export const indianInstitutes = [
  "Sri Venkateswara University, Tirupathy",
  "Indian Institute of Information Technology Design And Manufacturing, Kurnool",
  "National Sanskrit University , Tirupati",
  "Godavari Global University",
  "INDIAN INSTITUTE OF PETROLEUM & ENERGY",
  "Vellore Institute of Technology - Andhra Pradesh",
  "KREA UNIVERSITY",
  "SRM University-AP, Amaravati",
  "Indian Institute of Technology, Tirupati",
  "RAJIV GANDHI UNIVERSITY OF KNOWLEDGE TECHNOLOGIES",
  "NATIONAL INSTITUTE OF DESIGN ANDHRA PRADESH",
  "CLUSTER UNIVERSITY",
  "BHARTIYA ENGINEERING SCIENCE AND TECHNOLOGY INNOVATION UNIVERSITY",
  "Dr YSR Architecture and Fine Arts University",
  "Sri Venkateswara Vedic University, Tirpupathi",
  "Sri Padmavathi Mahila Visva Vidyalayam, Tirupathi",
  "Dr. N.T.R. University of Health Sciences, Vijaywada",
  "NATIONAL INSTITUTE OF TECHNOLOGY, ANDHRA PRADESH",
  "Sri Venkateswara Institute of Medical Sciences, Tirupathi",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCES, MANGALAGIRI",
  "Vignan's Foundation of Science, Technology & Research, Guntur",
  "Annamacharya University",
  "Aditya University",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, SRI CITY",
  "CENTURION UNIVERSITY OF TECHNOLOGY AND MANAGEMENT",
  "CENTRAL UNIVERSITY OF ANDHRA PRADESH",
  "Sri Krishnadevaraya University, Anantapur",
  "Indian Institute of Science Education & Research (IISER), Tirupati",
  "DR. ABDUL HAQ URDU UNIVERSITY",
  "INDIAN INSTITUTE OF MANAGEMENT VISAKHAPATNAM",
  "Jawaharlal Nehru Technological University, Kakinada",
  "Rayalaseema, University Kurnool",
  "Krishna University, Machhlipattanam",
  "Koneru Lakshmaiah Education Foundation,Guntur",
  "Gandhi Institute of Technology & Management (GITAM) University, Visakhapatnam",
  "Dravidian University, Kuppam, Chittoor District",
  "Dr.B.R.Ambedkar University, Etcherla",
  "Andhra University, Visakhapatnam",
  "Acharya Nagarjuna University, Guntur",
  "Yogi Vemana University, Kadapa",
  "Dr Y S R Horticulture University",
  "Vikram Simhapuri University, Nellore",
  "The Apollo University",
  "Acharya NG Ranga Agricultural University, Guntur",
  "MOHAN BABU UNIVERSITY",
  "ANDHRA KESARI UNIVERSITY",
  "Damodaram Sanjivayya National Law University",
  "Sri Sathya Sai Institute of Higher Learning",
  "School of Planning & Architecture Vijaywada",
  "Jawaharlal Nehru Technological University, Anantapur",
  "SIDDHARTHA ACADEMY OF HIGHER EDUCATION",
  "Adikavi Nannaya University, Rajahmundry, East Godawari",
  "ANDHRA PRADESH FISHERIES UNIVERSITY",
  "Sri Venkateswara Veterinary University, Tirupathi",
  "CENTRAL TRIBAL UNIVERSITY",
  "JAWAHARLAL NEHRU TECHNOLOGICAL UNIVERSITY GURAJADA VIZIANAGARAM",
  "Arunodaya University",
  "North Eastern Regional Institute of Science & Technology, Papum Pare, Itanagar",
  "INDIRA GANDHI TECHNOLOGICAL AND MEDICAL SCIENCES UNIVERSITY, ZIRO",
  "ARUNACHAL PRADESH UNIVERSITY",
  "National Institute of Technology Arunachal Pradesh",
  "VENKATESHWARA OPEN UNIVERSITY",
  "APEX PROFESSIONAL UNIVERSITY",
  "THE GLOBAL UNIVERSITY",
  "Rajiv Gandhi University, Itanagar",
  "HIMALAYAN UNIVERSITY, ITANAGAR",
  "NORTH EAST FRONTIER TECHNICAL UNIVERSITY",
  "ARUNACHAL UNIVERSITY OF STUDIES",
  "MAJULI UNIVERSITY OF CULTURE",
  "Tezpur University, Tezpur",
  "Indian Institute of Technology, Guwahati",
  "National Institute of Technology, Silchar",
  "Dibrugarh University, Dibrugarh",
  "Assam Agricultural University, Jorhat",
  "Gauhati University, Guwahati",
  "Auniati University",
  "NATIONAL INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH GUWAHATI",
  "Pragjyotishpur University",
  "THE ASSAM ROYAL GLOBAL UNIVERSITY, Guwahati, District- Kamrup (Metro)",
  "BIRANGANA SATI SADHANI RAJYIK VISHWAVIDYALAYA",
  "GIRIJANANDA CHOWDHURY UNIVERSITY",
  "SRI SRI ANIRUDDHADEVA SPORTS UNIVERSITY",
  "Rabindranath Tagore University",
  "Krishna Kanta Handiqui State Open University, Guwahati",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCES, GUWAHATI",
  "BHATTADEV UNIVERSITY, BAJALI",
  "NATIONAL INSTITUTE OF DESIGN, ASSAM",
  "Madhabdev University",
  "KRISHNAGURU ADHYATMIK VISVAVIDYALAYA",
  "Sibsagar University",
  "Assam University, Silchar",
  "Assam Skill University, Assam",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, GUWAHATI",
  "ASSAM WOMENS UNIVERSITY",
  "MAHAPURUSHA SRIMANTA SANKARADEVA VISWAVIDYALAYA",
  "Assam Don Bosco University, Guwahati",
  "CENTRAL INSTITUTE OF TECHNOLOGY, KOKRAJHAR",
  "THE ASSAM KAZIRANGA UNIVERSITY",
  "ASSAM DOWN TOWN UNIVERSITY",
  "NATIONAL LAW UNIVERSITY AND JUDICIAL ACADEMY",
  "ASSAM SCIENCE AND TECHNOLOGY UNIVERSITY",
  "SRIMANTA SANKARADEVA UNIVERSITY OF HEALTH SCIENCES, GUWAHATI",
  "KUMAR BHASKAR VARMA SANSKRIT AND ANCIENT STUDIES UNIVERSITY",
  "BODOLAND UNIVERSITY",
  "COTTON UNIVERSITY",
  "National Institute of Technology, Patna",
  "BIHAR ENGINEERING UNIVERSITY",
  "Bihar Sports University",
  "Nava Nalanda Mahavihara, Nalanda",
  "Bihar University of Health Sciences",
  "NALANDA UNIVERSITY",
  "Dr. C.V. Raman University",
  "Maulana Mazharul Haque Arabic & Persian University, Patna",
  "Bihar Agricultural University, Sabour",
  "Magadh University, Bodh Gaya",
  "Central University of South Bihar",
  "Indian Institute of Technology, Patna",
  "T.M. Bhagalpur University, Bhagalpur",
  "Babasaheb Bhimrao Ambedkar Bihar University, Muzaffarpur",
  "Patna University, Patna",
  "K K University",
  "Veer Kunwar Singh University, Arrah",
  "Chanakya National Law University, Patna",
  "Nalanda Open University, Patna",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY BHAGALPUR",
  "Dr Rajendra Prasad Central Agricultural University, Samastipur",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCES, PATNA",
  "Mahatma Gandhi Central University, Motihari",
  "Aryabhatta Knoweledge University , Patna",
  "INDIAN INSTITUTE OF MANAGEMENT BODH GAYA",
  "BIHAR ANIMAL SCIENCES UNIVERSITY",
  "PURNEA UNIVERSITY, PURNIA",
  "Bhupendra Narayan Mandal University, Madhepura",
  "Indira Gandhi Institute of Medical Sciences, Patna",
  "AMITY UNIVERSITY PATNA",
  "SANDIP UNIVERSITY",
  "MUNGER UNIVERSITY",
  "MATA GUJRI UNIVERSITY",
  "AL-KARIM UNIVERSITY",
  "Jai Prakash Vishwavidyalaya, Chapra",
  "Kameshwar Singh Darbhanga Sanskrit Vishwavidyalaya, Darbhanga",
  "Lalit Narayan Mithila University, Darbhanga",
  "GOPAL NARAYAN SINGH UNIVERSITY",
  "PATLIPUTRA UNIVERSITY, PATNA",
  "NATIONAL INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH HAJIPUR",
  "National Institute of Technical Teacher Training & Research Chandigarh",
  "Punjab Engineering College , Chandigarh",
  "Post Graduate Institute of Medical Sciences",
  "Panjab University,Chandigarh",
  "Pt. Deendayal Upadhyay Memorial Health Sciences and Ayush University of Chhattisgarh",
  "K K MODI UNIVERSITY",
  "Shaheed Mahendra Karma Vishwavidyalaya, Jagdalpur",
  "OP JINDAL UNIVERSITY",
  "SHRI SHANKARACHARYA PROFESSIONAL UNIVERSITY",
  "AMITY UNIVERSITY, CHHATTISGARH",
  "Guru Ghasidas Vishwavidyalaya, Bilaspur",
  "Indira Kala Sangit Vishwavidyalaya, Khairagarh",
  "MAHATMA GANDHI UDHYANIKEE EVAM VANIKEE VISHWAVIDYALAYA, DURG, C.G",
  "AAFT UNIVERSITY",
  "SHAHEED NANDKUMAR PATEL VISHWAVIDYALAYA",
  "ISBM University",
  "BHARTI VISHWAVIDYALAYA",
  "DR. SHYAMA PRASAD MUKHERJEE INTERNATIONAL INSTITUTE OF INFORMATION TECHNOLOGY - NAYA RAIPUR",
  "Indian Institute of Technology Bhilai",
  "Anjaneya University",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCES, RAIPUR",
  "KALINGA UNIVERSITY, RAIPUR",
  "Rungta International Skills University",
  "Shri Davara University",
  "ITM UNIVERSITY",
  "ICFAI UNIVERSITY",
  "Sant Gahira Guru Vishwavidyalaya, Sarguja, Ambikapur, Chattisgarh",
  "Pt. Sundarlal Sharma (Open) University, Bilaspur",
  "Pt. Ravishankar Shukla University, Raipur",
  "National Institute of Technology, Raipur",
  "MATS University, Raipur",
  "Kushabhau Thakre Patrakarita Avam Jansanchar Vishwavidyalaya, Raipur",
  "DAU SHRI VASUDEV CHANDRAKAR KAMDHENU",
  "Hidayatullah National Law University, Raipur",
  "Dr. C. V. Raman University, Kota Bilaspur",
  "Chhattisgarh Swami Vivekanand Technical University, Bhilai",
  "INDIAN INSTITUTE OF MANAGEMENT RAIPUR",
  "SHRI RAWATPURA  SARKAR UNIVERSITY",
  "HEMCHAND YADAV VISHWAVIDYALAYA",
  "Indira Gandhi Krishi Vishwavidyalaya, Raipur",
  "ATAL BIHARI VAJPAYEE VISHWAVIDYALAYA",
  "MAHARISHI UNIVERSITY OF MANAGEMENT AND TECHNOLOGY",
  "Delhi Technological University",
  "Institute of Liver and Bilary Sciences, New Delhi",
  "Indian Institute of Foreign Trade, Delhi",
  "Guru Gobind Singh Indraprastha University",
  "TERI School of Advanced Studies, New Delhi",
  "School of Planning & Architecture, New Delhi",
  "Shri Lal Bahadur Shastri National Sanskrit University",
  "National Forensic Sciences University",
  "Delhi Skill and Entrepreneurship University",
  "Jamia Millia Islamia University",
  "NETAJI SUBHAS UNIVERSITY OF TECHNOLOGY",
  "Indian Law Institute, Bhagwandas Road, New Delhi",
  "DELHI PHARMACEUTICAL SCIENCES AND RESEARCH UNIVERSITY",
  "Delhi Teachers University",
  "INDIAN INSTITUTE OF MASS COMMUNICATION, NEW DELHI",
  "INDIRA GANDHI DELHI TECHNICAL UNIVERSITY FOR WOMEN",
  "Indian Agricultural Research Institute (KRISHI PUSHA) New Delhi.",
  "Indraprastha Institute of Information Technology, Delhi",
  "South Asian University, New Delhi",
  "Dr. B. R. Ambedkar University Delhi",
  "National Museum Institute of History of Art Conservation and Museology",
  "Indira Gandhi National Open University",
  "Central Sanskrit University",
  "University of Delhi",
  "Indian Institute of Technology, Delhi",
  "National Institute of Technology Delhi",
  "All India Institute of Medical Sciences, New Delhi",
  "National Law University, Delhi",
  "Jawaharlal Nehru University",
  "National Institute of Educational Planning & Administration",
  "National Institute of Fashion Technology, Hauz Khas",
  "Jamia Hamdard",
  "Indian Institute of Technology, Goa",
  "Goa University, Goa",
  "INDIA INTERNATIONAL UNIVERSITY OF LEGAL EDUCATION AND RESEARCH",
  "National Institute of Technology Goa",
  "Gujarat Technological University, Ahmedabad",
  "PARUL UNIVERSITY",
  "RAI UNIVERSITY",
  "BHAIKAKA UNIVERSITY",
  "Karnavati University",
  "Indrashil University",
  "Marwadi University",
  "ATMIYA UNIVERSITY",
  "GLS UNIVERSITY",
  "G S F C UNIVERSITY",
  "Navrachana University",
  "INDUS UNIVERSITY",
  "INDIAN INSTITUTE OF TEACHER EDUCATION, GANDHINAGAR",
  "Sabarmati University",
  "Maharaja Krishnakumarsinhji Bhavnagar University",
  "R K University, Rajkot",
  "Ahmedabad University",
  "Anand Agricultural University, Anand",
  "Dhirubhai Ambani Institute of Information & Communication Technology, Gandhi Nagar",
  "Dr. Babasaheb Ambedkar Open University, Ahmedabad",
  "Gujarat Ayurveda University, Jamnagar",
  "Gujarat National Law University, Gandhinagar",
  "Gujarat University, Ahmedabad",
  "Gujarat Vidyapith, Ahmedabad",
  "Hemchandracharya North Gujart University, Patan",
  "Indian Institute of Technology, Gandhinagar",
  "Junagadh Agricultural University",
  "Kadi Sarva Vishwavidyalaya, Gandihnagar",
  "Maharaja Sayajirao University of Baroda, Vadodara",
  "Navsari Agricultural University",
  "Sardar Patel University, Vallabh Vidyanagar",
  "Sardar Vallabhbhai National Institute of Technology, Surat",
  "Dharmsinh Desai univeristy, Nadiad",
  "Sardarkrushinagar Dantiwada Agricultural University, Banaskantha",
  "Saurashtra University, Rajkot",
  "PANDIT DEENDAYAL ENERGY UNIVERSITY, GANDHI NAGAR",
  "Sumandeep Vidyapeeth, Vadodara",
  "Nirma University, Ahmedabad",
  ": CHILDREN'S RESEARCH UNIVERSITY",
  "UKA TARSADIA UNIVERSITY",
  "ITM VOCATIONAL UNIVERSITY, VADODARA",
  "Rashtriya Raksha University, Gujarat",
  "NATIONAL FORENSIC SCIENCES UNIVERSITY",
  "KAMDHENU UNIVERSITY, GANDHINAGAR",
  "C.U.SHAH UNIVERSITY, SURENDRANAGAR",
  "Charotar University of Science & Technology,  Anand",
  "Krantiguru Shyamji Krishna Verma Kachchh University, Kachchh",
  "Veer Narmad South Gujarat University, Surat",
  "LAKULISH YOGA UNIVERSITY, AHMEDABAD",
  "Ganpat University, Ganpat Vidyanagar, Kherva",
  "INSTITUTE OF INFRASTRUCTURE TECHNOLOGY RESEARCH AND MANAGEMENT (IITRAM)",
  "INSTITUTE OF ADVANCED RESEARCH, GANDHINAGAR",
  "TEAM LEASE SKILLS UNIVERSITY",
  "SHRI GOVIND GURU UNIVERSITY",
  "BHAKTA KAVI NARSINH MEHTA UNIVERSITY",
  "AURO UNIVERSITY OF HOSPITALITY AND MANAGEMENT",
  "GUJARAT UNIVERSITY OF TRANSPLANTATION SCIENCES",
  "Sankalchand Patel University, Visnagar",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, VADODARA",
  "ANANT NATIONAL UNIVERSITY",
  "PLASTINDIA INTERNATIONAL UNIVERSITY",
  "P.P. Savani University",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY SURAT",
  "GOKUL GLOBAL UNIVERSITY",
  "INDIAN INSTITUTE OF PUBLIC HEALTH GANDHINAGAR",
  "BIRSA MUNDA TRIBAL UNIVERSITY",
  "INDIAN INSTITUTE OF MANAGEMENT AHMEDABAD",
  "NATIONAL INSTITUTE OF DESIGN",
  "GUJARAT MARITIME UNIVERSITY",
  "BHAGWAN MAHAVIR UNIVERSITY",
  "ITM (SLS) BARODA UNIVERSITY, VADODARA",
  "SILVER OAK UNIVERSITY",
  "THE CHARUTAR VIDYA MANDAL (CVM) UNIVERSITY",
  "LOK JAGRUTI KENDRA UNIVERSITY",
  "CEPT UNIVERSITY",
  "SURENDRANAGAR UNIVERSITY",
  "SARVAJANIK UNIVERSITY",
  "JG UNIVERSITY",
  "MONARK UNIVERSITY",
  "GUJARAT BIOTECHNOLOGY UNIVERSITY",
  "DARSHAN UNIVERSITY",
  "UPL University of Sustainable Technology",
  "Drs Kiran and Pallavi Patel Global University",
  "VANITA VISHRAM WOMENS UNIVERSITY",
  "SHREYARTH UNIVERSITY",
  "DR SUBHASH UNIVERSITY",
  "ADANI UNIVERSITY",
  "GANDHINAGAR UNIVERSITY",
  "KAUSHALYA THE SKILL UNIVERSITY",
  "SWAMINARAYAN UNIVERSITY",
  "LOKBHARTI UNIVERSITY FOR RURAL INNOVATION",
  "NOBLE UNIVERSITY",
  "VIDHYADEEP UNIVERSITY",
  "TransStadia University",
  "MAGANBHAI ADENWALA MAHAGUJARAT UNIVERSITY",
  "SIGMA UNIVERSITY",
  "SARDAR VALLABHBHAI GLOBAL UNIVERSITY",
  "RAJJU SHROFF ROFEL UNIVERSITY",
  "INSTITUTE OF TEACHING AND RESEARCH IN AYURVEDA",
  "Gati Shakti Vishwavidyalaya",
  "GYANMANJARI INNOVATIVE UNIVERSITY",
  "KN UNIVERSITY",
  "Shree Somnath Sanskrit University, Junagarh",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCES, RAJKOT",
  "Swarrnim Startup & Innovation University",
  "M K University",
  "SKIPS University",
  "SWARNIM GUJARAT SPORTS UNIVERSITY",
  "CENTRAL UNIVERSITY OF GUJARAT",
  "Sushant University",
  "RISHIHOOD UNIVERSITY",
  "J.C. BOSE UNIVERSITY OF SCIENCE AND TECHNOLOGY, YMCA, FARIDABAD",
  "Maharshi Valmiki Sanskrit University",
  "Sports University of Haryana",
  "MAHARANA PRATAP HORTICULTURAL UNIVERSITY",
  "IILM UNIVERSITY",
  "Al-Falah University",
  "Maharshi Dayanand University, Rohtak",
  "Chaudhary Charan Singh Haryana Agricultural University, Hisar",
  "Ch. Devi Lal University, Sirsa",
  "Deenbandhu Chhotu Ram University of Science & Technology, Murthal(Sonepat)",
  "Guru  Jambheshwar University of Science and Technology, Hissar",
  "Kurukshetra University, Kurukshetra",
  "Lala lajpat Rai University of Veterinary and Animal Sciences",
  "Maharishi Markandeshwar University, Mullana-Ambala",
  "National Institute of Technology, Kurukshetra",
  "SRM UNIVERSITY, SONEPAT",
  "JAGAN NATH UNIVERSITY, JHAJJAR",
  "G.D. GOENKA UNIVERSITY",
  "ASHOKA UNIVERSITY",
  "Pt. Bhagwat Dayal Sharma University of Health Sciences",
  "M V N University, Palwal",
  "Bhagat Phool Singh  Mahila University, Khanpur Kalan, Sonipat",
  "CHAUDHARY RANBIR SINGH UNIVERSITY, JIND",
  "BML MUNJAL UNIVERSITY",
  "NIILM UNIVERSITY",
  "MAHARISHI MARKANDESHWAR UNIVERSITY, SADOPUR-AMBALA",
  "O. P. Jindal Global University, Sonipat",
  "SHREE GURU GOBIND SINGH TRICENTENARY UNIVERSITY, GURGAON",
  "K.R. MANGALAM UNIVERSITY, GURGAON",
  "INDIRA GANDHI UNIVERSITY, MEERPUR",
  "The Northcap University, Gurgaon",
  "Manav Rachna University",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, SONIPAT",
  "DADA LAKHMI CHAND STATE UNIVERSITY OF PERFORMING AND VISUAL ARTS",
  "STAREX UNIVERSITY",
  "World University of Design",
  "Manav Rachna International Institute of Research & Studies",
  "Sanskaram University",
  "NATIONAL INSTITUTE OF FOOD TECHNOLOGY ENTREPRENEURSHIP AND MANAGEMENT",
  "Lingaya's Vidyapeeth, Faridabad",
  "INDIAN INSTITUTE OF MANAGEMENT ROHTAK",
  "GURUGRAM UNIVERSITY, GURUGRAM",
  "SHRI KRISHNA AYUSH UNIVERSITY",
  "BABA MASTNATH UNIVERSITY",
  "CHAUDHARY BANSI LAL UNIVERSITY",
  "National Dairy  Research Institute, Karnal",
  "National Brain Research Centre, Gurgaon",
  "National Institute of Design Haryana",
  "Central University of Haryana, Mahendergarh",
  "Apeejay  Stya University, Sohna",
  "Amity University Haryana, Gurgaon",
  "GEETA UNIVERSITY",
  "SHRI VISHWAKARMA SKILL UNIVERSITY",
  "OM STERLING GLOBAL UNIVERSITY",
  "Dr. B.R Ambedkar National Law University",
  "REGIONAL CENTRE FOR BIOTECHNOLOGY",
  "PDM University",
  "HIMACHAL PRADESH NATIONAL LAW UNIVERSITY SHIMLA",
  "INSTITUTE OF CHARTERED FINANCIAL ANALYSTS OF INDIA UNIVERSITY, SOLAN",
  "Shoolini University of Bio Technology and Management Sciences, Oachghat, Solan",
  "Dr. Y.S. Parmar University of Horticulture and Forestry, Solan",
  "IEC (INDIA EDUCATION CENTRE) UNIVERSITY",
  "CAREER POINT UNIVERSITY, HAMIRPUR",
  "MAHARAJA AGRASEN UNIVERSITY",
  "Sri Sai University, Palampur",
  "Himachal Pradesh Technical University, Hamirpur",
  "Bahra University, Solan",
  "Indian Institute of Technology, Mandi",
  "Indus International University, Bathu, Una",
  "Jaypee University of Information Technology, Waknaghat, Solan",
  "Maharashi Markandeshwar University, Solan",
  "National Institute of Technology, Hamirpur",
  "Central University of Himachal Pradesh, Dharmshala, Kangra",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCE, BILASPUR",
  "Arni University, Katgarh (Indora), Kangra",
  "Chaudhary Sarwan Kumar Himachal Pardesh Krishi Vishvavidyalaya, Palampur",
  "ATAL MEDICAL AND RESEARCH UNIVERSITY",
  "Chitkara University, Kalu Jhanda (Barotiwala), Solan",
  "Sardar Patel University",
  "Eternal University, Baru Sahib Sirmour",
  "Himachal Pradesh University , Shimla",
  "ABHILASHI UNIVERSITY",
  "INDIAN INSTITUTE OF MANAGEMENT SIRMAUR",
  "Baddi University of Emerging Sciences and Technology, Baddi (Makhnumajra), Solan",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, UNA",
  "A P GOYAL SHIMLA UNIVERSITY",
  "Sher-e-Kashmir Institute of Medical Sciences, Srinagar",
  "Sher-e-Kashmir University of Agricultural Science & Technology of Jammu, Jammu",
  "Islamic University of Science & Technology, Pulwama",
  "INDIAN INSTITUTE OF MANAGEMENT, JAMMU AND KASHMIR",
  "University of Kashmir, Srinagar",
  "Shri Mata Vaishno Devi University, Jammu",
  "Baba Ghulam Shah Badshah University,  Jammu",
  "University of Jammu, Jammu Tawi",
  "Central University of Kashmir, Srinagar",
  "Cluster University of Jammu",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCE, JAMMU",
  "Sher-e-Kashmir University of Agricultural Science & Technology of Kashmir, Srinagar",
  "CENTRAL UNIVERSITY OF JAMMU",
  "National Institute of Technology, Srinagar",
  "Indian Institute of Technology Jammu",
  "Cluster University Srinagar",
  "SAI NATH UNIVERSITY",
  "Jharkhand University of Technology, Ranchi",
  "Indian Institute of Technology (Indian School of Mines), Dhanbad",
  "Central University of Jharkhand, Ranchi",
  "Birla Institute of Technology, Ranchi",
  "YBN University",
  "Sido Kanhu Murmu University, Dumka",
  "Vinoba Bhave University, Hazaribagh",
  "JHARKHAND RAI UNIVERSITY",
  "INDIAN INSTITUTE OF MANAGEMENT RANCHI",
  "National Institute of Advanced Manufacturing Technology",
  "SARALA BIRLA UNIVERSITY",
  "DR. SHYAMA PRASAD MUKHERJEE UNIVERSITY",
  "BINOD BIHARI MAHTO KOYALANCHAL UNIVERSITY",
  "Ranchi University, Ranchi",
  "Nilamber-Pitamber University, Palamu",
  "National Institute of Technology, Jamshedpur",
  "AMITY UNIVERSITY,JHARKHAND",
  "JHARKHAND RAKSHA SHAKTI UNIVERSITY",
  "AISECT UNIVERSITY",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, RANCHI",
  "National University of Study & Research in Law, Ranchi",
  "Usha Martin University",
  "Kolhan University,  West Singhbhum",
  "SRINATH UNIVERSITY",
  "JHARKHAND STATE OPEN UNIVERSITY",
  "JAMSHEDPUR WOMEN\"S UNIVERSITY",
  "ARKA JAIN University, Jharkhand",
  "CAPITAL UNIVERSITY",
  "DURGA SOREN UNIVERSITY",
  "BABU DINESH SINGH UNIVERSITY",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCE DEOGHAR",
  "Birsa Agricultural University, Ranchi",
  "RAM KRISHNA DHARMARTH FOUNDATION (RKDF) UNIVERSITY",
  "Sona Devi University",
  "NETAJI SUBHAS UNIVERSITY",
  "RADHA GOVIND UNIVERSITY",
  "RAMCHANDRA CHANDRAVANSI UNIVERSITY",
  "The Institute of Chartered Financial Analysts of India University, Jharkhand",
  "Swami Vivekananda Yoga Anusandhana Samsthan, Bangalore",
  "Alliance University. Bangalore",
  "Bangalore University, Bangalore",
  "Christ University, Bangalore",
  "Davangere University, Davangere",
  "Gulbarga University, Gulbarga",
  "Jain university,Bangalore",
  "K.L.E. Academy of Higher Education and Research, Belgaum",
  "Karnataka State Law University, Hubli",
  "NITTE Unversity, Mangalore",
  "Karnataka State Open University, Mysore",
  "Karnataka University, Dharwad",
  "Karnataka Vetrinary, Animal & Fisheries Science University, Nandinagar",
  "Kuvempu University, Shankaraghatta, Shimoga",
  "Mangalore University, Mangalore",
  "National Institute of Technology, Karnataka",
  "Rajiv Gandhi University of Health Sciences, Bangalore",
  "Tumkur University, Tumkur",
  "University  of Agricultural Sciences, Dharwad",
  "University  of Agricultural Sciences, Raichur",
  "University of Agricultural Sciences, Bangalore",
  "JSS ACADEMY OF HIGHER EDUCATION & RESEARCH",
  "Kannada University, Hampi, Kamalapura",
  "Manipal Academy of Higher Education, Manipal",
  "Vijayanagara Sri Krishnadevaraya University, Bellary",
  "Karnataka State Dr. Gangubai Hangal Music And Performing Arts University",
  "Karnataka Sanskrit University",
  "CMR UNIVERSITY, BANGALORE",
  "REVA UNIVERSITY, BANGALORE",
  "RAI TECHNOLOGY UNIVERSITY, BANGALORE",
  "UNIVERSITY OF AGRICULTURAL AND HORTICULTURAL SCIENCES, SHIMOGA",
  "M.S. RAMAIAH UNIVERSITY OF APPLIED SCIENCES, BANGALORE",
  "PES UNIVERSITY, BANGLORE",
  "National Law School of India University, Bangalore",
  "International Institute of Information Technology, Bangalore",
  "THE UNIVERSITY OF TRANS-DISCIPLINARY HEALTH SCIENCES AND TECHNOLOGY",
  "KARNATAKA JANAPADA VISHWAVIDYALAYA, GOTAGODI",
  "University  of Horticultural Sciences, Bagalkot",
  "Karnataka State Women University, Bijapur",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, DHARWAD",
  "KLE TECHNOLOGICAL UNIVERSITY",
  "DAYANANDA SAGAR UNIVERSITY",
  "PRESIDENCY UNIVERSITY , BENGALURU",
  "Karnataka State Rural Development and Panchayat Raj University",
  "Visvesvaraya Technological University, Belagavi",
  "ADICHUNCHANAGIRI UNIVERSITY",
  "BENGALURU NORTH UNIVERSITY",
  "BENGALURU CITY UNIVERSITY",
  "JSS Science and Technology University",
  "INDIAN INSTITUTE OF MANAGEMENT BANGALORE",
  "SHRI DHARMASTHALA MANJUNATHESHWARA UNIVERSITY",
  "KHAJA BANDANAWAZ UNIVERSITY",
  "Sri Siddhartha Academy of Higher Education",
  "Sharnbasva University",
  "MANDYA UNIVERSITY",
  "MAHARANI CLUSTER UNIVERSITY",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY RAICHUR",
  "National Institute of Mental Health & Neuro Sciences, Bangalore",
  "Garden City University",
  "Yenepoya (deemed to be University), Mangalore",
  "BENGALURU DR.B.R.AMBEDKAR SCHOOL OF ECONOMICS UNIVERSITY",
  "NRUPATHUNGA UNIVERSITY",
  "RV UNIVERSITY",
  "RAICHUR UNIVERSITY",
  "Indian Institute of Technology, Dharwad",
  "CHANAKYA UNIVERSITY",
  "Sri Devaraj Urs Academy of Higher Education and Research, Kolar",
  "Vidyashilp University",
  "St. Joseph's University",
  "SRINIVAS UNIVERSITY",
  "SRI SATHYA SAI UNIVERSITY FOR HUMAN EXCELLENCE",
  "KOPPAL UNIVERSITY",
  "KODAGU UNIVERSITY",
  "HAVERI UNIVERSITY",
  "BAGALKOT UNIVERSITY",
  "University of Mysore, Mysore",
  "GM UNIVERSITY",
  "Kishkinda University",
  "UNIVERSITY OF VISVESVARAYA COLLEGE OF ENGINEERING",
  "CHAMARAJANAGARA UNIVERSITY",
  "AMITY UNIVERSITY",
  "Bidar University",
  "BLDE (Deemed to be University)",
  "SAPTHAGIRI NPS UNIVERSITY",
  "Hassan University",
  "Atria University",
  "St. Aloysius",
  "Indian Institute of Science, Bangalore",
  "Azim Premji University, Bangalore",
  "Rani Channamma University, Belagavi",
  "Central University of Karnataka, Gulbarga",
  "Jawaharlal Nehru Centre for Advanced Scientific Research, Banaglore",
  "Indian Institute of Technology, Palakkad",
  "National University of Advanced Legal Studies, Kochi",
  "National Institute of Technology, Calicut",
  "Mahatma Gandhi University, Kottayam",
  "KERALA UNIVERSITY OF DIGITAL SCIENCES INNOVATION AND TECHNOLOGY",
  "University of Kerala, Thiruvananthapuram",
  "INDIAN INSTITUTE OF MANAGEMENT KOZHIKODE",
  "Chinmaya Vishwavidyapeeth",
  "Kerala Agricultural University, Thrissur",
  "KERALA UNIVERSITY OF HEALTH AND ALLIED SCIENCES",
  "Sree Chitra Tirunal Institute for Medical Sciences and Technology, Thiruvananthapuram",
  "Kerala Kalamandalam, Thrissur",
  "Kannur University, Kannur",
  "Sree Sankaracharya University of Sanskrit, Kalady",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, KOTTAYAM",
  "Cochin University of Science & Technology, Kochi",
  "UNIVERSITY OF CALICUT, MALAPPURAM",
  "Indian Institute of Science Education & Research (IISER), Thiruvananthapuram",
  "Indian Institute of Space Science and Technology, Thiruvananthapuram",
  "Kerala Veterinary & Animal Science University, Wayanad",
  "Kerala University of Fisheries & Ocean Studies, Kochi",
  "THUNCHATH EZHUTHACHAN MALAYALAM UNIVERSITY, TIRUR",
  "Central Univeristy of Kerala, Kasaragod",
  "SREENARAYANAGURU OPEN UNIVERSITY",
  "A P J ABDUL KALAM TECHNOLOGICAL UNIVERSITY",
  "UNIVERSITY OF LADAKH",
  "CENTRAL INSTITUTE OF BUDDHIST STUDIES",
  "Krantisurya Tantya Bhil University",
  "LNCT UNIVERSITY",
  "MALWANCHAL UNIVERSITY",
  "DHARMASHASTRA NATIONAL LAW UNIVERSITY",
  "Bhabha University, Bhopal",
  "Madhyanchal Professional University",
  "Renaissance University",
  "INDIAN INSTITUTE OF FOREST MANAGEMENT, BHOPAL",
  "Rani Awantibai Lodhi Vishwavidyalaya Sagar",
  "MANDSAUR UNIVERSITY",
  "NATIONAL INSTITUTE OF TECHNICAL TEACHERS' TRAINING & RESEARCH, BHOPAL",
  "Madhav Institute of Technology and Science",
  "Amaltas University",
  "Raja Mansingh  Tomar Music & Arts University, Gwalior",
  "PEOPLES UNIVERSITY",
  "Dr. Harisingh Gaur  Vishwavidyalaya, Sagar",
  "School of Planning & Architecture, Bhopal",
  "Nanaji Deshmukh Pashu Chikitsa Vigyan Vishwavidalaya, Jabalpur",
  "Lakshmibai National Institute of Physical Education, Gwalior",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCES, BHOPAL",
  "PRESTIGE UNIVERSITY",
  "SHUBHAM UNIVERSITY",
  "SWAMI VIVEKANAND UNIVERSITY",
  "AZIM PREMJI UNIVERSITY",
  "MANGALAYATAN UNIVERSITY",
  "Aryavart University",
  "DR PREETI GLOBAL UNIVERSITY",
  "VIKRANT UNIVERSITY",
  "SRI SATYA SAI UNIVERSITY OF TECHNOLOGY & MEDICAL SCIENCES, SEHORE",
  "TECHNO GLOBAL UNIVERSITY, SIRONG",
  "ABHYUDAY UNIVERSITY",
  "IES UNIVERSITY",
  "Gyanveer University",
  "CHIRAYU UNIVERSITY",
  "SCOPE GLOBAL SKILLS UNIVERSITY",
  "Gyanodaya University",
  "LNCT VIDHYAPEETH UNIVERSITY",
  "Makhanlal Chaturvedi National University of Journalism and Communication, Bhopal",
  "Maharshi Panini Sanskrit Evam Vedic Vishwavidyalaya, Ujjain",
  "J N C T Professional University",
  "RABINDRANATH TAGORE UNIVERSITY",
  "JAGRAN LAKECITY UNIVERSITY, BHOPAL",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY",
  "SRI AUROBINDO UNIVERSITY",
  "AKS UNIVERSITY, SATNA",
  "Vikram University, Ujjain",
  "Amity University, Gwalior",
  "Mahatama Gandhi Gramodaya Vishwavidyalaya, Chitrakoot, Satna",
  "Jaypee University of Engineering & Technology, Guna",
  "Shri Vaishnav Vidyapeeth Vishwavidyalaya",
  "DR B R AMBEDKAR UNIVERSITY OF SOCIAL SCIENCES",
  "MAHAKAUSHAL UNIVERSITY",
  "Awadesh Pratap Singh University, Rewa",
  "SAM GLOBAL UNIVERSITY",
  "ATAL BIHARI VAJPAYEE HINDI VISHWAVIDYALAYA",
  "Krantivir Tatya Tope Vishwavidyalaya",
  "SAGE UNIVERSITY",
  "ORIENTAL UNIVERSITY,INDORE",
  "Barkatullah University, Bhopal",
  "Madhya Pradesh Bhoj Open University, Bhopal",
  "Devi Ahilya Vishwavidyalaya, Indore",
  "EKLAVYA UNIVERSITY",
  "SANJEEV AGARWAL GLOBAL EDUCATIONAL UNIVERSITY BHOPAL",
  "ITM UNIVERSITY, GWALIOR",
  "SARVEPALLI RADHAKRISHNAN UNIVERSITY",
  "NATIONAL INSTITUTE OF DESIGN (NID) MADHYA PRADESH",
  "Indian Institute of Science Education & Research (IISER), Bhopal",
  "AVANTIKA UNIVERSITY",
  "SARDAR PATEL UNIVERSITY, BALAGHAT",
  "CHHINDWARA UNIVERSITY",
  "Indian Institute of Technology, Indore",
  "Maharishi  Mahesh Yogi Vedic Vishwavidyalaya",
  "Symbiosis University of Applied Sciences, Indore",
  "Jawaharlal Nehru Krishi Vishwavidyalaya, Jabalpur",
  "Jiwaji University, Gwalior",
  "Maulana Azad National Institute of Technology, Bhopal",
  "National Law Institute University, Bhopal",
  "VIT Bhopal University, Sehore",
  "MAHARAJA CHHATRASAL BUNDELKHAND UNIVERSITY",
  "Rajiv Gandhi Prodoyogiki Vishwavidyalaya, Bhopal",
  "Rajmata Vijayaraje Scindia Krishi Vishwa Vidyalaya, Gwalior",
  "Rani Durgavati Vishwavidyalaya, Jabalpur",
  "Pandit S.N. Shukla University, Shahdol",
  "Atal Bihari Vajpayee Indian Institute of Information Technology and Management, Gwalior",
  "Pandhi Dwarka Prasad Mishra Indian Institute of Information Technology & Manufacturing , Jabalpur",
  "Indira Gandhi National Tribal University, Amarkantak",
  "SHRI KRISHNA UNIVERSITY",
  "MANSAROVAR GLOBAL UNIVERSITY",
  "MEDI-CAPS UNIVERSITY",
  "INDIAN INSTITUTE OF MANAGEMENT INDORE",
  "RKDF UNIVERSITY",
  "MADHYA PRADESH AYURVIGYAN VISHWAVIDHLAYA, JABALPUR",
  "Dr. C.V RAMAN UNIVERSITY",
  "P.K. UNIVERSITY",
  "G.H. RAISONI UNIVERSITY",
  "Dr. A.P.J. ABDUL KALAM UNIVERSITY",
  "SANCHI UNIVERSITY OF BUDDHIST-INDIC STUDIES",
  "SPICER ADVENTIST UNIVERSITY",
  "Indian Institute of Science Education & Research (IISER), Pune,",
  "Maharashtra University of Health Sciences, Nashik",
  "Rashtrasant Tukadoji Maharaj Nagpur University, Nagpur",
  "MIT Art, Design and Technology University, Pune",
  "MAHARASHTRA STATE SKILLS UNIVERSITY",
  "Deccan College Postgraduate & Research Institute, Pune",
  "Datta Meghe Institute of Higher Education & Research (Deemed to be University)",
  "Shivaji University, Kolhapur",
  "MGM UNIVERSITY",
  "International Institute for Population Sciences, Mumbai",
  "Dr. Panjabrao Deshmukh Krishi Vidyapeeth, Akola",
  "Central Institute of Fisheries Education, Fishries University, Mumbai",
  "Krishna Vishwa Vidyapeeth, Karad, Maharashtra",
  "Dr. Babasaheb Ambedkar Marathwada University, Aurangabad",
  "Vasantrao Naik Marathwada Krishi Vidyapeeth, Parbhani",
  "Sant Gadge Baba Amravati University, Amravati",
  "ALARD UNIVERSITY, PUNE",
  "Tata Institute of Social Sciences, Mumbai",
  "SOMAIYA VIDYAVIHAR UNIVERSITY, MUMBAI",
  "Dr. Babasaheb Ambedkar Technological University, Lonere",
  "Mahatama Gandhi Antarrashtriya Hindi Vishwavidyalaya, Wardha",
  "Homi Bhabha National Institute, Mumbai",
  "Atharva University",
  "Universal SkillTech University",
  "Kavayitri Bahinabai Chaudhari North Maharashtra University, Jalgaon",
  "FLAME UNIVERSITY",
  "DES PUNE UNIVERSITY",
  "MIT VISHWAPRAYAG UNIVERSITY",
  "Bharati Vidyapeeth, Pune",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCES NAGPUR",
  "D Y PATIL AGRICULTURE AND TECHNICAL UNIVERSITY",
  "Punyashlok Ahilyadevi Holkar Solapur University, Solapur",
  "Dr. D.Y.Patil Vidyapeeth, Pune",
  "SVKM NMIMS Global University",
  "Maharashtra National Law University Mumbai",
  "Indian Institute of Technology, Bombay",
  "Indira University",
  "University of Mumbai",
  "Gokhale Institute of Politics & Economics, Pune",
  "NICMAR UNIVERSITY, PUNE",
  "SYMBIOSIS SKILLS AND PROFESSIONAL UNIVERSITY",
  "SMT. NATHIBAI DAMODAR THACKERSEY WOMEN'S UNIVERSITY, MUMBAI",
  "ATLAS SKILLTECH UNIVERSITY",
  "Kavi Kulguru Kalidas Sanskrit Vishwavidyalaya, Ramtek",
  "Laxminarayan Innovation Technological (LIT) University",
  "GONDWANA UNIVERSITY, GADCHIROLI",
  "Hyderabad (SIND) National Collegiate University",
  "GH Raisoni  International Skill Tech University",
  "Yashwantrao Chavan Maharashtra Open University",
  "Maharashtra National Law University, Aurangabad",
  "Maharashtra Animal & Fishery Sciences University, Nagpur",
  "CHHATRAPATI SHIVAJI MAHARAJ UNIVERSITY",
  "VISHWAKARMA UNIVERSITY",
  "MGM Institute of Health Sciences, Navi  Mumbai",
  "D Y PATIL UNIVERSITY PUNE AMBI",
  "Padmashree Dr. D. Y. Patil Vidyapeeth, , Mumbai",
  "Dr. D.Y. Patil Dnyan Prasad University",
  "Savitribai Phule Pune University",
  "G H RAISONI UNIVERSITY, AMRAVATI",
  "Maharashtra National Law University,Nagpur",
  "Sanjivani University",
  "INDIAN INSTITUTE OF MANAGEMENT, NAGPUR",
  "SHRI VILE PARLE KELAVANI MANDALS NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES (DEEMED UNIVERSITY), MUMBAI (SVKMs NMIMS)",
  "Pravara Institute of Medical Sciences, Ahmednagar",
  "Visvesvaraya National Institute of Technology, Nagpur",
  "Symbiosis International (Deemed University), Pune",
  "Tata Institute of Fundamental Research, Mumbai",
  "VIJAYBHOOMI UNIVERSITY",
  "Mahatma Phule Krishi Vidyapeeth, Rahuri",
  "Dr. Vishwanath Karad MIT World Peace University",
  "Ramdeobaba University",
  "Sandip University",
  "INDIAN INSTITUTE OF MANAGEMENT,MUMBAI",
  "D.Y. Patil Educational Society , Kolhapur",
  "UNIVERSAL Ai UNIVERSITY",
  "Tilak Maharashtra Vidyapeeth, Pune",
  "PIMPRI CHINCHWAD UNIVERSITY",
  "D Y PATIL INTERNATIONAL UNIVERSITY",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, NAGPUR",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, PUNE",
  "Ajeenkya D Y Patil University",
  "Swami Ramanand Teerth Marathwada University, Nanded",
  "JSPM University",
  "SANJAY GHODAWAT UNIVERSITY, KOLHAPUR",
  "Defence Institute of Advanced Technology, Girinagar, Pune",
  "Indira Gandhi Institute of Development Research, Mumbai",
  "KARMAVEER BHAURAO PATIL UNIVERSITY",
  "COEP Technological University",
  "DR HOMI BHABHA STATE UNIVERSITY MUMBAI",
  "Dr P A Inamdar University",
  "G H Raisoni Skill Tech University Nagpur",
  "ITM SKILLS UNIVERSITY",
  "Institute of Chemical Technology, Mumbai",
  "AMITY UNIVERSITY MUMBAI",
  "SRI BALAJI UNIVERSITY, PUNE",
  "Dr. Balasaheb Sawant Konkan Krishi Vidyaapeeth,(former Konkan Krishi Vidyapeeth) Ratnagiri",
  "NATIONAL SPORTS UNIVERSITY",
  "MANIPUR UNIVERSITY OF CULTURE",
  "Central Agricultural University, Imphal",
  "BIR TIKENDRAJIT UNIVERSITY",
  "National Institute of Technology Manipur",
  "MANIPUR INTERNATIONAL UNIVERSITY",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, SENAPATI",
  "Manipur University, Imphal",
  "DHANAMANJURI UNIVERSITY",
  "ASIAN INTERNATIONAL UNIVERSITY",
  "MANIPUR TECHNICAL UNIVERSITY",
  "KHONGNANGTHABA UNIVERSITY",
  "Captain Williamson Sangma State University",
  "NORTH EAST ADVENTIST UNIVERSITY",
  "National Institute of Technology Meghalaya",
  "Maharashtra Institute of Technology University, of Meghalaya",
  "North Eastern Hill University, Shillong",
  "CMJ University",
  "Institute of Chartered Financial Analysts of India University, Meghalaya",
  "William Carey University, Shillong",
  "NATIONAL LAW UNIVERSITY OF MEGHALAYA",
  "INDIAN INSTITUTE OF MANAGEMENT, SHILLONG",
  "Martin Luther Christian University, Shillong",
  "UNIVERSITY OF SCIENCE AND TECHNOLOGY",
  "Mahatma Gandhi University, Tura, West Garo Hills",
  "National Institute of Technology Mizoram",
  "Mizoram University, Aizwal",
  "The Institute of Chartered Financial Analysts of India University, Aizawl",
  "National Institute of Technology Nagaland",
  "The Institute of Chartered Financial Analysts of India University, Dimapur",
  "ST. JOSEPH UNIVERSITY, DIMAPUR",
  "The Global Open University Nagaland, Dimapur",
  "NORTH EAST CHRISTIAN UNIVERSITY",
  "Nagaland University",
  "Silicon University",
  "XIM UNIVERSITY, BHUBANESWAR",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCES, BHUBANESWAR",
  "Siksha 'O' Anusandhan",
  "Utkal University, Bhubaneswar",
  "Utkal University of Culture, Bhubaneswar",
  "Shri Jagannath Sanskrit Vishwavidyalaya, Puri",
  "Sambalpur University, Sambalpur",
  "Orissa University of Agriculture &  Technology, Bhubaneswar",
  "Veer Surendra Sai University of Technology, Sambalpur",
  "Ravenshaw University, Cuttak",
  "Fakir Mohan University, Balasore",
  "Centurion University of Technology and Management",
  "Biju Patnaik University of Technology, Rourkela",
  "Berhampur University, Berhampur",
  "GANDHI INSTITUTE OF ENGINEERING AND TECHNOLOGY UNIVERSITY, ODISHA, GUNUPUR (GIET UNIVERSITY)",
  "RAMA DEVI WOMEN'S UNIVERSITY, BHUBANESWAR",
  "GANGADHAR MEHER UNIVERSITY",
  "Indian Institute of Science Education & Research (IISER), Berhampur",
  "National Law University, Cuttuck",
  "National Institute of Technology, Rourkela",
  "Kalinga Institute of Industrial Technology, Bhubaneswar",
  "Indian Institute of Technology, Bhubaneshwar",
  "Central University of Orissa, Koraput",
  "Odisha State Open University",
  "INDIAN INSTITUTE OF MANAGEMENT SAMBALPUR",
  "BIRLA GLOBAL UNIVERSITY",
  "INTERNATIONAL INSTITUTE OF INFORMATION TECHNOLOGY BHUBANESHWAR",
  "KALINGA INSTITUTE OF SOCIAL SCIENCES (KISS) DEEMED TO BE UNIVERSITY",
  "C.V. RAMAN GLOBAL UNIVERSITY, ODISHA",
  "ASBM UNIVERSITY",
  "NIST University",
  "Dharanidhar University",
  "KALAHANDI UNIVERSITY",
  "Maharaja Sriram Chandra Bhanja Deo University",
  "RAJENDRA UNIVERSITY",
  "MADHUSUDAN LAW UNIVERSITY",
  "ODISHA UNIVERSITY OF TECHNOLOGY AND RESEARCH",
  "AIPH UNIVERSITY",
  "ODIA UNIVERSITY",
  "VIKRAM DEV UNIVERSITY",
  "VEER SURENDRA SAI INSTITUTE OF MEDICAL SCIENCES  AND RESEARCH",
  "DRIEMS UNIVERSITY",
  "ODISHA UNIVERSITY OF HEALTH SCIENCES",
  "Khallikote Unitary University",
  "SRI SRI UNIVERSITY",
  "Sri Balaji Vidyapeeth (Deemed to be University)",
  "Puducherry Technological University, Puducherry",
  "Pondicherry Univeristy, Puducherry",
  "National Institute of Technology Puducherry",
  "Jawaharlal Institute of Post Graduate Medical Education & Research, Puducherry",
  "Thapar Institute of Engineering and Technology, Patiala",
  "Central University of Punjab, Bathhinda",
  "I K Gujral Punjab Technical University, Jalandhar",
  "DAV University",
  "Indian Institute of Technology, Ropar",
  "Dr. B. R. Ambedkar National Institute of Technology, Jalandhar",
  "National Institute of Pharmaceutical, Educational and Research, Mohali",
  "Sant Longowal Institute of Engg. & Tech., Longowal",
  "AMITY UNIVERSITY",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCE, BATHINDA",
  "LAMRIN TECH SKILLS UNIVERSITY PUNJAB",
  "SANT BABA BHAG SINGH UNIVERSITY",
  "Sri Guru Granth Sahib World University, Fatehgarh Sahib",
  "JAGAT GURU NANAK DEV PUNJAB STATE OPEN UNIVERSITY",
  "GURU KASHI UNIVERSITY",
  "Lovely Professional University",
  "Punjab Agricultural University, Ludhiana",
  "RIMT UNIVERSITY",
  "Sardar Beant Singh State University Gurdaspur",
  "CT University, Ludhiana",
  "THE MAHARAJA BHUPINDER SINGH PUNJAB SPORTS UNIVERSITY",
  "Rajiv Gandhi National University of Law, Punjab",
  "ADESH UNIVERSITY",
  "Punjabi University, Patiala",
  "DESH BHAGAT UNIVERSITY",
  "Shaheed Bhagat Singh State University",
  "Guru Nanak Dev University, Amritsar",
  "GNA UNIVERSITY",
  "National  Institute of Electronics and Information Technology NIELIT",
  "CHANDIGARH UNIVERSITY",
  "RAYAT BAHRA UNIVERSITY",
  "Sri Guru Ram Das University of Health Sciences",
  "MAHARAJA RANJIT SINGH PUNJAB TECHNICAL UNIVERSITY, BATHINDA",
  "INDIAN INSTITUTE OF MANAGEMENT AMRITSAR",
  "Indian Institute of Science Education & Research (IISER), Mohali",
  "PLAKSHA UNIVERSITY",
  "GURU RAVIDAS AYURVED UNIVERSITY",
  "Guru Angad Dev Veterinary & Animal Sciences University, Ludhiana",
  "AKAL UNIVERSITY,BHATINDA",
  "Chitkara University, Patiala",
  "Baba Farid University of Health Sciences, Faridkot",
  "JAI MINESH ADIVASI UNIVERSITY",
  "Jayoti Vidyapeeth Women's University, Jaipur",
  "University of Rajasthan",
  "Maharaja Ganga Singh University, Bikaner",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCES, JODHPUR",
  "THE ICFAI UNIVERSITY, JAIPUR",
  "RAJASTHAN ILD SKILLS UNIVERSITY, JAIPUR",
  "SHRI KHUSHAL DAS UNIVERSITY, PILIBANAGA",
  "PANDIT DEENDAYAL UPADHYAYA SHEKHAWATI UNIVERSITY",
  "Birla Institute of Technology & Sciences, Pilani",
  "PRATAP UNIVERSITY",
  "GEETANJALI UNIVERSITY",
  "Institute of Advanced Studies in Education, Churu",
  "Homoeopathy University, Jaipur",
  "APEX UNIVERSITY",
  "Indian Institute of Technology, Jodhpur",
  "MADHAV UNIVERSITY",
  "Dr K N Modi University, Tonk",
  "Central University of Rajasthan, Jaipur",
  "Jain Vishva Bharati Institute, Nagaur",
  "SHYAM UNIVERSITY",
  "NIRWAN UNIVERSITY",
  "BIKANER TECHNICAL UNIVERSITY",
  "BHUPAL NOBLES' UNIVERSITY",
  "RAJASTHAN AYURVEDIC NURSING COUNCIL",
  "Maharana Pratap University of Agriculture & Technology, Udaipur",
  "MBM UNIVERSITY",
  "Banasthali Vidyapith",
  "Govind Guru Tribal University, Banswara",
  "VIVEKANANDA GLOBAL UNIVERSITY",
  "RAFFLES UNIVERSITY",
  "Jai Narain Vyas University, Jodhpur",
  "NIIT UNIVERSITY",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, KOTA",
  "LORDS UNIVERSITY",
  "Swami Keshwanand Rajasthan Agricultural University, Bikaner",
  "SANGAM UNIVERSITY, BHILWARA",
  "Mahatma Jyoti Rao Phoole University, Jaipur",
  "POORNIMA UNIVERSITY",
  "Amity University Rajasthan, Jaipur",
  "Mewar University, Chittorgarh",
  "JK LAKSHMIPAT UNIVERSITY",
  "SKN AGRICULTURE UNIVERSITY, JOBNER",
  "Nims University Rajasthan, Jaipur",
  "Maharishi Dayanand Saraswati University, Ajmer",
  "Career Point University",
  "Shri Jagdish Prasad Jhabarmal Tibrewala University, Jhunjhunu",
  "Vardhman Mahaveer Open University, Kota",
  "SAI TIRUPATI UNIVERSITY",
  "Jaipur National University, Jaipur",
  "Suresh Gyan Vihar Univeristy, Jaipur",
  "AGRICULTURE UNIVERSITY, KOTA",
  "Janardan Rai Nagar Rajasthan Vidyapeeth,  Udaipur",
  "Bhartiya Skill Development Univesity",
  "Jagadguru Ramanandacharya Rajasthan Sanskrit University, Jaipur",
  "Shridhar University,  Pilani",
  "Rajasthan University of Veterinary and Animal Sciences, Bikaner",
  "AGRICULTURE UNIVERSITY, JODHPUR",
  "INDIAN INSTITUTE OF MANAGEMENT UDAIPUR",
  "Rajasthan University of Health Sciences, Jaipur",
  "Rajasthan Technical University, Kota",
  "UNIVERSITY OF ENGINEERING AND MANAGEMENT",
  "MAHARAJA SURAJMAL BRIJ UNIVERSITY",
  "Singhania University, Jhunjhunu",
  "National Law University, Jodhpur",
  "LNM Institute of Information Technology, Jaipur",
  "JECRC UNIVERSITY",
  "Malviya National Institute of Technology, Jaipur",
  "Mohan Lal Sukhadia University, Uaipur",
  "MAHARISHI ARVIND UNIVERSITY",
  "Pacific Academy of Higher Education Research University, Udaipur",
  "RNB GLOBAL UNIVERSITY",
  "MAHATMA GANDHI UNIVERSITY OF MEDICAL SCIENCES AND TECHNOLOGY, JAIPUR",
  "IIS (Deemed to be University), Jaipur",
  "Jagannath University, Jaipur",
  "Haridev Joshi University of Journalism & Mass Communication",
  "Mody University of Science and Technology",
  "Kota University, Kota",
  "Bhagwant University,  Ajmer",
  "University of Technology",
  "National Institute of Ayurveda, Rajasthan",
  "MANIPAL UNIVERSITY, JAIPUR",
  "SARDAR PATEL UNIVERSITY OF POLICE, SECURITY AND CRIMINAL JUSTICE",
  "RAJ RISHI BHARTRIHARI MATSYA UNIVERSITY",
  "DR BHIMRAO AMBEDKAR LAW UNIVERSITY",
  "SHRI KALLAJI VEDIC VISHVAVIDYALAYA",
  "MAULANA AZAD UNIVERSITY, JODHPUR",
  "Sir Padampat Singhania University, Udaipur",
  "MAHARAJ VINAYAK GLOBAL UNIVERSITY, JAIPUR",
  "TANTIA UNIVERSITY, SRI GANGANAGAR",
  "PACIFIC MEDICAL UNIVERSITY",
  "IIHMR UNIVERSITY",
  "Dr Sarvepalli Radhakrishnan Rajasthan Ayurved University, Jodhpur",
  "SHRI RAMASAMY MEMORIAL UNIVERSITY",
  "SIKKIM SKILL UNIVERSITY",
  "Sikkim Sardar Patel University",
  "SIKKIM ALPINE UNIVERSITY",
  "The ICFAI University Sikkim",
  "National Institute of Technology Sikkim",
  "Sikkim Manipal University, Gangtok",
  "Sikkim  University, Gangtok",
  "MEDHAVI SKILLS UNIVERSITY",
  "Sikkim Global Technical University",
  "Sikkim Professional University, Tadong",
  "KHANGCHENDZONGA STATE UNIVERSITY",
  "Dakshina Bharat Hindi Prachar Sabha",
  "Indian Maritime University",
  "Sri Venkateswaraa University",
  "Periyar Maniammai Institute of Science & Technology, Thanjavur",
  "St Joseph University",
  "Bharathiar University, Coimbatore",
  "TAMIL NADU FISHERIES UNIVERSITY",
  "Tamil Univesity, Thanjavur",
  "Academy of Maritime Education and Training, Chennai",
  "National Institute of Technology, Tiruchirapalli",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCES MADURAI",
  "Noorul Islam Centre for Higher Education, Kanyakumari",
  "Joy University",
  "Periyar University, Salem",
  "Ponnaiyah Ramajayam Institute of Science & Technology, Thanjavur",
  "Sathyabama Institute of Science & Technology, Chennai",
  "THE TAMILNADU DR. J JAYALALITHAA MUSIC AND FINE ARTS UNIVERSITY",
  "NATIONAL INSTITUTE OF FOOD TECHNOLOGY, ENTREPRENEURSHIP AND MANAGEMENT -THANJAVUR",
  "Tamil Nadu Dr. Ambedkar Law University, Chennai",
  "Tamil Nadu Open University, Chennai",
  "M.G.R. Educational and Research Institute, Chennai",
  "Meenakshi Academy of Higher Education and Research, Chennai",
  "Karunya Institute of Technology and Sciences, Coimbatore",
  "NATIONAL INSTITUTE OF TECHNICAL TEACHERS TRAINING AND RESEARCH, CHENNAI",
  "Vel Tech Rangarajan Dr. Sagunthala R & D Institute of Science & Technology, Chennai",
  "Manonmaniam Sundaranar University, Tirunelveli",
  "St. Peter's Institute of Higher Education and Research, Chennai",
  "TAMIL NADU NATIONAL LAW UNIVERSITY",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, SRIRANGAM",
  "Tamilnadu Agricultural University, Coimbatore",
  "Madras University, Chennai",
  "Tamilnadu Physical Education and Sports University, Chennai",
  "Karpagam Academy of Higher Education, Coimbatore",
  "Indian Institute of Information Technology, Design & Manufacturing, Kancheepuram",
  "Madurai Kamaraj University, Madurai",
  "Vels Institute of Science, Technology and Advanced Studies, Chennai",
  "Tamilnadu Veterinary & Animal Sciences University, Chennai",
  "B.S. Abdur Rahman Crescent Institute of Science & Technology",
  "Takshashila University",
  "Thiruvalluvar Univeristy, Vellore",
  "S.R.M. Institute of Science & Technology, Chennai",
  "SAVEETHA INSTITUTE OF MEDICAL AND TECHNICAL SCIENCES (DEEMED TO BE UNIVERSITY)",
  "Rajiv Gandhi National Instiute of Youth Development, Sriperumbudur",
  "Vellore Institute of Technology, Vellore",
  "Mother Teresa Women's University, Kodaikanal",
  "Bharathidasan University, Tiruchirappalli",
  "Hindustan Institute of Technology and Science, Kancheepuram",
  "Chettinad Academy of Research & Education, Kancheepuram",
  "INDIAN INSTITUTE OF MANAGEMENT TIRUCHIRAPALLI",
  "Kalasalingam Academy of Research and Education",
  "Sri Chandrasekharendra Saraswathi Viswa Mahavidyalaya, Kancheepuram",
  "Annamalai University, Annamalainagar",
  "Anna University, Chennai",
  "SAI UNIVERSITY",
  "Avinashilingam Institute for Home Science & Higher Education for Women, Coimbatore",
  "Bharath Institute of Higher Education & Research",
  "DHANALAKSHMI SRINIVASAN UNIVERSITY",
  "Amrita Vishwa Vidyapeetham, Coimbatore",
  "Alagappa University, Alagappa Nagar, Karaikudi",
  "Gandhigram Rural Institute, Dindigul",
  "Shanmugha Arts, Science, Technology & Reserch Academy (SASTRA), Thanjavur",
  "JEPPIAR UNIVERSITY",
  "VINAYAKA MISSIONs RESEARCH FOUNDATION, SALEM",
  "SHIV NADAR UNIVERSITY",
  "Chennai Mathematical  Institute, Chennai",
  "Tamil Nadu Teachers Education University, Chennai",
  "Indian Institute of Technology, Madras",
  "Sri Ramachandra Institute of Higher Education and Research (Deemed University)",
  "Central University of Tamil Nadu, Tiruvarur",
  "Tamil Nadu Dr. M.G.R. Medical University , Chennai",
  "The English and Foreign Languages University, Hyderabad",
  "Sreenidhi University",
  "P.V. NARSIMHA RAO TELANGANA VETERINARY UNIVERSITY",
  "Jawaharlal Nehru Technological University, Hyderabad",
  "SR University",
  "National Academy of Legal Studies & Research (NALSR) University Hyderabad",
  "Aurora Higher Education and Research Academy",
  "Malla Reddy Vishwavidyapeeth",
  "University of Hyderabad, Hyderabad",
  "Guru Nanak University",
  "Nizam Institute of Medical Sciences,  Hyderabad",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCE  BIBINAGAR",
  "NATIONAL INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH (NIPER) HYDERABAD",
  "MAHINDRA UNIVERSITY",
  "MALLA REDDY UNIVERSITY",
  "CHAITANYA (DEEMED TO BE UNIVERSITY)",
  "RAJIV GANDHI UNIVERSITY OF KNOWLEDGE TECHNOLOGIES, BASAR",
  "Kaveri University",
  "SRI KONDA LAXMAN TELANGANA STATE HORTICULTURAL UNIVERSITY (SKLTSHU)",
  "NICMAR University of Construction Studies, Hyderabad Telangana",
  "MNR University",
  "WOXSEN UNIVERSITY",
  "ANURAG UNIVERSITY",
  "Sammakka Sarakka Central Tribal University",
  "KALOJI NARAYANA RAO UNIVERSITY OF HEALTH SCIENCES",
  "Suravaram Pratapa Reddy Telugu University, Hyderabad",
  "Telangana University, Nizamabad",
  "Satavahana University, Karimnagar",
  "Malla Reddy MR University",
  "Palamuru University,  Mahabubnagar",
  "Osmania University, Hyderabad",
  "National Institute of Technology, Warangal",
  "Maulana Azad National Urdu University, Hyderabad",
  "Mahatma Gandhi University, Nalgonda",
  "Jawarharlal Nehru Architecture and Fine Art University Hyderabad",
  "International Institute of Information Technology, Hyderabad",
  "Indian Institute of Technology, Hyderabad",
  "ICFAI Foundation for Higher Education, Hyderabad",
  "Dr. B. R. Ambedkar Open University, Hyderabad",
  "Kakatiya University, Warangal",
  "PROFESSOR JAYASHANKAR TELANGANA AGRICULTURAL UNIVERSITY (PJTAU)",
  "Mata Tripura Sundari Open University",
  "ARYAVART INTERNATIONAL UNIVERSITY",
  "Tripura University, Agartala",
  "Indian Institute of Information Technology Agartala",
  "TECHNO INDIA UNIVERSITY TRIPURA",
  "Dhamma Dipa International Buddhist University",
  "NATIONAL LAW UNIVERSITY",
  "The Institute of Chartered Financial Analysts of India University, Agartala",
  "MAHARAJA BIR BIKRAM UNIVERSITY, AGARTALA",
  "National Institute of Technology, Agartala",
  "UTTARAKHAND AYURVED UNIVERSITY",
  "IMS UNISON UNIVERSITY",
  "Forest Research Institute, Dehradun",
  "MOTHERHOOD UNIVERSITY",
  "Uttrakhand Technical University, Dehradun",
  "University of Patanjali, Patanjali Yogpeeth, Haridwar",
  "Jigyasa University, Dehradun",
  "Dev Sanskriti Vishwavidyalaya, Gayatrikunj",
  "Kumaun University, Nainital",
  "GRAPHIC ERA HILL UNIVERSITY",
  "G.B. Pant Universtiy of Agriculture and Technology, Pantnagar",
  "Doon University, Dehradun",
  "Hemwati Nandan Bahuguna Garhwal Univeristy, Srinagar, Garhwal",
  "Smt Manjira Devi University",
  "DBS Global University",
  "Amrapali University",
  "Mind Power University",
  "Uttarakhand Open University",
  "HARIDWAR UNIVERSITY",
  "SRI DEV SUMAN UTTARAKHAND UNIVERSITY, BADSHAHITHOL, TEHRI",
  "Maya Devi University",
  "HEMWATI NANDAN BAHUGUNA MEDICAL EDUCATION UNIVERSITY",
  "Gurukul Kangri Vishwavidyalaya, Haridwar",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCES, RISHIKESH",
  "SWAMI RAMA HIMALAYAN UNIVERSITY",
  "The ICFAI University, Dehradun",
  "SURAJMAL UNIVERSITY",
  "Uttarakhand Sanskrit University, Hardwar",
  "Bhagwant Global University",
  "COER ROORKEE",
  "DEV BHOOMI UTTARAKHAND UNIVERSITY",
  "INDIAN INSTITUTE OF MANAGEMENT KASHIPUR",
  "Shri Guru Ram Rai University, Dehradun",
  "Ras Bihari Bose Subharti University",
  "Indian Institute of Technology, Roorkee",
  "University of Petroleum and Energy Studies, Dehradun",
  "DIT UNIVERSITY",
  "HIMALAYAN GARHWAL UNIVERSITY",
  "National Institute of Technology Uttarakhand",
  "UTTARAKHAND UNIVERSITY OF HORTICULTURE AND FORESTRY, BHARSAR",
  "Quantum University",
  "Graphic Era University, Dehradun",
  "HIMALAYIYA UNIVERSITY",
  "UTTARANCHAL UNIVERSITY, DEHRADUN",
  "SARDAR BHAGWAN SINGH UNIVERSITY",
  "SOBAN SINGH JEENA UNIVERSITY",
  "Chatrapati Sahuji Maharaj Kanpur University, Kanpur",
  "HARCOURT BUTLER TECHNICAL UNIVERSITY",
  "Vidya University",
  "University of Allahabad, Allahabad",
  "U.P. Rajarshi Tandon Open University, Allahabad",
  "Teerthanker Mahaveer University, Moradabad",
  "Sharda University, Gautam Budh Nagar",
  "GLOCAL UNIVERSITY",
  "SHRI RAMSWAROOP MEMORIAL UNIVERSITY",
  "Motilal Nehru National Institute of Technology, Allahabad",
  "INDIAN INSTITUTE OF MANAGEMENT LUCKNOW",
  "G.L.A University, Mathura",
  "Chandigarh University",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, LUCKNOW",
  "Swami Vivekanand Subharti University, Meerut",
  "Sanskriti University",
  "Shobhit Institute of Engineering & Technology, Meerut",
  "Santosh University, Ghaziabad",
  "Indian Institute of Information Technology, Allahabad",
  "UNIVERSITY OF LUCKNOW",
  "Sanjay Gandhi Post Graduate Institute of Medical Sciences, Lucknow",
  "G S University",
  "Sharda University Agra",
  "Sam Higginbottom Institute of Agriculture, Technology & Sciences, Allahabad",
  "JAYPEE UNIVERSITY, ANOOPSHAHR",
  "Saroj International University",
  "Vivek University",
  "KING GEORGE MEDICAL UNIVERSITY",
  "KHWAJA MOINUDDIN CHISHTI BHASHA VISHWAVIDYALAYA LUCKNOW",
  "Nehru Gram Bharati (Deemed to be University), Prayagraj",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCES (AIIMS), RAEBARELI",
  "Dr. Rajendra Prasad National Law University",
  "Shiv Nadar (Institution of Eminence Deemed to be University)",
  "Babasaheb Bhimrao Ambedkar University, Lucknow",
  "BANDA UNIVERSITY OF AGRICULTURE AND TECHNOLOGY, BANDA",
  "SIDDHARTH UNIVERSITY, KAPILVASTU",
  "Dayalbagh Educational Institute, Agra",
  "RAJIV GANDHI NATIONAL AVIATION UNIVERSITY",
  "Central Institute of Higher Tibetan Studies, Varanasi",
  "DR SHAKUNTALA MISRA NATIONAL REHABILITATION UNIVERSITY",
  "Mahatama Jyotiba Phule Rohikhand University, Bareilly",
  "Jaypee Institute of Information Technology, Noida",
  "Deen Dayal Upadhyaya Gorakhpur University, Gorakhpur",
  "Indian Institute of Technology (Banaras Hindu University), Varanasi",
  "UP Pandit Deen Dayal Upadhyaya Veterinary University & Gau-Anusandhan Sansthan, Mathura",
  "Major Dhyan Chand Sports University",
  "Noida International University",
  "SKS International University",
  "Mohammad Ali Jauhar University, Rampur",
  "Footwear Design and Development Institute",
  "Rani Lakshmi Bai Central Agricultural University",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCE GORAKHPUR",
  "Bareilly International University, Bareilly",
  "Professor Rajendra Singh (Rajju Bhaiya) University, Prayagraj, Uttar Pradesh",
  "Chaudhary Charan Singh University, Meerut",
  "ATAL BIHARI VAJPAYEE MEDICAL UNIVERSITY",
  "Mangalayatan University, Aligarh",
  "Invertis University, Bareily",
  "MADAN MOHAN MALAVIYA UNIVERSITY OF TECHNOLOGY,",
  "MAA SHAKUMBHARI UNIVERSITY",
  "UNITED UNIVERSITY",
  "Maa Pateswari University",
  "IILM UNIVERSITY",
  "Bundelkhand University,  Jhansi",
  "Integral University, Lucknow",
  "Banaras Hindu University, Banaras",
  "ACADEMY OF SCIENTIFIC AND INNOVATIVE RESEARCH",
  "Chandra Shekhar Azad University of Agriculture & Technology, Kanpur",
  "RAJA MAHENDRA PRATAP SINGH UNIVERSITY",
  "Bennett University, Greater Noida",
  "FS University",
  "Varun Arjun University",
  "Maharaja Suhel Dev State University",
  "SHOBHIT UNIVERSITY, GANGOH",
  "Dr. B. R. Ambedkar University, Agra",
  "MAHAYOGI GURU GORAKHNATH AYUSH UNIVERSITY",
  "AGRAWAN HERITAGE UNIVERSITY",
  "SDGI GLOBAL UNIVERSITY",
  "K M KRISHNA MOHAN UNIVERSITY",
  "Maa Vindhyavasini University",
  "JANNAYAK CHANDRASHEKHAR UNIVERSITY BALLIA",
  "Dr. Ram Manohar Lohia  Awadh University, Faizabad",
  "Guru Jambheshwar University",
  "IIMT University",
  "HRIT University, Ghaziabad",
  "Acharya Narendra Deva University of Agriculture & Technology, Ayodhya",
  "MAHAYOGI GORAKHNATH UNIVERSITY GORAKHPUR",
  "Rajiv Gandhi Institute of Petroleum Technology, Amethi",
  "IFTM University, Moradabad",
  "Dr Ram Manohar Lohia Institute of Medical Sciences",
  "T S Mishra University",
  "Indian Institute of Technology, Kanpur",
  "Mahaveer University",
  "Indian Veterinary Research Institute, Izatnagar",
  "MONAD UNIVERSITY",
  "Bhatkhande Sanskriti Vishwavidyalaya",
  "JSS University",
  "Mahatma Gandhi Kashi Vidyapeeth, Varanasi",
  "Sampurnanand Sanskrit Vishwavidyalaya,  Varanasi",
  "Sardar Vallabh Bhai Patel University of Agriculture & Technology, Meerut",
  "Veer Bahadur Singh Purvanchal University, Jaunpur",
  "Aligarh Muslim University, Aligarh",
  "Shri Venkateshwara University, Gajraula, J.P Nagar",
  "Gautam Buddha University, Greater Noida, Gautam Budh Nagar",
  "Dr. Ram Manohar Lohiya National Law University, Lucknow",
  "ERA UNIVERSITY",
  "GALGOTIAS UNIVERSITY",
  "Babu Banarsi Das University, Lucknow",
  "Major S D Singh University",
  "Dr.A.P.J. ABDUL KALAM TECHNICAL UNIVERSITY ,LUCKNOW",
  "Future University",
  "UTTAR PRADESH UNIVERSITY OF MEDICAL SCIENCES,",
  "J S University",
  "Amity University, Uttar Pradesh",
  "RAMA UNIVERSITY UTTAR PRADESH",
  "Jagadguru Rambhadracharya Divyang State University, Chitrakoot",
  "MAHARISHI UNIVERSITY OF INFORMATION TECHNOLOGY",
  "Visva Bharati, Shantiniketan",
  "Uttar Banga Krishi Vishwavidyalaya, Cooch Behar",
  "The West Bengal University of Health Sciences, Kolkata",
  "TECHNO INDIA UNIVERSITY, WEST BENGAL",
  "Baba Saheb Ambedkar Education University",
  "BISWA BANGLA BISWABIDYALAY",
  "The West Bengal National University of Juridicial Sciences, Kolkata",
  "The University of Burdwan",
  "THE ALIPURDUAR UNIVERSITY",
  "UNIVERSITY OF CALCUTTA",
  "MAHATMA GANDHI UNIVERSITY",
  "HARICHAND GURUCHAND UNIVERSITY",
  "DAKSHIN DINAJPUR UNIVERSITY",
  "HINDI UNIVERSITY",
  "KANYASHREE UNIVERSITY",
  "MURSHIDABAD UNIVERSITY",
  "RAIGANJ UNIVERSITY",
  "KAZI NAZRUL UNIVERSITY, ASANSOL",
  "Sidho-Kanho Birsa University",
  "Netaji Subhash Open University, Kolkata",
  "SADHU RAM CHAND MURMU UNIVERSITY OF JHARGRAM",
  "ST. XAVIER'S UNIVERSITY, KOLKATA",
  "DARJEELING HILLS UNIVERSITY",
  "University of Gour Banga, Malda",
  "Ramakrishna Mission Vivekananda Educational  and Research Institute, Howrah",
  "INDIAN INSTITUTE OF ENGINEERING SCIENCE AND TECHNOLOGY, SHIBPUR",
  "RANI RASHMONI GREEN UNIVERSITY",
  "DIAMOND HARBOUR WOMENS UNIVERSITY",
  "BANKURA UNIVERSITY, BANKURA",
  "SWAMI VIVEKANANDA UNIVERSITY",
  "WEST BENGAL STATE UNIVERSITY ( BARASAT, NORTH 24 PARGANAS)",
  "SEACOM SKILLS UNIVERSITY",
  "ALL INDIA INSTITUTE OF MEDICAL SCIENCE KALYANI",
  "INDIAN ASSOCIATION FOR THE CULTIVATION OF SCIENCE",
  "COOCH BEHAR PANCHANAN BARMA UNIVERSITY",
  "UNIVERSITY OF ENGINEERING AND MANAGEMENT, KOLKATA",
  "National Institute of Technology, Durgapur",
  "JIS UNIVERSITY",
  "Indian Institute of Technology, Kharagpur",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, KALYANI",
  "INDIAN INSTITUTE OF MANAGEMENT, KOLKATA",
  "BRAINWARE UNIVERSITY",
  "West Bengal University of Animal and Fishery Sciences, Kolkata",
  "THE NEOTIA UNIVERSITY",
  "SISTER NIVEDITA UNIVERSITY",
  "Indian Institute of Science Education & Research (IISER), Kolkata,",
  "ADAMAS UNIVERSITY",
  "THE SANSKRIT COLLEGE AND UNIVERSITY",
  "AMITY UNIVERSITY",
  "Indian Statistical Institute, Kolkata",
  "Vidyasagar University, Midnapore",
  "Maulana Abul Kalam Azad University of Technology, West Bengal",
  "Rabindra Bharati University, Kolkata",
  "Presidency University",
  "North Bengal University, Darjeeling",
  "Kalyani University, Kalyani",
  "Jadavpur University, Kolkata",
  "Bidhan Chandra Krishi Vishwavidyalaya , Nadia",
  "Aliah University, Kolkata",
  "National Institute of Technical Teachers Training and Research Kolkata",
  "Andaman and Nicobar inslands Institute of medical sciences",
  "ANDAMAN COLLEGE (ANCOL)",
  "ANDAMAN LAW COLLEGE",
  "Zoological Survey of India",
  "Tagore Government College of Education",
  "Regional Medical Research Institute (I.C.M.R.)",
  "Mahatma Gandhi Govt. College",
  "Jawaharlal Nehru Rajkeeya  Mahavidyalaya",
  "Dr.B.R. Ambedkar Institute of Technology",
  "MAGUNTA SUBBARAMA REDDY DEGREE COLLEGE KONDAPI",
  "VARMA COLLEGE OF EDUCATION",
  "PUTTUR COLLEGE OF PHYSIOTHERAPY PUTTUR",
  "SREE VASAVI DEGREE COLLEGE",
  "Sri Venkateswara Degree College, Madakasira",
  "ADITYA DEGREE COLLEGE BODASINGIPETA BONDAPALLI",
  "GAYATRI VIDYA PARISHAD INSTITUTE OF HEALTH CARE AND MEDICAL TECHNOLOGY",
  "SREE LAGUDU SIMHADRI COLLEGE OF EDUCATION",
  "OMSAI COM DEGREE COLLEGE",
  "KODI RAMA MURTHY COLLEGE OF PHYSICAL EDUCATION",
  "SRI PADMAVATHI COLLEGE OF NURSING, TIRUPATI",
  "Sri Harsha Institute of PG Studies",
  "Mandava Institute of Engineering and Technology",
  "Govt college of Nursing,RIMS",
  "MINERVA BSC MLT COLLEGE",
  "Sree Tirumalesa Degree College",
  "MINERVA ALLIED HEALTH SCIENCES AND PHYSIOTHERAPY COLLEGE",
  "DRK REDDY COLLEGE OF PHYSICAL EDUCATION, G. MAMIDADA",
  "SRI VIVEKANANDA DEGREE COLLEGE",
  "HARINADHA REDDY INSTITUTE OF MANAGEMENT SCIENCES",
  "SIDDHARDHA B.ED. COLLEGE",
  "SRI LAKSHMI INSTITUTE OF MEDICAL SCIENCES COLLEGE OF PHYSIOTHERAPY",
  "Sri Hari Degree College",
  "Rani Tirumala Devi Degree College",
  "Varma College of Nursing, Tirupati",
  "S.L.V. College of Education, Cumbum",
  "Vagdevi Degree College, Narsaraopeta",
  "Sri A. S. N. M. Government College, Palakol",
  "Pushpagiri College of Education",
  "Sri BVR Degree College",
  "NRI COLLEGE OF PHYSIOTHERAPY",
  "Sri Mahaveer Memorial Jain Degree College",
  "D.S.Govt. Degree College for Women, Ongole",
  "J.M.J. College for Women",
  "Repalle Christian College, Repalle",
  "Hindu College of Pharmacy, Guntur",
  "S.V.K.P. College, Cumbum",
  "C.R. College, Nadendla",
  "BHH Degree College for Women, Guntur",
  "Alpha Degree College Kanigiri",
  "S.G.K. Oriental College, Tadikonda",
  "Andhra Kesari College of Education, Ongole",
  "ANDHRA KESARI BED COLLEGE OF EDUCATION CHAKIRALA KANIGIRI",
  "K.L.R. Degree College, Giddaluru",
  "SS AND N POLYTECHNIC OF AGRICULTURE",
  "OXFORD DEGREE COLLEGE",
  "Bhagawan Sri Satya SaiBaba Degree College, Tadikonda",
  "SRI VENKATESWARA DEGREE COLLEGE, PONNUR",
  "VIJAYALAKSHMI DEGREE COLLEGE  SRIKALAHASTI ",
  "Sri Lakshmi Sravani College of Education,Medarametla Village, Korisepadu Taluk, Prakasham District",
  "ADITYA DEGREE COLLEGE, Gudivada",
  "Sri Srinivasa Arts & Science College, Giddaluru",
  "Sri Raja Rajeswari College of Education, Giddalur",
  "DVR & Dr. HS MIC College of Technology",
  "Adarsa College of Education, Giddaluru",
  "N.T.R Memorial Degree College, Addanki",
  "ADITYA DEGREE COLLEGE, MACHILIPATNAM",
  "Janahitha Degree College",
  "Asha College of Education, Markapur",
  "S.N.B.T.M. College of Education, Repalle",
  "S.G.T. & J.V.B. College, Thulluru",
  "P.N.C.A Degree College, Somarajupalli, Singarayakonda",
  "Morning Star College, Phirangipuram",
  "G.C.K.V.N. Degree College, Guntur",
  "Venigalla Jayasri Ram College, Kolluru",
  "Dr. K.R.R.M. Degree College, Duggirala",
  "Abhyudaya Mahila Degree College, Guntur",
  "P.S.B. College of Education, Chirala",
  "HIS COLLEGE OF EDUCATION ",
  "Kamala College of Education, Markapur",
  "Govt. Degree College, Chebrolu",
  "COLLEGE OF FINE ARTS ",
  "R.V.V.N. College, Dharanikota, Amaravathi",
  "B.R.College of Education, Narsipatnam, Visakhapatnam",
  "Unity Degree College ",
  "SRI VENKATA SAI COLLEGE OF EDUCATION, KANDULAPURAM, CUMBUM, PRAKASAM DISTRICT",
  "Sriji Degree College, Maddiralapadu",
  "SRI VIGNANA BHARATHI DEGREE COLLEGE",
  "RCR Institute of Management & Technology, Karakambadi, Tirupati",
  "Dr. Modigunta Raja Reddy Degree College 4-139,Main Road,K.C.Palli Road,Penumuru (M),",
  "Shams-Ul_Uloom College of Education, Markapur",
  "Akshara Institute of Management and Technology, Kotramangalam, Tirupati",
  "Dr.A.E.R College of Mgnt Studies & Research, Ramapuram, Tirupati",
  "Sidhartha Institute of Higher learning, Madanapalle  Urban",
  "Malineni Lakshmaiah B.Ed College, Singarayakonda",
  "Gate Institute of Tech. & Manag. Sciences, Tirupati",
  "KKC Institute of PG Stuides, Puttur",
  "SP Ram Rayalaseema Degree College, Chandragiri",
  "Seshachala Degree      College, Puttur Rural",
  "Himaja Degree       College, Puttur Rural",
  "S.V.U. College of Engineering, Tirupati",
  "Shri Gnanambica Degree College, Madanapalli",
  "Krishna Teja Degree College, Tirupati",
  "PVKN Govt. College (A), CHITTOOR Urban",
  "Sahaya College of Education, Tirupati",
  "Munivenkata Subba  Reddy College of Education, Tirupati",
  "V.C.R Degree  College,  Mittoor Urban",
  "J.R.R Navodaya Degree College, Gurazala",
  "S.V.College of Education, RVS Nagar, Chittoor",
  "Rukminidevi Arundale college of Education, Madanapalle",
  "PSK DEGREE COLLEGE",
  "Vignana Sudha Degree College Chittoor",
  "SEICOM Degree College, Kalikiri",
  "S.G. Govt.      Degree College,      PILER   Rural",
  "Srinivasa College of Education, Puttur",
  "ADITYA DEGREE COLLEGE ICHAPURAM",
  "Viswam Degree & PG College, Angallu, Chittoor Dist.",
  "SRI HARSHINI COLLEGE OF ENGINEERING AND TECHNOLOGY FOR WOMEN",
  "Sri Eshwar Reddy College of Law, Tirupati",
  "Dr. Ambedkar Law College, Renigunta Road, Tirupati",
  "Govt. Degree College Pakala -Rural             Co-Ed.",
  "Siddhartha Institute of Pharmaceutical Sciences, Jonnalagadda",
  "K.M.M. College of Education, Ramireddypalli, Narasingapuram (post)",
  "Palnadu College of Education, Narayanapuram",
  "Sri. R.K.M. Law College, Tirupati",
  "Vasavi MBA & MCA College, Kandulapuram",
  "KAKINADA ADITYA DEGREE COLLEGE",
  "NALANDA DEGREE COLLEGE",
  "SRI GURUDATTA DEGREE COLLEGE",
  "PADMAVATHI COLLEGE OF TEACHER EDUCATION",
  "JESUS THE SAVIOUR OF NATIONS COLLEGE OF EDUCATION",
  "JESUS DOGGA COLLEGE OF EDUCATION",
  "SWAMY VIVEKANANDA DEGREE COLLEGE, AKUTHOTAPALLI, ANANTAPURAMU",
  "Sree Vignan Degree College, Amadaguru",
  "SVR Degree College, MGM Complex, Macherla, Guntur District",
  "Rayalaseema College of Education, Tirupati",
  "Sri Kalahasthiswara Institute of Infor. & Manag. Sciences, Sri Kalahasthi.",
  "SRI.C.DASS Arts & Science Degree  College,    SATHYAVEDU Rural",
  "H P N DEGREE COLLEGE",
  "SDHR Degree College, Tirupati",
  "INDIAN MARITIME UNIVERSITY, VISAKHAPATNAM",
  "S.V.U. College of Arts, Tirupati",
  "Sri Vivekananda   Degree College, Madanapalle Urban",
  "S.R.Govt.      Degree    College,      PUNGANUR Rural",
  "SRI VANI Degree College PALAMANER Rural",
  "Vignan Degree College, Bangarupalem",
  "MAHENDRA DEGREE COLLEGE",
  "THAMMI NAIDU DEGREE COLLEGE",
  "ADITYA DEGREE COLLEGE",
  "SRI VENKATA SAI DEGREE COLLEGE",
  "Royal College of Education, Markapur, Prakasam District",
  "SRI RADHAKRISHNA COLLEGE OF EDUCATION",
  "GOVERNMENT DEGREE COLLEGE FOR MEN",
  "B.S. & J.R. DEGREE COLLEGE",
  "SRI RAMESWARI DEGREE COLLEGE",
  "RAVOOF &  VAZIR KHAN MEMORIAL COLLEGE OF EDUCATION",
  "MOTHER THERESA DEGREE COLLEGE",
  "VAMSADHARA DEGREE COLLEGE",
  "SPOORTHY DEGREE COLLEGE",
  "S.S.N Degree College, Podili",
  "GURAJADA COLLEGE OF EDUCATION",
  "GOVERNMENT DEGREE COLLEGE, PALAKONDA",
  "SRI SAI DEGREE COLLEGE",
  "VAMSADHARA DEGREE COLLEGE, KOTABOMMALI",
  "SRI. GCSR. DEGREE COLLEGE",
  "SRI KRISHNA SAI DEGREE COLLEGE",
  "KIRANMAI DEGREE COLLEGE",
  "VAMSADHARA COLLEGE OF EDUCATION",
  "Priyadarsini Institute of Pharmaceutical Science",
  "PRAJNA COLLEGE OF SCIENCE & ARTS NEAR G.J. COLLEGE",
  "S.B.S.Y.M.  DEGREE COLLEGE, PALASA",
  "Chalapathi Institute of Engineering & Technology, Lam",
  "VIDYADHARI DEGREE COLLEGE",
  "ABHYUDAYA DEGREE COLLEGE",
  "SYSTEM DEGREE COLLEGE",
  "Vagdevi College of Pharmacy, Gurazala",
  "RANGUMUDRI COLLEGE OF EDUCATION",
  "Chegireddy Linga Reddy Instt of Management, Cumbum",
  "GOVERNMENT DEGREE COLLEGE, SEETHAMMAPETA",
  "G.B.R.Degree College",
  "Sri Venkateswara Vidya Peeth Degree College",
  "SGS Govt, IASE",
  "Sri Balaji Degree College",
  "Sri Chanakya Degree College",
  "AGRICULTURAL COLLEGE, PULIVENDULA",
  "Vivekananda Degree College, Balighattam, Narsipatnam",
  "Bellamkonda Sudha College of Education, Thripurapuram village, Giddalur, Prakasam District",
  "SURYA TEJA DEGREE COLLEGE",
  "GOVERNMENT COLLEGE OF NURSING",
  "DURGA COLLEGE OF NURSING",
  "V.S.Lakshmi Degree College for Women",
  "College of Horticulture, Venkataramannagudem",
  "College of Horticulture, Anantharajupet",
  "Pragathi Degree College, Kottavalasa, Vizianagaram",
  "N.R.K & K.S.R Gupta College of Pharmacy, Tenali",
  "S.B.V.S.R College of Education, Cheemakurthi",
  "Madura Sai Institute of IT & Management, Proddutur",
  "N B K R INSTITUTE OF SCIENCE & TECHNOLOGY, VIDYANAGAR, KOTA",
  "PRABHATH INSTITUTE OF COMPUTER SCIENCES, PARNAPALLI (V), NANDYAL",
  "Sir C.V. Raman Institute of Technology & Sciences, Tadipatri,",
  "Sarada College of Pharmaceutical Sciences, Narasaraopeta",
  "Annamacharya Institute of Technology And Sciences, Chinthakomma Dinne",
  "Vasavi Institute of Pharmaceutical Science",
  "SSK INSTITUTE OF BUSINESS MANAGEMENT, VONTIMITTA (V & M)",
  "SRI DATTA SAI SCHOOL OF BUSINESS, PRAKSASAMPALLI (V), KOPPARTHI (P)",
  "MJR INSTITUTE OF BUSINESS MANAGEMENT, DIGUVAPOKULAVARIPALLI (V), PULICHERLA (M)",
  "SRI BALAJI PG COLLEGE (MCA), ALAMURU (P), RUDRAMPETA",
  "SRI BALAJI PG COLLEGE (MBA), ALAMURU (P), RUDRAMPETA",
  "Sri Sai College of  IT & Management",
  "Sree Rama Engineering College, Tirupati",
  "Ravindra College of Engineering for Women, kurnool",
  "Allagadda Inst. Of Management & Science (PG), Allagadda",
  "Srinivasa Institute of Pharmaceutical Sciences, Proddutur",
  "Vignanasudha Institute of Management &Technology, Chittoor",
  "Balaji  College of Pharmacy, Anantapur",
  "A.Q.J. Degree College",
  "Saastra College of Pharmaceutical Educational & Research, Guduru.",
  "Kandula Lakshumma College of Egg. for Women",
  "Safa College of Pharmacy, Kurnool",
  "Ashoka Women's Engineering College, Kurnool",
  "NTR Govt.     Degree College,     Valmikipuram   Rural",
  "Narayana Engineering College",
  "Sri Krishna Chaitanya College of Pharmacy, Madanapalli",
  "Tadipatri Engineering College,  Tadipatri",
  "KMM Institute of Technology & Science, Tirupathi",
  "Sri Padmavathi School of Pharmacy, Tirupathi",
  "Creative Educational Society's College of Pharmacy, Kurnool",
  "Krishna Teja Pharmacy College, Tirupati",
  "Annamacharya P.G. College of Computer Studies, Rajampet",
  "Parvatha Reddy Babul Reddy Visvodaya Institute of Technology & Science",
  "K.S.R.M. College of Engineering",
  "Chaitanya Bharathi Institute of Technology, Proddutur",
  "NOVA PG COLLEGE(MBA)",
  "TSR BSC COLLEGE OF NURSING",
  "GOVERNMENT DEGREE COLLEGE PALASA",
  "DR YSR GOVT DEGREE COLLEGE VEDURUKUPPAM",
  "St. Xavier Institute of Pharmacy, Phirangipuram",
  "BHEEMESWAR DEGREE COLLEGE PUTHALAPATTU",
  "NOVA PG (MCA)",
  "Sri Vivekananda Degree College, Vinjamur",
  "SRI SAI COLLEGE OF EDUCATION ONGOLE",
  "Saraswathi College of Education Giddalur Prakasam District",
  "Mother College of Education (B.Ed) Darsi, Prakasam District",
  "Krishna Chaitanya Degree College, Nellore",
  "JRR B.Ed College, Cumbum",
  "Goutham College of Education, Cumbum",
  "Guthikonda Sreeramulu College of Education, Buchireddypalem",
  "SRI MUNINARAYANA DEGREE COLEGE, CHOWDEPALLI",
  "SRI MUNINARYANA DEGREE COLLEGE",
  "Vikas College of Education, Darsi",
  "Dr.PAUL RAJ ENGINEERING COLLEGE",
  "HEZEKIAH COLLEGE OF EDUCATION",
  "Devathi Venkata Subbiah College of Education, Darsi",
  "Visakha Govt. Degree College for Women",
  "KRISHNA CHAITANYA DEGREE COLLEGE, KANIGIRI",
  "SRI VENKATESWARA POLYTECHNIC OF AGRICULTURE",
  "SRI GOWTHAMI DEGREE COLLEGE, CHIRALA",
  "Aditya Womens Degree College",
  "Indira College of Education",
  "Priyadarshini Degree College",
  "Vignan Degree College, O.D. Cheruvu",
  "RATHNAMA COLLEGE OF NURSING",
  "Sahitya Degree College",
  "SRI DUGGANAPALLI KRISHNAREDDY DEGREE COLLEGE. VEERABALLI",
  "SRI RAJIV GANDHI COLLEGE OF NURSING WEST GODAVARI TANUKU",
  "Sri Venkateswara Degree College, Mudhanur",
  "A.S.N Pharmacy College, Tenali",
  "Aditya Degree and PG College",
  "SVSRM College of Education ",
  "SRI VENKATESWARA DEGREE COLLEGE",
  "Sri Vagdevi Degree College Phirangipuram",
  "ANIMAL HUSBANDRY POLYTECHNIC, GARIVIDI",
  "Sashikanthreddy College of Pharmacy, Nellore.",
  "NIMRA INSTITUTE OF MEDICAL LAB TECHNOLOGY",
  "GOVERNMENT COLLEGE OF NURSING ONGOLE",
  "NIMRA INSTITUTE OF PHYSIOTHERAPY",
  "NIMRA INSTITUTE OF PARAMEDICAL SCIENCES",
  "SRI SWAMINATHAN AGRICULTURE POLYTECHNIC",
  "SNK ANIMAL HUSBANDRY POLYTECHNIC COLLEGE, MADAKASIRA",
  "VEDHA COLLEGE OF NURSING",
  "AGRICULTURAL POLYTECHNIC",
  "S.D.S.(Autonomous) College of Arts & Science",
  "NIMRA COLLEGE OF NURSING",
  "Sri Nagarjuna Degree College, Ongole",
  "BR POLYTECHNIC OF AGRICULTURE",
  "SRI NAGARJUNA ARTS AND SCIENCE COLLEGE, CHEKURAPADU",
  "SYAMALAKRISHNA POLYTECHNIC OF AGRICULTURAL ENGINEERING",
  "Nagarjuna Institute of Management Studies, Chekurapadu",
  "Geethanjali Degree College, Darsi",
  "S.C.I.M Govt. College",
  "GOVERNMENT DEGREE COLLEGE, PANYAM",
  "Akshara Degree College, Pamuru",
  "RAJIV GANDHI INSTITUTE OF LAW",
  "Sri Rama Krishna Degree College, Ongole",
  "SRI MAHA LAKSHMI COLLEGE OF BSC MLT, VIZIANAGARAM",
  "ARROW COLLEGE OF PHYSIOTHERAPY, CURRENCY NAGAR, VIJAYAWADA",
  "Geetham Degree College, Ongole",
  "C.S.R. Sarma College, Ongole",
  "SYAMALAKRISHNA POLYTECHNIC OF SEED TECHNOLOGY",
  "B.A & K.R College of Education, Medarametla, Ongole",
  "ADVANCED POST GRADUATE CENTRE, LAM FARM, GUNTUR",
  "KAKINADA SIMS COLLEGE OF PHYSIOTHERAPY",
  "AKNU M.S.N. CAMPUS, KKD",
  "SATYA DEVA COLLEGE OF MEDICAL LAB TECHNOLOGY",
  "AL Momin College of Education, Podili",
  "Ramesh B.Ed College, Mangamuru, S.N Padu, Prakasam District",
  "Rao's Institute of Management Studies",
  "Velankini Institute of Management Studies",
  "PRIYADARSHINI INSTITUTE OF TECHNOLOGY & SCIENCES  CHINTALAPUDI, Near Tenali, Duggirala Mandal, PIN-522306  (CC-X2)",
  "Addanki Institute of Management & Science, Near Singara Konda, NRT Road,  North Addanki-523201  (CC-8D)",
  "RV INSTITUTE OF TECHNOLOGY, Chebrolu, Guntur District-522212 Andhra Pradesh.",
  "Godavari Institute of Engineering & Technology (GIET), NH-5, Chaitanya nagar, Velaguvanda Village, Rajanagaram(M),Rajahmundry,PIN- 533296  (CC-55)",
  "Sri Vasavi Institute of Engineering & Technology, Nandamuru, Pedana Mandal,  PIN-521369(CC-MQ)",
  "PRIYADARSHINI INSTITUTE OF TECHNOLOGY & SCIENCES FOR WOMEN, CHINTALAPUDI, Near Tenali, PIN-522306.(CC-KU)",
  "Lenora College of Engineering, Rampachodavaram,PIN- 533288(CC-96)",
  "BA&KR MCA&MBA College, NH-5, Doddavarappadu,  Ongole- 523211(CC-8R)",
  "Kakinada Institute of Technology & Science,Tirupathi Village, Divilli, Peddampuram (M), Pin-533433  (CC-JQ)",
  "Vasireddy Venkatadri Institute of Technology, Nambur (V), Pedakakani(M), PIN-522508(CC-BQ)",
  "SRK Institute of Technology, Enikepadu, Vijayawada-521108(CC-X4)",
  "Vignan's Lara Institute of Technology & Science, Vadlamudi, Chebrolu Mandal, PIN-522213(CC-FE)",
  "Malineni Lakshmaiah MBA College, Kanumall, (Vil),  PIN-523101(CC-2T)",
  "KALLAM HARANADHAREDDY INSTITUTE OF TECHNOLOGY",
  "NRI Institute of Technology, Visadala Road, Medikonda Mandal, Perecherla,PIN-522 009(CC-KP)",
  "Helapuri Institute of Technology & Science,Vegavaram, Denduluru Mandalam, Eluru",
  "VIKAS COLLEGE OF PHARMACY, PUTRELA ROAD, VISANNA PET",
  "MALINENI PERUMALLU EDUCATIONAL SOCIETY'S GROUP OF INSTITUTIONS (INTIGRATED CAMPUS) PULLADIGUNTA (V), VATTICHERUKURU (M), PIN-522017  (CC-7W)",
  "Prakasam Engineering College, O.V.Road, Kandukur,PIN- 523105(CC-F9)",
  "Krishna chaitanya Institute of Technology & Sciences, Jawayar nagar , MarkapurPIN-523316(CC-JU)",
  "MVR College of Engineering & Technology, Beside Hanuman Statue on NH-9, Paritala,  Vijayawada Rural,  PIN-521180(CC-8H)",
  "Bellamkonda Institute of Technology & Science, Kambhalapadu, Podili-523240, (CC-PH)",
  "Kakinada Institute of Technological Sciences,A Agraharam(V), Ramachandrapuram-533255   (CC-JP)",
  "Kakinada Institute of Engineering & Technology - II, Yanam Road, Korangi, Tallarevu Mandal, PIN-  533461(CC-6Q)",
  "GIET Engineering College",
  "Global Institute of Management & Technology, Bommuluru, Hanuman Junction, Bapulapadu Mandal,PIN- 521105,(CC - 7P)",
  "Chirala Engineering College, Ramapuram, Beach Road, Chirala, PIN-523157 (CC-E9)",
  "Sree Vahini Institute of Science & Technology",
  "Sri Sarathi Institute of Engineering & Technology, Nuzvid",
  "St. Marys Colleges of B.Pharmacy, A.D.B. Road, Surampalem, Anuru (P), Peddapuram Revenue Division,Pin-533437(CC-8Q)",
  "Nova College of Pharmacy, Vegaram, Jangareddigudem (Mandal), PIN-534447.(CC-T7)",
  "Aditya Engineering College, Aditya Nagar, ADB Raod, Surampalem, PIN-533437(CC-A9)",
  "Chalapathi Institute of Technology, A.R.Nagar, Amaravathi Road, Mothadaka, Tadikonda(Md), PIN-522016  (CC-HT)",
  "VALLABHANENI VENKATADRI INSTITUTE OF PHARMACEUTICAL SCIENCES,  SESHADRI RAO KNOWLEDGE VILLAGE, GUDLAVALLERU, PIN-521356(CC-9V)",
  "Bhimavaram Institute of Engineering & Technology, Swamy Gnananadha Ashram Road, Pennada, Bhimavaram , PIN - 534243(CC-AP)",
  "St. Mary's Group of institutions Guntur, Chebrolu (V&M),  PIN-522212  (CC-BJ)",
  "Nimra College of Engineering & Technology, Nimra nagar,(V), Ibrahimpatnam,  PIN-521456,(CC-23)",
  "BAPATLA COLLEGE OF PHARMACY,  BAPATLA-522101(CC-10)",
  "Sasi Institute of Technology & Engineering, Kadakatla, Tadepalligudem,  Pin-534101(CC-K6)",
  "Nimra College of Pharmacy, Ibrahimpatnam, Vijayawada, PIN-521456(CC-9A)",
  "D.C.R.M.Pharmacy College, Gangavaran Road, Inkollu Pin-523167(CC-Z4)",
  "D.N.R. College of Engineering & Technology, Balusumudi, Bhimavaram- 534 202,(CC-9P)",
  "Sri Mittapalli College of Engineering, NH-5, Tummalapalem,PIN-522 233  (CC-U9)",
  "PACE Institution of Technology & Sciences, NH-5, Near Valluramma Temple, Vallur, Ongole,-523272(CC-KQ)",
  "Narasaraopeta Institute of Pharmaceutical Sciences, Kotappakonda Road, Yellamanda (P.O), Narasaraopet (Md)  PIN- 522 601,(CC-CD)",
  "Vikas College of Engineering and Technology",
  "St. Mary's Women's Engineering College, Budumpadu, Guntur Rural, Guntur (Mandalam)  PIN-522013  (CC-ND)",
  "Nalanda institute of Pharmaceutical Sciences, Siddharth Nagar, Kantepudi(V), Sattenapalli (M),PIN-522 438.(CC-CR)",
  "MSN Degree & PG College",
  "S.K.M. College of Education",
  "Dr. Lankapalli Bullayya College of Engineering",
  "R.K.Degree College",
  "Dr.B.R.Ambedkar College of Law",
  "Srinivasa Institute of Management Studies ( SIMS )",
  "Krishna Degree College",
  "P.S.S.R College of Arts & Science",
  "M.V.R.Degree College",
  "All Saints Christian Law College",
  "Bhaskara Degree College",
  "I.B.M Degree College",
  "Royal College of Nursing, Chollangi",
  "Sri Aditya Degree College",
  "AKULA SREE RAMULU COLLEGE of EDUCATION Kovvur",
  "SANJEEV INSTITUTE OF PLANNING and MANAGEMENT",
  "S.V.R.M. College, Nagaram",
  "SRI RACHAPUDY NAGABHUSHANAM DEGREE & PG COLLEGE, BADVEL",
  "GOVERNMENT COLLEGE OF NURSING, MACHILIPATNAM",
  "Sri Sai Krishna Degree College",
  "Sai Chaitanya Degree College Giddalur",
  "SIDDHARTHA DEGREE COLLEGE VELAIRPAD",
  "Dr. Jayapradamba Degree College, Guntur",
  "Dr. B.R.Ambedkar Centenary Degree College, Tenali",
  "DCRM P.G College, MBA, Inkollu",
  "Chiristian Women's Degree College, Nallapadu, Guntur",
  "College of Agricultural Engineering, Madakasira",
  "Agricultural College, Bapatla",
  "Agricultural College, Mahanandi",
  "Agricultural College, Naira",
  "S.V. Agricultural College, Tirupathi",
  "College of Agricultural Engineering, Bapatla",
  "Chaitanya College of Education, Markapur",
  "BVSPM Degree College, Ongole",
  "B.R  College of Education, Pothuru, Naidupeta, Guntur",
  "Balaji Degree College, Nidubrolu, Ponnur",
  "Annabattuni Satyanarayana Degree College, Tenali",
  "Amrutha Degree College, Singarayakonda",
  "GOOD SAMARITAN COLLEGE OF NURSING ELURU",
  "PADMATEJA AND BHAVYATEJA COLLEGE OF PHYSIOTHERAPY",
  "POLYTECHNIC OF AGRICULTURE, RARS, NANDYAL",
  "VISWANATH COLLEGE OF PHYSIOTHERAPY, PHIRANGIPURAM, GUNTUR DISTRICT",
  "VAGDEVI COLLEGE OF NURSING, SEETARAMPURAM, JAGGAYYAPETA",
  "ASRAM COLLEGE OF ALLIED AND HEALTHCARE SCIENCES",
  "AM Reddy Memorial College of Pharmacy, Narasaraopeta",
  "AM Reddy College of Education, Narasaraopeta",
  "Acharya College of Engineering, Badvel",
  "GOVERNMENT DEGREE COLLEGE, VEERAGHATTAM",
  "JAGRUTHI COLLEGE OF NURSING",
  "SATYAM COLLEGE OF NURSING",
  "AGRICULTURE POLYTECHNIC RAMPACHODAVARAM",
  "POLYTECHNIC OF AGRICULTURE,RAMAGIRI",
  "AGRICULTURAL POLYTECHNIC",
  "GOVERNMENT COLLEGE OF NURSING, KAKINADA",
  "BELLAMKONDA FISHERIES POLYTECHNIC",
  "SRINIDHI FISHERIES POLYTECHNIC COLLEGE",
  "SRI VENKATESWARA FISHERIES POLYTECHNIC",
  "PYDAH COLLEGE OF FISHERIES POLYTECHNIC",
  "PYDAH GROUP FISHERIES POLYTECHNIC",
  "SRI HARI FISHERY POLYTECHNIC",
  "BHASKAR INSTITUTE OF TECHNOLOGY AND SCIENCE",
  "POLYTECHNIC OF AGRICULTURE, MARUTERU",
  "POLYTECHNIC OF AGRICULTURAL ENGINEERING, RARS, ANAKAPALLE",
  "POLYTECHNIC OF AGRICULTURE, GARIKAPADU",
  "YALAMANCHILI JANARDHANA RAO DAITA MADHUSUDANA SASTRY COLLEGE OF ENGINEERING",
  "SRI SAI DEGREE COLLEGE CHITVEL",
  "VISWABHARATHI COLLEGE OF ALLIED AND HEALTHCARE PROFESSIONS",
  "Ramachandra College of Engineering",
  "AKSHAY COLLEGE OF NURSING, KADAPA",
  "Vikas Degree College, Macherla",
  "KALANJALI INSTITUTE OF MEDICAL SCIENCES NURSING COLLEGE ",
  "AMARAVATHI BSC COLLEGE OF NURSING, ANANTHARAJUPET",
  "SRI VENKATESWARA INSTITUTE OF MEDICAL LAB TECHNOLOGY",
  "SRI VENKATESWARA COLLEGE OF PHYSIOTHERAPY",
  "SVR COLLEGE OF NURSING",
  "SYAMALAKRISHNA POLYTECHNIC OF AGRICULTURE",
  "SRI VENKATESWARA COLLEGE OF PHYSIOTHERAPY, BRODIPET, GUNTUR",
  "SRI VENKATESWARA COLLEGE OF NURSING, BRODIPET, GUNTUR",
  "Alpha College of Education, Kanigiri",
  "SRI VENKATESWARA COLLEGE OF NURSING, KOLLIPARA, GUNTUR DISTRICT",
  "Mother Theresa College of Education, Yemmiganur",
  "Santhinikethan College of Education, Kurnool",
  "SARM Degree College",
  "Sri Venkateswara & Sri Satyadev Degree College, Tenali",
  "The Adoni Arts & Science College,",
  "Ravindra Degree College for Women,",
  "Smt. Theresa Arts & Science College",
  "Sri Ravi Degree College,",
  "ST.Peters College of Education, Pathikonda",
  "Sri Venkateswara Degree College, Koilakuntla",
  "Osmania College (men)",
  "Sai Sree Degree College",
  "SARM College of Education, Allagadda",
  "Sri Vyshnavi Degree College, Yemmiganur",
  "Sri Vijayadurga Degree College,",
  "St.Joseph's Degree College",
  "Sri Sankara's Degree College",
  "Tagore College of Education, Kodumur",
  "Vaibhav College of Higher Learning, Koilakuntla",
  "St.Joseph's Degree  College for Women, Kurnool",
  "St. John College of Education, Cumbum",
  "POLYTECHNIC OF AGRICULTURE, REDDIPALLI, ANANTAPURAM",
  "POLYTECHNIC OF ORGANIC FARMING, CHINTAPALLE",
  "Kshna Chaitanya Institute of Management, Devarajugattu(CC-2Y)",
  "N S COLLEGE OF HORTICULTURE SCIENCE",
  "Bonam Venkata Chalamayya Institute  of Technology and Science, Batlapalem",
  "Mythili College of Nursing",
  "SRI VIDYAVIKAS DEGREE COLLEGE",
  "KVR Govt. Degree College for Women",
  "NRI Institute of Medical Sciences, Sangivalasa",
  "SRINIVASA INSTITUTE OF MANAGEMENT",
  "SNR Degree College, Karivena, Atmakur",
  "Sri Gowthami College of Education, Darsi",
  "Government College for Men, Kadapa (PG)",
  "SRI PRAGNA DEGREE COLLEGE",
  "Sri Venkata Sai College of Education (B.Ed), Plot No 104-1, Addanki, Prakasam District, 523201",
  "Master Degree College, Kurnool",
  "Malineni Suseelamma Women's Engineering College, Kanumalla(Vil), Singarayakonda,(Md),PIN-523101(CC-85).",
  "Boggavarapu Guravaiah Degree College, Velpur",
  "Sri Venkateswara Degree College, Guntur",
  "SIR C.R. REDDY COLLEGE",
  "Sir CR Reddy College PG Management Studies",
  "Sir CRR College (PG Courses)",
  "RGUKT-RK VALLEY",
  "CH. S.D. ST. THERESA'S COLLEGE FOR WOMEN (A)",
  "V D A Degree College",
  "Haritha Nursing Academy",
  "PRATHIBHASOWJANYA DEGREECOLLEGE",
  "S L N DEGREE COLLEGE",
  "SRI GOWTHAMI DEGREE COLLEGE, DONAKONDA, PRAKASAM DISTRICT",
  "Aditya Degree College, Sondipudi",
  "Akshara Techno Degree College, Kasibugga",
  "H.P.N. Degree College, Gara",
  "NOVA DEGREE COLLEGE",
  "M.V.N.J.S & R.V.R Degree College",
  "M.S.S.Degree College",
  "M.S.N.Degree College",
  "Sri Venkateswara Degree College, Chillakur",
  "Mother Degree College",
  "LAMP Degree College",
  "K.S.N.R. DEGREE COLLEGE",
  "B.V. RAJU COLLEGE, VISHNUPUR, BHIMAVARAM",
  "K.G.R.L. COLLEGE",
  "K.A. & H.L. DEGREE COLLEGE",
  "J.C.Degree College",
  "Ideal College of Arts & Sciences",
  "HIS Degree College",
  "Grace  Degree College",
  "Govt.Degree College, Tuni",
  "Govt.Degree College, Seethanagaram",
  "Government Degree College, Razole",
  "Govt.Degree College, Ravulapalem",
  "Govt.Degree College, Rampachodavaram",
  "Govt.Degree College, Rajahmundry",
  "Govt.Degree College, Pithapuram",
  "Govt. Degree College, Kommavarapukota",
  "Govt.Degree College, Jaggampeta",
  "Govt. Degree College, Eluru",
  "GOVERNMENT COLLEGE OF NURSING, GUNTUR",
  "Pragati Degree College, Kakinada, E.G.Dist.",
  "Minarva Degree College",
  "EMMANUEL COLLEGE OF NURSING MAKAVARAPALEM VISAKHAPATNAM DISTRICT",
  "SRI VYSHNAVI DEGREE COLLEGE,NANDIKOTKUR",
  "MAA COMMERCE & SCIENCE DEGREE COLLEGE",
  "SRINIVASA RAMANUJAN INSTITUTE OF TECHNOLOGY",
  "MARTHA COLLEGE OF NURSING, THUMMAPUDI",
  "SADHANA COLLEGE OF EDUCATION ",
  "Silver Jubilee Degree  College (Autonomous)",
  "GOOD WILL DEGREE COLLEGE B KOTHAKOTA",
  "SMT SARASWATHAMMA COLLEGE OF NURSING",
  "SRI PADMAVATHI COLLEGE OF NURSING, ANANTAPUR",
  "R R COLLEGE OF BSC MLT ANANTHAPURAM",
  "R R COLLEGE OF PHYSIOTHERAPY BPT, BALLARY BYPASS ROAD, ANANTHAPURAM",
  "MAM POLYTECHNIC OF AGRICULTURE, KESALUPALLI, NARASARAOPETA",
  "VISHWA HITHA DEGREE COLLEGE MADANAPALLE",
  "VIKAS DEGREE COLLEGE FOR WOMEN",
  "Little Rose Degree College",
  "NATIONAL COLLEGE OF NURSING, KAKINADA",
  "Bhashyam College of Education, Guntur",
  "Dr. SARVEPALLI RADHAKRISHNA DEGREE COLLEGE",
  "Dr.R.B.R.V.R.N.Edl.Academy Mahila Degree College",
  "Dr. Maddigopalakrishna Reddy Degree College",
  "SSS Degree College",
  "Dr.K.V.R.D & S.G.J.V.S.Degree College",
  "S.V.L.N.S.Government Degree College, Bheemunipatnam",
  "Sri Modamamba Degree College",
  "Prema College Of Education",
  "Sri Sai Degree College, Vinukonda",
  "D.R.G.Govt.Degree College",
  "Don Bosco P.G. College, Guntur",
  "SIMS College of Nursing, Guntur",
  "Prabha Degree College",
  "Sri Sai Degree College, Lower Tank Bund Road, Near RTC Complex, Vzm",
  "Dr. V.S. Krishna Government Degree College",
  "Sri Murali Krishna Degree College",
  "D.R.G. DEGREE COLLEGE FOR WOMEN",
  "Dr. C.S.N. DEGREE & P.G. COLLEGE",
  "GOVERNMENT COLLEGE FOR MEN, KURNOOL",
  "Sir C.R.Reddy. College Of Pharmaceutical Sciences",
  "Chaitanya Degree & PG College for Women",
  "D.N.R. GOVT. DEGREE COLLEGE FOR WOMEN",
  "Govt.Degree College, V-Madugula",
  "D.N.R. (A) COLLEGE",
  "Chaitanya College of Education, Parawada, Vsp",
  "Govt. Degree College Autonomous",
  "GITAMS Business and IT School",
  "SANJEEVANI DEGREE COLLEGE",
  "PYDAH COLLEGE OF PHARMACY",
  "Pragati College of Education",
  "S.V.G.M. Government Degree College, Kalyandurg",
  "S.M.J.L. Degree College, Kadiri",
  "SKU College of Education",
  "Govt. College of Nursing, Visakhaptnam",
  "Govt. College of Nursing, Kurnool",
  "D.L.R.Degree College",
  "Dileef College of Nursing, Nellore",
  "Guntur Medical College (B.Sc MLT), Guntur",
  "Sri Deepthi Mahila Degree College",
  "Sri Srinivasa Degree College",
  "Sri Narayanadri College of Education",
  "Masha College of Education",
  "SDHR Degree College",
  "Sri Varadaraja PG College",
  "Narasaraopeta Engineering College",
  "DAW Degree College",
  "SURYA DEGREE COLLEGE",
  "Bheema Institute of Technology & Sciences, Adoni",
  "Mangalakara Degree College, Jagaraju Palli",
  "SIREESHA COLLEGE OF PHYSIOTHERAPY",
  "Vaishnavi College of Arts and Science",
  "Sri Venkateswara College of Pharmacy, Chittoor",
  "Swathi College of Pharmacy",
  "Raghavendra Institute of Pharmaceutical Education & Research, Anantapur",
  "SPACES Degree College",
  "Deepthi Degree College, Mamidikuduru",
  "Santhiram College of Pharmacy, Nandyal",
  "ADITHE SATYANARAYANA PG COLLEGE(MBA)",
  "KMM Institute of P.G. Studies, Ramireddi Palle, Tirupati",
  "Dr CSN INSTITUTE OF PHARMACY",
  "Sarada College of Education, Medarametla, Prakasam District",
  "Chiranjeevi Reddy Institute of Engineering and Technology, Anantapur",
  "Sri Akshara Degree College, Gate Venture, Ponnavaram, Verullapadu,Krishna District.",
  "PNCA B.Ed College, Singarayakonda, Prakasam District.",
  "Sai Rajeswari Institute of Technology",
  "Vasavi Institute of Management & Computer Sciences",
  "CHANAKYA COLLEGE OF EDUCATION",
  "GMR BED COLLEGE  YEMMIGANUR",
  "BBH Degree College Vetapalem",
  "SESHACHALA VENKATA SUBBAIAH COLLEGE (B P Ed), IPPATHANGALE",
  "Bapatla College of Arts & Science, Bapatla",
  "VISWASHANTHI COLLEGE OF NURSING",
  "BOLLINENI MEDSKILLS BSC PARAMEDICAL COLLEGE ",
  "PES COLLEGE OF PHYSIOTHERAPY ",
  "KASIREDDY BUTCHI RAJU DEGREE COLLEGE YELLAMANCHILLI",
  "NARAYANA COLLEGE OF EDUCATION",
  "Raos Degree College",
  "A.S.Degree College Tugalli",
  "SML Govt. Degree College, Yemmiganur",
  "Osmania College of Education, Kurnool",
  "Satyam College of Education, Kodumur",
  "G.M.R. College of Education, Nandyal",
  "SVB Govt. Degree College",
  "SBSYM Degree College,",
  "Nalanda College of Education, Yemmiganur",
  "Govt. Degree College, Alur",
  "Ushodaya College of Education, Yemmiganur",
  "SMT AND  SRI PATAN HUSSAIN KHAN MEMORIAL POST GRADUATE COLLEGE",
  "Mother Theresa Degree College, Palamaner Rural",
  "Vijayam Science & Arts Degree College, Chittoor",
  "S.V. Arts & Science Degree College, Gudur",
  "V.R.Law College, Nellore",
  "Sri Y.K.R & K Government  Degree College, Kovur",
  "Raos Institute of Computer Sciences Chemudugunta, Bujabuja Nellore",
  "PRR & VS Govt. College, Vidavalur",
  "RAOS DEGREE COLLEGE",
  "SUN SENORA BEACH CAMPUS",
  "Seshachala College of Pharmacy,Tirupati Puttur",
  "GOVERNMENT DEGREE COLLEGE, BARUVA",
  "Aazad College of Education, Amaravathi",
  "DEEKSHITHA B.Ed COLLEGE",
  "College of Horticulture, Parvathipuram",
  "Emmi College of Nursing, Phirangipuram, Guntur",
  "SRI LAKSHMI SRAVANI DEGREE COLLEGE, ONGOLE",
  "AMRUTHASRI COLLEGE OF NURSING",
  "RH COLLEGE OF NURSING PORANKI VIJAYAWADA",
  "SANJEEVA REDDY INSTITUTE OF MEDICAL SCIENCES BSC NURSING",
  "SRI VIVEKANANDA COLLEGE OF NURSING, PODILI",
  "NARAYANA COLLEGE OF NURSING ",
  "A.Q.J. Centre for P.G. Studies",
  "Jagarlamudi Kuppuswamy Choudary College, Guntur",
  "Purandeswari College Of Education",
  "B.V.K.Degree College",
  "PRISM Degree College",
  "A V N (Arigi Veerunaidu) Science & Arts Degree College, Vizianagaram",
  "SRI VENKATESWARA COLLEGE OF EDUCATION",
  "RAMLEELA DEGREE COLLEGE",
  "S.S.R.  DEGREE COLLEGE",
  "S.L.T.N DEGREE COLLEGE",
  "Ushodaya Degree College, Bangarupalem",
  "Govt. Degree College Sathyavedu  Rural            Co-Ed.",
  "Sri Venkateswara College of Education, Bangarupalem",
  "Vidyalaya College of Education, Tirupati",
  "Y.V. RAO SIDDHARTHA COLLEGE OF EDUCATION",
  "KMR COLLEGE OF PHYSIOTHERAPY",
  "Sri Vidya Degree College",
  "College of Science & Technology",
  "S.L.G.Degree College",
  "Govt.Degree College, Salur",
  "College of Nursing",
  "D.N.R COLLEGE OF LAW",
  "Chaitanya Bharathi Degree College, Venkatachalam",
  "All Saints P.G. College",
  "AVANTHI DEGREE COLLEGE",
  "SRI MANJUNADHA COLLEGE OF EDUCATION, PODILI, PRAKASAM DISTRICT",
  "ADITYA DEGREE COLLEGE",
  "CORAMANDAL COLLEGE OF EDUCATION, MEDIKONDURU",
  "Sapthagiri Institute of Management, Hindupur",
  "SRI VENKATESWARA DEGREE COLLEGE, ETCHERLA",
  "Sri Aditya Degree College",
  "SRI VENKATESWARA HORTICULTURAL POLYTECHNIC",
  "PRIYADARSHINI DEGREE COLLEGE",
  "K S R DEGREE COLLEGE",
  "RGUKT-SRIKAKULAM",
  "Pragati Womens Degree College",
  "Nirmala College of Pharmacy, Mangalagiri",
  "Chalapathi Institute of Pharmaceutical Sciences, Lam",
  "Hindu College of Management, Guntur",
  "Victoria College of Pharmacy, Nallapadu",
  "SRI RAGHAVENDRA DEGREE COLLEGE (095) PATTIKONDA",
  "SRI VIDYA SAI DEGREE COLLEGE        MADDIKERA",
  "NAVABHARATH B.Ed COLLEGE",
  "GOVT DEGREE COLLEGE VIZIANAGARAM",
  "SRI BALAJI DEGREE COLLEGE",
  "KJR COLLEGE OF PHARMACY",
  "JJR COLLEGE OF EDUCATION",
  "sai gaytri bed cololege",
  "Government Degree College Chinturu",
  "S V R DEGREE COLLGE , SATTENAPALLI",
  "SRI VENKATESWARA HOTEL MANAGEMENT COLLEGE , PONNUR",
  "WISDOM DEGREE COLLEGE , RENTACHINTALA",
  "Government Degree College  Gajapathinagaram",
  "HAYAGREEVA COLLEGE OF EDUCATION",
  "B. G. College of Education, Piduguralla",
  "P S K COLLEGE OF NURSING",
  "Victory Degree College, Narsaraopeta",
  "Vasavi B.Ed College, Kandulapuram Village, Cumbum ",
  "SIDDAMURTHY MALLIKHARJUNA REDDY COLLGE OF PHYSICAL EDUCATION",
  "KMR COLLEGE OF NURSING ",
  "Bellamkonda Degree College, C.S. Puram.",
  "SRI RAVI TEJA DEGREE COLLEGE",
  "KARTHIKEYA DEGREE COLLEGE KOWTHALAM",
  "Sri Vijaya Durga College of Nursing, Kadapa",
  "Dr K V SUBBA REDDY BEd COLLEGE",
  "THRINAI COLLEGE OF PHARMACY",
  "KITS College of Pharmacy for Women",
  "SRI VALLI SUBRAMANYESWARA COLLEGE OF EDUCATIION BANAGANAPALLE 349",
  "SRI SAI LEELA COLLEGE OF EDUCATION",
  "Dr. Lakireddy Hanimireddy Government Degree College, Mylavaram",
  "VISWABHARATHI COLLEGE OF MEDICAL LAB TECHNOLOGY B.SC MLT, PENCHIKALAPADU",
  "SRI SAI WOMENS DEGREE COLLEGE GUNTAKAL",
  "VINAYAKA VENKATESWARA INSTITUTE OF MEDICAL AND SCIENCES PHYSIOTHERAPY",
  "SRI SITHA RAM COLLEGE OF NURSING",
  "SRI RACHAPUDY NAGABHUSHANAM COLLEGE OF HEALTH SCIENCES",
  "Haritha College of Nursing, Kakinada",
  "Sri Vivekanada College of Education, Taluk",
  "SRI SAI SIRISHA DEGREE COLLEGE",
  "SRI LAKSHMI VIGNESWARA DEGREE COLLEGE , CHENNEKOTHAPALLI",
  "Sri Krishnadevaraya College of Agricultural Sciences",
  "N.S.Agricultural college, Markapur",
  "J.C.Diwakar Reddy Agricultural College, Tadiptri",
  "Kadiri Babu Rao College For Agriculture",
  "St Mark NTR College of Education, Narasaraopeta",
  "Vyagheswarudu Inst. of Physical Medicine & Rehabilitation, Visakhapatnam",
  "Prema Sagari College of Nursing, Visakhapatnam",
  "SRI SAI DEGREE COLLEGE, KAREMPUDI",
  "MSRR COLLEGE OF PHYSIOTHERAPY",
  "Vasavi Mahila Kalasala,",
  "S K P P Horticultural Polytechnic",
  "Sri Venkateswara College of Education, Kollipara",
  "KURLI ANNAPURANAMMA RAMIREDDY DEGREE COLLEGE ",
  "ZOHARS COLLEGE OF EDUCATION",
  "SRI SRINIVASA DEGREE COLLEGE",
  "EDGE International Business School",
  "RUSHI ARTS And SCIENCE DEGREE COLLEGE ",
  "Kakatiya Degree College, Dakkili",
  "KSK Degree College, Bhattiprolu",
  "Sri Hari Degree College(047), Balaji Nagar, Kadapa, Andhra Pradesh",
  "BEHARA COLLEGE OF EDUCATION (B.Ed)",
  "GIET SCHOOL OF PHARMACY",
  "SAMARTHA SCHOOL OF OPTOMETRY ",
  "DVR and DS MEMORIAL DEEPTHI B.Ed College",
  "Sri Kumar Degree College, Haripuram",
  "Pydah College of Education",
  "Velagapudi Ramakrishna Siddhartha Engineering College, Vasantha Nagar, Kanuru, Vijayawada-520007(CC-8W)",
  "SVU College of Pharmaceutical Sciences",
  " University College of Engineering JNTUK Narasaraopet",
  "SMS & SMCMR College of Education, Guntur",
  "College of Home Science",
  "Rajeev Gandhi Memorial College of Engineering  & Technology, Nandyal",
  "St.Johns College of Pharmaceutical Sciences, Yemmiganur",
  "St.Johns College of Engineering & Technology, Yemmiganur",
  "SRI VENKATESWARA DEGREE COLLEGE PENAMALURU VIJAYAWADA",
  "SRI VENKATESWARA COLLEGE OF EDUCATION PENAMALURU",
  "SRI KOTA RAGHAVAIAH DEGREE COLLEGE",
  "Narayanadri Insitute of Science & Technology, Rajampet",
  "ANILNEERUKONDA INSTITUTE OF DENTAL SCIENCES",
  "SIMS College of Education, Guntur",
  "RAGHAVA COLLEGE OF B.SC. MEDICAL LAB TECHNOLOGY",
  "SRI LAKSHMI VENKATESWARA M.Ed COLLEGE,KURNOOL",
  "ONGOLE COLLEGE OF NURSING",
  "DR ANJI REDDY COLLEGE OF NURSING",
  "sree chaitanya degree college kavali",
  "Nalanda Degree College Hanumapuram Yemmiganur",
  "MSR National Degree College",
  "NIMRA INSTITUTE OF MEDICAL SCIENCES (NIMS)",
  "SRI BASARA DEGREE COLLEGE",
  "Sri Viswabharathi College of Education, Giddalur, Prakasam District",
  "Chanikya College of Education (B.Ed) Sri Bramaramba Mallikarjuna Eduational Society, Giddalur, Prakasam District - 523357",
  "SRI CHAITANYA DEGREE COLLEGE",
  "Lakshmi Narsimha College of Education, Narasaraopeta",
  "Shiridi Sai College of Education, Markapur, Prakasham District",
  "VARAPRASAD REDDY INSTITUTE OF TECHNOLOGY, Siddharth Nagar, Kantepudi(V), Sattenapalli(M), PIN -522438(CC-A7)",
  "Dr. Pinnemaneni Siddhartha Inst. of Medical Sciences & Research Foundation, Chinnaoutpalli",
  "M .R.GOVERNMENT  SANSKRIT  COLLEGE ",
  "Naidu Degree College",
  "Sri Venkateswara Degree college,BANAGANAPALLI ",
  "SRI SHRIDISAIRAM DEGREE COLLEGE, KALIGIRI",
  "SRI SAI  BALAJI COLLEGE OF EDUCATION YELESWARAM",
  "POTTI SRIRAMULU CHALAVADI MALLIKARJUNA RAO COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Nalanda College of Education, Kantipudi, Sattenapalli",
  "Vyshnavi College of Education, Gurazala",
  "CILRD AND M DEGREE COLLEGE, VINUKONDA",
  "Sri Gowthami Degree College Yerragondapalem",
  "Sri Venkata Ramana Degree College, Vzm",
  "BHAVANAMS DEGREE COLLEGE",
  "ST ANNS COLLEGE OF NURSING, MALKAPURAM, VISAKHAPATNAM",
  "GAYATRI DEGREE COLLEGE ANANDAPURAM",
  "MOTER CARE COLLEGE OF NURSING, MARKAPUR, PRAKASAM DISTRICT",
  "DR PENUBALA COLLEGE OF NURSING",
  "A S R   HOMOEOPATHIC  MEDICAL COLLEGE ",
  "SRINIVASA DEGREE COLLEGE, JAMMALAMADUGU",
  "CSSR & SRRM Degree & PG College, Kamalapuram",
  "VEDAVYASA DEGREE COLLEGE, KALYANAPURAM",
  "BELLAMKONDA BED COLLEGE",
  "Tirupathi Institute of Education, Vizianagaram",
  "Ramalakshmi College of Education",
  "ZENEX VISION DEGREE COLLEGE",
  "VIJETHA COLLEGE OF EDUCATION, Singarayakonda",
  "SPY Reddy College for Women",
  "Sree Rayalaseema Christian College of Education, Kurnool",
  "VIKAS DEGREE COLLEGE, REDDYGUDEM",
  "VIKAS DEGREE COLLEGE,KHAMBAMPADU",
  "SRI KRIHNAVENI DEGREE COLLEGE OF ARTS & SCIENCE",
  "VIKAS DEGREE COLLEGE, VISSANNAPETA",
  "SRI KRISHNAVENI DEGREE COLLEGE",
  "SRI VEDANARAYANA DEGREE COLLEGE, ERIKAMBATTU, NARAYANAVANAM",
  "Sree Vidya Arts & Science Degree College Yadamarri",
  "St. Marys College of Education, Cheepurupalli, Vizianagaram",
  "ASR DEGREE COLLEGE",
  "SRI CHAITANYA DEGREE COLLEGE B KOTHAKOTA",
  "EMMANUEL COLLEGE OF PHARMACY",
  "Nadimpalli Satyanarayana Raju Institute of Technology",
  "Gokul Group of Institutions,AP PIN- 535568 (CC-8K)",
  "Swamy Vivekananda College of Education, Kalyandurg",
  "SRI RAGHAVENDRA BED COLLEGE ",
  "Sri Sai Prakash Degree College",
  "GOVERNMENT DEGREE COLLEGE, DORNALA",
  "SRI GOWTHAMI DEGREE COLLEGE, CHIMAKURTHY, ",
  "Hazarath Ameeruddin College of Education, Giddaluru",
  "Aditya B.A & K.R Degree  and  PG College",
  "Aditya Degree and PG College,  Dabagardens, Visakhapatnam",
  "ADITYA DEGREE COLLEGE, MUNAGAPAKA, ANAKAPALLI",
  "SRI VIDYA DEGREE COLLEGE",
  "Aditya Degree and PG College, lakshminarayana Nagar, Kakinada",
  "Mahathma Degree College, Uravakonda",
  "SKU College of Engineering & Technology",
  "CSIRD Institute of Management, Gooty",
  "Sapthagiri Degree College, Hindupur",
  "Sri Siva Sai Degree College, Kothacheruvu",
  "P.V.K.K. Degree College, Anantapur",
  "A.M. Linganna College of Education, Hindupur",
  "SDGS PG Department of Management, Hindupur",
  "Haindavi College of Education, Dharmavaram",
  "SKU College of Pharmacy",
  "M.S. Degree College, Gooty",
  "Sri Vivekananda Degree College, Dharmavaram",
  "S.T.S.N. Government Degree College, Kadiri",
  "Vivekananda Degree College, Kadiri",
  "Sri Sai Degree College, Gooty",
  "Swamy Vivekananda Degree College, Kalyuandurg",
  "Sri Vani Degree and PG College, Anantapur",
  "S.S.B.N. Degree College (Auonomous), Anantapur",
  "Sri Sai Krupa Degree College, Dharmavaram",
  "Narayana Institute of Management, Tadipatri",
  "Sai Master Minds Degree College, Anantapur",
  "Haindavi PG College, Dharmavaram",
  "Balayesu Degree College, Hindupur",
  "CMI Degree College, Anantapur",
  "Venkateswara College of Education, Kadiri",
  "S.P.V.M. Degree College, Gorantla",
  "J.C.N.R.M. Degree College, Tadipatri",
  "Sri Sai Degree College, Dharmavaram",
  "Vidya Ratna Dr. K.G.A. Guptha Degree College, Agaili",
  "Royal PG Centre, Rayadurg",
  "S.Y.T.R. Government Degree College, Madakasira",
  "SKU College",
  "Sri Balaji Vidya Vihar Degree College, Hindupur",
  "Sri Venkateswara Degree College, Anantapur",
  "Gowtham Degree College, Anantapuram",
  "K.H. Government Degree College, Dharmavaram",
  "P.S. Government Degree College, Penukonda",
  "S.K.N.S. Amruthavali Mahila Kalasala, Kadiri",
  "PRR Institute of Management, Gooty",
  "Shri Vivekananda Institute of Science, Guntakal",
  "S.K.P. Government Degree College, Guntakal",
  "Sir C.V. Raman Degree College, Tadipatri",
  "Nalanda Degree College, Anantapur",
  "Sri Balaji College of Education, Anantapur",
  "Sri Venkateswara Degree College, Yadiki",
  "Saraswathi Degree College, Tadipatri",
  "Government Degree College, Tadipatri",
  "K.S.N. Government Degree College for Women, Anantapur",
  "K.T.S. Government Degree College, Rayadurg",
  "Government Degree College, Uravakonda",
  "Sreenivasa Degree College, Dharmavaram",
  "A.N.K. Degree College, Gorantla",
  "Sri Sai Degree College, Anantapur",
  "N.S.P.R. Government Degree College for Women, Hindupur",
  "Sai Siddartha College of Education, Tadipatri",
  "Sri Vani Institute of Management & Science, Anantapur",
  "Sri P. Rami Reddy Memorial College of Physiotherapy, Kadapa",
  "Sri Adi Siva Sadguru College of B.Sc. MLT, Guntakal",
  "Ayushman Nursing College, Kurnool",
  "Konaseema Inst. of Medical Sciences Research Foundation, Amalapuram",
  "Sri Vikasa Institute of Medical Sciences College of B.Sc MLT, Kadapa",
  "American NRI College of Nursing, Visakhapatnam",
  "Sri Vijaya Jyothi College of Nursing, Kadapa",
  "Jeevan Jyothi B.Sc Nursing College, Tenali",
  "Govt. College of Nursing, Kadapa",
  "Global Inst. of Paramedical Sciences, Kanuru",
  "Lakshmi Venkatesh TG College of Nursing, Kurnool",
  "Dr. Helen College of Nursing, Jammalamadugu",
  "Vijaya College of Nursing, Kurnool",
  "KIMS College of Nursing & Research Foundation, Amalapuram",
  "Viswa Bharathi College of Nursing, Kurnool",
  "Lalitha College of Nursing, Guntur",
  "Evangeline Booth College of Nursing, Ponnur",
  "Satyam College of Nursing, Rajahmundry",
  "Dr. NRS Ayurvedic College, Vijayawada",
  "Adarsha College of Nursing, Anantapur",
  "Katuri Medical College, Guntur",
  "Govt. Homoeo Medical College, Kadapa",
  "Sri Vikas College of Nursing, Tirupati",
  "Sri B.Ayyavaru Reddy Memorial College of Nursing, Kadapa",
  "Nirmala College of Nursing, Anantapur",
  "AVM College of Physiotherapy, Kadapa",
  "St. Joseph Dental College, Euluru",
  "Padmavatamma College of Nursing, Tirupati",
  "VIMS College of Medical Lab Technology, Vijaywada",
  "Sri Rama Educational Trust College of Physiotherapy, Vizianagaram",
  "Katuri College of Nursing, Guntur",
  "Mandyam College of Nursing, Tirupati",
  "Suma College of Nursing, Nellore",
  "VISAKHA ACADEMY OF PARAMEDICAL SCIENCES COLLEGE OF PHYSIOTHERAPY, VISAKHAPATNAM ",
  "Vijaya Krishna College of Nursing, Visakhapatnam",
  "Florence Nightingale Modern B.Sc Nursing Degree College For Women, Kadapa",
  "Sri Venkatadri College of Nursing, Kadapa",
  "J.D. College of Nursing, Kadapa",
  "Sri Sarada College of Nursing, Kadapa",
  "Indira Priyadarshini College of Nursing, Kadapa",
  "NRI College of Pharmacy, Pothavarappadu (V), Via Nunna Agiripalli (M), PIN-521212(CC-9E)",
  "GITAM INSTITUTE OF MEDICAL SCIENCES AND RESEARCH",
  "GONNA COLLEGE OF PHYSICAL EDUCATION",
  "St. Joseph's College of Nursing, Guntur",
  "Dr. Gururaj Govt. Homoeo Medical College, Gudiwada",
  "Mother College of Nursing, Visakhapatnam",
  "Balaji College of Nursing, Tirupati",
  "Aluuri Seetharama Raju Academy of Medical Sceiences, Eluru",
  "Kasturi College of Physiotherapy, Anantapur",
  "Jaya Shekara College of Nursing, Ongole",
  "Crescent College of Nursing, Kadapa",
  "OVR COLLEGE OF NURSING, TIRUPATI",
  "OVR COLLEGE OF PHYSIOTHERAPY, TIRUPATI",
  "POLYTECHNIC OF AGRICULTURE UTUKUR KADAPA",
  "RAJA RATNA COLLEGE OF PHYSIOTHERAPY AND REHABILITATION INSTITUTE",
  "R.R. Christian College of Nursing, Kurnool",
  "GSL College of Nursing, Rajahmundry",
  "SAVE College of Nursing, Tirupati",
  "Vishnu Dental College, Bheemavaram",
  "Kugler Memorial Physiotherapy Degree College, Guntur",
  "Sister Care College of Nursing, Guntur",
  "Aditya College of Education, Yerragondapalem",
  "Swatantra Inst. of Physiotherapy & Rehabilitation, Rajahmundry",
  "Sri Venkateswara College of Nursing, Tirupati Road",
  "Santhiram Medical College, Nandyal",
  "Sai College of Nursing, Rajahmundry",
  "Dr. C. Sobhanadri Siddhartha College of Nursing, Gannavaram",
  "MIMS College of Nursing, Nellimarla",
  "Priyadarsini College of Nursing, Rajahmundry",
  "Aswini College of Nursing, Guntur",
  "Sri Sadguru Alli Sabeh Swamy College of B.Sc. MLT, Guntakal",
  "Siddhartha Medical College, Vijayawada",
  "Sri Venkata Padmavathi College of Nursing, Guntakal",
  "Narayana College of Nursing, Nellore",
  "Nagarjuna College of Nursing, Kanuru",
  "Haritha Paramedical College (B.Sc MLT), Kakinada",
  "S.I.M.S College of Medical Lab Technology, Guntur",
  "College of Life Sciences, Visakhapatnam",
  "Academy of Life Sciences (Nursing), Visakhapatnam",
  "Venkata Padmavthi College of Medical Lab Technology, Tirupati",
  "GSL Medical College, Rajahmundry",
  "NRI College of Medical Lab Technology, Chinakakani",
  "Rayalaseema College of Physical Education",
  "Annamacharya College of Education, Rajampeta",
  "Nirmala College of Education",
  "Government Medical College, Anantapur",
  "Sarada Degree College, Medarametla",
  "P.S.N. Murthy Degree College",
  "Dr. Lankapalli Bullayya College",
  "PVKK Institute of Technology, Anantapur",
  "Vignan's Institute of Engineering for Women, Kapujaggarupeta, Vadlapudi Post, Gajuwaka, PIN-530049(CC-NM)",
  "ADINARAYANA COLLEGE OF NURSING ANAKAPALLE VISAKHAPATNAM",
  "P.V.R.Trust Degree College",
  "Sanskrithi School of Business, Puttaparthi",
  "Balaji Institute of I.T & Management",
  "HOLY FAITH COLLEGE OF NURSING",
  "LAKSHMI COLLEGE OF PHYSIOTHERAPY, MANGALAM, TIRUPATI",
  "Sri  Venkateswar  College of Engineering &Technology, RVS Murukambattu, Chittoor",
  "Mother Theresa Institute of Engineering & Technology,  Palamaner",
  "Sree Vidyanikethan Degree College, A.Rangampet, Tirupati.",
  "P S R LAW COLLEGE",
  "Narayana Pharmacy College, Chinthareddypalem",
  "Rao's College of Pharmacy,",
  "Prabhat Institute of Pharmacy, Kurnool",
  "Quba College of Engineering & Technology",
  "Sumourya Institute of Management",
  "SRI SITARAMA GOVERNMENT COLLAGE OF PHYSICAL EDUCATION",
  "GOVERNMENT MEDICAL COLLEGE,MACHILIPATNAM",
  "Annamacharya Institute of Technology & Sciences, New Boyanapalli, Rajampet",
  "Audisankara College of Engineering  & Technology, Gudur",
  "SRI KINJARAPU YERRAN NAIDU COLLEGE OF AGRICULTURAL SCIENCES",
  "TANVI COLLEGE OF PHYSIOTHERAPY",
  "SRI KRISHNA BED COLLEGE",
  "Narayana Engineering College-Gudur",
  "DR G VENKATA SUBBAIAH COLLEGE OF PHYSIOTHERAPY KADAPA",
  "SREE SAI COLLEGE OF NURSING",
  "Sairam Vidyanikethan College of Education, Penukonda",
  "Sri Venkateswara Medical College, Tirupati",
  "Rami Reddy Subbarami Reddy Engineering College, Kavali",
  "Bheemi Reddy Institute of Management Science, Adoni",
  "DR G VENKATA SUBBAIAH MEMORIAL COLLEGE OF HEALTH SCIENCES KADAPA",
  "Manisha College of Nursing, Visakhapatnam",
  "IASE Govt. College of Education, Kurnool",
  "Ratnam Institute of Pharmacy, Pidathapolur",
  "Gokula Krishna College of Pharmacy, Sullurpet",
  "Annamacharya College of Pharmacy, Rajampet",
  "M.J.R. College of Engineering & Technology, Pulicherla",
  "Sharada Post-Graduate Institute of Research & Technological Sciences",
  "Dr.K.V.Subba Reddy Institute of Pharmacy, Kurnool",
  "Sri Sai Srinivasa Degree College, Kotarubilli Jn.",
  "S.D.G.S. Degree College (Aided), Hindupur",
  "Government College (A), Anantapur",
  "Sri Venkateswara Degree College, Guntakal",
  "Sri Sathya Sai Degree College, Penukonda",
  "Sreedevi Degree College, Borampalli, Kalyandurg",
  "Raghavendra Institute of Arts & Sciences, Krishnamareddy Palli",
  "Jyothirmayee Degree College for Women, Kalyandurg",
  "S.S.S. Government Degree College, Bukkapatnam",
  "SREEPAADA Degree College",
  "BRINDAVAN INSTITUTE OF TECHNOLOGY & SCIENCE",
  "SAI TIRUMALA NALABOTHU VENKATA RAO ENGINEERING COLLEGE",
  "Sri Venkatesa Perumal College of Engineering & Technology, Puttur",
  "K.S.R.M. College of Management Studies",
  "Vikas Institute of Business Management",
  "JAVERA BED COLLEGE",
  "GOLDEN VALLEY INSTITUTE OF PHYSICAL EDUCATION",
  "JOY KARTHIK DEGREE COLLEGE",
  "Wellfare Institute of Science, Technology and Management",
  "Aman Showkath B.Ed College, Isspalem, Narasaraopeta",
  "Sree Sai Dental College & Research Inst., Srikakulam",
  "S.K. College of Nursing, Kakinada",
  "S.R.V.B.S.J.B.Maharani College",
  "S.V.Degree College",
  "GAYATRI COLLEGE FOR P.G. COURSES  ",
  "VKR, VNB & AGK COLLEGE OF ENGINEERING, ELURU ROAD, GUDIVADA, PIN - 521301  (CC-NH)",
  "Sri Vasavi Engineering College, Pedatadepalli, Tadepalligudem, PIN-534101  (CC-A8)",
  "D J R College of Engineering & Technology, DJR Nagar, N.H.5, Velpur (V), Via Gudavalli, Vijayawada, PIN- 521 104(CC-7K)",
  "KITS AKSHAR INSTITUTE OF TECHNOLOGY",
  "APOLLO COLLEGE OF NURSING",
  "SRI GAYATRI DEGREE COLLEGE DWARAPUDI VIZIANAGARAM",
  "VINANDA DEGREE COLLEGE",
  "Amar College of Education",
  "Government degree college, Kovvuru",
  "CHEGONDI  POLYTECHNIC OF AGRICULTURE",
  "SRI GAYATRI WOMENS DEGREE COLLEGE",
  "VAMSADHARA DIPLOMA IN PHYSICAL EDUCATION",
  "GBR DEGREE COLLEGE PG COURSES",
  " S R Horticultural polytechnic",
  "Nekkanti Ramarao Horticultural Polytechnic",
  "Sri Rama Degree College Palakonda",
  "Narasaraopeta Institute of Technology, Kotappakonda Road, Yellamanda(P.O), Narasaraopet, PIN-522601  (CC-KH)",
  "KAKINADA COLLEGE OF EDUCATION",
  "GEMS College of Physiotherapy",
  "AJK POLYTECHNIC OF SEED TECHNOLOGY",
  "SRI VENKATESWARA COLLEGE OF PHYSIOTHERAPY",
  "SRIKARA COLLEGE OF NURSING",
  "SRI VENKATESWARA COLLEGE OF PHYSIOTHERAPY, ANANTAPURAMU",
  "M.S.R. Degree College, Bapatla",
  "G V R  & S College of Engineering & Technology, Ganjinenipuram, Near Budampadu,PIN- 522013(CC-2W)",
  "St. Ann's College of Pharmacy, Nayunipalli(V), Vetapalem (M), Chirala - 523 187 (CC-DU)",
  "Pydah College of Engineering, Yanam Road, Patavala,Tallarevu (M), Kakinada-533461  (CC-6T)",
  "HARIKA COLLEGE OF PHYSIOTHERAPY",
  "PAVITRA DEGREE COLLEGE",
  "QIS College of Engineering & Technology, Vengamukkapalem (Village), Pondur Road, Ongle(M),PIN-523 272.(CC-49)",
  "WEST GODAVARI INSTITUTE OF SCIENCE AND ENGINEERING",
  "Vignan Pharmacy College, Vadlamudi Post, Chebrolu Mandalam, PIN- 522 213(CC-AB)",
  "Kakinada Institute of Engineering & Technology, Kiet, Korangi, Yanam Road, Kakinada.PIN-533461  (CC-B2)",
  "Dhanalakshmi College of Physical Education Muppalla, Guntur District",
  "VIDHYARDHI DEGREE COLLEGE CHODAVARAM",
  "Indira Gandhi Degree College",
  "NRI Institute of Technology, Pothavarappadu (V),  Agiripalli (M), Vijayawada Rural, PIN-821212(CC-KN)",
  "Pragati Engineering College",
  "Rajiv Gandhi Institute of Management & Science, 124, Thimmapuram Village, Panchayat Area, Kakinada, 533005  (CC-8Z)",
  "Dhanekula Institute of Engineering & Technology, Ganguru, Penamalluru Mandal, PIN-521139(CC-8T)",
  "KCREDDY COLLEGE OF NURSING",
  "SRI BIJIVEMULA VEERA REDDY EDUCATIONAL GROUP",
  "APOLLO INSTITUTE OF MEDICAL SCIENCES AND RESEARCH",
  "Nova College of Engineering And Technology",
  "Sri Vivekananda Degree College",
  "PRABHU COLLEGE OF NURSING",
  "SRI LAKSHMI VENKATESWARA COLLEGE OF NURSING",
  "GOVERNMENT DEGREE COLLEGE MUMMIDIVARAM",
  "SRI LAKSHMI BPED COLLEGE",
  "SNR DEGREE COLLEGE",
  "RAVI TEJA COLLEGE OF EDUCATION, BESTAVARIPET",
  "Sri Sai Prasanthi Degree College, Kunavaram, Khammam",
  "PRAVEEN COLLEGE OF EDUCATION, BESTAVARIPET",
  "Pratibha Degree College, New colony, Puritipenta, Gajapatinagaram, Vizianagaram",
  "BEHARA COLLEGE OF NURSING",
  "Chaitanya Degree College, S.Kota, Vizianagaram.",
  "Gayatri Degree College, Payakarao peta, Vsp.",
  "S.D.R.R. Degree College, Mudigubba",
  "ACSR GOVERNMENT MEDICAL COLLEGE",
  "Raghu Engineering College, Dakamarri Village, Bheemunipatnam Mandal,PIN-531162(CC-98)",
  "MEDHA DEGREE COLLEGE",
  "PRIYADARSHNI INSTITUTE OF TECHNOLOGY & MANAGEMENT",
  "V S LAKSHMI INSTITUTE OF COMPUTER APPLICATIONS AND MANAGEMENT STUDIES FOR WOMEN",
  "Government Degree College, Yeleswaram",
  "B.T. Government Degree College, Madanapalli",
  "K.S.R & K.R.K College of Education, Tenali",
  "GSL COLLEGE OF PHYSIOTHERAPY",
  "Yalamarthy Inst. Of Sciences",
  "GOVERNMENT DEGREE COLLEGE FOR WOMEN RAYACHOTY",
  "LENORA COLLEGE OF EDUCATION",
  "SESHADRI RAO GUDLAVALLERU ENGINEERING COLLEGE",
  "Thotakura RamaKotaiah College of Education",
  "Ali College of Education",
  "SCHOOL OF PLANNING AND ARCHITECTURE",
  "Anitha Venkateswara College of Eduation, Tenali",
  "Dr. K.S.P.R College of Education, Kesanupalli, Narasaraopeta",
  "M.A.M College of Education, Kesanupalli, Narasaraopeta",
  "VSM COLLEGE OF PHYSIOTHERAPY",
  "SRI HARSHA DEGREE COLLEGE FOR WOMEN MACHERLA",
  "SRI SUBBAIAH DEGREE COLLEGE ",
  "SRI SARASWATHI B ED COLLEGE ",
  "SAI BALAJI COLLEGE OF PHYSIOTHERAPY",
  "PALIVELA PG COLLEGE",
  "Sri Krishnadevaraya College of Horticultural Sciences",
  "SAI BABA BED COLLEGE AKKAYAPALLI KADAPA",
  "DR PENUBALA COLLEGE OF PHYSIOTHERAPY",
  "Sri Chaitanya College of Education, Podili",
  "Bharathi College of Education, Nandyal",
  "Sri Gayatri Degree College",
  "NEW MODERN DEGREE COLLEGE",
  "Omega College of Education, Pamuru",
  "SIDDHARTH DEGREE COLLEGE,West Godavari",
  "SRI NALANDA COLLEGE OF EDUCATION, MARTUR, BAPATLA DISTRICT",
  "DBHPSabha Dr.M.S.College of education",
  "S.G.A. Government Degree College, Yelamanchili",
  "SRI SAI RAJESWARI NURSING COLLEGE",
  "S.V.Arts &  Science  College,    Kongareddipalli Urban",
  "Government Degree College, Chodavaram",
  "RGUKT- ONGOLE",
  "VISWABHARATHI MEDICAL COLLEGE",
  "Sri Sadhana B.Ed College, Markapur",
  "Rohini Degree College, Chilakaluripet, Guntur District",
  "CARE DENTAL COLLEGE",
  "AMRITA VISHWA VIDYAPEETHAM AMARAVATI CAMPUS",
  "VVS POST GRADUATE COLLEGE, CHRIST VIDYA NAGAR",
  "Sri Siva Teja B.Ed College, Cumbum,Prakasam, District",
  "BR AND DHANALAKSHMI POLYTECHNIC OF AGRICULTURE",
  "Vivekananda   Degree College   CHITTOOR Urban",
  "S S R DEGREE COLLEGE",
  "Govt.Degree College, Chintapalli",
  "Govt Degree College, Marripalem, Koyyur Mandal",
  "SATYA INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "Government Degree College, Rajam ",
  "AYYANNA DEGREE COLLEGE",
  "STBC College,",
  "Govt.Degree College, Mandapeta",
  "KITES DEGREE COLLEGE, ATCHUTHAPURAM",
  "SADINENI CHOWDARAIAH POLYTECHNIC OF AGRICULTURE",
  "C.S.T.S. GOVT. KALASALA",
  "RRGR Degree College",
  "SARADA COLLEGE OF PHYSIOTHERAPY",
  "VINAYAKA POLYTECHNIC OF AGRICULTURE",
  "VINAYAKA POLYTECHNIC OF AGRICULTURAL ENGINEERING",
  "GOVERNMENT DEGREE COLLEGE FOR WOMEN PULIVENDULA",
  "SATAVAHANA COLLEGE",
  "Y.V.N.R. GOVT.DEGREE COLLEGE",
  "SARADA POLYTECHNIC OF AGRICULTURE",
  "Sri Sadhana Degree College, Nandyal",
  "TRINITY COLLEGE OF EDUCATION",
  "Sri Venkateswara Government Degree College, Parvathipuram Manyam District",
  "A.S.D.Government Degree College for Women",
  "College of Food Science and Technology, Pulivendula",
  "SRI ADITYA DEGREE COLLEGE",
  "Pithapur Rajah's Government College (Autonomous)",
  "VIKAS POLYTECHNIC OF AGRICULTURAL ENGINEERING",
  "GOVT. DEGREE COLLEGE,TIRUVURU",
  "S.R.R. & C.V.R. GOVT. DEGREE COLLEGE (AUTONOMOUS)",
  "Social Welfare Residential Government Degree College for Girls, Kanchikacherla",
  "SRI MEDHA DEGREE COLLEGE NELLIMARLA",
  "VIKAS POLYTECHNIC OF AGRICULTURE",
  "ENLIGHT COLLEGE OF SCIENCE AND COMMERCE",
  "GOWTHAM DEGREE COLLEGE",
  "AGR College of Arts and Science Degree College",
  "SRI KRISHNA CHAITANYA DEGREE COLLEGE, NARSARAOPET",
  "KRK Govt. Degree College, Addanki",
  "SRI VENKATESWARA COLLEGE OF NURSING CK PALEM ROAD ONGOLE PRAKASAM DISTRICT",
  "S.K.B.R. Govt. College, Macherla",
  "SGK Govt Degree College, Vinukonda",
  "T.R.R. Govt. Degree College, Kandukuru",
  "Sri VSSC Govt. Degree College, Sullurpeta",
  "R P R COLLEGE OF PHYSIOTHERAPY ONGOLE PRAKASAM DISTRICT",
  "DEEKSHITHA COLLEGE OF PHYSIOTHERAPY",
  "SRI CHAITHANYA DEGREE COLLEGE FOR COEDUCATION",
  "SRI LAKSHMI VENKATESWARA DEGREE COLLEGE GURRAMKONDA",
  "A.N.R. P.L. ARTS & SCIENCE COLLEGE",
  " Vijatha Dgree  College Dr.Y.L.P.Degree College of Arts & Sciences",
  "THE HINDU COLLEGE - MBA",
  "K.T.R.WOMEN'S COLLEGE",
  "Govt. Degree College, Naidupeta",
  "YSR VIVEKANANDA GOVERNMENT DEGREE COLLEGE",
  "SRI SAI NARAYANA DEGREE COLLEGE",
  "SRI SAI CHARVITH DEGREE COLLEGE",
  "SREE VYSHNAVI MBA COLLEGE GOOTY",
  "RAGHAVA COLLEGE OF NURSING",
  "Govt.Degree College, Rly.Koduru",
  "VIKAS COLLEGE OF EDUCATION",
  "DR SAMUEL GEORGE INSTITUTE OF PHYSICAL EDUCATION",
  "S.M.R & S.G.R COLLEGE",
  "SRI VENKATESWARA COLLEGE OF EDUCATION MUDDANUR",
  "SRI SAI COLLEGE OF NURSING NARAYANAVANAM",
  "Govt. Degree     College for     Women,     Madanapalle  Urban",
  "A G L Degree College S KOTA",
  "SRI VIJAYANANDA DEGREE COLLEGE, Machilipatnam",
  "SRI RAMA ADITYA COLLEGE OF NURSING, RAMACHANDRAPURAM",
  "MARIS STELLA COLLEGE",
  "SAI SRI COLLEGE OF PHYSIOTHERAPY",
  "DR ANJIREDDY COLLEGE OF MEDICAL LAB TECHNOLOGY",
  "Loyola Degree College",
  "DEVI DEGREE COLLEGE FOR WOMEN VEMPALLI",
  "Vikas Degree College",
  "G.M. College of Education, Nandyal",
  "JAGANS DEGREE COLLEGE MUTHUKURU",
  "Sai Parameswara Degree College",
  "Alwar Polytechnic",
  "JAAMIA COLLEGE OF EDUCATION",
  "Sir C.R.R College of Education, Eluru",
  "DR ANJI REDDY COLLEGE OF PHARMCY",
  "St. Anns College of Nursing, Guntur",
  "S.I.M.S. College of Physiotherapy, Guntur",
  "Aluri College of Nursing, Ongole",
  "Sri Chaitanya College of Nursing, Tirupati",
  "Bhavani College Of Education",
  "Shams-Ul-Uloom College of Education, Podili",
  "ARIGIVEERU NAIDU COLLEGE OF LAW",
  "Viveka Arts & Science Degree College, Pamuru",
  "VAGHDEVI COLLEGE OF NURSING, TIRUPATHI",
  "SCHOOL OF MANAGEMENT STUDIES",
  "Gayatri Degree College, Puritipenta(V), Vzm",
  "Presidency Degree College",
  "Chandra Kala Devi Sarda Degree College",
  "CARE YOGA NATUROPATHY MEDICAL COLLEGE",
  "AIM BED COLLEGE",
  "SRI BALAJI MEDICAL COLLEGE, HOSPITAL AND RESEARCH INSTITUTE",
  "Bellamkonda Horticultural Polytechnic",
  "MALINENI LAKSHMAIAH ANIMAL HUSBANDRY POLYTECHNIC COLLEGE",
  "Sri Sai College of Education, Dornala",
  "SATYA Degree College",
  "Shaida College of Education, Plot No 259/1C, Darsi, Prakasam District",
  "B.M.Degree College, P.Dornala",
  "ANIMAL HUSBANDRY POLYTECHNIC, VENKATARAMANNAGUDEM",
  "Sri Seven Hills College of Nursing, Visakhapatnam",
  "Sri Gayatri Vidya Parishad Degree College, Kandukuru",
  "ARCHANA ANIMAL HUSBANDRY POLYTECHNIC",
  "Andhra Kesari Vidya Kendram Degree College, Ongole",
  "POLYTECHNIC OF AGRICULTURE, THOGARAM",
  "LAKIREDDY BALI REDDY COLLEGE OF ENGINEERING, MYLAVARAM",
  "BSR COLLEGE OF EDUCATION  PAMUR PRAKASAM DISTRICT",
  "S.S.N. Degree College, Ongole",
  "CHIRALA COLLEGE OF NURSING",
  "KML DEGREE COLLEGE SABBAVARAM",
  "ASHOK KUMAR REDDY BED COLLEGE",
  "NIGHTINGALE COLLEGE OF NURSING SABBAVARAM",
  "A.G.K.M.College, Sattenapalli",
  "Acharya N.G.Ranga College of Education, Chilumuru",
  "S V College of Special Education Kothuru Vijayawada",
  "Sri Harshini Degree College, Martur",
  "Sri Tatiparthi Venkata Reddy Memorial College of Education",
  "Vignan Degree College, Chemakurthi",
  "Vijayateja Degree College, Addanki",
  "Sri Harshini Degree College, Ongole",
  "SRI MALLIKARJUNA BED COLLEGE DHAVEJIGUDEM GANNAVARM MANDAL",
  "Kalikamba College of Education, Chirala",
  "Venkateswara College of Eduation, Besthavaripeta",
  "MG College of Education, Kandulapuram, Cumbum",
  "MAHAMMAD GHORI COLLEGE OF EDUCATION, KANDULAPURAM, CUMBUM, PRAKASAM DIST",
  "Gayatri College of Education, Darimadugu Village, Markapur, Prakasam District",
  "BMRM Jhansi B.Ed College, Darsi",
  "Gayatri Degree College, Buchayyapeta",
  "SARAYU B.ED COLLEGE, Darsi",
  "Residency College of Education",
  "Vagdevi College of Pharmacy & Research Centre",
  "BOGGAVARAPU GURAVAIAH COLLEGE OF PHYSICAL EDUCATION VELPUR ATCHAMPET PALNADU DISTRICT",
  "RISHI POLYTECHNIC OF AGRICULTURE ",
  "S.V.K.P. Degree College, Podili",
  "SRI VASAVI GRANDHI MANIKYALA RAO B.Ed COLLEGE",
  "Sai Pradeep College of Education, Bestavaripeta, Prakasam District",
  "Sri Sidhartha Degree College, Bestavaripeta",
  "Sri Rajarajeswari College of Education, Pulipadu Village, Mundlamur Mandal, Prakasam District",
  "Alpha College of Education, Podili",
  "Sri Sadhana Degree College, Markapur",
  "REGENCY NALANDA DEGREE COLLEGE, RAJAMPET",
  "Aditya Degree College TPG",
  "Sri Srinivasa College of Education, Plot No. 571, Darsi, Prakasam District",
  "GSL College of B.Sc MLT, Rajahmundry",
  "DDR College of Para Medical Sceinces, Visakhapatnam",
  "Chebrolu Hanumaiah Institute of Pharmaceutical Sciences",
  "SRI VENKATESWARA DEGREE COLLEGE  NANDYAL",
  "KIMS COLLEGE OF NURSING , ONGOLE",
  "KUPPAM COLLEGE OF NURSING",
  "SAI BALAJI COLLEGE OF MEDICAL LAB TECHNOLOGY",
  "Rajiv Gandhi Institute of Management & Sciences",
  "RICH College of Nursing, Nellore",
  "SIR C R REDDY COLLEGE OF NURSING",
  "Swatantra College of Nursing, Rajahmundry",
  "PES Inst. of Paramedical Sciences, College of B.Sc MLT, Kuppam",
  "Konaseema Institute of Medical Sciences (B.Sc MLT), Amalapuram",
  "Mokshitha College of Physical Education, Singarayakonda",
  "Prasuna College of Law, Kurnool",
  "Basi Reddy Memorial Degree College, Nandikotkur",
  "SREE SOWJANYA COLLEGE OF NURSING TIRUPATI",
  "DR RANJAN BABU COLLEGE OF PHYSIOTHERAPY",
  "LAKSHMI COLLEGE OF BSC MEDICAL LAB TECHNOLOGY, TIRUPATI",
  "Sri Lakshmi Venkateswara College of  Education, Kurnool",
  "Vasavi Degree College, Narasaraopeta, Guntur District",
  "SRI VENKATESWARA COLLEGE OF PHYSICAL EDUCATION",
  "KMR COLLEGE OF EDUCATION",
  "Agricultural College, Rajahmundry",
  "College of Food Science and Technology, Bapatla",
  "Maharaja Inst. of Homoeopathy Sciences, Nellimarla",
  "G.Pulla Reddy Dental College & Hospital, Kurnool",
  "H.M.K.S. & M.G.S. Memorial College of Education",
  "sri sainatha degree college",
  "VIKAS INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "PES College of Nursing, Kuppam",
  "Kurnool Medical College, Kurnool",
  "Naipunya Degree College",
  "AGRICULTURAL POLYTECHNIC OF SEED TECHNOLOGY, J M PURAM, GURAZALA",
  "Sibar Institute of Dental Sciences, Guntur",
  "Mother Vaanini College of Nursing, Tadepalligudem",
  "DR VBR COLLEGE OF PHYSIOTHERAPY, TIRUPATI",
  "Santhiram Engineering College, Nandyal",
  "Sree Vidyanikethan  Engineering College,  Tirupathi,",
  "Pratibha Degree College, Kuyyeru(v), Kajukuru(M), E.G.Dist.",
  "N.N.S Vidya Degree College, Chirala",
  "St. Ignatious Degree College, Gurazala",
  "G.M.R. MEMORIAL VIDYARDHI COLLEGE",
  "C.L.R.Degree College, Cumbum, Prakasam District",
  "PRAKASAM DEGREE COLLEGE",
  "GOVERNMENT DEGREE COLLEGE, DARSI",
  "Priyadarshini College of Engineering Technology",
  "ARCHANA COLLEGE OF BSC MEDICAL LAB TECHNOLOGY",
  "ARCHANA COLLEGE OF PHYSIOTHERAPY",
  "Sreenivasa Inst. of Technology & Management Studies, Thimmasamudram, Chittoor",
  "Madanapalle Institute of Technology & Science, Madanapalle",
  "MADHURAI MEENAKSHI DEGREE COLLEGE",
  "SIDDARTHA COLLEGE OF PHYSICAL EDUCATION -TIRUPATI",
  "SRI SHIRDI SAI DEGREE COLLEGE",
  "S.N.B.T. Degree College for Women, Repalle",
  "Kasu Brahmananda Reddy Degree College, Narasaraopeta",
  "SS&N COLLEGE OF PHYSIOTHERAPY",
  "SIMS College of Pharmacy, Guntur",
  "DR ANJIREDDY COLLEGE OF PHYSIOTHERAPY",
  "GOWTHAMI COLLEGE OF NURSING",
  "ANU BSC MLT COLLEGE",
  "MGR COLLEGE OF PHYSIOTHERAPY",
  "GOVT. DEGREE COLLEGE, PENDLIMARRI",
  "ACTS Degree College (Ambedkar College of Tech. & Sci.)",
  "Sri Harsha B.Ed College, Chetticherla Village, Bestavaripeta, Prakasam District",
  "MAHARAJAHS COLLEGE OF PHARMACY",
  "Government Degree College, Rayachoti",
  "GEMS COLLEGE OF NURSING",
  "VIMS College of Physiotheraphy, Vijayawada",
  "ADITYA DEGREE COLLEGE",
  "SRI VANI SCHOOL OF PHARMACY, CHEVUTUR (V), G.KONDUR (MANDAL), VIJAYAWADA, KRISHNA DISTRICT, ANDHRA PRADESH",
  "ABHIRAM COLLEGE OF NURSING",
  "MGR COLLEGE OF PHYSIOTHERAPY",
  "Krishna Chaitanya Institute of Science & Technology, Kakatur",
  "Geethanjali Institute of Science and Technology",
  "GOVERNMENT MEDICAL COLLEGE,RAJAMAHENDRAVARAM",
  "JNTUA MBA, Anantapur",
  "Vikrama Simhapuri University P.G.Center, Kavali",
  "Shanthiram College of Nursing, Nandyal",
  "SITARAMA Degree college",
  "AMERICAN COLLEGE OF NURSING ANANTHAPUR",
  "MOTHER THERESA INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
  "Adusumilli Gopalakrishnaiah and sugarcane grower Siddhartha Degree College of Arts and Science, Vuyyuru",
  "VIMS Mother Theresa College of Nursing, Vijayawada",
  "RANGUMUDRI COLLEGE OF SCIENCE AND ARTS",
  "D.K. Govt. College for Women, Nellore",
  "SREE VIDYANIKETHAN COLLEGE OF EDUCATION ",
  "MAM DEGREE COLLEGE",
  "Sri Sai Aditya Degree College, Ponduru",
  "K C REDDY INSTITUTE OF PHARMACEUTICAL SCIENCES    ",
  "SAGAR DEGREE COLLEGE",
  "TENALI COLLEGE OF NURSING",
  "Sri Shiridi Sai Degree College, Mummidivaram, E.G.Dist.",
  "COLLEGE OF HORTICULTURE, PULIVENDULA, YSR KADAPA DISTRICT",
  "ADITYA DEGREE COLLEGE",
  "V.R.S. & Y.R.N. College, Chirala",
  "COLLEGE OF VETERINARY SCIENCE, GARIVIDI",
  "Sri Venkateswara College of Nursing, Kakinada",
  "St. Ann's College of Nursing, Vijayawada",
  "PRAGNA DEGREE COLLEGE-093",
  "SRI SAI VENKATESWARA DEGREE COLLEGE(094)GUDUR",
  "SREE SRINIVASA COLLEGE OF NURSING ANANTAPUR",
  "Jenila Varshini College of Education, Itha Nagar, Tenali, Guntur District",
  "Sadineni Chowdaraiah College of Arts & Science, Maddirala",
  "S.A.B.R. Govt. Degree College, Repalle",
  "Rayapati Venkata Ranga Rao College of Education, Guntur",
  "St. Vincent De-Paul College",
  "Repalle Christian College of Education, Repalle",
  "Ravindra Bharathi College of Education, Chirala",
  "Pedanandipadu College of Arts and Sciences, Pedanandipadu",
  "N.R.K. & K.S.R. Gupta Degree College, Tenali",
  "Navya Chaitanya College of Education, Vinukonda",
  "M.V.R.S. Viveka Degree College, Tenali",
  "Avanthi Institute of Engineering and Technology, Chirukupally(V), Bhogapuram(M), Near Tagarapuvalasa Bridge, PIN- 531 162 (CC-Q7)",
  "DR C R REDDY COLLEGE OF ARTS AND SCIENCE",
  "KGRL College (PG Courses)",
  "Indira Priyadarsni Law College, Ongole",
  "G.V.R.S Institute for Professional Studies, Guntur",
  "Erigineni Tirupati Naidu & Lakshmamma Degree College, Pamur",
  "T.R.R. & S. Degree College, Piduguralla",
  "V.V. & M. College, Ongole",
  "Pragathi Degree College Tanuku",
  "SRI KALYANI COLLEGE OF EDUCATION, CHINNARANGAPURAM, PULIVENDULA",
  "DRNSCVS College, Chilakaluripeta",
  "Career Degree College, Guntur",
  "Andhra Muslim College, Guntur",
  "AMG Degree College for Women, Chilakaluripeta",
  "A.L.College of Education, Guntur",
  "SRI SHIRIDI SAI NARAYANA DEGREE COLLEGE",
  "Aditya Degree College",
  "ASIAN COLLEGE OF HOTEL MANAGEMENT",
  "CHAITANYA DEGREE COLLEGE-PAMARRU",
  "ALLIANCE COLLEGE OF HOTEL MANAGEMENT",
  "RAJU COLLEGE OF EDUCATION, RAYACHOTY",
  "M.V.R Degree College, Karlapalem",
  "K.V.R., K.VR. & M.K.R College",
  " PRAGATHI COLLEGE OF PHYSICAL EDUCATION",
  "S M Y College of Education, Darsi",
  "ML College of Pharmacy, Singarayakonda",
  "GOVT. DEGREE COLLEGE BUTTAIGUDEM",
  "Fatima College of Education, Nadikudi",
  "DCRM Degree College, Inkollu",
  "University College of Physical Education and Sports Sciences",
  "Sri Sarada Niketanam Oriental College",
  "Nagarjuna College of Education",
  "Vinukonda B.Ed. College",
  "Viswam Degree College, Naidupet",
  "Sri Shiridi Sai Srinivasa Degree College, Chodavaram, Visakhapatnam",
  "Government Degree College, Yerragondapalem",
  "Sri Vivekananda Degree College, Podili",
  "Radha Degree College, Vinukonda",
  "Chakradhar Degree College, Macherla",
  "Government Degree College, Cumbum",
  "Samata Degree College.",
  "BRUNDAVAN DEGREE COLLEGE, DORNIPADU",
  "D Narayana Reddy Degree College",
  "CHAITANYA COLLEGE OF EDUCATION",
  "SPR DEGREE COLLEGE",
  "SRI LENDI DEGREE COLLEGE",
  "Raghava Degree College - Ongole",
  "D.A.R. COLLEGE",
  "SRI SAI MAHITHA DEGREE COLLEGE",
  "SRI KAKATIYA DEGREE KALASALA",
  "SRI SRINIVASA DEGREE COLLEGE",
  "SUGUNA DEGREE COLLEGE",
  "SARADA COLLEGE",
  "VIKAS DEGREE COLLEGE, MANDAVALLI",
  "SRI VIVEKANANDA DEGREE COLLEGE",
  "SIDDHARTHA INSTT.OF HOTEL MANAGEMENT & C",
  "MINAKSHI COLLEGE OF EDUCATION",
  "NARAYANA MEMORIAL DEGREE COLLEGE",
  "LITTLE FLOWER DEGREE COLLEGE",
  "S.G.L. (SARDAR GOWTHU LATCHANNA) DEGREE",
  "VIGNAN DEGREE COLLEGE, VISANNAPETA",
  "Sri Vivekananda College of Education, N.R.T Road, Vinukonda, Guntur District",
  "LMN College of Education, Markapur",
  "S.V. College of Music and Dance, Tirupati",
  "SRI SIDDHARTHA B.ED. COLLEGE",
  "S.L.R. PRATHIBA MODEL DEGREE COLLEGE",
  "VAGDEVI DEGREE COLLEGE FOR WOMEN'S",
  "A.K.R.G. DEGREE COLLEGE",
  "Aditya Degree College, Thadithota, Rajahmundry, EG Dist",
  "S.V.L. KRANTHI DEGREE COLLEGE",
  "GOVT. DEGREE COLLEGE,AVANGADDA",
  "TRIVENI MAHILA DEGREE COLLEGE",
  "SRI VENKATESWARA DEGREE COLLEGE",
  "M.V.R. DEGREE COLLEGE",
  "CHAITANYA DEGREE & PG COLLEGE",
  "PRABHAS COLLEGE OF EDUATION",
  "ANDHRA LOYOLA COLLEGE",
  "ANNAPURNA MEMORIAL MODERN DEGREE COLLEGE",
  "SRI SIDDHARTHA PHARMACY COLLEGE",
  "SRI VIJAYANANDA DEGREE COLLEGE",
  "PRABHAS DEGREE COLLEGE",
  "SUNFLOWER DEGREE COLLEGE",
  "A.N.R. COLLEGE",
  "NALANDA DEGREE COLLEGE",
  "K.V.R. COLLEGE",
  "Aditya Degree  and PG College for Women, Santinagar, Kakinada",
  "Aditya Degree and PG College for Women, Rajahmundry",
  "Veda  Degree College, Cinema Road, Tatipaka",
  "Adarsa Degree College",
  "ABHYUDAYA DEGREE COLLEGE",
  "SATYA COLLEGE OF EDUCATION",
  "SAV & NVJR DEGREE COLLEGE",
  "VIDYANJALI DEGREE COLLEGE",
  "S.P.K.R COLLEGE OF EDUCATION",
  "T.S.R  & E.R.R.GOVT. DEGREE COLLEGE",
  "KVSR SIDDHARTHA COLLEGE OF PHARMACEUTICAL SCIENCES",
  "MRR COLLEGE OF MCA",
  "WESTIN COLLEGE OF HOTEL MANAGEMENT",
  "Sri Venkateswara College of Law. Tiruchanoor, Tirupati",
  "SRINIVASA DEGREE COLLEGE",
  "Government College of Nursing, Anantapur",
  "Global College of Nursing, Kanuru",
  "P.N.C. & K.R College of Nursing, Guntur",
  "VENKATARAMA DEGREE COLLEGE",
  "P.R.P.M. DEGREE COLLEGE",
  "VIDYANJALI DEGREE & PG COLLEGE",
  "SAPTAGIRI DEGREE COLLEGE",
  "D.S.R. HINDU COLLEGE OF LAW",
  "B.J.T.DEGREE COLLEGE",
  "MARUTI DEGREE COLLEGE",
  "PRATHIBA COLLEGE OF EDUCATION",
  "GANDHIJI MAHILA KALASALA",
  "S.G.S. (SMT. GENTELA SAKUNTALAMMA) COLLE",
  "IMMACULATE DEGREE COLLEGE",
  "AVUTHU AMMI REDDY AND BONTHU MALLA REDDY",
  "S.P.M.H. COLLEGE OF EDUCATION",
  "V.S.R. GOVT. DEGREE & PG COLLEGE",
  "VIDYALAYA DEGREE COLLEGE",
  "S.P.MAHILA HINDU KALASALA",
  "MADONA DEGREE COLLEGE FOR DEAF",
  "SRI SARADA DEGREE COLLEGE",
  "Acharya College of Education, Kagithalagudem Village, Cumbum, Prakasam Dsitrict",
  "ANNAPURNA DEGREE COLLEGE",
  "S.R.S.V.R.G.N.COLLEGE OF ARTS & SCIENCE",
  "Parvathaneni Brahmayya Siddhartha College Of Arts & Science",
  "VIJAYA SAI DEGREE COLLEGE(085),PATTIKONDA.",
  "St.GREGORY B.Ed COLLEGE, Vetapalem",
  "DIVYA DEGREE COLLEGE",
  "VRR DEGREE COLLEGE",
  "VIGNAN DEGREE COLLEGE,KAIKALURU",
  "NOBLE COLLEGE",
  "GOVT. DEGREE COLLEGE, BANTUMILLI",
  "D.V.R. DEGREE COLLEGE",
  "S.R.S.V. COLLEGE OF EDUCATION",
  "BETHANY COLLEGE OF EDUCATION",
  "Velankini College of Education, Kandrika, Venkatachalam (M)Nellore Dist",
  "Simhadri Educational Society Group of Institutions, Narapadu (V), Sabbavaram Mandal, Sabbavaram To Ankapalli Road, PIN- 531002 (CC-6J)",
  "Chaitanya Engineering College, Chaitanya Valley, Kommadi, Madhurawada,Pin-530041(CC-L6)",
  "Madhu College of Nursing, Nandyal",
  "Vijaya College of Physical Education, Nunna",
  "GOKUL College of pharmacy, Piridi, Bobbili,  Pin- 535558 (CC-HH)",
  "BABA Institute of Technology & Science, P.M. Palem, Bakkannapalem Village,  Madhurawada, PIN-530048 (CC-NR)",
  "Sri Padmavathi Womens   Degree College Near Gundu bavi, Madanapalle   Road, Gangavaram",
  "DADI Institute of Engineering & Technology, Nh-5, Gavarapalem, Anakapalle-531002, (CC-U4)",
  "S.V.Arts College      Tirupati Urban",
  "RKM Degree College Penumuru(M), Chittoor Dist.   Rural Co-Ed.",
  "Indira Rajiv     Memorial Degree   College, Kuppam Urban",
  "Sri Vinayaka Degree College, Sadum, Chittoor (Rural)",
  "S.V.U. College of Commerce, Management & Information Sciences, Tirupati",
  "Sri Venkateswara Degree College Alur Kurnool(D).",
  "Monteesori College of Physiotheraphy, Vijayawada",
  "Sri Padmavathi Studies of Computer Sciences & Technology, Tiruchanoor",
  "Govt. Degree College for women  Sri kalahasthi Urban",
  "Blossom Degree College,  Mulakalacheruvu, Chittoor Dist  Rural",
  "Sreenivasa Degree College, Kalikiri Chittoor District",
  "Balaji College of Nursing",
  "Dr.Allu Ramalingaiah Government Homoeo Medical College, Rajahmundry",
  "S.V.S.R.Degree College",
  "BSR Degree College, Thatithopu, Tirupati Urban",
  "Vikram    Degree College      Srikalahasti,   Urban",
  "K.K.C. College of B.Sc Nursing, Puttur",
  "Madala Sakuntala Bhaskar College of Nursing, Guntur",
  "Anantha College of Law, Kesavayanagunta, Tirupati",
  "Vikas Degree College, Kuppam, Chittoor",
  "Sri Vidya  Degree College Nagari By-pass Road, Puttur",
  "Govt. Degree       College,  Karvetinagaram Rural",
  "Christian College of Education, Madanapalli",
  "S.G.S. Arts College, Tiruchanoor Road, Tirupati Urban",
  "Gayatri Degree College, Tirupati   Urban",
  "GREYFRIARS DEGREE COLLEGE",
  "SRI SRINIVASA DEGREE COLLEGE",
  "Vinex Degree College, Dwarakanagar, vskp",
  "Vikas College of Physical Education, Nunna",
  "MOTHER COLLEGE OF EDUCATION",
  "University College of Arts and Commerce",
  "SRI BHANODAYA COLLEGE OF EDUCATION",
  "Sai Ram Degree College, Mudinepalli, Krishna District",
  "VRN College of Computer Science and Mgmt, Peruru, Tirupati.",
  "GDMM COLLEGE OF NURSING",
  "Smt. NPS. Govt  Degree College   for  Women,      CHITTOOR Urban",
  "Sri Vidya Institute of Management, Puttur",
  "Agarala Eswsar Reddy MBA College, Ramapuram, Tirupati",
  "Rayalaseema Institute of Information & Management Sciences, Tirupati",
  "Margadarsi    Degree  College,Piler",
  "Dr. A.E.R. Degree College, Tirupati",
  "ATNs DEGREE COLLEGE, TIRUPATI Urban",
  "K.K.C. College of Education, Puttur",
  "S.V.U. College of Sciences, Tirupati",
  "CVRRM Degree College, V.Kota Rural",
  "Mother Theresa Institute of Computer Applns, Palamaneru",
  "S.V. Degree College D.No> 1-47, Mahaboob Bagar Kalakada (M) Chittoor Rural",
  "Government college of nursing",
  "GEETAM DEGREE COLLEGE",
  "GOVERNMENT COLLEGE FOR WOMEN",
  "GHANTA NARAYANA RAO PRIVATE UN  AIDED DEGREE COLLEGE",
  "SRI SIVANI DEGREE COLLEGE",
  "GOVERNMENT DEGREE COLLEGE Narasanna Peta",
  "SARADA DEGREE COLLEGE",
  "Dr.  C.L. NAIDU DEGREE COLLEGE",
  "SRI PRATIBA DEGREE COLLEGE",
  "SAMASKARA BHARATHI DEGREE COLLEGE",
  "SANTHINIKETAN DEGREE COLLEGE",
  "SSR COLLAGE OF EDUCATTION",
  "S.V.J.  DEGREE COLLEGE",
  "THAMMI NAIDU VIDYA DEGREE COLLEGE",
  "PADMAVATHI DEGREE COLLEGE",
  "SHIRIDI SAI DEGREE COLLEGE",
  "SRI SAKETI SATYANARAYANA DEGREE COLLEGE",
  "SAI VINEETH DEGREE COLLEGE",
  "M.L.R. NAIDU DEGREE COLLEGE",
  "GOVERNMENT DEGREE COLLEGE, ICHAPURAM",
  "SUN DEGREE COLLEGE",
  "GNANAJYOTHI DEGREE COLLEGE",
  "KRISHNA SAI DEGREE COLLEGE",
  "SRI RAMA DEGREE COLLEGE,VANDRANGI",
  "SRI VISWAJYOTHI DEGREE COLLEGE",
  "D.R.N. DEGREE COLLEGE",
  "BS & JR COLLEGE OF EDUCATION",
  "GOVERNMENT DEGREE COLLEGE Tekkali",
  "Sri Surya  Degree  College,      NAGARI Rural",
  "Gate Degree  College, Tirupati  Urban",
  "Dr. SRJ Degree College, Atmakur",
  "Alexa College of Education,Venkatachalam",
  "St. Marys Degree College, Bucchireddypalem",
  "S.V. Degree College",
  "Lendy Degree College, Nellore",
  "V.R. Institute of PG Studies, Nellore",
  "Dr. C.V Ramana Degree College, Naidupeta",
  "DRW College, Gudur",
  "Shri Shiridi Sai Ram Degree College, Atmalur",
  "S.V.Arts & Science College, Gudur",
  "SPBVD Degree College, Podalakur",
  "SKR Govt. Degree College, Gudur",
  "S.Chaavan Institute of Computer Applications, Muthukur",
  "GVK Degree College, Kothur",
  "Aaditya Degree College, Nellore",
  "GOVERNMENT DEGREE COLLEGE, AMADALAVALASA",
  "Pragathi Degree College, Ravi Nagar Kota",
  "V.R Institute of Post Graduate Studies,Nellore.",
  "Govt. Degree College, Udayagiri",
  "Vivekananda Degree College, Nellore",
  "Govt. Degree College, Rapur",
  "Sri Tanguturi Prakasam Govt. Institute of Advanced Studies in Education, Santhapeta, Nellore",
  "Visovadaya Govt. Degree College, Venkatagiri",
  "Jagans Degree College, Nellore",
  "St Mari College of Education, Buchireddypalem",
  "Dr. C.R.R. College of Education Sydapuram (M), Nellore (Dt.)",
  "N.B.K.R Science & Arts College, Vidyanagar",
  "Sitarama Degree College, Sitaramapuram",
  "Prathibha Degree College, Sullurpet",
  "Ramakrishna Arts & Science Degree College, Allur",
  "Sree Sai Degree College, Kavali",
  "Sri Venkateswara Degree College, Nellore",
  "Swarnandhra Bharathi Degree College, Gudur",
  "D.R.W. College, Gudur",
  "Jagan Degree & PG College, Nellore",
  "Siddardha College of Education, Musunoor, Kavali",
  "ESS Degree College, Venkatagiri",
  "Vignan Degree CollegePodalakur",
  "Sri Sarvodaya College, Nellore",
  "Vidyanjali College of Arts & Sciences Sullurupet",
  "Raos Degree College, Nellore",
  "Sri Siva Sai Degree College, Kaluvoyi",
  "Sana College of Education, S.No. 261/B, Chemudugunta, Bujabuja, Nellore",
  "MSR Degree College, Vinjamur",
  "Universal Christian College of Education, Indukurupet, GNT RoadNear RTC Bus Stand, Nellore- 524 003",
  "Doddapaneni Prameela Memorial College of Education, A.S.Peta, Atmakur,",
  "Krishna Chaitanya Degree and PG College, Buchireddypalem",
  "Audisankara College of EducationNH-5, Bypass Road, Aravinda Nagar,Gudur",
  "Visakha Institute for Professional Studies",
  "Sri Vasavi Institute of Pharmaceutical Sciences",
  "Catherine College of Education",
  "Aditya Degree College, Gajuwaka",
  "Geethanjali Degree College",
  "V.V.S. Degree College, U.Kothapalli",
  "Ln.G.V.Rao Modern Degree College",
  "Siriki College of Education for Women",
  "Sri Sai Degree College, D.No: 5-54, Near SBI, RLAM 535126, Vzm",
  "S.V.Kishore Chandradev Degree College",
  "Gayatri Degree College, Vzm",
  "Jesus & Mary College of Education",
  "ALWAR DAS DEGREE COLLEGE",
  "TSR & TBK Degree College",
  "Andhra Womens Sanskrit College",
  "Sri Satya Sai Degree College",
  "Sri Manikanta Kannababu & Konathala Degree College",
  "Sri Balaji Vidya Parishad Degree College",
  "Allam Gurumurthy Lakshmibai Memorial College",
  "A.M.A.L. Degree College, Anakapalle",
  "Govt.Degree College, Cheepurupalli",
  "N.V.P. Law College",
  "Sruthi College of B.Sc Nursing, Guntur",
  "Kavuri Subba Rao College of Nursing, Guntur",
  "St. Lukes College of Nursing, Visakhapatnam",
  "Sri Shiridi Sai Law College",
  "Pydah College for Women",
  "JES College of Education",
  "Sri Shiridi Sai Srinivasa Degree College, Sabbavaram",
  "Govt.Degree College, Sabbavaram",
  "Geetanjali Nursing College, Kurnool",
  "Sri Sai College of Nursing, Anantapur",
  "Nava Jeevan College of Medical Lab Technology, Kadapa",
  "Sri Venkata Padmavathi College of Nursing, Anantapur",
  "Konaseema Institute of Medical Sciences (BPT), Amalapuram",
  "Krishnaveni College of Nursing, Guntur",
  "Guntur Medical College, Guntur",
  "Smt. Vijaya Luke College of Nursing, Visakhapatnam",
  "A.M.G. College of Education for Women",
  "SRKR Engineering College",
  "Sree Chaitanya Degree College",
  "Dr.N.T.R. Degree College, Balighattam, Narsipatnam",
  "Rangumudri Degree College",
  "Y.R.College of Arts & Science & Tech",
  "MALINENI LAAKSHMAIAH WOMEN'S ENGINEERING COLLEGE, PULLADIGUNTA (V), VATTICHERUKURU (M),PIN-522017  (CC-KE)",
  "DHARVI COLLEGE OF NURSING",
  "SREE MARUTHI DEGREE COLLEGE",
  "G.B.R. College of Education",
  "V.S.M. College of Engineering",
  "Smt. SKR Degree & PG College for (W)",
  "Mahathi Degree College",
  "Pydah College",
  "Noble Institute of Science & Tech",
  "St. Paul College of Education",
  "Sri Venkateswara College Of Pharmacy",
  "Govt.Degree College, Gummalakshmipuram",
  "Dr. Hima Sekhar Degree College",
  "Sri Chaitanya College Of Education",
  "N.B.M. Law College",
  "Sri Sai Siddhartha Degree College",
  "Prof.G.Sundara Reddy Degree College",
  "Madhu College of Education",
  "Sri Vivekananda Degree College",
  "Satya Rama Degree College",
  "Visakha Law College",
  "Sanketika Vidya Parishad Engineering College",
  "Ushodaya College Of Education",
  "Emmanuel College of Education",
  "Kalyani MCA College, Eethamukkala",
  "Sri TLN Degree College",
  "Viveka Vardhani Bhaskar Degree College",
  "Sri Sai College Of Pharmacy",
  "P.M.N.Degree College",
  "Gayatri Degree College, Near RTC Complex, Seethanagaram",
  "Yalamarthy College Of Education",
  "Sri Uma Bharathi Degree College",
  "RISHI Degree College",
  "St. Anns College Of Pharmacy",
  "College of Arts & Commerce",
  "KPN College of Education",
  "Samyuktha Degree College",
  "Adarsh Degree College Chinamushidivada",
  "Meesala Lakshmayya Arts and Science Degree College",
  "ASRAM College of Nursing, Eluru",
  "Rayalaseema College of Nursing, Kurnool",
  "Lenora Institute of Dental Sciences, Rajahmundry",
  "Andhra University College of Engineering(A)",
  "S.A.R. College Of Education",
  "ABM Degree College",
  "Vidwan Degree College",
  "Sri Gowri Degree College",
  "GEMS Medical College, Srikakulam",
  "Emmenual Degree College, Tamavaram",
  "VVRL Kanaka Mahalakshmi Degree College",
  "Anil Neerukonda Institute Of Technology & Sciences",
  "Gayatri Degree College,  Kotavuratla,Vsp",
  "BSNM College of Education",
  "Srinivasa Rao College Of Pharmacy",
  "Government Degree College, Narsipatnam",
  "VRS & YRN College of Engineering & Technology, Vodarevu Road, Chirala(M)-523157(CC-L1)",
  "KonchadaRajeswaraRao Degree College, Sompeta",
  "S.V.B.S Degree College, Komarole",
  "Tiyyagura Sitarami Reddy Degree College, Piduguralla",
  "Sri Jeevana Jyothi Degree College, Giddalur",
  "Sri Gowthami Degree College, Darsi",
  "Saraswathi College of Arts & Science, Dachepalli",
  "Vyshnavi Degree College, Thripurantakam",
  "SIMS College of Life Sciences, Guntur",
  "PPRS Kaumudi Degree College, Balaga",
  "Pranavi College of Arts and Science, Ijjavaram",
  "Sri Vidya vahini Degree College, Kasibugga",
  "Swarna Bharathi Degree College, Ichapuram",
  "T.S.R. Degree College,Amadalavalasa",
  "S.V. College of Higher Education ",
  "Sri Mittapalli Institute of Technology for Women, Tummalapalem, NH-5, PIN-522233 (CC-MK)",
  "Ushodaya Degree College Chodavaram",
  "SANA DEGREE COLLEGE, KOILAKUNTLA",
  "KONDAVEETI DEGREE COLLEGE-404 GOPALAPURAM",
  "Benaiah Christian College of Education",
  "Mamata College of Nursing, Tenali",
  "Master Minds Degree College, Guntur",
  "Hanna College Of Education",
  "Indira Institute of Technology & Sciences,  Darimadugu(V), Markapur Mandal, PIN- 523316(CC-7Z)",
  "Smt.NARAYANAMMA COLLEGE OF PHYSICAL EDUCATION",
  "VISWATEJA DEGREE COLLEGE",
  "SRI VASAVI DEGREE and PG COLLEGE",
  "Srinivasa Institute of Engineering & Technology",
  "BVC College of Engineering, Palacharla, Rajanagaram Mandal, PIN-533104(CC-6M)",
  "NTR College of Veterinary Science, Gannavaram",
  "College of Dairy Technology, Tirupati",
  "Chaitanya Institute of Science & Technology, Madhavapatnam, Samaklkot (Mandal), near Kakinada, PIN-533005(CC-S0)",
  "PES INSTITUTE OF MEDICAL SCIENCES AND RESEARCH",
  "SREE LAKSHMI SREENIVASA COLLEGE OF EDUCATION ,KURNOOL",
  "Aditya College of Nursing, Kakinada",
  "Rangaraya Medical College, Kakinada",
  "Care Waltair College of Nursing, Visakhapatnam",
  "Global Institute of Business Management,  Markapur,  PIN-523316(CC-9B)",
  "PRASAD V POTLURI SIDDHARTHA INSTITUTE OF TECHNOLOGY, Devabhaktuni Ramalingeswara Rao Road, Behind VR Siddhartha Engg. College, Kanuru, Vijayawada, PIN-520007(CC-50)",
  "Ideal Institute of Technology",
  "Sri Venkateswara Degree College, Nakirekallu",
  "Lingayas Institute of Management & Technology,  Madalavarigudem(V), Via Nunna,  Gannavaram Mandal, Vijayawada , PIN-521212(CC-NA)",
  "Sri Vignan Nursing Academy College, Kadiri",
  "Dr. Samuel George Institute of Engineering & Technology, George Town, Darimadugum,(Post & Village) , Markapur(M), PIN-523 316.(CC-35)",
  "Padma Chandra College of Nursing, Kurnool",
  "Grace College of Nursing, Machilipatnam",
  "Kugler College of Nursing, Guntur",
  "Venkata Padmavathi College of Physiotherapy, Tirupati",
  "Saikrupa College of Nursing, Kadapa",
  "Rajiv Inst. of Medical Sciences, Srikakulam",
  "Horsley Hills College of Nursing, Madanapalle",
  "J.BEERA COLLEGE OF EDUCATION",
  "Konijeti Rosaiah Siva Lakshmi College, Bapatla",
  "St. Joseph's College of Nursing, Dargametta",
  "Maharaja Inst. of Medical Sciences, Vizianagaram",
  "Bonam Venkata Chalamayya Engineering College",
  "Velaga Nageswara Rao College of Engineering, G.B.C.Road, Ponnur,  PIN- 522124 (CC-NK)",
  "AKRG College of Pharmacy, Nallagerla PIN-534112(CC-8N)",
  "Nalanda Intitute of P.G Studies, Siddharth Nagar,  Kantipudi (V), Sattenapalli,PIN- 522438(CC-2R)",
  "Vijaya Institute of Technology for Women,Enikepadu, Vijayawada, PIN-521108  (CC-NP)",
  "SRI SAMHITHA DEGREE COLLEGE",
  "Vijaya Institute of Pharmaceutical Sciences for Women, Enkepadu, Vijayawada-521108(CC-7N)",
  "Nova College of Pharmacetical Education & Research",
  "Vishnu Institute of Technology, Vishnupur, Bhimavaram, PIN-534202(CC-PA)",
  "Sri Sai Degree College, Repalle",
  "HINDU COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Universal College of Engineering & Technology, Dokiparru(V), Medikondur(M),PIN-522438  (CC-NF)",
  "Jogaiah Institute of Technology & Pharmacy Sciences, (CC-GC)",
  "Buchepalli Venkayamma Subbareddy Engineering College, Ongole-Kurnool Road, Chimakurthy-523 226,(CC-HR)",
  "Vishwa Bharathi College of Pharmaceutical Sciences, NRT Road, Perecherla, PIN-522009.(CC-43)",
  "Rajamahendri Institute of Engineering & Technology, Bhoopalapatnam, Near Pidimgoyyi,  Rajahmundry-533103(CC-MD))",
  "A.M. Reddy Memorial College of Engineering and Technology, Vinukonda Road, Narasaraopet(Mandal), PIN-522601(CC-HM)",
  "KKR&KSR Institute of Technology & Sciences, VINJANAMPADU Village (CC-JR)",
  "A B R College of Engineering and Technology,  PIN-523230 (CC-HJ)",
  "MEDARAMETLA ANJAMMA MASTAN RAO PG COLLEGE",
  "SRI SRINIVASA DEGREE COLLEGE, VISSANNAPETA",
  "DEEKSHITHA COLLEGE OF EDUCATION",
  "S.K.B.R. P.G. COLLEGE",
  "SRI ADI SIVA SADGURU COLLEGE OF PHYSIOTHERAPY, THIMMAPURAM, GUNTAKAL TOWN, ANANTAPURAM DISTRICT",
  "M.R.R.College of Pharmacy, Near DSP Office, Madhira Road, Nandigamma,PIN-522185(CC-PJ)",
  "H P N Degree College Srikakulam",
  "Sadineni Chowdaraiah Horticultural Polytechnic",
  "KADIRI BABURAO COLLEGE OF HORTICULTURE",
  "Nova College of Education",
  "K.B.N. COLLEGE",
  "The Lakshmi Venkatesh T.G Physiotheraphy College, Kurnool",
  "Loyola Institute of Technology and Management, Loyola Nagar, Dhulipalla (Village), Sattenapalli (Mandal),  PIN-522412(CC-A4)",
  "Eswar College of Engineering, Kesanupalli(V),  Narasaraopet , PIN-522 601(CC-JE)",
  "V S M COLLEGE PG COURSES",
  "Adarsh College of Engineering, NH-214, Chebrolu,PIN-533449  (CC-HN)",
  "Sri Sunflower College of Engineering & Technology, Lankapalli (Challapalli), Ghantasala Mandal, -521131(CC-R8)",
  "Newtons Institute of Science & Technology, Alugurajupalli Village, Koppunur Post, Macherla Mandal,PIN-522426(CC-9H)",
  "SAPTAGIRI COLLEGE OF NURSING, TIRUPATI",
  "GOVERNMENT DEGREE COLLEGE FOR WOMEN TAGARAPUVALASA",
  "Govt. Degree College (W), Bapatla, Guntur (Dist.)",
  "BALAJEE COLLEGE OF NURSING",
  "SRI SADGURU ALLI SAHEB SWAMY COLLEGE OF PHYSIOTHERAPY, ARAVIND NAGAR, ANANTHAPURAM TOWN",
  "Shankar Reddy Institute of Pharmaceutical Sciences, Bestavaripeta (M),  PIN-523346(CC-9K)",
  "DHARMA COLLEGE OF NURSING",
  "R C REDDY DEGREE COLLEGE",
  "Kakinada Institute of Engineering & Technology for Women, Yanam Road, Tallarevu(M), Korangi, Kakinada. PIN-533461.  (CC-JN))",
  "Gurivindapalli Devanandam Mary Memorial College of Engineering & Technology for Women, Ramannapet Road, Nandigama,.PIN-521185(CC-JM",
  "GOVERNMENT DEGREE COLLEGE",
  "Tirumala Engineering College, Jonnalagadda(Post), Narasaraopet, PIN-522601(CC-NE)",
  "ANANTHA DEGREE COLLEGE",
  "VIJAYA LAKSHMI COLLEGE OF EDUCATION",
  "RISE Krishna Sai Prakasam Group of Institutions (Integrated Campus), Off NH-5, Valluru, Ongole-523272(CC-8A)",
  "ADVAITHA COLLEGE OF NURSING, ANANTAPURAMU",
  "St. Joseph BEd College, Kurnool",
  "Rangumudri Appalaswamy Naidu Physical Education College",
  "Donbosco Degree College",
  "SRI NARAHARI SETTI VENKATARAO DEGREE COLLEGE",
  "SARADA COLLEGE OF NURSING, MEDARAMETLA, PRAKASAM DISTRICT",
  "Rangumudri M.Ed. College",
  "SUN INSTITUTE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "VEDHANSHI COLLEGE OF BSC MLT",
  "NAVODAYA COLLEGE OF BSC MLT",
  "MOTHER TERESA COLLEGE OF NURSING",
  "VIDYANIKETAN DEGREE COLLEGE RAMAKUPPAM",
  "Punyagiri Degree College",
  "Bhaskara Institute Of Pharmacy",
  "SANGHAMITRA COLLEGE OF NURSING",
  "NRI INSTITUTE OF PARAMEDICAL SCIENCES",
  "DURGA COLLEGE OF PARAMEDICAL SCIENCES, NELLORE",
  "Sri Annamacharya Institute of Technology & Science",
  "NJW COLLEGE OF PHYSIOTHERAPY KETHANAKONDA",
  "CHADALAWADA ARUNA SCHOOL OF ARCHITECTURE",
  "Seven Hiils College of Pharmacy, Tirupati",
  "MANUU POLYTECHNIC, KADAPA",
  "GATES Institute of Technology,  Gooty",
  "SIDDARTHA INSTITUTE OF SCIENCE AND TECHNOLOGY ",
  "Anantha Lakshmi Institute of Technology & Sciences",
  "Jagans Institute of Pharmaceutical Sciences",
  "COLLEGE OF FISHERY SCIENCE, NARASAPURAM",
  "G.Pullaiah College of Engineering & Technology, Kurnool",
  "Siddardha College Of Education",
  "Fathima Institute of Medical Scineces, Pulivendula",
  "Jagan's College of Pharmacy, Muthukur",
  "SRI MVKR FISHERIES POLYTECHNIC, BHAVADEVARAPALLI",
  "ASRAM College of Medical Lab Technology, Malkapuram",
  "Nirmala College of Pharmacy",
  "Gayatri Vidya Parishad College of Engineering",
  "Goutami Institute of Technology & Management for Women, Proddatur",
  "ADITYA DEGREE COLLEGE FOR WOMEN",
  "Bharath Educational Society Group of Insittutions, (Integrated Campus) Angllu",
  "Krishnaveni Degree College, Vinukonda",
  "Sun Institute of Pharmaceutical Education & Research",
  "Netaji Degree College, Vinjamur",
  "USHODAYA DEGREE COLLEGE DEVARAPALLE",
  "BIT Insitute of Technology,  (F3) Hindupur",
  "SRI LAKSHMI VENKATESWARA COLLEGE OF NURSING  PEDDASETTYPALLI PRODDATUR ",
  "St. Joseph's College for Women",
  "Damisetty Bala Suresh Institute of Technology, Kavali",
  "Srinivasa Institue of Technology & Sciences",
  "Govt. Dental College, Vijayawada",
  "NRI College of Nursing, Chinakakani",
  "Sri Krishna Chaitanya College of Nursing, Madanapalle",
  "Siddartha Educational Academy Group of Institutions (Integrated Campus)  Tirupathi",
  "Sri Lakshmi Venkateswar Institute of Pharmaceutical Sciences, Proddatur",
  "Metas Advintest College of Nursing, Nuzividu",
  "KORM College of Engineering",
  "AMARAVATHI BSC COLLEGE OF NURSING,KADAPA",
  "Bollineni College of Nursing, Nellore",
  "Repalle Christian College of Nursing, Repalle",
  "Chaitanya College of B.Sc Nursing, Ongole",
  "Sri Sai Inst. of Technology & Science, 2/714-18, Rayachoti",
  "VIVEKANANDA DEGREE COLLEGE",
  "SIDDHARTHA DEGREE COLLEGE",
  "Narayana College of Physiotheraphy, Nellore",
  "Vijaya College of Nursing, Nellore",
  "ADITYA DEGREE COLLEGE, PALAKOL",
  "Elim College of Education ",
  "VIJAYA COLLEGE OF PHARMACY",
  "Sri Sai Degree College, Visakhapatnam",
  "Medarametla Anjamma Mastanrao College of Pharmacy, Narsaraopet",
  "SRI MITTAPALLI PHARMACY COLLEGE",
  "P.Rami Reddy Memorial College of Pharmacy",
  "A.V.R. and V.P.R. Degree College",
  "Chadalawada Ramanamma Engineering College , Tirupati",
  "J C DIWAKAR REDDY HORTICULTURAL COLLEGE",
  "Kuppam Engineering College. Chittoor",
  "Sri Venkateswara Institute of Technology, Hampapuram,Anantapur",
  "B.G.B.S. COLLEGE FOR WOMEN",
  "Sri Lakshmi Narasimha College of Pharmacy, Chittoor",
  "Aditya College of Engineering, Madanapalle",
  "G. Pulla Reddy Engineering College, (Autonomous), Kurnool",
  "Bh.S.R. & V.L.M. DEGREE COLLEGE",
  "Sri Venkateswara Institue of Technology & Sciences",
  "B.R.R. & G.K.R. CHAMBERS DEGREE COLLEGE",
  "A S COLLEGE OF NURSING",
  "B.S.R. Degree College",
  "C.B.R.Degree College",
  "SUN INSTITUTE OF PHYSIOTHERAPY REHABILITATION, KAKUPALLI, NELLORE",
  "Sri Vidyaniketan  College of Pharmacy,  Sri Sainath Nagar,A .Rangam pet Tirupathi",
  "Sri Kakatiya Degree College, Pedakurapadu",
  "ANDHRA COLLEGE OF NURSING ANKAPALLE",
  "Mahati College of Pharmacy, Madanaplle",
  "Mother Theresa Institute of Management, Palamaner",
  "Gokulakrishna College of  Engineering, Sullerpet",
  "SRI VENKATESWARA DEGREE COLLEGE KADIRI ",
  "Bapatla Engineering College, Bapatla",
  "Sri Vivekananda Degree College",
  "Sri Venkateswara College of Arts and Computer sciences, Proddatur",
  "Sadana Degree College",
  "S.V.Degree College",
  "S S P G Horticultural Polytechnic",
  "SRI VIDYANIKETAN DEGREE COLLEGE",
  "International School of Technology and Sciences for  Women",
  "Sri Vijayanagar College of Law, Anantapur",
  "Krishna Saradha Degree college",
  "Chaitanya Degree College",
  "MEDARAMETLA ANJAMMA MASTAN RAO BSC MLT COLLEGE",
  "SLS Degree College",
  "SRI PONNAVOLU GOPIREDDY B.ED COLLEGE",
  "MEDARAMETLA ANJAMMA MASTAN RAO PHYSIOTHERAPY COLLEGE",
  "Veerabhadra Degree College",
  "SAI SARANYA DEGREE COLLEGE",
  "SRI VENKATESWARA COLLEGE OF ENGINEERING",
  "JAGATHGURU COLLEGE OF EDUCATION, SANIKAVARAM, PRAKASAM DISTRICT",
  "V.S.R. & A.M. Degree College, Martur",
  "Aditya Degree and PG College",
  "PRAKASH DEGREE COLLEGE",
  "Sri Venkateswara College of Education, Darsi",
  "Govt. Degree College, Porumamilla.",
  "Sri Sathya Sai Degree College",
  "S V SCHOOL OF PHARMACY",
  "Smt. Koonapareddy Prameela Rani Degree College, Parchoor",
  "Sri Vasista Degree College",
  "Chaitanya Bharathi Degree College, Chirala",
  "SRI SURYA DEGREE COLLEGE",
  "Sri Vaishnavi Degree college, Rajampeta",
  "Jyothisri College of Education, Kandulapuram, Cumbum",
  "AMRUTHA COLLEGE OF NURSING VISAKHAPATNAM",
  "APOLLO COLLEGE OF PHYSIOTHERAPY",
  "ELISHA DEGREE COLLEGE",
  "Nagarjuna Degree College for Women",
  "SAI COLLEGE OF PHYSIOTHERAPY AND REHABILITATION ",
  "Sri Venkateshwara B.Ed College, Darsi",
  "VPR College of Education",
  "SKR & SKR Govt.Degree College for Women",
  "Sree Narayana Nursing College, Nellore",
  "S.V.Degree College",
  "Bharath College of Education",
  "Sairam Degree College",
  "G.R.R. & T.P.R. Degree College, Kandulapuram, Cumbum",
  "Islamia Arabic College, Kurnool",
  "SreeRama Institute of Management",
  "MEDARAMETLA ANJAMMA MASTAN RAO LAW COLLEGE",
  "AMARA COLLEGE OF NURSING",
  "CHANDRA COLLEGE OF NURSING",
  "GOVERNMENT MEDICAL COLLEGE ELURU",
  "SRI VENKATESWARA FISHERIES POLYTECHNIC, TAKKOLU",
  "B R FISHERY POLYTECHNIC",
  "Sri Kandula Obula Reddy Degree College, Bestavaripeta",
  "Sri Gowtham Degree College, Kandulapuram",
  "ALNM Degree College for Women, Kanigiri, Prakasam District,523230",
  "Yeswanth College of Education, Bestavaripeta",
  "Sri Prathibha Degree College, Kandukur",
  "ANIL NEERUKONDA COLLEGE OF MEDICAL LAB TECHNOLOGY",
  "KSK COLLEGE OF EDUCATION, Bhattiprolu",
  "KATTUPALLI YOHAN COLLEGE OF EDUCATION, Bhattiprolu",
  "VJP and DLB DEGREE COLLEGE, Mangalagiri",
  "Pratap College of Education, Chirala",
  "Prasad College of Education",
  "Hellen Keller's College of Special Education",
  "SESHACHALA VENKATASUBBIAH DEGREE COLLEGE",
  "S S AND N COLLEGE OF NURSING",
  "GSL dental college",
  "Sri Venkateswara college of Arts and Computer Sciences",
  "AKSHY COLLEGE OF MEDICAL LAB TECHNOLOGY",
  "SRI PADMAVATHI COLLEGE OF NURSING",
  "SRI BHARGAVI COLLEGE OF NURSING",
  "NALANDA DEGREE COLLEGE AND PG CENTRE",
  "VARAPRASAD RAO BED COLLEGE",
  "ANIL NEERUKONDA COLLEGE OF PHYSIOTHERAPY",
  "VEDA COLLEGE OF PHARMACY",
  "SRI RAGHAVENDRA DEGREE COLLEGE MANTRALAYAM",
  "Sri Pathanjali Maharshi Naturopathy and Yoga Medical College Guntakal",
  "Sri Palakondraya Swamy Degree College",
  "AKULA SREERAMULU COLLEGE OF EDUCATION TANUKU.",
  "Govt.Degree College, Yerraguntla",
  "SRI VIVEKA DEGREE COLLEGE, KANDUKUAR",
  "Sri Krishna Devaraya B.Ed College, Darsi, Prakasam District",
  "SBVR College of Education, Badvel",
  "Shri P.Basireddy College of Law",
  "SKSC Degree College",
  "SCNR Govt.Degree College",
  "VRS Degree College",
  "SRI NIKHILA DEGREE COLLEGE, CHILAKALURIPET, GUNTUR DISTRICT, 522616",
  "S.V. Arts & Science College, Giddaluru",
  "C.Gangi Reddy Degree College",
  "S.S. & N. College, Narasaraopeta",
  "SREE VENKATESWARA DEGREE COLLEGE, B. MATTAM",
  "VIGNAN DEGREE COLLEGE, KADAPA",
  "C.N.R.DEGREE COLLEGE,GUDIPALA",
  "Nalanda Degree College",
  "SBSYM Degree College",
  "Mahammod College of Education",
  "Govt. Degree College, Mydukur.",
  "LYDIA COLLEGE OF PHARMACY",
  "smt.B.S.R.College of Education,",
  "Palakondraya Degree College",
  "Blue Moon Degree College, Kadiri",
  "Jai Aruna Degreee College, Kothakota",
  "Government Degree College, Pathapatnam ",
  "Sarada College of Education",
  "Sri YVS and Sri BRM College of Physical Education",
  "S V COLLEGE OF ENGINEERING    ",
  "Sri Venkhateswara DEGREE COLLEGE, Kotturu",
  "Mohammed Arhan B.Ed College, Darsi, Prakasam District",
  "G.V.& A.D.S.L. College of Education, Ongole",
  "G.V.S.M. GOVT. Degree College",
  "University College of Education",
  "Sri Potti Sriramulu Degree College, Darsi",
  "University College of Engineering",
  "Mother College of Education",
  "S.R.DEGREE COLLEGE GUDUR",
  "JNTUA College of Engineering, Kalikiri",
  "G.T.P.COLLEGE OF EDUCATION FOR WOMEN",
  "Bharathi Degree College, Chirala",
  "University College of Arts, Commerce and Law",
  "St. Paul's College of Education",
  "DR ANJI REDDY COLLEGE OF PHYSIOTHERAPY ",
  "GOVERNMENT COLLEGE OF NURSING ELURU",
  "B.R.S.DEGREE COLLEGE",
  "Sri Vijayabharathi College of Education, Throvagunta, Ongole, Prakasam District",
  "HAJIKAREEM COLLEGE OF EDUCATION",
  "Sri Vinayaka Degree College C.Belagal",
  "LITTLE ROSE COLLEGE OF EDUCATION",
  "Aadilakshmi college of Education",
  "GEETANJALI DEGREE COLLEGE",
  "SRI RAGHAVENDRA DEGREE COLLEGE-074,ALUR",
  "Sri Chaitanya Degree College, Bukkarayasamudram, Anantapuramu.",
  "Prathibha Arts and Science College",
  "SIDDI DEGREE COLLEGE",
  "ANOOP DEGREE COLLEGE",
  "SANSKRITHI SCHOOL OF ENGINEERING, PUTTAPARTHI",
  "SHANKARI DEGREE COLLEGE",
  "Vikas College of Education, Pabbapuram",
  "SRI SHIRIDI SAI DEGREE COLLEGE, JAMMALAMADUGU ",
  "DNR COLLEGE OF EDUCATION ",
  "Sri Venkateswara Degree College, Porumamilla",
  "Space Degree College for Women, Kadiri",
  "Narayana B.P.Ed. College, Tadipatri",
  "GOVERNMENT HOMOEOPATHIC MEDICAL COLLEGE",
  "Government Degree college Arakuvalley",
  "SRI V.R.J.C. WOMENS DEGREE COLLEGE",
  "SREE KONASEEMA BHANOJI RAMARS COLLEGE",
  "Smt.BARLA SUBBALAKSHMI DEGREE COLLEGE",
  "DIVYA COLLEGE OF EDUCATION",
  " SRI VARI DEGREE COLLEGE",
  "SIMS Institute of Nursing, Guntur",
  "BEHARA COLLEGE OF NURSING",
  "FERGUSSON CENTRE FOR HIGHER LEARNING",
  "Annamacharya Institute of Technology & Sciences,Tirupati",
  "Sri Vivekanada Degree College",
  "RASS KRISHI VIGYAN KENDRA POLYTECHNIC OF AGRICULTURAL",
  "ADITYA COLLEGE OF ENGINEERING & TECHNOLOGY",
  "Tiruamala College of Nursing, Vizianagaram",
  "Sri Siva College of Nursing, Rayachoti",
  "Vydya College of B.Sc MLT, Vizianagaram",
  "SR AGRICULTURAL POLYTECHNIC, KOILKUNTLA",
  "Aragonda Apollo College of Nursing, Aragonda",
  "Vikas Group of Institutions, Nunna, Vijayawada (Rural)",
  "NIMRA INSTITUTE OF DENTAL SCIENCES",
  "SRI HARI POLYTECHNIC OF AGRICULTURE",
  "BR INSTITUTE OF TECHNOLOGY AND MANAGEMENT SCIENCES, YANAMADALA, GUNTUR DISTRICT",
  "SREE VENKATESWARA PHARMACY COLLEGE",
  "Bless College of Nursing, Tirupati",
  "Sri Ravi Degree College",
  "Sri Sai College of Education, Nandikotkur",
  "VIJAYA COLLEGE OF NURSING",
  "Dr. Sudha & Nageswara Rao Inst. of Dental Sciences, Chinaoutpalli",
  "Moulana Azad College of Nursing, Kurnool",
  "N S Raju Institute of Engineering & Technology, Visakhapatnam",
  "SNSR Degree College",
  "Sri Swamy Vivekananda B Ed College",
  "Prabhath College of Education, Nandyal",
  "Geetanjali College of Nursing, Kadapa",
  "MAM WOMENS ENGINEERING COLLEGE",
  "Adoni Arts & Science College (PG), Adoni",
  "Dr.Jyothirmayi Degree College,",
  "GTR College of Nursing, Kakinada",
  "Geethanjali Degree College, Rajampet",
  "Sree Vidyanikethan College of Nursing, Tirupati",
  "Andhra Medical College, Visakhapatnam",
  "Katrina Moller College of Nursing, Arogyavaram",
  "SRI SATYA SAI DEGREE COLLEGE, Palakonda",
  "Rajiv Gandhi Institute of Medical Sciences, Kadapa",
  "GOVERNMENT DEGREE COLLEGE,RAMACHANDRAPURAM",
  "V.Js. College Of Pharmacy",
  "PRAKASAM COLLEGE OF NURSING, KOYYALAGUDEM",
  "SRI VENKATESWARA COLLEGE OF NURSING, VISAKHAPATNAM",
  "Narayana Medical College, Nellore",
  "MOKSHA COLLEGE OF NURSING",
  "ANNAPURNA COLLEGE OF NURSING",
  "Govt. Dental College (RIMS), Kadapa",
  "PRAKASAM COLLEGE OF PHARMACY, KOYYALAGUDEM",
  "Avanthi Institute of Engineering & Technology, Tamaram Village, Makavarapalem mandal, Narsipatnam , Pin-531113. (CC-81)",
  "VSM INSTITUTE OF MEDICAL SCIENCES",
  "Sree Vidya Arts & Science Degree College, Sai Nagar",
  "DR K V SUBBA REDDY INSTITUTE OF MANAGEMENT",
  "JNTUA Oil Technological and Pharmaceutical Research Institute",
  "JNTUA College of Engineering, Pulivendula",
  "JNTUA College of Engineering, Anantapur",
  "SRI Y.N. COLLEGE OF EDUCATION",
  "St. Marys College for PG Courses",
  "S.S.G.S. Degree College (Aided), Guntakal",
  "GDMM COLLEGE OF NURSING",
  "NAVODAYA COLLEGE OF NURSING",
  "DR PENUBALA CHANDRASEKHAR AND GEETHADEVI DEGREE COLLEGE",
  "Global College of Engineering & Technology",
  "R K DEGREE COLLEGE",
  "Viswanandha Institute of Pharmaceutical Sciences, Mindivanipalem, Sontam Panchayat, Anandapuram Mandal, PIN-531173  (CC-PK)",
  "Visakha Institute of Management Science, Bodamettapalem (V), Dakamarri, Bheemunipatnam (M), 531162 (CC-8M)",
  "Visakha Institute of Engineering & Technology, 57th Division,  Narava,  PIN- 530027(CC-NT)",
  "Vignan's Institute of Information Technology, Beside VSEZ, Duvvada, Gajuwaka,Vadlapudi (P.O)Pin-530049  (CC-L3)",
  "VIGNAN INSTITUTE OF PHARMACEUTICAL TECHNOLOGY, Beside VSEZ, Vadlapudi (PO),Jaggarajupeta(V),Gajuwaka ,PIN-530049(CC-AC))",
  "VEMANA DEGREE COLLEGE, DARIMADUGU, Markapur",
  "Sri Venkateswara College of Engineering And Technology, Nh-5, Etcherla, PIN-532402 (CC-MT)",
  "Andhra Muslim College of Education, Guntur",
  "Dr. Zakir Hussain College of Education, Mulukuduru, Ponnur",
  "UNIVERSAL DEGREE COLLEGE, YERRAGONDLAPALEM",
  "CHALAPATHI COLLEGE OF PHARMACY",
  "SRI GOWTHAMI DEGREE COLLEGE, SANTHANUTHALAPADU",
  "INDIRA COLLEGE OF EDUCATION",
  "Hindu College of Education, Guntur",
  "VAMSADHARA BACHELOR OF PHYSICAL EDUCATION",
  "New Era College of Education, Agathavarappadu",
  "Sri Sivani College of Pharmacy, N.H-5, Chilakapalem Jn., Etcherla (Mandal) Srikakulam-532485 (CC-DA)",
  "Aditya Pharmacy College, Surampalem",
  "Shivani Degree College, Gullapalli",
  "Sri Sivani College of Engineering, Chilakapalem Junction, Etcherla Mandal,  PIN-532402 (CC-W6)",
  "Sai Ganapathi Engineering College for Women, Gidijala, Anandapuram (M),  PIN-531173 (CC-6F)",
  "Miracle Educational Society Group of Institutions, Miracle City, Bhogapuram Mandal PIN-535216, (CC-6C)",
  "Maharaj Vijayaram Gajapathi Raj College of Engineering, Chintalavalasa, Vizianagaram-535005 (CC-33)",
  "Lendi Institute of Engineering & Technology, Jonnada (V), Denkada mandal, PIN- 535005 (CC-KD)",
  "Gonna Institute of Information Technology & Science, Gonnavanipalem, Aganampudi, Ward No. 56, G.V.M.C, PIN- 530046 (CC-6E)",
  "GMR Institute of Technology (GMRIT)",
  "AVANTHI'S ST.THERESSA INSTITUTE OF ENGINEERING & TECHNOLOGY, Garbham Road, Garividi Village, Garividi Mandal, PIN -535101 (CC 99)",
  "Avanthi's Research & Technological Academy, Basavapalem (V), Bhogapuram(M),  PIN-500034 (CC-HQ)",
  "Avanthi Institute of Pharmaceutical Sciences, Bhogapuram(M), PIN-531162  (CC-T5)",
  "ADITYA INSTITUTE OF TECHNOLOGY & MANAGEMENT, K.Kothuru, Tekkali - 532201, Srikakulam District, A.P(CC-A5)",
  "GEMS COLLEGE OF B.Sc.MLT",
  "Govt Degree College For Women Arakuvalley",
  "Seven Hills College of Education",
  "ANAM SANJEEVAREDDY DEGREE COLLEGE, ATMAKUR",
  "VIGNAN DEGREE COLLEGE, CHEJARLLA",
  "K B REDDY COLLEGE OF EDUCATION, NAIDUPET",
  "SREE VENKATESWARA COLLEGE OF ENGINEERING",
  "THANUJA MEMORIAL DEGREE COLLEGE",
  "KLR COLLEGE OF EDUCATION,GIDDALUR",
  "GIDEONS COLLEGE OF EDUCATION, GIDDALURU",
  "INDIRADEVI COLLEGE OF EDUCATION",
  "S.V.J.V. SANSKRIT COLLEGE",
  "S.V.D. GOVT. DEGREE COLLEGE FOR WOMEN",
  "S.V. Degree Colelge, Bhimadole(V&M), W.G.Dist.",
  "Suryaraya Degree College",
  "St. MARYS NIRMALA HRUDAYA MAHILA COLLEGE",
  "Sanjeev College of Arts and Science",
  "V.V. GIRI GOVT. KALASALA",
  "V.S.R.Rural Degree College",
  "V.S.M.College",
  "Navyandhra Degree College",
  "V.S.K. DEGREE COLLEGE",
  "V.K.V.Govt.Degree College",
  "Smt. GOTTUMUKKALA SARASWATHI DEGREE COLLEGE",
  "Smt.B.S.R.Degree College, Gokavaram",
  "Smt.B.S.R.Degree College",
  "Aditya Degree College Tuni, East Godavari",
  "Aditya Degree College",
  "Smt.Alluru Varahalamma Memorial Degree College",
  "S.M.B.T.A.V. & S.N. DEGREE COLLEGE",
  "SKVT Government Degree College",
  "S.K.V.R.R. DEGREE COLLEGE",
  "S.K.S.D. MAHILA KALASALA UG AND PG (AUTONOMOUS)",
  "SRI BALAJI COLLEGE OF EDUCATION, KANIGIRI",
  "Pragyna Degree college",
  "VIKAS DEGREE COLLEGE",
  "VIJNANA NILAYAM DEGREE COLLEGE",
  "Vignan Institute of Science & Arts",
  "TRIVENI DEGREE COLLEGE",
  "The Amalapuram Degree College",
  "S.V.V.S.S.Devasthanam Degree College",
  "S.V.S.S. ARTS & SCIENCE COLLEGE",
  "Sri Gowthami Degree College, Jinnuru(V)",
  "SRI GOWTHAMI DEGREE COLELGE, NARSAPUR, W.G.DIST",
  "SRI CHALAPATI DEGREE COLLEGE",
  "ABN & PRR COLLEGE OF SCIENCE",
  "Sree Siddhartha Degree College",
  "Kasturibai College of Education",
  "S.N.M. Degree College",
  "Smt.Sakunthala Devi Degree College",
  "Smt.J.B.Degree College",
  "Vidyanidhi Degree College",
  "Sri Venkateswara College of Arts & Science",
  "Sri Venkatasai Degree College",
  "SRI VELAGAPUDI RAMAKRISHNA DEGREE COLLEGE",
  "SUMOURYA DEGREE COLLEGE",
  "Sri Varupala Surya Rao Degree College",
  "SRI BALAJI PHYSICAL EDUCATION, KANIGIRI",
  "SRI SURYA DEGREE COLLEGE",
  "Vellanki College of Education",
  "SRI SRINIVASA DEGREE COLLEGE",
  "Sri Sai Madhavi Degree College, Anaparthi",
  "Sri Sai Madhavi Degree College",
  "Sri Sairam Degree College, Nandikotkur",
  "SRI VENKATA RAMANA COLLEGE OF EDUCATION,GURAZALA",
  "AMAR COLLEGE OF BSC NURSING,AMARAVATHI",
  "NS LAW COLLEGE",
  "SRI SAI DEGREE COLLEGE, TANUKU, W.G.DISTRICT",
  "MVR Degree College, H.No: 6-1, Sai Nagar, Gangavaram,  Chittoor Dist.Rural",
  "S.D.V.R.R.Degree College",
  "Sathabdhi Degree College",
  "SASI DEGREE COLLEGE",
  "S.A.S. GOVT. DEGREE COLLEGE",
  "ADITYA DEGREE COLLEGE BVM",
  "Samhitha Degree College",
  "R.R.D.S. GOVT. DEGREE COLLEGE",
  "Sri Sankara's Degree College (PG), Kurnool",
  "Sai Degree College,",
  "S.V. Arts, Commerce & Science, Chagalamarri",
  "Sir C.V.RAMAN INSTITUTE OF MANAGEMENT STUDIES",
  "AKSHARA DEGREE COLLEGE",
  "SRI SAI VYSHNAVI DEGREE COLLEGE",
  "A.B.R College of Education, Kanigiri",
  "Rajiv Gandhi Degree College",
  "Rajamahendri  Degree College for Women",
  "S.V Degree College Kothapalle Mitta SR Puram(M), Chittoor Dist",
  "St. Anns College for Women, Guntur",
  "S.B.G. Degree College, Sattenapalli",
  "Vidya Kendran Degree College, Sattenapalli",
  "Pragati Degree College Sattenapalli",
  "Sri Venkateswara Degree College, Terlam, Vizianagaram Dist.",
  "A.S.N.Degree College for Women",
  "Andhra Kesari Degree College",
  "Al Ameer Institute of Management & Tech",
  "Chalapathi Degree College, Lam",
  "LAKSHMI SAVITRAMMA COLLEGE OF NURSING, KL PURAM, VIZIANAGARAM DISTRICT",
  "Vijaya Jyothi Degree College, Mangalagiri",
  "Bapatla Women's Engineering College, Bapatla",
  "KMR INSTITUTE OF MEDICAL SCIENCES NANDIGAMA",
  "RAJA RATNA COLLEGE OF NURSING",
  "JMJ COLLEGE OF NURSING",
  "AVANTHI DEGREE AND PG COLLEGE",
  "ZENEX VISION SCHOOL OF BUSINESS AND TECHNOLOGY    ",
  "SARADA BPED COLLEGE",
  "GOVERNMENT DEGREE COLLEGE, PONDURU",
  "SRI ADI SHIVA SADGURU ALLI SAHEB SIVAARYULA HOMEOPATHY MEDICAL COLLEGE, GUNTAKAL",
  "K.G.P.R - A.N.R.COLLEGE OF EDUCATION",
  "GIET DEGREE COLLEGE",
  "FRIENDS COLLEGE OF EDUCATION, CHAPADU",
  "Viveka College of Education, Vaddesangam",
  "Sri Harsha's Womens Degree College, Cumbum",
  "SVR Engineering College, Nandyal",
  "GOVERNMENT DEGREE COLLEGE, Nakkapalli",
  "Sri Adisiva Sadguru Alli Saheb Sivaarvyula Ayurvedic Medicakal College, Thimmapuram, Guntakal",
  "JANET DEGREE COLLEGE, KETHANKONDA, IBRAHIMPATNAM MANDAL",
  "Dr. Abdul Haq Unani College & Hospital, Kurnool",
  "Sri Sai Ram PG College, Nandikotkur",
  "S.V. Degree and PG College, Nellore",
  "SRI CHINTALAPATI VARAPRASADA MURTHY RAJU GOVERNMENT DEGREE COLLEGE ",
  "S.V.R. Government Degree College",
  "S.V.A Govt. College, Srikalahasti",
  "Govt. Degree College, Srisailam",
  "Govt. Degree College, Banganapalli",
  "ELURU COLLEGE OF ENGINEERING  & TECHNOLOGY",
  "SANKAR REDDY B.P.ED COLLEGE, SALAKALAVEEDU, BESTAVARIPETA",
  "SRI LAKSHMI INSTITUTE OF MEDICAL SCIENCES COLLEGE OF NURSING",
  "SRI SIDDHI VIGNESHWARA INSTITUTE OF MEDICAL SCIENCES COLLEGE  OF PHYSIOTHERAPY",
  "Govt. Degree College, Dhone (GVRS)",
  "PSC & KVSC Govt. Degree,",
  "Govt. Degree College, Nandikotkur",
  "Govt. Degree College, Atmakur",
  "Social Welfare Residential Govt.Degree College for Girls",
  "SKR Government Degree College (Women)",
  "Mrs. A.V.N.  College",
  "College of Fishery Science, Muthukur",
  "Sri Venkateswara Ayurvedic College, Tirupati",
  "SAROJINI DEVI COLLEGE OF NURSING",
  "MAHATMA COLLEGE OF NURSING",
  "Sai Degree College, Markapur (Trinity)",
  "Chaitanya College of Pharmacy, Devarajugattu (Vill), Near Markapur Town, PIN- 523316  (CC-8C)",
  "St.Marys PG College, Buchireddipalem",
  "Swarnandhra College of Engineering & Technology, Narasapur. PIN -534275  (CC-A2)",
  "VISWABHARATHI COLLEGE OF PHYSIOTHERAPY AND REHABILITATION",
  "SRI RACHAPUDY NAGABHUSHANAM COLLEGE OF PHYSIOTHERAPY",
  "University College of Engineering, Kakinada (AUTONOMOUS)",
  "B A & K R College of Pharmacy, NH-5, Doddavarappadu (V), Ongole- 523002(CC-PG)",
  "Nannapaneni Venkat Rao (NVR) College of Engineering & Technology, NVR Nagar, Ithanagar, Tenali, PIN-522501(CC-7T)",
  "Adarsa College of Pharmacy, G.Kothapalli, Gokavaram (M), PIN- 533285(CC-PE)",
  "K.V.Subba Reddy Degree College,",
  "Green Royal Academy of Pharmaceutical Education & Sciences,D.No.2-89,  Koyyalagudem Mandal,   Ponguturu-534312(CC-7H)",
  "Nova College of Engineering & Technology, Vegavaram, Jangareddigudem Mandal,PIN- 534447(CC-A0)",
  "Andhra Loyola Institute of Engineering & Technology, Polytechnic Post Office, Loyola Campus,Vijayawada, PIN-520008.  (CC-HP)",
  "RK College of Engineering, Navepothavaram(V),Kethanakonda, Ibrahimpatnam,PIN-521456,(CC-MC)",
  "Vignan's Nirula Institute of Technology & Science for Women, Vign avenue, Palakaluru Road  , PIN-522 005(CC-NN)",
  "BELLAMKONDA AGRICULTURAL POLYTECHNIC",
  "Amrita Sai Institute of Science & Technology, Amrita Sai Nagar, Paritala (PO), Kanchikacherla (MD), PIN-521180  (CC-AJ)",
  "St. Ann's College of Engineering and Technology., Nayunipalli(V), Vetapalem(M), Chirala-523187,(CC-F0)",
  "RISE Krishna Sai Gandhi Group of Institutions, Ongole",
  "Dr.K.V.Subba Reddy Institute of Technology, Kurnool",
  "Velankanni Institute of Computer Science, Venkatachalam",
  "Vemu Institute of  Technology, Chittoor",
  "Siddharth Institute of Engineering & Technology, Puttur",
  "G.V.R & S College of Education, Guntur",
  "ANDHRA ENGINEERING COLLEGE",
  "Viswam Engineering College",
  "RGUKT- NUZVID",
  "SAASTRA PHYSIOTHERAPY COLLEGE",
  "GM POLYTECHNIC OF AGRICULTURE",
  "Silver Jubilee College (PG), Kurnool",
  "S S AND N AH POLYTECHNIC COLLEGE",
  "Dr. K. V. Subba Reddy School of Business Management",
  "VENKATESWARA COLLEGE OF PHYSIOTHERAPY, ANAKAPALLI",
  "Kotha Hanumaiah & Lakshmi Kotamma Degree College, Piduguralla",
  "NARAYANA COLLEGE OF ALLIED HEALTH SCIENCES",
  "University College of Engineering, Vizianagaram",
  "SRI VENKATA SRINIVASA DEGREE COLLEGE , MAKKUVA",
  "GAYATRI COLLEGE OF SCIENCE & MANAGEMENT, MUNASABPETA, SRIKAKULAM",
  "VASAVI COLLEGE OF PHARMACY",
  "Sri C.V. Raman College of Computer Science, Podili",
  "POLYTECHNIC OF AGRICULTURE, REGIONAL AGRICULTURAL RESEARCH STATION, ANAKAPALLE",
  "Venkata Ramana College Of Education",
  "Vivekananda College of Education, Kandukur",
  "Anniebesant College of Education, Kandukur",
  "INSTITUTE OF ADVANCED STUDIES IN EDUCATION IASE",
  "KRISHNA TEJA HOTEL MANAGEMENT",
  "Sri Saraswathi College of Education, Tallur Village, Prakasam District",
  "C.N.R. Degree College",
  "Vani Rama College of Education, Medepi, Prakasam District",
  "NRI MEDICAL COLLEGE",
  "GOVERNMENT MEDICAL COLLEGE VIZIANAGARAM",
  "SRI LALITHA DEVI COLLEGE OF EDUCATION,RAJAMPALLI, DARSI",
  "SVCR Government Degree College, Palamaner   Rural",
  "Sri  Venkateswara  College of Engineering, Karakambadi Road, Tirupathi",
  "St. Johns College of Education, Eluru.",
  "BHARATH REDDY COLLEGE OF MEDICAL LAB TECHNOLOGY",
  "V.T.J.M. & I.V.T.R. Degree College, Mangalagiri",
  "SNEHA BED COLLEGE, Tarlupadu",
  "Sanviya College of Education, Bapatla",
  "K.G.R.L. College Of Pharmacy",
  "St. Johns College of Education",
  "Kalam B.Ed College, Kanigiri",
  "ST XAVIERS COLLEGE Jami",
  "SRI KRISHNA DEGREE COLLEGE BONDAPALLI (V AND M)",
  "CHAITANYA COLLEGE OF EDUCATION",
  "KKC HOMOEOPATHI MEDICAL COLLEGE",
  "SWATHI COLLEGE OF NURSING",
  "MEDI COLLEGE OF NURSING",
  "Govt. College of Nursing",
  "Integrated Special Education (B.Ed Spl.Ed.)",
  "K.G.R.DEGREE COLLEGE",
  "SRI VIVEKANANDA DEGREE COLLEGE-BETAMCHERLA",
  "ACHARYA B.ED. COLLEGE",
  "Sri Ramakrishna Degree College (Autonomous)",
  "Krishnaveni Degree College for Women, Narasaraopeta",
  "Gayatri Vidya Parishad College of Engineering for Women, Madhurawada, PIN-530048(CC-JG)",
  "GOVERNMENT COLLEGE OF NURSING,ELURU",
  "SR BUGGARAMESWARA DEGREE COLLEGE ORVAKAL",
  "PBDEVI COLLEGE OF EDUCATION ",
  "VEDA COLLEGE OF PHARMACY",
  "SDS MEMORIAL TEACHER TRAINING COLLEGE",
  "SWATHI COLLEGE OF PHYSIOTHERAPY",
  "USHA SRI DEGREE COLLEGE  KUKUNOOR",
  "VIJAYAM BUSINESS SCHOOL",
  "KKC COLLEGE OF PHYSIOTHERAPY",
  "RAGHAVA COLLEGE OF PHYSIOTHERAPY",
  "SAVEERA COLLEGE OF NURSING",
  "APPLE COLLEGE OF BSC NURSING ",
  "MSR Degree College, Kavali",
  "University College of Science and Technology",
  "S.D. College of Information Technology",
  " ASHOKA COLLEGE OF EDUCATION",
  "SRI VENKATESWARA DEGREE COLLEGE, GURRAMKONDA",
  "MPR LAW COLLEGE",
  "SRI VENKATESWARA PHARMACY COLLEGE, RVS NAGAR, CHITTOOR",
  "YSR ENGINEERING COLLEGE OF YVU",
  "Horticultural Polytechnic, Kalikiri",
  "SSB DEGREE COLLEGE FOR WOMEN YELESWRAM",
  "Horticultural Polytechnic, Nuzvid",
  "College of Horticulture, Chinalataripi",
  "SRI VINAYAKA VENKATESWARA COLLEGE OF EDUCATION",
  "SRI VENKATA SANDHYA COLLEGE OF EDUCATION",
  "College of Veterinary Science, Tirupati",
  "College of Veterinary Science, Proddutur",
  "Government Degree College, Paderu",
  "BADAGALA SANKARA RAO DEGREE COLLEGE",
  "Narayana Dental College & Hospital, Nellore",
  "Vaagdevi Institute of Technology & Science, Proddatur",
  "SRI MEKAPATI GOUTHAM REDDY AGRICULTURAL COLLEGE",
  "Venkataratna College of Education, Kurnool",
  "Gayatri Mahila Degree College",
  "Sri Sai Kulwant Degree College",
  "LEVAKU NARAPU REDDY COLLEGE OF EDUCATION",
  "SREE VENKATESWARA COLLEGE OF PHARMACY",
  "Chanakya Institute of Hotel Management and Catering Technology",
  "Gayatri College of Education",
  "Sri Sai MBA College, Nandikotkur",
  "Maheswari College Of Education",
  "Sri Kolla Appala Naidu College of Education",
  "Pydah College (PG Courses)",
  "SRI SADGURU SAI DEGREE COLLEGE",
  "ADARSH DEGREE COLLEGE ,PENDURTHI",
  "BEHARA COLLEGE OF ENGINEERING AND TECHNOLOGY    ",
  "Sree Kasyap Degree College",
  "Sri Adi Narayana Mahila Kalasala, Anakapalle",
  "Raghu College Of Pharmacy",
  "Shri Vishnu College Of Pharmacy",
  "Atchuta Degree College",
  "Vagdevi Degree College",
  "St.Ann's College for Women",
  "Kurnool Degree College,",
  "M.S.R.S. Siddhardha Degree College",
  "Govt.Degree College, S.Kota",
  "Sri Vasavi Vignana Mandali Degree College",
  "Gayatri Vidya Parishad College for Degree & PG courses (A)",
  "SVKP & Dr. K.S. Raju Arts &Science College",
  "GOVERNMENT DEGREE COLLEGE PERUMALLAPURAM",
  "ADITYA DEGREE AND PG COLLEGE",
  "Satya Krishna Degree College",
  "Sri Krishna Degree College",
  "Yalamarty B-Pharmacy College",
  "Hindustan Shipyard Degree College",
  "College of Pharmaceutical Sciences",
  "Maharajahs PG College",
  "Poorna Sai Vivekananda Degree College",
  "ADITYA DEGREE COLLEGE",
  "Uday Degree College",
  "Sri Shiridi Sai Srinivasa Degree College",
  "Christ College Of Education",
  "Sheela mantula Veera Suryavatamma Degree College",
  "Sri Swamy Vivekananda College of Education",
  "Sri Venkata Ramana Degree College",
  "Dadi Veeru Naidu Degree College",
  "PADMAVATHI DEGREE COLLEGE",
  "GITAM Dental College and Hospital, Visakhapatnam",
  "Yanamadala Kamala College of Education",
  "SUBRAHMANYAM ANANTHALAKSHMI COLLEGE OF NURSING",
  "SV DEGREE COLLEGE",
  "SRI RAMACHANDRA DEGREE COLLEGE",
  "KAKINADA SRI ADITYA DEGREE COLLEGE ",
  "SGTRM Govt. Degree College, Yerraguntla",
  "Y.K.M.College of Education",
  "Maharshi Degree College",
  "Rajah R.S.R.K.Ranga Rao College, Bobbili",
  "Oxford Degree College",
  "SRI BALASAI DEGREE COLLEGE",
  "A.J. COLLEGE OF EDUCATION",
  "DR. D.S. KOTHARI COLLEGE OF EDUCATION",
  "S.D.M.S.M KALASALA",
  "THE HINDU COLLEGE",
  "A.J. KALASALA",
  "VIKAS DEGREE COLLEGE",
  "SMT. VELAGAPUDI DURGAMBA SIDDHARDHA LAW",
  "SRI SIDDHARTHA DEGREE COLLEGE FOR SCI.& COMPUTERS",
  "VISWABHARATHI DEGREE COLLEGE",
  "DR. ZAKIR HUSSAIN COLLEGE OF ARTS & SCIE",
  "MATTREDDY DEGREE COLLEGE",
  "Mohan Degree College",
  "SRI KARIBANDI SUBBARAO MEMORIAL DEGREE COLLEGE",
  "Sri Boddu Krishna Degree College",
  "Andhra Christian College, Guntur",
  "Karunya College of Education",
  "Sri Sai Ram Degree College",
  "Devathi Venkata Subbaiah Degree College",
  "A.C.Evening College",
  "University Collge of Architecture & Planning",
  "Y.A. Govt. College for Women",
  "Sri Srinivasa   Degree College, Punganur Rural",
  "Sri Vema Degree College, Naidupeta",
  "Raos Degree & PG College,Nellore",
  "Vidyalaya Degree College, Gudur",
  "DDR College of Education, Saraswathi Nagar, Nellore",
  "Sri Chandra Reddy Degree College, Nellore",
  "Jawahar Bharathi Degree College, Kavali",
  "Dr. Chennur Radha Krishna Reddy Degree College,Sydapuram",
  "Sri Vimalamandagiri Swamy Residentoial College for Women, Vyasasramam, Yerpedu",
  "Sri Vignyadeepthi Degree College, Chittoor(Rural)",
  "Ravindras Rayalaseema College, Punganur Rural",
  "SAI SREE MAHILA DEGREE COLLEGE, DHONE",
  "SKR & SKR govt.Degree College for Women (PG)",
  "Sri Chaitanya Degree College",
  "Lepakshi Degree College",
  "YVNR Degree College",
  "Sri Vaishnavi Degree College, Kadapa",
  "C.R.Reddy Degree College",
  "Sri Sai Degree College, Rly.Koduru",
  "Sri Sai College of Education",
  "Balaji College of education",
  "St. Joseph College of Nursing, Eluru",
  "Rajiv Inst. of Medical Sciences, Ongole",
  "Florence Nightingale College of Nursing, Kankipadu",
  "Vijay College of Nursing, Srikakulam",
  "S.P.W. Degree & PG College, Tirupati",
  "CKS Teja Institute of Dental Sciences & Research, Tirupati",
  "Sri Padmavathi College of Nursing, Guntakal",
  "SVU IASE, Tirupati (Constituent College)",
  "SV.Oriental. College, Tirupati Urban",
  "Rayalaseema College of Graduation Tirupati Urban",
  "Sri Srinivasa Degree College , Chandragiri",
  "Sri Bharathi   Degree College, Piler  Rural",
  "Koringa College Of Pharmacy",
  "CNR Arts & Science College, Piler Rural",
  "BRUNDAVAN B.ED. COLLEGE, ALLAGADDA",
  "SANGAM REDDY PAIDAPU NAIDU COLLEGE OF EDUCATION",
  "HARAGOPAL COLLEGE OF EDUCATION",
  "SRIVYSHNAVI DEGREE COLLEGE PATTIKONDA",
  "TARAKARAM BED COLLEGE",
  "VIGNAN DEGREE COLLEGE",
  "WINGS BUSINESS SCHOOL, KKV PURAM, R C PURAM",
  "VIVEKA DEGREE COLLEGE",
  "Govt. Degree      College,      PUTTUR Rural",
  "SRI LAKSHMI VENKATESWARA COLLEGE OF EDUCATION,PANCHALINGALA",
  "Sri Sreenivasa Degree  College, Somala Rural",
  "K.K.C. College of Law, Puttur",
  "Sri Srinivasa Degree College, Madanapalle Urban",
  "Oxford Degree College 5-662 Santa Maidanam Srikalahasti Chittoor Dist-Urban",
  "Dr. Kunchala Rajarathnam Christian  Degree College, Jeevagram, Renigunta Rural",
  "Emeralds Degree College, Tirupati Urban",
  "Sri Vijetha Degree College, Chittor  Urban",
  "DBB Institute of PG Studies, Puttur",
  "ASRR Degree College, Pachikapallam, Rural",
  "Royal School of Information & Management, Agarala Village, Tirupati",
  "SBGR Degree College, Pakala Rural",
  "SRI VENKATESWARA College of  COMMERCE  TIRUPATI Urban",
  "Dr.R.C.Reddy Degree College, Tirupati Urban",
  "CVS Krishna Teja College of Education, Renigunta Road, Tirupati",
  "Kuppam Degree College, Kuppam",
  "KRISHNA UNIVERSITY Dr. MRAR  PG CENTRE, NUZVID",
  "NMES College of Education",
  "PRISM DEGREE COLLEGE ",
  "SRI BHARATHI B.ED COLLEGE",
  "KEERTHI DEGREE COLLEGE",
  "BHARATHI DEGREE COLLEGE",
  "SRI SATYAKRUPA DEGREE COLLEGE FOR WOMEN",
  "Penna College of Cement Sciences",
  "Government College for Women Autonomous, Guntur",
  "R.V.R. & J.C. College of Engineering",
  "Hindu College, Guntur",
  "S S R DEGREE COLLEGE , MARKAPUR, PRAKASAM DISTRICT",
  "Sir C.R.R. College Of Engineerng",
  "Siddhardha Degree College, Katrenikona, E.G.Dist.",
  "Sir C R Reddy College for Women",
  "S.K.B.R.Degree College",
  "SRI SAI DEGREE COLLEGE, LINGAPALEM",
  "Sri Kolla Veera Swamy Degree College",
  "Sri Venkateswara Degree",
  "Sasi Degree College",
  "Sri N.S.N.Raju Degree College",
  "Sri Padmavathi Mahila Degree College",
  "Sri Raja Rajeswari Degre College",
  "SRI RAMA DEGREE COLLEGE, TANUKU",
  "SRI Y.N. COLLEGE",
  "Miriam Degree College",
  "St.Peters College of Education, Adoni",
  "University College of Engineering & Technology",
  "DR SAI KALESWAR MEMORIAL DEGREE COLLEGE",
  "T.J.P.S. College",
  "V.S.R. & N.V.R. College, Tenali",
  "G.C & Y P N Degree College, Kanigiri",
  "Tarlapadu College of Education, Tarlapadu",
  "Government College for Men, Kadapa",
  "KITES COLLEGE OF BSC MLT",
  "DHANALAKSHMI COLLEGE OF EDUCATION , MUPPALLA",
  "PANDIT SUBBAREDDY COLLEGE , KONDAMODU",
  "Sri Venkateswara Degree College, Kollipara",
  "LVR DEGREE COLLEGE",
  "AKSHARA DEGREE COLLEGE",
  "G V R & S Degree College for Women, Guntur",
  "K Chandrakala PG College, Tenali",
  "Krishnaveni Degree College, Narasaraopeta",
  "Modern Degree College, Chilakaluripeta",
  "Prabhala Lakshminarayana Memorial Degree College, Kaza",
  "Sri Majeti Guravaiah Degree College, Guntur",
  "University Collge of Sciences",
  "Govt. Degree College, Kanigiri",
  "Vignan Degree College, Guntur",
  "St. Joseph's College of Education for Women",
  "P.B.N. College",
  "University College of Pharmaceutical Sciences",
  "A.P.Residential Degree College",
  "A.C.College of Law",
  "G.R.K. DEGREE COLLEGE, ONGOLE",
  "Dr.Homi Jahangir Baba Degree College, Karlapalem",
  "Dr. Samuel George College of Pharmaceutical Science, Markapur",
  "MCV Degree College, Tatimakula Palyam Road, Punganur",
  "Sri Venkateswara College of Education",
  "Ideal & S.K.C.M Degree College, Markapur",
  "J.C. College of Law, Guntur",
  "POLYTECHNIC OF AGRICULTURE PODALAKUR",
  "College of Engineering for Women",
  "Dr.PVG Raja Saheb College of Education",
  "Mahatma Gandhi College, Guntur",
  "Matrusri Oriental College, Jillelamudi, Bapatla",
  "Akshara College of Education, Pamur, Prakasam District",
  "P.N.C & K.R. College, Narasaraopeta",
  "Shri Vishnu Engineering College for Women, Vishnupur, Kovvada Village, Bhimavaram, PIN-534202(CC-B0)",
  "Newton's Institute of Engineering, Aluguraja Pally(V)",
  "SEICOM Degree College, Tirupati",
  "S V COLLEGE OF NURSING",
  "DR PENUBALA PENCHALAIAH COLLEGE OF EUDCATION, RLY KODUR",
  "AKNU Campus, T.P.Gudem",
  "SRI SAI COLLEGE OF EDUCATION, BUDDAYA PALLI, KADAPA",
  "Maharajah's college (Autonomous)",
  "Geethika B.Ed College, Piduguralla",
  "Elite Degree College",
  "Paladugu Parvathi Devi College of Engineering and Technology, Surampalli(v), Gannavaram(M), PIN-520001(CC-KR).",
  "Usha Rama College of Engineering & Technology,NH-5, Telaprolu, Near Gannavaram, Unguturu mandal, PIN- 521109.(CC-NG)",
  "Govt. Degree College, Pattikonda",
  "Madina College of Education, Brambanakotkur",
  "QIS College of Pharmacy, Vengamukkapalem, Pondur Road,  Ongole-523272  (CC-Y3)",
  "A1 Global Institute of Engineering & Technology, Markapur- 523316 (CC-7Y)",
  "Aditya College of Pharmacy",
  "Aditya College of Engineering, ADB Road, Surampalem, PIN-533437(CC-MH)",
  "KV RAMANA MEMORIAL DEGREE COLLEGE",
  "JVRRM College of  Education, Nandyal",
  "OMSAI COM BED COLLEGE",
  "DR GURURAJU GOVERNMENT HOMOEOPATHIC MEDICAL COLLEGE",
  "SOUTHERN INTERNATIONAL HOTEL MANAGEMENT ACADEMY",
  "Sri Datta Sai College of  MCA",
  "Dr.VARALAKSHMI B P Ed COLLEGE",
  "ALLURI SEETHARAMA RAJU DEGREE COLLEGE",
  "AUDISANKARA COLLEGE OF PHARMACY",
  "SRINIVASA COLLEGE OF EDUCATION",
  "Vikas Degree College",
  "S.L.N. Degree College",
  "Sri Kakatiya Womens Degree College",
  "Sri Vivekananda D.P.Ed College, Podili Village, Podili, Prakasam District",
  "SATHAVAHANA COLLEGE OF SCIENCE & ARTS",
  "Govt. Degree College Kuppam  Rural  Co-Ed.",
  "Sri Vivekananda B.P.Ed College, Ramayanakandrika Village, Madireddy Palem Village, Prakasam District",
  "Sri Vivekananda B.Ed College, Ramayanakandrika Village, Podili, Prakasam District, 523240",
  "V.K.R COLLEGE",
  "Sai Deepthi College of Physical Education, Edulapalem Village, Pathipadu, Guntur District",
  "GOVERNMENT DEGREE COLLEGE, ALAMURU",
  "Pujitha College of Education, Ravipadu, Narsaraopeta, Guntur District 522603",
  "Gowthamabudda College of Education,Karedu Village,Vulapadu",
  "Priya Darisini Degree College, Tenali",
  "NARAYANA DEGREE COLLEGE",
  "VIJAYA BEHARA COLLEGE OF EDUCATION ",
  "SRI HARA DEGREE COLLEGE",
  "SBVR Agriculture College",
  "S.R. Degree College, Pamidi",
  "St. Thomas College of Education",
  "Gnana Saraswathi Degree College,Bethamcherla - 518599",
  "SRI LAKSHMI VENKATESWARA DEGREE COLLEGE, DHONE",
  "SRI SAI RAJESWARI B.Ed COLLEGE, LINGAPURAM, PRODDATUR,",
  "SUJATHA COLLEGE OF NURSING",
  "KBR COLLEGE OF NURSING, VISHAKHAPATNAM",
  "SRI CHAITANYA COLLEGE OF NURSING, VIZIANAGARAM",
  "SVR DEGREE COLLEGE, PALAKONDA",
  "GITAMS Degree College, Kadapa",
  "DLR College PG Courses, G.Mamidada",
  "NJW COLLEGE OF MEDICAL LAB TECHNOLOGY, KETHANAKONDA, IBRAHIMPATNAM",
  "Vyshnavi Degree College, Dhone",
  "VISHISTA DEGREE COLLEGE",
  "KIMS DENTAL COLLEGE And HOSPITAL",
  "Dr.Mallela Ramaiah College of Nursing",
  "Seshachala Institute of Management Studies, Puttur",
  "Amrutha College of Education, Singarayakonda",
  "Kakatiya Degree College, Podalakur",
  "LAKSHMI NARASIMHA B.ED COLLEGE, Darsi",
  "GOVT. DEGREE COLLEGE CHINTALAPUDI",
  "KGR B.ED COLLEGE, Darsi",
  "Sri Sankara's College of  Education, Kurnool",
  "JEPHANYA INSTITUTE OF PARAMEDICAL EDUCATION AND REHABILITATION COLLEGE OF PHYSIOTHERAPY, TIRUPATI",
  "GOVERNMENT MEDICAL COLLEGE, NANDYAL",
  "National Degree College",
  "NARAYANA COLLEGE OF BSC MLT ",
  "Sri Raghavendra College of Education, Allagadda",
  "K.S.R B.ED COLLEGE, CUMBUM",
  "SRI GOWTHAMI B.ED COLLEGE, YERRAGONDAPALEM",
  "KITES COLLEGE OF NURSING ATCHUTHAPURAM ANAKAPALLI",
  "Govt. Degree College, Rajampet",
  "SPIRITS Degree College",
  "Akshara College of Education, Gundlapalli Village, Maddipadu Mandal, Prakasam District",
  "SANKAR REDDY BED COLLEGE, BESTAVARIPETA",
  "Government Degree College, Jammalamadugu",
  "Smt.Basava Rama Tarakam Memorial Law College",
  "Sri Shiridi Sai Degree College, Vizianagaram Dist.",
  "Shirdi Women's Degree College",
  "Sri Vedavyasa Degree college",
  "Hills College of Teacher's Education, Naharlagun",
  "Venerable Uktara Bethany College, Manmow",
  "College of Agriculture, Pasighat",
  "Saint Claret College, Ziro",
  "Doying Gumin College, Pasighat",
  "Tomo Riba Institute of Health and Medical Sciences",
  "SEI MEMORIAL COLLEGE    ",
  "DENNING COLLEGE FOR TEACHERS EDUCATION",
  "College of Horticulture and Forestry, Pasighat",
  "Government Model College, Basar",
  "DAYING ERING COLLEGE OF TEACHERs EDUCATION, PASIGHAT",
  "North East Nursing College of Health Science",
  "DONYI POLO B.Ed COLLEGE",
  "ARUNACHAL STATE NURSING COLLEGE TRIHMS NAHARLAGUN",
  "Wangcha Rajkumar Government College, Deomali",
  "Jomin Tayeng Government Model Degree College",
  "Govt Model Degree College Palin",
  "GOVERNMENT LAW COLLEGE",
  "ZION INSTITUTE OF NURSING",
  "Dera Natung Government College, Itanagar",
  "Jawaharlal Nehru College Pasighat",
  "Neelam Taram Government College, Yachuli",
  "Dorjee Khandu Government College Tawang.",
  "GOVERNMENT NURSING COLLEGE, PASIGHAT",
  "VIVEKANANDA KENDRA COLLEGE OF TEACHER EDUCATION",
  "Government College, Bomdila",
  "Don Bosco College, Juli, Itanagar",
  "Arunachal Law Academy",
  "Indira Gandhi Government College, Tezu",
  "Rang Frah Government College, Changlang",
  "Arunachal Community College of Health Sciences",
  "Government College Seppa",
  "Kasturba Gandhi Institue of Higher Education",
  "Donyi Polo Government College, Kamki",
  "St. Francis De Sales College, Aalo",
  "GOVERNMENT MODEL COLLEGE, GEKU",
  "MUDO TAMO MEMORIAL COLLEGE, ZIRO",
  "MAHABODHI LORD BUDDHA COLLEGE",
  "SIANG ROYAL ACADEMY, PASIGHAT",
  "Namdapha Degree College",
  "Government women college, NAHARLAGUN",
  "NORTH EASTERN INSTITUTE OF AYURVEDA AND FOLK MEDICINE RESEARCH    ",
  "RASHTRIYA RAKSHA UNIVERSITY REGIONAL CAMPUS",
  "GOVERNMENT COLLEGE, DAPORIJO",
  "GOVERNMENT COLLEGE, DOIMUKH",
  "TT COLLEGE, AALO",
  "Dikhowmukh College P.O. Dikhowmukh",
  "Furkating College P.O. Furkating- 785610",
  "D.H.S.K. Commerce College P.O Dibrugarh-786001",
  "N.N.Saikia College P.O. Titabor-785630",
  "MONMOHAN GHOSH ANIL DAS MEMORIAL COLLEGE ",
  "INSTITUTE OF MEDICAL & ALLIED HEALTH SCIENCES, GUWAHATI",
  "HILLS DEGREE COLLEGE",
  "LAHOWAL COLLEGE",
  "RAMANUJ GUPTA DEGREE COLLEGE ",
  "DON BOSCO COLLEGE GOLAGHAT",
  "HAM AK RURAL COLLEGE OF EDUCATION",
  "AYUSH PHARMACY INSTITUTE",
  "HAYAT INSTITUTE OF NURSING EDUCATION, HINE",
  "Parijat Academy Teacher Education Institute. P.O.Dibrugarh",
  "GEA NATIONAL COLLEGE",
  "NALBARI MEDICAL COLLEGE, NALBARI",
  "Nehru College",
  "NC Paul Memorial College",
  "NETES INSTITUTE OF TECHNOLOGY AND SCIENCE",
  "Pragjyotish College",
  "DHARMASALA COLLEGE ",
  "Mariani College P.O. Marioni--785634",
  "Lanka Mahavidyalaya",
  "Howragath College",
  "INSTITUTE OF PHARMACY, ASSAM MEDICAL COLLEGE, DIBRUGARH",
  "South Salmara College",
  "SJN HOMOEOPATHIC MEDICAL COLLEGE, GUWAHATI, PANJABARI",
  "INSTITUTE OF PARAMEDICAL SCIENCES, DIBRUGARH",
  "Tihu College",
  "Haflong Govt College",
  "Indian Yoga Culture and Yoga Therapy Centre",
  "Rampur Anchalik College",
  "Bengtol College",
  "DR SARVEPOLLI RADHAKRISHNNAN TEACHERS TRAINING & RESEARCH INSTITUTE",
  "Govt. College of Teacher Education, Kokrajhar",
  "Bihpuria College P.O. Bihpuria-784161",
  "Doom Dooma College ",
  "Huda Group of Institutions",
  "H.C.D.G. College P.O. Nitaipukhuri-785671",
  "JORHAT INSTITUTE OF NURSING",
  "Dr. Nobin  Bordoloi College P.O. Na-Ali ,Dhekiajuli",
  "L.C. Bharali College",
  "Government Dental College Dibrugarh",
  "Pub Majuli College P.O. Majuli",
  "Silchar Medical College",
  "Krishna Bora B.Ed. College",
  "Govt. B.T. College,Goalpara",
  "College of Education,Nagaon",
  "Tengakhat College P.O. Tenghat-786103",
  "Kamarbandha College P.O. Kamarbandha-785625",
  "Jonai Girls College P.O. Jonai",
  "Patherkandi College of Education",
  "D.H.S.K. College. P.O.Dibrugarh- 786001",
  "Guwahati College",
  "NEF COLLEGE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
  "NEF COLLEGE OF HEALTH SCIENCES",
  "GOVT MODEL WOMEN COLLEGE, CHENGA",
  "Amguri College P.O. Amguri-785680",
  "GOVT MODEL DEGREE COLLEGE, BAGHBAR",
  "Barpeta Girl's College",
  "MIRZA INSTITUTE OF NURSING AND HEALTH SCIENCES",
  "Samaguri College",
  "NATIONAL FORENSIC SCIENCES UNIVERSITY GUWAHATI CAMPUS",
  "Lakhimpur College of Veterinary Science",
  "J.B. Law College",
  "College of Teacher Education Dhakuakhana",
  "SWAGAT ACADEMY OF MEDICAL SCIENCES, GUWAHATI",
  "Eastern Karbi Anglong College",
  "Satya Ranjan College",
  "A.K.Chanda Law College",
  "J.N.Singh College",
  "Diphu Govt College",
  "Women's College,Silchar",
  "Karimganj College",
  "Hailakandi Women's College",
  "A.L.Choudhury College",
  "T.T. College",
  "Karimganj Law College",
  "M.K.Dey College",
  "Dispur Nursing Institute",
  "Janata College",
  "Bhergaon College",
  "NERIM LAW COLLEGE    ",
  "Ghana Kanta Borah College P.O.Tamulichiga",
  "RAHMAN HOSPITALS COLLEGE OF NURSING(Under Rahman Institute of Nursing and Paramedical Sciences)",
  "Regional College of Nursing",
  "Rahman Institute of Pharmaceutical Sciences and Research",
  "Fakhruddin Ali Ahmed Medical College",
  "GOVERNMENT MODEL DEGREE COLLEGE, DIBLONG, DIMA HASAO    ",
  "PANDIT DEENDAYAL UPADHYAYA ADARSHA MAHAVIDYALAYA DALGAON ",
  "Barpathar College P.O.Barpathar-785602",
  "Sonapur College",
  "ALLAMA TR COLLEGE OF PHARMACY",
  "Nalbari College ",
  "Thamna anchalik Degree College",
  "Gossaigaon B.Ed. College",
  "B Borooah College",
  "Biswanath College of Edu.",
  "Govt. Bani kanta College Teachers Edu.",
  "Arya Vidyapeeth College",
  "Birjhora Kanya Mahavidyalaya",
  "Ghanakanta Baruah College",
  "T.H.B. College",
  "Milanjyoti College",
  "Raha College",
  "Girl's College, Kokrajhar",
  "Mayang Anchalik College",
  "Scholar's Institute of Technology & Management",
  "R.C. Saharia T.T. College",
  "Goalpara Law College",
  "Barpeta Bongaigaon College",
  "Sipajhar College",
  "Bajali T.T.College",
  "TINSUKIA MEDICAL COLLEGE AND HOSPITAL    ",
  "JETTWINGS BUSINESS SCHOOL    ",
  "Damdama College",
  "Swami Vivekananda College",
  "Bamundi Mahavidyalaya",
  "Nonoi College",
  "Barnagar College",
  "P.B. College",
  "College of Education, Morigaon",
  "Dakshin Kamrup Girls' College",
  "State College of Music",
  "Mandia Anchalik College",
  "Binandi Chandra Medhi College",
  "Hari Gayatri Das College",
  "Paschim Jonai College P.O. Dekapam Dist. Dhemaji Pin. 787061",
  "PADMANATH GOHAIN BARUAH GOVERNMENT MODEL COLLEGE",
  "Abhayapuri College",
  "NEPEDS COLLEGE OF PHARMACEUTICAL SCIENCES",
  "BRAHMAPUTRA COLLEGES",
  "REIMALIE ACADEMY COLLEGE B ED BIJNI",
  "REGIONAL COLLEGE OF PHARMACEUTICAL SCIENCES",
  "INSTITUTE OF PARAMEDICAL AND MANAGEMENT TECHNOLOGY",
  "KHERKATA COLLEGE",
  "BORDOIBAM NCD DEGREE COLLEGE",
  "BIR LACHIT BORPHUKAN COLLEGE, SIVASAGAR",
  "Jaleswar College , Tapoban",
  "Patsaku College P.O. Patsaku",
  "Moran College P.O. Moran-785670",
  "Harhi College P.O. Harhi, Dhakuakhana",
  "Tingkhong College P.O Tingkhong- 786612",
  "Pub-Dikrong College P.O.Lahalial 784161",
  "Nowboicha College P.O.Doolahat-787027",
  "Sankardev Mahavidiyalaya P.O.Pathalipahar-784163",
  "BORGAON NAHARBARI DEGREE COLLEGE",
  "LOKPRIYA GIRLS COLLEGE, KALGACHIA",
  "GURU SANKAR NANAK COLLEGE",
  "CHANDRAPUR COLLEGE,CHANDRAPUR,GUWAHATI",
  "United Tribal Degree College,P.O.Bilmukh, Dist.Lakhimpur",
  "Bapujee College",
  "Behali Degree College",
  "College of Edu. Christianbasti",
  "GOALPARA  PHARMACY  INSTITUTE",
  "NORTH EASTERN REGIONAL INSTITUTE OF WATER AND LAND MANAGEMENT",
  "SIPE LAW COLLEGE",
  "Dhubri Law College",
  "Vidya Bharati College",
  "Madhab Choudhury College",
  "DON BOSCO COLLEGE DIPHU",
  "ASHRIKA REDUWAN B ED COLLEGE",
  "PRANAB JUBILEE COLLEGE",
  "North East Regional Centre, Tepesia Sports Complex, Sonapur, Guwahati",
  "West Guwahati College of Edu.",
  "North Gauhati College",
  "Bhawanipur Anchalik College",
  "K.C. Das Commerce College",
  "Mangaldai Law College",
  "K.R.D. College of Education",
  "Baihata Charili B.Ed. College",
  "Ratnapith College",
  "Srimanta Sankar Madhab Mahavidyalaya",
  "PANDIT DEENDAYAL UPADHYAYA GOVT MODEL COLLEGE",
  "Manabendra Sarma Girl's  College",
  "Debraj Roy College Autonomous",
  "FAKHRUDDIN ALI AHMED DEGREE COLLEGE",
  "Nagaon G.N.D.G. Commerce College",
  "Kampur College",
  "S.B.M.S. College",
  "Kayakuchi College",
  "Khagarijan College",
  "Batadraba Sri Sri Sankardev College",
  "Demow Chariali College P.O.Demow Chariali",
  "Rajiv Gandhi Memorial College",
  "SUKU RAM BHARALI COMMERCE AND MANAGEMENT COLLEGE",
  "West Guwahati Commerce College",
  "Apollo College of Nursing",
  "Bordoloni Central College P.O. Bordoloni Tin Ali",
  "NATIONAL COLLEGE OF EDUCATION",
  "Gauhati University Law College",
  "Gossaigaon College, Gossaigaon",
  "SANKOSH DEGREE COLLEGE GOSSAIGAON",
  "AUXILIUM COLLEGE, UDALGURI",
  "Morigaon Law College",
  "Pune Institute of Business Management Guwahati Campus",
  "Geleky Colege P.O. Galeky",
  "Cachar College",
  "Barak Valley Engineering College",
  "CRESCENT INSTITUTE OF PHARMACY",
  "Diphu Girls College",
  "Maibang Degree College",
  "SANKARDEV SHIKSHA NIKETAN, GOHPUR",
  "L.G.B. Girl's College",
  "Moirabari College",
  "Barkhola College",
  "GNRC Institute of Nursing Education",
  "Assam Medical College P.O. Dibrugarh- 786003",
  "Jagiroad College",
  "Rangapara College",
  "Nilambazar College",
  "Bodofa U.N. Brahma College",
  "West Goalpara College",
  "Pandu College",
  "GOVT COLLEGE OF ART AND CRAFTS, ASSAM",
  "PRATIKSHA INSTITUTE OF ALLIED HEALTH SCIENCES",
  "Saraighat College",
  "Army Institute of Nursing",
  "Radhamadhab College",
  "Dr. B. Borooah Cancer Institute",
  "Gauhati Medical College",
  "Purbanchal educational welfare Societys (PEWS) College of Physiotherapy and Medical Sciences",
  "Regional Dental College",
  "B.P. Chaliha College",
  "INSTITUTE OF PARAMEDICAL SCIENCES, SILCHAR",
  "INSTITUTE OF PHARMACY, SILCHAR",
  "DISPUR PARAMEDICAL AND NURSING INSTITUTE",
  "PEWS COLLEGE OF PARAMEDICAL SCIENCES",
  "TEZPUR MEDICAL COLLEGE AND HOSPITAL",
  "Nabinchandra College, Badarpur",
  "Mangaldai Commerce College",
  "INSTITUTE OF PARAMEDICAL SCIENCES, ATTACHED TO GAUHATI MEDICAL COLLEGE, GUWAHATI",
  "Mankachar College",
  "MARYAM AJMAL WOMENs COLLEGE OF SCIENCE AND TECHNOLOGY",
  "Paschim Barigog Anchalik Mahavidyalaya",
  "Indira Gandhi College",
  "Nirmal Haloi College",
  "Patharkandi College",
  "J.N. College",
  "Dhubri Girl's College",
  "Sipajhar B.Ed.",
  " K.K. Handique Govt Sanskrit College",
  "Mahatma Gandhi College",
  "J B COLLEGE OF HEALTH SCIENCES",
  "F.A. Ahmed College",
  "BISWANATH COMMERCE COLLEGE",
  "Jhanji Hemnath Sarma College ",
  "Moinul Hoque Choudhury Memorial Science College",
  "Alamganj Rangamati College",
  "AJMAL LAW COLLEGE HOJAI",
  "GOBINDA BASUMATARY COLLEGE JARAGURI",
  "Vivekananda College of Education",
  "ASSAM INSTITUTE OF MASS COMMUNICATION AND MEDIA RESEARCH",
  "N.E.F. Law College",
  "Pub-Bongsor College",
  "Narangi Anchalik Mahavidyalaya",
  " KANPAI BORDOLOI COLLEGE",
  "BURHINAGAR DEGREE COLLEGE",
  "Madhab Chandra Das College",
  "DEBABRAT BHUYAN COLLEGE",
  "Gauhati Commerce College",
  "Kalabari College",
  "Purbanchal College, Silapathar",
  "Pratiksha Institute of Pharmaceutical Sciences",
  "Guwahati College of Architecture",
  "ATAUR RAHMAN COLLEGE OF EDUCATION, UDMARI.",
  "Halakura College",
  "Bilasipara College",
  "College of Veterinary Science",
  "Bongaigaon College",
  "ANUNDORAM BOROOAH ACADEMY DEGREE COLLEGE, PATHSALA",
  "Dispur College",
  "Lalit Jain Commerce College",
  "J.B.Hagjer Degree College",
  "BOSCO INSTITUTE",
  "S.K.Roy Memorial ins.of Education",
  "PRATIKSHA COLLEGE OF NURSING",
  "Juria College,PO, Fakuli Pather, Nagaon, Assam",
  "Dr.S.P.M College of Education",
  "Biswanath College of Agriculture",
  "Rukasen College",
  "North Kamrup College",
  "Deomornoi Degree College",
  "S.S.College",
  "Kapili College",
  "West Silchar College",
  "Bikali College",
  "Goreswar College",
  "Barbhag College",
  "Barpeta B.T. College",
  "GOVERNMENT MODEL COLLEGE, KAZIRANGA",
  "Salbari College",
  "Majuli College P.O. Majuli",
  "Mushalpur College",
  "Murazar College",
  "MANGALDAI DEGREE GIRLS COLLEGE",
  "GOVERNMENT DENTAL COLLEGE SILCHAR",
  "SIKDER COLLEGE OF PHARMACY",
  "SC Dey College",
  "BAIDA COLLEGE BAIDA",
  "B.B. Kishan College",
  "DALGAON ADARSHA DEGREE COLLEGE",
  "GUWAHATI INSTITUTE OF FASHION TECHNOLOGY",
  "Barama College",
  "Silapathar Town College P.O.Silapathar- 787059",
  "Silchar College Singari",
  "Khoirabari College",
  "Diphu B.Ed College",
  "Kalaguru Bishnu Rabha Degree College",
  "U. N. Brahma College",
  "Icon Commerce College",
  "Lumding College",
  "Bijni College",
  "Margherita College ",
  "Basugaon College",
  "Swami Yogananda Giri College",
  "Barpeta Law College",
  "Kamargaon College",
  "Science College, Kokrajhar",
  "Kokrajhar Govt. College",
  "Janata College",
  "Fakiragram College",
  "KHAIRUN NESSA BEGUM WOMENS COLLEGE",
  "Kaliabor College",
  "Commerce College, Kokrajhar",
  "C.K.B. College P.O. Teok--785112",
  "Dr. R. K. B. Law College Dibruharh",
  "Chilarai College",
  "Kulajan College P.O.Kulajan Tinali",
  "GOVERNMENT NURSING COLLEGE, JORHAT",
  "Jonai Science College P.O. Jonai Dist. Dhemaji Pin. 787060",
  "Pub-Kamrup College",
  "G.S.Lohia College",
  "Kakojan College P.O. Kakojan--785107",
  "Pithubar College, Khowang",
  "Nowgong Law College",
  "G.L. Choudhury College",
  "S.P.P.College P.O. Namtichariali--785684",
  "Hatidhura College",
  "Simen Chapari College",
  "GOVT MODEL WOMEN COLLEGE, BILASIPARA    ",
  "Jiadhal College. Dhemaji",
  "Sarupathar College P.O. Sarupathar-785601",
  "R.G. Baruah College",
  "Dalgoma Anchalik College",
  "KBM College of Teacher Education. Jorhat",
  "Sibsagar Commerce College P.O. Sibsagar-- 785640",
  "Dhemaji Girls College P.O. Dhemaji- 787057",
  "Don Bosco College",
  "T.T. College",
  "Udali College",
  "Army Institute of Nursing Guwahati ",
  "B.N. College Autonomous",
  "ASSAM OIL COLLEGE OF NURSING",
  "DUNI DEGREE COLLEGE",
  "DEOPANI COLLEGE",
  "Swahid Smriti Mahavidyalaya",
  "Tinsukia Commerce College P.O.Tinsukia-786125",
  "Sontali Anchalik College",
  "SM Dev College",
  "GOVERNMENT MODEL COLLGE DEITHOR KARBI ANGLONG",
  "Kharupetia College",
  "Mazbat College",
  "Kaliabor College of Education",
  "Thong Nokbe College",
  "NERIM COMMERCE COLLEGE    ",
  "Agia College",
  "Bokajan College",
  "Manohari Devi Kanoi Girls' College, Dibrugarh",
  "Borhat Bhabani Prasad Baruah Memorial College P.O.Borhat",
  "Ujani Majuli Kherkatia College ",
  "KALAIGAON COLLEGE, KALAIGAON",
  "Suren Das College",
  "Kanya Mahavidyalaya",
  "S.K.Roy College",
  "KACHUA TINIALI COLLEGE",
  "Runikhata  College, Runikhata",
  "Madhya Kamrup College",
  "Gurucharan.College",
  "ZAMDUAR COLLEGE, SARAIBIL",
  "NILACHAL COLLEGE OF ALLIED HEALTH SCIENCES",
  "College of Nursing, NEMCARE Foundation",
  "BOROBAZAR COLLEGE",
  "TAMULPUR DEGREE COLLEGE",
  "ST. ANN S COLLEGE",
  "Asian Institute of Nursing Education",
  "BASKA DEGREE COLLEGE",
  "Gurudev Kalicharan Brahma College, Tipkai ",
  "Tupamari Anchalik College",
  "Government Ayurvedic College",
  "Nowgong College",
  "MEHTAB JAMAL B ED COLLEGE KAYAKUCHI BARPETA ASSAM",
  "COMPOSITE REGIONAL CENTRE GUWAHATI",
  "SEMSON SING ENGTI COLLEGE",
  "BRAHMAPUTRA COLLEGE",
  "PG Training College P.O. Jorhat -785001",
  "NEF College of Pharmacy",
  "MARWARI HOSPITALS PARAMEDICAL INSTITUTE",
  "Gyanpeeth Degree College",
  "DHEMAJI LAW COLLEGE",
  "PANDIT DEENDAYAL UPADHYAYA ADARSHA MAHAVIDYALAYA, TULUNGIA",
  "AADITYA COLLEGE OF PHYSIOTHERAPY AND HEALTH SCIENCES",
  "Bongaigaon Law College",
  "Shikshan Mahavidyalaya",
  "Biswanath College",
  "SWADESI COLLEGE OF COMMERCE",
  "NATIONAL INSTITUTE OF PUBLIC COOPERATION AND CHILD DEVELOPMENT, REGIONAL CENTRE, GUWAHATI",
  "Silchar College of Education",
  "R.K.Nagar College",
  "Golaghat Purbanchalik College. Hatiyekhowa Golaghat",
  "Barkhetri College",
  "Jamunamukh College",
  "AMIYA BHARALI NURSING INSTITUTE",
  "Lakhimpur Post Graduate Training College . Lakhimpur",
  "NETES Institute of Pharmaceutical Science (NIPS)",
  "Jengraimukh College ",
  "Golaghat Commerce College P.O. Golaghat- 785621",
  "BHASWATI DEB MEMORIAL CENTRE FOR HIGHER EDUCATION",
  "HITESWAR SAIKIA PARAMEDICAL COLLEGE",
  "ST MARTHA INSTITUTE OF NURSING",
  "Nazir Ajmal Memorial College of Education",
  "Harendra Chitra College",
  "Namrup College P.O.Namrup-786623",
  "HEALTH CITY INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "NATIONAL INSTITUTE OF ELECTRONICS AND INFORMATION TECHNOLOGY GUWAHATI",
  "NEF COLLEGE",
  "Chhaygaon College",
  "College of Fisheries Science",
  "Rangia T.T. College",
  "Darrang College",
  "Assam Engineering College",
  "GOVT MODEL COLLEGE BORKHOLA",
  "Tamulpur College",
  "ASIAN MISSION INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "L.T. K College P.O. Azad-787001",
  "Dergaon Kamal Dowerah College ",
  "NEF College of Management and Technology",
  "Sarbodhya College P.O. Sarbodhya",
  "Duliajan College, Duliajan P.O.Duliajan- 786602",
  "Sarat Chandra Singha College of Agriculture",
  "Silapathar Collge. P.O. Silapathar-787058",
  "Sibsagar College P.O. Sibsagar-785665",
  "Bahona College P.O. Bahona",
  "Silapathar Science College P.O. Silapathar",
  "Laimekuri College P.O. Laimekuri, Jonai Dist. Dhemaji Pin. 787060",
  "Golaghat Law College P.O. Golaghat-785621",
  "Sibsagar Girls College P.O.Sibsagar-785640",
  "Kherajkhat College. P.O. Bhugpur Chariali",
  "Jorhat College P.O. Jorhat-785001",
  "Khowang College P.O. Khowang-785676",
  "Kokrajhar Law College",
  "Mangaldai Govt. T.T. College",
  "Dispur Law College",
  "Dhemaji College P.O. Dhemaji-787057",
  "Lakhimpur Kendriya Mahavidiyalaya. Lakhimpur--787001",
  "CPMS COLLEGE OF NURSING, GUWAHATI",
  "JORHAT MEDICAL COLLEGE, JORHAT",
  "Duliajan Girls College P.O.Duliajan-786602",
  "Laluk College P.O.Laluk-784160",
  "Kaliganj Pioneer College",
  "Tinsukia Law College. Tinsukia",
  "Chatia College",
  "SRI SANKARADEVA NETHRALAYA, GUWAHATI",
  "INSTITUTE OF PHARMACY, GAUHATI MEDICAL COLLEGE, GUWAHATI",
  "Asom Sattriya Sangit Mahavidyalaya. Jorhat",
  "BINESWAR BRAHMA ENGINEERING COLLEGE",
  "RIDLEY COLLEGE OF OPTOMETRY, JORHAT",
  "S.B. Deorah College",
  "B SC NURSING COLLEGE, DIBRUGARH",
  "B SC NURSING COLLEGE, SILCHAR",
  "LANGHIN COLLEGE,LANGHIN",
  "BIR RAGHAB MORAN GOVERNMENT MODEL COLLEGE DOOMDOOMA",
  "ST XAVIER'S COLLEGE, TEZPUR",
  "DIPHU LAW COLLEGE, DIPHU",
  "Barpeta Road Howli College",
  "Borholla College P.O. Borholla-785631 District- Jorhat",
  "Tulshibil Degree College",
  "Habraghat Mahavidyalaya",
  "Sapekhati College P.O. Sapekhati-785692",
  "Moran Mahila Mahavidyalaya ",
  "PGT College Dhemaji P.O. Dhemaji-787057",
  "ROWTA DEGREE COLLEGE",
  "SHIFA PHARMACIST INSTITUTE",
  "Lala Rural College",
  "Mangaldai College",
  "HARLONGBI VELONGBI COLLEGE",
  "INDIAN STATISTICAL INSTITUTE, TEZPUR",
  "BEZARA ANCHALIK COLLEGE",
  "Pandit Deendayal Upadhyaya Adarsha Mahavidyalya, Amjonga",
  "GOVERNMENT MODEL COLLEGE, BAKSA",
  "Panigaon Om Prakash Dinodia College",
  "North Bank College P.O.Ghilamora-787053",
  "MISSAMARI COLLEGE",
  "Naharkatiya College. Naharkatiya",
  "SCHOOL OF PHARMACEUTICAL SCIENCE AND TECHNOLOGY",
  "Dhing College",
  "DONA INTERNATIONAL INSTITUTE OF ASSAM",
  "Chunari College",
  "C K COLLEGE",
  "Madhya Kampeeth College",
  "U N Academy, Kokrajhar",
  "Moridhal College P.O. Moridhal-787057",
  "Marangi Mahavidyalaya P.O.Lettekujan",
  "Moran Commerce College P.O.Moran-785670",
  "DAFFODIL COLLEGE OF AGRICULTURE AND TECHNOLOGY",
  "Jorhat Kendriya Mahavidyalaya,Kenduguri, P.O. Jorhat-785001",
  "C T College",
  "WAISONG COLLEGE, HAMREN",
  "Machkhowa Degree College P.O. Machkhowa-787058",
  "Pitambordev Goswami College P.O. Garamur Satra, Majuli Dist. Jorhat. Pin. 785104",
  "Alhaz Sunai Bibi Choudhury College",
  "CNB College P.O. Bokakhat- 785612",
  "Sonari Commerce College P.O. Sonari-785690",
  "Rangsina College",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING HAILAKANDI",
  "Pandit Deendayal Upadhyaya Adarsha Mahavidyalaya Behali",
  "G C PAUL COLLEGE OF EDUCATION",
  "Janapriya College",
  "Pandit Deendayal Upadhyaya Adarsha Mahavidyalaya Eraligool Karimganj ",
  "H.P.B.Girls College. Golaghat",
  "Paschim Dhemaji College P.O.Ghuguha Dol, Dhemaji",
  "Jorhat Institue of Science and Technology P.O. Chenijan-785010",
  "Ledo College. Ledo. Tinsukia",
  "Haji Anfor Ali College",
  "Nazira College P.O. Nazira-785685",
  "Janata Mahavidyalaya P.O.Borguri. Tinsukia",
  "J.B. College P.O. Jorhat-785001",
  "Subansiri College P.O. Pathalipam",
  "Namrup College of Teacher Education. Namrup-78662",
  "North Lakhimpur College (Autonomous)",
  "Murkong Selek College P.O. Jonai-- 787060",
  "Miry Jiory College P.O. Ghunasuti Dist. Lakhimpur Pin. 781001",
  "Digboi College P.O. Digboi-786171",
  "DHUBRI MEDICAL COLLEGE, DHUBRI",
  "Rengam Subansiri College P.O. Patrichuk,Lakhimpur",
  "Melamora College P.O. Melamora-785625",
  "Gargaon College P.O. Gargaon- 785686",
  "Sissiborgaon College P.O. Sissiborgaon",
  "Telahi Tuaram Nath College P.O.Lakhimpur",
  "Lakhimpur Girls' College ",
  "Abhiruchi Institute of Physical Education",
  "Cinnamara College P.O. Cinnamara-785008",
  "ASIAN INSTITUTE OF PARAMEDICAL SCIENCES, GUWAHATI",
  "North East Institute of Management Science. P.O. Jorhat",
  "Brahmaputra Degree College. P.O.Bokulguri",
  "Dhakuakhana College P.O. Dhakuakhana-787055",
  "Digboi Mahila Mahavidyalaya P.O. Digboi-786171",
  "Dr. Anita Baruah Sarma College of Education",
  "GOVERNMENT NURSING COLLEGE , KOKRAJHAR",
  "NAGAON MEDICAL COLLEGE AND HOSPITAL ",
  "Womens College Tinsukia P.O. Tinsukia-786125",
  "Mahendra Narayan Choudhury Balika Mahavidyalaya",
  "Nandalal Borghoain City College P.O.Dibrugarh",
  "Jorhat Engineering College P.O. Jorhat-785007",
  "CHANDRAKANTA HAZARIKA BED COLLEGE",
  "SHREEBHARATI COLLEGE",
  "INDRESWAR SARMA ACADEMY DEGREE COLLEGE",
  "ASSAM PARAMEDICAL INSTITUTE ",
  "INSTITUTE OF STRATEGIC BUSINESS MANAGEMENT",
  "C.G PURBANCHAL COLLEGE",
  "ASSAM PHARMACY INSTITUTE ",
  "Jorhat Law College P.O. Jorhat",
  "Udalguri College",
  "J.D.S.G.College P.O. Bokakhat-785612",
  "College of Teacher Education P.O.Tulsiram Road Tinsukia-786125",
  "Sadiya College ",
  "North Lakhimpur Law College. North Lakhimpur",
  "D.H.S.K. Law College P.O.Dibrugarh--786001",
  "Dhemaji Commerce College P.O. Dhemaji-787057",
  "Chandra Kamal Bezbaruah Commerce College",
  "Tinsukia College P.O. Tinsukia-786125",
  "GIRIJANANDA CHOWDHURY INSTITUTE OF PHARMACEUTICAL SCIENCE TEZPUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KARBI ANGLONG DIPHU",
  "PRAGJYOTISH BED COLLEGE PACHARIA .",
  "Gogamukh College P.O. Gogamukh-787029",
  "Regional College of Paramedical Health Sciences, Guwahati",
  "DIPHU MEDICAL COLLEGE AND HOSPITAL",
  "Barnagar B.Ed. College",
  "Rangia College",
  "GOLAGHAT ENGINEERING COLLEGE",
  "REGIONAL COLLEGE OF HEALTH SCIENCES",
  "KOKRAJHAR MEDICAL COLLEGE AND HOSPITAL, KOKRAJHAR",
  "National Institute for Teacher Education",
  "Nalbari Comm. College",
  "Tezpur College",
  "Koklabari Chapaguri College",
  "Joya Gogoi College P.O. Khumtai",
  "Tezpur Law College",
  "GLOBAL INSTITUTE",
  "Sonari College P.O. Sonari-785690",
  "HITENDRA NATH MUSHAHARY COLLEGE",
  "LAKHIMPUR MEDICAL COLLEGE",
  "GOVERNMENT MODEL COLLEGE BALIPARA",
  "Navasakti College",
  "Paschim Guwahati Mahavidyalaya",
  "Rangachachi College P.O. Majuli",
  "Katigorah A Degree College",
  "Manikpur Anchalik College",
  "Dakshin Bijni Degree College",
  "Mahamaya Degree College",
  "Haji Ajmal Ali College",
  "Goalpara College",
  "DHEMAJI ENGINEERING COLLEGE",
  "DAFFODIL COLLEGE OF HORTICULTURE",
  "Dr. B.K.B. College",
  "Dudhnoi College",
  "Deomornoi B.Ed. College",
  "BRIGHT FUTURE MODEL COLLEGE",
  "L.G.B. Regional Institute of Mental Health,",
  "Dhamdhama Anchalik College",
  "Bhuragaon College",
  "Bongaigaon B.Ed. College",
  "Dibru College",
  "Hojai Girl's College",
  "Birjhora Mahavidyalaya",
  "Kokrajhar Music  and  Fine Arts College",
  "S.D.P. College of Teachers Education",
  "Asian Institute of Management and Technology",
  "Progati College",
  "Tata Institute of Social Sciences Guwahati Campus",
  "Kamrup College",
  "Katahguri College",
  "Dimoria College ,Khetri",
  "Hamidabad College",
  "NORTH EASTERN REGIONAL INSTITUTE OF MANAGEMENT(NERIM)",
  "D.C.B. Girls College P.O. Jorhat-785001",
  "Dr. S.B. Institution of Education",
  "D.D.R. College P.O. Chabua-786184",
  "Nowgong Girls' College",
  "K.R.B. Girls' College",
  "Lakhipur College",
  "Makum College Makum Junction Tinsukia",
  "Rabindrasadan Girls' college",
  "Handique Girl's College",
  "Uttar Kampith Mahavidyalaya",
  "Hatsingimari College",
  "Dhubri P.G.T.T. College",
  "Nabajyoti College",
  "BRM Govt.Law College",
  "Paneri College, Paneri",
  "DIMAKUCHI COLLEGE",
  "LACHIT BARPHOOKAN COMMERCE ACADEMY",
  "LAHARIGHAT COLLEGE",
  "S K HAZARIKA COLLEGE",
  "PROVINCE COLLEGE",
  "Tangla College",
  "B M B B COMMERCE COLLEGE",
  "College of Teacher Education P.O Golaghat",
  "Arya Nursing College",
  "Uttar Barpeta College",
  "Beltola College",
  "Anandaram Dhekial Phookan College",
  "Dronacharya Academy",
  "Morigaon College",
  "Patidarrang College",
  "Chaiduar College",
  "M K GANDHI COLLEGE",
  "PGT College ,Bihpuria Lakhimpur-784161",
  "Karmashree Hiteswar Saikia College",
  "Rupahi College",
  "Govt. College of Teacher's Edu.",
  "Dakshin Guwahati B.Ed. College",
  "Asom Sikshak Prasikshan Mahavidyalaya",
  "S  R  ACADEMY",
  "B.H.B. College",
  "Demow College P.O. Demow- 785662",
  "Nakachari College P.O. Nakachari",
  "Assam Brilliant Academy",
  "Kaziranga College",
  "Swahid Sowarani College, Bamunbori.",
  "Baosi Banikanta Kakati College, Nagoan",
  "Aronai College",
  "GOALPARA GIRLS COLLEGE",
  "Chhamaria Anchalik College",
  "Sapatgram College",
  "Nalbari Law College",
  "Lokanayak Omeo Kumar Das College",
  "Hatichong College",
  "Luitparia College",
  "Charaibahi College",
  "S.M.D. College,Charing  P.O. Charing-- 785661",
  "Dakshin Kamrup College",
  "Puthimari College",
  "College of Ed. Boko",
  "Lakhimpur Commerce College. Lakhimpur",
  "Adinath Parash Mani Skt. College, Rahua Sangram, Madhubani",
  "NARDIGANJ COLLEGE NARDIGANJ",
  "K.S.T. College, Sohsarai",
  "S,N.M.R.Skt.College,Basaunakala",
  "L.N.R. Sanskrit College, Jaideopatti, Darbhanga",
  "Ramautar Goutam Sanskrit College, Ahilya Asthan,",
  "Women's College",
  "MAHARANI KALYANI COLLEGE",
  "M.M.T. College",
  "C. M. Sc. College",
  "D.N.Y. College",
  "Chandradeo Narain College, Sahebganj, Muzaffarpur",
  "L.C.S College",
  "G.K.P.D. College",
  "M.K.S. College",
  "G.B.M.College",
  "Millat Teachers' Training College",
  "Janta Degree College, Korthu",
  "RAJMUNI DEVI B.Ed. COLLEGE ",
  "Samastipur College",
  "Sant Kabir College",
  "J.N. College",
  "MOTHER TERESSA MANAGEMENT COLLEGE",
  "Dr. Shree Krishna Sinha Women's College, Motihari",
  "Braj Mohan Das College, Dayalpur, Vaishali",
  "MITHILA T T COLLEGE BASUARA",
  "AL HASAN T T COLLEGE SAMASTIPUR",
  "Bibi Fatma Teachers' Training College",
  "SATYADEV MAHAVIDYALAYA GOURIPUR",
  "Millia Kaniz Fatma Womens Teachers Training College",
  "Rameshwar Singh College, Muzaffarpur",
  "Sri Laxmi Kishori College, Sitamarhi",
  "M.P.S. Sc. College, Muzaffarpur",
  "M.J.K. College, Bettiah",
  "Raj Narain College, Hajipur",
  "S.B. College, Ara",
  "Patel College,Ghusiakhurd, Bikramganj",
  "Rohtas Vidhi Mahavidyalaya, Sasaram",
  "T.S.I. Mahila College, Ara",
  "Jagjiwan College, Dehri-On-Sone",
  "Mahabodhi College",
  "BINDESHWARI DUBEY COLLEGE BIHIYA, BHOJPUR",
  "Shaheed Sanjay Singh  Mahila College, Bhabua, Kaimur",
  "DASHRATH PRASAD SINGH INSTITUTE OF HEALTH EDUCATION",
  "Bhupesh Gupta College, Bhabua, Kaimur",
  "Dharichanna kuri College, Dumraon",
  "Rohtas Mahila College, Sasaram",
  "HIMALAYA COLLEGE OF PROFESSIONAL EDUCATION",
  "KUSUMRAJ EDUCATIONAL INSTITUITION",
  "PATLIPUTRA COLLEGE OF PROFESSIONAL EDUCATION",
  "CHAMPARAN COLLEGE OF PROFESSIONAL EDUCATION",
  "MUZAFFARPUR HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "Shyamnandan Sahay Mahavidyalaya, Muzaffarpur",
  "R P S TEACHERS TRAINING COLLEGE ",
  "Islamia Degree College, Kanti, Muzaffarpur",
  "Nitishwar College, Muzaffarpur",
  "Khemchand Tarachand College, Raxaul",
  "R.D.S.College, Muzaffarpur",
  "Jang Bahadur Singh Dhanaur College, Bakuchi, Muzaffarpur",
  "R.B.B.M. College, Muzaffarpur",
  "L.S.College, Muzaffarpur",
  "Mandan Bharti Agricultural College, Agwanpur",
  "Bihar Agricultural College, Sabour",
  "College of Horticulture, Noorsarai",
  "G M COLLEGE OF PHARMACY",
  "Baidyanath Shukla College of Education",
  "S.J.M.S.V. T.T. College, Dalsingsarai",
  "YOGENDRA INSTITUTE OF NURSING TRAINING",
  "LORD BUDDHA KOSHI MEDICAL COLLEGE HOSPITAL, SAHARSA",
  "KENT HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "SRI BHAGWAT PRASAD SINGH MEMORIAL INSTITUTE OF HIGHER EDUCATION",
  "Bihar Institute Of Technology And Management",
  "Dr. K.K. Mandal Mahila College, Buxar",
  "PHALGUNI PRASAD YADAV COLLEGE CHAKAI, JAMUI",
  "BIHAR COLLEGE OF TEACHER EDUCATION",
  "R.B. College",
  "RAGHU SAROJ WELFARE AND CHARITABLE TRUST",
  "Puranmal Bajoria Teachers Training College",
  "BABA BHAGWAT RAI DEGREE MAHAVIDYALAY, TELHUA, NAUTAN, WEST CHAMPARAN",
  "B.N. College, Sobh",
  "Bhagwati Singh Memorial B.Ed. Mahavidlaya",
  "Sri Radha Krishna Goenka College, Sitamarhi",
  "Baba Bhutnath College, Bagaha",
  "Magadh Teachers Training College (CO-Ed.)",
  "B.B.M.B.G. Kanya Mahavidyalaya, Bihta",
  "DR YADUVIR SINHA HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "HARIHAR SANSKRIT MAHAVIDYALAYA  BAKULAHR MATH WEST CHAMPARAN",
  "RADIANT INSTITUTE OF NURSING",
  "J P COLLEGE OF NURSING",
  "DEO NAGINA TEACHER TRAINING COLLEGE",
  "PANDIT VEDANAND UMESH MISHRA RAMJANKI COLLEGE EVENING MAHUA",
  "V S GROUP OF COLLEGES",
  "SHAHEED PRAMOD NURSING INSTITUTE,MADHOPUR SUSTA,MUZAFFARPUR,BIHAR",
  "R G COLLEGE OF EDUCATION ",
  "RCH NURSING COLLEGE",
  "M.M. Mahila College, Bettiah",
  "Dr. Jagannath Mishra College, Muzaffarpur",
  "SUB DIVISIONAL GOVERNMENT DEGREE COLLEGE BENIPUR",
  "VEDANT INSTITUTE OF EDUCATION  AND TECHNOLOGY",
  "RAGHUNATH PANDEY MEMORIAL LAW COLLEGE",
  "Ramsewak Singh Mahila College, Sitamarhi",
  "RBTS GOVT HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL MUZAFFARPUR",
  "S M V D COLLEGE KALYANPUR EAST CHAMPARAN    ",
  "Jawahar Lal Nehru Memorial College, Sitamarhi",
  "A. College, Mahua",
  "Maxford Teachers Training College",
  "RAM BILAS SINGH RAMDAYAL ROY COLLEGE",
  "JANKI DEVI GAURISHANKAR SARAF DEGREE MAHILA MAHAVIDYALAY JAYNAGAR MADHUBANI",
  "Mundeshwari College For Teacher Education",
  "V. B. College of Education, Bhagalpur",
  "B. N. COLLEGE OF EDUCATION",
  "MILLIA INSTITUTE OF TECHNOLOGY",
  "SANT MAALIK MEMORIAL INSTITUTE",
  "Rashtrakavi Ramdhari Singh Dinkar College of Engineering",
  "BRILLIANT INSTITUTE OF EDUCATION",
  "MADHUBANI MEDICAL COLLEGE",
  "Patna Dental College",
  "JAJBA TEACHER TRAINING COLLEGE",
  "K.L.S.College,",
  "Dr. Ram Manohar Lohiya Smarak College, Muzaffarpur",
  "Pt. U.S.T.M. College, Bagaha",
  "College of Agricultural Engineering,Pusa",
  "R.S.S.Sc. College, Sitamarhi",
  "S.N.S. College, Hajipur",
  "Tirhut College of Agricultural ,Dholi",
  "College of Fisheries, Dholi",
  "Ram Krishna College",
  "MAA KAMLA CHANDRIKA JEE MANAGEMENT TRAINING INSITUTE",
  "SRI RAY BAHADUR RAMCHANDRA RAM LAXMI NARAYAN MANAGEMENT INSITUTE",
  "Sarswati Bilas Skt.College.Shokhara Barauni",
  "SAPTRISHI DEGREE COLLEGE, RAJAULI ,NAWADA",
  "M. P. College of Education, Chandni Chowk",
  "SHRI RAM NARAYAN COLLEGE",
  "PATNA HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "BABA HEERA SINGH DEEPA SINGH JEE PRIMARY TEACHERS TRAINING COLLEGE",
  "SABHAPATI MISHRA INSTITUTE OF EDUCATION",
  "SHAHEED PRAMOD BED COLLEGE ",
  "MATA MANJHARO AJAB DAYAL SINGH MAHAVIDYALAYA",
  "R P COLLEGE",
  "K.K.M. Sc. College, Daudnagar",
  "SURENDRA B Ed TEACHERS TRAINING COLLEGE",
  "SWAMI VIVEKANAND B.ED COLLEGE",
  "L.P.Sahi College",
  "Parmarth Institute of Teacher's Education",
  "LORD BUDDHA KOSHI NURSING SANSTHAN SAHARSA",
  "SIDHNATH MEERA COLLEGE OF HIGHER EDUCATION",
  "MAHABIR NURSING SCHOOL AND COLLEGE",
  "RAJEEV COLLEGE OF PHARMACY",
  "C.M. Sc. College, Madhepura",
  "Sheodeni Sao College, Kaler",
  "LEELAWATI COLLEGE",
  "ER UPENDRA SHARMA TEACHERS TRAINING COLLEGE ",
  "Wazirganj College, Gaya",
  "MSJ COLLEGE OF PROFESSIONAL EDUCATION",
  "MAGADH  PROFESSIONAL  INSTITUTE",
  "SWADESHI COLLEGE OF EDUCATION, PURNEA",
  "Purnea College, Purnia",
  "P.M.J. College, Ara",
  "SCHOOL OF PHARMACY, AL KARIM UNIVERSITY KATIHAR",
  "Mahanth Ram Jiwan Das College, Vishnupur, Begusarai",
  "ISHWAR SHANTI MAHAVIDYALAYA, NAUTAN, WEST CHAMPARAN",
  "ACHELAL SINGH ASARFI DEVI DEGREE MAHAVIDYALAYA, VAISHALI",
  "Sri Krishna Jublee Law College, Muzaffarpur",
  "IMPERIAL COLLEGE OF BUSINESS AND SCIENCE",
  "RAJAN MAMTA DEGREE COLLEGE",
  "A.B.R. College, Sasaram",
  "Ganga Global Institute of Teacher Education",
  "Government Pharmacy Institute",
  "Institute of Management and Planing and Advance Computer Training",
  "International School of Management",
  "Kamla Bhubneswer B. Ed. College",
  "Sri Krishna Medical College and Hospital",
  "Maitreya College of Education & Management",
  "St. Xavier's College of Management & Technology",
  "Veerayatan B.Ed. College",
  "Trident B.Ed. College",
  "RAMCHANDRA VIDYAPEETH",
  "DR RAM NARAYAN PRASAD COLLEGE ARWAL",
  "Satyendra Narain Sinha College, Tekari ",
  "BSC NURSING COLLEGE, GOVERNMENT MEDICAL COLLEGE AND HOSPITAL, SARAN,CHAPRA",
  "SATYAM INTERNATIONAL INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "RADHAKRISHNAN COLLEGE OF EDUCATION",
  "SANT TAPASVI NARAYAN DAS SHIKSHAN SANSTHAN",
  "R.N. Sah Sarvodaya College, Ganjbharsara",
  "M. S. INSTITUTE OF EDUCATION",
  "R.M. Devi C.D. Rai College, Nuwan, Kochas",
  "M.G. College, Leharabad",
  "S.S.B.M. College, Jagdishpur",
  "Al-hafeez College, Ara",
  "H.N.S.B. Janta College, Dhansoi",
  "Gorakh Singh College (B.Ed. Courses), Maharahganj",
  "Jehanabad College, Jehanabad",
  "KMD College, Parbatta",
  "KKM College, Jamui",
  "SSV College, Kahalgaon",
  "Munshi Singh College, Motihari",
  "MUZAFFARPUR COLLEGE OF PROFESSIONAL EDUCATION",
  "HIMALAYA COLLEGE OF PHARMACY",
  "MAHABODHI MAHAVIDYALAYA, NALANDA",
  "RUNGTA INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "SUBHADRA DEVI SCHOOL OF NURSING",
  "SHRI RAM INSTITUTE OF MEDICAL SCIENCES",
  "SARASWATI DEVI RAM SAGAR JHA COLLEGE OF PHARMACY",
  "R R P SCHOOL OF NURSING",
  "SUNDARAM INSTITUTE OF MEDICAL SCIENCE,PATNA",
  "Nalanda Medical College and Hospital",
  "A AND E COLLEGE OF PHARMACY",
  "SUNDARAM INSTITUTE OF NURSING TRAINING ",
  "SHIVAM COLLEGE OF HIGHER STUDIES (NURSING)",
  "Public Health Institute",
  "BSC NURSING COLLEGE, NMCH, PATNA",
  "YASHODANAND COLLEGE OF PHARMACY",
  "S A INSTITUE OF NURSING",
  "Nibha Institute of Pharmaceutical Sciences",
  "N P INSTITUTE OF PHARMACY",
  "COLLEGE OF PHARMACY",
  "BSC NURSING COLLEGE BMIMS PAWAPURI NALANDA",
  "TALUKA INSTITUTE OF NURSING",
  "JANNAYAK KARPURI THAKUR MEDICAL COLLEGE AND HOSPITAL MADHEPURA",
  "Shyamlal Chandrashekhar Nursing College",
  "SHYAMLAL CHANDRASHEKHAR PARAMEDICAL INSTITUTE",
  "Katihar Engineering College",
  "KATIHAR BSC NURSING COLLEGE",
  "JAMUI COLLEGE OF PHARMACY",
  "MAGADH PARAMEDICAL AND NURSING INSTITUTE",
  "VARMA COLLEGE OF NURSING AND PARAMEDICAL SCIENCE ANAITH ARA",
  "CHANAKYA COLLEGE OF PHARMACY AND MEDICAL SCIENCES",
  "Jawahar Lal Nehru Medical College & Hospital",
  "MODERN INSTITUTE OF PHARMACY",
  "PRIYADARSHINI NURSING INSTITUTE",
  "SRI SHRAVAN KUMAR B.ED AND D.EL.ED COLLEGE",
  "KAMLESHWARI PRASAD SINGH TEACHER TRAINING COLLEGE",
  "GOVERNMENT PHARMACY COLLEGE NALANDA",
  "ZULFEQUAR HAIDER UNANI MEDICAL COLLEGE AND HOSPITAL",
  "GAUTAM BUDDHA COLLEGE BELAGANJ GAYA",
  "WOMENS COLLEGE KAUSHALYA GRAM MADHEPURA",
  "MINA DEVI DEGREE COLLEGE GAYA",
  "Dr. Ram Raj Singh Mahila Mahavidayalaya , Chandi",
  "UMAKANT RADHAKANT SANSKRIT MAHAVIDYALAYA, JHANJHARPUR",
  "SHREE MAHANTH VAIDEHI SHARAN SANSKRIT COLLEGE, NAUGACHHIA, BHAGALPUR",
  "late kamta prasad sharma B.Ed. college",
  "SEEMANCHAL DEGREE COLLEGE",
  "ALI NAGAR PALI MANAGEMENT COLLEGE ",
  "College of Community  Science,Pusa",
  "S K M COLLEGE OF NURSING AND PARAMEDICAL, DHADHI PAKARIA, SHAMBHUGANJ, BANKA",
  "Janardan Prasad Singh Teachers Training College",
  "S. T. College of Education",
  "PREMLATA MADAN MOHAN COLLEGE OF EDUCATION",
  "Gaureshwar Naraian Singh Teachers Training College",
  "SSPS College, Shambhuganj",
  "SHYAM SAI INSTITUTE OF EDUCATION",
  "R.L. College, Madhawnagar",
  "Purnea Mahila College, Purnea",
  "Shiv Deni Ram Ayodhya Prasad College, Barachakia",
  "Tara College of Education",
  "PATNA COLLEGE OF PHARMACY",
  "J R A DEGREE COLLEGE",
  "Siddharta Teachers Training College",
  "Dr. APJ Abdul Kalam Women's Institute of Technology",
  "Mahant Shi'vshankar Giri College, Areraj, East Champaran",
  "Laxmi Narain Dubey College, Motihari",
  "PNA SCIENCE COLLEGE",
  "B.S.College, Danapur",
  "C R K COLLEGE OF PHARMACY",
  "GAUTAM COLLEGE",
  "M.J.M. Mahila College, Katihar",
  "Madrasa islamia",
  "N G M DEGREE MAHAVIDYALAYA BHELAHI EAST CHAMPARAN",
  "Siwan College of Engineering and Management, Siwan",
  "COLLEGE OF VETERINARY AND ANIMAL SCIENCES",
  "Netaji Subhas Institute of Technology",
  "Buddha Institute of Technology",
  "Adwaita Mission Institute of Technology",
  "GOVERNMENT ENGINEERING COLLEGE SAMASTIPUR",
  "MAULANA AZAD PARAMEDICAL TRAINING AND RESEARCH INSTITUTE",
  "MOTHERS INSTITUTE OF TECHNOLOGY",
  "Vidya Vihar Institute of Technology",
  "Government Engineering College Sheikpura",
  "GOVERNMENT ENGINEERING COLLEGE BHOJPUR",
  "GOVERNMENT ENGINEERING COLLEGE BUXAR",
  "SHAHI INSTITUTE OF BUSINESS MANAGEMENT    ",
  "R.P. Sharma Institute of Technology",
  "GOVERNMENT ENGINEERING COLLEGE KHAGARIA",
  "GOVERNMENT ENGINEERING COLLEGE ARWAL",
  "Sityog Institute of Technology",
  "Exalt College of Engineering & Technology",
  "RAJENDRA KISHORI B.ED.COLLEGE ",
  "Modern Institute of Higher Education",
  "GOVERNMENT ENGINEERING COLLEGE LAKHISARAI",
  "MAHATMA BUDDHA TEACHERS TRAINING COLLEGE ",
  "GOVERNMENT ENGINEERING COLLEGE,VAISHALI",
  "GOVERNMENT ENGINEERING COLLEGE JAMUI",
  "SEEMANCHAL DEGREE COLLEGE, RAHIKA TOLA, ARARIA",
  "BIHAR COLLEGE OF EDUCATION",
  "BIHAR INSTITUTE OF LAW",
  "GOVERNMENT ENGINEERING  COLLEGE KISHANGANJ",
  "Shri Phanishwar Nath Renu Engineering College, Araria",
  "GOVERNMENT ENGINEERING COLLEGE MUNGER",
  "Government Engineering College Sheohar",
  "Government Engineering College West Champaran",
  "GOVERNMENT ENGINEERING COLLEGE AURANGABAD",
  "GOVERNMENT ENGINEERING COLLEGE KAIMUR",
  "GOVERNMENT ENGINEERING COLLEGE GOPALGANJ",
  "Government Engineering College Madhubani",
  "GOVERNMENT ENGINEERING COLLEGE SIWAN",
  "GOVERNMENT ENGINEERING COLLEGE JEHANABAD",
  "LAHTAN CHOUDHARY COLLEGE PASTWAR BALUAHA MAHISHI",
  "TAKSHILA COLLEGE OF EDUCATION",
  "Government Engineering College, Banka",
  "S T COLLEGE OF HEALTH EDUCATION",
  "SINDHU COLLEGE OF EDUCATION",
  "College of Teacher Education, Darbhanga",
  "DURGAWATI MAHAVIDYALAYA, BICHHIYA, DUMARI, KAIMUR",
  "MANUU POLYTECHNIC, DARBHANGA",
  "T.P. College, Madhepura",
  "K.P. College, Murliganj",
  "Dr. Mahachandra Prasad Singh B.Ed. College, Chandwara, Muzaffarpur.",
  "Digmani B.Ed. College",
  "FAKHRUDDIN ALI AHMAD TEACHERS TRAINING COLLEGE",
  "DR KALAM AGRICULTURAL COLLEGE",
  "Kingway Technical Institute",
  "VAISHALI INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "PADUM LAL RUPAN SINGH B.Ed. and D.El.Ed. COLLEGE",
  "NAWADA VIDHI MAHAVIDYALAYA, NAWADA",
  "Seemanchal Minority B.Ed. College Katihar",
  "S.R.Skt.College,Satouti,Jahanabad",
  "Tauheed Institute Of Information Technology Katihar",
  "YAMUNA INSTITUTE OF PHARMACY",
  "BABULAL YADAV COLLEGE DOBHI GAYA ",
  "M.M. Dental College",
  "SRI KANT BABU DEGREE COLLEGE, KUCHAIKOTE",
  "National Business College",
  "RAMAWTAR SINGH ADARSH MAHAVIDYALAYA, BIJHAURA, BUXAR    ",
  "BHAGWATI SHANTI COLLEGE, LOMA, RAJAPAKAR, HAJIPUR, VAISHALI    ",
  "TARA SHIVSHANKAR DEGREE COLLEGE, TIYARA, BUXAR    ",
  "PATEL COLLEGE OF EDUCATION",
  "LALU PRASAD YADAV COLLEGE, AKORHI GOLA, ROHTAS",
  "SHIVGOVIND NANDLAL SINGH DEGREE MAHAVIDYALAYA, SIKRAUL LOCK, DAFADIHARI, BUXAR    ",
  "RAJKIYA DEGREE MAHAVIDYALAYA PAKRIDAYAL EAST CHAMAPARAN",
  "S.P.College, Hilsa",
  "MARYADA PURUSHOTAM COLLEGE OF EDUCATION ",
  "SUFIA UNANI MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE",
  "KAILASH SUSHIL NURSING SANSTHAN",
  "COLLEGE OF MANAGEMENT AND TECHNOLOGY (RR SAHU CENTRE)",
  "Snatak College Islampur",
  "Vidhi Mahavidyalaya, Samastipur",
  "R.D.S. College, Salmari",
  "Pepople's College, Araria",
  "B. D. College, Barsoi",
  "Al-Momin College of Education",
  "SANSKAR BHARTI SCHOOL OF EDUCATION    ",
  "SYED NEHAL AHSAN EVENING COLLEGE, BARH PATNA ",
  "SWAMI VIVEKANAND NURSING SCHOOL",
  "MAGADH COLLEGE OF EDUCATION",
  "VEER KUNWAR SINGH COLLEGE, JAGDISHPUR, BHOJPUR",
  "GURU PRAKASH COLLEGE, KEKADHA, KILANI KAIMUR",
  "R S M DEGREE COLLEGE, SANTPUR, ARA, BHOJPUR",
  "INDRA PARSHURAM SINGH MAHAVIDYALAYA, MAIDAN, KALA BELAON, KAIMUR",
  "ARJUN COLLEGE OF EDUCATION",
  "GITA PRADEEP COLLEGE OF HIGHER EDUCATION",
  "CHANAKYA ACADEMY MAHILA MAHAVIDYALAY, SARENJA, BUXAR",
  "PAWAN KUMAR JHA DEGREE COLLEGE, LOMA, HAJIPUR",
  "MEGHRAJ MEMORIAL B.Ed. COLLEGE",
  "SATTAR MEMORIAL COLLEGE OF EDUCATION",
  "jehal parsad  teachers training college",
  "Buddha Multiplex Hotel and Management",
  "NATIONAL COLLEGE OF EDUCATION",
  "MAHATMA GANDHI BED COLLEGE",
  "RAGHUNANDAN SINHA T T COLLEGE ANM NURSING",
  "Sri Ravneshwar Sanskrit College,Gidhaur",
  "M.G.College",
  "S.S.Y. College",
  "Anooplal Yadav Mahavidyalaya, Triveniganj",
  "V.S.Roy M College, Sherghati",
  "RAMLAKHAN SINGH YADAV COLLEGE PALIGANJ PATNA",
  "S.T.S.M. College, Panwari",
  "JINVANI MANAGEMENT COLLEGE",
  "Nagarjun Umesh Sanskrit College, Tarauni, Darbhanga",
  "GOVT. COLLEGE OF TEACHER EDUCATION SAMASTIPUR",
  "Baba Sahib Ram Sanskrit College, Pacharhi, Darbhanga",
  "Baidyanath Pandey Arya Sanskrit College, Siwan",
  "Ch.Skt.College,Hathua,Gopal.",
  "G.G.Skt.College,Bakhtiyarpur",
  "TRIVENI COLLEGE OF EDUCATION",
  "Shyama Charan Banushi,Banka",
  "Government Sanskrit College, Kajipur, Patna",
  "Akhil Bharatiye Skt. Hindi Vidypeeth, Khamhar, Begusarai",
  "Ugra Tara Bharati Mandan Sanskrit College, Mahishi, Saharsa",
  "Raghavendra Sanskrit College, Taretpali, Naubatpur, Patna",
  "LAKSHMI NARAYAN COLLEGE OF BUSINESS MANAGEMENT",
  "Government Sanskrit College, Bhagalpur",
  "Madaneshwarnath Sanskrit College, Madaneshwar Asthan, Madhubani",
  "M.M. Lata Sanskrit Vidyapeeth, Lohana, Madhubani",
  "Dharma Samaj Sanskrit College, Muzaffarpur",
  "Shiv Prasad Sanskrit Degree College, Rampur, Buxar",
  "Sidheshwari Sanskrit College, Pachrukhiya, Bhojpur",
  "Basudev Skt.College,Akbarpur",
  "J.S.Skt.College,Majholiya,W.Champaran",
  "Nandan Sanskrit College, Ishahpur, Madhubani",
  "D.H.S.C.Skt.College,Chanpura",
  "G.R.Skt.College,Mahiya .Chapra",
  "Krishna College of Teachers Education",
  "Shri Ram Sanskrit College, Vijayeepur, Gopalganj",
  "Gautam Budh Teachers Training College ",
  "Dr Trishuldhari Pandey Memorial College of Education",
  "UDAY TEACHERS TRAINING COLLEGE",
  "L.P.R.L.Skt.College,Samaul,Birsayar,Madh.",
  "Purnima Ram Pratap Sanskrit College, Baigani, Darbhanga",
  "RAM SHRESTHA SINGH COLLEGE TEACHER TRAINING WING",
  "RAM BARAN RAY B.ED. COLLEGE",
  "Ram Dei Ram Chandra Memorial Shikshan Sansthan",
  "R.S SHARDA DEVI EDUCATION COLLEGE",
  "NAGEENA RAMDHYAN SHIKSHAK SHIKSHA MAHAVIDYALAYA",
  "DULARI INSTITUTE OF EDUCATION CENTRE",
  "Brajbhushan Sanskrit College, Kharkhura, Gaya",
  "Mahanth Keshaw Sanskrit College, Fathuha, Patna",
  "Radha Umakant Sanskrit College, Sukhsena, Purnea",
  "P.V.Skt.College,Andharatharhi,Madhubani",
  "Awadh Bihari Sanskrit College, Rahimpur, Khagaria",
  "Jagdamba Sanskrit College, Batho, Darbhanga",
  "Bharat Mishra Sanskrit College, Chapra",
  "Kalyani Mithila Sanskrit College, Deep, Madhubani",
  "K.N.K.Skt.College,Mahrail,Madhubani",
  "Nimbark Krishna Madhawanand Skt. College, Dhanamath, Patna",
  "Indrakali Ramjee Singh B.Ed. College",
  "J.M.Skt. College,Pastan",
  "CENTRAL INSTITUTE OF PETOCHEMICALS ENGINNERING AND TECHNOLOGY IPT BIHTA    ",
  "Admire Institute of Management And Technology",
  " Bhagwan Mahavir Ayurvigyan Sansthan, Pawapuri",
  "MILLIA TEACHERS TRAINING COLLEGE RADHANAGAR KASBA PURNEA",
  "SRP Teachers Training College Purnea",
  "MAHILA MAHA VIDYALAYA  MUDILA AMBA",
  "KESHO MAHTO MEMORIAL COLLEGE, PATHRA, IMAMGANJ, GAYA, BIHAR",
  "S R TEACHER TRAINING COLLEGE",
  "S. R. C. College, Katihar",
  "B K S COLLEGE",
  "K.P.S.College",
  "Mahila College, Tekari",
  "Heera Lal Roy Teacher Training College",
  "S.N.Sinha College, Warsaliganj",
  "Y.N.P.Degree College, Raniganj",
  "MADHAVAN MEMORIAL COLLEGE OF EDUCATION",
  "Deochand College, Hajipur",
  "Prakash Punj Teachers Training College",
  "NUTAN COLLEGE OF NURSING",
  "BIT Extension Center,Patna",
  "L.N.T. College, Muzaffarpur",
  "K.S.Y. College, Barun",
  "Muzaffarpur Institute of Technology",
  "Vaishali Mahila College, Hajipur",
  "Gaya College of Engineering",
  "CHAMPARAN COLLEGE OF PHARMACY",
  "B.P.J.P.S. Mahila College, Rajpur",
  "RAJKESHWAR RAO NANDANGARH DEGREE MAHAVIDYALAYA",
  "Kalawati Snatak Mahavidyalaya, Raniganj",
  "Maharani Punam Sahi B.Ed. College, Hathwa",
  "Swami Parankushacharya Adarsh Sanskrit Mahavidyalaya, Bihar",
  "ANM SCHOOL BAIKUNTHPUR",
  "Motihari College of Engineering",
  "MAHESH PRASAD SINGH SNATAK MAHAVIDYALAYA",
  "S.G.M.College",
  "KINGWAY TECHNICAL INSTITUTE, KAIMUR",
  "SRI TRIDANDI DEV GOVT DEGREE COLLEGE, GAUTAM NAGAR, SHAHPUR",
  "BABA VISHWANATH KEDARNATH VIMALA COLLEGE",
  "NALANDA SHODH SANSTHAN AVAM MAHAVIDYALAYA",
  "RAMESHWAR SINGH COLLEGE OF HIGHER EDUCATION    ",
  "Nalanda College, Biharshariff",
  "Nalanda Mahila College, Biharsharif",
  "Rameshwardas Pannalal Mahila College",
  "R.Lal College, Alinagar",
  "Mahila College, Khagaul",
  "M.M.College, Bikram",
  "R.P.S. College",
  "R. P. S. LAW COLLEGE",
  "R.P.S.M. College,",
  "DHARIKSHAN SHANTI MEERA SIDHNATH DEGREE MAHAVIDYALAYA KULHARIA ",
  "R P S TEACHERs TRAINING COLLEGE",
  "Sant Tapasvi Narayan Das Foundation",
  "S.P.M.College, Udantpuri",
  "K P S COLLEGE KINJAR ARWAL",
  "Sri Arvind Mahila College",
  "ADWAITA MISSION TRAINING COLLEGE",
  "S.U.College,Hilsa",
  "NIRSU NARAYAN COLLEGE, SINGHARA, VAISHALI",
  "Sri Raghav Prasad Singh College, Jaintpur, Muzaffarpur",
  "GURO BINDA COLLEGE",
  "Somavati Mehtab Das College",
  "Oriental College,Patnacity",
  "Jagjiwan Mahavidyalaya, Gaya",
  "Shivpari Devi Teacher s Training College",
  "MAGADH MAHAVIDYALAYA ",
  "SUB DIVISIONAL GOVERNMENT DEGREE COLLEGE NAUHATTA ROHTAS",
  "YAMUNA NAND KISHORE SHUKLA COLLEGE",
  "MOTIHARI DEGREE EVENING COLLEGE, MOTIHARI",
  "RAJKIYA DEGREE MAHAVIDYALAYA, SHEOHAR",
  "A.Y.T. Teachers training College",
  "Bihar Veterinary College, Patna",
  "Lok Nayak Jai Prakash Institute of Technology",
  "Priya Rani Rai Degree College, Bairgania",
  "Bakhtiyarpur College of Engineering",
  "Parmanand Sabitri Degree College, Harda",
  "PANACEA MEDICAL EDUCATION INSTITUTIONS",
  "BRADFORD INTERNATIONAL BUSINESS SCHOOL",
  "RAJVANSHI RAMASHISH COLLEGE OF PHARMACY",
  "R.L.S.Y. College",
  "DR. R. B. SINGH GAYA HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "R.L.S.Y. College, Bettiah",
  "Sidheshwar College of Teachers Education, Meyari, Bazar, Rohtas",
  "Shri Rishikul Br. Sanskrit College, Bediban Madhuban, East Champ.",
  "Birchand Patel Smarak Mahavidyalaya, Desri, Vaishali",
  "SHAHEED PEER ALI TEACHERS TRAINING COLLEGE",
  "Ramshreshtra Singh College, Chochahan, Belsar, Muzaffarpur",
  "WARSI COLLEGE PANDEY GANGOUT NAWADA",
  "Veer Kunwar Singh College of Agriculture, Dumraon",
  "Baldeo College OF Educatioal",
  "SIKARIA PHARMACY COLLEGE",
  "RAMESHWAR SINGH PHARMACY COLLEGE",
  "J.S.College, Chandaul, Sitamarhi",
  "R.P.S. College, Chakeyaj, Vaishali",
  "Laxmi Narayan College, Bhagwanpur, Vaishali",
  "Nand Lal Singh College, Jaitpur-Daudpur, Saran",
  "Ganga Singh College, Chapra",
  "SUB DIVISIONAL GOVT DEGREE COLLEGE DHAMDAHA PURNEA",
  "MAHATMA BUDH HIRAMAN COLLEGE",
  "DSM College, Jhajha",
  "BABASAHEB BHIMRAO AMBEDKAR MAHAVIDYALAY  VALMIKINAGAR WEST CHAMPARAN",
  "D D COLLEGE,DHANUPRA,BHOJPUR",
  "RAM NIRANJAN JANTA DEGREE COLLEGE, RAMPUR, MADHWAPUR",
  "Mahendra Mahila College, Gopalganj",
  "Gopeshwar College,Hathwa",
  "Bhola Prasad singh College, Bhore",
  "PBS College, Banka",
  "Banarsilal Saraf Commerce College, Naugachia",
  "L P N Sanskrit College, Baunsi,  Banka",
  "Forbesganj College, Forbesganj",
  "Araria College, Araria",
  "S S COLLEGE OF TEACHER EDUCATION",
  "MAM College, Naugachia",
  "SMT GANGA DEVI MEMORIAL COLLEGE,SUDAMAPUR, JAMUI",
  "MGM COLLEGE, PATNA",
  "RAM LAKHAN SINGH YADAV COLLEGE, JEHANABAD",
  "INTERNATIONAL BUSINESS COLLEGE PATNA",
  "MAULANA MAZHARUL HAQUE TEACHERS TRAINING COLLEGE",
  "HARE KRISHNA SINGH COLLEGE,HASANPUR KHOPI,VAISHALI",
  "OXFORD BUSINESS COLLEGE",
  "A.N.S. College,Nabinagar",
  "G.D. College",
  "C. M. Law College",
  "R.K.K. College, Purnia",
  "Mahila College, Daudnagar",
  "N.J.S. College, Bakhtiyarpur",
  "SRI KRISHNA DEGREE EVENING COLLEGE",
  "Sitamarhi Institute of Technology",
  "DR C P THAKUR COLLEGE",
  "SALFIA UNANI MEDICAL COLLEGE AND HOSPITAL",
  "Bibi Aasia Begum Teachers Training College",
  "NEZAMIA UNANI MEDICAL COLLEGE AND HOSPITAL",
  "D. P. Singh Institute of Education ",
  "R.C.S. college, Kurtha",
  "G.D.M. College, Harnaut",
  "R L MAHTO INSTITUTE OF EDUCATION",
  " S A COLLEGE NAWADA",
  "Govt. Girl's College, Gardanibagh",
  "MSKB College, Muzaffarpur",
  "Government Women's College, Gulzarbagh",
  "DR GANESH RAY DEGREE COLLEGE, SITAMARHI",
  "Jiwachh College, Motipur, Muzaffarpur",
  "M.D.D.M. College, Muzaffarpur",
  "B. P. Mandal College of Engineering, Madhepura",
  "Ram Lakhan Singh Yadav College, Bakhtiyarpur",
  "JAGESHWAR RAY ARTI B.Ed. COLLEGE ",
  "D.L.S SHIKSHA MAHAVIDHYALAY",
  "College of Commerce, Arts & Science",
  "College  of Basic Sciences and Humanities,Pusa",
  "Ram Ratan Singh College, Mokama",
  "VISHUN DEV NARAYANA INSTITUTE OF HIGHER EDUCATION",
  "ADARSH CHAMPARAN DEGREE COLLEGE",
  "M.M. College",
  "S.M. SHOAIB HASHMI EDUCATION AND WELFARE TRUST GROUP OF INSTITUTION,S.M. SHOAIB HASHMI B.Ed. college",
  "Subhwanti Institute of Education, Siwan",
  "SANJAY SINGH COLLEGE OF HIGHER EDUCATION",
  "Sri Gadadhar Acharya Janta College, Rambagh, Bihta",
  "Ganga Devi Mahila Mahavidyalaya, Patna",
  "Harshpati Singh College, Madhepur",
  "T.P.S. College, Patna",
  "Soghra College, Biharsharif",
  "B.M.T. Law College, Purnia",
  "DR. HALIM HOMOEOPATHIC MEDICAL COLLEGE  HOSPITAL",
  "INSAN DEGREE COLLEGE, KISHANGANJ",
  "B.N.C. College, Dhamdaha",
  "MAHABODHI TEACHERS TRAINING COLLEGE",
  "ARJUN COLLEGE OF NURSING",
  "Marwari College, Kishanganj",
  "BABA GANINATH COLLEGE, DEHRI-ON-SONE",
  "B. L. B.Ed. College",
  "Acharya Sudarshan B.Ed. College",
  "Shanti Memorial College of Education",
  "GURUDEO COLLEGE OF NURSING AND PARAMEDICAL SCIENCE ",
  "GURUDEO PARAMEDICAL COLLEGE",
  "GYANSAROVER VIDYAPEETH",
  "M. H. A. N. D. College, Thakurganj",
  "CHAITANYA COLLEGE OF MANAGEMENT AND TECHNOLOGY    ",
  "RAY BIRENDRA SINGH COLLEGE, KUTUBPUR KOTHI,THATHAN BUZURG, HAJIPUR VAISHALI",
  "ABC COLLEGE OF EDUCATION",
  "Patliputra Teachers Training College",
  "ASHA COLLEGE OF PROFESSIONAL STUDIES",
  "GYAN PRAKASH COLLEGE OF EDUCATION ",
  "RAJ MATA MADHURI DEVI TEACHERS TRAINING COLLEGE",
  "Brahmarshi Sahjanand Sarashwati College, Bachari-Piro, Bhojpur",
  "D.S.S.V. College, Simari",
  "MIRZA GALIB TEACHERS TRAINING COLLEGE, PATNA",
  "Saharsa College of Engineering",
  "SAHDEV PRASAD YADAV COLLEGE ARWAL",
  "SHAKUNI CHOUDHARY COLLEGE OF EDUCATION",
  "SUPAUL COLLEGE OF ENGINEERING",
  "Darbhanga College of Engineering",
  "Swami Shiwa Nand Jee Tirth College Sasaram",
  "NATIONAL B.ED. COLLEGE OF HIGHER EDUCATION",
  "Bisheshwaar Dayal Sinha Memorial Mahila College, Chapra",
  "Sri Mahendra Das Degree College,Mathiya, Nechua Jalalpur",
  "Dr Vijay Kumar Singh College, Rafiganj",
  "Narayan College Goreya Kothi",
  "Lok Mahavidyalaya, Hafipur, Baniyapur",
  "Katihar  Medical College, Katihar",
  "THE OXFORD COLLEGE OF EDUCATION",
  "Aryabhatta Teachers Training College",
  "Sanjay Gandhi Institute of Dairy Technology, Patna",
  "SHRI BHAGWAT PRASAD SINGH MEMORIAL COLLEGE OF NURSING",
  "Nalanda College of Engineering",
  "Sershah Engineering College, Sasaram",
  "A P J ABDUL KALAM DEGREE COLLEGE",
  "Chaurasiya Rajkishore College, Hajipur.",
  "L.K. MISHRA COLLEGE OF TEACHER EDUCATION",
  "SRI UMESH MISHRA RANJEET KUMAR PRAKASH COLLEGE",
  "NATIONAL TEACHERS TRAINING COLLEGE",
  "INDU DEVI RANJEET KUMAR PRAKASH PROFESSIONAL COLLEGE ",
  "Regional College of Education",
  "Government T.T.B.Ed. College, Turki, Muzaffarpur",
  "Srikant Sanskrit Mahavidyalaya Shikshan Kalyan Sansthan",
  "L.M.College",
  "Lichhavi College of Teacher's Training College, Hajipur, Vaishali",
  "G.S. Teachers Training College",
  "ROYAL HERITAGE COLLEGE OF EDUCATION",
  "Patna Muslim Science College,",
  "Vidya Niketan Teacher Training College, Charman,Masaurhi",
  "GANGA GLOBAL INSTITUTE OF MANAGEMENT STUDIES",
  "JP COLLEGE OF EDUCATION",
  "B.Ed. Teacher Training College",
  "DAYANAND AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "AMBEDKAR COLLEGE OF EDUCATION",
  "DR ZAKIR HUSSAIN EVENING COLLEGE SHERGHATI GAYA",
  "ROY COLLEGE OF EDUCATION",
  "Sri Narayan Singh College, Motihari",
  "KRISHNA INSTITUTE OF HIGHER EDUCATION",
  "RURAL TEACHERS TRAINING COLLEGE",
  "JANTA MAHAVIDHYALAY LABHRI PARSAWAN AMBA",
  "MAHANTH NARAYAN DAS COLLEGE",
  "ABHA TEACHERS TRAINING INSTITUTE",
  "DEO SHARAN WOMEN'S EVENING COLLEGE , SOHSARAI , NALANDA",
  "PRATIBHA PALLAVAN TEACHERS TRAINING COLLEGE",
  "A.K.GOPALAN DEGREE COLLEGE",
  "Pt. Yamuna Karjee Jayanti College, Bagahi, Muzaffarpur",
  "SOUMYA KRISHNA ANM TRAINING SCHOOL",
  "RAGHUNATH JHA DEGREE COLLEGE , SITAMARHI",
  "MEENA BASKIT RAY MAHAVIDYALAYA VAISHALI",
  "MAHESHWAR PRASAD SHAHI COLLEGE SITAMARHI",
  "Sub Divisional Govt Degree College Baisi  Purnea",
  "Harakhdeo Singh College of Education",
  "S.N.S.Y. Degree College, Rambagh",
  "MANAV BHARTI COLLEGE OF PHARMACY",
  "Radha Krishna Sikaria Educational Institution",
  "EXALT COLLEGE OF EDUCATION",
  "Nazirul Hasan Teachers Training College",
  "Zakia Afaque Islamia College, Siwan",
  "PARAMOUNT TEACHERS TRAINING COLLEGE, MUZAFFARPUR",
  "TRIDENT TEACHERS TRAINING COLLEGE, MUZAFFARPUR",
  "SUSHANT TEACHERS TRAINING COLLEGE, MUZAFFARPUR",
  "AMARNATH MISHRA DEGREE MAHAVIDYALAYA, DAYALPUR, BUXAR",
  "SARASWATI ARJUN EKLAVYA DEGREE COLLEGE JAMUI",
  "DEEPNARAYAN MEMORIAL TEACHER TRAINING COLLEGE",
  "Patna College",
  "GLOBAL FOUNDATION FOR HIGHER STUDIES",
  "Women's Training College",
  "Aihe Professional Institute",
  "Patna Training College",
  "FATIMA DEGREE COLLEGE, PATNA",
  "PRAGYA COLLEGE OF PHARMACEUTICAL SCIENCES",
  "MAHATMA GANDHI SIKSHAK PRASIKSHAN MAHAVIDYALYA",
  "SANSKRIT MAHAVIDHYALAY POTHIA KATIHAR BIHAR",
  "SIDHNATH SAH COLLEGE, TIYARA, RAJPUR, BUXAR",
  "LEEDS TRAINING COLLEGE",
  "ORAKH THAKUR MEMORIAL DEGREE COLLEGE, MOTIPUR, SANDHA, MUZAFFARPUR",
  "SEEMA KUMARI COLLEGE, ITARHI ROAD, TURKPURWA, BUXAR",
  "Muniswar Singh Muneswari Samta Mahavidyalaya, Jandaha, (Vaishali)",
  "SAI B Ed D El Ed COLLEGE",
  "VAIDEHI INSTITUTE OF NURSING AND HIGHER EDUCATION",
  "SHRI SAI COLLEGE OF NURSING AND PARAMEDICAL",
  "BHAGWATI COLLEGE OF EDUCATION",
  "S.N.S. Mahila College, Supaul",
  "B.S. College, Simraha",
  "M.H.M. College, Sonbarsa",
  "S.A.K.N.D. College, Madhepura",
  "Vanijya Mahavidayala",
  "K.N.D. College, Raghopur",
  "Adarsh College, Ghailarah",
  "R.M. College, Saharsa",
  "U.V.K. College, Karama",
  "R.P.M. College, Tuniyahi",
  "MATA SITA SUNDER COLLEGE OF EDUCATION VILLAGE DHANHARA PO MANIK CHOWK PS RUNNI SAIDPUR",
  "TEACHERS TRAINING COLLEGE, BHAGALPUR",
  "R.N.College",
  "Sanjay Sinha BEd College",
  "VEDMATI BHABNATH CHAUDHARY COLLEGE OF EDUCATION",
  "ARCADE BUSINESS COLLEGE RAJENDRA NAGAR PATNA",
  "SNS INSTITUTE OF NURSING SCIENCE",
  "KAUSHALYA RAMADHAR EDUCATIONAL TRUST ",
  "SNS COLLEGE OF PHARMACY",
  "RAMDHANI BHAGAT DEGREE COLLEGE, SANGRAMPUR",
  "RAVIKANT PUNAM MAHAVIDYALAYA",
  "G D MEMORIAL HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL ",
  "HARI ANAND COLLEGE, AKAUR, BENIPATTI, MADHUBANI, BIHAR ",
  "R. K. Saha  Women's College, Kishanganj",
  "B N BHAGAT LALAN SINGH DEGREE MAHAVIDYALAYA, ITARHI ROAD, BUXAR",
  "R.L.S.Y. College",
  "Ashoka Nursing and Paramedidal College",
  "RAJ ARYAN NURSING AND PARAMEDICAL COLLEGE",
  "BSC NURSING COLLEGE JLNMCH BHAGALPUR",
  "PANDIT NACHARI JHA SANSKRIT MAHAVIDHYALAYA, BAHADURPUR, SAMASTIPUR",
  "T.S. College, Hisua",
  "ANM TRAINING SCHOOL, BANMANKHI ",
  "IMPACT COLLEGE OF LAW ",
  "K.P.S. Sna College, H.Ganj",
  "Krishak College,Pakri Barwan",
  "M.B.COLLEGE OF EDUCATION",
  "VIVEKANAND PARAMEDICAL AND NURSING COLLEGE",
  "NETAJI SUBHAS MEDICAL COLLEGE AND HOSPITAL",
  "Mahavir Cancer Sansthan",
  "S.J.S. College, Kurtha",
  "MITHILA INSTITUTE OF POST GRADUATE STUDIES AND RESEARCH IN SANSKRIT, DARBHANGA",
  "PATEL NURSING COLLEGE",
  "DR RAM KRISHANA THAKUR JANTA SANSKRIT MAHAVIDHALAYA, EAKHARI, MADHUBANI",
  "LUTAN JHA MAHAVIDYALAYA NANAUR JHANJHARPUR",
  "S.Sinha College",
  "S.S.College,",
  "K.S.M. College",
  "S.D.College, Pariya",
  "Daudnagar College, Daudnagar",
  "A.M.College",
  "Mahila College, Warsaliganj",
  "S.B.A.N. College, Darheta Lari",
  "DR INDAL SINGH RAM JANKI DEGREE COLLEGE",
  "J.K.College, Fatehpur",
  "M.S.Y.College",
  "T.B.D.S. College, Goh",
  "KALYAN SEVA SANSTHAN COLLEGE OF NURSING ",
  "NITISHWAR AYURVED MEDICAL COLLEGE AND HOSPITAL",
  "Sai college of Education",
  "INDU DEVI RANJEET KUMAR PRAKASH COLLEGE",
  "ABUL KALAM MINORITY TEACHERS TRAINING BED COLLEGE",
  "DEVENDRA PATHAK SARVODAYA COLLEGE OF EDUCATION, DUBHAL GAYA",
  "ARCADE BUSINESS COLLEGE KHAGAUL PATNA",
  "SWAMI RAGHWENDRACHARYA TRIDANDI AYURVEDA COLLEGE AND HOSPITAL  ",
  "Maulana Minnatullah Rahmani Technical Institute",
  "JAY MURAT RAI DEGREE MAHAVIDYALAYA, NIRPUR, PATEPUR, VAISHALI",
  "M.L. Arya College, Kasba",
  "SHIVAM TEACHERS TRAINING COLLEGE",
  "DOON INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "MOHAN SHAKUNTALA TEACHERS TRAINING COLLEGE",
  "ARYAMAN COLLEGE OF HIGHER STUDIES",
  "M.L.D.P.K.Y College, Araria",
  "SCHOLARS DEGREE COLLEGE, B KOTHI PURNEA",
  "Maharana Pratap College, Mohania",
  "KRISHNA INSTITUTE OF IT AND MANAGEMENT",
  "R.C.College, Dholi, Sakra, Muzaffarpur",
  "AL  FATIMA EDUCATIONAL SOCIETY",
  "Radheshyam Teachers Training College, Pathra",
  "MGM COLLEGE OF LAW",
  "DOON INSTITUTE OF NURSING",
  "East  N West Teachers Training College, Patuaha,",
  "LORD BUDDHA KOSHI PHARMACY SAHARSA, BIHAR",
  "OM SRI SAI COLLEGE OF PARAMEDICAL AND SCIENCE",
  "Subhash Chandra Teachers Training College, Khurda",
  "KATIHAR GNM NURSING TRAINING SCHOOL",
  "Maa Arany Devi B.Ed. College",
  "C. K. M. Law College, Araria",
  "TAPINDU INSTITUTE OF HIGHER STUDIES",
  "GURO BINDA COLLEGE OF PHARMACEUTICAL SCIENCES",
  "CIMAGE CENTER OF DIGITAL TECHNOLOGY AND  ENTREPRENEURSHIP",
  "CATALYST INSTITUTE  OF MANAGEMENT AND ADVANCE GLOBAL EXCELLENCE",
  "MADHEPUR T T COLLEGE MADHEPUR",
  "Anandi Janki Mahila College, Banmankhi",
  "N.D. College, Rambagh",
  "J P INSTITUTE OF AYURVEDA AND MEDICAL SCIENCE",
  "R. Y. Manihari  College, Manihari",
  "Devraha Baba Sridhar Das Degree College,  Rampur,Kadna, Garkha",
  "NAGINA DEVI TEACHERS TRAINING COLLEGE",
  "AKHAND JYOTI EYE HOSPITAL",
  "S S S AGRAWAL PRABHANDHAN EVAM TAKNIKI MAHAVIDYALA",
  "ZEE EDUCATION FOUNDATION INSTITUTE OF PHARMACY",
  "S.B.R. College, Barh",
  "S.K.V.M. College, Fatuha",
  "Sir Ganesh Dutta Memorial College, Patna",
  "R B S R D R COLLEGE",
  "Deshratna Rajendra Prasad Shikshak Prashikshan Mahavidyalaya",
  "C.P. Verma College, Simari",
  "OM SRI SAI PHARMACY COLLEGE OF EDUCATION",
  "KATIHAR ANM NURSING TRAINING SCHOOL",
  "SHREE NARAYAN MEDICAL INSTITUTE AND HOSPITAL ",
  "DAKSH B.SC NURSING COLLEGE",
  "DR INDIRA INSTITUTE OF NURSING AND PARAMEDICAL, MUZAFFARPUR",
  "Catalyst College",
  "B.R.S. Y. College, Kanhauli",
  "C.S.Janta College,",
  "Jageshwari Kedar Tiwari Prachya Vidyapeeth, Bihar",
  "KRISHNA INSTITUTE OF PARAMEDICAL SCIENCES",
  "KUSUMRAJ INSTITUTE OF PARAMEDICAL AND HEALTH SCIENCE",
  "DIVINE COLLEGE OF PHARMACY",
  "V.K.S. Mahila College, Kashi Mednipur",
  "MONA SCHOOL OF NURSING AND PARAMEDICAL COLLEGE",
  "MGM COLLEGE OF PHARMACY",
  "S P VERMA COLLEGE",
  "PANDIT UJJWAL KUMAR MISHR FOUNDATION COLLEGE (EVENING) HAJIPUR",
  "MS College, Alouli, Khagaria",
  "SS College, Mehus, Seikhpura",
  "MAHATMA GANDHI MEMORIAL DEGREE COLLEGE",
  "P.M.S. College, Biharsharif",
  "Sri Krishan Singh College, Lohanda",
  "Maa Mundeshwari Sanskrit Mahavidhyalay Mundeshwari Ramgarh",
  "S.P.S. College, Jamui",
  "SBN College, Garhirampur, Munger",
  "PRATIK COLLEGE OF EDUCATION",
  "MAHABIR PARAMEDICAL TRAINING AND RESEARCH INSTITUTE",
  "MAGADH INSTITUTE OF PHARMACY",
  "MAA KANTI COLLEGE OF NURSING",
  "KUSUMRAJ INSTITUTE OF PHARMACY",
  "Government Ayurvedic College",
  "GOVERNMENT TIBBI COLLEGE AND HOSPITAL ",
  "College of Nursing, Kurji Holy Family Hospital",
  "Darbhanga Medical College & Hospital",
  "Himalaya Teachers Training College",
  "BSC NURSING COLLEGE DARBHANGA MEDICAL COLLEGE AND HOSPITAL DMCH DARBHANGA",
  "SBSS College",
  "Sanjay gandhi smarak mahila college",
  "M.L.S.M. College",
  "S.K. Mahila College",
  "S.M.R.C.K. College",
  "AWADHESH PRASAD MAHAVIDYALYA NADAUL, MASAURHI,  PATNA",
  "APOLLO COLLEGE OF  NURSING",
  "J P COLLEGE OF LAW",
  "gautam college of education",
  "LIFE LINE NURSING AND PARAMEDICAL COLLEGE",
  "INSTITUTE OF PHARMACY ",
  "R. Lal College, Lakhisarai",
  "Mahila College, Barhaiya",
  "AHS NURSING COLLEGE",
  "International College, Ghosaith",
  "BHUNESHWAR PRASAD YADAV COLLEGE GAYA    ",
  "B.ED. COLLEGE PARSATHUA, ROHTAS",
  "Mahabodhi Mahavidyalaya, Nalanda",
  "RAM PRATAP INSTITUTE OF PHARMACY COLLEGE",
  "SHRI MAHANTH SATANAND GIRI COLLEGE",
  "DR M KUMAR INSTITUTE OF NURSING",
  "PRAHALAD RAI TEACHERS TRAINING COLLEGE",
  "MATA ASHAPURI COLLEGE, PYAREPUR, PAWAPURI, NALANDA",
  "Bharteshwari Marwari Skt.College,Chapra",
  "MAHARANI GEETA PRABHAT DEGREE MAHAVIDYALAYA, BHIKHANPURA, MAHNAR, VAISHALI    ",
  "Arbind Teachers Training College, Araura,Dularur,Ara, Bhojpur",
  "R.B.S. College, Andaur",
  "Sri Ram Suhag Tilak College Of Education",
  "SHAKUNTALAM INSTITUTE OF TEACHERS EDUCATION, KIRHINDIH, SASARAM, ROHTAS",
  "DASHRATH PRASAD RAMNANDAN PANDEY COLLEGE OF PHARMACY",
  "MAKHDUM BAKHASH MEMORIAL DEGREE COLLEGE",
  "S.K. College Thatia",
  "I.B.M. Bela",
  "A.N.D. College",
  "COLLEGE OF FISHERIES, KISHANGANJ",
  "JANNAYAK KARPOORI THAKUR VIDHI MAHAVIDYALAYA, BUXAR",
  "Sukdeo Mahto Janta Mahavidyalaya, Khajedih",
  "MILLIA KISHANGANJ COLLEGE OF ENGINEERING & TECHNOLOGY",
  "A. P.S.M. College",
  "Q.A. Deg College, Zale",
  "MOTHERS INTERNATIONAL TECHNICAL AND MANAGEMENT INSTITUTE",
  "R.B.J. College",
  "G.M.R.D. College",
  "K. S. College",
  "Chanakya Foundation",
  "Jawaharlal Nehru Memorial College, Ghorasahan",
  "M.D.R. Patel Degree Mahila College, Bhabua, Kaimur - (Bihar)",
  "GYAN BHARTI COLLEGE OF EDUCATION",
  "Allama Iqbal Teachers Training College",
  "J.R.A. Teachers Training College",
  "RADIANT INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "SHRI BHAGWAT PRASAD SINGH MEMORIAL B.Ed. COLLEGE",
  "Patna Medical College",
  "J.P. Shikshak prashikshan Mahavidyalya",
  "G.B. Balika Vidyapith, Ramgarh",
  "Mithila B.Ed. College",
  "MAA SAVITRI INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES AND HOSPITAL",
  "PRAKASH B.ED TEACHERS TRAINING COLLEGE",
  "DRS College, Sikandra, Jamui",
  "L.N. Mishra College of Business Management, Muzaffarpur",
  "SHAMS TEACHERS TRAINING COLLEGE",
  "M.M.Rahmani B.Ed. College",
  "NEW HORIZON COLLEGE OF EDUCATION",
  "P.N.K. College, Achua",
  "K.P.S. College, Nadwan",
  "M. G. M. COLLEGE ",
  "K S R N S DEGREE COLLEGE MATHIYA, KESARIA, PURBI CHAMPARAN    ",
  "J.L.N. College, Dehri-on-sone",
  "R.K.S. College, Dalmianagar",
  "JAMUI B.Ed COLLEGE",
  "MAHADEVA LAL SCHROFF COLLEGE OF PHARMACY",
  "U.P. College",
  "DR ARVIND KUMAR COLLEGE BISHANPUR CHAKAI",
  "K.S.R. College, Sarairanjan",
  "S.S.D.M. College, Barh",
  "EMPLOYEES STATE INSURANCE MEDICAL COLLEGE",
  "Balrampur  College, Balrampur",
  "INDRA PARSHURAM SINGH MAHILA MAHAVIDYALAYA, CHILBILI, KUDRA, KAIMUR    ",
  "L.N.M. College of Higher Education",
  "EXALT COLLEGE",
  "Tagore Teachers Training College",
  "J. D. S. DEGREE COLLEGE",
  "P.D.K. Jha College",
  "Nalanda T T College, Biharsharif",
  "Nalanda Mahila Shikshak Prashikshan Mahavidyalaya",
  "Mahatma Gandhi College, Sundarpur",
  "MALTI DHARI COLLEGE",
  "S.G.G.S. college, Patnacity",
  "Ram Krishna Dwarika Mahavidyalaya, Lohiya Nagar, Patna",
  "SDMY Degree College, Dhoraiya",
  "B.N. College, Bhagalpur",
  "I.D.B.P.S.College, Garh Nokha",
  "Marwari College, Bhagalpur",
  "T.N.B. College, Bhagalpur",
  "CHAMPARAN GROUP OF INSTITUTIONS, MARJADWA PARSA, MAINATAND, WEST CHAMPARAN, BETTIAH",
  "KAMLA RANA SCIENCE COLLEGE, PRASHANT NAGAR SAPARDAH, PURAINI, DIST MADHEPURA ",
  "SHUKLA COLLEGE OF PROFESSIONAL EDUCATION",
  "Skt.College,Rosara",
  "S. Jhunjhunwala Mahila College, Bhagalpur",
  "JP College, Narayanpur",
  "Sabour College, Sabour",
  "RAM CHARITRA SINGH SMARAK COLLEGE, BIHAT, BEGUSARAI, BIHAR",
  "Murarka College, Sultanganj",
  "Tarar College, Tarar",
  "TNB Law College, Bhagalpur",
  "GB College, Naugachia",
  "PRABHU KAILASH NURSING COLLEGE",
  "S.M. College, Bhagalpur",
  "Mahadeo Singh College, Bhagalpur",
  "M.M. College, Bhagalpur",
  "DNS College, Bhusia, Rajoun",
  "Kamla Rai College, Gopalganj",
  "Daroga Prasad Rai Degree College, Siwan",
  "Hari Ram College, Mairwa",
  "Prabhu Nath College, Parsa",
  "Patna Law College",
  "Patna Science College",
  "B. M. College, Barari",
  "DR. PRAKASH CHANDRA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "F. Sanda College, Fatehpur",
  "Sri Ramchand Ram Laxmi Narayan Teachers Training College",
  "Dr. L.K.V.D.College",
  "STMARYNURSINGINSTITUTE",
  "Maa Kamla Chandrika Jee Teachers Training College",
  "LALDHARI MEMORIAL COLLEGE",
  "JANG BAHADUR SINGH MEMORIAL COLLEGE, BIJAULI, AURANGABAD, BIHAR",
  "RAMRATI SUNDAR SHILA COLLEGE DAUDNAGAR, AURANGABAD",
  "ADHIKARI COLLEGE SILAR, AURANGABAD",
  "R S INSTITUTE OF HIGHER EDUCATION",
  "TRIMURTI  MAHAVIDYALAYA, ISMAILPUR, PATNA",
  "D N DEGREE COLLEGE BAKHRI MADHEPURA",
  "R.N.A.R. College",
  "B.D.College",
  "R.P.College Datiana, Bikram",
  "A.M.M. College Benipur",
  "Government Engineering College Nawada",
  "Saryug Dental College",
  "Marwari College",
  "RAM SAKHI DEVI INSTITUTE OF PARAMEDICALS SCIENCE    ",
  "Bali Ram Bhagat College, Samastipur",
  "VIVEKANAND INSTITUTE OF PHARMACY",
  "GOVERNMENT MEDICAL COLLEGE PURNEA",
  "RAJKIYA DEGREE MAHAVIDYALYA",
  "nusrat banu educational welfare society",
  "Bhabha Institute of Education",
  "Teacher Training College",
  "LUV KUSH DEGREE COLLEGE",
  "Ambedkar Institute of Higher Education",
  "R.L.S.Y. College, Anisabad",
  "R.L.S.Y. College, Biharshariff",
  "School of Agribusiness and Rural Management",
  "MAA KAMLA CHANDRIKA JEE VIDYAPEETH",
  "PURNEA COLLEGE OF ENGINEERING, PURNEA",
  "L.B.T. College, Buxar",
  "R.R.P. College, Bhargawan",
  "CHAUDHARY CHARAN SINGH EVENING COLLEGE, BHAGIRATHA, NARWAR, KOCHAS, ROHTAS",
  "DIVINE INSTITUTE OF MANAGEMENT AND STUDIES ",
  " TRISHA NURSING INSTITUTE ",
  "DR KUMAR EDUCATIONAL INSTITUTION",
  "B.S. College, Hata Chenari",
  "C.R. College, Kishanpur,Samastipur",
  "Jan Sahkari D.C. Barap, Garahni",
  "S C S  NAGAR BANKA",
  "B. M.College,Rahika",
  "J.M.D.P.L.M. College",
  "Maharshi Chyawan College, Akhauripur gola, Chousa, Buxar",
  "P.C. College, Buxar",
  "INDIAN INSTITUTE OF HEALTH EDUCATION AND RESEARCH",
  "Bihar College of Physiotherapy & Occupational Therapy",
  "Government Medical College",
  "S.V.P. College, Bhabua",
  "FOOTWEAR DESIGN AND DEVELOPMENT INSTITUTE - PATNA",
  "S.N.M. College, VStan",
  "S.M. College, Dumraon",
  "L.N.Mishra Institute of Economic development and social Change",
  "K.V.Sc. College,",
  "B.N.M.V. College, Sahugadh",
  "J. K. College, Biraul",
  "SHAKUNI CHOUDHARY COLLEGE OF HEALTH AND SCIENCES",
  "DAV Post Graduate College, Siwan",
  "S.N.Skt.College,Chatauni",
  "I.T.S.M. College, Bikramganj",
  "BAIDYANATH INSTITUTE OF NURSING AND  PARAMEDICAL SCIENCES",
  "RAJENDRA KISHORI PHARMACY COLLEGE",
  "Oriental College of Education",
  "D.K.M. College, Dumri",
  "ALAY FATIMA HAI COLLEGE OF NURSING    ",
  "GAUTAM INSTITUTE OF NURSING",
  "College of Arts & Craft",
  "BRAHMDEO SINGH SUMITRA MAHAVIDYALAY BALI WARISALIGANJ NAWADA ",
  "Hotilal Ramnath College, Amnour",
  "Tarkeshwar Narain Agrawal College of Education, Harigaon",
  "PANDIT VEDANAND UMESH MISHRA RAMJANKI COLLEGE, MAHUA",
  "HIMALAYA MEDICAL COLLEGE  AND HOSPITAL ",
  "Gram Bharti College, Ramgarh",
  "Magadh Mahila College",
  "P.L.S.College, Masaurhi",
  "B.L.P. College, Masaurhi",
  "R.P.S. College, Harnaut",
  "SRI RAJ NURSING TRAINING INSTITUTE AND PARA MEDICAL INSTITUTE",
  "SANJAY SINGH YADAV COLLEGE RAFIGANJ",
  "SUBHWANTI INSTITUTE OF PROFESSIONAL EDUCATION",
  "Maharaja College, Ara",
  "Sri Shankar College, Sasaram",
  "Raghunandan Teachers Training College",
  "MAHARANA PRATAP COLLEGE OF EDUCATION",
  "DEV VALLEY GLOBAL SCHOOL OF NURSING",
  "Patna Women's College",
  "SWAMI VIVEKANAND PARA MEDICAL COLLEGE",
  "Bihar College Of Pharmacy",
  "S.P. Jain College, Sasaram",
  "J.M. College,Sakri Kudra",
  "HIMALAYA COLLEGE OF PARAMEDICS",
  "B.N. College, Indour",
  "Jagat Narain Lal College, Khagaul",
  "J.D. Women's College",
  "MATASHRI KAUSHALYA RAMDEV DR GANESH RAI DEGREE COLLEGE",
  "Dr. S.P. Singh College of Teacher Education, Laxmipur, Areraj Road, Post-Shankar Saraiya, Turkaulia, Motihari, East Champaran",
  "HIMALAYA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "Girish Narayan Mishra College, Parsathua,Rohtas",
  "Mahila College, Dalmianagar",
  "Vardhman Mahavir College Pawapuri",
  "HIMALAYA COLLEGE OF NURSING",
  "MAGADH TEACHERs TRAINING BEd COLLEGE, AURANGABAD",
  "Maa Vidya Maa Kusum Teachers Training College",
  "Pr. B.P. Singh College, Simri",
  "D.S. College, Katihar",
  "PRABHU KAILASH ENGINEERING COLLEGE",
  "SHRI NARAYAN SHARMA TEACHERS TRAINING COLLEGE",
  "BHARDWAJ COLLEGE SAKARPURA, HASANPUR ROAD",
  "OXFORD BUSINESS COLLEGE,PATNA",
  "Gaya Evening College",
  "RAMSHARAN YADAV COLLEGE DEOKUND",
  "Patna Institute of Nursing  and Paramedical Science",
  "C.C.S. College, Rajpur",
  "BSC NURSING COLLEGE ANMMCH GAYA",
  "A. N. Magadh Medical College & Hospital",
  "RAJKIYA AYODHYA SHIV KUMARI AYURVEDIC COLLEGE AND HOSPITAL BEGUSARAI",
  "RAM NAGINA SINGH COLLEGE",
  "Madhepura College, Madhepura",
  "KALYAN SEVA SANSTHAN COLLEGE OF PHARMACY",
  "Kisan College, Sohsarai",
  "Bhagalpur College of Engineering",
  "Millia Fakhruddin Ali Ahmad B.Ed. Teacher's Training College, Rambagh",
  "National Institute of Health Education and Research",
  "SAI BABA INSTITUTE OF PHARMACEUTICAL SCIENCES, MUZAFFARPUR",
  "ACHARYA DHRUBASHA COLLEGE OF HEALTH EDUCATION",
  "R.S.D.College, Bhagwanpur",
  "Rajendra College, Chapra",
  "B. M. A. College",
  "Rural Inst. of H.E., Birauli",
  "SKR College, Barbigha",
  "Sai college of Teachers Training ,Onama",
  "RS College, Tarapur",
  "K R NURSING COLLEGE AND HOSPITAL",
  "R.S. College, Tilouthu",
  "  SMRITI COLLEGE OF TECHNOLOGY AND MANAGEMENT",
  "PURNEA BUSINESS COLLEGE",
  " MATRI PREM COLLEGE OF EDUCATION",
  "   GURU PRAKASH B.ED. COLLEGE",
  "SARVODAY B.ED. COLLEGE",
  "Dharikshan Singh Teachers Training College",
  " G.D. MISHRA INSTITUTE OF HIGHER STUDIES",
  "Shershah College, Sasaram",
  "NITESH KUMAR SMARAK MAHAVIDYALAY PAHARPURTOI VAISHALI",
  "MAHAVIR UPADHYAY MEMORIAL DEGREE COLLEGE DHAKA EAST CHAMPARAN",
  "SRI RAM JANKI SWAMI SAHJANAND SARASWATI SNATAK MAHAVIDYALAYA",
  "LALGANJ MAHAVIDYALAY LALGANJ",
  "SAI COLLEGE OF PHARMACY",
  "VITTHAL COLLEGE OF EDUCATION",
  "G.M.Skt.College,Bangaon",
  "M.M. Mahila College, Ara",
  "V.K.S. College, Dharupur",
  "Patliputra College of Nursing",
  "R.B.S. College, Teyai",
  "Ram Jaipal College, Chapra",
  "GAUTAM INSTITUTE OF PHARMACY",
  "M.M.College, Chandi",
  "Jai Prakash Mahila College, Chapra",
  "Koshi College, Khagaria",
  "RD & DJ College, Munger",
  "RD College. Sheikhpura",
  "Harinarayan Singh Institute of Teachers Education, Sasaram",
  "Rahmani B.Ed. College, Munger",
  "Mahila College, Khagaria",
  "J P COLLEGE OF PHARMACY",
  "KSS College, Lakhisarai",
  "JMS College, Munger",
  "Jagjiwan College, Ara",
  "RAM LAGAN RAY DEGREE COLLEGE RAJAPAKAR VAISHALI",
  "CHANDRAGUPTA MAURYA COLLEGE OF EDUCATION",
  "Anjabit Singh College, Bikramganj",
  "CHANAKYA FOUNDATION",
  "Dr. K.K. Mandal College, Jagdishpur",
  "RAVI KANT PUNAM B ED COLLEGE",
  "L. P. SHAHI INSTITUTE OF TEACHER S EDUCATION",
  "Mahavir College",
  "H.D. Jain College, Ara",
  "S.P.Y. College",
  "D.B.K.N. College",
  "VIDYAPATI INSTITUTE OF HIGHER EDUCATION",
  "Bahera College, Bahera",
  "Jamalpur College, Jamalpur",
  "HS College, Haweli Kharagpur",
  "GOVERNMENT DEGREE COLLEGE, RAJGIR, NALANDA",
  "MOD NARAYAN MAHAVIDYALAYA AMBA SHAHKUND BHAGALPUR",
  "RAM SHARAN ROY COLLEGE OF PHARMACY",
  "URMILA DEVI SADANAND YADAV GURUKUL DEGREE COLLEGE",
  "CHANAKYA COLLEGE OF EDUCATION",
  "CNB College, Hathiama, Sheikhpura",
  "LALAN PRASAD YADAV COLLEGE BELAGANJ GAYA",
  "VISHUN RAJDEO TEACHERS TRAINING COLLEGE",
  "SARAN INSTITUTE OF MEDICAL SCIENCES NURSING COLLEGE",
  "B.S. Vidhi Sansthan, Munger",
  "Sachchidanand College, Shahmal Khaira-deo, Rohtas",
  "BRM College, Munger",
  "BNM College, Barhaiya",
  "R.C.S. College",
  "M. L.S. College",
  "TAPESHWAR SINGH TEACHERS TRAINING COLLEGE, KAYAMNAGAR",
  "CHAITANYA INTERNATIONAL BUSINESS COLLEGE",
  "M S Y COLLEGE KINZAR MIRZAPUR ARWAL",
  "ADITYANATH MEMORIAL COLLEGE",
  "Lalit Narayan Janta College ",
  "A.N.S. College, Barh",
  "A.N.College",
  "Z.A.T. T. College. Bahera",
  "KURMA SANSKRITI INSTITUTE OF PHARMACEUTICAL SCIENCE,JEHANABAD",
  "DHANRAJ BHAGAT DEGREE MAHAVIDYALAYA, MUSTAFAGANJ, MINAPUR, MUZAFFARPUR",
  "ALHAJ NAIMUDDIN SHAHIDI COLLEGE",
  "OXFORD COLLEGE OF RESEARCH AND MANAGEMENT",
  "U.R. College, Rosera",
  "BISHWANATH ROY DEGREE COLLEGE, NIRPUR, PATEPUR, VAISHALI",
  "Gyan Prakash Swami Vivekanand Teachers Training B.Ed. College",
  "CHAITANYA COLLEGE OF IT AND MANAGEMENT",
  "Balmiki Teachers Training College",
  "GNM TRAINING SCHOOL, NOONGARH, LAKHISARAI",
  "GOVERNMENT DENTAL COLLEGE AND HOSPITAL",
  "EVENING COLLEGE, MADHEPURA",
  "M. R. M. College",
  "ISLAMIA TEACHERS TRAINING (B.Ed.) COLLEGE ",
  "N.Jha M. College Lsarai",
  "A. N. Sinha Institute of Social Studies",
  "Ramadhin Mishra Bhaskaroday Sanskrit College, Deorahia, Buxar",
  "JRS College, Jamalpur",
  "D.B. College",
  "Prithwi Chand Vigyan College, Chapra",
  "Dr. Z.H.T.T. College",
  "B R DEGREE COLLEGE",
  "Deshratna Rajendra Degree College, Ziradei",
  "Jagdam College, Chapra",
  "C.M.B. College",
  "C. M. College (Arts & Commerce)",
  "MAA SHARDA COLLEGE OF TECHNICAL EDUCATION AND RESEARCH",
  "P.L.M. College Jhanjharpur",
  "MR.S.M. College Anandpur",
  "C.M.J. College",
  "Bhola Paswan Shastri Agricultural College, Purnia",
  "K.N. Singh College, Itarhi, Buxar",
  "Mazhrul Haque Degree College, Tarwara",
  "St Paul Teachers Training College Birsinghpur",
  "R.L.S.R.S.M. College,",
  "SONAWATI COLLEGE OF EDUCATION",
  "Amaltas College of Education",
  "K.S. College of Professional Education",
  "LNBJ Mahila College, Bhramarpur",
  "Lal Singh Tyagi Gramin Mahavidyalaya, Aungaridham, Nalanda",
  "Vaishali Institute of Business and Rural Management",
  "R.S. COLLEGE OF EDUCATION, BARE, KAIMUR",
  "SAHEED RAVIKANT MEMORIAL B.Ed. COLLEGE, DALSAGAR, BUXAR",
  "PANDIT DEENDAYAL UPADHYAY COLLEGE OF HORTICULTURE AND FORESTRY, PIPRAKOTHI",
  "S.N.S.R.K.S. College, Saharsa",
  "KANTI DEVI TEACHER TRAINING COLLEGE",
  "BAIDYANATH COLLEGE OF EDUCATION",
  "Sidheswari Laxminath Sanskrit.College,Gajahara",
  "SHYAM SCHOOL OF EDUCATION",
  "RAM SHARAN ROY COLLEGE PANAPUR MAKKANPUR",
  "J. P. SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA",
  "Baikunth Teachers Training College",
  "Mathura Singh Teacher Training College",
  "K.B.Women's College,Madhepura",
  "DASHRATH PRASAD RAMNANDAN PANDEY B.Ed COLLEGE",
  "SATYANAM SATYAGURU B ED COLLEGE",
  "GEETA PRASAD SINGH COLLEGE OF COMMERCE AN EVENING COLLEGE, MUZAFFARPUR    ",
  "BHARTI SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA",
  "ASIAN INSTITUTE OF MANAGEMENT AND INFORMATION TECHNOLOGY AIMIT",
  "MAHESH SINGH B.ED COLLEGE",
  "Maharshi Menhi Homoeopathic Medical College And Hospital, Katihar",
  "BISHUNPAT DEVI LAW COLLEGE",
  "SATYAM INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "KURMA SANSKRITI INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "DR. B.R. AMBEDKAR COLLEGE OF EDUCATION",
  "C M College, Mandar Bounsi",
  "RAMADHAR SINGH TEACHERS TRAINING COLLEGE",
  "Acharya Drona Institute For Teachers Training",
  "G.M.H.P. College, Bagaha",
  "BASUNDHARA TEACHERS  TRAINING COLLEGE",
  "RADHA DEVI JAGESHWARI MEMORIAL MEDICAL COLLEGE AND HOSPITAL    ",
  "APSAM COLLEGE OF EDUCATION, UTARWARI JUNGAL,  JAGDISHPUR",
  "MATA MANJHARO AJABDAYAL SINGH TEACHERS TRAINING COLLEGE, DULAOUR, JAGDISHPUR",
  "Khawaja Shahid Hussain Primary Teacher's Training College, Nista ",
  "BIHAR COLLEGE OF EDUCATION, GIDHA",
  "DR. ZAKIR HUSSAIN INSTITUE FOR NON-FORMAL & CONTINUING EDUCATION PATNA",
  "SHREE B P MEMORIAL INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "RAMESHWAR SINGH TEACHERS TRAINING COLLEGE",
  "SIDDIQUE MEMORIAL TEACHER TRAINING COLLEGE",
  "CHANCHAL SUMAN NURSING COLLEGE    ",
  "PANDIT UGAM PANDEY COLLEGE, MOTIHARI",
  "SUBHWANTI INSTITUTE OF EDUCATION",
  "SOLANKI B.Ed. TEACHERS TRAINING COLLGE",
  "St. Xavier's College of Education",
  "J.L.College, Hajipur",
  "CHETAN SADHAN INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "KGI School of Education",
  "Cimage Professional College",
  "Raja Singh College, Siwan",
  "KAMTA PRASAD SINHA COLLEGE CHIKSI PALIGANJ",
  "DR RAM BALAK ROY MAHAVIDYALAYA",
  "Crescent School of Education and Training",
  "Jitendra Kumar Yadav College, Gaya",
  "College of Teacher Education, Bhagalpur",
  "Govt. Teacher's Training College, Saharsa",
  "Govt. Teacher's Training College, Gaya",
  "Ram Bilas Ganga Ram College, Maharajganj",
  "P.Sc. College, Madhepura",
  "Bihar National College",
  "H.S. College, Udakishunganj",
  "MAA BAGESHWARI COLLEGE GAYA",
  "RAHMANIA INSTITUTE OF NURSING AND PARAMEDICAL SCIENCE MOTIHARI EAST CHAMPARAN     ",
  "L.N.M.S. College, Birpur",
  "R.M.M. Law College, Saharsa",
  "B.B.M. College, Okari",
  "Gaya College, Gaya",
  "M.A.Rameshwar Lata Sanskrit College, Darbhanga",
  "INDIAN INSTITUTE OF BUSINESS MANAGEMENT, PATNA",
  "Maulana Azad College of Engineering and Technology",
  "Maharshi Vishwamitra mahavidyalaya, Buxar",
  "SHUKDEO MUKHLAL DEGREE COLLEGE, HAJIPUR, VAISHALI",
  "BHAGWAN MAHAVEER MAHAVIDYALAYA    ",
  "USHA INSTITUTE OF PROFESSIONAL EDUCATION    ",
  "J. N. College, Nehra",
  "Satyendra Kishan College of Education",
  "VESTOR COLLEGE OF MANAGEMENT, JAKARIAPUR, PATNA    ",
  "A.H.S.A.  College",
  "NAROTTAM MISHRA MEMORIAL COLLEGE, NARWARA TARIYANI, SHEOHAR",
  "Sushila Sujata B.Ed. College",
  "Vidya College of Professional Studies",
  "G.R.Skt.College,Bairgainea",
  "Yadunandan College, Dighwara",
  "S.N.Sinha College,",
  "Allama iqbal College,Biharshariff",
  "R.K.A. Vidhi College",
  "S. D. Law College, Katihar",
  "Nehru College, Bahadurganj",
  "Katihar Teaches Training College,   Sirsa",
  "J.D.S.S. Mahila College, Forbishang",
  "sundaram International Institute Of Higher Studies",
  "G.L.M. College, Banmankhi",
  "L.N. College, Bangow",
  "A. M. Degree College, Araria",
  "sukhdeo narayan lal bahadur sita ram memorial b.ed college",
  "Scholars College of Education",
  "Satyam International Institute Of Higher Studies",
  "Mata Sushila Institute of Education",
  "MAA TARA INSTITUTE OF TECHNICAL EDUCATION",
  "MAA BACCHAN DEVI TEACHER TRAINING COLLEGE",
  "Gautam Teachers Training College",
  "R.Jha Mahila College, Saharsa",
  "BSC NURSING COLLEGE GOVERNMENT MEDICAL COLLEGE AND HOSPITAL BETTIAH",
  "KDS College, Gogri",
  "LUV KUSH NURSING INSTITUTE",
  "Degree College, Supaul",
  "S.P.M. Law College, Madhepura",
  "HARI PRASAD SAH COLLEGE, NIRMALI",
  "DASHRATH PRASAD SINGH INSTITUTE OF TEACHERS EDUCATION",
  "SRI KRISHNA MANORAMA SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA",
  "SHARDA GIRDHARI KESHRI COLLEGE MAHESHKHUNT",
  "A.B.S.College, Lalganj",
  "Vikramaditya College of Education",
  "Nezamia College of Education",
  "RAM KRIPAL SINGH TEACHER TRAINING COLLEGE, ARAUT",
  "D.N. College, Masaurhi",
  "Tarkeshwar Prsasad Verma College, Narkatiyaganj",
  "SAI BABA COLLEGE OF EDUCATION",
  "Bhuvan Malti College of Education",
  "MAHAMAYA COLLEGE OF EDUCATION VILL-DEVKALI, PO-SARSAULI,PS-OBRA",
  "VIVEKANAND VIPF INSTITUTE OF EDUCATION",
  "MAUNI BABA YAMUNA DAS LAKHRAJO DEVI MAHILA MAHAVIDYALAYA, BIKRAMGANJ, ROHTAS    ",
  "BHAGWAN PRASAD SHEONATH PRASAD BED COLLEGE DUADNAGAR AURANGABAD",
  "B.P. Azad College of Education",
  "BASUDEO SINGH MEMORIAL B. ED. COLLEGE, MASHRAK, SARAN",
  "CHANDRASHEEL COLLEGE OF EDUCATION",
  "SHIVAM COLLEGE OF HIGHER STUDIES",
  "M.L.T. College, Saharsa",
  "B.S.S. College, Supaul",
  "Sheopujan Shastri Samta College, Dinara, Rohtas",
  "MOTHER S INTERNATIONAL TEACHERS TRAINING ACADEMY",
  "S.R.P.Skt.College,Patepur,Vaishali",
  "S.K.M.College,",
  "A.N.S.College",
  "Gyan Bharti Teachers Training College",
  "MODERN COLLEGE OF EDUCATION",
  "Jaglal Chaudhary College, Chapra",
  "MAGADH TEACHERS TRAINING COLLEGE, GAYA",
  "RURAL TEACHERS TRAINING COLLEGE",
  "BIYOG LAL CHAUDHARY DEGREE COLLEGE JANDAHA",
  "ALIGARH MUSLIM UNIVERSITY KISHANGANJ CENTRE, BIHAR",
  "S. A. College of Eduation",
  "MAA BACHCHAN DEVI BED COLLEGE",
  "Evening College, Saharsa",
  "Millat College",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, PATNA",
  "BSC NURSING COLLEGE SKMCH",
  "S.R.N.D.M.Skt.College,Patnacity",
  "KIRAN T T COLLEGE DAHIVAT NAVRATTAN",
  "SWAMI VIVEKANAND B ED T T COLLEGE BASUDEOPUR",
  "SATI BHARAT COLLEGE PARARI",
  "DR GAURI BRAHMANAND T T COLLEGE BALLOPUR",
  "GANAURI RAMKALI TEACHERS TRAINING COLLEGE",
  "RAMESHWAR LAXMI MAHTO TEACHERS TRAINING COLLEGE ROSERA",
  "ASHARFI KUNWAR RAM RATAN RAI MAHAVIDALAYA KOTWA ROAD",
  "K.B. Jha College, Katihar",
  "R.M.W. College",
  "Mata Rojhni  Devi Chhathu Ram Degree College, Mairwa",
  "Vidya Bhawan Mahila College,Siwan",
  "Purvottar  Railway College,Sonpur",
  "HIMALAYA LAW COLLEGE",
  "V.S.J. College",
  "Govt Home Science College,Sector-10",
  "D.A.V.College, Sector 10",
  "Regional Institute of English, Sector-32",
  "Govt College of Commerce & Business Administration, Sector-50",
  "Dev Samaj College of Education, Sector 36-B, Chandigarh",
  "Brahmrishi Yoga Training College, Sector-19",
  "Govt. College of Education, Sector-20",
  "G.G.D.S.D.College, Sector-32",
  "Govt College of Art Sector-10",
  "Sri Guru Gobind Singh College, Sector-26",
  "Govt. College of Yoga Education & Health, Sector-23",
  "POST GRADUATE GOVERNMENT COLLEGE FOR GIRLS, SECTOR-11 CHANDIGARH",
  "Govt Medical College & Hospital, Sector-32",
  "Post Graduate Government College, Sector-11",
  "Dev Samaj College for Women, Sector-45 B",
  "Chandigarh College of  Engineering & Technology (Degree Wing), Sector-26",
  "Post Graduate Government College, Sector-46",
  "Regional institute of Mentally Handicapped, Sector-31",
  "Chandigarh College of Architecture Sector-12",
  "M.C.M.D.A.V.College For Women, Sector 36 A",
  "Govt Post Graduate College for Girls,Sector-42",
  "Shri Dhanwantry Ayurvedic  College & Hospital Sector-46 B",
  "Guru Gobind Singh  College for Women , Sector-26",
  "Homoeopathic Medical College & Hospital, Sector-26",
  " Bhanupratap Deo Govt. P.G. College Kanker CG.",
  "Govt. College, Silphili",
  "NMDC DAV Polytechnic Dantewada",
  "Government Mahendra Karma Girls College ",
  "Govt. Danteshwari PG College Dantewada",
  "KONDAGAON COLLAGE OF NURSING",
  "Govt.Swami Atmanand  Post Graduate College Narayanpur (C.G.)",
  "COLLEGE OF HORTICULTURE AND RESEARCH STATION, GAURELLA PENDRA MARWAHI",
  "VAIDEK MAHAVIDHYALAYA SEEPAT",
  "Govt. Bilasa Girls PG College, Bilaspur",
  "INSTITUTE OF NURSING RESEARCH CENTRE SURAJPUR",
  "J E S  College of nursing",
  "Shubham Shikshan Mahavidhyalaya, Shubham Shikshan Ssmiti, Vidya Vihar Mahavidyalaya Parisar, Shubham vihar, Bilaspur",
  "Jyoti Bhushan Pratap Singh Law College, Korba",
  "Govt. J.M.P. College, Takhatpur",
  "Mata Karma Arts/Commerce College, Kusmunda, Korba",
  "Modern College of Management & Information Technology, Korba",
  "Govt. E. V. Post Graduate College, Korba",
  "Govt. Naveen College, Konta",
  "Shri Rawatpura Sarkar College of Education, Naya Raipur",
  "College of Dairy Technology",
  "College of Fisheries",
  "College of Veterinary Science & Animal Husbandry",
  "CAREER COLLEGE OF NURSING, RAIGARH",
  "Govt. College Of Nursing, Durg",
  "Badri Prasad Lodhi Post Graduate Government College, Arang",
  "SANT GURU GHASIDAS COLLEGE OF EDUCATION",
  "CIT SCIENCE AND COMMERCE COLLEGE BHELWADIH ABHANPUR RAIPUR",
  "Holy Cross Women's College, Ambikapur",
  "Govt. Polytechnic , Jashpur.",
  "Chhattisgarh Engineering College Borsi, Dhanora Road",
  "Shri Rawatpura Sarkar Institute Behind Holiday Resort, G E Road,",
  "Chhatrapati Shivaji Institute of Technology Kolihapuri, P O Pisegaon",
  "Chouksey Engineering College  Lal Khadan,  Masturi Road",
  "Govt.Polytechnic, Durg",
  "Columbia Institute of Engineering and Technology Bhurkoni, Post Tekari",
  "Ashoka Institute of  Technology and Management",
  "Disha Institute of  Management and Technology Satya Vihar,",
  "J K Institute of Pharmacy Near Gatora Railway Station",
  "Govt.Polytechnic, Takhatpur",
  "Govt.Polytechnic, Kabirdham Kawardha",
  "Govt. Polytechnic Mahasamund",
  "Bharti College of Engineering and Technology",
  "Royal College of Pharmacy Sanjay Nagar, Ring Road No 1",
  "IBT College of Diploma Engg.,Berla Road, Ahiwara, Nandini Road",
  "Moulana Abul Kalam Azad College of Pharmacy Navdurga Nagar, Mathpurena",
  "Govt. Polytechnic, Narayanpur",
  "Govt. Polytechnic Bijapur",
  "Govt.Polytechnic, Ambikapur",
  "Govt. Girls Polytechnic Bilaspur",
  "Yugantar Institute of Technology and Management  Ramdhin Marg,",
  "SHRISHTI NURSING COLLEGE, GUJARATI SHIKSHAN SANGH PARISAR, JAI STAMBH CHOWK, RAIPUR",
  "RITEE COLLEGE OF EDUCATION, RAIPUR",
  "DAIRY POLYTECHNIC TAKHATPUR DISTRICT BILASPUR",
  "DAIRY POLYTECHNIC BEMETARA DISTRICT BEMETARA",
  "GRACIOUS COLLEGE OF PHARMACY BELBHATA ABHANPUR",
  "GOVT NAVEEN COLLEGE GOHARAPADAR",
  "RITEE COLLEGE OF MANAGEMENT ",
  "GOVT NAVEEN COLLEGE NARHARPUR",
  "GOVERNMENT POLYTECHNIC MARWAHI",
  "DBM INSTITUTE OF PHARMACY",
  "GOVT NAVEEN COLLEGE AAMDI ",
  "LCIT SCHOOL OF PHARMACY",
  "GOVERNMENT SCIENCE COLLEGE, AMBIKAPUR",
  "Govt.Madan Lal Shukla College, Seepat (Bilaspur)",
  "GURUKUL NURSING COLLEGE",
  "CHHATTISGARH PHARMACY COLLEGE DHANORA , DURG",
  "BHARTI COLLEGE OF PHARMACY",
  "NAVEEN GOVERNMENT GIRLS COLLEGE GAURELA PENDRA MARWAHI",
  "COLLEGE OF HORTICULTURE AND RESEARCH STATION SANKARA PATAN DIST DURG CG",
  "RAIGARH MEDICAL COLLEGE AND HOSPITAL OF AYURVEDA KOTRAPALI RAIGARH",
  "Govt.Polytechnic, Janjgir Champa",
  "LEELA DEVI COLLEGE OF PHARMACY",
  "SHYAMLAL MEMORIAL COLLEGE PUSSORE",
  "COLLEGE OF AGRICULTURE AND RESEARCH STATION, PRATAPPUR",
  "R N DUBEY COLLEGE OF PHARMACY KHORSI",
  "VIDYA SAGAR MAHAVIDYALAYA, BARIDIH, RATANPUR, BILASPUR    ",
  "MONA COLLEGE OF PHARMACY SARANGARH",
  "Rims College of Nursing, Bhansoj Raod,Gram - Godhi Dist. - Raipur (C.G.)",
  "NAVEEN  SHASKIYA SANGEET  MAHAVIDHYALAYA,  JAGDALPUR JILA BASTAR",
  "SHRI RAWATPURA SARKAR INSTITUTE OF MEDICAL SCIENCES AND RESEARCH    ",
  "SEVAK RAM SAHU COLLEGE FULWARI DISTRICT MUNGELI CHHATTISGARH",
  "NAVEEN GOVT COLLEGE GHOTIYA",
  "D L S PHARMACY COLLEGE",
  "NAVIN SHASKIYA SANGEET MAHAVIDYALAYA BILASPUR",
  "GOVERNMENT NAVEEN COLLEGE SARAGAON JANJGIR CHAMPA ",
  "NAVEEN SHASHKIYA SANGEET MAHAVIDYALAYA, DURG",
  "SHRI SAI PHARMACY COLLEGE",
  "RUNGTA COLLEGE OF PHARMACEUTICAL SCIENCES AND RESEARCH RAIPUR",
  "SITA RAM KASHYAP COLLEGE OF PHARMACY",
  "Govt. Digvijay Snatkottar Swashashi Mahavidyalaya, Rajnandgaon",
  "VISHNUKANTI COLLEGE CHHITAPAR LORMI DISTRICT MUNGELI CHHATTISGARH",
  "SWAMI ATMANAND GOVERNMENT ENGLISH MEDIUM MODEL COLLEGE",
  "GOVT NAVEEN COLLEGE KELHARI",
  "Govt. College, Batouli Dist. Surguja (C.G)",
  "Late Bindeshwari Baghel Government College, Kumhari",
  "JAGRANI DEVI COLLEGE BIRRA",
  "JAGRANI DEVI COLLEGE BAMHANIDIH",
  "KANGALU KUMHAR GOVERNMENT COLLEGE DURGKONDAL",
  "GLD INSTITUTE OF PHARMACEUTICAL SCIENCE  ",
  "\"Swa. Pyarelal Kanwar\" Govt College, Bhaisma, Dist-Korba",
  "ARUN PRATAP SINGH DEV GOVERNMENT COLLEGE, SHANKARGARH",
  "LCIT COLLEGE OF PHARMACY ",
  "Pratibha Institute of Nursing",
  "BIRENDRA DEEPAK COLLEGE OF NURSING JAMGAON FINGESHWAR",
  "RAJWADE INSTITUTE OF NURSING",
  "GYANROSHANI MAHAVIDYALAY JANJGIR DIST JANJGIR CHAMPA  CG",
  "CAREER COLLEGE,  RAIGARH ",
  "NAVEEN GOVERNMENT COLLEGE AKALTARI",
  "GOVT NAVEEN COLLEGE JATGA",
  "DBM COLLEGE OF PHARMACY ",
  "GOVT NAVEEN COLLEGE KAMLESHWARPUR MANPAT",
  "RUNGTA INSTITUTE OF SCIENCE AND MANAGEMENT ",
  "L A M Medical College, Raigarh",
  "GOVERNMENT  RAJKUMAR DHIRAJ SINGH COLLEGE, UDAIPUR",
  "Swargiya Shri Mahali Bhagat Shaskiya Snatak Mahavidyalaya, Kusmi",
  "Govt. College, Rajpur District Balrampur-ramanujganj c.g.",
  "Govt. Sant Rameshwar Gahira Guru Ji College, Bagicha",
  "Govt. College Bishrampur",
  "Govt.Rani Durgawati  College, Wadrafnager, Balrampur",
  "Govt. Vijay Bhushan Singhdeo Girls College, Jashpur Nagar",
  "Vedanti Vidya Nursing Institute, Berla Bemetara",
  "NAYANTARA SHARMA MAHAVIDYALAYA ,PANDHI BILASPUR",
  "RABINDRANATH TAGORE MAHAVIDYALAYA MURMUNDA DHAMDHA DURG",
  "DURGA KANYA MAHAVIDYALAYA KHAMHARIYA MADAI ",
  "Lovekush Institute of Nursing",
  "Shri Ram College Vill+post Saragaon Raipur",
  "Govt. G. N. A. P.G. College, Bhatapara",
  "MAHARANA PRATAP MAHAVIDYALA USLAPUR SAKARI",
  "RANI PADMAVATI MAHAVIDYALAYA LORMI",
  "CHAITANYA COLLEGE PAMGARH",
  "Shri Shankaracharya Mahavidyalaya, Junwani Bhilai",
  "Govt.  Naveen College, Mangchuwa",
  "SARDAR BHAGAT SINGH COLLEGE BELGAHNA BLOCK KOTA DIST BILASPUR",
  "SHRI BIRENDRA DEEPAK SHIKSHA MAHAVIDYALAYA, JAMGAON",
  "GOVERNMENT MAA MAHAMAYA COLLEGE, KHADGAWAN, DIST: MANENDRAGARH-CHIRMIRI-BHARATPUR (C.G.) ",
  "AARBEE College of Nursing",
  "Govt. Rewati Raman Mishra Post Graduate College, Surajpur",
  "KRISHNA COLLEGE PALI, DISTRICT KORBA",
  "COMP-TECH MAHAVIDYALAYA",
  "GOVERNMENT COLLEGE SANAWAL",
  "SHRI RAWATPURA SARKAR COLLEGE OF EDUCATION, DHANELI, RAIPUR",
  "Govt. Nursing College Rajnandgaon",
  "Saraswati Mahavidyalaya, Subhashnagar, Ambikapur",
  "College of Agriculture,Janjgir",
  "Disha Institute of Medical Sciences",
  "College of Agriculture,Raipur",
  "Shri Ram Sangeet Mahavidyalaya,Raipur",
  "Bhatkhande Sangeet Mahavidyalaya,Bilaspur-495001",
  "SHRI MAHAVIR NATURAL, PRAKRITIK & YOGA, VIGYAN MAHAVIDYALAYA, PARAS NAGAR, NAGPURA",
  "MODERN MEDICAL INSTITUTE OF NURSING, LALPUR",
  "NAVEEN GOVERNMENT COLLEGE MANA CAMP RAIPUR    ",
  "MARGDARSAN INSTITUTE COLLEGE OF NURSING, SHRI SARWESHWARI NAGAR, BAIKUNTHPUR",
  "RASTOGI COLLEGE OF NURSING, MODEL TOWN, NEHRU NAGAR (EAST) BHILAI",
  "GOVERNMENT NAVEEN COLLEGE KUI KUKDUR",
  "R.I.T.E.E. NURSING COLLEGE, MANDIR HASOUD, CHHATAUNA",
  "GRACIOUS COLLEGE",
  "SHRI MAHAVEER MAHAVIDYALAY ",
  "MAA DIDINESHWARI MAHAVIDYALAYA MALHAR MASTURI DIST BILASPUR    ",
  "JES COLLEGE FARHADA BILASPUR",
  "COLLEGE OF NURSING APOLLO HOSPITAL, VILL-LINGYADIH, SEEPAT ROAD",
  "GOVT. DENTAL COLLEGE ,BEHIND OF RAJBANDHA GROUND,IN FRONT OF MARHI MATA TEMPLE",
  "M.J.COLLEGE OF NURSING, KOHKA JUNWANI ROAD, NEAR C.B.S.C. SUBSTATION, BHILAI",
  "LIFE CARE COLLEGE OF NURSING BALODABAZAR",
  "ST THOMAS COLLEGE, KAILASH NAGAR, BHILAI",
  "Veterinary Polytechnic Rajnandgaon",
  "KHADYA PRAUDOUGIKI MAHAVIDHYALAYA RAIPUR",
  "GAYATRI COLLEG OF PHARMAACY DANTEWADA",
  "GOVERNMENT BED COLLEGE KANKER ",
  "NAVEEN GOVT GIRLS COLLEGE GARIABAND    ",
  "GOVT NAVEEN COLLEGE PIRDA",
  "COLLEGE OF NURSING, MEDUKA, PENDRA ROAD",
  "AASRA MAHAVIDYALAYA",
  "GOVT NAVEEN COLLEGE BORTARA",
  "DEV SANSKRITI COLLEGE OF EDUCATION & TECHNOLOGY",
  "NAVEEN SHASAKIYA KANYA MAHAVIDYALAYA, MANENDRAGARH CHIRIMIRI BHARATPUR",
  "PARAM ADARSH SWAMI VIVEKANAND MAHAVIDYALAYA ,BALODA BAZAR    ",
  "SHRI CHANDRA NURSING INSTITUTE, G.ROAD, POLYTECHNIC COLLEGE, G.E. ROAD, AMIT MEDICAL STORES, SINDHI COLONY",
  "BETHNI COLLEGE OF NURSING,BORSI ROAD",
  "PT. J.N.M. MEDICAL COLLEGE, RAIPUR",
  "GOVT.B.SC.NURSING COLLEGE, CIMS CAMPUS, BILASPUR",
  "CHHATTISGARH NURSING COLLEGE,DHANORA ROAD",
  "C.G. COLLEGE OF NURSING, SECT.-02, BAJAJ COLONY, NEW RAJENDRA NAGAR",
  "CHHATTISGARH INSTITUTE OF TECHNOLOGY, RAIGARH",
  "GOVT. MEDICAL COLLEGE, JAGDALPUR",
  "GOVT. B.SC.NURSING COLLEGE, NEAR AMANAKA THANA, DUMAR TALAB, IN FRONT OF KANCHAN VIHAR (SINHA BHAWAN)",
  "APPOLO COLLEGE OF PHYSIOTHERAPY, IN FRONT OF GOVT. VETERINARY COLLEGE, ANJORA",
  "TRIVENI INSTITUTE OF DENTAL SCIENCES HOSPITAL & RESEARCH CENTRE, VIDYASTHALI, RAIPUR ROAD, VILL-BODRI",
  "SURYA COLLEGE OF NURSING, LINK ROAD, PARSHURAM BHAWAN",
  "College of Information Tech. & Applied Social Science Bilaspur",
  "Govt. Swami Vivekanand  College, Bodla, Kabirdham",
  "D.P. Vipra Law College, Bilaspur",
  "GOVT NAVEEN GIRLS COLLEGE SURAJPUR",
  "Pt. Devi Prasad Choubey  Govt. College Saja",
  "Dr. Bhanvar Singh Porte Govt. College, Pendra (Bilaspur)",
  "PANDIT RAVISHANKAR TRIPATHI GOVERNMENT COLLEGE BHAIYATHAN DISTRICT SURAJPUR",
  "ATAL BIHARI VAJPAYEE GOVERNMENT COLLEGE PANDATARAI, KABIRDHAM",
  "Shanti Niketan College, Bilaspur",
  "COLLEGE OF FORESTRY AND RESEARCH STATION SANKRA PATAN DURG",
  "COLLEGE OF HORTICULTURE ARJUNDA",
  "COLLEGE OF HORTICULTURE AND RESEARCH STATION SILPHILI, SURAJPUR CHHATTISGARH",
  "Government Naveen College Bagbahar",
  "COLLEGE OF HORTICULTURE BEMETARA",
  "Kaushalendra Rao Law College",
  "NAVEEN GOVT GIRLS COLLEGE SAKTI",
  "COLLEGE OF HORTICULTURE DHAMTARI",
  "DBM COLLEGE",
  "KRUTI INSTITUTE OF JOURNALISM AND MASS COMMUNICATION",
  "Govt. Ramanuj Pratap Singhdeo Post Graduate College, Baikunthpur, District - Korea, (C.G.)",
  "Govt. Shaheed Bapurao PG College Sukama",
  "NAVEEN GOVT GIRLS COLLEGE SARANGARH",
  "NAVEEN GOVT KANYA COLLEGE MOHALA ",
  "Gayatri College of Nursing, Dantewada",
  "ANANT COLLEGE",
  "ARIECENT COLLEGE OF EDUCATION",
  "Ariecent College, Raigarh",
  "Arts/Science College, Baloda",
  "ATAL BIHARI VAJPAYEE GOVT.COLLEGE NAGARDA",
  "Batmul Aashram College, Salheona",
  "Girls Arts/Comm.College, Kharsia",
  "GOVERNMENT JAJWALYADEV NAVEEN GIRLS COLLEGE JANJGIR (C.G.)",
  "COLLEGE OF HORTICULTURE JASHPUR",
  "College of Horticulture,Rajnandgaon",
  "GOVERNMENT NAVEEN COLLEGE CHANDRAPUR ",
  "COLLEGE OF HORTICULTURE & RESEARCH STATION, JAGDALPUR",
  "MOTHER TERESA COLLEGE OF NURSING, RAWATPURA SARKAR INSTITUTE, VILL-CHORHA, KUMHARI",
  "DR. SHAKRAJEET NAIK GOVERNMENT COLLEGE, BARAMKELA",
  "GOVT.COLLEGE OF NURSING ,KAWARDHA,OLD DISTT. HOSPITAL CAMPUS",
  "C.P.M. Arts/Science College, Sarangarh",
  "DR JYOTI BRIJBHOOSHAN DWIVEDI ARTS AND SCIENCE COLLEGE SAKTI ",
  "CENTRAL INDIA COLLEGE OF NURSING, G.E.ROAD, KOPEDIH ROAD, DEVADA",
  "DR RADHAKRISHNA COMPUTER COLLEGE, BALODA",
  "Govt.Lochan Prasad Pandey College, Sarangarh",
  "GOVT. INDARU KENWAT GIRLS' COLLEGE, KANKER, CHHATTISGARH",
  "Govt. Mahatma Gandhi P.G. College, Kharsia,",
  "Govt. M.M.R. P.G. COLLEGE, CHAMPA",
  "GOVT NAVEEN COLLEGE BIRRA ",
  "RAIPUR HOMOEOPATHIC COLLEGE, NEAR SHITLAMATA MANDIR, RAMKUND",
  "Govt. College, Tamnar, Raigarh",
  "SCHOOL AND COLLEGE OF NURSING DHAMTARI CHRISTIAN HOSPITAL, DHAMTARI",
  "GOVT. DEGREE  COLLEGE, DABHARA",
  "Govt. Kanti Kumar Bhartiya College, Sakti, Dist.- Janjgir- Champa",
  "Govt. Laxmaneshwar College, Kharod",
  "Dr. Bhimrao Ambedkar Government College Baloda, Janjgir",
  " Late Shrimati Indira Gandhi Memorial Government Medical College Kanker ",
  "ADESHWAR NURSING INSTITUTE, SENIOR MIG G-145, HOUSING BOARD COLONY, BODHGHAT, JAGDALPUR",
  "Govt.Paluram Dhanania Commerce and Arts College, Raigarh",
  "GRACIOUS COLLEGE OF NURSING, BELBHATA, ABHANPUR",
  "Govt.Sant Gahira Guru Rameshwar College Lailunga",
  "Govt. Vedram College Malkharoda, Distt  - Janjgir - Champa (Chhattisgarh)",
  "Danteshwari College of Horticulture",
  "Gayatri College of Horticulture",
  "K.L. College of Horticulture",
  "G.R.D. College Pamgarh",
  "Indira Gandhi Arts /Science College, Rahod",
  "Jagrani Devi College of Education, Baradwar",
  "JAGRANI DEVI COLLEGE OF EDUCATION DARRABHATHA",
  "Jagrani Devi Degree Collage, Baradwar",
  "SHRI RAWATPURA SARKAR INSTITUTE OF NURSING, DHANELI, MANA ROAD, DHARSIWA",
  "JANKI COLLEGE OF EDUCATION, DHANUHARDERA",
  "BHAGIRATH COLLEGE JHALMALA RAIGARH",
  "SHRI SANDIPANI MAHAVIDYALAYA RAHOD NAHARPUL RAHOD",
  "NATIONAL INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESARCH",
  "J.L.N. College, Sakti",
  "J. V. G. COLLEGE OF EDUCATION",
  "MAHANT BISAHU DAS COLLEGE OF HORTICULTURE AND RESEARCH  STATION",
  "DIVINE INSTITUTE OF NURSING WADRAFNAGAR ",
  "DANTESWARI COLLEGE OF PHARMACY",
  "SWAMI ATMANAND GOVT ENGLISH MEDIUM MODEL COLLEGE MAHASAMUND",
  "SHREYAS COLLEGE OF NURSING, G.E.ROAD, SUPELA, BHILAI",
  "GOVERNMENT MODEL COLLEGE KORBA ",
  "NAVEEN GOVERNMENT COLLEGE KOMAKHAN",
  "NAVIN GOVT COLLEGE AMLIDIH RAIPUR",
  "Kirodimal Government Arts and Science College Raigarh",
  "K.M.T. Govt. Girls College Raigarh",
  "Konark College of Edu. Khokhasa, Janjgir",
  "K.P. COLLEGE BANDHAPALI SARANGARH DIST RAIGARH",
  "CAREER COLLEGE OF PHARMACY, RAIGARH",
  "PRATIBHA COLLEGE OF EDUCATION BALSI SARAIPALI",
  "GOVT.COLLEGE OF NURSING, BELADULA ROAD,NEAR BSNL OFFICE",
  "MAHARANA PRATAP COLLEGE OF NURSING, ASHISH BHAWAN, NEAR KOTA STADIUM",
  "Rani Durgawati College of Horticulture",
  "HOLYCROSS COLLEGE OF NURSING, HOLYCROSS HOSPITAL, AMBIKAPUR",
  "WE CARE COLLEGE OF NURSING ,TIWARI BUILDING ROAD, VASHUNDHARA GUDHANPUR",
  "GOVT. N.P.A. AYURVED COLLEGE, G.E.ROAD",
  "PARWATI INSTITUTE OF TRAINING,RESEARCH AND MANAGEMENT, NURSING COLLEGE CAMPUS MADANPUR,N.H.-78,M.G.ROAD,NEAR SILIFILI,AMBIKAPUR",
  "Lal Bahadur Shastri Edu. College, Balauda",
  "Govt. Vishwanath Yadav Tamaskar P. G. Autonomus College",
  "MAA COLLEGE OF EDUCATION, PAMGARH",
  "Govt.Girls Polytechnic Jagdalpur",
  "MAA MANGLA COLLEGE OF PHARMACY",
  "MAA DARSHAN COLLEGE",
  "Ma Mangala College, Raigarh",
  "Govt.  Polytechnic Raigarh",
  "Girls Polytechnic, Rajnandgaon",
  "RAIPUR INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH SARONA RAIPUR",
  "NAVEEN GOVT COLLEGE SAKRI",
  "SHRISHTI COLLEGE OF IT AND MANAGEMENT  JAI ISTAMBH CHOWK RAIPUR CG",
  "NAVEEN SHASKIYA SANGEET MAHAVIDYALAYA, AMBIKAPUR",
  "CHAMPA DEVI CHOUHAN COLLEGE OF NURSING",
  "C M D POST GRADUATE COLLEGE BILASPUR",
  "GOVERNMENT NAVEEN GIRLS COLLEGE GOBRA NAWAPARA ",
  "BUDHAN SHAH JI GOVERNMENT NAVEEN COLLEGE TENDUKONA",
  "COLLEGE OF AGRICULTURE AND RESEARCH STATION KUNKURI JASHPUR ",
  "KISMAT NURSING COLLEGE, VILLAGE KANCHANNAGAR, POST AARAGAHI, TEHSIL RAMANUJGANJ DISTRICT , BALRAMPUR CG",
  "College of Agriculture and Research Station",
  "Swami Atmanand Government English Medium Model College Atari Raipur CG",
  "College of Agriculture and Research Station Mahasamund",
  "K B PATEL COLLEGE",
  "AAKANKSHA LIONS SCHOOL FOR MENTALLY HANDICAPPED",
  "ADESHWAR NURSING INSTITUTE ",
  "GRACIOUS COLLEGE OF NURSING",
  "Govt Naveen College Amora ",
  "Govt. Nagarjuna P.G. College of Science, Raipur (C.G.)",
  "VIDYAPEETH COLLEGE",
  "Central India Institute ",
  "RAJIV LOCHAN AYURVED MEDICAL COLLEGE & HOSPITAL, GUNDERDEHI ROAD,CHANDKHURI, DURG",
  "Nursing College Sukma",
  "Pushpendra college of Nursing Ambikapur",
  "GOVT. NAVEEN COLLEGE, THELKADIH",
  "VIVEKANANDA INSTITUTE FOR HUMAN EXCELLENCE COLLEGE DIVISION  RAMKRISHNA PARAMHANSA NAGAR KOTA RAIPUR CHHATTISHGARH",
  "POST GRADUATE INSTITUTE OF BEHAVIOURAL AND MEDICAL SCIENCES SANTVANA MANOPCHAR AVAM ANUSANDHAN SANSTHAN ",
  "GOVT NAVEEN COLLEGE MANORA",
  "SHASKIYA NAVIN VIDHI MAHAVIDYALYA",
  "GURUKUL COLLEGE OF PHARMACY",
  "TAGORE COLLEGE OF MANAGEMENT",
  "COLLEGE OF PROFESSIONAL STUDIES, AMBIKAPUR",
  "M J COLLEGE",
  "SHYAM SHIKSHA MAHAVIDYALAYA, SHAKTI, JANJGIR",
  "VISHNU CHARAN GUPTA GOVT. COLLEGE  PUSSORE, RAIGARH",
  "Shri Agrasen Kanya Mahavidyalaya, Korba, Chhattisgarh",
  "S.D. MAHAVIDYALAYA, NAWAGARH",
  "Florence College of Nursing, Dhamtari",
  "Reliance Institute of Nursing ",
  "Girls Polytechnic, Raipur",
  "Hardik College of Nursing",
  "Shri Rawatpura Sarkar Institute of Physical Education, Naya Raipur",
  "RAVI SHANKAR GLOBAL EDUCATION COLLEGE",
  "Shahid Domeshwar Sahu Govt. College Jamgaon (R), Bharar, Dist- Durg(C.G)",
  "Bhoram Dev Kala & Vanijya Mahavidyalaya, village Pairi Dist Balod",
  "B.I.I.T. College Durg",
  "Govt. Thakur Maharaj Singh College Than Khamariya",
  "Late Lal Shyam Shah Govt. Naveen College Mohla, Rajnandgaon",
  "Govt. Danveer Tularam P. G. College Utai",
  "Govt. Eklavya College Dondi-Lohara",
  "Elegent College, Motinath Mandir Campus, Bharkapara, Rajnandgaon",
  "NAVEEN GOVT COLLEGE KUTRU",
  "BHARTI SCHOOL OF EDUCATION MAHAVIDHYALAYA PAKARIYA ROAD RAHOD",
  "SANDIPANI ACADEMY, ACHHOTI, DURG (C.G.)",
  "GOVERNMENT POLYTEHNIC (CO-ED), BILASPUR",
  "Chandu Lal Chandrakar Govt. Arts & Commerce College DHAMDHA",
  "GOVERNMENT NAVEEN COLLEGE, BORI",
  "G.D. Rungta College of Science And Technology Kohaka Kurud Road Bhilai",
  "Dr. Rajendra Prasad Art. & Comm College Risali Bhilai",
  "Dr. K. C. B. Govt. PG College Bhilai-3",
  "D A V MODEL COLLEGE, DHAMDHA ROAD",
  "Kopalvani Deaf and Dumb College, Sundar Nagar",
  "Confluence College of Higher Education, Rajnandgaon",
  "Chhattisgarh Kalayan Education College Nandni Road Aheri Durg",
  "PRERNA COLLEGE OF PHARMACY, GARIABAND CG",
  "Chhattisgarh Comm&Science College Sector-6",
  "B.M. College, Koliha Pur, Pulgaon, Durg",
  "BHILAI SCHOOL OF EDUCATION AND RESEARCH, CHANDKHURI",
  "Bhilai Maitry College Risali",
  "DIPTI INSTITUTE OF PHARMACY",
  "KRISHNA INSTITUTE OF SCIENCE COMMERCE",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING & TECHNOLOGY (CIPET) - RAIPUR",
  "PRISM COLLEGE",
  "Aadarsh Art.& Comm. College Nai Ganj Mandi",
  "Bhilai Mahila College Bhilai Nagar-2",
  "Alliance Institute Of Commerce & Management, Bhilai",
  "Pt. Harishankar Shukla Smriti Mahavidyalaya, Main Road, Kachna, Raipur",
  "Institute of Technology & Science Devobhog Road, Gariyabandh",
  "Chhattisgarh Mahatari College Bhakhara",
  "Agrasen Mahavidyalaya Ghanora",
  "Govt. Pt. Shyamacharan Shukla  College Sankar Nagar",
  "Acharya Panth Shri Grindh Muni Name Saheb Govt. Mahavidyalaya, Kawardha, Kabirdham",
  "Govt. J. Yoganandam Chhattisgarh College",
  "Govt. D. S. V. Sanskrit College",
  "Vivekanand Institute of Education  Ramkrishna Parmhansa Nagar Kota",
  "Durga Mahavidyalaya",
  "Govt. College Lawan (Balodabazar)",
  "College of Teacher Education, Raipur",
  "Margdarshan Sansthan Agriculture College",
  "NAVEEN GOVT GIRLS COLLEGE SUKMA ",
  "SURYA NURSING COLLEGE",
  "Aadarsh Mahavidyalaya,  Datrenga, Raipur",
  "Gurukul Institute Devbhog Road Gariyabandh",
  "Dr. Radha Bai Govt. Navin Girls College",
  "Central College of I.T. Fafadih",
  "Netajee Shubhash College Vill. Belbhata Abhanpur Road",
  "Govt. Shahid Veer Narayan Singh College, Bilaigarh",
  "Govt. Dau Kalyan Arts & Commerce Post Graduate  College, Balodabazar",
  "GOVT.  VEER SURENDRA  SAY  COLLEGE,  GARIABAND ",
  "VETERINARY POLYTECNICE MAHASAMUND",
  "Shantri Bai Kala Vanijya Vigyan Mahavidyalay ",
  "Swami Atmanand Govt. English Medium Model College Kanker",
  "Govt. Mukut Dhar Pandey College, Katghora",
  "Government Polytechnic, Balod",
  "NAVEEN GOVERNMENT COLLEGE BAZAR ATARIYA",
  "MAA MANGLA COLLEGE OF IT & MANAGEMENT, RAIGARH",
  "MAA PARWATI COLLEGE",
  "Christian College of Engineering and Technology Bhilai.",
  "Government Enginering College Dhrampura, Jagdalpur.",
  "Shaskiya Pandit Shyam Shankar Mishra Mahavidyalaya Deobhog Dist, Gariyaband",
  "NAVEEN GOVT COLLEGE NAGPURA DISTRECT  DURG CG",
  "Loyola.College,  Kunkuri",
  "COLUMBIA COLLEGE OF NURSING",
  "DKS COLLEGE OF AGRICULTURE AND RESEARCH STATION, BHATAPARA",
  "MAHESH BAGHEL JI KESHKAL DANDKARANYA GOVERNMENT COLLEGE KESHKAL",
  "SHRI BALAJI MAHAVIDYALAYA RISABHTIRTH GUNJI POST BARPALIKALA SAKTI",
  "DR. JWALA PRASAD MISHRA GOVERNMENT SCIENCE COLLEGE MUNGELI (C.G.)",
  "Government Naveen College Aundhi",
  "SHRI BALAJI COLLEGE OF PHARMACEUTICAL SCIENCES",
  "BHAKT MATA KARMA GOVT COLLEGE SAMODA RAIPUR CG",
  "Govt.Dr.Indrajeet Singh College Akaltara",
  "College of Agriculture And Research Station Saja",
  "college of Agriculture and Research Station, Korba",
  "COLLEGE OF AGRICULTURE AND RESEARCH STATION",
  "NAVIN SHASHKIYA MAHAVIDHAYALAYA KUNDA",
  "Govt Naveen College Gudiyari Raipur",
  "GOVERNMENT NAVEEN COLLEGE BANKI MONGRA",
  "GOVERNMENT NAVEEN COLLEGE LAKHANPUR ",
  "Shri Shankaracharya Institute of Medical Sciences",
  "Govt. NAGRIK KALYAN MAHAVIDYALAYA, NANDINI NAGAR (AHIWARA) DIST. DURG",
  "Govt. Pt. J.L.N. Arts And Science P.G. College Bemetarae ",
  "Govt. College Khertha",
  "Rani Rashmi Devi Singh Govt. College, Khairagarh",
  "Faculty of Agricultural Engineering",
  "RMD College of Agriculture and Research Centre",
  "GOVERNMENT POLYTECHNIC PATHARIYA",
  "JAGRANI DEVI COLLEGE DABHRA",
  "GOVT. RANI AVANTI BAI LODHI COLLEGE , GHUMKA , DISTT - RAJNANDGAON",
  "Swami Atmanand Govt English Medium Model College Jagdalpur District Bastar",
  "Vishwabharati Shiksha Mahavidhyalaya Konta",
  "College of Agriculture, Dantewada",
  "SHREE NARAYANA NURSING INSTITUTE",
  "M.J. College",
  "Khalsa Education Society, G.A.D. Colony, Durg",
  "MANSA COLLEGE OF EDUCATION",
  "Govt. Shukhram Nage College, Sihawa (Nagari)",
  "Shriram College of Agriculture",
  "Confluence College of Nursing, Rajnandgaon",
  "Virangana Avanti Bai Govt. College, Chhuikhadan, ",
  "Bhartiya College of Agricultural Engineering",
  "Government College Kartala",
  "Swargiya Ramnath Verma Shaskiya Mahavidayalya Mopka Nipniya",
  "Dr. B.S. Porte Arts, Science and Commerce College, Marwahi",
  "GOVT NAVEEN COLLEGE VATGAN",
  "Mahamaya College of Agriculture",
  "NAVEEN GOVERNMENT COLLEGE JARHAGAON",
  "NAVEEN GOVT COLLEGE DEORBIJA",
  "KISMAT PHARMACY COLLEGE",
  "Dr. Manrakhan lal Sahu, Shaskiya Mahavidyalaya, Jamul  ",
  "GOVT. DANTESHWARI P.G. MAHILA MAHAVIDYALAYA, JAGDALPUR BASTAR",
  "Chhattisgarh College of Agriculture",
  "GOVERNMENT MEDICAL COLLEGE MAHASAMUND",
  "MAITRI COLLEGE OF PHARMACY",
  "Lovekush Institute of Nursing, Kondagaon",
  "RAIGARH COLLEGE OF PHARMACY",
  "KRISHNA S VIKASH INSTITUTE OF TECHNOLOGY, RAIPUR",
  "Indira Gandhi Government College, Pandaria",
  "Dr. R.N.S. Shiksha Mahavidyalaya, Manendragarh",
  "GOVERNMENT POLYTECHNIC CHIRMIRI",
  "Bhoramdev College of Agriculture",
  "BHARATI INSTITUTE OF NURSING SARAIPALI",
  "College of Agriculture, Raigarh",
  "TCB College of Agriculture and Research Centre",
  "BRSM College of Agricultural Engineering and Technology",
  "College of Education, Meduka, Pendra Road, Dist-Bilaspur",
  "Kamlakant Shukla Institute, Bhatapara",
  "V M COLLEGE OF PHARMACY, BISHRAMPUR",
  "Maharshi Ved Vyas Govt. P.G. College Bhakhara, Dist. - Dhamtari (C.G.)",
  "APEX COLLEGE OF NURSING, RAIGARH ",
  "Prism School of Education",
  "NAVEEN GOVERNMENT COLLEGE DHANORA",
  "Govt. Nehru P.G. College, Dongargarh",
  "Govt. Shaheed Gendsingh College, Charama, District-Uttar Bastar Kanker (C.G.)",
  "ST TERESAS COLLEGE ",
  "Chhattisgarh College of Agricultural Engineering",
  "GOVERNMENT NAVEEN COLLEGE RAGHUNATHNAGAR",
  "SK College of Agriculture and Research Centre",
  "SG College of Agriculture and Research Centre",
  "Govt. Kaktiya P.G. College Jagdalpur",
  "ARYAVART PHARMACY COLLEGE, BHILAI",
  "Kalyan Law College",
  "SWAMI ATMANAND GOVERNMENT ENGLISH MEDIUM MODEL COLLEGE, SOMNI DIST-RAJNANDGAON",
  "Govt. Pataleshwar College Masturi",
  "Swami Shri Swaroopanand Saraswati Mahavidyalaya HUDCO, Bhilai",
  "COLLEGE OF HORTICULTURE AND RESEARCH STATION, RAIGARH",
  "BODHNI DEVI PHARMACY DIPLOMA COLLEGE JAGDALPUR BASTAR",
  "U V SANSKAR COLLEGE, LATORI",
  "RAM LAKHAN MAHAVIDYALAYMAHUATOLI KANDORA KUNKURI ",
  "Govt. Ayurved College, Bilaspur",
  "RANI AVANTI BAI LODHI GOVERMENT COLLEGE PARPODI",
  "GOVT NAVEEN COLLEGE JHALMALA ",
  "Govt.Polytechnic, Khairagarh",
  "Govt. Rani Suryamukhi Devi College Chhuria",
  "JAGRANI DEVI COLLEGE BILASPUR",
  "Govt. Mahaprabhu Vallabhacharya P.G. College Mahasamund (C.G.)",
  "RUNGTA INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH",
  "Govt. SHAHID KOUSHAL YADAV COLLEGE GUNDERDEHI",
  "Government  College  Gurur",
  "BIT COLLEGE OF COMMERCE SCIENCE MANAGEMENT AND ARTS ",
  "Govt. Dr. Baba Saheb Bhimrao Ambedkar PG College, Dongargaon.",
  "GOVERNMENT COLLEGE BARPALI",
  "SHRI VIDYAPATI NURSING COLLEGE,JAGDALPUR     ",
  "Govt. S.N.G. College, Mungeli (Bilaspur)",
  "Sw Daau Ramchandra sahu Shaskiya Mahavidyalaya, Ranitarai  Jila Durg",
  "College of Agriculture, Ambagarh Chwoki",
  "ORIENTAL COLLEGE OF NURSING, MANIKPUR, KORBA",
  "VETERINARY POLYTECNIC SURAJPUR",
  "GOVT. COLLEGE, FASTERPUR",
  "VETERINARY POLYTECNIC JAGADALPUR",
  "GOVT NAVEEN COLLEGE NANDGHAT",
  "GOVT NAVEEN COLLEGE CHILHATI",
  "HASDEV COLLEGE OF EDUCATION, AAMAPALI, TILKEJA",
  "HASDEV COLLEGE OF EDUCATION,DARRIROAD",
  "RAIGARH COLLEGE OF EDUCATION, PHARMACY",
  "NAVEEN GOVERNMENT COLLEGE MAINPUR",
  "MEDICAL COLLEGE, RAJNANDGAON",
  "KRUTI INSTITUTE OF TEACHER EDUCAATION",
  "NAVEEN GOVT COLLEGE JALBANDHA",
  "Gracious College of Education, Belbhata (Abhanpur)",
  "NAVEEN GOVT COLLEGE ARJUNI",
  "BHARTI AYURVED MEDICAL COLLEGE AND HOSPLITAL",
  "NAVEEN GOVERNMENT COLLEGE CHHOTEDONGAR, NARAYANPUR CHHATTISGARH",
  "SANSKAR CITY COLLEGE OF PHARMACY",
  "AYUSH COLLEGE OF NURSING",
  "NAVEEN GOVERNMENT COLLEGE BHIMBHORI",
  "COLLEGE OF HORTICULTURE AND RESEARCH STATION, CHIRMIRI, KORIYA",
  "SONKAR COLLEGE OF PHARMACY    ",
  "VEERANGANA MAASAK DEVI NAG GOVERNMENT NEW MODEL COLLEGE JAVANGA",
  "KESHARI COLLEGE OF PHARMACY KHOKHARA, JANJGIR",
  "Late Raja Virendra Bahadur Singh Government College saraipali",
  "COLLEGE OF HORTICULTURE AND RESEARCH STATION SITAPUR SURGUJA",
  "NAVEEN GOVT COLLEGE JEWARTALA",
  "ATHARVA COLLEGE OF PHARMACY",
  "Kamala Devi Sangeet Mahavidyalaya,Raipur",
  "C.M. NURSING INSTITUTE, CHANDULAL CHANDRAKAR MEMORIAL HOSPITAL, NEHRU NAGAR, G.E.ROAD, SUPELA, BHILAI",
  "COLLEGE OF HORTICULTURE AND RESEARCH STATION, CHAPKA, SONARPAL",
  "COLLEGE OF HORTICULTURE AND RESEARCH STATION HATHANI, BILASPUR",
  "COLLEGE OF HORTICULTURE AND RESEARCH STATION, RAMANUJGANJ, BALRAMPUR",
  "CHHATTISGARH AYURVED MEDICAL COLLEGE, G.E. ROAD, VILL-MANKI",
  "JES COLLEGE",
  "GOVT.PHYSIOTHERAPY COLLEGE, PT.J.N.M. MEDICAL COLLEGE",
  "NAVEEN GOVERNMENT COLLEGE BELTARA DISTRICT BILASPUR ",
  "Dau Uttam Sao Govt. College, Machandur, Dist. -  Durg (C.G.)",
  "JAGRANI DEVI PHARMACY COLLEGE BARADWAR",
  "H V SANSKAR COLLEGE, SITAPUR",
  "VIVEKANAND INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "GOVERNMENT NAVIN COLLEGE, ODGI",
  "GRACIOUS COLLEGE OF PHARMACY, KABIRDHAM",
  "Shri Shankaracharya Institute of Professional Studies, Raipur",
  "P.N.S. College, Nehrunagar Bilaspur",
  "SHEETAL INSTITUTE OF COMPUTER SCIENCE AMBIKAPUR",
  "C M MEDICAL COLLEGE AND HOSPITAL, KACHANDUR",
  "SHRI C M NURSING COLLEGE KACHANDUR",
  "COLLEGE OF HORTICULTURE AND RESEARCH STATION KOTBA",
  "PRISM COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHINC RAMANUJGANJ, OLD TEHSIL OFFICE",
  "GOVERNMENT POLYTECHINC, MUNGELI, MISSION HIGH SCHOOL CAMPUS, DAUPARA, MUNGELI",
  "GOVERNMENT POLYTECHNIC, SUKMA",
  "Shahid Rajeev Pandey Govt College Bhatagaon Raipur",
  "MAHAVEER COLLEGE OF AYURVEDIC SCIENCE, SUNDRA, RAJNANDGAON ",
  "MADAN LAL SAHU GOVERNMENT COLLEGE ARMARIKALA, BALOD",
  "A. K. Institute of Nursing Manendragarh",
  "NUPOOR COLLEGE OF PHARMACY",
  "PUSHPENDRA COLLEGE OF PHARMACY AMBIKAPUR",
  "Govt. Polytechnic Gariyaband",
  "COLLEGE OF AGRICULTURE & RESEARCH STATION, KOREA",
  "COLLEGE OF AGRICULTURE & RESEARCH STATION, KANKER",
  "GOVT NAVEEN COLLEGE SANNA DIST JASHPUR",
  "NAVEEN GOVT GIRLS COLLEGE MUNGELI C G",
  "S S COLLEGE OF EDUCATION, SARBAHARA",
  "INSTITUTE OF PHARMACY RESEARCH CENTRE SURAJPUR",
  "V M COLLEGE OF NURSING, BISHRAMPUR",
  "CG INSTITUTE OF NURSING ",
  "NAVEEN GOVT COLLEGE LOHANDIGUDA, DIST BASTAR",
  "Ayush College of Education Meduka",
  "NAVIN GOVERNMENT COLLEGE, SIRRI, KURUD, DHAMTARI CG",
  "Govt. E. Raghavendra Rao Postgraduate Science College, Bilaspur",
  "EKLAVYA INSTITUTE OF TECHNOLOGY KUNJARA LAILUNGA RAIGARH",
  "SBT  College, Bilaspur",
  "C S R COLLEGE, PIPARTARAI",
  "GOVERNMENT NAVEEN COLLEGE, SONHAT",
  "SWAMI ATMANAND GOVT ENGLISH MEDIUM MODEL COLLEGE KORBA",
  "SPECTRUM COLLEGE OF EDUCATION, NARDAHA",
  "AYUSH COLLEGE OF POLYTECHNIC, MEDUKA PENDRA ROAD",
  "GOVERNMENT POLYTECHNIC (CO-ED), RAIPUR",
  "GOVERNMENT POLYTECHNIC, BALODABAZAR",
  "SHASAKIY NAVEEN KANYA MAHAVIDYALYA BALRAMPUR, DISTRICT BALRAMPUR RAMANUJGANJ",
  "GOVERMNENT NAVEEN COLLEGE NAGPUR",
  "VIRANGANA RANI DURGAWATI MAHAVIDHALAYA SEKHWA, KOTMIKALA",
  "SARASWATI MAHAVIDYALAYA",
  "SHIV SHAKTI INSTITUTE, KHORSI",
  "Sant Shiromani Guru Ghasidas College, Pamgarh",
  "GOVERNMENT POLYTECHNIC (CO-ED), BASTAR, JAGADALPUR",
  "UNIVERSITY COLLEGE OF PHARMACY RAIPUR ",
  "TRIMURTY PHARMACY COLLEGE",
  "SIDDHARTH COLLEGE",
  "SHYAM BALAJI COLLEGE OF PHARMACY, MAHASAMUND ",
  "ABHYUDAY COLLEGE, CHANKHURIFARM",
  "SONKAR COLLEGE",
  "NAVEEN GOVRNMENT COLLEGE UMRELI",
  "NAVEEN GOVERNMENT COLLEGE, DHOURPUR",
  "APOLLO COLLEGE",
  "SHRI BALAJI INSTITUTE OF PHARMACY AND RESEARCH CENTRE     ",
  "NAVEEN GOVERNMENT COLLEGE BHANWARPUR",
  "WE CARE COLLEGE OF PHARMACY",
  "AGRASEN COLLEGE OF PHARMACY ",
  "NAVEEN GOVERNMENT COLLEGE PONDI BACHRA DISTRICT KOREA CG",
  "TRIVENI COLLEGE OF PHARMACY TILAI, AKALTARA",
  "DEPARTMENT OF NURSING, INSTITUTE OF TECHNOLOGY AND SCIENCES, GARIYABAND CG",
  "IPS PHARMACY COLLEGE RATANPUR,DISTT BILASPUR",
  "D.P. Vipra College, Bilaspur",
  "SHRI SIDDHI BALAJI COLLEGE OF NURSING",
  "NAVEEN GOVT COLLEGE VISHRAMPURI, DISTRICT KONDAGAON ",
  "G.T.B College of  Education, Farhada",
  "Bhartiya College of Agriculture",
  "KISMAT COLLEGE KAMALPUR RAMANUJGANJ",
  "SHRI SIDDI VINAYAK MAHAVIDYALAYA",
  "ASHOKA DEGREE COLLEGE, TORANKATTA",
  "JAN SWASTHYA SAHYOG, SCHOOL OF NURSING, GANIYARI",
  "PT MADAN MOHAN MALVIYA COLLEGE OF EDUCATION",
  "APEX INSTITUTE OF PHARMACY EDUCATION AND RESEARCH",
  "NAVIN PVT SAJAG COLLEGE, SARAGAON",
  "C.M. Dubey Post Graduate College, Bilaspur",
  "SHRI RAM COLLAGE BARAMKELA    ",
  "B L T COLLEGE, RATANPUR",
  "GOVERNMENT COLLEGE, KOTRI",
  "Sant. Guru Ghasidas Arts/Science College, Pachpedi",
  "SRI ONKAR COLLEGE OF NURSING KHARORA RAIPUR    ",
  "NAVEEN GOVT KANYA COLLEGE KHAIRAGARH    ",
  "CKD Girls College, Pathalgaon",
  "GAUTAM COLLEGE OF NURSING",
  "LEELAS INSTITUTE OF MEDICAL SCIENCES",
  "RIYANSH COLLEGE OF PHARMACY",
  "SANSKAR COLLEGE SAKET, PATHARIYA, DIST MUNGELI",
  "Scope College of Nursing Institute, Doomar Talab",
  "SHRI RAM AADARSH MAHILA COLLEGE, SARANGARH",
  "St. Thomas College Bhilai Durg",
  "SHRI RAWATPURA SARKAR INSTITUTE OF PROFESSIONAL STUDIES, KUMHARI",
  "Shri Ravat Pura Sarkar Sansthan, Holiday Resort Ke Peeche, Kumhari, Durg",
  "Shri Ram Siksha Mahavidyalaya Digvijay Stadium Campus, Rajnandgaon",
  "Shiva College Maitry Vihar Radhika Nagar Supela",
  "SHAIL DEVI COLLEGE, ANDA",
  "Seth R. C. S. LAW College DURG",
  " Seth R. C. S. Arts & Commerce College, Durg",
  "Seth Badrilal Khandelwal Siksha Mahavidyalaya, Gaurav Path, Utai Road, Durg",
  "SANT RAJA RAM SHADANI NAGRIK MAHAVIDYALYA, DONDI LOHARA",
  "Sai College Bhilai",
  "Rungta College of Science and Technology G. E. Road, Ganjpara, Durg ",
  "Royal College, Lalbagh, Rajnandgaon",
  "Pt. K.L.S. Vidhi Mahavidyalaya Rajnandgaon",
  "Karma Mata Vanijya & Vigyan Mahavidyalaya, Jamgaon, Durg",
  "Kantidarshan Saikshnik & Computer Prasikshan Sansthan, Kosanagar, Supela",
  "Kalyan P.G. College Bhilai Nagar",
  "JAGADGURU SHANKARACHARYA COLLEGE OF EDUCATION BHILAI",
  "Govt. Shivnath Science Mahavidyalaya, Rajnandgaon",
  "Govt. Rajmata Vijayaraje Sindhiya Kanya Mahavidyalaya, Kawardha, Kabirdham",
  "GOVT. NAVEEN COLLEGE, SALHEWARA",
  "Ayush College of Education, Marvahi, Village Lohari",
  "Govt. L.C.S. Mahavidyalaya, Ambagarh Chowki, Rajnandgaon",
  "INDIRA GANDHI GOVT. PG COLLEGE, VAISHALI NAGAR, BHILAI ",
  "Late Shri Devi Prasad Ji Choubey Government College, Gandai Distt-Rajnandgaon (C.G.)",
  "SHAMBHAVI SCHOOL OF EDUCATION",
  "Govt. Lalshyam Shah College, Manpur",
  "Govt. Kunj Bihari Choubey Mahavidyalaya, Lalbahadur Nagar",
  "Aryavart Education College Ruabandha Bhilai",
  "Bhilai College of Information Technology",
  "D.L.S. College, Bilaspur",
  "ASHOKA COLLEGE UMMEDPUR SARANGARH",
  "Bilaspur College of Polytechnic, Farhada",
  "Government Polytechnic Berla",
  "Government Polytechnic (Co-Ed) Kondagaon",
  "Government Polytechnic, Surajpur",
  "Krishna Engineering College",
  "Ramanujan College, Pandaria",
  "Govt.Pt. Madhavrao Sapre College, Pendraroad (Gaurela) Dist - Bilaspur",
  "IPS Gurukul College",
  "Uday College Chhawani Area Bhilai",
  "SHRIRAM COLLEGE OF PHARMACY",
  "UNIQUE COLLEGE OF IT KAWARDHA",
  "COLLEGE OF AGRICULTURE AMD RESEARCH STATION CHHUIKHADAN",
  "COLLEGE OF FOOD TECHNOLOGY RAIPUR",
  "COLUMBIA COLLEGE OF SCIENCE AND COMMERCE ",
  "BHAKT MATA KARMA GOVT GIRLS COLLEGE BALOD  ",
  "SRI JAGANNATH COLLEGE",
  "Govt. Ghanshyam Singh Gupt College Balod",
  "Sri Sathya Sai Sanjeevani Institute Of Nursing and Allied Heathcare Sciences",
  "SW Pukeshwar Singh Bhardiya Govt College Nikum, Dist Durg",
  "NAVEEN GOVT GIRLS COLLEGE TAKHATPUR DIST BILASPUR CG",
  "Govt. N. C. J. College Dallirajhara",
  "COLLEGE OF AGRICULTURE AND RESEARCH STATION KURUD",
  "COLLEGE OF AGRICULTURE LORMI",
  "Lat. Jaidev Sathpathi Govt. College Basana",
  "RITEE COLLEGE OF PHARMACY",
  "JIFSA PROFESSIONAL COLLEGE",
  "Govt. Kangla Manjhi College Daundi",
  "Veeraangana Maasak Devi Nag Government New Model College, Jawanga, Geedam, Dist- South Bastar Dantewada (C.G.)",
  "SAMADHAN COLLEGE BEMETARA",
  "DISHA LAW COLLEGE",
  "MSME TECHNOLOGY CENTRE DURG",
  "Al-Shamsh Infotech College Nagari (Sihawa)",
  "College Of Nursing Post Graduate Institute Of Behavioural and Medical Sciences Raipur C.G",
  "Shri Shankaracharya College of Pharmaceutical Sciences",
  "USHA DEVI MEMORIAL COLLEGE",
  "Govt. Girls Training College Pendra",
  "INSTITUTE OF GENERAL NURSING TRAINING CENTRE",
  "Maa Bahadur Kalarin Kala & Vigyan Mahavidyalaya, Gurur",
  "GOVERNMENT POLYTECHNIC, BHATAPARA",
  "Mata Karma Arts Commerce And Science College, Gunderdehi, Dist- Balod (C.G)",
  "Govt. Gajanan Madhav Muktibodh Mahavidyalaya, Sahaspur, Lohara",
  "SHRI SHANKARACHARYA INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH",
  "SURYA NURSING INSTITUTE ",
  "CIT DEGREE COLLEGE ",
  "Govt. Koduram Dalit College Nawagarh",
  "GOVIND SARANG  GOVT. LAW COLLEGE, BHATAPARA",
  "Govt Dr. Waman Vasudev Patankar Girls College",
  "GOVT. NAVEEN COLLEGE BERLA",
  "Kachna Dhurwa College Chhura ",
  "Samrat Ashoka College of Information Technology, Kawardha, Kabirdham",
  "VIRANGNA RANI AWANTIBAI LODHI GOVT. ARTS AND COMMERCE COLLEGE RAMATOLA, Dist. - RAJNANDGAON",
  "LAXMAN PRASAD BAIDH GOVT. GIRLS COLLEGE, BEMETARA ",
  "J K EDUCATIONAL INSTITUTE OF SCIENCE ARTS AND COMMERCE",
  "GOVT.  ADARSH COLLEGE  MAHASAMUND, DIST. MAHASAMUND",
  "GOVERNMENT MEDICAL COLLEGE, KORBA",
  "VEER NANGUL DORLA GOVERNMENT COLLEGE, AWAPALLI DISTRICT BIJAPUR",
  "GOVERNMENT NAVEEN COLLEGE PALI DISTRICT KORBA (C.G.)",
  "KAMLA KANT SHUKLA INSTITUTE, DEORI",
  "CENTRAL COLLEGE OF EDUCATION, RING ROAD",
  "SHRI RAWATPURA SARKAR INSTITUTE OF PROFESSIONAL STUDIES PACHEDA, ABHANPUR",
  "C I T B ED BELWADIH ABHANPUR COLLEGE",
  "DHURWARAO MADIYA GOVERNMENT NAVEEN  COLLEGE , BHAIRAMGARH DIST-BIJAPUR",
  "Agrasen Mahavidyalaya Purani Basti",
  "Rajkoshal Vyavsayik Prashikshan Sansthan, Lawar(Darrighat), Bilaspur",
  "YASHVANT RAO MEGHAWALE GOVERNMENT COLLEGE, MAGARLOD",
  "GOVERNMENT POLYTECHNIC, BAGICHA",
  "J.K. INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
  "AYUSH COLLEGE OF PHARMACY MARWAHI",
  "Korba Computer College, Korba (C.G.)",
  "Keshari Shikshan Samiti Khokhara, Janjgir",
  "Sant Shiromani Guru Ravidas Govt. College, Sargaon",
  "G.T.B College of Professional & Technical Education, Farhada",
  "SHREE MAHANT  LALDAS KALA VIGYAN AVAM SHIKSHA MAHAVIDAYALYA TUNDRANAGAR, BALODABAZAR BHATAPARA C G",
  "SANDIPANI COLLEGE OF PHARMACY POST PENDRI SHIVRINARAYAN ROAD MASTURI BILASPUR CHHATTISGARH",
  "Hidma Manjhi Government College, Katekalyan, Dist - South Bastar Dantewada (C.G.)",
  "DISHA COLLEGE OF PHARMACY",
  "GOVERMENT MODEL RESIDENTIAL GIRLS COLLEGE BIJAPUR ",
  "Shaheed Kawasi Rodda Pedda Government College, Kuakonda, Dist Dantewada CG",
  "Government Model Residential Girls College Kondagaon",
  "GOVERNMENT RAJMOHINI DEVI GIRLS  P.G. COLLEGE, AMBIKAPUR",
  "SAI SADAN EDUCATION SCHOOL BENDRI",
  "AASRA INSTITUTE OF NURSING",
  "Sukhnandan College, Mungeli",
  "HRISHIKESH COLLEGE OF PHARMACEUTICAL AND RESEARCH INSTITUTE JAGDALPUR DISTT BASTAR CG",
  "HRISHIKESH INSTITUTE OF PHARMACY RAIPUR C G",
  "SANSKRITI INSTITUTE OF PHARMACEUTICAL SCIENCE AND TECHNOLOGY PAMGARH",
  "INSTITUTE OF PHARMACEUTICAL STUDIES",
  "CHOUKSEY COLLEGE OF PHARMACY",
  "NAVEEN GOVERNMENT COLLEGE MARDAPAL",
  "GURUKRIPA PHARMACY COLLEGE RAMTAL ROAD SENDRI BILASPUR ",
  "MAA SHAKUNTALA COLLEGE OF HIGHER EDUCATION KOTADOL",
  "SWAMI ATMANAND GOVERMENT ENGLISH MEDIUM MODEL COLLEGE , BILASPUR",
  "GP GUPTA PHARMACY COLLEGE RAHOD",
  "THAKUR BHAVSINGH ARTS AND SCIENCE COLLEGE NARHARPUR",
  "Dau Kalyan Singh Sonwani Mahavidyalya G-Jamgaon",
  "AK GURUKUL COLLEGE DHELWADIH KORBA CG",
  "Govt. Rajeev Lochan College, Razeem",
  "Pt. Ram Sakha Uppadhayay College Gudiyadi",
  "Govt. K. L. Art. & Comm. College Bagbahara",
  "Satya Narayan Agarwal Government Arts. and Commerce College, Kohka-Neora",
  "Jai Burdhadev College Katghora",
  "Maulana Azad College of Education, Bilaspur",
  "Shri Sidhpith Mahamaya Education College, Bilaspur",
  "Govt. Mahamaya College, Ratanpur",
  "Govt.Minimata Girls Arts/Commerce College, Korba",
  "K. N. College, Korba",
  "Nalini Prabha Dev Prasad Roy, College Jorapara, Bilaspur",
  "RAJIV GANDHI GOVERNMENT ARTS AND COMMERCE COLLEGE, LORMI",
  "Disha College, Ram Nagar Kota Marg Raipur (C.G.)",
  "GOVERNMENT COLLEGE PREMNAGAR",
  "Shri Kuleshwar Mahadev Shaskiya Mahavidyalaya Gobra (Nawapara)",
  "Swami Atmanand Govt. English Medium Model College Dhanora, Dist-Durg",
  "SHRI SAI COLLEGE",
  "Govt. Larang Sai Post Graduate College, Ramanujganj",
  "Vishwavidyalaya Engineering College Ambikapur",
  "Bhilai Nair Samajam College",
  "ATHARVA COLLEGE",
  "MAHANT SHRI RAMJANKI SHARAN DAS VAISHNAV GOVERNMENT SNATAK COLLEGE PIPARIYA DIST:- KABIRDHAM",
  "COLLEGE OF AGRICULTURE AND RESEARCH STATION MARRA PATAN DURG CHHATTISGARH",
  "SHYAM BALAJI COLLEGE, MAHASAMUND",
  "Govenment  Niranjan Kesharwani College Kota",
  "Govt. Naveen  College  Beloudi",
  "LEELA DEVI COLLEGE OF NURSING, VILLAGE MOTIPUR TAH PATAN, DIST DURG CHHATTISGARH",
  " Rajeev Gandhi Government College, Simga",
  "Suyash College of Nursing ",
  "Raipur Institute of Medical Sciences",
  "LATE  RAMPRASAD  DEWANGAN  GOVERNMENT COLLEGE, KHARORA , DIST -  RAIPUR ",
  "GOVERNMENT NAVEEN COLLEGE CHIRKO",
  "GOVERNMENT NAVEEN COLLEGE NAWAGAON ",
  "DULICHAND JALAN COLLEGE OF QUALITY EDUCATION TILAIPALI SARSIWA",
  "CHHATTISGARH COLLEGE",
  "Late  Daulat Ram  Sharma  Govt.  Post  Graduate College  Kasdol",
  "B R SAO SCIENCE ART AND COMMERSE COLLEGE NEOSA BELTARA BILASPUR CHHATTISGARH",
  "NAVEEN GOVERNMENT GIRLS COLLEGE NARAYANPUR ",
  "Chhatrapati Shivaji Institute of Pharmacy Durg",
  "Government Medical College Ambikapur",
  "Government Navin College hasoud, Janjgir",
  "GOVERNMENT T.C. L. P.G. COLLEGE JANJGIR",
  "Govt.Art., Sc. & Comm. College, Dharamjaigarh, Distt.-Raigarh",
  "Govt. College, Gharghoda, Raigarh",
  "Govt. College, Jaijaipur",
  "SANSKRITI MAHAVIDYALAYA, MEU, PAMGARH",
  "Shri Mahant Laldas Arts/Science College, Shivrinarayana",
  "Shri Mahant Laldas Education College,Shivarinarayan",
  "SHRI RISHABH VIDYODAY MAHAVIDALAYA",
  "SHRI SANDEEPNI COLLEGE OF EDUCATION, RAHAOD",
  "Shri Sandeepni Vigyan Sansthan , College, Rahod",
  "Shri Shankaracharya Arts science and commerce college",
  "NEW LIFE INSTITUTE OF NURSING",
  "MOHAN LAL JAIN (MOHAN BHAIYA) GOVT. COLLEGE KHURSIPAR BHILAI, CHHATTISGARH",
  "Institute of Advanced Studies in Education (IASE) Bilaspur",
  "Govt. Naveen College, Tokapal",
  "NAVEEN GOVERNMENT COLLEGE KUSMURA DISTRICT RAIGARH CG",
  "NAVEEN GOVERNMENT COLLEGE, NAWAGARH",
  "Naveen Privet College, Gharghoda",
  "Naveen Pvt. Kalindri Devi Tilak Ramchandra Arts/Science,College, Salni",
  "Om Maya Sundram CollegeBrindavan Chhal",
  "O.P.SHARMA COLLEGE DABHARA",
  "Pt. Harishankar Education College, Jnajgir",
  "Pt. Jawaharlal Nehru College, Nawagarh",
  "VISHWA BHARTI INSTITUTE",
  "National Science & Commerce College, Kharsiya",
  "NAVEEN GOVERNMENT COLLEGE CHAPLE DISTRICT RAIGARH CG",
  "Purwanchal College,Sariya-Raigarh",
  "RADHAKRISHNA SHIKSHA SAMITI, NAWAGARH",
  "Rahod Education Society, Rahod",
  "Raigarh City College, Raigarh",
  "RAIGARH COLLEGE OF EDUCATION",
  "RAIGARH INSTITUTE OF TECHNOLOGY AND SCIENCE ",
  "Rambai Kanhaiyalal Sahu, Arts College, Hasawad",
  "S.B.K.P.Law College, Raigarh",
  "Gurukul College Magarlod",
  "S.D. Mahavidyalay Nawagarh",
  "Seth Surajmal Jaipuriya College, Bamneedih",
  "SHAHEED VEER NARAYAN SINGH GOVERNMENT COLLEGE, JOBI-BARRA",
  "SHANTI DURGA COLLEGE, MUDPAR",
  "SHASHIDHAR PANDA GOVERNMENT COLLEGE, SARIYA",
  "Lal Bahadur Shastri Arts/Commers College, Baloda",
  "GYANDEEP COLLEGE OF EDUCATION JANJGIR, DIST- JANJGIR-CHAMPA (C.G.)",
  "Gyanodaya College Of Education, Janjgir",
  "GYANROSHANI LOK KALYAN SANSTHA, PLOT NO. 3411, CITY/VILLAGE KHOKHARA",
  "SMT UKIYA DEVI SMRITI COLLEGE, RAIGARH",
  "S.S.COLLEGE RAIGARH",
  "Utkarsh Shiksha Mahavidyalaya, Naila Road, Sarkho",
  "UTTAM MEMORIAL COLLEGE, RAIGARH",
  "VIRAT LAKSHYA COLLEGE CHAMPA JANJGIR",
  "Rungta Institute of Pharmaceutical Sciences Bhilai",
  "RUNGTA INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
  "Bharti College of Nursing",
  "Govt. Gramya Bharti College,  Hardibazar, DIstt.- Korba (C.G.)",
  "Chhattisgarh college of Education",
  "Veerangana Awanti Bai Lodhi Govt. College, Patharia",
  "SANSKAR CITY COLLEGE OF EDUCATION",
  "Government Divyang College, Raipur",
  "ABHISHEK I MISHRA MEMORIAL MEDICAL COLLEGE AND RESEARCH, JUNWANI, BHILAI, CHHATTISGARH",
  "MANSA PHARMACY COL,LEGE",
  "TAGORE INSTITUTE OF PHARMACY AND RESEARCH",
  "Pt. Jwala Prasad Upadhyay Government College, Patna, District - Korea Chhattisgarh",
  "GOVT NAVEEN COLLEGE RISALI",
  "DR. BHIMRAO AMBEDKAR GOVERNMENT COLLEGE, BALODA",
  "FISHERIES POLYTECHNIC ",
  "RAMDARSHAN INSTITUTE OF EDUCATION JANGHORA",
  "GOVT COLLEGE KANDEL",
  "GOVT. COLLEGE SARONA (SALHEBHATA)",
  "GOVT NAVEEN COLLEGE SONAKHAN DISTT BALODABAZAR  BHATAPARA  C G",
  "FANIKESHWAR NATH GOVT. COLLEGE FINGESHWAR, GARIYABAND",
  "GOVT NAVEEN COLLEGE PENDRAWAN",
  "SANJIVANI INSTITUTE OF TECHNOLOGY",
  "CG SCHOOL OF NURSING",
  "NAYAK NITYANAND SAI GOVERNMENT COLLEGE, AARA",
  "LIKHAN SAI GOVT. COLLEGE, TAPKARA , DIST - JASHPUR",
  "SANJIVANI INSTITUTE OF PHARMACY",
  "V P COLLEGE OF NURSING",
  "Govt. College, Balrampur",
  "SANDIPANI ACADEMY MASTURI",
  "PARVATI INSTITUTE OF TRAINING RESEARCH AND MANAGEMENT",
  "Maharaja Agrasen International College Samata Colony Raipur",
  "Ravi Shankar Institute of Nursing",
  "Bharat Institute of Nursing ",
  "Maruti Institute of Nursing ",
  "MAITRI COLLEGE OF DENTISTRY AND RESEARCH CENTRE,G.E.ROAD,ANJORA",
  "Govt.Polytechnic,Korba",
  "Ghanshyam Singh Arya Kanya Mahavidyalya, Arya Nagar Durg",
  "Govt. Kamladevi Rathi Mahila PG Mahavidyalaya, Rajnandgaon",
  "College of Veterinary Science and Animal Husbandry",
  "Veerangana Rani Durgawati Govt. College, Marwahi, Distt-Bilaspur",
  "BABU PANDHARI RAO KRIDATT GOVERNMENT COLLEGE SILOUTI",
  "GOVERNMENT CHANDULAL CHANDRAKAR ARTS AND SCIENCE COLLEGE, PATAN",
  "SWAMI VIVEKANAND INSTITUTE OF PHARMACY AND RESEARCH SEMARTAL BILASPUR     ",
  "Govt.College RamanujNagar",
  "Saraswati  Shiksha Mahavidyalaya, Ambikapur",
  "St Xavier's College of Education, Fundurdihari , Ambikapur",
  "Govt. Bala Sahab Deshpandey  College, Kunkuri",
  "Veena Girls College, Vishrampur",
  "Govt. Kalidas College, Pratappur",
  "Gurukul Art/Comms & Science College, Pathalgaon",
  "Govt. Ram Bhajhan Rai N.E.S. P.G. College, Jashpur Nagar",
  "Sant Harkewal  Siksha  Mahavidyalaya, Ambikapur",
  "Neotech Technical & Management College, Ambikapur",
  "Govt.Navin Girls College, Baikunthpur",
  "Marg Dardhan Sansthan Shiksha Mahavidyalaya, Baikunthpur",
  "Thakur Shobha Singh Govt College, Pathalgaon",
  "Govt. College, Duldula",
  "K.R.Technical College, Ambikapur",
  "Govt. Navin College, Janakpur",
  "Govt.Shyama Prasad Mukharjee College, Sitapur",
  "Non Govt. Margdarshan Sanshthan, Baikunthpur",
  "Govt. Vivekanand P.G. College, Manendragarh",
  "Shri Sai Baba Aadarsh Mahavidyalaya ",
  "Govt. Lahiri P.G. College, Chirmiri",
  "Mahadev Hospital College of Nursing",
  "GOVERNMENT NAVEEN COLLEGE CHANDANI BIHARPUR",
  "Hopes Institute Of Nursing",
  "PIYALI FOUNDATION COLLEGE FOR SPECIAL EDUCATION    ",
  "Rajeev Gandhi Govt. Post Graduate College Ambikapur",
  "MAA MANGALA COLLEGE OF NURSING",
  "R.D.S College Umariya Bilha Bilaspur ",
  "Shri Rameshwar Gahira Guru Sanskrit Mahavidyalaya, Samarwar, Durgapur, Jashpur",
  "NAVEEN GOVERNMENT COLLEGE, TAMASEONI",
  "Mahant Laxminarayan Das College",
  "SHAHEED DEBRIDHUR GOVERNMENT COLLEGE, TONGPAL",
  "NAVEEN GOVERNMENT COLLEGE PACHPEDI DISTRICT BILASPUR",
  "NAVEEN GOVT COLLEGE THELKA",
  "NAVEEN GOVERNMENT COLLEGE, KERA",
  "G.T.B.College, Nehru Nagar, Bilaspur",
  "Mahamaya Excellancy College, Bilaspur",
  "CHAIYTUGAYTA (ALOR) GOVT. COLLEGE PHARASGAON",
  "SHRI RAMESHWAR GAHIRA GURU PRACHYA SANSKRIT COLLEGE, SHRIKOT",
  "GOVERNMENT COLLEGE, RAMCHANDRAPUR, BALRAMPUR",
  "Columbia College of Pharmacy Raipur",
  "Bhilai Institute of Technology Kendri, Raipur",
  "Government Engineering College Koni, Bialspur.",
  "Rungta College of Engineering & Technology Kohka-Kurud Bhilai.",
  "Government Engineering College Raipur",
  "Institute of Technology Government Polytechnic Campus, Korba.",
  "Columbia Institute of Pharmacy Raipur",
  "Siddhi Vinayak Institute of Technology & Science  (College of Pharmacy) Near Balram Talkies, Nehru Nagar",
  "Lakhmi Chand Institute of Technology Vidyasthali, Bilaspur.",
  "Shri Shankaracharya Institute of Professional Management & Technology Mujgahan",
  "Governement Polytechnic College Korea, Baikunthpur Korea",
  "RSR Rungta College of Engineering & Technology Bhilai.",
  "Bhilai Institute of Technology Durg",
  "Raipur Institute of Technology Chhatona, Mandir Hasaud,Raipur.",
  "B R P Govt. Polytechnic Dhamatari",
  "School of Pharmacy Chouksey Engineering College Bilaspur.",
  "Kirodimal Institute of Technology Garh Umaria Raigarh.",
  "NAVEEN GOVERNMENT COLLEGE, RAMPUR, KORBA",
  "SANJIVANI INSTITUTE OF PHARMACY II, JARHABHATA ",
  "Shri Shankaracharya Technical Campus Bhilai ",
  "Chaitanya Science and Arts College Pamgarh",
  "COLLEGE OF AGRICULTURE AND RESEARCH STATION SHANKARGARH",
  "RUNGTA COLLEGE OF PHARMACEUTICAL SCIENCES & RESEARCH",
  "Apollo College of Pharmacy Infront of Vaternery College, Anjora",
  "J K Institute of Engineering Near Gatora Railway Station",
  "Mansa Polytechnic, Kohka Kurud Road. Bhilai.",
  "Govt. Polytechnic Kanker",
  "J K College of Pharmacy Near Gatora Railway Station",
  "SURGUJA GYANODAYA ASSOCIATION",
  "BHILAI INSTITUTE OF PHARMACY, RAIPUR",
  "SHIV SHAKTI ARTS AND SCIENCE COLLEGE KHORSI",
  "NAVIN SHASAKIYA MAHAVIDYALYA RANAHAT DISTRICT BALRAMPUR RAMANUJGANJ CG",
  "LCIT COLLEGE OF COMMERCE AND SCIENCE",
  "Bharat Institute of Nursing Korba",
  "GOVT NAVEEN COLLEGE MAHUD B",
  "PADMA DEVI INSTITUTE OF COMPUTER & ENGINEERING RAIPUR",
  "Shanti Niketan College Changorabhata",
  "Govt. Kachna Dhurwa, College Chhura  ",
  "Vikas Shiksha College Tagor Nagar",
  "SMT. PRAMILA GOKULDAS DAGA GIRL'S COLLEGE, RAIPUR",
  "Mahatma Gandhi College Station Road",
  "Sant Guru Ghasidas Government Post Graduate College Kurud",
  "Indian College of Education Mahasamund",
  "NAVIN GOVT GIRL COLLEGE MANENDRAGARH CHIRIMIRI BHARATPUR",
  "Disha College of Managment Studies, Satyavihar Chankhuri",
  "Govt. Kavopadhayay Hiralal, College Abhanpur",
  "Om Shri Sai Nath College Parstarai",
  "Udanti College Devobhog",
  "Govt. Narayan Rao Meghawale Girls College",
  "Vivekanand College",
  "Shiksha Snatak College Mandher",
  "Vandemataram College Ganesh Chowk",
  "Geneshis College of Higher Education Sihawa Road",
  "Govt. Rajmahant Nayandas, Mahilang College Bhatgao",
  "Govt. D. B. P.G. Girls College kalibadi Chowk",
  "Jai Hind College",
  "Govt. Minimata Grils college Balodabazar",
  "K. D. Rungta College of Science & Technology, Atari",
  "S.K.T.D. Law College",
  "Shaskiya  Brijlal Verma Mahavidyalaya, Palari",
  "Arayabhat Art.& Science College Kopara",
  "Pragati College Chowbey Colony",
  "Govt. Mata Karma Girls College",
  "Shri Pairi Ganga College Mainpur",
  "Ramchandi College Saraipali",
  "Chandrapal Dadsena Govt. College  Pithora",
  "Vivekanand College Bhansoz Mandir Hasoud Road",
  "Ramkrishana Institute of Education, Sunder Nagar",
  "SETH PHOOLCHAND AGRAWAL SMRITI COLLEGE NAWAPARA RAJIM",
  "Century Cement College, Baikunth (Tilda)",
  "R. K. S. College, Newara-Tilda",
  "GURUKUL MAHILA MAHAVIDYALAYA, KALIBADI CHOWK, RAIPUR",
  "D.P. Vipra College of Education, Bilaspur",
  "Govt. Agrasen College, Belha (Bilaspur)",
  "Govt.Jamuna Prasad Varma PG Arts & Commerce College Bilaspur",
  "Mamatamai Minimata Sc. College, Lormi, Bilaspur",
  "SHRI BALAJI INSTITUTE OF MEDICAL SCIENCES",
  "Govt. College Dipka,Korba",
  "Government Mata Shabari Naveen Girls PG College Bilaspur(C.G.) ",
  "Surya College Jagdalpur",
  "Shri Vedmata Gayatri Shiksha College Jagdalpur",
  "Govt. Arvind College Kirandul",
  "Christ College Jagdalpur",
  "Govt. Veer Gend Singh College Pakhanjore",
  "Govt. Indrawati College Bhopalpatnam",
  "Govt. College Bhanpuri",
  "Govt. Shaheed Venkatrao Post Graduate College Bijapur",
  "Govt. Lal Kalind Singh College, Antagarh",
  "GOVT. COLLEGE BAKAWAND, DIST-BASTAR (C.G.)",
  "Shivam College of Nursing",
  "VIPRA KALA VANIJYA AVAM SHARIRIK SHIKSHA MAHAVIDYALAYA G.E. ROAD",
  "SOMANI MAHAVIDYALYA, NH-6 SOMANI",
  "GYANROSHANI COLLEGE OF PHARMACY JANJGIR",
  "SHRI RAMLALA MAHAVIDYALAYA KURMAPALI RAIGARH",
  "LALIT KUMAR CHANDRA COLLEGE BASANTPUR JANJGIR CHAMPA CG",
  "UNIQUE INSTITUTE OF PHARMACY AND RESEARCH",
  "NAVEEN GOVERMENT COLLEGE DADHI, BEMETARA",
  "YUGANTAR INSTITUTE OF PHARMACY ",
  "COLLEGE OF AGRICULTURE, PAKHANJORE",
  "TRIMURTY PROFESSIONAL COLLEGE",
  "MAA GANGADAI GOVT COLLEGE BASTAR, DIST BASTAR",
  "Dr. Bhimrao Ambedkar Government College, Pamgarh",
  "KRUTI SCHOOL OF BUSINESS MENAGEMENT",
  "COLUMBIA COLLEGE ",
  "MOTHER TERESA COLLEGE OF NURSING, 303 RING ROAD, CHOPRAPARA COLLEGE, AMBIKAPUR",
  "JAGATGURU SANKARACHARYA COLLEGE OF NURSING, SEJBAHAR, MUJGAHAN",
  "RASTOGI COLLEGE OF NURSING, VILL-TEDESARA",
  "CHHATTISGARH DENTAL COLLEGE AND RESEARCH INSTITUTE, SUNDARA",
  "K.B.PATEL COLLEGE OF NURSING ,GODRIPARA ,CHIRMIRI",
  "SANDIPANI ACADEMY VILLAGE PENDRI MASTURI DISTRICT BILASPUR CG",
  "MAITRI COLLEGE OF NURSING, G.E.ROAD, ANJORA",
  "SANDIPANI ACADEMY, VILL-ACHHOTI, POST-MURMUNDA, VIA - DHAMDHA, DIST - DURG (C.G.) PIN- 490036",
  "MAHARANA PRATAP HOMOEOPATHY MEDICAL COLLEGE, NEW RAJENDRA NAGAR",
  "RUNGTA COLLEGE OF DENTAL COLLEGE SCIENCE AND RESEARCH KOHKA, KURUD ROAD, BHILAI",
  "P.G. COLLEGE OF NURSING, STREET NO-5, HOSPITAL SECTOR, BHILAI",
  "SANKARACHARYA SWAMI SWAROOPANAND COLLEGE OF NURSING, SMRITI NAGAR, JUNWANI,BHILAI",
  "GOVT.B.SC.NURSING COLLEGE, PAREKH INSTITUTE, CIRCUIT HOUSE, JAGDALPUR",
  "CHRIST COLLEGE OF NURSING, GIDAM ROAD, JAGDALPUR",
  "ADARSH NURSING INSTITUTE, NEAR M.M.I. HOSPITAL, DHAMTARI ROAD, LALPUR",
  "SHRI SHANKARACHARYA COLLEGE OF NURSING, AAMDI NAGAR, HUDCO, BHILAI",
  "CHHATTISGARH INSTITUTE OF MEDICAL SCIENCE (CIMS)",
  "NEW HORIZON DENTAL COLLEGE & RESEARCH INSTITUTE, GANDHI SMRITI VATIKA, MUNGELI ROAD",
  "CHHATTISGARH INSTITUTE OF NURSING COLLEGE, RAMA ARKED, IN FRONT OF ICICI BANK, VYAPAR VIHAR",
  "BODHNI DEVI NURSING INSTITUTE, VILL.&POST-ADWAL, JAGDALPUR",
  "DR. RAJENDRA PRASAD COLLEGE OF NURSING, RISALI, BHILAI",
  "APPOLO COLLEGE OF NURSING IN FRONT OF GOVT. VATENARY COLLEGE, ANJORA",
  "C.L. CHOUKSEY HOMOEOPATHIC COLLEGE, HOSPITAL & RESEARCH CENTRE, LALKHADAN, MASTURI ROAD",
  "SHRISHTI COLLEGE OF NURSING, RAJGAMAR ROAD, IN FRONT OF DISTT.-JAIL",
  "GOVT.B.SC. NURSING COLLEGE, NAMNA RING ROAD, AMBIKAPUR",
  "JAGDALPUR INSTITUTE OF NURSING",
  "St. Vincent Pallotti College Kapa",
  "NEW GOVERNMENT COLLEGE, KANSABEL",
  "AYUSH COLLEGE OF PHARMACY MEDUKA PENDRA ROAD",
  "Govt. Maharshi Valmiki Post Graduate College Bhanupratappur",
  "Chouksey College of Science and Commerce LalKhadan, Bilaspur (C.G.)",
  "Govt. Gundadhur P.G. College, Kondagaon",
  "B.C.S. Govt. P.G. College Dhamtari",
  "GOVERNMENT COLLEGE, DUMARIYA-JARHI",
  "Shaheed Durwasa Nishad Govt. College, Arjunda Dist.- Balod",
  "PT. SHIV KUMAR SHASTRY COLLEGE OF AGRICULTURE & RESEARCH STATION, RAJNANDGAON",
  "COLLEGE OF AGRICULTURE & RESEARCH STATION, RAIGARH",
  "COLLEGE OF AGRICULTURE & RESEARCH STATION, BEMETARA",
  "NAVEEN GOVT COLLEGE MAKDI",
  "SHAHEED NANDKUMAR PATEL GOVT.  COLLEGE BIRGAON",
  "Shri Gobindram Shadani Govt. Arts. & Commerce Girls' College, Devendra Nagar, Raipur",
  "MARK INSTITUTE OF NURSING",
  "MAHAMAYA TECHNICAL AND PROFESSIONAL COLLEGE, RATANPUR",
  "SHREE SAI COLLEGE OF NURSING SEKHUWA KOTMIKALA GAURELA PENDRA MARWAHI CG",
  "NAVEEN GOVT COLLEGE BASIN",
  "SANDIPANI ACADEMY PENDRI MASTURI BILASPUR",
  "Zakir Husain P.G.  Evening College",
  "Bhim Rao Ambedkar College",
  "CHAMPS DSEU OKHLA II CAMPUS",
  "Ayurvedic & Unani Tibbia College",
  "Amar Jyoti Institute of Physiotheraphy",
  "Sri Guru Nanak Dev Khalsa College",
  "Pt. Deendayal Upadhyaya National Institute for  Persons with Physical Disabilities (Divyangjan)",
  "College of Nursing,  Army Hospital (RR)",
  "Sri Guru Gobind Singh College of Commerce",
  "Lady Irwin College",
  "Deen Dayal Upadhyaya College",
  "College of Art",
  "University College of Medical Science & Guru Teg Bahadur Hospital",
  "Maharaja Agrasen Institute of Management Studies",
  "Delhi Institute of Rural Development",
  "Lingaya's Lalita Devi Institute of Management & Sciences",
  "Rajiv Gandhi Cancer Institute & Research Centre",
  "Delhi College of Arts & Commerce",
  "Kamal Institute of Higher Education & Advance Technology",
  "Ram Lal Anand College",
  "Institute of Information Technology & Management",
  "Institute of Innovation in Technology & Management",
  "DSEU Okhla II campus",
  "Ahilya Bai College of Nursing",
  "Durgabai Deshmukh College of Special Education",
  "Delhi Institute of Advanced Studies",
  "R.C. Institute of Technology",
  "Lady Hardinge Medical College",
  "Dr. B.R. Sur Homeopathic Medical College and Hospital and Research Centre",
  "Aditi Mahavidyalaya",
  "College of Nursing,Dr. Ram Manohar Lohia Hospital",
  "Rajkumari Amrit Kaur College of Nursing",
  "Indian Red Cross Society",
  "Chanderprabhu Jain College of Higher Studies & School of Law",
  "Madhu Bala Institute of Communication & Electronic Media",
  "Shaheed Rajguru College of Applied Sciences for Women",
  "Atma Ram Sanatan Dharam College",
  "Deshbandhu College",
  "Jagan Institute of Management Studies (Rohini)",
  "Bara Hindu Rao Hospital",
  "MBS SCHOOL OF PLANNING AND ARCHITECTURE",
  "Delhi Institute of Heritage Research & Management",
  "ESI PGIMSR, ESI HOSPITAL, WEST DELHI",
  "TEACHERS TRAINING INSTITUTE FOR SPECIAL EDUCATION ",
  "VASTU KALA ACADEMY COLLEGE OF ARCHITECTURE",
  "DELHI SCHOOL OF PROFESSIONAL STUDIES AND RESEARCH, NORTH WEST DELHI",
  "Vallabhbhai Patel Chest Institute",
  "Kasturba DSEU Pitampura Campus",
  "DSEU RANHOLA CAMPUS",
  "PGDAV College (Eve.)",
  "Maharaja Surajmal Institute",
  "HMR Institute of Technology & Management",
  "North Delhi Municipal Corporation Medical College",
  "Rukmini Devi Institute of Advanced Studies",
  "DR. BABA SAHEB AMBEDKAR MEDICAL COLLEGE",
  "Amity Institute of Education",
  "GURU TEGH BAHADUR FOURTH CENTENARY ENGINEERING COLLEGE",
  "Trinity Institute of Professional Studies",
  "St . Stephen's College of Nursing",
  "Bhai Parmanand DSEU Shakurpur Campus - II",
  "Satyawati College",
  "PGDAV College",
  "SHARDA DEVI SANSKRIT VIDYAPEETH",
  "Shaheed Bhagat Singh College",
  "BOSCO TECHNICAL TRAINING SOCIETY DON BOSCO TECHNICAL SCHOOL OKHLA ROAD NEW DELHI",
  "Shyama Prasad Mukherji College for Women",
  "SHRI RAM JYOTISH KARM KAND SANSKRIT MAHAVIDAYALA",
  "Shyam Lal College",
  "VISHWA JAGRITI MISSION INTERNATIONAL YOG SCHOOL",
  "Kalka Institute for Research and Advanced Studies",
  "St . Lawrence College of Higher Education",
  "B.K. Institute of Education & Technology",
  "MAHARISHI VEDVYAS VIDYAPEETH",
  "Sri Venkateswara College",
  "Hindu College",
  "Indraprastha College for Women",
  "Maharishi Valmiki College of Education",
  "Holy Family College of Nursing",
  "Aryabhatta College",
  "IAAN SCHOOL OF MASS COMMUNICATION, NEW DELHI",
  "Bharati College",
  "Vardhman Mahavir Medical College & Safdarjung Hospital",
  "DSEU MAYUR VIHAR CAMPUS",
  "Army College of Medical Science",
  "BHAVANs LEELAVATI MUNSHI COLLEGE OF EDUCATION",
  "Bhaskaracharya College of Applied Sciences",
  "Ch. Brahm Prakash Govt. Engineering College",
  "Shri Ram College of Commerce",
  "Dyal Singh College",
  "Gargi College",
  "Ramanujan College",
  "Hans Raj College",
  "MORARJI DESAI NATIONAL INSTITUTE OF YOGA ",
  "Jesus & Mary College",
  "Mata Sundri College for Women",
  "Institute of Management and Research, New Delhi",
  "Maulana Azad Medical College",
  "SHRI MAHAVIR VISHWA VIDYAPEETH",
  "College of Nursing,Safdarjang Hospital",
  "Tecnia Institute of Dance, Music & Fine Arts,Delhi-110 085",
  "ASHTAVAKRA INSTITUTE OF REHABILITATION SCIENCES AND RESEARCH",
  "COMM-IT Career Academy",
  "Gitarattan Institute of Advanced Studies & Training",
  "Shaheed Bhagat Singh Evening College",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, NEW DELHI",
  "Dyal Singh College (Evening)",
  "Kamala Nehru College",
  "BHARATIYA VIDYA BHAVAN ",
  "COLLEGE OF NURSING, HINDU RAO HOSPITAL",
  "State Council of Educational Research & Training",
  "Jagannath International Management School, Kalkaji",
  "Miranda House",
  "Delhi institute of Rural Development (Sister Branch of DIRD)",
  "Nehru Homoeopathic Medical College & Hospital",
  "PANNA DAI COLLEGE OF NURSING NEW DELHI",
  "All India Institute of Ayurveda",
  "Daulat Ram College",
  "Guru Nanak Dev DSEU Rohini Campus",
  "Aryabhatt DSEU Ashok Vihar Campus",
  "Shivaji College",
  "DSEU WAZIRPUR-1 Campus",
  "DSEU Dwarka Campus",
  "DSEU Rajokari Campus",
  "G B PANT DSEU OKHLA-III CAMPUS",
  "College of Nursing Kasturba Hospital",
  "NATIONAL HEART INSTITUTE",
  "Maulana  Azad Institute of Dental Sciences",
  "Banarasi Das Chandiwala Institute of Professional Studies",
  "NATIONAL INSTITUTE OF LABOUR ECONOMICS RESEARCH AND DEVELOPMENT",
  "Bhagwan Parshuram Institute of Technology",
  "Banarasi Das Chandiwala Institute of Physiotherapy",
  "ISIC Institute of Rehabilitation Sciences",
  "Guru Nanak College of Education",
  "AMBEDKAR INSTITUTE OF ADVANCED COMMUNICATION TECHNOLOGIES AND RESEARCH , GEETA COLONY DELHI",
  "Ch. Brahm Prakash Ayurved Charak Sansthan",
  "Maharaja Surajmal Institute of Technology",
  "New Delhi Institute of Management",
  "V.D. Institute of Technology",
  "DSEU PUSA  CAMPUS II ",
  "National Centre for Diseases Control",
  "Ideal Institute of Management & Technology",
  "Bharati Vidyapeeth Institute of Computer Applications & Management",
  "Bharati Vidyapeeth's College of Engineering",
  "Banarsidas Chandiwala Institute of Hotel Management & Catering Technology",
  "National Institute of Public Cooperation and Child Development",
  "Jagannath International Management School,Vasant Kunj",
  "DSEU Vivek Vihar Campus",
  "DSEU SIRI FORT CAMPUS",
  "DR. AKHILESH DAS GUPTA INSTITUTE OF PROFESSIONAL STUDIES",
  "Ramjas College",
  "Institute of Home Economics",
  "Indira Gandhi Institute of Physical Education & Sports Sciences",
  "Pradeep Memorial Comprehensive College of Education",
  "Guru Teg Bahadur Institute of Technology",
  "Swami Shraddhanand College",
  "Maharaja Agrasen Institute of Technology",
  "Banarasi Das Chandiwala Institute of Information Technology",
  "Delhi Institute of Pharmaceutical Sciences & Research",
  "Shaheed Sukhdev College of Business Studies",
  "Florence Nightingale College of Nursing",
  "Tecnia Institute of Advanced Studies",
  "Bhagini Nivedita College",
  "Lakshmi  Bai College",
  "ESIC Dental College",
  "Vivekanand Institute of Professional Studies Technical Campus",
  "College of Vocational Studies",
  "Vivekananda College",
  "Lakshmi Bai Batra College of Nursing",
  "Fairfield Institute of Management & Technology",
  "Rajdhani College",
  "Guru Ram Dass College of Education",
  "AMBEDKAR DSEU, SHAKARPUR CAMPUS - I",
  "G.B. PANT DSEU OKHLA - I CAMPUS",
  "Action For Autism National Centre for Autism India",
  "Delhi Teachers Training College",
  "Moti Lal Nehru College (Evening)",
  "National Power Training Institute",
  "Army Institute of Education",
  "Gitarattan International Business School",
  "Sri Guru Tegh Bahadur Institute of Management and Information Technology",
  "Kirori Mal College",
  "College of Nursing, Institute of Liver and Biliary Sciences",
  "Sant Hari Dass College Of Higher Education",
  "Acharya Narendra Dev College",
  "Janki Devi Memorial College",
  "Periyar Management and Computer College, Jasola",
  "Kalindi College",
  "Sirifort College of Computer Technology & Management",
  "Maitreyi College",
  "Management Education & Research Institute",
  "Sri Aurobindo College",
  "Meera Bai DSEU Maharani Bagh Campus",
  "Lal Bahadur Shastri Institute of Management",
  "Moti Lal Nehru College",
  "Sri Guru Teg Bahadur Khalsa College",
  "DON BOSCO INSTITUTE OF TECHNOLOGY",
  "SANT NAGPAL SANSKRIT MAHAVIDYALAYA EVAM SHODH SANSTHAN",
  "Satyawati College (Evening)",
  "Sri Ram Institute of Teacher Education",
  "Shyam Lal College (Eve.)",
  "Zakir Husain Delhi College",
  "Sri Aurobindo College (Eve.)",
  "School of Open Learning",
  "St. Stephens's College",
  "Guru Nanak Institute of Management",
  "Maharaja Agrasen College",
  "Dr. Ram Manohar Lohia Hospital(PGIMER)",
  "Keshav Mahavidyalaya",
  "Institute of Vocational Studies",
  "Lady Shri Ram College for Women",
  "Kasturi Ram College of Higher Education",
  "V M  SALGAOCAR INSTITUTE OF INTERNATIONAL HOSPITALITY EDUCATION, RAIA",
  "SWAMI VIVEKANAND VIDYA PRASARAK MANDALS COLLEGE OF COMMERCE,",
  "AGNEL INSTITUTE OF TECHNOLOGY AND DESIGN, ASSAGAO, BARDEZ",
  "JD SCHOOL OF DESIGN",
  "Shree Rayeshwar Institute of Engineering  & Information Technology Shiroda",
  "Ponda Education Societys College of Education  Farmagudi  Ponda",
  "DNYANVARDHINI DIVYANG TRAINING COLLEGE ",
  "Shivgram Education Societys Shri Kamaxidevi Homoeopathic Medical College & Hospital Shiroda",
  "PADMINI COLLEGE OF PHARMACY",
  "GOA COLLEGE OF HOSPITALITY AND CULINARY EDUCATION, CIDADE-DE-GOA",
  "VIDYA PRABODHINI COLLEGE OF COMMERCE, EDUCATION, COMPUTER AND MANAGEMENT, VIDYANAGAR, ALTO PORVORIM",
  "SHREE SATERI PISSANI EDUCATION SOCEITY'S  SHRI GOPAL GAONKAR MEMORIAL GOA MULTI FACULTY COLLEGE, DHARBANDORA",
  "National Centre for Polar and Ocean Research",
  "CHOWGULE EDUCATION SOCIETYS PARVATIBAI CHOWGULE COLLEGE OF ARTS AND SCIENCE",
  "VIKAS PARISHAD MANDRE COLLEGE OF COMMERCE AND ECONOMICS, MANDHLAMANJ, MANDREM ",
  "Kala Academy Goa's College of Theatre Arts",
  "Government College of Commerce and Economics, Borda,  Margao",
  "The Cuncolim Educational Societys College of Arts & Commerce  Cuncolim, Salcete Goa - 403703",
  "Directorate of Archives and Archaeology",
  "Fisheries Survey of India",
  "Dnyanprassarak Mandal's College and Research Centre,  Assagao, Bardez, Goa -403507",
  "NAVAL WAR COLLEGE",
  "Goa Vidyaprasarak Mandals  Gopal Govind Poy Raiturcar College of Commerce and  Economics Farmagudi  Ponda",
  "Ponda Education Society's Ravi S Naik College of Arts & Science",
  "GOA COLLEGE OF PHYSIOTHERAPY NATUROPATHY AND YOGIC SCIENCE",
  "GOA COLLEGE OF AGRICULTURE",
  "SHRI BHUMIKA NURSING COLLEGE",
  "Thomas Stephen's Konkani Kendra",
  "ALL INDIA INSTITUTE OF AYURVEDA",
  "Xavier Centre of Historical Research",
  "RAMANATA CRISNA PAI RAIKAR SCHOOL OF AGRICULTURE",
  "Syngenta Research & Technology Centre",
  "DON BOSCO COLLEGE OF ENGINEERING, FATORDA, MARGAO",
  "Malaria Research Centre",
  "SANT SOHIROBANATH AMBIYE GOVERNMENT COLLEGE AND RESEARCH CENTRE, VIRNODA, PERNEM, GOA",
  "Centre for Latin American Studies",
  "Centre for Women's Studies",
  "Carmel College of Arts Science & Commerce for Women",
  "Goa College of Pharmacy  Panaji",
  "Rosary College of Commerce & Arts  Navelim",
  "Harmal Panchakroshi Shikshan Mandals Ganpat Parsekar College of Education, Vidya Sankul, Bhom Plateau, Harmal, Pernem, Goa",
  "Pragati Women's College of Education",
  "KAMAXI COLLEGE OF CULINARY ARTS ",
  "Institute of Psychiatry & Human Behaviour Bambolim",
  "Goa Vidyaprasarak Mandal's  Dr. Dada Vaidya College of Education, Ponda",
  "NATIONAL FORENSIC SCIENCES UNIVERSITY GOA CAMPUS",
  "Govt.College of Arts Science & Commerce Quepem",
  "Padre Conceicao College of Engineering  Agnel Ashram Verna",
  "SWAMI BRAHMANAND MAHAVIDYALAYA",
  "Devi Sharvani Education Societys V.M. Salgaocar College of Law Miramar Panaji",
  "Saraswat Education Societys Sridora Caculo College of Commerce & Management Studies, Mapusa, Goa",
  "Govt.College of Arts Science & Commerce Khandola",
  "Goa College of Home Science Campal Panaji",
  "Ponda Education Society's Rajaram and Tarabai Bandekar College of Pharmacy, Farmagudi, Ponda",
  "Goa Dental College & Hospital Bambolim",
  "Goa College of Architecture Altinho Panaji",
  "Goa Salesian Societys Don Bosco College  Panaji",
  "Goa College of Art  Altinho  Panaji",
  "Dnyan Prabodhini Mandals SHREE MALLIKARJUN & Shri. Chetan Manju Desai College, Delem-Canacona, Goa",
  "Goa Medical  College Bambolim",
  "Dempo Charities Trust Dhempe College of Arts & Science Miramar",
  "GOA COLLEGE OF ENGINEERING (GOVERNMENT OF GOA)",
  "National Institute of Hydrography",
  "National Institute of Oceanography",
  "Nirmala Institute of Education Altinho Panaji",
  "St. Xavier's College",
  "Vidya Vikas Mandals Govind Ramnath Kare College of Law  Margao",
  "Srinivassa Sinai Dempo College of Commerce and Economics",
  "Shree Bharateeya Sanskriti Prabodhinis Gomantak Ayurveda Mahavidyalaya & Research Centre  Shiroda",
  "Zanyte Brothers Educational Foundations Narayan Zantye College of Commerce, Bicholim, Goa",
  "Vrundavan Institute of Nursing Education & College of Nursing Colvale Bardez",
  "Goa College of Music Altinho Panaji",
  "Murgaon Education Society's Vasant Joshi College of Arts & Commerce, Zuarinagar",
  "Fr. Agnel College of Arts & Commerce  Pilar",
  "HARMAL PANCHAKROSHI SHIKSHAN MANDALS COLLEGE OF NURSING",
  "St. Joseph Vaz College, Cortalim",
  "Govt.College of Arts Science & Commerce  Sanquelim",
  "Vidya Vikas Mandals Shree Damodar College of Commerce & Economics Margao",
  "Birla Institute of Technology and Science Pilani K K Birla Goa Campus",
  "Institute of Nursing Education Bambolim",
  "Shri Bhuj Mercantile Co-Op Bank Charitable Trust Sanchalit Nursing College",
  "ANANYA COLLEGE OF HOMOEOPATHY",
  "SKUM college of Physiotherapy",
  "science college vadali",
  "SARVODAY INSTITUTE OF NURSING",
  "SMT S G RAO NURSING COLLEGE",
  "SHREE SURYODAY PGDMLT COLLEGE DHANERA",
  "Ganpat University B. S.Patel Polytechnic",
  "Jay Jalaram Ayurvedic Medical College",
  "Shri N.A.Patel Science College",
  "Sondarba Ramsinh Mangrola Institute of Science Studies, Valia",
  "PG CENTER OF SOCIAL WORK SHRI ADARSH M.S.W.COLLEGE",
  "SHRI ADARSH M.Sc.(IT) COLLEGE",
  "College of Dairy Science",
  "PGDCA COLLEGE ANDROKHA",
  "Gyanmanjari Institute of Technology",
  "B.G. GARAIYA HOMOEOPATHIC MEDICAL COLLEGE",
  "Krishna Institute of Engineering and Technology,jamnagar",
  "Government Arts and Commerce College, Barwala",
  "Government Science College, Gariyadhar",
  "Brahmachariwadi Institute of Sanskrit Studies, Ahmedabad",
  "shree un vibhag kelvani mandal sanchalit science college Un",
  "Smt. Kamlaben P. Patel Institute of Physiotherapy and Occupational Therapy",
  "Smt. Shantaben Haribhai Gajera Engineering College",
  "ADARSH SCIENCE COLLEGE, NAPA",
  "Vimal Tormal Poddar Commerce College",
  "Shree JM Patel Institute of Social Work and Applied Arts, Anand",
  "Smt S. K. Shah(Chahwala) College of Education, Kapadwanj",
  "Asia Pacific Commerce College",
  "GMERS MEDICAL COLLEGE",
  "Bhaskaracharya Institute for Space Applications & Geo Informatics",
  "Bio Care Research (India) Pvt. Ltd",
  "Narsinhbhai Institute of Computer Studies and Management",
  "U. N. Mehta Institute of Cardiology & Research Centre",
  "ARADHANA SCIENCE COLLEGE",
  "Smt. M P Patel College of Commerce and Centre for Professional Studies",
  "A-ONE PHARMACY COLLEGE, ENASAN  206 ",
  "VINAYAK INSTITUTE OF NURSING",
  "Smt Jayaben B Patel College of Commerce Studies & Research",
  "SHRI D N INSTITUTE OF P G STUDIES IN COMMERCE, ANAND",
  "UMIYA EDUCATION TRUST B ED COLLEGE",
  "K.M shah dental college & Hospital",
  "Government Physiotherapy College",
  "SARVODAY COLLEGE OF PHYSIOTHERAPY",
  "SWAMI VIVEKANAND EDUCATION TRUST M ED COLLEGE",
  "SOHAM INSTITUTE OF NURSING",
  "VIDYANAGAR B ED COLLEGE",
  "TAKSHASHILA EDUCATION COLLEGE",
  "UMA B ED COLLEGE",
  "Institute of Medical Post-graduate Studies & Research",
  "Gandhinagar Charitable Trust Sanchalit Samarpan Arts and Commerce College, Gandhinagar",
  "SHRIMAD RAJCHANDRA VIDYAPEETH, DHARAMPUR",
  "SMT. SHANTAGAURI RASIKLAL SHAH(RANGWALA) COLLEGE OF PHYSIOTHERAPY",
  "Maniben M.P.Shah Mahila Arts College, Kadi",
  "A P TRIVEDI ARTS, COMMERCE AND SCIENCE COLLEGE, KHORDA",
  "MERCHANT SCIENCE COLLEGE, VISNAGAR",
  "KAMDAR COLLEGE OF NURSING",
  "ANJAR EDUCATION SOCIETY SANCHALIT PGDSPM COLLEGE",
  "SHRI SAHJANAND GIRLS INSTITUTE, BHUJ",
  "SHREE SWAMINARAYAN POLYTECHNIC",
  "SHREE SWAMINARAYAN INSTITUTE OF TECHNOLOGY",
  "SHREE SWAMINARAYAN BED COLLEGE, BOTAD",
  "SHREE SWAMINARAYAN NAIMISHARANYA COLLEGE OF SCIENCE, BHAVNAGAR",
  "MATUSHRI RATANBEN RAMJIBHAI MONPARA ARTS COLLEGE KALIYABID",
  "SWAMINARAYAN COLLEGE OF COMPUTER SCIENCE, BHAVNAGAR",
  "S S Agrawal Institute of Physiotherapy and Medical Care Education",
  "SASCMA English Medium College",
  "L. M. College Of Pharmacy (Diploma) 408",
  "OM ENGINEERING COLLEGE CHOKLI, JUNAGADH 102",
  "IPCOWALA INSTITUTE OF ENGINEERING & TECHNOLOGY DHARMAJ, ANAND 101",
  " Dr. Subhash Technical Campus - 083",
  "Shri Labhubhai Trivedi Institute of Engineering And Technology, Rajkot 089",
  "Shri SWAMI ATMANAND SARASWATI INSTITUTE OF TECH., SURAT  076",
  "SHANKERSINH VAGHELA BAPU INSTITUTE OF TECH., UNAVA, GANDHINAGAR 075",
  "K.J. INSTITUTE OF ENGG. AND TECH., SAVALI 064",
  "GOVERNMENT ENGINEERING COLLEGE, PALANPUR 061",
  "Laxmi Institute of Technology, Valsad 086",
  "BIRLA VISHVAKARMA MAHAVIDHYALAYA, V.V.NAGAR 007 ",
  "HJD INSTITUTE OF TECHNICAL EDUCATION AND RESERCH, Kera 085",
  "GOVERNMENT ENGINEERING COLLEGE, GODHARA  060",
  "Dr. Jivraj Mehta Institute of Technology, Anand 082",
  "VADODARA INSTITUTE OF ENGG., KOTAMBI, WAGHODIYA 080",
  "Smt. S.R. PATEL ENGG. COLLEGE, DABHI, UNJHA 078 ",
  "FACULTY OF ENGG., MARWADI EDU. FOUNDATION GROUP OF INSTITUTIONS, RAJKOT 057",
  "ENGGINERING COLLEGE, TUWA, GODHARA 055 ",
  "Government Polytechnic,Palanpur 626",
  "Government Polytechnic,Jamnagar 625",
  "Government Polytechnic,Himmatnagar 624",
  "Government Polytechnic,Gandhinagar 623",
  "Government Polytechnic Godhra 618",
  "ARRDKETA INSTITUTE OF TECHNOLOGY RASHIWAD, SABARKANTHA 093 ",
  "SHRI SATSANGI SAKETDHAM `RAM ASHRAM` GROUP OF INSTITUTIONS, Vadasma 091",
  "SAMARTH COLLEGE OF ENGINEERING & TECHNOLOGY, Himatnagar 088 ",
  "SAL INSTITUTE OF TECH. & ENGG. RESEARCH, AHMEDABAD 067",
  " Central Institute of Petrochemicals engineering & Technology, VATVA, AHMEDABAD 052 ",
  "GOVERNMENT ENGINEERING COLLEGE, MODASA 016",
  "V.V.P. ENGINEERING COLLEGE, RAJKOT 047",
  "SHRI SADVIDHYA MANDAL INSTITUTE OF TECH., BHARUCH 045",
  "SHANTILAL SHAH ENGINEERING COLLEGE ,BHAVNAGAR 043",
  "SARDAR VALLABHBHAI PATEL INSTITUTE OF TECH.,VASAD 041",
  "S.P.B. PATEL ENGG. COLLEGE(SAFFRONY), LINCH, MAHESHANA 039 ",
  "NARNARAYAN SHASTRI INSTITUTE OF TECH., JETALPUR 034",
  "MAHATMA GANDHI INST.OF TECHNICAL EDU. AND RESEARCH CENTER,NAVASARI 033 ",
  "L.J.Institue of Engineering and technology (SFI)-Ahmedabad 032",
  "LALJIBHAI CHATURBHAI INSTITUTE OF TECH., BHANDU 029",
  "L.D.COLLEGE OF ENGINEERING, AHMEDABAD 028 ",
  "KALOL INSTITUTE OF TECH. & RESEARCH CENTER ,KALOL 026 ",
  "PARUL INSTITUTE OF ENGG. AND TECH., LIMDA, VAGHODIA",
  "GOVERNMENT ENGINEERING COLLEGE, PATAN 022",
  "GOVERNMENT ENGINEERING COLLEGE, BHAVNAGAR 021 ",
  "GOVERNMENT ENGINEERING COLLEGE, RAJKOT 020",
  "GOVERNMENT ENGINEERING COLLEGE, VALSAD 019",
  "GOVERNMENT ENGINEERING COLLEGE, DAHOD 018",
  "VISHWAKARMA GOVERNMENT ENGINEERING COLLEGE, CHANDKHEDA,GANDHINAGAR 017 ",
  "GOVERNMENT ENGINEERING COLLEGE, BHUJ 015 ",
  "SHRI V M SAKARIYA MAHILA COMMERCE COLLEGE",
  "SHRI SHAILESH CHANDULAL GANDHI B C A COLLEGE",
  "SHRI UMIYA MAHILA ARTS AND COMMERCE COLLEGE",
  "SHREE SWAMINARAYAN COMMERCE COLLEGE",
  "SHREE SWAMINARAYAN ARTS COLLEGE",
  "College of Agricultural Engineering & Technology, Godhra",
  "S D SOLANKI BCA COLLEGE, KUSKI",
  "SHRI SARVAJANIK MSCCA AND IT COLLEGE, MEHSANA",
  "SHREE MAHARSHI DAYANAND SARASWATI B Ed COLLEGE, TANKARA",
  "BHAGYALAXMI NURSING COLLEGE MODASA",
  "SMT H D PATEL BED COLLEGE SUJANPUR",
  "SHRI ADARSH SCIENCE COLLEGE RADHANPUR",
  "GOVERNMENT NURSING COLLEGE SIDDHPUR",
  "G M E R S MEDICAL COLLEGE DHARPUR",
  "DENTAL COLLEGE AND HOSPITAL SIDDHPUR",
  "SMT S A PATEL BED COLLEGE RAMPURA",
  "SHRI SARVAJANIK COMMERCE COLLEGE ENGLISH MIDUM",
  "SHRI SARVAJANIK BBA COLEGE MEHSANA",
  "GOVERNMENT SCIENCE COLLEGE VADNAGR",
  "LOKNIKETAN SAMAJKARYA MAHA VIHDYALAY PALANPUR",
  "Munshi Mahila B.Ed. College",
  "Government Arts College, Kaprada, Valsad",
  "Government Arts College, Jhagadia, Bharuch",
  "Government Arts College, Sagbara, Narmada",
  "Naran Lala Institute of Teacher Education",
  "J. P. Pardiwala Arts & Commerce College, Pardi",
  "Z. F. Wadia Womens College and N. K. Johta College of Commerce, Chorasi",
  "J. N. Patel B. Ed. College",
  "SHRI S.J.THAKKAR B.ED.COLLEGE-RAJKOT",
  "J. Z. Shah Arts & H. P. Desai Commerce College",
  "Narmada College of Science & Commerce",
  "Sheth C. D. Barfiwala College of Commerce",
  "R. K. Desai College of Education",
  "Vivekanand College for BBA",
  "Government Nursing College",
  "C. N. Kothari Homeopathic Medical College & Research Centre",
  "Tarkesh & Niranjana Sureshbhai Patel Commerce College, Boriavi",
  "Shri Saraswati College of Social Work",
  "B and B Institute of Technology,Vallabh Vidhyanagar - GIA 604 ",
  "A. Y. Dadabhai Technical Institute, Kosamba  601 ",
  "PRESIDENT NURSING COLLEGE",
  "KD INSTITUTE OF NURSING SCIENCE",
  "SHRADDHA MSC COLLEGE ",
  "SHAMA INSTITUTE OF MEDICAL SCIENCES",
  "BHARATIA POLYTECHNIC IN ANIMAL HUSBANDRY SURAT",
  "Van Bandhu Agriculture Polytechnic, Amirgadh",
  "VAN BANDHU POLYTECHNIC IN AGRICULTURE, KHEDBRAHMA",
  "VIVEKANAND NURSING COLLEGE",
  "R B AMIN NURSING INSTITUTE",
  "C S SHUKLA BSW COLLEGE VIRPUR",
  "SHRI K R KATARA DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "KARNAVATI INSTITUTE OF COMPUTER APPLICATION",
  "SHRI MATRUVANDAN B.ED. COLLEGE, SIMAR (KIDIVAV)",
  "LATE R. P. PATEL NURSING COLLEGE & PRAMUKH SWAMI SCHOOL OF NURSING, ODE",
  "Shri Bhaikaka Government Arts and Commerce, Sojitra",
  "NILKANTH M SC CA AND IT COLLEGE VISNAGAR",
  "ANANT INSTITUTE OF COMPUTER APPLICATION",
  "KARNAVATI INSTITUTE OF NURSING",
  "KALOL INSTITUTE OF PHARMACY, KALOL",
  "GROW MORE FACULTY OF DIPLOMA ENGINEERING",
  "MERCHANT PHARMACY COLLEGE",
  "ARUN MUCHHALA ENGINEERING COLLEGE KHOKHARA MAHADEV, AMRELI",
  "Adarsh B.C.A. College",
  "Adarsh B.Ed. College",
  "SHREE ADARSH B SC COLLEGE, ADARSH EDUCATIONAL CAMPUS",
  "SOM-LALIT POLYTECHNIC",
  "D.A. Diploma Engg. and Technology, Mahemdavad",
  "PACIFIC SCHOOL OF ENGINEERING",
  "Ved Vyas Polytechnic, Himmatnagar",
  "ASIATIC INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "Arpit Institute of Engineering & Technology (Diploma),Hadala,Rajkot",
  "Shri K. K. Shastri Government Commerce College, Maninagar",
  "M.L.Institute of Diploma Studies, Bhandu",
  "Growmore Group of Institutions (SFI)-Himmatnagar",
  "Swami Krishnajivandasji Institute of Technology, Sokli",
  "NOBLE STAR DIPLOMA ENGINEERING COLLEGE, Junagadh",
  "Shantilal Shah Pharmacy College (Diploma)",
  "SWAMINARAYAN AYURVED COLLEGE, SAIJ",
  "GEETANJALI POST GRADUATE CENTER",
  "S. R. Luthra Institute of Management",
  "SARASWATI NURSING COLLEGE",
  "BHAGWAN MAHAVIR COLLEGE OF DESIGN AND PLANING",
  "GOVERNMENT ARTS COLLEGE, BHANVAD",
  "MONARK AYURVED MEDICAL COLLEGE AND HOSPITAL",
  "FACULTY OF DESIGN",
  "GMERS MEDICAL COLLEGE, NAVSARI",
  "SMT. VASANTBEN N. VYAS B.ED COLLEGE AMRELI",
  "Anjar Education Society Sanchalit P.G.D.H.R.M. College",
  "Shree Rang Navchetan Mahila Arts College",
  "I. V. Patel College of Commerce",
  "Shri Bhikhabhai Patel Arts College, Anand",
  "Shri R. P. Anada College of Education",
  "C. B. Patel Arts College",
  "M. D. Shah Commerce & B. D. Patel Arts College",
  "Rama Manubhai Desai College of Music and Dance, Vallabh Vidyanagar",
  "J.K.Sarvaiya BSW college",
  "Shree J.C. Kumarappa Mahavidyalaya",
  "FACULTY OF TECHNOLOGY",
  "J.K.RAM ARTS, COMMERCE  & COMPUTER SCIENCE COLLEGE-VERAVAL",
  "DR.SUBHASH COLLEGE OF PHYSICAL EDUCATION-JUNAGADH",
  "DR SUBHASH UNIVERSITY, SCHOOL OF ENGINEERING AND TECHNOLOGY",
  "GAYATRI GURUKRUPA LAW COLLEGE ",
  "NAVNEET CHANDRAVALLABH ARTS COLLEGE",
  "AKSHAR DIPLOMA IN HELTH AND SANITARY INSPECTOR",
  "RKM PGDCA TECHNICAL COLLEGE VIJAYANAGAR",
  "SDJ International College",
  "ENGLISH MEDIUM COMMERCE COLLEGE DAHOD",
  "FAKIRBHAI PATEL INSTITUTE OF NURSING ",
  "SAMARPAN NURSING COLLEGE",
  "NATIONAL INSTITUTE OF BUSINESS ADMINISTRATION     ",
  "Shri Akhandvidhya Aranyak Gurukul B.Ed. College, Valsad",
  "NATIONAL INSTITUTE OF BACHELOR OF COMPUTER APPLICATION    ",
  "SMT RANIBEN MADHABHAI BHADARKA LAW COLLEGE ",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE NIZAR     ",
  "VISHWABHARTI GIRLS INSTITUTE OF NURSING",
  "PRATHANA COLLEGE OF NURSING    ",
  "SHRI SHAMLAJI HOMOEPETHIC MEDICAL COLLEGE",
  "MANJUSHREE INSTITUTE OF PHARMACY    ",
  "SHREE ARYATEJ INSTITUTE OF MANAGEMENT AND COMPUTER SCIENCE    ",
  "MAHARANISHREE NANDKUNVERBA MAHILA ARTS AND COMMERCE COLLEGE",
  "SCHOOL OF APPLIED SCIENCES AND TECHNOLOGY",
  "SHREE M A CHAVDA SCIENCE COLLEGE,KANBHA    ",
  "KTKM INSTITUTE OF MANAGEMENT AND COMPUTER APPLICATION    ",
  "Shri Sumanbhai Rangjibhai Bhabhor Arts College, Singvad",
  "G D PATEL MSC CA AND IT INSTITUTE, VIDHYANAGARI, HIMATNAGAR    ",
  "SIDDHIVINAYAK MSC COLLEGE    ",
  "SMT SHARDA DEVI SINGH ROFEL COLLEGE OF COMMERCE, VAPI",
  "ARTS COLLEGE  CHALALA    ",
  "SIDDHI VINAYAK INSTITUTE OF NURSING, DAKOR",
  "NACHIKETA BVOC COLLEGE LADOL    ",
  "HANSABA ARTS AND COMMERCE COLLEGE, CHARUP    ",
  "CVM SCHOOL OF DESIGN    ",
  "SHREE SWAMINARAYAN BCA COLLEGE    ",
  "CVM HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "SHRI K N PATEL M S W COLLEGE    ",
  " DR INDU DAYAL MESHRI  INSTITUTE OF COMPUTER SCIENCE AND TECHNOLOGY    ",
  "BHAGYODAY MEDICAL COLLEGE    ",
  "SHRI SENAL ARTS COLLEGE, PILUDA    ",
  "NARAYANI EDUCATION INSTITUTE    ",
  "SHREE REVA MSW COLLEGE PALANPUR     ",
  "ARTS COLLEGE, PALADI",
  "KMCA COMMERCE COLLEGE    ",
  "MATRU SHREE KESARBEN SAVAANIYA BED COLLEGE VERAVAL    ",
  "L.D.R.P. INSTITUTE OF TECH. & RESEARCH., GANDHINAGAR",
  "K B INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
  "COLLEGE OF AGRICULTURE THARAD",
  "S.V. Institute of Management (SFI),Kadi.",
  "BHAVANI SCHOOL OF NURSING",
  "AMBAJI NURSING COLLEGE POST BASIC BSC NURSING",
  "SHREE ARYATEJ INSTITUTE OF PHARMACY    ",
  "Government Dental College and Hospital, Ahmedabad",
  "LAXMINARAYAN  INSTITUTE OF NURSING",
  "ARRDEKTA HOMOEOPATHIC MEDICAL COLLEG AND HOSPITAL",
  "SHRI H V MEHTA INSTITUTE OF NURSING",
  "ONE WORLD INSTITUTE OF NURSING",
  "KAMLA AMRUT INSTITUTE OF NURSING",
  "ANANTA INSTITUTE OF NURSING",
  "ASHWINBHAI K PARIKH AND RASIKLAL N SHAH INSTITUTE OF NURSING",
  "SHIVAM COLLEGE OF NURSING",
  "CAPITAL NURSING COLLEGE",
  "SHREE SHAMALAJI NURSING COLLEGE ",
  "Navgujarat College of Computer Application",
  "Dr.ASHABEN PATEL GOVERNMENT SCIENCE COLLEGE UNJHA",
  "ARUNABEN BHAKTA NURSING COLLEGE",
  "KERR INSTITUTE OF LEGAL STUDIES    ",
  "P P Savani School of Management",
  "P P Savani School of Nursing",
  "RANCHODBHAI HARMANBHAI PATEL INSTITUTE OF NURSING EDUCATION AND RESEARCH CENTRE ",
  "TANARIRI PERFORMING ARTS COLLEGE ",
  "Vatsalya Nursing and Research Institute",
  "SAVITRI PATEL COLLEGE OF PHYSIOTHERAPY",
  "AM College of Science, Management & Computer Technology, Anand",
  "SHRI NAVJEEVAN DIPLOMA IN HEALTH AND SANITARY INSPECTOR ",
  "JK NURSING COLLEGE",
  "SHREE KESHARBA INSTITUTE OF NURSING COLLEGE",
  "SRK Institute  of Management & Computer Education (SFI)-Anjar Kutchh 781",
  "Patel Group of Institutions (SFI)-Moti Dau,Tal-Dist-Mehsana 803",
  "TAPI DIPLOMA ENGINEERING COLLEGE",
  "Grow More Faculty of Management (SFI),Himmatnagar",
  "VIDHYADEEP INSTITUTE OF PHARMACY",
  "Dharmaj College of Education",
  "VIDHYADEEP INSTITUTE OF NURSING (B.Sc. Nursing)",
  "MB Patel College of Education, Vallabh Vidyanagar",
  "Smt. Pushpaben Kanaiyalal Inamdar College of Education, Bakrol",
  "ARTS & COMMERCE COLLEGE, MENDARDA",
  "Shree PM Patel Institute of Postgraduate Studies & Research in Science, Anand",
  "MAHILA ARTS, COMMERCE &  COLLEGE, JETPUR",
  "M.P. SHAH COMMERCE COLLEGE -SURENDRANAGAR",
  "SMT. V.D. GHELANI MAHILA ARTS COLLEGE, SAVARKUNDLA",
  "SHREE SHYAMJI KRISHNA VERMA B.ED. COLLEGE-RAJKOT",
  "SHREE SARASWATI SHIKSHAN MAHAVIDHYALAY,BHUTVAD(TA.-DHORAJI)",
  "SHRI H.N.SHUKAL COLLEGE OF TEACHER EDUCATION AMARGADH",
  "MATUSHRI VIRBAIMA MAHILA ARTS COLLEGE, RAJKOT",
  "GOVERNMENT DENTAL COLLEGE, JAMNAGAR",
  "C.U.SHAH PHYSIOTHERPY COLLEGE-SURENDRANAGAR",
  "V.D.KANKIYA ARTS & M.R.SANGHVI COMMERCE COLLEGE-SAVARKUNDLA",
  "GAYATRI GURUKRUPA B.ED. COLLEGE, LATHI",
  "S. V. Commerce College",
  "Shree Narmada Gramvidhyapith",
  "College of Fisheries Sciences- Veraval",
  "College of Veterinary Science and Animal Husbandary- Junagadh",
  "POLYTECHNIC IN ANIMAL HUSBANDARY, JUNAGADH",
  "College of Veterinary Science & Animal Husbandary",
  "R. R. Lalan College, Bhuj",
  "CHITRINI NURSING COLLEGE FOR WOMEN PRANTIJ",
  "COLLEGE OF DENTAL SCIENCE AND RESEARCH CENTRE, BOPAL",
  "G C S MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE",
  "LOKMANYA COLLEGE OF EDUCATION (M ED)",
  "SAL SCHOOL OF ARCHITECTURE (356)",
  "Shree M.D.Patel Arts and Science College Takhatpur",
  "GOVERNMENT ARTS AND  SCIENCE COLLEGE PATDI ",
  "N J SONECHA MANAGEMENT AND TECHNICAL INSTITUTE, VERAVAL 817",
  "GLS Institute of Computer Technology (MCA Program) (SFI)-Ahmedabad",
  "SHARDA COLLEGE OF PHYSIOTHERAPY",
  "President Science College",
  "Smt. Galbiba Bhikhabhai Pavaya & Smt. Puriba Shamjibhai Pavaya Science College, Palanpur",
  "P P SAVANI SCHOOL OF CONTINUING EDUCATION",
  "P P SAVANI SCHOOL OF AGRICULTURE",
  "SHREE KUMARI SINOMI HITEN GARDI COMMERCE COLLEGE, NR BHARATNAGAR CHOCK",
  "P P Savani School of Science",
  "AARYA VEER NURSING INSTITUTE,RAJKOT",
  "SIGMA COLLEGE OF SANITARY INSPECTOR",
  "SHREE SWAMI VIVEKANAND COLLEGE OF NURSING",
  "GRADUATE SCHOOL OF PHARMACY",
  "SHRI SHARAD SHAH COLLEGE OF SOCIAL SCIENCE",
  "S S MAHLA COMPUTER SCIENCE COLLEGE",
  "Shri Muktajivan Swamibapa Kelvani Mandal Sanchalit Arts College",
  "SHREE SWAMINARAYAN MSW COLLEGE",
  "SHREE NARAYANMUNIDEV NURSING COLLEGE",
  "SHREE SWAMINARAYAN PARAMSUKH NURSING COLLEGE",
  "FACULTY OF COMPUTER APPLICATION",
  "B M PATEL PGDMLT COLLEGE HAJIPUR ",
  "BCA COLLEGE ANDROKHA",
  "SHRI P J PATEL NILKANTH COLLEGE OF NURSING",
  "SHREE MARUTI KELAVANI MANDAL MANAGED  B.ED., JASAPAR (JASDAN)",
  "NAVGUJARAT SANITARY INSPECTOR COLLEGE",
  "SHRI PARAGBHAI T  PATEL SCIENCE COLLEGE DEESA BANASKANTHA",
  "SHREE SWAMINARAYAN GURUKUL COLLEGE OF COMMERCE",
  "SHREE TAPASVI DIPLOMA IN HEALTH AND SENETARY INSPECTOR COLLEGE DEODAR",
  "V G SOLANKI ARTS COLLEGE DOLASA",
  "EKLAVYA COLLEGE OF SOCIAL WORKS",
  "EKLAVYA ARTS COLLEGE",
  "NAVYUG DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "VADODARA INSTITUTE OF S I",
  "SHREE M D PATEL DIPLOMA  IN HELATH AND SENETARY INCPECTOR COLLEGE TAKHATPUR",
  "SHREE M D PATEL M S W COLLEGE TAKHATPUR",
  "SIDDHIVINAYAK DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE",
  "SHRI TEJABHAI MEMABHAI AHIR AND SHRI SURABHAI DEVABHAI AHIR MAHILA COLLEGE",
  "ARRDEKTA INSTITUTE OF TECHNOLOGY",
  "VIDHYADEEP  INSTITUTE OF COMPUTER AND INFORMATION TECHNOLOGY",
  "VIDHYADEEP  INSTITUTE OF BUSINESS ADMINISTRATION",
  "ROFEL SHRI G.M. BILAKHIA COLLEGE OF PHARMACY, VAPI",
  "GIDC Rajju Shroff ROFEL Institute of Management Studies-Vapi",
  "RIDDHI DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "UNITEDWORLD SCHOOL OF LIBERAL ARTS  AND MASS COMMUNICATION",
  "ASHA M TARSADIA INSTITUTE OF COMPUTER SCIENCE AND TECHNOLOGY",
  "JG DIPLOMA IN SI COLLEGE",
  "SHREE KALUBHAI SAMATBHAI PATEL CHERITABEL TRUST PATAN SANCHALIT NACHIKETA DIPLOMA IN HEALTH AND SENITARY INSPECTOR COLLEGE THARA",
  "SHRIJI EDUCATION COLLEGE,B ED",
  "LIMBDI NURSING COLLEGE",
  "SHRI RAJ BSW COLLEGE GADH",
  "Pioneer Homoeopathic Medical College & Hospital",
  "Vanraj Arts & Commrece College, Dharampur",
  "SMT. C.D.JHOBALIA  ROFEL ARTS AND SMT. I.S.R.ACHCHHARIWALA ROFEL COMMERCE COLLEGE, VAPI",
  "SWAMINARAYAN INSTITUTE OF DESIGN MVOC",
  "SWAMINARAYAN INSTITUTE OF DESIGN BVOC",
  "SHRI MOHANSINH CHHOTUBHAI RATHVA SCIENCE COLLEGE",
  "Shantabaa Medical College",
  "SHRI MARUTI VIDHYAMANDIR COLLEGE OF COMMERCE AND ARTS",
  "SHRI SAHAJANAND MSW COLLEGE",
  "MAHARSHI DAYANAND LAW COLLEGE BASPA",
  "PRAYAG MSC CA AND IT COLLEGE, PANOL",
  "PRAYAG MSW COLLEGE, PANOL",
  "PRAYAG BCA COLLEGE, PANOL",
  "NACHIKETA ARTS COLLEGE THARA",
  "ADARSH SCIENCE MSC COLLEGE DHANERA",
  "SHRI DHANABHAI L BHARVAD MSW COLLEGE ",
  "OCHCHHAVLAL MAYACHANDDAS SCIENCE COLLEGE",
  "SHREE OGAD LAW COLLEGE,VAKHA DEODAR",
  "MESHW INSTITUTE OF M S W,",
  "VADODARA INSTITUTE OF RURAL STUDIES",
  "BALAJI COLLEGE OF LAW",
  "J J MED COLLEGE",
  "GYANDEEP MSW COLLEGE",
  "RADHE MSC COLLEGE,HIRPURA",
  "SHRI MAHARSHI DAYANAND SARASWATI BCA COLLEGE",
  "THE EXCELLENCE COLLEGE OF ARTS MAMANA",
  "MAHARSHI DAYANAND BRS COLLEGE BASPA",
  "MAHARSHI DAYANAND BCA COLLEGE BASPA",
  "KRISHNA SCHOOL OF TECHNOLOGY",
  "VALIBA BCA COLLEGE TAKHATPUR",
  "KIRAN MEDICAL COLLEGE",
  "MAHAJAN ANATH BALASHRAM COMMERCE COLLEGE",
  "NOBLE COMMERCE COLLEGE",
  "UGKM VIDHYASAGAR EDUCATION COLLEGE DANODARADA",
  "SHREE M V DESAI BED COLLEGE",
  "INDUBHAI PAREKH SCHOOL  OF ARCHITECTURE",
  "EXPERIMENTAL SCIENCE COLLEGE,PRANTIJ ",
  "S S ARTS COLLEGE PANTHAWADA",
  "BABADEV DIPLOMA IN SANITARY INSPECTOR COLLEGE, CHHOTAUDEPUR",
  "B V PATEL INSTITUTE OF COMMERCE",
  "Dr. Jaya and Dr. Harivadan Shah Institute of Applied Science",
  "SHREE GOPINATHJI COLLEGE OF NURSING",
  "GOVERNMENT LAW COLLEGE, VISNAGAR",
  "DR JASUBHAI AND DR TARABEN AND DR DINESHBHAI GNM NURSING SCHOOL AND BSC NURSING COLLEGE,  KHERALU",
  "GADHWADA COLLEGE OF NURSING",
  "AKSHATAM COLLEGE OF NURSING",
  "ADARSH INSTITUTE OF NURSING BAYAD",
  "Saurashtra Paramedical Institute",
  "M L GANDHI SCIENCE COLLEGE MODASA",
  "VIDYABHARTI TRUST COLLEGE OF APPLIED SCIENCE AND NURSING",
  "TAXSHEELA SCHOOL OF NURSING",
  "SHRI BHARATSINH GEMALSINH MAKWANA COLLEGE OF NURSING",
  "SUNRISE COLLEGE OF NURSING",
  "SHREEHARI VISHWASBHAI JANI SCHOOL COLLEGE OF NURSING AMRELI ",
  "SHREE SARDAR PATEL MAHILA HOMOEOPATHIC MEDICAL COLLEGE",
  "GVM SCIENCE COLLEGE",
  "SHREE SARASVATI COLLEGE OF NURSING",
  "SHREE KRISHNASHRAM VAIDIK PATHASHALA ",
  "SARDAR VALLABHBHAI PATEL INSTITUTE OF NURSING, SVIN",
  "NOOTAN HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "J AND D INSTITUTE OF NURSING",
  "SARDAR PATEL NURSING COLLEGE AKHAJ",
  "ROBERT INSTITUTE OF NURSING",
  "VALAN HOMOEOPATHIC MEDICAL COLLEGE",
  "Government BBA College",
  "Anjuman Education Trust M.Ed. College (Gujarati Medium)",
  "Degree College of Physical Education",
  "SHIVAM INSTITUTE OF NURSING",
  "NAVKAR INSTITUTE OF BSC NURSING",
  "NAVYUG NURSING COLLEGE",
  "SHREE ADARSH NURSING COLLEGE AMRAPUR",
  "Gopalak Vikas Mandal M.Ed. College",
  "Smt. N. H. L. Municipal Medical College",
  "Vivekanand College of Law",
  "AKHIL ANJANA KELVANI MANDAL SANCHALIT KISANBHARATI MSC COLLEGE  MEVAD TA DISTRICT MEHSANA",
  "GMERS MEDICAL COLLEGE PANCHMAHAL GODHRA",
  "ADARSH ARTS AND COMMERCE COLLEGE BHABHAR",
  "College of Nursing",
  "VIDHYADEEP INSTITUTE OF SOCIAL WORKS",
  "KD INSTITUTE OF PHYSIOTHERAPY",
  "NEOTECH INSTITUTE OF PHARMACY",
  "S S AGRAWAL INSTITUTE OF PHARMACY NAVSARI",
  "S S AGRAWAL INSTITUTE OF AYURVEDA NAVSARI",
  "GLS Institute of Design",
  "GLS School of Doctoral Research and Innovation",
  "Gujarat Adani Institute of  Medical Science",
  "Dhanvantari Ayurved College, Koyadam",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE, PALITANA",
  "SWARRNIM INSTITUTE OF DESIGN AND PLANNING",
  "Shree Muktanand Samskrit Mahavidyalaya, Magod (Valsad)",
  "Shree Aniruddhacharya Sanskrit Mahavidyalaya, Chandod",
  "SANTSHRI SANDHYAGIRIBAPU SANSKRIT VED VIDYALAYA, SAMKHIYALI",
  "NAVJAGRUTI SANSKRIT MAHAVIDYALAYA, VYARA",
  "DR. BHARAT BARAD PGDCA STUDY CENTER, SUTRAPADA",
  "Faculty of Technology and Engineering",
  "SMT. V.B. NANDOLA COMPUTER SCIENCE COLLEGE, BHACHA",
  "LAKULISH YOGA UNIVERSITY CONSTITUENT CENTRE, KAYAVAROHAN, BARODA",
  "College of Agriculture Vaso",
  "Neotech College of Applied Science and Research",
  "Shree H.K. Parekh College of Management",
  "Shree G. L. Kakadia College of Commerce and Management",
  "SMT. MITAL Y. PATEL COLLEGE OF NURSING",
  "Chaudhari Institute of Nursing",
  "K.J.INSTITUTE OF AYURVEDA AND RESEARCH",
  "THE NEW PROGRESSIVE COLL OF EDUCATION (MED)",
  "MANSINHBHAI INSTITUTE OF DAIRY AND FOOD TECHNOLOGY",
  "Lukhdhirji Engineering College, Morbi-031",
  "SHREE V G SOLANKI COMMERCE COLLEGE DOLASA",
  "Balasinor College of Polytechnic, Dist. Kheda  678",
  "shree M M Shah physiotherapy College",
  "SHRI VANRAJSINH DAMOR D S I COLLEGE, SANTRAMPUR",
  "C K PATEL COLLEGE OF MANAGEMENT & COMP STUDY",
  "MAHARSHI DAYANAND PGDCA STUDY CENTER, BASPA",
  "shree krishna institute of nursing,bhabher",
  "N.R.VEKARIYA MASTER OF LAW COLLEGE ",
  "SHREE HANSARAJBHAI SAVAJIBHAI RADADIYA NURSING COLLEGE",
  "ARTS COLLEGE BHILADI",
  "SHRI MAHARSHI DAYANAND SARASWATI BED COLLEGE",
  "SPECIAL EDUCATION COLLEGE",
  "Shree Swaminarayan RP Badiyani And SR Bandiyani Institute Of Nursing",
  "LAKULISH YOGA UNIVERSITY CONSTITUENT CENTRE, JAKHAN, SURENDRANAGAR",
  "SAL COLLEGE OF ENGINEERING (113)",
  "Shree Swaminarayan Nursing College (B.Sc.)",
  "SILVER OAK COLLEGE OF NURSING",
  "PARUL INSTITUTE OF AYURVED AND RESEARCH",
  "LAKULISH YOGA UNIVERSITY CONSTITUENT CENTRE, BARODA",
  "SILVER OAK COLLEGE OF PHYSIOTHERAPY",
  "GLOBAL INSTITUTE OF AYURVEDA",
  "Parul Institute of Diploma Studies 638 ",
  "Laxminarayan Dev Sanskrit Mahavidyalaya, Vadtal",
  "IKDRC College of Nursing",
  "SHREE JAMBU BRAHMAN KANVA SANSKRIT MAHAVIDYALAYA, CHANDOD",
  "LAKULISH YOGA UNIVERSITY CONSTITUENT CENTRE, MALAV, PANCHMAHAL",
  "Gujarat Institute of Mental health",
  "SHRI UN VIBHAG KELAVANI MANDAL ARTS AND COMMERCE COLLEGE,UN.",
  "BHARGAVA AYURVEDA COLLEGE",
  " Netra chikitsa ayurveda college",
  "LAKULISH YOGA UNIVERSITY CONSTITUENT CENTRE, SURAT",
  "NANDKUNVARBA MAHILA DIPLOMA IN FASHION DESIGNING COLLEGE",
  "Kamdar Homeopathic Medical College And Research Center, Rajkot",
  "Cadila Pharmaceuticals Clinical Research",
  "Sadbhav Institute of Nursing Rupal",
  "J K COLLEGE OF NURSING",
  "M.B. Gohil Institute of Medical Science and Research center.",
  "LT.KANKUBEN RATANSHI GOKANI AND LT.RATANSHI SUNDARJI GOKANI MAHILA COMMERCE COLLEGE ",
  "K. J. INSTITUTE OF NURSING (B.Sc Nursing)",
  "Shree H.R.Mehta M.Ed Mahila College",
  "Manjushree Institute of Nursing Science",
  "B. N. Patel College of Physiotherapy",
  "K J INSTITUTE OF PHYSIOTHERAPY",
  "Department of Law",
  "Rudra College of Business Administration (BBA)",
  "Maniba College of Eduction",
  "Amrut Mody School of Management",
  "Hasmukh Goswami College of Engineering(SFI)-Vehlal Dahegam",
  "SHREE VEER DEDAJI SCIENCE COLLEGE,KODINAR",
  "PIYUNI GOSWAMI COLLEGE OF COMMERCE",
  "SHRI B.M.SHAH COLLEGE OF PHARMACEUTICAL EDUCATION AND RESEARCH, MODASA 252",
  "School of Computer Studies",
  "School of Engineering and Applied Science",
  "VENUS INSTITUTE OF PHYSIOTHERAPY",
  "CP Patel & FH Shah Commerce College, Anand",
  "NOBLE STAR ENGINEERING COLLEGE - 109",
  "UNITED WORLD SCHOOL OF LAW",
  "SHREE VIVEK BHARTI B.ED. COLLEGE",
  "NOBLE SCIENCE COLLEGE",
  "NOBLE INSTITUTE OF BUSINESS MANAGEMENT",
  "NOBLE HOMOEOPATHIC COLLEGE AND RESEARCH INSTITUTE",
  "NOBLE PHARMACY COLLEGE",
  "K.D. BARAD ARTS & COMPUTER SCIENCE COLLEGE, AHEMDPUR, MANDVI-DIU",
  "NOBLE ENGINEERING COLLEGE (MBA Programme)",
  "NOBLE DIPLOMA ENGINEERING COLLEGE",
  "NOBLE AYURVED COLLEGE AND RESEARCH INSTITUTE",
  "SHRI SWAMINARAYAN COLLEGE OF PHARMACY, KALOL",
  "SHREE SWAMINARAYAN LAW COLLEGE",
  "SILVER OAK INSTITUTE OF DESIGN",
  "SEVASHRAM NURSING COLLEGE",
  "Brahmarshi Sanskrit Mahavidyalaya, Nadiad",
  "Dakor Sanskrit Pathshala, Dakor",
  "Shree Rajkiya Sanskrit Pathshala, Petlad",
  "SHREE KRISHNA SCIENCE COLLEGE  , BHABHAR",
  "Haidiyakhandi Sanskrit Mahavidyalaya, Kayavarohan",
  "SMT. K. B. JOSHI SANSKRIT MAHAVIDYALAYA, BHARWADA",
  "CHITRINI BED COLLEGE",
  "SHRI PRABODHKANT PANDYA SANITARY INSPECTOR COLLEGE",
  "SHRI PRABODHKANT PANDYA FIRE AND SAFETY COLLEGE",
  "VADODARA INSTITUTE OF COMPUTER APPLICATION",
  "H. L. College of Commerce",
  "Shree Shankaracharya Abhinav Sacchidanand Teerth Sanskrit Mahavidyalaya, Dwarka",
  "ASPEE College of Agriculture, Khapat (Porbandar)",
  "Shree Sitaram Gupta Sanskrit Mahavidyalaya, Adalaj",
  "Swami Hirapuri Sanskrit Mahavidyalaya, Asarva",
  "Shree Swaminarayan Sanskrit Mahavidyalaya, Dabhan",
  "SHREE J.B. DHARUKAWALA MAHILA ARTS COLLEGE B.COM (ENGLISH MEDIUM) ADDITIONAL DIVISION SELF FINANCE (FOR WOMENS)",
  "Government Arts College,shahera",
  "Department of Paramedical and Health Sciences",
  "FACULTY OF COMPUTER SCIENCE AND APPLICATIONS",
  "APOLLO COLLEGE OF NURSING  ENASAN",
  "L J INSTITUTE OF MEDIA AND COMMUNICATIONS",
  "B. V. Patel Pharmaceutical Education & Research Development (PERD) Centre",
  "Directorate of Forensic Science (DFS)",
  "Government Medical College",
  "Vibrant Nursing College",
  "Institute of Plasma Research (IPR)",
  "K. R. Desai Arts & Commerce College",
  "Law College",
  "Limkehda Arts College",
  "M. M. Gandhi Arts & Commerce College",
  "ARTS & COMMERCE COLLEGE, BARAVALA",
  "ARTS, COMMERCE COMPUTER SCIENCE COLLEGE-MANAVADAR",
  "Navjivan Arts and Commerce College",
  "Navjivan Science College",
  "Pioneer  Physiotherapy College",
  "Nalanda B. Ed. College",
  "Sanskar Bharti B. Ed. College",
  "Sarvodaya College of Education",
  "S. C. A. Patel Arts College",
  "Sheth P. T. Arts & Science College",
  "Shree B. K. Patel Arts and Smt. L. M. Patel Commerce College",
  "Intas Biopharmaceuticals Ltd., Biotechnology Division (R & D)",
  "THE FUTURE COMPUTER SCIENCE COLLEGE - KESHOD",
  "Sardar Patel B. Ed. College",
  "Shri Janki Vallabh Arts And Shri M. S. Patel Commerce College",
  "Shri Sarvajanik Commerce College",
  "Shri S. P. Patel Arts College",
  "Sigma Institute of Physiotherapy",
  "SKUB Arts & Smt N. C. Zaveri Commerce College",
  "Smt. H. C. Patel (Kandari) Arts and Commerce College",
  "Smt. K. C. M. Shah B. Ed. College",
  "Smt. M. K. Sanghvi Homeopathic Medical College",
  "Y. S. Arts & K. S. S. Commerce College",
  "Virpur Mahila Utkarsh B. Ed. College for Girls",
  "Smt. C. R. Gardi Arts College",
  "Shri Tejendraprasadji Swaminarayan Arts College",
  "Physical Research Laboratory (PRL)",
  "Shri P. N. Pandya Arts, Shri M. P. Pandya Science & D. P. Pandya Commerce College",
  "Space Application Centre (ISRO)",
  "Shri N. K. Mehta & Smt. M. F. Dani Arts College",
  "B. PHARMACY COLLEGE, RAMPURA 220",
  "FACULTY OF PHYSIOTHERAPY",
  "FACULTY OF PHARMACY",
  "FACULTY OF COMPUTER APPLICATION",
  "FACULTY OF MANAGEMENT STUDIES",
  "MARWADI EDUCATION FOUNDATION DIPLOMA STUDIES",
  "VEERAYATAN INSTITUTE OF PHARMACY, JAKHANIA 267",
  "SARDAR PATEL COLLEGE OF ENGINEERING",
  "RADHE INSTITUTE OF ENGINEERING AND TECHNOLOGY, UPLETA-970",
  "Institute of Pharmacy, Nirma University",
  "Parul Institute of Engineering & Technology-MCA Programme (SFI)-Vadodara",
  "Shree H.N.Shukla College of Management Studies,Rajkot (SFI) 759",
  "Mahadev Desai Samaj Seva Mahavidyalaya, Ahmedabad",
  "DR NATUBHAI POLYTECHNIC, MAHESANA",
  "SHREE D.K. KAPURIA ARTS COLLEGE AND S.B. GARDI COMMERCE COLLEGE, KALAVAD",
  "Hindi Shiksha Mahavidyalaya, Ahmedabad",
  "SHRI TEJENDRA PRASADJI B.ED. COLLEGE-CHARAVADA",
  "Mahadev Desai College of Physical Education, Sadra",
  "Biogas Research Unit & Microbiology, Sadra",
  "Sigma Institute of Engineering (SFI) -Barrrol-Ta:Waghodiya Di:Vadodara.",
  "Polytechnic in Agro-Processing- Junagadh",
  "PG Institute of Agricultural-Business Management- Junagadh",
  "Polytechnic in Agriculture- Dhari",
  "College of Agriculture - Junagadh",
  "College of Agricultural Engineering and Technology- Junagadh",
  "L J Institutes of Engineering and Technology",
  "Navajagruti Arts and Commerce College for Women",
  "Nandkunvarba Mahila B.C.A. College",
  "Nandkunvarba Mahila Commerce College",
  "SHRI SARDAR PATEL MAHILA B.ED.COLLEGE-JUNAGADH",
  "YADAV B.ED. COLLEGE-MANGALPUR",
  "FACULTY OF DIPLOMA ENGINEERING (NEOTECH)",
  "U.N.MEHTA ARTS COLLEGE-MORBI",
  "M.J.GORIYA ARTS & COMMERCE COLLEGE-JAMKHAMBHALIYA",
  "PARANGAT B.ED. COLLEGE, HALVAD",
  "S. V. Vanijya Mahavidyalaya",
  "K P TRIVEDI PGDMLT COLLEGE KHORDA",
  "SHREE AMARDEEP DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "ADARSH DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE PATAN",
  "KRISHNA SCHOOL OF BUSINESS MANAGEMENT",
  "J K PARAMEDICAL INSTITUTE",
  "SHREE HARI DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE",
  "SHREEJI  BAPA DIPLOMA IN HEALTH AND SANITARY INSPECTOR MEGHRAJ",
  "GOVERNMENT POLYTECHNIC HALOL",
  "SHRI HARI DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "SHRI K V TARAK DIPLOMA IN HEALTH SANITARY INSPECTOR COLLEGE DUCHAKWADA",
  "SMT SAVITABEN BHAVANBHAI SONI ARTS COLLEGE DUCHAKWADA",
  "MADINATUL ILM ARTS AND COMMERCE COLLEGE  KISHORGADH SQUARE",
  "N. C. Bodiwala & Prin. M. C. Desai Commerce College",
  "The Patidar Gin Science College, Bardoli",
  "EXPERIMENTAL COLLEGE OF DIPLOMA IN FIRE AND SAFETY",
  "J. G. College of Commerce",
  "Shri Bavisgam B.Ed.College",
  "EXPERIMENTAL ARTS AND COMMERCE COLLEGE",
  "EXPERIMENTAL COLLEGE OF DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "AMBICA DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "SHREE SURYODAY DIPLOMA IN HEALTH AND SANITARY INSPACTOR COLLEGE ",
  "THE MANDVI EDUCATION SOCIETY COMMERCE COLLEGE",
  "GURUKUL COLLEGE OF DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "SHRI SARVAJANIK PGDMLT COLLEGE MEHSANA",
  "Natubhai Revabhai Patel B.Ed (Co Ed) College, Karamsad",
  "SHREE RAJESHWAR ARTS COLLEGE THARAD",
  "UMIYAJI MAHILA B.ED. COLLEGE DHROL",
  "ADWAIT ARTS COLLEGE JASARA",
  "B. Ed. College Singvad (Randhikpur)",
  "Government Arts College, Gandhinagar",
  "Institute for Plasma Research",
  "B. J. Medical College",
  "School of Nuclear Energy",
  "Manikaka Topawala Institute of Nursing",
  "SHRI SHAKUNTAL SECONDARY TEACHERS TRAINING COLLEGE",
  "SHREE SVT DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE",
  "Krishna Ayurved Medical College",
  "M. S. Bhagat and C. S. Sonawala Law College",
  "KRISHNA SCHOOL OF SCIENCE",
  "KRISHNA SCHOOL OF NURSING",
  "KRISHNA SCHOOL OF PHYSIOTHERAPY & REHABILITATION",
  "Krishna School of Pharmacy & Research",
  "JAFRI ARTS AND COMMERCE COLLEGE, SEDRANA",
  "Veena Singhi College of Nursing",
  "School of Liberal Studies",
  "School of Petroleum Management",
  "School of Petroleum Technology",
  "School of Solar Energy",
  "School of Technology",
  "Shree Maruti Vidyamandir College of Business Management and Computer Science-B.C.A.",
  "Baroda Sanskrit Mahavidhyalay",
  "M K Amin Arts and Science & College of Commerce",
  "Polytechnic College",
  "DIVYACHETANA COLLEGE OF MSW",
  "MALIBA PHARMACY COLLEGE",
  "SHRI AMBAJI BCA COLLEGE",
  "GOVERNMENT ARTS COLLEGE SUBIR DANG",
  "Shri Mahavir Vidhyamandir Trust B. Ed. College",
  "GOVERNMENT ARTS COLLEGE, BHESAN",
  "K.B.RAVAL COLLEGE OF PHARMACY, KASTURINAGAR 224 ",
  "PIONEER PHARMACY COLLEGE, SAYAJIPURA 235",
  "SHARDA SCHOOL OF PHARMACY, PETHAPUR 247 ",
  "SHRI DHANVANTARY PHARMACY COLLEGE, KIM 254 ",
  "SMT R. D. GARDI B. PHARMACY COLLEGE, NYARA RAJKOT 263",
  "SAL INSTITUTE OF PHARMACY, AHMEDABAD 277",
  "SHIVAM PHARMACEUTICAL STUDIES & RESEARCH CENTER 282",
  "D.L.Patel Institute of Management & Technology, MCA college.(SFI)-Himmatnagar 507 ",
  "Shree Swaminarayan Institute of Technology(SFI)-Gandhinagar 533",
  "Shri Jaysukhlal Vadhar Institute of Management Studies  Shri Bipin T. Vadhar College of Management (JVIMS-MCA College)(SFI)-Jamnagar 537 ",
  "Dr.S.& S.S.Gandhi college of Engg. And Technology,Surat 612 ",
  "Government Polytechnic,Dahod 630 ",
  "R.C.Technical Institute,Ahmedabad 640",
  "Om Insti. Of Eng.& Technology, Junagadh 665",
  "K.K.Parekh Institute of Management Studies (SFI)-Amreli 722 ",
  "Shri Jairambhai Patel Institute of Business Management & Computer Applications (SJPI)(SFI),GANDHINAGAR. 769 ",
  "L.J.INSTITUTE OF PHARMACY, SANAND",
  "SHANKARSINH VAGHELA BAPU INSTITUTE OF PHARMACY, UNAVA, GANDHINAGAR 278",
  "SMT. S. M. SHAH PHAMACY COLLEGE, KHEDA 286 ",
  "L.J.Institue of Management Studies(SFI)-Ahmedabad",
  "R.B.Institute of Management Studies (SFI)-Ahmedabad 549",
  "Dr.J.N.Maheta Government Polytechnic,Amreli 611",
  "Excel Institute of Diploma Studies,Kalol 613 ",
  "Government Polytechnic,Porbandar 627",
  "Government Polytechnic,Valsad 629 ",
  "N.G.Patel Polytechnic,Isroli 637",
  "Shri K.J.Polytechnic,Bharuch 645",
  "Sigma Institute of Technology & Engg.( Polytechnic) 648 ",
  "Sir Bhavsinhji Polytechnic Institute, Bhavnagar 649 ",
  "Swami Sacchidanand Polytechnic college,Visnagar 650 ",
  "V.P.M.P. Polytechnic, Gandhinagar 654",
  "F. D.(Mubin) Institute of Engineering & Technology, Dehgam, Bahiyal, Gandhinagar 675 ",
  "MURLIDHAR COLLEGE OF NURSING",
  "Shree Samanvay Institute of Business Administration (SFI)-Botad -Bhavnagar. 762",
  "Smt. Vanitaben Bachubhai Nandola MCA College,Bhacha, Tal.Una, Di:Junagadh (SFI) 551",
  "Shri Chimanbhai Patel Institute of Management and Research (SFI)-Ahmedabad 768",
  "Government Polytechnic,Vadnagar 628",
  "Shri MH Kadakia Institute of Management & Computer Studies (SFI)-Ankleshwar 771",
  "Merchant Institute of Diploma Studies, Mehsana ",
  "Shri Sunshine Education Trust Group of Institute (Faculty of MBA) (SFI)-Rajkot 773",
  "Sal Institute of Management (SFI) ,Opp. Science City, Bhadaj,Ahmedabad 807 ",
  "Shree Satsangi Saket Dham (721) K.J. Institute of Management (SFI)-Vadasma Di:Mehsana",
  "L.B.RAO COLLEGE OF PHARMACEUTICAL EDU. AND RES., KHAMBHAT 226",
  "L.M.COLLEGE OF PHARMACY, AHMEDABAD 228",
  "Parul Institute of Engineering & Technology-MBA Programme (SFI),Waghodia.",
  "SMT NILABEN MANUBHAI PADALIA PHARMACY COLLEGE, NAVAPURA 262",
  "LAXMINARAYAN DEV COLLEGE OF PHARMACY, BHOLAV, BHARUCH 274",
  "Laljibhai Chaturbhai Institute of Technology (SFI),Bhandu,Mehsana. 515",
  "C.U.Shah Polytechnic,Surendranagar 609 ",
  "Government Girls Polytechnic,Surat. 615 ",
  "Vallabhbudhi polytechnic, Navsari 655",
  "C.K.Shah Vijapurwala Institute of Management, Vadodra (SFI) 705",
  "D.L.Patel Institute of Management & Technology-MBA Programme (SFI)-Himmatnagar 709",
  "Kalol Institute of Management (SFI),Kalol. 725 ",
  "N.R.Vekaria Institute of Business Management Studies (SFI)-Junagadh 736",
  "Narmada College of Management (SFI),Bharuch 737",
  "Naran Lala School of Industrial Management & Computer Science- Navsari -(SFI) 799",
  "Sarvajanik B. Ed. College",
  "ASHVINBHAI A PATEL COMMERCE COLLEGE",
  "B P COLLEGE OF COMPUTER STUDIES",
  "IJ Patel B.Ed. College, Mogri",
  "Shree PM Patel Institute of Integrated M.Sc. in Biotechnology, Anand",
  "Shree PM Patel College of Law & Human Rights, Anand",
  "Shri Dr. VH Dave Homoeopathic College & Research Institute, Anand",
  "Anand College of Education, Anand",
  "NA & TV Patel Arts College, Vallabh Vidyanagar",
  "SM Patel College of Home Science, Vallabh Vidyanagar",
  "Sardar Patel College of Education, Bakrol",
  "MB Patel Science College, Anand",
  "Anand Arts College, Anand",
  "Shree PM Patel College of Computer Science & Technology, Anand",
  "Shri Babubhai G Patel College of Physiotherapy, Anand",
  "Shri Vitthalbhai Z Patel Commerce College, Anand",
  "Anand Homoeopathic Medical College & Research Institute, Anand",
  "Shree PM Patel Institute of Biosciences, Anand",
  "Shree PM Patel Institute of Business Administration, Anand",
  "Anand Institute of Social Work, Anand",
  "SHRI A R BHATT COMPUTER & SCIENCE COLLEGE, UNA",
  "Akhilesh Sureshbhai Patel Arts College, Boriavi",
  "MAHRSHI SHRI AUROBINDO M.S.W. COLLEGE, RAJKOT",
  "SHRI SANSKARDHAM B.ED. COLLEGE, RAJKOT",
  "H. & H.B. KOTAK  INSTITUTE OF SCIENCE RAJKOT",
  "BHUVA ARTS & COMMERCE COLLEGE-RAJULA(TA.AMRELI)",
  "V.D.GARDI LAW COLLEGE-WADHWAN",
  "Shri Mirambika college of Education",
  "SHREE K.O. SHAH MUNI. ARTS & COMMERCE COLLEGE, DHORAJI",
  "KABARIYA ARTS, VAGHASIYA COMMERCE & BHAGAT SCIENCE MAHILA COLLEGE-AMRELI",
  "R.P.BHALODIYA MAHILA ARTS, COMM.  & HOMESCI. COLLEGE-UPLETA",
  "HARIBAPA CHARITABLE TRUST ARTS & COMMERCE COLLEGE-JASDAN",
  "VIVEKANANDA COLLEGE OF COMPUTER SCIENCE & MANAGEMENT-RAJKOT",
  "VIDYA SAGAR INFOTECH COLLEGE, JAMNAGAR",
  "S.D.KOTAK LAW COLLEGE-AMRELI",
  "M.P. SHAH MEDICAL COLLEGE, JAMNAGAR",
  "SMT. MINAXIBEN SHANTIBHAI DAVE COLLEGE OF EDUCATION, JAMNAGAR",
  "M.P.SHAH MUNI. COMMERCE COLLEGE, JAMNAGAR",
  "K.K.SHETH PHYSIOTHERAPY COLLEGE-RAJKOT",
  "GARDI ARTS & COMMERCE COLLERE-MALIAHATINA",
  "PATEL KELVANI MANDAL INSTITUTE OF TECH.& B.ED.-JUNAGADH",
  "SHRI BRAHAMANAND INSTITUTE OF EDUCATION, CHAPARDA",
  "SADHU VASWANI COLLEGE FOR PERAMEDICAL COURSES-RAJKOT",
  "SHRI V.M.MEHTA MUNICIPAL ARTS AND COMMERCE COLLEGE, JAMNAGAR",
  "JUNAGADH KELAVANI MANDAL B.C.A. COLLEGE-JUNAGADH",
  "MATRUSHRI D.B. & K.G. COMMERCE & B.B.A. B.C.A. COLLEGE, AMRAPUR",
  "PEOPLE WELFARE SOC. MANAGED M.V.B. MANVAR B.ED. COLLEGE-DUMIYANI",
  "A.V.D.SAVJANI ARTS & COMMERCE COLLEGE-JAMJODHAPUR",
  "SMT. S.J.VARMORA B.B.A./B.C.A. MAHILA COLLEGE, WADHWANCITY",
  "SHRI SARASWATI COLLEGE OF COMMERCE, B.B.A. & I.T., DHORAJI",
  "GRACE COLLEGE OF COMMERCE-RAJKOT",
  "SHRI DHARMJIVANDASJI B.ED.COLLEGE-TARVADA",
  "C.U.SHAH COLLEGE OF COMMERCE MANAGEMENT & COMPUTER EDUCATION -WADHWAN",
  "SHRI SHIPRA COLLEGE OF COMPUTER SCIENCE & TECH.-RAJKOT",
  "MAHILA ARTS COLLEGE , DHORAJI",
  "SMT. SHANTABEN R.HERMA B.ED. COLLEGE-STAPAR",
  "Smt. Sadguna C.U.Shah Home Science and C.U.Shah Arts & Commerce Mahila College",
  "K.K.PAREKH COMM.. COLLEGE -AMRELI",
  "J.J.KUNDALIYA COMMERCE COLLEGE-RAJKOT",
  "M.P.SHAH ARTS & SCIENCE COLLEGE, SURENDRANAGAR",
  "M.V.MAHILA SCIENCE & HOMESCI.COLLEGE-RAJKOT",
  "P.D.M. COMMERCE COLLEGE-RAJKOT",
  "SHRI D.M. PATEL COLLEGE OF PHYSIOTHERAPY, AMRELI",
  "DIGVIJAY A.& C. COLLEGE-DIGVIJAYGRAM (JAMNAGAR)",
  "SMT.S.S.AJMERA LAW COLLEGE, GONDAL",
  "SANSKRUTI COLLEGE OF MANAGEMENT I.T. COMMERCE & ARTS-SURENDRANAGAR",
  "M. G. Science Institute",
  "Shri Sahajanand Vanijya Mahavidyalaya",
  "C. U. Shah Science College",
  "H. A. College of Commerce",
  "Patel J. B. R. Arts, Patel A. M. R. Commerce & Patel J. D. K. Davolwala Science College",
  "Aroma College of Commerce",
  "Som-Lalit College of Commerce",
  "Akar Adhyapan Mandir",
  "R. G. Shah Science College",
  "Shree Narayan College of Commerce",
  "Sheth L. H. Science College",
  "KU. A.B. GARDI SHRI GRAMVIDHYA MAHAVIDHYALAYA B.S.M.S. COLLEGE OF RURAL STUDIES, SHARDAGRAM .",
  "Smt. S. C. P. F. Commerce College",
  "Shri H. K. Commerce College",
  "Shah C. K. Municipal Commerce College",
  "Sheth R.A. College of Science",
  "R. J. Tibrewal Commerce College",
  "SHREE G. K. & C. K. BOSAMIA ARTS & COMMERCE COLLEGE - JETPUR",
  "MAHILA ARTS  COLLEGE-UNA",
  "KODINAR ARTS & COMM. COLLEGE, KODINAR",
  "SHREE J.S.PARMAR ARTS & COMMERCE COLLEGE-KODINAR",
  "R. C. College of Commerce, Ahmadabad",
  "City C. U. Shah Commerce College",
  "National College of Commerce",
  "Vivekanand Vanijya Mahavidyalaya",
  "G. B. Shah Commerce College",
  "P. D. Pandya Mahila Commerce College",
  "C. U. Shah Commerce College",
  "K. K. Shah Jarodwala Maninagar Science College",
  "Sheth C. L. Commerce College",
  "Mahila Vanijya Mahavidyalaya",
  "Vivekanand College of Commerce",
  "Neeldeep College of Commerce",
  "C. C. Sheth College of Commerce",
  "Aradhna College of Education",
  "Arts, Science & R. A. Patel Commerce College",
  "K. M. Patel College of Education",
  "Sarvoday College of Education",
  "The Sandipani Shikshan Mahavidyalay",
  "H. B. Kapadia College of Education",
  "Shri Vitthalbhai I. Patel College of Eduction",
  "Vision College of Education",
  "I. D. Patel College of Education",
  "J. & J. College of Science",
  "Smt. S. I. Patel Ipcowala College of Commerce",
  "Smt. T. J. Patel English Medium Commerce College",
  "The Mahemdabad Education Society B. Ed. College",
  "Government Commerce College, Gandhinagar",
  "Government Science College, Gandhinagar",
  "National Institute of Occupational Health",
  "B. M. Institute of Mental Health",
  "L. D. Arts College",
  "C. U. Shah Arts College",
  "Smt. Sushilaben Ramniklal Mehta Arts College",
  "Government Ayurved College, Junagadh",
  "Shri O. H. Nazar Ayurved College, Surat",
  "Government Akhandanand Ayurved College",
  "Sheth J. P. Ayurved College, Bhavnagar",
  "Moraraji Desai Institute of Naturopathy and Yogic Sciences",
  "Chaudhari College of Education",
  "President College of Education",
  "J. G. College of Education",
  "Saraswati B. Ed. College",
  "Smt. S. N. Patel B. Ed. College",
  "Sharda Adhyapan Mandir B.Ed. College",
  "Shri M. D. Patel College of Education",
  "Shri K. G. Patel College of Education",
  "Government Ayurved College, Vadodara",
  "N.M.College of Agriculture",
  "ASPEE Institue of Agribussiness Management",
  "ASPEE College of Horticulture",
  "B. Ed. College",
  "B. J. Katara B. Ed. College",
  "Gopalak Vikas Mandal Mahila B. Ed. College (Co-Education)",
  "Smt. B. C. J. College of Education (M. Ed.)",
  "LOKNIKETAN MRS COLLEGE RATANPUR",
  "MED COLLEGE VADU",
  "SHRI B L PARIKH COLLEGE OF BBA",
  "ASH EDU TRUST BED COLLEGE VIJAPUR",
  "Sahajanand College of Nursing",
  "Brahmachari Wadi Trust : Institute of Business Administration",
  "Sir L. A. Shah Law College",
  "Shri Ram Charitable Trust B. Ed. College",
  "SHREE ADARSH PGDMLT COLLEGE RADHANPUR",
  "PRERNA INSTITUTE OF NURSING",
  "SHET H.P ARTS & T S M COMMERCE COLLEGE",
  "COLLEGE OF EDUCATION VIDHYANAGARI",
  "SHRI B H DAVE COLLEGE OF EDUCATION  SAMI",
  "GOVERNMENT ARTS COLLEGE BHECHARAJI",
  "VADU COLLEGE OF COMPUTER & MANAGEMENT STUDIES",
  "SHRI M H PATEL MAHAVIDHYALAYA SAMODA GANWADA",
  "SHRI B P B ARTS & M H GURU COMMERCE COLLEGE",
  "GROW MORE INSTI OF BUSINESS ADMINISTRATION",
  "SHREE R K PATEL BCA COLLEGE NANIKADI",
  "MUNCIPAL ARTS & URBAN BANK SCIENCE COLLEGE",
  "LOKNIKETAN SHIKSHAN MAHAVIDHYALAYA RATANPUR",
  "SHRI V S RAVAL EDUCATION COLLEGE PRANTIJ",
  "SMT C C MAHILA ARTS & SHETH C N COMME COLLEGE",
  "EDUCATION COLLEGE LADOL",
  "ARVALLI BED COLLEGE VIJAYNAGAR",
  "COLLEGE OF EDUCATION SHAMLAJI",
  "H N S B COLLEGE OF MANAGEMENT STUDIES BBA",
  "Lokbharati Lokseva Mahavidyalaya",
  "Shri Kelavni Mandal Dhasa B.Ed. College",
  "Shree V.M. Sakaria Mahila Arts College",
  "THE NEW PROGRESSIVE COLLEGE TEACHERS EDUCATION",
  "JAFRI BCA COLLEGE SADRANA",
  "SHETH  M N LAW COLLEGE PATAN",
  "GROW MORE INSTI OF COMP APPLI (BCA)",
  "C N ARTS & B D COMMERCE COLLEGE",
  "S V CHAUDHARY COLLEGE OF EDUCATION",
  "GOVERNMENT SCIENCE COLLEGE IDAR",
  "GOVERMENT COMMERCE COLLEGE VADALI",
  "LAW COLLEGE HIMATNAGAR",
  "SMT P R PATEL ARTS COLLEGE PALASAR",
  "Ashok & Rita Patel Institute of Physiotherapy",
  "PRAMUKH SWAMI SCIENCE & H D PATEL ARTS COLLEGE KADI",
  "SMT T S R COMMERCE COLLEGE PATAN",
  "KADVA PATEL BED COLLEGE",
  "Smt. Jayaben Dhirajlal Thakkar (Pumpwala) B.Ed College - Radhanpur",
  "COLLEGE OF EDUCATION CHHAPI",
  "VJKMS BED COLLEGE VADU",
  "SHREE G H PATEL COLLEGE OF EDUCATION",
  "SHRI AMARDEEP EDU TRUST SANCHALIT BED COLLEGE",
  "RIDHDHI BCA COLLEGE MOTIPURA",
  "VRUNDAVAN BCA COLLEGE GANESHPURA",
  "RRM COLLEGE OF SCI & CLP COLLEGE OF COMMERCE",
  "SHRI SARASWATI SHIKSHAN MAHAVIDHYALAYA",
  "THE HNSB LTD SCIENCE COLLEGE MOTIPURA",
  "T M SHAH MAHILA ARTS COLLEGE IDAR",
  "GITANJALI COLLEGE OF EDUCATION TALOD",
  "KTUVKM SHRI N S DESAI COLLEGE OF EDUCATION",
  "KKM COLLEGE OF EDUCATION PILVAI",
  "SMT R M PRAJAPATI ARTS COLLEGE SATLASANA",
  "AMBABEN SHANKARLAL BECHARDAS PATEL COLLEGE OF BUSINESS ADMINISTRATION (BBA PROGRAMME), UNJHA",
  "SMT S M  PANCHAL SCIENCE COLLEGE TALOD",
  "THE KNSB LTD ARTS & COMMERCE COLLEGE KHERALU",
  "THE SNS BANK LTD MAHILA ARTS COLLEGE MEHTAPURA",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE JADAR",
  "SHREE V R PATEL COLLEGE OF COMMERCE MEHSANA",
  "SHRI BKKP S S GOVINDA EDUCATION COLLEGE",
  "SMT K B DAVE COLLEGE OF EDUCATION (BED)",
  "SHRI JMP ARTS & SMT M N PATEL MAHILA COMMERCE COLLEGE",
  "NILKANTH COLLEGE OF EDUCATION",
  "EXPERIMENTAL COLLEGE OF EDUCATION(MED)",
  "NGES MSW COLLEGE",
  "SHRII S M SHAH LAW COLLEGE",
  "RADHE BED COLLEGE HIRPURA",
  "BRDF SAMAJKARYA MAHAVIDHYALAYA SALAL",
  "BDKM SANCHALIT LAW COLLEGE PALANPUR",
  "ARTS & COMMERCE COLLEGE DHANSURA",
  "The Idar Nagrik Sahkari Bank ltd.(INSB) Institute of Information Technology and Management Studies (BCA)  & Arvalli College of Computer Higher Education (PGDCA) College, Idar",
  "KANTABA BED COLLEGE",
  "SHRI & SMT P K KOTAWALA ARTS COLLEGE,PATAN",
  "P & T PATEL COLLEGE OF EDUCATION",
  "VIJAYNAGAR ARTS COLLEGE",
  "ASHIRWAD INSTITUTE OF NURSING",
  "A. D. Patel Institute Of Technology, Karamsad",
  "SABARIMALA COLLEGE OF NURSING",
  "Government Nursing College, Jamnagar",
  "Smt. Champaben Bhagat Education Trust B.Sc. (Fire & Safety) College",
  "SHRI SARVAJANIK SCIENCE COLLEGE POST GRADUATE MEHSANA",
  "SHREE ARYATEJ INSTITUTE OF NURSING",
  "NALANDA  ARTS AND SCIENCE COLLEGE",
  "VALLABHI VIDYAPITH COMMERCE COLLEGE",
  "SHREE UMIYA NURSING COLLEGE",
  "SHREE KRISHNA INSTITUTE OF PGDMLT",
  "SHRI T S PATEL P G SCIENCE COLLEGE AMBALIYARA ",
  "SHRI T S PATEL ARTS AND COMMERCE COLLEGE AMBALIYARA",
  "SHRI T S PATEL BCA AND PGDCA COLLEGE AMBALIYARA",
  "SHREE ARJUN LAW COLLEGE",
  "NALANDA LAW COLLEGE",
  "ARRDEKTA INSTITUTE OF SPORT",
  "NEW L J INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "MAHARSHI DAYANAND M SC COLLEGE BASPA",
  "MAHARSHI DAYANAND M S W COLLEGE BASPA",
  "DR B R AMBEDKAR LAW COLLEGE",
  "SARDAR PATEL INSTITUTE OF NURSING",
  "TATHYA PHARMACY COLLEGE",
  "SHREE SWAMINARAYAN B SC COLLEGE",
  "P P SAVANI AYURVEDIC COLLEGE AND HOSPITAL",
  "Smt. LP Patel Institute of Medical Laboratory Technology, Karamsad",
  "CAM Institute of Allied Health Science and Technology",
  "Shri GH Patel College of Nursing, Karamsad",
  "Pramukhswami Medical College, Karamsad",
  "K M Patel Institute of Physiotherapy, Karamsad",
  "MAHAVIR SWAMI COLLEGE OF POLYTECHNIC",
  "Bhagwan Mahavir College of Management-Surat (MCA ) (SFI)",
  "BHAGWAN MAHAVIR COLLEGE OF ENGG. AND TECH., SURAT",
  "BHAGVAN MAHAVIR PHARMACY COLLEGE, SURAT",
  "MAHAVIR SWAMI COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "BHAGWAN MAHAVIR COLLEGE OF MANAGEMENT-MCA-(SFI)-SECOND SHIFT-NEW",
  "Bhagwan Mahavir College of Management (MBA)(SFI),Vesu,Surat.",
  "Bhagwan Mahavir College of Education",
  "Bhagwan Arihant Institute of Technology",
  "Bhagvan Mahavir Polytechnic, Surat",
  "BAGWAN MAHAVIR COLLEGE OF ARCHITECTURE",
  "G.H.PATEL COLLEGE OF ENGG. & TECH. , V. V. NAGAR",
  "ITM (SLS) BARODA UNIVERSITY- SCHOOL OF TECHNOLOGY & ENGINEERING",
  "ITM (SLS) BARODA UNIVERSITY- SCHOOL OF SCIENCES",
  "SILVER OAK COLLEGE OF ANIMATION AND MULTIMEDIA",
  "ITM (SLS) BARODA UNIVERSITY- SCHOOL OF PHARMACY",
  "ADITYA SILVER OAK INSTITUTE OF TECHNOLOGY",
  "Sheth T. C. Kapadia Arts & Commerce College Bodeli",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE-BABRA",
  "P P SAVANI SCHOOL OF PHYSIOTHERAPY",
  "P P SAVANI SCHOOL OF DESIGN",
  "Shree Naranjibhai Lalbhai Patel College of Pharmacy",
  "SARVAJANIK COLLEGE OF ENGG. & TECH. , SURAT",
  "Sarvajanik College of Engineering & Technology(SFI),(MCA) SURAT",
  "L.J.Institute Computer Application (SFI)-Ahmedabad",
  "L.J.Institute of Management Studies (SFI)-First shift Ahmedabad",
  "L.J. INSTITUTE OF ENGG AND TECH., AHMEDABAD",
  "SVPES COLLEGE OF PHARMACY",
  "VISHWABHARTI GIRLS INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "GOVERNMENT ARTS COMMERCE AND SCIENCE COLLEGE  DOLVAN DI TAPI",
  "SHRI BANASKANTHA ANJANA PATEL KELVANI MANDAL SANCHALIT S. A. Patel Commerce College",
  "SHRI SWAMINARAYAN PHYSIOTHERAPY COLLEGE-NAGHEDI (JAMNAGAR)",
  "SHRI SAI M A PATEL M ED COLLEGE ",
  "DIMS Institute of Post Graduate Courses And Diploma",
  "P P Savani School of Engineering",
  "METAS Adventist College",
  "State Model Institute of Ayurveda Sciences, Kolavada",
  "M K COLLEGE OF EDUCATION (B.ED.), PATAN",
  "Manekchok Co-Op Bank Arts & Mahemdabad Urban People Co-Op Bank Commerce College",
  "NAVGUJARAT SCIENCE & ARTS COLLEGE",
  "GENEZEN INSTITUTE OF PHARMACY DELOL",
  "SHRI RATNABHAI KAJABHAI PATROD SCIENCE COLLEGE, DHANERA",
  "Sheth C. N. College of Education",
  "JAFARI INSTITUTE OF POST GRADUATE DIPLOMA IN MEDICAL LABORATORY TECHNOLOGY ",
  "College of Veterinary Science and Animal Husbandry, KU, Himmatnagar",
  "NAVKAR INSTITUTE OF NURSING",
  "Smt. Santokben Shantilal Mohanlal Patel B. Ed. College",
  "School of Agriculture Science, RK University, Rajkot",
  "SMT R.K.D. KHANUSHIYA M.ED. COLLEGE, PALANPUR",
  "ADIVASI ARTS & COMMERCE COLLEGE BHILODA",
  "JAWAHARLAL NEHRU HOMOEOPATHIC MEDICAL COLLEGE - LIMDA",
  "PANCHAMRUT INSTITUTE OF NURSING",
  "shree samjubhai raghavbahi kavani mahila english medium commerce college ",
  "SHASTRI SWAMI SHREE DHARMJIVANDASJI INSTITUTE OF INFORMATION TECHNOLOGY-JUNAGADH",
  "MATRUSHRI LALITABEN JAMNADAS GANDHI(BAKORWALA) BCA & DR N J SHAH PGDCA COLLEGE, MODASA",
  "Shree Veljibhai Narshibhai Borad Mahila B.C.A. College",
  "VIBRANT PHYSIOTHERAPY COLLEGE",
  "GOKUL INTEGRATED LAW COLLEGE",
  "FACULTY OF COMMERCE AND MANAGEMENT",
  "Graduate School of Management Studies, GTU",
  "C. U. Shah Technical Institute of Diploma Studies",
  "B. V. Shah B. Ed. College",
  "NACHIKETA MSW COLLEGE ",
  "Banas Medical College And Research Institute",
  "GLS (SADGUNA & B. D.) COLLEGE FOR GIRLS",
  "Polytechnic in Agriculture Science,Sidsar",
  "Polytechnic in Agriculture Science,Halvad",
  "A.P.TRIVEDI LAW COLLEGE,KHORDA",
  "ATMANAND SARASWATI SCIENCE COLLEGE",
  "SHREE JASUBHAI DHANABHAI BARAD COMMERCE COLLEGE - AJOTHA",
  "GOVT. ARTS COLLEGE, SUIGAM (BANASKANTHA)",
  "SHREE PANCHOTIYA PARIVAR ARTS AND COMMERCE COLLEGE, DABHODA",
  "Merchant Nursing College, Basna",
  "Shree Sharvoday Education Foundation Trust managed Arts AND Commerce College",
  "PARUL INSTITUTE OF  HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "VBTs Institute of Social Work",
  "VBTs Institute of Management Studies",
  "VBTs Institute of Arts & Humanities",
  "VBTs Institute of Commerce",
  "C. U. Shah College of Pharmacy & Research",
  "Smt. K. B. Shah (Vadi Vihar) Science College",
  "C. U. Shah Institute of Life Sciences",
  "C. U. Shah College of Engineering & Technology",
  "C. U. Shah College of Master of Computer Application",
  "C. U. Shah College of Law",
  "B. V. Shah (Vadi Vihar) Science College",
  "Tolani Motwane Institute of Management Studies",
  "Momina Nuriben Alijibhai Balya Jafari Arts & Commerce",
  "Shri M. N. Patel Science & Commerce College",
  "Saraswati College of Arts, , Ta. Himatnagar",
  " Matrushri Maniba Commerce College",
  "Shri T.S.Patel College (Four Year Intigrated) ",
  "NARAYANA BUSINESS SCHOOL",
  "PRIME COLLEGE OF DIPLOMA",
  "DR. V. R. GODHANIA COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "SHRI MAHAVIR B.ED.COLLEGE-DHANGADHRA",
  "SMT. R. O. PATEL WOMEN'S B.ED. COLLEGE, TANKARA",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE, SANJELI",
  "Polytechnic in Animal Husbandry, Himmatnagar",
  "FACULTY OF PROFESSIONAL STUDIES",
  "K P GIRLS INSTITUTE OF IT",
  "SHREE SWAMINARAYAN GURUKUL PHARMACY COLLEGE JAMNAGAR",
  "GMERS Medical College, Valsad",
  "SHREE ARYATEJ LAW COLLEGE",
  "AHMEDABAD INSTITUTE OF PHARMACY",
  "SHREE H.N. SHUKLA COLLEGE OF IT & MANAGEMENT - RAJKOT",
  "M. B. Patel Applied Science College",
  "Smt. CHANDRAKANTABEN G. DHANKA SCIENCE COLLEGE, NAGARALA",
  "SANJIVANI NURSING COLLEGE",
  "HIMALAY AYURVED CHIKITSALAY AND MAHAVIDHYALAY",
  "Centre for Studies on Rural Management, Randheja",
  "Agricultural Research Station, Kholwada",
  "Agricultural Research Station, Ladol",
  "Agricultural Research Station, Mundra",
  "Agricultural Research Station, Radhanpur",
  "Agricultural Research Station, Rapar",
  "Agricultural Research Station, Talod",
  "Aspee College of Home Science & Nutrition",
  "College of Agri Business Management",
  "College of Basic Science & Huminities",
  "College of Horticulture",
  "Agricultural Research Station, Adiya",
  "Agricultural Research Station, Aseda",
  "Agricultural Research Station, Bhachau",
  "Agricultural Research Station, Bhiloda",
  "Agricultural Research Station, Dehgam",
  "CRSS Jagudan",
  "Main Wheat Research Station, Vijapur",
  "Main Potato Research Station, Deesa",
  "Calorx Institute of Education",
  "DUNES COLLEGE KUTCH",
  "ADITYA B.ED. COLLEGE, JUNAGADH",
  "MARWADI EDUCATION FOUNDATIONS GROUP OF INSTITUTIONS-SECOND SHIFT-FACULTY OF BUSINESS MANAGEMENT-(SFI)-NEW",
  "MARWADI EDUCATION FOUNDATIONS GROUP OF INSTITUTIONS-FACULTY OF BUSINESS MANAGEMENT",
  "Institute of Diploma studies, Nirma University",
  "Sankalchand Patel College of Engineering, Visnagar",
  "Nootan Pharmacy College, Visnagar",
  "Shri Jivan Jyot Mahila B.A.B.ED ( Integrated ) College.",
  "MAHISAGAR SCIENCE COLLEGE",
  "SHREE BANASKANTHA KADVA PATIDAR SANSKAR MANDAL ARTS AND COMMERCE COLLEGE PALANPUR",
  "PARUL INSTITUTE OF MANAGEMENT AND RESEARCH, VADODARA",
  "DHARMSINH DESAI INSTITUTE OF COMMERCE",
  "SMT. G.S.PATEL SCIENCE AND COMMERCE COLLEGE",
  "KRITITI B.ED COLLEGE",
  "Shree R M D Ayurveda College and Hospital, Waghaldhara",
  "MANJUSHREE RESEARCH INSTITUTE OF AYURVEDIC SCIENCE",
  "INDIAN INSTITUTE OF AYURVED RESEARCH AND HOSPITAL",
  "VALIBA R PATEL B ED COLLEGE",
  "GOVERNMENT SCIENCE COLLEGE, BHILAD",
  "Government Arts and Commerce College-Ghogha",
  "ANANYA SCHOOL OF NURSING,KALOL",
  "RATNA PRABHA NURSING INSTITUTE",
  "PARUL INSTITUTE OF NURSING, VAGHODIYA",
  "Parul Institute of Business Administration",
  " AHMEDABAD PHYSIOTHERAPY COLLEGE",
  "PARUL INSTITUTE OF APPLIED SCIENCES",
  "L.J. INSTITUTE OF PHYSIOTHERAPY",
  "GOVERNMENT SCIENCE COLLEGE, FORT-SONGADH",
  "ILABEN K. PATEL PGDCA STUDY CENTER, VIRAMGAM",
  "Government Science College, Chhotaudepur",
  "PARUL INSTITUTE OF FINE ARTS",
  "SWAMI VIVEKANAND POST GRADUATE ACADEMY",
  "Department of Animation, ITIMS And Mobile Application",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE, TALALA",
  "Parul Institute of Design",
  "GOVERNMENT SCIENCE COLLEGE, PARDI",
  "KRISHNA LAW COLLEGE",
  "SHREE ATMIYA LAW COLLEGE",
  "MAHATMA GANDHI PHYSIOTHERAPY COLLEGE",
  "GOVT.ATRS AND COMMERCE COLLEGE.OKHAMANDAL",
  "Naran Lala Law College",
  "SHRI KANYA KELAVANI MANDAL, UNJHA ADMINISTERED UMA NURSING COLLEGE, UNJHA",
  "AKAR COLLGEG OF PHYSIOTHERAPY",
  "SHRIMAD RAJCHANDRA COLLEGE OF PHYSIOTHERAPY",
  "C. K. PITHAWALA COLLEGE OF ENGG. & TECH., SURAT 009 ",
  "GOVERNMENT ENGINEERING COLLEGE, SECTOR 28 GANDHINAGAR 013",
  "ANANYA INSTITUTE OF COMMERCE AND LAW",
  "R. H. Patel Institute of Management-Goblaj,Di:Kheda -(SFI) 804",
  "Late Smt S. G. Patel Institute of Physiotherapy ",
  "Samarpan School of Law",
  "Arush Physiotherapy College, Ahmedabad",
  "GOVERNMENT ENGINEERING COLLEGE, BHARUCH 014",
  "ANAND PHARMACY COLLEGE, ANAND  205 ",
  "AVANTIKA EDUCATION TRUST B.PHARMACY COLLEGE, NAVALGADH  211",
  "R H PATEL ENGLISH MEDIUM B ED COLLEGE",
  "DODHIWALA ARTS & COMMERCE COLLEGE-THANGADH",
  "SAHAJANAND INSTITUTE OF COMPUTER APPLICATION",
  "Sardar Patel College of Commerce",
  "COLLEGE OF AGRICULTURE MORBI    ",
  "IKDRC ITS COLLEGE OF PHYSIOTHERAPY",
  "GLS Institute of Computer Technology (GLSICT-MBA)-Ahmedabad (SFI)",
  "KHYATI COLLEGE OF PHYSIOTHERAPY, SHILAJ",
  "GUJARAT POWER ENGINEERING & RESEARCH INSTITUTE",
  "Nagar School of Optometry",
  "GIDC DEGREE ENGINEERING COLLEGE, NAVSARI",
  "New L. J. Commerce College",
  "SELF FINANCE SCIENCE COLLEGE DABHOI",
  "SPORTS COLLEGE KODINAR",
  "Akhil Anjana Kelavni Mandal (Chaudhari) College of Computer Application",
  "PARUL INSTITUTE OF PERFORMING ARTS ",
  "BKDKM COLLEGE  OF PROFESSIONAL STUDIES",
  "GOVERNMENT COMMERCE AND ARTS COLLEGE SAVLI",
  "Bharti Chandresh Virvadiya Law College, Radhanpur",
  "NIRMALABEN KISHORBHAI DESAI SCIENCE COLLEGE",
  "S.M.DESAI M.ED COLLEGE - BECHRAJI ",
  "GURU RAMANAND B.SC.B.ED.(INTEGRATED)COLLEGE,VIJAPUR",
  "SHREE SHARDA COLLEGE OF EDUCATION",
  "SHRI M.M.GHODASARA MAHILA ARTS & COMM.COLLEGE-JUNAGADH",
  "S.M.JADEJA ARTS & COMMERCE COLLEGE-KUTIYANA (PORBANDAR)",
  "JUNAGADH KELVANI MANDAL B.ED.COLLEGE-JUNAGADH",
  "H.J.DOSHI INFO.TECH. INSTITUTE -JAMNAGAR",
  "KAMANI SCIENCE & PRATAPRAI ARTS COLLEGE-AMRELI",
  "ARPIT COLLEGE OF EDUCATION, RAJKOT",
  "SIDDI VINAYAK COMMERCE & B.B.A.COLLEGE-JAMNAGAR",
  "SADGURU MAHILA HOMESCI.& M.J.K.ENG. MEDIUM MAHILA COMMERCE & B.B.A. COLLEGE-RAJKOT",
  "Lokmanya Commerce College",
  "V.k.KAMDAR B.ED.COLLEGE -RAJKOT",
  "Pujya Ladakchand Manekchand Vora College of Arts & Commerce - Sayla",
  "M.B.ARTS & COMMRGE COLLEGE, GONDAL",
  "GRAM SARVAJANIK EDUCATION TRUST B.ED.COLLEGE-AMRAPUR (JASDAN)",
  "SAKHIDA ARTS GADDIWALA COMM.& HOMESCI.COLLEGE-LIMBDI",
  "A.K.DOSHI MAHILA ARTS, COMM. &. HOMESCI.  COLLEGE-JAMNAGAR",
  "A.M.P. LAW COLLEGE-RAJKOT",
  "SMT. C.Z.M. GOSRANI B.C.A. COLLEGE-JAMNAGAR",
  "DR. BHARAT BARAD ARTS & COMMERCE COLLEGE, SUTRAPADA",
  "MAHILA ARTS & COMMERCE COLLEGE -SIMAR(VERAVAL)",
  "G.J.SHETH COMMERCE COLLEGE MORBI",
  "P.G.PATEL COMMERCE COLLEGE-MORBI",
  "SHREE ARYATEJ B.ED. COLLEGE, MORBI",
  "SHRI M.D.SITAPARA COMMERCE COLLEGE AMRELI",
  "SHRI H.N.DOSHI ARTS & R.N.DOSHI COMMERCE COLLEGE, WANKANER",
  "SHREE OM COLLEGE OF COMPUTER SCIENCE, RAJKOT",
  "DR.V.R.GODHANIYA B.ED. COLLEGE-PORBANDAR",
  "INNOVATIVE ARTS & B.S.W. COLLEGE, AT. KHORASA (GIR)",
  "J.J.C. EDU. COMMERCE COLLEGE -JUNAGADH",
  "K.H.MADHWANI ARTS & COMMERCE COLLEGE -PORBANDAR",
  "Matashree Jamnaba Shamjibhai Godhani Mahila Arts and Commerce College - Junagadh",
  "SAUTASHTRA EDUCATION TRUST MAHILA ARTS COMM. (B.B.A.) & B.C.A. COLLEGE-JUNAGADH",
  "YADAV COLLEGE OF COMPUTER SCIENCE,  DI.JUNAGADH",
  "SHRI J.N.BHATU COLLEGE OF EDUCATION-JUNAGADH",
  "SHRI V.J.MODHA COLLEGE OF INFORMATION TECH.-PORBANDAR",
  "U.K.VACHHANI MAHILA ARTS & HOMESCI. COLLEGE-KESHOD",
  "SARDAR PATEL EDU. SHREE MAHILA B.B.A. COLLEGE, JUNAGADH",
  "SHRI M.B. GARDI COLLEGE OF EDUCATION, MANGROL",
  "SHREE SWAMI VIVEKANAND COLLEGE, SURENDRANAGAR",
  "MS. S.V.PATEL (GARDI) B.ED. COLLEGE, NYARA-RAJKOT",
  "MINABEN KUNDALIYA MAHILA ARTS COMM. COLLEGE-RAJKOT",
  "SHANTI NIKETAN COLLEGE -RAJKOT",
  "Shankersinh Vaghela Bapu Institute of Science and Commerce",
  "KANKESHWARIDEVI INST. OF TECH.,JAMNAGAR 027 ",
  "Sir P.P. Institute of Science",
  "MODEL WOMEN’S COLLEGE",
  "BHAGWAN MAHAVIR COLLEGE OF LEGAL EDUCATION",
  "BHAGWAN MAHAVIR COLLEGE OF MANAGEMENT (MBA)(SFI),VESU,SURAT (SECOND SHIFT) - NEW",
  "Shri V. S. Patel College of Arts & Science, Bilimora",
  "Sheth H.J. Law College",
  "BHAGWAN MAHAVIR COLLEGE OF COMMERCE AND MANAGEMENT STUDIES",
  "SHARIRIK SHIKSHAN MAHAVIDYALAY",
  "Bhagwan Mahavir College of Computer Application",
  "School of Architecture",
  "School of Design",
  "VIVEKANAND COLLEGE OF BCA",
  "SMT AMARBEN HAMIRABHAI DESAI ARTS AND COMMERCE COLLEGE ",
  "SAMARPAN INSTITUTE OF COMPUTER SCIENCE",
  "BARODA HOMOEPETHIC MEDICAL COLLEGE",
  "CHITRINI INSTITUTE OF DIPLOMA IN FIRE AND SAFETY",
  "TAXSHILA COLLEGE ",
  "R G BAROT EDUCATION COLLEGE (MED)",
  "D D THAKAR ARTS & K J PATEL COMMERCE COLLEGE",
  "AKSHAR MAHILA B ED COLLEGE",
  "APOLLO INSTITUTE OF NURSING, GANDHINAGAR",
  "Som-Lalit Institute of Computer Application",
  "Government Physiotheraphy College",
  "K. K. Shashtri Government BCA College",
  "J. G. College of Computer Application",
  "NARENDRA MODI MEDICAL COLLEGE",
  "J. G. College of Physiotherapy",
  "Divaba Institute of Business Administration",
  "I. M. Nanavati Law College",
  "M. D. Patel College of Education (M. Ed.)",
  "Shri Chimanbhai Patel Institute of Business Administration",
  "J. G. College of Education for Women (PG)",
  "Shri Chimanbhai Patel Institute of Computer Applications",
  "Government Prosthetic & Orthotic College",
  "Daulatbhai Trivedi Law College",
  "Bhramanand Institute of Business Administration",
  "P. D. Pandya Institute of Computer Application",
  "Chaudhari M.Ed. College",
  "Suresh Brahmkumar Bhatt, College of Physiotherapy",
  "SHETH SHREE K J PATEL BBA COLLEGE NANI KADI",
  "Kameshwar College of Education and Kameshwar M. Ed. College",
  "L. J. Institute of Business Administration",
  "J. G. College of Nursing",
  "Siddharth Law College, Gandhinagar",
  "Som-Lalit Institute of Business Administration",
  "Shri B. J. Patel Umiya BBA College",
  "Maneklal Nanavati Law College",
  "L. J. College of Computer Application",
  "Motilal Nehru Law College",
  "J. G. College of Education M. Ed. (P.G.)",
  "Lokmanya College of Computer Applications",
  "RAJPUR KELAVANI MANDAL SAANCH BED COLLEGE VIJAYNAGAR",
  "MARUTINANDAN COLLEGE OF EDUCATION UMTA",
  "SHETH SHRI I M PATEL COLLEGE OF EDUCATION",
  "SHRI SHANKAR BED COLLEGE",
  "JOITIBA COLLEGE OF NURSING",
  "EKTA COLLEGE OF EDUCATION",
  "B M SHAH MAHAVIDHYALAYA ZILIYA",
  "UTTAR PURVA GUJARAT UCHCH KELAVANI MANDAL BED COLL",
  "SHRI U.P. ARTS, SMT M.G.PANCHAL SCIENCE & SHRI V.L.SHAH COMMERCE COLLEGE",
  "GOVERNMENT LAW COLLEGE, MANINAGAR",
  "SHREE S S MEHTA ARTS & M M PATEL COMMERCE COLLEGE",
  "Nandkunvarba Mahila Arts College",
  "GOVERMENT ARTS & COMM COLLEGE KADOLI",
  "SHRI K K SHAH NURSING COLLEGE VATRAK",
  "SHRI K. H. PATEL M.ED INSTITUTE MODASA",
  "SHRI B. H. GANDHI B.B.A. COLLEGE MODASA",
  "LALITABA EDU TRUST SANCHALIT BED COLLEGE",
  "GOVERMENT ARTS & COMMERCE COLLEGE MEGHRAJ",
  "Dr. K. C. Patel Research & Development Centre",
  "Indukaka Ipcowala Institute of Management",
  "Chandubhai S. Patel Institute of Technology",
  "Sheth D.M.Polytehnic in Horticulture, Vadodara",
  "Sheth M.C.Polytehnic in Agriculture , Anand",
  "SMT K B DAVE COLLEGE OF EDUCATION (MED)",
  "SARASWATI COLLEGE OF EDUCATION, VIRAVADA",
  "MSW COLLEGE MODASA",
  "BED COLLEGE ANTOLI",
  "SHETH I M PATEL COLLEGE OF EDUCATION (MED)",
  "SHREE N S PATEL LAW COLLEGE MODASA",
  "SRADDHA BCA COLLEGE BAYAD",
  "SHRI SVT COLLEGE OF EDUCATION",
  "SMT  A J SAVLA HOMOEPETHIC COLLEGE",
  "SAMARTH VIVIVDHLAXI BED COLLEGE",
  "SHRI SWAMI NARAYAN BED COLLEGE PALANPUR",
  "NILKANTH MED COLLEGE VISNAGAR",
  "NOOTAN BHARATI GRAM SEVA MAHAVIDHYALAYA",
  "MSCT AVADH MAHAVIDHYALAYA BED COLLEGE VISNAGAR",
  "C K PATEL COLLEGE OF SOCIAL WORK",
  "VNSB LTD ARTS & COMMERCE COLLEGE VADNAGAR",
  "SANSKAR BED COLLEGE",
  "ARTS COLLEGE LAVANA",
  "M.N COLLEGE ,VISNAGAR",
  "SHREE SEVANTILAL TRIBHOVANDAS JAVERI ARTS COLLEGE, GADH",
  "SMT B.K.MEHTA I.T.CENTRE (BCA COLLEGE), PALANPUR",
  "SMT M C DESAI ARTS & COMMERCE COLLEGE PRANTIJ",
  "BED COLLEGE ANDROKHA",
  "SAMARTH BCA COLLEGE",
  "G D MODI COLLEGE OF ARTS",
  "D N P ARTS & COMMERCE COLLEGE",
  "GUJARAT HOMOEPETHIC MEDICAL COLLEGE SAVLI",
  "GOVERNMENT ARTS COLLEGE AMIRGADH",
  "SHRI R J PATEL COLLEGE OF EDUCATION",
  "SHRI U H CHAUDHARY ARTS COLLEGE VADGAM",
  "GROW MORE EDUCATION COLLEGE",
  "SHETH V S LAW COLLEGE UNJHA",
  "SHRI KASNABHAI RAMJIBHAI AJANA ARTS AND COMMERCE COLLEGE DHANERA",
  "N M SHAH ARTS COMMERCE COLLEGE SHANKHESWAR",
  "N P PATEL ARTS AND S A PATEL COMMERCE COLLEGE PALANPUR",
  "College of Food Processing & Bio Energy , Anand",
  "Polytechnic in Food Science and Home Economics , Anand",
  "Polytechnic in Agricultural Engineering, Dahod",
  "VADODARA INSTITUTE OF LAW",
  "ARRDEKTA INSTITUTE OF MSW COLLEGE",
  "VIDHYADEEP COLLEGE OF PHARMACY",
  "SHRI S K PATEL SHANDILYA RUSHI VED SANSKRIT PATHSHALA",
  "SHREE SWAMINARAYAN GURUKUL BED COLLEGE ",
  "NOBLE STAR HOMOEOPATHIC COLLEGE AND RESEARCH INSTITUTE",
  "LJ INSTITUTE OF EVENT MANAGEMENT",
  "Space Applications Centre (ISRO) Industrial Area, Ambavadi Vistar P.O., Govt. of India, Ahmedabad - 380015",
  "SHREE SWAMINARAYAN GURUKUL NURSING COLLEGE JAMNAGAR",
  "SOM-LALIT INSTITUTE OF MANAGEMENT STUDIES (SLIMS)",
  "NEELDEEP COLLEGE OF COMPUTER APPLICATIONS",
  "GMB POLYTECHNIC RAJULA",
  "Prof. V. B. Shah Institute of Management, R. V. Patel College of Commerce(English Medium), V. L. Shah College of Commerce, (Gujarati Medium), Sutex Bank College of Computer Application & Science",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE, GARUDESHWAR DIST NARMADA    ",
  "GOVERNMENT COMMERCE AND ARTS COLLEGE, ABDASA",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE, WAGHAI   ",
  "GLORIOUS NURSING COLLEGE",
  "A P TRIVEDI COLLEGE OF COMPUTER STUDIES, KHORDA",
  "SHREE SWAMINARAYAN COLLEGE OF NURSING",
  "SHREE SWAMINARAYAN HOMOEOPATHY COLLEGE",
  "SHRI K K PATEL AND SMT MADHUBEN K PATEL NURSING COLLEGE    ",
  "Government Science College, Maninagar",
  "NEELDEEP LAW COLLEGE",
  "Shree Narmada Sanskrit Ved Pathshala, Bharuch",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING AMRELI",
  "Government Science College, Mandvi",
  "SWASTIK INSTITUTE OF MVOC    ",
  "ANANT LAW COLLEGE",
  "J M SCIENCE COLLEGE- VERAVAL",
  "MAHARSHI DAYANAND LAW COLLEGE MANDAL    ",
  "RKM INSTITUTE OF PHARMACY    ",
  "MAHILA ARTS & COMMERCE COLLEGE-VERAVAL",
  "SHREE SWAMINARAYAN GADI INSTITUTE OF TECHNOLOGY    ",
  "LOKMANYA BBA BCA COLLEGE    ",
  "MAKTABAH JAFARIYAH SCHOOL OF ENGINEERING AND TECHNOLOGY    ",
  "SHRADDHA LAW LL,B, COLLEGE    ",
  "SARASWATI B.ED. / M.ED. COLLEGE RANELA",
  "SMT S K PATEL ARTS AND COMMERCE COLLEGE KALYANA    ",
  "KHYATI SCHOOL OF BUSINESS ADMINISTRATION",
  "SHREE SARASWATI ARTS COMMERCE AND SCIENCE COLLEGE MEMADPUR ",
  "NEELDEEP INSTITUTE OF MSW",
  "PRADIP COLLEGE OF LAW, PATAN    ",
  "MAHARANI PREM KUMARI COLLEGE    ",
  "M D PATEL LAW COLLEGE     ",
  "LAW COLLEGE ,  HALOL    ",
  "ARPIT HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL    ",
  "SHREEMATI P S DESAI DIPLOMA IN SANITARY INSPECTOR COLLEGE    ",
  "SHREEMATI V P DESAI ARTS COLLEGE    ",
  "ADAMALI MULLA IBRAHIMJI ARTS COLLEGE, MODASA",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE SHIHORI",
  "PRIME INSTITUTE OF COMPUTER AND MANAGEMENT    ",
  "GOVERNMENT SCIENCE COLLEGE, BAGASARA",
  "MSC COLLEGE KHERALU    ",
  "A K PATEL DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "ARRDEKTA INSTITUTE OF BRS",
  "VIVEKANAND ARTS COLLEGE DUCHAKVADA",
  "LAW COLLEGE JAMKANDORNA",
  "GOPINATHJI MAHILA COLLEGE AND NURSING ",
  "NAVSARJAN INSTITUTE OF NURSING  ",
  "VJKM SELF FINANCE COLLEGE OF SI",
  "SHRI JIVAN JYOT DMLT COLLEGE",
  "SHRI RAMJANKI SANSKRIT MAHAVIDYALAYA",
  "DARSHAN INSTITUTE OF HUMANITIES",
  "DARSHAN INSTITUTE OF COMPUTER APPLICATION",
  "DARSHAN INSTITUTE OF MANAGEMENT",
  "SANTRAM NURSING INSTITUTE",
  "FACULTY OF INFORMATION AND COMMUNICATION TECHNOLOGY",
  "INDIAN INSTITUTE OF DESIGN ",
  "SARDAR AYURVED COLLEGE AND HOSPITAL, PILUDARA, MEHSANA",
  "DARSHAN INSTITUTE OF SCIENCE",
  "YASHODHARA ARTS, COMMERCE AND SOCIAL SCIENCE COLLEGE",
  "PARUL INSTITUTE OF NURSING AND RESEARCH ",
  "SHRI ISHVARBHAI NARAYANBHAI PATEL INSTITUTE OF MEDICAL TECHNOLOGY AND RESEARCH",
  "SHREE V G CHAUDHARY COLLEGE OF NURSING, PALANPUR",
  "NAVJEEVAN COLLEGE OF SCIENCE PG",
  "ANGEL COMMUNITY COLLEGE OF FIRE SAFETY",
  "LAXMINARAYAN INSTITUTE OF PARAMEDICAL SCIENCE AND HOSPITAL",
  "SHRI K N PATEL SCIENCE COLLEGE",
  "EXPERIMENTAL COLLEGE OF PGDMLT",
  "SHRI SHARAD SHAH COLLEGE OF COMMERCE AND COMPUTER SCIENCE",
  "Shri Pankaj Kapadia Sarvajanik College of Performing Arts",
  "SHRIJI DSI COLLEGE ",
  "SCIENCE COLLEGE, HALOL",
  "C. P. College of Agriculture",
  "UNITEDWORLD SCHOOL OF BUSINESS",
  "MONARK GOSWAMI COLLEGE OF PHARMACY",
  "VEDANSHI COLLEGE OF SOCIAL WORK",
  "DIVYACHETANA ARTS,COMMERCE AND SCIENCE COLLEGE,BHETALI",
  "SHRI RAMASARA DHARANIDHAR ARTS COLLEGE",
  "MOTHER CARE INSTITUTE OF NURSING",
  "PARUL INSTITUTE OF PHYSIOTHERAPY AND RESEARCH",
  "GAJWANI INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "KASTURBA GANDHI PHYSIOTHERAPY COLLEGE",
  "PANCHSHIL COLLEGE OF EDUCATION",
  "Shree Narayan Sanskrit Mahavidyalaya, Petlad",
  "GOKUL HOMEOPATHY MEDICAL COLLEGE",
  "GOKUL PHARMACY COLLEGE",
  "FACULTY OF PERFORMING ARTS",
  "NOBLE BCA COLLEGE",
  "SMT ANANDIBEN SHANKARBHAI CHAUDHRAY MAHILA  ARTS & HOME SCIENCE COLLEGE, MEHSANA",
  "BAHAUDDIN GOVERNMENT SCIENCE COLLEGE JUNAGADH",
  "NOBLE INSTITUTE OF SOCIAL WORK ",
  "NOBLE INSTITUTE OF COMPUTER SCIENCE ",
  "SMT LILABEN ANKOLIYA M S W COLLEGE",
  "AKSHATAM PHYSIOTHERAPY COLLEGE",
  "IDAR SCHOOL OF NURSING",
  "SHRIDHAR ATULKUMAR JANI AYURVEDIC MEDICAL COLLEGE AND HOSPITAL AMRELI ",
  "MAHENDRABHAI MANILAL SHAH POST GRADUATION SCIENCE MSC COLLEGE,RADHANPUR",
  "SABAR SCHOOL AND COLLEGE OF NURSING",
  "SHREE ADARSH SCIENCE COLLEGE DEODAR",
  "MATUSHREE MANJULABEN JAMNADASBHAI RAITHTHA SCIENCE COLLEGE ",
  "COLLEGE OF AGRICULTURE, BHUJ KUTCH",
  "AMAN COMMERCE COLLEGE, KANJARI",
  "Smt. R. P. Chauhan Arts & Smt. J. K. Shah & Shri K. D. Shah Commerce College",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE, TARAPUR",
  "SAL INSTITUTE OF MEDICAL SCIENCES,AHMEDABAD",
  "DEEPJYOTI COLLEGE OF COMMERCE AND ARTS",
  "SHRI JIVAN JYOT BRS HONOURS COLLEGE",
  "SAL COLLEGE OF PHARMACY",
  "KISHORBHAI INSTITUTE OF AGRICULTURE SCIENCES AND RESEARCH CENTRE",
  "BHULABHAI VANMALIBHAI PATEL INSTITUTE OF COMPUTER SCIENCE",
  "DIWALIBA POLYTECHNIC",
  "DR CHUNIBHAI VALLABHBHAI PATEL COLLEGE OF PHARMACY",
  "SILVER OAK COLLEGE OF PHARMACY",
  "Shree Vestabhai H. Patel College of B. Ed.",
  "PARUL COLLEGE OF PHARMACY AND RESEARCH",
  "ORSANG SANITARY INSPECTOR COLLEGE  ",
  "MATRU SHREE LILUBEN BHAGWANBHAI BARAD BBA AND BCA COLLEGE",
  "NEELDEEP NURSING COLLEGE",
  "OM INSTITUTE OF NURSING",
  "DALIA NURSING COLLEGE KANERA",
  "N J PATEL SCHOOL OF NURSING",
  "SHRI HARI NURSING COLLEGE",
  "GIRNAR NURSING INSTITUTE",
  "GMERS MEDICAL COLLEGE, PORBANDAR",
  "GOVERNMENT SCIENCE COLLEGE KHERALU",
  "Som Lalit College of Education",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE ANJAR",
  "TAXASHILA COLLEGE OF BBA AND BCA",
  "STEPHEN SCIENCE COLLEGE",
  "SHRIJI INSTITUTE OF NURSING",
  "SARDAR PATEL MSW COLLEGE",
  "GRAM VIDHYAPITH BRS COLLEGE DEVPURA VIJAPUR",
  "SHREE TAPASVI COLLEGE OF NURSING DEODAR",
  "LIONS ARTS COLLEGE,MOTAKAPRA",
  "BALAJI COLLEGE OF NURSING",
  "SHARDABEN BHAGUBHAI MANGALDAS PATEL NURSING AND PARA MEDICAL COLLEGE",
  "BALAJI COLLEGE OF PHYSIOTHERAPY",
  "GROW MORE INSTITUTE OF MASTER SCIENCE",
  "SHREE PAREKH ENGINEERING COLLEGE",
  "Ganpat University Subhadraben Sureshchandra Institute of Physiotherapy",
  "MAHATMA GANDHI PG CENTRE OF SOCIAL WORK",
  "M.J.KUNDALIYA EDUCATION & PHYSICAL EDUCATION COLLEGE-RAJKOT",
  "GANPAT UNIVERSITY KANTABEN KASHIRAM INSTITUTE OF AGRICULTURAL SCIENCES AND RESEARCH",
  "SHREE SWAMINARAYAN GURUKUL COLLEGE OF INFORMATION TECHNOLOGY",
  "SHREE ADARSH MSC COLLEGE RADHANPUR",
  "SHREE SAHAJANAND P G CENTRE OF SOCIAL WORK",
  "SHREE BHIKHUBHAI VEJANANDBHAI VAROTARIYA MAHILA ARTS COLLEGE AND SHREE HEMATBHAI RAMBHAI MADAM MAHILA SCIENCE AND COMMERCE COLLEGE JAMNAGAR ",
  "GANPAT UNIVERSITY INSTITUTE OF OPTOMETRY",
  "VISHWABHARTI GIRLS INSTITUTE OF COMMERCE MANAGEMENT AND COMPUTER APPLICATION",
  "SHREE RADHA GOVIND COLLEGE OF NURSING",
  "SMT RANIBEN MADHABHAI BHADARKA BCA COLLEGE, PALSANA, SURAT",
  "MAZUM MSC SCIENCE COLLEGE ",
  "SHREE RAJIBEN GANDALAL PATEL COLLEGE OF NURSING",
  "SHRI GHELIMA EDUCATION AND CHARITABLE TRUST SANCHALIT B ED COLLEGE VARDHARI  ",
  "SHRI P J PATEL NILKANTH MSC COLLEGE",
  "ADARSH SCIENCE PG COLLEGE PATAN",
  "SHREE ADARSH PGDMLT COLLEGE PATAN",
  "ADARSH ARTS AND COMMERCE COLLEGE PATAN",
  "GOVERNMENT ARTS COMMERCE AND SCIENCE COLLEGE LIMBAYAT SURAT",
  "UNITEDWORLD SCHOOL OF COMPUTATIONAL INTELLIGENCE",
  "SHREE H N SHUKLA COLLEGE",
  "GVM INSTITUTE OF POLYTECHNIC IN ANIMAL HUSBANDRY",
  "GVM LAW COLLEGE",
  "RANIBA ARTS COLLEGE, CHANCHBANDAR",
  "RMS COLLEGE OF BBA",
  "B M GONDIA BED COLLEGE",
  "SAIRAM ARTS AND COMMERCE COLLEGE",
  "FACULTY OF IT AND COMPUTER SCIENCES",
  "FACULTY OF COMMERCE AND MANAGEMENT",
  "GOVERNMENT SCIENCE COLLEGE, VARACHHA, SURAT",
  "GOVERNMENT SCIENCE COLLEGE, JASDAN",
  "DR SUBHASH UNIVERSITY, SCHOOL OF NURSING",
  "GVM DIPLOMA IN SI INSTITUTE",
  "TARSADIA INSTITUTE OF CHEMICAL SCIENCE",
  "IDAR ANJANA PATIDAR H.K.M. ARTS & P.N.PATEL COMMERCE COLLEGE, IDAR",
  "SHREE KRISHNA DIPLOMA IN HEALTH AND SANITARY INSPECTOR BHABHAR",
  "SHRI SWAMI VIVEKANAND MSW COLLEGE RONWEL",
  "SHREEJI DIPLOMA IN FIRE AND SAFETY MEGHRAJ",
  "SMT SHANTABEN SHANTILAL KOTHARI NURSING INSTITUTE",
  "SANDIPANI INSTITUTE OF NURSING SCIENCE",
  "SHRI VADGAM TALUKA ANJANA KELAVNI MANDAL VADGAM MANAGED DIPLOMA IN HEALTH AND SANITARY INSPECTORVADGAM",
  "NOBLE POLYTECHNIC IN ANIMAL HUSBANDRY JUNAGADH",
  "BHARAT EDUCATION TRUST SANCHALIT DIPLOMA IN HEALTH AND SANITARI INSPECTOR",
  "S.N.PATEL INSTITUTE OF TECHNOLOGY (SNPIT), BARDOLI, SURAT",
  "EKLAVYA PERA TECHNICAL COLLEGE DIPLOMA IN HEALTH AND SANITARY INSPECTOR PANOL",
  "EKLAVYA PERA TECHNICAL COLLEGE DIPLOMA IN FIRE AND SAFETY PANOL",
  "RAJVI DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE KODIYAVADA",
  "SHRI DHULIYA VALMABEN DAHYABHAI CHARITABLE TRUST SANCHALIT DIPLOMA IN HEALTH AND SANITARY INSPECTOR KUMMAR",
  "RAJVI DIPLOMA IN FIRE AND SAFETY COLLEGE KODIYAVADA",
  "ARADHANA DIPLOMA HEALTH SANITARY INSPECTOR ",
  "VRUNDAVAN MSC COLLEGE",
  "VRUNDAVAN DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "SHRI M N PATEL DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE",
  "SMT JAYABEN B PATEL POST GRADUATE INSTITUTE OF BUSINESS STUDIES AND RESEARCH",
  "NACHIKETA  DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "NAVKAR DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "Shree Mahalaxmiji Mahila Homeopathic Medical College",
  "SHREE SVT DIPLOMA IN FIRE AND SAFETY COLLEGE UJALESHWAR",
  "POLYTECHNIC IN ANIMAL HUSBANDARY, NAVSARI",
  "College of Fisheries Science",
  "Maniba Bhula Nursing College",
  "CHHOTUBHAI GOPALBHAI PATEL INSTITUTE OF TECHNOLOGY",
  "Bhulabhai Vanmalibhai Patel Institute of Business Management, Computer & Information Technology",
  "Arts College, Ta. Fatepura",
  "PRIZAM DIPLOMA IN HEALTH AND SANITARY INSPECTOR ",
  "SHRI L K PATEL PGDMLT COLLEGE ANDROKHA",
  "SHRI K K PATEL DIPLOMA IN FIRE AND SAFETY COLLEGE ANDROKHA",
  "AKAR DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE MAJARA",
  "NATIONAL ARTS COLLEGE RAH",
  "S I COLLEGE SUKHSAR",
  "Vidyabharati Trust College of Business, Computer Science and Research",
  "Waymade College of Education (English Medium), Vallabh Vidyanagar",
  "R N Patel Ipcowala School of Law and Justice, Vallabh Vidyanagar",
  "NV Patel College of Pure and Applied Sciences, Vallabh Vidyanagar",
  "Madhuben & Bhanubhai Patel Institute of Technology (MBIT)",
  "Institute of Science & Technology for Advanced Studies & Research (ISTAR) Vallabh Vidyanagar",
  "Institute of Language Studies and Applied Social Sciences, (ILSASS), Vallabh Vidyanagar",
  "INDUKAKA IPCOWALA COLLEGE OF PHARMACY, NEW V.V.NAGAR",
  "Govindbhai Jorabhai Patel Institute of Ayurvedic Studies & Research",
  "C V M College of Fine Arts",
  "C.L. Patel Institute of Studies and Research in Renewable Energy",
  "Centre for Studies & Research on Life & Works of Sardar Patel, Vallabh Vidyanagar",
  "Ashok & Rita Patel Institute of Integrated Study & Research in Biotechnology and Allied Sciences, New Vallabh Vidyanagar",
  "POLYTECHNIC IN AGRICULTURE",
  "GUJARAT SCIENCE ARTS AND COMMERCE COLLEGE",
  " DR KIRAN C PATEL MEDICAL COLLEGE AND  RESEARCH INSTITUTE",
  "NEOTECH SCHOOL OF NURSING",
  "MAKTABAH JAFARIYAH POSTGRADUATE COLLEGE OF SCIENCE SEDRANA SQUARE",
  "Shikshan Bharti College of Education",
  "SMT PUSHPABEN M CHAUHAN MSW  COLLEGE KHATAMBA",
  "BHAGWAN MAHAVIR COLLEGE OF NURSING",
  "BHAGWAN MAHAVIR COLLEGE OF PHYSICAL EDUCATION",
  "BHAGWAN MAHAVIR COLLEGE OF HOTEL MANAGEMENT",
  "BHAGWAN MAHAVIR COLLEGE OF LIBREAL ARTS HUMANITIES",
  "BHAGWAN MAHAVIR COLLEGE OF BASIC AND APPLIED SCIENCES",
  "SMT PUSHPABEN M CHAUHAN ARTS COLLEGE KHATAMBA",
  "SHREE SVT ARTS AND COMMERCE COLLEGE UJALESHWAR",
  "SHREE SWAMINARAYAN MSC COLLEGE  VIJAPUR",
  "College of Agriculture , Jabugam",
  "D.LPATEL COLLEGE OF NURSING, HIMATNAGAR",
  "VEERAYATAN POLYTECHNIC (990)",
  "Shree Patel Vidhya Mandir Science College",
  "VIVEKANAND LAW COLLEGE",
  "NAVGUJARAT MSW COLLEGE",
  "SHREE BANASKANTHA KADVA PATIDAR SANSKAR MANDAL P G SCIENCE M SC COLLEGE PALANPUR ",
  "Shree Gopalkrishna Sanskrit Mahavidyalaya, Patan",
  "Post Graduate Institute of Dairy Education and Research ",
  "NAVGUJARAT LAW COLLEGE",
  "Smt. Savitaben Panalal Kothari College of Secondary Education (English Medium)",
  "Bhulabhai Vanmalibhai Patel Institute of Technology(D.S),Umrakh 656",
  "Vatsalya Institute of Nursing ",
  "Asia Pacific BCA college",
  "C U SHAH INSTITUTE OF SCIENCE",
  "Dr N D Desai Faculty of Medical Science and Research",
  "MK INSTITUTE OF SECONDARY TEACHER EDUCATION BED  PATAN",
  "KALOL INSTITUTE OF COMPUTER STUDIES",
  "OSWAL ARTS AND COMMARCE COLLEGE",
  "KAMESHWAR BCA COLLEGE",
  "KAMESHWAR SCIENCE COLLEGE",
  "KHYATI COLLEGE OF PHARMACY",
  "SMT  V M CHANDERA COMMERCE COLLEGE DIVRANA DHAR",
  "CHRIST COLLEGE OF NURSING RAJKOT",
  "Swami Vivekananda College of Arts Palitana",
  "Parekh Commerce College ",
  "Shree Ravikumar Parbatbhai Chavda Mahila Arts College",
  "Vrundavan Commerce College",
  "Institute of Journalism and Communication",
  "PRESIDENT INSTITUTE OF COMPUTER APPLICATION",
  "SHREE ADARSH SCIENCE COLLEGE BHABHAR",
  "MUNI SEVA ASHRAM COLLEGE OF NURSING",
  "Bharatiya Chaturdham Vedbhavan Vidyalaya, Dwarka",
  "GEETANJALI INSTITUTE OF EDUCATION",
  "SMT V V SHAH M Sc (CA and IT) INSTITUTE COLLEGE, MODASA",
  "SHRI BAYAD KELAVANI MANDAL SANACHALIT BED COLLEGE",
  "GOVERNMENT ARTS COLLEGE, KALYANPUR",
  "PARUL INSTITUTE OF PUBLIC HEALTH",
  "SODHA INSTITUTE OF NURSING",
  "Mahatma Gandhi College of Nursing",
  "Shree Kaljibhai R Katara Arts College Shamlaji",
  "BHARGAVA HOMOEOPATHIC MEDICAL COLLEGE",
  "Aspee Shakilam Biotechnology Institute",
  "AHMEDABAD INSTITUTE OF TECH, AHMEDABAD  002",
  "B.H.GARDI COLLEGE OF ENGG. & TECHNOLOGY , RAJKOT 004",
  "Lukhdhirji Engineering College(Diploma), Morbi-634",
  "VEERAYATAN INSTITUTE OF ENGINEERING (092)",
  "Smt. Z. S. Patel College of Computer Application",
  " SHAMA COLLEGE OF NURSING, AHMEDABAD",
  "Government Arts College, Garbada",
  "GOKUL SCIENCE AND COMMERCE COLLEGE",
  "Gokul Physiotherapy college",
  "GOKUL NURSING COLLEGE",
  "GOKUL LAW COLLEGE ",
  "GOVERNMENT ARTS COLLEGE BHABHAR (BANASKANTHA)",
  "Shree J S Parmar PGDCA Study Center, Kodinar",
  "Mahavir M.Ed. College",
  "Department of Design, Nirma Univertsity",
  "Gandhinagar Homeopathic Medical College",
  "JG INSTITUTE OF LAW",
  "APOLLO LAW COLLEGE",
  "ITM (SLS) BARODA UNIVERSITY- SCHOOL OF ARCHITECTURE, ART & DESIGN",
  "ITM (SLS) BARODA UNIVERSITY- SCHOOL OF BUSINESS",
  "KALAJIBHAI R KATARA NURSING COLLEGE",
  "KHYATI SCHOOL OF ENGINEERING",
  "TAKSHASHILA INSTITUTE OF SCIENCE",
  "DEVRAJ INSTITUTE OF SOCIAL WORK",
  "DEVRAJ SCIENCE COLLEGE",
  "NAVSARJAN INSTITUTE OF MSW COLLEGE",
  "KIRAN NURSING COLLEGE",
  "OM COLLEGE OF B.B.A.",
  "SHRI PAREKH SCIENCE COLLEGE",
  "Devang Patel Institute of Advance Technology and Research",
  "SHREE DINESHBHAI SHAMJIBHAI RAVANI SCIENCE COLLEGE",
  "Institute of Behavioural Science",
  "INSTITUTE OF FORENSIC SCIENCE",
  "Institute of Research and Development",
  "Gyanmanjari Science College,Bhavnagar",
  "SHREE R.S.KANDORIYA SCIENCE COLLEGE - NANDANA",
  "Avkar Education and Charitable Trust S.V.Science College,Una",
  "SHRI MANAVADAR KELAVANI MANDAL,J.M.PANERA SCIENCE COLLEGE-MANAVADAR",
  "Dr. SUBHASH SCIENCE COLLEGE",
  "Nirja Education Trust Sanchalit B.Ed and M.Ed College, Lunawada ",
  "Space Application Centre, ISRO",
  "Shri L. D. Bharatiya Sanskruti Vidya Mandir",
  "Maharshi Academy of Vedic Science",
  "AMRUT INSTITUTE JUNAGARGH (BCA COLLEGE)",
  "Shri T. S. Patel M. S. W college , Ambaliyara",
  "SHREE D.D. KOTIYAWALA MUNI. LAW COLLEGE, PORBANDAR",
  "SHREE K.M. SAVJANI & SMT. K.K. SAVJANI B.B.A./B.C.A. COLLEGE,  VERAVAL",
  "SHRI KARMYOGI ARTS, COMMERCE AND B.R.S.COLLEGE - GADU (SHERBAUG)",
  "SHRI SAHJANAND SCIENCE COLLEGE ",
  "SHREE DHANVANTARY COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "SOMNATH COMMERCE COLLEGE",
  "SHREE KARMYOG COMMERCE COLLEGE",
  "SHREE B.D.BARAD PHYSIOTHERAPY COLLEGE - KODINAR",
  "SHREE B.D.BARAD B.Sc. COLLEGE - KODINAR",
  "SAURABH LAW COLLEGE - VISANVEL ",
  "SHREE SAURABH SCIENCE COLLEGE",
  "LATE U. V. ZALA COMMERCE COLLEGE   ",
  "HARIVANDANA PHYSIOTHERAPY COLLEGE",
  "DIVYACHETANA BRS COLLEGE ",
  "J R KATARA ARTS COLLEGE SUKHSAR ",
  "VIVEKANAND INSTITUTE OF MANAGEMENT",
  "SHREE SWAMINARAYAN ARTS AND COMMERCE COLLEGE  VIJAPUR",
  "SHRI M.P.PATEL B.Ed. & SCIENCE COLLEGE, Morbi",
  "R.K DESAI SCIENCE COLLEGE",
  "NAVODAY DIPLOMA IN FIRE AND SAFETY",
  "NGES DIPLOMA IN HEALTH AND SANITARY COLLEGE",
  "GLOBAL DIPLOMA IN MEDICAL LAB TECHNICIAN COLLEGE",
  "NOOTAN VINAY MANDIR DIPLOMA IN HEALTH SANITARY INSPECTOR COLLEGE PATAN",
  "JYOTI PRAKASH DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE",
  "SHREE A S PATEL BCA COLLEGE",
  "D L PATEL SCIENCE COLLEGE",
  "SHRI K K PATEL DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE ANDROKHA",
  "ASIAN BCA COLLEGE VADALI",
  "Department of Computer Application, Sankalchand Patel College of Engineering",
  "Kapadia N. M. M. S. Arts & The S. N. S. B. Commerce College",
  "Anjuman B. Ed. College",
  "K. C. Sheth Arts College",
  "SHRI V. M. MEHTA INSTITUTE OF AYURVEDA",
  "SMT S B PATEL INSTITUTE OF BUSINESS MANAGEMENT",
  "SHRI C J PATEL COLLEGE OF COMPUTER STUDIES",
  "Narsinhbhai Patel Dental College & Hospital",
  "Shree Sarvoday Education Foundation Trust Managed Law College.(kant) Deesa",
  "D L PATEL COMMERCE COLLEGE",
  "PARUL INSTITUTE OF COMPUTER APPLICATION",
  "School of Arts",
  "School of Commerce",
  "H.H.PATEL COLLEGE OF EDUCATION FOR WOMEN",
  " EVA COLLEGE OF AYURVEDA",
  "NEOTECH INSTITUTE OF PHYSIOTHERAPY",
  "M.M.SCIENCE COLLEGE, MORBI",
  "GOVERNMENT SCIENCE COLLEGE, THARAD",
  "Maharavshri Lakhpatji Government Arts and Commerce College - Lakhpat",
  "Institute of Commerce, Nirma University",
  "EKTA B.Sc. NURSING COLLEGE",
  "Faculty of Performing Arts",
  "MARWADI EDUCATION FOUNDATIONS GROUP OF INSTITUTIONS-FACULTY OF TECHNOLOGY, RAJKOT",
  "MARWADI EDUCATION FOUNDATIONS GROUP OF INSTITUTIONS - FACULTY OF ARCHITECTURE",
  "PARUL INSTITUTE OF LAW",
  "MAHARSHI DAYANAND SCIENCE COLLEGE BASPA",
  "SHETH SHREE MOHANLAL CHATURBHUJ AGARWAL SCIENCE COLLEGE NARODA (CTM WALA)",
  "D L Patel Institute of Management & Technology  BCA & PGDCA  College",
  "SWAMI SAHAJANAND INSTITUTE OF COMMERCE",
  "DIPLOMA IN HEALTH SANITARY INSPECTOR COLLEGE   RADHANPUR",
  "SHREE BAVISHI PRAJAPATI PRAGATI MANDAL VADGAM CONDUCTED DIPLOMA IN HEALTH AND SANITARY INSECTOR COLLEGE VADGAM",
  "SMT KUSUMBEN DAMOR MSW COLLEGE SANTRAMPUR",
  "SHRI T S PATEL DIPLOMA IN FIRE AND SAFETY COLLEGE AMBALIYARA",
  "SHRI T S PATEL DIPLOMA IN HEALTH SANITARY INSPECTOR COLLEGE AMBALIYARA",
  "SHRI T S PATEL BSC NURSING COLLEGE AMBALIYARA",
  "GRAVITY BRS COLLEGE KHEDBRAHMA",
  "GRAVITY MSW COLLEGE KHEDBRAHMA",
  "GRAVITY DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE KHEDBRAHMA",
  "NAVYUG INSTITUTE OF NURSING",
  "Government Arts and Science College, Bavla",
  "PRIME INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "SARDAR PATEL KELVANI MANDAL MAHILA B.ED.COLLEGE JETPUR",
  "CHIMANBHAI PATEL COLLEGE",
  "School of Business Studies, RK University, Rajkot",
  "LOKMANYA PHARMACY COLLEGE",
  "SHREE SWAMINARAYAN INSTITUTE OF PHARMACY AND RESEARCH",
  "SWARRNIM INSTITUTE OF LAW ",
  "SHREE TIRUPATI BALAJI ARTS  COMMERCE COLLEGE PANTHAWADA",
  "F. D. Science College for Women",
  "SIGMA INSTITUTE OF SCIENCE  COMMERCE",
  "SMT.U.L.D. MAHILA COLLEGE-GONDAL",
  "SMT VASANTBEN N VYAS HOMOEOPATHIC MEDICAL COLLEGE-AMRELI",
  "AMC MET Nursing College, Ahmedabad",
  "SARDAR EDU TRUST SANCHALIT BED COLLEGE",
  "R.V.Solanki B.B.A College, Kushki(Idar)",
  "SHREE SWAMINARAYAN PHYSIOTHERAPY COLLEGE",
  "GCS COLLEGE OF NURSING",
  "NOOTAN VINAY MANDIR MSW COLLEGE, PATAN",
  "SAL ENGINEERING AND TECHNICAL INSTITUTE 126",
  "SHREE NAVJIVAN BED COLLEGE",
  "BALAJI PHARMACY INSTITUTE",
  "Shri D K PATEL (Bhura) MED COLLEGE, Takhatpur",
  "BED COLLEGE THAKHATPUR",
  "L J SCHOOL OF LAW",
  "JAYVANTRAI HARRAI DESAI POLYTECHNIC, PALSANA 686",
  "Tatva Institute of Technological Studies, Modasa 090",
  "ARTS & COMMERCE COLLEGE DEVGADH",
  "TATVA INSTITUTE OF TECHNOLOGICAL STUDIES-689",
  "Shri H.L. Patel Arts & Commerce College - Bhayavadar",
  "Shri Trikamjibhai Chatwani Arts & J V Gokal Trust Commerce College, Radhanpur",
  "Smt. R. R. H. Patel MAHILA ARTS COLLEGE VIJAPUR",
  "Government Polytechnic Junagadh 619",
  "DR. S. & S. S. GHANDHY GOVERNMENT ENGINEERING COLLEGE, SURAT 023",
  "Maa Ashapura College of Education",
  "JOYANANDA COLLEGE OF EDUCATION, JAMANGAR",
  "KALOL TALUKA KELAVANI MANDAL LAW COLLEGE",
  "COLLEGE OF DENTAL SCIENCE AND HOSPITAL",
  "Sardar Patel Institute of Economics & Social Research",
  "ARUN BALCHAND VORA M.ED. COLLEGE, RADHANPUR",
  "Shree Bharatimaiya College of Optometry and Physiotherapy",
  "APOLLO INSTITUTE OF ENGINEERING AND TECHNOLOGY 121",
  "JETHIBA K. PATEL ARTS COLLEGE & B.A. PATEL & D. B. VYAS COMMERCE COLLEGE ",
  "SMT VMCHANDERA ARTS COLLEGE DIVARANA DHAR",
  "SCIENCE COLLEGE ANDROKHA",
  "C. K. PITHAWALLA COLLEGE OF COMMERCE – MANAGEMENT - COMPUTER APPLICATION",
  "Physiotheraphy College for Visually Impaired",
  "Bapubhai Desaibhai Patel Institute of Paramedical Sciences",
  "Sant Stifan Institute of Business Management and Technology",
  "Sanjaybhai Rajguru College of Engineering,036",
  "J.K.sarvaiya college",
  "Smt. Champaben Vasantbhai  Gajera Pharmacy Mahila College, AMRELI 251 ",
  "Smt. Shantaben Haribhai Gajera MBA Mahila College 760 ",
  "D L PATEL INSTITUTE OF MANAGEMENT BBA COLLEGE, HIMATNAGAR",
  "SHRI SAMANVAY INSTITUTE OF B B A",
  "SMT MANJULABEN ARVINDBHAI TEJANI ARTS COLLEGE - MAHILA COLLEGE, EDUCATIONAL CAMPUS",
  "SMT SAVITABEN RAMESHBHAI VAGHANI COMMERCE COLLEGE -MAHILA COLLEGE, EDUCATIONAL CAMPUS",
  "SHREE SAHJANAND INSTITUTE OF PHYSIOTHERAPY AKVADA, GOHOGHA ROAD",
  "MATUSHRI RAMUBA TEJANI AND MATUSHRI SHANTABEN VIDIA SCIENCE COLLEGE , SARDAR PATEL INSTITUTE, KALIYA BID",
  "NEOTECH INSTITUTE OF TECHNOLOGY-117",
  "SHIVAM INSTITUTE OF MANAGEMENT, VALASAN-829",
  "SHIVAM INSTITUTE OF COMPUTER TECHNOLOGY, VALASAN-572",
  "IPCOWALA INSTITUTE OF ENGINEERING AND TECHNOLOGY-951",
  "L J SCHOOL OF ARCHITECTURE, OPP DIVYABHASKAR PRESS, S G HIGHWAY-354",
  "GOVERNMENT MCA COLLEGE, MANINAGAR-569",
  "Institute of Architecture & Planning, Nirma University",
  "VIDHYASAGAR MED COLLEGE, DANODARDA",
  "COLLEGE OF EDUCATION, DANODARDA",
  "VICTORIA JUBILEE COLLEGE OF NURSING",
  "SHRI SATSANGI SAKETDHAM RAM ASRAM GROUP OF INSTITUTIONS 690",
  "ARRDEKTA INSTITUTE OF TECHNOLOGY-696",
  "K J INSTITUTE OF ENGINEERING AND TECHNOLOGY-957",
  "HJD INSTITUTE OF TECHNICAL EDUCATION AND RESEARCH-968",
  "REVABA SARVAJANIK EDUCATION COLLEGE",
  "S S Agrawal College of Commerce and Management, Navsari",
  "RMS Polytechnic 642",
  "Ambaba Commerce College, Maniba Institute of Business Management & Deviba Institute of Computer Application",
  "Asia Pacific Institute of Business Administration",
  "K. B. Sumaria Commerce and Natraj Professional Science College",
  "SHRI SARASWATI ARTS COLLEGE GIRGADHADA",
  "DR THAKORBHAI PATEL GIRLS BCA COLLEGE",
  "Vartantu Sanskrit Mahavidyalaya, Sola",
  "Shree Sarayu Ramanand Sanskrit Mahavidyalaya, Ahmedabad",
  "LAXMI INSTITUTE OF TECHNOLOGY, SARIGAM (2ND SHIFT), 691",
  "D A DEGREE ENGINEERING COLLEGE 118",
  "Shri S. G. Rao College of Teacher Education",
  "Government Science College, Vankal, Mangrol, Surat",
  "V.C.T. Mahila Arts & Commerce College, Bharuch",
  "Welfare Institute of Nursing & Midwifery, Bharuch",
  "R. K. Desai College of Commerce & Management",
  "Satyam College of Education",
  "R. K. Desai Achchhariwala College of Computer and Applied Sciences",
  "Naranlala College of Professional & Applied Science",
  "Naranlala College of Commerce and Management",
  "GOVERNMENT POLYTECHNIC, NAVSARI 975",
  "SHREE VASUDEVBHAI AND KANTILAL PATEL INSTITUTE OF ENGINEERING 971",
  "S.S.Agrawal Institute of Management & Technology-Navsari-(SFI) 806 ",
  "Param Institute of Management & Research(SFI) .Lakhabavad Road-Jamnagar. 801 ",
  "SHRI J M SABVA INSTITUTE OF ENGINEERING & TECHNOLOGY, BOTAD 107",
  "Shri B. M. Shah College Of Pharmacy (Diploma), Modasa 415 ",
  "Government Polytechnic,Chotta Udepur 622",
  "R.N.G. Patel Institute of Technology, Bardoli ",
  "Government Polytechnic,Bhuj 621",
  "Government Polytechnic Rajkot 620",
  "Government Polytechnic Ahmedabad 617 ",
  "Tolani Institute Of Pharmacy (Diploma), Adipur 417",
  "M. N. College Of Pharmacy (Diploma), Khambhat 409",
  "Samaldas Arts College",
  "FACULTY OF ENGG., GROW MORE FOUNDATION GROUP OF INSTITUTIONS, BERNA, HIMMATNAGAR 056 ",
  "Sahajanand College of IT and Managment - Gondal",
  "MAHARANI PREMKUMARI COLLEGE OF SOCIAL SCIENCES",
  "Dr Virambhai Rajabhai Godhaniya IT College",
  "SCIENCE AND COMMERCE COLLEGE, TARSADI, KOSAMBA (R.S.)",
  "Balaji College of Nursing ",
  "NARNARAYAN SHASTRI INSTITUTE OF NURSING",
  "Narsinhbhai College of Computer Studies and Management",
  "SHRI GOPALBHAI P. DHANKA MSW COLLEGE, NAGARALA.",
  "Ganpat University A. M. Patel Institute of Computer Studies",
  "Ganpat University U.V. Patel College of Engineering",
  "Ganpat University S.K. Patel College of Pharmaceutical Education & Research",
  "Ganpat University V.M. Patel Institute of Management",
  "SHRI D.V.RAVAL ARTS & COMM. COLLEGE-HALVAD",
  "GOVERNMENT POLYTECHNIC, VYARA 974",
  "Ganpat University Institute of Computer Technology",
  "Ganpat University Institute of Architecture",
  "GLS School of Management",
  "G. N. Patel College of Dairy Science",
  "SOORAJBA COLLEGE OF EDUCATION",
  "HVHP Institute of Post Graduate Studies and Research",
  "Hiren Popatlal Patel Post Graduate Institute of Commerce",
  "Chanchalben Mafatlal Patel College of Physiotherapy",
  "Shri Alpesh N. Patel Post Graduate Institute of Science and Research,Anand",
  "Loknad B. Ed. College",
  "SHRI K.P.SHAH LAW COLLEGE, JAMNAGAR",
  "Kavishri Botadkar Arts and Commerce College",
  "Government Arts And Commerce College, Vanthali (Sorath)",
  "SMT. V.B. NANDOLA B.ED. COLLEGE, BHACHA TA.UNA",
  "Ganpat University - Kumud & Bhupesh Institute of Nursing",
  "MATRUSHRI VRUJKUVERBEN MANGANLAL MEHTA COMPUTER SCIENCE AND MANAGEMENT COLLEGE, VAKANER",
  "SABAR SAMAJSEVA MAHAVIDHYALAY MSW COLLEGE, SONASAN",
  "SMT. MANIBA MAHILA B.ED COLLEGE",
  "THE MANDVI EDUCATION SOCIETY INSTITUTE OF COMPUTER STUDIES (563)",
  "College of Renewable Energy & Environmental Engineering",
  "VIDUSH SOMANY INSTITUTE OF TECHNOLOGY AND RESEARCH",
  "COLLEGE OF ARCHITECTURE, SVIT, VASAD",
  "SHREE SWAMINARAYAN MAHAVIDHYALAYA B COM MAHILA COLLEGE",
  "Shri Mansukhbhai  J. Medani B.B.A. College, Kalol",
  "SHARDA NURSING COLLEGE, PANSAR",
  "SHANTINIKETAN NURSING COLLEGE",
  "AHMEDABAD DENTAL COLLEGE, RANCHARADA",
  "GOENKA RESEARCH INSTITUTE OF DENTAL SCIENCES",
  "G M E R S MEDICAL COLLEGE, GANDHINAGAR",
  "DR B R AMBEDKAR COLLEGE OF NURSING",
  "C. B. Patel Computer College & Jamanaben Narottambhai Motiram Patel Science College",
  "B Jamnadas Patel College of Nursing and Chaturbhai Revabhai Patel School of Nursing GNM",
  "SHREY INSTITUE OF NURSING AND ALLIED SCIENCES",
  "SARDAR PATEL M ED COLLEGE",
  "SARDAR PATEL B ED COLLEGE (FOR WOMEN)",
  "G M E R S MEDICAL COLLEGE, AHMEDABAD",
  "MAHDI MAHILA COMMERCE COLLEGE",
  "SWAMI SAHAJANAND COLLEGE OF COMPUTER SCIENCE",
  "SMT LAXMIBEN PREMJIBHAI SAVANI SATUABABA B C A COLLEGE",
  "NAND KUNVARBA MAHILA B B A COLLEGE",
  "SMT KAMLABEN SHANTILAL KAPASHI B C A COLLEGE",
  "COLLEGE OF AGRICULTURE, BHARUCH",
  "SHRI MUKESHKUMAR MAGANLAL DOSHI ARTS AND COMMERCE COLLEGE",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, GANDHINAGAR",
  "Shri D N Institute of Computer Applications, Anand",
  "SHRI P M PATEL INSTITUTE OF PG STUDIES AND RESEARCH IN APPLIED SCIENCE, ANAND",
  "SHRI BHIKHABHAI PATEL INSTITUTE OF P G STUDIES AND RESEARCH IN HUMANITIES, ANAND",
  "SHRI D N INSTITUTE BUSINESS ADMINISTRATION, ANAND",
  "School of Arts and Sciences",
  "SHREE SWAMINARAYAN INSTITUTE OF DESIGN AND COMMUNICATION",
  "Shri Chunilal Himmatbhai Bhil Government Arts & Commerce, Naswadi",
  "VEERAYATAN INSTITUTE OF ENGINEERING (697)",
  "Ganpat University-Center for Applied Sciences and Technology",
  "COLLEGE OF COMPUTER STUDIES MSCIT VADU",
  "ARIHANT SCHOOL OF PHARMACY, UVARSAD  208",
  "Shri I. K. Chavda  Gram Vidhyapith",
  "NATIONAL SCHOOL OF INTERIOR DESIGN-RAJKOT",
  "Shri Swaminarayan Manav Seva Trust's",
  "Smt. N.C. Gandhi & B.V. Gandhi Mahila Arts & Commerce College",
  "SABAR GRAM SEVA MAHA VIDHYALAYA",
  "EXPERIMENTAL COLLEGE OF EDUCATION",
  "GOVT ARTS & COMMERCE COLLEGE, SAMI",
  "Shree M.L.Kakadiya MCA Mahila College Amreli",
  "GIDC RAJJU SHROFF ROFEL INSTITUTE OF MANAGEMENT STUDIES (B.B.A. Programme) & ROFEL SHRI G. M. BILAKHIA COLLEGE OF APPLIED SCIENCES (B.C.A. Programme) Vapi",
  "SILVER OAK COLLEGE OF ENGINEERING  & TECHNOLOGY",
  "R G BAROT COLLEGE EDUCATION",
  "MSW COLLEGE  BHILODA",
  "Faculty of Business Administration",
  "Chanakya College of Physiotherapy",
  "NOBLE ARTS COLLEGE",
  "Ganpat University Mehsana Urban Institute of Sciences",
  "Ganpat University Institute of Technology",
  "INFOSYS PGDCA STUDY CENTER, VANSDA",
  "PARUL INSTITUTE OF ARCHITECTURE AND RESEARCH",
  "SMT. LILAVATIBEN MANILAL SHAH SCIENCE COLLEGE RADHANPUR",
  "LALITABEN RAMNIKLAL SHAH HOMOEOPATHY COLLEGE",
  "PRABHABEN PATEL BED COLLEGE",
  "Government Arts & Science College, Dediapada",
  "Institute for Plasma Research (IPR),Gandhinagar",
  "DHRUV-RUTVIJ COLLEGE OF EDUCATION",
  "AARIHANT AYURVEDIC MEDICAL COLLEGE AND RESEARCH INSTITUTE",
  "Shree Ambaji Commerce College",
  "BAPS Swaminarayan Sanskrit Mahavidyalay, Sarangpur",
  "Anandbawa Vedant Sanskrit Mahavidyalaya, Dhorivav",
  "JEEL GOSWAMI COLLEGE OF SCIENCE AND RESEARCH",
  "Shri S. R. Patel B. Ed. College",
  "G.V.VAGHELA ARTS & COMMERCE COLLEGE VAKHA (DEODAR)",
  "Shree Babdeshwar Sanskrit Mahavidyalaya, Porbandar",
  "ELECTRONICS AND MECHANICAL ENGINEERING SCHOOL",
  "PARUL INSTITUTE OF HOMOEOPATHY AND RESEARCH",
  "Bhagwan Yagyavalkya Ved Sanskrit Mahavidyalaya, Mudeti",
  "Faculty of Computer Applications and  IT",
  "Shri Maharaja Rajendrasinhji Arts & Science College, Rajpipla",
  "SHREE AMBAJI ARTS COLLEGE",
  "Shri C. P. Degree College for Physical Education, Nandod",
  "Mahamandleshwar Shri Krishnandji Law College, Bharuch",
  "Shri Jayendrapuri Arts & Science College, Bharuch",
  "Shri S. G. Patel Arts & Shri P. K. Desai Commerce College, Nizar",
  "Shri R. K. Parikh Arts & Science College",
  "Hari Jyot College of Optometry",
  "B. K. M. Science College",
  "V. T. Choksi Sarvajanik Law College",
  "Shah N. H. Commerce College",
  "Shri Uttar Gujarat B. C. A. College",
  "Bachelor of Education College",
  "Shah Khimchandbhai Muljibhai Law College",
  "ASIAN INSTITUTE OF TECHNOLOGY, VADALI",
  "S B GARDI BED COLLEGE, DHROL",
  "Smt. Bhanumati Vrujlal Dhanak Arts, Commerce, Science & Management College - Bagasara",
  "COLLEGE OF AGRICULTURE, AMRELI",
  "POLYTECHNIC IN AGRICULTURAL ENGINEERING, TARGHADIA",
  "Shri J S Bhakta and Shri K M Bhakta Arts and Shri A N Shah Science and Shri N F Shah Commerce College",
  "Dada Dukhayal College of Education",
  "Institute of Management, Nirma University",
  "S S AGRAWAL INSTITUTE OF ENGINEERING AND TECHNOLOGY 123",
  "Institute of Technology, Nirma University",
  "Vivekanand College of Commerce",
  "NARNARAYAN SHASTRI INSTITUTE OF TECHNOLOGY, INSTITUTE OF FORENSIC SCIENCES AND CYBER SECURITY",
  "SMT. M V PATEL BED COLLEGE RANASAN",
  "SHREE SHARDA BBA AND BCA COLLEGE",
  "B A DANGAR NURSING COLLEGE",
  "SHIDDHESHWAR HANUMANJI AYURVED COLLEGE",
  "Dr.H R Gajwani College of Education",
  "SHRI ADARSH BCA COLLEGE, RADHANPUR",
  "Smt. R. P. Chauhan Arts & Smt. J. K. Shah & Shri K. D. Shah Commerce College & K. R. P. Darji Indoamerican Institute of Computer Science",
  "IQRA B. C. A. College",
  "PIONEER SANITARY INSPECTOR COLLEGE VIRPUR",
  "Mahila Mahavidyalaya",
  "SHRI J R DESAI SCHOOL OF NURSING",
  "A.P.M.C. COLLEGE OF PHARMACEUTICAL EDUCATION AND RESEARCH, HIMATNAGAR  207",
  "SHREE H.N.SHUKLA INSTITUTE OF PHARMACEUTICAL EDUCATION & RESEARCH, RAJKOT 250 ",
  "SAMARTH COLLEGE OF COMPUTER APPLICATION HAJIPUR, HIMATNAGAR 556 ",
  "SHAYONA INSTITUTE OF BUSINESS MANAGEMENT, AHMEDABAD 820",
  "Ahmedabad Institute Of Technology Gota, Ahmedabad (SFI)  701 ",
  "SMT C K PATEL MSC(CA&IT) COLLEGE NANIKADI",
  "VEDANT SCIENCE COLLEGE",
  "GITANJALI INSTITUTE OF MANAGEMENT STUDIES, RAJKOT 766",
  "GROWMORE INSTITUTE OF COMMERCE AND ARTS COLLEGE, BERNA",
  "School of Physiotherapy, RK University, Rajkot",
  "Pragjibapa M.S.W. College, Virpur",
  "GURJAR BHARATI B ED COLLEGE",
  "Shree J. L. K. Kotecha Arts & S. H. Gardi Commerce College",
  "MOTHER TERESA COLLEGE OF NURSING, GOTHVA",
  "SHRI SARVAJANIK BCA AND PGDCA COLLEGE, MEHSANA",
  "SHRI SARVAJANIK MSW COLLEGE, MEHSANA",
  "Shikshan Mahavidyalaya (College of Education), Ahmedabad",
  "RASHTRIYA SHAYAR JHAVERCHAND MEGHANI ARTS COLLEGE",
  "SHRI K V RAMANI MAHILA ARTS, COMMERCE COLLEGE, ATKOT",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE, JAFRABAD",
  "GOVERNMENT COMMERCE COLLEGE, JAMNAGAR",
  "P D U HOSPITAL GOVERNMENT COLLEGE OF NURSING, RAJKOT",
  "ASIA PACIFIC INSTITUTE OF HOTEL MANAGEMENT, AHMEDABAD 105",
  "Amrut Institute Junagadh-685",
  "Smt.V.D.Thacker College of Education",
  "The Mandvi Education Society Institute of Business Management and Computer Studies,Mandvi,(812)Di-Surat(SFI)",
  "P.D.U.MEDICAL COLLEGE, RAJKOT",
  "AKSHAR-PREET INSTITUTE OF PHARMACY, JAMNAGAR  203 ",
  "B. H. Gardi College of Engineering & Technology (SFI)-Rajkot 503 ",
  "L.J.Polytechnic,Ahmedabad 633",
  "Image Engg. And Technology Institute, Kheda 683",
  "Sardar Patel College of Administration & Management (SPCAM) - MBA (SFI),Bakrol,Anand. 755",
  "Shri Jaysukhlal Vadhar Institute of Management Studies Shri Bipin T. Vadhar College of Management (JVIMS) (SFI)-Jamnagar 770",
  "Shree Swaminarayan Institute of Management & I.T.Porbandar.(SFI) 810 ",
  "VALIA POLYTECHNIC COLLEGE 688",
  "Mahadev Desai Gram Seva Mahavidyalaya (For Girls), Randheja",
  "Navyug Commerce College, Chorasi",
  "S S PATEL COLLEGE OF EDUCATION",
  "B P COLLEGE OF BUSINESS ADMINISTRATION",
  "Shri Umiya College of Education",
  "Bhagwat Vidyapith Trust Sanchalit Shikshashastri (B.Ed.) Mahavidyalaya, Sola",
  "Swami Gansyam Jivandasji Institute of Management and IT",
  "Tolani Commerce College",
  "Veerayatan Institute of Computer Application & Business Administration",
  "Shri J.B.Thacker Commerce College",
  "Sheth Dosabhai Lalchand Law College",
  "Tolani Institute of Commerce",
  "Muktajivan Swamibapa Mahila Arts & Commerce College",
  "Government Arts College, Maninagar",
  "G.M.D.C. Sponsored - Manibhai Valji Ramani & Manilal Punjabhai Ramani  Arts College & Ratanshibhai Khimjibhai Khetani Commerce College,",
  "Sheth R.D.Education Trust Sanchalit Arts & Commerce College",
  "Patel Group of Institutions (SFI)  Village-Moti Dau,Tal-Di:Mehsana 548",
  "B and B Institute of Technology,Vallabh Vidhyanagar (SFI) 605",
  "T.F.Gandhidham Polytechnic,Adipur(Kutch)",
  "SHRI MATRU MANDIR  B.S.W. COLLEGE RAJKOT",
  "M D College of Education",
  "Sheth S.V. Arts & Commerce College",
  "SRK Institute Of Social Science",
  "Sanskar Institute of Management  & Information Technology",
  "Shri H B Palan Arts & Commerce College",
  "GOVERNMENT ARTS COLLEGE, DHANPUR",
  "DRASHTI NETRALAY",
  "GURJAR BHARTI INSTITUTE OF SANITARY INSPECTOR COLLEGE, NAGARALA",
  "Sad Guru B. Ed. College",
  "Jay Jalaram Homoeopathic Medical College & Hospital",
  "S. D. Arts & B. R. Commerce College",
  "Smt. R. B. Patel Arts & Commerce College",
  "Shri P. H. Goswami Municipal Arts & Science College",
  "S. L. U. Arts & H. P. T. Commerce College for Women",
  "B. V. D. Arts and Commerce College",
  "St. Xavier's College",
  "M. B. Patel Rashtrabhasha Vinayan Aur Vanijya Mahavidyalaya",
  "Kheda Arts and Commerce College",
  "Saraspur Arts & Commerce College",
  "Desai C. M. Arts & Commerce College",
  "N. M. Zala & G. N. Zala Arts & Commerce College",
  "Government Arts & Commerce College, Ahwa",
  "Shri Sahajanand Arts & Commerce College",
  "Smt. R. D. Shah Arts & Smt. V. D. Shah Commerce College",
  "Uma Arts & Nathiba Commerce Mahila College",
  "Shri K. K. Arts and Commerce College",
  "R. H. Patel Arts & Comm. College",
  "F. D. Arts & Commerce College for Women",
  "M. P. Arts & M. H. Commerce College for Women",
  "Ahmedabad Arts and Commerce College",
  "M. B. Commerce and G. M. N. Arts College",
  "Smt. A. P. Patel Arts & Late Shri N. P. Patel Commerce College",
  "H.R.SHAH MAHILA ARTS AND COMMERCE COLLEGE,NAVSARI",
  "Varahi Education College",
  "Shah K. S. Arts and V. M. Parekh Commerce College",
  "Sheth R. A. College of Arts and Commerce",
  "Pioneer Nursing College",
  "Shri S. D. Patel Arts & C. M. Patel Commerce College",
  "Smt. S. B. Patel Arts & Shri R. N. Amin Com. College",
  "Shri D. M. Patel Arts & Shri S. S. Patel Commerce College",
  "C. N. P. F. Arts & D. N. Science College",
  "Aakar Adhyapan Mandir M. Ed. College",
  "Hillwoods Academy of Teacher Education (English Medium)",
  "Shri Gayatri College of Education",
  "Shri M. R. Amin B. Ed. College",
  "Umiya B. Ed. College",
  "T.N.RAO INSTITUTE OF MANAGEMENT RESEARCH & TECHNOLOGY & B.ED.COLLEGE-RAJKOT",
  "K.A.PANDHI LAW COLLEGE-RAJKOT",
  "R.P.BHALODIYA COMMERCE, MANAGEMTNT & COMPUTER COLLEGE-RAJKOT",
  "N.H.RADADIYA ARTS & COMMERCE COLLEGE-JAMKANDORANA",
  "SOMANTH B.ED. COLLEGE-KODINAR",
  "BAHAUDDIN GOVT. ARTS COLLEGE JUNAGADH",
  "R.O.PATEL MAHILA  COLLEGE-MORBI",
  "NAVYUG B.ED. COLLEGE-VIRPAR(MORBI)",
  "TAKSHASHILA B.ED. COLLEGE-HALVAD",
  "SHRI SARVODAY COLLEGE OF COMPUTER SCIENCE,-RAJKOT",
  "M.J.GAJERA B.ED.MAHILA COLLEGE-AMRELI",
  "MUNI.MAHILA ARTS & COMM. & HOMESCI COLLEGE, GONDAL",
  "S.S.P.JAIN ARTS & COMM.COLLEGE-NARSHIPARA, DHANGADHRA",
  "BAPA SITARAM SEVA TRUST ARTS COLLEGE, RAJULA",
  "SMT. J.A. PATEL MAHILA COLLEGE, MORBI",
  "CREATION B.S.W. COLLEGE  RAJKOT",
  "SHRI SARASWATI B.ED. COLLEGE-JAMANAGAR",
  "M.T.DHAMSANIYA COMMERCE & B.B.A. COLLEGE-RAJKOT",
  "JUNAGADH KELAVANI MANDAL COMMERCE &  B.B.A. COLLEGE-JUNAGADH",
  "MAHARSHI DAYANAND SCIENCE COLLEGE -PORBANDAR",
  "MA.MONGHIBA MAHILA ARTS & COMM. COLLEGE-MENDARDA",
  "NAVYUG COLLEGE OF EDUCATION, SUKHPUR",
  "SHREE DEVMANI ARTS & COMMERCE COLLEGE-VISAVDAR",
  "SHRI SAURBH ARTS COLLEGE-GDU(JUNAGADH)",
  "JIVANJYOT COLLEGE OF EDUCATION VALAM",
  "SARDAR PATEL  MAHILA BED COLLEGE VADNAGAR",
  "SHRI SARVAJANIK BSW COLLEGE MEHSANA",
  "MSW COLLEGE ANDHROKHA",
  "RATANBA COLLEGE OF EDUCATION RAJENDRANAGAR",
  "SHREE HARI MSC COLLEGE KALYANPURA",
  "SHRI LABHUBHAI TRIVEDI INSTITUTE OF ENGINEERING AND TECHNOLOGY - 954",
  "KICH SCHOOL OF DESIGN",
  "SMT KUSUMBEN KADAKIA INSTITUTE OF COMPUTER APPLICATION",
  "ANANYA COLLEGE OF MEDICINE AND RESEARCH",
  "K D INSTITUTE OF OPTOMETRY",
  "ENGINEERING COLLEGE, TUWA DIPLOMA SECOND SHIFT - 958",
  "ADARSH ARTS AND COMMERCE COLLEGE,TIRTHGAM",
  "SIDDHIVINAYAK BVOC COLLEGE",
  "SWASTIK INSTITUTE OF B VOC",
  "SHREE KRISHNA ARTS COLLEGE LAKHANI",
  "SHRI M N PATEL M SC COLLEGE VIJAYNAGAR",
  "D I PATEL ARTS COLLEGE",
  "ACHIEVER M S W COLLEGE LIMDI    ",
  "Kankrej Taluka Kelvani Mandal managed Shri Sevantilal Amrutlal Surani Vidya Sankul Smt. Kantaben Kirtilal Shah Arts and Smt. Lilavatiben Bapulal Gunjariya Commerce College, At.-Thara, Ta.-Kankrej, Dist.-Banaskantha",
  "SHREE ANAND ARTS COLLEGE, ETA",
  "School of Engineering, RK University, Rajkot",
  "SHREE SARASWATI KANYA KELAVANI MADAL SANCHALIT COLLEGE OF NURSING",
  "INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "PARULBA MSW COLLEGE VIDHYANAGARI HIMATNAGAR",
  "SHRI MANGALAM MSC COLLEGE ",
  "SWAMINARAYAN GURUKUL HOMOEOPATHIC MEDICAL COLLEGE",
  "S S MAHLA NURSING COLLEGE",
  "VIDHYADEEP LAW COLLEGE",
  "VIDHYADEEP INSTITUTE OF COMMERCE",
  "SARVAJANIK COLLEGE OF NURSING MODASA",
  "LATE PARSOTTAMBHAI BECHARBHAI DALSANIA NURSING, UPLETA",
  "DIWALIBEN UKABHAI TARSADIA NURSING COLLEGE",
  "RMS COLLEGE OF NURSING",
  "L J INSTITUTE OF NURSING",
  "VS RAVAL SCIENCE MSC COLLEGE ",
  "TRANSWAD MED COLLEGE",
  "NACHIKETA MSC COLLEGE LADOL",
  "MATRUSHRI PARVATIBEN DAMJIBHAI KHERAJ DHADAVA ARTS AND COMMERCE COLLEGE, LAKADIYA",
  "RK University Ayurvedic College and Hospital",
  "SHREE KHODIYAR COLLEGE OF NURSING",
  "EXPERIMENTAL SCIENCE MSC COLLEGE",
  "SMT SAVITABEN J SABVA SHIKSHAN MAHAVIDYALAYA",
  "JASANI ARTS & COMMERCE COLLEGE-RAJKOT",
  "AKAR MSW COLLEGE MAJRA",
  "GOVERNMENT COMMERCE AND ARTS COLLEGE KHAMBHA    ",
  "ARRDEKTA INSTITUTE OF PGDMLT",
  "Shrimad Rajchandra Institute of Management and Computer Application",
  "SARASWATI COLLGE OF SCIENCE, VIRAVADA",
  "SMT. SARLABEN CHATURBHAI PATEL INSTITUTE OF COMMERCE",
  "V S LAKHANI COLLEGE OF COMPUTER SCIENCE",
  "L.J INSTITUTE OF APPLIED SCIENCES",
  "BHIKHUBHAI VEJANANDBHAI VAROTARIYA ARTS COLLEGE ",
  "Government Arts College, Mandal",
  "SHREE SAHAJANAND COLLEGE OF SCIENCE",
  "Government Arts College, Santalpur",
  "AHMEDABAD SCHOOL OF NURSING NIKOL ROAD AHMEDABAD",
  "SHREE PAREKH ARTS COLLEGE MAHUVA",
  "YADUNANDAN AHIR EDUCATION TRUST SANCHALIT DWARKADHISH COMMERCE COLLEGE ",
  "MONARK HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "MSC COLLEGE PANTHAWADA",
  "SHREE DHANERA TALUKA YUVAK PRAGATI  MANDAL DHANERA MANAGED BY ADARSH DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE DHANERA ",
  "EKLAVYA COLLEGE OF NURSING",
  "ADARSH SCIENCE COLLEGE VISNAGAR",
  "LOKMANYA INSTITUTE OF MANAGEMENT AND COMPUTER APPLICATION    ",
  "ADIVASI KALUYAN TRUST, VIJAYNAGAR KODIYAVADA SANCHALIT J V SOLANKI",
  "SARDAR VALLABHBHAI PATEL INSTITUTE OF COMPUTER APPLICATION",
  "SARDAR PATEL SEVA TRUST P G CENTRE OF SOCIOLOGY",
  "GOKUL AGRICULTURE COLLEGE",
  "SWAMI VIVEKANAND COLLEGE OF COMMERCE",
  "UNITEDWORLD INSTITUTE OF DESIGN",
  "PIONEER AYURVEDIC COLLEGE AND HOSPITAL",
  "Dr. Subhash College of Computer Science",
  "Shree Atal Bihari Vajpayee Government Arts & Commerce College, Vankal, Surat",
  "IPCOWALA INSTITUTE OF NURSING",
  "S K ARTS AND COMMERCE COLLEGE DHAJALA",
  "CHIMANSINH DHIRSINH B R S COLLEGE",
  "SHRIJI ARTS COLLEGE",
  "SHREE M D MEHTA MAHILA B ED COLLEGE ",
  "VRUNDAVAN ARTS COLLEGE",
  "MESHW INSTITUTE OF DIPLOMA FIRE AND SAFETY",
  "MESHW INSTITUTE OF S I,",
  " NAVGUJARAT PARAMEDICAL INSTITUTE",
  "RMS COLLEGE OF BCA",
  "SHRI SAHAJANAND ARTS COLLEGE",
  "SHRI SAHAJANAND SI COLLEGE",
  "SILVER OAK INSTITUTE OF PHARMACY AND RESEARCH",
  "SILVER OAK LAW COLLEGE",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE JAMKHAMBHALIYA",
  "ARRDEKTA INSTITUTE OF MSC COLLEGE",
  "SHREE UMIYA KVC NURSING COLLEGE",
  "Government Arts and Science College, Morvahadaf",
  "Government Arts College, Kawant",
  "MAHATMA GANDHI LAW COLLEGE",
  "Dollyben Desai Institute of Computer and Allied Sciences, Palsana",
  "K J SCIENCE COLLEGE  ",
  "GIRIRAJ GRAM VIDHYAPITH, JAMBUGHODA",
  "JIVAN JYOT MSC COLLEGE",
  "SWAMI SAHAJANAND COLLEGE OF ARTS",
  "GOVERNMENT POLYTECHNIC, KHEDA - 972",
  "Pacific School of Engineering- 976",
  "Government Arts Commerce & Science College, Khergam",
  "CVM NURSING COLLEGE",
  "DR SUBHASH UNIVERSITY, SCHOOL OF AGRICULTURE",
  "MAHISAGAR ARTS COLLEGE",
  "MAHISAGAR PGDMLT COLLEGE",
  "SARDAR PATEL MSC COLLEGE AKHAJ",
  "SIDDHIVINAYAK BRS COLLEGE",
  "Darshan Institute of Engineering and Technology for Diploma Studies",
  "GOVERNMENT POLYTECHNIC, Rajpipla - 973",
  "DR BHIMRAO AMBEDKAR LAW COLLEGE CHHOTAUDEPUR",
  "NAVYUG COLLEGE, MORBI",
  "Shree Ramkrishna Institute of Computer Education & Applied Sciences",
  "Vinayaka College of Nursing",
  "CHM SHAH NURSING COLLEGE",
  "Government Arts and Commerce College, Muli",
  "C Z Patel College of Business and Management, New Vallabh Vidyanagar",
  "GOVERNMENT COMMERCE AND SCIENCE COLLEGE, DAHEJ",
  "Shree Maruti Vidhya Mandir College of B.S.W.",
  "BHARAD INS. OF TEACHER'S EDUCATION, TRAMBA (RAJKOT)",
  "HM Patel Institute of English Training & Research, Vallabh Vidyanagar",
  "VIDHYADEEP HOMOEOPATHIC MEDICAL COLLEGE AND RESEARCH CENTRE",
  "FACULTY OF SCIENCE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, ANAND",
  "Government Arts and Commerce college, Poshina",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE, RAPAR",
  "Smt. Jamanabahen Bhuta Arts College",
  "Smt. P.N.R. Shah Mahila Arts and Commerce College",
  "Shree Parekh Arts, Science and Commerce College",
  "SHREE VANI VINAYAK ARTS AND COMMERCE COLLEGE, KACHCHH",
  "SHRI LATE ANIRUDHH JAYANTILAL PARSOTAM BHANUSALI ARTS AND COMMERCE COLLEGE, KACHCHH",
  "SHRI RAJABHAI P PATEL COMMERCE COLLEGE, KACHCHH",
  "LOKNIKETAN MAHAVIDHYALA RATANPUR",
  "MAHILA ARTS COLLEGE MOTIPURA",
  "SHREE MAHILA COLLEGE",
  "SHETH M N SCIENCE COLLEGE PATAN",
  "AARYAVEER HOMOEOPATHY MEDICAL COLLEGE, RAJKOT",
  "SHREE GURUVANDNA EDUCATIONAL TRUST. SANCHALIT ARTS COLLEGE-DERDI(TAL.GONDAL)",
  "COLLEGE OF EDUCATION BASPA",
  "Shree Manubhai Patel Dental College and Hospital",
  "SHRI M N PATEL MED COLLEGE",
  "SHREE MANIBEN KARSANBHAI SAVALIYA ARTS COLLEGE, BADHADA",
  "Shree Radheshyam B.Ed, College",
  "Shree J.K. Lukhi Arts and Commerce College",
  "Shree Sahjanand Institute of Nursing College",
  "Shree Swaminarayan College of Computer Science",
  "Smt. L.L. Kakadia B.Ed. College",
  "Swami Vivekanand Homoeopathic Medical College and Hospital",
  "Smt. V.P. Kapadia Mahila Arts College",
  "M.J. College of Commerce",
  "L.R.Valia Arts and P.R.Mehta Commerce College",
  "Smt. Chandaben Mohanbhai Patel Institute of Computer Applications",
  "Shree Swaminarayan College of Commerce and Management",
  "B. R. C. M. College of Business Administration",
  "Government Medical College",
  "Smt. K.B. Parekh B.C.A. College",
  "Smt. Y.J.J. Doshi Arts and Commerce College",
  "Government College of Nursing",
  "VJKM SCIENCE COMMERCE AND ARTS COLLEGE, VADU",
  "SARVODAY COLLEGE OF SCIENCE & TECHNOLOGY - RAJKOT",
  "Ramanbhai Patel College of Pharmacy",
  "P. D. Patel Institute of Applied Sciences",
  "International Agri-Business Management Institute , Anand",
  "College of Agricultural Information Technology , Anand",
  "Polytechnic in Agriculture, Vaso",
  "NATIONAL COMPUTER COLLEGE -JAMNAGAR",
  "B.R.S. COLLEGE - DUMIYANI",
  "B.A.College of Agricultural , Anand",
  "M. L. Parmar College of Computer Science and IT",
  "Gujarat Cancer & Research Institute",
  "NAVNIRMAN COMMERCE COLLEGE",
  "GMERS MEDICAL COLLEGE, MORBI",
  "MERCHANT AYURVED COLLEGE",
  "AMRUT INSTITUTE OF NURSING",
  "SILVER OAK COLLEGE OF AVIATION TECHNOLOGY",
  "Ananya College Of Physiotherapy",
  "MANIBA GAJERA INSTITUTE OF NURSING",
  "LOKMANYA COLLEGE OF NURSING EDUCATION AND RESEARCH",
  "RATANMA INSTITUTE OF NURSING",
  "DR SUBHASH AYURVEDA RESEARCH INSTITUTE",
  "Faculty of Law",
  "Suresh Mehta College of  Science and Commerce",
  "SWAMINARAYAN COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "GROW MORE INSTITUTE OF NURSING",
  "SHREE PARMESHVARI AMRUTLAL SONI ARTS COLLEGE LIMDI    ",
  "NACHIKETA PGDMLT COLLEGE, SAMI",
  "NAVGUJARAT LAW COLLEGE",
  "NACHIKETA MSC COLLEGE, SAMI",
  "GROW MORE INSTITUTE OF SCIENCE",
  "SHRI LEUVA PATEL B.B.A. MAHILA COLLEGE-AMRELI",
  "SMT GB PAVAYA AND SMT PS PAVAYA SCIENCE MSC COLLEGE PALANPUR",
  "SHRI S.K SHAH & SHRI KRISHNA O M ARTS COLEGE",
  "SWA S H JOSHI and B K JOSHI ARTS & COMMERCE COLLEGE",
  "BHIKHIBA MAHILA MED COLLEGE",
  "ANANT NURSING COLLEGE",
  "SMT CHANDANBEN SHANTILAL SWARUPCHAND BCA COLLEGE DEESA",
  "K P TRIVEDI DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "Shri Meghmani Umiya Science College",
  "NAVKAR BRS COLLEGE",
  "SHRI KRISHNA DIPLOMA IN HEALTH AND SENETARY INSPECTOR",
  "CHITRINI INSTITUTE OF DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "Christ Institute of Management,\"Vidya Niketan\"-Rajkot (Minority Institute ) (SFI)",
  "Swami Narayanswarup B. Ed. College",
  "FACULTY OF SOCIAL WORK",
  "SS Patel College of Physical Education, Vallabh Vidyanagar",
  "FACULTY OF LAW",
  "C. U. Shah Institute of Nursing",
  "SMT J A PATEL MAHILA SCIENCE COLLEGE MORBI",
  "FACULTY OF ARTS AND HUMANITIES",
  "Government Commerce College, Naroda",
  "M. K. Institute of Computer Studies",
  "LOKMANYA COLLEGE OF LAW",
  "IMAGE NURSING COLLEGE",
  "Shree Swaminarayan Sanskrit Mahavidyalaya, Jetalpur",
  "SHREE K M SAVJANI AND SHREEMATI K K SAVJANI COMMERCE COLLEGE ",
  "S V COLLEGE OF EDUCATION KADI",
  "SARASWATI MASTER OF SCIENCE COLLEGE VIRAVADA",
  "khyati Institution of valuation",
  "NOOTAN INSTITUTE OF DESIGN AND COMMUNICATION",
  "OM COLLEGE OF SCIENCE",
  "FACULTY OF ENGINEERING AND TECHNOLOGY",
  "GOVERNMENT ARTS, COMMERCE AND SCIENCE COLLEGE, DEODAR",
  "Shri J. S. Ayurved College, Nadiad",
  "JAFARI COLLEGE OF SICENCE AND TECHNOLOGY",
  "GRAVITY INSTITUTE OF NURSING KHEDBRAHMA",
  "SHREE SURYODAY ARTS AND COMMERCE COLLEGE DHANERA",
  "CHITRINI COLLEGE OF SOCIAL WORK SNDT",
  "CHITRINI ARTS COLLEGE",
  "SHRADDHA PGDMLT COLLEGE",
  "KIRTILAL PRABHULAL TRIVEDI MSC COLLEGE KHORDA",
  "GMERS Medical College",
  "VEDANTA DIPLOMA IN FIRE SAFETY    ",
  "M. A. PARIKH FINE ARTS AND ARTS COLLEGE",
  "SHRI UMIYA COLLEGE OF NURSING PALANPUR ",
  "SHREE ARYATEJ INSTITUTE OF PHYSIOTHERAPY    ",
  "GOVERNMENT PHARMACY COLLEGE GANDHINAGAR",
  "Tolani College of Arts & Science",
  "Government Pharmacy College Surat",
  "MAHARSHI DAYANAND DIPLOMA IN HEALTH SANITARY INSPECTOR COLLEGE BASPA",
  "Shri Morarji  Ranchhodji Desai Arts College",
  "Ganpat University Center for Management Studies and Research",
  "NAVODAY DIPLOMA IN HEALTH AND SENITARY INSPECTOR",
  "NAVJIVAN DIPLOMA IN FIRE AND SAFETY",
  "Shri Adarsh  Arts College",
  "NAVJIVAN DIPLOMA IN HEALTH AND SENITARY INSPECTOR",
  "Arts & Commerce College, Chovisi, Navsari",
  "BABU MADHAV INSTITUTE OF INFORMATION TECHNOLOGY",
  "DR VASANT PARIKH AYURVEDIC MEDICAL COLLEGE VADNAGAR",
  "SHREE SWAMINARAYAN INSTITUTE OF PHARMACY ",
  "SHRI T S PATEL P G D M L T COLLEGE AMBALIYARA",
  "SHRI T S PATEL B R S COLLEGE AMBALIYARA",
  "KAVI SHREE DAAD GOVERNMENT ARTS AND COMMERCE COLLEGE PADDHARI",
  "VIDYABHARTI TRUST COLLEGE OF MASTER IN COMPUTER APPLICATION",
  "SHREE P M PATEL P G INSTITUTE OF LAW AND HUMAN RIGHTS",
  "SHREE M H PARMAR DIPLOMA IN HEALTH AND SANITARY INSPECTORY COLLEGE",
  "Shree Swaminarayan Anikaben Ashwinbhai Kotadiya College Of BBA",
  "VADODARA INSTITUTE OF DESIGN",
  "SHREEMATI RUPABEN SURESHBHAI DATTANI COLLEGE OF TECHNOLOGY",
  "Smt. J. P. Shroff Arts College",
  "M. & V. Arts and Commerce College",
  "SHREE THAKORBHAI PATEL ARTS AND COMMERCE COLLEGE ANKLESHWAR",
  "Patel Raman Brothers Arts & Patel Gopalbhai Ranchhodji Commerce College, Bardoli",
  "MATUSHREE VELABEN DHARAMSHI AND DHARAMSHI VISHRAM TANNA MAHILA  ARTS COLLEGE ",
  "SVKM INSTITUTE OF COMPUTER STUDIES",
  "SARVA VIDYALAYA INSTITUTE OF COMPUTER STUDIES",
  "DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE PANTHAWADA",
  "SANJIVANI DIPLOMA IN HEALTH SANITARY INSPECTOR COLLEGE",
  "VEDANT NURSING COLLEGE",
  "ADARSH ARTS AND COMMERCE COLLEGE VISNAGAR",
  "SUVIDHA B.ED / M.ED COLLEGE, HEDUVA MEHSANA",
  "MAIKAL KANYA ARTS COLLEGE GARUDESHWAR",
  "V S RAVAL DIPLOMA IN HEALTH AND SANITARY PRANTIJ",
  "Siddharth Law College, Kamrej",
  "SOMNATH ARTS  & PHYS. EDUCATION COLLEGE-KODINAR",
  "Vanvasi Sewa Samaj B. Ed. College",
  "Shri R. P. Arts, Shri K. B. Commerce and Smt. B. C. J. Science College",
  "LATE SHREE PUNJABHAI NAJBHAI BORICHA COMMERCE COLLEGE DEVGADH",
  "U. T. S. Mahila Arts College",
  "AHMEDABAD INSTITUTE OF NURSING SCIENCES, LAPKAMAN",
  "R K INSTITUTE OF NURSING AND RESEARCH CENTER",
  "Divya Drashti B. Ed. College",
  "SHREE SHARDAPEETH ARTS,COMM.& EDUCATION COLLEGE-DWARKA",
  "J. K. Desai B.Ed. College",
  "J & R COLLEGE OF EDUCATION",
  "AHMEDABAD INSTITUTE OF MEDICAL SCIENCES, LAPKAMAN",
  "SHRI ARJUN B.ED. COLLEGE-SUPASI",
  "SHRI ARJUN ARTS & B.S.W.COLLEGE-SUPASI (TA.VERAVAL)",
  "SILVER OAK INSTITUTE OF MANAGEMENT",
  "SHRI V.J.SOLANKI B.ED. COLLEGE-KODINAR",
  "SMT. C.P. CHOKSI ARTS & SHREE P.L. CHOKSI COMMERCE COLLEGE, VERAVAL",
  "SHRI SARASWATI COLLEGE OF EDUCATION -GIR GADHADA(UNA)",
  "SHRI UKABHAI DODIYA MAHILA B.ED. COLLEGE, VERAVAL",
  "SHRI D.M. BARAD ARTS & COMMERCE GHUSIA(GIR)",
  "SHRI J.B. BARAD B.ED. COLLEGE, SUTRAPADA",
  "SHASHTRI SWAMI DHAMJIVANDASJI B.ED.COLLEGE-UNA",
  "SHASHIKALA AND DHANSUKHLAL DADARWALA NURSING COLLEGE",
  "GVM NURSING COLLEGE, ANIYAD",
  "GHANTAKARNA MAHAVIR PHYSIOTHERAPY COLLEGE, GODHRA",
  "DINSHA PATEL COLLEGE OF NURSING, NADIAD",
  "Arts & Commerce College, Kaparada, Motapondha",
  "V S RAVAL SCIENCE COLLEGE PRANTIJ",
  "College of Veterinary Science & Animal Husbandry, Anand",
  "Sheth M.C.College of Dairy Science, Anand",
  "A L T TRAINING COLLEGE",
  "HIRABA B ED COLLEGE",
  "KHYATI INSTITUTE OF PHYSIOTHERAPY",
  "SHRI RAM COLLEGE OF MASTER EDUCATION",
  "Shree Krishna Pranami Arts College,Dahod",
  "NEOTECH INSTITUTE OF PARAMEDICAL SCIENCE",
  "BHAVNA B ED COLLEGE",
  "SMT L. M. PATEL WOMEN'S B ED COLLEGE, LUNAWADA",
  "SILVER OAK COLLEGE OF  HUMANITIES AND SOCIAL SCIENCE",
  "KANORIA CENTRE FOR MEDICAL EDUCATION",
  "KAMDAR COLLEGE OF PHARMACY",
  "MERCHANT INSTITUTE OF PHARMACY",
  "Smt. Sharadben Shantibhai Patel Nootan Science and Commerce College, Visnagar",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING AND TECHNOLOGY",
  "SHREE MAHALAXMI DISTRICT INSTITUTE OF EDUCATION AND TRAINING, AHMEDABAD (RURAL)",
  "GUJARAT NURSING COLLEGE",
  "AANAND COLLEGE OF NURSING",
  "DVP COLLEGE - DEVKA",
  "Vimal Tormal Poddar BCA College",
  "SMT S M SHAH NURSING COLLEGE",
  "KALYAN POLYTECHNIC, SEKHPAT",
  "SHREE KRISHNA DIPLOMA IN HEALTH AND SANITARY INSPECTOR, LAKHANI",
  "G V VAGHELA SCIENCE COLLEGE, DEODAR",
  "District Institute of Education and Training Ahmedabad- City (Govt. Bed College).",
  "KHERALU TALUKA UTTAR VIBHAG KELVANI MANDAL SANCHALIT SCIENCE COLLEGE",
  "Institute of Science, Nirma University",
  "NEELDEEP COLLEGE OF BUSINESS ADMINISTRATION",
  "DR SUBHASH NURSING INSTITUTE",
  "SILVER OAK COLLEGE OF COMPUTER APPLICATION",
  "SHREE ODHAVJIBHAI RAVAJIBHAI BHALODIYA MAHILA SCIENCE COLLEGE",
  "SHRI T S PATEL SCIENCE COLLEGE",
  "SHREE SWAMINARAYAN B ED COLLEGE",
  "SHREE UKABHAI DODIYA BRS COLLEGE SIMAR",
  "SMT V M CHANDERA SCIENCE COLLEGE LOEJ",
  "MK INSTITUTE OF EDUCATION AND RESEARCH MED PATAN",
  "C U SHAH INSTITUTE OF COMPUTER APPLICATION",
  "ADARSH SCIENCE MSC COLLEGE BHABHAR",
  "State Institute of Hotel Management",
  "Limbdi Homoeopathic Medical College and Hospital",
  "DALIBA NURSING COLLEGE ANDROKHA",
  "KISANBHARATI ARTS COMMARCE AND SCIENCE COLLEGE",
  "ADARSH SCIENCE COLLEGE, PATAN",
  "Bhaktraj Dada Khachar Arts & Commerce College, Gadhada",
  "L N PATEL EDUCATION COLLEGE",
  "Zydus Medical College and Hospital.",
  "M. M. CHAUDHARI ARTS COLLEGE RAJENDRANAGAR",
  "INSTITUTE OF LANGUAGE TEACHING-RAJKOT",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING JAMNAGAR",
  "JG NURSING COLLEGE",
  "GOPINATHJI MAHILA COMMERCE COLLEGE",
  "AARIHANT HOMOEOPATHIC MEDICAL COLLEGE AND RESEARCH INSTITUTE",
  "Shri VJ Patel College of Physical Education, Mogri",
  "PANCHSHIL SI COLLEGE GODHRA",
  "JMD INSTITUTE OF NURSING",
  "Bharat Nursing College",
  "SIGMA INSTITUTE OF ENGG., BAKROL 050",
  "HJD INSTITUTE KUTCH",
  "PARUL INSTITUTE OF ARTS",
  "LATE MADHAVLAL FULSHANKAR VAIDHYA SELF FINANCE LAW COLLEGE, DABHOI",
  "SHRI P.J. PATEL NILKANTH SCIENCE COLLEGE, MAKTUPUR",
  "ITM SCHOOL OF PHYSIOTHERAPY",
  "Raj Krupa Institute of Nursing",
  "SVAYAMBHU INSTITUTE OF NURSING",
  "AARIHANT INSTITUTE OF NURSING",
  "SHREE N.L.AMODRA B.SC.NURSING COLLEGE CHARADVA",
  "MANJULABEN KIRTILAL TRIVEDI MSW COLLEGE KHORDA",
  "COLLEGE OF AGRICULTURE",
  "GUJARAT TECHNOLOGICAL UNIVERSITY- GRADUATE SCHOOL OF ENGINEERING AND TECHNOLOGY",
  "SMT. ANSUYABEN BALKRISHNA PARIKH LAW COLLEGE, KADI",
  "URMILA GOSWAMI COLLEGE OF NURSING",
  "Ankleshwar Environmental Preservation Society",
  "P P Savani School of Architecture",
  "PGDMLT COLLEGE RASANA MOTA",
  "SHREE SURYODAY SCIENCE COLLEGE DHANERA",
  "SHETH JAMNABHAI BHAGUBHAI BPA SCHOOL OF OPTOMETRY",
  "Department Of Management",
  "SHREE PARABATBHAI NATHABHAI VAROTARIA MAHILA COMMERCE COLLEGE",
  "SMT BABUBEN R PATEL MSC COLLEGE ANDROKHA",
  "PARUL INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
  "Bhavnagar Polytechnic Institute",
  "Government Science College, LIMKHEDA",
  "Government Science College, DHANPUR",
  "BALAJI COLLEGE OF COMMERCE SCIENCE TECHNOLOGY AND MANAGEMENT",
  "DR SUBHASH UNIVERSITY, SCHOOL OF ARTS AND HUMANITIES",
  "MAKTABAH JAFARIYAH SCHOOL OF MANAGEMENT    ",
  "Agricultural Research Station, Khedbrahma",
  "Agricultural Research Station, Kothara",
  "SHREE ARYATEJ HOMOEOPATHIC MEDICAL COLLEGE",
  "Tolani Institute of  Law",
  "Dolat-Usha Institute of Applied Science & Dhiru-Sarla Institute of Management & Commerce ",
  "LJ INSTITUTE OF SPORTS MANAGEMENT",
  "GANPAT UNIVERSITY INSTITUTE OF PHARMACY",
  "VARNIRAJ ARTS AND COMMERCE BABRA",
  "SHRADDHA MSW COLLEGE POYADA",
  "SANSKAR NURSING COLLEGE",
  "GANESH INSTITUTE OF NURSING PRANTIJ",
  "S.B. Polytechnic, Savli, Vadodara 666",
  "DR. SUBHASH TECHNICAL CAMPUS (695)",
  "NAVNIRMAN COLLEGE, RADHANPUR",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE, KATHLAL",
  "FACULTY OF PHARMACY, SRI SATSANGI SAKETDHAM RAM ASHRAM GROUP OF INSTITUTIONS (257), VADASMA",
  "Shri Natvarsinhji Arts & Science & Shri S. G. Patel Commerce College",
  "GMERS MEDICAL COLLEGE,HIMMATNAGAR",
  "MAHRSHIDAYANAD ARTS AND COMMERCE COLLEGE,  BASPA",
  "ARTS COLLEGE, ANDROKHA",
  "EKTA TRUST SANCHALIT BCA COLLEGE, NAVIMETRAL",
  "SMT SUSHILABEN P PATEL COLLEGE OF EDUCATION, GHATLODIA",
  "SWASTIK MAHILA ARTS AND COMMERCE COLLEGE PALANPUR",
  "NOBLE COLLEGE OF COMMERCE",
  "NOBLE MCA COLLEGE",
  "NOBLE LIBRARY SCIENCE COLLEGE",
  "LOKMANYA COLLEGE OF EDUCATION",
  "GROWMORE INSTITUTE OF MSW, BERNA",
  "GROWMORE INSTITUTE OF PGDCA COLLEGE, BERNA",
  "ANANYA INSTITUTE OF SCIENCE KALOL KIRC CAMPUS",
  "KARM INSTITUTE OF NURSING SCIENCE",
  "Government Arts & Commerce College, Kachhal",
  "AVIRAT LAW COLLEGE",
  "SHRIMATI SUBHADRABEN NAVINCHANDRA SHAH NURSING COLLEGE BALASINOR",
  "M. K. Mehta College of Education",
  "Shri. M. C. Rathva Arts College",
  "Department of Pharmacy",
  "Arts & Commerce College, Sarbhan, Bharuch",
  "Smt. B.K Shah Medical College & Research centre",
  "Sumandeep Nursing College",
  "FACULTY OF HUMANITIES & SOCIAL SCIENCES",
  "College of Physiotherapy",
  "GVM BACHELOR OF SCIENCE COLLEGE",
  "School of Diploma Studies, RK University, Rajkot",
  "School of Management, RK University, Rajkot",
  "School of Pharmacy, RK University, Rajkot",
  "POLYTECHNIC IN AGRICULTURE AMRELI    ",
  "A.R.COLLEGE OF PHARMACY & G.H.P. INSTITUTE OF PHARMACY, V.V.NAGAR  (GIA) 201",
  "RAJKOT HOMOEOPATHY MEDICAL COLLEGE-RAJKOT",
  "Smt. B. C. J. College of Education",
  "KARNAVATI INSTITUTE OF LAW",
  "SHREE SARASWATI NURSING COLLEGE, BHUTAVAD",
  "Sarvajanik College of Commerce and Computer Application",
  "Sarvajanik College of Law",
  "Parul Institute of Physiotherapy",
  "PARUL INSTITUTE OF LIBRARY AND INFORMATION SCIENCE",
  "AHMEDABAD HOMOEPETHIC MEDICAL COLLEGE",
  "GOVERNMENT ARTS COLLGE, BAYAD",
  "RAMAN BHAKTA SCHOOL OF ARCHITECTURE",
  "GOVERNMENT ARTS COLLEGE, RANAVAV",
  "DALIA AYURVED COLLEGE AND HOSPITAL, KANERA",
  "SGV NURSING COLLEGE DHROL",
  "GCS PHYSIOTHERAPY COLLEGE ",
  "Faculty of Commerce",
  "DR M. K. SHAH MEDICAL COLLEGE AND  RESEARCH CENTER",
  "Piyuni Goswami College of Arts",
  "SHRADDHA B.SC COLLEGE POYADA",
  "K.P.E.S. College",
  "SKET SHRI B J GADHAVI COLLEGE OF EDUCATION",
  "DR SUBHASH UNIVERSITY, SCHOOL OF PHYSIOTHERAPY",
  "COLLEGE OF EDUCATION VADASMA",
  "NIMA GIRLS ARTS COLLEGE GOZARIYA",
  "DIVYACHETANA COLLEGE OF EDUCCATION,BHETALI",
  "APOLLO HMCT COLLEGE    ",
  "Institute of Law, Nirma University",
  "AKAR COLLEGE OF PROFESSIONAL STUDIES    ",
  "B. K. Mody Govt.Pharmacy College (Diploma), Rajkot 403 ",
  "Dr. Dayaram Patel Pharmacy College (Diploma), Bardoli, Surat 406",
  "Chaudhari Technical Institute (Womens College) - MCA (SFI) - Gandhinagar 506 ",
  "A.V.Parekh Technical Institute,Rajkot  602",
  "EXCELLENT INSTITUTE    ",
  "ELITE INSTITUTE    ",
  "PARUL INSTITUTE OF AYURVED",
  "Butler Polytechnic, Vadodara 606 ",
  "Christ Polytechnic Institute, Rajkot 610",
  "Government Girls Polytechnic,Ahmedabad 614",
  "Government Polytechnic Aahva-Dang 616 ",
  "R.H.PATEL INSTI. OF TECHNOLOGY,GOBLAJ,KHEDA 641",
  "Karnavati School of Dentistry",
  "PARUL INSTITUTE OF PHARMACY, LIMDA 233",
  "N.R.VEKARIA INSTITUTE OF PHARMACY, JUNAGADH 231 ",
  "C.K.PITHAWALA INSTITUTE OF PHARMACEUTICAL SCIENCE  RESEARCH, SURAT 216",
  "SARASWATI INSTITUTE OF PHARMACEUTICAL SCIENCES, CHILODA 242",
  "SARDAR PATEL COLLEGE OF PHARMACY COLLEGE, BAKROL 244",
  "SAT KAIVAL COLLEGE OF PHARMACY, SAARSA 246",
  "K.V.VIRANI INSTITUTE OF PHARMACY AND RESEARCH CENTRE, BADHADA 253",
  "SHRI SWAMINARAYAN SANSKAR PHARMACY COLLEGE, ZUNDAL 260 ",
  "SIGMA INSTITUTE OF PHARMACY, BAKROL 261",
  "SWAMINARAYAN PHARMACY COLLEGE, SALVAV 265 ",
  "PARUL INSTITUTE OF PHARMACY & RESEARCH",
  "Kalol Institute of Management (SFI) (MCA Programme) 514 ",
  "L.J.Institute of Computer Applications (SFI)-Ahmedabad",
  "Shri Chimanbhai Patel post Graduate Institute of Computer Applications (SFI)-Ahmedabad 535 ",
  "K.D.Polytechnic,Patan 631",
  "Shree Hari Polytechnic Institute, Nani Kadi 677",
  "Smt. R.S.Patel Insti. Of Diploma Engg., Shelavi, Patan 681",
  "Laxmi Institute of Management,Sarigam (SFI) 731",
  "R.B. Institute of Management Studies (SFI),Ahmedabad. 746 ",
  "Dr. Subhash Technical Campus - 287",
  "Polytechnic in Horticulture- Junagadh",
  "S V VIRANI COLLEGE",
  "H. B. Patel Institute of Diploma Engineering & Technology, Limbodara, Lunavada 676",
  "SHRI SAMANVAY INSTITUTE OF PHARMACY, BOTAD 256 ",
  "B.K.MODI GOVERMENT PHARMACY COLLEGE, RAJKOT 212 ",
  "Parth College of Education",
  "C. & S. H. Desai Arts and L. K. L. Doshi Commerce College",
  "Government Physiotherapy College",
  "Surat Municipal Institute of Medical Education & Research Centre (SMIMER)",
  "Sarvajanik College of Physiotherapy",
  "Smt. Z. S. Patel College of Management",
  "Shri Sardar Patel College of Education",
  "Shri Narmada College of Education",
  "Gujarat Arts and Commerce College, (Evening), Ellisbridge",
  "Gujarat Arts & Science College, Ellisbridge",
  "Navyug Science College, Surat",
  "GOVERNMENT PHYSIOTHERAPY COLLEGE, JAMNAGAR",
  "S. B. Garda Arts College & P. K. Patel College of Commerce, Navsari",
  "A. V. Patel Commerce College, Bilimora",
  "J. M. Shah Arts & Commerce College, Jambusar",
  "M. R. Desai Arts & E. E. Laher Kodsadiya Commerce College, Chikhli",
  "P. T. Sarvjanik College of Science, Surat",
  "The Mandvi Education Society B. C. A. College",
  "Shri J. D. Gabani Commerce College",
  "Vanseva Mahavidhyalay",
  "Government Arts & Commerce College, Netrang",
  "Government Arts & Commerce College, Bhilad, Umargam",
  "Government Arts & Commerce College, Songadh",
  "Government Science College, Valod",
  "Shri Shambhubhai V. Patel College of Computer Science & Business Management ",
  "S. P. B. Physiotherapy College",
  "Shri Uttar Gujarat B. B. A. College",
  "C. D. Pachhigar College of Homeopathic Medicine & Hospital",
  "Vivekanand College for Advanced Computer and Information Science",
  "Nutan Gram Vidhyapeeth",
  "Jay Jalaram Talimi Snatak Mahavidyalaya",
  "Ma Gayatri B. Ed. College",
  "Shri Parsottambhai Haribhai Umrav College of Arts & Commerce",
  "The Mandvi Education Society B. B. A. College",
  "Smt P. N. Patel College of Education",
  "Samaj Seva Mahavidhayalay Gandhi Vidhyapeeth",
  "Shri Saraswati Hindi Mahavidhyalaya",
  "Government Arts & Commerce College, Vansda",
  "Vivekanand College for B. Ed.",
  "Udhna Citizen Commerce College & S.P.B. College of Business Administration & Smt. Diwaliben Harjibhai Gondaliya College of BCA and IT",
  "Smt. Tanuben and Dr. Manubhai Trivedi College of Information Science",
  "Adivasi Arts & Commerce College",
  "Shri Ratnasinhji Mahida Commerce College",
  "Government Science College, Chikhli",
  "Shri Manilal Kadakia College of Management & Computer Studies",
  "NS Patel Arts College, Anand",
  "VP & RPTP Science College, Vallabh Vidyanagar",
  "BN Patel Institute of Paramedical & Science, Anand",
  "Mangal Bharati Lokshikshan and Krushi Mahavidhyalay",
  "Akhand Anand Arts and Commerce College, Surat",
  "Sir K. P. College of Commerce, Chorasi",
  "M. T. B. Arts College, Surat",
  "Navyug Arts College, Chorasi",
  "Mahamandleshwar Shri Krishnanandji College of Commerce, Bharuch",
  "Shree JM Patel Institute of Studies & Research in Humanities, Anand",
  "Anand Commerce College, Anand",
  "Smt. Kamlaben P. Patel College of Home Science, Anand",
  "BJ Vanijya Mahavidyalaya, Vallabh Vidyanagar",
  "COLLEGE OF AGRICULTURAL ENGINEERING AND TECHNOLOGY, KHEDBRAHMA, CURRENTLY AT SARDARKRUSHINAGAR",
  "Sardar Patel College of Administration & Management, Bakrol",
  "Late M. C. Parmar B.ed. College, Khatamba-Vadodara",
  "C. N. PARMAR B.Ed. COLLEGE",
  "DC Patel School of Architecture, APIED, Vallabh Vidyanagar",
  "Christian College of Education, Anand",
  "Shri IJ Patel M.Ed. Course, Mogri",
  "Anand Law College, Anand",
  "Shree PM Patel College of Education, Anand",
  "Shree PM Patel College of Electronics & Communication, Anand",
  "Shree PM Patel College of Paramedical Science and Technology, Anand",
  "GEETANJALI COLLEGE OF COMMERCE & COMPUTER SCIENCE-RAJKOT",
  "SARDAR PATEL KANYA KELVNI MANDAL B.ED.COLLEGE-     JAMKANDORANA",
  "ZINZUVADA KELVANI MANDAL ARTS COLLEGE-ZINZUVADA (SURENDRANGAR)",
  "MURLIDHAR B.ED. COLLEGE-RAJKOT",
  "YOGIJI MAHARAJ MAHAVIDYALAY MAHILA ARTS & COMM.COLLEGE-DHARI",
  "SHRI SATYAPRAKASH COLLEGE OF MANAGEMENT AND COMPUTER SCIENCE, RAJKOT",
  "MATUSHREE MONGHIBA MAHILA ARTS COLLEGE, AMRELI",
  "SHREE K.P. DHOLAKIYA INFOTECH MAHILA COLLEGE-AMRELI",
  "S.H.GARDI ARTS & C.R.GARDI COMM.COLLEGE-DHROL",
  "A.V.HIRANI  COLLEGE OF JOURNALISM & PERFORMING ARTS-RAJKOT",
  "J.H.BHALODIYA WOMEN'S  COLLEGE-RAJKOT (COMMERCE & B.B.A.)",
  "SHREE A.V.J. OZA INSTITUTE OF B.ED. COLLEGE, LAKHTAR",
  "D.K.V. ARTS & SCIENCE COLLEGE, JAMAGAR",
  "WELL KNOWN COLLEGE OF COMPUTER SCIENCE-RAJKOT",
  "SMT. K.S.N.KANSAGARA MAHILA ARTS & COMM. COLLEGE-RAJKOT",
  "MUNI. ARTS & COMMERCE COLLEGE, UPLETA",
  "SHRI MUKESH JANI B.ED. COLLEGE, AMRELI",
  "J.J.KUNDALIYA ARTS & COMMERCE COLLEGE-RAJKOT",
  "SMT. R.D. GARDI COLLEGE OF EDUCATION, RAJKOT",
  "SHRI L.D. DHANANI ARTS COLLEGE-AMRELI",
  "HARI VANDANA COLLEGE-RAJKOT",
  "SHRI H.N.SHUKLA B.ED. COLLEGE -RAJKOT",
  "COLLEGE OF AGRICULTURE, WAGHAI",
  "MAHARSHI DAYANAND DIPLOMA STUDY CENTRE MANDAL    ",
  "MAHARSHI DAYANAND PGDCA STUDY CENTRE MANDAL    ",
  "GLORIOUS COLLEGE OF COMPUTER SCIENCE, RAJKOT",
  "SRI MIRAMBICA B.ED. COLLEGE, RAJKOT",
  "M.D.KAHOR ARTS & COMMERCE COLLEGE-JASDAN",
  "COLLEGE OF AGRICULTURAL ENGINEERING, DEDIAPADA",
  "C.U.SHAH MEDICAL COLLEGE -SURENDRANAGAR",
  "Prin. M. C. Shah Commerce College",
  "DR. SUBHASH COLLEGE OF EDUCATION, JUNAGADH",
  "DR.SUBHASH MAHILA ARTS COMM.& HOMESCI.COLLEGE-JUNAGADH",
  "GURUKUL MAHILA ARTS & COMMERCE COLLEGE-PORBANDAR",
  "LAW COLLEGE-JUNAGADH",
  "N. P. ARTS & COMMERCE COLLEGE-KESHOD",
  "Shri Manibhai Virani and Smt. Navalben Virani Science College, Rajkot",
  "H.M.V.ARTS & COMMERCE COLLEGE-UNA",
  "OM V.V.I.M. COLLEGE, MORBI",
  "SARASWATI INFOTECH EDUCATION COLLEGE OF COMPUTER, SCIENCE & I.T., JUNAGADH",
  "SHRI H.M.PATEL MAHILA LAW COLLEGE-JUNAGADH",
  "SHRI M.N. KAMPANI ARTS & A.K. SHAH COMMERCE COLLEGE, MANGROL",
  "SMT V.M. CHANDERA ARTS & B.S.W. COLLEGE, LOEJ",
  "MAHILA ARTS & HOMESCI. COLLEGE, KODINAR",
  "SHRI SHANKAR BED COLLEGE-2, MANUD",
  "DHARMENDRASIHJI ARTS COLLEGE, RAJKOT",
  "Government Science College, Jhalod",
  "SHRI SAURASHTRA COLLEGE OF MANAGEMENT & COMPUTER SCIENCE, ATKOT",
  "R.R.PATEL MAHILA ARTS & COMMERCE COLLEGE-RAJKOT",
  "Parekh Brothers Science College",
  "NKMS DIVYACHETANA BCA COLLEGE BHETALI",
  "Sardar Patel Institute of Applied Sciences, Bakrol",
  "Shree JM Patel Arts College, Anand",
  "AIMS College of Management & Technology, Bakrol",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING VADODARA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING KATHLAL KHEDA",
  "SHREE RAMBA DISTRICT INSTITUTE OF EDUCATION & TRAINING -PORBANDAR",
  "DR.SUBHASH MAHILA COLLEGE OF EDUCATION COLLEGE JUNAGADH",
  "Government Science College, Ahwa, The Dangs",
  "SHREE KOKILABEN KARSANBHAI PATEL GIRLS SCIENCE COLLEGE",
  "SIDDHIVINAYAK MVOC COLLEGE    ",
  "Shree G.H. Sanghavi Shikshan Mahavidyalaya",
  "NOOTAN COLLEGE OF PHYSIOTHERAPY",
  "MATUSHRI VIRBAIMA MAHILA COLLEGE OF COMMERCE, MANAGEMENT & IT, RAJKOT",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BHAVNAGAR",
  "S.D.Shethia College of Education",
  "VRUNDAVAN PGDMLT COLLEGE    ",
  "SMT. Kashiben Ambalal Patel Science College",
  "VED MSW COLLEGE    ",
  "P. T. Arts and Commerce College",
  "Sarvajanik College of Engineering & Technology, Faculty of Architecture",
  "Shankersinh Vaghela Bapu Institute of Nursing",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KUTCH BHUJ",
  "Shri Sarvajanik College of Education",
  "Sheth M. N. C. College of Education",
  "Government B. Ed. College, Naswadi",
  "V. T. Choksi Sarvajanik College of Education",
  "Snatak Adhyapan Mandir, (Basic Education)",
  "Shri Rang Shikshan Mahvidhyalaya",
  "Government B. Ed. College, Vansda",
  "Government B. Ed. College, Kachhal",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING RAJPIPLA NARMADA",
  "Sandra Shroff  College of Nursing, Valsad",
  "District Institute of Education and Training, Surat",
  "SWAMI SAHAJANAND SCHOOL OF MANAGEMENT",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, NAVSARI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, Bharuch",
  "College  of Education- Kharod, Ankleshwar",
  "SHRI C.H. SHAH MAITRI VIDHYAPITH MAHILA COLLEGE OF EDUCATION",
  "SMT. J. J. KUNDALIA GRADUATE TEACHERS' COLLEGE",
  "P.D.M.GRADUATE TEACHER'S COLLEGE-RAJKOT",
  "C G Bhakta Institute of Biotechnology",
  "SHRI EKLAVYA ARTS, RURAL AND SOCIAL SCIENCE COLLEGE NASWADI",
  "DR SUBHASH UNIVERSITY, SCHOOL OF VOCATIONAL EDUCATION",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING SURENDRANAGAR",
  "DARBAR GOPLDAS SHIKSHAN MAHAVIDHYALAYA-ALIABADA",
  "GOVERNMENT BED COLLEGE, MEGHRAJ",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING PATAN",
  "SWAMI VIVEKANAND SARVODAY BANK EDUCATION COLLEGE",
  "VJKM SELF FINANCE COLLEGE OF MSW",
  "SECONDARY TEACHER'S TRAINING COLLEGE, Visnagar, Mahesana",
  "L N K COLLEGE OF EDUCATION",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BANSKANTHA PALANPUR",
  "D D CHOKSHI COLLEGE OF SECONDARY EDUCATION",
  "COLLEGE OF EDUCATION,DARAMALI",
  "B D SHAH COLLEGE OF EDUCATION MODASA",
  "Vaidya Shri M. M. Patel Education College",
  "Smt. Ullasben Gordhandas College of Education",
  "Smt. M. N. K. Dalal Education College for Women",
  "Shri M. N. Shukla College of Education",
  "Prakash College of Education",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING GANDHINAGAR",
  "AcharatLal Girdhar Lal  Teachers College",
  "NAVYUG INSTITUTE OF BRS",
  "Smt. S. I. Patel Ipcowala College of Education",
  "DAHIBA SHABHAISINH PARMAR ARTS COLLEGE, GOLLAV",
  "S. V. Arts College",
  "Vivekanand College of Arts",
  "National Institute of Mass Communication and Journalism",
  "Smt. Laxmiben & Chimanlal Mehta Arts College",
  "Shri Swaminarayan Arts College",
  "GOVERNMENT ARTS COLLEGE, TILAKWADA",
  "Shri H. K. Arts College",
  "Shri P. K. Chaudhari Mahila Arts College",
  "B. V. Patel Pharmaceutical & Research Centre",
  "Physical Research Laboratory",
  "Shivrath Centre of Excellence in Clinical Research",
  "Shri Divyajeevan Samskrutik Sangh",
  "Shri K. L. Swadhyaya Mandir",
  "Subham Institute of Nursing Science & Research Center",
  "Anand Education College, Anand",
  "ASIA PACIFIC INSTITUTE OF COMPUTER APPLICATION    ",
  "AHMEDABAD INSTITUTE OF BUSINESS MANAGEMENT    ",
  "SHRI H S SHAH COLLEGE OF COMMERCE",
  "SHRI INDUBHAI SHETH LAW COLLEGE",
  "JG INSTITUTE OF BUSINESS ADMINISTRATION",
  "Shree Meghmani Parivar and Shree Bhailabhai A Patel (Detrojwala) Umiya Arts and Commerce College for Girls",
  "Samarth College of Education",
  "PARUL INSTITUTE OF COMMERCE",
  "GOVERNMENT ARTS & COMMERCE COLLEGE  GAMBHOI   ",
  "PANCHSHIL ARTS AND SCIENCE COLLEGE  GODHRA",
  "ARRDEKTA INSTITUTE OF SCIENCE(B.Sc.)",
  "PGDMLT COLLEGE, MAKTUPUR",
  "Shri Maruti Vidyamandir College of Fashion Designing",
  "SHREE UTTHAN BSW COLLEGE KANBHA",
  "DEVRAJ LAW COLLEGE",
  "Government Arts And Commerce College, Lalpur ",
  "SHREE SWAMINARAYAN B.ED.COLLEGE",
  "NILABEN MSW COLLEGE LIMADIYA",
  "Shri Balahanuman Ayurved College, Lodra",
  "CRYSTAL INSTITUTE OF NURSING",
  "Government Science College, Veraval",
  "M.M.SHAH COLLEGE OF EDUCATION -WADHWANCITY",
  "CRYSTAL SCIENCE COLLEGE",
  "GOVERNMENT COMMERCE AND ARTS COLLEGE, VIJAYNAGAR    ",
  "NH Patel College of Education, Anand",
  "Swami Sahajanand College of Commerce and Management",
  "SHREE ADARSH ARTS COLLEGE GANGOL",
  "Footwear Design and Development Institute - Bharuch",
  "KANKESHWARIDEVI  INSTITUTE OF TECHNOLOGY ,JAMNAGAR 991",
  "SHRI MAHAVIR ROFEL COLLEGE OF ARTS, VAPI",
  "SHREE DILIPBHAI K KATARA MSW COLLEGE SHAMLAJI",
  "VIDHYADEEP INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "VALLABHI VIDYAPITH ARTS COLLEGE",
  "SHETH S V ARTS AND COMMERCE COLLEGE SELF FINANCE    ",
  "Government Arts and Science College ,Harij",
  "K.R.DOSHI B.S.W.COLLEGE",
  "SHREE SAHJANAND ARTS AND COMMERCE COLLEGE, DAMNAGAR",
  "B.A. DANGAR HOMOEOPATHY MEDICAL COLLEGE-RAJKOT",
  "BHARAT PHARMACY COLLEGE    ",
  "SIR P.T. SCIENCE COLLEGE Modasa",
  "Sanskar B.Ed. College Pipaliya",
  "Zydus School of Nursing, Anand",
  "Smt.Minakshiben D. Patel Institute of Physical Science and Research, Anand",
  "Smt. Hiraba Motibhai Patel Institute of Performing Arts, Anand",
  "Smt. Dhariniben  A. Shukla B.Ed. College, Mahemdabad",
  "Shree R.N. Patel Institute of Design., Anand",
  "Knowledge Institute of Physiotherapy, Bakrol",
  "Knowledge Institute of Nursing, Bakrol",
  "Dr. Indravadan P. Patel Institute of Medical Technology and Research, Anand",
  "Anand College of Legal Studies",
  "Vinayaka College of IT and Management",
  "Shree Kelavani Mandal Sanchalit Mahila Arts College Dhasagam",
  "S P B PATEL ENGINEERING COLLEGE (DIPLOMA COURSE) - 693",
  "SMT NIRANJANA PANKAJ MAHETA MAHILA COLLEGE",
  "GOKUL AYURVEDIC COLLEGE",
  "CHANAKYA VIDHYAPEETH",
  "SHANKERSINH VAGHELA BAPU INSTITUTE OF LAW",
  "Takshshila Institute of Commerce",
  "Suryoday College of Commerce",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE-LILIYA",
  "APOLLO INSTITUTE OF PHYSIOTHERAPY",
  "SHRI SARVAJANIK PHARMACY COLLEGE, MEHSANA 245 ",
  "KRISHNA SCHOOL OF ARTS AND HUMANITIES",
  "SHRI SHANTABEN NANUBHAI SANGHANI ARTS AND COMMERCE COLLEGE",
  "KRISHNA SCHOOL OF DIPLOMA STUDIES",
  "SHREE PATEL VIDHYA MANDIR COMPUTER SCIENCE COLLEGE",
  "SHRI A C SHUKLA POST GRADUATE COLLEGE OF EDUCATION ",
  "SHETH U T KAPADIA LAW COLLEGE",
  "SHREE UMA GIRLS COLLEGE",
  "S K COLLEGE OF SCIENCE POST GRADUATION, PATAN",
  "S K COLLEGE OF SCIENCE PGDMLT, PATAN",
  "SDJ INTERNATIONAL COLLEGE, PALSANA",
  "S S MAHLA COLLEGE",
  "SHREE SWAMINARAYAN COLLEGE OF TECHNOLOGY AND MANAGEMENT",
  "SHRI M D PATEL MSC COLLEGE",
  "G.M.E.R.S. Medical College",
  "UDAAN INSTITUTE OF SOCIAL WORK MSW",
  "GOVT ARTS & COMMERCE COLLEGE THARAD",
  "GOVERNMENT SCIENCE COLLEGE, SANTRAMPUR",
  "DR SUBHASH UNIVERSITY, SCHOOL OF COMMERCE AND MANAGEMENT",
  "SHRI JIVAN JYOT SANITARY INSPECTOR COLLEGE",
  "HARIBEN BHAGVANJI  LALJI TEJURA MAHILA COLLEGE  CHALALA",
  "NATIONAL DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE",
  "SIGMA COLLEGE OF COMPUTER APPLICATION",
  "DR SUBHASH UNIVERSITY, SCHOOL OF PHARMACY",
  "DR SUBHASH UNIVERSITY, SCHOOL OF COMPUTER APPLICATION",
  "R.S.KANDORIYA ARTS COLLEGE-NANDANA",
  "SHRI JIVAN JYOT MSW COLLEGE",
  "DR SUBHASH UNIVERSITY, SCHOOL OF SCIENCE",
  "SHREE GOKUL ARTS COLLEGE,MANDVI",
  "SHRI JIVAN JYOT ARTS COLLEGE",
  "SHRI RAGHUNANDAN M A COLLEGE",
  "GOPINATHJI MAHILA ARTS COLLEGE",
  "KAMDAR INSTITUTE OF PHYSIOTHERAPY",
  "Dr. VIRAMBHAI RAJABHAI GODHANIYA COLLEGE OF ARTS, COMMERCE, HOME-SCIENCE AND INFORMATION-TECHNOLOGY FOR GIRLS, PORBANDAR",
  "ARVALLI DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE",
  "COLLEGE OF FORESTRY NAU NAVSARI",
  "CHAUDHARI COMMERCE COLLEGE",
  "NOBLE NURSING COLLEGE",
  "SHRI SWAMINARAYAN B ED COLLEGE",
  "Department of Education, C. U. Shah University",
  "SHREE SWAMINARAYAN SCIENCE COLLEGE",
  "SAMARPAN PGDMLT COLLEGE",
  "S.S.T.J. NURSING SCHOOL",
  "GUJARAT INSTITUTE OF HOTEL MANAGEMENT",
  "Commerce college,Vadgam",
  "Merchant Physiotherapy College",
  "SHREE SWAMINARAYAN SCIENCE COLLEGE,VIJAPUR",
  "SHRI SULESHWARI COLLEGE OF PHYSIOTHERAPY, BHANDU",
  "SWAMI VIVEKANAND ARTS AND COMMERCE COLLEGE",
  "Shri Gosar Hansraj Gosrani Commerce & Shri D. D.Nagda BBA College-Jamnagar",
  "AMULABA BED COLLEGE ",
  "PGDMLT COLLEGE KHERALU",
  "POLYTECHNIC IN AGRICULTURE, WAGHAI",
  "Darshanam Sanskrit Mahavidyalaya, Chharodi",
  "SHREE B.D.BARAD COMMERCE COLLEGE - KODINAR",
  "Bhartiya Vidya Bhavan's Shri Ishvarlal L. P Arts Science  & J. Shah Commerce College, Dakor",
  "F.D COLLEGE OF SCIENCE",
  "SHRI KIRITBHAI DAHYABHAI PATEL(DEVGADH) UMIYA BCA COLLEGE",
  "GROW MORE DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "GOVERNMENT ARTS, COMMERCE AND SCIENCE COLLEGE, KUKAVAV VADIYA",
  "SHREE B D S ARTS, SCIENCE AND COMMERCE COLLEGE",
  "Satish Goswami College of Physiotherapy",
  "Samarpan Science and Commerce College",
  "NOOTAN COLLEGE OF NURSING VISNAGAR",
  "Sardargunj Mercantile Co. Op. Bank Ltd. (Anand) English Medium College of Commerce & Management, Vallabh Vidyanagar",
  "CHITRINI  INSTITUTE OF NURSING SCIENCE",
  "T & T V INSTITUTE OF NURSING",
  "CHITRINI INSTITUTE OF NURSING PBBSC NURSING",
  "GOVT NURSING COLLEGE,DHARPUR",
  "SHREE TAPASVI ARTS COLLEGE KOTDA DEODAR",
  "KRISHNA SCHOOL OF COMMERCE",
  "Maa Devmogara Government Arts College, Uchchhal, Tapi",
  "School of Computer Science, RK University, Rajkot",
  "JIVAN JYOT DIPLOMA IN HEALTH AND SANITARY INSPECTOR  ",
  "JIVAN JYOT MSW COLLEGE",
  "TAPOVAN COLLEGE OF NURSING",
  "ASH SCHOOL OF NURSING BSC NURSING , VIJAPUR",
  "President Commerce College",
  "SHREE SAMANVAY NURSING COLLEGE",
  "JOITIBA COLLEGE OF DIPLOMA IN HEALTH AND SANITARY INSPECTOR",
  "BRS COLLEGE ANDROKHA",
  "SHAYONA INSTITUTE OF MANAGEMENT AND COMPUTER APPLICATION",
  "SHREE MOHANBHAI MEGHAJIBHAI KANANI COMMERCE COLLEGE",
  "NOBLE INSTITUTE OF TECHNOLOGY",
  "MERCHANT INSTITUTE OF NURSING PILUDARA",
  "Government Arts College, Vallabhipur",
  "SIDDHI B. ED. COLLEGE, AHMEDABAD",
  "RITA A PATEL INSTITUTE OF PHYSIOTHERAPY",
  "MAHARANI PREMKUMARI COLLEGE OF RURAL SCIENCES",
  "N.R. Institute of Business Management (GLS-MBA)(SFI)-Ahmedabad",
  "EKLAVYA BRS COLLEGE, KALARANI ",
  "ASIAN DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE",
  "SMT R P BHALODIA GIRLS BCA COLLEGE, UPLETA",
  "AHMEDABAD INSTITUTE OF BUSINESS STUDIES",
  "SHRI J M SABVA INSTITUTE OF ENGINEERING AND TECHNOLOGY 698",
  "WE CARE COLLEGE OF NURSING, MANDVI",
  "ASIAN DIPLOMA IN FIRE AND SEFTY COLLEGE",
  "MERCHANT ENGG. COLLEGE, BASNA. VISNAGAR 065",
  "J. G. COLLEGE OF PERFORMING ARTS",
  "Ganpat University V.M. Patel College of Management Studies",
  "Department of Business Management, Sankalchand Patel College of Engineering",
  "NOOTAN AYURVEDIC COLLEGE AND RESEARCH CENTRE",
  "SHREE SWAMINARAYAN GURUKUL SCIENCE AND COMPUTER SCIENCE COLLEGE",
  "MANGUBA M. ED. COLLEGE, VAHELAL",
  "The Mandvi Education Society Science College",
  "Prabhu BCA College",
  "Jetpur Law College ",
  "parul institute of Social Work",
  "ARRDEKTA INSTITUTE OF DIPLOMA IN HEALTH AND SANITARY INSPECTOR ",
  "M. L. Parmar Science College",
  "EKLAVYA COMMERCE COLLEGE, KALARANI",
  "Mahadev Desai Gram Seva Mahavidyalaya (for Boys), Sadra",
  "POLYTECHNIC IN HORTICULTURE, NAVSARI",
  "SARVA VIDHYALAYA MED COLLEGE KADI",
  "Elite Institute of Science, Technology and Management",
  "SHRI ARJUN B.Sc COLLEGE SUPASI",
  "INDUS INSTITUTE OF TECHNOLOGY & ENGINEERING",
  "AMC DENTAL COLLEGE, AHMEDABAD",
  "AMRUT INSTITUTE JUNAGADH (B.SC. COLLEGE)",
  "B G Garaiya Ayurveda College",
  "SILVER OAK COMMERCE COLLEGE",
  "GOVERNMENT ARTS COLLEGE, VAV",
  "SMT H.B.SANGHAVI MAHILA ARTS AND COMM COLLEGE RAJULA",
  "SHRI ARJUN B.COM COLLEGE SUPASI",
  "K R DOSHI B COM COLLEGE",
  "SHRI SURBHI MSW COLLEGE",
  "College of Horticulture Anand",
  "MAHAVIR COLLEGE OF NURSING ",
  "NUTAN COMMERCE COLLEGE - AMRELI",
  "JAFARI AND FATIMA COLLEGE",
  "Haridarshan MSW College",
  "Balaji Law College - Gomta",
  "LAW COLLEGE ANDROKHA",
  "Agarwal Vidya Vihar English Medium College",
  "Shri Shah K.L Institute for the Deaf - Trust Teachers Training College",
  "SHRI AMBALAL M.PATEL(Avni Seeds) MAHILA EDUCATION COLLEGE,UNJHA.",
  "SCIENCE AND COMMERCE COLLEGE,SATLASNA",
  "ADIVASI PGDCA STUDY CENTER,VYARA",
  "Narmada M.S.W College, Mangrol",
  "Rudra Goswami College of Computer Application",
  "Swaminarayan College of Engg., Saij, Kalol",
  "AMRITA PATEL CENTRE FOR PUBLIC HEALTH",
  "TRASWAD BED COLLEGE, TRASWAD",
  "Darshan Institute of Engineering and Technology",
  "SHREE UMIYA BCA COLLEGE",
  "CHANCHALBEN MAFATLAL PATEL COLLEGE OF NURSING",
  "ASIAN MSW COLLEGE",
  "Ambaji Nursing College",
  "ARRDEKTA INSTITUTE OF DIPLOMA IN FIRE AND SAFETY ",
  "MED COLLEGE  VIDHYANAGARI",
  "SHRI SARASWATI GRAM VIDHYAPITH SAMODA GANWADA",
  "ASIAN BSW COLLEGE ",
  "Sheth Shree Bhuralal Chhaganlal Shah Arts College, Vadali",
  "HANSABA COLLEGE OF ENGINEERING & TECHNOLOGY, SIDDHPUR",
  "INSTITUTE OF INFORMATION AND COMMUNICATION TECHNOLOGY",
  "INSTITUTE OF DESIGN ENVIRONMENT AND ARCHITECTURE",
  "SHREE R N MEHTA COLLEGE",
  "BALHANS COLLEGE OF SOCIAL WORK THAVA",
  "SHREE SWAMINARAYAN NURSING COLLEGE",
  "VRUNDAVAN COLLEGE OF EDUCATION GANESHPURA",
  "DR JIVRAJ MEHTA INSTITUTE OF POLYTECHNIC",
  "Narayani College of Education",
  "RADHE SCHOOL OF PHARMACY, HIRPURA 238",
  "NAVGUJARAT COMMERCE COLLEGE",
  "SHRI ARBUDA YUVA EDUCATION TRUST LAKHANI MANAGED ARTS COLLEGE LAKHANI",
  "Dinshaw Daboo Law College, Navsari",
  "GAYATRI GURUKRUPA ARTS AND COMMERCE COLLEGE ",
  "SHREE PAREKH LAW COLLEGE",
  "D. R. Patel & R. B. Patel Commerce College & Navnirman Institute of Management",
  "MAHARSHI DAYANAND PGDMLT COLLEGE BASPA",
  "SAHAJANAND COLLEGE OF EDUCATION BECHARAJI",
  "BRAHMANAND COLLEGE OF SCIENCE ",
  "S. S. AGRAWAL HOMOEOPATHIC MEDICAL COLLEGE, NAVSARI",
  "SHREE M M PATEL DIPLOMA IN HEALTH AND SANITARY INSPECTOR COLLEGE LAKHANI",
  "Shri Umiya Education B.Ed. College",
  "OM INSTITUTE OF TECHNOLOGY VANTAVACHHODA, PANCHAMAHAL 103 ",
  "Khyati College of Nursing",
  "SHANTAM COLLEGE OF NURSING",
  "ANANYA COLLEGE OF AYURVED",
  "IQRA Science College",
  "SMT HANSABEN JAYANTIBHAI PATEL ARTS AND COMMERCE GIRLS COLLEGE",
  "Shree Ambika Sanskrit Mahavidyalaya, Ambaji",
  "BHARAT EDUCATION TRUST BCA COLLEGE RASANA MOTA",
  "SWARRNIM COLLEGE OF AGRICULTURE",
  "Guruvandana Law College,Kalawad",
  "VED BSW COLLEGE    ",
  "N. P. Commerce (Eng. Med.) College-Keshod",
  "VRUNDAVAN B Sc COLLEGE, GANESHPURA",
  "MUKTAJIVAN INSTITUTE OF INNOVATIVE TECHNOLOGY",
  "SHREE GANESHBHAI NAGJIBHAI PATEL COMMERCE COLLEGE, NANIKADI",
  "JG COLLEGE OF EDUCATION (GUJARATI MEDIUM)",
  "SHREE V R PATEL ARTS COLLEGE,THARA",
  "SHREE SWAMINARAYAN GURUKUL NURSING COLLEGE",
  "GMERS MEDICAL COLLEGE,RAJPIPLA",
  "DIVYACHETANA MSC COLLEGE",
  "AVIRAT BBA BCA COLLEGE",
  "POLYTECHNIC IN ANIMAL HUSBANDRY",
  "S.N.M. Shah M.Ed. College",
  "Government Arts College, Talaja",
  "B D BARAD B ED COLLEGE",
  "V M PATEL PGDCA STUDY CENTER",
  "MERCHANT HOMOEOPATHY MEDICAL COLLEGE AND HOSPITAL",
  "SHREE K S JAVERI COMMERCE COLLEGE, GADH",
  "B Sc COLLEGE, RASANAMOTA",
  "SWARRNIM SCIENCE COLLEGE",
  "SARVOPARI COLLEGE",
  "Shri H. N. Sukala Homeopathic Medical College and Hospital",
  "POLYTECHNIC IN HORTICULTURE, PARIA",
  "TAPOVAN COLLEGE OF EDUCATION",
  "LAXMIBEN HOMOEOPATHIC INSTITUTE AND RESEARCH CENTER",
  "POLYTECHNIC IN AGRICULTURE, VYARA",
  "S M G K ARTS, COMMERCE AND SCIENCE COLLEGE",
  "CRYSTAL INSTITUTE OF SANITARY INSPECTOR",
  "GOVERNMENT HOMOEOPATHIC MEDICAL COLLEGE, DETHALI",
  "MURLIDHAR AYURVED COLLEGE",
  "SMT M M PATEL MSW COLLEGE VIJAYNAGAR",
  "CRYSTAL INSTITUTE OF FIRE SAFETY",
  "POLYTECHNIC IN AGRICULTURE, MAKTAMPUR",
  "SCHOOL OF PHARMACY",
  "GOVERNMENT ARTS, COMMERCE AND SCIENCE COLLEGE, UMARPADA",
  "DALIA INSTITUTE OF TECHNOLOGY",
  "POLYTECHNIC IN AGRICULTURAL ENGINEERING, DEDIAPADA",
  "Joriya Parmeshwar Arts and Science College,Jambughoda",
  "PANDIT NATHULAL VYAS COLLEGE OF SCIENCE, MANAGEMENT, I T AND COMMERCE",
  "GUJARAT COMMERCE COLLEGE",
  "B V PATEL INSTITUTE OF MANAGEMENT",
  "MAHATMA GANDHI INSTITUTE OF COMPUTER APPLICATION",
  "SHRI SHANKAR MED COLLEGE",
  "MADINATUL ILM SCIENCE COLLEGE",
  "Yadunandan Ahir Education Sanchalit  Dr. Ranmal Nathabhai Varotariya Mahila Arts College ",
  "Yadunandan Ahir Education Sanchalit MatruShree Rambhiben Devatbhai Kothiya Mahila  Commerce College ",
  "SHREE UKABHAI DODIYA COMMERCE COLLEGE",
  "ARIHANT SCHOOL OF PHARMACY",
  "Shri Odhavram Physiotherapy College",
  "Binary Skill Development Training - Lunawada",
  "ITM COLLEGE OF NURSING",
  "VIDHYADEEP INSTITUTE OF PHYSIOTHERAPY",
  "PARUL INSTITUTE OF MEDICAL SCIENCES AND RESEARCH",
  "SARDAR VALLABHBHAI PATEL INSTITUTE OF TECHNOLOGY-530",
  "D.N.V. International Education Academy",
  "S K PATEL INSTITUTE OF MANAGEMENT AND COMPUTER STUDIES",
  "NOOTAN MEDICAL COLLEGE AND RESEARCH CENTRE",
  "NOBLE ENGINEERING COLLEGE",
  "Sheth P.T. Mahila College of Arts & Home Science",
  "INDUBHAI PATEL COLLEGE OF PHARMACY & RESEARCH CENTRE, DHARMAJ",
  "INSTITUTE OF AVIATION TECHNOLOGY AND ENGINEERING",
  "B. P. Baria Science Institute, Navsari",
  "Post Graduate Institute of Fisheries Education and Research",
  "VICTORIA JUBILEE COLLEGE OF PHYSIOTHERAPY",
  "THAKORSHRI MULVAJI ARTS COLLEGE, KOTDASANGANI",
  "Vanbandhu College of Veterinary Science and Animal Husbandry",
  "V P DAVE COLLEGE OF EDUCATION MED SNDT,PILVAI",
  "KRISHNA SCHOOL OF EMERGING TECHNOLOGY & APPLIED RESEARCH",
  "PARUL INSTITUTE OF TECH., LIMDA, VAGHODIA",
  "SHETH B R POLYTECHNIC IN HORTICULTURE",
  "COLLEGE OF FOOD TECHNOLOGY",
  "Binary Skill Development Training Centre",
  "School of Science, RK University, Rajkot",
  "SWAMI VIVEKANAND SARVODAR EDUCATION COLLEGE POST GRADUATE DEPATMENT(M Ed)",
  "Shri Maneklal M Patel Institute of Sciences and Research",
  "P P SAVANI HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "VARSHA GOSWAMI COLLEGE OF PHARMACY",
  "SHRI DR R K PATEL AND K K PATEL BED COLLEGE, HADAD",
  "GROWMORE INSTITUTE OF MSCIT, BERNA",
  "VIVEKANAND INSTITUTE OF HOTEL & TOURISM MANAGEMENT -RAJKOT",
  "M L DHADUK ARTS AND COMMERCE COLLEGE BODELI    ",
  "SHREE DHANVANTRI PGDMLT  COLLEGE VAKHA DEODAR    ",
  "HASMUKH GOSWAMI COLLEGE OF ENGG, VAHELAL",
  "Vidhyadeep Institute of Science",
  "AAI RAMILA ARTS COLLEGE, DAHOD    ",
  "Shri Sadbhav Education Trust Sanchaliat Mahila College of Bhachau",
  "Arpit Nursing School and College",
  "SHREE SAMARPAN COLLEGE",
  "SHRI HARE KRISHNA COLLEGE    ",
  "S. P. B. English Medium College of Commerce, Surat",
  "SMT S N PATEL COLLEGE",
  "ARADHANA B Ed COLLEGE",
  "OM COLLEGE OF COMMERCE",
  "SILVER OAK INSTITUTE OF SCIENCE",
  "Smt. Vasantiben Ranchhodbhai Bhakta College Education",
  "T N RAO COLLEGE OF TEACHER EDUCATION ",
  "School of Science",
  "SWARRNIM INSTITUTE OF TECHNOLOGY",
  "SHREE SWAMINARAYAN PHYSIOTHERAPY COLLEGE KALOL",
  "VIDHYADEEP INSTITUTE OF ENGINEERING AND TECHNOLOGY(DIPLOMA)",
  "SILVER OAK COLLEGE OF VOCATIONAL EDUCATION",
  "CHRIST COLELGE, RAJKOT (ARTS, SCIENCE, COMMERCE)",
  "SAL INSTITUTE OF DIPLOMA STUDIES ",
  "V S RAVAL INSTITUTION OF NURSING PRANTIJ",
  "Navgujarat BCA College",
  "SWAMINARAYAN INSTITUTE OF MEDICAL SCIENCES AND RESEARCH",
  "SEVENTH DAY ADVENTIST ARTS AND SCIENCE COLLEGE",
  "Khyati School of Computer Applications",
  "Dr. Thakorbhai Patel Girls Commerce College",
  "SHREEBRAHMARSHISATAVALEKARSANSKRITMAHAVIDYALAY,PARDI",
  "ACHIEVER S I COLLEGE LIMDI    ",
  "ACHIEVER FIRE SAFETY COLLEGE LIMDI    ",
  "VIDHYADEEI INSTITUTE OF LIBERAL ARTS",
  "Anand Institute Of Management and Information Science",
  "PARUL POLYTECHNIC INSTITUTE, LIMDA",
  "SHRI NILKANTH COLLEGE OF SOCIAL WORK ",
  "COLLGE OF EDUCATION, DARAMALI (M Ed)",
  "DR SUBHASH MAHILA AHIR COLLEGE    ",
  "ARRDEKTA BSC NURSING COLLEGE",
  "SHREE SWAMINARAYAN BBA COLLEGE    ",
  "BHAGWAN MAHAVIR CENTRE FOR SKILL DEVELOPMENT",
  "Shree Rang Navchetan Commerce CollegeValia",
  "SARSWATI VAN VIDHYA MANDAL SANCHALIT  ARTS & COMMERCE COLLEGE, MANDVI, DIST. SURAT",
  "Gyanmanjari Pharmacy College",
  "SDA COLLEGE OF BUSINESS STUDIES    ",
  "SHRADDHA DIPLOMA HEALTH AND SANITARY INSPECTOR COLLEGE",
  "SAMARTH ARTS COLLEGE    ",
  "COLLEGE OF HORTICULTURE JUNAGADH AGRICULTURAL UNIVERSITY JUNAGADH    ",
  "SHREE SARASWATI ARTS AND SCIENCE COLLEGE",
  "Surat District Sahakari Bank Commerce College and Sayan Sahakari Khand Udhyog Arts College",
  "S. S. Agrawal College of Nursing Training College and Research Centre",
  "College of Applied Science & Professional Studies",
  "SRK Institute Of Management  and Computer Education",
  "Gyanmanjari Diploma Engineering College",
  "Shri Sarvajanik Science College",
  "SHRI BANASKANTHA KADVA PATIDAR SANSKAR MANDAL BSc COLLEGE",
  "Kinder Kin College of Education",
  "Jat College of Education",
  "Jeevan Chanan College of Education",
  "LAXMI COLLEGE OF EDUCATION, RATHIWAS",
  "Govt. College, Mohindergarh.",
  "YADUVANSHI DEGREE COLLEGE PATIKARA NARNAUL",
  "JIND CENTRAL JAYCEES EDUCATION AND CHARITABLE SOCIETY",
  "Saraswati College of Education",
  "Bhagwan Sri Krishan College of Education,Mandi Dabwali",
  "S.M.S. Khalsa Labana Girls College, Barara",
  "PURAN MURTI CAMPUS ",
  "RAO ADAL SINGH COLLEGE OF EDUCATION",
  "INDUS COLLEGE OF NURSING, KHANDA KHERI",
  "Panipat Institute of Engg. & Technology",
  "Government  College for Women , Gohana (Sonepat)",
  "RAMANUJAN COLLEGE OF EDUCATION",
  "Guru Gorakhnath Ji Government  College, Hisar",
  "L.C.R.T. College of Education",
  "R.S. Memorial College of Education",
  "Lala Ami Chand Monga Memorial College of Law",
  "Geeta Institute of Law",
  "GOVERNMENT COLLEGE FOR WOMEN, BEHAL",
  "Dyal Singh College Karnal",
  "D.C. JAIN COLLEGE OF EDUCATION",
  "Sri Guru Harkrishan Sahib Khalsa College, Panjokhra Sahib",
  "RAO UDMI RAM MEMORIAL COLLEGE OF EDUCATION",
  "MAJOR BIHARI LAL MEMORIAL COLLEGE OF EDUCATION",
  "RAO NEKI RAM MEMORIAL COLLEGE",
  "GOVT COLLEGE NIGDHU",
  "THE E FIVE COLLEGE FOR WOMEN GARHI HANSI HISAR",
  "SMT SHANTI DEVI COLLEGE OF NURSING SAHARANWAS REWARI",
  "GCG Gulha Cheeka (Kaithal)",
  "MAA SARASWATI TEACHERS TRAINING INST.",
  "C.R. COLLEGE OF EDUCATION",
  "laxmi college of education",
  "JHANKAR COLLEGE OF EDUCATION",
  "GOVT. COLLEGE RITHOJ",
  "Govt College for Girls, Manesar, Gurugram",
  "K.V.M. COLLEGE OF EDUCATION",
  "RASTRIYA VIDYA EDUCATION COLLEGE",
  "D.V.M. COLLEGE OF EDUCATION",
  "G.B. COLLEGE OF EDUCATION",
  "DRONA COLLEGE OF EDUCATION",
  "DAYAWANTI MEMORIAL COLLEGE OF EDUCATION",
  "CHANDERAWATI COLLEGE OF EDUCATION",
  "J.R. KISSAN COLLEGE OF EDUCATION",
  "NNSS Samalkha Group of Institutions",
  "BALAJI COLLEGE OF EDUCATION",
  "Satyam College of Education for Women",
  "B M GROUP OF INSTITUTIONS Vill. Hari Nagar (Dumha) , Farukh Nagar, Distt. Gurgaon",
  "SURAJ DEGREE COLLEGE",
  "STAREX INSTITUTE OF EDUCATION",
  "SREE SHIV CHAITANYA COLLEGE OF EDUCATION",
  "M.K.M COLLEGE OF EDUCATION FOR WOMEN",
  "DARSH COLLEGE OF EDUCATION",
  "SHRI SHANTI SAGAR JAIN COLLEGE OF EDUCATION FOR GIRLS",
  "SHRI SHANTI SAGAR JAI KANYA M. FEROZEPUR JHIRKA",
  "SHRI RAM COLLEGE OF EDUCATION",
  "Anangpuria  School of Management &Technology",
  "SANDESH COLLEGE OF EDUCATION",
  "College of Traffic Management Institute of Road Traffic Education ",
  "S.D. COLLEGE OF EDUCATION",
  "GURU NANAK INSTITUTE OF HIGHER EDUCATION ",
  "SHRI ATAL BIHARI VAJPAYEE GOVERNMENT MEDICAL COLLEGE",
  "GOVERNMENT COLLEGE DING MANDI ",
  "SARDAR PATEL COLLEGE OF EDUCATION",
  "VAISH GIRLS COLLEGE SAMALKHA",
  "Government College, Naraingarh",
  "SHREE RAM COLLEGE OF VETERINARY SCIENCE",
  "ROYAL INSTITUTE OF SCIENCE AND MANAGEMENT",
  "BHARTIYAM COLLEGE OF EDUCATION",
  "Dr. Ganesh Dass DAV College of Education for Women",
  "C.L. COLLEGE OF EDUCATION",
  "GOVERNMENT COLLEGE, KOSLI",
  "R.K. COLLGE OF EDUCATION, GURGAON",
  "Delhi College of Technology & Management",
  "B.M. COLLEGE OF EDUCATION",
  "Govt College Mangali Hisar",
  "H.D. COLLEGE OF EDUCATION",
  "B.L. COLEGE OF EDUCATION",
  "ODM COLLEGE FOR WOMEN",
  "United College of Education",
  "Rajendra Institute of Technology & Sciences, Sirsa",
  "G.S. COLLEGE OF EDUCATION",
  "BASANT LAL MEMORIAL COLLEGE OF EDUCATION",
  "Akido College of Engineering, Sahpur",
  "SCOPE REHABILITATION CENTRE",
  "Dayanand Mahila Mahavidyalaya",
  "D.S. ARYA COLLEGE OF EDUCATION",
  "Govt. College, NAGINA",
  "SAHEED CAPT. D.K. KHOLA COLLEGE OF EDUCATION",
  "BHAGWAN PRASHU RAM COLLEGE OF EDUCATION",
  "SAI MOHAN COLLEGE OF EDUCATION",
  "GOVERNMENT COLLEGE FOR WOMEN DHANAURI",
  "Govt College Uklana",
  "Gaur College of Education",
  "GOVT COLLEGE, KURAL BHIWANI",
  "MANGE RAM WOMENS COLLEGE OF EDUCATION",
  "MAA OMWATI COLLEGE OF EDUCATION",
  "MUKHI COLLEGE OF NURSING",
  "Govt. College, Birohar Distt.Jhajjar.",
  "JANTA VIDYA MANDIR GANPAT RAI RASIWASIA COLLEGE, CHARKHI DADRI",
  "D.H. LAWRENCE COLLEGE OF EDUCATION FOR WOMEN",
  "B.R.C.M.College of Engg. & Technology, Bahal,Distt. Bhiwani",
  "Vaish College of Engg. Rohtak",
  "RISE MAX COLLEGE OF EDUCATION",
  "RATTAN SINGH GIRLS COLLEGE OF EDUCATION",
  "MEENAKSHI COLLEGE OF EDUCATION",
  "GOVERNMENT COLLEGE PATAUDI",
  "Government Post Graduate College, Ambala Cantt.",
  "Saraswati College of Education",
  "MODERN INTERNATIONAL COLLEGE OF EDUCATION",
  "MODERN COLLEGE OF EDUCATION, REWARI",
  "United College of Education",
  "DPG LAW COLLEGE    ",
  "M.D. College of Education",
  "Hindu College of Design, Architecture & Planning",
  "BHAI SURENDER KUMAR MEMORIAL NURSING SCHOOL, VIKAS NAGAR, JIND",
  "MODERN COLLEGE OF EDUCATION, SONIPAT",
  "Government College, Barwala",
  "BDM COLLEGE OF PHARMACY",
  "BHARAT COLLEGE OF LAW",
  "RAM JAS COLLEGE OF EDUCATION",
  "PARADISE COLLEGE OF EDUCATION",
  "OM COLLEGE OF EDUCATION, SONIPAT",
  "Kithana College of Education",
  "VAISH ARYA SHIKSHAN MAHILA MAHAVIDHALAYA",
  "N.S. COLLEGE OF EDUCATION",
  "NAVYUG COLLEGE FOR EDUCATION",
  "M.V.N. COLLEGE OF EDUCATION",
  "SHAHEED DALBIR SINGH GOVERNMENT COLLEGE, KHARKHODA",
  "MUKHI COLLEGE OF EDUCATION",
  "PURAN MURTI COLLEGE OF LAW    ",
  "KIRTI COLLEGE OF EDUCATION",
  "GEETA INSTITUTE OF PHARMACY",
  "K.C. COLLEGE OF EDUCATION",
  "JEEVAN JYOTI COLLEGE OF EDUCATION",
  "Swami Devi Dyal College of Education",
  "Sardar Chanan singh Ghuman Memorial College of Educaton",
  "Isharjyot Degree College, Vill, Dhanirampura, Teh. Pehowa",
  "Savitri Devi Memorial College of Education",
  "S.D. Institute of Education for Girls",
  "SHRI KRISHNA COLLEGE OF EDUCATION  RAO TULA RAM CHOWK MAHENDERGARH",
  "JAWAHAR LAL NEHRU COLLEGE OF EDUCATION",
  "JANTA COLLEGE OF EDUCATION",
  "Echelon Institute of Technology, Kabulpur Khadar,Patti Parvarish, Faridabad Manjavli Road, Naharpur Faridabad",
  "Seth Tek Chand College of Education",
  "RAO PAHLAD SINGH COLLEGE OF EDUCATION",
  "INSTITUTE OF TEACHER EDUCATION",
  "T.R. COLLEGE OF EDUCATION",
  "GANPATI COLLEGE OF EDUCAITON",
  "GCG Raipur Rani",
  "BABA JAI RAM DASS COLLEGE OF EDUCATION KHATOD",
  "G.B.Degree College, Rohtak",
  "Saini College (Co.-Edu.),Rohtak. (SFS)",
  "RAO NEKI RAM MEMORIAL COLLEGE OF EDUCATION",
  "Adarsh College of Education",
  "Guru Nanak Institute of Management",
  "Shri Guru Amardass College of Education",
  "HARSH COLLEGE OF EDUCATION",
  "M.K.M.COLLEGE OF MANAGEMENT & INFORMATION TECHNOLOGY FOR GIRLS,HODAL DISTT PALWAL HARYANA",
  "R.R. COLLEGE OF NURSING, WAZIRPUR, GURGAON",
  "M.P. National College, Mullana",
  "Ganga Institute of Technology & Management",
  "Kanya Gurukul College of Education",
  "Guru Nanak Girls College, Santpura",
  "D.B.M. COLLEGE OF EDUCATION",
  "G.V.M. COLLEGE OF EDUCATION FOR WOMEN",
  "DARPAN REHABILITATION AND RESEARCH CENTRE",
  "S.G. College of Education",
  "RURAL NURSING TRAINING INSTITUTE, VPO BARWASNI, HULLARI MORE, SONEPAT",
  "Aakash College of Education, Jind",
  "Govt College for Girls, Palwal (kurukshetra)",
  "Kalpana Chawla Govt Medical College",
  "GOVERNMENT COLLEGE FOR WOMEN BAHADURGARH",
  "S.R.M. College of Education",
  "Saraswati College of Education",
  "SUNRISE COLLEGE OF PHARMACY",
  "Govt. College, Ellenabad",
  "C.C.A.S.Jain Girls College Gannaur(Spt)",
  "ADARSH REHABILITATION CENTRE FOR MENTALLY AND PHYSICALLY HANDICAPPED CHILDREN",
  "Arya College of Education Baliyali ",
  "Ganpati Institute of Hotel Mgt (G.H.I.M.)",
  "Shanti Devi Law College",
  "Kamrah Institute of Information & Technology(KIIT)",
  "Defence Degree College Amani, Tohana",
  "Government College, Bhuna",
  "WORLD COLLEGE OF PHARMACEUTICAL SCIENCES",
  "C.R.D.A.V. Girls College, Ellenabad",
  "Government College for Women, Sirsa",
  "LORD KRISHANA COLLEGE OF EDUCATION",
  "D.A.V. College, Naneola",
  "Hindu Girls College, Jagadhri",
  "Sidhi Vinayak College of Education",
  "S.A. Jain College, Ambala City",
  "Sir Chottu Ram College of Education",
  "Govt. College, Badli 240033.",
  "Green Wood College of Education",
  "DELHI INSTITUTE OF MANAGEMENT",
  "Doon Valley College of Education Chirao",
  "Budha College of Education",
  "Swami Ganesha Nand Sanatan Dharam College of Education",
  "Tau Devi Lal Memorial College of Education,",
  "GOLD FIELD COLLEGE OF EDUCATION",
  "Vardey Devi College of Education",
  "GOVT. COLLEGE FOR WOMEN, NARNAUL",
  "Lakshay College of Education",
  "SWAMI VIVEKANAND COLLEGE OF EDUCATION",
  "GURU DRONACHARYA COLLEGE OF EDUCATION",
  "CCLS COLLEGE OF ARCHITECTURE AND DESIGN",
  "L.N.T. College of Education",
  "B.P.R. College of Education",
  "JAGAN NATH UNIVERSITY, JHAJJAR",
  "Govt. College Barota",
  "Puran Murti College of Pharmacy",
  "RAO LAL SINGH COLLEGE OF EDUCATION",
  "GEETA NIKETAN NURSING SCHOOL, LOHARU ROAD, CHARKHI DADRI",
  "Govt. College, Dubaldhan(Jhajjar)",
  "GEETA COLLEGE OF EDUCAITON",
  "NGF College of Engineering & Technology",
  "Pt. Chiranji Lal Sharma Govt. College, Sector-14",
  "Govt. College, Ateli(M.Garh)",
  "Modern College of Education",
  "GOVERNMENT COLLEGE SARASWATI NAGAR ",
  "GOVT COLLEGE FOR GIRLS BASTLI KARNAL",
  "GOVT COLLEGE GORIWALA",
  "GOVERNMENT COLLEGE CHAMMU KALAN KURUKSHETRA",
  "GANDHI COLLEGE OF NURSING, GT ROAD, BYE PASS, KARNAL",
  "Govt PG College for Women Rohtak",
  "Govt. College, SIDHRAWALI",
  "N.C. College of Education",
  "Ram Narayan Institute of Education",
  "Guru Harkrishan College of Education, Raitkhana, karnal, haryana",
  "AGGARWAL COLLEGE OF LAW WOMEN BALLABGARH FARIDABAD    ",
  "GANGA INSTITUTE OF EDUCATION",
  "S.P.S. Janta College, Mustafabad",
  "Haryana College of Education Rampura Road, Safidon",
  "KESHAV LAW COLLEGE",
  "I.G. Government College, Tohana",
  "K.T. Government College, Ratia",
  "Sanatan Dharam Sanskrit Mahavidyalya, Sirsa",
  "C.M.K. National P.G. College, Sirsa",
  "Shah Satnam Ji Boys College, Shahpur Begu, Sirsa",
  "Shri Durga Mahila Mahavidyal, Tohana",
  "Shah Satnam Ji Girls College, Sirsa",
  "Janta Girls College, Ellenabad",
  "ARYAWART COLLEGE OF EDUCATION",
  "Government College, Bhattu Kalan, Fatehabad",
  "MANOHAR MEMORIAL COLLEGE, FATEHABAD",
  "Government National College, Sirsa",
  "Mata Harki Devi College for Women, Odhan",
  "Lala Hans Raj Phutela College of Law (Evening), Sirsa",
  "M.P. College for Women, Mandi- Dabwali",
  "Sri Guru Hari Singh College, Sri Jiwan Nagar",
  "SARASWATI COLLEGE OF EDUCATION, MAHENDRAGARH",
  "ROHITASH VETERINARY COLLEGE, ATELI MANDI",
  "G.V.M. Institute of Technology and Management",
  "Gateway Institute of Engineering and Technology",
  "Gateway College of Architecture & Design",
  "Hindu Institute of Management",
  "Government College, Hansi",
  "Bharat Institute of Techonlogy",
  "Bhagwan Parshuram College of Education",
  "Hindu College of Engineering",
  "Daronacharya College of Educaiton",
  "I.S.M. COLLEGE FOR GIRLS ",
  "M.D.S. DEGREE COLLEGE ",
  "SETH KALURAM GOYAL GOVERNMENT COLLEGE, KADMA ",
  "M.R.M COLLEGE OF EDUCATION",
  "SJS International College of Education",
  "Dronacharya College of Engineering,  Farukh Nagar, Gurgaon",
  "Hindu Instt. of Management & Technology",
  "Govt. College, Bahadurgarh.",
  "Maa Omwati Institute of management & Technology",
  "National Power Training Institute ,  Faridabad.",
  "Haryana College of Education",
  "City College of Education",
  "BHARAT VIDYA PEETH COLLEGE OF EDUCATION",
  "CBS College of Pharmacy and Technology",
  "C.R. College of Education",
  "ARAVALI COLLEGE OF ADVANCED STUDIES IN EDUCATION",
  "AGGARWAL COLLEGE OF EDUCATION, HODAL",
  "Jeevan Chanan Mahila Mahavidyalaya, Assandh",
  "Mata Sundri Khalsa Girls  College, Nissing (Karnal)",
  "Government College for women Ambala city ",
  "Maharishi Dayanand Govt. Girls College Dadupur Roran Karnal",
  "Ambala College of Engineering & Applied Research",
  "Government College for Women",
  "Budha college of Higher education",
  "BABA KHETANATH GOVT AYURVEDIC COLLEGE AND  HOSPITAL , PATIKARA , NARNAUL",
  "SARASWATI VIDYA MANDIR COLLEGE OF EDUCATION",
  "Lala C.B.Aggarwal College",
  "Babu Anant Ram Janta College of Education",
  "N.R.B. COLLEGE OF EDUCATION",
  "Govt. College for Women, Madlauda (Panipat)",
  "GOVT COLLEGE RAJOUND KAITHAL",
  "Swami Vivekanand College of Education",
  "AGGARWAL COLLEGE OF EDUCATION, BALLABGARH",
  "Manav Institute of Technology & Management",
  "LALA BIRKHA RAM COLLEGE OF PHARMACY",
  "Shri Baba Mast Nath Institute of Management Studies and Research",
  "Shri Baba Mast Nath College of Physiotherapy, Asthal Bohar, Rtk",
  "Bhai Surender Kumar Memorial College of Education",
  "KIRTI COLLEGE OF LAW",
  "SHREE RAM COLLEGE OF PHARMACY",
  "ADESH NURSING COLLEGE",
  "S.J.K. COLLEGE OF EDUCATION",
  "International Institute of Veterinary Education and Research",
  "GOVT. COLLEGE KRISHAN NAGAR",
  "Pt.Neki Ram Sharma G.C. Rohtak.",
  "MAHARANA PRATAP  MAHILLA MAHAVIDYALAYA BHIWANI",
  "Govt. College, Chhachhrauli",
  "D.C.S COLLEGE OF EDUCATION",
  "GANGA COLLEGE OF EDUCATION",
  "G.M.N. College,",
  "SH.SANATAN DHARAM SANSKRIT COLLEGE.BHIWANI",
  "D.A.V. College, Pehowa",
  "Swami Devi Dyal Institute of Management Studies",
  "Dev Samaj College for Girls",
  "Geeta Engg. College",
  "Shri Krishan Institute of Engineering & Technology",
  "Guru Nanak Instt. Of Tech.",
  "Delhi Institute of Technology and Management",
  "M.D. COLLEGE  OF EDUCATION",
  "Arya Kanya Mahavidyalaya, Mor-Majra,",
  "Markanda National College",
  "The Technological Institute of  Textile & Sciences, Bhiwani",
  "Manish Papneja Memorial S.D. Girls College, Ismailabad",
  "JAI GEETANJALI COLLEGE OF EDUCATION ",
  "KRISHNA DEGREE COLLEGE",
  "MCM COLLEGE OF SPECIAL EDUCATION JULANA JIND",
  "N.C.Medical College and Hospital",
  "GOVT COLLEGE JATUSANA",
  "World College Of Medical Sciences and Research and Hospital",
  "Dr. B.R. Ambedkar Govt. College",
  "SARDAR PATEL INSTITUTE OF HIGHER EDUCATION KURUKSHETRA",
  "Govt College Narnaund",
  "Oxford International College of Education",
  "VENKETESHWAR COLLEGE OF EDUCATION",
  "Vinayak Institute of Management",
  "MAHENDER SINGH COLLEGE OF PHARMACY",
  "Govt. College For Women Shahzadpur (Ambala)",
  "College of Agriculture",
  "RNRM COLLEGE OF PHARMACY",
  "Shri Sant Ram College of Education",
  "BHIMESHWARI DEVI COLLEGE OF EDUCATION",
  "GANGAPUTRA AYURVEDIC COLLEGE",
  "SOUTH POINT COLLEGE OF PHARMACY, NANGAL KHURD",
  "GOVT COLLEGE BARODA",
  "Delhi Global Institute of Management, Jasana, Faridabad",
  "Lakshay College of Hotel Management",
  "Jind Institute of  Engineering & Technology",
  "ADARSH COLLEGE OF EDUCATION, JHAJJAR",
  "D.A.V. College, Karnal.",
  "Shree Ram Mulkh Institute of Engg. & Tech.",
  "S.D. Mewat Institute of Technology & management",
  "Jat College",
  "HAPPY CHILD COLLEGE OF NURSING,SONIPAT",
  "Swami Devi Dayal Hospital & Dental College, Golpura(Panchkula)",
  "Lord Shiv College of Pharmacy, Sirsa",
  "Green Valley College of Education",
  "Geeta Institute of Education",
  "Geeta College of Education",
  "Mahila Mahavidyalaya, JHOJHU KALAN",
  "G.G.D.S.D.College",
  "RISHIKUL SANSKRIT COLLEGE",
  "MAHARISHI ARVINDO COLLEGE OF EDUCATION BHATTU MANDI",
  "STATE INSTITUTE OF ADVANCED STUDIES IN TEACHER EDUCATION GURUGRAM",
  "G.L WOMEN DEGREE COLLEGE",
  "GOVT COLLEGE BHAINDOLI",
  "PT. L.R. COLLEGE OF EDUCAITON",
  "Geeta Arya College of Education",
  "Pt. B.D.Sharma , PGIMS , Rohtak",
  "BRIGHT COLLEGE OF EDUCATION",
  "B.K. COLLEGE OF EDUCATION",
  "Arya Kanya Mahavidyalya, Shahabad-Markanda",
  "GOVT COLLEGE BHAINSWAL KALAN",
  "BABA SIDDHNATH COLLEGE OF EDUCATION",
  "MAA SARASWATI INSTITUTE OF ENGINEERING & TECHNOLOGY, KALANAUR",
  "Sant Nischal Singh College of Education for Women, Santpura ,Yamunanagar ",
  "ST ANDREWS INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "ADARSH COLLEGE OF EDUCATION, BHIWANI",
  "AARYAN COLLEGE OF EDUCATION,ROHTAK",
  "Rattan Institute of Technology & Management",
  "BDM LAW COLLEGE, CHHUCHHAKWAS, JHAJJAR",
  "GOVT COLLEGE FEROZEPUR JHIRKA NUH",
  "Maharaja Agrasen Institute of  Management & Technology",
  "GOVERNMENT COLLEGE BHERIAN, PEHOWA",
  "DBM SPECIAL COLLEGE OF EDUCATION",
  "Bhumika Institute of Veterinary Sciences",
  "Govt. College For Girls, Rania",
  "B.S.Anangpuria Institute of Law",
  "GOVERNMENT COLLEGE BAHU, JHAJJAR",
  "Sh. Atamanand Jain Institute of Management & Technology",
  "R K COLLEGE OF LAW, HUMAYUNPUR, ROHTAK",
  "SHRI SAI BABA COLLEGE OF EDUCATION",
  "Arya Girls College, Ambala Cantt.",
  "RAO BIRENDER SINGH STATE INSTITUTE OF ENGINEERING and TECHNOLOGY , ZAINABAD",
  "VIDYA BHAVAN COLLEGE OF EDUCATION",
  "SHRI RAM COLLEGE OF EDUCATION",
  "GOVT. COLLEGE FOR WOMEN PALI REWARI",
  "Govt. College for Women, Rewari.",
  "Rameshwar Dass Saraf  Public Girls College,Rewari.",
  "Yaduvanshi Institute of Edu., Bucholi Road,M.Garh",
  "NATIONAL COLLEGE OF EDUCATION",
  "RAO KHEM CHAND COLLEGE OF EDUCATION",
  "SIASTE KURUKSHETRA",
  "Arya College of Education",
  "SARASWATI COLLEGE OF EDUCATION",
  "S.J.K.College, Kalanaur (Rohtak.)",
  "G.D.R. College of Education",
  "SARASWATI COLLEGE OF PHARMACY",
  "ARYAVART COLLEGE OF EDUCATION",
  "C.R.A. College, Sonepat.",
  "GOVT COLLEGE CHATTER",
  "GOVT COLLEGE BAUND KALAN",
  "Somany Institute of Technology and Management",
  "RASHTRIYA COLLEGE OF EDUCATION",
  "GOVT. COLLEGE FOR WOMEN, JASSAUR KHERI",
  "Govt. College, Dujana (Jhajjar)",
  "SAKSHI MALIK GOVT COLLEGE , MOKHRA",
  "RAO NIHAL SINGH COLLEGE OF EDUCAITON",
  "Saradar Kartar Singh Hayer College of Nursing ",
  "PARAMOUNT COLLEGE OF EDUCATION",
  "OXFORD COLLEGE OF EDUCATION",
  "S S M COLLEGE OF PHYSICAL EDUCATION KALAYAT",
  "NARAYANA COLLEGE OF EDUCATION",
  "Y.M.D.College, NUH",
  "M.R. NAUHNTY COLLEGE OF EDUCATION",
  "Raj Rajeshwari College of Education",
  "THE BALAJI COLLEGE OF VETERINARY SCIENCE AND RESEARCH CENTRE",
  "M R COLLEGE OF EDUCATION, JHAJJAR",
  "S.P. COLLEGE OF EDUCATION",
  "MR DAV COLLEGE OF EDUCATION",
  "GOVERNMENT COLLEGE LADANA CHAKU KAITHAL",
  "THE SEHRAWAT COLLEGE OF VETERINARY SCIENCES",
  "CH. KATAR SINGH MEMORIAL COLLEGE OF EDUCATION, VPO. ASSAN",
  "K.R. COLLEGE OF EDUCATION",
  "SANSKARAM COLLEGE OF VETERINARY AND ANIMAL SCIENCES",
  "RPS COLLEGE OF VETERINARY SCIENCES",
  "VIDYAWATI SANSKRIT COLLEGE",
  "Footwear Design and Development Institute - Rohtak",
  "R.L.S. COLLEGE OF EDUCATION",
  "Government College, Aharwala , (Bilaspur) Yamunanagar ",
  "SURAJ DEGREE COLLEGE MAHENDERGARH",
  "RAO RAM SINGH COLLGE OF EDUCATION",
  "S.D. Institute of Management & Technology",
  "PT. RAM NIWAS COLLEGE OF EDUCATION",
  "GOVT P G COLLEGE CHARKHI DADRI",
  "ST. PAUL COLLEGE OF EDUCATION",
  "PROGRESSIVE LEARNING COLLEGE OF EDUCATION",
  "S.S.M. COLLEGE OF EDUCATION",
  "Ahir College, Rewari.",
  "S.S. COLLEGE OF EDUCATION",
  "MODERN COLLEGE OF EDUCATION, PALI",
  "MODERN COLLEGE OF EDUCATION, BHOJAWAS",
  "MDS COLLEGE OF EDUCATION, KOSLI",
  "FORE ACADEMY OF MANAGEMENT EDUCATION",
  "MATA VAISHNU DEVI COLLEGE OF EDUCATION",
  "KRISHNA COLLEGE OF EDUCATION",
  "S.R. COLLEGE OF EDUCATION",
  "KRISHNA ADARSH COLLEGE OF EDUCATION",
  "K.L. COLLEGE OF EDUCATION",
  "K.D. COLLEGE OF EDUCATION, PALI",
  "K.D. COLLEGE OF EDUCATION",
  "J.R. MEMORIAL COLLEGE OF EDUCATION",
  "SHEETAL COLLEGE OF EDUCATION",
  "SAT PRIYA COLLEGE OF EDUCATION",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY PANCHKULA",
  "H.J. INSTITUTE OF EDUCAITON & TECHNOLOGY",
  "SARVODYA COLLEGE OF EDUCATION",
  "TAGORE COLLEGE OF EDUCATION",
  "WOMEN COLLEGE OF EDUCATION",
  "S.D. COLLEGE OF EDUCATION",
  "Tagore college of veterinary sciences ",
  "Ch. Devi Lal Memorial Girls College, Sewah",
  "GOVT. COLLEGE OF EDUCATION, BHIWANI",
  "VIVEKANAND COLLEGE OF EDUCATION",
  "VIKRAMADITYA COLLEGE OF EDUCATION",
  "V.B. COLLEGE OF EDUCATION",
  "VAISH COLLEGE OF EDUCATION, Rohtak",
  "CH. RANBIR SINGH STATE INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "Tirupati College of Education, Sardulgarh Road, Ratia",
  "GOVERNMENT COLLEGE FOR WOMEN, ATELI ",
  "VENKTESHWARA COLLEGE OF EDUCAITON",
  "Surya College of Education, Vill. Baliala, Tohana",
  "Sir Chhotu Ram Jat College of Education, Ellanabad",
  "R.S.M. Veterinary Institute",
  "Lingay's Institute of Health Sc. ( Nursing), Vill Kanwara, Faridabad",
  "MAHARAJA NEEMPAL SINGH GOVERNMENT COLLEGE, BHIWANI",
  "SUN RISE COLLEGE OF EDUCATION",
  "Rashoba College of Education, Post Box No. 27, Moriwala, Sirsa",
  "UNIVERSITY INSTITUTE OF ENGG AND TECHNOLOGY",
  "Indira  Priyadarshani College for Women, Jhajjar.",
  "Kanya Mahavidyalaya, Kharkhoda",
  "Thakardevi T. DAV Institute of Physiotherapy & Reh. , prof colony, Yamunanagar",
  "MRDAV Institute of Management Studies",
  "RATTAN INSTITUTE OF MANAGEMENT ",
  "ST. LUKE COLLEGE OF EDUCATION",
  "Saket College of Physiotherapy, Chandi mandir, PKL",
  "S S COLLEGE OF EDUCATION, GOHANA",
  "Advance Institute of Pharmacy, 70 KM-Delhi Mathura Road, Aurangabad, Faridabad",
  "SOUTH POINT COLLEGE OF EDUCATION",
  "Swami Devi Dayal College of Nursing, Golpura, Panchkula",
  "Mata Raj Kaur Institute of Engineering & Technology",
  "PYARELAL NURSING COLLEGE MUBARIKPUR JHAJJAR",
  "SLD GIRLS COLLEGE OF EDUCATION",
  "SHRI GANESH COLLEGE OF EDUCATION, SONIPAT",
  "SHIV KARAN COLLEGE OF EDUCATION",
  "SHIV COLLGE OF EDUCATION",
  "Shah Satnam Ji College of Education, Shah Satnam Ji Dham, Dera Sacha Sauda, Sirsa",
  "Swami Vivekanand Nursing College, Nr. Sec 18, Huda Jagadhari",
  "Shaheed Bhagat Singh College of Education, Kalanwali",
  "MATA RAJ KAUR COLLEGE",
  "Gramin College of Education, VPO Jamalpur Sheikhan, Tohana",
  "KIRORIMAL COLLEGE OF EDUCATION",
  "Shaheed Baba Deep Singh College of Education,  Vill. Aharwan, Ratia",
  "Nehru College of Education",
  "GOVERNMENT ENGINEERING COLLEGE, NILOKHERI",
  "GOVT COLLEGE FOR GIRLS BAWAL",
  "MUH Jain College of Education, Vill. Chander Kalan, Tohana",
  "Ch.Dhajja Ram Janta, M., Butana(SFS) (Sonepat)",
  "MAA OMWATI DEGREE COLLEGE",
  "Hindu College for Girls, Sonepat.",
  "Chhotu Ram Institute of Law",
  "K.L.Mehta D.N.Coll. for Women",
  "Vaish Mahila Mahavidyalya,Rohtak ",
  "Vaish College, Rohtak.",
  "Institute of Management & Technology, Tigaon Road, Faridabad",
  "College of Teacher Education, Nuh",
  "M.M. College of Education, Sirsa Road, Fatehabad",
  "Government College for Women, Karnal",
  "SHIKSHA BHARTI COLLEGE OF EDUCATION, SONIPAT",
  "PKG COLLEGE OF ENGINEERING  TECHNOLOGY",
  "GOVT COLLEGE SULTANPUR FARRUKHNAGAR GURUGRAM",
  "SHAMBU DAYAL COLLEGE OF EDUCATION",
  "Mata Harki Devi College of Education for Women, Vill-Odhan",
  "J.G. College of Education, Hisar Road, C/o Bharat Sainik School, Sirsa",
  "Gandhi Adrash College, Samalkha",
  "SHRI RAM MEMORIAL COLLEGE OF EDUCATION BIDLAN SONIPAT",
  "Jan Nayak Ch. Devi Lal College of Education, Barnala Road, Sirsa",
  "SARASWATI VIDYA MANDIR COLLEGE OF EDUCATION",
  "Jai Mata College of Education",
  "YAMUNA INSTITUTE OF EDUCATION",
  "RAVINDRA BHARTI COLLEGE OF EDUCATION",
  "R.K. COLLEGE OF EDUCATION, ROHTAK",
  "RAMA KRISHNA COLLEGE OF EDUCATION",
  "Haryana College of Education, Dhani Bachan Singh, Ellenabad",
  "Hakeem Harbans Singh New Era College of Education, Sant Nagar, Rania",
  "Guru Dronacharya College of Education, Bhuna",
  "HARYANA SANSKRIT VIDYAPEETH",
  "SAINI INSTITUTE OF GIRLS EDUCATION",
  "SANSKRITI COLLEGE OF EDUCATION",
  "SARASWATI COLLEGE OF EDUCATION, ROHTAK",
  "Ideal Medical and Education Centre College of Nursing",
  "YASH COLLEGE OF EDUCATION",
  "INDER PRASTHA EDUCATION",
  "Defence College of Educaton, Tohana",
  "GURUGRAM GLOBAL COLLEGE OF PHARMACY",
  "G.C., TIGAON",
  "A.I.J.H.M.College, Rohtak.",
  "Government College of Nursing, Safidon, Jind",
  "Daffodils College of Education, Matana Road, Opposite-Police Line, Fatehabad",
  "D.A.V.Girls College, Kosli.",
  "INDUS COLLEGE OF EDUCATION",
  "Govt. College, HODEL",
  "GREEN MEADOWS COLLEGE OF EDUCATION",
  "HITKARI COLLEGE OF EDUCATION",
  "PUJYA SWAMI VIVEKANAND COLLEGE OF EDUCATION ",
  "COLLEGE OF MODERN EDUCATION BERLI KALAN",
  "H.N. COLLEGE OF EDUCATION",
  "J.K. MEMORIAL COLLEGE OF EDUCATION",
  "Crescent College of Education, Vill. Bhodia Khera",
  "K.C.M. ARMY COLLEGE OF EDUCATION",
  "K.M. COLLEGE OF EDUCATION",
  "C.R. D.A.V. Girls College of Education, Near Dabwali Road. Udham Singh Chowk, Ellenabad",
  "MAHARANA PRATAP COLLEGE OF EDUCATION FOR WOMEN",
  "MAJOR NAFE SINGH KUNGARIYA COLLEGE OF EDUCATION",
  "Ch. R.R. Memorial College of Education, Ellenabad",
  "Aakash College of Education, Vill. Chanderkalan, Tohana",
  "MLRS COLLEGE OF EDUCATION",
  "APEX College of Education Ellenabad",
  "Apex College of Education, VPO-Bidhai Khera, Tohana",
  "Yamuna Institute of Engineering & Technology",
  "SATYUG DARSHAN INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "APEX INSTITUTE OF VLDD",
  "Desh Bandhu Gupta Govt. College, Panipat",
  "Govt College For Girls Kulana (JHAJJAR)",
  "Government College, Israna",
  "G.A.V. DEGREE COLLEGE",
  "SVM COLLEGE OF NURSING",
  "STATE INSTITUTE OF ENGINEERING AND TECHNOLOGY PANCHKULA    ",
  "Jyotiba Phule Govt. College, Radaur, Yamunanagar",
  "Mahaveer Swami Institute of Technology",
  "J.K. Institute of Management Technology",
  "Dayanand College",
  "Government college for Girls, Ugalan",
  "SHIVOM  REHABILITATION CENTRE",
  "SBDS College of Veterinary and Animal Sciences",
  "Chaudhary Bhajan Lal Government College,Balsamand",
  "R.B.S. Degree College",
  "BITS LAW COLLEGE",
  "I.B. College, Panipat",
  "M. R. COLLEGE OF VETERINARY SCIENCES",
  "GOVT COLLEGE,  FATEHABAD DISTRICT HEADQUARTER",
  "Smt.Sushma Swaraj Government College for Girls ,Ballabgarh",
  "Govt.College,Chhilro",
  "RAO JAI RAM COLLEGE OF EDUCATION",
  "Government College, Nahar",
  "F.C. College for Women",
  "GCG Nacholi, Faridabad",
  "COLLEGE OF NURSING,PANDIT DEEN DAYAL UPADHYAYA UNIVERSITY OF HEALTH SCIENCES,KUTAIL KARNAL    ",
  "Rao Ram Singh Degree College",
  "DHARAMPUTRA COLLEGE OF PHARMACY",
  "S.R.M. College of Education",
  "DR B R AMBEDKAR LAW COLLEGE KURUKSHETRA    ",
  "Shri Kapil Muni Govt. College for Women, Kalayat",
  "MARC COLLEGE OF EDUCATION",
  "NAKSHTRA VIDYAPEETH",
  "Govt. College, Sihma",
  "BRCM LAW COLLEGE",
  "GCG Mandkola (Palwal)",
  "M.L.N. College, Radaur",
  "Government  College for women, Gurawara (Rewari)",
  "Guru Nanak Khalsa College, Yamuna Nagar",
  "MERI College of Engineering and Technology",
  "Sita Ram Arya Memorial College of Education",
  "Janta Institute of Veterinary Sciences, Butana, Sonipat",
  "GOVERNMENT COLLEGE FOR GIRLS , PADHA",
  "SHRI GANESH COLLEGE OF EDUCATION, MAHENDRAGARH",
  "D K PHARMA COLLEGE",
  "Ayujyoti Ayurvedic College , Jodhpuria, Sirsa",
  "Indira Gandhi National College, Ladwa (Dhanora), Distt. Kurukshetra",
  "Guru Nanak Khalsa Institute of Technology and Management Technical Campus, Yamuna Nagar",
  "Jan Nayak Ch. Devi Lal Memorial College of Engineering",
  "BMP COLLEGE OF EDUCATION",
  "ARYA COLLEGE OF EDUCATION, BHIWANI",
  "RAO MOHAR SINGH COLLEGE OF EDUCATION",
  "Yaduvanshi college of Edu., Patikara,Teh. Narnaul, M.Garh",
  "I.P. COLLEGE OF EDUCATION",
  "ADESH COLLEGE OF PHARMACY",
  "Bawa N.S. Janta Institute of Management & Technology",
  "BHAGWAN MAHAVIR COLLEGE OF EDUCATION",
  "SHAMSHER BHADUR SAXENA COLLEGE OF LAW",
  "PITAMAH UMDA SINGH COLLEGE OF EDUCATION",
  "Maharana Partap Institute of Technology & Management",
  "UNIVERSITY INSTITUTE OF LAW AND MANAGEMENT STUDIES GURGAON",
  "MAHARANA PRATAP COLLEGE OF EDUCATION",
  "MAHENDRA COLLEGE OF EDUCATION ",
  "Bhagwan Mahaveer Institute of Medical Sciences",
  "Vaish Institute of Pharmaceutical Education & Research, Rohtak",
  "C.D.L. College of Ayurveda Bhagwangarh, Buria Road, Jagadhari",
  "Doon Valley Institute of Pharmacy & Medical outside Jundla Gate, Karnal",
  "Kailash Institute of Health & Medical Science, Vill Chandikotla (PKL)",
  "Ganpati Institute of Pharmacy, Knowledge Temple Bilaspur, Jagadhari",
  "College of Nursing, Pt. B.D.Sharma  , PGIMS, Rohtak",
  "College of Pharmacy, Pt. B.D.Sharma, PGIMS, Rohtak",
  "Gaur Brahman Ayurvedic College Brahamanwas, Rohtak",
  "Dr. Jai Parkash Sharma College of Nursing Yamunanagar",
  "Jan Nayak CDL College of Pharmacy, Barwala Road, Sirsa",
  "J.R. Kissan Homeopathic Medical College & Hospital, Rohtak",
  "Ch. P.R.M. College of Education",
  "Bharat College of Education, Babain",
  "D K K S D ADARSH SANSKRIT COLLEGE",
  "J.B. Knowledge Park",
  "HARYANA COLLEGE OF SPECIAL EDUCATION AND REHABILITATION",
  "KIRTI COLLEGE OF SANSKRIT ",
  "Ch. Devi Lal State Institute of Engg. and Tech., Panniwala Mota  Sirsa",
  "MAHARAJA AGRASEN NURSING COLLEGE",
  "M R COLLEGE MITTERPURA",
  "MODERN COLLEGE OF EDUCATION, MAHENDRAGARH",
  "POOJA COLLEGE OF EDUCATION",
  "KRISHNA VIDYAPEETH OF MANAGEMENT AND TECHNOLOGY",
  "RACHNA COLLEGE OF NURSING NANGAL SIROHI MAHENDRAGARH ",
  "SHANTI COLLEGE OF EDUCATION",
  "YAMUNA INSTITUTE OF NURSING",
  "P.K.R. Jain College of Education",
  "Government College Kheri Chopta, Hisar ",
  "GOVERNMENT COLLEGE, MATANHAIL",
  "DEEN DAYAL RUSTOGI COLLEGE OF EDUCATION",
  "RAO DALIP SINGH COLLEGE OF EDUCATION",
  "RAOMOHAR SINGH COLLEGE OF EDUCATION",
  "SATYA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "T.I.T.(Technological Institute of Textiles, MBA) Bhiwani",
  "KEDARNATH AGGARWAL INSTITUTE OF MANAGEMENT, CHARKHI DADRI",
  "PATAUDI COLLEGE OF EDUCATION",
  "SARASWATI INSTITUTE OF LAW",
  "Mewat Engineering College, Mewat",
  "KIIT College of Engg.Sohna Road,Bhondsi (Gurgaon)",
  "Mata Shanti Devi Memorial College of Edu",
  "GOVT CO EDU COLLEGE GANNAUR ",
  "Global Institute of Technology & Management",
  "BHARTIYA COLLEGE OF EDUCATION",
  "Shri Guru Teg Bahadur Ji Govt. College , Taraori (Karnal)",
  "GOVT COLLEGE FOR WOMEN KHARAK  BHIWANI",
  "Mahabir College of Education for Women",
  "Teerthanker K.R.D. college Jatauli Haily mandi",
  "Yaduvanshi Degree College ",
  "Cambridge College of Education",
  "HARYANA HINDI SANSKRIT MAHAVIDYALAY ",
  "Government College,  Panchkula",
  "KIIT COLLEGE OF EDUCATION",
  "GOVERNMENT COLLEGE FOR GIRLS SECTOR FIFTY TWO GURUGRAM",
  "World College of Technology & Management,Farukh Nagar-Haley Mandi Road,Gurgaon",
  "Maa Bala Sundri College of Education , Zaffartur Pur Distt Ambala",
  "SHIVOM COLLEGE OF MANAGEMENT AND TECHNOLOGY",
  "Lord Krishna College of Education",
  "DPG DEGREE COLLEGE",
  "GOVT. COLLEGE, REWARI",
  "Keshav College of Pharmacy, Salwan Assandh ( Karnal)",
  "ADESH MEDICAL COLLEGE and HOSPITAL",
  "Singh Ram Memorial College of Education",
  "Ch. Bansi Lal Government College for Women, Tosham",
  "Lal Chand Mal College of Education",
  "SARASWATI COLLEGE OF EDUCATION, KANINA",
  "Deshraj College of Pharmacy, Sisar Khas, Mahem, Rohtak",
  "International  Institute of  Engg. & Tech Samani",
  "Govt. College, Narnaul",
  "Institute of Law & Research",
  "M.K.M.K.M, HODEL",
  "Prarambh State Institute of Advanced Studies in Teacher Education, JHAJJAR",
  "GREEN VALLEY COLLEGE OF EDUCATION",
  "Sarla Memorial Government Girls College, Safidon",
  "HINDU COLLEGE OF EDUCATION",
  "Govt.College Mandi Hariya  (Ch.Dadri)",
  "Rama College of Education",
  "Lala Ami Chand Monga Memorial College of Education",
  "GOVERNMENT COLLEGE ISSARWAL BHIWANI",
  "J.B.M. College of Education",
  "Institute of Integrated & Honors Studies,Kurukshetra.",
  "Sanatan Dharma College  Ambala Cantt.",
  "S.D.Mewat Institute of Engg. & Technology",
  "Ramanujan College of Management",
  "Budha College of Management",
  "Hindu College, Sonepat.",
  "Shaheed Udham Singh Government College,Matak-Majri Indri, Dist. Karnal ",
  "Kumari Vidyavati Anand D.A.V. College for Women, Karnal.",
  "Seth Jai Parkash Mukand Lal Inst. of Engineering & Technology",
  "D.A.V. College, Pundri",
  "Tilak Raj Chadha Institute of  Management & Technology,",
  "M.L.N. College",
  "Bhagwan Parshu Ram College",
  "Maharaja Agrasen College, Jagadhri",
  "Government Post Graduate  College for Women ,Panchkula ",
  "M.D.S.D. COLLEGE,AMBALA CITY",
  "Global Research  Institute of  Management. & Technology",
  "Ch. I.S. Kanya Mahavidyalaya, Fatehpur-Pundri",
  "MODERN COLLEGE OF EDUCATION, JHAJJAR",
  "D.A.V. College, Cheeka",
  "R.P. Indraprastha Institute of Technology",
  "Sat Priya Institute of Engg. & Technology",
  "Kurukshetra College of Education",
  "Technology Education & Research Institute",
  "LT. MAHIPAT SINGH COLLEGE OF EDUCATION",
  "Shanti Niketan College of Education",
  "Shanti Niketan College of Engineering",
  "Govt. College for Girls, Unhani",
  "SRI RAM NANDA BRAHMRISHI  SANSKRIT MAHAVIDYALAYA",
  "GOVERNMENT COLLEGE FOR WOMEN,SONIPAT",
  "National College of  Ayurveda ",
  "Imperial College",
  "Government College Mohna",
  "GCG BADOLI (PALWAL)",
  "GURU DRONACHARA GIRLS COLLEGE",
  "IDEAL VETERINARY COLLEGE",
  "GATEWAY COLLEGE OF PHARMACY",
  "Tulsi College of Education for Women",
  "JAN NAYAK CHAUDHARY DEVI LAL MEMORIAL COLLEGE, SIRSA",
  "Janki Ji College of Education",
  "IITM COLLEGE OF PHARMACY",
  "Renu Vidya Mandir  Bahalgarh Sonipat  ",
  "Sat kabir Institute of Technology",
  "Government College for Women, Faridabad",
  "Seth Navrang Rai Lohia Jai Ram Girls College, Lohar -Majra",
  "D.A.V. College For Girls",
  "INDRAPRASTHA INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "Maharaja Aggarsain College of Education Pundri ",
  "Seth Megh Raj Jindal G.C, SIWANI",
  "AKHIL BHARTIYA GAUR BRAHMAN SANSKRIT COLLEGE ROHTAK",
  "Faridabad College of Engineering and Management, Faridabad",
  "Maharshi Jamadagni Govt. College for Girls Pillukhera ,Jind",
  "AMRITA COLLEGE OF NURSING, AMRITA VISHWA VIDYAPEETHAM FARIDABAD CAMPUS",
  "R.P. Indraprastha Group of Institutions",
  "MASTER KHUB RAM COLLEGE",
  "DPG Institute of Technology and Management",
  "Guru Gobind Nath College of Education",
  "Amar Nath Bhagat Jai Ram Govt  Girls College Serdha ,Kaithal",
  "Geeta Adarsh College of Education",
  "B.P.S. Government Medical College for Women Khanpur Kalan",
  "Vidyawati College of Nursing, Mohindergarh",
  "Maharaja Agrasen College of Physiotherapy, Agroha, Hisar",
  "THE KRISHNA EDUCATION RESEARCH AND TECHNOLOGICAL INSTITUTE",
  "R.P. Indraprastha Institute of Medical Sciences, Karnal",
  "B.D.M. Nursing College, Chhuchhakwas",
  "D.A.V.Centenary College",
  "CODEQUOTIENT SCHOOL OF TECHNOLOGY    ",
  "M.K.J.K. Mahavidyalaya, Rohtak.",
  "Ganpati Institute of Education for girls",
  "AERP INSTITUTE OF BUSINESS MANAGEMENT ",
  "RAO ABHAY SINGH COLLEGE OF EDUCATION",
  "GOVERNMENT COLLEGE, PALWAL",
  "AHIR COLLEGE OF NURSING, REWARI",
  "E-Max College  of Education",
  "Dr. B.R. Ambedkar College of Education",
  "SHRI OMVIR  SINGH INSTITUTE OF REHABILITATION",
  "Dharamjeevi Institute of Professional Education",
  "Dharam College of Education",
  "Choudhary Matu Ram College of Education",
  "VIVEKANAND COLLEGE OF EDUCATION",
  "VADIC TEACHER TRAINING COLLEGE",
  "Shri Ram College of Education",
  "TAGORE COLLEGE OF EDUCATION",
  "SOUTH POINT COLLEGE OF LAW",
  "SWARANJALI COLLEGE OF EDUCATION",
  "SURAJ COLLEGE OF EDUCATION",
  "SHRI KRISHNA COLLEGE OF EDUCATION",
  "RAO NET RAM DEGREE COLLEGE    ",
  "Rawal Instt. of Engineering & Technology",
  "Ganga Institute of Architecture & Town Planning Village",
  "SHREE GANAPATI INSTITUTE OF EDUCAITON & TECHNOLOGY",
  "Govt. Post Graduate Nehru College, Jhajjar.",
  "SHIKSHA BHARTI COLLEGE OF EDUCATION, MAHENDRAGARH",
  "Satya College of Engineering & Technology",
  "SMT. SANTRA DEVI COLLEGE OF EDUCATION",
  "SHARBATI COLLEGE OF EDUCATION",
  "SARV HIND COLLEGE OF EDUCATION",
  "ST ANDREWS COLLEGE OF ARCHITECTURE AND PLANNING    ",
  "GMN COLLEGE OF NURSING, AMBALA CANTT    ",
  "GOVERNMENT COLLEGE BISSAR AKBARPUR NUH",
  "SANT JAI RAM DAS MEMORIAL COLLEGE OF EDUCATION",
  "NCU SCHOOL OF BUSINESS",
  "SOUTH POINT DEGREE COLLEGE",
  "SANSKRITI INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "BABA MUNGIPA VIDYAPEETH EDUCATION COLLEGE ",
  "International Institute of Technology & Management",
  "DELHI INSTITUTE OF ARCHITECTURE AND PLANNING",
  "YAMUNA INSTITUTE OF DENTAL SCIENCES AND RESEARCH",
  "GOVT. COLLEGE KHERI GURJAN",
  "Dronacharya Government College Gurugram ",
  "Government College for Girls, Datta",
  "ESIC MEDICAL COLLEGE AND HOSPITAL",
  "STATE INSTITUTE OF REHABILITATION TRAINING AND RESEARCH",
  "RBS COLLEGE OF EDUCAITON",
  "RAO SULTAN SINGH COLLEGE OF EDUCATION",
  "RISHIKUL SANSKRIT MAHAVIDYALYA BARODA ROAD GOHANA SONEPAT",
  "SWAMI SUDARSHANACHARYA VED VEDANG SANSKRIT MAHAVIDAYALA",
  "RAO RANJEET SINGH COLLEGE OF EDUCATION",
  "GOVERNMENT COLLEGE SECTOR TWENTY THREE BALLABGARH",
  "MAHAVEER SWAMI COLLEGE OF EDUCATION",
  "GOVERNMENT COLLEGE, SATNALI",
  "Government College for Women, Ratia,  Distt. Fatehabad",
  "SANSKARAM COLLEGE OF NURSING",
  "RAJESH PILOT MEMORIAL COLLEGE OF EDUCATION",
  "SWAMI DAYA MUNI VIDYAPEETH COLLEGE OF EDUCATION",
  "Govt. College, Sector-9, Gurgaon",
  "SUNIL GUGNANI MEMORIAL COLLEGE OF EDUCATION",
  "GOVT. COLLEGE HATHIN (PALWAL)",
  "Rajadevi Goyal M/P College of Education",
  "R.K.S.D. College",
  "R.K.S.D. College of Education",
  "Shree Ram Mulkh College of Education",
  "Shri Jai Ram Mahila College of Education Research & Development",
  "S.K.S COLLEGE OF EDUCATION KIRMACH KURUKSHETRA",
  "S.L.D.A.V College of Education",
  "S.N. College of Education",
  "Rajiv  Gandhi Govt. College Saha",
  "S.P.S. Janta College of Education",
  "Tagore College of Educaiton",
  "Nalwa College of Education Panipat",
  "Ladwa College of Education",
  "Doon Valley Institute of Education",
  "SB COLLEGE OF EDUCATION DEWAS MOHIENDERGARH ",
  "Saraswati College of Education teek ",
  "S.S.M. College of Education",
  "G.C.,Nangal Chaudhary",
  "Govt. College, Jassia",
  "I.G. Mahila Mahavidyalaya",
  "Society for Advance Study in Rehabilitation",
  "DARSH MODEL DEGREE COLLEGE, GOHANA, SONIPAT HARYANA-131301",
  "RAO JAI RAM DEGREE COLLEGE",
  "Saraswati Mahila MAHAVIDHALAYA",
  "SHRI RANJIT SMARAK SHANTI NIKETAN KANYA GURUKUL LOWA KALAN BAHADURGARH JHAJJAR HARYANA",
  "MANAS SANSKRIT MAHAVIDYALAYA",
  "DMA National College of Education, SES Parisar,B-Block, Sirsa",
  "VAISH COLLEGE OF EDUCATION BAUND KALAN, CHARKHI DADARI",
  "College of Agriculture, Kaul",
  "BDM COLLEGE OF AYURVEDA SCIENCE AND HOSPITAL CHHUCHHAKWAS JHAJJAR",
  "M R COLLEGE OF EDUCATION, MAHENDRAGARH",
  "A.M. COLLEGE OF EDUCATION",
  "ARAVALI COLLEGE OF EDUCATION",
  "ARAVALI COLLEGE OF EDUCATION, KAROTA",
  "ARYA COLLEGE OF EDUCATION, MAHENDRAGARH",
  "BABA KHETA NATH COLLEGE OF EDUCATION",
  "BABA MOHAN DASS COLLEGE OF EDUCATION",
  "B.R. COLLEGE OF EDUCATION",
  "BRIGHT LAND COLLEGE OF EDUCATION",
  "B.S. COLLEGE OF EDUCATION",
  "GANPATI INSTITUTE OF EDUCATION & TECHNOLOGY",
  "GAURAV COLLEGE OF EDUCATION",
  "GOVERNMENT COLLEGE OF EDUCATION NARNAUL",
  "GURU COLLEGE OF EDUCATION",
  "HAPPY COLLEGE OF EDUCATION",
  "Gurudham College of Education",
  "Kartar Memorial College of Education",
  "Maharishi Dayanand College of Education",
  "Mata Jiyo Devi College of Education",
  "Jan Nayak Choudhary Devi Lal Memorial Institute of Business Management",
  "Hindu College of Education",
  "Kalpana Chawla College of Education for Women",
  "Maharaja Aggrasen College of Education",
  "T.R.Girls College, Sonepat.",
  "Deen Dayal Rustagi College Of Pharmacy",
  "Govt. College for Girls, Kalanwali",
  "Government College For Girls Kairu (Bhiwani)",
  "Oxford Girls College of Education",
  "Vision International College of Education",
  "K.M. Government  College, Narwana",
  "Arya College, Panipat",
  "Pragya College of  Education,Dulhera",
  "C.R. Kisan College",
  "ASHA GIRLS COLLEGE",
  "Chajju Ram Law College",
  "C.R.M. Jat College",
  "Shanti Niketan College of Education Agroha Mor",
  "F.G.M. Government  College, Adampur",
  "Government  College, Nalwa",
  "Govt. College, Barwala",
  "MAHARANI LAKSHMI BAI COLLEGE, BHIWANI ROHILLA",
  "Adarsh Mahila Mahavidyalaya",
  "Apeejay Saraswati College for Girls",
  "B.L.Jindal Suiwala College, TOSHAM",
  "Ch.Bansi Lal G. C, LOHARU",
  "DISHA COLLEGE OF EDUCATION",
  "GOVT. COLLEGE FOR WOMEN, BADHRA ",
  "ROHITASH DEGREE COLLEGE ",
  "JAI PARKASH MUKAND LAL INNOVATIVE ENGINEERING AND TECHNOLOGY INSTITUTE",
  "SATYUG DARSHAN INSTITUTE OF EDUCATION AND RESEARCH FOR GIRLS",
  "Govt. College for Women, Bawani Khera",
  "Government College, Safidon",
  "Govt. College ,Alewa(Jind)",
  "Shaheed Major Sanjeev Lather Government College, Julana",
  "Hindu Kanya Mahavidyalaya",
  "INDUS DEGREE COLLEGE, KINANA",
  "Swami Devi Dyal Law College",
  "Metis Degree College, Anta, Safidon",
  "Priyadarshini Indira Gandhi Govt. College for Women, Jind",
  "Rajiv Gandhi Mahavidyalaya, Uchana Kalan",
  "S.D. Mahila Mahavidyalaya, Narwana",
  "D.A.V. College, Ambala City",
  "Government College, Bapauli",
  "MUKHTIAR SINGH MEMORIAL DEGREE COLLEGE, BEHBALPUR",
  "Baijnath Choudhary Government College for Women, Nangal Choudhary",
  "B.R DEGREE COLLEGE, SEHLANG",
  "GEETA DEGREE COLLEGE V.P.O.SHERA PANIPAT",
  "Guru Brahmanand Women College, Kurana",
  "RAJIV GANDHI GOVERNMENT COLLEGE FOR WOMEN, BHIWANI",
  "S.D. Mahila Mahavidyalaya",
  "RATIRAM SANSKRIT MAHAVIDYALAYA PANDU PINDARA JIND HARYANA",
  "Chaudhary Hardwari Lal Government College,Chhara",
  "Shri Sai Baba College of Education",
  "Advanced Institute of Technology & Management, Aurangabad, Tehsil Hodal, Palwal",
  "Aravali College of Engineering & Management",
  "Shri Ram College of Engineering & Management",
  "MAHARISHI DAYANAND INSTITUTE OF NURSING, CHAUDHARYWAS",
  "College of Agriculture, Bawal",
  "K.L.P.College, Rewari",
  "ASIA PACIFIC INSTITUTE OF INFORMATION TECHNOLOGY (APIIT) SD INDIA, PANIPAT",
  "Savitribai Phule Govt College for Women ,Loharu",
  "RAO MOOL CHAND COLLEGE OF EDUCATION",
  "Guru Nanak Khalsa College, Karnal",
  "Pitamah Kanh Singh D.C.Kanina",
  "Suraj College of Engineering & Technology",
  "Aakash College of Education, Hisar",
  "POSTGRADUATE INSTITUTE OF DENTAL SCIENCES, ROHTAK",
  "COLLEGE OF PHYSIOTHERAPY, PGIMS, ROHTAK",
  "LAL BAHADUR SHASTRI MAHILA AYURVEDIC COLLEGE & HOSPITAL, BILASPUR",
  "SATYA COLLEGE OF NURSING, SISARKHAS",
  "Adarsh Subhash Tayal College of Education",
  "Ambika College of Education",
  "Arya College of Education, VILL BHERIAN POST MUKLAN  HISAR",
  "ARYA COLLEGE OF EDUCATION, ROHTAK",
  "CAMBRIDGE COLLEGE OF EDUCATION FOR WOMEN",
  "CAPT. HARDEV SINGH COLLEGE OF EDUCATION",
  "D.A.V. COLLEGE OF EDUCATION",
  "M.T. COLLEGE OF EDUCATION",
  "NETAJI SUBHASH COLLEGE OF EDUCATION",
  "SHAHEED HASAN KHAN MEWATI GOVT. MEDICAL COLLEGE, NALHAR",
  "R.D. COLLEGE OF EDUCATION Mukundpur, Jhajjar",
  "LORD SHIVA COLLEGE OF EDUCATION",
  "MAA GANGA COLLEGE OF EDUCATION",
  "Ch. Ishwar Singh Mahila Shikshan Mahavidyalaya",
  "Gyan Bharti College of Education",
  "Jaat College of Education",
  "Shanti Devi College of Education",
  "HARYANA COLLEGE OF EDUCATION",
  "S.D. MEMORIAL COLLEGE OF EDUCATION",
  "Guru Harkrishan College of Education Yamunanagar",
  "MERI PROFESSIONAL AND LAW INSTITUTE, ASANDA",
  "College of Agricultural Engineering & Technology",
  "College of Basic Sciences & Humanities",
  "GOVERNMENT COLLEGE FOR WOMEN, MANPUR",
  "I. C. College of Community Science",
  "Bhiwani Institute of Tech. & Science Kharakhari,By Pass Bhiwani",
  "Pt. L.R. College of Technology, Technical Campus,",
  "B.M. Institute of Engineering and Technology",
  "Ch. I. S. Kanya Mahavidyalaya, Dhand-Dadwana",
  "DHARAMPUTRA COLLEGE OF LAW    ",
  "VISION INSTITUTE OF APPLIED STUDIES ",
  "D.A.V.  College, Sadhaura",
  "Hari Om Shiv Om College of Education",
  "SHRI KRISHNA COLLEGE OF EDUCTAION",
  "VIGYA COLLEGE OF EDUCATION",
  "BABA JAI RAM DASS COLLEGE OF EDUCATION",
  "Hindustan Institute of Technology & Management",
  "Indian School of Hospitality",
  "Pt L R COLLEGE OF PHARMACY",
  "JEEVAN JYOTI PHARMACY AND MEDICAL SCIENCE",
  "CAMBRIDGE COLLEGE OF MANAGEMENT AND TECHNOLOGY",
  "Government College, Jind",
  "SHRI RAM COLLEGE OF NURSING",
  "Jan Nayak Ch. Devi Lal Dental College, Sirsa",
  "P R B S LAW COLLEGE, KHATOD, MAHENDERGARH, HARYANA    ",
  "COLLEGE OF BIOTECHNOLOGY    ",
  "ADVANCED INSTITUTE OF EDUCATION",
  "Mittaso College of Education",
  "Ch. Devi Lal College of Education",
  "B.R.College of Education",
  "Brahamrishi College of Education",
  "Birkha Ram College of Education",
  "Balaji College of Education",
  "Matu Ram Institute of Engineering & Management",
  "Arya Kanya Gurukul College of Education",
  "Aastha College of Education",
  "Govt. College, Kharkhara Distt. Rewari",
  "Brij Mohan Institute of Mgt. & Technology",
  "Swami Devi Dyal Institute of Engineering & Technology",
  "Sh.L.N.Hindu College, Rohtak.",
  "Shri Krishna G.C. Kanwali (Rewari)",
  "S.D. College, Panipat.",
  "Dr. Bhim Rao Ambedkar Govt. College, Dabwali",
  "Ch. Mani Ram Godara Govt. College for Women, Bhodia Khera",
  "G.V.M.Girls College, Sonepat",
  "Rajiv Gandhi Sanatam Dharam Commerce & Science College for women, Narwana",
  "PARMANAND COLLEGE OF SANSKRIT    ",
  "SAVITRI DEVI WOMEN DEGREE COLLEGE",
  "GOVT COLLEGE FOR WOMEN GHARAUNDA KARNAL",
  "GOVT COLLEGE FOR GIRLS MOHANA SONIPAT",
  "COLLEGE OF FISHERIES SCIENCE",
  "New Kalpana Chawla College of Education",
  "EKTA COLLEGE OF SANSKRIT",
  "M.A.College for Women, Jhajjar.",
  "School of Engineering and Technology, Soldha",
  "PIET NCR COLLEGE",
  "GOVERNMENT COLLEGE AGROHA",
  "LN COLLEGE  OF PHARMACY    ",
  "C M COLLEGE OF EDUCATION",
  "GOVT. COLLEGE FOR WOMEN PUNHANA",
  "SHARDA MAHILA MAHAVIDYALAYA SINGHANI",
  "Shri Ganesh College of Education",
  "N.B.G.S.M.College, SOHNA",
  "RAWAL COLLEGE OF EDUCATION",
  "Rawal Institute of Management, Sohna Road, Faridabad",
  "Govt. College for Women, Lakhan Majra (Rohtak) .  ",
  "Vaish College, Bhiwani",
  "ADESH PHYSIOTHERAPY COLLEGE",
  "DAV INSTITUTE OF MANAGEMENT",
  "I.P.J. COLLEGE OF EDUCATION",
  "Govt. College, Bawal",
  "SHRI MATA MANSA DEVI GOVERNMENT SANSKRIT MAHAVIDYALAYA PANCHKULA",
  "Babu Anant Ram Janta College, Kaul",
  "GOVERNMENT COLLEGE PRATAP NAGAR",
  "Govt. College, Jatauli Hailey Mandi",
  "GOVERNMENT COLLEGE MORNI",
  "Tau Devi Lal G.C. for Women,Murthal",
  "G.C. for Women, M.Garh.",
  "SHRI RAM COLLEGE OF PHARMACY AND MEDICAL SCIENCES, PALWAL    ",
  "G.D.C.Memorial College, BAHAL",
  "Vaish College of Law",
  "SANT ROSHAN LAL COLLEGE OF EDUCATION FOR WOMEN",
  "CBS Group of Institutions,",
  "S.D. College of Education",
  "Shri Baba Mast Nath Ayurvedic college,Asthal Bohar, Rohtak",
  "PT. SITA RAM SHASTRI B.Ed TRAINING COLLEGE",
  "H.L.G.Govt. College, Tauru",
  "Shaheed Lieutenant Kiran Shekhawat Government College for Women, Salaheri, Nuh",
  "Aryavart College of Education",
  "Sir Chhotu Ram  Government College for Women  Sampla",
  "DELHI GLOBAL INSTITUTE OF TECHNOLOGY",
  "Vaish Arya Kanya M. B.Garh(Jhajjar)",
  "Aggarwal College, BALLABGARH",
  "Deen Dayal Rustogi College of Management & Technology",
  "RBS COLLEGE OF PHARMACY",
  "BRDEWS BABA RAMDAS INSTITUTE OF SPECIAL EDUCATION",
  "Ch. Kapoori Ram College of Education",
  "ST PETERS COLLEGE",
  "SHAHEED CAPT D K KHOLA COLLEGE FOR WOMEN",
  "B.P.S. COLLEGE OF EDUCATION",
  "CH. PARTAP SINGH MEMORIAL COLLEGE OF EDUCATION",
  "Smt. Shanti Devi College of management & Technology",
  "LAL BAHADUR SHASTRI COLLEGE OF EDUCATION",
  "R.P.S. COLLEGE OF EDUCATION",
  "MAA SARASWATI COLLEGE OF PHARMACY",
  "Pt J L N Government PG Cpllege Faridabad",
  "Murari Lal Rashwasia Ayurvedic college, Charkhi Dadri.",
  "RISHIKUL SANSKRIT MAHAVIDYALAY GURUGRAM",
  "GOVT COLLEGE, JAKHAULI",
  "SANSKARAM LAW COLLEGE",
  "SANSKARAM GROUP OF INSTITUTIONS",
  "JHANKAR COLLEGE",
  "Saheed Capt. D.K.Khola College of Management and Technology",
  "SADASUKH COLLEGE OF EDUCATION",
  "YADUVANSHI COLLEGE OF ENGINEERING AND TECHNOLOGY, PATIKARA ROAD, NARNAUL",
  "Rao Pahlad Singh College of Engineering & Technology",
  "Govt. College Meham (Rohtak)",
  "Government College, Gharaunda",
  "surya college of education",
  "World Institute of Technology",
  "arpan institute of mentally handicapped children gandhi nagar rohtak",
  "GLOBAL RESEARCH INSTITUTE OF PHARMACY",
  "SDS COLLEGE OF ANIMAL SCIENCES",
  "SLD INSTITUTE OF MANAGEMENT, CHHAPROULA,PALWAL    ",
  "GURJAR KANYA GURUKUL MAHAVIDYALAYA DEVDHAR",
  "Government College, Kalka",
  "Bharat Institute of Pharmacy, Sonepat",
  "Sanatan Dharam  Mahila Mahavidyalya, Hansi",
  "Rao Pahlad Singh Degree College",
  "Arya Adrash Girls College, Madlauda",
  "Government College for Girls,SECTOR-14,Gurugram",
  "SMT INDIRA DEVI COLLEGE OF EDUCATION ",
  "Haryana Engineering College",
  "IPSE College of Education",
  "SK COLLEGE OF ELEMENTARY EDUCATION",
  "Lord Krishna College of Education",
  "Manav Institute of Education",
  "GOVERNMENT COLLEGE, SAMPLA",
  "GURU NANAK KHALSA COLLEGE OF EDUCATION VILL RAITKHANA KARNAL",
  "Keshav College of Education",
  "Shri Ram College of Pharmacy, Vill. Rambha, Indri road, Karnal",
  "Shrbati College of Nursing, Gayushala Road, Mahandergarh",
  "Anangpuria School of Pharmaceutical Sciences",
  "Himalyan Institute of Nursing, VPO Kala Amb, Sadhaura Rd., Amb",
  "Ram Gopal College of Pharmacy, Vill Sultanpur Gurgaon",
  "R.P. Education Trust Group of Institution ( Pharmacy) Vill. Bastara, Karnal",
  "GVM College of Pharmacy, Murthal Road Sonipat",
  "KVM Nursing College, Ladhot Road, Rohtak",
  "Birender Singh Nursing College, Uchana ( Jind)",
  "Savitri Devi Memorial College of Pharmacy, Pundri road Rajound",
  "SEHRAWAT DEGREE COLLEGE OF EDUCATION",
  "RAJ COLLEGE OF EDUCATION",
  "Janta College of Pharmacy, Butana, Sonipat",
  "CDL college of Pharmacy, Vill Bhagwan Garh, Buria Road, Jagadhari",
  "Florence School & College of Nursing Ballabhgarh, Faridabad",
  "JN Kapoor, DAV Cent. Dental College, Model Town (YNR)",
  "Hindu College of Pharmacy, Sonepat",
  "Maharaja Agrasen Nursing College ( Agroha)",
  "Haryana College of Nursing, Sirsa",
  "Shaheed Udham Singh College of Nursing, Nr Govt. Girl School, Ratia, Fatehabad",
  "Maharaja Agrasen Medical College, Agroha (Hisar)",
  "Prem Physiotherapy & Rehabilitation College, Panipat",
  "South Point Institute of Technology & Management",
  "Ved Nursing College, 98, Milestone, G.T.Road, Barauli, Panipat",
  "National College of Nursing, Dhani Garan Road, Barwala",
  "BHARAT INSTITUTE OF PHARMACY DEGREE COURSE",
  "PDM School of Pharmacy, Karsindhu, Teh. Safidon, JInd",
  "Swami Devi Dayal Institute of Pharmacy, Golpura, Barwala",
  "Manav Institute of Pharmacy Vill Javra Bahbalpur, Teh Barwala , Hisar",
  "Guru Gobind Singh College of Pharmacy, Yamunanagar",
  "Sudha Rustagi College of Dental Sc. & Res. Kheri More, Faridabad",
  "RKSD College of Pharmacy ambala road, Kaithal",
  "K.R.M.COLLEGE,  JAMAL",
  "BHARTIYA DEGREE COLLEGE",
  "R.L. College of Education",
  "IITM College of Science Art and Commerce",
  "B M COLLEGE OF PHARMACY",
  "SANSKAR BHARTI DEGREE COLLEGE FOR WOMAN,PALI",
  "Y P S MEMORIAL COLLEGE OF EDUCATION KAKROLI SARDARA, CHARKHI DADRI",
  "KHUSHI COLLEGE OF NURSING",
  "Singh Ram Memorial College",
  "IBMR Business College",
  "GURU BRAHMANAND KANYA MAHAVIDYALAYA",
  "Seth Banarasi Dass College of Education",
  "KHUSHI COLLEGE OF PHARMACY",
  "TCM COLLEGE OF PHARMACY, JAMALPUR, BHIWANAI",
  "Govt. College, Assandh (Karnal)",
  "VIVEKANAND DEGREE (P.G.) COLLEGE, DAHINA (REWARI)",
  "KISSAN COLLEGE OF EDUCATION",
  "Shree Sat Guru Dev College of Education Goalpura Barwala",
  "DEHAT VIKAS INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "JAGRITI INSTITUTE OF HIGHER EDUCATION",
  "PANCHSHEEL INSTITUTE OF EDUCATION, RESEARCH & EDUCATION",
  "NGF DEGREE COLLEGE PALWAL ",
  "SKS COLLEGE",
  "HAPPY COLLEGE OF EDUCATION",
  "SMT. BHAGWANI MEMORIAL INSTITUTE OF HIGHER EDUCATION",
  "RANJIT SINGH MEMORIAL COLLEGE OF EDUCATION & TECHNOLOGY",
  "DRONACHARYA DEGREE COLLEGE",
  "SHARVAN INST. OF REHABILITATION FOR MENTALLY RETARDED PERSONS",
  "SHRI BABA MASTH NATH INSTITUTE OF EDUCATIONAL TRANING & RESEARCH",
  "Navyug College of Education",
  "JK INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "Vishva Bharti College of Education",
  "M.D.N. College of Education",
  "Minerva College of Education",
  "Partap College of Education",
  "GOVT. DEGREE COLLEGE DEHRA, KANGRA",
  "SHEDS COLLEGE OF HOSPITALITY MANAGEMENT, SOLAN",
  "Bhagwan Parshuram Degree College Sirmour",
  "SAMPATI DEVI MEMORIAL NURSING COLLEGE BIJNI DISTT MANDI H.P.",
  "GOVERNMENT DEGREE COLLEGE SAINJ, DISTT. KULLU HP 175134",
  "MATA PADMAWATI EDUCATIONAL SOCIETY, SIRMOUR",
  "SHREE BALAJI HOSPITAL AND COLLEGE OF NURSING",
  "COLLEGE OF AYURVEDIC PHARMACEUTICAL SCIENCES JOGINDER NAGAR, MANDI ",
  "Rajiv Gandhi Govt. Engineering College, Kangra",
  "SHIVA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL BILASPUR",
  "Tara Collge of Education Kangra",
  "Jawaharlal Nehru Govt.Engineering College, Mandi",
  "Atal Bihari Vajpayee Govt. Institute of Engineering  Technology (Degree wing), Pragatinagar, Shimla",
  "Shri Lal Bahadur Shastri Govt. Medical College Mandi at Nerchowk",
  "GOVERNMENT DEGREE COLLEGE  LANJ ",
  "Scared Heart Education Society, Gutkar, Teh. Sadar, C/O Laljee B.Ed Colalge Distt Mandi",
  "HIMACHAL INSTITUTE OF LEGAL STUDIES SHAHPUR, KANGRA",
  "Govt. College Theog, Distt Shimla",
  "SATYAM COLLEGE OF NURSING LANJOT,KANGRA",
  "Green Hills College of Hotel Management",
  "SHANTI NIKETAN INSTITUTE OF VETERINARY SCIENCES",
  "NAINA COLLEGE OF NURSING",
  "T.R. Abhilashi Memorial Institute of Engg. & Technology, Tanda, PO Balt, Distt Mandi",
  "Vaishno College Of Engg. Thapkour, Nurpur, Kangra",
  "KULLU VALLEY COLLEGE OF NURSING",
  "Vinayaka College Of Pharmacy, Kullu",
  "GOVT.DEGREE COLLEGE TIKKAR, SHIMLA",
  "AAKASH INSTITUTE OF MEDICAL SCIENCES AND NURSING COLLEGE NALAGARH",
  "K.C. Institute of Pharmaceutical Sciences, VPO Pandoga Uprla, Distt Una",
  "GOVERNMENT DEGREE COLLEGE, BAROH",
  "SHEDS COLLEGE OF LAW",
  "Pandit Jawahar Lal Nehru Govt Medical College Chamba",
  "MINERVA COLLEGE OF NURSING",
  "K.C. Education and Social Welfarre Society Group of Research & Professional Institutes, VPO pandoga Uparla Tehsil & Distt Una",
  "Govt. College, Shahpur, Distt Kangra",
  "Govt. College, Karsog, Distt Mandi",
  "Bhardwaj Shikshan Sansthan, VPO Baral, Tehsil Karsog, Distt Mandi",
  "BKD College for Women, Ponta Sahib, Distt Sirmour",
  "Jagriti Teachers Training College Deodhar, PO Talyahar, Distt Mandi",
  "Govt. Degree College, Nerwa (Chopal), Distt Shimla",
  "GOVT. COLLEGE, HARIPURDHAR (SIRMOUR)",
  "Rajkiya Kanya Mahavidyalaya, Lakkar Bazar, Shimla",
  "JEEVAN JYOTI COLLEGE OF NURSING",
  "Indira Gandhi Medical College, Shimla",
  "Govt. Degree College Khad, Una",
  "Himalayan Institutes of Management Sadhoura Road, Kala Amb, Distt Sirmour",
  "Himalayan College of Education, Pungh, Sundernagar, Distt Mandi",
  "Govt. College Chowki Maniar (Una)",
  "Rajiv Gandhi Post Graduate Ayurvedic College, Paprola, Distt Kangra",
  "Govt. College, Saraj at Lambathach, Tehsil Thunag, Distt Mandi",
  "L.R. Institutes of Pharmacy, Jabli-Kyar, Oachghat Distt Solan",
  "GOVERNMENT DEGREE COLLEGE NOHRADHAR",
  "Govt. College Nihri, Mandi",
  "VIDYARTHI COLLEGE OF NURSING VIDYARTHI KALYAN SHIKSHA SAMITI",
  "KLB, DAV College for Girls Palampur, Distt Kangra",
  "L.R. Institutes of Management Vill. Jabli Kyar. Distt Solan",
  "GOVERNMENT DEGREE COLLEGE RIRKMAR",
  "Govt. Degree College Sugh Bhatoli, P.O. Mandoli, District Kangra",
  "GOVT. COLLEGE ARKI (SOLAN)",
  "Abhilashi Group Of Institutions, (School of Pharmacy), Chail Chowk, Distt Mandi",
  "GURUKUL BHARTI COLLEGE OF NURSING",
  "Government Degree College Subathu, Solan",
  "HERITAGE INSTITUTE OF HOTEL AND TOURISM,SHIMLA",
  "Himachal Institute of Hotel Management Vidyanagar,Shahpur, Kangra",
  "Govt. Degree College Rey, Kangra",
  "COLLEGE OF BASIC SCIENCES",
  "Jagriti Institute of Management Deodfhar, Talayhar, Distt Mandi",
  "Govt. College Naura, Distt - Kangra (HP)",
  "K C Group of Research and Professional Institutes, Pandoga",
  "SAI SARASWATI INSTITUTE FOR TEACHER EDUCATION SHANGTI SUMMERHILL SHIMLA",
  "Govt. College , Kumarsain , Distt. Shimla , H.P",
  "RADHE RADHE VETERINARY PHARMACIST TRAINING INSTITUTE REWARI    ",
  "GOVT.COLLEGE NAGROTA SURIAN (KANGRA)",
  "SIRDA Institute of Engineering & Technology for Women, Naulakda Troat, Sunder Nagar, Distt Mandi",
  "GOVT. COLLEGE NANKHARI (SHIMLA)",
  "GOVT. COLLEGE, CHAIL-KOTI, DISTT. SHIMLA",
  "BHOJIA INSTITUTE OF NURSING NALAGARH, SOLAN",
  "Murari Lal Memorial College of Nursing, Solan Distt. Solan",
  "Minerva Education Society, Baggi, Tehsil & Distt Mandi",
  "SHANTI PARA VETERINARY INSTITUTE , KAILASH NAGAR , NAKROH",
  "JAI DURGA MAA COLLEGE OF NURSING JOGINDER NAGAR, MANDI",
  "GAUTAM VETERINARY PHARMACIST TRAINING INSTITUTE HAMIRPUR",
  "Shimla Nursing College",
  "JAWAHAR LAL NEHRU GOVERNMENT COLLEGE OF FINE ARTS SHIMLA",
  "Govt. College, Dhaliara, Distt Kangra",
  "Govt. College Bilaspur",
  "Yen Law College Sungal, District Bilaspur.",
  "Himachal Institute of Pharmaceutical, Bela, Nadaun. Distt Hamirpur",
  "Shaheed Captain Vikram Batra Govt. College, Palampur, Distt Kangra",
  "Govt. College, Salooni, Distt Chamba",
  "L. R. Institutes of Management, Jabli-Kyar, Oachghat, Distt Solan",
  "Himachal Institutes of Pharmacy, Paonta Sahib, Distt Sirmour",
  "GOVT PHARMACY COLLEGE SULLAH CAMP AT GOVT DEGREE COLLEGE NAURA DISTT KANGRA HP",
  "SHIVA INSTITUTE OF B PHARMACY BILASPUR",
  "Government Degree College Drang at Narla",
  "NANDINI COLLEGE OF NURSING",
  "ARYABHATTA GOVT. DEGREE COLLEGE SANDHOLE, DISTT. MANDI",
  "Dr. Radhakrishnan Government Medical College , Hamirpur ",
  "M.L.S.M College, Sundernagar, Distt. Mandi",
  "Central Research Institute. Kasauli, Distt Solan",
  "Govt. Sanskrit College, Kiartu. Teh. Theog. Distt Shimla",
  "Govt. College Nurpur, Distt Kangra",
  "GOVT. COLLEGE KHUNDIAN (KANGRA)",
  "Govt. College Bharali, Anjbhoj Transgiri Area (Sirmour)",
  "Govt. College Pangi, Distt Chamba",
  "H.P. Govt. Dental College, Shimla",
  "Solan Homeopathic Medical College and Hospital, Barog Bye-Pass, Kumarhatti, Distt. Solan",
  "Shimla College of Education, Sheetal kunj Estate, Kamla Nagar, Sanjauli Distt Shimla",
  "Govt. College, Sangrah, Distt Sirmour",
  "Astha College of Education, Hatkot, Arki, Kunihar, Distt Solan",
  "MSCM Govt. Degree College, Thural, Distt Kangra",
  "Laureate Institute of Pharmacy, kathog, Dehra, Distt Kangra",
  "GOVT. COLLEGE, SARAHAN, SIRMAUR",
  "KC INSTITUTION OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "Shri Shakti Sanskrit College, Shri naina Devi. Distt Bilaspur",
  "Laureate Institute of Management and Information Technology Kathog",
  "Raj Rajeshwari College of Education, Ward No. 3, Partap Nagar. Distt Hamirpur",
  "Govt. College Kukumseri, Distt Lahaul & Spiti",
  "GOVT. DEGREE COLLEGE DHANETA,HAMIRPUR",
  "Awasthi Law College",
  "Govt. College Gadagusain,Kullu",
  "Venkateshwar Vidyapeeth, Village Dhillo, Kumarhatti, Distt. solan",
  "School Of Law, HPU, Regional Centre, Dharamshala",
  "Vijay Vallabh College of Education, Nadaun at Bela, Distt Hamirpur",
  "H.P. University Regional Centre, Dharamshala",
  "Shiva College Of Education Village Barota,PO Luharwin Tehsil Ghumarwin Distt Mandi",
  "Gian Jyoti institutes of Teachers Education, Ichhi at Rajol Distt Kangra",
  "SVSD College  Bhatoli, Distt Una",
  "GOVT. COLLEGE RAKKAR (KANGRA)",
  "Govt. Snaskrit College, Nahan, Distt Sirmour",
  "Govt.Degree College Pajhota at  Phatti Patel",
  "Lord Mahavira B.Sc Nursing College. Ist Floor, PNB Building, Ropar Road, Nalagarh, Distt.  Solan",
  "Shanti Alya Institute of Education and Training, Vill. Rampur Keonthal, Distt Shimla",
  "GOVERNMENT DEGREE COLLEGE GHANDALWIN, DISTT BILASPUR HP",
  "B.T.C., DAV College. Banikhet, Distt Chamba.",
  "Gautam College Hamirpur, Distt Hamirpur",
  "Venkateshwar Shiksha Samiti, Vill Dhillon, PO Sultanpur, Distt Solan",
  "G.P. Pant Memorial Govt. College Rampur Bhushar, Distt Shimla",
  "Govt. College Solan. Distt Solan",
  "Thakur Jagdev Chand Memorial Govt. College, Sujanpur Tihra, Distt Hamirpur",
  "Lala Lilu Ram Educational Trust, Jabli PO Kyar, PO Oachghat, Distt Solan",
  "Shri Lal Devi Annapurna, Sanskrit College, Ramsheela Lakkar Bazar, Kullu",
  "Nehru Govt. Sanskrit College, Phagli, Shimla",
  "Shiv Shakti College of Advanced Study in Education, Kheri Road, Rajgarh, Distt Sirmour",
  "Dr. Sarvepalli Radhakrishnan Government Degree College, Dharampur, District Mandi",
  "MINERVA COLLEGE OF PHARMACY",
  "Deen Dayal Upadhayay College of Education, Mehre, Distt Hamirpur",
  "Govt. College, Banjar, Distt Kullu",
  "HP University Institute of Legal Studies, Ava Lodge, Shimla",
  "Himachal Adarsh Sanskrit College, Jangla, Teh. Rohru Distt Shimla",
  "Sharan College of Education for Women, Ghurkhari, Distt Kangra",
  "Dr. RP Medical College, Tanda, Distt Kangra",
  "Dr. Yashwant Singh Parmar Govt. Medical College, Nahan",
  "GOVERNMENT DEGREE COLLEGE DARLAGHAT",
  "Govt. Degree College Chopal Distt. Shimla",
  "Jawahar Lal Nehru Government College, Haripur at Manali, District Kullu",
  "shri vyas sanskrit collage raghunathpur,kullu",
  "Dean Dayal Mahesh Public College of Education, Sugh Bhatoli, P.O. Mandoli Distt Kangra",
  "Gautam College of Nursing Hamirpur ",
  "Rameshwari Teachers Training, Institute Upper HPSEB Colony Sarabai, Distt KUllu",
  "Govt. Sanskrit College, Purana Bazaar, Sundernagar, Distt Mandi",
  "Modern Nursing College, Shimla",
  "University Institute of Information and Technology, H.P.U, Shimla",
  "Government Degree College, Chintpurni, Distt. Una",
  "Shanti Niketan College of Education, Hira Nagar, Ward No-1, Distt Hamirpur",
  "Gautam College of Pharmacy Hamirpur",
  "Noble College of Education, NH-21, Vill Seog, PO Pandoh, Distt Mandi",
  "Modern Education College, Annadale, Shimla",
  "Blooms College of Education, Kot, P.O. Chunahan, Distt Mandi",
  "L.R. Institute of Legal Studies, Jali-Kyar, Oachghat, Distt Solan",
  "Govt. College, Nagrota Bagwan, Distt Kangra",
  "Sister Nivedita Govt. Nursing College, IGMC, Shimla",
  "Namdhari Education Society, Bhojpur, Sundernagar, Distt Mandi",
  "Krishma Education Centre, Vill. Ner Chowk, Distt Mandi",
  "MINERVA COLLEGE OF ARTS SCIENCE AND COMMERCE",
  "MNDAV Dental College, Tatul, PO Oachghat, Distt. Solan",
  "Dronacharya College of Education, Rait, Distt Kangra",
  "Adarsh College of Education, Amarpur, Tehsil Ghumarwin , Distt Bilaspur ",
  "WRS Govt. College Dehri, Distt Kangra",
  "Sunaina Sanskrit Mahavidalaya, Swarghat, Nalagarh, Distt Solan",
  "BKD Degree College for Women, Paonta Sahib, Distt Sirmour",
  "GOVT. COLLEGE TAKIPUR (KANGRA)",
  "Govt Pharmacy College Seraj",
  "Mahatma Gandhi Govt. Engg.College,Kotla (Jeori), Teh.Rampur, District Shimla, H.P.",
  "Govt. Degree College Shri Naina Devi Ji, Bilaspur",
  "Kamakshi Nursing Institutes, Bassa Wazira, Nurpur, Distt Kangra",
  "Govt. College Bharmour, Distt Chamba",
  "CHANDER DHAR GULERI GOVT. DEGREE COLLEGE, HARIPUR (GULER), DISTT. KANGRA",
  "Shoolini Institutes of Life Sciences and Business Management Anand Campus, The mall , Distt Solan",
  "Govt. Degree College Shri Renuka Ji at Dadahu",
  "Govt. College, Tissa, Distt Chamba",
  "GOVT. COLLEGE DHAMI (SHIMLA)",
  "Mehar Chand Mahajan DAV College, Kangra",
  "Govt. College, Jukhala, Distt Bilaspur",
  "Bushehar B.Ed. Institute PO Nogli, Rampur, Distt Shimla",
  "Govt. College, Diggal Solan ",
  "Govt Degree College Shivnagar, Kangra",
  "Netaji Subhash Chander Bose Memorial Govt. College, Hamirpur, Himachal Pradesh.",
  "Lala Jagat Narain Himotkarsh Government Girls Degree College Kotla Khurd, Distt Una",
  "Govt. College, Jhanduta, Distt Bilaspur",
  "GOVT DEGREE COLLEGE CHHATRI DISTRICT MANDI HP    ",
  "Kol Valley Institutes of Nursing, Vill Nehar, Harnora. Bilaspur",
  "SD Adarsh Sanskrit College, Dohgi, Teh. Bangana, Distt Una",
  "HIMACHAL PHARMACY COLLEGE NALAGARH, SOLAN",
  "Mata Bala Sundari College of Legal Studies, Shimla Road, Nahan, Distt Sirmour",
  "Govt. College, Barotiwala (Solan)",
  "Indian institute of Legal Studies, Hari Devi, Ghanahatti, Distt Shimla",
  "GDC Kotla Behar",
  "Vijay Institute of Higher Education, VPO Bhangrotu, Tehsil Sadar, Distt. Mandi",
  "Gautam Institute of Management and Technology, Hamirpur",
  "SHRI ARVIND SANSKRIT MAHAVIDYALYA KARSOG",
  "Swami Vivekanand Govt. College Ghumarwin, Distt Bilaspur",
  "Vallabh Govt. College, Mandi",
  "GOVT.COLLEGE REWALSAR (MANDI)",
  "Govt. Sanskrit College, Solan",
  "Shiva Institute of Engineering & Technology, Chandpur, Distt Bilaspur,",
  "Shri Ramanuj Sanskrit Mahavidyalaya Punjgain, Distt Bilaspur",
  "Vaidh Shankar Lal Memorial College of Education, VPO Chandi, Teh. Kasauli, Distt Solan",
  "Government  Sanskrit College Chamba",
  "Shivalik Institutes of Nursing, Chibber Complex, Kamlanagar, Snajauli, Distt. Shimla",
  "Govt. College Bhoranj (Tarkawari), Distt Hamirpur",
  "Nalanda College of Education, VPO Jhaniari, Distt Hamirpur",
  "Lal Bahadur Shastri Govt. Degree College Saraswati Nagar (Sawra), Distt Shimla",
  "Govt. College Dharmashala, Distt Kangra",
  "Govt. College,Una, Distt Una,",
  "LLR Institute of Management, Jabli-Kyar, PO Oachghat, Distt Solan",
  "Indain Institute of Education, Hari Devi, Ghanahatti. Distt Shimla",
  "Chamba Millenimum Education College, Saraswati Nagar, PO hardaspur, Distt Chamba",
  "Himachal College of Law Kala Amb, Sirmour to be run Maa Saraswati Educational Trust karnal",
  "GOVT. COLLEGE ANNI AT HARIPUR (KULLU)",
  "Govt. College Sanjauli, Shimla (Centre of Excellence)",
  "SVN College of Education, Tarkwari, (Bhoranj) Distt Hamirpur",
  "Jupitor College of Education, Mairi, Distt Una",
  "Green Hills Engineering College, Gandhi Gram Road, Kumarhatti, Distt Solan",
  "SGSD Sanskrit College, Santokhgarh, Distt Una",
  "Govt. College Chowari, Distt Chamba",
  "Himachal Pradesh College of Education, Kala Amb, Distt Sirmour",
  "Govt. College, Daulatpur Chowk, Distt Una",
  "Kanta College of Education, Chalwara, Teh. Jawali, Distt Kangra",
  "Droncharya College of Education, P.O. Rait, Tehsil Shahpur, Distt Kangra",
  "MAA JAWALA NURSING INSTITUTE JAWALAMUKHI",
  "DDM Sai Law College, Nadaun Distt Hamirpur",
  "Himachal Research Institute, Chakmoh, Distt Hamirpur",
  "Govt. Sanskrit College Tungesh, PO Cheog, Distt Shimla",
  "Netaji Subhash Nursing College, Behind Cinema Hall Building, Palampur, Distt. Kangra",
  "Minerva College of Education, Vill Changrara, PO Bhapoo, Teh. Indora, Distt Kangra",
  "Sant Baba Dhangu Wale Gujjer Govt. Degree College, Beetan Distt Una",
  "Govt. College, Seema (Rohru) Distt Shimla",
  "Trisha College of Education, Thain, PO Jol Sappar, (RANGAS), Distt Hamirpur",
  "Him Institute of Education, Ponda, Tehsil Nichar, Distt Kinnaur",
  "HPU Centre for Evening Studies, The Mall, Shimla",
  "DDM College of Pharmacy, VPO Gondpur, Teh Amb. Distt Una",
  "Dreamz College of Pharmacy, Khirla, PO Mera Masit, Tehsil Sundernager, Distt mandi",
  "Himachal Institute of Engg. & Tech. Vidya Nagar, Shahpur, Kangra",
  "Govt.Degree College TELKA ",
  "Govt. College, Chamba",
  "MAA HATESHWARI COLLEGE OF NURSING",
  "Govt. Degree College Jainagar",
  "Rameshwari Teachers Training  Institute Upper HPSEB Colony Sarabai, Distt Kullu",
  "Bhojia Dental College, Budh (Baddi), Chandigarh-Nalagarh Road, Distt. Solan",
  "H.P. College of Education, Mauja Majeth, P.O. Totu, Shimla-11",
  "Kanwar Durga Chand Govt Degree College, Jaisinghpur, Distt Kangra",
  "Awasthi College of Education Shamnagar, Dharamshala, Distt Kangra",
  "Dawarka Dass Memorial Sai College of Education, Vill. Kallar, P.O. Jalari, Teh. Nadaun, Distt Hamirpur",
  "Shanti College of Education, Nakroh, Tehsil Amb, Distt. Una",
  "Himachal Dental College, Sundernagar, Distt. Mandi",
  "Govt. College, Sarkaghat, Distt Mandi",
  "Shri Vishwa Nath Snaskrit College, Chakmoh, Teh. Barsar, Distt Hamirpur",
  "R.C. College of Education, Dhanot, PO Adhwani, Teh. Dehra, Distt Kangra",
  "T.S. Negi Govt. College, Reckong Peo, Distt Kinnaur",
  "GGDSD College Rajpur, Palampur, Distt Kangra",
  "A One College of Education Raja Ka Bag (Nurpur), Kangra",
  "HIMCAPES Co-operative school of Legal Studies, Badhera, Distt Una",
  "Dr. Sharma Prasad Mukherjee College of Physical Education, Nurpur, Distt Kangra",
  "Shri. Saraswati Sanskrit Degree College, Dangar, Teh. Ghurmarwin. Distt Bilaspur",
  "Shiksha Bharti Institute of Education, Training & Research, Samoor Khurd, Bangana, Distt . Una",
  "Govt.Sanskrit College, Sarain (Chopal), Distt Shimla",
  "HIMALAYAN GROUP OF PROFESSIONAL INSTITUTION MANDI",
  "Lakshay Institute of Education. Arki, Solan",
  "CTNT STUDY CENTRE MANDI",
  "Vaishno College of Education Vill. Thapkour, PO Bhadroya, Teh. Nurpur, Distt kangra",
  "FD Public Degree College, Mand Miyani, Teh. Indora, Distt Kangra",
  "BATT COLLEGE OF NURSING",
  "Govt. College of Teacher Education Dharamshala, Distt Kangra",
  "GOVERNMENT DEGREE COLLEGE BANIKHET, DISTRICT CHAMBA HP",
  "Doon International College of Education. Rajban, Paonta Sahib. Distt Sirmour",
  "Govt. College, Basa, Distt Mandi",
  "Atal Bihari Vajpayee Govt. Degree  College Sunni, District Shimla",
  "Govt. College, Shillai, Distt Sirmour",
  "Sarvopalli Radha Krishan Institute Nogli, NH-22, Rampur Bushaher, Distt Shimla",
  "Himachal College of Education, Nalagarh at Kishanpura, Nalagarh, Distt Solan",
  "Govt. College of Pharmacy, Rohroo, Distt Shimla",
  "SHAHEED BHAGAT SINGH COLLEGE OF PHARMACY",
  "Thakur College of Education, Dhaliara, Teh. Dehra, Distt Kangra",
  "St. Bede's College, Shimla",
  "Rajiv Gandhi Memorial Govt. College, Choura-Maidan, Shimla",
  "Himachal Institute of Education, Bye Pass Road, Near Petrol Pump, Amar Building. Solan",
  "Hamirpur College of Education, Ward No. 10. Ram Nagar, Choulla, Hamirpur",
  "Vijay Memorial College of Education, Ner-Chowk, Distt Mandi",
  "Himalayan Institutes of Computer Sciences, Sadhoura Roah, Kala Amb, Distt Sirmour",
  "Kshtriya College of Education, Kathgadh Road, Kursain, Indora, Distt Kangra",
  "Janak Raj Mahajan, B.Ed. College Gangath, Teh. Nurpur, Distt Kangra",
  "Priyadarshaini College of Education, VIll. Kudnu, Chowari, Distt Chamba",
  "Gayatri College of Education. P.O. Kangoo. Tehsil Sundernagar, Distt Mandi",
  "Himachal Institute of Dental Sciences, Paonta Sahib, Distt. Sirmour",
  "Ram nursing college",
  "Freedom Fighter Pandit Susheel Rattan Govt Degree College Jawalamukhi",
  "Govt. Degree College Baldwara , Distt Mandi (H.P)",
  "Neelam College of Education, 1249/999, Vill. Jimjima, Manja, PO Dul, teh. Jogindernagar, Distt mandi",
  "Jai  Durga Maa College of Nursing",
  "AROMA COLLEGE OF NURSING",
  "Awasthi Institute OF Nursing, Nalagarh, Solan",
  "Govt.Degree College Kotli, Mandi",
  "AAKASH INSTITUTE OF MEDICAL SCIENCES NALAGARH",
  "MLSM B.ED College, Sunder Nagar, Distt Mandi",
  "HP University College of Business Studies, Ava Lodge, Shimla",
  "Gurukul Bharti College, Vill. Benla, P.O. Chandpur, Distt Bilaspur",
  "BBN College, Chakmoh, Distt Hamirpur",
  "Government Degree College, Indora, Distt Kangra",
  "Lord Budha College of Education, Purana Bazar, Sundernagar, Dist mandi",
  "Govt. College Rajgarh, Distt Sirmour",
  "Laurate Institute of Education & Training, Bharari, Shimla",
  "Himachal Institutes of Life Sciences, Paonta Sahib, Sirmour",
  "Trigart Sanskrit Mahavidyalaya, Shri Nandikeshwari Mandir, Kangra",
  "Govt. College, Barsar, Distt Hamirpur",
  "Sidharth Govt. Degree College, Nadaun. Distt Hamirpur",
  "Pt. Sant Ram Govt. College, Baijnath, Distt Kangra",
  "DAV Centenary College Kotkhai, Distt Shimla",
  "Govt. College, Nalagarh, Distt. Solan",
  "MEN-TSEE-KHANG SOWA RIGPA MEDICAL COLLEGE AND HOSPITAL",
  "SHIMLA VALLEY NURSING COLLEGE",
  "AWASTHI AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "Jaya Man Ashram Snatakottar Sanskrit Mahavidyalaya, Sug Bhatoli",
  "SHIVA INSTITUTE OF  VETERINARY  PHARMACIST",
  "Shree Guru Gobind Singh Ji Government College, Paonta Sahib, Sirmour",
  "HIMACHAL PRADESH TECHNICAL UNIVERSITY OFFCAMPUS BUSINESS SCHOOL",
  "Himalayan Institute of Pharmacy, Sadoura Road, Kala Amb. Distt Sirmour",
  "ATAL BIHARI VAJPAYEE GOVERNMENT DEGREE COLLEGE BANGANA, DISTRICT UNA",
  "V.V.M Institute of Nursing  Malkwal,P.O. Khuwara,Kangra",
  "Baba Kanshi Ram Government Degree College Dadasiba, Kangra",
  "Abhilashi College of Pharmacy, Ner-Chowk, Distt Mandi ",
  "GOVT. DEGREE COLLEGE KANDAGHAT, SOLAN",
  "GOVT. DEGREE COLLEGE,  PANARSA DISTT. MANDI (H.P.)",
  "Abhilashi P.G. Institute of Sciences ( Ner-chowk), Distt Mandi",
  "GOVERNMENT HYDRO ENGINEERING COLLEGE BANDLA, BILASPUR. ",
  "GOVT. COLLEGE BHALLAI",
  "Govt. Degree College Kaffota. Sirmour",
  "SHRI MAA SANSKRIT MAHAVIDYALAYA  JAWALAMUKHI (KANGRA)",
  "GOVT.DEGREE COLLEGE NIRMAND, KULLU",
  "GOVT. PHARMACY COLLEGE KANGRA AT NAGROTA BAGWAN, KANGRA",
  "Govt. College Majheen, Kangra ",
  "Himalayan Institute of Engineering & Technology, Sadhoura Road, Kala  Amb. Distt Sirmour",
  "Rajiv Gandhi Memorial Government College Joginder Nagar, Distt Mandi",
  "  SHAKUNTLA MEMORIAL B.SC. COLLEGE OF NURSING CHAMBA",
  "GOVT. COLLEGE SIHUNTA (CHAMBA)",
  "Government Degree College Dehar, Mandi",
  "Abhilashi College of Nursing,Mandi",
  "GOVT.COLLEGE LYTH KOTHI (CHAMBA)",
  "Kullu College of Education, Vill. Bohgana, PO Garse, Distt Kullu",
  "Government College Haroli (Una)",
  "Govt. Degree College Matour, Kangra",
  "Gurudronacharya College of Nursing, Kangra",
  "GOVT.COLLEGE LAD-BHAROL (MANDI)",
  "Govt. Degree College Dhrampur, Solan",
  "Abhilashi College of Education, Ner Chowk, Teh. Sadar, Distt Mandi",
  "VMRT CAPT SAURABH KALIA MEMORIAL NURSING COLLEGE",
  "GOVERNMENT COLLEGE RAMSHEHAR, SOLAN",
  "Government Degree College Multhan, (Chotta Bhangal) KANGRA",
  "Maharana Pratap Government Degree College Amb",
  "Government Degree College, Ronhat (Sirmaur)",
  "Govt. Degree College Jawali",
  "Govt. Degree College  Thachi ",
  "L.R. Engineering & Technology, Jabli Kyar, Distt Solan",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, KANGRA",
  "L. R. Institute of Hotel Management and Catering Technology",
  "Govt. Degree College  Jeori ",
  "GOVT PHARMACY COLLEGE RAKKAR DISTT KANGRA",
  "Dr. Yashwant Singh Parmar Government Post Graduate College, Nahan",
  "Govt Degree College, Vailoo, Larnoo",
  "GREEN LAND COLLEGE OF EDUCATION, SRINAGAR",
  "GOVERNMENT DEGREE COLLEGE DANGIWACHA",
  "SOUTH VALLEY COLLEGE OF EDUCATION, DEVSAR KULGAM",
  "School of Architecture Govt MAM College Jammu",
  "GHANDHI MEMORIAL COLLEGE OF EDUCATION, JAMMU",
  "VISHWA BHARTI COLLEGE OF EDUCATION, JAMMU",
  "MANUU Arts and Science College for Women,Srinagar",
  "GOVERNMENT MEDICAL COLLEGE,UDHAMPUR",
  "SHEIKHUL- AALAM COLLEGE OF EDUCATION, KUPWARA",
  "Faculty of Fisheries",
  "New Age College of Education",
  "JAMIA MADINAT-UL-ALOOM, ORIENTAL COLLEGE, HAZRATBAL",
  "GREEN VALLEY COLLEGE OF EDUCATION, PULWAMA",
  "GURU NANK COLLEGE OF EDUCATION, PULWAMA",
  "GOVT DEGREE COLLEGE VERINAG",
  "Jammu and Kashmir Institute of Mathematical Sciences",
  "Govt. Degree College, Bani",
  "GOVERNMENT DEGREE COLLEGE, MARWAH",
  "Govt. Degree College, R.S. Pura",
  "Shri Chhote Shah Government Degree College Mendhar",
  "Sher-e-Kashmir College of Education",
  "Rajive Gandhi Degree College",
  "Lal Bahadur Shastri College of Education",
  "Govt. Degree College, Ramban",
  "INSIGHT INSTITUTE OF EDUCATION AND TRANING, PULWAMA",
  "LAKE CITY COLLEGE OF EDUCATION, SRINAGAR",
  "Govt. Degree College for Women, Kathua",
  "Govt. Degree College, Bishnah",
  "Islamia Farida College of Education",
  "Acharya Sri Chander College of Medical Science & Hospital",
  "Jammu College of Physiotherapy",
  "Bhargava College of Education",
  "FACULTY OF FORESTRY",
  "Ramisht College of Education",
  "Institute of Ayurveda and Research",
  "Ranjit College of Education",
  "KC College of Education",
  "MBS College of Engg. & Technology",
  "K.C Law College",
  "Govt. College for Women, Udhampur",
  "Govt. Degree College, Paloura",
  "Govt. Degree College, Banihal",
  "Govt. Degree College, Budhal",
  "New Age Degree College",
  "National College of Education",
  "Cosmic College of Education",
  "Govt. Degree College, Rajouri",
  "Trikuta College of Education",
  "MODEL GOVERNMENT DEGREE COLLEGE, CHRARI SHARIEF, ",
  "Sant Mela Singh College of Education",
  "JK College of Computer Science and Business Administration",
  "K.C. Gurukul College of Education",
  "KCEF COLLEGE OF EDUCATION, PULWAMA",
  "Shivalik College of Education",
  "J.K College of Education",
  "Surya College of Education",
  "Poonch College of Education",
  "Govt. Degree College, Doda",
  "Govt. Medical College",
  "Muqaddas Degree College",
  "Bhartiya College of Education",
  "Govt. S.P.M.R College of Commerce",
  "Alamdar Memorial College of Nursing and Medical Technology, Charar-i-Sharief, Budgam",
  "Himalayan College of Education",
  "Govt. Degree College Kulgam, Kashmir",
  "Sai Shyam College of Education",
  "BABA PAYAM-UDDIN COLLEGE OF EDUCATION, BARAMULLAH",
  "SSM COLLEGE OF ENGINEERING",
  "INSTITUTE OF ASIAN MEDICAL SCIENCE AND UNANI",
  "ZAKIR MEMORIAL COLLEGE OF EDUCARTION, PULWAMA",
  "NUND RESHI COLLEGE OF EDUCATION, SRINAGAR",
  "M C Khalsa College of Education",
  "IBN SINA COLLEGE OF NURSING AND HEALTH SCIENCES",
  "Govt. Degree College, Bhaderwah",
  "Government  Dy S.P Aman Thakur Memorial Degree College Kastigarh",
  "Govt. College for Women, Gandhi Nagar",
  "Rajive Gandhi B.Sc Nursing",
  "Govt Degree College Jourian",
  "DOLPHIN INSTITUTE OF MEDICAL SCIENCE AND TECHNOLOGY TAHAB ROAD PULWAMA",
  "SRINAGAR COLLEGE OF EDUCATION, SHUPIYAN",
  "FRANKLIN COLLEGE OF EDUCATION, BARAMULLAH",
  "GOVT DEGREE COLLEGE VILGAM KUPWARA",
  "GOVT DEGREE COLLEGE DARHAL",
  "GOVERNMENT NURSING COLLEGE AKHNOOR ",
  "ARR RASHID COLLEGE OF EDUCATION UNISOO",
  "Bhargava Degree College",
  "GREEN VALLEY COLLEGE OF EDUCATION, BARAMULLAH",
  "Hamidi Kashmiri Memorial, GDC IDGAH",
  "GULZAR MEMOROIAL COLLEGE OF EDUCATION, BARAMULLAH",
  "GOVT DEGREE COLLEGE NAGROTA",
  "KASHMIR COLLEGE OF EDUCATION, BARAMULLAH",
  "RAMZAN MEMORIAL COLLEGE OF EDUCATION, BARAMULLAH",
  "WELKIN COLLEGE OF EDUCATION, BARAMULLAH",
  "SIR SYED MEMORIAL COLLEGE OF EDUCATION, BUDGAM",
  "SHRI MATA VAISHNO DEVI GURUKUL    ",
  "TAHIRA KHANAMS COLLEGE OF EDUCATION, SRINAGAR",
  "SHANTI NIKATAM COLLEGE OF EDUCATION, SRINAGAR",
  "GOVERNMENT DEGREE COLLEGE PURMANDAL SAMBA",
  "WULAR VALLEY COLLEGE OF EDUCATION, BANDIPORE",
  "Government Degree College Neeli Nallah Udhampur",
  "Govt. Gandhi Memorial Science College",
  "BIBI HALIMA COLLEGE OF NURSING AND MEDICAL TECHNOLOGY",
  "New Milleninium National College of Education",
  "SANCTORUM COLLEGE OF EDUCATION, LALAD, SOPORE, BARAMULLA",
  "DATA RANPAT DEV  OF PHARMACY",
  "JAN BAZ WALI COLLEGE OF EDUCATION, BARAMULLAH",
  "JAMIA COLLEGE OF EDUCAITON, ANANTNAG",
  "KASHMIR PARADISE COLLEGE OF EDUCATION, BARAMULLAH",
  "Government Degree College Ukhral",
  "KASHMIR WOMENS COLLEGE OF EDUCATION, BARAMULLAH",
  "GOVT DEGREE COLLEGE CHADOORA",
  "GOVT MEDICAL COLLEGE DODA",
  "GOVERNMENT DEGREE COLLEGE ALLOCHI BAGH SRINAGAR",
  "SUBHAN INSTITUTE OF EDUCATIONAL TENCHNOLOGY, BARAMULLAH",
  "Govt Degree College Ghagwal",
  "GOVT DEGREE COLLEGE DUDU BASANTGARH",
  "RAHMAT-E- AALAM COLLEGE OF EDUCATION, ANANTNAG",
  "GOVERNMENT MEDICAL COLLEGE BARAMULLA",
  "UNIQUE COLLEGE OF EDUCATION, MIRGUND BARAMULLAH",
  "Bhagat Kabir College of Education",
  "SOCH KRAL MEMROIAL COLLEGE OF EDUCATION, PULWAMA",
  "Poonch Campus",
  "Syed Mantaqui Memorial College of Nursing and Medical Technology, Awantipora, Pulwama",
  "Govt. College for Women, Parade ",
  "COMPOSITE REGIONAL CENTRE, MINISTRY OF SOCIAL JUSTICE EMPOWERMENT, BEMINA",
  "SHAHEEN COLLEGE OF EDUCATION, BANDIPORE",
  "GREEN LAND BUSINESS SCHOOL",
  "GOVERNMENT DEGREE COLLEGE, SURANKOT",
  "NURSING COLLEGE GOVERNMENT MEDICAL COLLEGE BARAMULLA",
  "CASET COLLEGE OF COMPUTER SCIENCES",
  "GOVERNMENT MEDICAL COLLEGE HANDWARA",
  "Tariq College of Education",
  "Ramnagar Campus",
  "South Campus Anantnag",
  "Government College of Education",
  "Government Degree College Katra Reasi",
  "GOVERNMENT DEGREE COLLEGE  KREERI",
  "SHADAB COLLEGE OF EDUCATION, SRINAGAR",
  "KASHMIR TIBBIA COLLEGE",
  " Maulana Azad Memorial College",
  "Govt Degree College Chenani",
  "Divya College of Education",
  "Reasi Campus",
  "GOVT DEGREE COLLEGE KOTERANKA",
  "DR IQBAL TEACHER TRAINING COLLEGE OF EDUCATION, SRINAGAR",
  "SEM COLLEGE OF EDUCATION, BUDGAM",
  "RAMZAAN COLLEGE OF NURSING, GALLANDER, PAMPORE",
  "Govt Degree College Padder",
  "VITASTA SCHOOL OF LAW",
  "Government DEGREE College Pouni",
  "Jamia Babul Aloom, Mirgund Budgam",
  "JAMIA-TUL-BANAT, UMER COLONY, LAL BAZAR",
  "ISLAMIC ORIENTAL COLLEGE, TRAL",
  "KCEF LAW COLLEGE",
  "Govt. Degree College, Akhnoor",
  "Guru Gang Dev ji college of Education",
  "Govt. Degree College Khansahib Budgam,Kmr.",
  "HANEEFA NURSING COLLEGE SOPORE",
  "Bhaskar Degree College",
  "GOVT. DEGREE COLLEGE MAJALTA",
  "Government Medical College Anantnag",
  "SOPORE LAW COLLEGE",
  "Govt. Degree  College Bemina, Srinagar",
  "SYED ALI MEMORIAL COLLEGE OF EDUCATION, BEERWAH",
  "QAMARIYA COLLEGE OF EDUCATION, GANDERBAL",
  "MOTHER TERESA MEMORIAL COLLEGE OF EDUCATION, TANGMARG",
  "Govt. College for Women M.A.Road, Srinagar",
  "M.E.T College of Education",
  "KIDNEY COLLEGE OF NURSING ZAKURA SRINAGAR KASHMIR",
  "SCHOOL OF ARCHITECTURE KASHMIR",
  "A. S. College, Srinagar",
  "S M IQBAL COLLEGE OF EDUCATION, SRINAGAR",
  "Shri Mata Vaishno Devi College of Nursing",
  "GOVERNMENT DEGREE COLLEGE KALKOTE",
  "Sri  Pratap  College, Srinagar",
  "SARAH INSTITUTE OF MEDICAL SCIENCES BANDIPORA",
  "Govt. Degree College Kokernag, Kashmir",
  "SHRI RANBIR CAMPUS",
  "GOVERNMENT NURSING COLLEGE, KATHUA",
  "SHRI RANBIR CAMPUS, JAMMU",
  "Harvard College of Education",
  "GOVERNMENT DEGREE COLLEGE, HADI PORA, BARAMULLA",
  "INSTITUTE OF PUBLIC HEALTH AND HYGIENE COLLEGE OF NURSING AND  ALLIED HEALTH SCIENCES",
  "GOVERNMENT DEGREE COLLEGE WOMEN, KUPWARA",
  "Government General Zorawar Singh Memorial Degree College, Reasi",
  "CMH College of Legal Studies",
  "R.S College of Education",
  "Sh. Swami Vishwatamanand Saraswati Degree College",
  "Trikuta Degree College",
  "Govt Degree College, Kishtwar",
  "PIONEER NURSING AND PARAMEDICAL COLLEGE",
  "Govt. Indira Gandhi Dental College",
  "MIER College of Education",
  "Govt. Degree College, Udhampur (Boys)",
  "Galaxy College of Education",
  "Institute of Dental Sciences",
  "Calliope College of Education",
  "Govt. Degree College, Ramnagar",
  "Kishtwar",
  "GOVT NURSING COLLEGE REASI",
  "Government Ayurvedic Medical College Jammu",
  "GOVT COLLEGE OF NURSING PULWAMA",
  "SYED BAHA UD DIN GANJ BAKSH MEMORIAL  INSTITUTE OF PARAMEDICAL SCIENCES ARHAMA SHOPIAN",
  "GOVERNMENT DEGREE COLLEGE. THATHRI",
  "MEHBOOB-UL-AALAM COLLEGE OF EDUCATION, BANDIPORE",
  "Govt. Degree College, Thanamandi",
  "AFARWAT COLLEGE OF EDUCATION",
  "G A MEMORIAL COLLEGE OF EDUCATION",
  "ISLAMIC DISCOVERY OF EDUCATION",
  "PARAMOUNT COLLEGE OF EDUCATION",
  "PIONEER COLLEGE OF EDUCATION",
  "SVS PARAMEDICAL COLLEGE",
  "Kalra College of Education udhampur",
  "Kalra College of Education kud",
  "B.N College of Education",
  "BABA MAAN SINGH COLLEGE OF NURSING    ",
  "CHINAB VALLEY COLLEGE OF EDUCATION, BUDGAM",
  "AL-AHAD COLLEGE OF EDUCATION, ANANTNAG",
  "AL-HUDA COLLEGE OF EDUCATION, BARAMULLAH",
  "Bhaderwah",
  "JEHLUM EDUCATION TRUST, BARAMULLAH",
  "MEX WELL COLLEGE OF EDUCATION",
  "Hassan Khoyihami Memorial Degree College Bandipora",
  "College of Teacher Education, Srinagar",
  "Government Degree College, Ramkote",
  "Govt Medical College Rajouri",
  "GOVT DEGREE COLLEGE SIDHRA",
  "Government Degree College, Marh",
  "GOVT COLLEGE FOR WOMEN BHAGWATI NAGAR JAMMU",
  "Govt. Degree College Beerwah, Kashmir",
  "Anjuman Nusrat ul Islam Oriental College Rajouri Kadal",
  "GOVERNMENT DEGREE COLLEGE HYDERPORA ",
  "GOVT NURSING COLLEGE GANGYAL JAMMU",
  " GOVT DEGREE COLLEGE QAZIGUND",
  "GOVT DEGREE COLLEGE AJAS",
  "GOVERNMENT DEGREE COLLEGE BOMAI",
  "GOVT DEGREE COLLEGE LANGATE ",
  "GOVERNMENT DEGREE COLLEGE HAJIN",
  "GOVERNMENT DEGREE COLLEGE ZAINAPORA",
  "DOGRA DEGREE COLLEGE",
  "GOVERNMENT DEGREE COLLEGE FRISAL ",
  "GOVERNMENT DEGREE COLLEGE TULAIL",
  "Government Medical College Kathua",
  "GOVERNMENT DEGREE COLLEGE. JINDRAH",
  "Division of Agriculture Engineering",
  "Prabha Harjilal College of Pharmacy and Paraclinical Sciences",
  "Shiekh-ul-Alam Memorial Degree College, Budgam.",
  "Islamia College of Science & Commerce, Srinagar",
  "Govt. College for Women Nawakadal, Srinagar",
  "Govt. Degree College Boys Baramullah, Kashmir",
  "Govt. Degree College Kupwara, Kashmir",
  "Govt. Degree College for Women Pulwama, Kashmir",
  "Govt. Degree College, Uri",
  "Govt. Degree College for Boys Anantnag, Kashmir",
  "Govt Degree College Handwara, Kashmir",
  "Govt. Degree College Shopian, Kashmir",
  "Govt. Degree College Dooru, Kashmir",
  "North Campus Baramullah",
  "Govt. Degree College Tangdar Kupwara, Kashmir",
  "Govt. Dental College, Srinagar",
  "Govt. Degree College Uttersoo, Kashmir",
  "Gandhi Memorial College, Srinagar",
  "Vishwa Bharti  Womens College, Srinagar",
  "Govt. Degree College Gurez, Kashmir",
  "Govt. Degree College Tral, Kashmir",
  "Govt. Degree College Ganderbal, Kashmir",
  "Govt. Degree College Sogam Kupwara, Kashmir",
  "Govt. Degree College Pattan, Kashmir",
  "Govt. Degree College  Pulwama, Kashmir",
  "Govt. Degree College Bijbehara, Kashmir",
  "Govt. Degree College,Killam Kulgam,Kmr",
  "Govt. Degree College for Womens, Anantnag",
  "Govt. Medical College Srinagar,",
  "Craft Development Institute, Bagh-i-Ali Maradan Khan",
  "Government Degree College,Magam",
  "GOVERNMENT DEGREE COLLEGE, TANGMARG",
  "GOVERNMENT DEGREE COLLEGE, KANGAN",
  "GOVERNMENT DEGREE COLLEGE DHMHAL, HANJI PORA",
  "GOVERNMENT DEGREE COLLEGE, PAMPORE",
  "Govt. Degree College Sopore",
  "Govt. Degree College for Women, Baramullah, Kmr.",
  "JSS COLLEGE OF PHARMACY",
  "Govt. College of Nursing, Shireen Bagh,",
  "Govt.  College  of Education, Srinagar",
  "STEPHENS COLLEGE OF NURSING",
  "Government College of Engineering and Technology Safapora",
  "GOVT DEGREE COLLEGE KRALPORA",
  "Iqbal Institute of Technology & Management Hyderpora,Srinagar",
  "Govt.  Degree College for Women Sopore, Kashmir",
  "Govt. College of Physical Education Ganderbal,Kashmir",
  "Government Degree College, Sumbal, Sonawari, ",
  "GOVERNMENT DEGREE COLLEGE GOOL",
  "Srinagar Women's College, Srinagar",
  "Zakura Campus, University of Kashmir",
  "Vimal Muni College of Education",
  "Chenab College of Education",
  "Govt. Degree College, Nowshera",
  "TRIKUTA COLLEGE OF PHYSICAL COLLEGE",
  "GOVERNMENT UNANI MEDICAL COLLEGE AND HOSPITAL GANDERBAL",
  "GOVERNMENT DEGREE COLLEGE MATTAN ANANTNAG",
  "GOVERNMENT DEGREE COLLEGE AWANTIPORA",
  "GOVT DEGREE COLLEGE BONIYAR ",
  "KASHMIR LAW COLLEGE",
  "GOVERNMENT DEGREE COLLEGE VIJAYPUR",
  "DODA COLLEGE OF EDUCATION DODA",
  "Govt Degree College Sainik Colony Kunjwani",
  "SIDDHI VINAYAK COLLEGE OF NURSING",
  "Girdari Lal Dogra Memorial Degree College Hiranagar",
  "Government Degree College, Marheen",
  "Govt Degree College Ramgarh",
  "KASHMIR COLLEGE OF ENGINEERING AND TECHNOLOGY, RANBIRGARH, NARBAL SRINAGAR    ",
  "Govt Degree College Batote ",
  "FLORENCE PARAMEDICAL AND NURSING INSTITUTE ANANTNAG",
  "GOVT NURSING COLLEGE UDHAMPUR",
  "ARSH INSTITUTE OF HEALTH SCIENCE AND TECHNOLOGY",
  "GOVERNMENT DEGREE COLLEGE RAJPORA",
  "RIZWAN MEMORIAL COLLEGE OF EDUCATION, BANDIPORA",
  "GOVERNMENT DEGREE COLLEGE SARH BAGGA, MAHORE",
  "SVS DEGREE COLLEGE FOR WOMEN, RAJOURI",
  "Government Degree College Doongi Rajouri",
  "GOVERNMENT DEGREE COLLEGE MANDI ",
  "National Institute of Electronics and Information Technology, (NIELIT) Srinagar",
  "Thakur Dharma Singh College of Education",
  "BEE ENN Charitable Trust",
  "Bhim Singh College of Education",
  "Kawa college of Education",
  "Guru Teg Bahadur College of Education",
  "Govt. College of Engineering & Technology",
  "Himalayan Degree college",
  "Sacred College of Education",
  "Govt. Degree College, Samba",
  "Govt. Degree College, Chatroo",
  "Sh. Krishan Chander Govt. Degree College Poonch",
  "Udhampur",
  "Kathua Campus",
  "Dogra College of Education",
  "Govt. Degree College,Basohli",
  "Govt. Degree College, Billawar",
  "Govt. Degree College Kilhotran",
  "Vivekananda College of Education",
  "Ashoka Law College",
  "Swami Vishwatamanand Sarawati College of Education",
  "Govt. Degree College, Dharmari",
  "Model Institute of Engg. & Technology",
  "Rajiv Gandhi Memorial College of Education",
  "Institute of Management Sciences",
  "Govt. Degree College, Kathua",
  "GOVERNMENT DEGREE COLLEGE SUNDERBANI",
  "DARUL-ALOOM HANFIA ARABIA COLLEGE, NOOR BAGH",
  "GOVERNMENT DEGREE COLLEGE, MAHANPUR",
  "Dogra Law College",
  "GOVT DEGREE COLLEGE SOIBUGH",
  "DATA RANPAT DEV COLLEGE OF BSC NURSING AND POST BASIC BSC NURSING",
  "RB College of Education",
  "Temperate Sericulture Research Institute ",
  "Faculty of Veterinary Sciences and Animal Husbandry",
  "YOGANANDA COLLEGE OF ENGINEERING AND TECHNOLOGY, PURKHOO ,JAMMU",
  "Faculty of Agriculture",
  "GOVERNMENT DEGREE COLLEGE, KHOUR",
  "VIR ARJUN SINGH COLLEGE SONUA",
  "TETRI CHANDRAVANSI PHARMACY COLLEGE",
  "PAKUR POLYTECHNIC",
  "Shamshul Haque Memorial Teacher Training college",
  "TRIBAL COLLEGE OF NURSING",
  "SRINATH COLLEGE OF EDUCATION",
  "Vananchal College of Nursing",
  "SAHIBGANJ COLLEGE, SAHIBGANJ",
  "COLLEGE OF FISHERIES SCIENCE",
  "ELITE PUBLIC B.Ed. COLLEGE",
  "JAMSHEDPUR WORKER'S COLLEGE",
  "KUMARESH INTERNATIONAL B.Ed. COLLEGE",
  "JYOTI PRAKASH MAHILA B.Ed. COLLEGE",
  "DEOGHAR COLLEGE, DEOGHAR",
  "JAMTARA MAHILA SANDHYA COLLEGE, JAMTARA",
  "SHIBU SOREN DEGREE COLLEGE DUBRAJPUR TUNDI DHANBAD",
  "MILLAT COLLEGE, GODDA",
  "DEO COLLEGE OF EDUCATION, MUKUNDGANJ",
  "JAMTARA COLLEGE, JAMTARA",
  "Mayurakshi Gramin College, Raneshwar, Dumka",
  "KARNPURA COLLEGE, BARKAGAON",
  "GAUTAM BUDDHA T. T. COLLEGE, HAZARIBAG",
  "B J AZAD COLLEGE, DUMKA",
  "K. B. WOMEN'S COLLEGE, HAZARIBAG",
  "ANNADA COLLEGE,  HAZARIBAG",
  "GOVERNMENT POLYTECHNIC, DHANBAD",
  "St.Xavier's College,Mahuadand",
  "R. S. MORE COLLEGE, GOVINDPUR, DHANBAD",
  "AWADH DENTAL COLLEGE AND HOSPITAL, Jamshedpur",
  "BIT Extension Center, Lalpur",
  "OM SADASHIVA COLLEGE OF PHARMACY",
  "Cambridge Institute of Technology",
  "SIMARIA DEGREE MAHAVIDYALAYA, SIMARIA",
  "Chotanagpur Law College",
  "RTC Institute of Technology",
  "DEGREE COLLEGE, TUNDI",
  "BAHARAGORA COLLEGE",
  "B. N. J. College, Sisai",
  "LAKSHMI CHANDRAVANSI DEGREE MAHILA COLLEGE",
  "ABM college. Jamshedpur",
  "GHAGHRA SCIENCE COLLEGE",
  "Shiveshar Chandravansi Degree College,Majhiaon",
  "MODEL DEGREE COLLEGE, GARHWA",
  "B. S. K. COLLEGE, MAITHON, DHANBAD",
  "GOVT. SANSKRIT COLLEGE, RANCHI",
  "Maa Nagina Shahi Mahila Mahavidyalaya,Nagar Untari",
  "MAHILA COLLEGE PAKUR",
  "PHULO JHANO MEDICAL COLLEGE",
  "GOVERNMENT POLYTECHNIC, BHAGA",
  "CHAIBASA ENGINEERING COLLEGE (ESTD. BY GOVT. OF JHARKHAND & RUN BY TECHNO INDIA UNDER PPP)",
  "GOVERNMENT WOMENS TEACHERS TRAINING COLLEGE",
  "MANIPAL TATA MEDICAL COLLEGE",
  "BAGHMARA COLLEGE, BAGHMARA, DHANBAD",
  "LANGTA BABA COLLEGE, MIRZAGANJ, GIRIDIH",
  "KUNWAR PIRTHI NATH SINGH B.Ed. COLLEGE",
  "D M M T T COLLEGE, BANASO, BISHNUGARH",
  "RAMGARH ENGINEERING COLLEGE (ESTD. BY GOVT. OF JHARKHAND & RUN BY TECHNO INDIA UNDER PPP)",
  "GIRIJA INSTITUTE OF NURSING",
  "PATEL B.ED. COLLEGE, KATAMKUKU, LODHMA KARA",
  "JAMINI KANT B.Ed COLLEGE",
  "SWAMI VIVEKANANDA COLLEGE OF EDUCATION",
  "B.S.S. MAHILA MAHAVIDYALAYA, DHANBAD",
  "AROGYAM HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "R. K. MAHILA COLLEGE, GIRIDIH",
  "Sant Tulsidas College, Rehla",
  "SANSKRIT HINDI VIDYAPITH, JHARKHANDDHAM, GIRIDIH",
  "SHAHEED SHEIKH BHIKHARI COLLEGE OF EDUCATION, SUTIYAMBE, PITHORIA, KANKE, RANCHI",
  "GANDHI INSTITUTE OF PHARMACY",
  "ST. AUGUSTINEs COLLEGE",
  "GOVERNMENT WOMEN POLYTECHNIC, JAMSHEDPUR ",
  "PATAMDA DEGREE COLLEGE, JALLA",
  "MAHILA COLLEGE, GODDA",
  "GOVERNMENT POLYTECHNIC, DUMKA",
  "BOKARO THERMAL SANDHYAKALIN DEGREE COLLEGE ",
  "SHASWAT INSTITUTE OF TEACHERS EDUCATION",
  "Medini Rai Medical College and Hospital, Palamu",
  "S.S.J.S.N. College,Garhwa",
  "R. T. C. B.Ed. College",
  "BAIJNATH PRASAD SNEHI COLLEGE OF EDUCATION",
  "Gossner College",
  "Doranda College",
  "B.S.M.College,Bhawanathpur",
  "S R T COLLEGE, GODDA",
  "CENTRE FOR BIOINFORMATICS",
  "BOKARO MAHILA MAHAVIDYALAYA, BOKARO",
  "Ranchi Women's College",
  "Paramvir Albert Ekka Memorial College, Chainpur",
  "S. K. Bage College",
  "J. N. College",
  "ADARSH COLLEGE, RAJDHANWAR, GIRIDIH",
  "K. O. College",
  "Marwari College",
  "JHARKHAND MAHAVIDYALAYA, DUMRI, GIRIDIH",
  "Maulana Azad College",
  "K. C. Bhagat College, Bero",
  "Yogoda Satsanga Mahavidyalaya",
  "Nirmala College",
  "GOVERNMENT POLYTECHNIC, ADITYAPUR",
  "Dumri College",
  "GOVERNMENT POLYTECHNIC, RANCHI",
  "SATYENDRA NARAYAN SINHA INSTITUTE OF BUSINESS MANAGEMENT",
  "B I T SINDRI",
  "MADHUPUR COLLEGE, DEOGHAR",
  "P. K. ROY MEMORIAL COLLEGE, DHANBAD",
  "DEGREE COLLEGE MAHAGAMA ",
  "KATRAS COLLEGE, KATRASGARH, DHANBAD",
  "MAHINDI BAURI DEGREE COLLEGE KODIA CHANDANKIYARI BOKARO",
  "TATHAGAT T.T. COLLEGE, DHANBAD",
  "PANDIT JAGNARAYAN TRIPATHI B.Ed. COLLEGE",
  "RAJGANJ DEGREE COLLEGE, RAJGANJ, DHANBAD",
  "S P COLLEGE, DUMKA",
  "Karim City College Jamshedpur",
  "DR S RADHA KRISHNAN T T COLLEGE, LARI",
  "SANGHAMITRA TEACHER TRAINING COLLEGE",
  "SANTOSH COLLEGE OF NURSING",
  "AVIRAM GRAMIN VIKASH SWYAM SEVI SANSTHAN COLLEGE OF NURSING ",
  "LAW COLLEGE, DHANBAD",
  "KINGPIN COLLEGE OF NURSING",
  "G.D. BAGARIA TEACHRS' TRAINING COLLEGE",
  "DR C C MAHATO TEACHERS TRAINING COLLEGE BOKARO",
  "GRIZZLY COLLEGE OF EDUCATION, JHUMRI TELAIYA",
  "GOVERNMENT WOMEN POLYTECHNIC, BOKARO",
  "R.N.M.COLLEGE, HUNTERGANJ, CHATRA",
  "FLORENCE COLLEGE OF PARAMEDICAL SCIENCES",
  "NIRMALA COLLEGE OF NURSING",
  "VANANCHAL COLLEGE, TANDAWA",
  "BIT Extension Center Deoghar",
  "Banwari Sahu Mahavidyalay, Latehar",
  "B B M BEd COLLEGE, SARDAHA, CHAS",
  "Sri Ram Teachers Training College",
  "R D B MAHILA COLLEGE, DEOGHAR",
  "HZB AROGYAM INSTITUTE OF NURSING",
  "PEMIYA RISHIKESH INSTITUTE OF TECHNOLOGY",
  "A N COLLEGE, DUMKA",
  "GOVERNMENT POLYTECHNIC JAGNNATHPUR",
  "Greet Teacher Training College",
  "MAHILA COLLEGE MADHUPUR ",
  "MODEL COLLEGE SUGGABATHAN POREYAHAT GODDA",
  "JHUMRI TELAIYA COMMERCE COLLEGE, KARMA",
  "MADHUPUR POLYTECHNIC",
  "SWAMI DHARMABANDHU COLLEGE OF EDUCATION",
  "MORJIWALA  B.Ed. COLLEGE JASIDIH ",
  "JASIDIH B.Ed. COLLEGE",
  "SHIKARIPARA MAHAVIDYALAYA, DUMKA",
  "CHANAKYA TEACHERS TRAINING COLLEGE",
  "HINDI VIDYAPITH B.Ed. COLLEGE",
  "MOTI RAJ DAVI TEACHERS TRANING COLLEGE ANANDI, ORMANJHI",
  "MADHUSTHALI INSTITUTE OF TEACHER TRAINING",
  "GIIT Professional College",
  "A. J. K. College, Chakulia",
  "Institute for Education, Seraikela Kharsawan",
  "TENUGHAT MAHAVIDYALAYA, TENUGHAT, BOKARO",
  "SARIYA COLLEGE, SURIYA",
  "Maryland Institute of Technology and Management",
  "ST BARNABAS HOSPITAL COLLEGE OF NURSING RANCHI",
  "RANCHI AGRICULTURE COLLEGE ",
  "LAKSHMI DEVI SHROFF ADARSH SANSKRIT MAHAVIDYALAYA",
  "SAROJINI INSTITUTE OF TECHNOLOGY",
  "Jamini Kalyani Mahato College of Management, Science and Commerce",
  "ST. XAVIER'S COLLEGE, MAHARO, DUMKA",
  "K.K. COLLEGE OF ENGG. & MANAGEMENT, GOVINDPUR,",
  "NILAI EDUCATIONAL TRUST'S GROUP OF INSTITUATION",
  "K. K. POLYTECHNIC",
  "AVIRAM COLLEGE OF EDUCATION FOR B.ED COURSES, KURU",
  "UTTARI KARNPURA SHRAMIK MAHAVIDYALAYA, DAKRA",
  "Haji Naeemul Haque Degree College",
  "CITY NURSING COLLEGE",
  "BSA MAHILA MAHAVIDYALAYA, SAHIBGANJ",
  "HORTICULTURE COLLEGE KHUNTPANI",
  "AGRICULTURE COLLEGE GARHWA",
  "S. S. Memorial College",
  "St. Xavier's College",
  "B. S. College",
  "B.N.SAHA DAV TEACHER'S TRAINING COLLEGE, GIRIDIH",
  "GOVERNMENT WOMENS POLYTECHNIC, DUMKA",
  "MAHILA MAHAVIDYALAYA,GUMLA",
  "Mahila Mahavidyalaya, Lohardaga",
  "Rambha College of Education",
  "RANCHI COLLEGE OF PHARMACY",
  "MBNS INSTITUTE OF EDUCATION, ASANBANI",
  "SHARDA MAHESH SHARMISTHA DEO DEGREE COLLEGE ",
  "BEHARAGORA POLYTECHNIC, BEHARAGORA",
  "SUBHASH INSTITUTE OF TECHNOLOGY GIRIDIH",
  "GREET EVENING DEGREE COLLEGE, RAJDHANWAR ,GIRIDIH ",
  "J. J. COLLEGE, JHUMRITELAIYA, KODERMA",
  "GIRIJA INSTITUTE OF POLYTECHNIC",
  "KISHOR KUMAR VERMA EVENING COLLEGE BERGI GIRIDIH",
  "Bethesda Women Teachers' Training College",
  "WOMENS COLLEGE, CHATRA",
  "RP NURSING COLLEGE",
  "Mahila Mahavidyalaya, Seraikella- Kharsawan",
  "Janta Shivratri College, Medininnagar",
  "Ganesh Lal Agrawal College, Medininagar",
  "MAHARSHI PARAMHANSH COLLEGE OF EDUCATION",
  "LALA PRITAM BEd COLLEGE, CHATRA",
  "MAA VINDHYAVASHINI COLLEGE OF EDUCATION, PADMA",
  "S B M TEACHERs TRAINING COLLEGE, MASIPIRI",
  "THE HOMOEOPATHIC COLLEGE AND HOSPITAL OF MIHIJAM",
  "JHARKHAND T T COLLEGE, JHUMRI TELAIYA",
  "Shankar Pratap Dev Degree College,Nagar Untanri,Garhwa",
  "Indra Singh B.Ed. College,Garhwa",
  "Surat Pandey Degree College, Garhwa",
  "RINPAS, Kanke",
  "CHITARPUR COLLEGE, CHITARPUR",
  "Rajendra Institute of Medical Sciences (RIMS)",
  "Central Institute of Psychiatry",
  "VIDYA MEMORIAL INSTITUTE OF TECHNOLOGY",
  "CAMBRIDGE INSTITUTE OF POLYTECHNIC",
  "Gulab Chand Prasad Agarwal Degree College,Sadma,Chhatarpur",
  "Vananchal College of Science,Garhwa",
  "Vananchal Dental College and Hospital,Garhwa",
  "GOVERNMENT ENGINEERING COLLEGE, BOKARO",
  "Ashu Kisku Memorial And Rabi Kisku Teachers Training Institute, Chandil ",
  "BHARATHI COLLEGE  OF EDUCATION, KANDRI",
  "GOVERNMENT POLYTECHNIC, KHUTRI",
  "R S ROY PARAMEDICAL AND RESEARCH INSTITUTE",
  "Scholar B.Ed College",
  "SATISH KUMAR SINHA MEMORIAL COLLEGE OF NURSING",
  "RAM TAHAL CHOUDHARY COLLEGE, RANCHI",
  "R K V COLLEGE OF EDUCATION, BAGODAR",
  "RAMBHA COLLEGE, GITILATA",
  "Santosh College of Teachers' Training and Education",
  "Sri Ramakrishna Sarada Ashrama Teacher's Training College",
  "BASIA COLLEGE, BASIA ",
  "S.R.K.M Degree college Chakulia",
  "SUNRISE COLLEGE OF NURSING",
  "Sheikh Bhikhari Medical College & Hospital, Hazaribag",
  "SHIVAM COLLEGE OF EDUCATION",
  "Ramchandra Chandravansi Institute of Technology,Bishrampur",
  "GOVT B ED COLLEGE, HAZARIBAG",
  "GIRIDIH COLLEGE, GIRIDIH",
  "GUMLA POLYTECHNIC",
  "Aditya Prakash Jalan Teachers Training College",
  "Tana Bhagat College",
  "RAMBHA COLLEGE OF NURSING",
  "SAMARPAN DEEP B.ED COLLEGE, USHAMATU, RATU RANCHI",
  "NIRMAL MAHTO EVENING COLLEGE, BERGI, GIRIDIH",
  "CAMBRIDGE TEACHER TRAINING COLLEGE",
  "Government Pharmacy Institute Bariatu Ranchi",
  "RAJEEV GANDHI MEMORIAL TEACHER'S TRAINING COLLEGE, DHANBAD",
  "BIRSA INSTITUTE OF TECHNOLOGY (TRUST)",
  "D.A.V.Institute of Engineering and Technology,Medininagar",
  "SWAMI SAHAJANAND SARASWATI B.Ed COLLEGE",
  "DEGREE COLLEGE BARKATHA",
  "SWAMI VIVEKANAND TEACHER TRAINING B.Ed COLLEGE  ",
  "JHARKHAND VIDHI MAHAVIDAYALAYA, JHUMRI TELAIYA",
  "Rahat College of Education",
  "DEVKI MAHAVEER HOMOEOPATHIC COLLEGE AND RESEARCH HOSPITAL",
  "Degree College",
  "Pakur B.Ed. College, Pakur ",
  "Birsa College",
  "RAMGARH COLLEGE, RAMGARH",
  "MARKHAM COLLEGE OF COMMERCE, HAZARIBAG",
  "TATA COLLEGE, CHAIBASA",
  "J.L.N. COLLEGE ,CHAKRADHARPUR",
  "G.C. JAIN COMMERCE COLLEGE, CHAIBASA",
  "MODEL COLLEGE, CHATRA",
  "Simdega College",
  "DEGREE COLLEGE JARMUNDI    ",
  "GOVERNMENT ENGINEERING COLLEGE GODDA",
  "S.B. COLLEGE, CHANDIL",
  "GOVERNMENT POLYTECHNIC, KODARMA",
  "K.S. COLLEGE, SERAIKELLA",
  "BLNL BOHRA COLLEGE, SAHIBGANJ",
  "B S K COLLEGE, SAHIBGANJ",
  "Silli College, Silli",
  "S. G. M. College",
  "R. L. S. Y. College",
  "K K M COLLEGE, PAKUR",
  "P. P. K. College, Bundu",
  "CHAS COLLEGE, CHAS, BOKARO",
  "DEGREE COLLEGE GOMIA    ",
  "Mandar College, Mandar",
  "P.T.P.S. COLLEGE, PATRATU, RAMGARH",
  "St. Joseph College",
  "CHANDIL POLYTECHNIC CHANDIL",
  "J. M. MAHAVIDYALAYA, BHURKUNDA, RAMGARH",
  "USHA COLLEGE OF PHARMACY",
  "MODEL MHAVIDYALAY NAVADIH PALAJORI",
  "GOLA POLYTECHNIC ",
  "J. S. M. COLLEGE, PHUSRO, BOKARO",
  "CHOTANAGPUR COLLEGE, RAMGARH",
  "WOMENS COLLEGE SIMDEGA",
  "IMPERIAL COLLEGE OF NURSING",
  "Y.S.N.M. College, Medininnagar",
  "Majdur Kisan College,Panki",
  "A. K. Singh College, Japla",
  "URSULINE WOMEN'S TEACHERS TRAINING COLLEGE, LOHARDAGA",
  "MANRAKHAN MAHTO B.Ed. COLLEGE",
  "S P MAHILA COLLEGE, DUMKA",
  "GODDA COLLEGE, GODDA",
  "N.N GHOSH TEACHERS TT COLLEGE, JAMUNARY, KANKE  ",
  "Fatma Teachers' Training College, CHANDWAY DUBALIYA, KANKE",
  "UDAY MEMORIAL B.ED COLLEGE, KEDAL, NEORI VIKASH, KANKE ",
  "JASPURIA B.ED. COLLEGE, ANGARA",
  "GOVERNMENT TEACHERS TRAINING COLLEGE RANCHI",
  "GOVERNMENT WOMENS POLYTECHNIC, RANCHI",
  "CHHOTA NAGPUR INSTITUTE OF INFORMATION TECHNOLOGY AND MANAGEMENT",
  "PHULO JHANO MURMU COLLEGE OF DAIRY TECHNOLOGY",
  "N P SANDHYAKALIN SNATAK MAHAVIDYALAY",
  "GOVERNMENT POLYTECHNIC SAHIBGANJ",
  "SUBHASH TEACHERS TRAINING COLLEGE, GIRIDIH",
  "SHONEBHADRA ADARSH DEGREE COLLEGE",
  "R K M VOCATIONAL TRAINING INSTITUTE ",
  "METAS COLLEGE OF NURSING BARIYATU ROAD RANCHI",
  "MAHILA COLLEGE, SARATH",
  "AROGYAM NURSING COLLEGE",
  "J.K.S. COLLEGE, MANGO, JAMSHEDPUR",
  "FACULTY OF FORESTRY, BIRSA AGRICULTURAL UNIVERSITY, KANKE, RANCHI",
  "IMAMUL HAI KHAN LAW COLLEGE, BOKARO",
  "K. B. COLLEGE, BERMO, BOKARO",
  "K K TEACHERS TRAINING COLLEGE",
  "K.S.G.M. COLLEGE, NIRSA, DHANBAD",
  "R. S. TEACHERS TRAINING COLLEGE",
  "R. V. S. COLLEGE, CHAS, BOKARO",
  "SILLI POLYTECHNIC (Estd. by Govt. of Jharkhand and Run by Techno India under PPP)",
  "AL HABEEB T.T. COLLEGE, BOKARO",
  "AL IQRA T.T. COLLEGE, GOVINDPUR",
  "A R S BEd COLLEGE, BOKARO",
  "Rajendra Prasad Singh Degree College, Chandrapura",
  "MAHILA COLLEGE SAHIBGANJ",
  "B. B. M. COLLEGE, BALIAPUR, DHANBAD",
  "BHAVNATH CHAUDHARY COLLEGE OF EDUCATION",
  "Damodar Valley Teachers Training College,Dhanbad",
  "DAV MAHILA COLLEGE, KATRAS, DHANBAD",
  "DHANBAD TEACHERs TRAINING COLLEGE, DHANBAD",
  "SHAMSHUL HAQUE MEMORIAL EVENING DEGREE COLLEGE",
  "DR. S. RADHAKRISHNAN COLLEGE OF EDUCATION, CHAS",
  "GURU NANAK COLLEGE, DHANBAD",
  "SINDRI COLLEGE, SINDRI, DHANBAD",
  "S.S. COLLEGE, CHAS, BOKARO",
  "S.S.L.N.T MAHILA COLLEGE, DHANBAD",
  "Swami Ramkrishan Pramhansh Teachers Training College",
  "R. S. P. COLLEGE, JHARIYA",
  "JAMSHEDPUR CO-OPERATIVE LAW COLLEGE, JAMSHEDPUR",
  "SIBU SOREN JANJATIYA DEGREE COLLEGE BORIO SAHEBGANJ",
  "SIDHNATH B.ED.COLLEGE",
  "HOLY CROSS COLLEGE EVENING HAZARIBAG",
  "DEV SANGHA INSTITUTE OF PROFESSIONAL STUDIES AND EDUCATIONAL RESEARCH (DIPSER)",
  "ST. COLUMBA'S COLLEGE, HAZARIBAG",
  "PALAMAU INSTITUTE OF PHARMACY",
  "XAVIER INSTITUTE OF POLYTECHNIC AND TECHNOLOGY",
  "Ramchandra Chandravanshi College Of Physical Education",
  "DR JM COLLEGE, DEOGHAR",
  "RAMESH PRASAD YADAV DEGREE COLLEGE DOMCHANCH KODERMA",
  "DEGREE COLLEGE SHIKARIPARA",
  "RAMGOVIND POLYTECHNIC INSTITUTE",
  "GARHWA POLYTECHNIC",
  "NARSINGH COLLEGE OF EDUCATION",
  "Parjanya B.Ed. College",
  "GOVT POLYTECHNIC SIMDEGA",
  "AWADH INSTITUTE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "GOVT POLYTECHNIC  LATEHAR",
  "UNIVERSITY LAW COLLEGE, HAZARIBAG",
  "K N BAKSHI COLLEGE OF EDUCATION",
  "UNIVERSITY COLLEGE OF ENGINEERING & TECHNOLOGY",
  "BAIDYANATH KAMAL KUMARI SANSKRIT COLLEGE",
  "GOVERNMENT POLYTECHNIC, NIRSA DHANBAD",
  "PARASNATH MAHAVIDYALAY, ISRI BAZAR, GIRIDIH",
  "BOKARO STEEL CITY COLLEGE, BOKARO",
  "B.D.A. COLLEGE, PICHRI, BOKARO",
  "RAMGOVIND INSTITUTE OF TECHNOLOGY, KODERMA",
  "P N M COLLEGE,GOMO",
  "PATLIPUTRA MEDICAL COLLEGE, DHANBAD",
  "R.N.Y.M. COLLEGE, BARHI",
  "BALANAND SANSKRIT COLLEGE, DEOGHAR",
  "J.N.M. SANSKRIT COLLEGE, CHAIBASA",
  "G.M. EVENING COLLEGE, ICHAK",
  "ST. XAVIERS COLLEGE, SIMDEGA",
  "BHADRAKALI COLLEGE, ITKHORI",
  "Govt. Homoeopathic Medical College & Hospital, Godda",
  "GURU GOBIND SINGH EDUCATIONAL SOCIETY'S TECHNICAL CAMPUS, CHAS, BOKARO",
  "DAV EVENING COLLEGE GIRIDIH",
  "CHATRA COLLEGE, CHATRA",
  "Cambridge Institute of Teachers Education",
  "R. P. Y. T. T. COLLEGE, JHUMRI TELAILYA, KODERMA",
  "RABINDRA NATH TAGORE AGRICULTURE COLLEGE",
  "DINESH COLLEGE OF EDUCATION",
  "GULMOHAR DEGREE EVENING COLLEGE",
  "J.D. National B.Ed College",
  "Binod bihari Mahato Memorial teachers Training College, Sahu Bahiyar, Topchanchi, Dhanbad,(Jh)",
  "D.B.M.S COLLEGE OF EDUCATION",
  "N.P TEACHERS TRAINING COLLEGE",
  "J J S DEGREE COLLEGE, MIHIJAM",
  "Sukhdeo Sahay Madheshwar Sahay  Degree College,Tarhassi",
  "R.S. ROY COLLEGE OF NURSING",
  "Noamundi College, Noamundi",
  "A S COLLEGE, DEOGHAR",
  "MAX INSTITUTE OF TEACHERS TRAINING ",
  "Womens College, Ramgarh",
  "BCM EVENING DEGREE COLLEGE",
  "PATEL EVENING DEGREE COLLEGE MASIPIRHI HAZARIBAG",
  "S. B. PANDEY SANATHAN TEACHERS' TRAINING COLLEGE",
  "LAXMI CHANDRAVANSI MEDICAL COLLEGE AND HOSPITAL",
  "MOTHER ZIRAMANI TEACHER TRAINING COLLEGE, ORMANJHI ",
  "DUMKA ENGINEERING COLLEGE (ESTD. BY GOVT. OF JHARKHAND & RUN BY TECHNO INDIA UNDER PPP)",
  "AMRITA COLLEGE OF NURSING",
  "Ravi Mahato Smarak Teacher's Training B.Ed. College, Mahuda",
  "R.V.S. College of Engineering & Technology, Jamshedpur",
  "MAHUDA MAHAVIDYALAY, DHANBAD",
  "SURYA NURSING EDUCATIONAL COLLEGE",
  "JUBLEE COLLEGE, BHURKUNDA, RAMGARH",
  "TOKIPUR B.ED COLLEGE",
  "RUPSONA NURSING COLLEGE,HESAL",
  "MOULANA ABUL KALAM AZAD DEGREE COLLEGE",
  "ANGEL NURSING COLLEGE",
  "KUMAR B.ED COLLEGE",
  "TAIYAB MEMORIAL TEACHERS TRAINING INSTITUTE",
  "AL KABIR POLYTECHNIC MANGO JAMSHEDPUR",
  "Tetri Chandravansi College of Education,Garhwa",
  "DEGREE COLLEGE MAJHGAON",
  "Z A ROYAL COLLEGE OF NURSING",
  "GOVERNMENT POLYTECHNIC, KHARSAWAN",
  "R K Vyawasaik Sansthan (B Ed) ",
  "TILKA MANJHI AGRICULTURE COLLEGE, GODDA",
  "COLLEGE OF AGRICULTURAL ENGINEERING, KANKE, RANCHI",
  "B.D.S.L. Mahila College, Ghatsila",
  "X.I.T.E Gamharia Seraikela Kharsawan",
  "L.B.S.M. COLLEGE, JAMSHEDPUR",
  "Degree College Jagannathpur",
  "HAZARIBAG COLLEGE OF DENTAL SCIENCES & HOSPITAL",
  "TEKLAL MAHTO DEGREE COLLEGE",
  "DEGREE COLLEGE MANOHARPUR",
  "Gopinath Singh Mahila College,Garhwa",
  "RANCHI VETERINARY COLLEGE",
  "BETHEL COLLEGE OF NURSING",
  "JHARKHAND EVENING DEGREE COLLEGE",
  "BHOLA CHANDRAVANSI COLLEGE OF SCIENCE",
  "MODEL COLLEGE DUMKA",
  "RAINBOW DEGREE COLLEGE SANDHYAKALIN",
  "MODEL MAHAVIDYALAYA SERAIKELLA KHARSAWAN",
  "S.B.S.S.P.S Janjatiya Mahavidyalay, Pathargama, Godda",
  "DEGREE COLLEGE NALA, JAMTARA",
  "A G COLLEGE OF NURSING",
  "MBNS INSTITUTE OF NURSING",
  "SHINE ABDUR RAZZAQUE ANSARI INSTITUTE OF HEALTH EDUCATION AND RESEARCH CENTRE",
  "MAHILA COLLEGE, CHAIBASA",
  "GOVT TEACHERS TRAINING COLLEGE DEOGHAR",
  "Gopinath Singh B.Ed College Latdag, Meral, Garhwa",
  "ELITE PUBLIC NURSING COLLEGE CHIANKI, DALTONGANJ",
  "MODEL DEGREE COLLEGE, BANO",
  "DEGREE COLLEGE, MAHESHPUR ",
  "GHATSHILA COLLEGE, GHATSILA",
  "MODEL COLLEGE RAJMAHAL , SAHIBGANJ",
  "Mrs. K.M.P.M. Vocational College, Jamshedpur",
  "MBNS INSTITUTE OF GRADUATE STUDIES ",
  "MODEL COLLEGE PAKUR",
  "BHISHMA NARAIN SINGH LAW COLLEGE",
  "B.A College of Engineering, Jamshedpur",
  "MGM Medical College, Jamshedpur",
  "SAHADEV CHANDRAVANSI BED COLLEGE",
  "VISTHAPIT COLLEGE, BALIDIH, BOKARO",
  "DEGREE COLLEGE NALA, FATEHPUR",
  "BUDDHA NURSING COLLEGE",
  "FoIRTDM, Ramakrishna Mission Vivekananda University",
  "SAHYOG EVENING COLLEGE GIRIDIH ",
  "JAMSHEDPUR CO-OPERATIVE COLLEGE",
  "DHANBAD INSTITUTE OF TECHNOLOGY",
  "GOVERNMENT ENGINEERING COLLEGE PALAMU",
  "MODEL DEGREE COLLEGE, GHAGHRA",
  "ST. PAULS COLLEGE, RANCHI",
  "THE GRADUATE SCHOOL COLLEGE FOR WOMEN, JAMSHEDPUR",
  "Madhusudan Mahto Teacher Training College, Chakradharpur",
  "Havanur College of Law, Bangalore",
  "Vidyodaya First Grade College",
  "MAGNUM FIRST GRADE COLLEGE ",
  "SDM College of Physiotherapy",
  "AKASH INSTITUTE OF MEDICAL SCIENCES AND RESEARCH CENTRE",
  "SRI KRISHNA DEGREE COLLEGE",
  "VISHWA VENKATESHWARA DEGREE COLLEGE ",
  "GOVERNMENT FIRST GRADE COLLEGE T DASARAHALLI KALASTREE NAGAR",
  "JSS College for  Women,Saraswathipuram  Mysore",
  "Government First Grade College ,Bilikere",
  "Shree Devi College of Information Science, Ballalbagh, Mangalore",
  "Govt. First Grade College, Vamadapadavu, Bantwal",
  "Prasanna College of Education, Ujire-574240",
  "St. Aloysius Evening College, Mangalore",
  "Mythri College of Education, Shimoga.",
  "Government First Grade College, Sringeri.",
  "Sri Gangarasa College of  Fine Arts, Kengal Channapatna-571501.",
  "Basaveshwara Degree College, 14th Main, Vijaynagar, Bangalore-40",
  "R.J.S. Evening College,  #1, Mahayogiramana Road, 16th Main, 3rd Block, Koramangala, Bangalore -34,",
  "MYSORE SCHOOL OF ARCHITECTURE",
  "Reddy Jansangha FGC, 17th Main road, 3rd Block,  Koramangala, Bangalore-34",
  "L.B. & S.B.S. Arts, Science & Commerce Autonomous College, Sagara.",
  "Sri Kote Boramma First Grade Women's College, Challakere.",
  "New City College of Nursing Udupi",
  "SAI SHANKAR DEGREE COLLEGE, PONNAMPETE",
  "THOUHID WOMEN'S COLLEGE OF COMMERCE, GANGOLLI, KUNDAPURA",
  "GLOBAL EDUCARE FOUNDATION GLOBAL COMMERCE COLLEGE, AKSHAYA COLONY",
  "MARATHA VIDYA PRASARAK MANDAL SHRI CHATRAPATI SHIVAJI MAHARAJ ARTS AND COMMERCE COLLEGE, SAVADATTI ROAD",
  "St.Josephs First Grade College, Jayalakshmipuram, Mysuru",
  "Christ College of Science and Management",
  "Vikram College of Education, Near Railway Track, Chelur Road, Chintamani-563 125, Chikkaballapur Dist",
  "Govt. First Grade College Srinivasapura-563135, Kolar Dist.",
  "Sivananda Sarma Memorial R. V. College, No.17, 26th Main, 36th Cross, Jayanagar, 4th T Block, Bangalore-41.",
  "Government Fine Art College, Opp. SBI Main Branch, College Road.Dharwad.",
  "Sri D Devaraja Urs First Grade College",
  "Shri Sangameshwar Arts and Commerce College Ap kolhar",
  "Nargund college of Physiotherapy",
  "SHRI SIDDAROOD GRAMEEN ABHIVRADDHI EDUCATION SOCIETYES SHRI SADGURU BASAVAROODHA  MAHASWAMIJI ARTS AND COMMERCE COLLEGE, HUVIN HIPPARAGI ",
  "Amrita School of Arts and Sciences, Mysore",
  "KRISHNA COLLEGE OF NURSING",
  "KLE SOCIETYS COMMERCE DEGREE COLLEGE AKOL ROAD  AP  TQ CHIKODI DT BELAGAVINIPANI",
  "FAITH COLLEGE OF NURSING SCIENCES",
  "DECCAN COLLEGE OF NURSING",
  "YASHODHA COLLEGE OF NURSING VIJAYAPUR",
  "SMT SHANTADEVI M KAVATAGIMATH INSTITUTE OF NURSING SCIENCES CHIKODI",
  "SWAMY VIVEKANANDA INSTITUTE OF NURSING SCIENCES, CHITRADURGA",
  "GURUKUL DEGREE COLLEGE KALABURAGI",
  "ANJANADRI INSTITUTE OF PHYSIOTHERAPY",
  "SUVARNA COLLEGE",
  "SYMBIOSIS CENTRE FOR MANAGEMENT STUDIES, BENGALURU",
  "K H PATIL SCHOOL OF LAW HUBBALLI    ",
  "ST JOHNS COLLEGE OF PHYSIOTHERAPY YELAHANKA    ",
  "GOPALA GOWDA SHANTHAVERI MEMORIAL INSTITUTE OF PHYSIOTHERAPY    ",
  "KLA SCHOOL OF LAW TIPTUR",
  "Reva Institute of Science & Technology, No.227, Kattigenahalli, Jala Hobli, Yelahanka, Bangalore -64",
  "SYED ALI IMAM ORIENTAL DEGREE COLLEGE    ",
  "YENEPOYA SCHOOL OF ALLIED HEALTH SCIENCES    ",
  "MM COLLEGE OF NURSING    ",
  "RASHMI INSTITUTE OF AYURVEDA MEDICAL SCIENCE AND RESEARCH CENTRE     ",
  "RELIANCE EDUCATION SOCIETYS RELIANCE BCA AND BA DEGREE COLLEGE AP TALIKOTI    ",
  "MOUNT SHEPHERD COLLEGE OF LAW    ",
  "STANFORD SCHOOL OF LAW    ",
  "JAI LAW COLLEGE    ",
  "SRI BHAURAO DESHPANDE VETERINARY COLLEGE, ATHANI",
  "MS BGS INSTITUTE OF ALLIED HEALTH SCIENCES, DR BM LOKESH CHRITABLE EDUCATIONAL TRUST",
  "VIDYA PRASARAK SOCIETY's COLLEGE OF BCA  BAGALKOT",
  "ANIMAL HUSBANDRY POLYTECHNIC DORANAHALLI",
  "C668 SRIRAKSHA DEGREE COLLEGE YADGIRI",
  "COLLEGE OF HORTICULTURE ALMEL",
  "S R PATIL COLLEGE OF ALLIED HEALTH SCIENCES, BADAGANDI",
  "EAST WEST INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "FATHER MULLER ALLIED HEALTH SCIENCES COLLEGE, THUMBAY",
  "Raman Research Institute",
  "D556 SAJJALSHREE ARTS DEG. COLLEGE, NAGARAL, LINGASUGUR",
  "D561 SRI KHENED MURIGEPPA MSW PG COLLEGE DEVADURGA",
  "D567 NOBLE DEGREE COLLEGE , KUSTAGI ROAD SINDHANUR",
  "D577 SRI SHARADA DEGREE COLLEGE ARAKERA",
  "D578 SAI SPOORTHI DEGREE COLLEGE, MASKI",
  "D581 SIDDHANT DEGREE COLLEGE RAICHUR",
  "D554 BASAVA COMMERCE DEGREE COLLEGE DEVADURGA",
  "D580 SRI SANJEEV COLLEGE OF EDUCATION (B.Ed) LINGASUGUR",
  "D583 SHRI UMAMAHESHWARI BSc DEGREE COLLEGE LINGASUGUR",
  "nfant Jesus Arts and Commerce Degree College",
  "CES BASAVESHWARA ARTS & COMMERCE DEGREE COLLEGE YADGIR",
  "D558 J.M.S M.S.W. COLLEGE, DEODURGA, RAICHUR",
  "Venkateshwara College of Nursing",
  "Government First Grade College, Bukkapatna",
  "GLOBAL SCHOOL OF COUNSELLING",
  "Government First Grade College ,Joida. Tq  Haliyal Dist:  Uttara Kannada,",
  "Government First Grade College, Siddapur. Dist  Karwar.",
  "Government First Grade College, Manki. Tq  Honnavar Dist  Karwar",
  "Government First Grade College, Nelamangala, Junior College Annexure High School Ground, Nelamangala-562 123.",
  "Government First Grade College for Women, Ramanagara, Near Kempegowda Circle, Magadi Road, Rayaradoddi, Ramanagara-562159..",
  "MVJ MEDICAL COLLEGE AND RESEARCH HOSPITAL  MVJ COLLEGE OF ALLIED HEALTH SCIENCES",
  "Dr. P. Dayananda Pai- P. Satisha Pai Government First Grade College, Car Street, Mangalore",
  "The Oxford College of Business Management,  No.32, 19th Main Road, 17th B Cross, Sector-4, HSR Layout, Bangalore -560 102",
  "Seshadripuram Degree College",
  "Veterinary College, Hassan",
  "Bapuji College of Nursing Shimoga",
  "SMT.LAKSHMI. S. NANAVATE B.ED. COLLEGE",
  "Prakash C.N. Arts Commerce And Science Degree College Vijayapur 586103",
  " C681 OM SAI ARTS AND COMMERCE DEGREE, COLLEGE, SEDAM",
  "Sir M V School of Architecture, BANGALORE",
  "D588 SRI AMAREGOUDA PATIL BAYYAPUR DEGREE COLLEGE SIRWAR",
  "ACHARYA SCHOOL OF LAW",
  "Dr. Ambedkar FGC, (Evening)HAL, IInd Stage, Indiranagar, Bangalore-38",
  "Indian Academy Degree College, Hennur Cross, St. Thomas Town,Bangalore-84",
  "Indian Academy Evening College, Hennur Cross, Hennur Road, Kalayanagar, Bangalore-560 043 Ph:25442370/ 9980066012 (2011-12)",
  "Vijaya Teachers College, 11th Main IV Block, Jayanagar, Bangalore-11(PA  UP 2012-13 FOR B.ED)",
  "NAGARAJUNA DEGREE COLLEGE",
  "Sharada Womens First Grade College, Mulabaghalu-563131",
  "Govt. First Grade College, K.R. Puram,Bangalore-36",
  "Govt. First Grade College, Mulabagalu-563131,  Kolar Dist.",
  "DIPLOMA AGRI COLLEGE KUMTA",
  "DIPLOMA AGRI COLLEGE JAMAKHANDI",
  "DIPLOMA AGRI COLLEGE VIJAYAPUR",
  "SHRI SHARANABASAVESHWAR COLLEGE OF PHARMACY VIJAYAPURA",
  "SHRI SHARANBASAVESHWAR NURSING COLLEGE VIJAYAPURA",
  "THE OXFORD MEDICAL COLLEGE AND HOSPITAL  ALLIED HEALTH SCIENCES  ",
  "Al-Badar Rural Dental College & Hospital, Kalaburagi",
  "Smt. Nalini Raghunath Rao Degree College, Jigani, Anekal Taluk, Bangalore District.",
  "Govt. First Grade College, Malur-563130, Kolar Dist.",
  "S M VISVESVARAYA DEGREE COLLEGE",
  "Oxford College of Computer Applications Keshwapur,  Sholapur Road, Hubli.",
  "Govt., First Grade College, Alnavar (Tq:Dharwad)",
  "DR. B. R.Ambedkar Institute of Nursing Bangalore",
  "VBR DEGREE COLLEGE",
  "KUM. SHARANESHWARI RESHMI WOMEN'S BED COLLEGE, KALABURAGI",
  "BLDEA's Smt. Bangaramma Sajjan Arts & Commerce college for women Vijayapura-586101",
  "National Degree College, Bagepalli-562 207, Chikkaballapur Dist.",
  "Government College for Women, Kolar-563101",
  "SIDDHARAMESHWAR ARTS AND SCIENCE COLLEGE KALYAN NAGAR DHARWAD ",
  "Sagar Gangothri College of Nursing",
  "FORTUNE COLLEGE OF NURSING",
  "M S COLLEGE OF NURSING",
  "SRI CHANNEGOWDA COLLEGE OF PHYSIOTHERAPY",
  "ATRIA INSTITUTE OF COMMERCE AND MANAGEMENT ",
  "KALIPALYA CHANAPPA INSTITUTE OF ALLIED HEALTH SCIENCES   ",
  "SHRI BASAVESHWAR EDUCATION SOCIETYS GANACHARI ARTS COMMERCE  SCIENCE DEGREE COLLEGE BAILHONGAL",
  "ALPHA DEGREE COLLEGE BANGARPET",
  "ST CLARET INSTITUTE OF MANAGEMENT",
  "PRERANA TRUST  SCIENCE AND COMMERCE DEGREE COLLEGE AP BHUTANAL",
  "OUR LADY OF BON SECOURS DEGREE COLLEGE",
  "SARVODAYA COLLEGE OF EDUCATION",
  "ASTER CMI HOSPITAL",
  "NINGAMMA HUNACHAPPA MADARI ARTS AND COMMERCE DEGREE COLLEGE TALIKOTI ",
  "Brindavan College, Dwarakanagar, Bagalur Main Road, Yelahanka, Bengaluru - 560063",
  "Smt. PALAMMA WOMENS FIRST GRADE COLLEGE CHALLAKERE",
  "ST BENEDICTS INSTITUTE OF NURSING",
  "SACRED DEGREE COLLEGE  GANAPATHI HALLI",
  "ADITYAS GLOBAL INSTITUTE OF MANAGEMENT ",
  "SRI APSANI N R LAW COLLEGE GANGAVATHI",
  "BEST DEGREE COLLEGE",
  "SHANTHA COLLEGE OF NURSING",
  "C308 N.V. SOCIETY'S, N.V. ARTS, SRI KANHAYALAL MALU SCIENCE & DR. PANDURANGRAO PATKI COLLEGE OF COMMERCE, KALABURAGI",
  "ADITYA WOMENS SCIENCE AND COMMERCE DEGREE COLLEGE BHALKI",
  "KSAWU EXTENSION CENTRE FOR PG STUDIES AND RESEARCH MANDYA",
  "CRESCENT COLLEGE OF NURSING BELAGAVI ",
  "ST JUDE COLLEGE OF NURSINBG",
  "New Ashwini Institute of Nursing  ",
  "CSI Lombard Memorial College of Nursing",
  "Dr. John's College of Nursing",
  "VITTALA INTERNATIONAL INSTITUTE OF OPHTHALMOLOGY",
  "SRI GURU RAGHAVENDRA COLLEGE OF NURSING CHITRADURGA ",
  "St Alphonsa College of Nursing ",
  "Sri Akshaya College Of Commerce and Management",
  "COLACO COLLEGE OF ALLIED HEALTH SCIENCE",
  "Shri Mallikarjun vidya vardhak sangha RKM Ayurvedic Medical College Bijapur",
  "SKIBS B SCHOOL",
  "Westline Degree College",
  "SRI SHIVAGANGA FIRST GRADE COLLEGE OF ARTS AND COMMERCE",
  "NAVACHETHANA DEGREE COLLEGE",
  "AGM Homeopathic Medical College and Hospital",
  "SRI DEVARAJ URS FIRST GRADE EVENING COLLEGE",
  "HOYSALA DEGREE COLLEGE",
  "New Royal College of Nursing",
  "VENKATADRI DEGREE COLLEGE  SRINIVASAPURA ",
  "VIGHNESHWARA INSTITUTE OF NURSING SCIENCE COLLEGE HUBLI",
  "Nanjappa institute of Allied Health Sciences ",
  "SMT VASANTHA COLLEGE OF NURSING GULBARGA",
  "INDIRA COLLEGE OF ALLIED HEALTH SCIENCES",
  "Florida college of nursing",
  "Mahaganapati College of Nursing ",
  "GOVERNMENT COLLEGE OF NURSING DISTRICT HOSPITAL TUMAKURU",
  "NBP Degree College",
  "SRI RAGHAVENDRA FIRST GRADE COLLEGE",
  "SRI SIDDHARTHA INSTITUTE OF MEDICAL SCIENCES AND RESEARCH CENTRE",
  "Nitte University Centre for Science Education and Research",
  "Nitte Institute of Communication",
  "Shri Swami Vivekanand Education Society Shri Basavaraj Siddappa Sanadi Arts and Commerce Degree College",
  "Sri Jagadguru anadaneshwar Education Committees Mundargi Sri Annadaneshwar Commerce Degree College For Womens Mundargi",
  "St. Anne's Degree College, Virajpet, Coorg",
  "Bangalore City College of Nursing, Kadusonappanahalli Cross",
  "SRISAILA JAGADGURU VAGEESHA PANDITARADHYA COLLEGE, HARIHAR",
  "M S College of Commerce ",
  "Kateel Ashok Pai Memorial College",
  "CENTRE FOR HUMAN GENETICS",
  "Mahaganapati Ayurvedic Medical College  Hospital ",
  "RAY Integrated College",
  "SDM INSTITUTE OF NURSING SCIENCES",
  "LEELA COLLEGE OF NURSING",
  "ADITYA COLLEGE OF PARA MEDICAL SCIENCES",
  "UNIVERSITY EVENING COLLEGE MANGALORE",
  "ADITYA COLLEGE OF PHYSIOTHERAPY",
  "Jagadguru Shri Shivanand Commerce College  Kundgol",
  "Shri Basaveshwar International Yoga Kendra Kundgol",
  "grace international college",
  "AVK EVENING COLLEGE",
  "Brindavan college of Architecture, Bengaluru",
  "MES COLLEGE OF NURSING SCIENCES",
  "SAMVEDANA SCIENCE AND COMMERCE FIRST GRADE COLLEGE KHAMBADAKONE",
  "College of Agricultural Engineering, Raichur",
  "Imperial Degree College",
  "SWAMY VIVEKANANDA FIRST GRADE COLLEGE",
  "COLUMBIA COLLEGE OF PHYSIOTHERAPY",
  "CAMBRIDGE COLLEGE OF NURSING",
  "AGM COLLEGE OF PHARMACY VARUR POST HUBBALLI TQ DHARWAD  DIST",
  "Brite Law college",
  "ST CLARET EVENING COLLEGE",
  "SIET COLLEGE",
  "SHREE SWAMI VIVEKAKNDA ARTS AND COMMERCE COLLEGE VIJAYAPUR",
  "NEW EXPERT FIRST GRADE COLLEGE",
  "REGIONAL COLLEGE OF MANAGEMENT BANGALORE",
  "Sahyadri Commerce and Management College ",
  "Shri Vidyasagar College Of Education,Borgaon",
  "VIGOUR INSTITUTE OF YOGIC SCIENCE AND STUDIES ",
  "Jain Degree College",
  "KVG Institute of Nursing Sciences, Sullia",
  "V.V.SANGHA S.K.B.ED COLLEGE TALIKOTI",
  "SHREE BEERESHWAR SHIKSHAN SANSTHE KRISHNA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "DBHPS BASAVESHWARA COLLEGE OF EDUCATION, MYSORE",
  "DBHPS DR.B.D.JATTI COLLEGE OF EDUCATION",
  "Florence Degree College, #60/15/116/2, Huskur Main Road, Near Fruit Market, Electronic City Post, Bangalore-560100",
  "Government First Grade College, Kunigal",
  "Sri Basaveshwara College of Education, Tiptur",
  "Government First Grade College, Bellavi",
  "SANJEEVINI AYURVEDA MEDICAL COLLEGE AND HOSPITAL",
  "KARUNYA FIRST GRADE COLLEGE ",
  "Gurushree College of Commerce and Social work ",
  "ANUGRAHA FIRST GRADE COLLEGE, KUSHALNAGAR",
  "Sri Basaveswara first grade college for women",
  "OXFORD JAIN COLLEGE, TUMKUR",
  "VIDYA BHARATI FOUNDATIONS INSTITUTE OF BUSINESS MANAGEMENT AND RESEARCH, MBA, VIDYA NAGAR, HUBLI",
  "MAR IVANIOS COLLEGE",
  "RAGHAVENDRA COLLEGE OF NURSING",
  "MANORAMA COLLEGE OF COMMERCE , KC RANI ROAD, VIDYANAGAR, GADAG.",
  "RR School of Architecture, BANGALORE",
  "Goutham College of Education",
  "C347 MAHATMA JYOTIBA PHULE DEGREE COLLEGE",
  "C362 NAIK DEGREE COLLEGE OF ARTS WADI",
  "C411 SRI MAILARLINGESHWAR FIRST GR COLLEGE",
  "C471 SMT BHAGAMMA DEGREE COLLEGE OF ARTS",
  "Shri Kalavara Varadaraj M. Shetty Govt. First Grade College, Kundapura, Post:Koteshwara, Udupi District, PIN-576222",
  "SHRI MALLIKARJUN EDUCATION TRUSTS SHRI GANGARAM FIRST GRADE COLLEGE",
  "K L E SOCIETY'S COMMERCE COLLEGE, BELAGAVI",
  "GARMENT RESEARCH TRAINING DESIGN AND DEVELOPMENT CENTRE, BELLARY",
  "SRI PHIRANGISWAMY SAMSKRIT COLLEGE, TUMKUR",
  "Bishop Narman Car Sargent  College Of Commerce &Business  Management,Mysore",
  "Sai Vidya Institute of Technology, BANGALORE",
  "Bearys Institute of Technology, MANGALORE",
  "KLEs College of Engineering & Technology, Chikkodi",
  "Navodaya Institute of Technology, RAICHUR",
  "B G S Inst., of Technology, Mandya Dist",
  "A M C Engineering College , BANGALORE",
  "ATME College of Engineering, MYSORE",
  "Bhemanna Khandre  Institute of Technology, BHALKI",
  "H K B K College of Engineering, BENGALURU",
  "S J M Institute of Technology, CHITRADURGA",
  "Govt. Engineering College, RAICHUR",
  "SEA College of Engineering & Technology, BANGALORE",
  "R V College of Engineering, BANGALORE",
  "VTU  Extension  Center, Karnataka State Remote Sensing Application Centre, Bangalore",
  "S J B Institute of Technology, BANGALORE",
  "Vidya Vardhaka College of Engineering, MYSORE",
  "Govt. Engineering College, KUSHALANAGAR",
  "R L Jalappa Institute of Technology, DODDABALLAPURA",
  "K N S Institute of Technology, BANGALORE",
  "Akshaya Institute of Technology, TUMKUR DIST",
  "Vemana Institute of Technology, BANGALORE",
  "Adichunchanagiri Institute of Technology, CHIKKAMAGALUR",
  "Ballari Institute of Technology & Management, BELLARY",
  "Dr. Ambedkar Institute of Technology, BANGALORE",
  "Govt. Engineering College, CHAMARAJANAGARA",
  "Sampoorna Institute of Technology & Research,RAMANAGAR DIST",
  "Visvesvaraya Technological University, VTUs Regional Office, Mysore",
  "Siddaganga Institute of Technology, TUMKUR",
  "Malik Sandal Inst. of Arts & Architecture, BIJAPUR",
  "Malnad College of Engineering, HASSAN",
  "P D A College of Engineering, GULBARGA",
  "Jain College of Engineering,  BELGAUM",
  "City Engineering College, BANGALORE",
  "Veerappa Nisty Engineering College, HASNAPUR",
  "Govt. Engineering College, HAVERI",
  "BLDEAs  V.P. Dr. P.G. Halakatti College of Engineering and Technology, Vijayapur",
  "P A College of Engineering, MANGALORE",
  "S D M College of Engg. & Technology,  DHARWAD",
  "AGM Rural College of Engineering & Technology,  VARUR",
  "C. BYREGOWDA INSTITUTE OF TECHNOLOGY",
  "Acharya Institute of Technology, BANGALORE",
  "S J C Institute of Technology, CHICKBALLAPUR",
  "S G Balekundri Institute of Technology,  BELGAUM",
  "Govt. Engineering College, MANDYA",
  "Canara Engineering College, BANTWAL",
  "Sir M Visvesvaraya Institute of Technology, BANGALORE",
  "Govt. Engineering College, RAMANAGARA",
  "Vivekananda College of Engg. & Tech., PUTTUR",
  "M S Ramaiah Institute of Technology, BANGALORE",
  "R N S Institute of Technology, BANGALORE",
  "K S School of Engineering & Management, BANGALORE SOUTH",
  "Govt. Tool Room & Training Centre, BANGALORE",
  "Rajeev Institute of Technology, HASSAN",
  "Smt. Kamala & Sri Venkappa M Agadi College of Engineering & Technology, Lakshmeshwar",
  "Bangalore Institute of Technology, BANGALORE-560 004",
  "G S S S Institute of Engineering & Technology for Women, MYSORE",
  "ST JOSEPH ENGINEERING COLLEGE",
  "YENEPOYA INSTITUTE OF TECHNOLOGY, MOODBIDRI, MANGALURU",
  "B M S Institute of Technology & Management, BANGALORE",
  "Channabasaveshwara Institute of Technology, GUBBI",
  "P E S College of Engineering, MANDYA",
  "Sardar Veerangouda Patil mahila vidyapeth smt. Manoramadevi Jugal kishor SomaniArts & Commerce College for Women vidya Nagar, Hubli-580 021",
  "New Education Society's Syeda Safia Degree college for women Raichur",
  "Akkamahadevi Arts & Commerce College for Women, Basavakalyan-585 327",
  "Govt. First Grade Women's College, Bailhongal-591 102",
  "Global College of Education for women Gulbarga",
  "Shri Padmaraj women's Degree College Sindagi",
  "Ramchandra Veerappa Arts & Science College for Women, Humnabad-585 330",
  "Smt. Veeramma Gangasiri College for Women Gulbarga",
  "Smt. K.S. Jiglur Arts & Dr. (Smt) S.M. Sheshgiri Commerce College for Women Near R.N. Stadium, Dharwad- 586 008",
  "KLE Society's Institute of Fashion Technology and apparel Design women college Belgaum-590001",
  "Sri. Vijay Mahantesh Arts & Commerce College for Women, Ilkal-587 125",
  "Sri Jagadaraddya Jayashantilingeshwar Educational Society's Matoshri A. Mallamma Sharnappa Patil Arts College for women Devdurg",
  "Gujjamma Education Society's Women's BEd College, Bhalki",
  "Daryn College of Education for Women, Jamakhandi",
  "Bhagwan Sri Satya Sai Institute of Home Science for Women Saptapur, Dharwad-580 001",
  "SJMV's Arts & Commerce College for Women J.C. Nagar,Hubli-580 020",
  "Sri. Tunnur Siddamma Mallanagoud Arts College for Women, Yadgir-585 201",
  "Consortium of minorities associations CMA Arts and Commerce Degree college for womenC.M.A  Career Management Academy, M.G Tower, IInd Floor, Khade Bazar, Belgaum- 590 001",
  "Sri. Bapugouda Darshnapur Memorial College for Women Gulbarga",
  "Kalmath Sri Chanabasava Swamy Arts & Commerce College for Women, Gangavati-583 227",
  "Deccan College of Education for womens, Hagarga cross, ring road, Gulbarga-585104",
  "Shri Basaveshwar Education society's Akkamahadevi Artscollege for women  Bailhongal",
  "Soma Subhadramma Ramangoud Arts & Commerce College for Women Station Road,      Raichur-584 101",
  "Shastriji Vasati Education College for women, Okkalgeri- Gadag-582103.",
  "Anjuman Degree College for Women,  Shamshuddin Circle Near Hotel cola paradise, Bhatkal-581320",
  "Shri Jagadguru Gurusiddeshwara Vidyavardhak & Sanskritika samsthe's college of Education for women Guledgudd 587203",
  "B.A.J.S.S. Arts & Commerce College for Women   Ranebennur-581 115",
  "Nagambika Educational & Charitable trust's college of Education for women Gulbarga",
  "Chand Bi Bi College of Education for Women,  Gulbarga",
  "Mohammadia B.Ed College for Women, Ballari",
  "C388 Al-Badar ECT's College of Education Gulbarga",
  "C409 Hameed Pyane College of Education Gulbarga",
  "Govt College of Education Gulbarga",
  "C442 Inamdar MSW College & BCA Gulbarga",
  "C407 Taj College Of Education Gulbarga",
  "C393  Deccan College of Education Gulbarga",
  "B278 Jasmine College of Education Bidar",
  "D455 Konda Saraswathamma Hanumanthayya B.Ed College Raichur",
  "C457 Shri Basavanappa Kosgi BCA/BBM Degree College Gulbarga",
  "C491 Siddartha MSW College Gulbarga",
  "C392 KCT's College Of Education Gulbarga",
  "Shantiniketan BBM College Gulbarga",
  "B297 Shree Guru Prsanna Degree College Bhalki",
  "C380 Shriman Dharamsingh College of Science",
  "D461 Nalanda College of Education Yeramaras",
  "C387 National College of Education Gulbarga",
  "C500 S.S Tegnoor College of Mgmt Gulbarga",
  "C313 H.K.E'S, S.S Margol College of Arts, Science & Commerce Shahabad Dist. Kalaburagi",
  "Government First Grade College, Chitapur",
  "Government First Grade College, Basavakalyan",
  "C432 Govt  F G College Chincholi",
  "Sri Sai BCA Degree College Gulbarga",
  "C408 Hingulambika College of Education Gulbarga",
  "B245 K R E Society College of Education Bidar",
  "J.S.S. Sakri Law College, Hubballi",
  "D413 VCBES  ARTS AND COMMERCE COLLEGE LINGASUGUR",
  "C430 Govt  F G College Karajgi",
  "C389 SRI. MURUGHA RAJENDRA SWAMIJI B.Ed. & M.Ed. COLLEGE",
  "C412 S V Arts First Grade College (Swamy Vivekananda) Hunasigi",
  "Hurakadali Ajja Law College, Dharwad.",
  "C437 Shri Shivalingeshwara Govt  F. G. College Madanahipparga",
  "C501 Vishwa Gur Education Welfare Societys Smt Mahadevamma Memorial degree Colleg Chittapur",
  "C406 SB College of Education Gulbarga",
  "D477 Govt First Grade Degree College Jalahalli",
  "C301 H K E S Degree College Aland",
  "B257 Sri Dattagiri Maharaj College of Education Bidar",
  "Seth Chunilal Amarchand Bohra Law College, Raichur",
  "M.K. Sreenivasa Shetty Law College, Chikmagalore.",
  "Vidyodaya Law College, Tumkur",
  "Sharadha Vilas Law College, Mysore",
  "Rajiv Gandhi College of Law, Bangalore",
  "Seshadripuram Law College, Bangalore",
  "B291 Shri Yellalingeshwar College of Education Bidar",
  "Bangalore Institute of Legal Studies, Bangalore",
  "Government First Grade College, Chitaguppa",
  "R.T.E.S Law College, Ranebennur",
  "Government Law College, Holenarasipura",
  "M. Krishana Law College, Hassan",
  "C303 Government College, Kalaburagi",
  "G.K. Law College, Hubli.",
  "Smt. Basamma Gurulingappa Law College, Lingsugur",
  "Sidhartha Law College, Gulbarga.",
  "Rajiv Gandhi College of Education",
  "S.A. Manvi Law College, Gadag.",
  "Panchami College of Law, Bangalore",
  "Dr. Rammanohar Lohia College of Law, Bangalore",
  "R.L. Law College, Davangere",
  "Vunki Sannarudrappa Law College, Bellary",
  "B.M.S. College of Law, Bangalore",
  "M.H. College of Law, Ramanagar.",
  "R.V. Bidap Law College, Bidar",
  "Government Law College, Kolar",
  "D450 KALAMATH POOJYA SRI SIDDARAMA SHIVACHARYA DEGREE COLLEGE, MANVI",
  "GOVT FIRST GRADE COLLEGE,  KHANAPUR",
  "BEYNON SMITH METHODIST DEGREE COLLEGE,   BELGAUM",
  "GOVT.FIRST GRADE COLLEGE, HUKKERI",
  "PADMARAJ B.ED COLLEGE,  SINDAGI",
  "PES & T SHAIKH COLLEGE OF EDUCATION, BELGAUM",
  "BDBVS'S BANJARA ARTS COLLEGE,  BIJAPUR",
  "S R E S 'S  FIRST GRADE ARTS/COMM COLLEGE, KALLOLLI",
  "CTES'S COLLEGE OF EDUCATION, ,   CHIKKODI",
  "JSP SANGHAS COLLEGE OF EDU.,  MUNAVALLI",
  "K V S'S SACHIDANANDA SWAMIJI VEERAKANTAMATH ARTS COLLEGE, KATKOL",
  "SRI RENUKACHARYA ARTS COLLEGE, HORTI",
  "VIDY PRASARAK SAMITIS EDUCATION COLLEGE, RAMDURG",
  "ARIHANT CHARITABLE MINORITY BSW COLLEGE MUDDEBIHAL",
  "SHRI C C HEBBAL GOVT FIRST GRADE COLLEGE,   GOLASANGI",
  "SRI P N CHAVAN MEMORIAL COLLEGE OF EDU.,   HITTINA HALLI-LT",
  "J S P S'S AJJAPPA GADAMI ARTS/COMM COLLEGE, MUNAVALLI",
  "JAI GURUDEV COLLEGE OF SOCIAL WORK, BIJPAUR(PG)",
  "KARNATAKAA TEACHERS EDU., COLLEGE,  INDI",
  "VPS C S BEMBALAGI ARTS, SHA .M. R .PALARESHA SCIENCE AND G L RATHI COMMERCE COLLEGE, RAMDURG",
  "SHRI SANGAMESHWAR EDUCATION SOCIETYS SHRI SANGAMESHWAR ARTS AND COMMERCE COLLEGE, CHADCHAN",
  "KLE'S SHRI SHIVAYOGI MURUGENDRA SWAMIJI BBA COLLEGE,  ATHANI",
  "S C VIDYAVARDHAK SANGHA'S ARTS DEGREE COLLEGE, MUGALKOD",
  "SDM TRUST B.ED COLLEGE,  TERDAL",
  "KLE SOCIETYS COLLEGE OF EDUCATION, ATHANI",
  "SSVS's H S PATIL B.P.ED COLLEGE,  TALIKOTI",
  "VPM's S R NARASAPUR  ARTS & M B SHIRUR COMM COLLEGE  BAGALKOT",
  "CHETANA EDU., SOCI.,CHETANA BCA COLLEGE,  BIJAPUR",
  "LES'S K M ARTS / COMM COLLEGE, BEDAKIHAL",
  "V V Sangha's S K ARTS/ COMM and Science COLLEGE, TALIKOTI",
  "DMSM'S COLLEGE OF BBA,  BELGAUM",
  "L K KHOT COLLEGE OF COMM,  SANKESHWAR",
  "JAIN COLLEGE OF MBA & MCA, BELAGAVI (PG)",
  "SRI LAXMANRAO JARKIHOLI EDUCATION COLLEGE, GOKAK",
  "GVP COLLEGE OF BUSINESS ADM.,, BELGAUM",
  "KLE'S G I BAGEWADI BCA COLLEGE ,  NIPPANI",
  "GOVT FIRST GRADE COLLEGE,  GOKAK",
  "SHRI. GANGADHAR SWAMIJI VIRAKTAMATH ARTS COLLEGE,  BAILHONGAL",
  "SMES'S SHRI. MURUGARAJENDRA DEGREE COLLEGE,    ATHANI",
  "SRI VVSS VEERESHWARA ARTS COLLEGE,  NALATAWAD",
  "SHRI.SAHYADRI DEGREE COLLEGE,  BIJAPUR",
  "CHETANA EDU., SOCI., CHETANA BBA COLLEGE,  BIJAPUR",
  "SHRI SIDDHALINGESHWAR B.C.A COLLEGE  GOKAK",
  "BASAVAPHRABU KORE  COLLEGE OF ARTS/SCIENCE / COMMERCE,  CHIKKODI",
  "KLE SOCIETYS COMMERCE COLLEGE,  SHIRAGUPPI",
  "BANJARA B.ED COLLEGE,  BIJAPUR",
  "SRI MV NAGATHAN ARTS COLLEGE,  NIDAGUNDI",
  "BHARATESH COLLEGE OF COMPUTER APPLICATION,  BELGAUM",
  "SKES'S G S SCIENCE COLLEGE, ,  BELGAUM",
  "VVS'S ARTS/COMM COLLEGE,  BIJAPUR",
  "GOVT. FIRST GRADE COLLEGE,  KOKATANOOR",
  "S S S S'S COLLEGE OF BUSINESS ADMINISTRATION,  BELGAUM",
  "SSVVS KUMARI MONICA BASAVARAJ KANNI B.ED COLLEGE,  BIJAPUR",
  "SMVSS SANGABASAVESHWARS DEGREE COLLEGE,  MASUTI KUDAGI",
  "GRAMEENA V V SS EDU COLLEGE, NODAGUNDI",
  "N R E S'S M G ARTS/COMM COLLEGE, NANDAGAD",
  "KRCESS COLLEGE OF EDUCATION, BAILHONGAL",
  "SKES'S RPD COLLEGE, ,  BELGAUM",
  "TUSWSET'S ARTS/COMM COLLEGE,  UGAR-KHURD",
  "SES WS'S MOULANA ABDUL KALAM AZAD BSW COLLEGE, CHIKKODI ROAD,  EXAMBA",
  "Y V V S'S ARTS COLLEGE,  YAMAKANAMARDI",
  "SPVV SANGHA'S G P PORWAL BCA COLLEGE,  SINDAGI",
  "GOVT FIRST GRADE COLLEGE, PASCHAPUR",
  "SHRI SIDDARAMESHWARA ARTS DEGREE COLLEGE, MORATAGI",
  "SHRI SIDDESHWARA ARTS AND  COMM COLLEGE,  HARUGERI",
  "BHRATESH COLLEGE OF EDUCATION, BELLAD BAGEWADI",
  "ASNSS BHART RATNA DR.RADHAKRISHNAN B.ED COLLEGE, SANKESHWAR",
  "S P M ARTS/SCIE  COLLEGE,  HARUGERI",
  "PES &T BIMS DEGREE COLLEGE, BELGAUM",
  "BVVS BANJARA B.PED COLLEGE,  BIJAPUR",
  "SKET B.ED COLLEGE SRI KALAMATH, APMC ROAD,  SAVADATTI",
  "GOVT. FIRST COLLEGE, KITTUR",
  "S P M S F S ARTS COLLEGE, MADABHAVI",
  "KLE SOCIETYS COLLEGE OF EDUCATION, BELGAUM",
  "SHRI P.S. ARTS AND COMMERCE DEGREE COLLEGE, SUREBAN",
  "BVVS THE PRESIDENCY B.ED COLLEGE,  BIJAPUR",
  "SDVSS'S BCA COLLEGE,  SANKESHWAR",
  "GOVT FIRST GRADE COLLEGE (BA/B.COM/B.SC/BBA),  CHIKKODI",
  "GOVT FIRST GRADE COLLEGE,   BASAVANBAGEWADI",
  "M N R A EDUCATION COLLEGE, BELGAUM",
  "Sri Malemahadeshwara Samskrita College, Kollegal",
  "Sri Rajarajeshwari Samskrita College, Sirsi",
  "Sri Poornaprajna Vidyapeetha Samskrita College, Bangalore",
  "Sri Lakshminarasimha Samskrita College, Jamkhandi",
  "Sri Raghavendra Bharati Saveda Samskrita College, Honnavar",
  "Govt Samskrita College, Melukote",
  "Sri Siddhalingeshwara Veda Samskrita College, Sidhhaganga",
  "Sri Medha Dakshinamurthy Vedabhavana Samskrita College, Gokarna",
  "Srimanmadhwa Sidhhanta Prabodhini Samskrita College, Udupi",
  "Sri Chamarajendra Samskrita College, Bangalore",
  "Sri Kalabhairaveshwara Samskrita Vedagama College, Aadichunchanagiri",
  "Sri Gajanana Samskrita College, Sudi",
  "Sri C L Y Samskrita College, Dharwad",
  "Sharada Vilas Teachers College,  Krishnamurtypuram.",
  "University Law College",
  "University College of Physical Education",
  "University Vishweshwaraya College of Engineering",
  "Dr. B.B. Hegde First Grade College, Near Mookambika Industries, Kundapura--576201",
  "Smt. Rukmini Shedthi Memorial National Govt. First Grade College, Barkur",
  "Sri Dharmasthala Manjunatheshwara College of Buisiness Management, Mangalore-575003",
  "Alva's College, Sundari Ananada Alva Campus, Moodabidri - 574227",
  "Poornaprajna Institute of Management, Udupi",
  "Tippu Sulthan First Grade College, Ombathukere P.O. Ullal-574159",
  "St.Mary's College, Shirva-574116",
  "Mahatma Gandhi Memorial College, Udupi - 576102",
  "Hoysala College of Management, Shimoga.",
  "Badriya First Grade College, Kandak, Mangalore-575001",
  "Govt. First Grade College, Sullia",
  "Kanachur Institute of Management and Science, Deralakatte, Mangalore",
  "Dr. M.V. Shetty Institute of Professional Sciences and Management, Mangaluru",
  "Sri Niranjana Swamy First Grade College, Sunkadakatte, Bajpe",
  "Govt. First Grade College, Bettampady",
  "Sri Devi Institute of Social Work, Ballalbagh, Mangalore-575003",
  "Sacred Heart College, Madanthyar-574224",
  "Mahatma Gandhi Memorial Science College, Behind Govt. Hospital, Kushalnagar, Kodagu",
  "Govt. First Grade College, Napoklu, Kodagu - 571214",
  "St. Agnes College, Mangalore-575002",
  "Alva's College of Education, Sundari Ananda Alva Campus, Moodabidri- 5742207",
  "Govt. First Grade College, Byndoor - 576214",
  "B.T. CHANAIAH GOWRAMMA GOVERNMENT FIRST GRADE COLLEGE",
  "Cauvery College, Pandanda Subbamma Campus, P.B. No.17, Virajpet-571218",
  "Sri Gokarnatheshwara College, Gandhinagar, Mangalore-576003",
  "Sri Devi College of Fashion Design, Ballalbagh, Mangalore-575003",
  "First Grade College, Shanivarasanthe, Kodagu District",
  "Sarasa College of Arts & Science, Ramakripa, Coconut Garden, Near Nanthoor, N.H.17, Mangalore-575002",
  "Karavali College, NH-17, Near Kottara Chowki Junction, Bangra Kuloor, Mangalore-13",
  "GSSS Simha Subbamahalakshmi  First Grade College, Metagalli, Mysuru",
  "JSS Institute of Education, Suttur,Nanjangud Tq.",
  "Government First Grade College, Holalkere,",
  "Jnanadeepa First Grade College",
  "D.Banumaiahs Arts & Commerce College, Mysore",
  "Government First Grade College , Periyapatna",
  "S.R.S. College of education, Chitradurga",
  "Sri Nataraja Residentional  First grade College for Women, Mysore",
  "Bharath  Matha First Grade College,Koppa ,Piriyapatna",
  "Government First Grade College, Holenarsipura",
  "Maharanis  Science College For Women JLB Road Mysore",
  "Vidyodaya  Arts Commerce and Science College,T.Narsipura",
  "SBRR Mahajana  First Grade College, Jayalakshmipuram",
  "Government First Grade College, K.R Nagar",
  "Moulana Azad College of Education, Radha Krishna Nagar Teachers layout, Rajkumar Road",
  "Government First Grade College For Women, K.R Nagar",
  "Government First Grade College ,Hanagodu",
  "Basudeva Somani College, Kuvempunagar,Mysore",
  "Vidya Vikas  First grade College, Bannur Road Mysore",
  "Zubaida Womens Arts College, Shikaripura.",
  "Government First Grade College, Birur.",
  "M.L.M.N. College of Education, Chikmagalur.",
  "P.E.S. Institute of Advanced Management Studies, Guddadakere.",
  "Government First Grade College, Shiralakoppa.",
  "Adichunchanagiri Institute of Business Management, Chikmagalur.",
  "S.R. Nagappa Shresti Memorial National College of Applied Science, Shimoga.",
  "Government First Grade College, Koppa.",
  "Government First Grade College, Ananvatti. Soraba Taluka.",
  "Government First Grade College, Soraba.",
  "I.D.S.G. Government College, Chikmagalur.",
  "St. Charle's Degree College, Bhadravathi.",
  "Tungabhadra College of Education, Tarikere.",
  "Edurite College of Administration & Management Studies, Shimoga.",
  "Government First Grade College, Thirthahalli.",
  "Government First Grade College, Kaduru.",
  "D.K. Shivakumar College of Education, Bhadravathi.",
  "Kuvempu Shatamanothsava Shikshana Mahavidyalaya",
  "Government First Grade College, Panchanahalli.",
  "Sahyadri Science College, Shimoga.",
  "National College of Education, Shimoga.",
  "B.G.S. College of Education, Sringeri.",
  "Sir M.V. Government Arts and Commerce College. Bhadravathi",
  "Sir M.V. Government Science College, Bhadravathi.",
  "Government First Grade College, Yagati.",
  "S.J.G. College of Education, Anandapura, Sagara Taluka.",
  "Government First Grade College, Government Primary School Campus, K.R. Puram.",
  "Sri Maruthi First Grade College, Holaluru.",
  "Jnana Bharathi College of Education, Kaduru.",
  "Government First Grade College, Tarikere.",
  "Sagara Gangothri College of Education, Sagara.",
  "Kodachadri Government First Grade College, Hosanagara.",
  "Government First Grade College, Kalasa, Mudigere Taluka.",
  "Tunga Mahavidyalaya, Anandagiri. Thirthahalli.",
  "Kamala Nehru Memorial National  College for Women,  Shivamogga.",
  "Acharya Tulsi National College of Commerce, Shimoga.",
  "Dr. G A Nariboli College of Education, Sagara.",
  "S.B.C. First Grade College, Davangere",
  "Lingayatha Study Centre, Gadag",
  "Sri SBSS Fine Arts College, Rattihalli",
  "Chitrakala Mandira Kalashale, Udupi",
  "Ranga Study Centre, Kundapur",
  "Nirmala Chitrakalashale, Hasan",
  "Kalamandira Kalashale, Bangalore",
  "Bhavani Lalitakala Mahavidyalaya, Bellary",
  "Halabavi School of Arts, Dharwad",
  "Ravindra Kalaniketana, Tumkur",
  "Dr.F.G. Halakatti Research Centre, Bijapur",
  "SJMS Chitrkala Mahavidyalaya, Chitradurga",
  "Dr.Ha.Ma.Na. Research Centre, Ujire",
  "Benon Smith School of Arts, Belgaum",
  "JN Kalavidyalaya, Gadag",
  "Vijaya Kalamandira, Gadag",
  "Hampi Lalitakala Mahavidyalaya, Hospet",
  "Sri Vivekananda Kalamandira, Raibag",
  "RAJIV GANDHI CAMPUS",
  "Rural college, Kanakapura-561117",
  "Amith Frist Grade Evening College, CA No.2, 2nd Stage, 3rd Main, West of Chord Road, Mahalakshmipuram, Bangalore -86",
  "Shantiniketan College of Science & Management Studies, BM Road, Vivekanandangar, Ramangaram Dist.-571 511,",
  "Bharathiya Samskrithi Vidhya Pith, Ijoor, Ramanagar-571511",
  "Vasavi Jnanapeeta First Grade College, No.10, 2nd Main, Vijayanagar, Bangalore 40.",
  "R.R. Institute of Adavanced Studies, Chikkabanavara, Hesaraghatta Road, Bangalore-90)",
  "Ramanashree Academy of Mgmt., No.14, 10th Cross, 18th Main, MC Layout Vijanagar, Bangalore -40",
  "Sheshadripuram Commerce College, No.65, 10th Cross, Magadi Mn Road, Bangalore -23",
  "Govt. First Grade College, Ramanagara-571571",
  "Keshava College of Dance & Music, No.556, 11th Main, ISRO Layout, Bangalore-78",
  "Spurthy College of Science & Management Studies, #328, Marasur Gate, Anekal Main Road, Marasur Post, Anekal Taluk, Bangalore-562 106",
  "Kengeri First Grade College, Kengeri, Bangalore-60.",
  "Panchajanya Vidhya Peetha Degree College, #42, Ring Road, Mallathhalli, Bangalore -56(08-09)",
  "Sree Nirvana Swamy College of Education, Sree Degulamata, Kanakapura-562 117.",
  "Jnana Vikas Institute of Management Studies & Commerce, Near Tyota Circle, BM Road, Bidadi-562 109, Ramanagaram Taluk & Dist.",
  "Shanti Dhama College, Shantidhama, Sunkadakatte, Magadi Main Road, Bangalore -91",
  "Shanthini Kethana College, No.70, Bile Kalli Bangalore-76",
  "Government First Grade College, Harohalli, Kanakpura, Ramanagar Dist.",
  "Government First Grade College, Govt. Middle & Higher School Annex, 2nd Block, Rajajinagar, Bangalore -560 010.",
  "SJR Women College, #1/D 59th C cross, 4th M block, Rajajinagar, Bangalore-10",
  "Bangalore City College of Education, No.160, Cellakere Main Road, Kalyananagar, Bangalore 43.",
  "Smt. Mehra's College of Management Studies & Science,# 132/2 PNT Layout, 5th Cross, Horamavu Post, Bangalore -43",
  "Kaveri First Grade College, No.354, F Block, Sahakaranagar, Bangalore -92",
  "Surarna Evening College of Commerce & Management, #16, South End Road, Basavanagudi, Bangalore-560 004(2011-12)",
  "Universal College of Computer Application, No. 90, Magadi Main Road Near Tolgate Circle, Bangalore-44",
  "V.V.N Degree College,# 3. Vanivilas Rd.Bangalore-04",
  "JINDAL COLLEGE FOR WOMEN",
  "SFS Evening College, Opp. to Biocon, Huskur Gate, Hosur-Bangalore Main Road, Electronic City, Bangalore-560 100",
  "Bapu College of Management Studies, Thalaghattapura Post, Kanakapura Road, Uttarahalli Hobli, Bangalore -62",
  "The Oxford College of Science, No.32, 19th Main Road, 17th B Cross, Sector-4, HSR Layout, Bangalore -560 102",
  "Jain College, No.463/465, SS Royal, 18th Main Road, 80ft Road, R.R. Nagar, Bangalore-98  (2011-12)",
  "G.T. Institute of Advanced Studies, 10/15, Magadi Road, Sunkadakatte, Vishwaneedum Post, Bangalore-560 091.",
  "B.T.L College, No256, Bommasandra Industrial area, Hosur Road, Bangalore-158",
  "Lorvin Education Centre, 84, 1 Chandapur, Anekal Taluk, Bangalore Dist.-68",
  "Jain Institute of Business Management, #161, Jain Educational Campus, Jakkasandra Post, Kanakapura Taluk-562 112",
  "Sharada Vikas Institute of Mgmt. Studies, No.450/01-14, Lakshmi Complex, 2nd Floor, 10th Main, 27th Cross, 4th Block, Jayanagar, Bangalore -560 011.",
  "S.V.R. College of Commerce & Management Studies, (P.E.S. College of Commerce & Management Studies), No.20/1, Samasandra Palya, HSR Sector-2, Bangalore-34.",
  "Shushruti Institute of Business Management,  #68, Shushruti Nagar, Andrahalli mn road, Peenya 2nd Stage, Bangalore -91",
  "Basaveshwara College of Education, 14th Main, Vijayanagar, Bangalore-40(N)",
  "M.H. College of B.Ed, Vivekanandanagar, B.M. Road, Ramanagaram-571511",
  "City college, 27/2, 33rd Cross, 2nd Main road, 7th block, Jayanagar, Bangalore-82",
  "B.M.S. College for Womens, Bugel Rock Road, Basvanagudi, Bangalore-4",
  "PRAGATHI FIRST GRADE COLLEGE, VIJAYAPURA-562 135",
  "B.E.T College of Management and Science, Dodda Banasawadi, Bangalore-43",
  "K.G.F Frist Grade College, Oorgam, K.G.F-563120,  Kolar Dist.",
  "Sri BVN College Physical Education, 4th Cross, Robertsonpet, K.G.F-563 122.",
  "GEAR B.Ed. College, Sarjapur Road, Doddkanelli, Bangalore -35",
  "Shri Bhaghavan Mahaveer Jain Evening College, Dr. A.N. Krishna Rao Road, Vishveshwar Puram , Banglore-4",
  "Noori College of Education, Al-Hazma Noorinissa Road, Andersonpet, K.G.F-563 113.",
  "Shushruti College of Education, No.68, Shushruthinagar, Andrahalli Main Road, Peenya 2nd Stage, Bangalore -91",
  "Dr. S. Gopalaraju Govt. First Grade College College, Anekal-562106",
  "Adharsha Vidhya Kendra College, 27th Cross, Banashankari 2nd Stage, Bangalore-70",
  "MET Academy of Management  Science,  No.1/4, Ittina Apartments, Balaji Layout, 4th Main, Hongasandra, Bommanahalli, Bangaloe-68.",
  "Vasavi  Jnanapeetha FGC( Evening),#10, 11th main, Vijayanagar,  Bangalore-40",
  "Colombia College, #6, Guruvanagar, Kothanur Dinne Main Road, JP Nagar 7th Phase, Bangalore  78",
  "East West College of  Management, Viswaneedum Post, Magadi Mn Road, Bangalore-91",
  "Sri Sharada First Grade College",
  "SJB College of Management Studies, #67, BGS Health & Education City, Kengeri, Bangalore -560 060(10-11)",
  "Dayananda Sagar Evening College, Shavige Malleshwara hill, Kumaraswamy layout , Bangalore-12",
  "Seshadripuram Academy of Business Studies",
  "Sri Raghavendra College of Education, No.24, Chinmaya Hills, Pipeline Road, Chikkabanavara Post, Bangalore -90",
  "Dayananda Sagar College of Arts, Science & commerce College, Shavige Malleswara hills, Kumara Swamy Layout, Bangalore-78",
  "Baghirathi Bai Narayana Rao Mane College, Banashanakari IInd Stage, Bangalore-70",
  "BBMP First Grade College, Kasturaba Nagar, Mysore Road, Bangalore-560 026 Ph:9480683136(2011-12)",
  "SEA Evening Degree College, Ektanagar, Basavanaupra, Virgonagar Post, Bangalore -49",
  "Pinnacle Institute of Management & Science #19/2, Bhavani Mansion, Mallathalli, Nagarabhavi 2nd Stage, Deepa Complex, Opp. AIT Bangalore -72",
  "Shakuntala Devi International Institute  of Management Science, CA Site, #32/P3 Sector-IV, HSR Layout, Hosur Sarjapur Road, Behind International Freedom School, Bangalore (10-11)",
  "SJES College of Management Studies",
  "G.T. Institute Management Studies & Research, 10/15, Magadi Road, Sunkadakatte, Vishwaneedum Post, Bangalore-560 091.",
  "SHREE DAKSHA ACADEMY,#596, Andrahalli mn rd, Opp D gp, Layout Arch, Blore-91",
  "KLE Society's Degree College, 2nd Stage, 3rd Block, Next to BDA Complex, Nagarabhavi, Bangalore-560 072. (9-10)",
  "RR Institute of Management, #67, Chikkabanavara, Bangalore-560 090.",
  "KUMADVATHI FIRST GRADE COLLEGE, SHIKARIPURA",
  "Karnatak  Education College, Dharwad",
  "J.M.J Education Society, J.M.J B.C.A College, Hubli Road. Chippagi, Shirsdi Dt- Karwar",
  "Bapuji Grameen Vikas Samitis Arts and Commerce College, Sadashivagad, Karwar.",
  "Sir Siddappa Kambali Law College, Dharwad",
  "Shri Siddarameshwar Education College,Kalyan Nagar, Dharwad.",
  "KLESs Sri.Kaddasiddeshwar Arts & HSK Science Institute, Hubli",
  "KLESs College of Education, Hubli",
  "Patima B.B.A College Keshwapur Hubli.",
  "Bapuji Grameena Vikas Samitis Arts College, Ramanagar,  Tq: Joida.",
  "BMHECs Kittel Science College, Dharwad",
  "KSS Arts & Commerce College, Mulgund.",
  "Government First Grade College , Kumata.Dist:  Uttara Kannada",
  "Government First Grade College, Bankapur Tq:Shiggaon",
  "SHRI.SHA.BRA.SIDDALINGA SHIVACHARYA MAHASWAMIGALU PANCHAGRAHA HIREMATH GOVERNMENT FIRST GRADE COLLEGE KUNDAGOL-581113",
  "Shri. R.N. Deshpande Government First Grade College, Mulgund",
  "BMHECs CSI College of Commerce. Dharwad",
  "SES Shivaji Arts & Commerce College, Baad-Karwar.",
  "Gokhale Centenary College, Ankola.",
  "Rural B.Ed College Sattur, P.B.Road, Dharwad.",
  "Govt., First Grade College, Gadag",
  "GESs G.S.Patil Arts & Commerce College Kundagol",
  "Divekar College of Commerce, Karwar.",
  "Shri. Guru Sudhindra B.C.A College Ayodya Nagar, Bhatakal Dt- Karwar",
  "JSS Banashankari Arts,Commerce & S.K.Gubbi Science College, Vidyagiri Dharwad",
  "ASS Amruteshwar Arts & Comm.  College Annigeri    (Tq: Dharwad)",
  "Bangurnagar Arts, Science & Commerce College, Dandeli.",
  "NTSS Shree Shankar Arts & Commerce College Navalgund.",
  "Oxford College of Business Administration   Keshwapur  Sholapur Road, Hubli.",
  "KSS Vijayanagar College of Education Hubli",
  "Global Educare Foundation Global B.B.A College Vidya Nagar Hubli.",
  "Anjuman B.B.A College, Dharwad",
  "Vidhya Sarswati Foundation CIM Grad B.B.A College White House, Desai Building, Sarswatpur, Dharwad",
  "Kittel Arts College, Dharwad",
  "KLEs Arts & Commerce College, Ankola (UK)",
  "Bhatkal Education Trusts Guru Sudhindra Arts & Commerce College, Bhatkal.",
  "Anjuman-Hami-A-Muslimin Societys Anjuman Institute of Management, Bhatkal.",
  "Canara Welfare Trust, Divekar B.C.A. College, Karwar",
  "KSS Arts,Science & Commerce College, Gadag",
  "Govt., First Grade College, Haliyal.",
  "Al-Mizan B.Ed College, Old Hubli, Hubli.",
  "Kanara Welfare Trusts B.Ed College, Janata Vidyalaya Campus, Dandeli.",
  "Govt., First Grade College, Dharwad.",
  "Govt., Arts & Science College, Karwar.",
  "Shri. Yadiyur siddlingeshwar Trust Shri. Yadiyur Siddlingeshwar B.Ed College, Naragund Dist- Gadag",
  "Anjuman Arts, Science & Commerce College, Bhatkal.",
  "RTES Arts Science & Commerce College, Ranebennur",
  "Sri.Jnaneshwari College of Education, Sagar Road, Ayodhya Nagar, Bhatkal.",
  "K.L.E. Society's  P.C.Jabin Science College, Hubballi  (Autonomous)",
  "Sakhaphiya millat Edn. Societies Abdul Kalam BCA College, Vivekanad Nagar Irani Colony Gadag.",
  "K.R.Bellad Arts & Commerce College, Mundargi.",
  "Shri. Channabasaveshwar Shikshna Samste, Shri. Sai Phy. College, Navanagar Hubli.",
  "MVAS Shree K.G.Nadgir College of Phy.Education Dharwad",
  "KCS Dr.A.V.Baliga Comm.  & B.B.A. College of Kumta.",
  "SESs Shivaji Education College, Baad-Karwar.",
  "R.S.Shetty College of Commerce (Corporate Secretary)Dharwad.",
  "Shri. Jagadguru Tontadarya Govt., First Grade B.Sc. & BBA College Mundargi.",
  "Adventist College of Nursing",
  "Sri Nirvanaswamy College of Nursing",
  "Roohi College of Nursing",
  "Rajiv Memorial College of Pharmacy",
  "Athena College of Nursing",
  "Rev. Noorunnissa College of Nursing",
  "Government Dental College, Bangalore",
  "Acharya College of MLT",
  "D A Pandu Memorial R V Dental College",
  "Sri Venkateshwara College of Nursing, Dasanapura",
  "V L College of Pharmacy",
  "SVET College of Pharmacy",
  "Unity Institute of Nursing Sciences",
  "Abhaya College of Nursing",
  "M V M Suma College of Nursing",
  "S V M V V Ayurvedic Medical College",
  "Unity College of  Nursing",
  "KCT College of Pharmacy",
  "Dr. Shyamala Reddy College of Nursing",
  "Navaneetham College of Nursing",
  "A J Institute of Medical Sciences",
  "Swamy Vivekananda College of Nursing",
  "Mangalore College of Nursing",
  "Karnataka College of Nursing",
  "Sri Ramakrishna College of Nursing",
  "Shree Devi College of Nursing",
  "Indian Academy College of Nursing",
  "Narayana Hrudayalaya_Paramedical",
  "HMS Unani Medical College & Hospital",
  "Nethradhama School of Ophthometry",
  "Kiran College of Nursing",
  "K P S V Shri Virupaksha Ayurvedic Medical College",
  "Padmashree Institute of Nursing",
  "Vidyakirana Institute of Nursing Sciences",
  "Luqman Unani Medical College & Hospital",
  "Shridevi College of Nursing",
  "B N M Ayurvedic Medical College",
  "East west College of Nursing",
  "Karnataka Ayurvedic Medical College",
  "City College of Nursing",
  "M M U College of Pharmacy",
  "Varadaraja College of Nursing",
  "Padmashree College of Hopspital Management",
  "Indian Institute Ayurvedic Medical College",
  "Sahyadri College of Nursing",
  "Vydehi Institute of Dental Sciences & Research Centre",
  "St. Ann’s College of Nursing",
  "K L E Society's College of Pharmacy",
  "SLES College of Nursing",
  "B M S Hospital College of Nursing",
  "Vidya College of Health Sciences",
  "Cauvery College of Nursing",
  "Fr. Muller College of Physiotherapy",
  "KVG Medical College Sullia",
  "Shanti Dhama College of Nursing",
  "SLV College of Nursing",
  "Royal College of Nursing",
  "Al-Ameen College of Pharmacy",
  "Smt. Narayani D.R. Karigowda College of Nursing",
  "P M Nadagowda Memorial Dental College & Hospital",
  "Nargund College of Pharmacy",
  "Laxmi Memorial College of Physiotherapy",
  "Government College of Pharmacy",
  "Banasawadi College of Nursing",
  "Holdsworth Memorial College Of Nursing",
  "KVG Dental College & Hospital Sullia",
  "Udupi College of Nursing",
  "E T C M College of Nursing",
  "Alva’s Homoeopathic Medical College",
  "The Capitol College of Nursing",
  "R V College of Physiotherapy",
  "Government Unani Medical College",
  "Indian Institute of Nursing",
  "A E C S Maruthi College of Nursing",
  "The Oxford Dental College",
  "Rajeev College of Nursing",
  "Varalakshmi Hospital College of Nursing",
  "Sri Sri Ayurvedic Medical College",
  "Srinivasa College of Physiotherapy",
  "Bapuji College of Pharmacy",
  "R V College of Nursing",
  "Sharabeshwara College of Nursing",
  "Shimoga Institute of Medical Sciences,",
  "S.J.M. Institute of Nursing Sciences",
  "Sri Raghavendra  College of Nursing",
  "BVV Sangha’s S. Nijalingappa Medical College",
  "Sri Krishna College of Nursing",
  "Alva's College of Naturopathy & Yogic Sciences",
  "SDM Ayurvedic Medical College",
  "Sri Dharmasthala Manjunatheshwara College of Nursing",
  "Manjushree College of Nursing",
  "Noor College of Nursing",
  "Adichunchanagiri College of Nursing",
  "Sri Sharada College of Nursing",
  "Adarsha College Of Nursing",
  "Global College of Nursing",
  "Alva's College of MHA",
  "Faran College of Nursing",
  "The Oxford College of Physiotherapy",
  "Sri Shanthini College of Nursing",
  "Jupiter College of Nursing",
  "The Oxford College of Nursing",
  "Smt. Nagarathanamma College of Nursing",
  "Sri Ramana Maharshi College of Nursing",
  "JSS College of Physiotherapy",
  "Brite College Of Nursing",
  "Surya College of Nursing",
  "Sri Channe Gowda College of Nursing",
  "Sarvodaya College of Nursing",
  "Navodaya Medical College",
  "Noorie College of Nursing",
  "Vijayanagar Institute of Medical Sciences",
  "Sri Raghavendra College of Pharmacy",
  "Nethaji Institute of Nursing Sciences",
  "Heardtland College of Nursing",
  "Government Dental College, Bellary",
  "Koshys College of Nursing",
  "Belgaum Institute of Medical Sciences",
  "Vokkaligara Sanga Dental College & Hospital",
  "Ashwini Ayurvedic Medical College",
  "Siddarameshwar Ayurvedic Medical College",
  "M V J College of Nursing",
  "Siddagnaga College of Pharmacy",
  "S B Patil Institute of Dental Sciences & Research",
  "Gopala Gowda Shantaveri Memorial College of Nursing",
  "Christian College of Nursing",
  "SGV Ayurvedic Medical College",
  "Shree Devi College of Pharmacy",
  "SYMBIOSIS Institute of Business Management, Bengaluru",
  "SMS First Grade College, Honnali",
  "Sri Jattangi Rameswara Rural First Grade College, Rampura.",
  "Vedavati Government First Grade College, Hiryuru.",
  "A.R.G. COLLEGE OF ARTS & COMMERCE, Davangere",
  "Shatamanosthava College of Physical Education. Malladihalli Chitradurga district",
  "Bapuji College of  Nursing Davangere",
  "COLLEGE OF RURAL HOME SCIENCE,DHARWAD",
  "Smt. Lakshmi Devi College of Nursing",
  "C361 Sri Veerendra Patil First Grade Degree College Afzalpur",
  "C405 Motherteresa College Of Education Gulbarga",
  "Shushruti College of Nursing",
  "Seshaiah College of Nursing Vidyaranyapura",
  "KLEs College Of Pharmacy Nipani",
  "Institute Of Nephro-Urology Bangalore",
  "C352 Chawan Degree College Gulbarga",
  "Shree Devi College of Physiotherapy, Mangalore",
  "C568 Sri Basawalingappa B.Reshmi M.Sc. Computer Science college Gulbarga",
  "JSS SHRI  MANJUNATHESWARA INSTITUTE OF UG & PG STUDIES VIDYAGIRI, DHARWAD",
  "DR H L THIMMEGOWDA COLLEGE OF PHARMACY, RAMANAGARA",
  "Government Ayurvedic Medical College, Bangalore",
  "Government  College of Nursing, Bangalore",
  "Government College of Nursing, Dharwad",
  "Government College of Nursing, Gulbarga",
  "ASHRITH COLLEGE OF NURSING, KOTA,UDUPI",
  "Government College  of Nursing, Hassan",
  "JSS SHRI MANJUNATHESHWAR COMMERCE COLLEGE, HUBLI",
  "BASAVAREDDY EDUCATION SOCIETYS BASAVAREDDY ARTS AND COMMERCE COLLEGE, DHARWAD",
  "RAJEEV GANDHI YOGA COLLEGE, GADAG",
  "CBS CHARITABLE FOUNDATIONS CBS ARTS COMMERCE AND SCIENCE COLLEGE, DHARWAD",
  "SHRI VIDYA SARASWATI FOUNDATIONS CIM ARTS AND COMMERCE COLLEGE, DHARWAD",
  "KANAKADAS SHIKSHNA SAMITI KSS ARTS COLLEGE, GAJENDRAGAD",
  "BANGALORE CITY COLLEGE OF NURSING",
  "C519 NISARGA BCA COLLEGE, GULBARGA",
  "Sangolli Rayanna First Grade Constituent College, Belagavi",
  "Kumadvathi College of Education, Shikaripura.",
  "GOVT FIRST GRADE COLLEGE, DANDELI",
  "JANATHA SHIKSHANA PRASARAK SAMITHI ARTS COLLEGE, ITAGI, KHANAPUR",
  "SAVITHRIBAI PULE MULTIPURPOSE WOMENS WELFARE SOCIETY GURUBASAVA ARTS COLLEGE, ATHARGA, INDI",
  "GRAMINA ABHIVRUDHI VIDYAVARDHAKA SAMITHI  SHRI GURUBASAPPA GUNDAGI ARTS COLLEGE, ALMELA, SINDHAGI",
  "B316 SRI BASAVESHWAR SCIENCE FIRST GRADE COLLEGE, BASAVAKALYAN",
  "B314 SRI BASAVESHWAR ARTS FIRST GRADE COLLEGE RAJESHWAR, BASAVAKALYAN",
  "D532 GOVT FIRST GRADE COLLEGE, SIRWAR, MANVI",
  "C530 SMT SUBADRAMA B RESHME ARTS, SCIENCE AND COMMERCE DEGREE COLLEGE",
  "C522 SRI SHIVANA GUNDESHWAR EDUCATION SOCIETY LOVELY FRIEND ARTS DEGREE COLLEGE",
  "C528 GANGNA PARAMESHWARI ARTS AND COMMERCE DEGREE COLLEGE",
  "C524 M A TENGLIKAR COLLEGE OF COMMERCE",
  "C531  SAMBUDHA ARTS & SCIENCE DEGREE COLLEGE, ALAND",
  "C529  ANAND ARTS DEGREE COLLEGE, MARAGUTTI CROSS",
  "University Evening College, University of Mysore",
  "GOOD SHEPHERD INSTITUTE OF MANAGEMENT STUDIES, RAJARAJESHWARI NAGAR",
  "Cambridge Institute of Technology North Campus, BANGALORE",
  "BILURU GURUBASAVA MAHASWAMIJI INSTITUTE OF TECHNOLOGY, MUDHOL",
  "SJB SCHOOL OF ARCHITECTURE AND PLANNING, BGS HEALTH AND EDUCATION CITY, KENGERI",
  "Maharanis Arts College For Women, JLB Road,Mysore",
  "CANARA EVENING COLLEGE",
  "SNS COLLEGE OF NURSING, GUNDLUPET",
  "University College, Mangalore",
  "GOVT. FIRST GRADE WOMENs  COLLEGE, MADIKERI-571201",
  "HULKOTI CO-OPERATIVE EDUCATION SOCIETYs LAW COLLEGE",
  "SRI SAI RAM DEGREE COLLEGE",
  "C537 SHARAD RESHMI DEGREE COLLEGE",
  "C538 SHISHIR RESHMI DEGREE COLLEGE",
  "C539 SMT BHARTHI RESHMI DEGREE COLLEGE",
  "Vidyavahini PG College",
  "Tagor Chitrakala Vidyalaya, Karwar",
  "Chamarejendra Government college of visual arts,(CAVA).",
  "SKSSSs SHRI ADRUSHYA GURUSIDDESHWARA DEGREE COLLEGE, MARADIMATH",
  "The Oxford Medical College Hospital  Research Center",
  "KLE Society Degree College, Ankali",
  "SMT PREMA B KARAJAGI WOMENS DEGREE COLLEGE",
  "DR. LALITHA MANOHARAN COLLEGE OF NURSING",
  "GOVERNMENT FIRST GRADE COLLEGE FOR WOMEN",
  "City College of Imaging Technology",
  "AMBIKA WOMENS DEGREE COLLEGE",
  "C494 GURUJI ARTS AND COMMERCE DEGREE COLLEGE",
  "SHREE VINAYAKA INSTITUTE OF TECHNOLOGY",
  "SUBBAIAH INSTITUTE OF DENTAL SCIENCES",
  "C569 Harshavardhan Degree College Mallabad Tq Afzalpur",
  "Channamma First Grade College",
  "ST JOSEPH FIRST GRADE COLLEGE, HUNSUR , MYSORE Dist",
  "SHREE SAPTHAGIRI INSTITUTE OF NURSING SCIENCES",
  "Mysore City Minority First grade college",
  "BGS  First Grade College, Kuvempunagar",
  "BGS First Grade college, Mandya -Bannur Road ",
  "Government First Grade college, Saragur, ",
  "BGS Global Institute of Medical Sciences",
  "S V N COLLEGE OF EDUCATION",
  "Sapthagiri College of Allied Health Sciences",
  "Sapthagiri College of Nursing (Bangalore)",
  "Sapthagiri Institute of Physiotherapy",
  "M. B .S. ARTS FIRST GRADE COLLEGE, MUDDEBIHAL-586 212",
  "Smt. Ugamadevi Bhawarlal Nahar Theosophical Womens College, Hospet",
  "B.V.V.S. Akkamahadevi Women's Arts, Science and Commerce College,  Bagalkot",
  "MANGALORE INSTITUTE OF MANAGEMENT AND SCIENCE",
  "Maharani's Women's Commerce and Management College, Valmiki Road, Paduvarahalli, Mysuru-12.",
  "KARNATAKA RATHNA DE JA GOW FIRST GRADE EVENING COLLEGE, JAYALAKSHIPURAM, MYSURU-12",
  "MAA-BHARATI WOMENS FIRST GRADE COLLEGE RABAKAVI",
  "ASC Degree Evening College",
  "INDU DEGREE COLLEGE",
  "Jnanapeetha degree  evening college",
  "SHREE GURU MALLIKARJUN COLLEGE OF EDUCATION(B.ED),CHADCHAN-586205",
  "East Point College of Nursing",
  "HILLSIDE AYURVEDA MEDICAL COLLEGE AND HOSPITAL",
  "VIDYA VIKAS INSTITUTE OF LEGAL STUDIES, MYSORE",
  "SHRI TAI PARWATIMAKKALA BALAGAS ARTS and COMMERCE WOMENS DEGREE COLLEGE LAXMESHWAR",
  "Veervanite Mallamma Womens Degree College,M.Belawadi",
  "CAMBRIDGE FIRST GRADE COLLEGE ",
  "Amrutha Ayurveda Medical College and Hospital, Chitradurga",
  "C591 MAHANAGESHWAR ARTS DEGREE COLLEGE, GULBARGA",
  "B533 SUNSOFT DEGREE COLLEGE, BIDAR ",
  "Bangalore Baptist College Of Nursing",
  "CENTURY COLLEGE OF NURSING",
  "S B COLLEGE OF HOSPITAL ADMINISTRATION",
  "Nitte Institute of Architecture",
  "Karnataka Health Institute Ghataprabha",
  "DR N A MAGADUM AYURVEDIC MEDICAL COLLEGE, HOSPITAL AND RESEARCH CENTRE ANKALI",
  "KARAVALI COLLEGE OF PHYSIOTHERAPHY",
  "SADHANA DEGREE COLLEGE",
  "ESIC MEDICAL COLLEGE AND HOSPITAL, SEDAM ROAD GULBARGA",
  "government college of nursing,BIMS Belgaum",
  "EMPLOYEES STATE INSURANCE CORPORATION COLLEGE OF NURSING  GULBARGA",
  "B550  IDIAL DEGREE COLLEGE, BASAVAKALYAN, BIDAR",
  "HARSHA INSTITUTE OF ALLIED HEALTH SCIENCES",
  "BITS HI-TECH COLLEGE",
  "CHRIST COLLEGE",
  "TAPOVANA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "HARSHA INSTITUTE OF PHYSIOTHERAPY",
  "PADMASHREE INSTITUTE OF CLINICAL RESEARCH",
  "ST. XAVIERS DEGREE EVENING COLLEGE",
  "Acharya Shri Gunadhara Nandi Maharajar Arts and Commerce College Navagraha Teerth Kshetra Varur",
  "Sonia Gandhi College of education ",
  "C429 AFZAL MASHKABEE TAHER ANSARI GOVERNMENT FIRST GRADE COLLEGE, ALAND DISTRICT. KALABURAGI",
  "UNITED DEGREE COLLEGE",
  "B562 TRIRATNA ARTS AND COMMERCE FIRST GRADE DEGREE COLLEGE MUDBI, BASAVAKALYAN",
  "C605 ARYAN ARTS AND COMMERCE DEGREE COLLEGE KALABURAGI",
  "VETERINARY COLLEGE GADAG",
  "JNANAMANTAPA COLLEGE OF EDUCATION",
  "SHARABHESWARA COLLEGE OF EDUCATION (B.ED)",
  "B. M .SANKANUR ARTS AND COMMERCE DEGREE COLLEGE FOR WOMEN",
  "AKKAMAHADEVI WOMENS BA DEGREE COLLEGE ALAND ",
  "MUKTAYAKKA WOMENS DEGREE COLLEGE DEVADURGA",
  "SHRIDEVI COLLEGE OF PHYSIOTHERAPY",
  "N M A M Institute of Technology, NITTE",
  "Sadvidya Arts and Commerce Degree College",
  "MAM COLLEGE OF PHARMACY",
  "KLE Societys College of Bachelor of Computer Application Khanapur",
  "TRISHA VIDYA COLLEGE OF COMMERCE AND MANAGEMENT",
  "TRISHA VIDYA EVENING COLLEGE",
  "TRISHA EVENING COLLEGE",
  "PRESTIGE MEDICAL HEALTH SCIENCES",
  "S.S.S.Samitis Degree College Of Commerce Shedbal",
  "ST PAULS COLLEGE",
  "ROSY ROYAL HOMEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "APOORVA INSTITUTE OF MANAGEMENT STUDIES",
  "CHRISTIAN INSTITUTE OF OPTOMETRY",
  "MATOSHREE NEELAMMA FIRST GRADE COLLEGE, KAKAMARI MATH",
  "C650 SRI SAIBABA COMMERCE AND SCIENCE DEGREE COLLEGE, KALABURAGI",
  "ABBS SCHOOL OF LAW",
  "Krupanidhi Degree College, No.12, Chikkabellandur, Carmelara Post, Varthoor Hobli, Bangalore-560035",
  "Lavanya College of Education, Ramannda Ashrama, Doddaballapura-561203.",
  "Mount Carmel College,58, Palace Rd, Bangalore-52 (Autonomous)",
  "MP Birla Institute of Management, No.43, Racecourse Road, Bangalore-9",
  "MQI Degree College,  #8, Bore Bank Road, Benson Town, Bangalore -46",
  "M.S. Ramaiah College of Education, MSRIT Post, MSR Nagar, Bangalore -54.",
  "LOHITS ACADEMY OF COMMERCE",
  "Lourds College of Education, No.54, Bank avenue, Ring Road, Babusab Palya, Bangalore -43",
  "Lowry Adventist College, No 1603, Dooravani Nagar, Bangalore-16",
  "Manasa B.Ed College, Malur",
  "Manasa Institute of Science & Management Studies, White Garden, Malur-563 130",
  "MILLATH WOMENS DEGREE COLLEGE",
  "Mont Fort  College, Old Madrass Road, Bl-38",
  "M.V.J College of Education, Marathahalli, Near H.A.L Colony, Bangalore-37",
  "NAGARJUNA COLLEGE OF MANAGEMENT STUDIES",
  "Nalanda College of Education, P.B. No.10, D.S. Road, Devanahalli-562 110.",
  "Government Ramnarayan Chellaram College of Commerce & Management, Racecourse Road, Bangalore-560001",
  "New Baldwin International Degree College, No.25, RM Nagar Main Road, Doddabanaswadi, Bangalore -43",
  "New Horizon College, Kasturinagar, NGEF Layout, Bangalore-43",
  "New Horizon College, No.41, Kadubisanahalli, Marathalli Ring Road, Bangalore-87",
  "Vijaya College,  11th Main, 4th block, Jayanagar, Bangalore-11.(Previous name: B.H.S First Grade College)",
  "Vijaya College, RV Road, Bangalore-4",
  "Vijaya Evening College, RV Road, Bangalore-4",
  "M.S. Ramaiah College of Arts Science and Commerce, Bangalore-54",
  "KIET B.Ed. College, No.60/1, 7th Cross, Bismillah Nagar, Bannergatta Road, Bangalore-29.",
  "NITTE SCHOOL OF FASHION TECHNOLOGY AND INTERIOR DESIGN",
  "Noble Evening College,  #12A/19, 9th Cross, Opp. to Rajashekhar Hospital,  JPNagar, 1st Phase, Bangalore-78  (2011-12)",
  "Visveswarapura College of Science, K.R. Road, Bengaluru - 560004",
  "Yadava Degree College, No. 12/2, Madhavanagar, Bangalore-1",
  "Visveswarapura College of Arts and Commerce, K.R Road, Bangalore-4",
  "M.E.S College of Arts, Commerce & Science, Malleshwaram, Bangalore-3",
  "YMCA College of Physical Education,Nrupathunga Road, Bangalore 01.",
  "PRIDE DEGREE COLLEGE",
  "Rani Sarala Devi Degree College",
  "RBANMS, First Grade College. #12, Annaswamy mudliar road, Banglaore-42",
  "Ravi College of Education, 2nd Cross, Gowripet, Kolar-563 101.",
  "Rock Valley College of Science & Management, Sri Sai Sadana, Near Kamala Nehru Hospital, Bangarpet Road, Kolar-563 101.",
  "Rock Valley Teachers College, Near Sai Sadhana, KNS Hospital, Bangarpet Road, KOLAR-563 101",
  "Royal Degree College, Anjani Extension, Chintamani-563 125, Chikkaballapur Dist, (10-11)",
  "Sai Vijaya First Grade College, Kollur Road Srinivasapur",
  "Sri Venkateshwara College of Science & Management Studies, K.R. Puram, Bangalore -36,",
  "Sri Vijayendra B.Ed. College, Yernagana Halli Road, Oorgaumpet, KGF-563 117.",
  "SRUSHTI College, #92, Karthik Nagar, Marathahalli Outer Ring Road, Bangalore -560 037, (10-11)",
  "St. Aloysius Degree College, St. Aloysius PU Campus, Cox Town, Bangalore -05",
  "Suguna B.Ed. College, Behind Deephti Mahal, Tamaka, KOLAR-563 101",
  "THE GOLDEN GLEAMS FIRST GRADE COLLEGE CHICKBALLAPUR",
  "University College of Education, Chitravathi Campus, B.B. Road, N.H. 7, Honnenahalli, Manchanabele Post, Chickballapur-562101",
  "Vijaya First Grade College, Shidlagatta deviation Road, Vijayapura-562 135, Devanahalli Taluk, Bangalore Rural Dist.,",
  "VIKASA FIRST GRADE COLLEGE BAGEPALLI",
  "Vishnu B.Ed. College, Hunasanahalli, Banarpet-563 114. Kolar District.",
  "VISHNUPRIYA COLLEGE OF MANAGEMENT STUDIES",
  "Sanjay Gandhi college of Education, Chola Nagar Hebbal, Bangalore-32",
  "S.B. College of Management Studies, No.293, Chikkabommasandra Cross, 1st A Main Road, Yelahanka New Town, Bangalore -64.",
  "Sha-Shib College, #38-39, Prestige Enclave, Bettahalsur Cross, BB Road, Bangalore North-562157, Ph:9342660429",
  "Sitadevi Ratan Chand Nahar Adarsh College, 75, Devathachar Street, 5th main Chamarjpet,Bangalore-18",
  "Sitadevi Ratan Chand Nahar Adarsh Evening College, 75, Devathachar Street, 5th main Chamarjpet,Bangalore-18",
  "Sri Venkateshwar College of Education, No. 1/18, 8th Cross, Maruthinagar, Madivala, Bangalore 68.",
  "Indiragandhi Memorial Education Societys Indiragandhi Womens Degree College",
  "SRI SIDDARAMAIAH LAW COLLEGE",
  "M E S M P Ed College Mudalagi",
  "AKASH INSTITUTE OF PHYSIOTHERAPY",
  "HILLSIDE COLLEGE OF PHYSIOTHERAPY",
  "St. Anns FGC for Women, #4, Millers Road, Bangalore-52",
  "KAIRALEE NIKETHAN DEGREE COLLEGE",
  "Al-Mighty First Grade College, No.23, Opp. Arabic College, Nagavara Main Raod, Bangalore -560 045(2006-07)",
  "Al-Mighty First Grade Evening College, No.23, Opp. Arabic College, Nagavara Main Raod, Bangalore -560 045(2006-07)",
  "Army Institute of Hotel Management & Catering Technology, Nagareshwaranagehalli, Kottannur Post, Bangalore -560 077.",
  "Bangalore City College,No.116, Cellakere Mainr Road, Banasawadi, Outer Ring Road, Kalayananagar Post,  Bangalore-43",
  "Diamond College of Management and Science,No.123, GNR Residency Park, Diamond Nagara, Kithaganaur, Maragondanhalli Main Road, T.C. Palya, Post, K.R. Puram, Bangalore-036 (2011-12)",
  "Government First Grade College, Govt. Tamil School Annex, Cox Town, Frazer Town Post, Bangalore -560 005.",
  "Govt. First Grade College, Varthur, Bangalore -560 087.",
  "Indiranagar Evening college, IInd Main,Indiranagar,Bangalore-38",
  "Indo Asian Academy Degree College,No.10, 4th D Main HRBR Layout, 2nd Block, Kalayanagar, Bangalore -43",
  "INFANT JESUS EVENING COLLEGE",
  "Hasnath College, No.8/3, Byraveshwara Layout, Hennur Bande, Kalayanagar, Bangalore -43",
  "Kairalee Niketan Golden Jubilee Degree College, #181, 9th Cross, Indirangar, I Stage, Bangalore -560 038(10-11)",
  "Koshys Institute of  Management Studies, No.31/1, Hennur-Bagalur Road, Kadusonnappana Halli, Bangalore -562 149",
  "L.B.S  Govt. First Grade College, Dinnoor Road, Jayamahal Extn. Bangalore-32",
  "MIRANDA COLLEGE OF EDUCATION",
  "PG  Center, Kolar",
  "Pragathi College of Education, M.G. Road, Chintamani-563 125.",
  "Sree Omkar College of Commerce & Management, #67, Opp to Country Club, Sathanur, Bagalur Road, Jala Hobli, Bangalore -562149(08-09)",
  "SREE BALAJI DEGREE COLLEGE",
  "RAMAIAH INSTITUTE OF BUSINESS STUDIES",
  "Bapu College of Education, Triveni Rd, Yashavanthapura, Bangalore-22(N)",
  "Bapu Degree College, No.500/A/32, 6th Main Road, Gokula 1st Stage, 4th Phase, Yeshwanthapura, Bangalore-22.",
  "Bapu Evening Degree College, #500/A/32, 531/42, 6th Main, Gokula Ist Stage, 4th Phase, Bangalore -22(08-09)",
  "GURUKUL EDUCATION AND MANAGEMENT STUDIES",
  "Spurthy College of Physiotherapy",
  "Vivekananda College of Education, Dr. Rajkumar Road, Rajajinagar 2nd Stage, Bangalore -55",
  "Capitol Teachers Training College,No.1,8,9, RBI Layout, Kottanur Dinne, JP Nagar7th Phase, Bangalore -78",
  "Vidyavardhaka Research Foundation",
  "VISION DEGREE COLLEGE",
  "SOPHIA DEGREE COLLEGE",
  "COLUMBIA COLLEGE OF NURSING",
  "C330 NRUPATUNGA ARTS AND COMMERCE COLLEGE, SEDAM",
  "BLOSSOM COLLEGE OF NURSING",
  "Manipal School of Life Sciences, Manipal",
  "RV COLLEGE OF ARCHITECTURE, BANGALORE",
  "Sri Jagadguru Chandrashekhara Bharathi Memorial College, Sringeri.",
  "Manipal School of Information Sciences, Manipal",
  "College of Sericulture,Chinthamani",
  "College of Agriculture, V C Farm, Mandya",
  "Padma College of Management & Science, 301/A, 8th Main, 3rd Stage, 4th Block, Basaveshwarangar, Bangalore -79",
  "Sahyadri College of Engineering & Management, MANGALURU",
  "ARIHANT EVENING COLLEGE",
  "Government First Grade College, Yedur, 6th Block, Jayanagar, Bangalore -560 082.",
  "R V Institute of Technology and Management",
  "Government Engineering College Mosalehosahalli",
  "SMH COLLEGE OF PHYSIOTHERAPY",
  "VIDYALAXMI GROUP OF INSTITUTION BRAHMAVARA",
  "SURYA COLLEGE OF PHARMACY",
  "RAJEEV INSTITUTE OF AYUVEDIC MEDICAL SCIENCE AND RESEARCH CENTRE",
  "NITTE COLLEGE OF PHARMACEUTICAL SCIENCES",
  "VIVEKANANDA DEGREE COLLEGE, Rajkumar Rd, Rajajinagar II stage, Bangalore-55",
  "GM INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH",
  "SRI SHARADA COLLEGE OF MANAGEMENT ",
  "ROSY ROYAL COLLEGE OF PHARMACY",
  "Shree Bheemarao Patil College of Physiotherapy Humnabad",
  "Smt Padma G Madegowda college of Nursing",
  "MYSURU ROYAL INSTITUTE OF TECHNOLOGY ",
  "BENEDICTINE ACADEMY",
  "OCEANIK COLLEGE OF HIGHER EDUCATION",
  "TAPOVANA MEDICAL COLLEGE OF NATUROPATHY AND YOGIC SCIENCES BATHI",
  "JALAHALLI JAYASHANTALINGESHWAR ARTS COLLEGE WADAWADAGI",
  "Karunadu College of Paramedical Sciences ",
  "AALIYAH COLLEGE OF NURSING",
  "C695 SAI PRATAP DEGREE COLLEGE KADAGANCHI ALAND KALABURAGI",
  "VANSHIKA COLLEGE OF NURSING",
  "C722 UNITED DEGREE COLLEGE KALABURAGI",
  "C648 SAMRAT ASHOK ARTS  COMMERCE DEGREE COLLEGE KALABURAGI",
  "C553 BASVA INSTUTE OF SOCIAL WORK",
  "Government  First Grade College For Women, Balmatta, Mangalore",
  "Prasanna School of Public Health",
  "DHARMASAGARA FIRST GRADE COLLEGE",
  "Shri BVVS Institute of Nursing Sciences Bagalkot",
  "lakeside college of nursing",
  "HPR COLLEGE OF NURSING ",
  "naseema institute of Physiotherapy and Research",
  "KKECS COLLEGE OF NURSING",
  "DR RAVI PATIL INSTITUTE OF PHYSIOTHEARPY",
  "VIJAYA COLLEGE OF NURSING SCIENCE",
  "MVM College of Pharmacy",
  "NANJAPPA INSTITUTE OF PHYSIOTHERAPY",
  "MVM College of Allied Health Sciences",
  "R K INSTITUTE OF ALLIED HEALTH SCIENCES",
  "MVM College of Physiotherapy",
  "R K COLLEGE OF PHYSIOTHERAPY",
  "LITTLE FLOWER INSTITUTE  OF PARA MEDICAL SCIENCES",
  "DIVINE GRACE COLLEGE OF NURSING",
  "ST THERESAS COLLEGE OF NURSING",
  "SUPRAJA COLLEGE OF NURSING",
  "Jupiter Institute of Physiotherapy",
  "JUBILEE MISSION COLLEGE OF NURSING",
  "VEMANA INSTITUTE OF PHYSIOTHERAPY ",
  "SAINT ANTONYS COLLEGE OF NURSING",
  "Prudence college of PHYSIOTHERAPY",
  "Prudence college of ALLIED HEALTH SCIENCES",
  "VARADARAJA COLLEGE OF PARAMEDICAL SCIENCES",
  "SUBASH COLLEGE OF NURSING",
  "G MADEGOWDA COLLEGE OF PHYSIOTHERAPY",
  "S.E.A. LAW COLLEGE",
  "PADMA LAW COLLEGE",
  "karanadu college of law",
  "Shri Siddalingeshwar Vidya Peeth Trust Dr G V Choukimath Degree College",
  "SGVC VIDYA PRASARAKA TRUSTS MGVC COLLEGE OF EDUCATION MUDDEBIHAL",
  "ANJUMAN ARTS AND COMMERCE DEGREE COLLEGE INDI",
  "GOVT FIRST GRADE COLLEGE SINDAGI  ",
  "B.T.L College of Educational, No.259/B Bommasandra Industrial Area, Hosur Road, Bangalore99.",
  "SHRI SIDDHIVINAYAKA  INSTITUTE OF NURSING HARUGERI",
  "T M A E SOCIETYS COLLEGE OF NURSING",
  "SRI ESHWARAMMAJI COLLEGE OF NURSING",
  "HPR COLLEGE OF NURSING BIDAR",
  "BLDEAs College of Nursing Tikota Vijayapur",
  "HINDUSTAN COLLEGE OF NURSING ",
  "KANACHUR INSTITUTE OF MEDICAL SCEINCES MANGALURU",
  "Sowkhya College of nursing",
  "Shri G E S S College of Nursing Ankali TalChikodi",
  "LIMA INSTITUTE OF NURSING SCIENCES",
  "NRR Hospital College of Nursing",
  "RR INSTITUTE OF MEDICAL SCIENCES",
  "Spurthy college of pharmacy",
  " Vishwabharati First Grade COLLEGE, TURNUR-591123",
  "SRI SHARADA FIRST GRADE COLLEGE",
  "RNS SCHOOL OF ARCHITECURE",
  "JNANAGANGA DEGREE COLLEGE",
  "VEIT Degree College, South End Circle, 3rd Block, Jayangar, Bangalore-560 011 (2011-12)",
  "Ayesha College of Commerce and Management",
  "SC ST RESIDENTIAL GOVERNMENT FIRST GRADE COLLEGE DEVARYASAMUDRA MULBAGAL TQ KOLAR DIST",
  "Smt Danamma Channabasavaiah college of Arts Commerce Science and Management Studies KOLAR ",
  "Markazul Huda College",
  "Indian Institute of Design",
  "Smt Danamma Channabasavaiah college of Arts Commerce Science and Management Studies Bangarpet",
  "vikas First Grade College   Mangaluru",
  "AL IHSAN FIRST GRADE COLLEGE MULOOR POST UCHILA UDUPI DIST ",
  "ACHARYA TULSI NATIONAL EVENING COLLEGE OF COMMERCE",
  "Adarsha College",
  "KLE Societys  BCA College Chikodi",
  "VIDYODAYA COLLEGE OF NURSING",
  "BASAVESHWARA COLLEGE OF COMMERCE ",
  "BETHEL INTERNATIONAL COLLEGE OF COMMERECE ",
  "New Roohi College of Nursing",
  "santana college of allied Health Sciences ",
  "PVS College of Nursing",
  "R K VISION DEGREE COLLEGE",
  "Basavashree  Institute of Management Studies",
  "First Grade College Murnad",
  "Karnatak Lingayat Education Societys Degree College Gokak",
  "SRD SOCIRTY S SHALINI  COMMERCE COLLEGE",
  "Shree Vidya Womens Degree College of Science and Commerce Kalburgi",
  "Sri Basaweshwara College Tumkur",
  "SOUTHERN COLLEGE OF NURSING",
  "ST FRANCIS COLLEGE",
  "MAHILA SEVA SAMAJA FIRST GRADE WOMENS COLLEGE",
  "MS Degree college",
  "SB COLLEGE OF EDUCATION ",
  "Agriculture Diploma College, Hagari",
  "RJS INSTITUTE OF MANAGEMENT STUDIES",
  "GOVERNMENT COLLEGE OF NURSING",
  "H.P.P.S. Arts & commerce First grade college,Harapanahalli.",
  "TMAE College of Education, Harapanahalli",
  "Aditya Bangalore Institute of Pharmacy Education and Research",
  "SRI SIDDHALINGESHWAR COLLEGE OF PHARMACY BIDAR",
  "SRI GURU DEGREE COLLEGE",
  "SHANKAR SINGH MEMORIAL TRUST ARYAN COLLEGE OF PHARMACY",
  "SUNRISE COLLEGE OF NURSING",
  "DIPLOMA AGRI COLLEGE KONNUR",
  "DIPLOMA AGRI COLLEGE DHARWAD",
  "CAUVERY COLLEGE OF PHARMACY",
  "Government Womens College, Hunsur",
  "PES UNIVERSITY (EC Campus)",
  "B L D E A's,  A S PATIL COLLEGE OF COMMERCE,  VIJAYAPUR ",
  "SDM TRUSTS DANIGOND COLLEGE OF NURSING",
  "Pandit Panchaxara Gavaigalavara Music College, Gadag.",
  "SARANGA COLLEGE OF COMMERCE AND COMPUTER APPLICATION",
  "ANGADI SCHOOL OF ARCHITECTURE BELAGAVI",
  "CAUVERY INSTITUTE OF TECHNOLOGY, Mandya",
  "Dayananda  Sagar  College  of Architecture, Bengaluru",
  "EAST WEST SCHOOL OF ARCHITECTURE, Bengaluru",
  "GOPALAN SCHOOL OF ARCHITECTURE AND PLANNING, Bengaluru",
  "IMPACT SCHOOL OF ARCHITECTURE, Bengaluru",
  "JAIN COLLEGE OF ENGINEERING AND TECHNOLOGY, Hubballi",
  "KOPPAL INSTITUTE OF NURSING SCIENCES KOPPAL",
  "R D ASTER COLLEGE OF NURSING HUBLI",
  "BGS GLOBAL INSTITUTE OF NURSING SCIENCES",
  "Kodagu Institute of Medical Sciences, Government College of Nursing, Madiekri ",
  "HILLSIDE INSTITUTE OF ALLIED HEALTH SCIENCES",
  "GURAMMA COLLEGE OF NURSING GADAG",
  "GOVERNMENT ENGINEERING COLLEGE CHALLAKERE",
  "COLLEGE OF AGRICULTURE GANGAVATHI",
  "RIMS GOVERNMENT COLLEGE OF NURSING RAICHUR",
  "SUYOG COLLEGE OF NURSING",
  "ANNAPURNA COLLEGE OF NURSING",
  "ATLAS COLLEGE OF NUSRING",
  "BIPIN CHIKKATTI DEGREE COLLEGE MUNDARGI ROAD GADAG",
  "AYESHA COLLEGE OF PHARMACY KALABURAGI",
  "RMSS INSTITUTE OF NURSING SCIENCES",
  "LOMBARD ACADEMY OF ALLIED HEALTH SCIENCES",
  "SVET S SRI VEERABHADRESHWARA HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL HUMNABAD",
  "GLOBAL INNOVATIVE COLLEGE OF SCIENCE",
  "MILESTONES INSTITUTE OF ALLIED HEALTH SCIENCES",
  "BES BAGALKOT COLLEGE OF NURSINGBAGALKOT",
  "ALLAMAPRABHU COLLEGE OF NURSING LINGASUGUR",
  "SAINT MARYS COLLEGE OF NURSING",
  "SHANTIDHAMA COLLEGE OF PHYSIOTHERAPY",
  "SHANTIDHAMA INSTITUTE OF ALLIED HEALTH SCIENCES",
  "SYED ABUBAKAR SIDDIQUE SYED BAREY SASSB COLLEGE OF NURSING GULBARGA",
  "SYED ABUBAKAR SIDDIQUE SYED BAREY COLLEGE OF  PHYSIOTHERAPY GULBARGA",
  "SHRI GURU COLLEGE OF NURSING BELAGAVI",
  "SHRI GURU INSTITUTE OF ALLIED HEALTH SCIENCE BELAGAVI",
  "SANJAY DANGE COLLEGE OF NURSING SCIENCES HAVERI",
  "PRITHVI COLLEGE OF NURSING KALABURAGI",
  "INDIRA PRIYADARSHINI COLLEGE OF NURSING BIDAR",
  "NISARGA INSTITUTE OF ALLIED HEALTH SCIENCES",
  "NISARGA COLLEGE OF PHYSIOTHERAPY",
  "S S SAINATH COLLEGE OF NURSING BIDAR",
  "GOLDEN DEGREE COLLEGE OF ARTS SCIENCE COMMERCE AND MANAGEMENT STUDIES",
  "KLE SOCIETYS COLLEGE OF BUSINESS ADMINISTRATION AND COMPUTER APPLICATION DHARWAD",
  "JNANA SINCHANA ARTS AND COMMERCE DEGREE COLLEGE KALABURAGI",
  "Sacred Heart Degree College for Women, Jeevanbheemanagar, Bangalore -75.",
  "Chetan College of Commerce, Tajnagar, Hubli - 580 031",
  "EAST WEST SCHOOL OF BUSINESS MANAGEMENT",
  "GOLDEN INSTITUTE OF NURSING SCIENCE BANGALORE",
  "SSETS ARTS COMMERCE AND SCIENCE COLLEGE SHIVABASAV NAGAR BELAGAVI",
  "VIDYANIKETHAN COLLEGE",
  "IA SCHOOL OF MANAGEMENT STUDIES",
  "SAVITRIBAI PHULE ARTS COMMERCE AND SCIENCE",
  "SREE KRISHNA EDUCATION SOCIETY SREE KRISHNA COLLEGE OF PHARMACY TUMKUR  ",
  "SRI VIDYA VIKAAS DEGREE COLLEGE",
  "BRUNDA DEGREE COLLEGE",
  "GOVT FIRST GRADE EVENING COLLEGE  KUMARESHWAR NAGAR DHARWAD",
  "Anjuman-e-Islam's Nehru Arts, Science and Commerce College, Hubli.",
  "Sana Institute of Health Sciences (Nursing)",
  "Sahyadri Arts College, Shivamogga",
  "GOVERNMENT FIRST GRADE COLLEGE HEBBALA BENGALURU",
  "DR KARIAPPA BUSINESS SCHOOL",
  "EAST WEST BUSINESS SCHOOL",
  "JNANODAYA COMMERCE AND MANAGEMENT ACADEME",
  "SHANTIDHAMA INSTITUTE OF NURSING SCIENCES",
  "GITAM : Gandhi Institute of Technology and Management , Off Campus - Bengaluru",
  "ST PHILOMENA COLLEGE, PHILONAGAR, DARBE, PUTTUR, D. K., 574202 KARNATAKA, INDIA",
  "SHRI BASAVESHWAR DEGREE COLLEGE ATHANI",
  "NETHAJI COLLEGE OF ALLIED HEALTH SCIENCE",
  "DON BOSCO COLLEGE ",
  "FATHER MULLER NURSING COLLEGE THUMBAY ",
  "MOTHER MARY COLLEGE OF NURSING KALABURAGI",
  "VISTHAR ACADEMY",
  "ARIHANT INSTITUTE OF COMMERCE AND MANAGEMENT KANAKAPURA MAIN ROAD",
  "BGS GLOBAL INSTITUTE OF ALLIED HEALTH SCIENCE",
  "KANACHUR INSTITUTE OF PARA MEDICAL SCIENCES ",
  "SHRI REVANASIDDESHWAR RURAL DEVELOPMENT AND SOCIAL WELFARE SOCIETYS SHRI S M PATIL COMMERCE DEGREE COLLEGE GHATAPRABHA TQ GOKAK DIST BELAGAVI",
  "PUJYA ANNAPURNA INSTITUTE OF NURSING SCIENCES ATHANI",
  "GOUTHAM COLLEGE OF NURSING",
  "SHANTHA COLLEGE OF PHYSIOTHERAPY",
  "GNYANA SUDHA DEGREE COLLEGE FOR ARTS SCIENCE AND COMMERCE BIDAR",
  "SONIYA EDUCATION TRUSTS SONIYA ARTS SCIENCE AND COMMERCE COLLEGE  DHARWAD",
  "NATIONAL DEGREE COLLEGE HOSAPETE",
  "JSS COLLEGE OF NURSING CHAMARAJANAGAR",
  "SIDDAGANGA MEDICAL COLLEGE AND RESEARCH INSTITUTE TUMKUR",
  "RAJIV GANDHI ARTS AND COMMERCE COLLEGE RON",
  "SRI SAI EVENING COLLEGE",
  " B.S.V.P. First Grade College, Vijayanagar, Bangalore-40",
  "VICTORY FIRST GRADE COLLEGE, MYSURU",
  "GOVERNMENT ENGINEERING COLLEGE BIDAR",
  "PADMASHREE COLLEGE OF HOSPITAL ADMINISTRATION",
  "AGRICULTURE DIPLOMA COLLEGE",
  "VIMOCHANA COLLEGE OF NURSING ",
  "GLOBAL SHAHEEN COLLEGE",
  "CHARKOS COLLEGE OF NURSING, MYSURU",
  "VIDYA SOUDHA ACADEMY OF MANAGEMENT SCIENCES",
  "SMT CHANNAMMA SHIVAMURTAYYA GADDADEVARAMATH ARTS AND COMMERCE COLLEGE, LAXMESHWAR",
  "S N J P S N M S TRUST'S COMPUTER APPLICATION,  SCIENCE AND COMMERCE  DEGREE COLLEGE, NIDASOSI",
  "SHRI BAPUGOUDA DARSHANPUR DEGREE COLLEGE SHAHAPUR",
  "PRAGATHI INSTITUTE OF ALLIED HEALTH SCIENCES",
  "SHRI BASAVESHWAR EDUCATION SOCIETYS SHRI BASAVESHWAR DEGREE COLLEGE AP KALLOLI TQ MUDALAGI",
  "MARGADARSHAN COLLEGE OF NURSING ILKAL",
  "SPARSHA INSTITUTE OF NURSING SCIENCES GADAG ",
  "EXCELLENT COLLEGE OF NURSING ",
  "H T SASNUR INSTITUTE OF NURSING SCIENCES, VIJAYAPUR",
  "SIDDAGANGA COMMERCE AND MANAGEMENT COLLEGE",
  "TAPASYA DEGREE COLLEGE HULIMAVU",
  "SIR M VISVESVARAYA INSTITUTE OF COMMERCE AND ADMINISTRATION",
  "NALANDA COLLEGE OF HIGHER EDUCATION",
  "SMT PARVATHAMMA SHAMANURU SHIVASHANKARAPPA SCHOOL OF HIGH TECH EDUCATION ",
  "GANGA DEGREE COLEEGE",
  "KLE SOCIETYS INSTITUTE OF FASHION TECHNOLOGY AND APPAREL DESIGN FOR WOMEN GOKAK",
  "A V S COLLEGE OF EDUCATION",
  "H K COLLEGE OF NURSING",
  "PRINCE COLLEGE OF NURSING ",
  "SRI LAKSHMI COLLEGE OF PHARMACY",
  "SAMATA AYURVEDIC MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE ALAND",
  "A G M COLLEGE OF NURSING",
  "ASHOKA INSTITUTE OF NURSING SCIENCES HUBBALLI",
  "INDIANA COLLEGE OF NURSING",
  "Mulki Sunder Ram Shetty College, Shirva",
  "INTERNATIONAL INSTITUTE OF BUSINESS MANAGEMENT DEGREE COLLEGE",
  "GOVERNMENT ENGINEERING COLLEGE NARGUND",
  "YADGIRI INSTITUTE OF MEDICAL SCIENCES YADGIRI",
  "TALUK SHIKSHANA PRASARAKA MANDALIS AYURVEDIC MEDICAL COLLEGE SINDAGI",
  "GOPALA GOWDA SHANTHAVERI MEMORIAL INSTITUTE OF HEALTH SCIENCES, MYSURU",
  "SRI RANGA COLLEGE OF NURSING",
  "NEHA NURSING COLLEGE, NIPPANI",
  "ADARSHA INSTITUTE OF ALLIED HEALTH SCIENCES, UDUPI",
  "SHRI RENUKA INSTITUTE OF NURSING",
  "SRI JYOTI COLLEGE OF NURSING, RANEBENNUR",
  "THE PRUTHVI COLLEGE OF NURSING DAVANGERE ",
  "CHRIST COLLEGE OF NURSING",
  "SECAB COLLEGE OF NURSING VIJAYAPUR",
  "DEVAMALLAMMA GURUSHANTHAPPA MAMDY WOMENS DEGREE COLLEGE OF SCIENCE ",
  "GOVERNMENT FIRST GRADE COLLEGE (Autonomous), GUBBI",
  "C.V. Gurukula Evening College",
  "MVM COLLEGE OF SPEECH AND HEARING",
  "CHRIS CANADIAN DEGREE COLLEGE",
  "ANJANADRI DEGREE COLLEGE",
  "SRI DATTA SAI RURAL DEGREE COLLEGE, KGF ROAD, BETHAMANGALA, KGF",
  "VEDANTA DEGREE COLLEGE",
  "SNEHA DEGREE COLLEGE SHAHPUR",
  "NATIONAL SCHOOL OF JOURNALISM AND PUBLIC DISCOURSE",
  "GRV BUSINESS MANAGEMENT ACADEMY",
  " JAIN  TRINITY  BUSINESS  SCHOOL",
  "VEDA AGAMA SAMSKRUTHA MAHA PATASHALA, VEDA DEPARTMENT",
  "SARVODAYA INSTITUTE OF GRADUATE STUDIES",
  "POORNAA PRAJNA  COLLEGE OF NURSING",
  "BASAVESHWARA COLLEGE OF ALLIED HEALTH SCIENCES",
  "KUKKE SRI SUBRAHMANYESHWARA COLLEGE, SUBRAHMANYA",
  "POOJYA DR,SHIVAKUMAR SWAMIJI SCHOOL OF ARCHITECTURE",
  "BANKATLAL RAJARAM BOOB COLLEGE OF COMMERCE, RAICHUR.",
  "SRI JAGADGURU MURUGHARAJENDRA COLLEGE OF ARTS, SCIENCE AND COMMERCE, CHITRADURGA",
  "Vivekananda Institute of Technology, BANGALORE",
  "Ikon Nursing College",
  "SKVP Samitis Arts, Science and Commerce College  Hole-Alur. Tq: Ron.",
  "LAKESIDE COLLEGE OF ALLIED HEALTH SCIENCES ",
  "JAIN COLLEGE OF COMPUTER APPLICATION AND MANAGEMENT",
  "CHITRADURGA MEDICAL COLLEGE AND RESEARCH INSTITUTE",
  "OM COLLEGE OF PHARMACY",
  "WINNERS FIRST GRADE COLLEGE",
  "AGM BBA AND BCA COLLEGE, VARUR ",
  "JSS COLLEGE OF ALLIED HEALTH SCIENCES ",
  "ADITYA COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Basaveshwara College of Commerce, Arts & Science  2nd Block, Rajajinagar, Bangalore-10",
  "BGS College of Education ,Adichunchanagiri Kshetra, Nagamangala Taluk.",
  "B G S FIRST GRADE COLLEGE",
  "St. Mary's College of Education, Chitradurga",
  "Sri Poornaprajna Evening College, Udupi-576101",
  "SRI CHAMUNDESHWARI MEDICAL COLLEGE HOSPITAL AND RESEARCH INSTITUTE ",
  "S R N MEHTA DEGREE COLLEGE ",
  "SDM TRUSTS DANIGOND COLLEGE OF PHARMACY COLLEGE TERDAL",
  "R V S INSTITUTE OF NURSING SCIENCES",
  "ASHRAYA COLLEGE OF NURSING, CHIKKAMAGLURU",
  "AKASH INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "MNH INSTITUTE OF ALLIED HEALTH SCIENCES LOWERBENDOOR BALMATTA MANGALORE",
  "NIRAMAYA COLLEGE OF ALLIED HEALTH SCIENCES",
  "INDIANA INSTITUTE  OF ALLIED HEALTH SCIENCES , MANGALORE ",
  "NIRAMAYA COLLEGE OF NURSING",
  "JANANI YOGA AND NATUROPATHY MEDICAL COLLEGE, HOSPITAL AND RESEARCH CENTRE",
  "SRI VISHWARADHYA INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "INDIANA COLLEGE OF PHYSIOTHERAPY",
  "BLISS COLLEGE OF NURSING",
  "PHOENIX INSTITUTE OF NURSING SHIGGAON",
  "SHIFA INSTITUTE OF ALLIED HEALTH SCIENCES ",
  "MANONIDHI INSTITUTE OF  ALLIED HEALTH SCIENCES ",
  "SAMPOORNA INTERNATIONAL INSTITUTE OF AGRI SCIENCE AND HORTICULTURAL TECHNOLOGY",
  "Govt. First Grade College for Women and P G Center   Jamkhandi-587301",
  "BERD TRUST SIDDHARTH COLLEGE OF PHARMACY, JEERAGAL",
  "C583 RESHMI PG COLLEGE",
  "KLE SOCIETYS COLLEGE OF BCA SANKESHWAR",
  "KLE SOCIETYS COLLEGE OF BCA BAILHONGAL",
  "T M A E SOCIETYS S C S INSTITUTE OF PHARMACEUTICAL SCIENCES  HOSAPETE",
  "Bishop Cotton Women's Christian College, No.19, 3rd Cross, CSI Compound, Mission Road, Bangalore - 560027",
  "IZEE Business School, PLOT 325, PART A, JIGANI INDUSTRIAL AREA, JIGANI POST, BENGALURU-560105",
  "AKASH INSTITUTE OF MANAGEMENT AND SCIENCE",
  "ONE SCHOOL OF BUSINESS",
  "Sapient College of Commerce and Management Mysore",
  "D491 Vivekananda M.S.W. College Raichur",
  "D464 Sri Kanakadasa Degree College Sindhanur",
  "D498 Aftab Degree College Yermaras Camp Raichur",
  "D509 Basava Arts Degree College Deodurg",
  "D518 OXFORD DEGREE COLLEGE",
  "CRR DEGREE COLLEGE",
  "SMT VIJAYAMALA V NILAJAGI DEGREE COLLEGE  HUKKERI  TQ HUKKERI  DIST BELAGAVI",
  "OXFORD BUSINESS COLLEGE",
  "HITA AYURVEDIC MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE ",
  "S A NINGOJI AYURVEDIC MEDICAL COLLEGE, HOSPITAL AND RESEARCH CENTER",
  "Moodlakatte Institute of Technology, Moodlakatte -576217, Kundapur Taluk, Udupi - District.",
  "GPS INSTITUTE OF AGRICULTURAL MANAGEMENT BANGALORE",
  "DAVANGERE UNIVERSITY CONSTITUENT FIRST GRADE COLLEGE TURUVANUR CHITRADURGA TALUK",
  "RAMAIAH INSTITUTE OF BUSINESS STUDIES, BANGALORE UNIVERSITY",
  "SHRI HINGULAMBIKA EDUCATION SOCIETYS COLLEGE OF PHYSIOTHERAPY",
  "SRI SAI INSTITUTE OF MANAGEMENT SCIENCE",
  "BANGALORE INTEGRATED MANAGEMENT ACADEMY",
  "SUDHAMURTI ARTS, SCIENCE AND COMMERCE DEGREE COLLEGE SEDAM TQ SEDAM DIST KALABURAGU",
  "ST ALPHONSA INSTITUTE OF ALLIED HEALTH SCIENCES",
  "BVVS Hanagal Shri Kumareshwar College of Pharmacy, Bagalkot",
  "MANASA COLLEGE OF MANAGEMENT",
  "HIMALAYA BCA COLLEGE ANKOLA UK",
  "SHRI LAXMANRAO ANANTRAO POTNIS MEMORIAL COLLEGE OF BUSINESS ADMINISTRATION  GADAG",
  "CAUVERY AYURVEDIC MEDICAL COLLEGE AND HOSPITAL MYSORE",
  "CAMBRIDGE INSTITUTE OF PROFESSIONAL STUDEIS    ",
  "JYOTHY EVENING COLLEGE",
  "SHREE SIDDARAM SWAMIJI DEGREE COLLEGE OF ARTS, SAVALAGI B, TQ, DIST KALABURAGI",
  "GOURAMMA INSTITUTE OF ALLIED HEALTH SCIENCES BAGALKOT ",
  "HKBK COLLEGE OF ALLIED HEALTH SCIENCES BANGALORE",
  "AKASH INSTITUTE OF ALLIED HEALTH SCIENCES",
  "SHREE BHAVANI INSTITUTE OF ALLIED HEALTH SCIENCE  BANGALORE",
  "POORNAPRAJNA VIDYAPEETA VEDANTA GURUKULAM SANSKRIT COLLEGE ",
  "RATHINAM SCHOOL OF BUSINESS",
  "Dr. PGAS Samitis Pandit Panchaxara Gavaigalavar Arts College, Gadag",
  "SPARSH COLLEGE OF NURSING    ",
  "CAUVERY COLLEGE OF LIFE SCIENCE AND MANAGEMENT, MYSORE    ",
  "R K INTERNATIONAL DEGREE COLLEGE BIDAR",
  "MASOOD COLLEGE OF ALLIED HEALTH SCIENCES    ",
  "MAYUR COLLEGE OF PHARMACY ",
  "St Anthonys College, Mysore Road, Opp. R.V. Eng College, Bangalore",
  "V V SANGHS VISHWANATH REDDY MUDNAL DEGREE AND POST GRADUATE COLLEGE KALABURAGI",
  "SRI BASAVESHWARA COLLEGE OF PHARMACY,TIPTUR    ",
  "CHINMAYA DEGREE COLLEGE    ",
  "BHARATESH INSTITUTE OF TECHNOLOGY    ",
  "SESHADRIPUARM INSTITUTE OF TECHNOLOGY    ",
  "FATHER MULLER COLLEGE OF PHARMACEUTICAL SCIENCES     ",
  "ADITYA COLLEGE OF LAW     ",
  "VYDEHI INSTITUTE OF LAW    ",
  "GOMATESH VIDYAPEETH COLLEGE OF COMPUTER APPLICATION,  BELGAUM",
  "S R PATIL COLLEGE OF NURSING BADAGANDI",
  "ARUNA EDUCATIONAL TRUST, ARUNA COLLEGE OF PHARMACY    ",
  "SHRI CHANNABASAVESHWAR INSTITUTE OF NURSING SCIENCES NAVANAGAR HUBBALLI    ",
  "KANACHUR COLLEGE OF PHARMACY    ",
  "BHARATHI DEGREE COLLEGE    ",
  "SRI MUDEGOWDRA REVANASIDDAPPA SCHOOL OF INFORMATION SCIENCE AND MANAGEMENT",
  "SARJI INSTITUTE OF NURSING SCIENCES    ",
  "INTERNATIONAL INSTITUTE OF FINANCE AND ADMINISTRATION",
  "ANJUMAN E ISLAM DEGREE COLLEGE SAVANUR",
  "Shrinidhi College of Education for Women, No. 93/2, Hommadevanahally, Bannerghatta Main Road, Bangalore -83",
  "DAKSHIN MAHARASHTRA SHIKSHAN MANDALSS BHAURAO KAKATKAR COLLEGE OF ARTS, SCIENCE & COMMERCE COLLEGE,  BELAGAVI",
  "SARVODAYA ARTS AND COMMERCE FIRST GRADE COLLEGE AFAZALPUR DIST KALABURAGI",
  "GOVERNMENT FIRST GRADE EVENING COLLEGE , SHIVAMOGGA ",
  "GOLDEN COLLEGE OF LAW , KGF",
  "C630 MATOSHREE NIMBEMMA DEGREE COLLEGE ",
  "B299 Indian Education Society's M.Ed  College Bidar",
  "C396 Karnataka College Of Education Rangampet",
  "C334 Jawahar College of Education Yadgir",
  "C360 Dr Ambedkar First Grade Degree College Rangampet",
  "C402 Don BosCo College of Education Yadgir",
  "C460 Yashasvi Degree College Shahapur",
  "C497 MAHATMA GANDHI DEGREE COLLEGE",
  "C562 Milarlingeshwar MSW College, Rangampet ",
  "DEESHA DEGREE COLLEGE BIDAR",
  "Stone Woods College of Nursing",
  "ASTER COLLEGE OF PHYSIOTHERAPY",
  "MOTHER THERESA COLLEGE OF EDUCATION DODDABALLPURA",
  "D420 Methodist Degree College Raichur",
  "D425 Shri Sangameshwar Arts & BBM Degree College Lingasugur",
  "D428 Shri Chanamallikarjuna Arts & Comm College Devasugur",
  "D449 Smt R.Subhodramma Vitthoba Shetty Arts college Manvi",
  "D459 Poornapragnya Degree College Hatti",
  "D460 Sri J.J First grade Degree College Jalahalli",
  "D463 SEVA's Parvathamma Basanna Degree College Raichur",
  "D467 Sri Basaweshwara Arts College Sirwar",
  "D471 Dr BR Ambedkar BCA Degree College Lingasugur",
  "D473 SRI RAMKRISHNA DEGREE COLELGE, RAICHUR",
  "D511 SEVA MSW College Raichur",
  "D513 Sri Sanjeev MSW College Lingasur",
  "D514 Shri Kanakadasa B.Ed College Sukalpet Sindanoor",
  "D522 SHRI JNANA GANGA DEGREE COLLEGE",
  "D526 SHRI VISHWANATHESHWAR DEGREE COLLEGE, RAICHUR",
  "D527 LOYALA FIRST GRADE DEGREE COLLEGE, MANVI",
  "D529 SHRI SANJEEV ARTS AND COMMERCE COLLEGE, LINGASUGUR",
  "D534 SRI BASAVESHWARA DEGEE COLLEGE, BALAGANUR, SINDHANOOR",
  "D536 SRI K VIRUPAKSHAPPA DEGREE COLLEGE, TURVIHAL, SINDHANOOR",
  "D537 ANAND DEGREE COLLEGE RAICHUR",
  "D542 NAVAYUGA GABBURU DEGREE COLLEGE GABBURU",
  "D548 SHARADA VIDYANIKETAN COLLEGE OF EDUCATION MANVI",
  "D550 SRI. KHENED MURIGEPPA DEGREE COLLEGE, DEODURGA, RAICHUR",
  "D551 SRIKRISHNADEVARAYA DEGREE COLLEGE, SINDHANOOR",
  "D552 SRI. GURU KRUPA DEGREE COLLEGE, DEODURG, RAICHUR",
  "MAHAGAONKAR ISTITUTE OF SOCIAL SCIENCES",
  "ARUNA FIRST GRADE DEGREE COLLEGE KARAJAGI",
  "SARVAJNA DEGREE COLLEGE KALABURAGI",
  "SUMAN SMANVAYA ARTS AND COMMERCE DEGREE COLL.,GLB",
  "SIDDALINGA SWAMIJI FIRST GRADE COLLEGE",
  "ALVAS COLLEGE OF PHARMACY",
  "B546 M.M.J. DEGREE COLLEGE GHAT BORAL, HUMNABADA, BIDAR",
  "KLS COLLEGE OF ALLIED HEALTH SCIENCE HOSPET",
  "SHRI SOMALING B KANTIGOND DEGREE COLLEGE CHANDAKVATHE TQ SINDAGI DIST VIJAYAPUR",
  "GYANA LAXMI INSTITUTE OF NURSING SCIENCES COLLEGE OF NURSING, KALABURAGI",
  "LABUBAI BANITABAI BHANDARI COLLEGE OF ALLIED SCIENCES, RAICHUR",
  "NEO MOBILITY INSTITUTE OF REHABILITATION SCIENCES COLLEGE OF PHYSIOTHERAPY ",
  "BALLARY RUDRAPPA EDUCATION SOCIETY’S COLLEGE OF PHARMACY, MOTEBENNUR",
  "SHRI SHANAMUKAPPA LAXMAPPA AMMANNAVAR DEGREE COLLEGE BALAGANUR CROSS",
  "SHREE SIDDESHWARA VIDYAVRDHAKA SANGHA, SHREE SHIDDESHWARA DEGREE COLLEGE BILAGI",
  "SRI KRISHNA DEGREE COLLEGE, CHIKKADEVASANDRA",
  "PARAMANANDA COLLEGE OF NURSING",
  "SHANTHINIKETAN COLLEGE OF PHARMACY",
  "KALIDAS COLLEGE OF NURSING,BADAMI",
  "SANJAY COLLEGE OF PHARMACY, BORGAON",
  "EIMR BUSINESS SCHOOL",
  "SRI JNANAYOGI SIDDESHWAR SRI DEGREE COLLEGE AFZALPUR",
  "MAURYA COLLEGE OF NURSING",
  "SAWKAR LAW COLLEGE",
  "OM SAI DEGREE COLLEGE, KADABAGERE",
  "JANASEVA SAMITI'S VINAY HUBBALLI B.C.A. COLLEGE",
  "SHREE MAHALAXMI GROUP EDUCATION SOCIETY’S, SHANTINIKETAN DEGREE COLLEGE, PARISHWAD ROAD, AP KHANAPUR, TQ KHANAPUR, DT BELAGAVI",
  "S.E.A College of Science, Commerce and Arts, Ekta Nagar, Basavanapura, Virgo Nagar Post, Bengaluru",
  "ST PHILOMENAS INSTITUTE OF NURSING SCIENCES",
  "D404 Govt Degree College Sindhanoor",
  "C671 GANGABAI S HIREMATH DEGREE COLLEGE RAICHUR",
  "D597 SUNRISE MCOM COLLEGE",
  "ASHOK BHEEMAPPA NAYAK DEGREE COLLEGE, MUDHOL",
  "YASHODA INSTITUTE OF ALLIED HEALTH SCIENCES VIJAYAPURA",
  "PINNACLE SCHOOL OF COMMERCE AND MANAGEMENT",
  "SMT. SUNANDA COLLEGE OF NURSING, BIDAR",
  "IIFA LANCASTER DEGREE COLLEGE ",
  "SRI VINAYAKA INSTITUTE OF ALLIED HEALTH SCIENCES",
  "INAMDAR COLLEGE OF PHYSIOTHERAPY",
  "BETHEL COLLEGE OF PHYSIOTHERAPY",
  "S S K S College of Education",
  "CAUVERY COLLEGE OF ENGINEERING",
  "VSH NURSING COLLEGE",
  "BTL COLLEGE OF NURSING",
  "NALAPAD COLLEGE OF NURSING",
  "SAI SIDD COLLEGE OF NURSING, MYSURU",
  "R L JALAPPA COLLEGE OF PHARMACY ",
  "GUDAGE COLLEGE OF NURSING, BIDAR",
  "SHRI BASAVESHWAR BCA COLLEGE SATTUR DHARWAD",
  "BAMANE INSTITUTE OF PHARMACY",
  "D563 SRI VENKATESHWAR MCOM COLLEGE",
  "B222 KAVIRATNA KALIDAS FIRST GRADE COLLEGE, BIDAR",
  "SHRI HINGULAMBIKA ARTS AND SCIENCE DEGREE COLLEGE, KALABURAGI",
  "ANJUMAN -A-ISLAMS GOUSIYA ARTS AND COMMERCE COLLEGE, RANEBENNUR, HAVERI",
  "Government First Grade College, Byadagi, Dist- Haveri.",
  "Government First Grade College, Ranebennur.Dist:Haveri",
  "Government First Grade College, Sunakalbidari. Tp- Ranebennur  Dist- Haveri.",
  "BAJSS B.ED COLLEGE ",
  "B223 Shree Guru Ayyappa Swamy Degree College Chitguppa",
  "AJUMAN REFAHE AAM ANJUMAN DEGREE COLLEGE NAVANAGAR BAGALKOT",
  "SES WELFARE'S SWAMI VIVEKANADA BCA COLLEGE CHIKKODI ROAD, EXAMBA",
  "SRI SIDDHARTHA SCHOOL OF ARCHITECTURE, TUMAKURU",
  "Kalpatharu First Grade College K R Pet Mandya",
  "Mandavya  First Grade College,Mandya",
  "Mandavya College of Education ,Acetate Town M C Road Mandya",
  "OYSTER FIRST GRADE COLLEGE",
  "P.E.S. College of Science, Arts & Commerce",
  "PLN  First Grade College Purigali  Malavalli TQ",
  "Vijaya First grade College, Pandavapura",
  "S M Lingappa College of Education, K R Pet  Mandya",
  "Shankargowda College of Education ,Mandya",
  "Sri Shambhulingeshwara College of  Physical Education",
  "Sri Shambhulingeshwara College of Education Jayanthi nagar Pandavapura Tq",
  "B298 Basavateerth Degree College Hallikhed",
  "B231 C E S Degree College Mannaekheli",
  "B564 CHANNABASAVESHWAR GURUKUL SCIENCE DEGREE COLLEGE TALWAD (K)",
  "B325 CMM FIRST GRADE ARTS COMMERCE SCIENCE COLLEGE BASAVAKALYAN",
  "B251 CMM College of Education, Mudubi Basavakalyan",
  "B535 CMM MSW COLLEGE BASAVAKALYAN",
  "B252 Doddappa Appa College of Education Basavakalyan",
  "B320 EXCELLENT DEGREE COLLEGE",
  "B553 GHOUSIYA DEGREE COLLEGE BASAVAKALYAN",
  "D553 SWAMY VIVEKANANDA ARTS DEGREE COLLEGE, SUNKESHWARAHAL,DEODURGA, RAICHUR",
  "D568 GNANA BHARATHI ARTS AND COMMERCE DEGREE COLLEGE RAICHUR",
  "D575 SRI PRAGNYA DEGREE COLLEGE RAICHUR",
  "Sri Maddaneshwara Government First Grade College Kabballi",
  "Sri Mahadeshwara Government First Grade College Kollegal",
  "Vijaya College Of Education Pandavapura Mandya",
  "De Paul First Grade College",
  "BGS INSTITUTE OF NURSING SCIENCES",
  "AET College of Education,Swarnasandra",
  "Bhagavan Buddha College of Education, Malavalli",
  "Bhagavan Buddha Institute Of Management  Malavalli Mandya",
  "RESIDENTIAL GOVERNMENT FIRST GRADE COLLEGE CHAMARAJANAGAR",
  "Government  First Grade College, Kyathanalli, Pandavapura Tq",
  "Government  First Grade College, Malavalli",
  "Government  First Grade College, Melukote Tq",
  "Sri Basaveshwara Arts Degree college Rangampet Tq shorapur",
  "SHREE BASAVAPRABHU ARTS AND COMMERCE DEGREE COLLEGE KODEKAL",
  "C661 PRAGATI DEGREE COLLEGE, SHAHAPUR, YADGIR",
  "B547 AL-AMEEN SYED MAHABOOB ALI DEGREE COLLEGE OF ARTS, HUMNABAD",
  "B561 SRI SAI COMMERCE DEGREE COLLEGE BHALKI ",
  "B250 H K D E College of Education Humnabad",
  "B539 SRI BASAVESHWAR FG COLL OF ARTS COMM, BASAVAKALYAN ",
  "B552 ALAMPRABHU SCIENCE DEGREE COLLEGE, TRIPURANT, BASAVAKALYAN",
  "B256 Noor College of Education Bidar",
  "B304 Global College of Education Bidar",
  "B570 SHARANA NADU ARTS AND COMMERCE DEGREE COLLEGE BASAVAKALYAN",
  "B587 BHAGYODAY MSW COLLEGE BASAVAKALYAN",
  "B586 PANCHAYATRAJ PG COLLEGE BASAVAKALYAN",
  "B567 SHANTI VARDHAK EDUCATION SOCIETYS B.ED COLLEGE BHALKI DIST BIDAR ",
  "VIDYA VIKAS FIRST GRADE ARTS AND SCIENCE COLLEGE GUNNALLI ROAD BIDAR",
  "B590 MATHOSHREE JAISHEELA BULLA MSW PG COLLEGE HUMNABAD",
  "B584 PANCHAYATRAJ ARTS DEGREE COLLEGE MUCHALAMBA",
  "B583 NPS DEGREE COLLEGE, BIDAR",
  "B581 Siddharudha Arts and Commerce Degree College Hallikhed B",
  "B571 PANCHAYAT RAJ DEGREE COLLEGE BASAVAKALYAN",
  " B572 BASAVASAGAR DEGREE COLLEGE, HUMANABAD, BIDAR",
  "B573 BASAVESHWAR ARTS AND COMMERCE DEGREE COLLEGE HUMNABAD",
  "B574 M.S INSTITUTE OF TECHNOLOGY AND MANAGEMENT, BIDAR",
  "B579 SUN SHINE DEGREE COLLEGE BIDAR",
  "Govt First Grade college, Mangalore-583230, Yalaburga(Tq)",
  "A.L. Prasad Degree College, Sriram Nagar",
  "C. Mallikarjunappa Nagappa Arts & Commerce College, Karatagi.",
  "GHN College of Commerce, Pampanagar, Gangavathi.",
  "GOVERNMENT RESIDENTIAL MODEL FIRST GRADE COLLEGE TALABAL",
  "Govt., First Grade College, Alavandi",
  "Govt First Grade College, Hirevankalakunte - 583 237",
  "Govt., First Grade College, Hitnal",
  "Govt First Grade College, Hosbandi Harlapura.",
  "Govt. First Grade College, Irakalagada.",
  "JNANASANGAMA GURUKUL DEGREE COLLEGE GANGAVATHHI",
  "JS DEGREE COLLEGE, GANGAVATHI",
  "KK INSTITUTE OF COMMERCE (B.COM), MILLINEUM CAMPUS, KOPPAL",
  "K L E SOCIETYS B COM DEGREE COLLEGE, GANGAVATI",
  "Rural College of Commerce (B.Com) Dadegal, Koppal",
  "Rural College of Commerce, Dadegal.",
  "Smt. Sharadamma V. Kotabal BBM & BCA College,  Koppal- 583231",
  "SMBS College of Education, Ruderswara nagara Marali-583268.",
  "Phoenix College of Education, Gadag Road, Koppal-583231.",
  "Govt. First Grade College, Yelaburga - 583236",
  "Govt. First Grade College, Kustagi",
  "Govt., First Grade College,  Koppal",
  "Chilukuri Nageshwar Rao Government First College, Sriramnagar",
  "Smt. & Sri Andanappa Hosamani Rural First Grade College of Arts, Kukanur.",
  "St Paul's College , Koppal",
  "APT DEGREE COLLEGE ",
  "VIDYAPRASARAKA MANDALS COLLEGE OF BACHELOR OF COMPUTER APPLICATION, BAGALKOT",
  "Govt. Engineering College, HASSAN",
  "B312 V K INTERNATIONAL ARTS COLLEGE, VIDYA NAGAR",
  "East Point College of Engg., & Tech., BANGALORE",
  "Sneha College of Nursing",
  "Sri Revana Siddeshwara Institute  of Technology,  BANGALORE",
  "Government Homoeopathic Medical College",
  "KTG College of Nursing Sciences",
  "Ramakrishna Ayurvedic Medical College",
  "Sri  Rajiv Gandhi College of Dental Sciences",
  "Sri Venkateshwara College of Engineering, BANGALORE",
  "Karavali Institute of Technology, MANGALORE",
  "Dr. Timmaiah  Institute of Technology,  K G F",
  "R R Institute of Technology, BANGALORE",
  "Dr. Sri Sri Sri Shivakumara Mahaswamy College of Engineering, BANGALORE",
  "Visvesvaraya Technological University, Belgaum",
  "Visvesvaraya Technological University, VTU Regional Office, Gulbarga",
  "UBDT College of Engineering, Davanagere",
  "Brindavan College of Engg., BANGALORE",
  "Impact College of Engg. & Applied Science,  BANGALORE",
  "Basaveshwar Engineering College, BAGALKOT",
  "Sapthagiri College of Engineering, BANGALORE",
  "Wockhardt Institute of Nursing",
  "PES Institute of Technology & Management,  SHIVAMOGA",
  "Maratha Mandal’s College of Pharmacy",
  "TATWADARSHA INSTITUTE OF NURSING SCIENCES HUBBALLI",
  "Maratha Mandal Engineering College, BELGAUM",
  "Bengaluru School of Visual Arts Evening",
  "East West Institute of Technology, BANGALORE",
  "Sajjalashree Institute of Nursing Science",
  "VIDYA VIKAS INSTITUTE OF ENGINEERING & TECHNOLOGY, MYSORE",
  "K B N College of Engineering, GULBARGA",
  "Govt. S K S J Technological Institute,  BANGALORE",
  "V S Ms Institute of Technology,  NIPPANI",
  "T M A E s Ayurvedic Medical College",
  "B540 CHALUKYA DEGREE COLLEGE MARKUNDA BIDAR",
  "B545 Shree Sai Chaitanya Degree College",
  "D539 MOURYA COMMERCE & ARTS DEGREE COLLEGE, ARAB MOHALLA",
  "BGS EVENING COLLEGE",
  "B544 CHANAKYA DEGREE COLLEGE BIDAR",
  "Government First Grade CollegeFor Women, Hassan",
  "Dhanvantari Nursing College",
  "Sri Sathya Sai Institute of Higher Medical Sciences",
  "R R College of Pharmacy",
  "Karnataka Institute of Medical Sciences",
  "Vydehi Inst. of Medical Sciences_Paramedical",
  "Ocean College of Nursing",
  "M R Medical College",
  "Hill Side College of Pharmacy",
  "Hina College of Nursing",
  "Vidyaniketan Degree College Bhalki",
  "Kamala College of Management Studies, No.453, OTC Road, Cotton pet, Bangalore -53",
  "Government First Grade College,Hirisave",
  "Bharathesh Homoeopathic Medical College & Hospital",
  "Government  Home Science College for Women Holenarasipura Taluk ",
  "SUJALA COLLEGE OF COMMERCE, Hassan",
  "C619 GETs First Grade College of Science and Commerce",
  "YDD Government First Grade College, Belur",
  "BVV Sangha’s Ayurvedic Medical College",
  "GNANA KALA CHETANA VIVIDODDESHAGALA SAMSTHE, CHETANA BSW COLLEGE, NARAGUND",
  "B585 SUNRISE DEGREE COLLEGE BIDAR",
  "B588 SAMRAT ASHOK ARTS COMMERCE AND SCIENCE DEGREE COLLEGE BIDAR",
  "SUYOG INSTITUTE OF ALLIED HEALTH SCIENCES",
  "SVM ARTS/SCI/COMM COLLEGE,   ILKAL",
  "SRI SADASHIVA B.ED COLLEGE,  MUDHOL",
  "HALAMMA COLLEGE OF NURSING ILKAL",
  "SRI MALIY APPAIAH SWAMI EDU., COLLEGE,  GADDANKERI",
  "MELAKA MANIPAL MEDICAL COLLEGE, MANIPAL",
  "SRI SIDDHARTHA SCHOOL OF ENGINEERING, TUMAKURU",
  "B538 NALANDA ARTS AND COMMERCE DEGREE COLLEGE SANTPUR",
  "Government Science College,Hassan",
  "GOVT FIRST GRADE COLLEGE FOR WOMEN GANDHADAKOTI HASSAN",
  "B532 PRAGATI ARTS COMMERCE SCIENCE DEGREE COLLEGE BASAVAKALYAN",
  "B529 NISARGA ARTS AND COMMERCE DEGREE COLLEGE",
  "B315 M J P ARTS DEGREE COLLEGE NITTUR, BHALKI",
  "B313 SRI SAINATH COMMERCE COLLEGE, BIDAR",
  "B283 Sri Satyam B.C.A College Bidar",
  "B264 Govt First Grade Degree College,Aurad",
  "B260 Goutham College of Education Bidar",
  "B258 JAI JYOTHI EDUCATION SOCIETYâS COLLEGE OF PHYSICAL EDUCATION",
  "B249 Anjanadevi College of Education Humnabad",
  "B214 Shri Siddharameshwara Degree College Kamalnagar",
  "B248 Hallapa Kote College of Education Bidar",
  "B235 Bodhi Vriksha Degree College Humnabad",
  "SIDDARTHA COLLEGE OF EDUCATION,  JAMKHANDI",
  "Karavali College of Pharmacy",
  "Alva's College of Nursing",
  "GUNASHREE FIRST GRADE COLLEGE SIDDAKATTE BANTWAL",
  "Nightingale College Of Nursing",
  "Florence College of Nursing",
  "Goutham First Grade College, Gundlupete",
  "Govt. First Grade College Shidlaghatta-562105",
  "Sri Hemadri B.Ed. College, Murandhalli Cross, Arekalalli post, Srinivasapura Road, Kolar-563 101.",
  "Sri Jagadguru Balagangadaranatha Swamy College of Physical Education, SBJS Campus, Chikkaballpura-562101.",
  "JMM's Sundrabai A. Patil Education College for Women Tilakwadi, Belguam-590 006",
  "Dr. Sarojini Naidu college of Education, Kattalli Road, Humnabad",
  "Al Kareem College of Nursing",
  "KLE'S BAAVPRBHU KORE BBA COLLEGE,  CHIKKODI",
  "PARAS WOMENS DEGREE COLLEGE, AFZALPUR",
  "K V G Institute of Allied Health Sciences",
  "M J COLLEGE OF NURSING BIDAR",
  "SUNRISE COLLEGE OF PHYSIOTHERAPY BIDAR",
  "Prajwal College of Nursing",
  "DR SUDHAMURTHY INFO WOMENS DEGREE COLLEGE LINGASAGUR",
  "ST ANTONEY COLLEGE OF COMMERCE, BELTHANGADY",
  "Hampi Virupaksheshwara Swamy College,Vidyaranya ( Post)",
  "SRI CHANNAKESHAVA FIRST GRADE COLLEGE",
  "SHREE PADMAVATHI INSTITUTE OF NURSING SCIENCES",
  "ATHENA INSTITUTE OF NURSING ",
  "SHREE SHIVAM COLLEGE OF NURSING RAICHUR",
  "Sri Vishnu College of Nursing",
  "C342 GOVERNMENT FIRST GRADE COLLEGE, GURMITKAL",
  "Sri Kongadiayappa College, Doddaballapura-561203",
  "Sri Krishna College of Education, Sri Venugopalaswamy Education Complex, Bychapura Raod, Devenahlli-562 110.",
  "Sri Devaraj Urs College of Nursing",
  "Hassan Institute of Medical Sciences",
  "SRI KRISHNA RUKMINI FIRST GRADE COLLEGE CHICKBALLAPUR",
  "Shri Jagadguru Gavisiddeshwara Ayurvedic Medical College",
  "Govt. First Grade College, Magadi-562102",
  "D530 NAVAYOGA DEGREE COLLEGE, DADY COLONY",
  "K V G Institute of Physiotherapy",
  "Sri K. Venkatapathappa college of Education, C.V.V Campus, Chikaballapur-562101",
  "SRS AKKAMAHADEVI WOMENS FIRST GRADE COLLEGE",
  "B578 IMPERIAL INSTITUTE OF ARTS AND COMMERCE DEGREE COLLEGE BASAVAKALYAN",
  "B279 Sri Siddaganga B.C.A Degree College Humnabad",
  "Government First Grade College, Badavanahalli",
  "Fine Arts College",
  "Davana Institute of Advanced Management Studies, Davangere",
  "Dr.C.V.Raman College, Davangere",
  "SHRI M VISHWESHWARAYA COLLEGE OF BBA,  BILAGI",
  "B589 NILA MSW COLLEGE BIDAR",
  "BASAVAKALYAN ARTS SCIENCE AND COMMERCE DEGREE COLLEGE BASAVAKALYAN",
  "R R College of Nursing",
  "SHRI KALIDAS EDUCATION SOCIETY  SHRI KALIDAS ARTS AND COMMERCE",
  "SHANTI INSTITUTE OF MEDICAL SCIENCES",
  "RUDRAGOUDA PATIL GOVT FIRST GRADE COLLEGE,  BILAGI",
  "THE YENEPOYA COLLEGE",
  "BLDEAS J S S COLLEGE OF EDU., BIJAPUR",
  "Shri maruthi College of Nursing",
  "C440 Sri Laxmayya Jajee Degree College",
  "Mangala College of Nursing",
  "SHREE MAHALAXMI WOMENS ARTS AND COMMERCE DEGREE COLLEGE JEWARGI",
  "Smt. Pillo Homi Irani College for Women Gulbarga",
  "Indoglobe College of Nursing",
  "Victory Collge of Nursing",
  "DIAMOND DEGREE COLLEGE VIJAYAPUR  ",
  "C443 Aryan College of MSW Gulbarga",
  "Canara College of Nursing",
  "BVV SANGHAS COLLEGE OF PHYSIOTHERAPY BAGALKOT",
  "Indira Gandhi Institute of Child Health",
  "Kamala Krishna Royale Nursing College Cottonpet",
  "Acharya College of Imaging Technology, Bangalore",
  "Command Hospital",
  "Florence College of Physiotherapy Hennur",
  "Bapuji Ayurvedic Medical College Shimoga",
  "Ambika College of Nursing",
  "Mobility India",
  "Goutham College of Physiotherapy",
  "Padmashree School of Public Health",
  "Gouthami College of Nursing",
  "Vidyarathna College of Nursing",
  "B277 Smt. Laxmibai Kamthane College of Education",
  "Muniyal Ayurvedic Medical College",
  "C485 SLVVS Chandana College of MSW Gulbarga",
  "C489 Sri Sai Prasad MSW College Gulbarga",
  "G D DAVID FOUNDATIONS TRINITY COLLEGE OF COMMERCE",
  "B275 Rajeev Gandhi College of Education Bidar",
  "M R Ambedkar Dental College & Hospital Institute",
  "Grameen Ayurvedic Medical College terdal",
  "Santosh Institute of Nursing  Research ",
  "SAHYADRI FIRST GRADE COLLEGE",
  "C701 BALAJI DEGREE COLLEGE YADAGIRI",
  "KALA NIKETAN COLLEGE OF NURSING",
  "SWAMI VIVEKANANDA COLLEGE OF COMMERCE AND MANAGEMENT",
  "VISHWANATH M KATTI FIRST GRADE ARTS AND COMMERCE COLLEGE BELLAD BAGEWADI",
  "SHRIDEVIU INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "S.Nijalingappa Sugar Institute, College of B.Sc (Sugar Science and Technology), Belagavi",
  "A M E’s Dental College & Hospital",
  "MIT first Grade College, Industrial Subrub, Fort Mohalla, Mysore-570008",
  "INDIAN INSTITUTE OF FASHION TECHNOLOGY WOMENS COLLEGE",
  "KANAKASHREE FIRST GRADE COLLEGE",
  "Miranda College of Nursing",
  "AVK (Adarsha Vidyakendra) College of Nursing",
  "Vogue Institute of Art and Design",
  "Raichur Institute of Medical Sciences",
  "Bangalore Animation College",
  "Sri Sadguru Sainath Degree College, No.165, Koodlu village, Madivala Post, Bangalore -68 (SCT First Grade College)",
  "SDM Trust  Ayurvedic Medical College",
  "C706 SHREE SAI DEGREE COLLEGE  SHAHAPUR",
  "C680 Government First Grade College, Mahagaon Cross",
  "KUMUD BEN DURBAR COLLEGE OF BCA,  BIJAPUR",
  "JSS COLLEGE OF NURSING SCIENCES ",
  "C652 SHREE GURUPADLINGA SWAMY ARTS AND COMMERCE DEGREE COLLEGE, MAHAGAON CROSS",
  "ST.PHILOMENAS FIRST GRADE COLLEGE",
  "SRI NETAJI SUBHASH CHANDRA BOSE DEGREE COLLEGE -583115",
  "Vivekananda College of Pharmacy",
  "K.P.E.S. G.M. Patil Law College, Dharwad.",
  "EAST POINT COLLEGE OF PHYSIOTHERAPY ",
  "East West College of Pharmacy",
  "The Bangalore Social Social College of Nursing",
  "CHRISTIAN COLLEGE OF PHYSIOTHERAPY",
  "MASOOD COLLEGE OF PHYSIOTHERAPY",
  "KTG College of Physiotherapy",
  "B254 Rural B.Ed. College Aurad (B)",
  "M V Shetty Inst. MLT",
  "J J M Medical College",
  "Josco College of Nursing",
  "DR. B.R. AMBEDKAR M.S.W. COLLEGE, KALABURAGI",
  "Basaveshwara Medical College & Hospital",
  "GLOBAL EDUCATION NETWORK SOCIETY GLOBAL BUSINESS SCHOOL, HUBBALLI ",
  "Government First Grade College, Akki-Alur. Tq: Hangal",
  "Manasa College of Nursing",
  "Sindagi Shanthaveereshwara Ayurvedic Medical College",
  "DR N B INSTITUTE OF PHARMACY EDUCATION AND RESEARCH",
  "DEVALAMAHARSHI TRINITY FIRST GRADE COLLEGE",
  "Pragathi First Grade College",
  "SATYAM COLLEGE OF TECHNICAL EDUCATION BALLARI",
  "Rathna College of Nursing",
  "Wadiyar Centre For Architecture ",
  "Maharaja Samskrita College, Mysore",
  "SRI UMA MAHESHWARI WOMENS DEGREE COLLEGE LINGASUGUR",
  "LAVANYA DEGREE COLLEGE",
  "K L E SOCIETY'S COMMERCE COLLEGE, KHANAPUR",
  "SIGMA COLLEGE OF ALLIED HEALTH SCIENCES ",
  "shri balabhim arts degree college devar nimbaeagi  ",
  "Shri J G Co-Operative Hospital Society's College of Nursing",
  "B242 Doddappa Appa B C A Degree College Basavakalyan",
  "DHANWANTARI ACADEMY FOR MANAGEMENT STUDIES",
  "ANJUMAN FIRST GRADE COLLEGE JOKATTE MANGALORE",
  "Shri Shambulinga Pratistana Shri Ramananda Teerth Arts College Sindagi",
  "VSMS ARTS COMMERCE AND SCIENCE DEGREE COLLEGE NIPANI",
  "SHARADA AYURVEDA MEDICAL COLLEGE AND HOSPITAL",
  "K N N College of Nursing",
  "SRI GHANAMATHESHWAR COLLEGE OF EDU,  TALIKOTI",
  "VIJAYA INSTITUTE OF PHYSIOTHERAPY",
  "SBG FIRST GRADE COLLEGE",
  "HKDE’s Trust Dental College",
  "M.E.S.M.S.P.S. First Grade College, Chikkamagaluru.",
  "AIMS FIRST GRADE COLLEGE KADABA, PUTTUR",
  "SRI GURUDEVA FIRST GRADE COLLEGE, BELTHANGADI",
  "POORNIMA AYURVEDIC MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE RAICHUR",
  "Y S S RASHMI INSTITUTE OF NURSING ",
  "SHRI SIDDHIVINAYAKA RURAL COLLEGE OF EDUCATION, HARUGERI",
  "KSR COLLEGE OF EDUCATION, BELGAUM",
  "SHRI KALIDAS COLLEGE OF EDUCATION BADAMI",
  "Y S S COLLEGE OF PHARMACY ",
  "ROYAL COLLEGE OF MANAGEMENT STUDIES",
  "Dr.B.R. Ambedkar Law College, Bangalore.",
  "Siddheshwar Law College, Bijapur.",
  "The Oxford College of Law, Bangalore",
  "Sagar Gangotri Law College, Sagar",
  "Shri Balaji College of Law, Bangalore",
  "Dr. B R Ambedkar Medical College",
  "Kempegowda College of Law, Chikaballapur.",
  "Sarswati Law College, Chitraduraga",
  "SHRI KALIDAS BSW COLLEGE,  BADAMI",
  "J H PATEL EDUCATION COLLEGE,  SINDAGI",
  "JNANABHARATI VIDYA MANDIR ARTS AND COMMERCE COLLEGE MUDDEBIHAL",
  "SHRI KALIDAS ARTS COLLEGE, KERUR",
  "SHRI KAGENELE MAHASAMSTANA KANAKA GURUPETH, SHRI KALIDAS ARTS AND COMMERCE COLLEGE, GUDUR, HUNAGUND",
  "SKDV TS SRI VISHWAKARMA FIRST GRADE COLLEGE,  HUVIN HIPARAGI",
  "SIDHIVINAYAK DEGREE COLLEGE BASAVAKALYAN",
  "ATHENA INSTITUTE OF HEALTH SCIENCES",
  "College of Fisheries, Mangalore",
  "Government College, Alur",
  "Government First Grade College ,Arakalagud",
  "ADWIKA INSTITUTE OF NURSING",
  "Government First Grade College,Channarayapatna",
  "NEW ALLIANCE FIRST GRADE COLLEGE",
  "Rajeev College Of Education,Sampangi Road K R Puram",
  "JESs Sri. Kumareshwar Education College, Hangal.",
  "TMAEs College of Education, Ijari Lakamapur, PB Road, Haveri",
  "M.K. Panduranga Setty Memorial RV Institute of Legal Studies",
  "S. P. MANDAL'S ARTS AND COMMERCE COLLEGE, RAIBAG",
  "P.A. COLLEGE OF PHARMACY ",
  "ANJUMAN ARTS AND COMMERCE COLLEGE SINDAGI  586128",
  "B R AMBEDKAR SCHOOL OF LAW",
  "SHRI GALAVA EDUCATION SANSTHE SHRI GALAVA MAHARSHI ARTS AND COMMERCE COLLEGE",
  "S R KANTHI COLLEGE OF EDUCATION,  ILKAL",
  "Jain AGM Ayurvedic Medical college and Hospital , Varur",
  "Shri Atal Bihari Vajpayee Medical College & Research Institute",
  "Navkis College of Engineering, HASSAN",
  "THE RK COLLEGE OF PHARMACY    ",
  "AKASH GLOBAL INSTITUTE OF ALLIED HEALTH SCIENCES    ",
  "B N KHOT DEGREE COLLEGE ANAGAWADI    ",
  "VISHWA CHETHANA DEGREE COLLEGE",
  "SHARADA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL MUNDARGA YADGIR",
  "Rani Chennamma College of Pharmacy",
  "G.J. Surya Nursing College",
  "Goodwill Christain Womens College, 10, Frazer Town, Bangalore-51",
  "St. John's College of Nursing",
  "SHRINIDHI COLLEGE OF NURSING BANGALORE",
  "Shri S.B.S. Ayurvedic Medical College and Hospital Mundargi",
  "Srinivasa Institute of Nursing Sciences",
  "Universal College of Nursing",
  "C598 BALAJI MSW COLLEGE",
  "Dr. B R Ambedkar Institute of Paramedical Science",
  "Ambigara Chowdaiah College of Nurisng",
  "RES SHRI O & R G SHEELAVANT ARTS&COMM COLLEGE,  RABKAVI",
  "Hindustan Business School,  Chennappanahalli, No.24, K.R. Puram, Bangalore-16",
  "KARNATAKA COLLEGE OF EDUCATION",
  "Smt. Saraswati Gurupadappa Nagamarapalli College of Nursing",
  "DR RAVI PATIL INSTITUTE OF ALLIED HEALTH SCIENCES",
  "NARAYANA HRUDAYALAYA INSTITUTE OF PHYSIOTHERAPY",
  "S C S College of Pharmacy, Davangere",
  "SAMARTHA DEGREE COLLEGE OF COMMERCE, SHIRUR PARK, HUBLI",
  "Maratha Mandal’s Nathajirao G Halgekar Institute",
  "SRI VASAVI DEGREE COLLEGE ",
  "SS Institute of Nursing Sciences",
  "GOPALAN COLLEGE OF COMMERCE",
  "SDGECT VIDYADAYINI COLLEGE OF EDUCATION",
  "VIDYA VARDHAK DEGREE COLLEGE SAIDAPUR",
  "KLE'S SHRI SMS'S BCA COLLEGE ATHANI",
  "GOMATESH VIDYAPEETH COMMERCE BELAGAVI",
  "KLE'S G I BAGEWADI BBA COLLEGE,  NIPPANI",
  "SECAB INST., OF BBA/BCA,  COLLEGE, BIJAPUR",
  "BLDE Association's New Arts College, Tikota",
  "S P M S EDUCATION COLLEGE, HARUGERI",
  "L.K.KHOT ARTS COLLEGE, HEBBAL",
  "JES'S S K A LOKAPUR ARTS/ SCIE / COMM COLLEGE,  ATHANI",
  "M E S'S BACHELOR OF PHYSICAL EDUCATION, MUDALGI",
  "ANJUMAN ARTS/SCI/COMM COLLEGE,  BIJAPUR",
  "GOVT FIRST GRADE COLLEGE, ,  INDI",
  "SHRI HIRABAI BHARAMA ANNAPPA CHOUGULE ARTS/SCI  COLLEGE,  RAIBAG",
  "C L E SOCIETYS COLLEGE OF EDUCATION, CHIKKODI",
  "SMYK  GOVERNMENT FIRST  GRADE COLLEGE, TELASANG",
  "JSS'S BHARATESH COLLEGE OF BUSINESS ADMINISTRATION,  BELGAUM",
  "GOVT. FIRST GRADE COLLEGE, AINAPUR",
  "MGVC ARTS/SCI/COMM COLLEGE MUDDEBIHAL",
  "SHRI SIDDARAMAPPA BASAPPA MAMDAPUR  ARTS/SCI/COMM/COLLEGE,  BADAMI",
  "CTES'S ARTS & COMMERCE COLLEGE, CHIKKODI",
  "SDVS'S S S ARTS COLLEGE & TP SCIENCE INSTITUTE ,  SANKESHWAR",
  "KLE SOCIETYS BBA COLLEGE,  KHANAPUR",
  "S.M.K. ARTS/COMM COLLEGE,  INDI",
  "KLS INST. OF MANAGEMENT EDUCATION & RESEARCH, BELAGAVI (PG)",
  "Faculty of Pharmaceutical Sciences",
  "GOKAK EDUCATION SOCIETYS COLLEGE OF EDUCATION, GOKAK",
  "SHRI K M MAMANI GOVT. FIRST GRADE,  SAVADATTI",
  "MES'S ISLAMIA ARTS/COMM COLLEGE,   BELGAUM",
  "LET'S SRI LAXMANRAO JARKIHOLI COLLEGE OF BBA,  GOKAK",
  "ASS'SMT H A NANDI ARTS COLLEGE, ALMEL",
  "JAGADAMBA ARTS/SCI COLLEGE,   HITTINA HALLI-LT",
  "KUMUD BEN DURBAR COLLEGE OF BUSINESS ADMINISTRATION.  BIJAPUR",
  "KLE SOCIETYS COLLEGE OF EDUCATION, NIPPANI",
  "SVES'S B.PED COLLEGE, HARUGERI",
  "SAGAR B.ED COLLEGE, BELGAUM",
  "JSS ARTS/SCIE/COMM COLLEGE,  GOKAK",
  "DMSM'S COLLEGE OF BCA,  BELGAUM",
  "GOVT FIRST GRADE COLLEGE,  MUDDEBIHAL",
  "Mahadeva College Of Commerce   Hoskote",
  "VSG ARTS AND COMM COLLEGE,  BIJAPUR",
  "RAMAKRISHNA VIVEKANANDA BCA COLLEGE,  TIDAGUNDI",
  "V S M COLLEGE OF BBA & BCA, NIPPANI",
  "SHRI MURUGRAJIENDRA ARTS COLLEGE, KOLIGUDD",
  "GOVT FIRST GRADE BA,B.COM&BBA COLLEGE, RAIBAG",
  "ACHARY DESHBHSHANE COLLEGE OF EDUCATION, BEDIHAL",
  "ANGADI COLLEGE OF COMMERCE & SIENCE, BELGAUM",
  "ANJUMAN-E-ISLAM EDU., COLLEGE, BIJAPUR",
  "GLOBAL BUSINESS SCHOOL, BELAGAVI (PG)",
  "GOVT.COLLEGE OF TEACHERS EDUCATION, BELGAUM",
  "S M HILLI DEGREE COLLEGE,  BOLEGAON",
  "Shri Shanteshwar Vidyavardhak Sangha Shri. Gulabachand Ravaji Gandhi Arts, Shri Yashavantaray Annaray Patil Commerce and Shri Manikachand Phulachand Doshi Science Degree College, Indi-586209. Dist:Vijayapur",
  "GOVT FIRST GRADE COLLEGE  BIJAPUR ( 5012)",
  "GOVT FIRST GRADE COLLEGE, NESARGI",
  "KLS GOGTE COLLEGE OF COMMERCE,  BELGAUM",
  "KJSS'S SHRI ADAVI SIDDESHWARA ARTS COLLEGE,  ANKALGI",
  "SDVSS'S BBA COLLEGE,  SANKESHWAR",
  "BHARATESH COLLEGE OF COMMERCE,  BELGAUM",
  "ANNAPOORNA INSTITUTE OF MANAGEMENT RESEARCH, SANKESHWAR (PG)",
  "BIRDs BSW COLLEGE, TUKKANATTI",
  "B. SHANKARANAND ARTS COLLEGE, KUDACHI",
  "Maratha Mandal's Arts, Commerce, Science, and Home Science College, Belgaum",
  "KNVV'S ARTS & COMMERCE COLLEGE,  KITTUR",
  "S H E S 'S J P SHIRAGAONKAR DEGREE COLLEGE,   PARAMANANDAWADI",
  "PES BBA COLLEGE,  UGAR-KHURD",
  "BLDEA'S BASAVESHWAR ARTS&COMM COLLEGE,   BASAVANBAGEWADI",
  "GOVT FIRST GRADE COLLEGE, SADALGA",
  "KRCES'S GGD ARTS, BMP COMMERCE SVS SCIENCE COLLEGE,  BAILHONGAL",
  "N.G.S.M. INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "KUMAKALE DEGREE COLLEGE MUDHOL",
  "MANONIDHI COLLEGE OF PHARMACY",
  "Rajiv Gandhi Fine Art College",
  "KUMAR KANADE DEGREE COLLEGE NILAJI ",
  "BAPUJI COLLEGE OF PHYSIOTHERAPY, DAVANGERE",
  "K.S.GOUTAM COLLEGE OF COMMERCE RABKAVI",
  "GOVT.COLLEGE OF TEACHERS EDU., JAMAKHANDI",
  "The Karnatak Hindu Kshatriya Samajada Vidya Vardak and Hitabhiruddi Mandal Sriram Degree College",
  "International Institute of Business Studies, No.70, Sujatha Complex, KHB Main Road, RT Nagar, Bangalore-560 032",
  "Malleshwaram Ladies Association FGC, 14th Cross Raod, Malleshwaram, Bangalore-3",
  "SIDDAGANGA  SHIVAKUMARA SWAMIJI DEGREE COLLEGE ( SSK DEGREE COLLEGE)",
  "Bhagath College of Nursing",
  "K G F College of Dental Sciences",
  "Sir M.Vishveshwaraiah college, H.A.L , Bangalore-17",
  "Shri J G Co-operative Ayurvedic Medical College",
  "ISBC College of Arts, Science and Commerce",
  "GOVT. FIRST GRADE COLLEGE,   ILKAL",
  "SMT G ANURADHA COLLEGE OF NURSING",
  "Prasanna College of  Nursing",
  "Shri Kalidas Ayurvedic Medical College and Hospital Badami ",
  "PMS College of Nursing",
  "Mallige College of Pharmacy",
  "SDM Institute of Ayurveda and Hospital",
  "SRI PARIPOORNA SANATHANA AYURVEDA MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE",
  "ECR Institute of Management Studies, Kota ,Udupi",
  "Mariyappa Evening College,No.3022, 3023, 3024, MKK Road, Gayathrinagar, Bangalore -21",
  "SMT M C VASANTHA COLLEGE OF NURSING BIDAR",
  "KU PG Center Gadag",
  "Government Ayurveda Medical College",
  "AKSHAYA INSTITUTE OF PHARMACY",
  "Vijnaneshwar Government Law College, Martur Village, Chittapur Taluk, Gulbarga District, Karnataka-585229",
  "Mother Teresa  College of Nursing",
  "Sri BGS First Grade College",
  "GOVT. FIRST GRADE COLLEGE,  HUNNUR",
  "GOVT. FIRST GRADE COLLEGE , KALDAGI",
  "KRUPANIDHI COLLEGE OF COMMERCE  AND MANAGAMENT ",
  "Sri Venkateshwara College,#1/18, 8th Cross, Maruthinagar, Bangalore -68",
  "Vidhyaashram First Grade College  #12,Temple Road Jayalakshmipuram, Mysore 570 012",
  "Institute for Social and Economic Change",
  "Sarojini Naidu Womens Degree college of Science and commerce",
  "B559 BASAVESHAVAR POST GRADUATE CENTRE OF M A ENGLISH BASAVAKALYAN DIST BIDAR",
  "Kempegowda Institute of Medical Sciences",
  "S SALINS COLLEGE OF OPTOMETRY",
  "Gangavathi Bhagyamma Rural Degree College, HuvinaHadagali-583219.",
  "GOVERNMENT FIRST GRADE WOMENS COLLEGE YADAHALLI",
  "MES College of Pharmacy",
  "Shanthi SSK First Grade College  Pavagada",
  "Acharya School of Design",
  "C623 ANANYA ARTS and COMMERCE DEGREE COLLEGE., KALABURAGI",
  "MATOSHREE WOMENS DEGREE COLLEGE KALABURAGI",
  "SWAMI VIVEKANAND FIRST GRADE COLLEGE BILAGI",
  "D457 Nandini College of Education Raichur",
  "Sri Krishna Rukmini College of Nursing",
  "Kidwai Memorial Inst. of Oncology",
  "N S V K Sri Venkateshwara Dental College & Hospet",
  "SDS TRC AND RGICD, COLLEGE OF NURSING",
  "TEJASVINI PHYSIOTHERAPY COLLEGE",
  "SPM ADARSH COMMERCE COLLEGE M.VADGAON  BELAGAVI",
  "H D Devegowda Co - Operative College of Nursing",
  "BANGI INSTITUTE OF NURSING SCIENCES VIJAYAPURA",
  "SINDHI INSTITUTE OF MANAGEMENT",
  "Vikram College of Nursing",
  "PES College of Pharmacy",
  "C473 Siddeshwar Arts College ladchincholi",
  "K.K. COLLEGE OF NURSING BIDAR",
  "NIMRA COLLEGE OF NURSING ",
  "Oxford college of Nursing Sciences, Bengaluru",
  "Government First Grade College for Women, Bagalkot",
  "B V V Sanghas Danammadevi Arts, Commerce and Science College for women, Mudhol",
  "C634 NAGAMANIKYA MSW COLLEGE",
  "ARISTOTLE COLLEGE OF NURSING ",
  "HERITAGE CITY INSTITUTE OF ALLIED HEALTH SCIENCES",
  "HERITAGE CITY COLLEGE OF PHYSIOTHERAPY",
  "UDUPI COLLEGE OF ALLIED HEALTH SCIENCES",
  "SRI VENKATESHWARA FIRST GRADE COLLEGE",
  "SHRI MANJUNATHA COLLEGE OF NURSING ",
  "Bangalore  College of Nursing",
  "C419 Sri Mahanteshwar College of Education Afzalpur",
  "C I T FIRST GRADE COLLEGE ",
  "VAASUDHARA COLLEGE OF NURSING",
  "ST CLARET COLLEGE OF NURSING",
  "VAASUDHARA COLLEGE OF PHARMACY",
  "VISVESWARAPURA EVENING COLLEGE OF ARTS AND COMMERCE, K.R Road, Bangalore-4",
  "C466 Jai Hind College of Education Gulbarga",
  "GRAMANTARA VIDYAVARDHAK SANGHAS ARTS AND COMMERCE DEGREE COLLEGE HOOVIN HIPPARAGI",
  "SBG COLLEGE OF NURSING",
  "Hemadri Post Graduate Center",
  "The Oxford College of Hotel Management, J.P. Nagar, Ist Stage, Banaglore-78",
  "ARUNODAYA COLLEGE, BANGALORE",
  "HKBK Degree College (K.S.M.F First Grade College), No.6/1, Contonment Station Road, Bangalore-51",
  "DIPLOMA AGRI COLLEGE NIPANI",
  "Government First Grade College, Bagepalli-561 207, Chikkaballapur Dist.",
  "GFGC RAMPUR",
  "Government First Grade College, Behind BEO Office, Robertsonpet, 3rd Cross, KGF-563 122, Kolar Dist.",
  "AIMS IBS BUSINESS SCHOOL",
  "PARIVARTHANA LAW SCHOOL ",
  "AVVSS SHRI PARAPPA SANGAPPA SAJJAN ARTS COLLEGE ,  BEWOOR",
  "Government First Grade College, Sulibele, Hoskote Taluk, Bangalore Rural Dist",
  "Government First Grade College, Vemagal-563 101, Kolar Dist.",
  "Govt. First Grade College, Bangarpet-563114, Kolar Dist.",
  "Wockhardt / Fortis Inst. of OTT",
  "Kempegowda Institute of Physiotherapy",
  "BGS VIJNATHAM INSTITUTE OF PHYSIOTHERAPY",
  "BGS VIJNATHAM INSTITUTE OF ALLIED HEALTH SCIENCES",
  "PRAYUKTHI INTERNATIONAL COLLEGE",
  "JSS Ayurvedic Medical College",
  "Presidency College of Nursing",
  "DON BOSCO COLLEGE",
  "MUDRA COLLEGE OF NURSING",
  "D508 St.Thomas Degree College Raichur",
  "D433 A M E DEGREE SCIENCE COLLEGE",
  "C.B Degree College, Bhalki",
  "Soundarya Arts and Commerce Evening College",
  "Bharathi College of Pharmacy",
  "Indira College of Nursing",
  "SYMBIOSIS School of Media and Communication, Bengaluru",
  "Shivasharane Hemareddy Mallamma College of Education, LINGASUGUR",
  "GOVERNMENT FIRST GRADE COLLEGE SHANTINAGARA DOMLUR  BANGALORE",
  "BGS MEDICAL COLLEGE AND HOSPITAL, NAGARUR",
  "SALIHATH WOMENS FIRST GRADE COLLEGE",
  "SRI YADATORE COLLEGE OF EDUCATION     ",
  "Gangothri College of Nursing",
  "Kodagu Institute of Medical Sciences",
  "MANJAPPA HARDEKAR MEMORIAL ARTS AND COMMERCE DEGREE COLLEGE ALMATTI",
  "K Pandyarajah Ballal Nursing Institute College of Nursing",
  "T.V.M. College of Pharmacy",
  "Sambhram College of Nursing",
  "Matru College of Nursing",
  "SAI BABA ARTS COMMERCE AND SCIENCE COLLEGE BALLARI",
  "Tadikela Subbaiah College of Nursing",
  "Vijaya jyothi degree college",
  "KLE Universitys Homoeopathic Medical College  and Hospital Belagavi",
  "Arunodaya Evening College, Ring Road, Mariyappanapalya, Jnanabharathi Post, Bangalore-56.",
  "D473 SHRI RAM KRISHNA DEGREE COLLEGE",
  "Dr. N.S.A.M. First Grade College, Nitte, Karkala",
  "Acharya College of MHA",
  "GOVERNMENT R C EVENING COLLEGE",
  "Dharwad Institute of Mental Health and Neurosciences (DIMHANS)",
  "ST XAVIERS DEGREE COLLEGE",
  "SHREE KRISHNA DEGREE COLLEGE  6U",
  "S J J ARTS COLLEGE, KALAKERI",
  "S B Shirkoli Homoeopathic Medical College",
  "S S Institute of Medical Sciences & Research Centre",
  "BALDWIN WOMEN'S METHODIST COLLEGE, #90, Richmond Road, Bangalore-560025",
  "C435 Govt  F G College Farthabad",
  "Government First Grade College, Vijayanagar, Banglor-40",
  "Sri Vardhaman Mahaveer Jain Evening College, 17th C Cross, CMH Road, 2nd Stage, Indiranagar, Bangalore -38",
  "A.M.C College, 18th Km. Bannerghatta Road, Bangalore-83",
  " K S SCHOOL OF ARCHITECTURE",
  "SRI KONGADIYAPPA COLLEGE OF EDUCATION",
  "SRI VANI DEGREE COLLEGE",
  "CHRIST ACADEMY INSTITUTE FOR ADVANCED STUDIES",
  "SHRAVANA INSTITUTE OF SPEECH AND HEARING",
  "GOVERNMENT FIRST GRADE RESIDENTIAL MODEL COLLEGE AP HADALAGERI ",
  "Silicon City College of Management and Commerce, No.1, Harinagara Cross, Amruthenagara Main, Konanakunte, Bangalore -108.",
  "GSSS SCHOOL OF ARCHITECTURE FOR WOMEN",
  "Shri Shivayogeeshwara Ayurvedic Medical College",
  "KANACHUR COLLEGE OF PHYSIOTHERAPY",
  "ANUGRAHA TRAINING COLLEGE",
  "D557 MODEL DEGREE COLLEGE",
  "CINDREBAY SCHOOL OF DESIGN",
  "College of Fine Arts Karnataka Chitrakala Parishath Art Complex Kumarakrupa Rd Bangalore",
  "Sri Dharmaguru B.Ed. College, Bagepalli, Chikkaballapur District.",
  "PROVINCE COLLEGE",
  "SRI CHAYADEVI FIRST GRADE COLLEGE , HUNSUR",
  "Manipal Institute of Regenerative Medicine, Bangalore",
  "PATEL LAW COLLEGE",
  "Smt Ramamani Sundararaja Iyengar First Grade College",
  "Vidyavahini First Grade College",
  "SRI KRISHNA DEGREE EVENING COLLEGE ",
  "SRI ANUPAMA DEGREE COLLEGE",
  "Siddashri First Grade College, Nittur",
  "Sri Siddhartha Dental college, Tumkur",
  "Sridevi First Grade College",
  "Anjuman Arts, Science, Commerce College & P.G. Studies, Dharwad",
  "RajaRajeswari College of Engineering, #14, Ramoholli Cross, Kumbalgodu, Mysore road, Bangalore - 560074",
  "Government First Grade College, Turuvekere",
  "K.L.E. SOCIETY'S SVS BELLUBBI ARTS & COMMERCE COLLEGE,  SAUNDATTI",
  "Kalpataru  First Grade Science College, Tiptur",
  "Indira College of Education",
  "Bengaluru Law College",
  "Hill Side College of Nursing",
  "Smt Danamma channabassappa mahilasamaj FGC, New Extn. Kolar",
  "Sri Balagangadharanatha Swamiji School of Business Management, Byrapalli, Srinivasapura Taluk, Kolar Dist-563 135.(08-09)",
  "Farooqia College of Pharmacy",
  "Faith Institute of Nursing Sciences`",
  "SRI UMAPRAGATHI FIRST GRADE COLLEGE",
  "HKES Homoeopathic Medical College & Hospital",
  "Vatsalya College of Education, Shankaramata road",
  "Sofia College of Nursing",
  "Mahalasa Chitrakala Mandira, Mangalore",
  "Yogish Chitrakala Mandira, Dargapur, Bidar",
  "Siddeswara Kalamandira, Bijapur",
  "Bharatiya Kalakendra, Dharwad",
  "Aadarsha Chitrakala Mahavidyalaya, Indi",
  "Veerabhadreshwara Chitrakala Mahavidyalaya, Humnabad",
  "Bhuvaneshwari Lalitakala Mahavidyalaya, Hoovinahadagali",
  "Karnataka Theological Research Centre, Mangalore",
  "Dairy Science College, Bangalore",
  "C381 Abhayarathna Degree college Gulbarga",
  "Bapuji Institute of Hi-tech Education, Davangere",
  "Govt. College, Hebri",
  "J S S College of Nursing",
  "Vidya Vikas College of Education, Alanahalli.",
  "JSS Arts Scie& Commerce College Rashtrapathi Road ,Nanjangud",
  "Gold Finch College of Nursing",
  "Sri K. Venkatapathappa College of Physical Education, C.V.V Capmus, Chikaballapur-562101",
  "Kittur Rani Channamma College of Horticulture, Arabhavi",
  "Jayadeva Inst. of Cardiology",
  "BGS GLOBAL INSTITUTE OF PHARMACEUTICAL SCEINCES    ",
  "P G COLLEGE OF NURSING",
  "St. Johns Research Institute",
  "Dayananda Sagar College of Dental Sciences",
  "BGS INSTITUTE OF MANAGEMENT",
  "Sri Cauveri Management College, CA No.5, Near KEB Office, Kodihalli, HAL 2nd Stage, Bangalore-08",
  "JNANAKASHI DEGREE COLLEGE, DAVANGERE",
  "Navodaya College of Nursing",
  "JSS Dr. D Verendra Heggade Institute of Management Studies & Research Vidyagiri, Dharwad",
  "GAYATHRI EDUCATIONAL SOCIETY, ANUPAMA COLLEGE OF PHARMACY    ",
  "ANJANADRI INSTITUTE OF PHARMACY     ",
  "Fr. Muller's College of Nursing",
  "Padmashree Institute of Physiotherapy",
  "Shri.Jagadguru Fakkireshwar Government First Grade College, Shirahatti.",
  "KLS Vishwanatharao Deshpande Institute of Technology, HALIYAL  Dt: N.K.",
  "Sri Siddhartha Medical College, Tumkur",
  "Government First Grade College, Hanaga.l Dist- Haveri.",
  "Government First Grade College, Baad. Tq Kumata Dist  Karwar",
  "Shri Hingulambika Ayurvedic Medical College",
  "HKES College of Pharmacy",
  "Government First Grade College, Yellapur.",
  "Karnataka College of Pharmacy",
  "T. John College of Nursing",
  "Shri. K. H. Patil Government First Grade College. Hulakoti Dist- Gadag.",
  "Government First Grade College, Hubli.",
  "Sakhafiya Millat Education Society Abdul kalam College of Information Science & Management (B.B.A) Vivekanand Nagar, Gadag",
  "RNS Nursing College",
  "Ashwini Ayurvedic Medical College",
  "ANANYA COLLEGE OF NURSING    ",
  "VYMAK COLLEGE OF PHYSIOTHERAPY",
  "RVD College of Management and Information Technology",
  "HCG SUCHIRAYU NURSING COLLEGE",
  "Fr. Muller's Medical College of MLT",
  "SJMVS  Arts & Commerce College, Hubli.",
  "ASS College of Commerce, Gadag.",
  "VYMAK COLLEGE OF ALLIED HEALTH SCIENCES",
  "JSS  Institute of Education  Chamarajanagar",
  "Kempegowda College of Nursing",
  "Rajiv Gandhi Education B.Ed. College, Ron. Tq:Dt: Gadag.",
  "SHRI LAXMI THIMMAPPA COLLEGE OF ALLIED HEALTH SCIENCES",
  "New Mangalore College of Nursing",
  "Nanjappa Institute of Nursing Sciences",
  "Lisaa School Of Design",
  "YENEPOYA SCHOOL OF ENGINEERING AND TECHNOLOGY    ",
  "MGC Arts, Commerce & GHD Science College, Siddapur.",
  "HAJARE FOUNDATION PADMAVATI DEGREE COLLEGE HOSUR",
  "Dr. Sarojini B.S.W College,  Near Govt. Model Higher Primary School Siddharudha Nagar Adargunchi Hubli. 580028",
  "INTERNATIONAL SCHOOL OF MANAGEMENT EXCELLENCE ",
  "RRK Samithi's College of Pharmacy",
  "S R PATIL MEDICAL COLLEGE, HOSPITAL AND RESEARCH CENTRE, BADAGANDI    ",
  "TRIVENI INSTITUTE OF COMMERCE AND MANAGEMENT",
  "Srinivasa College of Pharmacy",
  "PET,SMB ARTS RRB COMM, SKR SCI & BCA COLLEGE GULEDAGUD",
  "VIDHYA SHEKHAR INSTITUTION OF MANAGEMENT STUDIES",
  "VAARI VENKATESHWARA COLLEGE OF NURSING",
  "St. Ann’s Institute of Health Sciences",
  "Navodaya dental College",
  "Mythri College of Nursing",
  "DHANWANTARI COLLEGE OF PHARMACY",
  "C436 Govt  F G College Kembhavi",
  "INAMDAR UNANI MEDICAL COLLEGE AND HOSPITAL ",
  "Jagadguru Annadaneshwar Vidya Samiti Education College Mundargi Dt: Gadag.",
  "MESs M.M.Arts & Science College, Sirsi.",
  "SANA College of Education, Shantiniketan Bairidevarkoppa, P.B. Road, Hubli-580025.",
  "Smt.Manoramabai Bhimarao Huilgol College of Education Croni Road, Gadag.",
  "RAVI COLLEGE",
  "C.B. BHANDARI JAIN COLLEGE, 84 K.R Road, Shankar Puram, Bangalore-4",
  "KANAKA SCHOOL OF LAW",
  "Royal College of  Education, Bellary",
  "Imperial Institute of Advanced Management",
  "V.V. Sangh's Sha Bhawarlal Babulal Nahar College of Education, Hospet - 583 201.",
  "SAVITHA MAHARSHI DEGREE COLLEGE",
  "Sri.Bhadrakali First Grade Arts College, Gokarna.",
  "SHRI SIDDALING SHIKSHAN MATTU GRAMEEN ABHIVARUDDI SANSTHE KONNUR ARTS COLLEGE",
  "KMS First Grade College, Khanahosahalli - 583 218",
  "Rajeev Gandhi Rural College of Education, Koppal-583 231.",
  "Allam Karibasappa Institute of Management, Bellary.",
  "S.A.V.T Govt. First Grade college, Kudligi - 583 135,",
  "Sri. Kollinageswara Rao Gangaiah Govt First Grade College, Gangavathi.",
  "City College of Allied Health Sciences",
  "Christian Institute of Allied Health Sciences",
  "Government First Grade College, Navalagund",
  "Government  First grade college for Women, Chamarajanagara",
  "VMK SRV ARTS/SCI & VSB COMM COLLEGE, HUNAGUND",
  "BLDE ASSOCIATION'S COMMERCE, BHS ARTS AND TGP SCIENCE COLLEGE, JAMAKHANDI",
  "Acharya Institute of Physiotherapy Soladevanahalli Bangalore  ",
  "GOVT FIRST GRADE COLLEGE, BADAMI",
  "B R SANGAPPAGOL COLLEGE OF NURSING MAJALATTI",
  "KLE SOCIETY'S  G I BAGEWADI  ARTS, SCIENCE AND  COMMERCE  COLLEGE,  NIPANI",
  "GOVT. FIRST GRADE COLLEGE,  HUNAGUND",
  "HSSSs Arts,Science & Commerce College,Gadag.",
  "KLE  SOCIETY 's  SHRI CHANNAGIRISHWAR PRASADIK ARTS, SCIENCE AND   D.D. SHIROL COMMERCE COLLEGE, MAHALINGPUR(PG)",
  "shri siddalingeshwara  rural arts college sirur",
  "Suvrna Educational Trust, Suvarna Arts & Commerce Collge, Janemane Bldg. Elkki Shettar Colony Bus stap, PB Road Dharwad",
  "SHRI GURU RAGHAVENDRA FIRST GRADE COLLEGE",
  "C368 Jawahar Degree College Yadgir",
  "KLEs Education College, Ankola, Dt: Karwar.",
  "Government First Grade College ,Chamarajanagar",
  "Government First Grade College Gundlupet",
  "BETHEL WOMENS DEGREE COLLEGE GANGAVATHI",
  "SSWM KONIKA BBA/BCA COLLEGE VIJAYAPUR",
  "D492 Rural and Urban Development Society's MSW College Raichur",
  "PPG College of Education, Gadag.",
  "Oxford College of Commerce, Keshwapaur, Solaplur Road, Hubli.",
  "Global Education Network Society Global Business School S. N. 326 B Opp. Mahima Hotel Hubli.",
  "SHRI CHANNABASAVESHWAR DEGREE COLLEGE",
  "Sonia College of Education ,Tejashwi Nagar Dharwad.",
  "Anjuman Institute of Information Science & Management,Dharwad.",
  "MVJ COLLEGE OF SCIENCE AND COMMERCE    ",
  "Sri Mangilal Sundar Bai Gotawat Jain College of Arts & Commerce, # 17- C Croos, Chinmaya Mission Rd, Indiranagar IInd stage, Banglaore-38.",
  "Shantiniketan Commerce College Ghantikeri Near KEB Hubli ",
  "Bengaluru Amirta College of Arts and Science",
  "JAHAN INSTITUTE OF NURSING SCIENCES",
  "Shree Siddeshwar Govt., I Grade College,Nargund.",
  "Anglo-Urdu School Committes Taj Shameer Arts & Commerce College, Gadag.",
  "ST MARYS COLLEGE OF PHARMACY",
  "Kamala Baliga College of Education, Kumta.",
  "AET College",
  "Sri Shankara College Of Nursing",
  "BGS SCHOOL OF ARCHITECTURE AND PLANNING",
  "Anjuman Centary B.Ed College, Ghantikeri,Hubli.",
  "Government First Grade College, Koratagere",
  "ST JEROME FIRST GRADE COLLEGE",
  "College of Horticulture, Bidar",
  "College of Horticulture, Sirsi",
  "CHAITHANAYA INSTITUTE OF MANAGEMENT AND SCIENCE",
  "Government First Grade College  Hanur",
  "College of Horticulture, Kolar",
  "C431 Govt  F G College Kalgi",
  "BHUVANA JYOTHI INSTITUTE OF LEGAL STUDIES ",
  "GOVERNMENT FIRST GRADE COLLEGE LINGASUGUR",
  "AKASH INSTITUTE OF PHARMACY ",
  "KK DEGREE COLLEGE",
  "Hasnath College for Women, 43, Dickenson Road, Bangalore-42",
  "EXCELLENT DEGREE COLLEGE SINDHANUR ",
  "SMT GOURAMMA CHARANTIMATH INSTITUTE OF NURSING SCIENCES HUNGUND",
  "College of Horticulture, Mysore",
  "Biligiri First Grade College, Yelandur",
  "DR RAVI PATIL COLLEGE OF PHARMACY BELAGAVI",
  "C609 KALESHWARA ARTS AND COMMERCE DEGREE COLLEGE, KALAGI",
  "MUNIYAPPA MUDAPPA DEGREE COLLEGE",
  "C608 Mohanraj Arts Degree College Kalaburagi",
  "BVV SANGH INST. OF MANAGEMENT STUDIES, BAGALKOTE (PG)",
  "C639 MOHANRAJ MSW COLLEGE, KALABURAGI",
  "B225 DR B R AMBEDKAR FIRST GRADE COLLEGE",
  "AKKAMAHADEVI WOMENS P G CENTRE ",
  "College of Horticulture, Koppal",
  "College of Horticulture, Bagalkot",
  "N E T Pharmacy College",
  "GOVERNMENT FIRST GRADE COLLEGE GULEDAGUDDA",
  "GOVERNMENT FIRST GRADE COLLEGE  RABKAVI BANAHATTI",
  "Sharavathi Dental College",
  "SDM COLLEGE OF PHARMACEUTICAL SCIENCES",
  "Sri Basaveshwara  College of Nursing",
  "Sree Krishana College of Nursing",
  "MVJ Medical College",
  "Government First Grade College, Sulepeth",
  "MIT FIRST GRADE COLLEGE THANDAVAPURA",
  "MES Institute of Management, 17th Main, 2nd Block, Rajajinagar, Bangalore -10",
  "C338 Govt F G Degree College,Afzalpur",
  "SMT SHAKUNTHALA GADIGI INSTITUTE OF NURSING SCIENCES KITTUR",
  "Sri Siddhartha Institute of Technology, Tumkur.",
  "Raja Rajeswari Dental College & Hospital",
  "C579 SARADAGI DEGREE COLLEGE OF ARTS & COMMERCE, KALABURAGI",
  "Government Ayurvedic Medical College, Mysore",
  "Farooquia Dental College",
  "BES College of Arts and Commerce(Evening), 4th block, Jayanagar, Bangalore-11",
  "ANUGRAHA WOMEN'S COLLEGE, GOLTHAMAJALU, KALLADKA",
  "M B Residential College, Sirigere",
  "KLEU'S SHRI.B.M.K. AYURVEDA MAHAVIDYALAYA,BELGAUM",
  "KLE College of Pharmacy, Bangalore",
  "KENSRI DEGREE COLLEGE",
  "AMATYBHARATI COLLEGE OF NURSING",
  "Sri Shrimata Samskrita College, Yellapur",
  "Sri. Bhagawan Mahaveer Jain Educational and Cultural Trust, Jain Commerce College, Suvidha Plaza, CTS No: 2927/A-6, Bailappanavar Nagar, Behind KIMS, Vidya Nagar, Hubballi -29 ",
  "Mariyappa First Grade College, No.3022, 3023, 3024, MKK Road, Gayathrinagar, Bangalore -21",
  "Vanguard Business School, No.128, 38th Cross, East End Road, 9th Block, Jayangar, Bangalore-69",
  "MILLENNIUM CITY COMMERCE EVENING COLLEGE",
  "KATEEL ASHOK PAI MEMORIAL INSTITUTE OF NURSING ",
  "The National College, Autonomous Basavanagudi, Bangalore",
  "C425 Sha Bra Mahanta Shivachary Swamyji Degree college",
  "Bangalore College of Engineering & Tech, BANGALORE",
  "KERUDI COLLEGE OF NURSING, BAGALKOTE",
  "Acharya College of Nursing",
  "C390 Shriman Dharmsingh College of Education Gulbarga",
  "C647 RESHMI (EVENING) BA  and B.Com DEGREE COLLEGE KALABURAGI",
  "GLORIA INSTITUTES OF MANAGMENT AND SCIENCE ",
  "INDIAN COLLEGE OF EDUCATION",
  "ROSY ROYAL COLLEGE OF ALLIED HEALTH SCIENCES",
  "ROSY ROYAL INTERNATIONAL COLLEGE OF PHYSIOTHERAPY",
  "Laxmi Memorial College of Nursing",
  "Sri Chaitanya Degree College, Ballari",
  "C321 B.Shyamsundar College of Phy Education Gulbarga",
  "MSMS LAW COLLEGE MARALI ",
  "C404 GuruShantappa Jawali College of Education Pattan",
  "BGS COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Government First Grade College, Chikkaballapura",
  "Rajiv Gandhi College of Education, Behind SOS Children's Village, National Park Road, Bangalore -78",
  "MLA Academy of Higher Learning, 14th Cross, Malleswaram, Bangalore 03.",
  "INDO ASIAN WOMENs DEGREE COLLEGE",
  "St. John’s College of Physiotherapy",
  "GVPP,    Govt., First Grade College, Ramnagar, Hagaribommanahalli.",
  "Kaizen Eduplus Society Institute of Excellence In Management Science Hubballi",
  "Tungabhadra B.P.Ed, College, Kottur - 583134",
  "B319 ST PAULS SCIENCE AND COMMERCE DEGREE COLLEGE BIDAR",
  "J.S.S. Institute of Education, Huvinahadagali.",
  "PARIVARTHANA BUSINESS SCHOOL, Plot No B, Near KRS Signal, Metagally, MYSORE",
  "GOVERNMENT FIRST GRADE COLLEGE,HOSKOTE 562114",
  "Tejasvini Nursing Institute",
  "TARINI INSTITUTE OF NURSING GAJENDRAGADA",
  "Government First Grade College , Kuderu",
  "ANURADHA HOMEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "MAHATHMA GANDHI MEMORIAL EVENING COLLEGE, KUNJIBETTU, UDUPI",
  "Siddhartha First Grade College, Chamarajanagar",
  "C391 N V College of Education Gulbarga",
  "Veterinary College, Bidar",
  "Dairy Science College, Mahagoan",
  "Veterinary College, Shimoga",
  "DBAES SAGAR COLLEGE OF PHARMACY    ",
  "RESHMI EVENING P G COLLEGE, KALABURAGI",
  "Veterinary College,Bangalore",
  "GIBS BUSINESS SCHOOL",
  "Sahaj Marg Spirituality Foundation",
  "SABARIGIRI DEGREE COLLEGE FOR WOMENS",
  "KODLIPET FIRST GRADE COLLEGE",
  "Christ Academy Institute of Law",
  "VISHWADEEP ARTS COMMERCE AND SCIENCE DEGREE COLLEGE BIDAR  ",
  "C395 Aryan College of Education Gulbarga",
  "INDUS VALLEY DEGREE COLLEGE",
  "Government First Grade College,  Ankola. Dist  Karwar.",
  "Govt. First Grade College, Devanahalli-562110",
  "KLE SOCIETY'S JAGADGURU TONTADARYA COLLEGE, GADAG.",
  "SHREE MARIDEVARU SWAMIJI DEGREE COLLEGE OF COMMERCE, SAVALAGI B, TQ, DIST KALABURAGI",
  "M.P.E.Society's Shree Dharmasthala Manjunatheshwar College of Arts, Science and Commerce, Honnavar (Uttara Kannada)",
  "AKSHARA FIRST GRADE COLLEGE",
  "BASAVACHETAN POST GRADUATION CENTER RANEBENNUR ",
  "GOVERNMENT ENGINEERING COLLEGE ARSIKERE",
  "Sevabharathi First Grade College For Women, Chamarajanagar",
  "UNIVERSITY CONSTITUENT COLLEGE BENGALURU NORTH UNIVERSITY LINGARAJAPURAM  ",
  "C V GURUKULA COLLEGE",
  "Nisarga Institute of Education, Kollegal",
  "SRI SURYA FIRST GRADE COLLEGE",
  "B300 Allamprabhu B.Ed College talawad(k)",
  "AAFFINITY  COLLEGE OF NURSING",
  "UNITED INTERNATIONAL BUSINESS SCHOOL",
  "D564 WISDOM POST GRADUATION COLLEGE OF COMMERCE SINDHANUR, RAICHUR",
  "D519 WISDOM COLLEGE OF COMMERCE AND MANAGEMENT",
  "KRIPA INSTITUTE OF NURSING SCIENCES",
  "US Business School",
  "JYOTIBA PHULE LAW COLLEGE",
  "C638 BASAVARAJAPPA APPA DEGREE COLLEGE OF COMMERCE",
  "GOVERNMENT FIRST GRADE COLLEGE & P.G. CENTER  CHINTHAMANI -563125",
  "SREE MALATHESHA BED COLLEGE MALEBENNURU",
  "Y ANNAPPA DEGREE COLLEGE",
  "Nisarga College of Management,Kollegal",
  "MVM COLLEGE OF ARTS SCIENCE AND MANAGEMENT",
  "Ballari Business College, Ganesh Nagar, Opp to KSRTC Depot, Siruguppa Road, Ballari",
  "CHAITANYA COLLEGE OF NURSING ",
  "S.A. Ningoji College of Education, Yelaburga - 583 236",
  "Government First Grade College for Women, Doddaballapura",
  "Diana College of Nursing",
  "BHARATH COLLEGE OF NURSING",
  "Aditya College of Nursing",
  "GOVERNMENT FIRST  GRADE COLLEGE FOR WOMEN, PUTTUR",
  "JSS College  of Arts & Commerce,Gundlupet",
  "Oriental College of Nursing",
  "Army Institute of Fashion & Design, ITI Bhavan, Dooravani Nagar, Old Madras Road, Bangalore -16",
  "Government First Grade College, Doddaballapura",
  "Dr. Ambedkar Institute of Management Studies, HAL, IInd Stage, Indiranagar, Bangalore-38",
  "Indira B.Ed. College, Boodkiote-563 114,  Bangarpet Taluk, Kolar District.",
  "Koppal Institute of Medical Sciences Koppal",
  "INIMS College, No.123, I Main Road, Kengeri Sattelite Town, Bangalore -60",
  "SSM TRUST SHETTY HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL KALABURAGI",
  "DR LYDIA COLACO COLLEGE OF NURSING, MANGALORE",
  "GOVERNMENT FIRST GRADE COLLEGE KERUR",
  "PALOMA DEGREE COLLEGE",
  "ANANYA INSTITUTE OF COMMERCE AND MANAGEMENT, TUMKUR",
  "B323 CITY DEGREE COLLEGE, BIDAR",
  "DIPLOMA AGRI COLLEGE HANUMANAMATTI",
  "B.D.P.H.W. Association Mathoshri Ambavva Khed Arts,Commerce & Science  College Bijapur.",
  "MOTHER THERESA DEGREE COLLEGE",
  "IFIM Law College",
  "Govt. Arts College, K.R. Circle, Bangalore-1",
  "NAVAJEEVAN COLLEGE OF NURSING SCIENCES",
  " SRI SRI INSTITUTE OF NURSING SCIENCES AND RESEARCH CENTRE",
  "BBMP FIRST GRADE COLLEGE FOR WOMEN, BHYRAVESHWARANAGAR",
  "K.R.C.E.S's S.B.Harkuni BBA College, Bailhongal",
  "GRV Business Management Academy, #19, 2nd Cross, Ganganagar, Bellary Road, Bangalore -560 032.(10-11)",
  "C686 SHRI DATTA DEGREE COLLEGE",
  "Al Qamar College of Nursing",
  "St. John’s College of Pharmacy",
  "Basaveshwara College of Pharmacy",
  "B537 BASAVA COMMERCE DEGREE COLLEGE, BIDAR",
  "SUBBAIAH INSTITUTE OF MEDICAL SCIENCES, SHIMOGA",
  "C344 National Evening Degree College Gulbarga",
  "Dhanwantri College of Education, MAJ Foundation, No.39/1, Vinayakanagara, Hesrghatta Main Road, Chikkabanavara,Bangalore-560 091.",
  "Shri S.G Keshannavar S.A.V.V.P Samiti's Shree Annadaneshwara Arts, Science and Commerce College Naregal",
  "EKAM HEALTH CARE INSTITUTION BENGALURU URBAN B SC NURSING ",
  "BGS ART AND DESIGN ACADEMY",
  "Forestry College, Ponnampet",
  "College of Horticulture, Hiriyur",
  "College of Horticulture, Mudigere",
  "C582 SIDDESHWAR P.G. COLLEGE, LAD CHINCHOLI, GULBARGA",
  "HEMADRI FIRST GRADE COLLEGE, TUMKUR",
  "GOVERNMENT FIRST GRADE COLLEGE, TUMKUR",
  "Sri Devaraj Urs Medical College",
  "AACHARYA FIRST GRADE COLLEGE ",
  "A J Institute of Engineering and Technology Mangaluru",
  "SRI VIDYANIKETAN DEGREE COLLEGE",
  "JSS College for Women, Chamarajanagar",
  "medha college",
  "Shri Jagajyoti Basaveswar Vidyavardhak Sangh R Late Smt Matoshree Kashibaigoudati Basanagouda Patil arts and Commerce Degree College, Pulakeshi Nagar Basavan Bagewade Road Vijjayapur",
  "V.M Lingaiah College of Education, Somanahalli ,Maduur Tq",
  "RAYANNA COLLEGE OF NURSING",
  "Indian Institute of Information Technology, Dharwad",
  "Kanachur College of Nursing Sciences",
  "SRI LAXMI VENKATESHWARA DEGREE COLLEGE, KUDLIGI",
  "INDO-AMERICAN DEGREE COLLEGE, BELLARY",
  "CMR Law School, Bangalore",
  "PNC COGNITIO DEGREE COLLEGE",
  "C493 Shri Siddeshwar B.Ed College Ladchincholi",
  "RNS FIRST GRADE COLLEGE",
  "Sidu Vidya Sansthe Nalanda B.C.A College Vidyaranya, Gadag Road, Bhandiwad , Hubli",
  "Global Educare Foundation Global College of Computer Application Vidya Nagar Hubli.",
  "SDM COLLEGE OF DENTAL SCIENCES  HOSPITAL DHARWAD",
  "Government First Grade College , Sirsi, Dist:  Uttara Kannada",
  "KU PG Center Karawar",
  "SHRI JAGADGURU MADIVALESHWAR KALMATH TRUST SHRI CHANNABASAV ARTS AND COMMERCE COLLEGE, GARAG",
  "ST JOSEPHS COMMERCE COLLEGE, COLLEGE ROAD",
  "KSS ARTS AND COMMERCE COLLEGE, RON",
  "SDM College of Medical Sciences and Hospital",
  "SAISHANKAR B ED COLLEGE, PONNAMPETE",
  "Shri Mahadevappa Basalingappa Halli Government First Grade College,  Annigeri  Dharwad -582201",
  "STG FIRST GRADE COLLEGE",
  "GNYAN SAI EDUCATION TRUST SHARADA ARTS DEGREE COLLEGE",
  "Sri  Adichunchanagiri College of Arts & Commerce, Nagamangala",
  "B244 Gurunanak College of Education Bidar",
  "M.M K College of Visual Arts Gulbarga",
  "C345 Karnataka Degree College of Arts Bankur",
  "SHRI SHRUNGERI COLLEGE OF EDUCATION",
  "MARCHAD INSTITUTE OF HOTEL MANAGEMENT, BELLARY",
  "MSMS DEGREE COLLEGE, MARALI",
  "Shree Jagajyoti Basaveshwar Viday Vardhak Sangh s College of Education  BEd Pulakeshi Nagar, Ap   Vijayapur",
  "JSS SAMSKRIT COLLEGE, JAGADGURU DR. SHIVARATRI RAJENDRA CIRCLE, RAMANUJA ROAD, MYSORE",
  "Janatha First Grade College, Chamarajapet, Bangalore-18",
  "Hasnath Academy of Management Studies, No.43, Dickenson Road, Bangalore-42",
  "IMJ COLLEGE OF ALLIED HEALTH SCIENCES",
  "SHIKSHA INSTITUTE FOR LEGAL STUDIES DHARWAD",
  "P C SIDDANGOUDAR LAW COLLEGE NOOLVI",
  "UNIVERSITY CONSTITUENT COLLEGE TERAKANAMBI, CHAMARAJANAGA",
  "Sri. Vijayachandrashekara College of Education, Kushtagi.",
  "Smt. Gali Rukminamma Chengareddy Memorial Govt. Commerce and Management College,  Ballari - 583102",
  "Government First Grade College Yelandur",
  "MANJUSHREE INSTITUTE OF HEALTH SCIENCES",
  "BASAVA DEGREE COLLEGE ",
  "SAHYADRI INSTITUTE OF COMMERCE ",
  "SCHOOL OF LAW",
  "KOLLUR MALLAPPA DEGREE COLLEGE YADGIRI",
  "SRI VINAYAKA COLLEGE OF NURSING",
  "JSS College for  Women, Kollegal",
  "St. George College of Management, Banasawavdi, OMBR Layout, Bangalore-33",
  "SRI SIDDI VINAYAKA COLLEGE OF NURSING",
  "Smt. Padmavatibai Raghavendrarao Deshpande Pikalihal Government First Grade College, Mudgal",
  "SC ST STUDENTS RESIDENTIAL GOVERNMENT FIRST GRADE COLLEGE KAVITALA TQ MANV DIST RAICHURI",
  "D592 BTS DEGREE COLLEGE RAICHUR",
  "D579 SWMIVIVEKANANDA DEGREE COLLEGE DEVADURGA",
  "Seshadripuram College, Seshadripuram , Bangalore-20",
  "Seshadripuram Evening College, Seshadripuram, Bangalore-20",
  "D574 Horizon Degree College",
  "D570 SIDDARTH DEGREE COLELGE, MANVI, RAICHUR",
  "SRI ABHINAVA RAMANANDA SARASWATHI DEGREE COLLEGE",
  "CAUVERY INSTITUTION OF HEALTH SCIENCES",
  "SRI RAMALINGESHWARA COLLEGE OF EDUCATION",
  "SHRI KUMARESHWAR COMMERECE DEGREE COLLEGE GAJENDRAGAD-582114",
  "VISHWADARSHANA COLLEGE OF EDUCATION YELLAPUR",
  "SRI MARUTHI DEGREE COLLEGE",
  "Shanthi Arts, Science& Commerce  College,Malavalli",
  "SRI MARUTHI INSTITUTE OF SCIENCE  COMMERCE AND MANAGEMENT DEGREE COLLEGE ",
  "LNR DEGREE COLLEGE",
  "SCS FIRST GRADE COLLEGE",
  "HCBM First Grade College, Jagalur",
  "St Josephs College for Women Next to St Arnolds School Mahadevapura Main Road Rammanahalli",
  "BANGALORE INSTITUTE OF MANAGEMENT SCIENCE AND RESEARCH",
  "GOVERNMENT COLLEGE OF NURSING, HOLENARASIPURA",
  "A.V Kamalamma College for Women, Davanagere",
  "SNEHA BHARATHI COLLEGE OF NURSING TUMKURU",
  "BAPUJI COLLEGE OF ALLIED HEALTH SCIENCES, SHIVAMOGGA",
  "KLE SOCIETY'S GUDLEPPA HALLIKERI ARTS, SCIENCE & COMMERCE COLLEGE, HAVERI ",
  "KLE INSTITUTE OF PHYSIOTHERAPY",
  "KLE College of Pharmacy, Hubli",
  "KLE COLLEGE OF PHARMACY, BELGAUM",
  "KLE VISHWANATH KATTI INSTITUTE OF DENTAL SCIENCES",
  "JAWAHARLAL NEHRU MEDICAL COLLEGE",
  "CHIKKABALLAPUR INSTITUTE OF NURSING SCIENCES",
  "C477 Vishwahindu College Gulbarga",
  "KLE Institute of Nursing Sciences",
  "SHRI ATAL BIHARI VAJPAYEE INSTITUTE OF ALLIED HEALTH SCIENCES",
  "THE NISARGA COLLEGE OF NURSING",
  "APS DEGREE COLLEGE SOMANAHALLI",
  "VIDYARTHI COLLEGE OF ALLIED HEALTH SCIENCES, CHIKKAMAGALURU",
  "VIDYARTHI COLLEGE OF NURSING, CHIKKAMAGALURU",
  "GOVERNMENT COLLEGE OF NURSING BRIMS, BIDAR",
  "RBANMS Evening,College. #24, Gangadhar Chetty Rd, Banglaore-42",
  "J.E. Co-Op Societys Sri Kumareshwar Arts & Commerce College, Hanagal",
  "Dr. Ambedekar College of Education, Pipe line road, Jayachamarajanagar, West of Chord Road, Mahalakshimpuram(post), Bangalore-86 (PA  UP 2012-13 FOR B.ED)",
  "Government First Grade College, Bangaru Tirupathi, Kolar Dist.",
  "Nisarga Degree College",
  "GDJ DEGREE COLLEGE",
  "SWAMYVIVEKANANDA FIRST GRADE COLLEGE",
  "H.K.E. Society's, Sree  Veerendrapatil Degree College of Science, Arts & Commerce, #231,15th main, 9th Cross, Sadashivanagar,                Bangalore-80",
  "RAJASHEKARAIAH INSTITUTE OF NATUROPATHY AND YOGIC SCIENCES, SOLUR",
  "MANGALORE COLLEGE OF PHYSIOTHERAPY",
  "Government First Grade Arts & Commerce College  Hirekerur.",
  "NITTE USHA INSTITUTE OF NURSING SCIENCES",
  "K. S. HEGDE MEDICAL ACADEMY",
  "A.B.S.M. INSTITUTE OF DENTAL SCIENCES",
  "NITTE INSTITUTE OF PHYSIOTHERAPY",
  "GREEN CITY COLLEGE OF NURSING",
  "CHARKOS INSTITUTE OF ALLIED HEALTH SCIENCES, MYSORE",
  "SANCTA MATHA COLLEGE OF NURSING, VIRAJPET",
  "Government First Grade College,  Bhatkal, Dist: Uttara Kannada",
  "DR  D  G  SHETTY EDUCATIONAL SOCIETYS   R S  SHETTY COLLEGE OF COMMERCE , DHARWAD",
  "KLE SOCIETYS INSTITUTE OF NURSING SCIENCES GOKAK",
  "ST LOURDES COLLEGE OF NORSING ADYAR , MANGALORE",
  "Vivekananda Degree College for Women, No.22, Srikanteswaranagar, Mahalakshmi Layout, Bangalore 96.",
  "SREE SADGURU KABEERANANDA SWAMY INSTITUTE OF NURSING SCIENCES",
  "SVVN DEGREE COLLEGE",
  "Hosmat College of Nursing",
  "Hosmat College of Physiotherapy",
  "RAJASHEKARAIAH INSTITUTE OF AYURVEDA MEDICAL SCIENCES AND HOSPITAL, SOLUR",
  "C550 SAI PRESIDENCY DEGREE COLLEGE",
  "Government First Grade College, Halebeedu",
  "SSVS SHRI SANGAMESHWARA DEGREE ARTS COLLEGE TALIKOTI",
  "Hosmat Education Inst. of OTT",
  "SMT KAMALA BASAVARAJ PATIL OKALY DEGREE COLLEGE OKALY VIDYA MANDIR M B NAGAR KALABURAGI ",
  "Sapthagiri Institute of Medical Sciences and research centre",
  "C584 SHA BRA MAHANTHA SHIVACHARYYA SWAMIJI P G COLLEGE",
  "C.L.E SOCIETYS DEGREE COLLEGE, CHIKODI",
  "ACHUTHA AYURVEDIC MEDICAL COLLEGE",
  "LITTLE FLOWER COLLEGE OF PHYSIOTHERAPY",
  "SOFIA COLLEGE OF ALLIED HEALTH SCIENCES",
  "SACRED HEART INSTITUTE OF NURSING",
  "KALIPALYA CHANNAPPA INSTITUTE OF NURSING ",
  "SANKANUR INSTITUTE OF NURSING SCIENCES ",
  "Bharat Ratna Shri Atal Bihari Vajpayee Law College",
  "N R COLLEGE OF NURSING ",
  "MARUTHI COLLEGE OF NURSING",
  "SRI SOUBHAGAYA LALITHA COLLEGE OF NURSING",
  "Yenepoya Naturopathy & Yogic Science College & Hospital",
  "SHARANESHWARI RESHMI WOMENS DEGREE COLLEGE KALABURAGI",
  "CHIKKAMAGALURU INSTITUTE OF MEDICAL SCIENCES",
  "WESTERN HILLS FIRST GRADE COLLEGE",
  "SUNRISE WOMEN DEGREE COLLEGE MASKI",
  "Jawahar Law College, Yadagiri.",
  "Sri K Puttaswamy First Grade College, Gokulam 3rd stage",
  "JHANHJAVI INSTITUTE OF NURSING SCIENCES",
  "VIDHYA SHEKHAR COLLEGE OF NURSING",
  "Akash Global College of Management and Science, 43-(P-1), Doddajala, Bengaluru International Airport Road, Bengaluru North, Bengaluru - 562157",
  "PRIYADARSHINI COLLEGE OF NURSING",
  "Sambhram Academy of Management Studies, Near Amba Bhavani  Temple, Jyothinagar, Vidhyaranyapura post, Bangalore-97",
  "RAJEEV COLLEGE OF PHARMACY",
  "C718 SRI BALABHEEMASENA MSW COLLEGE KALAGI KALABURAGI",
  "S.J.E.S College Education, Medahalli, Old Madras Road, Bangalore-49",
  "S.M.G VISHNU COLLEGE OF NURSING",
  "NEW R K COLLEGE OF NURSING",
  "Hanagal Taluka Education Society Arts and Commerce College, Akki-Alur - 581 102 Tq- Hanagal",
  "Sri Devaraj Urs Institute of Management, RLJIT Campus, Kodigehalli, Doddaballapura, Bangalore Rural District.",
  "Government First Grade College, Govt. Middle School Annex, Near NES Office, Yelahanka, Bangalore -560 064.",
  "SPOORTHI AYURVEDIC MEDICAL COLLEGE AND DR S V SAVADI AYURVEDIC HOSPITAL GANGAVATHI",
  "GUDLEPPA VEERAPPA HALLIKERI ARTS AND COMMERCE FIRST GRADE COLLEGE HOSARITTI HAVERI",
  "SIDDHASIRI LAW COLLEGE",
  "MANGALORE COLLEGE OF ALLIED HEALTH SCIENCES",
  "SHETTY INSTITUTE OF PHARMACEUTICAL SCIENCES, KALABURGI",
  "MATHOSHREE KAMALABAI SIDDAPPA KARJAGI LAW COLLEGE TALIKOTI",
  "VASAVI FIRST GRADE COLLEGE, KOLLEGAL",
  "Sri Sarvajna college of Education",
  "Gupta College, No.808, 100 ft Ring Road, BSK 3rd Stage, Bangalore-560 085",
  "NEW EBENEZER INSTITUTE OF TECHNOLOGY",
  "Dayananda Sagar Business Academy, Udayapura, BM Kaval, Kanakapura Road, Near Art of Living, Bangalore",
  "M Basavaiah Institute of Management Studies, #12, 2nd Stage, Nagarabhavi Ring Road, Near BDA Complex, Bangalore -560 072.(10-11)",
  "Karnataka College of Pharmacy",
  "Anupama College of Management and Science, Mahalakshmi Puram, Bangalore-86",
  "Alva's College of MLT",
  "Lorven International Institute of Management Studies, No.62/8A, Kodichikkanahalli Main Road, Bommanahalli, Bangalore -68",
  "Government First Grade College, Thyamagondlu, Nelamangala-562 132, Bangalore Rural Dist.",
  "Hill Side Institute of Mgmt., No.9, Raghuvanahalli, Kanakapura Mn. Road, Uttrahalli Hobli, Bangalore -62",
  "SLES COLLEGE OF PHARMACY",
  "DSLD College of Horticulture Engineering and Food Technology",
  "GHOUSIA INSTITUTE OF TECHNOLOGY FOR WOMEN, BANGALORE",
  "Sri Vivekananda College of Arts, Science & Commerce, Nehru Nagar, Puttur-574203",
  "Manjunatha Pai Memorial Govt. First Grade College of Professional & Business Management, Karkala - 574104",
  "Besant Evening College, Mangalore-575003",
  "Sarvodaya College of Education, Virajpet-571218",
  "Bhuvanendra College, Karkala - 574104",
  "Shree Dharmasthala Manjunatheshwara College of Education, Ujire, Belthangady",
  "Sri Sharada Women's College, Sullia-574239",
  "A.J. Institute of Management, Kottara Chowki, Bypass, Ashoknagar, Mangalore",
  "Moti Mahal College, Falnir Road, Mangalore-575001",
  "SWAMY VIVEKANANDA RURAL FIRST GRADE COLLEGE, Chandapura, Anekal Taluk, Bangalore -81",
  "Govt. First Grade College, Vittala, Bantwal - 574243",
  "G.M. College of Education, GM Campus, Arisina Kunte, Nelamangala by pass, Bangalore-562 123.",
  "Govt First Grade College and Centre for Post Graduate Studies   Thenkanidiyur",
  "SHREE DAKSHA ACADEMY EVENING COLLEGE, #596, Andrahalli mn rd, Opp D gp Layout Arch, Blore-91",
  "Centre for Nano and Soft Matter Sciences",
  "COLLEGE OF AGRICULTURE HANUMANAMATTI",
  "MM College of Education, Davangere",
  "OM COLLEGE OF NURSING",
  "Bhandarkr's Arts & Science College, Kundapura-576201",
  "SMRK VIDYAVARDHK SANGHAS COLLEGE OF EDU., BIJAPUR",
  "Govt. First Grade College, Kavoor, Mangalore",
  "Hira Women's College, Permannur Post, Babbukatte, Mangalore",
  "Alvas College of Physical Education, Sundari Ananda Alva Campus, Moodabidri-574227",
  "MET Degree Evening College,  No.1/4, Ittina Apartments, Balaji Layout, 4th Main, Hongasandra, Bommanahalli, Bangaloe-68.",
  "Dr. M.V. Shetty College of Speech & Hearing Institute of Health Science, Vidyanagar, Panjimogaru, P.O., Kulur, Mangalore",
  "Govt. First Grade College, Madikeri, Coorg",
  "Poornaprajna College, Udupi - 576102",
  "Sri Dhawala College, Moodabidri - 574227",
  "Govt. First Grade College, Siddakatte, Bantwal",
  "Sri Venkaramana Swamy College, Bantwal-574211",
  "Laxmi memorial College of Hotel Management, near Besant college, Kalakunja road, Mangalore",
  "Shree Bharathi College, Vivekananda Road, Nanthoor, Mangalore",
  "Shree Devi College, Mangalore",
  "Sri Rama First Grade College, Hanuman Nagarm Kalladka, Bantwal Taluk",
  "Sri Ram Kunjeshwara College, Ramakunja Post, Puttur-5742141",
  "Sri Devi College of Interior Design, Poonja Building, Lalbagh, Mangalore-575003",
  "Govt. First Grade College, Punjalkatte, Belthangady",
  "Meridian College, Shanthi Kendra, Opposite Fathima Retreat, House Valencia, Mangalore-2",
  "Govinda Dasa College, Surathkal- 575014",
  "Govt. First Grade College, Uppinangady-574241",
  "Sri Devi College of Hotel Management, Maina Towers, Ballal Bagh, Mangalore-575003",
  "Canara College, Mangalore-575003",
  "Govt. First Grade College, Shankaranarayana- 567227",
  "St. Mary's Syrian College, Brahmavar-576213",
  "Mar Ivanios College of Education, Kunthoor, Perabe, Puttur Taluk-574285",
  "Indian Institute of Astrophysics",
  "SIDDHARTHA DEGREE COLLEGE ",
  "gnanadri first grade college srinivasapura",
  "K H PATIL SCHOOL OF LAW, BANGALORE    ",
  "Kateel Ashok Pai Memorial Institute of Allied Health Sciences Malligenahalli Shivamoga",
  "Amrutha College of Education, Padil, Mangalore",
  "Govt. First Grade College, Kaup",
  "St. Joseph's Degree College, Choudlu Village, Somavarpet-571236",
  "Carmel College, Modankaup, Bantwal Taluk",
  "Crossland College, Chanthur, P.B.No.7, Brahmavar-576213",
  "Mangalore Academy of Professional Studies, Vyasa Nagara, Behind KPT Ground, Kadri Hill, Mangalore",
  "Richard Almeda Memorial College, Navunda, Kundapura",
  "Milagres College, Kallianpur-576114",
  "Krishnabai Vasudeva Shenoy Memorial College, Katapadi, Udupi",
  "Vivekananda College of Education, Puttur",
  "P.A. First Grade College, Kairangala, Nadupadvu, Bantwal Taluk",
  "St. Aloysius Institute of Education, Mangalore",
  "Vidyanikethana College, Kaup-574106",
  "Shantiniketan College of Education,No.70, Bilekalli, Bangalore-76",
  "Global Instititue of Management Sciences,Rajarajeshwari Nagar, Bangalore-98",
  "Rajajinagar Parents Association FGC, CA-2, 5th Block, Rajajinagar, Bangalore-10.",
  "KARAVALI COLLEGE OF ALLIED HEALTH SCIENCES MANGALORE    ",
  "Oxbridge Business School, No.8 & 9 Mahadeshwaranagar, Vishvaneedum Post, Herohalli Cross, Bangalore -91",
  "SREE SIDDAGANGA HOSPITAL COLLEGE OF ALLIED HEALTH SCIENCES     ",
  "THE DR V P KANAKARADDI MEMORIAL COLLEGE OF NURSING, MAHALINGPUR",
  "The East Point College of  Higher Education, No.147, Bidarahalli, Virgonagar Post, Bangalore -49",
  "Tirumala College of Commerce & Business Management, Machohalli, Magadi Road, Badagrama Post, Bangalore -91",
  "Vidhya Vahini first grade college, Anandanagar, R.T Nagar,Bangalore-24",
  "V.E.T First Grade College, 14th Main Road, 2nd Stage, J.P. Nagar, Banglore-560078",
  "SANJEEVINI NURSING COLLEGE VIJAYAPUR",
  "Kanaka College of Mgmt Studies and Science, Kanaka Complex, Srinivasanagar, 80 ft Rd, Bsk Ist stage, Bangalore-50.",
  "C721 SIDDASHREE DEGREE COLLEGE ALAND KALABURAGI",
  "C735 ITIHASINI MSW COLLEGE KALABURAGI",
  "S.L.N College of Arts and Commerce, Fort Road, Bangalore-2",
  "Government First Grade College, Govt. PU College Annex, 18th Cross, Malleswaram, Bangalore -560 003.",
  "B.E.L First Grade College, Jalahalli, Bangalore-13",
  "Soundarya Institute of Management & Science, Soundarya Road, Havanoor Extn., Nagasandra Post, Bangalore -73,",
  "T John Institute of Management and Science, Banerghatta Road, Bangalore -83",
  "M.N. Degree College, Kammagondanahalli, Bangalore -15",
  "Maharishi Institute of Management, 29th K.M, Bangalore Mysore Road, Bheemanahalli, Bidadi-562109. Ramanagaram Dist.(08-09)",
  "BRIGHT BEGINNING DEGREE COLLEGE RAICHUR",
  "C727 GANGOTRI MSW COLLEGE KALABURAGI ",
  "Shri Sharada B.Ed. College, BM Road, Ramanagaram-571 511.",
  "Sri Gandhadh Kavalu FGC , Magadi Road, Bangalore-79",
  "CHANNABASAPPA KARALE  ARTS COMM COLLEGE, EXAMBA",
  "Don Bosco College of Science and Management, 1A & 10, Bommahalii Hosur Main Rd,  Bangalore -68.",
  "K T S V FIRST GRADE COLLEGE FOR WOMEN",
  "M.H. Institute of Management Sciences, BM Road, Vivekanandanagar, Ramanagaram-571 511",
  "Rajajinagar First Grade College, 10th Main, 5th Block, Rajajingar, Bangalore -10",
  "N U Trust College, Bangalore",
  "VAGDEVI DEGREE COLLEGE ",
  "Williams International College, #163, I Mian road, Bhuvaneshwarinagar, Sultanpalya, Bangalore -560 032",
  "Soundarya College of Law",
  "Bijapur District Education Societys Bhavani Management School BBA  College    Ap Vijayapur   TqDist Vijayapur            ",
  "SHARADA NURSING INSTITUTE",
  "Vidyavardaka First grade College , Sheshadri Road",
  "Government First Grade College, Siddarthanagar",
  "SHRI RAJKUMAR KAMBLE MEMORIAL B COM COLLEGE KALABURAGI",
  "Sri Lakshmi Hayagreeva Institute of Science ,Commerce, Management, Divans Road,",
  "Government First Grade College ,Salligrama",
  "Vikram BBM College, Chelur Road, Near Railway Track, Chintamai-563 125, Kolar Dist.",
  "Yuvaraja's College (Autonomous) Mysore",
  "All India Institute of Speech and Hearing, Manasagangothri,Mysore",
  "Government First Grade College, H.D.Kote",
  "S.G.M. DEGREE COLLEGE",
  "Mallamma Marimallappa Science and BBM College, Mysore",
  "VASANTHA COLLEGE OF PHARMACY, BIDAR",
  "B.R. Tambakad Arts, Commerce & Science First Grade College, Hirekerur",
  "Govt. First Grade College, Kanakapura-562 117",
  "Bangalore College of Education, Heelalige Village, Chandapura, Bangalore -81",
  "The Oxford College of Arts, No.32, 17th B main, sector 4, HSR layout, Bangalore 102",
  "JNANA MANDIRA DEGREE COLLEGE",
  "B.E. Society's Merchants' Arts & Commerce College, Byadgi",
  "UNIVERSAL SCHOOL OF LAW",
  "ASIA PACIFIC INSTITUTE OF EMBRYOLOGY",
  "SRINIVAS INSTITUTE OF DENTAL SCIENCES",
  "Karnataka College of Management, No.33/2, Thirumenahalli, Hegadenagara, Bangalore -560 064.",
  "Gold Field College of Edcuation, Kolar Road,Karahalli Extension, Bangarpet-563114",
  "Full-in-Faws College,221/1,Akshayanagar, Yellanahally, Begoor hobli, Bangalore-68.",
  "C486 SARDAR VALLABHABHAIPATEL MSW COLLEGE CHITTAPUR",
  "VIDYA FIRST GRADE COLLEGE",
  "GMS ACADEMY FIRST GRADE COLLEGE, DAVANGERE",
  "LORAA Business Academy",
  "GOVERNMENT COLLEGE OF NURSING, SEDAM    ",
  "GURUDEV COLLEGE OF NURSING, BALLARI",
  "KOSHYS INSTITUTE OF HOTEL MANAGEMENT ",
  "Shree Vedha College of Nursing",
  "shri Basaveshwar Arts and Commerce first grade College Hidkal Dam",
  "C510 ST. XAVIER DEGREE COLLEGE, GULBARGA",
  "HOLY TRINITY COLLEGE",
  "SRI MAHAVEER B.ED COLLEGE",
  "JAGADGURU GANGADHAR MAHASWAMIGALU MOORSAVIRMATH MEDICAL COLLEGE ",
  "Hill View Institute of Nursing",
  "Kaveri First Grade College, APS School Premises, Hosur Road, Anekal, Bangalore Dist(10-11)",
  "Federal College of Management, No.54-58, Uttarahalli Main Raod, Uttarahalli, Bangalore -61",
  "Smt. GOWRAMMA and SHRI. D.K. KEMPEGOWDA GOVERNMENT DEGREE COLLEGE, Kodihalli, Kanakapura, Ramanagar Dist.",
  "TALUKA SHIKSHANA PRASARAK MANDALI, CHANAVEERAPPA MALLAPPA MANAGULI ARTS,SCIENCE AND COMMERCE COLLEGE,   SINDAGI",
  "G.R. College of Arts, Science & Commerce, #77/2B, BM Kaval Village, Off Agara Main, Tataguni Post, Bangalore South.(9-10/10-11)",
  "BNES College, 9/6, 3rd Cross, Mahalakshmi Layout, Bangalore -86",
  "MAHARAJA COLLEGE OF NURSING",
  "SRI SAI DEGREE COLLEGE,BETHMANGALA",
  "SJB COLLEGE OF ARTS AND SCIENCE",
  "DON BOSCO DEGREE COLLEGE YADGIRI",
  "Jame-Ul-Uloom College of Information Science, Shikshanagar, 26th Mile, Mysore Road, Near Wonderla, Bidadi Hobli-562 109, Ramanagar Dist.",
  "International Academy of Management  & Entrepreneurship, #152/2, Nisarga Campus, Behind the Art of Living, off Kanakapura Road, Udayapura Post, Bangalore -82,",
  "BARAKAH DEGREE COLLEGE",
  "Acharya Institute of Management and Science, Ist Stage, Peenya Industrial Estate,  Bangalore-58",
  "IIFT College of Fashion, #3, 1/6, MC Road, Ist Cross, Vijayanagar, Near Telephone Exch. Bangalore -79",
  "Sardar Vallabai Patel, FGC, Sarjapur-562125",
  "SHRI BIDARUR INSTITUTE OF AYURVEDA AND HOSPITAL, GADAG ",
  "THE MILLENNIUM COLLEGE OF ALLIED HEALTH SCIENCES, BIDAR",
  "IAS COLLEGE OF EDUCATION",
  "ADICHUNCHANAGIRI SCHOOL OF NATURAL SCIENCES",
  "PRIME INSTITUTE OF PHYSIOTHERAPY BENGALURU",
  "BVVSS COLLEGE OF EDUCATION,  BAGALKOT",
  "GOVT FIRST GRADE COLLEGE,    MUDHOL",
  "GOVT FIRST GRADE COLLEGE, TERADAL",
  "BLDEAS COLLEGE OF PHARMACY JAMKHANDI",
  "H.K.E Society's Sir M Visvesvaraya College of Engineering, Raichur",
  " Maratha Mandals Arts and Commerce College, Khanapu",
  "MIT DEGREE COLLEGE, MYSURU",
  "MRN INSTITUE OF NURSING SCIENCES NAVANAGAR BAGALKOT",
  "MRN AYURVEDIC MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE NAVANAGAR BAGALKOT",
  "NITTE INSTITUTE OF PROFESSIONAL EDUCATION",
  "Atria Institute of Technology, BANGALORE",
  "BASAVA RAJENDRA COLLEGE OF NURSING ",
  "C546 KOHINOOR COMMERCE DEGREE COLLEGE, GULBARGA",
  "Govt. First Grade College, Chikkabasur, Tq  Byadagi Dist  Haveri.",
  "Sri Bapuji College of Education, Gudanahalli Road, Malur-563130",
  "MANGALORE UNIVERSITY JNANA KAVERI POST GRADUATE CENTRE CHIKKA ALUVARA KODAGU",
  "HASS INSTITUTE OF NURSING SCIENCES,  HUBBALLI",
  "C465 Indira Gandhi Bed College",
  "V V SANGHA DEGREE COLLEGE, T B DAM HOSAPETE",
  "Srikantha  First grade College for Women, Mysore",
  "Govt First Grade college, Tavaragere-583278, Kustagi(Tq)",
  "Sree Cauvery First Grade College, Kuvempunagar",
  "Sri  D Devaraj Urs Govt  First Grade College,  Hunsur",
  "Government First Grade College, Bannur",
  "Mallamma Marimallappa Arts & Commerce College For Women,Ramavilas Road Mysore",
  "Sri Chayadevi College of Education Rajendra Nagar",
  "Maharajas college Mysore",
  "TTL College of Business Management, Saraswathipuram",
  "Mahatma Gandhi First Grade college ,AdiShatki Road  Shakthinagar",
  " R L JALAPPA COLLEGE OF PHYSIOTHERAPY",
  "BGS SCIENCE ACAEMY",
  "National Institute of Engineering, MYSORE",
  "Karnataka College of Management and Science, No.33/2, Tirumenahalli, Hegadenagar Main Road, Jakkur Post, Yelahanka Hobli, Bangalore-64.",
  "DEODHAR COLLEGE OF NURSING, HAVERI",
  "K.L.S. DEGREE COLLEGE, HALIYAL",
  "JNANA VIKAS womens degree college jewargi",
  "NEW BALDWIN INTERNATIONAL DEGREE COLLEGE, ATTIBELE",
  "Karavali Ayurvedic medical college ",
  "Maharaja Madakari Nayaka First Grade Arts and Commerce College, Chitradurga",
  "J.H.Patel Institute of Management & Technology, Davangere",
  "Girisha College Of education, Hiriyiur",
  "Bapuji College of Education, Lake View Campus, Davangere",
  "Chanukya First Grade College of commerce, Davangere",
  "SAI SIDD COLLEGE OF PHYSIOTHERAPY",
  "Sri Ragavendra College Of education, Mallladihalli,  Chitradurga district",
  "A.D.V.S. Arts & Commerce First Grade College, Sasvehalli",
  "SJVP College of Education, Honnali-577217",
  "SSMB College of Education for Women, Davangere-577005",
  "Sri Nandishwara Rural College of Education Harihara",
  "S.M. Krishna College of Education, Davangere-577001",
  "D.R.M. Science College, Davangere",
  "B.S. Channabasappa First Grade college, Davangere",
  "Bapuji Academy of Managment & Research, Davangere",
  "Siddaratha College of Education, Jagalur -577528",
  "Sri Shivalingeshwara Government First Grade College, Channageri",
  "Sri Basaveshwara First Grade College, Hireguntanuru,",
  "A.R.M.First Grade college,Davangere",
  "Sri Ragavendra College of Education, Chitradurga",
  "Sri Venkateshwara First Grade College, Chitradurga.",
  "D.Banumaiah's Evening College, Mysore",
  "Srishaila College of Education, Harihara",
  "Government First Grade College,Harihara",
  "GOVERNMENT ARTS COLLEGE (AUTONOMOUS), CHITHRADURGA",
  "Baba Saheeb Ambedkar Centunary Degree College, Harihara",
  "University college of Fine Arts Mysore",
  "Sharada College of Education, Mulbagal-563131, Kolar District.",
  "Sri Yashodaramma Borappa Womens First Grade College, Chitradurga.",
  "MES College of Education, Davangere-577004",
  "Bapuji First Grade College, Challakere,",
  "Government First Grade College, Parushurampura.",
  "Government First Grade College, Davangere",
  "SHRI PADMARAJ VIDYAVARDHAK SANGH 's G P PORWAL ARTS,COMM AND V V SALIMATH SCIENCE COLLEGE,  AP SINDGI 5286128 TQ SINDGI DT VIJAYAPUR",
  "INDIAN DESIGN SCHOOL MANGALORE",
  "VINAY HUBBALLI COLLEGE OF NURSING   BELAGAVI",
  "SB COLLEGE OF ALLIED HEALTH SCIENCES",
  "ANIMAL HUSBANDRY POLYTECHNIC BARGI GUNDULPETE CHAMARAJANAGAR DISTRICT  KARNATAKA ",
  "TMAE Societys  College of Education, Iagari Lakamapur,  PB Road, Haveri",
  "MESAS NOBLE DEGREE COLLEGE ATHANI-591304",
  "D443 Devanampriya Ashok Govt. First Grade College Maski",
  "PRASANNA COLLEGE OF PHARMACY",
  "NEW MANGALA COLLEGE OF NURSING, MANGALORE",
  "Premier College of Nursing",
  "Hanagal Taluka Education Society Arts and Commerce College",
  "SCT College of Education, Vignananagar, Kaggadasapura Main Road, Thippasandra, Bangalore -75",
  "SCHOOL OF ALLIED HEALTH SCIENCES",
  "Ballari Rudrappa Education Societys BBA College Motebennur",
  "ANJUMAN - E - ISLAM'S ARTS & COMMERCE COLLEGE,  BELGAUM",
  "Hanagal Taluk Shikshna Sanghas B.B.A College, Narasinga Nagar Akki-Alur  Tq Hanagal",
  "D465 Shri Venkateshwara BBM College Raichur",
  "KRE Society's Karnatak Arts Science & Commerce College,Bidar",
  "Central Institute of Indian Languages, Manasagangotri, Mysore",
  "Dr. Sri. Jachani First Grade College, Vapasandra, Chikkaballapura Dist.",
  "ARUNA COLLEGE OF ALLIED HEALTH SCIENCES TUMKUR",
  "SHIRDI SAIBABA COLLEGE OF NURSING",
  "JNYANAYOGI SIDDESHWARA SWAMIJI ARTS DEGREE COLLEGE, AALMEL",
  "B203 B.V.BHOOMARADDI COLLEGE OF ARTS, SCIENCE AND COMMERCE, BIDAR",
  "C353 Govt First Grade College,Kamalapur, Tq. and District Kalaburgi",
  "B238 GURU NANAK FIRST GRADE COLLEGE BIDAR",
  "C311 S.B College of Commerce Gulbarga",
  "NEW ERA COLLEGE",
  "SUSHRUTHA INSTITUTE OF AYURVEDA MEDICAL SCIENCES AND RESEARCH CENTER",
  "Mother Teresa College of Education, P.O. Box No.1320, MES Ring Road, Jalahalli, Bangalore -13",
  "BASAVESHWARA COLLEGE OF PHYSIOTHERAPY",
  "Kristu Jayanti College, K. Narayanapura, Kothanur P.O. Bengaluru 560077 ",
  "DIYA COLLEGE OF NURSING",
  "C674 POOJYA SHRI RAJASHEKHAR MAHASWAMIJI B.ED COLLEGE ALAND",
  "K.N. Nagegowda College of Law, Malavalli",
  "ASIAN INSTITUTE OF GAMING AND ANIMATION",
  "SWAMY VIVEKANANDA AYURVEDIC MEDICAL COLLEGE HOSPITAL   LINGASUGUR RAICHUR DISTRICT",
  "BALLARI RUDRAPPA EDUCATION SOCIETYS COLLEGE OF EDUCATION, HAVERI",
  "Shri Jagadguru Renukacharya College of Law, Bangalore",
  "Basaveshwar B.Ed. College, SJM Vidyapeeth, Near Hosamath, Haveri",
  "Bellari Rudrappa Education Trust's Arts , Commerce and Science College, Motebennur, Haveri",
  "UNIVERSAL SCHOOL OF ADMINISTRATION",
  "GOVERNMENT FIRST GRADE EVENING COLLEGE KUVEMPUNAGARA",
  "Raja Lakhamgouda Law College, Belgaum",
  "AROGYA COLLEGE OF NURSING MUDALAGI",
  "VISHWANATH MALLAPPA KATTI SMARAK DHARMARTH TRUST  V M KATTI SCIENCE COLLEGE BELLAD BAGEWADI",
  "Sri Kalaniketana School of Art, Mysore",
  "Vijayamahantesh Lalitakala Mahavidyalaya, Hubli",
  "The Arts Integration Chitrakala Mahavidyalaya, Gulbarga",
  "Research Centre of Sri Basaveshwar Veerashaiva Vidhyavardhaka",
  "Mahesh Chitrakala Mahavidyalaya, Jamakhandi",
  "The Natural Fine Arts College, Bidar",
  "SJPD Chitrakala Mahavidyalaya, Balki",
  "Chitrakala Mahavidyalaya, Hoovinahipparagi",
  "Sri B.R. Darooru Research Centre, Harugeri",
  "Vani Chitrakala Shale, Chikkanayakanahalli",
  "Siddarth Lalitakala Vidyalaya, Gokak",
  "Chetana Lalitakala Mahavidyalaya, Bangalore",
  "SREE KRISHNA COLLEGE OF EDUCATION",
  "Raja Raviverma Chitrakala Mahavidyalaya, Basavanabagewadi",
  "Kuvempu Vidyavardhaka Trust, Mysore",
  "Shantala Lalitakala Mahavidyalaya, Hasan",
  "Nootana Lalitakala Mahavidyalaya, Lingasugur",
  "G.B. COLLEGE OF NURSING",
  "SHREE VEDHA COLLEGE, PAPAREDDY PALYA BENGALURU",
  "LAKESIDE COLLEGE OF NURISNG ",
  "akkamahadevi ayurvedic madical college",
  "GOVERNMENT FIRST GRADE COLLEGE, TILUVALLI",
  "National College of Nursing",
  "NISARGA DEGREE EVENING COLLEGE",
  "LITTLE FLOWER COLLEGE OF NURSING",
  "KRISHIK SARVODAYA FOUDATION SCHOOL OF BUSINESS, MYSORE ",
  "Government First Grade College, Shiggaon, Dist- Haveri.",
  "SRI MUNESHWARA COLLEGE OF NURSING",
  "PEOPLETREE EDUCATION  SOCIETY'S BBA/BCA AND BCOM  COLLEGE, AP NEHARU NAGAR, BELAGAVI",
  "C692 SRI JAGADGURU TINTHANI MOUNESHWARA FIRST GRADE COLLEGE KAKKERA, YADGIR",
  "C693 KRISHNA DEVARAYA DEGREE COLLEGE GURMITAKAL ",
  "C734 SC ST RESIDENTIAL GOVT FIRST GRADE COLLEGE MUDNAL YADAGIR",
  "C716 MATOSHRI MALLAMMA DEGREE COLLEGE YADGIR",
  "PAVITRA DEGREE COLLEGE WADAGERA",
  "Kamala College of Nursing",
  "BGS VIJNATHAM INSTITUTE OF NURSING SCIENCES",
  "Vijayanagar College of Nursing",
  "Masood College of Nursing",
  "Sri Basavaraja Swamy College of Nursing",
  "UDUPI DHANVANTARI COLLEGE OF NURSING, UDUPI",
  "Nidhi College of Nursing",
  "INSTITUTE OF AEROSPACE MEDICINE, BANGALORE",
  "ST. JOSEPHS COLLEGE OF NURSING, MYSORE",
  "Dr. B R Ambedkar Medical College1",
  "SCSES Dhavantari Ayurvedic Medical College",
  "Bapuji Dental College & Hospital",
  "SRINIVAS INSTITUTE OF MEDICAL SCIENCE AND RESEARCH CENTRE, MANGLORE",
  "AIR FORCE TEST PILOTS SCHOOL, BANGALORE",
  "AIR FORCE TECHNICAL COLLEGE, BANGALORE",
  "ANNAPURNA INSTITUTE OF BUSINESS MANAGEMENT AND COMPUTER APPLICATION",
  "Manipal College of Dental Sciences, Mangalore",
  "ESIC MEDICAL COLLEGE Â AND POST GRADUATE INSTITUTE OF MEDICAL SCINECES AND RESEARCH, Bangalore",
  "SHRI KALMESHWAR ARTS COLLEGE, M K HUBLI",
  "Kasturba Medical College, Manipal",
  "College of Dental Sciences",
  "Welcomgroup Graduate School of Hotel Administration, Manipal",
  "Manipal College of Nursing, Manipal",
  "Manipal College of Pharmaceutical Sciences, Manipal",
  "Kasturba Medical College, Mangalore",
  "Manipal Institute of Technology, Manipal",
  "Manipal College of Dental Sciences, Manipal",
  "Mahatma Gandhi Professional College of Nursing",
  "KHAJA BANDA NAWAZ COLLEGE OF NURSING, GULBARGA",
  "Sea College of Nursing",
  "United Mission Degree College, Mission Road, Bangalore-27",
  "Bangalore Institute of Dental Sciences & Hospital",
  "''SMAT ' s  SHIVANAND  COLLEGE, KAGWAD''",
  "VEDAVATHI COLLEGE OF EDUCATION",
  "Bilal Education Society's College of Education for Women, BIDAR",
  "C340 Vijaya Vidyalaya Degree College Gulbarga",
  "Krishnadevarayan College of Dental Sciences",
  "Harsha College of Nursing",
  "Sri Siddartha Institute of Business Management",
  "B.M.S. Government First Grade College, Huliyar",
  "Sacred Heart First Grade College",
  "Sri T.V.Venkataswamy First Grade College, Madhugiri",
  "University College of Arts",
  "St. AGNES CENTRE FOR POST GRADUATE STUDIES AND RESEARCH",
  "Sree Siddaganga Arts, Science and Commerce First Grade Women's College",
  "Sri Siddeshwara Samsthe's College of Nursing",
  "St. Philomina's College of Nursing",
  "Panchasheela Degree College, #10, BHEL Layout, 21st Cross, Pattanagare, RR Nagar, Bangalore -560 098.(10-11)",
  "Bhuvan College of Nursing",
  "Hi – Tech City College of Nursing",
  "The Oxford College of Pharmacy",
  "BUNTS SANGHA RNS EVENING COLLEGE",
  "SMT. DANAMMA CHANNABASAVAIAH COLLEGE OF ARTS, COMMERCE, SCIENCE AND MANAGEMENT STUDIES  ",
  "Vishnupanth Nanavate Degree College",
  "Manipal Institute of Management, Manipal",
  "Bi Bi Raza Degree College for Women (Arts & Science) Kalaburagi",
  "A J College of Nursing",
  "Sri Krishna Degree College, #2(P), ITI Colony, Katraguppa Mian Road, BSK 3rd Stage, Bangalore -85,",
  "SANA DEGREE COLLEGE, HUBBALLI    ",
  "Government First Grade College, Madhugiri",
  "Y.E.R Government First Grade College, Pavagada",
  "Sri Siddartha College of Education",
  "C737 Billav PG College Hunasagi",
  "Union Christian First Grade College",
  "Sri Siddartha Centre for Media Studies",
  "Udayabharathi Arts First Grade College for Women, Tiptur",
  "Sri T.V.Venkataswamy College of Education, Madhugiri",
  "University College of Science",
  "Indira First Grade College",
  "ST IGNATIUS INSTITUTE OF HEALTH SCIENCES, HONAVAR",
  "S.V.S First Grade College",
  "Akshaya College of Education",
  "Government First Grade College, Tiptur",
  "Manipal Institute of Communication, Manipal",
  "Manipal College of Health Professions, Manipal",
  "Government First Grade College, Hebbur",
  "K.S.E.F College of Education",
  "S.V.S College of Education",
  "Sree Siddaganga College of Education",
  "Kalpatharu College of Education, Tiptur",
  "Sri Honnadevi Government First Grade College, Dandinashivara",
  "Sarvodaya First Grade College",
  "Sree Siddaganga Arts and Commerce First Grade Evening College",
  "Sri Digvijaya College of Education, Turuvekere",
  "Jnanajyothi First Grade College, Baragur",
  "Santosh D Nayak Degree College Ap Kudalasangam",
  "Sri Gokula College of Arts, Science & management Studies, Jayanagar, Kolar-563 101.",
  "VASANTARAO PATIL FIRST GRADE COLLEGE",
  "T. John College of Pharmacy",
  "HKES College of Nursing",
  "Janatha Government First Grade College,, Basavapatna",
  "Srilakshmi College of Nursing_Bangalore",
  "SCSES Shiva Basavajyothi Homoeopathic Medical College",
  "MAHARAJA INSTITUTE OF AYURVEDA MEDICAL SCIENCES AND HOSPITAL, BELAWADI, SRIRANGAPATNA TQ, MANDYA DISTRICT    ",
  "BHRAMARI INSTITUTE OF NURSING AND HEALTH SCIENCES    ",
  "HOLY CROSS COLLEGE OF NURSING KAMAGERE KOLLEGAL CHAMARAJANAGAR ",
  "R L Abhishek Rao College of Nursing",
  "National College of Edcation, Harihara Road, Hosapete-583201.",
  "D590 SUNRISE DEGREE COLLEGE, RAICHUR",
  "Vedant B.C.A and B.Com College",
  "SVSET's SVS BCA COLLEGE,   ILKAL",
  "CHAITANYA FIRST GRADE COLLEGE CHITRADURGA    ",
  "UNIVERSITY COLLEGE, BANNADKA, MOODABIDRI",
  "Mandya Institute of Medical Sciences",
  "Acharya's NRV School of Architecture, BANGALORE",
  "Sri Hasanamba Dental College",
  "S B COLLEGE OF PHYSIOTHERAPY",
  "Fr. Muller Medical College",
  "Shri  C.M. PANCHAKATTIMATH GOVERNMENT FIRST GRADE COLLEGE,  LOKAPUR",
  "SANJEEVINI INSTITUTE OF PARAMEDICAL SCIENCES",
  "WESTERN HILLS COLLEGE OF EDUCATION ",
  "Coorg Institute of Dental Sciences Virajpet",
  "Mahadevappa Gadgi Law College, Bidar",
  "D454 Shri veerashaiva  Samaji (HCMSK) College of Education Raichur",
  "Father Muller Homoeopathic Medical College & Hospital",
  "St. Josephs College of Law",
  "Sharada Vikas School of Excellence for Law",
  "SRI BHAGAWAN MAHAVEER JAIN FIRST GRADE COLLEGE, KGF-563122",
  " JD School of Design, No 18, Edward House, Brigade Road, Shanthala Nagara, Bengaluru-560001",
  "SINDHI COLLEGE, No.33/2 B, Kempaprua Hebbal, Bangalore -64",
  "Samuel Memorial College of Commerce Mudhol",
  "A. M Shaikh Homoeopathic Medical College",
  "HARSHA INSTITUTE OF TECHNOLOGY ",
  "Vydehi Institute of Nursing Sciences   & Research Centre",
  "SVSET'S SVS BBA COLLEGE,   ILKAL",
  "CHANAKYA ",
  "SVM V V SANGHA'S INSTITUTE OF MANGEMENT STUDIES, ILKAL (PG)",
  "Melkar Degree College",
  "N E T INSTITUTE OF ALLIED HEALTH SCIENCES",
  "Consortium Minorities Association Arts and Commerce ",
  "SVM JAHAGIRDAR COLLEGE OF BCA,   ILKAL",
  "Jnanajyothi Degree College, CA 23, 3rd Cross, Yelahanka New Town, Bangalore  64",
  "NIDA COLLEGE OF NURSING",
  "AVISHKAR COLLEGE OF NURSING",
  "Laasya College of Nursing",
  "SVM COLLEGE OF BBA,    ILKAL",
  "C B Guttal  Ayurvedic Medical College",
  "GLORIA INSTITUTE OF MANAGEMENT AND SCIENCE",
  "ACS College of Engineering, BANGALORE",
  "Sri. Govindatheertha College, Visveshwaranagar, Nandi Chikkaballapur road, Chikkaballapur Dist.",
  "Chinai College of Nursing",
  "Cambridge Institute of Technology, BANGALORE-560036",
  "Amrutha Institute of Engineering & Management Sciences, BANGALORE",
  "SURANA COLLEGE    ",
  "Sri Mariyappa Balappa Kalakonnavar Government First Grade College Naregal Tq- Ron  Dist- Gadag.",
  "SHREE NEELAKANTH ARTS FIRST GRADE COLLEGE DEVAPUR TQ SHORAPUR DT YADGIRI",
  "JNANA JYOTHI EVENING DEGREE COLLEGE",
  "Shri Madhwa Vadiraja Institute of Technology  & Management, BANTAKAL",
  "Tontadarya College of Engineering, GADAG",
  "Manipal Institute of Virology",
  "Sri Sairam College of Engineering, BANGALORE",
  "Nitte Meenakshi Institute of Technology, BANGALORE",
  "SDM Institute of Technology, UJIRE",
  "VTU Extension Centre, IR Rasta, Bangalore",
  "B551 VIVEKANAND DEGREE COLLEGE BASAVAKALYAN",
  "Gopalan College of Engineering & Management, BANGALORE",
  "Bapuji Institute of Engineering & Technology, DAVANAGERE",
  "NIE Institute of Technology, MYSORE",
  "Govt. Engineering College, BELLARY",
  "Sambhram Institute of Technology, BANGALORE",
  "Angadi Institute of Technology & Mgmt., BELAGAVI",
  "Sri Krishana Institute of Technology,  BANGALORE",
  "Ghousia College of Engineering, RAMANAGARAM",
  "Bangalore Technological Institute, BANGALORE",
  "Dayananda Sagar College of Engineering, BANGALORE",
  "The Oxford College of Engineering, BANGALORE",
  "S T J Institute of Technology, RANEBENNUR",
  "J S S Academy of Technical Education, BANGALORE",
  "Hirasugar Institute of Technology, NIDASOSHI",
  "Nagarjuna College of Engg. & Technology, BANGALORE",
  "Government First Grade College for Women, Opp R N Shetty Stadium Office, Dharwad",
  "C M R Institute of Technology, BANGALORE",
  "ICBIO CLINICAL RESEARCH PVT LTD",
  "C593 M. N. DESAI DEGREE COLLEGE GULBARGA",
  "GOVERNMENT FIRST GRADE COLLEGE BYATARAYANAPURA BANGALORE ",
  "Shree Devi Institute of Technology, MANGALORE",
  "STG COLLEGE OF NURSING",
  "B N M Institute of Technology, BANGALORE",
  "SECAB Institute of Engg. & Technology,  BIJAPUR",
  "Rao Bahaddur Y Mahabaleshwarappa  Engineering College, BELLARY",
  "Coorg Institute of Technology, PONNAMPET",
  "Kalpataru Institute of Technology, TIPTUR",
  "Rajiv Gandhi Institute of Technology,  BANGALORE",
  "Govt. Tool Room & Training Center, MYSORE",
  "B F DANDIN LAW COLLEGE ",
  "Shah-Shib College of Engineering,CHIKKABALLAPUR",
  "Shri Channabasaveshwar Education Societies Shri. Sai B.Ed College, Navanagar Hubli.",
  "SADBHODINI EDUCATION SOCIETYs ARTS DEGREE COLLEGE FOR WOMEN, CHITAGUPPA",
  "SANKALP EDUCATION TRUSTS FIRST GRADE ARTS AND COMMERCE COLLEGE FOR WOMEN, GANGAVATI",
  "Smt. Lalitadevi Gurusiddappa Sindhur Government First Grade College, Bankapur Road Savanur",
  "Shri. Guru Rachoteshwar Vidya Samsthe Shri. Channabasaveshwar Education College, Savanur ",
  "DBHPS RAJIV GANDHI COLLEGE OF EDUCATION, DHARWAD",
  "SHRI MALLIKARJUN VIDYA VARDHAK SANGHs SHRI BASAVESHWAR ARTS DEGREE COLLEGE FOR WOMEN, KALKERI",
  "SHRI SHIVAYOGI SANGAMARYA VIDYA SAMSTHAs SHRI H S PATIL ARTS DEGREE COLLEGE FOR WOMEN, TALIKOTI",
  "Vishwakavi  Kuvempu   First grade College, Jayalakshmi puram",
  "SARVAJYAN VIDYAPEETHAS SMT SIDDAMMA BASANAGOUDRA PATIL ARTS COLLEGE, HAVERI",
  "GOVERNMENT NURSING COLLEGE, MYSORE",
  "SHUBHAM COLLEGE OF NURSING BENGALORE",
  "Ranebennur Shri. Basava Chetan Vidya samste, Shri. Basava Chetan Education College, Puttaiah Viraktha Matha, Doddapete, Ranebennuru",
  "Priyadarshini First Grade College Rattihalli ",
  "G R R COLLEGE OF NURSING, BANGALORE",
  "CNK COLLEGE OF NURSING, HEBBAL",
  "MANGALORE MARINE COLLEGE AND TECHNOLOGY, MANGALORE",
  "B577 SUCCESS DEGREE COLLEGE BASAVAKALYAN",
  "Shri Veerabhadreshwar Vidya Samsthe Keerti Arts and Commerce College, Savanur",
  "MVPs Mahanta Swamy Arts,Science & Commerce College, Haunsabhavi Tq: Hiekerur",
  "St Hopkins International College",
  "SC ST Residential Govt First Grade College Devagiri, Haveri",
  "RTE Societys College of Education Ranebennur",
  "Dr. S.R. Chandrasekhar Institute of Speech and Hearing, Hennur rd, Bangalore-84",
  "Don Bosco Institute of Management Studies and Computer Applications, Kumbalagodu, Mysore Road,  Bangalore.",
  "K.L.E. SOCIETY 'S RAJA LAKHAMAGOUDA SCIENCE   INSTITUTE (AUTONOMOUS), BELAGAVI",
  "K.L.E. Society's Jagadguru Gangadhar College of Commerce, Hubli - 21",
  "VIDYARATHNA PARA MEDICAL COLLEGE, UDUPI",
  "Sri Siddaganga College of Physical Education",
  "Sri Basaveshwara First grade College, Tiptur",
  "Udayabharathi First Grade College for Women, Turuvekere",
  "Government First Grade College, Bidadi-562109",
  "S P G FIRST GRADE COLLEGE",
  "Seshadripuram Institute of Commerce & Management., Seshadripuram, No.40, Girls' School Street, Bangalore -560 020.",
  "Govt. Engineering College, KARAWAR",
  "K.L.Es Societies   G.H    B.C.A College Haveri.",
  "TMAE Samsthes College of Physical Education Haveri.",
  "BVVS's BASAVESHWAR ARTS COLLEGE,  BAGALKOT",
  "SHRI HVSS RURAL ARTS COLLEGE,  KAMATGI",
  "KLES INSTITUTE OF NURSING SCIENCES, CHIKODI",
  "SRI SANJEEVINI INSTITUTE OF NURSING SCIENCES  FOR DEGREE COURSES",
  "SMT RAJESHWARI VISHWANATH KATTI CHARITABLE TRUSTS RAJESHWARI VISHWANATH KATTI INSTITUTE OF NURSING SCIENCES BELLAD BAGEWADI ",
  "ANIMAL HUSBANDRY POLYTECHNIC  KONEHALLY TIPATURU TQ TUMKURU DISTRICT",
  "D499 Sanketh College of Commerce And Mgmt Sindhanoor",
  "D507 Sgreevaari education Trust BBM College Raichur",
  "D508 ST.THOMAS DEGREE COLLEGE RAICHUR",
  "NAIKAR EDUCATION  SOCIETY  MALATESH DEGREE COLLEGE, SHIRAGUPPI",
  "C N MUGALKHOD COLLEGE OF NURSING MUDALGI",
  "D524 K HANUMANTHARAYA NAYAK ARTS DEGREE COLLEGE",
  "SRI NANAK ZEERA SAHEB COLLEGE OF NURSING BIDAR",
  "D525 IDEAL DEGREE COLLEG, SINDHANOOR",
  "GOVT  FIRST GRADE COLLEGE, TURVIHAL, SINDHANOOR",
  "Indian Institute of Psychology and Research, No.85, Hosur main road, St. Anthony Friary Church, Madiwala Check Post, Bengaluru - 560095",
  "UNIVERSITY COLLEGE FOR WOMEN",
  "SHRI BASAVESHWAR ARTS COLLEGE KABBUR",
  "SCST RESIDENTIAL GOVERMENT FIRST GRADE COLLEGE MALLADIHALLI HOLALKERE TALUK CHITRADURGA ",
  "SBS DEGREE COLLEGE",
  "SHRI SHRIPADBODH  SWAMIJI GOVERNMENT FIRST GRADE COLLEGE,  MUDALAGI",
  "NEW EXPERT FIRST GRADE EVENING COLLEGE",
  "Government First Grade College, Talakad",
  "SHREE DEVI COLLEGE OF ALLIED HEALTH SCIENCES MANGALORE",
  "SHRI SHIKSHA COLLEGE OF NURSING",
  "DHANWANTARI INSTITUTE OF ALLIED HEALTH SCIENCES",
  "D540 Infant Jesus Arts and Commerce Degree College",
  "D541 SHRI SWAMY VIVEKANDA DEGREE DEGREE COLLEGE, KONGANAHALLI",
  "OM SAI DEGREE COLLEGE",
  "Shri Lakshminarayan Swamy and Shri Anjaneya Swamy SC and ST Education Societys Priyadarshini Arts and Commerce College for Women, Mariyammanahalli",
  "Government First Grade College for Women, Belgaum",
  "SHIRDI SAI DEGREE COLLEGE , KARKALA",
  "Government First Grade College for Women, Bellary",
  "Government First Grade College for Women, Bidar",
  "Surya Education Societys Shri Pawad Basaveshwar Arts and Commerce Colege for Women, Huvina Hippargi",
  "Karnataka Rural and Education Development Societys Shivasharny Hemraddi Mallamma Arts College for Women, Hirur",
  "SDM COLLEGE OF BUSINESS MANAGEMENT POST GRADUATE CENTRE FOR MANAGEMENT STUDIES AND RESEARCH",
  "Shri Gurudev Vidya Sanghas Matoshri Gauramma First Grade Arts College for Women, Shri Basava Rajendra Devasthan Campus, Sindagi Road, Indi",
  "Anjuman E Islam Societys Anjuman Arts Womens College, Almail",
  "Government First Grade College for Women, Bijapur",
  "Government First Grade College for Women, Gadag",
  "Smt. Goudshani Savitramma Com Limbangoudar Patil Government First Grade Womens College Haveri",
  "Tauhid Education Societys Firoza Hashim Commerce College for Women, Karwar",
  "Government First Grade College for Women, Karwar",
  "Shri Srinivas Rural Development Trusts Vidya Bharati Arts and Commerce College for Women, Marlanhalli, Karatgi",
  "Government First Grade College for Women, Koppal",
  "D545 ANIKETHAN DEGREE COLLEGE, SINDHNOOR",
  "Government First Grade College for Women, Raichur",
  "Government First Grade College for Women, Sindhanur",
  "Government First Grade College for Women, Yadgir",
  "D562 ARUNDHATI M.S.W COLLEGE DEODURGA",
  "GOVERNMENT WOMENS FIRST GRADE COLLEGE, TUMKUR",
  "GOVERNMENT FIRST GRADE COLLEGE, C S PURA, GUBBI",
  "GOVERNMENT FIRST GRADE COLLEGE, MEDIGESHI",
  "KSS DEGREE COLLEGE",
  "BGS FIRST GRADE COLLEGE, ABBURU, PERIYAPATNA",
  "Teresian College , Siddrthanagara, Mysore",
  "JSS COLLEGE OF EDUCATION,  BANAHATTI",
  "JSS College of Arts, Commerce and Science, Ooty Road, Mysore",
  "Mysore Institute of Commerce and Arts, Metagalli",
  "MAHARANI LAKSHMI AMMANNI COLLEGE FOR WOMEN, 18th Cross, Malleshwaram, Bangalore 12",
  "THE OXFORD SCHOOL OF ARCHITECTURE",
  "Sambhram Institute of Medical Sciences and Research",
  "SRI RAGHAVENDRA DEGREE COLLEGE",
  "JNANADHARA FIRST GRADE COLLEGE",
  "SUBRAMANYA COLLEGE OF EDUCATION",
  "GURUKULAS ARJ BBA AND BCA COLLEGE",
  "Sri. Bhagawan Mahaveer Jain Educational and Cultural Trust, Jain College of B.B.A, Suvidha Plaza, CTS No: 2927/A-6, Bailappanavar Nagar, Behind KIMS, Vidya Nagar, Hubballi -29",
  "NAYALA COLLEGE OF EDUCATION",
  "NAVAYUGA  WOMENS DEGREE COLLEGE MANVI",
  "CHAMPA SCHOOL OF LAW",
  "CITIZENS FIRST GRADE COLLEGE OF SCIENCE, COMMERCE AND MANAGEMENT",
  "SANGAMESHWAR DEGREE COLLEGE, AMINGAD",
  "ST. TERESA DEGREE COLLEGE FOR WOMEN",
  "Shri. Sharana Nooliya Chandayya Dr. B. R. Ambedkar Smaraka A.K.K Education Society's Arts & Commerce College,Gangadhar Nagar, Hubli.",
  "Maharaja Institute of Tech., MYSORE",
  "Bharathi College of Education",
  "K C T Engineering College, GULBARGA",
  "Godutai Doddappa Appa Arts, Commerce & Science Degree College for Women Kalaburagi",
  "DNYAN GANGA TRUSTS SRI SHAHU MAHARAJ COLLEGE OF PHARMACY BIDR",
  "Srinivas Institute of Technology, Magalore",
  "Government First grade college for women Byarapura T Narasipura  ",
  "PRM Vijaya First Grade college,Gopalapura Road",
  "K S Institute of Technology, BANGALORE",
  "GULBARGA INSTITUTE OF MEDICAL SCIENCES, GULBARGA",
  "Amrita School of Engineering, Bangalore",
  "ANJUMAN INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "GOVT. FIRST GRADE COLLEGE, KANYANA",
  "GOVT. FIRST GRADE COLLEGE, MUNIYALU, KARKALA",
  "GOVT. FIRST GRADE COLLEGE, MUDIPU-574153",
  "GOVT FIRST GRADE COLLEGE FOR WOMEN",
  "GOVERNMENT FIRST GRADE COLLEGE",
  "Amrita School of Education, Mysore",
  "Alvas Institute of Engineering and Technology, MOODBIDRI",
  "T. John Institute of Technology, BANGALORE",
  "New Horizon College of Engineering, BANGALORE",
  "DAYANANDA SAGAR ACADEMY OF TECHNOLOGY AND MANAGEMENT, BANGALORE",
  "JYOTHY INSTITUTE OF TECHNOLOGY, BANGALORE",
  "LINGARAJ APPA ENGINEERING COLLEGE, BIDAR",
  "JAIN INSTITUTE OF TECHNOLOGY, DAVANAGERE",
  "SHETTY INSTITUTE OF TECHNOLOGY, GULBARGA",
  "G MADEGOWDA INSTITUTE OF TECHNOLOGY, MANDYA",
  "Department of Management, Bangalore",
  "International Vachana Studies Centre, Kudalasangama",
  "The Ideal Fine Arts Institute, Gulbarga",
  "Rural Engineering College, HULKOTI",
  "Ken Kalashale, Sheshadripuram, Bangalore",
  "D.V.S. Evening College, Shimoga.",
  "Chitradurga P.G. Centre",
  "Sri Jayanna College of education, Challkere",
  "K L Es College of Engg. & Technology, BELGAUM",
  "B. Parameshwarappa Arts and Commerce College, Holalkere,",
  "G M Institute of Technology, DAVANGERE",
  "S C T Institute of Technology, BANGALORE",
  "J N N College of Engineering, SHIMOGA",
  "MES First Grade College, Udayagiri,",
  "Central Food Technological Research Institute, Cheluvambe Mansion, Mysore.",
  "Sharada College, Devinagara, Talapady, Mangalore - 575023",
  "B307 SARVODAYA DEGREE COLLEGE",
  "B309 JASMIN DEGREE COLLEGE",
  "C410 VASANT B ED COLLEGE",
  "C507 MANYAWAR DADASAHEB KANSIRAM MEMORIAL ARTS DEGREE COLLEGE",
  "C508 SRI MAHANTESHWAR DEGREE COLLEGE OF ARTS",
  "C536  Reshmi  Degree College, Gulbarga",
  "C506 SRI SAI PRASAD ARTS AND COMMERCE FIRST GRADE COLLEGE",
  "JANATA SHIKSHAN SANGHA'S SHREE TAMMANNAPPA CHIKODI  ARTS AND COMMERCE  COLLEGE, BANHATTI",
  "GOVT FIRST GRADE COLLEGE,  BAGALKOT (6012)",
  "BVVS Shri S R Kanthi Arts, Commerce and Science College, MUDHOL",
  "Kakal First Grade Arts and Commerce College",
  "C655 BASAVESHWAR ARTS AND COMMERCE DEGREE COLLEGE MUDHOL TQ SEDAM DIST KALABURAGI",
  "Beary's College of Education, Kodi, Kundapura",
  "BVVS PG DEPT. OF EDUCATION, ,  BAGALKOTE (PG)",
  "Govt. First Grade College, Hiriadka-576113",
  "BASAVESHWARA SCIENCE COLLEGE  BAGALKOT",
  "Rosario College of Management Studies, Cathedral, Mangalore-575001",
  "SRI CHANNAMALLIKARJUNA SANSKRIT COLLEGE, DAVANAGERE",
  "VARDARAJA DEGREE COLLEGE",
  "SIDDAPUR INSTITUTE OF NATUROPATHY AND YOGIC SCIENCES SIDDAPUR",
  "BASEL MISSION CSI HOSPITAL COLLEGE OF NURSING",
  "Pallagatti Adavappa Arts and Commerce First Grade College, Tiptur",
  "K M PATTANASHETTI DEGREE COLLEGE BADAMI",
  "B218 Dr Ambedkar Degree College, Hallikhed",
  "B302 Siddarth College Of Education Bhalki",
  "Shri ramayyaswami Arts and Commerce Degree College Sulebhavi ",
  "Shri Channappanna  Ningappa Nirani GOVERNMENT  FIRST GRADE COLLEGE,  SAVALAGI-587330",
  "B554 Everest Degree College",
  "C326 Mohammadi College of Education Gulbarga",
  "C397 Basaweshwar College Of Education  Jewargi",
  "Mahatma Gandhiji Law College, Sankeshwar",
  "K.L.E. Society Law College, Bangalore",
  "BHAGAWAN BUDDHA LAW COLLEGE,MALAVALLI",
  "VEDA VIJNANA SHODHAÂ  SAMSTHANAM, BANGALORE",
  "SMT .I. S. YADAWAD GOVERNMENT  FIRST GRADE COLLEGE, RAMDURG",
  "VIJAYANAGAR COLLEGE, Hospet.",
  "PADUA COLLEGE OF COMMERCE AND MANAGEMENT, KADRI HILLS, NANTHOOR",
  "R G E SOCITYS ATHARVA AYURVEDA MEDICAL COLLEGE AND HOSPITAL DHARWAD",
  "MATOSRI G C G MEMORIAL WOMENs ARTS COLLEGE, ATHANI",
  "Government First Grade College, Kolar",
  "CHANDRASHEKHAR EDUCATION SOCIETYs FIRST GRADE WOMENs COLLEGE CHETUGUPPA",
  "SADGURU SIDDARUDH WOMEN'S DEGREE COLLEGE, BIDAR",
  "SHRI SHANTESHWAR VIDYA VARDHAK SANGHs CHAITRA WOMENs ARTS COLLEGE, HORTI",
  "SHARADA VIVEK WOMENs COLLEGE, GULBARGA",
  "SRI HAKK BUKK VIDYA VARDHAK SANGHs MATOSRI HOLEYAMMA WOMENs COLLEGE, KUSHTAGI",
  "LINGERI KONAPPA EDUCATION TRUST WOMENs COLLEGE, YADAGIR",
  "SHREE JANANI WOMENs COLLEGE, SHORAPUR",
  "B D E SOCIETYs WOMENs COLLEGE, BIJAPUR",
  "Government First Grade College, Sagar",
  "AKSHARA FOUNDATION NIDAVANI MAHAVIDYALAYA, Station Road, Dharwad 580001",
  "C526  VENKAYYA KUSAYYA GUTTEDAR DEGREE COLLEGE, ALAND",
  "Gogte Institute of Technology, BELGAUM",
  "M S Engineering College, BANGALORE",
  "Proudhadevaraya Institute of Technology, Hospete",
  "Indiragandhi College of Education,Kuvempu Nagar, Hosadurga",
  "GOVT FIRST GRADE COLLEGE BETTADAPURA, PERIYAPATNA (Tq) ",
  " C700 BASAVASHREE COMMERCE DEGREE COLLEGE, JEWARGI",
  "Alvas Evening College",
  "Shri Shivaji Education Societys  Mahasatee Arts, Commerce and Science College, Ulga-Karwar.",
  "Sri Jagadguru Renukacharya College of Science, Arts  and Commerce, #9, Race Course Road, Bengaluru-560009",
  "B.G.S. First Grade College",
  "C560 Paras MSW College, Gulbarga",
  "SRI SATYAM COLLEGE OF EDUCATION BALLARI",
  "Swamy Vivekananda First garde College, M.B.Ayyanahalli. N.H-13.Kudligi(tq).",
  "SHREE MEDHA DEGREE COLLEGE ",
  "SHANTIDHAMA DEGREE EVENING COLLEGE",
  "C594 TAJ DEGREE COLLEGE OF ARTS AND COMMERCE",
  "Dr. N.S.A.M First Grade College, Krishnarajapura Village, Hesaraghatta Hobli, Bengaluru - 560089",
  "Basava Kalyan Engineering College,  BASAVA KALYAN",
  "Guru Nanak Dev Engineering College, BIDAR",
  "M V J College of Engineering, BANGALORE",
  "Bahubali College of Engineering, SHRAVANABELAGOLA",
  "KLE Institute of Technology, HUBLI",
  "Global Academy of Technology, BANGALORE",
  " APS College of Engineering, Kanakapura Road, Somanahalli",
  "Jnana Vikas Institute of Technology, BANGALORE",
  "K V G College of Engineering, SULLIA",
  "Vijaya Vittal Institute  of Technology,  BANGALORE",
  "Don Bosco Institute of Technology, BANGALORE",
  "BMS College of Engineering, BANGALORE",
  "VISIONFLY COLLEGE, VIDYANAGAR HUBBALLI ",
  "SHRI BASAVESHWAR INSTITUTE OF PHARMACY",
  "Government First Grade College, Ayanur",
  "Government First Grade Women's College, Shimoga",
  "Basaveshwara First Grade College Shimoga",
  "C578 BASAVESHWARA ARTS  COMMERCE DEGREE COLLEGE, GULBARGA",
  "CITY COLLEGE OF PHYSIOTHERAPY",
  "RVS COLLEGE OF NURSING SCEINCES",
  "ST.THERESA COLLEGE OF EDUCATION, ALNAVAR",
  "SANJEEVINI COLLEGE OF NURSING BIDAR",
  "Daksha First Grade college ",
  "SAI COLLEGE OF NURSING",
  "K.N  Nagegowda Law College,  Malavalli",
  "VAGDEVI VILAS COLLEGE",
  "D596 KATARKI MAHALINGAPPA DEGREE COLLEGE",
  "Karnataka State Womens University, Extension Centre for PG Studies and Research, Mandya",
  "BHM First Grade College, Besagarahalli",
  "Ambika Mahavidyala Bappalige Puttur",
  "VTU POST GRADUATE AND SKILL DEVELOPMENT CENTRE, TALAKAL",
  "PARIVARTHANA FIRST GRADE COLLEGE",
  "GOVERNMENT MODEL DEGREE COLLEGE, SIDRAMPURA, RAICHUR",
  "SHRI SHANKAR ANAND SINGH GOVERMENT FIRST GRADE COLLEGE, HOSPET.",
  "Carmel College of Nursing",
  "VINOOTHANA WOMENS DEGREE COLLEGE KAMPLI",
  "Hosmat Institute of Medical Sciences",
  "SDS TRC AND RGICD COLLEGE OF ALLIED HEALTH SCIENCES",
  "SHIMOGA INSTITUTE OF MEDICAL SCIENCES  NURSING COLLEGE",
  "DR. GURACHAR NARGUND COLLEGE OF PHARMACY",
  "SANJO COLLEGE OF NURSING",
  "MVJ DEGREE COLLEGE ",
  "Smt. Somavva Channabasappa Angadi, Government First Grade College  K.K.Koppa",
  "D S R ULLAH INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "L. C. R. Indian Degree College, Kakyapadavu, Post: Uli, Bantwal-574326, D.K.",
  "SRI SHANKARA CANCER HOSPITAL AND RESEARCH CENTRE",
  "GOVERNMENT FIRST GRADE COLLEGE BASAVANAGUDI BANGALORE",
  "ALVAS COLLEGE OF ALLIED HEALTH SCIENCES",
  "S B D INSTITUTE OF PHARMACY",
  "SWETHA COLLEGE OF NURSING",
  "JYOTHY INSTITUTE OF COMMERCE AND MANAGEMENT",
  "SACRED HEART COLLEGE OF NURSING",
  "VIDYA SIRI COLLEGE OF PHARMACY",
  "JAIHIND DEGREE COLLEGE",
  "SAI VIDYA FIRST GRADE COLLEGE",
  "INDIRA MAHILA MANDHALS MATOSHRI MAHADEVI MALABAGI ARTS COLLEGE",
  "THE RK COLLEGE OF NURSING",
  "VYDEHI INSTITUTE OF PHYSIOTHERAPY ",
  "GREEN CITY COLLEGE OF PHARMACY ",
  "DMJ INSTITUTE OF NURSING SCIENCE",
  "MOUNT SHEPHERD COLLEGE OF NURSING",
  "HKBK COLLEGE OF PHYSIOTHERAPY",
  "GRAND COLLEGE OF NURSING BIDAR",
  "BEARYS ENVIRO ARCHITECTURE DESIGN SCHOOL MANGALORE",
  "ISBR EVENING COLLEGE",
  "MAHALASA SCHOOL OF ART",
  "EDURITE COLLEGE OF FASHION TECHNOLOGY AND COMMERCE WOMENS DEGREE COLLEGE",
  "KENGAL HANUMANTHAIAH INSTITUTE OF PHYSIOTHERAPY",
  "MOODLAKATTE COLLEGE OF NURSING",
  "BANGALORE LITTLE FLOWER COLLEGE OF NURSING",
  "INDIRA COLLEGE OF ALLIED HEALTH SCIENCES PHYSIOTHERAPY TECHNOLOGY",
  "RAJEEV COLLEGE OF ALLIED HEALTH SCIENCES",
  "Govt. First Grade College, Kadugudi, Bangalore -560 067.",
  "Vidyabharati Foundation, IBMR College of BBA BCA BCOM  POST GRADUATE STUDIES IN COMMERCE MANAGEMENT  Akshay Colony, Vidyanagar, Hubballi",
  "SRI LAKSHMI COLLEGE OF ALLIED HEALTH SCIENCES",
  "SIDDHARTH ARTS AND COMMERCE DEGREE COLLEGE BIDAR",
  "Vishwabharathi College of Nursing",
  "R G INSTITUTE OF COMMERCE AND MANAGEMENT",
  "C540 SHARANESHWARI RESHMI DEGREE COLLEGE",
  "C573 SURABHI DEGREE COLLEGE OF ARTS AND COMMERCE, SEDAM",
  "C541 SHRI B.S.RESHMI DEGREE COLLEGE",
  "Shridevi Institute of Medical Sciences And Research Institute ",
  "SVNK COLLEGE OF COMMERCE AND MANAGEMENT",
  "C566 SWAMY VIVEKANAND MSW COLLEGE SEDAM",
  "St.Josephs College of Commerce,  # 5031, Museum Road, Banglore 25. (Autonomous)",
  "SRI.VENKAT FIRST GRADE EVENING COLLEGE",
  "C545 Shri Guru Degree College",
  "Sridevi Post Graduate Centre",
  "Navodaya First Grade College, Chikkanayakanahalli",
  "Bapuji First Grade College",
  "C576 TNR ARTS DEGREE COLLEGE GULBARGA",
  "KSSs B.S.W. College Hubli.",
  "Mallikarjuna Arts & Commerce College, Siddar-Karwar.",
  "KLE's Arts & Commerce College, Gadag-Betageri",
  "Channabasamma Eshwargouda Chikkanagouda (CIC) Grameen Shikshana Samste CIC Arts & Commerce College, Adaragunchi Tq -Hubli",
  "TMC Muncipal Arts & Commerce College Laxmeshwar.Tq: Shirahatti",
  "Priyadarshini Janasevasagara Siri BSW College, Aare Angadi Tq Honnavar",
  "Shri, Jagadguru Renekacharya group Education Society, Shri Jagadguru Renukacharya Education College, Noolvi",
  "KLEs Institute of Management Studies & Research, Vidya nagar, Hubli",
  "Good News Welfare Society, Arts and Commerce First Grade College, Kalaghatgi-581204",
  "Shri. Yadiyur Siddalingeshwar First Grade College, Naragund Dist  Gadag",
  "KKS B.S.W.College, Gadag-Betageri.",
  "Rajiv Gandhi Shikshana Samsthes College of Physical Education Ron.",
  "V.H Marad M.Ed College, Sattur, Dharwad",
  "Priyadashrini Janaseva Sagar Sansthe Maharani Arts & Commerce  College, Gurunath Nagar, Old  Hubli-24",
  "Sri.  Rambapuri Jagadguru Veeragangadhar Arts & Commerce College, Shiggaon",
  "Indian Institute of Inspirational Leadership for Rural Development, surashettikoppa (Tq:Kalaghatgi)",
  "KVVS J.P.College of Education, Gadag",
  "Govt., First Grade College, Haveri",
  "KCS Dr.A.V.Baliga Arts & Science College, Kumta. (N.K.)",
  "Sukurti Commerce College, Hubli",
  "J.T.Vidya Peethas Shree Basaveshwar Arts & Commerce College,Gadag",
  "CSTE SOCIETY'S  SSN ARTS AND COMMERCE COLLEGE, HUKKERI",
  "Hulkoti Sahakari Shishna Samste, H.S.S.S, College of Computer Application, Gadag",
  "JMJ  Commerce College Chippagi Sirsi",
  "Priyadarashni College of Education Mundargi. Dt:Gadag.",
  "GVVSs S.M.Bhoomaraddi Arts & Commerce College, Gajendragad. Tq: Ron.",
  "SSK Shri. Tulajabhavani Education society's SSK Arts & Commerce College, MT Mill Road, chanukya puri, Hubli - 24",
  "Govt. First Grade College, Gudibande-561 209, Chikkaballapur Dist.",
  "HINDUSTAN COLLEGE NO 27/F INDUSTRIALSUBRUB  J P NAGAR MYSORE-570008",
  "Manorama College of Computer Application, K. C. Rani Road, Hatalgeri Naaka, Vidyanagar, Massari, Gadag.",
  "MGP COLLEGE OF PHYSIOTHERAPY",
  "Government First Grade College, Chikkanayakanahalli",
  "Sri Siddartha Arts, Science and Commerce First Grade College",
  "R.Muddarangegowda College of Education, Sira",
  "Sri Siddartha Institute of Management Studies",
  "Divya College of Education",
  "Sri Ranganatha First Grade College, Sira",
  "Sree Siddaganga  College of Arts, Science and Commerce",
  "Swamy Vivekananda First Grade College, Pavagada",
  "RNS EVENING COLLEGE",
  "KOSHYS INSTITUTE OF ALLIED HEALTH SCIENCES",
  "MOUNT CARMEL COLLEGE OF NURSING",
  "VARADARAJA INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
  "SIGMA COLLEGE OF NURSING ",
  "SRI SUBHADRA COLLEGE OF NURSING ",
  "UNITY COLLEGE OF ALLIED HEALTH SCIENCES",
  "HERITAGE CITY COLLEGE OF NURSING",
  "PRAJNA COLLEGE OF NURSING SAKLESHPUR HASSAN",
  "CIMS COLLEGE OF NURSING",
  "CHAMARAJANAGAR INSTITUTE OF MEDICAL SCIENCES ALLIED HEALTH SCIENCES",
  "SRI RAGHAVENDRA COLLEGE OF PHARMACY  CHITRADURGA  ",
  "KUNDAPURA RURAL AYURVEDA MEDICAL COLLEGE AND HOSPITAL",
  "HOSABELAKU FIRST GRADE COLLEGE",
  "SHREE GOPALDEV JADHAV COLLEGE OF NURSING KALABURAGI",
  "Government First Grade College of Arts, Science and Commerce, Sira",
  "HIMA INSTITUTE OF NURSING SCIENCES HOSAPETE",
  "SHREE GAVISIDDHESHWARA COLLEGE OF NURSING",
  "B557 PRAGATI MCOM PG COLLEGE",
  "MUNIYAL INSTITUTE OF YOGA AND NATUROPATHY MANIPAL",
  "B.V.V.Sangha's BASAVESHWAR COMMERCE,COLLEGE,  BAGALKOT",
  "BASAVESHWAR VEERSHAIVA VIDYAVARDHAK SANGHAS BASAVESHWAR ARTS SCIENCE AND COMMERCER COLLEGE, BAGALKOT",
  "S J G V V C S's BSW COLLEGE   GULEDAGUD",
  "N S G A SAMSTE's NETAJI BSW COLLEGE,  MADHOL",
  "BHOMI SEVA SANSTHE DR.B R HIREMATH BSW COLLEG, MADHOL",
  "SREE KANAKDAS BSW COLLEGE, HUNGUND, BAGALKOT",
  "SURAKSHA COLLEGE OF NURSING",
  "SHRI SIDDHARAMESHWARA VIDYAVARDHAK SANGHA SHRI MALIYAPPAYYASWAMI ARTS COLLEGE, GADDANAKERI",
  "SHRI HOLE HUCCHESHWARA EDUCATION AND COLLEGE DEVELOPMENT SOCIETY, GULEDGUDD, BADAMI",
  "BLDEA'S COMMERCE, B H ARTS & TGP SCIENCE COLLEGE, JAMKHANDI (PG)",
  "BLDEA'S BBA COLLEGE,  JAMAKHANDI",
  "BASAVESHWAR COLLEGE OF PHYSICAL EDUCATION,  BAGALKOTE (PG)",
  "Sri. Gavisiddeswara College of Education, Koppal.",
  "SHRADDHA INSTITUTE OF NURSING SCIENCES VIJAYAPUR",
  "GOVERNMENT LAW COLLEGE, CHAMARAJANAGARA",
  "ADROIT ACADEMY ",
  "S J GLOBAL DEGREE COLLEGE",
  "SUVARNA FIRST GRADE COLLEGE",
  "PRAKRUTHI DEGREE COLLEGE",
  "MYCAS COLLEGE OF PROFESSIONAL STUDIES",
  "BANGALORE COLLEGE OF ARTS AND SCIENCE",
  "SRI RAMA NURSING COLLEGE",
  "KIRLOSKAR INSTITUTE OF ADVANCED MANAGEMENT STUDIES",
  "S S SAINATH COLLEGE OF PHARMACY",
  "DR S V TOTAGANTIMATH COLLEGE OF NURSING GADAG",
  "RATNADEEP COLLEGE OF ALLIED HEALTH SCIENCES HUBBALLI",
  "ASTER COLLEGE OF NURSING",
  "ROYAL PALACE DEGREE COLLEGE, JAMKHANDI    ",
  "NEELSAROJ INSTITUTE OF PHARMACY ",
  "SURAKSHA COLLEGE OF NURSING",
  "DIVINE INSTITUTE OF NURSING SCIENCES",
  "MVM COLLEGE OF NATUROPATHY AND YOGIC SCIENCE",
  "NAGESH  COLLEGE OF NURSING",
  "ABHINAVA BHARATHI COLLEGE OF PHARMACY",
  "SRI GANGOTHRI COLLEGE OF NURSING",
  "Keerthi College of Nursing",
  "AADYA COLLEGE OF PHARMACY",
  "BBC COLLEGE OF NURSING GANGAVATHI",
  "SHRI GURU MAHALINGESHWAR ARTS DEGREE COLLEGE RANNA BELAGALI    ",
  "NOORIE COLLEGE OF PHARMACY",
  "HARSHA COLLEGE OF PHARMACY ",
  "SWASTIKA NATIONAL BUSINESS SCHOOL",
  "NOBLE LAW COLLEGE",
  "Seshadripuram First Grade College, Yelahanka New Town, Bangalore-64",
  "CHIKKABALLAPURA INSTITUTE OF ALLIED HEALTH SCIENCES",
  "SHRI JAGADARADHYA JAYASHANTHALINGESHWARA EDUCATION SOCIETY  SHRI JAGADARADHYA JAYASHANTHALINGESHWARA DEGREE ARTS COLLEGE",
  "GOVERNMENT FIRST GRADE COLLEGE HARUGERI",
  "GOVERNMENT FIRST GRADE COLLEGE, NIPPANI",
  "Harward Institute of Management & Science, Dasanapura Village, Bangalore Tumkur Highway, Bangalore Noth",
  "Dr. D. G. Shetty Edn. Society's Rukmini Shetty Memorial Sudhakar Shetty  B.C.A College Dharwad.",
  "GOVERNMENT FIRST GRADE COLLEGE FOR WOMEN, PAVAGADA",
  "ACHARYA PATHASALA COLLEGE OF COMMERCE",
  "Gnana Jyothy Town Mahila Samaja First Grade College",
  "CONSTITUTE COLLEGE OF VTU    ",
  "C320 GOVERNMENT FIRST GRADE COLLEGE, JEWARGI",
  "Government College for Women, Chintamani-563125",
  "K V HANCHINAL COLLEGE OF NURSING ",
  "VIJATA VITTALA INSTITUTE OF MANAGEMENT AND SCIENCE",
  "Amareshwar Arts And Commerce Degree College Aurad(B) Dist Bidar",
  "BLDE Associations S B ARTS AND KCP SCIENCE COLLEGE VIJAYAPUR",
  "Govt., First Grade College, Sandur - 583 119.",
  "Govt First Grade College, Kurugodu.",
  "Post Graduate Center, Nandihalli, Sandur",
  "TMAE Society's College of Education, Gangavathi - 583 227.",
  "Srikari Degree College, Hospet - 583 201",
  "Smt. Rudramba M.P. Prakash Govt., First Grade College, Huvinahadagali-583219,",
  "Krishna Sai College, Hospet - 583 201.",
  "Yenepoya Physiotherapy College",
  "Yenepoya Medical College",
  "Yenepoya Nursing College",
  "Yenepoya Dental College",
  "Sri. Siddalingeswara First Grade College, Khanamadugu.",
  "Gangaothri B.S.W. Degree College, Kottur-583 134",
  "GOVERNMENT COLLEGE OF NURSING DISTRICT HOSPITAL CHITRADURGA",
  "Kumari G. Sudha Shankara Gouda Memorial Theosophical College of Management, Hospet - 583 201.",
  "Sri. Gavisiddeswara Arts, Science & Commerce College, Koppal - 583 231.",
  "Ward Law C.S.I. College, Bellary",
  "Jnana Bharati Degree College, Siruguppa - 583 121",
  "Jnana Bharathi college of Education, Kudligi - 583 135.",
  "S A NINGOJI WOMENS FIRST GRADE COLLEGE DADEGAL KOPPAL",
  "SHRI BASAVESHWAR RURAL EDUCATION AND DEVELOPMENT TRUST SHRI BASAVESHWAR ARTS SCIENCE AND COMMERCE COLLEGE SATTUR DHARWAD ",
  "SHRI BASAVESHWARA AYURVEDIC MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE",
  "MANDYA INSTITUTE OF NURSING SCIENCES ",
  "Sri. H.R. Sri Ramulu Memorial College, Gangavathi.",
  "DR RAVI PATIL AYURVEDIC MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE BELAGAVI",
  "Veerashaiva College, Bellary",
  "Kotturswamy College of Teacher Education, Bellary - 583 103.",
  "Sri. Guruthipperudra College, Gandhinagar, Bellary - 583 103.",
  "Govt First Grade College, Siruguppa",
  "Govt. First Grade College, Kampli",
  "Govt First Grade College, Mariammanahalli.",
  "Kottureshwara Degree College, Kottur.",
  "Government First Grade College,,Harapanahalli",
  "Arasikere Hikkimagere Ajjappa Halamma First  Grade college Arasikere (p) Harapanahalli (t) Davanagere (d) ",
  "ADB First Grade College, Harpanahalli",
  "Govt First Grade College, Moka",
  "Tungabhadra B.Ed, College, Kottur - 583134",
  "B. SHANKARANAND NATIONAL ARTS COLLEGE,  GHATAPRABHA",
  "SRI V V SS VERESHWAR V V SANGHAS COLLEGE OF EDU., NALATWAD",
  "KLE SOCIETYS COMMERCE COLLEGE,  RAIBAG",
  "SPM S P PHYSICAL EDU,COLLEGE (BP.ED) ,  RAIBAG",
  "THE ADARSH EDU., SOCIETY'S ADARSH ARTS/COMM COLLEGE,SAVADATTI",
  "Smt. Honnuramma Late M.Siddappa Government  First Grade College, Tekkalakote - 583122.",
  "M S SCIENCE AND COMMERCE COLLEGE",
  "NEELGANGA AYURVEDIC MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE ",
  "JK College of Commerce, Santosha Nagar, Hubli",
  "Soukhya College of Education, Bhatkal, Dt: Karwar.",
  "Govt., First Grade College Mundagod",
  "Janata Shikshna Samitis J.S.S Shri. Manjunatheshwar B.Ed College, Dharwad.",
  "Diaosis Board of Education & Welfare Fathima College of B.C.A. Keshwapur, Hubli-580023",
  "SJMV Mahant 1st Grade Arts & Commerce College, Rayapur, Dharwad.",
  "National Science & Arts Degree college for women Gulbarga",
  "Sri Hucheshwar Vidyavardhak Sanghas, Education College for Women, Kamatgi",
  "Godutai College of Education for women, Sharananagar, Gulbarga-585103",
  "Kudal Sangam Education Societies Arts College for Women, Shahabad-585 228",
  "T M A E  SOCIETYS SRI CHANDRAMOULESHWARA SWAMIJI INSTITUTE OF NURSING SCIENCES HARAPANAHALLI ",
  "SECAB LAW COLLEGE, VIJAYAPURA",
  "ALLAMPRABHU COLLEGE OF PHARMCY BASAVAKALYAN",
  "GNYANA SUDHA COLLEGE OF NURSING",
  "B293 DR PRASHANT MASHETTY BUSINESS MANAGEMENT COLLEGE BIDAR",
  "B556 Shree Veerabhadreshwar MSW PG College Basavakalyan",
  "Sri. Pampanna Sharanappa Guggalashetty, Govt., First Grade College, Kanakagiri.",
  "MEDI CARE INSTITUTE OF NURSING SCIENCES",
  "K S COLLEGE OF NURSING KOPPAL",
  "FALCON DEGREE COLLEGE    ",
  "Smt. Gundamma Basappa Yelburgi samanya shikshana samstha's Arts college for women Koppal",
  "Matoshri Kantamma Sanganagouda Patil (Sasnoor) College of Education for women, Hirur   (Dist: Bijapur)",
  "Anjuman-E-Islam committee's Anjuman Degree College for Women,Muddebihal- 586212",
  "Akkamahadevi Mahila Mahavidyalay BIDAR",
  "Nagambika Educational & Charitable trust's Degree college for women Gulbarga",
  "SJMV's Business Administration College for Women J.C.Nagar, Hubli-580 020",
  "Indian College of Education for women, Kamthan Road, Chidri-Bidar-585403",
  "Anjuman Arts College for Women Koulpet,  Hubli-580 020",
  "S.J.M.V: B.A.J.S.S Arts & Commerce College for Women Church Road, Post Box No:52, Ranebennur-581 115",
  "Mumbai Karnataka Education Trust's Education College for Women, Ranebennur-581115",
  "VAISIRI FIRST GRADE COLLEGE    ",
  "SHRI K R H VIDYA VARDHAKA SANGHS SMT PARVATEVVA KADAPPANNA HUKKERI FIRST GRADE ARTS AND COMMERCE DEGREE COLLEGE GHATAPRABHA",
  "AVK College for Women, Hassan",
  "PATIL DEGREE COLLEGE FOR WOMEN SINDHANUR",
  "B289 SIDDARTH COLLEGE OF EDUCATION",
  "SKANDA INSTITUTE OF NURSING DAMMUR",
  "SHREE BHAGYAVANTI COLLEGE OF NURSING TALIKOTI",
  "GREEN CITY DEGREE COLLEGE",
  "METROUNITED NURSING COLLEGE",
  "Central Commerce College",
  "P S E DEGREE COLLEGE",
  "Vinootana Shikshana Seva samsthe's surabhi women's Education college B.Ed Munirabad  583234",
  "Sharda Arts &  Commerce College for Women, Adarsh Colony,           Sindhanoor-584 128",
  "Sri. Gurubasappa Revansidappa Goled Arts & Commerce College for Women, Shahabad",
  "GOLDEN FIRST GRADE COLLEGE",
  "Secab's ARS Inamdar Arts, Science & Commerce college for women Bijapur",
  "Sri. Shivalingeshwar Degree College for Women,  Haveri-581 110",
  "GNYANA GANGA COLLEGE OF NURSING BIDAR",
  "Al Aziz welfare charitable trust's AIM College of Education for Women ,Bidar",
  "Smt. Ahalyabai A. Patil Arts & Commerce College for Women, Chikkodi- 591201",
  "Sri siddrameshwar Education society's chandrageri college of Education for Women Shivabasava nagarBelguam-591 102",
  "Bharathi College of Nursing",
  "ANIMAL HUSBANDRY POLYTECHNIC KUNNUR SHIGGAON HAVERI DISTRICT KARNATAKA",
  "SPOORTHI COLLEGE OF NURSING",
  "NDRK First Grade College ,,Hassan",
  "THE DALAI LAMA INSTITUTE FOR HIGHER EDUCATION",
  "BVVS SHARADAMBE INSTITUTE OF NURSING SCIENCES VIDYAGIRI BAGALKOTE",
  "VRET COLLEGE OF PHYSICAL EDUCATION",
  "VIKRAM COLLEGE OF PHYSIOTHERAPY",
  "Anjuman Education College, Bhatakal",
  "CHIKKABALLAPURA INSTITUTE OF MEDICAL SCIENCES",
  "ANJANI LAW COLLEGE     ",
  "SHRI VARCHAS NURSING COLLEGE",
  "DR SAROJINI SHINTRI COLLEGE OF COMPUTER APPLICATION AND BUSINESS ADMINISTRATION DHARWAD    ",
  "ADICHUNCHANAGIRI COLLEGE OF AGRICULTURAL SCIENCES    ",
  "SHRI SHARADHAMBA BCA DEGREE COLLEGE",
  "SAMYAK JNANA SCHOOL OF LAW",
  "B276 Shantivardhak College of Education Bidar",
  "BRAHMARI INSTITUTE OF NURSING AND HEALTH SCIENCES HONNAVAR",
  "DEVANGA SANGHA COLLEGE OF LAW     ",
  "IMJ INSTITUTE OF SCIENCE AND COMMERCE ",
  "SRI ADARSHA COLLEGE OF NURSING",
  "SRI S KARIAPPA COLLEGE OF AGRICULTURE    ",
  "Arunodaya Institute of Legal Studies, Bangalore",
  "Vivekananda College of Law, Bangalore",
  "Karnataka Law College, Gulbarga.",
  "M.S. Ramaiah College of Law, Bangalore",
  "Al-Ameen College of Law, Bangalore",
  "B.V. Bellad Law College, Belgaum.",
  "Basavashree College of Law, Kolar",
  "J.S.S. Law College, Mysore",
  "Sarvodaya Law College, Bangalore",
  "Bishop Cotton Women Christian Law College, Bangalore",
  "J.N.R. Ladda Law College, Sedam",
  "Vaikunta Baliga College of Law, Udupi.",
  "K.L.E. Society Law College, Chikodi",
  "Sree Krishna Institute of Law, Tumkur",
  "Shri. Laxmanrao Jarkihole Law College, Gokak.",
  "Seth Shankarlal Lahoti Law College, Gulbarga",
  "Kurunji Venkatramana Gowda Law College, Sullia",
  "B.L.D.E. Association Law College, Jamkhandi.",
  "Teachers Law College, Bangalore",
  "Shri Dharmasthala Manjunatheshwara Law College and Centre for Post Graduate Studies and Research In Law, Mangaluru",
  "Vidyavardhaka Law College, Mysore",
  "H.V. Koujalagi Law College, Bailhongal",
  "S.J.M. Law College, Chitraduraga",
  "S.C. Nandimath Law College, Bagalkot",
  "S.B.R.R. Mahajan Law College, Mysore",
  "B.E.S. College of Law, Bangalore",
  "C312 S.B College of Science Gulbarga",
  "C433 Government First Grade College, Mahagaon Cross",
  "Government Law College, Salgame Road, Hassan",
  "C. Bhimasena Rao National College of Law, Shivamogga",
  "SIRIGERI D VENKOBA SETTY MEMORIAL COLLEGE OF NURSING GANGAVATHI",
  "Government Law College, Ramanagara.",
  "C416 Vivekananda BBM/BCA Inst of Mgmt Gulbarga",
  "D432 AMES Science Degree College Raichur",
  "Basaveshwar College of Education Bidar",
  "C403 Ganga Parameshwari College of Education Chittapur",
  "C341 National Degree College Gulbarga",
  "C496 Sri Saibaba Degree college",
  "P.E.S. Law College, Mandya.",
  "Vivekananda Law College, Puttur",
  "M.E.S. Law College, Sirsi",
  "Anjuman Law College, Bijapur",
  "C335 Govt F G Degree College,Sedam",
  "C310 SHARANABASAVESHWAR COLLEGE OF ARTS, KALABURAGI",
  "R D S  BSW COLLEGE,  MUDALAGI",
  "RAJESHWARI KARPURMATH MEMORIAL RKM COLLEGE OF NURSING ",
  "MESs College of Commerce, Sirsi.",
  "Govt. First Grade College, Kalaghatagi.",
  "K.L.E Socities K.F. Patil Institute of Business Administration,  Ranebennur Dist  Haveri",
  "KSSs Arts & Commerce College Hubli",
  "D.C.Pavate Education College, Gadag.",
  "Shree Prabhurajendra College of Physical Education, Gadag.",
  "TAPASYA DEGREE COLLEGE KR PURAM",
  "GS COLLEGE OF MANAGEMENT",
  "Manorama College of Business Administarion, K. C. Rani Road Hatalgeri Naaka, Vidyanagar, Masaari, Gadag.",
  "Bangalore Baptist Hospital ",
  "RAJARAJESWARI INSTITUTE OF ALLIED HEALTH SCIENCES",
  "SRI NANAK JHIRA SAHEB FOUNDATION, GURU NANAK COLLEGE OF PHARMACY, BIDAR",
  "Karnatak Science College, Dharwad",
  "C597 SHIVASHANTALA ARTS AND COMMERCE FIRST GRADE COLLEGE YADRAMI",
  "C708 SRI SHANTALA ARTS COMMERCE AND SCIENCE DEGREE COLLEGE JEWARGI",
  "K.L.E. Society's Shri Mrityunjaya College of Arts and Commerce, Dharwad",
  "BRIGHT BUSINESS SCHOOL, HUBLI     ",
  "Karnatak Arts and Commerce College, Dharwad",
  "OM SAI DEGREE EVENING COLLEGE",
  "VARASIDDHI VINAYAKA FIRST GRADE COLLEGE KERADI",
  "University College of Fine Arts and Music, Dharwad",
  "AVK Institute of Management",
  "Excellent Degree College",
  "Mallige College of Nursing",
  "Colaco college B.Sc Medical Laboratory Technology",
  "LOYOLA DEGREE COLLEGE",
  "SHRI LAXMANRAO JARKIHOLI ARTS/SCIE/COMM COLLEGE,  GOKAK",
  "MES'S ARTS AND COMMERCE  COLLEGE, MUDALAGI",
  "SVVSS SRI SHANKARAPPA REVAPPA MALAGI ARTS COLLEGE,  TAMBA",
  "KGSS HEMARADDH  ARTS/COMM/SCI COLLEGE,   TIDAGUNDI",
  "VIDYAPANA LAW COLLEGE",
  "IBMR LAW COLLEGE SHEREWAD PALE HUBBALLI DHARWAD",
  "SKPVS'S ARTS COLLEGE,  LONE B.K.",
  "Shri Sahasrarjun B.Ed. College, Hubli Road, near ramageri,  Laxmeshwar - 582 116",
  "JALAPPA LAW COLLEGE",
  "Deyosis Board of Education & Social Welfare Trust, Our Lady of Fatima College of Commerce, Keshawapur, Tq - Hubli",
  "Shri. Guru Sudhindra B.B.A College, Ayodya Nagar, Bhatakal Dt- Karwar",
  "Govt., First Grade College, Gudgeri,(Tq:Dharwad)",
  "D535 FEDERAL DEGREE COLLEGE YARAMAS CAMP",
  "SHREE SWAMI VIVEKANANDA DEGREE COLLEGE PWD CAMP SINDHANUR ",
  "D599 NAVAYUGA MSW COLLEGE RAICHUR",
  "D595 S E C T POST GRADUATE COLLEGE RAICHUR",
  "D593 SMT R RAJESHWARI R TIMMAYYA SHETTY M.COM COLLEGE MANVI",
  "D584 NAMMA MANVI DEGREE COLLEGE MANVI, RAICHUR",
  "D560 SHIVASHARANE HEMARADDY MALLAMMA ARTS DEGREE COLLEGE, RAICHUR",
  "D559 S.B.E.R.D.S M.S.W COLLEGE, MANVI, RAICHUR",
  "D594 PRESIDENCY ARTS AND COMMERCE DEGREE COLLEGE MASKI",
  "D582 SRI VIRAT DEGREE COLLEGE YAPALADINNI",
  "C713 SWAMI VIVEKANANDA MSW PG COLLEGE SHAHAPUR",
  "B269 Govt First Grade Degree College,Manhalli",
  "C691 SSRS DEGREE COLLEGE YADGIR",
  "C690 PRAGATI DEGREE COLLEGE YADGIR",
  "C687 CHAITANYA DEGREE COLLEGE GURUMATKAL",
  "C682 GOKUL DEGREE COLLEGE SHAHAPUR",
  "C678 LKET MA POLITICAL SCIENCE PG COLLEGE YADGIRI",
  "SHRI SIDDALINGESHWARA P G COLLEGE YADGIR",
  "GOVERNMENT FIRST GRADE COLLEGE SHORAPUR",
  "C731 PRIYANK MSW PG COLLEGE",
  "C725 ADARSH ARTS AND COMMERCE DEGREE COLLEGE YADGIR",
  "C720 NALANDA DEGREE COLLEGE YADGIR",
  "C717 PRAGATI DEGREE COLLEGE SHAHAPUR",
  "C702 YASHODHA DEGREE COLLEGE YADAGIRI",
  "C675 SMC JAIN B.Ed COLLEGE SHAHAPUR",
  "C714 SRI S B DESHMUKH MSW COLLEGE",
  "C685 SHRI YAMAREDDY MUNDAS DEGREE COLLEGE YADAGIRI",
  "C683 BAPUGOUDA DEGREE COLLEGE, KEMBHAVI, SURPUR,YADGIR",
  "SPANDANA COLLEGE OF NURSING, SHAHAPUR",
  "KALIDASA INSTITUTE OF LAW",
  "C676 DEVAGIRI FIRST GRADE COLLEGE SHAHAPUR  ",
  "Indira Gandhi College of Nursing",
  "Krupanidhi College of Pharmacy",
  "V.V. Pura Institute of Pharmaceutical Sciences",
  "C669 PRIYADARSHINI DEGREE COLLEGE, RANGAMPET, YADGIR",
  "C666 MAHARAJ ARTS AND COMMERCE DEGREE COLLAGE YADGIRI",
  "Bethel Medical Institute of Nursing Sciences",
  "C665 KANNADAMBE DEGREE COLLEGE, SHAHAPUR, YADGIR",
  "BASAVESHWAR ARTS  COMMERCE AND SCIENCE COLLEGE INDI",
  "C663 BILLAV ARTS DEGREE COLLEGE SHAHAPUR DIST YADAGIR",
  "C662 SHREE BASAVAPRABHU DEGREE COLLEGE KODEKAL ",
  "C659 ARUNDHATI DEGREE COLLEGE, SHORAPUR, YADGIR",
  "C658 SWAMI VIVEKANAND DEGREE COLLGE, RANGAMPET DIST YADAGIRI",
  "C649 AKHILA KRNATAKA SNEHA GANGA VAHINI ARTS AND COMMERCE COLLEGE",
  "Shree Benakappa Shankrappa Simhasanad Government First Grade College, Gajendragad. ",
  "Acharya Institute of Allied Health Sciences Soladevanahalli Bengaluru",
  "HCG BANGALORE INSTITUTE OF ONCOLOGY",
  "SHRI VEER PULIKESHI RURAL AYURVEDIC MEDICAL COLLEGE BADAMI",
  "Basavashree Institute of Education",
  "Government First  Grade College, Honnavar  - Uttara Kannada District - 581334",
  "EAST WEST COLLEGE OF ENGINEERING, Bengaluru",
  "C657 Priyank Degree College Shahapur",
  "Greencity Degree College Bangalore",
  "Institute of Bioinformatics and Applied Biotechnology",
  "SVN College of Nursing Gayathrinagar Bangalore",
  "JNANA SAROVARA FIRST GRADE COLLEGE",
  "SRI GURU SAI FIRST GDADE COLLEGE",
  "SHRI. VRUSHABHENDRA EDUCATION SOCIETY'S, B. R. DARUR FIRST GRADE COLLEGE,  HARUGERI",
  "PRAKRUTHI COLLEGE OF ALLIED HEALTH SCIENCES",
  "SRI VISHWA VIVEKA FIRST GRADE COLLEGE ",
  "MARUTHI DEGREE COLLEGE",
  "AMARA JYOTHI DEGREE COLLEGE  MULBAGAL",
  "JESSE DEGREE COLLEGE",
  "Cambridge College",
  "C643 VIVEK JAGRUTI PG COLLEGE KALABURAGI",
  "PRAGATHI DEGREE COLLEGE",
  "Anirudh College of Nursing",
  "O P JINDAL COLLEGE OF NURSING",
  "SAHYADRI DEGREE COLLEGE",
  "GOVERNMENT FIRST GRADE COLLEGE, BIDI.,  KHANAPUR TQ.",
  "Vidya Vikas College of Nursing",
  "VIDYAVANA FIRST GRADE COLLEGE",
  "SRI VIVEKANANDA DEGREE COLLEGE ",
  "Sankara College of Optometry",
  "C637 SRI BALAJI M.A HISTORY P.G COLLEGE, SAIDAPUR",
  "Cresent College of Education, KK Doddi, Ramanagaram",
  "K.T.G AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "CHAUSON EDUCATION COLLEGE, CHIKKODI (PG)",
  "CHAUSON COLLEGE OF EDUCATION, CHIKKODI",
  "Huliyappa Mallamma Bed College",
  "MQI COLLEGE OF MANAGEMENT",
  "BMS COLLEGE OF COMMERCE AND MANAGEMENT",
  "BBMP FIRST GRADE COLLEGE FOR WOMEN CLEVELAND TOWN FRAZER TOWN BANGALORE",
  "C632 ORIENT M.S.W. COLLEGE, YADGIR",
  "C631 IMPERIAL DEGREE COLLEGE, GURUMITHKAL, YADGIR",
  "Shri Kengal Hanumanthaiya Law College, K.G.F.",
  "Indira Priyadarshini College of Law, Bangalore",
  "C627 SRI. NEELKANTHA DEGREE COLLEGE, SHORAPUR, YADGIR",
  "The Yenepoya Institute of Arts Science Commerce and Management ",
  "Yenepoya Ayurveda Medical College and Hospital",
  "C711 MAHATMA GANDHI MSW COLLEGE AFZALPUR KALABURAGI",
  "C616 NAGAMBIKA ARTS AND COMMERCE DEGREE COLLEGE NEHAR GUNJ HUMNABAD ROAD KALABURAGI",
  "C730 SALVIN  MSW COLLEGE KALBURAGI",
  "MANGALA COLLEGE OF PHYSIOTHERAPY",
  "Manjunatha College of Physiotherapy",
  "Manjunatha College of Paramedical Sciences ",
  "NEW PRAGATHI COLLEGE OF NURSING",
  "NEW PRAGATHI COLLEGE OF PHYSIOTHERAPY",
  "BVVS HOMOEOPATHIC MEDICAL COLLEGE  HOSPITAL",
  "N A Global Law School",
  "The Oxford College of Education, 1st Phase, J.P. Nagar, Bangalore -78.",
  "C624 SRI GURUKULA BA, B.COM DEGREE COLLEGE RANGAMPET",
  "ARIHANT INSTITUTE OF COMMERCE AND MANAGEMENT",
  "TAPASYA DEGREE COLLEGE",
  "RMS INSTITUTE OF MANAGEMENT AND SCIENCE",
  "AADYA AVIATION COLLEGE",
  "SAMRUDDHI DEGREE COLLEGE",
  "VIDYANIDHI INSTITUTE OF COMMERCE AND MANAGEMENT STUDIES",
  "Shri  Ramakrishna Arts and Commerce College  Ap Arakeri",
  "Swami Vivekananda Arts And Commerce Degree College Ap Muddebihal",
  "Netaji Subhashandra Bhose Degree College Vijaypur",
  "BANAJAWAD DEGREE COLLEGE ATHANI",
  "shri siddeshwar societys s p uppin commerce management and science college kavalagi ",
  "SHRI SHARADA SCIENCE COLLEGE",
  "Suvarna Devendra Nayak Degree College Yaragatti",
  "Devendra Bhimappa Nayak Commerce Degree College Yaragatti",
  "SBJ ARTS AND COMMERCE COLLEGE VIJAYAPUR",
  "ABHYUDAYA SCIENCE AND COMMERCE DEGREE COLLEGE MUDDEBIHAL",
  "Shri Mahant Shivayogi Arts and Commerce College Ap Arabhavimath",
  "Shri Siddalingeshwar Vidya Peeth Trust College of Education",
  "Bhavani management school BBA college ",
  "KALPAVRUKSHA DEGREE COLLEGE MORATAGI TQ SINDAGI",
  "Mysore college of Engineering and Management",
  "MAHARAJA INSTITUTE OF TECHNOLOGY THANDAVAPURA",
  "BASAV ENGINEERING SCHOOL OF TECHNOLOGY ZALAKI",
  "Shri. Murughrajendra Yoga Vidya Kendra, Shri. Channabasava Mahasvamiji First Grade Arts and Commerce",
  "GOVT FIRST GRADE COLLEGE, ATHANI",
  "GOVT FIRST GRADE COLLEGE DEVARAHIPPARAGI - 586115",
  "SESWS Chatrapati Shivaji Arts Science and Commerce College Nangnoor-Nipani",
  "C622 PRAGNYA DEGREE COLLEGE SHAHAPUR DIST YADAGIRI",
  "GOVT FIRST GRADE COLLEGE MAMDAPUR",
  "C601 Shree Basavaraj Hiremath diggi degree college Shorapur",
  "C600 SRI SIDDALINGESHWAR MSW PG COLLEGE, SHAHAPUR",
  "C559 ORIENT DEGREE COLLEGE YADGIR",
  "ARUNODAYA DEGREE COLLEGE",
  "C533  PRARTHANA ARTS AND COMMERCE DEGREE COLLEGE",
  "C520 SRI GURU DIGAMBAR SIDDHARUDHA DEGREE ARTS COLLEGE, SHAHAPUR",
  "C503 BANASIRI ARTS DEGREE COLLEGE, HIREWADAGERA",
  "C495 Sri LKET's   Degree College Yadgir",
  "C492  LKET Kannada P G Centre Yadgir",
  "C642 HULIGAPPA M.A. PG COLLEGE YADGIRI",
  "C555 HULIGAPPA DEGREE COLLEGE, YADGIRI",
  "C468 SIDDALINGAPPA B DESHMUKH COLLEGE OF BCA AND BBM COLLEGE",
  "C464 Vishwaradhya College Of Education Abbetumkur",
  "The Siruguppa Education Societys B E Ramaiah Arts and Commerce College for Women, Bellary Road, Siruguppa",
  "C399 Sri Balaji Govt First Grade Degree college Saidapur",
  "THE MILLENNIUM COLLEGE OF NURSING",
  "C343 CESS Degree College Yadgir",
  "C325 Govt First Grade College Shahapur",
  "C309 HKE SOCIETY's SHRI PRABHU ARTS, SCIENCE AND J. M. BOHRA COMMERCE DEGREE COLLEGE SHORAPUR, TQ. SHORAPUR DIST. YADGIR",
  "C305 Govt First Grade Degree College Yadgir",
  "Alva's Law college",
  "Pride First Grade college, Hassan ",
  "College of Agriculture, Kalaburagi ",
  "Vidya Sanskaar Institute of Science, Commerce & Management, Machohalli gate, Magadi Main Road, Bengaluru -560 091 Ph: 9900505885, 28535286/27, 28536855/56  (2011-12)",
  "Jain College, No.15, Vasavi Temple Road, V.V. Puram, Bangalore-04. ",
  "RAJPUTANA COLLEGE OF PHARMACY",
  "ADARSH FIRST GRADE ARTS AND SCIENCE COLLEGE KALAKERI",
  " S V COLLEGE OF NURSING",
  "Shri Siddeshwar education Socialites Arts Degree College At Bhatagunaki ",
  "Oxbridge College of Pharmacy",
  "Umadevi Patil College of Nursing Science Humnabad",
  "GOVERNMENT ENGINEERING COLLEGE  TALAKAL",
  "Vidya Vardhaka Sangha First Grade College, Basaveshwaranagar, ",
  "EARTHA-Elements of Art and Heritage Academy",
  "SRI BGS INSTITUTE OF NURSING    ",
  "C641 SAMRAT ASHOK MSW COLLEGE KALABURAGI",
  "Yenepoya Homeopathic Medical College and Hospital",
  "Presidency College, No.33-2C, 33-2D, Kempapuara Hebbal, Bangalore-24",
  "ICAT Design and Media College",
  " SBG AYURVEDIC MEDICAL COLLEGE AND HOSPITAL BELAGAVI",
  "SMT SHAKUNTALA INSTITUTE OF NURSING EDUCATION ",
  "P A INSTITUTE OF PHYSIOTHERAPY",
  "NANDI INSTITUTE OF NURSING SCIENCES",
  "Prayavi College of Nursing Bidar",
  "SEVAKI COLLEGE OF NURSING BIDAR",
  "SAMRUDDI COLLEGE OF NURSING GOKAK",
  "TMAE SOCIETY MMJG COLLEGE OF PHARMACY",
  "MANONIDHI INSTITUTE OF NURSING ",
  "Manjunatha College of Nursing",
  "C697 SWAMY VIVEKANANDA ARTS DEGREE COLLEGE SEDAM",
  "Manipal School of Architecture and Planning",
  "Yenepoya Pharmacy College and Research Centre",
  "JSS SHRI MANJUNATHESHWARA MCA INSTITUTE    ",
  "Sri Basaveshwara Institute of Technology, TIPTUR",
  "KRUPANIDHI COLLEGE OF MANAGEMENT",
  "ANIKETHAN LAW COLLEGE     ",
  "GLOBAL COLLEGE OF MANAGEMENT STUDIES",
  "IMPACT Institute of Management Studies",
  "Skybird Aviation",
  "Sophia Evening College",
  "MAURYA INSTITUTE OF ALLIED HEALTH SCIENCES    ",
  "SATISH SUGARS ACADEMY ARTS AND COMMERCE FIRST GRADE COLLEGE GOKAK",
  "SARVODAYA ARTS AND COMMERCE WOMENS DEGREE COLLEGE",
  "MALAVA EVENING COLLEGE OF ARTS, COMMERCE AND YOGIC SCIENCE",
  "GLOBAL INSTITUTE OF NURSING SCIENCES",
  "J V LAW COLLEGE BANGALORE ",
  "Sri Jayachamrajendra College of Engg (Even.),  MYSORE",
  "Sri Jayachamarajendra College of Engg., MYSORE",
  "Cauvery College, Gonikoppal - 571213",
  "PATEL COLLEGE OF NURSING",
  "SHREE SHARDA COLLEGE OF NURSING",
  "SRI VANI VIDYA KENDRA DEGREE COLLEGE",
  "Jnanabharathi College of Education",
  "G MADEGOWDA INSTITUTE OF NATUROPATHY AND YOGIC SCIENCES",
  "VEDANTHA DEGREE COLLEGE",
  "THE KINGDOM COLLEGE Bannerghatta Road ",
  "ASC SILVER VALLEY DEGREE EVENING COLLEGE",
  "ASC SILVER VALLEY DEGREE COLLEGE",
  "IDeA Worldwide College",
  "SRI CHANNEGOWDA ALLIED HEALTH SCIENCES",
  "cauvery college of physiotheraphy",
  "MCNAY DOONS DEGREE COLLEGE ",
  "Global Innovative College of Computer Applications Akshay Colony, Hubballi",
  "CES INSTITUTE OF FASHION TECHNOLOGY",
  "Josco Institute of physiotherapy",
  "BET Sadathunnisa College, Bismillah Nagar, Bannerghatta Road, Jayanagar, Bangalore-29",
  "C620 SARVAGNA ARTS And COMM. DEG. COLL., AURAD(B), KALABU",
  "GIMS GOVERNMENT COLLEGE OF NURSING",
  "HARSHA INSTITUTE OF MANAGEMENT STUDIES",
  "Abhaya Group of Institution",
  "BANGALORE CITY INTERNATIONAL COLLEGE OF NURSING",
  "PRISM DEGREE COLLEGE",
  "KANNADA BHARATHI FIRST GRADE COLLEGE KUSHALNAGAR",
  "SESHADRIPURAM INSTITUTE OF MANAGEMENT STUDIES",
  "R T Nagar Degree College",
  "THE KINGDOM COLLEGE",
  "Sri Jagadguru Panditharadhya Arts College, Hunasemaranahalli-56217.",
  "VIVEKANANDA INSTITUTE OF MANAGEMENT, RAJAJINAGAR",
  "Sri Sai College for Women, #1889, 3rd Cross, II Stage,Rajajinagar, Banglaore-10",
  "CREO Valley College",
  "Huda National Arts, Commerce and Science Degree College",
  "Advitya Degree College",
  "Sree Adithya Degree College",
  "SAI VIDYA NIDHI NATIONAL DEGREE COLLEGE",
  "Samvaad College of Speech and Hearing",
  "BBMP FIRST GRADE COLLEGE, MAGADI ROAD, BANGALORE 560023.080 23503955",
  "ADARSH INSTITUTE OF MANAGEMENT AND INFORMATION TECHNOLOGY",
  "The Regency College of Education, No.51/1, AMS Layout, Vidyaranyapura,Bangalore-560 097.",
  "Smt. Gangamma Hombegowda First Grade College, Hombegowdanagar, Bangalore -560 027(9-10/10-11)",
  "YIMS GOVERNMENT COLLEGE OF NURSING YADGIRI",
  "GLOBAL INSTITUTE OF PHYSIOTHERAPY",
  "N E T COLLEGE OF PHYSIOTHERAPY",
  "N E T COLLEGE OF NURSING ",
  "Acharya Institute of Graduate Studies",
  "KARNATAKA CIDYA VARDHAKA SANGHA ARTS COLEGE INDI",
  "K.E.Boards First Grade Arts &  College Dharwad.",
  "SARVODAYA WOMENS DEGREE COLLEGE GAJENDRAGAD",
  "Sri. S. Kariyappa College of Education, RS Campus, MG Road, Kanakapura-562 117, Ramanagar District.",
  "RAJADHANI DEGREE COLLEGE",
  "Patel Institute of Science & Mgmt., Kariyammana Agrala, Belandur PO, Opp intel, Outer Ring Road, Bangalore -560 103, (08-09)",
  "MAHESHWARI INISTITUTE OF MANAGEMENT AND SCIENCE COLLEGE ",
  "INSPIRE INSTITUTE OF SCIENCE AND COMMERCE",
  "INNOVA INSTITUTE OF MANAGEMENT AND SCIENCE",
  "I.B.M DEGREE COLLEGE ",
  "St.Anns Womens College, Ramamurthynagar, Bangalore -16",
  "Pragathi Science & Management Studies, Chinthamani-563125",
  "Sapthagiri First Grade College, Gundamanatha Village, Muabagal Circle, Srinivasapura-563 135, Ph:9901538099, 9448886668(2011-12)",
  "Sambhram College of Hotel Management, BEML Nagar, KGF-563 115, Kolar Dist.",
  "SHREEYA INSTITUTE OF ALLIED HEALTH SCIENCES",
  "CIPET SARP APDDRL    ",
  "R.V (Rashtreeya Vidyalaya) Teachers College, Jayanagar, Bangalore-11(PA  UP 2012-13 FOR B.ED)",
  "RV Institute of Management, No.17, 26th Main, 36th Cross, Jayanagar, 4th T Block, Bangalore-41.",
  "CURA COLLEGE OF NURSING",
  "C498 Nivedita Degree College",
  "C516 SRI SIDDALINGESHWAR ARTS DEGREE COLLEGE, YADGIR",
  "D P N COLLEGE OF LAW    ",
  "MILAGRES COLLEGE OF NURSING    ",
  "C556 MALLIKA DEGREE COLLEGE, YADGIR",
  "C558 GOVT. FIRST GRADE COLLEGE, HUNASAGI",
  "MANASWINI COLLEGE OF NURSING, MANGALORE    ",
  "C585 VISHWAJYOTI DEGREE COLEGE SHAHAPUR ",
  "C586 SUBAM DEGREE COLLEGE",
  "MOHAMMDIA DEGREE COLLEGE     ",
  "Government First Grade College, Arsikere",
  "C587 CES BASAVESHWARA ARTS AND COMMERCE DEGREE COLLEGE YADGIR",
  "SRI SAI LAW COLLEGE     ",
  "C589 SHRI JANAKA ARTS DEGREE COLLEGE KODEKAL SHORAPUR",
  "PRAKRUTHI AYURVEDA MEDICAL COLLEGE AND HOSPITAL    ",
  "St. Anne's Evening College, Cambrdge Road, Halasuru, Bangalore",
  "St. Anne's Degree College for Women, Cambridge Road, Halaruru, Bangalore-8",
  "East Point College of Mangement, #2, 80ft Road, HRBR Layout, Kalayanagar, Bangalore  43",
  "Dolphin's Degree College, Near Poojamma Temple, Nellimaradahalli Road, Shidlagatta, Chikkaballapur Dist.",
  "BGS Institute of Management Studies, BGS Campus, Chikkaballapura-562 101,",
  "DR H N NATIONAL COLLEGE OF ENGINEERING    ",
  "BGS COLLEGE OF COMMERCE MALUR",
  "Aristotle College of Education, Andersonpet, K.G.F-563 113, Kolar District",
  "SHEKAR INSTITUTE OF ALLIED HEALTH SCIENCES    ",
  "ANJANADRI FIRST GRADE COLLEGE",
  "Al-Ameen Dr. Momthag Ahamed Khar college, Kolar-563101",
  "AES National College, Gowribidanur-561208",
  "AE & CS Ramapriya College of Education, Bangalore Chennai Bye pass Road, Mulbagal, Kolar District.",
  "Jyothi Nivas college, Hosur Rd, Bangalore-95(Autonomous)",
  "AE & CS Pavan College Physical Education, Kolar-563 101.",
  "Adarsha college of Management Studies, P.C Halli,Kolar-563101",
  "Acharya Womens First Grade College Gowribidanur561208, Chikkaballapur District",
  "Govt. First Grade College, Hesaragatta",
  "C625 Shri Jnana Bindu Degree College Rangampet",
  "GOVERNMENT FIRST GRADE COLLEGE FOR WOMEN, CHAMARAJAPET-26",
  "Bishop Cotton Academy of Professional management, 23/C Sector A, Yelahanka New Town, Bangalore -64",
  "Bharath Matha Womens College, Hanumanthanagara, Bangalore-19",
  "Dr. Ambedkar FGC, HAL, IInd Stage, Indiranagar, Bangalore-38",
  "BANGALORE COLLEGE OF MANAGEMENT STUDIES",
  "BOSTON INSTITUTE OF MANAGEMENT STUDIES (BIMS)",
  "Bangalore School of Design",
  "Christ the King College",
  "Christian Institute of Management",
  "Chinnamma Junjappa  Reddy R.J.S College, Chowdeshwari Layout, R.J.S Road, Maratthahalli, Bangalore-37",
  "Diana College of Education, No.68, Chikkanahalli, Yelahanka Hobli, Ramakrishna Hegde Nagara, Jakkur Post, Bangalore North",
  "Devanga Sangha First Grade College, 6th Cross, Devanga Hostel Road, 6th Cross, Sampangiramangar, Bangalore -27",
  "Crescent First Grade College for Women, Bangalore South City, Basavanagudi, Bangalore -560 004, (10-11)",
  "Community Institute of Management Studies,  #2 Block, Jayangar, Bangalore -11",
  "Community Institute of Commerce & Management Studies,  #2 Block, Jayangar, Bangalore -11",
  "CHARANS DEGREE COLLEGE",
  "Cauvery B.Ed. College, No.3/1, Kodigehalli Main Road, Sahakaranagar, Bangalore --92",
  "B.S.V Degree College, 4th Main Road, Chamarajpete, Bangalore-18",
  "BMS Evening College of Arts and Commerce",
  "BES College of Education, IV Block, Jayanagar, Bangalore-11",
  "BES College,16th Main Road,4th block, Jayanagar, Bangalore-11",
  "Baldwin Methodist College, No.14 Hosur Road, Richmond Town,Bangalore-25",
  "Anugraha B.Ed. College(S.V.S. College of Education), No.206, 15th Main, Nagendra Block, Girinagar, Bangalore-50",
  "Animaster Academy",
  "AGRAGAMI INSTITUTE OF COMPUTERS AND ADVANCED MANAGEMENT STUDIES",
  "AL-AMEEN INSTITUTE OF MANAGEMENT STUDIES ",
  "Al-Ameen Institute of Information Science, Hosur Road, Near Lalbagh Mn. Gate, Bangalore-27",
  "Al-Ameen College of Education, Hosur Road, Near Lalbagh Main Gate, Bangalore-27",
  "Al-Ameen Arts, science & Commerece College, Hosur Road, Bangalore-27",
  "Adithya Institue of Management Studies & Resarch (Previous name: Yelahanka College), No.12, Kogilu Main Road, Behind Annapoorneshwari Temple, Yelahanka Bangalore -64.",
  "Acharya Patashala Evening College. N.R. Colony, Bangalore-19",
  "Acharya Patashala College of Arts and Science, N.R. colony, Bangalore-19",
  "Abbas Khan College for Women,Durga Complex, OTC Road, Cubban Pet, Bangalore-560 002.",
  "SJM College of Arts and Commerce, Chitradurga ",
  "KLE Arts and Commerce Ist Grade College, Sounshi - 581 117               Tq- Kundagol ",
  "PRAGATHI COLLEGE OF NURSING SCIENCES     ",
  "DHANUSH INSTITUTE OF NURSING SCIENCES BAGALKOT ",
  "SRI VISHWESHATHIRTHA MAHAVIDYALAYA DEGREE COLLEGE",
  "Vidyalaya Evening College ",
  "C571 BASAVA SCIENCE AND COMMERCE DEGREE COLLEGE,JAYANAGAR,SEDAM ROAD,GULBARGA",
  "C448 Bujari & Biradar College of Education Afzalpur",
  " JAIN COLLEGE OF BBA ,BCA,  B.com   BELGAUM",
  "MIT PHARMACY COLLEGE",
  "C660 Basaveshwara Degree college Rangampet Tq shorapur",
  "Smt. Neelamma Kudur, K.A. Sathyanarayana Shetty, Government First Grade College, Kudur, Magadi Taluk-561101",
  "SYBMSYs Basava Yoga Mahavidyalay Gadag",
  "C709 ANANYA M.S.W. COLLEGE, KALABURAGI",
  "C667 RACHOTI VEERANNA DEGREE COLLEGE YADGIR",
  "APOORVA INSTITUTE OF MANAGEMENT STUDIES EVENING DEGREE COLLEGE",
  "Ramaiah Institute of Legal Studies",
  "ADICHUNCHANAGIRI AYURVEDIC MEDICAL COLLEGE, HOSPITAL AND RESEARCH CENTRE",
  "BLDE Association College of Education (B.Ed) Jamkhandi",
  "College of Agriculture, Hassan",
  "B.M Shetty  Government First Grade College,Konanur",
  "Gnanadhare  First Grade College ,K.R. Puram",
  "ROYAL INSTITUTE OF COMMERCE",
  "Nehru Memorial College, Kurunjibhag, Sullia-574239",
  "VSS  First grade College,Ratnapuri Colony Hunsur Tq",
  "Government  First Grade College, Kuvempunagar",
  "Sharada Vilas College,  Krishnamurtypuram.",
  "Sri Adichunchanagiri  First Grade College, H.D.Kote",
  "Government First Grade CollegeFor Women, Vijayanagar",
  "Government college of Teacher Education, Vasanthamahal Premisis, Mysore",
  "Sri  Kaginele Mahasamsthana Kanakaguru peetha College  of Education,  Adichunchanagiri Road Kuvempunagar,",
  "Sri Vani Vilas Urs  First grade College for Women, Nazarbad Mysore",
  "J.S.S Institute of Speech & Hearing Ooty Road",
  "Regional Institute Of Education ,Manasagangothri Mysore",
  "Government First Grade College ,T. Narasipura",
  "NIE First Grade College VIshweshwaranagar Mysuru",
  "B.G.S.B. Ed College Adichunchanagiri Road Kuvempunagar",
  "Mysore Makkala Koota and Sri Dharmasthala Manjunatheswara College For Women, Mysore",
  "Vidya Vikas Institute of Hotel Management and Catering Tech, Manasara Road,",
  "Government First Grade College ,Hullahally",
  "St.Philomena's College , Bannimantap",
  "ST BENEDICTS COLLEGE OF PHYSIOTHERAPY",
  "NANDI DEGREE COLLEGE",
  "ROYAL COLLEGE OF ARTS SCIENCE AND MANAGEMENT",
  "TARANATHA SHIKSHAN SAMSTHES LAXMI VENKTESH DESAI COLLEGE",
  "GEVA INSTITUTE OF ALLIED HEALTH SCIENCES BANGALORE",
  "BRV B.Ed COLLEGE",
  "Parivartana Commerce College, Byahatti Bldg. Vidyanagar, Hubli -580 001",
  "Ikon Pharmacy College",
  "C654 KALMESHWAR ARTS DEGREE COLLEGE, AFZALPUR, KALABURAGI",
  "SANMATI SHIKSHANA SAHAKARI SAMITIS BACHELOR OF COMPUTER APPLICATIONS NEHRU NAGAR BELAGAVI",
  "College of Agriculture,Bheemarayangudi",
  "C704 SIDDARTH COMMERCE DEGREE COLLEGE WADI",
  "S B K COLLEGE OF NURSING",
  "C656 DEVANAMPRIYA DEGREE COLLEGE, NIMBARGA, ALAND, KALABURAGI",
  "PANA INSTITUTE OF UNDER GRADUATE STUDIES ",
  "C696 INSPIRE DEGREE COLLEGE, SEDAM",
  "KLE SOCIETYS COLLEGE OF BCA GOKAK",
  "D520 EXCELLENT DEGREE COLLEGE",
  "DR AMBEDKAR EDUCATIONAL ASSOCIATIONS MATHOSHRI RAMABAI AMBEDKAR ARTS, COMMERCE AND SCIENCE DEGREE COLLEGE VIJAYAPURA",
  "SCHOOL OF LAW BLDE,DU VIJAYAPURA    ",
  "Y. B Annigeri Commerce Degree College, Saptapur Dharwad ",
  "Chinmaya Degree College, Mayuri Estate, Nagashettykoppa Hubballi ",
  "S.J.E.S. College of Nursing",
  "RASHTRIYA RAKSHA UNIVERSITY REGIONAL CAMPUS",
  "Sri Sharada College, Basrur, Kundapura-576211",
  "MEN-TSEE-KHANG (SOWA RIGPA) MEDICAL COLLEGE",
  "Sri Dharmasthala Manjunatheshwara College, Ujire-574240, Belthangady",
  "Mangalore Institute of Fire and Safety Engineering, C.P. Complex, Pumpwell, Mangalore",
  "Govt. College of Teacher Education, Mangalore - 575001",
  "Govt. First Grade College, Kushalnagar",
  "C699 Sri Channabasaveshwar Arts and Commerce Degree College Gulbarga",
  "Udupi Institute of Hotel & Tourism NH-17, Karavali Hotel Complex, Adiudupi-Udupi-576103",
  "Maps Evening College, Vyasanagar, Kadri Hills, Mangalore-4",
  "Sru Venkataraman Women's College, Karkala - 574104",
  "Milagres College, Falnir Road, Hampankatte, Mangalore",
  "Karavali College of Education, NH17, Near Kottara Chowki Junction, Mangalore-13",
  "Sri Narayanguru College, Kurdoli, Mangalore-575003",
  "Leelavathi Shetty College of Education Kavoor Junction, Mangalore",
  "St. Raymonds College, Vamanjoor, Mangalore-575028",
  "Govt. First Grade College, Haleyangady - 574237",
  "Mangalore Institute of Fashion Technology Tripthi Cimplex, Baipass Road, Kankanady, Mangalore-2",
  "Sri Gokarnanatheshwara College of Education, Mangalore",
  "Besant Women's College, Mangalore-575003",
  "Sri Ramakrishna College, SRS Home Campus, Bunts Hostel Circle, Mangalore-3",
  "Govt. First Grade College, Belthangady - 574214",
  "Madhava Pai Memorial College, Manipal",
  "Sri Premakanthi College of Education, Bhandarkar Complex, Mannagudda, Mangalore",
  "Pompei College, Talipady, Aikala Post, Kinnigoli-574141",
  "Bethani First Grade College, Nujibalthila, Puttur",
  "Beary's First Grade College, Kodi, Beach Road, Kundapura - 5",
  "Sri Durgaparameshwari Temple First Grade College, Kateel-574148",
  "Sri Mahaveera College, Kodangallu P.O. Moodabidri-574197",
  "NHF INSTITUTE OF ALLIED HEALTH SCIENCE, MYSURU",
  "Dr. K. Shivarama Karanth Govt. First Grade College, Bellare - 574212",
  "St. Ann's college of Education, Mangalore",
  "Govt. First Grade College, Belandoor.",
  "Govt. First Grade College, Kota, Padukere, Kundapura, Udupi",
  "Father Muller's College, Mangalore",
  "Govt. First Grade College, Puttur",
  "School of Social Work, Roshni Nilaya, Mangalore",
  "Field Marshal K.M. Cariappa College, Madikeri",
  "Dr. T.M.A. Pai College of Education, Kunjibettu, Udupi - 576102",
  "THE PRUTHVI COLLEGE OF ALLIED HEALTH SCIENCES DAVANGERE",
  "GOVERNMENT FIRST GRADE EVENING COLLEGE,TUMKUR",
  "SAJJAL SHREE COMMERCE DEGREE COLLEGE NAGARAHAL, LINGASAGUR",
  "Upendra Pai Memorial College, Kunjibettu, Udupi-576102",
  "B.D. Shetty College of Business Management, N.H.17, Goa Circle, Brahmavar-576213",
  "Govt. First Grade College,  Virajpete, Coorg Dist",
  "PRINSTINE INSTITUTE OF LEGAL STUDIES",
  "SGM DEGREE COLLEGE",
  "SRI LAKSHMI LAW COLLEGE",
  "JSS Medical College, Mysore",
  "JSS Dental College and Hospital",
  "KLESs B.B.A. College Hubli.",
  "Veerashaiva Samaji HCMSK Degree College Raichur",
  "SHAMSUL ULAMA  FIRST GRADE COLLEGE",
  "JSS College of Pharmacy",
  "ST MARYS DEGREE COLLEGE, CHITRADURGA",
  "BMS SCHOOL OF ARCHITECTURE, YELAHANKA",
  "AL QAMAR COLLEGE OF PHARMACY",
  "Government First Grade College ,Nanjangud",
  "Mahatma Gandhi College Of Education,Shakthinagar",
  "Hebbur Mahavidyalaya, Bhadravathi.",
  "CHAMARAJANAGAR INSTITUTE OF MEDICAL SCIENCES",
  "Sri Bhanuparkash p v College of Education (B.Ed)",
  "SURANA COLLEGE, NO-167, 2ND STAGE, PEENYA, BANGALORE-22",
  "BMS COLLEGE OF ARCHITECTURE, DESIGN AND PLANNING, BENGALURU",
  "C548 SIDDARTHA ARTS DEGREE COLLEGE, GOBBUR (B)",
  "C611 THAKSHASHILA ARTS AND COMM. DEG. COLLE., KAMALAPUR, ",
  "D543 SHRI. BASAVESHWAR DEGREE COLL., DEODURGA, RAICHUR",
  "C610 SAHYADRI F.G. COLLEGE, AFZALPUR, KALABURAGI",
  "ASM COLLEGE OF NURSING KALABURAGI ",
  "CRESCENT COLLEGE OF PHYSIOTHERAPY",
  "PVS FIRST GRADE COLLEGE CHITRADURGA    ",
  "Shanthala  First Grade College  For Women ,Belur",
  "Anantha sadvidya College of Education, Arsikere",
  "VYASA INSTITUTE OF NURSING SCIENCES, BENGALURU",
  "C612 SRI. SHIVALINGESHWAR F.G. DEGREE. COLLEGE, AFZALPUR,",
  "D549 KARNATAKA ARTS AND COMMERCE DEGREE COLLEGE, DEODURGA, RAICHUR",
  "Gadag Institute of Medical Sciences, Gadag",
  "SRI VISHWARADHYA COLLEGE OF NURSING",
  "GOVERNMENT MODEL DEGREE COLLEGE SHAHAPUR",
  "TRANSCEND EVENING COLLEGE OF COMMERCE",
  "Alvas Ayurvedic Medical College",
  "B534 SANDEEP TAXILA Degree College of Commerce ",
  "B317 KANNADAMBE B.A. AND  B.COM. DEGREE COLLEGE",
  "The Institute of Education Onkarmal Somani College of Education, Kuvempunagar",
  "A.N Varadarajulu  First Grade College,Gorur",
  "Government First Grade College, Santebennur",
  "Government College of Teacher Education Stadium Road, Chitradurga.",
  "Sri Manjari Hanumanthappa College of Education, Davangere-577004",
  "Sri. Manjunatha Swamy First Grade College, Davangere",
  "Sri. Rajarajeshwari First Grade college Jagalur",
  "S.G.R.K. Women's college, Harihar",
  "Smt. Hemavathi Kuvempu Womens College of education, MM first grade college  campus,Chitradurga",
  "Nutan College of Education,Davangere-577004",
  "Government First Grade College, Baramasagara.",
  "Government First Grade College,,Honnali",
  "SRI Basaveshwara Government First Grade College ,Mayakonda",
  "Government First Grade College, Hosadurga.",
  "Government First Grade College, Molakalmuru",
  "Sri Kote Sanna Borappa Boramma First Grade College, Imangala.",
  "KSS College of Education and PG centre, Davangere",
  "Government First Grade College,,Jagalur",
  "Government Science College, Chitradurga.",
  "P.V.S. B.Ed, College, Chitradurga",
  "Sri Venkateshwara College of Education, Chitradurga",
  "HPPC Government First Grade College, Challakere.",
  "Vani Sakkare Government First Grade College, Hiryuru.",
  "Government First Grade College, Javagondanahalli,",
  "Government First Grade College, Nyamati",
  "Sri. Beeralingheshwara First Grade College, Malebennur",
  "Dr.Jakeer Husain First Grade College, Davangere",
  "Bapuji College Of Education,  Chitradurga",
  "M.S.B. Arts & commerce College, Davanger",
  "H.M.T. First Grade College, Nayakanahatti.",
  "A.G.B. First Grade College, Davangere",
  "B.E.A. College of Education & PG Centre, Davangere",
  "Bhadra Institute of  Management & Information Science Studies(BIMS), Davangere",
  "Government First Grade College, Sakleshpura",
  "Government First Grade College for Women, Davanagere",
  "D.S.B.G. Government First Grade College, Mudigere.",
  "S.M.R. Arts & Commerce College, Shankaraghatta.",
  "S.J.M. First Grade Arts & Commerce College, Tarikere.",
  "Government First Grade College, Koppa, Holehonnur.",
  "Government First Grade College, Ajjampura.",
  "Visveswaraya College of Education, Bhadravathi.",
  "Government First Grade College, Sakaryapattana.",
  "A.V.S. College of Education, Gantekanive, Tarikere Taluka.",
  "St. Josepher First Grade College, Chikmagalur.",
  "D.V.S. Arts & Science College, Shimoga.",
  "Smt. Indira Gandhi Government First Grade Womens College, Sagara.",
  "Sri Veerabhadreshwara College of Education, Thalagunada, Shikaripura Taluka.",
  "Kadamba Arts & Commerce College, Shiralakoppa.",
  "Vagdevi College of Education, Thirthahalli.",
  "Rajivgandhi College of Education, Bhadravathi.",
  "Sharavathi First Grade College, Konanduru.",
  "N.E.S. Institute of Advanced Studies, Shimoga.",
  "Government First Grade College, Shikaripura.",
  "Government First Grade College, Narasimharajapura.",
  "Government First Grade College,Rippanpete.",
  "Government First Grade College, Bhadravathi.",
  "Al-Mahmood College of Education, Shimoga.",
  "HKDET BASAVARAJ PATIL MEMORIAL AYURVEDIC MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE HUMNABAD",
  "BEST FIRST GRADE COLLEGE",
  "Sufiya Law College",
  "VENKATESHWARA DEGREE COLLEGE OF MANAGEMENT STUDIES",
  "T.A. PAI MANAGEMENT INSTITUTE MANIPAL",
  "H K E S INSTITUTE OF PHARMACY",
  "Government First Grade College, Banavara",
  "GOVT. ARTS, COMMERCE & POSTGRADUATE COLLEGE-AUTONOMOUS, HASSAN",
  "ESIC College of Nursing, Bangalore",
  "Hasanamba College of Education, Hassan",
  "Hoysaleshwara First Grade College, Arsikere",
  "PRIDE FIRST GRADE EVENING COLLEGE, HASSAN",
  "GVV'S SHRI SHANTAVEER ARTS COLLEGE,  BABALESHWAR",
  "B279 SRI SIDDAGANGA BCA DEGREE COLLEGE, HUMNABAD, BIDAR",
  "B221 Al-Ameen First grade Degree College Bidar",
  "St.Joseph College, Near Dairy Circle, B.Katihalli, Hassan.",
  "St.Philomenas First Grade College For Women, H N Pura Road, Near New Bus stand Hassan.",
  "SVM  College OF Education, Hassan",
  "VIDYA SOUDHA ACADEMY OF MANAGEMENT SCIENCES",
  "Government First Grade College,Udayapura",
  "B219 C S M Degree College Bhalki",
  "B220 RRKS Science  College Bidar",
  "B232 A I M E S Degree College Bidar",
  "SHIKSHAN PRASARAK MANDALS LAW COLLEGE RAIBAG",
  "SUNFLOWER COLLEGE OF NURSING",
  "B285 Sri Om Siddi  Vinayaka B.C.A Degree College Bidar",
  "Government First Grade College, Mosalehosahally",
  "Government First Grade College, Javagal",
  "Adichunchanagiri College of Education, Channarayapatna",
  "GOVENMENT HOME SCIENE COLLEGE, HASSAN",
  "CHANAKYA ARTS AND COMMERCE COLLEGE VIJAYAPUR",
  "GOVT COLLEGE OF NURSING DISTRICT HOSPITAL HAVERI",
  "Government First Grade CollegeFor Women, Holenarsipur",
  "Government First Grade College, Gandasi",
  "MISBAH WOMENS COLLEGE",
  "Govt. First Grade College for Women, Chikaballapur-562101",
  "BHUVAN LAW COLLEGE",
  "MODEL RESIDENTIAL GOVERNMENT FIRST GRADE COLLEGE FOR WOMEN",
  "Sri H.D Devegowda  Government First Grade College,Paduvalahippe",
  "SIES ARTS AND COMMERCE DEGREE COLLEGE BELAWADI",
  "Haranahalli Ramaswamy Institute of Higher Education",
  "JSS Institute of Education, Sakleshpura",
  "SPATIKA COLLEGE OF NURSING",
  "HOPKINS COLLEGE OF NURSING",
  "KLE COMMERCE COLLEGE, VIDYA NAGAR , HUBLI, DHARWAD",
  "Kuvempu First Grade College",
  "DIPALI COLLEGE OF NURSING",
  "NDRK College for Education, B M Road Hassan",
  "Sri  Adichunchanagiri  First Grade College ,Chennarayapatna",
  "UDUPI COLLEGE OF PHYSIOTHERAPY",
  "BIMS COLLEGE OF LAW",
  "BLDEAS  COLLEGE OF NURSING JAMKHANDI",
  "CHETAN BUSINESS SCHOOL INSTITUTE OF MANAGEMENT AND RESEARCH, HUBLI",
  "GOVT COLLEGE OF NURSING KARKALA",
  "D409 SRK College of Education Raichur",
  "ST. FRANCIS DE SALES COLLEGE, MERMIER NAGAR, HUSKUR GATE, ELECTRONIC CITY POST, BANGALORE",
  "Beena Vaidya Commerce and Science College, Murudeshwar ",
  "Sakhafiya Millat Education Society, Abdul Kalam Arts, Science and Commerce College, Gadag ",
  "J V MANDALS DEGREE COLLEGE TERDAL",
  "VEDA DEGREE COLLEGE CHITRADURGA ",
  "B.A.J.S.S  Arts College Gayatri Campus Halageri Road Ranebennur",
  "Sri Ranga college of Education, Karmal Mathashrama Road,Hemavathi nagar",
  "SRI VIDYANIDHI WOMENS FIRST GRADE COLLEGE, SBI BANK OPPOSITE, SHAHAPUR",
  "Smt. Allum Sumangalamma Memorial College for Women, Ballari- 583103",
  "SRI LAKSHMI COLLEGE OF MANAGEMENT AND SCIENCE.",
  "S.E.T. Degree Evening College",
  "SDM TRUSTS, DANIGOND COLLEGE OF COMMERCE(B.COM)",
  "S.E.T. DEGREE COLLEGE  ",
  "SHIVABASAPPA GEERANNAVAR COLLEGE OF COMMERCE",
  "S R S COLLEGE OF NURSING",
  "College of Horticulture, Bangalore",
  "SURANA EVENING COLLEGE",
  "PRASANNA COLLEGE OF AYURVEDA AND HOSPITAL",
  "TUNGAL SCHOOL OF BASIC AND APPLIED SCIENCES, JAMKHANDI",
  "Vivekananda College of Education,Arsikere",
  "C614 SANCHI ARTS AND COMM. DEG. COL., AFZALP., KALABURAGI",
  "D544 SHRI. VENKATESHWAR DEGREE COLLEGE, MANAVI, RAICHUR",
  "vidyasree science and commerce college ",
  "Aditya Academy of Architecture & Design",
  "Govt Womens First Grade College Jewargi Colony Kalaburagi",
  "MRM COLLEGE OF NURSING, MADIKERI",
  "SRI CHAMUNDESHWARI COLLEGE OF NURSING",
  "C653 YATIRAJ ARTS DEGREE COLLEGE DEVAL GANAGAPUR",
  "CHANNABASAMMA BCA AND B COM COLLEGE BIDAR",
  "B294 Islamia Arts College Basavakalyan",
  "B291 YALLINGA COLLEGE OF EDUCATION",
  "SRI MAHESHWARI DEGREE COLLEGE",
  "B306 JOY B.C.A College Bidar",
  "SHAHEEN DEGREE COLLEGE",
  "RESIDENTIAL GOVERNMENT FIRST GRADE COLLEGE GHODAMPALLI BIDAR KARNATAKA",
  "KARANJA MSW  PG COLLEGE  K NAGAR BIDAR",
  "SHRI LAKSHMISEN SHIKSHANA SAMSTHE GRADE COLLEGE AP RAIBAGH",
  "RATHINAM COLLEGE OF LIBERAL ARTS AND SCIENCE",
  "D438 VIVEKANAND COLLEGE",
  "Mangalore Institute of  Technology  & Engineering, MANGALORE",
  "PRERANA COLLEGE",
  "MANUU POLYTECHNIC, BANGALORE",
  "SHREE SHIVAYOGEESHWAR DEGREE COLLEGE, INCHAL.",
  "CHAITANYA HITECH INSTITUTE OF COMMERCE MANAGEMENT AND SCIENCE DAVANAGERE",
  "Visveswarapura College of Law, Bangalore",
  "BEARYS INSTITUTE OF EMERGING SCIENCES",
  "BLDEA Shri Sanganabasava Mahaswamiji College of Pharmacy and Research Centre, Vijayapur",
  "VIKAS DEGREE COLLEGE VIJAYAPUR",
  "College of Teacher Education, Bidar",
  "MANIPAL ACADEMY OF HIGHER EDUCATION BANGALURU CAMPUS",
  " Dr. Babasaheb Ambedkar College of Education (B.Ed) Nanadi",
  "S L T COLLEGE OF NURSING",
  "RAJEEV COLLEGE OF PHYSIOTHERAPY",
  "MOOGAMBIGAI COLLEGE OF NURSING",
  "ADITYA COLLEGE OF PHARMACY BHALKI",
  "TUMKUR UNIVERSITY PG CENTRE, TIPTUR ",
  "V CARE COLLEGE OF NURSING, HUBBALLI",
  "MOODLAKATTE COLLEGE OF PHYSIOTHERAPY",
  "School of Business Management -Bangaluru Campus",
  "RAMAN DEGREE COLLEGE",
  "S.R.S. First Grade College, Chitradurga.",
  "East West First Grade College of Science, Viswaneedum Post, Magadi Mn Road, Bangalore-91",
  "T. John College, No.80/1, Gottigere Post, Bannergatta Road, Bangalore-83",
  "Smt. Manjula Mallesh College of Education, CanaraBank Colony, Nagarabhavi Road, Bangalore -72",
  "D.V.S. Shilpashree Degree Evening College,  #6, Sunkadakatte, Magadi Main Road, Vishwaneedum Post, Bangalore -91",
  "Government First Grade College, Gowribidanur-561 208, Chikkaballapur Dist.",
  "Rajajinagar College of Education, K.T.S. V Sangha, 10th Main Vth Block, Rajajinagar, Bangalore-10",
  "R.R. College of Education, No.40, Raja Reddy Layout, Near Chikkabanawara Railway Station, Hesaragatta Road, Bangalore -90",
  "Sri Kuvempu Maha Vidhyalaya, FGC, Channapatna-571501.",
  "Acharyas Bangalore B School, No.3, Lingadeeranahalli, Bangalore -91 (Acharya Institute of Science, No.01, Chola Nagar, R.T. Nagar post, Bangalore-32)",
  "University UG Programme for B.P.Ed.",
  "PADMASHREE INSTITUTE OF MANAGEMENT AND SCIENCES, KOMMAGHATTA, KENGERI, BANGALORE",
  "Amitha B.Ed. College, C.A. No.2, 3rd Main, West of Chord Road, 2nd Stage, Mahalkshmipura, Bangalore -560 086",
  "Sri Siddagana Arts and Commerce College, Nelamangala-562 123,",
  "Noble College, #12A/19, 9th Cross, J.P Nagar 1st Phase, Opposite Rajashekar Hospital, Bengaluru - 560078.",
  "Government First Grade College, Peenya, Bangalore -560 058.",
  "Channambika Degree College, 2nd Cross, Mahalakshmi Layout, Channpatna-571 501, Ramanagar Dist.",
  "Oxbridge College of Science & Commerce (SKM Degree College), No.26 Ist Main Road, Vijayanandanagar,  Nandini Layout, Bangalore-96",
  "Darshan First Grade Evening College, H.R Layout, Prashanth Nagar, Bangalore-560079",
  "ISBR College, #62B, Opp. Electronic City Police Station, 1st Phase, Electronic City, Hosur Road, Bangalore -560 100.",
  "Kuvempu FGC, Mallasandra, T Dasarahalii, Bagalore-57",
  "St. Claret College, MES Road, 5th Cross, 1st Main, Sharadambangar, Bangalore-13",
  "Government First Grade College, Govt. Higher  Primary School Annex,  Hosur Sarjapur Road, HSR Agara, Bangalore-560 034.",
  "Ebenezer College, #44, Railway Gate, Horamavu, Banaswadi, Bangalore-560 043(10-11)",
  "SEA College of Education, Ektanagar, Basavanapura Virgo Post, Bangalore -49",
  "Silicon City College, Ravindra Layout, #35, 41 &42/26-/2 KR Puram, Basavanapura Road, Bangalore -36",
  "Government First Grade College, Kengeri, Bangalore -60",
  "Kuvempu Evening Degree College, Mallasandra, T.D. Halli Post, Hesaraghatta main Road, Bangalore -560 052.(2011-12)",
  "Govt. First Grade College, Bantwal",
  "P.V.P. First Grade Evening College, #42, Ring Road, Mallathhalli, Bangalore -56(08-09)",
  "P.E.S. Degree College (Bangalore South Campus),  Hosur Road, Electronic City, Bangalore-560 100",
  "Bangalore Instiute of Management Studies, Opp.RVCE, Mysore Road, Bangalore -60",
  "Oxford Degrree College, Sir MV Layout, Ullal Main Road, Bangalore-560 056 (2011-12)",
  "SJB College of Education ,BGS Health Education City, No.67, Uttarahalli Road, Kengeri, Bangalore -60",
  "Govt. First Grade College, Channapatna-571501.",
  "St. Paul's College of Education, No.1, 2nd Main, BDA Layout, Pttegarapalya Bangalore -79.",
  "Anupama College of Education, Est of Chord Road, 2nd Stage, Mahalakshmipuram, Bangalore -86",
  "Sri Adi Chunchanagiri College of Business Management, No.1416/A, 3rd Floor, Behind Adichunchanagiri Mutt, 1st A Main Road, 3rd Cross, Vijayanagar, Bangalore -40.",
  "IFIM College, # 8 P & 9P, KIADB Industrial Area, Electronic City, I Phase, Bangalore -560 100.,",
  "Siddaganga College of Management and Science, #33, Suraj Towers, Service Road, Near Laggere last Busstop, Narasimhaswamy Layout, Bangalore-58",
  "Siddaganga Evening College, #33, Suraj Towers, Service Road, Near Laggere last Busstop, Narasimhaswamy Layout, Bangalore-58",
  "Prashasthi Degree College #21/21, Yadavanahalli Gate, Hosur Road, Anekal Taluk, Bangalore -562107.",
  "Shri Sharada First Grade College, SPG Colony, Tavarekere, Magadi Main Road, Bangalore-560 0130 Ph:9449194511 (2011-12)",
  "Sri Aurobindo College, No.8, 5th Main, IInd Stage, Mahalakshmipuram, Bangalore-86",
  "K.L.E Society S. Nijalingappa College, Rajajinagar, Bangalore-10",
  "Goutham College of Science, No.258, 5th Main, 2nd Cross, Manjunathanagar, Bangalore-10",
  "ASC Degree College, No.3/10, 1st Main, 6th Block, Rajaji Nagar, Industrial Estate, Bangalore -10",
  "VALMIKI COLLEGE OF VEDIC WISDOM",
  "KINGSTON ACADEMY DEGREE COLLEGE",
  "KARWAR INSTITUTE OF MEDICAL SCIENCES KARWAR",
  "Smt. B.E. Hanumanthamma Memorial Institue of Management, Siruguppa-583121.",
  "Sri Lakshmi Venkateswara B.Ed College, Kudligi - 583 135",
  "Saraladevi Satishchandra Agarwal, Govt., First Grade College, Bellary",
  "Sri. Maata Degree College, Hospet - 583 201.",
  "COLLEGE OF AGRICULTURE, DHARWAD",
  "COLLEGE OF AGRICULTURE,BIJAPUR",
  "COLLEGE OF FORESTRY,SIRSI",
  "C423 North Karnataka Arts and Commerce Degree college Gulbarga",
  "Murugendra Lalitakala Mandira, Athani",
  "Federal College of Nursing",
  "Padmashree Institute of Medical Lab Technology",
  "Krupanidhi College of Physiotherapy",
  "KLE Society's  Lingaraj College, Belgaum",
  "HOSKOTE MISSION INSTITUTE OF NURSING, BANGALORE",
  "SAHAKAR EDUCATION AND SOCIAL DEVELOPMENT SOCIETYS BASAVAJYOTI SCIENCE AND COMMERCE COLLEGE, BELGAUM",
  "VIDYAVARDHAK SANGHAS B B NYAMAGOUDAR FIRST GRADE ARTS AND COMMERCE COLLEGE, BELGAUM",
  "NIRMALA COLLEGE OF NURSING, BHADRAVATHI",
  "VEMAN VIDYAVARDHAK SANGHS KH PATIL COMMERCE COLLEGE, DHARWAD",
  "AKKIHAL FOUNDATIONS SMT SHRI G S AKKIHAL COMMERCE COLLEGE, DHARWAD",
  "MAILARAPPA MENASANAGI MEMORIAL TRUST MAILARAPPPA ARTS AND COMMERCE COLLEGE, GADAG",
  "SATYAM COMPUTER EDUCATION KAMADHENU BCA COLLEGE, KARWAR",
  "Sri Basavaraj College of Nursing",
  "BLDEA's Sri B M Patil College of Nursing",
  "SJM Dental College & Hospital",
  "Goutham College of Nursing",
  "City College of MLT",
  "Al-Aameen Fathima College of Nursing",
  "Sri Kalabyreshwara Ayurvedic Medical College",
  "St. George College of Nursing",
  "Bhagawan Mahaveer Ayurvedic Medical College",
  "St. Johns Medical College_ParaMedical",
  "Shekar College of Nursing",
  "Tipu Sultan Unani Medical College & Hospital",
  "Luqman College of Pharmacy",
  "Zulekha Nursing College",
  "Rajiv Gandhi College of Nursing",
  "Vydehi Institute of Medical Sciences",
  "S J M College of Pharmacy",
  "Ashwini Collge of Nursing",
  "Sarojini College of Nursing",
  "Bangalore Medical College",
  "Taranath Ayurvedic Medical College",
  "Pragathi Institute of Nursing",
  "Chinmaya Institute of Nursing",
  "Acharya Deshbhushan Ayurvedic Medical College",
  "NATIONAL FORENSIC SCIENCES UNIVERSITY DHARWAD CAMPUS",
  "Siddaganga Institute of Nursing Sciences and Research Centre",
  "MODEL SC ST RESIDENTIAL GOVERNMENT FIRST GRADE COLLEGE, GUNDEPALLI TQ SEDAM DISTRICT KALABURAGI",
  "St.Josephs College of Education, Jayalakshmipuram",
  "PANNALAL HEERALAL DEGREE COLLEGE, BIDAR",
  "VISHWADARSHANA BCA COLLEGE YELLAPUR",
  "ST FRANCIS EVENING COLLEGE",
  "Tulza Bhavani College of Nursing",
  "DGM Ayurvedic Medical College",
  "B255 Govind Rao Mulay College of Education Aurad",
  "B568 Basavakalyan B.Ed College,Basavakalyan",
  "Netra Jyothi Institute of Allied Health Sciences,Udupi",
  "ST FRANCIS DE SALES COLLEGE, NEAR D C OFFICE, TAMAKA, KOLAR",
  "ST MARYS  NURSING COLLEGE  BANGALORE",
  "Sarada Vilas College of Pharmacy",
  "P R College of Nursing",
  "B310 SARASWATHI BCA DEGREE COLLEGE, BASAVAKALYAN",
  "B208 S.S.K.B Degree College,Basavakalyan",
  "Shuttariya College of Education, No.35/1, B Nijagal, Nelamangala, Bangalore Rural District-562 123.",
  "BTM First Grade College, No.20, 20th Main, BTM Layout, 2nd Stage, Bangalore-68.",
  "PRIMUS SCHOOL OF MANAGEMENT STUDIES",
  "Vagdevi College Of Nursing",
  "Bharatesh College of Nursing",
  "VEER RANI AHALYABAI HOLKAR WOMES ARTS AND COMMERCE DEGREE COLLEGE NIDAGUNDI DIST VIJAYPUR",
  "SANVI SUNILKUMAR ANGADI ARTS AND COMMERCE COLLEGE VIJAYAPUR",
  "SHETTY NURSING COLLEGE ",
  "SAMATA LOK SHIKSHANA SAMITIS DHANVANTRI COLLEGE OF PHARMACY ALAND",
  "PES SMT PREMA B KARJAGI ARTS AND COMMERCE COLLEGE SINDAGI",
  "HITA COLLEGE OF NURSING",
  "Kalaniketan College of Education, No.42/1, AECS Layout, Koodlu Gate, Hosur Road, Bangalore -68",
  "KTG COLLEGE OF NURSING",
  "SHRI SHIVAYOGESHWAR COLLEGE OF NURSING",
  "VISHWADARSHANA PGDMCJ COLLEGE ",
  "CORNERSTONE COLLEGE OF COMMERCE, MANAGEMENT AND SCIENCE, BENGALURU",
  "RR INSTITUTE OF PHYSIOTHERAPY",
  "B213 Methodist First Grade Degree College,Bidar",
  "B580 MANJEERA PG COLLEGE BIDAR",
  "Vijay College of Fine Arts, Gadag",
  "Maharshi Savitha College of Education",
  "VIVEKANANDA INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "Nitte School of Architecture Planning and Design",
  "Fr. Muller Medical College_Paramedical",
  "K L E SOCIETYs SHRI SHIVAYOGI MURUGHENDRA SWAMIJI   ARTS ,SCIENCE & COMMERCE COLLEGE,  ATHANI",
  "THE NATIONAL COLLEGE, AUTONOMOUS, JAYANAGAR, BENGALURU-560070 ",
  "College of Agriculture,Raichur",
  "B305 Manjeera College of Education Bidar",
  "AECS Pavan College of Nursing",
  "Shreeya College of Nursing",
  "Dr. M V Shetty Institute of Health Sciences",
  "Government Nature Cure and Yoga College",
  "Navodaya College of Physiotherapy",
  "S. S. S. SAMITI ' S MAHAVEER P. MIRJI COLLEGE OF COMMERCE,  BELAGAVI",
  "Ranebennur Taluk Education Society's College of Nursing",
  "Mangala College of Allied Health Sciences",
  "TRISHA COLLEGE OF COMMERCE AND MANAGEMENT, MANGALORE, DAKSHINA KANNADA",
  "B528 Royal Degree College",
  "Government First Grade College Bidar",
  "Father Mathews College of Nursing",
  "B530 SATYANIKETAN DEGREE COLLEGE BHALKI",
  "B543 SJSBVT B.Ed College Basvateertha Math Humanabad",
  "B233 Rajiv Gandhi First Grade Degree College Basavakalyan",
  "D516Shri Aditya Commerce Degree College Sindhanoor",
  "Sri. Vejaya Sangameshwara College of Education, Hosadurga",
  "Vijaya College, Mulki",
  "GOMATESH VIDYAPEETH  ARTS COLLEGE BELAGAVI",
  "C319 Dr B R Ambedkar College Gulbarga",
  "Bashumiyan Sahukar Government First Grade College Manvi",
  "D414 SitaSubbaraju Memorial Degree College Raichur",
  "Raj Rajeshwari Arts & Commerce College for Women, Ranebennur-581 115",
  "D418 Govt First Grade Degree College Deodurga",
  "D436 Shri Shankar Trust's Arts Degree College Sindhanoor",
  "NSB Academy",
  "Suleman College of Nursing",
  "SHRI CHANDRASHEKHAR  MALLIKARJUN MAMANI GOVERNMENT .FIRST  GRADE COLLEGE, YARAGATTI",
  "B266 Govt First Grade Degree College,Hulsoor",
  "D438 VIVEKANANDA BCA COLLEGE RACIHUR",
  "ALN Rao Ayurvedic Medical College",
  "Sushrutha Ayurvedic Medical College",
  "NK Jabshetty Ayurvedic Medical College",
  "ASN LAW COLLEGE, NALTWAD, BIJAPUR",
  "New Navodaya Institute of Nursing",
  "D.R. Karigowda College of Pharmacy",
  "B288 Noor M.Ed College Bidar",
  "SHRI ATAL BIHARI VAJPAYEE INSTITUTE OF NURSING",
  "VISION DEGREE COLLEGE",
  "KARAVALI AYURVEDIC MEDICAL COLLEGE AND RESEARCH CENTRE",
  "R K M Ayurvedic Medical College",
  "ARYABHARATHI FIRST GRADE COLLEGE",
  "B271 Vidya Vikas MSW College Bidar",
  "JAIN COLLEGE OF ENGINEERING AND RESEARCH  BELAGAVI",
  "AL-Ameen Dental College",
  "Karavali College of Nursing",
  "B267 Govt First Grade Degree College,Balki",
  " S.B.C.S. Arts, S.V. Commerce & Science  College, Humnabad",
  "NBP DEGREE COLLEGE, NO.78, OPP. VEERESH THEATER, MAGADI MAIN ROAD, Bangalore-560079",
  "Bapuji Ayurvedic Medical College",
  "SDM RESEARCH INSTITUTE FOR BIOMEDICAL SCIENCES",
  "National Rural Development and Education Trust National Womens Degree College for Women, National Career Academy Campus, Raichur Main Road, Ligasgur",
  "B311 IMPERIAL FIRST GRADE COLLEGE, BIDAR",
  "TRIVENI DEGREE EVENING COLLEGE",
  "C565 ARUNDATI MSW COLLEGE",
  "AL SHARAY WOMENS DEGREE COLLEGE, KALABURAGI",
  "Priyadarshani College of Pharmacy",
  "East Point College of Pharmacy",
  "Kumuda Institute of Nursing Sciences, Kumuda College of Nursing",
  "M M Joshi Eye Institute Hubli ",
  "G Madegowda Institute of Allied Health Sciences",
  "Residential Governament First Grade College Ramanagar",
  "Madhugiri Sri Raghavendra College of Nursing",
  "Aruna College of Nursing",
  "Acharya Institute of Physiotherapy",
  "AECS Maruthi College of Dental Sciences",
  "M S Ramaiah Institute of Nursing Sciences, Education & Research",
  "Kailkere Rukmini Shetty Memorial College of Nursing",
  "B G S Nursing College",
  "Atreya Ayurvedic Medical College",
  "Sri K V College of Pharmacy",
  "Alva’s College of Physiotherapy",
  "National College of Pharmacy",
  "R K College of Nursing",
  "TMAE’s  Ayurvedic Medical College",
  "Shridevi Institute of paramedical sciences",
  "Narayana Hrudayalaya College of Nursing",
  "Acharya B M Reddy College of Pharmacy",
  "Eben Ezer College of Nursing",
  "Gayathri College of Nursing",
  "KASTURI BAA WOMENS DEGREE COLLEGE KARATAGI ",
  "Acharya Inst. of Health Sciences",
  "SMART DEGREE COLLEGE KOLAR",
  "S B College of Nursing",
  "Bhagwan Buddha Homoeopathic  Medical College & Hospital",
  "INTERFACE COLLEGE OF COMPUTER APPLICATIONS",
  "VIDYAPANA DEGREE COLLEGE",
  "Dr. B D Jatti Homoeopathic Medical College, Hospital & PG Research Centre",
  "B262 Govt First Grade Degree College,Humnabad",
  "ARUNDHATI LAW COLLEGE SURAPUR ",
  "SRI ESHWARAMMAJI COLLEGE OF PHARMACY",
  "Bharathi College, Bharthinagar",
  "RK First Grade College",
  "St. John's Medical College",
  "H.K Veeranna Gowda  First Grade College,Maddur",
  "Visvesvaraya Technological University, VIAT, Muddenahalli ",
  "M.S Ramaiah Medical College",
  "C646 SIDDESHWAR ARTS DEGREE COLLEGE KALABURAGI",
  "Gramanthara  First Grade College Keragodu Mandya",
  "Sri. Dharmasthala Manjunatheshwara College of Naturopathy & Yogic Sciences Centre",
  "AKKAMAHADEVI RESEARCH SKILL DEVELOPMENT AND EXTENSION CENTRE UDUTADI",
  "Quality Health Care College of Nursing",
  "K L E Society’s Institute of Dental Sciences",
  "Sri Vijayakumar College of Nursing",
  "Government First Grade College Raichur",
  "D456 Navodaya College of Education Raichur",
  "Sri Siddhartha Institute of Nursing Sciences and Research Centre",
  "Shushrutha College of Nursing",
  "St. Mary’s Institute of Nursing",
  "LINGANAGOUDA SHARANAGOUDA BAYYAPUR COLLEGE OF NURSING, HUTTI ",
  "SRI RENUKA COLLEGE OF NURSING ",
  "KVC ALLIED  HEALTH SCIENCES ,MYSORE",
  "KUSHMA COLLEGE OF NURSING, HUBBALLI",
  "GOUTHAM INSTITUTE OF ALLIED HEALTH SCIENCES",
  "SDS TUBERCULOSIS RESEARCH CENTRE AND RAJIV GANDHI INSTITUTE OF CHEST DISEASES",
  "BANGALORE NURSING COLLEGE ",
  "LAKEVIEW COLLEGE OF NURSING, BELAGAVI",
  "MAHIMA COLLEGE OF NURSING BELLARY ",
  "S D M JAIN MATH TRAST, AGM AYURVEDIC MEDICAL COLLEGE AND HOSPITAL, JAMAKHANDI",
  "ASILA WOMENS DEGREE COLLEGE KALABURAGI",
  "GOUTHAM COLLEGE OF LAW",
  "VYDEHI INSTITUTE OF PHARMACY",
  "SHARADA YOGA AND NATUROPATHY MEDICAL COLLEGE ",
  "SOUNDARYA AMBIKA DEGREE COLLEGE T BEGUR TYMAGONDLU ROAD NELAMANGALA TALUK",
  "Government Engineering College Gangavathi",
  "Government College for Women, Maddur",
  "Krupanidhi College of Nursing",
  "NMKRV College,",
  "P V P FIRST GRADE EVENING COLLEGE FOR WOMEN",
  "COLLEGE OF AGRICULTURE CHAMARAJANAGARA",
  "OXFORD INSTITUTE OF GRADUATE STUDIES ",
  "TRANSCEND DEGREE COLLEGE",
  "GOODWILL DEGREE COLLEGE ",
  "BASAVESHWARA DEGREE COLLEGE",
  "HMR DEGREE COLLEGE",
  "KVC COLLEGE OF NURSING",
  "Gautham College of Pharmacy",
  "AISHWARYA INSTITUTE OF NURSING SCIENCES",
  "prestige college of nursing",
  "PRESTIGE COLLEGE OF PHYSIOTHERAPY",
  "ISLAMIA NISWAN DEGREE COLLEGE FOR WOMEN",
  "Akash Institute of Nursing",
  "Shri Raghavendra Ayurvedic Medical College",
  "Government College For Women (Autonomous),Mandya",
  "Government  First Grade College,Koppa,Maddur Tq",
  "Government  First Grade College, Srirangapatna",
  "Government  First Grade College, Pandavapura",
  "Government  First Grade College, Nagamangala",
  "Government  First Grade College, K R Sagara ,Srirangapatna Taluk, Mandya",
  "Government  First Grade College, Halaguru, Malavalli",
  "Government  First Grade College, Bharthinagar ,Maddur",
  "Government  First Grade College For Women K.R. Pete",
  "Alkareem Degree College For Women, Raichur",
  "KLE AYURVEDA MEDICAL COLLEGE, CHIKODI BELAGAVI",
  "SDVS SANGHS ANNAPOORNA INSTITUTE OF NURSING",
  "SHIKSHAN PRASARAK MANDAL INSTITUTE OF NURSING SCIENCES RAIBAG",
  "MARGADARSHAN PHARMACY COLLEGE ILKAL",
  "SMT MEENAXI R KALLUR V V SANGHAS ARTS AND COMMERCE COLLEGE ALIYABAD , VIJAYAPUR",
  "GOVERNMENT FIRST GRADE EVENING COLLEGE, CARSTREET, MANGALORE",
  "PRINCE COLLEGE OF EDUCATION",
  "BGS INSTITUTE OF HOTEL MANAGEMENT",
  "JANAPRIYA COLLEGE OF NURSING HASSAN",
  "SHANTHA COLLEGE OF PHARMACY",
  "MATHRUSHREE INSTITUTE OF  NURSING",
  "SMT SHANTADEVI MEMORIAL COLLEGE OF NURSING, BADAGANDI",
  "SMT SHANTADEVI MEMORIAL AYURVEDIC MEDICAL COLLEGE AND HOSPITAL, BADAGANDI, BAGALKOT",
  "JUPITER INSTITUTE OF ALLIED HEALTH SCIENCES",
  "Vishwasai College of Nursing",
  "SJB College of Nursing",
  "SDM Ayurvedic Medical College",
  "KARNATAKA STATE AKKAMAHADEVI WOMENS UNIVERSITY REGIONAL CENTRE BIDAR",
  "SHRIDEVI INSTITUTE OF ENGINEERING AND TECHNOLOGY, TUMKUR",
  "D462 Smt Mahantamma LingaGouda Bayyapur Arts College Lingasugur",
  "NBC DEGREE COLLEGE",
  "Cavalier Animation and Media College",
  "AJ INSTITUTE OF SPEECH AND HEARING",
  "Tejasvini Institute of Allied Health Sciences",
  "Soniya Education Trust's College of Pharmacy",
  "KLES CENTENARY INSTITUTE OF NURSING SCIENCES,YALLUR,BELAGAVI.",
  "Shri Dhanvantri Ayurvedic Medical College",
  "Kalyanasiri Foundations Kalyanasiri Arts and Commerce College  Gadag ",
  "DR G MADEGOWDA COLLEGE OF EXCELLENCE",
  "CAUVERY DEGREE COLLEGE",
  "Bharathi College of Education, Bharathinagar,KM Doddi Mandya",
  "JASMINE COLLEGE OF NURSING",
  "K R College of Nursing",
  "Sri Siddartha College of Nursing",
  "AJ Institute of Dental Sciences",
  "KLE Societys Institute of Nursing Sciences",
  "Classic Degree College Dharwad",
  "College of Nursing, St. Martha's Hospital",
  "Vivekananda College of Nursing",
  "Akshaya  College of Nursing",
  "JES Mother Teresa College  of Nursing",
  "Akshaya College, Puttur",
  "Nisarga College of Nursing",
  "A J Inst. of Medical Sciences, (MLT)",
  "HKDETs Rajarajeshwari Ayurvedic Medical College, Humnabad, Bidar",
  "HKE’s Nijalingappa Institute of Dental",
  "Sri Sathya Sai Inst. of Medical Sciences_Paramedical",
  "SCS College of Nursing",
  "Spurthy College of Nursing",
  "M R College of Nursing for Women",
  "Sri Adichunchanagiri College of Pharmacy",
  "VIMS College of Nursing",
  "Sanjay  Gandhi Accidental Hospital & Research Center",
  "AVS Ayurvedic Medical College",
  "New Sri Shanthini College of Nursing",
  "KVG Ayurvedic Medical College",
  "silicon college of advanced studies",
  "Mysore Medical College",
  "Rajarajeshwari College of Nursing",
  "Bharathi  First grade College, Kirugavalu",
  "Bellary Institute of Nursing",
  "JSS Institute of Speech & Hearing , Near Taponvana, Kelageri Road, Dharwad",
  "Sharadadevi College of Nursing",
  "smt narmadadevi gilda womens arts degree college",
  "smt,Mangala Kadappanna.Magadum Arts And Commerce First Grade College Snkeshwar",
  "Sri Kalabhyraveshwara Swamy College of Nursing",
  "D469 Kanishka College of Physical Education Yeramaras",
  "K. R. College of Pharmacy",
  "GLOBAL EMBASSY FIRST GRADE COLLEGE",
  "C E S College Of Commerce Yamakanmardi",
  "JS DEGREE COLLEGE COLLEGE",
  "VISHWA CHETHANA COLLEGE",
  "NEW BALDWIN DEGREE COLLEGE",
  "BLOOMS FIRST GRADE COLLEGE",
  "SHANTHA COLLEGE OF ALLIED HEALTH SCIENCES",
  "K. R. INSTITUTE OF HEALTH SCIENCES",
  "Nutan institute of management, Davangere",
  "Seshadripuram College Tumakuru",
  "SHRI B M PATIL MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE VIJAYAPURA",
  "SHRI, MALLIKARJUN VIDYAVARDHAKA SANGHAS SHRI, BASAVESHWAR ARTS DEGREE COLLEGE, AP KALAKERI",
  "SJP FINE ART COLLEGE,",
  "CRESTA First Grade college",
  "BLUE MOON FIRST GRADE COLLEGE CHINTAMANI",
  "NETHAJI COLLEGE OF PHYSIOTHERAPY",
  "East Point College of Medical Sciences and Research Centre",
  "UNIVERSITY FIRST GRADE COLLEGE MANGALAGANGOTHRI",
  "C588 SHREE SOMANATHESHWARA DEGREE COLLEGE KAKKERA",
  "Shri Vanayak Womens Arts and Commerce Degree College, Hatti Village ",
  "HAVERI INSTITUTE OF MEDICAL SCIENCES HAVERI",
  "D470 National Commerce College Sindhanur",
  "Gnanodaya College of Nursing",
  "Bhagavan Buddha  First Grade Evening College Siddartha Nagar Mandya",
  "Gayathri Devi College of Nursing",
  "NHF COLLEGE OF NURSING",
  "GOURAMMA INSTITUTE OF NURSING SCIENCES",
  "Kristu Jayanti College of Law",
  "RAJALAKSHMI SCHOOL OF NURSING",
  "Naseema Institute of Optometry and Research",
  "SRI VENKATESHWARA COLLEGE OF LAW ",
  "SHIVA PRIYA LAW COLLEGE ",
  "S.T.J. Womens First Grade Arts, Commerce & Home Science College, Chikmagalur.",
  "Rajarajeswari College of Physiotherapy",
  "C604 SRI SAIBABA MSW P.G. COLLEGE, GULBARGA",
  "SHRI SATHYASAIBABA DEGREE COLLLEGE, HADAGALI TANDA",
  "BGS FIRST GRADE COLLEGE SIDDAPURA",
  "Raja Rajeswari Medical College & Hospital",
  "Al-Ameen Medical College",
  "C324 H.K.E, SOCIETY'S SMT CHINNAMMA BASAPPA PATIL ARTS  AND COMMERCE DEGREE COLLEGE CHINCHOLI",
  "shree Veerabhadreshwar Arts college Tamba",
  "Govt. First Grade College Zalaki",
  "MARKAZUL HIDAYA FIRST GRADE COLLEGE",
  "ESIC DENTAL COLLEGE, GULBARGA",
  "Govt. First Grade College Managuli",
  "C V GURUKUL COLLEGE OF COMMERCE",
  "Dr. M.V. Shetty College of Physiotherapy",
  "Sri Sathya Sai College of Homoeopathic Medical Science",
  "Siddhivinayak Ayurvedic Medical College",
  "ISBR LAW COLLEGE",
  "Ayurveda Mahavidyalaya",
  "RAJIV GANDHI EDUCATION SOCIETYs AYURVEDIC MEDICAL COLLEGE HOSPITAL AND POST GRADUATE RESEARCH CENTRE RON",
  "C307 HYDERABAD KARNATAKA EDUCATION SOCIETY'S, M.S.IRANI DEGREE COLLEGE OF ARTS, SCIENCE & COMMERCE, KALABURAGI",
  "Shri J. G. Co-operative Hospital Societys Naturopathy and Yogic sciences College Ghataprabha",
  "SHARADA VIDYANIKETAN ARTS AND COMMERCE COLLEGE, MANVI",
  "SRI GOVIND M KARAJOL DEGREE COLLEGE LINGASUGUR",
  "Manel Srinivas Nayak Institute of Management, Bondel, Mangalore",
  "VIDYA RASHMI FIRST GRADE COLLEGE VIDYAGANGOTHRI",
  "NANDINI COLLEGE OF NURSING, RIACHUR",
  "C517 DR RAVINDRANATH TAGOOR ARTS COLLEGE, CHITTAPUR",
  "Dr. G. Shankar Government Women's First Grade College and P.G. Study Centre, Ajjarkadu, Udupi",
  "Bidar Institute of Medical Sciences",
  "St. Mary’s College of Nursing",
  "Vikas College of Physiotherapy",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, BANGALORE",
  "SREE SIDDALINGESHWARA BA INTEGRATED KANNADA PANDIT COLLEGE, TUMKUR",
  "ST. VINCENT PALLOTTI DEGREE  COLLEGE",
  "GENIUS FIRST GRADE COLLEGE, MYSORE",
  "Shree Guru Maharshi Degree College",
  "BGS College Of Physical Education Nagamangala Tq",
  "SRI MAHALINGESHWARA SAMSKRIT COLLEGE",
  "AD Biligowda First grade College,  Koppa",
  "Government  First Grade College, Krishnarajpet",
  "SRI RUDRESHWARA SAMSKRIT COLLEGE",
  "SRI SHANKAR VILASA SAMSKRIT COLLEGE",
  "SRI GURUSARVABHOUMA VEDA SAMSKRIT COLLEGE",
  "St. Josephs College of Teacher Education",
  "Sri Vishwabarathi First grade Collage",
  "Shri. Shakti Association Tapovan Institute of Management (B.B.A) Hiregoudra Complex, Ranebennur",
  "NIRVANASWAMY SAMSKRIT COLLEGE",
  "Taralabalu Jagadguru College of Education Hirekerur",
  "BCN ARTS, COMMERCE AND SCIENCE COLLEGE, SAVANUR ROAD, LAXMESHWAR",
  "SRI JAGADGURU GURU GURUBASAVESHWARA SAMSKRIT COLLEGE",
  "R N SHETTY TRUST R N SHETTY DEGREE COLLEGE, MURUDESHWAR",
  "NIMS Management Institutions Pvt Ltd",
  "ALLAM IQBAL EDUCATION SOCIETYs SHAHEEN DEGREE COLLEGE FOR WOMEN, BIDAR",
  "C K NAIR ARTS AND MANAGEMENT COLLEGE",
  "VAIDYARATNAM PSV AYURVEDA COLLEGE, KOTTAKKAL",
  "MAR GREGORIOS COLLEGE OF ARTS AND SCIENCE",
  "THAQVA AFZAL ULLAMA ARABIC COLLEGE, ANDATHODE",
  "KMM COLLEGE FOR WOMEN",
  "GOVT. MEDICAL COLLEGE, PALAKKAD",
  "ST JUDES ARTS AND SCIENCE COLLEGE ",
  "SAYYID MUHAMMED ALI SHIHAB THANGAL MEMORIAL ARTS AND SCIENCE WOMENS COLLEGE",
  "AASHRAYAM COLLEGE OF ARTS AND SCIENCE, AASHRAYAM ORCHARD,NENMENI POST,KOLLENGODE    ",
  "ROYAL COLLEGE OF ARTS AND SCIENCE",
  "INSTITUTE OF PARAMEDICAL SCIENCES, ANJARAKANDY",
  "GREENWOODS ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "ST KURIAKOSE COLLEGE OF MANAGEMENT AND SCIENCE",
  "ILM COLLEGE OF ARTS & SCIENCE, METHALA, KEEZHILLAM, PERUMBAVOOR",
  "M E S GOLDEN JUBILEE COLLEGE KOTTAYAM",
  "SMI ARTS AND SCIENCE COLLEGE",
  "Govt.Sanskrit College, Thiruvananthapuram",
  "MALABAR MEDICAL COLLEGE AND RESEARCH CENTRE ",
  "MUSALIAR COLLEGE OF ARTS & SCIENCE, CHEENKALTHADOM, MALAYALAPPUZHA",
  "Aligarh Muslim University, Malappuram Centre.",
  "SI. MET COLLEGE OF NURSING, MALAMPUZHA",
  "GOVERNMENT MEDICAL COLLEGE-Thiruvananthapuram",
  "SREE NARYANA TRUSTS ARTS AND SCIENCE COLLEGE, PAMBANAR",
  "MM KNOWLEDGE ARTS AND SCIENCE COLLEGE",
  "UIT, MUKHATHALA",
  "SAFA COLLEGE OF ARTS AND SCIENCE",
  "BISHOP MOORE COLLEGE FOR THE HEARING IMPAIRED",
  "MALABAR COLLEGE OF PHARMACY",
  "MM NSS College, Kottiyam",
  "DM WIMS College of Pharmacy, Naseera Nagar,  Meppadi, Wayanad ",
  "SUNNIYA ARABIC COLLEGE, MUKKAM",
  "S.N. COLLEGE, NATTIKA",
  "MES ARTS AND SCIENCE COLLEGE ANGADIPPURAM PERINTHALMANNA",
  "Govt.College of Teacher Education, Thycaud, Thiruvananthapuram",
  "GOOD SHEPHERD COLLEGE, NATTAKOM",
  "SI-MET College of Nursing Kannur",
  "GOVERNMENT AYURVEDA MEDICAL COLLEGE",
  "MAHAGURU INSTITUTE OF TECHNOLOGY",
  "C S I COLLEGE FOR LEGAL STUDIES, ETTUMANOOR",
  "KMCT COLLEGE OF PHARMACEUTICAL SCIENCES",
  "NIRMALA COLLEGE OF ARTS & SCIENCE, KUNNAPPILLY P.O. MELOOR,CHALAKUDY, THRISSUR",
  "KAS COLLEGE, ANAVATHIL , ULLIYERI, KOZHIKODE",
  "SREE NARAYANA GURU MEMORIAL CATERING COLLEGE",
  "FATHIMA ARTS AND SCIENCE COLLEGE, MOOTHEDAM",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE,NADAPURAM,P.O.VANIMEL,(VIA)KALLACHI,PIN 673506",
  "SANTHIGIRI AYURVEDA MEDICAL COLLEGE, KOLLANGODE",
  "College of Veterinary and Animal Sciences Pookode",
  "College of Veterinary and Animal Sciences Mannuthy",
  "Verghese Kurien Institute of Dairy and Food Technology, Mannuthy,Thrissur",
  "COLLEGE OF DAIRY SCIENCE AND TECHNOLOGY",
  "ST MARYS COLLEGE OF PHYSIOTHERAPY",
  "KNM B.Ed College, Mavila, Thiruvananthapuram",
  "VAIDYARATNAM AYURVEDA COLLEGE, OLLUR",
  "TRAVANCORE ARTS AND SCIENCE COLLEGE",
  "GOVT T D MEDICAL COLLEGE ALAPPUZHA",
  "CO OPERATIVE ARTS AND SCIENCE COLLEGE",
  "SANTHOM MALANKARA ARTS AND SCIENCE COLLEGE",
  "University College of Nursing, Chuttippara, Pathanamthitta",
  "SREE NARAYANA GURU COLLEGE OF ADVANCED STUDIES, VAZHUKUMPARA",
  "Koyili College of Nursing, Kannadiparamba (P.O),Kannur",
  "NSS COLLEGE OF  ARTS   AND SCIENCE",
  "S.N.M Institute of Management and Technology, Maliankara P.O. Moothakunnam, North Paravur- 683 516",
  "Rajiv Gandhi Institute of Technology, Velloor P.O.,Pampady. Kottayam - 689 501",
  "St James College of pharmaceutical Sciences",
  "Musaliar College of Engineering and Technology, Musaliar College P.O., Kumbazha, Pathanamthitta - 689653",
  "St.Thomas College of Nursing, Chethipuzha, Changanacherry",
  "MOOKAMBIKA TECHNICAL CAMPUS, ETTAPIILLY, MANNATHUR",
  "MAR SLEEVA COLLEGE OF ARTS & SCIENCE, MURIKKASSERRY",
  "SULLAMUSALAM COLLEGE OF TEACHER EDUCATION, AREACODE",
  "Nehru College of Architecture",
  "CHRIST COLLEGE OF ENGINEERING",
  "Government Arts and Science College Uduma",
  "COLLEGE OF APPLIED SCIENCE,KARTHIKAPPALLY",
  "SACRED HEART COLLEGE, CHALAKKUDY",
  "RAWTHER COLLEGE OF ARTS AND SCIENCE",
  "Mar Baselios Christian College of Engineering and Technology, Peerumedu - 685 531",
  "School of Medical Education, Thalappady, Kottayam",
  "CALICUT UNIVERSITY REGIONAL CENTRE PERAMBRA",
  "ROUZATHUL ULOOM ARABIC COLLEGE, FAROOK COLLEGE",
  "Mar Baselious Institute of Technology and Science, Nellimattom. P.O,Kothamangalam - 686 693",
  "Jaibharath College of Management & Engineering Technology, Arackappady, Vengola P.O., Perumbavoor,Kochi - 683 554",
  "I L M COLLEGE OF ENGINEERING & TECHNOLOGY, KEEZHILLAM",
  "SREE AYYAPPA COLLEGE OF NURSING, VADASSERIKKARA, PATHANAMTHITTA    ",
  "BHARATA MATA SCHOOL OF LEGAL STUDIES, ALUVA EAST, CHUNGAMVELIL",
  "INSTITUTE OF NURSING EDUCATION ",
  "FR PORUKARA CMI COLLEGE OF ADVANCED STUDIES, CHAMPAKULAM, ALAPPUZHA",
  "GOVERNMENT COLLEGE SANTHANPARA",
  "MAJMA,A ARTS AND SCIENCE COLLEGE    ",
  "COLLEGE OF NURSING E M S MEMORIAL CO OPERATIVE HOSPITAL AND RESEARCH CENTRE",
  "AL-AZHAR COLLEGE OF ALLIED HEALTH SCIENCE",
  "LITTLE FLOWER COLLEGE, GURUVAYUR",
  "CHRIST COLLEGE",
  "Indira Gandhi Institute of Engineering and Technology",
  "Jawaharlal Nehru Tropical Botanic Garden and Research Institute",
  "PMS COLLEGE OF DENTAL SCIENCE AND RESEARCH",
  "Gurudeva Institute of Science and Technology, Vennimala, Payappady P.O, Puthuppally, Kottayam",
  "SREEKRISHNA COLLEGE OF PHARMACY AND RESEARCH CENTRE",
  "KMP COLLEGE OF ARTS & SCIENCE, ASAMANNOOR P.O, PERUMBAVOOR",
  "BLOSSOM ARTS AND SCIENCE COLLEGE KONDOTTY ",
  "CARITAS COLLEGE OF PHARMACY",
  "PVS COLLEGE OF ARTS AND SCIENCE PANTHEERANKAVE",
  "MORES COLLEGE OF ARTS AND SCIENCE",
  "SREE SANKARA DENTAL COLLEGE",
  "Christ Knowledge City, Christ Nagar, Kuzhoor, Airapuram P.O, Emakulam- 683 541",
  "DHARMAGIRI COLLEGE OF ARTS AND SCIENCE CHEREKKAD",
  "M G M SILVER JUBILEE COLLEGE OF PHARMACY",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, KOTTRARAKARA",
  "Marthoma College of Science and Technology, Chadayamangalam",
  "KMCT COLLEGE OF PHARMACY MAMPARA PAZHUR PO  KUTTIPPURAM ",
  "KERALA UNIVERSITY COLLEGE OF TEACHER EDUCATION, NEDUMANGAD",
  "Christ Nagar College of Education, Chavarapuram, Thiruvallam",
  "ST. ALOYSIUS COLLEGE, ELTHURUTHU",
  "CHAVARA INSTITUTE OF MANAGEMENT STUDIES",
  "HINDI PRACHARA KENDRA COLLEGE OF TEACHER EDUCATION, KODUNGALLUR",
  "kTCT COLLEGE OF ARTS & SCIENCE",
  "ST THOMAS COLLEGE OF ADVANCED STUDIES EDAMURI - RANNY",
  "MARKAZ TRAINING COLLEGE, ATHAVANAD",
  "SALAFIYYA COLLEGE WANDOOR",
  "KERALA STATE INSTITUTE OF DESIGN",
  "REGIONAL AGRICULTURAL RESEARCH STATION, KUMARAKOM",
  "COLLEGE OF AVIAN SCIENCES AND MANAGEMENT ",
  "SREEPATHY INSTITUTE OF MANAGEMENT & TECHNOLOGY, VAVANOOR",
  "Jamia Islamiya Arts and Science College",
  "MANNAM NSS COLLEGE, EDAMULACKAL, ANCHAL",
  "ST. GEORGE COLLEGE VAZHAKULAM",
  "GIRIJYOTHI COLLEGE, VAZHATHOPE, IDUKKI COLONY PO,IDUKKI",
  "GRACE VALLEY ARTS & SCIENCE COLLEGE, MARAVATTAM",
  "PIMS COLLEGE OF NURSING WALAYAR PALAKKAD",
  "AL IRSHAD ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "AL SHIFA COLLEGE OF ARTS AND SCIENCE",
  "CAPE COLLEGE OF NURSING ALAPPUZHA",
  "NATIONAL INSTITUTE OF PHYSICAL MEDICINE AND REHABILITATION",
  "College of Applied Sciences, Kundara, Kollam",
  "JDT ISLAM COLLEGE OF NURSING",
  "KTCT College of Teacher Education, Kaduvayil, Thottakkadu, Kallambalam, Thiruvananthapuram",
  "School of Medical Education,(SME),,Gandhinagar P.O.,  M G University,Kottayam",
  "Sobha College of Teacher Education, Mararikulam",
  "Sri Vidyadhiraja Model College of Teacher Education, Kundara, Kollam",
  "VISAT ENGINEERING COLLEGE",
  "Al-Ameen Law College",
  "SREE NARAYANA ARTS and SCIENCE COLLEGE CHITTAR",
  "Mount Zion College of Engineering",
  "CFI COLLEGE OF LAW, POYYA",
  "KPPM COLLEGE OF TEACHER EDUCATION, ANAKKAYAM",
  "CARMEL COLLEGE, MALA",
  "MAR CHRYSOSTOM COLLEGE, PARANTHAL, ADOOR",
  "GOVT. LAW COLLEGE",
  "ST. JAMES COLLEGE OF NURSING, THRISSUR",
  "GOVT. COLLEGE, KODENCHERY",
  "MERCY COLLEGE OF NURSING,MERCY HOSPITAL,POTHY,THALAYOLAPARAMBU,KOTTAYAM(DIST)-686605",
  "St. Gregorios Teacher Training College, Meenangadi",
  "MES ADVANCED INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "Badhariya B.Ed Training College, Velichikkala, Kollam",
  "Global Institute of Public Health",
  "INSTITUTE OF LAND AND DISASTER MANAGEMENT",
  "SR MEDICAL COLLEGE AND RESEARCH CENTRE",
  "TALENT INSTITUTE OF ARCHITECTURE (TIBA)",
  "GOVERNMENT NURSING COLLEGE, ERNAKULAM",
  "COLLEGE OF NURSING, NIRMALA MEDICAL CENTRE, MUVATTUPUZHA",
  "SREE GOKULAM NURSING COLLEGE",
  "GOVERNMENT COLLEGE OF NURSING KASARAGOD",
  "MEPPAYUR SALAFI COLLEGE OF TEACHER EDUCATION,",
  "UIT Tholicode",
  "TOMS ARTS AND SCIENCE COLLEGE",
  "PSM COLLEGE OF DENTAL SC. AKKIKAVU",
  "PMSA Pookoya Thangal Memorial Arts & Science College, Kadakkal",
  "VISAT ARTS AND SCIENCE COLLEGE , ELANJI, ERNAKULAM",
  "Amrita School of Biotechnology, Amritapuri, Kollam",
  "SARBTM GOVT. COLLEGE, KOYILANDY",
  "PRESENTATION CENTRE OF ALLIED SCIENCES",
  "SI MET COLLEGE OF NURSING TANUR",
  "SIMET COLLEGE OF NURSING, VARKALA",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, KANNUR",
  "UPASANA COLLEGE OF NURSING",
  "ST JOSEPH's COLLEGE OF NURSING",
  "St.John's College, Anchal",
  "MG College, Thiruvananthapuram",
  "DON BOSCO COLLEGE, MANNUTHY",
  "VIGYAAN COLLEGE OF APPLIED SCIENCES",
  "HOLY CROSS COLLEGE OF NURSING",
  "Allama Iqbal Institute of Management, Iqbal Nagar, Daivappura P.O., Peringammala, Nedumangad",
  "Govt.College, Nedumangad",
  "Sree Narayana Training College, Nedunganda, Varkala, Thiruvananthapuram",
  "Dr.PALPU COLLEGE OF ARTS AND SCIENCE",
  "Lakshmibai National College of Physical Education, Kariavattom, Thiruvananthapuram",
  "Oriental School of Hotel Management, Valley View, Lakkidi",
  "Oriental College of Hotel Management & Culinary Arts, Vythiri",
  "BISHOP BENZIGER COLLEGE OF NURSING",
  "Mahatma College of Education, Pandikot, Nileswar, Kasaragod",
  "College of Applied Science- Neruvambram-Payyanur",
  "N.A.M College,Kallikandy",
  "JESUS TRAINING COLLEGE, MALA",
  "PRAYAGA FOUNDATION FOR EXCELLENCE AND TRAINING",
  "Amrita School of Dentistry, Kochi",
  "ERANAD KNOWLEDGE CITY COLLEGE OF ARCHITECTURE, CHERUKULAM, MANJERI",
  "SIVAGIRI SREE NARAYANA MEDICAL MISSION COLLEGE OF NURSING",
  "Amrita School of Engineering, Amritapuri, Kollam",
  "DAYAPURAM ARTS & SCIENCE COLLEGE (WOMEN),REC",
  "M.E.S College, Erumely",
  "SIMET COLLEGE OF NURSING, DHARMADAM",
  "Sacred Heart College, Thevara- 682013",
  "ILAHIYA ARABIC COLLEGE, THIRURKKAD",
  "KAHM UNITY WOMENS' COLLEGE, MANJERI",
  "SIMET COLLEGE OF NURSING TALIPARAMBA",
  "MAR OSTHATHEOS TRAINING COLLEGE, PERUMPILAVU",
  "PROVIDENCE COLLEGE OF TEACHER EDUCATION,",
  "SULLAMUSSALAM ARABIC COLLEGE, AREACODE",
  "HIKAMIYYA ARTS & SCIENCE COLLEGE, POONTHOTTAM",
  "VIMALA COLLEGE, THRISSUR",
  "SIMET COLLEGE OF NURSING, NOORANAD",
  "SALAFIYYA ARABIC COLLEGE, KARINGANAD",
  "MAHAJUBILEE TRAINING COLLEGE, MULLORKARA",
  "IDEAL TRAINING COLLEGE, CHERPULASSERY",
  "GOVERNMENT COLLEGE OF NURSING,MAKKAMKUNNU",
  "MERCY COLLEGE, PALAKKAD",
  "VIDYA ACADEMY OF SCIENCE AND TECHNOLOGY - TECHNICAL CAMPUS, KILIMANOOR",
  "THE DALE VIEW COLLEGE OF PHARMACY AND RESEARCH CENTRE",
  "Catholicate College, Pathanamthitta - 689 645",
  "P.A Aziz College of Engineering and Technology, Karakulam, Thiruvananthapuram",
  "Malik Deenar College of Pharmacy, Seethangoli, Bela P.O., Kasaragod",
  "GOVERNMENT COLLEGE OF NURSING, KUNNATHURMEDU",
  "CSI INSTITUTE OF LEGAL STUDIES",
  "THEJUS COLLEGE OF ATCHITECTURE",
  "Indian Naval Academy, Ezhimala",
  "N.S.S. LAW COLLEGE, KOTTIYAM",
  "KHIDMATH ARTS & SCIENCE COLLEGE, EDAKKULAM",
  "SULLAMUSSALAM  SCIENCE COLLEGE, AREAKKODE",
  "KERALA ACADEMY OF PHARMACY",
  "COLLEGE OF APPLIED SCIENCES, CHELAKKARA",
  "Model College, IHRD, Meenangadi",
  "SUT ACADEMY OF MEDICAL SCIENCES",
  "KMCT COLLEGE OF ALLIED HEALTH SCIENCES",
  "AWH COLLEGE OF SCIENCE & TECHNOLOGY, ANAKKARA",
  "Mar Ivanios College (Autonomous), Thiruvananthapuram",
  "UNIVERSITY INSTITUTE OF MANAGEMENT, PUNALUR",
  "Carmel College of Nursing",
  "COLLEGE OF APPLIED SCIENCE",
  "AZEEZIA COLLEGE OF NURSING",
  "TRAVANCORE MEDICAL COLLEGE",
  "THUNCHAN MEMORIAL GOVT. COLLEGE, TIRUR",
  "BETHANY NAVAJEEVAN COLLEGE OF PHSIOTHERAPY",
  "SP FORT COLLEGE OF NURSING",
  "AZHARUL ULOOM COLLEGE OF ARTS AND SCIENCE",
  "KTMCollege of Advanced studies",
  "Valiyam Memorial College of Teacher Education, Edappallycotta, Chavara, Kollam",
  "SREENARAYANA GURU COLLEGE OF ARTS AND SCIENCE, PAINGOTTOOR, KADAVOOR, KOTHAMANGALAM",
  "LOURDE INSTITUTE OF ALLIED HEALTH SCIENCES",
  "GOVERNMENT MEDICAL COLLEGE, ERNAKULAM",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, KARUVATTA",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, PATHANAPURAM",
  "P.N. Panicker Souhruda Ayurveda Medical College , Paraklayi, Kanhangad",
  "SN College, Chempazhanthy, Thiruvananthapuram",
  "SREENARAYAGURU COLLEGE OF ARTS AND SCIENCE",
  "TRAVANCORE COLLEGE OF ALLIED HEALTH SCIENCES",
  "SRI VIDYADHIRAJA HOMOEPATHIC MEDICAL COLLEGE",
  "SREE KRISHNA COLLEGE, GURUVAYUR",
  "KKTM GOVT. COLLEGE, PULLUT",
  "BABY MEMORIAL COLLEGE OF ALLIED MEDICAL SCIENCES",
  "J.D.T. Islam College of Physiotherapy",
  "POOKOYA THANGAL MEMORIAL GOVT. COLLEGE, PERINTHALMANNA",
  "Hi-Tech Arts and Science College,Vattoli",
  "Kunnamangalam Government Arts and Science College, Chathamangalam",
  "St.Gregorios College, pulamon P.O., Kottarakkara",
  "Sree Ayyappa College, Thiruvanvandoor, Chengannur",
  "MIC ARTS & SCIENCE COLLEGE, VALLUVAMBRAM",
  "Mannaniya College of Arts & Science, Pangode, Thiruvananthapuram",
  "CHERPULASSERY COLLEGE OF SCIENCE & TECHNOLOGY",
  "SNEHA COLLEGE OF ARCHITECTURE, GOVINDAPURAM",
  "KNM Govt. Arts and Science College, Kanjiramkulam",
  "PRS COLLEGE OF NURSING",
  "Chinmaya Arts & Science College for Women",
  "Sree Narayana College of Technology, Vadakkevila, Kollam",
  "COLLEGE OF NURSING THALASSERY",
  "College of Pharmaceuital Sciences, Govt.Medical College, Gandhinagar P.O,  Kottayam 686 008",
  "T.K.M.College of Arts and Science, Kollam",
  "College of Dairy Science and Technology",
  "Sabarigiri College of Education, Anchal, Kollam",
  "BNV College of Teacher Education, Thiruvallam, Thiruvananthapuram",
  "Janey College of Health and Allied Sciences, Eroor, Ernakulam",
  "BAKER COLLEGE FOR WOMEN",
  "School of Management Studies",
  "SAFA ARABIC COLLEGE",
  "School of Management Studies Dr JMC Thrissur",
  "School of Management Studies, Kuttippuram",
  "SALAFIYYA TRAINING COLLEGE, KARINGANAD",
  "M.S.T.M ARTS AND SCIENCE COLLEGE PERINTHALMANNA",
  "MHES COLLEGE OF SCIENCE & TECHNOLOGY, MANIYOOR",
  "Bishop Jerome Institute, Fathima College Road, Kollam",
  "Sree Narayana College, Cherthala",
  "ST. JOSEPH'S COLLEGE (AUTONOMOUS), DEVAGIRI",
  "Ahalia School of Paramedical Sciences",
  "COLLEGE OF APPLIED SCIENCE, KOTTARAKKARA",
  "GREGORIAN INSTITUTE OF TECHNOLOGY",
  "VELANKANNI MATHA COLLEGE OF NURSING, MATHA HOSPITAL",
  "Sree Narayana College, Kollam",
  "SNES INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH, CHETHUKADAVU",
  "MES ARTS AND SCIENCE COLLEGE, KUTTIPPURAM",
  "KVVS College of Science & Technology, Kaithaparambu, Enathu, Adoor",
  "Travancore College of Nursing",
  "TOMS College of Engineering ",
  "UNIVERSITY TEACHER EDUCATION CENTRE, MALAPPURAM",
  "Gurudev Institute of Management Studies, Kottappuram P.O., Kadakkal, Kollam",
  "Sree Narayana College for Women, Kollam",
  "COLLEGE OF APPLIED SCIENCES, PERISSERY, CHENGANNUR",
  "Kesari Government Arts & Science College, North Paravur",
  "Heera College of Engineering and Technology, Panavoor, Nedumangad",
  "ASIAN SCHOOL OF BUSINESS",
  "GOVT. DENTAL COLLEGE ALAPPUZHA",
  "K.V.V.S. Institute of Technology, Kaithaparambu, Adoor.",
  "S.N.Guru Memorial Arts & Science College, Vlamangalam South P.O, Alappuzha",
  "SREE NARAYANA COLLEGE OF ADVANCED STUDIES KUTTANADU, MONCOMPU , THEKKEKARA",
  "SNGIST Group of Institutions",
  "Mannam Memorial Training College, Vilakudy, Kollam",
  "KOTTAKKAL FAROOK ARTS & SCIENCE COLLEGE",
  "Sree Buddha College of Engineering for Women, Ayathil, Elavumthitta P. 0., Pathanamthitta, 689 625",
  "Sree Narayana Gurukulam College of Engineering",
  "S.C.M.S. School of Engineering Technology, Vidyanagar, Palisserry, Karukutty P.O., Ernakulam- 683 582",
  "Saintgits College of Engineering, Kottukulam Hills, Pathamuttam P.O., Kottayam 686532",
  "Rajagiri School of Engineering and Technology, Rajagiri Valley P.O, Kakkanad,  Kochi- 682 039",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, KULATHOOR",
  "ST MARYS COLLEGE",
  "MES COLLEGE OF ENGINEERING & TECHNOLOGY, KUNNUKARA",
  "RAJIV GANDHI INSTITUTE OF SPEECH AND HEARING",
  "Mangalam College of Engineering, Mangalam Hills, Ettumanoor P.O, Kottayam-686 631",
  "K.M.E.A Engineering College, Kuzhivelipady, Edathala, Aluva, Ernakulam 683 561",
  "Ilahia College of Engg. and Technology, Mulavoor P.O., Muvattupuzha, Ernakulam- 686 673",
  "UNIVERSITY TEACHER EDUCATION CENTRE, KODUVAYUR",
  "Govt. Engineering College, Painavu P.O., ldukki- 685  603",
  "MOTHER THERESA COLLEGE",
  "Federal Institute of Science and Technology (FISAT), Hormis Nagar, Mookannoor. P.O., Angamaly, Ernakulam -683 577",
  "SREE NARAYANA LAW COLLEGE, POOTHOTTA",
  "College of Engineering Vadakara",
  "COCHIN INSTITUTE OF SCIENCE & TECHNOLOGY, ETTAPPILLY, ERNAKULAM",
  "Caarmel Engineering College, Perinadu, Ranni- 689 711",
  "COMPOSITE REGIONAL CENTRE FOR SKILL DEVELOPMENT, REHABILITATION AND EMPOWERMENT OF PERSONS WITH DISABILITIES KOZHIKODE",
  "MVR INSTITUTE OF LIFE SCIENCE AND RESEARCH STUDIES",
  "MGM COLLEGE OF PHARMACY",
  "BASELIOS THOMAS I CATHOLICOSE COLLEGE OF ENGINEERING & TECHNOLOGY, SYRIAN PARK, KOOTHATTUKULAM",
  "SRV GOVT COLLEGE OF MUSIC AND PERFORMING ARTS THRISSUR",
  "Al-Azhar College of Engineering & Technology, Perumpillichira, Thodupuzha",
  "Adi Shankara Institute of Engineering and Technology, Sankar Nagar, Mattoor,  Kalady- 683 547",
  "PRISTINE VALLEY COLLEGE OF ARTS AND SCIENCES",
  "Jameela Beevi Centre for Teacher Education, Kayamkulam",
  "ARAFA INSTITUTE FOR TEACHER EDUCATION, ATTUR",
  "MARIA THERESA COLLEGE OF NURSING ",
  "CARMEL COLLEGE",
  "Annoor Dental College and Hospital ,Puthupady, Muvattupuzha.  686 673",
  "College of Applied Sciences, Dhanuvachapuram, Parassala",
  "Haneefa Kunju Memorial College of Education, Umayanalloor P.O.",
  "C.K. RAGHAVAN MEMORIAL COLLEGE OF TEACHER EDUCATION, PULPALLY",
  "JDT ISLAM COLLEGE OF  ARTS & SCIENCE ",
  "S.N. COLLEGE ALATHUR",
  "Muhammed Abdurahiman Memorial Orphanage College",
  "ST DOMINICS COLLEGE OF LAW, KANJIRAPALLY, KOTTAYAM    ",
  "KUNIYA COLLEGE OF ARTS AND SCIENCE",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, MUHAMMA REGIONAL CENTRE, KAYIPPURAM",
  "PK Das Liberal College of Arts and Science",
  "NATIONAL HOMOEOPATHY RESEARCH INSTITUTE IN MENTAL HEALTH",
  "Rajagiri College of Management & Applied Sciences, Kakkanad, Kochi",
  "INDIRA GANDHI MEMORIAL COLLEGE OF NURSING",
  "Mar Baselios Institute of Technology, Anchal, P.O. Kollam.",
  "BAFAKHY Y. B. Ed. COLLEGE, KALPAKANCHERY",
  "SNGIST ARTS AND SCIENCE COLLEGE",
  "Sree Vidyadhiraja College of Arts and Science, Karunagappally",
  "SREE VIVEKANANDA COLLEGE OF TEACHER EDUCATION, AKKIKAVU",
  "Mar Thoma College for the Hearing Impaired, Cherkala",
  "Govt. College for Women, Thiruvananthapuram",
  "ST THOMAS COLLEGE OF NURSING",
  "Mar Thoma Institute of Technology, Chadayamangalam, Ayur, Kollam.",
  "JOSCO COLLEGE OF NURSING",
  "MES Institute of Technology and Management, Chathannoor, Kollam",
  "GOVERNMENT COLLEGE OF NURSING WAYANAD",
  "Sree Narayana College, Chengannur",
  "Bishop Moore College, Mavelikkara, Alappuzha",
  "M.I.TRAINING COLLEGE, PONNANI",
  "SREE NARAYANA INSTITUTE OF TECHNOLOGY ,THEPPUPARA,ADOOR",
  "SAHRDAYA COLLEGE OF ENGINEERING & TECHNOLOGY",
  "Iqbal College, Peringammala",
  "Mar Theophilus Training College, Thiruvananthapuram",
  "NSS College, Nilamel",
  "MAR IVANIOS LAW COLLEGE",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, KURAVANKONAM, THIRUVANANTHAPURAM",
  "DE PAUL INSTITUTE OF SCIENCE AND TECHNOLOGY, DISAT",
  "MES COLLEGE, ERATTUPETTA",
  "National College, Manacaud P.O., Thiruvananthapuram",
  "College of Applied Sciences, Puthenvelikkara P.O, North Paravur Ernakulam- 683 594",
  "Cochin University College of Engineering",
  "M.E.S M.K. MACKAR PILLAY COLLEGE FOR ADVANCED STUDIES, EDATHALA",
  "MAR THOMA COLLEGE, CHUNGATHARA",
  "ANSAR TRAINING COLLEGE, PERUMPILAVU",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY (UIT) ITTIVA",
  "SCHOOL OF MANAGEMENT STIUDIES VATAKARA",
  "MAET  Training College, Nettayam, Thiruvananthapuram",
  "Peet Memorial Training College, Mavelikkara",
  "NATTIKA EDUCATIONAL SOCIETY ARTS AND SCIENCE COLLEGE, NES, TRIPRAYAR SOUTH",
  "SREE SANKARA COLLEGE, NAGAROOR,KILIMANOOR",
  "AKG CO-OPERATIVE INSTITUTE OF HEALTH SCIENCES",
  "KVM College of Arts and Science",
  "MARIAN COLLEGE OF ARCHITECTRUE AND PLANNING",
  "St. Mary's College of Commerce & Management Studies, Thuruthiply, Valayanchirangara, Perumbavoor 683 556",
  "M C Varghese College of Arts & Science, Kumaranalloor",
  "College of Applied Science, Petta, Kanjirappally, Kottayam-686507",
  "Mannam Memorial N.S.S College, Konni, Pathanamthitta- 689 691",
  "St. Thomas Arts & Science College, Puthencruz P.O., Ernakulam -682308",
  "ETCES COLLEGE FOR ADVANCED STUDIES, MANJERI, MALAPPURAM    ",
  "St. Stephen's College, Uzhavoor 686 634",
  "St. Peters Training College, Kolencherry, Ernakulam 682 311",
  "Govt. College, Tripunithura - 682 301",
  "St. Thomas College, Kozhencherry 689 641",
  "St. Joseph College of Communication, Kurisummoodu Changanacherry - 686104",
  "SI-MET College of Nursing, Palluruthy, Ernakulam",
  "Malik Deenar Arts & Science College, Adivadu, Pallarimangalam P.O., Pothanicadu (via), Muvattupuzha, Ernakulam 686 671",
  "CARMELGIRI COLLEGE",
  "De Paul Institute of Science and Technology, De Paul Nagar, Angamaly South 683573",
  "College of Indigenous Food Technology, Anakuthi, Perinjottakkal P.O, Konni, Pathanamthitta- 689 692",
  "SDV COLLEGE OF ARTS AND APPLIED SCIENCE",
  "University College of Engineering, Muttom, Thodupuzha, Idukki",
  "Mar Thoma Teachers Training College, Edakulam, Ranni - 689 672",
  "St. Alberts College, Banerji Road, Ernakulam 682 018",
  "Sree Narayana Arts & Science College, Kumarakom, Kottayam-686 563",
  "MALABAR DENTAL COLLEGE AND RESEARCH CENTRE",
  "University College of Teacher Education, Near Government Boys High School Campus, Vaikom Road, Thrippunithura, Ernakulam",
  "AZEEZIA COLLEGE OF DENTAL SCIENCES & RESEARCH",
  "Aquinas College, Edacochin, Cochin - 682 006",
  "Bishop Vayalil Memorial Holy Cross College, Cherpunkal P.O., Pala   686 584",
  "R Parameswaran Pillai Memorial Arts and Science College",
  "Labour India College of Teacher Education, Marangattupally P.O., Kottayam-686 635",
  "Kuttukaram Polytechnic College, North Paravur",
  "Nirmala Arts & Science College, Nirmala Hills, Mulanthuruthy P.O. Emakulam - 682 314",
  "National College for Teacher Education, Iqbal Square, Mepprathupady.Vengola P.O, Perumbavoor, Ernakulam - 683 554",
  "MERCY COLLEGE OF TEACHER EDUCATION, EDODI, VADAKARA",
  "C.E.T. College of Management, Science & Technology, Airapuram,P.O, Perumbavoor- 683541",
  "Sree Narayana Arts & Science College, Kedamangalam, N.Paravur - 683 513",
  "Mar Gregorios Abdul Jaleel Arts and Science College, North Paravur - 683 513",
  "Porukara College of Education, Gagultha Monastery Campus, Champakulam East P.O, Alappuzha - 688 505",
  "Institute of Nursing Education,SME, Gandhinagar,Kottayam",
  "University College of Teacher Education, Panchayat U.P. School Campus, Nedumkandam, Idukki",
  "RLV College of Music and Fine Arts, Tripunithura",
  "University College of Teacher Education, Government High School Campus, Petta, Kanjirappally, Kottayam",
  "Govt. Sanskrit College, Tripunithura -682 301",
  "LAKSHMI NARAYANA ARTS AND SCIENCE COLLEGE",
  "College of Applied Science (IHRD), Puthuppally",
  "KMCT INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
  "Baja Model College of arts and Science",
  "H. M. Training College, Randarkara P.O. Muvattupuzha 686 673",
  "Indira Gandhi College of Arts and Science, Nellikuzhi P.O., Kothamangalam - 686 691",
  "University College of Teacher Education, Government Higher Secondary School, Thekkekara, Erattupetta, Kottayam",
  "N.S.S College, Rajakumari, Kulapparachal P.O. 685 619",
  "ST THOMAS COLLEGE, THAVALAPPARA, KONNI",
  "St. Xavier's College for Women, Aluva - 683 101",
  "Mar Baselios Dental College, Thankalam, Kothamangalam-686 691",
  "Institute of Nursing Sciences and Research, Malabar Cancer Centre",
  "Rajagiri College of Social Sciences, Kalamassery 683 104",
  "DEVAMATHA COLLEGE OF ADVANCED STUDIES  KANHIRAPUZHA  PALAKKAD DT",
  "P.G.M. College, Devagiri P.O. Kangazha-686 555",
  "University Institute of Technology,Pathiyoor",
  "Sree Vidyadhi Raja N S S College, Vazhoor, Theerthapadapuram P.O, Kottayam- 686 505",
  "Kristu Jyoti College of Management and Technology, Kurisummoodu P.O. Chethipuzha, Changanacherry 686 104",
  "University College of Teacher Education, Government High School Campus, Kudamaloor, Kottayam",
  "College of Applied Science IHRD, Kuttikanam, Peerumedu, - 685 531",
  "Sree Sankara College, Kalady 683 574",
  "St. Joseph College of Teacher Education for Women, Ernakulam ",
  "Bharata Matha College, Thrikkakara P.O. 682 021",
  "ST.JOSEPH'S ACADEMY OF HIGHER EDUCATION AND RESEARCH,MOOLAMATTOM",
  "University College of Nursing, Andoor, Marangattupally P.O., Pala, Kottayam",
  "Santhigiri College of Computer Sciences, Vazhithala P.O., Thodupuzha 685 583",
  "Nazareth College of Pharmacy, Othera, Tiruvalla- 689 546",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, MANNANCHERRY REGIONAL CENTRE",
  "Govt. College, Kattappana - 685 508",
  "Mar Thoma College For Women, Perumbavoor 683 542",
  "B.C.M. College, Kottayam - 686 001",
  "College of Applied Sciences, Anchanadu, Marayoor, Idukki",
  "SRI SATHYA SAI ARTS and SCIENCE COLLEGE",
  "M. E. S College, Marampally, North Vazhakulam, Aluva- 683 107",
  "Newman College, Thodupuzha East- 685 585",
  "St. George's College, Aruvithura- 686 122",
  "M.G. College of Engineering",
  "K.V.M. College of Engineering and Information Technology",
  "Marian College, Kuttikanam P.O. Peermade- 685 531",
  "College of Medical laboratory technology, Lisie medical and educational institutions",
  "College of Engineering,Thrikkaripur",
  "GOVT. ARTS AND SCIENCE COLLEGE,KARUNAGAPPALLY",
  "KMCT COLLEGE OF NURSING, MAMPATTA, KOZHIKKODE",
  "ELIMS COLLEGE OF PHARMACY",
  "College of Engineering ,Thalassery",
  "College of Engineering, Poonjar",
  "ST.MARYs ARTS AND SCIENCE COLLEGE ,CHERUPANATHADY",
  "College of Engineering, Perumon",
  "COLLEGE OF ENGINEERING, PATHANAPURAM",
  "HM COLLEGE OF SCIENCE & TECHNOLOGY, MANJERI",
  "College of Engineering , Munnar",
  "College of Engineering ,Kottarakkara",
  "College of Engineering ,Kidangoor",
  "MAJLIS ARTS & SCIENCE COLLEGE, PURAMANNUR",
  "St. Mary's College, Sulthans Bathery",
  "College of Engineering ,Karunagappally",
  "KUNIYA COLLEGE OF MANAGEMENT AND INFORMATION TECHNOLOGY",
  "REGIONAL COLLEGE OF SCIENCE AND HUMANITIES",
  "College of Engineering ,Kallooppara",
  "College of Engineering, Cherthala",
  "SI MET COLLEGE OF NURSING , KONNI",
  "Toc-H Institute of Science and Technology, Arakunnam",
  "MES T.O. Abdulla Memorial College, Kunnukara",
  "MOSC Institute of Allied Health Sciences",
  "T.K.M.Institute of Technology",
  "Sarabhai Institute of Science and Technology",
  "College of Applied Science IHRD, Pulimoottil Bldg., Moolamattom Road, Thodupuzha 685 584",
  "Sree Narayana College, Sivagiri, Varkala",
  "Sree Sankara Vidyapeetom. College, Valayanchirangara P.O., Perumbavoor - 683 556",
  "CPA COLLEGE OF GLOBAL STUDIES, PUNNATHALA, PUTHANATHANI",
  "AWH SPECIAL COLLEGE, KALLAI",
  "College of Applied Sciences, Nedumkandam, ldukki- 685 553",
  "Mar Baselios College, Adimaly, Idukki 685 561",
  "Model Engineering College,Thrikkakkara",
  "ISS COLLEGE OF TEACHER EDUCATION, PONNIAMKURISSI",
  "SN COLLEGE, VATAKARA",
  "GOVT. LAW COLLEGE, AYYANTHOLE",
  "College of Applied SCience (IHRD), Govt.High School Campus, Mavelikkara",
  "Central Institute of Fisheries, Nautical & Engineering Training (CIFNET)",
  "VISHNU AYURVEDA COLLEGE, SHORNUR",
  "DARUL ULOOM COLLEGE OF TEACHER EDUCATION, VAZHAKKAD",
  "Malankara Orthodox Syrian Church College of Nursing",
  "College of Hospital Administration, DR.S.M.C.S.I Medical college and hospital",
  "CHITRA COLLEGE OF NURSING",
  "ALPHONSA COLLEGE THIRUVAMBADY",
  "MOULANA COLLEGE OF PARAMEDICAL SCIENCES",
  "MES KALLADI COLLEGE, MANNARKKAD",
  "ASSABAH ARTS & SCIENCE COLLEGE, VALAYAMKULAM",
  "K.M. COLLEGE OF TEACHER EDUCATION, VALILLAPUZHA",
  "GEMS ARTS & SCIENCE COLLEGE, PANANAGANGARA",
  "MAR DIONYSIUS COLLEGE, PAZHANJI",
  "CICS COLLEGE OF TEACHER EDUCATION,",
  "Westfort College of Allied Health Sciences",
  "DUXFORD COLLEGE FOR ADVANCED STUDIES, KALIKAVU",
  "LAXMI MEGHAN COLLEGE OF NURSING",
  "SNEHODAYA COLLEGE OF NURSING",
  "ELITE COLLEGE OF NURSING",
  "Mount Zion Nursing College",
  "P K Das College of Nursing",
  "Govt. Medical College, Manjeri",
  "College of Paramedical sciences, EMS Memorial Co-operative Hospital",
  "SREE ANJANEYA COLLEGE OF NURSING",
  "Holy Cross College of Allied Health Sciences",
  "Government Medical College Idukki",
  "Welcare College of Nursing",
  "Sree Sudheendra College of Nursing",
  "MOTHER ARTS & SCIENCE COLLEGE, POOVATHUR",
  "AMAL COLLEGE OF ADVANCED STUDIES, MYLADI",
  "JAWAHARLAL NEHRU INSTITUTE OF ARTS AND SCIENCE",
  "SILVER ARTS & SCIENCE COLLEGE, PERAMBRA",
  "AL SHIFA COLLEGE OF PHARMACY, PERINTHALMANNA",
  "IQRAA INTERNATIONAL HOSPITAL AND RESEARCH CENTRE",
  "ROYAL DENTAL COLLEGE,MANNARAPARAMBA, CHALISSERY",
  "MES KEVEEYAM COLLEGE, VALANCHERI",
  "THUNCHATH EZHUTHACHAN COLLEGE, ELAVANCHERY, NEMMARA",
  "Nehru Academy of Law",
  "SANTHIGIRI SIDHA MEDICAL COLLEGE",
  "College of Engineering ,Chengannoor",
  "RUCKMONI COLLEGE OF NURSING",
  "NOORUL ISLAM COLLEGE OF DENTAL SCIENCES, NEYYATTINKARA",
  "LBS Institute of Technology for Women, Poojappura, Thiruvananthapuram",
  "A.J. College of Science and Technology, Thonnakkal, Thiruvananthapuram",
  "GOVT. COLLEGE, MOKERI",
  "ASWINI COLLEGE OF NURSING",
  "ST. JOSEPH'S TRAINING COLLEGE, PAVARATTY",
  "NSS TRAINING COLLEGE, OTTAPPALAM",
  "Millath College of Teacher Education, Sooranad P.O., Kollam",
  "MAHLARA ARTS AND SCINCE COLLEGE FOR WOMEN, MAVOOR",
  "SREE NARAYANA GURU COLLEGE OF ADVANCED STUDIES, ALATHUR",
  "SREE NARAYANA COLLEGE OF TEACHER EDUCATION,KANNANKARA. P.O, CHELANNUR",
  "St..Cyril's College, Adoor",
  "SI-MET College of Nursing, Uduma, Kasaragod",
  "UIT,VAKKOM,ATTINGAL",
  "LBS MODEL DEGREE COLLEGE (APPLIED SCIENCE)",
  "PEEKAY ARTS & SCIENCE COLLEGE, NALLALAM",
  "Pariyaram Dental College, A.C.M.E. , Pariyaram, Kannur",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, ADOOR",
  "STELLA MARIS COLLEGE OF COMMERCE AND INDUSTRY",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE,ELANTHOOR",
  "Govt Institute for paramedical Sciences Pilathara",
  "Malik Deenar College of Nursing , Thalangara, Kasargod",
  "University College of Engineering, Kariavattom",
  "Baby John Memorial Govt. College, Chavara",
  "Lourdes Matha Institute of Hotel Management  and Catering Technology, Kuttichal, Thiruvananthapuram",
  "DON BOSCO COLLEGE, SULTHAN BATHERY",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, VELLARADA CENTRE",
  "MIMS College of Allied Health Sciences",
  "K T N COLLEGE OF PHARMACY",
  "VINAYAKA COLLEGE OF NURSING",
  "Dr. Moopen's Medical College",
  "REGIONAL CANCER CENTRE, THIRUVANANTHAPURAM",
  "LITTLE FLOWER COLLEGE OF NURSING",
  "KMCT LAW COLLEGE, KUTTIPURAM, VALANCHERY",
  "M.A.O. COLLEGE OF ARTS AND SCIENCE",
  "AYYANKALI MEMORIAL ARTS AND SCIENCE COLLEGE",
  "MOUNT ZION COLLEGE OF PHARMACEUTICAL SCIENCES AND RESEARCH ADOOR",
  "ELIJAH INSTITUTE OF MANAGEMENT STUDIES",
  "JM COLLEGE OF ARTS AND SCIENCE, PANNEKAD, TIRUR",
  "St. Paul's College, Kalamasserry - 683 503",
  "Adi Sankara Training College, Sankar Nagar, Mattoor, Kalady, Ernakulam  - 683 574",
  "University College of Applied Sciences, Edappally, Kochi, Ernakulam",
  "INSTITUTE FOR COMMUNICATIVE AND COGNITIVE NEUROSCIENCES (ICCONS)",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, MANKADA",
  "CHRIST COLLEGE",
  "RAJAGIRI VISWAJYOTHI COLLEGE OF ARTS AND APPLIED SCIENCES",
  "KODIYERI BALAKRISHAN MEMORIAL GOVT. COLLEGE (KBMGC), THALASSERY",
  "EDUCOS ARTS AND SCIENCE COLLEGE",
  "R.SANKAR SMARAKA SREE NARAYANA COLLEGE Nedumkunnam Chanaganachery",
  "MANGALAM SCHOOL OF ARCHITECTURE AND PLANNING",
  "BHARATHAMATHA COLLEGE OF ARTS AND SCIENCE",
  "POYANIL COLLEGE OF NURSING",
  "Patriarch Ignatius Zakka -1 Training College, Malecruz, Puthencruz 682 308",
  "MES DENTAL COLLEGE, PERINTHALMANNA",
  "St.Xaviers Training College for Women, Aluva - 683 101",
  "Maharaja's College, Ernakulam- 682 011",
  "K.M.M. College of Arts & Science, Thrikkakara. Cochin - 682 021",
  "Seth Ram Bahadur Singh Gujarathi College, Gujarathi Road, Kochi - 682 002",
  "Mangalam College of Education, Vettimukal P 0, Ettumanoor 686 631",
  "Holy Cross College of Management and Technology, Puttady, Idukki 685 551",
  "Mar Athanasius College, Kothamangalam- 686 666",
  "Devaswom Board College, Keezhoor. P.O., Vaikom, Kottayam 686 605",
  "ALMAS COLLEGE OF NURSING",
  "Baselios Poulose Second College, Piramadom, Emakulam - 686 667",
  "Govt. College, Munnar- 685 612",
  "University College of Teacher Education, Government High School Campus, Paippad, Changanacherry, Kottayam",
  "PARABRAHMA COLLEGE OF NURSING",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY KANJIRAMKULAM",
  "Nirmala Sadan Training College For Special Education, Muvattupuzha 686 661",
  "D.C. School of Management and Technology, Pullikkanam P.O., Vagamon, ldukki- 685 503",
  "CALICUT UNIVERSITY TEACHER EDUCATION CENTRE VALAPAD",
  "DAKSHINA BHARAT HINDI PRACHAR SABHA, B.ED. TRAINING COLLEGE, AMBADIMALA, ERNAKULAM",
  "MES COLLEGE OF NURSING, PERINTHALMANNA",
  "Emmanuel College, Vazhichal",
  "Sree Narayana College, Kannur",
  "JAMIA NADWIYYA WOMEN'S ARABIC COLLEGE, EDAVANNA",
  "M.E.S. Training College, Edathala North P.O., Aluva, Emakulam- 683 564",
  "AL SALAMA EYE HOSPITAL, PERINTHALMANNA",
  "NAJATH ARTS AND SCIENCE COLLEGE, MANNARKKAD",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, KONDOTTY",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, TANUR",
  "Sree Anjaneya Institute of Dental Sciences",
  "ERANAD KNOWLEDGE CITY COLLEGE OF COMMERCE AND SCIENCES, MANJERI",
  "THIRUHRUDAYA COLLEGE OF NURSING, POOVANTHURUTHU, KOTTAYAM",
  "LITTLE LOURDES COLLEGE OF NURSING",
  "Avila College of Education, Edacochin 682 006",
  "Ilahia College of Arts and Science, Pezhakkappilly P.O. Muvattupuzha -686 674",
  "SANATANA ARTS AND SCIENCE COLLEGE",
  "SREE NARAYANA COLLEGE OF ADVANCED STUDIES, CHELANNUR",
  "SREE GOKULAM ARTS AND SCIENCE COLLEGE, KOOTALIDA, BALUSSERY",
  "College of Applied Science IHRD, Madathil Arcade, Erattayar Road, Kattappana- 685 508",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, CALICUT",
  "KSHM ARTS AND SCIENCE COLLEGE",
  "N S MEMORIAL COLLEGE OF NURSING",
  "LISIEUX COLLEGE OF PARAMEDICAL SCIENCES, MOOKKANNOOR",
  "S.H Colege of Nursing,Grrengardens,Cherthala",
  "CHETANA COLLEGE OF MEDIA AND PERFORMING ARTS",
  "EMEA TRAINING COLLEGE, KONDOTTY",
  "MALABAR CHRISTIAN COLLEGE, KOZHIKKODE",
  "Crescent College of Nursing, Mottambram, Kannur",
  "College of Nursing Kannur Medical College, (A unit of Prestige Educational Trust), Anjarakandy, Post Mamba, Kannur",
  "Govt. Ayurveda College, Kannur",
  "Canossa College of Nursing. St. martin De Porres Hospital, Cherukunnu",
  "AMSTECK Arts & Science College, Kalliassery",
  "Don Bosco Arts & Science College , Angadikkadavu",
  "Keyi Sahib Training College, Karimbam, Taliparamba, Kannur",
  "Malik Deenar Institute of Management Studies , Seethangoli, Kasaragod",
  "P.K.M. College of Education, Kaithapram (P.O), Madampam, Kannur",
  "College of Applied Science, Manjeswaram, Kumbala P.O",
  "SANTHI COLLEGE OF NURSING",
  "S.N.D.P. Yogam Arts & Science College, Near F.C.I, Perole, Nileswar",
  "Nusrathul Islam Arabic College, P.O. Kadavathur, Kannur",
  "HOLY FAMILY COLLEGE OF EDUCATION FOR WOMEN, KODUVAYUR",
  "TKM College of Engineering , Kollam",
  "SUM College of Teacher Education, Mamba, Kannur",
  "S.E.S College Sreekandapuram,Kannur",
  "HOLY GRACE ACADEMY OF ENGINEERING ",
  "Crescent B.Ed college ,Madayipara, P.O. Payangadi",
  "Govinda Pai Memorial Govt. College, Manjeswaram, Kasaragod",
  "CENTRE FOR COSTUME AND FASHION DESIGNING",
  "I.T.M College of Arts & Science , Mayyil",
  "SCHOOL OF HEALTH SCIENCES, UNIVERSITY CAMPUS",
  "College of Agriculture, Vellayanai",
  "MGM TECHNOLOGICAL CAMPUS, VALANCHERY",
  "Govt. College, Attingal",
  "Baselios Poulose II Catholicose College, Piravam",
  "TKM Institute of Management, Karuvelil, Kollam",
  "SNES COLLEGE OF ARTS, COMMERCE AND MANAGEMENT,CHETHUKADAVU, KUNNAMANGALAM",
  "KVASU CENTRE FOR WILDLIFE STUDIES POOKODE",
  "PEEKAY CICS ARTS AND SCIENCE COLLEGE, MATHARA",
  "KMCT COLLEGE OF ARCHITECTURE, MANASSERY",
  "VISWABHARATHI S N ARTS & SCIENCE COLLEGE, NJEEZHOOR",
  "COLLEGE OF APPLIED SCIENCE, THIRUVAMBADI, ",
  "KMCT COLLEGE OF ARCHITECTURE, KALLANTHODE",
  "GOVERNMENT COLLEGE OF NURSING IDUKKI",
  "Henry Baker College, Melukavu, Melukavumattom P.O.-686 652",
  "JPM Arts and Science College, Kanchiyar P.O., Labbakkada, Kattappana 685 511",
  "KERALA UNIVERSITY COLLEGE OF TEACHER EDUCATION  KUNNAM",
  "Sree Narayana Guru College of Engineering & Technology, P.O. Chalakode, Payyanur Kannur",
  "Sadguru Swamy Nithyananda Institute of Technology, Kanhangad",
  "PRIME COLLEGE OF ENGINEERING FOR WOMEN, KADUMBU",
  "NSS COLLEGE OF ENGINEERING, AKATHETHARA",
  "MES COLLEGE KOTHAMANGALAM",
  "KMCT ARTS AND SCIENCE COLLEGE",
  "BHAVAN'S N.A.PALKHIVALA ACADEMY FOR ADVANCED LEGAL STUDIES & RESEARCH,VAZHAYUR",
  "Department of Management, Amritapuri, Kollam",
  "Amrita School of Pharmacy, Kochi",
  "COLLEGE OF APPLIED SCIENCES, THAMARASSERY",
  "KADATHANAD ARTS AND SCIENCE COLLEGE VATAKARA",
  "COLLEGE OF APPLIED SCIENCE AYROOR",
  "ASPIRE COLLEGE OF ADVANCED STUDIES, MUDAVANNUR",
  "SAQAFATHUL ISLAM ARABIC COLLEGE, PARAKKADAVU",
  "IKTM ARTS & SCIENCE COLLEGE, CHERUKULAMBA, VATTALUR",
  "MES ARTS AND SCIENCE COLLEGE, AMAYUR, PATTAMBI",
  "FAROOK INSTITUTE OF MANAGEMENT, FAROOK COLLEGE",
  "V.K.H.M.O. COLLEGE OF ARTS & SCIENCE FOR WOMEN, MUKKAM",
  "SADANAM KUMARAN COLLEGE, MANKARA",
  "PRIYADARSINI ARTS & SCIENCE COLLEGE, MELMURI",
  "CHATHANKULAM IMS, MENONPARA",
  "SALAFIYYA ARABIC COLLEGE, MEPPAYUR, KOYILANDI",
  "ST. XAVIER'S ARTS & SCIENCE COLLEGE, ERANHIPPALAM",
  "COLLEGE OF APPLIED SCIENCES, MALAMPUZHA",
  "NOBLE WOMENS COLLEGE, MANJERI",
  "NASRA COLLEGE OF ARTS AND SCIENCE, TIRURKKAD",
  "COLLEGE OF APPLIED SCIENCES, VADAKKANCHERY",
  "AL SALAMA INSTITUTE OF ARCHITECTURE, MALAPARAMBA",
  "IDEALCOLLEGE OF ARTS & SCIENCE, KUTTIADI",
  "COLLEGE OF APPLIED SCIENCES, AGALI, ATTAPPADI",
  "COLLEGE OF APPLIED SCIENCES, KUZHALMANNAM",
  "North Malabar Institute of Technology , Nelliadukam, P.O Parakalai, Kanhangad, Kasaragod",
  "CHRIST COLLEGE OF PHYSICAL EDUCATION, IRINJALAKKUDA",
  "Amrita School of Ayurveda, Amritapuri, Kollam",
  "Amrita School of Arts and Sciences, Kochi",
  "DON BOSCO COLLEGE , MAMPETTA, MUKKAM, THAMARASSERY",
  "DARUNNUJOOM COLLEGE OF ARTS AND SCIENCE, PERAMBRA",
  "Amrita School of Arts and Sciences, Amritapuri, Kollam",
  "Amrita College of Nursing, Kochi",
  "Amrita Centre for Nanomedical Sciences, Kochi",
  "FAROOK TRAINING COLLEGE",
  "Department of Management, Kochi",
  "CCSIT Peramangalam",
  "ARAFA COLLEGE OF ARTS & SCIENCE, PEZHAKKAPPILLY, MUVATTUPUZHA",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, MANNADY",
  "ST THOMAS COLLEGE OF ADVANCED STUDIES PARACKATHANAM",
  "Kerala University College of Teacher Education, kariavattom",
  "A.K.G. Memorial Co-operative College of Nursing, Mavilayi Kannur",
  "School of Technology & Applied Sciences",
  "MOUNT CARMEL COLLEGE, KARUKADOM, KOTHAMANGALAM",
  "Amrita School of Medicine, Kochi",
  "PALAKKAD INSTITUTE OF MEDICAL SCIENCES, WALAYAR    ",
  "N S S ARTS and SCIENCE COLLEGE,PARAKKULAM,KAPPUR-PALAKKAD DIST-679552",
  "MOULANA COLLEGE OF TEACHER EDUCATION, KUTTAYI",
  "TRIBAL ARTS AND SCIENCE COLLEGE , NADUKANI",
  "CENTER FOR COMPUTER SCIENCE AND INFORMATION TECHNOLOGY PULLUT",
  "CENTRE FOR COMPUTER SCIENCE AND INFORMATION TECHNOLOGY PUTHUKKAD",
  "YMCA COLLEGE, THOTTUMUGHAM, ALUVA",
  "Sri. C. ACHUTHA MENON GOVT. COLLEGE, THRISSUR",
  "ST CLARE COLLEGE FOR THE HEARING IMPAIRED, MANICKAMANGALAM",
  "AL SHIFA COLLEGE OF NURSING, PERINTHALMANNA",
  "SANTHIGIRI INSTITUTE OF MANAGEMENT",
  "ACKHM ICA COLLEGE, THOZHIYUR",
  "NIRMALAGIRI COLLEGE OF ADVANCED STUDIES, KUTHUPARAMBA",
  "SREE NARAYANA COLLEGE OF ARTS AND SCIENCE , KUNDALASSERY, KERALASSERY, PALAKKAD",
  "Rajiv Gandhi Institute of Pharmacy, Meeliyat, Trikaripur, Kasaragod",
  "Natyaveda College of Performing Arts,Vattiyurkavu P.O.- Thiruvanthapuram-13",
  "MAR BASELIOS COLLEGE OF EDUCATION SULTHAN BATHERY WAYANAD",
  "INSTITUTE OF PUBLIC POLICY AND LEADERSHIP",
  "KMM COLLEGE, KUMBALAM, PANANGAD",
  "NEST INSTITUTE OF HUMANITIES AND BASIC SCIENCES",
  "Cochin Arts and Science College,Manakkakadavu , Ernakulam",
  "RED CRESCENT COLLEGE OF NURSING",
  "MALABAR ARTS AND SCIENCE COLLEGE , CHAKKARAKAL ,KANNUR",
  "Morning Star Home Science College, Angamali South P.O. 683 573",
  "PROVIDENCE WOMENS COLLEGE, KOZHIKKODE",
  "INDIRA GANDHI POLYTECHNIC",
  "Century International Institute of- Dental Science and Research Centre, Poinachi,P.O",
  "Government Medical College Kannur",
  "VALLUVANAD INSTITUTE OF  NURSING SCIENCES",
  "St. Joseph's Training College, Mannanam, Kottayam - 686 561",
  "Girideepam Institute of Advanced Learning, Bethany Hills, Vadavathoor P.O Kottayam-686010",
  "Nirmala College, Muvattupuzha - 686 661",
  "Union Christian College, Aluva ",
  "College of Applied Science IHRD, Mallappally West, Pathanamthitta",
  "MES ARTS AND SCIENCE COLLEGE, CHATHANNOOR, KOLLAM",
  "LEYAMMA MEMORIAL COLLEGE OF NURSING",
  "EURO TECH MARITIME ACADEMY",
  "TELLICHERRY INSTITUTE OF ADVANCED STUDIES",
  "Mar Elias College, Kottappady, Kothamangalam",
  "NAVAJYOTHI COLLEGE OF TEACHER EDN.,OLARIKKARA",
  "Mount Carmel College of Teacher Education for Women, Kottayam- 686 004",
  "PG.Radhakrishnan Memorial S.N.College, Channanikkad, Kottayam-686533",
  "V.V. COLLEGE OF SCIENCE & TECHNOLOGY, CHULLIMADA",
  "Institute of Mental Health and Neurosciences (IMHANS)",
  "Mar Thoma College of Management & Technology (MCMAT), Asramam Campus,Perumbavoor - 683 542",
  "Mar Kuriakose Arts & Science College, Koothattukulam, Emakulam-686 662",
  "AI-Azhar College of Arts and Science, Perumpillichira P.O., Thodupuzha - 685 605",
  "TRIKARIPUR ARTS AND SCIENCE COLLEGE,TRIKARIPUR",
  "AVANI INSTITUTE OF DESIGN",
  "St. Thomas College, Ranni, Pazhavangadi P.O. 689 673",
  "KMCT MEDICAL COLLEGE, MUKKAM",
  "KMCT DENTAL COLLEGE, MAMPATTA, KOZHIKKODE",
  "KILA COLLEGE OF DECENTRALISATION AND LOCAL GOVERNANCE    ",
  "Al-Furqan Arabic College",
  "KOCHI BUSINESS SCHOOL, EDACHIRA, THENGODE, KAKKANAD",
  "C.H. Mohammed Koya Memorial Government Arts and Science College",
  "Sanatana Dharma College, Alappuzha",
  "SREE GOKULAM COLLEGE OF ARTS AND SCIENCE  PAZHUVIL WEST",
  "CALICUT UNIVERSITY TEACHER EDUCATION CENTRE  ARANATTUKARA THRISSUR",
  "MPM MSN TRUST COLLEGE, SHORNUR",
  "INDIRA GANDHI INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "St. Benedict's College, Pasukkadavu",
  "SREE NARAYANA GURU COLLEGE, CHELANNUR",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, THENMALA",
  "UIT MULAMKADAKAM KOLLAM",
  "SSM COLLEGE, RAJAKKAD",
  "AWH COLLEGE OF EDUCATION, KALLAI",
  "SIRAJUL HUDA ARTS & SCIENCE COLLEGE,NADAPURAM",
  "Isha Athul Islam Arabic College (Unaided), Parappanangadi",
  "Vimal Jyothi Engineering College, Jyothi Nagar, Chemperi, Kannur",
  "Swamy Saswathikananda College, Poothotta, Poothotta P.O Ernakulam",
  "ELIMS COLLEGE OF ARTS AND SCIENCE",
  "MES COLLEGE OF ARCHITECTURE, KAKKODI, KOZHIKODE",
  "SEVENTH DAY ADVENTIST COLLEGE OF NURSING, OTTAPALAM",
  "SAHRDAYA COLLEGE OF ADVANCED STUDIES, KODAKARA",
  "NAJATH COLLEGE OF SCIENCE & TECHNOLOGY, KARUVARAKUNDU",
  "SNDP SS COLLEGE, PERINTHALMANNA",
  "FALAHIYA ARABIC COLLEGE, MALAPPURAM",
  "GOVERNMENT MEDICAL COLLEGE KOLLAM",
  "ANWARUL ISLAM ARABIC COLLEGE, THIRURKAD",
  "ICNAS, PALLIPOYIL",
  "MARKAZ ORIENTAL COLLEGE, THOTTAKKARA",
  "INDU MEMORIAL TRAINING COLLEGE, KUZHALMANNAM",
  "GOVT. COLLEGE OF PHYSICAL EDUCATION,KOZHIKKODE",
  "ST. THOMAS COLLEGE, THRISSUR",
  "CKG MEMORIAL GOVT. COLLEGE,PERAMBRA",
  "WMO Arts & Science College, Muttil",
  "KMCT COLLEGE OF TEACHER EDUCATION,",
  "MES PONNANI COLLEGE, PONNANI",
  "University College of Medical Education, Manimalakunnu, Ernakulam Dist.",
  "MEA ENGINEERING COLLEGE, CHEMMANIYODE",
  "KMO COLLEGE OF TEACHER EDUCATION,",
  "DE PAUL ARTS AND SCIENCE COLLEGE",
  "SIRAJUL HUDA INSTITUTE OF MANAGEMENT STUDIES",
  "University College of Applied Sciences, Chuttippara, Pathanamthitta",
  "MES COLLEGE, VADAKARA",
  "COLLEGE OF ENGINEERING, ARANMULA",
  "COLLEGE OF APPLIED SCIENCES, NATTIKA",
  "GOVT. COLLEGE, MADAPPALLY",
  "PSMO COLLEGE, THIRURANGADI",
  "SREE NARAYANA COLLEGE OF NURSING",
  "A.V.ABDURAHIMAN HAJI ARTS & SCIENCE COLLEGE,MEPPAYUR",
  "University College of Medical Education, Regional Centre, Municipal Building, Railway Station Road, Angamaly, Ernakulam",
  "BHARATHEEYA VIDYA NIKETHAN COLLEGE OF TEACHER EDUCATION, KALLEKKAD",
  " MES MAMPAD COLLEGE (AUTONOMOUS)",
  "Ambedkar College of Arts and Science, Wandoor",
  "Hillvalley College of Education for Women, Changampuzha Nagar P.O, Thrikkakara, Kochi - 682 033",
  "HDPY College of Education, Mattupuram P.O., Mannam, Ernakulam 683 520",
  "COLLEGE OF APPLIED SCIENCES, IHRD, KILIYANAD",
  "HH Marthoma Mathews II Training College, Adoor",
  "GOVT. COLLEGE PERINGOME",
  "ISS ARTS AND SCIENCE COLLEGE, PONNIAKURISSY",
  "SREE SWAMY VIVEKANANDA CENTRE OF TEACHER EDUCATION, AMBALAPPARA",
  "SSM COLLEGE OF TEACHER EDUCATION, NELLIKKAPARAMBA, MUKKAM",
  "SREE NARAYANA GURU COLLEGE OF ADVANCED STUDIES NATTIKA",
  "MES ARTS & SCIENCE COLLEGE,CHATHAMANGALAM",
  "University College of Teacher Education, Amaravathy P.O., Kumily 685 509, Idukki",
  "University College of Pharmacy, Cheruvandoor, Ettumanoor P.O., Kottayam",
  "St. Marys College for Women, Paliakara, Thiruvalla 689 101",
  "Saintgits College of Applied Sciences, Kottukulam Hills, Pathamuttam P.O., Kottayam-686 532",
  "Sahodaran Ayyappan Memorial College of Education, Poothotta- 682 307",
  "AIM College of Law",
  "SREE NARAYANAGURU COLLEGE OF ADVANCED STUDIES,CHEMPAZHANTHY.",
  "Sree Narayana Guru College of Advanced Studies, Varkala",
  "MATER DEI CMI COLLEGE",
  "AMC Allied Management College",
  "SHAREEATH COLLEGE FOR WOMEN, CHAPPAPARA, CHENAKKALANGADI",
  "PANAKKAD MOHAMEDALI SHIHAB THANGAL ARTS AND SCIENCE   COLLEGE, KUNDOOR",
  "MONTI INTERNATIONAL INSTITUTE OF MANAGEMENT STUDIES, PUTHANANGADI",
  "BHAVANS COLLEGE OF ARTS AND COMMERCE",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, ALAPPUZHA",
  "SREE NARAYANA GURU COLLEGE OF ADVANCED STUDIES CHERTHALA",
  "MAR IVANIOS COLLEGE OF ARTS AND SCIENCE",
  "Titus II Teachers College, Thiruvalla 689 101",
  "KMMMO ARABIC COLLEGE, THIRURANGADI",
  "AL JAMIA ARTS & SCIENCE COLLEGE, PATTIKKAD",
  "KET COLLEGE OF TEACHER EDUCATION,ULLIYERI",
  "ST. JOSEPH'S COLLEGE,  IRINJALAKKUDA",
  "KMO ARTS & SCIENCE COLLEGE, KODUVALLY",
  "saraswathi College of Arts and Science",
  "SREE KERALA VARMA COLLEGE, THRISSUR",
  "GOVT. ARTS & SCIENCE COLLEGE, KOZHINJAMPARA",
  " University Institute of Technology(UIT)  Kallara",
  "Pazhassiraja College, Pulpally",
  "RSM SNDP YOGAM ARTS & SCIENCE COLLEGE, KOYILANDY",
  "GOVT. VICTORIA COLLEGE, PALAKKAD",
  "YUVAKSHETRA INSTITUTE OF MANAGEMENT STUDIES, EZHAKKAD, MUNDUR",
  "Holy Cross Institute of Management and Technology, Kozhikode",
  "MAJMA'S TRAINING COLLEGE, KAVANNUR",
  "PRAJYOTI NIKETAN COLLEGE, PUDUKAD",
  "DHANALAKSHMI COLLEGE OF NURSING",
  "Government College Kasaragod",
  "TKM SCHOOL OF ARCHITECTURE, KARUVELIL, KOLLAM",
  "IDEAL COLLEGE FOR ADVANCED STUDIES, KADAKASSERY, AYANKALAM",
  "LITTLE FLOWER INSTITUTE OF SOCIAL SCIENCES & HEALTH, KAITHAPOYIL",
  "COLLEGE OF APPLIED SCIENCES, IHRD, VATTAMKULAM",
  "FAROOK B. Ed. COLLEGE, CHANGUVETTY",
  "KARUNA MEDICAL COLLEGE, CHITTUR",
  "Kelappaji College of Agricultural Engineering and Food Technology",
  "EDAPPAL HOSPITALS NURSING COLLEGE",
  "BETHANIA INSTITUTE OF MANAGEMENT STUDIES, KUNNAMKULAM",
  "JAMIYA NADAWIYA ARTS & SCIENCE COLLEGE, EDAVANNA",
  "AL HIDAYATH ARABIC COLLEGE, THURAKKAL",
  "GOVT.  COLLEGE, CHITTUR",
  "MINORITY ARTS & SCIENCE COLLEGE, VATTAPARAMBA",
  "ASSABAH ARABIC COLLEGE, PAVITTAPURAM",
  "GOVT. COLLEGE OF TEACHER EDUCATION,",
  "MARKAZ ARTS & SCIENCE COLLEGE, ATHAVANAD",
  "MADEENATHUL ULOOM ARABIC COLLEGE, PULIKKAL",
  "MOUNT SEENA COLLEGE OF ARTS & SCIENCE, LAKKIDI",
  "T.M.JACOB MEMORIAL GOVERNMENT COLLEGE,MANIMALAKUNNU",
  "MES ASMABI COLLEGE, KODUNGALLUR",
  "BISHOP JESUDASAN C.S.I. ARTS AND SCIENCE COLLEGE, MULAYARA",
  "Mount Zion Medical College",
  "EZHUTHACHAN TRAINING COLLEGE, MANNAPRA",
  "CHEMBAI MEMORIAL GOVT. MUSIC COLLEGE, PALAKKAD",
  "Dr...B.R Ambedkar Memorial GOVERNMENT ARTS AND SCIENCE COLLEGE, BALUSSERY",
  "COLLEGE OF APPLIED SCIENCES, IHRD, VAZHAKKAD",
  "INSTITUTE OF MANAGEMENT AND TECHNOLOGY, POTTORE",
  "KARUNA COLLEGE OF NURSING, VILAYODI, CHITTUR",
  "West Fort College of Pharmacy, Pottore, Thrissur",
  "IDEAL ARTS & SCIENCE COLLEGE, KARUMANAMKURUSSI",
  "INSTITUTE OF ADVANCED STUDY IN EDUCATION, THRISSUR",
  "CHINMAYA INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "GOVERNMENT COLLEGE OF NURSING KOZHIKODE",
  "ST. MARY'S  COLLEGE, THRISSUR",
  "JPE TRAINING COLLEGE, KOORKANCHERY",
  "RAHMANIYA ARABIC COLLEGE, KATAMERI",
  "NSS COLLEGE, MANJERI",
  "Baithul Izza Arabic College",
  "CRESCENT COLLEGE OF NURSING, ALATHUR",
  "TIM TRAINING COLLEGE, NADAPURAM",
  "SREE VIVEKANANDA COLLEGE, KUNNAMKULAM, KIZHOOR",
  "SREE VIVEKANANDA PADANA KENDRAM ARTS & SCIENCE COLLEGE, PALEMAD, EDAKKARA",
  "JAWAHARLAL COLLEGE OF ENGINEERING & TECHNOLOGY, MANGALAM",
  "TRAVANCORE DENTAL COLLEGE, KOLLAM",
  "SREE VYASA NSS COLLEGE, VYASAGIRI, WADAKKANCHERY",
  "INSTITUTE OF FASHION TECHNOLOGY KERALA",
  "C. M. College of Arts & Science, Kaithakkal, Panamaram",
  "JUBILEE MISSION MEDICAL COLLEGE, THRISSUR",
  "JUBILEE MISSION COLLEGE OF NURSING, THRISSUR",
  "JDT ISLAM COLLEGE OF PHARMACY",
  "JAMIA SALAFFIYYA COLLEGE OF PHARMACY, PULIKKAL",
  "GRACE COLLEGE OF PHARMACY, ATHALUR, KODUNTHIRAPPALLY",
  "SAHRDAYA INSTITUTE OF MANAGEMENT STUDIES",
  "GURU NARAYANA COLLEGE OF ARTS AND SCIENCE",
  "PROVIDENCE COLLEGE OF ENGINEERING",
  "St. Josephs Institute of Hotel Management and Catering Technology, Choondacherry P.O, Pala, Kottayam-686579",
  "Kumbalathu Sankupillai Memorial Devaswom Board College, Sasthamcotta",
  "CMS College Kottayam",
  "ST. MARY'S COLLEGE, PUTHANANGADI, ANGADIPPURAM",
  "ST. MARYs COLLEGE, BELA",
  "ILAHIYA ARTS & SCIENCE COLLEGE,CHENGOTTUKAVU",
  "kERALA UNIVERSITY COLLEGE OF TEACHER EDUCATION.ARYAD.ALAPPUZHA",
  "JYOTHI ENGINEERING COLLEGE, CHERUTHURUTHY",
  "MAR OSTHATHEOS COLLEGE, PERUMPILAVU",
  "Central Institute of Petrochemicals Engineering & Technology, Kochi (CIPET)",
  "S.N.D.P. Yogam Training College, Adimali, Idukki -685 561",
  "MH College of Arts and Science Kuttiady",
  "MOTHER THERESA COLLEGE OF TEACHER EDUCATION,",
  "GOVT. MEDICAL COLLEGE, KOZHIKKODE",
  "S.N.M College, Maliankrara P.O. Moothakunnam (via) 683 516",
  "COLLEGE OF APPLIED SCIENCES, KODUNGALLUR",
  "Muthoot Institute of Technology and Science,Varikoli P.O., Putencruz- 682308, Ernakulam",
  "BSS B. Ed. TRAINING COLLEGE, ALTHUR",
  "Govt. College, Nattakom, Kottayam-686013",
  "St. Aloysius College, Edathua - 689 573",
  "MMS Govt Arts and Science College",
  "ABILITY ARTS AND SCIENCE COLLEGE FOR HEARING IMPAIRED",
  "LUMINOUS ARTS AND SCIENCE COLLEGE",
  "University College of Pharmacy, Thalappady, Kottayam",
  "College of Pharmaceutical Sciences",
  "KODUNGALLUR VIDWATHPEETHAM",
  "THANTHRA VIDYAPEEDHAM",
  "GOVT. COLLEGE OF FINE ARTS, THRISSUR",
  "NIRMALA COLLEGE OF HEALTH SCIENCE",
  "ANSAR ARABIC COLLEGE, VALAVANNUR",
  "SNEHA COLLEGE OF TEACHER EDUCATION, ATTAYAMPATHY",
  "SREE NARAYANA COLLEGE OF MANAGEMENT STUDIES PERIYA,KASARAGOD",
  "GOVT. HOMEOPATHIC MEDICAL COLLEGE, KARAPARAMBA",
  "GOVT. DENTAL COLLEGE, KOZHIKKODE",
  "PVS COLLEGE OF NURSING, KOZHIKKODE",
  "FAROOK COLLEGE AUTONOMOUS, KOZHIKODE",
  "GOVT. COLLEGE OF NURSING, VELAPPARA",
  "CHRIST COLLEGE, IRINJALAKKUDA",
  "SNDP Yogam Arts & Science College, Pulpally",
  "NAIPUNNYA INSTITUTE OF MANAGEMENT AND INFORMATION TECHNOLOGY, KORATTY",
  "Lourdes Matha College of Science and Technology, Kuttichal, Thiruvananthapuram",
  "INSTITUTE OF LIBRARY AND INFORMATION SCIENCE",
  " DC SCHOOL OF ARCHITECTURE AND DESIGN",
  "GURUVAYOOR CAMPUS",
  "Kannur Medical College, Anjarakandy, Post Mamba, Kannur",
  "Travancore Engineering College, Oyoor, Kollam",
  "Kannur Dental  College, Anjarakandy, P.O. Mamba",
  "UIT KATTAYIKONAM",
  "Kannur Salafi B. Ed. College, Chekkikulam , Kannur",
  "SREEKRISHNAPURAM V.T.BHATTATHIRIPPAD COLLEGE, MANNAMPATTA",
  "Co-operative Institute of Health Sciences, Thalassery.",
  "NATIONAL COLLEGE OF ARTS AND SCIENCE, PULIYAVU",
  "Baselius College, Kottayam-686 001",
  "Mar Athanasios College for Advanced Studies, Tiruvalla",
  "Siena College of Professional Studies, Edakochi P.O., Kochi 682010",
  "AL-AMEEN COLLEGE OF MEDICAL SCIENCES",
  "GOVT ARTS AND SCIENCE COLLEGE THOLANUR",
  "LEAD COLLEGE OF MANAGEMENT, DHONI",
  "M DASAN ARTS AND SCIENCE COLLEGE ULLIYERI",
  "College of Nursing, ACME, Pariyaram, Kannur",
  "ST.GREGORIOS COLLEGE OF HEALTH SCIENCE",
  "KERALA UNIVERSITY COLLEGE OF TEACHER EDUCATION, KAYAMKULAM",
  "KERALA UNIVERSITY COLLEGE OF TEACHER EDUCATION,  ANCHAL",
  "GOVERNMENT DENTAL COLLEGE, THRISSUR",
  "SREE NARAYANA COLLEGE OF TEACHER EDUCATION, KOTTAPPURAM",
  "Nangelil Ayurveda Medical College, Nellikuzhy P.O., Kothamangalam- 686 691",
  "Govt. Ayurveda College, Dhanwanthari Nagar, Tripunithura 682 301",
  "MCT TRAINING COLLEGE, MELMURI",
  "KERALA INSTITUTE OF HOSPITALITY MANAGEMENT, THALASSERY, KANNUR",
  "BHAVAN'S INSTITUTE  OF EDUCATION, RAMANATTUKARA",
  "PNNM AYURVEDA MEDICAL COLLEGE, CHERUTHURUTHY",
  "HOLY GRACE ACADEMY OF MANAGEMENT STUDIES, MALA",
  "COLLEGE OF APPLIED SCIENCES, AYALUR",
  "SCHOOL OF MEDICAL EDUCATION,MANIMALAKKUNNU",
  "Ahalia School of Optometry & Research Centre",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY REGIONAL CENTRE PARAVUR ",
  "BAITHUL IZZA ARTS & SCIENCE COLLEGE, NARIKKUNI",
  "KMCT INSTITUTE OF PHARMACY, KUTTIPURAM, MALAPPURAM",
  "Mookambika College of Parmaceutical Sciences and Researches",
  "NIRMALA COLLEGE OF NURSING, KOZHIKKODE",
  "NEHRU COLLEGE OF PHARMACY, PAMBADY",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, Bharanikavu",
  "K.M.M Govt Women's College , Kannur",
  "College of Dairy Science and Technology, Pookode",
  "EUPHRASIA TRAINING COLLEGE, IRINJALAKKUDA",
  "COLLEGE OF APPLIED SCIENCES, IHRD, MUNDUPARAMBA",
  "NATIONAL HOSPITAL COLLEGE OF NURSING, KOZHIKKODE",
  "NAMBOODIRI'S COLLEGE OF TEACHER EDN., IRINJALAKKUDA",
  "UNITY COLLEGE OF ARTS AND SCIENCE, THALIKKULAM, TRISSUR",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY MANNAR",
  "Holy Family College of Nursing, Muthalakodam P.O., Thodupuzha,ldukki -685 605",
  "MAWLANA ABUL KALAM AZAD COLLEGE OF SOCIAL SCIENCES, PATTERKULAM, MANJERI, MALAPPURAM ",
  "SREE VIVEKANANDA COLLEGE OF TEACHER EDUCATION, PALEMAD",
  "Dr. PALPU MEMORIAL SNDP YOGAM COLLEGE OF EDUCATION, KODUNGALLUR",
  "SANJO COLLEGE OF NURSING AND ALLIED SCIENCES",
  "P K DAS INSTITUTE OF MEDICAL SCIENCES",
  "Parassinikadavu Ayurveda Medical College, Parassinikadavu",
  "N.S.S Hindu College, Changanacherry- 686 102",
  "Govt Arts and Science College Nilambur",
  "PANAMPILLY MEMORIAL GOVERNMENT COLLEGE, CHALAKUDY",
  "CAPE COLLEGE OF NURSING PATHANAPURAM",
  "University College of Teacher Education, Government High School Campus, Thodupuzha, Idukki",
  "Government Arts and Science College, Pathirippala",
  "CENTRE FOR P.G.STUDIES IN SOCIAL WORK,SULTHAN BATHERY,WAYANAD",
  "MET COLLEGE, NADAPURAM",
  "Sree Anjaneya college of paramedical sciences",
  "SUSRUTA SCHOOL OF OPTOMETRY AND VISUAL SCIENCES ",
  "Nirmala College of Pharmacy, Muvattupuzha - 686 661",
  "NATIONAL COLLEGE OF PHARMACY",
  "MOTHER COLLEGE OF NURSING, THRISSUR",
  "ILAHIA LAW COLLEGE",
  "SANTHI INSTITUTE OF ALLIED HEALTH SCIENCES",
  "ZAMORIN'S GURUVAYURAPPAN COLLEGE, KOZHIKKODE",
  "JALALIYA WOMENS ARABIC COLLEGE, KUTTIKKATTUR",
  "MIMS COLLEGE OF NURSING, VAZHAYUR",
  "TALIPARAMABA CO OPERATIVE COLLEGE OF NURSING",
  "AHALIA SCHOOL OF MANAGEMENT, KOZHIPPARA",
  "ALPHONSA ARTS AND SCIENCE COLLEGE, SULTHAN BATHERY",
  "SDSM WOMENS COLLEGE, VELLANUR, KOZHIKODE",
  "UIT VALLAKKADAVU",
  "University Institute of Management, Kollam",
  "ST TERESAS EDUCATIONAL AND CHARITABLE TRUST, KOTTAKAL,MALA, MUKUNDAPURAM",
  "GURU NITHYA CHAITHANYA YATHI COLLEGE OF LAW AND RESEARCH CENTRE",
  "PARAMEKKAVU COLLEGE OF ARTS AND SCIENCE THRISSUR",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, CHELAKKARA",
  "SNES KALLYANI COLLEGE, KARIMPUZHA, OTTAPPALAM",
  "JAMIA NADAWIYYA COLLEGE OF TEACHER EDUCATION, EDAVANNA",
  "DARUL ULOOM ARABIC COLLEGE, VAZHAKKAD",
  "EMEA ARTS & SCIENCE COLLEGE, KONDOTTY",
  "Indira Gandhi Co-operative Nursing College, Gandhinagar,Cochin - 682 020",
  "SREE SASTHA COLLEGE, EDAKKAD",
  "St. Thomas College of Teacher Education, Pala 686 575",
  "University College of Teacher Education, Government Model High School Campus, Muvattupuzha, Ernakulam",
  "Mar Augusthinose College, Ramapuram Bazar P.O., Kottayam-686 576",
  "College of Applied Science (IHRD), Njeezhoor P.O., Kaduthuruthy",
  "Ettumanoorappan College, Ettumanoor - 686 631",
  "Theophilus College of Nursing, MGDM Hospital, Kangazha, Devagiri P.O.  Kottayam- 686 555",
  "University College of Teacher Education, Vocational Higher Secondary School Campus, Elanthoor, Pathanamthitta",
  "MES MEDICAL COLLEGE, PERINTHALMANNA",
  "University College of Nursing, Nedumkandam, Idukki",
  "NETHAJI MEMORIAL ARTS AND SCIENCE COLLEGE, NENMARA",
  "KMCT INSTITUTE OF EMERGING TECHNOLOGY AND MANAGEMENT",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, THRITHALA",
  "SCHOENSTATT ACADEMY",
  "CALICUT UNIVERSITY TEACHER EDUCATION CENTRE,KANIYAMBETTA",
  "TALENT INSTITUTE OF MANAGEMENT STUDIES, MUDUR, EDAPAL",
  "PANAKKAD POOKKOYA THANGAL MEMORIAL ARTS AND SCIENCE,COLLEGE, CHERUR, VENGARA",
  "College of Applied Sciences, Konni",
  "MOULANA COLLEGE OF ARTS, SCIENCE AND COMMERCE KUTTAYI,TIRUR",
  "MALABAR COLLEGE OF COMMERCE AND SCIENCE, MANOOR,CHEKANOOR ROAD",
  "MALABAR COLLEGE OF ADVANCED STUDIES, VENGARA",
  "NIRMALA COLLEGE OF ENGINEERING TECHNOLOGY AND MANAGEMENT",
  "College of Pharmacy Kannur Medical College",
  "ST. JOHNS COLLEGE OF PHARMACEUTICAL SCIENCES AND RESEARCH, KATTAPPANA",
  "Malankara Orthodox Syrian Church Medical College, Kolenchery, Ernakulam- 682 311",
  "ST THOMAS COLLEGE OF ALLIED HEALTH SCIENCES",
  "HOLY QUEEN COLLEGE OF PHARMACEUTICAL SCIENCES AND RESEARCH",
  "MUTHOOT COLLEGE OF ALLIED HEALTH SCIENCES",
  "MOUNT ZION INSTITUTE OF MANAGEMENT",
  "INSTITUTE OF ENGINEERING AND TECHNOLOGY, (CUIET), KOHINOOR",
  "Kerala University College of Teacher Education, Kumarapuram, Thiruvananthapuram",
  "Amal Jyothi College of Engineering, Kanjirappally, Koovapally PO, Kottayam-686518",
  "M G M college Of Engineering and Technology",
  "Vedavyasa College of Arts and Science, Karad Paramba, Malapprlram",
  "University Institute of Management, Adoor",
  "KMCT COLLEGE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "University Institute Of Management,Varkala",
  "THEJUS ENGINEERING COLLEGE, ERUMAPPETTI",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, UNIVERSITY OF KERALA, NEYYATTINKARA REGIONAL CENTRE",
  "ROYAL COLLEGE OF ENGINEERING & TECHNOLOGY, AKKIKAVU,THRISSUR",
  "University Institute of Management  Kundara",
  "IMDR College of Advanced Studies",
  "INSTITUTE OF AGRICULTURAL TECHNOLOGY AND REGIONAL AGRICULTURAL RESEARCH STATION PATTAMBI",
  "University institute of technology vallakkadavu",
  "MARKAZ COLLEGE  OF ARTS & SCIENCE ,KARANTHUR,KOZHIKODE",
  "DIVINE INSTITUTE OF MEDIA SCIENCE (DiMS)",
  "Govt. Law College, Ernakulam 682 011",
  "SREE GOKULAM INSTITUTE OF PARAMEDICAL SCIENCES",
  "KANNUR UNIVERSITY TEACHER EDUCATION CENTER KASARAGOD",
  "SREE DHARMA SASTHA COLLEGE OF ARTS AND SCIENCE",
  "Marian College of Arts and Science",
  "Vypin Government Arts and Science College",
  "KMM LAW COLLEGE, THRIKKAKARA",
  "MARKAZ LAW COLLEGE",
  "GLOBAL INSTITUTE OF ARCHITECTURE",
  "St. Joseph's College of Engg. and Technology,Choondacherry P.O., PIassanal (Via), Palai, Kottayam-686 579",
  "Viswajyothi College of Engineering and Technology, Vazhakulam P.O., Muvattupuzha , Ernakulam- 686 670",
  "Kerala University College Of Teacher Education  Kulakkada ",
  "CALICUT UNIVERSITY TEACHER EDUCATION CENTRE, POOMALA, SULTHAN BATHERY",
  "CALICUT UNIVERSITY TEACHER EDUCATION CENTRE, NATTIKA",
  "ALBERTIAN INSTITUTE OF SCIENCE & TECHNOLGY (AISAT)- TECHNICAL CAMPUS",
  "ANVARUL ISLAM ARABIC COLLEGE, KUNIYIL, AREACODE",
  "IMT LAW COLLEGE ",
  "ACE COLLEGE OF ENGINEERING, THIRUVALLAM",
  "AHALIA SCHOOL OF ENGINEERING & TECHNOLOGY, KOZHIPPARA",
  "AL AMEEN ENGINEERING COLLEGE, KULAPPULLI",
  "RAJADHANI INSTITUTE OF SCIENCE & TECHNOLOGY",
  "AWH ENGINEERING COLLEGE, KUTTIKKATTOOR",
  "AXIS COLLEGE OF ENGINEERING AND TECHNOLOGY, MURIKKINGAL",
  "Baselios Mathew II College of Engineering, Sasthamcottah, Kollam",
  "College of Engineering and Technology, Payyannur",
  "ERANAD KNOWLEDGE CITY TECHNICAL CAMPUS, CHERUKULAM, MANJERI",
  "GOVERNMENT ENGINEERING COLLEGE, SREEKRISHNAPURAM",
  "Govt. College of Engineering, P.O. Parassinikadavu, Kannur",
  "Govt. College of Engineering, Wayanad, P.O. Thalappuzha, Mananthavady",
  "GOVT. ENGG COLLEGE, THRISSUR",
  "GOVT. ENGINEERING COLLEGE, WEST HILL",
  "I.E.S. COLLEGE OF ENGINEERING,CHITTILAPPILLY",
  "St Thomas College of Engineering and Technology, Mattannur",
  "UNIVERSAL ENGINEERING COLLEGE, VALIVATTAM",
  "VEDAVYASA INSTITUTE OF TECHNOLOGY, PONNEMPADAM",
  "VIDYA ACADEMY OF SCIENCE & TECHNOLOGY, PUNNUKARA",
  "KMCT ENGINEERING COLLEGE, MANASSERY, MUKKAM",
  "KMCT ENGINEERING COLLEGE (WOMEN), MUKKAM",
  "L.B.S College of Engineering , Kasaragod",
  "MALABAR COLLEGE OF ENGG & TECH., DESHAMANGALAM",
  "Malabar Institute of Technology, Anjarakandi, Kannur",
  "M.DASAN INSTITUTE OF TECHNOLOGY, ULLIYERI",
  "MET COLLEGE OF ENGINEERING, MALA",
  "NATIONAL INSTITUTE OF ELIT, REC, KOZHIKKODE",
  "NEHRU COLLEGE OF ENGINEERING AND RESEARCH CENTRE, PAMBADY",
  "INDIRA GANDHI LAW COLLEGE, NELLIKUZHY, KOTHAMANGALAM, ERNAKULAM",
  "University College of Nursing, Thalappady, Kottayam",
  "KMCT ARTS AND SCIENCE COLLEGE, KUTTIPPURAM",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, MUTHUKULAM",
  "CARMEL COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "COLLEGE OF ARCHITECTURE TRIVANDRUM",
  "College of Engineering and Management, Vadackal P.O., Punnappara, Alappuzha",
  "Govt. Engineering College, Barton Hill, Thiruvananthapuram",
  "PANKAJAKASTHURI AYURVEDA MEDICAL COLLEGE",
  "NIGHTINGALE COLLEGE OF NURSING",
  "MAR DIOSCORUS COLLEGE OF PHARMACY, ALATHARA",
  "KIMS COLLEGE OF NURSING",
  "GOVERNMENT DENTAL COLLEGE",
  "ARCHANA COLLEGE OF NURSING, ARCHANA HOSPITAL COMPLEX",
  "VELLAPPALLY NATESAN SHASHTIABDAPOORTHI SMARAKA COLLEGE OF NURSING",
  "SREE GOKULAM MEDICAL COLLEGE AND RESEARCH FOUNDATION",
  "SARASWATHY COLLEGE OF NURSING",
  "DIVINE LAW COLLEGE PATHANAMTHITTA",
  "NIMS COLLEGE OF NURSING",
  "GOVERNMENT HOMEOPATHIC MEDICAL COLLEGE",
  "GOVERNMENT COLLEGE OF NURSING",
  "ST JOSEPH's COLLEGE OF PHARMACY, NAIPUNYA ROAD",
  "MANNAM AYURVEDA CO-OPERATIVE MEDICAL COLLEGE",
  "GOVERNMENT COLLEGE OF NURSING",
  "BABY MEMORIAL COLLEGE OF NURSING, KOZHIKODU",
  "EZHUTHACHAN COLLEGE OF PHARMACEUTICAL SCIENCES, MARAYAMUTTOM,",
  "DR SOMERWELL MEMORIAL CSI MEDICAL COLLEGE",
  "CSI COLLEGE OF NURSING",
  "CO-OPERATIVE COLLEGE OF NURSING",
  "COLLEGE OF NURSING, ANANTHAPURI HOSPITALS AND RESEARCH INSTITUTE",
  "MERCY COLLEGE OF NURSING",
  "VIJAYA COLLEGE OF NURSING, NEELESWARAM",
  "AZEEZIA INSTITUTE OF MEDICAL SCIENCES AND RESEARCH",
  "KVM INSTITUTE OF PARAMEDICAL SCIENCES, CHERTHALA",
  "KVM COLLEGE OF NURSING",
  "UIT AROOR",
  "SREE NARAYANA INSTITUTE OF AYURVEDIC STUDIES AND RESEARCH",
  "KMEA COLLEGE OF ARTS AND SCIENCE, KUZHIVELIPPADY, ALUVA EAST",
  "ST ANNs COLLEGE, ANGAMALY, ALUVA",
  "COOPERATIVE SCHOOL OF LAW VENGALLOOR, THODUPUZHA",
  "SANJO COLLEGE MULLAKKANAM, RAJAKKAD, ADIMALY",
  "SREE NARAYANA COLLEGE OF ARTS AND SCIENCE, PARATHOD, KONNATHADY, UDUMBANCHOLA",
  "MOUNT ROYAL COLLEGE, SOORYANELLI, CHINNAKANAL, UDUMBANCHOLA",
  "ST JOHN OF GOD COLLEGE FOR SPECIAL EDUCATION , VELLOOR, PAMPADY",
  "MOUNT ZION LAW COLLEGE, KK NAIR ROAD NEAR GENERAL HOSPITAL PATHANAMTHITTA",
  "SREE NARAYANA ARTS AND SCIENCE COLLEGE OTHARA KUTTOOR, THIRUVALLA",
  "SNDP YOGAM ARTS AND SCIENCE COLLEGE ATTACHAKKAL, KONNI",
  "SREE NARAYANA GURU COLLEGE OF ADVANCED STUDIES, MEZHUVELI, KOZHENCHERRY",
  "College of Engineering, Attingal",
  "ST ANTONYs COLLEGE, PERVANTHANAM, PEERUMEDU",
  "SREE NARAYANA GURU COLLEGE OF ADVANCED STUDIES, PAMPANAR, PEERUMADE",
  "AMAN COLLEGE OF SCIENCE & TECHNOLOGY, PAIPPAD, CHANGANASSERY",
  "JAYASREE ARTS AND SCIENCE COLLEGE, PULPALLY",
  "NAJEETH ROYAL COLLEGE OF ARTS AND SCIENCE,CHERUNNIYOOR,VARKALA",
  "AYYAPPA INSTITUTE OF MANAGEMENT STUDIES",
  "KMEA COLLEGE OF ARCHITECTURE",
  "Institute of Communication and Journalism",
  "BHARATA MATA COLLEGE OF COMMERCE AND ARTS",
  "COLLEGE OF FOOD TECHNOLOGY",
  "SCMS SCHOOL OF ARCHITECTURE",
  "ALAZHAR LAW COLLEGE",
  "APJ ABDUL KALAM SCHOOL OF ARCHITECTURE",
  "MCT College of Legal Studies",
  "RAJADHANI INSTITUTE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "Younus College of Engineering and Technology, Vadakkevila, Kollam",
  "DR JOSEPH MAR THOMA INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH",
  "Valiya Koonambaikulathamma College of Engineering and Technology, Chavarcode, Parippally P.O., Thiruvananthapuram",
  "TRINITY COLLEGE OF ENGINEERING",
  "ST.Thomas College of Engineering and Technology, Kozhuvalloor P.O., Chengannur",
  "KARUNA COLLEGE OF PHARMACY",
  "KVM College of Pharmacy",
  "Sree Chitra Thirunal College of Engineering, Pappanamcode, Thiruvanthapuram",
  "Sree Buddha College of Engineering, Pattoor P.O., Nooranad, Alappuzha",
  "Nucleus College of Arts and Science Muthuthala , Pattambi",
  "MALIK DEENAR COLLEGE OF GRADUATE STUDIES",
  "Muslim Association College of Arts and Science",
  "SRI SARADA COLLEGE OF NURSING, SASTHAMANGALAM, TRIVANDRUM",
  "WOMENS ISLAMIYA ARTS AND SCIENCE COLLEGE",
  "Labour India College",
  "Malabar Arts and Science Collegefor Women,Chekkiad",
  "GREGORIAN COLLEGE OF ADVANCED STUDIES",
  "GOLDEN HILLS ARTS AND SCIENCE COLLEGE, ELETTIL",
  "Mount Zion Institute of Science and Technology , Kozhyvalloor, Chengannur",
  "MOR IVANIAN COLLEGE",
  "Shahul Hameed Memorial Engineering College, Kadakkal, Kollam",
  "SREE NARAYANA GURU COLLEGE OF ADVANCED STUDIES",
  "Rajadhani Institute of Engineering and Technology, Alamcode, Attingal",
  "PRS College of Engineering and Technology, Dalumukham, Neyyattinkara",
  "Muslim Association College of Engineering, Venjaramoodu, Thiruvananthapuram",
  "Musaliar College of Engineering, Chirayinkeezhu, Thiruvananthapuram",
  "Mohandas College of Engineering &Technology, Nedumangad, Thiruvananthapuram.",
  "Marian Engineering College, Thiruvananthapuram",
  "Mar Baselios College of Engineering and Technology, Nalanchira, Thiruvananthapuram",
  "BAFAKY YATHEEM KHANA ARTS & SCIENCE COLLEGE OF WOMEN, KALPAKANCHERY",
  "K.R.Gouri Amma College of Engineering for Women, Valamangalam South P.O., Thuravoor, Alappuzha",
  "Hindustan College of Engineering, Arippa, Kulathupuzha, Kollam",
  "VTM NSS College, Dhanuvachapuram",
  "St Josephs Academy of Higher Education and Research",
  "Government Arts and Science College, Ollur",
  "ELDHO MOR BASELIOS COLLEGE,MEENANGADI",
  "SREE NARAYANA LAW COLLEGE",
  "Vedavyasa college of Architecture",
  "Centre for Computer Science and Information Technology Regional Centre  Manjeri",
  "CHAITHANYA INSTITUTE OF OPTOMETRY AND VISION SCIENCES    ",
  "CO OPERATIVE COLLEGE OF NURSING PAYYANUR    ",
  "DR TONYS SCHOOL OF OPTOMETRY ALUVA",
  "Centre for Computer Science and Information Technology",
  "COLLEGE OF ENGINEERING MUTTATHARA",
  "HOLY CRESCENT COLLEGE OF ARCHITECTURE, SOUTH VAZHAKKULAM, ALUVA",
  "MARIAN INTERNATIONAL INSTITUTE OF MANAGEMENT, KUTTIKKANAM",
  "KOTTAYAM INSTITUTE OF TECHNOLOGY & SCIENCE, CHENGALAM EAST, ANICKAD",
  "BELIEVERS CHURCH MEDICAL COLLEGE",
  "Pushpagiri College of Dental Sciences, Medicity, Perumthuruthy, Thiruvalla -689107",
  "School of Engineering",
  "Christ Nagar College, Maranalloor",
  "NAIPUNNYA BUSINESS SCHOOL",
  "CALICUT UNIVERSITY TEACHER EDUCATION CENTRE-MANJERI",
  "CCS AND IT , PALAKKAD",
  "Centre for Computer Science and Information Technology",
  "CENTRE FOR COMPUTER SCIENCE AND INFORMATION TEHNOLOGY MUTTIL",
  "UNIVERSITY TEACHER EDUCATION CENTRE, CALICUT",
  "HINDUSTAN COLLEGE OF PHARMACY",
  "ORIENTAL COLLEGE OF TEACHER EDUCATION,",
  "Triveni Institute of Pharmacy",
  "SREE NARAYANA GURU COLLEGE OF LEGAL STUDIES ",
  "University Institute of Technology, Yeroor",
  "School of Management Studies Palakkad",
  "SCHOOL OF MANAGEMENT STUDIES ",
  "SCHOOL OF ARCHITECTURE  MOOKAMBIKA TECHNICAL CAMPUS",
  "Grace International Academy",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY REGIONAL CENTRE PALLICKAL VARKALA",
  "Holy Grace Academy of Pharmacy",
  "AMALA COLLEGE OF NURSING, THRISSUR",
  "John Paul Memorial B.Ed College, Labbakkada",
  "CENTRE FOR COMPUTER SCIENCE AND IT, UNIVERSITY CAMPUS",
  "Centre for Computer Science and Information Technology Dr John Matthai Centre Aranattukara Thrissur",
  "GOVT. COLLEGE, MALAPPURAM",
  "Al-Azhar Dental College, Perumpillichira P.O, Thodupuzha- 685 605",
  "COLLEGE OF APPLIED SCIENCES,IHRD, KALLACHI",
  "COLLEGE OF APPLIED SCIENCES, IHRD, MUTHUVALLUR",
  "Athurasramam N. S. S. Homeo Medical College, Sachivothamapuram P.O.,  Kottayam - 686 532",
  "Bahuleyan Charitable Foundation College of Nursing, Chemmanakary, Vaikom, Kottayam",
  "BCF College of Phsiotheraphy, Chemmanakary, Akkarapadam P.O, Vaikom,  Kottayam -686143",
  "Carithas College of Nursing, Thellakom P.O. Kottayam 686016",
  "Chemists College of Pharmaceutical Sciences and Research, Varikkoly, Puthencruz, Ernakulam - 682 308",
  "College of Nursing, Medical Trust Hospital, HOC Township Back Side Road, Irimpanam P.O., Ernakulam - 682 308",
  "Dr. Padiyar Memorial Homoeopathic Medical College, Chottanikkara, Ernakulam- 682 312",
  "Shermount College Of Arts And Commerce",
  "LE-MENT COLLEGE OF ADVANCED STUDIES,PALAKKAD",
  "Govt. College of Nursing, Medical College, Gandhi Nagar P.O. Kottayam 686 006",
  "Govt. Dental College, Gandhinagar P.O., Kottayam-686008",
  "Lissie College of Nursing, Lissie Hospital, P B No. 3053 Ernakulam 682  018",
  "Little Flower College of Nursing, Angamaly, Ernakulam- 683 572",
  "Little Flower Institute of Medical Science and Research , Angamaly",
  "Mar Baselios College of Nursing, Kothamangalam- 686 691",
  "Mar Gregorios Memorial Muthoot College of Nursing, Pathanamthitta",
  "Mar Sleeva College of Nursing, Cherpumkal, Pala - 686 584",
  "ANSAR WOMEN'S COLLEGE, PERUMPILAU",
  "Medical College, Gandhinagar. P.O, Kottayam- 686 008",
  "N.S.S. COLLEGE, OTTAPPALAM",
  "KSHM TRAINING COLLEGE, EDATHANATTUKARA",
  "Medical Trust Institute of Medical Sciences, Emakulam",
  "Muthoot College of Nursing, Kozhencherry, Pathanamthitta- 689 641",
  "Pushpagiri College of Nursing, Pushpagiri Medical College Hospital, Tiruvalla 689 101",
  "College of Co-Operation Banking & Management, Vellanikkara",
  "UIT CHENGANNUR",
  "UIT SASTHAMCOTTA",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY,REGIONAL CENTRE,AZHOOR",
  "MGM College of Arts and Science",
  "LISIE COLLEGE OF PHARMACY",
  "Al-Azhar College of Pharmacy",
  "Pushpagiri College of Pharmacy, M.C. Road, Perumthuruthy P.O., Thiruvalla- 689 107",
  "St. Peter's College, Kolenchery- 682 311",
  "College of Pharmaceutical Sciences, T D MEDICAL COLLEGE",
  "Pushpagiri Institute of Medical Sciences and Research Centre, Tiruvalla 689 101",
  "KNM Arts and Science College, Kanjiramkulam",
  "S.B. College, Changanacherry-686 101",
  "Presentation College of Applied Sciences",
  "Mar Severios College of Teacher Education, Chengaroor P.O. Mallapally 689 594",
  "St. Xavier's College, Kothavara P.O., Vaikom-686 607",
  "Kuriakose Gregorios College, Pampady, Kottayam 686 502",
  "St. Dominic's College, Parathod P.O., Kanjirappally-686 512",
  "Marian Academy of Management Studies, Puthuppady, Kothamangalam",
  "Yeldo Mar Baselios College, Puthuppady, Kothamangalam 686 673",
  "NSS Training College, Perunnai P.O, Changanacherry-686 102",
  "Assumption College, Changanacherry 686 101",
  "Rural Academy for Management Studies, Kuzhupilly, Ayyampilly, Ernakulam-682501",
  "Devaswom Board College, Thalayolaparambu-686605",
  "St. Marys Womens College for Teacher Education, Paliakara, Thiruvalla- 689 101",
  "Viswabrahmana College, Vechoochira, Pathanamthitta- 686 511",
  "Devamatha College, Kuravilangad-686633",
  "St. Teresa's College, Ernakulam - 682 011",
  "Bishop Abraham Memorial College, Thuruthicaud 689 597",
  "Indira Gandhi Institute of Dental Sciences, Nellikuzhi P.O., Kothamangalam, Ernakulam- 686 691",
  "Sneha Sadan College of Special education, Angamaly, Ernakulam - 683 572",
  "St.Josephs College, Moolamattom, Arakulam P.O.- 685 591",
  "Bishop Speechly College for Advanced Studies, Pallom, Kottayam 686 007",
  "D B Pampa College, Parumala, Pathanamthitta 689 626",
  "University College of Teacher Education, Government Girls High School Campus, Vaikom, Kottayam",
  "St. Thomas College, Arunapuram P.O., Pala-686 574",
  "St. Mary's College, Manarcaud, Malam P.O. Kottayam-686031",
  "Alphonsa College, Pala - 686 574",
  "Samaritan College of Nursing, Samaritan Hospital, Pazhanganad, Kizhakkambalam P.O, Emakulam- 683 562",
  "Jai Bharath Arts and Science College, Chelakulam, Vengola P.O. Perumbavoor - 683 554",
  "Nirmala Training College, Thalacode P.O., Mulanthuruthy, Ernakulam- 682 314.",
  "M. E. S. College, Nedumkandam, Chembalam P.O., ldukki- 685 553",
  "Auxilium College of Education, Kidangoor,  P.O., Angamaly, Ernakulam",
  "Al-Azhar Training College, Perumpillichira P.O., Thodupuzha - 685 605",
  "Al- Ameen College, Edathala North P.O. Alwaye - 683 564",
  "Sahodaran Ayyappan Smaraka SNDP Yogam College, Konni- 689 691",
  "H.M. Arts and Science College, Randarkara, Muvattupuzha, Ernakulam",
  "Mar Thoma College, Kuttapuzha P.O. Tiruvalla, Pathanamthitta- 689103",
  "Bishop Kurialacherry College For Women, Amalagiri P.O Kottayam 686 561",
  "St. Gregorios College of Social Science Parumala P.O., Thiruvalla, Pathanamthitta 689 626",
  "Sree Narayana College of Education, Muvattupuzha -686 661",
  "Kuriakose Elias College, Mannanam, Kottayam-686 561",
  "Pavanatma College, Murrickacherry - 685 604",
  "St. John the Baptist College of Education, Nedumkunnam, Kottayam 686 542",
  "University College of Teacher Education, Thottakkad P.O., Kottayam",
  "Parumala Mar Gregorious College, Valanjavattom, Thiruvalla",
  "Sree Narayana Training College, Okkal P.O. Perumbavoor - 683 550",
  "St. Thomas College of Teacher Education, Mylacompu, Thodupuzha 685 584",
  "S N M Training College, Moothakunnam, Ernakulam 683 516",
  "V.N.S College of Arts and Science, Konni, Konnappara, Athumpumkulam P 0. - 689 692",
  "The Cochin College, Cochin-682 002",
  "St. John The Baptists' College of Special Education, Nedumkunnam",
  "Chinmaya College of Arts, Commerce and Science, Layam Road, Tripunithura,Kochi",
  "San Joe College of Nursing, Pulluvazhy P.O. Ernakulam- 683 541",
  "KUCTE ADOOR",
  "SCMS School of Technology & Management, Muttom, Aluva",
  "Government College Of Nursing Eranakulam",
  "MARIAN ARTS AND SCIENCE COLLEGE,KODUVAYUR",
  "HOLY GRACE ACADEMY OF ARTS AND SCIENCE",
  "MADIN COLLEGE OF PHARMACY",
  "ANVARUL ISLAM WOMEN'S ARABIC COLLEGE, MONGAM",
  "MALABAR COLLEGE OF ARTS & SCIENCE, MOODADI",
  "MA'DIN ARTS & SCIENCE COLLEGE, MELMURI",
  "Thiruvalla Medical Mission College of Nursing, Anjilithanam. P.O, Kaviyoor, Thiruvalla, - 689 582",
  "DEVAKI AMMA G. COLLEGE OF ARCHITECTURE, CHELEMBRA",
  "Lourde College of Nursing, Ariyil (P.O.), Taliparamba",
  "Sidhi Sadan Lourdes College of Nursing, Chembumukku.Thrikkakara P.O.,  Cochin- 682 021",
  "GOVERNMENT MEDICAL COLLEGE, THRISSUR",
  "Sree Narayana Institute of Medical Sciences, Chalakka, North Kuthiathode,  Ernakulam- 683",
  "St. Gregorios Dental College, Chelad P.O, Kothamangalam, Emakulam - 686 681",
  "St. Gregorious College of Nursing, Parumala, Pathanamthitta",
  "St. Johns College of Nursing, Kattappana South P.O. 685 515",
  "St. Josephs College of Nursing, St. Josephs Hospital, Dharmagiri, Kothamangalam, Ernakulam- 686 691",
  "I E S COLLEGE OF ARCHITECTURE, CHITTILAPPILLY, THRISSUR",
  "AMALA INSTITUTE OF MEDICAL SCIENCES, THRISSUR",
  "ASWINI COLLEGE OF NURSING, NADATHARA",
  "BABY MEMORIAL COLLEGE OF NURSING, KOZHIKKODE",
  "COLLEGE OF NURSING, MOULANA HOSPITAL, PERINTHALMANNA",
  "KMCT AYURVEDA MEDICAL COLLEGE",
  "DEVAKI AMMA MEMORIAL COLLEGE OF PHARMACY",
  "EDUCARE INSTITUTE OF DENTAL SCIENCES, CHATTIPARAMBA",
  "GOVT. COLLEGE OF NURSING, KOZHIKKODE",
  "WEST FORT COLLEGE OF NURSING, THRISSUR",
  "N. M. S. M. Government College, Kalpetta",
  "KMM COLLEGE OF ARTS AND SCIENCE, CHOWARA ALUVA",
  "UIT, Regional centre,Malayinkeezhu",
  "PRIME COLLEGE OF PHARMACY",
  "V.R KRISHNAN EZHUTHACHAN LAW COLLEGE",
  "Co-Operative Arts & Science College,Madai, Pazhayangadi",
  "Khansa Women's College for Advanced Studies , Milekallu, Kumbla",
  "College of Applied Science,PO- Kuthuparamba-Kannur",
  "A.W.H. Al-Badar Special College, Near New Bus stand, Payyannur, Kannur",
  "College of Applied Science (Pattuvam),Kuttikkol",
  "Naher Arts & Science College, Kanhirode, P.O Kanhirode(Via Koodali, Kannur",
  "Sharaf  Arts & Science College, Padanne, Kasaragode",
  "Pilathara Co-op Arts & Science College , Pazhichiyil, P.O. Nareekamvalli, Kannu",
  "Nalanda College of Arts & Science, P.O. Perala, Kasargod",
  "Pattom Thanupillai  Memorial College of Education, Maruthoorkonam",
  "Taliparamba Arts & Science College, PO- Kanhirangad",
  "Sa-Adiya Arabic College, Deli, P.O. Kalanad, Kasaragod",
  "Ideal Arabic College, Uliyil P.O, Kannur",
  "K V Ustad Memorial Darul Hidaya Orphanage Arts and Science College for Women (Unaided)",
  "Morazha Co-operative Arts & Science College, Morazha P.O. , Kannur",
  "Department of pharmaceutical Sciences (RIMSR), Centre for Professional and Advanced studies (CPAS)",
  "Sa-A-Diya Arts & Science College, Koliyadukkam, P.O. Kalanad, Kasargod",
  "Jaybees Training College of B. Ed., Kuttoor, P.O. Mathamangalam",
  "P.K.K.M. College of Applied Science, Mananthavady",
  "UNIVERSITY INSTITUTE OF MANAGEMENT ALAPPUZHA",
  "M.E.S College,Naravoor South,PO Kuthuparamba",
  "Malabar Islamic Complex-  Arts & Science College, Mahinabad, Thekkil",
  "Darul Irshad Arabic College, P.O. Paral, Thalassery, Kannur",
  "Govt. College, Mananthavady, P.O. Nalloornad, Mananthavady, Waynad",
  "Chinmaya Institute of Technology, Govindagiri.,Chala, Kannur",
  "Orphanage Arabic College Kanhangad , Kottachery, P.O.Kanhangad",
  "Institute of Technology, Mayyil, Pavannoor Motta, Kannur",
  "SI-Met College Of Nursing, Muttathara",
  "HERMANN GUNDERT COLLEGE OF ADVANCED STUDIES",
  "Gurudev Arts & Science College, Mathil-PO,Mathil",
  "SANJO COLLEGE OF PHARMACEUTICAL STUDIES",
  "St. Pius X College, Rajapuram, Kanhangad Via., Kasaragod",
  "Navajyothi College, Cherupuzha, P.O Chunda, Kannur 670511",
  "SIBGA Institute of Advanced Studies, Irikkur",
  "Sir Syed Institute for Technical Studies",
  "Pazhassiraja NSS College,Mattannur",
  "St. Joseph's College Pilathara Kannur",
  "Mary Matha Arts & Science College Alakode",
  "Crescent  College of Pharmaceutical Sciences, Madaipara, Payangadi",
  "AHALIA AYURVEDA MEDICAL COLLEGE",
  "College of Pharmaceutical Sciences Kannur",
  "Malabar Training College, Peravoor Kannur",
  "MECF College of Teacher Education, Peringathur, Kannur",
  "Indira Gandhi Training College, Nellikuzhi P.O., Kothamangalam, Ernakulam - 686 691",
  "Don Bosco College, Angadikadavu, Kannur",
  "W.M.O Imam Gazzali Arts & Science College",
  "Payyanur College, Payyannur,PO-Edat",
  "Sir Syed College,PO- Karimbam,Taliparamba",
  "Nehru Arts & Science College, P.O. Padanekat, Kanhangad, Kasaragod",
  "B L M College of Applied Sciences,Thimiri",
  "Deva Matha Arts & Science College , Paisakari",
  "Rajeev Memorial College of Teacher Education, Mattanur",
  "Thanbeehul Islam Womens College, Naimarmoola, Kasaragod",
  "Dr. Ambedkar Arts & Science College, Sreesailam, Periya P.O",
  "Mahatma Gandhi College,Iritti,PO-Keezhur",
  "Vimal Jyothi Institute of Management and Research, Chemperi, Kannur",
  "College of Applied Science, P.O. Pettikundu (Cheemeni), Via Cheruvathur",
  "EMS Memorial College of Applied Science , Vallithode, Iritty, Kannur",
  "Govt. Brennen College, Dharmadam,Thalassery,Kannur",
  "Wadihuda Institute of Research and Advanced Studies, Vilayancode, Kannur",
  "Model College, Madikkai, Neeleshwaram , Kasaragod",
  "People Institute of Management Studies, Munnad, Kasaragod",
  "Mary Matha Arts & Science College, P.O. Vemom, Mananthavady, Wayanad",
  "CENTRE FOR COMPUTER SCIENCE AND INFORMATION TECHNOLOGY, VATAKARA",
  "Nirmalagiri College,PO-Nirmalagiri",
  "Dr. Ambedkar College of Education, Sreesailam, Periye, Periye P.O., Kasaragod",
  "CENTRE FOR COMPUTER SCIENCE AND INFORMATION TECHNOLOGY THALIKKULAM",
  "Peoples Co-operative arts & Science College-Munnad, P.O. Munnad",
  "Mahatma Gandhi Arts & Science College, Chendayad-PO",
  "E.K. Nayanar Memorial Govt. College, Elerithattu. Nileshwar",
  "College of Applied Science , Pinarayi, Kannur",
  "Govt. Brennen College of Teacher Education, Thalassery",
  "College of Agriculture, Padannakkad",
  "College of Forestry, Vellanikkara",
  "College of Agriculture, Vellanikkara",
  "St.Thomas Training College, Mukkalakkal, Thiruvananthapuram",
  "Mannam Foundation Centre for Education Technology, Poruvazhy, Edakkad P.O., Kollam",
  "St.Joseph's College for Women, Alappuzha",
  "SREE NARAYANA GURU COLLEGE OF ADVANCED STUDIES, PUNALUR",
  "Manjappara Educational & Charitable Trust B.Ed College, Manjappara, Ayur, Kollam",
  "ILAHIA SCHOOL OF SCIENCE & TECHNOLOGY, PEZHAKKAPPILLY, MUVATTUPUZHA",
  "POPE PAUL MERCY HOME TEACHERS TRAINING CENTRE",
  "Milad-E-Sherief Memorial College, Kayamkulam",
  "CSI College of Education, LMS Compound, Parassala",
  "Mar Thoma College of Special Education, Badiadka, Beejanthadka, Perdala (P.O)",
  "Jamia Training College, Chithara, Kollam",
  "Kaviyattu College of Education, Pirappancode P.O., Thiruvananthapuram",
  "NSS Training College, Pandalam",
  "College of Fine Arts, Thiruvananthapuram",
  "Baselios Marthoma Mathews II Training College, Kottarakkara, Kollam",
  "St.Michael's College, Cherthala",
  "Buddha College of Teacher Education, Muthukulam North, Alappuzha",
  "Member Sree Narayana Pillai Institute of Management and Technology, Chavara, Kollam",
  "University College, Thiruvananthapuram",
  "Christian College, Kattakada",
  "NSS College, Pandalam",
  "KPM B.Ed. College, Cheriyavelinelloor, Kollam",
  "Govt.Arts and Science College, Ambalappuzha, Alappuzha",
  "Sree Swathi Thirunal College of Music, Thiruvananthapuram",
  "Emmanuel College of B.Ed. Training, Vazhichal, Kudappanamoodu P.O.",
  "NAIPUNNYA SCHOOL OF MANAGEMENT, Near Manorama Jn., Cherthala",
  "Karmela Rani Training College, Kollam",
  "C.H.M.M. College of Advanced Studies, Palayamkunnu, Varkala",
  "Kerala Institute of Tourism and Travel Studies, Thycaud, Thiruvananthapuram",
  "All Saints' College, Thiruvananthapuram",
  "St.Xavier's College, Thumba, Thiruvananthapuram",
  "Kerala Institute of Co-operative Management, Nettukaltheri, Neyyar Dam, Thiruvananthapuram",
  "ST.Thomas Institute of Science and Technology, Mar Chrystom Nagar, Kattaikonam P.O., Thiruvananthapuram",
  "Snehacharya Institute of Hotel Management and Technology, Karuvatta, Alappuzha",
  "HHMSPB NSS College for Women, Neeramankara, Thiruvananthapuram",
  "Govt. College, Kariavattom, Thiruvananthapuram",
  "College of Applied Science (IHRD), Adoor",
  "John Cox Memorial CSI Institute of Technology, Kanammoola, Thiruvananthapuram",
  "R.V. Training College, Valakom, Kottarakkara",
  "Sree Narayana College, Chathannur",
  "Govt.Law College, Kunnukuzhi P.O., Thiruvananthapuram",
  "Fathima Memorial Training College, Pallimukku, Kollam",
  "Sree Narayana Institute of Technology, Vadakkevila, Kollam.",
  "ALSHIFA COLLEGE OF PARAMEDICAL SCIENCES",
  "G.Karunakaran Memorial Co-operative College of Management, Azhicode, Thiruvananthapuram",
  "Sree Narayana Gurukripa B.Ed College, Pothencode",
  "CENTRE FOR DEVELOPMENT OF IMAGING TECHNOLOGY",
  "Iqbal Training College, Iqbal Nagar, Daivapura P.O., Peringammala",
  "Fathima Memorial Training College, Mylapore, Kollam",
  "Institute of Management and Technology, Punnapra, Alappuzha",
  "St.Stephen's College, Pathanapuram",
  "METCA Institute of Teacher Education, Chavarcode, Thiruvananthapuram",
  "Mount Tabor Training College, Pathanapuram",
  "Sree Narayana College, Punalur",
  "National Institute of Speech and Hearing, Karimanal, Akkulam, Thiruvananthapuram",
  "Christian College, Cengannur",
  "ST.Jacob's Training College, Menamkulam, Kazhakkootom, Thiruvananthapuram",
  "T.K.Madhava Memorial College, Nangiarkulangara",
  "Victory College of Teacher Education Centr, Olathanni, Thiruvananthapuram",
  "Raja Ravi Varma College of Fine Arts, Mavelikkara",
  "Govt.Arts College, Thiruvananthapuram",
  "Loyola College of Social Sciences, Srekariyam, Thiruvananthapuram",
  "Malabar Cancer Centre College Thalassery",
  "Kerala Law Academy Law College, Thiruvananthapuram",
  "New B.Ed. College, Nellimoodu, Thiruvananthapuram",
  "Sree Sankara Vidya Peetom College, Nagaroor, Kilimanoor",
  "Sree Narayana Training College, Sreekandeswaram, Alappuzha",
  "KVM College of Special Education, Cherthala, Alappuzha",
  "THARANANELLUR ARTS & SCIENCE COLLEGE",
  "DARUL MA ARIFA ARABIC COLLEGE, PUTHUPPADY",
  "SREE NEELAKANTA GOVT. SANSKRIT COLLEGE, PATTAMBI",
  "NSS College, Cherthala, Alappuzha",
  "MALABAR TMS COLLEGE OF MANAGEMENT TECHNOLOGY",
  "ALPHONSA COLLEGE OF NURSING, MURICKASSERY,IDUKKI    ",
  "Fatima Mata National College, Kollam",
  "Sunrise College of Advanced Studies",
  "College of Engineering Trivandrum.",
  "BHARATHEEYA VIDYA NIKETHAN ARTS AND SCIENCE COLLEGE KALLEKKAD, PALAKKAD, KERALA",
  "SAHYA ARTS AND SCIENCE COLLEGE",
  "DC SCHOOL OF ARCHITECTURE AND DESIGN",
  "Dr.Moopen's Nursing  College",
  "CPAS INSTITUTE OF NURSING EDUCATION KANJIRAPALLY",
  "KERALA UNIVERSITY COLLEGE OF TEACHER EDUCATION, THEVALLY (PO), KOLLAM -691009",
  "SREE NARAYANA GURU COLLEGE OF ADVANCED STUDIES, NANGIARKULANGARA",
  "LIONS EDUCATIONAL TRUST COLLEGE, MUDAPPALLUR",
  "MTM COLLEGE OF ARTS, SCIENCE AND COMMERCE, PAZHANJI, VELIYANCODE",
  "Zainab Memorial B.Ed Centre",
  "GURUDEVA COLLEGE OF ADVANCED STUDIES KOYILANDY",
  "MARYGIRI COLLEGE OF ARTS and SCIENCE, KOOTHATTUKULAM",
  "MAR IVANIOS COLLEGE FOR ADVANCED STUDIES",
  "KRs SREENARAYANA COLLEGE",
  "GOVERNMENT COLLEGE OF NURSING, MANJERI",
  "SIMET COLLEGE OF NURSING , NEYYATTINKARA",
  "MSS COLLEGE OF ARTS AND SCIENCE, THARUVANA",
  "LAMPSHARE COLLEGE OF ARTS AND SCIENCE, IRIMBLIUM,VALANCHERY, MALAPPURAM",
  "KTCT COLLEGE OF ALLIED HEALTH SCIENCES",
  "GOVERNMENT MEDICAL COLLEGE, KONNI",
  "SREE NARAYANA PARAMAHAMSA COLLEGE OF ARTS AND SCIENCE, POONJAR",
  "GOVERNMENT COLLEGE OF NURSING, KOLLAM",
  "ASSUMPTION COLLEGE OF NURSING",
  "SREEPATHY INSTITUTE OF ADVANCED STUDIES",
  "IES COLLEGE OF ARTS AND SCIENCE",
  "AL AZHAR COLLEGE OF NURSING THODUPUZHA",
  "LOURDE INSTITUTE OF SCIENCE AND TECHNOLOGY ",
  "COLLEGE FOR COSTUME AND FASHION DESIGNING",
  "DR APJ ABDUL KALAM COLLEGE OF PROFESSIONAL STUDIES, ULIKKAL",
  "BHUVANESWARI ARTS SCIENCE COLLEGE, CHEEMENI",
  "INDIAN MARITIME UNIVERSITY, KOCHI",
  "ASIAN SCHOOL OF ARCHITECTURE AND DESIGN INNOVATIONS ",
  "STELLA MARIS INSTITUTE OF MANAGEMENT AND TECHNOLOGY, POYYA",
  "DEVAKI AMMA MEMORIAL TEACHER EDUCATION COLLEGE, CHELEMBRA",
  "DC SCHOOL OF MANAGEMENT AND TECHNOLOGY TRIVANDRUM",
  "MALIK DEENAR COLLEGE OF NURSING",
  "MES ENGINEERING COLLEGE, KUTTIPPURAM",
  "College of Agriculture Ambalavayal",
  "Rajiv Gandhi Centre for Biotechnology",
  "N.S.S. COLLEGE, NEMMARA",
  "SAMARITAN INSTITUTE OF PARAMEDICAL SCIENCES",
  "INSTITUTE OF NURSING EDUCATION ,KOTTARAKKARA",
  "ST JOSEPHS COLLEGE OF PARAMEDICAL SCIENCES",
  "CPAS INSTITUTE OF NURSING EDUCATION SEETHATHODE",
  "LISIEUX COLLEGE OF NURSING",
  "THE ELEGANT COLLEGE OF ARTS AND SCIENCE",
  "CALICUT ADARSHA SANSKRIT VIDYAPEETHA BALUSSERY",
  "Markaz Unani Medical College, Puthuppadi, Kozhikode",
  "ER & DCI Institute of Technology",
  "METs College of Advanced Studies",
  "PRAVASI ARTS & SCIENCE COLLEGE, GOKULAM, EDAYUR",
  "UNIVERSITY TEACHER EDUCATION CENTRE, VATAKARA",
  "UNIVERSITY TEACHER EDUCATION CENTRE, VALAPPAD",
  "UNIVERSITY TEACHER EDUCATION CENTRE, SULTHAN BATHERY",
  "UNIVERSITY TEACHER EDUCATION CENTRE, NATTIKA",
  "UNIVERSITY TEACHER EDUCATION CENTRE, MANJERI",
  "UNIVERSITY TEACHER EDUCATION CENTRE, KANIYAMBETTA",
  " R.SANKAR  COLLEGE OF ARTS AND  SCIENCE ",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY REGIONAL CENTRE PIRAPPANCODE",
  "UNIVERSITY TEACHER EDUCATION CENTRE, CHAKKITTAPPARA",
  "ST.JOSEPHS ARTS AND  SCIENCE COLLEGE ,PAVARATTY",
  "WHITE MEMORIAL COLLEGE OF ARTS AND SCIENCE, PANACHAMOODU",
  "RAJIV GANDHI MEMORIAL GOVT. ARTS AND SCIENCE COLLEGE, ATTAPPADI",
  "GOVT. ARTS AND SCIENCE COLLEGE FOR WOMEN MALAPPURAM",
  "SREE MAHADEVA COLLEGE",
  "ASSISI COLLEGE OF NURSING",
  "DON BOSCO COLLEGE, KOTTIYAM",
  "MICHAELS INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "MES INSTITUTE OF PARAMEDICAL SCIENCES PERINTALAMNAA",
  "LOURDES MATHA COLLEGE OF ARTS AND SCIENCE KUTTICHAL",
  "CSI COLLEGE FOR ADVANCED STUDIES,KOZHENCHERRY,PATHANAMTHITTA",
  "SREE SABAREESA COLLEGE",
  "KMM COLLEGE, THRIKKAKARA, VAZHAKKALA",
  "LASYA COLLEGE OF FINE ARTS",
  "AHALIA COLLEGE OF NURSING PALAKKAD",
  "MOTHER COLLEGE OF PARAMEDICAL SCIENCES, Thrissur",
  "MAR GREGORIOS COLLEGE OF LAW",
  "SAHYAJYOTHI ARTS AND SCIENCE COLLEGE",
  "MAHATHAMA GANDHI UNIVERSITY INSTITUTE OF ARTS AND COMMERCE,CHUTTIPPARA,PATHANAMTHITTA",
  "Government Arts and Science College, Tavanur",
  "CONCORD ARTS AND SCIENCE COLLEGE,MUTTANUR",
  "Ahalia School of Pharmacy",
  "AL-AZHAR MEDICAL COLLEGE",
  "HOLY CROSS COLLEGE OF NURSING",
  "SI WOMENS COLLEGE OF ARTS AND SCIENCE, UMMATHUR, PARAKKADAVU",
  "MUSLIM ORPHANAGES COLLEGE OF ARTS AND SCIENCE, CHERUVATTA,  PARAMBADAM, KURUVATTUR",
  "C S I CHRISTIAN MULLER WOMENS COLLEGE, CHOMBALA, VATAKARA",
  "SAFI INSTITUTE OF ADVANCED STUDY AUTONOMOUS, VAZHAYUR",
  "College of Nursing, Guru Group of Institute, Karukachal",
  "ICCS College of Engineering and Management,Thrissur",
  "PINNACLE SCHOOL OF ENGINEERING AND TECHNOLOGY",
  "GOVT ARTS AND SCIENCE COLLEGE, KINANOOR-KARINDALAM",
  "SILVER JUBILEE LAW COLLEGE ,POOVACHAL, KATTAKADA, THIRUVANANTHAPURAM",
  "SEEDAC COLLEGE OF ARTS AND SCIENCE  MANNARKKAD",
  "FOCUS INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "Centre for Development Studies",
  "BHAVANs ROYAL INSTITUTE OF MANAGEMENT,THRIPUNITHURA",
  "Conspi Academy of Management Studies, Plankalamukku",
  "MOULANA COLLEGE OF PHARMACY",
  "College of Engineering ,Adoor",
  "UKF College of Engineering and Technology, Parippally, Kollam",
  "College of Climate Change and Environmental Science",
  "MES COLLEGE KOCHI",
  "UNIVERSAL COLLEGE OF ARTS AND SCIENCE",
  "AHALIA SCHOOL OF COMMERCE AND MATHEMATICS",
  "SABARI DURGA COLLEGE OF ARTS AND SCIENCE ",
  "Mar Athanasius College of Egineering, Kothamangalam, Ernakulam -686 666",
  "Ashtamgam Ayurveda Chikitsalayam And Vidyapeedham",
  "NATIONAL INSTITUTE OF SOWA RIGPA",
  "Kargil Campus",
  "GOVERNMENT DEGREE COLLEGE, NOBRA",
  "Eliezer Joldan Memorial College Leh, Ladakh",
  "GOVERNMENT DEGREE COLLEGE KHALTSI",
  "Govt. Degree College Kargil",
  "Govt Degree College Drass",
  "GOVERNMENT DEGREE COLLEGE, ZANSKAR",
  "GOVERNMENT NURSING COLLEGE KAVARATTI",
  "College of Education. Kavaratti",
  "GOVERNMENT POLYTECHNIC COLLEGE MINICOY LAKSHADWEEP",
  "GOVERNMENT COLLEGE OF ARTS AND SCIENCE  KADMAT ISLAND LAKSHADWEEP",
  "Calicut University Centre, Kadamat",
  "GOVERNMENT COLLEGE OF ARTS AND SCIENCE, ANDROTH",
  "PM Sayeed Centre, Andrott",
  "GOVERNMENT COLLEGE OF EDUCATION KADMAT LAKSHADWEEP",
  "MICT COMPUTER INSTITUTE",
  "navya computer center",
  "BCST BETUL BAZAR",
  "BRILLIANT COMPUTER",
  "Bijuri Institute Of technology",
  "CENTRE OF COMPUTER EDUCATION",
  "daksh computers",
  "PRANJAL INFORMATION TECHNOLOGY",
  "RAVI SHANKAR TECHNICAL INSTITUTE",
  "SANT MEERA INSTITUTE OF PROFESSIONAL STUDIES",
  "SHRI SAI INSTITUTE OF COMPUTER EDUCATION",
  "WINSOME COMPUTER EDUCATION",
  "MAA VAISHNOVI INSTITUTE",
  "SAM COLLEGE OF NURSING BHOPAL ",
  "HARMILAP INSTITUTE OF EXCELLENCE",
  "MAA SHARDA COMPUTER AND IT",
  "NISHA MEMORIAL INSTITUTE FOR COMPUTER EDUCATION ",
  "PIONEER STUDY CIRCLE",
  "I I TECH INSTITUTE",
  "baihar institute of computer education",
  "NICE COMPUTER ACADEMY REWA",
  "Eskam Computer Education",
  "Advance Courses of Computer Application ",
  "SHREE DWARKA PRASAD ARTS AND SCIENCE COLLEGE VIJAYRAGHAVGARH",
  "PT ASHOK NAYAK MAHAVIDHYALAYA GAURIHAR DISTT CHHATARPUR MP",
  "ARIHANT INSTITUTE OF COMPUTERS AND INFORMATION TECHNOLOGY",
  "ASCENT COMPUTER INSTITUTE",
  "CAPITAL COMPUTER IT AND SCIENCE",
  "DESHMUKH COLLEGE OF NURSING UJJAIN",
  "CAPITAL ACADEMY",
  "career paver institute of technology and management",
  "DAKSHITA COMPUTER INSTITUTION ",
  "MAA SARASWATI SHIKSHA MAHAVIDHYALAYA",
  "DPS INSTITUTE OF TECHNOLOGY",
  "MALAY COLLEGE OF NURSING",
  "RESONANCE INSTITUTE OF TECHNOLOGY",
  "sarvodaya institute for professional studies ",
  "softline centre of it",
  "ICT Computer Institute",
  "SHIV SHIKSHA MAHAVIDYALAY SEMARPURA BHIND",
  "FIRDOS COLLEGE OF EDUCATION",
  "DEEPAK MUSIC and ARTS COLLEGE ",
  "JAI MAA SHIKSHA MAHAVIDHYALAYA",
  "AMBIKA INSTITUTE OF TEACHERS EDUCATION",
  "BHANDARI GROUP OF HOSPITALS AND PARAMEDICAL INSTITUTE",
  "PRINCETON COLLEGE CHAINPUR ROAD BARELI DIST RAISEN MP",
  "THAKUR SHIVKUMARSINGH MEMORIAL POLYTECHNIC COLLEGE BURHANPUR",
  "SWAMI VIVEKANAND PARAMEDICAL COLLEGE JANAKPUR PANNA",
  "PRATIBHA COLLEGE OF PROFESSIONAL STUDIES KHEDI DIST KHANDWA",
  "UNIQUE COLLEGE OF PARAMEDICAL",
  "Govt College Gopalpur Nasrullaganj",
  "LAXMI BAI SAHUJI COLLEGE OF PHARMACY",
  "GOVT MUSIC COLLEGE NARSINGHGARH ",
  "EXCEL COMPUTER CENTRE",
  "EXCEL INSTITUTE OF PROFESSIONAL STUDIES",
  "SHIVAM COLLEGE, KATANGI",
  "Govt. College, Mahidpur",
  "Shri Krishna College of Education, Javi, Neemuch",
  "SHRI GURU SANDIPANI GIRLS INSTITUTE OF PROFESSIONAL STUDIES",
  "J.R.Kimti Girls College, Rampura",
  "N.S. MEMORIAL COLLEGE OF SCIENCE & STUDIES, BHADER",
  "Late R.M.S.College of Education, Bhanpura",
  "MALWA INSTITUTE OF MEDICINE",
  "Govt.College, Badanagar",
  "Madhav College,Dewas Gate, Ujjain",
  "Radha Devi R.M. Institute of Management & Research, Bhatkhedi, Neemuch",
  "VIJYASHREE AYURVEDIC MEDICAL COLLEGE AND HOSPITAL, JABALPUR",
  "JAGAT NARAYAN COMPUTER INSTITUTE JATARA",
  "PRAGYA SAGAR COLLEGE, PACHORE",
  "M P  INSTITUTE OF FASHION AND DESIGN",
  "Lakshya Institute of Professional Studies Narwar",
  "GOVT LAW COLLEGE SHEOPUR ",
  "NATURE INSTITUTE OF COMPUTER AND  MANAGEMENT STUDIES",
  "Thakur Niranjan Singh Institute Of Computer Science  and Technology",
  "VITAL EDUCATION SOCIETY",
  "ATHARVA PARAMEDICAL INSTITUTE BEOHARI",
  "VIVEKANAND COLLEGE, DABOHA",
  "BHARAT INSTITUTE OF TECHNOLOGY AND SCIENCE DATIA",
  "ASHA INSTITUTE OF TECHNOLOGY AND SCIENCE (AITS) GWALIOR",
  "ARIHANT COMPUTERS BALAGHAT",
  "Sri Satya Sai Institute of Pharmacy (Polytechnic)",
  "BIIT (BRILLIANT INSTITUTE OF INFORMATION TECHNOLOGY) SHEOPUR",
  "HUMAN WELFARE SOCIETY",
  "ADVANCE COMPUTER",
  "COMPUTER TECHNICAL INSTITUTE KURWAI",
  "Govt Naveen College Rajnagar",
  "Shubhdeep Ayurvedic Medical College, Khandwa Road, Indore",
  "Maa Sharda Mahavidhyalaya Chhatarpur (M.P.)",
  "GOVT.TULSI COLLEGE ANUPPUR",
  "BVM ICM GWALIOR",
  "RADHARAMAN SPECIAL EDUCATION",
  "Manovikas College of Special Education",
  "GOVERNMENT MEDICAL COLLEGE SATNA ",
  "College of Veterinary Sciences and Animal Husbandry, Kuthulia, Rewa (MP)",
  "SHRI SAHAJ INSTITUTE OF PHARMACY",
  "Govt. College, Makdone",
  "Govt. College, Mohan Badodia",
  "BARHI COMPUTER SCIENCE AND JOURNALISM INSTITUTE BARHI",
  "MICT (MORENA INSTITUTE FOR COMPUTER TECHNOLOGY) MORENA",
  "Govt. College, Tal",
  "RENAISSANCE LAW COLLEGE, INDORE",
  " MANSINGH INSTITUTE OF PROFESSIONAL STUDIES KHADIYAHAR TEHSIL AMBAH DISTRICT MORENA",
  "DANVEER MAHAVIDHYALAYA",
  "GOVERNMENT COLLEGE KHAJRANA, INDORE",
  "Chandra Shekhar Azad Govt. PostGraduate Lead College, Sehore",
  "Govt. College, Shamgarh",
  "Govt. College, Mallahargarh",
  "SHRI GANESH B ED COLLEGE MANDVI  ATHNER DIST BETUL",
  "Veerangna Awanti Bai  College, Chhatarpur",
  "Shri Dada ji Shaikhnik Avam  Samajik Samiti, Satwas",
  "Veerangna Awanti Bai  Law College, Chhatarpur",
  "SAMEKIT KSHTRIYA KENDRA DISABLE CRC BHOPAL",
  "Shanti NiketanInstitute of Technology, Ratlam",
  "Royal Institute of Manag.& Advance Stu., Ratlam",
  "Aakriti Institute of Fine Arts,Jabalpur",
  "SAI COLLEGE OF NURSING, KHANDWA",
  "Govt. College, Kalukheda",
  "Shri Saai Institute of Tech.New R.T.O.Office, Jaora Road, Ratlam",
  "Govt. Arts & Science College, Ratlam",
  "Dr.K.N.Kataju Law College, Ratlam",
  "Yogindra Sagar Institute of Tech & Sc.Dharad, Ratlam",
  "Govt. College, Sailana",
  "Shaheed Narandra Singh Education College, Jaora",
  "TECHNOCRATS INSTITUTE OF PARAMEDICAL SCIENCES",
  "St. Stifan College, Ratlam",
  "Swami Vivekanand Govt. Commerce College, Ratlam",
  "SPDN TEACHERS TRAINING INSTITUTE DORIYA NOWGONG CHHATARPUR",
  "Govt. P.G. College, Rehli",
  "SATPUDA COLLEGE OF ENGINEERING AND POLYTECHNIC",
  "Guru Vashishtha Education College, Dewas",
  "Harda Degree College",
  "Govt. Girls  P. G. College, Ratlam",
  "EKLAVYA GOVERNMENT POLYTECHNIC COLLEGE HARSUD",
  "SAKSHI LAW COLLEGE BADHAURA",
  "SHRI RAJABHOJ MAHAVIDHYALAYA SEHORE",
  "GANESH EDUCATION COLLEGE",
  "J S PHARMACY COLLEGE PRITHVIPUR",
  "Swami Vivekanand Govt. College, Lakhnadon, Seoni",
  "MOTIVE COMPUTERS JHABUA",
  "SHRINATH PHARMACY COLLEGE",
  "SRAJAN INSTITUTE OF TECHNOLOGY MANAGEMENT AND SCIENCE",
  "Govt. Arts College, Panagar, Jabalpur",
  "Govt. Degree College, Timarni, Distt. Harda",
  "Maharishi Edu. College  Panna",
  "MAA  KANKESHWARI DEVI SHASKIYA MAHAVIDYALAYA  INDORE",
  "SWASTIK NURSING COLLEGE REWA ",
  "CAREER COLLEGE OF NURSING",
  "GLOBAL PACIFIC INSTITUTE OF TECHNOLOGY",
  "SVKMS NMIMS INDORE",
  "GOVERNMENT COLLEGE REHATGAON",
  "N R I GIRLS COLLEGE, BETUL M P",
  "AMRIT LAW COLLEGE",
  "SHRI GURU SANDIPANI INSTITUTE OF MANAGEMENT",
  "Govt. Dr. Shyama Prasad Mukharjee, Science & Commerce College Bhopal",
  "ASTRAL INSTITUTE OF PROFESSIONAL STUDIES, INDORE",
  "ORIENTAL COLLEGE OF PHARMACY",
  "SHRI SATYA SAI COLLEGE OF PARAMEDICAL SCIENCE BARWANI ",
  "SHRI BARDHMAN GIRLS COLLEGE",
  "LNCT COLLEGE OF ARTS COMMERCE AND SCIENCE JABALPUR",
  "PRESTIGE COLLEGE",
  "JAI SHRI SHYAM COLLEGE OF EDUCATION",
  "DIVY JYOTI NURSING COLLEGE",
  "GOVT. AYURVED COLLEGE.REWA",
  "EDU SERUMX COLLEGE OF COMMERCE AND MANAGEMENT",
  "GOVT. COLLEGE MUGANWALI",
  "GOVERNMENT COLLEGE, ISHAGARH",
  "VANDEY MATRAM EDUCATION COLLEGE MOTI JHEEL",
  "GOVERNMENT LAW COLLEGE, ASHOKNAGAR",
  "GOVERNMENT POLYTECHNIC COLLEGE SATNA",
  "Narmada College of fine arts ",
  "Govt. Girls P.G.College Chhatarpur M.P.",
  "MIRACLE NURSING COLLEGE",
  "SHRI SAI NATH COLLEGE OF NURSING, MANDSOUR",
  "pt dd pathak college",
  "RAJA HARPALSINGH GOVT. COLLEGE HARPALPUR",
  "PT T P SHUKLA COLLEGE OF NURSING",
  "Shree Rajiv Gandhi Government College, Banda",
  "GOVERNMENT COLLEGE SULTANPUR",
  "Mahakoshal College Of Science AND  Arts ",
  "Ram krishana memorial B.Ed. training college",
  "N I  COLLEGE. CHHINDWARA",
  "GOVERNMENT COLLEGE SEHRAI  ",
  "Government Aanad Music College Dhar",
  "Maa Narmada College of Education, Dhamnod",
  "GOVT. BAPU COLLEGE NOWGONG ",
  "EXECELLENCE COLLEGE OF SCIECNE AND MANAGEMENT,",
  "SHREE VINAYAK NURSING COLLEGE, RATLAM",
  "Urdesh Shiksha Mahavidhalaya",
  "SHIVANI PARAMADICAL INSTITUTE,SHAHDOL",
  "INSTITUTE OF MANAGEMENT STUDIES",
  "GOVT COLLEGE BADI",
  "SHRI PARASNATH MAHAVIDYALAY",
  "IPS ACADEMY COLLEGE OF LAW, SANWER",
  "COLLEGE OF AGRICULTURE, PANNA ",
  "GURUSAHAB SCIENCE AND ART COLLEGE",
  "FRIENDS INSTITUTE OF COMPUTER SCIENCE AND TECHNOLOGY",
  "MAHATMA GANDHI INSTITUTE OF TECHNOLOGY",
  "HASDEO INSTITUTE OF TECHNOLOGY ",
  "SIGMA INFOTECH COMPUTER INSTITUTE LALBURRA",
  "GOVERNMENT COLLEGE DOLARIYA",
  "VIKRAMADITYA INSTITUTE OF COMPUTER SCIENCE AND TECHONOLOGY",
  "Mahatma Gandhi B.Ed. College",
  "CITY PUBLIC COLLEGE OF EDUCATION",
  "SWAMI VIVEKANAND SANGEET AVAM KALA MAHAVIDHYALAYA",
  "E-@NET COMPUTERS PANDHURNA",
  "Government Degree College Piprai District Ashoknagar",
  "GOVT. NEHRU P.G. COLLEGE DEORI",
  "Saifia Hamidia Unani Tibbia College, Burhanpur",
  "INSTITUTE OF POLYTECHNIC ENGINEERING",
  "GOVT. NEHRU DEGREE COLLEGE",
  "JAWAHARLAL INSTITUTE OF TECHNOLOGY BORAWAN M C A",
  "SAM COLLEGE BHOPAL",
  "SAILANA COLLEGE OF NURSING SAILANA",
  "govt college shadhora",
  "SRI SAI MAHAVIDHYALAYA NIWARI",
  "RISHIRAJ COLLEGE OF DENTAL SCIENCES AND RESEARCH CENTRE BHOPAL",
  "ANANT INSTITUTE OF PROFESSIONAL STUDIES",
  "GOVT. COLLEGE RAHATGARH",
  "ASTHA INSTITUTE OF PARAMEDICAL TECHLOGY",
  "GOVT LAW COLLEGE BINA",
  "Govt. P.G. College, Bina",
  "AADHAR SHIKSHA MAHAVIDHYALAYA GOURJHAMAR",
  "SHRI SAI COLLEGE OF NURSING, KHARGONE (MANDLESHWAR)",
  "PT NEHRU D ED COLLEGE",
  "Aadhya Mahavidhyalya",
  "JANKI VALLABH DEGREE COLLEGE ",
  "MAA SHARDA INSTITUTE OF NURSING, JHABUA",
  "K.M. College , Shivpuri ",
  "BKP COLLEGE OF COMPUTER EDUCATION, DEORI",
  "vedanta degree college nanora pohari Shivpuri",
  "RATAN SHIKSHA MAHAVIDYALAYA",
  "Govt womens polytechnic college,sehore",
  "SMT. RAMDEVI COLLEGE OF EDUCATION",
  "INDIRA INSTITUTE OF PROFESSIONAL STUDIES SUNHERA ROAD SABALGARH",
  "ORIENTAL INSTITUTE OF SCIENCE AND TECHNOLOGY JABALPUR",
  "S.R. MAHAVIDHYALAY",
  "B.T. Inst. of Research and Technology, Sironja, Sagar",
  "GOVERNMENT ADARSH COLLEGE UMARIA",
  "Govt Degree College Prithvipur",
  "BITS AND BYTES INSTITUTE OF INFO. TECH.",
  "CIFINET INSTITUTE OF PROFFESSIONAL STUDIES",
  "MGM COMPUTER AND EDUCATION CENTRE",
  "SCHOOL OF PARAMEDICAL STUDIES,SSSUTMS",
  "AASTHA INSTITUTE OF SCIENCE and TECHNOLOGY JAORA ",
  "ABACUS INSTITUTE OF TECHNOLOGY & MANAGEMENT PANDHURNA",
  "MODERN DENTAL COLLEGE",
  "RADHARAMAN INSTITUTE OF NURSING, BHOPAL",
  "SHRI RAMNATH SINGH ANIMAL HUSBANDRY DIPLOMA COLLEGE GORMI BHIND MP",
  "ACADEMY OF COMPUTER SCIENCE & TECHNOLOGY JABALPUR",
  "ACADEMY OF JOURNALISM & BROADCAST COMMUNICATION, HOSHANGABAD",
  "ACMEVISION INSTITUTE OF COMPUTER SCIENCE SHAJAPUR",
  "ADITI COMPUTER INSTITUTE & ENGINEERING TECHNOLOGY , SATNA",
  "ADVANCE COURSES OF COMPUTER APPLICATION JABALPUR",
  "ALMA COMPUTER EDUCATION CENTRE GADARWARA",
  "GOVT POLYTECHNIC COLLEGE JHABUA",
  "IMI LAW COLLEGE, INDORE",
  "OXFORD INTERNATIONAL COLLEGE, INDORE",
  "FACULTY OF EDUCATION(SCHOOL OF EDUCATION,SSSUTMS)",
  "SCHOOL OF ENGINEERING SRI SATYA SAI UNIVERSITY OF TECHNOLOGY AND MEDICAL SCIENCES,(SSSUTMS)",
  "FACULTY OF EDUCATION,SSSUTMS",
  "INSTITUTE OF COMPUTER EDUCATION",
  "FACULTY OF PHARMACY(POLYTECHNIC PHARMACY, SRI SATYA SAI UNIVERSITY OF TECHNOLOGY AND MEDICAL SCIENCES, (SSSUTMS))",
  "SRIJI INSTITUTE OF NURSING SCIENCE, MANDSAUR",
  "FACULTY OF EDUCATION(SCHOOL OF PHYSICAL EDUCATION,SSSUTMS)",
  "AMBIKA COMPUTER & MANAGMENT EDUCATION SHIVPURI",
  "CHANDNA COMPUTER",
  "CENTRE FOR MANAGEMENT & INFORMATION TECHNOLOGY SIDHI",
  "CHITRAKOOT INSTITUTE OF COMPUTER SCIENCE AND TECHNOLOGY",
  "CITY CENTRE OF MANAGEMENT & INFORMATION TECHNOLOGY JABALPUR",
  "COLLEGE OF COMPUTERS & COMMUNICATION JABALPUR",
  "COMP-FEEDERS TAKNIKI PRASHIKSHAN SANSTHAN INDORE",
  " B T MAHAVIDHYALAY",
  "COMPUTER POINT BHOPAL",
  "CREATIVE COMPUTER ACADEMY",
  "CITY INSTITUTE OF IT & PROFESSIONAL STUDIES KATNI",
  "DEEKSHA COMPUTER INSTITUTE MANDIDEEP",
  "SRI AUROBINDO INSTITUTE OF SPEECH AND HEARING",
  "Dalal Institute of IT and Management ",
  "GYAN SAGAR COLLEGE OF EDUCATION",
  "Gyanveer College, Sagar",
  "DIGITAL COMPUTER ACADEMY AJAIGARH",
  "CENTRE OF COMPUTER & INFORMATION TECHNOLOGY SIHORA",
  "CENTRE OF COMPUTER AND SOFTWARE EDUCATION JABALPUR",
  "S R COLLEGE OF NURSING, ITARSI",
  "MEHCKO COLLEGE OF NURSING, BHOPAL",
  "Softtech Computer Academy ",
  "VITAL PARAMEDICAL COLLEGE JHABUA",
  "RINI COLLEGE OF NURSING, SEONI",
  "RITU COLLEGE OF NURSING, CHHINDWARA",
  "D.H. COMPUTER EDUCATION PATHAKHERA",
  "DOT-CMC COMPUTER EDUCATION SEHORE",
  "AWADH MADHAV SAI SHRADDHA COLLEGE OF NURSING, CHHINDWARA",
  "DIGITAL COMPUTER AND MANAGEMENT ACADEMY CHHATARPUR",
  "BRD NURSING COLLEGE, HOSHANGABAD",
  "M.B. KHALSA INSTITUTION OF EDUCATION, INDORE",
  "VINDHYA COLLEGE OF NURSING SHAHDOL",
  "AGNOS COLLEGE OF TECHNOLOGY",
  "DIGITAL INSTITUTE OF TECHNOLOGY & SCIENCE KOTMA",
  "KAMTANATH B.ED COLLEGE",
  "GOVT. COLLEGE GANDHWANI, DIST. DHAR",
  "SHRI RAMNATH SINGH MAHAVIDYALAYA, GORMI, BHIND",
  "PARASHAR AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "PREMWATI COLLEGE OF PARAMEDICAL SCINECE",
  "GANPATI PARAMEDICAL COLLEGE",
  "SHRI GAJANAN SHIKSHA SAMITI COLLEGE",
  "CRYSTAL COMPUTER ACADEMY",
  "Shri Ram Institute of Science & Technology,  ITI Madhotal , Jabalpur",
  "GANPATI NURSING COLLEGE",
  "NEW ERA COLLEGE OF NURSING, DEWAS",
  "MOTHER MARY COLLEGE OF NURSING, INDORE ",
  "EKTA INSTITUTE",
  "DR. RADHAKRISHNAN VIDYAPEETH NEEMUCH",
  "Gynodaya Mahavidyalaya, Jaisinagar",
  "NOBLE COLLEGE DEORI ",
  "DYNAMIC COMPUTER ACADEMY",
  "EXCEL INSTITUTE OF COMPUTERS HOSHANGABAD",
  "EXCELLENCE MANAGEMENT PROFESSIONAL INSTITUTE ",
  "LSA College, Dhar",
  "EXTOL FACULTY OF COMPUTER SCIENCES BHOPAL",
  "GALAXY COMPUTERS",
  "Sarswati Sangeet Mahavidhyalaya, bhopal",
  "FASTEST COMPUTER EDUCATION CENTRE NARSINGHGARH",
  "GICTS (GWALIOR INSTITUTE FOR COMPUTER TECHNOLOGY & SCIENCE) GWALIOR",
  "PT BRIJKISHORE PATERIYA COLLEGE OF EDUCATION DEORI",
  " SHRI KAILASH JOSHI GOVERNMENT COLLEGE, SATWAS",
  "EXTOL INSTITUTE OF COMPUTER APPLICATION BHOPAL",
  "SHASKIYA MAHAVIDYALAYA JAISINAGAR",
  "SHRI RAWATPURA SARKAR COLLEGE PANTNAGAR SAGAR ",
  "Sir Hari Singh Gour Mahavidyalaya, Sagar",
  "S.V.N. COLLEGE MALTHONE",
  "CAMPUS OF BEST MORAL COLLEGE ,BEDIA",
  "DESIGN EDUTECH JABALPUR",
  "GYAN GANGA MAHAVIDHYALAYA GWALIOR",
  "GYAN SAGAR INSTITUTE OF COMPUTER SCIENCE & APPLICATION JABALPUR",
  "AROHI COMPUTER INSTITUTE",
  "HARMILAP INSTITUTE OF COMPUTER & TECHNOLOGY, SHAHDOL",
  "HORIZON ACADEMY SEONI MALWA",
  "ICCI COMPUTER ACADEMY BHOPAL",
  "BALAJI INSTITUTE OF NURSING ",
  "vidyavahini institute tecnology ",
  "VIVEKANAND COMPUTER SANSTHAN VIDISHA",
  "VIVEKANAND INSTITUTE OF INFORMATION TECHNOLOGY BARWANI",
  "SRI AUROBINDO COLLEGE OF DENTISTRY, INDORE",
  "BHABHA INSTITUTE OF MANAGEMENT",
  "Sri Parashuram Institute of Technology and Research, Khandwa",
  "ALL IS WELL COLLEGE OF NURSING",
  "SHRIJEE PARAMEDICAL COLLEGE MANDSAUR",
  "BHAVISHYA NIRMAN INSTITUTE OF INFORMATION TECHNOLOGY",
  "S. Kishorlal Verma Memorial College, Pandhana, Dist Khandwa",
  "M.L. Nehru Law College,Khandwa",
  "TECHNOCRATS INSTITUTE OF TECHNOLOGY AND SCIENCE PHARMACY",
  "GOVERNMENT COLLEGE DIMNI",
  "GOVT COLLEGE RITHOURA, MORENA",
  "B.M. INST. OF PROF. STUDIES, INDORE",
  "SHOPHIA COLLEGE OF HOMEOPETHIC  COLLEGE",
  "SHRI RAWATPURA SARKAR COLLEGE OF NURSING",
  "THAKUR SHIVKUMARSINGH MEMORIAL MANAGEMENT COLLEGE, NAVALNAGAR, ZIRI",
  "Govt. College, Burhanpur",
  "GOVERNMENT SCHOOL OF NURSING J.A. HOSPITAL GWALIOR",
  "SHWAMI AMURTANAND GOVERNMENT COLLEGE, ANJAD",
  "IDEAS NURSING COLLEGE GWALIOR",
  "NAVEEN GOVERNMENT COLLEGE SALICHOUKA ",
  "SHAKTI VIDHYA MANDIR EDUCATION AND TRANING INSTITUTE, KATANGI",
  "Sri Balaji College of Education, Chhindwara",
  "MANAV INSTITUTE OF TECHNOLOGY",
  "NEW SHIVANI COMPUTER CENTRE ",
  "SIR ATMA RAM INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "KOPAL COLLEGE FOR MANAGEMENT,  BHOPAL ",
  "CBS GROUP OF EDUCATION MADANPURA GWALIOR",
  "ORIENTAL INSTITUTE OF MANAGEMENT LALBURRA",
  "N Y COLLEGE OF EDUCATION",
  "SHRI ATAL BIHARI VAJPAYEE GOVERNMENT COLLEGE, PANSEMAL",
  "Madhuban Instt. of Prof. Studies, Cat Road, Indore",
  "Govt. Girls College, Dhar",
  "S.M. Sidha College of Education, Dhar",
  "Shri Cloth Market Girls Commerce College, Ganeshganj, Indore",
  "Shri Cloth Market Instt. Of Prof. Studies,  Bada Ganpati, Indore",
  "Indore Mahavidhyalya, Moole Tower,  Indore",
  "Bherulal Patider Govt.  P.G. College, Mhow",
  "Govt. College, Dharampuri",
  "GANDHI   VOCATIONAL COLLEGE",
  "Gyanodya B.Ed. College, MIG Colony, Indore",
  "Seva Sadan College, Burhanpur",
  "Shri Aurbindo Institute of Management, Sanwer Road, Indore",
  "Shri Kanwartara Institute for Teachers Training, Mandleshwar",
  "Shri Nityanand B.Ed. College, 1 Mission Compound, Dhar",
  "S.D. Bansal College of Technology,  Umariya, A.B.Road, Indore",
  "Vikrant Institute of Integrated & Advanced Studies, Gram Borkhedi, Indore",
  "Govt. College, Sanawad",
  "Sardar Vallabh Bhai Patel College, Mandleshwar",
  "Govt. Shiksha College, Khandwa",
  "SHRI UMIYA KANYA MAHAVIDYALAYA, RANGWASA (RAU) INDORE",
  "Lakshmi Narain College of Technology,  Sanwar Road, Indore",
  "Gyan Shiksha College, Opp. Govt. College, Dhar",
  "Sardar Vallabh Bhai Patel Shiksha College, Sendhwa",
  "Renaissance College of Commerce & Management. 45, Anurag Nagar, INdore",
  "B.M. College of Technology, Khandwa Road, Indore",
  "Military College of Telecommunication Engineering (MCTE), Mhow",
  "Radiant Institute. of Management, Bakhtawar Ram  Nagar, Indore",
  "Saifee Golden Jubilee Quaderia College, Burhanpur",
  "Shri Kanwartara Science & Commerce, Mandleshwar",
  "S.D. Bansal College of Engg., Indore",
  "Shri Vaishnav Institute of Law Rajendra Nagar, Indore",
  "Shri Vaishnav Commerce College,  Rajmohalla Square, Indore",
  "GOVERNMENT COLLEGE GARHA, JABALPUR",
  "ISBA INSTITUTE OF PROFESSIONAL STUDIES",
  "\"Mahakal Institute of Technology,Karcha Farms Village Datana,  Behind Air Strip, Dewas Road, Ujjain-456006\"",
  "Swami Vivekanand College of Pharmacy, Khandwa Road, Tool Naka, Indore-452020",
  "R B S INSTITUTE OF NURSING, NEEMUCH",
  "KARYON COLLEGE OF PARAMEDICAL SCIENCE CHHINDWARA",
  "MAHARISHI MAHAVIDYALAYA, NARSINGHPUR",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, BHOPAL",
  "GYANVEER NURSING COLLEGE, SAGAR",
  "CORE COLLEGE OF NURSING PARAMEDICAL INDORE",
  "Times College, Choupra Khurd, Damoh",
  "Pt.Bhagirath BilgaiyanMemorial Tech.and ProfessionalTakshshila Coll, Bina",
  "BHAKTANANDJI INSTITUTE OF MEDICAL SCIENCE ",
  "BALAJI COLLEGE OF EDUCATION",
  "Shri V.D.M. College, Khurai",
  "VIDYAVATI COLLEGE GWALIOR",
  "Digital Inst. of Sc. and Tech. Chhatarpur",
  "Saupura College of Information and Bio-Technology, Sausar (Pipla)",
  "MP STATE INSTITUTE OF HOSPITALITY TRAINING",
  "AKHIL BHARTI COLLEGE OF MANAGEMENT",
  "MAA GAYATRI TRIAINING COLLEGE, HAIBATPURA, BHIND M P",
  "JNCT COLLEGE BHOPAL",
  "MILLENNIUM COLLEGE OF NURSING, BHOPAL",
  "NAVEEN SHASAKIYA MAHAVIDHYALAYA, BETMA",
  "SAI NURSING COLLEGE BARWANI",
  "INFOZONE GROUP OF INSTITUTES",
  "Kamla Memorial College of Education ",
  "Patel College of Science & Technology, Near Navodaya Vidyalaya Samazgarh, Jain Mandir Road, Ratibad, Bhopal",
  "MA SARASWATI SCHOOL OF NURSING, BADWANI",
  "FINE ART COLLEGE, PANNA",
  "TECHNOCRATS INSTITUTE OF NURSING",
  "SWAMI VIVEKANAND COLLEGE OF NURSING  SAGAR",
  "VEER COLLEGE OF MANAGMENT ",
  "ANIMAL HUSBANDRY DIPLOMA COLLEGE BHOPAL",
  "SHRI RAM SCHOOL OF BUSINESS STUDIES",
  "R.D.G.D. College Of Nursing, Ujjain",
  "Gyanodya Inst. of Management, Behind Little Flower School, Sadar, Betul",
  "Choradia Institute of Pharmacy, Gram Baroli, Sanwer Road, Indore - 452001",
  "NRI INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES, BHOPAL",
  "Nutanben Mansukhbhai Turakhia Gujarati College of Pharmacy, Scheme No. 54, Near Bombey Hospital, A.B. Road, Indore",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE TALA SATNA MADHYA PRADESH",
  "ANIMAL HUSBANDRY DIPLOMA COLLEGE REWA",
  "GOVERNMENT COLLEGE, MAJHOLI",
  "Institute for Excellence in Higher Education(IEHE),Bhopal(Autonomous) Kaliya sot bandh Kolar Road, Bhopal",
  "HOLY FAITH COLLEGE OF EXCELLENCE, HARDA KHURD",
  "BRIGHT CAREER COLLAGE OF EDUCATION, RAISEN",
  "ALPHA COLLEGE, SHYAMPUR",
  "MAHATMA GANDHI COLLEGE, ASHTA",
  "PRATAP COLLEGEE",
  "SWAMI VIVEKANAND COLLEGE, BEGUMGANJ",
  "SAGAR INSTITUTE OF SCIENCE & TECHNOLOGY (SISTEC), GANDHI NAGAR",
  "IDEAL COLLEGE OF PROFESSIONAL STUDIES, SEHORE",
  "MAR MASELIOS COLLEGE OF NURSING",
  "SHRI RADHA KRISHAN COLLEGE OF EDUCATION, BHOPAL",
  "GOVERNMENT DEGREE COLLEGE BARGAWAN",
  "VIVEKANAND COLLEGE, PIPARIYA",
  "RKDF College of Technology, NH-12, Hoshangabad Road, Jatkhedi",
  "LAXMAN SETH EDUCATION COLLEGE, KATETA, SHIVPURI",
  "AMRIT SHIKSHA COLLEGE, BARGAWAN, SINGRAULI",
  "PRATYANSH COLLEGE OF NURSING",
  "CARE COLLEGE OF EDUCATION",
  "SONALI COLLEGE LAW",
  "IG GROUP OF DEGREE COLLEGE PADAINIYA",
  "SARDAR AJIT SINGH SMRITI AYURVED MAHAVIDHYALAYA ADAMPUR CHAWANI BHOPAL",
  "CIST College",
  "LITTLE ANGEL INSTITUTE OF PROFESSIONAL STUDIES",
  "PRISTEN COLLEGE SELWANI",
  "GOVT COLLEGE RAJMILAN",
  "GOVERMENT COLLEGE GOHPARU",
  "GOVERNMENT COLLEGE NOWROZABAD DISTRICT UMARIA",
  "ARTEMISIA BUSINESS SCHOOL",
  "INDORE INTERNATIONAL COLLEGE KHASGI KA BAGICHA ",
  "Govt. M.H. College of Home Science and Science for Women, Jabalpur",
  "CYBER COMPUTER AMARWARA",
  "RANI DULLAIYA SMRITI HOMOEOPATHY COLLEGE AND HOSPITAL",
  "DR BHAGAT SINGH RAI COLLEGE OF PHARMACY ",
  "IG EDUCATION MAHAVIDHYALAYA SARNI DISTT BETUL MP",
  "NAVIN PURNA ART AND SCIENCE COLLEGE BHAINSDEHI",
  "UMA COMPUTER INSTITUTE",
  "Shri jain Diwakar Mahavidyalaya",
  "SRI SATYA SAI COLLEGE OF ENGINEERING",
  "JAIHIND COLLEGE OF MANAGEMENT ",
  "Govt. Degree College  Ajaygarh",
  "JAI MAA KAILA DEVI MAHAVIDYALAY MORENA",
  "Govt. Girls  College, Panna",
  "VNS GROUP OF INSTITUTIONS FACULTY OF PHARMACY",
  "SMT MAINA DEVI MEMORIAL ANIMAL HUSBANDRY DIPLOMA COLLEGE GWALIOR MP",
  "SANJIVANI INTERNATIONAL",
  "Govt. Degree College, Devendranagar",
  "Smt. Dhairya Prabhadevi Sojatia Women's College",
  "Lt. Nand Kishor Patel B.Ed. College, Betul",
  "SURBHI INFOTECH SARANGPUR",
  "Bhagirathji Silawat Govt College Depalpur Distt Indore",
  "PRAKHAR MASTER MIND COMPUTER ",
  "SBS INSTITUTE OF COMPUTER VIDISHA",
  "SECT LEELAWATI INSTITUTE, BALAGHAT",
  "Sarman Computer Institute Amanganj 8181",
  "SHARDA INSTITUTE OF COMPUTER andMANAGEMENT",
  "SHARP COMPUTER CENTRE TIKAMGARH",
  "shree sai vidhyapeeth",
  "SARA COMPUTER EDUCATION GADARWARA",
  "SHREE COMPUTER  I.T.",
  "Shree Sai Computer Institute ",
  "SHREE SAI COMPUTERS BHOPAL",
  "Govt.College Palera, Tikamgarh ",
  "SHREE UNIQUE COMPUTER  I.T.",
  "shri kedar institute of computer technology R.I.T COMPLEX SIRMOUR CHOUK REWA ",
  "SHRI SAI INSTITUTE OF COMPUTER AND TECHNOLOGY",
  "SHRI SHIV GIRIJA INSTITUTE OF COMPUTER SCIENCE BANDA",
  "SHUBHAM ACADEMY SHUJALPUR",
  "SECT COMPUTERS, SEONI",
  "Silicobyte Katni Degree College of Computer Science",
  "Omega College of Professional Studies, Ujjain ",
  "SHRI SAI COMPUTER & INFORMATION TECHNOLOGY REWA",
  "SITC CHHINDWARA",
  "SAI NATH COLLEGE OF NURSING, KATNI",
  "MITALI INSTITUTE OF NURSING",
  "SINGRAULI INSTITUTE OF COMPUTER TECHNOLOGY SINGRAULI",
  "ANGIRA COLLEGE OF EDUCATION",
  "SHRI SHARDA INSTITUTE OF COMPUTER APPLICATION & INFORMATION TECHNOLOGY MAIHAR",
  "SOFT LINE COMPUTER CENTRE BHOPAL",
  "SOFT PLUS RATLAM",
  "SMT. SAVITRI DEVI INSTITUTE OF COMPUTER SCIENCES BURHANPUR",
  "WINNERS COMPUTER ACADEMY",
  "VARDHMAAN KALAASHRAM ART AND CRAFT SOCIETY",
  "SICT INSTITUTE",
  "Sidhi Institute of Professional Studies 8267",
  "SPARSH INSTITUTE OF IT EDUCATION",
  "SPACE COMPUTER DAMOH",
  "SRI AUROBINDO INSTITUTE OF PROFESSIONAL STUDIES SHAJAPUR",
  "Pt. Shiv Shaktilal Sharma Ayurved Medical College, Ratlam",
  "SRIT EDUCATION ",
  "JAI NARSINGH COLLEGE    ",
  "IMI PHARMACEUTICAL STUDIES, INDORE    ",
  "PRESTIGE COLLEGE OF PHARMACY    ",
  "SRUSHTI COMPUTER EDUCATION MULTAI",
  "S.S. COLLEGE OF COMPUTER & PROFESSIONAL STUDIES CHHINDWARA",
  "DAKSH ACADEMY DHAR",
  "SUBHEDAR INSTITUTE OF COMPUTER EDUCATION SAGAR",
  "SHRI RAMSNEHI SHUKLA INSTITUTE OF SCIENCE & MANAGEMENT BAMOURGAON",
  "LAL BAHADUR SHASTRI ANIMAL HUSBANDRY DIPLOMA COLLEGE, HARDA    ",
  "SONY COMPUTER EDUCATION CHHINDWARA",
  "SRIRAM INSTITUTE OF IT NOWGONG",
  "N.I.C.T. KANYA COLLEGE, VAIDHAN",
  "SSI COMPUTER INSTITUTE GWALIOR",
  "SUNRISE INSTITUTE OF PROFESSIONAL STUDIES ",
  "SUNRISE INSTITUTE OF TECHNOLOGY BHOPAL",
  "SUPREME INSTITUTE OF COMPUTER INFORMATION TECHNOLOGY",
  "SUNRISE INSTITUTE OF INFORMATION TECHNOLOGY NOWGONG",
  "SHRI SWAMI SAMARTH COLLEGE OF PHARMACY, HARDA    ",
  "SURYA ACADEMY BHOPAL",
  "S.V.S. COMPUTERS CHHINDWARA",
  "Shri Saibaba College for Teachers Training, Saibabanagar, Indore",
  "JD Institute of fashion Technology",
  "S.I.T. COLLEGE OF EDUCATION, JAMORI, SIDHI",
  "SAKSHI B.ED. COLLEGE, BARAURA, SIDHI",
  "JYOTSANA B.ED. COLLEGE, HARBARO, SIDHI",
  "Ganesh Pd. Vedni College., Ghuwara",
  "VEER BALIDANI KHAJYA NAYAK GOVERNMENT P.G. COLLEGE SENDHWA",
  "Government Science College, Jabalpur",
  "SAK MEMORIAL INSTITUTE OF NURSING SCIENCE CHHINDWARA",
  "NEERANCHALAM COLLEGE METHAURI, MANGAWA, REWA",
  "CARE SCHOOL OF NURSING, MANDLA",
  "SHAUDAMINI INSTITUT OF NARSHING AND RISARCH REWA",
  "INSTITUTE OF PHARMACY DIPLOMA",
  "MAHARANA PRATAP COLLEGE OF NURING",
  "UNIVERSITY COLLEGE OF NURSING BHOPAL",
  "NEWTON COLLEGE OF SCINSE AND TECNOLOGY SAINKHEDA",
  "PATIRAM SHIVHARE NURSING COLLEGE BHIND",
  "SWAMI VIVEKANAND COMPUTER ACADEMY BEGUMGANJ",
  "LAKSHMI NARAIN COLLEGE OF TECHNOLOGY EXCELLENCE, Khajuri Khurd, Raisen Road, Bhopal - 462021",
  "GRANTHAM NURSING COLLEGE",
  "SWAMI VIVEKANAND INSTITUTE OF TECHNOLOGY BALAGHAT",
  "RADIANT INSTITUTE OF MANAGEMENT AND SCIENCE",
  "MADHAV VIDHI MAHAVIDHYALAYA",
  "SOFT PLUS COMPUTERS CENTER",
  "Veerangna Rani Avantibai Government College Khairlanji",
  "RADHA KRISHAN COLLEGE OF PHARMACY",
  "SHRI RAWATPURA SARKAR INSTITUTE OF NURSING MANDLA",
  "GOVT COLLEGE AKODA",
  "SSG MEDICAL INSITUTION UJJAIN",
  "INDIRA INSTITUTE OF PROFESSIONAL STUDIES ",
  "INSTITUTE OF PROFESSIONAL EDUCATION AND RESEARCH IPER",
  "Madhuban College of Nursing Indore",
  "Dr M B SHARMA NURSING COLLEGE",
  "VNS COLLEGE OF NURSING",
  "NALANDA COLLEGE ICHHAWAR",
  "SAPPHIRE INSTITUTE, INDORE",
  "SRI SAI INSTITUTE OF AYURVEDIC RESEARCH AND MEDICINE BHOPAL",
  "SHRI UMA GIRLS COLLEGE, HATPIPLIYA",
  "Sri Sathya Sai Institute of Pharmaceutical Sciences",
  "Intellicom B.Ed. College, Jawahar Chowk, Bhopal",
  "INDORE INSTITUTE OF MEDICAL SCIENCES",
  "SUNRISE INSTITUTE OF COMPUTER EDUCATION MANDSAUR",
  "SWAMI VIVEKANAND INSTITUTE OF PROFISSIONAL STUDIES",
  "RKDF COLLEGE OF TECHNOLOGY AND  RESEARCH",
  "RAI SCHOOL OF NURSING",
  "TAVITE COMPUTER & SOFTWARE INSTITUTE KATNI",
  "TIMES COLLEGE OF COMPUTER AND INFORMATION TECH. DAMOH",
  "SRUSHTI COMPUTER EDUCATION BETUL",
  "Law College, Betul",
  "UNIQUE COMPUTER CENTRE TIKAMGARH",
  "UNIQUE INSTITUTE OF MEDIA AND TECHNOLOGY, BALAGHAT",
  "UNIQUE INSTITUTE OF PROFESSIONAL STUDIES KHANDWA",
  "UNITY IN-FORMATIVE INSTITUTE OF TECHNOLOGY VIDISHA",
  "UNIVERSAL COMPUTERS PANNA",
  "UNIVERSAL INSTITUTE OF COMPUTER AND TECHNOLOGY BURHAR",
  "UNIVERSAL COMPUTER ACADEMY SEONI",
  "Vaishnavi College of CS/IT Parasia ",
  "INDRA GANDHI COLLEGE OF TECHNOLOGY & SCIENCE, BEOHARI",
  "MANOJ JAIN MEMORIAL COLLEGE, SHERGANJ, SATNA",
  "VINDHYA COLLEGE OF EDUCATION, AMARPATAN ROAD, SATNA",
  "UNIQUE INSTITUTE OF PROFESSIONAL STUDIES BURHANPUR",
  " SSICAIT KANYA COLLEGE, MAIHAR",
  "JAWAHARLAL NEHRU COLLEGE OF EDUCATION, RATAHARA, REWA ",
  "EXILENCE B.ED. COLLEGE, MHASUA, REWA",
  "G.K. COLLEGE OF EDUCATION, CHAKGHAT, REWA",
  "CHHATRAPATI SAHU JI B.ED. COLLEGE, RATHARI, REWA",
  "INNOVATIVE COMMERCE COLLEGE GOVINDPURA BHEL BHOPAL",
  "GURU GOBIND SINGH INSTITUTE OF COMPUTER AND COMMUNICATION",
  "UNIX COMPUTERS RAJGARH",
  "GOVERNMENT POLYTECHNIC COLLEGE JAWAD",
  "VIVEKANAND VIDHYAPEETH",
  "WADHWANI INSTITUE OF COMPUTER TECHNOLOGY BHOPAL",
  "Indira Gandhi Girls College, Pathakheda, Sarni, Betul",
  "INDIRA GANDHI B ED COLLEGE, BAGDONA",
  "H.L. Agrawal B.Ed. College, Betul",
  "J.H. Govt. P.G. College, Betul",
  "Govt. College, Sarni, Betul",
  "Govt. College, Multai, Betul",
  "GOVT. COLLEGE KARERA",
  "GOVT COLLEGE GORAMI",
  "ARYANSH COLLEGE OF ARTS AND MANAGEMENT",
  "Govt. College, Bhaisdehi, Betul",
  "Govt. College, Athner Betul",
  "GOVERNMENT GIRLS COLLEGE, BETUL",
  "BHAGYODAY TIRTH NURSING COLLEGE",
  "Padma College of Education Jhabua",
  "SHRI RGP GUJARATI PROFESSIONAL INSTITUTE, Scheme No. 54, Near Bombey Hospital , Ab.B. Road, Indore - 452010",
  "SRAJAN COLLEGE LAVKUSHNAGAR",
  "World Computer Centre",
  "BHOPAL INSTITUTE OF TECHNOLOGY AND MANAGEMENT MBA",
  "SANDIPANI PROFESSIONAL COLLEGE PAWAI ",
  "COLLEGE OF POLYTECHNIC ENGINEERING",
  "MILLENNIUM COLLEGE OF MANAGEMENT",
  "SHIVPURI INSTITUTE OF TECHNOLOGY",
  "THAKUR HARI SINGH MAHAVIDHYALAYA",
  "Compfeeders Aisect College of Professional Studies Pharmacy College Indore",
  "EXCELLENCE COLLEGE KHEDLI DIST SEHORE",
  "SHRI COLLEGE OF EDUCATION",
  "JAGADGURU DATTATRAY COLLEGE OF PHARMACY INDORE ",
  "MAHAMRITYUNJAY SCHOOL OF NURSING",
  "COLLEGE OF MANAGEMENT SCIENCE,,SIDHI",
  "RANI COLLEGE OF EDUCATION, RAUSAR, REWA",
  "SWAMI NEELKANTH LAW COLLEGE MAIHAR, SATNA",
  "Government Law College Ujjain",
  "GOVERNMENT COLLEGE, VIJAYRAGHAVGADH",
  "NACHIKETA INSTITUTE OF MANAGEMENT AND INFORMATION TECHNOLOGY",
  "Vidyodaya College, Manawar",
  "Alexia College of Professional Studies, Indore",
  "PARAMHANS INSTITUE OF EDUCATION",
  "VINAYAK MAHAVIDHALAYA, GADARWARA",
  "MAHARASHTRA INSTITUE OF HIGHER EDUCATION, JABALPUR",
  "MATHER TERESA LAW COLLEGE, JABALPUR",
  "SHRI RAWATPURA SARKAR SNATAK COLLEGE",
  "SAINA INTERNATIOAL COLLEGE, KATNI",
  "SARDAR PATEL INSTITUTE OF EDUCATION, Jabalpur",
  "MAHARANA PRATAP COLLEGE OF ALLIED SCIENCE",
  "OM MAHAVIDHYALAYA",
  "College of Agriculture, Warasiwani",
  "GOVERNMENT COLLEGE, SIHORA",
  "Indira Gandhi Memorial Homeopathic College, Dhar",
  "Dr. Bhimrao Ambedkar Mahavidyalaya, Betul",
  "MAHARANA PRATAP COLLEGE OF SCIENCE AND TECHNOLOGY",
  "Dr. Bhimrao  Ambedkar Government College Amla ",
  "AS DEGREE COLLEGE  KAILARAS",
  "NALANDA SCIENCE & COMMERCE COLLEGE",
  "RELIANCE INSTITUTE OF NURSING KOTMA ANUPPUR",
  "RELIANCE INSTITUTE OF NURSING BIRSINGHPUR PALI UMARIA",
  "BHARAT INSTITUTE OF NURSING MANDLA",
  "GYANDEEP COLLEGE OF EDUCATION",
  "SMT. KAMLABEN RAOJIHAI PATEL GUJARATI HOMEOPATHIC MEDICAL COLLEGE, INDORE, M.P.",
  "ATASH COLLEGE, MULTAI",
  "AD KADWE COLLEGE, DUNAWA MULTAI",
  "Vivekanand Science College, Betul",
  "Shri Ganesh Education College, Mandvik Athaner, Betul",
  "Sai Kripa Vigyan Mahavidhyalaya, Betul",
  "GOVERNMENT COLLEGE ORCHHA     ",
  "BHABHA COLLEGE OF ENGINEERING",
  "GOVT. ARTS & COMMERCE COLLEGE MOHNA",
  "MALHOTRA COLLEGE (PHARMACY)",
  "MALHOTRA  COLLEGE OF PHARMACY,Badwai Near Karond BHOPAL-462038",
  "RAJA BHOJ COLLEGE OF EDUCATION",
  "Pt. Jawaharlal Nehru College, Ratera Road, Govind Colony, Amla, Betul",
  "SOHAGI COLLEGE OF EDUCATION, SOHAGI, REWA",
  "Christ College, Saint Paul School Campus, Anand Nagar, Bhopal",
  "Maharishi Koutilya Academy",
  "Pt. Dwarika Prasad College, Athner, Betul",
  "Prabhat College, Prabhat Pattan, Multai, Betul",
  "SUNDERLAL PATWA GOVERNMENT MEDICAL COLLEGE, MANDSAUR    ",
  "PADMAVATI MAHAVIDHYALAYA PUNJI",
  "Shri Ram College Of Technology Bhopal",
  "BEST GWALIOR",
  "Jawaharlal College, Vidisha",
  "Govt. College, Zirapur, Rajgarh",
  "SPS COLLEGE",
  "SIIT CHANDERI",
  "CHAMMBAL B.ED COLLEGE",
  "RAMDEV COLLEGE OF NURSING",
  "SANJEEVANI PARAMEDICAL COLLEGE SEONI",
  "RAMSUAROOP EDUCATION COLLEGE",
  "SHRI RAWATPURA SARKAR SANSKRIT MAHAVIDYALAYA RAWATPURA DHAM    ",
  "SHRI SAI COLLEGE OF EDUCATION ",
  "MAHARANA PRATAP COLLEGE DENTESTRY & RESEARCH CENTER",
  "SHRIRAM SCHOOL OF PHARMACY    ",
  "LBS Homeopathic College Samardha, Hoshangabad Road, Bhopal",
  "SHRI KESHAV SINGH EDUCATION COLLEGE",
  "Govt. Degree College, Shahpura, Dindori",
  "RAJA BHOJ GOVERNMENT COLLEGE MANDIDEEP",
  "NAMOKAR COLLEGE, VIDISHA",
  "MOHI CLLEGE OF EDUCATION",
  "SANT SHRI SINGAJI GOVERNMENT COLLEGE RAJPUR",
  "M.K. H.S. Gujarati Girls Commerce College, Indore",
  "JAIN DEGREE COLLEGE, BHIND",
  "LT SARDAR SINGH SMRITI SHIKSHA SAMITEE TAL DARWAJA TIKAMGARH ",
  "SUBHASH COLLEGE, MORENA",
  "Abdul Hamid Unani Chikitsa College, Dewas",
  "Medicare Institute Of Medical Science",
  "VITS COLLEGE OF PHARMACY, SATNA",
  "IES INSTITUTE OF PHARMACY, BHOPAL",
  "SUN INSTITUTE TEACHER EDUCATION LAHAR",
  "D S MAHAVIDYALAY JHONPA",
  "AP COMPUTER INSTITUTE",
  "MADHYA BHARAT PHARMACY COLLEGE ",
  "SAGAR INSTITUTE OF PHARMACEUTICAL TECHNOLOGY AND RESEARCH",
  "H L AGRAWAL COLLEGE OF EDUCATION",
  "KUNO COLLEGE",
  "ORIENTAL INSTITUTE OF PHARMACY AND RESEARCH",
  "CARE COLLEGE OF NURSING ",
  "Govt. Music College, Maihar, Satna",
  "SHRI RAVINDRANATH TAGORE INSTITUTE OF PROFESSIONAL STUDIES",
  "N. R. INSTITUTE D.ED. COLLEGE MANDVI DIST. BETUL M.P.",
  "GOVERNMENT COLLEGE, DOBI",
  "SUKH SAGAR MEDICAL COLLEGE AND HOSPITAL",
  "TOMAR COMPUTERS",
  "Shri Rawatpura Sarkar Institute of Technology and Science",
  "FINE ART COLLEGE",
  "KHAJURAHO FINE ART COLLEGE",
  " SCHOOL OF HOMOEOPATHY SRI SATYA SAI UNIVERSITY OF TECHNOLOGY AND MEDICAL SCIENCES",
  "REWA INSTITUT OF TECNOLOGY RATAHARA,REWA",
  "ANIMAL HUSBANDRY DIPLOMA COLLEGE, MORENA",
  "S B COLLEGE",
  "J.C. MILLS GIRLS COLLEGE",
  "TATA B.ED. COLLEGE, SAGRA, REWA",
  "SHARDA DEVI COLLEGE, TEONTHAR",
  "GOVERMENT COLLEGE BIDWAL DHAR",
  "WISDOM INSTITUTE OF NURSING KATNI",
  "PRESTIGE COLLEGE OF SCIENCE AND TECHNOLOGY",
  "B L MAHAVIDYALYA, JOURA ROAD",
  "JJ COLLEGE OF EDUCATION",
  "GENIUS MAHAVIDYALYA",
  "SRC BHOPAL",
  "Revanath Chaure College of Education, Sausar",
  "SHRINATH PARAMEDICAL COLLEGE",
  "OXFORD COLLEGE OF LAW",
  "V.M. GOVERNMENT POLYTECHNIC COLLEGE NARSINGHPUR",
  "SARVE ASTHA COLLEGE SULTANGANJ",
  "RAMBAI SMRITI COLLEGE, DABHAURA",
  "GOVT. DEGREE COLLEGE PORSA",
  "RAMDEV MAHAVIDYALAYA",
  "NARMADA INSTITUTE OF TECHNOLOGY BABAI",
  "IGM INSTITUTE OF COMPUTER EDUCATION",
  "EXCEL INSTITUTE OF COMPUTER SCIENCE EICS ACADEMY",
  "DIVYANSH COLLEGE",
  "Mathuradevi Institute of Management, Indore",
  "Govt. Degree College, Pawai",
  "S B D KALA EVAM VIGYAN MAHAVIDYALYA, NAGRA, PORSA",
  "SARVODAYA MAHAVIDHYALAYA TALENT",
  "B.L. PARAMEDICAL COLLEGE",
  "ADARSH COLLEGE",
  "NRI Vidyadayani Institute of Science Management and Technology Bhopal",
  "SWAMI VIVEKANAND COLLEGE OF SCIENCE AND TECHNOLOGY",
  "BHAGYODAY TIRTH INSTITUTE OF PARAMEDICAL SCIENCE SAGAR",
  "K R Academy",
  "UNIQUE COMPUTER AND IT TEONTHAR REWA",
  "LAKSHNI NARAIN COLLEGE OF PROFESSIONAL STUDIES",
  "H.L.AGRAWAL B.ED. COLLEGE",
  "shri ram computer education ",
  "MILLENNIUM INSTITUTE OF PARAMEDICAL SCIENCES BHOPAL",
  "LOTUS COMPUTER EDUCATION ACADEMY SOHAGPUR",
  "Alpine Institute of Tech., Ujjain",
  "Babulal Tarabai Institute of Pharmaceutical Science",
  "CHRISTUKULA MISSION COLLEGE",
  "KALYANIKA KENDRIYA SHIKSHA NIKETAN, AMRKANTAK",
  "ADITYA B.ED. COLLEGE, SATNA",
  "S I  P STUDYIES, AJAD NAGAR,  URRHAT,  REWA",
  "Seva Sadan Law College,  Burhanpur",
  "RD MEMORIAL COLLEGE",
  "SCHOOL OF NURSING SRI SATYA SAI UNIVERSITY OF TECHNOLOGY AND MEDICAL SCIENCES",
  "Prime Minister College of Excellence Govt College Makronia, Bujurg, Sagar MP",
  "NRI COLLEGE OF EDUCATION",
  "SWAMI VIVEKANAND DEGREE COLLEGE SIRONJ DIST VIDISHA",
  "ASHOKA D S COLLEGE KHASRA NO",
  "KS EDUCATION COLLEGE MUA.",
  "PRESTIGE INSTITUTE OF MANAGMENT",
  "KHERAPATI SARKAR GROUP OF COLLEGE INDERGARH",
  "GOVT. DR. BHAGWAT SAHAY COLLEGE",
  "DURGAPRASAD  SARRAF COLLEGE DABHO",
  "GOVT.  CHATRSAL COLLEGE PICHORE",
  "CH. DILIP SINGH GIRLS COLLEGE",
  "HICT EDUCATION COLLEGE TEERUPATI MOTERS KE PASS TANSEN ROAD",
  "SHITALA  EDUCATION COLLEGE DABRA",
  "SWAMI VEVEKANAND COLLEGE OF EDUCATION",
  "SHRI SWAMI JI  MAHARAJ COLLEGE OF EDUCATION",
  "NAGAJI INSTITUTE OF TECH. & MANAGEMENT SITHOLI",
  "SHR RAMNTH SINGH EDUCATION COLLEGE, SITHOLI",
  "SHIV SHANKAR  COLLEGE , SUMAVALI",
  "NATIONAL EDUCATION COLLEGE NEW HIGH COAD KE PASS",
  "GOVT. MADHAV COLLEGE CHANDERI",
  "NEELKANTH EDUCATION COLLEGE",
  "CH- DILIP SINGH GIRLS COLLEGE",
  "NRI INSTITUTE OF NURSING AND RESEARCH BHOPAL",
  "Shrimant Madhavrao Scindia Government Model Science College, Gwalior",
  "COLLEGE OF ADVANCE TECHNOLOGY & SCIENCE (IATS) COLLEGE  (B.ED.)",
  "Maa Shanti Devi Mahavidyalaya, Badokhar,Morena",
  "OASIS EMPIRIAL COLLEGE OF EDUCATION GOHAD",
  "RADHA KRISHAN EDUCATION COLLEGE",
  "ADITYA COLLEGE CITY CENTER",
  "Vishnu Rajoriya College, Khirkiya, Harda",
  "Mansarovar Dental College Kolar Road, Bhopal",
  "Rajeev Gandhi College, Obedullahganj, Raisen",
  "Career Law College, BHEL, Bhopal",
  "Govt. College, Sarangpur, Rajgarh",
  "Unique College, M.A.L. Quater Jawahar Chowk, Bhopal",
  "NES College, Hoshangabad",
  "City College of Education, Bhopal",
  "K.M.L. Vatsalya College, Haripura, Vidisha",
  "Rai Sahab Bhanwar Singh College, Nasrullaganj, Sehore",
  "Govt. Girls College, Itarsi, Hoshangabad",
  "Regional Inst. of Education, Shyamla Hills, Bhopal",
  "Malhotra College ,Karod Road, Bhopal",
  "Vardhman College, Near Sub Post Office, Surajganj, Itarsi, Hoshangabad",
  "KDBM College, New Bus Stand, Paliwal Farm House, Sironj, Vidisha",
  "N.R. I Institute of Information Sc. & Technology Sajan Nagar Raisen Road, Bhopal",
  "Kalawati Smriti College, AShatha, Sehore",
  "Princeton College, Bareli, Raisen",
  "Lal Bhadur Shashtri JProfessional Studies, Harda",
  "Veena Vadani College of Education, Chuna Bhati, Bhopal",
  "Green Vally College, C-Sector, Kolar Road, Bhopal",
  "Mansarover Nursing College, Kolar Road, Bhopal",
  "Guru Kripa College, Bareli, Raisen",
  "Govt. Geetanjali Girls College, Berasia Road, Bhopal",
  "Bhopal degree College, 393 Ashok Vihar, Ashoka Garden, Bhopal",
  "Kushabhao Thakre Nursing College, Karod, Bhopal",
  "Institute of Advanced Study in Education(IASE), Bhopal",
  "Akhil Bhartiya Shiksha Avm Prashikshan Mahavidyalaya, Bhopal",
  "Mahatama Gandhi College, Sehore",
  "Ramkrishna Memorial College, Girija Sapan Vidya Vihar, Ahmadpur Road, Vidisha",
  "Vidhik Education College, Bhopal",
  "Maharishi Centre for Education Excellence, Lambakheda, Berasia Road, Bhopal",
  "Pt. Ram Lal Sharma Education College, Hoshangabad",
  "Vikramaditya College Zone-II, M.P. Nagar, Bhopal",
  "Harda Adarsh College, Harda",
  "Vidhya Sagar Inst. of Management, Vallabh Nagar, BHEL, Bhopal",
  "Sardar Ajit Singh Memorial Girls College, 13 Lala Lajpat Rai Colony, Raisen Road, Bhopal",
  "Kushabhaou Thakre College, Gyraspur Lokkalyan Samiti, Vidisha",
  "Govt. Home Science College, Hoshangabad",
  "Takshila College, ",
  "VNS College of Physical Education and Management Studies",
  " SAROJINI NAIDU GOVERNMENT GIRLS POST GRADUATE (AUTONOMOUS) COLLEGE , SHIVAJI NAGAR,BHOPAL",
  "Nirvindiya Mahavidyalay, Biaora, Distt. Rajgarh",
  "Govt. Mahatama Gandhi College, Itarsi, Hoshangabad",
  "Gurudev Vidya Sagar B.Ed. College, Vidisha",
  "Govt. Homeopathic Medical College, Bhopal",
  "Rajeev Gandhi College, Kala Bagh Belet Road, Ganjbasoda, Vidisha",
  "Johri Prof. College Rajat Nagar, Narli shankari JK Road, Bhopal",
  "Govt. Girls College, Pipariya, Hoshangabad",
  "Ram Manohar Lohiya College, Bhopal",
  "Renu College, Mandideep, Raisen",
  "Safia Science College, Bhopal TAlkies, Bhopal",
  "Gandhi PR College D-1, Danish Nagar, Hoshangabad Road, Bhopal",
  "Saifia Arts College, Ahmedabad Palace, Bhopal",
  "Kopal College for Excellence, Neelbad, Bhopal",
  "Sehore College English Pada Sehore",
  "Bhoj College, 81 Akash Nagar, Kotra Sultanabad, Bhopal",
  "Govt. Kusum P. G. College, Seoni Malwa",
  "Govt. College, Pachore, Rajgarh",
  "Govt. College, Udaipura, Raisen",
  "Jawahar Lal Nehru Smriti, College, Vidisha",
  "Govt. College, Rajgarh, Rajgarh",
  "All Saint's College, Idhgah Hills, Bhopal",
  "Career College, Opp. Dashera Maidan Govindpura, BHEL, Bhopal",
  "SHRI RAMA KRISHNA COLLEGE OF ENGINEERING SCIENCE AND MANAGEMENT (SRKCESM)",
  "Rashtra Bharti Education College, Ujjain.",
  "LYRICS GROUP OF ART COLLEGE",
  "SRGP Gujarati Professional Institute, Indore",
  "SHRI KALIKA KANYA COLLEGE, NIPANIYA",
  "Royal College of Edu. Bhesodamandi, Mandsaur",
  "IDEAS PHARMACY COLLEGE, GWALIOR",
  "Saraswati Edu.College,Ujjain",
  "OM SAI PROFESSIONALCOLLEGE SIMARIYA DISST PANNA  ",
  "SAI COMPUTER EDUCATION INSTITUTE BALAGHAT",
  "S.L.V.College, Saraswati College, Shujalpur Mandi",
  "Govt. Mahatma Gandhi Mahavidyalaya Jawad, Dist. Nimach",
  "Govt. Arts & Comm. College, Kannod",
  "POLYTECHNIC ENGINEERING SRI SATYA SAI UNIVERSITY OF TECHNOLOGY AND MEDICAL SCIENCES",
  "SHRI KRISHNAJIRAO PAWAR GOVERNMENT POST GRADUATE COLLEGE DEWAS, MADHYA PRADESH",
  "SAPPHIRE INSTITUTE OF NURSING SCIENCES",
  "PT KHUSHI LAL GOVT AYURVED COLLEGE AND INSTITUTE BHOPAL",
  "GOVERNMENT AUTONOMOUS ASHTANG AYURVED COLLEGE INDORE",
  "Balkavi Bairagee College, Kanawati, Neemuch",
  "Bhabha Pharmacy Research Institute, NH12, Hoshangabad Road, Village Jatkhedi Misrod Road, Bhopal",
  "Bhabha Engineering Research Institute, Hoshangabad Road",
  "Govt. College of Education, Ujjain",
  "Shanti Niketan College, Akodiya Mandi",
  "Babulal Tarabai Institute of Research & Technology, NH 26, Narsinghpur Road, Village Sironja,District Sagar",
  "Shri Vaishnav Institute of Management & Science,  Indore",
  "SHRI SR COLLEGE OF PHARMACY",
  "SUDHA RAJE COMPUTER INSTITUTE CHITRAKOOT",
  "SANT SINGAJI MAHARAJ INSTITUTE OF INFORMATION TECHNOLOGY CHHANERA DIST KHANDWA",
  "VISION COLLEGE OF PHARMACY KEOLARI SEONI ",
  "SHRI R C E BHARHUT NAGAR , SATNA",
  "Om Shanti Vigyan College, Bagli",
  "S N S COLLEGE SATNA",
  "SHIVAM COLLEGE SUKTARA BAMHANDEHI SEONI MP",
  "GOVT.COLLEGE, SATNA",
  "SANSKAR LAW COLLEGE,ANUPPUR",
  "GURUKRUPA ANIMAL HUSBANDRY DIPLOMA COLLEGE",
  "DEPARTMENT OF PHARMACY RAM KRISHNA DHARMARTH FOUNDATION UNIVERSITY",
  "GOVERNMENT COLLEGE CHAND DIST CHHINDWARA",
  "Govt. Madhav Music College, ujjain",
  "COLLEGE OF LAW & LEGAL  AID,SHAHDOL",
  "GOVERNMENT COLLEGE, KHANIYADHANA",
  "SRAJAN COLLEGE OF FINE ART AND FASHION DESIGN",
  "Oriental College of Technology,  Thakral Nagar, Raisen Road, Bhopal 462021",
  "Govt. Institute of Fine Arts, gwalior",
  "College of Agriculture , Rewa",
  "College of Agriculture, Jabalpur",
  "College of Agriculture, Tikamgarh",
  "College of Agriculture, Ganjbasoda",
  "P.I.P.S. COLLEGE",
  "GOVT.S.V COLLEGE,TEONTHAR,REWA",
  "JANTA COLLEGE,GOHPARU,SHAHDOL",
  "SARSWATI SCIENCE COLLEGE NIRALA NAGAR REWA",
  "MASS PARAMEDICAL INSTITUTE, SATNA",
  "Faculty of Paramedical Sciences (RKDF University), Bhopal",
  "GOVT COLLEGE PICHORE, DISTRICT GWALIOR ",
  "VISION INSTITUTE OF COMPUTER AND TECHNOLOGY, SIHORA",
  "SATPURANURSINGCOLLEGE ",
  "RAM KRISHNA COLLEGE OF AYURVEDA AND MEDICAL SCIENCES",
  "S N COLLEGE OF EDUCATION",
  "DEPARTMENT OF PHARMACY, PRESTIGE INSTITUTE OF MANAGEMENT AND RESEARCH BHOPAL",
  "Govt. P.G.College, Tikamgarh",
  "Sardar Vallabh Bhai Patel Govt.College Ladkui District Sehore",
  "REVA INSTITUTE OF COMPUTER AND EDUCATION NIWAS",
  "M K Ponda College of Business and Management, Bhopal",
  "Govt. Swami Vivekanand College, Raisen",
  "Madan Maharaj College, Bhopal",
  "TECH POINT COMPUTER",
  "IES College of Education",
  "Extol College, Bawariya Kalan, Bhopal",
  "RAB MAHAVIDHYALAYA ",
  "SPS INSTITUTE OF PROFESSIONAL STUDIES, PACEHERA, MEHGAON, BHIND",
  "Rajeev Gandhi College, Raisen",
  "Presidency College, Raisen",
  "SWAYAM SIDH INSTITUS OF PERAMEDICAL TECHNOLOGY",
  "SWAMI VIVEKANAND SHIKSHA MAHAVIDYALAYA AMBAH MORENA",
  "KESHAV INSTITUTE OF PHARMACEUTICAL SCIENCE ",
  "Kamla Nehru College A-50, Kotra Sultanabad, Bhopal",
  "Pt. Deendayal Girls College, Bairagarh, Bhopal",
  "Kasturba Girls College, Near Moti Masjid, Car Parking, Bhopal",
  "SANT HIRDRAM GIRLS COLLEGE",
  "Radharaman Institute of Technology & Science, Bhadbhada Road, Ratibad, Bhopal-462002",
  "ST MARYS PG College, Vidisha",
  "BUNDELKHAND COLLEGE",
  "Atas  College of Management and Technology, Pandhurana",
  "INSTITUTE OF PROFESSIONAL  STUDIES ",
  "SUNRISE COLLEGE ",
  "VANASTHALI COLLEGE OF PHARMACY REWA MP",
  "SANT RAMDAS INSTITUTE OF SCIENCE AND MANAGEMENT TIKAMGARH",
  "SARDAR AJEET SINGH MEMORIAL(SMRITI) MAHAVIDHALAYA BHOPAL ",
  "Vivekanand College of Pharamcy, Ratibad",
  "ST ALOYSISUS INSTITUTE OF TECHNOLOGY",
  "Raghukul College of Education",
  "District Homeyopathy College, Katju Nagar, Ratlam",
  "NISHA MEMORIAL COLLEGE FOR EDUCATION ",
  "REWA GUJAR INSTITUTE OF MANAGEMENT STUDIES",
  "PT. MOTILAL NEHRU LAW COLLEGE",
  "SCHOOL OF DESIGN SRI SATYA SAI UNIVERSITY OF TECHNOLOGY AND MEDICAL SCIENCE",
  " SCHOOL OF LAW SRI SATYA SAI UNIVERSITY OF TECHNOLOGY AND MEDICAL SCIENCES",
  "BUDDHISAGAR COLLEGE AGAR",
  "Shri Bherulal Pharmacy Institute, Village: Gokanya, PO kasturbagram Indore - Khandwa Road, Indore - 452020",
  "SWAMI PRANVANAND COLLEGE, CHHATARPUR M.P.",
  "Amar Shahid Chandrashekhar Azad Govt. Postgraduate College, NIWARI",
  "Kailash Chandra Bansal College of Technology, Kokta Raisen Road, Anand Nagar, Bhopal",
  "GREASES COLLEGE OF NURSING, BALAGHAT",
  "RKDF Institute of Hotel management, Bhopal",
  "Govt. Degree College, Damua",
  "Govt. Degree College, Lanji, Balaghat",
  "Govt. J.S.T.P.G. College, Balaghat",
  "Govt. Law College, Chhindwara",
  "CARE COLLEGE OF EDUCATION",
  "Sagar Institute of Research & Technology, Bhopal",
  "Hitkarini College of Architecture & Town Pilanning,  Hitkarini Hills, Dumna Road,                    Jabalpur-482005",
  "\"Bhagyoday Tirth Pharmacy College, Khurai Road, Karila, Sagar 470001\"",
  "GIGABYTE INSTITUTE OF COMPUTER AND TECHNOLOGY CHHAPIHEDA",
  "A.K. INSTITUTE OF MANAGEMENT COLLEGE",
  "Trinity Institute of Education",
  "HEERALAL SINGH TEACHERS TRAINING COLLEGE REWA",
  "Seva sadan Shiksha Mahavidyalaya, Burhanpur",
  "Mahatma Gandhi Science College, Athner, Betul",
  "IASSCOM Fortune Institute of Technology, Village Rasulia, Gosai, Ratibad, Bhopal",
  "perfect computer",
  "Om college of education",
  "HOPE INSTITUTE OF TEACHERS TRAINING",
  "VAISHNAVI SHIKSHA MAHAVIDYALAY",
  "Radharaman Engineering College, Fatehpur Dobera Ratibad Bhopal 462002",
  "Vikrant Institute of Technology and Management, Borkhedi, Behind Veterinary College, AB Road, Indore- 453446",
  "GURUSAHAB EDUCATION COLLEGE",
  "RAJA  ANANGPAL SINGH TOMAR MAHAVIDHYALAY RACHED PORSA",
  "GOVERMENT COLLEGE UMARBAN DHAR",
  "GOVERMENT COLLEGE KANWAN DHAR",
  "JAI NARAYAN COLLEGE OF NURSING                 ",
  "THE BHARTI COLLEGE",
  "MAHARAJA  ANANGPAL DIGREE COLLEGE  KASAMDA PORSA MORENA",
  "BHOPAL COMPUTER EDUCATION ",
  "BHOPAL TECHNICAL INSTITUTE ",
  "NARSINGHGARH COMPUTER ACADEMY",
  "KURAWAR COMPUTER ACADEMY",
  "HQ ONE SIGNAL TRAINING CENTRE",
  "ROSHAN HOSPITAL COLLEGE OF NURSING, BHOPAL",
  "Lakshmi Narain College of Technology",
  "S K S College",
  "BHAVYAA INSTITUTE OF INFORMATION TECHNOLOGY",
  "SHREE INSTITUTE OF PROFESSIONAL STUDIES",
  "Mittal Institute of Pharmacy, Opp. Bhopal Memorial Hospital, Navi Bagh, Bhopal",
  "RISHI GALAV SHIKSHA MAHAVIDHYALAYA DABRA GWALIOR",
  "Sun Institute of Pharmaceutical Education & Research (SIPER), Lahar",
  "Ravi Shankar College Of Pharmacy,  Bhanpur Bypass Road, Near Peoples Dental College, Bhopal -462010",
  "SHRI COMPUTER POINT REWA",
  "C.R.M INSTITUTE OF TEACHER EDUCATION BARAUA GWALIOR",
  "Shree Sai Institute of Technology,  Jaora Road, Ratlam 45700",
  "Parijat College of Pharmacy",
  "Govt. Geetanjali Girls P G College, Bhopal",
  "MAA REWATI COLLEGE OF EDUCATION",
  "AMIT INSTITUTE OF PROFESSIONAL STUDIES ",
  "TIRUPATI COLLEGE OF MANAGEMENT AND SCIENCE",
  "Govt. Degree College Lavkushnagar",
  "SAHARA INSTITUTE OF COMPUTER EDUCATION SEHORE",
  "Govt. Hamidia Arts & Commerce College, Bhopal",
  "AYUSHRAJ COLLEGE OF EDUCATION KARAHAL SHEOPUR",
  "SACRED HEART COLLEGE OF NURSING",
  "AALAP ACADEMY",
  "PRATIBHA EDUCATION",
  "ATAL BIHARI VAJPAYEE GOVERNMENT MEDICAL COLLEGE VIDISHA",
  "ShriRam Institute of Professional Studies",
  "CHIRAYU INSTITUTE OF MEDICAL SCIENCE MAIN ROAD BICHHUA CHHINDWARA",
  "SANSKAR INSTITUTE OF COMPUTER AND TECHNOLOGY",
  "M.P.C.T. COLLEGE OF MANAGEMENT",
  "GAROTH INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "I.P.S. COLLEGE OF TECHONOLOGY AND MANAGEMENT",
  "Shri Mahamrityunjay Computer & IT",
  "RAJESHWARI MAHAVIDYALAYA MADHAUGANJ AJAIGARH",
  "Vaishnavi Institute of Pharmacy",
  "ANSH COLLEGE OF PHARMACY GWALIOR",
  "JABALI K.S. COMPUTER INSTITUTE JABALPUR",
  "SHRI NITYANAND COLLEGE OF PHARMACY",
  "Technocrats Institute of Technology & Science, Anand Nagar, PB No. 24, Post Piplani, BHEL, Bhopal - 462021",
  "Sha-Shib College of Technology, Parvalia, Bhopal - 462030",
  "govt college meghnagar",
  "SHRI RAGHUNATH PRASAD CHATURVEDI SHIKSHA MAHAVIDYALAYA UNCHATOLA REWA MP",
  "GOVERNMENT COLLEGE BIRSINGHPUR ",
  "SWAMI VIVEKANAND COLLEGE, KALYANPUR,  DISTT SHAHDOL MP",
  "Thakur Lal Bahadur Singh College, Panwar Sidhi MP",
  "Shri Balaji Mahavidyalaya ",
  "LAKSHYA INSTITUTE OF EDUCATION KARAHAL SHEOPUR",
  "Technocrats Institute of Technology,  Anand Nagar Near Hathaikheda Dam,  P.B. No. 24, Post Piplani,  B.H.E.L,  Bhopal -462021",
  "\"Government Engineering College, Gokulpur, Ranjhi Jabalpur, Jabalpur - 482001\"",
  "Hitkarini College of Engineering and Technology, Hitkarini Hills Dumna Road, Rembhar P.O. Khamaria,  Jabalpur-482005",
  "Sagar Institute of Science  & Technology, Gandhi Nagar, Pipalner Near Airport, Jaipur Road, NH 12, Bhopal - 462036",
  "Thakur Shivkumar Singh Memorial Engineering College, Navall Nagar (Ziri), Tehsil & District Burhanpur-450223",
  "\"All Saints College of Technology, Jaipur Jabalpur, NH-12, Gandhi Nagar, Bhopal-462031 \"",
  "Acropolis Institute of Technology & Research, Village Raukhedi, Khasra No. 144/3, Indore Bypass Road, Indore-453771",
  "Sri Dadaji Institute of Technology & Science, Rehmapur, Khandwa Dist. East Nimar-450001",
  "B.M. College of Pharmaceutical Education and Research, Village Gokanya, Indore Khandwa Road, Indore 452001",
  "Sandipani Low College, Ujjain",
  "Prashanti Inst. Of Management,Ujjain",
  "Dr. Shri R.M.S. Institute of Science & Technology College of Pharmacy, Bhanpura Dist - Mandsaur-458775",
  "ADITYA COLLEGE OF TECHNOLOGY SCIENCE AND EDUCATION BARAUA GWALIOR",
  "OM AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "SWASTIK COLLEGE OF NURSING",
  "Vidhyapeeth Institute of Science & Technology, Village Kala, Patwari Halka No. 19, Vikash Khand, Funda, Tehsil Huzur, Bhopal - 462021",
  "Gwalior Institute of Information Technology, Near Police Station, Maharajpura, Gwalior",
  "GURUKUL ACADEMY",
  "Gracious College of Pharmacy",
  "GOVERNMENT SHRIMANT MADHAVRAO SCINDIA POST GRADUATE COLLEGE, SHIVPURI",
  "SHRI RANGAM COLLEGE OF EDUCTION TIKAMGARH M P",
  "victoria college of education sehore",
  "GOVT. VRINDA SAHAY P.G. COLLEGE, DABRA,GWALIOR",
  "GLOBAL PRASHANTI NURSING COLLEGE UJJAIN",
  "Maharaja Agrasen Mahavidhyalay Gram Purushottampur Panna",
  "AMPLE DREAMS INSTITUTE OF EDUCATION",
  "MAA SHANTADEVI COLLEGE OF PHARMACY",
  "R.K.D.F.Institute Of Pharmacy Science, Bhopal,  N.H. 12, Hoshangabad Road, Near Mark Hotel, Bhopal",
  "MEERA DEVI PHARMACY COLLEGE ",
  "SCHOOL OF PHARMACY(DEGREE)",
  "AZAD COLLEGE OF EDUCATION",
  "AUROVINDO COLLEGE OF NURSING ",
  "Jai Institute of Pharmaceutical Sciences and Research",
  "svn college panna",
  "thakur surya pratap singh mahavidyalaya lauwa laxmanpur rewa",
  "INDORE INSTITUTE OF MEDICAL SCIENCES COLLEGE OF NURSING INDORE ",
  "IPS Academy Institute of Hotel management",
  "MAHATMA GANDHI COLLEGE OF COMMERCE  AND SCIENCE NAGOD",
  "Chhindwara Institute of Medical Sciences Chhindwara",
  "Kailash Narayan Patel College of Pharmacy, Misrod, Bhopal",
  "Government Medical College Ratlam",
  "\"Shri Ram College of Pharmacy, Infront of Narrow-Guage, Railway Station, Banmore,               Morena, -476444 \"",
  "Bundelkhand Medical College ",
  "Vinayaka College of Pharmacy ",
  "Bombay Hospital College of Nursing, Ring Road, Indore",
  "Sagar Institute of Research, Technology & Science-Pharmacy, Near ISRO, Ayodhya Nagar, By Pass Road, Bhopal - 462041",
  "ARNAV INSTITUTE OF PHARMACEUTICAL SCIENCES BHOPAL",
  "INSTITUTE OF DENTAL EDUCATION & ADVANCED STUDIES",
  "PT DEVPRABHAKAR SHASTRI COLLEGE OF PHARMACY",
  "AIMS COMPUTER ACADEMY",
  "Guru Ramdas Khalsa Institute of Science & Technology (Pharmacy), Kukrikheda, Barela, Jabalpur--483001",
  "Adina Institute of Science & Technology, Opposite Bamhori Seed Farm, Bhopal Road, Sagar",
  "GRVI COMPUTER COLLEGE DEOTALAB",
  "Guru Ramdas Khalsa Institute of Science & Technology, Barela,                 Jabalpur-482002\"",
  "GOVERNMENT COLLEGE LIDHOURA",
  "Shri Ram Institute of Information Technology, A.B. Road, NH 3 Banmore, Gwalior",
  "Sagar Institute of Science Technology and Engineering (SISTec-E), Sikandrabad, Near Ratibad, Bhadbhada Road, Bhopal",
  "Nagaji Institute of Technology & Management, Thankur Baba Campus, Jhansi Road, Sitholi, Gwalior 474001",
  "Shri Ram Institute of Technology,  ITI, Madhotal, Jabalpur-482002",
  "\"School of Computer and Electronics, IPS Academy, Rajendra Nagar, A.B. Road, Indore-452012",
  "Truba College of Science & Technology, Karond - Gandhi Nagar, Bypass Road, Bhopal",
  "Bansal Institute of Science & Technology, Raisen Road, Kokta, Anand Nagar, Bhopal  - 462021",
  "Modern Institute of Pharmaceutical Sciences, Gram Alwasa, Sanwer Road, Indore",
  "GOVERNMENT COLLEGE, BADWARA",
  "\"Nimar Institute of Pharmacy, Maheshwar Road, Opp. ITI Dhamnod, Distt. Dhar - 454552\"",
  "\"Mahakal Institute of Technology & Management, Behind Air Strip, Dewas, Ujjain - 456446\"",
  "GOVT. COLLEGE VIJAYPUR",
  "Radharaman Institute of Pharmaceutical Sciences, Fatehpur Dobra, Ratibad, Bhopal",
  "Shri Mohanlal college of arts science and Management",
  "\"Jai Narain College of Technology, New Chouksey Nagar, Berasia Road,Bhopal - 462038\"",
  "\"Samrat Ashok Technological Institute,Civil Lines, Netaji Subhash Marg, Vidisha \"",
  "MANSAROVAR AYURVEDIC MEDICAL COLLEGE HOSPITAL RESEARCH CENTER BHOPAL",
  "Shri Rewa Gurjar Bal Niketan College, Sanawad",
  "VISHNAU SHIKSHA COLLEGE, GHURATHI, REWA",
  "\"Indore Institute of Pharmacy, Pithampur Road, Opp. IIM, Rau, Indore \"",
  "SHRI RAM B.ED. COLLEGE, RAURA, REWA",
  "MA ASHTBHUJA COLLEGE OF EDUCATION, PATEHARA, REWA",
  "SHREEJEE INSTITUTE OF INFORMATION TECHNOLOGY",
  "Sri Aurobindo Institute of Technology, Indore - Ujjain, Highway, Near MR-10, Gram Bhavarasla, Indore-453111",
  "Gyan Sagar College of Engineering, Village Seronja, Tehsil & District Sagar",
  "Takshila Institute of Engineering & Technology,    NH7 Road, Madan Mahal, Jabalpur-482002",
  "TIT College, Anand Nagar, PB No. 24, Post Piplani, BHEL, Bhopal - 462021",
  "Bethesda Institute of Technology & Science, Gram Ratwai, (Chitora Road), Morar Cant Gwalior-474006",
  "Prashanti Institute of Technology & Science,  Gram Gangedi, Near Mahveer Tapobhumi Jain Mandir, Indore Road, Ujjain",
  "\"Radharaman College of Pharmacy, Fatehpur Dopra, Ratibad, Bhopal   \"",
  "University Institute of Technology, RGPV",
  "LATE K L PANDEY SCHOOL OF NURSING",
  "SAHEED BHAGAT SINGH COLLEGE, ICHHAWAR",
  "SHANTI DEVI INSTITUTE OF COMPUTER EDUCATION NALKHEDA",
  "GURUKUL INSTITUTE OF SOFTWARE TECHNOLOGY",
  "Maharaja Chhatrasal College of Computer Science Badamalehra",
  "All Saints College (B.Ed.), Gandhinagar Bhopal",
  "ORIENTAL ENGINEERING COLLEGE(POLYTECHNIC)",
  "ADARSH KANYA COLLEGE, SIDHI",
  "IES College of Technology, Kalikheda, Ratibad Main Road, Bhopal - 462044",
  "DR RAJENDRA PRASAD MAHAVIDYALAYA ",
  "ARTS AND COMMRCE COLLEGE PANDHURNA TH PANDHURNA",
  "Badalmohi Mahavidyalaya, Bhemsen Parasia, Chhindwara",
  "OM SAI SAMARTH COLLEGE OF COMMERCE AND COMPUTER SCIENCE ",
  "Sausar Girls College Of Science And Technology",
  "UNIVERSAL GIRLS COLLEGE, PANDHURNA ",
  "VIVEKANAND KANYA MAHAVIDHALAYA, KHURSARA",
  "BCIT COMPUTER CENTRE",
  "VIKRAMADITYA INSTITUTE OF MANAGEMENT AND TECHNOLOGY BHOPAL",
  "M G M MEDICAL COLLEGE, INDORE",
  "PT SHIVNATH SHASTRI GOVT AUTO  AYURVED COLLEGE AND  HOSPITAL BURHANPUR MP",
  "VIDHYA ACADEMY",
  "COMMERCE POINT AND COMPUTER EDUCATION",
  "SUNRAYS FUTURE TECHNOLOGIES",
  "AMARPATAN INSTITUTE OF COMPUTER SCIENCE",
  "PT BRIJKISHORE PATERIA INSTITUTE MALTHONE",
  "PERFECT COMPUTER INSTITUTE",
  "SUCCESS COMPUTER EDUCATION CENTER",
  "GYAN KUNJ INSTITUTE",
  "PITAMBARA SCHOOL OF NURSING",
  "VIVEKANAND PARAMEDICAL COLLEGE ANUPPUR",
  "CORPORATE COLLEGE OF PARAMEDICAL SCIENCES",
  "RAI INSTITUTE OF PARAMEDICAL TECHNOLOGY",
  "PREMWATI COLLEGE OF NURSING, JABALPUR",
  "MOHAN PARAMEDICAL COLLEGE",
  "ABHISHEK NURSING COLLEGE",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE MAJHAULI SIDHI MP",
  "GOVT.ART&COMM. COLLEGE RAMPUR NAIKIN, SIDHI",
  "EDUCATION COLLEGE,,SIDHI",
  "GOVT.LAW COLLEGE.REWA",
  "NEHRU SMARAK COLLEGE CHAKGHAT, REWA",
  "RAJIV GANDHI COLLEGE OF COMP. & TECH. , SATNA",
  "MAHARANI LAXMIBAI COLLEGE OF TECHNOLOGY REWA",
  "Samta Vidhya Peeth ",
  "SARDA COLLEGE SARLA NAGAR MAIHAR, SATNA",
  "GOVERNMENT MODEL SCIENCE COLLEGE.REWA",
  "S. I. N. P. S. JANKI KUND CHITRAKUT, SATNA",
  "SRI SAI MANAGLAM COLLEGE,,SINGRAULI",
  "S.I.T.E ,SINGRAULI",
  "RAJBHANU SINGH SMARK COLLEGE MANIKWAR,REWA",
  "CHAURASHIYA PAIRAMEDICAL INSTITUT REWA",
  "GOVT. S.K. COLLEGE,MAUGANJ.REWA",
  "S.R.P SMARK COLLEGE HANUMANA,REWA",
  "JANTA COLLEGE REWA",
  "GOVT.COLLEGE JAYSHINGNAGAR,SHAHDOL",
  "GOVT.COLLEGE, JAITWARA,SATNA",
  "VINDHYACHAL COLLEGE JIGNA, SATNA",
  "A.G I COLLEGE OF EDUCATION,REWA ROAD ,SATNA",
  "LATE UMA RAMAN PRATAP BHADUR SINGH MAHAVIDYALAYA, KOTHI, SATNA",
  "SAI COLLEGE,VINDHYA NAGAR,SINGRAULI",
  "SHRIYUT COLLEGE GANGAVE,REWA",
  "T.D. STUDY COLLEGE CHAKGHAT DISST. REWA",
  "D.R.S. COLLEGE REWA",
  "SUDARSHAN COLLEGE LALGAWAN,REWA",
  "GOVERNMENT ARTS AND COMMERCE COLLEGE BADERA",
  "VAISHNAVI NURSING COLLEGE",
  "CHRISTUKULA MISSION WOMENS ENGLISH MEDIUM COLLEGE",
  "GOVT.MAHARAJA MARTAND COLLEGE KOTMA, ANUPUR",
  "PANDIT CHANDRASEKHER STUDY COLLEGE SATNA",
  "S B B PATEL SHIKSHA COLLEGE RATAHRI,SMAN,REWA",
  "SHRI GANESH SANSKRIT MAHAVIDHYALAYA GARHAKOTA",
  "V.I.M.R, AMOUDHA,SATNA",
  "M.J M C NURSING & REASEARCH,SHERGANJ,SATNA",
  "NATIONAL B.ED COLLEGE REWA",
  "MAYARAM MAHAVIDYALAYA,MEDHOLI MORWA,,SINGRAULI",
  "GOVT.THAKUR RANMAT SINGH COLLEGE REWA",
  "GURUKUL BUSINESS SCHOOL, INDORE",
  "GEETA JYOTI SHIKSHA COLLEGE REWA",
  "Government College Jeeran",
  "Govt. Girls' P.G. College, Rewa",
  "ORIENTAL INSTITUTE OF PHRAMACY LALBURRA",
  "SCHOOL OF INFORMATION TECHNOLOGY",
  "INDORE MANAGEMENT INSTITUTE",
  "ASIAN INSTITUTE OF PROFESSIONAL STUDIES",
  "SBS COLLEGE, TALEN",
  "RUSTAMJI INSTITUTE OF TECHNOLOGY DIPLOMA",
  "KAMLA NEHRU MAHILA  COLLEGE SATNA",
  "GOVT.COLLEGE CHURHAT,SIDHI",
  "R.S.C.E,CHITRACOOT,SATNA",
  "TATA COLLEGE,JAMOUDI KHURDA,,SIDHI",
  "GOVERNMENT POLYTECHNIC COLLEGE HOSHANGABAD MP",
  "JANTA LAW COLLEGE,GOHPARU,SHAHDOL",
  "YAMUNA PRASAD SHASTRI COLLEGE SEMARIA,REWA",
  "KAMLA SMRITI COLLEGE,AMAHA,SIDHI",
  "MAHATMA GANDHI COLLEGE, BANAULI ,SINGRAULI",
  "SHREE INSTITUTE OF PROGRESSIVE STUDIES",
  "MAHI INSTITUTE OF NURSING, RATLAM MP",
  "GOVT. NEHRU DEGREE COLLEGE BURHAR DISTT. SHAHDOL (M.P.)",
  "COMMERCE COLLEGE SATNA",
  "N C T EDUCATION, SHAREGUNJ SATNA",
  "Noble College Rajakhedi Makroniya",
  "GOVT.COLLEGE DEVSAR, SINGROLI",
  "Government College Pipalrawan ",
  "JAI SHRI SHYAM COLLEGE",
  "VINDHYACHAL COLLEGE REWA",
  "YAMUNA PRASAD SHASTRI COLLEGE SIRMAUR,REWA",
  "GOVT. GAJRARAJA MEDICAL COLLEGE",
  "PT. DEV PRABHAKAR SHASTRI BED COLLEGE GATHEORA CHHATARPUR M.P.",
  "PT. R.G.T.TECHNOLOGY & SCIENCE COLLEGE,ANUPPUR",
  "GOVT.COLLEGE, NEWRAMNAGAR,SATNA",
  "S.I.T COLLEGE,SIDHI",
  "SANJIVANI INSTITUTE OF PARAMEDICAL SCIENCE BALAGHAT",
  "ISHWAR CHAND VIDHYA SAGAR COLLEGE JAWA,REWA",
  "TMC COMPUTER EDUCATION",
  "GOVT.COLLEGE BARKA, SINGROLI",
  "SHRI SAI COMPUTER INSTITUTE SATNA",
  "VISHWATECH EDUCATION",
  "MEDHAVI INSTITUTE OF MANAGEMENT JABALPUR",
  "Extol Inst. of Management, Near Lily Talkies Jehangirabad, Bhopal",
  "ADVANCE INFOTECH",
  "HARSH COMPUTER CENTER PATHARIA ",
  "Information Technology Resource Center",
  "GURUKUL INSTITUTION OF SCIENCE & TECHNOLOGY",
  "Government Navin College, Narwar",
  "sai shraddha institute of computer education ",
  "SADGURU INSTITUTE OF COMPUTER STUDIES CHITRAKOOT",
  "ROYAL INSTITUTE OF PROFESSIONAL STUDIES DABRA",
  "GOVT.Madhav Sadashivrao Golvalkar College, Rewa (M.P.)",
  "PARAKH INSTITUTE OF PROFESSIONAL STUDIES",
  "Chhatrasal Govt. P.G. College Panna ",
  "RAJEEV GANDHI INSTITUTE  OF SCIENCE & TECHNOLOGY JABALPUR",
  "REGIONAL INSTITUTE OF MANAGEMENT & TECHNOLOGY JABALPUR",
  "RAJIV GANDHI INSTITUTE OF COMPUTER TECHNOLOGY-8358",
  "RAMLAKHAN SHIKSHAN SAMITI",
  "PANTIUM POINT TACHQUNICAL COLLEG REWA",
  "GOVT.GIRLS COLLEGESIDHI",
  "RAMKRISHNA INFORMATION TECHNOLOGY EDUCATION BANDA",
  "rajradha academy ",
  "RAJESHWARI INSTITUTE OF COMPUTER SCIENCE MADHAUGANJ AJAIGARH",
  "daipuria college mehgaon bhind",
  "LATE SHRI KUSHABHAU THAKRE SMRITI GOVERNMENT COLLEGE, MAKSI",
  "VITS COLLEGE OF EDUCATION, SATNA",
  "Government College Patharia",
  "RAJIV GANDHI INSTITUTE OF COMPUTER EXCELLENCE (RGICE) SATNA",
  "RAJEEV GANDHI INSTITUTE  OF MEDIA  AND TECHNOLOGY, JABALPUR",
  "VIDYAWATI CHATURVEDI SHIKSHA MAHAVIDYALYA, CHHATARPUR",
  "Shree Inst. of Teachers Training, Abbas Nagar New Jail Road Gandhi Nagar, Bhopal",
  "NAVEEN SWAMI VIVEKANAND BED COLLEGE",
  "JMD COMPUTER EDUCATION SOCIETY    ",
  "RAJEEV GANDHI INSTITUTE OF IT",
  "SRI AUROBINDO INSTITUTE OF MEDICAL SCIENCES COLLEGE OF NURSING INDORE",
  "rajeev gandhi computer college ",
  "RAJEEV GANDHI INSTITUTE OF COMPUTER & INFORMATION TECHNOLOGY , SHAHDOL",
  "A N D COLLEGE JOURA",
  "SRI AUROBINDO MEDICAL COLLEGE &  POSTGRADUATE INSTITUTE, INDORE",
  "PIONEER ACADEMY OF COMPUTER EDUCATION",
  "RAJEEV GANDHI COLLEGE OF COMPUTER APPLICATION & TECHNOLOGY SATNA",
  "RAISEN INSTITUTE OF COMPUTER STUDIES SULTANPUR  MP ",
  "GOVT.R.V.P S. COLLEGE, UMARIA,",
  "SARDAR PATEL COLLEGE OF NURSING",
  "Prof Brijmohan Mishra Institute of Medical & Technical Sciences",
  "BHAGYODAY TIRTH NURSING COLLEGE ",
  "VINDHYA COLLEGE OF NURSING, PANNA ROAD, SHERGANJ",
  "GOVERNMENT COLLEGE, RAMPUR BAGHELAN",
  "RAISEN INSTITUTE OF COMPUTER STUDIES RAISEN",
  "RADIANT INSTITUTE OF PROFESSIONAL STUDIES SHIVPURI",
  "PRT INSTITUTE OF TECHNOLOGY & SCIENCE ANUPPUR",
  "PROFESSIONAL INSTITUTE OF COMPUTER SCIENCE GUNOUR",
  "PEOPLE'S INSTITUTE OF MEDIA STUDIES, BHOPAL",
  "NOVEL INSTITUTE OF TECHNICAL EDUCATION",
  "patel institute of computer science",
  "PACE COMPUTER INSTITUTE, KATNI m",
  "Akshay College of Education",
  "GURUKUL COLLEGE, BERASIA",
  "Govt College Jharda",
  "Govt. Degree  College, Bijawar",
  "VINDHYANCHAL COLLEGE OF NURSING",
  "GYANODAYA INSTITUTE OF PROFESSIONAL STUDIES",
  "SHRIRAM COLLEGE, MORENA",
  "SHREE JAGAT NARAYAN COLLEGE JATARA",
  "D P SINGH SHIKSHA MAHAVIDHYALA, GWALIOR",
  "SHRI PITAMBARAPEETH SANSKRIT COLLEGE, DATIA",
  "Swami Vivekanand Government College, Berasia, District, Bhopal (M.P.)",
  "GOVERNMENT COLLEGE, INDERGARH, DATIA",
  "APEX INSTITUTE OF MANAGEMENT STUDIES",
  "Gurukul College of Education. Tikamgarh",
  "CHAITANYA INSTITUTE OF PARAMEDICAL SCIENCES",
  "BHOPAL INSTITUTE OF TECHNOLOGY and SCIENCE-PHARMACY",
  "A.D.S. GROUP OF COLLEGE VILL PARVALIA SADAK TEH HUZUR BHOPAL",
  "JSR COLLEGE OF PHARMACY BHOPAL",
  "GOVERNMENT POLYTECHNIC COLLEGE MANDLA ",
  "GOVERNMENT NEHRU PG COLLEGE AGAR MALWA",
  "UNIVERSAL INSTITUTE OF EXCELLENCE SHAHDOL",
  "UNIVERSAL INSTITUTE OF COMPUTER TECHNOLOGY KEOLARI",
  "SHRI SITARAM MEMORIAL INSTITUTE OF I.T.",
  "SHRI SHIV COMPUTER EDUCATION ",
  "SARASWATI ACADEMY OF COMPUTER SCIENCE AND TECHNOLOGY GOTEGAON",
  "SAKSHYA COMPUTER KIRNAPUR",
  "r c education narsinghpur",
  "SAI COMPUTER AND I T INSTITUTE SLEEMNABAD",
  "MOTHER TERESA INSTITUTE OF COMPUTER AND TECHNOLOGY",
  "MODREN INSTITUTE OF COMPUTER AND TECHNOLOGY",
  "KHANDWA INSTITUTE OF PROFESSIONAL STUDIES KHANDWA",
  "Z TO Z IT COMPUTER CENTER ",
  "AW INSTITUTE OF COMPUTER EDUCATION ",
  "SRCJ COMPUTER INSTITUTE",
  "SHRI SAI BABA INSTITUTE OF PROFESSIONAL STUDIES SSB",
  "SARASWATI COMPUTER EDUCATION CENTER",
  "SAI INSTITUTE OF COMPUTER SCIENE",
  "ROM COMPUTER ACCOUNTS EDUCATION PVT LTD",
  "rajiv gandhi institute of computer and excellence shahdol",
  "OMKAR INSTITUTE OF PROFESSIONAL STUDIES",
  "RAGHUKUL COLLEGE OF MANAGEMENT",
  "NOBELE INSTITUTE OF COMPUTER SCIENCE DEVENDRANAGAR",
  "J. J. INSTITUTE OF COMPUTER EDUCATION",
  "INSEARCH COMPUTER INSTITUTE",
  "AISHWARYA COMPUTER INFORMATION TECHNOLOGY INSTITUTE",
  "Omega Softech Solutions",
  "JSTC COMPUTERS",
  "BHAVANI COMPUTER EDUCATION CENTER",
  "B.C.S.T. COMPUTER",
  "kaushal memorial institute for computer",
  "Govt. Fine Arts College, Jabalpur ",
  "ROYAL COMPUTER",
  "Institute of Information and Computer Education Technology",
  "ICIT COMPUTER INSTITUTE",
  "Global Institute Sheopur",
  "creative computer academy",
  "YUVA INSTITUTE OF INFORMATION TECHNOLOGY",
  "BALAJI INSTITUTE OF COMPUTER SCIENCE AND TECHNOLOGY",
  "OJASWINI COLLEGE PAR EXCELLENCE",
  "GOVERMENT NAVEEN COLLEGE BANKHEDI HOSHANGABAD M P",
  "Vaishnav Mata Vidhi Mahavidhyalay Panna (M.P.)",
  "Chameli Devi Institute of Professional Studies, Indore",
  "Govt. Law College, Dewas",
  "TAKSHASHILA COLLEGE ",
  "swami samarth college",
  "K.B.M. COLLEGE OF EDUCATION BARAUA GWALIOR",
  "Shubhdeep College of Nursing, Indore",
  "rvs bed college plot no 53 hamirpura porsa morena ",
  "ARC NET COMPUTER EDUCATION CENTRE BHOPAL",
  "BHOPAL CAMPUS",
  "Kasturba Nursing College, BHEL, Bhopal",
  "Satya Sai College of Education, Budhuda, Balaghat",
  "SATPUDA COLLEGE",
  "Tavite B.Ed. Training College, Katni",
  "Govt. Dhanvantri Aurved College, Ujjain",
  "IMI PROFESSIONAL STUDIES",
  "ST PAUL INSTITUTE OF PROFESSIONAL AND MANAGEMENT STUDIES",
  "SHRI MAHAKAL INSTITUTE OF MANAGEMENT AND SCIENCE",
  "BHAGAT SINGH GOVT. P.G. COLLEGE,JAORA",
  "HINDUJA COLLEGE ASHTA",
  "Pradhan Mantri College of Excellence Shri Neelkantheshwar Government Post Graduate College, Khandwa (M.P.)",
  "VEERANGNA AWANTI BAI NURSING COLLEGE",
  "RAM KARISHAN EDUCATION COLLEGE",
  "WINGS COLLEGE GWALIOR",
  "PATHAN BABA COLLEGE",
  "SCHOOL OF ARCHITECTURE RAJIV GANDHI PROUDYOGIKI VISHWAVIDYALAYA A STATE TECHNOLOGICAL UNIVERSITY OF MADHYA PRADESH INDIA",
  "FEROZ GANDHI GROUP OF COLLEGE",
  "Ayushman College, C-Sector, Shahpura, Bhopal",
  "GOVERNMENT WOMENS POLYTECHNIC COLLEGE JABALPUR",
  "EVERGREEN EDUCATION SOCIETY COLLEGE",
  "JEEVAN JYOTI SHIKSHA MAHAVIDYALAYA",
  "AADARSH B ED COLLEGE, PALARI, SEONI",
  "Government College, Bichhua",
  "Arts and Comm. College, Sausar",
  "Ramkrishna College of Professional Education",
  "Laxmipati College",
  "DR.UMASHANKAR VINOD MUSIC AND ART COLLEGE CHHATARPUR M.P.",
  "Arts and Commerce College Chaurai",
  "VICTORIA COLLEGE OF EDUCATION",
  "M R C COLLEGE OF EDUCATION",
  "Shobha Singh Yadav Govt. College Patan",
  "PATIDAR NURSING INSTITUTE ",
  "BALAGHAT SNATAK COLLEGE",
  "Danielson Degree College, Chhindwara",
  "D.P. Chtaturvedi Science, Commerce College, Seoni",
  "FORTUNE GROUP OF SCIENCE AND TECHNOLOGY COLLEGE",
  "BALAJI B ED COLLEGE, SEONI",
  "GLOBAL LAW COLLEGE",
  "Government Girls College, Seoni",
  "GOVT.  COLLEGE BADAMALEHRA ",
  "B.T.I. of Excellence Sagar",
  "Government College Harrai ",
  "Rajeev Lochancharya College Khurai",
  "Government College, Lodhikheda",
  "COOPERATIVE TRAINING CENTER INDORE",
  "Govt. College Tamia ",
  "Sri Sai B.Ed. College, Khurai Road, Jarara",
  "PRAYAGRAJ COLLEGE OF NURSING",
  "KBH COLLEGE OF EDUCATION",
  "SHRI RAWATPURA SARKAR INSTITUTE OF NURSING",
  "Govt. Arts And Commerce College, Keolari, Seoni",
  "GOVT. COLLEGE GHANSOR",
  "Govt. Degree College, Amarwara",
  "HAJRA MEMORIAL COLLEGE MALHARGARH, KHALWA",
  "Govt. Degree College, Barghat, Seoni",
  "Government College, Chhapara, District - Seoni",
  "Govt. Postgraduate College, Seoni",
  "BAGULAMUKHI COLLEGE OF EDUCATION BHOPAL",
  "Govt. Science College, Pandhurana",
  "Government College, Sausar",
  "P.G. COLLEGE OF NURSINGH CENTER HOSPITAL",
  "Tirth Inst. Deepdi Bhojpur Road, Bhopal",
  "Maharaja Ranjit Singh Group of Institutions",
  "AMAR JYOTI SCHOOL AND REHAB CENTRE NEAR IT PARK MANPUR GWALIOR",
  "SHIVAM SHIKSHA MAHAVIDHYALAYA PORSA MORENA",
  "V I P S College",
  "TEXAS EDUCATION COLLEGE",
  "S.M.Y. COLLEGE OF EDUCATION",
  "R.A.B. SHIKSHA MAHAVIDYALAYA ",
  "MISS SILL COLLEGE OF EDUCATION",
  "ARYANSH COLLEGE",
  "SUBHASH CHANDRA BOSE COLLEGE",
  "C.I. COLLEGE OF EDUCATION",
  "AVADH MADHAV COLLEGE OF EDUCATION",
  "Government Shankar Sao Patel Arts, Commerce and Law College, Waraseoni, Balaghat MP",
  "Brilliant institute of professional studies ",
  "ANNIE INSTITUTE OF TECHNOLOGY AND RESEARCH CENTRE",
  "VANKHANDESWAR SHIKSHA MAHAVIDHYALAYA",
  "UDAY EDUCATION COLLEGE",
  "MALWA COLLEGE OF EDUCATION BEENAGUNJ CHACHOUDA",
  "R L D COLLEGE UDOTPURA",
  "N R INSTITUTE OF EDUCATION ",
  "PATIRAM SHIVHARE INSTITUTE OF TEACHER EDUCATION ",
  "Ujjain Institute of Pharmaceutical Sciences, Chandesara Village, Dewas Road, Ujjain",
  "Rukmani Ben DeepchandGardi Medical College, Charitable Hospital, Ujjain",
  "NARMADA COMPUTER EDUCATION BARGHAT",
  "MANTHAN POLYTECHNIC COLLEGE",
  "Govt. Postgraduate College, GUNA",
  "Maa Narmada Shaskiya Mahavidyalaya, Sondwa, Alirajpur ",
  "BRM MAHAVIDHYALAYA MORENA",
  "VVM Nursing College, E-14, Opp. Income Tax Colony Kotra, Bhopal",
  "SMRITI INSTITUTE OF COMPUTER EDUCATION MEHANDWANI",
  "ANSH COLLEGE OF EDUCATION",
  "KRISHNA INFOTECH BHOPAL",
  "ANUSHREE INSTITUTE OF COMPUTER AND EDUCATION",
  "Indira Priyadarshini Mahavidyalaya., Chhindwara",
  "KAPS DEGREE COLLEGE OF SCIENCE MANAGEMENT AND IT PANDHURNA ",
  "LOKMANYA COLLEGE OF EDUCATION (B.ED.)",
  "MAHAJAN ARTS AND COMMERS COLLEGE, ARANDIY",
  "VAISHNAV MATA MAHAVIDYALAYA",
  "GANDHI MEDICAL COLLEGE BHOPAL",
  "GOVERNMENT POLYTECHNIC COLLEGE UMARIA",
  "RD COLLEGE GURAIYA CHHATARPUR MP",
  "Mahakoushal College of Science, Chhapara, Seoni",
  "Govt. Music College, indore",
  "Bhatkhande Sangeet Mahavidhyalaya, jabalpur",
  "Jain Arts Academy, indore",
  "Graffiti Institute of Fashion Technology, indore",
  "Govt. Madhav Music College, gwalior",
  "Sarswati Shishu Vidhya Sangeet Mahavidhyalaya, ratlam",
  "Shri Narayana Sangeet Mahavidhyalaya, Chhindwara",
  "Shri Krishna Sangeet Mahavidhyalaya, indore",
  "Tirupati kala evam Sangeet Mahavidhyalaya, shivpuri",
  "Geetanjali Sangeet Mahavidhyalaya, katni",
  "Shubhankan Fine Art College",
  "Basant Sangeet Mahavidhyalaya, indore",
  "I.P.S. Academy, indore",
  "Pandit Upendranath Rishikul Mahavidhyalaya, chhatarpur",
  "SAPPHIRE INSTITUTE OF NURSING AND SCIENCE ",
  "Haniman Homeopathic College, New Jail By-pass Road, Karond, Bhopal",
  "Tata Institute of Technology",
  "ORENTAL B ED COLLEGE",
  "GOVT. KASTURBA KANYA MAHAVIDIYALAYA GUNA",
  "Hindupat Institute of Teacher Training, Raghogarh",
  "GOVT.  GRADUATE COLLEGE, ARON",
  "SRIPS COLLEGE OF EDUCATION",
  "SONALI EDUCATION COLLEGE",
  "GOVT COLLEGE KUMBHRAJ",
  "mspm college of education",
  "SUNRISE COLLEGE",
  "GOVT. LSGK COLLEGE POHARI",
  "MAHAMANDLESHWAR SWAMI PARMANAND JI MAHARAJ MAHAVIDYALYA, KARERA",
  "AMBIKA INSTITUTE OF MANAGEMENT",
  "Sendhwa Homeopathic Chikitsa College, Sendhwa",
  "I.I.T.S. COLLEGE, GUNA",
  "GOVT COLLEGE KARANJIYA",
  "ACADEMY OF NURSING AND HEALTH SCIENCES BHOPAL",
  "ABHISEK INSTITUTE OF PROFESSIONAL STUDIES GWALIOR",
  "Bhopal Memorial Hospital & Research Centre, Karod Raisen Road, Bhopal",
  "SHAHEED TANTYA MAMA GOVERNMENT COLLEGE, PANDHANA",
  "Softvision College,  Indore",
  "Swati Jain Institute of Management  Studies, Indore",
  "Vikrant Institute of Technology & Management Gram Borkheri,  Mhow, Indore",
  "Vivekanand College,  Burhanpur",
  "Choithram College of Prof. Studies,  Dhar Road, Indore",
  "Shri Gujarati Samaj B.Ed. College, Indore",
  "Shivkumarsingh Instt. of Science & Technology, Gram Dehadi, Near IIM, Indore",
  "Patel College of Science & Technology, Ralamandal, Indore",
  "Yash College of Educaton, Badnawar",
  "Sanskar College of Prof. Studies, Dhar Road, Indore",
  "ILVA Commerce & Science College, Indore",
  "Indore Christian College, Nasia Road, Indore",
  "Indore Institute of Law, Indore",
  "Maharshi Institute of Management Studies, Rau, Indore",
  "KASTURBAGRAM RURAL INSTITUTE, KASTURBAGRAM ,INDORE",
  "Pandit Jawaharlal Nehru Goverment College, Nepanager",
  "P.M.B. Gujarati Science College, Nasia Road, Indore",
  "Matushri Ahilya Devi Teachers Education Institute,  Manglia Chourha, Indore",
  "P.M.B. Gujarati Commerce College, Indore",
  "Sendhwa Sharirik Shiksha Sansthan, Sendhwa",
  "Rishiraj Institute of Technology Village Revati, Sanwer Road,Indore",
  "Sanghvi Institute of Management & Science Rau,  Indore",
  "Kothari College of Management  Science & Technology,  Pipliyahana Square, Indore",
  "Shri Jain Diwakar College, Palasia, Indore",
  "Shri Saibaba College, Khaknar, Dist. Burhanpur",
  "St. Paul Institute of Professional Studies, Lalaram Nagar, Indore",
  "Victoria College of Education,  Khandwa Road, Indore",
  "Vidya Sagar College, Bicholi Mardana, Indore",
  "Vishisht School of Management. Pologround, Indore",
  "K.K. Vigyan College, Vijay Nagar, Indore",
  "GOVERNMENT COLLEGE, UCHEHARA",
  "Patel College of Management, Tillore Road,  Ralamandal, Indore",
  "I.K. D.C. College, Indore",
  "Parijat College, Ring Road, Indore",
  "Devi Ahilya Arts & Commece College, Indore",
  "Acropolis Tech. Campus, Indore",
  "GOVERNMENT COLLEGE, JAITAHARI",
  "GOVERNMENT GIRLS COLLEGE, WAIDHAN",
  "Astral Institute of Technology and Research, Bypass Road, Indore",
  "Devi Ahilya Mateshwari Suganidevi Girls College, Indore",
  "Indore Institute of Management & Research Rau, Pithampur, Indore",
  "Maa Narmada College, Dhamnod",
  "Prestige Institute of Management & Research, Ring Road,  Indore",
  "Rukmadevi Pannalal Ladha Mahashwari Commerce College, Indore",
  "M.B. Khalsa College,  Rajmohalla Square, Indore",
  "Apex Institute of Management & Research, Hansakhedi, Nemavar Road. Indore",
  "Colonel Fateh Jung College, Mhow",
  "Comp-Feeders Takniki Prashikshan Sansthan College, Gumasta Nagar, Indore",
  "Indore School of Social Work, Indore",
  "Malwa  Institute of Science and Management, Indore",
  "Malwa  institute of Technology, Nipaniya Byass, Indore",
  "Mata Jeeja Bai Govt. P.G. Girls College Moti  Tabela, Indore",
  "Shri G.S.I.T.S. , Park Road, Indore",
  "Shri Jain Shwetamber Prof. Academy, Airport Road, Indore",
  "Shri Yashwant Singh  B.Ed. College, Vijay Nagar, Indore",
  "Swami Vivekanand Shiksha Mahavidyalay, Sendhwa",
  "Tagore Shiksha College,  Arihant Nagar, Indore",
  "Modern Institute of Prof. Studies, Gram Alwasa, Sanwer Road, Indore",
  "SAKSHI INSTITUTE OF TECHNOLOGY AND MANAGEMENT, MYANA",
  "SATNA DEGREE COLLEGE, SATNA",
  "SICA COLLEGE",
  "Hitkarini Dental College, Jabalpur",
  "Shipra Fine Art College, Ujjain",
  "ADITYA COLLEGE OF TECHNOLOGY AND SCIENCE  ,SATNA",
  "Pali Academy Institution",
  "IASSCOM INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "RAJEEV GANDHI MANAGEMENT INSTITUTE BHOPAL",
  "LORD KRISHNA COLLEGE OF NURSING DATIA",
  "Al Farukh Unani Medical College, Indore",
  "VASUNDHARA RAJE HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "SHREE SRUSHTI COMPUTERS",
  "Kanya Kubj Nursing College, Indore",
  "SAIMS COLLEGE OF NURSING, INDORE",
  "DATACARE INSTITUTE OF INFORMATION TECHNOLOGY SATNA",
  "Govt. P.G. College,  Khargone",
  "M.S.M.",
  "ADITYA COLLEGE OF PHARMACY",
  "IES Institute of Technology and Management, Bhopal",
  "SHRI LAXMIKANTA COLLEGE OF TECHNOLOGY LANJI BALAGHAT",
  "ACHARYA SHRIRAM D.Ed B.Ed COLLEGE,BAMANGAON",
  "Govt. College, Bhabhra",
  "BHAGWAN BIRSA MUNDA GOVERNMENT COLLEGE, PATI, DISTRICT - BARWANI",
  "GOVERNMENT LAW COLLEGE BARWANI",
  "JANKI PRASAD SHIKSHA MAHAVIDYALAYA, SHAHPUR, NAGOD ,SATNA, MADHYA PRADESH",
  "Vijayshree Education Institute, Jabalpur",
  "CRYSTALCOLLEGE GURAIYA CHHATARPUR",
  "CRYSTAL TEACHERS TRAINING INSTITUTE CHHATARPUR",
  "APS MAHAVIDHYALAYA MAIN ROAD BUDAUR CHHATARPUR",
  "Govt. Degree College, Barhi, Katni",
  "Shri Varnee Digambar Jain Gurukul College",
  "Rajiv Gandhi Arts, Commerce College, Reethi, Katni",
  "Govt. P.G. College , Gadarwara, Narsinghpur",
  "Govt. Degree College, Bamhin Banjar, Mandla",
  "Hitkarini Law College, Jabalpur",
  "GOVT COLLEGE SIRALI HARDA",
  "Government College, Kundam, Jabalpur",
  "Jabalpur College of Computer & Communication, J.R. Complex Narbada Road Katanga Crossing Gorakhpur, Jabalpur",
  "Shri Ram Institute of Management, Jabalpur",
  "Mekalsuta College, Dindori",
  "C.P. Womens (Mahila) Mahavidyalaya, Jabalpur",
  "G.S. College of Commerce & Economics (Autonomous), Jabalpur",
  "St. Aloysous College, Sadar, Jabalpur",
  "Govt. Girls College, Ranjhi, Jabalpur",
  "H.B. College, Vijay Nagar, Jabalpur",
  "Silcobrite Katni Degree College, Katni",
  "DUKE COLLEGE OF MANAGEMENT",
  "APS MAHAVIDHYALAYA CHHATARPUR",
  "Raja Bhoj Govt. College, Katangi, Balaghat",
  "ACHIEVER'S COLLEGE OF MANAGEMENT & SCIENCE, BARI",
  "Govt. Girls College, Barwani",
  "GOVT MODEL COLLEGE BAWRANI",
  "RAJMATA SCINDIA GOVT. PG GIRLS COLLEGE, CHHINDWARA",
  "CAREER COMPUTER EDUCATION GANDHWANI    ",
  "KUNDAM TECHNOLOGY INSTITUTE",
  "I.I.T.S. COLLEGE",
  "PT B D MEMORIAL COLLEGE MAKRONIA DISTT SAGAR MP",
  "Vikrmaditya Arts Commerce College, Jabalpur",
  "Katni Arts &  Commerce College, Katni",
  "Shri Guru Teg Bhadur Khalsa College, Goraakhpur, Jabalpur",
  "Sant Moni Sarvodaya Girls College, Tendukheda, Narsinghpur",
  "Govt . Mahakoshal Autonmous Arts. & Commerece College, Civil Line Jabalpur",
  "Jagatguru Shankaracharya  Arts & Commerce College, Shrinagar, Shridham",
  "Hitkarini Arts, science & Commerce Collgeg, Deoltal, Garha, Jabapur",
  "Hitkarini Mahila Arts & Commerce College, Jabalpur",
  "Govt. Degree College, Bhua Bichhiya, Mandla",
  "Kamore Science College, Kymore, Katni",
  "Takshashila Institute of Management, Jabalpur",
  "N.E.S. Science  College, Jabalpur",
  "St. Paul College, Jabalpur",
  "Shri Guru Nanak Girls College, Jabalpur",
  "Kesharwani College, Ranital, Jabalpur",
  "Shir Jankiraman College, Jabalpur",
  "Gyanganga College of Technology, Jabalpur",
  "College of Material Management, Jabalpur",
  "Bardoli Shiksha College, Katni",
  "Govt. J.M.C. Girls College, Mandla",
  "Govt. College of Education, Near Collectorate, Jabalpur",
  "Govt. Shyam Sundar Agrawal P.G. College, Sihora, Jabalpur (M.P.)",
  "Shri Neelkanth Law College, Jabalpur",
  "Govt. College of Educational, Psychology & Guidance, Near Model School, Jabalpur",
  "Center for Higher Education College, Jabalpur",
  "Dr. Radha Krishnan Education College, Jabalpur",
  "A.P.N. College, Sadar, Jabalpur",
  "S.S.N. Mushran Institute of Management & Technology, Narsinghpur",
  "Mata Gujari Mahila Mahavidyalaya, Marhatal, Jabalpur",
  "Mahatma Gandhi College, Kareli, Narsinghpur",
  "Govt. Tilak College, Katni",
  "Govt. T.N.S. College, Gotegaon, Narsinghpur",
  "Shri Ram Institute of Technology, Jabalpur",
  "SARDAR PATEL INSTITUTE OF PARAMEDICAL SCIENCES",
  "GOVERNMENT COLLEGE SAMNAPUR",
  "SAI SANSKAR COMPUTER ACADEMY -8531",
  "CORPORATE COLLEGE OF AYURVEDIC SCIENCES",
  "CMS INSTITUTE OF COMPUTER EDUCATION",
  "Rana Hanuman Singh Arts,Commerce & Science College, Kirnapur, Balaghat",
  "Rani Durgavati Govt. College, Paraswada, Balaghat",
  "SSLN GOVT. PENCH VALLEY PG COLLEGE PARASIA",
  "Navambey Arts & Commerce College, Adhartal, Jabalpur",
  "Ashaskiya Hawabagh College, Jabalpur",
  "SMT LEELAVATI VISHWAKARMA SANGEET MAHAVIDYALAYA CHHINDWARA",
  "Govt. College Nariaoli ",
  "NIRMALA DEVI DEGREE COLLEGE JAAM KANHARGAON DISTRICT SEONI",
  "GOVT COLLEGE UDAYNAGAR DIST DEWAS",
  "ATHARV INSTITUTE OF COMPUTER EDUCATION SAGAR     ",
  "VEER BALIDANI TANTYA MAMA GOVERNMENT COLLEGE, BALWADI",
  "TIMES COLLEGE OF PHARMACY",
  "BKP COLLEGE OF PHARMACY ,MALTHONE",
  "BADERIA GLOBAL INSTITUTE OF ENGINEERING AND MANAGEMENT, JABALPUR",
  "Narayanshri Homeopathic Medical College, Hospital & Research Center, Pushpa Nagar, Bhopal",
  "GOVT AUTO GIRLS PG COLLEGE OF EXCELLENCE SAGAR",
  "Government College Kesli",
  "SHRI ARJUN SINGH EDUCATION AMBAH",
  "GOVERNMENT ADARSH COLLEGE ",
  "NAS COLLEGE PORSA",
  "Veer Narayan Mahavidyalya Tamia",
  "Vivek Jyoti College, Balaghat",
  "GOVERNMENT COLLEGE KHURAI",
  "SWAMI VIVEKANANAND MAHAVIDYALAYA CHHATARPUR",
  "Bansal College of Engineering, Mandideep",
  "VEDICA COLLEGE OF PHARMACY (POLYTECHNIC)",
  "PENTIUM POINT COLLEGE OF LAW",
  "SHANTI COLLEGE OF PHARMACY",
  "Govt. College Dhodhar Sheopur",
  "KNP COLLEGE OF SCIENCE AND TECHNOLOGY BHOPAL",
  "UNIQUE GIRLS COLLEGE, PARASIA",
  "GOVT COLLEGE GHORADONGRI ",
  "GOVT COLLEGE BHIMPUR",
  "GOVT COLLEGE LAMTA BALAGHAT",
  "BALAJI PHARMACY COLLEGE HAMA MAHOBA ROAD CHHATARPUR MP",
  "RADIANT INSTITUTE OF ENGINEERING AND MANAGEMENT",
  "Pickthall College of Education Idgah Hills, Bhopal",
  "GOVERNMENT COLLEGE GULABGANJ DISTT VIDISHA",
  "JAWAHARLAL INSTITUTE OF TECHNOLOGY AND MANAGEMENT ",
  "S K COLLEGE OF EDUCATION CHAKARPUR DISTT NIWARI MP",
  "SR COLLEGE OF SCIENCE AND TECHNOLOGY GRAM CHAKARPUR DISTT NIWARI",
  "JIIT BICHHUA",
  "KRISHNA COMPUTER ACADEMY",
  "GOVT GIRLS COLLEGE ANUPPUR",
  "Mahamaya Siksha College, Gathawara, Chhatarpur",
  "GOVT POLYTECHNIC COLLEGE PANNA",
  "Laxmipati Institute of Professional Studies",
  "SAI KRISHNA COMPUTER EDUCATION CENTER",
  "RAJEEV GANDHI INSTITUTE RAIPURA",
  "SHRIKRISHNA PHARMACY COLLEGE, REWA",
  "Shri Yogindra Sagar Institute of Technology & Science, Dharad Gram, Mhow Neemach Road, Ratlam",
  "Choithram College of Nursing,  Manikbag Road, Indore",
  "R K COLLEGE OF SCIENCE TECHNOLOGY, LOUNDI",
  "SHRI GOVIND INSTITUTE OF EDUCATION",
  "AMPLE DREAMS INSTITUTE OF EDUCATION PHARMACY",
  "GOVERNMENT COLLEGE SOYATKALA",
  "SAD GURU COLLEGE OF EDUCATION, Datia",
  "KAILASH NARAYAN PATEL COLLEGE OF SCIENCE",
  "SHRI NARAYANA COLLEGE OF EDUCATION, PORSA, MORENA",
  "Government College Raghogarh",
  "SHRI KRISHNA MAHAVIDHYALAY, INDERGARH, DATIA",
  "Swami Vivekanand Govt. P.G. College, Narsinghpur",
  "Swami Vivekanand College Hatta",
  "Sadhu Waswani College, Bairagarh, Bhopal",
  "ADARSH COLLEGE OF EDUCATION",
  "GOVERNMENT COLLEGE SHAHPUR    ",
  "OM SAI NAATH COLLEGE OF PHARMACY",
  "MAA SHARDA EDUCATIONAL INSTITUTE CHHATARPUR SAMITI",
  "Chhatrasal Edu. College, Devendranagar, Panna",
  "ACADEMY OF MANAGEMENT",
  "St Francis College of Nursing",
  "BHARTIYA VIDYA MANDIR COLLEGE",
  "KISAN DEGREE COLLEGE",
  "SHRI RAM COLLEGE, NAUGAON",
  "RADHA KRISHAN MEERA CONVENT COLLEGE, RAMPUR CHAURASI, SATNA",
  "Jan Nayak Tantya Mama Govt. college Bhikangaon",
  "BHARAT MATA COLLEGE SHAHDOL",
  "SIT VIDYAPEETH",
  "AROGYA INSTITUTE OF NURSING",
  "RADHA KRISHAN COLLEGE",
  "SARDAR PATEL LAW COLLEGE KUNDAM ROAD PIPARIYA KHAMRIYA JABALPUR",
  "GOVT COLLEGE SILODI",
  "Sagar Institute of Science Technology & Research (SISTec-R), Sikandrabad, Near Ratibad, Bhadbhada Road, Bhopal",
  "GURU RAMDAS KHALSA INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "GURUKUL COLLEGE OF EDUCATION",
  "MIRACLE PARAMEDICAL COLLEGE",
  "College of Pharmacy",
  "SHRI G.L.S. COLLEGE BANMORE",
  "ADITYA COLLEGE, JABALPUR",
  "GOVT COLLEGE DINARA SHIVPURI",
  "Hitkarini  Women's College of Education, Jabalpur",
  "MAA KAILADEVI INSTITUTE",
  "VIP COLLEGE OF NURSING, BHOPAL",
  "M A COLLEGE OF EDUCATION BILKISGANJ SEHORE MP",
  "Yogeshwar Shiksha College, 11 Rajghat, Barwani",
  "P S T COLLEGE, BADPHARA, AMBAH",
  "MAHARAJA CHHATRASAL SHIKSHA MAHAVIDYALAYA",
  "Govt Collage shahgarh",
  "GLOBAL INSTITUTE OF ENGINEERING AND SCIENCE",
  "Govt. College Karahal, Sheopur",
  "Shree Jee College Of Education",
  " G L S COLLEGE JALONI AMBAH ",
  "Guru Droan  Mahavidyalaya",
  "TATA INSTITUTE OF TECHNOLOGY, SIDHI",
  "GOVERNMENT COLLEGE KHIRKIYA",
  "Shyam Adarsh Shiksha Mahavidyalaya",
  "Government Motilal Vigyan Mahavidyalaya, Bhopal",
  "Sadguru Institute of Nursing and Paramedical Sciences",
  "Govt. College Bandari ",
  "MODEL  COMPUTER OF TECHNICAL EDUCATION, KOTMA ",
  "Govt. Model Girls College Sheopur (M.P.)",
  "SHIVNATH SINGH COLLEGE",
  "adarsh shiksha mahavidyalaya jeerapur",
  "AADARSH NURSING COLLEGE JETPURA",
  "Govt College Jatara",
  "PRESTON COLLEGE",
  "SURABHI COLLEGE OF ENNGINEERING AND TECHNOLOGY, BHOPAL",
  "SURABHI COLLEGE OF PHARMACY",
  "JAGATGURU SANKRA CHARAY COLLEGE OF EDUCATION",
  "RAM KRISHNA MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE BHOPAL",
  "MAA PITAMBARA PARAMEDICAL COLLEGE",
  "HICT G.N.M. COLLEGE ",
  "SHRI REWA GURJAR MEDICAL SCIENCE TRAINING AND RESEARCH CENTER",
  "ADINA COLLEGE OF PHARMACY, SAGAR",
  "Govt Girls College, Seonimalwa ",
  "SANKALP COLLEGE, ANUPPUR",
  "SUSHILA TEACHERS TRAINING INSTITUTE",
  "IPS ACADEMY JHABUA",
  "GOVT COLLEGE BAGH DIST DHAR MP",
  "S R S PARAMEDICAL COLLEGE",
  "Globus College of Pharmacy",
  "SWAMI VIVEKANAND MAHAVIDYALAYA, SEHORE",
  "Aspire Institute ",
  "LAKSHMI NARAIN COLLEGE OF TECHNOLOGY AND SCIENCE GWALIOR",
  "Institute of Professional Education and Research PGDM",
  "Government College, Namli",
  "Government College Piploda",
  "Government College Bajna",
  "Government College Rawti",
  "Government College Kaytha",
  "AASTHA GIRLS COLLEGE, SHYAMPUR",
  "Daly College of Business Management ",
  "MANAS MAHAVIDYALAYA BAHADURGANJ AJAYGARH ",
  "Cambrige International College",
  "ACHARYA RAJENDRA SURI SHIKSHA MAHAVIDHYALAYA",
  "GOVT CHHATRASAL MAHARAJA COLLEGE MAHARAJPUR",
  "A.S.E.College of Education",
  "Dr. B.R. Ambedkar Law College, Indore",
  "BETWANCHAL COLLEGE OF EDUCATION    ",
  "Govt. College, Dhana",
  "Jai Maa Pitambra College of Ccience and Education datia ",
  "SHRI RAWATPURA SARKAR INSTITUTE OF PHARMACY JABALPUR",
  "SHAKUNTALA MAHAVIDYALAY",
  "SUPERIOR INSTITUTE OF COMPUTER TECHNOLOGY LAHAR",
  "NRS COLLEGE, BARKOHA, CHHATARPUR",
  "Thakur Shivkumarsingh Memorial Pharmacy College",
  "Swa. Tukojirao Pawar Shaskiya Vigyan Mahavidyalaya, Dewas",
  "Babulal Gaur Govt. PG College BHEL, Bhopal",
  "M P S COLLEGE GWALIOR",
  "GOVT. INDIRA GANDHI HOME SCIENCE GIRLS P.G. COLLEGE, SHAHDOL",
  "GOVT.INDIRA GANDHI GIRLS COLLEGE,SATNA",
  "Government College, Jawarnagar",
  "VIKRAMADITYA INSTITUTE OF PHARMACEAUTICAL SCIENCE",
  "ARADHAYA COMPUTER INSTITUTE",
  "RASS JB COLLEGE FOR PROF. STUDIES",
  "SR COLLEGE OF EDUCATION SANKAT MUCHAN NAGAR MORAR",
  "MAA SANTI DEVI COLLEGE  KUTGHAN SABALGARH",
  "SARVE DHARAM LAW COLLEGE",
  "DVS EDUCATION COLLEGE LMP COLLEGE KE PASS MORAR",
  "GOVT. COLLEGE ATER",
  "ROSHAN LAL DAIPURIYA COLLEGE , SURPURA",
  "NRI INSTITUTE OF INFORMATION SCIENCE AND TECHNOLOGY BHOPAL",
  "NRI INSTITUTE OF AYURVEDIC MEDICAL SCIENCES, BHOPAL",
  "AMBAJI COMPUTER AND CAREER ACADEMY ",
  "GOVT. GRADUATE COLLEGE ALAMPUR",
  "MJS GOVT. POST GRADUATE  COLLEGE",
  "Govt. P.G. College, Morena",
  "Govt. College, Jaura, Morena",
  "VEERANGNA JHALKARI BAI GOVERNMENT GIRLS COLLEGE, GWALIOR",
  "BIMR NURSING COLLEGE",
  "JAI INSTITUTE OF NURSING & RESEARCH THATIPUR",
  "OM SHIV COLLEGE KARAHAL",
  "RAJIV GANDHI PROF. STUDIES COLLEGE URWAI GATE",
  "VIDYAWATI COLLEGE",
  "JAI HIND BISMIL COLLEGE OF EDUCATION AMBAH",
  "CH- YADUNATH SINGH EDUCATION COLLEGE",
  "MAHATMA GANDHI COLLEGE OF LAW",
  "CH. KAMAL SINGH COLLEGE , MOU.",
  "GOVT.GIRLS COLLEGE",
  "AMALTAS INSTITUTE OF AYURVEDA    ",
  "JAI MATA DI COLLEGE",
  "SARDAR GYAN SINGH MEMORIAL EDUCATION COLLEGE BADAGAON  MORAR",
  "SHRI RAWAT PURA SARKAR COLLEGE OF MANAGEMENT & SCIENCE",
  "RVS COLLEGE JOTAI ROAD, PORSA",
  "UMA DEGREE COLLEGE BADAKHAR",
  "CH. DILIP SING LAW COLLEGE",
  "PATIRAM SHIVHARE COLLEGE",
  "DREAM VALLEY COLLEGE ",
  "JAIN COLLGE LITTIL ANJELS SCHOOL KE PASS SHIVPURI LINK ROAD",
  "COLLEGE OF ADVANCE STUDIES",
  "GOVT. PG COLLEGE",
  "GOVT. DEGREE COLLEGE  CHACHORA ,BEENAGANG",
  "KS GROUP OF COLLEGES",
  "OPTIMUS COLLEGE HIGHER STUDIES",
  "SHIVNATH SINGH COLLEGE OF NURSING",
  "AMAR BHARTI COLLEGE CHUAHAN PIYAO THATIPUR",
  "BIMR COLLEGE OF LIFE SCIENCES",
  "GOVT. NEHRU DEGREE COLLEGE SABALGARH",
  "RSC COLLEGE BANT PARISAR THATIPUR",
  "VINAYAK COLLEGE , KALAN",
  "SHIVNATH EDUCATION COLLEGE SHIVPURI LINK ROAD",
  "MAA VIDYADEVI EDUCATION COLLEGE",
  "LAXMI NARAYAN ACADEMY OF MANAGEMENT CHITORA ROAD",
  "RAMNTHA SINGH COLLEGE GORMI",
  "M.L.B ARTS AND COMMERCE COLLEGE, GWALIOR",
  "CH. YADUNATH SINGH COLLEGE",
  "AMBAH PG COLLEGE , AMBAH",
  "GOVT. COLLEGE  MAHGOAN",
  "MAHARANA PRATAP COLLEGE GULALAI SABALGARH",
  "BHARTI VIDYA MANDIR COLLEGE OF MANAGEMENT EDUCATION YAMUNA NAGAR THATIPUR",
  "GOVT. COLLEGE KOLARAS",
  "SANTYOGI MANSINGH EDUCATION COLLEGE TANSEN ROAD",
  "SHRI VIASHNAV  COLLEGE  OF MANAGEMANT",
  "SABDHRM COLLEGE TANSE NAGAR",
  "GURUKUL EDUCATION COLLEGE",
  "MAT COLLEGE OF EDUCATION SATANBADA",
  "SWAMI VIVEKANAND COLLEGE OF EDUCATION",
  "ADS COLLEGE AMBAH",
  "PT. SYAMACHARAN UPADHYAY  COLLEGE , JOURA KHURD",
  "MRITUN JAY COLLEGE",
  "JAIN COLLEGE, MORENA",
  "Yuva Vyavsaik Shikshan Mahavidhyalaya, Guna",
  "SBRS COLLEEGE ADOKHAR",
  "RSC NURSING COLLEGE",
  "GOVT. LAW COLLEGE",
  "Govt college Bajag,Dindori",
  "Govt. College Khimlasa ",
  "Swami Vivekanand Mahavidhyalaya Tikamgarh",
  "SANSKAR COMPUTER INSTITUTE",
  "SHRI R C COMMERCE AND SCINCE  SATNA",
  "Government PG College, Rampura",
  "Govt. College Malthon ",
  "St. Paul College of Education, Khandwa",
  "GOVERNMENT COLLEGE, KHALWA",
  "Government College, Harsud",
  "VEER RENGU KORKU GOVERNMENT COLLEGE, KHAKNAR",
  "Government College Ranapur",
  "Krantikari Shahid Chhitusingh Kirad Government Post Graduate College, Alirajpur, District- Alirajpur",
  "Govt College Dhulkot",
  "SHANTI INSTITUTE OF PHARMACEUTICAL SCIENCES NOWGONG ",
  "SHREE JI COLLEGE OF PHARMACY, MANDSAUR",
  "SHRI RAM INSTITUTE OF LAW",
  "JAI NARAIN COLLEGE OF PHARMACY",
  "SANT SINGAJI GOVERNMENT COLLEGE, MUNDI",
  "Poonamchand Gupta Vocational College, Khandwa",
  "SALONI COLLEGE, VILLAGE DHARAD, POST OFFICE DHARAD, TEHSIL RATLAM, DISTRICT RATLAM, MADHYA PRADESH",
  "MILLENNIUM B.ED. COLLEGE BURHANPUR",
  "Kiran Vividh Kala Mahavidhyalaya, Bhopal",
  "DIVY JYOTI PHARMACY COLLEGE",
  "VAISHNO SHREE EDUCATION COLLEGE",
  "Dr. Jakir Hussain College of Education, Burhanpur",
  "RAM KRISHNA COLLEGE OF HOMEOPATHY AND MEDICAL SCIENCE, GANDHI NAGAR, BHOPAL",
  "Sugam Informatics Society",
  "Veena Vadini, Ayurvedic College, Kanha Kunj Akbarpur Choona Bhatti, Kolar Road, Bhopal",
  "RAJIV GANDHI INSTITUTE OF COMPUTER TECHNOLOGY-5537",
  "Govt College Unhel",
  "Omshree Mahavidyalaya, Sagar",
  "DIKSHA PROFESSIONAL ACADEMY",
  "Dr. Jakir Hussain Academy, Burhanpur",
  "IPS ACADEMY INSTITUTE OF ENGINEERING AND SCIENCE INDORE OFF CAMPUS I    ",
  "Bhagwan Birsa Munda Govt. College Divyagawan",
  "Saheed Bhima Nayak Govt. P.G. College, Barwani",
  "B.P.Dixit Coll. of Education Nawgaon",
  "ORIENTAL COLLEGE OF PHARMACY",
  "Rukmani Academy, Barwani",
  "PADMSHREE LATE KANTA BAHAN TYAGI GOVERNMENT COLLEGE NIWALI",
  "BSSS INSTITUTE OF ADVANCED STUDIES",
  "Maa Renuka Institute of Management, Sendhwa",
  "GOVERNMENT COLLEGE NADAN, SATNA",
  "SDPS COLLEGE OF COMMERCE AND MANAGEMENT",
  "GNS NURSING COLLEGE DATIA",
  "MANORAMA COLLEGE OF NURSING",
  "DIAMOND NURSING COLLEGE, BHENSODAMANDI",
  "JABALPUR PUBLIC COLLEGE OF NURSING",
  "LCH NURSING ACADEMY",
  " SUNDER DAIRY TECHNOLOGY DIPLOMA COLLEGE",
  "SUNRISE INSTITUTE OF EDUCATION ",
  "K L SHARMA COLLEGE OF MANAGEMENT SEHORE",
  "Cimti College, Ridhora",
  "GURU GOBIND SINGH COLLEGE OF PARAMEDICAL SCIENCE",
  "SHREE AADHYA EDUCATIONAL INSTITUTE UJJAIN",
  "SHAHEED BHAGAT SINGH INSTITUTE",
  "MAA NARMADA MAHAVIDYALAYA",
  "SANSKRITI INSTITUTE OF TECHNOLOGY SHAHDOL",
  "JD INSTITUTE OF FASHION TECHNOLOGY, GWALIOR    ",
  "SIDDHI VINAYAK,SHAHDOL",
  "DEHLI PUBLIC ACADEMY",
  "SACRED HEART COLLEGE OF ARTS AND SCIENCE",
  "JYOTI COLLEGE OF EDUCATION",
  "SHRI LAKHANLAL AGNIHOTRI MAHAVIDYALAYA PATHARI",
  "NEW MAHARSHI VISHWAMITRA COLLEGE SAWARGAON PANDHURNA",
  "GOVERNMENT LAW COLLEGE DHAR",
  "VIDHYAPEETH INSTITUTE OF LAW",
  "GOVERNMENT COLLEGE KAMPEL",
  "DATAPRO",
  "Corporate Institute of Science & Technology, Hataikheda, Near Patel Nagar, Raisen Road, Bhopal",
  "Chamelidevi Group of Institutions, Gram Umrikheda, Near Toll Naka, Khandwa Road, Indore 452020",
  "Bagula Mukhi College of Technology, Village-Mugalia Kot, Vidisha Road, Bhopal",
  "Infinity Management & Engineering College, Village - Patharia Jat Deori Road, Sagar - 470228",
  "GOVERNMENT COLLEGE, GUDI, DISTRICT KHANDWA MP",
  "\"Truba Institute of Pharmacy, Karod-Gandhi Nagar By Pass Road Bhopal  462038\"",
  "S.G.B.M. Institute of Technology & Science, Village Bineki, Tahsil Patan Dist. Jabalpur",
  "\"Shri Ramnath Singh Mahavidyalaya (Pharmacy), Gormi, Bhind \"",
  "\"Lakshmi Narain College of Pharmacy, Adampur, Raisen Road, Bhopal-462021\"",
  "Gulab Kali Memorial College Of Pharmacy,Gora Road Chakghat,  Post-Chakghat, Teh.Teonthar Distt.Rewa-486226",
  "Oriental Institute of Science & Technology, Thakral Nagar, Opp Patel Nagar, Raisen Road, Bhopal-462021",
  "\"NRI Institute of Pharmacy, 2, Sajjan Singh Nagar, Opp. Patel Nagar, Raisen Road,                Bhopal-462026\"",
  "SHRI SIDDHI VINAYAK COLLEGE",
  "Pt. Devprabhakar Shastri College of Technology, Gatheora, Chhatarpur",
  "Vedic Institute of Pharmaceutical Education and Research, University Bamhori, Tigadda, Link Road, Bahupura,                       Sagar - 470003",
  "Sagar Institute of Pharmaceutical Sciences, Sironja, Infront of Jubilee Petrol Pump, NH-26, Narsinghpur Road, Sagar-470004",
  "\"Charak Institute of Pharmacy, Choli Road, Mandleshwar Block  Maheshwar,    Khargone 451221\"",
  "Alpine Institute of Technology,  Gram Chandesara, Dewas Road, Ujjain",
  "Shri G. S. Institute of Technology & Science, 23,Park Road, Indore - 452003",
  "Malwa Institute of Science & Technology, Village Limbodagari Palia Post, Hathod Via, Indore, Indore - 453111",
  "SHRI BALAJI INFOTECH",
  "Saraswati Institute of Engineering & Technology, Tripuri Ward, Sagda, Jabalpur - 482003",
  "Shri Ram Institute of Technology Pharmacy, In front of ITI, Madhotal, Jabalpur-482002",
  "Synergy Institute of Technology,  Village Rajapura, Maxi Road, A.B. Road, Dewas",
  "Adina Institute of Pharmaceutical Science, Opposite Bamhori Seed Farm, Bhopal Road, Sagar-470002",
  "\"College of Pharmacy, IPS Academy, Rajendra Nagar, A.B. Road, Indore-452012\"",
  "\"Rewa College of Pharmacy, NH 7, Allahabad Road, Rathiri,  Rewa-486001\"",
  "Shri Ram College of Engineering & Management, Infrant of Railway Station,  A.B. Road, Banmore, Morena-476444",
  "Institute of Professional Studies Colleges of Pharmacy, Shivpuri Link Road, Near Bela Ki Bawadi Tiraha, Gwalior-475330",
  "Shri Ram Institute of Tech., Diploma Pharmacy, Near I.T.I., Madatal, Jabalpur-482002",
  "Kailash Narayan Patidar College of Science & Technology, Misrod, Bhopal",
  "Shri Guru Sandipani Institute of Technology & Science, Opposite R D Gardi Medical College, Village-Surasa, Agar Road, Ujjain",
  "KRISHNA COMPUTER CENTER NEELBAD BHOPAL ",
  "Shreejee Institute of Technology and Management , Khandwa  Road, , Khargone",
  "Nagaji Institute of Pharmaceutical Science, Thakur Baba Campus, Jhansi Road, Sitholi, Gwalior-474001",
  "SONY COMPUTER EDUCATION HARRAI",
  "\"Maharana Pratap College of Technology, Putli Ghar Road, Near Jiwaji University, Gwalior-474006\"",
  "\"TIT College of Pharmacy, Anand Nagar, Infront of Hathaikheda Dem, P.B. No. 24, Piplani, BHEL, Bhopal 462021\"",
  "IPS Academy, School of Architecture, Indore",
  "Rewa Engineering College,  University Road, Rewa  - 486001",
  "Indira Gandhi Engineering  College, Bahera, Sagar Jabalpur Road, Sagar-470004",
  "GYAN SAGAR COLLEGE OF PHARMACY SAGAR",
  "Laxmipati Institute of Science & Technology (List), Opp SOS, Village Ahjehara Road, Khajuri Kalan, Bhopal",
  "COLLEGE OF HORTICULTURE  REHLI",
  "NRI Institute of Pharmaceutical Science, 3, Sajjan Singh Nagar, Opp. Patel Nagar, Raisen Road,             Bhopal-462021",
  "Swami Vivekanand College of Engineering, Khandwa Road, Near Tool Naka,  Indore-452020",
  "Shri Balaji Institute of Technology & Management, Khasra No. 238, Village Gohchi, Tah. & Dist. Betul - 460005",
  "V E E ACEDEMY, SHIVPURI LINK ROAD",
  "GURU GOBIND SINGH COLLEGE OF DENTAL SCIENCE AND RESEARCH CENTER",
  "RAMKRISHNA COLLEGE OF NURSING, SADA",
  "KNOWLADGE INSTITUTE OF COMPUTER EDUCATION,SATNA",
  "Smart Computer Institute",
  "SHRI KRISHNA COLLEGE, BADARWAS",
  "SHIV SHANKAR COLLEGE, KALAMAD, BAIRAD, POHARI",
  "SHIDDHI VINAYAK COLLEGE, NARAYANPUR, NARWAR",
  "INDRAPRASTHA COLLEGE, GHATIGAON",
  "DR RADHAKRISHNAN COLLEGE, CHAROKHARA, SAPORA",
  "SWAMI VIVEKANAND COLLEGE, MACHHAND",
  "KANKAR COLLEGE",
  "DR AMBEDKAR COLLEGE, SIDDHPURA, DURGAPURA, LAHAR",
  "APEX COLLEGE, CHHIMKA, GOHAD",
  "SHEOPUR INSTITUTE OF PROFESSIONAL STUDIES",
  "JAVITRI DEVI MAHAVIDHYALAY",
  "J B COLLEGE, SABALGARH",
  "SD COLLEGE OF PARAMEDICAL SCIENCE ",
  "SRI AUROBINDO INSTITUTE OF LAW",
  "NAMDEV COMPUTER SILWANI",
  "VAIBHAV INSTITUTE",
  "ICIC COMPUTER CENTER VIDISHA",
  "shri rawatpura Sarkar Institute of Pharmacy",
  "BHANDARI GROUP OF HOSPITALS AND INSTITUTIONS, COLLEGE OF NURSING",
  "RADHA KRISHNA PHARMACY COLLEGE SATNA",
  "SHAHID CHANDRA SHAKHAR AZAD MAHAVIDHALAYA",
  "INSTITUTE OF TECHNICAL STUDIES",
  "GOVERNMENT COLLEGE GOVINDGARH",
  "BRILLIANT COMPUTER EDUCATION",
  "CHITRANSH COMPUTER",
  "UTKARSH COMPUTER INSTITUTE",
  "VIDYADAYINI INSTITUTE OF SCIENCE MANAGEMENT AND TECHNOLOGY",
  "SUNDAR DEVI NURSING COLLEGE",
  "LAXMIPATI INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "CHIRAYU MEDICAL COLLEGE AND HOSPITAL",
  "RBS INSTITUTE",
  "DIVINE INTERNATIONAL GROUP OF INSTITUTIONS",
  "Govt. Music College, Mandsaur",
  "NAVRATNA COLLEGE OF EDUCATION, DHAR",
  "COSMIC CAREER ACADEMY",
  "KAMLESH MAHAVIDYALAYA, BHIND",
  "M.B. KHALSA LAW COLLEGE, INDORE",
  "Govt. Institute of Fine Art, Indore",
  "Adarsh Sangeet Mahavidhyalaya, Sagar",
  "FUTURE PILLAR COMPUTER INSTITUTE KURWAI",
  "BHARAT COLLEGE, DATIA",
  "SHRI VAISHNAV COLLEGE OF EDUCATION, GWALIOR",
  "GYANWATI MAHAVIDYALAYA, BHIND",
  "HNS COLLEGE",
  "K S COLLEGE, MORENA",
  "GOVERNMENT COLLEGE, SUKHTAWA",
  "Graduate School of Business , Nipaniya, Indore",
  "Government College, Badnawar ",
  "Annie Besant College  Annapurna Road, Indore",
  "SAI INSTITUTE OF MANAGEMENT",
  "Acropolis Faculty of Management & Research, Manglia Chouraha, Indore",
  "Acropolis Institute of Management Studies & Research, Manglia Chouraha, Indore",
  "Acropolis Institute of Technology and Research, Manglia Chouraha, Indore",
  "Idyllic Institute of Management, Indore",
  "Shaheed Chandra Shekhar Azad Govt. P.G. College,  Jhabua",
  "Govt. Girls College, Jhabua",
  "Govt. College, Thandla",
  "BM College of Management & Research, Khandwa Road, Indore",
  "Adarsh Institute of Management and Science, Dhamnod",
  "CH Institute of Management and Commerce ,Sanwer Road,  Indore",
  "AISECT College of Prof. Studies, Gumasta Nagar, Indore",
  "Govt. College, Manawar",
  "Christian Eminent College (Academy of Management, Professional Education and Research), Indore",
  "USTAD ABID HUSSAIN KHAN SAHEB SANGEET EVAM KALA MAHAVIDHYALAY",
  "UNIQUE COMPUTER AND MEDIA CENTRE",
  "GOVERNMENT COLLEGE, BAKTARA",
  "INFORMATION TECHNOLOGY DEVELOPMENT CENTRE RATLAM",
  "INSTITUTE OF COMPUTER SCIENCE & TECHNOLOGY BINA",
  "GRENADIERS REGIMENTAL CENTRE JABALPUR",
  "BLEW COMPUTER CENTRE BHOPAL",
  "BHARTIYA INSTITUTE OF PROFESSIONAL STUDIES UJJAIN",
  "Nirmala College Of Education",
  "TIRUPATI BALAJI PARAMEDICAL COLLEGE UMARIA",
  "V I M S , SATNA",
  "SHRI SAI COLLEGE OF TECHNOLOGY AND SCIENCE, BAIKUNTHPUR",
  "SAINATH SCHOOL OF NURSING, VAIDHAN",
  "GOVERNMENT COLLEGE, MAJHGAWAN, SATNA",
  "GOVERNMENT COLLEGE, KUSMI",
  "Sardar Vallabh Bhai Patel Government College Devtalab",
  "SANGHAMITRA COLLEGE REWA",
  "GOVT COLLEGE RITHI",
  "ACROPOLIS INSTITUTE OF LAW",
  "THE GEETA COLLEGE",
  "SWAMI VIVEKANAND INSTITUTE OF MANAGEMENT TIKAMGARH",
  "KPM COLLEGE, SULTANPUR",
  "SHITLA PRATAP SINGH COMPUTER TECHNOLOGY UMARIA",
  "PROMINENT ACADEMY OF COMPUTERS EDUCATION JABALPUR",
  "SWAMI VIVEKANAND INSTITUTE OF IT EDUCATION",
  "BIVHA INSTITUTE OF COMPUTER AND COMMUNICATION",
  "AYUSHI INSTITUTE OF MEDIA & SCIENCE BHIND",
  "PC TECH COMPUTER EDUCATION",
  "ASTRAL INSTITUTE OF BUSINESS MANAGEMENT",
  "SOCIAL ORGANISATION FOR LITERACY",
  "MAHATMA GANDHI INSTITUTE OF COMPUTER EDUCATION,BERASIA ,BHOPAL",
  "GOVERNMENT COLLEGE, TONK KHURD",
  "SHRI ARIHANT COLLEGE OF PROFESSIONAL EDUCATION, SAILANA",
  "NAMO INSTITUTE OF COMPUTER TECHNOLOGY",
  "AKLAVYA PRERNA MAHAVIDYLAYA, MANDSAUR",
  "Shri Jayantilal Hirachand Sanghvi Gujarati Innovative College of Commerce & Science,  Ring Road, Indore",
  "CHHATARPUR LAW COLLEGE",
  "GOVERNMENT GIRLS COLLEGE, NAGDA",
  "SHRI VIRENDRA KUMAR SAKHLECHA GOVERNMENT COLLEGE SINGOLI",
  "GOVERNMENT COLLEGE PHANDA BHOPAL",
  "R C L COLLEGE OF  EDUCATION PORSA MORENA M P",
  "DESIGN CENTRE",
  "MADHYA PRADESH SCHOOL OF DRAMA BHOPAL",
  "MAA DHANVANTI DEVI SANGEET EVAM KALA MAHAVIDYALAYA",
  "NISHTHA COLLEGE OF EDUCATION",
  "Sangeetika Sangeet Mahavidhyalaya",
  "CAREER COLLEGE OF ANIMATION",
  "CORE COLLEGE OF NURSING AND PARAMEDICAL",
  "Govt. College Junnardeo",
  "KNK COLLEGE OF HORTICULTURE, MANDSAUR",
  "SPLASH MULTIMEDIA",
  "PRABHA INSTITUTE OF COMPUTER SCIENCE",
  "SAI COMPUTER INSTITUTE ",
  "Smt. Dhairya Prabhadevi Sojatia Women's Education College",
  "Govt (Auto) P.G. College,  Chhindwara",
  "Devi Singh Keshar Bai Shiksha Samiti",
  "FOOTWEAR DESIGN AND DEVELOPMENT INSTITUTE - CHHINDWARA",
  "Seoni Degree College",
  "SHREE DURGA COMPUTER INSTITUTE MOMAN BARODIYA",
  "DIKSHA COLLEGE OF MANAGEMENT",
  "BKP COLLEGE",
  "LITTLE ANGEL INSTITUTE OF LAW",
  "SHARDA DEVI SHIKSHA MAHAVIDYALAYA",
  "GOVT POLYTECHNIC COLLEGE LATERI",
  "Footwear Design and Development Institute - Guna",
  "DAKSH PHARMACY COLLEGE",
  "OM SANTI IT INSTITUTE",
  "Government College Niwas, Mandla",
  "RISHI GALAV COLLEGE , MORENA",
  "PARSHVA INFOTECH",
  "MINAAKSHI ACADEMY OF PARAMEDICAL STUDIES SEONI",
  "FLORENCE NIGHTINGALE SCHOOL OF NURSING",
  "GOVERNMENT MODEL COLLEGE",
  "KUSHAGRA PROFESSIONAL COLLEGE",
  "DEVI SHAKUNTALA SHIKSHAN SANSTHAN JAISINGHNAGAR",
  "GOVERNMENT COLLEGE BAROADA SHEOPUR",
  "IPS ACADEMY INSTITUTE OF BUSINESS MANAGEMENT AND RESEARCH SANWER CAMPUS,SANWER",
  "PBGM Nursing College",
  "MSPM COLLEGE OF PHARMACY    ",
  "THAKUR SOMESHWER SINGH SHASKIYA MAHAVIDHYALAYA NAIGARHI REWA",
  "SHINE COLLEGE OF EDUCATION",
  "DIVY JYOTI PARAMEDICAL COLLEGE",
  "SHRI GOKUL SINGH MAHAVIDHYALAY GORMI BHIND",
  "IPS COLLEGE OF EDUCATION VILL JARAINA JOURA MORENA",
  "SHRI HUKUMCHAND YADAV GOVERNMENT NEW MODEL DEGREE COLLEGE, KHANDWA MP",
  "GURUKUL SCHOOL OF PHARMACY",
  "GOVERNMENT COLLEGE HANUMANA",
  "AYUSH GRAM COLLEGE OF PHARMACY",
  "SHRIRAM COLLEGE OF PHARMACEUTICAL SCIENCES",
  "SENDHWA INSTITUTE OF PROFESSIONAL STUDIES",
  "GOVERNMENT MEDICAL COLLEGE     ",
  "SHRI RAMKRISHNA COLLEGE OF PHARMACY     ",
  "DIVY JYOTI ENGINEERING COLLEGE    ",
  "VIRENDRA KUMAR SAKHLECHA GOVERNMENT MEDICAL COLLEGE, NEEMUCH, MP    ",
  "SHREE BALVEER COMPUTERS",
  "maa shitla computer institute",
  "GLOBAL DIGITAL LITERACY CENTER",
  "SATYADEV COMPUTER INSTITUTE , SALEHA",
  "T D COLLEGE OF PHARMACY",
  "NICE COMPUTER BALAGHAT",
  "UNIQUE INSTITUTE OF MEDIA AND TECHNOLOGY BALAGHAT",
  "K.K. EDUCATION INSTITUTE JABALPUR",
  "GRADUATE SCHOOL OF LAW",
  "VENUS INSTITUTE OF COMPUTER AND TECHNOLOGY   , DEORI ",
  "BEGUM AHMED BAKSH GIRLS COLLEGE",
  "CENTRE OF COMPUTER AND SOFTWARE TECHNOLOGY",
  "AJAX MEDICAL TRAINING",
  "AUGUSTINE COLLEGE OF NURSING",
  "SHRI SHRI EK SO AATH  BABA BALAKDAS  SHIKSHA MAHAVIDHYALAY PORSA MORENA BED ",
  "DHAR COLLEGE OF EDUCATION",
  "INSTITUTE OF PROFESSIONAL AND TECHNICAL EDUCATION ",
  "BNP MEMORIAL DEGREE COLLEGE ",
  "SHINE PARAMEDICAL COLLEGE",
  "PT. RAM SUNDER SHUKLA SHIKSHA EVAM PRASHIKSHAN SANSHTHAN ",
  "Radha Devi Ramchandra mangal Institute, Bhatkhera , NeemuchNeemuch",
  "SHIVAM COLLEGE OF PHARMACY SEONI ",
  "BHABHA COLLEGE OF DENTAL SCIENCE",
  "VIKRANT INSTITUTE OF NURSING SCIENCE INDORE",
  "VARMA UNION NURSING COLLEGE",
  "THE ACADEMY OF NURSING SCIENCES AND HOSPITAL",
  "SMS ENERGY NURSING COLLEGE",
  "CORPORATE COLLEGE OF NURSING",
  "Ch Dilip Singh Pharmacy College",
  "SHRI DHEERSINGH MAHAVIDYALAYA, GORMI",
  "PT B D MEMORIAL COLLEGE BILEHARA DISTT SAGAR MP",
  "SHRI MADHUKAR SHARIRIK SHIKSHA MAHAVIDHYALAYA UJJAIN",
  "government college bijuri",
  "Govt Medical College Datia",
  "R.B.S.Inst.Of Education, Kacholi, Neemuch",
  "ENGINEERING COLLEGE NOWGONG",
  "AARYAWART MAHAVIDHYALAY",
  "GOVT. COLLEGE MANPUR, DISTT-UMARIYA",
  "SAM COLLEGE OF MANAGEMENT AND TECHNOLOGY, BHOPAL",
  "Imperial Computer Academy",
  "Govt. College Of Education, Dewas",
  "Maya Devi Institute of Education, Dewas",
  "Shri SitaRam Jaju Govt. Girls College, Neemuch",
  "Vardhman College Of Prof.Studies, Nagda",
  "Bhagvan Mahavir Education College Daloda, Mandsaur",
  "Advance Science & Commerce College, Ujjain",
  "SANJAY GANDHI SMRITI GOVERNMENT AUTONOMOUS POST GRADUATE COLLEGE SIDHI",
  "Dr. Rawatmal Dhanroupmalji Sojatia College of Education, Bhanpura",
  "Guru Vashita College, Dewas",
  "JAWAHARLAL NEHRU SMRITI GOVERNMENT POST GRADUATE College, Shujalpur,Shajapur",
  "Govt.Girls College, Shajapur",
  "Govt. Ramchandra Vishwanath College, Manasa ",
  "B.K.S.N. Govt. College, Shajapur",
  "Pandit Atal Bihari Vajpayee Govt. College, Pipliyamandi",
  "Gyanoday Institute of Mangt & Technology, Kanawati, Neemuch",
  "Ma Jinwani College of Professional Studies, Pushpgiri Sonkach",
  "Shikhar Teacher Training Inst. Bholyawas, Neemuch",
  "SHRI BALAJI COLLEGE OF PHARMACY, AMLA",
  "MAGNUS COLLEGE OF EDUCATION, CHAINPURA, BILKISGANJ",
  "J S COLLEGE OF LAW PRITHVIPUR ",
  "MAA NARMADA INSTITUTE OF PROFESSIONAL EDUCATION DHAMNOD",
  "MAIPS INSTITUTE GWALIOR",
  "MAHATMA GANDHI INSTITUTE FOR COMPUTER SCIENCE & TECHNOLOGY JABALPUR",
  "UNIQUE  ACADEMY PARASIA",
  "MAHARAJA AGRASEN INSTITUTE OF COMPUTER SCIENCE MAIHAR",
  "KRISHANA INFORMATION TECHNOLOGY",
  "KRISHNA COLLEGE OF EDUCATION MANGAWAN REWA",
  "GOVT LAW COLLEGE SHAJAPUR",
  "HI-TECH COMPUTER ACADEMY, KHANDWA",
  "Prashanti College of Professional Studies, Ujjain",
  "GOPALJI COMPUTER ACADEMY",
  "SHRI R.K COLLEGE OF LAW, BHARHUT NAGAR SATNA",
  "PC COMPUTER CENTRE ",
  "COLLEGE OF PHARMACY",
  "JAI AMBE INSTITUTE ON INFORMATION TECHNOLOGY",
  "SCHOOL OF MANAGEMENT STUDIES, SRI SATYA SAI UNIVERSITY OF TECHNOLOGY AND MEDICAL SCIENCES (SSSUTMS)",
  "CENTRE FOR ADVANCED COMPUTER TRAINING B.J.S. BHOPAL",
  "career computer education ",
  "CENTRAL ACADEMY COMPUTER CENTER CHANDERI",
  "BUREAU OF COMPUTER SCIENCE & TECHNOLOGY BETUL",
  "BRIGHT CAREER COMPUTER CENTER",
  "BRIGHT FUTURE COMPUTER BHAINSDEHI DIST. BETUL M.P. PIN 460220",
  "BRIGHT CAREER COMPUTER INSTITUTE AND TECHNOLOGY LATERI",
  "B.M.M INSTITUTE OF PROFESSIONAL STUDIES",
  "BHOPAL INSTITUTE OF PROFESSIONAL STUDIES BHOPAL",
  "BHOPAL COMPUTER ACADEMY",
  "BHARTIYA VIDYA MANDIR INSTITUTE OF INFORMATION AND TECHNOLOGY GWALIOR",
  "BHAGWAN KALA KENDRA BHOPAL",
  "BALMIK ELECTRONIC SOFTWARE TECHNOLOGY (BEST) JHABUA",
  "BestWay Computer",
  "BEST COMPUTER EDUCATION",
  "AVS COMPUTER INSTITUTE SATAI",
  "ARYAN INSTITUTE OF PROFESSIONAL STUDIES & RESEARCH GWALIOR",
  "COLLEGE OF PROFESSIONAL STUDIES ATC",
  "SCHOOL OF PHARMACY ",
  "GOVERNMENT ADARSH COLLEGE VIDISHA ",
  "SUBHASH YADAV MEMORIAL DEGREE COLLEGE BORAWAN",
  "Mayo College of Peramedical Science Maya Hospital Campus, opp. State Bank, Sultaniya Road, Bhopal",
  "KEWALSHREE INSTITUTE OF PHARMACY    ",
  "Govt. College, Alot",
  "Liberal College, IIM Pithampur Rau, Indore",
  "MALWA INSTITUTE OF PHARMACY",
  "Modern Institute. of Prof. Science, Gram Alwasa, Sanwar Road, Indore",
  "MASTER INSTITUTE OF COMPUTER AND TECHNOLOGIES    ",
  "N.E.S. Law College, Jabalpur",
  "Anushree homeopathy College, Jabalpur",
  "T.S.S COLLEGE",
  "GOVERNMENT COLLEGE HATTA, BALAGHAT",
  "N.E.S. Education College, Jabalpur",
  "Reva B.Ed. College of Education, Jabalpur",
  "Rajendra Kala Sangeet Mahavidyalaya,Balaghat - 481 001",
  "ST JOSEPHS COLLEGE OF  NURSING, HOSHANGABAD",
  "Govt. College, Rau",
  "Bhartiya Vidya Mandiar College of Pharmacy, Opp. Ashram Bapu Ashram, Shivpuri Link Road, Gwalior",
  "DP COLLEGE OF PHARMACY    ",
  "Master Mind Computer Academy",
  "Roshan College of Education, Shri Nagar Colony, Dhar",
  "Shree Rajendra Suri Govt. College Sardarpur  Rajgarh Dhar  ",
  "RAJ COMPUTER ACADEMY",
  "Shreejee Degree College Khargone",
  "CORPORATE INSTITUTE OF PHARMACY",
  "RAJA BALWANT SINGH SHIKSHA MAHAVIDHYALAY RAJNAGAR",
  "Sardar Vallabh Bhai Patel Govt. College, Kukshi Dist. Dhar",
  "INSTITUTE OF ADVANCED STUDIES BY MALWA    ",
  "SVN COLLEGE OF EDUCATION",
  "RADHA KRISHAN COLLEGE, CHITUWA, DATIA",
  "Shivkumarsingh College of Prof. Studies, Bank Colony, Indore",
  "Arihant College,  Khandwa Road,Indore",
  "Govt. Degree College, Amanganj",
  "VARNAM INSTITUTE OF INFORMATION TECHNOLOGY",
  "VISION COMPUTER EDUCATION PIPARIYA",
  "VIKRAM INSTITUTE OF PROFESSIONAL STUDIES UJJAIN",
  "VISHAL COMPUTERS INSTITUTE OF INFORMATION TECHNOLOGY ",
  "VINDHYA INSTITUTE OF COMPUTER SCIENCE REWA",
  "VENUS INSTITUTE OF COMPUTER  TECHNOLOGY ",
  "VENUS COMPUTER INSTITUTE",
  "R K TEACHERS TRAINING INSTITUTE LAVKUSH NAGAR",
  "RAJSHREE COLLEGE OF PROFESSIONAL STUDIES, ASHTA",
  "MADHAV MAHAVIDYALAYA",
  "New TAkshila College, Bhagat Singh Chauraha, Karod, Bairasia Road, Bhopal",
  "Sri Sathya Sai College for Women, Bhopal",
  "Govt. Naveen College Buxwaha",
  "Shri Anand Mahavidhyalaya, Laundi Distt Chhatarpur",
  "The Grantham College of Education Vidisha",
  "BUNDELKHAND COLLEGE",
  "GOVERNMENT COLLEGE SUTHALIYA",
  "AYUSHMATI COLLEGE OF EDUCATION",
  "Bhabha College of Education, Bhopal",
  "Bhabha Engineering Research Institute, MCA",
  "vaibhav computer and management education",
  "GOVERNMENT MEDICAL COLLEGE SHAHDOL",
  "Bhabha Management Research Inst. NH 12 Hoshangabad Road Misrod Road, Bhopal",
  "UNIQUE INSTITUTE OF INFORMATION TECHNOLOGY PORSA",
  "BHABHA POLYTECHNIC PHARMACY, BHOPAL",
  "Vivekanand computer centre",
  "REWANCHAL INSTITUT OF TECNOLOGY LALGANWA,REWA",
  "T.D.SHIKSHA COLLEGE INDRANAGAR REWA",
  "JAWAHARLAL NEHRU COLLEGE OF TECHNOLOGY REWA",
  "REWA COLLEGE OF EDUCATION  RATAHRA, REWA",
  "A.V.B.ED COLLEGE,GAHILGARH,VINDHYA NAGAR,SINGRAULI",
  "GOVT.COLLEGE JAITPUR, SHAHDOL",
  "GOVT.COLLEGE, BIRSINGHPUR PALI,UMARIA",
  "GOVT.COLLEGE,NAGOD,SATNA",
  "MAHATMA GANDHI COMPUTER COLLEGE ,  SATNA",
  "M.L. CHAURASHIYA B.ED COLLEGE REWA",
  "IDEAL COLLEGE",
  "GOVT.S.S MEDICAL COLLEGE,REWA",
  "GOVT.COLLEGE,RAIPURKARCHULIAN,REWA",
  "RAJIV GANDHI COLLEGE,WAISDHAN,SINGRAULI",
  "GOVT.EDUCATION COLLEGE,REWA",
  "GOVT.COLLEGE SIHAWAL, SIDHI",
  "R.K.D.F. School of Pharmaceutical Sciences, NH-12, Village Jatkhedi, Hoshangabad Road, Bhopal",
  "NARSINGH IT TECH COMPUTER OF COLLEGE ",
  "Govt. RAJNARAYAN SMRITI COLLEGE, WAIDHAN,DISTRICT SINGRAULI (M.P.)",
  "Silicobyte Katni Degree College Gyanteerth",
  "Department of Education, R.K.D.F University, Bhopal",
  "GOVT.VIVEKANAND MAHAVIDYALYA, MAIHAR,SATNA",
  "GOVT DEGREE COLLEGE GURH, REWA",
  "ACHARYA VIRAGSAGAR VIDHYAPEETH BINA (M.P)",
  "Gyanodyaya Institute of Professional Studies,    Gram Kanwati Tehsil-District Neemuch (M.P.)",
  "\"Lakshmi Narain College of Technology & Science, Kalchuri Nagar, Raisen Road, Bhopal-462021 \"",
  "Institute of Engineering & Science, IPS Academy, Rajendra Nagar, A.B. Road, Sita Building, Indore 452003",
  "Transnational Knowledge Society's Group of Institutions, Tillore Khured, Ralamandal, Indore",
  "\"B.M. College of Technology, Gokanya Khandwa Road, Indore452001\"",
  "Bansal Institute of Research and Technology, Raisen Road, Kokta, Anand Nagar, Bhopal  - 462021",
  "\"Malwa Institute of Technology, Village Nipani, Bypass Road, Opp, D.P.S., Indore   \"",
  "The Bhopal School of Social Sciences, Bhopal",
  "Kopal Institute of Science & Technology, Gram Kalkheda, Tehsil Huzur, District Bhopal - 462003",
  "Shiv Kumar Singh Institute of Technology and Science, Gram Dehri (Bangwasa) Infront of IIM, Pithampur Road, Indore",
  "Jawaharlal Institute of Technology, Vidhya Vihar, Borwan, Kasrwada, Khargone-45122",
  "NRI INSTITUTE OF PARAMEDICAL SCIENCES BHOPAL",
  "AEC Training College and Centre, Pachmarhi, Dist. Hoshangabad",
  "LATE M L CHAURASIA MEMORIAL NURSING COLLEGE SCHOOL",
  "Government Holkar (Model Autonomous) Science College Indore (M.P.)",
  "GOMTI NANDAN INSTITUTE OF MANAGEMENT AND RESEARCH",
  "ANUSHASHAN INSTITUTE OF MANAGEMENT",
  "STEPS SOFTWARE SOLUTION AND COMPUTER EDUCATION",
  "Institute of Professional and Technology Education, Gram Piproli, Dist. Gwalior",
  "GOVT COLLEGE BANSAGAR ",
  "\"Lakshmi Narain College of Technology, Kalchuri Nagar, Raisen Road, Post Klua, Bhopal-462021\"",
  "All Saints College of Engineering, Gram Pipalner, Bhopal - 462036",
  "\"Rustamji Institute of Technology, Border Security Force (BSF) Academy, Tekanpur, Gwalior 474005",
  "RR COLLEGE",
  "SRISRAJAN COLLEGE OF ARTS  AND ANIMATION ",
  "SHRI SHYAM JI PARAMEDICAL INSTITUTE",
  "Technocrats Institute of Technology (Excellence), Anand Nagar, PB No. 24, Post Piplani, BHEL, Bhopal - 462021",
  "Srajan Institute of Technology Management & Science, Jaora Road, Ratlam",
  "INTELLICON COLLEGE OF PHARMACEUTICAL SCIENCES BHOPAL",
  "Prestige Institute of Engineering Management & Research, Scheme No 74-C. Sector D, Indore - 452010",
  "Shri Ganesh Digembar Jain Sanskrit College, Varni Bhawan, Sagar",
  "Government Sanskrit College, Rambagh, Indore",
  "Nagar Nigam Shri Loknath Shastri Sanskrit College, Govindgunj, Jabalpur",
  "Government Sanskrit College, Lashkar, Gwalior",
  "Shri Ramnam Sanskrit College, Akshaywat, Chitrakoot, Satna",
  "Government Sanskrit College, Bhitri",
  "Government Manmal Mimraj Ruyia Sanskrit College, Ujjain",
  "Government Sanskrit College, Devendra Nagar, Panna",
  "Government Sanskrit College, Dharmshree, Sagar",
  "SCHOOL OF PERFORMING OF ARTS ",
  "Shri Govindram SeksariaInstitute of Management & Research, Indore",
  "Shri Rishi Kumar Sanskrit College, Pili Kothi, Chitrakoot, Satna",
  "SHRI RAMA KRISHNA COLLEGE OF PHARMACY",
  "Swami Vivekanand Govt. College,  Susner",
  "R D Memorial College Of Pharmacy and Research",
  "GOVERNMENT COLLEGE, BUDHNI",
  "Govt. College, Sonkach",
  "New Era College of Education, Dewas",
  "Govt. Girls College, Mandsaur",
  "Vidhya Sagar Institute of Professional Studies, Khategaon",
  "GOVT AUTONOMOUS AYURVED COLLEGE GWALIOR ",
  "GOVERNMENT SANJAY GANDHI SMRITI POST GRADUATE COLLEGE, GANJ BASODA",
  "Shri Narayan Sanskrit College, Katni",
  "Government Venkat Sanskrit College, Rewa",
  "IGM INSTITUE OF IT AND MANAGMENT",
  "Jawaharlal Nehru Smriti College, Sohagpur, Hoshangabad",
  "GOVT. GIRLS COLLEGE",
  "SHRI RAWATPURA SARKAR INSTITUTE OF SCIENCE & EDUCATION",
  "BHAGWAN JULELAL SCIENCE COLLEGE SAMADHIYA COLONY  TARAGANG",
  "INDRA INSTITUTE OF COMPUTER EDUCATION, BHIND",
  "INSTITUTE OF COMPUTER SCIENCE & TECHNOLOGY BINA1",
  "SHRI SWAMIJI MAHARAJ COLLEGE OF PHARMACY DATIA",
  "Manjula K Ponda College of Management, Bhopal",
  "TRANSNATIONAL SCHOOL OF LAW",
  "Govt. College Tendukheda",
  "NISAD COLLEGE OF NARSING  & ALLIED SCIENCE'S, SATNA",
  "College of Veterinary Science and Animal Husbandry",
  "Govt. Naveen College Chandla Distt. Chhatarpur (m.p.)",
  "SANT RAMANAND MAHAVIDYALAYA EVAM ANUSANDHAN SANSTHAN",
  "GOVERNMENT COLLEGE BANMORE",
  "GOVT COLLEGE RANNOD",
  "INSTITUTE OF COMPUTER SCIENCE & TECHNOLOGY BETUL",
  "HI TECH COMPUTER INSTITUTE",
  "GOVERNMENT MODEL COLLEGE, JHABUA ",
  "SSL Jjain College, Vidisha",
  "srs it institute",
  "INSTITUTE OF COMPUTER SCIENCE AND TECHNOLOGY BETUL",
  "INTERMATICS COMPUTER CENTRE PARASIA",
  "INFOTECH COMPUTER ACADEMY INDORE",
  "NAVANKUR SCHOOL OF COMPUTER SCIENCE (8288), GANJ BASODA",
  "RAVINDRANATH TAGORE COMPUTER INSTITUTE ITARSI",
  "GYANAYATAN COLLEGE OF MANAGEMENT",
  "GLOBAL TECHNOLOGIES",
  "IT COMPUTER ACADEMY",
  "GOVERNMENT COLLEGE, MANGAWAN",
  "GOVT. COLLEGE OF DENTISTRY",
  "S.S.College of Education Chainpura Biskisganj",
  "Devi ahilya college of pharmacy.",
  "T D EDUCATION COLLEGE",
  "Government College, Phoop",
  "ADVANCE COLLEGE OF PHARMACY DATIA",
  "CORPORATE INSTITUTE OF MANAGEMENT",
  "GOPESH COLLEGE OF EDUCATION",
  "SHRI VAISANAV INSTITUTE OF TECHNOLOGY & MANAGEMENT BIRLA NAGAR",
  "RADHARAMAN AYURVED MEDICAL COLLEGE RESEARCH HOSPITAL",
  "KUNO COLLEGE OF EDUCATION",
  "BHOOMI COLLEGE OF EDUCATION",
  "Sankul Institute Of Computer Education",
  "SATNA INSTITUTE OF INFORMATION TECHNOLOGY SATNA",
  "VIP PARAMEDICAL COLLEGE BHOPAL ",
  "VISM COLLEGE OF PROFESSIONAL STUDIES",
  "SARASWATI ACADEMY OF COMPUTER SCIENCE AND APPLICATION NARSINGHPUR",
  "JAI HIND BISMIL COLLEGE AMBAH",
  "NEW ERA SCHOOL OF NURSING",
  "Virangana Rani Durgavati GOVERNMENT COLLEGE, BAHORIVAND",
  "Government Purushottam Sanskrit College, Khajurital, Satna",
  "SARDAR VALLABHBHAI PATEL GOVERNMENT  COLLEGE, NALKHEDA",
  "M P S SHIKSHA MAHAVIDHYALAYA BAROUA GWALIOR",
  "Millennium College of Pharmacy and Science,  Village Foura, Near Neelbad Chouraha, Nathu BarKheda Road, Bhopal",
  "Millennium Institute of Technology & Science, Village Goura, Near Neelbad Chouraha, Nathu Barkheda Road, Bhopal",
  "Millennium Institute of Technology,  Nathu Barkheda Road, Neelbad Bhopal",
  "\"Millennium College of Pharmacy, Nathu Barhkeda Road, Near Neelbad Chouraha,              Bhopal  462011  \"",
  "SUKHWANTI DEVI SHIKSHAN SANSTHAN HANUMANA REWA MP",
  "Rajeev Gandhi Ayurved College & Hospital",
  "Govt. Girls P.G College, Ujjain",
  "GOVT COLLEGE BADARWAS",
  "MP COMPUTER AND I T AMARPATAN",
  "GOVERMENT ADARSH COLLEGE SHAHPURA DITRICT DINDORI",
  "Maharana Pratap College",
  "Govt. College Shahpur, Betul",
  "IPS ACADEMY, Indore",
  "Bhopal Institute of Technology & Management (BITM), Village Bangrasia, Bhojpur Road, Bhopal",
  "BHOPAL INSTITUTE OF TECHNOLOGY, BHOPAL ",
  "BHOPAL INSTITUTE OF TECHNOLOGY AND SCIENCE",
  "\"Bansal College of Pharmacy, Kokta Anand Nagar, Bhopal-462021\"",
  "SWAMI VIVEKANAND SHIKSHA MAHAVIDHYALAYA, MANDSAUR",
  "TECHNOCRATS INSTITUTE OF COMMERCE AND SCIENCES",
  "Government College Gulana",
  "SHRI RAM COLLEGE",
  "KHAJURAHO INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "SHRI RAMA KRISHNA COLLEGE POLYTECHNIC AND MANAGEMENT",
  "Govt College Daloda",
  "SHRI RAM COLLEGE OF COMMERCE",
  "Shri Bhabanas Bharti Education College, Bhopal",
  "JABALPUR COMPUTERS & INFORMATION TECHNOLOGY JABALPUR",
  "ISLAMIA INSTITUTE OF COMPUTER SCIENCE AND MANAGEMENT INDORE",
  "JAI SHRI BALAJI INSTITUTE OF PROFISSNIOL STUDIES - 8249",
  "Keshav Mahavidhyalaya Tikamgarh Mp",
  "JABALPUR INSTITUTE OF COMPUTER SCIENCE, JABALPUR",
  "J.D. COMPUTER EDUCATION CENTRE SAGAR",
  "JAWAHARLAL NEHRU INSTITUTE OF COMPUTER TECHNOLOGY REWA",
  "Girdhar Shiksha Evam Samaj Kalyan Samiti Group of Institutions, Village Bamulia, Thesil Goharganj, Mandeep, Bhopal",
  "GOVERNMENT COLLEGE BASAI DATIA",
  "JCRC INSTITUTE OF TECHNOLOGY",
  "I.I.H.R.D. College, Vidisha",
  "GOVT NAVEEN COLLEGE MAWAI",
  "JET-POINT COMPUTER CENTRE BHOPAL",
  "M S M SHRI RAM SITA SHIKSHA SEWA SANSTHAN",
  "NCEC INSTITUTE OF SCIENCE & TECHNOLOGY BHOPAL",
  "GOVT COLLEGE ANJANIYA",
  "DR BHAGAT SINGH RAI INSTITUTE OF TECHNOLOGY SEONI",
  "JAWAD INSTITUTE OF INFORMATION TECHNOLOGY",
  "KCE INSTITUTE OF PROFESSIONALS NARSINGHPUR",
  "GOVT. GOVIND DEGREE COLLEGE SEBDA",
  "KESHAV INSTITUTE OF COMPUTER SCIENCE HATTA",
  "MAHATMA GANDHI COLLEGE OF PHARMACY",
  "KRISHNA INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH BADARWAS DIST SHIVPURI",
  "GYANVEER COLLEGE OF PHARMACY SAGAR",
  "GOVERNMENT GIRLS COLLEGE, SINGRAULI",
  "DR.RAGHUVIR SINGH GOVERNMENT COLLEGE, SITAMAU DISTRICT MANDSAUR",
  "KOTMA INSTITUTE OF COMPUTER & TECHNOLOGY KOTMA",
  "YOGESHWAR COLLEGE OF PHARMACY",
  "KRISHNA COMPUTER INSTITUTE INDORE",
  "NRI Institute of Research & Technology, Sajjan Singh Nagar, Raisen Road, Bhopal",
  "Mathuradevi Institute of Technology & Management, Garipipliya, Nemawar Road, Indore  - 452018",
  "SRI AUROBINDO INSTITUTE OF PHARMACY",
  "L N COLLEGE OF PHARMACEUTICAL STUDIES,INDORE",
  "Gyan Ganga Institute of Technology & Sciences",
  "Govt. College, Silwani Raisen",
  "JAI SHRI SAI INSTITUTE OF PROFISSIONAL STUDIES",
  "MAA SHARDA COMPUTER AND IT RAMNAGAR",
  "SWAMI VIVEKANAND COLLEGE OF PHARMACY PANNA    ",
  "Netaji Subhashchandra Bose Govt. Degree College, Ichhawar, District Sehore",
  "DR SHANKAR DYAL SHARMA SMRITI MAHAVIDHYALAYA",
  "MAA TRIPURA COLLEGE    ",
  "VAISHNAV MATA COLLEGE OF PHARMACY PANNA     ",
  "B M PROFESSIONAL INSTITUTE",
  "AYUSHMAN GROUP OF COLLEGE",
  "Swami Vivekanand Govt.P.G.College,Neemuch,Dist.Neemuch,Madhya Pradesh",
  "LNCT INDORE CAMPUS",
  "SCHOOL OF WILDLIFE FORENSIC AND HEALTH",
  "I PS College, Nirala Nagar",
  "JAGADGURU DATTATRAY COLLEGE OF NURSING",
  "SAI PARAMEDICAL COLLEGE BARWANI",
  "MA SARASWATI COLLEGE OF PARAMEDICAL BARWANI",
  "VENUS INSTITUTE OF COMPUTER AND TECHNOLOGY,SAIKHERA",
  "S R Institute of Technology",
  "NPC COMPUTER CENTRE ",
  "LALBAHADUR SHASTRI  INSTITUTE OF  TECHNOLOGY  AND MANAGEMENT",
  "Babu Hardev SIngh college, Prathvpur",
  "Shri Krishna College Of Education, Nowgong Road Chhatarpur, Dist.- Chhatarpur MP",
  "Govt College Dheemerkheda",
  "Govt College Umariapan",
  "NIRMALA COLLEGE",
  "YOGESHWAR PARAMEDICAL COLLEGE",
  "KESHAR EDUCATIN ACADEMY BAMOOR KA PURA KOTHARKALA PORSA MORENA",
  "\"Scope College of Engineering, NH-12, Hoshangabad Road, Village Bhaironpur, Misrod Bhopal.-462026\"",
  "Shri Rawatpura Sarkar Institute of Pharmacy, 3 Km Stone, Dagzai NH-75, Jhansi Road, Datia-475661",
  "Shri Ram Group of Institutions, Near ITI, Madhotal, Jabalpur-482002",
  "\"VNS Group of Institution,VNS Campus, Vidya Vihar, Nathu Barkheda, Neelbud, Bhopal-462044",
  "ITCON INSTITUTE OF COMPUTER EDUCATION",
  "Swami Vivekanand College Of Pharmacy Barkhedi Kala Neelbad Road,P.O.Suraj Nagar Bhopal-462044",
  "RDS VIDYASHRAM GROUP OF COLLEGE ",
  "GOVERNMENT COLLEGE GHUWARA CHHATARPUR MP",
  "Dr. Vijai Lall Smriti Mahavidyalaya Damoh",
  "RAJIV GANDHI GOVERNMENT POST GRADUATE COLLEGE, MANDSAUR",
  "PRAKHAR INSTITUTE OF IT EDUCATION",
  "JAWAHARLAL NEHRU MAHAVIDYALAYA RATAHRA",
  "GYAN GANGA COLLEGE OF TECHNOLOGY, JABALPUR",
  "SCIENCE GURU COLLEGE SIRMOUR REWA",
  "SANAND MANAGEMENT AND COMMERCE MAHAVIDYALAYA",
  "LOGICAL CONCEPTS COMPUTER EDUCATION SEONI",
  "SWAMI VIVEKANAND MAHAVIDYALAYA JANAKPUR PANNA",
  "SHRI RAVINDRANATH TAGORE INSTITUTE OF PROFESSIONAL STUDIES MORGHADI SANAWAD",
  "SONANCHAL DEGREE COLLEGE CHANDWAHI BAHARI DISTRC SIDHI",
  "JAGANNATH PREMVATI COLLEGE OF EDUCATION, Jabalpur",
  "ATAL BIHARI DEGREE COLLEGE",
  "MAA SHARDA INSTITUTE OF PROFESSIONAL STUDIES ",
  "MALWA INSTITUTE OF IT EDUCATION",
  "ALL TECH COMPUTER EDUCATION",
  "GOVT COLLEGE, BHITARWAR",
  "RAvishankar Teachers Training Inst. Near People Dental College Bhanpur, Bhopal",
  "PEACE COLLEGE OF EDUCATION, MEHGAON",
  "Advanced Computing  Education Center",
  "CEREBRAL HEIGHTS COMPUTER CENTER",
  "VAISHNAV MATA INSTITUTE PANNA (M.P.)",
  "INDORE MAHAVIDYALAYA INSTITUTE    ",
  "JAIN COLLEGE",
  "Guru Ramdas Khalsa Institute of Science & Technology\"MCA\", Kukrikheda, Barela, Jabalpur-483001",
  "PANDIT RAMESH CHANDRA BHATELE MAHAVIDYALYA, GOHAD",
  "PITAMBARA COLLEGE OF PHARMACY",
  "GOUTAM BUDDH MAHAVIDYALAY MORENA",
  "VIDHIK INSTITUTE PHARMACY",
  "Rajeev Gandhi Prodhogiki College, Saliya, Bhopal",
  "KAILADEVI MAHAVIDYALYA, AHROLI KALI, ATER",
  "Institute of Prof. Education Research,  Bhojpur Road, Bhopal",
  "B S PATEL COLLEGE, SEPURA, MEHGAON",
  "GREEN FIELD COLLEGE OF VOCATIONAL STUDIES",
  "DR SHYAM BIHARI TIWARI MAHAVIDYALAY",
  "NEW-TECH COMPUTER INSTITUTE",
  "SAINIK DEGREE COLLEGE",
  "MAYO COLLEGE OF MANAGEMENT",
  "VIP COLLEGE OF MANAGEMENT",
  "DAKSH LAW COLLEGE",
  "\"Mahakal Institute of Pharmaceutical Studies, Karcha farma, Behind Air Strip, Datana Station Road, Ujjain-456010\"",
  "Anand Institute of Management(BEd), Barkheda Nahu Neelbad, Bhopal",
  "SCHOOL OF ENGINEERING",
  "COLLEGE OF PROFESSIONAL STUDIES",
  "SVI COLLEGE OF PHARMACY AND RESEARCH",
  "ANURAG COLLEGE OF EDUCATION DUNDASEONI KHAIRAPALARI",
  "SHRIKRISHNAMAHAVIDHYALAYAVILLKURROLIMSROADKAILARASMORENA",
  "Maharaja Ranjit Singh College of Professional Sciences, Khandwa Road, Indore",
  "GYAN VITARANAM RESEARCH INSTITUTE FOR MEDIA STUDIES",
  "RAM KRISHNA COLLEGE GWALIOR",
  "J M COLLEGE OF EDUCATION",
  "S R D COLLEGE MORENA",
  "S D M J COLLEGE, M S ROAD, MORENA GAON, BAIPAS CHOURAHA",
  "ORANGE CITY COLLEGE SAUSAR",
  "SHRI ARJUN SINGH SHIKSHA MAHAVIDHYALAY  CHOKWAN PURA  ",
  "Krishnarao Khot Management   Technical College",
  "Times College of Education Damoh",
  "LAXMI DEVI COMPUTER EDUCATION ",
  "maa rajeshwari institute of profissional studies",
  "PT. DEEN DAYAL UPADHYAY COLLEGE PORSA",
  "Bagula Mukhi Bahu-uddishiya Girls Degree College, Sagar",
  "DEVI AHILYA COMPUTER",
  "Shri Krishna Mahavidhyalay, Harpalpur, Chhatarpur",
  "Sitaram College of Education Khop, Chhatarpur",
  "Govt. College Baldevgarh Distt. Tikamgarh",
  "Govt. College Mohangarh Distt. Tikamgarh (M.P.)",
  "ASTRAL INSTITUTE OF PROFESSIONAL STUDIES",
  "ARYA COLLEGE OF FASHION DESIGNING",
  "GOVT. DEGREE  COLLEGE  LAHAR",
  "Govt. Degree College, Shahnagar",
  "Mittal College of Education Chhatarpur",
  "Govt. College, Pachmarhi, Hoshangabad",
  "Swami Vivekanand Education College, Ratibad, Bhopal",
  "Maharani Pushpmala Raje Puar Govt. Girls Degree College, Dewas",
  "Government Degree  College, Hatpipliya",
  "LBS College, Ganjbasoda, Vidisha",
  "VINDHYA COLLEGE OF EDUCATION, KALYAN PUR, SHAHDOL ",
  "T.M.S. INSTITUTE OF PROFESSIONAL STUDIES, SHEOPUR",
  "Satpura Law College, Chhindwara",
  "Government College Chinor",
  "Vidya Devi Shukla College, Chhindwara",
  "Bhundelkhend Carrier College Hatta",
  "Swami Viveianand  College, Amarmue",
  "S.S. College, Compt.and Professional Studies, Chhindwara",
  "Swarswati College of Computer Science, Chhatarpur",
  "Pt. BrijKishore Pateria College Malthone",
  "Shri S.L.S. College of Edu. Rajakhedi Sagar",
  "Aricent College of Education Bina",
  "Thakur Feran Singh Arts and Comm. Degree College, Shahpur",
  "Litel Step Sc. and Tech. Boargawn, Chhindwara",
  "SARVANI COLLEGE SIKARPUR MORNEA",
  "MAHAKAL INSTITUTE OF COMPUTER TECHNOLOGY BHIND",
  "ADARSH MAHAVIDYALAYA",
  "Pt. Deendayal Upadhyay Government College Begumganj Dist. Raisen",
  "Govt. Girls College, Katni",
  "LBS College, Sironj, Vidisha",
  "Mahatma Gandhi Institute",
  "GOVT COLLEGE LATERI ",
  "Kamalnath College, 468/9A Saket Nagar, Bhopal",
  "Pt. Bhori Lal Gyatri Memorial College, Near Jain Mandir, Jehangirabad, Bhopal",
  "PANDIT NEHRU MAHAVIDYALYA, BANMORE",
  "R.K.D.F. College of Engineering, Village Jatkhedi, NH-12, Misrod, Bhopal",
  "GOVERNMENT KAMLA RAJA GIRLS POST GRADUATE AUTONOMOUS COLLEGE, GWALIOR ",
  "SAnjay Gandhi College, Vidisha",
  "State Law College, Tilak Hostel Behind M.V.M. College, Bhopal",
  "S R COLLEGE OF NURSING, MORAR",
  "GOVT. POLYTECHNIC COLLEGE ASHOKNAGAR",
  "International Fine Art Academy",
  "R G COLLEGE RAJGARH",
  "Late Smt. Indra Gandhi Government Girls College, Shivpuri",
  "BALAJI COMPUTER ACADEMY",
  "MICRO CAMPUTER ACADEMY",
  "vivekanand paramedical college ",
  "Govt. Mankunwar Bai Arts & Commerce Autonomous College for Women Jabalpur",
  "PT DEV PRABHAKAR SHASTRI COLLEGE, BAMITHA ",
  "SARASWATI B.ED. COLLEGE, BADOKHAR, MORENA",
  "COLLEGE OF FISHERIES",
  "R K COLLEGE",
  "Devisingh Kesharbai College, Shahpura Bhitoni, Jabalpur",
  "MD COLLEGE OF SCIENCE AND TECHNOLOGY",
  "Govt. Makhanlal Chaturvedi, College, Babai, Hoshangabad",
  "Maharaja Ranjit Singh College, Near K- Sector Ayodhya Nagar Bypass Road, Bhopal",
  "Govt. H.S.Z.H. Unani Medical College, Science Hills Behind MNIT Chunabhatti Bhopal",
  "GURU GOVIND SINGH INSTITUTE OF INFORMATION TECHNOLOGY ",
  "KMC COMPUTER ACADEMY",
  "Govt. Degree College, Nainpur, Mandla",
  "ORCHHA COMPUTER ACADEMY",
  "Mahatma Gandhi Homeopathy College, Jabalpur",
  "NISTHA COLLEGE OF EDUCATION",
  "Shri Dwarika Pd. Yadav, Khargapur",
  "JMRD EDUCATION COLLEGE",
  "Baba Loknath Indian Institute of Pharmacy Science and Research Centre, Chanatoriya, Bamhori Dudhar, Naya Kheda ,Post Siddhguaon, Sagar, M.P.",
  "LITTLE FLOWERS SCHOOL GROUP OF EDUCATION",
  "GOVERNMENT COLLEGE CHOURAI DIST CHHINDWARA MADHYA PRADESH",
  "D.C.A.B. College, Obdullahganj, Raisen",
  "YUVA INSTITUTE OF PHARMACY",
  "GOVT LAW COLLEGE DATIA",
  "JAIN COLLEGE, GWALIOR",
  "Govt. College, Nasrullaganj, Sehore",
  "J.M. COMPUTER ITARSI",
  "MAHAKAL ACADEMY OF COMPUTER TECHNOLOGY",
  "imperial institute of technology and science jaisinghnagar",
  "Govt. College, Kurwai, Vidisha",
  "Swa. Gulab Bai Yadav Smriti Shiksha Mahavidyalaya, Borawan ",
  "GOVERNMENT LAW COLLEGE BETUL",
  "SHRI VAISHNAVI INSTITUTE OF PHARMACY",
  "GOVERNMENT COLLEGE, LALBURRA",
  "GOVERNMENT COLLEGE, MALAJKHAND",
  "GOVERNMENT COLLEGE, TIRODI",
  "Late Dilip Bhatere GOVERNMENT  COLLEGE, KIRNAPUR Distt  Balaghat",
  "Swami Vivekanand Govt PG College, Harda",
  "UNIQUE COLLEGE OF TECHNOLOGY AMARPATAN SATNA",
  "R.D. Memorial College of Nursing, Scheme No. 54, Opp. Sayaji Hotel  Indore",
  "GOVT COLLEGE CHARGAWAN, JABALPUR ",
  "GOVT COLLEGE SHAHPURA, JABALPUR ",
  "XAVIER INSTITUTE OF MANAGEMENT JABALPUR XIMJ",
  "PATEL COLLEGE OF PHARMACY INDORE",
  "LATE JAHID KHAN COLLEGE GURH REWA",
  "BALAJI INSTITUTE OF PROF. STUDIES, DABRA",
  "SHRI VAISHNAV INSTITUTE OF MANAGEMENT, GWALIOR",
  "Saviour College, E-9 Arera Colony, Pallavi Nagar Near Dana Resturent, Bhopal",
  "awadh digree colleg",
  "SAINATH INSTITUTION KATNI",
  "RAVI SHANKAR COLLEGE OF EDUCATION, RAWATPURA ASHRAM. LAHAR BHIND",
  "MASTEK ACADEMY BHOPAL",
  "SLS COLLEGE OF PHARMACY",
  "St. Aloysius Institute of Technology,  Mandla Road, Jabalpur - 482001",
  "SHRI RAWATPURA SARKAR COLLEGE OF EDUCATION LAHAR",
  "Mandsaur Infotech",
  "AEKLAVYA SCI. MGT. AND I.T. COLLEGE AMARWARA",
  "GOVERNMENT COLLEGE, CHITRANGI",
  "Gyanoday Institute of Nursing Kanavati, Neemuch",
  "BETWANCHAL COLLEGE OF MANAGEMENT",
  "GOVERNMENT COLLEGE NARAYANGANJ",
  "SHRI RAWATPURA SARKAR  COLLEGE OF EDUCATION CHITRAKOOT, SATNA",
  "Media World Computer Education-8199",
  "GOVERNMENT COLLEGE KAILARAS ",
  "GOVERNMENT COLLEGE MEHANDWANI",
  "GURUKUL INSTITUTE OF SOFTWARE TECHNOLOGY",
  "UMARVIND COLLEGE ",
  "PRATHVI COLLEGE OF PHARMACY",
  "SYNA INTERNATIONAL COLLEGE OF MANAGEMENT STUDIES",
  "MEGA BYTE COMPUTER ACADEMY DEWAS",
  "VIDHYADEVI MAHAVIDHALAYA",
  "VEDIC PHARMACY COLLEGE",
  "MEDIA COMPUTER EDUCATION GANJBASODA",
  "Govt College Gunour",
  "GOVERNMENT COLLEGE, SARAI",
  "KEWALSHREE INSTITUTE OF MANAGEMENT",
  "DIGDARSHIKA TRAINING COLLEGE BHOPAL",
  "SHRI SAI COLLEGE, SIDHI",
  "SHREE INSTITUTE OF PROFESSIONAL STUDIES",
  "MCS- MAHAN COMPUTER SERVICE MANDLA",
  "SHRI SWAMI SAMARTH COLLEGE OF NURSING AND PARAMEDICAL SCIENCES, HARDA",
  "MICROTECH COMPUTER INSTITUTE OF TECHNOLOGY SIRONJ",
  "GURUKUL COLLEGE FOR EXCELLENCE",
  "ANANTA COMPUTER ACADEMY",
  "GURUKRIPA COLLEGE OF MANAGEMENT",
  "Lord Krishna College of Technology, Bhesalay Rau,  Pithampur Road Near, IIM, Infront of Steel Tubes India, Indore",
  "Technocrats Institute of Technology (Pharmacy), Anand Nagar, Infront of Hathaikheda Dam, B.H.E.L., Bhopal",
  "GYANSAGAR ACADEMY",
  "MASTERMIND COMPUTER INSTITUTE OF INFORMATION TECNOLOGY ",
  "GOVERNMENT LAW COLLEGE NARMADAPURAM ",
  "MAA SHANTA DEVI COLLEGE OF MANAGEMENT BETUL",
  "SENDHWA ANIMAL HUSBANDRY DIPLOMA COLLEGE",
  "Shaheed Bhagat Singh Government Degree College, Ashta",
  "Govt. College, Bareli, Raisen",
  "NATIONAL FORENSIC SCIENCES UNIVERSITY, BHOPAL CAMPUS",
  "GOVT COLLEGE OF NURSING, CRP LINE, INDORE",
  "GOVT POLYTECHNIC COLLEGE SENDHWA",
  "Sunries College of Excellence, Vidisha",
  "COLLEGE OF LAW IPS ACADEMY INDORE ",
  "Indore Institute of Science & Technology,  Village Dehri, Opp IIM, Pithampur Road, Indore  453 331",
  "PENTIUM POINT COLLEGE OF PHARMACY",
  "Shanti College of Pharmacy Datia Madhya Pradesh",
  "IPS Academy, Institute of Business Management and Research, Indore",
  "MICROSYS INSTITUTE OF COMPUTER TECHNOLOGY UMARIA",
  "Shri Ram Pharmacy College, Jamthi, Betul",
  "Jawaharlal Nehru College, 56-C Civil Lines Shyamla Hills, Bhopal",
  "IPS College of Technology & Management, Shivpuri Link Road, Near Bela Ki Bawadi Tiraha, Gwalior",
  "VIKRAMADITYA ACADEMY",
  "MICROTECH COMPUTER ACADEMY",
  "MIC INSTITUTE OF COMMUNICATION HOSHANGABAD",
  "Govt. College, Ghairatganj, Raisen",
  "GOVERNMENT LAW COLLEGE SEHORE",
  "PRATAP COLLEGE",
  "RAGHUKUL COLLEGE OF PHARMACY BHOPAL",
  "MODAK INSTITUTE OF COMPUTER & MANAGEMENT KHARGONE",
  "MISSION INFORMATION COMMUNICATION",
  "College of Agriculture, Powarkheda",
  "EKTA COLLEGE",
  "Mittal Institute of Technology, Ward No. 66, Opposite Bhopal Memorial Hospital, Navi Bagh, Bhopal - 462038",
  "TECHNOCRAT INSTITUTE OF PROFESSIONAL STUDIES, TIPS    ",
  "Raja Balwant Singh College, Rajnagar",
  "SARDAR VALLABH BHAI PATEL MAHAVIDYALAYA",
  "PLANET IT SPOT    ",
  "Maharaja Bhoj Govt. P.G.Autonomous College,Dhar",
  "GOVT. DEGREE COLLEGE PUSHPRAJGARH DISTT. SHAHDOL (M.P.)",
  "MICROSYS INSTITUTE OF COMPUTER EDUCATION BHOPAL",
  "Laxman Seth Pharmacy College",
  "NARMADA MEDIA AND COMPUTERS ACADEMY JABALPUR",
  "N.A.S. INSTITUTE OF PROFESSIONAL STUDIES PORSA",
  "JAI SHRI KRISHNA COLLEGE",
  "SWAMI SRI RAMKRISHNA PARAMHANSA COLLEGE, MORENA",
  "GEETA VERMA INSTITUTE OF TECHNOLOGY CHHINDWARA",
  "GOVERNMENT COLLEGE KOTHI SATNA MADHYA PRADESH    ",
  "Rajeev Gandhi College, Trilanga Colony, E-8 Shahpura, Bhopal",
  "PATEL MAHAVIDYALYA, GORMI",
  "VIDHYASHREE COLLEGE FOR HIGHER EDUCATION",
  "COLLEGE OF HORTICULTURE, CHHINDWARA",
  "MLC Govt. Girls P.G. College Khandwa",
  "SRI AUROBINDO INSTITUTE OF JOURNALISM AND MASS COMMUNICATION",
  "Saphalta Commerce  Computer Classes",
  "GOVERNMENT COLLEGE KHADDI DISTRICT SIDHI MP    ",
  "GOVERNMENT COLLEGE MADWAS DISTRICT SIDHI MP    ",
  "GEETA  JYOTI  B  ED  COLLEGE  KITWARIYA  REWA   M P         ",
  "Adarsh Shiksha Mahavidyalaya",
  "Ekta Mahavidyalaya",
  "LATE K L PANDEY SCHOOL OF PHARMACY",
  "GURUKUL COLLEGE OF EDUCATION",
  "Shri Atal Bihari Vajpayee Goverment Arts and Commerce College, Indore",
  "KRISHNA MAHAVIDYALAYA MANGAWAN REWA",
  "SARSWATI COLLEGE BAHMAHNI KOTHI MAIHAR SATNA MP",
  "Bonnie foi College, Narela Shankari, By-pass Road, Ayodhya Nagar, Bhopal",
  "GOVT.MAHRISHI ARVIND  DEGREE COLLEGE, GOHAD",
  "AASTHA ACADEMY AND SCIENCES",
  "Shashib College of Science & Management, Parvaliya Sadak, Jaipur Road, 69 National Highway, Bhopal",
  "RAJIV GANDHI MEMORIAL COLLEGE BARODA",
  "CHAUDHARY RUSTAM SINGH GROUP OF COLLEGE, DIRDI",
  "Abhilasha College of Education, Bhopal",
  "ASHOKA D S ",
  "COLLEGE OF DESIGN AND TECHNOLOGY",
  "NEOTECH INSTITUTE OF MANAGEMENT STUDIES",
  "SKI-HI Institute of Education",
  "ARYA BHATT COLLEGE OF TECHNOLOGY, UDAIPURA",
  "GOVT. P.G. COLLEGE SHEOPUR KALAN",
  "MAA SARDA COLLEGE, SELWANI",
  "Govt. College, Narshingarh, Rajgarh",
  "Govt. Girls College, Raisen",
  "SAMRAT ASHOK COLLEGE OF PROFESSIONAL STUDIES, SEHORE",
  "CHIRAYU COLLEGE OF NURSING",
  "Shaheed Bhagat Singh Mahavidyalaya, Shamshabad, Vidisha",
  "Shri Ambika Adrash College, Sardar Patelnagar, Badnawar",
  "SAINATH INSTITUTE OF EDUCATION",
  "University Polytechnic, RGPV",
  "PENTIUM POINT COLLEGE OF MANAGEMENT",
  "SHWAMI VIVEKANAND INSTITUTE OF MANAGMENT SHAHDOL MP",
  "S.V.N. COLLEGE CHHATARPUR",
  "S S COLLEGE BHOPAL",
  "Swami Vivekanand Govt. College, Sleemnabad",
  "SAMARPIT COMPUTER INSTITUTE OF TECHNOLOGY BARELI",
  "CHAMBAL VANSTHALI SHIKSHA MAHAVIDHALAY, PORSA, MORENA",
  "SAMMYAK COMPUTER EDUCATION SHUJALPUR",
  "POORNAYU AYURVED CHIKITSALAYA EVAM ANUSANDHAN VIDYAPEETH",
  "VEER B.ED COLLEGE",
  "Institute of Pharmacy",
  "College of Engineering",
  "\"Ujjain Engineering College, Sanwer Road, Ujjain",
  "Vaishnavi Institute of Technology and Science, Village-Deepadi,P.O. Misrod,Bhopal",
  "Swami Vivekanand College of Prof. Studies, H.N.15, Near Bhopal Naka, Sehore",
  "AMALTAS INSITUTE OF HOMOEOPATHY HOSPITAL AND RESEARCH CENTER ",
  "Keshav Institute 8255 shivpuri",
  "ROYAL INSTITUTE OF IT & MANAGEMENT GWALIOR",
  "TIT MBA",
  "Sagar Institute of Pharmacy and Technology, Near Airport, Raipur Road, Gandhi Nagar, Bhopal 462036",
  "CHAMELI DEVI INSTITUTE OF PHARMACY",
  "CHRIST COLLEGE",
  "Silver Lining",
  "Govt. College, Shamshabad, Vidisha",
  "Daksh Institute of Pharmaceutical Science, Near Vrandavanpuram, Nayapura Road, Chhatarpur",
  "Vindhya Institute of Technology & Science, Karhi Road, Amoudha, Satna-485441",
  "KARAHAL EDUCATION COLLEGE",
  "Keshav Institute 8253 Narwar",
  "MAT INSTITUTE SATANWADA SHIVPURI",
  "MATA SEETA DEVI COMPUTER CENTER, CHHATARPUR",
  "MAYO COLLEGE OF NURSING",
  "SET EDUCATION",
  "KALPTARU COMPUTER INDORE",
  "RITS",
  "Govt. Ayurveda College, Gorakhpur, Jabalpur",
  "NEA COMPUTER CENTER HARDA",
  "GOVT V R S COLLEGE, BHANDER",
  "SIPER LAHAR",
  "OM COMPUTER ",
  "MAHARANA PRATAP COLLEGE OF MANAGEMENT",
  "IPS Institute",
  "VIDYA VAHINI SHIKSHA MAHAVIDYALAY",
  "Rahat College of Nursing, Khargone",
  "SWAMI DAYANAND SARASWATI SHIKSHA MAHAVIDHYALAYA",
  "SUYASH COMPUTER EDUCATION DHAMNOD",
  "IPS ACADEMY",
  "GOVERNMENT COLLEGE VENKATNAGAR",
  "ACTI COMPUTER SAGAR",
  "IIPS INFOTECH",
  "Maa Sharda Devi Mahavidyalay",
  "Shri Vyankatesh Education Academy",
  "Shyamlal Pandviya Government Post Graduate College Morar, Gwalior (M.P.) ",
  "HARI SINGH RUPRAH ARTS COMMERCE  AND LAW COLLEGE",
  "ARYAVART COLLEGE OF PARAMEDICAL SCIENCES SEONI",
  "MAHAVEER PHARMACY COLLEGE",
  "ORIENTAL INSTITUTE OF NURSING LALBURRA",
  "SHASKIYA ADARSH MAHAVIDYALAYA DINDORI",
  "GOVT COLLEGE AMARPUR DINDORI",
  "GOVERNMENT  COLLEGE CHANDIA",
  "GOVT COLLEGE KESHWAHI",
  "HITKARINI COLLEGE OF PHARMACY",
  "GOVERNMENT COLLEGE MADA",
  "ANIMAL BIOTECHNOLOGY CENTRE NDVSU JABALPUR",
  "YOGESHWAR NURSING SHIKSHA MAHAVIDHYALAYA",
  "KRISHNA KANISHK COMPUTER CENTER",
  "PIONEER COLLEGE OF PARAMEDICAL SCIENCES MANDLA",
  "MAA GIRJA DEVI COLLEGE",
  "GOVT COLLEGE  RAJMILAN",
  "GOVERNMENT COLLEGE BERGAWAN",
  "sundaram college of professionol studies Jawar",
  "P D S TEACHERS TRAINING INSTITUTE",
  "scholars home college bus stand satna",
  "GOVERNMENT THAKUR SOMESHWAR SINGH COLLEGE, NAIGARHI",
  "Patel College of Science & Technology, Sheri Gram Ralamandal, Indore",
  "S.D.P.S. Womens College, Khandwa Road,  Indore",
  "Lakshmi Narain College of Pharmacy",
  "Sagar Institute of Research & Technology Pharmacy, Ayodhya By Pass Road, Near Sagar Estate, Bhopal-462041",
  "COLLEGE OF NURSING, PADHAR HOSPITAL",
  "VAISHNAVI INSTITUTE OF COMPUTER EDUCATION ",
  "SHIV COMPUTER INSTITUTE",
  "G K COMPUTERS",
  "Govt. Mahaveer College, Petlawad",
  "GIT COMPUTERS",
  "ANAND VIHAR COLLEGE FOR WOMEN",
  "SAMARPAN COLLEGE OF NURSING",
  "FACULTY OF ARCHITECTURE",
  "SARDAR PATEL SCHOOL OF NURSING MANDLA",
  "DR. C P TIWARI SMTRITI COLLAGE AMJHOR",
  "Oriental College of  Management Raisen Road, Bhopal",
  "RADHAKRISHNA NURSING COLLEGE",
  "CHOITHRAM INSTITUTE OF HEALTH SCIENCES",
  "Vikram Institute of Management and science",
  " MAHATMA GANDHI COLLEGE OF EXCELLENCE",
  "VIDHYAPEETH INSTITUTE OF PHARMACY",
  "Swamideen  Mahavidhyalay ",
  "MADHVIRAJE NURSING MAHAVIDYALAYA",
  "JB INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "GOVERNMENT MODEL COLLEGE CHHATARPUR",
  "VEDICA COLLEGE OF B.PHARMACY",
  "Govt. Aranya Bharti PG College, Baihar",
  "Swarg Mandir Girls College, Mhow",
  "Shri Janki Sanskrit College, Puranilanka, Chitrakoot, Satna",
  "Pt T P Shukla Graduate College, Venkatnagar",
  "IPS Academy, Rajendra Nagar,  Indore",
  "OMKAR COLLEGE OF NURSING",
  "PANDIT RAMSHANKAR BANNI LAL PATHAK SHASKIYA MAHAVIDYALAYA, BARELA, JABALPUR",
  "RAVINDRA NATH TAGORE INSTITUTE OF SCIENCE AND PROFESSIONAL STUDIES, MORGHADI",
  "GOVERNMENT COLLEGE, BARGI",
  "AARAV DIKSHA SHIKSHAN SANSTHAN",
  "SRI S R EDUCATION COLLEGE, NEWADA",
  "NETWAVES INSTITUTE OF COMPUTER EDUCATION BHOPAL",
  "UNIVERSITY INSTITUTE OF TECHNOLOGY, RGPV, SHAHDOL",
  "GOVERNMENT COLLEGE, BHANPURA",
  "SUNRISE  INSTITUTE OF COMPUTER EDUCATION",
  "SCI COMPUTER",
  "NEW HI-TECH COMPUTER CENTRE BARELI",
  "Mata Gujri College of Professional Studies Indore ",
  "PUSHPDEEP GIRLS COLLEGE, KHATEGAON",
  "R N KAPOOR MEMORIAL AYURVEDIC MEDICAL COLLEGE AND HOSPITAL, INDORE",
  "MASTER MIND GIRLS COLLEGE, MAKDON",
  "DR SHANKAR DAYAL SHARMA AYURVED COLLEGE ",
  "NEO-TECH COMPUTER INSTITUTE PIPARIYA",
  "JAI NARAYAN COLLEGE OF PARAMEDICAL",
  "NEW CIFINET INSTITUTE OF PROFESINOL STUDEY",
  "GOVT. GIRLS COLLEGE CHACHORA , BEENAGANG",
  "UNIQUE SKILLS ACADEMY OF IT EDUCATION",
  "APS INSTITUTE OF TECHNOLOGY, CHURHAT",
  "Career Computer",
  "MATHURADEVI INSTITUTE OF PHARMACY ",
  "NAVANKUR COMPUTER SIRONJ",
  "SAD GURU COLLEGE OF EDUCATION ",
  "NICE INSTITUTE OF COMPUTER EDUCATION , MANDLA",
  "VDS COMPUTER EDUCATION",
  "NICT COMPUTER ACADEMY SINGRAULI",
  "NICTEC INSTITUTE OF COMPUTER AND EXCELLENCE",
  "NICE COMPUTER EDUCATION",
  "NIS UJJAIN",
  "Govt Virangana Avantibai Lodhi Girls College, Tikamgarh MP",
  "NICE COMPUTER EDUCATION",
  "MALWA INSTITUTE OF PROFESSIONAL STUDIES",
  "NPCC COMPUTER INSTITUTE ",
  "SUN GROUP OF INSTITUTE",
  "NICTEC INSTITUTE OF COMPUTER AND EXCELLENCE",
  "ORBIT INSTITUTE OF COMPUTER SCIENCE UJJAIN",
  "PANNA INSTITUTE OF COMPUTER SCIENCE PANNA",
  "APS INSTITUTE OF TECHNOLOGY",
  "VIDHYA DEVI COMPUTER EDUCATION",
  "GOVERNMENT COLLEGE GADASARAI",
  "government college of teacher education chhatarpur",
  "DHARM RAJESHWAR MAHAVIDYALAY BELA",
  "VEE ACADEMY ",
  "Govt.college",
  "Keshav Mahavidhyalaya",
  "SENDHWA INSTITUTE OF NURSING",
  "Gyanodaya Institute of Professional Studies",
  "VINDHYA SHIKSHA SAMITI COLLEGE",
  "SARDAR PATEL SHIKSHA MAHAVIDYALAYA BIGNODIPURA",
  "Shri Krishna Shiksha Mahavidhyalya Chhatarpur ",
  "Shri Ram Sanskrit College, Chitrakoot, Satna",
  "SHIVOM COMPUTER EDUCATION",
  "SUBHASH CHANDRA BOSS COLLEGE GOVINDPURI",
  "THE VITS POLYTECHNIC, SATNA",
  "Swayam Shri Institute of Paramedical Technology, Balaghat",
  "ASTHA COLLEGE OF EDUCATION KULAITH GWALIOR",
  "Government Abhyananda Sanskrit College, Kalyanpur",
  "UNIVERSAL INSTITUTE OF TECHNOLOGY BALAGHAT",
  "GANDHI INSTITUTION OF SOFTWARE TECHNOLOGY",
  "CAPITAL COMPUTER IT AND SCIENCE CHHATARPUR",
  "BADAL BHOI COMPUTER",
  "S.D.P.S. College of Nursing, Khandwa Road, Indore",
  "ANANT INSTITUTE OF MANAGEMENT STUDIES",
  "P.C.S.T. COMPUTERS AMLA",
  "SANT HIRDARAM INSTITUTE OF MANAGEMENT FOR WOMEN ",
  "SARASWATI COLLEGE, PADARIYA",
  "SUNDER NATH MAHAVIDYALYA, JHAKRI, GOHAD",
  "SHRI RAM COLL OF INFORMATION TECHNOLOGY, BANMORE",
  "MARUTI COMPUTER ACEDEMY BIAORA",
  "MRITAYUNJAY NURSING COLLEGE",
  "KS PARAMEDICAL COLLEGE",
  "GOVERNMENT COLLEGE RAJNAGAR ",
  "GYANODAYA INSTITUTE OF PHARMACY",
  "MAULANA AZAD B.Ed. COLLEGE, GULABGANJ, VIDISHA",
  "SHRI SHANTI NIKETAN MAHAVIDYALAYA ",
  "MAHARANA PRATAP INSTITUTE OF COMPUTER TECHNOLOGY",
  "CHOUHAN COLLEGE OF EDUCATION, BHOPAL",
  "Government Shyam Sunder Narayan Mushran Women's College, Narsinghpur",
  "College of Agricultural Engineering, Jabalpur",
  "chhindwara computer information technology",
  "K.C.SHARMA TECHNICAL TRANING INSTITUTE MUNGAOLI",
  "TATA INSTITUTE OF TECHNOLOGY AND SCIENCE ANUPPUR MP",
  "Surprabha Sangeet Mahavidhyalaya, jabalpur",
  "Sharda Vihar Shiksha College",
  "PITAMBARA COLLEGE OF EDUCATION",
  "Shri Ram Institute of Pharmacy, Near I.T.I, Madhotal, Jabalpur",
  "M M COLLEGE OF PHYSIO THERAPY AND PARAMEDICAL SCIENCES, Jabalpur",
  "Ojaswini Nursing College Sagar",
  "NAGAJI INSTITUTE OF EDUCATION SITHOLI",
  "Choithram College Of Nursing",
  "Govt College Barod",
  "Govt. Narmada College, Hoshangabad",
  "AIM COMPUTER EDUCATION CENTER",
  "CHHATRAPATI SHIVAJI SCIENCE COLLEGE BISNOOR",
  "Goverment Medical College, Shivpuri",
  "AGRABHAN INSTITUTE OF EXCELLENCE",
  "VB COMPUTER EDUCATION ",
  "P.M.B. Gujarati Arts College, Indore",
  "Smriti College of Pharmaceutical Education, 4/1, Pipliya Kumar Kakkad, Mayakhedi Road, Indore-452010",
  "UNIQUE COMPUTERS",
  "ABHIRUCHI LALIT KALA AkADAMI",
  "SHRI DAYARAM SIKSHA MAHAVIDHYALAY, SEMARIYA, REWA",
  "MIMT LAW COLLEGE NARSINGHPUR",
  "Govt. Nirbhay Singh Patel New Science College,  Holkar  College Campus, Indore",
  "S R DEGREE COLLEGE",
  "CHOUDHARY RAMCHARAN LAL SAHU NURSING INSTITUTE",
  "DR AMBEDKAR INSTITUTE OF NURSING BINA SAGAR MP",
  "Safe Institution of Nursing College ",
  "Government Fine Arts College Dhar",
  "Jain Institute, Salupura, Piproli-Shivpuri Link Road, Gwalior",
  "VENKATSWAR B ED COLLEGE, Jabalpur",
  "SHRI HARI INSTITUTE OF COMPUTER EDUCATION BARI",
  "SHRI SAIBABA SHIKSHAN PRASHIKSHAN SANSTHAN",
  "Govt. Maharani LaxmiBai Girls P.G. College, Fort, Indore",
  "Microtech Institute of Computer and I. T. Chakghat Rewa",
  "Sagar Institute of Research & Technology-Excellence",
  "Govt. College Shahganj, Sehore",
  "A C M COLLEGE OF EDUCATION, SEONI",
  "CHOUDHARY SHIKSHA MAHAVIDHYALAYA",
  "HINDUPAT INSTITUTE OF PHARMACY RAGHOGARH",
  "BRD COLLEGE OF PHARMACY",
  "BONANZA COLLEGE OF EDUCATION",
  "CHETANA COLLEGE OF PHARMACY",
  "LORD COLLEGE OF EDUCATION ",
  "S.D.A.M. COLLEGE SEONI MALWA",
  "INFOTECH IT ACADEMY",
  "CAREER INSTITUTE OF COMPUTER EDUCATION AMLA",
  "Maruti College of Education, Satna",
  "MICROTECH INSTITUTE OF COMPUTER TECHNOLOGY SHAHPURA",
  "BETWANCHAL COLLEGE OF PHARMACY",
  "ACADEMY OF JOURNALISM & BROADCAST COMMUNICATION-7342",
  "Shri Ram Nath Sigh Institute of Pharmaceutical Science, Near Railway Station, Setholy, Gwalior",
  "GYANSHREE COMPUTER ACADEMY",
  "GALAV RISHI INSTITUTE OF EDUCATION IKHARA",
  "AISECT COMPUTER EDUCATION CENTRE, HOSHANGABAD",
  "JAIN COMPUTERS",
  "Pranav Institute of Pharmaceutical Sciences and  Research,  Jhansi Road, Sitholi, Gwalior",
  "SHRESHTH COMPUTER CENTER GADASARAI",
  "GOVT LAW COLLEGE, RAJGARH ",
  "Indira Priya Darshani College, Shahjhanabad, Bhopal",
  "Jai Hind Defence College, Ayadhya Nagar, Bypass Road, Bhopal",
  "GOVT. P. G .COLLEGE AMARPATAN, DISTRICT SATNA (M.P.)",
  "Sri S R Tiwari College of Education, Nevar, Neemuch",
  "IDEAS INSTITUTE OF TEACHERS EDUCATION ",
  "EURASIAN INSTITUTE OF MANAGEMENT",
  "VARDHMAN B ED COLLEGE, Katni",
  "Altius Institute of Universal Studies - Indore",
  "Narmada Institute of Nursing Science",
  "SHIVAM COLLEGE PORSA",
  "N A S INTERNATIONAL SCHOOL, PORSA ",
  "Rajmata Vijayraje Scindhia Govt. Girls P.G College,  Vidisha (M.P)",
  "Artemisia College of Fine Arts and Animation",
  "VIJAYA RAJE GOVERNMENT GIRLS POST GRADUATE COLLEGE MORAR",
  "rahini college of art and design",
  "BCIT COMPUTER EDUCATION",
  "Govt. College, Dhamnod",
  "Government Music And Fine Arts College Khandwa",
  "Shri Dwarika Prasad Yadav College, Sironj, Vidisha",
  "YOGESHWAR ACEDEMY",
  "Gyandeep Institute of Computer and Technology",
  "shaheed bhagat singh college vidisha",
  "NIMAR INSTITUTE OF INFORMATION TECHNOLOGY & SCIENCE , KHARGONE",
  "SWAMI VIVEKANAND COLLEGE AMBAH",
  "SHREE RAMRAJA SHIKSHA MAHAVIDHYALAY",
  "RAGINI KALA AVAM SANGEET MAHAVIDYALAYA",
  "SHRI RAMA UNIQUE INSTITUTE OF COMPUTER AND MANAGEMENT",
  "SICT SECURE INSTITUTE OF COMPUTER TECHNOLOGY",
  "SICT COMPUTER ACADEMY",
  "MODREN INSTITUTE OF COMPUTER AND TECHNOLOGY ASHOK NAGAR",
  "SHREE GURUJI INSTITUTE OF INFORMATION TECHNOLOGY MANAWAR",
  "Mittal Institite of Education, Bhopal",
  "MAS COMPUTER EDUCATION",
  "mekalsuta institute of computer technology dindori",
  "GWALIOR LAW COLLEGE MORAR",
  "VIJAYARAJE INSTITUTE  OF SCIENCE & MANAGEMENT",
  "BADERIA GLOBAL INSTITUTE OF ENGINEERING AND MANAGEMENT, JABALPUR (M.P)",
  "Astha College of Education",
  "SUN INSTITUTE OF TEACHER EDUCATION CHETAKPURI",
  "SHRI GANESH SHANKAR COLLEGE , VIJAYPUR",
  "PARAGON COMPUTER CENTER",
  "RAJEEV GANDHI INSTITUTE OF COMPUTER TECHNOLOGY SINGRAULI",
  "ROYAL INSTITUTE OF COMPUTER TECHNOLOGY",
  "SARDAR VINAYAK COMPUTER ACADMEY",
  "SRAJAN MAHAVIDHYALAYA",
  "NAADYOG GURUKUL",
  "SHRI SANTI KISHOR EDUCATION COLLGE",
  "DR AMBEDKAR MAHAVIDHLAYA",
  "Madhusudan College,Javi, Neemuch",
  "BHAGWANT RAO MANDALOI, COLLEGE OF AGRICULTURE, KHANDWA",
  "R A K COLLEGE OF AGRICULTURE, SEHORE",
  "COLLEGE OF AGRICULTURE, INDORE",
  "COLLEGE OF AGRICULTURE, GWALIOR",
  "RISHISHWAR COLLEGE , PHOOF",
  "ARYAN COLLEGE OF EDUCATION SINDEY KI CHHAVNI",
  "MGM COLLEGE",
  "SWAMI VIVEKANAND SHIKSHA MAHAVIDYALYA, AMBAH",
  "MAHARAJA MANSINGH COLLEGE",
  "NACHIKETA COLLEGE OF BUSINESS STUDIES",
  "GOVT LAW COLLEGE, TIKAMGARH",
  "SWAMI PRAGYANAND EDUCATION COLLEGE, KATANGI",
  "GOVERNMENT COLLEGE REHTI",
  "SHIVAJI SHIKSHA MAHAVIDYALAYA  GAYATRI NAGAR REWA",
  "Dr APJ Abdul Kalam UIT Jhabua",
  "ALPHA INSTITUTE SEHORE",
  "AWADH  MADHAV COLLEGE OF PHARMACY",
  "SWAMI VIVEKANAND COLLEGE JOURA MORENA",
  "SPS ACADEMY",
  "VEENAVADHNI TEACHER TRAINING INSTITUTE JIWAJI GUNJ",
  "SNEHIL INSTITUTE OF COMPUTER TECHNOLOGY BAJAG",
  "NITYA INSTITUTE OF COMPUTER TECHNOLOGY MEHADWANI",
  "JAI SHRI RAM EDUCATION COLLEGE",
  "CPS COLLEGE BADAGAON",
  "ROSHANLAL DAIPURIA COLLGE SURPURA",
  "GOVT. GANDHI DEGREE COLLEGE BALAJI MIHONA",
  "SOFTPOINT institute of professional studies",
  "SARAIYA COMPUTERS TENDUKHEDA",
  "MICT COMPUTERS ACADEMY OF COMPUTER ",
  "PANDIT DEENDAYAL MAHAVIDYALYA, LADAMPURA",
  "MAHARISHI VAIDVYASH EDUCATION COLLEGE JANGIPUR",
  "NOBEL CAREER ACADEMY",
  "MILLENNIUM COLLEGE OF  EXCELLENCE",
  "ARCHANA MUSIC AND ART COLLEGE GWALIOR    ",
  "MATA PRASAD TIWARI BED COLLEGE",
  "JATAHANKAR PARAMEDICAL INSTITUTE",
  "SIDDHARTH INSTITUTE OF INFORMATION TECHNOLOGY DHANPURI",
  "ARTISTS COMBINE INSTITUTE OF PERFORMING ARTS",
  "SHRI CHAITANYA COLLEGE OF NURSING SCIENCE",
  "Govt. Chandra Vijay College, Dindori",
  "Amar Veerangana Rani Durgavati Shaskiya Mahavidyalaya Tendukheda",
  "GOVERNMENT MEDICAL COLLEGE KHANDWA ",
  "INDORE MAHAVIDYALAYA",
  "Raja Ramanna Centre for Advanced Technology (RRCAT),Indore",
  "GOVT COLLEGE SAIKHEDA  ",
  "Anand Institute Of Management (MBA)",
  "PRIYADARSHINI INSTITUTE OF PARAMEDICAL SCIENCE BALAGHAT",
  "MICROSYS INSTITUTE OF COMPUTER TECHNOLOGY AMARPUR",
  "SMT RUKHMINIBEN DEEPCHAND BHAI GARDI, NTC, INDORE",
  "D.N. Jain College, Jabalpur",
  "SUBHISHI INSTITUTE OF PARAMEDICAL SCIENCES  KHARGONE  MADHYA PRADESH",
  "OJASWINI PHARMACY COLLEGE SAGAR",
  "GOVT COLLEGE KURAI",
  "SD COLLEGE OF PHARMACY ",
  "SAI COMPUTER COLLEGE NAIGARHI",
  "Media Tech Educational Society",
  "Govt.College,Batiyagargh",
  " Bright Career Institute Of Computer Narsinghpur",
  "GOVT COLLEGE OF NURSING UJJAIN",
  "MICROLINE COMPUTER",
  "VIDHIK INSTITUTE OF MANAGEMENT",
  "vision computer centre",
  "SHIVA COLLEGE OF EDUCATION, INDORE ",
  "VIVEKANAND COMPUTER ACADEMY",
  "PANDIT RAMKISHORE SHUKLA  SMRITI  GOVT. ARTS AND COMMERCE COLLEGE, BEOHARI DISTT. SHAHDOL",
  "KEWAL SHREE INSTITUTE OF NURSING INDORE",
  "ANANTAM COLLEGE OF SCIENCE AND MANAGEMENT",
  "THE PRESTIGE INSTITUTE OF PROFESSIONAL STUDIES ",
  "Mahatma Gandhi Vidyapeeth",
  "KUSUMBAI JAIN GIRLS COLLEGE, BHIND",
  "GOVT. GIRLS COLLEGE, MORENA",
  "BABULAL TARABAI INSTITUTE OF NURSING SCIENCES",
  "Rajvaidya Excellence ITC",
  "SCHOOL OF NURSING MAIN HOSPITAL DATIA",
  "Rani Durgawati  Government Post Graduate. College, Mandla, M.P.",
  "GRAFIX COMPUTER EDUCATION GUNA",
  "NRI INSTITUTE OF NURSING BHOPAL",
  "VEDICA INSTITUTE OF TECHNOLOGY",
  "GOVT COLLEGE JHIRNIYA",
  "Institute of Technology and Management,  Opp Sitholi Railway Station NH 75, Jhansi Road, Gwalior 474001",
  "GOVT COLLEGE BHAGWANPURA",
  "TRUBA INSTITUTE OF SCIENCE AND COMMERCE",
  "S.R. College, of Education Chhatarpur",
  "CHARAK INSTITUTE OF EDUCATION - MANDLESHWAR",
  "Maharshi Dyanand College of Education, Maharajpur,",
  "Swami Pranvanand  Degree College, Dumra",
  "SWAMI VIVEKANAND INSTITUTE OF TECHNOLOGY MANASA",
  "Acropolis Institute of Pharmaceutical Education & Research, Khasra No. 283/3, Indore Bypass Road, Near manglya Square, Indore",
  "Bala jee Coll. Nowgaon",
  "RADHE SHYAM PARAMEDICAL COLLEGE",
  "VIKRANT INSTITUTE OF PHARMACY AND SCIENCE INDORE",
  "MAHATMA GANDHI COMPUTER INSTITUTE",
  "GOVT POLYTECHNIC COLLEGE PAWAI",
  "GOVERNMENT COLLEGE, BILASPUR",
  "Government College Nateran",
  "SHRI HARI COLLEGE OF MANAGEMANT AND SCIENCE DEORI",
  "College of Teacher Education, Bhopal",
  "GOVERNMENT COLLEGE, BHAREWA",
  "Jabalpur Public College, Jabalpur",
  "TIT COMPUTER INSTITUTE KURWAI",
  "INTITUTE OF INFORMATION &  PROF.STUDIES",
  "Navyug Arts & Commerce College, Near Civil Line Thana, Jabalpur",
  "Govt. College, Kasrawad",
  "Govt. College, Mandleshwar",
  "TECHNOCRATS INSTITUTE OF LAW ",
  "GWALIOR COLLEGE OF EDUCATION, GRAM BARAUA NURABAD GWALIOR",
  "SECT COLLEGE OF PROFESSIONAL EDUCATION MISROD BHOPAL",
  "Govt. Girls College, Sehore",
  "PARAMEDICAL INSTITUTE JAWAHARLAL NEHRU CANCER HOSPITAL",
  "shri ganesh college of education",
  "OMKAR COLLEGE OF PHARMACY ",
  "AMBIKA INSTITUTE OF PHARMACY",
  "NOBLE INSTITUTE OF COMPUTER EDUCATION DAMOH",
  " JAWAHARLAL NEHRU COLLEGE OF TECHNOLOGY ENGINEERING REWA MP",
  "JAIN COLLEGE OF PHARMACY    ",
  "SIR ATMA RAM INSTITUTE OF PHARMACY AND TECHNOLOGY, MANEGAON    ",
  "SAMPOORNA COMPUTER'S EDUCATIONAL GROUP BHOPAL",
  "AMALA INSTITUTE ",
  "DEVI RUKMANI COLLEGE, KHARGONE",
  "APALA INSTITUTE OF COMPUTER SCIENCE AND TECHNOLOGY",
  "SONY COMPUTER EDUCATION",
  "DRISHTI COMPUTER EDUCATION INSTITUTE",
  "CIIT COLLEGE",
  "AMALTAS INSTITUTE OF NURSING SCIENCES    ",
  "Govt. Kamla Nehru Girls College, Balaghat",
  "GRY INSTITUTE OF PHARMACY, BORWAN, KHARGONE",
  "J B COLLEGE, JOURA",
  "CHAMELI DEVI INSTITUE OF LAW",
  "yes institute of professional studies kham sidhi",
  "Ashasakiya Mahatma Gandhi College Kurawar",
  "College of Veterinary Science and Animal Husbandry Mhow",
  "Govt. Girls College, Khargone",
  "DR A P J ABDUL KALAM COLLEGE OF EDUCATION",
  "Amarjyoti Institute of Nursing and Science, Jabalpur",
  "College of Fishery Science",
  "SHREE OM COLLEGE OF PHARMACY AND RESEARCH",
  "MADHUBAN COLLEGE OF EDUCATION",
  "GOVERNMENT MEDICAL COLLEGE SHEOPUR",
  "MAA PITAMBRA COLLEGE UMMEDGHAD BANSHI MORENA",
  "Madhuban College of Management Barwani",
  "LAXMI BAI SAHUJI INSTITUTE OF MANAGEMENT, PATAN ROAD",
  "MICRO COMPUER    ",
  "NATHURAM INSTITUTE OF EDUCATION AND MANAGEMENT, LADAMPURA, MEHGAON",
  "GOVT LAW COLLEGE KHARGONE",
  "Jawaharlal Nehru Government Degree College, Barwaha",
  "Shri Umiya Girls College, Mandleshwar",
  "S V N COLLEGE PREMPURA HATTA",
  "Shri Raghvendra Singh Hazari Govt Degree College, Hatta",
  "UMIYA KANYA SHIKSHA MAHAVIDYALYA MANDLESHWAR, KHARGONE",
  "Shri Krishna Mahavidyalay raseelpur ",
  "LATE PRATAP NARAYAN SINGH RAJA BHAIYA SHRI JAGESHWAR NATH COLLEGE HINDORIA DIST DAMOH",
  "Krishna Mahavidyalay Hatta ",
  "J L VERMA LAW COLLEGE DAMOH",
  "Guru Ramdas Education College, Damoh",
  "Govt. P.G. College, Damoh",
  "GOVT MODEL COLLEGE DAMOH MP    ",
  "govt college jabera",
  "GOVERNMENT KAMLA NEHRU MAHILA MAHAVIDYALAYA DAMOH (M.P.) ",
  "OJASWINI COLLEGE OF EDUCATION",
  "NEERANCHLAM COLLEGE MANKAHRI",
  "Ojaswani Inst. of Management and Technology, Damoh",
  "VASUDEV EXCELLENCE COLLEGE  ",
  "Thakur Feran Singh Education College Ganeshganj Shahpur",
  "SWAMI VIVEKANAND MAHAVIDHYALAYA AMARMOU SHAHGRH DIST SAGAR",
  "Swami Vivekananda College Deendayal Nagar Sagar",
  "S.V.N. COLLEGE SIRONJA",
  "Shri Sainath Mahavidyalaya",
  "RISHABH ACADEMY, KHURAI",
  "Pt.Deendayal Upadhyay Govt.Arts and Commerce College Sagar",
  "Pearl Academy College of Education Malthone",
  "Noble B.Ed. College Rajakhedi Makroniya,",
  "MAHARANA PRATAP BED COLLEGE ",
  "Mahadeo Coll. Kashle",
  "G I S College, Pathriya Jat Sagar",
  "Dronacharya Academy B.Ed College dhana",
  "IDEAL INSTITUTE OF INFORMATION TECHNOLOGY SEHORE",
  "Dignity college keolari kesli",
  "Infinity Mgt. and Engg. College, Sagar",
  "Govt. P.G. College, Garhakota",
  "GOVT GIRLS COLLEGE BINA",
  "J K COLLEGE OF LAW",
  "MEDICARE NURSING COLLEGE INDORE",
  "Shri Raj Rajendra Jayant Sen Suri College of Education, Ujjain",
  "GURUKUL COLLEGE OF EDUCATION MAUHARIYA",
  "Pragya Arts & Commerce College, Katangi, Jabalpur",
  "HALLMARK COMPUTER SERVICES, RATLAM",
  "SEVA SADAN PRABANDHAN MAHAVIDYALAYA BURHANPUR    ",
  "CSU COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "JAGAT PATHAK PATRAKARITA SANSTHAN,BHOPAL",
  "MSME TECHNOLOGY CENTRE BHOPAL",
  "SEWA BHARTI COMPUTER PRASHIKSHAN KENDRA",
  "JAI NARSINGH COMPUTER INSTITUTE KARELI",
  "LORD KRISHNA COLLEGE OF EDUCATION",
  "GURUDEV SANSHTHAN",
  "R D MEMORIAL COLLEGE OF NURSING INDORE",
  "BKP COLLEGE DEORI     ",
  "R N Kapoor Memorial Homoeopathic Hospital and Medical College ",
  "N S MEMORIAL COLLEGE OF PHARMACY BHANDER DISTT DATIA M P",
  "KUSHABHAU THAKRE LAW COLLEGE",
  "GOVT COLLEGE UMRANALA DIST CHHINDWARA",
  "GOVERNMENT LAW COLLEGE",
  "SHRI VAISHNAV POLYTECHNIC COLLEGE INDORE",
  "AADINATH INSTITUTE OF INFORMATION TECHNOLOGY & MANAGEMENT BARWANI",
  "AMBIKA COLLEGE IKLOD VIJAYPUR SHEOPUR",
  "SWAYAM PRABHA COLLEGE DABOH",
  "GOVT COLLEGE RAJOUDHA MORENA",
  "SHRI RAM COLLEGE OF PHARMACY",
  "SHRI RADHA VALLABH COLLEGE OF EDUCATION",
  "MAHAVEER INSTITUTE OF MEDICAL SCIENCES AND RESEARCH",
  "ADITYA COLLEGE OF MANAGEMENT",
  "GOVERNMENT COLLEGE CHHAPIHEDA DIST RAJGARH",
  "Government College, Narela, Bhopal",
  "SHIVAM COLLEGE OF PHARMACY",
  "NARMADA SHIKSHA COLLEGE, LAXMIPUR",
  "CSU COLLAGE OF PHARMACY",
  "IIC LAW COLLEGE INDORE",
  "SARDAR PATEL COLLEGE OF PHARMACY KHAIRI, MANDLA",
  "ADVANCE INSTITUTE OF TECHNICAL STUDIES UJJAIN",
  "RANI DULLAIYA SMRITI AYURVED PG COLLEGE AND HOSPTIAL  BHOPAL",
  "GURUKUL INSTITUTE OF  MANAGEMENT",
  "BIHARI  COLLEGE",
  "INDRAPRASTH INSTITUTE OF ARTS SCIENCE AND MANAGEMENT, KAILARAS",
  "OM INSTITUTE OF TECHNICAL AND TEACHERS EDUCATION",
  "GOVERNMENT COLLEGE SANWER",
  "NOVEL INSTITUTE OF PHARMACY BHOPAL ",
  "SHRI SWAMI KRUPA COLLEGE OF MANAGMENT  AND NFORMATION TECHNOLOGY ,KHAMARPANI TAH. BICHHWA",
  "Digital college of education kotma",
  "AIMS COLLEGE",
  "ACHARYA NARENDRA DEV COLLEGE , KAILARAS",
  "SIDHI VINYAK EDUCATION COLLEGE",
  "SAINT GIRDHAR COLLEGE VIDISHA",
  "NOBLE",
  "GOVERNMENT COLLEGE VIDISHA",
  "VIDYASAGAR COLLEGE OF PHARMACY",
  "Nachikata College of Computer Science Technology, Jabalpur",
  "Shriniwas Rao N.E.S. College Barman, Narsinghpur",
  "Netaji SubhashChandra Bose Govt. College Biowara, Distt.- Rajgarh (M.P.)",
  "Lakshmi narain College of Pharmacy RCP Indore",
  "mahatmaphule ecucation acadamy",
  "NEA Computer Center",
  "GYANESHWARI EDUCATION COLLEGE, DINDORI",
  "Govt. College, Jobat",
  "Govt. College, Pithampur",
  "ANUSHREE COLLEGE OF NURSING, KASHODHAN NAGAR, MADHOTAL",
  "INDIAN INSTITUTE OF NURSING SCIENCE AND RESEARCH",
  "College of Dental Sciences & Hospital,  Rau, Indore",
  "SSC EDUCATION COLLEGE SEONI",
  "INDORE INTERNATIONAL COLLEGE, SOLSINDA, INDORE",
  "SAIRAM INSTITUTE OF COMPUTER TECHNOLOGY",
  "Govt. College, Khilchipur, Rajgarh",
  "RADHARAMAN INSTITUTE OF NURSING BHOPAL",
  "MAA PITAMBARA INSTITUTE",
  "SUBHASH CHANDRA PARAMEDICAL COLLEGE, Jabalpur",
  "METC CAMPUS",
  "GLOBAL INFORMATION TECHNOLOGY OF INSTITUTE  ",
  "DR. SATYENDRA KUMAR MEMORIAL COLLEGE OF PHARMACY",
  "Rani Dullaiya Nursing College, Berkedi Kalan Sharda Vidy Mandir Bhadbadha Road, Bhopal",
  "NEW ERA COLLEGE VILL KODRIYA TEHSIL  MHOW DIST INDORE M P",
  "Netaji Subhash Chandra Bose Medical College, Jabalpur",
  "Millenium Teachers Training Inst. Nathu Barkheda Road Neelbad, Bhopal",
  "ST GEORGE INSTITUTE OF PHARMACY, DEEWANGANJ",
  "Indore  Nursing College, Pithampur Road Indore",
  "CHOURASIA SHIKSHA MAHAVIDYALAYA, KATANGI, Jabalpur",
  "EXTOL INSTITUTE OF JOURNALISM, BHOPAL",
  "MAHARANI SHIVANGI COLLEGE OF NURSING & SCIENCE RESEARCH  INSTITUTE",
  "VINAYAK COMPUTER ACADEMY",
  "SHRI AGRASEN MAHARAJ SCHOOL OF NURSING",
  "FLY GROUP OF EDUCATION",
  "GOVT POLYTECHNIC COLLEGE BARELI ",
  "SHRI BALAJI COLLEGE CHICHOLI ",
  "Gurukul Institute of Pharmaceutical Science & Research, Gram Odpura, lashkar, Gwalior",
  "Veer Savarkar Govt. College, Obedullahganj, Dist. Raisen",
  "C.V. Raman College of Education, Hoshangabad",
  "Subbhadra Sharma Govt. Girls College, Ganjbasoda Distt. Vidhisha",
  "MADHUBAN COLLEGE OF LAW",
  "Regional Institute of Nursing, Jabalpur",
  "BCST KANAK COMPUTER EDUCATION",
  "SRI AUROBINDO INSTITUTE OF ALLIED HEALTH AND PARAMEDICAL SCIENCES, INDORE",
  "MAHARANA PRATAP SCHOOL OF NURSING BHOPAL",
  "GOVERNMENT COLLEGE RAIGAON ",
  "GOVT. SIKSHA COLLEGE",
  "Shri Ram Institute of Technology (MCA), Near ITI, Madhotal, Jabalpur-482002",
  "SHRI BALAJI SHIKSHA MAHAVIDHYALAYA",
  "State Institute of Science Education, Jabalpur",
  "SANJIVANI COLLEGE OF NURSING TIRLA ",
  "DHAR COLLEGE OF NURSING DHAR",
  "Gyan Ganga College of Excellence,Jabalpur",
  "shree ram college lehchuya ",
  "O F K GOVERNMENT COLLEGE, KHAMARIYA",
  "GOVERNMENT R D COLLEGE OF NURSING",
  "Lakshmi Narain College of Technology, Gram Bhita, Bedaghat Road, Jabalpur",
  "Royal Institute of Management and Advanced Studies, Behind Land Mark Motors, Gram Salakhedi & Kharakhedi, Ratlam - 457001",
  "Truba Institute of Engineering & Information Technology, Karod-Gandhi Nagar By-Pass Road, Bhopal-462036",
  "Government Ramananda Sanskrit College, Lalghati, Bhopal",
  "Govt. Maharani Laxmi Bai Girls PG Autonomous College, Bhopal- 462002",
  "Nav Samvat Vidhi College, Ujjain",
  "Govt. Vikram College, Khachraud",
  "NANDANVAN COLLEGE OF NURSING, Jabalpur",
  "Lokmanya Tilak Science & Commerence College, Ujjain",
  "AADARSH COLLEGE OF BUSINESS MANAGEMENT, DHAR",
  "Govt. Madhav Science College, Ujjain",
  "PRESTIGE INSTITUTE OF MANAGEMENT & RESEARCH, BHOPAL",
  "Future Vision College, Ujjain",
  "Maharaja College of Ujjain, Ujjain",
  "SHAHEED BHAGAT SINGH GOVT. P.G. COLLEGE , PIPARIA (M.P.)",
  "Balkavi Bairagee Education College, Neemuch",
  "Sant Singaji Institute of Science & Management Sandalpur, Dewas",
  "Shri J.N.Law College, Mandsaur",
  "Gyan Mandir College, Neemuch",
  "Seshshayee College of Prof. Studies, Nagda",
  "P.G.V.  COLLEGE",
  "K S HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL GWALIOR",
  "RADHARANI NURSING COLLEGE SHAHDOL",
  "LAW COLLEGE SATNA",
  "ICON COMPUTER EDUCATION SAUSAR",
  "IITM (INSTITUTE OF IT & MANAGEMENT) SABALGARH",
  "INDIRA GANDHI COMPUTER TECHNOLOGY BEOHARI",
  "Swargiya  Nagulal Malviya Govt. College, Ghattiya",
  "Bhartiya College, Madhav Nagar Front Of Railway Station, Ujjain",
  "Mahakal Institute of Management, Ujjain",
  "Govt. College, Kalapipal",
  "Govt.Kalidas Girls College,Ujjain",
  "Govt. S.N.Udia College, Mandsaur",
  "Lokmanya Tilak College of Education, Ujjain",
  "Jain College of Education, Mandsaur",
  "Saraswati Education College, Mandsaur",
  "Mahatma Gandhi Institute of Nursing, Jabalpur",
  "GYANDEEP INSTITUTE OF NURSING SCIENCE",
  "Jabalpur Institute of Nursing Science and Research, Jabalpur",
  "H.C. College, Bhanpura",
  "Safal College, Suswara, Mandsaur",
  "Sandipani Arts & Com. College, Ujjain",
  "Guru Harkishan College of Education, Ratlam.",
  "Jagannath Gomthi Ambavatiya College of Edu.Nalkheda, Shajapur",
  "OMKAR COLLEGE OF PROF. STUDIES",
  "COLLEGE OF LIFE SCIENCE CENTER HOSPITAL AND RESEARCH INSTITUTE",
  "Govt. Arts and Commerce (Naveen) College, Bhopal",
  "MEENAKSHI ACADEMI OF PARAMEDICAL SCIENCES, Jabalpur",
  "B I P M S PARAMEDICAL COLLEGE, Jabalpur",
  "BALASHREE INSTITUTE OF PARAMEDICAL SCIENCES",
  "Govt. College, Khategaon",
  "M.C.C.T.M KATNI ROAD,MAIHAR,SATNA",
  "Prestige Institute of Management, Dewas",
  "Late Shree Saligram Tomar Gov College Polayakalan",
  "Shivajirao Kadam Institute of Pharmaceutical Education and Research Indore",
  "Govt. College, Bagli",
  "B.C.G. Education College, Dewas",
  "Princeton College Udaipura",
  "Govt. College,Nagda",
  "Dayanand Saraswati College, Shajapur",
  "Savita Devi Jaiswal College, Samgarh",
  "Govt College, Tarana",
  "Moulana Azad College of Prof. Studies, Dewas",
  "Shramdham Arts & Commerce College, Kymore",
  "MADHYA BHARAT INSTITUTE OF LEGAL STUDIES GULABGANJ,VIDISHA",
  "Swami Vivekanad Adarsh College, Jabalpur",
  "Priyadarshini Anjuman Islamia Girls College, Moti Nala, Gohalpur, Jabalpur",
  "SCHOOL OF COMPUTER APPLICATION,SRI SATYA SAI UNIVERSITY OF TECHNOLOGY AND MEDICAL SCIENCES,(SSSUTMS)",
  "SCHOOL OF HOTEL MANAGEMENT, SRI SATYA SAI UNIVERSITY OF TECHNOLOGY AND MEDICAL SCIENCES,(SSSUTMS)",
  "FACULTY OF PHARMACY (COLLEGE OF PHARMACY, SRI SATYA SAI UNIVERSITY OF TECHNOLOGY AND MEDICAL SCIENCES, (SSSUTMS))",
  "FACULTY OF PHARMACY(SCHOOL OF PHARMACY,SRI SATYA SAI UNIVERSITY OF TECHNOLOGY AND MEDICAL SCIENCES,(SSSUTMS))",
  "FACULTY OF EDUCATION(SCHOOL OF TEACHERS EDUCATION,SSSUTMS)",
  "SAI COLLEGE OF NURSING AND PARAMEDICAL COLLEGE",
  "SHRI RAM COLLEGE PARSIYA",
  "NIVEDITA BED COLLEGE",
  "ATAL BIHARI VAJPAYEE COLLEGE OF AGRICULTURE KHURAI",
  "OXFORD INTERNATIONAL ANIMAL HUSBANDRY DIPLOMA COLLEGE INDORE",
  "Laxmi Bai Sahu College, Jabalpur",
  "Govt. College, Suwasra",
  "VAISHNAVI INSTITUTE OF MANAGEMENT",
  "SANSKAR INSTITUTE OF PROFESSIONAL  STUDIES",
  "LORD COLLEGE OF STUDIES",
  "AKHIL BHARTI COLLEGE OF PHARMACY",
  "VIDHYAPEETH INSTITUTE OF EDUCATION",
  "MAA PEETAMBRA PEETH COLLEGE LAHAR",
  "KAMAKHYA SHIKSHA BED COLLEGE MAU BHIND",
  "\"Rajeev Gandhi College of Pharmacy, Gram Salaiya, Via Danish Kunj, Kolar Road,  Bhopal  462042\"",
  "DNYANVIHAR SAMAJKARYA MAHAVIDYALAYA ARVI",
  "Dr. M.I. Jamkhanwala Tibbia College & Hospital, Varsova, Andheri, Mumbai",
  "Youth Education & Welfare Society's National Senior College, Nashik, National Campus, Moulana Azad Road, Sarada Circle, Nashik 422001",
  "Aasara Samajik Sanstha Kalyan Sanchalit Arts Commerce and Science Night College",
  "Late  Gyanbaji Keshve  Sr. College, Mahur",
  "DHANESHWARI AYURVED COLLEGE AND RESEARCH INSTITUTE",
  "BHAGINI MANDAL CHOPD'S COLLEGE OF SOCIAL WORK, CHOPDA.",
  "S.R.B Mahila Mahavidyalaya Salekasa, Gondia",
  "Aadarsh Shikshan Prasarak Mandal, K.T. Patil College of Education, Tambri Vibhag, Osmanabad.",
  "Matoshri Subhadrabai Patil Arts and Late Pandurangji Thakare Commerce College, Manora.",
  "College of Engineering & Technology, Akola.",
  "Sadhana College of Commerce English Medium Gadhinglaj Tal Gadhinglaj Dist Kolhapur",
  "TRIMURTI ARTS COMMERCE AND SCIENCE COLLEGE",
  "S.K.B. College of Pharmacy, Gada, Kamptee",
  "SUPRIYA MAHILA  ARTS COMMERCE AND SCIENCE COLLEGE JAFRABAD",
  "FABTECH TECHNICAL CAMPUS, COLLEGE OF ENGINEERING AND RESEARCH,  SANGOLA",
  "Mahatma Gandhi Missions Institute of Physiotherapy, Aurangabad",
  "Shri AmolakJain Vidya Prasarak Mandals College of Pharmaceutical Science and Research Center Kada  ",
  "Sansthamata Sushiladevi Salunkhe Mahila Shikshan Shastra Mahavidyalaya, TASGAON",
  "College of Computer Science & Information Technology, Latur",
  "Central Provincial Arts Commerce and Science Mahila Mahavidyalaya",
  "ASHWAMEDH NIGHT COLLEGE SAVEDI AHMEDNAGAR",
  "Habib Educational & Welfare Society's M.S. College of Arts,Commerce,Science and B M S Mumbra  Dist Thane.",
  "SANT GAJANAN MAHARAJ ARTS AND COMMERCE COLLEGE, PENDHARI MAKTA",
  "LATE SITABAI SHENDE MAHILA MAHAVIDYALAYA, SINDEWAHI",
  "DADASAHEB MOKASHI COLLEGE OF AGRICULTURE, RAJMACHI",
  "THE SHRAMIK VIDHYRATHI DNYANSEVA SANSTHA AMDAR DEEPAKBHAI KESARKAR SCIENCE COLLEGE, SINDHUDURG",
  "Shree BH Govt. Medical College, Chakkar Bardi, Dhule",
  "Navasanjeevan Shikshan Prasarak Mandals Smt. Sumitrabai Thakare Training College of Nursing (B.Sc.), Darwha Road, Yavatmal, Dist. Yavatmal",
  "Ahmednagar Homoeopathy College, Ahmednagar",
  "Dr. Ghali College, GADHINGLAJ",
  "Vasudeo Gavade Education and Charitable Trust Ideal Institute of Management, Kondigre, Gat",
  "Venutai Chavan College, Vidyanagar, KARAD",
  "Smt. Kasturbai Walchand College of Arts & Science, Woodhouse Road, Rajnemi Campus",
  "Vaibhav Technical Education Institute Magic Compute Academy, Paithan.",
  "Arts, Science  & Commerce College, Naldurg, Tuljapur.",
  "Sri Shivaji Arts Commerce Science College, Rajura",
  "Bhagwantrao Arts College, Sironcha",
  "Late Sainuji Patil Kowase Arts Commerce College, Murkala",
  "Adarsh Arts Commerce College, Desaiganj",
  "Bhagwan Shri Krishna College of Education, Talodhi (Balapur)",
  "Shantaram Potdukhe College of Law",
  "Nevjabai Hitkarini College, Bramhapuri",
  "KHEMAJI NAIK ARTS AND SCIENCE GADCHANDUR",
  "JAI PERSAPEN SCIENCE COLLEGE, BHAMRAGAD",
  "Deogiri Institute of Engineering and Management Studies, Aurangabad",
  "SHRIRAM COLLEGE OF HORTICULTURE,PANIV",
  "Shikshan Prasarak Sanstha's Shri. Omkarnath Malpani Law College, Sangamner, District - Ahmednagar 422605",
  "Parvatibai Jondhale Womens Law College Dombivli",
  "H. B. Arts, Commerce and Science College Pishor Ta kannad",
  "Shriram Education Societys Shri Anandrao Pawar Arts, Commerce, Science Mahavidyalaya",
  "Dr Deepak Patil Ayurvedic Medical College and Reserch Center",
  "Dr R N Lahoti Institute of Pharmaceutical Education And Research Center Sultanpur",
  "BHAGWANRAO PRASHASKIYA MAHAVIDYALAYA  KURHA",
  "SHRI SWAMI SAMARTH COLLEGE",
  "Lal Bahadur Shastri Senior College, Partur, Dist. Jalna",
  "B.K.L. Walawalkar  College of Physiotherapy,  At Post Kasarwadi, Sawarde, Tal. Chiplun, Ratnagiri-415606",
  "DR N Y TASGAONKAR INSTITUTE OF MEDICAL SCIENCE ",
  "BHARAT RATNA ATAL BIHARI VAJPAYEE MEDICAL COLLEGE AND TEACHING HOSPITAL PUNE",
  "RAJMUDRA SENIOR COLLEGE SAKSHAL PIMPRI TQ BEED DIST BEED ",
  "MAULI MAHILA MAHAVIDYALAY",
  "KAI NILKANTHRAO SHINDE PRASHASKIY SEWA MAHAVIDYALAY WARORA",
  "PARVATI MAHAVIDYALAY, GOREGAON",
  "DNYANDEEP MAHAVIDYALAY",
  "M.T.C. Unani Medical College, Malegaon",
  "AVDHOOT MAHILA MAHAVIDYALAYA KUHI",
  "CHANDRAPUR COLLEGE OF NURSING",
  "SMT VIMLADEVI COLLEGE OF PHYSIOTHERAPHY  AT VILLAGE WANDHARI GHUGUS ROAD  CHANDRAPUR",
  "Aai Tuljabhavani Shikshan Prasarak Mandal's Washi's Shivashakti Sanganak Mahavidyalaya, Washi.",
  "Mahatma Jyotiba Phule College of Computer Science, Chousala, Beed.",
  "Reddys College of Civil Services and Public Administration",
  "Aditya College of Agriculture, Telgaon Road, Beed",
  "Smt.Savitabai Uttamrao Deshmukh Mahavidyalaya, Digras.",
  "NEW MONTFORT INSTITUTE OF PHARMACY ",
  "OPULENCE COLLEGE OF CIVIL SERVICES MANDVE BU TAL SANGAMNER DIST AHMEDNAGAR",
  "Ashok Moharkar Arts Commerce Science College, Pahela",
  "Late Nirdhan Patil Vaghaye  College of education,  Tumsar",
  "SMT K N PATEL COLLEGE OF NURSING",
  "Shinde B.Ed. College, Anjani Bu. Mehakar",
  "Adinath Krishi Vikas Pratishthans Arts College, Adinathnagar, Koradgaon, Tal.Pathardi, Dist. Ahmednagar",
  "Matsyodari Shikshan Sanstha's Arts & Science College, Ranjani, Ghansawangi.",
  "Yuvak Vikas Mandal's Rajshri Shahu Maharaj College of Home Science and Nutrition, Malipura, Jalna.",
  "Swami Vivekanand Arts, Commerce & Science College, Mantha",
  "VARTAK NAGAR SHIKSHAN MANDALS ARTS,SCIENCE AND COMMERCE COLLEGE THANE",
  "Y AND M ANJUMAN KHAIRUL ISLAM TRUSTS, Y AND M AKIS WOMENS COLLEGE OF ARTS, SCIENCE AND COMMERCE, MAHAGIRI, THANE",
  "KGS ARTS COMMERCE AND SCIENCE COLLEGE SHAHAPUR",
  "Sindhbharati Trust's S.L. Women's College of Education",
  "SADASHIVRAO MANDLIK INSTITUTE OF NURSING  SHINDEWADI MURGUD TAL KAGAL DIST KOLHAPUR",
  "DR.PD.PATIL COLLEGE OF COMPUTER SCIENCES&MNGT STUDIES ZARE. TEH-KARMALA DIST. SOLAPUR.",
  "SHRI SWAMI SAMARTH MED COLLEGE GADEGAON ROAD BARSHI    TAL.BARSHI    DIST-SOLAPUR",
  "SINHGAD SCHOOL OF COMPUTER STUDIES KEGAON SOLAPUR",
  "JAYWANT INSTITUTE OF MEDICAL SCIENCES",
  "KRISHI MAHAVIDYALAY TONDAVALI",
  "Swami College of B.Sc. IT",
  "MITRA SADHANA SHIKSHAN PRASARAK MANDALS, DR.GANGADHARRAO PATHRIKAR COLLEGE OF AGRICULTURE.PATHRI (11299)",
  "Janata Shikshan Prasarak Mandal Women's B.Ed. College",
  "Atlanta College, Kamptee road",
  "Mother Teresa Social Work College Katol",
  "TANISHQ COLLEGE OF NURSING NAGPUR",
  "KRUSHI TANTRA VIDHYALAY ASANGAON TAL DAHANU PALGHAR",
  "KANDHAR COLLEGE OF PHARMACY, BALANTWADI TQ. KANDHAR DIST. NANDED",
  "SHREE RAMRAJE COLLEGE OF PHYSIOTHERAPY,DAPOLI",
  "Y AND M AKIS COLLEGE OF ARTS, SCIENCE AND COMMERCE, GOREGAON, LONERE SHRIVARDHAN ROAD, GOREGAON, TAL MANGAON, DIST RAIGAD",
  "TEJGYAN INSTITUTES OF DESIGN",
  "Shri Seetaramji Munde Arts & Commerce College, Jintur",
  "Priyadarshini Shikshan Prasarak Mandals Ashoka Institute of Management and Research, Trimurti Society, Warje Malwadi, Pune 411058",
  "Centre for Online Learning",
  "Mahatma Basweshwar Education Society's  College of Engineering, Ambajogai.",
  "BHAGWANT INSTITUTE OF TECHNOLOGY, BARSHI",
  "Janata Shikshan Prasarak Mandal's College of Education",
  "Shri Shivaji Maratha Societys Law College, Shukrawar Peth, Pune 2",
  "Gordhandas Seksaria College of Yoga and Cultural Synthesis",
  "VIJAYRAJ BHARAT AVIATION AND TECHNOLOGY FOUNDATIONS PUNE INSTITUTE OF AVIATION TECHNOLOGY",
  "Patuck Polytechnic Trusts Patuck Gala College of Commerce",
  "KHAREPATAN PANCHAKROSHI SHIKSHAN PRASARAK MANDAL S ARTS AND COMMERCE COLLEGE KHAREPATAN TALUKA KANKAVALI DISTRICT SINDHUDURG",
  "NATIONAL FORENSIC SCIENCES ACADEMY PUNE",
  "swaraj college of arts, commerce and Science",
  "Habib Educational & Welfare Societys M.S. College of Law, Devghar, Taluka -Wada, Palghar",
  "S S P Mandals Bhagwan Mahavidyalaya Arts, Commerce and Science College, Ashti.",
  "SCHOOL OF ARTILLERY, DEVLALI",
  "SHRI YUVRAJSINGH MAHAVIDYALAY CHUTIYA",
  "SONEKAR COLLEGE OF HEALTH SCIENCES BSC NURSING",
  "BABUSING NAIK MAHAVIDYALAY",
  "Kai Vasantrao Kale  Sr. College, Degloor Naka, Nanded",
  "Audyogik Shikshan Mandal Institute of  Management & Computer Studies Wagle Industrial Estate Near Mulund Check Naka Thane",
  "S P mandals institute for advanced training and research in interdisciplinary science",
  "LEELA EDUCATION SOCIETY S, G.V. ACHARYA INSTITUTE OF ENGINEERING AND TECHNOLOGY, VEERACHARYA TECHNICAL EDUCATION COMPLEX",
  "KAI SUMAN BARKU WAGH ARTS AND SCIENCE COLLEGE KHANDBARA",
  "ARTS, COMMERCE AND SCIENCE COLLEGE, DWARLI, NEAR ZILLA PARISHAD SCHOOL, DWARLI, POST DWARLI, TAL AMBARNATH DIST THANE    ",
  "LATE SAU CHANDRAPRABHA BHIKANRAO SALUNKHE ARTS AND COMMERCE COLLEGE MHASAWAD TAL DIST JALGAON    ",
  "SHASHI SUBHASH NURSING COLLEGE TUMSAR    ",
  "SHRI ANANDRAO ABITKAR COLLEGE OF ENGINEERING,PAL    ",
  "SWA INDIRA LAKHANIKAR MAHILA MAHAVIDYALAYA SAWRI TA LAKHANI DISTT BHANDARA    ",
  "SHRI VILE PARLE KELAVANI MANDALS COLLEGE OF ENGINEERING, SHIRPUR    ",
  "Shri Vile Parle Kelavani Mandals Dr Bhanuben Nanavati College of Pharmacy, Gate No One, Mithibai College Building, First Floor, V M Road, Vileparle West, Mumbai",
  "R B ARTS COMMERCE AND SCIENCE COLLEGE    ",
  "SANTOSH EDUCATION SOCIETYS SANTOSH COLLEGE OF MANAGEMENT AND COMPUTER SCIENCE, MHASRUL, NASHIK     ",
  "SHREE RAMRAJE COLLEGE OF PHARMACY    ",
  "SHRI DNYANDEV LIMBAJI TAMBARE SAMAJKARY MAHAVIDYALAY TAGADGAON TQ SHIRUR KASAR DIST BEED    ",
  "NALANDA EDUCATIONAL SOCIETYS SMT KRUSHNAI ARTS AND COMMERCE NIGHT COLLEGE    ",
  "YUGANTER EDUCATION SOCIETYS TIRPUDE NURSING COLLEGE CHALKS COLONY INDORA NAGPUR    ",
  "Modern College of Computer Science & I.T., Near Soni Video, Naik Nagar, Nanded",
  "Sakeshwar Gramin Vikas Seva Sanstha's Adsul's Technical Campus, Chas, Ahmednagar",
  "YASHWANT MAHILA MAHAVIDYALAYA LAKHANDUR",
  "DAKSHIN SOLAPUR TALUKA SHIKSHAN MANDAL'S   V. G. SHIVDARE COLLEGE OF ARTS, COMMERCE AND SCIENCE, JULE SOLAPUR - 1, VIJAPUR ROAD, SOLAPUR 413004",
  "PRAMILADEVI  PATIL COLLEGE OF PHYSIOTHERAPY",
  "Dr. D.Y. Patil Unitech Society's Dr. D.Y. Patil Arts, Commerce & Science College, Pimpri, Pune 411018.",
  "Hutatma Rajguru Shikshan Prasarak Mandal's, Sirsenapati Hambirrao Mohite Law College, Rajgurunagar, Pune",
  "MGM Trust, Nandeds Mother Teresa College of Nursing (B.Sc.), Aurangabad",
  "DR NAIKWADI COLLEGE OF NURSING JAMGAON SINNAR",
  "SMBT DENTAL COLLEGE & HOSPITAL",
  "GURUKRUPA COLLEGE OF PHYSIOTHERAPY",
  "MILITARY INSTITUTE OF TECHNOLOGY ",
  "GOVERNMENT MEDICAL COLLEGE ALIBAG",
  "GURUKRUPA INSTITUTE OF PHARMACY (DEGREE), MAJALGAON.",
  "Shivaji Arts, Commerce and Science College",
  "KALYAN COLLEGE OF NURSING ",
  "HORIZON COLLEGE OF PHYSIOTHERAPY",
  "SHREE SIDDHESHWAR COLLEGE OF PHYSIOTHERAPY",
  "DR N Y TASGAONKAR COLLEGE OF PHYSIOTHERAPY",
  "SAI AYURVED COLLEGE AND RESEARCH INSTITUTE",
  "SHRIMATI PANCHASHILA ARTS COMMERCE AND SCIENCE WOMENS COLLEGE HARDOLI",
  "SAKYA SCIENCE COMMERCE AND ARTS COLLEGE",
  " Arts, Commerce  and Science College, Narayangaon 410 504, Tal.Junnar, District Pune(M.S.)",
  "Dhanlaxmi Shikshan Sansthas Sahakarmitra Shivajirao Katkade Arts & Commerce College, Naigaon, Tal. Sinnar, Dist. Nashik 422109",
  "Shri Gajanan Maharaj Shikshan Prasarak Mandal's Sharadchandra Pawar  Arts & Commerce College, Alandi Devachi, (Dudulgaon)  Tal.Khed, Dist. Pune Pin.412105",
  "240036- S.P.D.M. ARTS, S.B.B. & S.H.D. COMMERCE & S.M.A. SCIENCE COLLEGE, SHIRPUR.",
  "Late Nirdhan Patil Waghaye Art and Science College, Sondad",
  "SURYADATTA SCHOOL OF INTERNATIONAL HOTEL MANAGEMENT  BAVDHAN ",
  "RASHTRASANT JANARDHAN SWAMI HOMOEOPATHIC MEDICAL COLLEGE AND RESEARCH CENTER",
  "RASHTRASANT JANARDHAN SWAMI AYURVED MEDICAL COLLEGE AND RESEARCH CENTRE",
  "VASANTPRABHA COLLEGE OF PHYSIOTHERAPY ",
  "MADANBHAU PATIL COLLEGE OF NURSING KAVALAPUR  DIST SANGLI ",
  "JNANA PRABODHINI SAMSHODHAN SANSTHAS JNANA PRABODHINIS INSTITUTE OF PSYCHOLOGY",
  "SHRI CHAKRADHAR ARTS AND SCIENCE COLLEGE SONI",
  "Vasundhara College of Arts, Science and Commerce, Ghatnandur, Tq. Ambajogai, Dist. Beed",
  "R. K. Talreja College of Arts, Science & Commerce, Ulhasnagar (West) - 421 003",
  "SHRI BHAIRAVNATH NISARG MANDALS MAULI NURSING COLLEGE HATTA TQBASSMAT DISTHINGOLI",
  "LATE BALARAM DHARMA PATIL SHIKSHAN SANSTHA SANCHALIT SUSHMA PATIL SENIOR NIGHT COLLEGE",
  "DR NAIKWADI COLLEGE OF PHYSIOTHERAPY AT JAMGAON PO MALEGAON TAL SINNAR DIST NASHIK",
  "Dr. R. N. Lahoti Mahila Science Mahavidyalay, Sultanpur",
  "SMT. USHABEN CHANDRAKANT THAKAR WOMENS COLLEGE",
  "Arts College, Sihora",
  "D.A.V. VELANKER COLLEGE OF COMMERCE. SOLAPUR-413002. DIST. SOLAPUR",
  "Swami Ramanand Teerth Arts and Science, Masal",
  "Dr Milind Yerne College of Law, Pavni",
  "Arts and Commerce(Eve) College, Chitnavispura,  Mahal",
  "Yashwantrao Chavan Engineering College, Wanadongri, Hingna road",
  "Ranibai Agnihotri College of Pharmacy",
  "Vincent Apostollic Degree College, Jaywant nagar",
  "Samarth College, Lakhni",
  "Science College, Pavni",
  "MukunrajswamiCollege, Pachkhedi",
  "Ravindranath Tagore College of Arts, Science and Commerce, Dongargaon, Wardha Road Nagpur.",
  "Joshi College of Library and Information Science, Mahal",
  "Nabira College, Katol",
  "Rajiv Gandhi College, Arjuni",
  "NJP Arts Commerce College, Mohadi",
  "Santaji College, Pavni",
  "Indutai Memorial Physical education college, Teka Naka",
  "St Xaviers College Mahapalika  Marg Mumbai",
  "St. Xaviers Institute of Education New Marine Lines Mumbai",
  "Guru Nanak Vidyak Society College of Education and Research Bhandup Mumbai  400 078",
  "H.K. College of Pharmacy, H. K. Building, Pratiksha Nagar, Relief Road, MHADA Colony, Oshiwara, Jogeshwari (West), Mumbai - 400 102",
  "Sindhu Education Societys, (S.E.S.), Swami Hansmuni Maharaj Degree College of Commence, Netaji Chowk, Opp. Dena Bank, Ulhasnagar-421 004",
  "Abhinav Shetkari Shikshan Mandal  Abhinav College of Arts  Science andCommerce  At Goddev Bhayandar East Dist Thane 401 105",
  "Shramik Shikshan Mandals F.G. Naik  College of Arts, Science (IT) & Commerce , KoperKhairane, Thane - 400 709",
  "Vidya Prasarak Mandals Dr V N Bedekar Institute of Management Studies Chendani Bunder Road Thane (W) 400 601",
  "Gyanodaya shikshan Pracharak Samiti Gyanodaya B.Ed. College Survey No.160 4 Post J.K. Gram Savarkar Nagar Dist-Thane  400 606",
  "The foundation for medical research",
  "Anjuman-I-Islams M.H. Saboo Siddik College of Engineering 8-Shephard Road  Mumbai 400 008",
  "Shikshan Vikas Mandals Shri Shantaram Krishnaji  College of Education Deogad Dist Sindhudurg",
  "Satish Pradhan Dnyansadhana College, Thane (Arts, Science and Commerce ) Eastern Express Highway,  Dnyansadhana Marg,  Thane (West)  400 604.",
  "Vidya Prasarak Mandals K G Joshi College of Arts & N G Bedekar College of  Commerce  Chendani Bunder Road  Thane",
  "Shri Sai Aniruddha Education Socioetys  D J Samant Senior College Arts Commerce and Science  Pali  N H  17  Near S T Stand Pali  Dist Ratnagiri",
  "Dapoli Education Societys Dapoli Urban Bank Senior Science College Dapoli  Dist Ratnagiri  415 712",
  "SOPHIA SMT. MANORAMA DEVI SOMANI COLLEGE Bhulabhai Desai Road Mumbai 400 026",
  "Shetkari Shikshan Prasarak Mandals Gurukrupa College of Education & Research Ramkrishna Nagar E wing Poornima Campas Murbad Road Dist. Thane",
  "Navyug Vidyapeeth Trust College of Arts  Science & Commerce  at Ladvali  Mahad  Dist  Raigad",
  "Church of Our Lady of The Sea St Joseph College of Arts and Commerce  at P O Uttan  Bhayandar West   Dist  Thane 401 106",
  "Datta Meghe College of Engineering CIDCO Sector III Airoli Navi Mumbai  400 708",
  "Adarsha Shikshan Prasarak Mandal's K.T.Patil College of M.B.A., Tambri Vibhag, Osmanabad.",
  "Navgan Shikshan Sanstha's Arts & Commerce College, Parli-Vaijnath, Dist. Beed.",
  "Vaidyanath College of Arts,Science & Commerce, Parli-Vaijnath.",
  "Sant Ramdas Arts, Commerce & Science College, Ghansawangi",
  "Dr Arun Motghare Collge of Home Science, Wadsa",
  "Sadguru Jagannath Baba Shikshan Mahavidyalaya, Nanda",
  "MATOSHRI COLLEGE OF EDUCATION",
  "Vidya Prasarini Sabhas College of Engineering and Technology, Lonavala",
  "TULSIRAMJI GAIKWAD-PATIL COLLEGE OF ARCHITECTURE ",
  "Mohammad Ali College of Education, Kamptee",
  "S V M P Senior Arts College, Mohadi, Kannad.",
  " Late Ramrao Patil B.Sc Nursing College ,Udgir",
  "JBVP Vidya Niketan College of Pharmacy",
  "Yashwantrao arts College, Mahagaon",
  "KAVAYITRI BAHINABAI CHAUDHARI NORTH MAHARASHTRA UNIVERSITY JALGAON CONDUCTED SCIENCE AND COMMERCE COLLEGE MOLAGI",
  "Tulsi Shikashan Prasarak Mandals Ujwal Night College of Arts Commerce and Science",
  "DR D Y PATIL INSTITUTE OF NURSING EDUCATION",
  "Nanasaheb Ghatge Arts & Science College, Dethna,. Tq. Parbhani",
  "Shivaji Mahavidyalaya, Renapur",
  "Dr.G.D.Pol Foundation Y.M.T. Dental College & Hospital",
  "120018-NPS'S COLLEGE OF EDUCATION, AMALNER.",
  "230033-POOJYA SANE GURUJI VIDYA PRASARAK MANDAL'S S. I. PATIL ARTS, G. B. PATEL SCIENCE AND S.T. K. V. SANGH COMMERCE COLLEGE, SHAHADA, DIST-NANDURBAR",
  "Maharshi Karve Stree Shikshan Samstha's Smt. Bakul Tambat Institute of Nursing Education, Pune",
  "ARIHANT EDUCATION FOUNDATION, ARIHANT COLLEGE OF ARTS COMMERCE AND SCIENCE BAVDHAN, PUNE",
  "Genba Sopanrao Moze Trust's Genba Sopanrao Moze Art's Commerce & Science (B.C.S) College yerwada, Pune",
  "Kumbhalkar Social Work Evening College, Ganeshpeth, Nagpur",
  "Vidarbha Mahavidyalaya, Buldhana (Arts & Commerce)",
  "JAI HIND MAHAVIDYALAY",
  "G. H. Raisoni College of Engineering and Management, Pune ",
  "Jeevan Jyot Educational Charitable Trust, Reena Mehta College of Arts, Science, Commerce & Management Studies, S.No.574/5, Near Flyover Bridge, 150 Feet Road, Near Maxus Mall, Bhayandar(West) - 401101",
  "Sou. Shobhakaki Babar Kanya Mahavidyalaya, Vita Tal. Khanapur Dist. Sangli",
  "ADVIKA MAHAVIDYALAYA BIBI ",
  "SADANAND MAHAVIDYALAYA MOTIGAVHAN",
  "DNYANDEVRAO BAPU DANDGE MAHAVIDHYALAY DHAD",
  "BHAUSAHEB GAIKWAD SENIOR COLLEGE MALKAPUR",
  "Samarth Law Collage ",
  "SAHYADRI COLLEGE OF PHARMACY METHWADE TAL . SANGOLA  DIST-SOLAPUR",
  "200018-Social and Cultural Association's Smt. Narmadabai Nago Chaudhari Arts, Commerce and Science College Kusumba, Tal. & Dist- Dhule.",
  "Satara College of Pharmacy",
  "Priyadarshini College of Engineering, Hingna Road, Nagpur 44019",
  "DR UTTAMRAO MAHAJAN COLLEGE OF B PHARMACY CHALISGAON",
  "Government Institute of Forensic Science, Aurangabad.",
  "RAJIV VIDNYAN VA VANIJYA MAHAVIDHYALAY, ZARI- JAMNI TQ.ZARI",
  "GOVINDRAO PAWAR PHYSICAL EDUCATION COLLEGE, KALAMB DIST. YAVATMAL",
  "SRIRAM COLLEGE KURKHEDA",
  "VYWS Dental College and Hospital, Tapovan-Wadali Road Camp, Amravati",
  "Pragati Mahavidyalaya, Sawkheda, Tq. Sillod, Dist. Aurangabad",
  "CHHATRAPATI SHIVAJI MAHAVIDYALAYA ARTS COMMERCE SCIENCE CHINCHOLI KHURD TA RAJURA DIST CHANDRAPUR",
  "Vinayakrao Patil Mahavidyalaya, Vaijapur",
  "Late Rajiv Gandhi College of Agriculture, Jintur Road",
  "Shri Wadmauli Vidya Prasarak Mandal's Shyam Gadale Arts College, Dahiphal, Kaij.",
  "PRAGATI MAHAVIDYALAYA TISGAON  AURANGABAD",
  "KT MAHAVIDYALAYA SAWARGAON TQ KALAMB DIST YAVATMAL",
  "Adv Bhagwan Keni Charitable Trusts Jai Bhagwan College of Law",
  "ARDHANARI NATESHWAR MAHAVIDYALYA VELAPUR",
  "Dharmaraj Shaikshanik Pratishthans College of Pharmacy",
  "OJAS College of Pharmacy Jalna",
  "SAMARTH COLLEGE OF PHARMACY",
  "Shantiniketan College of Pharmacy ",
  "Karmayogi Tatyasaheb Bondre Institute of Pharmacy",
  "Raosaheb Patil Danve Mahavidyalaya Wakulni",
  " Bharati Vidyapeeth (Deemed to be University) College of Engineering, Pune",
  "Devaki Mahavidyalaya Pirpimpalgaon",
  "Shri Dhaneshwari Manav Vikas Mandal Dr Vedprakash Patil Arts Commerce And Science Mahavidyalaya, Hatta",
  "Oasis Mahavidyalaya Bela Bhandara",
  "JIJAMATA COLLEGE OF NURSING MAJALGAON DIST BEED",
  "THE SIA COLLEGE OF HEALTH SCIENCES COLLEGE OF PHYSIOTHERAPY",
  "Valmik Naik College of Pharmacy Kannad",
  "SMBT INSTITUTE OF NURSING",
  "SHRI SAI JANVIKAS PRATISHTHANS SHRI SAI COLLEGE OF PHARMACY KHANDALA TQ VAIJAPUR",
  "N L Dalmia College of Arts Commerce and Science",
  "R P EDUCATIONAL TRUST R P INSTITUTE OF HOSPITALITY AND MANAGEMENT",
  "N.K.P. Salve Institute of Medical Sciences & Research Centre and Lata Mangeshkar Hospital",
  "220077-NANDURBAR TALUKA VIDHAYAK SAMITI'S COLLEGE OF LAW, INSTITUTE OF LEGAL EDUCATION & RESEARCH, NANDURBAR",
  "Samarth Mahavidyalaya, Jijamata Nagar, Hingoli",
  "Gokhale Education Society Law College",
  "PURUSHOTTAMDADA SONWANE ARTS COMMERS SCIENCE VARISHTH MAHAVIDHYALAYA SARNI ANANDGAON",
  "Ashvin College of Pharmacy Manchi Hill ",
  "Loksampapa Mahavidyalaya",
  "Shri Sant Gajanan Maharaj Commerce College",
  "SMT SUGRATA WANJARI MAHILA MAHAVIDYALAYA WADODA TH KAMPTEE DIST NAGPUR",
  "Late Shri Ashokrao Motghare Samajkarya Mahavidyalaya Kosra Kondha",
  "SARASWATI VIDYALAYA UNIONS COLLEGE OF COMMERCE EVENING",
  "SwaSavitribai Laxmanrao Ghade Mahavidyalaya Allipur Ta Hinganghat Dist Wardha",
  "Shri Krushna Mahavidyalaya Chale",
  "Sane Guruji Arts College Islapur",
  "Jagadambha Institute of Pharmacy and Research",
  "Rajmata Jijau Senior College Ghodegaon Taluka Khultabad",
  "College of Nursing, INHS Asvinis College of Nursing (B.Sc.) INHS Asvini, Colaba, Mumbai",
  "RAJKUNWAR MAHILA MAHAVIDYALAY BANOTI",
  "ANAND AYURVED COLLEGE",
  "Vidyaniketan Mahila Mahavidyalaya Yevatmal",
  "Shri Jain Vidya Prasarak Mandal's Rasiklal M. Dhariwal Institute of Pharmaceutical Education and Research, Telco Road, Chinchwad, Pune 411019",
  "Om Sai Samajik Sevabhavi Sanstha's Sharda College, Sinnar, Dist. Nashik 422103",
  "S. Chavhan Mahila Mahavidyalaya, Amgaon",
  "Vasantidevi Patil Institute of Pharmacy (B.Pharm)",
  "B.P.H.E.Society's Ahmednagar College, Ahmednagar 414001.",
  "VIDYANIKETAN MAHILA MAHAVIDYALAYA ARVI DIST. WARDHA",
  "SaiBalaji International Institute of Management Sciences",
  "Shreeyash Institute of Pharmaceutical Education and Research Aurangabad (B. PHARMACY)",
  "Pinglakshidevi Mahavidyalaya Narpingali Tal Morshi Dist. Amravti",
  "Deeps Degree College",
  "School of Environment and Architecture",
  "Deccan Education Society's Chintamanrao Institute of Management Development and Research, Sangli",
  "Lokmanya Medical College Of Physiotherapy",
  "Atharva Educational Trust's Atharva College of Hotel Management & Catering Technology, Plot No. 8/12, Survey No. 263, Malad Marve Road, Charkop Naka, Malad (West), Mumbai - 400 095",
  "Anjuman College of Engineering and Technology",
  "Arts, Science and Commerce College, Chikhaldara ",
  "Bar. Sheshrao Wankhede College of Arts & Commerce, Khaparkheda",
  "DR. N. J. PAULBUDHE NIGHT COLLEGE ",
  "DR. N. J. PAULBUDHE MAHILA MAHAVIDHYALAYA",
  "DNYANSAGAR SENIOR COLLEGE JAFRABAD",
  "100098-SHELLINO EDUCATION SOCIETY'S ARUNAMAI COLLEGE OF PHARMACY,MAMURABAD,JALGAON",
  "MADHUKARRAO CHAVAN CHARITABLE TRUST ANDURS MADHUSHALI ARTS, SCIENCE  COMM COLLEGE SALGARA, TULJAPUR",
  "SWAMI VIVEKANAND AYURVED MEDICAL COLLEGE AND RESEARCH CENTER , PARGAON SUDRIK  ",
  "Zeal Education Society's Zeal Institute of Business Administration,Computer Application & Research, Narhe, Pune 411041",
  "HON.R.R.PATIL COLLEGE OF HOMOEOPATHY AND HOSPITAL AND RESEARCH CENTER ",
  "Arts Science And Commerce R. College Soygaon",
  "K. K. Wagh College of Performing Arts, Nashik",
  "College Of Horticulture, Mulde, Tal - Kudal",
  "Yashwant College, Waigaon",
  "R.M. Dhariwal Sinhgad Management School, Kondhapuri, Tal.Shirur, Dist.Pune 412208",
  "ARTS COMMERCE SCIENCE COLLEGE, GITTIKHADAN",
  "Krishna College of Physiotherapy",
  "Karmaveer Bhausaheb Hiray Institute of Management And Research ",
  "SHREE JAGDAMBA SANSTHA'S PIBM - TIRUPATI INSTITUTE OF MANAGEMENT, Sr.No. 24, Shindewadi, Pune-Satara Road, Pune 412205",
  "Shivramji Pawar Gramin Institute of Agriculture Engineering, Nehrunagar, Kandhar",
  "MIT College of Food Technology  Aurangabad",
  "Late shree Fakirbhai Pansare Education Foundations College of Physiotherapy, Nigdi Pune",
  "VEDANATA INSTITUTE OF MEDICAL SCIENCES",
  "Smt. Meenalben Mehta College, Panchgani (Arts, Commerce and Science)",
  "SSS MOTHER TERESA NURSING SCHOOL (B.SC.NURSING), VISHNUPURI NANDED",
  "D Y Patil Dental School, Lohegaon",
  "Y S PAWAR ARTS AND COMMERCE COLLEGE NERI.",
  "SANSKRUTI MAHAVIDHYALAYA PURNA",
  "K.S.E.TS COLLEGE OF COMPUTER APPLICATIONS ",
  "VASANTDADA SUGAR INSTITUTE",
  "HUDA COLLEGE OF EDUCATION, Aurangabad.",
  "MRFTs Shri Ganapati Netralaya College of Optometry Jalna",
  "College of Agriculture, (Konghara)",
  "Ahmednagar Jilha Maratha Vidya Prasarak Samaj's Shri Mulikadevi Mahavidyalya, Nighoj, Taluka - Parner, District - Ahmednagar 414306",
  "Pune Zilha Shikshan Mandal's Mamasaheb Mohol College of Arts, Commerce & Science, Erandwane, Paud road, Pune 38",
  "Deccan Education Societys Brihan Maharashtra College of Commerce, Pune 411004",
  "Late Udhavrao Tulshiram Jadhavar Foundation's Dr. Sudhakar Jadhavar Arts, Commerce and Science College, Manaji Nagar, Narhe-Dhayari, Pune 411041.",
  "Nilkanthrao Shinde Science and Arts College, Bhadrawati",
  "Dnyanvardhini Adhyapak Mahavidyalaya, Hingoli",
  "Gramonnati Mandal B.Ed College,Pune",
  "ADITYA PHARMACY COLLEGE, BEED.",
  "Mangaon Panchakroshi Shikshan Prasarak Mandals Late Parvatibai Mahadeorao Dhuri Arts College, Late Mahadeorao Narayanrao Dhuri Commerce & Science College Shri Shetra Mangaon, Tal. - Kudal Dist. - Sindhudurg - 416 519",
  "Sharadchandraji Pawar Homoeopathic Medical College and Hospital",
  "anand college of nursing vaijapur",
  "College Of Physiotherapy, Wanless Hospital, Miraj Medical Center, Miraj.",
  "Dr D Y Patil Educational Federation Dr D Y Patil Institute of Management & Entrepreneur Development,Varale, Talegaon, Maval",
  "SHRIRAM COLLEGE OF AGRICULTURAL ENGINEERING, PANIV",
  "SHRIRAM COLLEGE OF AGRICULTURE, PANIV",
  "S A V ACHARYA INSTITUTE OF MANAGEMENT STUDIES",
  "Maratha Vidya Prasarak Samaj's Karmayogi Dulaji Sitaram Patil College of Agriculture,Gangapur Road Nashik-422013",
  "SHRAMSHAKTI COLLEGE OF AGRICULTURE, MALDAD",
  "SAIKRUPA COLLEGE OF FOOD TECHNOLOGY, GHARGAON",
  "COLLEGE OF AGRICULTURE, AMALNER",
  "SHARAD COLLEGE OF AGRICULTURE, JAINAPUR",
  "K K WAGH COLLEGE OF HORTICULTURE, NASHIK",
  "COLLEGE OF AGRICULTURE, BABHULGAON",
  "VSBT COLLEGE OF AGRICULTURAL BIOTECHNOLOGY, VIDYANAGARI, BARAMATI",
  "Sir M Visvesvaraya Institute of Management Studies and Research",
  "Shree Chanakya Education Societys Indira School of Business Studies",
  "Sawkar Homoeopathic Medical College, Satara 415004",
  "Bharati Vidyapeeth's College of Engineering, Kolhapur",
  "OYSTER INSTITUTE OF PHARMACY, GOLATGAON, AURANGABAD.",
  "PRIYADARSHINI J. L. COLLEGE OF PHARMACY, Hingna Road",
  "Aqsa Womens Degree College",
  "Priyadarshini Bhagwati College of Engineering, Umred Road",
  "DR SHIVAJIRAO GHOGARE INSTITUTE OF NURSING",
  "M B DESHMUKH MAHAVIDYALAYA DONGARGAON SADAK",
  "Marotrao Pantawane Mahavidyalaya Kandri Kanhan",
  "Mahatma Gandhi Missions College of Engineering and Technology Sector 18, kamothe, Navi Mumbai, Raigad -410209",
  "G.H. Raisoni College of Engineering ,Nagpur",
  "VIMALTAI MAHILA MAHAVIDYALAYA SAOLI, CHANDRAPUR",
  "Deccan College of Interiar Design, Cosmos Commercial Complex, 3rd Floor,Station Road, New Shahupuri,",
  "Shri Vile Parle Kelavani Mandals Usha Pravin Gandhi College of Arts, Science and Commerce, Bhaktivedant Swami Marg, Juhu Scheme, Vile Parle West, Mumbai",
  "DR.BABASAHEB AMBEDKAR ARTS,COMMERCE AND SCIENCE COLLEGE",
  "Shrimant Babasaheb Deshmukh Mahavidyalaya, Atpadi",
  "Dinkarrao K. Shinde College of Education, Kadgaon Road,  Maruti Mal, GADHINGLAJ",
  "Lal Bahadur Shastri College of Arts, Science and Commerce,  17, Malhar Peth, Satara",
  "H.E.S. Homoeopathy College, Akot Rd., Akola",
  "SHEILA RAHEJA SCHOOL OF BUSINESS MANAGEMENT AND RESEARCH, MUMBAI SUBURBAN",
  "Smt. Akkatai Ramgonda Patil Kanya Mahavidyalaya, ICHALKARANJI-416115,             Tal-Hatkanangale,Dist-Kolhapur",
  "YESHWANT MAHAVIDYALAYA, KALMESHWAR",
  "PAL RAJENDRA EDUCATION TRUSTS PAL RAJENDRA BED COLLEGE, MUMBAI SUBURBAN",
  "PRAVARA RURAL EDUCATION SOCIETY PRAVARANAGAR HAL-PRAVARA AVIATION INSTITUTE, NASHIK",
  "Maharia Charitable Trust's Sahyadri Valley College of Engineering & Technology  Address: Rajuri, Taluka - Junnar, District Pune, Taluka: Junnar, District: Pune",
  "Shrinath Vedabhyas Kendra Sanskrit Mahavidyalaya, Khadkeshwar, Aurangabad",
  "KES's Shri Jayantilal H. Patel Law College  At- Shantilal Modi Road, Kandivali (W), Mumbai  400 067.",
  "Citizen Welfare Education Societys Dr. Manzoor Hasan Ayyubi College of Education, Sr.No. 224, Plot No. 124, Guruwar Ward, Islam Nagar, Malegaon, Dist. Nashik - 423203",
  "Gokhale Education Society's Sir Dr. M.S. Gosavi College of Pharmaceutical Education and Research,  Address: Prin. T.A. Kulkarni Vidyanagar, Nashik, Taluka: Nashik, District: Nashik",
  "ShrI Guru Govindsinghji College (B.J.), Malegaon Road, Nanded",
  "ANJUMAN-I-ISLAMS SCHOOL OF PHARMACY, MUMBAI",
  "DR AMBEDKAR COLLEGE OF COMMERCE AND ECONOMICS, MUMBAI",
  "GNVS INSTITUTE OF MANAGEMENT, MUMBAI",
  "Deep's MIDC College of Management (BMS), AT SARAWALI, TAL-PALGHAR, DIST-PALGHAR",
  "Ramrao Adik Education Society's, Dr. D. Y. Patil College of Law, Dr. D. Y. Patil Vidyanagar, Sector-7, Nerul, Navi Mumbai-400706",
  "ST WILFRED COLLEGE OF LAW IMPARTING LLB, MUMBAI",
  "Adarsh Shikshan Prasarak Mandals K.T. Patil College of B.Sc. Nursing, Osmanabad",
  "D.K.M.M. Homoeopathy College, Aurangabad",
  "P.T. School and Centre, Govt. Medical College,  Nagpur",
  "SS Girls College",
  "Vetal Bambarde Vibhag Shikshan Prasarak Mandals Dadasaheb Tirodkar Educational Academy  Padmashri Babasaheb Vengurlekar Mahavidyalaya,  At. Post - Pandurtitha, Tal - Kudal,  Dist - Sindhudurg 416 412",
  "KOHINOOR BUSINESS SCHOOL KOHINOOR EDUCATION COMPLEX, MUMBAI SUBURBAN",
  "ST WILFRED EDUCATION SOCIETY'S  ST WILFRED INSTITUTE OF ARCHITECTURE, RAIGAD",
  "GOKHALE EDUCATION SOCIETYS COLLEGE OF ARTS COMMERCE AND SCIENCE, RAIGAD",
  "MB MORE FOUNDATION OF ARTS COMMERCE SCIENCE WOMEN COLLEGE, RAIGAD",
  "ROYAL EDUCATION SOCIETYS DR A R UNDRE WOMENâS COLLEGE OF SCIENCE, RAIGAD",
  "KONKAN GYNAPEETHS KARJAT COLLEGE OF ARTS COMMERCE AND SCIENCE COLLEGE, RAIGAD",
  "GOPINATH MAHADEO VEDAK PRATISHTHANS GM VEDAK INSTITUTE OF TECHNOLOGY, RAIGAD",
  "MANDAR EDUCATION SOCIETYâS SOU SHAILAJA SHINDE ARTS SCIENCE COMMERCE COLLEGE, RATNAGIRI",
  "REGAL EDUCATION SOCIETYâS COLLEGE OF HOTEL MANAGEMENT AND TOURISM, RATNAGIRI",
  "JAYAWANTI BABU FOUNDATIONâS METROPOLITAN INSTITUTE OF TECHNOLOGY AND MANAGEMENT, SINDHUDURG",
  "LOKMANYA TILAK JANAKALYAN SHIKSHAN SANTHAS LOKMANYA TILAK INSTITUTE OF ARCHITECTURE AND DESIGN STUDIES, MUMBAI",
  "PHANSGAON PANCHKROSHI SHIKSHAN SANSTHA PHANSGAON ARTS AND COMMERCE COLLEGE, SINDHUDURG",
  "SOUTH RATNAGIRI DISTRICT SHIKSHAN PRASARAK MANDAL  PANCHAM KHEMRAJ LAW COLLEGE, SINDHUDURG",
  "JAY SHRI SIDDHIVINAYAK FOUNDATIONâS BR HARNE COLLEGE OF ENGINEERING AND TECHNOLOGY, THANE",
  "ROYAL COLLEGE OF EDUCATION AND RESEARCH FOR WOMEN AT ROYAL COLLEGE, THANE",
  "SHAHU SHIKSHAN SANSTHA (P), DEVJIBHAI HARIYA LAW COLLEGE, SHAHAD (W) THANE -421 103",
  "SHURPARAKA EDUCATIONAL AND MEDICAL TRUSTâS MOINUDDIN BURHAN HARRIS COLLEGE OF ARTS & A.E. KALSEKAR COLLEGE OF COMMERCE & MANAGEMENT, NAWAYAT NAGAR",
  "The Bombay Salesian Society's Don Bosco College,Don Bosco Centre for Learning  premier Automobile Road Kurla (W),Mumbai -400 070 .",
  "BGPS Mumbai College of Arts, Commerce and Science, Nadkarni Park, Behind M.B.P.T. Hospital, Wadala (E), Mumbai - 400 037",
  "Shri Vile Parle Kelvani Mandals Pravin Gandhi College of Law Vile Parle (W) Mumbai 400 056",
  "Navnirman Shikshan Sansthas College of Arts,Commerce & Science Sangameshwar. ",
  "SHRI DOMBIVLI MITRA MANDAL MATRUSHRI KASHIBEN MOTILAL PATEL SENIOR COLLEGE OF COMMERCE & SCIENCE, THANE",
  "\" SWATANTRYA SAINIK SHRI KANHAIYALALJI RAMCHANDRA INNANI MAHAVIDYALAYA\" ,KARANJA (LAD),DIST WASHIM (M.S.)",
  "Principal K.M. Kundnani College of Pharmacy, Jote Joy Building, Rambhau Salgaonkar Marg ,Cuffe Parade, Mumbai - 400 005.",
  "Medical College",
  "Sharda Bhavan Education Society's College of Education, V.I.P. Road, Nanded.",
  "Government College of Education, Parbhani",
  "Late Sow. Kamlatai Jamkar Mahila Mahavidalaya, Jintur Road, Parbhani",
  "Vai. Dhunda Maharaj Deglurkar College, Degloor",
  "Vivek Vardhini Mahavidyalaya, Deoni",
  "Dhaneshwari Manav Vaikas Mandal,  College of Education, Hatta, Tq. Vasmat",
  "Sant Sambhaji Shinde College of  Library & Information Science, Parbhani",
  "Mahatma Phule College of I.T., Jalkot",
  "Late Bhimrao Chavhan Arts & Sci College Chavhanvadi, Tq. Mukhed",
  "Lokmanya Arts Mahavidyalaya Sonkhed, Tq. Loha",
  "S.S.B.E'S Institute of Technology & Management, V.I.P Road, Nanded",
  "D.S.M.'s Institute of Information Technology & Management, Parbhani",
  "Dnyanopasak Shikshan Mandal's Arts, Commerce & Science College, Jintur ",
  "Sant Dnyaneshwar Chitrakala Mahavidyalaya, Parbhani",
  "Pratibha Niketan Mahavidyalaya,Nanded",
  "Dnyanopasak Shikshan Mandal's College of Arts, Commerce and Science, Parbhani",
  "Raosaheb Patange Arts College, Vasmat",
  "Shivneri Mahavidyalaya, Shiruranantpal",
  "Hutatma Jaywantrao Patil College, Himayatnagar",
  "Yuvak Pratishthan's MIT College of Computer Science & I.T. Vasmat",
  "G.S.P.M.'s Gramin Science Vocational College, Vishnupuri, Nanded",
  "Shri Shivaji Law College, Kandhar",
  "Ramji Pawar Adhyapak Mahavidyalaya, Tadmogli",
  "Ushatai  Dhondge College of Journalisam, Kalamandir, Nanded",
  "Shri Gurubudhi Swami Mahavidyalaya, Purna",
  "M.I.P. Arts  & Computer College, Jawalbazar, Tq. Aundha Nagnath",
  "Bhagwanbaba College of Education, Karegaon, Parbhani",
  "Shahir Annabhau Sathe Mahavidyalaya, Mukhed",
  "Khan Abdul Gaffar Khan Arts College Parthri",
  "Sanjivani Mahavidyalaya, Chapoli, Tq. Chakur",
  "Smt.Shakuntalabai Bordikar College of Computer, Jintur",
  "Swami Vivekanand Mahavidyalaya, Mukramabad, Tq. Mukhed",
  "Shri Sharadchandra Pawar Arts Sr. College Mahur",
  "Jai Jawan S.P.M.'s  College of  B.B.A. & B.C.A., Taroda, Manik Nagar, Nanded",
  "Sharadchandra Pawar Law College, Manik Nagar, Taroda, Nanded",
  "Santshresht Namdev Maharaj Pathade College, Hingoli",
  "S R T M University, Sub Centre, Latur",
  "Matoshri Pratishthan's  School of Engineering, Jijau Nagar, Khupsarwadi, Post Vishnupuri, Nanded",
  "Smt. Indira Gandhi Adhyapak Mahavidyalaya, Vasarni, Nanded",
  "S.G.G.S. Inst. of Engineering & Technology, Vishnupuri, Nanded",
  "Maharashtra Shikshan Mandal, Rajmata Jijamata B.Ed. College, Kendre Building, Shivnagar, Latur",
  "Shri Sant Gadge Maharaj Adhyapak Mahavidyalaya, Hingoli",
  "Dr. Babasaheb Ambedkar Mahavidyalaya, Latur",
  "Yeshwant College of Information Technology, Vasmat Road Parbhani",
  "Shivaji Mahavidyalaya, Udgir",
  "Maharashtra College of Pharmacy, Nilanga",
  "Manavendra Kendre Adhyapak Mahavidyalaya, Jalkot",
  "Bhagwantrao Arts and Science College, Etapalli",
  "Lal Bahadur Shastri Mahavidyalaya, Dharmabad",
  "Master Dinanath Mangeshkar College Aurad Shahjani, Tq. Nilanga",
  "Sharad Chandra Arts, Commerce & Science  College, Naigaon",
  "Smt. Shakuntalabai Bordikar Arts Sr.  College, Jintur",
  "Mahatma Jyotiba Phule Mahavidyalaya, Mukhed",
  "Bahirji Smarak Mahavidyalaya, Vasmat",
  "Vivek Vardhini Mahila Adhyapak Mahavidyalaya, Visava Nagar, Nanded",
  "Indira College of Pharmacy, Vishnupuri, Nanded",
  "Shri Kumarswami Mahavidyalaya, Ausa",
  "Sant Tukaram College of Arts and Science, Basmat Road, Parbhani",
  "Adarsha Edu. Society's Arts Commerce & Science College, Hingoli",
  "PDVVPF Ayurved College, Shevgaon",
  "Ramkrishna Shikshastri (B.Ed.) Mahavidyalaya, Darapur",
  "Chakarpani Panchakarma Yoga Va Nisargopchar Mahavidyalaya, Nagpur",
  "Administrative Service Degree College, Nagpur",
  "Swami Vivekananda Shikshan Va Yoga Mahavidyalaya, Sakoli",
  "Dr. Panjabrao Deshmukh Yog Mahavidyalaya, Chandurbazar",
  "Chhatraveer Raje Sambhaji Prashasakiya Seva Mahavidyalaya, Morwa",
  "Gurukrupa Mahavidyalaya, Akola",
  "Manjulabai Bhondekar College,  Pandharbodi",
  "Nagaji Maharaj Mahavidyalaya, Nagpur",
  "Damayantitai Deshmukh B.Ed. College, Ramtek",
  "Chaitanya Ayurved Mahavidyalya, Sakegaon, Tal-Bhusawal",
  "Terna Dental College, Nerul, Navi Mumbai",
  "NDMVPSs College of Physiotherapy, Nashik.",
  "270083-VES'S SARVAJANIK ARTS COLLEGE, VISARWADI,TAL-NAVAPUR,DIST-NANDURBAR",
  "Maharashtra Institute of Dental Sciences & Research Dental College, Ambejogai Road, Latur",
  "JMFs A.C.P.M. College B.Sc. Nursing, Dhule",
  "Grant Medical Foundation, Ruby Hall Clinics Tehmi Grant Institute of Nursing, Pune. (B.Sc.)",
  "S.C.Mutha Aryangla Vaidyak College, Satara",
  "Manakchand Prabhudan Charitable Trusts Asharam College of Nursing (B.Sc.), Kamptee, Nagpur",
  "Nair Hospital Dental College, Mumbai",
  "KVTR Ayurved Mahavidyalya, Boradi, Tal-Shirpur",
  "Shri. Shivaji Education Societys Dr. Panjabrao Deshmukh Nursing Institute, Shivaji Nagar, Amravati",
  "Dnyanpath Bahu-uddeshiya Shikshan Prasarak Mandals Suretech College of Nursing (B.Sc.), Jamtha, Tal. Dist. Nagpur",
  "Smt. Kashibai Navale College of Physiotherapy, off westerly by Pass, Narhe (Ambegaon), Pune",
  "B.J.Medical College & Sassoon General Hopsital, Punes Training College of Nursing (B.Sc.), Pune",
  "K.J. Somaiya College of Nursing (B.Sc.), Sion, Mumbai",
  "Gramodhyogik Shikshan Mandals MITs Nursing College, Cidco, Aurangabad",
  "S.M.B.T. Ayurved College & Hospital, Nandihills,  Dhamangaon, Tal. Igatpuri, Dist. Nashik",
  "K. J. Somaiya Medical College, Sion, Mumbai",
  "Janseva Mandal Trusts, Sai Homo. Medical College Dugad Phata, Bhivandi. Dist. Thane.",
  "Gulabrao Patil Homoeopathy College, Miraj",
  "P.E. Societys Modern College of Physi., Pune",
  "Baliraja Shikshan Prasarak Mandals Padmashree Shyamraoji Kadam Homoeopathic Medical College, CIDCO, New Nanded",
  "Maharashtra Institute of Physiotherapy College, Vishwanathpuram, Ambajogai Road Latur",
  "Sinhgad Technical Edu. Societys Smt. Kashibai Navale Med Colle. & General Hosp., Narhe, Ambegaon, Pune",
  "Y.M.T. Homoeopathy College, Kharghar, Raigad",
  "College of Nursing, Wanless Hospital, Miraj, Sangli  (P.B.B.Sc.)",
  "Gangadhar Shastri Gune Ayur. Mahavidyalya, Ahmednagar",
  "Antarbharati Homoeopathy College, Nagpur",
  "MGMs College of Physiotherapy, Navi Mumbai.",
  "200064-A.R.A. COLLEGE OF PHARMACY, DHULE.",
  "Tatyasaheb Kore Dental College & Research Centre, Pargaon Hatkanangle, Kolhapur",
  "Shivratna Shikshan Sansthas Vijaysinh Mohite Patil College of Nursing (B.Sc.) & Medical Research Institute, Malshiras, Solapur",
  "Aditya Bahuuddeshiya Sansthas Ayurved college & Research Centre, Beed",
  "Seth G.S. Medical  College & KEM Hospital, Parel, Mumbai",
  "P.S.P.M. Mahila Homoeopathy College, Solapur",
  "Padmashri Dr. Vithalrao Vikhe Patil Foundations College of Nursing (P.B.B.Sc.), Ahmednagar",
  "Godavari Foundation's Godavari College of Nursing, Jalgaon",
  "Govt. Ayurved Mahavidyalaya, Osmanabad",
  "MAMs Sumatibhai Shah Ayur. Mahavidyalaya, Malwadi,  Hadapsar, Pune",
  "Maharashtra Medical Education & Research Centres M.A. Rangoonwala College of Phys., Pune",
  "120017-KES'S PRATAP COLLEGE, AMALNER.",
  "100112-EKES'S RAOSAHEB RUPCHAND SENIOR COLLEGE,JALGAON",
  "130106-KDMG'S NANASAHEB DR.UTTAMRAO MAHAJAN COLLEGE OF EDUCATION,KARGAON,TAL-CHALISGAON",
  "250042-SSSVPS'S LATE S.D.PATIL ARTS,COM.&LATE M.D.SISODE SCI.COLLEGE SHINDKHEDA",
  "130082-SSMACT'S SMT. SITABAI MANGILAL AGRAWAL INSTITUTE OF MANAGEMENT, CHALISGAON",
  "Gondia Homoeopathic Medical College and Hospital, Gondia",
  "Rural Dental College, Loni",
  "Dr. APJ Abdul Kalam College of Physiotherapy",
  "Smt. Sindhutai Eknathrao Vikhe Patil College of Nursing",
  "COLLEGE OF BIOSCIENCES AND TECHNOLOGY ",
  "Government College of Engineering, Karad",
  "Yunus Fazlani Unani Medical College & Al Fazlani Hospital, Kunjkheds, Tal. Kannad, Dist. Abad",
  "Shri Anant Smruti Charitable Trust, A-p Kasal, Tal. Kudal, Sindhudurgs Institute of Nursing (B.Sc.), A-p. Gaorai, Tal. Kudal, Dist. Sindhudurg",
  "Topiwala National Medical College, Mumbai Central, Mumbai",
  "Armed Forces Medical College, Pune",
  "Gulabrao Patil Memorial Trusts Institute of Nursing Sciences (P.B.B.Sc.), Miraj, Dist. Sangli",
  "B.S.D. Trusts Ayurved Mahavidyalaya, Ap. Wagholi,  Tal. Haveli, Pune",
  "College of Nursing, Jagdale Mama Hospital, Tal. Barshi, Shivaji Nagar, Dist- Solapur",
  "Govt. Dental College, Panchakki Rd, Aurangabad",
  "Yeshwant Ayurvedic College, AP. Kodoli, Kolhapur",
  "VNH Ayurved College, Rahuri",
  "Manjara Charitable Trusts Ayur.  Maha. & Hospital, Latur",
  "Lt.sunil Ramsingji Chunawale Ayurved colloge.Chikhil",
  "Pune District Education Association's College of Ayurved & Research Centre, Akurdi, Pune ",
  "Shri Gurudeo Ayurved College, Gurukunj, Mozari",
  "Dr. Shankarrao Chavan Government Medical College Vishnupuri Nanded",
  "Mahila Shikshanshastra Mahavidyalaya, Market Yard, Yuth Bank",
  "Arts,Commerce & Science Mahavidyalaya, ASURLE-PORLE",
  "Arts, Comm. & Science College, VATHAR-STATION,",
  "Balasaheb Desai College, PATAN",
  "Bhogawati Mahavidyalaya KURUKALI",
  "Chh. Shivaji College of Education, Rukadi",
  "Shri Prince Shivaji Maratha Boarding House's College of Architecture, Kolhapur",
  "College of Education Pantacha Kot, Somwar Peth,  KARAD",
  "Yashwant Shikshanshastra Mahavidyalaya (B.Ed. College), Kodoli.",
  "Yashwantrao Chavan Mahavidyalaya,   HALKARNI",
  "Vishwasrao Naik Arts, Commerce & Baba Naik Science Mahavidyalaya, Shirala",
  "Walchand  College of Engineering , Vishrambag",
  "Tatyasaheb Kore Shikshanshastra Mahavidyala, Warananagar,",
  "Special Education (Hearing Empered) Adhayapak Maha., Near Govt, Doodh Dairy, Miraj",
  "Shri. Sant Gadagebaba Mahavidyalaya, KAPASHI",
  "Indian Youth Welfare Multipurpose Societys Sumantai Wasnik College of Nursing (B.Sc.), Shivpriya Nagar, Dabha, Kha No. 142 1, Nagpur",
  "Shree Santkrupa College of Pharmacy, GHOGAON",
  "Shri Venkatesh Mahavidyalaya, ICHALKARANJI",
  "Motiwala (National) Homoeopathic Medical College & Hospital, Nashik.",
  "Yashwantrao Chavan Warana Mahavidyalaya, Warananagar",
  "Modern College of Education, MALKAPUR, KARAD",
  "Shripatrao Kadam Mahavidyalaya, SHIRVAL",
  "Sharirik Shikshan Mahavidyalaya, KURUNDWAD",
  "Shikshanshastra Mahavidyalaya,KAGAL",
  "Modern Education Society's College of Education, Vita",
  "S.B.Khade Mahavidyalaya, KOPARDE",
  "R.B.Madkholkar College, CHANDGAD",
  "Sadguru Gadage Maharaj College, Vidyanagar,   KARAD",
  "Sai Special B.Ed.(H.I.) College, Gijavane, Tal. Gadhinglaj Dist. Kolhapur",
  "Rajarambapu College of Sugar Technology, New Bahe Naka, Islampur,",
  "Rajarshi Chhatrapati Shahu College, Kolhapur",
  "Rajarshi Shahu Arts and Commerce College,   RUKADI",
  "Nemgonda Dada Patil Night College of  Arts & Commerce",
  "Late H. G. Alias B. G. Kharade College of Education, Shivaji Peth, Kolhapur",
  "Mahila Mahavidyalaya, Mangalwar Peth, KARAD",
  "Late Narayandas Bhavandas Chabada Institute of Engineering & Technology",
  "Karmveer Bhaurao  Patil College,  URUN-ISLAMPUR",
  "Doodhsakhar Mahavidyalaya, BIDRI",
  "Kolhapur Institute of Technology's College of Engineering (Autonomous),  GOKUL-SHIRGAON",
  "Giristhan Arts and Commerce College,  MAHABALESHWAR",
  "Shrimant Jayashrimaladevi Naik Nimbalkar Institute of Management Studies, Phaltan",
  "Priyadarshini Dnyan Prabodhini's Law College, PHALTAN",
  "Arts and Commerce College, 51, Yadogopal Peth",
  "Arts and Commerce College, MAYANI",
  "Shankarrao Jagtap Arts and Commerce College, Wagholi",
  "Arts, Commerce & Science College, PALUS",
  "Arts & Science College, ATPADI",
  "Asha College of Special Education, Kodoli   Rahimatpur",
  "Azad College of Education, Campus,",
  "College of Education (B.Ed.), Peth Vadgaon",
  "Yashwantrao Chavan (K.M.C.) College, Kolhapur",
  "Yashwantrao Chavan College of Science,  KARAD",
  "Vivekanand College, Kolhapur",
  "Textile & Engineering Institute, Rajwada Chowk, ICHALKARNJI",
  "Vasant College of Education, URUN  ISLAMPUR",
  "Vasantraodada Patil Institute of Management Studies and Research, Sangli Miraj Road,",
  "Vasantrao Naik Shikshanshastra Mahavidyalaya, Kalaba Road",
  "Shri Sampatrao Mane Mahavidyalaya, KHANAPUR",
  "Shri Shahaji Chhatrapati Mahavidyalaya,Dasara Chowk,",
  "Shree Maharani Tarabai Government College of Education, Kolhapur",
  "Karnataka Sanghas Manjunatha College of  Commerce Manjunatha College Building Kanchagaon Kambalpada Thakurli Kalyan Road Thakurli East Thane 421 201",
  "MANAV SCHOOL OF ENGINEERING AND TECHNOLOGY",
  "SYMBIOSIS Institute of Business Management, Pune",
  "HEMUJI CHANDELE  COLLEGE  SHELGAON   R TAL.BARSHI DIST. SOLAPUR.",
  "WALCHAND COLLEGE OF ARTS AND SCIENCE ASHOK CHOWK SOLAPUR DIST-SOLAPUR",
  "DESHBHAKATA  HARI NARAYAN BANKATLAL SONI  COLLEGE 1051B.VASHNAVI NAGER BIJAPUR ROAD DIST. SOLAPUR.",
  " CHHATRAPATI SHIVAJI NIGHT COLLEGE OF ARTS AND COMMERCE. SOLAPUR, 101B MURARJI PETH DIST SOLAPUR413001",
  "UMA MAHAVIDYALAYA PANDHARPUR TAL.PANDHARPUR DIST-SOLAPUR",
  "MATOSHRI LAXMIBAI MHETRE  COLLEGE OF EDUCATION ,AKKALKOT TAL.AKKALKOT DIST-SOLAPUR",
  "COLLEGE OF ENGINEERING GOPALPUR RANJANI ROAD GOPALPUR PANDHARPUR-413304",
  "SHRI SHIVAJI MAHAVIDHYALAYA BARSHI   TAL.BARSHI DIST-SOLAPUR",
  "COLLEGE OF EDUCATION  BARSHI  413411 DIST. SOLAPUR",
  "BHAI CHHANNUSING CHANDELE COLLGE OF SOCIAL WORK  163 A RAILWAY LINE OLD EMPLOYMENT CHOWK  IN FRONTOF BHANDARE HOSPITAL SOLAPUR-413001",
  "D.P.B. DAYANAND COLLEGE.OF EDUCTION DAYANAND NAGER, RAVIWAR PETH-SOLAPUR-413002.",
  "SANGOLA MAHAVIDYALAYA, SANGOLA",
  "UMA SHIKSHANSHASTRA MAHAVIDYALAYA, PANDHARPUR TAL.PANDHARPUR DIST-SOLAPUR",
  "BRAHMDEVDADA MANE INSTITUTE OF TECHNOLOGY GAT NO. 137. BELATI.  TAL NORTH SOLAPUR,",
  "B. P SULAKHE COMMERCE COLLEGE BARSHI .413411 DIST SOLAPUR  MAHARASHTRA.",
  "PRIN. K. P. MANGALVEDHEKAR INSTITUTE OF MANAGEMENT CAREER DEVELOPMENT AND RESEARCH SOLAPUR DIST-SOLAPUR",
  "GREENFINGERS COLLEGE OF  COMPUTER AND TECHNOLOGY, SHANKARNAGAR, AKLUJ ",
  "SAMEER GANDHI KALA  MAHAVIDYALAYA, MALSHIRAS ",
  "PRATAPSINH MOHITE PATIL MAHAVIDYALAYA KARMALA DIST-SOLAPUR",
  "SHRI SWAMI SAMARTH EDUCATION COLLEGE GADEGAON ROAD BARSHI  TAL.BARSHI  DIST-SOLAPUR",
  "KASTURBAI COLLEGE OF EDUCATION ASHOK CHWOK SOLAPUR DIST-SOLAPUR 413 006 MAHARASHTRA",
  "SHOLAPUR SOCIAL ASSOCIATIONS ARTS AND COMMERCE, COLLEGE, SOLAPUR",
  "DESHBHAKATA  SAMBHAJIRAO GARAD MAHAVIDYALAYA. MOHOL-413213",
  "RAJARSHI SHAHU LAW COLLEGE BARSHI 413  411 DIST-SOLAPUR",
  "SOU.SUVARNLATA GANDHI MAHAVIDYALAYA VAIRAG TAL.BARSHI   DIST-SOLAPUR",
  "MAULI MAHAVIDYALAYA WADAL TAL.NORTH SOLAPUR DIST-SOLAPUR",
  "SHIVRATNA INSTITUTE OF MANAGEMENT STUDIES, AKLUJ",
  "SHRI SANT DAMAJI MAHAVIDYALAYA MANGALWEDHA   DIST-SOLAPUR",
  "MANDESH COLLEGE JUNONI TAL.SANGOLA DIST-SOLAPUR",
  "KARMVEER BHAURAO  PATIL MAHAVIDYALYA PANDHARPUR-413 304. DIST-SOLAPUR",
  "Arvindbabu Deshmukh Mahavidyalaya, Bharsingi Tah. Narkhed,Dis.Nagpur",
  "K. Vasantrao Naik Physical Education College, New Nandanvan",
  "Matoshree Anjanabai Mundaphule Social Work and Arts College, Narkhed",
  "V. Kaushalyayan Mahila Mahavidyalaya, Deori",
  "Ramji Pandav Master of Computer Management, Trimurti Chowk",
  "Jagat Prakash B Ed College, Siddartha Nagar",
  "Dr. Madhukarrao Wasnik PWS Arts & Commerce College, Kamptee Road, Nagpur-26",
  "Central Institute of Business Management, Research and Development,  Somalwada",
  "Shrikrishnadas Jajoo Grameen Seva Mahavidyalaya, Pipri-Wardha",
  "Sandesh Arts College, Sirsi",
  "Swami Vivekanand Mahavidyalaya , Amgaon",
  "Agnihotri College of Engineering Nagthana road",
  "Santaji College, Pt. Jawaharlal Nehru Marg",
  "MB Patel Arts Commerce College, Salekesa",
  "Priyadarshini Lokmanya Tilak Institute of Management Studies and Research, Hingna Road, Nagpur",
  "Diamond College of Commerce and Science, Jaffernagar",
  "Mahatma Jyotibaphule Physical Education College, Umred",
  "Cummins College of Engineering for Women, Mauja",
  "Tirpude Institute of Management Education, Civil Lines",
  "Priyadarshini J.L. College of Engineering ",
  "Nikalas Mahila Mahavidyalaya, Khamla",
  "Avtaar Maherbaba College, Manewara Road",
  "Sant Gajanan Maharaj Arts Commerce, giraj",
  "Bhawabhuti Mahavidyalaya, Amgaon",
  "Rajkumar Kevalaramani Girls College, Zaripatka",
  "Swami Vivekanand Samajkarya Mahavidyalya",
  "Shri. Nashikrao Tirpude College Of Physical Education, Nagpur",
  "Vidarbha Arts Commerce Women's College, Lakhni",
  "Sri Sainath College of Pharmacy, Davlameti",
  "Dhanwate National College, Congressnagar",
  "K D Pawar Physical Education College Saoner",
  "BHIWAPUR MAHAVIDYALAYA",
  "Sonekar college of Pharmacy, Koradi",
  "Dr Arun Motghare Mahavidyalaya Kondha-Kosra",
  "Kamla Nehru College, Sakkardhara",
  "Madhavrao Tidke Physical Education College, Mauda",
  "Suryodaya College of Engineering and Technology, Nagpur.",
  "Amar Arts and Commerce College, Takalghat",
  "Shankarlal Agarwal Science College, Salkesa",
  "Arts, Commerce and Science College, Arvi Dist. Wardha",
  "Yeshwant Mahavidyalaya, Seloo",
  "Jyotiba College of Physical Education, Higna Road",
  "Gopikabai Bhure Mahila Mahavidyalaya, Tumsar",
  "Arun Joshi Education College, Hanuman nagar",
  "Ishwar Deshmukh Physical Education College, Hanuman nagar",
  "Principal Sachhidanand Fulekar,  Arts College, Mehagaon Road, Tumsar",
  "Seth Kesarimal Porwal College of Arts and Science and Commerce, Kamptee",
  "Tai Golwalkar Mahavidyalaya, Ramtek",
  "Adilok Mahila B Ed College, Goregaon",
  "Regional Labour Institute, Old Morris College Campus",
  "Jay Vikas Mahavidyalaya, Shirpur (Hore), Ta.Deoli, Dist.Wardha",
  "Late Shri Govindrao Wanjari  College of Education, Borkhedi, Butibori,Nagpur",
  "Om Satyasai Arts Commerce College, Jawaharnagar",
  "Gyaneshwar Arts College, Pragati Nagar",
  "Rani Indirabai Bhonsale College, Kuhi",
  "Rambhau Pandagale Science and Management College, Sawangi meghe",
  "K.Z.S Science College, Bramhani, Kalmeshwar",
  "Kamla Nehru College of Pharmacy, Borkhedi",
  "Smt Radhikatai Pandav College of Engineering",
  "Savitribai Phule Women's College, Pavni",
  "Indutai Memorial College of Education, Hardoli",
  "Hislop College, Temple Road, Civil Lines, Nagpur",
  "Shiladevi Arts Commerce and Science College, Wadi",
  "Rajiv Gandhi Samajkarya Mahavidyalaya, Kudwa Road, Tah. Gondia, Dis. Gondia",
  "Aadinath  College of Education, Ranala, Kamptee",
  "Dr RG Bhoyar Institute of Pharmaceutical Education and Research, Bachelor Road",
  "Sharadchandra Arts and Commerce College, Butibori",
  "Bhiwgade  National College, Shantinagar, Nagpur",
  " NARAYANRAO KALE SMRUTI MODEL COLLEGE( KALA VANIJYA AND VIDHYAN ) Karanja (Ghadge) ",
  "Pragati Mahila Kala Mahavidyalaya",
  "Shri Chakrapani Kala Mahavidyalaya Hudkeshwar Road",
  "Bharat Friends Associations Bharat College of Arts & Commerce, Badlapur Hendre Pada, Kulgaon, Badlapur (W), Dist. Thane-421503",
  "Padmashri Annasaheb Jadhav Bharatiya Samaj Unnati Mandals Bhiwandi Nizampur Nagarpalika Arts Science & Commerce College Bhiwandi Dist Thane  421 305.\"",
  "Rachana Sansads College of Applied Arts and Craft 278 Shankar Ghanekar Marg Prabhadevi Mumbai  400 025 Started New Course Applied",
  "Dr B B Gaitonde Charitable Trusts B S Bandekar College of Fine Art (Applied Art)  At Sawantwadi Dist-Sindhudurg  416 510",
  "Konkan Education Societys Anandibai Pradhan Science College  Nagothane  Tal Roha Dist Raigad",
  "Shetkari Shikshan Santha's College of Management Studies & Commerce, Thane-Belapur Road, Ghansoli, Navi Mumbai-400 701",
  "Shahapur Taluka Education Societys College of Education Shahapur Dist Thane",
  "Dnyan Ganga Education Trusts College of Education (B.Ed.)  At Borivade Ghodbunder Road Thane(W)",
  "Shree Ghatkopar Sarvajanik Jivdaya Khatu Aruna Manharlal Shah Institute of Management & Research At R B Kadam Marg Jivdaya Lane Ghatkopar (W) Mumbai 400 086",
  "Dnyandeep Mandal's St. Joseph College of Arts & Commerce, Satpala, Rajodi Road, P.O. Agashi, Virar (West), Tal. Vasai, Dist. Palghar - 401301",
  "Annasaheb Vartak College of Arts Kedarnath Malhotra College of Commerce and E S Andrades College of Science  Vasai Road Dist- Palghar 401 202",
  "Guruvarya B S  Naik Memorial Trusts College of Arts & Commerce Co R P D High School Sawantwadi  Dist  Sindhudurg",
  "Nirmala Memorial Foundation College of Commerce and Science, Near Thakur Polytechnic, 90  Feet Road, Thakur Complex, Kandivli (E), Mumbai-400 101",
  "D S P Mandals K V Pendharkar College of Arts  Science and Commerce  MIDC Area  Dombivli  East  Dist Thane",
  "S P K Mahavidyalaya Sawantwadi Dist Sindhudurg",
  "Chetanas Hazarimal Somani  College of Commerce and Smt.Kusumtai Chaudhari College of Arts  Near Government Servants Colony  Bandra Mumbai",
  "Shree Shankar Narayan Education Trusts Rohidas Patil Institute of Management Studies At Navghar Bhayandar (E) Dist Thane",
  "Sir Mohamed Yusuf Seamen Welfare Foundation, Training Ship Rahaman, Nhava, Tal. - Panvel, Dist. Raigad - 410 206",
  "Rashtriya Shikshan Sansthas Swami Vivekanand Night College o Arts & Commerce Dombivli Chhatrapati Bhavan Ayare Marg Dattanagar Dombivli East Dist Thane 421 201",
  "Saket Gyanpeeths Saket College of Education Saket Vidyanagari Marg Chinchpada Road Katemanvali Kalyan (E) Dist  Thane",
  "K J Somaiya College of  Science & Commerce Vidyanagar Vidyavihar Mumbai",
  "Mumbai Educational Trusts Institute Management Studies Gen.Arunkumar Vaidya Chowk Bandra Reclamation,Bandra (West) Mumbai-400 050",
  "Adivasi Pragati Mandal Sanchalit Comrade Godavari Shamrao Parulekar College of Arts, Commerce & Science, Talasari, Taluka-Talasari, Dist : Palghar-401 606",
  "Vivekanand Education Societys College of Arts Science and Commerce Sindhi society Chembur Mumbai",
  "Gautam Educational Trusts Suraju Singh Memorial College of Education & Research Adhaeadi Jail Road (Kolwada) Umbardegaon Kalyan (W) Dist Thane",
  "National Institute for the Mentally Handicapped Fkat Bi, B-102 Vasundhara CHS Plot No 13-14  Sector 8 Kharghar Navi Mumbai 410 210",
  "Deccan Education Societys Navinchandra Mehta Institute of Technology and Development At Dadar Mumbai 400 028",
  "Marg Tamhane Education Societys Dr Tatya Saheb Natu College of Arts Marg Tamhane Taluka Chiplun Dist Ratnagiri 415 702.",
  "The Kelkar Education Trusts Vinayak Ganesh Vaze College of Arts Science and Commerce Mithagar Road Mulund East Mumbai",
  "Saket Gyanpeeth's, Saket College of Arts, Science & Commerce, Saket Vidyanagari Chinchapada Road, Katemanivli, Kalyan (East), Dist. Thane 421 306",
  "N K VARADKAR ARTS & R V BELOSE COMMERCE COLLEGE  DAPOLI  AT KALKAI KOND DAPOLI, DIST - RATNAGIRI - 415 712",
  "Kankavali College Kankavli",
  "Gramin Shikshan Sanstha's, Arts, Commerce & Science College, Majiwade, Dist.Thane- 400 601",
  "Shubhamkaroti Charitable & Educational Trust Universal College of Science Hospitality Studies) Survey No.108 Village Ambhai Post Kanchad Tal Wada Dist Thane 421 303",
  "Karachi Maharashtriya Shikshan Prasarak Mandals Sant Rawool Maharaj Mahavidyalaya, Kudal, Dist. Sindhudurg- 416520",
  "Jogeshwari  Education Societys college of Commerce Science and Information Technology Jogeshwari E  Mumbai 400 060",
  "Chembur Trombay Education Societys N G Acharya and D K Marathe College of Arts Science and Commerce Near Subhash Nagar N G Acharya Marg Chembur Mumbai  400 071",
  "Thadomal Shahani Engineering College 32nd Road TPS III Bandra Mumbai 400 050",
  "Lala Lajpatrai Institute of Management  Lala Lajpatrai Marg, Mahalaxmi, Mumbai 400 034",
  "College of Social Work Nirmala Niketan, New Marine Lines, Mumbai",
  "Keraliya Samajam Dombivli's Model College, Kanchangav, Khambalpada, Thakurli (E)",
  "Gharda Foundations Gharda Institute Of  Technology At & Post Lavel Tal Khed Dist  Ratnagiri",
  "Lokmanya Shikshan Prasarak Mandal's  Arts,Commerce & Science  Sr. College  at Chondhi  Post Kihim  Tal  Alibag  Dist Raigad",
  "Kishinchand Chellaram Law College, 123, Dinshaw Wachha Road, Vidyasagar Prin. K. M. Kundnani Chowk, Churchgate, Mumbai - 400 020",
  "Lala Lajpatrai College of Law, Lala Lajpatrai Marg, Haji Ali, Mahalaxmi (West) - 400034",
  "Maharashtra College of Arts Science and Commerce 246 A Bellasis Road Byculla Mumbai  400 008",
  "Burhani College, 10 Nesbit Road, Opp. St. Mary's High School, Mazgaon, Mumbai - 400 010",
  "Janata Shikshan Prasarak Societys Pandit Rajpati Mishra College of Education and Research Manorama Nagar Krishna Compound Near Shankar Temple Dhokali Thane (W)",
  "Karmayogi Shikshan Sansthas Chatrapati Rajashri Shahu Maharaj Senior College of Arts  Degaon Po Phanasu Tal Dapoli Dist Ratnagiri",
  "Shikshan Prasark Mandals Kirbet College of Arts & Commerce Sakharpa Taluka Sangmeshwar Dist Ratnagiri",
  "Aldel Education Trust's St. John Institute of Pharmacy & Research, At Vevoor, Manoor, Tal Palghar",
  "Vivek Education Society's  Vivek College of Commerce, Vivek College Road, Siddharth Nagar, Goregaon (West), Mumbai",
  "Peoples Education Societys Siddharth College of Commerce and Economics  Anand Bhavan Dr  Dadabhai Naoroji Road Fort  Mumbai  400 023",
  "Maharashtra Cosmopoliation Educational Society's M.C.E.S college of Education & Research Mumbra Dist.Thane ",
  "Konkan Gyanpeeths Rahul Dharkar College of Pharmacy and Research Institute Vengaon Road Dahivali Karjat Dist  Raigad  410 201",
  "Nava Balodyan Trusts Kohinoor College of  Hotel & Tourism Management Studies Bhikoba Waman Pathare Marg Dadar (West) Mumbai 400 028",
  "The Byramjee Jeejeebhoy College of Commerce, 33, M. Karve Marg, Opp. Charni Road Rly. Station, Mumbai - 400004",
  "ANANDIBAI DAMODAR KALE SHAIKSHANIK SANSTHA'S ANANDIBAI DAMODAR KALE DEGREE COLLEGE OF ARTS AND COMMERCE ",
  "Seva Sadan's College of Education, Seva Sadan Marg, Opp. Central Hospital, Ulhasnagar",
  "Gokhale Education Societys Shri Bhausaheb Vartak Arts Science and Commerce College M H B Colony Gorai Road Borivli West  Mumbai  400 091",
  "Maratha Mandirs Babasaheb Gawde Institute of Management Studies Maratha Mandir Marg Mumbai 400 008",
  "St. Francis Institute of Technology (Engineering College)",
  "Vasantdada Patil Pratishthan's College of Engineering and Visual Arts, Vasantdada Patil Educational Complex, Eastern Express Highway, Padmabhushan Vasantdada patil Marg, Sion, Mumbai-400022",
  "MGMs Institute of Management Studies & Research, MGM Educational Campus, Sector-1, Kamothe, Navi Mumbai - 410 209",
  "Kamladevi Educational Trusts Kamladevi College of Arts and Commerce at Vitthalwadi  Dist Thane",
  "Vighnaharta Trust s Shivajirao S Jondhale College of Engineering &Technology Asangaon Tal Shahapur  Dist Thane",
  "Yadavrao Tasgoankar Institute of Engineering & Technology, Dr. N. Y.  Tasgaonkar Educational Complex, Chandhai, Near Bhivpuri Road Railway Station, Tal. Karjat, Dist. Raigad-410201",
  "Smt. Dhaklubai Dhondu Thakrey, Samajik and Shaikshnik Sanstha's, Mahendra Laxman Mhatre Vyavsayik  Mahavidyalay, At Thakrupada, Post Dandekarwadi, Ranjnoli, Tal.- Bhiwandi, Dist. Thane - 421 302",
  "Bhimrao Pradhan College of Arts, Science and Commerce, Shahapur, Mumbai-Nashik Highway, Gotheghar, Kinawali-Murbad Chowk, Shahapur, Dist. Thane - 421 601",
  "Modern Education Society`s D G Ruparel College of Arts Science and Commerce Senapati Bapat Marg Mahim Opp Matunga Road Station Western Railway Mumbai  400 016",
  "Janata Shikshan Mandals Advocate Datta Patil College of Law Taluka  Alibag Dist. Raigad 402 201",
  "The South Indian Assosciation (Regd.) The S.I.A. College of Higher Eduction Plot 88 MIDC Residential Ares Dombivli (E)",
  "Mumbra Shikshan Prasarak Mandals G. R.Patil College of Arts  Science and Commerce  Behind Police Station Mumbra Dist Thane",
  "NAGSEN ART'S COLLEGE, AURANGABAD",
  "Jnan Vikas Mandals  Mohanlal Raichand Mehta College of Commerce Diwali Maa College of Science  Amritlal Raichand Mehta College of Arts  Dr. R T  Doshi College of Computer Science  Plot No. 9  Sector 19  Airoli  Navi Mumbai  400 708",
  "Konkan Education Societys Laxmi Shalini College of Arts Commerce and Science Womens College Pezari  Post Poyned Taluka Alibag  Dist Raigad  402 108",
  "Swayam Siddhi Mitra Sangh's Degree College at Sonadevi Compound Near Octroi Naka Kalyan Bhiwandi Road Vasai Diva Rail Route Bhiwandi Dist Thane",
  "Dnyandeep Shikshan Prasarak Mandal's Dnyandeep College of Science & Commerce, At/Post Morvande-Boraj, Tal. Khed,Dist. Ratnagiri-415709",
  "Rishi Dayaram and Seth Hassaram National College and Seth Wassiamull Assomull Science College, Linking Road, Bandra (W), Mumbai - 400 050.",
  "Shri Yashwantrao Chavan Shikshan Prasarak Mandals  Sinhgad Institute of Business Management, Mumbai, Plot No. 126, MHADA Colony, Chandivali, Powai, Mumbai - 400 072",
  "Sindhu Bharati Trusts Shri  Sindh Thakurnath S S T  College of Arts & Commerce Ulhasnagar Dist  Thane  421 005",
  "Rizvi Education Societys College of Arts Science and Commerce Rizvi Complex Off Carter Road Sherly Road Bandra West Mumbai  400 050",
  "Konkan Agriculture Education and Research institute College of Education (B.Ed.), Mandki-Palvan, Tal. Chiplun, Dist. Ratnagiri-415 641",
  "Mahatma Education Societys Vidyadhiraja College of Physical Education & Research Mahatma School of Academics & ports Sector 8 New Panvel (West) Dist. Raigad",
  "Janardan Bhagat Shikshan Sansthas  Bhagubai Changu Thakur College of Law At New Panvel Dist Raigad",
  "Shivai Shikshan Prasarak Mandal's Sundarrao More Arts, Commerce & Science College, Poladpur, Dist.- Raigad-402303.",
  "Terna Public Charitable Trusts Terna Engineering College Nerul Navi Mumbai",
  "Mother Velankani Education Trusts Ashadeep Adhyapak Mahavidyalaya (B.Ed.) Mahesh Park Tulinj Road Nallasopara (East) Tal  Vasai Dist Thane 401 209",
  "Vidya Mandir Mandals  Matoshree  Sumati Chintamani Tipnis College of  Arts & Commerce, At Mamdapuir, Neral, Tal. Karjat, Dist.-Raigad-410101 ",
  "Vighnaharata Trust, Shivajirao S. Jondhle College of Pharmacy, Asangaon. (E) Tal Shahapur Dist. Thane 421 601",
  "Rachana Sansad's Academy of Architecture,  278, Shankar Ghanekar Marg, Prabhadevi, Mumbai -400025.",
  "Konkan Unnati Mitra Mandals Vasantrao Naik Arts & Commerce College Murud Janjira Dist Raigad 402 401",
  "Mandar Education Societys  Lt Shashikant Gawde College of Education At & Post  Pedhambe (Bharde) Taluka  Chiplun Dist. Ratnagiri",
  "Children Welfare Centre Clara's College of Commerce, Yari Road, Versova, Andheri (W), Mumbai-400061",
  "Talat College of Education, Nandrabad, Tq. Khultabad.",
  "Sai Shikshan & Samajik Sanshodhan Sanstha College of Arts  Commerce & Science Behind Padmavati Apartment Near Ratnagiri Sindhudurg Dist Principals Association Vidyabhavan  Khareyewadi  At Sindhudurgnagari Dist  Sindhudurg",
  "\"Sir. J. J. College of Architecture, Dr. Dadabhai Nawroji Road,  Fort, Mumbai-400 001.  \"",
  "Guru Nanak Khalsa College of Arts Science & Commerce Kings Circle Matunga Mumbai",
  "Mahatma Education Societys Pillais College of Education, Chembur Naka, Mumbai",
  "Seth Hirachand Mutha Shaikshanik Trust College of Arts Commerce & Science Koliwali  Kalyan West  Dist  Thane.",
  "The East Kalyan Welfare Societys Model College of Science &Commerce East Kalyan Welfare Society Building Chinchpada Road Rajbhar Nagar Katemanivali Kalyan (East) Dist Thane 421 306",
  "Gyanodaya Shikshan Pracharak Samiti Lokmanya Nagar  Pada No.4 Pokharan Road No.1 Thane  400 606",
  "Rayat Shikshan Sansthas Abasaheb Marathe Arts & New Commerce Science College  Rajapur  Dist Ratnagiri",
  "Hind Seva Parishads Public Night Degree College, Shikshalaya, Hind Nagar, Public Mahavidyalaya Marg, Aaram Society Road, Vakola Market, Santacruz (East), Mumbai-400055",
  "P.E.S. College of Engineering, Nagsenvana, Aurangabad.",
  "Thakur Educational Trusts Thakur Institute of Management Studies Career Development and Research Thakur Village W. E. Highway Kandivli (East) Mumbai",
  "Prabodhan Shikshan Prasarak Sansthas Rajendra  Mane College of Engineering & Technology At Post Ambav (Devrukh),Tal.-Sangmeshwar,Dist.Ratnagiri-415804",
  "Habiab Educational & Welfare Societys Late Khatija College of Education at Deoghar Post Khanivali Tal Wada Dist Thane",
  "Sadhana Education Societys  L S Raheja College of Arts and Commerce  Juhu Road  Santacruz  West  Mumbai",
  "Shrimati Indira Mahadev Behere College of Arts  Shriman Chandulal Sheth Commerce and Shrimati Shobhanatai Chandulal Sheth College  of  Science  Khed  Dist  Ratnagiri  415 709",
  "Shri N B  Mehta Education Charity  Trusts College of Commerce Night R R P Municipal School Building  Shantilal Modi Road  Kandivli W  Mumbai  400 067",
  "Ratnam College of Arts Science and Commerce National High School Marg Bhandup West Mumbai  400 078",
  "People's Education Society's Siddharth College of Law 348, Anand Bhavan, Dr. Dadabhai Naoroji Road, Fort, Mumbai  400 023.",
  "Kalyan Wholesale Merchants Education Societys Laxman Devram Sonawane College of Arts & Commerce, Opp. Fire Station, Near Durgadi Killa, Murbad Road, Kalyan (W)-421301",
  "People's Education Society's Siddharth College of  Arts, Science and Commerce, Anand Bhavan, Dr. D. N. Road, Fort, Mumbai-400 001",
  "Lala Lajpatrai College of Commerce And Economics  Lajpatrai Marg, Mahalaxmi,  Haji Ali, Mumbai",
  "Khalapur Taluka Shikshan Prasarak Mandals  Khopoli Municipal Council College  Khopoli  Dist Raigad 410 203",
  "Shri Siddheshwar Mahavidyalay, Majalgaon, District-Beed.",
  "Chetna Shikshan Prasarak Mandal's (Vaijapur) Arts College",
  "Vidyavardhinis College of Engineering and Technology Vidyavardhinis College Campus Vasai Road (Western Railway) Dist Thane 401 202",
  "Shri Yashwantrao Chavan Shikshan Prasarak Mandals Sinhgad College of Commerce  Plot No  126  MHADA Colony  Chandivali  Mumbai 400 072",
  "Education Board Mulunds Jai Bharat  College of Commerce  Night  Mulund Colony Mulund W Mumbai  400 082",
  "Excelsior Education Societys K  C  College of Engineering Mith Bunder Road Kopri Thane (E)  400 603",
  "Rajiv Gandhi Arts, Commerce & Science College, Chincholi Phata, Bhoom.",
  "Sai College of Computer Education, Sai Nagar, Ranjani, Kalamb.",
  "Shri Swami Vivekanand Shikshan, Sanstha Kolhapur's College of Education, Osmanabad.",
  "Dr. Zakir Hussain College of Education, Khultabad.",
  "Balaghat Education Society's Yeshwantrao Chavan Mahavidyalaya, Tuljapur.",
  "Late. Bhagwanrao Kedar College of Education, Warni, Tq. Shirur Kasar",
  "Maulana Azad College of Arts, Science and Commerce, Aurangabad.",
  "Karmaveer Mamasaheb Jagdale Mahavidyalaya, Washi.",
  "Ashti Taluka Shikshan Prasarak Mandal's Adv. B. D. Hambarde Mahavidyalaya, Ashti",
  "Jai Bhawani Shikshan Prasarak Mandals, Mahila Mahavidyalaya Georai, Tq. Georai, Dist. Beed.",
  "Marathwada Shikshan Prasarak Mandal's, Law College.",
  "Matsyodari Shikshan Sanstha's Arts, Commerce & Science College, Ambad.",
  "Dr.Babasaheb Ambedkar Marathwada University Model College of Ghansawangi",
  "Shri Swami Vivekanand Sevabhavi Sanstha Sanchalit, Dyannvardhani B.C.A.& B.C.S. College, Parli Vaijanath",
  "Ajanta Shikshan Sanstha's Baburao Kale College of Arts, Ajanta, Sillod.",
  "Bhartiya Shikshan Sanstha's Gajanan Arts & Science College, , Golegaon, Sillod.",
  "Everest Educational Society's Group of Institutions",
  "Govt. College of Arts & Science, Kileark, Aurangabad.",
  "BGP'S Hitech Institute of Technology, MIDC, Waluj, Aurangabad.",
  "Jai Prakash Narayan College of Education, Near Deogiri College, Aurangabad.",
  "Late. M.L.C. Vasantraoji Kale Law College, Shivaji Nagar, Cidco, Aurangabad.",
  "Maharaja Sayajirao Giakwad Arts, Commerce & Science College, Bazar Sawangi, Khultabad.",
  "M.G.M's Jawaharlal Nehru College of Engineering, N-6, Cidco, Aurangabad.",
  "Milind College of Arts, Nagsenvana, Aurangabad.",
  "Nalanda College of Arts, Commerce & Science, Satara Parisar, Aurangabad.",
  "New Kohinoor Arts, Commerce & Science College, Chowka, Aurangabad.",
  "Pandit Jawaharlal Nehru Mahavidyalaya, Aurangabad.",
  "Sant Dnyaneshwar College of Arts, Science & Commerce, Soegaon.",
  "Tanzil College of Education, Mohmoodpura, Opp. Taj Residency, Aurangabad.",
  "Vivekanand Arts, Sardar Dalip Singh Commerce & Science College, Samarth Nagar, Aurangabad.",
  "Shri Datta Shikshan Prasark Mandal's Nalanda College of Computer Science, Ashti, Dist. Beed.",
  "Shivsagar Sevabhavi Shikshan Prasarak Mandal's College of Arts, Nandurghat, Kaij.",
  "Shri Bankatswami Arts & Commerce Mahavidyalaya, Beed.",
  "Shri Chhatrapati Shivaji Shikshan Sanstha's Kala Mahavidhyalaya, Adas, Kaij.",
  "Shri Guru Virupaksha Shivacharya Maharaj College, Manur, Shirur Kasar.",
  "Shri. Panditguru Pardikar Arts College, Shirsala., Parli  Vaijanath.",
  "Dharti Janseva Pratishthan Mauli College of Library & Information Science, Ambewadi, Jalna.",
  "Lal Bahadur Shastri Arts, Commerce & Science College, Ashti, Partur.",
  "Matsyodari Shikshan Sanstha's College of Engineering & Technology, Nagewadi, Jalna.",
  "Matsyodari Shikshan Sanstha's College of Law, Mastagad, Jalna.",
  "Rajureshwar Arts, Commerce & Science College, Dabhadi, Badnapur.",
  "Ramchandra Shikshan Sanstha's College of Journalism & Mass Communication, Mahatma Gandhi Road, Jalna.",
  "Smt.Dankuwar Mahila Mahavidyalaya, Jalna",
  "K.S.P. Mandal's, College of Library & Information Science, Mahatma Gandhi  Corner, Osmanabad.",
  "Saraswati Mahavidyalaya, Kaij",
  "Vasantrao Kale College of Management Science, Kalamb.",
  "Bhagwan  Shikshan Prasarak Mandal's Rashtramata Indira Gandhi Arts, Commerce & Science College, Jalna.",
  "Dagdojirao Deshmukh Arts, Commerce and Science College,Waluj,Gangapur, Aurangabad.",
  "Rajshri Shahu College of Education, Ambajogai.",
  "R.B. Attal Arts, Science & Commerce College, Georai.",
  "Moreshwar Arts, Science and Commerce College, Bhokardan",
  "Nagnathappa Halge College of Engineering, Parli-Vaijnath.",
  "Late. Adv. Shrinivasraoji Dagaduraoji Deshmukh College of Computer Science and Management, Bhokardan.",
  "Deogiri College Aurangabad",
  "Vivekanand Shikshan Sanstha, Shri Nath College of Education, Paithan.",
  "Late. Laxmibai Deshmukh Mahila Mahavidyalaya, Parli-Vaijnath.",
  "Rajiv Gandhi Institute of Information Technology and Biotechnology, Pune",
  "Institute of Management, Kolhapur",
  "Dental College and Hospital, Pune",
  "Institute of Environment Education and Research, Pune",
  "College of Nursing, Pune",
  "Yashwantrao Chavan Institute of Social Science Studies and Research, Pune",
  "New Law College, Pune",
  "Poona College of Pharmacy, Pune",
  "College of Nursing, Navi Mumbai",
  "Institute of Management and Rural Development Administration, Sangli",
  "College of Ayurved, Pune",
  "Institute of Hotel Management and Catering Technology, Pune",
  "Yashwantrao Mohite Institute of Management, Karad",
  "Bharati Vidyapeeth Deemed to be University College of Nursing, Sangli",
  "College of Physical Education, Pune",
  "Social Sciences Centre, Pune",
  "Interactive Research School for Health Affairs, Pune",
  "Medical College and Hospital, Sangli",
  "DR D Y PATIL SCHOOL OF LIBERAL ARTS",
  "Shivajirao S. Jondhale College of Engineering, Sonarpada, Dombivli (East) Dist: Thane",
  "LATE PUNDALIKRAO GAWALI ARTS AND SCIENCE MAHAVIDYALYA, SHIRPUR (JAIN) Tal. Malegaon Dist Washim 444 504.",
  "Sipna College of Engineering and Technology, Amravati ",
  "KAMLADEVI SHIKSHAN MAHAVIDYALAYA",
  "Swayam Siddhi Mitra Sangh's College of Management and Research, Sonadevi Compound,Temghar, Kalyan -Bhiwandi Road, Bhiwandi, Dist-Thane-421203",
  "Progressive Education Societys Modern College of Agriculture Biotechnology",
  "Tata Memorial Centre (TMC),Mumbai",
  "Bhabha Atomic Research Centre (BARC), Mumbai",
  "Homi Bhabha Centre for Science Education",
  "Sinhgad Technical Education Societys Sinhgad Institute of Technology & Science , Narhe Ambegaon,Pune  41",
  "Krantiveer Vasantrao Narayanrao Naik Shikshan Prasarak Sansthas Arts & Commerce College, Dindori, Dist.Nashik",
  "Bhima Shaikshanik Nyass Subhash Anna Kul College of Education,Pune",
  "Genba Sopanrao Moze Trusts Genba Sopanrao Moze College of Pharmacy,Pune",
  "All India Shivaji Memorial Societys College of Engineering, Pune",
  "Sinhgad Technical Education Societys Smt. Kashibai Navale College of Pharmacy, Kondhawa bk.,Dist.Pune  48",
  "Indian Law Societys I.L.S. Law College, Pune  411 004",
  "Jadeed Anjuman-E-Taleem's Haroon Ansari Girl's College of Education, Malegaon, Dist. Nashik",
  "Mahatma Phule Shaikshnik, Samajik, Sanskrutik & Krida Mandals Chhatrapati Shivaji Maharaj  College of Education,Jamkhed,Dist.Ahmednagar",
  "Shri Dattakrupa Shaikshnik & Krishi Gram Vikas Pratishthans College of Educaton, Ghargaon, Tal. Shrigonda, Dist. Ahmednagar",
  "Institute of Management and  Technology, M.V.P.Campus, Gangapur Road, Nashik 422002",
  "Shivnagar Vidya Prasarak Mandals College of Pharmacy, Malegaon Bk.Tal. Baramati, Dist.Pune",
  "SANJIVANI PRATISHTHAN COLLEGE OF EDUCATION",
  "ABMSPs Yashwantrao Chavan Law College, Pune",
  "S.V.N.H.TS COLLEGE OF B.PHARMACY, SHRISHIVAJINAHAGAR (RAHURI FACTORY)",
  "Trimurti Pawan Pratishthans Khasdar Shri Govindrao Aadik Law College, Shrirampur, Dist.Ahmednagar 413709",
  "Sarhads  Sarhad College of Arts, Commerce & Science, Katraj, Pune 46",
  "Nashik Rural Education Prasarak Mandals College of Pharmacy,Brahma Valley Education Campus ,Anjneri,Trymbkeshwar, Dist.Nashik 422212",
  "Satyaniketan's Adv. Manoharrao Nanasaheb Deshmukh Arts, Science & Commerce College, Rajur, Ta- Akole, Dist- Ahmednagar 422604",
  "Vidya Pratishthans College of Education, Baramati, Pune  413133",
  "Vidya Pratishthans Commerce & Science College, Vidyanagari, Indapur, Dist.Pune",
  "Chaudhary Attarsingh Yadav Memorial Education Trusts, Siddhant College of Engineering, Pune",
  "Maratha Vidya Prasarak Samaj's, GMD Arts BW Commerce & Science College, Sinnar, Tal. Sinnar, Dist. Nashik 422103",
  "Shri Khanderai Pratishthan Dnyansagar Institute of Management and Research, Balewadi, Pune 411045",
  "Pravara Rural Education Societys  Pravara Rural College of Pharmacy, Pravaranagar, Dist.Ahmednagar 413736",
  "Jog Education Trusts P. Jog College of Science & Commerce, Mayur Colony ,Kothrud, . Pune  411 038.",
  "Mohammadiya Education Societys Masumiya Shikshanshastra Mahavidyalaya,Bagroza Hudco Colony, Ahmednagar 414503",
  "OZAR VIKAS SANSTHAS VISHWASATTYA ARTS AND COMMERCE COLLEGE OJHAR MIG",
  "N.D.M.V.P.Samajs  Arts & Commerce College,Taharabad, Tal. Baglan, Dist. Nashik",
  "Progressive Education Societys Modern College of Pharmacy for Ladies, Borhadewadi,AtPost- Moshi, Tal. Haveli, Dist. Pune",
  "Hutatma Rajguru Shikshan Prasarak Mandal's Ratnai Mahavidyalaya, Rajgurunagar Pune",
  "Shri Jain Vidya Prasarak Mandal College of Education, Chinchwad, Pune 33",
  "Abhinav Education Societys College of Education, Pune",
  "Kopargaon Taluka Vidyarthi Sahayyak Samiti's Namdevrao Parjane Patil Law College,,In front of Kopargaon Court,  New Police Quarter, Kopargaon. Tal - Kopargaon, Dist - Ahmednagar - 423601",
  "Vidya Niketan Global Institute's Vidya Niketan College of Engineering  Address: 670, Taluka - Sangamner, District Ahmednagar 422602  ",
  "All India Shri Shivaji Memorial Society's Institute of Information Technology, Pune 411001.",
  "Audyogik Shikshan Mandals College of Commerce, Science & Information Technology,Pimpari,Pune-18",
  "Pune Institute of Computer Technology, Dhankawadi, Pune 411043",
  "Pravara Rural Education Society's Sir Visvesvaraya Institute of Technology, Chincholi, Tal. Sinnar, Dist. Nashik 422101",
  "Sinhgad Technical Education Societys Sinhgad Institute of Management, Vadgaon Bk., Off. Sinhgad Road, Pune 411041",
  "Shri Anand Vidya Prasarak Mandals Sancheti College of Arts, Commerce & Science ,Thergaon,Chinchwad,Pune 33",
  "Sinhgad Technical Education Societys Sinhgad College of Science, Vadgaon bk., Sinhgad road, Pune 41",
  "Dnyanvardhini Pratishthans, Dnyanvardhini College of Arts, Science and Commerce, Pune",
  "Deccan Education Societys Fergusson College, (Arts, Science), Pune",
  "Bharati Vidyapeeths College of Fine Arts, Pune",
  "Shikshan Prasarak Sansthas College of Education B.Ed., Ghulewadi, Sangamner College Campus,Sangamner, Dist. Ahmednagar",
  "Navashyadris Institute of Business Management and Research, Chakan, Tal. Khed, Dist.Pune  410501",
  "Prof Ramkrishna More Arts,Commerce & Science College, Akurdi, Pune 44",
  "CARMEL VIDYA BHAVAN TRUSTS CHRIST COLLEGE-PUNE ",
  "Janata Shikshan Prasarak Mandals Marutraoji Ghule Patil Arts,Commerce & Science College, Nagapur, Tal.& Dist. Ahmednagar",
  "Marathwada Mitra Mandal's College of Pharmacy, Pune 17",
  "Subhadra Education Societys S.N.B.P.College, Yerwada, Pune 6",
  "Nashik Gramin Shikshan Prasarak Mandals Brahma Valley Arts, Commerce & Science College, CIDCO, Nashik 422008",
  "Gokhale Edcuation Societys H.P.T.Arts & R.Y.K.Science College, Vidyanagar, Nashik 422005",
  "Rajmata Jijau Shikshan Prasarak Mandals Institute of Computer and Management Research,  Moshi, Alandi Road, Dudulgaon , Pune",
  "Marathwada Mitra Mandal's Shankarrao Chavan Law College, Pune 4",
  "Amrutvahini Institute of Management and Business Administration, Tal. P.O.Sangamner, SK, Dist. Ahmednagar 422608",
  "Shri Sairaj Shikshan Pratishthans  Vishwalata  Arts , Commerce and Science College Bhatgaon Yeola Tal Yeola Dist-Nashik",
  "SAMAJ SHIKSHAN MANDAL AMRUTESHWAR ARTS, COMMERCE AND SCIENCE COLLEGE, VINZAR",
  "Sane Guruji Shikshan Prasarak Mandal's Nasik Road Arts and Commerce College, Baragaon Pimpri,  Address: baragaon pimpari,  Taluka: Sinnar District: Nashik",
  "Indapur Taluka Gramvikas Pratishthan's Vishwasrao Ransing College (Arts, Commerce & Science), Kalamb-Walchandnagar,Pune",
  "Nashik Zilla Maratha Vidya Prasarak Samajs College of Education, Shivajinagar, Gangapur Road, Dist.Nashik 422002",
  "S.V.P.M. College of Engineering, Malegaon bk., Tal. Baramati, Dist Pune 413115",
  "Mumbai Education Trusts Institute of Engineering, Bhujbal Knowledge City, Adgaon, Nashik 422003",
  "Institute of Science Poona's Swami Vivekanand College of Education, S.no. 130, Mumbai-Bangalore Highway, Wakad, Pune 411057.",
  "Karve Institute of Social Service, 18 Hillside, Karvenagar, Pune 411052",
  "M.C.E.Society's Abeda Inamdar Senior College of Arts, Science and Commerce, Pune 411001",
  "Dhole Patil Education Societys Dhole Patil College of Engineering,Pune",
  "Om Shiv Foundation's Arts and Commerce Night College, Pune 11",
  "KARMVEER KAKASHEB WAGH EDUCATION SOCIETYS, K.K WAGH COLLEGE OF EDUCATION, NASHIK ",
  "All India Shivaji Memorial Societys Institute of Hotel Management and Catering Technology, Shivajinagar, Pune 411005",
  "Navjeevan Law College, Shivshakti Chowk, CIDCO, Nashik 422009",
  "Sinhgad Technical Education Society's Sinhgad College of Arts & Commerce, Narhe, Tal.Haveli, Dist. Pune",
  "Trimurti Pawan Pratishthans College of Education for Women Trimurtinagar, Nevasa Phata, Tal.Nevasa, Dist.Ahmednagar 414603",
  "Zeal Education Society's Dnyanganga College of Education, Sinhgad Road, Pune 411051",
  "Dang Seva Mandal's Arts College, Abhone, Taluka - Kalwan, District - Nashik 423502",
  "Sandip College Zodage Tal- Malegaon Dist-Nashik",
  "Kailas Shikshan Mandal's,  Arts and Commerce College, Rahu, Tal. Dound, Dist. Pune 412207",
  "Shri Mugutrao Sahebrao Kakade Mahavidyalaya Arts and Commerce, Someshwarnagar,Nira, Dist. Pune 412306",
  "Shri Gurudatta Shikshan  Sansthas Ajitdada Pawar College of Education, Manur, Tal. Kalwan, Dist.Nashik 423501",
  "Amrutvahini Sheti & Vikas Santhas Amrutvahini College of Engineering , Amrutangar, Tal.Sangamner, Dist. Ahmednagar 422608",
  "Progressive Educational Societys Modern College of Engineering,Shivajinagar, Pune 5",
  "P.R. Patil College of Architecture, Amravati",
  "Maratha Vidya Prasarak Samaj's Karmaveer Punjababa Goverdhane Arts, Commerce and Science College, Igatpuri, Nashik 422403",
  "Pune District Education Association's Mahatma Phule Institute of Management and Computer Studies, Hadapsar, Pune 411028",
  "Mahatama Gandhi Vidyamandir's Karmaveer Bhausaheb Hiray Arts, Science & Commerce College, Nimgaon, Taluka - Malegaon, District - Nashik ",
  "Saraswati Mata Shikshan Prasarak Sanstha Malegaon, Shri. B.M.Patil Arts & Commerce College, Dabhadi, Tal.Malegaon, Dist.Nashik",
  "Shikshan Prasarak Mandal's Sahebrao Shankarrao Dhamdhere Art & Commerce College, Talegaon Dhamdhere, Tal. Shirur, Dist. Pune 412208.",
  "Dnyaneshwar Gramonnati Mandals Hon.Balasaheb Jadhav Arts, Science and Commerce College,Pune",
  "Navsahyadri Charitable Trusts Institute of Management Science, Pimpri Bk., Payeet Road, Tal. Khed, Dist. Pune 410501",
  "Rayat Shikshan Santhas Maharaja Jivajirao Shinde Arts, Science & Commerce College, Shrigonda, Dist.Ahmednagar, 413701",
  "Rayat Shikshan Sansthas,  Dada Patil Mahavidyalaya, Karjat,  Dist. Ahmednagar",
  "MAEER's MIT Academy of Engineering, Alandi (Devachi), Dehu Phata, Taluka - Khed, District - Pune 412105",
  "Rajmata Jijau Shikshan Prasarak Mandal's Arts, Commerce & Science College, Landewadi, Bhosari,Pune 411039",
  "Camp Education Societys Dr. Arvind B.Telang Institute of Hotel Management, M.I.D.C.Chinchwad, Pune 411019",
  "Samarth Shaikshnik Samajik & Sanskrutik Pratisthans Samarth Shikshanshastra Mahavidyalaya, Kakadenagar, Satpur, Dist.Nashik",
  "Alard Charitable Trusts Alard College of Pharmacy, Pune",
  "Brahma Valley Institute of Management, Anjaneri, Tryambakeshwar, Nashik",
  "Arihant Education Foundation's Arihant College of Arts,Commerce & Science, Camp, Pune 411001",
  "Dr. D.Y.Patil Pratishthans Dr.D.Y.Patil Institute of Management Studies, Akurdi, Pune 411044",
  "Pragnya Educational Trusts Pragnya College of Management & Computer Studies Village Handewadi, Tal Haveli, Dist Pune 28",
  "Jaywant Shikshan Prasarak Mandals Imperial College of Engineering and Research, Gat No. 720 (1 and 2), Pune Nagar Road, Wagholi, Pune  412 207.",
  "The Shetkari Shikshan Mandals Padma Vasantdada Patil Institute of Technology, Bavdhan Khurd,Pune 38",
  "Kopargaon Taluka Education Societys K.J.Somaiya College of Arts,Commerce & Science College, Mohinirajnagar, Kopargaon, Dist.Ahmednagar 423601",
  "Shri Gajanan Maharaj Shikshan Prasarak Mandals Sharadchandra Pawar College of Engineering , At. Dumberwadi, Post. Khamundi, Tal. Junnar, Dist.Pune 412409",
  "Ambegaon Taluka Vidya Vikas Mandals B.D.Kale Mahavidyalaya,Pune",
  "Shri Marutrao Ghule Patil Shikshan Sansthas Jijamata College of Science & Arts, Dnyaneshwarnagar, At. Bhende Bk., Tal. Newasa, Dist.Ahmednagar 414605",
  "Bhartiya Dyanvardhini Sabhas Kantilal Khinwasara Education College,Pune",
  "Jagdamba Education Societys S.N.D.College of Engineering & Research Centre,Babhulgaon Tal. Yeola, Dist. Nashik 423401",
  "Al Ameen Educational & Medical Foundation's College of Engineering & Management Studies, Pune",
  "Shri Wagheshwar Gramvikas Pratishthan Sanchalit Shri Vasantrao Pharate Patil Arts, Commerce & Science College, Mandavgan Farata, Tal.Shirur, Dist. Pune 412211",
  "Gokhale Edcuation Societys  Sir Dr. M.S.Gosavi College of Commerce, Nashik 422005",
  "Sinhgad Technical Education Societys Smt.Kashibai Navale College of Education, Kusagaon bk., Lonavala,Tal. Maval,Dist.Pune",
  "Gramoday Trusts Rajeev Business School, Tathawade, Pune 411033",
  "Pune Vidyarthi Griha's College of Science & Commerce, Vidyanagari, Parvati, Pune 411009.",
  "Kannada Sangha Pune's Kaveri College of Arts, Science and Commerce, Ganeshnagar, Erandavane, Pune - 411038.",
  "Shri Dhokeshwar College, Takali Dhokeshwar, Tal - Parner, Dist - Ahmednagar",
  "Pimpri Chinchwad Education Trusts S.B.Patil Institute of Management, S.No. 26,Pradhikaran, Nigdi,Pune 411044",
  "Late Bhausaheb Hire Smaranika Trusts Institute of Pharmacy,Bhaygaon Road, Malegaon Camp, Dist.Nashik 423105",
  "Sou. Mathurabai Bhausaheb Thorat Sevabhavi Trusts S.M.B.T. College of Pharmacy, Nandhills, Damangaon, Tal.Igatpuri, Dist.Nashik",
  "Khatun Minority Womens Social Welfare & Educational Societys Royal College of Pharmaceutical,Educational & Research, Sachane Khurd, Malegaon, Dist. Nashik 423203",
  "Shri Sant Tukaram Shikshan Prasarak Mandals College of Education, Officiating Principal, Wadgaon Maval, Dist. Pune",
  "M.T.E.S.College of Hospital Management, Karve Road, Pune 411004",
  "Shahajirao Patil Vikas Pratishthans S.B.Patil College of Engineering, Vangali, Tal. Indapur, Dist.Pune 413106",
  "Ira Education Societys College of Education Sr.No.149-2 Arvi, Tal:Haveli, Dist:Pune",
  "Ahmednagar Jilha Maratha Vidya Prasarak Samajs New Law College, Ahmednagar 414001",
  "Indapur Taluka Shikshan Prasarak Mandals Arts, Science and Commerce College, Indapur,Pune",
  "Alard Charitable Trusts Alard College of Engineering & Management,Pune",
  "R.M.P.S.Bhalchandra College of Pharmacy, Gorhe Khurd, Pune 42",
  "K.K.Wagh Education Societys K.K.Wagh Arts, Commerce & Science & Computer Science College, Bhausahebnagar Tal.Niphad,Dist.Nashik 422301",
  "Nashik Rural Education Prasarak Mandals College of Education, Co Ed, Brahma Valley Educational Campus,Anjneri,Trymbkeshwar, Dist.Nashik 422212",
  "Kalwan Education Societys Arts, Commerce & Science College, Kalwan, Dist.Nashik 423501",
  "Shri Chhatrapati Education Sansthas Arts & Commerce College, Bhavaninagar, Tal. Indapur, Dist. Pune",
  "Pravara Rural Education Societys  Arts, Commerce & Science College, Alkuti,Tal. Parner,Dist.Ahmednagar",
  "Maharashtriya Mandals  Chandrashekhar Agashe College of Physical Education, Pune",
  "Shri Gajanan Maharaj Shikshan Prasarak Mandal's, Vilas Tambe Women's College of Education, Dumbarwadi, Otur, Tal. Junnar, Dist. Pune 412409",
  "Shivnagar Vidya Prasarak Mandals College of Commerce,Science & Computer Education, Malegaon Bk., Tal. Baramati, Dist.Pune",
  "Progressive Educational Societys Modern College of Arts, Science & Commerce , Ganeshkhind, Pune 53",
  "Vasantdada Patil Pratishthans Guruvarya Sadanand Maharaj Arts & Commerce College, Kondhawa bk., Pune 48",
  "Maharashtra Cosmopolitan Education Society's Allana College of Artchitechture, Camp Pune",
  "Progressive Education Society's, Modern College of Pharmacy, Sector No. 21, Yamunanagar, Nigdi, Pune  411044",
  "S.P.Mandalis Prin.N.G.Naralkar Institute of Career Development and Research, Shaniwar Peth, Opp. Prabhat Talkies, Pune 411030",
  "Mahatama Gandhi Vidyamandirs Arts,Science & Commerce College,Harsul, Tal. Trymbakeshwar, Dist.Nashik",
  "Arihant Education Foundations Arihant College of Education, Pune",
  "Sammati College of Education, washim.",
  "Shri Shivaji Education Society's, Smt. Ratnaprabhadevi Patil College, A/P. Bavada, Tal. Indapur, Dist. Pune  413103",
  "Jagdamba Education Societys S.N.D.College of Pharmacy, Babhulgaon Tal. Yeola, Dist. Nashik 423401",
  "Agricultural Development Trusts Sharadabai Pawar Mahila Arts, Commerce & Science College, Pune",
  "The Poona Jesuit Schools' Society's St. Vincent College , Pune 411037",
  "Khatun Monority Womens Social Welfare & Educational Societys A.M.College of Education English Medium, Aaishanagar, Malegaon Dist.Nashik 423203",
  "Kalyani Charitable Trusts Late G.N.Sapkal College of Engineering , Sapkal Knowledge Hub,Kalyani Hills, Anjaneri Vadholi, Tryambakeshwar, Dist.Nashik 422212",
  "K.E.S.Pratibha Institute of Business Management,Chinchwad, Pune 411019",
  "S.P.Mandals Tilak College of Education, Tilak Road, Pune 30",
  "Sanskar Mandir Sansthas Arts & Commerce College,Warje Malwadi, Pune 52",
  "Mula Education Societys College of Pharmacy, Sonai, Tal. Nevasa,Dist. Ahmednagar 414105",
  "JSPMs Jayawantrao Sawant College of Engineering, Handewadi Road, Hadapsar, Pune 28.",
  "Mahatma Gandhi Vidhyamandirs Karmaveer Bhausaheb Hiray Law College, Malegaon-Camp  Dist- Nashik- 423105",
  "Symbiosis College of Arts & Commerce, Senapati Bapat Road, Pune 411004.",
  "Maratha Vidya Prasarak Samaj's  Arts, Commerce & Science College, Trymbakeshwar, Taluka - Trymbakeshwar, District - Nashik 422212",
  "Sangamner Nagarpalika Arts, D.J.Malpani Commerce and B.N.Sarda Science College, Sangamner, Dist.Ahmednagar",
  "B.P.Hivale Education Societys Centre for Studies in Rural Development Institute of Social Work and Research, Station Road, Ahmednagar 414001",
  "Ahmednagar Jilha Maratha Vidya Prasarak Samajs New Arts,Commerce & Science College,Parner,Dist Ahmednagar  414302",
  "Sinhgad Technical Education Societys Nivrutti Babaji Navale College of Commerce and Science",
  "Shri Chhatrapati Sambhaji Shikshan Sansthas Sitabai Thite College of Pharmacy, Shirur, Ghodnadi, Dist . Pune  412210",
  "Shri Neminath Jain Brahmacharyashram (Jain Gurukul's) Karmveer Keshavlalji Harakchandji Abad Arts, Shriman Motilalji Girdharilalji Lodha Commerce and Shriman P.H.Jain Science College, Chandwad, Dist.Nashik 423101",
  "Sandip Foundation's Sandip Institute of Pharmaceutical Sciences, Mahirvani, Trimbak road, Taluka & District - Nashik 422213.",
  "CHME Societys Bhonsala Military College, Arts, Science & Commerce, Rambhumi, Nashik  422005",
  "S. S. HORTICULTURE COLLEGE AMRAVATI",
  "Govt. B.Ed. College, Buldhana",
  "Nanibai Education Mahavidyalaya Rathi Nagar, Amravati.",
  "Gulamnabi Azhad Arts, Commerce College, Barshi Takali.",
  "BHAGWANBABA BSC INTERIOR DESIGN MAHAVIDYALAY CHINCHOLI SANGALE, TA LONAR IST BULDHANA",
  "Indirabai Meghe Mahila Mahavidyalaya , Irwin Chowk, Morshi Road, Amravati.",
  "Shri Padamprabh Digambar Jain Arts College, Ansing,Tq- W'ashim.",
  "Savitri Jyotirao, Social Work College, Yavatmal.",
  "Govt. Pharmacy College, Govt. Pol. Area. Gadgenagar, Amravati",
  "Shri Sant Gajanan Maharaj Engineering College, Shegaon.",
  "Jagadamba Mahvidyalaya , Achalpur City",
  "Shri R. R. Lahoti Science College , Morshi.",
  "Late Panchphulabai Pawade Arts, Commerce Mahila mahavidyalaya , Warud",
  "Mahatma Jyotiba Fule College of Social Work, Yavatmal",
  "Babaji Date Arts and Commerce College, Yavatmal.",
  "Dr. Panjabrao Deshmukh Law College  , Morshi Road .",
  "Shri Vasantrao Naik Arts and Amarsingh Naik Commerce College, Mangrulpir.",
  "Shri Gajanan Maharaj Arts, Commerce College, Mukutban.",
  "Indira College , Kalamb.",
  "Shri Vasantrao Naik Mahavidyalaya, Dharni",
  "Gopikabai Sitaram Gawande College, Umarkhed",
  "Shri Ramrao Sarnaik Social Work College, Akola.",
  "Narayanrao Rana Mahavidhyalaya, Badnera Railway,Badnera ",
  "Late R. Bharti Arts, Commerce & Smt. S.R. Bharti Science College, Arni.",
  "Dr. R.N.Lahoti B.Ed. College,Sultanpur ,Tq. Lonar.",
  "Mahila Kala Vanijya Mahavidyalaya , Chandur Rly.",
  "Rajarshi Shahu College of Engineering, Rajarshi Shahu Nagar, Buldana.",
  "Matoshree Shantabai Gote Arts, Commerce & Science College, Washim.",
  "Ramrao Zanak Arts and Commerce College, Malegaon.",
  "Shri Sudhakarrao Naik Arts & Umashankar Khetan Commerce College, Akola.",
  "Gulamnabi Azad Education College, Pusad",
  "lshwar Deshmukh B.Ed. College, Digras.",
  "Dayabhai Patel Physical Education College, Yavatmal.",
  "Arts College, Buldhana",
  "Babasaheb Naik college of Engineering, Pusad",
  "RAMKRUSHNA MAHAVIDYALAYA, DARAPUR",
  "Mahatma Jyotiba Fule Social Work College, Buldhana.",
  "Shri Saraswati Socialwork College, Washim.",
  "Arts and Commerce College, Hivarkhed, Tq. Telhara",
  "Smt. Kokilabai Gawande mahila Mahavidyalaya, Daryapur Amravati",
  "Arts, Commerce College, Ralegaon.",
  "Arts & Commerce College, Boriarab, Tq. Darwha.",
  "Mungasaji Maharaj Mahavidyalaya, Darwha.",
  "Arts and Science College, Kamargaon, Tq. Karanja (lad)",
  "Mukul Wasnik Law College, Buldhana",
  "J.D. Patil Sangludkar Mahavidyalaya , Daryapur.",
  "Abasaheb Parvekar Arts, Commerce College < Yavatmal",
  "Arts & Commerce College, Warwat - Bakal, Tah. Sangrampur, Distt. Buldana",
  "Satyajeet B. Ed. College, Khandala, Tq. Mehkar Dist.Buldhana",
  "Anuradha College of Pharmacy, Chikhali.",
  "Ratrkalin (Night) Arts, Commerce College , Kiran Nagar, Amravati.",
  "Bar.Ramrao Deshmukh Arts, Smt. Indiraji Kapadiya Commerce & Naymurti Krushnrao Deshmukh Sci. College, Badnera    Rly .",
  "Vidyabharati College of Pharmacy , C.K. Naydu Road , Camp, Amravati",
  "Late Adv. Ramkrishnaji Rathi Law College, Washim.",
  "Mhatama Jyotiba Fule Mahavidyalaya , Akoli, Sainagar, Amravati.",
  "Pataldhamal Wadhwani B.Pharmacy College, Yavatmal.",
  "Late Ku. Durga Kanhaiyyalal Banmeru Science College, Lonar.",
  "Mauli Group of Institution's College of Engineering &  Technology, Shegaon,",
  "Prof Ram Meghe College of Engineering & Management, Badnera Rly",
  "B.S. Patel Arts, Commerce & Science College, Pimpalgaon",
  "Degree college of Physical Education, Hanuman Nagar Near Shri Ekvira Devi Temple, Amravati.",
  "Government engineering college, Infront of V.M.V. ,Amravati.",
  "Late. Yadavrao Dada Deshmukh Vidhi Mahavidyalaya, Achalpur Camp, Distt:-Amravati",
  "Sammati College of Law, Washim.",
  "S.P.M. Science and Gilani Art, Commerce College, Ghatanji. Maharashtra Yavatmal.",
  "Nankibai Wadhwani Arts College, Yavatmal.",
  "Rajiv Arts College, Patanbori, Tq. Kelapur.",
  "Shri Lakshmanrao Chandrabhanji Kherde Kala Mahavidyalaya, Karajgaon, Tq.Chandur Bazar. Distt:- Amravati",
  "Laxmibai Rajgadkar Smurti Kala Mahavidyalaya , Shripur , Tq- Wani.",
  "Late Dattatraya Pusadkar Arts College, Nandgaon Peth",
  "Arts, Commerce & Science College, Maregaon Road,Tq. Maregaon.",
  "Bhagwantrao Shivaji Patil Mahavidyalaya , Partwada, Tq-Achalpur city.",
  "Shri Ganesh Kala Mahavidyalaya, Shivani-Kumbhari, Tq. Akola.",
  "Law college, Akola",
  "Shri Shivaji Science College , Morshi Road , Amravati.",
  "Vandiniya Rashtrasant Tukdoji Maharaj Shikshan Mahavidyalya , Anjangaon Surji.",
  "Global Business School & Research Centre, Tathawade, Pune",
  "Dr. D. Y. Patil Biotechnology and Bioinformatics Institute, Tathawade, Pune",
  "Dr. D. Y. Patil Institute of Optometry and Visual Sciences, Pune",
  "Dr. D. Y. Patil Dental College & Hospital, Pune",
  "Nagpur Veterinary College, Nagpur",
  "College of Fishery Sciences, Nagpur",
  "College of Dairy Technology, Warud (Pusad)",
  "Bombay Veterinary College, Mumbai",
  "College of Veterinary & Animal Sciences, Udgir",
  "Post Graduate Institute of Veterinary & Animal Sciences",
  "Krantisinh Nana Patil College of Veterinary Science, Shirwal",
  "College of Dairy Technology, Udgir",
  "College of Fishery Sciences, Udgir",
  "College of Veterinary & Animal Sciences, Parbhani",
  "Shivaji College, Hingoli",
  "Govindrao Patil  College, Banchincholi Road, Hadgaon",
  "MGM's College of Agril Bio-Technology, N-6, CIDCO, Aurangabad",
  "College of Agriculture, Parbhani",
  "College of Home Science, Parbhani",
  "College of Food Technology, Udgir",
  "College of Agriculture, Selu",
  "College of Agriculture, Badnapur",
  "SMT. SUMITRABAI ANDHARE COLLEGE OF AGRICULTURE, SHIRLA",
  "S.V.I. COLLEGE OF AGRICULTURE, JALGAON JAMOD",
  "S.V.I. COLLEGE OF HORTICULTURE, JALGAON JAMOD",
  "SHRI. SANT SHANKAR MAHARAJ COLLEGE OF AGRI. PIMPALKHUTA",
  "VIVEKANAND COLLEGE OF AGRI. BUSINESS MGT. HIWARA",
  "MANOHAR BHAI PATEL COLLEGE OF AGRICULTURE, HIRATOLA",
  "VIVEKANAND COLLEGE OF AGRI. HIWARA",
  "COLLEGE OF AGRICULTURE, SONAPUR",
  "COLLEGE OF AGRICULTURE ENGINEERING JALGAON JAMOD",
  "SHRI. SARMATHA COLLEGE OF AGRI. DEULGAON RAJA",
  "MAROTRAO VADAFALE COLLEGE OF AGRI. YAVATMAL",
  "LATE R. G. DESHMUKH COLLEGE OF AGRICULTURE TIWASA",
  "COLLEGE OF AGRICULTURE, NAGPUR",
  "RAMKRISHNA BAJAJ COLLEGE OF AGRICULTURE, WARDHA",
  "COLLEGE OF AGRICULTURAL ENGINEERING & TECHNOLOGY, AKOLA",
  "College of Agriculture, Kolhapur",
  "Post Graduate Institute, Rahuri",
  "College Of Agriculture, Shivajinagar, Pune",
  "Jawahar Education Society's A. C. Patil College of Engineering, Plot No. 17, Sector 4, Kharghar, Navi Mumbai-410210",
  "COLLEGE OF AGRICULTURE, AKOLA",
  "COLLEGE OF AGRICULTURE, BRAHMANGAON (UMARKHED)",
  "S.S.A.C. Amravati",
  "COLLEGE OF HORTICULTURE, AKOLA",
  "SOU. VASUDHATAI DESHMUKH COLLEGE OF AGRICULTURE TALEGAON",
  "POST GRADUATE INSTITUTE, AKOLA",
  "DR. RAJENDRA GODE COLLEGE OF AGRI. BULDHANA",
  "SHRI. SEVAKBHAU WAGHE PATIL COLLEGE OF AGRICULTURE, KESALWADAWAGH TALUKA LAKHANI",
  "Abhinav Education Society's Institute of Management & Business Administration, Akole, Dhamangaon  Awari Road, Akole, Dist.Ahmednagar 422601.",
  "JSPM's Jayawantrao Sawant Institute of Management and Research, S.No. 58, Indrayaninagar,Handewadi Road, Hadapsar, Pune 411028.",
  "Shri Gurudatta Shikshan Sanstha Sanchalit Loknete Dr. J.D. Pawar College  of Pharmacy, Manur, Tal. Kalwan, Dist. Nashik",
  "TSSM's Bhivarabai Sawant College of Engineering & Research, Narhe, Taluka Haveli, District Pune 411041.",
  "Sandip Foundation's Sandip Institute of Engineering and Management, Mahiravani, Trimbak Road, Nashik 422213",
  "Jai Hind College of Engineering, Kuran, Tal. Junnar, Dist. Pune",
  "Central Hindu Military Education Societys Dr. Moonje Institute of Management & Computer Studies, Bhonsala Military College Campus,Rambhoomi, Nashik 422005",
  "Pune District Education Association's Institute of Technical Education, Research & Management, Sec. No. 28, Ganganagar, PCNTDA, Akurdi, Pune 411044.",
  "BUNTS SANGHAs RAMANATH PAYYADE COLLEGE OF HOSPITALITY MANAGEMENT STUDIES",
  "SINHGAD TECHNICAL EDUCATION SOCIETYS NBN SINHGAD TECHNICAL INSTITUTES CAMPUS, PUNE",
  "SINHGAD TECHNICAL EDUCATION SOCIETYS RASIKLAL M DHARIWAL SINHGAD TECHNICAL INSTITUTES CAMPUS, PUNE",
  "SINHGAD TECHNICAL EDUCATION SOCIETYS SKN SINHGAD INSTITUTE OF TECHNOLOGY AND SCIENCE, PUNE",
  "SUMAN RAMESH TULSIYANI CHARITABLE TRUSTS SUMAN RAMESH TULSIANI TECHNICAL CAMPUS FACULTY OF ENGINEERING, PUNE",
  "SMT AMBABAI KHOBRAGADE ARTS COMMERCE AND SCIENCE COLLEGE BRAMHAPURI",
  "SMT SHOBHATAI BANSOD ARTS COMMERCE AND SCIENCE COLLEGE KHEDMAKTA",
  "Shri Govindrao Munghate Arts & Science College, Kurkheda",
  "DR SWETA SMRUTI WOMEN COLLEGE DHANORA",
  "Netaji Subhashchandra Science College, Mulchera",
  "Shri Sadguru Saibaba Science & Commerce College, Ashti",
  "SADGURU SAI COLLEGE ATAPALLI",
  "SAU SUJATA MOTGHARE WOMEN COLLEGE DESAIGANJ",
  "ANIL SAOKAR AINCHWAR ARTS COLLEGE Bhangaram Talodhi",
  "SHANTABAI BHAIYA WOMEN COLLEGE BRAMHAPURI",
  "SHRI SANT GAJANAN MAHARAJ ARTS COLLEGE MUDZA",
  "SULOCHANA BELHEKAR SAMAJIK AND BAHU UDDIESHIYA SHIKSHAN SANSTHAs SANT DNYANESHWAR INSTITUTE OF MANAGEMENT AND BUSINESS ADMINISTRATION COLLEGE, NEWASA",
  "SASMIRAS INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH",
  "KONKAN MUSLIM EDUCATION SOCIETYs COLLEGE OF EDUCATION",
  "ANJUMAN-I-ISLAMS COLLEGE OF HOTEL & TOURISM MANAGEMENT STUDIES & RESEARCH",
  "Gondwana College of Arts, Commerce and Science, Jiwati",
  "Anjuman-I-Islams Institute of Hospitality Management, Dr. D. N. Road, Opp. Chatrapati Shivaji Terminus, Fort, Mumbai",
  "PRABHAKAR PATIL EDUCATION SOCIETYs B Ed COLLEGE, VESHVI",
  "MAHATMA EDUCATION SOCIETY'S PILLAI'S HOC COLLEGE OF ARCHITECTURE",
  "JANTA SHIKSHAN PRASARAK MANDALs JANTA ADHYAPAK MAHAVIDYALAYA",
  "POTDAR COLLEGE, DHANGARWADI, LATUR ROAD",
  "SHRI GURUGOVINDSINGHJI MAHAVIDYALAYA, ZARI",
  "SWAMI VIVEKANAND ARTS COLLEGE, KUNTOR",
  "ARTS AND COMMERCE COLLEGE, PHONDAGHAT",
  "MATSYODARI SHIKSHAN SANSTHA'S, ANKUSHRAO TOPE COLLEGE, JALNA.",
  "Yash Institute of Pharmacy, Waluj, Aurangabad.",
  "PEOPLES EMPOWERMENT GROUPS ISB&M SCHOOL OF TECHNOLOGY, NANDE VILLAGE, MULSHI",
  "JIJAMATA SHIKSHAN PRASARAK MANDAL, SARATI SANCHALIT JIJAMATA MAHAVIDYALAYA, SARATI, INDAPUR",
  "GURU GOBIND SINGH FOUNDATIONS GURU GOBIND SINGH COLLEGE OF ENGINEERING, & RESEARCH CENTRE, KHALSA EDUCATIONAL COMPLEX, GURU GOBIND SINGH MARG",
  "BHIMASHANKAR SHIKSHAN SANSTHA'S, DATTATRAY GOVINDRAO WALSE PATIL MAHAVIDHYLAY, A/P - DATTATRAY NAGAR, PARGAON, TAL: AMBEGAON, DIST: PUNE 412406",
  "Maharashtra Education Society's Garware College of Commerce, Karve Road, Pune-411004.",
  "\"Achievers College of Commerce and Management Night College, Near HDFC Bank, Santoshi Mata Mandir Road, Besides New High School Joshi Baug, Kalyan (W), Dist. Thane - 421301  \"",
  "VITTHAL (DAJI) PATIL ARTS, COMMERCE AND SCIENCE MAHAVIDYALA, SANGLI",
  "SMT PREMALATAI CHAVAN COLLEGE OF ARCHITECTURE, SATARA",
  "Dr. Rafiq Zakaria College for Women, Navkhanda, Aurangabad.",
  "Dr. Balasaheb Vikhe Patil Rural Medical College",
  "JAGDAMBA SHIKSHAN PRASARAK MANDAL SANCHALIT,PUNYASHLOK AHILYABAI HOLKAR B.Ed COLLEGE, GADHI,GEORAI",
  "Kokanes Kohinoor Technical Trusts Kohinoor College of Hotel & Tourism Management Studies",
  "Karmaveer Shankarrao Kale Education Society,s Sau.Sushilamai Kale Arts,Commerce & Science College Gautamnagar.",
  "International School of Management and Research, Pune",
  "DATTAKALA COLLEGE OF PHARMACY, SWAMI CHINCHOLI, DAUND",
  "AKOLE TALUKA EDUCATION SOCIETYs ARTS AND COMMERCE COLLEGE, SAMSHERPUR, AKOLE",
  "SUPRIYADIDI SULE COLLEGE OF NURSING, SHRIRAMPUR",
  "JIIUs INDIAN INSTITUTE OF MEDICAL SCIENCE AND RESEARCH, WARUDI, BADNAPUR",
  "ITM TRUST CHEMBUR, MUMBAIs ITM INSTITUTE OF HEALTH SCIENCE COLLEGE OF NURSING (B Sc), NEW PANVEL",
  "GOVERNMENT INSTITUTE OF FORENSIC SCIENCE, NAGPUR",
  "NAMCO COLLEGE OF NURSING (P B B SC) AND RESEARCH INSTITUTE, PANCHVATI",
  "MATOSHRI COLLEGE OF B SC NURSING, EKLAHARE",
  "SWAMI VIVEKANAND COLLEGE OF NURSING (B Sc), JALKOT ROAD UDGIR",
  "OYSTER COLLEGE OF NURSING (B Sc), MOUZA",
  "JEEVAN JYOTI PRATISTHAN, LATE SAU VASUDHA ZADE NURSING COLLEGE, SARKAR NAGAR",
  "DAUND MEDICAL FOUNDATIONS, SUSHRUSHA INSTITUTE OF NURSING SCIENCE, DAUND",
  "120072-GRAM VIKAS SHIKSHAN MANDAL MARWAD SANCHALIT, LATE. NHANABHAU MANSARAM TUKARAM PATIL ARTS COLLEGE, MARWAD,TAL-AMALNER,DIST-JALGAON.",
  "THAKUR SCHOOL OF ARCHITECTURE & PLANNING",
  "Rajmata Jijau Science & Commerce Night College of B.Sc. (I.T.)",
  "Ramesh Phirodia Education Trusts Ramesh Phirodia Arts, Commerce & Science College, Sakur, Taluka - Sangamner, District - Ahmednagar",
  "Ashwaghosh Education &  Vyayam Prasarak Mandal's  Womens College of Bachelor of Computer Application ",
  "Shirdi Sai Rural Institute's Arts, Science & Commerce College, Rahata, Taluka - Rahata, District - Ahmednagar",
  "Vidya Pratishthan's School of Architecture, Vidyanagari, Bhigwan Road, Baramati, District - Pune 413133.",
  "GOODWILL INTERNATIONAL FOUNDATION'S, SHREE JAYA ANAND COMMERCE & SCIENCE NIGHT COLLEGE, AT CHARAI, BESIDE DR.KUMBLA HOSPITAL,THANE (W) - 400 601",
  "Bombay Suburban Art and Craft Education Society, L.S. Raheja School of Architecture, Raheja Education Complex",
  "Bharati Vidyapeeth's College of Pharmacy,  Morewadi, Near Chitranagari, Kolhapur",
  "Vasantrao College of Nursing",
  "SHRI TANAJIRAO PATIL B.ED. COLLEGE ATPADI, TAL- ATPADI, DIST- SANGLI.",
  "Loknete Shri Dadapatil Pharate College of Pharmacy, Mandavgan Pharata, Tal- Shirur, Dist.- Pune 412211",
  "S. S. COLLEGE OF BIO TECHNOLOGY AMRAVATI",
  "Shahu Shikshan Sanstha's College of\t         Arts, Science & Commerce, Gorai, Plot No.2, RSc-34, Gorai-2, Mangal Murti Hospital Road, Near Shivnari Building, Borivli, Mumbai: 400 091",
  "Institute of Naval Medicine INHS Asvini Near R C Church Colaba Mumbai",
  "Smt. Gulbanu A. Lalani Educational Trusts College of Commerce for  Women, Dahisar (E), Mumbai  400 068.",
  "School of Public Health and Social Medicine (SPHSM)",
  "Sakeshwar Gramin Vikas Seva Sanstha's B.Ed. College, At. Gurukul, Lal Taki Road, Post - Savedi, Tal. & Dist. Ahmednagar 414001.",
  "SHREE SARASWATI COLLEGE OF NURSING ",
  "DR. Arun Motghare Mahavidyalaya, Vihirgaon",
  "Sau Sujata Motghare Mahila Mahavidyalaya, Umred",
  "College of Food Technology, Achloli, Mahad",
  "DADASAHEB MOKASHI COLLEGE OF AGRICULTURAL ENGINEERING AND TECHNOLOGY, RAJMACHI",
  "Rajarshi Chhatrapati Shahu Maharaj College of Agriculture Business Management Sangli ",
  "Dr. Hedgewar College of Nursing",
  "Padmashree Dr. D. Y. Patil College of Agricultural Engineering & Technology",
  "Shahu Shikshan Sanstha's  Nalanda College of  Law, Gorai, Plot No.2, RSc-34, Gorai-2, Mangal Murti Hospital Road, Near Shivnari Building, Borivli, Mumbai: 400 091",
  "LOKMANGAL COLLEGE OF AGRICULTURE BUSINESS MANAGEMENT, WADALA",
  "Sir J. P. College of Education And Research",
  "Vishwabharati Bahuuddeshiya Shikshan Sanstha  Arts Commerce and Science College Osmanabad",
  "BGPS Mumbai B.Ed College For Women",
  "LOKNETE MARUTRAO GHULE PATIL MAHAVIDYALAYA",
  "Chembur Trombay Education Society, CTES College of Architechture ",
  "PRIYADARSHANI GRAMIN MAHILA MANDAL LONI ARTS, COMMERCE AND SCIENCE COLLEGE",
  "DIVINE COLLEGE OF PHARMACY",
  "SMT.K.L.TIWARI COLLEGE OF ARCHITECTURE",
  "OYSTER COLLEGE OF PHYSIOTHERAPY",
  "WALWA TALUKA EDUCATION SOCIETYs, SHRI S. D. PATIL COLLEGE OF ARCHITECTURE",
  "ALARD COLLEGE OF BUSINESS STUDIES",
  "SASMIRAs INSTITUTE OF COMMERCE AND SCIENCE  ",
  "RAJEEV GANDHI COLLEGE OF MANAGEMENT STUDIES, GHANSOLI, NAVI MUMBAI",
  "GOVERNMENT COLLEGE OF ENGINEERING AND RESEARCH ,AVASARI",
  "SINHGAD TECHNICAL EDUCATION SOCIETYS SMT. KASHIBAI NAVALE COLLEGE OF ARCHITECTURE",
  "Smt. Putalaben Shah College of Education, Rajwada, Sangli",
  "SHRI LAHU BALA PARITKAR ARTS, COMMERCE AND SCIENCE COLLEGE, KOLHAPUR",
  "K.V.N. NAIK S. P. SANSTHAS LOKNETE GOPINATHJI MUNDE INSTITUTE OF ENGINEERING EDUCATION AND RESEARCH",
  "Shri Shivaji College of Education, Amravati.",
  "B. P. MARINE ACADEMY NAUTICAL SCIENCE, PANVEL",
  "IBSAR School of Law",
  "KALA INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH",
  " NAVNIRMAN SHIKSHAN SANSTHA'S LAXMIBAI SITARAM HALBE COLLEGE OF ARTS, COMMERCE AND SCIENCE, DODAMARG",
  "LATE ANJANABAI BHANGE WOMENS COLLEGE KARANJA DIST WARDHA",
  "Y.J.M. MAHAVIDIYALYA, TALEGAON  (S.P.) TA. ASHTI, DIST WARDHA",
  "SIDDHARTH B.ED COLLEGE - BORADPADA",
  "Bhagwanbaba Arts , Commerce College, Lonar.",
  "GOVERNMENT COLLEGE OF ENGINEERING",
  "Saibaba Arts and Science College",
  " Balasaheb Thackeray Law College",
  "SHRI MAHILA MAHAVIDYALAYA, KHARANGNA KACHNOOR",
  "Shramshakti College of Agricultural Engineering,maldad",
  "College of Agriculture, Achloli",
  "M.I.P.COLLEGE OF FOOD TECHNOLOGY, AUNDHA NAG. ",
  "Nanded Rural Dental College and Research Center,Nanded.",
  "College of Agriculture Golegaon.",
  "Dr. Arun Motghare Mahavidyalaya Kurkheda",
  "Nanded Physiotherapy College and Research Center",
  "Amdar Shashikant Shinde Mahavidyalaya  , Medha ",
  "ST. PAUL COLLEGE",
  "Rayat Shikshan Sanstha's Annasaheb Awate Arts, Commerce & Hutatma Babu Genu Science College, Manchar, Tal.Ambegaon, Dist.Pune 410503.",
  "Renuka Education Society, Renuka College of Education, Renapur ",
  "KISHORI COLLEGE OF MBA,BEED",
  "Latur College of Pharmacy, Hasegaon",
  "Sau.Shantadevi Vedprakash Patil Ayurved College And Research Institute, Hatta",
  "MARATHWADA MAHILA KALA MAHAVIDYALAYA, AURANGABAD ",
  "RANI PUTALABAI WOMEN S LAW COLLEGE",
  "MUP S COLLEGE OF PHARMACY (B. PHARM)",
  "NAGARJUNA INSTITUTE , NAGPUR",
  "SHRI VILE PARLE KELAVANI MANDALS INSTITUTE OF PHARMACY, DHULE",
  "Yashaswi Education Society's International Institute of Management Science, Elpro International, Chinchwad, Pune 411033",
  "Army Law College, Kanhe",
  "Ratnadeep College of Pharmcy (B.Pharm) Ratnapur Taluka Jamkhed District Ahmednagar",
  "GOVERNMENT COLLEGE OF ENGINEERING YAVATMAL",
  "SHRI PANDHARINATH ARTS COMMERCE SCIENCE COLLEGE POKHARI",
  "RAJKUNWAR COLLEGE PIMPLA TQ SOEGAON DIST AURANGABAD",
  "PEOPLES COLLEGE OF FORENSIC SCIENCE and CYBER SECURITY, SHENDRA PARISAR, AURANGABAD",
  "Samaj Prabodhan Sanstha, Chandrabhama Mahavidyalaya, At/Post- Karjat, Ta - Karjat, Dist - Ahmednagar 414402",
  "Shri. L.P. Raval Education Trust, Shri. L.P. Raval College of Mass Media & Management Studies, RavalNagar, Near New Post office, Mira Road (E) , Thane-401 107. ",
  "Gurukul college of Bachelor in Computer Application, Kale",
  "RASHTRIYA KALA MAHAVIDHYALYA HATNOOR",
  "Dhaneshwari Arts,Commerce and Science College",
  "Late Bhagirathi Yaswantrao Pathrikar College of Pharmacy",
  "JSPM`s JAYAWANT INSTITUTE OF MANAGEMENT STUDIES",
  "Devyanee Mahila Mahavidyalaya",
  "Mahatma Gandhi Vidyamandir's Sau. Smitatai Hiray College of Applied Arts, Performing Arts and Fashion Design, Panchavati, Nashik 422003. ",
  "YASHWANTRAO CHAWHAN ARTS, COMMERCE & SCIENCE COLLEGE, LAKHANDUR",
  "SURAJ INSTITUTE OF MANAGEMENT",
  "P R POTE (PATIL) COLLEGE OF AGRICULTURE, AMRAVATI",
  "Swami Vivekanand College of Pharmacy, Udgir",
  "Santram Lomate Senior College, Salgara D",
  "SHREE KSHETRA AJUBAI PRESIDENCY SENIOR and JR. COLLEGE OF SCIENCE, ARTS, COMMERCE, ANWA",
  "BHONSALA INSTITUTE OF NURSING DR.MOONJE MARG RAMBHOOMI OPP GURUJI RUGNALAYA ",
  "SRINATH COLLEGE ARTS COMMERCE and SCIENCE",
  "Shivaji Mahavidyalaya, Gadchiroli",
  "Dr. D.Y. Patil Pratishthan's D. Y. Patil Institute of Master of Computer Applications and Management, Akurdi, Pune 411044",
  "D G Tatkare Arts and Commerce College Tala Tal Tala Dist Raigad  402 111",
  "S. Chandra Mahila Mahavidyalaya, Ashti",
  "Nirmala College of Commerce, Rani Sati Muncipal School Bldg, Rani Sati Marg, Malad (E) Mumbai 400097",
  "MATOSHRI NILIMATAI SHINDE KALA, VAANIJYA, VIGYAN MAHILA MAHAVIDYALAY, CHICHORDI, BHADRAWATI",
  "Sir Vithaldas Thackersey College of Home Science (Autonomous College), Santacruz(W) Mumbai-49",
  "NAVSAHYADRI EDUCATION SOCIETYs GROUP OF INSTITUTIONS, NAIGAON,PUNE",
  "Padmashri Dr. G. G. Jadhav Mahavidyalaya, Gaganbavada, Dist. Kolhapur",
  "PUNYASHLOK AHILYADEVI HOLKAR COLLEGE OF AGRICULTURE",
  "Late. Nirdhan Patil Waghaye Arts And Science College Murmadi/Tupkar.",
  "Mahatma Jyotiba Fule Mahavidyalaya, Ballarpur",
  "Shripatrao Chougule Arts and Science College,Malwadi-Kotoli,Tal-Panhala,Dist-Kolhapur",
  "Indira College of Engineering & Management, Parandawadi,Taluka - Maval, District - Pune 410506",
  "Marathwada Mitra Mandal's Institute of Management, Education Research and Training, Sr.No.18, Plot No.5/3, CTS No.205, Karve Nagar, Pune 411052",
  "Srinath College of Pharmacy, Aurangabad",
  "Girijan Physical Education Mahavidyalaya , Mardi Road, Amravati.",
  "SHRI DHANESHWARI NURSING COLLEGE, AURANGABAD",
  " Shree Goraksha Arts Commerce and Science Senior Collage, Khamgaon, Aurangabad.",
  "DR NAIKWADI COLLEGE OF D PHARMACY ",
  "JIIUs Indian Institute of Medical Science and Research.Mother Hawwa Nursing College",
  "NANDKUMAR SHINDE COLLEGE OF PHARMACY, VAIJAPUR",
  "DJPS COLLEGE OF PHARMACY ",
  "INDIRA GANDHI MAHILA MAHAVIDYALAYA GHUGUS",
  "DAYANAND COLLEGE OF ARCHITECTURE, LATUR",
  "Institute of Forensic Science",
  "Madhukarrao Pawar Arts College, Murtizapur.",
  "Innovative Engineers and Teachers Education Society's, Bharat College of Engineering, Opp. Gajanan Maharaj Temple, Kanhor, Badlapur (W) Tal. Ambernath, Dist. Thane- 421 503.",
  "Suwalal Patni Arts Commerce College, Pulgaon",
  "Shri Tripura Mahavidyalaya",
  "Trinity College of Pharmacy",
  "MES Senior College",
  "Rashtrasant Janardhan Swami College of Physiotherapy",
  "Ma Aa Shivajirao Kardile arts commerce and science college  Jamb Kaudgaon",
  "SUNRISE COLLEGE OF ARTS COMMERCE AND SCIENCE SHRIGONDA ",
  "SHRI SAI JANVIKAS PRATISTHANS B.ED.COLLEGE ,AT. ALANI TQ: OSMANABAD DIST: OSMANABAD",
  "J.B.S.P.Mandals Arts and Science College, Patoda District Beed",
  "R B Mundada College of Arts Commerce and Science Nere Dattawadi Tal Mulshi Dist Pune ",
  "Sterling Institute of Management Studies  Plot No.93 93A Sector 19 Nerul (E) Navi Mumbai 400 706",
  "The Mechanised infantry Regimental Centre MIRC",
  "R. N. Education Trust's Reckon Women Degree College of Commerce, R. N. Nagar,  Vakan Road, Vakan Pada, Behind Shalimar Udyag Nalasopara (E), Dist.- Palghar-401209",
  "SUNRISE COLLEGE OF HOSPITALITY AND MANAGEMENT STUDIES",
  "LATE WAMANRAO GADDAMWAR ARTS AND COMMERCE COLLEGE KUNGHADA RAI",
  "Guru Nanak Institute of Hotel Management and Catering Studies ",
  "GOVERNMENT AYURVED COLLEGE AND HOSPITAL, JALGAON",
  "SMT SURYAKANTA TELGOTE MAHILA MAHAVIDYALAYA, YAVATMAL",
  "Sai Seva Shikshan Prasarak Mandals Shri Pandit Baburao Chaughule College of Pharmacy",
  "PROF RAVINDRA NIKAM  COLLEGE OF PHARMACY B PHARMACY DHULE",
  "Adarsh Mahila Commerce and Science College Hingoli",
  "Dr D Y Patil Arts Commerce Night College Pimpri Pune  ",
  "RASHTRIYA SHIKSHAN MANDAL N N SATTHA COLLEGE OF PHARMACY",
  "ABHINAV JNYAN MANDIR SANSTHA ABHINAV JNYAN MANDIR ARTS SCIENCE COMMERCE COLLEGE",
  "Abhinav Mahavidyalaya",
  "Janta Shikshan Prasarak Mandals Arts Commerce and Science Mahavidyalaya Hupari Tal Hatkanangle  Dist Kolhapur",
  "PUNDLIK PRASHASKIYA MAHAVIDYALAYA",
  "Indira Gandhi Fashion Design College ",
  "Vasantrao Naik Govt. Institute of Arts and Social Sciences, Nagpur",
  "Shatayu College of Professional Studies, Hingna",
  "Hariom Senior College Turkabad",
  "Oasis mahavidyalaya",
  "Jivan Pragati Arts Comm Science Sr College, Karmad",
  "shri sant wamanbhau sanskrut mahavidyalya gahininathgad ",
  "R R Mahavidyalay",
  "R D MAHAVIDYALAY",
  "Arunodaya Dnyan Prasarak Mandal's Women's College, Jalgaon",
  "Shri Balaji Shikshan Prasarak Mandal, Ambajogai. College of Compute Science and I.T., Ambajogai.",
  "ISHWARI AMMA MAHILA KALA AND VANIJYA MAHAVIDYALAYA TIRORA",
  "HIRWAL EDUCATION TRUST HIRWAL RATRA MAHAVIDYALAYA",
  "Shahbabu Education Society Shahbabu Womens College Patur",
  "Pratibhatai Pawar College Of Pharmacy Shrirampur ",
  "Kai Banai Chougule Arts Commerce and Science Mahavidyalaya  Manjare Tal Shahuwadi Dist Kolhapur",
  "Nashik Shikshan Prasarak Mahdal Arts and Commerce Ratra Mahavidyalaya NashikRoad",
  "Progressive Education Society's Modern College of Arts, Science and Commerce, Warje, Pune 411058",
  "Vasantdada Patil Pratisthans Law College",
  "Chinchni Tarapur Education Society's Shri Purshottamdas Laldas Shroff College of Arts & Commerce Mahavidyalaya, Chinchani,Tal Dahanu, Dist-Palghar- 401 503.",
  "Hindustani Education Society's Azad Senior College, Ausa",
  "Dr Deepak patil Nursing Institute ",
  "Shirgaon Panchakroshi Shiskshan Prasarak Mnandal Mumbai Pundalik Ambaji Karle Arts and College Shiraon",
  "SHRI SANT GAJANAN MAHARAJ COLLEGE OF PHARMACY BULDANA",
  "DR MOHAMMED BADRODDIN SENIOR COLLEGE JALNA",
  "Bharatratna Dr Babasaheb Ambedkar Law College",
  "Times and Trends Academy of Fashion Design",
  "Dr. (Sow) Indirabai Bhaskarrao Pathak Mahila Kala Mahavidyalay, Samarth Nagar, Aurangabad.",
  "Kamla  Raheja Vidyanidhi Institute of Architecture and Environmental Studies, Vidyanidhi Marg of 10th Road, Juhu Scheme, Juhu, Mumbai - 400 049.",
  "JD College of Engineering, Khandala",
  "W.K.B.S. MANDAL'S DR S. R. AJMERA MCA COLLEGE FOR WOMEN, DEOPUR, DHULE.",
  "Rajashri Shahu Maharaj Mahavidhyalay",
  "Dr. Ambedkar Institute of Social Work, Kailas Nagar, Nagpur - 27",
  "Arts and Commerce Mahavidyalaya, Thadipauni",
  "South Indian Childrens Education Societys, Degree College of Arts, Science and Commerce, Chikloli, Ambernath (W), Thane - 421 505",
  "Kunbi Shikshan Prasarak Sanstha Khed, Tukaram Baburao Kadam College of Arts, Science & Commerce, Bharne Naka, Tal.- Khed, Dist.- Ratnagiri-415621",
  "Smt. Shakuntalabai Dhabekar Mahavidyalaya, Karanja Lad, Dist: Washim",
  "M.V.P.Samajs College of Architecture,Nashik 422002",
  "COLLEGE OF HORTICULTURE DAPOLI",
  "SWA BHARATSINH THAKUR KALA VANIJYA VA VIDNYAN MAHAVIDYALAY JAWALA TQ ARNI DIST YAVATMAL ",
  "K.D. Gavit Physiotherapy College, Pathrai Site, Tal. Dist. Nandurbar",
  "PRITI ACADEMY EDUCATION  SOCIETYS  PRITI  ACADEMY LAW C OLLEGE  KALYAN  MURBAD ROD MHARAL TAL KALYAN DIST THANE ",
  "LATE NARAYAN MEGHAJI LOKHANDE MAHARASHTRA INSTITUTE OF LABOUR STUDIES",
  "SAI CARE COLLEGE OF PHYSIOTHERAPY NASHIK",
  "SAI CARE COLLEGE OF NURSING NASHIK",
  "SARSAM COLLEGE OF PHARMACY",
  " LATE P V BELHEKAR MAHAVIDYALAYA",
  "RELIABLE COLLEGE",
  "Karmaveer Bhaurao Patil  College of Engineering, Satara",
  "VIDYA VIKAS EDUCATION TRUSTS UNIVERSAL COLLEGE OF ARCHITECTURE",
  "CHHATRAPATI SHIVAJI MAHARAJ MAHAVIDHYALAYA OSMANABAD",
  "M.C.E.Society's M.A.Rangoonwala Institute of Hotel Management & Research, Azam Campus, Camp, Pune 411001",
  "BAKLIWAL FOUNDATION",
  "DNYANDEEP PRASHASKIYA MAHAVIDYALAYA CHAUGAN TA BRAMHAPURI DIST CHANDRAPUR",
  "TEJGYAN SENIOR COLLEGE",
  "CHEFS KITCHEN INSTITUTE OF CULINARY ARTS AND HOTEL MANAGEMENT KOLHAPUR",
  "SURYADATTA INTERNATIONAL INSTITUTE OF CYBER SECURITY SIICS",
  "LATE LAXMIBAI PHADTARE COLLEGE OF PHARMACY KALAMB WALCHANDNAGAR",
  "ANGLO EASTERN MARITIME ACADEMY",
  "SIDDHAGIRI NURSING INSTITUTE ",
  "SHRI SHIVAJI MAHAVIDYALAY MAREGAON",
  "KALYANI PATIL DEGREE COLLEGE",
  "MATOSHRI  MAHAVIDYALAYA",
  "THAKUR PRASHASKIY MAHAVIDYALAY JAWALA",
  "COLLEGE OF AGRICULTURE MUL MARODA DIST CHANDRAPUR",
  "SHRI BHASKARRAOJI BATHE NURSING COLLEGE AKOLA",
  "SWAMI VIVEKANAND MAHAVIDYALAYA  DEOLAPAR TAL RAMTEK DIST NAGPUR",
  " Sheila Raheja Institute of Hotel Management, Raheja Education Complex, Opposit Colgate Ground,  Khernagar, Bandra (E) Mumbai  - 400 051  ",
  "Matru Sewa Sangh Institute of Social Work, Bajajnagar, Nagpur",
  "Kai. Bhausaheb Hiray Smaranika Samiti Trust's Indira College, Malegaon, Nashik.",
  "SHRI KESHAORAO SHENDE MAHAVIDYALAYA GADMOUSHI",
  "SHIV COLLEGE OF MANAGEMENT SCIENCE",
  "JOSHABA CIVIL SERVICES MAHAVIDYALAY",
  "DR GYANRATNA CIVIL SERVISES COLLEGE",
  "Deogiri Pratishthan Tulsi College of Fashion Design Beed",
  "MATOSHRI MAHILA MAHAVIDYALAY",
  "EKLAVYA MAHAVIDYALAY ",
  "Shri Ambabai Talim Sanstha, Sanjay Bhokare Group of Institutes, Faculty of Engineering,  Tilak Nagar, Miraj-Sangli Road, Miraj  416 414, Dist-Sangli.",
  "Aravind Gavali College of Engineering, Gat, Panmalewadi,",
  "Shri Vijaysinh Yadav College, PETH-VADGAON",
  "Gauri Shankar Institute of Pharmasutical Education and Research",
  "Shivraj College of Arts, Commerce and D.S. Kadam Science College, Gadhinglaj.",
  "SETH SUBHASHBABU GOWARDHANDASJI PALIWAL COLLEGE OF PUBLIC ADMINISTRATION",
  "RASHTRASANT TUKADOJI MAHARAJ NAGPUR UNIVERSITYS DR BABASAHEB AMBEDKAR COLLEGE OF LAW",
  "KRANTIVEER VASANTRAO NARAYANRAO NAIK SHIKSHAN PRASARAK SANSTHAS ARTS COMMERCE AND SCIENCE COLLEGE SINNAR",
  "SHIVTEJ AROGYA SEVA SANSTHAS SIDDHAYOG LAW COLLEGE KHED",
  "VITHU MAULI PRASHASKIYA SEVA MAHAVIDYALAYA ",
  "Maratha Vidya  Prasarak Samaj 's Karmaveer Raosaheb Thorat  Arts & Commerce College, Vani, Tal.Dindori District - Nashik 422215.",
  "VAISHANAVI ARTS AND COMMERCE COLLEGE SADAK ARJUNI",
  "LATE KU ARCHANATAI CHAVAN ARTS COMMERCE AND SHRI MANOHARRAO NAIK SCIENCE MAHAVIDYALAYA KONDALA",
  "JAI BHARAT PRASHASKIY SEVA PADVI MAHAVIDYALAY HINGOLI",
  "SANT NAMDEV PRASHASKIYA SEVA PADVI MAHAVIDHYALYA",
  "JET INDIA ",
  "PREMIER COLLEGE",
  "KISSAN ARTS COMMERCE AND SCIENCE COLLEGE PARNER",
  "College of Horticulture, Parbhani",
  "Ayurved Vidya Prasarak Mandals Ayurved Mahavidyalaya, Sion (E), Mumbai",
  "Rajiv Gandhi Medical College, Kalwa, Thane",
  "DIPAK ABA SALUNKHE PATIL MAHAVIDDYALAYA KOLE",
  "GLOBAL VILLAGE ARTS SCIENCE AND COMMERCE COLLEGE BORAMANI",
  "DEFENCE CAREER ACADEMY SENIOR COLLEGE",
  "SHREE PANACHAVATI EDUCATION SOCIETY INSTITUTE OF PHARMACY",
  "RASHTRASANT DR SHIVLING SHIVACHARYA MAHARAJ SENIOR COLLEGE LATUR",
  "SURYADATTA INSTITUTE OF HEALTH SCIENCES  COLLEGE OF PHYSIOTHERAPY ",
  "KISANJI TAGDE MAHAVIDHYALAYA",
  "RIDDHI VINAYAK COLLEGE OF NURSING",
  "SVJCT's  Samarth Nursing College, At-Kasarwadi, Post-Sawarde, Tal. Chiplun, Dist-Ratnagiri-415606",
  "Shree Gurudatta Gramvikas Pratishthan,  Jijamata Senior College, Jategaon Bk., Tal. Shirur, Dist. Pune-412 208.",
  "Sushila Shankarrao Gadhave Mahavidyalaya, Khandala Tal. Khandala Dist. Satara",
  "People's Education Society's (Mumbai) Milind College of Science, Nagsenvan ,Aurangabad.",
  "Vidnyan Mahavidyalaya, Malkapur, Dist.Buldhana",
  "Vidyalankar School of Information Technology, Vidyalankar Educational Campus, Vidyalankar College Marg, Wadala (East), Mumbai - 400037",
  "JAGDAMBA EDUCATION SOCIETYS S.N.D. ARTS, COMMERCE & SCIENCE COLLEGE, YEOLA",
  "Shri Jain Vidya Prasarak Mandal Sangavi Keshri Arts & Commerce College, Opposite Finolex Company, Tal - Haweli, (excluding Corporation Area), Dist Pune - 411019 ",
  "Swami Vivekanand Shikshan Prasarak Mandal, Swami Vivekanand College Of Education, Survey No. 184, Jalkot Road, Bodhan Nagar, Udgir",
  "Pushpak Mahavidyalaya, Umred",
  "Hanuman Vyayam Prasarak Mandal's College of Engineering & Technology, Amravati",
  "Bharat Shikshan Sanstha's Arts, Science and Commerce College Makni, Tq. Lohara, Dist. Osmanabad",
  " Chhatrapati Shahu Maharaj Shikshan Sanstha's Ayurved Mahavidyalaya & Rugnalaya, Aurangabad",
  "Marathwada Shikshan Prasarak Mandal's Shri Muktanand College, Gangapur, Dist. Aurangabad",
  "Viva School of Architecture, New Building, Viva Campus, Shirgaon Virar (East) - 401305 Tal. : Vasai, Dist. : Palghar",
  "Siddhivinayak Shikshan Prasarak Mandals R. K.  B.Ed. College Ram Nagar Rawate Compound Tembe Pada Road Bhandup (East) Mumbai 400 078",
  "Tuljabhavani Education Social & Welfare Societys Shree Saptashrungi Arts & Commerce College, Dangsaundane, Tal. Baglan, Dist. Nashik 423301",
  "PRAVARA RURAL EDUACTION SOCIETY S SINDHUTAI VIKHE PATIL COLLEGE OF NURSING CHINCHOLI SINNAR NASHIK",
  "Decade Devrukh College of Art & Design, bhagwat Sankul, Middle Lane, Tal. - Sangmeshwar, Dist. Ratnagiri - 415804",
  "Kai.Shri. Y. D. Patil Arts, Commerce & Science College, Yavaluj, Tal. Panhala Dist. Kolhapur",
  "Late Kedari Redekar Ayurvedic Mahavidyalaya, Gadhinglaj, Dist. Kolhapur",
  "200009-ABHAY YUWA KALYAN KENDRA'S ARTS MAHILA MAHAVIDYALAYA, DHULE.",
  "Jayawant College of Engineering & Polytechnic, Gat,Kille Machindragad,",
  "Mahatma Gandhi Vidyamandir's, Loknete Vyankatrao Hiray Arts, Science & Commerce College, Panchavati, Nashik, Dist. Nashik - 422003.",
  "SWA MISHRILALJI ZADKHANDE  PRASHASKIYA MAHAVIDYALAY BAMADEHI TQ CHIKHALDARA",
  "SMT SHALINITAI MEGHE AYURVED MEDICAL COLLEGE AND HOSPITAL  ",
  "ASHVIN ARTS, COMMERACE, SCENCE COLLEGE MANCHI HILL",
  "Shri Rambhau Shelke Vidhi Mahavidyalaya, Khamgaon, Dist-Buldhana ",
  "Niranjanlal Dalmia Institute of   Management Studies and Research Shristi Sector-1 Mira Road (E) Dist Thane  401 104",
  "Elphinstone College Fort Mumbai 400 032",
  "120064-SHRAM SAFALYA EDUCATION SOCIETYS, PANDIT JAWAHARLAL NEHRU COLLEGE OF SOCIAL WORK, AMALNER",
  "SHRI PRAKASHCHAND JAIN COLLEGE OF EDUCATION AND RESEARCH",
  "Shri Hari Educational Trust's St. Rock's Degree College of Commerce & Science, Talepakhdi  Eksar Village Near Aquaria Club  Borivali  (W),  Mumbai  400 092 ",
  "Secondary Training College   3 Mahapalika Marg Mumbai  400 001",
  "The Institute of Science  Fort Mumbai  400 032",
  "D.D. Bhoyar College of Arts and Science, Mouda",
  "SVSS LATUR COLLEGE OF PHYSIOTHERAPY, HASEGAON",
  "SHRI GAJANAN MAHARAJ MAHILA MAHAVIDYALAY, AMGAON",
  "MAEER COLLEGE OF NURSING TALEGAON DABHADE",
  "TOLANI MARITIME INSTITUTE,INDURI",
  "VEDANTAA INSTITUTE OF NURSING SCIENCES, SASVAND, DHUNDALWADI, TAL DAHANU  DIST PALGHAR",
  "SAIKRUPA COLLEGE OF AGRICULTURAL ENGINEERING AND TECHNOLOGY GHARGAON TAL SHRIGONDA, DIST AHMEDNAGAR",
  "Shri Dadapatil Rajale Shikshan Sanstha's Dadapatil Rajale Arts & Science College, Adinathnagar, Tal. Pathardi, Dist. Ahmednagar 414505",
  "GOVERNMENT AYURVED COLLEGE,BARAMATI",
  "LATE VILASRAO DESHMUKH COLLEGE OF PHYSIOTHERAPY ",
  "BHAWABHUTI SHIKSHAN SANSTHA AMGAON SHRI LAXMANRAO MANKAR INSTITUTE OF PHARMACY AMGAON",
  "Krantisurya Annasaheb Patil Social work College, Dharashiv",
  "Womens College of Arts, Commerce and  Computer Application, Dongar Kathore, Tal.- Yawal, Dist.- Jalgaon",
  "KALASAI COLLEGE BAHIRVADI,TQ BEED,DIST BEED",
  "TALENT HUNT COLLEGE PISADEVI TQ,DIST,AURNGABAD ",
  "HOMRAJ KOPGATE PRASHASKIY SEVA MAHAVIDYALAY JAMBHALI SADAK TA SAKOLI DIST BHANDARA",
  "UNIVERSAL BA CIVIL SERVICES COLLEHE NERLA ADYAL",
  "SWA SHAMRAOJI ALHAT MAHAVIDYALAYA ANJANI BK",
  "VIDHYA SACHCHIDANAND FULEKAR MAHAVIDHYALAYA,HANAVATKHED ROAD BULDHANA",
  "LATE JAMUNABAI COLLEGE UMARI,NAWEGAON BANHD",
  "SHRI GAJANAN MAHARAJ VARISHTHA MAHAVIDYALAYA PACHORA",
  "ANNASAHEB MAHAVIDHYALAY PIMPALGAON KOLTE TA BHOKARDAN DI JALNA",
  "CHATRAPATI SHAHU MAHARAJ MAHAVIDYALAYA KHARPUDI TAL, DIST. JALNA",
  "RADHE KRUSHNA MAHAVIDYALAYA PARTUR",
  "RAJKUNWAR MAHAVIDYALAYA SOMTHANA",
  "RAJKUNWAR MAHVIDYALAYA BHOKARDAN",
  "RAJRUDRA VARISHTHA MAHAVIDYALAY VADIGODRI",
  "SAMARTH MAHAVIDYALAY JAFRABAD TQ JAFRABAD DIST JALNA",
  "VITTHALA VARSHTHA MAHAVIDYALAY",
  "JANKI MAHAVIDYALAY AHMADPUR",
  "Hutatma Rajguru Shikshan Prasarak Mandal's,  Arts, Commerce & Science College, A/P Dehane, Ta: Khed, Dist: Pune 412402",
  "Novel Institute of Business Management & Research NIBR College of Hotel Management & Catering Technology, NIBR Sant Tukaram Sankul, Nigdi Pradhikaran, Tal. Haweli, Dist. Pune 411044",
  "Pratibhatai Patil Mahila Shikshanshastra Mahavidyalaya, Vidyabharti College Campus, Amravati",
  "Anand Vishwa Gurukul College of Law, T.M.C. School No. 18, Near Mental Hospital, Near A.C.C. Cement Colony, Thane (West)-400604",
  "Pune District Education Association's,  Annasaheb Waghire College of Arts, Science & Commerce , Otur, Tal. Junnar, Dist. Pune 412409",
  "Dr. D. Y. Patil Pratishthan's, Dr. D. Y. Patil College of Pharmacy, Sector No. 29, Pradhikaran, Akurdi, Pune - 411044i",
  "UNIQUE MAHAVIDYALAY JAITPUR, PO JAITPUR TA LAKHANDUR DIST BHANDARA ",
  "MATOSHRI BALJABAI BURDE MAHAVIDYALAYA  ASOLA ",
  "SHREE SWAMI VIVEKANAND MAHAVIDYALAYA AMGAON",
  "SHREE CHICHGAD MAHAVIDYALAYA CHICHGAD",
  "NARAYANI MOHANLAL CHANDAK COLLEGE BONDGAON DEVI",
  "Natraj Art and Culture Centre",
  "RAJKUNWAR MAHAVIDYALAYA KINWAT",
  "VISHWARATNA PRASHASKIY MAHAVIDYALAY IT BHUM DIST USMANABAD",
  "VITTHALA VARISHTHA MAHAVIDYALAY",
  "RADHASHYAM PRASHASKIY SEVA MAHAVIDYALAY, PARBHANI",
  "ANAND MAHAVIDYALAYA WAIFAD TAH DIST WARDHA",
  "SHRI DADASAHEB HIVASE PATIL MAHAVIDYALAYA",
  "DR USHAKIRAN THUTE MAHAVIDYALAY, CIVIL LINE, GOKUL DHAM MAIDAN,  HINGANGHAT DIST WARDHA",
  "SWA SAVITABAI LAXMAN GHADE MAHAVIDYALAYA ALLIPUR TAH HINGANGHAT DIST WARDHA",
  "VIVEKANAND COLLEGE OF CIVIL SERVICES HINGANGHAT ",
  "SWA AANANDRAO GOVINDRAO AMBHORE KALA, WANIJYA, VIDHNYAN MAHAVIDYALAY, MOTHEGAON, TA RISOD, DIST WASHIM",
  "SMT SWA INDIRABAI ANANDRAO AMBHORE KALA, VANIJYA, VIDNYAN MAHAVIDYALAY, RAJGAON, TA DIST WASHIM",
  "RAJKUNWAR MAHAVIDYALAYA WANI",
  "Dr. S.C. Gulhane Prerna College of Commerce, Science and Arts, Reshimbagh Chowk, Nagpur",
  "Gandhigram College, Wardha",
  "SHRI MOHATADEVI SEVABHAVI PRATISHTHAN CRYSTAL COLLEGE , RANJANGAON GANPATI,TAL SHIRUR ,DIST PUNE ",
  "Vishwatmak Jangli Maharaj Ashram Trust (Kokamthan), Atma Malik Institute of Technology & Research, Aatgaon, Tansa - Aghai Road, At. Mohili, Post. Aghai, Viakalyan, Tal. Shahapur, Dist.Thane - 421301",
  "200057-GRAM VIKAS MANDAL'S KRANTIVEER NAVALBHAU ARTS COLLEGE, NAVALNAGAR-424318, TAL.& DIST-DHULE.",
  "SAKET COLLEGE OF LAW",
  "Savitribai Phule Shikshan Prasarak Mandal's Loknete Gopinathji Munde Arts, Commerce and Science College, Mandangad, Dist. Ratnagiri - 415 203",
  "GARBHGIRI COLLEGE FOR WOMENS PATHARDI",
  "SHRI BALASAHEB TIRPUDE COLLEGE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "Sakharitola Mahavidyalaya, Sakharitola",
  "Al Jamia Mohammediyah Education Society's, Maulana Mukhtar Ahmad Nadvi Technical Campus, Mansoora, P. O. Box. No. 144, Malegaon, Dist. - Nashik 423203",
  "D C NARAKE SENIOR COLLEGE KARANJPHEN TAL SHAHUWADI DIST KOLHAPUR",
  "D C NARAKE SENIOR COLLEGE KUDITRE KOPARDE TAL KARVEER DIST KOLHAPUR",
  "SHRIMATEE INDUMATI KASAR MAHILA MAHAVIDYALAYA ADARKI BK TAL PHALTAN DIST SATARA",
  "Oriental Education Societys Sanpada College of Commerce & Technology, Sanpada, Sector2, Plot No. 3, 4, 5, behind Sanpada Railway Station, Sanpada (West), Navi Mumbai - 400705",
  "Sant Kuriakose Elias Chavara B.Ed College",
  "270047-SHRI. D.H. AGRAWAL ARTS, SHRI. RANG AVADHOOT COMMERCE AND SHRI. C. C. SHAH AND M.G. AGRAWAL SCIENCE COLLEGE, NAVAPUR TAL. NAVAPUR DIST. NANDURBAR",
  " Mahatma Phule College Of Education, Tal.Sangola Dist-Solapur",
  "Late. Nirdhan Patil Waghaye Arts, Commerce & Science Mahavidyalaya, Tah. Lakhni, Dis. Bhandara",
  "Swami Vivekanand Gramin Shikshan Prasarak Mandal, Loha-Kandhar Road, Loha, Nanded",
  "Shirur Shikshan Prasarak Mandal's Chandmal Tarachand Bora  College of Arts, Commerce and Science, Shirur-Ghodnadi, District - Pune 412210.",
  "Vidya Prasarak Mandal Kinhavali's Arts, Commerce & Science College, Kinhavali, Tal. Shahapur, Dist.Thane - 421405",
  "Tilak Education Society's, Sarada Kurup College of Education & Research, Plot No. 22, Sector-5, Opp. Ghansoli Station, Navi Mumbai-400 701",
  "Marathwada Shikshan Prasarak Mandal's Shivchhatrapati College, Cidco, Aurangabad.",
  "Sahakarbhushan S. K. Patil College, Kurundwad, Dist. Kolhapur",
  "D Y PATIL SCHOOL OF ENGINEERING AND MANAGEMENT",
  "Pune Vidyarthi Griha's College of Engineering & Shrikrushna S. Dhamankar Institute of Management, Nashik 422004",
  "Mauli Vidyapeeth Kaij's Pramiladevi Patil Arts and Science College, Neknoor, Tq. Dist. Beed.",
  "Raje Dharamrao College Of Science, Aheri",
  "Victor Dantas Charitable & Educational Foundation's Victor Dantas Law College, Hasina Manzil, Near Bhairav Mandir, Kudal,Sindhudurg-416 520",
  "Vishweshwar Education Societys Western College of Commerce & Business Management Plot No.2  Sector 9 Sanpada  Navi Mumbai  400 705",
  "Manjara Charitable Trust College of Law ,Sector 4, Airoli  Navi Mumbai - 400 708",
  "B. K. Birla College of Arts, Science & Commerce, Kalyan, B. K. Birla College Road, Kalyan, Dist. Thane",
  "Shri Rishikesh Shikshan Prasarak Mandal's D. D. Vispute College of Pharmacy & Research Center, Gut No. 104, Devad-Vichumbe, Adjacent to Mumbai Pune Express Highway, Near Panvel, Raigad-410 206",
  "Kavikulguru Kalidas Sanskrit University's College of Education, Nagpur",
  "PRITI ACADMY DEGREE COLLEGE, MAHARAL",
  "Smt. Fatimabai M. S. Educational Trust's Mumbra College of Arts & Commerce (Night),C/o.St.Johns Convent High School,Near Canara bank, Mumbra, Dist .Thane - 400 612 ",
  "Karnala Sports Academys Barns College of Arts, Science & Commerce plot no.7, sector-16, Behind HOC colony Taluka Panvel Dist. Raigad- 410 206",
  "Karamvir Dadasaheb Deotale Mahavidyalaya, Chamorshi",
  "Shri Shivaji Arts, Commerce & Science College, Akot",
  "BALASAHEB THAKARE SENIOR COLLEGE, MALI GHOGARGAON",
  "DR ASHOK GUJAR INSTITUTE OF PHARMACY KARAD",
  "DR BAPUJI SALUNKHE INSTITUTE OF ENGINEERING AND TECHNOLOGY, KOLHAPUR",
  "SHRI DHANESHWARI MANAV VIKAS MANDALS, PARBHANI MEDICAL COLLEGE, PEDGAON, PARBHANI",
  "LIFELINE INSTITUTE OF NURSING, PANDHARPUR, SOLAPUR",
  "AANANDI LAW COLLEGE KALAMBE TARFE KALE TAL KARVEER DIST KOLHAPUR",
  "DATTAJIRAO KADAM LAW COLLEGE ICHALKARANJI TAL HATKANGALE DIST KOLHAPUR",
  "DR D Y PATIL INSTITUTE FOR SUGAR ALLIED PRODUCTS TECHNOLOGY AT POST WESARAF PALSAMBE TAL GAGANBAWADA DIST KOLHAPUR",
  "SINDHU SENIOR COLLEGE GANDHINAGAR KOLHAPUR",
  "SARDAR RAMCHANDRA BADE ARTS COMMERCE SCIENCE COLLEGE PUNAL TAL PANHALA DIST KOLHAPUR",
  "SURYAKANT SADASHIV DINDE BAPU ARTS COMMERCE AND SCIENCE COLLEGE GANESHAWADI BIDSHED TAL KARVEER DIST KOLHAPUR",
  "SWARGIY AMBAJI BABURAO KHAMKAR GURUJI SENIOR COLLEGE DHAMOD TAL RADHANAGARI DIST KOLHAPUR",
  "VYANKATRAO ARTS COMMERCE SCIENCE COLLEGE AJARA TAL AJARA DIST KOLHAPUR",
  "MANALIS INSTITUTE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY KASEGAON TAL WALWA DIST SANGLI",
  "GURU NANAK VIDYAK SOCIETYS LAW COLLEGE",
  "K M S P COLLEGE OF COMMERCE",
  "ZAGDU SINGH CHARITABLE TRUSTS THAKUR SPECIALIZED DEGREE COLLEGE",
  "NIRMAL EDUCATION SOCIETYS, SUBHASH DESAI COLLEGE OF LAW",
  "RECKON DEGREE COLLEGE OF ARTS AND COMMERCE",
  "ANJUMAN HIMAYTUL ISLAM SENIOR COLLEGE, MAHAD",
  "SHRIMAD RAJCHANDRA AATMA TATVA RESEARCH CENTRES SHREE RAJ COLLEGE",
  "BOMBAY INSTITUTE OF PHARMACY AND RESEARCH",
  "PRAVIN ROHIDAS PATIL COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "K M E SOCIETY NIGHT DEGREE COLLEGE OF ARTS AND COMMERCE",
  "ST WILFREDS COLLEGE OF COMPUTER SCIENCES, MIRA ROAD THANE",
  "ST WILFREDS INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH MIRA ROAD THANE",
  "ST WILFREDS COLLEGE OF ARTS, COMMERCE AND SCIENCE MIRA ROAD THANE",
  "DR V S JADHAV COLLEGE",
  "NIRMALABAI SHAMRAO SHIRSAT MAHAVIDYALAY KAMATHWADA TA KARANJA LAD DIST WASHIM",
  "GURUKUL MAHAVIDYALYA BHARAJ BU",
  "SWA AKSHAY DHANANJAY ROTHE MAHAVIDYALAY",
  "ABHINAV VARISHTHA MAHAVIDYALAY JINTUR TA JINTUR DIST PARBHANI",
  "VRINDAVAN COLLEGE OF AGRICULTURE",
  "SAHAKAR MAHARSHI BHAUSAHEB THORAT COLLEGE OF AGRICULTURE, AMRUTNAGAR, TAL SANGAMNER, DIST AHMEDNAGAR",
  "COLLEGE OF FOOD TECHNOLOGY, KHADAKEWAKE",
  "JAYAWANT SHIKSHAN PRASARAK MANDAL CHHATRAPATI SHIVAJI COLLEGE OF ARTS COMMERCE AND SCIENCE",
  "MUKUNDRAJ MAHAVIDYALAY PACHKHEDI",
  "Navgan Shikshan Sanstha Rajuri (N) Mrs. Kesharbai Sonajirao Kshirsagar Alias Kaku Arts,Science & Commerce College, Beed.",
  "GOVERNMENT COLLEGE OF ENGINEERING KOLHAPUR",
  "Progressive Education Society's Modern Institute of Business Studies, Sector 21,Yamunanagar, Behind LIC Building, Nigdi, Pune 411044",
  "5365-VARDHAMAN EDUCATION & WELFARE SOCIETY,AHINSA INSTITUTE TECHNOLOGY, DHULE",
  "S.S.V.P. Homoeopathic Medical College and Research Institute",
  "All India Shri Shivaji Memorial Society's College of Pharmacy, Pune",
  "Annasaheb Magar Mahavidyalaya",
  "GRAMIN VIKAS SHIKSHAN SANSTHA NASHIK SANCHLIT SHREE GAJANAN MAHARAJ ARTS SCIENCE AND FASHION DESIGN  WOMENS COLLEGE SARTALE ,TALUKA NANDGAON  DISTRICT NASHIK",
  "NSSR Arts and Science College, Telgaon, Tq. Dharur, Dist. Beed.",
  "P R POTE PATIL COLLEGE OF NURSING BSC",
  "ADITYA COLLEGE OF PHYSIOTHERAPY, BEED",
  "DR VARSHA PATIL WOMENS COLLEGE OF COMPUTER APPLICATION JALGAON",
  "MAA GANGA COLLEGE OF NURSING",
  "DR RAJENDRA GODE INSTITUTE OF NURSING AMRAVATI",
  "B D KARVE COLLEGE OF ARTS COMMERCE AND SCIENCE KARVE NAGAR PUNE",
  "HON TUKARAMSHETH S BAVISKAR INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH, SHIRPUR",
  "GOVINDRAO DUDHE MAHAVIDYALAY, MAHAGAON KASBA, TA DARWHA, DIST YAVATMAL",
  "Sinhgad College of Architecture, Vadgaon bk, Sinhgad road, Pune41",
  "Shri Sant Gajanan Maharaj Arts college Borgaon Manju",
  "Saraswati College, Gaulkhed Road, Shegaon.",
  "Saraswati College, Gaulkhed Road,Shegaon Buldhana.",
  "Shri Datta Arts, Commerce & Science College, Hadgaon",
  "Shri Kisanrao Khobragade Arts, Commerce and Science Mahavidyalaya, Armori",
  "K. L. E. Society's Science and Commerce College, Plot No. 29, Sector 1, Kalamboli, Navi Mumbai-410 218",
  "M.S. Bidve Engineering College, Latur",
  "Y N P COLLEGE OF PHARMACY ",
  "ROSHANBI SHAMANJI EDUCATION SPORTS AND WELFARE SOCIETY RIYAJBHAI SHAMANJI COLLEGE OF PHARMACY,GADHINGLAJ",
  "SAU SANGITA SURYAWANSHI NURSING COLLEGE,MUNGASE, MALEGAON",
  "SHREE RAMRAJE COLLEGE OF NURSING DAPOLI",
  "MATOSHRI ASARABAI DARADE HOMOEOPATHIC MEDICAL COLLEGE",
  "CHHATRAPATI SHIVAJI MAHARAJ COLLEGE OF NURSING, SHEDUNG,PANVEL",
  "APARAMPAR SWAMI PHYSIOTHERAPY COLLEGE",
  "ANAND CHARITABLE TRUST ASHTI ARTS COMMERCE  AND SCIENCE COLLEGE TINTARWANI TQ SHIRUR ",
  "SMT RADHIKATAI PANDAV COLLEGE OF PHYSIOTHERAPY NAGPUR",
  "KAUSHALYABAI PRADHAN COLLEGE OF ARTS SCCIENCE AND DESIGN",
  "Dr BHIMSING CHAVAN MAHAVIDYALAY",
  "Janta College of Education ",
  "AIMS COLLEGE OF PHARMACY ",
  "GRACE INSTITUTE OF FASHION DESIGN",
  "R G COLLEGE OF FASHION DESIGN WASANWADI BEED",
  "SAWALE COLLEGE LAKHANWADA TQ KHAMGAON DIST BULDHANA",
  "Shahada Taluka Educational Society and Cooperative Educational Society Limiteds, Senior Arts Mahila Mahavidyalaya, Shahada",
  "SAKESHWAR GRAMIN VIKAS SEVA SANSTHA ADSUL COLLEGE OF PHARMACY",
  "JAGDAMBA SHIKSHAN PRASARK MANDAL COLLEGE OF B PHARMACY AND RESEARCH CENTRE",
  "SANCHETI INSTITUTE OF NURSING EDUCATION",
  "UTTAMRAO DAHAKE SHIKSHAN MAHAVIDYALAYA, KANHERI SARAP, TQ BARSHITAKLI, DIST AKOLA",
  "Hon. Shri. Annasaheb Dange Ayurved Medical College, Post Graduate and Research Centre, Ashta, Tal- Walwa, Dist- Sangli.",
  "PINAKESHWAR ARTS COMMERCE AND SCIENCE COLLEGE VASANT NAGAR POST JATEGAON TAL NANDGAON DIST NASHIK",
  "MAHARASHTRA COLLEGE OF PHARMACY KHAMARI GONDIA",
  "People's Education Society's (Mumbai) Dr. Babasaheb Ambedkar College of Arts & Commerce, Nagsenvana, Aurangabad.",
  "Padmashree Appasaheb Pawar Arts, Science & Commerce College, Bardapur, Ambajogai.",
  "SHRI CHHATRAPATI SHIVAJI COLLEGE OF PHARMACY",
  "Adarsha College of Computer & Management, Shrawgi Plot, Akola",
  "SMRK Arts Fine Arts B.K. Commerce and A.K. Home Science Mahila Mahavidyalaya",
  "SARASWATI DARSHAN FOUNDATIONS ARHAM MANAGEMENT INSTITUTE",
  "KARMAYOGI INSTITUTE OF NURSING, SHELVE PANDHARPUR",
  "B. Raghunath Arts, Commerce & Science College Parbhani",
  "Dr.D.Y.Patil Unitech Society's, Dr. D.Y.Patil Unitech Arts,Commerce and Science College Tathawade",
  "Nari Gursahani Law College",
  "\" Bhartiy Samaj Vikas  & Sanshodhan Sanstha's Rashtrapita Mahatma Gandhi Mahavidyalaya, Khednagar, Tal. Karjat, Dist. Ahmednagar\".",
  "Marutirao Harirao Mahadik Arts and Commerce College Modnimb Tal- Madha Dist - Solapur",
  "ANJANEYA AYURVED COLLEGE AND HOSPITAL NASHIK",
  "Dayanand Arya Kanya Mahavidyalaya, Nagpur",
  "SAU PREMATAI PATIL ARTS COMMERCE AND SCIENCE COLLEGE GAUDGAON SOLAPUR",
  "MIT ARTS, COMMERCE AND SCIENCE COLLEGE BARSHI",
  "SAMARTH RURAL EDUCATIONAL INSTITUTE, RAJURIs SAMARTH COLLEGE OF ENGINEERING AND MANAGEMENT, AT BANGARWADI, POST BELHE, JUNNAR",
  "SHRI CHHATRAPATI VARISHTH MAHAVIDYALAYA GARAJ",
  "Loknayak Bapuji Aney Mahila Mahavidyalaya, Yavatmal",
  "DNYANVARDHINI SHIKSHAN SANSTHAS GLOBAL INSTITUTE OF MANAGEMENT, AHMEDNAGAR",
  "DR SUBHASHRAO DHAKNE COLLEGE OF B SC NURSING ROHANWADI     ",
  "MAULI MAHAVIDYALAY ROHANWADI    ",
  "A T PAWAR WOMENS COLLEGE KANASHI DIST NASHIK",
  "MAHATMA GANDHI MISSIONS MEDICAL COLLEGE,VASHI",
  "KAI SAVITRIBAI SASANE ARTS COMMERCE AND SCIENCE COLLEGE",
  "DNYANDEEP SHIKSHAN PRASARAK MANDALS, DNYANDEEP LAW COLLEGE, TAL KHED DIST RATNAGIRI",
  "Orange City Institute of Management, Tal.Dist. Nagpur",
  "MGM SCHOOL OF PHARMACY, NAVI MUMBAI",
  "B.M. Ruia Girls' College",
  "Synergy Foundations Synergy School of Commerce, Khajina Vihir Chowk, Sadashiv Peth,Pune  30",
  "PRADNYA KARUNA BAHUODESHIYA SHIKSHAN SANSTHAS ARTS COMMERCE AND SCIENCE, THANE",
  "GODAWARI COLLEGE PAITHAN ",
  "MOHATADEVI SEVA PRATISHTHAN SUNRISE COLLEGE",
  "MOHATADEVI SEVA PRATISHTHAN SUNRISE COLLEGE OF FASHION DESIGNING",
  "D Y PATHRIKAR COLLEGE OF NURSING    ",
  "DR B G DERE PHYSIOTHERAPY COLLEGE    ",
  "SMBT COLLEGE OF PHYSIOTHERAPY    ",
  "YASHODEEP INSTITUTE OF COMPUTER APPLICATION MCA",
  "SHIKSHAKMITRA BALASAHEB MHATRE COLLEGE OF ARTS, SCINECE AND COMMERCE    ",
  "Ali Yavar Jung National Institute Of Speech and Hearing Disabilities (Divyangjan).",
  "VIDYAVIHAR MAHILA MAHAVIDYALAYA WARUD DIST AMRAVATI",
  "SHRI SAI MAHILA MAHAVIDYALAYA TIOSA DIST AMRAVATI",
  "VIDYANIKETAN MAHAVIDYALAYA AMRAVATI",
  "SHRI GURUDEV MAHAVIDYALAY JANEPHAL    ",
  "MAULI AYURVEDIC COLLEGE AND HOSPITAL, MARKHEL    ",
  "KEN KENDRE COLLEGE OF TECHNOLOGY AND MANAGEMENT    ",
  "BHAKTI MAHAVIDYALAYA PARBHANI    ",
  "SAVITRIBAI PHULE ARTS COMMERCE AND SCIENCE COLLEGE PISOLI    ",
  "AARYA COLLEGE OF AGRICULTURE MANEGAON MADHA DIST SOLAPUR    ",
  "VITTHALA KALA MAHILA MAHAVIDYALAY PATHRI    ",
  "5286-SWAMI VIVEKANAND SANSTHAS INSTITUTE OF PHARMACY D PHARMACY",
  "G H Raisoni College of Engineering & Management, Nagpur",
  "SWA SHOBHATAI MANIKRAO DESHMUKH MAHAVIDYALAY SULTANPUR    ",
  "SHRIRAM INSTITUTE OF NURSING B SC PANIV TAL MALSHIRAS DIST SOLAPUR MAHARASHTRA     ",
  "NANDURBAR TALUKA VIDHAYAK SAMITI SMT VIMALTAI BATESING RAGHUVANSHI COLLEGE OF NURSING     ",
  "Dr Davids College of Higher Education, P and T Colony, Nandivali Gandhi Nagar, Dombivli East, Thane",
  "K T S P M LAW COLLEGE KHOPOLI    ",
  "SMT MIRABAI MAHILA ARTS,SCIENCE AND COMMERCE MAHAVIDYALAY , NER MOHADI, TAL AND DIST JALNA     ",
  "SARASWATI MAHAVIDYALAY, DEOGAON  DEVGAON DEVLI    ",
  "YOGESHWARI COLEEGE OF NURSING     ",
  "VISHWABHARATI ACADEMYS COLLEGE OF COMPUTER SCIENCE AND MANAGEMENT    ",
  "PROF DR N D PATIL LAW COLLEGE URUN ISLAMPUR TAL WALWA DIST SANGLI    ",
  "ANDARSUL SHIKSHAN PRASARAK MANDAL MATOSHRI SHANTABAI GOVINDRAO SONAWANE ARTS COMMERCE AND SCIENCE COLLEGE ANDARSUL NASHIK MAHARASHTRA     ",
  "S R T DEGREE COLLEGE    ",
  "ASIAN ACADEMY OF EDUCATION AND RESEARCH ASIAN COLLEGE OF SCIENCE, COMMERCE AND ARTS, VELHE    ",
  "SINDHU EDUCTATION SOCIETYS INSTITUTE OF TECHNOLOGY AND MANAGEMENT    ",
  "SHIVCHHATRAPATI MAHILA MAHAVIDYALAY    ",
  "LEELAVATI INSTITUTE OF HOTEL MANAGEMENT AND BUSINESS STUDIES, ROHA    ",
  "DEVI MAHALAXMI ARTS, SCIENCE AND COMMERCE COLLEGE    ",
  "PRESIDENCY COLLEGE OF LAW    ",
  "S M  JOSHI COLLEGE OF PHYSIOTHERAPY RATNAGIRI    ",
  "PIMPRI CHINCHWAD EDUCATION TRUST PIMPRI CHINCHWAD COLLEGE OF ARTS,COMMERCE AND SCIENCE    ",
  "DADASAHEB BALPANDE COLLEGE OF HOTEL MANAGEMENT AND FASHION DESIGN    ",
  "MAHATMA GANDHI MISSIONS MEDICAL COLLEGE, NERUL, NAVI MUMBAI    ",
  "GOVERNMENT MEDICAL COLLEGE AMRAVATI    ",
  "Shikshan Prasarak Mandal N  R Bhagat Senior College of Arts, Commerce and Science,  At Nerul, Thane",
  "SHRI L D AHER COLLEGE OF PHARMACY    ",
  "VPS COLLEGE OF PHARAMCY    ",
  "HIRWAL EDUCATION TRUST, HIRWAL LAW COLLEGE    ",
  "CHHATRAPATI SHRI SHIVAJI MAHARAJ COLLEGE OF AGRICULTURE     ",
  "SARASWATI SENIOR COLLEGE MALKAPUR TAL MALKAPUR DIST BULDHANA",
  "DR R N LAHOTI COLLEGE OF NURSING, SULTANPUR",
  "B G Patle College of Education Tiroda",
  "MSMGVBS CENTRAL INDIA COLLEGE OF PHARMACY, LONARA, NAGPUR    ",
  "GOVERNMENT MEDICAL COLLEGE, JALNA",
  "SHRI LAXMANRAO TRYAMBAKRAO NAKADE PHARMACY COLLEGE, DHORJALGAON NE    ",
  "K C BAJAJ COLLEGE OF PHARMACY AND RESEARCH, SINDHU EDUCATION SOCIETY CAMPUS, JARIPATKA, NAGPUR",
  "RASTRIYA ARTS COMMERCE AND SCIENCE MAHAVIDYALAY NAGAD",
  "SHRI DHANAJI SHELKE COLLEGE OF PHARMACY    ",
  "DR B B KHALADAKR COLLEGE OF PHARMACY    ",
  "DR P M PATIL VARISHTHA MAHAVIDYALAY VANGAON TAH SOYGAON DIST CHHATRAPATI SAMBHAJINAGAR",
  "HON SHRI BABANRAO PACHPUTE VICHARDHARA TRUST PARIKRAMA LAW COLLEGE KASHTI TAL SHRIGONDA DIST AHILYANAGAR",
  "APPASAHEB ZAGDU DARYAV INDRAJIT ARTS SCIENCE COMMERCE SENIOR COLLEGE PRATAPPUR    ",
  "INSTITUTE OF PHARMACY, BADNAPUR    ",
  "SIDDHANT SOCIAL WORK COLLEGE  AMBAPUR TEL SAKIR DIST DHULE",
  "DNYANSADHANA PRATISHTHAN EDUCATIONAL INSTITUTION",
  "GANGABAI BADOLE INSTITUTE OF SCIENCE SAWARI",
  "SHRI SAMBHAJI COLLEGE OF MANAGEMENT AND TECHNOLOGY",
  "RAJMATA JIJAU MAHILA MAHAVIDYALAY DONGAON ",
  "Smt. Maniben M.P. Shah Women's College of Arts and Commerce,",
  "GOVERNMENT MEDICAL COLLEGE GADCHIROLI    ",
  "PARBHANI COLLEGE OF PHYSIOTHERPY ",
  "KASTURI SHIKSHAN SANSTHA SCHOOL OF LAW",
  "Pravara Rural Education Societys Arts, Commerce, Science & BCS College, Ahmednagar",
  "GOVERNMENT MEDICAL COLLEGE SINDHUDURG ",
  "SHRI GYANRAJ VEDANT GURUKULAM, ALANDI, PUNE",
  "SHRI BALESHWAR SHAIKSHANIK VA KRUSHI VIKAS FOUNDATIONS SHRI SWAMI SAMARTH INSTITUTE OF COMPUTER SCIENCE AND TECHNOLOGY AT MALWADI PO BOTA TAL SANGAMNER DIST AHILYANAGAR  ",
  "SIDDHI COLLEGE OF MANAGEMENT AND BUSINESS STUDIES",
  "PARWE ARTS, COMMERCE AND SCIENCE COLLEGE, BHIWAPUR",
  "SHIKSHAN MAHARSHI VAIJANATHRAO AKAT COLLEGE, SATONA",
  "S D DESHMUKH MAHAVIDYALAYA RAJUR ",
  "HALKARNI MAHAVIDYALAYA HALKARNI TAL GADHINGLAJ DIST KOLHAPUR",
  "VASANT NANA DESHMUKH BAHUUDESHIYA SAMAJSEVA SANSTHA, KASEGAON, PRIYADARSHANI INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH, KASEGAON, PANDHARPUR, ",
  "College of Teacher Education, Aurangabad",
  "SHREE AMGAON MAHAVIDYALAYA AMGAON    ",
  "LATE SUSHILABAI JAISWAL MAHILA MAHAVIDYALAY",
  "ADIVASI SEVA SAMITTEE NASHIKS ARTS AND COMMERCE COLLEGE, WADALA, NASHIK, MAHARASHTRA ",
  "DHARMVEER SAMBHAJI MAHARAJ VIDHI MAHAVIDYALAYA JATH DIST SANGLI",
  "SAVITRIDEVI COLLEGE OF NURSING, WADGAON WANI",
  "KEWALRAM MAHAVIDYALAY CHUTIYA TA DIST GONDIA",
  "SHINDE INSTITUTE OF PHARMACY AND RESEARCH",
  "ADV B D HAMBARDE VIDHI MAHAVIDYALAYA ASHTI",
  "SHRI GULABARAO DEOKAR COLLEGE OF NURSING JALGAON",
  "PDEA COLLEGE OF PHARMACY, HADAPSAR",
  "ADV B D HAMBARDE VIDHI MAHAVIDYALAYA ASHTI",
  "SHRI WAGHESHWAR GRAMVIKAS PRATISHTHANS PHARATE PATIL MANAGEMENT INSTITUTE ",
  "MUHAMMAD WAHED HOMOEOPATHY MEDICAL COLLEGE AND RESEARCH CENTRE",
  "DR AJAY PATIL COLLEGE OF LAW ",
  "JSPMS, RAJARSHI SHAHU COMMERCE AND SCIENCE COLLEGE, WAGHOLI, TAL HAVELI, DIST PUNE ",
  "BHOJRAJJI BHONDEKAR PHYSIOTHERAPY COLLEGE",
  "CENTRAL INDIA NURSING COLLEGE",
  "SHIVSHAMBHO INSTITUTE INFORMATION AND TECHNOLOGY JALBHAVI",
  "Saptaratna Bahuudheshiya Sevabhavi Sanstha, Shirur, College of Computer Science, Shirur.",
  "VENKATESHWARA INSTITUTE OF PHYSIOTHERAPY ",
  "GOVERNMENT MEDICAL COLLEGE, AMBERNATH  WEST,  DIST THANE",
  "SHANKARRAO DESHMUKH SENIOR COLLEGE BARAD TA MUDKHED DIST NANDED",
  "NARAYANI WOMEN COLLEGE KORCHI",
  "COLLEGE OF NURSING MURSHADPUR GANGAINAGAR ASHTI",
  "ARTS COMMERCE AND SCIENCE COLLEGE, KONDHALI",
  "SHRI BALASAHEB MANE SHIKSHAN PRASARAK MANDAL, ASHOKRAO MANE COLLEGE OF NURSING, VATHAR TARF VADGAON, TAL HATKANAGALE, DIST  KOLHAPUR",
  "SAI HOMOEOPATHY MEDICAL COLLEGE, SASURE VAIRAG",
  "VRTS MADHAVBAUG INSTITUTE OF PREVENTIVE CARDIOLOGY,KHOPOLI",
  "National Defence Academy",
  "HIND SEVA PARISHADS PUBLIC LAW COLLEGE",
  "ANJANEY WELFARE AND EDUCATION SOCIETYS SHRIRAM ARTS, COMMERCE AND SCIENCE COLLEGE ",
  "MADHUBAN MAHAVIDYALAYA ARTS COMMERCE & SCIENCE TEMBRUSONDA TQ CHIKHALDARA DIST AMRAVATI",
  "PANDURANG BANPURKAR MAHAVIDYALAYA DHANORA",
  "LATE VINAYAKRAOJI DESHMUKH ARTS COMMERCE AND SCIENCES COLLEGE KATA TQ DIST WASHIM",
  "RENUKADEVI MAHAVIDYALAY, KINWAT",
  "MATOSHRI COLLEGE OF NURSING,DHANORE ",
  "RASHTRAMATA JIJAU MAHILA MAHAVIDYALYA  INCHA PALSHI ROAD HINGOLI ",
  "SANTOSHIMATA COLLEGE OF NURSING,PANHALSATHE",
  "SAU PARVATABAI TUKARAM PATIL COLLEGE KHEDI BK TAL DIST JALGAON",
  "SWAMI VIVEKANAND MAHILA MAHAVIDYALAY, YANOLI",
  "VAMANRAO ITHAPE INSTITUTE  OF MANAGEMENT, SANGAMNER",
  "SANJEEVAN MEDICAL COLLEGE OF NURSING, SATARA",
  "GURUMAULI COLLEGE OF NURSING     ",
  "Gopikisan Bang Arts and Science College, Hingna",
  "Grant Medical College, Seth J.J. Compound Byculla, Mumbai",
  "Gurudatta Shikshan Sansthas College of Pharmacy, Manur, Tal.Kalwan, Dist.Nashik 423501",
  "Kesharbai Kale Girls College",
  "LATE RAHULBHAU BOMMAWAR GONDPIPARI",
  "Late Vasantrao Sawkar Poreddywar B Ed College Dhanora",
  "GOVERNMENT MEDICAL COLLEGE, JALGAON",
  "Government Medical College, Nagpur",
  "HELEN ROSE COLLEGE OF NURSING UMRI",
  "Hirwal Education Trust Rajmata Jijau Mahila Vidyalaya",
  "Indira Gandhi  Govt. Medical College, Nagpur",
  "Jai Hind Mahila Kala Mahavidyalay, Beed",
  "KARMAYOGI SHRI HA RA KAWCHALE KALA VA VIDNYAN MAHAVIDYALY BORALE",
  "KISAN KATHORE SCIENCE COLLEGE MURBAD",
  "Mahalaxmi College of Physiotherapy and Rehabilitation Center",
  "Maharana Pratap College of Education",
  "Mandar Education Societys Rajaram Shinde College of Engineering Pedhambe Taluka  Chiplun Dist. Ratnagiri",
  "RURAL INSTITTUTE OF AYURVED RESEARCH CENTER HOSPITAL  MAYANI",
  "SATI ANUSAYA MAA ARTS SCIENCE COLLEGE YENGALKHEDA",
  "Smt Vatsalabai Bhonsale Arts College, Kharsoli Road",
  "St. Paul College of Science and Commerce, Hudkeshwar",
  "SUYASH COLLEGE OF ARTS, SCIENCE AND COMMERCE",
  "THE NAVKONKAN EDUCATION SOCIETYS INSTITUTE OF MANAGEMENT STUDIES",
  "Swa. Narmadabai Bodkhe Mahila Mahavidyalay.",
  "Sai Samajik Santha Sanchalit College of Engineering, Pardarigaon, Aurangabad.",
  "SHRI GORAKSHA NURSING COLLEGE AND RESEARCH CENTER ",
  "SHRI SANTAJI MAHILA MAHAVIDHYALYA TALODHI BA",
  "Sri Sant Sunyoji Maharaj Education College, Gadchandur",
  "SANT DNYANESHWAR B.C.A. COLLEGE, PARBHANI",
  "SHRI SHIVAJI VIDYA PRASARAK SANSTHAS YOGSHASTRA COLLEGE, DEOPUR, DHULE",
  "Shri Tuljabhavani Arts and Science College, Chitte Pimpalgaon, Aurangabad.",
  "VIDYANIKETAN DEGREE COLLEGE OF COMMERCE ",
  "Sati Anusuiya Mata Women's College, Katol",
  "Savitribai Fule Vidyan Mahavidyalaya, Shindkhed Raja.",
  "SHRI GORAKSHA AYURVEDIC MEDICAL COLLEGE, HOSPITAL AND RESEARCH CENTER",
  "SHRI RADHE MAHAVIDHYALAYA NAGPUR",
  "Shriram Arts Commerce & Science College, Morshi,",
  "SHRI SAI SAMARTH ARTS COMMERCE AND SCIENCE COLLEGE BHADGAON",
  "SWA SHREE MALLAJI ATRAM ARTS COLLEGE JARAWANDI",
  "WAVIKAR COLLEGE OF OPTOMETRY",
  "VASUNDHARA MAHILA MAHAVIDYALAY, PARBHANI",
  "MANGALDEEP COLLEGE OF ENGINEERING, NIPANI",
  "SUVIDYA DEGREE COLLEGE",
  "KAMALADEVI LAW COLLEGE",
  "HINDUSTAN AEROSPACE & ENGINEERING PUNE",
  "RADHAI COLLEGE OF PHARMACY, KAREGAON",
  "SUBHADRAS EDUCATIONAL SOCIETYS, SNBP INSTITUTE OF NURSING",
  "MDA EDUCATION AND RESEARCH INSTITUTE",
  "GOVTNMENT MEDICAL COLLEGE BHANDARA",
  "ADSUL ARTS COMMERCE AND SCIENCE COLLEGE",
  "GENESIS COLLEGE OF NURSING, RADHANAGARI",
  "MATOSHRI ARTS SCIENCE AND COMPUTER SCIENCE COLLEGE DHANORE",
  "R. S. GUNJAL COLLEGE OF B.SC. NURSING",
  "SSPMS Arts Commerce Science Sr College Dhanora Tq-Ashti Dist - Beed",
  "THAKUR SHREE DPS COLLEGE OF ENGINEERING AND MANAGEMENT ",
  "SAKESHWAR GRAMIN VIKAS SEVA SANTHS ADSUL LAW COLLEGE ",
  "BHANDUP EDUCATIONAL SOCIETY P A MENON COLLEGE OF LEGAL STUDIES",
  "JIJAMATA COLLEGE OF PBBSC NURSING MALEGAON",
  "SANKALP PRATISHTHANS SANKALP COLLEGE OF LAW",
  "LOKNETE DR SHIVAJIRAO SHENDGE BSC NURSING COLLEGE ",
  "SHRI ANGARSIDDHA SHIKSHAN PRASARAK MANDAL'S DIPLOMA IN PHARMACY INSTITUTE, SANGULWADI, TAL-VAIBHAVWADI",
  "SHRI GAJANAN MAHARAJ SHIKSHAN PRASARAK MANDAL DNYANVILAS COLLEGE OF ENGINEERING",
  "PVGs College of Engineering ,Technology and Management",
  "Jahnvis Multi Foundation's Vande Mataram Degree College of Arts, Commerce & Science, JMF Sanskriti Vihar, Dr. Namade Road, Telcos Wadi, Old Dombivli, Kopar, Cross Road, Near Diva-Vasai Railway Route, Dombivli (West)",
  "DR SUBHASHRAO DHAKNE COLLEGE OF COMPUTER SCIENCE AND DATA SCIENCE",
  "Mohini Murari Shikshan Sanstha  Mohini Murari Mayekar Arts & Commerce College  At Post  Malgund Chafe Tal & Dist  Ratnagiri",
  "P. R. POTE PATIL COLLEGE OF ENGINEERING AND MANAGEMENT, AMRAVATI",
  "SAU VANDANA NANDKUMAR TASGAONKAR SCHOOL OF GNM",
  "SHRI SHIVAJIRAO NAGAWADE LAW COLLEGE, SHRIGONDA",
  "NATIONAL FIRE SERVICE COLLEGE",
  "MAEERS MAHARASHTRA INSTITUTE OF TECHNOLOGY THANE",
  "SBS INSTITUTE OF HOTEL AND TOURISM MANAGEMENT",
  "DNYAN BHARATI SOCIETYS SAU. SITABAI RAMKRUSHNA KARANDIKAR SENIOR COLLEGE OF COMMERCE & LATE MEHERNOSH BOMAN BURJOR IRANI COLLEGE OF ARTS, VADKUN, DAHANU ROAD, DIST PALGHAR",
  "RAMAI MAHILA  MAHAVIDYALAYA",
  "VALMIKRAO DALVI ARTS COMMERCE AND SCIENCE SR COLLEGE CHHATRAPATI SAMBHAJINAGAR",
  "D. B. COLLEGE OF PHARMACY AND RESEARCH, LATUR",
  "NKSPT'S, INSTITUTE OF NURSING, PATHRIKAR CAMPUS, BADNAPUR",
  "ADV SHARDULRAO SUDHAKARRAO JADHAVAR COLLEGE OF LAW",
  "NKSPT INSTITUTE OF ENGINEERING AND TECHNOLOGY PATHARIKAR CAMPUS BADNAPUR",
  "SANT JAGANADE MAHARAJ SHIKSHAN MANDAL'S SHRI BAPUSAHEB V.C. CHAUDHARI ARTS & COMMERCE SENIOR COLLEGE, AT POST KHAPAR, TAL. AKKALKUWA, DIST. NANDURBAR",
  "Vishnu Waman Thakur Charitable Trust s VIVA Institute of Management & Research",
  "Terna Public Charitable Trust's College of Engineering, Tuljapur Road, Osmanabad.",
  "MODERN COLLEGE OF BCA SONAI    ",
  "Millennium Arts Commerce Science College, Nagpur",
  "SOPAN's Suvidya College of Special Education  New Panvel",
  "SHRI VILE PARLE KELAVANI MANDALS NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES NAVI MUMBAI",
  "Jupiter Ayurved Medical College, Nagpur",
  "MANAVATA INSTITUTE OF NURSING",
  "CALIBER COLLEGE OF ARTS,COMMERCE AND SCIENCE",
  "GENERAL HOSPITAL NASIK",
  "NATIONAL FORENSIC SCIENCES UNIVERSITY, NAGPUR CAMPUS",
  "ZEAL INSTITUTE OF TECHNOLOGY KUPWAD KAWALAPUR ROAD BAMNOLI SANGLI",
  "Dr. Vivek Shinde Prashaskiya Sewa Mahavidyalaya, Bhadrawati",
  "DNYANSADHANA COLLEGE OF PHARMACY",
  "Maharashtra Institute of Mental Health, Pune",
  "Shivajirao Pawar College of Pharmacy",
  "chatrapati shri shivaji arts commerce and  science college jafrabad",
  "D. K. Mahila Mahavidyalaya, Kurkheda",
  "Matoshree Prashaskiya Seva Mahavidyalay, Umred ",
  "Vidyavardhans Institute of Design Environment and Architecture (IDEA), Nashik",
  "Saraswati College of Education and Research(B.Ed.)",
  "Jayawant Shikshan Prasarak Mandals Rajarshi Shahu College of Pharmacy & Research , Survey no. 82-2, Tathawade, Pune 33",
  "Yadaorao Poshattiwar Arts College, Talodhi (Balapur)",
  "MGM School of Physiotherapy, Aurangabad",
  "Maratha Vidya Prasarak Samaj's Commerce, Management & Computer Science (CMCS) College, Udoji Maratha Boarding Campus, Gangapur Road, Nashik 422002",
  "Subhash Vidya Mandals D.R.Kakade College of Commerce, Pimpalwandi,Tal.Junnar,Dist.Pune 412412",
  "Jai Jawan S.P.M.'s  College of  B.Lib. Taroda, Manik Nagar, Nanded",
  "M.G.M. College of Fine Arts, Air Port Road, Nanded",
  "Social Security Mission College of Computer Science & Multimedia",
  "INDIAN MARITIME UNIVERSITY, MUMBAI PORT ",
  "Swami Vivekanand Mahavidyalaya, Udgir",
  "RAJASHRI SHAHU SCIENCE COLLAGE ",
  "Sai Ayurved College Hospital  Research Center Vairag",
  "College of Food Technology, Ashti",
  "Dr. Ambedkar College of Social work, Sawangi (Meghe) Road, Wardha",
  "Mandke Human Happiness Foundation's Smt. Sudhatai Mandke College, Pune 38",
  "Bhairavnath Shikshan Mandal's Bhairavnath Vidnyan Mahavidyalaya, Khutbav, Taluka - Daund, District - Pune 412203",
  "SANTOSH BHIMRAO PATIL ARTS, COMMERCE & SCIENCE COLLEGE MANDRUP TAL.SOUTH  SOLAPUR",
  "Choice College of Arts and Commerce ",
  "Bhagwantrao Shikshan Mahavidyalaya, Aheri",
  "Maulana Abul Kalam Azad Marathi B.Ed. College, Dhad",
  "Arham Foundation's Arham College of Arts and Commerce, Camp, Shaheen Building, Near Azam Campus Gate No. 4, Opp. Golibar Maidan, Camp, Pune - 411001",
  "Delonix Societys Baramati College of Pharmacy",
  "FINE ART MAHAVIDYALAYA JALNA",
  "DELIGHT COLLEGE OF PHARMACY ",
  "Shramjivi College of Pharmacy, Omerga ",
  "SSP Shikshan Sansthas Siddhi College of Pharmacy",
  "FABTECH COLLEGE OF PHARMACY",
  "Xavier Institute of Natural Resource Management ",
  "Shree Siddheshwar Womens College of Engineering Solapur",
  "VIJAYRAO NAIK COLLEGE OF PHARMACY",
  "Womens College of Pharmacy, Peth Vadgaon",
  "ARIHANT COLLEGE OF PHARMACY",
  "Sipna School of Planning and Architecture Amravati",
  "MANGALDEEP INSTITUTE OF PHARMACY",
  "DR ZAKIR HUSAIN ARTS AND SCIENCE COLLEGE LONAR",
  "Mansi Bharat Gada Degree College of Commerce, Near Bhiwandi, Road Railway Station, Anjurphata, Bhiwandi, Dist.- Thane.- 421 305.",
  "Orange city College of Social Work, Koradi Road, Nagpur",
  "D. R. Mane Mahavidyalaya, Kagal",
  "Bajaj College of Science, Wardha",
  "Utkarsh Vocational Training Collage",
  "Om Shanti Bahuuddeshiya Shikshan Sanstha Aurangabad s Guru Mishri Homo. Medical College & Hospi. Tal. Badnapur, Dist. Jalna",
  "Dr. D. Y. Patil Medical College, Hospital and Research Centre, Pimpri, Pune",
  "MAHATMA GANDHI COLLEGE OF NURSING DHOTRA  RAILWAY WARDHA",
  "KRANTIVEER VASANTRAO NARAYANRAO NAIK SHIKSHAN PRASARAK SANSTHAS  INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH NASHIK",
  "Vidya Niketan Institute of Pharmacy and Research Center",
  "180035-VIDYA BHARATI SHAIKSHANIK MANDALACHE AMARAVATI SANCHLIT SANT MUKTABAI ARTS AND COMMERCE COLLEGE, MUKTAINAGAR.",
  "G. H. Raisoni Educational & Medical Foundation's G. H. Raisoni College of Arts, Commerce and Science, Pune-Nagar Road, Wagholi, Tal. Haweli, Pune 412207",
  "Indraraj Arts, Commerce & Science College, Sillod.",
  "SAMAJSHREE PRASHANTDADA HIRAY LAW COLLEGE PANCHVATI NASHIK",
  "SARASWATI MAHVIDYALAYA",
  "ARTS COMMERCE AND SCIENCE COLLEGE ASHTI  WARDHA",
  "SHRI SHIVAJI COLLEGE OF PHYSICAL EDUCATION AMRAVATI ",
  "Shri Someshwar Shikshan Prasarak Mandal, Sharadchandra Pawar  College of Engineering and Technology, Someshwarnagar,Taluka- Baramati, District- Pune- 412306",
  "AHMEDNAGAR JILHA MARATHA VIDYA PRASARAK SAMAJ'S JANATA ARTS AND SCIENCE COLLEGE, RUICHHATTISI, AHMEDNAGAR",
  "IndSearch Institute of Management Studies and Research at 85/1, Law College Road, Erandavana, Pune 411004",
  "Chhatrapati Shivaji B.C.A. &  B.C.S. College, Pandharpur",
  "Konkan Gyanpeeth,Uran College of Commerce and Arts, Near Tahsil Office, Uran, Tal- Uran Dist- Raigad. 400 702",
  "CHHATRAPATI SHIVAJI MAHARAJ MAHAVIDYALAYA JALNA",
  "K T PATIL COLLEGE OF COMMERCE",
  " Bar S K Wankhede University College of Education  Nagpur",
  "NEW VIJAN KALA VANIJAY MAHAVIDYALAYA ANDHA APANGA",
  "A.B.V.M. Agrawal Jatiya Koshs Ghanshyamdas Jalan College of Science, Commerce & Arts , Upper Govind Nagar, Malad (E), Mumbai - 400097",
  "Dang Seva Mandals Arts Commerce And Science College Mulher",
  "Chembur Karnataka Sangha's Chembur Karnataka Night College, 3rd Floor, Vidyasagar, Ghatla Chembur, Mumbai- 400 071",
  "Sahajeevan Shikshan Sanstha's Madanbhai Sura Institute of Business Management  Khed, Dist- Ratnagiri. 415709",
  "RAVOSAHEB PATIL DANVE COLLEGE OF PHARMACY BADNAPUR",
  "Mahadev Kanchan College of Pharmaceutical Education and Research",
  "Rashtriya Alpasankhyank Mahila Maha Vidyalaya",
  "Art Commerce and Science College Kurha Kakoda",
  "Savitribai Phule Women College Jafrabad",
  "Baba Naik Mahavidyalaya, Kokrud",
  "Aditya College of Science",
  "Prabhat Arts Commerce and Science College Nidhona  Tq Phulambri",
  "MULA EDUCATION SOCIETYS ARTS COMMERCE AND SCIENCE COLLEGE MAKA TAL NEWASA",
  "Godavari Institute of Pharmacy ",
  "INDUTAI TILAK COLLEGE OF PHYSIOTHERAPY PUNE",
  "KAI BHAGUBAI PINGLE ARTS COMMERCE NIGHT COLLEGE CHAKAN",
  "MAULI EDUCATION COLLEGE WADALA TAL.NORT SOLAPUR DIST-SOLAPUR",
  "MATRIX EDUCATIONAL FOUNDATIONS MATRIX SCHOOL OF MANAGEMENT STUDIES, PUNE",
  "LATE. AMBADASRAO WARPUDKAR COLLEGE OF AGRICULTURE, WARPUD.",
  "Daar-Ul-Rehmat Trust's A.E. Kalsekar  Degree College, Near Bhaarat Gear Factory, Post-Dawla, Kausa Mumbra, Dist. Thane - 400612.",
  "Sant Bhagwan Baba Arts & Science College, Bodhadi, Tq. Kinwat",
  "Lalit Kala Mahavdiyalaya, Parbhani",
  "SHIVA TRUST GODAVARI COLLEGE OF PHARMACY MANORI NASHIK ",
  "Smt Mithibai Motiram Kundnani College of Commerce and Economics",
  "Bharati Vidyapeeth Matoshri Bayabai Shripatrao Kadam Mahavidyalaya, KADEGAON",
  "DR. RAJENDRA GODE NURSING INSTITUTE, RAJENDRA NAGAR, OLD AJISPUR ROAD, BULDHANA TQ. DIST. BULDHANA",
  "ALICE DEGREE COLLEGE OF ARTS AND COMMERCE    ",
  "GOVT. OF MAHARASHTRA'S BACHELOR OF NATUROPATHY & YOGIC SCIENES COLLEGE",
  "SURYADATTA EDUCATION FOUNDATIONS SURYADATTA LAW COLLEGE",
  "V.V.P. INSTITUTE OF ENGINEERING & TECHNOLOGY, 72/2/B PRATAP NAGAR, SOREGAON-DONGAON ROAD, SOREGAON, SOLAPUR-413004",
  "VANMALA EDUCATIONAL AND CHARITABLE TRUSTS DHARMVEER ANAND DIGHE SAHEB MAHAVIDYALAY",
  "PJBS AAISAHEB SHAKUNTALAJI JAIN COLLEGE OF PHARMACY AND RESEARCH ",
  "SAMARTH COLLEGE OF NURSING BANGARWADI TAL JUNNAR DIST PUNE",
  "Bhagwan Sri Chakradhar Swami Physical Education College, Balapur",
  "National Arts, Commerce & Science College,Palaskheda, Taluka Soegaon",
  "Rajrishi Chatrapati Shahu Maharaj, Arts and Commerce College, Babupeth",
  "IMPERIAL COLLEGE OF ENGINEERING",
  "NAVKAR D AND B PHARMACY COLLEGE AND RESEARCH CENTER",
  "SHUSHRUT B SC NURSING COLLEGE OMERGA",
  "MUMBRA SHIKSHAN PRASARAK GR PATIL SCIENCE AND COMMERCE COLLEGE, THANE",
  "DR. A. P. J. ABDUL KALAM ARTS AND SCIENCE COLLEGE, UNDANGAON",
  "VASANT PHARMACY COLLEGE KAIJ",
  "PAVITRA BSC NURSING COLLEGE",
  "Akole Taluka Education Society Agasti Institute of Management,  Computer Application and Research,Akole, Tal Akole, Dist Ahilyanagar",
  "Maharshi Karve Mahila Mahavidyalay, Wai",
  "YASHODABAI HARDE MAHILA MAHAVIDYALAYA CHAMORSHI",
  "SHRIRAMCHANDRA INSTITUTE OF MEDICAL SCIENCES SRIMS COLLEGE OF PHYSIOTHERAPY",
  "DR K R COLLEGE OF PHARMACY AND RESEARCH LAKHANI BHANDARA",
  "JAGDAMBA EDUCATION SOCIETY'S S.N.D INSTITUTE OF PHARMACY, YEOLA",
  "DR BHANUDAS DHERE COLLEGE OF AYURVED     ",
  "College of Agriculture, Khandala, Tal. Vaijapur",
  "SDMVM College of Agriculture, Georai Tanda, Paithan Road",
  "BALASAHEB DESAI COLLEGE OF PHARMACY,PAL",
  "MKD COLLEGE OF NURSING, VIRCHAK",
  "SAVITRIBAI PHULE MAHILA MAHAVIDYALAY, TIRTHPURI    ",
  "N D MARATHE ARTS, COMMERCE AND SCIENCE COLLEGE, SHINDKHEDA",
  "MANAV SADHAN VIKAS SANSTHA COLLEGE OF PHYSIOTHERAPY ANAV",
  "GEETAI NURSING INSTITUTE OF BSC NURSING",
  "M.G.M. College of Journalism & Media Science, Nanded",
  "130091-MAHATMA FULE SAMAJIK V SHAIKSHANIK VIKAS MANDAL SANCHALIT MAHATMA PHULE COLLEGE OF EDUCATION, CHALISGAON",
  "120068-DHANDAIMATA EDUCATION SOCIETY SANCHALIT DHANDAI ARTS AND SCIENCE COLLEGE, AMALNER TAL. AMALNER, DIST. JALGAON",
  "ISMAIL MEHTA COLLEGE OF PHARMACY",
  "JAMIA INSTITUTE OF TECHNOLOGY",
  "Kala Wanijya Mahila Mahavidyalaya, Ballarpur",
  "Shri Narsing Arts and Commerce College, Akot. ",
  "Mahatma Education Society's Pillai Institute of Management Studies and Research, Dr. K.M Vasudevan Pillai Campus, New Panvel",
  "DALIT MITRA KADAM GURUJI COLLEGE OF PHARMACY MANGALWEDHA",
  "NIRMITI DEGREE COLLEGE OF ARTS, COMMERCE AND SCIENCE",
  "SUSHGANGA INSTITUTE OF MANAGEMENT ",
  "BHAGWAN MAHAVIDYALAYA, SHEWADI",
  "SANTOSHIMATA BAHUUDESHIYA SHAIKSHANIK SEVA SANTHA (SBSS) A.L.D. ARTS, COMMERCE AND SCIENCE COLLEGE, NANDGAON, YEOLA, NASHIK",
  "ADSUL COMPUTER AND MANAGEMENT INSTITUTE",
  "TAKSHSHILA MAHAVIDYALAY",
  "SAMAJBHUSHAN EKNATHRAO DHAKANE COLLEGE OF ENGINEERING, SHEVGAON",
  "AAROGYA SAMPADA COLLEGE OF PHARMACY",
  "DR BHANUDAS DERE COLLEGE OF PHARMACY",
  "BHARATRATNA DR APJ ABDUL KALAM COLLEGE FOR UG AND PG COURSES WITH MILLENNIUM SKILLS INNOVATION INCUBATION AND RESEARCH, RAHATGAON, AMRAVATI",
  "UJJWAL PRAKASH ARTS COMMERCE AND SCIENCE COLLEGE WAGHDARDI TAL CHANDWAD DIST NASHIK",
  "Renuka College of Arts, Commerce & Science College, Mantha.",
  "Ratnadeep Homoeopathic Medical College Ratnapur Taluka Jamkhed District Ahemednagar.",
  "RATNADEEP AYURVED MEDICAL COLLEGE, RATNAPUR TAL JAMKHED DIST AHMEDNAGAR MAHARASHTRA",
  "Rani Satyadevi Women's College, Aheri",
  "Ramrao Adik Institute of Technology Dr D Y  Patil Vidyanagar Sector-7 Phase-I Nerul Navi Mumbai  400 706",
  "RAMPARVA HOSPITALITY AND TOURISM COLLEGE",
  "Raje Dharmarao Law College, Gadchiroli",
  "Radhikatai Pandav Institute of Architecture, Umred road",
  "P.R.Patil College of Engineering & Technology, Gajanan Township Campus, Kathora Road,Amravati",
  "Priyadarshini College, Rampur",
  "Poona District Education Associations Arts, Commerce & Science College ,Sambhaji nagar, Chinchwad, Pune 19",
  "NUTAN BAL SHIKSHAN SANGH SANCHALIT DR SHASHIKALA POTNIS ARTS AND COMMERCE COLLEGE KOSBAD DAHANU",
  "National Power Training Institute, Gopal Nagar",
  "NANDKUMAR BASENE PRASHASKIY MAHAVIDYALAY , CHICHALA, RAMTEK, DIST NAGPUR",
  "M.G.M.'s Institute of Bio-Science, Cidco, Aurangabad.",
  "M.G.M. College of Journalism & Mass Communication, Cidco, Aurangabad.",
  "Mata Ramabai Ambedkar Womens Law College",
  "Master Education Society College of Arts  Science and Commerce  Nalasopara  Taluka Vasai Dist  Thane",
  "MANGALA INSTITUTE OF NURSING EDUCATION AKOLE",
  "MANAV SADHAN VIKAS SANSTHA COLLEGE OF NURSING",
  "Late Nagoraoji Movade Arts College, Saoner",
  "Gondia Government Medical College Gondia",
  "GLOBAL NURSING INSTITUTE JANAPURI NANDED    ",
  "Dr. S. R. Ajmera B.C.A. College of Women",
  "Dr. G.Y.Patharikar College of Computer Science & Information Technology, N-6, Cidco, Aurangabad.",
  "DR D Y PATIL EDUCATIONAL ACADEMYS DR D Y PATIL SCHOOL OF ENGINEERING ACADEMY, AMBI, TALEGAON, PUNE",
  "Davidkirti Techical College, Wadsa",
  "B. R. HARNE COLLEGE OF ARCHITECTURE",
  "Bhartiya Vidya Bhavans Shriyans Prasad Jain Institute of Management of Research Munshi Nagar Dadabhai Road Andheri (West) Mumbai 400 058",
  "Bharatratna Dr. A.P.J.Abdul, Kalam College of Architecture",
  "AYURVED MAHAVIDYALAYA, PUSAD",
  "Ayurvedic College, Hospital & Research Centre, Degaon, Tal. Risod, Dist. Washim",
  "Arya Vidya Mandir Institute of Education 287 Arya Vidya Mandir Marg J V P D Scheme Mumbai  400 049",
  "Amruta Vasishnavi Education & Welfare Trusts College of Education, Prashant  Garden, Agaskhind, Post Shenit, Tal. Sinnar, Dist. Nashik",
  "ADITYA COLLEGE OF ARCHITECTURE",
  "Abdul Aziz Thamani College, Nagbhid",
  "ROYAL INSTITUTE OF TECHNICAL EDUCATION LATUR",
  "BLESSING COLLEGE OF BSC NURSING DHARMAPURI PARBHANI",
  "INSTITUTE OF NURSING EDUCATION AND RESEARCH AKOLA",
  "Mula Education Societys Shri Dnyaneshwar Mahavidyalaya Newasa, Tal-Newasa, Dist-Ahmednagar 414603",
  "Toshniwal Arts, Commerce & Science College, Sengaon Dist. Hingoli",
  "SP Jain college of Pharmacy and Research, Palaskheda",
  "GURU GANGABHARTI MAHAVIDYALAY , KALMNURI",
  "JIJAMATA MAHILA MAHAVIDYALAY SIRSAM",
  "Ramji Assar Vidyalaya's Laxmichand Golwala College of Commerce & Economics M. G. Road. Ghatkopar (E), Mumbai-400 077",
  "M. J. M. Mahavidyalaya, Shirpur (Hore), Ta. Deoli, Dist. Wardha",
  "Dr Arun Motghare College of Pharmacy",
  "Rural Development Social Wel. Society's Chatrapati Shivaji Raje College, Rajendra Nangar, Kinwat",
  "Mahatma Basweshwar Mahavidyalaya, Latur",
  "Jawaharlal Nehru College of Social Work, Cidco, Nanded",
  "Dr. Shivling Shivacharya Maharaj Pratishthan's College of Education, Ahmedpur",
  "Saint Gadage Maharaj Mahavidyalaya, Loha",
  "Sharda Mahavidyalaya (Arts & Science), Parbhani.",
  "Dept of Occupational Therapy, Seth G.S.Medical College,  Mumbai",
  "100008-SES'S COLLEGE OF PHYSICAL EDUCATION, JALGAON.",
  "100113-KHANDESH COLLEGE EDUCATION SOCIETY'S POST GRADUATE COLLEGE OF SCIENCE, ARTS & COMMERCE, JALGAON.",
  "140065-PS&SSS PANKAJ ARTS COLLEGE, CHOPDA",
  "180049-APSPM'S SARDAR VALLABHBHAI PATEL ARTS & SCIENCE COLLEGE, AINPUR.",
  "200073-BSSPM'S ARTS & SCIENCE COLLEGE, SONGIR, TAL.& DIST-DHULE",
  " Yogita Dental College & Hospital, Naringi Riverside, At.-Post.Tal.-Khed, Dist. Ratnagiri-415709.",
  "SSTs Ayurved Medical College, Sangamner",
  "D. S. Homoeopathy College, Pune",
  "Sinhgad Dental College & Hospital, Vadgaon (BK), Pune",
  "P.D.Upadhyay Dental College, Kegaon,Solapur",
  "Foster Developments Homoeopathy College, CIDCO, Aurangabad",
  "CMFs College of Physiotherapy, Pune",
  "200022-K.S.WANI ADVANCED STUDY CENTRE IN MARATHI, DHULE.",
  "JAMIA ISLAMIA ISHAATUL ULOOMS, JAMIA COLLEGE OF EDU. (B.ED), AKKALKUWA.",
  "Vasantrao Kale Homoeopathic Medical College & Hospital, Latur",
  "Sanjivani College of Engineering, At. Sahajanandnagar, Post. Shingnapur, Tal. Kopargaon, Dist. Ahmednagar 423603",
  "ADITYA INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH",
  "G S PATIL COLLEGE OF MANAGEMENT AND BUSINESS STUDIES",
  "A M D MAHAVIDYALAYA",
  "Lokmanya Tilak Medical College, Sion, Mumbai",
  "SACCHIDANAND KALA, KRIDA & SHIKSHAN MANDAL'S B ED COLLEGE, PARNER",
  "MATOSHRI GURUBASAVVA KALYANSHETTI  ARTS AND COMMERS WOMENS COLLAGE, AKKALKOT",
  "SAI COLLEGE OF B DESIGN",
  "B N Bandodkar College of Science  Chendani Bunder Road  Thane",
  "IMPERIAL COLLEGE, NANDED",
  "RASHTARMATA JIJAU MAHILA MAHAVIDYALYA NANDED ROAD WASMATH DIST HINGOLI",
  "Shri Vile Parle Kelavani Mandal's Narsee Monjee College of Commerce & Economics, New SBMP Building, Opp Cooper Hospital, Bhakti Vedant Marg, Behind B.J. Hall, Vile Parle (West), Mumbai",
  "PROFESSIONAL SKILL DEVELOPMENT COLLEGE OF B.SC (INTERIER DESIGN) RAHIMPUR  TQ. GANGAPUR, DIST. AURANGABAD",
  "RADIANT SUPERSPECIALITY HOSPITAL",
  "A P SHAH INSTITUTE OF TECHNOLOGY, KASARVADAVALI",
  "AMAR SANSTHA SANCHALIT ARTS COLLEGE, CHOPDA",
  "VISHWANIKETANs COLLEGE OF ARCHITECTURE, ARTS AND DESIGN (VCAAD)",
  "KALPATARU ARTS, COMMERCE AND SCIENCE COLLEGE, NIMGAON",
  "Thakur College of Engineering & Technology Shaymnarayan Thakur Marg Thakur Village Samata Nagar Kandivli (East) Mumbai",
  "Mahatma Education Societys  Pillais College of Arts Commerce & Science",
  "Bombay College of Pharmacy Kalina Santacruz (East) Mumbai",
  "The Kandivli Education Societys Bhanumati Kishandas Shroff of Arts and Maganlal Hargovinddas Shroff College of Commerce  Shantilal Modi Road Kandivli  West Mumbai",
  "Ashoka Education Foundations Ashoka Business School, Address: Next to Suman Petrol Pump, Mumbai Agra Highway, Rane Nagar, Nashik - 9.",
  "R A Podar College of Commerce & Economics Matunga Mumbai",
  "Hindi Vidya Prachar Samitis Ramniranjan Jhunjhunwala College Opp Railway Station Ghatkopar West Mumbai",
  "South Indian Education Societys College of Arts, Science and Commerce Sion West Mumbai",
  "Jai Hind College,Basantsing Institute of Science and J.T.Lalvani College of Commerce & Shaila Gopal Raheja College of Management, Backba Reclamation, A Road, Churchgate, Mumbai",
  "Metropolitan Education Trust - Mata Vaishnodevi College of Arts, Commece And Science",
  "Shri Vile Parle Kelvani Mandals Mithibai College of Arts Chauhan Institute of Science and Amrutben Jivanlal College of Commerce and Economics Vile Parle West Mumbai",
  "Principal  L N Welingkar Institute of Management Development and Research L. N. Road, Opp. Matunga Gymkhana, Matunga (Central) Mumbai",
  "Bharatiya Vidya Bhavans, Sardar Patel College of Engineering, Munshi Nagar, Andheri West, Mumbai",
  "Bhartiya Vidya Bhavans Sardar Patel Institute of Technology  Munshi Nagar Andheri Mumbai",
  "Shikshana Prasark Mandals Ramnarain Ruia College",
  "Malad Kandivli Education Societys Nagindas Khandwala College of Commerce, Arts and Management Studies and Shantaben Nagindas Khandwala College of Science, Bhavishya Bharat Campus, SVRoad, Malad West, Mumbai",
  "SAVITRIBAI PHULE MAHILA MAHAVIDYALAYA JAMNER TAKLI TAL JAMNER DIST JALGAON",
  "COLLEGE OF HOME SCIENCE",
  "TALENT HUNT COLLEGE WADWANI",
  "DR A P J ABDUL KALAM COLLEGE OF MANAGEMENT",
  "SHRIRAM KALA MAHILA MAHA VIDYALAYA, DHAMANGAON RLY",
  "P E SOCIETYS PHARMACY COLLEGE AND RESEARCH CENTER, PHALTAN",
  "Loknete Ma.Hanmantrao Patil Charitable Trusts, Adarsh Institute of Technology &  Reserch Centre Tal. Khanapur Dist. Sangli ",
  "KEDARI REDEKAR COLLEGE OF NURSING",
  "DAMJI POSALA GAVIT AYURVAD COLLEGE AND HOSPITAL PATHARAI TAL DIST NANDURBAR MAHARASHTRA ",
  "Tuljabhavani Mahavidyalaya, Tuljapur, Dist. Osmanabad",
  "LPS ARTS COMMERCE AND MANAGEMENT COLLEGE BHANDARA",
  "GOVERNMENT COLLEGE OF ENGINEERING RATNAGIRI",
  "Br. Nath Pai B.Ed. College",
  "SHRIPATRAO CHAUGULE VIDHI MAHAVIDHYALAYA MALWADI KOTOLI TAL PANHALA DIST KOLHAPUR",
  "DR APJ ABDUL KALAM LAW COLLEGE VASUMBE TAL TASGAON DIST SANGLI",
  "CHHATRAPATI SHIVAJI MAHARAJ VIDHI MAHAVIDYALAYA KOROCHI TAL HATKANGALE DIST KOLHAPUR",
  "LOBHASING NAIK MAHAVIDYALAY KALAMBA TQ MANGRULPIR DIST WASHIM",
  "Shree L.R.Tiwari College of Law",
  "SHIVGANGA AYURVEDIC MEDICAL COLLEGE AND RESEARCH CENTRE ",
  "DR DNYANESHWAR MULE LAW COLLEGE SANGLI",
  "Mamasaheb Bhuwad College of Commerce and Hotel Management",
  "SANGAMESHWAR RATRA MAHAVIDYALAYA",
  "Army Institute of Technology, Dighi Hills, Pune",
  "JANKI DEVI BAJAJ INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH, PUNE",
  "S K PATIL SHIKSHAN PRASARAK MANDAL SANCHALIT DR VILASRAO DESAI ARTS COMMERCE AND SCIENCE COLLEGE ",
  "SHREE DATTA  MAHAVIDYALAY TIRORA",
  "YOG VIDYA DHAM SHIRPUR",
  "SAMAJONNATI SHIKSHAN SANSTHAS COMMERCE COLLEGE",
  "SHRI SANT DAMAJI APPA MAHAVIDYALAY SINGNAPUR",
  "IIBM COLLEGE OF HOSPITALITY STUDIES ",
  "SIDDHANT SENIOR COLLEGE  AMBAPUR TAL SAKRI  DIST DHULE",
  "MADHAVASHRAM MAHAVIDYALAY MARDSGAON",
  "DNYANDEO LIMBAJI TAMBARE VARISHTH MAHAVIDYALAY",
  "KAVYA MAHILA MAHAVIDYALYA",
  "DEOGIRI MAHILA MAHAVIDYALAY",
  "MATOSHRI MAHILA MAHAVIDYALAY",
  "SAHAJ JEEVAN EDUCATION TRUST SANCHALIT R V PATEL COLLEGE OF SCIENCE COMERCE AND ARTS",
  "LATE MADHUKARRAO KASHIKAR PRASHASAKIY SEVA MAHAVIDYALAYA  MADH",
  "LATE R K PATIL COLLEGE OF CIVIL SERVICES PIMPRI GAWALI  TQ MOTALA  DIST BULDANA",
  "VILASRAO DESHMUKH PRASHASKIY SEVA MAHAVIDYALAY GANGAKHED DIST PARBHANI",
  "MAULI B A PRASHASKIY SEVA VARISHTH MAHAVIDYALAY RAJUR TA BHOKARDAN JI JALNA",
  "YASH PRASHASAKIYA MAHAVIDYALAY JAFRABAD TA JAFRABAD DIST JALNA",
  "Sanjeevan Engineering & Technology Institute, Somwar Peth,Panhala,",
  "College of Pharmacy,  JAVALWADI,",
  "Late. R.G.Deshmukh Arts,Commerce & Science Mahavidyalaya, Tiosa, Distt:-Amravati",
  "Maharshi Karve Stree Shikshan Sanstha's Sitabai Nargundkar College of Nursing for Women, Nagpur",
  "Shikshak Sanchalit Shikshan Sanstha's, Dr. Shantilal Dhanji Devsey Arts College and Commerce and Science College, Wada, Dist.-Palghar-421303",
  "Krishnarao Sitaram Desai Shikshan Mandal's S. K. Patil Sindhudurg Mahavidyalaya, Malvan, Dist. Sindhudurg-416 606",
  "160031-P.R.HIGH SCHOOL SOCIETY'S ARTS, COMMERCE AND SCIENCE COLLEGE, DHARANGAON, TAL : DHARANGAON",
  "SYMBIOSIS Centre for Management and Human Resource Development",
  "St. Andrews College of Nursing (B.Sc.), 283, Shukrawarpeth, Wadia Hospi. Campus, Pune",
  "St. Andrews Education Foundations St. Andrews College of P.B.B.Sc. Nursing, Pune",
  "Saraswati Dhanwantari Dental College & Hospital, Parbhani",
  "POST GRADUATE INSTITUTE OF MEDICAL SCIENCES, NAVI MUMBAI",
  "170033-APPASAHEB RAGUNATHRAO BHAURAO GARUD ARTS, COMMERCE & SCIENCE COLLEGE SHENDURNI TAL-JAMNER DIST-JALGAON",
  "Maharashtra Academy of Engineering and Educational Research's MIT Arts, Commerce and Science College, Alandi Devachi, Tal. Haweli, Dist. Pune",
  "Vishwabharti Mahavidyalaya, Nanded",
  "GONDIA COLLEGE OF PHARMACY CHULOD GONDIA",
  "Vision college of Nursing Yelgaon Buldana",
  "Shivaji Raje Mahavidyalaya Kinwat",
  "NAGPUR COLLEGE OF PHARMACY",
  "Ozar Vikas Sansthas Vishwasattya College of MBA, Ozar (Mig), Tal. Niphad, Dist. Nashik 422206",
  "SANT GAJANAN MAHARAJ COLLEGE OF OPTOMETRY, MAHAGAON ",
  "HON SHRI SHANKARRAO TAKEKAR INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH",
  "SYMBIOSIS Law School, Nagpur",
  "Adarsh Shikshan Sanstha's, Kalikadevi Arts, Commerce and Science College Shirur (Kasar), Tq- Shirur (Kasar), Dist- Beed",
  "Ganpati  Arts & Science College, Biloli",
  "SHRI SAI COLLEGE OF PHARMACY MOUDA",
  "MDA School of Pharmacy Kolpa",
  "SMT SUSHILADEVI MALHARRAO DESAI KANYA MAHAVIDHYALYA, PETH VADGAON",
  "BAPUSAHEB THITE COLLEGE OF NURSING",
  "250043-SSVPS'S SMT.P.B.BAGAL ARTS & COMMERCE COLLEGE, DONDAICHA, TAL SHINDKHEDA, DHULE",
  "Chichgad Mahavidyalaya Chichgad",
  "BAJAJ INSTITUTE OF TECHNOLOGY",
  "SHIV CHTRAPATI MAHAVIDYALAY",
  " Training Ship Chanakya",
  "V P College of Pharmacy, Madkhol",
  "LATE SHOBHATAI MANIKRAO DESHMUKH GRANTHALAY VARTASHASHTRA MAHAVIDYALAY",
  "THE SHETKARI SHIKSHAN MANDALS, JAYAWANT INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH",
  "SARA INSTITUTE OF NURSING EDUCATION",
  "RAJMATA JIJAU MAHILA MAHAVIDYALAY RAMNAGAR",
  "Swami Vivekanand Institute of Paramedical Sciences",
  "Sw. Swati Patil Mahavidyalay Asangaon, Tal-Dahnau, Dsit- Palghar",
  "MATOSHRI HOMOEOPATHIC COLLEGE EKLAHARE NASHIK    ",
  "SINDHUTAI KALE MAHILA MAHAVIDYALAY, ERANDESHWAR    ",
  "CHITRAI MAHAVIDYALAYA KARANJKHEDA",
  "SHRIRAM INSTITUTE OF ENGINEERING AND TECHNOLOGY POLY PANIV",
  "Samarth Rural Educational Institute, Rajuri's Samarth College Of Computer Science, Belhe (Bangarwadi), Taluka - Junnar, District - Pune 412410",
  "Sinhgad Institute of Business Administration and Computer Application",
  "Matoshri Sayarbai Champalalji Chopda B.Ed. College, Khamgaon",
  "Ruplata Dewaji Kapgate Mahavidyalay Kokna Jami ",
  "Shaikh Ahmed Mahila Arts College, Harsul, Aurangabad",
  "DHIMAN MULTIEDUCATION COLLEGE OF COMMERCE and SCIENCE  BRAMHANI, TH. KALMESHWAR, dIST. NAGPUR",
  "Pravara Rural Education Societys Arts ,Commerce and Science College, Satral, Tal.Rahuri, Dist.Ahmednagar.",
  "Shri Shiv-Shahu Mahavidyalaya, SARUD",
  "Maratha Vidya Prasarak Samaj's Arts, Commerce and Science College, Khedgaon.",
  "Shree Saraswati Institute Of Pharmacy, Tondavali",
  "HINDI VIDYA PRACHAR SAMITIS COLLEGE OF LAW",
  "BHARATMATA MAHILA MAHAVIDYALAY MALGANI    ",
  "CHITRAI MAHAVIDYALAY CHAPANER",
  "Pune District Education Mandal's Anantrao Pawar College, Pirangut, Taluka - Mulshi, District - Pune 412115",
  "Mahatama Gandhi Vidyamandirs  Samajshree Prashant Hiray College of Pharmacy,Malegaon Camp,Dist.Nashik 423101",
  "Dr. D.Y. Patil  Unitech Society's Dr. D. Y. Patil Law College, Sant Tukaram Nagar, Pimpri, Pune 411018",
  "Shree Samarth Shikshan Va Krida Prasarak Mandal Akola s Samarth Nursing BSc College Akola",
  "SHRI DATTA MAHILA MAHAVIDYALAY",
  "100004-Khandesh College Education Society'S College of Education And Physical Education, JALGAON.",
  "DNYANADA MAHAVIDYALAY SASHTAPIMPALGAON TAL AMBAD DIST JALNA    ",
  "YASHWANT MAHILA MAHAVIDYALAY, MANTHA",
  "MURDESHWAR MAHILA MAHAVIDYALAY",
  "METs School of Architecture and Interior Design",
  "RAJMATA JIJAU MAHILA MAHAVIDYALAY MEHKAR",
  "BALAGHAT VIDHI MAHAVIDYALAYA AHMEDPUR TQ AHMEDPUR DIST LATUR",
  "M.G.M.'S College of Engineering, Air Port, Hingoli Road, Nanded",
  "College of Agriculture, (Amkheda)",
  "Rajashree Shahu Maharaj College of Agriculture Business Management (Sadak Aurjuni)",
  "Vidya Vikas Education Trust's Lords Universal College Night Topiwala Marg, Off Station Road, Goregaon (W), Mumbai - 400 104",
  "BIRLA INSTITUTE OF TECHNOLOGY AND SCIENCE PILANI OFF CAMPUS CENTRE AT MUMBAI METRO POLITAN REGION",
  "Vidya Vikas Education Trust's Lords Universal College Topiwala Marg, off Station Road, Goregaon West, Mumbai - 400 104",
  "Camp Education Society's Rasiklal M. Dhariwal Institute of Management, Nigadi Pradhikaran, Pune 411044",
  "Sanskardham Kelvani Mandals Jashbhai Maganbhai Patel College of Commerce  Unnat Nagar Off M G Road  Goregaon West Mumbai",
  "Dhote Bandhu Science College,",
  "SYMBIOSIS School of International Studies",
  "SYMBIOSIS School of Sports Sciences",
  "Krishna Foundation Sanchalit Jayawant Institute of Management, Vathar",
  "Krishna Foundation Sanchalit Krishna Institute of Computer Application and Management, Vathar",
  "Kasegaon Education Society Smt. Kusumtai Rajarambapu Patil Kanya Mahavidyalaya,Islampur",
  "Kai Sou Malatidevi Vasantrao Patil Mahila Shikshan Shastra Mahavidyalaya, Duyyam Bazar Awar, Market Yard, MIRAJ",
  "Kamala College,Rajarampuri",
  "Dahiwadi College,  DAHIWADI",
  "Dr.J.P.Naik Mahavidyalaya, Uttur",
  "Ganpatrao Arwade College of Commerce",
  "SKN SINHGAD COLLEGE OF ENGINEERING KORTI  TAL PANDHARPUR  DIST-SOLAPUR",
  "Ismailsaheb Mulla Law College",
  "Gulabrao Patil College Of Education, Miraj",
  "SAU LEENA KISHOR MAMIDWAR INSTITUTE OF MANANAGEMENT STUDIES AND RESEARCH, KOSARA",
  "SHRI SANT MAHAVIDYALAYA (NIGHT SHIFT)",
  "ORIENTAL INSTITUTE OF MANAGEMENT",
  "Dr D Y Patil Educational Federation Dr D Y Patil College of Engineering & Innovation, Varale, Talegaon, Maval",
  "Ekta Shikshan Prasarak Mandal Sanchalit Arts, Commerce & Science College, Pipeline Road, Savedi, Ahmednagar",
  "Pad Dr D Y Patil College of Architecture Nerul Mumbai",
  "PADMASHREE DR D Y PATIL COLLEGE OF AGRICULTURE, TALSANDE",
  "Dr. Ashok Gujar Technical Institute's Dr.Daulatrao Aher College of Engineering, Banavadi, KARAD, Tal. Karad",
  "K K WAGH COLLEGE OF AGRICULTURAL BIOTECHNOLOGY, EDUCATIONAL CAMPUS",
  "PADMASHREE DR VITHALRAO VIKHE PATIL FOUNDATIONS COLLEGE OF AGRICULTURE, MIDC VADGAON",
  "SADGURU COLLEGE OF AGRICULTURE, MIRAJGAON",
  "BHARTIYA EDUCATION SOCIETY INSTITUTE OF PHARMACY",
  "HON SHRI BABANRAO PACHPUTE VICHARDHARA TRUST PARIKRAMA ARTS COMMERCE AND SCIENCE COLLEGE KASHTI TAL SHRIGONDA, DIST AHILYANAGAR",
  "Late Bhaskarrao Shingane Arts, Prof. Narayanrao Gawande Science & Ashalata Gawande Commerce College, SakharKherada, Tq- Sindkhed Raja, Buldhana",
  "COLLEGE OF AGRICULTURAL BUSINESS MANAGEMENT, LONI",
  "COLLEGE OF AGRICUTURE, LONI",
  "SHRAMSHAKTI COLLEGE OF FOOD TECHNOLOGY, MALDAD",
  "K K WAGH COLLEGE OF FOOD TECHNOLOGY, SARASWATINAGAR",
  "K V PATEL COLLEGE OF AGRICULTURE, SHAHADA",
  "K K WAGH COLLEGE OF AGRICULTURAL ENGINEERING AND TECHNOLOGY, PANCHVATI NASHIK.",
  "Purushottam Thote College of Social Work, Narsala Road",
  "JAYWANTRAO BHOSLE KRISHNA COLLEGE OF AGRICULTURE, RETHARE BUDRUK",
  "SSPM FOOD TECHNOLOGY COLLEGE, DIWANMALA",
  "COLLEGE OF AGRICULTURE, SONAI",
  "COLLEGE OF AGRICUTURAL BIOTECHNOLOGY, LONI",
  "COLLEGE OF AGRICULTURE BUSINESS MANAGEMENT, GUNJALWADI PATHAR",
  "SHIV SHANKAR COLLEGE OF AGRICULTURAL ENGINEERING, MIRAJGAON",
  "Chirayu K.C. Bajaj College of Education, Jaripatka, Nagpur.",
  "Gauri Shankar Education & Charitable Trust Gauri Shankar Institute of Management Sciences, Limb,",
  "Govt. College of Pharmacy, KARAD",
  "Yashwantrao Chavan Mahavidyalaya, Urun Islampur",
  "Bombay Hospital College of Nursing, Bombay Hospital Trust, Mumbai",
  "Mahatma Education Societys Pillai College of Education and Research  Plot No.1, Sector-8, Khanda Colony, New Panvel (w)  410 206",
  "Gandhi Natha Rangaji Homoeopathy College, Solapur",
  "MATOSHRI ASARABAI DARADE AYURVED COLLEGE",
  "Shri Narendra Tidke College of Arts & Commerce, Ramtek",
  "HOUSABAI COLLEGE OF PHYSIOTHERAPY",
  "LATE SURESHANNA BATKADLI COLLEGE OF PHYSIOTHERAPY",
  "R G INSTITUTE OF PHARMACY, AURALA    ",
  "KRANTISURYA BIRSA MUNDA MAHAVIDYALAY GOKUNDA ",
  "GOVERNMENT MEDICAL COLLEGE,HINGOLI    ",
  "GOVERNMENT MEDICAL COLLEGE BULDHANA    ",
  "Trinity Academy of Engineering",
  "MODEL DEGREE COLLEGE, GADCHIROLI",
  "Oriental College of Law",
  "Mahatma Gandhi Missions College of Commerce",
  "CSMSS Chh. Shahu College of Engineering, Kanchanwadi, Aurangabad.",
  "LATE RAMCHANDRA DADA DHAS SENIOR COLLEGE, DEULGAON GHAT, ASHTI.",
  "Mahatma Gandhi Missions College of Computer Science and  & Information Technology,  Sector 18, Navi Mumbai 410 209",
  "PRAMOD RAVINDRA DHURI ADHYAPAK MAHAVIDYALAY",
  "Bharatiya Vidya Bhavans Hazarimal Somani  College of Arts and Science Jayaramdas Patel College of Commerce and Management Studies, Chowpatty",
  "Acharya Jawadekar Shikshanshastra Mahavidyalaya, GARGOTI",
  "PTVA's Institute of Management, Chitrakar Ketkar Marg, Behind M.L.Dahanukar College of Commerce, Vile Parle (E), Mumbai - 400 057.",
  "Padmabhushan Vasantraodada Patil Mahavidyalaya,  KAVATHE-MAHANKAL",
  "Shree Chanakya Education Society's Indira Global Bussiness School  Address: Sr. No. 64,65, Gat no. 276, Parandwadi, Near Somatane Phata, Off Old Pune Mumbai Highway, Taluka- Maval District Pune 410506  ",
  "National Centre for Rural Development`s Sterling College of Arts, Science, & Commerce, Plot No.93, Sector 19, Nerul, Navi Mumbai: 400 706.",
  "Sir J J  School of Art  Dr D N Road Mumbai  400 001 (Painting)",
  "Veermata Jijabai Technological Institute Matunga Mumbai",
  "The Bassein Gujarathi Education Societys Shah Khimchand Bhai Muljibhai College of Commerce  Bazarpeth  At Vasai Dist Thane 401 201",
  "Akemi Education Society Akemi Business School, Address: Buchade Wasti, Village- Marunji, Taluka: Mulshi, District: Pune 411057. ",
  "Mahatma Phule Education Societys College of Arts & Commerce  Night Jerbai Wadia Road  Bhoiwada Parel  Mumbai   400 012",
  "Shri L P Rawal College of Eduction & Research Mira Road (East) Dist. Thane 401 107",
  "DR D Y PATIL SCHOOL OF DESIGN",
  "SAHAKAR MAHARSHI SHANKARRAO MOHITE PATIL INSTITUTE OF TECHNOLOGY AND RESEARCH, SHANKARNAGAR",
  "Jawahar Education Society's Institute of Technology Management and Research, Address: Servey No-48,Gowardhan, Gangapur Road, Nashik, Taluka: Nashik District: Nashik",
  "Sinhgad Technical Education Societys Sinhgad College of Engineering, Wadgaon Bk., Pune",
  "Sindhudurg Education Societys V Y S B Ed College Tonadavli Nandgaon Titha Tal Kankavli  Dist  Sindhudurg",
  "Annasaheb Dange College of Engineering and Technology,  ASHTA",
  "Appasaheb Birnale College of Pharmacy, South Shivajinagar,Sangli Miraj Road,",
  "St. Wilfred College of Arts, Commerce and Science, At- Shedung, Tal - Panvel, Dist- Raigad - 410 206.",
  "Matoshree Shaikshnik Pratishthan Ane Rajiv Gandhi College of Engineering, Address: At-Po- Karjule Harya, Taluka: Parner District: Ahmednagar",
  "SAVITRIDEVI COLLEGE OF PHARMACY,WADGAON TIP,WANI,DIST YAVATMAL    ",
  "National Education Society Laxmi Ratan Shah B.Ed College Chinchghar Road Kudas Tal Wada Dist Palghar",
  "GOVERNMENT MEDICAL COLLEGE, WASHIM     ",
  "KARMAYOGI INSTITUTE OF PHARMACY    ",
  "Mumbai Educational Trust Institute of Phamacy Gen. Arun Kumar Vaidya Chowk Bandra Reclamation Bandra (West) Mumbai  400 050",
  "Navgan Shikshan Sanstha Rajuri's College of Physical Education.",
  "D B INSTITUTE OF MANAGEMENT AND RESEARCH, LATUR",
  "ANJUMAN-I-ISLAMS SCHOOL OF ENGINEERING AND TECHNOLOGY ATANJUMAN-I-ISLAM KALSEKAR TECHNICAL, MUMBAI",
  "SHRI V D DESHMUKH COLLEGE OF MCA, LATUR",
  "MARATHWADA ADHYAPAK MAHAVIDYALAYA, NANDED",
  "STMEIs Sandipani Technical Campus Faculty of Engineering Nanded Road, Kolpa, Latur-12",
  "LOKRAJYA JANSANVAD AND VRATTAPATRAVIDHYA MAHAVIDYALA, PARBHANI",
  "SYMBIOSIS Institute of Operations Management, Nashik",
  "SYMBIOSIS Institute of Management Studies",
  "Krishna Institute of Medical Sciences",
  "School of Dental Sciences",
  "Krishna Institute of Nursing Sciences",
  "2538-LATUR COLLEGE OF PHARMACY D. PHARM, LATUR",
  "R K DAMANI MEDICAL COLLEGE SHRIRAMCHANDRA INSTITUTE OF MEDICAL SCIENCES    ",
  "SES RAI SAHEB SITALDAS KHEMANI DEGREE COLLEGE OF ARTS COMMERCE AND SCIENCE     ",
  "SINDHUTAI VIKHE PATIL COLLEGE OF AGRICULTURE, MOH CHINCHOLI, TAL SINNAR, DIST  NASHIK    ",
  "MKD ARTS COMMERCE SCIENCE AND FASHION DESIGING COLLEGE, VIRCHAK , VIRCHAK    ",
  "ATMA SHANTI COLLEGE OF NURSING, MIRAJ    ",
  "Dnyansadhna B.C.A. College, Adarsh Nagar, Selu",
  "SHIDDHAI BED COLLEGE    ",
  "SANKALP PRATISHTHANS SANKALP COLLEGE OF ARTS, COMMERCE, AND SCIENCE    ",
  "GOVERNMENT MEDICAL COLLEGE NASHIK    ",
  "JIJAMATA EDUCATION SOCIETYS COLLEGE OF B SC NURSING, WAGHODA ROAD, NANDURBAR    ",
  "ANAND COLLEGE OF HOMOEOPATHY    ",
  "Smt. Sushiladevi Deshmukh Mahila Senior college, Latur",
  "Indira Gandhi Senior College, Cidco, Nanded",
  "Saraswati Sangeet Arts Mahavidyalaya, Latur",
  "Sant Tukaram Law College, Udgir",
  "Dr. Ram Rodge Adhyapak Mahavidyalaya, Selu",
  "Ahilyadevi Holkar College, Jalkot",
  "Shri Hawagiswami College, Udgir",
  "Vasantrao Naik College, Vasarni, Nanded",
  "Ujwal Gramin Mahavidyalaya Ghonsi, Tq. Devni",
  "College of Physical Education, New Bridge, Kautha, Nanded",
  "BRAHMA VALLEY INSTITUTE OF PHARMACY    ",
  "SHETH M K DEGREE COLLEGE OF SCIENCE    ",
  "SANKALP PRATISTHANS SANKALP COLLEGE OF BBA BCA    ",
  "MATOSHRI COLLEGE OF PHARMACY MHASRUL NASHIK     ",
  "DNYAN GANGA COLLEGE OF PHARMACY    ",
  "Netaji Subhashschandra Bose Arts, Commerce and Science College, Vazirabad, Nanded",
  "Pradnya Pratishtan's Adhyaapak Mahavidyalaya,Purna Road, Nanded",
  "Narayanrao Waghmare Mahavidyalaya, Akhada Balpur, Tq. Kalamnuri",
  "Maharashtra Udaygiri Mahavdiyalaya, Udgir",
  "Late Bapusaheb Patil Ekambekar College, Hagegaon, Tq. Degloor",
  "Dayanand Science College, Latur",
  "Late Sow. Sheshabai Sitaram Munde Arts College, Gangakhed",
  "Pansare Mahavidyalaya, Arjapur, Tq. Biloli",
  "Shivneri Mahavidyalaya,  Palam",
  "PANDIT DEENDAYAL UPADHYAY MAHAVIDYALAYA, DEONI",
  "S.S.T.'s Arts College of Fashion Design, Latur",
  "Priyadarshini Seva Sanstha's College of Education Kalamnuri",
  "K.R.M. Mahila Arts & Comm Mahavidyalaya, Vazirabad, Nanded",
  "Madhavarao Patil Mahavidyalaya, Palam",
  "Sindhu College of I.T. & Science, Degloor",
  "Shri Yoganand Swami Arts Mahavidyalaya, Vasmat Nagar",
  "Baliram Patil Mahavidyalaya, kinwat",
  "Matoshri Pratishthan's School of Management, Jijau Nagar, Khupsarwadi, Post Vishnupuri, Nanded",
  "Shankarrao Chavan Mahavidyalaya, Ardhapur",
  "Late Shankarrao Satav Arts & Commerce College Kalamnuri",
  "Vyankatesh Mahavidyalaya, Valandi, Tq. Devni",
  "Rajarshi Shahu Mahavidyalaya, Parbhani",
  "Shyamgir Mahavidyalaya, Shivni Kotal, Tq. Nilanga",
  "Shri Chatrapati Arts, Science  College, Jawla Bazar, Tq. Aundha Nagnath",
  "Dr. A.P.J. Abdul Kalam College of Education, Yusufiya Colony, Parbhani",
  "Shri Shivaji College, Vasmat Road, Parbhani",
  "Mahatma Phule Adhyapak Mahavidyalaya, Jalkot",
  "Science College, Nanded",
  "Jijau College of Education (B.Ed), Bachoti",
  "M.G.M.'S College of Computer Science & I.T., Nanded",
  "Naigaon Education Society's College of Education, Nagigaon",
  "College of Education, Gangakhed",
  "Nutan Mahavidyalaya, Selu",
  "People's College, Nanded",
  "Late Ramesh Warpudkar Arts, Commerce and Science College, Sonpeth",
  "Nanded Pharmacy College, Shyam Nagar, Nanded",
  "V.B.S.S. Shri Shyamrao Patil Journalism College, Latur",
  "M.G.M. College of Library & Information Science, Nanded",
  "Rabindra Nath Tagore Chitrakala Mahavidyalaya, Parbhani",
  "Gramin Arts, Commerce & Science Mahavidyalaya, Vasant Nagar, Kotgyal, Tq. Mukhed",
  "Abhinav College of Education, Latur",
  "Sahyog Seva Bhavi Sanstha College  of Education Vishnupuri, Nanded",
  "Sambhaji College Arts and Commerce, Murud",
  "Baliram Patil Gawte Arts & Commerce College, Penoor, Tq. Loha",
  "Shahu Raje Adhyapak Mahavidyalaya, Ahemadpur",
  "Vasant Kale College of Computational & Management Science, Vishnupuri, Nanded",
  "Azad Mahavidyalaya, Ausa",
  "Dayanand Arts College, Latur",
  "Late Venkatrao Deshmukh Mahavidyalaya Babhalgaon",
  "Jai Kranti Arts College, Latur",
  "Dayanand Commerce College, Latur",
  "Shri Shivaji Law College, Vasmat Road, Parbhani",
  "Sambhajirao Kendre Mahavidyalaya, Jalkot",
  "Rajarshi Shahu Mahavidyalaya, Latur",
  "Shri Shivaji College, Murud, Tq. Latur",
  "Late Baburao Patil Arts & Science College, Hingoli",
  "Yeshwant College, Wadwana, Tq. Ahemadpur",
  "Yeshwant Mahavidyalaya, Nanded",
  "Shahid Bhagatsingh College of Killari, Tq. Ausa",
  "Karmyogi Tulsiram Pawar Mahavidyalaya Hadolti,Tq. Ahemadpur",
  "Mahatma Phule College, Kingaon,Tq. Ahemadpur",
  "Channabasweshwar Pharmacy College (Degree), Latur",
  "Rajiv Gandhi Mahavidyalaya, Mudkhed",
  "Matarbhomi Mahavidyalaya, Udgir",
  "Sai Ram College, Biloli",
  "PU AHILYADEVI VARISHTHA MAHAVIDYALAYA SANGAVI SU TQ AHMEDPUR DIST LATUR    ",
  "College of Military Engineering",
  "DR KHACHANE NURSING COLLEGE ,JALGAON    ",
  "DISHA BAHUDDESHIY SEVABHAVI SANSTHAS MATOSHRI RAMAI COLLEGE OF SOCIAL WORK, BADANAPUR TQ BADANAPUR DIST JALNA    ",
  "ART COMMERCE AND SCIENCE COLLEGE AARAVE TAL SHINDKHEDA DIST DHULE    ",
  "GODAVARI FOUNDATIONS DR. ULHAS PATIL COLLEGE OF SCIENCE, JALGAON",
  "100054-GOVERNMENT COLLEGE OF ENGINEERING, JALGAON.",
  "260084-GRAMVIKAS MANDAL'S MOLGI SANCHALIT PRADNYA SR. COLLEGE OF ARTS, MOLGI, TAL-AKKALKUWA, DIST-NANDURBAR",
  "200003-SSVPS'S BHAUSAHEB N.S.PATIL ARTS & M.F.M.A. COMMERCE COLLEGE, DHULE.",
  "200101-ASPMD'S BAPUSAHEB D.D.VISPUTE COLLEGE OF EDUCATION, VALWADI-DHULE",
  "240096-KVPS'S INSTITUTE OF PHARMACEUTICAL EDUCATION, BORADI",
  "SHIRPUR EDUCATION SOCIETY'S R.C. PATEL COLLEGE OF EDUCATION SHIRPUR, TAL. SHIRPUR, DIST. DHULE",
  "260050-VIDYA VIKAS MANDAL'S ARTS & COMMERCE COLLEGE, AKKALKUWA.",
  "210027-PIMPALNER EDUCATION SOCIETY'S KARM. A. M. PATIL ARTS, COMMERCE AND KAI. ANNASAHEB N. K. PATIL SCIENCE SENIOR COLLEGE, PIMPALNER TAL-SAKRI, DIST-DHULE",
  "100007-SSBT'S COLLEGE OF ENGINEERING & TECHNOLOGY, BAMBHORI.",
  "Eklavya Study Center, Nandurbar",
  "100003-EU'S DR. ANNASAHEB G.D.BENDALE MAHILA MAHAVIDYALAYA, JALGAON.",
  "170034-PT CO-OP ES'S ARTS,SCIENCE & COMMERCE COLLEGE, PACHORA.",
  "160030-YASHWANTRAO CHAVAN SHIKSHAN PRASARAK MANDAL'S DADASAHEB DIGAMBAR SHANKAR PATIL ARTS, COMMERCE AND SCIENCE COLLEGE, ERANDOL",
  "140024-CES'S COLLEGE OF EDUCATION, CHOPDA.",
  "240080-AVPSS ARTS COLLEGE,THALNER,TAL-SHIRPUR, DIST-DHULE",
  "170096-SHREE SURESHDADA JAIN INSTITUTE OF PHARMACEUTICAL EDUCATION & RESEARCH, JAMNER",
  "230066-GRAM VIKAS SANSTHA'S ARTS COLLEGE, BAMKHEDA, TAL-SHAHADA. DIST. NANDURBAR",
  "240055-SES'S R.C.PATEL INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH, SHIRPUR, DIST DHULE",
  "110050-THE BHUSAWAL PEOPLES CHARITABLE SANSTHA'S DADASAHEB DEVIDAS NAMDEO BHOLE COLLEGE, BHUSAWAL TAL. BHUSAWAL DIST. JALGAON",
  "100103-SES'S COLLEGE OF EDUCATION, JALGAON.",
  "190042-SSPM'S RANI LAXMIBAI MAHAVIDYALAYA, PAROLA, Tal-Parola, Dist - Jalgaon",
  "140046-MGSM'S SMT.SHARADCHANDRIKA SURESH PATIL COLLEGE OF PHARMACY, CHOPDA",
  "260089-RFN'S SENIOR SCIENCE COLLEGE, AKKALKUWA.",
  "130021-RSSPM'S NANASAHEB YASHAVANTRAO N.CHAVAN ARTS,SCIENCE&COMMERCE COLLEGE,CHALISGAON",
  "100110-SMBKMP'S SHRI.CHHATRAPATI RAJE SAMBHAJI COLLEGE OF EDUCATION, JALGAON",
  "210068-NAVODAY SHAIKSHANIK SANSTHA DHULE'S  UTTAMRAO PATIL ARTS AND SCIENCE COLLEGE, DAHIWEL,TAL-SAKRI, DIST-DHULE",
  "BODWAD EDUCATION SOCIETY, BODWAD, ARTS, COMMERCE & SCIENCE COLLEGE, BODWAD.",
  "220029-TES'S ARTS,COMMERCE & SCIENCE MAHILA MAHAVIDYALAYA, NANDURBAR.",
  "Jamia Islamia Ishatul Uloom Ali-Allana College of Pharmacy Akkalkuwa.",
  "100089-GFS'S GODAVARI COLLEGE OF MUSIC & FINE ARTS,JALGAON",
  "100006-KRIDA RASIK EDUCATION SOCIETY INSTITUTE OF MANAGEMENT & RESEARCH JALGAON SANCHALIT ADV.SITARAM (BABANBHAU) ANANDRAMJI BAHETI ARTS,COMMERCE&SCIENCE COLLEGE, JALGAON",
  "100010-KCES'S INSTITUTE OF MANAGEMENT & RESEARCH, JALGAON.",
  "230069-SSPM'S ARTS MAHILA COLLEGE, SHAHADA.",
  "100005-KCES'S S.S.MANIYAR LAW COLLEGE, JALGAON.",
  "Godavari Foundations Dr. Ulhas Patil Medical College & Hospital, Jalgaon Khurd, Tal. & Dist. Jalgaon",
  "MCE Societys M. A. Rangoonwala College of Dental Sciences & Research Centre, Pune",
  "VSPM's College of  Physiotherapy, Nagpur",
  "Maharashtra Institute of Nursing Sciences  (B.Sc.) Vishwanathpuram, Latur",
  "Occupational Therapy School & Centre,  Lokmanya Tilak Municipal Medical College, Mumbai",
  "Physiotherapy Teaching and Treatment Centre, Lokmanya Tilak Municipal Medical College, Mumbai",
  "Jagdamba Education Soceitys S.N.D. College of B.Sc. Nursing at Babhulgaon, Tal. Yeola, Nashik",
  "Rural Ayurved Mahavidyalay & Research Centre,  Mayani, Tal. Khatav, Dist. Satara.",
  "Ramrao Patil Ayurved Mahavidyalaya & Rugnalaya, Purna",
  "Government Dental College & Hospital, Mumbai",
  "Vamanrao Ithape Homoeopathy College, Sangamner",
  "Kasturba Health Societys Kasturba Nursing (B.Sc.) College, Sewagram, Tal. &  Dist. Wardha",
  "Pad. Dr. V.V. Patil Foundations Medical College, Ahmednagar.",
  "T.S. Homoeopathy College, Amravati",
  "Kakasaheb Mhaske Homoeopathy College, Ahmednagar",
  "Dr. J.J. Magdum Homoeopathy College, Jaisinghpur",
  "Govt. Ayurved Mahavidyalaya, Nagpur",
  "VSPMs Dental College & Research Centre, Dighoh Hills, Hingna Road, Nagpur",
  "Bhausaheb Mulak Ayurved Mahavidyalaya, Nagpur",
  "E.B. Gadkari Homoeopathy College, Gadhinglaj",
  "Reynolds Memorial Hospital & Affiliated Clinicss Nazarene Nurses Training College (B.Sc.), Pusad Road, Washim",
  "Gokhale Education Societys Sir Dr.M.S.Gosavi Institute of Nursing Education Training& Research,Nashik.",
  "Marathwada Medical and Research Institute, Aurangabads Kamalnayan Bajaj Nursing College (B.Sc.) Aurangabad",
  "Dept. of Occupational Therapy, Govt. Medical College, Nagpur",
  "Z. V. M. Unani Medical College, Pune",
  "Sinhgad Nursing College, Pune (B.Sc.)",
  "L.M.F. Homoeopathy College, Chinchwad, Pune",
  "Shirodkar Hospital Trust s Institute of Nursing Education & Paramedical Sciences (P.B.B.Sc.), Dombivli (E), Dist. Thane",
  "P.D. Jain Homoeopathy College, Parbhani",
  "Ahmed Garib Unani Medical College, Akkalkuwa,",
  "K. C. Ajamera Ayurved Mahavidyalya, Dhule",
  "Anantrao Kanase Homoeopathic Medical College & Hospital, Alephata",
  "Tilak Ayurved Mahavidyalaya, Pune",
  "Shri. S.K.Patil Shikshanshastra Mahavidyalaya, Prayag Chikhali",
  "Shri Raosaheb Ramrao Patil Mahavidyalaya,  SAVALAJ",
  "Shikshan Maharshi Bapuji Salunkhe Mahavidyalaya, Pantacha Kot,   Somwar Peth,          KARAD",
  "Savitribai Phule Mahila Shikshanshastra Mahavidyalaya, PETH-VADGAON",
  "Sadashivrao Mandlik Mahavidyalaya,  MURGUD",
  "Rajaram College",
  "Raja Shivchhatrapati Arts and Commerce College, MAHAGAON",
  "Padmabhushan Dr. Vasantraodada Patil Mahavidyalaya,  TASGAON",
  "Prof. Dr.N.D.Patil Mahavidayalaya,   MALKAPUR",
  "Rajarambapu College of Pharmacy, KASEGAON,",
  "Mudhoji College,  PHALTAN",
  "Namdevrao Suryawanshi (Bedake) Mahavidyalaya, PHALTAN",
  "Mahavir Mahavidyalaya,Bhausingji Road",
  "Mhaisal Mahavidyalaya, Mhaisal",
  "Kratisinh Nana Patil Mahavidyalaya, WALAWE",
  "Karmaveer Bahurao Patil Institute of Management  Studies & Research,",
  "Bharati Vidyapeeth's New Law College, Rajwada Chowk, Sangli",
  "Jaywant Mahavidyalaya Near Govt. Resthouse, Shahapur,  ICHALKARANJI",
  "Kakasaheb Chavan Mahavidyalaya, TALMAVALE",
  "Krishna College of Commerce & Science, Wather",
  "Hon.Shri Annasaheb Dange College of Education (B.Ed..), Ashta",
  "Bharati Vidyapeeth's New Law College,",
  "Jagruti Shikshanshastra Mahavidyalay, Gadhinglaj",
  "Jaysingpur  College, JAYSINGPUR",
  "Dattajirao Kadam Arts, Science & Commerce College, ICHALKARANJI",
  "Deshbhakta Ratnappa Kumbhar College of Commerce",
  "The New College, Kolhapur",
  "Arts, Commerce and Science College Kowad",
  "Devchand College, ARJUNNAGAR,   Nipani",
  "D.P.Bhosale College, KOREGAON",
  "Dr. Babasaheb Ambedkar Mahavidyalaya,  PETH-VADGAON",
  "D. Y. Patil College of Engineering & Technology,  KASABA BAWADA",
  "D. D. Shinde Sarkar College, Bhavani Mandap, Kolhapur",
  "Gopal Krishna Gokhale College",
  "Ichalkaranji Shikshan Shastra Mahavidyalaya, Shahapur, Ichalkaranji",
  "Bharati Vidyapeeth's Yashwantrao Chavan  Law College,  MALKAPUR KARAD,",
  "Arts and Commerce College, UNDALE",
  "M. H. Shinde Mahavidyalaya, Tisangi",
  "Arts & Commerce College, KASEGAON",
  "DR. PATANGRAO KADAM MAHAVIDYALAYA, RAMANANDNAGAR (BURLI)",
  "Arts, Commerce & Science College,Saraswati Nagar,GADHINGLAJ",
  "Arts, Comm. & Science Mahila Mahavidyalaya, Vishnu Galli, Vidyaniketan, premises, TASGAON",
  "Babasaheb Chitale College, BHILAWADI",
  "Chandrabai Shantappa Shendure College, HUPARI",
  "Chintamanrao College of Commerce",
  "Yashwantrao Chavan School of Social Work, Jakatwadi",
  "V.K.Chavan-Patil Arts, Commerce & Science College, Karave",
  "Walwa Taluka Education Society Late Malati Vasantdada Patil Kanya Mahavidyalaya, ISLAMPUR",
  "Warana Mahavidyalaya, AITAWADE",
  "Willingdon College",
  "Tatyasaheb Kore Institute of Engineering & Technology, WARANANAGAR",
  "Smt.Rajmati Nemgonda Patil Kanya Mahavidyalaya , Sangli",
  "Shikshan Maharshi Dr. Bapuji Salunkhe College, MIRAJ",
  "Shrimant Bhaiyyasaheb Rajemane Mahavidyalaya, Mhaswad Tal Man Dist Satara",
  "Savitribai Phule Mahila Mahavidyalaya",
  "Shahajiraje  Mahavidyalaya, KHATAV",
  "Sharadchandra Pawar Mahavidyalaya, LONAND",
  "Sant Gajanan Maharaj College of Pharmacy, Chinchewadi, Mahagaon,",
  "Raja Shripatrao Bhagawantrao Mahavidyalaya,  AUNDH",
  "Raje Ramrao Mahavidyalaya, JATH",
  "Prof.Sambhajirao Kadam College,  DEUR",
  "Radhanagari Mahavidyalaya, RADHANAGARI",
  "Mohanrao Patangrao Patil Mahavidyalaya, BORGAON",
  "Govt. Medical College, Latur",
  "B. J. Medical College, Sassoon Hospital Compound, Pune",
  "YOGAARTHI SCHOOL OF INDIC STUDIES    ",
  "SADGURU SHREE WAMANRAO PAI SHIKSHAN SANSTHA, CHANDRABHAGA COLLEGE OF PHARMACY KATPHAL BARAMATI    ",
  "ADVIKA ARTS, COMMERCE AND SCIENCE WOMENS COLLEGE, BIBI    ",
  "SUMITRABAI VARISTHA MAHILA MAHAVIDYALAY, KHEDGAON    ",
  "BHUJBAL ACADEMY OF SCIENCE AND COMMERCE    ",
  "SNBP COLLEGE OF PHARMACY, CHIKHALI, PUNE    ",
  "CHIMA PATIL SHIKSHAN SANTHAS ADV KALYANI PATIL LAW COLLEGE    ",
  "MAHATMA JYOTIBA PHULE MAHILA MAHAVIDYALAY    ",
  "WATUMULL INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "LOKNETE BALASAHEB DESAI COLLEGE OF AGRICULTURE DAULATNAGAR    ",
  "COLLEGE OF AGRICULTURE NANDED    ",
  "SANT EKNATH COLLEGE OF ENGINEERING NIPANI BHALGAON BEED HIGHWAY CHHA SAMBHAJINAGAR    ",
  "Bharati Vidyapeeth  College of  Hotel & Tourism Management Studies  C.B.D. Belapur Navi Mumbai",
  "NASHIK SHIKSHAN PRASARAK MANDALS ARTS AND  COMMERCE MAHAVIDHYALAYA SINNAR TAL SINNAR DIST NASHIK ",
  "SAU SUREKHA PRAKASH KOLPE AYURVED COLLEGE & RESEARCH CENTRE    ",
  "MAHILA MAHAVIDYALAYA KALIMATI TA AMGAON DIST GONDIA    ",
  "RISING EDUCATION AND WELFARE SOCIETY,MATRUBHUMI MAHILA MAHAVIDYALAY,SIRSAM TAL DIST HINGOLI    ",
  "MAHAJAN SCIENCE COLLEGE YAVATMAL",
  "SHIVSHAMBHO MAHAVIDYALAYA KANHER TAL MALSHIRAS    ",
  "VIDYA PRASARAK MANDALS VIDYA PRASARAK MANDAL KINHAVALI SANCHALIT ARTS, COMMERCE AND SCIENCE COLLEGE DOLKHAMB    ",
  "BCA COLLEGE BHANSHIWARE",
  "YASHRATI MAHILA MAHAVIDYALAY",
  "CHANDRAPUR COLLEGE OF PHARMACY ",
  "GODAVARI SENIOR COLLEGE",
  "NATIONAL COLLEGE OF PHARMACY",
  "NK COLLEGE OF PHARMACY, ANTRAJ TQ KHAMGAON DIST BULDANA",
  "P G COLLEGE OF ENGINEERING AND TECHNOLOGY ",
  "FRIENDS UNION FOR ENERGISING LIVES FUEL",
  "LATE.MHATARBA LAXMAN PA.AHER PRATISHTHANS ,SITAI ARTS COMMERCE AND SCIENCE COLLEGE",
  "Vidya Prasarak Mandal's College of Engineering Jnanadweepa Thane College Campus Chendani Bunder Road Thane",
  "ARHAM LAW COLLEGE",
  "GANGA BHAGIRATHI MAHILA ARTS COMMERCE AND SCIENCE MAHAVIDYALAY MANTHA",
  "PRAGATI EDUCATION SOCIETYS PRAGATI DEGREE COLLEGE",
  "BR NATH PAI ARTS, COMMERCE AND SCIENCE COLLEGE (WOMEN)",
  "Shikshan Mandal Bhagur Shri Eknathrao Sahadu Shete Arts, Commerce and Science Senior College, Deolali Nashik",
  "SAYYED MOHASIN ARTS COMMERCE AND SCIENCE SENIOR COLLEGE PATUR TQ PATUR DIST AKOLA",
  "SAMAEE ASHFAQUE BSC COLLEGE ARTS AND SCIENCE MEHKAR ROAD WADAP TQ MALEGAON DIST WASHIM",
  "Shankarrao Chavan College, Tamsa, Tq. Hadgaon",
  "Bharata College of Fine Arts & Culture, Mumbai",
  "Shri Lemdeo Patil Mahavidhyalaya, Mandhal",
  "PRAVARA RURAL AYURVED COLLEGE",
  "Nashik Shikshan Prasarak Mandals Late Bindu Ramrao Deshmukh Arts Commerce and Science Mahila Mahavidyalaya, Nashik Road",
  "Shri Kisanlal Nathmal Goenka Arts & Commerce College, Karanja (Lad) Dist. Washim",
  "DR V K PATIL COLLEGE OF ENGINEERING AND TECHNOLOGY, AURANGABAD ROAD, OSMANABAD",
  "Shri Shivaji Education Society Amravati's Science College, Congress Nagar, Nagpur",
  "Matsyodari Shikshan Sanstha's Arts College, Tirthpuri Tq Ghansawangi, Dist Jalna",
  "Jaywant Shikshan Prasarak Mandal's Rajarshi Shahu College of Engineering, Mulashi, Pune",
  "Navjeevan Education Societys NAVJEEVAN INSTITUTE OF MANAGEMENT",
  "PSD Shastri Educational Foundations ASMA Institute of Management",
  "Late Vilas Bhosle College, Jalkot",
  "Shri Khanderai Pratishthan Dnyansagar Arts and Commerce College, Balewadi, Tal.Haveli, Dist. Pune",
  "SHANUBAI NAIK MAHILA MAHAVIDYALAYA,DHANKI",
  "RAJASHTHAN SHIKSHAN PRASARAK MANDALS ARTS COMMERCE AND SCIENCE COLLEGE MALEGAON DIST NASHIK",
  "NASHIK SHIKSHAN PRASARAK MANDALS ARTS AND COMMERCE COLLEGE J S RUNGATA HIGH SCHOOL NASHIK",
  "DESHMUKH ARTS, COMMERCE AND SCIENCE VARISHTHA MAHAVIDYALAYA, KASAR SIRSI",
  "MADHAVRAO PATIL ZARIKAR MAHAVIDYALAY ",
  "Sahyadri Bahujan Vidya Prasarak Samaj, Loknete Balasaheb Thorat Art, Commerce & Science College, Talegaon Dighe, Tal. Sangamner, Dist- Ahmednagar",
  "B.Sc. Nursing, Govt. Medical College & Hospital, Ajni, Nagpur",
  "KAI GANESH KAKA KULKARNI SCIENCE COLLEGE MADHA",
  "Rajrshi Shahu Arts, commerce Science  & I.T. College Hingoli",
  "NANDADEEP SCHOOL OF OPTOMETRY, NANDADEEP EYE HOSPITAL, OPPOSITE PATIDAR BHAVAN",
  "Jupiter Physical Education College, Sawarkar Nagar",
  "Saw.Padmadevi Ramprasadji Somani BCA College, Yeldarkar Colony, Parbhani",
  "COLLEGE OF AGRICULTURE, PAL GARGOTI",
  "MES MUKUNDDAS LOHIA COLLEGE OF ENGINEERING, PUNE",
  "COLLEGE OF NURSING, ST LUKES HOSPITAL, SHRIRAMPUR",
  "SHREE SAI PRASAD COLLEGE OF ARTS, SALWA, MOUDA",
  "SHRI BALASAHEB MANE SHIKSHAN PRASARAK MANDAL'S ASHOKRAO MANE GROUP OF INSTITUTIONS",
  "Swatantrata Sainani Kai. Kamalnaryanji Jaiswal Arts, Commerce and Science College",
  "Bhiwandi Womens College of Arts and Commerce",
  "Bahirji Smarak Senior College, Hatta, Tq. Vasmat",
  "SYMBIOSIS Law School, Pune",
  "Shri Murudeshwar College, Petshivni, Tq. Palam",
  "MATOSHRI INDIRA MAHAVIDYALAY",
  "GODAVARI COLLAGE WASHIM",
  "DEEPSTAMBH MAHAVIDYALAY SHEGAON",
  "VIDYAVARDHINI MANDAL ICE COLLEGE OF HOTEL MANAGEMENT",
  "Ashoka Education Foundations Ashoka Center for Business & Computer Studies,Chandasi, Tal. Dist.Nashik 422013",
  "250046-GRAMIN VIKAS SHIKSHAN PRASARAK MANDAL'S LATE M.D.SISODE ALIAS BHAUSAHEB ARTS, COMMERCE AND DR. SAU. USHATAI PRASADRAO TANPURE SCIENCE COLLEGE, NARDANA, TAL-SHINDKHEDA, DIST - DHULE",
  "COLLEGE OF AGRICULTURE, DIGAS OF INDRAYANI SHIKSHAN PRASARAK MANDAL, DIGAS, TAL KUDAL DIST SINDHUDURG",
  "MATOSHRI AYURVED COLLEGE DHANORE TAL YEOLA DIST NASHIK",
  "MGM S NANASAHEB KADAM COLLEGE OF AGRICULTURE, GANDHELI, AURANGABAD",
  "MGM College of Food Technology, CIDCO",
  "JAI JAGDAMBA COLLEGE  OF EDUCATION VIRAG 413 402 511 INDRA NAGER TAL BARSHI DISTT SOLAPUR",
  "DNYANODAYA EDUCATION TRUSTS, ORCHID DEGREE COLLEGE OF ARTS, SCIENCE AND COMMERCE",
  "AMBAMATA MAHILA MAHAVIDYALAY ARMORI TA ARMORI DIST GADCHIROLI",
  "DNYAN VIKAS SANSTHAS ADV P C PATIL LAW COLLEGE",
  "DIVINE COLLEGE OF ARTS, COMMECE AND SCIENCE SATANA CITY",
  "GODAVARI WOMENS COLLEGE WASHIM B SC HOME SCIENCE",
  "TRINITY COLLEGE OF ARTS COMMERCE AND SCIENCE",
  "D Y PATIL ACADEMIC EDUCATION EXCELLENCE FEDERATION,DR D Y PATIL TECHNICAL CAMPUS,VARALE,TALEGAON DABHADE,PUNE ",
  "R G COLLEGE OF FASHION DESIGN JANUNA TQ MAHAGAON DIST YAVATMAL",
  "MAHATMA PHULE VASTIGRUH M P COLLEGE PUNE",
  "M P COLLEGE OF CYBER AND DIGITAL SCIENCE  PUNE",
  "B K PATIL INSTITUTE OF PHARMACY , TALOJA",
  "ADIVASI SEVA SAMITI NASHIK SANCHLIT SAMJSHRI PRASHANTDADA HIRAY ARTS COMMERCE AND SCIENCE COLLEGE SURGANA DIST NASHIK",
  "Nagrik Shikshan Sanstha's College of Commerce and Economics, NSS Educational Complex, M. P. Mills Compound, Tardeo, Mumbai-400034",
  "Anusaya Shikshan Prasarak Mandals Swatantrya Sainik Suryabhanji Pawar College, Purna(Jn.)",
  "Vidya Bhavan College of Management & Research, Yavatmal",
  "SHRI, GAJANAN MAHARAJ MAHAVIDYALAY",
  "YASHODEEP COLLEGE OF PHARMACY SARALGAON",
  "SURYADATTA EDUCATION FOUNDATION SURYADATTA COLLEGE OF PHARMACY  HEALTHCARE AND RESEARCH BAVDHAN PUNE",
  "Subhadras Educational  Society's S.N.B.P.Law College, Sant Dnyaneshwar Nagar, Morwadi, Pimpri,Pune 18",
  "SHRI GURUDEV INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH ",
  "SYMBIOSIS Institute of Business Management, Nagpur",
  "Lok Mahavidyalaya Wardha",
  "Arts and Commerce College, Tumsar",
  "Education College, Arvi Road",
  "Rani Laxmibai women's Arts Commerce and Science College, Sawargaaon",
  "Agnihotri College of Law",
  "Mahalaxmi Jagdamba Kala, Vanijya va Vidnyan Mahavidyalaya, Koradi",
  "Adarsh Sanskar College of Education, Hasanbagh road",
  "Late Nirdhan Patil Vaghaye Arts Commerce and Science College, Salebhata",
  "Vilasrao Deshmukh College of Engineering and Technology, Mauda",
  "R.S. Mundle Dharampeth Arts and Commerce College, Nagpur",
  "Dr Babasaheb Ambedkar College of Law",
  "G H Raisoni College of Business Management, Khaperkheda, Nagpur",
  "Jailaxmi Arts Commerce and Science College, Karanja",
  "Tirpude Social Work College, Sadar",
  "Arts Commerce College, Kardi",
  "Smt Savitarani Narayandas Javandhia Arts Commerce College, Devli",
  "Bhartiya Shikshan Mahavidyalaya, Nagpur",
  "Renaissance College of Computer Science and Advanced Technology, Nagpur",
  "Madukarrao Pandav College of Engineering",
  "Modern College, Daulatwadi",
  "Smt. Rewaben Manoharbhai Patel Mahila Kala Mahavidyalaya, Bhandara",
  "Navpratibha Mahavidyalaya, Umred Road",
  "Sharirik Shikshan Mahavidyalaya",
  "Principal Arunrao Kalode College, Omkar Nagar, Ring road",
  "Central India College of Law, Godhani",
  "Bela College, Bela",
  "Umred Shikshan Mahavidyalaya, Umred, Nagpur",
  "Academy of Arts and Science Institution's Women's Arts College, Umred",
  "K.D. Pawar Shikshan Mahavidyalaya, Saoner, Nagpur",
  "MB Patel Arts Commerce Science College",
  "Sri Niketan Arts Commerce College, Tulsibag",
  "PMBS Arts Commerce and Computer Science College, Umred Road",
  "Dhananjayrao Gadgil Sahakari Prabandh Sansthan, New nandanvan",
  "Bajirao Karenjikar College of Pharmacy, Sakoli",
  "Real Institute of Management and Research Belatrodi road",
  "Svavlambi Education College",
  "Maharshi Sharad Pawar College of Arts Commerce and Science, Wardha Road",
  "C.P. &  Berar Education Society's College",
  "Late Gyaneshwar Meghde Education College, Kosra",
  "Dnyanbharati College, Deoli",
  "Motiraoji Shinde Arts and Commerce College, Madgaon",
  "SHRI LAXMANRAO MANKAR COLLEGE OF EDUCATION, AMGAON",
  "CENTRAL PROVINCE COLLEGE OF BUSINESS MANAGEMENT AND STUDIES",
  "Shri Binzani City College, Umred road",
  "Late Mansaramji Padole Arts College, Ganeshpur",
  "Jagat Arts Commerce Indraben hariharbhai Patel Science College, Goregaon",
  "Dr. L.D. Balkhande College of Arts and Commerce, Paoni Dist Bhandara",
  "Arts Commerce Science College, Borgaon",
  "Dr. Arun Motghare College of Home science, Lakhandoor",
  "Ranibai Agnihotri Institute of Computer Science and Information Technology",
  "Indira Gandhi Arts Commerce College, Kalmeshwar",
  "National College of Management, Jhingabai takli",
  "Manoharhai Patel Institute of Engineering and Technology, Shahapur",
  "Sri Santaji Arts and Science College, Palandur",
  "Dadasaheb Balpande College of Pharmacy, Besa road",
  "Indira Gandhi Physical Education College, Hanuman Nagar",
  "Dr. MKU Arts and Sri. RM Commerce College, Bhamti, Ring Road",
  "Geetacharya Tukaramdada Arts Commerce College, Lakandoor",
  "Priyadarshini Women's College",
  "Yashoda Girls Arts Commerce College, Somalwada",
  "Dr. Panjabrao Deshmukh Arts Commerce College, Cotton Market",
  "St. Francis De Sales College, Seminary Hills",
  "Late  Vasantrao Kolhatkar Arts College, Rohana",
  "Mehmuda Shikshan & Mahila Gramin Vikas Bahuddeshiya Sanstha's Central India College of Education, Nagpur",
  "Natwarlal Maniklal Dalaal Arts Commerce College",
  "Chintamani Physical Education, Selukate",
  "Elite college of Computer Application, Commerce and Management Studies, Saoner",
  "CHHOTABHAI JAVERBHAI PATEL ARTS & COMMERCE COLLEGE, TIRORA",
  "Ramkrishna Wagh College of Arts and Commerce, Koradi road",
  "Gulab Nabi Azad Physical Education College, Khapri",
  "Hajratbaba Tajuddin Arts Commerce College, New Subhedar Layout",
  "Devajibhau Budhe Memorial College of  Physical Education, Gondia",
  "Taywade College of Pharmacy, Koradi",
  "Jawaharlal Nehru Arts Commerce and Science College, Wadi",
  "Smt. Kishoritai Bhoyar Adhyapak Mahavidyalaya",
  "Ram Ganesh Gadkari Arts And Commerce College, Saoner",
  "Renuka  College, Manewada  Road Besa, Nagpur",
  "Guru Nanak Institute of Engineering and Technology, Dahegaon",
  "Randhirsingh Bhadoriya College, Umred",
  "Shankarlal Agarwal College of management Studies Bachelor's, Suryatola",
  "Wainganga College of  Physical Education, Sakoli",
  "Sri Govindrao Wanjari College of Engineering and Technology, Godhani",
  "Kumbhalkar College of Social Work, Wardha",
  "SB Jain Institute of Technology Management and Research, Yerla",
  "Jhulelal Institute of Technology, Lonara",
  "Jivan Vikas College of Education, Thungaondev",
  "Shyamkishore Pashine College of Arts, Commerce and Science, Dasgaon",
  "St. Vincent Palloti College of Engineering and Technology, Warha Road",
  "Late Nirdhanrao Patil Waghaye Adhyapak Mahavidyalaya Lakhani",
  "Rajabhau Jachak College of Education, Elakeli",
  "Shri Bhaiyaji Pandharipande National Institute of Social Work, Hanuman Nagar, Nagpur",
  "Suyash College of Education, Umred Road",
  "Antyoday Mahavidyalaya Devgram",
  "Pooja Physical Education College",
  "Bharat Sevak Siddarth Arts Commerce Science College, Kondha",
  "Mathuradas Mohta Science College, Nagpur",
  "Manoharbhai Patel College of Pharmacy, Kudwa",
  "Basant B Ed College, Ganesh Nagar",
  "Priyadarshini Institute of Architecture and Design Studies, Hingna Road",
  "Mahila Mahavidyalaya, 152, Nandanvan, Nagpur",
  "Mahatma Gandhi Arts Commerce College, Parseoni",
  "Bhalerao Science College Saoner",
  "Geeta Shikshan Mahavidyalaya, Nagpur",
  "Prajasattak B.Ed. College, Nagpur",
  "Nagpur Institute of Technology, Katol road",
  "Vidyaniketan College, Hinganghat",
  "VM Institute of Engineering and Technology, Dongargaon",
  "VMV Commerce JMT Arts JJP Science College, Wardhaman Nagar",
  "Tuli College of Hotel Management",
  "Yashwantrao Gudadhe Patil Memorial College of Arts ,Commerce and Science, Jaitala , Hingna Road, Nagpur",
  "Ideas Institute of Design Education and Architecture Studies",
  "Jyotiba Phule Education College, Pavan Bhoomi Layout",
  "Shree Pandharinath Arts & Commerce College, Narkhed.",
  "H (S) NCB'S Dr.L.H.Hiranandani College of Pharmacy Campus of CHM College Ulhasnagar Dist Thane",
  "Manisha Education Trust's Smt. Janakibai Rama Salvi College of Arts, Commerce & Science, Manisha Nagar, Kalwa (W), Thane-400605",
  "SAKESHWAR GRAMIN VIKAS SEVA SANSTHA SAKESHWAR COLLEGE OF PHARMACY",
  "SHREE GAJANAN MAHARAJ COLLEGE OF NURSING",
  "DR K D SHENDGE AYURVED COLLEGE, OMERGA, TAL OMERGA, DIST OSMANABAD, MAHARASHTRA",
  "MKD COLLEGE OF PHARMACY, VIRCHAK, TAL ,DIST NANDURBAR",
  "VARDHAMAN BSC NURSING COLLEGE ,KOLI , KARANJA LAD",
  "TRIDENT INSTITUTE OF NURSING CHANDUR RLY AMRAVATI",
  "RAMJI MAHAVIDYALAY SOYGAON",
  "RASHTRASANT BHAGWAN BABA MAHAVIDYALAY SIRSAM SHE",
  "CHETANA FOUNDATION CHETANA COLLEGE OF PHARMACY, SARDEWADI, INDAPUR",
  "KAI DIGAMBAR BHANUDASRAO LOLGE AYURVED COLLEGE, CHANAKWADI, PAITHAN, DIST CHHATRAPATI SAMBHAJINAGAR",
  "PRADIP PATIL AYURVEDIC MEDICAL COLLEGE, KHUTALWADI",
  "AIMS COLLEGE OF PHYSIOTHERAPY",
  "GURU GANGABHARATI MAHAVIDYALAY",
  "GURU GANGABHARATI MAHAVIDYALAY",
  "SANTOSHIMATA COLLEGE OF PHARMACY, PANHALSATHE",
  "S K COLLEGE, STATION ROAD, JALNA",
  "GURU GANESH MISHRI JAIN KALA AANI VIDNYAN VARISHTH MAHAVIDYALAY ALEGAON",
  "Krishna Institute of Pharmacy",
  "Krishna Institute of Allied Sciences",
  "The Bombay Flying Club's College of Aviation, N.S.Road No.6 (Next to Jamnabai Narsee School, Gate no.4) J.V.P.D. Scheme Vile Parle (W), Mumbai400 056",
  "Anjuman-I- Islam's, Akbar Peerbhoy College of Commerce & Economics, Maulana Shaukat Ali Road,Do Taaki, Mumbai- 400 008",
  "ICL's Motilal Jhunjhunwala College of Arts, Science and Commerce, Plot No. 53, Sector 9-A, Vashi, Navi Mumbai-400 703 ",
  "PRAKASHCHAND JAIN AYURVED COLLEGE",
  "Shriram Shikshan Sanstha's Mahila Education College",
  "ADARSH COLLEGE OF PHARMACY, VITA",
  "SAI PRATISHTHANS MARATHWADA COLLEGE OF INFORMATION TECHNOLOGY BEED",
  "Bharati Vidyapeeth Deemed to be University School of Physiotherapy Pune",
  "Bharati Vidyapeeth Deemed to be University Department of Management Studies Off-Campus",
  "DR NARAYANRAO CHATE COLLEGE OF PHARMACY",
  "Maharashtra Shikshan Vikas Mandal Sanchalit New Shikshanshastra Mahavidyalay Bhor Township Chunchale Shivar Nashik - 422010",
  "VARDHAMAN EDUCATION AND WELFARE SOCIETYS, AHINSA INSTITUTE OF PHARMACY, DONDAICHA",
  "Konkan Gyanpeeth College of Engineering Vengaon Road Dahivali Tal Karjat Dist Raigad  410 201",
  "TILAKNAGAR SHIKSHAN PRASARAK MANDALS TILAKNAGAR COLLEGE OF COMMERCE DOMBIVLI EAST",
  "COLLEGE OF NURSING, DR SHANKARRAO CHAVAN GOVERNMENT MEDICAL COLLEGE AND HOSPITAL, VISHNUPURI, NANDED",
  "KAI. AMDAR KAKASAHEB SALUNKHE PATIL ARTS AND SCIENCE COLLEGE ",
  "CHINTAMANI MAHAVIDYALAYA BALLARPUR",
  "D K AUTI COLLEGE OF PHARMACY, PARNER",
  "SHAKUNTALABAI MAHILA MAHAVIDYALAY",
  "VEWS S AHINSA INSTITUTE OF AYURVEDA DHULE ROAD DONDAICHA TAL SHINDKHEDA,DIST DHULE",
  "Yashoda Technical Campus, Satara",
  "SHURVIE MAHILA MAHAVIDYALAYA MUL",
  "Phaltan Education Society's College of Engineering, Survey No. 31, At Post. Thakurki,  Tal. Phaltan, Dist. Satara",
  "MAHATMA PHULE MAHILA MAHAVIDYALAY",
  "SUSHILA SURYAWANSHI MANAGEMNT INSTITUTE OF TECHNOLOGY ADVANCEMENT",
  "DR RAJENDRA GODE MEDICAL COLLEGE",
  "SAVITRIBAI PHULE MAHILA MAHAVIDYALAY",
  "NEW COLLEGE OF PHARMACY KOLHAPUR",
  "VISHALBHAU CHAUHAN MAHAVIDYALAY KINHIRAJA",
  "P JOG LAW COLLEGE PUNE",
  "ABHA GAIKWAD PATIL COLLEGE OF PHARMACY NAGPUR",
  "Mumbra Shikshan Prasarak Mandals G. R. Patil College of Arts, Science & Commerce, Dombivli (East), Dist. Thane - 421 204",
  "The Borivli Education Society's Matushri Pushpaben Vinubhai Valia College of Commerce, M. K. School Complex, Factory Lane, Borivali (W), Mumbai  400 092 ",
  "Janseva Shikshan Mandals Jayvantrao Pawar Arts Commerce & Science College  At Tokawads  Tal  Murbad  Dist  Thane  421 401",
  "Mahatma Education Societys Pillai HOC College of Arts, Science and Commerce",
  "Distinctive Education Societys Ramraje College of Hotel & Tourism Management . At Post Tal. Dapoli Dist. Ratnagiri",
  "Government College of Engineering, Railway Station Road, Aurangabad.",
  "Mahatma Phule Education Society College of Arts, Commerce & B.M.S, Jerbai Wadia Road,  Bhoiwada, Parel, Mumbai- 400 012.",
  "Pradnya Karuna Bahudeshiya Shiksan Sansthas Samayak Sanklpa College of Architecture Sai Ganesh Chhaya  2nd Floor Near Jarimari Temple Tisgaon Kalyan E Dist Thane.",
  "IBSAR College of Commerce & Science Dahivali Tal Karjat Dist Raigad",
  "Janseva Shikshan Mandals College of Education  Shivle Murbad Dist.  Thane",
  "Sophia College for Women",
  "The Achara Peoples Association, Achara  College of Management  Studies  Achara Tal Malvan  Dist  Sindhudurg",
  "Shaheed Dunichand Tejandas Kalani Memorial Trusts, College of Education, Site No. 57, A-Block Road, Near Shahad Railway Station (East), Ulhasnagar-421001",
  "Late Bhausaheb Hiray S S Trusts Institute of Computer Application Next to New English School Bandra (East) Mumbai  400 051",
  "Sahyadri Parisar Shikshan Prasarak Mandals  Shri Manohar Hari Khapane College of Arts & Commerce Pachal  Tal-Rajapur Dist Ratnagiri 416 704.",
  "Navjeevan Education Societys College of Education (B.Ed.) Malegaon Dahivali Tal Karjat",
  "Smt Chandibai Himathmal Mansukhani College, Opp Ulhasnagar Railway Station Ulhasnagar Dist Thane",
  "Saraswati Vidya Bhavans College of Pharmacy Sankara Nagar Shilpada Road  Sonarpada Dombivli (East) Dist Thane-421 201",
  "MAHATMA EDUCATION SOCIETY'S MAHATMA NIGHT DEGREE COLLEGE OF ARTS & COMMERCE CHEMBUR NAKA CHEMBUR  MUMBAI  400 071",
  "Shramik Kisan Seva Samittees Lok Nete Shamraoji Peje Mahavidyalaya at and post Shivar Ambere  Tal  & Dist  Ratnagiri",
  "Maharashtra Shaikhsanik and Arogya Vidyanagari K.G.S.B.Ed. College At Kambare Shahapur Dist Thane",
  "Sree Naryana Guru College of Commerce  P L Lokhande Marg  Chembur  Mumbai  400 089",
  "Navneet Education Societys Navneet College of Commerce & Science, Gilder Lane Mun. School Builg, Belasis Flyover, Opp. Railway Station, Mumbai Central, Mumbai- 400 008.",
  "R.P.Gogate College of Arts Science and R V Joglekar College of Commerce,  Ratnagiri, Dist Ratnagiri",
  "The Royal Higher Education Societys College of Arts  Science and Commerce  Ismail M Kanga Educational Campus  Shrishti Housing Complex  Kashimira  Mira Road  Near Dahisar Checknaka  Dist Thane",
  "LATE DR SACCHIDANAND MUNGANTIWAR NIGHT COLLEGE, WADGAON, CHANDRAPUR",
  "Apeejay Education Trust, Apeejay Institute Of Hospitality, Plot No 1, Sector-10, CBD Belapur, Navi-Mumbai - 400 614",
  "Haji Jamaluddin Thim Trust College of BHTM BM S and B Sc Computer Science  Saibaba Vihar Complex Thane West  400 601",
  "New Law College Senapati Bapat Marg Matunga Mumbai  400 016",
  " Uran Education Societys College of Management and Technology,  Palak Maidan, Bori, Near N.M.M.T. Stop, AT Uran, Dist. Raigad.",
  "Educational Uplift Society'S Husna Abdul Malik Madu Women College of Arts, Science & Commerce, Gafoor Don Chowk, Ghass Bazar,  Kalyan, Dist: Thane.- 421 301",
  "Lokmanya Tilak Jankalayn Shikshan Sansthas Lokmanya Tilak College of Engineering, Vikas Nagar Kopar Khairane Navi Mumbai",
  "Dr  Patangrao Kadam Arts and Commerce College  Pen Dist Raigad",
  "Rayat Shikshan Sansthas Karmaveer Bhaurao Patil College Vashi Navi Mumbai",
  "Hansraj Jivandas College of Education, Khar, Mumbai",
  "Konkan Education Societys  Dr Chintamanrao Deshmukh Commerce   Sau  KG  Tamhane Arts College  Roha Dist Raigad 402 109",
  "D.V.S. College of Commerce, Koparkhairne, Navi Mumbai 400 709",
  "Chikitsak Samuha's Sir Sitaram and Lady Shantabai Patkar College of Arts and Science and V.P. Varde College of Commerce and Economics, S.V. Road, Goregaon (West), Mumbai",
  "Wilson College  Chowpatty  Mumbai",
  "Dhirajlal Talakchand Sankalchand Shah College of Commerce Kurar Village  Malad East  Mumbai",
  "Shri Vile Parle Kelavani Mandals Dwarkadas J. Sanghvi College of Engineering  J V P D  Scheme Gulmohar Road Vile Parle (West) Mumbai",
  "Jitendra Chauhan College of Law Vile Parle (W) Mumbai 400 056",
  "Koti Vidya Charitable Trusts Alamuri Ratnamala Institute of Engineering & Technology At Post Sapgaon Tal Shahapur Dist Thane-421 601",
  "Parle Tilak Vidyalaya Associations Sathaye College Dixit Road  Vile Parle East Mumbai",
  "Nalanda Educational Foundations Dr Babasaheb Ambedkar College of Arts Science & Commerce Malekarwadi  P L Lokhande Marg Chembur Mumbai 400 089",
  "VPMs Ramniklal  Z Shah College of  Arts Science and Commerce Mithagar Road Mulund East Mumbai 400 081",
  "Jaihind Gramonnati Sansthas Jaihind College of Science at Post Salgaon Tal Kudal Dist Sindhudurga",
  "Chembur Colony Yuwak Mandals Hashu Advani College of Special Education 64-65 Collectors Colony Chembur Mumbai - 400 074",
  "Veer Wajekar Arts  Science and Commerce College  Mahalan Vibhag,Phunde  Uran Panvel Road Tal Uran Dist Raigad",
  "Bharati Vidyapeeths College of Architecture Sector 8 CBD Belapur Opp to Konkan Bhavan Navi Mumbai                  Mumbai 400 614",
  "Abhay Shikshan Kendras Krantijyoti Savitribai Phule College of Bachelor of Education Kannamwar Nagar No. 1 Vikroli (E) Mumbai 400 083",
  "Shikshan Vikas Mandals S H  Kelkar College of Arts  Science and Commerce  Devgad Dist Sindhudurg  416 613",
  "Bunts Sangha Mumbais Anna Leela  College of Commerce & Economics and Shobha Jayaram Shetty College for BMS Shashi Manmohan Shetty Higher Education Complex Opp Buntara Bhavana  Buntara Bhavan Marg  Kurla  East  Mumbai 400 070",
  "Shailendra Education Societys Arts, Science & Commerce College, Shailendra Nagar, Dahisar (E), Mumbai - 400 068",
  "Ramchandra Sanskritik Krida Mandal's C.P.College of Education, M.G.Road, Jalna.",
  "Shahu shikshan Sanstha's Pandharpur Sanstha's Matoshree Velbai Devaji Hariya College of Arts, Commerce & Science, Mohone Road, Shahad (West)-421103",
  "Vidya Prasarak Mandals Thane Municipal Council Law College Chendani Bunder Road Thane 400 601",
  "R.R. Educational Trusts College of Education (B.Ed.)  Mulund (E) Mumbai",
  "Oriental Education Societys Oriental College of Pharmacy, Plot No. 3, 4, 5, Sector - 2, Near Sanpada Railway Station, Sanpada, Navi Mumbai - 400 705",
  "Shri Tuljabhavani Temple Trust's Tuljabhavani College of Engineering, Tuljapur.",
  "Sai Shiv Education Trusts, Arun Muchhala International College of Hotel Management,  Sai Baba Vihar Complex, Ghodbunder Road, Thane (West) - 400 601",
  "Thakur Institute of Management Studies and Research",
  "Lokvikas Samajik Sanstha M M  Jagtap College of Art Science & Commerce  at Mahad  MIDC  KSF Colony No.2  Dist  Raigad",
  "Dnyan Prasarak Shikshan Sanstha, Indira Gandhi College of Arts & Commerce,  Park- Site, Vikhroli (West), Mumbai  400 079",
  "Bhavik Vidya Prasark Mandals Jai Bhavani College Near Vitva Octoo Naka Vitava Kalwa Dist Thane",
  "Haji Jamaluddin Thim TrustTheem College of Engineering  At Village Betegaon Boisar Chikhar Road (N.H.No.8) Near Union Park Boisar(E) Tal Palghar Dist. Thane 401 501",
  "Versova Education Trusts Smt Kamala Mehta V W A College of Commerce 7 Bunglows Versova Andheri W Mumbai  400 061",
  "ITM Trusts Institute of Hotel Management ITM Campus 25 & 26 Institutional Area Sector-4 Kharghar (E) Navi Mumbai  410 210",
  "Bunts Sanghas S M  Shetty College of Science Commerce and Management Studies At S M  Shetty High School and Jr College   Nr.Hiranandani Complex  Powai Mumbai",
  "Deep Education Societys A.G.S College of Education Boisar Amay Park Bldg.No.2 Navghar Road Dist. Thane  410 501",
  "Shri Sadguru Vamanbaba Maharaj Shikshan Prasarak Mandals Eknath B Madhavi Senior College of Arts Commerce and Science  Arye Dombivli E Dist  Thane 421 201",
  "SUDHAGAD EDUCATION SOCIETY'S SHIKSHAN MAHARSHI DADASAHEB LIMAYE ARTS, COMMERCE AND SCIENCE COLLEGE, Sector 3E CIDCO Colony Kalamboli, Navi Mumbai 410 218",
  "Jeevandeep Shaikshanik Sanstha's Poi's, Arts, Commerce & Science College At. Khardi (E) Tal -Shahapur Dist- Thane- 421601",
  "Dnyan Prasarak Shikshan Sanstha Rajiv Gandhi Night College of Arts And Commerce  Tagore Nagar  Vikroli E  Mumbai 400 083",
  "Dombivli Yuvak Education Trusts, Royal College of Science & Commerce, P & T Colony, Gandhinagar, Village-Nandivli, Dombivli (E), Dist. Thane - 421 201",
  "Katta Panchkroshi Shikshan Prasarak Mandass Dr  Waradkar College of Arts & Commerce  Katta Tal  Malvan  Dist Sindhudurg",
  "Rayat Shikshan Sansthas Loknete Ramsheth Thakur Arts Science and Commerce College Mokhada Taluka  Mokhada  Dist Palghar",
  "Gokhale Education Societys Dr T K Tope Arts and Commerce Night College  Co R M Bhatt High School Gokhale Society Lane Parel  Mumbai  400 012",
  "Samaj Hitakarni Sanstha  Utkarsha College of Arts & Commerce  at Vasind Tal Shahapur Dist Thane",
  "MAHATMA EDUCATION SOCIETY'S  PILLAI  COLLEGE OF  ARCHITECTURE, Composit College Complex, New Panvel, Navi Mumbai",
  "Dr.Babasaheb Ambedkar College of Arts  Sience and Commerce  Mahad Dist Raigad",
  "Manjara Charitable Trusts Smt. Sushiladevi Deshmukh College of Arts  Science and Commerce  Sector 4  Airoli  Navi Mumbai 400 708",
  "St Andrews College of Arts Science & Commerce St Domnic Road Bandra West  Mumbai  400 050",
  "BAL Bharatis Maghanmal J Pancholia College of  Commerce  S V Road  Kandivli  W  Mumbai  400 067",
  "A.D. College of Education, Khultabad.",
  "Aakash Educational Society  Aakash College of Commerce  at 404 to 407, 4th floor, Gundavali Municipal School Building, Next to Natraj Studio, Andheri (E), Mumbai - 400 069.",
  "Bhanudas Chavan Arts, Commerce & Science College, Partur",
  "Shri Ravishankar Vidyamandir, Omerga Sanchalit, Shri Computer Science College, Omerga.",
  "Shri B.S.P.M. Adhyapak Mahavidyalaya, Shepwali, Tq. Ambajogai, Dist. Beed",
  "Bramha Chaitanya Education Trust Radhai Mahavidyala, Cidco, Aurangabad.",
  "Dr. Rafiq Zakaria Center for Higher Learning and Advanced Research, Rauza Bagh, Aurangabad.",
  "Ashvaghosh Education & Vyayam Prasarak Mandal's College of Physical Education, Gymnasium Hall, N-1, Cidco, Aurangabad.",
  "J.K. Jadhav Arts, Commerce & Science College, Vaijapur.",
  "Kamdhenu Shikshan Sanstha Sanchalit, College of Education, Jatwada Road, Aurangabad.",
  "Pratishthan Arts, Commerce & Science College, Paithan.",
  "Rajarshi Shahu  Institute of Management, MIDC, Chikalthana, Aurangabad.",
  "Vivekanand Institute of Advanced Studies in Management Science & Communication, Samarth Nagar, Aurangabad.",
  "Adarsh Gramvikas Sevabhavi Swayansevi Sanstha. Adarsh Arts College, Rajur(Ganpati), Bhokardan.",
  "Late. Annasaheb Deshmukh Arts and Science College,Pimpalgaon  Renuka, Bhokardan.",
  "Rajkuwar College, Waghrul Jahangir, Taluka Jalna, Dist. Jalna",
  "Hindustani Education Society's Sharadchandra Mahavidyalaya, Shiradhon,Tq Kalamb Dist Osmanabad",
  "Nagar Shikshan Vikas Mandal's Madhavrao Patil Arts, Science  & Commerce College, Murum, Omerga.",
  "Navin Osmanabad Jilha Balvikas Samiti Sanchalit, Mahananda College of Education, Osmanabad.",
  "Prayag Samajonoti Mandal's, Advanced Computer College, Osmanabad.",
  "Rajiv Gandhi Vichardhara Pratishthan Sanchalit, College of Education, Chincholi, Bhoom.",
  "Ransamrat Krida Mandal's College of Physical Education, Kalamb.",
  "Shikshan Maharshi Dnyandeo Mohekar Mahavidyalaya, Kalamb, Dist. Osmanabad",
  "Shri Swami Vivekanand Shikshan Sanstha's, Law College, Osmanabad.",
  "Government Institute of Science, Nipat Niranjan Nagar, Caves Road, Aurangabad.",
  "Shiv Jyoti Shikshan Prasarak Mandal, Dyanjyoti College Bachelor of Education, Soyegaon",
  "Shri Balaji Shikshan Prasarak Mandal Sanchalit, College of Pharmacy, Ambajogai.",
  "Adarsh Computer Science and Management Science College, Jafrabad.",
  "S.B.E.S. College of Science, Saraswati Nagar, Aurangpura, Aurangabad.",
  "Shivam Mahila Shikshan Prasarak Mandal Parbhani College of Management Science,Kacheri.",
  "Sant Eshwarshing Arts, Commerce & Science College",
  "Vasantrao Naik Shikshan Prasarak Mandal's Vasantrao Naik Mahavidyalaya, Aurangabad",
  "Shri Yogeshwari Education Societys Yogeshwari Mahavidyalaya, Ambajogai",
  "Om Shanti Dnyan Mandir's College of Education, Ambad.",
  "Vasantdada Patil Arts, Commerce and Science College, Patoda, Dist. Beed.",
  "Shardchandraji Pawar College of Computer & Management B.C.A, Jafrabad.",
  "Swami Ramanand Teerth Mahavidyalaya, Ambajogai.",
  "College of Social Work , opp Dept. of Chemistry , Dr.Babasaheb Ambedkar Marathwada  University Aurangabad.",
  "D.S.R. College of Education (English Medium), Daultabad T-Point, Aurangabad.",
  "I.I.R.W's, International Centre of Excellence in Engineering and Management, Pune-Aurangabad Highway, Pandharpur, Aurangabad.",
  "Mahatma Phule College of Education, Peer Bazar, Osmanpura, Aurangabad.",
  "Marathwada Institute of Technology Engineering College, Satara Road, Aurangabad.",
  "M.S.P.Mandal Chhatrapati Shahu Arts, Commerce & Science College, Lasur Station, Gangapur.",
  "Padmshri Vasantdada Patil College of Computer Science, B.C.A. & B.Sc. I.T., JAlna Road, Aurangabad.",
  "Pragati Arts and Science College, Sillod.",
  "Rajiv Gandhi College of Computer Science, Padegaon, Aurangabad.",
  "National Arts & Science College, Fardapur, Soegaon.",
  "A.C.E. Foundation's Maharashtra Institute of Information Technology, Chhatrapati Sankul, Beed.",
  "Bharatiya Rashtriya Shikshan Sanstha's Shankarrao Jawale Patil, Arts, Science  & Commerce College, Lohara.",
  "Shivraj College, Partur, Tq. Partur, Dist. Jalna",
  "Marathwada Shikshan Prasarak Mandal's Swami Vivekanand Arts, Science & Commerce College, Parli Vaijanath.",
  "Dr. Babasaheb Ambedkar Smarak Samiti Aurangabad, Anand Institute of Management, Osmanpura, Aurangabad.",
  "Ekta Shikshan Prasarak Mandal's College of Arts, Bidkin, Paithan.",
  "Geetai Sevabhavi Charitable Trust's Geetai Institute of Management Bidkin, Tal. Paithan, Dist. Aurangabad",
  "Mahatma Gandhi College of Education, Aurangabad.",
  "Maratha Shikshan Sanstha's Late Pandharinath Patil Institute of Management Studies, Samarth Nagar, Aurangabad.",
  "Marathwada College of Education, Rozabagh, Aurangabad.",
  "Mohata Devi Shikshan Santha Aurangabad, Mohata Devi Computer Science College, Padegaon, Aurangabad.",
  "Rajiv Gandhi College of Arts, Commerce & Science, Karmad, Aurangabad.",
  "Shri Asaramji Bhandwaldar Arts, Science & Commerce College, Deogaon Rangari, Kannad.",
  "Shri Sai Institute of Management and Research, MIDC Chikalthana, Aurangabad.",
  "Devgiri Pratishthans Siddharth Library and Information Science College, Padegaon, Aurangabad Dist Aurangabad",
  "Tarai Arts and Science College, Paithan.",
  "Vijayendra Kabra College of Social Work, Aurangabad.",
  "Aditya Education Society Beed, Aditya College of Education, Beed.",
  "Mauli Vidyapeeth's Mahila Kala Mahavidyalaya, Mane Complex, Vidya Nagar, Beed.",
  "Pragati Shikshan Prasarak Mandal's Beed Arts,Commerce & Science College, Kusalamb, Patoda.",
  "Sahebrao Mhaske Patil Shikshan Prasarak Mandal's Chhatrapati, Shivaji College of Library and Information Science, Beed.",
  "Shri Chhatrapati Sevabhavi Sanstha Sanchalit, Twaritapuri Arts and Science College, Talwada, Tq. Georai, Dist. Beed.",
  "Bhausaheb Deshpande College of Biotechnology & Bioinformatics, Yogeshwari Nagar, Jalna.",
  "J.E.S.R.G.Bagadiaya Arts S.B. Lakhotiya Commerce & R. Bezonji Science College, Jalna.",
  "JIJAU ARTS & SCI COLLEGE WARUD BK, JAFRABAD.",
  "Matsyodari Shikshan Sanstha's Arts, Science & Commerce College, Ankush Nagar, Ambad.",
  "Adarsha Shikshan Prasarak Mandal's K.T.Patil College of Computer Science, Barshi Road, Osmanabad.",
  "Shri Chhatrapati Shivaji Arts & Science College, Kalamb.",
  "Terna Public Charitable Trust's Terna Arts, Science  & Commerce College, Osmanabad.",
  "Ramkrishna Paramhansa Mahavidyalaya, Osmanabad.",
  "Janta Shikshan Prasarak Mandal's College of Education, Khultabad.",
  "Vinayakrao Patil Shikshan Prasarak Mandal Aurangabad Sanchalit, Sant Tukaram Mahavidyalay, Kannad",
  "Rashtriya Shikshan Prasarak Mandal Beed's, Lokmanya Tilak Mahavidyalaya,Wadwani, Tq.Wadwani Dist.Beed",
  "Dental College and Hospital, Sangli",
  "SUNITATAI EKNATHRAO DHAKANE COLLEGE OF MANAGEMENT SHEVGAON",
  "SAHAKAR MAHARSHI SHANKARRAO MOHITE PATIL MAHAVIDYALAYA,  NATEPUTE -413 109 DIST-SOLAPUR",
  "THAKUR ARTS COMMERCE AND SCIENCE RATRKALIN COLLEGE VAGHAPUR ROAD YAVATMAL",
  "SANT BHAGWANBABA M ED COLLEGE, KAIJ",
  "COLLEGE OF AGRICULTURE,KHIRDI TAH KORPANA, DIST CHANDRAPUR",
  "Bhai Tukaram Kolekar College, Nesari, Tal. Gadhinglaj, Dist. Kolhapur",
  "Sahakar Maharshi Bhausaheb Santuji Thorat Arts, Science and Commerce College, Sangamner",
  "Varwand Gram Shikshan Sansthas Eknath Sitaram Divekar Arts, Science & Commerce  Mahavidyalaya,Varwand, Tal.Daund,Dist.Pune",
  "Jagdamba Education Societys S.N.D.College of Education, Babhulgaon Tal. Yeola, Dist. Nashik 423401",
  "Nutan Maharashtra Vidya Prasarak Mandal's Nutan Maharashtra Institute of Engineering and Technology, Talegoan Station Tal Maval Dist Pune",
  "Shri. Dr. R. G. Rathod Arts & Science College, Murtizapur, Dist. Akola",
  "Pravara Rural Education Societys Pravara Rural Engineering College, Loni Bk., Tal. Rahata, Dist.Ahmednagar  413736",
  "Gokhale Education Society's, B.Y.K. (Sinnar) College of Commerce, Prin. T. A. Kulkarni Vidya Nagar, Tal. - Nashik, Dist. - Nashik 422005",
  "Godavari Shikshan Mandals G.D.Sawant Arts,Commerce & Science College, Suchetanagar, Mumbai Agra Road, Nashik 422010",
  "Forum for Culture Studies Institute of Advanced Studies in English,Pune",
  "Ozar Vikas Sansthas Vishwasattya B.Ed. College, Tambat Lane, Ozar Mig, Tal.Niphad, Dist.Nashik  422206",
  "Vidya Pratishthans Institute of Information Technology, Vidyanagari, Bhigwan Road, Baramati, Dist. Pune 413133",
  "Abhinav Education Societys Institute of Management & Research, Narhe Ambegaon, Tal. Haveli, Dist.Pune",
  "Shikshan Prasarak Mandalis Sir Parshurambhau College Arts, Science & Commerce Tilak Road Pune 30",
  "Maharashtra Cosmopolitan Education Societys Allana Institute of Management Science, Camp, Pune 411001",
  "Baburaoji Gholap Multipurpose Institute, Sangvi, Pune 411027",
  "Progressive Educational Societys Modern Law College, Ganeshkhind, Pune  53",
  "Samarth Dnyanpeeths Sahyadri Shikshanshastra Mahavidyalaya, Someshwarnagar, Tal. Baramati, Dist. Pune 412306",
  "Rayat Shikshan Sanstha's S. M. Joshi College Hadapsar, Pune.",
  "Maratha Vidya Prasarak Samajs Arts & Commerce College, Vadner Bhairav, Tal. Chandwad, Dist. Nashik",
  "The New Education Institute, Nashik's Late Sau. Ratnaprabha Prabhakar Vaishampayan Arts, Commerce & Science Night College, Opp. Nashik District Court, Nashik 422002",
  "Genba Sopanrao Moze Trusts, Parvatibai Genba Moze College of Engineering,Pune",
  "DES Shri. Navalmal Firodia Law College, Fergusson College Campus, Pune 411004.",
  "Shri Neminath Jain Brahmacharyashramas College of Engineering, Neminagar, Chandwad, Dist.Nashik 423101",
  "Bansilal Ramnath Agarwal Charitable Trusts Vishwakarma College of Arts, Science and Commerce College,Pune",
  "Bahooddesheey Samajik Gramin & Shikshanik Sanstha Sanchlit Shikshanshashra Mahavidyalaya, Abhone, Tal. Kalwan, Dist. Nashik",
  "Netaji Shikshan Sanstha's Subhash Baburao Kul Arts, Commerce and Science College, Kelgaon, Tal Daund, Dist Pune",
  "Sir Choturam College of Agricultural Engineering and Technology, Lodge",
  "Maharashtra Academy of Engineering and Educational Research's, Saint Dnyaneshwar B.Ed. College, Dehuphata, Alandi (Devachi), Tal. Khed, Dist. Pune 412105",
  "KTSP Mandal's Hutatma Rajguru Mahavidyalaya, Rajgurunagar, Pune 410505",
  "Institute of Science Poona's College of Computer Science, Wakad, Pune 411057.",
  "Kasturi Education Sanstha's Arts, Commerce & Science College, Post-Shikrapur, Tal.Shirur, Dist  Pune - 412208",
  "Sinhgad Technical Education Societys Smt.Kashibai Navale College of Commerce, Erandwana,Pune 4",
  "Maharashtra Cosmopolitan Education Society's Allana College of Pharmacy, Camp Pune",
  "Dr. D.Y. Patil Pratishthan's Padmashree Dr. D.Y. Patil College of Architecture, Sector 29, Nigdi Pradhikaran, Akurdi, Pune - 411044",
  "Genaba Sopanrao Moze Trusts College of Engineering,Pune",
  "Pune Vidyarthi Gruh's, Shriram Sadashiv Dhamankar College of Commerce & Science",
  "Anjuman Khairul Islams Poona College of Arts, Science & Commerce, Pune",
  "MVP Samaj's Karmaveer Abasaheb aliase N.M.Sonawane Arts,Commerce & Science College, Satana, Tal. Baglan, District Nashik ",
  "Kalyani Charitable Trusts Ravindra Gambhirrao Sapkal Pharmacy College, Sapkal PharmacyCollege, Ajneri, Wadholi, Tryambak, Dist.Nashik",
  "Maratha Vidya Prasarak Samajs Arts & Commerce College, Satpur, Tal. & Dist. Nashik 422007",
  "Marathwada Mitra Mandal's College of Commerce, Pune 4",
  "SHRI BHAIRAVNATH SHIKSHAN PRASARAK MANDALS SHRI BHIMASHANKAR B.ED. COLLEGE, A/P LANDEWADI, CHINCHODI, TAL. AMBEGAON, DIST. PUNE, 410503",
  "Waghire College of Arts, Commerce and Science, Saswad, Dist-Pune- 412301 ",
  "Tuljaram Chaturchand College, Baramati, Dist.Pune 413102",
  "International Institute of Information Technology, Pune Infotech Park, Hinjawadi, Pune  411057",
  "Maharashtra Cosmopolitan Education Society's H.G.M. Azam College of Education, Camp Pune",
  "Dnyan Kala,Kreeda and Krishi Pratisthans Maharashtra Institute of Management, Kalamb Walchandnagar, Tal.Indapur, Dist. Pune",
  "Ahmednagar Jilha Maratha Vidya Prasarak Samajs Institute of Hotel Management and Catering  Technology, Ahmednagar 414001",
  "Pimpri Chinchwad Education Trust's Pimpri Chinchwad College of Engineering, Nigdi, Pune 411044.",
  "Maharshi Karve Stree Shikshan Sanstha's Shri Siddhivinayak Mahila Mahavidyalaya,Karvenagar, Pune 411052",
  "Gokhale Education Society's R. H. Sapat College of Engineering, Management Studies and Research",
  "Maratha Vidya Prasarak Samaj's Arts, Science & Commerce College, Ozar (MIG), Tal. Niphad, Dist. Nashik 422206",
  "Maratha Vidya Prasarak Samaj's College of Pharmacy, M.V.P.Campus, Gangapur Road, Nashik 422002",
  "Shri Someshwar Shikshan Prasarak Mandals Someshwar Vidnyan Mahavidyalaya,Someshwar, Tal.Baramati, Dist.Pune",
  "San Mahu Education & Research Society's  Ambrosia Institute of Hotel Management, 38/2 Bawdhan Khurd, Tal. Mulashi, Dist. Pune-411021 ",
  "Nashik Gramin Shikshan Prasarak Mandals Brahma Valley College of Engineering & Research Institute,BrahmaValley Education Campus, Anjneri Gaon, Tal.Trymbakeshwar, Dist.Nashik",
  "Shan Education Societys Guardian College of Education, NIBM, Kondhawa Khurd, Pune 48",
  "Matoshri Education Society's Matoshri College of Engineering & Research Centre, At-Po.Eklahare, Tal. & District- Nashik 422105.",
  "Suryadatta College of Hospitality Management & Travel Tourism (SCHMTT), Bavdhan,Pune-21",
  "Zeal Education Society's Zeal College of Engineering & Research,Narhe, Taluka - Haveli, District - Pune 411041",
  "Amrutvahini Sheti and Shikshan Vikas Sanstha's Amrutvahini College of Pharmacy, Amrutnagar",
  "KAMALA EDUCATION SOCIETY'S  PRATIBHA COLLEGE OF EDUCATION",
  "The Poona Diocesan Educational Society's Vidya Bhavan College of Commerce, Bhairoba Nala, Pune 13",
  "Rayat Shikshan Sanstha's Mahatma Phule Mahavidyalaya, Pimpri, Pune",
  "Kalyani Charitable Trusts K.R.Sapkal College of Management Studies, Kalyani Hills, Anjaneri,Tryambakeshwar Road, Nashik",
  "Maharshi Karve Stree Shikshan Sansthas Smt. Hiraben Nanavati Institute of Management and Research for Women, Karvenagar, Cummins College Campus, Pune 411052",
  "Mahatma Phule Nutan Mahavidyalaya Arts Mirajgaon Tal Karjat Dist Ahmednagar",
  "Shikshan Maharshi Dr. D. Y. Patil Shikshan Sanstha's, Dr. D. Y. Patil Centre for Management & Research, Gat. No. 1029,1030, Newale Vasti, Chikhali, Pimpri Chinchwad, Pune",
  "K.J's Educational Institutes K.J.College of Engineering and Management Research Village Pisoli, Pune 48",
  "Bhagwan Mahavir Education Societys Preetam Prakash College,Pune",
  "Mahatama Gandhi Vidyamandirs Arts,Science & Commerce College, Manmad, Dist.Nashik 423401",
  "Sahyadri Shikshan Mandals Mahant Jamanadas Maharaj Arts, Commerce  & Science College, Karnjali, Tal. Peth, Dist.Nashik",
  "Pravara Gramin Shikshan Sansthas  Pravara Rural College of Architecture,Loni Pravaranagar Tal. Rahata,Dist. 413736",
  "Janata Seva Mandal Nashik Modern College,Samarthnagar,Peth Road, Panchavati, Nashik 422003",
  "Sri Balaji Society's, Balaji Law College, Sr, No. 3/1+4, Aundh Ravet Road, Tathawade, Tal- Mulashi, Dist- Pune 411033",
  "SINHGAD TECHNICAL EDUCATION SOCIETY'S SINHGAD COLLEGE OF COMMERCE ",
  "Ashok Gramin Shikshan Sansthas Arts, Commerce & Science College, Ashoknagar, Tal. Shrirampur,Dist.Ahmednagar",
  "Gokhale Education Society's  H.A.L. College of Science and Commerce, Ozar Township, Tal. Niphad, Dist. Nashik 422207",
  "Sinhgad Technical Education Societys Sinhgad Academy of Engineering,Kondhawa bk., Dist.Pune 48",
  "Shri Brahmanand Swami Shikshan Prasarak Mandals Arts & Commerce College, Dodi Budruk Tal.Sinnar, Dist.Nashik",
  "Dr.  D. Y. Patil Unitech Society's  Dr. D. Y. Patil Institute of Management and  Research",
  "Motiwala Education & Welfare Trusts Motiwala College of Educational Sciences, Motiwala Nagar, Gangapur Satpur Link Road, Nashik 422222",
  "Marathwada Mitra Mandal's College of Architecture Pune 4",
  "Vidya Prasarini Sabhas Arts, Science & Commerce College, Lonavala, Tal. Maval,Dist.Pune",
  "Sinhgad Technical Education Society's Sinhgad Institute of Business Administration and Research, Kondhwa Bk., Pune 411048",
  "Institute of Science, Poona's Institute of Business Management and Research, Mumbai Banglore Highway, Wakad, Pune 411057",
  "Suryadatta Education Foundations Suryadatta College of Management and Information Research, Vijaynagar Colony, Sadashiv Peth, Pune 411030",
  "Chaudhari Attarsingh Yadav Memorial Education Trust's Siddhant College of Pharmacy,Pune",
  "Kasturi Education Sanstha's College of Education, Shikrapur, Tal.Shirur, Dist Pune",
  "Progressive Education Societys Modern College of Arts, Science and Commerce, Shivajinagar, Pune 411005",
  "PRUTHVIRAJ DESHMUKH COLLEGE OF PHYSIOTHERAPY YAVATMAL",
  "S R B MAHAVIDYALAYA KESHORI",
  "ST ROCKS DEGREE COLLEGE OF LAW",
  "VILASRAO SHINDE MAHAVIDYALAYA ARTS COMMERCE AND SCIENCE ASHTA TAL WALWA DIST SANGLI",
  "DR ASHISH MOHARKAR ARTS,COMMERCE AND SCIENCE COLLEGE BHISI TAHSIL CHIMUR DISTRICT CHANDRAPUR",
  "Shikshan Maharshi Dr. D.Y.Patil Shikshan Sansthas Dr. D.Y.Patil College of Computer & Business Studies, Pune",
  "MEHERBABA MAHAVIDYALAYA",
  "'Mahatma Gandhi Shikshan Mandalache Dadasaheb Dr. Suresh G. Patil College, Chopda'",
  "DR.TANAJIRAO CHORGE SENIOR  ARTS AND COMMERCE COLLEGE MANDAKI,PALVAN,TAL-CHIPLUN,DIST-RATNAGIRI -415641",
  "Smt.Kamladevi Gauridatta  Mittal College of  Arts and Commerce  Marwari Vidyalaya, Bhandarwada  Gaothan Road  Rajanpada  Malad West  Mumbai  400 064",
  "Appaswami Mahavidyalaya, Shendurajna (Adhav) Tq. Manora.",
  "Matoshri Nanibai Gharpalkar Vidhnyan Mahavidyalaya, Babhulgaon.",
  "Vinayak Vidnyan Mahavidyalaya , Nabdgaon Kh.",
  "Yashawantrao Chauhan Shikshan (B.Ed) Mahavidyalaya, Near State Bank, Mangarulpir",
  "Vinayak Vidya Mandir, Sidhhi Vinayak Colony, Saturna Road, Amravati.",
  "Dr Rajendra Gode College of Pharmacy, Malkapur",
  "Shri. Dnyaneshwar Maskuji Burungale Science and Arts College, Shegaon Dist-Buldhana",
  "Akola Law College, Akola",
  "Smt. Kesharbai Lahoti Mahavidyalaya,Morshi Road,Amravati",
  "Shivshakti Arts, Commerce College, Babhulgaon.",
  "Y.D.V.D. Arts ,Commerce College Teosa .",
  "Sau.Vaidhe Vishnu Saraf Mahavidyalaya, 3rd Fiore, Harsh Maharashtrz Sankul, Civil Line, Akola.",
  "Smt. Surajdevi Ramchandra Mohata Mahila Mahavidyalaya, Khamgaon.",
  "Late Narmadabai Bodkhe Adhyapak Mahavidyalaya, Telhara, Dist. Akola",
  "Bhausaheb Lahane Dnyanprakash Arts College, Pinjar, Tq. Barshitakali.",
  "Sanmati College of Engineering, Sawargaon Barade, Washim",
  "Science & Home Science College,Chandur Bazar",
  "Dr. H.N. Sinha Arts & Commerce College , Patur",
  "Kesharbai Shikshanshastra Mahavidyalaya, Achalpur. Distt:- Amravati",
  "Shahu Maharaj Education College, Buldhana",
  "Smt. Maherbanu College of Science & Commerce, Akola.",
  "Shri. Dhabekar Kala Mahavidyalaya , Khadki,  Akola",
  "Phulsingh Naik Mahavidyalaya, Pusad.",
  "K.M. Asgar Hussain Education College, Akola",
  "Smt. Panchafuladevi Patil Social Work College, Khadki (Burj.), Tq. Akola.",
  "Narayanrao Nagare Arts College, Dusarbeed,Tq. Sindkhed raja",
  "Jagadamba College of Engineering & Technology, Arni road, Yavatmal.",
  "Noorjaha Begam Salam Ahmad Arts & Commerce College, Wani.",
  "Shankarlal Khandelwal Arts, Science and Commerce College, Akola.",
  "Padmashri Dr.V.B.Kolte College of Engineering, Malkapur",
  "Late Govindrao Patil Education College, Darwha.",
  "Shri Gadge Maharaj Mahavidyalaya, Murtijapur.",
  "Dr. Shyamprasad Mukharji Kala Mahavidyalaya , Shendurjana Ghat , Tq- Warud",
  "Shivramji Hiwase Adhayapak Mahavidyalaya, Warud, Di stt:-Amravati",
  "Satyajit College of Science Mehakar,",
  "Smt. Panchfuladevi Patil Arts, Commerce & Science College, Khadki (Bu.), Akola.",
  "Shri Vyankatesh Arts, Commerce & Science College, Deulgaon Raja, Dist. Buldhana",
  "Kadriya College of Education, Buldhana",
  "Jijamata Mahavidyalaya, Buldhana",
  "Late Bapuraoji Wankar Arts 6'z, Commerce College, Khairi, Tq.Ralegaon",
  "Wahed Khan Shikshan Mahavidyalaya , Near Parfect Darma Kata, Walgaon Rd., Amravati",
  "Bhausaheb Janolkar Vidyan Mahavidyalaya, Akola",
  "Babasaheb Deshmukh Parwekar Mahavidyalaya, Parwa, Tq.Ghatanji.",
  "Mahatma Gandhi Adhyapak Mahavidyalaya, Vanketesh Nager, Buldhana.",
  "Dr.Babasaheb Ambedkar mahavidyalaya , Amravati.",
  "Shri Pundalik Maharaj College, Nandura Rly.",
  "Government College of Education, Yavatmal",
  "Dr. Gopalrao Khedkar Mahavidyalaya , Gadegaon Telhara.",
  "Shivramji Moghe Science, Arts and Commerce College, Kclapur, Tq. Pandarkavada.",
  "Shri Sharadchandraji Pawar Kala, Vanijaya & Vidyan Mahavidyalaya, Dongaon, Tq. Mehkar.",
  "Sant Bhagwanbaba Kala Mahavidyalaya , Sindkhed raja,",
  "Dwarka College of Education, Buldana",
  "RAJARSHEE SHAHU SCIENCE COLLEGE, CHANDUR RAILWAY DIST AMRAVATI",
  "Noorjahan Begam Salam Ahmad Woman's College of Law, Buranda, Tq. Maregaon,",
  "Savitribai Phule Women College, Washim.",
  "Milind Mahavidyalaya, Mulava, Tq. Umarkhed",
  "Smt.Tulshibai Rangalalji Zambad Sinior College,Anand Maharashtra Buldana Nagar, Nandura, Buldhana",
  "Shri Brijlal Biyani Science College , Near Dashara Ground, Durga Vihar, Amravati.",
  "Smt. Radhabai Sarada Arts , Commerce College , Anjangaon Surji.",
  "Model Degree College of Arts, Science & Commerce, Buldhana",
  "Shradchandrajee Pawar College of Horticulture",
  "MES Ayurved Mahavidyalaya Ghanekhunt-Lote, Tal. Khed, Dist. Ratnagiri  ",
  "Indira Institute of Management Sciences, Vishnupuri, Nanded",
  "Vasantdada Patil Dental College, Tal. Miraj, Sangli",
  "Shri Dhaneshwari Manav Vikas Mandal's",
  "Jijamata Mahila College of Education",
  "Smt. Geeta Bankar Women's College of Education",
  "Swayam Siddhi Mitra Sangh's College of Education",
  "Indian Institute of Food Science & Technology",
  "Shri Swami Smarth Women's College of Education",
  "Shri. Tuljabhavani Bahuuddeshiya Samajseva Sansthas, College of Education for Women, Kurduwadi",
  "Regal College of Computer Application",
  "Sadabai Raisoni Women's College",
  "Mohammmad Ali Johar Women's College of Education",
  "Shahu Shikshan Sanstha Pandharpur's Rajmata Women's College of Education",
  "Queens College of Education for Women,",
  "Karmaveer Shikshan Prasarak Mandal's College of Education for Women",
  "Shri Swami Samarth Computer Science Ladies B.C.A. College",
  "Devmorgramata Mata Art's & B.C.A. College for Women",
  "Bhagwan Shikshan Prasarak Mandal's",
  "Aishabai College of Education",
  "Leelabai Thackersey College of Nursing",
  "Matoshri Girijabai Dhobale Women's College of Education",
  "Rural Foundation's Shikshanshastra Mahil Mahavidyalaya",
  "Matoshri Asarabai Darade Women's College of Education",
  "Anjuman-I-Islam's, Begum Jamila Haji Abdul Haq College of Home Science",
  "Tuljabhavani Seva Pratisthan's Women's College of Education",
  "Late. Kalpana Chawla Mahila Senior College of Arts & Science",
  "Dr. Bhanuben Mahendra Nanavati College of Home Science",
  "Navalbhau Pratishthan's Rukmanitai Arts & Commerce Mahila College",
  "SHPT School of Library Science",
  "C.U.Shah College of Pharmacy",
  "Smt. Kamlaben Gambhirchand Shah Law School",
  "Distinctive Education Soceity's",
  "Centre for Education, Tehnology and Health Sawantwadi Women's College of Computer Studies and Research",
  "Regal College of Technology, 9B.C.A.)",
  "Adarsh Shikshan Sanstha's Late Chhabhutai Dahake College of Education",
  "Usha Mittal Institute of Technology for Women",
  "180037-RPSPM'S SHRI VITTHALRAO SHANKARRAO NAIK ARTS,COMMERCE & SCIENCE COLLEGE, RAVER.",
  "200088-SYSTEL TECHNICAL EDUCATION SOCIETYS SYSTEL INSTITUTE OF MANAGEMENT & RESEARCH, DEOPUR,DHULE.",
  "100061-SE&CM'S SHRI GULABRAO DEOKAR COLLEGE OF ENGINEERING, JALGAON.",
  "220105-JIJAMATA EDUCATION SOCIETY'S COLLEGE OF EDUCATION, NANDURBAR",
  "240051-R.C.PATEL E.T.'S ARTS & SCIENCE COLLEGE, SHIRPUR.",
  "Ajara Mahavidyalaya,     AJARA",
  "Aravind Gavali College of Pharmacy,",
  "Arts and Commerce College,  KADEPUR",
  "Appasaheb Birnale College of Education,",
  "Appasaheb Birnale  College of Architecture,Sangli Miraj Road,",
  "Dr. Annasaheb Shinde College of Agriculture Eng., Rahuri",
  "Medical College, Pune",
  "Adarsh  College,  VITA",
  "Marathwada Mitra Mandal's College of Engineering Pune 52",
  "Art Development Academys Minerva College of Architecture, S.No. 512, Ambi, Talegaon MIDC Road, Talegaon Dabhade, Pune 410507.",
  "Datta Kala Group of Institutions Faculty of Engineering, Gat No. 541-2, Pune - Solapur Highway, A-p. Swami Chincholi, Taluka Daund, District Pune",
  "Sinhgad Technical Education Society's S.K.N. Sinhgad School of Business Management, S.No. 10-1, Ambegaon Bk., Tal. Haveli, Dist. Pune 411041.",
  "Swami Vivekanand Mahavidyalaya, Shirur Tajband, Tq. Ahemadpur",
  "Anjuman E Islam Education Societys Anjuman Islam Janjira Degree College  Lokmanya Tilak Road At Post Tal Murud Janjira Dist  Raigad 402 401",
  "110013-SHRI SARASWATI VIDYA PRASARAK MANDAL'S SMT.P.K.KOTECHA MAHILA MAHAVIDYALAYA, BHUSAWAL. DIST JALGAON",
  "Tilak Education Societys, Tilak College of Science and Commerce, Plot No.131, Sector-28, Vashi, Navi Mumbai- 400 703",
  "Tatyasaheb Kore College of Pharmacy, Warananagar.",
  "People's Education Society's, Dr. Ambedkar College of Law, Opp. Wadala, B.E.S.T. Depot, Tilak Road Extension, Wadala, Mumbai-400031",
  "SHIVAI PRABHODHINI SANSTHA AMDAR DAULAT DARODA SCIENCE MAHAVIDLAYA, THANE",
  " Vishnu Waman Thakur Charitable Trusts Bhaskar Waman Thakur College of Science Yashvant Keshav Patil College of Commerce Vidhya Dayanand Patil College of Arts, VIVA College, VIVA College Road Virar West Pin 401 303",
  "Swargiya Dadasaheb Kalmegh Smruti Dental College and Hospital, Hingna",
  "Adarsh Shikshan Prasarak Mandals K.T. Patil College of Pharmacy, Osmanabad",
  "College of Agricultural, Saralgaon",
  "College of Agriculture, Dapoli",
  "College of Agriculture, Sangulwadi",
  "Sahkar Maharshi Late Bhaskarrao Shingane  Arts College, Khamgaon",
  "Sri Sai Education College, Chandrapur",
  "Mahatma Gandhi Mission's Medical College,Navi Mumbai",
  "Rajasthan Arya Arts, Shri Mithulalji Kacholiya Commerce and Shri Satyanarayanji Ramkrushnaji Rathi Science College, Washim.",
  "CHINTAMANI COLLEGE OF ARTS AND SCIENCE, GONDPIPRI DIST. CHANDRAPUR",
  "Govindrao Wajurkar Arts Commerce College, Nagbhid",
  "Govt Engineering College, Ballarpur road",
  "Govt Science College",
  "DALIT MITRA KADAM GURUJI  VIDNYAN MAHAVIDYALY  MANGALWEDHA",
  "Gurukul Arts Commerce Science College, Nanda",
  "Prof Jogendra Kawade College of Arts and Commerce, Vairagad",
  "Pratibha Arts Commerce Science, Mool",
  "Raje Dharamrao Arts Commerce College, Mulchera",
  "Raje Dharmarao Arts and Commerce College, Allapalli",
  "Sharadchandra Pawar Kala Mahila Mahavidyalaya, Charmoshi",
  "Sharadrao Pawar Arts and Commerce College, Gadchandur",
  "Smt Sindutai Poreddiwar Arts Commerce Science College, Gogaon",
  "Sri Chintamani Arts Commerce College, Ghuggus",
  "Sri Govind Prabhu Arts Commerce College, Balapur",
  "Shri Jivanrao Sitaram Patil Munghate Arts, Commerce and Science College, Dhanora",
  "Shri Kisanrao Khobragade Shikshan Mahavidyalaya, Armori",
  "Sri Late Jageshwar Sawkar Ganyarpawar Arts Science Ghot",
  "Sri Namdeo Wadettiwar College, Sindewahi",
  "Shri. Dnyanesh College, Navargaon",
  "SIDDHARTH MAHAVIDYALAYA CHICHPALLI",
  "SWA. LAXMIBAI ARTS, SCIENCE AND COMMERCE WOMEN'S COLLEGE ALLAPALLI",
  "Smt. P.N. Doshi Women's College of Arts, Kum. U.R. Shah Women's College of Commerce & Dr. Smt. Nanavati Bhanuben  Mahendra Women's College of Home Science",
  "Dr. Ambedkar College of Arts, Commerce and Science, Chandrapur",
  "Chintamani College of Commerce, Pombhurna",
  "Chintamani Mahavidyalaya, Pombhurna",
  "Gramgeeta Mahavidyalaya, Chimur",
  "Sant Dnyaneshwar Shikshan Sansthas Hon. Shri. Annasaheb Dange Arts, Commerce and Science College, Hatkanangale ",
  "S.N.D.T. College of Home Science",
  "Janardan Bhagat Shikshan Prasarak Sansthas Changu Kana Thakur Arts Commerce and Science College",
  "100001-KCES'S MOOLJEE JAITHA COLLEGE, JALGAON.",
  "Dayanand College of Law, Latur",
  "LAT MORESHWARJI FAYE SCIENCE COLLEGE KHURANA",
  "SHAHID BIRSAMUNDA ARTS AND SCIENCE COLLEGE LAGAM",
  "Fule Ambedkar College of Social work, Gadchiroli",
  "Rajiv Gandhi Arts College, Patan",
  "Rajiv Gandhi Arts College, Shankarpur",
  "Rajiv Gandhi Arts Commerce Science College, Desaiganj",
  "Rajiv Gandhi Arts Commerce Science College, Mulroad",
  "Rajiv Gandhi College of Bachelor in Education, Ashti",
  "Rajmal Puglia Institute of Management and Technology",
  "Sarvodaya Mahavidyalaya, Sindewahi",
  "Ramchandrarao Thote Arts Commerce Science College, Rajura",
  "Rashtrapita Mahatma Gandhi Asrts, Commerce and Science College, Saoli",
  "Rashtrasant Tukdoji College, Chimur",
  "Rashtrpita Mahatma Gandhi Arts Science College, Nagbhid",
  "Renaissance Institute of Management Studies, New Chandrapur",
  "Sarvodaya shikshan Mandal's Sardar Patel Mahavidyalaya, Chandrapur",
  "Samrat Sevakbhau Patil Waghaye Arts Commerce Science College, Armori",
  "Vanshree Arts and Science College, Korchi",
  "Janata Shikshan Mandal's, Smt. Indirabai G. Kulkarni Arts College, J. B. Sawant Science College and Sau. Janakibai Dhondo Kunte Commerce College, Alibag, Dist.-Raigad - 402 201",
  "Dadasaheb Jotiram Godse Arts Commerce Science College, Vaduj Tal - Khatav, Dist - Satara",
  "H R College of Commerce & Economics 123  Dinshaw Wachha Road  Churchgate  Mumbai  400 020",
  "Adv Vitthalrao Banpurkar Arts Commerce College, Malewada",
  "Shri Sai College of Engineering and Technology Bhadrawati",
  "National Kannada Education Society's N K E S College of Arts Commerce and Science",
  "BOMBAY NATURAL HISTORY SOCIETY",
  "Nagpur Sharirik Shikshan Mahavidyalaya, Nagpur",
  "K.K.Wagh Education Societys K.K.Wagh Arts,Commerce,Science & Computer Science College, Kakasahebnagar, Tal.Niphad, Dist.Nashik 422308",
  "Dayanand Education Society's Dayanand College of Pharmacy, Latur",
  "Dr. D. Y. Patil Educational Enterprises Charitable Trust`s  Ajeenkya DY Patil School of Engineering, PUNE",
  "MAULI PRASHASKIY SEVA VARISHTHA MAHAVIDYALAY, ROHANWADI DIST JALNA",
  "Savitribai Phule Mahila  adhyapak Mahavidyalaya, Vasarni, Nanded",
  "Pragat Samajik Shikshan Society Sanchalit S K C Degree College Near Diwanman Talao  Vasai W  Dist  Palghar",
  "SWA BALASAHEB KALE MAHAVIDYALAY",
  "Maratha Vidya Prasarak Samaj's, Shri Swami Shatkopacharyaji Maharaj Arts, Science  & Commerce College, Saikheda, Tal. Niphad, Dist. Nashik 422210",
  "Anantrao Pawar College of Engineering & Research, Parvati, Pune - 411009 ",
  "SAHYADRI COLLEGE OF HOTEL MANAGEMENT AND TOURISM",
  "MAULI HOMOEOPATHIC COLLEGE AND RESEARCH INSTITUTE TONDAR UDGIR LATUR ",
  "P R POTE PATIL COLLEGE OF MEDICAL SCIENCES AYURVED AMRAVATI",
  "AMAR EDUCATION SOCIETYS  S P INTERNATIONAL SENIOR COLLEGE, PUNE",
  "LATE ASHOK G THAKARE ARTS, SCIENCE AND COMMERCE COLLEGE, TALWADE DIGAR",
  "SMT PARMESHWARIDEVI DURGADUTT TIBREWALA INSTITUTE OF MANAGEMENT AND RESEARCH",
  "Punyashlok Ahileyadevi Holkar College, Ranisawagaon Tq. Gangakhed",
  "UDAY MAHAVIDYALAY",
  "LOKSAVA MAHILA MAHAVIDYALAYA",
  "Radhika Adhyapak Mahavidyalaya, Rajiv Nagar, Somalwada, Nagpur",
  "Ashok Moharkar Arts & Commerce College, Adyal Tah. Pauni Dis. Bhandara",
  "Nyayadhish Tatyasaheb Athalye Arts Vedmurti S R Sapre Commerce and Vidhidnya Dadasaheb Pitre Science College, Deorukh Dist Ratnagiri",
  "Dr D Y PATIL EDUCATIONAL ENTERPRISES CHARITABEL TRUST Dr D Y PATIL GROUP OF INSTITUTIONS, Dr D Y PATIL SCHOOL OF MANAGEMENT, Dr D Y PATIL KNOWLEDGE CITY, CHARHOLI",
  "Dnyan Prasarak Shikshan Sanstha's,Sandesh College of Arts, Commerce and Science, Tagore Nagar, Vikhroli East, Mumbai-400 083.",
  "Priyadarshini Gramin Mahila Mandal Loni Arts, Commerce & Science,Puntamba, Tal. Rahata, Dist. Ahmednagar",
  "IDEAL INSTITUTE OF TECHNOLOGY",
  "Rajasthani sammelans  Ladhidevi Ramdhar Maheshwari Night College of Commerce R.S. Campus, S. V. Road, Malad (W) Mumbai  400 064",
  "ADITYA COLLEGE OF ARCHITECTURE",
  "PSD Shastri Education Foundations, Wings College of Aviation Technology, S.NO-85, NDA Road, Shivane, Pune (West) - 411023",
  "VISHWANIKETANs INSTITUTE OF MANAGEMENT ENTREPRENEURSHIP and ENGINEERING TECHNOLOGY",
  "Hajra Mohammad Husain Bhure Degree College of Arts, Science and Commerce Senior College At Post Mahapoli,  H.N. 414, At Mahapoli, Tal. Bhiwandi, Dist. Thane",
  "R K VIDYA PRASARAK MANDALs COLLEGE OF ARTS, COMMERCE AND SCIENCE",
  "SADHANA EDUCATION SOCIETYs SADHANA COLLEGE OF EDUCATION",
  "SHRI MAHADEV BABURAO CHAUGHULE MAHAVIDYALAYA ARTS, SCIENCE COMMERCE",
  "Haji Karim Mohammed Suleman Charitable Trust CUMMOO JAFFER SULEMAN COLLEGE OF ARTS AND COMMERCE FOR WOMEN",
  "Vidya Pratishthan ( Maharashtra)'s College of Education, Ahmednagar. 414005",
  "SARVODAY SHIKSHAN PRASARAK MANDALs BHOSE YASHAWANTBHAU PATIL MAHAVIDYALAYA",
  "DR D Y PATIL SCHOOL OF SCIENCE AND TECHNOLOGY",
  "Dr, Sharadchandra Pawar College of Agriculture, Baramati, Dist Pune",
  "ADIVASI SEVA SAMITI NASHIK, SANCHALIT, ARTS, COMMERCE AND SCIENCE COLLEGE, MANUR",
  "Shri Ambabai Talim Sanstha, Sanjay Bhokare Group of Institutes, Faculty of Management,  Tilak Nagar, Miraj-Sangli Road, Miraj  416 414, Dist-Sangli.",
  "Vasantrao Naik College of Agricultural Biotechnology",
  "ABHINAV EDUCATION SOCIETY'S  ABHINAV COLLEGE OF SCIENCE, AKOLE",
  "VIDYA PRASARAK MANDAL KINHAVALI SANCHALIT LAW COLLEGE",
  "NARSINGRAO GURUNATH PATIL MAHAVIDYALAYA TUDAYE TAL CHANDGAD DIST KOLHAPUR",
  "CHETANA PHYSIOTHERAPY COLLEGE, UMARI MEGHE, WARDHA",
  "BG MAHAVIDYALAYA CHAMORSHI",
  "GURUKUL MAHAVIDYALAY AHERI",
  "SARVODAYA COLLEGE, GONDPIPARI",
  "DIAMOND MAHAVIDYLAY DEOLI TA DEOLI, DIST WARDHA",
  "Pravara Rural Education Society's  Pravara Rural College of Education, Loni, Tal.Rahata, Dist. Ahmednagar  413736",
  "170032-JAMNER TALUKA EDUCATION SOCIETY'S GITABAI DATTATRAY MAHAJAN ARTS, SHRI KESHRIMAL RAJMAL NAVLAKHA COMMERCE AND MANOHARSHETH DHARIWAL SCIENCE COLLEGE, JAMNER TAL-JAMNER DIST-JALGAON",
  "KARMAVEER VYANKATRAO RANDHEER ARTS, SCIENCE, COMMERCE COLLEGE, BORADI TAL-SHIRPUR DIST-DHULE",
  "100055-DHANAJI NANA CHAUDHARI VIDYA PRABODHINI SANCHALIT LOKSEVAK MADHUKARRAO CHAUDHARI COLLEGE OF SOCIAL WORK, JALGAON.",
  "Late. Babanrao Deshmukh Mahavidyalaya,AmravatI",
  "Athavale College of Social Work, Chimur Dist. Chandrapur",
  "JEEVANDEEP SHAIKSHANIK SANSTHECHE  JEEVANDEEP ARTS, COMMERCE AND SCIENCE COLLEGE MHASA",
  "B R HARNE COLLEGE OF PHARMACY",
  "SANSKRUTI ARTS, SCIENCE AND COMMERCE COLLEGE, LALONDE",
  "ST PETER DEGREE COLLEGE DIWANMAN VASAI DIST PALGHAR",
  "SHRADDHA HOMOEOPATHIC MEDICAL COLLEGE HOSPITAL  AND RESARCH CENTER KONDALA ZAMBRE WASHIM",
  "DR G D POL FOUNDATION COLLEGE OF NURSING",
  "LATE RAJENDR SHRIVAVAST MAHAVIDYALY PARADH BK",
  "VIDYA SACCHIDANAND FULEKAR MAHAVIDYALAY",
  "VIVEKANAND ART,COMMERCE,SCIENCE COLLEGE BHOKARDAN",
  "SUNRISE COLLEGE OF HOTEL MANAGEMENT AND ADMINISTATIVE SERVICES  DATALA ROAD CHANDRAPUR",
  "KDM COLLEGE OF ARTS COMMERCE SCIENCE AND TECHNOLOGY",
  "R K M SENIOR COLLEGE BAHADARPUR TAL PAROLA",
  "ARTS, COMMERCE AND SCIENCE COLLEGE, PAL, TAL  RAVER",
  "SAMUNDRA INSTITUTE OF MARITIME STUDIES LONAVALA",
  "DADASAHEB RAWAL PHARMAY COLLEGE MANDAL DONDAICHA ",
  "BHILDARI BAHOOUDHESHIYA SANSTHAS ARTS COMMERCE AND SCIENCE COLLEGE WATUR",
  "LATE NARAYANRAO KARDAK ARTS COMMERCE AND SCIENCE SR COLLEGE NAGAMTHAN TQ VAIJAPUR DIST AURANGABAD",
  "Vasantrao Naik B.Ed. College, Bal Bhagwan Shikshan Prasarak Mandal, At. Post. Shirur Tajband.",
  "SMT KAMALBAI YADAVRAO DANGE ARTS COMMERCE AND SCIENCE MAHAVIDHYALAY KINHI YAVATMAL",
  "MATA RAMABAI ARTS COMMERCE AND SCIENCE MAHAVIDYALAY ",
  "NALANDA COLLEGE OF FASHION DESIGN",
  "SHIVPRASAD MAHAVIDYALAY MUKHED DIST NANDED",
  "NATIONAL INSTITUTE OF FASHION DESIGNING, KASAR SIRSI",
  "NARAYANA COLLEGE OF FASHION DESIGN STATION ROAD UDGIR DIST LATUR",
  "BHARATMATA MAHILA MAHAVIDYALAY",
  "RAJKUNWAR BAHHUDESHIY SEVA BHAVI SANSTHA RAJKUNWAR MAHILA MAHAVIDYALAY DHAWDA",
  "SAMARTH MAHILA MAHAVIDYALAY JAFRABAD TA JAFRABAD DIST JALNA",
  "RADHE KRUSHNA MAHILA MAHAVIDYALAY PARTUR ANANDWADI",
  "RAJKUNWAR MAHILA MAHAVIDYALAYA WAGHRUL J TAL JALNA DIST JALNA",
  "MATA JAGDAMBA MAHILA MAHAVIDYLAY, VAIRAGAD TAL ARMORI DIST GADCHIROLI",
  "ANURADHA COLLEGE OF BACHELOR OF DESIGN, CHIKHLI",
  "SMT PRABHATAI SARUK MAHILA KALA VIDNYAN VA VANIJYA MAHAVIDYALAY COLLEGE DHORKIN",
  "MAHARUDRA ARTS COMMERCE AND SCIENCE COLLEGE KUMBHEPHAL",
  "LATE AMBUBAI WOMENS ARTS SCIENCE AND COMMERCE COLLEGE",
  "SAVITRIMAI MAHILA MAHAVIDYALAY",
  "VIKRAMSHILA COLLEGE OF FASHION DESIGN",
  "SHRI MOHATADEVI SHIKSHAN SANSTHA, PRAGATI MAHAVIDYALAY, PALSHI KANHAPUR, TAL AND DIST AURANGABAD",
  "MILANO FASHION INSTITUTE OF DESIGN AND TECHNOLOGY SANGMANER",
  "MAGARPATTA CITY EDUCATIONAL FOUNDATIONS MAGARPATTA COLLEGE OF  HOSPITALITY STUDIES  PUNE",
  "VILASRAO DESHMUKH LAW COLLEGE,PUNE ",
  "SHRI SOMESHWAR SHIKSHAN PRASARAK MANDALS, SHARADCHANDRA PAWAR INSTITUTE OF MANAGEMENT AND RESEARCH, SOMESHWARNAGAR",
  "PUNE CAMBRIDGE SENIOR COLLEGE",
  "KAUSHALY DNYANVARDHINI ARTS,COMMERCE AND SCIENCE COLLEGE,GOREGAON",
  "JAY BHARAT COLLEGE OF PHARMACY DAPKA  TQ NILANGA DIST LATUR",
  "SAMAJ PRABODHAN ARTS COMMERCE AND SCIENCE COLLEGE KANHERGAON NAKA WASHIM ROAD",
  "SHRI VINAYAKRAOBAPU DESHMUKH COLLEGE OF NURSING, YAVATMAL",
  "SAWKAR AYURVEDIC MEDICAL COLLEGE AND SAWKAR AYURVEDIC HOSPITAL SATARA",
  "SHANTABAI SHIVSHANKAR ARALI AYURVEDIC HOSPITAL AND COLLEGE",
  "DR B B KHALADKAR PHYSIOTHERAPY COLLEGE WAKHARI DAUND PUNE",
  "PHARATE PATIL AYURVEDIC MEDICAL COLLEGE, MANDAVGAN PHARATA, TAL SHIRUR, DIST PUNE",
  "PARBHANI NURSING COLLEGE PEDGAON PARBHANI MANVAT ROAD PARBHANI",
  "IDEAL INSTITUTE OF NURSING",
  "SIR J P  COLLEGE OF PHYSIOTHERAPY  B P TH",
  "SHIVAI INSTITUTE OF NURSING ",
  "GOVERNMENT MEDICAL COLLEGE OSMANABAD",
  "DR SMITA GHOGARE PHYSIOTHERAPY INSTITUTE",
  "TANMAYI COLLEGE OF PHYSIOTHERAPY PADMA NAGAR BHAKSHI ROAD SATANA TAL SATANA DIST NASHIK",
  "BHAUSAHEB MULAK NURSING COLLEGE",
  "DR SHUBHANGI PRADIP PATIL AYURVEDIC MEDICAL COLLEGE",
  "DR VEDPRAKASH PATIL AYURVED COLLEGE AND RESEARCH INSTITUTE JALNA ",
  "SHRI PRAKASHCHAND JAIN COLLEGE OF PHYSIOTHERAPY AND RESEARCH",
  "SHRI K R PANADAV COLLEGE OF PHYSIOTHERAPY, BHANDARA",
  "JIJAMATA COLLGE OF PHYSIOTHERAPY MAJALGAON",
  "SHIVAJIRAO PAWAR AYURVEDIC MEDICAL COLLEGE AND RESEARCH CENTRE PACHEGAON AHMEDNAGAR",
  "SANJIVANI COLLEGE OF AYURVEDA AND RESEARCH CENTRE  ",
  "VAMANRAO ITHAPE NURSING COLLEGE,SANGAMNER",
  "RAOSAHEB BALARAM DNYANDEO THAKUR VIDYAMANDIR'S DR. ARVIND M. PRADHAN COMMERCE & ARTS COLLEGE.",
  "Sancheti Institute for Orthopaedics & Rehabilitation, College of Physiotherapy, Sancheti Healthcare Academy, 11/12, Thube Park, Shivajinagar,  Pune-411005",
  "The Education Societys, P. D. Karkhanis College of Arts & Commerce, Ambernath, Kansai Section, Ambernath (East), Dist. Thane - 421 501",
  "KSS WOMENS COLLEGE DHRMAPURI PARBHANI",
  "Kasarde Vikas Mandal's, Kasarde Senior College, Kankavli, Sindhudurg - 416801",
  "ALL INDIA SHRI SHIVAJI MEMORIAL SOCIERTYS COLLEGE OF BUSINESS ADMINISTRATION",
  "VIDHYAVIHAR MAHAVIDHYALAYA KALAMB DIST YAOTMAL",
  "210075-ADISHAKTI DHANDAI MATA SHIKSHAN PRASARAK SASNSTHA'S LATE ANNASAHEB R.D.DEORE ARTS & SCIENCE COLLEGE, MHASDI,TAL-SAKRI",
  "SEVASADAN ARTS, COMMERCE AND SCIENCE SENIOR COLLEGE",
  "Arts and Commerce College , Jarud",
  "TRIMURTI ARTS COMMERCE SCIENCE COLLEGE  DHORJALGAON NE ",
  "H. B. B.Ed. College, Plot No. 16 & 17, Sector-10A, Vashi, Navi Mumbai-400703",
  "Parmita Education Society Sanchalit, Modern College of Computer Science & I.T.",
  "Sudhagad Education Socicty's, Sheth J. N. Paliwala Commerce College, Science & Arts College, Pali Sudhagad, District- Raigad",
  "HARSH INSTITUTE OF NURSING KHAMGAON BULDHANA",
  "Audyogik Tantra Shikshan Sanstha, ATSS College Of Business Studies & Computer Application, C2 MIDC Chinchwad, Tal-Pimpri Chinchwad (Corporation Area), Dist-Pune-411019",
  "SHRI GANESH SHIKSHAN PRASARAK MANDAL, PU. AHILYADEVI ADHYAPAK MAHAVIDYALAYA, NANDED-LATUR HIGHWAY, AT. SANGVI, POST. SANGVI, TAL. AHMEDPUR, DIST. LATUR, STATE. MAHARASHTRA",
  "Ramdas Athawale Arts & Commerce College, Nilanga",
  "Kishori College of Pharmacy",
  "Maratha Vidya Prasarak Samaj's Karmaveer Shantarambapu Kondaji Wavare Arts,Science & Commerce College, CIDCO, Uttamnagar, Nashik 422008",
  "SHRI JANRAOJI KALE MAHAVIDYALAY, SONKHAS, SHAHAPUR, TQ MANGRULPIR",
  "KASTURI CHARITABLE TRUSTS, GUARDIAN DEGREE COLLEGE OF ARTS, COMMERCE AND SCIENCE, BHOPAR CROSS ROAD, DOMBIVLI EAST, DIST THANE",
  "VIDYABHARATI MAHAVIDYALAY, RALEGAON",
  "VIVEKANAND NURSING COLLEGE MEHKAR BULDANA ",
  "SHIVAJI COLLEGE",
  "JIJAU MAHAVIDYALAY, PARANDA",
  "MARATHWADA MAHILA MAHAVIDYALAY, LATUR",
  "GURU GANGABHARTI MAHILA MAHAVIDYALAY KALAMNURI ",
  "KAVYITRI BAHINABAI CHAUDHARI MAHAVIDYALAY BHUSAVAL",
  "R M D COLLEGE AKOLA",
  "SHRAVANI HI TECH EDUCATIONAL CAMPUS B DESIGN COLLEGE BORALA BASMAT",
  "ADIVASI MAHAVIDYALAY TUNKI",
  "CHHATRAPATI VARISHTHA MAHAVIDYALAY",
  "VIRAJ VARISTHA MAHAVIDYALAY, SILLOD",
  "Pradnya Niketan Education Societys Nagesh Karajagi Orchid College of Engineering and Technology, Solapur",
  "BABURAO PATIL BHOYAR KALA MAHAVIDYALAYA, WADADHA",
  " Institute of Pharmaceutical Education and Research,  Borgaon Meghe, Wardha",
  "Dr. Hedgewar Smruti Rugna Seva Mandals Dental College, Akola Road, Hingoli",
  "KAPOL Vidyanidhi Trusts Kapol Vidyanidhi College of Hotel Management at Adijacent to Poisar Gymkhana Kamala Vihar Sports Club Lane Mahavir Nagar Kandivali(W) Mumbai  400 067",
  "All India Institute of Physical Medicine & Rehabilitation, Haji Ali Park, K. Khadye Marg, Mahalaxmi, Mumbai 422 004",
  "Seva Mandal Education Society's Smt. Sunanda Pravin Gambhirchand College of Nursing, Smt. Parmeshwari Devi Gordhandas Garodia Educational Complex, R.A. Kidwai Road, Matunga (E), Mumbai-400019",
  "Government medical college Baramati",
  "JEEVANDEEP LAW COLLEGE, GOVELI",
  "JEEVANDEEP ARTS, COMMERCE AND SCIENCE COLLEGE ,TITWALA",
  "Rashtriya Charitable Trust Sanchalit Arts, Science & Commerce College",
  "Pandit Jawaharlal Nehru Arts, Science & Commerce College, Parli Vaijanath.",
  "Karmavir Mahavidyalaya, Mul",
  "G H Raisoni College of Engineering and Management, Jalgaon",
  "TAKSHASHILA INSTITUTE OF ENGINEERING & TECHNOLOGY, DARAPUR. Distt:-Amravati",
  "Badrinarayan Barwale Mahavidyalaya, Jalna",
  "Vitthalrao Patil Mahavidyalaya, (Arts, Commerce and Science), KALE",
  "210076-TRIMURTI SHIKSHAN SANSTHA'S SMT.VIMALBAI UTTAMRAO PATIL ARTS AND LATE DR.BHASKAR SADASHIV DESALE SCIENCE COLLEGE,SAKRI.",
  "Vidya Vikas Education Trusts The Lords Universal College of Law, Topiwala Marg, Off Station Road, Goregaon (West), Mumbai 400104",
  "SATISH MISAL EDUCATIONAL FOUNDATION'S BRICK SCHOOL OF ARCHITECTURE, PUNE",
  "Nirmal Education Societys Nirmal Degree College of Commerce, Kandivali (W) , Mumbai - 400 067",
  "Thakur Ramnarayan College of Arts and Commerce, S.V.Road, Dahisar (E), Mumbai - 400 068.",
  "THAKUR RAMNARAYAN COLLEGE OF LAW  S.V.ROAD ,DAHISAR (E) ,MUMBAI - 400 068",
  "AMOLAKCHAND VIDHI MAHAVIDYALAYA, YAVATMAL.",
  "Lokmanya Trust, Deshbhakta Shankarrao College of Commerce, 1st Floor, Rameshwar Plaza, Opp. Moti Talav, Sawantwadi  416 510 ",
  "LOKMANYA MAHAVIDYALAYA, WARORA, CHANDRAPUR",
  "250114-SHRI JAYKUMAR RAWAL INSTITUTE OF TECHNOLOGY, DONDAICHA, DHULE",
  "NASHIK NURSING COLLEGE (P B B SC), PANCHVATI",
  "SUPRIYADIDI SULE COLLEGE OF NURSING P B B SC, SHRIRAMPUR",
  "SMMPPS GANPATRAO ADKE COLLEGE OF NURSING (P B B SC), DUGAON",
  "THE BANDRA HOLY FAMILY HOSPITAL SOCIETYS HOLY FAMILY INSTITUTE OF NURSING EDUCATION (B SC), KURLA",
  "Gondpipri Shikashan Mahavidhyalaya, Gondpipri",
  "Vilasrao Deshmukh Foundation, Group of Institutions, Latur",
  "Late Nirdhan Patil Waghaye Arts, Commerce, Science College, Ekodi Ta.Sakoli, Dist.Bhandara",
  "Raje Chhatrapati Kala Mahavidyalaya, Buldhana.",
  "Peoples Education Societys Adv. Balasaheb Apte College of Law, Prin N. M. Kale Marg, Gokhale Road (S), Dadar (West), Mumbai-400028",
  "Karmayogi Institute of Technology, Tal.Pandharpur, Dist-Solapur",
  "KHILESH MAHAVIDAYALAYA SALEKASA, SLEKASA",
  "P N SARODE COLLEGE OF ARTS, COMMERCE AND HOMESCIENCE, HINGANGHAT",
  "Vidya Vikas Education Trusts Vidya Vikas College of Arts, Science, Commerce, B.M.M., B.M.S., Opp. Bansi Snacks, Chincholi Bunder Road, Malad (W), Mumbai - 400 064",
  "DNYANDEEP COLLEGE OF ADMINISTRATION, VADDHAMNA",
  "PATALDHAMAL WADHWANI COLLEGE OF PHARMACY, YAVATMAL",
  "Mumbai Pradesh Arya Vidya Sabha's  Gurukul College of Commerce, Gurukul Educational Institutions, Tilak Road, Gurukul Lane, Opp Punjab National Bank, Ghatkopar (East), Mumbai - 400077",
  "Lady Amritbai Daga College For Women of Arts,Commerce & Science And Smt. RP College of Home Science and Home Science Technology",
  "JIJAU MEMORIAL PRASHASKIY SEWA MAHAVIDYALAY,TA LOHARA,DIST OSMANABAD ",
  "SHIVAJI COLLEGE",
  "SWARAJYA  VARISTHA MAHAVIDYALAY BHAKSHI, MULANE  TA BAGLAN DIST NASHIK",
  "SATPUDA MAHAVIDYALAY ",
  "NARAYANA PRASHASKIY SEVA MAHAVIDYALAYA LOHA",
  "Rashtramata Jijau Charitable Trust Sanchalit, Chhatrapati Sambhaji College of Computer Science",
  "SHANKARRAO CHAUHAN MAHAVIDYALAY PETHWADAJ TQ KANDHAR DIST NANDED",
  "JANPRABHA COLLEGE ",
  "S A COLLEGE JALNA",
  "DEVAKI MAHAVIDYALAYA, JALNA RAJUR ROAD PIRPIMPALGAON",
  "SMT SUMITRABAI MAHAVIDYALAY ANVA",
  "SWATANTRAVEER SAVARKAR B A  PRASHASAKIY SEVA MAHAVIDYALAY",
  "Karmveer Ganpat Dada More Arts, Commerce & Science College,Niphad, District - Nashik 422303",
  "RASHTRASANT TUKADOJI MAHARAJ ARTS COLLEGE ARTS COLLEGE DEVLAPAR",
  "JIJAU VARISHTH MAHAVIDYALAY SHELGAON TQ BADNAPUR DIST JALNA",
  "DR VITTHALRAO KHOBRAGADE B.Ed COLLEGE NAGPUR",
  "SWAMI VIVEKANAND VARISHTH MAHAVIDYALAY ",
  "DR MILIND BIMBE COLLEGE, RAVER DIST JALGAON",
  "KAI BABARAO PATIL VARISTH MAHAVIDYALAY JAWLA TQ SENGAON DIST HINGOLI",
  "MA SHARADCHANDRAJI PAWAR VARISHTHA MAHAVIDYALAY, SANTUKPIMPRI, TA DIST HINGOLI ",
  "R K PRASHASKIY MAHAVIDYALAY DESAIGANJ TA WADSA DIST GADCHIROLI",
  "SAMIDHA COLLEGE OF CIVIL SERVICES ADAPALLI",
  "MATA JAGDAMBA PRASHASKIYA MAHAVIDYALAYA,WADHOLI TA GONDPIPRI DIST CHANDRAPUR",
  "CHHATRAPATI SHIVAJI MAHARAJ MAHAVIDYALAYA SURLA DIST CHANDRAPUR",
  "NITANSHU MAHAVIDYALAYA NAVKHADA NAGBHID, TAH NAGBHID, DIST CHANDRAPUR",
  "SMT SHOBHATAI BANSOD MAHAVIDYALAYA KHEDMAKTA TH BRAMHAPURI DIST CHANDRAPUR",
  "KARMAVIR BHAURAO PATIL MAHAVIDYALAYA, MUL",
  "KARMAVIR BHAURAO PATIL MAHAVIDYALAYA, BALLARPUR",
  "SWA SUSHILABAI JAISWAL MAHAVIDYALAY PANHERA",
  "BHAUSAHEB GAIKWAD SENIOR COLLEGE,PETH TA,CHIKHALI,DIST,BULDHANA",
  "PRANJAL KALA,VANIJYA,VIDNYAN MAHAVIDYALAY,MOTALA",
  "SWAMI VIVEKANAND MAHAVIDYALAYA ANTRAJ TQ KHAMGAO  ",
  "KHOMAN PRASHASKIYA MAHAVIDYALAY SAKOLI",
  "SAI MAHAVIDYALAY TUMSAR",
  "YUG PRASHASKIY MAHAVIDYALAY, MOHADI ",
  "S D PRASHASKIY MAHAVIDYALAY  BHANDARA",
  "VSPM COLLEGE OF EDUCATION(B.ED), KHUTAMBA ROAD KATOL",
  "SHIV CHHATRAPATI MAHAVIDYALAY PACHOD TA PAITHAN DIST AURANAGABAD",
  "SHANTA BABURAO PAWAR VARISHTH MAHAVIDYALAY, SHEKTA, AURANGABAD",
  "GEETAI KALA VA VANIJYA MAHAVIDYALAY",
  "CHHATRAPATI SAMBHAJI COLLEGE",
  "Bapuraoji Butle Arts, Narayanrao Bhat Commerce and . Bapusaheb Patil Science College, Digras.",
  "BLD MAHAVIDYALAY",
  "BHARATRATNA ATAL BIHARI VAJPEYI MAHAVIDYALAY, MALKAPUR, DIST AKOLA",
  "SUNRISE MAHAVIDHYALAYA",
  "SHRI NAGESHWAR UCCH SHIKSHAN MAHAVIDYALAY, BHANDGAON",
  "SHRI. SUSHILKUMAR SHINDE COLLEGE OF PHYSICAL EDUCATION NEHRU NAGAR, SOLAPUR.",
  "GOVERMENT HOMOEOPATHIC MEDICAL COLLEGE JALGAON",
  "Yashwantrao Bhonsale College of Pharmacy, Sawantwadi",
  "Smt Sindhutai Jadhao Arts and Science Mahavidyalaya, Mehkar Dist. Buldana",
  "DR NITIN HUMANE COLLEGE OF HOTEL MAMAGEMENT AND PROFESSIONAL COURSES, VIHIRGAON NAGPUR",
  "Sai Shraddha Foundation,Saeesh College of Computer Science & Technology of B.Sc.(Hospitality Studies) Gr. Floor Madhukunj Next to Govt. Library Opp. Alibag ST Stand Alibag Dist  Raigad",
  "SSMM BED COLLEGE",
  "GOVERNMENT MEDICAL COLLEGE, CHANDRAPUR",
  "Rani Maa Saheb Rawal Mahila Science Mahavidyalay, Dondaicha Tal-Shindkheda",
  "Vaidyanath Institute of Nursing (PBBSc Nursing)",
  "The Yash Foundations College of Nursing & Medical Research Institute, Mirjole, Ratnagiri",
  "NKSPTS INSTITUTE OF MANAGEMENT ",
  "YASHODA COLLEGE OF ARCHITECTURE, SATARA",
  "KJ's Educational Institute, Trinity College of Architecture, Survey No. 25 & 27, Kondhwa Saswad Road, Pune 411048",
  "IDEAL COLLEGE OF ARCHITECTURE,KONDIGRE",
  "G.B. TATHA  TATYASAHEB KHARE COMMERCE, PARVATIBAI GURUPAD DHERE ARTS & SHRI MAHESH JANARDAN BHOSALE SCIENCE COLLEGE, GUHAGAR ,DIST.:-RATNAGIRI-415703",
  "G K MAHAVIDHYALAY KAWARABANDH",
  "SHRI JANARDHAN RAMCHANDRA KAKDE ARTS COMMERCE AND SCIENCE MAHAVIDYALAYA KANKARWADI",
  "SHRI SAKHARAMJI DESHMUKH MAHILA MAHAVIDYALAY ZILMILI KAMTHA GONDIA",
  "DIWAKARRAO INGALE B A PRASHASKIYA MAHAVIDYALAYA",
  "RAJMATA JIJAU MAHILA MAHAVIDHYALAYA NER ",
  "RAJMATA JIJAU MAHAVIDYALAY KINGAON RAJA TQ SINDKHED RAJA DIST BULDHANA",
  "VPS INSTITUTE OF HOSPITALITY STUDIES AND HOTEL MANAGEMENT",
  "DR ABDUL KALAM URDU ARTS SENIOR COLLEGE SULTANPUR TQ KHULTABAD DIST AURANGABAD",
  "New Arts, Commerce & Science College, Shevgaon, Tal -  Shevgaon, Dist. Ahmednagar 414502",
  "DNYAN MAHAVIDYALAYA SOMTHANA, MANORA, TA MANORA, DIST WASHIM",
  "ASMITA MAHILA BAHUUDESHIYA SANSTHA, SUMANTAI PATIL B.ED. COLLEGE, PACHORA, DIST. JALGAON",
  "Shri Kesarchand Gulabchand Munot Newaskar Sarvajanik Trusts k. g. College of Arts & Commerce, Ahmednagar 414001",
  "College of Agriculture, Muktainagar ",
  "Dr.R. G. Bhoyar Arts, Commerce & Science College, Seloo, Dist.Wardha",
  "Shriram College of Agriculture Business Management, Paniv",
  "Shri Purogami Shikshan and Sanskrutik and Krida Prasarak Mandal Jijamata Kala Mahila Mahavidyalay",
  "Vilasrao Deshmukh Foundation, Group of Institutions, VDF School of Pharmacy, Latur",
  "LOTUS COLLEGE OF OPTOMETRY",
  "Maharshi Karve Model College, Shriwardhan",
  "VAIDYANATH INSTITUTE OF PHYSIOTHEAPY",
  "AHIRKAR INSTITUTE OF MANAGEMENT STUDIES",
  "MATOSHRI AYURVED COLLEGE",
  "MGM School of Biomedical Sciences, Navi Mumbai",
  "DINDORI COLLEGE OF NURSING DINDORI",
  "DR J J MAGDUM TURST DR J J MAGDUM PHARMACY COLLEGE JAYSINGPUR",
  "KOHINOOR INSTITUTE OF PHARMACY KHULDABAD",
  "JAIKRANTI COLLEGE OF EDUCATION",
  "LAW COLLEGE VITA TAL KHANAPUR DIST SANGLI",
  "Asian Academy of Education & Research, Asian College of Science & Commerce, Pune",
  "Nirmal Education Society Vidya Niketan Degree College of Commerce, Pant Nagar BMC School No. 2, Opp. Acharya Atre Ground, Pant nagar Ghatkopar East, Mumbai - 400 075",
  "SHRI TUKARAMJI PATIL ARTS COMMERCE AND SCIENCE MAHAVIDYALAYA TORNALA JODGAVHAN TQ WASHIM DIST WASHIM",
  "POOJA NURSING COLLEGE,BHANDARA",
  "VIDARBH MODERN DEGREE COLLEGE",
  "SHIVRAJ MAHILA MAHAVIDYALAYA PARTUR",
  "BALIVANSH COLLEGE OF YOGA NATUROPATHY AND HOTEL MANAGEMENT",
  "SARVODAYA COLLEGE MUL",
  "ABHAY COLLEGE OF ARTS COMMERCE AND SCIENCE",
  "BHARATRATNA NANAJI DESHMUKH SENIOR COLLEGE AT PO GOREGAON TQ SENGAON DI HINGOLI ",
  "LATE BHAIYYASAHEB GHORPADE INSTITUTE OF PHYSIOTHERAPY",
  "Late Roopchandbhai Premchand Pugalia, Arts Commerce Science, Navegaon",
  "Digambarrao Bindu Arts, Commerce and Science College, Bhokar Dist. Nanded",
  "Yuvashakti Arts & Science College , Amravati.",
  "Shikshan Maharshi Shri Krishnarao Zoting Patil Arts & Commerce College, Samudrapur, Dist. Wardha",
  "Shri Tilok Jain Dnyan Prasarak Mandals Shri Anand College, Pathardi",
  "Jyotirao Phule Samajkarya Mahavidhyalaya, Umred",
  "Shri Shivaji Arts, Commerce and Science College, Motala, Dist. Buldana",
  "Shahid Bhagatsingh College of Physical Education, Amravati",
  "NKGS, College of Agriculture, Nanded Road, Udgir",
  "COLLEGE OF HORTICULTURE, SARALGAON",
  "COLLEGE OF AGRICULTURE ENGINEERING AND TECHNOLOGY",
  "Annasaheb Dange College of B. Pharmacy, Sangli ",
  "K.H.M.W. COLLEGE OF COMMERCE",
  "Muslim Education Committees Kala (Urdu) Mahavidyalaya, Sangli",
  "Dr. Shivajirao Kadam College of Pharmacy",
  "Mauli College of Pharmacy (B.Pharm)",
  "DR ZAKIR HUSSAIN WOMENS DEGREE COLLEGE OF ARTS COMM and SCI, PARBHAN",
  "HINDUHRIDAYSAMRAT BALASAHEB THACKERAY MEDICAL COLLEGE AND Dr. R.N.COOPER MUNCIPAL GENERAL HOSPITAL",
  "Shikshan Prasarak Mandals Smt.Ratnaprabhadevi Mohite Patil College of Home Science For Women, Akluj Pin code - 413101",
  "B.P. Marine Academy Hospitality Studies, Sai Pooja Chambers 7th Floor Sector11 CBD Belapur Navi Mumbai- 400614",
  "RAMKRISHNA SENIOR COLLEGE DAHEGAON",
  "SWAYAM SIDDHI DEGREE NIGHT COLLEGE",
  "COLLEGE OF AGRIBUSINESS MANAGEMENT KASHTI MALEGAON",
  "SIDDHIS INSTITUTE OF PHARMACY NANDGAON",
  "DHOLE PATIL COLLEGE OF PHYSIOTHERAPY ",
  "WADA NIRMITI EDUCATION SOCIEITYS VIDYA VARIDHI DEGREE COLLEGE OF ARTS AND COMMERCE",
  "KRANTIVEER KAKASAHEB DESHMUKH ARTS COMMERCE AND SCIENCE COLLEGE",
  "BHAUSAHEB MULAK PHYSIOTHERAPY COLLEGE ",
  "D K PATIL INSTITUTE OF PHARMACY ",
  "Kala Mahavidyalaya, Malakapur, Tq. Akola",
  "Late Nitin Mahavidyalaya, Pathri",
  "Kai. Bapusaheb Patil Ekambekar Mahavidyalaya, Udgir",
  "M.P.G.V.S.'s Mahatma Phule B.C.A. College, karegaon Road, Parbhani",
  "Raje Shahaji Senior Arts Commerce and Science College Ambelohal",
  "MAHARASHTRA PRASHASKIY SEVA COLLEGE GADHINGLAJ",
  "HINDUHRIDAYSAMRAT MANANIYA BALASAHEB THACKERAY ARTS COMMERCE  SCIENCE COLLEGE ",
  "NCIT INDIA'S IIBM COLLEGE OF HOTEL MANAGEMENT, IIBM CAMPUS, CHINCHWAD, PUNE",
  "PADMABHUSHAN VASANTDADA PATIL PRASHASKIY SEVA MAHAVIDYALAY",
  "Aurangabad College of Engineering, aurangabad",
  "Habib Educational and Welfare Societys M S College of Arts, Commerce, Science and BMS ",
  "G K ARTS  AND SCIENCE MAHILA MAHAVIDYALAYA,  KAWARABANDH",
  "SHRI KALA MAHAVIDYALAYA, ANJI (MOTHI), TAL",
  "Zagdu Singh Charitable Trust's Thakur Shyamnarayan Degree College, Thakur House, Ashok Nagar, Kandivali (East), Mumbai-400 101",
  "V.R.College wardha",
  "Dr.R.N.Lahoti Ayurvedic College, Hospital and Research Institute Sultanpur",
  "PRAKASH INSTITUTE OF MEDICAL SCIENCES AND RESEARCH",
  "JAYAWANT SHIKSHAN PRASARAK MANDALS J S P M NARHE TECHNICAL CAMPUS, NARHE, PUNE",
  "MET's Institute of Pharmacy, Bhujbal Knowledge City, Adgaon, Nashik 422003",
  "Janata Shikshan Sansthas Smt. Chandrakala Kishorilal Goyal , Arts  and Commerce College, Dapodi, Pune  411 012",
  "S.V.Ss, VIKASRATNA SARKARSAHEB RAWAL, COLLEGE OF AGRICULTURE, DONDAICHA, TAL. SHINDKHEDA",
  "DHANVANTARI D.M.L.T.COLLEGE ",
  "swa. k.g. wagh mahila mahavidiyalaya kalamb, dist yavtmal",
  "Late Dr. Haribhau Admane Arts and Commerce College, Saoner",
  " ARTS COMMERCE  AND SCIENCE COLLEGE HARSUL SAVANGI TQ DIST AURANGABAD",
  "Gurunanak Science College, Ballarpur",
  "Shri Chhatrapati Shivaji Vidya Vikas Mandal, Kolegaon, Tuljabhavani College of Information Technology, Osmanabad.",
  "K. M. Arts College, Pangaon",
  "Dnyanada College Of Education, Bhiwapur Ward, Chandrapur",
  "Mahatma Gandhi College of Science, Gadchandur",
  "RAFI AHMAD QUIDWAI COLLEGE OF ARTS AND COMMERCE GHUTKALA",
  "Laxmibai BBA and BCA College, Lakandoor",
  "LAXMIBAI ARTS AND SCIENCE COLLEGE, MANGLI / KHAPA",
  "Sharad Institute of Technology College of Engineering, Gat",
  "K.D. Gavit Nursing College  (B.Sc.) Natawad, Nandurbar",
  "Universal Society for Quality Education & Research Irene Institute of Education, Ambedkar Road, Near Pathare Nursary, Kalyan  (W), Pincode - 421301",
  "SINDHUDURG SHIKSHAN PRASARAK MANDAL SSPM MEDICAL COLLEGE AND LIFETIME HOSPITAL PADVE",
  "GURU GOVINDSINGH MEMORIAL SCHOOL OF NURSING",
  "TULSI SHIKSHAN PRASARAK MANDALS ADARSH NIGHT COLLEGE OF ARTS COMMERCE AND SCIENCE",
  "INDALA INSTITUTE OF PHARMACY",
  "SMT K L TIWARI DEGREE COLLEGE OF COMMERCE AND SCIENCE",
  "Brilliant Women Commerce College, Latur",
  "MUMBRA SHIKSHAN PRASARAK MANDALS  G R PATIL COLLEGE OF ARTS SCIENCE AND COMMERCE WAGHIVALI MURBAD",
  "RAJKUNWAR MAHILA MAHAVIDYALAYA WANI",
  "RAJKUNWAR MAHILA MAHAVIDYALAYA KINWAT",
  "Yadavrao Tasgaonkar Institute of Pharmacy",
  "Pune District Education Associations College of Architecture, Sector28, Pradhikaran, Akurdi, Pune 44",
  "P. R. Pote Patil College of Pharmacy, Amravati",
  "A.D. Institute of Science and Management, Khultabad.",
  "Appex Institute of Computer and Management Studies, Beed Baypas, Aurangabad.",
  "AURANGABAD B.ED. COLLEGE, Aurangabad.",
  "Chistiya College of Arts, Khultabad.",
  "Dhareshwar Shikshan Sanstha s Arts and Science College, Chincholi, Kannad.",
  "Dr. Ambedkar College of Law, Nagsenvana, Aurangabad.",
  "Dr. Vedprakash Patil Pharmacy College , Georai Tanda, Chhatrapati Sambhajinagar.",
  "Foster Development School of Management, Garkheda, Aurangabad.",
  "Goverment college of Education, Padampura, Aurangabad.",
  "Gramaudyogik Shikshan Mandal's, Maharashtra Institute of Technology, Satara Parisar, Aurangabad.",
  "Hi-tech College of Management & Computer Science, Waluj, Gangapur.",
  "SYMBIOSIS MEDICAL COLLEGE FOR WOMEN",
  "Rashtramata Jijau Charitable Trust Sanchalit, Swami Vivekanand College of Computer Science, Aurangabad.",
  "Late Laxmanrao Bhimrao Kolate Patil Arts, Commerce and Science College, Sawaldabara, Soegaon.",
  "Lokseva Education Society Arts & Sci. College, Garkheda, Aurangabad.",
  "Lokvikas  Education & Charitable Trust Sanchalit, Marathwada Institute of Management and research, Satara Parisar, Aurangabad.",
  "Marathwada Institue of Career Education Managment Studies and Research, Khokadpura, Aurangabad",
  "Maulana Azad Educational Trust's Y.B.Chavan College of Pharmacy, Roza Bagh, Aurangabad.",
  "M.P.S.S. Shishaknete Shivajirao Patil College of Education, Bhendala, Gangapur.",
  "Navalbhau Pratisthan's V.N. Patil Law College, N-3, Cidco, Aurangabad.",
  "PADMAVATI BEd COLLEGE, AGHOOR, VAIJAPUR.",
  "Parivartan Education Society Jalna's, Rajarshi Shahu Arts & Science College, Waluj, Aurangabad.",
  "RAJESHBHAIYYA TOPE COLLEGE OF B.PHARMACY",
  "RAJKUNWAR COLLEGE, FARDAPUR, SOEGAON.",
  "Rashtriya B.C.S. College, PAdegaon, Aurangabad.",
  "Rashtriya Arts, Commerce and Science College, Nagad, Tq. Kannad, Dist. Aurangabad.",
  "Gramaudyogik Shikshan Mandal's Marathwada Institute of Technology, Cidco, Aurangabad.",
  "Ramdas Athawale Arts, Commerce & Science College, Chowka, Aurangabad.",
  "Shri Renukadevi Arts, Commerce and Science Mahavidyalaya, Mahur",
  "ASCENT COLLEGE SOLAPUR",
  "Rashtriaya Charitable Trust B.C.A. College, Garkheda, Aurangabad.",
  "RYP COLLEGE OF ARTS VIHAMANDWA, PAITHAN.",
  "Jivan Vikas Mahavidyalaya, Shivoor Tq - Vaijapur, Dist-Aurangabad",
  "M.S.P. Mandal's Deogiri Institute of Technology and Management Studies, Aurangabad.",
  "Shreeyash Pratishthan's Shreeyash College of Engineering and Technology , Satara Tanda, Aurangabad.",
  "Shri Dhaneshwari Manav Vikas Mandal's Post-Graduate Education College, Georai Tanda, Aurangabad.",
  "Vidya Sahyog Bahuddeshiya Sanstha Trimurti Mahila Mahvidyalaya, Amlad",
  "National Arts And Science College Ambhai",
  "Vasantdada Patil Pratishthans Manohar Phalke College of Architecture",
  "MATHOSHRI HAUSAI ATHAWALE ART AND SCIENCE COLLEGE",
  "M V  Mandali's Colleges  of Commerce & Science, Mogaveera Bhavan, Veera Desai Road, Andheri (West), Mumbai  400 058",
  "Maharashtra Cosmopolitan Education Society's A.K.K. New Law Academy, Camp Pune",
  "Sankalp Education Society's ISMS Sankalp Business School,S.No. 9-1-1, Ambegaon Bk., Pune 411041.",
  "SAMARTH MAHAVIDYALAYA KURULA TQ KANDHAR DIST NANDED ",
  "DATTA MEGHE COLLEGE OF PHYSIOTHERAPY",
  "shree goraksha college of pharmacy and research center, khamgaon",
  "SHREE L.R.TIWARI DEGREE COLLEGE OF ARTS, COMMERCE and SCIENCE",
  "Mahatama Gandhi Vidyamandirs Arts, Science and Commerce College, Vinchur Dalvi",
  "ASPM COLLEGE OF PHARMACY, SANGULWADI",
  "  Bharatiya Gramin Punarrachana  Sansthas Mumbai Institute of Management & Research, J.K. Jadhav Knowledge Centre, Near MBPT Hospital, Wadala (E), Mumbai - 400037  ",
  "Karmaveer Hire Arts, Science, Commerce and Education College, Gargoti",
  "AHILYABAI HOLKAR ARTS AND SCIENCE COLLEGE",
  "Universe Public Collage (UPSC), Maregaon, Dist. Yavatmal",
  "SAHEBRAOJI BUTTEPATIL MAHAVIDYALAYA",
  "College of Physical Education, Udgir",
  "Dr. D.Y. Patil Unitech Society's Dr. D.Y. Patil Arts, Science & Commerce College, Akurdi, Pune 411044",
  "CHHATRAPATI SHIVAJI MAHARAJ ARTS AND SCIENCE COLLEGE",
  "JIVAN PRAGATI COMM.AND SCI. Sr College ",
  "SYMBIOSIS Statistical Institute",
  "P R Patil Institute of Pharmacy",
  "Trimurti Womens College of Science,Shevgaon",
  "SHETH T.J.EDUCATION SOCIETY'S SHETH N.K.T.T. COLLEGE OF COMMERCE AND SHETH J.T.T. COLLEGE OF ARTS",
  "SIR DR. M.S. GOSAVI COLLEGE OF PHYSIOTHERAPY AND HEALTH CARE MANAGEMENT, NASHIK",
  "Xavier Institute of Engineering, Mahim Causeway Mahim Mumbai-400 016",
  "Dr. D.Y. Patil Unitech Society's Dr. D.Y. Patil College of Education, Sant Tukaram Nagar, Pimpri, Pune 411018.",
  "Central Institute of Education,Gondia",
  "Vidarbha College Of Arts, Commerce & Science, Jiwati",
  "S Chandra Mahila Mahavidyalay Amgaon",
  "S Chandra Mahila Mahavidyalay, Sakoli",
  "Shri Sai Mahavidyalaya, Kurhadi",
  "Prachiti Mahila Mahavidyalay, Mohadi",
  "IDEAL INSTITUTE OF ARCHITECTURE",
  "IDEALCOLLEGE OF LAW",
  "IDEAL INSTITUTE OF PHARMACY",
  "SAHADEVRAO BHUTE KALA MAHAVIDYALAYA SALWA",
  "Shri Swami Vivekanand Shikshan Sanstha Sanchlit, Samajbhushan Ganpatrao Kalbhor College, Loni Kalbhor, Taluka - Haveli, District - Pune 412201.",
  "Dr. Ram Manohar Lohiya Institutions College of  Bio-Science and Technology",
  "SHIVRAJ MAHAVIDYALAYA, PIMPALGAON KOLTE",
  "C.B. Khedgis Basaveshwar Science, Raja Vijaysinh Commerce and Raja Jaysinh Arts College, Akkalkot",
  "College of Non Conventional Vocational Courses for Women, Kolhapur.",
  "Dr.D.Y.Patil College of Ayurved and Research Centre, Pimpri, Pune ",
  "DR.SHIVAJIRAO GHOGARE INSTITUTE OF OPHTHALMOLOGY",
  "Late Babasaheb Deshmukh Gorthekar, Arts, Commerce & Science College Umri",
  "Dr. D. Y. Patil Homoeopathic Medical College and Research Centre, Pimpri, Pune",
  "Chatrapati Shahu Education Society, Pachpimpli",
  "Bombay Bunts Associations Bunts Institute for Higher Education, Bunts Centre, Sector-24, Plot No.42, off. Gaondevi Chowk, Juinagar (W), Navi Mumbai-400706",
  "Nutan College of Engineering and Research",
  "NOOTAN HOMEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "Durgamata Bahuddeshiya Krida and Shaikshanik Sanstha Ishwar Deshmukh Institute of Pharmacy",
  "Saiprasad Mahavidyalaya Bhamragad",
  "Late. Rahulbhau Bommawar Mahavidyalaya Bhendala",
  "Vamanrao Ithape B. Sc. Nursing College, Sangamner",
  "SHRI HARIDASAN MAHILA MAHAVIDYALAYA",
  "Dr. Manorama and Prof. Haribhau Shankarrao Pundkar Arts, Commerece Science College, Balapur",
  "GODAVARI COLLEGE OF COMPUTER SCIENCE AND INFORMATION TECHNOLOGY, KOLPA, LATUR",
  "RAJARSHI SHAHU MAHARAJ AYURVED COLLEGE HOSPITAL AND RESEARCH CENTRE, BULDHANA  ",
  "Late. Ramraoji Dudhe Adhyapak Mahavidyalaya, Darwha",
  "RAJASHRI AYURVEDIC MEDICAL COLLEGE AND HOSPITAL MEHKAR",
  "Ahmednagar Jilha Maratha Vidya Prasarak Samajs Rajarshi Shahu Mahavidyalaya,Deolali,Pravara,Tal.Rahuri,Dist.Ahmednagar",
  "NAV MAHARASHTRA SHIKSHAN MANDALS ABASAHEB KAKADE COLLEGE OF B PHARMACY, BODHEGAON",
  "SHANTINIKETAN LALIT KALA AND NATYA TANTRA SHIKSHAN MAHAVIDYALAYA, SANGLI",
  "ARTS AND COMMERCE COLLEGE, KOYANANAGAR",
  "JMFs ACPM Dental College, Sakri Road, Dhule",
  "Dr. Vaishampayan Memorial Govt. Medical  College, Solapur",
  "KONARK IDEAL COLLEGE OF SCIENCE and COMMERCE",
  "KISHOR R PATIL COLLEGE (ARTS & B Sc (IT))",
  "GAJANANRAO PANDURANG PATIL COLLEGE OF ARTS AND SCIENCE",
  "REGAL COLLEGE OF HOTEL and TOURISM MANAGEMENT",
  "D. E. Society's Smt. Subhadra K. Jindal College of Nursing, Pune",
  "VITTALRAO SHINDE ARTS MAHAVIDYALAYA TEMBURNI TAL-MADHA  DIST-SOLAPUR",
  "WALCHAND INSTITUTE OF TECHNOLOGY, SOLAPUR",
  "Rajashree Chhatrapati Shahu Maharaj Govt. Medical College, Kolhapur",
  "250108- SWODDHARAK VIDYARTHI SANSTHA SRIMANT RAJE DAULATSINGJI RAWAL B.ED COLLEGE, DONDAICHA, TAL SHINDKHEDA, DHULE",
  "SHREE ANANT SMRITI CHARITABLE TRUST INSTITUTE OF PHYSIOTHERAPHY KASAL",
  "KALAVATI INSTITUTE OF MANAGEMENT",
  "ST PAUL COLLEGE OF PHARMACY, NAGPUR",
  "JAYKRANTI SHIKSHAN PRASARAK MANDAL, SHIVAJIRAO PATIL KAVEKAR COLLEGE OF PHARMACY, LATUR",
  "BHAGWAN MAHAVIDYALAYA, CHAITANYANAGAR, PARBHANI",
  "NATH MAHAVIDYALAY",
  " LOKMANYA TILAK INSTITUTE OF PHARMACY",
  "Shri Chankya Education Societys Indira College of Pharmacy, Tathawade, Pune 33",
  "GLOBAL VISION ARTS, COMMERCE AND SCIENCE COLLEGE",
  "SHANKARRAO MOHITE MAHAVIDYALAYA, AKLUJ TAL.MALSHIRAS DIST-SOLAPUR",
  "K K MAHAVIDYALAY KOSAMTONDI TAH SADAK ARJUNI DIST GONDIA",
  "LATE DEVRAO DIGAMER VARAT COLLEGE OF PHARMACY SAKAT ",
  "LATE V C V SUBBAREDDY DEGREE COLLEGE NANDAFATA",
  "Shri. N.K.D. Charitable Trusts Nalasopara Ayurved College, Nalasopara(E), Tal. Vasai,  Palghar",
  "Sonopant Dandekar Shikshan Mandalis Womens College of Commerce Palghar",
  "HON. BHAGYALAXMI T BAVISKAR INSTITUTE OF MANAGEMENT RESEARCH AND DEVELOPMENT, DAHIWAD, SHIPRUR",
  "DR. G.D.POL FOUNDATIONS YMT COLLEGE OF PHYSIOTHERAPY",
  "ADITYA INSTITUTE OF PHARMACY CHALISGAON",
  "Sarojini College of Pharmacy, Kolhapur",
  "Sonajirao Kshirsagar Homoeopathy College, Beed",
  "Deogiri Pratishthan Sanchalit Tulsi Computer Science and Information Technology College Beed.",
  "Sonopant Dandekar Shikshan Mandalis Law College Palghar",
  "COLLEGE OF AGRICULTURE, HATTA TQ VASMAT DIST HINGOLI",
  "TRIMURTI GRAMIN PHARMACY COLLEGE",
  "100066-Dhanaji Nana Chaudhari Vidya Prabodhini Sanchalit Shirish Madhukarrao Chaudhari College, Jalgaon",
  "GRAMIN SHIKSHAN PRASARAK MANDALS, GRAMIN TECHNICAL & MANAGEMENT CAMPUS, VISHNUPURI, NANDED",
  "Kolhapur Institute of Technology's Institute of Management Education and Research, GOKUL-SHIRGAON, Kolhapur",
  "Laddhad College of Pharmacy, Yelgaon",
  "SAU PARVATABAI TUKARAM PATIL COLLEGE, NERI NERI",
  "SHRI VIVEKANANDJI MESHRAM MAHAVIDYALAYA, DAWANIWADA",
  "Rajureshwar Senior College Nalni (Kd) (387)",
  "Atalbihari Vajpayee Homoeopathic Medical College and Hospital",
  "Yashodeep Institute of Pharmacy",
  "Dhirajlal Talakchand Sankalchand Shah College of Law",
  "Bhausaheb Mulak Ayurved Mahavidyalaya, Nagpur",
  "INDALA COLLEGE OF ENGINEERING",
  "SHRI SAI INSTITUTE OF PHARMACY AND RESEARCH",
  "SAHYADRI SHIKSHAN SANSTHAS GOVINDRAO NIKAM COLLEGE OF PHARMACY, SAWARDE, RATNAGIRI",
  "Dr. J. J. Magdum College of  Engineering, JAYSINGPUR",
  "Mahatma Gandhi Mission's Medical College,Aurangabad",
  "Rajgad Institute of Management Research and Development, S.No. 31,2,12-16, Opp. Dhankawadi Post Office, Dhankawadi, Pune 411043",
  "COLLEGE OF FORESTRY",
  "D Y Patil College of Physiotherapy Kolhapur",
  "SARASWATI KALA MAHAVIDYALAYA DAHIHANDA AKOLA",
  "SOU. VASUDHATAI DESHMUKH COLLEGE OF FOOD TECHNOLOGY AMRAVATI",
  "JIJAU INSTITUTE OF ENGINEERING TECHNOLOGY AND MANAGEMENT",
  "SRUJAN FOUNDATIONS G D BURKULE INSTITUTE OF RESEARCH AND EDUCATION IN PHARMACEUTICAL SCIENCES",
  "ASVMs Bhimashankar Ayurved College",
  "LATE MRS HOUSABAI HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL NIMSHIRGAON",
  "\"Mangaon Shikshan Prasarak Mandal's Ashokdada Sable Law College\" Near Dist. Court, Old Mangaon, Tal. Mangaon, Dist. Raigad-402104",
  "SHRI SAI INSTITUTE OF NURSING AND MEDICAL SCIENCE, WAKADI",
  "SMT. RADHIKABAI MEGHE MEMORIAL COLLEGE OF NURSING",
  "TIRUPATI ARTS COMMERCE SCIENCE COLLEGE WASHIM",
  "Vasantdada Patil Ayurvedc Medical College and Institute of Yoga Sangli",
  "Sree Narayana Mandira Samiti's Sree Narayana Guru Adhyapak Vidyalaya",
  "NASHIK COLLEGE OF PHYSIOTHERAPY",
  " Aurangabad College Of Physiotherapy Aurangabad",
  "Shree Mahavir Education Society’s Shree Mahavir Institute of Pharmacy",
  "School of Pharmacy and Research Centre, Baramati",
  "Sardar Patel Arts And Commerce College Mohada",
  "B R Harne Ayurvedic Medical College",
  "ALICE LAW COLLEGE ",
  "SARASWATI MAHILA MAHAVIDYALAYA",
  "Samarth College of Pharmacy",
  "shivanjali college of nursing pachegaon",
  "Dr. D.Y. Patil Unitech Society's Dr. D.Y. Patil Arts, Commerce & Science Women's College, Sant Tukaram Nagar, Pimpri, PUNE - 411018",
  "Pravara Rural Education Society's College of Pharmacy (For Women), Chincholi, Taluka - Sinnar, District - Nashik",
  "New Heritage Education Trusts R R International School and College",
  "P.V.D.T. College of Education for Women",
  "Smt. Mankaranabai Vinayakrao Marathe Women's College of Education",
  "Dr. Vithalrao Vikhe Patil Foundations College of Physiotherapy, Ahmednagar.",
  "Dadasaheb Dhanaji Nana Choudhary Social Work College, Malkapur",
  "Laxmibai Kawalc Varishta Kala Mahavidyalaya, Akola bazar,Tq. Yavatmal.",
  "Govt.Vidarbha Institute of Science & Humanities, Amravati.",
  "Anjuman Ishat-e-Taleem Beed's, Milliya Arts, Science and Management Science College, Beed, M.S., India",
  "NCIT India's IIBM College of BBA and BCA Chinchwad, Pune 19",
  "Mahadevrao B.Ed. College, Turkewadi,",
  "Ahmednagar Jilha Maratha Vidya Prasarak Samajs New Arts,Commerce & Science College, Ahmednagar 414001",
  "Pravara Institute of Research and Education in Natural and Social Sciences Pirens, Institute of Business Management and Administration IBMA, At-Po. Loni Bk., Tal. Shrirampur, Dist.Ahmednagar 413736",
  "Maratha Vidya Prasarak Samajs Law College , Udoji Maratha Boarding Campus, Beside MVP Semajs K.B.G.T. College of Engineering, Gangapur Road, Nashik, Maharashtra, India-422013.",
  "The Bombay Saint Paul Society s St Pauls College for Women",
  "New Horizon Education Society's New Horizon Institute of Technology and Management, Anand Nagar,Kavesar, Off. Ghodbunder Road, Thane (West)-400615",
  "Shri Amolak Jain Vidya Prasarak Mandal's Smt. Shantabai Kantilal Gandhi Arts, Amolak Science and Panalal Hiralal Gandhi Commerce College, Kada, Ashti",
  "Ritambhara Vishva Vidyapeeth's Malini Kishor Sanghvi College of Commerce & Economics, Shri Jitendra Mafatlal Mehta Educational Complex Plot No A 12  18  JVP D Scheme  Mora Village Road  Vile Parle  West  Mumbai  400 049",
  "Rayat Shikshan Sansthas R.B.Narayanrao Borawake College, Shrirampur, Dist.Ahmednagar 413709",
  "Pune District Education Association's Law College, Annasaheb Magar College Campus, Hadapsar, Pune 411014",
  "Shri Shivaji Shikshan Prasarak Mandals College of Education,Saswad, Tal. Purandar, Dist. Pune 412301",
  "Vidya Vikas Education Society Vikas College of Arts, Science & Commerce, Kannamwar  Nagar-2, Vikhroli (E), Mumbai-400 083  ",
  "Parth  Vidya Prasarak Mandals Babuji Avhad Mahavidyalaya Arts & Commerce, Pathardi,Dist. Ahmednagar  414102",
  "Suhrud Mandals Pandurang Shyamrao Mulgaonkar Vishesh Adhyapak Mahavidyalaya, Pune 19",
  "Dr. D. Y. Patil Pratishthan's, D.Y. Patil College of Engineering, Akurdi, Pune",
  "Acharya Atre Development Trust Purandar's Sharadchandraji Pawar College, Jejuri, Chinchbaug, Taluka - Purandar, District - Pune 412303",
  "Lokhit B.P.Ed. College, Yavatmal.",
  "Shri Shahu Mandir Mahavidyalaya, Parvati Ramana, Pune  411009",
  "New Education Society's Shriram Kusumtai Sadashiv Vanjare College, Lanja, Zapade-Kante Road, Tal. Lanja Dist. Ratnagiri",
  "College of Agriculture, Pathri",
  "Shri Neminath Jain Brahmacharyashrmas Gurukul Shriman Sureshdada Jain College of Pharmacy, Chandwad, Dist.Nashik 423101",
  "Audyogik Tantra Shikshan Sansthas Institute of Industrial and Computer Management and Research, Nigdi, Pune 411044",
  "Padamshri. Dr.Vitthalrao Vikhe Patil Foundations Padamshri. Dr.Vitthalrao Vikhe Patil College of Engineering, Vilad Ghat,  Ahmednagar 414111",
  "Night College of Arts & Commerce,  Industrial Estate, ICHALKARANJI-416115      Tal-Hatkanangale,Dist-Kolhapur",
  "Night College of Arts & Commerce,Azad Chowk,",
  "Narayandas Sarwottamdas Soti Law College, Sangli.",
  "Rajarambapu Institute of Technology, Rajaramnagar, SAKHARALE",
  "SYMBIOSIS ARTIFICIAL INTELLIGENCE INSTITUTE",
  "Shahaji Law College, 1090, E Ward, Shahupuri,",
  "Ramchandra Sanskritik Krida Mandal's Bharat College of Physical Education.",
  "G.D. College of Food Technology Mohol, Solapur.",
  "Aldel Education Trust St. John College of Humanities and Sciences St. John Technical Campus, Veroor, Manor Road, Palghar (E), Dist. -Palghar -401404",
  "Rajasthani Sammelan Education Trust Ghanshyamdas Saraf College of Arts and Commerce, Sarvodaya Balika Vidyalaya Bhavan, Smami Vivekanand Road, Malad (West), Mumbai - 400 064",
  "Sau. Mangaltai Ramchandra Jagtap Mahila Mahavidyalaya, UMBARJ",
  "Dr Ulhas Patil Homoeopathic Medical College and Hospital, Jalgaon",
  "Shivajirao Deshmukh Shikshanshastra Mahavidyalaya, SHIRALA",
  "Shri. Yashawantrao Patil Science College, Solankur",
  "Venkateshwara Institute of Management, Peth Naka",
  "KAUSHALYA DEVI WOMEN COLLEGE KORCHI",
  "Saraswatibai Jambhulkar Mahavidyalay Wardha",
  "Late Rupeshkumar Ingole College of Management Technology, Yavatmal",
  "DATTA MEGHE AYURVEDIC COLLEGE, HOSPITAL AND RESEARCH CENTRE",
  "Mariya Arts and Science College, Deoli",
  "Matoshri Ashatai Kunawar Arts Commerce and Science Womens College, Hinganghat",
  "SHRI GULABRAO DEOKAR COLLEGE OF PHARMACY",
  "Yashwantrao Chavan Mahavidyalaya,  PACHAWAD",
  "Kewalramji Harde Mahavidyalaya, Chamorshi",
  "Mohsinbhai Zaweri Mahavidyalaya, Desaiganj (Wadsa)",
  "H H SRI SRI MURALIDHARA SWAMIJI COLLEGE OF AGRICULTURE, MALEGAON",
  "KK WAGH COLLEGE OF AGRICULTURE BUSINESS MANAGEMNET, SARASVATINAGAR",
  "Anekant Education Societys Anekant Institute of Management Studies, C o. Tuljaram Chaturchand College Campus, Baramati, Dist. Pune 413102",
  "ARIHANT INSTITUTE OF BUSINESS MANAGEMENT, Bavdhan, Pune",
  "AUDYOGIK SHIKSHAN MANDAL'S INSTITUTE OF PROFESSIONAL STUDIES, Chinchwad, Pune",
  "K.B.H.S.S. Trust's  Dr.B.V. Hiray College of Management & Research Centre, Address: Krushi Nagar, Malegaon Camp, Malegaon, Taluka: Malegaon District: Nashik",
  "Modern Education Society's Neville Wadia Institute of Management Studies and Research, V.K.Joag Path, Pune 411001",
  "SAMARTH RURAL EDUCATIONAL INSTITUTE, RAJURIs SAMARTH GROUP OF INSTITUTIONS FACULTY OF MANAGEMENT, JUNNAR",
  "Sindhudurg Shikshan Prasarak Mandal's College of Engineering, Kankavli",
  "Zeal Education Societys Zeal Institute of Management and Computer Application, Narhe",
  "Padmashri Dr. D.Y.Patil Institute of Pharmaceutical Science and Research, Pimpri, Pune 411018",
  "Mahila Shikshanshastra Mahavidyalay, Chandrapur",
  "KDMGs Ayurved Medical College, Chalisgaon",
  "Agnel School of Law",
  "MATOSHRI COLLEGE OF SCIENCE",
  "NOBLE INSTITUE OF MEDICAL SCIENCES, COLLEGE OF PHYSIOTHERAPY, HADAPSAR PUNE",
  "SHRIMATI NARSAMMA ARTS, COMMERECE AND SCIENCE COLLEGE, KIRAN NAGAR, AMRAVTI",
  "Hanuman Shikshan Prasrak Mandals Ayur. Medical College, Peth Vadgaon, Kolhapur",
  "Samarth Institute of Pharmacy",
  "DATTA MEGHE COLLEGE OF NURSING",
  "Institute of Nursing Education and  Research pune",
  "Swami Vivekananda Arts and Commerce College Jamner",
  "AL AMEEN UNANI MEDICAL COLLEGE AND HOSPITAL",
  "VIVA College of Law",
  "B K Birla Night Arts Science and Commerce College Kalyan",
  "Rashtrasant Janardhan Swami College of Nursing",
  "Pravara Rural Education Society's Women's College of Home Science and BCA, A/p. Loni kd., Taluka - Rahata, District - Ahmednagar 413713",
  "Solapur Education Societys College of Architecture Solapur",
  "P G College of Pharmaceutical Science and Research",
  "Dr. Vasantrao Pawar Medical College, Hospital & Research Centre, Adgaon naka, Nashik",
  "260049 - Adhyapak shiksha Mandal's C.H.C Arts, S.G. Patel Commerce & Babaji B.J.Patel Science College, Taloda, District-Nandurbar-425413",
  "SJPE. Homoeopathy College, Kolhapur",
  "Chhatrapati Shahu Institute of Business Education and Research ,",
  "Janata Shikshan Sanstha's Kisan Veer Mahavidyalaya, Wai",
  "Kanya Mahavidyalaya, Miraj, Dist. Sangli",
  "Krishna Mahavidyalaya, Rethare Bk, Shivnagar, Tal. Karad, Dist. Satara",
  "Late.Ramrao Nikam B.Ed. College,  Indoli,",
  "Dharampeth M.P. Deo Memorial Science College",
  "Karmaveer Kakasaheb Wagh Education Society's Karmaveer Kakasaheb Wagh Arts, Commerce, Science and Computer Science College, Chandori, Taluka - Niphad, District - Nashik 422201",
  "Arts and Commerce College, Pusegaon Tal-Khatav Dist Satara",
  "Deshbhakta Anandrao Balwantrao Naik Arts and Science College,Yashwantnagar,  CHIKHALI",
  "College of Home Science Nirmala Niketan",
  "B.Ed. College, PATAN",
  "Renukadevi Shikshan Prasarak Mandal's,  Arts, Commerce, Science Senior College, Kukane, Tal. Malegaon,Dist. - Nashik - 423203. ",
  "Seva Nursing Institute, Dhule",
  "SAIKRUPA INSTITUTE OF PHARMACY",
  "THE NATIONAL INSTITUTE OF BUSINESS EDUCATION",
  "B G COLLEGE OF CIVIL SERVICES",
  "MATOSHRI SONABI GOSWAMI MAHAVIDYALAY TEDHA",
  "LATE SHOBHATAI MANIKRAO DESHMUKH MAHAVIDYALAYA",
  "UNIVERSAL PUBLIC SERVICE COLLEGE",
  "Shetkari Unnati Mandal's Smt. Pushpalata Madhukar Madhvi Mahavidyalaya, At Post-Kalher, Tal.-Bhiwandi, Dist.-Thane-421302",
  "Parth Arts and Science College Ner Rathod Nagar TaDist Jalna",
  "Dnyanvardhini Education Society's Mumbai College of Management Studies, B-12, Saraswati Building, Maheshwari Bhavan Road, Mira-Bhayander (W), Dist.-Thane-401104",
  "Adarsh Prashaskiya Seva Mahavidyalaya ",
  "Gondwana Prashaskiya Seva Mahavidyalaya",
  "Shri Sant Gajanan Prashaskiya Seva Mahavidyalaya",
  "Navi Mumbai College New Panvel",
  "SHRI B K SOCIAL WORK MAHAVIDHYALAYA DEOLI",
  "Raigad College Of Pharmacy, Mohopre ",
  "SURYADATTA INSTITUTE OF FASHION TECHNOLOGY SIFT",
  "Swa Shri Mallaji Atram Arts College Jarawandi",
  " Harsiddhi Arts commerce  Science College Aurangabad ",
  "ASHOKRAO MANE INSTITUTE OF PHARMACY AMBAP",
  "RAVIDNRANATH TAGOR ARTS AND SCIENCE COLLEGE GALLE BORGAON",
  "Sant Gajanan Maharaj Ayurved Medical College Mahagaon",
  "RASHTRASANT JANARDHAN SWAMI COLLEGE OF PHARMACY",
  "Habib Educational & Welfare Societys M.S.College of Pharmacy, Survey No. 120, Devghar, Taluka Wada, Dist. -Palghar-401404",
  "MES COLLEGE OF PERFORMING ARTS",
  "Swa Wacchalabai Mamulkar Prashaskiya Seva Mahavidyalaya",
  "SHRI  VASNATDADA DESHMUKH BA CIVIL SERVICES COLLEGE",
  "Yashwant Redekar College Of Pharmacy B Pharm and D Pharm Nesari",
  "Balwantrao Chavan College Of Pharmacy Naigaon",
  "Ashokrao Mane College of Pharmacy,Peth-Vadgaon",
  "Arts & Comm. College, NAGTHANE",
  "Ashvin Rural Ayurved College, Sangamner",
  "R.A. Podar Ayurved Mahavidyalaya, Worli, Mumbai",
  "Br. Nath Pai Shikshan Sansthas Br. Nath Pai College of B.Sc. Nursing, Kudal, Dist. Sindhudurga",
  "Sadhu Vaswani College of Nursing (B.Sc.), Pune",
  "Dhanwantari Ayurved Medical College & Hospital, Deglour Road, Tal. Udgir, Dist. Latur-413517",
  "Institute of Nursing Education, J.J. Group of Hospital, Mumbai (P.C.B.Sc)",
  " Shriram Mahila Vidnyan Mahavidyalaya, Paniv",
  "MAEER MITs MIMER Medical College, Talegaon-Dabhade, Tal. Maval,  Pune",
  "JMFs A.C.P.M. Medical College, Sakri Road, Dhule",
  "Smt. C.M. Patel Homoeopathy College, Vile Parle, Mumbai",
  "MAHATMA PHULE PHARMACY COLLEGE BABHULGOAN AKOLA",
  "TERNA PADMAYOG SADHANA COLLEGE",
  "K. J. Somaiya College of Physiotherapy, Sion, Mumbai.",
  "Purushottam Das Bagla Homoe College, Chandrapur",
  "Shri. Beleshwar Shikshan Prasarak Mandals Beleshwar Institute of Nursing (B.Sc.), Parbhani",
  "SHAHID BIRSA MUNDA MAHAVIDYALAYA KORCHI TA KORCHI DISTRICT GADCHIROLI",
  "THEEM COLLEGE OF ARTS, COMMERCE AND SCIENCE",
  "Bel-Air College of Nursing (B.Sc.), Bel-Air Hospital, Panchgani, Dist-Satara",
  "SHRIMAN SHRI VALLABHJI AND SMT DHANIBAI CHANDAK TRUST SANSKRIT MAHAVIDYALAY AMBAPETH AMRAVATI",
  "Radhakrishna Toshniwal Ayurved Mahavidyalaya, Akola",
  "College of Nursing, P.D. Hinduja National Hospital & Medical Res. Centre Andheri (E) Mumbai",
  "C.H. Keluskar Homoeopathy College, Alibag",
  "Swatantra Senani Uttamraoji Patil Nursing College, Shivaji Nagar East, Garkheda Campus, Sambhajinagar",
  "Smt. K.G. Mital Punarvasu Ayurvedic Mahavidyalaya, Charni Road, Mumbai",
  "Shree Saptashrungi Ayurved Mahavidyalaya & Hospital, Kamal Nagar, Hirawadi, Panchavati, Nashik-422003",
  "Smt. Vimladevi Ayurvedic Medical  College & Hospital At. Po. Tadali, Village Wandhari, Dist. Chandrapur-442406",
  "Venutai Chavan Homoeopathy College, Kolhapur",
  "Deep Paramedical Organisations Nett College of Physi., Owala, P.O. Kasarvadavli, Thane",
  "Virar Homoeopathic Medical College, Vir Savarkar Marg, Virar (E), Tal. Vasai, Dist. Thane",
  "Shri Swami Vivekanand Shikshan Sanstha s Savitribai Phule College of Nursing, Kolhapur",
  "Bhaisaheb Sawant Ayurved Mahavidyalaya, Sawantwadi, Dist. Sindhudurga",
  "Sidhakala Ayurved Mahavidyalya, Sangamner",
  "Vidarbha Ayurved Mahavidyalaya, Amravati",
  "Late Shri. Yashwantrao Chavan memorial Medical & Rural Developmet Foundation s Dental College & Hospital, Ahmednagar",
  "Abhinav Education Societys College of Pharmacy, Pune",
  "D.M.M. Ayurved Mahavidyalaya, Yavatmal",
  "RAJMATA JIJAVU SENIOR COLLEGE KARMAD",
  "Sanmarg Shikshan Sansthas Shri. K.R. Pandav Ayurved College & Hospital, Bahadura, Nagpur",
  "SHRI D.D. VISPUTE COLLEGE OF SCIENCE COMMERCE AND MANAGEMENT, RAIGAD",
  "Shri Bahagwan Homoeopathy College, Aurangabad",
  "Pen Education Societys Bhausaheb Nene Arts  Science and Commerce College  Pen  Dist Raigad  402 107",
  "Suman Education Society's LN College H.D. Gaonkar Vidya Sankul, Suman Education Society Campus, Plot No. 89, Near General Kariappa Bridge, Rajendra Nagar, Borivali (East), Mumbai - 400066",
  "Lok Dnyan Prasarak Sanstha, Chandrapurs Niharika College of Physiotherapy, Isasani, Tal. Hingana, Dist. Nagpur",
  "NETAJI SUBHASHCHANDRA BOSE MAHAVIDYALAY BORALA TQ VASMAT DIST HINGOLI    ",
  "MATOSHRI SENIOR COLLEGE PARBHANI    ",
  "Tulsiramji Gaikwad-Patil College of Engineering and Technology, Nagpur.",
  "MAHATMA PHULE SENIOR COLLEGE GHATPURI TAL KHAMGAON DIST BULDHANA    ",
  "UNION EDUCATION SOCITIES MAHILA MAHAVIDYALAYA 141 -A SIDDHESHWAR  PETH  . SOLAPUR",
  "BHAKTIVEDANTA RESEARCH CENTER    ",
  "FR.C.RODRIGUES INSTITUTE OF MANAGEMENT STUDIES",
  "ADITYA EDUCATIONAL FOUNDATIONS JADHAVAR COLLEGE OF LAW ",
  "MOKASHI COLLEGE OF FOOD TECHNOLOGY, KARAD",
  "B V COLLEGE OF HORTICULTURE, SONSAL HINGANGAON",
  "DR A D SHINDE COLLEGE OF ENGINEERING",
  "Dr D Y Patil Prathisthan College of Engineering Salokhe-Nagar Kolhapur",
  "PADMASHREE DR D Y PATIL COLLEGE OF AGRICULTURE BUSINESS MANAGEMENT, AKURDI,PUNE-44",
  "Govt. Ayurved Mahavidyalaya, Nanded",
  "MARATHWADA MITRA MANDALS M M COLLEGE OF PHYSIOTHERAPY PUNE    ",
  "SHRI SAMBHAJI COLLEGE OF NURSING    ",
  "KASTURBA GANDHI VIDNYAN MAHILA MAHAVIDYALAYA SHIRUR",
  "KES Vengurla Homoeopathy College, Vengurla",
  "LATE SHRI VISHNU WAMAN THAKUR CHARITABLE TRUST VIVA INSTITUTE OF PHARMACY",
  "S M B T INSTITUTE OF MEDICAL SCIENCES & RESEARCH CENTRE, IGATPURI",
  "SMT M P KOTHARI MAHILA MAHAVIDYALAY NANDURA    ",
  "COLLAGE OF AGRICULTURE, KARAD",
  "COLLEGE OF HORTICULUTRE, SHIVAJINAGAR",
  "LOKMANGAL COLLEGE OF AGRICULTURE, WADALA",
  "LOKMANGAL COLLEGE OF AGRICULTURAL BIOTECHNOLOGY, WADAL",
  "COLLEGE OF AGRICULTURE, PHALTAN",
  "SHREEMANT SHIVAJIRAJE COLLEGE OF HORTICULTURE, PHALTAN",
  "LMK COLLEGE OF AGRICULTURE, KADEGAON",
  "COLLEGE OF AGRICULTURE BUSINESS MANAGEMENT, BARAMATI",
  "GRAMONNATI MANDALS COLLEGE OF AGRICULTURE BUSINESS MANAGEMENT",
  "H H SRI SRI MURLIDHARA SWAMIJI COLLEGE OF HORTICULTURE",
  "K K WAGH COLLEGE OF AGRICULTURE, NASHIK",
  "ROSHANBI SHAMANJI COLLEGE OF AGRICULTURE, NESARI",
  "SAIKRUPA COLLEGE OF AGRICULTURE, GHARGAON",
  "COLLEGE OF AGRICULTURAL BIOTECHNOLOGY, MADADGAON",
  "Alfa Social And Educational Foundations Dhanwantary Arts And Science College, Address: Dhawalpuri Taluka: Parner District: Ahmednagar Pincode: 414103  ",
  "SHIVAJIRAO PAWAR COLLEGE OF AGRICULTURE    ",
  "Progressive Education Society's B.Ed.College, Near M.I.B.M., Shivajinagar, Pune 5",
  "VASUNDHARA MAHILA MAHAVIDYALAY, TAKLI KUMBHKARN    ",
  "TULASKAR COLLEGE OF PHARMACY, HINGANGHAT    ",
  "SHOBHA BABAR INSTITUTE OF NURSING     ",
  "Matushri Kanbai Lalbai & Motibai Lohana Kanyashala & Balikagruh's B.L. Amlani College of Commerce & Economics, M.R. Nathwani College of Arts, N.S. Road No. 6, (Next to Jamanabai Narsee School,Gate No. 4), J.V.P.D. Scheme,Vile Parle (W),Mumbai-400056",
  "CHHATRAPATI SHAHU MAHILA MAHAVIDYALAY    ",
  "MATOSHRI INSTITUTE OF TECHNOLOGY    ",
  "ANANDI SHIKSHAN PRASARAK MANDAL KALAMBE TARF KALE  POST KOPARDE  TAL KARVEER DIST KOLHAPUR SANCHALIT  ANANDI INSTITUTE OF NURSING KALAMBE TARF KALE TAL KARVEER DIST KOLHAPUR    ",
  "SHRI AMBABAI TALIM SANSTHAS INSTITUTE OF NURSING MIRAJ    ",
  "SES DAYAL ASHA LAW COLLEGE     ",
  "SHREEYASH AYURVEDIC COLLEGE AND HOSPITAL RESEARCH CENTER    ",
  "SOCIETY OF ST FRANCIS INDUSTRIAL INSTITUTES ST FRANCIS DEGREE COLLEGE    ",
  "COLLEGE OF AGRICULTURE, NANDURBAR",
  "COLLEGE OF AGRICULTURE, AKLUJ",
  "Kevalramji Harde College of Agriculture, (Chamorshi)",
  "Government College of Art and Design, Chhatrapati Sambhajinagar",
  "JIJAMATA WOMENS COLLEGE OF AGRICULTURE, MANDKIPALVAN    ",
  "Marathwada Shikshan Prasarak Mandal's Rajmata Jijau Mahavidyalaya, Kille-Dharur, Dist. Beed",
  "BHAUSAHEB PHUNDKAR GOVERNMENT AGRICULTURE COLLEGE, BULDHANA",
  "NAVSAHYADRI EDUCATION SOCIETY NAVSAHYADRI SENIOR COLLEGE, AT NAYGAON, TAL BHOR, DIST PUNE",
  "DR. ARCHANATAI GADE PATIL COLLEGE OF NURSING YAVATMAL",
  "SANGAMESHWER COLLEG SOLAPUR DIST-SOLAPUR",
  "GANGABAI TALMALE ART, COMMERCE AND SCIENCE COLLEGE, BRAMHAPURI",
  "VIVEKANAND VARISTHA MAHAVIDYALAYA, BEMBAL",
  "Anjuman I Islams Akbar Peerbhoy College of Education, Vashi, Navi Mumbai",
  "170111-PDUSPM'S INSTITUTE OF MANAGEMENT & RESEARCH, JAMNER",
  "DR ULHAS PATIL COLLEGE OF FOOD TECHNOLOGY, JALGAON",
  "DR ULHAS PATIL COLLEGE OF AGRICULTURE, JALGAON",
  "DR ULHAS PATIL COLLEGE OF AGRICULTURAL ENGINEERING & TECHNOLOGY, JALGAON",
  "110102-KYDSCT'S COLLEGE OF PHARMACY, SAKEGAON-BHUSAWAL",
  "220028-JIJAMATA EDUCATION SOCIETY'S ARTS, SCIENCE AND COMMERCE COLLEGE, NANDURBAR TAL-NANDURBAR",
  "Ravikant Ragit Prashaskiya Mahavidyalaya, Ramtek",
  "200008-DES'S COLLEGE OF EDUCATION, DHULE.",
  "250044-SVS'S ARTS & SCIENCE COLLEGE, DONDAICHA, TAL SHINDKHEDA, DHULE",
  "MAHATMA FULEY M.S.W AND MATOSHREE ZAVERIBEN MOTILAL TURKHLYA B.S.W. COLLEGE, TALODA, DIST-NANDURBAR",
  "150026-JDMVP CO-OP S'S ARTS,COMMERCE & SCIENCE COLLEGE, YAWAL.",
  "240093-THE SHIRPUR EDUCATION SOCIETY'S H.R.PATEL INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH, SHIRPUR",
  "200007-WKDSPM'S DR.BABASAHEB AMBEDKAR MEMORIAL COLLEGE OF LAW, DHULE",
  "110109-LATE DAGADABAI CHAMPALALJI BIYANI SHAIKSHANIK VIKAS, BHUSAWAL, SANCHALIT BIYANI B.ED COLLEGE AT. MIRGAVHAN, NEAR GOVT. ITI, JAMNER ROAD, BHUSAWAL, JALGAON 425201",
  "200111-SS&SS'S VIDYADHAN COMMERCE COLLEGE,VALWADI, DHULE",
  "200001-JAI HIND ET'S ZULAL BHILAJIRAO PATIL COLLEGE, DHULE.",
  "110012-TES'S BHUSAWAL ARTS,SCIENCE & P.O.NAHATA COMMERCE COLLEGE, BHUSAWAL.",
  "230065-PSGVPM'S COLLEGE OF PHARMACY, SHAHADA, DIST-NANDURBAR.",
  "100002-J.D.M.V.P. SAMAJ'S SHRI S. S. PATIL ARTS, SHRI BHAUSAHEB T.T. SALUNKHE COMMERCE AND SHRI G. R. PANDIT  SCIENCE COLLEGE, JALGAON TAL. JALGAON DIST. JALGAON",
  "230032-PSGVPM'S D.N.PATEL COLLEGE OF ENGINEERING, SHAHADA, DIST-NANDURBAR.",
  "200019-NES'S GANGAMAI COLLEGE OF EDUCATION, NAGAON, TAL.& DIST-DHULE.",
  "180036-MUKTAINAGR TALUKA EDUCATION SOCIETY'S,SHRIMATI GODAVARIBAI GANPATRAO KHADSE COLLEGE, MUKTAINAGAR",
  "200006-DES'S M.D.PALESHA COMMERCE COLLEGE, DHULE.",
  "100081-GODAVARI FOUNDATION'S GODAVARI INSTITUTE OF MANAGEMENT & RESEARCH JALGAON",
  "220052-NTVS'S COLLEGE OF EDUCATION, NANDURBAR.",
  "190097-SSPM'S COLLEGE OF EDUCATION, TEHU, TAL.PAROLA",
  "100090-GODAVARI FOUNDATIONS'S DR.ULHAS PATIL LAW COLLEGE, JALGAON TAL. JALGAON DIST.JALGAON",
  "SHRI DATTA SHIKSHAN PRASARAK MANDAL SAMBHJIRAJE COLLEGE OG MANAGEMENT SCI, Shirur Kasar.",
  "190041-PTSS'S SAU. RAJNITAI N.DESHMUKH ARTS,COMMERCE & SCIENCE COLLEGE, BHADGAON.",
  "NAVJEEVAN NURSING COLLEGE CHANDRAPUR",
  "200013-ABHAY YUVA KALYAN KENDRA'S COLLEGE OF EDUCATION, DHULE TAL-DHULE DIST-DHULE.",
  "180038-JANTA SHIKSHAN MANDAL'S SANE GURUJI VIDYA PRABODHINI COMPREHENSIVE COLLEGE OF EDUCATION, KHIRODA TAL-RAVER DIST-JALGAON",
  "110088-K.NARKHEDE COLLEGE BHUSAWAL, Dist JALGAON",
  "150028 - TAPI VALLEY EDUCATION SOCIETY'S DHANAJI NANA MAHAVIDYALAYA, FAIZPUR.",
  "210067-NIJAMPUR JAITANE SHIKSHAN PRASARAK MANDALACHE, JAGANNATH KADWADAS SHAH ADARSH MAHAVIDYALAY, NIJAMPUR-JAITANE,TAL-SAKRI.",
  "Bharati Vidyapeeths Institute of Management and Information Technology , Sector-8 C B D  Belapur Navi Mumbai.",
  "210026-VIDYA VIKAS MANDAL'S SITARAM GOVIND PATIL ARTS,SCIENCE & COMMERCE COLLEGE, SAKRI. DIST. DHULE",
  "200004-SSVPS'S BAPUSAHEB SHIVAJIRAO DEORE COLLEGE OF ENGINEERING, DHULE.",
  "200095-NES'S GANGAMAI COLLEGE OF PHARMACY, NAGAON, DHULE.",
  "200002-SSVPS'S LATE KARMAVEER DR.P.R. GHOGREY SCIENCE COLLEGE, DHULE.",
  "200070-SSS'S DR.B.R.AMBEDKAR COLLEGE OF SOCIAL WORK, MORANE, TAL.&DIST-DHULE.",
  "240074-R.C.PATEL EDU.TRUST'S INSTITUTE OF MANAGEMENT RESEARCH&DEVELOPMENT, SHIRPUR",
  "100105-JAI DURGA BHAVANI KRIDA MANDAL'S OM SAI COLLEGE OF EDUCATION, SHIRSOLI",
  "190040-KVPS'S KISAN ARTS,COMMERCE & SCIENCE COLLEGE, PAROLA.",
  "100062-KHASHABA APANG KRIDA PRASHIKSHAN SANSHTA'S COMMERCE AND SCIENCE COLLEGE, JALGAON DIST JALGAON",
  "200110-SSS'S HAJI SAEED AHMAD SARDAR ARTS&SCIENCE COLLEGE, DHULE",
  "150051-TVES'S HON'BLE LOKSEVAK MADHUKARRAO CHAUDHARI COLLEGE OF PHARMACY, FAIZPUR.",
  "130020-CES'S BP.ARTS,SMA.SCIENCE & KKC.COMMERCE COLLEGE, CHALISGAON.",
  "220053-NANDURBAR TALUKA VIDHAYAK SAMITI'S G.T.PATIL ARTS, COMMERCE AND SCIENCE COLLEGE, NANDURBAR.",
  "200025-NES'S GANGAMAI COLLEGE OF ENGINEERING, NAGAON, TAL.& DIST-DHULE.",
  "100063-GF'S GODAVARI COLLEGE OF ENGINEERING, JALGAON",
  "Shri Surupsing Hirya Naik College of Education, Navapur",
  "110015-JDMVP CO-OP S'S ARTS,COMMERCE & SCIENCE COLLEGE, VARANGAON.",
  "100043-IES'S IQRA COLLEGE OF EDUCATION, MEHRUN.",
  "110059-HINDI SEVA MANDAL'S SHRI.SANT GADGE BABA COLLEGE OF ENGINEERING & TECHNOLOGY, BHUSAWAL",
  "230034-POOJYA SANE GURUJI VIDYA PRASARAK MANDAL'S COLLEGE OF EDUCATION SHAHADA NANDURBAR",
  "150056-SES'S ARTS & SCIENCE COLLEGE, BHALOD, TAL. YAWAL",
  "KHANDESH COLLEGE EDUCATION SOCIETY'S COLLEGE OF ENGINEERING AND MANAGEMENT, JALGAON",
  "PADMBHUSHAN VASANT DADA PATIL COLLEGE OF AGRICULTURE, PUNE",
  "Sadhu Vaswani Institute of Management Studies for Girls, 6, Koregaon Road, Pune 411001",
  "SAVITRIBAI PHULE WOMENS COLLEGE, PIMPALKOTHA    ",
  "BHART RATNA INDIRA GANDHI COLLEGE OF ENGINEERING  SOLAPUR,-PUNE NATIONAL HIGHWAY NO 9, GAT NO.58 3,KEGAON  DIST. SOLAPUR,",
  "S.N.D.T Womens University Law School",
  "LATE VIMALBAI KHANDELWAL MAHILA MAHAVIDYALAYA    ",
  "OAK MAHILA MAHAVIDYALAYA , NACHANGAON , TA DEOLI, DIST WARDHA",
  "PRIYADARSHINI SHAIKSHANIK  SAMAJIK VIKAS MANDALS JAYVANT HARCHANDRA LOKHANDE LAW COLLEGE",
  "BHAUSAHEB P H PATIL ARTS AND SCIENCE COLLEGE, DEVLI, JALGAON    ",
  "DEVI MAHALAXMI COLLEGE OF PHARMACY    ",
  "P K Technical Campus, Kadachiwadi, Chakan, Taluka - Khed, District - Pune 410501",
  "Sardar Babasaheb Mane Mahavidyalaya, Rahimatpur, Tal. Koregaon, Dist. Satara",
  "DR. BABASAHEB AMBEDKAR COLLEGE OF JOURNALISM AND SOCIAL WORK, AKOLA",
  "Humera Khan College of Education, Adjacent MHADA Colony, Pratiksha Nagar, Oshiwara, Jogeshwari (W), Mumbai  - 400 102",
  "Shivramji Pawar Gramin Instititus of Food Technology, Nehrunagar,Kandhar",
  "SYMBIOSIS School of Biological Sciences",
  "SYMBIOSIS School of Banking and Finance",
  "SYMBIOSIS Institute of Media and Communication",
  "SYMBIOSIS Institute of Design",
  "SYMBIOSIS College of Nursing",
  "SYMBIOSIS Centre for Media and Communication",
  "SYMBIOSIS Centre for Information Technology",
  "English Language Teaching Institute of SYMBIOSIS",
  "SDMVMs College of Food Technology, Aurangabad ",
  "Chhatrapati Shikshan Mandal's Arts & Commerce College, Padgha, Padgha at Padgha, Tal.  Bhivandi, Dist. Thane",
  "Laxmi College of Optometry",
  "Ramesh Phirodia College of Architecture",
  "Shri Vile Parle Kelvani Mandals Institute of Technology, Dhule",
  "Navsahyadri Institute of Pharmacy",
  "SYMBIOSIS School of Economics",
  "SYMBIOSIS School for Liberal Arts",
  "SYMBIOSIS Centre for Management Studies, Pune",
  "SEVA NURSING COLLEGE,SAKHAR KAMGAR HOSPITAL TRUST, SHRIRAMPUR.",
  "SHRI NAMDEO MOTIRAM MANGAONKAR ARTS AND COMMERCE SENIOR COLLEGE MOND",
  "PRAJASATTAK COLLEGE,NAGPUR",
  "PADMSHREE AJIT WADEKAR COLLEGE OF PHYSICAL EDUCATION, NAGPUR",
  "PADMAVATI ARTS AND SCIENCE COLLEGE, MOHADI, KANNAD.",
  "IAEER's Pune Institute of Business Management,  Address: Pirangut,  Taluka: Mulashi, District: Pune",
  "K. R. PANDAV MAHAVIDYALAYA",
  "SHIVSHAKTI MAHAVIDYALAYA ARTS, SCIENCE AND COMMERCE KAKANDI    ",
  "JIJAMATA ARTS COMMEREC AND SCIENCE COLLEGE NIPANI",
  "Rizvi Education Society Rizvi College of Law Bandra (West) Munbai 400 050",
  "The All India Khilafat Committees College of Education Khilafat House 173-175 Motishah Lane Byculla Mumbai  400 027",
  "Shri Chhatrapati Shivaji Education Society's Late Sau S. R. Abhang memorial College of Arts & Commerce Ulhasnagar, Padmashri Mohd., Rafi Marg, Netaji Section, Ulhanagar-421 004",
  "Government College of Education Ratnagiri Dist.  Ratnagiri",
  "Kunbi Shikshan Prasarak Sanstha Sanchalit,Senior College of Education, At-Post- Bharne,Tal-Khed, Dist- Ratnagiri,Pin - 415621",
  "Balasaheb Khardekar College  Vengurla  Dist Sindhudurg",
  "K J  Somaiya College of Arts & Commerce  Vidyanagar Campus  Vidyavihar Mumbai",
  "Parle Tilak Vidyalaya Associations Mulund College of Commerce Sarojini Naidu Road Mulund West  Mumbai",
  "Om Vidyalankar Shikshan Sansthas Asmita College of Arts & Commerce for Women  Knnamwar Nagar No 2  Vikhrol Mumbai  400 083",
  "Sahyadri Shikshan Sansthas Arts and Science College Sawarde, At Post Sawarde,Tal. Chiplun, Dist. Ratnagiri-415606",
  "Sir J J Institute of Applied Art Dr D N Road Mumbai  400 001 (Applied Art)",
  "K P B  Hinduja College of Commerce, New Charni Road, Mumbai",
  "Suman Education Trust Dilkap Research Institute of  Engineeing  & Management Studies Village Mamdapur Post Neral Tal Karjat Dist  Raigad 410 101",
  "Chembur Sarvankash Shikshanshastra Mahavidyalaya Near Chembur Ramkrishna Chemburkar Marg Chembur Mumbai 400071",
  "Thakur Educational Trusts Thakur Shyamnarayan College of Eduction & Research Thakur Village, Kandivli (E) Mumbai 400 101",
  "Bab-E-Rahmat Education Trusts St. Marys B.Ed.College  Kausa Mumbra Dist  Thane",
  "Mahatma Gandhi Missions Law College Plot No14 C B D Belapur Navi Mumbai 400 614",
  "Oriental Educational Societys Oriental College of Education & Research Oriental Building Adarsh Nagar Behind Lotus Petrol Pump Andheri (West) Mumbai 400 102",
  "Parle Tilak Vidyalaya Associations M L Dahanukar College of Commerce Dixit Road Vile Parle East Mumbai",
  "Sanjivan Gramin Vaidyakiya and Samajik Sahayata Pratishthan College of Arts Science & Commerce At Onde  Tal Vikramgad  Dist Palghar",
  "MET Institute of Computer Science, Bhujbal Knowledge Center, Bandra Reclamation, Bandra (West), Mumbai",
  "Jan Seva Sanghs  Shriram College of Commerce  Kumari Kasturi Vidyalaya  K K V  Jr  College  Datta Mandir Road  Bhandup  W Mumbai  400 078",
  "Patpanhale Arts, Commerce & Science College, A/P. Patpanhale - Shringartali, Tal. Guhagar, Dist. Ratnagiri - 415 724 ",
  "Sahyadri Shikshan Sansthas  B.A. Alias Bhaisaheb Sawant Adhyapak Mahavidyalaya Sawarde Taluka  Chiplun Dist.  Ratnagiri",
  "Vivekanand Education Societys College of Pharmacy Sindhi Society Chembur Mumbai",
  " Hashmatrai & Gangaram Himathmal Mansukhani Institute of Management, Post Box No.17, Smt. CHM College Campus, Opp. Railway Station, Ulhasnagar, Dist. Thane  421 003",
  "Maharashtriya Shikshan Sanstha Parag B.Ed. College  At Post Sadavali Tal Sangameshwar Dist Ratnagiri",
  "Abhay Shikshan Kendra's Rajarshi Shahu College of Law, Dr. Babasaheb Ambedkar Bhavan, Kannamwar Nagar 1, Vikhroli Mumbai - 400 083",
  "Bharati Vidyapeeths College of Engineering Sector-7 C.B.D.Belpada Navi Mumbai  400 614",
  "Kamalgauri Hiru Patil Shikshan Sansthas Sadguru Vamanbaba Commerce and Science College Taloja Majkur Po Taloja Tal Panvel  Dist Raigad",
  "Kaiser Education Society Kaiser College of Commerce Bandra E Mumbai-400 051",
  "Saraswati Education Societys Saraswati College of Engineering Kharghar Navi Mumbai",
  "Gandhi Shikshan Bhavans  Smt.Surajba College of Education Juhu Road Juhu Mumbai 400 049",
  "Prahladrai Dalmia Lions College of Commerce and Economics Sundar Nagar S V Road Malad West  Mumbai  400 064",
  "Shaheed Dunichand Tejandas Kalani Memorial Trust s College of Arts, Commerce and Science, Ulhasnagar, Dist - Thane",
  "Manohar Joshi College of Arts, Science & Commerce Raje Shivaji Vidyalaya PMGP Colony Buldg No13 & 31 Dharavi Mumbai 400 017",
  "Vidyalankar Institute of Technology, Vidyalankar Campus, Vidyalankar College Marg, Antop Hill, Wadala (East), Mumbai",
  "The Bombay St. Xaviers College Societys Xaviers Institute of Management Xaviers College 5  Mahapalika Marg  Mumbai 400 001",
  "Pillai HOC Institute of Management Studies & Research",
  "Indian Education Society's College of Architecture, VML Vidya Sankul, Plot No. 791, Shree Krishna Chanda Marg, Bandra Reclamation, Bandra (West),   Mumbai-400 050",
  "Esplanade Education Societys Niranjana Majithia College of Commerce Bohra Colony M G Road Kandivli  W Mumbai",
  "Rizvi Education Societys Rizvi College of Education New Rizvi Educational Complex Off Carter Road Bandra (West) Mumbai 400 050",
  " NIRMAL KRIDA AND SAMAJ PRABODHAN TRUST'S ARTS SCIENCE AND COMMERCE COLLEGE, BADNAPUR. DIST JALNA.",
  "Children Welfare Centres Claras  College of Education Yari Road,   Versova, Andheri (W), Mumbai- 400 061.",
  "Atharva Educational Trust  Atharva Institute of Management Studies Malad Marve Road Malvani Malad Mumbai 400 095",
  "The Janseva Shikshan Mandal's Shantarambhau Gholap Arts, Science and Gotirambhau Pawar Commerce College Shivale Tal. - Murbad, Dist. Thane- 421 401",
  "The J B Sawant Education SocietysTikambhai Metha Commerce College At & Post  Mangaon  Dist Raigad  402 104",
  "Bharati Vidyapeeths College of Pharmacy Sector-3 CBD Navi Mumbai 400 615",
  "Seva Sadan Trust Seva Sadan College of Arts Science and Commerce  Seva Sadan Marg  Opp  Central Hospital Ulhasnagar 421 003 Dist Thane",
  "Mandar Education Societys Rajaram Shinde College of Master Business Administration At Post Pedhambe Tal Chiplun Dist Ratnagiri",
  "Government College of Pharmacy Near Thiba Palace Ratnagiri Dist Ratnagiri- 414 612",
  "Government Law College Opp Churchgate Station Mumbai  400 020",
  "Rais Education Societys College of Arts  & Commerce  Popular House P L Lokhande Marg  Near Telephone Exchange  Chembur  Mumbai  400 089",
  "Vishweshwar Education Societys Indira Institute of Business Management At Plot no.2 Sector 9 Sanpada  Navi Mumbai-400 705",
  "Gokhale Education Societys Arts,  Commerce and Science  College Jawhar, Dist-Palghar- 401 603",
  "Mohindar Singh Kabal Singh Degree College of Arts  & Commerce  Kalyan Bhiwandi road near petrol pump Kalyan (W) - 421301",
  "Atharva Educational Trusts, Atharva College of Engineering, Plot No. 8/12, Survey No. 263, Malad Marve Road, Charkop Naka, Malad (West), Mumbai-400095",
  "Manjara Charitable Trusts Rajiv Gandhi Institute of Technology, Juhu Versova Link Road, Versova, Andheri (West), Mumbai-400053",
  "Raosaheb Gogate College of  Commerce  & Smt. Saraswatibai Ganashet Walke College of Arts Panval  Banda Taluka Sawantwadi  Dist Sindhudurg 416 511",
  "Fr Conceicao Rodrigues College of Engineering Band Stand  Bandra (West)  Mumbai",
  "Thakur Educational Trusts Thakur College of  Science and Commerce Thakur Village  W E Highway Kandivli East Mumbai",
  "DR D Y PATIL SCHOOL OF ALLIED HEALTH SCIENCES, PIMPRI, PUNE",
  "Khar Education Societys College of Commerce and Economics S V Road Khar W Mumbai 400 052",
  "Oriental Education Society College of Arts Commerce & Science Oriental Building Adarsh Nagar New Link Road Andheri West Mumbai 400 102",
  "Bhiwandi Weavers Education Societys Samadiya College of Arts & Commerce  349 Samad Nagar Kaneri Bhiwandi Dist Thane 421 305",
  "Maharashtra Samaj MSG-SGKM College of Arts Science and Commerce Plot No.17 Tilak Road Opp. Lion Garden Ghatkopar(E)  Mumbai 400 077",
  "Pune Vidyarthi Grihas College of Science & Technology  CTS 218  Br Nath Pai Nagar  Kurla Powai Rd Ghatkopar E Mumbai 400 077.",
  "Government of Maharashtras Sydenham Institute of Mangaement  Studies and Research and trepreneurship Education B Road Churchagate Mumbai 400 020",
  "Maharshi Dayanand College of Arts Science & Commerce Kamgar Manzil 25 Dr.S.S.Rao Road  Parel Mumbai  400 012",
  "Vivekanand Education Societys College of Law 1st floor Trust Office Sindhi Society Chembur Mumbai-400 071",
  "G. M. VEDAK COLLEGE OF SCIENCE",
  "Chetanas Ramprasad Khandelwal Institute of Management and Research  Survey No 341 Bandra (East)  Mumbai 400 051",
  "K.B.S.S, COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Bhausaheb Patil College of Education, Kaij.",
  "Adarsh Vikas Mandal  Karmaveer Bhaurao Patil College of Arts and Commerce  Wagale Estate  Thane W",
  "Tilak Education Society J. K. College of Science & Commerce at Plot No.22 Ghansoli Navi Mumbai 400 705",
  "Adarsh Shikshan Prasarak Mandals Shri.Bapusaheb D.D.Vispute B.Ed.College, New Panvel Dist Raigad 410 706",
  "Shri N B  Mehta Education Charity Trusts Prakash Degree College of Commerce Kandivli  W Mumbai  400 067",
  "Guru Nanak Vidyak Society's, Guru Nanak College of Arts, Science & Commerce, Guru Tegh Bahadur Nagar, Mumbai",
  "Lokmanya Nagar Shikshan Mandal's R. J. Thakur College of Arts & Commerce, Veer Savarkar Nagar, Dist. Thane-400 606",
  "K M Agrawal College of Arts Commerce and Science",
  "D E Societys Kirti M Doongursee College of Arts Science & Commerce, Kashinath Dhuru Road, Off. Veer Savarkar Marg,  Near Agar Bazar Dadar West  Mumbai",
  "Sadhana Education Societys Smt. Kapila Khandwala College of Education Near Lions Park Juhu Road Santacruz (West) Mumbai",
  "National Centre for Rural Developments Sterling Institute of Pharmacy  Plot No 93 Sector-19 Nerul Navi Mumbai",
  "K J Somaiya Institute of Technology, Somaiya Ayurvihar Complex, Everard Nagar, Eastern Express Highway, Sion, Mumbai",
  "Saraswati Shikshan Prasarak Mandal's Godawari Art's  Junior & Senior College, Ambad, Tq. Ambad, Dist. Jalna.",
  "Yashwantrao Chavan College of Arts Commerce & Science Sector-15 Plot No.23 Post-Koparkairne Navi Mumbai 400 709",
  "Late Smt. Hanjabai Gahlot Charitable Trusts, Gahlot Institute of Pharmacy, Plot No. 59, Sector-14, Koparkhairane, Navi Mumbai - 400709",
  "Konkan Unnati Mitra Mandal's Vasantrao Naik College of  Arts, Commerce and Barrister A. R. Antulay Science College, Mhasala, Dist-Raigad - 402 105.",
  "Jai Bhavani Shikshan Prasarak Mandal College of B.C.A., Mantha.",
  "Suman Education Societys Veena College of Commerce and Science (Women), Shrikrishna Shikshan Prasarak Mandal, 79, Shree Krushna Nagar, Borivali (E), Mumbai - 400 066",
  "Rahul Shikshan Prasarak Mandals Satyagraha Mahavidyalaya at Supparak Bhavan Plot No 52 Sector 19 Kharghar Navi Mumbai410 210",
  "Om Vidyalankar Shikshan Sanstha's Asmita College of Law Kannamwar Nagar No.2 Vikhroli (East) Mumbai-400 083",
  "Gurukul Education & Research Foundation Gurukul College of Computer Sci. & Information Technology  Prathmik Shikshak Bhavan Bahadurshekh Naka Chiplun Dist  Ratnagiri",
  "Dnyan Ganga Education Trust's Degree College of Arts, Commerce & Science, Behind Hypercity Mall, Kasarvadavali Naka, Ghodbunder Road, Thane (W) - 400 615.",
  "The B.P.C.As College of Physical Education Bharatiya Krida Mandir Naigaum Cross Road Wadala Mumbai 400 031",
  "Abhay Shikshan Kendra  Rajarshri Shahu College of Arts  Commerce & Science  Jogalekar Wadi  Sion  East  Mumbai 400 022",
  "Oriental Education Societys Oriental College of Education Opp Sanpada Railway Station (West) Navi Mumbai 400 705",
  "\"Rizvi Education Society's College of Architecture, Rizvi Education Complex, Off. Carter Road, Bandra (West),                         Mumbai-400050\"",
  "Shree Shankar Narayan Education Trust's Shankar Narayan College of Arts and Commerce, Mahavidyalaya Marg, Navghar, Bhayander (East), Dist. - Thane - 401 105",
  "Shree Panchal Samaj Madhyavarti Mandal's Yeshwantrao Chaphekar  College of Arts and Commerce (for women),Tembhode,College Road  Palghar (West) Palghar -401 404",
  "Bhavna Trust Junior and Degree College of Commerce and Science",
  "Smt Durga Devi Sharma Charitable Trusts Chandrabhan Sharma College of Arts Commerce & Science At Powai Vihar, Mumbai",
  "Dr  Datar Science Dr Behere Arts and Shri Pilukaka Joshi Commerce College  S K  Patil Nagar  Chiplun Tal Chiplun  Dist Ratnagiri   415 605",
  "Shikshan Prasarak Mandals  P.P. Vinayak Anna Rawool Maharaj College, Salgaon At Salgaon, Tal. Kudal ,Dist-Sindhudurg-416 510.",
  "Mahatma Phule Arts  Science and Commerce College  Panvel Dist Raigad  410 206",
  "Bharat Education Societys Sant Gadge Maharaj College of Commerce & Economics 12th Lane Khetwadi Mumbai  400 004",
  "Sonopant Dandekar Arts V S Apte Commerce and M H Mehta Science College Palghar District Palghar",
  "Hirwal Education Trusts College of Science (Computer Science and Information Technology) At Mahad Dist Raigad",
  "Sonubhau Baswant College of Arts & Commerce Near Government Godown  Savroli Road  Shahapur Dist Thane  421 601",
  "Gopaldas Jhamatmal Advani Law College 32nd Road Bandra (West) Mumbai 400 050",
  "Ratnagiri Education Societys Shriman Bhagojisheth Keer Law College Late Sou Indirabai Vishnupant Kulkarni(G.J. College) Boys Hostel Complex Ratnagiri 415 612",
  "Thane Zilla Agri Shikshan Prasarak Mandals Pragati College of Arts and Commerce DNK Road Dattata Nagar Dombivli East Dist Thane 421 201",
  "Jeevandip Shikshanik Sansthas Arts Commerce and Science  Goveli  Poi  Dist Thane",
  "Padmavati College of Computer Science, Hudco, Aurangabad.",
  "The Konkan Muslim Education Societys G M Momin Womenss College Rais High School Campus Thana Road Bhiwandi  Dist Thane 421 302",
  "Shiposhi Shikshan Prasarak Mandals Late Bapuji Hariji Baing College of BMS At Post Shiposhi Tal-Lanja  Dist Ratnagiri-415 802",
  "Prabodhan Shikshan Prasarak Sansthas College of Indira Institute of Pharmacy At Post Sadavali Tal Sangameshwar Dist Ratnagiri Pin 425 804",
  "Government College of Education, Panvel",
  "Mahatma Education Societys Pillai HOC College of Engineering and Technology, Rasayani ",
  "Sadhubella Education Societys J Watumull Sadhubella Girls College Ulhasnagar  Dist Thane",
  "Tilak Education Societys S K  College of Science & Commerce  At Nerul New Mumbai",
  "Prabhakar Patil Education Society's Arts, Commerce and Science College at Veshvi Tal. Alibag",
  "Bharatiya Vidya Bhavans  M  M College of Arts, N.M.Institute of Science and  Haji Rashid Jaffer College of Commerce Bhavans College Munshi  Nagar Andheri West Mumbai",
  "Laxmi Education Societys Chinai College of Commerce & Economics  Dr  S  Radhakrishnan Marg  Andheri East Mumbai  400 069",
  "Tolani College of Commerce, Sher-E-Punjab Society, Guru Gobind Singh Road, Andheri (East), Mumbai",
  "Adarsh Shikshan Sanstha's Women College of Education, Khadakpura Peth, Beed.",
  "Sunderrao Solanke Mahavidyalaya, Majalgaon.",
  "Mauli Vidyapeeth Kaij Sanchalit Sairam Arts, Science & Commerce College, Yusuf Wadgaon, Kaij.",
  "Navgan Shikshan Sanstha Rajuri's Arts and Science College, Chousala, Beed.",
  "Savitribai Phule Mahila Shikshan Prasarak Mandal's Gurukul College of Computer Science Gurukul Nagar, Beed.",
  "Vichardhara Pratisthan's Rajiv Gandhi Arts & Science College, Raimoha, Shirur Kasar.",
  "Jijamata Women's Development and Education Society Sanchalit Jijau  Arts, Commerce & Science College,Tembhurni, Jafrabad.",
  "Mahatma Jyotiba Phule College of Social Work, Jalna.",
  "Rajkunwar Bahuudeshiya Sevabhavi Santha ,Jalna,  Rajkunwar College, Dhawda, Jalna.",
  "Sagar B.C.A.College, Jalna.",
  "Shivaji Shikshan Mandal Ajit Pawar Arts, Commerce & Science College, Ram Nagar, Jalna.",
  "Shetkari Shikshan Prasarak Mandal, Balsur Sanchalit, Bhausaheb Birajdar Senior College, Balsur, Omerga.",
  "Shikshan Prasarak Mandal's (Andoor) Jawahar Arts, Science  & Commerce College, Andoor, Tuljapur.",
  "Shrikrishna Education Societys Shrikrishna Mahavidyalaya, Gunjoti, Omerga",
  "Ahilyadevi Shikshan Prasarak Mandal Shri Ramesh Bhau Shendge College, Indewadi, Jalna.",
  "Government College of Education, Ambajogai",
  "MSP Mandal's Yeshwantrao Chavan Arts & Commerce College, Ambajogai.",
  "Shri Yogeshwari Shikshan Sanstha Sanchalit, College of Education , Kari, Tq. Dharur.",
  "NIELIT Aurangabad",
  "Venutai Chavan Pratishthan's Mahila Arts & Commerce College, Ambajogai.",
  "Dr. Vishwanathrao Karad College of Education, Kaij.",
  "Shetkari Shikshan Prasarak Mandal's, College of Education, Ashti.",
  "R.G. Shinde Arts, Commerce & Science College, Paranda.",
  "Manavlok Social Work College, Ambajogai.",
  "Omsai Shikshan Prasarak Mandal, Shri Shivaji College, Paranda.",
  "Kholeshwar Mahavidyalaya, Ambajogai, Dist. Beed",
  "Siddharth Arts, Commerce & Science College,Jafrabad.",
  "Shri Datta Shikshan Prasarak Mandal Jamgaon Sanchalit, Arts & Science College, Ashti",
  "Foster Development's College of Education, Garkheda, Aurangabad.",
  "Govt. College of Pharmacy, Osmanpura, Aurangabad.",
  "Vivekanand Shikshan Sanstha's Institute of Management Studies & Information Technology, Samarth Nagar, Aurangabad.",
  "Marathwada Legal's & General Education Society's, Manikchand Pahade Law College, Samarthnagar, Aurangabad.",
  "M.S.M's College of Physical Education,Khadkeshwar, Aurangabad.",
  "National Education Society's Arts, Commerce & Science College, Bharadi, Sillod.",
  "Peoples Education Societys P.E.S. College of Physical Education, Nagsenvana, Cantt Aurangabad.",
  "S.B. Education Society's, College of Arts & Commerce, Aurangpura, Aurangabad.",
  "Shiv Chhatrapati College Arts, Pachod, Paithan.",
  "Shri Sant Sawata Mali Gramin Mahavidyalaya (Art, Commerce & Sci.), Phulambri.",
  "Sillod Education Trust's Nalanda College of B.C.A, Hudco, Aurangabad.",
  "Sir Sayyed College of  Arts, Commerce & Science, Aurangabad.",
  "Adarsh Sanstha, Beed Adarsh Shikshan Sanstha Sanchalit Arts, Science & Commerce College, Pimplaner, Beed.",
  "Balbhim Arts,Science & Commerce College, Beed.",
  "Savitribai Phule Mahila Shikshan Prasarak Mandal's Gurukul College of Education, Gurukul Nagar, Beed.",
  "Adarsh Gram Viaks Sevabhavi Sanstha Sanchalit Adarsh Arts, Commerce & Science College, Dhawada, Bhokardan.",
  "Dharti Janseva Partishthan's Bachelor of Education College, Revgaon, Jalna.",
  "Late. Santukrao Khomane College, Navha, Tq. Dist. Jalna",
  "Karmaveer Pratishthan's College of Social Work,Ram Nagar, Jalna.",
  "Matsyodari Shikshan Sanstha's Arts & Science College, Kumbhar Pimpalgaon, Ghansawangi.",
  "Senior Arts College, Gondegaon",
  "Matsyodari Shikshan Sanstha's College of Education, Mastgad, Jalna.",
  "R.S.K. Mandal's  Savitribai Phule Mahila College of Arts, Commerce & Science, Jalna.",
  "Vasantrao Naik Shikshan Sanstha's College of Education, Jalna.",
  "Adarsh Shikshan Prasarak Mandal's K.T. Patil College of Engineering and Technology, Osmanabad.",
  "Mother Kanchan Institute of Business Management & Computer Application, Yashwant Nagar, Barshinaka, Osmanabad.",
  "Mitra Sadhana Shikshan Prasarak Mandal's Rajarshi Shahu College of Arts, Commerce & Science, Pathri, Aurangabad.",
  "Janta Vastigrah Sanstha, Dhanora, Janta Arts, Science & Commerce College, Dhanora, Ashti.",
  "B.S.P. Sanstha, Swa. Sawarkar Mahavidyalaya, Beed.",
  "Jijae Prathishthan Sevli Sanchalit, Lokmanya Tilak Arts, Commerce & Science College, Sevli, Jalna.",
  "Shri Krishna Bahuudeshiya Samajsevi Sanstha, College of Education, Shikshak Colony, Osmanabad",
  "J V INSTIUTE OF PHARMACY KHAMONA",
  "SVKMS SHRI BHAGUBHAI MAFATLAL POLYTECHNIC AND COLLEGE OF ENGINEERING",
  "P V BELHEKAR COLLEGE OF PHARMACY",
  "RATNADEEP PHARMACY COLLEGE RATNAPUR TALUKA JAMKHED DISTRICT AHMEDNAGAR",
  "PBMAs H V Desai Eye Hospital",
  "Dr. Rajesh Ramdasji Kambe Dental College and Hospital ",
  "SYMBIOSIS Institute of International Business",
  "SYMBIOSIS Institute of Health Sciences",
  "SYMBIOSIS Institute of Geoinformatics",
  "SYMBIOSIS Institute of Digital and Telecom Management",
  "SYMBIOSIS Institute of Computer Studies and Research",
  "LIFELINE INSTITUTE OF PHYSIOTHERAPY    ",
  "KISSAN LAW COLLEGE PARNER",
  "Manjara Charitable Trusts College of Education And Research Sector four Airoli Navi Mumbai",
  "KISAN VIDYA PRASARAK SANSTHAS MAHARANI AHILYABAI HOLKAR M A H COLLEGE OF PHARMACY, SHIRPUR",
  "5292-MATOSHRI EDUCATION SOCIETY'S MABD INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH, BHABULGAON, TAL YEOLA DIST. NASHIK",
  "SANT DNYANESHWAR MAHILA MAHAVIDYALAY    ",
  "NAMOYUG VARISHTH MAHAVIDYALAY BORGAON MANJU TQ DIST AKOLA    ",
  "MARATHWADA SAMAJKARYA MAHAVIDYALAY    ",
  "Adv. Yadavrao Dhote Smruti Mahavidyalaya, Rajura",
  "R B LAW COLLEGE",
  "SWAMI VIVEKANAND KALA V VIDNYAN MAHAVIDYALAY UMARI KHURD TAH MANORA DIST WASHIM    ",
  "VSPM COLLEGE OF NURSING, KATOL",
  "COLLEGE OF AGRICULTURE JIREWADI    ",
  "Venkatesh Mahajan Senior College, Dharashiv.",
  "Late Nirdhan Patil Vaghaye  College of education,  Sakoli",
  "SHIV CHHATRAPATI MAHAVIDYALAY",
  "PADMINI COLLEGE OF PHARMACY DIGHANCHI",
  "SHIKSHAN MAHARSHI VAIJNATHRAO AKAT MAHAVIDYALAY, SATONA",
  "Vichar Vikas Mandal's Mahatma Gandhi Mahavidyalaya, Ahmedpur",
  "Mukundrao Patil BCA B.Sc.C.S. College, Opp. Bus Stand, Kinwat",
  "SAI CARE COLLEGE OF PHARMACY NASHIK",
  "Nagnath Arts, Commerce & Science College, Aundha Nagnath",
  "Bharti Arts & Science College, Near Bus Stop, Hadgaon",
  "VARDHAMAAN MAHAVIR COLLEGE OF NURSING",
  "Dr. Vandanatai Jagannathrao Dhone Gramin Ayurved Mahavidyalaya,  Patur",
  "AKEMI COLLEGE OF CYBER AND DIGITAL SCIENCE ",
  "NUTAN MAHARASHTRA VIDYA PRASARAK MANDALS LATE ADV KU SHALAKA SANTOSH KHANDGE LAW COLLEGE",
  "KRUSHNAI INSTITUTE OF BSC NURSING SALEGAON TAL KAIJ DIST BEED",
  "S. K. Somaiya College of Arts, Science and Commerce, Vidyanagar, Vidyavihar, Mumbai",
  "AL MUBEEN SENIOR COLLEGE    ",
  "Kai. Kishanrao Ramji Shinde College  of Library & Info. Science, Jintur Road, Parbhani",
  "N.M.Azad Education Soc'sCollege of Education, Parbhani",
  "Narayan Rao Chavan Law College, Visava Nagar, Nanded",
  "Swami Ramanand Teerth Adhyapak Mahavidyalaya, Kandhar",
  "Saraswati Vidya Mandir Arts College, Kinwat",
  "SHRI VILE PARLE KELVANI MANDALS COLLEGE OF AGRICULTURE",
  "GOVERNMENT BSC NURSING COLLEGE, GENERAL HOSPITAL JALNA",
  "SYNERGY COLLEGE OF NURSING ",
  "RAMOJI MAHILA MAHAVIDYALAY, JUNA KAUTHA NANDED",
  "CITIZENS EDUCATION SOCIETY ARTS COMMERCE SCIENCE AND B SC INFORMATION TECHNOLOGY COLLEGE",
  "Late Laxmanraoji  InformationTechnology College, Manik Nagar, Nanded",
  "Smt.  Shankuntala bai Kadam  Bordikar Senior Arts College, Bori, Tq. Jintur",
  "AL AMEEN EDUCATIONAL AND MEDICAL FOUNDATIONS NEW LIFE AYURVEDIC COLLEGE",
  " SHREE SANT GAJANAN MAHARAJ WOMENS ARTS , SCIENCE AND COMMERCE COLLEGE",
  "N.T.S. B.Ed. College of Education, Parbhani",
  "Vivekanand College of Technology & Management, Hingoli Naka, Nanded",
  "R C PATEL COLLEGE OF ENGINEERING AND POLYTECHNIC, SHIRPUR",
  "Mahatma Phule Mahavidyalaya, Ahemadpur",
  "Vishwadip S.S.'s Vishwakarma College, Karegaon Road, Parbhani",
  "Chatrapati Sambhaji Maharaj College, Mahur",
  "NAV SAHYADRI CHARITABLE TRUST KAI NIRMALATAI PINGLE LAW COLLLEGE",
  "VIDYAVARDHINI LAW COLLEGE",
  "Shiv Jagruti Senior College Nalegaon",
  "DUDHABHATE OPTOMETRY COLLEGE",
  "K. K. M. Arts Commerce & Science College, Manwat",
  "AHMEDNAGAR JILHA MARATHA VIDYA PRASARAK SAMAJ, YASHWANTRAO CHAVAN ARTS, COMMERCE AND SCIENCE COLLEGE VAMBORI",
  "Rajiv Gandhi College of Computer Sci.& Management, Vidhout Nagar, Nanded",
  "GAJANAN SENIOR COLLEGE KADA TAL ASHTI DIST BEED",
  "Shivaji College of Arts, Comm. & Science, Kandhar",
  "Saraswati  College of Education, Kinwat",
  " JIJAI CHARITABLE TRUST  JIJAU MAHAVIDALAYA RASHIN TALUKA KARJAT DISTRICT AHMEDNAGAR ",
  "Government College of Education, Nanded",
  "Rajiv Gandhi College of Engineering, Research and Technology",
  "Degloor College, Degloor",
  "Yeshwant Arts College, Ahemadpur",
  "Maharashtra Mahavidyalaya, Nilanga",
  "Smt. Sushiladevi Deshmukh Senior College, Latur",
  "Shri Sant Janabai Arts Commerce Science College, Gangakhed",
  "Shree Rahul Education Society s Rahul  College of Education  Navghar Road  Bhayandar E Thane",
  "KAMAL MAHILA MAHAVIDHYALAY    ",
  "GLOBAL DEGREE COLLEGE    ",
  "Vaishnavi Mahavidyalaya,Wadwani, Tq:Wadwani.",
  "St Andrews College of Physiotherapy",
  "Chanakya Education Societys Indira College of Commerce & Science, Pune",
  "Karmveer R.S. Wagh Education & Health Organization's, Arts, Commerce & Science College, Mu Rajaramnagar, Post- Materewadi, Tal- Dindori, Dist- Nashik 422209",
  "K.R.T. Arts, B.H. Commerce & A.M. Science College (K.T.H.M.), Nashik 422002.",
  "Dr. D. Y. Patil Unitech Society's Dr. D.Y. Patil Science & Computer Science College, Akurdi, Pune 411044",
  "Dr. D.Y. Patil Unitech Society's Dr. D.Y. Patil College of Education, Near Lokmanya Hospital, Sector No. 27-A, Nigdi-Pradhikaran, Akurdi, Pune 411044.",
  "Belapur Education Societys Arts & Commerce College,Belapur, Tal.Shrirampur, Dist.Ahmednagar 413715",
  "All India Shivaji Memorial Societys  Institute of Management, Kenedi Road, Near RTO, Pune 411001",
  "Skylark Foundations Arts, Science & Commerce College, Khed Shivapur, Tal. Haveli, Dist. Pune",
  "Khadaki Education Society's Tikaram Jagannath College of Arts, Commerce and Science, Khadaki, Pune 03",
  "Maharashtra State Institute of Hotel Management and Catering Technology, Shivajinagar, Pune 411016",
  "Shikshan Prasarak Mandal's, Pabal, Shri Padamamani Jain Arts & Commerce College, Pabal, Tal. Shirur, Dist. Pune-412403",
  "Modern Education Society's Nowrosjee Wadia College Arts, Science, Pune 01",
  "Sanjeevani Rural Education Societys Sanjeevani College of Pharmaceutical & Research, At. Sahajanandnagar, Post. Shinganapur, Tal. Kopargaon ,Dist.Ahmednagar",
  "Rahuri Rural Womens Institute of Educations Gayatri College of Education, Deolali Pravara Dist. Ahmednagar 413716",
  "St. Mira's College for Girls , Pune -411001 ",
  "Pune Zilha Shikshan Mandals Late Shankarrao Bhelke Arts, Science & Commerce College, Nasarapur, Tal. Bhor, Dist. Pune 412213",
  "Bharateeya Jain Sanghatanas Arts, Science and Commerce College, Pune",
  "Jaywant Shikshan Prasarak Mandals Jaywantrao Sawant College of Education, Sr.No.58,Indrayani Nagar, Handewadi Road, Hadapsar, Pune  411 028",
  "Dnyanoday Prashikshan Sevabhavi Sansthas, Foresight College of Commerce,Pune",
  "Jadeed Anjuman E Taleem's  J.A.T. Arts, Science & Commerce College (for women), Malegaon, Tal-Malegaon, Dist-Nashik 423203",
  "People Education Societys Dr. Ambedkar College of Arts & Commerce,Yerwada, Pune 6.",
  "Bansilal Ramnath Agarwal Charitable Trusts Vishwakarama Institute of Technology, Apper Indiranagar, Pune  411037",
  "Mahatama Gandhi Vidyamandirs Arts & Commerce College, Yeola,Dist.Nashik 423401",
  "Anjuman Imdadut Tulba Arts,Commerce & Science Night College, Pharmacy Nagar, Malegaon, Dist. Nashik 423203",
  "Maharashtra Vikas Kendra's Conquest College of Arts, Commerce and Computer Studies, Chikali, Tal Haveli, Dist Pune",
  "Modern Education Societys Ness Wadia College of Commerce, P.V.K.Joag Path, Pune 411004",
  "Shree Mahavir Education Society's Nashik Sanghavi College of Engineering  Address: Mhasrul Varvandi Road,  Village Varvandi,  Nashik-422202  Taluka: Dindori District: Nashik",
  "Maratha Vidya Prasarak Samaj's  Arts & Commerce College, Soygaon, Tal.Malegaon, Dist.Nashik 423203",
  "Jai Ganesh Educational Foundations Jai Ganesh College of Education, Manaji Nagar, Narhe  Road, Pune 41",
  "Nutan Vidya Prasarak Mandals Arts,Commerce & Science College, Lasalgaon, Dist.Nashik 422306",
  "Shri Gurudev Shikshan Prasarak Mandals Swami Muktanand Science College, Yeola, Dist. Nashik 423401",
  "Bharati Vidyapeeths College of Engineering for Women, Pune",
  "Akole Taluka Education Societys Sant Kondajibaba Arts & Commerce College,Kotul, Tal. Akole, Dist.Ahmednagar 422610",
  "Maratha Vidya Prasarak Samaj Institute of Management, Research and Technology, Gangapur Road, Nashik, Tal. Nashik, Dist. Nashik 422002",
  "Sinhgad Technical Education Societys Sinhgad Institute of Pharmacy, Pune Mumbai Bypass Highway, Narhe Ambegaon,Dist.Pune  41",
  "N.D.M.V.P.Samajs Karmaveer Kakasaheb Wagh Arts, Science & Commerce College,Pimpalgaon Baswant, Dist. Nashik 422209",
  "Rayat Shikshan Sanstha's Radhabai Kale Mahila Mahavidyalaya, Ahmednagar 414001",
  "Indrayani Vidya Mandir's Indrayani Mahavidyalaya, Talegaon - Chakan road, Talegaon (Dabhade)  Taluka - Maval, District - Pune  410507",
  "Gokhale Education Societys R.N.C.Arts, J.D.B.Commerce and N.S.C.Science College, Nashik Road, Nashik 422101",
  "Smt.Vimlaben Khimji Tejookaya Arts, Science & Commerce College , Deolali Camp, Dist.Nashik",
  "Rajgad Dnyanpeeth's College of Pharmacy, Bhor, Dist. Pune",
  "Maharashtra Education Societys Institute of Management and Career Course IMCC, Mayur Colony, Kothrud, Pune 411029",
  "Snehvardhak Mandal Shaikshnik Trusts College of Education English Medium, Talegaon Dabhade, Dist.Pune 410506",
  "J.D.C.Bytco Institute of Management Studies and Research, Nashik 422005",
  "Shri Sant Tukaram Prasarak Mandal Arts, Science & Commerce College, Wadgaon Maval, Dist. Pune.",
  "Sinhgad Business School,Erandwane, Pune 411004",
  "Devala Education Societys Karmaveer Ramraojee Aher Arts,Science & Commerce College, Deola, Tal. Kalwan, Dist. Nashik 423102",
  "Chaudhary Atarsingh Yadav Memorial Education Trusts, Siddhant College of Management Studies,Pune",
  "SMT KAMALTAI KISAN KATHORE LAW COLLEGE MHASA",
  "Sandip Foundations Sandip Institute of Technology & Research Centre, P.O.Mahirawani, Dist.Nashik",
  "Shri Dattakrupa Shaikshanik & Krushi Gramvikas Pratishthan's Abhinav College of Arts & Commerce (BCA), Bhistbaug Chauk, Pipeline Road, Waninagar, Ahmednagar",
  "Bhartiya Kalaprasarini Sabhas College of Architecture,Pune",
  "Sunni Jumma Masjid Education Societys Dr.Mumtaj Ahmed Khan Education College, Manchar, Dist.Pune",
  "Pravara Rural Education Society's Pravara College of Physical Education, Pravaranagar, Tal. Rahata, Dist. Ahmednagar 413712",
  "Shri Baneshwar College of Education,Burhannagar, Ahmednagar",
  "HON. SHRI BABANRAO PACHPUTE VICHARDHARA TRUST'S, GROUP OF INSTITUTION'S, FACULTY OF ENGINEERING, KASHTI, TAL.- SHRIGONDA, DIST.-AHMEDNAGAR 414701",
  "BRACT Vishwakarma Institute of Information Technology, Pune 411048.",
  "Kai. Ramrao Patil Adhyapak Mahavidyalaya, Udgir",
  "Mahatma Gandhi Vidyamandirs Arts Science Commerce College, Surgana",
  "Shri Shivaji Maratha Societys Institute of Management and Research,Parvati, Aranyeshwar, Pune 411009",
  "Maratha Vidya Prasarak Samaj's  Arts & Commerce College, Makhamalabad, Nashik",
  "Maharashtra Association for the Cultivation of Science, Agarkar Research Institute , Agarkar Road, Pune 411004",
  "Bharat Shikshan Prasarak Mandals, Jaikranti College of Computer Science & Management Studies,Pune",
  "Dhareshwar Vidya va Krida Pratishthans Dhareshwar Shikshanshastra Mahavidyalaya, Pune-41",
  "Sinhgad Technical Education Societys Sinhgad Law College, Kondhawa Bk. , Pune 48",
  "Al-Ameen Educational & Medical Foundations Dattatray Govindrao Walse-Patil M.Ed. College , Pune",
  "Shri Shivaji Shikshan Prasarak Mandals Arts,Science & Commerce College, Rahuri, Dist.Ahmednagar 413705",
  "Rajmata Jijau Shikshan Prasarak Mandals College of Pharmacy,Dudulgaon, Pune 412105",
  "Dr Vithalrao Vikhe Patil Foundations College of Pharmacy, Vadgaon Gupta (Vilad Ghat), Ahilyanagar",
  "Shridatta Krupa Education & Agriculture Rural Development Pratishthans Saikrupa College of Arts,Ghargaon, Tal. Shrigonda, Dist. Ahmednagar",
  "Navmaharashtra Shikshan Mandals College of Education, Shevgaon, Dist.Ahmednagar 414502",
  "Sinhgad Technical Education Societys Sinhgad Institute of Pharmaceutical Science, Kusagaon bk., Lonavala,Tal. Maval,Dist.Pune",
  "Shree Chanakya Education Societys Indira Institute of Management, Pune Mumbai Highway, Near Wakad Police Station, Tathwade, Pune 411033",
  "K.J.S.Education Institute Trinity Institute of Management and Research, Village Pisoli, Tal.Haveli, Dist.Pune 411048",
  "Dang Seva Mandal's Dadasaheb Bidkar Arts, Science & Commerce College, Peth, Taluka - Peth, District - Nashik 422208",
  "Gokhale Edcuation Societys  Narhar Balwant Thakur Law College, Vidyanagar, Nashik 422005",
  "Sinhgad Technical Education Societys Sinhgad Institute of Technology, Kusagaon bk., Lonavala,Tal. Maval,Dist.Pune",
  "The Poona Gujrati Kelwani Mandals H.V.Desai Senior College of Arts, Science & Commerce ,Budhawar Peth,Pune 2",
  "Modern Education Society's College of Engineering, V.K.Jog Path, Pune 01",
  "Sulochana Belhekar Samajik & Bahuuddesheeya Shikshan Sanstha Sant Dnyaneshwar B.Ed.College, Nevasa Phata, Tal.Nevasa, Dist. Ahmednagar",
  "Shri Chhatrapati Shikshan & Aarogya Prasarak Mandal's Shri Sant Gajanan Mahavidyalaya, Kharda, Tal. Jamkhed, Dist. Ahmednagar 413204",
  "Poona District Education Associations Shankarrao Ursal College of Pharmaceutical Science & Research Centre, Kharadi, Pune",
  "Kasturi Shikshan Sansthas Institute of Management, A-p. Shikrapur, Tal. Shirur, Dist. Pune 412208",
  "Shree Samarth Academics Shree Samarth College of Education & Research B.Ed. Mhasane  Phata, Tal. Parner, Dist. Ahmednagar",
  "Mahatma Gandhi Vidyamandir's Mahilaratna Pushpatai Hiray Arts,Science & Commerce Mahila Mahavidyalaya Loknete Vyankatrao Hiray Marg, Malegaon Camp, Dist.Nashik 423105",
  "CAMP EDUCATION SOCIETY   DR. ARVIND B. TELANG SENIOR COLLEGE OF ARTS, SCIENCE & COMMERCE,NIGDI,PUNE-44 ",
  "Gargi Education Institutes Gargi Agriculture Research & Training Institute , CIDCO, Nashik",
  "Gajanan Maharaj Shikshan Prasarak Mandals Sharadchandra Pawar College of Pharmacy,Pune",
  "The D.C.M. Society of India Punes Dr.Babasaheb Ambedkar Commerce & Maharshi Vitthal Ramji Shinde Arts College, Ahilyashram,Nana Peth,Pune 2",
  "Rayat Shikshan Sansthas Swami Sahajanand Bharati College of Education, Shrirampur, Dist. Ahmednagar 413709",
  "Dr. Vithalrao Vikhe Patil Foundations Institute of Business Management & Rural Development, Vilad Ghat, Post MIDC, Ahmednagar 414111",
  "M.G.Vidyamandirs  College of Education, Malegaon Camp,Dist. Nashik 423105",
  "Paschim Maharashtra Education Trusts College of Education Kondhwa khurd, Tal. Haveli, Dist. Pune 48.",
  "Vivekanand Institute of Technology's, Padmabhushan Dr. Vasantdada Patil College of Architecture, 274/2, 275/2, 282, Aditya Nisarg, At Post - Pirangut, Taluka - Mulshi, Dist. Pune 412115",
  "PDEAs A G Awate College of Engineering, Hadapsar, Pune 28",
  "Gokhale Education Societys College  of Education,Sangamner,Dist.Ahmednagar 422605",
  "JaiHind Sindhu Education Trust's Manghanmal Udharam College of Commerce, Opp. Jijamata Hospital, Pimpri, Pune-17",
  "ASM'S INSTITUTE OF BUSINESS MANAGEMENT AND RESEARCH, MBA INSTITUTE MIDC BLOCK 'C', CHINCHWAD, PUNE-411019. ",
  "Eagle Education Societys Unique Institute of Management, Katraj, Kondhava Rd., Pune 411046",
  "Marathwada Mitra Mandal's Institute of Technology, Lohgaon, Tal Haveli, Pune 32",
  "Suryadatta Education foundations Suryadatta Institute of Management & Mass Communication (SIMMC), Bavdhan (BK) Pune-411021",
  "Sinhgad Technical Education Societys Smt. Kashibai Navale College of Engineering, Vadgaon bk., Sinhgad road, Pune 41",
  "Genba Sopanrao Moze Trusts Genba Sopanrao Moze Adhyapak Mahavidyalaya,Pune",
  "Indira Gandhi Kala Mahavidyalaya, Ralegaon.",
  "Sinhgad Technical Education Society's Sinhgad College of Pharmacy, Vadgaon (Bk.), Sinhgad Road, Pune 411041",
  "Vidya Pratishthans Arts, Science and Commerce College,Baramati, Pune  413133",
  "Mahatma Gandhi Vidyamandir's Samajshree Prashantdada Hiray Arts, Science & Commerce College, Nampur, Taluka - Baglan, District - Nashik 423204",
  "People Education Societys Jamkhed College Arts Science & Commerce, Jamkhed, Dist.Ahmednagar 413201",
  "Abhinav Education Societys Law College, Pune",
  "Sinhgad Technical Education Societys Sinhgad Institute of Hotel Management and Catering Technology, Kusgaon Bk., Lonavala, Tal. Maval, Dist.Pune  410401",
  "Bhigawan Shikshan Prasark mandals Loknete Shardchandraji Pawar College of Education,Pune",
  "Maharshi Karve stree Shikshan Sanstha's Dr.Bhanuben Nanavati College of Artchitecture for Women, Karve Nagar, Pune",
  "Pravara Rural Education Society's  Arts, Science & Commerce College, Kolhar, Tal.Rahata, Dist.Ahmednagar - 413710",
  "K.K.Wagh Education Societys  College of FIne Arts Hirabai Haridas Vidyanagari, Amrutdham, Panchavati,Nashik",
  "Janseva Foundation Loni Budruks Arts & Commerce College,Shendi,Tal.Akole,Dist.Ahmednagar",
  "Arts & Commerce College, Shendi, Bhandardara Dam,Tal.Akole,Dist.Ahmednagar",
  "Hind Seva Mandal's, Pemraj Sarda College, Savedi Raod, Tal-Ahmednagar, Dist-Ahmednagar 414001",
  "MET's Institute of Management, Bhujbal Knowledge City, Adgaon, Nashik 422003",
  "Mahatma Gandhi Vidyamandir's, Panchvati College of Management & Computer Science, Panchvati, Nashik, Tal. Nashik, Dist - Nashik-422003",
  "N.D.M.V.P.Samajs Arts,Commerce & Science College, Nandgaon,Nashik 423106",
  "Naigaon Education Societys Arts and Commerce College, Daund, Dist Pune",
  "Nav Sahyadri Charitable Trust's College of Education, Chakan, Tal. Khed, Dist Pune",
  "Rayat Shikshan Sansthas S.S.G.M.Science, Gautam Arts & Sanjeevani Commerce College, Kopargaon, Dist.Ahmednagar 423601",
  "Sinhgad Technical Education Societys Sinhgad Institute of Management and Computer Application, Narhe  Ambegaon, Dist. Pune  411041",
  "INSTITUTE OF MANAGEMENT",
  "J.T.S.S.P Mandals Shri Shiv Chhatrapati College of Arts, Science & Commerce, Bodkenagar, Junnar Dist. Pune 410 502",
  "Peoples Empowerment Groups ISB&M College of Commerce, Nande Village, Pune 42",
  "Vishal Junnar Seva Mandals Vishal Institute of Pharmaceutical Education & Research , Ale,Tal. Junnar,Dist.Pune 412411",
  "Jaywant Shikshan Prasark Mandals Jaywantrao Sawant College of Pharmacy and Research, Handewadi Road, Hadapsar,Pune.",
  "Maharshi Karve stree Shikshan Sanstha's Cummins College of Engineering for Women, Karve Nagar Pune 52",
  "150027-TMES'S J.T.MAHAJAN COLLEGE OF ENGINEERING, FAIZPUR.",
  "TATYASAHEB KORE COLLEGE OF ARCHITECTURE WARANANAGAR",
  "A.N.A.C. WARORA",
  "NANDURBAR TALUKA VIDHAYAK SAMITIS INSTITUTE OF PHARMACY, NANDURBAR    ",
  "MAXWELL MAHAVIDYALAYA DHAMNA NAGPUR     ",
  "AMEPURVA FORUMS NIRANT INSTITUTE OF PHARMACY BORAMANI SOLAPUR",
  "MAXWELL COLLEGE OF ARTS COMMERCE AND SCIENCE DHAMNA    ",
  "G H RAISONI COLLEGE OF BUSINESS MANAGEMENT, MADHAVNAGARI, NAPGUR",
  "PEARL COLLEGE OF D AND B PHARMACY    ",
  "BHARATRATNA ATALBIHARI WAJPEI MAHAVIDYALAY, SINGNAPUR    ",
  "COLLEGE OF AGRI BUSINESS MANAGEMENT JIREWADI     ",
  "Sahyadri Shikshan Sanstha College of Science B.Sc.(I.T.) and B.Sc. ( Computer Science) at Sawarde Tal Chiplun Dist Ratnagiri",
  "COLLEGE OF AGRICULTURE LIHAKHEDI    ",
  "SHRI GANPATI INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH TEMBHURNI",
  "Utkranti Mahavidyalaya, Jarud. Tq.Warud",
  "COLLEGE OF AGRICULTURE, DARWHA",
  "Y AND M AKIS COLLEGE OF ARTS SCIENCE AND COMMERCE",
  "PARAMPUJYA GURUMAULI ANNASAHEB MORE AYURVED COLLEGE,",
  "UNITED PUBLIC SERVICE COLLEGE RAJUR",
  "ARHAM INTERNATIONAL INSTITUTE OF INFORMATION SECURITY    ",
  "SAHYADRI COLLEGE OF AGRICULTURAL ENGINEERING, YESHWANTNAGAR",
  "AMRUTVAHINI SHETI & SHIKSHAN VIKAS SANSTHA`S AMRUTWAHINI INSTITUTE OF PHARMACY SANGAMNER AHILYANAGAR",
  "ARHAM COLLEGE OF MANAGEMENT AND INFORMATION TECHNOLOGY    ",
  "Tata Institute of Social Sciences Tuljapur Campus",
  "SHAMRAO PATIL INSTITUTE OF AYURVED RESEARCH CENTRE AND HOSPITAL, PANIV    ",
  "SEVEN ISLANDS MARITIME TRAINING INSTITUTE    ",
  "Maharashtriya Mandals College of Commerce",
  "MATOSHRI AYURVED COLLEGE, HOSPITAL AND RESEARCH CENTER, KARJULE HARYA",
  "VISHWABHARATI ACADEMYS COLLEGE OF PHARMACY",
  "PUNE CAMBRIDGE INSTITUTE OF MANAGEMENT AND COMPUTER APPLICATION",
  "RAJKUNWAR COLLEGE HIWRA TQ BADNAPUR DIST JALNA",
  "Marathwada Mitra Mandals Institute of Environment and Designs college of Architecture",
  "BHAUSAHEB GULABRAOJI PATIL SENIOR COLLEGE PALDHI BK TAL DHARANGAON DIST JALGAON    ",
  "SUPRIYA TAI SULE MANAGEMENT SCI COLLEGE",
  "College of Management Khamgaon",
  "G.B.Murarka Arts and Commerce College,Shegaon.",
  "Mahatma Jyotiba Fule Commerce, Science and Vitthalrao Raut Arts College, Bhatkuli",
  "Gunwantrao Deshmush Education College. Pusad",
  "P. R. Patil College of Education (B.Ed.), Amravati",
  "Shri Chatrapati Shivaji Kala Mahavidyalaya , Asegaon Purna , Tq- Chandur Bazar.",
  "G.S. Science , Arts And Commerce College , Khamgaon",
  "College of Physical Education , Shivaji Nagar, Yavatmal",
  "Smt. Radhadevi Goenka Mahila Mahavidyalaya, Akola.",
  "Nehru Mahavidyalaya (Arts, commerce, science) Nerparsopant, Dist:Yavatmal",
  "Jijau Education College, Yavatmal",
  "357 Late.Uttamrao Deshmukh Adhyapak Mahavidyalaya, Rely Station,Shegaon.",
  "Yeshwantrao Chavan Physical Education College, Mangrulpir.",
  "Smt. Kaveridevi Kedarmal Agrawal Arts & Commerce College, Malkapur.",
  "Shri Vitthal Rukmini Arts, Commerce College, Sawana, Tq. Mahagaon.",
  "Yeshwantrao Chavan Science College, Mangrulpir.",
  "G.S. Tompe Arts, Commerce & Science College , Chandur Bazar.",
  "Late Narayanrao Amritrao Deshmukh Arts , Commerce College , Chandur Bazar",
  "Takashilla Mahavidyalaya, Sham Nagar Amravati.",
  "Mahajan College of Technology, Arani Road, Yavatmal.",
  "Abhinav College of Education, D.P.Road, Chikhali.",
  "Shri Babasaheb Deshmukh Parwekar Mahavidyalaya, Pandharkawada, Tq. Kelapur. Dist. Yavatmal",
  "Karmyogi Babasaheb Apotikar Adhyapak & Anusandhan Mahavidyalaya, Apoti (Khu.)Tq.:-Akola",
  "Tapasvi Ramrao Maharaj Arts College,Poharadevi, Tq. Manora",
  "Shri Radhakisan Lakshminarayan Toshniwal Science College, Akola.",
  "Mahatma Phule Arts & Science College Patur , Tq.Patur,Dist.Akola",
  "Pankaj Laddhad Institute of Technology and  Management Studies, Buldana",
  "S.P.M. late Tatyasaheb Mahajan Arts and Commerce College, Chikhali i",
  "Shripad Krishna Kolhatkar Mahavidyalaya, Jalgaon Jamod",
  "SHRI SHIVAJI COLLEGE OF ARTS, COMMERCE AND SCIENCE, AKOLA",
  "Smt. Salunkabai Raut Arts and Commerce College, Wanoja,  Mangrulpir.",
  "M.E.S. Arts, Commerce College , Mehakar",
  "Mahatama Fule Arts, Commerce &Sitaramji Chaudhari Science College, Warud.",
  "Adarsh Science, Jairamdas Bhagchand Arts &Birla Commerce College, Dhamangaon Rly.",
  "College of Social Work  , Anjangaon Bari Road, Badnera, Amravati, 444701",
  "Vidyabharati Mahavidyalaya , C.K. Nayadu Road , Camp, Amravati.",
  "Shri Shivaji Arts , Commerce College , Morshi Road,Amravati.",
  "College of Management And Computer Science, Yavatmal.",
  "GulabNabi Azad College of Social Work, Pusad, Dist: Yavatmal",
  "Amolakchand Mahavidyalaya, Yavatmal. Maharashtra Yavatmal",
  "Government Education (B.Ed.) Mahavidyalaya, Akola",
  "Late.Sanjay Tompe & Late Samir Deshmukh Shikshanshastra Mahavidyalaya, Chandur Bazar.",
  "Matoshree Vimalabai Deshmukh Mahavidyalaya, Amravati",
  "Lokmanya Tilak College, Wani. Distt:- Yavatmal. Maharashtra Yavatmal",
  "Hanuman Vyayam Shala Krida Mandal's Physical Education College, Yavatmal.",
  "Arts, Commerce College , Yeoda , Tq- Daryapur.",
  "Arts college,Wadhona Ramnath,Tq: Nangaon (Kh.). Distt:- Amravati",
  "Javaharlal Darda Institute of Engineering And Technology, Lohara,",
  "Prof. Ram Meghe Institute of Technology & Research Badnera Rly.",
  "Late Pushpadevi Patil Arts and Science College, Risod, Washim",
  "Sitabai Arts, Commerce & Science,College, Akola",
  "Savitribai Fule Education Mahavidyalaya, Akot.",
  "Bharatiya Mahavidyalaya , Badnera Road",
  "JAI TULJA BHAVANI BAHUUDDESHIYA SEVABHAVI SANSTHA JETHABAI GHARAT MAHILA MAHVIDVALAY SHAHAPUR, SHENVA TAL SHAHAPUR DIST THANE",
  "Jai Bajrang Arts College , Channi , Tq- Patur",
  "Smt. Vatsalabai Naik Mahila Mahavidyalaya, Pusad.",
  "Rambhau Lingade Shikshan Mahavidyalaya, Buldhana",
  "Science College, Risod.",
  "Sudhakarrao Naik Institute of Pharmacy, Pusad.",
  "College of Pharmacy, Kaulkhed, Akola.",
  "Bhartiya Mahavidyalaya , Morshi Road, Amravati.",
  "Art &Science College , Kurha , Tq- Teosa",
  "Vivekand Science Col lege,Vivekand Nagar, Hiwara Ashram,Tq.Mehkar.",
  "Hemant Nrutya Sangeet Kala Mahavidyalaya , Maltekdi Road , Amravati.",
  "SHRI SWAMI SAMARTH INSTITUTE OF MANAGEMENT AND TECHNOLOGY ",
  "MAHESH AYURVED COLLEGE, ASHTI",
  "SANT BHAGWANBABA ARTS AND SCIENCE COLLEGE KHARWANDI KASAR PATHARDI ",
  "SHRIRAM PRATISHTHAN ADITYA INSTITUTE OF PHARMACY, SELU",
  "Anjuman-I-Islam's Allana Institute of Management Studies",
  "Sai Seva Shikshan Prasarak Mandal Bhiwandis Shri Indrapal Baburav Chaughule Law College At Rahnal, Anjurphata, Tal Bhiwandi, Dist Thane",
  "Dr. D. Y. Patil College of Nursing, Pune",
  "Dr. D. Y. Patil College of Physiotherapy, Pune",
  "SHARWANI ARTS,COMMERCE AND SCIENCE COLLEGE",
  "PUNYASHLOK DEVI AHILYA GRAMVIKAS SANSTHA CHANDWAD SANCHALIT V N KOTWAL ARTS, COMMERCE AND SCIENCE COLLEGE CHANDWAD DIST NASHIK",
  "SYMBIOSIS School of Culinary Arts and Nutritional Sciences",
  "Swami Vivekanand College of Management, Science and Arts, Warud",
  "Shri Madhukarrao Bapurao Patil Khatgaonkar College, Shankarnagar",
  "TAKSHASHILA COLLEGE OF ARTS,SCIENCE AND COMMERCE PUNE ",
  "Latthe Education Societys Smt. Gangabai Khivraj Ghodawat Kanya Mahavidyalaya JAYSINGPUR",
  "LOKNETE APPASAHEB RAJALE COLLEGE OF PHARMACY",
  "TUNGARESHWAR ACADEMY VIDYANAGARI VASAI COLLEGE OF LAW ",
  "DNYANODAYA EDUCATION TRUST GNYANODAYA DEGREE COLLEGE OF ARTS SCIENCE AND COMMERCE",
  "VPM's Maharshi Parshuram College of Engineering",
  "College of Fisheries",
  "College of Forestry",
  "Chhatrapati Shivaji College of Agriculture",
  "College of Agricultural Engineering & Technology",
  "Govindraoji Nikam College of Agriculture",
  "College of food Technology",
  "Kai. Rajaram Marathe College of Agriculture",
  "SARASWATI NIGHT DEGREE COLLEGE",
  "College of Agriculture Biotechnology, Kharawate,Dahiwali,Ratnagiri",
  "Shradchandrajee Pawar College of Food Technology",
  "Shradchandrajee Pawar College of Agriculture",
  "DR GUNAWANTRAO SARODE AYURVEDIC MEDICAL COLLEGE, HOSPITAL AND RESEARCH CENTRE, JALGAON KHURD, JALGAON    ",
  "SHRI RAJASTHANI SEVA SANGHS LAW COLLEGE",
  "Late Padmashri Shri. M Tatha Annasaheb Beharay Institute of Hotel Management",
  "MADHUBAN MAHAVIDYALAYA ARTS COMMERCE SAWALIKHEDA TA DHARNI",
  "Vidya Wardhini Sabha's Dr. M. Y. Vaidya Arts, Prof. P. D. Dalal Commerce and Dr. D. S. Shah Science College, Dhule",
  "Maksud Bahuuddeshiya Sevabhavi Sanstha Sanchlit Dr. Abdul Kalam Computer Science And Information Technology College, Neknoor",
  "Jawahar Shikshan Prasarak Sanstha's College of Education Gartad, Tal. & Dist. Dhule",
  "NEW SATARA COLLEGE OF BCA, PANDHARPUR",
  "BALIRAMDADA BANSODE SHIKSHANSHASTRA MAHAVIDYALAYA CHALE. TAL. PANDHARPUR. DIST. SOLAPUR,  MAHARASHTRA.",
  "SHRIMAN BHAUSAHEB ZADBUKE MAHAVIDYALAYA, BARSHI TAL- BARSHI, DIST- SOLAPUR",
  "YASHWANT RAO CHAVAN MAHAVIDHYALAYA KARMALA TAL.KARMALA  DIST-SOLAPUR",
  "SHIKSHAN PRASARAK MANDALS COLLEGE OF PHARMACY AKLUJ TAL MALSHIRAS DIST SOLAPUR",
  "D.S.T.S. MANDAL'S COLLEGE OF PHARMACY JULE SOLAPUR BIJAPUR ROAD SOLAPUR",
  "A.R. BURLA MAHILA VARSIHTHA MAHAVIDYALAYA",
  "Tirupati Teachers College, Arjuni",
  "MADHAN SINHA MOHITE PATIL SCIENCE COLLEGE  TAL.MANGLWADHA DIST-SOLAPUR",
  "BHARAT MAHAVIDYALAYA JEUR- .413202 TAL,KARMALA  DIST, SOLAPUR.",
  "SHRI VITTHAL EDUCATION AND RECARCH INSTIIUTES COLLEGE OF PHARMACY GOPALPUR PB.NO 54 TAL.PANDHARPUR DIST-SOLAPUR",
  "SHRI BABURAO PATIL COLLEGE OF ARTS AND SCIENCE COMM ANGAR  TAL.MOHOL DIST-SOLAPUR",
  "SSAS COLLEGE OF EDUCATION, SOLAPUR ",
  "SHRI VEERTAPASVI CHANNVEER SHIVACHARYA B.ED. COLLEGE SOLAPUR",
  "COLLEGE OF ARCHITECTURE S NO 631A F.P .NO. 34 UJJANI COLONY OLD KUMATA NAKA. DIST SOLAPUR 413003",
  "SMT.KASHIBAI NAVALE COLLEGE OF EDUCATION KAMLAPUR TAL.SANGOLA  DIST-SOLAPUR",
  "KARMAVEER AUDUMBAR PATIL LAW COLLEGE PANDHARPUR DIST-SOLAPUR413304",
  "HIRACHAND NEMCHAND COLLEGE OF COMMERCE ASHOK CHOWK SOLAPUR DIST.SOLAPUR",
  "ARTS AND COMMERCE COLLEG.MADHA 413209 DIST SOLAPUR  MAHARASHTRA",
  "D.B.F. DAYANAND COLLEGE OF ARTS & SCIENCE. DAYANAND NAGER, RAVIWAR PETH-SOLAPUR-413002.",
  "Mehmuda Shikshan & Mahila Gramin Vikas Bahuddeshiya Sanstha's Central India Women's College of Education",
  "NAGAR YUWAK SHIKSHAN SANSTHA AIROLI, NEW HORIZON COLLEGE OF COMMERCE, Plot No. 5, Sector - 13, Airoli,Navi Mumbai - 400 708.",
  "Dnyandeep Education Society's Mahila Shikshanshatra Mahavidyalaya",
  "Shri Swami Samarth Mahila Kala Mahavidyalaya",
  "Godavari Foundation's Dr. Varsha Patil Women's College of Home Science",
  "Regal College for Technology",
  "Modern Shikshan Prasarak Mandal's College of Arts and Commerce",
  "S.N.D.T. Arts & Commerce College for Women",
  "Maharshi Karve Mahila Mahavidalay Ratnagiri",
  "Modern Institute of Paramedical Technology",
  "Modern Shiskshan Prasarak Mandal's Women's B.Ed. College",
  "Ambikabai Jadhav Mahila Mahavidyalaya",
  "Saraswathi Vidya Bhavan's College of Education & Research",
  "Bahinabai Women's College of Education",
  "W.K. Bhagini Seva Mandal's",
  "Maharshi Karve Stree Shikshan Samstha's, K.B. Joshi Insitute of Information Technology,",
  "Janata Shikshan Prasarak Mandal's Mahila Kala Mahavidyalaya",
  "Priyadarshani Women's B.C.A. College",
  "Premlila Vithaldas Polytechnic",
  "Maharshi Karve Stree Shikshan Samstha's School of Fashion Technology",
  "Gandhi Gram Women's B.Ed. College",
  "Jeevan Rekha Pratisthan's Mahila B.C.A. Mahavidyalaya",
  "Shivaji Shikshan Prasarak Mandal's Women's College of Education",
  "Dnyankunj College of Information Technology and Management",
  "Shahu Shikshan Sanstha Pandharpur Venutai Womens College of Education",
  "Bhartiya Gramin Punarachana Sanstha's B.Ed. Women's College,Aurangabad",
  "West Khandesh Bhagini Seva Mandal's Arts and Commerce College for Women",
  "General Education Institute's Mahil Mahavidyalaya",
  "Umer Bin Khattab Welfare Trust's, amu Bai Allana B.Ed. College of Women",
  "Maharshi Karve Mahila Mahavidyalay, Satara",
  "Sambhajirao Shinde College of Education",
  "Shreemati Jamnabai H. Wadhwa College of Technology and Kothari College of Management Studies",
  "Yuva Rashtra Sant Bhayyuji Maharaj B.Ed. Women's College",
  "Jankidevi Bajaj Institute of Management Studies",
  "Gangabai Gobbi Women's College of Education",
  "Nandkishore Bhutada's Foundation SAVVY Group of Colleges",
  "Maniben Nanavati Women's College",
  "SHRI BHAGWAN PRATHISTHAN NATHNAGAR PATHARDIS, NEW BHAGWAN ARTS COMMERCE AND SCIENCE COLLEGE, TANPURWADI TAL. PATHARDI",
  "Loknete Rajarambapu Patil Ayurvedic Medical College and Hospital, Post Graduate Institute and Research Centre- Islampur, Sangli",
  "Sharda Education Societys Anand Vishwa Gurukul Senior Night College, Raghunath Nagar, Next to Mittal Park, Tin Hat Naka, Wagle Estate, Thane",
  "Arts and Commerce College, ASHTA",
  "Sayali Charitable Trust, College of Homoeopathy",
  "S.N.D.T. College of Education,Pune",
  "B.P.H.E. Society's Institute of Management Studies Career Development  and Research IMS Campus, Station Road, Ahmednagar 414001",
  "Rajgad Dnyanpeeth's, Sou. Nirmalatai Thopate College of Education, Bhor, Tal. Bhor, Dist. Pune 412206",
  "Vishwabharati  Academys College of Engineering, Jamkhed Road, Ahmednagar",
  "Rajgad Dnyanpeeths  Shri Chhatrapati Shivajiraje College of Engineering, Dhangwadi, Tal.Bhor, Dist. Pune 412206",
  "Al-Ameen Educational & Medical Foundations Sharadchandraji Pawar College of  Education, Pune",
  "Karmaveer Kakasaheb Wagh Education Societys Arts, Commerce, Science & Computer Science College, Hirabai Haridas Vidyanagari, Adgaon Road, Panchvati, Nashik 422003",
  "Chakan Shikshan Mandal's, Arts and Commerce College, Chakan Aagarwadi Road, Tal. Khed, Dist. Pune-410501",
  "Kasturi Education Sanstha's College of Pharmacy, Shikrapur, Tal.Shirur Dist Pune",
  "Janata Arts, Commerce College, Malkapur",
  "Kanifnath Mahavidyalaya, Kherda, Tq. Karanja(lad).",
  "Shri Madangopalji Mundhada Arts & Commerce College , Chandur Rly.",
  "A.B.M. COLLEGE NAGPUR",
  "K.K.Wagh Education Society's K.K.Wagh Institute of Engineering Education & Research, Hirabai Haribai Vidyanagari, Panchavati, Nashik 422003",
  "Regal College of Technology and Managment",
  "Shree Santkrupa Institute of Engineering And Technology, (B. Tech.) ",
  "DR RAJENDRA GODE AYURVED COLLEGE, HOSPITAL AND RESEARCH CENTRE, AMRAVATI",
  "LOKMANGAL SCIENCE AND ENTREPRENEURSHIP COLLEGE,  WADALA",
  "Maharashtra Education Society's Abasaheb Garware College,Karve Road, Pune 411004",
  "Mahatma Gandhi Sarvodaya Sangh Sanchalit Padmashri Manibhai Desai Mahavidyalaya, Urulikanchan, Pune",
  "Marathwada Kala Varishta Mahavidyalaya, Gharani Road, Nalegaon",
  "Brilliant Mahavidalaya (Evening), Latur",
  "Shri Chhatrapati Shivaji Shikshan Sansthas Shri Chhatrapati Shivaji  Mahavidyalaya, Shrigonda, Dist. Ahmednagar ",
  "Progressive Educational Societys Modern College of Commerce & Computer Studies, Yamunagar,Nigdi, Pune 44",
  "Akole Taluka Education Society's Agasti Arts, Commerce and Dadasaheb Rupwate Science College, Akole, District - Ahmednagar 422601",
  "Indrayani Vidya Mandirs Krishnarao Bhegade Institute of Pharmaceutical Education & Research",
  "Netaji Subhashchandra Bose College of Agriculture, Markhel, Tal. Degloor",
  "College of Food Technology, Parbhani",
  "Vasantrao Naik Gramin College of Agriculture, Nehrunagar, Tal. Kandhar",
  "College of Agriculture, Ambajogai",
  "Late Rajiv Gandhi College of Food Technology, Jintur Road",
  "College og Agriculture, Osmanabd",
  "Late Dadasaheb Patil College of Agriculture, Dahegaon, Tal. Vaijapur",
  "Sou. KSK alias Kaku College of Food Technology, Navgan College Campus",
  "College of Agriculture, Tondapur, Tal. Kalamnuri",
  "College of Agriculture, Latur",
  "College of Agriculture, Naigaon Bazaar, Tal. Naigaon",
  "College of Agricultural Biotechnology, Latur",
  "CSMSS College of Agriculture, Kanchanwadi, Paithan Road",
  "Mahatma Gandhi College of Agril Bio-Technology, Pokharni, Limbgaon",
  "RAJASTHAN RELIEF SOCIETY BAJAJ DEGREE COLLEGE OF ARTS COMMERCE AND SCIENCE",
  "Aditya College of Food Technology, Beed",
  "Shri. Chatrapati Shahu, Phule, Ambedkar College of Agriculture, Ashti",
  "DMV Mandal's College of Agril Bio-Technology, Hatta",
  "Aditya College of Agril Engineering, Telgaon Road",
  "Aditya College of Agril Bio-Technology, Telgaon Road",
  "Ashokrao Mane Institute of Pharmaceutical Sciences and Research, Save,Kolhapur",
  "SHRI SAI JANVIKAS PRATISHTHAN, OJAS ARTS, COMMERCE AND SCIENCE COLLEGE, ROHANWADI, JALNA",
  "ADARSHA SHIKSHAN MANDALIS ADARSHA COMPREHENSIVE COLLEGE OF EDUCATION AND RESEARCH, PUNE",
  "POST GRADUATE INSTITUTE OF POST HARVEST MANAGEMENT, KILLA-ROHA",
  "DR D Y PATIL EDUCATIONAL ENTERPRISES CHARITABLE TRUSTS DR D Y PATIL GROUP OF INSTITUTIONS DR D Y PATIL SCHOOL OF ENGINEERING AND TECHNOLOGY, PUNE",
  "DR D Y PATIL EDUCATIONAL ENTERPRISES CHARITABLE TRUSTS DR D Y PATIL SCHOOL OF ARCHITECTURE, PUNE",
  "DR D Y PATIL EDUCATIONAL ENTERPRISES CHARITABLE TRUSTS DR D Y PATIL SCHOOL OF MCA, PUNE",
  "The Bombay Salesian Societys Don Bosco Institute Technology at Premier Automobile Road Kurla (W) Mumbai 400 070",
  "MES NIGHT COLLEGE OF ARTS AND COMMERCE, PUNE",
  "MAULI PRATISHTHANS SHRIMATI KALAWATI BADHE ARTS AND COMMERCE MAHILA MAHAVIDYALAYA, PUNE",
  "MAVAL SHIKSHAN PRATHISHTHANS SAVITRIBAI PHULE MAHILA MAHAVIDYALAYA, PUNE",
  "SHALAKA FOUNDATIONS KEYSTONE SCHOOL OF ENGINEERING, PUNE",
  "SOCIETY FOR EDUCATION DEVLOPMENT AND RESEARCH IN ARCHITECTURE AND ARTS AAYOJAN SCHOOL OF ARCHITECTURE AND DESIGN, PUNE",
  "LOTUS BUSINESS SCHOOL, PUNE",
  "SHRI DATTAKRIPA SHAIKSHNIK VA KRISHI GRAM VIKAS PRATISHTHANS SAIKRUPA INSTITUTE OF MANAGEMENT SCIENCE, AHMEDNAGAR",
  "PROGRESSIVE EDUCATION SOCIETYS MODERN INSTITUTE OF BUSINESS MANAGEMENT, PUNE",
  "SAIBALAJI EDUCATION SOCIETYS INTERNATIONAL INSTITUTE OF MANAGEMENT AND HUMAN RESOURCE DEVELOPMENT FOR WOMEN, PUNE",
  "SURYADATTA EDUCATION FOUNDATION PUNES SURYADATTA INSTITUTE OF BUSINESS MANAGEMENT AND TECHNOLOGY, PUNE",
  "MATOSHRI EDUCATION SOCIETYS MATOSHRI COLLEGE OF MANAGEMENT AND RESEARCH CENTRE, NASHIK",
  "HON. SHRI BABANRAO PACHPUTE VICHARDHARA TRUST'S, GROUP OF INSTITUTION'S, FACULTY OF MANAGEMENT, KASHTI, TAL.- SHRIGONDA, DIST.-AHMEDNAGAR",
  "Matoshri Kesharbai Kale College of Education, Latur",
  "D.G.B. DAYANAND  LAW COLLEGE. DAYANAND NAGER, RAVIWAR PETH-SOLAPUR-413002",
  "MATOSHRI MIRATAI AHER  COLLEGE OF PHARMACY",
  "DURGAMATA INSTITUTE OF PHARMACY,(B.PHARM) DHARMAPURI-PARBHANI",
  "K. K. Wagh College of Pharmacy, Nashik",
  "MGM New Bombay College of Nursing, Navi Mumbai",
  "MGM School of Physiotherapy, Navi Mumbai",
  "Padmabhooshan Vasantraodada Patil Institute  of   Technology, BUDHAGAON",
  "DNYANSHREE INSTITUTE OF ENGINEERING AND TECHNOLOGY, SATARA",
  "Chintamani B Ed College, Ballarpur",
  "Hightech college of Pharmacy, Morba",
  "Hitkarini Arts College, Armori",
  "Maria College, Mool",
  "Mariya Adhyapak Mahavidyalaya",
  "Mohsinbhai Javeri Girls College, Ballarpur",
  "Shri Shankarrao Bezalwar Arts and Commerce College, Aheri",
  "Matoshri Kaushalyabai Bogawar Arts, Commerce and Science College",
  "Mahatma fule - Dr Babasaheb Ambedkar College, Mindala",
  "Indira Gandhi College, Charmoshi Road, Gadchiroli",
  "Krishnai Shikshan Prasarak Mandal Latur's Janvikas Mahavidyalaya, Bansarola, Tq. Kaij, Dist. Beed",
  "Shri Kisanrao Khobragade Arts, Commerce and Science Mahavidyalaya, Vairagad",
  "Vivekanand Mahavidyalaya, Bhadrawati",
  "Vyankateshwara College of Science Commerce Management Studies, Ghuggus",
  "SHREE L R TIWARI COLLEGE OF ENGINEERING, THANE",
  "LATE DAGOJI PISE COLLEGE NERI",
  "MAHARASHTRA INSTITUTE OF PHARMACY (B.PHARM), CHOUGAN",
  "MAHATMA GANDHI ARTS COLLEGE RAJOLI",
  "S R V COLLEGE NAGBHID",
  "Anand Niketan College of Science, Arts and Commerce, Anandwan, Warora",
  "Aniket Samajkarya Mahavidyalaya, Desaiganj (Wadsa)",
  "Arts Commerce College, Bisi",
  "Arts Commerce College, Gondpipri",
  "Bar. Rajabhau Khobragade College Of Education, Bramhapuri",
  "Sushilabai Ramchandrarao Mamidwar College of Social Work, Chandrapur, Nagpur Road, Padoli, Morva, Post-Tadali ",
  "Late Gyaneshwarji Menghre Education College, Wadsa",
  "Late Nirdhanrao Patil Vaghaye Education College, Armori",
  "Adv. N.S. Ganguwar College of Education, Gadchiroli",
  "Chintamani College of Science, Pombhurna",
  "Shri Shivaji Institute of Engineering and Management Studies, Parbhani",
  "Dr. Khatri Mahavidyalaya, Tukum",
  "Mahila Mahavidyalaya, Gadchiroli",
  "Dr C V Raman Science College, Sironcha",
  "FES Girls College",
  "Saket Gyanpeeths Pramod Ram Ujagar Tiwari Saket Institute of Management, Saket, Saket Nagar, Pune Link Road, Katemanivali, Kalyan (E)-421 306",
  "COLLEGE OF AGRICULTURE, RESOD (KARDA)",
  "ABHINAV EDUCATION SOCIETYS COLLEGE OF COMPUTER SCIENCE AND MANAGEMENT, PUNE",
  "OM JAI SHRIRAM SAMAJ SEVA SANSTHAS JAISHRIRAM COLLEGE OF EDUCATION, PUNE",
  "NASHIK SHIKSHAN PRASARAK  MANDAL'S  NASHIK ARTS AND COMMERCE COLLEGE, IGATPURI, NASHIK ",
  "College of Agri-Business Management, Barshi Road",
  "Postgraduate Institute For Agriculture Business Management, Chakur",
  "College of Agriculture, Dhule",
  "SATPUDA SENIOR COLLEGE",
  "Dr. G.D. Pol Foundations, Y.M.T.  Ayurvedic Medical College and Hospital, Kharghar, Navi Mumbai",
  "YAK EDUCATION TRUST",
  "PRERANA PRATISHTHANS UNIVERSAL COLLEGE OF ENGINEERING AND RESEARCH, PUNE",
  "L.J.N.J. Mahila Mahavidyalaya",
  "S.N.D.T. College of Arts and Smt. C.B. College of Commerce and Science for Women",
  "DR. MOONJE INSTITUTE OF MANAGEMENT & INFORMATION TECHNOLOGY",
  "INDUBAI BHADANE PRATISHTHANS COLLEGE OF PHRAMACY ",
  "PRAKSHCHAND JAIN HOMOEOPATHIC MEDICAL COLLEGE, HOSPITAL AND RESEARCH",
  "MATUSHRI KANBAI LALBAI AND MOTIBAI LOHANA KANYASHALA AND BALIKAGRAH CHARITABLE TRUSTS ADHIA COLLEGE OF LAW",
  "PRASHASKIYA SEVA MAHAVIDYALAY ",
  "DR R N LAHOTI HOMOEOPATHY MEDICAL COLLEGE, HOSPITAL AND RESEARCH CENTER ",
  "GANGABHARATI MAHAVIDYALAY ASHTI",
  "JAI TULJA BHAVANI BAHUUDDESHIYA SEVABHAVI SANSTHAS SAMARTH ARTS COMMERCE AND SCIENCE COLLEGE LAVALE TAL SHAHAPUR DIST THANE",
  "M.S.W.  College Parbhani",
  "Institute of Management and Entrepreneurship Development, Pune",
  "V.K.Krishna Menon College of Commerce & Economics and Sharad Shankar Dighe College of Science and P. A. Menon College of Management, Bhandup - (E), Mumbai - 400042.",
  "Flora College of Architecture",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, MUMBAI",
  "ARTS COMMERCE AND SCIENCE COLLEGE, CHIKALTHAN, CHIKALTHAN",
  "JIJAMATA EDUCATION SOCIETY'S  COLLEGE OF PHARMACY, NANDURBAR",
  "KAI YASHODABAI DAGADU SARAF CHERITABLE TRUST INSTITUTE OF MANAGEMENT AND SCIENCE, SAKEGAON",
  "WELLNESS COLLEGE OF PHYSIOTHERAPHY OSMANABAD",
  "COLLEGE OF PHARMACEUTICAL SCIENCES",
  "SANT GAJANAN ADHYAPAK MAHAVIDYALAY AMBAJOGAI TA AMBAJOGAI DIST AMBAJOGAI",
  "VSS DR SHIVAJI MADAN INSTITUTE OF MANAGEMENT JALNA",
  "Kohinoor Arts, Commerce and Science College, Khultabad, Tq. Khultabad, Dist. Aurangabad",
  "Mahatma Gandhi Vidyamandir's Samajshree Prashantdada Hiray College of Management and Technology, Panchavati, Nashik - 422003",
  "SHRIRAM INSTITUTE OF INFORMATION TECHNOLOGY AT.POST PANIV TAL. MALSHIRAS",
  "SCHOOL OF BROADCASTING & COMMUNICATION, MUMBAI",
  "N.B. NAVALE SINHAGAD COLLEGE OF  ENGINEERING KEGAON  SOLAPUR  PUNE ROAD SOLAPUR -413 304. DIST-SOLAPUR",
  "INSTITUTE OF COMPUTER & MANEGEMENT STUDIES OLD.KARAD NAKA.GEND WASTI, PANDHARPUR",
  "Abasaheb Garware Institute of Management Studies S.T. Stand, Khanbhag,",
  "Sanjivani Rural education Society's Sanjivani Arts, Commerce and Science College  Address: Sanjivani Rural Education Society, At-Sahajnanad Nagar, Taluka- Kopargaon, District-Ahmednagar  Taluka: Kopargaon, District: Ahmednagar",
  "SHIKSHANSHATRA MAHAVIDYALAYA MADHA",
  "NEW MODEL DEGREE COLLEGE, HINGOLI",
  "B C A  COLLEGE CHANDGAD TAL CHANDGAD DIST KOLHAPUR",
  "Seva Shikshan Prasarak Mandals Dr.N.J.Paulbudhe College of Pharmacy",
  "Seth Narsingdas Mor College of Arts & Commerce & Smt.G.D.Saraf Science College, Tumsar-441912, Dist.Bhandara",
  "Shantiniketan Women's College of Education, Kamptee Road, Nagpur",
  "Yoga Mahavidyalaya",
  "Aniket College of Social Work, Wardha",
  "Dr. Rajendra Gode Institute of Pharmacy, Amravati",
  "MAEERS MIT College of Railway Engineering and Research",
  "Manoharbhai Patel Arts Commerce Science College, Sakoli",
  "Ratnadeep College of Arts, Commerce and Science Jamkhed(Ratnapur) Taluka Jamkhed District Ahmednagar(Ms)",
  "S.R. Mahavidyalaya, Suryatola, Gondia",
  "Dr Arun Motghare College of Management, Kosra",
  "Government Education College",
  "Late Nirdhan Patil Vaghaye Arts Commerce and Science College, Mundipaar",
  "Sheeladevi College of Education, Wadi",
  "Kavi Kulguru Institute of Technology and Science,  Ramtek",
  "Arts Commerce College, Patansawangi",
  "Late Sanjay Chahande Arts Sri Parmod Chahande Commerce College,Kanhan",
  "K. D. K. College of Engineering, Nagpur",
  "Late Govindrao Wanjari College of Law",
  "Smt. Rajkamal Baburao Tidke Mahavidyalay, Mouda",
  "Shri M.D. Bonde (Patil) Shikshan Mahavidyalaya, Bramhani, Kalmeshwar",
  "Arts and Science College, Pulgaon",
  "Vidya Vikas Arts, Commerce & Science College, Samudrapur, Dist. Wardha",
  "SHRI GPM DEGREE COLLEGE, MAHATAMA GANDHI ROAD",
  "Guru Nanak Institute of Technology, Dahegaon",
  "Wainganga College of Engineering and Management, Dongargaon, Nagpur",
  "Smt. Shyampatidevi Mishra Educational Trust SHRI GPM DEGREE COLLEGE OF SCIENCE AND COMMERCE , TELLI GALI, ANDHERI EAST",
  "Vidya Pratishthan Supe Arts, Science and Commerce College, Supe, Taluka - Baramati, District - Pune 412204",
  "VIDYA PRATISHTHANS INDAPUR COLLEGE OF ARCHITECTURE",
  "MAHATAMA JYOTIBA PHULE EDUCATION TRUSTs S N G INSTITUTE OF MANAGEMENT & RESEARCH, KHED",
  "Bharati Vidyapeeths Institute of Management Studies & Research",
  "Punjabhai Patel College of Education",
  "Laxmi Charitable Trusts Sheth L.U. Jhaveri College of Arts and Sir M.V. College of Science and Commerce",
  "Late Parvatabai Madankar Arts College, Warthi",
  "Saraswati Bahuuddeshiya Savabhavi Sanstha, Gojegaon, Ta. Mukhed, Nanded",
  "MSSM College of Agriculture, Kharpudi, Bhatepuri Road",
  "Shri Samarth Arts and Commerce College, Ashti",
  "Sri Sant Gadge Maharaj College, Hingna",
  "Dr S Radhakrishnan Education College, Sakoli",
  "JAMIA COLLEGE OF LAW",
  "SAVITRIBAI PHULE MAHILA MAHAVIDYALAY KUMBHEFAL JALNA",
  "Terna Medical College, Nerul, Navi Mumbai",
  "COLLEGE OF AGRI-BIOTECHNOLOGY ,SARALGAON",
  "TRIMURTI SHIKSHAN PRASARAK MANDALS  SHILPKAR LAW COLLEGE, LONIKAND RAMNAGAR, WAGHOLI,  TAL HAVELI, DIST PUNE  ",
  "SNJB'S SMT. K. B. ABAD HOMOEOPATHIC MEDICAL COLLEGE, SHRI. R. P. CHORDIYA HOSPITAL AND BHAMASHAH SHRI. V. D. MEHTA, DEV VIJAY P. G. INSTITUTE OF HOMOEOPATHY AND RESEARCH CENTRE, CHANDWAD, DIST. NASHIK",
  "SOMAYYA INSTITUTE OF NURSING , BHADRAWATI",
  "ARTS SCIENCE & COMMERCE COLLEGE SHIVAJINAGAR GADHI",
  "BABAN DADA PATIL COLLEGE OF PHYSIOTHERAPY ",
  "VIDYA VARIDHI MAHILA MAHAVIDYALAYA",
  "SHETKARI SHIKSHAN PRASARAK MANDAL MAHESH INSTITUTE OF ENGINEERING AND TECHNOLOGY,ASHTI TAL ASHTI DIST BEED",
  "Aditya Institute of Pharmaceutical",
  "Utkranti Law College, Jarud.Tq.Warud Distt-AmravatI",
  "Late Nirdhanrao Patil Waghaye Arts, Commerce and Science College, Andhalgaon",
  "Shahu Shikshan Sanstha Pandharpur, Adhyapak Mahavidyalaya (B.Ed.) ,Shahad (W) Kalyan Dist.Thane - 421 103",
  "Bhai Kishanrao Deshmukh Mahavidyalaya, Chakur",
  "Mahalaxmi Jagdamba college of Library Science, Nagpur",
  "Srikrishna Physical Education College",
  "Late Sri K G Chowdhari College, Arvi",
  "RAHUL SHIKSHAN PRASARAK MANDAL, SATYAGRAHA COLLEGE OF EDUCATION, NAVI MUMBAI",
  "Revnath Choure College, Saoner",
  "Late HPS Arts Commerce Science College,, Pavni",
  "Dr. Ambedkar College, Deekshabhoomi",
  "Chetna Shikshan College, Deoli Road",
  "Tirupati Arts Commerce Science College, Kitali",
  "SHANTINIKETAN BUSINESS SCHOOL",
  "Ranibai Agnihotri Sharirik Shikshan Mahavidyalaya, Wardha",
  "Saket College of Physical Education Gondia",
  "Institute of Science, Nagpur",
  "YUVAK VIKAS MANDAL SANCHALIT ARTS, COMMERCE AND SCIENCE COLLEGE BHALAVALI",
  "ZULEKHA COLLEGE OF EDUCATION, SHANTI NAGAR ",
  "Annasaheb Gundawar College, Katol Road",
  "Vidyasagar Educational Institution's Vidyasagar Arts College, Khaeri",
  "Sonekar B Ed College Koradi",
  "Aakar Institute of Management and Research Studies, Shankar Nagar",
  "Mukund College, Dighori",
  "Shri. Madhaorao Wankhade Sharirik Shikshan Mahavidyalaya, Kamptee",
  "Prajasattak Arts Commerce and Science College",
  "Dr Ambedkar Institute of Management Studies Research, Deekshabhoomi",
  "CITY PREMIER COLLEGE, HINDUSTAN COLONY, WARDHA ROAD, NAGPUR",
  "Government College of Art and Design, Laxminagar, Nagpur",
  "SUDHA SURESHBHAI MANIAR COLLEGE OF COMPUTER AND MANAGEMENT",
  "Maratha Shikshan Sanstha P.R.Patil Shikshan Mahavidyalay, Talegaon, Wardha",
  "Smt Kishoritai Bhoyar College of Pharmacy, Kamptee",
  "Late Rajendrasingh urf Baba Vyas Arts Commerce College Kondhali",
  "Samta Shikshan Mahavidyalaya, Movad",
  "Women's Arts and Commerce College, Nandanvan",
  "NIT Graduate school of Management, Katol Road",
  "Bar. Sheshrao wankhede Arts and Commerce College, Mohpa",
  "Purna Education College, Khamari",
  "Kinkar College of Education, Seloo, Wardha",
  "JAN UTKARSHA PRABODHINI ARTS SCICE AND COMMERCE COLLEGE, THANE",
  "RS Bidkar Arts Commerce Science College, Hinganghat",
  "Bapurao Deshmukh Engineering College, Sewagram",
  "Pankaj P Tijare College,, Veltur",
  "K. Manoharrao Kamdi College, Chitnavispura, Mahal",
  "Govindrao Sekasariya Commerce College",
  "Gurunanak College of Pharmacy, Dikshit nagar",
  "Social Work College, Kamptee",
  "SWARAJ INSTITUTE OF MANAGEMENT, SATARA",
  "SMT VIJAYADEVI DESAI SENIOR COLLEGE, SATARA",
  "Dr. BRA Law College, Nara Road",
  "MAITREYA  BAHUUDDESHIYA  SEVABHAVI SANSTHA'S G.K.S. COLLEGE OF ARTS ,COMMERCE AND SCIENCE KHADAVALI, TAL.- KALYAN ,DIST.-THANE, MAHARASHTRA -421605.",
  "SANT GAJANAN MAHARAJ COLLEGE OF ENGINEERING, KOLHAPUR",
  "ARTS, COMMERCE AND SCIENCE MAHILA MAHAVIDYALA, KASABA BEED",
  "Shamrao Bapu Kapgate Arts College Sakoli",
  "Smt. Kaushalyadevi Maheshwari Mahila Mahavidyalaya, Nagpur",
  "HABIB EDUCATIONAL AND WELFARE SOCIETYs MS COLLEGE OF LAW, THANE",
  "MODEL COLLEGE OF ARTS COMMERCE SCIENCE, RATNAGIRI",
  "VAIJANATHRAO MUKUNDRAO DESHMUKH V M D COLLEGE OF NURSING",
  "SHRI DNYANESHWAR MAHAVIDYALAY MALHIVARA TQ AND DIST HINGOLI ",
  "SAHYADRI ARTS COMMERCE AND SCIENCE COLLEGE SAWARGAON",
  "AJANTA ARTS AND SCIENCE COLLEGE GHOSALA",
  "DR A PA J ABDUL KALAM ARTS AND SCIENCE COLLEGE SILLOD",
  "SYMBIOSIS Centre for Management Studies, Nagpur",
  "DR A P J ABDUL KALAM ARTS AND SCIENCE COLLEGE SAROLA",
  "IDEAL COLLEGE OF ARTS COMMERCE AND SCIENCE",
  "SARHAD LAW SCHOOL",
  "PRIN DR BHAGWAN PRADHAN WOMENS COLLEGE",
  "TELUGU SAMAJ SHIKSHAN SANSTHA P E M NIGHT DEGREE COLLEGE",
  "G H Raisoni College of Arts, Commerce and Science",
  "Vinayak Vidhi Mahavidyalaya, Chatri Talao Road, Amravati.",
  "INDIRA GLOBAL SCHOOL OF BUSINESS",
  "Shri Khanderai Pratishthans Shri Martand Bhairav Adhayapak Mahavidyalaya Balewadi Pune",
  "Rizvi Education Societys College of Engineering Bandra (West) Mumbai-400 050",
  "VITTHAL PRATISTHAN COLLEGE OF PHARMACY ",
  "ONKAR BAHUUDDHESHIYA VIKAS SANSTHA NIKAM COLLEGE OF PHARMACY",
  "DR ABDUL GAFFAR MALIK COLLEGE OF ARTS SCIENCE AND COMMERCE JALGAON",
  "S P INGLE MAHAVIDYALAY ASTUL ",
  "KARANJEKAR COLLEGE OF ENGINEERING AND MANAGEMENT SAKOLI",
  "NAVYUVA COLLEGE OF NURSING, BHANDARA",
  "PHARATE PATIL BSC NURSING COLLEGE ",
  "THE ROYAL GONDWANA COLLEGE OF PHARAMCY, NAGPUR",
  "BIRSA MUNDA GADCHIROLI COLLEGE",
  "Shri. Bhimrao Shinde Arts,Commerce & Science Mahila Mahavidyalaya, Wai",
  "Homeopathic Medical College, Pune",
  "Arts, Comm. & Science College UMADI",
  "Niora Arts, Commerce Mahila Mahavidyalaya, Gadhinglaj,",
  "Vishwakarma Dadasaheb Chavan Institute of Management and Research,Malawadi",
  "NASHIK JILHA AHILYADEVI SHIKSHAN PRASARAK MANDALS RODU ANNA GOVINDRAO PATIL VARISHTHA MAHAVIDHYALAY JALGAON NI TA MALEGAON DIST ",
  " Vishnu Waman Thakur Charitable Trust's VIVA Institute of Technology at Shirgoan Post Virar Tal- Vasai Dist. -Palghar -401305",
  "LATE NANKUBAI KHUSHAL KAPSE ARTS SCIENCE AND COMMERCE NIGHT COLLEGE GONDIA",
  "SARASWATI GIRLS COLLEGE",
  "P V BELHEKAR AYURVED MEDICAL COLLEGE BHANASHIWARE TAL NEWASA DIST AHMEDNAGAR",
  "SHRI SAMARTH ARTS , COMMERCE AND SCIENCE COLLEGE ABHONA TAL KALWAN DIST NASHIK",
  "Pune District Education Associations Seth Govind Raghunath Sable College of Pharmacy, Saswad",
  "Shri Tulshiramji Jadhao Arts and Science College, Washim.",
  "SYMBIOSIS INSTITUTE OF TECHNOLOGY, NAGPUR",
  "SYMBIOSIS School of Planning, Architecture and Design, Nagpur",
  "SYMBIOSIS Institute of Technology, Pune",
  "RAJMATA JIJAU SHIKSHAN PRASARAK MANDALS ARTS COMMERCE NIGHT COLLEGE LANDEWADI BHOSARI ",
  "GOVERNMENT MEDICAL COLLEGE AND HOSPITAL, SATARA",
  "SES'S R.C.PATEL INSTITUTE OF TECHNOLOGY, SHIRPUR",
  "SANT GAJANAN MAHARAJ COLLEGE OF NURSING, MAHAGAON ,SITE CHINCHEWADI",
  "ASHOKRAO MANE AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "KARMVEER BHAURAO PATIL ARTS COMMERCE AND SCIENCE COLLEGE PUSESAVLI TAL KHATAV DIST SATARA",
  "MMPPCTs ASHWINI RURAL MEDICAL COLLEGE, HOSPITAL AND RESEARCH CENTRE, KUMBHARI",
  "DEVAASHISH LAW COLLEGE, ARJUNNAGAR TAL KAGAL DIST KOLHAPUR",
  "NALANDA MAHAVIDHYALAY CHIKANI DOGMA TAH NER DIST YAVATMAL",
  "KAL DR SUBHASHRAO DHAKNE BAHUUDDESHIYA SEVABHAVI SANSTHA, DR SUBHASHRAO DHAKNE LAW COLLEGE ROHANWADI TQ DIST JALNA",
  "M S COLLEGE OF MANAGEMENT",
  "NAGAR SHIKSHAN VIKAS MANDALS MADHAVRAO PATIL COLLEGE OF PHARMACY",
  "RITIKA MUCHHALA EDUCATION AND RESEARCH FOUNDATION AARAV MUCHHALA SENIOR COLLEGE OF ARTS, COMMERCE AND SCIENCE, THANE ",
  "BR NATH PAI ARTS COMMERCE AND SCIENCE NIGHT COLLEGE KUDAL",
  "SATPUDA NURSING INSTITUTE SHEGAON",
  "BHARAT SHIKSHAN SANSTHAS TATYARAOJI MORE COLLEGE OF PHARMACY UMERGA OSMANABAD ",
  "School of Physiotherapy, Sangli",
  "CHATRAPATI SAMBHAJI RAJE MANAGEMENT SCIENCE COLLEGE",
  "JAIHIND COLLEGE OF PHARMACY",
  "SINDHUTAI SAPKAL MAHILA MAHAVIDYALAYA BADEGAON CHARGAON SAONER ",
  "TRIMURTI SHIKSHAN PRASARAK MANDALS, TRIMURTI INSTITUTE OF PHARMACY",
  "THE GREAT EASTERN INSTITUTE OF MARITIME STUDIES",
  "RAJESH RATHOD MAHAVIDYALY WATUR",
  "RAJESH RATHOD MAHAVIDYALY MANTHA",
  "JIJAMATA COLLEGE OF BSC NURSING",
  "SHAKUNTALA PATIL BAHUUDDESHIYA SANSTHAS SHATABDI INSTITUTE OF PHARMACY",
  "MAHATMA BASWESHWAR MAHAVIDYALAYA OSMANNAGAR TQ KANDHAR DIST NANDED",
  "ARTS AND SCIENCE COLLEGE LOHGAON",
  "YASHWANTRAO BHONSALE INSTITUTE OF TECHNOLOGY",
  "K S S MAHAVIDYALAY AJIJIYA NAGAR DIST PARBHANI",
  "RAIGAD INSTITUTE OF NURSING EDUCATION",
  "RASHTRIYA  SHIKSHAN SANSTHAS SWAMI VIVEKANAND LAW COLLEGE DOMBIVLI EAST",
  "RUKHMINI AYURVEDIC MEDICAL COLLEGE, VELHALE",
  "INDIAN INSTITUTE OF MEDICAL SCIENCES  AYURVEDIC COLLEGE HOSPITAL",
  "MANJU INSTITUTE OF HOTEL MANAGEMENT",
  "LOKARPAN MAHAVIDYALAY WARTHI",
  "LOKARPAN MAHAVIDYALAY GANGALWADI",
  "ORANGECITY INSTITUTE OF NURSING",
  "DHARTI JANSEVA PRATISTHANS, OJAS COLLEGE OF NURSING B SC , ROHANWADI, REVGAON ROAD, JALNA",
  "ALLAM PRABHU COLLEGE OF PHARMACY",
  "VAISHALITAI JONDHALE COLLEGE OF PHARMACY B PHARM",
  "SHIKSHAN PRASARAK SANSTHAS MBA INSTITUTE SANGAMNER ",
  "BHARATI VIDYAPEETH COLLEGE OF PHARMACY, PALUS",
  "RADHABAI SHINDE COLLEGE OF PHARMACY, GADHINGLAJ",
  "Dada Ramchand Bakhru Sindhu Mahavidyalaya, Nagpur",
  "JAIHIND COMPREHENSIVE EDUCATIONAL INSTITUTES JAIHIND INSTITUTE OF MANAGEMENT AND RESEARCH",
  "BHAIRVNATH MAHAVIDYALAY TADSONNA TQ DIST BEED ",
  "NOOTAN COLLEGE OF PHYSIOTHERAPY  KAVATHEMAHANKAL",
  "SHAHAJIRAO PATIL VIKAS PRATISHTHANS S B PATIL COLLEGE OF PHARMACY INDAPUR VILLAGE VANGALI PUNE SOLAPUR HIGHWAY TALUKA INDAPUR DIST PUNE",
  "SMT VIMLADEVI VAGHECHA NURSING COLLEGE, SAKET ROAD, MAJIWADA, THANE WEST",
  "THE ROYAL GONDWANA NURSING COLLEGE",
  "LATE SHREE FAKIRBHAI PANSARE EDUCATION FOUNDATIONS COLLEGE OF PHARMACY ",
  "PRIYADARSHANI SHAIKSHANIK AND SAMAJIK VIKAS MANDAL SAILEE DEGREE COLLEGE",
  "SCHOLARS COLLEGE SADAK ARJUNI",
  "UMATAI MAHAVIDYALAYA RAWANWADI",
  "PROF MANJUNATH ACHARYA COLLEGE OF PROFESSIONAL STUDIES",
  "NATIONAL ARTS AND SCINCE COLLEGE ANDHARI",
  "Adarsh Vidya Prasarak Sanstha's Adarsh College of Arts & Commerce, Kulgaon, Badlapur, Dist. Thane-421503",
  "3143-THAKUR SHYAMNARAYAN ENGINEERING COLLEGE",
  "MAHARASHTRA INSTITUTE OF PHARMACEUTICAL SCIENCES, LATUR",
  "CHHATRAPATI SHAHU MAHARAJ ARTS, COMMERCE AND SCIENCE COLLEGE    ",
  "Government of Maharashtra Ismail Yusuf  College of Arts Science & Commerce Jogeshwari East Mumbai  400 060",
  "Shri. M.D. Shah Mahila College of Arts & Commerce",
  "YSPMS YASHODA COLLEGE OF PHARMACY, SATARA    ",
  "Yashwantrao Mohite College of Arts, Science and Commerce, Pune",
  "SVP COLLEGE OF PHARMACY  (B.PHARM), HATTA TQ. BASMATH DIST. HINGOLI",
  "KARMVEER DR MAMASAHEB JAGDALE COLLEGE OF AGRICULTURE, BARSHI TAL BARSHI DIST SOLAPUR    ",
  "SAHYADR INSTITUTE OF BSC NURSING EDUCATION CHINCHOLIRAO LATUR    ",
  "DEVI MAHALAXMI COLLEGE OF ENGINEERING AND TECHNOLOGY    ",
  "MKD INSTITUTE OF TECHNOLOGY ,VIRCHAK NANDURBAR    ",
  "SHREE SANATAN DHARAM COLLEGE OF COMMERCE    ",
  "K H F  College of Arts Commerce and Science Hardoli Janzad",
  "Mangaon Shikshan Prasarak Mandals D. G. Tatkare Mahavidyalay Arts, Science, Commerce, Near by Dist. Court, Old Mangaon, Tal. Mangaon, Dist. Raigad-402104",
  "Shri Shivaji Maratha Societys Samaj Bhushan Baburao alias Appasaheb Jedhe Arts,Commerce & Science College,Pune",
  "The South Indian Education Societys College of Commerce and Economics  Sion Matunga Estate Sion East Mumbai",
  "Yashavantrao Chavan Institute of Science, Satara",
  "Dhananjayrao Gadgil College of Commerce, Satara",
  "Chhatrapati Shivaji College",
  "Bharati Vidyapeeth Deemed to be University School of Audiology and Speech Language Pathology",
  "Agashi Virar Arnala Education Society's Padmashree Bhausaheb Vartak College, Jivdani Panch Payri, Naringi,  Virar (E), Dist. Palghar-401305",
  "HITKARNI COLLEGE OF LAW",
  "College of Architecture, Pune",
  "Bharati Vidyapeeth Deemed to be University Department of Engineering and Technology Off-Campus",
  "Bharati Vidyapeeth ( Deemed to be University) Dental College and Hospital, Navi Mumbai",
  "Abhijit Kadam Institute of Management and Social Sciences, Solapur",
  " Nava Samaj Mandal Degree College, Dixit Road No.1 Vile Parle, (E), Mumbai-400 057",
  "PARVAZ INSTITUTE OF ARTS, COMMERCE AND SCIENCE GIRLS SENIOR COLLEGE, MILLAT NAGAR, GOWALKOT ROAD,TAL CHIPLUN ,DIST RATNAGIRI    ",
  "Shri Sharadchandraji Pawar Senior College, Narangwadi, Tq. Omerga, Dist. Osmanabad",
  "Dr. Panjabrao Alias Bhausaheb Deshmukh Memorial Medical College, Amravati",
  "Bhimthadi Education Society's, Late. K. G. Kataria College. Daund. Tal. Daund Dist Pune 413 801",
  "ARTS COMMERCE AND SCIENCE COLLEGE KUMBHARI TAL JAT DIST SANGLI",
  "ARYA SENIOR COLLEGE, MANJARI",
  "ADARSH MAHAVIDYALAYA, KHADAKWADI, TAL PARNER, DIST AHMEDNAGAR",
  "OJAS COLLEGE OF PHYSIOTHERAPY ",
  "DR B B KHALADKAR BSC NURSING COLLEGE, TAL DAUND DIST PUNE",
  "Shramjivi College of Education, Omerga",
  "Excelsior Education Society's K. B. College of Arts and Commerce for Women, Mithbunder Road, Kopri, Dist. Thane (East) - 400 603",
  "D Y PATIL COLLEGE OF PHARMACY",
  "Kai. Rasika Mahavidyalaya, Deoni",
  "Dr.Rajendra Gode Institute of Technology & Research, Mardi Road, Amravati",
  "Shri Sevadas Shikshan Prasarak Mandal Mahatma Gandhi B.Ed College, CIDCO, New Nanded",
  "Vidya Pratishthan's Vasantrao Pawar Law College, Vidyanagari, M.I.D.C. Bhigwan road, Baramati, Dist. Pune 413133",
  "Nagarjuna Institute of Engineering, Technology and Management",
  "ANEKANT EDUCATION SOCIETYS COLLEGE OF PHARMACY BARAMATI    ",
  "Nandigram Institute of I.T. , Taroda, Nanded",
  "130083-MAHATMA PHULE SAMAJIK AND SHAIKSHANIK VIKAS MANDALACHE MAHATMA PHULE ARTS AND SCIENCE COLLEGE, CHALISGAON TAL.CHALISGAON DIST. JALGAON",
  "Bharati Vidyapeeth's Dr. Patangrao Kadam Mahavidyalaya, Sangli",
  "Vaibhav Shikshan Sanstha,College of Education (B.Ed.), Vita Tal - Khanapur Dist - Sangli",
  "Smt. C.B. Shah Mahila Mahavidyalaya, Sangli",
  "Indraprastha New Arts Commerce and Science College, Wardha",
  "Chaudhary Atarsingh Yadav Memorial Education Trusts Siddhant Institute of Computer Application, Pune Maharashtra",
  "VISHAL SHIKSHAN PRASARAK MANDAL DHULE SANCHALIT PROF. A. B. PATIL ARTS COMMERCE AND SCIENCE COLLEGE, MAHINDALE TAL.DHULE DIST. DHULE",
  "230056-SATPUDA SHIKSHAN PRASARAK MANDAL SANCHALIT VASANTRAO NAIK ARTS SCIENCE AND COMMERCE COLLEGE, SHAHADA TAL. SHAHADA DIST. NANDURBAR",
  "Children Werlfare Centre's College of Law ,Valnai Village,Marve Road ,Orlem Bavadi Stop,Malad (W) Mumbai 400 064",
  "230099-SHRI SAIBABA BHAKTA MANDAL SANCHALIT, KALA  VARISHTHA  MAHAVIDYALAY, MHASAWAD TAL. SHAHADA DIST. NANDURBAR",
  "Dalvi Educational & Charitable Trust's Dalvi College of Arts, Commerce and Science, Group Grampanchayat Shirgaon, At. Shenale, Post. Soveli, Tal. Mandangad, Dist. Ratnagiri",
  "SARASWATI INSTITUTE OF PHARMACY, PANGRI, NANDED",
  "SHRI ANANDRAO ABITKAR ARTS COMMERCE AND SCIENCE MAHAVIDYALAYA KADGAON TAL BHUDARGAD DIST KOLHAPUR",
  "JIJAMATA MAHAVIDYALAYA DURGMANWAD TAL RADHANAGARI DIST KOLHAPUR",
  "Shri Neminath Jain Brahmacharyashram's Shriman Sampatlalji Pemrajji Surana Law College, Chandwad,Tal, Chandwad, Dist., Nashik 423101",
  "UTKARSH ART, COMMERCE AND SCIENCE COLLEGE, SINDKHED RAJA",
  "VITTUJI ARTS COMMERCE AND SCIENCE COLLEGE MOHADI TAH MOHADI DIST BHANDARA",
  "SHRI VIVEKANAND MESHRAM ARTS COMMERCE AND SCIENCE COLLEGE RUPERA SIHORA TAH TUMSAR DIST BHANDARA",
  "TREATWELL COLLEGE OF NURSING",
  "HEALING HANDS COLLEGE OF PHYSIOTHERAPY",
  "MANWATKAR COLLEGE OF NURSING,  AT GHODPETH, TAH BHADRAWATI, DIST CHANDRAPUR ",
  "ANAND COLLEGE OF PHYSIOTHERPAY",
  "ADARSH MAHAVIDAYALAY JAMKHED ",
  "SAHYADRI MAHAVIDYALAY SAWARGAON",
  "AJANTA MAHAVIDYALAY GHOSALA",
  "SANT GAJANAN MAHARAJ MAHAVIDHYALAY NIMKARDA",
  "Rajgad Dnyanpeeth's, Anantrao Thopte College, Bhor, Dist- Pune 412206",
  "Padmabhushan Dr. Krantiveer Nagnathanna Naikwadi Kala Mahavidyalaya, Zare, Tal. Atpadi Dist. Sangli",
  "280061-A. S. S. P. MANDAL'S MAHARAJ J. P. VALVI ARTS, COMMERCE & SHRI V. K. KULKARNI SCIENCE COLLEGE, DHADGAON TAL AKRANI DIST NANDURBAR",
  "INDIRA COLLEGE OF PHYSIOTHERAPY, VISHNUPURI, TAL  DIST NANDED ",
  "Indapur Taluka Shikshan Prasarak Mandal, College of Arts Bhigwan, A/P- Bhigwan, Ta- Indapur, Dist- Pune 413130",
  "Nirmala Memorial Foundation College of Education. D.S.Road, Asha Nagar, Thakur Complex, Kandivali (E) Mumbai  400 101",
  "Chandrakant Yashwant Dangat Patil Shikshan & Krida Mandal's, Shiv Chatrapati Arts & Commerce College, S. No. 46, Vidyanagar, Wadgaon Bk, Tal. Hawali, Pune - 41",
  "MAHATMA EDUCATION SOCIETYS PILLAI HOC COLLEGE OF EDUCATION AND RESEARCH ",
  "Seva Shikshan Prasarak Mandal's  Dr. N. J. Paulbudhe College of Education, Shaneshwar Nagar, Vasant Tekdi, Ahmednagar, Tal. Ahmednagar, Dist. Ahmednagar 414003",
  " Late Pandurang Patil Nursing College (B.Sc.),   At. post  Kanheri (Sarap), Tal. Barshitakli, Dist. Akola",
  "PVG COLLEGE OF EDUCATION AND RESEARCH, NASHIK",
  "Saraswati Bahuddeshiya Samaj Shikshan Sanstha, Bonde B.Ed. College, Khapri, Kalmeshwar, Nagpur",
  "Sainath Education Trust's Rajiv Gandhi College of Arts, Commerce and Science, Plot No. 16 / 17, Sector 10/A, Juhu Nagar, Vashi, Navi Mumbai - 400 703",
  "LATE SHRI. MALLAJI ATRAM ARTS, SCIENCE AND COMMERCE COLLEGE, MULCHERA",
  "D.E.Society's Brijlal Jindal College of Physiotherapy, Pune",
  "ANURAG COLLEGE OF PHARMACY ",
  "Amro College of Hotel Management's, Amro Institute of Management, Surajkund, Rajurbahula, Ta: Nashik, Dist : Nashik 422010",
  "GAWARABAI ARTS COLLEGE, ZALIYA",
  "Hutatma Rashtriya Arts and Science College, Ashti, Dist-Wardha",
  "230102-SHAHADA TALUKA EDUCATIONAL SOCIETY & CO-OPERATIVE EDUCATIONAL SOCIETY LTD. INSTITUTE OF MANAGEMENT RESEARCH & DEVELOPMENT, SHAHADA",
  "230078-SHAHADA TALUKA EDUCATIONAL SOCIETY & CO-OPERATIVE EDUCATIONAL SOCIETY LTD. SCIENCE SENIOR COLLEGE, SHAHADA DIST- NANDURBAR",
  "Sree Narayana Mandira Samiti, Sree Narayana Guru College of Education (B.Ed.), Plot No. 1, 2 & 3, Khasra No. 96, Borla, P. L. Lokhande Marg, Chembur, Mumbai - 400 089",
  " D.Y. Patil Technical Campus, Faculty of Engineering and Faculty of Management, Talsande, Kolhapur",
  "Zulekha College of Commerce, Science and Technology",
  "KARMAVIR EKNATH AAWAD MAHAVIDYALAY, TELGAON",
  "SANT GAJANAN MAHARAJ MAHAVIDYALAYA",
  "SOMAYYA INSTITUTE OF PHARMACY    ",
  "VITTHALA ARTS, COMMERCE AND SCIENCE SR COLLEGE",
  "DNYANDEEP SHIKSHAN PRASARAK MANDAL , KHED RATNAGIRI, DNYANDEEP COLLEGE OF PHARMACY, BORAJ",
  "SHARDA EDUCATION CHARITABLE TRUSTS KESARDEVI MISHRA DEGREE COLLEGE",
  "SHARDA EDUCATION CHARITABLE TRUSTS KRM DEGREE COLLEGE",
  "P K BOPCHE KALA SCIENCE AND VANIJYA MAHAVIDHYALAYA KURHADI TAH GOREGAON DIST GONDIA",
  "COLLEGE OF AGRICULTURE, KASHTI, MALEGAON ",
  "COLLEGE OF FOOD TECHNOLOGY, KASHTI, MALEGAON ",
  "COLLEGE OF AGRICULTURE ENGINEERING AND TECHNOLOGY ",
  "COLLEGE OF HORTICULTURE, KASHTI, MALEGAON ",
  "ADITYA DIPLOMA INSTITUTE OF PHARMACY,BEED",
  "SHRIGANESH RAMCHANDRA KATRUWAR COLLEGE OF PHARMACY MANWATH",
  "KASAI COLLEGE GOSHEGAON",
  "Tatkare Charitable Trusts, Kolad, Dr. Shree Nanasaheb Dharmadhikari Arts, Commerce & Science College, Gove-Kolad, Tal. Roha, Dist. Raigad, Pin - 402 304",
  "SOMAYYA INSTITUTE OF TECHNOLOGY CHANDRAPUR    ",
  "SHIVAJI SHIKSHAN SANSTHAs SCIENCE AND COMMERCE COLLEGE, (NIGHT) PANT NAGAR",
  "TULASKAR INSTITUTE OF SCIENCE AND TECHNOLOGY HINGANGHAT",
  "ADARSH EDUCATION COLLEGE",
  "M.R.T. COLLEGE FOR WOMEN’S AMRAVATI",
  "Ramanand Arya D.A.V. College, Station Road Datar Colony Bhandup East Mumbai",
  "Mahatma Education Societys Pillai College of Engineering, Dr. K. M. Vasudevan Pillais Campus, Panvel, Raigad",
  "NITYASEVA HOSPITAL COLLEGE OF NURSING SHEVGAON, DIST AHMEDNAGAR    ",
  "MAA JIJAU MAHILA MAHAVIDYALAY TARODA NANDED    ",
  "SAS INSTITUTE OF MANAGEMENT STUDIES",
  "PIMPRI CHINCHWAD EDUCATION TRUST'S PIMPRI CHINCHWAD COLLEGE OF ENGINEERING AND RESEARCH, LAXMINAGAR, RAVET",
  "SHRI GAJANAN MAHARAJ SHIKSHAN PRASARAK MANDALs SHARADCHANDRA PAWAR INSTITUTE OF MANAGEMENT, DUMBERWADI, KHAMUNDI, JUNNAR",
  "BOMBAY BUNTS ASSOCIATIONS BUNTS COLLEGE OF HIGHER EDUCATION (NIGHT COLLEGE)",
  "KAI. DIGAMBARRAOJI DEVDE MAHAVIDHYALAYA LAHAN TQ ARDHAPUR DIST NANDED",
  "APURVA VARISTHA MAHAVIDYALAY, KHAIRAV",
  "S.I.W.S. N.R. Swamy College of Commerce & Economics and Smt. Thirumalai College of Science, Major R. Parmeshwaran Marg, Sewri Wadala Estate, Wadala, Mumbai",
  "ROKDESHWAR SANKAR VARISHTH MAHAVIDYALAY UJJAINPURI TA. BADNAPUR DIST. JALNA",
  "S.I.E.S (Nerul) College of Arts, Science and Commerce, Sri Chandrasekarendra Saraswati Vidyapuram, Plot No One C,  Sector V, Nerul, Navi Mumbai",
  "Vivekanand Education Societys Institute of Technology",
  "Mahavir Education Trusts Shah and Anchor Kutchi Engineering College Shivaji Chowk Junction V N  Purav Marg Opp R K Studio Near M s Dukes Co Chembur Mumbai",
  "DR. A.P.J. ABDUL KALAM ARTS, COMMERCE AND SCIENCE COLLEGE",
  "Prince of wales museum of western india",
  "DR PRAFULLA PATIL BSC NURSING COLLEGE PARBHANI",
  "Sahyog Pratishthans, Sahyog College of Management Studies, Indraratna Palace, B- Wing, 2nd Floor, Jambhali Naka, Thane (W) - 400 601",
  "200121-STREE SHIKSHAN SANSTHA'S SUNDARBAI MAGANLAL BIYANI LAW COLLEGE, DHULE",
  "SHRI GURUDEO ADIVASI SHIKSHAN PRASARAK MANDAL'S KIRSAN'S MISSION INSTITUTE OF MANAGEMENT",
  "PRAVARA MEDICAL TRUST'S ARTS, COMMERCE AND SCIENCE COLLEGE, SHEVGAON",
  "SAHYADRI SHIKSHAN SANSTHAS SAHYADRI INSTITUTE OF MANAGEMENT AND RESEARCH, SAWARDE, CHIPLUN",
  "Janta College",
  "SANT GADGEBABA VARISHTHA MAHAVIDYALAY PRASHASKIY SEVA DHORKIN TQ PAITHAN DIST AURANGABAD",
  "ANANTRAO PAWAR COLLEGE OF ARCHITECTURE, PARVATI",
  "SHRI SAI MAHAVIDYALAYA AMADABAD",
  "PRAVARA RURAL EDUCATION SOCIETY'S COLLEGE OF ARCHITECTURE, MOHU, SINNAR",
  "Finolex Academy of Management & Technology",
  "BHAGVATI MAHAVIDYALAYA PANGARI",
  "BHAGVATI MAHAVIDYALAYA SAWANGI",
  "RAJKUNWAR MAHAVIDYALAYA BANOTI ",
  "JYOTITAI CHAVAN ARTS COMMERCE AND SCIENCE COLLEGE TUPEWADI TQ BADNAPUR DIST JALNA",
  "SHARDCHANDRA PAWAR COLLEGE BHOKARDAN",
  "LATE ADV BHAUSAHEB DESHMUKH SENIOR COLLEGE, JOMALA",
  "DR. A.P.J. ABDUL KALAM MANAGMENT SCIENCE COLLGE, DEOLAI",
  "GURUVARYA R G SHINDE LAW COLLEGE,OSMANABAD",
  "DR APJ ABDUL KALAM ARTS, COMMERCE AND SCIENCE SENIOR COLLEGE, DEVLAI, AURANGABAD",
  "MANJARA MAHAVIDYALYA, MOTI NAGAR, KANHERI ROAD, LATUR",
  "M G TELE COMMERCE COLLEGE CHINDHA AND BARAKU RAMAJI TELE SCIENCE COLLEGE AND KESHARBAI TELE COLLEGE OF MANAGEMENT THALNER",
  "Sant Gadge Maharaj Arts, Commerce and Science College, Walgaon",
  "Yadavrao Tasgaonkar College of Engineering and Management, Dr. N. Y. Tasgaonkar Technical Education Complex, Village-Chandhai, Neral-Kadav Road, Post-Nasrapur,Tal-Karjat (East), Dist-Raigad-Pin-410201",
  "Shri Rajasthani Seva Sangh's Smt. Parmeshwaridevi Durgadutt Tibrewala Lions Juhu College of Arts, Commerce & Science, Shriniwas Bagarka Marg, J.B.Nagar, Andheri (East), Mumbai",
  "Angel  Charities Fr. C. Rodrigues Institute of Technology, Vashi, Navi Mumbai",
  "College of Agricultural Engineering, Parbhani",
  "DR. ITHAPE INSTITUTE OF PHARMACY, SANGAMNER",
  "Amruta Vaishnavi Education and Welfare Trust's Shatabdi Institute of Engineering and Research ",
  "Bhildari Bahooudheshiya Sanstha's  Rajarshi Shahu Arts, Commerce & Science College, Paradh, Bhokardan.",
  "U D PATHRIKAR SCHOOL OF BUSINESS MANAGEMENT",
  "City Pride College, Hingna",
  "Girivasi Seva Mandal Kalyans Murlidhar Nanaji Mohite Guruji College of Arts, Commerce & BMS, Khodala-Jogalwadi, Tal.-Mokhada, Dist. Palghar-401604",
  "Dr. Baliram Hiray College of Architecture Government Colony, Bandra ",
  "NANDURBAR TALUKA VIDHAYAK SAMITIS INSTITUTE OF PHARMACY, NANDURBAR",
  "TPCTs TERNA PHYSIOTHERAPY COLLEGE, NAVI MUMBAI",
  "GOVERNMENT MEDICAL COLLEGE, RATNAGIRI    ",
  "SARASWATI JAIRAMJI TARVEKAR MAHILA MAHAVIDYALAYA , NAGBHID",
  "DR DAULATRAO AHER COLLEGE OF NURSING     ",
  "Adv. Bhagwan Keni Shikshan Prasarak Mandal Devta College of Education & Research at Kharegaon Kalwa Thane 400 605",
  "NAV YUVA INSTITUTE OF MEDICAL SCIENCES AND RESEARCH (PHYSIOTHERAPY)",
  "Vidya Vikas Education Trust, Universal College of Engineering, Kaman Bhiwandi Road, Survey No. 146 (Part),  Village Kaman, Vasai (E) -401212, Tal. Vasai. Dist. - Palghar",
  "A G PATIL INSTITUTE OF TECHNOLOGY  18 2A2  PRATANAGER SOREGON ROAD",
  "VIJAYA COLLEGE OF NURSING",
  "KARMAVEER TATYASAHEB HARI RAOJI PATIL ARTS COLLEGE KOLGAON",
  "Umang Geetai College of Womens Education",
  "COUNCIL OF EDUCATION  PARVATIDEVI KUMBHAR COLLEGE OF NURSING, KOLHAPUR",
  "SAMRAT ASHOKA RESIDENTIAL COLLEGE, WANI, DIST YAVATMAL",
  "Aldel Education Trusts St John College of Engineering and Management Vevoor Palghar Tal Palghar",
  "Shri Saibaba College of Physical Education, Gadchiroli",
  "Aditya Dental College,Bid",
  "Rizvi Institute of Management Studies & Research New Rizvi Education Complex, Off Carter Road, Bandra (West), Mumbai - 400 050",
  "Vikas Pratisthan's Late Tukaram Dhondiba Pathare Arts, Commerce & Science College, Chandannagar, Pune - 14",
  "DNYANODAYA EDUCATION TRUSTS, VIDYANIKETAN DEGREE COLLEGE OF ARTS, SCIENCE AND COMMERCE",
  "LATE YADAVRAO DANGE PRASHASKIYA MAHAVIDYALAY LASINA , YAVATMAL",
  "College Of Nursing, Sir J J Group of Hospitals Byculla Mumbai-08 (BSc Nursing)",
  "RASHTRIYA SHARIRIK SHIKSHAN MAHAVIDYALAY, VISAPUR, TAL. BALLARPUR, DIST. CHANDRAPUR",
  "ABDUL SAMAD COLLEGE OF EDUCATION (B.Ed), KANJHARA TQ. KHAMGAON",
  "DANG SEVA MANDAL ARTS AND COMMERCE COLLEGE, UMBARTHAN",
  "Mahatma Gandhi Vidyamandirs Pharmacy College, Dist.Nashik",
  "RAJMATA JIJAU SHIKSHAN PRASARAK MANDALS DNYANBHAKTI SENIOR COLLEGE",
  "VASANTDADA PATIL PRATISHTHANCHE KALA VANIJYA V VIDNYAN MAHAVIDYALAY BHIVRI ",
  "SAI SIDDHI COLLEGE OF NURSING, PAREGAON, YEOLA",
  "SHRI GANPATI MAHAVIDYALAYA",
  "Pimpri Chinchwad Education Trust S.B Patil College of Architecture and Design",
  "DR ASADULLAH KHAN COLEGE OF ARTS COMMERCE AND SCIENCE",
  "OMAR HOMOEOPATHIC MEDICAL COLLEGE AND RESEARCH  CENTRE, RANJANI ,JALNA",
  "PARUBAI VIGHNE VARISHTH MAHAVIDYALAY ANANDGAON",
  "KARMAVEER VARISHTHA SR COLLEGE",
  "SHREE CHANAKYA EDUCATION SOCIETYS INDIRA COLLEGE OF ARTS, COMMERCE AND SCIENCE PIMPRI CHINCHWAD CORPORTAION AREA PUNE ",
  "VASANTRAO NAIK INSTITUTE OF NURSING JALNA",
  "St. Fransis Institute of Management & Research Poinsur, S.V.P. Road, Borivali (West), Mumbai",
  "SMT SMITA RAVINDRA GHODVINDE LAW COLLEGE DALKHAN TAL SHAHAPUR DIST THANE",
  "KARMAVEER  SENIOR COLLEGE",
  "RAJASTHANI SAMMELANS DEVIPRASAD GOENKA MANAGEMENT COLLEGE OF MEDIA STUDIES",
  "MATOSHRI MAINABAI VITHALRAO MATE MAHAVIDYALAY, UMBARDA BAZAR, TQ KARANJA LAD",
  "J.M.PATEL Arts, Commerce & Science College, Bhandara",
  "MATOSHRI GAYABAI JAYRAMJI DOK MAHAVIDYALAY, TQ NANDGAON KHANDESHWAR",
  "Pune District Education Association's Baburaoji Gholap College, Sangvi, Tal. Haweli (Excluding Corporation Area), Dist - Pune 411027",
  "Government of Maharashtra Sydenham College of Commerce & Economics B Road  Churchgate  Mumbai  400 020",
  "Raireshwar Dongari Vikas Parishad's Adhyapak Mahavidyalaya, Dhankawadi, Pune 411043.",
  "DR. GANPATRAO DESHMUKH MAHAVIDYALAYA SANGOLA  TAL-SANGOLA DIST-SOLAPUR",
  "UMA INSTITUTE OF NURSING SCIENCES, JATH, TAL-JATH,DIST-SANGLI",
  "G.S. College of Commerce and Economics, Nagpur",
  "K.J's Educational Institute's Trinity College of Engineering and Research, Pisoli, Pune 411048",
  "SANJEEVAN EDUCATION SOCIETYS SANJEEVAN COLLEGE OF HOME SCIENCE AND NUTRITION, OSMANABAD",
  "Nalanda Nritya Kala Mahavidyalaya, Juhu Vile Parle Development Scheme Vile Parle (West) Mumbai",
  "Late. Maharudra (Bappa) Mote College of Education, Girwali, Bhoom.",
  "Med Pro College Of Nursing",
  "Ayurved Seva Sangh Ayurved Mahavidyalya, Ganeshwadi, Near Gadage Maharage Bridge, Panchavati Nashik-422003",
  "Umer Bin Khattab Welfare Trust Vastanvi College of Pharmacy  At.Kunjkheda Post Wadali Tal. Kannad Dist. Aurangabad",
  "Rajiv Arts College, Zari,Tq. Zarijamni.",
  "Jijau Gramin Pratishthan's Mahila Sevabhavi Sanstha's Sant Bahgwanbaba Mahavidyalaya, Ghatshil Pargaon, Shirur Kasar.",
  "Shri Chamundamata Homoeopathic Medical College and Hospital, Gat No. 95/1, Near Jalgaon Airport, Behind Shakambharimata Temple Chincholi, Jalgaon-425103",
  "Maharashtra Education Society's,  MES College of Nursing, Ghanekhunt-Lote, Tal. Khed, Dist. Ratnagiri-415722",
  "Ashoka International Centre for Educational Studies & Research",
  "Shivprasad Sadanand Jaiswal College, Arjuni/Mor, Dist. Gondia",
  "CHITRAI MAHAVIDYALAYA VADALI",
  "Late Lasasaheb Dcshmukh Shikshan Mahavidyalaya, Tiosa, Distt:-Amravati",
  "Shri Purogami Shikshan Sanskritik Krida Mandal Sanchalit Kai. Wamnrao Pitambare College, Padegaon, Aurangabad.",
  "Vidya Vikas Education Trust's- The Lords Universal College of Education Daftary Road Opp Jain Temple Malad (E) Mumbai 400 097",
  "CENTRAL PROVINCE COLLEGE OF LAW ",
  "K.D.M.Gs Homoeopathy College, Shirpur, Dhule",
  "Malad Kandivali Education Societys College of Law, Bhavishya Bharat Campus, Gate No.4, Off S.V. Road, Malad (West), Mumbai-400 064",
  "Research Development and Evaluation Wing, HQ-AC Armoured Corps Centre and School, Ahmednagar 414002",
  "SIES SCHOOL OF PHARMACEUTICAL SCIENCES",
  "VIDYABHARTI MAHAVIDYALAY DIGRAS , DIST YAVATMAL ",
  "JEEVANDEEP INSTITUTE OF TECHNOLOGY AND MANAGMENT STUDIES",
  "UNIVERSAL ARTS, COMMERCE AND SCIENCE COLLEGE",
  "MAHATMA GANDHI MAHAVIDYALAY MAHILA DUDHA SAILANI ROAD TAL DIST BULDHANA",
  "HITKARNI COLLEGE OF COMMERCE",
  "THEEM COLLEGE OF PHARMACY AND RESEARCH",
  "Valia Chhaganlal Laljibhai College of Commerce and Valia Lilavantiben Chhaganlal College of Arts",
  "A M D SAMAJKARY MAHAVIDYALAY MANTHA ",
  "Savitribai Phule BCA College, Vasmat",
  "Balwant College, VITA",
  "U D PATHRIKAR INSTITUTE OF MANAGEMENT PATHRI",
  "SHREEYASH INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH",
  "DISHA COLLEGE OF SOCIAL WORK",
  "MISHRI SHIKSHAN PRASARAK MANDAL NAVKAR ARTS COMMERCE AND SCIENCE COLLEGE MITMITA AURANGABAD",
  "GANGAMATA SHIKSHAN PRASARAK MANDALS, KARMAYOGI KESHAVRAO DADA PADUL ARTS, COMMERCE AND SCIENCE COLLEGE, LADSAWANGI ",
  "VIDYA VIKAS PRATISHTHANS, RAJMATA JIJAU ARTS, COMMERCE AND SCIENCE COLLEGE, LIMBE JALGAON, TQ GANGAPUR, DIST AURANGABAD ",
  "SAVITRIBAI PHULE ARTS COMMERCE AND SCIENCE SENIOR COLLEGE AURALA",
  "Shramjivi Shikshan Prasarak Mandal's Adarsh Mahavidyalaya, Omerga, Dist. Osmanabad",
  "Rajiv Gandhi Scinec College, Mehkar.",
  "Prabhakarrao Mamulkar Mahavidyalaya, Korpana",
  "K.J.SOMAIYA CAMPUS",
  "BHAI GURUDAS EDUCATIONAL SOCIETY ICE COLLEGE OF HOTEL MANAGEMENT",
  "RASHTRAMATA JIJAU CHARITABLE TRUST, SWAMI VIVEKANAND COLLEGE OF COMPUTER SCIENCE, MAVSALA ,AURANGABAD",
  "SHRIRAM ARTS,COMMERCE,SCIENCE COLLEGE INZAPUR ROAD NER",
  "SHRIRAM ARTS, COMMERCE, SCIENCE COLLEGE,SAISAMRATH NAGRI,DIGRAS",
  "SHRI L T BUNDHE COLLEGE OF ARTS COMMERC, SCIENCE MANAGEMENT ADMINISTRATOR",
  "SUBHASHRAO NAIK MAHAVIDYALAYA,LOHGAON,TQ KARANJA LAD",
  "SWA SOUDAJI NATTHUJI KAKAD KALA VA WANIJYA MAHAVIDYALAY ANDHERA TA DEULGAON RAJA DIST BULDHANA",
  "LAXMI MAHAVIDYALAYA SHIRPUR HORE TA DEOLI DIST WARDHA",
  "KOKAN RATNA KALA MAHAVIDYALAY BHARNE TAL KHED DIST RATNAGIRI ",
  "ADITI COLLEGE OF HOTEL MANAGEMENT AND CIVIL SERVICES WAKSAI TQ MAWAL DIST PUNE",
  "MAGARPATTA COLLEGE OF HOSPITALITY MANAGEMENT, MAGARPATTA CITY, HADAPSAR ,PUNE",
  "SANT DNYANESHWAR PRASHASKIY SEVA MAHAVIDYALAY ",
  "SHREE SHIDDESHWAR SENIOR COLLEGE,ERENDESHWAR",
  "SHRI NATHURAM MAHARAJ MAHAVIDYALAY KEHAL TAL JINTUR DIST PARBHANI",
  "Shri Baneshwar Shikshan Sansthas, Arts, Science and Commerce College, Burhannagar, Ta: Ahmednagar, Dist: Ahmednagar 414002",
  "LATE SHRI VISHNU WAMAN THAKUR CHARITABLE TRUST VIVA INSTITUTE APPLIED ART, THANE",
  "SHRAM SADHANA BOMBAY TRUSTS ARTS COMMERECE AND SCIENCE COLLEGE BAMBHORI JALGAON",
  "240039-SES'S Smt. H.R.PATEL ARTS MAHILA MAHAVIDYALAYA, SHIRPUR.",
  "SHARADCHANDRA PAWAR COLLEGE OF ATRS, COMMERCE AND SCIENCE",
  "Anuradha College of Nursing, Chikhli",
  "Divakar Patil Education(B.Ed.) D.K. Patil Education Trust Street No.26 2 Pasthal Village Pasthal Naka Boisar Rarapur Road Tal Palghar Dist  Thane 401 501",
  "Pushpanjali College of Education Papdy Vasai Dist.  Thane  401 207",
  "Our Lady of Grace Trusts St.Gonsalo Garcia College of Arts and Commerce  Behind Bassein Cricket Ground  Near Bassein Bus Depot  Bassein  401 201",
  "Gokhale Education Society's N.B. Mehta (Valvadz) Science College, Acharya Bhise Vidyanagar, Bordi,  Dist-Palghar  - 401 701",
  "AAKAR COLLEGE OF MANAGEMENT FOR WOMENS, HINGNA, NAGPUR",
  "Ninaidevi Shikshan Prasarak Mandals Matoshree Hirai Deshmukh Nursing Institute (B.Sc.), A-p Shirala, Tal. Shirala, Dist. Sangli",
  "Mahatma Jyotiba Fule Kala Mahavidyalaya, Ashti",
  "Dr. D.Y. Patil Unitech Society's Dr. D. Y. Patil Institute of Technology, Sant Tukaram Nagar, Pimpri, Pune 411018",
  "M.G.E. Society's Huzurpaga Shrimati Durgabai Mukunddas Lohiya Mahila Vanijya Mahavidyalaya, 691, Narayan Peth, Laxmi Road, Pune 411030",
  "ADARSH INSTITUTE OF PHARMACY, NAGPUR ",
  "PIMPRI CHINCHWAD MUNICIPAL CORPORATION POSTGRDUATE INSTITUTE Y C M HOSPITAL PIMPRI PUNE",
  "Late Khatija College of Education B.Ed. English Medium, Kausa-Mumbra",
  "Smt. Indira Gandhi College of Engineering, Ghansoli, Navi Mumbai",
  "DURGADEVI SARAF INSTITUTE OF MANAGEMENT STUDIES, MUMBAI",
  "Ekvira devi College of Education",
  "Prof. Rajabhau Deshmukh Kala Mahavidyalaya , Nandgon Khandeshwar .",
  "Shri Shivaji Science and Arts College , Chikhali.",
  "Haffkine institute for training research and testing",
  "KASTURI SHIKSHAN SANSTHA COLLEGE OF PHARMACY",
  "INDUTAI GAIKWAD PATIL AYURVEDIC COLLEGE AND RESEARCH CENTER",
  "SHREE SHIVAJI MAHILA MAHAVIDYALAY MAREGAON",
  "PRIDE INSTITUTE, PRASHASKIY SEVA MAHAVIDYALAY",
  "SWAMI VIVEKANAND MAHAVIDYALAY DIGHORI DIST YAVATMAL",
  "SANT DNYANESHWAR PRASHASKIY MAHAVIDYALAY BODHADI TA KINVAT DIST NANDED",
  "Late Shewantadevi Motghare Mahila Mahavidyalaya, Koregaon",
  "ADARSH PRASHASKIY MAHAVIDYALAY WARORA ROAD VANI DIST YAVATMAL",
  "MAHATMA FULE SENIOR COLLEGE KHAMGAON",
  "SARSWATI SENIOR COLLEGE MALKAPUR",
  "SWA PRAKASHBHAU BAWASKAR MAHAVIDYALAY SAWALI",
  "ADITYA COLLEGE OF MBA, BEED.",
  "Saraswati Mandir Sanstha Saraswati Mandir  Night College of  Commerce & Arts ",
  "Marwadi Sammelan, Sitaram Deora Institute of Management Studies",
  "RANGNATH MAHARAJ AGRICULTURE COLLEGE NAVHA",
  "P G M M Lonis B.Sc. Home Science and BCA Womens College, Kopargaon",
  "RAJASHRI SHAHU MAHAVIDYALAY",
  "G T Sanskrit Mahavidyalaya",
  "SAVITRIBAI PHULE MAHILA MAHAVIDYALAY CHALISGAON BAHAL TAL CHALISGAON DIST JALGAON",
  "Vidarbha Institute of Technology, Bhiwapur",
  "College of Agriculture, Bhanashiware",
  "SHREEMATI SHANTIBAI OTARMAL JAIN AYURVEDIC MEDICAL COLLEGE",
  "AHILYABAI HOLKAR MAHILA MAHAVIDYALAYA AKOT",
  "PRABHAT INSTITUTE OF PHARMACY, RUI",
  "DR RAJESH RAMDASJI KAMBE AYURVED COLLEGE AND HOSPITAL TURKHED TQ MURTIZAPUR DIST AKOLA ",
  "Maharana Pratapsinh Shikshan Sansthas  Anandibai Raorane Arts, Commerce and Science College, Vaibhavwadi",
  "Maratha Vidya Prasarak Samaj's Karmaveer Adv. Baburao Ganpatrao Thakare College of Engineering, Udoji Maratha Boarding Campus,Gangapur Road, Nashik 422013",
  "S Chandra Mahila Mahavidyalaya,Sadak Arjuni,Gondia",
  "Sarvajanik Shikshan Sansthas Adv. V. B. Deshpande College of Commerce (Night),  Smt. N. G. Purandare High School Building, V. P. Road,  Mulund (West), Mumbai - 400 080",
  "Athawale College of Social Work, Bhandara",
  "SHRI TUKARAM KAD VARISHTA MAHAVIDYLAY DHOTRA NAIK",
  "SHILPKAR COLLEGE SHIRUR KASAR",
  "BHOJRAJ BHONDEKAR AYURVEDIC MAHAVIDYALAYA",
  " Dr. Vithalrao Vikhe Patil Foundation's College of Nursing, Opp. Govt. Milk Dairy, Vadgaon Gupta, Post-MIDC, Ahmednagar-414111",
  "Smt Binzani Mahila Mahavidyalaya, Mahal, Nagpur",
  "M.V.P Samaj's Institute of Nursing Education, Vasantdada Nagar, Adgaon, Nashik",
  "SIDDHARTH MAHAVIDYALAYA AND SHIKSHAN PRABODHINI, NANDED.",
  "College of Agricultural Biotechnology, Achloli, Mahad",
  "College of Horticulture, sangulwadi Tal ,Vaibhavwadi",
  "College Of Food Technology ,Vaibhavwadi",
  "College Of Agril. Bio-Technology ,Sangulwadi Tal ,Vaibhavwadi",
  "College Of Agril. Engineering And Technology.sangulwadi,Tal Vaibhavwadi",
  "Uttar Bharatiya Sanghs Mahendra Pratap Sharada Prasad Singh College of Commerce & Science",
  "DNYANDEEP COLLEGE OF ARCHITECTURE",
  "Aditya Educational Foundation's Aditya Institute of Management-AIMS Sr. No. 42(part), Narhe-Ambegaon, Near Springdale School, Pune 411041",
  "Maratha Vidya Prasarak Samaj's Arts, Commerce and Science College Manmad, Tal-Nandgaon, Dist-Nashik 423104",
  "SE Society's SNBP College of Arts, Commerce, Science & Management Studies, Sant Dnyaneshwar Nagar Morwadi Pimpri Pune.",
  "Mangaon Taluka Education Societys Doshi Vakil Arts College and G. C. U. B. Science & Commerce College, At Goregaon, Tal. - Mangaon, Dist. Raigad - 402103",
  "GANGABAI BADOLE COLLEGE SAWARI",
  "NOOTAN COLLEGE OF PHARMACY",
  "JYOTIRMAY MAHAVIDYALAY",
  "SHRI CHAKRADHAR GURUKUL SANSKRIT MAHAVIDYALAY",
  "Kasturba Women's Multipurpose Society's, Kasturba College of Education Borgaon Meghe Wardha",
  "CAMBRIDGE COLLEGE OF PHARMACY, BULDHANA",
  "RASHTRAMATA JIJAU MAHILA MAHAVIDYALYA NANDED ROAD ",
  "PRIYADARSHANI MAHILA MAHAVIDYALAYA MORSHI    ",
  "MRT COLLEGE FOR WOMENS AMRAVATI    ",
  "KRISHNA FOUNDATION JAYWANT INSTITUTE OF PHARMACY WATHAR    ",
  "Pushpalata Mhatre Womens College of Arts Commerce and Science",
  "Nagaji Maharaj Physical Education College, Reshimbagh",
  "Yashwant College Of Nursing, Kodoli",
  "Radha Mahavidyalaya Reshimbagh,Nagpur ",
  "Pujya Sane Guruji Senior Arts & Commerce College, Palgad (Dapoli)",
  "G. H. RAISONI LAW COLLEGE NAGPUR ",
  "YASHVANTRAO CHAVAN AYURVEDIC MEDICAL COLLEGE AND HOSPITAL BEED ROAD NIPANI BHALGAON AURANGABAD ",
  "Rashtriya Mill Mazdoor Sanghs  G.D. Ambekar Pratishthans College of Management & Technology at Bhoiwada, Parel, Mumbai 400 012",
  "SIES College of Management Studies Sri. Chandrasekarendra Saraswathy, Vidyapuram, Plot No. 1-E Sector - V Nerul Navi Mumbai - 400 706",
  "Late Nirdhan Patil Waghaye Arts and Science College, Chopa (Mohadi)",
  "Uttamchand Bagdiya Arts and Commerce College, Risod.",
  "MGM Dental College & Hospital, Kamothe, Navi Mumbai",
  "M.G.M. College of Nursing, Vashi, Navi Mumbai",
  "Dapoli Homoeopathy College, Dapoli",
  "M.H.F.'s Homeopathic Medical  College & Hospital, Sangamner",
  "MS Ayurved Mahavidyalaya, Kudwa, Gondia",
  "Sitarang Charitable Society Shrimati Sitabai Ranguji Shinde Arts,Commerce & Science College, Bori, Tal. Junnar, Dist. Pune 412411",
  "LOKPRABHA MAHAVIDYALAYA NARKHED",
  "JAY BHAVANI INSTITUTE OF MANAGEMENT",
  "PRERNA MAHILA MAHAVIDYALAY",
  "COLLEGE OF FOOD TECHNOLOGY YAVATMAL",
  "PRABODHANKAR MAHILA MAHAVIDYALAYA RAMTEK",
  "MAHATMA PHULE VIDYA PRATISHTHANS SHANTABAI SHIVRAM PAWAR COLLEGE AMBEGAON BUDRUK PUNE",
  "SHREE BHAIRAVNATH DMLT COLLEGE",
  "JANAKI MAHAVIDYALAY AHMEDPUR",
  "P N SARODE MAHILA MAHAVIDYALAYA",
  "REGAL COLLEGE OF HOTEL MANAGEMENT ",
  "KRANTIJYOTI SAVITRIBAI FULE MAHILA MAHAVIDYALA NAGPUR",
  "SHRI MAHAVIR KALA VANIJYA VA VIDNYAN MAHAVIDYALAY ",
  "REGAL  COLLEGE SHRINGARTALI",
  "Shri Saibaba Lok Prabodhan Arts College, Wadner, ",
  "MALEGAON SENIOR COLLEGE OF ARTS SCIENCE AND COMMERCE",
  "S P MORE DNYANAM ANNAM FOUNDATION  S P MORE COLLEGE OF ARTS COMMERCE AND SCIENCE",
  "Raje Vishweshwarrao Arts & Commerce College, Bhamragad",
  "SHRI SAI COLLEGE OF HOTEL MANAGEMENT AND CIVIL SERVICES    ",
  "RAMSHETH THAKUR COLLEGE OF COMMERCE and SCIENCE KHARGHAR NAVI MUMBAI",
  "Holy Spirit Institute of Nursing Education, Holy spirit Hospital, Mahakali caves Road, Andhari (E), Mumbai.",
  "Pragatik Shikshan Sanstha Nutan Arts College, Post-Rajapur, Tal-Sangamer, Dist. Ahmednagar- 422605",
  "200058-GANGAMAI EDUCATION TRUST'S ARTS, COMMERCE AND SCIENCE COLLEGE, NAGAON, TAL.& DIST-DHULE.",
  "Anandrao Dhonde Alias Babaji Mahavidyalaya (Arts, Commerce and Science) Kada, Tq. Ashti Dist. Beed 414202.",
  "Maharashtra Educational Societys, H.K. Institute of Management Studies & Research, H. K. Compus, Relief Road, Pratiksha Nagar, Oshiwara, Jogeshwari (West), Mumbai",
  "Vidya Pratishthan's Kamalnayan Bajaj Institute of Engineering & Technology, Baramati, M.I.D.C.road, District - Pune",
  "Smt. Mathubai Garware Kanya Mahavidyalaya, Sangli",
  "Sevadal Mahila Mahavidyalaya",
  "ASM INSTITUTE OF BUSINESS MANAGEMENT AND RESEARCH MCA PUNE",
  "Swaminarayan Siddhanta Institute of Technology",
  "Chhatrapati Shahu Maharaj Shikshan Sanstha's Dental College & Hospital, Kanchanwadi, Paithan Road, Aurangabad",
  "Mula Education Society's Arts, Commerce and Science College, Sonai, Tal. Nevasa, Dist. Ahmednagar 414105",
  "ADITYA BASIC BSC NURSING COLLEGE BEED",
  "VEER MAHAVIDYALAYA",
  "Kala Prabodhini's,Institute of Design ,Co Bhalaji Pendharkar Sanskrutik Kendra, 253 Kha, Nagala Park,",
  "Miraj Mahavidyalaya, 705 1 Budhagaonkar Mala, Near Govt. Milk Dairy, MIRAJ",
  "BHANUDASRAO CHAVAN ARTS SCIENCE  AND COMMERCE COLLEGE LOHARA TQ LOHARA DIST OSMANABAD",
  "Mahatma Gandhi Arts, Science and Late Nasaruddhinbhai Panjwani Commerce College",
  "Kasmade Parisar Vikas Mandals , Dr.D.S. Aher B.Ed College, A/p Vakasa, Vithewadi,Tal-Deola, Nashik.",
  "Adarsh Shikshan Mandals Ideal College of Pharmacy and Research Adarsh Vidya Nagari 21 11 Bhal Villege PO Dwarli Malang Road Via-Kalyan(Rly. Stn.)Tal Ambernath, Dist Thane",
  "ANJUMAN-I-ISLAM'S SCHOOL OF ARCHITECTURE AT ANJUMAN-I-ISLAM'S KALSEKAR TECHNICAL, MUMBAI",
  "Jaywant Shikshan Prarsark Mandals Rajarshi Shahu College of Education Sr.No.80-2, Pune Mumbai Bypass Highway, Tathwade,Pune  411 033",
  "St. Teresas Institute of Education Co St Teresas Convent S V Road Santacruz Mumbai  400 054",
  "Shree Ramchandra Education Society Lonikand, Pune Shree Ramchandra College of Engineering,  Address: Gat No 351 and 333-1, A-p Lonikand, Pune-Nagar Road  Taluka: Haweli (excluding Corporation Area) District: Pune",
  "Vivekanand Education Societys  Institute of Management Studies and Research 495 497 Near Municipal School Collectors Colony Chembur Mumbai - 400 074",
  "Alard Charitable Trust Alard Institute of Management Sciences, Sr. No. 50 Marunje, Near Rajiv Gandhi Infotech Park, Pune 411057",
  "Dnyaneshwar Shikshan Prasarak Mandals Yamunabai Kurhe B.Ed. College ,A-p. Wadala Bahiroba,Tal.Nevasa, Dist.Ahmednagar",
  "Flora Education Societys Flora Institute of Technology, Address: A P Khopi, near Khedshivapur Toll Plaza Off Pune-Satara Highway, TQ Bhor, District - Pune 412205  Taluka: Bhor District: Pune",
  "Dhanvantari Homoeopathic Medical College and Hospital & Research Centre, Nashik",
  "HON. SHRI BABANRAO PACHPUTE VICHARDHARA TRUST'S, GROUP OF INSTITUTION'S, FACULTY OF PHARMACY, KASHTI, TAL.- SHRIGONDA, DIST.-AHMEDNAGAR 414701",
  "Shri Ramdeobaba College of Engineering and Management, Nagpur",
  "Wada Nirmiti Educational Society Wada College of Management & Science At Post Wada Tal  Wada Dist  Thane",
  "Dnyan Prasarak Shikshan Sanstha's Sandesh College Of Law 8 B Tagoe Nagar Vikhroli (E) Mumbai 400 083",
  "Dr. D.Y.Patil Institute of Engineering, Management and Research, Sector no 29, PCNTDA (Ravet), Akurdi, Pune 411044",
  "Matoshri Education Society's Matoshri College of Pharmacy, Address: At-Po, Eklahare, Near Odhagaon, Nashik Taluka: Nashik, District: Nashik",
  "Gokhale Education Societys College of Education and Research Co  R M Bhatt High School Parel Mumbai 400 012",
  "Siddhant Institute of Business Management, At Post. Sudumbare, Tal. Maval, Dist.Pune 412109",
  "Shri Bhairavnath Shikshan Prasarak Mandals Adhalrao Patil Institute of Management  and Research, At-Po .Landewadi, Chincholi, Tal.Ambegaon, Dist.Pune",
  "Rayat Shikshan Sanstha's Dr.Babasaheb Ambedkar Mahavidyalaya Arts, Science & Commerce, Aundhgaon, Pune 411067",
  "Ahmednagar Jilha Maratha Vidya Prasarak Samajs Ahmednagar Shri.Chhatrapati Shivaji Maharaj College of Engineering, Nepti,  Address: Nepti Nagar Kalyan Road, Ahmednagar, Taluka: Ahmednagar, District: Ahmednagar",
  "Bharati Vidyapeeths College of Engineering, Lavale  Address: lavale  Taluka: Mulashi District: Pune",
  "Pravara Rural Education Societys Padmashri Vikhhe Patil College of Arts, Science and Commerce, Pravaranagar, At-Po. Loni, Tal. Rahata, Dist.Ahmednagar 413713",
  "Bombay Salesian Societys Don Bosco College of Arts and Commerce (Evening)  Address: Don Bosco Marg, Yervada, Pune - 411006  Taluka: Pune (corporation Area) District: Pune",
  "SAVITRIBAI FULE MAHILA MAHAVIDYALAYA ",
  "MAHATMA FULE ARTS AND SCIENCE COLLEGE ",
  "MAEERs Physiotherapy College, Talegaon Dabhade, Pune",
  "Dnyan Prasarak Shikshan Sanstha Balasaheb Mhatre College of Science at Badlapur Tal Ambernath Dist.Thane",
  "RSM's Chetan Dattaji Gaikwad Institute of Management Studies, Karve Road, Pune 411004",
  "UNIQUE PUBLIC SERVICES COLLEGE",
  "DHNYANDA MAHILA MAHAVIDYALAYA WADEGAON TAH TIRODA DIST GONDIA",
  "Jayawant Shikshan Prasarak Mandal's Bhivarabai Sawant Institute of Technology & Research, Gat No. 720-1&2, Pune-Nagar Road, Wagholi, Tal. Haveli Pune 412 207.",
  "Dr. Ulhas Patil College of Physiotherapy, Jalgaon",
  "Krantiagrani Dr. G. D. Bapu Lad Mahavidyalaya, Kundal",
  "Iqra Unani Medical College, Jalgaon",
  "Jayawant Shikshan Prasarak Mandal's Charak College of Pharmacy & Research, 720/1&2, Wagholi, Pune  412 207",
  "DR KETKI PATIL COLLEGE OF NURSING JALGAON ",
  "SHRI KASHIRAMJI HUMANE MAHAVIDYALAYA KONDHA KOSRA TAH PAUNI DIST BHANDARA",
  "GOVERNMENT MEDICAL COLLEGE NANDURBAR",
  "CHHATRAPATI SHIVAJI COLLEGE OF PHARMACY BPHARM DEORI DIST GONDIA",
  "PEOPLES COLLEGE OF ARTS AND SCIENCE SHENDRA PARISAR AURANGABAD",
  "College of Management  and Information Technology, Aurangabad",
  "BALASAHEB THAKRE MAHAVIDYALYA GANESH NAGAR GOLAPANGARI",
  "NIRMALATAI KAKADE ARTS COMMERCE AND SCIENCE COLLEGE SHEVGAON ",
  "VIJAYALAKSHMI VISHWANATH DALVIE COLLEGE (MODEL COLLEGE)",
  "ANJUMAN ISLAM JANJIRA DEGREE COLLEGE OF COMMERCE,SHRIWARDHAN, DIST - RAIGAD- 402 110",
  "SHIVAJIRAO S. JONDHLE INSTITUTE OF SCIENCE AND COMMERCE ",
  "SGPCS GURU NANAK INSTITUTE OF MANAGEMENT STUDIES",
  "SHRI SHIVAJI MARATHA SOCIETYs COLLEGE OF ARCHITECTURE",
  "RUKHAMA MAHILA MAHAVIDYLAYA ",
  "MAHARASHTRA COLLEGE OF NURSING",
  "SMBT INSTITUTE OF DENTAL SCIENCES AND RESEARCH",
  "K. L. E. Society's, KLE College of Law, 4th Floor, Plot No. 29, Sector-1, Kalamboli, Navi Mumbai-410 218",
  "MATOSHRI USHATAI JADHAV INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH CENTRE BHIWANDI",
  "Saint Gadgebaba Mahavidyalaya, Paranda.",
  "ssjp R P COLLEGE OF PHARMACY, Osmanabad.",
  "KHEMAJI NAIK SCIENCE PITIGUDA",
  "SAU KSK ALIAS KAKU COLLEGE OF AGRICULTURE BEED",
  "Vedanta Foundation's Vedanta College, Vithhalvadi Railway Station Road, Vitthalwadi (W), Ulhasnagar, Dist.-Thane- 421003",
  "GODAVARI FOUNDATION HARIBHAU JAWALE INSTITUTE OF HOSPITALITY MANAGEMENT AND CATERING TECHNOLOGY",
  "Dyandeep Shikshan Sanstha's Late. Ramchandra Dhas College of Computer Science, Ashti",
  "Yeshwant Mahavidyalaya,Wardha",
  "Late Madhuribai Deshmukh Sharirik Shikshan Mahavidyalaya, Hingna, Nagpur",
  "Ashoka Education Foundation's Ashoka College of Education",
  "Ballarpur Institute of Technology, Ballarpur",
  "VIDHYABHARATI MAVIDHYALAYA ARNI",
  "BHAGWAN MAHAVIDYALAY PARBHANI",
  "GURU MAHAD BHARTI MAHAVIDYALAY SAMBAR",
  "GODAWARI MODERN DEGREE COLLEGE",
  "DNYANVIHAR MAHAVIDYALAY DEOLI TA  DEOLI DIST  WARDHA ",
  "VASUNDHARA  KALA MAHAVIDYALYA 22, MHADA, SHAHU MARG JULE SOLAPUR VIJAPUR ROAD, SOLAPUR 413004",
  "SHRI SANT GADGE BABA HINDI MAHAVIDYALAYA, BHUSAWAL",
  "Late Nirdhan Patil Waghaye Arts Commerce and Science College, Sangadi",
  " CHHATRAPATI SHIVAJI MAHARAJ INSTITUTE OF TECHNOLOGY, PANVEL",
  "ST. WILFREDS INSTITUTE OF PHARMACY, PANVEL",
  "Bharat Shikshan Mandal's Arts, Commerce & Science Senior College, Ratnagiri - 415 612",
  "KOHINOOR SENIOR COLLEGE JALNA",
  "HON TATYASAEB ALIAS VISHWASRAO DEORE ART COMMERCE AND SCIENCE COLLEGE UMARANE TALUKA DEOLA DIST NASIK ",
  "Abhinav Education Society College of Engineering  & Technology, Vaddwadi,",
  "PRERNA B A PRASHASKIY SEVA MAHAVIDYALAY GADCHANDUR TAH KORPANA DIST CHANDRAPUR ",
  "MIMSR Medical College, Latur",
  "Purushottam Thote College, Nagpur",
  "SHIVAJIRAO S JONDHLE INSTITUTE OF LAW AND RESEARCH ",
  "Taywade College, Koradi",
  "Priyadarshini College of Education, Sonegaon",
  "Kamala Education Society's Pratibha College of Commerce & Computer Studies, Plot No. 3 Behind Mehta Hospital, Off Mumbai Pune Road, Chinchwad, Pune 411 019.",
  "SWAMI VIVEKANAND MAHAVIDYALAYA LATUR",
  "Shivlingeshwar College of Pharmacy, Almala, Tq. Ausa",
  "SUPRIYA COLLEGE OF PHARMACY TEMBHURNI    ",
  "VSPM Madhuribai Deshmukh Institute of Nursing Education, Nagpur",
  "Kamalayee Mahavidyalaya, Vyahad (Khurd)",
  "SHRI SANT GAJANAN MAHARAJ VARISHTH MAHAVIDYALAY, LONAR",
  "SAI KALA VANIJYA PRASHYASKIYA MAHAVIDYALAY MUNDIKOTA",
  "SANIKA COLLEGE OF B DESIGN",
  "LATE UJWALBAPU DESHMUKH COLLEGE NIWANA",
  "Suryadatta Education Foundation's Suryadatta College of Management Information Research and Technology(SCMIRT),Bavdhan (Bk.), Pune 411021",
  "Gramin Vikas Sanstha Nasik Sanchalit Shri Siddhivinayak College of Education, V.T.Sankul, Malegaon Road, Nandgaon, Dist.Nashik",
  "Navmaharashtra Shikshan Mandals Late Abasaheb Kakade Arts College,Bodhegaon,Tal. Shevgaon, Dist.Ahmednagar",
  "SHAHU SHIKSHAN SANSTHAS PANDHARPUR C D DESHMUKH LAW COLLEGE, AHMEDNAGAR",
  "Maharaja Sayajirao Gaikwad Arts,Science & Commerce College,Malegaon Camp, Dist.Nashik 423105",
  "Mahila Mahavidyalaya , Jog Chowk,   Amravati.",
  "ANKUR INSTITUTE OF OPTOMETRY AND OPHTHALMIC SCIENCES    ",
  "Shiva Trust Aurangabad s Aurangabad Training college of B.Sc. Nursing, Shivaji Nagar, Aurangabad",
  "Nutan Adarsh Arts, Commerce and Smt. M.H. Wegad Science College, Umrer, Dist-Nagpur",
  "NIMGAON GRAMIN SHIKSHAN PRASARAK MANDALS INSTITUTE OF PHARMACY D PHARMACY",
  "SWA BALIRAMJI ARTS SCIENCE AND COMMERCE COLLEGE KUNDALWADI    ",
  "ALDEL COLLEGE OF PHARMACY AND RESEARCH    ",
  "Dr. M. L. Dhawale Memorial Homoeopathy Institute, Palghar",
  "Post Graduate Institute of Swastiyog Pratisthan, Extension Area, Station Road, Miraj, Dist. Sangli- 416 410",
  "Sancheti Institute of Orthopaedics & Rehabilitation, 16, Shivaji Nagar, Pune- 411 005",
  "Sanjeevan Medical Foundation ENT Postgraduate Training Institute, Ashivini Prasad Hospital, Station Road, Miraj- 416 410",
  "MAULI MAHAVIDYALAYA",
  "BABURAOJI ADASKAR MAHAVIDYALAYA, KAIJ",
  "MGM Institutes University Department of Prosthetics and Orthotics",
  "SHIDHESHWAR COLLEGE OF PHARMACY LATUR",
  "UDAY PHYSIOTHERAPY MEDICAL COLLEGE, NAGPUR ",
  "SAMRAT ASHOK INSTITUTE OF COMPUTER MANAGEMENT STUDIES, CHALISGAON TAL CHALISGAON DIST JALGAON",
  "SIDDHARTH COLLEGE OF PHARMACY AND RESEARCH CENTRE",
  "ANJUMAN KHAIRUL ISLAM POONA INSTITUTE OF MANAGEMENT SCIENCES AND ENTREPRENEURSHIP",
  "Arts And Commerce Degree College Petrol Pump, Jawaharnagar",
  "Maratha Vidya Prasarak Samaj's Arts, Commerce &  science College, Dindori, Dist Nashik-422202",
  "Lonavla Education Trust's, Dr.B.N.Purandare Arts,Smt. S.G.Gupta Commerce and Smt.Shardaben Amrutlal Mithaiwala Science College, Valvan, Lonavala, Tal. Maval, Dist. Pune 410403",
  "Dr. D. Y. Patil Institute of Hotel Management and Catering Technology, Tathwade, Pune 411033",
  "SHIVAI VIDYA PRASARAK MANDALS SHIVAI ARTS SCIENCE AND COMMERCE NIGHT COLLEGE",
  "MATRUBHUMI MAHAVIDYALAY",
  "VIDYA UTKARSH MANDAL SANCHALIT VIDYA UTKARSH MANDALACHE ARTS SCIENCE AND COMMERECE COLLEGE ",
  "SHREE PARAM SADGURU COLLEGE",
  "MAJI AMDAR DATTUSHETH PATIL SHIKSHAN PRASARAK MANDAL SANCHALIT DSP COLLEGE OF ARTS SCIENCE SCIENCE IT AND COMMERCE",
  "Kishinchand Chellaram College Dinshaw Wachha Road  Churchgate Mumbai  400 020",
  "Bombay Teachers Training College Mahakavi Bhushan Road Opp Hotel Regency Inn Colaba  Mumbai 400 039",
  "Jijamata Arts College , Darwha.",
  "Anurag Adhyapak Mahavidyalaya, Warthi",
  "Maharaja Sayajirao Gaikwad College, Town Center, Aurangabad.",
  "Sahyadri Shaikshan Seva Mandals College of Arts and Commerce at Juchandra  Tal Vasai  Dist Thane 401 202",
  "Rayat Shikshan Sansthas C.D.Jain College of Commerce, Shrirampur, Dist.Ahmednagar 413709",
  "SHRI SWAMI SAMARTH VIDYA PRASARAK MANDALS ARTS, COMMERCE AND SCIENCE COLLEGE RAVALGAON TAL- MALEGAON DIST- NASHIK 423108",
  "J M KOLPE COLLEGE OF PHARMACY    ",
  "Jai Bhagwan College of Education, Opp. H. P. Petrol Pump, Near Vitawa, Kalwa, Dist. - Thane - 400605",
  "Anjuman Girls Arts College, Sadar",
  "DR. KOLPE NURSING COLLEGE (B.Sc. NURSING) KOLPEWADI",
  "ANANDI SHIKSHAN PRASARAK MANDALS AYURVED MEDICAL COLLEGE, HOSPITAL AND RESEARCH INSTITUTE, BULDANA",
  "SIDDHIVINAYAK COLLEGE OF SCIENCE, COMMERCE AND ARTS, SHIRASGAON NILE, KHAMGAON ROAD TQ SHEGAON DIST BULDHANA",
  "Shri Chatrapati Shivaji College, Omerga",
  "ANANDI MAHAVIDYALAYA KALAMBE TARF KALE TAL KARVEER DIST KOLHAPUR",
  "DR S C GULHANE PRERNA COLLEGE OF MANAGEMENT AND TECHNOLOGY",
  "Smt. Laxmibai Radhakisan Toshniwal College of Commerce, Ratanlal Plot, Akola.",
  "Shri Shankarprasad Agnihotri College of Engineering, sindi (meghe), Wardha",
  "DR S S GORDE VIDNYAN MAHAVIDYALAY PATHROT TQ ACHALPUR DIST AMRAVATI",
  "Umme Salma Girls Arts and Science College, Rashidnagar",
  "Shree Swaraj Education Societys Swaraj College of Commerce & Computer Studies,Dhankawadi,Pune-411043",
  "SANT GAJANAN MAHARAJ MAHAVIDYALAY KANKARWADI FATA AGARWADI TAH RISOD DIST WASHIM ",
  "DISHA MAHAVIDYALAY JALNA",
  "LA SPHERE SCHOOL OF HOTEL MANAGEMENT",
  "SYMBIOSIS School of Visual Arts and Photography",
  "Shankarrao Patil Mahavidyalaya, Bhoom, Dist. Dharashiv",
  "SHRI VITHALRAO JOSHI CHARITIES TRUST's, B.K.L. WALAWALKAR RURAL MEDICAL COLLEGE, CHIPLUN",
  "GOVINDRAO WANJARI AYURVEDIC COLLEGE AND RESEARCH CENTER",
  "NATIONAL INSTITUTE OF PUBLIC HEALTH TRAINING AND RESEARCH",
  "MITTHULALJI SARDA MBA COLLEGE, BEED.",
  "SHEETAL COLLEGE OF NURSING",
  "COLLEGE OF FISHERY SCIENCE",
  "AMS AYURVED MEDICAL COLLEGE AND HOSPITAL, MALEGAON DIST NASHIK",
  "Kukadi Education Societys Savitribai College of Arts Commerce and Science Pimpalgaon Pisa Tal Shrigonda Dist Ahilyanagar",
  "MHATMA PHULE COLLEG OF EDUCATION  AKLUJ TAL.MALSHIRAS DIST-SOLAPUR",
  "KALAVATI LAW COLLEGE",
  "MGM School of Biomedical Sciences",
  "GURUKUL SENIOR COLLEGE ALAND TQ PHULAMBRI DIST AURANGABAD ",
  "Nanasaheb Mahadik College of Engineering, Pune - Banglore High way (NH4) Tal. Walwa",
  "TILAK MAHARASHTRA VIDYAPEETHS LOKMANYA TILAK INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "Shubhamkaroti Charitable & Education Trusts Vasai College of Science & Technology At Manickpur Vasai Road West  Dist Thane",
  "ANURADHA COLLEGE OF ENGINEERING AND TECHNOLOGY, CHIKHLI, DIST. BULDHANA",
  "VINDHYANCHAL SHIKSHAN SANSTHAS VSS INSTITUTE OF B PHARMACY",
  "SHREE KAKASAHEB HEERALAL MAGANLAL CHAUDHARI ARTS, COMMERCE and SCIENCE COLLEGE, NANDURBAR",
  "Seth Govindaji Raoji Ayur.Mahavidyalaya, Solapur",
  "S R MAHILA MAHAVIDYALAYA, GOREGAON",
  "KALIMATI MAHAVIDYALAYA KALIMATI",
  "LAXMIBAI GORULE COLLEGE OF PHYSIOTHERAPY WASHIM ",
  "VISHWARAJ INSTITUTE OF NURSING PUNE",
  "DHANESHWARI COLLEGE OF PHYSIOTHERAPY",
  "ROYAL COLLEGE OF PHYSIOTHERAPY",
  "MAHATMA GANDHI LAW COLLEGE HINGOLI, MAHARASHTRA",
  "Pandurang Gramin Vikas Pratishthans Dilip Walse Patil Arts, Commerce & Science College, Nimgaonsava, Tal. Junnar, Dist. Pune 410504.",
  "BR NATH PAI COLLEGE OF PHYSIOTHERAPY KUDAL",
  "Nagar Parishad Shivaji College, Mowad",
  "Krantiveer Vasantrao Narayanrao Naik Shikshan Prasarak Sanstha's Arts, Commerce  & Science College, Nashik",
  "RASHTRIYA CHARITABLE TRUSTS RASHTRIYA COLLEGE OF PHARMACY",
  "SNDT WU CENTRE FOR VOCATIONAL AND TECHNICAL EDUCATION",
  "WARDHA PRASHASAKIY MAHAVIDHYALAYA WARDHA",
  "GAJANAN MAHARAJ VANIJYA MAHAVIDYALAYA",
  "MOTIWALA COLLEGE OF PHYSIOTHERAPY",
  "ARTS SCIENCE AND COMMERCE COLLEGE VIZORA ",
  "YASHWANT MAHAVIDYALAYA LAKHANDUR ",
  "SANTAJI MAHAVIDYALAYA ARMORI ",
  "SHRI KISANRAO KHOBRAGADE PRASHASKIYA MAHAVIDYALAYA VAIRAGAD ",
  "GENESIS COLLEGE OF HOTEL MANAGEMENT MOUJE SONYACHI SHIROLI TAL RADHANAGRI DIST  KOLHAPUR",
  "DR TANAJIRAO CHORAGE ARTS COMMERCE AND SCIENCE SENIOR COLLEGE NANDWAL JAITAL PHATA TAL KARVEER DIST KOLHAPUR",
  "J K COLLEGE OF COMPUTER SCIENCE",
  "MODERN COLLEGE",
  "SARASWATI SENIOR WOMENS COLLEGE",
  "Wahed Khan College Of Science, Amravati",
  "ARTS COMMERCE AND SCIENCE COLLEGE KONOLI TARF ASANDOLI POST GARIWADE TAL RADHANAGARI DIST KOLHAPUR",
  "TIRPUDE INSTITUTE OF HOSPITALITY MANAGEMENT ",
  "SAHYOG COLLEGE OF ARTS COMMERCE AND SCIENCE",
  "S S GANPATRAO MAHARAJ DEGREE COLLEGE OF ADMINISTRATIVE SERVICES AND DEGREE COLLEGE OF FINE ARTS NEHARU NAGAR VIJAPUR ROAD SOLAPUR",
  "SHRI BALASAHEB MANE SHIKSHAN PRASARAK MANDALS ASHOKRAO MANE GROUP OF INSTITUTIONS",
  "GURUKUL NURSING INSTITUTE DARYAPUR ",
  "SANT DAMAJI APPA MAHAVIDYALAYA",
  "MAHATMA GANDHI PRASHASKIY SEVA MAHAVIDYALAYA",
  "Tirupati Shikshan Prasarak va Sevabhavi Sanstha Sanchalit Vidyadhan College, Cidco, Aurangabad.",
  "Yeshwantrao Chavan College of Arts, Commerce & Science, Sillod.",
  "Aditya Bahuuddeshiya Education Society's Aditya Engineering College, Telgaon Road, Beed.",
  "Anand Charitable Sanstha s College of Pharmaceutical Science and Research, Murshadpur, Ashti.",
  "APS Sansthas Sambhaji Raje College of Library and Management Science, Beed",
  "JAIBHAVANI SHIKSHAN PRASARAK MANDAL SANCHALIT ARTS & SCIENCE COLLEGE CHAKLAMBA, GEORAI.",
  "Late. Shankarrao Gutte Gramin Arts, Science & Commerce College, Dharmpuri, Parli, Vaijanath.",
  "VASANTRAO KALE COLLEGE OF JOURNALISM AND COMPUTER SCIENCE ,BEED",
  "Late. Yeshwantrao Chate Shikshan Santha, Tambwa, Tq-Kaij Shri Tambeshwar Commerce Science & Information Technology College, Kaij.",
  "Lonar Shikshan Prasarak Mandal, Kannapur, Shri Moreshwar Arts and Science College, Gangamasla, Majalgaon.",
  "FAJANDAR EDUCATION TRUSTS FAJANDAR WOMEN DEGREE COLLEGE AT VAHOOR TAL MAHAD DIST RAIGAD",
  "Sbhobhadevi Mahila Sevabhavi Sansth s Rajmata Jijau Arts and Science College, Madalmohi, Georai.",
  "ARTS COMMERCE and SCIENCE COLLEGE MAHURA TAL JAFRABAD.",
  "ARTS,COMMERCE AND SCIENCE COLLEGE WALSAWANGI, BHOKARDAN.",
  "Matsyodari Shikshan Sanstha's College of Physical Education, Motibaugh, Jalna.",
  "Ramkrishna Parmhans Shikshan Sanstha's, Rajshree Shahu Computer Science College, Barshinaka, Near Bhogavati Bridge , Shubham Complex, Osmanabad.",
  "Shri Kulswamini Shikshan Prasarak Mandal's Bill Gates Institute of Computer Science and Management, Osmanabad.",
  "Shri Swami Samarth Bahuddeshiya Shikshanik Samajik Sanstha aani Krida Mandal Sanchalit, V. J. Shinde Mahila Arts, Commerce & Science Mahavidhyalaya, Osmanabad.",
  "Shri Swami Samarth Senior College of Arts and Science, Ruibhar, Osmanabad.",
  "Vasantrao Kale College, Dhoki, Osmanabad.",
  "Jai Bhavani Shikshan Prasarak Mandals, Arts and Science College Marphala Tq Georai Dist Beed",
  "Shri Shivaji Maratha Societys Adhyapak Mahavidyalaya, Aranyeshwar, Pune 9",
  "GANGA MAHAVIDYALAYA",
  "Sancheti Institute for Orthopaedics and Rehabilitation, Shivajinagar, Pune 411005",
  "AMD COLLEGE OF ARTS AND SCIENCE",
  "Sheth Lalji Dayal Amalgamated Trusts Lilavati Lalji Dayal Night College of Commerce",
  "UEI GLOBAL EDUCATION",
  "Dnyanvilas College of Pharmacy",
  "RAJKUNWAR MAHILA MAHAVIDYALAYA BHOKARDAN",
  "ST ARNOLDS EDUCATION TRUST ST ARNOLDS NIGHT DEGREE COLLEGE OF ARTS AND COMMERCE",
  "Datta Meghe Institute of Management Studies",
  "MUSLIM EDUCATION SOCIETYS M E S WOMEN COLLEGE OF ARTS COMMERCE AND SCIENCE",
  "Govt. Medical College & Hospitals College of Nursing (B.Sc.), Aurangabad",
  "VIDYA PRASARAK SANSTHAS DEVRAM LAXMAN BHOIR DEGREE COLLEGE OF ARTS COMMERCE AND SCIENCE",
  "INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH FOR GIRLS",
  "INSTITUTE OF ENGINEERING AND TECHNOLOGY, NDA",
  "SAIKRUPA INSTITTUE OF FASHION DESIGN ",
  "Gurukul Residential Training College of Civil Services, Karmad",
  "GAJANAN MAHARAJ COLLEGE OF PHARMACY",
  "Sarswati Institute of Pharmacy, Kurtadi.",
  "Major Anandrao Ghatge Arts, Commerce and Science College, At post Senapati Kapashi, Kagal",
  "Shri Venkateshwara College of Science,Peth",
  "Anandi B. Pharmacy College, Kalambe Tarf Kale, Tal- Karveer, Dist- Kolhapur,",
  "Shri R.K.Patil Arts,Commerce and Science College,Sankh,Tal.Jat,Dist.Sangli",
  "Chembur Karnataka College of Law",
  "Ishwarrao More patil Arts Commerec Science Mahila Mahavidyalay, Ektanagr Dighanchi Tal -Atpadi Dist - Sangli",
  "Parvatibai More Mahila Mahavidyalaya ( Arts,Commerce  Science), Sarawade,Tal. Radhanagari",
  "Vivekanand Education Societys College of Architecture ",
  "JEEVAN SHIKSHAN SCIENCE COLLEGE KAIJ",
  "Mahila mahavidyalaya (Arts,Commerce and Science) Kavathemahankal,Tal.Kavathemahankal Dist.Sangli",
  "Mahatma Gandhi Vidyamandir's Arts, Commerce & Science College, Malegaon City, District - Nashik 423203.",
  "RAJARSHI SHAHU COLLEGE OF PHARMACY BULDANA",
  "SHIV MAHAVIDYALAY",
  "MATOSHRI RAJALADEVI GURUKULAM MAHAVIDYALAYA     ",
  "ANJANBAI ARTS COMMERCE AND SCIENCE COLLEGE KHANAPUR    ",
  "AASAWA BROTHERS BUSINESS SCHOOL ARTS, SCIENCE, COMMERCE",
  "Datta Dwaraka Mahavidyalaya Wakare Tal Karveer  Dist Kolhapur ",
  "HEALTHCARE MANAGEMENT INSTITUTE, KEM HOSPITAL, PUNE",
  "Pra Bhaurao Ubale Patil Arts and Science college sultanpur",
  "Pride Institutes Guruprasad College, Arag Tal. Miraj Dist. Sangli",
  "YELESHWAR B A CIVIL SERVICE MAHAVIDYALAYA",
  "Empire Education Societys Indira Institute of Aircraft Engineering, ",
  "Vidya Amrut Dnyan Pratishthan, Shirsondi Sanchalit Arts, Science  and Commerce College, Shirsondi",
  "D.Y.Patil College of Architecture,Talsande,Tal.Hatknangale,Dist.Kolhapur",
  "Shri Sadguru Saibaba Seva Trust sanchlit Late C. R. Rangnathan Deaf College of Arts and Commerce",
  "Shri Sai Nirman Pratishthans Shri Sai Nirman Arts, Commerce and Science College, Shirdi",
  "Jayawant Shikshan Prasarak Mandal's Jayawantrao Sawant Commerce and Science College, Hadapsar, Pune 411028.",
  "Anjuman-I-Islams Barrister A R Antulay College of Law",
  "Shri Ayurved Mahavidyalaya, Nagpur",
  "SAINT THOMAS PRASHASKIYA MAHAVIDYALA",
  "LATE SUSHILABAI JAISWAL MAHAVIDYALAY RAMGAON",
  "NAVNIRMAN SHIKSHAN SANSTHAS NAVNIRMAN COLLEGE OF NURSING",
  "Shahid Shikshan Prasarak Mandals Shahid Virpatni Laxmi Mahavidyalaya, Titave",
  "MANDESH INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH CENTRE MHASWAD",
  "MRS VANDANA NANDKUMAR TASGAONKAR AYURVED MAHAVIDYALA AND RESEARCH CENTRE     ",
  "Dr Babasaheb Ambedkar College of Arts, Commerce & Science, Bramhapuri",
  "ASHOK COLLEGE OF PHARMACY",
  "K. N. BHISE ARTS, COMMERCE AND VINAYAKRAO PATIL SCIENCE COLLEGE, VIDYANAGAR, BHOSARE TAL.MADHA  DIST-SOLAPUR",
  "100009- IQRA EDUCATION SOCIETY'S H.J.THIM COLLEGE OF ARTS AND SCIENCE MEHRUN, JALGAON.",
  "Shri Gajanan Arts,Commerce and Science College,Jadarboblad.Tal.Jat,Dist.sangli.",
  "SHRI SAIBABA COLLEGE SHIRDI",
  "GRAMIN VIKAS SHIKSHAN SANSTHA,SANT DASGANU ARTS, COMMERCE AND SCIENCE COLLEGE, AKOLNER",
  "Shrimati Shobhatai Kore Warana Mahila Mahavidyalaya,Yelur,Tal.Shahuwadi,Dist.Kolhapur",
  "Sahkar Maharshi Manikrao Palodkar College, Ajintha, Sillod.",
  "R.V. Parankar College of Engineering and Technology, Arvi",
  "College of Food Technology Lodaga. Tq. Ausa, Dist. Latur.",
  "Siddhivinayak Technical Campus, Shirasgaon Nile, Khamgaon-Shegaon road , Shegaon dist. Buldhana Maharashtra.",
  "Terna Public Charitable Trusts, Terna Nursing College, Nerul, Navi Mumbai (B.Sc.)",
  "DOMAJI JAMBHULKAR COLLEGE SAKOLI",
  "Indian Naval Ship Hamla",
  "SAI COLLEGE OF PHARMACY ",
  "Mahatma Gandhi Institute of Medical Sciences,  Sevagram, wardha",
  "Smt. Manoramabai Mundle College of Architecture, Nagpur",
  "Dayanand Education Society's Dayanand Institute of Pharmacy, Barshi Road, Latur",
  "DNYANRAJ MAULI ARTS AND SCIENCE COLLEGE TORNALA JODGVHAN",
  "GONDIA EDUCATION SOCIETY'S MANOHARBHAI PATEL COLLEGE OF ARTS AND COMMERCE DEORI.",
  "VSS College, Jalna",
  "Sri Balaji Society's Balaji College of Arts, Commerce & Science, Tathwade, Pune 411033.",
  "INTERNATIONAL CENTRE FOR THEORETICAL SCIENCES",
  "Govt. Dental College & Hospital, Nagpur",
  "MGV'S KBH Dental College and Hospital Mumbai-Agra Road, Panchavati Nashik-422003",
  "Panchasheel Homoeopathy College, Khamgaon",
  "Sir H.N. Hospital & Research College of Nursing (B.Sc.), Mumbai",
  "NSS S.P. Hegshetye College of Arts, Commerce & Science, Mirjole, Tal. Ratnagiri",
  "Tirupati Arts, Commerce and Science, Masal",
  "SIES Graduate School of Technology",
  "GOVINDLAL KANHAIYALAL JOSHI (NIGHT) COMMERCE COLLEGE, LATUR",
  "Anand Charitable Sanstha's Asthi Sanchalit's Mahila Arts College Patoda, Beed.",
  "LAXIMIBAI BHAURAO PATIL MAHILA MAHAVIDYALAYA, SOLAPUR",
  "Dnyanvardhini Charitable Trust's Arts & Commerce College At &Post Talere  Tal Kankavali  Dist Sindhudurga",
  "S S MAHAVIDYALAYA",
  "Lamka College",
  "Pandit Deen Dayal Upadhyay Institute of Agricultural Sciences",
  "Yairipok College",
  "Bethesda College of Nursing",
  "Ideal Girls' College",
  "D.M. College of Teachers' Education",
  "Hill College",
  "Kha-Manipur College",
  "C.I. College",
  "Don Bosco College",
  "Kakching Khunou College",
  "D.M. College of  Science",
  "LUNGNILA ELIZABETH COLLEGE",
  "Asufii Christian Institute",
  "Biramangol College",
  "Kanggui Christian College",
  "Institute of Rural Education",
  "Hindi Teachers' Training College",
  "DR HELENA OPTOMETRY COLLEGE    ",
  "Bethany Christian College",
  "Pravabati College",
  "Kanon Devi Memorial College of Teachers' Education",
  "South East Manipur College",
  "Jiri College",
  "Yaima College of Optometry",
  "D.M. College of  Arts",
  "Kamakhya Pemton College",
  "Pole Star College",
  "Manipur College",
  "Tamenglong College",
  "National Institute of Electronics & Information Technology (NIELIT), Imphal",
  "MT ZION COLLEGE",
  "VIBGYOR Institute of Management and Information Technology",
  "Oriental College",
  "St Joseph College",
  "Modern College",
  "Imphal College",
  "Churachandunpur College",
  "Saraswati Institute of Management and Para Medical Science ",
  "Nambol L. Sanoi College",
  "Thambal Marik College",
  "Pettigrew College",
  "JCRE Global College",
  "Ibotombi Institute of Education",
  "Trinity Teachers' Training College",
  "Waikhom Mani Girls' College",
  "Manipur Institute of Technology",
  "VISHAL LAW INSTITUTE ",
  "Moirang College",
  "Mt Pisgah College ",
  "UNIVERSAL COLLEGE OF NURSING",
  "YOUNG PILLARS COLLEGE",
  "Standard College",
  "S. Kula Women's College",
  "JADONANG MEMORIAL COLLEGE",
  "R D O COLLEGE OF NURSING",
  "COLLEGE OF NURSING, RIMS",
  "Temple of Learning Degree College",
  "DENTAL COLLEGE, RIMS",
  "FGI College of Agricultural Sciences",
  "College of Agriculture, Imphal",
  "United College",
  "Mayai Lambi College",
  "Thoubal College",
  "SORSHIA CHRISTIAN COLLEGE    ",
  "YENGKHOM NETRAMANI COLLEGE OF PARAMEDICAL SCIENCES    ",
  "SOUTH ASIAN INSTITUTE OF RURAL AND AGRICULTURAL MANAGEMENT",
  "EASTERN PARAMEDICAL SCIENCE AND RESEARCH INSTITUTE",
  "C M C COLLEGE OF NURSING",
  "GREEN LAND COLLEGE OF NURSING",
  "SENTINEL COLLEGE",
  "VISHNU ART AND CULTURE RESEARCH AND TRAINING CENTRE, BISHNUPUR",
  "JR INSTITUTE OF MEDICAL SCIENCES",
  "INSTITUTE OF FORENSIC SCIENCES FOR TRAINING AND SKILLING OF NFSU",
  "COLLEGE OF NURSING",
  "UNACCO COLLEGE",
  "College of Food Technology",
  "CITY COLLEGE OF NURSING",
  "M.B. College",
  "THE IDEAL TEACHERS TRAINING ACADEMY",
  "TC COLLEGE OF TEACHERS EDUCATION AND SOCIAL WORK",
  "G.P. Women's College",
  "T.S. Paul Manipur Women's College",
  "R K  Sanatombi  Devi College of  Education",
  "D.M. College of Commerce",
  "Damdei Christian College",
  "Lilong Haoreibi College",
  "College of Social Work",
  "Mangolnganbi College",
  "HIGHLAND NATIONAL COLLEGE",
  "ST XAVIER COLLEGE",
  "TEMPLE OF LEARNING MAYENGBAM APABI NURSING COLLEGE",
  "Slopeland  College of Teachers Education",
  "Rayburn College",
  "Western College",
  "Royal Academy of Law",
  "Naorem Birahari College",
  "Jawaharlal Nehru Institute of  Medical Sciences",
  "LMS Law College",
  "Institute of Cooperative Management",
  "Ng. Mani College",
  "CHURACHANDPUR MEDICAL COLLEGE",
  "Presidency College",
  "Mount Everest College",
  "Imphal Art College",
  "Shree Shree Gourgobind Girls' College",
  "YENGKHOM NETRAMANI COLLEGE OF NURSING",
  "ESCENT INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH",
  "ACME COLLEGE OF NURSING    ",
  "STATE INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION    ",
  "SHIJA  ACADEMY OF HEALTH SCIENCES",
  "Regional College",
  "THE THOKCHOM IBOTOMBI INSTITUTE OF TEACHER EDUCATION AND TRAINING",
  "NG College",
  "Liberal College",
  "Kangleipak Medical & Nursing Institute",
  "Y.K. College",
  "Kumbi College",
  "Regional Institute of Medical Sciences",
  "Government Polytechnic",
  "Moreh College",
  "KHA MANIPUR HINDUSTANI SANGEET MAHAVIDYALAYA",
  "KHRAWSING CHRISTIAN COLLEGE",
  "DON BOSCO COLLEGE",
  "College of Teacher Education",
  "TURA CHRISTIAN COLLEGE",
  "RIWAR COLLEGE",
  "Mawsynram Border Area College",
  "St. Mary's College",
  "Mendipathar College",
  "College of Teacher Education (PGT)",
  "Tirot Sing Memorial College",
  "Tikrikilla College",
  "Synod College",
  "UMMULONG PRESBYTERIAN COLLEGE",
  "Khadsawphra College",
  "AMWI COLLEGE",
  "College of Agriculture, Kyrdemkulai",
  "Balawan College",
  "Morning Star College",
  "Loyola College",
  "BANSARA INSTITUTE OF OPHTHALMIC SCIENCES",
  "Captain Williamson Memorial Government College",
  "SELSELLA COLLEGE",
  "INSTITUTE OF INTEGRATED PROFESSIONAL STUDIES SHILLONG",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, SHILLONG",
  "COLLEGE OF SCIENCE AND COMMERCE, MAWPHLANG",
  "IAIKYNTIEW COLLEGE",
  "Jaintia Eastern College",
  "St. Anthony's College",
  "Kazi & Zaman College",
  "Nongstoin College",
  "Nongtalang College",
  "SHANGPUNG COLLEGE",
  "Shillong College",
  "St. Edmund's College",
  "BELLEFONTE EVENING COLLEGE",
  "RI BHOI SYNOD COLLEGE UMSAITSNING",
  "ST XAVIERS COLLEGE UMOID",
  "Lyngngam Presbyterian College",
  "CHRIST COLLEGE",
  "College of Community Science, Tura",
  "SHILLONG GOVERNMENT COLLEGE OF ENGINEERING",
  "PASF ABONG NOGA COLLEGE",
  "Tura Government College",
  "Don Bosco College",
  "Goodwill College",
  "MERIBON K H MEMORIAL COLLEGE",
  "NORTH EAST REGIONAL INSTITUTE OF EDUCATION",
  "Seng Khasi College",
  "Regional Institute of Science & Technology",
  "Raid Laban College",
  "Ampati College",
  "NEIGRIHMS, MBBS College",
  "St. Dominic's College",
  "Bissau College",
  "Thomas Jones Synod College",
  "MASON PHILLIPS ACADEMY",
  "SYNOD COLLEGE NONGSTOIN, NONGSTOIN",
  "Tura Law College",
  "St. Mary's College of Teacher Education",
  "Don Bosco College of Teacher Education",
  "Shillong Commerce College",
  "North -Eastern Hill University,Tura Campus",
  "Durama College",
  "Umshyrpi College",
  "K. L. Bajoria College",
  "Mawlai Presbyterian College",
  "Sohra Government College",
  "SMIT COLLEGE",
  "RONGJENG MODEL DEGREE COLLEGE",
  "Kiang Nangbah Government College",
  "Regional Campus, Shillong",
  "Sankardev College",
  "Shillong Law College",
  "NEIGRIHMS, College of Nursing",
  "Buddha Bhanu Saraswati College",
  "Ri Bhoi College",
  "Sngap Syiem College",
  "Lady Keane College",
  "KHAD AR DALOI LAW COLLEGE JOWAI",
  "BHAITBARI SCIENCE COLLEGE",
  "St. Francis D Assisi College, Siejlieh, Nongstoin",
  "Bormanik College",
  "Phukan Memorial College",
  "Women's College",
  "Nongrum College",
  "Acheng Rangmanpa College",
  "Nabon Synod College",
  "Union Christian College",
  "ALPHA COLLEGE OF ARTS AND COMMERCE",
  "Mairang Presbyterian Science College",
  "Williamnagar Government College",
  "Greater Mawlai College",
  "College of Post Graduate Studies, Umiam",
  "JJM NICHOLS ROY COLLEGE ",
  "MIRIAM RUSSEL WOMEN COLLEGE ",
  "National Institute of Electronics and Information Technology (NIELIT)",
  "AIZAWL COLLEGE OF NURSING",
  "College of Veterinary sciences & Animal Husbandry, Aizawl",
  "Zoram Medical College",
  "BN COLLEGE OF NURSING",
  "KAWNPUI COLLEGE",
  "Higher and Technical Institute, Mizoram (HATIM)",
  "COLLEGE OF NURSING, SYNOD HOSPITAL DURTLANG",
  "Govt. Hnahthial College",
  "MIZORAM CHRISTIAN COLLEGE",
  "Govt. Mizoram Law College",
  "Institute of Advanced Study in Education",
  "Govt. Lawngtlai College",
  "Govt. Aizawl West College",
  "Govt. Zawlnuam College",
  "Govt. Champhai College",
  "Lunglei Government College",
  "Govt. Aizawl North College",
  "Govt. Aizawl College",
  "Govt. Serchhip College",
  "Pachhunga University College",
  "Govt. Kolasib College",
  "Divine Mercy College ",
  "Govt. Hrangbana College",
  "Govt. J. Thankima College",
  "Govt. Kamalanagar College",
  "College of Horticulture, Thenzawl, Mizoram",
  "Govt. Saiha College",
  "Govt. Khawzawl College",
  "Govt. T. Romana College",
  "Govt. Mamit College",
  "Regional Institute of Paramedical and Nursing Sciences",
  "Govt. Saitual College",
  "HELEN LOWRY COLLEGE",
  "Govt. Zirtiri Residential Science College",
  "MIZORAM COLLEGE OF NURSING",
  "Aizawl City College ",
  "Govt. J. Buana College",
  "SCERT",
  "Govt. Johnson College",
  "Sazolie College",
  "PARA MEDICAL TRAINING INSTITUTE",
  "NAGALAND INSTITUTE OF MEDICAL SCIENCES AND RESEARCH KOHIMA    ",
  "JUBILEE MEMORIAL COLLEGE",
  "Patkai Christian College",
  "Bailey Baptist College",
  "St. Joseph's College",
  "Alder College",
  "Japfu Christian College",
  "COLLEGE OF NURSING, NAGA HOSPITAL KOHIMA",
  "NORTH EAST REGIONAL MULTIDISCIPLINARY PARAMEDICAL INSTITUTE",
  "Kohima Law College",
  "Sakus Mission College",
  "St. Xavier's College",
  "Immanuel College",
  "Bosco College of Teacher Education",
  "CORNERSTONE COLLEGE",
  "NEW MODEL COLLEGE, WAKCHING, MON",
  "Modern College",
  "Capital College of Higher Education",
  "Pfutsero Government College",
  "St.John College",
  "Unity College",
  "Baptist College",
  "MOUNT MARY COLLEGE",
  "shamator college",
  "City Law College",
  "Tuli College",
  "NORTH EAST INSTITUTE OF SOCIAL SCIENCES AND RESEARCH",
  "Eastern Christian College",
  "Kohima Science College",
  "Dimapur Govt College",
  "Mokokchung Law College",
  "City College of Arts & Commerce",
  "People's College",
  "Zisaji Presidency College",
  "Mount Tiyi College",
  "Model Christian College",
  "DON BOSCO COLLEGE",
  "COLLEGE OF NURSING , CHRISTIAN INSTITUTE OF HEALTH SCIENCES AND RESEARCH, DIMAPUR",
  "Mount Olive College",
  "PLATINUM COLLEGE    ",
  "J N AIER COLLEGE, DIMAPUR",
  "MODERN INSTITUTE OF TEACHERS EDUCATION, KOHIMA",
  "Yingli College",
  "C-EDGE COLLEGE, DIMAPUR",
  "YEMHI MEMORIAL COLLEGE , DIMAPUR",
  "UNITY COLLEGE OF TEACHERS EDUCATION , DIMAPUR",
  "Pranab College",
  "Fazl Ali College",
  "NEW MODEL COLLEGE, MANGKOLEMBA",
  "College of Veterinary Sciences And Animal Husbandry, Jalukie",
  "SAZOLIE COLLEGE OF TEACHERS EDUCATION, KOHIMA",
  "Kros College",
  "Peren Government College",
  "NAGALAND COLLEGE OF MUSIC  AND FINE ARTS",
  "COLLEGE OF NURSING (IMDH), MOKOKCHUNG, NAGALAND",
  "Salt Christian College of Teaacher Education",
  "Oriental College",
  "Salesian College of Higher Education",
  "Salt Christian College",
  "MON VALE COLLEGE",
  "Sao Chang College",
  "SD Jain Girl's College",
  "Kohima College",
  "State College of Teacher Education",
  "Tetso College",
  "Wangkhao Government College",
  "MOKOKCHUNG COLLEGE OF TEACHER EDUCATION",
  "NAGALAND CONSERVATORY OF MUSIC    ",
  "NORMAN PUTSURE COLLEGE, CHUMOUKEDIMA",
  "Public College",
  "Regional Institute of E-Learning & Information Technology",
  "MGM COLLEGE",
  "Phek Govt. College",
  "Zunheboto College",
  "CAMBRIDGE SCHOOL OF MANAGEMENT",
  "NETAJI COLLEGE OF NURSING",
  "GOVERNMENT DEGREE COLLEGE GURUNDIA    ",
  "RAISUAN DEGREE MAHAVIDYALAY, RAISUAN",
  "OXFORD COLLEGE OF MANAGEMENT",
  "NARMADA SCHOOL AND COLLEGE OF NURSING ",
  "Babamani College (+3)",
  "IDEAL INSTITUTE OF MANAGEMENT STUDIES",
  "R.J.S.M.S.",
  "S.R. College",
  "Balasore Mahila College",
  "COLLEGE OF NURSING NPM IMSR, KEONJHAR    ",
  "Science College, Gudari",
  "SARALA DEGREE RESIDENTIAL COLLEGE ,SRIRAMPUR",
  "Remunda College, Remunda",
  "B.N.M.A. College",
  "Government B.Ed. Training college Kalinga",
  "INSTITUTE OF NATURE CURE AND YOGIC SCIENCE",
  "L.N. College",
  "THE COLLEGE OF PHARMACEUTICAL SCIENCE TAMANDO",
  "Binapani Degree College, Dhumabhata",
  "GAYATRI COLLEGE OF NURSING",
  "OMM BIDYA BHARATI  PLUSH THREE SCIENCE AND ARTS RESIDENTIAL COLLEGE    ",
  "BALASORE COLLEGE OF NURSING CHITAPADA",
  "K.C.G. Sanskrit College",
  "Degree Science College, Mahaling",
  "MAA DAKHINESWARI INSTITUTE OF MEDICAL SCIENCE    ",
  "Geteswar Sanskrit College",
  "GOVERNMENT DEGREE COLLEGE JHARIGAON    ",
  "Trident Academy of Creative Technology, Chandaka  Industrial Estate, Bhubaneswar",
  "CNCB ACADEMY OF SCIENCE AND TECHNOLOGY",
  "Sukinda College,Sukinda,Jajpur",
  "S TARAMANI ACADEMIC REGIONAL COLLEGE AND MANAGEMENT",
  "RENSUM INSTITUTE OF NURSING    ",
  "SULAGNA INSTITUTE OF MEDICAL SCIENCE    ",
  "NAUMI BUSINESS SCHOOL    ",
  "Regional College,Rambag,Jajpur",
  "B.P. College of Science  & Edu., BBSR, Khurda",
  "SVNIRTAR, Olatpur, Bairoi, Cuttack",
  "S.S.D.College of Science & Technology, Bali, Cuttack",
  "Mathakaragola College,Mathakaragola,DKL",
  "Sri Jayadev College of Edu.&Tech.,Naharkanta,BBSR, Khurda",
  "Gopabandhu Sc.College,Athagarh,Cuttack",
  "G.C.College,Ramachandrapur, Jajpur",
  "Naba Krishna Choudhury Institute of Education, Tarikund, Jagatsinghpur",
  "Debray Samarsing College, Ganeswarpur, Kendrapara",
  "INSTITUTE OF BUSINESS AND MANAGEMENT STUDIES    ",
  "Balimela College of Science and Technology, Balimela",
  "B.P. College",
  "Kabi Prasanna Patsani Anchalika Degree Mohavidyalaya,Malipada, Khurda",
  "KAIRALI INSTITUTE OF MEDICAL SCIENCE",
  "D.G.B.K. Mahavisyalaya,Kasarda, Cuttack.",
  "SWADHIN PLUS THREE RESIDENTIAL COLLEGE",
  "K.C. Pipili +3 Mahavidyalaya",
  "BIDYANIKETAN COLLEGE OF PROFESSIONAL STUDIES, NABARANGPUR",
  "Computer Application Centre, Link Road, Arunodaya Market, Cuttack",
  "Hi-Tech. Dental College & Hospital, Health Park, Rasulgarh, Bhubaneswar",
  "MAA MANIKESWARI DEGREE COLLEGE ",
  "MAHIMA COLLEGE OF NURSING",
  "BIJU PATNAIK COLLEGE OF NURSING, BAIGANJURI, SONEPUR",
  "SUNDARGARH COLLEGE OF NURSING",
  "G K SCIENCE DEGREE COLLEGE UMERKOTE",
  "Panchayat Degree College of Edn. & Tech. Satapada, Puri",
  "SEVANANDA SARASWATI DEGREE MAHAVIDYALAYA",
  "D.K.N.College,Branch,Cuttack",
  "Mangala Mahavidyalaya, Kakatpur",
  "AUM SAI COLLEGE OF NURSING  BERHAMPUR",
  "VISWASS College of Nursing, Plot No. 474, Pitapalli Square, Kumarbasta, Khurda",
  "JAGATESWAR BHANJABHARATI SANSKRIT MAHAVIDYALAYA",
  "UG.Mahavidyalaya, Khamar,Angul",
  "Institute of Media Studies, OCHC Complex, Janpath, Kharvel Nagar, Bhubaneswar",
  "Chakradhara Institute of Rehabilitation Sciences, F-10, BJB Nagar, Bhubaneswar",
  "ALEKHA MAHIMA DEGREE COLLEGE",
  "ANCHALIKA DEGREE MAVIDYALAYA,GUNEIBIL,DHENKANAL",
  "R.S. Mahavidyalaya, Odagaon, Nayagarh",
  "Haladia College, HaladiaKhurda",
  "Regional Institute of Education, Bhubaneswar,",
  "Brahmani College, Dandisai, Kendrapara`",
  "SCHOOL OF REHABILITATION AND SOCIAL SCIENCES, DHENKIKOTE",
  "SAI MEDICAL COLLEGE OF NURSING AND PARAMEDICAL STUDIES",
  "Yudhistir Mishra Law College, Balangir",
  "BINAYAK DEGREE COLLEGE,BHAWANIPATNA",
  "Janaki Madhusudan Womens Degree College, Mandhatapatna",
  "B.J.B. +3 College, Gadarodang, Brahmagiri, Puri",
  "MAHAVINAYAK  SANSKRIT COLLEGE",
  "Dr. J.N. College",
  "A.E.S.College, Tarbha",
  "B.T.Women's College,Chhenapodi",
  "CITY COLLEGE OF MANAGEMENT AND SCIENCE",
  "C.S College, Champua",
  "SGI SCHOOL OF MEDICAL SCIENCES NURSING    ",
  "PURI WOMENS DEGREE COLLEGE PURI    ",
  "BIJUPATTNAIK MEDICAL TECHNOLOGY BARIPADA",
  "COLLEGE OF B SC NURSING TRAINING COLLEGE ",
  "VIKASH BSC NURSING COLLEGE    ",
  "A.B. College",
  "GOVT DEGREE COLLEGE KHAJURIPADA    ",
  "SWOSTI INSTITUTE OF MANAGEMENT AND SOCIAL STUDIES",
  "BIDYA BHUSHAN SANSKRIT MOHAVIDYALAYA, BALANGIR",
  "NILAGIRI SANSKRIT COLLEGE",
  "ParadipCollege,Paradip,Jagatsinghpur",
  "B.P.College,Antei, Kendrapara",
  "NAGENDRANATH SANSKRIT COLLEGE, KUMBHARI",
  "Baba Bhairabananda Autonomous Mahavidyalaya, Chandikhola,Jajpur",
  "Kendrapara Evening College,Kendrapara",
  "SIDHESWAR SANSKRIT MOHAVIDYALAYA, BARADIA",
  "DHAMARAI SANSKRIT DEGREE COLLEGE    ",
  "BARABATI SANSKRIT COLLEGE, DHARMASALA",
  "Debendra Satapathy Memorial College, Bhapur, Dhenkanal",
  "Olaver College,Olaver, Kendrapara",
  "Balugan College,Balugan,",
  "M.P.Mahavidyalaya, Erakana,Cuttack",
  "Lord Jagannath Mission's College of Nursing, Plot No.228/237,  Mancheswar Industrial Estate, Bhubaneswar",
  "P.P.College, Nichintakoili,Cuttack",
  "Maa Tarini Mohavidyalaya, Panikoili,Jajpur",
  "Hingala Degree College,Saliada,Angul",
  "Manjari Devi College of Nursing, Plot -68, Rasulgarh, Bhubaneswar",
  "Dhenkanal Law College, Station Bazar, Dhenkanal",
  "Derabis College,Derabis, Kendrapara",
  "Ekarma College,BBSR",
  "Sri Jagannath Mahavidyalaya,Nauganhat,Jagatsinghpur",
  "S.V.M. Autonomous College,Jagatsinghpur,",
  "P.A. College, Baulasahi, Nayagarh",
  "Sunakhala College, Rajsunakhala, Nayagarh",
  "Biraja Law College, Jajpur",
  "Academy of Management & Information Technology, IID Centre, Bidya Vihar, Khurda",
  "Regional College of Management, Chakadola Vihar, Bhubaneswar",
  "Junabhadra College, Birana,Jajpur",
  "Chouda Mouza Bidyut Mahavidyalaya, Garhasanput",
  "R.D. Chilika Mahavidyalaya, Chilika, Nuapada, Puri",
  "BALABHADRA NARAYAN SANSKRIT COLLEGE, SALAPADA",
  "S.M.Mahavidyalaya,Asueswar,Cuttack",
  "LALMOHAN SANSKRIT COLLEGE, BEGUNIADIHA KHALADI",
  "PANCHAYAT DEGREE MAHAVIDYALAYA BADCHERGAON",
  "SMT SUSILA DEVI INSTITUTE OF HEALTH AND TECHNOLOGY",
  "CHIDANANDA YOGA SANSKRUTI SANSTHAN",
  "Sri Sri Jagannath Mohavidyalaya,Rajnagar, Kendrapara",
  "Pattamundai College, Pattamundai,Kendrapara",
  "Tangi  College,Tangi,Cuttack",
  "SHRI SADASHIVA CAMPUS",
  "Janata College, Kuhuri, khurda",
  "Kendrapara Autonomous College, Kendrapara,",
  "SABITRI DEVI PLUS THREE SCIENCE COLLEGE",
  "B.I.S.T.",
  "Millenium Academy of Higher Education, Nayagarh",
  "Niali College,Niali,Cuttack",
  "Jatni College, Jatni, Khurda",
  "Nilamadhaba Mahavidyalaya, Kantilo, Nayagarh",
  "DR AMBEDKAR LAW COLLEGE",
  "Govt. College of Physical Education, Kalinga Stadium, Nayapalli, Bhubaneswar",
  "ZENITH ENGINEERING AND MANAGEMENT STUDIES",
  "MAYURBHANJ INSTITUTE OF MANAGEMENT STUDIES",
  "Talcher College, Talcher,Angul",
  "NAVAPRVATA  ACADEMY FOR MANAGMENT EDUCATION",
  "Parbatigiri College,Jujumura",
  "ANANDA CHANDRA SANSKRIT DEGREE COLLEGE",
  "SARASWATI DEGREE COLLEGE SIALKHANDAHATHA",
  "Banki Autonomous College,Banki, Cuttack.",
  "SHREEKSHETRA NURSING COLLEGE",
  "Banamalipur Degree College, Banamalipur, Khurda",
  "Maniabadha College,Cuttack",
  "Hindol College,Khagurikota, Dhenkanal",
  "Charampa Mahavidyalaya",
  "Soro Womens College",
  "KAIRALI COLLEGE OF +3 SCIENCE, CHAMPUA",
  "NIRMANA INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "UNIPOWER SCHOOL OF IT AND MANAGEMENT",
  "Government Teachers Training College, Phulbani",
  "SRI LAXMI SANSKRIT MAHAVIDYALAYA",
  "INTERNATIONAL INSTITUTE OF HOTEL AND TOURISM MANAGAMENT ",
  "GITANJALI SCHOOL AND COLLEGE OF NURSING    ",
  "SAI ACADEMY OF MANAGEMENT STUDIES",
  "MAHARANI  PREM  KUMARI  COLLEGE  OF  NURSING",
  "Bhairab Degree College, Dabugaon",
  "COLLEGE OF BASIC SCIENCE AND TECHNOLOGY",
  "SITALA THAKURANI COLLEGE",
  "MAHAVIR SANSKRIT COLLEGE",
  "Institute of Pharmacy and Technology (IPT), Salipur",
  "CAPITAL BUSINESS SCHOOL ",
  "BIDYANIKETAN DEGREE COLLEGE, NABARANGPUR",
  "AVANTIKA DEGREE COLLEGE",
  "Anchalik Degree College,Subalaya",
  "MAHAVIR COLLEGE OF NURSHING",
  "Dhyamnagar College",
  "SUSILA DEVI COLLEGE OF NURSING, NUAPADA",
  "DHENKANAL ACADEMY OF MANAGEMENT AND TECHNOLOGY",
  "BALASORE INSTITUTE OF HOTEL MANAGEMENT AND TOURISM",
  "SIEMS COLLEGE OF NURSING",
  "VIVEKANANDA COLLEGE OF NURSING ",
  "GAYATRI COLLEGE OF ENGINEERING",
  "ANCHALIK DEGREE COLLEGE, PAHARSRIGIDA",
  "BIGHNESH RESIDENTIAL DEGREE COLLEGE",
  "Gandhi Institute of Excellent Technocrats (GIET), Bhubaneswar ",
  "KALAHANDI COLLEGE OF ART AND RESEARCH",
  "ACHARYA HARIHAR POST GRADUATE INSTITUTE OF CANCER, CUTTACK, ODISHA",
  "e-Tech Residential Degree College",
  "BISHNU RESIDENTIAL INSTITUTE OF SCIENCE , KARANJIA",
  "Konark Bhagabati College, Konark",
  "LALITA ANANTA SEVASHRAM MAHAVIDYALAYA",
  "JAYADEV INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "MERIDIAN DEGREE COLLEGE",
  "MAHARAJA BUSINESS SCHOOL",
  "AMCS College, Tikabali",
  "DR ARTA BALLAVA MOHANTY ADARSHA SANSKRIT AND YOGA MAHAVIDYALAYA",
  "DR SHYAMA PRASAD DEGREE COLLEGE MV SEVENTY NINE",
  "Institute of Management & Information Technology, Cuttack",
  "Royal College of Pharmacy and Health Sciences (RCPHS), Berhampur",
  "Sabitri Devi Sanskrit Mahavidyalaya",
  "Hi-Tech Institute of Technology (HIT), Bhubaneswar",
  "RJ School of Mgmt. Studies (RJSMS), Balasore",
  "Govt.College of Physical Education",
  "P.K.S.S.College",
  "PRIYADARSHINI COLLEGE OF NURSING    ",
  "Ispat College,Rourkela",
  "Ghanteswar Degree College",
  "JAMLA DEGREE COLLEGE",
  "GAYATRI INSTITUTE OF MANAGEMENT SUDHASARANGI BHUBANESWAR",
  "ODISHA ACADEMY OF MEDICAL SCIENCE",
  "VIDYA GROUP OF INSTITUTIONS",
  "Kalahandi Law College",
  "RAJTARA DEGREE COLLEGE    ",
  "DR S S NAYAK ACADEMY",
  "Anugul Mahila Mahavidyala,Angul (W)",
  "Emarti Devi Women’s College,Nayasark,Ctc.",
  "Gopabandhu Women's Degree College, Athgarh, Cuttack.",
  "Indira Gandhi Degree Women's College, Nimapara",
  "SHRI JAGANNATH MEDICAL COLLEGE AND HOSPITAL",
  "Mahanadi Vihar Women's College, ,Mahanadivihar, Cuttack",
  "GOLAP INSTITUTE OF HOTEL MANAGEMENT AND TOURISM ",
  "Rani Sukadei Mahila Mahavidyalaya,Banki, Cuttack",
  "Dharamasala Mahila Mohavidyalaya,(W) Jajpur",
  "Indira Gandhi Mahila Mohavidyalaya, Jajpur",
  "J.P.Sandhya Mahavidyalaya",
  "Kadambini Pal Women's College,Rajatota,Jajpur",
  "Gadibrama Women's College, Kaduapada, Jagatsinghpur",
  "Nayagarh Prajamandal Mahila Mahavidyalaya, Nayagarh",
  "Women's College, Khurda",
  "Satyasai College for Women's, BBSR, Khurda",
  "Tulasi Women's College, Kendrapara",
  "Dr. R.C.S.R.I of Sc. & Tech., Gania, Nayagarh",
  "PRAMILADEVI RESIDENTIAL WOMENS COLLEGE OF SCIENCE AND TECHNOLOGY",
  "ABHIRAM INSTITUTE OF MANAGEMENT AND SCIENCE",
  "LINGARAJ COLLEGE OF NURSING",
  "Dr. H.K. Mahatab Sanskrit College",
  "Santialata Mahavidyalaya",
  "Rayagada (Autonomous) College, Rayagada",
  "MAHESWARI BSC NURSING COLLEGE ",
  "SIEMS COLLEGE OF NURSING",
  "Dr.P.M.I.A.S.for Teacher Education",
  "MOHAN PYARI NILAMBAR NEGI DEGREE COLLEGE RAJPUR PURUNASAR",
  "Udayanath Autonomous College of Science & Technology, Adasapur, Cuttack",
  "NATIONAL INSTITUTE OF SCIENCE EDUCATION AND RESEARCH",
  "ODISHA COLLEGE OF ART AND CRAFTS, PURI",
  "I.G.M. College",
  "IMAGE PLOT NO.2001 SATYAVIHAR RASULGRAH BBSR-10",
  "STEELCITY SCIENCE DEGREE COLLEGE",
  "Tihidi Degree College",
  "MAA BHANDARAGHARANI COLLEGE OF NURSING",
  "KATS Ayurvedic College, Ankushpur",
  "KAMAL KUMARI SANSKRIT WOMENS COLLEGE, LANGALESWAR",
  "Vinayak Degree College",
  "KIIT SCHOOL OF SOCIAL SCIENCES",
  "KUMUDINI NURSING COLLEGE,RANAPUR",
  "Bhadrak (Auto.) College",
  "SRIRAM SCHOOL AND COLLEGE OF NURSING, BHADRAK",
  "Laxmipriya +3 Mahila Mahavidyalaya",
  "P.S.+3 Mahavidyalaya",
  "SANCKET  SCHOOL OF BUSINESS MANAGEMENT,PURAN",
  "SANTI COLLEGE OF NURSING",
  "CENTURION UNIVERSITY OF TECHNOLOGY AND MANAGEMENT RAYAGADA CAMPUS",
  "PALLISHREE MAHILA MAHAVIDYALAYA",
  "Gadibrahma College, Delanga",
  "GOPALPUR COLLEGE, GOPALPUR  ON SEA GANJAM ODISHA",
  "Government Science College, Chatrapur",
  "SUM Nursing College(Faculty of Nursing)",
  "SUBHADRA DEVI COLLEGE OF NURSING",
  "GURUKUL HARIPUR",
  "GITANJALI COLLEGE OF NURSING ",
  "Mahanga Women's College,(W)Pallisahi, Mahanga,Cuttack",
  "SOA National Institute of Law",
  "Institute of Medical Sciences and SUM Hospital( Faculty of Medical Sciences)",
  "PURI SCHOOL AND COLLEGE OF NURSING",
  "RAJDHANI NURSING COLLEGE",
  "NABAGHANA NAYAK DEGREE COLEGE, P NUAGAON",
  "MODERN INSTITUTE OF PROFESSIONAL STUDIES ",
  "Saraswata Mahavidyalaya,",
  "ICSS COLLEGE",
  "Gopalpur College,",
  "DHABALESWAR DEGREE COLLEGE MOHANGIRI",
  "Gop College, Gop",
  "Gayatri Institute of Science and Technology, Berhampur",
  "BINORI COLLEGE AND SCHOOL OF NURSING",
  "AFFINITY INSTITUTE OF MEDICAL SCIENCE",
  "TRISHA NURSING CENTRE",
  "BETNOTI COLLEGE OF NURSING",
  "GHADAI RESIDENTIAL DEGREE COLLEGE MALKANGIRI",
  "SRI JAGANNATH COLLEGE OF PHYSIOTHERAPY ",
  "U.N. College",
  "Centre for Post Graduate Studies, Bhubaneswar",
  "College of Veterinary Science & Animal Husbandry, Bhubaneswar",
  "AYAN INSTITUTE OF HOTEL MANAGEMENT",
  "SCHOOL OF PHARMACY, CENTURION UNIVERSITY OF TECHNOLOGY AND MANAGEMENT, RAYGADA",
  "HATTAKESWAR INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "XGEN COLLEGE OF VISUAL ART",
  "ROYAL DEGREE COLLEGE",
  "Katapali +3 Degree College,Barpali",
  "SCHOOL OF NURSING, CENTURION UNIVERSITY OF TECHNOLOGY AND MANAGEMENT, RAYAGADA",
  "TECHNOWORLD DEGREE COLLEGE, RAIRANGPUR",
  "SIMILIPAL CLLEGE OF NURSING",
  "VISHWA VINAYAK DEGREE COLLEGE",
  "BOUDH COLLEGE OF NURSING",
  "Maharshi Womens Degree College, Sailashree Vihar, Bhubaneswar",
  "C P DEGREE COLLEGE, BHANJKIA",
  "FRANKLIN INSTITUTE OF HOSPITALITY AND MANAGEMENT",
  "PIMIT DEGREE COLLEGE",
  "Lokdrusti College of Advanced Technology",
  "S T A R COLLEGE OF HOTEL AND TOURSIM MANEGEMENT",
  "SANTH ASHARAMJI BAPU DEGREE COLLEGE",
  "MAHAMAYA DEGREE COLLEGE NUAPADA",
  "Balangi Mahavidyalaya",
  "Jambeswar Mahavidyalaya",
  "Jeypore College of Pharmacy (JCP), Jeypore",
  "College of Teacher Education",
  "Premier School of Tourism and Hotel Management",
  "NEW STAR DEGREE COLLEGE",
  "Siddheswar College",
  "BALASORE COLLEGE OF NURSING",
  "NABARANGPUR COLLEGE OF NURSING",
  "PARAMANANDA  DEGREE COLLEGE",
  "SAI COLLEGE OF PHYSIOTHERAPY",
  "TARINI COLLEGE OF NURSING",
  "KALAM  COLLEGE OF NURSING",
  "PRATIVA ACADEMY OF NURSING    ",
  "NUCLEON INSTITUTE OF MEDICAL SCIENCE    ",
  "SAI COLLEGE OF NURSING",
  "MAA TARINI COLLEGE OF NURSING",
  "HAYAGRIBA DEGREE COLLEGE",
  "ARYAN COLLEGE OF NURSING",
  "CHAITANYA PRASAD WOMENS DEGREE COLLEGE , SUNAPOSI",
  "YASHODA WOMENS COLLEGE DEGREE",
  "TRILOCHAN NETRALAYA SAMBALPUR    ",
  "GOURI INSTITUTE OF MEDICAL SCIENCE, LAHUNIPADA",
  "KORAPUT B SC NURSING COLLEGE ",
  "PRATIVA INSTITUTE OF HOLISTIC HEALTH CARE    ",
  "BADRIPRASAD COLLEGE OF COMPUTER TECHNOLOGY",
  "INSTITUTE OF MANAGEMENT AND APPLICATION",
  "KAIRALI COLLEGE OF NURSING",
  "NICE College of + 3 Commerce, Bolangir",
  "SGI SCHOOL OF MEDICAL SCIENCES PHARMACY    ",
  "LACHHAMAN BALAJEW DEGREE COLLEGE, ANGALO",
  "D.K. College",
  "LUCKKY COLLEGE OF PHARMACEUTICAL SCIENCES",
  "UTKAL INSTITUTE OF MANAGEMENT",
  "GOLAP INSTITUTE OF MANAGEMENT TECHNOLOGY ",
  "BADRIPRASAD COLLEGE OF NURSING",
  "UTKALMANI SANSKRIT MOHAVIDYALAYA, BETADA",
  "Central Institute of Petrochemicals Engineering and Technology (CIPET), Bhubaneswar",
  "PADMASHREE KRUTARTHA ACHARYA COLLEGE OF NURSING BARGARH BSC NURSING",
  "NM INSTITUTE OF PROFESSIONAL STUDIES",
  "GONASIKA PLUS THREE SCIENCE COLLEGE",
  "BISWAPRAVA DEGREE COLLEGE,BAHIRKHAMAN",
  "Nrusinganath DEGREE COLLEGE, Mahanadapur",
  "Mahimunda College",
  "P.S.Degree College,Bhedabahal",
  "COLLEGE OF NURSING, VIMSAR, BURLA",
  "Prasanna Panda Law College",
  "S.S.College",
  "Women's Degree College,Kamgaon",
  "P.S.College,Laikera",
  "ALI YAVAR JUNG NATIONAL INSTITUTE OF SPEECH AND HEARING DISABITIES DIVYANGJAN REGIONAL CENTRE JANLA",
  "Radheshyam Degree College",
  "S.G.Women's College",
  "B.P.Degree Women's College,Sonepur",
  "V.V.College,Paikmal",
  "O.M.C. of Homoeopathy & Research",
  "Attabira College,Attabira",
  "P.S.College,Saintala",
  "Agalpur Science College",
  "Bhairabi College,Purunakatak",
  "Jagannath College",
  "Sanatan Harichandan Degree Mahavidyalaya, Madanpur, Khurda",
  "Koira Degree College,Koira",
  "Maa Jhadeswari College,Dhama",
  "Bonaigarh College,Bonaigarh",
  "Deogarh College",
  "R.I.M.Studies,Chhend",
  "Kishorenagar College",
  "A.W.D.I.,Sector-6,Bastia Bhawan,Rourkela",
  "Sohela College",
  "Loisingha College,Loisingha",
  "B.G.T.Law College,Gadvitar",
  "Ghess College,Ghess",
  "P.I.Degree College",
  "Anchal College,Padampur",
  "P.S.College,Gaisilat",
  "Kinjirkela College",
  "B.P.Degree College,Boden",
  "Ekalabya P.S.College,Kansar",
  "College of Arts,Science &Technology,Bondomunda",
  "Bijepur College,Bijepur",
  "P.S.Degree College,Lathor",
  "Hirakud College,Hirakud",
  "Boudh Panchayat College",
  "Bhima Bhoi College,Rairakhol",
  "+3 Women's College,Kantabanji",
  "P.S.College,Belpada",
  "P.S.+3 College",
  "Jasoda Bishnu College",
  "P.S.Degree College,Ulunda",
  "Tora Degree College",
  "Govt.Women's College",
  "Brajrajnagar College",
  "Kantabanji Vocational College, Kantabanji",
  "Government Autonomous College,Rourkela",
  "Maa Maheswari College",
  "Deogarh Women's College",
  "Dalmia College,Rajgangpur",
  "Solapada +3 Degree Mahavidyalaya",
  "Patneswari Women's College",
  "P.S.College,Jharbandh",
  "M.H.N.Degree Mahavidyalaya",
  "Jyoti Vikash College",
  "Motto +3 Degree College",
  "Mandosil College,Mandosil",
  "MINAKSHI COLLEGE OF NURSING",
  "C.J.Degree College,Borda",
  "Kesinga Mahavidyalaya,Kesinga",
  "K.M.Degree College",
  "Govt. Women's College",
  "Lephripara College,Lephripara",
  "Vedvyas Mahavidyalaya",
  "Lingaraj Law College, Berhampur",
  "Shree Ram College",
  "Panchayat College",
  "Women's College, Padampur",
  "ROURKELA SENIOR NURSING COLLEGE",
  "P.S.Degree College,Narla",
  "Jagannath Degree College",
  "Women's College",
  "M.D.Mahavidyalaya",
  "N.A.C.College,Burla",
  "Government Women's College",
  "Lahunipara College,Lahunipara",
  "S.C.Degree College",
  "SARBATI DEVI WOMEN'S COLLEGE,RAJGANGPUR",
  "M.G.Degree College",
  "M.K.M.D.+3 Mahavidyalaya",
  "Govt.Women's College",
  "National College",
  "Gandhi Mahavidyalaya,Rourkela",
  "P.S.College,Kantamal",
  "S.R.Degree Mahavidyalaya",
  "Bargarh Law College,Bargarh",
  "Women's College,Bargarh",
  "H.K.Roy Mahavidyalaya,Chhend",
  "SABITRI GOPAL DEGREE COLLEGE BIRBIRA",
  "Sambalpur University Institute of Information Technology (SUIIT)",
  "Balasore Law College",
  "B.R.Science College,Hatasahi Kacheri,Kendrapara",
  "Katapali  Degree College,Katapali",
  "SAILASHREE SCHOOL AND COLLEGE OF NURSING",
  "ZENITH SCHOOL OF MANAGEMENT",
  "MADHUSUDAN DAS INSTITUTE OF PROFESSIONAL STUDIES ",
  "Astaranga  Degree College, Astarang",
  "INTERNATIONAL INSTITUTE OF MANAGEMENT TECHNOLOGY BHUBANESWAR",
  "RADHA KRISHNA ADIBASI DEGREE COLLEGE DASHMANTPUR",
  "AYUSH DEGREE COLLEGE",
  "Dharamgarh Women's College",
  "Janata College,Boinda",
  "Trupti Womens College",
  "Nilamani Mahavidyalaya",
  "Simulia College",
  "IMB School of Hospitality",
  "BABA SRINIBAS DAS SANSKRIT COLLEGE",
  "Institute of Dental Sciences(Faculty of Dental Sciences)",
  "Oxford College of Engineering and Management (OCEM), Bhubaneswar",
  "NIIS Institute of Engineering & Technology (NIET)",
  "Barapur College",
  "Sarada Sanskrit College",
  "H.K. Mahatab College,",
  "Brahmaeswar Mahavidyalaya, Dharmakirti,Puri",
  "KEONJHAR DEGREE COMMERCE COLLEGE, KEONJHAR",
  "INSTITUTE OF INSTRUMENTATION AND MEDIA SCIENCE",
  "M.H.D.Mohavidyalaya, Chhatia,Jajpur",
  "ISHAAN INSTITUTE OF MANAGEMENT STUDIES",
  "Kalayatan College of Art and Crafts",
  "PREMIER COLLEGE OF NURSING",
  "SATYANARAYAN COLLEGE OF NURSING",
  "Ramjee Degree Mahavidyalaya, Bhishmagiri",
  "SAI INSTITUTE OF PROFESSIONAL STUDIES ",
  "SRI BHUTESWAR PLUS THREE MAHAVIDYALAYA MUSKUTI ",
  "SARASWATI DEGREE VIDYA MANDIR, NEELAKANTHA NAGAR, BERHAMPUR",
  "ARKA ACADEMY OF MANAGEMENT STUDIES",
  "STATE INSTITUTE OF SPECIAL EDUCATION AND RESEARCH,SISER",
  "SHIBANSHI INSTITUTE OF MEDICAL SCIENCE",
  "JHADESWAR COLLEGE OF NURSING",
  "SHREE JAGANNATH SCHOOL OF MANAGMENT",
  "City Women's Degree College, Siripur, BBSR,Khurda",
  "BALAKRUSHNA DAS SHARMA SANSKRIT COLLEGE",
  "Ansupa Degree College, Saranda, Cuttack",
  "PURI INSTITUTE OF HOSPITALITY AND MANAGEMENT",
  "Microsolution Computer Academy",
  "Model Degree College Nuapada",
  "BHABANI COLLEGE OF MANAGEMENT AND TECHNOLOGY",
  "VIDYARTHI COLLEGE",
  "NIST INSTITUTE OF MEDICAL SCIENCE",
  "THE NEWTON COLLEGE OF MANAGEMENT, BARIPADA",
  "SPARSH COLLEGE OF NURSING AND ALLIED SCIENCES, KANTABADA, BHUBANESWAR",
  "JRG COLLEGE OF PHARMACY",
  "ARAMAN TECHNO COLLEGE",
  "Nilgiri Women College",
  "Nilgiri College",
  "Academy of Business Administration",
  "BHUBANESWAR LAW COLLEGE",
  "LOCHAN JAGAT DEGREE COLLEGE",
  "Sai valley World Institute of Management and Technology",
  "P.S.College",
  "Thayaramma Women's Degree College, Gunupur",
  "Ram Narayan Degree College, Dura",
  "T.F.College",
  "Nabarangpur women's degree College, Nabarangpur",
  "BISWAJIT COLLEGE OF MEDICAL SCIENCES",
  "SHREE JAGANNATH COLLEGE OF NURSING",
  "Shri Shri Jagannath Mahvidyalaya, Krushnachandrapur, Nimol, Tiran, Jagatsinghpur",
  "N.B.C. College, Kendupadar",
  "Model Degree College",
  "Gandhi Engineering College (GEC), Bhubaneswar",
  "SBRG (Autonomous) Women's College, Berhampur",
  "Binayak Acharya College, Berhampur",
  "COMPASSION COLLEGE OF NURSING",
  "Rourkela Law College",
  "The Pharmaceutical College (TPC), Barapali",
  "Academy of Business Administration, (ABA), Balasore",
  "Ghanashyam Hemlata Institute of Technology and Management (GHITM), Puri",
  "S.B.P. Mahavidyalaya, Samantiapalli",
  "SRINIX College of Engineering (SCE), Balasore",
  "KALINGA DEGREE COLLEGE ASTARANG",
  "Panabeda Mahavidyalaya, Chandahandi",
  "KHETRA MOHAN COLLEGE",
  "Ranpur College, Ranpur",
  "Biju Patnaik College of Education, Govindapalli",
  "Fakir Mohan Medical College",
  "TSD College, B.D. Pur",
  "NIST Institute of Science and Technology (Autonomous), Berhampur",
  "Radhakrishna Institute of Technology and Engineering (RITE), Khurda, Bhubaneswar",
  "Indira Gandhi Institute of Technology (IGIT), Sarang",
  "Muniguda College, Muniguda",
  "Bhubaneswar Institute of Technology, (BIT), Infovalley, Harapur, Bhubaneswar",
  "Dadhichi College of Pharmacy (DCP), Cuttack",
  "Nowrangpur College, Nowrangpur",
  "Institute of Professional Studies and Research (IPSAR), Cuttack",
  "Malkangiri College, Malkangiri",
  "SANSKRIT MAHAVIDYALAYA, BADAKIA",
  "SIDDHI BINAYAK PLUS THREE SCIENCE COLLEGE",
  "Indian Institute of Yogic Science and Research",
  "Samanta Chandrasekhar Institute of Technology and Management (SCITM), Semiliguda",
  "GURUKRUPA COLLEGE OF MEDICAL SCIENCE,UMERKOTE",
  "UNIITECH DEGREE COLLEGE",
  "Sundergarh  Engineering College (SEC), Sundergarh",
  "IIPM School of Management, Rourkela",
  "MOTHER TERESA COLLEGE OF NURSING",
  "Roland Institute of Technology (RIT), Berhampur",
  "Trinathpur Meeradevi Sanskrit Mahavidyalaya",
  "Sophitorium Engineering College (SEC), Khurda",
  "Black Diamond College of Engineering and Technology, (BDCET), Jharsuguda",
  "Gayatri College of Pharmacy (GCP), Sambalpur",
  "Aryan Institute of Engineering and Technology, (AIET), Barakuda, Khurda, Bhubaneswar",
  "COLLEGE OF MANAGEMENT AND TECHNOLOGY",
  "VIKASH DEGREE COLLEGE",
  "Seemanta Engineering College (SEC), Mayurbhanj",
  "GOVERNMENT WOMENS DEGREE COLLEGE, TITILAGARH",
  "College of IT and Management Education, Bhubaneswar",
  "BIJU PATTNAIK DEGREE COLLEGE, SINGDA",
  "BORDER DEGREE COLLEGE KANKERI",
  "Synergy Institute of  Technology (SIT), Pahala, Bhubaneswar",
  "College of Teacher Education",
  "MANIKESWARI SENOIR NURSING COLLEGE BHAWANIPATNA",
  "Modern Institute of Technology and Management (MITM), Bhubaneswar",
  "SAI SABURI NURSING AND HEALTH SCIENCE COLLEGE ",
  "NIIS Institute of Business Administration (IBA), Bhubaneswar",
  "Majhighariani Institute of Technology and Science (MITS), Rayagada",
  "Sauri Charan Sanskrit Mahavidyalaya",
  "Brundaban +3 Science Residential College, Baramba",
  "Swami Vivekananda College of Science and Management",
  "Rajdhani College of Engineering and Management (RCEM), Bhubaneswar",
  "S.M. Government Women's College, Phulbani",
  "Sri Ram College, Kashinagar",
  "MAYURBHANJ COLLEGE OF NURSING",
  "Saheed Laxman Nayak Medical College and Hospital",
  "KALINGA BHARATI RESIDENTIAL DEGREE COLLEGE",
  "KHORDHA LAW COLLEGE",
  "Saraswat Institute of Management (SIM), Bhubaneswar",
  "DUNGURIPALI WOMENS DEGREE COLLEGE ,DUNGURIPALI",
  "Roland Institute of Pharmaceutical Sciences (RIPS), Berhampur",
  "Polasara Science College, Polasara",
  "SHANTI COLLEGE OF NURSING, JAJPUR",
  "IRMA INSTITUTION OF MEDICAL SCIENCES ",
  "VAMSI INSTITUTE OF MANAGEMENT STUDIES RAYAGADA",
  "GOVT COLLEGE OF NURSING, DISTRICT HEAD QUARTER HOSPITAL, AT KHAMAR SAHI ,NEAR POLICE BARAK ,DIST DHENKANAL",
  "VIVEKANANDA INSTITUTE OF ADVANCED EDUCATIONAL RESEARCH AND TECHNOLOGY",
  "DAV College of Teacher Education, Koraput",
  "Hi-Tech Medical College, Rourkela",
  "D.A.V. School of Business Management, Unit-8, BBSR",
  "CREATIVE TECHNO COLLEGE",
  "Prince (Degree) College of Science",
  "Stewart Science College, Cuttack",
  "SATYANARAYAN COLLEGE OF MANAGEMENT",
  "GANESH INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "RAJKUMAR COLLEGE OF INFORMATION TECHNOLOGY AND MANAGEMENT",
  "GOVERNMENT MEDICAL COLLEGE AND HOSPITAL SUNDARGARH",
  "Minaketan Degree College, Gurandi",
  "KOUSTUV INSTITUTE OF PROFESSIONAL STUDIES",
  "KRUSHNA CHANDRA SANSKRIT WOMENS COLLEGE",
  "KASTURABA COLLEGE OF NURSING GANJAM",
  "ARUN COLLEGE OF NURSING ",
  "AYAN INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "NUAGAON +3 DEGREE COLLEGE",
  "R.G. College, Padmapur",
  "GURUKUL INSTITUTE OF MEDICAL SCIENCE ",
  "Govt. Women's College, Puri",
  "Indira Gandhi Womens College, Selter Chhaka,Cuttack.",
  "K.D.S.Women’s College, Darakhapatna,Cuttack",
  "K.N.Women's  College,BBSR, Khurda",
  "Korua Women's College, Korua,Kendrapara",
  "Mangalpur Women's College, Mangalpur,Jajpur",
  "Nalini Devi Women's College of Teachers' Education, Bhubaneswar",
  "Netrananda Sahoo Women's College, Kakatpur",
  "Pattamundai Women's College, Pattamundai, Kendrapara",
  "SRI INSTITUTE OF MANAGEMENT",
  "Remuna Degree College",
  "DPIASE, Konisi",
  "Army A.D. College, Gopalpur",
  "Saheed Laxman Nayak Degree College, Baipariguda",
  "Gunupur College, Gunupur",
  "Mahamayee Mahila Mahaidyalaya, Berhampur",
  "R.I.H.S. Bhograi",
  "Biju Patnaik Women's College, Digapahandi",
  "MITS Institute of Professional Studies, Rayagada",
  "Salandi Mahavidyalaya",
  "RADHARAMAN COLLEGE OF NURSING",
  "ABHINAV BINDRA SPORTS MEDICINE AND RESEARCH INSTITUTE",
  "School of Pharmaceutical Sciences(Faculty of Pharmaceutical Sciences)",
  "Rambag Womens College, Rambag",
  "Derabish Degree Mahila Mahavidyalaya",
  "S.B.D.Mahila Degree Mahavidyalaya",
  "Kasturaba Gandhi Womens College",
  "SRI VENKATESWAR DEGREE COLLEGE KASHINAGAR",
  "School of Hotel Management(Faculty of Hotel Management)",
  "Institute of Technical Education & Research(Faculty of Engineering and Technology)",
  "Aska Science College, Aska",
  "Government (Autonomous) College, Phulbani",
  "GOPINATH COLLEGE OF NURSING, NUAPADA",
  "BADRIPRASAD INSTITUTE OF MEDICAL SCIENCE",
  "Capital Law College, Plot No. A/63, CRP Square, Bhubaneswar",
  "L.B.College,Ayatpur, Kendrapara",
  "Kalam Institute of Technology (KIT), Berhampur",
  "College of Basic Science & Humanities, Bhubaneswar",
  "Institute of Business & Computer Studies( Faculty of Management Studies)",
  "College of Fisheries, Rangailunda",
  "College of Agriculture, Chiplima",
  "College of Agriculture, Bhubaneswar",
  "College of Agriculture, Bhawanipatna",
  "College of Agricultural Engineering & Technology, Bhubaneswar",
  "RAYAGADA INSTITUTE OF PROFESSIONAL STUDIES",
  "IDREAM GROUP OF INSTITUTIONS ",
  "UNOPOS College of Professional Studies, Jagatsinghapur",
  "Pipli College, Pipli",
  "BRM Institute of Management and Information Technology (BRMIMIT), Bhubaneswar",
  "Barrister Ranjit Mohanty  International Institute of Technology (BRMIIT), Bhubaneswar",
  "Anchalik Degree College,Talmal,Angul",
  "RADHAKRUSHNA SANSKRIT MAHAVIDYALAYA",
  "DHRUBA CHARAN MAHAVIDYALAYA",
  "HM SCHOOL OF BUSINESS MANAGEMENT",
  "AMIT COLLEGE OF NURSING",
  "College of Advance Computing, Berhampur",
  "Chatrapur Women's College, Chatrapur",
  "Indira Memorial Degree College, Chandiput",
  "Sunabeda Women's College, Sunabeda",
  "Khemundi College, Digapahandi",
  "Maa Markama College, Bissamcuttack",
  "SUBARNAPUR NURSING SCHOOL",
  "Kishore Nagar College,Kishore Nagar,Cuttack",
  "B B CHHATOI COLLEGE OF NURSING ",
  "MANMATH DHAL DEGREE COLLEGE",
  "MAHARSI COLLEGE OF NURSING",
  "PRATIVA DEVI COLLEGE OF NURSING",
  "UTKALMANI GOPABANDHU DEGREE MAHAVIDYALAYA MATHILI MALKANGIRI",
  "KALAM INSTITUTE OF MANAGEMENT STUDIES",
  "BIDYARTHI DEGREE COLLEGE",
  "XAVIERS NURSING COLLEGE",
  "LOK YOJANA",
  "STATESMAN ACADEMY OF MEDICAL SCIENCE",
  "XAVIER PHARMACY COLLEGE",
  "DHABALESWAR INSTITUTE OF NURSING",
  "SARASWATI NURSING COLLEGE ",
  "PLUS THREE KASHI BISWANATH MAHAVIDYALAYA,PAIKSAHI DIST ANGUL",
  "BHIMA BHOI DEGREE COLLEGE KATAPALI",
  "EINSTEIN COLLEGE OF PHARMACY",
  "VINAYAK INSTITUTE OF MEDICAL SCIENCE",
  "SRI JAGANNATH COLLEGE OF NURSING, NUAPADA",
  "BIRAJA NURSING COLLEGE",
  "Capital Engineering College, (CEC), Mahatpala, Khordha",
  "ORISSA COLLEGE OF PHARMACEUTICAL SCIENCES",
  "VEDBYASH RESIDENTIAL DEGREE COLLEGE, BERHAMPUR",
  "DR AMBEDKAR INSTITUTE OF PHARMACEUTICAL SCIENCE ",
  "BHARAT INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "Templecity Institute of Technology and Engineering (TITE), Khurda",
  "SAHAJANAGAR SANSKRIT COLLEGE",
  "OMCC DEGREE COLLEGE BHADRAK",
  "Trident Academy of Technology (TAT), Bhubaneswar",
  "CUTM-Bolangir campus",
  "JEEVAN VIKASH DEGREE COLLEGE DAHYA BOUDH",
  "Krushna Priya Devi Degree Women's College, Daspalla",
  "Pingalakhi Public Welfare Organisation",
  "Sambalpur Nursing College, At- ASA Academy,Po-Jayantpur",
  "K C DEGREE COLLEGE, DARINGBADHI",
  "K B H I S T DEGREE COLLEGE",
  "P.S.College,Kolabira",
  "Belpahar College,Belpahar",
  "Bhubaneswar Institute of Industrial Technology, (BIIT), Khurda",
  "Ajay Binay Institute of Technology, (ABIT), Cuttack",
  "B.S. College, Daspalla",
  "D.J. +3 Mahavidyalaya, Bahada Jhola, Nayagarh",
  "K.I.G.M. Degree College, Linepada",
  "DM Science College, Gallery",
  "Science College, Hinjilicut",
  "Astha School of Management, (ASM), Bhubaneswar",
  "Anchalika Degree College, Jagannathprasad",
  "Sri Jagannath Mahavidyalaya, Rambha",
  "Konark Institute of Science and Technology (KIST), Bhubaneswar",
  "The Techno School (TTS), Bhubaneswar",
  "INSTITUTE OF MANAGEMENT STUDIES",
  "Rayagada Institute of Technology And Management (RITAM), Rayagada",
  "DELTA INSTITUTE OF AGRICULTURE AND MANAGEMENT",
  "AMRI COLLEGE OF NURSING     BHUBANESWAR",
  "SUBAS Institute of Technology (SIT), Barang, Bhubaneswar",
  "SYNERGY COLLEGE OF NURSING DHENKANAL",
  "Regional College of Management (RCM), Bhubaneswar",
  "Gandhi Institute for Education and Technology (GIET), Khurda, Bhubaneswar",
  "VITS Engineering College, Khurda",
  "Science College, Konkorada",
  "Srimaa Mahila M.V. Baripada",
  "Bhadrak Womens College",
  "Boula +3 Degree College, Soso",
  "Mayurbhanj College of Account & Mgt, Baripada",
  "B.P.S College, Barsahi",
  "MAA VAISHNODEVI COLLEGE OF PHARMACY ",
  "BALAJI INSTITUTE OF TECHNOLOGY",
  "VIDYA COLLEGE OF MEDICAL AND HOSPITAL TRAINING",
  "Madhupur College,Kalan,Jajpur",
  "SANTHA KABI BHIMA BHOI MAHIMA PLUS THREE MAHAVIDYALAYA CHAKARKEND",
  "ADARSHA COLLEGE OF LAW",
  "Baya Abadhut College,Kanimal,Jagatsinghpur",
  "LAKSHYA INSTITUTE OF TECHNOLOGY",
  "Maa Maninaga Durga Mahila Mahavidyalaya",
  "REGIONAL DEGREE COLLEGE ADAKATA",
  "CENTURION UNIVERSITY OF TECHNOLOGY AND MANAGEMENT, GOPALPUR, BALASORE",
  "SHREE GANESH INSTITUTE OF BUSINESS MANAGEMENT",
  "+3 sanda College, Sanda, Hindol Road, Dhenkanal",
  "VIKASH SCHOOL OF BUSINESS MANAGEMENT",
  "STAR MANAGEMENT COLLEGE",
  "Bhadrak Institute of Engineering and Technology, (BIET), Bhadrak",
  "Krutika Institute of Technical Education (KITE), Bhubaneswar",
  "Dr. Ambedkar Memorial Institute of Information Technology and Management Science, Rourkela",
  "Saheed Bhagat Singh Degree College, Khandadeuli",
  "Koustav Business School, BBSR",
  "ADARSHA PROFESSIONAL DEGREE COLLEGE",
  "Balasore College of Engineering and Technology, (BCET), Balasore",
  "Satyasai Engineering College (SEC), Balasore",
  "Padmashree Krutartha Acharya College of Engineering (PKACE), Bargarh",
  "JEYPORE COLLEGE OF NURSING",
  "SRI SAI RAMA KRISHNA DEGREE COLLEGE    ",
  "Rimuli College, Rimuli",
  "SARASWATI DEGREE SCIENCE COLLEGE, LINK ROAD, CUTTACK",
  "Krupajal Management Studies (KMS), Bhubaneswar (Formerly : AMS, Bhubaneswar)",
  "Capital Institute of Management and Science, (CIMS), Bhubaneswar",
  "BHAGABATI KOUSALYA SCHOOL OF NURSING BALANGIR",
  "Chitrada Coqllege, Chitrada",
  "Jhadeswar +3 Degree College,chhanpur",
  "Bhubaneswar College of Engineering, (BCE), Khordha",
  "Sanjay Memorial Institute of Technology (SMIT), Berhampur",
  "Ramamani  Mohavidyalaya,  Kantabad,Khurda",
  "PJ College of Management and Technology (PJCMT), Bhubaneswar",
  "People's College, Buguda",
  "Trident Academy of Creative Technology (TACT), Bhubaneswar",
  "Kanak Manjari Institute of Pharmaceutical Sciences (KMIPS), Rourkela",
  "Laxmipur College, Laxmipur",
  "SAI NURSING COLLEGE",
  "A.A.Training College, Fakirpur, Aanandapur",
  "GURUKRUPA COLLEGE OF NURSING    ",
  "Belavoomi Mahavidyalaya",
  "Dadhibaman College, Turmunga",
  "VIJAYANJALI SCHOOL OF MANAGEMENT, KHANTAPADA, BALASORE    ",
  "Mahavir Institute of Engineering and Technology (MIET), Khurda, Bhubaneswar",
  "Ranapur Sanskrit College",
  "Damodar Sanskrit College",
  "Jagannath Veda Karmakanda Mohavidyalaya",
  "Binapani Sanskrit College",
  "Astasambhu Sanskrit College",
  "Sanskrit College (Paralakhemundi)",
  "Abhaya Ayurveda Sanskrit College",
  "S.N. Sanskrit College",
  "Saraswati Mahila Sanskrit College",
  "Jagannath Sanskrit College",
  "Sri Sri Ananta Narayan Sanskrit College",
  "Shymarai Sanskrit College",
  "Pathadurga Sanskrit College",
  "Sri Jagannath Sanskrit College",
  "Bagiswari Sanskrit College",
  "Government College of Engineering, Keonjhar",
  "Bholanath Sanskrit College",
  "Swami Sivananda Sanskrit College",
  "Radhamadhab Sanskrit College",
  "Dr. Ghanashyam Mishra Sanskrit College",
  "Kalandi Charan Sanskrit College",
  "U.K.Mahavir College, Madanpur, Kendrapara",
  "GNEXT ALLIED MEDICAL INSTITUTE",
  "PHULBANI ACADEMY OF MANAGEMENT AND TECHNOLOGY",
  "Gopinathpur Sanskrit College",
  "Jadunath Sanskrit College",
  "Narendranath Sanskrit College",
  "Dadhibamanjew Sanskrit College",
  "Ramadhin Sanskrit College",
  "Mac-Micle Sanskrit College",
  "Biraja Sanskrit College",
  "Malagiri Mahavidyalaya,Pallahara,Angul",
  "Government College, Sundargarh",
  "VIDYANT COLLEGE OF MANAGEMENT AND SOCIAL SCIENCE",
  "NUCLEUS INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "NIGAMANANDA INSTITUTE OF MANAGEMENT STUDIES",
  "NATIONAL INSTITUTE OF LEGAL STUDIES (NILS), MANJURI, JAJPUR",
  "Japakud Women's Degree College, Japakud",
  "ODISHA COLLEGE OF NURSING AND MEDICAL SCIENCES",
  "College of Pharmaceutical Sciences, Mohuda",
  "IIMT COLLEGE OF NURSING    ",
  "GOVERNMENT DEGREE COLLEGE, KUARMUNDA    ",
  "GOVERNMENT DEGREE COLLEGE, NUAGAON    ",
  "GOVERNMENT DEGREE COLLEGE, CHITRAKONDA    ",
  "DHABALESWAR INSTITUTE OF PHARMACY    ",
  "GOVERNMENT DEGREE COLLEGE BANDHUGAON     ",
  "FUTURE COLLEGE OF NURSING",
  "GOVERNMENT DEGREE COLLEGE NARAYANPATNA    ",
  "ODISHA NURSING COLLEGE",
  "Jeypore Law College, Jeypore",
  "D.A.V Autonomous College,Titlagarh",
  "Bhairaba Degree Mahavidyalaya, Borigumma",
  "GOVT DEGREE COLLEGE DHARAKOTE    ",
  "Barbil College, Barbil",
  "Karanjia  Autonomous College, Karanjia",
  "RAJANIKANTA DEGREE COLLEGE , BIJATALA",
  "MUKTI COLLEGE OF NURSING",
  "VIDYA COLLEGE OF MANAGEMENT",
  "SARALA SANSKRIT MAHAVIDYALAYA",
  "GOUTAM BUDHA NURSING AND PARAMEDICAL SCIENCE COLLEGE",
  "SARASWATI PLUS THREE SCIENCE COLLEGE, BHAWANIPATNA    ",
  "Belleswar Mahavidyalaya, Gondola",
  "VIDYA DEGREE COLLEGE",
  "KOSHAL COLLEGE OF NURSING",
  "SURYA INSTITUTE OF MEDICAL SCIENCE AND RESEARCH CENTRE",
  "DIVINE INSTITUTE OF MEDICAL SCIENCE AND RESEARCH",
  "Anchalika Mahavidyalaya, Kshetriyabarapur",
  "S.N.Ayurvedic College,Paikmal",
  "N.S.C.B.College",
  "Saswat Mahavidyalaya",
  "Anchalik +3 Degree College,Sanchergaon",
  "Kalyani Roy Mahavidyalaya",
  "U.H.Medical College",
  "Tusra Degree College",
  "P.S.+3 Degree College",
  "D.S.College,Laida",
  "Dunguripali College,Dungripali",
  "+3 Degree College,Sinapali",
  "GAYATRIMATA SANSKRIT MOHAVIDYALAYA",
  "ANCHALIKA SAHAJOGA SANSKRIT MAHAVIDYALAYA",
  "I.M.P.S.Degree College",
  "Rourkela College",
  "P.S.Degree College",
  "Sonepur College",
  "Indravati Mahavidyalaya",
  "Jamankira College,Jamankira",
  "D.B.College,Bhatli",
  "Palsama Science College,Palsama",
  "A.K.College,Bheden",
  "+3 Degree College,Karlapada,Kalahandi",
  "Athamallik College,Athmallik",
  "P.A.Mahavidyalaya",
  "P.M.Mahavidyalaya",
  "Mahima College",
  "V.P.College",
  "Govt. Ayurvedic College",
  "Naktideul College",
  "B.G.Degree College,Kasaibahal",
  "Tara Tarini College, Purushottampur",
  "RNM INSTITUTE OF HIGHER STUDIES    ",
  "Gayatri Institute of Computer and Management Studies (GICMS), Gunupur",
  "AMBEDKAR DEGREE COLLEGE",
  "OM BBS COLLEGE OF NURSING ",
  "S.A.N. College of Edu. Technology, Kurtang, Jagatsinghpur",
  "S.M.S. College, Chitrakarasahi, Puri",
  "Gatiswar College, Malisahi, Nayagarh",
  "Sarat Paikaray Mohavidyalaya, Aragul, Khurda",
  "Mahanadi Mahavidyalaya, Khakhadi, Cuttack",
  "Kanas College, Kanas, Puri",
  "Sudhananda School of Management and Computer Science (SSMCS), Bhubaneswar",
  "A.P.College,Sujanpur,Jajpur",
  "Kalinga Institute of Management & Technology, 7th Floor, OCHC Complex, Unit-III, Bhubaneswar",
  "+S.S.S. Mohavidyalaya, Satyavihar, Dhenkanal",
  "M.S.College,Baramba, Cuttack",
  "K.B.D.A.V.College, Nirakarpur, Khurda",
  "Naxatra Institute of Media Studies, Chandrasekharpur, Plot No.-1, CNI Complex, Bhubaneswar",
  "Sophitorium Institute of Technology & Life Skills, Jatni, Khurda",
  "Adivasi College, Balliguda",
  "Jiral College,Jiral,Dhenkanal",
  "Konark Women's College, Sarada, Konark",
  "Balikuda College,Balikuda,Jagatsinghpur",
  "P.S. College, Khandapara, Nayagarh",
  "PJ College of Management & Technology, Kesora, Bankual, Bhubaneswar",
  "Jhadeswar Degree College, Tolkani,Jajpur",
  "Nimapara Autonomous College, Nimapara",
  "Kaniha Degree College, Kaniha, Angul",
  "Chitalo College,Chitalo, Jajpur",
  "Kandarpur College, Kandarpur,Cuttack",
  "Christ College, Cuttack",
  "GovindapurCollege, Sailo,Govindapur,Ctc.",
  "Delta Degree College,Narayani Vihar,Bhitar Bampu, Kendrapara",
  "D.S. Law  College, Kendrapara",
  "AlakaMohavidyalaya,Anantabata,Jagatsinghpur",
  "U.N.S.College,Mugpal, Jajpur",
  "BIJU PATNAIK SCIENCE DEGREE COLLEGE BADAGADA GANJAM",
  "MAHARSHI BUDDHARAM DEGREE COLLEGE,MENDA",
  "VEDIC COLLEGE OF PLUS THREE SCIENCE AND COMMERCE, PABPALI, SASON, SAMBALPUR",
  "MAA BHAGABATI SANSKRIT COLLEGE, NADUPUR",
  "Biju Patnaik Homeopathy Medical College & Hospital, Berhampur",
  "Sidhabarang College of Edu. Tech., Punanga, Jagatsinghpur",
  "BH.D.Mahavidyalaya, Markandapur,Jajpur",
  "Arya School of Management & Information Technology, Plot No. 320, Patrapada, BBSR",
  "+3 Anchalika Mahavidyalaya, Barisal, Dhenkanal",
  "Chaitanya Sahu College of Sci.&Arts, Nuapatna, Cuttack",
  "Kalapathar Dhalapathor College, Kalapathar, Cuttack",
  "Ramachandi Mohavidyalaya, Gadamanitri, Khurda",
  "P.M.M.Degree College, Rengali,Angul",
  "Garhapalasuni College,Garhapalasuni,Dhenkanal",
  "J.N.College,Kuanpal, Cuttack",
  "N.S.M.CityCollege, Rajabagicha, Cuttack",
  "S.S.R.N.J. Mahavidyalaya, Gania, Nayagarh",
  "International Institute of Rehabilitation Sciences & Research",
  "Patitapaban Mahavidyalaya,Jarapara,Angul",
  "RAJA MADHUSUDAN DEV DEGREE COLLEGE OF SCIENCE AND EDUCATION, BHUBANESWAR",
  "Hi-Tech College of Nursing, Health Park, Pandara, Rasulgarh, Bhubaneswar",
  "Brahmonjharilo Mahavidyalaya,Raipur, Phulnakhera, Cuttack",
  "NISWASS, 3, Chandrasekharpur, Bhubaneswar",
  "Institute of Technology & Management Studies, Praja Niketan, Nimapara, Puri",
  "Rajdhani College,BBSR, Khurda",
  "Mukundapatra Degree Mahavidyalaya, Balarampur, Jajpur",
  "Inter Science Degree College,, Kantabad, Khurda",
  "Maharshi College of Natural Law, BBSR, Khurda",
  "IPSAR, IPSAR House, Sector- 6 CDA, Cuttack-14",
  "K.C.Mohavidyalaya, Korai,Jajpur",
  "S.N.College,Rajkanika, Kendrapara",
  "Pingua Degree College, Pingua,Dhenkanal.",
  "M.A.College,Lemalo,Cuttack",
  "Kalyanpur College, Kalyanpur, Puri",
  "AnchalikMahavidyalay, Pragyan Vihar,Dhenkanal",
  "Dhenkanal Autonomous College, Dhenkanal",
  "Godabarish Mohavidyalaya, Banpur,Khurda",
  "P.S. Degree College,Balakati, Khurda",
  "Raghunath Jew College, Deuliisahi,Cuttack",
  "College of Business Management, Mukund Prasad, Khurda",
  "Sahaspur College, Balichandrapur,Jajpur",
  "Jenapur Degree College, Jenapur,Jajpur",
  "Hindi Teachers Training Institute, Old Secretariat Building, Cuttack.",
  "K.B.College,Baranga,Khurda",
  "P.S.S.J.College, Banarpal,Angul",
  "S.A.Mohavidyalaya, Balipatna, Khurda",
  "KESABA PANDA DEGREE WOMENS COLLEGE SURADA",
  "PATHANI SAMANTA COLLEGE OF NURSING",
  "Biju Patnaik Institute of Information Technology and Management, (BIITM), Bhubaneswar",
  "REGIONAL DEGREE COLLEGE DAMBASARA",
  "Berhampur City College, Berhampur",
  "SABARMATI  COLLEGE OF NURSING",
  "Anchalika Science College, Ballipadar",
  "Semiliguda College, Semiliguda",
  "SRI INTERNATIONAL COLLEGE",
  "SWAMI VIVEKANANDA INSTITUTE OF MANAGEMENT",
  "HITECH COLLEGE OF NURSING ROURKELA",
  "EVERMATE INSTITUTE OF TOURISM MANAGEMENT",
  "NIPS HOTEL MANAGEMENT",
  "INSTITUTE OF BUSINESS MANAGEMENT",
  "Biju Patnaik Institute of Information Technology and Management Studies",
  "Bellaguntha Science College, Bellaguntha",
  "Bhanja College of Computer and Management, Bhanjanagar",
  "Udaya Pratap Science College, Shegada",
  "K.M. Science College, Narendrapur",
  "SHRI JAGANNATH ADARSHA SANSKRIT MAHAVIDYALAYA",
  "KOUSIKA BABA +3 COLLEGE, TERESINGA",
  "Dr. Ramesh Prasad Degree Womens College, Ulunda",
  "K.K.S. Women's College",
  "Agarapada College",
  "Baliapal College of Phy, Edn",
  "Berhampur College",
  "Naami College",
  "Balikhand +3 College",
  "Khaira College,",
  "Jaleswar Womens College",
  "S.J.E.F. Barunsingh",
  "Chandabali College",
  "Mandari College",
  "+3 Maa Sarada Devi Mahavidyalaya",
  "Kamarda Mahavidyalaya",
  "GOVERNMENT DEGREE COLLEGE KOSAGUMUDA    ",
  "Bant Achalika College",
  "Bhadrak Law College",
  "Chikiti Mahavidyalaya, Chikiti",
  "Disha College of Management, Berhampur",
  "Government College, Koraput",
  "JUPITER DEGREE COLLEGE",
  "Jagannath College",
  "P.S.Degree College",
  "GOVERNMENT DEGREE COLLEGE TENTULIKHUNTI    ",
  "J.J. Mahavidyalaya, Raikia",
  "F.M. College",
  "MODEL DEGREE COLLEGE",
  "Aeronautics College, Sunabeda",
  "LAMTAPUT DEGREE COLLEGE",
  "Satyanarayan Degree Science College",
  "Biswasroy Science College, Pattapur",
  "Panchayat Degree Mahavidyalaya, Belakhandi",
  "Gangeswari Mahavidyalaya, Pottangi",
  "MODEL DEGREE COLLEGE RAYAGADA",
  "Khariar Autonomous College,Khariar",
  "MKCG Medical College, Berhampur",
  "Oupada College",
  "NILAKANTHESWAR COLLEGE",
  "Nayanamani (+3) Womens College",
  "MURALIDHARA SWAIN ART AND CRAFTS MAHAVIDYALAYA",
  "INSTITUTE OF BUSINESS MANAGEMENT AND TECHNOLOGY",
  "Bhima Bhoi Medical College and Hospital, Balangir",
  "JAY MAA PATANESWARI DEGREE COLLEGE PANCHCHHAK",
  "Kotpad College, Kotpad",
  "MANUU POLYTECHNIC, CUTTACK",
  "SWARNALATA SCHOOL OF NURSING",
  "ASWASANA COLLEGE OF NURSING",
  "College of Horticulture, Chiplima",
  "S.C.B. Medical College, Cuttack",
  "College of Home Science, Bhubaneswar",
  "DARWIN MEMORIAL DEGREE COLLEGE, KUDUMULUGUMMA",
  "NUCLEUS INSTITUTE OF MEDICAL SCIENCES",
  "SHAIKH COLLEGE OF NURSING",
  "Saraswat Degree Mahavidyalaya",
  "College of Forestry, Bhubaneswar",
  "Rushimal Mahavidyalaya, Bamunigaon",
  "A.B.Womens Degree College,Alakunda,Jajpur",
  "PARSURAM DEGREE COLLEGE SEVAKPUR",
  "Balikuda Women's College,Balikuda(W),Jagatsinghpur",
  "B.D.Mahila Mahavidyalaya, Natkai,Nischintakoili,Cuttack",
  "Bhuban +3 Womens College,Bhuban,Dhenkanal",
  "Biraja Womens College, Jajpur",
  "Biren Mitra Memorial Women’s College, Thoriasahi, Ctc.",
  "Chitrotpala Women's College, Korua, Kendrapara",
  "Dhenkanal Mahila Mahavidyalaya(W), Dhenkanal",
  "BaphgeeCollege,Chendipada,Angul",
  "P.S.Degree College,Koksara",
  "College of Teacher Education,Rourkela",
  "Dr. Ambedkar Memorial Institute of Information Technology & Management Science,Rourkela",
  "SAI SMRUTI COLLEGE",
  "JIBANJYOTI COLLEGE OF SPECIAL EDUCATION",
  "Degree Goorumahisani Iron College",
  "AMAR +3 MAHAVIDYALAYA KUSURLA",
  "GURUKRUPA COLLEGE OF MANAGEMENT",
  "Trytoon Academy",
  "College of Nursing, Plot No. 201, Ranihat, Cuttack",
  "Arabian Institute of  Hospitality Management",
  "Laxmi Nursingh Sanskrit College",
  "NM Institute of Engineering and Technology (NMIET), Bhubaneswar",
  "SHREE GANESH PLUS THREE SCIENCE RESIDENTAL COLLEGE",
  "A.S.College,Tirtol, Jagatsinghpur",
  "Global Institute of Engineering and Management",
  "CHANDAKA DEGREE COLLEGE",
  "INSTITUTE OF PROFESSIONAL LEARNING",
  "BABA SAHEB AMBEDKAR DEGREE COLLEGE KHAJURIPADA GAJAPATI DISTRICT",
  "Sambad School of Media and Culture",
  "U.N College, Nalagaja",
  "BABA BHIMESWAR SANSKRIT COLLEGE, CHAPAMANIK",
  "PADMALAYA SCHOOL AND COLLEGE OF NURSING",
  "Balasore College of Art and Crafts",
  "Badampahar Degree College, Badampahar",
  "Xavier College of Hotel Management",
  "SOS COLLEGE OF NURSING",
  "Bhubaneswar School of Hotel Management and Tourism",
  "Bhadrak College of Art and Crafts",
  "S.S.D.Mahavidyalaya,Gurudijhatia,Cuttack",
  "Govt. College of Art and Crafts",
  "Salipur College,Salippur,Cuttack",
  "M.G. College of Education and Tech. Astarang",
  "National Institute of Hotel Management and Tourism",
  "Buji Pattnaik College of Hotel Management and Tourism",
  "R.C.M. Science College, Khallikote",
  "SCB Dental College & Hospital, Cuttack",
  "Mayurbhanj Law College, Baripada",
  "Orissa Academy of Social Sciences and Integrated Studies",
  "Nayagarh College, Nayagarh",
  "Pabitranager +3 Mahavidyalaya,Porbil, Angul.l",
  "B.J.B. Autonomous College, BBSR, Khurda",
  "Dampara Anchalik Mahavidyalaya,Dampara, Cuttack.",
  "Larambha College",
  "Regional Institute of Social Science of Research",
  "Gopinath Dev Degree College, Pratap Purusottampur",
  "National Institute of Fashion Design",
  "Loknath  Mohavidyalaya, Korua,Patkura, Kenedrapara",
  "Nigam Institute of Engineering and Technology (NIET), Bhubaneswar",
  "D.L.Degree College, Bahalda",
  "Nachuni College, Nachuni, Khurda",
  "Academy of Technocrats, Berhampur",
  "ASHWINI COLLEGE OF NURSING CUTTACK",
  "Kalinga C ollege, Manada",
  "SCS (Auto) College, Puri",
  "Indira Gandhi Institute of Pharmaceutical Sciences (IGIPS), Bhubaneswar",
  "Dhenkanal Evening College,Dhenkanal",
  "Keonjhar Law College, Keonjhar",
  "S.S Mahavidyalaya, Kuamara",
  "Sukruli Degree College, Sukruli",
  "Mahabirod College,Mahabirod,Dhenkanal",
  "SHALOM INSTITUTE OF MANAGEMENT STUDIES",
  "RAJDHANI COLLEGE OF SCIENCE TECHNOLOGY AND MANAGEMENT",
  "Seemaanta M.V, Jharapokharia",
  "Sindhidevi Mahavidyalaya, Nandapur",
  "Women's Degree College, Khandapara, Nayagarh",
  "KANDHAMAL COLLEGE OF NURSING",
  "MAA VAISHNODEVI NURSING COLLEGE",
  "Women's Degree College, Paralakhemundi",
  "ODISHA INSTITUTE OF MEDICAL SCIENCE",
  "SATYABADI SANSKRIT MAHAVIDYALAYA",
  "Hilltop College, Mohana",
  "NSB College, Nuvapada",
  "PRAVAKAR SANSKRIT MAHAVIDYALAYA",
  "RATNAKAR SANSKRIT MAHAVIDYALAYA",
  "KT SCHOOL OF PHARMACY",
  "National Institute of Social Work and Social Science",
  "Sri Jayadev College of Pharmaceutical Sciences (SJCPS), Bhubaneswar",
  "Govt. Women's College,Baripada",
  "BAITARANI COLLEGE OF NURSING",
  "GANESH INSTITUTE OF HEALTH SCIENCE",
  "MAMATADEVI COLLEGE OF NURSING",
  "Ashramapatna College,Ashramapatn,Jagatsinghpur",
  "NARAYANI INSTITUTE OF MANAGEMENT AND COMPUTER EDUCATION,TALCHER,ANGUL",
  "Manikeswari Degree College",
  "SRI AUROBINDO INSTITUTE OF HIGHER EDUCATION, RESEARCH AND STUDIES",
  "GANESH INSTITUTE OF ENGINEERING AND TECHNOLOGY  DEGREE SCIENCE COLLEGE",
  "Institute of Physics (IOP),Bhubaneswar",
  "VIKASH NURSING COLLEGE",
  "Utkal Sangeet Mahavidyalaya",
  "SPARSH COLLEGE OF COMPUTER AND MANAGEMENT",
  "SRI DADHIBAMAN JEW SANSKRIT MAHAVIDYALAYA",
  "THE NEWTON COLLEGE OF MANAGEMENT",
  "SRIRAM INSTITUTE OF MEDICAL SCIENCE AND RESEARCH",
  "SARASWATI COLLEGE OF NURSING",
  "SAHAYOGA COLLEGE OF NURSING",
  "ANANTA MEMORIAL COLLEGE OF NURSING",
  "SHREE MANDIR COLLEGE OF NURSING",
  "SARALA COLLEGE OF NURSING",
  "SAI COLLEGE OF NURSING",
  "SATYANARYAN COLLEGE OF NURSING",
  "SAILABALA INSTITUTE OF NURSING AND MEDICAL SCIENCE",
  "SRI JAGANNATH B SC NURSING COLLEGE ",
  "Krupajal Computer Academy (KCA), Bhubaneswar (Formerly : OCA, KEC, BBSR)",
  "GURUKRUPA COLLEGE OF NURSING",
  "JAYA JAGANNATH DEGREE COLLEGE",
  "GKF NURSING INSTITUTE",
  "MOTHERS COLLEGE AND SCHOOL OF NURSING BHUBANESWAR",
  "RADHAKANT COLLEGE OF NURSING",
  "TIMES DEGREE COLLEGE, JEYPORE",
  "Nilachhal Narayan Ayurveda Chatuspathy",
  "Guru Harekrushna Behera College of Art and Culture",
  "Bauribandhu Mahavidyalaya, Chhatabar",
  "United School of Business Management (USBM), Bhubaneswar",
  "Central Institute of Hotel Management and Catering",
  "KMBB College of Engineering and Technology, Bhubaneswar",
  "GITA Autonomous College, Bhubaneswar ",
  "Tulasi Sanskrit College",
  "D.P. Mishra Institute, Kodala",
  "Niranjan Government Women's College, Aska",
  "Rushikulya Degree College, Surada",
  "L.N. Degree College, Kodala",
  "D.R.Nayapalli College, Nayapalli, BBSR, Khurda",
  "Baji Roul Memorial College, Bhuban,Dhenkanal",
  "Keshpur College, Keshpur",
  "Sukra Behera Degree College, Kendudhip, Nayagarh",
  "MITS  School of Biotechnology, 2P, Infocity, Patia, Chandaka Industrial Estate, Bhubaneswar",
  "GRAMYAPRAVA COLLEGE OF NURSING BSCN",
  "Bamra T.F.College,Bamra",
  "G.M. Law College, Puri",
  "Maa Basuli M.V Thakurmunda",
  "Kujang College,Kujang,Jagatsinghpur",
  "Santoosi Maa Regional College, Jharbelda",
  "Academy of Management Studies",
  "Raneswar Institute of Management & Information Technology, Angul",
  "P.N. College of Lib.& Information Science, Bhubaneswar",
  "S.S. Mahavidyalaya, Baliput, Puri",
  "Panchayat College +3, Godiput Matiapada, Puri",
  "SCB College of Nursing",
  "Parimal College, Pandua,Dhenkanal",
  "S.C. College",
  "Biruppa College,Indupur, Kendrapara",
  "Mahapat Mahavidyalaya, Janghira",
  "Ashutosh Maharaj College of Management and Technology",
  "MUNICIPAL COLLEGE ROURKELA",
  "Sri Jagannath College, Kaipadar, Khurda",
  "Anchalika M.V Purunabaripada",
  "Sudarshan Mahaviidyala,Baialish Mauza,Cuttack",
  "KISHORE CHANDRA DEGREE COLLEGE TARABHATTA",
  "Hi-Tech College of Pharmacy (HCP), Bhubaneswar",
  "ANCHALIK GRAM PANCHAYAT DEGREE COLLEGE GHANTAPADA BOUDH",
  "Bahugram Degree College, Bahugram, Cuttack",
  "Anchalika M.V. Hatadihi",
  "Panchayat College, Phiringia",
  "Women's College, Rayagada",
  "Cuttack College, Nayabazar, Cuttack",
  "NALANDA INSTITUTE OF PROFESSIONAL STUDIES",
  "BHUBANESWAR SCHOOL OF MANAGEMENT",
  "Bhubaneswar Engineering College, (BEC), Bhubaneswar, Khordha",
  "Government College of Engineering, Kalahandi",
  "Seemanta Institute of Pharmaceutical Sciences (SIPS), Jharpokharia, Mayurbhanj",
  "PRAVATI RATH WOMENS DEGREE COLLEGE BANGOMUNDA",
  "MODEL DEGREE COLLEGE, DEOGARH",
  "Banshidhar Mahavidyalaya, Itamati, Nayagarh",
  "Kalinga Mahavidyalaya, G. Udayagiri",
  "Sabitri Women's College, Bhanjanagar",
  "College of Nursing, Berhampur",
  "SKCG (Autonomous) College, Parlakhemundi",
  "Gajapati College of Nursing, Parlakhemudndi",
  "Begunia College,Begunia, Khurda",
  "P.P.Mahavidyalaya,Tigiria,Cuttack",
  "N.C. Autonomous College,Jajpur",
  "Sri Sri Balunkeswar +3 Mahavidyalaya, Baruan, Dhenkanal",
  "Laxminarayan College, Jharsuguda",
  "Dr. A.C. Homeopathic Medical College & Hospital, Kharvel Nagar, Bhubaneswar.",
  "R.N.B.Mahavidyalaya,Khuntuni,Cuttack",
  "GAYATRI INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "B.S.College,Nuahat,Jajpur",
  "MAHIMA JYOTI SCIENCE DEGREE COLLEGE",
  "REGIONAL DEGREE COLLEGE",
  "Narashingapur College, Narashingapur,Cuttack",
  "T.T.Mahavidyalaya, Ghatagaon",
  "GAYATRI COLLEGE OF NURSING",
  "+3 Womens College Bhogarai",
  "Dhauli College of Art and Crafts",
  "BHUBANESWAR INSTITUTE OF MANAGEMENT ",
  "VENKATESWARA INSTITUTE OF PLANNING AND MENAGEMENT",
  "Silpanchal Mahila Mahavidyalaya, Hattota,Talcher,Angul (W)",
  "Anchalik Mahavidyalaya,Kusang",
  "Dr.J.K.S.College",
  "Jaloe Degree College,Jaloe",
  "A.S.Degree College,Subdega",
  "Maa Metakani Womens College, Ullunda",
  "Yuvodaya College of Advanced Technology",
  "KORAPUT COLLEGE OF NURSING",
  "SWARNALATA MANAGEMENT AND INFORMATION TECHNOLOGY",
  "Balanga College, Balanga, Puri",
  "GAYATRI  PLUS THREE SCIENCE COLLEGE BHAWANIPATNA",
  "GAYATRI PLUS THREE SCIENCE COLLEGE ROURKELA",
  "SHREYA INSTITUTE OF INFORMATION TECHNOLOGY",
  "PATITAPABAN COLLEGE OF NURSING",
  "Centurion Institute of Technology",
  "Srinibas College",
  "BIDWAN RESIDENTIAL DEGREE COLLEGE",
  "ODISHA COLLEGE OF NURSING,CUTTACK",
  "SIDDHI BINAYAK DEGREE COLLEGE PATNAGARH",
  "BANAVASI SADHUCHARAN SANSKRIT MAHAVIDYALAYA",
  "ASSTHA COLLEGE OF IT AND MANAGEMENT BHUBANESWAR",
  "Gopal Krishna College of Engineering and Technology (GKCET), Jeypore",
  "SUNDARGARH NURSING COLLEGE,BHEDABAHAL",
  "Saheed Rendo Majhi Medical College and Hospital, Bhawanipatna,Kalahandi",
  "Gokul Parvati Rural College, Kuntara",
  "PRIYANKADEVI COLLEGE OF NURSING    ",
  "Imperial College",
  "GANGADHAR SAHU SCIENCE DEGREE COLLEGE ",
  "P.S. College, Suliapada",
  "Sarbamangala Degree College",
  "NEELACHAL INSTITUTE OF MEDICAL SCIENCES, BHUBANESWAR",
  "Banabhumi College, Rangamatia",
  "U.G.S. Mahavidyalaya, Sakhigopal",
  "Khunta Degree Mahavidyalaya, Khunta",
  "GAYATRI PLUS THREE SCIENCE COLLEGE BHUBANESWAR",
  "B.B College, Baiganbadia",
  "Rourkela Institute of Management Studies (RIMS), Rourkela",
  "Meghasan College, Nudadiha",
  "Dharanidhar (Auto) College, Keonjhar",
  "Charigarh M.V. Telkoi",
  "Bhubaneswar Institute of Management and Information Technology (BIMIT), Bhubaneswar",
  "College of Engineering (CEB), Bhubaneswar",
  "Indian Institute of Science and Information Technology (IISIT), Bhubaneswar",
  "SaralaMahavidyalaya,Rahama, Jagatsinghpur",
  "UNITY INSTITUTE OF PARAMEDICAL SCIENCE AND RESEARCH",
  "Govt. Autonomus College, Angul,",
  "SRI BALDEVJEW COLLEGE OF NURSING",
  "M.Rampur College",
  "S.G.College,Kanikapada Jajpur",
  "Jewels International (Chetana College of Special Edn.) A/3, Institutional Area, BBSR",
  "Jagannath M.V. Nayagarh, Batto",
  "Rairangpur  College, Rairangpur",
  "Barpali College,Barpali",
  "Bhubaneswar College (Degree) of Computer Science & Technology, Chandaka, Bhubaneswar",
  "Kharasrota Mohavidyalaya, Singhpur,Jajpur",
  "SAMRAT COLLEGE",
  "MAA SAMALAI NURSING COLLEGE, PADHANPADA",
  "K.M Women's College,Keonjhar",
  "SAMET SCHOOL OF MANAGEMENT",
  "SHRI JAGANNATH SANSKRIT COLLEGE, PATIMUNDA ANANTAPUR",
  "Nabaghana College",
  "OPS Mahavidyalaya, Hindol Road,Dhenkanal",
  "Barapora Mohavidyalaya Barapara, Pattamundai, Kendrapara",
  "A.P College, Raruan",
  "L.R.Law College",
  "Kamakshyanagar College,Kamakshyanagar,Dhenkanal",
  "Vyasa Nagar College,Jajpur Road, Jajpur",
  "ODISHA INSTITUTE OF MANAGEMENT STUDIES",
  "B.B Mahavidyalaya, Harichandanpur",
  "Anandapur College, Anandapur",
  "Gandhi Institute For Technology (GIFT), Khurda, Bhubaneswar",
  "INSTITUTE OF PHARMACEUTICAL SCIENCES JALESWAR BALASORE",
  "GANESH INSTITUTE OF MANAGEMENT STUDIES",
  "Sri Baneswar Degree College, Bentapur, Khurda",
  "KALINGA INSTITUTE OF PHARMACEUTICAL SCIENCES BALASORE",
  "BIJU PATTNAIK B SC NURSING COLLEGE",
  "RAGHUNATH JEW NILAMANI SANSKRIT COLLEGE ",
  "PRADIPTA RAY SANSKRIT MAHAVIDYALAYA",
  "Rajiv Memorial Institute of Technology, Berhampur",
  "SAMET INSTITUTE OF HOTEL MANAGEMENT AND TOURISM",
  "DAYANIDHI SANSKRIT MAHAVIDYALAYA",
  "BRILLIANT B SC NURSING COLLEGE",
  "VIGYAN INTERNATIONAL DEGREE COLLEGE",
  "BLUE WHEEL INSTITUTE OF PARAMEDICAL SCIENCES, BBSR",
  "DISHA COLLEGE OF MANAGEMENT AND TECHNOLOGY",
  "ST JOHN COLLEGE OF NURSING AND PARAMEDICAL    ",
  "SMART GURUKUL DEGREE COLLEGE    ",
  "BASUDEV SANSKRIT MOHAVIDYALAYA",
  "Hi-Tech College of Physiotherapy, Pandara, Bhubaneswar",
  "PRACHI MAHAVIDYALAYA FOR SPECIAL EDUCATION",
  "Jadupati +3 Degree College",
  "U.B.S College, Chaksuliapada",
  "SHYAMA SUNDAR SANSKRIT MAHAVIDYALAYA,KHARIAGUDA",
  "Panchayat Degree College, Kalla",
  "Anchalik Mahavidyalaya, Banasingh,Dhenkanal",
  "Shastriji womans degree college",
  "Ganjam Law College, Berhampur",
  "BANCHHAKALPA SANSKRIT MAHAVIDYALAYA",
  "Nigamananda Mahila Degree Mahavidyalaya",
  "Kuchinda College,Kuchinda",
  "MINAKETAN MEMORIAL SANSKRIT MOHAVIDYALAYA",
  "Aul College Aul, Kendrapara",
  "Kondhamal Degree College, Sarangada",
  "PRAGATI DEGREE COLLEGE",
  "Thakur Nigamananda Mohavidyalaya,Niigama Vihar, Babar, Kendrapara",
  "N.K. Choudhury College of teacher's Education, Angul",
  "Paramananda College, Balagarh, Khurda",
  "Luipa Mahaavidyalaya, Radho",
  "NYSASDRI School of Journalism and Social Work",
  "Choudhar College, Choudwar, Cuttack",
  "J.K.B.K.College, OMP Square, Cuttack",
  "Kaptipada College, Kaptipada",
  "Govt.Balangir College (Even.)",
  "JAGABANDHU DASH DEGREE WOMENS COLLEGE,KADALIPALI",
  "NITYANANDA COLLEGE OF PHARMACY",
  "Nalanda Institute of Technology (NIT), Bhubaneswar",
  "GANDHI GLOBAL BUSINESS STUDIES",
  "Hi-Tech. Medical College & Hospital, Pandra, Rasulgarh, Bhubaneswar",
  "SAI COLLEGE OF HOTEL MANAGEMENT",
  "KALAHANDI GNM COLLEGE, BHAWANIPATNA",
  "K.B.V. Mahavidyalaya, Kabisuryanagar",
  "Prasannamani College of Physical Education & Yoga, Tigiria, Cuttak",
  "ASIAN SCHOOL OF MANAGEMENT",
  "Sudhananda Engineerng and Research Centre (SERC), Bhubaneswar",
  "Capital Academy of Nursing",
  "Vikash Institute of Technology",
  "SRI SRI RAMESWAR SANSKRIT COLLEGE",
  "Academy of Management and Information Technology, (AMIT), Khurda",
  "U.G,C.T.E. College, Baripada",
  "Vignan Institute of Technology and Management (VITAM), Brahmapur",
  "Jagannath Institute for Technology and Management (JITM), Paralakhemundi",
  "School of Engineering & Technology (JITM), Paralakhemundi",
  "Dharamasala Mohavidyalaya, Dharamsala,Jajpur",
  "B.C.College,Reddhua,Jagatsinghpur",
  "NIIS Institute of Inf. Sc. & Management, Sarada Vihar, Madanpur, Bhubaneswar",
  "Kalinga College of Commerce,  Samantarapur, BBSR",
  "College of Library and Information Science, SMIT, Ankushpur",
  "Parajanga Mohavidyalaya,Parajanga,Dhenkanal",
  "Govt. Women's college,Keonjhar",
  "S.S.B.College,Mahakalpara, Kendrapara",
  "Janata College,Satmaile,Dhenkanal",
  "AGANIMANI SANSKRIT COLLEGE",
  "INSTITUTE OF MEDICAL SCIENCE AND RESEARCH",
  "AGROPOLYTECHNIC CENTRE FISHERY SCIENCE OUAT RANGEILUNDA BERHAMPUR",
  "M.G. College, Baisinga",
  "GOVERNMENT DEGREE COLLEGE CHANDRAPUR RAYAGADA",
  "GOVERNMENT DEGREE COLLEGE KASHIPUR, RAYAGADA    ",
  "GOVERNMENT DEGREE COLLEGE RAMANAGUDA    ",
  "PANDIT NILAKANTHA UTKAL ACADEMY DEGREE COLLEGE CHATRAPUR",
  "Kandakhai College of Sc. & Arts, Kandakhai, Bajarkote, Puri",
  "H.N.S.College,Chandol, Kendrapara",
  "BHAKTA MANEIN SMRUTI DEGREE MAHAVIDYALAYA    ",
  "SCIENCE DEGREE COLLEGE KUKUDAKHANDI GANJAM",
  "Saraswati Institute of IT and Management, Bhawanipatna",
  "ADARSHA INSTITUTE OF BSC NURSING AND PHARMACEUTICAL SCIENCE",
  "SRADHA INSTITUTION OF HEALTH SCIENCE",
  "SANJAY MEMORIAL INSTITUTE OF TECHNOLOGY , SMIT",
  "GOVERNMENT DEGREE COLLEGE,RAIGHAR,NABARANGPUR    ",
  "H.D.V. Science College, Panaspada, Puri",
  "INDIAN INSTITUTE OF MANAGEMENT AND SCIENCE",
  "Baisimauza College,Puran,Anakhia,Jagatsinghpur",
  "A.D. Mahavidyalaya, Brahmagiri",
  "College of Business  Administration, Berhampur",
  "Panchayat Degree College",
  "Kanpur Anchalik Mahavidyalaya,Kanpur,Cuttack",
  "Sarankul College, Sarankul, Nayagarh",
  "Mahima Mahavidyalaya,Joranda,Dhenkanal",
  "SWAMI VIVEKANANDA INSTITUTE OF HOTEL MANAGEMENT AND TOURISM",
  "P.K.College,Baitarani Road,Jajpur",
  "Raajdhani Engineering College (REC), Bhubaneswar",
  "Einstein Academy of Technology and Management (EATM), Bhubaneswar",
  "BIET DEGREE COLLEGE",
  "JSM COMMERCE DEGREE COLLEGE",
  "Neelashaila Mahavidyalaya,Rourkela",
  "Nilakantheswar Mahavidyalaya,South Balanda, Angul",
  "RAMARANI MEDICAL ACADEMY",
  "MAA MAJHIGHARIANI INSTITUTE OF NURSING  RAYAGADA",
  "KAIRALI INSTITUTE OF PHARMACY",
  "SUNNAYANA COLLEGE OF MEDICAL SCIENCE    ",
  "GANDHI INSTITUTE OF NURSING AND SCIENCES    ",
  "DIBYA COLLEGE OF NURSING, BHUBANESWAR    ",
  "Kasinath Mohavidyalaya, Kaipada,Jajpur",
  "SHANTI INSTITUTE OF MEDICAL SCIENCE AND TECHNOLOGY BSC N    ",
  "Betnoti College, Betnoti",
  "PRAGATI INSTITUTE OF MEDICAL EDUCATION, BHAWANIPATNA, KALAHANDI    ",
  "ARJUNA DEGREE COLLEGE, KADALIGARH    ",
  "IMT Pharmacy College, Puri",
  "JAJATI KESHARI MEDICAL COLLEGE AND HOSPITAL,  JAJPUR     ",
  "SHREE RAM COLLEGE OF NURSING    ",
  "P.S College, Jhumpura",
  "Sivananda Yoga Vedanta Academy",
  "Joda Women's College,joda",
  "Regional Degree Cwollege, Udayapur",
  "The Law College, Cuttack",
  "BINKA WOMENS DEGREE COLLEGE BINKA",
  "NATIONAL INSTITUTE OF PROFESSIONAL STUDIES",
  "NARAYANI COLLEGE OF NURSING    ",
  "SIBARAM PRASAD COLLEGE OF MEDICAL SCIENCE    ",
  "VINAYAK COLLEGE OF NURSING    ",
  "DIVINE DEGREE COLLEGE    ",
  "Global Institute of Management (GIM), Bhubaneswar",
  "APRIZE COLLEGE OF MEDICAL SCIENCE, SAMBALPUR",
  "Gopabandhu Anchalika Mahavidyalaya, Kalimela",
  "M.G.M. College of Edn. & Tech., Kousalyagang, Puri",
  "Ananta Sanskrit College",
  "ARATIDAITARI SANSKRIT MAHAVIDYALAYA",
  "BERHAMPUR SCHOOL OF NURSING",
  "Chintamani Sanskrit College",
  "Bijayachand Sanskrit College",
  "GIMSAR SCHOOL COLLEGE OF NURSING, ATHAGARH",
  "SUDHA KIRAN DEGREE COLLEGE",
  "Model Degree College Sonepur",
  "MODEL DEGREE COLLEGE BOUDH",
  "model degree college",
  "Lalaji Gopalji Sanskrit College",
  "BALARAM INSTITUTE OF MEDICAL SCIENCES    ",
  "SWARNALATA COLLEGE OF MEDICAL SCIENCE MAYURBHANJ    ",
  "BAIKUNTHA NATH INSTITUTE OF HIGHER STUDIES, KACHUADI    ",
  "GOVERNMENT DEGREE COLLEGE THUAMUL RAMPUR    ",
  "UTKAL INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "+3 Degree Women's College, Kamakshyanagar, Dhenkanal",
  "Panchayat College,Dharamgarh",
  "Ramachandi Sanskrit College",
  "KSUB COLLEGE ",
  "Centre for Distance and Online Education,Utkal University",
  "GOVERNMENT SANSKRIT COLLEGE, BARIPADA",
  "Bhagaban Chandra Sanskrit College",
  "Shyama Sundar Sanskrit College",
  "SUPREME TASK COLLEGE OF NURSING",
  "Jamda Anchalika M.V, Jamda",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, BHUBANESWAR",
  "Gurukula Sanskrit College",
  "Madhusudan Sanskrit College",
  "Sukadei Sanskrit College",
  "Gurukul Sanskrit College",
  "Dadhibaman Sanskrit College",
  "Panchayat Degree College",
  "G.P.College,Lachhipur",
  "Baruneswar Mohavidyalaya,Arei,Jajpur",
  "JAIPRAKASH HOSPITAL AND RESEARCH CENTRE PVT LTD",
  "NEWTONIAN BASIC SCIENCE COLLEGE",
  "SHAILABALA WOMEN'S AUTONOMOUS COLLEGE",
  "Salabani G.P College, Salabani",
  "GURUKRUPA DEGREE COLLEGE RAIGHAR",
  "BHARAT INSTITUTE OF TECHNICAL STUDIES",
  "A.S.College,Balia, Jajpur",
  "Siddhartha Degree College",
  "Sri Rama Chandra Sanskrit College",
  "Modern Engineering and Management Studies (MEMS), Balasore",
  "A.P.S.College,Roth",
  "Gandhi Institute of Technology And Management (GITAM), Bhubaneswar",
  "ANCHALIK DEGREE MAHAVIDYALAYA SINDHOL",
  "Pendrani Mahavidyalaya, Umerkote",
  "KSUB College of Teacher Education, Bhanjanagar",
  "FUTURE BRIGHT COLLEGE OF NURSING",
  "Netaji Subhas Bose Degree College, Tumudibandha ",
  "MAHAMAYA SCHOOL OF BUSINESS MANAGEMENT",
  "Vedang Institute of Technology (VIT), Khurda, Bhubaneswar",
  "DEVAGIRI DEGREE COLLEGE",
  "INDIAN INSTITUTE FOR PRODUCTION MANAGEMENT",
  "Dayavihar Degree College, Gadasahi, Kanas",
  "GHADAI B SC NURSING COLLEGE MALKANGIRI",
  "Government Women's College, Jeypore",
  "SHREE SAI DEGREE COLLEGE KURUMPURI",
  "MAHAMAYA INSTITUTE OF LEGAL SCIENCE, NUAPADA",
  "MADANMOHAN SANSKRIT MAHAVIDYALAYA",
  "GURUKRUPA COLLEGE OF NURSING",
  "KRISHNA INSTITUTE OF MANAGEMENT AND SCIENCE, KIMS",
  "Reamal College",
  "SRI SAI SIDDHI +3 DEGREE SCIENCE RESIDENTIAL COLLEGE",
  "Biramaharajpur College",
  "SAI SADHANA COLLEGE OF BASIC SCIENCE",
  "SAI DEGREE COLLEGE, BARIPADA",
  "VIKASH NURSING COLLEGE",
  "R.K. Behera (+3) College",
  "JHADESWAR ENGINEERING COLLEGE",
  "ROYAL ACADEMY",
  "PANCHAYAT DEGREE COLLEGE, GHUNSAR",
  "SRIRAM PLUS THREE SCIENCE RESIDENTIAL COLLEGE",
  "Srusti Academy of Management (SAM), Bhubaneswar",
  "KALPATARU SANSKRIT MAHAVIDYALAYA",
  "Madhusudan Institute of Cooperative Management (MICM), Bhubaneswar",
  "Anchalika M.V. Swampatana",
  "Gurukula Institute of Technology (GIT), Bhubaneswar",
  "Ajay Binay Institute of Technology Piloo Modi College of Architecture (ABIT-PMCA), Cuttack",
  "Jawaharlal College,Patnagarh",
  "Ganjam College, Ganjam",
  "SARASWAT COLLEGE OF NURSING",
  "GOVERMENT  DEGREE COLLEGE, TIRING",
  "PRATIVA INSTITUTE OF MANAGEMENT AND TECHNOLOGY    ",
  "ODISHA PACHHUA ANCHALA DEGREE COLLEGE",
  "Marshaghai College,Marshaghai, Kendrapara",
  "Vijayanjali Institute of Technology (VIT), Balasore",
  "PRABHUPADA INSTITUTE OF NURSING SCIENCES",
  "University Law College",
  "INDOTECH College of Engineering (ICE), Khurda, Bhubaneswar",
  "SAI MEDICA GROUP, KENDRAPARA",
  "Eastern Academy of Science and Technology (EAST), Phulnakhara",
  "Bharati Vihar Degree Mohavidyalaya",
  "MODERN DEGREE COLLEGE",
  "Silicon Institute of Technology (SIT), Sambalpur",
  "Gandhi Institute of Advanced Computer and Research (GIACR), Rayagada (Formerly  IACR, Rayagada)",
  "College of Pharmaceutical Sciences (CPS), Mohuda, Berhampur",
  "BHARATI COLLEGE OF NURSING",
  "Parala Maharaja Engineering College, Berhampur",
  "College of Pharmaceutical Sciences (CPS), Puri",
  "GOVERNMENT MEDICAL COLLEGE, KEONJHAR",
  "Gandhi Academy of Technology and Engineering (GATE), Berhampur",
  "MARY ELIZA SCHOOL AND COLLEGE OF NURSING",
  "BALABATI DEVI SCHOOL OF NURSING    ",
  "P.S.Santak Mahavidyalaya,Barkote",
  "SMIT, PG Centre for Management Studies, Brahmapur",
  "Prananath College(Autonomous), Khordha",
  "KALINGA BHARATI SANSKRIT DEGREE COLLEGE",
  "Surajmal College,Rengali",
  "BHUBANESWAR COLLEGE OF PHARMACY    ",
  "Gandhi Institute of Science and Technology (GIST), Rayagada",
  "Roland Institute of Computer and Management Studies, Berhampur",
  "CRSR COLLEGE OF SPECIAL EDUCATION",
  "Synergy Institute of Engineering and Technology (SIET), Dhenkanal",
  "Balunkeswar Dev Anchalik Degree College, Tikiripada",
  "Adarsha College of Engineering, (ACE), Angul",
  "Dibya College of Nursing",
  "Gayatri Institute of Science and Technology (GIST), Gunupur",
  "DAYANAND ACADEMY OF ART CULTURE  AND YOGA",
  "Indus College of Engineering (ICE), Bhubaneswar",
  "Krupajal Engineering College (KEC), Bhubaneswar",
  "DIBYA COLLEGE OF PHYSIOTHERAPY BHUBANESWAR",
  "FUTURE TIME B SC NURSING COLLEGE ",
  "INDIAN VASTU ACADEMY",
  "Premere Institute of Hotel Management, Catering Technology and Tourism",
  "GYANADEVI DEGREE COLLEGE, KUANARPUR RENCH PURI",
  "EMINENCE ACADEMY",
  "PEARL ACADEMY",
  "COLLEGE FOR HOTEL AND TOURISM MANAGEMENT",
  "M.P.C (Auto) College, Baripada",
  "ASPIRING LEADERS ACADEMY",
  "JANAKALYAN INSTITUTE OF NURSING AND HEALTH SCIENCE",
  "THE NEWTON COLLEGE OF MANAGMENT, SUNDURI",
  "S.M.P.College",
  "GANESH COLLEGE OF EDUCATION",
  "Maharshi Plus Three Science Residential College",
  "CRYOGENEX INSTITUTE OF MEDICAL SCIENCE AND RESEARCH",
  "Institute of Mathematics & Application, Andharua, Bhubaneswar",
  "Pandit Raghunath Murmu Medical College and Hospital",
  "RAGHUNATH SANSKRIT MAHAVIDYALAYA",
  "GOVT COLLEGE OF NURSING DISTRICT HEAD QUARTER HOSPITAL NABARANGPUR ",
  "Institute of Health Sciences, N-2/41, IRC Village, Nayapalli, Bhubaneswar",
  "Gopabandhu Ay. Mahavidyalaya, Puri",
  "BADAMESWARI SANSKRIT MOHAVIDYALAYA",
  "BIRENDRA KUMAR COLLEGE DEGREE COLLEGE ",
  "S.C.B. Degree College, Ragdha",
  "Anchalika Mahavidyalaya, Padmapur",
  "Biju Patnaik College, Kundra",
  "GOVT. COLLEGE OF NURSING, KALAHANDI",
  "Anchalika M.V, Gadia",
  "Panchpirh +3 Degree College, Karanjia",
  "Patteswar Degee College, Suakati",
  "Mahila Mahavidyalaya, Rairangpur",
  "Udala College, Udala",
  "Baripada College, Baaripada",
  "Pallishree College",
  "I.G Mahila M.V, Udala",
  "Kusaleswar A.MV, Rekutia",
  "INSTITUTE OF PROFESSIONAL STUDIES",
  "Laxmi Narayan Degree College, Pipilia",
  "S.M.D College, Manida",
  "L.K College, Bangriposi",
  "R.D.S Mahavidyalaya, Kundabai",
  "Raghunath M.V, Kadadiha",
  "Jashipur College, Jashipur",
  "Patita Paban M.V. Sainkul",
  "Brahma Bbarada Degree College, Brahmabarada,Jajpur",
  "SAI ADARSHA DEGREE COLLEGE",
  "Kaptipada Degree College, Nuasahi",
  "V.H.J.Mohavidyalaya, Nikirai,Kendrapara",
  "FRANKLIN INSTITUTE OF MEDICAL SCIENCE",
  "L.N.Sahu Mahavidyalaya,,Jagatpur,Cuttack",
  "K.P.A.N.College, Bankoi,Khurda",
  "Radhanath Institute of Advanced Studies, Cuttack",
  "Raghunath College, Deuli, Khurda",
  "Ratanpur Science Degree College, Udayapur, Astarang",
  "Bantala College of Higher Education,Bantal,Angul",
  "Durga Charan Chilika College,Tangi, Khurda",
  "Sahid Raghu Dibakar College, Gadapanikilo, Nayagarh",
  "MAYURBHANJ COLLEGE OF NURSING ASA TRUST TAKATPUR",
  "BHAGABATI COLLEGE OF NURSING JAJPUR",
  "GAYATRI INSTITUTE OF COMPUTER AND MANAGEMENT HINJILICUT",
  "BHUBANESWAR COLLEGE OF NURSING",
  "BHANJA COLLEGE OF NURSING",
  "IMPERIAL COLLEGE",
  "SGI SCHOOL OF ARCHITECTURE",
  "NORTH ODISHA DEGREE COLLEGE OF SCIENCE",
  "BRAJAKISHORE SANSKRIT COLLEGE",
  "DR BR AMBEDKAR NATIONAL DEGREE COLLEGE RAMAGIRI GAJAPATI",
  "P C COLLEGE OF NURSING",
  "SUBHAM COLLEGE OF NURSING, BHADRAK",
  "VIKASH NURSING COLLEGE, SAMBALPUR",
  "COLLEGE OF NURSING, CHRISTIAN MEDICAL SOCIETY, NABARANGPUR    ",
  "IGKC COLLEGE OF NURSING    ",
  "KRISHNA VIKASH COLLEGE OF NURSING AND ALLIED HEALTH SCIENCES    ",
  "RADHA KRISHNA DEGREE COLLEGE PADWA KORAPUT",
  "XAVIER COLLEGE OF NURSING KHORDHA",
  "PRESIDENCY COLLEGE",
  "SWAMI CHIDANANDA INSTITUTE OF SOCIAL SCIENCES",
  "JAY GANESH INSTITUTE OF BUSINESS MANAGEMENT",
  "CENTURION UNIVERSITY OF TECHNOLOGY AND MANAGEMENT ",
  "Karilopatna College, Karilopatna,Kendrapara",
  "CENTRE FOR STUDIES IN YOGA AYURVEDA AND NATUROPATHY",
  "Spintronic Technology and Advanced Research (STAR), Taraboi, Bhubaneswar",
  "B.K. College of Art and Crafts",
  "Kalahandi Training College",
  "WOMEN'S ENGINEERING COLLEGE LAWSPET",
  "SCHOOL OF ALLIED HEALTH SCIENCES, VMRFDU, PUDUCHERRY",
  "MAHATMA GANDHI MEDICAL COLLEGE AND RESEARCH INSTITUTE",
  "Chirst Institute of Technology",
  "VIVEKANANDHA NURSING COLLEGE ",
  "Sri Venkateshwaraa Medical College Hospital and Research Centre",
  "PANDIT JAWAHARLAL NEHRU COLLEGE OF AGRICULTURE AND  RESEARCH INSTITUTE, KARAIKAL",
  "Senthil College of Education",
  "Indira Gandhi College of Arts   and Science",
  "A G PADMAVATHI COLLEGE OF NURSING ",
  "Pope John Paul II College of  Education",
  "INDIRA GANDHI INSTITUTE OF DENTAL SCIENCES",
  "SCHOOL OF ALLIED HEALTH SCIENCES, VMRFDU",
  "Rajiv Gandhi Ayurveda Medical College",
  "KASTURBA GANDHI NURSING COLLEGE",
  "Usha Latchumanan College of Education",
  "Dr. S.R.K. Govt. Arts College",
  "Mother Theresa Post Graduate and Research Institute of Health Sciences",
  "Dr. Kalaikannan College of Education for Women",
  "Sabari College of Nursing",
  "SHANMUGA COLLEGE OF PHYSIOTHERAPY KARAIKAL",
  "Sree Narayana College of Education",
  "SCHOOL OF REHABILITATION AND BEHAVIORAL SCIENCES PUDUCHERRY",
  "SCHOOL OF PHYSIOTHERAPY PUDUCHERRY",
  "Perunthalaivar Kamarajar Arts College",
  "Sri Manakula Vinayagar Medical College  and Hospital",
  "Nehru College of Education",
  "Indira Gandhi Medical College & Research Institute",
  "Saradha Gangadharan College",
  "Vector Control Research Centre (I.C.M.R.)",
  "ECOLE FRANCAISE D EXTREME ORIENT, CENTRE DE PONDICHERY",
  "SRI LAKSHMI NARAYANA INSTITUTE OF MEDICAL SCIENCES    ",
  "Achariya College of Education",
  "Don Bosco College of Education and Research Institute",
  "SRI VENKATESHWARAA DENTAL COLLEGE",
  "Arignar Anna Govt. Arts College",
  "SHRI KRISHNAA COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Shri Venkateshwara College of Pharmacy",
  "Sri Ganesh College of Engineering & Technology",
  "Tagore Government Arts and Science College",
  "Venkateswara College of Education",
  "PSV COLLEGE OF ARTS AND SCIENCE ",
  "JESUS CHRIST ARTS AND SCIENCE COLLEGE",
  "CHRIST ARTS AND SCIENCE COLLEGE ",
  "Aarupadai Veedu Medical College and Hospital",
  "Sri Manakula Vinayagar Engineering College",
  "Rajiv Gandhi College of Engineering and Technology",
  "CHRIST COLLEGE OF NURSING ",
  "Perunthalaivar Kamarajar College of Education",
  "Rathnavel Subramaniam College of Arts and Science",
  "RAAK COLLEGE OF PHARMACY",
  "TVR COLLEGE OF EDUCATION",
  "Mahatma Gandhi Govt. Arts College Chalakkara Post",
  "Pondicherry University Campus  I",
  "Achariya Arts and Science College",
  "Sri Manakula Vinayagar Nursing College",
  "Bharathiar Palkalaikoodam",
  "RVS College of Engineering and Technology",
  "Sri Venkateshwaraa College of Para Medical Sciences",
  "French Institute of Pondicherry",
  "Pondicherry Institute of Medical Sciences",
  "Mahe Co-operative College of Higher Education & Technology",
  "Sri Venkateswara College of Education",
  "RAAK COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Indirani College of Nursing",
  "Dr. B.R. Ambedkar Government Law College",
  "Vivekanandha College of Education",
  "Mahe Co-operative College of Teacher Education",
  "Mahatma Gandhi P.G. Institute of Dental Sciences",
  "Raak Nursing and  Paramedical College",
  "Avvaiyar College of Engineering and Technology for Women",
  "Arutperunchothi Ramalingasammy College of Education",
  "PONNAIYAH RAMAJAYAM INSTITUTE OF SCIENCE AND TECHNOLOGY, PUDUCHERRY-605 007",
  "College of Nursing, Pondicherry Institute of Medical Sciences",
  "Co-operative College of Education",
  "Regency Institute of Technology",
  "College of Nursing, East Coast Institute of Medical Sciences",
  "Perunthalaivar Kamarajar Institute of Engineering and Technology",
  "Avvaiyar Govt. College for Women",
  "Pondicherry University Community College",
  "Idhaya College of Arts and Science for Women",
  "ManakulaVinayagar Institute of Technology",
  "Bharathiyar College of Engineering and Technology",
  "COLLEGE OF HEALTH SCIENCES,PONDICHERRY INSTITUTE OF MEDICAL SCIENCES",
  "ALPHA COLLEGE OF ARTS AND SCIENCE",
  "Vinayaka Mission's College of Nursing",
  "VIJAY ARTS AND SCIENCE COLLEGE    ",
  "Kanchi Mamunivar Government Institute for Postgraduate  Studies and Research",
  "Rajiv Gandhi College of Veterinary  &  Animal Sciences",
  "Bharathidasan Govt. College for Women",
  "Rajiv Gandhi Arts & Science College",
  "Vasavi College of Education",
  "Vinayaka Mission's Medical College and Hospital",
  "Immaculate College of Education for Women",
  "R.V.S Institute of Management Studies and Computer Application",
  "ADITYA INSTITUTE OF MANAGEMENT, SCIENCE AND RESEARCH",
  "Amarnath College of Education",
  "Kasthurba College for Women",
  "Mahe Institute of Dental Sciences & Hospital",
  "Achariya College of Engineering Technology",
  "SRI VENKATESHWARAA COLLEGE OF ENGINEERING  AND TECHNOLOGY",
  "COLLEGE OF ALLIED HEALTH SCIENCES, EAST COAST INSTITUTE OF MEDICAL SCIENCES",
  "Vinayaka Mission's College of Nursing",
  "RVS College of Education",
  "MOTHER THERESA POST GRADUATE AND RESEARCH INSTITUTE OF HEALTH SCIENCES, KARAIKAL BRANCH",
  "Alpha College of Engineering & Technology",
  "Christ College of Engineering and Technology",
  "DON BOSCO COLLEGE, ARTS AND SCIENCE",
  "Krishnasamy College of Education for Women",
  "Global College of Pharmacy, Anandpur Sahib",
  "Shivam College of Education, Khokarkalan, Lehragagga",
  "B. C. M. College of Education, Sector-32 A Urban Estate",
  "Guru Nanak Prem Karamsar College Nadala (Kapurthala)",
  "Swami Sarvanand Institute of Engg. & Technology, Dinanagar",
  "Govt College for Girls",
  "Govt. Dental College, Amritsar",
  "Rayat Bahra College of  Nursing, Village  Sohauran, Tehsil Kharar,  Distt. Mohali",
  "Mata Sahib Kaur Girls College, Village Gaihal, Barnala",
  "Bhai Gurdas Degree College",
  "Khalsa Institute of Management and Technology for Women",
  "Bhai Gurdas College of Law, Sangrur",
  "Government Bikram College of Commerce, Patiala",
  "Mata Ganga Girls College Tarn Taran",
  "Indo Global College of Engg. Abhipur",
  "Guru Nanak College, Killianwali",
  "Gurdasidevi Institute of Management & Technology, Budhlada",
  "GURU NANAK DEV UNIVERSITY COLLEGE,PATTI",
  "Guru Nanak Khalsa College for Women, Model Town",
  "Hakim Kishori Lal  College of Nursing,  Guruharsahai, Distt.  Ferozepur",
  "Life Guard Nursing  Institute, Village  Bhindran, Kaloudi Road,  Sangrur",
  "SS College of Education, Dinanagar.",
  "Punjab Institute of Technology",
  "Tagore College of Education For Women, Gurdaspur",
  "INDO GLOBAL COLLEGE OF PHARMACY",
  "Ludhiana College of Engg. and Technology, Ludhiana",
  "Arya Bhatta College, Barnala",
  "Akal College of Education, Mastuana Sahib, Sangrur",
  "Baba Farid College of Education, V&P.O. Deon, Muktsar Road, Bathinda",
  "Kabli Mal Ramji Dass Jain College for Women, Malerkotla",
  "Malwa College of Education, Deon, Bathinda",
  "Desh Bhagat College of Education, Bardwal Dhuri,",
  "University College, Nihal Singh Wala, Moga",
  "S. Balraj Singh Bhundarh Memorial university College Sadulgarh",
  "Public College of Education, Samana, Patiala",
  "Shaheed Lachhman Singh Dharowali University College, kalanaur (Gurdaspur)",
  "HARF COLLEGE MALERKOTLA",
  "Sanjeevani College of  Nursing, Village Daudpur, Khanna",
  "AKAL COLLEGE FOR WOMEN, KHAMANO",
  "Davindra Memorial  College of Nursing,  Khemkaran Road, Patti,  Distt. Tarn Taran-143416",
  "JUSS Institute of Nursing,  VPO Sekhwan, Distt.  Gurdaspur",
  "Baba Mehar Singh Memorial College of Education, Purana Shala, Gurdaspur.",
  "L.B.S. Arya Mahila College",
  "ST.SOLDIER COLLEGE (CO-EDUCATION)",
  "GNDEC SCHOOL OF ARCHITECTURE ",
  "Sant Baba Bhag Singh  Institute of Nursing,  Village Khiala, PO  Pandhiana, Distt.  Jalandhar",
  "Apeejay Institute of Management & Engineering Technical Campus, Jalandhar",
  "College of Nursing, Govt.  Rajindra Hospital, Patiala",
  "ASSM College, Mukandpur",
  "Kay Jay College of Education, Village Rasulpur, P.O. Chapper Seal Road, Patiala.",
  "MALWA COLLEGE OF EDUCATION for Girls Kotakpura",
  "Christian Medical College, Brown Road, Ludhiana",
  "College of Nursing, Sigma  Nursing Training Institute,  Dakhni Bye Pass, Gill  Road, Ludhiana",
  "SAHEED KASHI RAM COLLEGE OF PHYSICAL EDUCATION, BHAGOO MAJRA KHARAR",
  "Guru Nanak Govt College, Guru Teg Bahadurgarh",
  "Khalsa College of Physical Education,  VPO Heir, Dist Amritsar.",
  "Rayat Institute of Management, Railmajra",
  "National Dental College, VPO Gulabgarh, Tehsil Dera Bassi",
  "Colonel College of Education, Chural Kalan, Distt. Sangrur",
  "College of Nursing,  Christian Medical College,  Brown Road, Ludhiana",
  "CT Institute of Management and IT , Jalandhar",
  "Swami Vivekanand College of Education, Village Ram Nagar, Near Banur, Tehsil Rajpura, Distt. Patiala",
  "Baba Banda Singh Bahadur College of Education, Vill.  Mullianwal, Bidhipur Fatak, Dhariwal, Gurdaspur.",
  "Amar Professional College  of Nursing, VPO  Dayalpura,   Zirakpur-Patiala  Highway, Tehsil  Derabassi, Distt. Mohali",
  "Sri Sai College of Engg and Technology , Badhani",
  "G.G.S. Khalsa College, Sarhali (Distt. Tarn Taran)",
  "College of Nursing,  Dayanand Medical  College, Civil Lines,  Ludhiana",
  "Ambika College of  Nursing, VPO Badali,  Badala Road, District  Mohali",
  "APS College of Nursing,  VPO Malsian, Distt.  Jalandhar",
  "Saraswati Nursing  Institute, Kurali-Morinda  Road, Village Dhyanpura,  Distt. Ropar",
  "Gian Sagar Medical College & Hospital, Vill. Ram Nagar, Banur",
  "Mai Bhago College of  Nursing, Village Piddi,  Distt. Tarn Taran",
  "Swami Premanand  College of Nursing, G.T.  Road, Mukerian, Distt.  Hoshiarpur-144211",
  "Banarsi Dass Arya College, Jalandhar Cantt",
  "Patiala College of Education for girls, Village Hardaspur, Patiala",
  "College of Nursing, Govt.  Medical College, Majitha  Road, Amritsar",
  "GGS.DAV Centenary College, Jalalabad (W)",
  "DAV College for Girls,Garhshankar",
  "SHAHEED UDHAM SINGH GOVERNMENT COLLEGE, SUNAM",
  "FOOD CRAFT INSTITUTE",
  "G. G. N. Khalsa College",
  "Govt. College of Education Jalandhar",
  "Lilly Swords Mathodist College of Education, Kanuwan Road, Batala.",
  "G S FOUNDATION COLLEGE OF LAW",
  "GANGA COLLEGE OF PROFESSIONAL EDUCATION AND RESEARCH",
  "D.A.V College of Education for Women Amritsar",
  "Army College of Nursing, Deep Nagar,  Jalandhar Cantt",
  "SWAMI VIVEKANAD FACULITY OF INFORMATION TECHONOLOGY AND BUSINESS MANAGEMENT VILL RAM NAGAR JHANSLA BANUR",
  "GURU GOBIND SINGH COLLEGE TALWANDI SABO",
  "MOTHER INDIA COLLEGE OF EDUCATION",
  "Baba Mangal Singh Institute of Computer Science, Barnala Road, VPO Bughipura, Distt Moga",
  "Baba Moni ji Maharaj,  College of Nursing, Lehra  Mohabbat, Distt.  Bathinda",
  "Sri Guru Hargobind  College of Nursing,  Opposite Reliance Petrol  Pump, Raikot-141109",
  "Govt. Dental College, Sangrur Road, Patiala",
  "Punjab Public College of  Nursing, VPO. Katar  Singh Wala, Mansa Road,  Distt.Bathinda",
  "Guru Teg Bahadur College  of Nursing, Jandiala Guru,  Distt. Amritsar",
  "Sri Guru Ram Das Institute of Dental Sciences & Research, G.T. Road, Amritsar",
  "Shri Dandi Swami Dharmsangh Sanskrit Mahavidyalaya",
  "Baba Banda Bahadur  College of Nursing,  Faridkot",
  "Mata Gujri Institute of  Nursing, Village  Mehmadpur, P.O.   Adampur, Distt. Jalandhar",
  "Guru Gobind Singh  College of Nursing,  Talwandi Sabo,  Sardulgarh Road Distt.  Bathinda",
  "Gian Sagar College of  Nursing, Ram Nagar  (Banur) Distt. Patiala",
  "State Institute of Nursing & Paramedical Sciences, Badal",
  "Amandeep College of Nursing, Jethuwal",
  "Bibi Sharan Kaur Khalsa College, Sri Chamakaur Sahib",
  "The Enlightened College of Physical Education, Jhunir",
  "The Enlightened Degree College, Jhunir",
  "SBS Institute of Nursing,  Village Sohian Kalan,  Tehsil Majitha, Fatehgarh  Churian Road, Distt.  Amritsar",
  "Dasmesh College of  Nursing, Talwandi Road,  Faridkot",
  "SBS College of Nursing,  Village Sodewala,  Malanwala Road, Distt.  Ferozepur",
  "College of Nursing,  Mohan Dai Oswal Cancer  Treatment & Research  Foundation, G.T. Road,  Sherpur Bye Pass,  Ludhiana-141009",
  "Malwa College of  Nursing, Faridkot Road,  Kotkapura",
  "BBK DAV College for women Amritsar",
  "KRISHNA COLLEGE OF HIGHER EDUCATION VILL RALLI BUDHLADA",
  "LALA LAJPAT RAI INSTITUTE OF MANAGEMENT AND TECHNOLOGY    ",
  "GTB COLLEGE , BALLOH Dist Bathinda",
  "College of Animal Biotechnology",
  "College of Physiotherapy, Adesh Institute of Medical Sciences, Kotkapura Road, Muktsar",
  "Netaji Subhas Institute of Sports, Moti Bagh, Patiala",
  "International College of  Nursing, Ferozepur G.T.  Road, Village Piddi, Distt.  Tarn Taran",
  "SMD GIRLS COLLEGE OF EDUCATION ",
  "D.M.College, Moga",
  "Tapacharya Hem Kunwar Rasik Lal Dhariwal Jain Girls College, Raman, Bathinda",
  "Sandhu Institute of  Nursing, Mahalon,  Nawanshahr",
  "GURU TEG BAHADUR DEGREE COLLEGE",
  "GULZAR COLLEGE OF ENGINEERING",
  "Punjab State Aeronautical Engineering College, Patiala",
  "Bhag Singh Khalsa College  for Women, Kala Tibba",
  "Sri Satya Sai Ayuvedic College and Hospital Moga",
  "Shivalik Hills College of Education, Patti, P.O. Manakpur, Anandpur Sahib",
  "GHG INSTITUTE OF PHARMACY",
  "Shiv Shakti College of  Nursing, Bhikhi, Distt.  Mansa",
  "Bathinda College of Law, Bathinda",
  "JASDEV SINGH SANDHU DEGREE COLLEGE, RAJPURA ROAD , KAULI",
  "NATIONAL INSTITUTE OF HEALTH SCIENCES  ",
  "Jyoti B.Ed College  Abohar Road, Fazilka",
  "Mata Gurdev Kaur Memorial  Shahi  Sports College of Physical Education",
  "GURU GOBIND SINGH POLYTECHNIC COLLEGE, HOSHIARPUR",
  "Universe Professional College of Education, VPO Adampura",
  "University College, Barnala Sandhu patti Road",
  "University College, Benra Dhuri",
  "Ajit Nursing Institute,  Sunam, Distt. Sangrur",
  "Sadhbhavna College of Education For Women Raikot",
  "D.A.V.College of Education College Road, Fazilka",
  "National Degree College, Chowarianwali, Fazilka",
  "Khalsa College for Women, Civil Lines",
  "Baba Ajay Singh Khalsa College, Gurdas Nangal",
  "The Royal Group of Colleges, Borawal",
  "GEE BEE INSTITUTE OF NURSING AND HEALTH SCIENCES",
  "University Institute of Nursing, Jalalabad, Disst. Fazilka",
  "Christian Dental College, Brown Road, Ludhiana",
  "Bhai Sangat Singh College",
  "Bhai Gurdas General  Nursing College, Vpo.  Nandpur Kesho, Sirhind Road, Patiala",
  "Baba Sahib Dr. Bhim Rao Ambedkar Government College Roshanwala",
  "MODERN COLLEGE OF TECHNICAL EDUCATION, VPO KHURD",
  "Sant Majha Singh Karamjot College for Women, Miani",
  "Swami Vivekanand Faculty Of Technology and Management",
  "A.S.College of Education, Kalalmajra",
  "Nankana Sahib College of  Education",
  "Ramgarhia Girls College, Miller Ganj",
  "Veterinary Polytechnic Kaljharani",
  "Govt.  Arts & Sports College, Jalandhar",
  "MTSM College for Women, Ludhiana",
  "University College, Guru Har Sahai, Firozpur",
  "Dev Samaj College for Women, Firozpur",
  "Mata Gujri Khalsa College kartarpur",
  "S.D. College for Women, Moga",
  "Mother Mary s Institute of  Nursing, Deowal Road,  Nasrala, Distt. Hoshiarpur",
  "D.M. College of Education, Moga",
  "Aryans Institute of Mangement & Technology",
  "Govt College, Muktsar",
  "ALPINE INSTITUTE OF INFORMATION AND TECHNOLOGY,RODE",
  "Guru Gobind Singh College of Management and Technology",
  "Jamna Devi Institute of Management and Technology",
  "Maharaja Ranjit Singh Khalsa Technical College, Batinda",
  "National College of Information Technology, Muktsar",
  "Sant Baba Hari Singh Memorial   College of Education, Mahilpur",
  "Rayat College of Education, Railmajra",
  "SV Memorial College of  Nursing, VPO Moodhal,  Near Verka, Amritsar",
  "Rayat Bahra Dental College, Village Daon Majra, Tehsil Kharar",
  "Institute of Nursing  Education, Guru Teg  Bahadur Sahib (C)   Hospital, Shastri Nagar,  Model Town, Ludhiana",
  "College of Nursing, Adesh  Institute of Medical  Sciences, Kotkapura Road,  Muktsar",
  "Sant Darbara Singh College  of Education for Women Lopon",
  "Sanmati Government College of Science Education and Research, Jagraon",
  "Guru Gobind Singh College of Management and IT",
  "CENTRE FOR INTERDISCIPLINARY BIOMEDICAL RESEARCH",
  "S.D.College, Hoshiarpur",
  "Ram Asra College of Education",
  "Dr Shyam Lal Thapar  College of Nursing,  Amritsar Barnala Bypass  Road, Moga",
  "University College of Nursing, Faridkot",
  "Dashmesh Khalsa College, Muktsar",
  "Nightingale College of  Nursing, VPO Narangwal  Kalan, Distt. Ludhiana",
  "College of Physiotherapy, Christian Medical College, Ludhiana",
  "SDP College for Women, Ludhiana",
  "J.D.College of Education, Muktsar",
  "Guru Teg Bahadur Khalsa College of Education, Dasuya",
  "Guru Nanak College of Education, Gopalpur",
  "N.I.S., Patiala",
  "Adesh Institute of Medical Sciences & Research, Barnala Road",
  "Swami Vivekanand College of Pharmacy, Ramnagar",
  "Baba Zoravar Singh Fateh Singh Khalsa Girls College, Morinda, Ropar",
  "Guru Nanak Dev University College, Chung, Khemkaran Road, Near Bhikhiwind",
  "BAM Khalsa College,Garhshankar",
  "Khalsa College of Engg. and Technology",
  "DAV Institute of Physiotherapy & Rehabilitation, MHRM, G.T. Road, Jalandhar",
  "INSTITUTE OF NURSING, UNIVERSITY REGIONAL CENTRE, SRI GOINDWAL SAHIB",
  "College of Veterinary Science",
  "VIDYA RATTAN COLLEGE FOR WOMEN",
  "Sri Guru Harkrishan Sahib College of Nursing, Sohana",
  "D M COLLEGE OF EDUCATION, KARARWALA",
  "S.R.P.A.  Adarsh Bhartiya College, Pathankot",
  "Baba Banda Singh Bahadur Engineering College",
  "Panjab University Constituent College Mohkam Khan Wala Ferozepur",
  "GN National College Nakodar",
  "G.M.T. College of Education, Jalandhar Bypass",
  "KC College of Hotel Management",
  "Bebe Nanaki Khalsa College for Women, Dhariwal",
  "Rayat College of Law, Railmajra",
  "Punjabi University Post Graduate Regional Centre Bathinda",
  "Guru Hargobind Singh Khalsa College for Women, Hansali Khera Fatehgarh Sahib",
  "KHALSA COLLEGE(AMRITSAR) OF TECHONOLOGY AND BUSINESS STUDIES MOHALI",
  "Guru Harkrishan Girls College, Phalewal, Ludhiana, Sangrur-Road., Sangrur",
  "FOOTWEAR DESIGN AND DEVELOPMENT INSTITUTE",
  "M and M College of Education, Village Nagri,",
  "Government College for Girls, Patiala",
  "I.K.G.P.T.U .Amritsar Campus ",
  "Shahid Udham Singh College of Research & Technology, Tangori, Mohali",
  "Mata Gurdev Kaur Memorial Education Institute (for girls), Bareta, Mansa",
  "Guru Teg Bahadur College of Education, Dalelwala, Teh. Budhladha, Mansa",
  "St. Soldier Management and Technical Institute, Jalandhar",
  "KRM DAV College Nakodar",
  "Khalsa College of Education Amritsar",
  "Maharaj Braham Sagar Brahmanand Bhuriwale College, Tibba Nangal",
  "Tawi College",
  "Swift School of Pharmacy, Ghaggar",
  "ISF college of Pharmacy, Moga",
  "Guru Nanak Ayurvedic Medical College & Research Institute, Malerkotla Road, VPO Gopalpur",
  "ADVANCE CANCER INSTITUTE BATHINDA    ",
  "Mata Sahib Kaur Girls College, Damdama Sahib, Bathinda",
  "Shaheed Kartar Singh Sarabha Ayurvedic College & Hospital, VPO Sarabha",
  "Guru Nanak College Of Education, Dalewal",
  "University College of Physiotherapy, Faridkot",
  "Govt College, Karamsar-Rara Sahib",
  "Khalsa College of Pharmacy, Amritsar",
  "SGGS Khalsa College, Mahilpur",
  "Vishavkarma College for Girls, Dirba Mandi",
  "Northern India Institute of Fashion Technology (NIIFT)",
  "Aryans College of EducationVillage  Nepra, Chandigarh-Patiala Highway,  Near Banur, Teh. Rajpura",
  "JETHEDAR UJJAGAR SINGH SEKHWAN (J.U.S.S.) INSTITUTE,SEKHWAN",
  "Shree Lakshmi Narayan Ayurvedic College, O/S Lohgarh Gate, Amritsar",
  "RADICAL TECHNICAL INSTITUTE",
  "Baba Mehar Singh Memorial College of Education,Kalanaur Gurdaspur",
  "Govt. Ripudaman College, Nabha",
  "D A V COLLEGE OF EDUCATION, ABOHAR",
  "CT INSTITUTE OF ARCHITECTURE AND PLANNING",
  "GCET, Gurdaspur",
  "Baba Kundan Singh College, Muhar",
  "Malwa College of Education, Sardulewala, Mansa",
  "S. Amarjit Singh Memorial Institute of Law, Dhainthal (Samana), District Patiala",
  "University College, Ghanaur",
  "SWAMI VIVEKANAND COLLEGE OF NURSING",
  "MEERA MEDICAL INSTITUTE OF NURSING AND HOSPITAL, ABOHAR",
  "GURU GOBIND SINGH COLLEGE OF NURSING, DHANAULA ROAD",
  "University College, Chunni Kalan",
  "Sant Baba Sewa Singh Memorial Govt. College Girls  Guru Ka Khuh, Mune, Nurpur Bedi, Ropar",
  "Punjab Institute of Management and Technology",
  "Shivshankar Institute of Engg. & Tech, Patti",
  "Dashmesh Girls College, Badal",
  "Gulzar School of Management, Vill Libra",
  "SYNETIC BUSINESS SCHOOL",
  "DASMESH COLLEGE OF PHYSIOTHERAPY, FARIDKOT",
  "Mahatma Hans Raj DAV  Institute of Nursing &  Hospital,  MHRM, G.T.  Road, Jalandhar",
  "Khalsa College of  Nursing, Amritsar",
  "Lincoln College of Law, Sirhind, Fatehgarh Sahib",
  "Malout  Institute of Management and Information Technology",
  "Modern Group of Colleges(College of Management)",
  "MATA SAHIB KAUR GIRLS COLLEGE, TALWANDI BHAI",
  "Shiwalik College of Education, Vill. Mustafabad Jatta, PO Babbehali, Gurdaspur.",
  "Mastermind College of Education, Bathinda",
  "Mata Misri Devi D.A.V.College, Giddderbaha",
  "Guru Gobind Singh Khalsa College for Women, Jhar Sahib",
  "Dasmesh Girls College  of Education, Badal",
  "A.S. Group of Institutions, Khanna",
  "AMAR SHAHEED BABA AJIT SINGH JUJHAR SINGH MEMORIAL PARAMEDICAL COLLEGE,BELA",
  "Sri Guru Teg Bahadur College, Sathiala",
  "Mata Ganga Khalsa College for Girls, Kottan",
  "GNBL Ramgarhia College for Women,  Phagwara",
  "Baba Farid College, Deon",
  "SWIFT TECHNICAL CAMPUS, PATIALA",
  "COLONEL DEGREE COLLEGE,CHURAL KALAN,SANGRUR",
  "RR Bawa DAV. College for Girls Batala",
  "Sukhdeva Krishna Collegeof Education for Women",
  "LONGOWAL ACADEMIC COLLEGE",
  "JPS INSTITUTE OF TECHNICAL VOCATIONAL STUDIES",
  "Swami Ganga Giri Janta Girls College, Raikot",
  "Rayat Bahra Institute of Engg. and Nano Technology, Hoshiarpur",
  "M. B. B. G. R. G. C. B.Ed Girls College, Mansowal",
  "Baba Kundan Singh Memorial  Law College, Dharmkot",
  "Baba Sheehan Singh Gill Govt. College, Sidhsar",
  "S.D. College, Barnala",
  "Government College, Machhiwara",
  "Bibi Rehmete Christian  College of Nursing",
  "THE SALVATION ARMY MAC ROBERT HOSPITAL, COLLEGE OF NURSING, DHARIWAL",
  "Arjan Dass College, Dharamkot",
  "FATEH COLLEGE OF B.ED FOR WOMEN",
  "MOHALI NURSING COLLEGE",
  "Guru Gobind Singh Khalsa  for Women, Kamalpura",
  "J.C.D.A.V.College, Dasuya",
  "Doraha College of Education, Doraha",
  "Khalsa College for Women,Sidhwan Khurd",
  "Centre for Development of Advanced Computing (C-DAC), Mohali",
  "Hardik College of Education, Bhawanigarh",
  "Akal Sahae College of Education Kotkapura, Faridkot",
  "Guru Nanak College, Sukhchainana Sahib, Phagwara",
  "Pine Grove College of Education, Bassi Pathana, Distt. Fatehgarh Sahib",
  "Swami Dayanand College of Education, Lehra Bega, Bathinda",
  "Maharaja Ranjit Singh College, Malout",
  "Govt. Kirti College, Nial Patran",
  "Guru Nanak Dev Khalsa Girls College, Bathinda",
  "S.S. Jain College of Ecucation (for  girls) Mansa",
  "Lala Hans Raj Memorial College of Education, Bhangeria",
  "Guru Nanak Khalsa College, Abohar",
  "Lala Jagat Narayan Education College, Jalalabad(W)",
  "Punjabi University Guru Kashi  Campus",
  "G.H.G. Khalsa College of Pharmacy, Gurusar Sadhar, Ludhiana",
  "Guru Nanak Institute of Management and Technology, Ludhina",
  "Ludhiana Group of Colleges",
  "Meera College of Education, Mansa Road Sardulewala, Mansa",
  "Punjabi University Neighbourhood Campus, Ralla, Mansa",
  "Baba Ke College of Education, Daudhar",
  "Sant Darabara Singh College  for Women, Lopon",
  "Sri Guru Gobind Singh College of Education, Beghpur Kamlooh",
  "KHALSA AYURVEDIC MEDICAL COLLEGE",
  "A.S.College  Khanna",
  "Kamla Nehru College for Women Phagwara.",
  "Babe ke College of Education, Mudki",
  "Kanya Maha Vidyalaya Jalandhar",
  "Saint Sahara College of Education",
  "University College, Ghudda",
  "Kamla Lohtia S.D College, Subhash Nagar",
  "Arihant College Of Education",
  "Patel Memorial National College, Rajpura, Patiala",
  "WAHEGURU COLLEGE",
  "Akal Degree College for Women, Sangrur",
  "Modern College of Education, Birkalan, Distt. Sangrur",
  "Guru Gobind Singh College of Education",
  "D.A.V. College, Bathinda",
  "IK Gujral Punjab Technical University",
  "Jhulka College of Nursing  & Health Sciences, Julka  Nagar, Batala Road,  Qudian, Distt. Gurdaspur",
  "Govt. College Bholath (Kapurthala)",
  "Punjabi University Centre for Emerging & Innovative Technology, Mohali.",
  "Lala Lajpat Rai Memorial Institute of Management and Computer Sciences, Ajitwal",
  "Bharat Group of Colleges",
  "SYON COLLEGE",
  "Baba Namdev University College, Kishankot",
  "BHAI MATI DASS COLLEGE OF NURSING, GORAYA",
  "PCTE INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "Nam Rattra International  College of Nursing,  Loharka Road, Near  Power House, Amritsar.",
  "Northern India Institute of Fashion Technology",
  "CKD Institute of Management and Technology, Amritsar",
  "Akal College of Pharmacy and Technical Education, Mastuana",
  "Universal Law College, Ballopur, Lalru",
  "S SUKHJINDER SINGH COLLEGE OF PHARMACY",
  "Gursewa Institute of Science and Technology,Garshankar",
  "Allied College of Hospitality Culinary Arts and management",
  "Guru Nanak Dev College of Education, Majatri, Kharar,",
  "Adesh Institute of Higher Studies",
  "BABA HIRA DASS JI COLLEGE OF VETERINARY PHARMACY",
  "Ganga Degree College Village Dhabi Gujran Tehsil Patran , Khanouri",
  "College of Dairy Science & Technology",
  "College of Fisheries",
  "College of Veterinary Science",
  "Government Mohindra College, Patiala",
  "SARASWATI GROUP OF COLLEGES",
  " Sainik Institute of Management and Technology",
  "Aklia College of Education, Village Akliakalan, P.O. Goniana Mandi, Distt Bathinda",
  "Akal College of Physical Education, Mastuana, Sangrur",
  "KHALSA COLLEGE OF LAW",
  "Bibi Chhankaur College of  Nursing, Sardulgarh,  Mansa",
  "PUNJABI UNIVERSITY COLLEGE, MEERAPUR",
  "Modern Group of Colleges, Mukerian",
  "Govt. College of Education, Patiala",
  "Islamia Girls College, Malerkotla",
  "S. Sukhjinder Singh Institute of Nursing",
  "SSSS College of Commerce for Women, Mall Road Chowk, Majitha Road, Amritsar",
  "Sri Sai Iqbal College of Management and IT, Badhani",
  "Shri Vishwa Mittar Sekhari College of Law, Plot No. 26-30, Focal Point, Batala",
  "VMS College of Nursing  & Paramedical Sciences,  Said Mubarak, Amritsar  Road, Batala",
  "S.D.College of Education, Barnala",
  "Global Group of Institutes",
  "N.J.S.A. Govt. College Kapurthala",
  "A.S.College for Women, Khanna",
  "Sai College of Education, Jadla, NawanShehar",
  "SFC INSTITUTE OF NURSING",
  "Hindu College Amritsar",
  "PUNJAB INSTITUTE OF AYURVEDA ABOHAR",
  "SSD Women's Institute of Technology, Bathinda",
  "GOVERNMENT COLLEGE, DANEWALA, MALOUT",
  "Shaheed Kartar Singh Sarabha Dental College, VPO Sarabha, Distt. Ludhiana",
  "Panjab University Rural Centre Kauni",
  "Lord Krishna College of Education, Vill Dera Saidan, Sultanpur Lodhi, Kapurthala",
  "University Institute of Pharmaceutical Sciences & Research, Faridkot",
  "SMDRSD College of Education Pathankot",
  "SBS COLLGE OF PHARMACY, MEHAL KALAN",
  "Rattan College of  Education ,  V&PO Sohana, Mohali",
  "Smt. Jawala Devi College of Education, Sanghol,",
  "ARYANS PHARMACY COLLEGE, RAJPURA",
  "Cordia Institute of Business Management, Sanghol, Fatehgarh Sahib.",
  "S.S. College of Education for Girls, Bhikhi, Mansa",
  "GOLDEN INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "S T College of Nursing and Medical Sciences",
  "Public College, Samana, Patiala",
  "Rattan Professional Education College,  V&PO Sohana, Mohali",
  "SFC INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "R P C DEGREE COLLEGE",
  "GN College for Women Banga",
  "Vidya Sagar College of Education (for girls) Dhuri",
  "SRI GURU RAMDASS DEGREE COLLEGE",
  "Chief Khalsa Diwan International Nursing College",
  "ROYAL INSTITUTE OF NURSING",
  "Aasra Institute of Advance Studies, Rajpura, Bhawanigarh, Sangrur",
  "GLOBAL GROUP OF INSTITUTES SCHOOL OF LEGAL STUDIES AMRITSAR    ",
  "Tagore College of Education, Fatehgarh",
  "Asra College of Education, Village   Rajpura, Near Channo, Tehsil Bhawanigarh,",
  "Punjabi University Neighbourhood Campus, Maur Mandi",
  "Sukhjinder Novel Institute of Nursing, Dunera",
  "College of Nursing, Public  Khalsa College for  Women, VPO Kandhala  Jattan (Adda Saran), Distt.  Hoshiarpur",
  "St. Soldier College of Education Behind  REC (NIT) Jalandhar.",
  "Baba Kuma Singh Ji Degree College",
  "Sant  Namdev  Kanya  Mahavidiyala, Bassi Pathana, Distt Fetehgarh Sahib",
  "HARMONY AYURVEDIC MEDICAL COLLEGE AND HOSPITAL FEROZEPUR PUNJAB",
  "PAU COLLEGE OF AGRICULTURE BALLOWAL SAUNKHRI",
  "M.L.M. COLLEGE OF NURSING, KILLI CHAHAL",
  "Swift Institute of Nursing,  Village Ghaggar Sarai,  Teh. Rajpura Distt. Patiala",
  "Sigma College of Pharmacy",
  "Govt. Medical College, Sangrur Road, Patiala",
  "Govt. College, Dera Bassi",
  "Punjabi University Neighborhood Campus Rampura Phul ( Engineering College)",
  "JUPITER GROUP OF INSTITUTIONS    ",
  "Mata Sahib Kaur Khalsa  College of Education, Dhamo Majra, Patiala",
  "SRI SUKHMANI DENTAL COLLEGE & HOSPITAL, DERABASSI",
  "IKGPTU Mohali Campus-II",
  "Guru Nanak Dev Dental College & Research Institute, Patiala Bathinda Road, Sunam",
  "G.H.G. Khalsa College of Education Gurusar Sadhar",
  "CT Institute of Engineering, Management & Technology",
  "Guru Ram Dass B.Ed College, Jalalabad(W)",
  "Aryans College of Pharmacy ",
  "Shri Vishwa Mitar Shekhri College of Education, Vill. Said Mubarak,  Amritsar Road, Batala.",
  "St. Soldier Institute of Hotel Mangement and Catering Technology",
  "S.D. College for Women Sultanpur Lodhi (Kapurthala)",
  "DIPS College (Co-Education) Dhilwan, Kapurthala",
  "Sri Sai College of Pharmacy, Badhani",
  "SGAD College of Education, Khadoor Shahib, Distt-Tarn Taran",
  "SAFFRON COLLEGE FOR GIRLS KOTLA BAJWARA",
  "Swami Vivekanand College of Education, Moonak, Tohana Road Moonak",
  "Guru Gobind Singh College of Education,  Dabwali Road",
  "Sainik Institute of Management and Technology",
  "Baba Kundan Rural College Of Education, Kulliawal",
  "Rayat Group of Institutions",
  "SARASWATI INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH, GHARUAN",
  "Chandigarh College of Technology, Landran",
  "Punjabi University Baba Dhyan Dass Neighbourhood Campus, Jhunir",
  "Hans Raj Memorial College of Education, Baja Khana, Kotkapura",
  "SATYAM INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "AMRITSAR LAW COLLEGE",
  "Guru Gobind Singh College of Arts, Science and Commerce, Khokhar Kalan",
  "I.K.G.P.T.U. Batala Campus",
  "Global College of Engg and Tech. , Anandpur Sahib",
  "Aman Bhalla College of Nursing, Kotli",
  "Hindu Kanya College Kapurthala",
  "Nancy College of Education, Samana, Patiala",
  "Gobindgarh Public College, Alour Khanna",
  "GHG Harparkash College Of Education for Women, Sidhwan Khurd",
  "Sai Ram College of Education, Srain Patti Samana",
  "Punjab College of Education, Sarkapra, Fatehgarh Sahib",
  "CT College of Pharmacy",
  "ARYANS INSTITUTE OF NURSING",
  "GURU VIRJANAND GURUKUL MAHAVIDYALYA",
  "Sant Baba Bhag Singh Memorial Girls College, Sukhanand",
  "GOVERNMENT COLLEGE SHAHKOT JALANDHAR",
  "Govt. College Ajnala  (Distt. Amritsar)",
  "Shivalik Institute of Education & Research, Mohali",
  "Lala Lajpat Rai Govt. College, Dhudike",
  "Guru Gobind Singh College, Sanghera",
  "Bharat Institute of Nursing  Training, Jalandhar  Nakodar Road, VPO  Mundh, Distt. Jalandhar",
  "Punjab Degree College Vill -Mehmuana, Faridkot",
  "Sainik Institute  of Management And Technology",
  "Shaheed Bhagat Singh College of Pharmacy, Sohian Kalan",
  "GCS Institute of Vocational Studies, Bhaddal",
  "National College, Bhikhi, Mansa",
  "University College, Moonak",
  "University College, Balachaur, Nawanshehar",
  "Punjab Business School, Vill Sarkapra",
  "Baba Mangal Singh Institute Of Education, Bughipura",
  "CKD INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "D.A.V.College for Women",
  "G. N. Khalsa College   Sultanpur Lodhi (Kapurthala )",
  "MRPD Government College, Talwara",
  "Ramgarhia Institute of Management and Advance Studies",
  "Adarsh Degree College for Girls Vill Dhainthal Patiala Road",
  "Ram Devi Jindal Educational Charitable Society Group of Institutions",
  "Govt. Polytechnic College, Patila",
  "BHAI GURDAS INSTITUTE OF EDUCATION ",
  "Doaba Business School",
  "Kular College of Nursing,  VPO Kishangarh, Distt.  Ludhiana",
  "H.K.L. College of Education, Guru Harsahai",
  "Baba Banda Bahadur College of Education, Vire wala Road, Near Canel Bridge",
  "MAI BHAGO COLLEGE OF HEALTH SCIENCES",
  "S. RAJINDER SINGH CHAHAL COLLEGE OF PHYSICAL EDUCATION,KALYAN",
  "ARYABHATTA GROUP OF INSTITUTES, BARNALA",
  "Sri Sai College of Pharmacy, Manawala",
  "SWAMI VIVEKANAND COLLEGE OF LAW",
  "Public Khalsa College for Women, Khandhala Jattan",
  "D.D.Jain College of Education, Kidwai Nagar",
  "DAV College, Malout",
  "Aryan Global College of Education",
  "PUNJAB INSTITUTE OF MEDICAL SCIENCES, JALANDHAR",
  "Prof. Gursewak Singh Government College of Physical Education, Patiala",
  "SAINIK INSTITUTE OF IT AND MANAGEMENT",
  "DOLPHIN PG COLLEGE",
  "Guru Nanak National College, Doraha",
  "M.B.G. Govt College, Pojewal",
  "Guru Nanak Dev University College Sujanpur",
  "Giani Kartar Singh Memorial Govt. College,Tanda Urmar",
  "GOVERNMENT COLLEGE LADHUPUR",
  "Aryans Buisness School, Vill Nepra",
  "Guru Gobind Singh Law College, Giddarbaha",
  "Sri Satya Sai Education College, Karaiwala",
  "SATYAM INSTITUTE OF MANAGEMENT",
  "Satyam College of Education, Ghall Kalan",
  "I.K.Gujral Punjab Technical University Mohali campus",
  "Jawahar Lal Nehru Government College ,  Tooran, Mandi Gobindgarh, Fatehgarh Sahib",
  "M.B.B.G.R.G.C.Girls College, Mansowal",
  "Maharishi Dayanand CollegeOf Education, Azimgarh",
  "ANAND COLLEGE OF MANAGEMENT",
  "M.K. College of Education, Vill. Shahpur, PO Udhopur,   Via Jamsher Khas, Jalandhar",
  "GOVERNMENT COLLEGE FOR GIRLS, JALALABAD",
  "KC College of Pharmacy",
  "LYALLPUR KHALSA COLLEGE TECHNICAL CAMPUS SCHOOL OF PHARMACY",
  "CHANDIGARH COLLEGE OF ENGINEERING",
  "ABHISHEK COLLEGE",
  "GOVT. COLLEGE LUDHIANA (EAST)",
  "Maharaja Aggarsain College of Education, Jai Singh Wala, Bathinda",
  "Muktisar Institute of  Higher Education",
  "Guru Hargobind Institute of Law, Sidhwan Khurd",
  "MOHAN DAI OSWAL CANCER TREATMENT AND RESEARCH FOUNDATION",
  "M.R.Govt College, Fazilka",
  "Lala Lajpat Rai Memorial College of Education, Dhudike",
  "Shri Guru Ram Dass  Nursing Institute, Pandher,    Amritsar",
  "GOVT MODEL DIGREE COLLEGE FATEHGARH KOROTANA MOGA",
  "Baba Mehar Singh  Memorial College of  Nursing, VPO Purana  Shalla, Distt. Gurdaspur",
  "Nawab Sher Mohammad Khan Institute Of Advanced Studies in urdu, Persian & Arabic, Malerkotla",
  "CHANDIGARH PHARMACY COLLEGE",
  "BHAI MAHA SINGH COLLEGE OF INFORMATION TECHNOLOGY    ",
  "Akarshan College of Education, Old Tara Garh Road, Dinanagar Gurdaspur.",
  "Govt college for Girls malerkotla",
  "Lajpat Rai DAV College, Jagraon",
  "Punjab College of Commerce and Agriculture Sarkapra, CHUNNI KALAN",
  "M.L.B.G.Girls College Tapprian Khurd,Balachaur",
  "University Institute of Para Medical Sciences",
  "Pandit Mohan Lal SD  College for Girls, Dera Baba Nanak Road, Fathehgarh Churian, Gurdaspur.",
  "FATEH COLLEGE  RAMPURA PHUL",
  "Dr. I. T Institute of Management and Technology ,  Jalalapur",
  "SHRI SARASWATI SANSKRIT COLLEGE KHANNA",
  "AMAN BHALLA INSTITUTE OF MANAGMENT  TECHNOLOGY",
  "Dr. I. T Business school , Jalalapur",
  "BIS Baba Isher Singh College of Engg & Technology, Gagra",
  "Bhai Maha Singh College of Information Technology and life Science",
  "Bhai Maha Singh College of Engg.",
  "NANCY COLLEGE OF LAW",
  "CT INSTITUTE OF TECHNOLOGY AND RESEARCH",
  "Rayat Bahra College of Education, Hoshiarpur",
  "Govt. College, Malerkotla, Sangrur",
  "SETH MADAN LAL MEMORIAL COLLEGE OF NURSING, BHANOHAR",
  "GURU NANAK INSTITUTE OF PHARMACY",
  "D.A.V. College, Abohar",
  "GGDSD College, Hariana,",
  "Cordia College, Sangol,  Fatehgarh Sahib",
  "Baba Sri Chand College of Management , Nurpura",
  "PUNJAB COLLEGE OF LAW",
  "REHBAR AYURVEDIC AND UNANI TIBBI MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTER ",
  "Mata Gujri College,  Fatehgarh Sahib",
  "General Shivdev Singh Diwan Gurbachan Singh Khalsa College, Patiala",
  "SARASWATI COLLEGE OF PHYSIOTHERAPY GHARUAN MOHALI",
  "Genesis Institute of Dental Sciences & Research(Dental College & Hospital), Ferozepur- Moga Road, Ferozepur",
  "Shaheed Major Harminderpal Singh ( Shaurya Chakra) Govt College, Sahibzada Ajit Singh Nagar",
  "Bhai Gurdas Institute of Management & Technology",
  "Guru Teg Bahadur College of Education, Village Lehal Khurd, Lehragagga",
  "Shri Raghunath Girls College, Circular Road, Jandiala Guru, Amritsar.",
  "Baba Farid Law College, Faridkot",
  "Aman Bhalla College of Education, Kotli, Pathankot",
  "Guru Teg Bahadur College for Women  Village Lehal Khurd, Lehragagga, Sangrur",
  "S.M.D.R.S.D. COLLEGE PATHANKOT",
  "Malwa College of Physical Education, Goniana Road, Bathinda",
  "BABA SAHEB BHIM RAO AMBEDKAR GOVT CO EDUCATION COLLEGE BOOTAN MANDI JALANDHAR",
  "Govt. Rajindra College, Bathinda",
  "Mehar Chand College of Education, Bhanopli",
  "S.D. Kanya Mahavidyala, Mansa",
  "Punjabi University Akali Phoola Singh Neighbourhood Campus Dehla Seehan",
  "SACHKHAND COLLEGE OF NURSING",
  "Dr. B.R. Ambedkar, Govt. College, Mukhilana, Distt. Hoshiarpur",
  "Bahra College of Law, Patiala Campus",
  "Sant Baba Attar Singh Khalsa College, Sandour, Sangrur",
  "Bawa Nihal Singh B.Ed College,  Bawa Nihal Singh Street",
  "Saint Soldier Law College, Behind R.E.C.(N.I.T.),  Jalandhar.",
  "Punjab Institute of Technology Guru Teg Bahadurgarh ",
  "Universal College of Education BALLOPURA LALRU MOHALI ",
  "Shri Sanatan Dharam Girls College, Bathinda",
  "Aman Bhalla Institute of Engg. & Tech, Jhakolari, Pathankot",
  "Amar Shaheed Baba Ajit Singh Jujhar Singh Memorial College of Pharmacy",
  "Swami Vivekanand Institute of Engineering & Technology, Ramnagar",
  "Jasdev Singh Sandhu College of Education, Rajpura Road, Kauli, Patiala",
  "Akal College of Education for Women, Village Fatehgarh Chhanna, Distt. Sangrur",
  "Shaheed Udham Singh College of Management & Computer Science VPO Mehlan ,Tehsil  Sunam, Sangrur",
  "Gurmat College, Patiala",
  "Army Institute of  Law, Sector-68, Mohali.",
  "Amritsar Group of Colleges, Amritsar",
  "SAI COLLEGE OF EDUCATION",
  "Amar Shahid Baba Ajit Singh Jujhar Singh Memorial College, Bela , Ropar",
  "Guru Hargobind Sahib Khalsa Girls College, Karhali Sahib, Patiala",
  "Shanti Tara College, Akbarpur Mandi Ahmedgarh, Sangrur",
  "IKGPTU HOSHIARPUR CAMPUS",
  "Bhai Assa Singh Girls College, Goniana Mandi",
  "Dolhpin (PG) College of Life Sciences, Chuni, Fatehgarh Sahib",
  "M.L.Memorial Technical College",
  "Gulzar Institute of Professional Studies",
  "SANT BABA HAZARA SINGH GIRLS COLLEGE NIKKE GHUMMAN    ",
  "Desh Bhagat College, Bardwal Dhuri",
  "S.G.A.D.Govt. College Tarn Taran",
  "Modern College of Education (for girls)  Bhikhi, Mansa",
  "Satyam Institute of Management and Technology, Nakodar",
  "Baba Farid College of Management & Technology, Mukatsar Road, Deon, Bathinda",
  "Divya Shikhsha Gurukul College of Education, Village Ghollu Majra, Derabassi-Lalru Highway, Distt. Mohali",
  "SHIV SHAKTI AYURVEDIC MEDICAL AND HOSPITAL",
  "Mata Sundri Girls College, Dhade, Bathinda",
  "Bhai Gurdas Institute of Engineering and Technology",
  "M.B.B.G.Gokal Gaur Girls College, Rattewal",
  "Panjab University Regional Centre, Ludhiana",
  "Guru Nanak College of Education, Bhikhi, Mansa",
  "University College, Jaitu",
  "Saraswati Professional &  Higher Education College  of Nursing, VPO-Gharuan,   Tehsil-Kharar, Mohali",
  "SANT BABA DALIP SINGH MEMORIAL KHALSA COLLEGE, DOMELI",
  "Institute of Engg. & Tech, Bhaddal",
  "Adarsh College of  Nursing, Village  ChontKheri Patiala Samana Road, Patiala",
  "Sacred Heart International College of Education, Barnala",
  "Modern College of Education, Ranwan, P.O. Khanpur, Malerkotla",
  "SAINIK INSTITUTE OF MGT AND TECHNOLOGY",
  "Punjab College of Education, Raipur, Bahadurgarh, Distt. Patiala",
  "Bhai Ghanaiya Ekta College of Nursing, Dharamkot",
  "Gopi Chand Arya Mahila College, Abohar",
  "St.Soldier College  Basti  Danashmandan, Jalandhar",
  "Baba Isher Singh Institute of Technology VPO-Gagra",
  "Rayat Bahra College of Law",
  "Modern College of Education for Girls, Shergarh Cheema, Malerkotla",
  "D.A.V.College of Education, Hoshiarpur",
  "DEPARTMENT OF MASTER OF COMPUTER APPLICATIONS INSTITUTE OF ENGINEERING AND TECHNOLOGY - BHADDAL",
  "Baba Ishar Singh College of Pharmacy, Kot-ise-khan",
  "DD Jain Memorial College for Women, Ludhiana",
  "R.S.D.College, Ferozepur",
  "Guru Nanak Dev Engineering College, Ludhiana",
  "Miri Piri Khalsa College, Bhadour, Barnala",
  "Malwa College Bondli, Samrala",
  "Aryans College of Engineering, Patiala",
  "Baba Moni Ji Maharaj  Degree College, Lehra Mohabbat",
  "NATIONAL  INSTITUTE OF ELECTRONICS AND INFORMATION TECHNOLOGY,NIELIT",
  "CT Institute of Higher Studies, Jalandhar",
  "Shri Guru Ram Das Institute of Mgt & Tech, VPO- Halwara",
  "KC School of Management and Computer Application",
  "GOVT COLLEGE JADLA",
  "SHAHEED BHAI MANI SINGH KHALSA COLLEGE",
  "Dashmesh Khalsa College",
  "Chandigarh Engineering College Jhanjeri ",
  "RATTAN PROFESSIONAL EDUCATION COLLEGE OF PARA MEDICAL SCIENCES,",
  "Panjab University Regional Centre Muktsar",
  "Sri Sukhmani Institute of Hospitality Management and Technology",
  "Trinity Institute  of Management and Technology",
  "Guru Gobind Singh Khalsaof Education for Women",
  "Guru nanak Institute of Engg. & Management",
  "Dayanand Medical College,Civil Lines, Ludhiana",
  "Malwa College of  Nursing, Mehal Kalan,  Distt. Barnala",
  "G N GIRLS COLLEGE, RAVAS BRAHMNA SULAR",
  "Anand College of Nursing,  Jethuwal, Batala Road ,  Amritsar",
  "Shaheed Bhagat Singh Polytechnic and Pharmacy College",
  "DAV Institute of Engineering and Technology, Jalandhar",
  "SWAMI VIVEKANAND COLLEGE OF MANAGEMENT AND TECHNOLOGY",
  "Guru Nanak College, Ferozpur",
  "SANJEEVANI TECHNICAL AND PARAMEDICAL COLLEGES",
  "Gian Sagar College of Physiotherapy, Ram Nagar, VPO Banur, Distt. Patiala",
  "Gujranwala guru Nanak Institute of Management & Technology",
  "Baba Jaswant Singh Dental College Hospital & Research Institute, Sector 40, Urban Estate, Ludhiana",
  "VMS Institute of Management, Batala",
  "Rayat & Bahra Institute of Management, Bohan",
  "Smt Urmila Devi Ayurvedic College of Medical Sciences & Hospital, VPO Kharkan, Una Road",
  "Smt. Rama Chopra S.D Kanya Mahavidyalaya, Pathankot",
  "Shri Guru Ram Dass  College of Nursing, Canal  Road, Hoshiarpur",
  "Sri Sukhmani Institute of Pharmacy",
  "Royal Institute of Nursing,  Village Jaito Sarja, Tehsil  Batala, Distt. Gurdaspur- 143505",
  "GN Khalsa Girls College, Baba Sang Dhesian (Jalandhar)",
  "GURU NANAK COLLEGE, MOGA",
  "Guru Teg Bahadur Institute of Management & Technology , Dakah",
  "Om Prakash Memorial College of Education, Vill. Dyalpur, Tehsil Dhilwan, Kapurthala",
  "SHRI GURU TEG BAHADUR KHALSA COLLEGE FOR GIRLS, AKAR",
  "K.C Institute of Hotel Management, Nawansheher",
  "PATEL INSTITUTE OF MANAGEMENT & TECHONOLOGY, RAJPURA",
  "Guru Nanak College, Sri Muktsar Sahib",
  "Genesis Institute of  Nursing, Ferozepur",
  "Sri Guru Ram Das College  of Nursing, Near  Gurdwara Shaheed Gunj,  Sri Amritsar",
  "Gursewa College of  Nursing, VPO Panam,  Garhshankar, Distt.  Hoshiarpur",
  "Guru Nanak College of  Nursing, P.O. Dehlon,  Gopalpur, Distt. Ludhiana",
  "Rayat Bahra College of  Nursing, VPO Bohan,  Tehsil & Distt. Hoshiarpur",
  "Sri Sukhmani Institute of  Nursing, Dera Bassi, Distt.  Mohali",
  "Sant Baba Bhag Singh Memorial  College of Education for Girls, Sukhanand",
  "Guru Gobind Singh Medical College, Sadiq Road, Faridkot",
  "Gian Sagar Dental College, Village Ram Nagar, Banur",
  "baba kharak singh baba darshan singh institute of education chatiwind gate amritsar ",
  "Sainik Institute of Management and Technology Hoshiarpur",
  "KHALSA COLLEGE OF PHARMACY AND TECHNOLOGY",
  "Sainik Institute of Management and Technology Jalandhar",
  "Shaheed Kartar Singh  Sarabha College of  Nursing, Sarabha, Distt  Ludhiana",
  "KMS College of IT and Management",
  "CT Institute of Hospitality Management",
  "COLONEL COLLEGE OF PHYSICAL EDUCATION ",
  "College of Para Medical Sciences, Adesh Institute of Medical Sciences and Research",
  "GURUKUL INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "Mata Sahib Kaur College  of Nursing, VPO Balongi,Teh. & Distt. Mohali- 140301",
  "Babe Ke Institute of  Nursing, VPO Daudhar,  Distt.Moga",
  "GURU NANAK PARAMEDICAL COLLEGE,DHAHAN KALERAN",
  "Luxmi Bai Institute of Dental Sciences & Hospital, Sirhind Road, VPO Baran",
  "Aggarwal College of  Nursing, Tehsil Road,  Guru Harsahai, Distt.  Ferozepur",
  "National Institute of  Nursing, Village Khurana,  Distt. Sangrur",
  "HOMI BHABHA CANCER HOSPITAL",
  "Baba Farid College of  Nursing, Faridkot Road,  Kotkapura",
  "Shaheed Baba Jiwan Singh Khalsa College",
  "Guru Nanak College of  Nursing, VPO Dhahan  Kaleran,Distt. Nawanshahr",
  "ISF COLLEGE OF PHARMACY AND RESEARCH MOGA    ",
  "Lala Lajpat Rai Institute of  Nursing Education, Gulab  Devi Hospital, Jalandhar",
  "Mata Saraswati Institute of  Nursing Education, VPO  Birmi, District Ludhiana",
  "Hari Parkash Institute of Management and Technology",
  "SAHIBZADA ZORAWAR SINGH GOVERNMENT COLLEGE, BURJ HARI SINGH RAIKOT",
  "PUNJAB AIRCRAFT MAINTENANCE ENGINEERING COLLEGE PATIALA",
  "A&M Institute of Computer & Technology , Pathankot",
  "Nehru Memorial Govt. College, Mansa",
  "Babe Ke Ayurvedic Medical College & Hospital, VPO Daudhar, Via Ajitwal",
  "Dayanand Ayurvedic College, Mahatma Hans Raj Marg, G.T. Road, Jalandhar",
  "Govt. Ayurvedic College, Lower Mall, Patiala",
  "Guru Nanak Ayurvedic Medical College, Barkandi Road, Near Ajit Cinema",
  "Mai Bhago College for Women, Ramgarh",
  "Lyallpur Khalsa college technical campus",
  "ARYANS DEGREE COLLEGE, RAJPURA",
  "Baba Farid College of Pharmacy",
  "MK INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "Govt. Medical College, Majitha Road, Amritsar",
  "Universal Business School, Desa Bassi, SAS, Nagar",
  "Universal Institute of Engg. & Technology , Vill Ballopur, Lalru",
  "DASMESH COLLEGE OF PHARMACY",
  "CGC College of Engineering, Landran",
  "Doaba College of Pharmacy, Ghatuar",
  "Doaba Institute of Engineering & Technology, Ghatuar",
  "CITY NURSING COLLEGE, GURDASPUR",
  "Indo American College of  Nursing, Amritsar Road,  Moga-142001",
  "GOVERNMENT COLLEGE, AMARGARH",
  "Guru Nanak Dev University Regional Campus",
  "Guru Teg Bahadur National College, Dakha",
  "Ly. Khalsa College  Jalandhar",
  "Majha College for Women,   Tarn Taran.",
  "Lord Mahavira Homeopathic Medical College, Kitchlu Nagar, Hehneman Road, Ludhiana",
  "S.C.D.Govt College, Ludhiana",
  "DR B R AMBEDKAR STATE INSTITUTE OF MEDICAL SCIENCES MOHALI",
  "ANGELSINSTITUTEOFPHARMACEUTICALSCIENCESGHASITPURMUKERIAN",
  "Phoneix, The Global Institute of Nursing, Vill. Rampur, Lambra",
  "CT Institute of Technology, Shahpur",
  "DOABA KHALSA TRUST GROUP OF INSTITUTIONS  MANAGEMENT",
  "Shivalik College of Pharmacy, Nangal",
  "All Saints Institute of Medical Sciences & Research, On Sidhwan Canal, P.O. Jaspal Bangar, Ludhiana",
  "GHG AYURVEDIC MEDICAL COLLEGE AND HOSPITAL, RAIKOT,LUDHIANA",
  "Bee Kay Institute of  Nursing, VPO Behrampur  Zimidara, District Ropar",
  "St. Soldier Group of Institutions, Jalandhar",
  "Khalsa College for Women Amritsar",
  "P.T.M. Arya College,  Noor Mehal (Jalandhar).",
  "MAHANT GURBANTA DASS MEMORIAL COLLEGE OF PARAMEDICAL SCIENCES BATHINDA",
  "Quest infosys foundation group of institutions",
  "UNIVERSAL COLLEGE PATRAN",
  "ST SOLDIER INSTITUTE OF BUSINESS MANAGEMENT AND AGRICULTURE",
  "CT INSTITUTE OF LAW ",
  "D.A.V. College Amritsar",
  "BHAI GURDAS COLLEGE OF PHARMACY SANGRUR",
  "SHRI GURU TEG BAHADUR COLLEGE FOR WOMEN, BALLLOH",
  "Khalsa College Amritsar",
  "Sant Hira Das Kanya Mahavidyalaya Kala Sanghian (Kapurthala)",
  "Chacha Satyapal Tuli Memorial College of Education,Vill raipur, P.O Kathlour, Tehsil  Pathankot.",
  "Swami Swatantranand Memorial College, Dinanagar",
  "S.D.S.P. Memorial College for Women, Rayya  (Distt. Amritsar)",
  "SHRI GURU RAM DAS COLLEGE OF EDUCATION",
  "Mohan Lal Memorial Institute of Education, Mudhal, Near Verka, Batala Road, Amritsar.",
  "Trinity College, Church Nagar, G.G.S.Avenue,Chogitti Jalandhar",
  "Sri Guru Teg Bahadur College of Education, Khankot, Amritsar",
  "GURU GOBIND SINGH KHALSA COLLEGE",
  "AKAL GROUP OF TECHNICAL AND MANAGEMENT INSTITUTION, MASTUANA",
  "SANT MAHESH MUNIJI GIRLS COLLEGE , BATHINDA",
  "GND University College, Near Govt. College of Edu., Ladowali Rd.",
  "SSD COLLEGE FOR PROFESSIONAL STUDIES, BHOKHRA",
  "Sidana Institute of Education, Khiala Khurd, Near Ram Tirth, Amritsar.",
  "Universal Institute of Pharmacy",
  "Shanti Devi Arya Mahila College Dina Nagar",
  "UNIVERSAL COLLEGE, BALLOPURA LALRU MOHALI",
  "Mai Bhago Degree College, Ralla, (Mansa)",
  "Mai Bhago College of Education Ralla (MANSA)",
  "GURU COLLEGE",
  "ADARSH MEMORIAL COLLEGE FOR WOMEN",
  "College of Nursing, Adesh  Institute of Medical  Sciences & Research,  Bathinda",
  "Adesh Institute of Pharmacy & Biomedical Sciences, Bathinda",
  "ASHOKA COLLEGE OF HEALTH SCIENCES AND TECHNOLOGY",
  "Mata Gujri Memorial College, Vill. Balwanda, Teh. Kahnuwan, Gurdaspur.",
  "Guru Nanak Girls College, Model Town, Ludhiana",
  "MALWA DEGREE COLLEGE FOR GIRLS KOTAK PURA",
  "YOUNG SCHOLARS COLLEGE",
  "Quest Group of Institutions",
  "Mai Bhago Ayurvedic College (For Women), Ferozepur Road, Muktsar",
  "University College, Bahadarpur",
  "Pyramid College of Business And Technology",
  "Shaheed Bhagat Singh Khalsa College for Women, Padiala",
  "Sri Guru Har Rai Sahib College for Women, Chabbewal",
  "GN Navbharat College Narur Panchhat (Kapurthala)",
  "Dev Samaj College of Education  For Women, Firozpur",
  "CHANDIGARH ENGINEERING COLLEGE-CGC, LANDRAN, MOHALI",
  "AMRITSAR, INSTITUTE OF PARAMEDICAL SCIENCES    ",
  "Seva Devi College of Education, Tarntaran .",
  "Hans Raj Mahila Maha Vidyalaya, Jalandhar",
  "Saint Sahara Ayurvedic Medical College & Hospital, Kot Shameer, Bathinda",
  "Kenway College of Education, Azimgarh",
  "Anand College of Education for Women, Jhethuwal, Batala Road, Amritsar.",
  "Guru Nanak College of Education for Women, Kapurthala",
  "Cheema College of Education, VPO Kishan Kot, Tehsil Batala, Gurdaspur.",
  "Shaheed Bhagat Singh College of Education, Patti.",
  "Bebe Nanki University College, Vill. Mithra",
  "Shri Sai College of Education, Badani, Pathankot.",
  "ARYANS COLLEGE OF LAW",
  "Lyallpur Khalsa College of Education For Women, Jalandhar",
  "MALWA INSTITUTE OF HIGHER STUDIES, SARDULEWALA",
  "Rayat & Bahra Institute of Pharmacy, Bohan",
  "SAHEED KASHI RAM MEMORIAL COLLEGE, BHAGOO MAJRA KHARAR",
  "Govt College, Zira",
  "SRI GURU TEG BAHADUR KHALSA COLLEGE, SRI ANANDPUR SAHIB",
  "Punjab College of Law",
  "Golden College of Education, Hanuman Chowk, Gurdaspur",
  "GN Khalsa College Daroli Kalan (Jalandhar)",
  "Guru Nanak Dev University College, Narot Jaimal Singh",
  "MAA SARASWATI INSTITUTE OF PHARMACEUTICAL SCIENCES, ABOHAR",
  "GN National College for Women Nakodar",
  "Pt. Mohan Lal S.D.College for Women, Gurdaspur",
  "JDS College of Education, Vill. Kot, Tehsil Thar Kalan, Pathankot",
  "J R M ADARSH BHARTIYA COLLEGE OF PHARMACY, PATHANKOT",
  "Sant Baba Hazara Singh College of Education, Vill. Chhina, PO. Naushehra Majha Singh, Gurdaspur.",
  "SARASWATI COLLEGE OF PHARMACY",
  "Govind National College, Narangwal",
  "Guru Nanak Dev University Regional Campus",
  "Angel's College of Education, Mamun, Pathankot",
  "Guru Nanak Dev University College Nakodar",
  "Khalsa College of Veterinary and Animal Sciences",
  "SHAHEED RAM SINGH PATHANIA MEMORIAL GURU NANAK DEV UNIVERSITY COLLEGE, NIARI",
  "St. Soldier Institute of Pharmacy",
  "Adesh Institute of Dental Sciences & Research, Baranala Road, Bathinda",
  "College of Physiotherapy, Adesh Institute of Medical Sciences & Research, Bathinda",
  "MAJHA COLLEGE OF PHARMACY    ",
  "GURU NANAK DEV UNIVERSITY COLLEGE PHILLAUR",
  "PUNJAB MULTIPURPOSE MEDICAL INSTITUTE, V.P.O SEHNA, BARNALA",
  "Bebe Nanaki University college for girls Fattu dhinga  ",
  "Institute of Pharmaceutical Sciences, Bhaddal",
  "Dasmesh Institute of Research & Dental Sciences, Talwandi Road, Faridkot",
  "M.K. Education Societies Group of Institutions",
  "GURU RAM DASS COLLEGE OF PHARMACY",
  "Chandigarh Business school of Administration, Landran",
  "PCTE Group of Institutes, Jhande",
  "Punjab College of Technical education, Jhande",
  "GN College of Education, Patiala",
  "Swift Technical Campus Ghaggar Sarai",
  "JAIN INSTITUTE OF NURSING",
  "SIDANA NURSING COLLEGE",
  "Shaheed Ganj College for Women, Mudki",
  "Indo Global College of Management and Technology",
  "Sant Hari Singh Memorial College for Women",
  "Panjab University Regional Centre Hoshiarpur",
  "S.N. College Qadian",
  "Ambika College of Education, Opp. Village Badali, Badala road, Kharar, Ropar",
  "GOSWAMI GANESH DUTTA SANATAN DHARMA COLLEGE, KHERI GURNA, RAJPURA",
  "Giani Zail Singh College of Engg. & Technology, Bhatinda",
  "SL Bawa DAV College, Batala",
  "Chandigarh College of Pharmacy, Landran",
  "Anand College of Engg. and Management, Sultnpur",
  "GURU RAMDAS MALWA COLLEGE BUTTAR SAREEH",
  "Guru Gobind Singh University College, Jandiala (Jalandhar)",
  "ST SOLDIER INSTITUTE OF BUSINESS MANAGEMENT AND TECHNOLOGY",
  "VIDYA SAGAR COLLEGE OF EDUCATION",
  "SGL College of Nursing,  Village Semi, P.O.  Khajurala, Distt. Jalandhar",
  "GOVT COLLEGE ABOHAR",
  "GOVERNMENT COLLEGE DHOLBAHA",
  "Arya College",
  "Sri Aurobindo College of  Commerce & Management, Jhande",
  "Guru Nanak Dev University College, Pathankot",
  "Ashoka Institute of Nursing",
  "Tri Shatabdi GGS Khalsa College Ramsar Road, Amritsar",
  "GOVT COLLEGE SHAHBAAZPUR",
  "GOVT COLLEGE SIDHPUR",
  "SBRS College for Women, Sadik, Faridkot",
  "Guru Nanak College, Budhladha, Mansa",
  "SSSS COLLEGE OF COMMERCE AND ALLIED STUDIES",
  "National College of Physical Education, Village Chupki, Patiala",
  "VIDYA JYOTI INSTITUTE OF HIGHER EDUCATION DERABASSI, MOHALI ",
  "Multani Mal Modi College, Patiala",
  "International Divine College of Education, Ratwara Sahib Complex, P.O. Mullanpur Garibdass, Tehsil Kharar,",
  "Punjabi University Law Regional Centre Bathinda",
  "S.S. College for Girls, Bhikhi, Mansa",
  "Tara Vivek College, Gajjan Majra, Malerkotla",
  "GOVERNMENT COLLEGE ROPAR ",
  "Lal Bahadur Memorial Mahila College, Nabha",
  "Akal Degree College, Mastuana, Sangrur",
  "Guru Arjan Dev Khalsa College, Chohla Sahib, Tarn Taran",
  "ALLIANCE COLLEGE GIDDERBAHA ",
  "Guru Nanak College Batala",
  "Lord Mahavir College of Education, Hamirgarh",
  "Milkha Singh Educational Institute, Bareta, Mansa",
  "Vidya Sagar College of Management and Technology, Fatehpur, Patiala",
  "Doaba College of Education, Ghatour",
  "Malwa College, Bathinda",
  "Attri College of Education for Girls, Lalru Mandi, Near Shiv Mandir Road, Derabassi",
  "Baba Moni  Ji  Maharaj Education College, Lehra Mohabbat, Bathinda",
  "Shaheed Udham Singh College of Education, VPO Mehlan Chowk, Sunam, Sangrur",
  "Guru Nanak College of Education, for girls, Lehal Khurad, Sangrur",
  "Shri Guru Teg Bahadur College of Education, Village-Sehke, Malerkotla",
  "Government Shivalik College, Naya Nangal",
  "Aklia Degree College, Jaitu Road, Goniana Mandi, Bathinda",
  "Saint Kabir College of Education, Kauli, Patiala",
  "CGM College Mohlan",
  "S.G.A.D. College Khadoor Sahib (Distt Tarn Taran)",
  "Sainik Institute Of Management and Technology",
  "Shahid Bhagat Singh Government College, Kotkapura",
  "University College, Dhilwan",
  "Govt. College of Education, Malerkotla  Sangrur",
  "Bhagwati College of Education for girls, Bhikhi, Mansa",
  "VMS College of Pharmacy, Batala",
  "Khalsa College, Chawinda Devi, Amritsar",
  "DIPS College of Education Rarra Morr, Jalalpur",
  "Guru Teg Bahadur  Khalsa College for Women, Dasuya",
  "Khalsa College,Garhdiwala",
  "Moga College of Education for Girls, Ghall Kalan",
  "SILVER OAKS COLLEGE OF NURSING",
  "Sant Kabir College of Management Arts & Computer Science for Girls, Bhucho Kurad, Bathinda",
  "Hoshiarpur Institute of management and Technology, Vill Bhagpur",
  "Guru Ram Das College of Management and technology",
  "Saini Bar College, Bulhowal",
  "Baba Budha College Bir Sahib.",
  "Hindu Kanya Mahavidayala Dhariwal",
  "D.A.V.College Jalandhar",
  "DIPS College of Education, Dhilwan, Distt Kapurthala",
  "Mata Maisar Khana College of Education  for girls, Maisar Khana, Bathinda",
  "Guru Gobind Singh College of Education, Gidderbaha",
  "B.K.M.College of Education, Balachaur",
  "UNIVERSAL INSTITUTE OF NURSING, BALLOPUR, LALRU",
  "GOVT COLLEGE SUKHCHAIN BALLUANA",
  "Khalsa College of Education, C-Block, Ranjit Avenue, Amritsar.",
  "KCL Institute of Law, Jalandhar.",
  "Jasmer Singh Jeji Degree College, Gurne Kalan, Munak, Sangrur",
  "Malwa College of Trainings and Education, Malakpur Khiala, Mansa",
  "Shiva College of Education, Dirba, Sangrur",
  "GOVT COLLEGE MAHAIN",
  "Govt. Ranbir College, Sangrur",
  "Mohan Lal  Uppal  D.A.V.College Phagwara",
  "Lincoln College of Education, Sirhind, Distt. Fatehgarh Sahib",
  "B.U.C. College,  Batala",
  "Baba Shri Chand Ji Govt. College, Sardargarh",
  "Doaba College Jalandhar",
  "Govt. Brijindra College, Faridkot",
  "Desh Bhagat Pandit Chetan Dev Govt. College of Education, Faridkot",
  "SSD Girls College of Education, Bhokra,Bathinda",
  "SANT KABIR COLLEGE ZIRA",
  "Surjeet Memorial College of Education, Malwal",
  "GRD College Co Edu,  Phagwara",
  "Govt. College Gurdaspur",
  "Asian Educational Institute, Sirhind Road, Patiala",
  "R.K. Arya College Nawan Shehar",
  "K.C. College of Education, NawanShehar",
  "Sant Ram S.D. College, Barnala",
  "Ramgarhia College of Education Phagwara",
  "Guru Tegh Bahadur College, Bhawanigarh, Sangrur",
  "Khalsa College of Education, Muktsar",
  "DRV DAV Centenary College Phillaur (Jalandhar)",
  "Innocent Heart College of Education, Green Model Town,  Jalandhar",
  "Doaba Khalsa trust group of Institutions, Chhokran",
  "Govt College, Hoshiarpur",
  "Maghi Memorial College for Women, Amloh, Fatehgarh Sahib",
  "GOVT COLLEGE HUSNAR GIDDERBAHA SRI MUKTSAR SAHIB",
  "DIPS Institute of Management & Technology, Jalandhar",
  "Lyallpur Khalsa College for Women Jalandhar",
  "CHANDIGARH LAW COLLEGE JHANJERI",
  "Saraswati Ayurved Hospital and Medical College Gharuan Distt Mohali",
  "SRI SUKHMANI COLLEGE OF LAW ",
  "Punjabi University Education Regional centre Bathinda",
  "APJ College of Fine Arts Jalandhar",
  "Government Institute of Pharmaceutical Sciences and Engg",
  "Kamla Nehru College of Education For Women, Phagwara",
  "JAIN COLLEGE OF PHARMACY",
  "CT College of Education Jalandhar.",
  "SPSK Khalsa College  Begowal  (Kapurthala)",
  "PUNJAB COLLEGE OF PHARMACY, BATHINDA",
  "Baba Hira Das Ji Ayurvedic Medical College and Hospital",
  "Nightingale College of Education",
  "Sri Guru RamDass College Of Education",
  "BHAI GURDAS INSTITUTE OF ALLIED SCIENCES SANGRUR",
  "NIRMAN CAMPUS OF EDUCATION RESEARCH AND TRAINING",
  "Saroop Rani Government College for Women, Amritsar",
  "SSS College of Edcuation ",
  "St. Soldier College Hadiabad (Phagwara)",
  "Tawi Engineering College",
  "DAN College of Edu. for Women Nawan Shehar",
  "SAI COLLEGE OF EDUCATION, SARDULAPUR",
  "MGSM Janta College Kartarpur",
  "Gulzar Group Of Institutions, Khanna",
  "BHAI BEHLO KHALSA GIRLS COLLEGE PHAFRE BAHI KE",
  "PCM SD College for Women Jalandhar",
  "GIAN JYOTI GIRLS COLLEGE GURTHARI ROAD SANGAT KALAN",
  "Asian College of Education, Vill Kasiana",
  "GANDHI MEMORIAL COLLEGE FOR WOMEN KOTHE KOTAPURA",
  "NAVJIVINI INSTITUTE OF SPECIAL EUCATION AND RESEARCH SULAR",
  "RRMK Arya Mahila Maha Vidyalaya Pathankot",
  "GLOBAL COLLEGE OF HIGHER EDUCATION NAGAL KHURD",
  "BABA PARMANAD KANYA MAHAVIDYALAYA, JAKHEPAL SUNAM",
  "Shree Atam Vallabh Jain College",
  "Gian Jyoti Institute of Management and Technology",
  "Dasmesh Girls College Chak Alla Baksh GT Road Mukerian",
  "MATA SITO DEVI COLLEGE OF EDUCATION,KOT DHARMU",
  "Malwa Central College of Education for Women, Ludhiana",
  "Sachdeva College of Pharmacy, VPO- Gharaun",
  "CT Institute of Management & Technology, Shahpur",
  "Guru Nanak Dev University College, Verka",
  "LYALLPUR KHALSA COLLEGE ",
  "S.G.T.B Institute of Management and IT, Bhogpur",
  "Montgomery Guru Nanak College of Education Jalandhar",
  "Lala Laj Pat Rai Institute  of Nursing, Moga",
  "Sri Ram College, Dalla",
  "Partap College of Education, Hambran Road",
  "Guru Hargobind College of Education,  Gondwal  Raikot",
  "Bhutta College of Education, Bhutta",
  "Mata Sundri Girls College of Education, Dhade",
  "UNIVERSITY COLLEGE TPD MALWA COLLEGE RAMPURA PHUL BATHINDA",
  "S.N. College Banga",
  "D.S DANI COLLEGE OF HIGHER EDUCATION , BARNALA",
  "SHIVALIK GIRLS COLLEGE, BHUCHO MANDI BATHINDA",
  "SACHDEVA GIRLS COLLEGE GHARUAN MOHALI",
  "Mata Gujri Memorial College of Education, Balwanda, Gurdaspur",
  "Indo Global College of Architecture, Abhipur",
  "Baba Kuma Singh Ji Engg. College, Hushair Nagar, Amritsar",
  "Aklia Education and Research Society Group of Institutions, Aklian",
  "Asra College of Engg. & Tech, Near Channo, Teh. Bhawani Garh",
  "Baba Farid College of Engineering& Technology, Bathinda",
  "BAHRA INSTITUTE OF PHARMACY",
  "BLM Girls College Nawan Shehar",
  "DOABA DEGREE COLLEGE VILL GHATAUR THE KARAR MOHALI",
  "Doaba Women Institute of Engg. & Technology",
  "Shree Hanumat Institute of Management and Technology",
  "Universal Institute of Management & Technology , Vill Ballopur, Lalru",
  "G.H.G.Khalsa College, Gurusar Sadhar",
  "Bharat Institute of Management Studies , Vill Khara Khurd",
  "Desh Bhagat Foundation gruoup of Institutions, Moga",
  "Ferozpur College of Engg. & Technology",
  "UNIVERSAL COLLEGE OF PHARMACY",
  "KCT COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Lala Lajpat Rai College of Pharmacy , Moga",
  "Lala Lajpat Rai Institute of Engg. & Tech., Moga",
  "Lala Lajpat Rai Memorial Institute of Management and Technology",
  "PUNJAB INSTITUTE OF TECHNOLOGY, NANDGARH",
  "Guru Nanak Govt. College Kala Afghana, Gurdaspur",
  "Ghubaya College of Engg. and Technology",
  "S.D College ofPharmacy, Barnala",
  "Sri Sukhmani Institute of Engg. and Technology, Dera Bassi",
  "SIGMA COLLEGE OF PARAMEDICAL AND TECHNICAL EDUCATION     ",
  "Shahzada Nand College. Maqbul Road, Amritsar",
  "Sewa Devi S.D.College  Tarn Taran",
  "Institute for Management Studies, IET Bhaddal",
  "S. Sukhjinder Singh Engg. & Tech College, VPO- Hayat Nagar",
  "S. Sukhjinder Singh Institute of Science & Tech, VPO- Hayat Nagar",
  "Swami Sarvanand Institute of Mangement and Technology",
  "Lajjiawati Jain Memorial  Nursing Institute, Barnala  Chowk, Raekot",
  "SARASWATI GROUP OF COLLEGES GHARUAN MOHALI    ",
  "Pathankot College of Education, Opp. Canada Palace Behind AB College Mammon, Pathankot",
  "Sri Guru Ram Das Institute of Medical Sciences & Research, VPO Vallah",
  "MATA SUNDARI UNIVERSITY GIRLS COLLEGE MANSA",
  "CT Institute of Pharmaceutical Sciences, Shahpur",
  "Ramgarhia College Phagwara",
  "MODERN COLLEGE ,BIR KALAN",
  "Homoeopathic Medical College, Hanumangarh Road, Abohar",
  "PANJAB UNIVERSITY CONSTITUENT COLLEGE ,DHARAMKOT,MOGA",
  "GGS College of Modern Technology, Kharar",
  "University College, Sikhwala, Muktsar",
  "Chandigarh School of Business, Jhanjeri",
  "Bagla Mukhi college of Education, Malout Road",
  "BATALA COLLEGE OF EDUCATION",
  "BABA MANGAL SINGH NURSING INSTITUTE, BARNALA ROAD, BUGHIPURA",
  "Swami Permanand Mahavidyalaya, Mukerian",
  "CHINTPURNI INSTITUTE OF NURSING, BUNGAL",
  "BHAI GURDAS INSTITUTE OF NURSING, SANGRUR",
  "Vidya Jyoti Educational Society, VPO-Gholu Majra",
  "RADICAL BUSINESS SCHOOL",
  "ML MEMORIAL COLLEGE OF PHARMACY,KILLI CHAHAL",
  "LORD SHIVA COLLEGE OF NURSING, HAMIRGARH",
  "Punjab College of Technical Education, Baddowal",
  "Innocent Hearts Group of Institutions",
  "DAV College, Hoshiarpur",
  "A & M Institute of Management & Technology, Pathankot",
  "K.C College of Engg. and Information Technology",
  "JIWAN JYOTI COLLEGE    ",
  "Chandigarh College of Hospitality, Landran",
  "GURU NANAK COLLEGE OF MANAGEMENT AND TECHNOLOGY FAZILKA ROAD MALOUT     ",
  "Jagat Sewak Khalsa College For Women, Amargarh",
  "GURU NANAK LAW COLLEGE    ",
  "Ramgarhia Institute of Engg. and Tech, Phagwara",
  "Shri Kalyan TT College, Jaipur",
  "Saini Adarsh PG Mahavidyayalay, Bandikui",
  "St. Wilfred's TT College, Jaipur",
  "SATGURU COLLEGE OF TECHNICAL EDUCATION",
  "SRI BALAJI COLLEGE ",
  "Government Ayurved Nursing Training Centre & Affilated Hospital, Ajmer",
  "Bhartiya Mahavidyalaya, Chitawa",
  "MAI KHADIJA INSTITUTE OF NURSING SCIENCES, JODHPUR",
  "G.T. Ayurved Unani Institute Research Centre Nursing Training Centre, Alwar",
  "Government College, Kuchera",
  "SINGHANIA LAW COLLEGE",
  "Dhanwantri Ayurved Nursing Training Centre, Sikar",
  "Dev College",
  "Biff & Bright T T College, Jaipur",
  "B.M. Education Foundation Trust Ayurved Nursing Training Centre, Pilani",
  "KANHA COLLEGE, RAMLIYAS",
  "RASHTRIYA MAHILA MAHAVIDYLAY DHANOTA JAIPUR",
  "Sevanand College",
  "NEHRU JYOTI YOGA COLLEGE",
  "Vinayak Girls College, Jaipur",
  "Chhatrapati Shivaji B.Ed. College, Jaipur",
  "Bright Moon B.Ed. College, Jaipur",
  "SMT  SUNDER DEVI MEMORIAL  COLLEGE GUDHANATHAWATAN ",
  "SHREE BALAJI MAHAVIDHLAYA , SADHSAR ",
  "SANSKAR COLLEGE NADBAI",
  "CLG DEGREE COLLEGE",
  "Bharti Bal Mandir Samiti, Ayurved Nursing Training Centre, Jaipur",
  "Balaji Sanskrit Mahavidyalaya",
  "Siddharth Shiksha Sansthan",
  "Arya TT College",
  "Parishkar Inst. of Edu., Jaipur",
  "SARASWATI P G COLLEGE BEENJHBAYALA",
  "AHDP DAG JHALAWAR",
  "Acharya Kalu Kanya Mahavidyalaya",
  "GOVERNMENT COLLEGE RAJALDESAR",
  "R R MAHAVIDYALAY , SEDVA",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE SRIGANGANAGAR",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE KARUNDA",
  "Late Moolchand Meena SHikshak Prashikshan Mahavi., Dausa",
  "Times Sanskrit TT College",
  "Akasha Deepa TT college",
  "Mewad TT College",
  "G.R. Memorial Shiksha Shastri Mahavidyalaya",
  "Pratibha Mahila Shikshak Prashikshan Mahavi., Jaipur",
  "ST MOTHER TERESA DEGREE COLLEGE",
  "Baba Narayandas Ayurved  Nursing Training Centre, Jhunjhunu",
  "J R COLLEGE UDAIPUR SISARMA",
  "Ambika Vikas Sansthan Ayurved Nursing Training Centre, Jodhpur",
  "Aditi Vikas Ayurved  Nursing Training Centre, Sikar",
  "Princess TT College",
  "SHRI KRISHAN AADRASH VIDHYA  MANDIR SAMITI MAHAPURA JAIPUR ",
  "Maharana Government Sanskrit PG college Udaipur",
  "MURLI SINGH YADAV MEMORIAL COLLEGE UDAIRAMSAR",
  "KAMAKSHA COLLEGE SAGWARA",
  "SHRI RAM COLLEGE  SIKAR ROAD JAIPUR ",
  "Vittalnath Sadasiva Patak Government Sanskrit PG college Kota",
  "Smt. Kunani Devi Mahila TT College, Jhunjhunun",
  "Government Sanskrit UG College Chechat",
  "J L N MEDICAL COLLEGE AND HOSPITAL, AJMER",
  "JAI BHARTI YOGA MAHAVIDHALAY JAIPUR ",
  "Bharat Mata T.T. College, Kishanganj, Baran",
  "ASIAN YOGA MAHAVIDHALAY JAIPUR",
  "P.L. Dubey Memorial Sanskrit TT College",
  "AHINSA YOGA MAHAVIDHYALAYA",
  "Deep Shikha Sansrit TT College",
  "LORD BUDDHA COLLEGE",
  "SHIVGYAN LIVESTOCK DIPLOMA TRAINING INSTITUTE",
  "Livestock Assistant Training College (AHDP 32)",
  "Choti Devi Memorial B.ed College",
  "Seema Shiksha Shastri and B.ed College",
  "Maharshi Womens TT College",
  "VIDHYASHRAM COLLEGE",
  "SHRI BALAJI YOG MAHAVIDHYALAYA CHOMU JAIPUR",
  "ROOPRAJ YOG SADHANA COLLEGE",
  "SHIVAM YOGA COLLEGE",
  "RCI COLLEGE BANSUR ALWAR",
  "Sri Dadu Sanskrit College",
  "Seth Shri Surajmal Tapadiya Sanskrit UG college",
  "GOVERNMENT GIRLS COLLEGE, BAR, RAIPUR ,PALI",
  "SERENITY COLLEGE FATEHGARH",
  "K R MAHAVIDHALYA LAKHANI RINGUS KHANDELA",
  "Shri Shastri TT College, Sikar",
  "GOVERNMENT COLLEGE KHAMNOR",
  "Dr. Ambedkar Mahavidyalaya",
  "BOMBAY INSTITUTE OF PHARMACY",
  "Baba Narayan Das P.G. College, Jaipur",
  "SHRI GIRDHARISINGH RAJVI MEMORIAL KANYA MAHAVIDHALYA GOGATIYA BAGHAWATAN",
  "SAMBAL SAMITI",
  "GYANDEEP MAHAVIDHYALYA, JAHAJPUR",
  "ST WILFREDS COLLEGE OF PHARMACY",
  "KALIKA GLOBAL DEGREE COLLEGE",
  "UDAIPUR COLLEGE OF YOGA",
  "S. K Greenwood College, Shekhabasni, Deedwana",
  "MAHADEV YOGA COLLEGE",
  "PHYSIOTHERAPY COLLEGE MAA GAYTRI SWASTHAYA AVM SHIKSHA SANSTHAN, UDAIPUR",
  "MAHARSHI VASHISTHA MAHAVIDYALAYA",
  "LZEBRA GIRLS COLLEGE 121 SHASTRI NAGAR, KOTA",
  "MAHARSHI GAUTAM T T COLLEGE VIR SAVARKAR NAGAR, KOTA",
  "ACHARYA NANESH T T COLLEGE ALANPUR, SAWAIAMDHOPUR",
  "THAKUR MADAN SINGH COLLEGE BAL MANDIR COLONY, SAWAIMADHOPUR",
  "DISHA YOGA COLLEGE",
  "GLOBAL COLLEGE ",
  "CHOUDHARY A R COLLEGE OF PHARMACY, SARDARSHAHAR, CHURU",
  "AISHWARYA COLLEGE OF EDUCATION, KHAS BAGH",
  "Jaswantpura College, Jaswantpura",
  "SHRI GYAN VIHAR MAHAVIDHYALAY",
  "YOGESHWARI JAN HITAY SEVAYATAN SANSTHAN AMLIPADA, SAJJANGARH",
  "Maa Bharti PG College, Mahaveer Nagar-III, Kota",
  "CAMBRIDGE MAHILA MAHAVIDYALAY BAREMR",
  "MAHALA INSTITUTE OF AYURVEDA",
  "NAVJEEVAN COLLEGE OF BSC  NURSING",
  "JAWAN MAHAVIDYALAYA",
  "GOVT  AYURVED COLLEGE JAIPUR ",
  "HADI RANI TEACHERS TRAINING COLLEGE, SHOBHAGPURA",
  "GOVT COLLEGE NADOTI, KARAULI",
  "College of Agriculture Sumerpur",
  "RAMDULARI T T COLLEGE HINDAUNCITY",
  "EXCELLENT LAW COLLEGE NAYAGAON BORABAS RAWATBHATA ROAD, KOTA",
  "JAMWAI KANYA MAHAVIDHYALAYA BAL MANDIR COLONY, SAWAIMADHOPUR",
  "MAHARAJA HAMMIR COLLEGE BAL MANDIR COLONY, SAWAIMADHOPUR",
  "DAV COLLEGE  RAISINGHNAGAR",
  "GANPATI INSTITUTE OF PHARMACY",
  "GOVERNMENT COLLEGE NANGAL RAJAWATAN",
  "Shri Shastri mahila TT College, Sikar",
  "GOVERNMENT COLLEGE BAGRU JAIPUR",
  "Shri Raghunath Shikshak Prashikshan Mahavi., Sikar",
  "MAHALA COLLEGE OF NATUROPATHY AND YOGIC SCIENCES",
  "BHARTI TEACHER TRAINNING MAHILA COLLEGE",
  "Shri Raghunath Girls College, Sikar",
  "Seth Ram Kishan Dhanuka Kanya Mavi., Sikar",
  "J D ARTS AND SCIENCE COLLEGE",
  "Sardar Patel Shikshak Prashikshan Mahavi., Sikar",
  "Ramprasad Bohara B.Ed. College, Jhunjhunun",
  "S.S. JAIN SUBODH MGT. INSTITUTE, JAIPUR",
  "Shekhawati Institute of Pharmacy",
  "Salasar Balaji Institute of Pharmacy",
  "GOVT COLLEGE KANWAS",
  "SAINIK DEFENCE COLLEGE",
  "ASTHA TEACHERS TRAINING COLLEGE ",
  "Sant Kabir P G Mahavidyalaya, Jaipur",
  "RAMKUMARI COLLEGE OF PHARMACY",
  "PSP COLLEGE OF EDUCATION",
  "SSS TT College, Jaipur",
  "GOVERNMENT NURSING COLLEGE, KOTA",
  "IBB COLLEGE OF PHYSIOTHERAPY, KOTA",
  "M D MISSION COLLEGE OF NURSING, KOTA",
  "OPERA COLLEGE OF NURSING, KOTA",
  "SETH G L BIHANI S D COLLEGE OF TECH EDUCATION, SRIGANGANAGAR",
  "Marigold B.Ed. College, Jaipur",
  "Sanskar Bharti P G COllege, Jaipur",
  "JAMBUKHAND TEACHER TRAINING INSTITUTE  ",
  "Shrimati Ramkumari TT College",
  "ENGINEERING COLLEGE KARAULI",
  "Shri Ganesha College of Education",
  "Tilak TT College for Women, Jaipur",
  "NATIONAL INSTITUTE OF ELECTRONICS AND INFORMATION TECHNOLOGY, AJMER",
  "Norangrama Dayanand Dookiya TT College",
  "Kala Bharti Girls College, Bharatpur",
  "Sawai Madhopur College of Engineering and Technology, Sawai Madhopur",
  "Ganpati T T College, Jaipur",
  "St. Wilfred College of Law, Jaipur",
  "S.N. College of Education",
  "Shri Bankey Bihari Mahavidyalaya, Nagar, Bharatpur",
  "Sankalp Veterinary & Animal Husbandry Institute (AHDP 28)",
  "Khairthal Pharmacy College",
  "SNEHDEEP INSTITUTE OF HOTEL MANAGEMENT AND SKILLS, GANGAPUR CITY",
  "SAINT MEERA UNNATI COLLEGE  NATHDWARA ",
  "JAMBHEWSHWAR TT COLLEGE RAMSAR BARMER",
  "LEO COLLEGE GHATOL",
  "SHAKTI YOG SADHANA KENDRA JAIPUR",
  "Shri Bankey Bihari Mahavidyalaya, Dhaulpur",
  "GULSHAN COLLEGE OF NURSING, SAWAIMADHOPUR",
  "RANTHAMBHORE COLLEGE OF NURSING, SAWAIMADHOPUR",
  "SHRI USB COLLEGE OF PHARMACY, SIROHI",
  "U S B COLLEGE OF NURSING, SIROHI",
  "RAMI DEVI COLLEGE OF NURSING, TONK",
  "KALPTARU COLLEGE OF BSC NURSING, UDAIPUR",
  "RAJASTHAN COLLEGE OF NURSING, JAIPUR",
  "RAWAT NURSING COLLEGE, JAIPUR",
  "SAINT FLORENCE COLLEGE OF NURSING, JAIPUR",
  "SAKET COLLEGE OF NURSING, JAIPUR",
  "SHREE RAM COLLEGE OF NURSING, JAIPUR",
  "SHRI RADHA RAMAN NURSING, JAIPUR",
  "S M S COLLEGE OF NURSING, JHALAWAR",
  "CHOUDHARY KANARAM DHAKA MEMORIAL NURSING COLLEGE, JHUNJHUNU",
  "RAJASTHAN COLLEGE OF NURSING, JHUNJHUNU",
  "MAYURAKSHI COLLEGE OF NURSING, JODHPUR",
  "SHREE LBS COLLEGE OF NURSING, JODHPUR",
  "SRI LAL BAHADUR SHASTRI COLLEGE OF NURSING, JODHPUR",
  "VYAS COLLEGE OF NURSING, JODHPUR",
  "ARIHANT COLLEGE OF NURSING, KOTA",
  "FLORENCE NURSING COLLEGE, KOTA",
  "KOTA COLLEGE OF PHARMACY, KOTA",
  "KUCHAMAN COLLEGE OF PHARMACEUTICAL SCIENCES, NAGAUR",
  "LAGAN SHAH MEMORIAL NURSING, NAGAUR",
  "SARVODAYA COLLEGE OF NURSING, NAGAUR",
  "SHRI SAWAI COLLEGE OF NURSING, NAGAUR",
  "R C MEMORIAL NURSING COLLEGE, PALI",
  "SMT DAKUBEN SAREMALJI SANCHETI NURSING INSTITUTEITUTE, PALI",
  "Shrinath Ji Institute of Pharmacy, Nathdwara, Rajsamand",
  "SRINATH B SC NURSING COLLEGE, RAJSAMAND",
  "AKHIL BHARTI VIDHYAPEETH, SIKAR",
  "ANNAPURANA MEDICAL TRAINING INSTITUTEITUTE, SIKAR",
  "MEWAR BSC NURSING COLLEGE, UDAIPUR",
  "SHRI BALAJI COLLEGE OF NURSING, UDAIPUR",
  "UDAIPUR COLLEGE OF NURSING, UDAIPUR",
  "SARVODAYA COLLEGE OF PARAMEDICAL AND NURSING EDUCATION, KOTA",
  "SUDHA COLLEGE OF NURSING, KOTA",
  "ARAWALI COLLEGE OF NURSING, SIKAR",
  "GOENKA COLLEGE OF PHARMACY, SIKAR",
  "KHAWAJA GARIB NAWAZ COLLEGE OF NURSING, SIKAR",
  "RAJASTHAN COLLEGE OF NURSING, SIKAR",
  "SUNRISE COLLEGE OF NURSING, UDAIPUR",
  "VEDANSHI COLLEGE OF NURSING, UDAIPUR",
  "PARMANAND COLLEGE OF TECHNOLOGY, SRIGANGANAGAR",
  "Jai Narayan Vyas Women T.T. College",
  "MAA GAYATRI BSC NURSING COLLEGE, UDAIPUR",
  "RNT MEDICAL COLLEGE, UDAIPUR",
  "SAGAR COLLEGE OF BSC NURSING, UDAIPUR",
  "SARASWATI COLLEGE OF NURSING, UDALPUR",
  "BHARTI INSTITUTEITUTE OF PHARMACEUTICAL SCIENCE, SRIGANGANAGAR",
  "GURUKUL COLLEGE OF PHARMACY, SRIGANGANAGAR",
  "JUBIN COLLEGE OF POST BASIC BSC NURSING, SRIGANGANAGAR",
  "S N COLLEGE OF NURSING, SRIGANGANAGAR",
  "Shri Radha Krishan Edu. Inst., Bharatpur",
  "Shri Sanskar TT College, Jaipur",
  "Ananta Institute of Medical Sciences and Research Center",
  "Bharti Vidyapeeth T T College, Jaipur",
  "Alankar Mahila B.Ed. College, Jaipur",
  "CKRD MEMORIAL PHARMACY COLLEGE",
  "Sadguru Institute of Professional Education, Jaipur",
  "Aadarsh Mahavidyalaya, Jaipur",
  "SANTOSH YOGA MAHAVIDHYALAYA",
  "SADHNA YOG MAHAVIDHYALAYA KHANNIPURA",
  "Khoj TT College, Jaipur",
  "Poddar International College, Jaipur",
  "AGRANI COLLEGE OF PHARMACY ",
  "Shri Mangal Maila Mahavidyalaya, Jaipur",
  "SHRIMATI PANADEVI MORIJAWALA RAJKIYA KANYA MAHAVIDYALAYA, KOTPUTLI, JAIPUR",
  "Shrimati Mohari Devi Tapadiya Sanskrit TT College",
  "SANT SHRI KISHNARAM MAHAVIDYALAY HINGLAJ NAGAR SANCHORE",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, JODHPUR",
  "Sri Rama Vaikunt Sanskrit PG College",
  "Stani Memorial PG College, Jaipur",
  "Madhay Mahavidhyalaya, Dausa",
  "Sri Sarveshwar Sanskrit UG college",
  "Prashasvi TT College",
  "SMT SAROJ DEVI COLLEGE JARGA BASERI DHOLPUR RAJSTHAN",
  "BSN COLLEGE OF EDUCATION",
  "PINUS REGIONAL COLLEGE",
  "Rawat Mahila B.Ed. College, Jaipur",
  "GOVT COLLEGE MANIA DHOLPUR",
  "Astha Colege of Edu., Jaipur",
  "J.V.M. Girls College, Jaipur",
  "Deepshikha TT College, Jaipur",
  "NEW RAVINDER YOGA MAHAVIDHYALAYA ",
  "Sambal College of Edu., Sikar",
  "Salasar Balaji B.Ed. College, Sikar",
  "Navjyoti Shikshak Prashikshan Mahavi., Sikar",
  "TECHNOLOGY PARK YOGA TEACHER TRAINING COLLEGE BHARATPUR",
  "GANDHI BADHIR MAHAVIDHYALAYA, JODHPUR",
  "CENTRAL ACADEMY INSTITUTE OF HIGHER EDUCATION",
  "AJMER GIRLS COLLEGE ",
  "Shri Shastri Mahila Mahavi., Sikar",
  "Shri Bhawani Niketan TT College, Jaipur",
  "Amer Maharaja College, Jaipur",
  "GOVT COLLEGE MASALPUR",
  "GOVT COLLEGE BAGDI",
  "ACHARYA TULSI PHARMACY COLLEGE RANAWAS PALI",
  "GOVERNMENT COLLEGE, KANOTA, JAIPUR",
  "Rajasthan Shikshak Prashikshan Vidyapeeth, Jaipur",
  "Shri Veer Tejaji College, Jaipur",
  "IRIS College, Jaipur",
  "SARSWATI COLLEGE OF EDUCATION UNDU",
  "APEX LAW COLLEGE, MAKRANA ",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE BARAN",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE, NAREDA",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE BUNDI",
  "RAJASTHAN YOGA MAHAVIDHYALAY, KUNDA,AMER",
  "RS YOGA TT COLLEGE KURGAON KARAULI",
  "GOVT SHASTRI SANSKRIT COLLEGE SIWADA CHOUHAN JALORE",
  "MARUDHAR INSTITUTE OF PHARMACY, CHURU",
  "SANSKAR COLLEGE BAJJU",
  "SHRI BALAJI INSTITUTE OF PHARMACY, SANTHALPUR, BANSUR",
  "MATA SARBATI DEVI KANYA MAHAVIDHYALAYA",
  "Shradha Nath TT College",
  "St. Xavier's College Jaipur",
  "Shri Bhawani Niketan Law College, Jaipur",
  "Smt. Anar Devi T T College, Jaipur",
  "SCHOOL OF ARCH. APEX GROUP OF INSTITUTIONS, JAIPUR",
  "Shri Krishna Law College, Jaipur",
  "Sri Govardhan Sanskrit PG college",
  "MOTHER INDIA SHIKSHA SHASTRI MAHAVIDYALAYA",
  "Vardha College of Education",
  "Birbal Memorial TT College",
  "Viswha Bharati Shiksha Shastri Mahavidyalaya",
  "Shri Ana Sagar Mahila Shiksha Shastri Mahavidyalaya",
  "Rajasthan Shikshaka Prashikshana Mahavidyalaya",
  "Govt. Law College, Alwar",
  "Shri Narayan Teachers Training School, Kuchaman City",
  "Government Sanskrit College, titariya",
  "Government Sanskrit PG college Talavgoan",
  "Universal College, Dausa",
  "Mahatma Gandhi College of Edu., Jaipur",
  "Prasasvi TT College, Dausa",
  "J B International College, Jaipur",
  "Supreme Mahavidyalaya, Jaipur",
  "Saint Soldier Mahila Mahavidyalaya",
  "EMINENT GIRLS COLLEGE",
  "SARASWATI SHIKSHAN SANSTHAN COLLEGE OF ARTS AND SCIENCE",
  "Aryan International College",
  "AASHIRWAD COLLEGE, BITHARI, PHALODI, JODHPUR ",
  "Maharishi Dayanand Law College, Jaipur",
  "GURUKUL COLLEGE , RAIPURA, RANOLI",
  "Shri Shirdi Sai Baba Ayurved College and Hospital, Mundiyagarh, Kishangargh Renwal",
  "Kanoria P G Mahila Mahavidyalaya, Jaipur",
  "Kautilya Mahavidhyalaya, Rawat Bhata Road, Nayagaon, Kota",
  "Dr. Radhakrishanan Integrated College",
  "Shri Agarsen Mahila T.T. College, Hindauncity",
  "Tagore Girls College of Arts & Sci., Jhunjhunun",
  "INDIAN COLLEGE OF PHARMACY",
  "PRIMEROSE COLLEGE OF PHARMACY ",
  "Smt. Manbhari Devi PG College, Jhunjhunun",
  "ARYA NARAYANI DEVI MAHAVIDYALAYA",
  "SUNRISE COLLEGE OF PHARMACY",
  "NAVJEEVAN MAHAVIDYALAY",
  "SHRI KALYAN MAHAVIDHYALAYA, RENWAL MANJI, JAIPUR",
  "Satguru College, Lamba Kotra",
  "Shri Nawalgarh PG Mahila Mahavi., Jhunjhunun",
  "Shri LBS Kanya PG Mahavi., Sikar",
  "Shri Balaji College, Sikar",
  "Shikshak Prashikshan Mahavi., Jhunjhunun",
  "Maa Jalpa Devi Government College, Taranagar",
  "SUPREME PHARMACY COLLEGE HINGONIYA  JAIPUR",
  "Government College, Bhinai",
  "Seth Gangadhar Shiv Bhagwan Patwari College, Jhunjhunun",
  "SBS Memorial TT College, Sikar",
  "Mahatma Gandhi TT College, Sikar",
  "Khandela Sah Shiksha Mahavi., Sikar",
  "B S Memorial B.Ed. College, Sikar",
  "Arawali PG College, Sikar",
  "Sant Jogendra TT College, Jaipur",
  "Vivekanand Girls PG College, Jaipur",
  "Mahatma Jyoti Rao Phoole Women's B.Ed. College, Jaipur",
  "Eashwaramma Shikshak Prashkshan Mahavi., Jaipur",
  "Sri Sathya Sai College for Women, Jaipur",
  "Savitri Bai Phule Shikshak Prashikshan Mahila Mahavi., Jaipur",
  "SWARGIYA RAJESH PILOT GOVERNMENT COLLEGE BANDIKUI (DAUSA)",
  "Bandhu Balika Mahavidyalaya, Sikar",
  "BHARTI PHARMACY COLLEGE",
  "NIMT COLLEGE OF AYUSH NURSING AND PHARMACY",
  "Gurukul Keshari Mahavidyalaya, Bandanwara",
  "B K Birla Institute of Higher Education, Pilani",
  "Khoj Mahavidyalaya, Jaipur",
  "RAMSEEN COLLEGE,RAMSEEN",
  "Prabhashankar Pandya T.T. College",
  "INDIRA GANDHI MEMORIAL DEGREE COLLEGE",
  "C.T.E. (College For Teacher Education) B.Ed. College Bhinmal, Jalore",
  "GOVERNMENT COLLEGE ASNAWAR",
  "Shri Radhe Patel Dgree College, Bharatpur",
  "Government College, Gangapur",
  "GURUKUL COLLEGE, SALUMBAR",
  "GOVT COLLEGE RAMGARH",
  "Seth Netram Maghraj Tiberawala Government Girls College, Jhunjhunu",
  "KASTURI DEVI COLLEGE, DATWAS",
  "Government Girls College, Ajmer",
  "R S COLLEGE OF EDUCATION",
  "Government Girls College, Didwana",
  "Government College, Jahazpur ",
  "Sanskar Girls College Kapren",
  "B.R. MAHAVIDYALAY",
  "OM SHIV SANSTHAN TEACHER TRAINING COLLEGE",
  "SHRI KANIRAM PHARMACY COLLEGE DHORIMANA",
  "Vivekanand Kanya Mahavidyalaya, Dhaulpur",
  "Government College, Kareda",
  "G B College, Bharatpur",
  "Supreme Bal Bharti TT College, Jaipur",
  "S.J. College, Jaipur",
  "Vivekanand College",
  "Rawat Mahila Mahavidyalaya, Jaipur",
  "Parishkar College of Global Excellence, Jaipur",
  "Advait Mahila Mahavidyalaya, Dausa",
  "GOVT COLLEGE KATHUMAR ALWAR",
  "Aadarsh B.Ed. College, Jaipur",
  "TOP CAREER COMPUTERS, JHALAWAR",
  "Times Pharmacy College",
  "Maharshi Dayanand B.Ed. College, Jaipur",
  "KMD Memorial College of Edu., Jaipur",
  "Shri Bhawani Niketan P G Boys College, Jaipur",
  "Raj Shree Mahila TT College, Jaipur",
  "TRINITY TEACHER TRAINING COLLEGE",
  "Vinayak B.Ed. College, Jaipur, Jaipur",
  "Sahid Ramkesh Meena Government College, Sikrai (Dausa)",
  "S.M.C.C. Government College Aburoad",
  "S.S. College, Jaipur",
  "AGARWAL GIRLS COLLEGE",
  "MAMA BALESHWAR DAYAL GOVERNMENT COLLEGE KUSHALGARH",
  "Pannadhay Evening College",
  "Govt. Lohia College, Churu",
  "SANTOKBA DURLABHJI COLLEGE OF NURSING",
  "SAPTRISHI MAHAVIDHYALAYA DAUSA",
  "VEDANT SIKSHAN PRASIKSHAN MAHAVIDAYALAYA,CHHATTARGARH",
  "SHRI SHYAM CO-EDUCATION COLLEGE",
  "Bagru Mahila Mahavidyalaya, Jaipur",
  "SARASWATI MAHAVIDYALAYA SETRAWA DECHU",
  "Mahila Mahavidyalaya, Dausa",
  "CHOUDHARY K R  GODARA MEMORIAL COLLEGE BASHEER TIBBI",
  "Jaipur National University Institute for Medical Sciences and Research Centre",
  "SHRI MOTI MEMORIAL MAHAVIDHALAYA",
  "MAHADEV COLLEGE OF EDUCATION",
  "Shri Bharti Shikshak Prashikshan Mahavi., Jaipur",
  "Shri Minesh Mahavidyalaya, Jaipur",
  "Sumitra Memorial TT College, Sikar",
  "Nalanda Carier Academy Kanya Mahavidyalay",
  "SPR COLLEGE",
  "MATA BHAGWATI DEVI DEV SANSKRITI MAHILA KRISHI MAHAVIDHALAYA",
  "AMRITUM TEACHER TRAINING COLLEGE, BATAWADI",
  "Smt.Manbhari Devi TT College, Jhunjhunun",
  "Smt. Asha Devi PG Mahavi., Sikar",
  "Shri Madhukar Shyam PG Mahavi., Jhunjhunun",
  "Shri Chavo Veero Balika PG Mahavi., Jhunjhunun",
  "Rajasthan TT College., Jhunjhunun",
  "NORTHERN INSTITUTE OF PHARMACY AND RESEARCH",
  "LIVESTOCK RESEARCH STATION NOHAR HANUMANGARH ",
  "Prabha Mahavi., Sikar",
  "Poonam Balika Mahavi., Jhunjhunun",
  "Mandawa College, Jhunjhunun",
  "Nehru Memorial Law P.G. College",
  "SURYODAY EDUCATION GROUP",
  "SETH C.L. SOMANI (P.G.) COLLEGE, RAWATSAR",
  "K S Bhaskar College, Jhunjhunun",
  "Jai Shri Dayal TT Colege, Sikar",
  "VEER AKLAVYA COLLEGE, JOULANA",
  "Rajasthan Swayat Shasan Mahavidyalaya, Jaipur",
  "Shankara Mahavidyalaya, Jaipur",
  "Shri Maharaja Vinayak Mahavidyalaya, Jaipur",
  "BALAJI COLLEGE OF NURSING, BHILWARA",
  "Shaurya Edu. Inst., Bhartpur",
  "MANDA COLLEGE, RAISAR",
  "RRB DEGREE COLLEGE",
  "POOJA COLLEGE, DHAKAWALA",
  "Government Veerbala Kalibai Girls College, Dungarpur",
  "J R COLLEGE , PHALISIA",
  "MAHARAJA AGRASEN COLLEGE OF PHARMACY NAGAR",
  "SHRI AGRASEN KANYA MAHAVIDHYALAYA BAYANA BHARATPUR",
  "Swami Laltanand Pashu palan Vidyalaya (AHDP 11)",
  "G.D. Memorial College, Sector-4, Kudi Bhagtasni Housing Board, Jodhpur",
  "Shah Goverdhanlal Kabra Teachers College ,Umaid Hospital Road ,Jodhpur",
  "Vyas College of Commerce, Sardarpura 1-A Road, Jodhpur",
  "Shri Lal Bahadur Shastri Women Teachers Training College, 357, Laxmi Nagar, Jodhpur",
  "Holy Sprite Institute of Technology, Science & Research College, Paota-C- Road, Jodhpur",
  "Vyas, B.Ed. College, Near Kudi Haud, Jodhpur",
  "SHRI ROOPRAM SWAMI LAW COLLEGE NOHAR",
  "Mahila Mahavidyalaya ,Kamala Nehru Nagar ,Soor Sagar Road ,Jodhpur",
  "B R KHOKHAR MEMORIAL SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA",
  "SARASWATI TEACHER TRAINING COLLEGE",
  "MC BHASKAR COLLEGE SULTANA JJN",
  "Choudhary Yoga Institute Rajgarh",
  "Sangh Mitra Teachers Training College, Mandal Nath Choraha, Jodhpur",
  "Shri R. N. Memorial Women Teachers Training College, Madhuban, Basani, Jodhpur",
  "Umrao B.Ed. College, Banar Road, Jodhpur",
  "Apex college of Pharmacy",
  "Gomi Devi Women Teachers Traning College, Kudi Bhagtasani Housing Board, Jodhpur",
  "Gurukul Institute of Commerce and Advance Courses, Opp. N.S. Garden , Pal Road, Jodhpur",
  "Kumodini Mahila Shikshak Prakshishan Mahavidyalaya. Sector-B, Bhagwati Colony,Near PWD, Jodhpur",
  "PRAGATI MAHILA COLLEGE PATAN",
  "NIRMAL SPECIAL SHIKSHAN PRASHIKSHAN MAHAVIDAYALAYA MUNDERI TEH ASNAWAR DIST JHALAWAR",
  "Saraswati Mahavidhyalaya, Dausa",
  "RAJDHANI COLLEGE NARAYANPUR",
  "BARJI DEVI MAHILA SHIKSHAK PRASIKSHAN MAHAVIDYALAYA",
  "Trinity Women Teachers Training College, 1st Tilak Nagar, Bhadwasia Road, Jodhpur",
  "AGRASEN COLLEGE",
  "GOVERNMENT COLLEGE RADAWAS",
  "GOVT COLLEGE FATEHGARH",
  "DHATTARWAL BA BED BSC BED COLLEGE",
  "GLM COLLEGE KISHANGARH BAS",
  "S.D.T.T.COLLEGE",
  "Research Education  and Audiological Development Society",
  "Suyash T.T. College",
  "LAL BAHADUR SHASTRI INSTITUTE OF COMPUTER SCIENCE PRATAPGARH",
  "Gurukul Mahavidyalaya, Maulasar",
  "CHANDRAWATI GURUKUL GIRLS T T COLLAGE VAMANPURA BHARATPUR",
  "MAA BHARTI MAHAVIDHYALYA",
  "Mayur College, Degana",
  "Nirmla Kothari Teachers Training College, Sawar",
  "Atamanand Teachers Training College, Ayurvedic College Road, Jhalamand Circle, Jodhpur",
  "Punit Teacher Training College, Pansal",
  "D.R.MEMORIAL COLLEGE BORANADA",
  "S B S COLLEGE PAHARSAR NADBAI BHARATPUR  (RAJ)",
  "KARMA BAI MAHAVIDHYALAY KHERAPA",
  "government college pindwara",
  "ROYAL RAJASTHAN COLLEGE, BHINMAL ",
  " GOVT. GIRLS COLLEGE, RAJSAMAND",
  "SHIV NARAYAN CHOUBISA COLLEGE",
  "L.B.S. T.T. COLLEGE GANODA",
  "SURAJ KARAN GANGA VISHAN MAHAVIDHYALAY VEDIYA  JALORE",
  "DR. CHAUDHARY COLLEGE OF NURSING",
  "ARAVALI COLLEGE",
  "NEW LOOK GIRLS COLLEGE,SAGWARA",
  "GOVT. COLLEGE LASADIYA ",
  "NEW LOOK GIRLS T.T. COLLEGE,PARTAPUR",
  "Adarsh Mahavidyalaya, 2-nd, Kamala Nehru Nagar, Chopasani Road, Jodhpur",
  "Surendra College of Animal Husbandry (AHDP 27)",
  "PRATAP COLLEGE",
  "DIYA INSTITUTE OF SPECIAL EDUCATION AND RESEARCH",
  "Dr. Radha Krishnan Women Tearchers Training College, Mathania Road, Daizer, Jodhpur",
  "R.S. Mahila Teachers Training College, 4th Road,  Shakti Nagar, Paota C-Road, Jodhpur",
  "Thomas Cangon Teachers Training College, Radhe Krishna Puram, Chokha Road, Jodhpur",
  "Mahila Vidhi Mahavidyalaya, Kamala Nehru Nagar, Soor Sagar Road, Jodhpur",
  "Maulana Azad Muslim Tearchers Training College, Pal Link Road ,Kamla Nehru Nagar, Jodhpur",
  "Ma Saraswati B.Ed. College, 6/44, Kudi Bhagtasni Housing Board , Jodhpur",
  "Agrawal Evening College, Jaipur",
  "Shri Pustikar Shri Purohit Surajraj Roopadevi Smriti Mahila Mahavidyalaya, Siwachi Gate, Jodhpur",
  "Kailash Trivedi Government Girls College, Gangapur",
  "Shanti Devi B.Ed. College, 78, Laxmi Nagar, Paota C-Road, Jodhpur",
  "GOVERNMENT COLLEGE OF NURSING JAISALMER",
  "Mayurakashi Teachers Training College, Mandal Nath Choriya, Jodhpur",
  "S.K. Greenwood Shikshak Prashikshan Mahavidyalaya, Shekhabasni, Deedwana",
  "MOTI LAL DAVE T.T. COLLEGE METWALA",
  "MANGALYAM DRISHTI GIRLS COLLEGE",
  "Kanchan Devi Shikshahk Prashikshan Mahavidyalaya",
  "Jai Marudhar Kesari B.Ed. College, Merta City",
  "Saini Mahavidhyalaya Jaitaran ",
  "LAL BAHADUR SHASHTRI MAHAVIDHYALAYA BILANDERPUR SHAHPURA JAIPUR",
  "GOVERNMENT LAW COLLEGE DAUSA",
  "GAURAV T T COLLEGE",
  "KRISHNA YOGA INSTITUTE RAJGARH ALWAR",
  "government college mavli",
  "SHREE RAM YOG SADHANA COLLEGE NAYLA BASSI JAIPUR",
  "JMK SHIKSHAN SANSTHAN",
  "S V COLLEGE OF SPECIAL EDUCATION RUN BY SHANESHWARAM MANAV SEVA SAMITI",
  "RAGHUKUL COLLEGE JODHPUR",
  "MAA GAYATRI MAHAVIDHYALAY CHAUMAHLA",
  "SHRI SAWAI LAW COLLEGE DIDWANA",
  "Suratgarh P.G. College",
  "Prabhakar Degree College, Merta City",
  "Acharya Shri Tulsi Amrit Mahavidyalaya, Gangapur",
  "Veer Teja Mahila Shikshan & Shodh Sansthan, Mundwa",
  "MAHATMA GANDHI B.SC NURSING COLLEGE",
  "Ch. Mani Ram College of B.Ed.",
  "Dakha Devi Mahavidyalaya, Dausa",
  "Shri Parshu Ram College, Dungarana",
  "SARASWATI MAHAVIDHYALAY LAMBORE BARI RAJGARH CHURU",
  "MAHARSHI DAYANAND SARASWATI NURSING COLLEGE",
  "Prince Mahila Mahavidyalaya, Makrana",
  "MODERN COLLEGE",
  "P R Memorial College",
  "MAHARISHI SANDEEPANI YOGA COLLEGE",
  "SAWAMI VIVEKANAND COLLEGE KOTA",
  "Marwar Mahavidyalaya, Degana Junction",
  "Geetanjli B.Ed. College, Borawar",
  "Sarvodaya Shikshak Prashikshan Mahavidyalaya, Chenar",
  "Kanya Mahavidyalaya, Niwai",
  "Matribhoomi Degree College, Borawar",
  "Indira Professional Sansthan, Gulabpura",
  "Shri Shiv Charan Mathur Government College, Mandalgarh",
  "Dev Kanya Shikshak Prashikshan Mahavidyalaya, Deoli",
  "Agarwal Shikshak Prashikshan Mahavidyalaya, Merta City",
  "SHRI BALAJI COLLEGE OF PHARMACY",
  "Green Valley College of Education",
  "Seth Phool Chand Chhitarmal Jain Mahavidyalaya, Pisangan",
  "Seema Memorial Mahavidyalaya, Parbatsar",
  "Gayatri Shaktipeeth Kanya Mahavidyalaya, Pushkar",
  "SHREE SAI COLLEGE OF PHARMACY ",
  "GOVERNMENT AGRICULTURE COLLEGE, TARANAGAR CHURU",
  "FRAME COLLEGE OF PHARMACY",
  "Sophia Girls College",
  "Bliss College of Higher Education, Todaraisingh",
  "Maharshi Dayanand Sarswati Kanya Mahavidyalaya ",
  "MATA KITAB KAUR MAHAVIDYALYA",
  "S B S DEGREE COLLEGE",
  "B R Mirdha Government College",
  "BABA KAMALDAS GIRLS COLLEGE HANTRA NADBAI BHARATPUR",
  "Sunder Sanskit TT College",
  "Sainik College, Ladnun",
  "SKARAN INSTITUTE OF PHARMACY",
  "GODARA COLLEGE OF PHARMACY, NOHAR",
  "ADVENT COLLEGE OF PHARMACY",
  "SHRI MATASYA COLLEGE OF PHARMACY",
  "SHRI HARI ADARSH MAHAVIDYALAYA BORUNDA JODHPUR",
  "Arawali College Of Science And Arts ,Kathumar",
  "BALAJI COLLEGE JALORE",
  "NAVKAR TEACHERS TRAINING COLLEGE,BHADEAR",
  "Shri Onkar Singh Memorial Women Teachers Training College",
  "Rajeev Gandhi Mahavidyalaya, Kookar",
  "Samrat Prithviraj Chauhan Government College",
  "SWAMI BHASKARANAND PASHUDHAN SAHAYAK PRAKSHIKSHAN SANSTHAN ROOPVAS",
  "GOVERNMENT COLLEGE OF NURSING, JAIPUR",
  "SANSKRITI COLLEGE",
  "MAA BHAGWATI COLLEGE",
  "Sevanand Mahavidyalaya, Niwai",
  "Star Infotech College",
  "SHIVAJI MAHAVIDHYALAYA",
  "Swami Vivekanand Shikshak Prashikshan Mahavidhyalaya, Roopangarh",
  "PIONEER COLLEGE GARHI",
  "Shri Kalyan Women Teachers Training College",
  "Marwar Mahavidyalaya, Kuchaman City",
  "Government College, Manglana",
  "Engineer Rahul Mirdha Memorial Mahavidyalaya, Junjala, Jayal",
  "Sambhal College of Education",
  "Government College, Mangrol",
  "Government College, Kekri",
  "Government College, Malpura",
  "Shri Jain College, Kekri",
  "Shri Gandhi Kanya Mahavidyalaya, Gulabpura",
  "GOVT YOG AND NATUROPATHY COLLEGE KOTA",
  "SORABH COLLEGE OF TEACHER TRAINING  MASALPUR KARAULI",
  "Maa Saraswati Shikshak Prashikshan Mahavidyalaya",
  "COLLEGE OF DAIRY SCIENCE AND TECHNOLOGY BIKANER    ",
  "NAVJYOTI COLLEGE OF SPECIAL EDUCATION, HANUMANGARH (RJ121)",
  "Shaheed Bhagat Singh Law College,Hanumangarh",
  "BHAWANI NIKETAN GIRLS COLLEGE RAWATSAR",
  "MANASVI AAYUSH NURSING COLLEGE",
  "SOBHASARIA COLLEGE",
  "S.B.N. College, Near Court, Shrimadhopur",
  "Shree Ram TT Coolege, Sikar",
  "CH MANIRAM COLLEGE OF HIGHER EDUCATION",
  "Rajeev Gandhi Shikshak Prashikshan Mahavidyalaya, Kookar",
  "COLLEGE OF TECHNOLOGY AND ENGINEERING",
  "GRAMOTTHAN MAHILA MAHAVIDYALAYA ,MEGA HIGHWAY,PARIHARA,RATANGARH",
  "SHOURABH COLLEGE OF VETERINARY SCIENCE",
  "SAMBAL MAHAVIDYALAYA",
  "shree swaminarayan bsc college",
  "PARMANAND TRILOKCHAND YOGA INSTITUTE",
  "GOVERNMENT COLLEGE LOSAL",
  "K C P SPECIAL EDUCATION TEACHER TRAINING COLLEGE",
  "M I DEGREE COLLEGE",
  "MAHATMA GANDHI LIVESTOCK ASSISTANT DIPLOMA TRAINING INSTITUTE",
  "GOVERNMENT COLLEGE OF NURSING SIROHI",
  "SHREE P R MEMORIAL COLLEGE OF PHARMACY",
  "GOVT COLLEGE OF NURSING JHUNJHUNU",
  "RAWAT PHARMACY COLLEGE",
  "SHRI DADHIMATI MAHAVIDYALAYA",
  "OM SHIV SANSTHAN PHARMACY COLLEGE MANGALWAD",
  "UMEED COLLEGE, LANGOD DEGANA",
  "SMT GOMATI DEVI YOGA OR NATURAL THERAPY COLLEGE BARAGAON",
  "SMT BHIKHI DEVI GEWARCHAND JI JAIN COLLEGE MANDAWALA JALORE",
  "MUSKAN COLLEGE OF PHARMACY",
  "Apex Institute of Manag. & Science (Dept. of Animal Husb.) (AHDP 16)",
  "B LAL INSTITUTE OF PHARMACY, DANTA, SANCHOR",
  "Rekha Devi Memorial T.T. Institute, Malpura",
  "SUNRISE COLLEGE OF EDUCATION, KISHANGARH RENWAL JAIPUR",
  "GOVERNMENT COLLEGE BASAI NAWAB DHOLPUR",
  "M.B.R. Government College, Balotra",
  "PANDIT DEENDYAL UPADHYAYA MEDICAL COLLEGE CHURU",
  "Shri Rana Mahila Teachers Training College, Borawar, Makrana",
  "JAWAHAR LAL NEHRU DEGREE COLLEGE OF SCIENCE SANGOD, KOTA    ",
  "FATEHPUR MAHAVIDYALAYA",
  "BANSAL COLLEGE OF HIGHER EDUCATION",
  "Government Medical College",
  "COLLEGE OF FISHERIES",
  "CAPTAIN SHREYANSH KUMAR MEMORIAL DEGREE COLLEGE RANJEETPURA KOLAYAT",
  "GOVERNMENT COLLEGE LAXMANGARH ",
  "Apollo College of Veterinary Medicine (CV:04)",
  "Government Law College",
  "CHOUDHARY CHARAN SINGH T T COLLEGE",
  "GOVERNMENT MEDICAL COLLEGE SRI GANGANAGAR",
  "Mastya College, Dausa",
  "Thakur Durgpal Singh Memorial B.Ed. College, Alwar",
  "Ryan College  for Higher Education, Jandawali",
  "Swami Shiksha Samiti Pashudhan Sahayak",
  "ANEKANT SEVA SANSTHN  TEACHERS TRAINING COLLEGE, ANEKANT NAGAR, INTALI KHERA ROAD, SALUMBER",
  "Sardar Ballabhbhai Patel Animal Husbandry College",
  "Vaidehi Devi Mahila TT College, Alwar",
  "Government Medical College Barmer",
  "Shivam College of Animal Husbandry (AHDP 20) ",
  "Vaidik Shikshak Prashikshan Mahavi., Alwar",
  "VAISHNAVI COLLEGE, KATHUMAR",
  "SWAMI VIVEKANAND B.Sc.NURSING COLLEGE",
  "SHEKAHWATI PHARMACY COLLEGE KHINWASAR",
  "Vivekanand Girls TT College, Alwar",
  "Shri Radha Govind Government College, Kanwar Nagar, Brahmpuri, Jaipur",
  "GOVERNMENT COLLEGE KALWAR JAIPUR    ",
  "IDEAL MAHAVIDHYALAYA",
  "AMAN PHARMACY COLLEGE DHOLAKHERA UDAIPURWATI JHUNJHUNU",
  "SHRI RAMPRASAD BOHARA P.G. COLLEGE ,BUHANA",
  "University Maharani's College, Jaipur",
  "PRERNA GIRLS COLLEGE SAHAWA",
  "B.R.CHOUDHARY COLLEGE",
  "JHALAWAR NURSING COLLEGE",
  "KKC COLLEGE OF PHARMACY",
  "OM SHIV PHARMACY COLLEGE SAGWADIYA NIMBAHERA",
  "DHOLAPLASH PHARMACY COLLEGE",
  "HOPEWELL PHARMACY COLLEGE",
  "PRINCE COLLEGE",
  "SBM LADDHA COLLEGE FOR HIGHER EDUCATION AND RESEARCH",
  "GOVERNMENT COLLEGE SANGARIA",
  "GOVERNMENT GIRLS COLLEGE PILIBANGA",
  "GEVERNMENT COLLEGE PALLU",
  "GOVERNMENT GIRLS COLLEGE, BAJJU",
  "GOVERNMENT COLLEGE MOMASAR, SHREEDUNGARGARH, BIKANER",
  "GOVERNMENTCOLLEGE GANGASHAHAR",
  "GOVT GIRLS COLLEGE, MDV NAGAR, BIKANER",
  "GOVERNMENT GIRLS COLLEGE, NAGARFORT",
  "University Law College Ist, Jaipur",
  "GOVERNMENT COLLEGE, LOONWA",
  "Government College, Kuchaman City",
  "Government Girls College, Degana",
  "GOVERNMENT COLLEGE, CHHOTI KHATU",
  "RAJIV GANDHI MAHAVIDYALA T T AMARWASI",
  "Government College, Hamirgarh",
  "Government College, Phulia Kalan, Shahpura",
  "Government Girls College, Shahpura",
  "Government College, Borada",
  "Government College, Pisangan",
  "Government College, Naand",
  "GOVERNMENT GIRLS COLLEGE LUNAWAS BHAKHAR , LUNI , JODHPUR",
  "GOVERNMENT COLLEGE MOHANGARH",
  "GOVERNMENT COLLEGE PHALSOOND, JAISALMER ",
  "GOVERNMENT COLLEGE, SABLA",
  "GOVERNMENT COLLEGE PARTAPUR, GARHI",
  "DR RADHA KRISHAN KANYA COLLEGE DULMERA",
  "GOVERNMENT MEDICAL COLLEGE, KARAULI",
  "GOVERNMENT COLLEGE LALGARH JATAN SRIGANGANAGAR",
  "SVR GIRLS COLLEGE",
  "M K Saboo PG College, Jhunjhunun",
  "GOVERNMENT COLLEGE GODU",
  "  NEERAJ MEMORIAL COLLEGE",
  "Mrs. Helena Kaushik Women's Edu. College, Jhunjhunun",
  "NARAYANI DEVI GIRLS COLLEGE SULTANA",
  "VIJAY MAHILA MAHAVIDYALAYA ",
  "Raath Mahila PG College, Alwar",
  "Rajasthan Mahila Mahavidyalaya, Alwar",
  "Rajasthan Shikshak Prashikshan Mahavi., Alwar",
  "SCHOOL OF EDUCATION",
  "maa bhagawati degree college  pichuna",
  "GURUKUL COLLEGE STATION ROAD KUCHAMAN CITY",
  "SHIVKRISHI COLLEGE LUKSAJOHARA",
  "Government College, Khajwana",
  "GOVERNMENT COLLEGE TALERA ",
  "Deen Bandhu Sikhan Sansthan (AHDP 03)",
  "SUBODH COLLEGE OF PHARMACY",
  "RUHS College of Medical Sciences, Jaipur",
  "GURUKRIPA INSTITUTE OF MEDICAL EDUCATION",
  "ARYA COLLEGE OF ENGINEERING",
  "Kautilya Mahila Shikshak Prashikshan Mahavidyalaya, Nayagaon Tehsil-Ladpura, NH-76, ByPass, Distt-Kota",
  "M.B. COLLEGE OF PARAMEDICAL AND NURSING EDUCATION, KOTA",
  "Swami Vivekanand College of Teachers Training & Research, Village- Danta (Kelwara) Sitabari, Tehsil-Shahbad, Baran",
  "Government College, Bijoliya",
  "SHAHEED-E-AZAM BHAGAT SINGH LAW COLLEGE",
  "Aspire Degree College",
  "SHRI SHYAM B.V.V. B.Ed. COLLEGE ANANDPURI, BANSWARA",
  "S.S.M. DEGREE COLLEGE TARANAGAR",
  "GOVERNMENT COLLEGE BAWARI",
  "MEERA MEMORIAL COLLEGE GUDAMALANI",
  "Government College Baseri",
  "SUDHA PHARMACY COLLEGE",
  "MAHATMA JYOTIRAO PHULE YOGA INSTITUTE SADULPUR CHURU ",
  "GOVERNMENT COLLEGE BAP",
  "GOVERNMENT COLLEGE MARWAR JUNCTION (PALI)",
  "GOVERNMENT COLLEGE, RAIPUR (PALI)",
  "Noble P.G. Mahavidyalay, Buhana Jhunjhunu",
  "Government College, Raniwara ",
  "RUHI CONVENT EDUCATION AND RESEARCH SOCIETY, SADULPUR CHURU",
  "KRISHNA PHARMACY COLLEGE JODHPUR",
  "SHRI TAGORE COLLEGE, GANGAPUR, SAHADA",
  "MAHARSHI KANYA MAHAVIDYALAYA, SAHADA, GANGAPUR",
  "MAITREYEE DEGREE COLLEGE, Riyan Badi",
  "SHAKTI SARASWATI SHIKHSAN MAHAVIDYALAYA",
  "SWAMI VIVEKANAND MAHAVIDYALAYA BUNDI KA GOTHDA",
  "K S MEMORIAL SHIKSHAN SANSTHAN COLLEGE OF EDUCATION, SANKDA, POKARAN, JAISALMER",
  "NAVODAYA EDUCATION INSTITUTE, LOHAWAT",
  "JAIPUR INSTITUTE OF YOGA AND NATUROPATHY ",
  "BIYANI INSTITUTE OF YOGA AND NETUROPATHY ",
  "SURAJ SADAN VIDYASHRAM MAHAVDYALAYA",
  "BHAGWATI DEVI COLLEGE THANAGAZI ALWAR",
  "MARUDHARA MAHILA MAHAVIDYALAYA",
  "Government College Shridungargarh",
  "Government College Chouhtan",
  "SHRI JAGDAMBA TEACHER BED EDUCATION VI COLLEGE",
  "BLOOM COLLEGE CHIRAWA",
  "BARJI DEVI GIRLS COLLEGE",
  "SHRI JAGDAMBA ACADEMY OF REHABILITATION SCIENCE",
  "Shri Mishri Lal Sanwal Government Girls College, Jaisalmer",
  "Shrimati Gumanbai Pannalal Bhanshali Govt. Girls College, Pali",
  "Ch. Balluram Godara Government Girls College, Sriganganagar",
  "Government Dungar College, Bikaner",
  "RAJ PHARMACY COLLEGE",
  "Smt. Kesri Devi Lohia Govt. Girls College, Ratangarh",
  "GOVERNMENT GIRLS COLLEGE, CHITTORGARH",
  "KESHAV VIDYAPEETH COLLEGE",
  "GANGA DEVI GAUTAM COLLEGE, Sawar",
  "GOVT. COLLEGE MUNDAWAR",
  "MATA KRISHNAWANTI COLLEGE PADAMPUR",
  "POOJA YOG MAHAVIDYALAYA",
  "BANSAL COLLEGE OF NURSING, HANUMANGARH",
  "PRAGATICOLLEGE",
  "Pragati T.T. College",
  "Govt. Girls PG College, Sawaimadhopur",
  "Subhash college of Animal husbandry (AHDP 21) ",
  "KATTA COLLEGE OF PHARMACY, BASANDA BRAHMNAAN, PANDITPURA, BANDIKUI, DAUSA ",
  "TAGORE INSTITUTE OF ANIMAL SCIENCE, KUCHAMAN CITY",
  "SHREE TAGORE INSTITUTE OF ANIMAL SCIENCE, KUCHAMAN CITY",
  "GOVERNMENT NEHRU MEMORIAL COLLEGE, HANUMANGARH",
  "SAROJ MEMORIAL MAHAVIDYALAYA",
  "SURYA COLLEGE OF SPECIAL EDUCATION ",
  "SSM TEACHER TRAINING COLLEGE",
  "MISHRI DEVI MEMORIAL ART AND SCIENCE COLLEGE",
  "RSM COLLEGE",
  "PARMANAND SHARMA SMRITI MAHAVIDYALAYA",
  "AMERICAN INTERNATIONAL INSTITUTE OF MEDICAL SCIENCES",
  "Lal Bahadur Shastri T.T. College,Mahaveer  Nagar Extension, Kota",
  "SWAMI VIVEKANAND BEd COLLEGE",
  "SHREENATH MAHAVIDHYALAYA",
  "SANSKAR COLLEGE TARANAGAR",
  "Janki Devi Bajaj Government Girls College, Kota",
  "Satya Sadhna Mahavidhyalaya, Todabhim, Karauli",
  "MAHATMA GANDHI COLLEGE OF HOSPITAL ADMINISTRATION",
  "Om Kothari Institute of Management & Research, Kota",
  "Amar Chand Rajkumari Bardiya Jain Vishwa Bharti College, Chhabra, Baran",
  "Adarsh Shikshak Prashikshan Mahavidyalaya, Kheevsar",
  "GOVERNMENT MEDICAL COLLEGE CHITTORGARH ",
  "Govt. Girls College, Jhalawar",
  "Seth Moti Lal Law College, Jhunjhunun",
  "MARWAR WINNERS COLLEGE, SOYLA, JODHPUR",
  "SHRI SHYAM PHARMACY COLLEGE",
  "Adarsh Phy. T.T. College, Suroth, Karauli",
  "Mayur Mahavidyalaya, Kuchaman City",
  "LRL SHIKSHAK PRASHIKSHAN MAHAVIDHYALAY",
  "ARAVALI COLLEGE OF PHARMACY",
  "Shri Krishna Shiksha Samiti Mahavi., Jhunjhunun",
  "ARAVALI INSTITUTE OF PHARMACY",
  "Shri Ramakant Vyas Women TT College, Jhunjhunun",
  "SHRI RAM AYURVED NURSING INSTITUTE",
  "SHRI TAIJAL BA BED INTEGRATED COLLEGE    ",
  "MAHATMA GANDHI COLLEGE",
  "K.R.B.R. Hedgewar T.T. College, Bundi",
  "Government Law College, Kota",
  "Govt. Law College, Jhalawar",
  "Millinium T.T. College, Aklera, Jhalawar",
  "K P COLLEGE OF ARTS AND SCIENCE AHORE",
  "GOVT LAW COLLEGE, BUNDI",
  "SHEKHAWATI INSTITUTE OF NATUROPATHY AND YOGIC SCIENCES SIKAR",
  "GOVERNMENT COLLEGE BARAN",
  "Hitkari Sahakari Mahila Shiksha Mahavidyalaya Arampura Dhakhar Kheri Teh Ladpura Kaithoon Road Kota",
  "S S B College, Maroth",
  "S.R.D. Modi College for  Woman, Kota",
  "Shri R K PG Mahavi., Jhunjhunun",
  "Gurukul Mahavidyalaya, Khinyala, Jayal",
  "Vardhman T.T. College, Guradia, The.- Pidawa, Jhalawar",
  "GOVT YOGA AND PRAKRITIK CHIKITSA MAHAVIDHYALYA",
  "Darshan T.T. College, Jhalrapatan, Bhawanimandi Road, Jhalawar",
  "Aklank T.T. College, Basant Vihar, Kota",
  "K.B.M. T.T. College, Bonli, Sawaimadhopur",
  "Ambika T.T. College",
  "SHRI RANJEET SINGH T T COLLEGE",
  "Sigma T.T. College, Jawahar Nagar, Jhalawar",
  "Govt. College, Kelwara, Baran",
  "Bhagwan Adinath Jairaj Marwara Govt. College, Nainwa",
  "Sugani Devi Mahila TT College, Alwar",
  "Mahrishi Parashuram Mahila Mahavidyalaya, Alwar",
  "Swami Keshwanand College of Higher Education Lili,Laxmanagrh",
  "S S G Pareek P G Girl's College, Chomu",
  "Late Kumari Laxmi Badhala Girls P.G. College, Jaipur",
  "Maharana Pratap T.T. College, 234,Behind Central Academy School, Kota",
  "QUEEN MARY INSTUTITE OF HOTEL MANAGAMENT",
  "Sorabh T.T. College, Kheda, Hindauncity, Karauli",
  "SHRI KRISHAN COLLEGE OF PHARMACY, GOVINDGARH, TEH CHOMU, DIST JAIPUR",
  "KGN COLLEGEOF PHARMACY",
  "MARWAR WINNERS SPECIAL T T COLLEGE",
  "SHREE JI PHARMACY INSTITUTE, NATHUWAS, NATHDWARA",
  "GOVERNMENT AGRICULTURE COLLEGE BEHRAWANDA KHURD KHANDAR SAWAI MADHOPUR",
  "MAHARAJA SURAJMAL MAHILA MAHAVIDYALAY",
  "G.H.S. Government College, Sujangarh",
  "BIFF AND BRIGHT COLLEGE OF PHARMACY",
  "NAGFANI INSTITUTE OF PHARMACY, KHANDI OBRI, KHERWARA",
  "APEX INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH",
  "ADARSH COLLEGE OF PHARMACY",
  "SHRI SHANKAR MAHILA MAHAVIDHAYALAY DIVRALA",
  "GHANSHYAM BABA COLLEGE OF PHARMACY",
  "SVR GIRLS COLLEGE, BHIWADI",
  "SMS COLLEGE OF PHARMACEUTICAL SCIENCES SHIVNATHPURA BEAWAR AJMER ",
  "OM SATYAM YOGA MAHAVIDHYALAYA",
  "PRABHA DEVI MEMORIAL COMPUTER PRAKSHISHAN MAHAVIDHYALAYA",
  "MAHATMA GANDHI INSTITUTE OF ALLIED HEALTH SCIENCES",
  "SHRI VINAYAK P.G. COLLEGE , CHALA, NEEM KA THANA ",
  "LJN Mahavidalaya, Dhaulpur",
  "GOVT COLLEGE OF NURSING, MAHARANA BHUPAL GOVT HOSPITAL UDAIPUR",
  "Maa Kasturba Gandhi Mahila College, Bharatpur",
  "UMD MAHARANI COLLEGE ",
  "Tagore T.T. College, Aklera, In-front of Ram Mandir, Aklera, Jhalawar",
  "Bhagwati Mahavidhyalaya, Gangapurcity",
  "SHRI RATANLAL KANWARLAL PATNI GIRLS NURSING COLLEGE",
  "RAMKISHAN JUGALKISHORE BARASIA TEACHER  TRAINING COLLEGE, SURAJGARH",
  "Sankalan Mahavidhyalaya, Kapren, Distt. Bundi",
  "SARASWATI COLLEGE ADARSH NAGAR PHALODI JODHPUR",
  "GOVERNMENT AGRICULTURE COLLEGE, TIJARA, ALWAR RAJASTHAN",
  "SWAMI VIVEKANAND GIRLS COLLEGE - CHAK 14 KSP SHERGARH ",
  "CHOUDHARY B R COLLEGE",
  "Prashanti T.T. College, Mahaveer Nagar, Kota",
  "Sanskar T.T. College, Ward No. 23, Nohar",
  "Maharaja Surajmal Mahavidyalaya, Bharatpur",
  "J.L.N.T.T. College, Sakatpura, Kota",
  "JYOTIBA PHULE GOVT COLLEGE, JAISINGHPURA KHOR, JAIPUR",
  "Maruti Nandan TT College, Bharatpur",
  "Master Balvir SIngh College, Bharatpur",
  "GOVT COLLEGE SEMARI",
  "GOVT GIRLS COLLEGE ANUPGARH",
  "RRB COMPUTER AND YOGA TEACHER TRAINING COLLEGE",
  "PRAGYAN COLLEGE NEAR SBI BANK BUS STAND AKOLA TEHSIL BHUPAL SAGAR DIST CHITTORGARG",
  "VANDEMATRAM TEACHER TRAINING COLLEGE",
  "KANHA DEGREE COLLEGE",
  "GOVERNMENT COLLEGE MANDAWAR",
  "Chaudhary Charan Singh Animal Husbandry College (AHDP 25)",
  "Mehta Teacher Training College, Jaipur",
  "BIYANI INSTITUTE OF PHYSICAL EDUCATION",
  "GOVT YOGA EVAM PRAKRITHIK CHIKITSA MAHAVIDHYALAY, JAIPUR",
  "GOVERNMENT AYURVED, YOGA AND NATUROPATHY COLLEGE",
  "Islamia , Sikar",
  "GAURISHANKAR BIHANI MAHAVIDYALAYA, JAMDOLI, JAIPUR    ",
  "ST FRANCIS HOSPITAL AND COLLEGE OF NURSING",
  "Great India T.T. College, Khanpur, Jhalawar",
  "KASTURI DEVI COLLEGE, CHAKSU",
  "GOVERNMENT COLLEGE GANGADTALAI",
  "KISHAN SHIKSHAK PRASHIKSHAN  COLLEGE PAOTA JAIPUR ",
  "R N COLLEGE, BHALERI",
  "Khatushyam Mahavidhyalay Sarmathura",
  "Prince College ",
  "SHRI USB COLLEGE OF PHYSIOTHERAPY",
  "Sagar College, Jaipur",
  "GRAMODAYA GIRLS COLLEGE",
  "Balaji Mahila Mahavidhyalaya,Mainpura, Sawaimadhopur",
  "Bhagwati Shikshak Prashikshan Mahavidyalaya, Gangapur city",
  "LAXMI CO- EDUCATION COLLEGE",
  "SHREE RAM MAHILA T.T. COLLEGE",
  "Ramanand Vidhya Mandir Women TT College, Alwar",
  "S.P.M. Government College, Bhopalgarh",
  "GOVT. COLLEGE, SIMALWARA, DUNGARPUR, RAJASTHAN",
  "Imperial College of Nursing",
  "PRINCE GIRLS COLLEGE, BADHAL",
  "ST WILFREDS COLLEGE",
  "Purushottam Mahavidhyalaya",
  "SARASWATI MAHAVIDYALAYA, JAGRAMPURA, KOTKHAWADA",
  "Bhartiya T T College, Chandpura, Sikar",
  "ANNUAL EDUCATION GROUP",
  "HARI DAYALU KAUSHAL MAHAVIDYALAYA BARMER",
  "L B S College of Education",
  "IMPULSE DEGREE COLLEGE, DAUSA",
  "SANJU MAHAVIDYALYA, LOSAL",
  "RAWAT COLLEGE OF EDUCATION",
  "APARAJITA COLLEGE KISHANGARH RENWAL JAIPUR",
  "Saint Paul College, Naner",
  "Swami Vivekanand Mahavidyalaya, Jobner, Jaipur",
  "SHEKHAWATI MEDICAL TRAINING INSTITUTE COLLEGE OF NURSING, SIKAR",
  "Government College Patan",
  "Punjab Ayurved Medical College & Hospital, Ganganagar",
  "Bhanwar Lal Duggad Ayurveda Vishva Bharti,Sardar Shahar",
  "Swasthya Swasthya Kalyan Homoeopathy Medical College & Research Institute, Jaipur",
  "S S COLLEGE TUTOLY",
  "SURENDERA PHARMACY COLLEGE",
  "P.L. Dubey Memorial College, Jagpura, Near Jagpura Choki, Kota",
  "Kautilya Institute of Technology & Engineering and School of Management,Jaipur",
  "RAJDHANI  T T COLLEGE KHANDELA",
  "Biyani Institute of Science & Management",
  "Compucom Institute of Information Technology & Management",
  "St. Wilfred's College for Girls, Jaipur",
  "JAIPUR COLLEGE OF PHARMACEUTICAL SCIENCES",
  "Post Graduate Institute of Ayurved, Jodhpur",
  "H.P. KABRA GIRLS COLLEGE, Kuchaman City",
  "Shekhawati Ayurved College, Jhunjhunu",
  "ARAVALI COLLEGE",
  "GOVERNEMENT COLLEGE TALCHIDI    ",
  "GURUKUL COLLEGE SAGWARA",
  "RANA PUNJA COLLAGE",
  "Shiv Mahavidyalaya, Alwar",
  "ANNIE BESANT COLLEGE",
  "Government Girls College Kishanpole  Jaipur",
  "SHAHEED BHAGAT SINGH GIRLS COLLEGE, HINGONIA",
  "Shrimati Mohari Devi Taparia Kanya Mahavidyalaya, Jaswantgarh",
  "GOVERNMENT COLLEGE CHITALWANA",
  "COLLEGE OF HORTICULTURE DURGAPURA JAIPUR",
  "COLLEGE OF AGRICULTURE, KOTPUTLI",
  "GOVERNMENT COLLEGE SAMDARI",
  "COLLEGE OF AGRICULTURE, BHUSAWAR, BHARATPUR",
  "SANSKAR BHARTI COLLEGE OF NURSING , HANTRA , NADBAI, BHARATPUR",
  "LAXMI COLLEGE OF EDUCATION",
  "SUNRISE COLLEGE ASPUR",
  "Government Girls College, Merta City",
  "Government College, Sawar",
  "ANANTA INSTITUTE OF HOTEL MANAGEMENT  ALLIED STUDIES ",
  " D P M COLLEGE OF NURSING, HALENA ROAD, SARSENA, WEIR, BHARATPUR",
  "INSTITUTE OF COMPUTER TECHNOLOGY, KOTA",
  "PRAGATI MEDICAL COLLEGE OF PHARMACY",
  "SHEKHAWATI SHIKSHAN SANSTHAN T T  COLLEGE TEHANDESAR",
  "SHRI HANS NIMBARK VETERINARY INSTITUTE ",
  "GOVERNMENT  COLLEGE  KHANDELA",
  "BRAINWAVES PHYSIOTHERAPY COLLEGE",
  "SHRI LAKSHYA COLLEGE",
  "GOVT GIRLS COLLEGE TAKHATGARH",
  "GOVERNMENT GIRLS COLLEGE TODABHIM",
  "GOVERNMENT COLLEGE KUDI BHAGTASNI",
  "SHRI BALAJI NURSING COLLEGE",
  "GOVERNMENT MEDICAL COLLEGE NAGAUR",
  "MAHARANA PRATAP GIRLS COLLEGE ",
  "GOVERNMENT YOGA AND NATUROPATHY COLLEGE, KEKARI, AJMER",
  "IDEAL COLLEGE ",
  "Liberty Livestock Assistant Training Institute (AHDP 18) ",
  "U.S. OSTWAL PG COLLEGE",
  "GOVERNMENT COLLEGE PIPAR CITY JODHPUR",
  "SUKHIDEVI NARAYANRAM MAHILA COLLEGE",
  "ARYAN COLLEGE OF NURSING",
  "JAIPUR COLLEGE OF EDUCATION AND SCIENCE",
  "GOVERNMENT GIRLS COLLEGE DANTARAMGARH",
  "RNT TT COLLEGE KAPASAN",
  "BM LAW COLLEGE",
  "MAHAVEER AMBESH GURU COLLEGE, FATEHNAGAR",
  "MAHARAJA SURAJMAL COLLEGE ",
  "Shri S. J. D.  Agrawal (Tola) Smriti Mahila P.G. Mahavidhyalaya, Sadulpur (Churu)",
  "NATHDWARA LAW COLLEGE",
  "Compucom Institute of Technology & Management,Jaipur",
  "Chandravati Educational Charitable Trust Group of Institutions, Bharatpur",
  "GOVERNMENT GIRLS COLLEGE, WAZEERPUR",
  "GOVERNMENT GIRLS COLLEGE SIWANA",
  "GOVERNMENT GIRLS COLLEGE KISHANGARHBAS",
  "SHRI RAJESHWAR BHAGWAN AANJANI MATA KANYA MAHAVIDYALAYA NAYA CHENDA ROHAT PALI",
  "GOVERNMENT GIRLS COLLEGE BASSI,  CHITTORGARH, RAJASTHAN",
  "BRIGHT CAREER AGRICULTURE COLLEGE ",
  "GOVERNMENT AGRICULTURE COLLEGE POKARAN",
  "BALAJI  COLLEGE KHATUSHYAMJI ROAD VILLAGE BAY TEHSIL DANTARAMGARH DISTT SIKAR",
  "MAA VANKAL COLLEGE OF SPECIAL EDUCATION CHOHTAN",
  "GOVERNMENT AGRICULTURE COLLEGE KHEDLABUJURGA, MAHUWA",
  "GOVERNMENT AGRICULTURE COLLEGE, BAHARAWANDA ",
  "GOVERNMENT AGRICULTURE COLLEGE CHIRAWA",
  "GOVERMENT AGRICULTURE COLLEGE MUNDAWAR",
  "SARVODAYA B ED COLLEGE KALINJARA, VILL NAYA PADARIYA KALINJARA  BANSWARA RAJ",
  "S K D AGRICULTURE COLLEGE",
  "GOVERNMENT AGRICULTURE COLLEGE, NOHAR",
  "GOVERNMENT GIRLS COLLEGE FATEHPUR SIKAR",
  "GOVERNMENT GIRLS COLLEGE JHALATALA",
  "MADHANI COLLEGE OF SPECIAL EDUCATION, RAMSAR",
  "RAJKIYA KANYA MAHAVIDYALAYA, SHRIMADHOPUR",
  "ROOPA RAM SEVADA MAHAVIDHYALAYA KERU JODHPUR",
  "Choudhary Chanan Ram Memorial College Srikaranpur",
  "Beena Mahavidyalaya",
  "LAL BAHADUR SHASTRI COLEGE",
  "KNOWLEDGE COLLEGE",
  "GOVERNMENT COLLEGE CHORASI",
  "GOVERNMENT GIRLS COLLEGE, RAMPURA KOTA",
  "RAJKIYA KANYA MAHAVIDYALAYA, MUKUNDGARH",
  "GOVERNMENT GIRLS COLLEGE KOLAYAT",
  "GOVERNMENT GIRLS COLLEGE, SANDWA ",
  "Government College, Roopangarh",
  "GOVERNMENT COLLEGE PAOTA",
  "SHRI SHRI UTTAM BALIKA MAHAVIDHYALAYA",
  "GOVERNMENT GIRLS COLLEGE, GANGAURI BAZAR, JAIPUR",
  "Balaji T T College, Jhunjhunun",
  "GOVT GIRLS COLLEGE RAJGARH",
  "GOVERNMENT GIRLS COLLEGE, DATWAS",
  "GOVERNMENT GIRLS COLLEGE BARDOD",
  "GOVERNMENT GIRLS COLLEGE, NEWAI",
  "GOVERNMENT COLLEGE,HINDUMALKOT,SRIGANGANAGAR",
  "GOVERNMENT GIRLS COLLEGE, GOVINDGARH, JAIPUR",
  "GOVERNMENT COLLEGE ANANDPURI",
  "GOVERNMENT GIRLS COLLEGE, SAINTHAL DAUSA",
  "GOVERNMENT GIRLS COLLEGE SANGANER ",
  "GOVT MODEL NURSING INSTITUTE KEKRI AJMER",
  "GOVERNMENT GIRLS COLLEGE VIDYADHAR NAGAR JAIPUR",
  "SHRI VINAYAK COLLEGE OF EDUCATION",
  "Post Graduate Institute of Veterinary Education and Research (PGIVER)",
  "NIMT TECHNICAL AND PROFESSIONAL COLLEGE",
  "GOVERNMENT COLLEGE KAMAN",
  "SUN COLLEGE OF MANAGEMENT AND SCIENCE, IP-4, RIICO INDUSTRIAL AREA, BHAMASHAH, KALADWAS, UDAIPUR",
  "ANJUMAN MAHAVIDYALAYA, MAKRANA",
  "Vivekanand Mahavidhyala, kalu ka bas",
  "UTKARSH MAHAVIDHAYALA, WEIR BHUSAWAR ROAD WEIR",
  "Piyasha Girls College",
  "Bihari Lal Mahavi., Jhunjhunun",
  "BPS T T College, Sikar",
  "Career T T College, Jhunjhunun",
  "Chirawa PG College, Jhunjhunun",
  "Choudhary RR Memorial PG Mahavi., Sikar",
  "Dhattarwal T T College, Jhunjhunun",
  "Dr. Mohan Lal Peeramal Balika Mahavi., Jhunjhunun",
  "Gandhi Vidya Mandir Mahila T T College, Sikar",
  "Gangadhar T T College, Jhunjhunun",
  "Golden Balika Mahavi., Jhunjhunun",
  "Gopi Krishan Piramal TT College,Jhunjhunun",
  "Goswami Tulsidas PG Mahavi., Jhunjhunun",
  "DEEN DAYAL T T COLLEGE, SIKAR",
  "Govt. P G Law College, Sikar",
  "JIET COLLEGE OF NURSING",
  "Govt. Kamla Modi P.G. Mahila Mahavidyalaya, Neem Ka Thana (Sikar)",
  "DPM B.ed COLLEGE, SARSENA",
  "CHAUDHARY KANYA COLLEGE, HANTRA",
  "S B N College of Education",
  "H B Bhansali T T College",
  "SHRI SHYAM SHIKSHAK PRASHIKSHAN SANSTHAN, BHADRA",
  "NIMT MAHILA B.ED COLLEGE",
  "SHRI VINAYAK COLLEGE THANAGAZI",
  "banswara institute of higher studies",
  "ST. WILFREDS INSTITUTE OF ARCHITECTURE, AJMER",
  "St. Wilfred Institute of Engg. & Tech.",
  "Shekhawati Institute of Engineering & Technology,Sikar",
  "Raj Engineering College,Jodhpur",
  "PRATAP INSTITUTE OF TECHNOLOGY & SCIENCE, SIKAR",
  "MANAV DHARM VIKLANG SEVA SANSTHA AYURVED NURSE, COMPOUNDER TRAINING CENTER TONK",
  "SHAKSHI AYUSH NURSE COMPOUNDER TRAINING CENTRE",
  "SHRI KANIRAM SALAGRAM TAK RAJKIYA AYURVED NURSE COMPOUNDER TRAINING CENTER, PUNJLA JODHPUR",
  "ST. XAVIERS COLLEGE, NEVTA ",
  "S.S. COLLEGE OF EDUCATION, SWAMI SHARNAM SHIKSHAN SANSTHAN, JHAMAR KOTRA MAIN ROAD, UMARDA",
  "ASIAN COLLEGE OF EDUCATION HAWALA KHURD,BARI MAIN ROAD, NEAR POLICE ANVESHAN BHAWAN",
  "ARIHANT MAHILA TEACHERS TRAINING COLLEGE ,17-B.C. SAHELI MARG, NEAR IDBI BANK, SAHELI MARG",
  "SHREE S.K. AMBIKA COLLEGE MALSISAR",
  "Shri BBM Mahila PG Mahavi., Jhunjhunun",
  "Shri BBM Mahila Shikshak Prashikahan COllege, Jhunjhunun",
  "J.R. SHARMA TEACHERS TRAINING COLLEGE, JHADOL(F)",
  "SHRINATHJI B.Ed. COLLEGE, AMTHALA, ABU ROAD",
  "Shri Karni Kanya Mahavi., Jhunjhunun",
  "Shri Krishna Girls College, Kanwat",
  "Shri Mansa Kanya PG Mahavi., Jhunjhunun",
  "Shri Nathmal Todi B.Ed. College, Sikar",
  "Shri Ram College, Sikar",
  "V.B.G.S.T.T. COLLEGE",
  "CHUNDA MAHILA  TEACHERS TRAINING COLLEGE, DHINKLI",
  "Shri Rameshwar Lal Sharma Kanya Mahavi., Jhunjhunun",
  "Shri Rishikul B.Ed. College, Sikar",
  "Shri RK B.Ed. College, Jhunjhunun",
  "Shri Shradha Nath PG Mahavi., Jhunjhunun",
  "Smt. Kunani Bola Memorial Girls College, Mandrella",
  "Smt. Ramkumari Mahila PG Mahavi., Jhunjhunun",
  "Smt. Ramkumari TT College, Jhunjhunun",
  "Tagore Mahavi., Sikar",
  "TAGORE P.G. COLLEGE, DANTA RAMGARH",
  "Tagore PG Mahavi., Jhunjhunun",
  "Tagore Shikshak PRashikshan Sansthan, Sikar",
  "Tagore TT College, Sikar",
  "Trilok Singh Mahavi., Sikar",
  "SARDAR BHAGAT SINGH NURSING COLLEGE HANUMANGARH",
  "R.N.T. COLLEGE OF B.ED. ,SECTOR NO. 5 GANDHI NAGAR",
  "CHANAKYA COLLEGE OF  TEACHERS TRAINING ,  HAWALA KHURD",
  "BAHUBALI TEACHERS TRAINING COLLEGE BADWAI,  TEHSIL DUNGLA",
  "KAVYANJALI GIRLS COLLEGE, CHAWAND, TESHIL SARADA",
  "Umrao Singh Arya College, Jhunjhunun",
  "Veer Sawarkar Balika mahavidyalaya, Jhunjhunun",
  "BIJARNIA COLLEGE OF NURSING",
  "AMBIKA COLLEGE OF NURSING",
  "Vidya Bharti B.Ed. College, Sikar",
  "Vinayak B.Ed. College, Sikar",
  "GURU PUSHKAR  JAIN, COLLEGE, GOGUNDA",
  "Vinayak College, Sikar",
  "Vinayak Mahavi., Sikar",
  "MEWAR GIRLS COLLEGE OF TEACHERS EDUCATION, SECTOR NO.5 GANDHI NAGAR",
  "Vishwa Bharti B.Ed. College, Sikar",
  "RAVINDRANATH THAKUR B.Ed. COLLEGE, TULSIDAS JI KI SARAI, DABOK ROAD, DEBARI",
  "NATHDWARA INSTITUTE OF BIOTECHNOLOGY AND MANAGEMENT",
  "S.P. COLLEGE, BARI SADRI",
  "J.R. COLLEGE, RISHABHDEO",
  "ARAVALI TEACHERS TRAINING COLLEGE, AKLINGPURA, JHAMAR KOTRA ROAD",
  "JAWAHAR VIDYAPEETH TEACHERS TRAINING  COLLEGE, KANORE",
  "GOVT. MEERA GIRLS COLLEGE, UDAIPUR",
  "GOVT.GIRLS COLLEGE, SIROHI",
  "Seth Mathuradas Binani Government P.G. College Nathdwara, Rajsamand",
  "GURUKUL  MAHILA B.ED. COLLEGE",
  "B.N. GIRLS COLLEGE,  RAJSAMAND",
  "RAJENDRA MUNI TEACHERS TRAINING COLLEGE,  KUMHARWADA",
  "MAHABALI DANI PANNA DHAY MAHILA TEACHERS TRG. COLLEGE, DELWARA",
  "PT. UDAI JAIN COLLEGE, KANORE",
  "R.N.T.COLLEGE, HIGHWAY ROAD, NEAR MATAJI TEMPLE, KAPASAN",
  "J.R. COLLEGE,  AJARI ROAD, PINDWARA",
  "MAHARSHI INSTITUTE OF EDUCATION, 11-12 UDAIPUR-CHITTOR ROAD, SUNDERWAS",
  "VISION COLLEGE OF COMMERCE, UDAIPUR ROAD, POST BOX NO. 23",
  "J.R. SHARMA COLLEGE, JHADOL",
  "RAM KISHAN TEACHERS TRAINING COLLEGE, BEHIND. SECTOR NO.4,5 & 6, HIRANMAGRI,  BY PASS ROAD, MANVA KHEDA",
  "SHRINATH TEACHERS TRAINING COLLEGE, BARI SADRI",
  "GOVERNMENT LAW COLLEGE DUNGARPUR",
  "MANTRAM TEACHERS TRAINING COLLEGE, VILLAGE- KAMLI, PANCHYAT -NAI",
  "Government College, Ratangarh",
  "MEERA MAHILA B.ED. COLLEGE,  NEAR ROADWAYS BUS STAND",
  "SHREE  DWARKADHISH TEACHERS TRAINING COLLEGE,PRATAP PURA",
  "SHRI AGRASEN MAHILA MAHAVIDHYALAYA,BARI,DHOLPUR ",
  "Govt. Girls College, Chomu",
  "Rajesh Pilot Govt. PG College, Lalsot",
  "Dadhimati Mahila T. T. College, Sriganganagar",
  "Asha Devi College of Education, Sadulpur",
  "Shubhash Chandra Bose T.T. College, Sahwa",
  "Vishwa Bharti Teachers Training College, Sardarshahar",
  "I.A.S.E., Bikaner",
  "M. L. B. Govt. College - Nokha",
  "Shri Swami Vivekanand Co-Education College, Rawla Mandi",
  "S.K.S. Chandi College - Khajuwala",
  "Adrash Gramin College, Mirjawalimeer",
  "Maa Saraswati Girls College, Jetsar",
  "Shri Mahaveer T.T. College, Sardarshahar",
  "D.A.V. Girls College, Goluwala",
  "Tagore College, Taranagar",
  "Maruti Girls College, Ratangarh",
  "Dev T.T. College, Taranagar",
  "Vivekanand College, Bhadra",
  "S.D. Degree College, Jakhrawali",
  "Global College, Sadulpur",
  "Rastra Udai T.T. College, Bikaner",
  "Ch. Motaram Meel Memorial College of Education, 5 NRD, Nirwana",
  "Gyan Vidhi Mahavidyalya, Bikaner",
  "Pink Model T.T. College, Bikaner",
  "Sarswati Vidhya Mandir, Lambor Bari",
  "Sh. Amichand Memorial T.T.College, Taranagar",
  "K.K.C. College, Sardarshahar",
  "Shri Dwarka Physical T. T. College, Naal",
  "Chaudhary B .Ed. College, Sadulpur",
  "S. D. S. Girls (PG) College, Sujangarh",
  "Arya College of Education, Bhadra",
  "S. D. P.G.College - Khajuwala",
  "Bharti T.T. College, Nathwala",
  "SCHOLAR ARENA GIRLS B.ED. COLLEGE, 29-NEW SWAMI NAGAR, TEKRI-MADRI LINK ROAD",
  "GOVERNMENT COLLEGE, BANIPARK, JAIPUR    ",
  "Vishwa Bharti College, Sikar",
  "Vivekanand College, Sikar",
  "ST. PAUL'S COLLEGE OF SCIENCE AND MANAGEMENT,GANDHI NAGAR, ABU ROAD",
  "Vivekanand TT College, Sikar",
  "Vivek Bharti TT College, Sikar",
  "Yaduvanshi College of Education,Jhunjhunun",
  "MANAV DHARAM MAHAVIDHYALAYA",
  "R N T COLLEGE, ARTHUNA, BANSWARA",
  "P D COLLEGE OF HIGHER EDUCATION",
  "Jaipur Engineering College & Research Center,jaipur",
  "Aravali Institute of Technical Studies,Udaipur",
  "Dr. Radhakrishnan Institute of Technology,Jaipur",
  "Om Kothari Institute of Management & Research",
  "Shri Bhawani Niketan Inst. Of Tech. & Management,Jaipur",
  "SHREE DIGAMBER INSTITUTE OF TECHNOLOGY,Mitrapura,DAUSA",
  "Yagyavalkya Institute of Technology,Jaipur",
  "Laxdeep T.T. College, Devpura, Bundi",
  "Vijay Singh Pathik Mahavidhyalaya, Srimahaveerji, Distt. Karauli",
  "GOVT. COLLEGE, BHIM, DISTT. RAJSAMAND",
  "Lal Bahadur Shastri College, Mahaveer Nagar Extension, Kota",
  "Govt. Girls College, Baran",
  "Tagore Mahavidhyalaya, Bonli, Sawaimadhopur",
  "Mahila Shiksha Gramin Vidhyapeeth, Mainpura, Sawaimdhopur",
  "SHAHEED CAPTAIN RIPUDAMAN SINGH RAJKIYA MAHAVIDYALAYA, SAWAI MADHOPUR",
  "SWAMI VIVEKANAND COLLEGE, VALLBHANAGAR",
  "Govt. Girls College, Bundi",
  "KRISHNA COLLEGE OF PHYSICAL EDUCATION, MAVLI, DABOK ROAD",
  "JAIPUR CAMPUS",
  "NORTHERN INSTITUTE OF ENGINEERING & TECHNICAL CAMPUS, ALWAR",
  "INDO AMERICAN INSTITUTE, OPP. SNEH RESORTS, NH-8 VILLAGE, BALICHA, UDAIPUR",
  "SHRI TEJENDRA PRASAD TEACHERS TRAINING COLLEG (B.ED.)",
  " KR TEACHERS TRAINING INSTITUTE LAKHANI KHANDELA SIKAR",
  "SUNRISE COLLEGE DATA",
  "Mahaveer Institute of Technology and Science, Jadan",
  "JODHPUR INSTITUTE OF ENGINEERING & TECHNOLOGY",
  "Seth Kesrimal Memorial Mahavidyalay, Dhorimanna",
  "Bharti T.T. College, A 484, Industrial Area, Road No. 7, Anantpura, Kota",
  "RAJASTHAN MAHILA TEACHERS TRAINING COLLEGE",
  "Bhagwan Mahaveer  T.T. College, Kachroli, Teh.Hindauncity, Karauli",
  "Swami Vivekanand Pashudhan Sahayak Prasikshan Sansthan",
  "CAREER TEACHERS TRAINING COLLEGE, WARD NO. 03, KISHAN COLONY, SUJANGARH",
  "B K Birla Institute of Engineering & Technology, Pilani",
  "MEENAKSHI EDUCATION SANSTHAN",
  "CHOUDHARY PARMA RAM GODARA AGRICULTURE COLLEGE",
  "VIVEKANAND VIDYA ASHRAM COLLEGE ",
  "Bhartiya Institute of Engineering & Technology,Sikar",
  "BHARTI MAHAVIDYALAYA REENGUS, DIST- SIKAR",
  "shri ram college raisinghnagar",
  "APEX MAHAVIDYALAYA DAUSA",
  "government shashtri sanskrit college mahapura",
  "Sharda Mahila Mahavidyalaya, Degana Junction",
  "Shri Nakoda Parshvanath Jain Mahavidyalaya, Jodhpur.",
  "GOVERNMENT PHYSIOTHERAPY COLLEGE",
  "D.P. Tiwari Medical And Nursing Educational Institute",
  "PARNYARAJ DEGREE COLLEGE BAJJU",
  "GOVT.COLLEGE, SAGWARA",
  "GOVERNMENT COLLEGE, DHARIAWAD",
  "Government College Chotti Sadri",
  "Shri Baba Laxmandas College, Kanjoli Line Bharatpur",
  "Agrawal Kanya Mahavidhyalaya, Gangapurcity",
  "Shree Agrasen Girls College, Hindauncity",
  "R.N.T.LAW COLLEGE, SECTOR NO. 5 GANDHI NAGAR",
  "S.P. COLLEGE, SARVADHAM ,OPP. POLICE LINES",
  "SHRI RAM TEACHERS TRAINING COLLEGE",
  "GLOBAL INSTITUTE OF EDUCATION AND RESEARCH , BARODIA",
  "Om Kothari T.T. College, A-1, Special I.P.I.A., Kota",
  "Aryabhatt College of Management",
  "Govt. College, Jhalawar",
  "SHREE BALAJI DEGREE COLLEGE",
  "Ranthambore Mahavidhyalaya, Sawaimadhopur",
  "Ramkrishan Parmahans T.T. College, Kaviraja Ki Haveli, Kotri Subjimandi, Kota",
  "Lord Buddha Institute of Tech. & Science College, Kota",
  "Shri Prem Singh Singhvi Mahavidhyalaya, Chhipabarod, Baran",
  "Government College, Ahore",
  "SARASWATI MAHILA MAHAVIDYALAYA, PATAN",
  "AARSH SADHANA MAHAVIDYALAYA ",
  "J.L.N.B. Ed. College, Sangod, Kota",
  "Abhigyan Mahavidyalaya",
  "Government Girls UG Sanskrit College Chack",
  "Agrawal Mahila T.T. College, Gangapurcity",
  "SHRI KRISHNA MAHAVIDYALAYA, JAIPUR",
  "B R MAHILA MAHAVIDHYALAY",
  "SHRI KRISHNA TEACHER TRAINING COLLEGE MANOHARPUR JAIPUR",
  "AISHWARIYA TEACHERS TRAINING COLLEGE, ADARSH NAGAR, UNIVERSITY ROAD",
  "ALANKAR GIRLS LAW COLLEGE",
  "AISHWARIYA COLLEGE OF EDUCATION SANSTHAN, 1-4, D-BLOCK ADARSH NAGAR",
  "Government College, Sumerpur",
  "Government College, Manoharthana",
  "Government College, Degana",
  "Government College, Khandar",
  "Aryabhatta College of Engg. & Research Center,Ajmer",
  "SARBATI DEVI MAHILLA COLLEGE",
  "GOVERNMENT GIRLS COLLEGE, CHADO KI DHANI, SINDHARI",
  "ARYA INSTITUTE OF ENGINEERING TECHNOLOGY AND MANAGEMENT ",
  "BHOM SINGH MAHILA TEACHER TRAINING COLLEGE",
  "R R PATEL COLLEGE,CHAUTH KA BARWARA",
  "Shri Haridutt Degree College",
  "ADITI MAHAVIDYALAYA, NAINWA",
  "NIMBARK TEACHERS TRAINING  COLLEGE",
  "PACIFIC COLLEGE, CHITRAKUT NAGAR, NEAR PF OFFICE, BHUWAN",
  "Shekhawati Institute of Technology",
  "VIKAS TEACHERS TRAINING COLLEGE",
  "Shri Rajkumar Maan College",
  "Sister Nivedita Girls College",
  "DR.N.S.LAW COLLEGE",
  "BVM TEACHERS TRAINING COLLEGE",
  "BHOGI LAL PANDIYA, GOVT.COLLEGE, DUNGARPUR",
  "SHRADHYALAYA MAHILA TEACHERS TRAINING COLLEGE RAWAT BHATTA",
  "VINAYAK GIRLS COLLEGE",
  "Shree S. L. Jangu Institute of Veterinary Science (AHDP 34)",
  "SAINT JAI GIRLS COLLEGE DOONGRI KALAN",
  "Government Sanskrit PG college Ajmer",
  "TEACHER TRAINING COLLEGE, JHADOL (F)",
  "MODERN SANWALIYA TEACHERS TRAINING COLLEGE CHHOTI SADRI",
  "Government Sanskrit PG college Ganoda",
  "RANA PRATAP GIRLS TEACHERS TRAINING COLLEGE, BHINDER",
  "Government Sanskrit UG college Chouth Ka Barwara",
  "R.P.PHY.EDU. COLLEGE ,BHINDER",
  "SAINT MEERA MAHILA TEACHERS TRAINING COLLEGE, SUKHADIA NAGAR, NATHDWARA",
  "M.J.F. Institute of Veterinary Science (AHDP)",
  "Shri Vinayak Research & Training Institute (AHDP 24)",
  "KALA ASHRAM COLLEGE OF TEACHERS TRAINING, 186, PADMAWATI COMPLEX, BHUWANA ROAD",
  "Government Sanskrit UG college Nathdwara",
  "Government Sanskrit UG College Sarmuthra",
  "Government Sanskrit UG College Salasar",
  "JYOTIBA PHULE TEACHERS TRAINING COLLEGE, BEHIND. SECTOR NO.4,5 & 6, HIRANMAGRI,  , MANVA KHEDA",
  "RAJDEV TEACHERS TRAINING COLLEGE, 3-RATA KHETA, B-BLOCK, SAJJAN NAGAR, SISARMA ROAD",
  "R.P.GIRLS COLLEGE, BHINDER",
  "SAINT MEERA COLLEGE, SHEOGANJ",
  "ACHARYA SHRI NANESH SAMTA MAHAVIDHYALAYA, NANESH NAGAR, DANTA TEHSIL KAPASAN",
  "Government Sanskrit PG College Bonli",
  "BHARTIYA VIDYA BHAWAN TEACHERS TRAINING COLLEGE, RATI TALAI",
  "DIVYA JYOTI EDUCATION INSTITUTE BHINMAL",
  "GOVERNMENT COLLEGE DEOLI KALLAN    ",
  "ROOHI COLLEGE OF PHARMACY BHILWARA",
  "Vision School of management",
  "Bai Shabari Mahila College",
  "ARAVALI MAHAVIDHYALAYA",
  "A. P.C. COLLEGE ,  NEEMUCH ROAD,  (SAMRAT HOTEL)",
  "ADARSH COLLEGE, ANANDPURI",
  "Lakshaya Mahavidyalaya RAMSAR",
  "shri Krishna mahavidhyalaya",
  "VCD College of Designing",
  "PT. DEEN DAYAL UPADHYAY AGRICULTURE COLLEGE ",
  "O P Agriculture College",
  "MB AGRICULTURE COLLEGE ",
  "Govt. College, Kota",
  "Government Law College, Bharatpur",
  "LT. MOOLCHAND MEENA AGRICULTURE COLLEGE",
  "BHAGWAN SHRI KRISHNA COLLEGE",
  "Sahid Captain Ripudaman Law College, Sawaimadhopur",
  "Adarsh Shikshak Prashikshan Mahavidhyalaya., Jaipur",
  "SHREE VINAYAK COLLEGE TIKRI JAPHRAN MAHUWA DAUSA",
  "Saraswati Girls College, Bayana, Bharatpur",
  "SHREE SHYAM COLLEGE SINDOLI",
  "Government Laxmi Nath Shastri Sanskrit College Chithwari",
  "DIVYA CO EDUCATION COLLEGE AJEETPURA NAGAUR    ",
  "SHRI IMRAT SHIKSHAN SANSTHAN",
  "Government Sanskrit UG College Alwar",
  "Government Sanskrit UG college Kotkasim",
  "Shri Sitarama Modi Government Sanskrit UG college Neem Ka Thana",
  "Sri Kalyan Government Sanskrit PG college Sikar",
  "Darbar Government Sanskrit PG college Jodhpur",
  "Shri Ganga Shardool Government Sanskrit PG college Bikaner",
  "Government Maharaj Acharya Sanskrit College, Jaipur",
  "Shrimati Govindi Devi Sahariya Government Sanskrit UG College Kaladera",
  "MATA GUJRI KHALSA COLLEGE  MIRZE WALA ROAD  SRI GANGANAGAR",
  "Dronachary Mahila Mahavidyalaya Budhi Bawal",
  "SHRI KRISHAN CO-EDUCATION COLLEGE HARSOLI",
  "TILAK INSTITUTE OF MEDICAL SCIENCES",
  "Rajeev Gandhi Balika Mahavidyalya",
  "GOVERMENT GIRLS COLLEGE CHAKSU, JAIPUR",
  "Vivek Mahavidyalaya",
  "Shri Balaji Mahavidyalaya, Deedwana",
  "Laxmibai Mahila Mahavidyalaya, Malpura",
  "LORD SHIVA VIDHI MAHAVIDYALAYA",
  "SHIV CHARAN MATHUR INSTITUTE OF MANAGEMENT AND TECHNOLOGY, BHILWARA",
  "Daswani Dental College and research Centre",
  " GOVERNMENT COLLEGE, KARAULI ",
  "ANIMAL HUSBANDRY DIPLOMA INSTITUTE, CHANDAN JAISALMER",
  "Saraswati Mahila T.T. College, Kerdha, Sawaimadhopur",
  "Sarvodaya T.T. College, Matunda, Bundi",
  "MASTER VIDYARAM COLLEGE, TASIMO",
  "SANKALP COLLEGE PALSANA, SIKAR",
  "Bhagwati Kanya Mahavidhyalaya, Gangapurcity",
  "Swami Vivekanand T.T. College, Bhawanimandi, Jhalawar",
  "Vivekanand T.T. College, Suroth, Karauli",
  "Govt. Engineering College, Jhalawar",
  "INDIA OVERSEAS COLLEGE FOR EDUCATION JAIPUR",
  "R.E.D. Animal Husbandry College (AHDP 29)",
  "Sati Jabde Veterinary Compounder Training Institute (AHDP 04)",
  "Bright Minds Mahavidyalaya, Ranasar",
  "KISHANGARH PG COLLEGE, KISHANGARH BAS",
  "Govt. College Nagar",
  "GOVERNMENT GIRLS COLLEGE, DHOLPUR",
  "SATGURU T.T. COLLEGE ,NARNAUL ROAD SINGHANA",
  "Yogeshwar Mahavidhyalay",
  "GOVERNMENT GIRLS COLLEGE PHALASIA    ",
  "PRABHU DHAN DEGREE COLLEGE, BHORUGRAM",
  "Saraswati PG College, Buhana",
  "DR RADHA KRISHAN COLLEGE KHAIRTHAL HARSAULI ROAD NANGAL SANTOKRA",
  "GOVERNMENT GIRLS COLLEGE KAPASAN",
  "SKN COLLEGE OF AGRICULTURE, JOBNER",
  "KESHAV COLLEGE, KHIRNI TAHSIL MALARNA DUNGAR  DISTRICT SAWAI MADHOPUR",
  "GOVERNMENT COLLEGE MALARNA DUNGAR",
  "INDIAN INSTITUTE OF CRAFTS AND DESIGN",
  "GL MEMORIAL AGRICULTURE COLLEGE",
  "Government Girls College, Duni",
  "Government Girls College, Ladnun",
  "Mahatama Gandhi Teachers Training college, Bharatpur",
  "BHARTI NIKETAN MAHAVIDHALAYA ,SHRI DUNGARGARH",
  "Teja Memorial College, Roopangarh",
  "Rajasthan Livestock Assistant Training School (AHDP 12)",
  "SUNRISE SAHSHIKSHA MAHAVIDHYALAYA THOI",
  "MAULANA AZAD COLLEGE",
  "MAHARSHI DAYANAND SARSWATI MAHAVIDYALAYA PALSANA",
  "Adarsh Pilani college of Animal Husbandry (AHDP 30)",
  "LOTUS COLLEGE OF PHARMACY",
  "GAREEB NAWAZ COLLEGE, BASNI",
  "SHRI GAURISHANKAR BIHANI GOVERNMENT GIRLS COLLEGE, NOHAR",
  "Shri Raghunath Mahavi., Sikar",
  "Shree Kesha Balaji TT College, Sikar",
  "Regional Girls College, Jhunjhunun",
  "Gramin Balika PG Mahavi., Jhunjhunun",
  "Shikshak Prashikshan Mahavi., Alwar",
  "Rao B.Ed. College, Alwar",
  "Shri Radha Swami College, Jaipur",
  "Shri Shirdi Sai Baba Mahila B.Ed. College, Jaipur",
  "Swami Vivekanand PG College, Bharatpur",
  "Shree Bankey Bihari PG Girls College, Bharatpur",
  "Rajasthan College of Edu., Alwar",
  "Vivekanand Mahila Shikshan PRahikshan Mahvi., Dhaulpur",
  "GOVERNMENT COLLEGE KITHANA,CHIRAWA JHUNJHUNJU    ",
  "BLD MEMORIAL COLLEGE",
  "Gyayak Sanskrit UG & TT college",
  "Shri Ratan Singh Boys, College, SRS,  Kumher, Bharatpur",
  "Shree Ram College, Jaipur",
  "Baldev Ram Mirdha College of Science, Didwana",
  "Vivekanand College",
  "Shaheed Bhagat Singh Mahila b.Ed. College, Jaipur",
  "Deepshikha College of Technical Education, Jaipur",
  "Bhagat Singh College, Merta Road",
  "Tagore TT College, Jaipur",
  "Teja Memorial Shikshan Sansthan, Roopangarh",
  "Government College Bajju",
  "Government College Chhatargarh",
  "COLLEGE OF AGRICULTURE, NAVGAON, ALWAR",
  "J.B. Shah Girls (P.G.) College, Jhunjhunu",
  "COLLEGE OF AGRICULTURE KISHANGARHBAS ALWAR",
  "SHRI SANWALIAJI GOVERNMENT COLLEGE,MANDAPHIA",
  "College of Agriculture, Bikaner",
  "Sant Kabir TT College, Jaipur",
  "Radha Krishnan TT College",
  "St. Joseph TT College, Jaipur",
  "GOVERNMENT GIRLS COLLEGE, PHALODI",
  "RPD College, Sitasar",
  "Veer Teja Mahavidyalaya, Jayal",
  "Smt. Madibai Mirdha Government Girls College, Nagaur",
  "SIR PRATAP MAHAVIDYALAYA",
  "MOHANLAL SAHEWAL SMRITI MAHAVIDHYALAYA NOHAR",
  "SHRI SUMER MAHILA MAHAVIDYALAYA, MAHAMANDIR CIRCLE, JODHPUR",
  "CH G R DHAKA PHARMACY COLLEGE    ",
  "ADARSH MAHAVIDHYALAY GHATOL",
  "NETAJI SUBHASHCHANDRA BOSE COLLEGE, KHERLI, TEHSIL KATHUMAR, ALWAR, RAJASTHAN",
  "SHARDA MAHAAVIDYAALAY CHOMU JAIPUR ",
  "Mahatma Gandhi TT College, Dausa",
  "Shri Digamber Jain Acharya Sanskrit Mahavidyalaya, Jaipur",
  "S.P. Rugta Sanskrit PG College",
  "Vardhamana TT College",
  "Shri Lalbahadur Shastri TT College",
  "Shri Banwar Sanskrit UG college",
  "Shri Raghunath TT College",
  "Sri Sanathana Dharma Sanskrit UG college",
  "Ambica Sanskrit TT college",
  "Nehru Sanskrit UG college",
  "Karuna TT College",
  "Shrimati Sarala Parasaramapuriya Sanskrit TT College",
  "Vardhamana TT College",
  "Amichand Memorial Sanskrit TT College",
  "R.N.T. College of Teachers Education",
  "VINAYAK COLLEGE KUCHAMAN CITY",
  "Ryan College of Education & Technology Center, Jaipur",
  "B R Kabra Kuchaman Mahila Shikshak Prashikshan Mahavidyalaya",
  "K.C.P. Mahavidyalaya, Kuchaman City",
  "KUCHAMAN COLLEGE OF EDUCATION U G COURSES",
  "PSB COLLEGE NANA",
  "Shree Tagore College, Kuchaman City",
  "Kumari Lakshmi Badhala Education and Research Institute",
  "Sanjay TT College, Jaipur",
  "SHRI NARAYAN MAHAVIDYALAYA, KUCHAMAN CITY",
  "SHRI TAGORE TEACHERS TRAINING COLLEGE, KUCHAMAN CITY",
  "SAYALA COLLEGE SAYALA",
  "S S Jain Subodh PG Mahila College, Jaipur",
  "VIVEKANAND COLLEGE, KHOOR, SIKAR",
  "DCS Mahila T T College, Jaipur",
  "SHRI DHARAM CHAND GANDHI JAIN GOVERNMENT COLLEGE, BEHROR",
  "Pandit Badri Prasad Shikshak Prashikshan Mahavidyalaya , Kolana, Bandikui",
  "GEETANJALI COLLEGE OF NURSING",
  "UTKARSH MAHAVIDHYALAYA DHOLIYA BHATA KOJA DHORIMANNA",
  "R R YOGA COLLEGE",
  "GOVT AGRICULTURE COLLEGE, DHOLPUR",
  "Smt. Anar Devi Mahila Mahavidyalaya, Jaipur",
  "Hans College, Jaipur",
  "VIVEKANAND YOG MAHAVIDYALAYA MANOHARPUR",
  "GURUKRIPA MAHAVIDYALAYA",
  "Sri Balaji TT College, Jaipur",
  "KRISHNA MAHAVIDYALAYA",
  "KRISHNA MAHAVIDYALAYA",
  "INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "GENIUS COLLEGE BAKANI DISTRICT JHALAWER",
  "Ummed Singh Bhati Ayurved Nursing Training Centre,Abu Road",
  "Sarvodaya Ayurved Nursing Training Centre, Bundi",
  "Vidya Sagar Mahila Mahavidyalaya, Jaipur",
  "CAMBRIDGE COLLEGE OF NURSING BARMER",
  "GANDHI YOGA AND NATUROPATHY INSTITUTE, MANSAROVAR, JAIPUR",
  "YUVA JAGRITI YOG PRASHIKSHAN MAHAVIDYALAYA BANSUR ",
  "LOKMANYA TILAK DEGREE COLLEGE",
  "MAA BHARTI PHARMACY CCOLLEGE",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE, JOJAWAR, PALI, RAJASTHAN",
  "S S G Pareek P G Girls College, Jaipur",
  "ARYA PHARMACY GRADUATE COLLEGE",
  "Rajeev Gandhi Ayurved Nursing Training Centre,Hindaun City",
  "Om Shiv Ayurved Nursing Training Centre,Mangalwad Choraha",
  "SARKAR PHARMACY COLLEGE",
  "RBS PARAMEDICAL COLLEGE NAYA SANWARA TEH PINDWARA SIROHI",
  "Naurang Ram Dayanand Dhukiya Ayurved Nursing Training Centre, Jhunjhunu",
  "MURLI MEMORIAL COLLEGE OF PHARMACY",
  "S A S VIPRA LAKECITY COLLEGE",
  "Mewar Education Society Ayurved Nursing Training Center, Chittorgarh",
  "INSTITUTE OF PUBLIC HEALTH RUHS",
  "SHIV SHAKTI MAHAVIDHALYA NAGAR FORT ",
  "Mahatma Jyotiba Phoole Ayurved Nursing Training Centre,Chaumu",
  "ADARSH NAVODAYA MAHAVIDHYALYA, GANESH NADA, MERTACITY",
  "Madhuban Shikshan Sansthan Ayurved Nursing TrainingCentre, Jodhpur",
  "GOVERNMENT COLLEGE BHUSAWAR BHARATPUR",
  "Kala Asram Ayurved Nursing Training Centre, Udaipur",
  "VIVEK PG MAHAVIDYALAYA, LAHAN PALDA TONK",
  "SUJAS COLLEGE,SIKAR",
  "Marwar Shikshak Prakshikshan Mahavidyalaya, Khasra No. 73/5, Mandalnath Chouraha, P.O Mandore, SH-61, Daijar, Jodhpur",
  "Central Modern Tearcher Training College",
  "Netraheen Vikas Sansthan, B.Ed. College, D- Sector,  Kamla Nehru Nagar, Jodhpur",
  "Lucky Institute of Professional Studies, ESI Hospital Road, Kamala Nehru Nagar, Jodhpur",
  "Maharshi Dadhich Mahila Mahavidyalaya, Madhuvan Basni, Jodhpur",
  "Bharti Mahavidyalaya, Jaipur",
  "National TT College for Girls, Alwar",
  "PODDAR INTERNATIONAL COLLEGE OF PHARMACY",
  "TRINITY COLLEGE CHHOTI SARWAN",
  "DEENDAYAL SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA",
  "SHREE R. R. COLLEGE WEIR, BHARATPUR",
  "Government College Rawatbhata",
  "Government College Gogunda",
  "Government College Karanpur",
  "GOVT COLLEGE SEDWA",
  "Shri BL Memorial Shikshak Prashikshan Mahavi., Jaipur",
  "GURUKUL COLLEGE, KUCHAMANCITY",
  "dholpur college of science and arts dholpur ",
  " Aishwarya College of Education LAW",
  "Asian Mahavidyalaya, Jaipur",
  "Shri Khandelwal Vaish P G Mahavidyalalay, Jaipur",
  "S S Jain Subodh Commerce & Arts College, Jaipur",
  "Shaheed Bhagat Singh Law College, Jaipur",
  "Govt. P G College, Dausa",
  "New Adarsh College, Jaipur",
  "B.S.N. College, Jaipur",
  "Bharat Women B.Ed. College, Digari Kalan, Jodhpur",
  "Shri Mahalaxmi Mahila Shikshak Prashikshan Mahavidyalaya , Sector-E, Pratap Nagar, Jodhpur",
  "Gyandeep Shodh Avam Shikshan Sansthan , 78, Laxmi Nagar, Paota C-Road, Jodhpur",
  "Aman Mahila Teachers Training College, 3/9 Kudi Bhagtasni Housin Board, Jodhpur",
  "Chopasni Teachers Training College, Chopasni, Jodhpur",
  "Onkarmal Somani College of Commerce, 1-Pulia,Chopasani Housing Board, Jodhpur",
  "childrens academy intregrated degree college",
  "RPS DEGREE COLLEGE SIDHMUKH",
  "SS yoga college",
  "GURUKUL COLLEGE OF EDUCATION",
  "SPBR College of Education Saipau Dholpur",
  "Mahila Teachers Training College, Soor Sagar Road, Kamla Nehru Nagar,Jodhpur",
  "Vidhyashram Institute of Teachers Training, Uchiarda, Jodhpur",
  "Sanskar Mahila Shikshan Prakshikshan Mhavidyalaya, Shanti Priya Nagar, OPP Dev Nagar, Jodhpur",
  "Shri Mahalaxmi Girls College, Sector-E, Pratap Nagar, Jodhpur",
  "Rajmata Vijay Raje Scindia, Teachers Training College, Near Pratap Nagar Thana, Kamla Neru Nagar Jodhpur",
  "AMRITA DEVI COLLEGE OF NURSING,BALOTRA",
  "ADARSH COLLEGE OF NURSING ",
  "AMBIKA SCHOOL OF NURSING",
  "BHUPAL NOBLES INSTITUTE OF PHARMACUTICAL SCIENCES, UDAIPUR",
  "BHARTIYA PASHUPALAN NIGAM LIMITED, PASHUPALAK KAUSAL PRASHIKSHAN KENDRA",
  "UTKARSH MAHAVIDHYALA, SAJJAN GARH",
  "Trinity College, Dalot",
  "SWAMI VIVEKANAND COLLEGE",
  "SONIKSKI GIRLS COLLEGE",
  "SIDHESHWAR VINAYAK TEACHERS TRAINING COLLEGE, DHARIYAWAD",
  "Aayushman Institute of Medical Science and College of Nursing",
  "MURLI MEMORIAL T T COLLEGE ",
  "SIDDHESWER VINAYAK ARTS COLLEGE DHARIYAWAD",
  "SHRI SHYAM B V V COLLEGE , ANANDPURI ",
  "SHRI NATH JI COLLEGE, GARHI",
  "SHRI GOVIND GURU  GOVT.  COLLEGE, BANSWARA",
  "SHREE VIPUL COLLEGE",
  "UNIVERSITY COLLEGE OF UNANI, YUSUFPURA CHARAI",
  "SHIVANKARI COLLEGE KASARWADI",
  "SARYODAYA MAHAVIDHYALAYA, NAYAPADARIYA, BAGIDORA",
  "Sarvodaya mahila College",
  "SARAWATI VIMANDIR, GHATOL",
  "Swami Vivekanand Mahila Mahavidhyalaya, Roopangarh",
  "Amar Jyoti College, Dawal",
  "Saraswati College, Saredi Badi",
  "RAHUL CHANDIJA MEMORIAL COLLEGE, BHANPUR KALAN",
  "Aravali College of Nursing, Udaipur",
  "Mahaveer International Agriculture College ",
  "Maharaja Agrasen Agriculture College, Suratgarh",
  "Surendra Kaur Memorial Agriculture College, Padampur",
  "Swami Shri Prannath Parnami Agriculture College, Padampur",
  "RAVINDRA NATH TAGORE COLLEGE, PIPALKHUNT",
  "RAJ NOBELS DEGREE COLLEGE",
  "Punji Lal Damor Chorasigarh College Simalwara",
  "NEW LOOK GIRLS COLLEGE, PARTAPUR",
  "NEW LOOK GIRLS COLLEGE, LODHA CAMPUS",
  "M.V.M.TEACHERS TRAINING COLLEGE",
  "MSRD TEACHERS TRAINING COLLEGE",
  "M.P. COLLEGE, PALODA",
  "M.B. MAHILA TEACHERS TRAINING COLLEGE",
  "MANSI MAHILA MAHAVIDHAYALAYA, ANANDPURI",
  "MANAS MAHAVIDHYALAYA CHITRI",
  "MANAS COLLEGE, OBRI",
  "MAHILA COLLEGE,  TRIVEDI MEWARA HOSTEL BHAWAN, GOMATHWARA ROAD, SAGWARA",
  "MAHAVEER B.Ed. COLLEGE ,DANGAPARA",
  "MAHATMA GANDHI COLLEGE",
  "RUHS DENTAL COLLAGE OF SCINECES",
  "Mascot College ",
  "M WINGS GIRLS COLLEGE RENWAL MANJI PHAGI JAIPUR",
  "MAHATMA GANDHI B.ED. COLLEGE, POST BADLIYA,  TANTIYA CHOURAHA",
  "ARYAN PG COLLEGE DANTA RAMGARH",
  "MAA SHARDE COLLEGE, GANGARATLAI, BANSWARA",
  "MAA BHARTI COLLEGE",
  "LEO COLLEGE",
  "UJJAWAL VIKRAM LAW COLLEGE",
  "SHRI AAI JEE MARWAR MAHAVIDHYALAYA, BILARA",
  "Smt. Barji Devi Girls college",
  "VSOCH  COLLEGE, SIYAT",
  "JAGADGURU KRIPALU MAHAVIDHYALAYA, JASRAPUR",
  "LBS GANODA",
  "L.B.S. COLLEGE",
  "LATE. SHRI P.P. COLLEGE , PARTAPUR",
  "JAMBUKHAND MAHAVIDHYALAYA",
  "IDEALS  COLLEGE",
  "Harideo Joshi Rajkiya Kanya Mahavidyalaya,Banswara (Rajasthan)",
  "HARISH ANJANA COLLEGE, CHHOTISADRI",
  "GYAYAK COLLEGE, RATAN HOUSE, GAMATHWADA ROAD, SAGWARA",
  "Gyaanmoorti Mahavidhylaya",
  "GURUKRIPA SHIKASHAN SANSTHAN COLLEGE,PEETH",
  "Shri Hari Pharmacy College Hanumangarh Road Sardarshahar",
  "GOVT. P.G.COLLEGE, PRATAPGARH",
  "Dr. Bhim Rao Ambedkar Government College, Sri Ganganagar, Rajasthan",
  "INDIAN COLLEGE OF TEACHER TRAINING",
  "SIDDHI VINAYAK COLLEGE ",
  "Naveen Vidyapeeth T.T. College, Nimbhijodha, Ladnun",
  "COLLEGE OF AGRICULTURE HANUMANGARH",
  "UMD MAHARANI COLLEGE FOR WOMENS",
  "GR MEMORIAL GIRLS COLLEGE ",
  "P K MEMORIAL MAHAVIDALAYA  TITPURI",
  "GOVT COLLEGE RISHABHDEO",
  "College of Agriculture Mandor Jodhpur",
  "Shri Shiva Adarsh Shikshan Prashikshan Avam Sodh Sansthan (B.E.D. College) Barni Khurd , Jodhpur",
  "Maharaja Ganga Singh Dental College",
  "K S MEMORIAL COLLEGE OF PHYSIOTHERAPY JODHPUR",
  "GAJENDRA SINGH SHAKTAWATGOVERNMENT GIRLS COLLEGE BHINDER",
  "LEELAWATI COLLEGE",
  "SMT MANJU DEVI MEMORIAL GIRLS COLLEGE",
  "SUMITRA MEMORIAL MAHAVIDYALAYA SINGRAWAT",
  "SANWARIYA COLLEGE SALUMBER",
  "SUNRISE COLLEGE JHALLARA",
  "SHRI ABHIMANYU GIRLS COLLEGE",
  "MAA BHARTI MAHAVIDYALAYA, Kuchaman City",
  "COLLEGE OF AGRICULTURE DUNGARPUR",
  "M G D GIRLS COLLEGE",
  "SHRI DWARIKA PRASAD GIRLS T T COLLEGE SARSENA WEIR BHARATPUR RAJASTHAN",
  "BRP COLLEGE GHUGHRAI KAINTHARI SAIPAU DHOLPUR",
  "GOVERNMENT COLLEGE UDAIPURWATI",
  "LAL BAHADUR SHASTRI GOVERNMENT COLLEGE, KOTPUTLI",
  "GOVERNMENT COLLEGE SARMATHURA",
  "MASTER BHANWARLAL MEGHWAL GOVT GIRLS COLLEGE SUJANGARH",
  "GOVERNMENT COLLEGE HINDOLI ",
  "GOVERNMENT GIRLS COLLEGE NOKHA",
  "GOVERNMENT GIRLS COLLEGE SHRI DUNGARGARH",
  "GOVERNMENT COLLEGE HADAN KOLAYAT BIKANER",
  "Madhav College Of Nursing",
  "KAUTILYA COLLEGE OF EXCELLENCE JAIPUR",
  "RG TEACHER TRAINING COLLEGE",
  "ARYAN INTERNATIONAL COLLEGE NAREHADA",
  "MAHATMA GANDHI INSTITUTE OF HEALTH INFORMATICS",
  "RUHS COLLEGE OF NURSING SCIENCES",
  "THE IMPULSE COLLEGE LALSOT",
  "RAMANAND MAHAVIDHYALAYA, THANAGAZI",
  "Gayatri College Of Nursing",
  "MAHARSHI VALMIKI COLLEGE GHATOL DIST BANSWARA",
  "SAGAR COLLEGE  PIPALDA ",
  "MEERA KESHAV SAHESHIKSHA SHIKSHA SHASTRI COLLEGE",
  "EKKIISS COLLEGE",
  "KHAIRTHAL COLLEGE KHAIRTHAL",
  "SAINT SOLDIER COLLEGE OF PHARMACY TONK",
  "RUNICHA MAHAVIDYALAYA JAISALMER",
  "OM SHIV SANSTHAN COLLEGE SAGWADIYA NIMBAHERA",
  "KPS COLLEGE",
  "Kisan Law College",
  "B LAL INSTITUTE OF NURSING AND TECHNOLOGY",
  "IDEAL COLLEGE",
  "GOVT COLLEGE BHADRA",
  "SHRI RANA COLLEGE OF PHARMACEUTICAL SCIENCE BORAWAR",
  "SARITA MAHAVIDHALYA",
  "Shiv Mahavidyalaya",
  "Gokulpura Shikshak Prashikahan Mahavi., Sikar",
  "AMRIT NATH COLLEGE",
  "MAA BHARTI NURSING COLLEGE",
  "MUKESH MAHAVIDYALAYA",
  "VATSALYA ACADEMY COLLEGE BHADSODA",
  "SMT MOTADEVI COLLEGE MAHWA",
  "Sardar Patel Education College, Baran",
  "Arawali Kanya Mahavidhyalaya, Itawa, Kota",
  "MAHI GIRLS COLLEGE BANEDIYA KHURD PRATAPGARH RAJASTHAN",
  "ASHOK MAHAN MAHAVIDYALAYA",
  "GURUKRIPA MAHAVIDHYALAY PADLI DUNGARPUR",
  "SANSKAR GIRLS COLLEGE",
  "GOVERNMENT COLLEGE, CHHABARA",
  "JIET Institute of Design and Technology",
  "Institute of Professional Studies Research (law) ",
  "DR RAJENDRA PRASAD COLLEGE OF PHARMACY ",
  "TRINITY COLLEGE OF PHARMACY",
  "MAHATMA GANDHI OCCUPATIONAL THERAPY COLLEGE ",
  "GLOBAL COLLEGE",
  "SHRI AATM VALLABH JAIN GIRLS (P.G.) COLLEGE",
  "NAVJEEVAN NURSING COLLEGE LALSOT ",
  "Kothari T.T. College, Sankhan Tal",
  "Sant Nekiram T.T.College, Sitsar",
  "Eklavya Vidhyapith Mahavidyalya, Bhadra",
  "VIDYA BHARTI TEACHERS TRAINING COLLEGE, BHIMAL, MAVLI-DABOK ROAD",
  "COLLEGE OF AGRICUTLTURE BHILWARA",
  "Muslim Balika Mahavidyalaya, Jaipur",
  "S K D T T MAHILA COLLEGE RAMGARH PACHWARA",
  "M D COLLEGE OF EDUCATION",
  "Kanoria Mahavi., Jhunjhunun",
  "Shri Krishan Shikshan Sansthan B.Ed. College, Jaipur",
  "BALAJI COLLEGE OF EDUCATION",
  "Salasar Balaji Veterinary Institute",
  "Anuradha Mahila Shikshak Prashikshan Mahavi., Jaipur",
  "Marudhar Mahila Vidhyapeeth College, Pallu",
  "Keen College",
  "Sharda College of Arts & Science",
  "M.D. B.Ed. College, Pallu",
  "Bal Vikas Adarsh Mahavidyalaya, Chakdai das Pura",
  "Global Institute of Technology,Jaipur",
  "Sine International Institute of Technology,Jaipur",
  "KIRTI MAHAVIDYALAYA NAINWA",
  "SARASWATI YOGA COLLEGE GONER ROAD JAIPUR",
  "R M B K YOGA MAHAVIDHALAYA HEERAWALA JAMWARAMGARH JAIPUR",
  "SHREE BHARTI YOGA TRAINING COLLEGE",
  "RAHUL CHANDIJA MEMORIAL YOGA MAHAVIDHYALAYA",
  "MOOLRAJ MAHAVIDYALAYA GADRA ROAD",
  "MAHATMA JYOTI RAO PHOOLE SHIKSHAN SHANSTHAN  LSAT",
  "Shekhawati Veterinary Institute  ",
  "SWAMI VIVEKANANDA COLLEGE TIBBI",
  "ADARSH COLLEGE,SIYANA",
  "UNIVERSAL YOGA AND NATUROPATHY AND RESEARCH COLLEGE ",
  "GOVERNMENT LAW COLLEGE SANGANER, JAIPUR",
  "Government College, Jayal",
  "Government College, Makrana",
  "SWAMI VIVEKANAND COLLEGE OF PHARMACY, BHAWANIMANDI, JHALAWAR",
  "ANAND SHIKSHAK PRASHIKSHAKN MAHAVIDHYALAYA",
  "G L MEMORIAL COLLEGE",
  "Shri Arjuna Rama  TT College",
  "Shri Raghunath Bishnoi Memorial College, Raniwara",
  "Kshetra Pal Mahavidyalaya, Desuri",
  "Sucheta Kriplani T.T. College, Manaklav",
  "Kanku Vijay T.T. College",
  "Bhartiya Vidya Mandir Mahila Teachers Training College",
  "Ashwasan Mahavidyalaya Education & Research Centre, Bagawas",
  "Aravali Mahavidyalaya, Sumerpur",
  "MOTHER TERESA COLLEGE FOR GIRLS",
  "Leela Devi Parasmal Sancheti Kanya Mahavidyalaya, Rani",
  "G.S. Jangid Teachers Training College for Women, Gangana",
  "Mahipal Shikshan Sansthan, Tinwari",
  "Keru Mahila Shikshak Prashikshan Mahavidyalaya, Keru",
  "Shri Khaiteshwar Mahavidyalaya, Nandri",
  "Bhagwan Mahaveer College, Balotra",
  "D.R.J. Government Girls College, Balotra",
  "Pokhran Teacher's Training College, Pokhran",
  "Ram Dev Shikshak Prashikshan Mahavidyalaya",
  "Lord Shiva Girls T.T. College, Bhinmal",
  "Shree Bhagwan Mahaveer B.Ed. College, Sanchore",
  "Shanti Nath Vidya Bharti T.T. College",
  "Smt. Dhapu Devi Memorial Mahavidyalaya",
  "P.L.V. Memorial College, Shikargarh",
  "Aishwarya College, Sojat Road",
  "Adarsh Mahila Shikshak Prashikshan Mahavidyalaya, Bilara",
  "Padam Shri Vijaydan Detha Mahila Mahavidyalaya, Borunda",
  "R G Mishra B.Ed. College, Alwar",
  "Rao Umrao Singh TT College, Alwar",
  "S.B.K. Government College, Jaiselmer",
  "SHREE DIGAMBAR DEGREE COLLEGE OF NURSING, BHARATPUR",
  "SHRI BALAJI COLLEGE OF PHARMACY, ALWAR",
  "SHARDA COLLEGE OF NURSING, ALWAR",
  "SAMVARDHANA COLLEGE OF NURSING, ALWAR",
  "COLLEGE OF NURSING HARISH HOSPITAL, ALWAR",
  "BANSUR COLLEGE OF NURSING, ALWAR",
  "ATHINA NURSING COLLEGE, ALWAR",
  "MITTAL COLLEGE OF NURSING, AJMER",
  "SANJIVAN COLLEGE OF PHARMACY, DAUSA",
  "RAJASTHAN COLLEGE OF NURSING, DAUSA",
  "SHRI BAJRANG COLLEGE OF PHARMACY, BHARATPUR",
  "MEWAR GIRLS INSTITUTEITUTE OF NURSING, CHITTORGARH",
  "S TECH COLLEGE OF NURSING, BHILWARA",
  "S M S COLLEGE OF NURSING, AJMER",
  "AANASAGAR MAHILA T T COLLEGE RANGBARI, KOTA",
  "MATA BHAGWATI DEVI DEV SANSKRITI MAHILA MAHAVIDYALAYA SISWALI, BARAN",
  "MAHARSHI DAYANAND MAHAVIDYALAYA SISWALI, BARAN",
  "Rao Sohan Lal College, Alwar",
  "PATAN GIRLS COLLEGE KESHORAIPATAN, BUNDI",
  "INDIRA GANDHI T T COLLEGE DEVPURA, BUNDI",
  "PANDIT DEENDAYAL UPADHYAY MAHILA T T COLLEGE BAPJI NAGAR, BARAN",
  "Ramanujan College of Edu., Alwar",
  "S W S College, Jaipur",
  "Pannadhay College",
  "Bajrang PG College, Rudawal, Bharatpur",
  "Sand Dunes B.Ed. College, Jaipur",
  "VIVEKANAND COLLEGE OF NURSING",
  "GOVERNMENT COLLEGE, JASRASAR",
  "Shri Pratap Singh Barahat Government College, Shahpura",
  "P D COLLEGE OF PHARMACY",
  "SHRI BALAJI PHARMACY COLLEGE, KALWAR ,JAIPUR ",
  "NIRMAL COLLEGE OF PHARMACY",
  "BHAGWAN MAHAVEER INSTITUTE OF PHARMACY, VILL  KACHROLI, TEH HINDAUN CITY KARAULI",
  "VIVEKANAND PHARMACY COLLEGE ",
  "GOVERNMENT COLLEGE OF NURSING NAWA,NAGAUR",
  "ARYAN COLLEGE OF PHARMACY NH  SHISHU RANOLI SIKAR ",
  "JAWAHAR VIDHYAPEETH COLLEGE OF PHARMACY",
  "RAJKIYA KANYA MAHAVIDYALAYA PARASRAMPURA",
  "SHREE KRISHNA MAHAVIDHYALAYA, SIKANDRA (DAUSA)",
  "S D CO EDUCATION COLLEGE TIBBI",
  "JIWANI SHIKSHA SASTRI COLLEGE",
  "SHREENATH COLLEGE",
  "GOVT COLLEGE BISSAU, MANDAWA, JHUNJHUNU",
  "GOVT GIRLS COLLEGE AJITGARH",
  "GOVERNMENT GIRLS COLLEGE, NARAYANPUR, ALWAR",
  "GOVERNMENT COLLEGE SUROTH",
  "GOVERNMENT GIRLS COLLEGE, SUKAR",
  "Shri Rajendra Suri Kundan Jain Rajkiya Mahila Mahavidyalaya, Jalore",
  "GOVERNMENT COLLEGE, WAZIRPUR",
  "GOVERNMENT AGRICULTURE COLLEGE GOGUNDA",
  "GOVERNMENT AGRICULTURE COLLEGE RAWATBHATA",
  "GOVERNMENT COLLEGE KAILASH NAGAR, SIROHI",
  "Tagore Adarsh PG College, Jaipur",
  "GOVERNMENT COLLEGE, BADGAON",
  "GOVERNMENT COLLEGE VALLABHNAGAR",
  "GOVERNMENT COLLEGE GEEJGARH",
  "SARVODAYA LIVESTOCK DIPLOMA TRAINING INSTITUTE ",
  "SIDDHARTH LIVESTOCK ASSISTANT DIPLOMA TRAINING INSTITUTE ",
  "SHRI R N COLLEGE, SALASAR (SUJANGARH)",
  "SHRI ARJUN YOG MAHAVIDYALAYA ANTELA",
  "ARYA GIRLS COLLEGE HAMIRWAS",
  "BIRLA INSTITUTE OF TECHNOLOGY OFF CAMPUS JAIPUR",
  "SARDAR PATEL COLLEGE OF PHARMACY LOSAL",
  "KMMP COLLEGE",
  "Takshila Women College, Alwar",
  "M R S SHRI KRISHANA PRANAMI MAHILA SHIKSHAK PRASHIKSHAN COLLEGE BHADRA",
  "Poddar Shikshan Sansthan, Alwar",
  "Poddar Mahavidyalaya, Alwar",
  "Northern Inst. of Learing & Mgt., Alwar",
  "Nobles PG College, Alwar",
  "Neelam TT College, Alwar",
  "Modern Mahila B.Ed. College, Alwar",
  "Mastsya College, Alwar",
  "Lord Krishana College of Edu., Alwar",
  "LBS TT College, Alwar",
  "Babu Shri Narayandas Abhinav PG Mahila Mahavidyalaya, Alwar",
  "Baba Shri Narayandash Shikshak Prashikshan Mahila Mahavi., Alwar",
  "SWARGIYA SHREE GURUSHARAN CHHABRA GOVERNMENT COLLEGE, SURATGARH",
  "G.S.G.D. Girls Shikshak Prashikshan College, Padampur",
  "Ch.  Parma Ram Godara T.T. College, Bhadra",
  "Maharaja Agarsen College, Bhadra",
  "Mata Gujri Girls College, Srikaranpur",
  "Shiva Smart College, Sahawa",
  "Shri Nehru T.T. College, Taranagar",
  "S.G.N. Khalsa College, Anupgarh",
  "SAGAR TEACHER TRAINING COLLEG PIPALDA KOTA",
  "Malaram T.T. College, Sankhan Tal",
  "SANT PRANNATH PARNAMI T.T. COLLEGE",
  "Maharshi Dayanand B.Ed. College, Sriganganagar",
  "Govt. Girls College, Sadulshahar",
  "Adarsh Mahila Mahavidhyalya, Taranagar",
  "Shri Hari Shikshan Prashikshan Mahavidhyalay, Sardarshahar",
  "D.A.V. T.T. College, Raisinghnagar",
  "Kalpana Chawala Kanya Mahavidhyalya, Sahawa",
  "Geeta Co-Education T.T. College, Gharsana",
  "GOVERNMENT COLLEGE OF NURSING PALI",
  "Meera Kanya PG Mahavidyalaya, Sangaria",
  "Maa Karni B.Ed. College, Naal",
  "M.D.M. Co-Education B.Ed. College, 12 T.K., Raisinghnagar",
  "GOVERNMENT LAW P. G. COLLEGE BIKANER",
  "S.B.S.  College, Raisinghnagar",
  "Carrier College - Churu",
  "Rajasthan Mahila  T.T. College, Bikaner",
  "Swami Keshwanand G.V. College, Sangaria",
  "Dada Pommaram (PG) Kanya Mahavidyalaya, Srivijaynagar",
  "Shri Trimurti Degree College, Gharsana",
  "D.R. Mahila T.T. College, Sangaria",
  "G.S. G.D. Kanya Mahavidyalaya, Padampur",
  "Vedic Co-Edu. College, Rawatsar",
  "Tilak College - Rampura",
  "G.V. Home Science College, Sangaria",
  "Sh. Shyam Shikshak Prashikshan Mahavidhyalaya, Bhadra",
  "R.S. Memorial Girls College - Rampura Beri",
  "Vivekanand T.T. College, Bhadra",
  "Swami Vivekanand T.T. College, Sinthal",
  "Shripati Kanya Mahavidhyalya, Pilibanga",
  "Ch. M.S.Memorial T.T.College, Taranagar",
  "J.B. Teachers Training Institute, 23 P.T.P., Sadulsahshar",
  "Rajasthan T.T. College, Jaipur-Jodhpur Bypass Road",
  "Kaswan Kanya College, Tibbi",
  "India Mahila T.T. College, Ratangarh",
  "SHRINATH TEACHERS TRAINING COLLEGE, BHIMAL, MAVLI-DABOK ROAD",
  "UNIVERSITY COLLEGE OF HOMEOPATHY KEKRI AJMER",
  "SHREE KANIRAM GIRLS COLLEGE, RAWATSAR",
  "Anand Shikshak Prashikshan Mahavidyalaya, Bharatpur",
  "BHARAT COLLEGE",
  "Government Engineering College Barmer",
  "SHREE SUNDAR COLLEGE ",
  "RMV GIRLS COLLEGE,  NEAR GULAB BAGH ROAD",
  "SALASAR BALAJI INSTITUTE OF TECHNOLOGY",
  "SHRI NARAYAN SHIKSHAN SANSTHAN, KUCHAMAN CITY",
  "S S COLLEGE OF HIGHER EDUCATION",
  "GRG COLLEGE LAXMANPURA DHOLASAR TEHSIL LOHAWAT DISTRICT JODHPUR",
  "MOTHER TERESA MAHAVIDYALAYA RAM NAGAR BARMER",
  "CRM COLLEGE BAIRASAR CHHOTA RAJGARH CHURU",
  "SANT JOGENDRA MAHAVIDHALAYA FATEHPURA KALAN",
  "SHREE VERAI COLLEGE KEELWA SANCHORE ",
  "RAJKIYA MAHAVIDYALAYA, REENGUS, SIKAR",
  "COLLEGE OF AGRICULTURE, JHILAI (NIWAI), TONK",
  "UNIVERSITY COLLEGE OF ENGINEERING, BANSWARA ",
  "Shri Kalyan Rajkiya Kanya Mahavidyalaya, SIKAR",
  "S.M.M. Government Girls College",
  "Sevanand College, Peeplu",
  "Haribhau Upadhyaya Teachers College for Women, Hatundi",
  "MAHATMA JYOTI RAO PHULE COLLEGE",
  "Smt. Hemlata Memorial Girls College, Alwar",
  "SHAHEED BHAGAT SINGH GIRLS BED COLLEGE HINGONIA JHOTWARA JAIPUR",
  "SHRI HARI ADARSH PHARMACY COLLEGE",
  "MAHATMA GANDHI MAHAVIDHALAYA ",
  "Bharti Mahavidyalaya, Dausa",
  "B P Gautam College, Sawar",
  "ENGINEERING COLLEGE BARAN",
  "GOVERNMENT COLLEGE SINDHARI",
  "VIJAY BHARTI COLLEGE BALLABHGARH BHUSAWER BHARATPUR",
  "MAHARAJA AGARSEN COLLEGE",
  "D.B. College, Alwar",
  "SHRI SHYAM KRISHI MAHAVIDYALYA BHADRA",
  "ARYABHATTA COLLEGE OF PHARMACY",
  "KAMDHENU COLLEGE OF VETERINARY SCIENCE",
  "R.R. T.T. COLLEGE SEDWA-BARMER",
  "BHAGAT SINGH MAHAVIDYALAY JAITARAN (PALI)",
  "K G R MAHAVIDHYALAY ",
  "Jaipur Hospital College of Nursing",
  "Bharati Balika Vigyan Mahavidyalaya",
  "B.R. COLLEGE DEGREE COLLEGE,  KHANDELA,  DISTT. SIKAR",
  "SRI BALAJI FIRE AND SAFETY COLLEGE",
  "Government College Bicchiwara",
  "SHRI SHYAM MAHILA MAHAVIDYALYA, BHADRA",
  "TAGORE COLLEGE OF PHARMACY,SHAYAM COLONY, SYAOU GOVINDGARH,JAIPUR",
  "MEHTA COLLEGE OF PHARMACY",
  "DR. RADHA KRISHANAN INSTITUTE OF ANIMAL SCIENCE, KUCHAMAN CITY",
  "SHRI NARAYAN YOGA MAHAVIDHYALAYA, CHOMU",
  "SMT RAMKUMARI INSTITUTE OF NATUROPATHY AND YOGIC SCIENCES",
  "PRIYADARSHINI YOG PRASHIKSHAN SANSTHA",
  "RAJ PHARMACY COLLEGE",
  "SHRI GURU GOVIND SINGH KHALSA SHIKSHAN SANTHAN  SRI KARANPUR",
  "SHRI GOVIND YOG MAHAVIDYALAYA",
  "DEENDAYAL KIRAN TEACHER TRAINING COLLEGE",
  "CHOPASANI MAHAVIDHYALAYA",
  "Punit College",
  "Ravindra Nath Tagore Shikshan Sansthan, Choti Khatu",
  "Satguru Teacher Training College, Lamba Kotra",
  "AMAR JYOTI TEACHERS TRAINING COLLEGE ",
  "MAYUR JAMNA DEVI COLLEGE,NASIRDA",
  "Gramin Mahila PG Mahavi., Sikar",
  "Ekta Mahavidyalaya, Sikar",
  "Sri Kalyan TT College, Jaipur",
  "Dr. Shankar Dayal Sharma P G College, Jaipur",
  "Agrawal Shikshak Prashikshan Mahavi., Jaipur",
  "B R Memorial T T College, Jaipur",
  "Kiran Mahavidyalaya, Jaipur",
  "ICG Inst. of Edu. Research & Development, Jaipur",
  "Meera Keshav Mahila B.Ed. College, Jaipur",
  "Dr. B. Lal Institute of Biotechnology, Jaipur",
  "Baba Gangadas Govt. Girls College, Jaipur",
  "GOVERNMENT COLLEGE JAMDOLI JAIPUR",
  "GOVINDAM LIVE STOCK ASSISTANT DIPLOMA TRANING INSTITUTE",
  "SORABH INSTITUTE OF PHARMACY",
  "SOURABH COLLEGE OF VETERINARY SCIENCE",
  "SORABH AGRICULTURE COLLEGE",
  "Mahatma Jyotiba Fule Mahavidyalaya, Jaipur",
  "Aryan Mahavidyalaya, Jaipur",
  "Gaurav College of Edu., Jaipur",
  "Choudhary TT College, Jaipur",
  "Vedic Balika PG Mahavidyalaya, Jaipur",
  "LIBRA NATIONAL INSTITUTE OF TEACHERS EDUCATION",
  "SHRI JEETENDRA GODARAS SLBS KRISHI MAHAVIDYALAYA JODHPUR",
  "GOVERNMENT AGRICULTURE COLLEGE GUDAMALANI",
  "GOVERNMENT COLLEGE OF AGRICULTURE, BARMER",
  "ROYAL MHAVIDYALAYA",
  "GANPATI COLLEGE OF PHARMACY",
  "Shri Bankey Bihari Kanyalal Mahila College, Bharatpur",
  "Shri S.N. COllege, Bharatpur",
  "Rajasthan B.Ed. College, Dausa",
  "Bharti Vidhyapeeth, Jaipur",
  "Gandi Devi Shikshan Sansthan, Jaipur",
  "SS Jain Subodh Mahila TT college, Jaipur",
  "Akash Mahavidyalaya, Mandawar, Dausa",
  "GOURAV LIVE STOCK ASSISTANT DIPLOMA TRAINING  INSTITUTE ",
  "GURUKUL COLLEGE OF VETERINARY SCIENCE",
  "Sneh Teacher's Training College, Jaipur",
  "Shri Mahaveer Shikshak Prashikshan Mahavi., Jaipur",
  "Sharda TT College, Jaipur",
  "Shri Mahatma Jyotiba Fule Mahila Mahavidyalaya, Jaipur",
  "Sunder Mahavidyalaya, Jaipur",
  "Mayur College, Jaipur",
  "Swami Keshwanand Kanya Mahavi., Sikar",
  "GOVERNMENT COLLEGE VIDHYADHARNAGAR JAIPUR    ",
  "Smt. Harkori Devi Girls TT College, Jhunjhunun",
  "Shekhawati TT Inst., Sikar",
  "Shekhawati PG Mahavi., Sikar",
  "Shekhawati College of Commerce & Sci., Jhunjhunun",
  "Ginni Devi Satyanarayan Shekhsari Kanya PG Mahavi., Jhunjhunun",
  "SHRI KHEMA BABA MAHILAMAHAVIDYALAY , BAYTU",
  "NEETU MEMORIAL COLLEGE MED",
  "Arya Mahavi., Jhunjhunun",
  " AISHWARYA COLLEGE OF IT AND MANAGEMENT, JODHPUR    ",
  "S S S College, Jaipur",
  "AVP Mahila Mahavidyalaya, Dausa",
  "LBS P.G. College, Jaipur",
  "IGM TT College, Jaipur",
  "Kaushalya Devi Balika Mahavidyalaya, Dausa",
  "Tagore PG Girls College, Jaipur",
  "Vinayak PG College, Jaipur",
  "Vedant Mahavidyalaya, Jaipur",
  "Jasoda Devi TT College, Jaipur",
  "Vivekanand College, Alwar",
  "Nav Bharti TT College, Jaipur",
  "Vidhyasthali Mahila Shikshak PRashikshan Mahavi., Jaipur",
  "Shri Sanskar Mahila Mahavidyalaya, Jaipur",
  "Om Shiv Mahila TT College, Dausa",
  "Biyani College of Sc. & Mgt., Jaipur",
  "Tilak PG College, Jaipur",
  "SIDDHI COLLEGE OF EDUCATION",
  "Rajdhani Law College, Jaipur",
  "GOVERNMENT AGRICULTURE COLLEGE, CHURU",
  "GOVERNMENT COLLEGE OF NURSING TONK",
  "KRISHNA COLLEGE OF NURSING .BAWARLA JODHPUR",
  "JAGDISH PHARMACY COLLEGE",
  "Shri Sai Nath Shikshak Prashikshan Mahavidyalaya, Badayali",
  "Shri Shyam Shiksha Shastri Mahavidyalaya, Bhadra",
  "St. Wilfred's P.G. College, Jaipur",
  "MD College, Dausa",
  "Saraswati College of Teacher's Traning, Dausa",
  "Bagru Shikshak Prashikahan Mahavi., Jaipur",
  "S. D. Government College",
  "Dayanand Arya Balika Mahavidyalaya",
  "Laxmi Bai Mahila TT College, Jaipur",
  "Global College, Dausa",
  "Radha Swami PG College, Bharatpur",
  "DRM College, Dhaulpur",
  "SHREE MANGAL PRAGYATA YOGA TEACHER TRAINING COLLEGE",
  "GOVT GIRL COLLEGE SEKHALA ",
  "GOVERNMENT COLLEGE REWTARA",
  "GOVT GIRLS COLLEGE BARODAMEO ALWAR",
  "GOVERNMENT COLLEGE SANKDA",
  "GOVERNMENT COLLEGE KISHANGARH RENWAL ",
  "GOVERNMENT DEAF AND DUMB COLLEGE, JAIPUR",
  "GOVERNMENT GIRLS COLLEGE, MARENA",
  "Govt. Science. College, Sikar",
  "Jobner P G Mahavidyalaya, Jaipur",
  "Target Mahavidyalaya, Jaipur",
  "Vinodini PG Mahavidyalya, Jhunjhunun",
  "Vedanta PG Mahila Mahvi., Sikar",
  "Government College, Bada Kheda, Tatgarh",
  "GOVERNMENT GIRLS COLLEGE",
  "Rajasthan Dental College and Hospital",
  "Shri Vardhman Kanya Mahavidyalaya",
  "D.P.D. COLLEGE, RAJGARH ",
  "Sunrise Gurukul TT College, Sikar",
  "Subhash Vidhya Mandir Shikshak Prahikshan Mahavi., Sikar",
  "Ch. Motaram Meel Memorial Girls College, Padampur",
  "APEX INSTITUTE OF AGRICULTURE AND RESEARCH, RANPUR, KOTA",
  "Smt. Parmeshwari Devi Dhanraj Khetan Kanya Mahavi., Sikar",
  "SHAKTI SARASWATI SHIKSHAN PRASHIKSHAN SANSTHAN,SARDARSHAHAR",
  "Smt. Kunani Devi Mahila PG Mahavi., Jhunjhunun",
  "SHRI SHYAM SHIKSHA SANSTHAN, BHADRA",
  "GURUKUL ARTS COLLEGE",
  "Shri Shyam PG Mahavi., Jhunjhunun",
  "Shri Krishna Satsang Balika PG Mahavi., Sikar",
  "Shri G D Kishan College, Jhunjhunun",
  "Shri Arjun Ram TT College, Sikar",
  "Shekhawati PG College, Sikar",
  "Savitri Bai Phule Mahila Shikshak Prashikahn Mahavi., Sikar",
  "Saraswati TT College., Sikar",
  "Mandiya College, Sikar",
  "Chanchal Ahilya Umrawati Mahila PG, Jhunjhunun",
  "College of Community Science, Bikaner",
  "GOVERNMENT AGRICULTURE COLLEGE PHULIAKALAN, SHAHPURA ,BHILWARA",
  "GOVERNMENT AGRICULTURE COLLEGE KHERWARA",
  "GOVERNMENT COLLEGE, PUGAL",
  "SHREE RNT COLLEGE MUKAM",
  "SHREE NATH PHYSICAL TEACHERS TRAINING COLLEGE",
  "H K M PG COLLEGE  NEW MANDI GHARSANA",
  "Tirupaati College of TEchnical Edu., Jaipur",
  "GOVERNMENT GIRLS COLLEGE, KELWARA ",
  "GOVT COLLEGE, NAHARGARH",
  "GOVERNMENT GIRLS COLLEGE, GANGAPUR CITY",
  "GOVERNMENT YOGA AND NATUROPATHY COLLEGE SIKAR, RAJASTHAN",
  "VINAYAK MAHAVIDYALAYA ANANDPURKALU JAITARAN",
  "GOVERNMENT COLLEGE RAMGARH JAISALMER",
  "GOVERNMENT GIRLS COLLEGE BHOPALGARH",
  "GOVERNMENT AGRICULTURE COLLEGE SAWAI MADHOPUR",
  "GOVERNMENT AGRICULTURE COLLEGE, NAWA, NAGAUR",
  "GOVERNMENT AGRICULTURE COLLEGE,KESHWANA, DIST JALORE",
  "GOVERNMENT AGRICULTURE COLLEGE, DEEDWANA",
  "RAJASTHAN SWASTHYA YOGA AVM CHIKITSA AAKADMI",
  "Navrang Shikshak Prashikshan Mahavi., Jaipur",
  "Shri Narayan Mahavidyalaya, Jaipur",
  "GALAXY COLLEGE",
  "Vansh Higher Edu. Inst., Dhaulpur",
  "Radha Saravershawari College, Bharatpur",
  "Ravindreapal Singh Parmar, Bharatpur",
  "Aatmaram College, Jaipur",
  "AVP PG College, Dausa",
  "Cambridge Court College of Edu., Jaipur",
  "Rajputana P G College, Jaipur",
  "Government College, Nadbai, Bharatpur",
  "Vinayak College, Dausa",
  "Savitri Bai Phule Mahavidyalaya, Jaipur",
  "MASTER HAJARI LAL SHARMA GOVERNMENT COLLEGE, CHIRAWA",
  "Akashdeep TT Girls College, Jaipur",
  "Shiv Saaraswati Mahila TT College, Jaipur",
  "Varda College of Edu., Sikar",
  "Tagore B.Ed. College, Jhunjhunun",
  "GAYATRI PHARMACY COLLEGE VARKANA",
  "Seth Motilal TT Edu. College, Jhunjhunun",
  "Savitri Bai Phoole Mahila Mahavi., Sikar",
  "Sarasawti Vidya Mandir B.Ed. College, Jhunjhunun",
  "Rajasthan TT College, Jhunjhunun",
  "Jagan Shikshak Prashikshan Mahavi., Sikar",
  "Gyandeep P G Mahavidyalaya, Jaipur",
  "Sanskar Mahila Mahavidyalaya, Jaipur",
  "Siddharth Shiksha Sansthan, Jaipur",
  "Mahatma Jyotiba fule Shikshak Prashikshan Mahavi., Jaipur",
  "Aatma Ram TT College, Jaipur",
  "Sh. Agrasen Girls P.G. College, Mahwa",
  "Sant Jayacharya Mahila College, Jaipur",
  "GURU JAMBHESHWAR COLLEGE, RAWATSAR",
  "MAHARAJA SURAJMAL AGRICULTURE COLLEGE, BHARATPUR    ",
  "Vedic Kanya PG Mahavidyalaya, Jaipur",
  "Pt. Deen Dayal Upadhyaya Smiti Mahila TT College, Dausa",
  "Bharat law College, Jaipur",
  "Shri Bhawani Niketan Mahila Mahavidyalaya, Jaipur",
  "Mahatma Gandhi PG College Shrimadhopur Sikar",
  "Smt. Kamla Devi TT College, Jaipur",
  "Vivek Shikshak pRashikshan Mahavi., Jaipur",
  "Maharshi Sandeepani TT College, Jaipur",
  "MAHARISHI VALMIKI GOLLEGE, JOHALANA",
  "Shri Narayan Singh TT College, Jaipur",
  "STAR COLLEGE SATRA",
  "IILM ACADEMY OF HIGHER LEARNING, JAIPUR",
  "B.R. Memorial Mahila Mahavidyalaya, Jaipur",
  "Ujas College of Edu., Jaipur",
  "A.N. College, Jaipur",
  "SLB COLLEGE KATARWARA DAUSA",
  "Manav P G Mahavidyalaya, Jaipur",
  "Compucom Inst. of Infor. Tech. & Mgt., Jaipur",
  "S.R. TEACHERS TRAINING COLLEGE, NADBAI",
  "Shri Bankey Bihari Kanhiya Lal Mahila TT College, Bharatpur",
  "Shree Agrasen Mahila Snatakottar Mahavidyalaya, Bharatpur",
  "ARYAN B.ED COLLEGE",
  "GOVERNMENT COLLEGE, BAMANWAS",
  "J L N DEGREE COLLEGE, SANGOD",
  "GOVERNMENT COLLEGE, SAPOTRA",
  "NEERAJ MOMORIAL MAHAVIDYLAYA, NAGAL SHERPUR, TODABHIM",
  "SWAMI VEVEKANND COLLEGE, BHAWANIMANDI",
  "J D P.G. College, Jaipur",
  "NAVEEN VIDHYAPEETH MAHAVIDYALAYA NIMBI JODHA",
  "GOVERNMENT AGRICULTURE COLLEGE DAUSA",
  "Lokmanya Tilak Degree B.Ed. College, Jaipur",
  "Shaheed Hemraj Meena Government College, Sangod",
  "Arya Mahila T T College, Jaipur",
  "Mahatama Gandhi PG College, Dausa",
  "D C S P.G. College, Jaipur",
  "Subodh TT College, Sikar",
  "Shri Ganesh Mahavidyalaya, Sikar",
  "Shekhawati Gramin Mahavi., Sikar",
  "Saraswati Shikshak Prashikshan Mahavi., Sikar",
  "R P Dular Balika Mahavi., Jhunjhunun",
  "Mohini Devi Goenka Mahila Mahavi., Sikar",
  "Kanoria B.Ed. COllege, Jhunjhunun",
  "Swarup College of Education, Jaipur",
  "Subodh Law College, Jaipur",
  "Vashundhara Mahila Shikshak Prashikshan, Jaipur",
  "B D Memorial B.Ed. College, Jaipur",
  "Rajasthan Shiksha Mahaiv, Jaipur",
  "Shree Teekmani Ved Vedang Sanskrit Mahavidyalaya, Rajasthan",
  "Rajasthan School of Art, Jaipur",
  "Shri Krishan TT College, Jaipur",
  "Universe Arts & bCommerce College, Jaipur",
  "St. Xavier's College PG College, Jaipur",
  "GURUKUL PHARMACY COLLEGE",
  "Sri Balaji P G Mahavidyalaya, Jaipur",
  "TAPOVAN COLLEGE OF SPECIAL EDUCATION AND RESEARCH",
  "Princess B.Ed. College, Jaipur",
  "Shyam TT College, Jaipur",
  "Maa Kesar Devi Girls College, Dausa",
  "RAJKIYA MAHAVIDYALYA BUHANA",
  "Smt. Hemlata Memorial College, Jaipur",
  "GOVERNMENT GIRLS COLLEGE JOJAWAR, MARWAR JUNCATION, PALI",
  "Rekha Shikshak Prashikshan Mahavi., Jaipur",
  "SHREE SANWARLAL  SUSHILA DEVI SUTHAR GOVT. COLLEGE, BIDASAR CHURU",
  "Shree Kkarni Universe College, Mundiya Ramsar, Jaipur",
  "LORD KRISHNA ACADEMY OF HIGHER EDUCATION GIRLS COLLEGE",
  "GOVERNMENTAGRICULTURECOLLEGE,JOGIWALA,BHADRA,HANUMANGARH",
  "SHRI J B DEGREE MAHAVIDHYALY,RAWLA MANDI",
  "Agrawal P.G. College, Jaipur",
  "Bright Moon Girls P.G. College, Jaipur",
  "Ideal Shiksha Sansthan, Hissar Road",
  "Sanskar Women International T.T. College",
  "Government College, Kolayat",
  "BAL BHARTI COLLEGE",
  "Govt. College, Bayana",
  "Choudhary M.S. Memorial College",
  "SMT. PANA DEVI RAMESHWAR LAL SHARMA PG COLLEGE (ADUKA) CHIRAWA",
  "OM SHIV SANSTHAN COLLEGE MANGALWAD",
  "KARUNA COLLEGE OF NURSING",
  "Swami Vivekanand Government College, Khetri, Jhunjhunu",
  "Maa Karni Pashudhan Sahayak Training College",
  "M.D. College, Rawatsar",
  "Shri Dungargarh Mahavidyalaya",
  "Pandit Deen Dayal Upadhyay T.T. College",
  "Pragati Kisan College, Chandgothi",
  "UMANG",
  "Saraswati Shikshan Sadan P G Mahavidyalaya",
  "Mira Girls College, Jaipur",
  "S.G.N. Khalsa (PG) College",
  "GOVERNMENT MEDICAL COLLEGE HANUMANGARH",
  "GOVERNMENT MEDICAL COLLEGE DAUSA",
  "GOVERNMENT COLLEGE MUBARIKPUR ALWAR",
  "SANSKRITI LAW COLLEGE, JAIPUR",
  "GOVERNMENT GIRLS COLLEGE JHALAMAND",
  "GOVERNMENT COLLEGE OF NURSING, RAWATBHATA, CHITTORGARH",
  "GOVERMENT GIRLS COLLEGE JAHAZPUR ",
  "PRANAYRAJ SHSHIKSHA MAHAVIDYALAYA, NACHANA",
  "Government Law College",
  "Maitrai Girls College, Riyan Bari",
  "Dr. Radha Krishan Teachers Training College, Kuchaman City",
  "Smt. N.D.V. Mahila Physical T.T. College (Mahila Ashram)",
  "Shreeji Teachers Training College, Bijolia",
  "Gandhi Teacher College, Gulabpura",
  "Bala Satiji Mahila Shikshan Prashikshan Mahavidyalaya",
  "P D S MAHAVIDYALAYA ",
  "DR. BHIMRAO AMBEDKAR RAJKIYA MAHAVIDHYALAYA, BILARA",
  "GOVERNMENT COLLEGE VIRATNAGAR ",
  "RAJASTHAN COLLEGE OF AGRICULTURE UDAIPUR",
  "RNT College of Agriculture Kapasan",
  "Government College Sajjangarh",
  "DARSHAN MAHAVIDHYALAY",
  "mass college of nursing",
  "LALIMA MAHAVIDYALAYA, TONK",
  "SIKAR COLLEGE OF PHARMACY",
  "GOVT GIRLS COLLEGE MAGRA PUNJALA JODHPUR",
  "GOVT GIRLS COLLEGE CHHABRA ",
  "GOVERNMENT GIRLS COLLEGE LAWAN",
  "government college shahbad baran",
  "Government College, Malsisar (Jhunjhunu)",
  "GOVERNMENT COLLEGE, ITAWA",
  "GOVERMENT COLLEGE REODAR",
  "Govt College Dhorimana",
  "Sanjeevani College of Nursing",
  "Swami Keshvanand Institute of Pharmacy",
  "MAHARSHI KASHYAP COLLEGE",
  "GOVERNMENT COLLEGE, ATRU",
  "MAYUR MAHAVIDYALAYA PANCHALA",
  "Government college Mandrayal",
  "ADITYA MAHAVIDHALAYA",
  "SMT RAM PYARI  DEVI SHIKSHAK PRAKSHISHAN MAHAVIDHYALAY",
  "Mahatma Jyotiba Fule Ayurveda Mahavidyalaya",
  "KALA ASHRAM AYURVED MEDICAL COLLEGE AND HOSPITAL",
  "VISHWA BHARTI GRAMOTHAN MAHAVIDYALAYA RAMGARH SHEKHAWATI ",
  "BHAGWATI MAHILA MAHAVIDHYALAYA BASSI",
  "SMT RAMKUMARI COLLEGE OF YOGA AND NATUROPATHY",
  "SUNDARAM MAHAVIDHYALAYA JHOTHARI",
  "Government college saipau",
  "Mewar Shikshak Prashikshan Shiksha Shastri Mahavidyala",
  "GOVT COLLEGE JAMWA RAMGARH JAIPUR",
  "NAGFANI DEGREE COLLEGE",
  "College of Agriculture Basedi Dholpur",
  "Nehru College of Education Bayana Road Hindaun City ",
  "SANSKAR COLLEGE, DANTA, SIKAR",
  "MANAS GANGA COLLEGE WOMEN",
  "SETH RAMVILASH JOSHI MAHAVIDYALAYA TUNGA BASSI ",
  "DEEPAK GIRLS COLLEGE PAOTA JAIPUR ",
  "MARUDHAR COLLEGE BANSUR",
  "DR RADHAKRISHNAN DEGREE COLLEGE",
  "UNIVERSE TEACHERS TRAINING COLLEGE",
  "GOVERNMENT COLLEGE CHAKSU",
  "SARDAR PATEL P.G. COLLEGE, LOSAL",
  "YADUVANSHI COLLEGE OF EDUCATION SOHALI FOUR YEAR INTEGRATED COURSE",
  "Govt Girls College Pratapgarh",
  "GOVT GIRLS COLLEGE HETAMSAR JHUNJHUNU",
  "SWAMI VIVEKANAND TEACHER TRAINING COLLEGE",
  "RAJSHREE COLLEGE OF NURSING",
  "GOVERNMENT COLLEGE GIDA",
  "ST.J.K.L.TEACHERs TRAINING COLLEGE",
  "GOVERNMENT COLLEGE BONLI SAWAI MADHOPUR",
  "SRI GURU TEG BAHADUR COLLEGE OF EDUCATION",
  "Pratap T.T. College",
  "U.S. OSTWAL INSTITUTE OF PHARMACY",
  "Gyandeep Shikshak Prashikshan Mahavidyalaya",
  "NAVODAYA GIRLS T T COLLEGE MALVIYA NAGAR JAIPUR",
  "LAXMI NARAYAN MEMORIAL COLLEGE SHRI KOLAYAT BIKANER",
  "SMT. REETA CHANDRA SAXENA MEMORIAL COLLEGE (CO-EDU) RINGUS",
  "GOVERNMENT COLLEGE RUPWAS",
  "GOVERNMENT GIRLS COLLEGE KHERLIGANJ, KATHUMAR, ALWAR",
  "GOVERNMENT COLLEGE GANGRAR CHITTORGARH",
  "KARAM BHOOMI YOGA TEACHERS TRAINING COLLEGE",
  "Sanskar Teacher Training College, Peeplu",
  "RAMDEO COLLEGE OF MANAGEMENT AND SCIENCE",
  "Government Girls College Rajgarh Churu",
  "Government College Railmagra",
  "Government college of nursing ",
  "Sri Balaji College Of Pharmacy, JAIPUR",
  "Indian Institute of Teacher Training",
  "Govt College Laxmangarh Alwar",
  "GYANDEEP COLLEGE MAHWA",
  "SWAMI VIVEKANAND MAHAVIDHYALAY PUNALI",
  "Asian College of Pharmacy",
  "AACHARYA CHANAKYA LAW COLLEGE",
  "GOVT COLLEGE, BHACHUNDLA",
  "GYANODYAN MAHILA MAHAVIDYALAYA CHHAPAR",
  "GOVERNMENT GIRLS COLLEGE, SHIVGANJ, SIROHI",
  "GOVERNMENT COLLEGE SIDHMUKH CHURU",
  "GOVT GIRLS COLLEGE KUSHALGARH",
  "GOVERNMENT GIRLS COLLEGE, KUCHAMAN CITY",
  "GOVERNMENT GIRLS COLLEGE , DUDU , JAIPUR",
  "GOVT GIRLS COLLEGE BHIM",
  "THOMAS CANGAN MEMORIAL COLLEGE ",
  "GOVT GIRLS COLLEGE, MAHUWA, DAUSA",
  "KUND KUND KAHAN DIGAMBER JAIN SANSKRIT MAHAVIDYALAY",
  "ADARSH COLLEGE DECHU",
  "GOVERNMENT GIRLS COLLEGE , BADA GUDA , SOJAT CITY",
  "VIVEKANAND YOGA COLLEGE",
  "SUCHETA KRIPLANI MAHAVIDHYALAYA ",
  "GOVERNMENT COLLEGE NEEMRANA",
  "RAMASHRAM MAHAVIDYALYA",
  "GOVERNMENT GIRLS COLLEGE, NASIRABAD",
  "GOVERNMENT GIRLS COLLEGE PRATAPGARH",
  "MEWAR GIRLS AYURVED NURSE COMPOUNDER PRASHIKSHAN KENDRA",
  "YS MEMORIAL  MAHAVIDHYALAYA , BASERI",
  "JANAK NEMSINGH PARMAR MAHAVIDYALAY, JAYSHREE ROAD, SIKRI, TEHSIL NAGAR, DISTRICT BHARATPUR, RAJASTHAN",
  "SHRI SHYAM EDUCATIONAL INSTITUTION",
  "GOVERNMENT COLLEGE, NECHHWA",
  "GOVERNMENT GIRLS COLLEGE, ATRU, BARAN RAJASTHAN",
  "VIVEKANAND MAHAVIDYALAYA, GADHABAS, DEEDWANA",
  "GOVERNMENT GIRLS COLLEGE GUDA",
  "GOVERNMENT GIRLS COLLEGE MANDRELLA",
  "GOVERNMENT COLLEGE, TIBBI",
  "DAKSH MAHAVIDYALAYA,Ed Chhotu",
  "BHAVANI ARTS AND SCIENCE COLLEGE",
  "MAA JWALA COLLEGE OF EDUCATION",
  "PRERNAMURTI COLLEGE CHITRI ",
  "SARASWATI MAHAVIDHYALAYA, MOKHATRA ",
  "GOVERNMENT COLLEGE ASOP",
  "SHREE BALAJI PHARMACY COLLEGE DHINGPUR",
  "SHEKHAWATI VETERINARY COLLEGE",
  "ARJUN COLLEGE OF PHARMACY",
  "Maheshwari P.G. College",
  "GOVERNMENT GIRLS COLLEGE SHAHBAD",
  "MATSYA MAHAVIDHYALAYA, BANSUR",
  "GOVERNMENT COLLEGE OF NURSING BARMER",
  "GOVT GIRLS COLLEGE SALUMBER",
  "DR RK SINGH PHARMACY COLLEGE",
  "Government Law College, Nagour",
  "Government College, Tonk",
  "Government College Pahari",
  "Gargi T T College, Alwar",
  "Durga Devi T T College, Alwar",
  "Dr. Radha Kishan TT College, Alwar",
  "K.R. College, Ajmer",
  "GOVERNMENT COLLEGE SURAJGARH",
  "IPS COLLEGE",
  "Sardar Bhagat Singh College, Goluwala",
  "Government College, Barmer",
  "VEER VIRAMDEV GOVERNMENT POST GRADUATE COLLEGE, JALORE",
  "KAMAKSHI COLLEGE BALOTRA",
  "ACHIEVER MAHAIDHYALAYA, NOHAR",
  "SHREE MURLIDHAR MAHAVIDHALYA, JAITPUR",
  "SADHANA MAHILA MAHAVIDYALAYA, DOOKIYA",
  "Smt Ram Pyari Devi Mahila Mahavidyalaya",
  "SUBHASH VIDHYA MANDIR MAHAVIDHALYA, SEWAD BARI",
  "SHREE RANGEY RAGHAV MAHAVIDYALAYA, WEIR",
  "Parishkar International College",
  "JAI BABA AMARNATH MAHAVIDYALAYA",
  "Dholaplash B.Ed. College, Alwar",
  "SLBS Engineering College,Jodhpur",
  "Surendera Group of Institutions,Sri Ganganagar",
  "Shri Aatam Ballabh Jain Kanya Mahavidyalaya,Shri Ganganagar",
  "Modern Institute of Technology & Research Centre,Alwar",
  "Maharishi Dayanand College",
  "Lucky Institute of Professional Studies",
  "Shri krishna mahila mahavidhylya",
  "Institute of Management Studies, BJS Rampuria Jain College",
  "Govt. Mahila Engineering College,Ajmer",
  "CLG Institute of Engg. & Technology,Sumerpur,Pali",
  "Poornima Group of Institutions, Jaipur",
  "ENGINEERING COLLEGE, JHALAWAR",
  "DEV INTERNATIONAL COLLEGE, ALWAR",
  "ENGINEERING COLLEGE, BHARATPUR ",
  "Vyas Institute of Management",
  "Saint Joseph College",
  "ADARSH TAGORE PREM SHUBHADRA COLLEGE, NADBAI",
  "M G College,  weir Bharatpur",
  "Shri Govind Dev College",
  "VINAYAK LAW COLLEGE, CHOMU",
  "Deep International College of Edu., Alwar",
  "CRC TT College, Alwar",
  "Children's Academy B.Ed. College, Alwar",
  "SHRINATHJI INSTITUTE OF TECHNOLOGY & ENGINEERING, UPALI ODEN, NATHDWARA, RAJSAMAND",
  "HANS LAW COLLEGE, KOTPUTLI",
  "Rajasthan College of Engineering for Women,Jaipur",
  "Jaipur Institute of Engineering & Management,Jaipur",
  "Apex College, Makrana",
  "Gurukul Institute of Engineering & Technology,Kota",
  "Rajasthan Institute of Engineering & Technology,Chittorgarh",
  "Modi Institute of Management & Technology",
  "Sri Balaji College of Engineering & Technology,Jaipur",
  "Rajdhani Engineering College,Jaipur",
  "Anand International College of Engineering",
  "Aishwarya Institute of Management & Information Technology",
  "International School of Informatics & Management",
  "Chandraprabh Dig. Jain Kanya Mahavidyalaya, Alwar",
  "SARASWATI MAHAVIDHYALAYA NEEM KA THANA ",
  "Mahatma Gandhi Engineering College,Jaipur",
  "Jaipur Engineering College,Kukas,jaipur",
  "Swami Keshvanand Institute of Technology, Management & Gramothan",
  "Tirupati College of Technical Education",
  "Vedant College of Engineering & Technology,Bundi",
  "Adarsh Mahavidyalaya, Sikar",
  "Adarsh Rajasthan Mahavi., Jhunjhunun",
  "Adarsh Shikshak Prashikshan Sansthan, Sikar",
  "Ajitgarh College, Sikar",
  "Ambika T T College, Jhunjhunun",
  "Amman T T College, Jhunjhunun",
  "B..L.COLLEGE OF ARTS AND SCIENCE, SHEO",
  "Annapurna Shikshak Prashikshan Sansthan, Sikar",
  "A N TT College, Sikar",
  "Aravali T T College, Sikar",
  "Arya Shikshak Prashikshan Mahavi., Sikar",
  "Baba Ganga nath Co-ed College, Jhunjhunun",
  "Baba Ganganath T T College,Jhunjhunun",
  "Baba Kheenva Das PG Mahavidylaya, Sikar",
  "Baba Narayandas Mahila Shikshak Prashikshan Sansthan, Sikar",
  "Baba Narsingh Das Mahila Shikshak Prashikshan Mahavi., Sikar",
  "Baba Narsingh Das PG College, Sikar",
  "Baba Shayam Rishi Sanskrit Mahila Mahavidyalaya, Sikar",
  "Shri Ratanlal Kanwarlal Patni Girls College, Kishangarh",
  "Baba Umad Singh College, Jhunjhunun",
  "Bagaria B.Ed. College, Sikar",
  "Bal Sadhana Girls College, Jhunjhunun",
  "Bhaliya Devi Balika PG Mahavi., Jhunjhunun",
  "Apex Institute of Engineering & Technology,Jaipur",
  "Chandra Prabha Digamber Jain Mahila TT College, Alwar",
  "BR T T College, Alwar",
  "Jaipur Institute of Technology Group of Institutions,Jaipur",
  "Bhanwar Kanwar Sugan Singh Shiksha Mahavi., Jhunjhunun",
  "Bharatraj Mahavi., Sikar",
  "Bhartiya Balika Shikshak Prashikashan Mahavi., Sikar",
  "Bhaskar Kanya PG Mahavi., Jhunjhunun",
  "Bhura Ram Mahavi., Jhunjhunun",
  "Biff & Bright College of Engg. & Tech. ,Dudu,Jaipur",
  "Acharya Shri Nanesh Samta Mahavidyalaya",
  "Modi Institute of Technology,Kota",
  "Rajasthan Engineering College,Dausa",
  "Techno India NJR Institute of Technology,Udaipur",
  "Apex Institute of Management & Science",
  "Rajasthan Institute of Engineering & Technology,Jaipur",
  "Poornima College of Engineering,Jaipur",
  "Maharishi Arvind Institute Of Science And Management",
  "Manda Institute of Technology,Bikaner",
  "Laxmi Devi Institute of Engineering & Technology,Alwar",
  "G.D. Memorial College of Mgmt & Tech",
  "Engineering College,Ajmer",
  "Biff & Bright College of Technical Education",
  "Stani Memorial College of Engg. & Technology,Phagi,Jaipur",
  "Rajasthan Law College, Jhunjhunun",
  "Poornima Institute of Engineering & Technology,Jaipur",
  "Rakesh Shikshak Prashikshan Mahavi., Jhunjhunun",
  "Rama Devi Mahila Mahavi., Jhunjhunun",
  "Rama Devi Mahila TT College, Jhunjhunun",
  "Ravindra Academy PG Girls College, Jhunjhunun",
  "Sanskar Balika Mahavi., Sikar",
  "Nathdwara Institute of Engg. & Tech.,Nathdwara,Rajsamand",
  "Shankara International School of Management & Research,Jaipur",
  "M.L.V Textile & Engineering College,Bhilwara",
  "B R TT College, Alwar",
  "Khandelwal Vaish Girls Institute Of Technology",
  "Geetanjali Institute of Technical Studies,Udaipur",
  "Rajasthan College Chirawa, Jhunjhunun",
  "Rajasthan Shikshak Prashikshan Mahavi, Chirawa, Jhunjhunun",
  "Swami Vivekanand Inst of Mgmt & Tech",
  "Aayojan School of Architecture,Jaipur",
  "Arya College of Engineering & Research Center,Jaipur",
  "Saraswati TT College, Palsana, Sikar",
  "Regional College for Education,Research & Tech. ,Jaipur",
  "KCP COLLEGE OF PHARMACY",
  "CAMBRIDGE TEACHERS TRAINING INSTITUTE, SHAHPURA ROAD, KANWAT",
  "College of Veterinary and Animal Science, Bikaner",
  "MAHATMA GANDHI MAHAVIDHYALAYA",
  "MAMTA INSTITUTE OF TECHNOLOGY",
  "MAMTA YOG MAHAVIDHYALYA",
  "STECH GILRS COLLEGE",
  "MJD COLLEGE FOR HIGHER EDUCATION NEAR NANUWALI KOTHI RAISINGHNAGAR  ",
  "R R COLLEGE OF VETERINARY AND ANIMAL SCIENCE DEOLI",
  "Sardar Patel B.Ed. College, Sikar",
  "Sardar Patel College, Sikar",
  "Seth Gyaniram Bansidhar Podar College, Nawalgarh",
  "Seth GR Chamria PG College, Sikar",
  "Seth Gyaniram Bansidhar GB Podar TT College, Nawalgarh",
  "Seth Motilal PG College, Jhunjhunun",
  "Shadi Lal Kataria Memorial Women's TT College, Jhunjhunun",
  "Shaheed Bhagat SIngh Law College, Sikar",
  "Sharwani Jhajharia Inst. of Edu., Jhunjhunun",
  "Shekhawati KanyaMahavi., Jhunjhunun",
  "Shekhawati Mahavidyalaya, Losal",
  "Shekhawati Mahila Shikshak Prashikshan Mahavi., Sikar",
  "Shekhawati M.Ed. College, Dundlod",
  "Shekhawati TT College, Jhunjhunun",
  "Shekhawati TT College., Jhunjhunun",
  "SHREE BALAJI COLLEGE OF PHARMACY BHILWARA ",
  "SHRI KALYAN COLLEGE ",
  "VIVEKANAND PHARMACY COLLEGE DHOLPUR",
  "GOVERNMENT GIRLS COLLEGE SAMBHAR LAKE ",
  "GOVERNMENT COLLEGE BIRMANA",
  "GOVERNMENT GIRLS COLLEGE, PADAMPUR",
  "GOVERNMENT GIRLS COLLEGE, CHUNAWADH",
  "GOVERNMENT GIRLS COLLEGE, KHINWSAR",
  "SMD COLLEGE",
  "PRINCESS GIRLS COLLEGE KHATUSHYAMJI",
  "Birbal Memoroal TT College, Alwar",
  "Bhartiya T T College, Alwar",
  "Bhartiya Prashikshan Sansthan, Alwar",
  "MADHU MADHAV COLLEGE",
  "PIYUSH COLLEGE",
  "ASHWINI BALIKA MAHAVIDYALAYA, BAY",
  "SHRI ARJUNRAM MAHAVIDHYALAYA",
  "Biyani Law College",
  "Smt. Chandrawal Gupta College, Reodar",
  "PRABHA DEVI MEMORIAL MAHAVIDHAYALA, KABARI, DOONGRI, MUNDOTA",
  "Bhartiya College, Alwar",
  "Aaryan Mahila Mahavidyalaya, Shishu",
  "Government College, Bijaynagar",
  "GURUKRIPA COLLEGE, TOSHINA",
  "GOVERNMENT GIRLS COLLEGE, MANDAL",
  "Institute of Advance Studies in Education",
  "M.L.V. Government College",
  "Saraswati Mahavidyalaya, Manda, Basni Road, Deedwana",
  "SUJAS MAHAVIDYALAYA, Baneda",
  "Behror College, Alwar",
  "VIVEKANAND MAHAVIDHYALYA, MAULASAR",
  "SMT. VINOD COLLEGE OF EDUCATION, JHUNJHUNU",
  "Shri Subhash College ",
  "RADHIKA TEACHER TRAINING COLLEGE BHANDAREJ DAUSA",
  "GEETANJALI PHARMACY COLLEGE BORAWAR",
  "RAGHUKUL COLLEGE OF PHARMACY , KOTDA",
  "SRI SANT SUNDARDAS GOVERNMENT GIRLS COLLEGE, DAUSA",
  "Nightingale College for Girls, Alwar",
  "SMS COLLEGE OF PHARMACY ",
  "JIET COLLEGE OF PHARMACY",
  "KAUTILYA LAW COLLEGE",
  "DRONACHARYA COLLEGE, BHINDAR",
  "B.D., M.L. College, Alwar",
  "M R MEMORIAL COLLEGE, RAISINGHNAGAR",
  "Nirmala Kothari Mahavidyalaya, Sawar",
  "SKG COLLEGE OF PHARMACY",
  "Bansur PG College, Alwar",
  "Bal Bharti T T College, Alwar",
  "Babu Shobha Ram Government Arts College Alwar",
  "DOMINANT COLLEGE OF EDUCATION DAUSA",
  "Baba Khetanath Women PG College, Alwar",
  "SHRI BAPUJI COLLEGE OF NURSING, LADNUN",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE GALOD ",
  "MLD PHARMACY COLLEGE KEKRI",
  "RAJEEV GANDHI PHARMACY COLLEGE, DIDWANA ROAD, MAULASAR",
  "SWAMI SHRI PRANNATH PARNAMI PHARMACY COLLEGE PADAMPUR",
  "GURUKUL COLLEGE OF PHARMACY",
  "S N  COLLEGE OF PHARMACY  DHOLPUR",
  "RANA ROYALS PHARMACY COLLEGE BORAWAR",
  "NAGAUR PHARMACY COLLEGE ",
  "GURUKUL COLLEGE OF PHARMACY",
  "MADHUBAN PHARMACY COLLEGE",
  "DARSHAN DENTAL COLLEGE AND HOSPITAL, UDAIPUR",
  "Government Girls College, Tonk",
  "MADAN SINGH COLLEGE OF PHARMACY, HAMMIR NAGR, KHERDA, SAWAI MADHOPUR",
  "Bhaskar Mahavidyalya Balotra",
  "SMT NARAYANI COLLEGE OF PHARMACY KISHANGARH RENWAL",
  "SAWAI MADHOPUR COLLEGE OF PHARMACY",
  "SAI COLLEGE OF SPECIAL EDUCATION AND RESEARCH",
  "SAMBAL COLLEGE OF PHARMACY",
  "MARUDHARA COLLEGE OF PHARMACY",
  "SGR COLLEGE OF PHARMACY SHYAM NAGAR UDAIPURIA CHOMU JAIPUR RAJASTHAN",
  "JAIPUR INSTITUTE OF PHARMACY",
  "PARISHKAR INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "BAORI MAHAVIDHYALAYA BAORI",
  "PRABHA DEVI MEMORIAL PHARMACY COLLEGE ",
  "SMT PANA DEVI RAMESHWAR LAL SHARMA COLLEGE OF PHARMACY,KHETRI ROAD,CHIRAWA",
  "Government College, Osian",
  "PRINCE ACADEMY PHARMACY COLLEGE SIKAR",
  "GOVERNMENT GIRLS COLLEGE, RANI, MARWAR JUNCTION, PALI",
  "GOVT GIRLS COLLEGE NADAUTI",
  "GOVT AYURVED COLLEGE BIKANER",
  "GOVERNMENT COLLEGE, NAYAGAON,",
  "Shankara Institute of Technology,jaipur",
  "Aravalli College of Education",
  "Sri Nath Shikshaka Prashikshana Mahavidyalaya",
  "Shri Digambara Jain Adarsha Womens TT college",
  "SIDDHARTH SHIKSHA SANSTHAN KOTKHAWDA",
  "Geeta saha Shiksha TT College",
  "Government Sanskrit UG college, Sri Madhopur",
  "EKLAVYA PHARMACY COLLEGE",
  "GOVERNMENT COLLEGE GHOSUNDA CHITTORGARH ",
  "GOVERNMENT AGRICULTURE COLLEGE GANGAPUR",
  "GOVERNMENT LAW COLLEGE CHITTORGARH",
  "GOVT,SHASTRI SANSKRIT COLLEG, PRATAPGARH, RAJASTHAN  ",
  "GOVERNMENT COLLEGE KADERA",
  "GOVERNMENT COLLEGE ANTALI",
  "GOVERNMENT COLLEGE NACHNA",
  "SHARDA COLLEGE, CHOMU",
  "B R MEMORIAL SPECIAL TEACHERS TRINING COLLEGE",
  "SHRI DAMARAM COLLEGE OF PHARMACY",
  "Maa Ambe K.P. Sanghvi Government Law College, Sirohi",
  "BKLG MAHAVIDYALAYA",
  "Govt. College, Ramganjmandi",
  "Swami Vivekanand Mahavidyalaya, Niwai",
  "LZEBRA PHARMACY COLLEGE KOTA ",
  "Govt. College, Todabhim, Karauli",
  "MUNGESHAWARI DEVI GODARA COLLEGE GUDHA GORJI",
  "VEER DURGADAS COLLEGE, SAMDARI",
  "Sanjeevani Mahavidyalaya, Bijainagar",
  "R.D.R.K. Jatia College, Ramganjmandi",
  "Raghukul T.T. College,Bahadur Singh Marg, Bundi",
  "Ganpati Adarsh T.T. College, Barundhan, Bundi",
  "Sorabh College of Pharmacy",
  "Mahatma Gopal Ram Mahavidhyalaya, Anta, Distt. Baran",
  "MASTER SOMNATH LAW COLLEGE",
  "Nirmal Mahavidhyalaya, Hindauncity",
  "P.L. Dubey Memorial T.T. College, Jagpura, Near Jagpura Choki, Kota",
  "Children T.T. College,Dadabari Chhota Choraha, Near Police Station, Kota",
  "Nirmal T.T. College, Hindauncity, Karauli",
  "Govt. College, Bundi",
  "Bharat Mata Phy. T.T. College, Kishanganj, Baran",
  "Tagore Mahavidhyalaya, Aklera, Jhalawar",
  "Maharaja Mool Singh Degree College, Lakheri, Bundi",
  "Eklavya Mahavidhyalaya, Indrajit Vila, Civil Line, Jhalawar",
  "Maa Vaibhav Laxmi Mahavidhyalay, Mangrol, Baran",
  "Astha Mahavidhyalaya, Itawa, Distt. Kota",
  "Dr. Zakir Hussain M.M.T.T. College, Varindhawan, Kota Road, Jhalawar",
  "Arihant T.T. College, Chandrasel, Kota",
  "Albert Einstein Womens T.T. College,Basant Vihar, Kota",
  "Vijaya Raje Mahila T.T. College, Aklera, Jhalawar",
  "Maa Saraswati Mahavidhyalaya, Baran",
  "Rajiv Gandhi Mahavidhyalaya, Nadoti, Karauli",
  "Govt. College, Hindauncity",
  "M.D. Mission College, Keshavpura, Kota",
  "Keshav Mahavidhyalaya, Atru, Distt.-Baran",
  "Radha Krishnan T.T. College, Sawaimadhopur",
  "Eklavya Mahavidhyalaya, Beebanva Road,Devpura, Bundi",
  "Ramanand T.T. College,Mahaveer Colony,  Rangpur Road, Station, Kota",
  "Maa Bharti T.T. College, Talwandi, Kota",
  "Rajasthan T.T. College, Karauli Road, Kheda, Hindauncity, Karauli",
  "Govt. Commerce College, Kota",
  "Gopeshwar T.T. College,Kanwarpura, Kota",
  "Govt. College, Gangapurcity",
  "Govt. Birla College, Bhawanimandi, Distt. Jhalawar",
  "Ashapurna Vidhi Mahavidyalaya",
  "SETH RANGLAL KOTHARI GOVERNMENT COLLEGE, RAJSAMAND",
  "DEEPAK PHARMACY COLLEGE,PAOTA,JAIPUR",
  "L  N  INSTITUTE OF PHARMACEUTICAL SCIENCES, KANWAT ,SIKAR",
  "SHRI SHYAM COLLEGE OF PHARMACY, THOI ROAD KANWAT SIKAR, RAJASTHAN",
  "M B D COLLEGE OF PHARMACY",
  "SIR PRATAP COLLEGE ",
  "VINAYAK COLLEGE FOR PHARMACY",
  "BPS PHARMACY COLLEGE",
  "XAVIER INSTITUTE OF MANAGEMENT AND INFORMATICS",
  "GOVERNMENT COLLEGE PATODI",
  "Marudhar Mahavidyalaya, 16-E-6 Chopasani Housing Board, Jodhpur",
  "Pashudhan Sahayak Prashikshan Sansthan (AHDP 40)",
  "GOVERNMENT COLLEGE, KOTRI, BHILWARA",
  "COLLEGE OF DAIRY SCIENCE AND TECHNOLOGY, JOBNER",
  "Maharaja Agrasen Teacher Training College",
  "Sri Ganganagar Institute of Veterinary Science (AHDP 43)",
  "SRI BALAJI COLLEGE, KOTKHAWDA, CHAKSU",
  "Shri Mastsya Mahavidyalaya, Alwar",
  "Sajjan International College",
  "Ruhi Choudhary College, Sadulpur",
  "KIRAN MAHESHWARI GOVT. COLLEGE, KUNWARIYA",
  "GOVERNMENT GIRLS COLLEGE RAMGARH PACHWARA DAUSA ",
  "GOVERNMENT COLLEGE BASWA ",
  "Rajasthan Teachers Training College, Aagoloi",
  "S.L.A. Golecha College, Khinchan",
  "Government College, Jaitaran",
  "Government College, Phalodi",
  "Shri Param Hans Swami Madhvanand College, Jadan",
  "Shri Dhanraj ji Shri Chand ji Badamia College of Professional Studies, Varkana, Teh. Desuri",
  "Shri Sai Nath Mahila Shikshan Sansthan, Pipar City",
  "Shri Khatishwar B.Ed. College, Nandri",
  "Veena Memorial P.G. College, Karauli",
  "MAHARANA PRATAP COLLEGE CHAKSU JAIPUR",
  "BUNDI AGRICULTURE COLLEGE MOHANPURA INDERGARH",
  "SMT SOHAN DEVI GATTANI COLLEGE",
  "Shri I.G. Marwar Mahavidyalaya, Bilara",
  "Smt. Rukmani Devi Ramdev Ladha Government College, Nawa City",
  "GOVERNMENT BANGUR P.G. COLLEGE, PALI",
  "SAROJ LAL MAHROTRA GLOBAL NURSING COLLEGE, SIROHI",
  "Government College, Shiv (Barmer)",
  "Arya College of Engineering & Information Technology",
  "MAHATMA GANDHI COLLEGE OF PHARMACY, SIKAR",
  "VEER NARAYAN PARMAR GOVERNMENT COLLEGE SIWANA",
  "SHRI AGRASEN SNATKOTTAR SHIKSHA MAHAVIDYALAYA, KESHAV VIDYAPEETH, JAMDOLI, JAIPUR",
  "CHARTERED INSTITUTE OF TECHNOLOGY",
  "Ravindranath Tagore Mahila Mahavidyalaya, Choti Khatu",
  "KAMLA DEVI SINGHVI COLLEGE OF SCIENCE AND TECHNOLOGY, KUCHERA",
  "KHACHARIYAWAS GIRLS COLLEGE KHACHARIYAWAS SIKAR",
  "SANSKAR GIRLS COLLEGE",
  "Government College, Arain",
  "DAYANAND COLLEGE, JAWLA",
  "Central Academy Teachers Training College",
  "Kanchan Devi College of Computer Science",
  "Agarwal Girls College, Kishangarh",
  "Shri Kalyan Shikshak Prashikshan Mahavidyalaya, Niwai",
  "Sita Devi Mahavidyalaya",
  "Vaidanti Shiksha Mahavidyalaya, Degana",
  "Mahaprabhu Swami Ramcharan Kanya Vidyapeeth, Shahpura",
  "Bhartiya Teachers Training College, Ladnun",
  "Suraj Narayan Pareek Mahila T.T. College, Pushkar",
  "Shaheed Bhagat Singh College, Nawashahar",
  "Government Bangur College, Deedwana",
  "SWAMI KESHWANAND COLLEGE OF NURSING, SIKAR",
  "SIKAR NURSING COLLEGE, SIKAR",
  "Agarwal College, Merta City",
  "Rajeev Gandhi Vidhi Mahavidyalaya",
  "Saint Soldier Mahila T.T. College",
  "AADARSH YOGA MAHAVIDHALYA KHATUSHYAMJI DANTARAMGARH SIKAR    ",
  "Dr. MPK Homoeopathic Medical College, Hospital & Research Centre",
  "CHOUDHARY GHARSIRAM COLLEGE OF PHARMACY",
  "GOVERNMENT GIRLS COLLEGE MANDRAYAL",
  "S S Jain Subodh Girls P.G. College, Sangnaer, Jaipur",
  "SHREE BHAGWAN MAHAVEER PG COLLEGE ,SANCHORE",
  "JYOTIBA PHULE MAHAVIDYALAYA DHANDHOLAI , BANDIKUI",
  "Kuchaman College, Kuchaman City",
  "Agarwal Girls T.T. College, Merta City",
  "Balaji T.T. College, Kuchaman City",
  "ANUPAMMA MEDICAL TRAINING INSTITUTEITUTE COLLEGE OF NURSING, SIKAR",
  "LIBERTY COLLEGE OF NURSING, JAIPUR",
  "S M S MEDICAL COLLEGE, JAIPUR",
  "ALWAR NURSING COLLEGE, ALWAR",
  "PRINCE COLLEGE PALWAS",
  "Saheed Bhagat Singh College, Nohar ",
  "Arawali Veterinary College (CV 08)",
  "vivekanand mahavidhyaly  , ramsar, barmer ",
  "BABA GANGA DAS VIDHYAPEETH MAHAVIDYALAY CHIMANPURA SHAHPURA JAIPUR",
  "University College of Ayurved Nursing, Jodhpur",
  "GOVERNMENT COLLEGE SADRI",
  "Rajputana Unani Medical College Hospital & Research Centre, Jaipur",
  "Yuvraj Pratap Singh Memorial Homeopathy Medical College, Hospital & Research Centre, Alwar",
  "MODI LAW COLLEGE",
  "RAJASTHAN COLLEGE 465RD",
  "PULKIT COLLEGE FOR HIGHER EDUCATION",
  "BALAJI MAHAVIDHYALAYA SANPA",
  "M.R. MEMORIAL COLLEGE, DHORIMANNA",
  "Madhav mahavidhyalay",
  "BPS DEGREE COLLEGE MANASIYA ROAD NH- 52 LAXMANGARH ",
  "GOVERNMENT COLLEGE SIKRI",
  "Biyani Institute of Pharmaceutical Sciences",
  "Choudhary Nandram Memorial Agriculture College",
  "Government College, Khinvsar",
  "PROF S KARAN INSTITUTE OF VETERINARY",
  "SMT RAMKUMARI VETERINARY COLLEGE",
  "RADHIKA MAHILA MAHAVIDYALAYA  ",
  "RUHS COLLEGE OF PHARMACEUTICAL SCIENCES",
  "R.M. Memorial Women Teacher Training College",
  "Rajeev Gandhi Mahavidyalaya, Maulasar",
  "Maa Durga Mata B.Ed. College, Riyan Bari, Merta City",
  "Shri Sawai Mahavidyalaya, Deedwana",
  "Shri Govind Singh Gurjar Government College, Nasirabad",
  "Prakash Institute of Vety.Science & Animal Husbandry (AHDP 52)",
  "R R COLLEGE OF PHYSIOTHERAPY",
  "GOVERNMENT GIRLS COLLEGE, NIMBAHERA, RAJASTHAN    ",
  "SKD College for Higher Education",
  "Vinayak College ",
  "Tagore College, Nimbi Jodha",
  "Bal Krishna Institute Of Technology",
  "PODDAR MANAGEMENT AND TECHNICAL CAMPUS",
  "Vijay Central Academy Girls College",
  "H. F. M. DEGREE COLLEGE",
  "CLG PHARMACY COLLEGE",
  "Government College, Rajgarh, Churu",
  "Govt.Girls College, Taranagar, Churu",
  "DASWANI NURSING COLLEGE",
  "Shri Maa Mahavidyalaya, Kathumar, Alwar",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE HAMIRGARH BHILWARA",
  "VYAS DENTAL COLLEGE AND HOSPITAL, JODHPUR",
  "KAMAKSHA INSTITUTE OF PHARMACY SAGWARA DUNGARPUR",
  "GOVERMMENT COLLEGE OF AGRICULTURE, BORWAT, BANSWARA RAJASTHAN",
  "J D GIRLS COLLEGE, HASTEDA",
  "RAJASTHAN COLLEGE, PAOTA",
  "Shri Shyam Mahavidyalaya, Chandwaji",
  "SMT JYANKI DEVI COLLEGE OF PHARMACY",
  "Government Girls College, Sarwar",
  "Government College, Raipur",
  "Government College Newai",
  "Government College, Asind",
  "Lachoo Memorial College of Science & Tech",
  "Suyash College",
  "ANANTA COLLEGE OF NURSING",
  "GLOBAL MAHAVIDYALYA ",
  "SARASWATI GIRLS COLLEGE, CHANDGOTHI",
  "Cobridge Nursing Institute of Veterinary Science (AHDP 56)",
  "M.J.R. Phule Shikshan Sansthan Livestock Assistant Training (AHDP 26)",
  "Veer Teja Mahila College, Kankday, Mundwa",
  "Takshila Niketan Girls College",
  "TAGORE MAHAVIDHALAYA",
  "SHRI AAIJEE MAHILA MAHAVIDYALAYA, BILARA",
  "Daksh Mahavidhyalay",
  "SHREE GANESH MAHILA MAHAVIDHALAY, MAHISHWASH KALAN ROJDA",
  "Poddar Animal Husbandry Diploma  Institute  ",
  "Eklavya College",
  "GOVERNMENT GIRLS COLLEGE, LALSOT",
  "GOVERNMENT COLLEGE, SARADA",
  "GOVERNMENT COLLEGE, JHADOL",
  "GOVERNMENT COLLEGE, DEOGARH",
  "GOVERNMENT COLLEGE, KAPASAN",
  "GOVERNMENT COLLEGE, JAIPUR",
  "GOVERNMENT GIRLS COLLEGE, KHERWARA",
  "GOVERNMENT COLLEGE, LUNKARANSAR",
  "Seth Bihari Lal Chhabra Govt.College Anupgarh",
  "GOVERNMENT COLLEGE, GUDHAMALANI",
  "GOVERNMENT COLLEGE, BAYTOO",
  "RANA ROYALS GIRLS COLLEGE, Borawar, Makrana",
  "K R KANYA MAHAVIDHYALAY  BOLAWALI SANGARIA",
  "SLBS YOG AND NATUROPATHY COLLEGE JODHPUR",
  "V C I COLLEGE",
  "College of Dairy and Food Technology",
  "R.V.V.S.P. Shramjivi College, Ajmer",
  "Swift College",
  "UNIVERSAL TEACHER TRAINING COLLEGE, MAHWA, HINDAUN ROAD MAHWA, DAUSA",
  "Agarwal Girls College, Merta City",
  "Rajkiya Vanijya Kanya Mahavidyalaya Kota",
  "GOVERNMENT MEDICAL COLLEGE SAWAI MADHOPUR",
  "VIBRANT PHARMACY COLLEGE SUMERPUR",
  "GOVERNMENT MEDICAL COLLEGE BARAN ",
  "Aishwarya College of Education, Jodhpur",
  "Bharti T T College, Bharatpur",
  "V K Tyagi TT College, Dhaulpur",
  "Vardhman TT College, Dhaulpur",
  "Shri Krishna Edu. Inst., Bharatpur",
  "Shri Kanhaiya Lal College of Teacher's Edu., Dhaulpur",
  "Shri Ganeshi Lal Tiwari TT College, Dhaulpur",
  "Shri Brijendra Memorial Degree College, Bharatpur",
  "Shree Radhey PG Mahavidyalaya, Bharatpur",
  "Rajesh Pilot Mahavidhyalaya, Rudawal, Bharatpur",
  "Radharani Kanya Mahavidyalaya, Bharatpur",
  "Pt. Uma Dutt Kanya PG Mahavidyalaya, Dhaulpur",
  "GYANODAYA T T COLLEGE BISSAU",
  "SARASWATI COLLEGE OF HIGHER EDUCATION PALSANA ",
  "TAGORE PHARMACY COLLEGE",
  "SMT MANBHARI DEVI MAHILA MAHAVIDYALYA SINGNOR UDAIPURWATI",
  "TAGORE MAHAVIDHYALAYA BUNDI",
  "Harsh Bhaskar PG College, Buhana, Jhunjhunun",
  "IPS COLLEGE OF TECHNICAL EDUCATION",
  "COLLEGE OF AGRICULTURE CHANDGOTHI",
  "BARJI DEVI SHIKSHAK PRASIKSHAN MAHAVIDYALAYA SIKAR",
  "Prakash Shikshak Prashikshan Mahavi., Dhaulpur",
  "Poddar College of Tech. & Management, Bharatpur",
  "GLOBAL COLLEGE OF PHARMACY SIKAR",
  "MADI DEVI MEMORIAL COLLEGE",
  "Lakes Institute Of Skill Initiate",
  "Mata Shanti Godara College",
  "KESHAV AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "M.N. College and Research Institute, Bikaner",
  "Maharishi Parshuram Mahavidyalaya, Dhaulpur",
  "Maharani Mahila Mahavidyalaya, Dhaulpur",
  "parashuram mahavidyalay",
  "AZAD BED COLLEGE",
  "GOVERNMENT GIRLS COLLEGE BILARA",
  "Shri Sant Ram Das Tyagi Livestock Assistant Training Inst. (AHDP 06)",
  "SHRI KRISHNA SHIKSHAK PRASHIKSHAN COLLEGE,By Pass Road, KANWAT",
  "Navjyoti Manovikas Special Teachers Training College",
  "SHRI BANKEY BIHARI COLLEGE KAMAN",
  "SHRI RAM KANYA MAHAVIDHALYA JAKHDAWALI",
  "Shree SAVITRI DEVI MAHILA MAHAVIDYALAYA BALODA",
  "VIRATRA COLLEGE,CHOHTAN",
  "A V M T T College, Bharatpur",
  "TRM COLLEGE BINASAR  CHURU",
  "LAKSHMI NARAYAN COLLEGE JEEWANA",
  "OM COLLEGE OF EDUCATION ",
  "UDAI SINGH YADAV PRASHIKSHAN UDAIRAMSAR",
  "CHANDRASHEKHAR MAHILA SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA, SUJANGARH",
  "SWAMI SHRI RAMSHARAN JI COLLEGE OF PHARMACY ",
  "SHIV SANSTHAN PHARMACY COLLEGE",
  "MOTHER TERESA COLLEGE OF PHARMACY",
  "PRAKHAR COLLEGE",
  "G.B. YOGA AND NATUROPATHY RESEARCH COLLEGE, BHUSAWAR BHARATPUR",
  "GOVERNMENT MEDICAL COLLEGE SRI GANGANAGAR ",
  "SAVITRI DEVI PRASHIKSHAN SANSTHAN UDAIRAMSAR BIKANER",
  "R.N. LIVE STOCK DIPLOMA COLLEGE",
  "CHHATRAPATI SHIVAJI MAHAVIDYALAYA",
  "MARUDHAR COLLEGE OF PHARMACY",
  "SHRI B L INDORIA MEMORIAL TEACHER TRAINING COLLEGE",
  "SUJAS COLLEGE OF PHARMACY",
  "FOOTWEAR DESIGN AND DEVELOPMENT INSTITUTE",
  "KRISHNA COLLEGE OF NURSING",
  "ROOP RAJAT INSTITUTE OF PHARMACY",
  "SHRI SIDDHI VINAYAK CO-EDUCATION COLLEGE TIBBI",
  "DISHA DEGREE COLLEGE",
  "LUV KUSH ADARSH T.T. MAHAVIDHYALAYA  GUDAMALANI",
  "Smt. Ramadevi Mahila Mahavidyalaya",
  "MARUDHARA MAHAVIDHYALAYA BIJRAD",
  "VIJAYDEEP COLLEGE OF EDUCATION",
  "Shri Vivekanand Mahila Mahavidyalaya, Manglana, Parbatsar",
  "GOVERNMENT COLLEGE, GULABPURA",
  "GOVERNMENT COLLEGE, DIGOD, SANGOD, KOTA",
  "GURUKUL MAHAVIDYALAYA",
  "GOVERNMENT COLLEGE, RASHMI KAPASAN CHITTORGARH",
  "B.B.D. GOVERNMENT COLLEGE CHIMANPURA (SHAHPURA) JAIPUR",
  "SALONI INSTITUTE OF MEDICAL SCIENCE",
  "THE TRIDENT INSTITUTE OF HOTEL MANAGEMENT ",
  "Disha, Jaipur",
  "Maharaja shri surajmal TT college Rahimpur",
  "Apex agriculture college",
  "MAHI COLLEGE OF EDUCATION, SABLA",
  "PINK CITY LAW COLLEGE",
  "SHRI MATSYA ANIMAL HUSBANDRY DIPLOMA INSTITUTE ",
  "PANDIT PANNA LAL MEMORIAL PASHUDHAN SAHAYAK PRASHIKSHAN VIDHYALAYA",
  "Blm college of pharmacy Khetri",
  "SANSKAR T T COLLEGE",
  "HARSH MAHILA MAHAVIDYALAYA",
  "Sarswati Teachers Training College  Nani   Sikar",
  "GR COLLEGE OF EDUCATION",
  "KISHANGARH GIRLS COLLEGE",
  "HARI OM SEVA SANSTHAN TT COLLEGE",
  "Raj Rani Co-Education College, Alwar",
  "Sampat tt college bansur alwar",
  "SEVANAND COLLEGE CHOUTH KA BARWARA",
  "SARVEPALLI DR RADHA KRISHNANA COLLEGE BAGIDORA ",
  "Institute of Hotel Management and Culinary Studies",
  "Udaipur Institute of Hotel Management",
  "SR LSA Training Institute Bayana  ",
  "Satguru Yoga and Naturopathy College",
  "Sunrise College of Education Udaipur",
  "Neewara Academy",
  "OSTWAL COLLEGE OF PHARMACY MANGALWAD",
  "Amar internationa college palari solyankiyan sanchore",
  "SAGAR PHARMACY COLLEGE",
  "Ellen School of Art and Design",
  "Vivekanand College of Pharmacy Sikar",
  "BHARTENDU COLLEGE ",
  "SANSKAR SHA SHIKSHA MAHAVIDYALAY ARUKA CHIRAWA",
  "Saraswati Shikshan Sansthan Jaisinghwas Jhunjhunu",
  "shri nawab singh mahavidhyalya kumher",
  "SHRI ARJUNRAM YOGA AND PRAKRUTIK CHIKITSA MAHAVIDHYALAYA",
  "MAHARANA PRATAP PASHUDHAN SAHAYAK PRASHIKSHAN KENDRA BASERI",
  "Shri Shyam Mahila Mahavidyalaya, Jaipur",
  "Government Girls College Bandikui",
  "GOVT COLLEGE WEIR BHARATPUR",
  "SARASWATI MAHAVIDHYALAYA BHADRAJUN",
  "COLLEGE OF AGRICULTURE SRIGANGANAGAR",
  "COLLEGE OF AGRICULTURE BAYTU BARMER",
  "GOVT GIRL COLLEGE HINDAUN CITY",
  "CRM INSTITUTE OF YOGA SCIENCE",
  "AMBIKA COLLEGE",
  "Navjeevan College of Pharmacy ",
  "GYAYAK TT COLLEGE",
  "LAL BAHADUR SHASTRI MAHILA MAHAVIDHYALAYA, JAIPUR",
  "M L D LIVE STOCK ASSISTANT DIPLOMA TRAINING INSTITUTE  KEKRI",
  "RUKMANI DEVI GIRLS COLLEGE CHAKSU",
  "JLN SHIKSHRAN SANSTHAN BASERI DHOLPUR",
  "SHIV COLLEGE OF PROGRESSIVE EDUCATION, RANOLI, PEEPLU",
  "Government Sanskrit UG college Peeth",
  "SATYAM INSTITUTE OF PHARMACY",
  "M D COLLEGE  PALLU",
  "Compucom Institute of Information Technology and Management Evening",
  "padmani devi girls collage weir, Bharatpur, rajasthan ",
  "LAKSHYA GIRLS COLLEGE",
  "govt girls college sikandra",
  "College of Veterinary and Animal Science, Navania, Udaipur",
  "Govt Girls College Behror  Alwar",
  "Raj Kumar Mahavidyalaya, Bari ( Dhaulpur)",
  "GOVERNMENT MEDICAL COLLEGE, JHUNJHUNU",
  "SHREE SANWARIYA SETH COLLEGE OF PHARMACY THANWALA",
  "Dr. B.R. Ambedkar Government Medical College, Sirohi",
  "BHARTI COLLEGE OF PHARMACY",
  "ARAWALI COLLEGE OF PHARMACY",
  "GOVT COLLEGE OF NURSING, JALORE",
  "VINAYAK NATIONAL COLLEGE FOR PHARMACY",
  "VINAYAK INTERNATIONAL COLLEGE FOR PHARMACY",
  "TAGORE COLLEGE OF PHARMACY, SANGETDA, KATPUTLI, JAIPUR ",
  "SWAMI VIVEKANAND COLLEGE OF PHARMACY",
  "GOVERNMENT COLLEGE LOHAWAT",
  "Govt. College DUDU ",
  "GOVT COLLEGE KUMBHALGARH",
  "Government College, Masuda",
  "government college Rohat",
  "SHAHEED SHREE MUKUT BIHARI MEENA GOVERNMENT COLLEGE, KHANPUR (JHALAWAR)",
  "GOVERNMENT COLLEGE, BADI SADRI",
  "Rameshwari Devi Girls College, Bharatpur",
  "SHRI KRISHNA ACADEMY OF LEGAL EDUATION",
  "Shri Mahaveer College ",
  "TAJ MEMORIAL GIRLS COLLEGE",
  "VAIDIK BALIKA PG MAHAVIDHYALAYA, VARUN PATH, MANSAROVER, JAIPUR",
  "COLLEGE OF DAIRY AND FOOD TECHNOLOGY",
  "TRILOK SINGH COLLEGE OF PHARMACY",
  "KCP COLLEGE OF PHARMACY, KUCHAMAN CITY",
  "SHREE VINAYAK COLLEGE ",
  "GIRDHAR COLLEGE CHIMANPURA PALI",
  "UNIVERSITY COLLEGE OF HOMEOPATHY JODHPUR",
  "SAINT SOLDIER COLLGE SOHELA",
  "Ganpati Mahila Mahavidyalaya, Jaipur",
  "Poddar Mgt. Tranning Institute, Jaipur",
  "VIDYASTHALI SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA NAGLA MADHOPUR KHERLI ALWAR",
  "GOVT COLLEGE OF NURSING KUMHER BHARATPUR",
  "UNIVERSITY COLLEGE OF NATUROPATHY AND YOGIC SCIENCE",
  "MURLI SINGH MEMORIAL PRASHIKSHAN SANSTHAN PHARMACY COLLEGE",
  "S D PHARMACY COLLEGE KHAJUWALA BIKANER",
  "Shree Damodar Lal Vyas Kanya Mahavidyalaya, Bharatpur",
  "SHRI AMRITNATH GIRLS COLLEGE",
  "Mehta College & Institute of Technology, Jaipur",
  "Late Ku. Laxmi Badhla Mahila TT College, Jaipur",
  "Jagriti Shikshak Prashikshan Mahavi., Jaipur",
  "St. Xavier TT College, Jaipur",
  "MAHATMA GANDHI COLLEGE OF NURSING, JHALAWAR",
  "Manavata Mahila Mahavidyalaya, Jaipur",
  "SHRI RAMESHWAR LAL DHANI DEVI BED COLLEGE, SUJANGRH DIST CHURU",
  "KRISHNA DEVI MAHESWARI PHARMACY COLLEGE, JHUNJHUNU",
  "Vidyasthali Inst. of Technology Sc. & Mgt., Jaipur",
  "Kasturba Gandhi Mahila Shikshak Prashikshan Mahavidyalaya, Jaitaran",
  "Vidya Gram Shikshak PRashikshan Mahavi., Jaipur",
  "Guman Singh Memorial Mahila Shikshak Prashikshan Mahavidyalaya, Sumerpur",
  "SANJIVANI COLLEGE OF PHARMACY, JHUNJHUNU",
  "Shri Parshwanath Ummed College, Falna",
  "Tagore Mahavi., Jhunjhunun",
  "Sunshine College of Mandrella, Jhunjhunun",
  "VIVEK DEGREE TEACHER TRAINING COLLEGE",
  "CAREER COLLEGE OF PHARMACY,BISSAU ROAD,CHURU",
  "Ratan Devi College, Jaipur",
  "Sultan Mahavi., Jhunjhunun",
  "GURU ARJUN DEV DEGREE COLLEGE SAMEJA ",
  "Central Institute of Petrochemicals Engineering & Technology (CIPET), Jaipur",
  "Gramodhyog Mahavidyalaya, Bilara",
  "Smt Rukma Devi Mahila Shikshan Prashikshan Mahavidalaya, Pali",
  "Smt. Jyanki Devi TT College, Jhunjhunun",
  "Smt. Indramani Mandelia PG Shiksha Niketn, Jhunjhunun",
  "GOVT COLLEGE OF NURSING SRI GANGANAGAR",
  "HANS COLLEGE OF PHARMACY",
  "Shri Si Ram Krishan College, Dhaulpur",
  "Government Girls College, Peeplu",
  "SN College of Sc., Dhaulpur",
  "ADARSH COLLEGE OF PHARMACY,  EXT KAMLA NEHRU NAGAR, JODHPUR ",
  "RAMI DEVI COLLEGE OF PHARMACY DEOLI",
  "SHEKHAWATI COLLEGE OF PHARMACY, JHUNJHUNU",
  "SHREE RAM SINGH VISHNOI MEMO BSC NURSING, JODHPUR",
  "ARAVALI COMMERCE AND SCIENCE COLLEGE ",
  "Surendera Dental College and Research Institute",
  "Kanak College of Education",
  "SHRI KALYAN GOVT MEDICAL COLLEGE SIKAR",
  "STARCITY MEDICAL COLLEGE OF PHARMACY",
  "SLNG COLLEGE OF PHYSIOTHERAPY, JODHPUR",
  "AARADHANA DEGREE COLLEGE AHORE",
  "SN College of Education, Dhaulpur",
  "MARUDHAR COLLEGE OF NURSING, NAGAUR",
  "MAHARASHI PARASHAR YOG MAHAVIDHYALAYA",
  "GRAMIN KANYA MAHAVIDYALAYA , BHADRA",
  "TIMES SHIKSHAN MAHAVIDHYALYA HANUMANGARH TOWN",
  "Sanatan Dharm Mahila B.Ed. College, Ravindra  Path",
  "ESIC MEDICAL COLLEGE AND HOSPITAL ALWAR",
  "N.S.P. (PG) College",
  "GOVERNMENT COLLEGE, JODHPUR",
  "GOVERNMENT COLLEGE, BALI",
  "J M B.ED COLLEGE ,BUHANA",
  "STAR NURSING COLLEGE, JAIPUR",
  "R.N. MAHAVIDHYALYA ",
  "ADARSH COLLEGE OF PROFESSIONAL STUDIES",
  "Vivekanand College, Jakhrawali",
  "Dr. Rajendra Prasad Shah Shiksha College",
  "Sri Arorvansh Girls College",
  "SAHID BHAGAT SINGH COLLEGE OF NURSING, NAGAUR",
  "SUFIYA COLLEGE OF NURSING, NAGAUR",
  "GOVT. COLLEGE, KOTRA",
  "GOVT.  COLLEGE, KHERWARA",
  "S.S. COLLEGE OF EDUCAION (S.S. SHIKSHAK SANSTHAN),  SECTOR NO.5,  HIRAN MAGRI",
  "H.R. GOVT. COLLEGE, SALUMBER",
  "SHRI KRISHN YOGA MAHAVIDYALAY ",
  "BHAGWATI GIRLS TEACHERS TRAINING COLLEGE",
  "CHOUDHARY COLLEGE OF EDUCATION RAJGARH",
  "Shri Sabal Mahila T.T. College, Borunda",
  "RANABAI MAHAVIDHALAYA, HASIYAS ROAD, MERTA ROAD",
  "Gurukul Sanskar Kanya Mahavidyalaya, Sumerpur",
  "Sajjan T.T. College",
  "Seth RL Saharia Government PG College, Kaladera, Jaipur",
  "Saraswati Shikshak Prashikshan Mahavidyalaya",
  "MAHILA TECHNICAL AND MANAGEMENT COLLEGE JODHPUR",
  "SWAMI VIVEKANAND COLLEGE GANDHIPATH",
  "Santosh Mahavidyalaya, Riyan Badi",
  "Shri Jain Shwetambar Terapanthi Manav Hitkari Sangh, Ranawas",
  "ARIHANT COLLEGE",
  "Gayatri College, Sanchore",
  "G.K. Gowani Government College, Bhinmal",
  "Global Education Institute, Sanchore",
  "Rajshree Mahila Mahavidyalaya, Sanchore",
  "Krishna Mahila Mahavidyalaya, Sanchore",
  "Sundamata Mahila Shikshak Prashikshan Mahavidyalaya, Bhinmal",
  "GOVT COLLEGE PEEPALKHUNT",
  "U.K. Singh Deval Memorial Teachers Training Sansthan, Bhinmal",
  "SHREE DWARKADHISH INSTITUTE OF MANAGEMENT AND SCIENCE,PRATAP PURA",
  "Seth Ganpat Ram Laxmi Devi College, Dabri",
  "Karuna Shikshan Prashikshan Mahavidhyalaya",
  "Shri Ratan Singh PG Mahila Mahavidyala, Bharatpur",
  "Shiva College of Education 10S.D.P., Lalgarh Jatan",
  "Dr. Radhakrishnan Girls College",
  "Rajasthan College, Sankhu Road",
  "SHRI JAIN TERAPANTHI COLLEGE, Ranawas Zila Pali",
  "KOTA COLLEGE OF TEACHER TRAINING KOTA",
  "GOVERNMENT NURSING COLLEGE, BHILWARA",
  "TIMES SHIKSHA MAHAVIDYALYA",
  "Keshav Vidyapeeth T.T. College, Sumerpur",
  "saraswati bal niketan mahavidyalaya, shyampura mainana , via -bhuhana",
  "Sanwaria Mahavidyalaya, Dhorimanna",
  "GOVT. MEDICAL COLLEGE KOTA",
  "BHOM SINGH TEACHERS TRAINING COLLEGE",
  "sainger college of art and education ",
  "Adarsh College, Sardarpura Khalsa",
  "ROHET COLLEGE",
  "SHREE LUMBARAM MEMORIAL COLLEGE, LOHAWAT",
  "DPM College, Bharatpur",
  "GOVERNMENT GIRLS COLLEGE ,POKARAN",
  "Sri Guru Nanak Girls College",
  "Churu Balika Mahavidyalaya",
  "THE NOBLE  B.ED. COLLEGE, KHERWARA",
  "Muni Shri Kamal Vijayji M.S. Shikshak Prashikshan Mahavidyalaya, Bhinmal",
  "Smt. Gomati Devi TT College, Jhunjhunun",
  "Rajasthan College, Pallu",
  "Harnamdas Lekhraj Institute of Education, Chak 24, B.B.",
  "CAREER MAHAVIDYALAYA",
  "GOVERNMENT COLLEGE, SARWAR",
  "gurukul college gothara",
  "Ganadhipati Purushottam Shekhawati College of Nursing",
  "Maa Durga Shikshan Sansthan Women T.T. College, Damodra",
  "SMT. HARKORI DEVI GIRLS PG COLLEGE, JHUNJHUNU",
  "SHREE GANDHI JYOTI MAHILA MAHAVIDYALAY BHUSAWAR ",
  "Maa Vakal Malani Mahavidyalaya, Chohattan",
  "SHIV SHAKTI, MAHAVIDAYALYA,  AKHAIGARH, NADBAI",
  "Mahesh Institute of Professional Studies",
  "Marudhara Shikshak Prashikshan Mahavidyalaya, Balotra",
  "VIDYA BHAWAN RURAL INSTITUTE",
  "TAKSHILA TEACHERTS TRG. COLLEGE, CHIRWA",
  "BABA VISHAMBHAR DAS GOVERNMENT GIRLS COLLEGE, HOD, KHANDELA, ",
  "MAHARANA PRATAP LAW COLLEGE, CHITTORGARH",
  "Shekhawati B.Ed. College, Sikar",
  "KRISHNA MAHILA TEACHERS TRAINING COLLEGE, SISARMA",
  "Rajasthan TT College, Sikar",
  "Priya TT College, Sikar",
  "GD ML Patwari PG Mahila Mahavi., Sikar",
  "Banshiwala Mahila Mahavi., Sikar",
  "Shri Lal Bahadur Shatri Mahila Mahavidyalaya, Jaipur",
  "Ram Krishan Colege of Edu., Jaipur",
  "GIMT College, Bharatpur",
  "Biyani Girls College, Jaipur",
  "rajeshwer Mahavidyalaya, Alwar",
  "Modern Edu. Society Women TT College, Jaipur",
  "ALKA MEMORIAL GIRLS COLLEGE",
  "GOVERNMENT COLLEGE, BARI, DHOLPUR",
  "Shri Krishan Mahila Mahavidyalaya, Jaipur",
  "Annu Shree PG Mahila Mahavidyalaya, Dausa",
  "shri karani college kajoi",
  "College of Hortiuclture and Forestry",
  "Bhagwan Mahaveer Law College & Research Centre, Jaipur",
  "MAHERSHI MAHILA TEACHERS TRAINING COLLEGE, KANKROLI",
  "Kamla Shikshak Prashikshak Mahavidhyalay,Dholpur(Raj.)",
  "Triveni TT College, Jaipur",
  "Bhartiya T T College, Dabla, Sikar",
  "Shri Agrasen Mahila TT College, Dausa",
  "Seva Mahila Mahavidyalaya, Jaipur",
  "Superking TT College, Jaipur",
  "Alankar Mahila P G Mahavidyalaya, Jaipur",
  "Govt. Shakambhar PG College, Sambhar Lake, Jaipur",
  "DEVMAHAVIDYALAYA THALI JAMWARAMGARH",
  "J K College of SC. & Research Tech., Bharatpur",
  "MSJ Government College, Bharatpur",
  "Ram Swaroop Agarwal TT College, Dausa",
  "Government Maharani Sudarshan College for Women, Bikaner",
  "A N B.Ed. College, Jaipur",
  "ENGINEERING COLLEGE DHOLPUR",
  "Pratap Mahavidyalaya, Jaipur",
  "Uma Mahila Shikshak Prashikshan Mahavi., Dausa",
  "Shri Rishikul Bramhacharya Ashram Sanskrit PG college",
  "GOVT COLLEGE FATEHPUR",
  "Tagore Public Law College, Jaipur",
  "Geeta Bajaj Girls TT College, Jaipur",
  "Ahangran Girls College, Jaipur",
  "Gurukul College",
  "SMT INDIRA PRIYADARSHINI MAHILA MAHAVIDYALAYA, HINDAUNCITY",
  "NEW HIND GIRLS DEGREE COLLEGE SIDHMUKH",
  "DHANVANTRI INSTITUTE OF MEDICAL SCIENCE, JAIPUR",
  "TAGORE INSTITUTE OF HIGHER STUDIES",
  "Kamla PG Mahavidyalaya, Dhaulpur",
  "VIVEKANAND COLLEGE PAMANA",
  "SHRI TAIJAL SHIKSHAN SANSTHAN GIRLS COLLEGE",
  "S S  G Pareek PG College, Jaipur",
  "Monika Virmani TT College, Alwar",
  "Khandelwal TT College, Bharatpur",
  "GOVERNMENT COLLEGE OF NURSING SIKAR",
  "Saraswati Girls College, Beenjh Bayla",
  "Gyan Kanwar Girls T. T. College",
  "AKASH TEACHERS TRAINING COLLEGE UKROOND, MANDAWAR TEH- MAHWA (DAUSA)",
  "A.P.S. SHIKSHAN  PRASHIKSHAN MAHAVIDYALYA",
  "COLLEGE OF ARCHITECTURE MLSU UDAIPUR",
  "ARADHANA COLLEGE ITAWA",
  "SANSKRITI COLLEGE",
  "Tagore Nursing College",
  "SUNRISE COLLEGE FOR HIGHER STUDIES ",
  "Shri B R Sunda College, Jaipur",
  "Marwar Institute of Vetenary Science, Jodhpur",
  "HILL GROVE COLS INSTITUTE OF PHARMACY",
  "GURUKUL MAHAVIDYALAYA, MAUZMABAD,JAIPUR",
  "RUKMANI DEVI COLLEGE",
  "St. JKL College, Jaipur",
  "Takshila College, Hamjapur",
  "Shri Krishna T.T. College, Naya Nohara, Baran Road, Kota",
  "ADARSH KANYA MAHAVIDYALAYA",
  "Varsha TT College, Jhunjhunun",
  "Tagore Balika Mahavi., Sikar",
  "UKRAJ JI RAJPUROHIT GIRLS COLLEGE  AJODAR RANIWARA ",
  "Shri Jeevan PG Mahavidyalaya, Sikar",
  "Shri Govind Shikshak Prashikshan Mahavi., Jhunjhunun",
  "Rakesh PG Mahavi., Jhunjhunun",
  "VARDHMAN COLLEGE",
  "New Rajasthan Women TT College, Jhunjhunun",
  "Marudhara Shikshak Prashikshan Mahavi., Sikar",
  "IDEAL COLLEGE BICHHIWARA",
  "Laxmi TT women College, Bharatpur",
  "SHEKHAWATI COLLEGE TEHANDESAR",
  "The Gurukul College",
  "Shri Radheshyam R. Morarka Government College, Jhunjhunu",
  "SHRI RAM COLLEGE OF TEACHERS EDUCATION,  58-GOKUL PURA, NORTH AYAD, UNIVERSITY ROAD",
  "Guru Hargovind Sahib Shiksha Mahavidhyalaya, 12 B.B.",
  "MAHATMA GANDHI NURSING COLLEGE, JAIPUR",
  "SRI GURUGRAM TEACHER TRAINING COLLEGE,GANAGANAGR",
  "GURUGRAM DEGREE COLLEGE",
  "CHANDRAWATI GIRLS COLLEGE    ",
  "MARUDHARA COLLEGE",
  "S.K. MEMORIAL COLLEGE, PIPAR CITY",
  "Shravani devi mahila B.Ed.college",
  "SMT. PARVATI DEVI GIRLS COLLEGE BANSUR",
  "Maharaja Surajmal TT College, Bharatpur",
  "S.R.GIRLS COLLEGE AJEETGARH ROAD DIVRALA  SIKAR",
  "CHOUDHARY T.T. COLLEGE, JHUNJHUNU",
  "Apex College for Girls",
  "M.D. College, Phephana",
  "S.G.N. Khalsa Law College",
  "SARASWATI SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA, BEHIND POLICE STATION, SARDARSHAHAR CHURU. 331403",
  "CREATIVE GIRLS COLLEGE, GANGAPUR CITY",
  "Adarsh College, Near Tantia Kuwa",
  "SUFIYA COLLEGE OF PHARMACY",
  "MAHALA INSTITUTE OF AYURVEDA, AYURVEDA NURSING TRAINING CENTRE",
  "SHRI KARNI COLLEGE OF EDUCATION",
  "GOVT. COLLEGE OF NURSING",
  "Mahala TT Inst., Sikar",
  "Maa Bharti TT College, Jhunjhunun",
  "Jamna GIrls B.Ed. College, Sikar",
  "Gramotthan J P College, Jhunjhunun",
  "Chandu Ram Suthar Memorial College, Chhanibadi",
  "INDRAPRASTHA MAHILA MAHAVIDYALAYA MUNDAWAR",
  "CHOUDHARY MAHAVIDYALAYA RAWATSAR",
  "Binani Kanya Mahavidyalaya",
  "Excellence Kanya Mahavi., Sikar",
  "Gurukul Instittute of T.T. & Research, Lalpura, Paliwala",
  "S.K. College, New Mandi",
  "Rajasthan Shiksha Mahavidyalaya",
  "Alliance College, Sangaria",
  "JAI DURGA COLLEGE OF PHYSIOTHERAPY",
  "Shri Ram Narain Dixit Degree College, Srivijaynagar",
  "S.B.N. MEMORIAL COLLEGE",
  "Indira Priydarshini T.T. College, Chak-8, Nohar Road",
  "Tagore College, Suratgarh",
  "Maa Saraswati T.T. College, 30 B.B., 4 J.J., Via-Gajsinghpur",
  "Shri Mahavir Jain Girls College, Hanumangarh Town",
  "Sesomu Girls College",
  "Rajasthan T.T. College, Sankhantal Road",
  "Mohan Lal Sahewal Smriti Institution 4 B.K.K., Bhujarka",
  "Bright India Mahila Shikshak Prashikshan Mahavidyalaya",
  "Hukum Chand Noble Institute of Science & Technology, Danta",
  "Lord Tirupati Mahavidyalya, Kekri",
  "SATYAM COLLEGE",
  "Shri Ratanlal Kanwarlal Patni Government P.G. College, Kishangarh",
  "St. Wilfred Law College, Gegal",
  "Government College of Nursing Ajmer",
  "Excdellence Girls Education College, Sikar",
  "Mahila (PG) Mahavidyalaya, Sadulshahar",
  "Govt. College of Physical, Jodhpur",
  "KARM VIDHYA MANDIR CO-ED COLLEGE, MUNDAWAR",
  "Saraswati Girls College",
  "Vivekanand Vidhya Ashram T.T. College, Katar Choti",
  "Bhartiya Mahila PG Mahavi., Sikar",
  "Ch. M.S. Tandi Memorial Girls College",
  "Baby Happy Modern Degree College, Hanumangarh Jn.",
  "Baba Mast Nath Institute of Education Training & Research",
  "KUCHAMAN PHARMACY COLLEGE",
  "ADINATH MAHILA TEACHERS TRAINING COLLEGE, H.M. SEC.11,ADINATH SANSTHAN CAMPUS",
  "C.R. Memorial T.T. College, Taranagar Road",
  "MODERN MAHILA MAHAVIDYALAYA, Kuchaman City",
  "Saraswati Mahila Mahavidyalaya, Makrana",
  "Saraswati Shikshak Prashikshak Mahavidyalaya, Banthri",
  "Shri Madhav Shikshak Prashikshan Mahavidyalaya, Harnarayan Baas, Deedwana",
  "Shri Nagaji Mahavidyalaya, Kantiya, Kheevnsar",
  "SHRI SHYAM DEGREE COLLEGE, MOKALSAR",
  "Chanakya College, Reengus",
  "SURIYA COLLEGE, BANSKHO, BASSI",
  "Guru Jambheshwar Adarsh B.Ed. College, Uttaradh Bass",
  "Maharana Pratap TT College, Dhaulpur",
  "Shri Guru Nanak Khalsa College",
  "Shri Vinayak College, 32 G.B.",
  "AGRAWAL INSTITUTE OF PHARMACY, JAIPUR",
  "SHRI MATSAYA COLLEGE OF EDUCATION",
  "shri guru madhwanand pratibha college roopwas",
  "MURLI MEMORIAL DEGREE COLLEGE KHATUSHYAMJI",
  "GEETANJALI LAW COLLEGE, NOHAR",
  "GEETANJALI COLLEGE OF SCIENCE AND COMMERCE",
  "JAMNA COLLEGE JEEVANPURA",
  "LRL TT COLLEGE , PICHUNA",
  "Shri Adarsh B.Ed. College, Bigga",
  "Smt. Kamla Devi Gauridutt Mittal Mahila Mahavidyalaya",
  "M.D. College, Thalarka",
  "Shakuntalam college (chak 22 PS)",
  "M.N. Institute of Teacher's Training",
  "Mohta College",
  "Prerna Girls College, Gandhibari",
  "Shri R. D. Singh Memorial T.T. College Fatehpur Shekhawati ",
  "Saraswati Mahila  Shikshak Prashikshan Mahavidhyalaya",
  "Ch. S.R. College, Patroda",
  "Patel Co-Education T.T. College, Chak 3 S.T.R., 24 A.S.C. New Mandi",
  "M. R. S. Srikrishan Parnam Kanya Mahavidyalaya",
  "Nohar Degree  College",
  "Yukta Bindal College, Taranagar Road",
  "INSTITUTEITUTE OF MEDICAL TECHNOLOGY AND NURSING EDUCATION, JAIPUR",
  "Shri Shiv Co-Education T.T. College, Chak 3 S.T.R., New Mandi",
  "Baby Happy T.T. College",
  "Shri Guru Nanak Khalsa T.T. College",
  "Suratgarh  T.T. College",
  "GOVT. COLLEGE, MAHUWA",
  "B.J.S.Rampuria Jain College",
  "Indira Gandhi Memorial B.Ed. College, Pilibanga",
  "LUV KUSH ADARSH  MAHAVIDHYALAYA  GUDAMALANI",
  "Lehri T.T. College, 237 Hisar Road",
  "Seth G. L. Bihani S.D. Law College",
  "B.J.S.Rampuria Jain Law College",
  "R R DENTAL COLLEGE AND HOSPITAL",
  "Sarvesh College, New Mandi",
  "Geeta Jyoti T.T. College, 36 M.O.D. Kachiya Post- Kothwali",
  "RAJDHANI COLLEGE, KHANDELA ",
  "Apex Co-Edu. College, Chaiya",
  "GOVERNMENT GIRLS COLLEGE OSIAN    ",
  "Shree Pooniram Memorial College Bhadoti ",
  "SHAHEED RUPAJI KARPAJI GOVT. COLLEGE BEGUN",
  "GOVERNMENT COLLEGE OF NURSING , DUNGARPUR ",
  "Guru Hargobind Sahib College, C.C. Head",
  "MARWAR WINNERS PHARMACY COLLEGE",
  "Shri Pandit Mishirilal mahavidhayalaya Rajakhera ",
  "Seth Sushil Kumar Bihani S. D. T.T. College",
  "Tagore Gramothan College, Ratanpura",
  "Sobhasaria Group of Institutions, Sikar",
  "KUND KUND KAHAN DIGAMBER JAIN MAHAVIDYALAY",
  "AAI MATA GOVERNMENT GIRLS COLLEGE, PALI",
  "Seth Rawat Mal Bothra Girls  College",
  "Jaharvir Goga Ji National Girls College, Nivan, Bhadra",
  "Shri Ganga Singh College",
  "J R COLLEGE NALA KA BALAJI PIPRALI ROAD SIKAR",
  "BAGODA COLLEGE, BAGODA",
  "SHREE JI ANIMAL HUSBANDRY TRAINING INSTITUTE NATHDWARA",
  "R C MEMORIAL TEACHER TRAINING COLLEGE",
  "NARAIN COLLEGE  ",
  "Vyapar Mandal Girls College",
  "Career T.T. College, Plot No. 2829, Bissu Road",
  "Ravi Shikshak Prashikshan Mahavidhyalaya",
  "Shri Taijal TT College, Sikar",
  "S S COLLEGE OF SPECIAL EDUCATION",
  "S S MAHAVIDYALAYA NAGLA SEWAKURWARIYA BAYANA BHARATPUR",
  "Shri Abhay Animal Husbandry college (AHDP 07)",
  "Chandgi Ram College, Berasar Chota",
  "ADITYA COLLEGE",
  "Shri Lal Bhadur Shastri Research & Training Institute (AHDP 35)",
  "Veena Memorial livestock Assistant Training School (AHDP 36)",
  "MAHARISHI ARVIND INTERNATIONAL INSTITUTE OF PHARMACY",
  "SHREE GOKUL MAHAVIDHYALAY ARNIYALI,DHORIMANA ",
  "M.D.M. Animal Husbandry College (AHDP 39)",
  "Animal Husbandry Mahavidhlaya Sri Gangangar",
  "Institute of Agricultural Business Management ",
  " Saraswati Shikshan Sadan Agriculture College , Sriganganagar",
  "CBR COLLEGE KALU ROAD LOONKARANSAR ",
  "Seth G. L. Bihani S. D. P G College",
  "AISHWARYA COLLEGE OF PHARMACY",
  "S. G. N. Kanya College, Gajsinghpur",
  "Ashutosh PG Mahavidyalaya",
  "BHARTI TEACHER TRAINING COLLEGE",
  "SANSKAR GIRLS COLLEGE SURATPURA BHADRA",
  "MITS SCIENCE,ARTS  AND  COMMERCE COLLEGE  ",
  "LSRC COLLEGE OF AGRICULTURE, MANDAWA     ",
  "DIAMOND GIRLS COLLEGE OF SCIENCE",
  "Sundhamata Institute For Higher Studies, Rajpura (Jalore)",
  "AAROGYA HOMOEOPATHIC MEDICAL COLLEGE",
  "MANGLAM COLLEGE",
  "GLOBAL PHARMACY COLLEGE",
  "Government College, Parbatsar",
  "ANNUAL COLLEGE ",
  "GOVERNMENT MEDICAL COLLEGE, BANSWARA",
  "MAHESH INSTITUTE OF AYURVED BSC NURSING MAHAVIDYALA BARMER",
  "MAA VANKAL PHARMACY COLLEGE CHOHTAN",
  "Shri S.R. B.Ed. College, Patroda",
  "LBS PHARMACY OF EDUCATION GANORA",
  "AISHA MAHILA MAHAVIDYALAYA, BERI KHURD, MAULASAR",
  "SOGANI MAHAVIDYALAYA, BONLI",
  "SWAMI VIVEKANAND COLLEGE, SITABADI, DANTA",
  "GOVERNMENT GIRLS COLLEGE, MANDAWARI",
  "GOVERNMENT COLLEGE ANTAH",
  "GOVERNMENT COLLEGE MALAKHERA ALWAR",
  "MANAV PHARMACY COLLEGE CHAKSU JAIPUR",
  "Choudhary K. R. Kanya College, Gharsana",
  "GOVERNMENT COLLEGE SANCHORE JALORE",
  "BDML PHARMACY COLLEGE, DHELAWAS",
  "Swami Sevanand T.T. College, Sardarshahar",
  "PINK PEARL COLLEGE REENGUS",
  "PARISHKAR MAHAVIDYALAYA GALIFA",
  "GOVERNMENT COLLEGE DUNGLA    ",
  "Sarvodaya animal Husbandry School",
  "BRIGHT COMPUTER KOTA",
  "GOVT COLLEGE, ARNOD, DIST  PRATAPGARH RAJASTHAN     ",
  "KAUTILYA COLLEGE, PREMPURA ROAD, KUNWARIYA",
  "DECOLE COLLEGE",
  "S R K MEMORIAL MAHAVIDYALAYA",
  "Astha Mahavidyalaya, Kuchaman City",
  "SHRI SAWAI GIRLS COLLEGE DIDWANA",
  "G R GINEE DEVI MAHILA MAHAVIDYALAYA",
  "Arjun College, Kuchaman City",
  "Adarsh College, Kuchaman City",
  "DR TANVEER MALAWAT COLLEGE",
  "GEETANJALI COLLEGE NOHAR",
  "GOVERNMENT COLLEGE SANGANER JAIPUR",
  "GOVERNMENT COLLEGE OF NURSING BUNDI",
  "DPC COLLEGE MANOHARPUR  TEH SHAHPURA JAIPUR",
  "GYANODAY GIRLS COLLEGE JILOLA AMET",
  "SARASWATI GIRLS COLLEGE ",
  "CRC COLLEGE",
  "RAJPUTANA TEACHER TRAINING COLLEGE KOTPUTLI",
  "COLLEGE OF COMMUNITY AND APPLIED SCIENCES",
  "GOVERNMENT COLLEGE DESURI",
  "NEW INDIAN INSTITUTE OF PHARMACY",
  "SARASWATI VIDYALAYA SHIKSHAN SANSTHAN",
  "GOVERNMENT AGRICULTURE COLLEGE, OSIAN",
  "MATA BOGI DEVI MEMORIAL T T COLLEGE",
  "ASHA DEVI COLLEGE",
  "Shri S.R. Shikshan Sansthan, Lunkaransar",
  "Maharaja Agarsain PG College, Bhadra",
  "M.D. (PG) Girls College, Raisinghnagar",
  "Parmanand Trilokchand T.T. College, Sujangarh",
  "Renesans College, Sidhmukh",
  "Government Law College, Sriganganagar",
  "SHRI KRISHNA INSTITUTEITUTE OF MEDICAL AND HEALTH SCIENCES AND RESEARCH, JAIPUR",
  "Kothari College, Sankhan Tal",
  "BANGAR COLLEGE AJEETGARH SIKAR",
  "VISION COLLEGE OF PHARMACY DEOLI ",
  "TAGORE  SAH SHIKSHA COLLEGE OF SCIENCE AND ARTS SURAJGARH  J J N",
  "MARUDHAR COLLEGE",
  "Keshav College, Pilibanga",
  "MOTHER TARESA COLLEGE OF PHARMACY",
  "SHREE BALAJI PGDCA MAHAVIDHYALAYA CHOMUJAIPUR",
  "RAJKIYA KANYA MAHAVIDYALAYA ALSISAR MANDAWA",
  "BHARTI COLLEGE SIKAR",
  "RUDRAKSH SPECIAL TEACHERS TRAINING COLLEGE",
  "PANNALALMEMORIAGIRLSCOLLEGEDHINGPUR",
  "KCRI COLLEGE",
  "GOVERNMENT GIRLS COLLEGE BAYTU",
  "GOVERNMENT COLLEGE BHADESAR",
  "Saraswati Shikshan Sadan Mahila Shiksan Parshiksha College, Sriganganagar",
  "Choudhary T.T. College, Rawatsar",
  "M.J.  Kumeria College, Rawla Mandi",
  "SARDAR BHAGAT SINGH COLLEGE OF PHARMACY",
  "S G COLLEGE",
  "SHRI HARI  MAHAVIDHYALAYA, KOTRA",
  "Government Law College, Churu",
  "MAHARAJA AGARSEN COLLEGE OF PHARMACY",
  "TAGORE P.G. MAHAVIDYALAYA, SIKAR",
  "GOVT  COLLEGE  PAL DEWAL ,DUNGARPUR",
  "SYMBIOSIS YOGA COLLEGE JAIPUR",
  "HIMALAY MAHAVIDYALAY PUNALI",
  "Lords International T.T.College, Sadulpur",
  "BR PHARMACY COLLEGE",
  "Shrimati Narbada Devi Bihani Government Post Graduate College, Nohar",
  "GOVERNMENT AGRICULTURE COLLEGE, JAMWARAMGARH, JAIPUR",
  "SETH SHREE KEDARNATH MODI RAJKIYA MAHAVIDHALYA, GUDHA (JHUNJHUNU)",
  "SANSKAR BHARTI TEACHER TRAINING COLLEGE SIHALI KHURD,MUNDAWAR. ALWAR",
  "Smt Motadevi Mahavidhalaya, Mahwa",
  "GOVERNMENT COLLEGE, CHECHAT    ",
  "GOVERNMENT COLLEGE DAG    ",
  "GOVERNMENT GIRLS COLLEGE, BHAGWATGARH, KHANDAR, SAWAI MADHOPUR, RAJASTHAN    ",
  "GOVERNMENT AGRICULTURE COLLEGE, BALAHEDA",
  "ANNIE BESANT COLLEGE, AAU",
  "Acharya Shri Mahapragya Institute of Excellence, Asind",
  "GOVERNMENT COLLEGE OF NURSING, LALSOT (DAUSA)",
  "Navjeevan Mahavidhalaya, Kanwat",
  "GOVT GIRLS COLLEGE MITRAPURA SAWAI MADHOPUR",
  "Institute Of Hotel Management Catering and Tourism",
  "Gokul Babu Degree College",
  "SHRI BHARTI PGDCA COLLEGE, JAIRAMPURA, JAIPUR",
  "S G YOGA COLLEGE",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE SABUANA",
  "Adarsh Mahila B.Ed.  Mahavidhyalya, Taranagar",
  "HUA DEVI MANA RAM COLLEGE, MALWARA",
  "VINAYAK INTERNATIONAL COLLEGE CHOMU",
  "Shri Krishan Livestock Assistant Training College (AHDP 08)",
  "Lal Bahadur Shastri Mahila TT College, Tilak Nagar, Jaipur",
  "SHRI HARIDATT COLLEGE OF PHARMACY",
  "SYMBIOSIS COLLEGE OF PHYSIOTHERAPY JAIPUR",
  "GOVERNMENT COLLEGE ANDHI",
  "GOVERNMENT AGRICULTURE COLLEGE PRATAPGARH, RAJASTHAN",
  "B N GIRLS COLLEGE, SALUMBER",
  "SARVODAYA TEACHER TRAINING COLLEGE, Plot No.-IPC-17, Part-B, RIICO Institutional Area, Ranpur, Tehsil-Ladpura, Kota-324003",
  "Sarvodaya Mahila T.T. College, Plot No.-IPC-17, Part-C, RIICO Institutional Area, Ranpur, Tehsil-Ladpura, Kota-324003",
  "DR.RADHAKRISHAN T.T. COLLEGE",
  "BHARATI GIRLS COLLEGE",
  "GOVERNMENT COLLEGE, RAWATSAR",
  "GOVERNMENT COLLEGE, KURABAD",
  "SHRI LAL CHAND MILAP CHAND DHADHA JAIN COLLEGE, OSIAN",
  "MDM HIGHER EDUCATION COLLEGE 11 TK RAISINGHNAGAR",
  "Mansha Ram Bangarwa (MRB) College Kishangarh Renwal, Jaipur",
  "RAJASTHAN L.S.A. TRAINING INSTITUTE",
  "Jasveer Memorial T.T. College, Sahwa",
  "GOVERNMENT ENGINEERING COLLEGE JAIPUR",
  "LRL DEGREE COLLEGE",
  "Mahatma Gandhi Mahavidyalaya, Choti Khatu",
  "AAKASH DEEP TEACHER TRAINING COLLEGE",
  "SIDDHI VINAYAK COLLEGE OF SCIENCE AND HR EDUCATION, ALWAR",
  "SHARDA COLLEGE ",
  "Arya Perfect Graduate College",
  "UNIVERSAL INSTITUTE OF NURSING, NEEMRANA",
  "MOTILAL DAVE COLLEGE METWALA",
  "SHRI RAM GIRLS COLLEGE BASSI",
  "J D COLLEGE OF YOGA",
  "UTTAM PRAKASH AGARWAL COLLEGE OF COMMERCE AND ECONOMICS",
  "SHRI BADRIVISHAL MAHAVIDHYALAY",
  "MA BHAGAWTI PUBLIC GIRLS COLLEGE PADRU ",
  "MONIKA YOGA COLLAGE AMER JAIPUR RAJ",
  "VYAS MEDICAL COLLEGE AND HOSPITAL",
  "GHUSHMESHWAR MAHAVIDHYALYA",
  "SIDDHARTH COLLEGE OF NURSING",
  "YOGMAYA YOGA MAHAVIDHYALAYA",
  "B S COLLEGE BHINMAL",
  "Balhans Mahavidyalaya BIWAI DAUSA",
  "Acharya Chanakya Shiksha Pratisthan, Jaipur",
  "VINAYAK COLLEGE OF PHARMACY",
  "R R COLLEGE OF EDUCATION",
  "M D COLLEGE MAHAJAN",
  "SANKALP MAHAVIDYALAYA",
  "RAJMATA VIJAYARAJE SCINDIA MEDICAL COLLEGE, BHILWARA",
  "DANTA MAHAVIDYALAYA ",
  "CHANDRA SHEKHAR SHASTRI DEGREE COLLEGE",
  "KAUSHALYA DEVI COLLEGE DEEG BHARATPUR RAJASHTAN",
  "Shri Shirdi Sai Baba PG College, Kishangarh",
  "GURUKUL MAHAVIDYALAYA HALIWAV ",
  "R J WORLD COLLEGE OF PHARMACY EDUCATION AND TECHNOLOGY",
  "S.N.College of Pharmacy",
  "KARTIK COLLEGE",
  "DESERT VALLEY DEGREE COLLEGE SEDWA BARMER",
  "ADARSH COLLEGE OF EDUCATION ANANDPURI ",
  "GOVERNMENT COLLEGE BASSI ",
  "Siddhi Vinayak T.T. College, V.K.I Area, Sikar Road, Jaipur",
  "Biyani Girls College., B.ed. College, Jaipur",
  "Swami Vivekanand T.T. College",
  "D.A.V. Law P.G. College, Sri Ganganagar",
  "Siddharth College of Edu., Jaipur",
  "AYUSHMAAN COLLEGE OF NATUROPATHY AND YOGIC SCIENCE",
  "Rajasthan Sangeet Sansthan, Jaipur",
  "Vinayak Mahavidyalaya, Lunwa",
  "BRILLIANT COLLEGE SOMASAR",
  "Shri B L Indoria Memorial College Of Education ",
  "Rajiv Gandhi Livestock Assistant training center (AHDP 37)",
  "SHRI ADARSH COLLEGE",
  "GOVERNMENT COLLEGE CHOTI SARVAN",
  "SHREE DURGA DAN MEMORIAL COLLEGE",
  "Arya Vidyapeeth PG Girls College, Bharatpur",
  "Govt Girls College Tivri Mathania ",
  "Government Girls College Hanumangarh",
  "BHARTI MAHILA MAHAVIDHYALAYA DHANOTA JAIPUR",
  "PIONEER COLLEGE BARAN",
  "SUDHA MEDICAL COLLEGE KOTA",
  "RUKMANI DEVI MEMORIAL COLLEGE OF AGRICULTURE SARAWALI MANDAWAR",
  "SIDDHI VINAYAK MAHAVIDHYALAYA ",
  "GOVT COLLEGE DESHNOK BIKANER",
  "Government College, Khajuwala",
  "M.B. Vagad Pashudhan Sahayak Training Center (AHDP 13)",
  "B.B.M.S. Animal Husbandry College (AHDP 17) ",
  "S D COLLEGE OF PHYSICAL EDUCATION ",
  "GOVERNMENT COLLEGE NOKHADA",
  "SUBHASH CHANDRA BOSE COLLEGE, SAHAWA",
  "CHHATRAPATI SHIVAJI MAHAVIDYALAYA, JAIPUR",
  "GOVT SHASTRI SANSKRIT COLLEGE SAIDPURA BHARATPUR",
  "B P GAUTAM SHIKSHA SHASTRI COLLEGE SAWAR AJMER",
  "LORD BUDDHA COLLEGE SANCHORE",
  "DR ANUSHKA LAW COLLEGE UDAIPUR",
  "SUNRISE COLLEGE OF PHARMACY",
  "SHRI HARDEV KRIPA EDUCATION COLLEGE SABLA",
  "GOVT.  COLLEGE, SIROHI",
  "NAGFANI INSTITUTE OF ANIMAL HUSBANDRY",
  "FACULTY OF AGRICULTURE ENGINEERING",
  "SIDDHARTH COLLEGE SANCHORE",
  "SANSKAR INTERNATIONAL B SC NURSING COLLEGE",
  "PRATISTHA COLLEGE",
  "JR PG COLLEGE PRATAPGARH",
  "Rajeev Gandhi Memorial College of Animal Husbandry (AHDP 19) ",
  "GOVT GOLLEGE LAKHERI, KESHORAIPATAN, BUNDI    ",
  "AMBIKA COLLEGE, PALLU",
  "M.D. College",
  "SURENDERA COLLEGE OF NURSING",
  "NAMAN HOSPITAL AND INSTITUTE OF NURSING",
  "GAURAV COLLEGE OF EDUCATION",
  "M. H. NURSING COLLEGE JODHPUR",
  "SIDDHANT COLLEGE OF NURSING, JAIPUR",
  "Bright Future TT College, Jaipur",
  "Flower Kids College",
  "Bhadra Century College, Bhadra",
  "mahveer jain pg college",
  "INDIRA MAHAVIDHAYALAY LAL JI KI DUNGARI ",
  "SHRADDHA WOMAN TT COLLEGE KAMAN",
  "GOVERNMENT COLLEGE RENI, ALWAR",
  "Government Arts College, Kota",
  "Government Arts Girls College, Kota",
  "Government Commerce College, Sikar",
  "SANJEEVAN COLLEGE OF TEACHING EDUCATION, DAUSA",
  "Sh. Chandrashekhar College, Sujangarh",
  "RATNI DEVI GIRLS T T COLLEGE",
  "St Wilfreds Evening College for Girls",
  "RAMKUMARI INSTITUTE OF AYURVEDA",
  "Kanoria School of Law for Women, Jaipur",
  "Gyan Jyoti College, Srikaranpur",
  "Surendra Kaur Memorial T.T. College, Padampur",
  "SHRI GANPATI ADARSH LSA TRAINING INSTITUTIE BARUNDHAN BUNDI RAJASTHAN",
  "Shri Shyam Teacher Training College Bhadra",
  "Modern Teachers Training College, Churu",
  "Bharti Vidyapeeth College - Rajaldesar",
  "nirmal shikshak prashikshan sansthan munderi",
  "SAND DUNES COLLEGE OF EXCELLENCE",
  "JAISWAL COLLEGE OF NURSING, KOTA",
  "IG MAHAVIDYALAY NAYA BATADU",
  "Arch Research College for Higher Education, Jaipur",
  "Bhavya Kanya Mahavidyalaya, Kuchera",
  "SHRI GANGASHARAN MAHILA COLLAGE BHARATPUR",
  "MRBD COLLEGE OF EDUCATION,BHADRA",
  "VIDHYASTHALI SHIKSHA SHASTRI COLLEGE",
  "GOVT  COLLEGE  RAMSAGRA , DUNGARPUR ",
  "RADHIKA  MAHAVIDHYALAYA, BHANDAREJ",
  "KARNI GIRLS COLLEGE",
  "Hans College of Edu., Jaipur",
  "Raj Shikshak Prashikshan Mahila Mahavi., Jhunjhunun",
  "New Adarsh Mahila TT College, Jaipur",
  "S S COLLEGE ",
  "MAA VAISHNAVI EDUCATION INSTITUTE AND RESEARCH SANSTHAN",
  "NAVJEEVAN VIGYAN MAHAVIDHALAYA",
  "GANPATI KESHORAI COLLEGE OF NURSING",
  "S P N Agriculture College",
  "Shri Adarsh Mahila b.Ed. College, Sikar",
  "LUV-KUSH TEACHER TRANING COLLEGE, DUDHU ",
  "Maharshi Parshu Ram College, Jaipur",
  "H. H. Maharaja Hanwant Singh Memorial Girls College",
  "SHREE KANIRAM COLLEGE, KEKAR",
  "GOVERNMENT COMMERCE COLLEGE, ALWAR",
  "Cambridge Kanya PG Mahavidyalaya, Sikar",
  "shree Ji College ",
  "GOVINDAM T.T. COLLEGE,Palwas Road ,Sikar",
  "SAINT PAUL CONVENT COLLEGE ",
  "GOVT GIRLS COLLEGE TAPUKRA",
  "Pragati College, Dungarpur",
  "SHRI DAU BABA COLLEGE OF PHARMACY",
  "GOVERNMENT COLLEGE KHAIRTHAL ALWAR",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE KUNDGATE SAWAR",
  "JAI MARUDHAR KESHARI COLLEGE",
  "SHREE VINAYAK COLLEGE, SOJAT CITY ",
  "RAJASTHAN COLLEGE OF PHARMACY",
  "MAHALA COLLEGE",
  "SHEKHAWATI INSTITUTE",
  "B.N.D. Government Arts College, Chimanpura",
  "Shri Jain Adarsh B.Ed. College, Nokha",
  "VINAYAK COLLEGE, BAGRU",
  "Manav Mangal College of Education, Sangaria",
  "Dhattarwal College Of Pharmacy",
  "GOVERNMENT ARTS COLLEGE, SIKAR",
  "Sanskar International College",
  "Shri Ram Mahavidhyalay Tinwari",
  "SHRI KARNI TEACHERS TRAINING COLLEGE",
  "VIVEKANAND COLLEGE LALGARH",
  "Maitreyee Girls Teacher Training College, Riyanbadi",
  "GOVERNMENT GIRLS COLLEGE, CHHAREDA",
  "GOVERNMENT GIRLS COLLEGE BHANDAREJ, DAUSA ",
  "GOVTRNMENT COLLEGE KALLAWAS, DAUSA",
  "Adarsh Mahavidyalaya, Khinwsar",
  "GOVERNMENT COLLEGE JAGATPURA, JAIPUR",
  "GOVERNMENT GIRLS COLLEGE, AMER",
  "Kanoria Girls B.Ed. College, Jhunjhunun",
  "Shri B.D. Todi PG College, Sikar",
  "SARVODAYA GIRLS COLLEGE RAJGARH",
  "GOVERNMENT MEDICAL COLLEGE, DUNGARPUR",
  "Smt. Mohani Devi Chachan Government College, Sahwa",
  "Hans College Paota",
  "SUNDER T T COLLEGE MAHAPURA AJMER ROAD JAIPUR ",
  "REKHA MAHAVIDHYALAYA ",
  "GOVT COLLEGE CHIKHALI",
  "SADGURU INSTITUTE OF EDUCATION",
  "RANI RUPADE MAHILA MAHAVIDYALAYA PADARLI ROAD GARH SIWANA BARMER",
  "Govt. College Bansur, Alwar ",
  "KESARI COLLEGE, BAGODA (JALORE)",
  "GOVERNMENT COLLEGE SHERGARH, JODHPUR",
  "UDAI COLLEGE,KARDA",
  "CHOUDHARY A.R. COLLEGE,WARD NO.19.BUKANSAR BASS,SARDARSHAHAR",
  "NORANG RAM DAYANAND DHUKIA COLLEGE JHUNJHUNU",
  "Shri Shyam Mahila Mahavidyalaya, Behramda, Teh. Nadbai, Dist. Bharatpur ",
  "Shree Tagore Integrated College",
  "S.S. College of Engineering,Udaipur",
  "Parashuram Bed College",
  "GOVERNMENT COLLEGE, TEHALA, ALWAR",
  "GOVERNMENT COLLEGE, RAJAKHERA",
  "SANT SRI PRANNATH PARNAMI P.G. COLLEGE, PADAMPUR",
  "SADULSHAHAR DEGREE COLLEGE ",
  "Mahant Kishore Puri College of Management and Technology",
  "MOTHERLAND CAREER COLLEGE",
  "Aishwarya College of Management & Research Center-ACMRC",
  "D.A.V.TEACHERS TRAINING COLLEGE, (4 YEAR INTIGRETED COLL)",
  "SHREE HARI TT COLLEGE KOTDA",
  "SORABH COLLEGE",
  "M.B. Pachak College, Mokalsar (Barmer)",
  "khawaja garib nawaz college,kharachi",
  "SARSWATI COLLEGE RENI (ALWAR)",
  "RUNGTA NURSING COLLEGE",
  "GLOBAL INSTITUTE OF B.ED COLLEGE BARODIYA",
  "MAHADEV COLLEGE BAYTU",
  "Rishi Galav TT College, Dhaulpur",
  "LUV-KUSH COLLEGE ",
  "VIVEKANAND INTEGRATED COLLEGE, KUCHAMAN CITY",
  "Government Sanskrit PG college Dausa",
  "YOGESHWAR COLLEGE , SAJJANGARH",
  "VIVEKANAND COLLEGE, GHATOL",
  "sunrose teacher training  institute ",
  "GOVERNMENT LAW COLLEGE NAWA",
  "Basic College",
  "Gurukul College, Jaipur",
  "JAGRAUTI WOMEN COLLEGE, KHERLA BUJURG",
  "Shekhawati College for Edu., Sikar",
  "SAINT SOLDIER COLLEGE FOR GIRLS, JAIPUR",
  "S. P. N. HIGHER EDUCATION COLLEGE",
  " Dhooleshwar Govt. Sanskrit PG , Manoharpur",
  "Mata Mohani Devi Bedi Mahila T.T. College, Anupgarh",
  "SHREE BALAJI MAHAVIDHYALA",
  "VIVEKANAND COLLEGE, ANJANA",
  "BS MEMORIAL COLLEGE OF PHARMACY RANOLI SIKAR ",
  "SUNROSE COLLEGE",
  "Shankara College of education ",
  "Gurukul Institute of Post Graduate & Research, Lalpura, Suratgarh",
  "S S Jain Subodh P G College, Jaipur",
  "ABHILASHA COLLEGE,  SANDWA ",
  "Shri Mangilal Nirvan Homeopathic Medical College and Research Centre, Bikaner",
  "Smt. Rama Devi T.T. College, Sadulpur",
  "Khalsa Girls College, Sadulshahar",
  "IMPULSE GIRLS COLLEGE DAUSA",
  "GOVERNMENT GIRLS COLLEGE, ABUROAD RAJ",
  "MAHARISHI ARVIND INSTITUTE  OF PHARMACY",
  "RAJASTHAN PHARMACY COLLEGE, JAIPUR",
  "ANAND INSTITUTE OF MEDICAL SCIENCES & RESEARCH CENTRE, JAIPUR",
  "JAIPUR COLLEGE OF PHARMACY",
  "SSG Pareek PG College of Education, Jaipur",
  "Shri Sharma Shikshak Prashikshan Mahavi., Jaipur",
  "Shri Pitambra P G Mahila Mahavidyalaya, Jaipur",
  "Pinkcity Girls College, Jaipur",
  "Vidyasthali Law College, Jaipur",
  "Shri Bal Vikas TT College, Bharatpur",
  "ALWAR PHARMACY COLLEGE",
  "VIDYA BHAWAN GANDIAN INSTITUTE OF EDUCATION STUDIES, RAM GIRI (BADGAON)",
  "VISDAM TEACHERS TRAINING COLLEGE, 38-GANDHI NAGAR, MULLA TALAI",
  "VIVEKANAND YOGA AND NATUROPATHY COLLEGE, BAJOUR, SIKAR",
  "S.K.D.T.T.COLLEGE",
  "B R COLLEGE LAKHANI",
  "SLBS Pharmacy College ",
  "Vasundhara Mahila PG Mahavidyalaya, Jaipur",
  "R.K. Vigyan (P.G.) Mahavidyalaya, Jaipur",
  "GOVERNMENT MEDICAL COLLEGE ALWAR",
  "MEWAR GIRLS COLLEGE, SECTOR NO.5 GANDHI NAGAR",
  "Om Shiv Sansthan Yoga and Naturopathy College",
  "G D College, Jaipur",
  "Taj Memorial TT College, Jaipur",
  "M.S.D. College of Education",
  "VIVEKANAND COLLEGE OF B.Ed., DABOK",
  "Maharaja Ganga Singh College, Kesharisinghpur",
  "Murli Singh Yadav Memorial T.T. College, Udairamsar",
  "Shri Jain Adarsh Kanya College - Nokha",
  "S.S.C. Balaram Arya Girls College, Chandgothi",
  "Bal Gangadhar Tilak Shiksha Sansthan, Bhadra",
  "Govt. Law College, Dhaulpur",
  "Eminent Academic Girls College, Diggi Malpura",
  "Smt. Sarbati Devi Mahila TT College, Jaipur",
  "Dr. B. R Ambedkar P G College, Jaipur",
  "Lokesh TT College, Jaipur",
  "UMA SHIV T T COLLEGE BASANT VIHAR, KOTA",
  "Mahaveer Law College, Jaipur",
  "Makrana T.T. College, Makrana",
  "Aatmaram S.V.S. College",
  "Shahid Bhagat Singh Mahavidyalaya, Chhan",
  "Shri Jain Girls College - Bikaner",
  "Mata Jeetoji Girls College, Suratgarh",
  "Jasveer Memorial College, Sandwa",
  "AKLANK COLLEGE, BASANT VIHAR, KOTA",
  "Global Mahavidyalaya, Thanwla, Tehsil Riyanbadi",
  "Mata Gujri Khalsa T.T. College, Sriganganagar",
  "GANESH  COLLEGE, GANEDI",
  "Government College, Sojat City",
  "K.D. Mahavidyalaya, Guddamalani",
  "Adarsh Mahavidyalaya, Gotan",
  "Roopi Devi Kanya Mahavidyalaya, Mandal",
  "TRINETRA MAHAVIDHYALAYA MALARNA CHOUR SAWAI MADHOPUR",
  "S.S. Rathore Memorial T.T. College",
  "AATMARAM COLLEGE OF EDUCATION SHRIMADHOPUR",
  "Sanskar Bharti Mahila TT College, Jaipur",
  "Vishwa Bharti B.Ed. College, Jhunjhunun",
  "Vasundhara Mahila Shikshak Prashikshan Mahavi., Sikar",
  "Kuchaman College of Education, Kuchaman City",
  "Trilok Singh TT College, Sikar",
  "GOVERNMENT GIRLS COLLEGE BHIWADI ",
  "FRANKLIN COLLEGE, THALARKA",
  "SARASWATI MAHAVIDYALAYA",
  "VIVEKANAND COLLEGE OF PHARMACY KATAR CHHOTI",
  "Smt. Narayani Devi Verma Women's Teachers Training College (Mahila Ashram)",
  "Dayanand College",
  "Shree Bangur Mahila Mahavidyalaya, Deedwana",
  "Jupiter College, Kuchaman City",
  "Mahaveer B.Ed. College, Jaipur",
  "Adarsh Teachers Training College, Deoli",
  "Dev Kanya P.G. Mahavidyalaya, Deoli",
  "S.M.S. Mahila Shikshak Prashikshan Mahavidyalaya",
  "Government College, Uniara",
  "Eklavya Teachers Training College",
  "Rajasthan Aanchlik Mahavidyalaya, Aasind",
  "Murtidevi Memorial  B.Ed. College, Chak 4 SDS, Sadulsahshar",
  "RADHAKRISHNAN MAHAVIDHYALYA",
  "Veer Teja Mahila Mahavidyalaya, Mundwa",
  "Pt. J.P. Upadhyaya T.T. College",
  "SHRI LAL BAHADUR SHASTRI BED COLLEGE JODHPUR",
  "Marwar Mahavidyalaya, Makrana",
  "sardar patel law college ",
  "Gramotthan Vidyapeeth T. T. College, Sangaria",
  "Gurukul B.Ed. College, Gotan",
  "Bhagwati Girls College, Lalgarh Jattan",
  "Sardar Vallabh Bhai Patel Mahavidyalaya, Bhadra",
  "S S COLLEGE OF PHARMACY",
  "GOVERNMENT GIRLS COLLEGE SOORSAGAR",
  "R.N.T. COLLEGE OF TEACHERS & EDUCATION, KAPASAN",
  "Madi Devi Memorial B.Ed. College, Rianbari",
  "Star Infotech College, Deoli",
  "Dr. Ambedkar B.Ed. College",
  "Vidhya Professional & Technical College",
  "Smt. Sushila Devi Mathur Kanya Mahavidyalaya",
  "Shri Pragya Mahavidyalaya, Bijainagar",
  "Tagore Mahavidyalaya, Molasar",
  "SHRI KRISHNA MAHAVIDYALAYA, GOVINDGARH, TEH CHOMU, JAIPUR",
  "Narayana Shikshak Prashikshan Mahavidyalaya",
  "GOVERNMENT COLLEGE RIYAN BARI",
  "GOVERNMENT COLLEGE OF NURSING, NIMBAHERA DIST CHITTORGARH",
  "Global College, Jhunjhunun",
  "Chaudhry Charan Singh College of Animal Husbandry (AHDP 02)",
  "D.A.V. COLLEGE (SRI GANGANAGAR)",
  "SHIVAM MAHILA MAHAVIDYALAY",
  "Shekhawati Sandhya Law Institute Behind Circuit House Jaipur Road Sikar",
  "MARUTI NANDAN GIRLS COLLEGE BHARATPUR",
  "Tagore Shikshak Prashikshan Sansthan, Kuchaman City",
  "Jia Lal Institute of Education",
  "CAMBRIDGE COLLEGE JAIPUR ROAD SARDARSHAHAR CHURU",
  "Vijaya Raje College of Nursing Jodhpur",
  "SKG MEMORIAL NURSING INSTITUTE",
  "Mahadev B.Ed. College, Chhoti Khatu",
  "SHRI DATTATRYA COLLEGE ,KANKROLI",
  "Mishri Lal Dubey Girls T.T. College, Kekri",
  "Eminent T.T. Girls College, Diggi Malpura",
  "Dezyne E-cole College",
  "Government College, Pokaran",
  "Peepar Teachers Training College, Peepar City",
  "Alok Vigyan Mahavidyalaya, Kekri",
  "Pannadhay Mahila Shikshak Prashikshan Mahavidyalaya",
  "INDERPURA PHARMACY COLLEGE ",
  "R.N.T. Memorial College, Newai",
  "Rajeev Gandhi Mahavidyalaya, Amarwasi",
  "Adarsh B.Ed. College, Merta City",
  "Government College, Deoli",
  "Dev Shikshak Prashikshan Mahavidyalaya",
  "Gurukul College, Kekri",
  "Government College, Merta City",
  "Choti Devi Memorial Girls B.Ed. College, Deedwana",
  "Regional Institute of Education",
  "Shri Madhav Mahavidyalaya, Ladnun",
  "Gramothhan Vidyapeeth Sansthan",
  "Maharana Pratap Mahavidyalaya, Uniara",
  "Arya Narayani Devi T.T. College",
  "Seema Memorial B.Ed. College, Parbatsar",
  "Smt. Rama Devi B.Ed. College, Bijainagar",
  "Tagore T.T. College, Kekri",
  "Aryabhatt International College of Technical Education",
  "SAJJAN VIDHI MAHAVIDYALAYA",
  "SARASWATI MAHILA MAHAVIDHYALYA MANOHARPUR",
  "SHRI ARJUN MAHAVIDHLAYA ANTELA",
  "Gargi Kanya Mahavidyalaya, Nohar",
  "FRAME COLLEGE",
  "SWAMI VIVEKANAND MAHAVIDHYALAYA BADHAL",
  "Government Medical College",
  "St. Stephen College, Kishangarh",
  "Smt. Seeta Devi Chunni Lal Baradia Government Girls College, Pipar City",
  "MAHARAJA SHRI SURAJMAL COLLEGE, RAHIMPUR ",
  "INDIAN COLLEGE",
  "Choudhary Girdhari Ram Dhaka Agriculture College",
  "Hind Teachers Training College",
  "Mother Land Girls Teachers Training College",
  "Shri Ganesh Chandra T.T. College, Jas Nagar, Merta City",
  "BABA VISHAMBHAR DASS MAHAVIDAHAYLA, KHANDELA",
  "GOVINDAM MAHAVIDYALAYA, NEAR BYPASS CIRCLE, PALWAS ROAD",
  "Baba Shyam T T College, Sikar",
  "Shri Sawai T.T. College, Bhatibas, Deedwana",
  "Shaheed Bhagat Singh Shikshak Prashikshan Mahavidyalaya, Nawa Shahar",
  "Vivek Bharti College, Bhilunda Sikar ",
  "Anuvrat Mahila Shikshak Prashikshan Mahavidyalaya, Bankli, Mandal",
  "J.B.GIRLS COLLEGE TOONGA",
  "Sanskar College of Graduation, Peeplu",
  "Tagore Girls College  Shastri Nagar",
  "SHRI RAMJILAL SMRITI SHIKSHA MAHAVIDYALAYA VILL-PAWALIYA, SANGANER, JAIPUR, RAJASTHAN",
  "S. S. JAIN SUBODH COLLEGE OF GLOBAL EXCELLENCE",
  "RAJASTHAN GRAMIN MAHAVIDYALAYA, THOI",
  "SORABH COLLEGE OF EDUCATION",
  "MATESHWARI TEACHERS TRAINING COLLEGE, APSARA BHAWAN, TORAN BAWRI",
  "SHRINATHJI INSTITUTE OF BIOTECHNOLOGY AND MANAGEMENT",
  "SAGAR B.Ed. COLLEGE, SERVICE ROAD, H.NO.8, NEAR PANCHOLI HOSPITAL ,KHERWARA",
  "S.S. RAMBHAROSE LAL VERMA GOVT. ACHARYA SANSKRIT COLLEGE BHARATPUR",
  "SANSKAR TEACHERS TRAINING COLLEGE, SHIVGANJ",
  "MAHARAJA COLLEGE OF ARTS & EDUCATION, AIRPORT ROAD, DEBARI",
  "Arch Research College for Higher Education Evening",
  "Shri Ganganagar Shikshan Prashikshan College, Sriganganagar",
  "MEHTA GIRLS COLLEGE",
  "MAHALA INSTITUTE OF PHARMACY",
  "MAHALA VETERINARY COLLEGE",
  "Rajasthan College., Jhunjhunun",
  "GOVERNMENT COLLEGE KALYANPUR",
  "MAA VAISHNOV DEVI TEACHERS TRAINING COLLEGE, T-26 , UDAI PARK SECTOR NO. 5",
  "Prince Shikshak Prashikshan Mahavi., Sikar",
  "DR. B.R. AMBEDKER GOVT.COLLEGE, NIMBAHERA",
  "BDML COLLEGE OF EDUCAITON BED DHELAWAS",
  "Kalyani Devi Mahavidhyalaya Naila,",
  "M.B.C. Government Girls College, Barmer",
  "GOVT GIRLS COLLEGE BARI",
  "Gramodaya Degree College Bamrala",
  "ARAVALI MAHAVIDYALAYA, BASSI, JAIPUR",
  "KANKU VIJAY COLLEGE OF EDUCATION, PALI",
  "Gurukul Mahavidhalaya VPO- Chomupurohita-Khatushyamji",
  "SANSKAR COLLEGE OF NURSING, JAIPUR",
  "Prince Academy of Higher Edu. Shikshan Prashikshan Mahvi., Sikar",
  "SHRI BALAJI COLLEGE",
  "MAHARANI GIRLS B.Ed. COLLEGE, NH-76 AIRPORT ROAD, DEBARI",
  "VAGAD SHREE COLLEGE",
  "NITYA LEELASTHA TILKAYAT SHRI. GOVINDLALJI MAHARAJ GOVT. GIRLS COLLEGE, NATHDWARA",
  "SANJEEVANI TEACHERS TRAINING COLLEGE, NH-8, UDAIPUR-AHMEDABAD ROAD, OPP. MATTS RESORT, VILLAGE- KAYA",
  "GOVT. COLLEGE, AMET",
  "U.S.B. COLLEGE OF TEACHERS EDUCATION,  G-192 AMBAJI INDUSTRIAL AREA",
  "J.R. COLLEGE , RAILMAGRA",
  "Prince Academy of Higher Edu. Girls College, Sikar",
  "Norang Ram Dayanand Dhukia TT College, Jhunjhunun",
  "Sanskar Bharti T T College",
  "Vardhman Shikshak PRashikshan Mahavi., Sikar",
  "SMS MEDICAL DEPARTMENT OF PHARMACY, JAIPUR",
  "Vishwa Bharti Degree College, Jhunjhunun",
  "B R COLLEGE REENGUS TEH SHRIMADHOPUR DIST SIKAR",
  "UPCHAR COLLEGE OF NURSING, JAIPUR",
  "New Rajasthan TT College, Jhunjhunun",
  "VARUN COLLEGE OF PHARMACY, JAIPUR",
  "BIRLA COLLEGE OF NURSING, JHUNJHUNU",
  "Geeta Devi Degree Kishan Garh Road, Alwar",
  "Global T T College, Alwar",
  "GOVERNMENT COLLEGE, THANAGAZI",
  "GOVERNMENT COLLEGE, TIJARA",
  "Govindam T T College, Alwar",
  "Govt. College, Bibi Rani, Alwar",
  "Govt. College, Govindgarh, Alwar",
  "Govt. College, Rajgarh",
  "Gramotthan Vidyapeeth PG Girls College, Alwar",
  "Guardian Inst. Of Edu. & Technology, Alwar",
  "Guru Govind Singh Kanya Mahavidyalaya, Alwar",
  "Harsh TT College, Alwar",
  "Janki Devi College, Alwar",
  "Kalpana Chawla Girls PG College, Alwar",
  "Karam Bhoomi TT College, Alwar",
  "KARAM MANOVIKAS SANSTHAN",
  "Karam Vidya Mandir Shikshan Sansthan, Alwar",
  "Maharaja College of Edu., Alwar",
  "Maharaja Mahila Mahavidyalaya, Alwar",
  "MAHARSHI ARVIND MAHAVIDYALAYA , KATHUMER ROAD KHERLI",
  "AGRASEN MAHILA SHIKSHAK PRASHIKSHAN SANSTHAN, KHERLI",
  "AGRSEN MAHILA MAHAVIDHYALAYA, KHERLI",
  "Ananad Mahavidyalaya, Alwar",
  "Anand T T College, Alwar",
  "Anniebeasent Girls College, Alwar",
  "Arya Kanya Mahavidyalaya, Alwar",
  "Arya Mahila T T College, Alwar",
  "Baba Bhagwan Das T T College, Alwar",
  "Baba Khetanath Mahila Shikshak Prashikshan Mahjavi., Alwar",
  "SMT.PANA DEVI RAMESHWER LAL SHARMA LAW COLLEGE ,CHIRAWA",
  "NAURANG RAM DUKIYA COLLEGE OF NURSING, JHUNJHUNU",
  "New Rajasthan Balika PG Mahavi., Jhunjhunun",
  "GYANODYA COLLEGE, BISSAU",
  "Gyan Sindhu Girls College, Jhunjhunun",
  "New Indian TT College, Jhunjhunun",
  "Raj Rishi College, Alwar",
  "GYAN VIHAR COLLEGE SCIENCE PARK ROAD,NAWALGARH",
  "Indian Girls College of Edu., Jhunjhunun",
  "SVP B.Ed. College, Sikar",
  "Indira Gandhi PG Balika Niketan, Jhunjhunun",
  "SN Girls B.Ed. College, Jhunjhunun",
  "Indira Priyadarshini Kanaya, Sikar",
  "Jhunjhunun Icon College, Jhunjhunun",
  "Sanskar College of Edu., Alwar",
  "Jiwani B.Ed. College, Jhunjhunun",
  "K.K.M.S. College, Jhunjhunun",
  "MAULANA AZAD INSTITUTEITUTE OF PHARMACY, JODHPUR",
  "Saraswati TT College, Alwar",
  "SARISKA  MAHAVIDYALAYA, RAJGARH",
  "Seth Prahlad Rai Inst. of Edu., Alwar",
  "G D MEMORIAL COLLEGE OF PHARMACY, JODHPUR",
  "Seth Raj Narayan Gupta Mahila Law College, Alwar",
  "Shaheed Bhagat Singh College, Alwar",
  "Shahjahanpur College, Alwar",
  "Shanti Niketan Shikshak Prashikshan Mahavi., Alwar",
  "Sharbati Devi Shikshak Prashikshan Mahavi., Alwar",
  "Sharma Modern Mahila TT College, Alwar",
  "Shree Shyam TT College, Alwar",
  "Shri Adinath Commerce Evening College, Alwar",
  "Shri Babu Lal Co-education, Alwar",
  "Shri Jain TT College, Alwar",
  "KOTHARI MAHILA MAHAVIDYALAY,MANDRELLA",
  "LN Inst. Of Teacher Edu., Sikar",
  "MAHARANI BALIKA MAHAVIDHYALAYA, RAMPURA, MALSISAR",
  "GOVERNMENT NURSING COLLEGE, JODHPUR",
  "Maharishi Dayanand Balika Vigyan, Jhunjhunun",
  "Maharishi Parshuram PG Mahacvi., Sikar",
  "Mandiya TT College, Sikar",
  "Manu Oxfordt TT College, Jhunjhunun",
  "Jain Institute Of Skills",
  "Shri Krishan PG College, Alwar",
  "Shri Mastsya PG College, Alwar",
  "Shri Matsya Teacher Education College, Kherli",
  "Shri Omkarmal B.Ed. College, Alwar",
  "New Indian Mahila Mahavi., Jhunjhunun",
  "Mata Keshri Devi Kanya PG Mahavi., Jhunjhunun",
  "Mata Keshri Devi TT College, Jhunjhunun",
  "Modern TT CDollege, Jhunjhunun",
  "Mohari Devi Madhav Mahavi., Sikar",
  "Mohini Devi Goenka Girls B.Ed. College, Sikar",
  "SHREE SHYAM COLLEGE,MANDHAN,Teh,BEHROR,ALWAR",
  "Siddhi Vinayak Collegeof Sc. & Hr. Education, Alwar",
  "SITARAM GIRLS COLLEGE ,SIHALI KHURD",
  "Smt. Kamla Devi Mahavidyalaya, Alwar",
  "Mrs. Helena Kaushik Mahila PG Mahavi., Jhunjhunun",
  "Naveen Bharti B.Ed. College, Sikar",
  "Smt. Mahadevi Mahila TT College, Alwar",
  "Smt. Narayan Devi Girls TT College, Alwar",
  "Smt. Narayani Devi Girls College, Alwar",
  "Neelkanth TT College, Jhunjhunun",
  "Saraswati Vidya Niketan Girls College, Rawatsar",
  "SHRADHALAYA JANJATI  B.ED. COLLEGE, ADARSH NAGAR, RAWATBHATA",
  "Jagdamba College - Khajuwala",
  "Navrang Mahavidhalaya",
  "Prince College, Sahawa",
  "Adesh College - Srikolayat",
  "BHAGWAN JAMBHESHWAR MAHAVIDHYALAYA ",
  "SG NURSING COLLEGE",
  "MAHALAXMI MAHAVIDHYALAYA ",
  "SARSWATI MAHAVIDHYALYA NORANGPURA",
  "Paramanand Degree College, Gajsinghpur",
  "Shri Radha Krishan Girls College, Nohar",
  "Swami Commerce College, Ratangarh",
  "S.G.N. Khalsa Girl College, Kesharisinghpur",
  "Shri Jain P. G. College - Bikaner",
  "Shri Bhartiya Adarsh Vidhya Peeth T.T. College, Sardarshahar",
  "M. M. D. Bedi Girls College, Anupgarh",
  "Seth Dharmchand Insttute of Teachers Training, Raisinghnagar",
  "I.G.M. College, Pilibanga",
  "Abhilasha T.T.College, Sahwa",
  "Basic College, Rawatsar",
  "Murti Devi P.G. College",
  "JAIN DIWAKAR KAMALA MAHAVIDYALAYA, KOTA",
  "Shiva Girls College - Khajuwala",
  "S. B. D. Govt. College, Sardarshahar",
  "Agarsen Degree College, Padampur",
  "Sanjivani College, Raisinghnagar",
  "VIJAY RAJE MAHILA SHIKSHA SHASTRI COLLEGE ,AKLERA",
  "SBN Degree College, Sidhmukh",
  "Indian T.T. College, Churu",
  "JAWAN SINGH MEMORIAL VETERINARY AND ANIMAL HUSBANDRY COLLEGE ",
  "MAHATMA GANDHI SCHOOL OF PHARMACY, BANSWARA",
  "PRABHA SHANKAR PANDYA COLLEGE OF NURSING, BANSWARA",
  "SHRI ONKAR LAL NURSING COLLEGE, BARAN",
  "PROF. S. KARAN MAHILA SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA",
  "SHREE NRASINGH COLLEGE OF NURSING, BHARATPUR",
  "RAMSNEHI COLLEGE OF NURSING, BHILWARA",
  "DR TANVEER MALAVAT NURSING COLLEGE, BIKANER",
  "GOVERNMENT COLLEGE, CHAUMAHLA",
  "GOVERNMENT COLLEGE, PIDAWA",
  "MAHARANI GIRLS ENGGINEERING COLLEGE, JAIPUR",
  "NEW EDEN MAHILA MAHAVIDYALA ",
  "Oxford International College, Parawa",
  "GOVT COLLEGE UCHAIN BHARATPUR",
  "SANT RADHA RAMAN TEACHERS TRAINING COLLEGE, PATAN ROAD, MANPURA, NEEM KA THANA",
  "MAHESH INSTITUTE OF PROFESSIONAL STUDIES YOGA AND NATUROPATHY COLLEGE, BARMER",
  "GOVERNMENT AGRICULTURE COLLEGE KEKRI",
  "AAPESHWAR COLLEGE,  RAMSEEN",
  "VIDHYASTHALI TEACHER TRAINING COLLEGE, KHERLI",
  "VINAYAK YOGA AND NATUROPATHY COLLEGE ",
  "VINAYAK AYURVED NURSING BSC NURSING (AYURVED) COLLEGE",
  "Mahesh Teachers Training College",
  "Mahesh Mahila Shikshak Prashikshan Mahavidyalaya",
  "GOVERNMENT GIRLS COLLEGE ,PEEPLA, BHARATPUR",
  "BALA JI COLLEGE OF BHM",
  "Government Law College, Pali",
  "G.D. Government College For Women , Alwar",
  "M N COLLEGE OF NURSING, BIKANER",
  "SHRI BALAJI COLLEGE OF NURSING, CHURU",
  "INDIAN COLLEGE OF NURSING, DAUSA",
  "SARASWATI COLLEGE OF NURSING, DAUSA",
  "NEHRU MEMORIAL COLLEGE OF PHARMACY, HANUMANGARH",
  "GOVERNMENT DENTAL COLLEGE, JAIPUR",
  "S.N.K.P. Govt. P.G. College, Neem Ka Thana (Sikar)",
  "Seth R.N. Ruia Govt. College, Ramgarh Shekhawati (Sikar)",
  "DIVYA CO EDUCATION MAHAVIDHYALAYA, AJEETPURA, NAWAN",
  "SHREE KRISHNA T T COLLEGE SIKANDRA ",
  "ARYA COLLEGE OF PHARMACY, JAIPUR",
  "SHRI VINAYAK COLLEGE OF AGRICULTURE ",
  "SANGVI MATUSHRI PURIBAI BHURMAL JAIN GOVERNMENT COLLEGE, SHEOGANJ ",
  "B L M COLLEGE OF NURSING, JAIPUR",
  "D H COLLEGE OF NURSING, JAIPUR",
  "DEVI INSTITUTEITUTE OF NURSING COLLEGE, JAIPUR",
  "JEEVAN SHREE NURSING COLLEGE, JAIPUR",
  "LAL BAHADUR SHASHTRI COLLEGE OF PHARMACY, JAIPUR",
  "Kota College of Education, Sp.-1, RIICO IndustrialArea,Ranpur, Kota",
  "ST  AGASTYA COLLEGE",
  "SHRI AGRASEN SHIKSHAK PRASHIKSHAN MAHILA MAHAVIDYALAYA, BHARATPUR",
  "Nehru Mahavidyalaya",
  "VAGAD COLLEGE, DAVELA, KOTRA",
  "GOVERNMENT AGRICULTURE COLLEGE,HINDAUN CITY",
  "GOVERNMENT GIRLS COLLEGE, GALIYAKOT ",
  "ASIAN INSTITUTE OF VETERINARY SCIENCE ",
  "MAHARANA PRATAP NATIONAL INSTITUTEITUTE OF NURSING EDUCATION AND RESEARCH CENTRE, JAIPUR",
  "Rama Krishna Teacher Training College, Jaipur",
  "MAHARSI ARVIND COLLEGE OF PHARMACY, JAIPUR",
  "SHRI SANT VETERINARY INSTITUTE",
  "Sharda Sadan College of Education",
  "SAURABH NURSING COLLEGE ",
  "SWAMI VIVEKANAND LIVESTOCK DIPLOMA  TRAINING INSTITUTE  ",
  "JEEVAN RATAN MAHAVIDYALAY",
  "Shah Satnam Mahila College, Shrigurusar Modiya",
  "SOBHASARIA SCHOOL OF LAW",
  "GOVERNMENT GIRLS COLLEGE, PANCHLA SIDDHA",
  "SHREE GRAMOTTHAN COLLEGE, SEDWA",
  "ARAVALI SHIKSHAN EVAM ANUSANDHAN SANSTHAN",
  "Raghav Aadarsh Mahavidhyalay Khinwara",
  "M.G. Memorial College, Jetsar",
  "SWASTHYA KALYAN COLLEGE OF PHARMACY",
  "Sir Chhotu Ram L.S.A. Training Institute (AHDP 05)",
  "BALAJI BED COLLEGE",
  "DEVSTHALI MAHAVIDYALAYA",
  "GOVT GIRLS COLLEGE SARDARSHAHAR ",
  "MAA BHARTI COLLEGE",
  "GRAMIN COLLEGE JANAU KHARI RAJGARH CHURU",
  "MAHATMA GANDHI COLLEGE OF PHARMACEUTICAL SCIENCES, JAIPUR",
  "KUMODINI MAHAVIDHYALAYA",
  "SHRI BHAWANI NIKETAN COLLEGE OF PHARMACY",
  "Vagad College, Badgi",
  "LOKMANYA TILAK PHARMACY COLLEGE ",
  "GOVERNMENT COLLEGE JALSU",
  "SHRI BAPUJI COLLEGE OF PHARMACY",
  "Tagore Mahila T.T. College, Suratgarh",
  "B.R. COLLEGE OF AGRICULTURE , SAHAWA",
  "GOVERNMENT GIRLS COLLEGE BAHADURPUR ALWAR",
  "LORD BUDDHA COLLEGE OF PHARMACY",
  "MAHARAJA HAMEER COLLEGE CHAUTH KA BARWARA SAWAI MADHOPUR",
  "MAHATMA JYOTIBA FULE COLLEGE OF NURSING, JAIPUR",
  "JAI SHREE COLLEGE OF PHARMACY, JAITARAN, PALI",
  "Balaji Institute of Education, C/o Madhu Smriti Sansthan, Teh. Ladpura, Kota",
  "PINK CITY COLLEGE OF NURSING, JAIPUR",
  "GENIUS COLLEGE OF NURSING, BHILWARA",
  "SUMATI COLLEGE OF PHARMACY",
  "CHANAKYA MAHAVIDYALAYA",
  "GANPAT RAM DHUKIA TT COLLEGE",
  "VINAYAK COLLEGE BAGHER",
  "SHANTINATH COLLEGE SEWADI",
  "MAHARANA PRATAP COLLEGE SEWADA",
  "RAMA KRISHNA INTEGRATED DEGREE COLLEGE",
  "GOVERNMENT AGRICULTURE COLLEGE MACHARI",
  "RAMAKRISHNA DEGREE COLLEGE",
  "SARASWATI COLLEGE OF PHARMACY JAISINGHWAS",
  "VANDEMATRAM COLLEGE",
  "GOVERNMENT GIRLS COLLEGE, BUDDHA JOHAR, RAISINGHNAGAR",
  "FACULTY OF DAIRY TECHNOLOGY",
  "SHREE J G S MEMORIAL BED COLLEGE KHAJUWALA",
  "MAHATMA GANDHI PG COLLEGE SHRIMADHOPUR NEEMKATHANA",
  "GOVT GIRLS COLLEGE UCHCHAIN BHARATPUR RAJASTHAN",
  "ANNIE BESANT SPECIAL TEACHERS TRAINING COLLEGE, JODHPUR",
  "GOVERNMENT AGRICULTURE COLLEGE, TODABHIM",
  "KARUNA SHIKSHAK PRASHIKSHAN MAHILA MAHAVIDYALYA",
  "IMPULSE COLLEGE OF EDUCATION DAUSA ",
  "GOVERNMENT COLLEGE SISWALI",
  "GOVERNMENT COLLEGE OF NURSING, BIKANER",
  "GOVERNMENT AGRICULTURE COLLEGE, KARAULI ",
  "MAHARANA PRATAP EVENING MAHAVIDHALIYA, Uniyara",
  "VARDA COLLEGE",
  "GOVERMENT COLLEGE OF NURSING, BHARATPUR ",
  "GOVT GIRLS COLLEGE KATKAD",
  "GOVT GIRLS COLLEGE DEEG BHARATPUR RAJ",
  "A.P.J. ABDUL KALAM GOVERNMENT GIRLS COLLEGE, GANGAPOLE, JAIPUR",
  "SHRI SAYAR MAHAVIDYALAYA KUPDAWAS UDALIYAWAS ",
  "BIKANER COLLEGE OF NURSING, BIKANER",
  "ABHISHEK COLLEGE, DATTWAS, Tehsil NIWAI",
  "A I KHOKHAR MEMORIAL COLLEGE, CHHAPRI KHURD",
  "ALOK MAHAVIDYALAYA",
  "APEX COLLEGE OF EXCELLENCY, Makrana",
  "Dr RADHAKRISHNAN COLLEGE, Kuchaman City",
  "Government College, Tantoti, Kekri",
  "Government College, Pushkar",
  "Government College, Todaraisingh",
  "GOVERNMENT GIRLS COLLEGE, ALIGARH, UNIARA",
  "LAKSHYA COLLEGE OF PHARMACY",
  "SWAMI KESHWANAND INSTITUTE OF PHARMACY, BIKANER",
  "LRL PHARMACY COLLEGE",
  "STECH GIRLS COLLEGE PHARMACY",
  "GOVERNMENT GIRLS COLLEGE, GULABPURA",
  "ARYAMAN PHARMACY COLLEGE",
  "VIDHYA SAGAR MAHAVIDYALAYA, HATHGI MOD, AJMER ROAD, MALPURA",
  "SANTOSH DEVI GIRLS COLLEGE",
  "SHRI JEETENDRA GODARS SLBS VETERINARY INSTITUTE NAYA GANV SUJAT ROAD PALI",
  "NAVJEEVAN COLLEGE",
  "GOVERNMENT GIRLS COLLEGE, SAMDARI ",
  "GOVERNMENT COLLEGE DECHU",
  "GOVERNMENT GIRLS COLLEGE NAPASAR, BIKANER",
  "GOVERNEMENT GIRLS COLLEGE, JAISLA, GHANTIYALI",
  "Shri Radheshyam R. Morarka Rajkiya Mahavidyalaya, Nawalgarh",
  "SHRI KRISHAN MAHAVIDYALALA DEVTHALA NIWANA TEHSIL CHOMU JAIPUR ",
  "RBM MAHAVIDYALAYA BARAN",
  "MAHARANI GIRLS COLLEGE, NH-8 SURATPURA ROAD,KALWARA",
  "GOVERNMENT GIRLS COLLEGE ABHANERI",
  "Ahinsa T T College, Jaipur",
  "Barala Nursing College",
  "S N COLLEGE OF EDUCATION DHOLPUR",
  "SUDARSHAN MAHAVIDHYALAYA, BHINMAL",
  "DR AMBEDKAR PHARMACY COLLEGE TONK",
  "SHREE SITA SAMRIDHI MAHAVIDYALAYA",
  "MOTHER TERESA MEMORIAL PUBLIC COLLEGE",
  "Kuldeepak Mahavidyalaya",
  "Deep International College, Jaipur",
  "MAHENDER MAHAVIDYALAYA ISLAMPUR JHUNJHUNU",
  "Sri Digambar Jain Adarsh ladies Sanskrit PG College",
  "DIVYADARSHINI MAHILA MAHAVIDAYALAYA BHOJPURA KALAN",
  "RADHE KRISHAN COLLEGE OF PHARMACY",
  "MAHALAXMI PHARMACY COLLEGE",
  "Shri Khandelwal Vaish P G Girls College, Jaipur",
  "Gurukul Teachers' Institute, Kekri",
  "MKB Mahila B.Ed. Mahavi., Jaipur",
  "Saraswati Girls College, Taranagar",
  "SAPTRISHI INSTIUTE OF PHARMACY ",
  "Smt. Mota Devi TT College, Dausa",
  "B D MEMORIAL KALYAN SANSTHAN",
  "Mayaurakshi Siksha Aur Vikas Sansthan (AHDP 33)",
  "DR.B.R.AMBEDKAR COLLEGE,NOHAR (HANUMANGARH)",
  "Vivek PG Mahavidyalaya, Jaipur",
  "MINAL COLLEGE",
  "R K Girls College, Borawar",
  "LAXMI COLLEGE OF PHRAMACY",
  "BHASKAR MAHAVIDHYALAYA RAIPUR PALI",
  "GYANODAYA COLLEGE NARWALI",
  "DEEP MAHAVIDYALAYA BHAINSAWA",
  "Naresh Shikshak Prashikshan Mahavi., Jhunjhunun",
  "UMMED MAHAVIDHYALAYA",
  "Naresh Kanya PG Mahavi., Jhunjhunun",
  "Swami Keshwanand TT Girls College",
  "Swami Keshwanand Mahavidyalaya, Alwar",
  "PRESIDENCY COLLEGE ALWAR",
  "BABA MOHANRAM KISSAN GOVERNMENT COLLEGE BHIWADI",
  "GOVERNMENT GIRLS COLLEGE BANSKHOH",
  "SHRI JASNATH MEMORIAL COLLEGE SATA ",
  "MITRANSH COLLEGE OF PHARMACY ",
  "RAJKIYA KANYA MAHAVIDYALAYA, BABAI (KHETRI)",
  "SARASWATI COLLEGE OF PHARMACY DAUSA",
  "GOVERNMENT COLLEGE CHAUTH KA BARWARA SAWAI MADHOPUR",
  "SURENDERA COLLEGE",
  "ST WILFREDS EVENING COLLEGE",
  "J M Kanya Mahavi., Jhunjhunun",
  "SW MOOLCHAND MEENA MAHAVIDYALAYA",
  "Govt college Luni",
  "RAVINDRA PAL SINGH PARMAR TT COLLEGE KAMAN",
  "Chaudhary P.R. T.T. College, Rawatsar",
  "ARTS COLLEGE, JASELA",
  "Parmanand Degree College for B.Ed., Gajsinghpur",
  "KRISHNA NURSING COLLEGE BHILWARA",
  "GOVT   AGRICULTURE COLLEGE  SHAHBAD ",
  "KALPTARU YOGA SANSTHAN ",
  "Government Sanskrit UG College,Jalia II",
  "Government College, Banera",
  "BHAGAT SINGH MAHAVIDHYALAYA, NEWAI",
  "SHRI KRISHNA COLLEGE OF PHARMACY",
  "SMT GODAWARI DEVI MEMORIAL COLLEGE OF PHARMACY",
  "VINAYAK COLLEGE OF PHARMACY KUCHAMAN CITY",
  "SHRI BALAJI COLLEGE OF PHARMACY",
  "SHRI SAWAI COLLEGE OF PHARMACY",
  "SHRI KALYAN COLLEGE OF PHARMACY ",
  "ALANKAR GIRLS PHARMACY COLLEGE",
  "NEW VAGAD DHARA COLLEGE ",
  "shiv shakti college ",
  "S N MAHILA MAHAVIDYALAYA",
  "Smt. Parmeshwari Devi Dhanraj Khaitan Mahila B.Ed. College, Sikar",
  "ADARSH TAGORE COLLEGE OF PHARMACY NADBAI",
  "SHRI ADARSH PHARMACY COLLEGE",
  "MATSYA COLLEGE",
  "SHRI SHYAM COLLEGE OF PHARMACY, BHADRA",
  "Bhartiya TT College, Sikar",
  "ADARSH MEDICAL COLLEGE OF PHARMACY, TARANAGAR",
  "STAR COLLEGE OF PHYSIOTHERAPY",
  "VINAYAK COLLEGE OF PHARMACY ,RENWAL MANJI,JAIPUR",
  "MAHATMA GANDHI GROUP OF INSTITUTE",
  "SWAMI VIVEKANAND COLLEGE OF PHARMACY KURGAON",
  "CHAMAN COLLEGE OF ANIMAL HUSBANDRY",
  "Bajrang TT College, Bharatpur",
  "GOVT GIRLS COLLEGE, BAYANA ",
  "GENIUS COLLEGE KHERLA BUJURG",
  "H D Teacher Training Inst., Bharatpur",
  "Veena Memorial College of Education",
  "shri kaila devi uma mahavidhyalay ",
  "JAGDISH MAHAVIDHYALAY, ANGAI",
  "Sardar Vallabh Bhai. Patel T.T. College, Bhadra",
  " SHREE ASHAPURA COLLEGE, SADRI",
  "Smt. Gomti Devi Mahavi., Jhunjhunun",
  "Shri Shraddha Nath Teacher Edu. College, Jhunjhunun",
  "Guru Nanak Girls P.G. College",
  "Shri Ram Mahavidyalaya, Ram ji Ka gol",
  "Mahatma Jyotiba Fule College of Veterinary & Animal Science (CV 06)",
  "Pandit Parsadi Lal Sharma College Deeg",
  "SHRI GOVIND COLLEGE",
  "SMT.KANCHAN DEVI MAHAVIDYALAYA ,RAMGARH PACHWARA, LALSOT",
  "M B D MEMORIAL COLLEGE ",
  "KAILASHWATI ANCHALIK MAHAVIDHYALAYA",
  "CHHATRAPATI SHIVAJI YOG MAHAVIDYALAYA, MANDHA BHIMSINGH JAIPUR II",
  "Shri Dau Baba T.T College",
  "Gyan Tripti College",
  "Sadgurudev College, Raniwara",
  "shekhawati college, gadakhera",
  "MAULANA AZAD MUSLIM MAHILA T. T. COLLEGE",
  "SHRI PARASMAL BOHRA NETRAHEEN MAHAVIDYALAYA JODHPUR",
  "GOVERNMENT COLLEGE BHANIYANA JAISALMER ",
  "Ramkishan Jugal Kishor Barasia PG Mahavi., Jhunjhunun",
  "GOVERNMENT COLLEGE, KALANDRI",
  "COLLEGE OF AGRICULTURE, NAGAUR ",
  "GOVERNMENT COLLEGE DHOLPUR",
  "Govt. Medical College, Bundi(Raj.)",
  "swasthya kalyan institute of naturopathy and yogic sciences",
  "GOVERNMENT AGRICULTURE COLLEGE KUMHER ",
  "Brajesh Mahila Shikshak Prashikshan Mahavi, Dhaulpur",
  "S P MEDICAL COLLEGE AND HOSPITAL, BIKANER",
  "GOVERNMENT AGRICULTURE COLLEGE,MAUZAMABAD",
  "THE ANKUR B.Ed. COLLEGE,  TAELIYON KA TALAB, SHRINATH NAGAR, NATHDWARA",
  "B R College of Edu., Dhaulpur",
  "Mother Teresa Mahila B.Ed. College, Bharatpur",
  "NIGHTINGLE COLLEGE OF NURSING, BUNDI",
  "GOVERNMENT AGRICULTURE COLLEGE BARAN ",
  "G S JANGID GIRLS DEGREE COLLEGE",
  "GOVERNMENT AYURVEDA COLLEGE, KOTA",
  "JLN COLLEGE OF PHARMACY,BASERI",
  "CHHOTI DEVI MEMORIAL SHIKSHAN SANSTHAN DIDWANA",
  "GOVT COLLEGE VISHALA",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE MARWAR MUNDWA NAGAUR",
  "SANSKAR PHARMACY COLLEGE GOVATI ROAD PALSANA THE DANTARAMGARH SIKAR RAJASTHAN",
  "MATA PHOOLA DEVI COLLEGE OF PHARMACY, TONK",
  "KAMAKSHI COLLEGE OF PHARMACY BALOTRA",
  "VIDYASTHALI PHARMACY COLLEGE KHOOR, SIKAR",
  "GOVERNMENT AYURVED MAHAVIDHALAYA, SIKAR",
  "MAHILA PHARMACY MAHAVIDHYALAYA",
  "GOVT SHASTRI SANSKRIT COLLEGE RATLAI JHALAWAR",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE MANDAL BHILWARA",
  "GURUKUL INSTITUTE OF PHARMACY",
  "PRINCE PHARMACY COLLEGE BADHAL",
  "GOVT SHASTRI SANSKRIT COLLAGE DEEDWANA",
  "SANSKAR INTERNATIONAL PHARMACY COLLEGE",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE KARAULI",
  "GOVERNMENT SHASTRI SANSKRIT COLLEGE RAISINGHPURA NOHAR",
  "ARAVALI COLLEGE OF PHARMACY",
  "GOVT COLLEGE GOLIYA JETMAL",
  "K G R YOG SADHNA KENDRA ",
  "EKLAVYA YOGA T T COLLEGE, KARAULI",
  "GOVERNMENT GIRLS COLLEGE SIKRI",
  "GOVERNMENT GIRLS COLLEGE NITHAR",
  "GOVERNMENT GIRLS COLLEGE, NADBAI",
  "GOVERNMENT GIRLS COLLEGE RUDAWAL ,ROOPWAS",
  "SANSKAR COLLEGE",
  "TAGORE PHARMACY COLLEGE, MANSAROVAR, JAIPUR",
  "Govt College Phagi",
  "VIKRAMADITHYA MAHILA SHIKSHAK PRASHIKSHAN MAHAVIDHYALYA, DAUSA",
  "LATE PANDIT SURAY NARAYAN RAJ MISHRA TEACHER TRAINING COLLEGE , NEW MANDI ROAD ,DAUSA ",
  "SHEKHAWATI COLLEGE, SEWAD BARI",
  "SHRI MAHAVEER COLLEGE",
  "MURLI SINGH YADAV MEMORIAL PRASHIKSHAN SANSTHAN LSA DIPLOMA TRAINING INSTITUTE, UDAIRAMSAR, BIKNAER",
  "GOVERNMENT GIRLS COLLEGE LOHAWAT",
  "M B VETERINARY COLLEGE DUNGARPUR",
  "BS Memorial College, Sikar",
  "GOVERNMENT GIRLS COLLEGE SIKRAI DAUSA",
  "COLLEGE OF AGRICULTURE, KUMHER BHARATPUR",
  "RRB PHARMACY COLLEGE",
  "GOVERNMENT COLLEGE BADNORE",
  "SARVODAYA COLLEGE OF PHARMACY",
  "JIET MEDICAL COLLEGE AND HOSPITAL",
  "JAI MEENESH COLLEGE, BISALPUR ROAD PHAGI",
  "COLLEGE OF AGRICULTURE, FATEHPUR SHEKHAWATI",
  "COLLEGE OF AGRICULTURE PEETHAMPURI NEEM KA THANA SIKAR",
  "Buddha Institute of Architecture & Town Planning,Udaipur",
  "R R COLLEGE OF EDUCATION KHELNA ROAD",
  "SAMANT BHADRA KANYA MAHAVIDHYALAYA, HIMVAN, DHARIYAWARD",
  "Chaudhary Goli Singh College, Nadbai, Bharatpur",
  "MAHARANA PRATAP GOVERNMENT P. G. COLLEGE, CHITTORGARH",
  "JAIN ITI SRI GANGANAGAR",
  " GOVERNMENT COLLEGE GADRA ROAD",
  "Akhandata Mahila Mahavidyalaya, Jaipur",
  "GEETANJALI MAHAVIDYALAYA KITNORIYA BARMER",
  "GOVERNMENT COLLEGE KOTKHAWADA",
  "SHRI NARAYAN MEMORIUM COLLEGE CHITALWANA",
  "R R COLLEGE OF NURSING, AJMER",
  "DR S N MEDICAL COLLEGE AND HOSPITAL, JODHPUR",
  "SHREE VIJAY STHALI VIDHAYAPEETH MAHILA MAHAVUDAYALAYA, KUMHER",
  "Tak Shiksha Nikaten T.T. College",
  "St. Wilfred College, Chandiawas, Gegal",
  "Sanatan Dharam Physical T.T. College, Kekri",
  "PARMANAND TRILOKCHAND COLLEGE, CHHAPAR ROAD",
  "Government Girls College, Kishangarh",
  "Caliber College",
  "JAIPUR HOSPITAL COLLEGE OF PHYSIOTHERAPY",
  "Govt. Girls College, Karauli",
  "Mother Teresa T.T. College, Gaddhipura, Hindauncity",
  "AADI COLLEGE OF NURSING, JAIPUR",
  "RAMKUMARI INSTITUTE OF AYURVEDA AYURVEDA NURSING TRAINING CENTER",
  "Swami Gangadas Teacher Training College,Kheda",
  "BIKANA COLLEGE OF B SC NURSING BIKANER",
  "NEW SAINIK COLLEGE OF PHARMACY",
  "SARASWATI COLLEGE OF NURSING",
  "KONARK COLLEGE OF HOTEL MANAGEMENT",
  "SMD COLLEGE OF NURSING, KOTA",
  "SAVITRI BAI FULE COLLEGE OF NURSING",
  "siddhi pg college sagwara",
  "BIYANI INSTITUTE OF SKILL DEVELOPMENT",
  "AKASHDEEP COLLEGE OF PHARMACY, JAIPUR",
  "A K INTERNATIONAL COLLEGE OF HOTEL MANAGEMENT, LAXMANGARH (SIKAR)",
  "BIYANI INSTITUTEITUTE OF SCIENCE AND MANAGEMENT, JAIPUR",
  "GOVT COLLEGE OF NURSING NATHDWARA RAJSAMAND",
  "EKLAVYA DENTAL COLLEGE AND HOSPITAL, JAIPUR",
  "G L SAINI MEMORIAL COLLEGE OF NURSING, JAIPUR",
  "M. A. J. Govt. College, Deeg",
  "Adarsh L.S.A. Traning Institute (AHDP 57)",
  "Madan Mohan Malviya Government, Ayurveda College, Udaipur",
  "Rajasthan Unani Medical College and Hospital, Jaipur",
  "Dev Pashudhan Sahayak Prashiksan Mahavidyalaya (AHDP 46)",
  "Rajasthan College of Animal Husbandry (AHDP 45)",
  "GOVERNMENT COLLEGE OF NURSING CHITTORGARH ",
  "JAI DURGA COLLEGE OF NURSING, JAIPUR",
  "SHRI RANJEET SINGH SHIKSHAN SANSTHAN",
  "GOVT COLLEGE OF NURSING TIJARA ALWAR",
  "Alliance shikshan evam Anusandhan sansthan (AHDP 44)",
  "Swami Gopaldas Government Girls College, Churu",
  "GOVERNMENT COLLEGE OF NURSING SAWAIMADHOPUR",
  "RAMSAHAY GIRLS COLLEGE, KURGAON",
  "JAIPUR COLLEGE OF NURSING AND HOSPITAL, JAIPUR",
  "GOVT COLLEGE OF NURSING BANSWARA RAJASTHAN",
  "MEDICAL AND TECHNOLOGY INSTITUTEITUTE OF NURSING, JAIPUR",
  "MOTHER TERESA NURSING AND PARAMEDICAL INSTITUTEITUTE, JAIPUR",
  "HILL GROVE COLS ACADEMY, COLLEGE OF HIGHER EDUCATION",
  "AKME THE SCHOLARS ARENA GIRLS DEREEE COLLEGE, UDAIPUR",
  "GANGAPUR INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES ",
  "Udaipur Institute of Physiotherapy and Paramedical Sciences Udaipur ",
  "NIMT COLLEGE OF NURSING, JAIPUR",
  "RGM COLLEGE OF NURSING",
  "GOVT COLLEGE OF NURSING, PRATAPGARH, RAJASTHAN",
  "GOVT  COLLEGE OF NURSING, NAGAUR",
  "GOVT COLLEGE OF NURSING BARAN",
  "Gurmeet Singh Ghanshyam  Dass Girls Agriculture College 25 BB",
  "TAJ MEMORIAL INSTITUTE OF PHARMACY",
  "MAYURAKSHI COLLEGE OF PHARMECY",
  "VIDHYASHRAM COLLEGE OF PHARMACY",
  "ASHA DEVI COLLEGE OF PHARMACY",
  "Shri TOdarmal PG Mahavi., Jhunjhunun",
  "Nanu Ram Choudhary Memorial Mahila Mahavidyalaya, Jaipur",
  "R R COLLEGE OF NURSING, JAIPUR",
  "Rana Ugam Singh Inda Rajkiya Mahavidyalaya, Balesar, Jodhpur",
  "Jawaharlal Nehru TT college",
  "Shri Maharshi Dadhich Sanskrit TT college",
  "AMBIKA COLLEGE OF PHARMACY",
  "Ch. Jagan Singh Edu. Inst., Bharatpur",
  "BHARDWAJ COMPUTER TRAINING INSTITUTE CHHABRAGUGOR",
  "Mahatma Gandhi International Girls College, Jaipur",
  "M.B.M. B.Ed.College, Sriganganagar",
  "Government sanskrit PG college, Chirana",
  "Baba Narayandas T T College, Jaipur",
  "REGIONAL COLLEGE OF PHARMACY, JAIPUR",
  "Rana Shiksha Shastri Mahavidyalaya",
  "RAJDHANI COLLEGE OF PHARMACY ",
  "Srimati Laddevi Sharma Panchouli Sanskrit UG college",
  "Deva Shikshaka Prashikshana Mahavidyala",
  "Shri Ramanuja Sanskrit UG college",
  "Raghukul College of Education, Chaksu, Jaipur",
  "Visvesvaraya Community College",
  "GOVERNMENT COLLEGE OF NURSING KARAULI",
  "Shri Krishana Mahavidyalaya, Duni",
  "Marwar Shikshak Prashikshan Mahavidyalaya",
  "SHREE BALAJI COLLEGE OF NURSING BHILWARA ",
  "Prachya Vidya Peeth",
  "Vivekanand College of Teachers Education",
  "College of Agriculture Ummedganj Kota",
  "Indira Gandhi Balika Niketan Shikshak Prashikshan Mahavidhyalaya, Ardawata",
  "COLLEGE OF AGRICULTURE, LALSOT",
  "TRIBHUVAN COLLEGE OF ENVIRONMENT AND DEVELOPMENT SCIENCES    ",
  "Maharishi Arvind School of Mgt. Studies, Jaipur",
  "Shri Balaji PG Mahila College, Dausa",
  "Rose TT College, Jaipur",
  "AAKAR COLLEGE",
  "COLLEGE OF AGRICULTURE HINDOLI",
  "GOVERNMENT AGRICULTURE COLLEGE, PAHARI ,KAMAN",
  "SAHNAAJ COLLEGE OF NURSING, JAIPUR",
  "GOVERNMENT AGRICULTURE COLLEGE NAGAR,BHARATPUR ",
  "GOVERNMENT GIRLS COLLEGE, KAMAN",
  "SHIVAJI COLLEGE OF NURSING, JAIPUR",
  "SONI COLLEGE OF NURSING, JAIPUR",
  "ST THOMAS COLLEGE OF NURSING, JAIPUR",
  "SUPERKING COLLEGE OF NURSING, JAIPUR",
  "SWASTHYA KALYAN COLLEGE OF PHYSIOTHERAPY, JAIPUR",
  "RADHIKA YOGA COLLEGE BHANDAREJ,DAUSA",
  "GAYATRI MAHAVIDYALAYA BIJOWA",
  "SYMBIOSIS INSTITUTEITUTE OF NURSING, JAIPUR",
  "GOVERNMENT AGRICULTURE COLLEGE BHARATPUR",
  "GOVERNMENT AGRICULTURE COLLEGE BASSI",
  "REGIONAL COLLEGE BAGORA UDAIPURWATI",
  "MAYURAKSHI COLLEGE OF AGRICULTURE",
  "ASHIRWAD SHIKSHAK PRASHIKSHAN SANSTHAN  BITHARI PHALODI",
  "VIDHYASTHALI INSTITUTEITUTE OF TECH, JAIPUR",
  "KEKRI COLLEGE, Kekri",
  "SHAGUN COLLEGE",
  "KRISHNA MAHAVIDYALAYA, Ratau",
  "Maharaja Agrasen PG College, Bharatpur",
  "VINAYAK COLLEGE OF NURSING, JAIPUR",
  "JHALAWAR MEDICAL COLLEGE AND HOSPITAL, JHALAWAR",
  "Akashdeep P.G. Girls College, Jaipur",
  "CHANKYA YOGA COLLEGE, REENGUS, SIKAR",
  "SHRI KRISHNA COLLEGE OF PHARMACY DIDWANA",
  "SHRI SAWAI COLLEGE OF PHARMACY DIDWANA",
  "ABHINAV COLLEGE",
  "Rajasthan College, Sahawa",
  "Guru Govind Singh Khalsa Girls College, Srikaranpur",
  "Nar Bahadur Bhandari Government College,Tadong",
  "Sikkim Manipal College of Nursing (SMCON)",
  "Sikkim Government College, Rhenock",
  "SIKKIM PROFESSIONAL COLLEGE OF NURSING",
  "Sikkim Government Law College,Burtuk",
  "Namchi Government College, Kamrang",
  "Damber Singh College, 6th mile, Samdur",
  "Loyola College of Education, Namchi",
  "Harkamaya College of Education, 6th mile, Samdur",
  "SANSKRIT MAHAVIDYALAYA, SAMDONG",
  "Himalayan Pharmacy Institute, Majhitar",
  "Sikkim Government College, Burtuk",
  "College of Agricultural Engineering and Post Harvest Technology, Ranipool, Gangtok",
  "College of Horticulture, Bermiok",
  "Government Pharmacy College Sajong",
  "Sikkim Manipal Institute of Medical Sciences (SMIMS)",
  "Sikkim Government B.Ed College, Soreng",
  "Sikkim Manipal College of Physiotherapy (SMCPT)",
  "Linke Sanskrit Mahavidyalaya",
  "Sikkim Institute of Science and Technology",
  "GOVERNMENT ARTS COLLEGE MANGSHILA, NORTH SIKKIM",
  "Sikkim Manipal Institute of Technology (SMIT)",
  "Sikkim Govt.Science College,Chakhung",
  "NAMGYAL INSTITUTE OF TIBETOLOGY",
  "SIKKIM PROFESSIONAL COLLEGE OF PHARMACEUTICAL SCIENCES",
  "SIKKIM PROFESSIONAL COLLEGE OF ARTS AND SCIENCES",
  "Government Vocational College Dentam",
  "Sikkim Government College of Nursing",
  "Sanchaman Limboo Government College, Gyalshing",
  "Sikkim Government Institute of Higher Nyingma Studies, Pangthang",
  "SRS INSTITUTE OF AGRICULTURE AND TECHNOLOGY",
  "Good Samaritan College of Education",
  "Good Shepherd college of Education",
  "Government College of Education",
  "Government College of Education",
  "Government  COLLEGE OF ARTS AND SCIENCE,thittagudi,cuddalore District",
  "Jayaram College of Engineering and Technology",
  "M.A.M. College of Engineering",
  "SENTHAMIL COLLEGE",
  "Panimalar Engineering College",
  "JEPPIAAR ENGINEERING COLLEGE",
  "Don Bosco College of Agriculture",
  "PGP College of Education",
  "The Kavery College of Education",
  "ST. JOSEPH COLLEGE OF EDUCATION 12819",
  "SSM COLLEGE OF PHYSIOTHERAPY",
  "Air Force Administrative College",
  "Providence College for Women (Autonomous)",
  "Bharat College of Education",
  "Sri Vikasa College of Education, Theni",
  "SHRI INDRA GANESAN INSTITUTE OF MEDICAL SCIENCE ",
  "PACHAMUTHU COLLEGE OF PHARMACY ",
  "SREE SASTHA ARTS AND SCIENCE COLLEGE",
  "PANIMALAR ENGINEERING COLLEGE CHENNAI CITY CAMPUS",
  "AARTHI SCANS PVT. LTD.  (Inst.Code - 584)",
  "Pavai College of Technology",
  "Panimalar Institute of Technology",
  "Sengunthar College of Engineering",
  "DHANALAKSHMI SRINIVASAN INSTITUTE OF TECHNOLOGY",
  "ANNAII MEDICAL COLLEGE AND HOSPITAL",
  "TAMIL NADU GOVERNMENT MUSIC COLLEGE CHENNAI ",
  "Sri Ramakrishna Mission Vidyalaya College of Arts and Science",
  "GOVERNMENT MEDICAL COLLEGE VIRUDHUNAGAR",
  "LONDON COLLEGE OF NURSING",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE COED MANALMEDU MAYILADUTHURAI",
  "THE NEW COLLEGE",
  "AJK COLLEGE OF NURSING",
  "THE KAVERY PHYSIOTHERAPY COLLEGE",
  "M.G.R College",
  "Bharathiyar Arts & Science College (W)",
  "Vivekanandha College for Women",
  "ERK College of Arts & Science",
  "Salem Kongunadu Arts & Science",
  "Gonzaga College of Arts & Science for women",
  "PMP College of Arts & Seience",
  "Government Arts College for Men",
  "Hallmark Business School",
  "Imayam College of Engineering",
  "KRISHNASAMY COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Kurinji College of Engineering and Technology",
  "M.N.S.K. College of Engineering",
  "Mookambigai College of Engineering",
  "Nethaji Subash Chandra Bose College, Thiruvarur- 614 001.",
  "Government Arts and Science College, Perambalur",
  "M.K. UNIVERSITY EVENING COLLEGE, GOVT. HR. SECY. SCHOOL CAMPUS",
  "SATHANGAI ACADEMY",
  "M.K. UNIVERSITY COLLEGE, ALAGARKOIL ROAD",
  "DEVANGA ARTS COLLEGE",
  "S.L.S.M.A.V.M.AYIRA VYSIAR COLLEGE",
  "ST. GEORGE JEYARAJ CHELLADURAI COLLEGE FOR WOMEN",
  "SOURASHTRA COLLEGE",
  "GOVERNMENT CHENGALPATTU MEDICAL COLLEGE AND HOSPITAL, CHENGALPATTU",
  "VSK COLLEGE OF EDUCATION",
  "Arignar Anna Government Arts College, ATTUR",
  "Sri Rangachinnammal College of Education",
  "THAAI ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "INDIRA MEDICAL COLLEGE AND HOSPITALS",
  "PARAPROFESSIONAL INSTITUTE OF FISHERIES TECHNOLOGY",
  "CAPITAL COLLEGE OF ARCHITECTURE",
  "Sasurie Academy of Engineering",
  "ELIZABETH COLLEGE OF ENGINEERING TECHNOLOGY",
  "SKANDHA SCHOOL OF ARCHITECTURE",
  "THULASI COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "AES COLLEGE OF ARTS AND SCIENCE ",
  "Government  COLLEGE OF ARTS AND SCIENCE, IDAPPADI",
  "MARG Institute of Design and Architecture Swarnabhoomi (MIDAS)",
  "J.P.College of Engineering",
  "S.Veerasamy Chettiar College of Engineering and Technology",
  "A.V.C. College of Engineering",
  "TAMIL NADU GOVERNMENT DENTAL COLLEGE AND HOSPITAL (Inst. Code - 020), CHENNAI",
  "GOVERNMENT MEDICAL COLLEGE RAMANATHAPURAM",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE",
  "GOVERNMENT MEDICAL COLLEGE ARIYALUR",
  "SRV COLLEGE OF ARTS AND SCIENCE SIVAKASI",
  "PPG COLLEGE OF OCCUPATIONAL THERAPY",
  "JEPPIAAR COLLEGE OF ARTS AND SCIENCE ",
  "SREE SASTHA COLLEGE OF EDUCATION ",
  "GOVERNMENT MEDICAL COLLEGE NAMAKKAL",
  "VALANAR ARTS AND SCIENCE COLLEGE",
  "ST MARIAM COLLEGE OF PHARMACY",
  "SRI RANGAPOOPATHI COLLEGE OF PHARMACY",
  "VIJAYA COLLEGE OF NURSING",
  "RD National Arts and Science co education college",
  "ANNAI VEILANKANNI'S COLLEGE OF ENGINEERING",
  "Royal College of Education",
  "Sri Venkateswara College of Education",
  "Adhiparasakthi Horticultural College",
  "J N N ARTS AND SCIENCE WOMENS COLLEGE",
  "Dr MGR Institute of Special Education and Research ",
  "RD COLLEGE OF EDUCATION",
  "DNCMANIVANNAN COLLEGE OF EDUCATION",
  "Saraswathy Law College",
  "Tamilnadu government music college coimbatore",
  "Sree Vee College",
  "Susila College of Education",
  "Om Shanti College of Education",
  "Vidyaa Vikas College of Arts and Science ",
  "KRISHNA COLLEGE OF AGRICULTURE AND TECHNOLOGY (KRISAT)",
  "INFANT JESUS COLLEGE OF ARTS AND SCIENCE FOR WOMEN  ",
  "ADHIYAMAAN COLLEGE OF AGRICULTURE AND RESEARCH",
  "Nammazhvar College of Agriculture and Technology",
  "MIT COLLEGE OF ARTS AND SCIENCE FOR WOMEN, MUSIRI",
  "Concord College of Education",
  "Kalvithanthai AKR Sourashtra Teachers College",
  "Kamala College of Education",
  "K.M.B.Ed., College of Education",
  "K.R.  College of Education",
  "Krishnaveni Ammal College of  Education",
  "Naina Mohamed College of Education",
  "National Institute for Empowerment of Persons with Multiple Disabilities (NIEPMD)",
  "St.Stephen college of Education",
  "Vekkaliyamman College of Education",
  "Vellore College of Education",
  "Government College of Arts and Science, Sendamangalam",
  "Vivekananda College of Education",
  "K.Indira College of Education",
  "Aruna Malai College of Education",
  "Nairs College of Education",
  "N.V.K.S.D. College of Education, (Aided)",
  "Our Lady College of Education",
  "Paulsons Teacher Training College",
  "Prime College of Education",
  "P.S.R. College of Education",
  "Rangaswamy College of Education",
  "Saithanibi College of Education",
  "Sri Vijay Vidyalaya College of Education",
  "V.P. Muthiah Pillai Meenakshi Ammal College   of Education for Women",
  "ADHIPARASAKTHI AGRICULTURAL COLLEGE, VELLORE",
  "COLLEGE OF AGRICULTURAL TECHNOLOGY, THENI",
  "Sri Aurobindo Mira College of Education",
  "St.Marks College of Education",
  "COLLEGE OF FISHERIES ENGINEERING, PANANGUDI, NAGAPATTINAM",
  "MADHA MEDICAL COLLEGE AND HOSPITAL (Inst. Code - 464), KANCHEEPURAM",
  "SIVA COLLEGE OF EDUCATION",
  "FOOTWEAR DESIGN AND DEVELOPMENT INSTITUTE",
  "SHRI SURYA COLLEGE OF EDUCATION , DINDIGUL",
  "DR.ZAKIR HUSAIN COLLEGE OF EDUCATION , SIVAGANGA",
  "CHRISTIAN FELLOWSHIP COMMUNITY HEALTH CENTRE, COLLEGE OF NURSING (Inst. Code - 035 ) DINDUGUL",
  "KARUR VELALAR COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "Sri Swamy College of Education for Women",
  "Swaminathan Saraswathi College of Education for Women",
  "RATHINAM SCHOOL OF ARCHITECTURE",
  "MIT COLLEGE OF EDUCATION FOR WOMEN",
  "The Indian Agriculture College",
  "ANDAVAR COLLEGE OF NURSING",
  "A. R. College of Engineering and Technology",
  "MMES ACADEMY OF ARCHITECTURE",
  "Government Arts and Science College, Pollachi",
  "SONA COLLEGE OF ARTS AND SCIENCE",
  "St.ANNE S ARTS AND SCIENCE COLLEGE,MADAVARAM, CHENNAI - 600 110",
  "Nalanda College of Agriculture",
  "SCHOOL OF ARCHITECTURE COIMBATORE INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "KAVERY ARTS AND SCIENCE COLLEGE",
  "VAIGAI ARTS AND SCIENCE WOMENS COLLEGE",
  "SANKARA NETHRALAYA ACADEMY (UNIT OF MEDICAL RESEARCH FOUNDATION) (Inst. Code - 383), CHENNAI",
  "SRI JAYARAM INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "PARK INSTITUTE OF ARCHITECTURE",
  "PSG INSTITUTE OF TECHNOLOGY AND APPLIED RESEARCH",
  "SHIVPARVATHI MANDRADIAR INSTITUTE OF HEALTH SCIENCES (Inst. Code - 278) , ERODE",
  "Government Arts College, Nilgiris",
  "KAMALA COLLEGE OF NURSING, SALEM",
  "Horticultural College and Research Institute, Theni",
  "GOVERNMENT INSTITUTE OF REHABILITATION AND MEDICINE (Inst. Code - 036), CHENNAI",
  "GOVERNMENT SIDDHA MEDICAL COLLEGE (Inst. Code - 015), CHENNAI",
  "KANCHI KAMAKOTI CHILDS TRUST HOSPITAL (Inst. Code - 409), CHENNAI",
  "K.G. COLLEGE OF PHYSIOTHERAPY (Inst. Code - 144), COIMBATORE",
  "TAGORE DENTAL COLLEGE & HOSPITAL (Inst. Code - 273), CHENNAI",
  "K.K. COLLEGE OF PHARMACY (Inst. Code - 056), CHENNAI",
  "K.M.C.H. COLLEGE OF NURSING (Inst. Code - 078), COIMBATORE",
  "K.M.C.H. COLLEGE OF PHARMACY (Inst. Code - 114), COIMBATORE",
  "M.A. CHIDAMBARAM COLLEGE OF NURSING (Inst. Code - 050), CHENNAI",
  "MADHA COLLEGE OF PHYSIOTHERAPY (Inst. Code - 148), CHENNAI",
  "MADHA DENTAL COLLEGE AND HOSPITA (Inst. Code - 268)L, CHENNAI",
  "V.V.VANNIAPERUMAL COLLEGE FOR WOMEN ",
  "MMM COLLEGE OF HEALTH SCIENCES (Inst. Code - 354), CHENNAI",
  "NATIONAL INSTITUTE OF  SIDDHA (Inst. Code - 183), TAMBARAM SANITORIUM, CHENNAI",
  "SANKARA NETHRALAYA MEDICAL RESEARCH FOUNDATION (Inst. Code - 044), CHENNAI",
  "TAGORE MEDICAL COLLEGE & HOSPITAL , CHENGALPATTU",
  "VANAVARAYAR INSTITUTE OF AGRICULTURE, COIMBATORE",
  "THANTHAI ROEVER INSTITUTE OF AGRICULTURE AND RURAL DEVELOPMENT, PERAMBALUR",
  "TEXCITY COLLEGE OF NURSING (Inst. Code - 231), COIMBATORE",
  "AYURVEDA COLLEGE (Inst. Code - 019), SULAR,  COIMBATORE",
  "CANCER INSTITUTE (W.I.A.) (Inst. Code - 039), CHENNAI",
  "CANCER INSTITUTE (W.L.A.) (Inst. Code - 439), ADYAR, CHENNAI",
  "CHERRAAN S  COLLEGE OF PHYSIOTHERAPY (Inst. Code - 111), COIMBATORE",
  "COIMBATORE MEDICAL COLLEGE (Inst. Code - 007), COIMBATORE",
  "SRI RAMAKRISHNA INSTITUTE OF PARAMEDICAL SCIENCES COLLEGE OF PHYSIOTHERAPY (Inst. Code - 038), COIMBATORE",
  "DR.KAMAKSHI MEMORIAL HOSPITAL PVT. LTD., (Inst. Code - 381) CHENNAI",
  "Dr.MOHAN'S  DIABETES SPECIALITIES CENTRE & Dr.MOHAN'S  DIABETES EDUCATION ACADEMY (Inst. Code - 451), CHENNAI",
  "ESI MEDICAL COLLEGE & ESI-PGIMSR (Inst. Code - 495), CHENNAI",
  "GLOBAL HOSPITALS & HEALTH CITY (Inst. Code - 382), CHENNAI",
  "K.M.C.H. COLLEGE OF PHYSIOTHERAPY (Inst. Code - 100), COIMBATORE",
  "MADRAS ENT RESEARCH FOUNDATION (P) LTD., (Inst. Code - 402), CHENNAI",
  "MEDISCAN SYSTEMS (Inst. Code - 406), CHENNAI",
  "P.S.G. COLLEGE OF NURSING (Inst. Code - 109), COIMBATORE",
  "P.S.G. INSTITUTE OF MEDICAL SCIENCES & RESEARCH (Inst. Code - 012), COIMBATORE",
  "R.V.S. COLLEGE OF PHARMACEUTICAL SCIENCES (Inst. Code - 079), COIMBATORE",
  "THE INSTITUTE OF NEUROLOGICAL SCIENCES, THE VOLUNTARY HEALTH SCIENCES (Inst. Code - 425) , CHENNAI",
  "GEM INSTITUTE OF NURSING EDUCATION AND RESEARCH (Inst. Code - 332), COIMBATORE",
  "GOVERNMENT DHARMAPURI MEDICAL COLLEGE (Inst. Code - 244), DHARMAPURI",
  "JEEVA COLLEGE OF NURSING (Inst. Code - 467), KRISHNAGIRI",
  "J.K. COLLEGE OF NURSING AND PARAMEDICAL (Inst. Code - 052), COIMBATORE",
  "J.S.S. INSTITUTE OF NATUROPATHY AND YOGIC SCIENCES (Inst. Code - 132), OOTACAMUND, COIMBATORE",
  "KARPAGAM COLLEGE OF PHARMACY (Inst. Code - 225), COIMBATORE",
  "K.G. COLLEGE OF NURSING (Inst. Code - 119), COIMBATORE",
  "Dr.G.SAKUNTHALA COLLEGE OF NURSING (Inst. Code - 189), TIRUCHIRAPALLI",
  "GOVERNMENT MOHAN KUMARAMANGALAM MEDICAL COLLEGE (Inst. Code - 010), SALEM",
  "INDIRA COLLEGE OF NURSING (Inst. Code - 316), TIRUCHIRAPALLI",
  "INSTITUTE OF OPHTHALMOLOGY, JOSEPH EYE HOSPITAL (Inst. Code - 041), TIRUCHIRAPALLI",
  "JENNYS COLLEGE OF NURSING (Inst. Code - 457), TIRUCHIRAPALLI",
  "K.A.P. VISWANATHAM GOVERNMENT MEDICAL COLLEGE (Inst. Code - 134), TIRUCHIRAPALLI",
  "MADURAI APOLLO COLLEGE OF NURSING (Inst. Code - 359), MADURAI",
  "MANNAI NARAYANASAMY COLLEGE OF NURSING (Inst. Code - 339), THANJAVUR",
  "SHANMUGA COLLEGE OF NURSING, SHANMUGA INSTITUTE OF PARA MEDICAL SCIENCES (Inst. Code - 158), SALEM",
  "SIVARAJ HOMOEOPATHIC MEDICAL COLLEGE AND RESEARCH INSTITUTE (Inst. Code - 211), SALEM",
  "SRI GOKULAM COLLEGE OF NURSING (Inst. Code - 217), SALEM",
  "DOCTOR S  COLLEGE OF NURSING (Inst. Code - 314), PUDUKKOTTAI",
  "KARPAGA VINAYAGA COLLEGE OF NURSING (Inst. Code - 288), PUDUKKOTTAI",
  "ST. BONNIE WHITE COLLEGE OF NURSING (Inst. Code - 478), SALEM",
  "Chettinad College of Nursing",
  "Chettinad Hospital and Research Institute",
  "Selvam College of Physical Education",
  "Vinayaka Mission's Kirupananda Variyar Engineering College",
  "Vinayaka Mission's College of Pharmacy",
  "Vinayaka Mission's Annapoorana College of Nursing",
  "Vinayaka Mission's Kirupananda Variyar Medical College and Hospital",
  "Vinayaka Mission's Sankarachariyar Dental College",
  "Vinayaka Mission's Kirupananda Variyar Arts and Science College",
  "Vinayaka Mission's Homeopathic Medical College",
  "Sri Venkateswara College of Arts & Science",
  "Arignar Anna Government Arts College, NAMAKKAL",
  "Arignar Anna College (Arts & Science)",
  "P.G.P College of Arts & Science",
  "Sri Balamurugan College of Arts & science",
  "A.V.S College of Arts & Science",
  "Jai Shree Venkateswara College of Arts & Science",
  "Sri Sarada College for Women(Autonomous)",
  "Kailash  Womens College",
  "Government Arts College for Women",
  "Morappur Kongu Arts & Science College",
  "Salem Christian College of Arts & Science",
  "Thiruvalluvar Government Arts College",
  "Sri Ganesh College of Arts & Science",
  "Sri Vijay Vidyalaya College of Arts and Science",
  "Gem Gates Arts & Science College",
  "NKR Government Arts College for Women",
  "Sri Vidhya Mandir College of Arts & Science",
  "S.K.P Engineering College",
  "Sri Balaji Chockalingam Engineering College",
  "C.K.S. College  of Education",
  "Paramveer College of Education",
  "Ganadipathy Tulsi's Jain Engineering College",
  "Alpha College of Engineering",
  "Loyola-ICAM College of Engineering and Technology",
  "Mailam Engineering College",
  "MEASI Academy of Architecture",
  "University College of Engineering, Arani",
  "Sams College of Engineering and Technology",
  "Sree Sastha Institute of Engineering and Technology",
  "Sri Krishna Institute of Technology",
  "Vel Tech Multi Tech Dr. Rangarajan Dr. Sakunthala Engineering College",
  "Auxilium College of Education for Women",
  "Senthil College of Education",
  "Shri Bharathi College of Education",
  "Mahendra College of Education",
  "Jayalakshmi Narayanaswami College of Education",
  "Nazareth College of Education for Women",
  "Sri Ram Nallamani Yadava College of Education",
  "Sri Thangam Periyasamy College of Education",
  "Indira Gandhi College of Special Education",
  "Kalaivani College of Education",
  "C.S. College of Education",
  "Durai Murugan College of Education",
  "St. Pauls  College of Education",
  "Sri Balaji College of Education",
  "Krishnasree College of Education for Women",
  "V.S. Isaac College of Education",
  "U.S.P.College of Education",
  "Chezhian College of Education",
  "Gnanamani College of Education",
  "St. Johns College of Education Palayamkottai",
  "Keins College of Education for Women",
  "Veludayar College of Education",
  "Peace College of Education",
  "Kongunadu College of Education for  Women",
  "Sarah College of Education for Women",
  "Jairam College of Education",
  "S.Preethi B.Ed College of Education",
  "Amirtha College of Education",
  "Eden Gardens College of Education",
  "Sri Vidaya Mandir College of Education, Dharmapuri",
  "Oxford College of Education",
  "Stanley  College of Education",
  "Vidhya Vikas Plus The Institute of Education",
  "Bishop Agniswamy College of Education",
  "Vidayaa Vikas College of Education",
  "K.S. College of Education",
  "Wisdom College of Education",
  "T.V.M. College of Education",
  "Chellammal College of Education",
  "Sri Kumaran  B.Ed College",
  "Kongunadu College of Education",
  "Sri Balaji College of Education",
  "Institute of Education",
  "Kongunadu College of Education",
  "Vel College of Education",
  "Bishop Packiam Arokiaswamy College of Education",
  "Dr. R.K. Shanmugam College of Education",
  "Meenakshi B.Ed., College",
  "Rasama College of Education",
  "Kongunadu College of Education",
  "Rabindharanath Tagore College of Education for Women",
  "S.V.I College of Education",
  "Assefa College of Education",
  "Omm Muruga College of Education",
  "Kalaibharathi B.Ed College",
  "Vivekanandha College of Education for Women",
  "Ponnusamy Nadar College of Education",
  "Sri Renugambal College of Education",
  "Arasu College of Education for Women",
  "S.Veerasamy chettiar college of    Education",
  "Sri Raaja Raajan College of Education for Women",
  "S.A.S. College of Education",
  "Meera College of Education",
  "PET College of Teacher  Education",
  "Paavai College of Education",
  "Sri Renga College of Education",
  "M. Shanthi College of Education",
  "Sri Lakshmi College of Education",
  "Bhavani College of  Education",
  "S.T.Hindu College of Education",
  "Venkatesvara College of Education",
  "Dr. N.G.P. College of Education",
  "Sree Vinayaka Vidyalaya College of Education",
  "Ayira Vaisya College of  Education",
  "Kalaimahal College of Education",
  "Maruthi College of Education",
  "Sri Raghavendra College of Education, Dindigul",
  "Smt. A.K.D. Sakkaniamma College of Education for Women",
  "Annai Mathammal Sheela College of Education",
  "K.S. Maniam College of Education",
  "St. Grace Lilian College of Education",
  "Bethesda College of Education",
  "Jayanthi College of Education",
  "Cosmopolitan College of Education",
  "Arunai College of Education",
  "Shree College of Education",
  "Divine College of Education",
  "Shri V.P.R. College of Education",
  "SRV College of Education",
  "Sri Adichunchanagiri women's college, Cumbum",
  "Jayaraj Annapackiam College for Women, Periyakulam",
  "Nadar Saraswathi College of Arts and Science, Theni",
  "Sakthi College of Arts and Science for Women, Oddanchatram",
  "Arulmigu Palaniandavar Arts College for Women, Palani",
  "Government Arts and Science College (Women),Kodaikanal",
  "LADY DOAK COLLEGE",
  "A.V.V.M. Sri Pushpam College",
  "Sri Saradha College for Women, Perambalur - 621 212.",
  "Thanthai Hans Roever College, Perambalur - 621 212.",
  "Enathi Rajappa College of Arts & Science, Enathi Post, Pattukkottai - 614 615.",
  "Government Arts College, Tiruchirappalli - 620 022.",
  "Kurinji College of Arts & Science, Green Ways Road, Tiruchirappalli - 620 002.",
  "Swami Dayananda College of Arts & Science, Tiruvarur - 612 610.",
  "Adaikala Matha College, Arun Nagar, Vam, Thanjavur - 613 403.",
  "AIMAN COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "Bharathidasan University Model College, Vedaranyam - 614 810",
  "Arungarai Amman College of Arts & Science, Chinnatharapuram, Aravakkurichi, Karur - 639 202.",
  "Meenakshi Chandrasekaran College of Arts & Science, Pattukkottai - 614 601.",
  "BON SECOURS COLLEGE FOR WOMEN (AUTONOMOUS), THANJAVUR",
  "Cauvery College for Women, Annamalai Nagar, Tiruchirappalli - 620 018.",
  "Christhu Raj College, Panjapur, Edamalaipatti Pudur, Tiruchirappalli - 620 012.",
  "Bharathidasan University Constituent Arts & Science College (Co-education),  Kaadambadi",
  "S.K.S.S. Arts College, Thiruppanandal - 612 504.",
  "Urumu Dhanalakshmi College, Tiruchirappalli - 620 019.",
  "Bharath College of Science & Management, South Garden, Thanjavur - 613 007.",
  "Rajagiri Dawood Batcha College of Arts & Science, Papanasam, Thanjavur - 614 207.",
  "Bharathidasan University Constituent Arts & Science College (Co-education),  Inamkulathur, Tiruchirappalli",
  "MEENAKSHI MISSION HOSPITAL & RESEARCH CENTRE",
  "M.K. UNIVERSITY EVENING COLLEGE, TELC",
  "AMMAN COLLEGE OF ARTS & SCIENCE",
  "C.S.I. COLLEGE OF ARTS & SCIENCE FOR WOMEN",
  "SRI NAGALAKSHMI AMMAL COLLEGE OF SCIENCES",
  "KODAIKANAL CHRISTIAN COLLEGE",
  "MADURAI INSTITUTE OF SOCIAL SCIENCE COLLEGE",
  "Sun Arts &Science College,Keeranoor,(V),Rajapalayam- 606 755",
  "Loyola College,Olaipadi village,Vettavalam-606 755",
  "Sri   Bharathi Women arts&Science,Arni-VelloreMain,Road,Kunnathur,Arni-632314",
  "Kamban college of Arts and Science for women,Mathur.-606603",
  "Jothi's  Vallimalai  Road,  Katpadi-632 007",
  "Tamilnadu School of Architecture",
  "K.M.G.college of ARTS&SCIENCE ,R.S.ROAD,Ammananguppam,Gudiyatham-635 803",
  "KIng Nandivarman college of Arts & Science,Thellar- 604406",
  "Indian Arts &Science college,Kariyandal -Kondam-606 802",
  "Arignar Anna Govt.Arts College,Cheyyar-602 407",
  "Voorhees College,Vellore-632001",
  "Idaya College of Arts &Science for Women,Pudupalayam,Chengam-606 705",
  "Govt. Arts College Thiruvannamalai-606 603",
  "M.K. UNIVERSITY EVENING COLLEGE, PALANI",
  "AMBIGA COLLEGE OF ARTS & SCIENCE",
  "INSTITUTE OF GANDHIAN STSUDIES & RESEARCH",
  "ANNAI FATIMA COLLEGE OF ARTS & SCIENCE",
  "Sri Bharathivelu arts &Science  Kalpattu,Sholinghur-631 102",
  "Goverment  Arts & Science college ,Thennangur Village,Vandavasi Taluk-604 408",
  "SRI S.RAMASAMY NAIDU MEMORIAL COLLEGE",
  "Indo-American College,Cheyyar-604407",
  "Al-Amen Arts & Science College, Somasipadi-606611",
  "Sathyam College of Arts &Science  College, Sundakkapalayam Village,Kariyamangalam Post Chengam Taluk  a Taluk",
  "Dhivya Arts &Science College,Gingee road, Chetpat-606611",
  "Dr.M.G.R.Chokalingam Arts  college Arcot Road,ACS Nagar(Irumbedu)-632 317",
  "Sri Akilandeshwari Women's College,ThindivanamHigh Way,Vandavasi-604408",
  "Wisdom College of Arts &Science (co-ed)Annakkoor,Cheyyar Taluk",
  "Virudhunagar Hindu Nadars' Senthikumara Nadar College",
  "Government Thirumagal Mill's College,Gudiyattam-632602",
  "Sri Ramakrishna Engineering College",
  "Muthurangam Govt.Arts College (autonomous),Vellore-632002",
  "S.S.S college of Arts &ScienceandManagement,(co-ed)Bye-passRoad,Arcot-635 2503",
  "Government  College of Arts &Science ,E.V.N.Govt.Boys Higher SEcondary School,Krishanagiri Road,Gazhanayeganpatti,Tirupattur Taluk,Tirupattur-635 901aGd,",
  "Kovai Kalaimagal College of Arts and Science",
  "Chikkanna Govt Arts College",
  "RATHINAM BUSINESS SCHOOL AT WISDOM CAMPUS",
  "P K R Arts College for Women",
  "Sri Nehru Maha Vidyalaya College of Arts and Science",
  "Dr.S.N.S.Rajalakshmi College of Arts and Science",
  "Dr.G.R.Damodaran College of Science",
  "Sri Subash Arts and Science College",
  "PSGR Krishnammal College for Women",
  "Kamban College of Arts and Science",
  "Coimbatore Institute of Management and Technology",
  "Saratha College of Arts and Science",
  "Sri Vasavi College",
  "Vellakoil Arts and Science College",
  "V.N.Krishnasamy Naidu College of Arts and Science for Women",
  "CBM College",
  "CMS College of Science and Commerce",
  "Sree Saraswathi Thiagaraja College",
  "Kaamadhenu Arts and Science College",
  "Dr.R.V.Arts and Science College",
  "St. Pauls College of Arts and Science for Women",
  "Kamalam College of Arts and Science",
  "Guruvayurappan Institute of Management",
  "Kongu Arts and Science College",
  "Nehru College of Management",
  "Kongunadu Arts and Science College",
  "D.J.Academy for Managerial Excellence",
  "Lakshmi Narayana Visalakshi College of Arts and Science",
  "A.G. Arts and Science College",
  "Pioneer College of Arts and Science",
  "Chikkaiah Naicker College",
  "Sri Ramalinga Sowdambigai College of Science and Commerce",
  "Government Arts College, Tiruppur",
  "Maharaja Arts and Science College",
  "Kaypeeyes College of Arts and Science",
  "Nandha Arts and Science College",
  "Shiri Kumaran College of Arts and Science",
  "Michael Job College of Arts and Science for Women",
  "PSG College of Arts and Science",
  "K.G. College of Arts and Science",
  "Sri Krishna Arts and Science College",
  "KGISL Institute of Information Management",
  "Sri Ramakrishna College of Arts and Science",
  "Palanisamy College of Arts",
  "Erode Arts and Science College",
  "Sree Narayana Guru College",
  "Tirupur Kumaran College for Women",
  "CMS Academy of Management and Technology",
  "Nehru Arts and Science College",
  "Rathinam College of Arts and Science",
  "Bishop Thorp College",
  "Bishop Ambrose College",
  "NIFT-TEA College of Knitwear Fashion",
  "Gobi Arts & Science College",
  "Dr.R.A.N.M. Arts and Science College",
  "Sri Paramakalyani College, Alwarkurichi - 627 412.",
  "Bishop Caldwell College, Maravanmadam, Tuticorin - 628 101",
  "Sri Devi Kumari Women's College, Kuzhithurai, Kanyakumari Dist",
  "Lekshmipuram College of Arts & Science, Neyyoor - 629 802.",
  "Malankara Catholic College, Mariagiri, Kaliakkavillai, Kanyakumari Dist.",
  "Rani Anna Government College for Women, Tirunelveli - 627 008",
  "Pioneer Kumaraswamy College, Vettoornimadam, Nagercoil - 629 003.",
  "Ambai Arts College, Ambasamudram - 627 401, Tirunelveli District.",
  "Sardar Raja Arts & Science College, Vadakkankulam - 627 116",
  "St.Xavier's College, Palayamkottai - 627 002",
  "Holy Cross Home Science College, 52, New Colony, Tuticorin - 628 003.",
  "St.Jerome's College, Allan Street, Asaripallam Road (via) Ananthanadarkudy, Kanyakumari Dist - 629 201",
  "Govindammal Aditanar College, Tiruchendur - 628 215, Tuticorin Dist",
  "Holy Cross College, Nagercoil - 629 004.",
  "Sree Ayyappa College for Women, Ayyappanagar, Chunkankadai - 629 807, Nagercoil - 629 807",
  "Sarah Tucker College, Perumalpuram, Palayamkottai - 627 011",
  "St.John's College of Arts & Science, Ammandiviali, Kanyakumari Dist - 629 204",
  "Women's Christian College, Nagercoil - 629 001",
  "Sivanthi Aditanar College, Pillayarpuram, Nagercoil - 629 501",
  "Scott Christian College, Nagercoil - 629 003",
  "Govt. Arts College, Surandai - 627 859",
  "Sadakathullah Appa College, Rahmath Nagar, Palayamkottai, 627 011",
  "S.T.Hindu College, Nagercoil - 629 002",
  "Noorul Islam College of Arts & Science, Kumaracoil, Thuckalay 629 175, Nagercoil.",
  "Manonmaniam Sundaranar University College, Govindaperi.",
  "Manonmaniam Sundaranar University College, Nagampatti,",
  "Manonmaniam Sundaranar University College, Panakudi",
  "QUAID E MILLETH COLLEGE FOR MEN",
  "GAC FOR MEN",
  "C.KANDASWAMI NAIDU COLLEGE FOR MEN",
  "DMI College of Engineering",
  "Nehru Memorial College, Puthanampatti - 621 007.",
  "Park's College",
  "The Kavery Engineering College",
  "Swami Vivekananda College of Education, Perambalur",
  "St. Xavier College of Education, Thanjavur",
  "St. Xaviers College of Education, Pudukkottai",
  "St.Josephs College of Education, The Nilgiris",
  "Sri Ragavendra College of Education, Erode",
  "Sri Vengateswara College of Education, Cuddalore",
  "Angel College of Engineering and Technology",
  "Coimbatore Institute of Technology",
  "College of Business Management",
  "CSI College of Engineering",
  "DHIRAJLAL GANDHI COLLEGE OF TECHNOLOGY, SALEM",
  "Dr.Mahalingam College of Engineering and Technology",
  "Hindusthan College of Engineering and Technology",
  "Hindusthan Institute of Technology",
  "Info Institute of Engineering",
  "Jansons Institute of Technology",
  "Jayam College of Engineering and Technology",
  "JCT College of Engineering and Technology",
  "JKK Munirajah College of Technology",
  "J.K.K Munirajah School of Architecture",
  "J.K.K.Nattraja College of Engineering & Technology",
  "Karpagam College of Engineering",
  "Karpagam Institute of Technology",
  "Nandha College of Technology",
  "Nandha Engineering College",
  "Nehru Institute of Engineering and Technology",
  "Nehru Institute of Information Technology and Management",
  "N.R. SCHOOL OF ARCHITECTURE, COIMBATORE",
  "N.S.N COLLEGE OF ENGINEERING AND TECHNOLOGY, KARUR",
  "Paavai College of Engineering",
  "SNS College of Technology",
  "Sona College of Technology",
  "Sree Sakthi Engineering College",
  "Sri Eshwar College of Engineering",
  "Sri Ganesh School of Business management",
  "Sri Krishna College of Engineering and Technology",
  "Sri Krishna College of Technology",
  "Sri Ramakrishna Institute of Technology",
  "OASYS Institute of Technology",
  "KIT- Kalaignar Karunanidhi Institute of Technology",
  "Jai Shriram Engineering College",
  "Dhanalakshmi Srinivasan Engineering College",
  "Indra Ganesan College of Engineering",
  "J.J. College of Engineering and Technology",
  "Kings College of Engineering",
  "K.Ramakrishnan College of Engineering",
  "St.Joseph's College of Engineering and Technology",
  "Annapoorana Engineering College",
  "AVS Engineering College",
  "Bannari Amman Institute of Technology",
  "Chettinad College of Engineering & Technology",
  "Christ The King Engineering College",
  "Dr N.G.P. Institute of Technology",
  "Er. Perumal Manimekalai College of Engineering",
  "Excel Engineering College",
  "Government College of Technology",
  "Happy Valley Business School",
  "KGiSL Institute of Technology",
  "Knowledge Institute of Technology",
  "Kongu Engineering College",
  "KPR Institute of Engineering and Technology",
  "K.S.Rangasamy College of Technology",
  "K S R College of Engineering",
  "KSR INSTITUTE FOR ENGINEERING AND TECHNOLOGY, NAMAKKAL",
  "KV Institute of Management and Information Studies",
  "Mahendra Engineering College",
  "Mahendra Engineering College for Women",
  "Mahendra Institute of Engineering and  Technology",
  "Mahendra Institute of Technology",
  "McGan's Ooty School of Architecture",
  "M.P.Nachimuthu M.Jaganathan Engineering College",
  "Muthayammal Engineering College",
  "P.A.College of Engineering and Technology",
  "Park College of Engineering and Technology",
  "Park College of Technology",
  "PGP college of Engineering and Technology",
  "PPG Business School",
  "PPG Institute of Technology",
  "PSG College of Technology",
  "P.S.V.College of Engineering and Technology",
  "SAN International Business School",
  "Sasurie College of Engineering",
  "Selvam College of Technology",
  "Rajiv Gandhi College of Engineering",
  "R.M.D Engineering College",
  "R M K College of Engineering and Technology",
  "R.M.K Engineering College",
  "Sri Ramanujar Engineering College",
  "Sri Sairam Engineering College",
  "Sri Sai Ram Institute of Technology",
  "Sri Venkateswaraa College of Technology",
  "Sri Venkateswara College of Engineering",
  "Sri Venkateswara College of Engineering and Technology",
  "Sri Venkateswara Institute of Science and Technology",
  "St Peter's College of Engineering and Technology",
  "Thangavelu Engineering College",
  "Velammal Engineering College",
  "Velammal Institute of Technology",
  "University V.O.C College of Engineering,Tuticorin",
  "V.R.S. College of Engineering and Technology",
  "Meenakshi Sundararajan Engineering College",
  "Pallavan College of Engineering",
  "VILLUPURAM GOVERNMENT MEDICAL COLLEGE AND HOSPITAL (Inst. Code - 399), VILLUPURAM",
  "Karpaga Vinayaga College of Engineering and Technology",
  "Jerusalem College of Engineering",
  "KCG College of Technology",
  "Sri Sivasubramaniya Nadar College of Engineering",
  "Sardar Raja College of Engineerings",
  "Mahakavi Bharathiyar College of Engineering and Technology",
  "Prince Dr. K. Vasudevan College of Engineering & Technology",
  "Prince Shri Venkateshwara Padmavathy Engineering College",
  "Priyadarshini Engineering College",
  "Idhaya Engineering College for Women",
  "RENGNAYAHI VARATHARAJ COLLEGE OF ENGINEERING",
  "Surya Group of Institutions",
  "Adhiparasakthi Engineering College",
  "A.K.T. Memorial College of Engineering & Technology",
  "Annamalaiar College of Engineering",
  "Apollo Engineering College",
  "A R Engineering College",
  "Arulmigu Meenakshi Amman College of Engineering",
  "Arunai Engineering College",
  "Asan Memorial College of Engineering and Technology",
  "Chendu College of Engineering & Technology",
  "Chennai Institute of Technology",
  "Dhanalakshmi College of Engineering",
  "Easwari Engineering College",
  "Gojan School of Business and Technology",
  "Madha Engineering College",
  "Madha Institute of Engineering & Technology",
  "Loyola Institute of Technology",
  "Oxford College of Engineering",
  "Rrase College of Engineering",
  "S.A Engineering College",
  "Saraswathy College of Engineering and Technology",
  "Saveetha Engineering College",
  "Sri Krishna College of Engineering",
  "Sri Muthukumaran Institute of Technology",
  "Thirumalai Engineering College",
  "Thiruvalluvar College of Engineering and Technology",
  "T.J. Institute of Technology",
  "T.J.S. Engineering College",
  "GRT Institute of Engineering and Technology",
  "College of Food and Dairy Technology, Koduvalli",
  "Veterinary College and Research Institute, Tirunelveli",
  "ADHIPARASAKTHI COLLEGE OF NURSING (Inst. Code - 083), KANCHEEPURAM ",
  "ADHIPARASAKTHI COLLEGE OF PHYSIOTHERAPY AND PARAMEDICAL SCIENCES (Inst. Code - 107), KANCHEEPURAM",
  "MOHAMED A.J. COLLEGE OF PHYSIOTHERAPY(Inst. Code - 219), CHENNAI",
  "AL AMEEN COLLEGE OF NURSING (Inst. Code - 292), TIRUVANNAMALAI",
  "Government Arts and Science College, Kangeyam",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, KOMARAPALAYAM",
  "OM MURUGA COLLEGE OF ARTS AND SCIENCE , SINGIRIPATTI",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE FOR WOMEN, DHARMAPURI",
  "AAB COLLEGE OF NURSING (Inst. Code - 344), TIRUVANNAMALAI",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, HOSUR",
  "M.KUMARASAMY COLLEGE OF ENGINEERING, KARUR",
  "ANNAI COLLEGE OF NURSING (Inst.Code - 595)",
  "ANTHONIAMMAL COMMUNITY COLLEGE - AACC  (Inst.Code - 517)",
  "WOMEN'S CENTER & HOSPITALS (P) LTD (Inst. Code - 398), COIMBATORE",
  "RSV SKIN & LASER CENTRE (Inst. Code - 582), CHENNAI",
  "PSG INSTITUTE OF MEDICAL SCIENCES AND RESEARCH (Inst. Code - 446), COIMBATORE",
  "GLOBAL HOSPITALS & HEALTH CITY (Inst. Code - 512), CHENNAI",
  "DOCTORS INSTITUTE OF LABORATORY SCIENCE (Inst. Code - 554), TRICHY",
  "ARTHUR ASIRVATHAM HOSPITAL  (Inst.Code - 563)",
  "SOORIYA HOSPITAL (Inst. Code - 574), CHENNAI",
  "REGIONAL INSTITUTE OF OPHTHALMOLOGY AND GOVT. OPHTHALMIC HOSPITAL, (MMC) EGMORE (Inst. Code - 416), CHENNAI",
  "R.K. PARA MEDICAL COLLEGE (Inst. Code - 528), SALEM",
  "MADRAS MEDICAL COLLEGE & GOVT. GENERAL HOSPITAL (Inst. Code - 395), CHENNAI",
  "JAIRUPAA COLLEGE OF ENGINEERING",
  "C.K. College of  Engineering & Technology",
  "POLLACHI COLLEGE OF ARTS AND SCIENCE",
  "VIVEKANANDA (RABINRANATH TAGORE) NURSING COLLEGE  FOR WOMEN (Inst. Code - 235), SALEM",
  "J.K.K. MUNIRAJAH MEDICAL RESEARCH FOUNDATION, COLLEGE OF PHYSIOTHERAPY (Inst. Code - 103),  NAMAKKAL",
  "BON SECOURS COLLEGE OF NURSING (Inst. Code - 622), Kancheepuram ",
  "SASHANK EDUCATIONAL TRUST (Inst. Code - 608)",
  "AGRICULTURAL COLLEGE AND RESEARCH INSTITUTE",
  "Government Arts and Science College, Nagalapuram",
  "NEHRU MEMORIAL COLLEGE OF EDUCATION",
  "MUTHAYAMMAL COLLEGE OF EDUCATION",
  "SRI RAM NALLAMANI YADAVA COLLEGE OF PHARMACY  (Inst. Code - 101), TENKASI TALUK",
  "The Kavery College of Education for Women",
  "KURINCHI COLLEGE OF EDUCATION, ATTUR",
  "STET COLLEGE OF EDUCATION FOR WOMEN",
  "St.JUSTIN ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "SRI RAMANAS COLLEGE  OF EDUCATION",
  "VALLALAR COLLEGE OF EDUCATION",
  "sethu bhaskara agricultural college and research foundation",
  "EXCEL COLLEGE FOR COMMERCE AND SCIENCE",
  "Government Arts and Science College for Women,Barugur",
  "DHANALAKSHMI SRINIVASAN AGRICULTURE COLLEGE",
  "S.M.S. College of Arts and Science",
  "Solai College of Arts and Science",
  "Vivekanandha College of Arts and Sciences for Women (Autonomous)",
  "Rajiv Gandhi College of Education",
  "DON BOSCO COLLEGE OF EDUCATION AND RESEARCH INSTITUTE",
  "E.S. College of Education",
  "ST.JOSEPH COLLEGE OF EDUCATION KALAKAD",
  "DR KALAM COLLEGE OF PHARMACY",
  "DHARAN INSTITUTE OF HEALTH SCIENCES",
  "Punitha Ohm College of Education",
  "Lady Willingdon Institute of Advanced Study In Education, (Autonomous)",
  "INSTITUTE OF FISHERIES POST GRADUATE STUDIES, VANIYANCHAVADI",
  "INDIAN MARITIME UNIVERSITY, CHENNAI",
  "TAMIL NADU GOVERNMENT M.G.R.  FILM AND TELEVISION INSTITUTE",
  "SWAMY VIVEKANANDHA COLLEGE OF PHARMACY (Inst. Code - 059), Namakkal",
  "SRM ARTS AND SCIENCE COLLEGE",
  "Dr MGR FISHERIES COLLEGE AND RESEARCH INSTITUTE, THALAINAYERU",
  "Cherran College for Women",
  "Vins Christian Women's College of Engineering",
  "GOVERNMENT ARTS COLLEGE, MELUR",
  "DWARAKA DOSS GOVERDHAN DOSS VAISHNAV COLLEGE",
  "Anna University Regional Campus - Tirunelveli",
  "Anna University Regional Campus - Madurai",
  "Anna University Regional Campus - Coimbatore",
  "Grace College of Engineering (Formerly Chandy College of Engineering)",
  "Nellai College of Engineering (Formerly National College of Engineering)",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE MUDACHIKKADU",
  "PERI COLLEGE OF ARTS AND SCIENCE",
  "SEMBODAI R V ARTS AND SCIENCE COLLEGE",
  "SONA MEDICAL COLLEGE OF NATUROPATHY AND YOGA",
  "KOKILA ARTS AND SCIENCE COLLEGE",
  "Padmavani Arts and Science College for Women(Autonomous)",
  "Sri Rangapoopathi College of Education",
  "MEERA COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "APOLLO ARTS AND SCIENCE COLLEGE NORTH CHENNAI",
  "VIVEKANANDHA PHARMACY COLLEGE FOR WOMEN",
  "ALMIGHTY COLLEGE OF NURSING",
  "MOTHER TERASA COLLEGE OF PHYSIOTHERAPY",
  "MAR GREGORIOS COLLEGE OF ARTS & SCIENCE",
  "SCUDDER INSTITUTE OF ALLIED HEALTH SCIENCES ",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE JAYANKONDAM",
  "GOVERNMENT ARTS SCIENCE COLLEGE COEDUCATION KUTHALAM",
  "THANGAVEL WOMENS ARTS AND SCIENCE COLLEGE",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE THARAGAMPATTI KADAVUR TALUK KARUR DISTRICT",
  "STPETERS ARTS AND SCIENCE COLLEGE",
  "NYRUTHI ARTS AND SCIENCE COEDUCATION COLLEGE",
  "SRI AMARAAVATHI COLLEGE OF ARTS AND SCIENCE",
  "DR M SIVAKKANNU WOMENS ARTS AND SCIENCE COLLEGE",
  "K  S  RANGASAMY  COLLEGE  OF  NURSING",
  "MARIA HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL (Inst.Code - 625)",
  "NANDHA NATUROPATHY AND YOGA MEDICAL COLLEGE",
  "MASS COLLEGE OF EDUCATION",
  "SHREE VENKATESHWARA COLLEGE OF NURSING",
  "ANNAI COLLEGE OF OCCUPATIONAL THERAPY",
  "AVS ARTS AND SCIENCE COLLEGE",
  "ARUNAI MEDICAL COLLEGE AND HOSPITAL",
  "NG INSTITUTE OF PARAMEDICAL SCIENCES",
  "CLAUDINE COLLEGE OF NURSING",
  "CHEZHIAN ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "ARULMIGU PALANIANDAVAR ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "MARIAMMAN NURSING COLLEGE",
  "SHRI PARANJOTHI YOGA COLLEGE",
  "VETHATHIRI MAHARISHI COLLEGE OF YOGA",
  "RATHINAM  COLLEGE  OF  PHYSIOTHERAPY",
  "SRI BALAJI ARTS AND SCIENCE CO EDUCATION COLLEGE",
  "GRACE PHYSIOTHERAPY COLLEGE ",
  "PERI COLLEGE OF PHARMACY",
  "GNANAMANI INTEGRATED COLLEGE OF EDUCATION",
  "M/s SALEM POLYCLINIC , (Inst. Code - 626), Salem",
  "Arcot Lutheran Church College of Education",
  "KALAIMAGAL COLLEGE OF EDUCATION, DHARMAPURI ",
  "ARUL COLLEGE OF EDUCATION ",
  "Government Arts and Science College, Pennagaram.",
  "International College of Education (Women)",
  "INSTITUTE OF HORTICULTURE",
  "BHARATHIAR UNIVERSITY PG EXTENSION AND RESEARCH CENTRE",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, SERKADU",
  "SATHYA SAAI ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "SUN COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, GINGEE",
  "MANIKAM RAMASWAMI COLLEGE OF ARTS AND SCIENCE",
  "G T N LAW COLLEGE",
  "MOTHER TERASA LAW COLLEGE",
  "SATHYABAMA COLLEGE OF EDUCATION",
  "PERI COLLEGE OF NURSING",
  "ENNAM COLLEGE OF NURSING",
  "NIGHTINGALE INSTITUTE OF PHYSIOTHERAPY",
  "GOVERNMENT MEDICAL COLLEGE AND HOSPITAL, CUDDALORE DISTRICT, ANNAMALAINAGAR",
  "GOVERNMENT DENTAL COLLEGE AND HOSPITAL, CUDDALORE DT, CHIDAMBARAM",
  "E G S PILLAY COLLEGE OF NURSING",
  "KALAIMAHAL COLLEGE OF NURSING",
  "GOVERNMENT MEDICAL COLLEGE, THE NILGIRIS",
  "KAUVERY HOSPITAL, CHENNAI",
  "SS INSTITUTE OF PHARMACY",
  "THIRUVALLUVAR ARTS AND SCIENCE COLLEGE",
  "HORTICULTURAL COLLEGE AND RESEARCH INSTITUTE PAIYUR",
  "SRI SHIRDI SAI BED COLLEGE",
  "PAAVAI COLLEGE OF NURSING AND RESEARCH",
  "BHARATHIDASAN UNIVERSITY POST GRADUATE EXTENSION CENTRE",
  "PSA COLLEGE OF EDUCATION",
  "PAPNI SCHOOL OF ARCHITECTURE",
  "VALLAL P T LEE CHENGALVARAYA NAICKER ARTS AND SCIENCE",
  "MARIA COLLEGE OF NURSING",
  "NATIONAL COLLEGE OF ARTS AND SCIENCE CO ED",
  "GURU SHREE SHANTIVIJAI JAIN ARTS AND SCIENCE COLLEGE",
  "RKP COLLEGE OF PHARMACY",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, JAMBUKULAM, SHOLINGHUR",
  "KRISHNA COLLEGE OF ARTS AND SCIENCE",
  "P.S.G. Ponnammal College of Education",
  "SRI AYYAPPA COLLEGE OF EDUCATION",
  "SANGAMAM ARTS AND SCIENCE COLLEGE ",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, VADALUR",
  "SSM COLLEGE OF ENGINEERING (MCA STANDALONE)",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE  THALAVADI",
  "MARAGATHAM ARTS AND SCIENCE COLLEGE, NILAKOTTAI",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE ANTHIYUR",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE FOR WOMEN ,KOOTHANALLUR, THIRUVARUR DISTRICT",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, ODDANCHATRAM",
  "ATHOOR COOPERATIVE ARTS AND SCIENCE COLLEGE",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, REDDIARCHATRAM",
  "GOVERMENT ARTS AND SCIENCE COLLEGE, THIRUCHUZHI",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, ERIYUR, PENNAGARAM TALUK",
  "ERODE COLLEGE OF LAW",
  "NPR COLLEGE OF NURSING AND RESEARCH INSTITUTE ALLIED HEALTH SCIENCE",
  "PSP NURSING COLLEGE",
  "CROSS COLLEGE OF NURSING",
  "ARAVINDHAR ARTS AND SCIENCE COLLEGE",
  "ANR COLLEGE OF ARTS AND SCIENCE",
  "SRI AANDAL ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "PANIMALAR COLLEGE OF ALLIED HEALTH SCIENCES",
  "BSD COLLEGE OF ALLIED HEALTH SCIENCES",
  "HINDUSTHAN COLLEGE OF SCIENCE AND COMMERCE",
  "VAILANKANNI MATHA ARTS AND SCIENCE COLLEGE",
  "SRI LAKSHMI MEDICAL CENTRE AND HOSPITAL",
  "G T N MEDICAL COLLEGE OF NATUROPATHY AND YOGIC SCIENCE RESEARCH CENTRE",
  "SANTHI PARAMEDICAL INSTITUTE",
  "MOTHER TERASA INSTITUTE OF PARAMEDICAL AND ALLIED HEALTH SCIENCES",
  "A R COLLEGE OF NURSING",
  "C.Kandaswami Naidu College for Women,Cuddalore-607001",
  "MOTHER TERASA NATUROPATHY AND YOGA MEDICAL COLLEGE ",
  "MANGALAM COLLEGE OF ARTS AND SCIENCE",
  "PSG INSTITUTE OF ARCHITECTURE AND PLANNING",
  "JAYA WOMENS COLLEGE ARTS AND SCIENCE",
  "KUMARAN COLLEGE OF NURSING",
  "AMBARI ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "J J COLLEGE OF NURSING",
  "ST DEVASAHAYAM INSTITUTE OF FISHERIES SCIENCE AND TECHNOLOGY ",
  "ANNAI COLLEGE OF PHARMACY,DHARMAPURI",
  "St.Josephs College of Arts & Science for Women",
  "SAYA Gosh College of Education",
  "GOVERNMENT COLLEGE OF EDUCATION",
  "Bharathi Vidyalaya College of Education (Women)",
  "ST.JOSEPH'S COLLEGE (ARTS & SCIENCE )",
  "GRT COLLEGE OF NURSING, TIRUTANI",
  "V O Chidambaranar Agricultural College and Research Institute, Killikulam",
  "PRANAV COLLEGE OF NURSING ACADEMY",
  "SRI RAMAJAYAM ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "JAINEE COLLEGE OF NURSING (Inst. Code - 229), DINDIGUL",
  "VIHAAN COLLEGE OF PHARMACY",
  "MARIA COLLEGE OF ALLIED HEALTH SCIENCES",
  "AVE MARIA COLLEGE OF NURSING",
  "GOVERNMENT DENTAL COLLEGE  PUDUKKOTTAI",
  "M.I.E.T. Arts and Science College, Gundur, Tiruchirappalli - 620 007.",
  "NEHRU INSTITUTE OF HEALTH SCIENCES",
  "SIVA HOSPITAL",
  "RAJAS INSTITUTE OF ALLIED HEALTH SCIENCES",
  "SCHOOL OF ARTS AND SCIENCE, VMRFDU",
  "VELAMMAL MEIGNANAGURU COLLEGE OF NURSING ",
  "Government Arts and Science College - Aundipatti",
  "SRINIVASAN NURSING COLLEGE",
  "P.P.G.  INSTITUTE OF ALLIED HEALTH SCIENCE (Inst. Code - 642)",
  "PARIMALA COLLEGE OF NURSING KOVILPATTI TUTICORIN",
  "JAYAMADHI COLLEGE OF ALLIED HEALTH SCIENCE",
  "Amrita College of Education",
  "THE KAAVERY PHARMACY COLLEGE    ",
  "CENTRE FOR BIOSCIENCE AND NANOSCIENCE RESEARCH    ",
  "SHRI INDRA GANESAN INSTITUTE OF MEDICAL SCIENCE SIDDHA MEDICAL COLLEGE",
  "SCAD COLLEGE OF NURSING    ",
  "Dharmapuram Adhinam Arts College",
  "SREE SASTHA COLLEGE OF NURSING, THIRUVALLUR",
  "S THANGAPAZHAM PHARMACY COLLEGE",
  "AMC COLLEGE OF NURSING,KARUMATHAMPATTI,COIMBATORE",
  "SASURIE COLLEGE OF PHARMACY",
  "ST JUDES NURSING COLLEGE",
  "AMC COLLEGE OF PHARMACY",
  "DR KAMAKSHI COLLEGE OF NURSING",
  "AGRICULTURAL COLLEGE AND RESEARCH INSTITUTE, CHETTINAD",
  "Government College of Architecture and Sculpture Mamallapuram",
  "JAGANATH COLLEGE OF PHARMACY",
  "ST JOHNS COLLEGE OF NURSING ",
  "DHANALAKSHMI SRINIVASAN INSTITUTE OF MEDICAL SCIENCES AND HOSPITAL",
  "SANKARA SCHOOL OF SCIENCE AND TECHNOLOGY",
  "SRI VENKATESWARAA MEDICAL COLLEGE HOSPITAL AND RESEARCH INSTITUTE",
  "KANGEYAM INSTITUTE OF TECHNOLOGY",
  "ICMR-NATIONAL INSTITUTE OF EPIDEMIOLOGY, CHENNAI",
  "GK COLLEGE OF NURSING",
  "KALYANI KIDNEY CARE CENTRE",
  "SRINIDHI COLLEGE OF HEALTH SERVICES AND RESEARCH",
  "SWAMY VIVEKANANDHA COLLEGE OF PHARMACY (Inst. Code - 644) VIVEKANANDA MEDICAL CARE HOSPITLA",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, THIRUTHURAIPOONDI",
  "CHRISTIAN MEDICAL COLLEGE AND HOSPITAL, COLLEGE OF NURSING (Inst. Code - 033), VELLORE",
  "Sri Karpaga Vinayagar College of Education",
  "Sri Kalaimagal College of Education",
  "Nadar Mahajana Sangam Kamaraj College of Education",
  "Meenammal College of Education for Women",
  "K.S.M. College of Education for Women",
  "KAAMADHENU COLLEGE OF EDUCATION",
  "Jenneys College of Education",
  "JAS College of Education",
  "Thanthai Periyar Government Arts and Science College (Autonomous), Tiruchirappalli",
  "Dr. S.N.S. College of Education",
  "D.K.T. College of Education",
  "Christ College of Education for Women",
  "Sri Lakshmi College of Education",
  "DMI College of Education",
  "INDIAN COLLEGE OF EDUCATION FOR WOMEN",
  "Vivekananda College of Education",
  "Madha College of Education",
  "KKG COLLEGE OF EDUCATION",
  "Christ College of Education for Women",
  "ADHIYAMAN COLLEGE OF EDUCATION FOR WOMEN 11115",
  "YMCA College of Physical Education",
  "Sri Ramakrishna Mission Vidyalaya Maruthi College of Physical Education",
  "Devarajan College of Education",
  "Danie College of Education",
  "Crescent College of Education for Women",
  "Amala College of Education",
  "All Saints College of Education",
  "A.M.E.S. College of Education",
  "A.G. College of Education",
  "DHANALAKSHMI SRINIVASAN COLLEGE OF PHARMACY",
  "THIRUVALLUVAR ARTS & SCIENCE COLLEGE FOR WOMEN, SOOLAPURAM",
  "PSM College of Education",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, MANUR",
  "YUVAGURU COLLEGE OF ARTS AND SCIENCE COEDUCATION",
  "AKSHAYA COLLEGE OF ARTS AND SCIENCE ,KINATHUKADAVU,COIMBATORE ",
  "SSS COLLEGE FOR WOMEN",
  "NEHRU COLLEGE OF PHYSIOTHERAPY",
  "SRI LAKSHMI COLLEGE OF NURSING ",
  "SRI LAKSHMI COLLEGE OF PHYSIOTHERAPY ",
  "KAMARAJAR COLLEGE OF NURSING",
  "MULLAI COLLEGE OF NURSING",
  "ERK COLLEGE OF PHARMACY",
  "NPR COLLEGE OF NURSING AND RESEARCH INSTITUTE",
  "NANDHA DENTAL COLLEGE AND HOSPITAL",
  "IMMANUEL ARASAR AYURVEDA MEDICAL COLLEGE AND HOSPITAL",
  "GLOBAL COLLEGE OF ALLIED HEALTH SCIENCE",
  "P S V COLLEGE OF NURSING BANGALORE CHENNAI HIGHWAY BALINAYANAPALLI VILLAGE BARGUR TALUK KRISHNAGIRI DISTRICT TAMIL NADU",
  "SRI VIJAY VIDYALAYA COLLEGE OF NURSING AND RESEARCH",
  "DHANALAKSHMI SRINIVASAN DENTAL COLLEGE",
  "TAGORE COLLEGE OF NURSING",
  "KAILASH NURSING COLLEGE",
  "N R T  COLLEGE OF NURSING",
  "REVATHI INSTITUTE OF OCCUPATIONAL THERAPY AND MEDICAL RESEARCH",
  "S.N. College of Education",
  "VALLIAMMAL COLLEGE FOR WOMEN",
  "A.P.C. Mahalaxmi College for Women, Ettayapuram Road, Tuticorin - 628 002",
  "Hajee Karutha Rowther Howdia College",
  "Nehru Institute of Technology",
  "QUEEN MARYS COLLEGE",
  "VENKATESWARA HOMOEOPATHIC MEDICAL COLLEGE (Inst. Code - 205), CHENNAI",
  "VEE CARE COLLEGE OF NURSING (Inst. Code - 487), CHENNAI",
  "ULTRA COLLEGE OF PHARMACY (Inst. Code - 046), MADURAI",
  "EASA COLLEGE OF NURSING",
  "St.Joans College of Education",
  "SREE BALAJI MEDICAL COLLEGE AND HOSPITAL",
  "Sri Venkateswara College of  Education, Thanjavur",
  "RAJAJI COLLEGE OF EDUCATION",
  "PSG Ponnammal College of Education",
  "C. Abdul Hakeem College,Hakeem Nagar,Melvisharam-632 509",
  "Sacred Heart College(autonomous)Thirupattur-635 601",
  "Islamiah college(autonomous),New town,Vaniyambadi-635 752",
  "M.A.M. School of Engineering ",
  "GEM HOSPITAL AND RESEARCH CENTRE PVT LTD",
  "K.S.K College of Engineering and Technology",
  "K.Ramakrishnan College of Technology",
  "Dr.Navalar Nedunchezhiyan College of Engineering",
  "School of Architecture & Planning Campus",
  "Madras Institute of Technology Campus",
  "Vetri Vinayaha College of Engineering and Technology",
  "Sri Bharathi Engineering College for Women",
  "Shri Angalamman College of Engineering and Technology",
  "Shivani Engineering College",
  "Saranathan College of Engineering",
  "Roever Engineering College",
  "Pavendar Bharathidasan College of Engineering and Technology",
  "Parisutham Institute of Technology and Science",
  "K.N.SUBBARAJ MEMORIAL COLLEGE OF EDUCATION , THOOTHUKKUDI",
  "R.V.S. College of Engineering",
  "Oxford Engineering College",
  "M.R.K. Institute of Technology",
  "Mount Zion College of Engineering and Technology",
  "POONDI PUDHUMAI MADHA COLLEGE OF EDUCATION, TIRUCHIRAPPALLI ",
  "University College of Engineering, Pattukkottai",
  "University College of Engineering, Ariyalur",
  "MERIT COLLEGE OF EDUCATION , TIRUNELVELI",
  "SIMPRA COLLEGE OF EDUCATION , THANJAVUR",
  "Swami Vivekananda College of Education, Thanjavur",
  "SRI VINAYAGA COLLEGE OF EDUCATION",
  "RAMYA SATHIANATHAN COLLEGE OF EDUCATION , THANJAVUR",
  "ST.JOSEPH COLLEGE OF EDUCATION , SIVAGANGA",
  "GRT COLLEGE OF EDUCATION",
  "M.A.M. College of Engineering and Technology",
  "PRIME NEST COLLEGE OF ARCHITECTURE AND PLANNING",
  "OM COLLEGE OF EDUCATION",
  "U S P ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "CAPE ARTS AND SCIENCE COLLEGE ARALVOIMOZHI",
  "AUXILIUM ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, KAPPALUR, THIRUMANGALAM",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, VEDASANDUR",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, ARUPPUKOTTAI, VIRUDHUNAGAR DISTRICT",
  "MUGIL COLLEGE OF LAW",
  "S THANGAPAZHAM LAW COLLEGE",
  "KMC COLLEGE OF LAW ",
  "THULASI COLLEGE OF LAW FOR WOMEN",
  "ROSAMMAL MEMORIAL MINORITY COLLEGE OF EDUCATION FOR WOMEN",
  "ARULMIGU KAPALEESWARAR ARTS AND SCIENCE COLLEGE",
  "OPR MEMORIAL ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "Chendhuran College of Engineering and Technology",
  "ST ANNS COLLEGE OF ARTS AND SCIENCE",
  "GOVERNMENT ARTS AND SECIENCE COLLEGE,ALANGUDI",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE,THIRUMAYAM",
  "C S I BISHOP SOLOMON DORAISAWMY COLLEGE OF ARTS AND SCIENCE ",
  "ABC COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "SRI RANGAPOOPATHI COLLEGE OF ARTS SCIENCE AND EDUCATION",
  "SENTRAYA PERUMAL COLLEGE OF EDUCATION",
  "MRK COLLEGE OFEDUCATION",
  "SREE KRISHNA COLLEGE OF EDUCATION",
  "INTERNATIONAL INSTITUTE OF YOGA  AND NATUROPATHY MEDICAL SCIENCES",
  "NEHRU COLLEGE OF NURSING AND RESEARCH INSTITUTE",
  "GOVERNMENT COLLEGE OF NURSING, CUDDALORE",
  "GLOBAL INSTITUTIONS",
  "Government Medical College and ESIC Hospital",
  "EXCEL COLLEGE OF PHARMACY",
  "As-Salam College of Engineering and Technology",
  "ST PETERS MEDICAL  COLLEGE HOSPITAL AND RESEARCH INSTITUTE",
  "K S RANGASAMY COLLEGE OF ALLIED HEALTH SCIENCE",
  "PAAVAI PHYSIOTHERAPY SCIENCE COLLEGE",
  "SKS COLLEGE OF NURSING , SALEM",
  "THARAMANGALAM SENGUNTHAR COLLEGE OF NURSING",
  "SRINIVASA RAMANUJAN CENTRE",
  "INSTITUTE OF AGRICULTURE, NPRC CAMPUS, VAMBAN",
  "SRI VIRUTHAMBIGAI COLLEGE OF EDUCATION",
  "Akshaya College of Education",
  "GOVERNMENT LAW COLLEGE DHARMAPURI",
  "R.K.P.E.T. B.Ed. College",
  "St.Jude's College, Thoothoor - 629 176, Kanyakumari Dist",
  "A.R.J. Institute of Management Studies",
  "E.G.S.PILLAY COLLEGE OF EDUCATION",
  "A.R.J. College of Engineering and Technology",
  "ANAND ARTS AND SCIENCE COLLEGE",
  "Annai College of Engineering and Technology",
  "Anjalai Ammal Mahalingam Engineering College",
  "USHA COLLEGE OF EDUCATION",
  "STUDY WORLD COLLEGE OF ARTS AND SCIENCE [CO-EDUCATION]",
  "Annai Hajira Women's College, Melapalayam, Tirunelveli - 627 005.",
  "G.K. College of Education",
  "Grace College of Education",
  "Rose Mary College of Arts & Science, Nagercoil Road, Muneerpallam Village, Tirunelveli",
  "S.S.Duraisamy Nadar Mariammal College, Sattur Road, Kovilpatti - 628 501",
  "Nagai College of Education",
  "Trichy Engineering College",
  "Wavoo Wajeeha Women's College of Arts & Science, Kayalpatnam, Thoothukudi Dist",
  "Nazareth Margoschis College, Pillaiyanmanai, Nazareth - 628 617, Thoothukudi Dist",
  "Annai Velankanni College, Tholayavattam 629 157. Kanyakumari District",
  "Avalurpet Arts & Science College,Avalurpet Village,Gingee Taluk",
  "ShriVidhyodhaya College of Education",
  "Sudharsan Engineering College",
  "MAHENDRA INSTITUTE OF MEDICAL AND PHARMACEUTICAL SCIENCES",
  "Sri Sarada College for Women, V.M. Chatram, Tirunelveli - 627 011",
  "Arignar Anna College, Aralvaimoli 629 301 Kanyakumari District",
  "APOLLO ARTS AND SCIENCE COLLEGE CHENNAI",
  "Sembodai Rukmani Varatharajan Engineering College",
  "P.R. Engineering College",
  "Gnanam School of Business",
  "APOLLO INSTITUTE OF HOSPITAL MANAGEMENT & ALLIED SCIENCES (A UNIT OF APOLLO HOSPITALS EDUCATIONAL TRUST) (Inst. Code - 371), CHENNAI",
  "UNITED COLLEGE OF PHYSIOTHERAPY",
  "Kongunadu College of Engineering and Technology",
  "Karpaga Vinayaga Institute of Management",
  "Arasu Engineering College",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, THIRUKOVILUR",
  "St.Mary's College, North Beach Road, Tuticorin - 628 001",
  "SRI RAMAKRISHNA COLLEGE OF NURSING (Inst. Code - 496), KANNIYAKUMARI",
  "Kalaivani College of Education",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, MANAPPARAI",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, THIRUKKATTUPALLI",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, ARAVAKURICHI",
  "SIR ISSAC NEWTON SIDDHA MEDICAL COLLEGE",
  "Sri Bharathi Arts and Science College for Women, Pudukkottai 622 303.",
  "Annai Vailankanni Arts and Science College, Bishop Sundaram Campus, Pudukottai Road, Thanjavur - 613007",
  "RANIPPETTAI ARTS SCIENCES AND MANAGEMENT COLLEGE",
  "SREE MOOKAMBIKA INSTITUTE OF DENTAL SCIENCES (Inst. Code - 203),  KANNIYAKUMARI",
  "Arulmigu  Pannirupidi Ayyan College of Arts & Science, Vagaikulam, Nanguneri (TK) Tirunelveli Dist - 627 108.",
  "Billgates College of Education",
  "Suresh Bernard Teacher Training College",
  "C.S.M. College of Education",
  "St. Pauls College of Education",
  "MEENAKSHI CHANDRASEKARAN COLLEGE OF EDUCATION",
  "KG COLLEGE OF PHARMACY AND RESEARCH INSTITUTE",
  "JEYANTHINATHER ACADEMY OF MARINE STUDIES    ",
  "SOUTHERN ACADEMY OF MARITIME STUDIES",
  "MELMARUVATHUR ADHIPARASAKTHI INSTITUTE OF MEDICAL SCIENCES AND RESEARCH (Inst. Code - 243), KANCHEEPURAM",
  "C.S.I. Jayaraj Annapackiam College, Nallur - 627 853, Tirunelveli Dist .",
  "AUROVILLE INSTITUTE OF APPLIED TECHNOLOGY",
  "SRI VIJAY VIDYALAYA COLLEGE OF PHARMACY",
  "J.K.K MUNIRAJAH COLLEGE OF AGRICULTURAL SCIENCE",
  "ANNAI MEDICAL COLLEGE OF SIDDHA AND RERSEARCH CENTRE",
  "SAGAYATHOTTAM INSTITUTE OF AGRICULTURE AND RURAL DEVELOPMENT ",
  "Sri Vidya College of Engineering and Technology",
  "Satyam College of Engineering and Technology",
  "KARPAGA VINAYAGA INSTITUTE OF MEDICAL SCIENCES AND RESEARCH CENTRE (Inst. Code - 336), KANCHEEPURAM",
  "J.K.K.MUNIRAJAH MEDICAL RESEARCH FOUNDATION, COLLEGE OF OCCUPATIONAL THERAPY (Inst. Code - 276),  NAMAKKAL",
  "J.P. College of Arts and Science, Ayikudy - 627 852, Tenkasi",
  "J.K.K NATARAJAH DENTAL COLLEGE & HOSPITAL (Inst. Code - 022), NAMAKKAL",
  "ANBU COLLEGE OF NURSING (Inst. Code - 320), KOMARAPALAYAM",
  "Nesamony Memorial Christian College, Marthandam - 629 165, Kanyakumari Dist.",
  "P.M.T. College, Melaneelithanallur, Sankarankoil- 627 755.",
  "Ponjesly College of Engineering",
  "Narayana Guru College of Engineering",
  "M.E.T. Engineering College",
  "Dr.Sivanthi Adithanar College of Engineering",
  "Dr.G.U.Pope College of Engineering",
  "C.S.I.Institute of Technology",
  "Annai Vailankanni College of Engineering",
  "Vins Christian College of Engineering",
  "VASAN INSTITUTE OF OPHTHALMOLOGY AND RESEARCH,COIMBATORE",
  "WHITE MEMORIAL COLLEGE OF ALLIED HEALTH SCIENCE",
  "INDIRA COLLEGE OF ALLIED HEALTH SCIENCES",
  "RAGA AGRICULTURAL COLLEGE AND RURAL DEVELOPMENT",
  "MET COLLEGE OF FINE ARTS ",
  "TMariappan Nadar Muthukani Ammal college of Arts and Science",
  "SHRI INDRA GANESAN INSTITUTE OF MEDICAL SCIENCE COLLEGE OF PHARMACY",
  "Jairam Arts & Science College",
  "SIV COLLEGE OF EDUCATION",
  "Perarignar Anna Science College, Dharugapuram, Sivagiri (TK) Tirunelveli - 627 755.",
  "Thiruvalluvar College, Papanasam, V.K.Puram - 627 425",
  "JESU ARTS AND SCIENCE COLLEGE",
  "MIT COLLEGE OF AGRICULTURE AND TECHNOLOGY MUSIRI",
  "Bharatharathna Dr APJ Abdul Kalam Government Arts and Science College Rameswaram",
  "GTN College Of Nursing",
  "MERIT HAJI ISMAIL SAHIB ARTS AND SCIENCE COLLEGE  PERNAMBUT",
  "Indian Institute Of Sports Medicine  Sparrc Trust  ",
  "MASS College of Physical Education",
  "HINDUSTHAN COLLEGE OF NURSING",
  "TIPS SCHOOL OF ARCHITECTURE",
  "Sri vidhya college of Arts and Science",
  "VINAYAKA MISSION'S LAW SCHOOL",
  "GOVERNMENT LAW COLLEGE SALEM",
  "Lord Jegannath College of Engineering and Technology",
  "JOHN DEWEY COLLEGE OF ARTS AND SCIENCE FOR WOMEN ",
  "Mahatma Gandhi College of Arts & Science, V.R.Naidu Nagar.",
  "GLOBAL COLLEGE OF PHYSIOTHERAPY, ANAPARAI, NATTALAM, MARTHANDAM, KANYAKUMARI DISTRICT",
  "SREE SASTHA PHARMACY COLLEGE",
  "Jansons School of Business",
  "KUMARAGURU SCHOOL OF BUSINESS",
  "JKK MUNIRAJAH INSTITUTE OF HEALTH SCIENCES COLLEGE OF PHARMACY (Inst. Code - 649)",
  "AYYA NADAR JANAKI AMMAL COLLEGE",
  "University College of Engineering, BIT Campus, Tiruchirappalli",
  "University College of Engineering, Panruti",
  "Hindusthan College of Arts and Science",
  "LRG Government Arts College for Women",
  "DHANALAKSHMI SRINIVASAN COLLEGE OF PHYSICAL EDCUATION",
  "MOTHER TERASA COLLEGE OF PHYSICAL EDUCATION",
  "CHERAN COLLEGE OF PHYSICAL EDUCATION",
  "SREE BHAVANI COLLEGE OF PHYSICAL EDUCATION",
  "JENNEYS COLLEGE OF PHYSICAL EDUCATION",
  "Government Arts and Science College, Gudalur",
  "Government Arts and Science College, Valparai",
  "STUDY WORLD COLLEGE OF ENGINEERING   ",
  "GRACE COLLEGE OF ALLIED HEALTH SCIENCES",
  "ST GEORGES ARTS AND SCIENCE COLLEGE",
  "MEENAKSHI AMMAL ARTS AND SCIENCE COLLEGE",
  "INDRA GANESAN COLLEGE OF NURSING",
  "TERF's Academy College of Arts and Science",
  "Servite College of Education for Women",
  "Annai Theresas College of Education for Women",
  "VINAYAGA EDUCATION COLLEGE",
  "VISHWAKSENA COLLEGE OF EDUCATION",
  "University College of Engineering, Villupuram",
  "Vel Tech High Tech Dr.Rangarajan Dr.Sakunthala Engineering College",
  "K.L.N. B.Ed College",
  "Vellalar College of Education",
  "Sri GVG Visalakshi College for Women",
  "Alagappa Chettiar Government College of Engineering and Technology, Karaikudi",
  "WHITE MEMORIAL HOMOEOPATHY MEDICAL COLLEGE (Inst. Code - 062), KANNIYAKUMARI",
  "ST. ANN'S  COLLEGE OF NURSING (Inst. Code - 492), THOOTHUKKUDI",
  "SRI RANGAPOOPATHI COLLEGE OF NURSING (Inst. Code - 318), VILLUPURAM",
  "PAULS COLLEGE OF NURSING (Inst. Code - 330), VILLUPURAM",
  "MEENAKSHI MISSION HOSPITAL & RESEARCH CENTRE (Inst. Code - 449),  MADURAI",
  "Rajalakshmi Institute of Technology",
  "Rajalakshmi Engineering College",
  "P M R Engineering College",
  "P.B. College of Engineering",
  "Indira Institute of Engineering and Technology",
  "I.F.E.T. College of Engineering",
  "Lord Venkateshwara Engineering College",
  "Kingston Engineering College",
  "Kings Engineering College",
  "J N N Institute of Engineering",
  "Amrita College of Engineering and Technology",
  "Unnamalai Institute of Technology",
  "University College of Engineering, Nagercoil",
  "Udaya School of Engineering",
  "VIDHYAA GIRI COLLEGE OF ARTS AND SCIENCE",
  "Kalaignar Karunanidhi Government Arts College for Women (Autonomous), Pudukkottai - 622 001.",
  "Bon Secours Arts and Science College for Women.",
  "Dr.N.G.P. Arts and Science College",
  "St. Joseph's College for Women",
  "KR ARTS AND SCIENCE COLLEGE",
  "Sri Ramakrishna Hospital - AHS - (Inst code - 640 )",
  "NANDHA COLLEGE OF ALLIED HEALTH SCIENCES (665)",
  "K.S.G. College of Arts and Science",
  "Sri Ramakrishna College of Arts and Science for Women",
  "Ayyan Thiruvalluvar College of Arts and Science",
  "MAGNA COLLEGE OF ARTS AND SCIENCE",
  "ARUNAI PARAMEDICAL COLLEGE",
  "ROYAL CARE INSTITUTE OF NURSING",
  "PREETHI COLLEGE OF NURSING , MADURAI",
  "SIV COLLEGE OF PHARMACY",
  "SKP ARTS AND SCIENCE COLLEGE  ",
  "Sasurie College of Arts and Science",
  "Sankara College of Science and Commerce",
  "CMS Institute of Management Studies",
  "Global College of Arts and Science for Women",
  "DLR ARTS  AND SCIENCE COLLEGE co education",
  "PANNAI MARIMUTHU COLLEGE OF PHARMACY",
  "Adharsh Vidyalaya College of Arts and Science for Women",
  "ENNAM COLLEGE OF PHARMACY",
  "Erode Christian College of Arts and Science for Women",
  "NESAM COLLEGE OF HEALTH SCIENCES",
  "UNIVERSAL COLLEGE OF ENGINEERING TECHNOLOGY, TIRUNELVELI",
  "GLOBAL BUSINESS SCHOOL",
  "Vellalar College for Women",
  "CAAD-CHENNAI ACADEMY OF ARCHITECTURE AND DESIGN",
  "TJS COLLEGE OF ARTS AND SCIENCE",
  "Nirmala College for Women",
  "Angappa College of Arts and Science",
  "Bharathidasan College of Arts and Science",
  "BHARATH COLLEGE OF NURSING",
  "N G M College",
  "Bishop Appasamy College of Arts and Science",
  "GOVERNMENT CHENGALPATTU MEDICAL COLLEGE & HOSPITAL, COLLEGE OF NURSING, CHENGALPATTU",
  "CHETTINAD SCHOOL OF PHYSIOTHERAPY ",
  "CHETTINAD SCHOOL OF PHARMACEUTICAL SCIENCES",
  "Thavathiru Santhalinga Adigalar Arts, Science and Tamil College",
  "Sree Ramu College of Arts and Science",
  "VLB Janaki Ammal College of Arts and Science",
  "Karuppannan Mariappan College",
  "Texcity Arts and Science College",
  "Sree Amman Arts and Science College",
  "G.R.Damodaran Academy of Management",
  "Navarasam Arts and Science College For Women",
  "SRI DEVI  COLLEGE OF NURSING (Inst. Code - 481), THIRUVALLUR",
  "Podhigai College of Engineering and Technology",
  "Dhanalakshmi Srinivasan College of Engineering and Technology",
  "Tagore Engineering College",
  "Government Arts and Science College, Sathyamangalam",
  "ITHAYA JYTHOI COLLEGE OF NURSING (Inst. Code - 469), TIRUNELVELI",
  "Dr.HAHNEMANN HOMOEOPATHY MEDICAL COLLEGE & RESEARCH CENTRE (Inst. Code - 206), NAMAKKAL",
  "DEVENDRAR COLLEGE OF PHYSIOTHERAPY (Inst. Code - 140), TIRUNELVELI",
  "SHRI SAPTHAGIRI INSTITUTE OF TECHNOLOGY",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE,NATRAMPALLI",
  "THEERAN CHINNAMALAI COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "CET COLLEGE OF NURSING (Inst. Code - 507), KANNIYAKUMARI",
  "BHAARATH COLLEGE OF NURSING (Inst. Code - 453), DINDIGUL",
  "Manonmaniam Sundaranar University College, Puliankudi",
  "Manonmaniam Sundaranar University College, Sankarankovil",
  "Salem Sowdeswari College",
  "SCAD College of Engineering and Technology",
  "ANNAI DORA COLLEGE OF NURSING (Inst. Code - 328), THENI ",
  "P.S.R.Engineering College",
  "PSN Institute of Technology and Science",
  "PSN Engineering College",
  "PSN College of Engineering and Technology",
  "PET Engineering College",
  "MASS COLLEGE OF ARTS AND SCIENCE",
  "Mepco Schlenk Engineering College",
  "Maria College of Engineering and Technology",
  "THIRAVIAM COLLEGE OF ARTS & SCIENCE FOR WOMEN, PERIYAKULAM ",
  "St.Xavier' Catholic College of Engineering",
  "St. Mother Theresa Engineering College",
  "Department of Social Work, Coimbatore",
  "Department of Communication, Coimbatore",
  "Sivaji College of Engineering and Technology",
  "Amrita School of Engineering, Coimbatore",
  "VET Institute of Arts and Science Coeducation College",
  "Velumanoharan Arts and Science College for Women",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE Dr RK NAGAR TONDIARPET CHENNAI ",
  "Sethu Institute of Technology",
  "Government Arts and Science college(Co-Ed), Veerapandi, Theni",
  "Jayamatha Engineering College",
  "Infant Jesus College of Engineering",
  "Immanuel Arasar J.J.College of Engineering",
  "Holycross Engineering Colleges",
  "Government College of Engineering",
  "Francis Xavier Engineering College",
  "Private Law College, Salem",
  "Paavai College of PharmacY and Research",
  "J.K.K. NATTRAJA COLLEGE OF PHARMACY, NAMAKKAL",
  "Government College of Arts &Science Panchayat Union Middle School,Kacharapalayam Road, Kallakuruchi-606 202",
  "IMMACULATE COLLEGE FOR WOMEN",
  "Immaculate college for Women,Viriyur,devapandelam,Post,SankarapuramTaluk-606 402",
  "Indira Gandhi -Jayanthi women's College,Krishaveni Nagar,Kilgudalur,Melpaddi(Post),Tindivanam-604 307",
  "Jawaharlal Nehru College for Women,Pali Village,Ulunderpet Taluk",
  "Jawahar Science College,Block -14,Neyveli-607 803",
  "Joseph Arts &Science College,Thirunavallur-607204",
  "Krishanasamy college of Science,Arts &Management for women,Nellikuppam High oad,S.Kumarapuram-",
  "K.S.Raja Arts &Science College for Women,Cherapperattai-604 210",
  "Manbumigu Dr Puratchithalaivar M G R  Govt  Arts and Science College",
  "MERCY ARTS AND SCIENCE COLLEGE",
  "M.R.K.College of Arts & Science,pazhzchanallurANDPost,Kattumannarkudi-608 301",
  "NPV ARTS AND SCIENCE COLLEGE, CUDDALORE",
  "Periyar Arts College,Cuddalore-607 001",
  "RAAK Arts &Science College(c0-Ed),11 Perambi Road,Perambai,Villainaur post,VanurTaluk-605 110",
  "Rajeshwari College of Arts &science   for women  ,Bommapalayam (village&post),Vanur Taluk-605 104ge",
  "Sacred Heart Arts and Science College",
  "Sanghamam College of Arts And Science, Annamangalam ,Gingee taluk-604 210",
  "Saraswathi college of Arts &  science,Konerikuppam,Mailam,Tindivanam-604 304",
  "Shree Arumugham Arts & Science College,Raja Nagar,Vaithiyanaythapuram,Tholudur-606 303",
  "siddhar Sivagnanni Arts &Science college for Men,BommapalayamVillage&Post,Vanur Taluk-605 104",
  "SIGA College of Management and Computer Science,Kappiyampuliyur,Villupuram-605 601",
  "S K VELAYUTHAM WOMENs ARTS AND SCIENCE COLLEGE, KURINJIPADI",
  "SREE BHAVANI COLLEGE OF ARTS AND SCIENCE COED",
  "Sreemath Sivagnana Balaya Swamigal Tamil Arts &Science College ,Mailam-604 304",
  "Sri Aravindar Arts &science College ,Pondy-Mailam Road,Sedarapet-605 111",
  "Sri Lakshmi College of Arts & Science ,BangalamVillage,Thottiyam Post,Kallakurchi Taluk",
  "Sri Sarada Mahavidyalayam  Arts & Science College for women ,New  Edikal ,Uludurpettai",
  "Sri Vinayaga Colllege of Arts 7Science College,Virudhachalam Main ,Road,Ulundur pet- 606 107",
  "St CHARLES COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "SUSILA ARTS AND SCIENCE COLLEGE FOR WOMEN ",
  "Swami Vivekananda Arts &Science College,Lakshmipuram,Orathur X Road,Gingee Main Road-605 601",
  "Theivanai Ammal College for Women,(Autonomous),Chennai-Trichy Trunk Road,605 401",
  "Thiru. A.Govindasamy Govt.Arts College,Tindivanam-604 001",
  "Thiru Kolanchiyappar Govt.Arts College,Virudachalam-606001",
  "Thiruvalluvar Arts &Science College,Kurinjipadp-607 302",
  "Annamalai University PG Extension Centre , Salamedu",
  "Tirukkoilur College of Arts &Science (co-ed) No.282,Asanur Road,Sandapet,Thirukkoilur-605 757",
  "Vallalar  Arts & Science College,Neyveli Main Road,Vadalur-607 303",
  "Government Law College, Tirunelveli",
  "SRI LAKSHMINARAYAN COLLEGE OF PHARMACY",
  "Dr Ambedkar Govt Law College",
  "Indira Gandhi Centre for Atomic Research (IGCAR), Kalpakkam",
  "Theni Kamavar Sangam College of Technology, Theni",
  "Muthayammal Memorial College of Arts and Science, Rasipuram",
  "Agricultural College and Research Institute, Thiruvannamalai",
  "Aalim Muhammed Salegh College of Engineering",
  "A.T.S.V.S. (AKILA THIRUVITHAMCORE SIDDHA VAIDHYA KALLOORI) SIDDHA MEDICAL COLLEGE AND HOSPITAL (Inst. Code - 199), MUNCHIRAI, KANNIYAKUMARI",
  "Sree Krishna College of Engineering",
  "S.K.R Engineering College",
  "VELLORE GOVERNMENT  MEDICAL COLLEGE (Inst. Code - 221), VELLORE",
  "P.S.N.A. College of Engineering and Technology, Dindigul",
  "University College of Engineering, Ramanathapuram",
  "Mar Ephraem College of Engineering and Technology",
  "Loyola Institute of Technology and Science",
  "THE MADRAS SANSKRIT COLLEGE AND SSV PATASALA",
  "Kamaraj College of Engineering and Technology",
  "DB JAIN COLLEGE",
  "Latha Mathavan Engineering College, Madurai",
  "Jayaraj Annapackiam CSI College of Engineering",
  "Salem College of Engineering and Technology",
  "CSI EWARTS WOMENS CHRISTIAN COLLEGE",
  "Sakthi Institute of Information and Management Studies",
  "Government Law College, Chengalpattu",
  "R.V.S. School of Architecture",
  "RVS Institute of Management Studies",
  "RVS College of Engineering and Technology",
  "R V S Technical Campus Coimbatore",
  "Coimbatore Institute of Engineering and Technology",
  "CMS College of Engineering",
  "Annai Mathammal Sheela Engineering College",
  "HINDU MISSION COLLEGE OF NURSING (Inst. Code - 551), CHENNAI",
  "Paavai Engineering College",
  "The Institute of Mathematical Sciences (IMSc),chennai",
  "Government Law College, Coimbatore",
  "ALAGAPPA UNIVERSITY EVENING COLLEGE, PARAMAKKUDI",
  "KOVAI MEDICAL CENTER AND HOSPITAL LIMITED (Inst. Code - 461), COIMBATORE",
  "THANTHAI PERIYAR GOVERNMENT INSTITUTE OF TECHNOLOGY",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, NEMMELI",
  "K.M.C.H. COLLEGE OF OCCUPATIONAL THERAPY (Inst. Code - 117), COIMBATORE",
  "K.G. HOSPITAL AND POST GRADUATE MEDICAL INSTITUTE (Inst. Code - 374), COIMBATORE",
  "SRI AMMAN COLLEGE OF NURSING",
  "PAUL INSTITUTE OF SPECIAL TEACHER TRAINING",
  "Loyola College of Education",
  "INDIA HEART FOUNDATION (UNIT OF VENKATESWARA HOSPITALS) (Inst. Code - 364), CHENNAI",
  "GOVERNMENT UNANI MEDICAL COLLEGE (Inst. Code - 017), CHENNAI",
  "GURU NANAK COLLEGE",
  "ASAN MEMORIAL COLLEGE OF ARTS AND SCIENCE",
  "STELLA MARIS COLLEGE [AUTONOMOUS]",
  "Dr. Sivanthi Aditanar College of Physical Education",
  "SIR THEAGARAYA COLLEGE",
  "SACRED HEART NURSING COLLEGE (Inst. Code - 055), MADURAI",
  "Government Arts and Science College(Co-Education),Mettupalayam",
  "KARPAGA VINAYAGA COLLEGE OF NURSING (Inst. Code - 378), KANCHEEPURAM",
  "NEW PRINCE SHRI BHAVANI ARTS AND SCIENCE COLLEGE",
  "SRINIVASAN  COLLEGE OF NURSING (Inst. Code - 479), PERAMBALUR",
  "SRI GOKULAM HOSPITAL (Inst. Code - 361), SALEM",
  "SREE ABIRAMI COLLEGE OF NURSING (Inst. Code - 313), COIMBATORE",
  "SIVARAJ SIDDHA MEDICAL COLLEGE (Inst. Code - 329), SALEM",
  "SSM INSTITUTE OF ENGINEERING AND TECHNOLOGY, DINDIGUL",
  "SRI RANGANATHAR INSTITUTE OF ENGINEERING AND TECHNOLOGY, COIMBATORE",
  "MADRAS MEDICAL COLLEGE, COLLEGE OF PHARMACY (Inst. Code - 184), CHENNAI",
  "JR MEDICAL COLLLEGE AND HOSPITAL",
  "L N GOVT COLLEGE",
  "ARINGAR ANNA INSTITUTE OF MANAGEMENT STUDIES AND COMPUTER APPLICATION",
  "Einstein College of Engineering",
  "SREE BALAJI DENTAL COLLEGE AND HOSPITAL",
  "SREE BALAJI COLLEGE OF NURSING",
  "DMI Engineering College",
  "Cape Institute of Technology",
  "Arunachala College of Engineering for Women",
  "SANKARA COLLEGE OF NURSING WOMEN",
  "SREE BALAJI COLLEGE OF PHYSIOTHERAPY",
  "VIVEKANANDA VISION ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "BHAARATH MEDICAL COLLEGE AND HOSPITAL",
  "PRINCE SHRI BALAJI ARTS AND SCIENCE COLLEGE",
  "NATESAN INSTITUTE OF CO-OPERATIVE MANAGEMENT",
  "VINAYAKA MISSIONS SCHOOL OF ECONOMICS AND PUBLIC POLICY",
  "MAHENDRA  ARTS & SCIENCE COLLEGE (AUTONOMOUS)",
  "Government Arts and Science College,Thittamalai",
  "MALOLAN COLLEGE OF ARTS AND SCIENCE",
  "DR MGR JANAKI COLLEGE OF ARTS AND SCIENCE",
  "SRI RAMAKRISHNA MISSION VIDYALAYA INSTITUTE OF AGRICULTURE AND RURAL DEVELOPMENT",
  "MEENAKSHI ARTS AND SCIENCE COLLEGE",
  "VISHWAKSENA ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "MAHENDRA COLLEGE OF PHYSIOTHERAPY",
  "MAHENDRA COLLEGE OF NURSING",
  "GOVERNMENT LAW COLLEGE NAMAKKAL",
  "A.K.D. Dharma Raja Womens College",
  "THIRUMALAI SRINIVASA COLLEGE OF EDUCATION",
  "VAANI COLLEGE OF EDUCATION",
  "Easa College of Engineering & Technology",
  "P.T.R. College of Engineering and Technology,  Madurai",
  "Central Electro-Chemical Research Institute, Karaikudi",
  "Vijay Institute of Management",
  "Dhanalakshmi Srinivasan College of Engineering(CBE)",
  "Syed Ammal Engineering College",
  "Al-Ameen Engineering College",
  "Akshaya College of Engineering and Technology",
  "AJK Institute of Management",
  "Adiyaman College of Engineering",
  "Adithya Institute of Technology",
  "Vandayar Engineering College",
  "Government Law College, Trichy",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE,SRIPERUMBUDUR,KUNDRATHUR,CHENNAI",
  "Gnanamani College of Technology",
  "NACHIAPPA SWAMIGAL ARTS AND SCIENCE COLLEGE, KOVILOOR",
  "JAINEE COLLEGE OF PHARMACY",
  "SINGAI SITHAR AYYA COLLEGE OF ARTS AND SCIENCE, A THEKKUR",
  "M.I.E.T. Engineering College",
  "Mahath Amma Institute of Engineering and Technology",
  "BHARATH INSTITUTE OF SCIENCE AND TECHNOLOGY    ",
  "MEENAKSHI COLLEGE FOR WOMEN",
  "S K P LAW COLLEGE     ",
  "SIR ISSAC NEWTON LAW COLLEGE    ",
  "Government College of Education, (Govt.)",
  "SRI AHOBILA MUTH SANSKRIT COLLEGE",
  "KCS KASI NADAR COLLEGE OF ARTS AND SCIENCE",
  "JUSTICE BASHEER AHMED SAYEED COLLEGE FOR WOMEN",
  "CHELLAMMAL WOMENS COLLEGE",
  "CHERAN COLLEGE OF EDUCATION",
  "RVS PADMAVATHY COLLEGE OF HORTICULTURE",
  "SARDAR VALLABHAI PATEL INTERNATIONAL SCHOOL OF TEXTILE AND  MANAGEMENT",
  "VIVEKANANDA COLLEGE OF ARTS AND SCIENCE,VELLALANKULAM,TENKASI DT    ",
  "Government Law College, Madurai",
  "TAGORE COLLEGE OF ARTS AND SCIENCE",
  "Theivanai Ammal  College of Education",
  "NANJIL CATHOLIC COLLEGE OF ARTS AND SCIENCE, KALIYAKKAVILAI",
  "University College of Engineering, Tirukkuvalai",
  "RVS PADMAVATHY SCHOOL OF ARCHITECTURE",
  "Vyasa Arts and Science Womens College",
  "SHRI KRISHNASWAMY COLLEGE FOR WOMEN",
  "C.S.I. College of Education",
  "SRI KANYAKA PARAMESWARI ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "AGRICULTURAL COLLEGE AND RESEARCH INSTITUTE",
  "Santha College of  Education, Sivagangai",
  "SRINIVASAN INSTITUTE OF NURSING",
  "Al-Amir College of Education Sivagangai",
  "VIDYA SAGAR FORMERLY THE SPASTICE OF INDIA    ",
  "VELLORE NURSING COLLEGE    ",
  "IMMANUEL ARASAR COLLEGE OF NURSING    ",
  "THIRAVIUM PHYSIOTHERAPY COLLEGE    ",
  "SRI LAKSHMI COLLEGE OF PHARMACY    ",
  "VELLALAR PHYSIOTHERAPY COLLEGE    ",
  "ANANDAM LAW COLLEGE, THANJAVUR    ",
  "ST JOHNS COLLEGE OF MEDICAL SCIENCES",
  "Ganesar College of Arts and Science, Melaisivapuri - 622 403.",
  "Annai Ayesha Arts and Science College for Women",
  "V.O.Chidambaram College, Tuticorin - 628 008",
  "SANTHOSHI ARTS AND SCIENCE COLLEGE",
  "JAYA COLLEGE OF ARTS AND SCIENCE",
  "A.V.C. College, Mannampandal, Mayiladuthurai",
  "PERI COLLEGE OF PHYSIOTHERAPY",
  "Dr.Zakir Husain College, Ilayangudi",
  "IMMANUEL ARASAR COLLEGE OF NATUROPATHY",
  "J.K.K. MUNIRAJAH MEDICAL RESEARCH FOUNDATION,  ANNAI J.K.K. SAMPOORANI AMMAL COLLEGE OF PHARMACY (Inst. Code - 082), ETHIRUMEDU",
  "SHREE CHANDRAPRABU JAIN COLLEGE",
  "ANNAI THERESA ARTS AND SCIENCE COLLEGE",
  "DON BOSCO COLLEGE (CO-ED), GUEZOU NAGAR, ATHANAVOOR, YELAGIRI HILLS",
  "Shanmuga Industries arts &SCience college,(Co-Ed),Manalurpet road,604 401",
  "Kumaraguru college of Technology",
  "ANNAI MEENAKSHI COLLEGE OF NURSING (Inst. Code - 102), COIMBATORE",
  "Mohamed Sathak Hamid College of Arts and Science for Women",
  "ANNAI VEILANKANNIS COLLEGE OF NURSING (Inst. Code - 352), CHENNAI",
  "VEL TECH RANGA SANKU ARTS COLLEGE",
  "SPC INSTITUTE OF NURSING EDUCATION AND RESEARCH (Inst. Code - 591), SALEM",
  "CHEVALIER T THOMAS ELIZABETH COLLEGE FOR WOMEN",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, NATHAM",
  "Mazharul Uloom College,Ambur -635 802",
  "BHAKTHAVATCHALAM MEMORIAL COLLEGE",
  "A.R.C. Viswanathan College, Mayiladuthurai, Nagapattinam - 609 003.",
  "Servite Arts and Science College for Women, Thogaimalai Panchayat, Kaladai Village, Karur Dist. - 621 313",
  "Adhiparasakthi College of Education",
  "SRI SUBRAMANIYA SWAMY GOVT ARTS COLLEGE",
  "REV. JACOB MEMORIAL CHRISTIAN COLLEGE",
  "C.M.S. College of Education,",
  "Roseline College of Education",
  "EXCEL INSTITUTE OF HEALTH SCIENCE",
  "Chandra Chellappan College of Education",
  "JAGANNATH COLLEGE OF NURSING CHENGALPATTU",
  "GANDHIMATHI COLLEGE OF NURSING    ",
  "PONJESLY COLLEGE OF NURSING    ",
  "JCT COLLEGE OF ARTS AND SCIENCE    ",
  "CHENNAIS AMIRTA NURSING COLLEGE    ",
  "MAHATMA GANDHI COLLEGE OF PHARMACY    ",
  "SLNC COLLEGE OF NURSING    ",
  "P.P.G. College  of Education",
  "Government Arts College, Karur - 639 005.",
  "ABI & ABI College, Vayalur, Thanjavur - 613 003",
  "Seethalakshmi Ramaswami College, Tiruchirappalli - 620 002.",
  "Jairams Arts & Science College, NH7, Karur-Madurai By-Pass Road, Aattamparappu, Kakavadi (P.O), Karur - 639 003.",
  "Mahatma Arts and Science College, Ariyur Village, Iluppur Taluk, Pudukkottai District-622 101.",
  "Thiyagi Dharmakkan Amirtham  College of Education",
  "Rabiammal Ahamed Maideen College for Women, Thiruvarur - 610 002.",
  "PALAR AGRICULTURAL COLLEGE",
  "PUSHKARAM COLLEGE OF AGRICULTURE SCIENCES",
  "Sivanthi Arts And Science College for Women, Udangudi",
  "Kumaraguru College of Liberal Arts and Science",
  "TIPS COLLEGE OF ARTS AND SCIENCE",
  "O.P.R Memorial College of Education",
  "N.K.T.National College of Education for Women, (Autonomous)",
  "DHANVANTRI COLLEGE OF NURSING (Inst. Code - 357), ERODE",
  "MASS College of Arts and Science, Kumbakonam.",
  "Indra Ganesan College of Education",
  "Sri R. Ponnusamy Naidu College of Education",
  "RVS College of Education",
  "Vickram Teacher Training College",
  "HINDUSTHAN COLLEGE OF ENGINEERING, INGUR, PERUNDURAI",
  "RAO HOSPITAL (Inst. Code - 508), COIMBATORE",
  "R.K. Samy College of Education",
  "Star College of Education",
  "ALAGAPPA UNIVERSITY MODEL CONSTITUENT COLLEGE OF ARTS AND SCIENCE, PARAMAKUDI",
  "JRS College of Education",
  "COLLEGE OF PHYSIOTHERAPY, SRI VENKATESWARAA UNIVERSITY",
  "Sree Velavan College of Education",
  "Krishna  College of Education",
  "IMMACULATE COLLEGE OF NURSING, PULIYAL, SIVAGANGAI",
  "Centwin College of Education",
  "Merit College of Education",
  "BHARATH INSTITUTE OF LAW",
  "Mother Teresa College of Education -1",
  "Newton College of Education",
  "Arcot Sri Mahalakshmi Women's College of Education",
  "Shivparvathi Mandradiar College of Education",
  "Vandayar College of Education",
  "Stella Marys college of Education",
  "Sri Parasakthi College of Education for Women",
  "DINDIGUL SHIFA COLLEGE OF HEALTH SCIENCE",
  "Vathsala Johnson College of Teacher Education",
  "Mangayarkarasi College of Education",
  "Udaya College of Education",
  "Ganapathy College of Education",
  "Minakshee Ramasami College of Education",
  "Sri JayaJothi College of Education",
  "Sri Manickam College of Education",
  "Sri Vinayaga College of Education",
  "Sri Ramakrishna College of Education, Perambalur",
  "SASURIE COLLEGE OF NURSING",
  "Ponkaliamman College of Education",
  "Viswa Bharathi College of Education",
  "Annai College of Education",
  "Kamarajar College of Education",
  "Indhira College of Education",
  "Sri Vidya College of Education",
  "R.V.S.College of Education",
  "Annai India College of Education",
  "PACHAIYAPPAS COLLEGE FOR WOMEN",
  "Rajas Institute of Technology",
  "Kaliammal College of Education",
  "Sengunthar College of Education",
  "SREE ABIRAMI COLLEGE OF OCCUPATIONAL THERAPY COIMBATORE",
  "Annammal college of Education for women, (Aided)",
  "Ganesh  College of Education",
  "PRINCE SHRI VENKATESHWARA ARTS AND SCIENCE COLLEGE",
  "Tranquebar Bishop Manikam Lutheran College, Porayar",
  "LOYOLA COLLEGE",
  "Annai College of Education",
  "SCHOOL OF ALLIED HEALTH SCIENCES, VMKVMC",
  "SCHOOL OF ALLIED HEALTH SCIENCES, VMRFDU",
  "FISHERIES BUSINESS SCHOOL",
  "P.S.Y. College of Education",
  "Michael Job Memorial College of Education for Women",
  "Sri K Ramachandra Naidu College of Education",
  "Meston College of Education,  (Autonomous)",
  "Grace College of Education",
  "Jaya College of Education",
  "Sivagamiammal College of  Education",
  "B.T.K.  College of Education",
  "Apollo College of Education",
  "A.K.T. Memorial College of Education",
  "CSI Bishop Newbigin College of Education",
  "Sri Vidya Vihar College of Education",
  "SoRSPE, Ramakrishna Mission Vivekananda University",
  "Rajalakshmi College of Education",
  "Muslim College of Education",
  "Shree Raghavendra Arts &Science College ,Keezhamoongiladi,Chidhambaram-608 102",
  "Kanchi College of Education",
  "Dr.G.U.Pope college of Education",
  "St.Marys College of Education and Research Institute",
  "Pallavan College of Education",
  "KANGEYAM INSTITUTE OF COMMERCE ",
  "MOHAMED SATHAK TEACHER  TRAINING COLLEGE",
  "DIVYAKALA COLLEGE OF EDUCATION",
  "Sir Issac Newton College of Education",
  "MARIA ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "Manonmaniam Sundaranar University College, Thisayanvillai",
  "Vivekananda College, Agastheeswaram - 629 701",
  "Sri Parasakthi College for Women, Courtallam, Tirunelveli Dist. - 627  802",
  "St.John's College, Palayamkottai - 627 002",
  "Sri Ram Nallamani Yadava College of Arts & Science, Kodikurichi, Tenkasi - 627 804, Tirunelveli Dist",
  "Dhanalakshmi Srinivasan College of Education",
  "Aditanar College of Arts & Science, Virapandianpattinam, Tiruchendur - 628 216 Thoothukudi District.",
  "K.R.College of Arts & Science, K.R. Nagar, Kovilpatti - 628 503.",
  "St. Josephs Womens College of Education",
  "Mahendhira  College of Education",
  "Bon Secours College of Education",
  "Prof. S.A.College of Education",
  "Sri Sowbackiya College of Education",
  "PSN College of Education",
  "Mar Chrysostom College of Education",
  "Krishna College of Education for Women",
  "Udaya College of Arts and Science, Vellamodi, Ammandivilai Post, K.K. Dist - 629 204",
  "Tagore College of Education",
  "Sakthi College of Education for Women",
  "Ruckmani college of Education",
  "KRISHNA COLLEGE OF PARAMEDICAL AND ALLIED HEALTH SCIENCE",
  "Nandha College of Education",
  "St. Justins College of Education, (Aided)",
  "K.M. College of Education",
  "Christian College of Education",
  "Arumugam Pillai Seethai Ammal College of Education",
  "Dr.Rajalakshmi College of Education",
  "Puratchi Thalaivar Dr.M.G.R. College of Education",
  "Chandy College of Education",
  "Sri Kumara Gurupara Swamigal Arts College, Srivaikuntam -628 619",
  "PSG College of Education",
  "Sri Vari College of Education",
  "K. Nanjappa Gownder College of Education",
  "Mahatma College of Education",
  "Annai  Veilankannis  College of  Education",
  "Veterinary College and Research Institute, Namakkal",
  "Madras Veterinary College, Chennai - 7",
  "Suraj College of Education",
  "Bharath Institute Of Catering Technology & Hotel Management , Thanjavur - 613 001",
  "Maruthupandiyar College",
  "Mother Gnanamma Women's College of Arts and Science, Varadarajanpet, Jeyankondam Taluk, Ariyalur District",
  "A.V.S. College of Education",
  "Sourashtra College of Education",
  "Sri Devi College of Education",
  "C.S.I. College of Education",
  "The M.D.T. Hindu College, Pettai, Tirunelveli - 627 008",
  "T.D.T.A.D.S. Daniel Rajammal College of Education",
  "Sri Sarada college of Education for women",
  "Mother Terasa College of Arts and Science, Mettusalai, Veerapatti Village, Illupur Post, Pudukkottai - 622 102.",
  "Jairupa  College of Education",
  "New Ideal College of Education",
  "Victory  College of Education",
  "Sri Amman College of Education",
  "G T N COLLEGE OF TECHNOLOGY",
  "Crescent College of Education",
  "MARIAMMAN COLLEGE OF EDUCATION",
  "Tirunelveli Dakshina Mara Nadar Sangam College, T.Kallikulam - 627 113, Tirunelveli Dist",
  "Kamaraj College, Tiruchendur Road, Tuticorin - 628 003.",
  "Muslim Arts College, Thiruvithancode - 629 174, Kanyakumari Dist.",
  "R.D.B. College of Education",
  "Sandaravadhanam College of Education",
  "POPE'S College, Sawyerpuram - 628 251",
  "Sri Sankara Bhagavathi Arts & Science College, Kommadikottai - 628 653",
  "Amman College of Education",
  "St. Ignatius college of Education, (Autonomous)",
  "Seventh-Day Adventist College of  Education",
  "Sasthaa College of Education",
  "Aruna Vidya Arts & science college,Kannakurukkai Village,Chegam Taluk",
  "Annai JKK Sampoorani Ammal College of Education",
  "Sri Ramachandra College of Management",
  "National College, Tiruchirappalli - 620 001.",
  "WOMENS CHRISTIAN COLLEGE",
  "ANNAPOORANA MEDICAL COLLEGE AND HOSPITAL (Inst. Code - 491), SALEM",
  "K R P College of Arts and Science",
  "Swami Vivekananda Arts & Science College, Sami Arul Nagar, Vallam, Thanjavur - 613 007.",
  "Mother Theresa Arts and Science College",
  "Srinivasan College of Arts and Science, Perambalur - 621 212.",
  "EXCEL COLLEGE OF PHYSIOTHERAPY AND RESEARCH CENTRE",
  "H.H. The Rajah's College, Pudukkottai - 622 001.",
  "ANANDHAN MEMORIAL ARTS AND SCIENCE COLLEGE",
  "Uswathun Hasana Oriental Arabic College, Pallapatti - 639 205",
  "Kalai Kaviri College of Fine Arts, 18 Benwells Road, Tiruchirappalli - 620 001",
  "Dhanalakshmi Srinivasan College of Arts & Science for Women, Perambalur - 621 212.",
  "Siga College of Education",
  "Sri Vatsa College of Education",
  "Jayasanthi B.Ed. College",
  "Sai Ram College of Education",
  "Dr. Nagarathinams College of Education",
  "St.Christophers College of Education,  Autonomous",
  "G.K.M. College of Engineering and Technology",
  "Ranippettai Engineering College",
  "T.S.M. Jain College of Technology",
  "Annai Teresa College of Engineering",
  "Bharathidasan Engineering College",
  "PERI Institute of Technology",
  "V.P.M.M. COLLEGE OF NURSING (Inst. Code - 534), VIRUDHUNAGAR ",
  "THE SALVATION ARMY CATHERINE BOOTH COLLEGE OF NURSING (Inst. Code - 544), NAGERCOIL",
  "Vi Institute of Technology",
  "Khadir Mohideen College, Adirampattinam - 614 701.",
  "Sakthi Institute of Teacher Education and Research",
  "Dharmambal Ramasamy Arts & Science College, Orathanadu T.k.Thanjavur - 614 625.",
  "Vestley College of Education",
  "Paspo College of  Education",
  "Arulmigu Kalasalingam College of Education",
  "Best College of Education",
  "P.T. Lee Chengalvaraya Naicker College of Engineering and Technology",
  "M.E.T. College of Education",
  "University College of Engineering, Tindivanam",
  "Rajah's College, Thiruvaiyaru - 613 204.",
  "Jaya Institute of Technology",
  "St. Joseph's College, Tiruchirappalli - 620 002.",
  "St. Joseph College of Engineering",
  "Sri Venkateshwara College of Arts & Science, Peravurani - 614 804.",
  "Sri Rangapoopathy College of Engineering",
  "Sri Ram Engineering College",
  "Naina Mohamed College of Arts & Science, Rajendrapuram, Pudukkottai - 614 624.",
  "Modern Arts and Science College, 35A, Sannathi Street, Jayankondam, - 621 802.",
  "Sri Krishna Engineering College",
  "Meenakshi College of Engineering",
  "VIVEK INSTITUTE OF LABORATORY MEDICINE  (Inst. Code - 473), KANNIYAKUMARI",
  "Jaya Engineering College",
  "Dhaanish Ahmed College of Engineering",
  "Adhiparasakthi College of Engineering",
  "Adhi College of Engineering and Technology",
  "M.A.M. COLLEGE OF NURSING (Inst. Code - 475), THIRUCHIRAPPALLI",
  "Bharathidasan University Model College, Aranthangi - 614 616",
  "APOLLO COLLEGE OF NURSING (Inst. Code - 128), CHENNAI",
  "R.V.S College of Engineering and Technology (MBA Standalone)",
  "VELLALAR COLLEGE OF PHARMACY",
  "PANNAI COLLEGE OF PHARMACY",
  "Dr. Nallikuppusamy Arts College, Manakkarambai, Thanjavur - 613 003.",
  "COLLEGE OF FISH NUTRITION AND FOOD TECHNOLOGY, MADHAVARAM, CHENNAI",
  "Arputha College of Arts & Science, Arputha Nagar, Vamban - 622 303.",
  "Dr. Kalaignar Government Arts College, Kulithalai ( Sattamandra PonVizha )",
  "SURYA SCHOOL OF PHARMACY (Inst. Code - 380), VILLUPPURAM",
  "Subashkathi Arts and Science College for Women, Kulithalai - 639 120.",
  "Annai Teresa College of Education",
  "M.R. Government Arts College, Mannargudi - 614 001.",
  "ARUNAI INSTITUTE OF NURSING EDUCATIONAND RESEARCH (Inst. Code - 350), THIRUVANNAMALAI",
  "ASAN MEMORIAL DENTAL COLLEGE AND HOSPITAL (Inst. Code - 501), KANCHEEPURAM",
  "C.L.BAID METHA COLLEGE OF PHARMACY (Inst. Code - 027), CHENNAI",
  "Sri Krishna College of Education",
  "MADRAS MEDICAL COLLEGE, COLLEGE OF NURSING (Inst. Code - 163), CHENNAI",
  "Rajah Serfoji Government College, Thanjavur - 613 005.",
  "Tamilavel Umamaheswaranar Karanthai Arts College, Thanjavur - 613 002.",
  "MADURAI MEDICAL COLLEGE, COLLEGE OF PHARMACY (Inst. Code - 185),  MADURAI",
  "THE STANDARD FIREWORKS RAJARATNAM COLLEGE FOR WOMEN, SIVAKASI",
  "SRI RAMAKRISHNA INSTITUTE OF PARAMEDICAL SCIENCES, COLLEGE OF PHARMACY (Inst. Code - 030),  COIMBATORE",
  "TRINITYC MISSION MEDICAL FOUNDATION, COLLEGE OF PHYSIOTHERAPY (Inst. Code - 084), MADURAI",
  "C.S.I. COLLEGE OF NURSING (Inst. Code - 550), KANNIYAKUMARI",
  "Dr.A.RAMACHANDRAN'S DOANETES HOSPITAL & INDIA  DIABETES RESEARCH FOUNDATION (Inst. Code - 433), CHENNAI",
  "EDAYATHANGUDY G.S.PILLAY COLLEGE OF PHARMACY (Inst. Code - 127),  NAGAPATTINAM",
  "J.J. College of Education",
  "E S COLLEGE OF NURSING (Inst. Code - 307), VILLUPURAM",
  "GANDHIGRAM INSTITUTE OF RURAL HEALTH AND FAMILY WELFARE TRUST (Inst. Code - 040),  DINDIGUL",
  "GOVERNMENT ARIGNAR ANNA MEMORIAL CANCER HOSPITAL (Inst. Code - 346), KANCHEEPURAM",
  "GRACE  COLLEGE OF NURSING (Inst. Code - 538), KANYAKUMARI",
  "INDIRA COLLEGE OF NURSING (Inst. Code - 237), THIRUVALLUR",
  "I.R.T. PERUNDURAI MEDICAL COLLEGE & RESEARCH CENTRE (Inst. Code - 013), ERODE ",
  "J.M. CHARITABLE TRUST (Inst. Code - 437),  KANYAKUMARI",
  "KAMALAM VISWANATHAN COLLEGE OF PHYSIOTHERAPY (Inst. Code - 174), TIRUCHIRAPALLI",
  "KARPAGAM NURSING COLLEGE (Inst. Code - 286), COIMBATORE",
  "Gandhi Arts and Science College",
  "National Arts and Science College, Trichy Road, Jayankondam, Ariyalur Dt. 621 802.",
  "A.V.P. College of Arts and Science",
  "Kathir College of Arts and Science",
  "Sri Krishna Adithya College of Arts and Science",
  "Sadasivam Kathirkamavalli College of Arts and Science, Melavasal, Mannargudi, Thiruvarur District.",
  "J.J. College of Arts & Science, Namanasamuthiram, Pudukkottai - 622 404.",
  "KMC SPECIALITY HOSPITALS (I) LTD., (Inst. Code - 355)  TRICHY",
  "MADHA COLLEGE OF NURSING (Inst. Code - 156), CHENNAI",
  "MARTIN HOMOEOPATHY MEDICAL COLLEGE  AND HOSPITAL (Inst. Code - 208), COIMBATORE",
  "Annai College of Arts & Science, Kumbakonam-612 503.",
  "Chidambaram Pillai College for Women, Manachanallur, Tiruchirappalli - 621 005.",
  "Sri Sarada Niketan College of Science for Women, Karur - 639 005.",
  "S.K. Arts and Science College, Thamaraipulam, Vedaranyam, 614 809.",
  "MERF INSTITUTE OF SPEECH AND HEARING (Inst. Code - 367), CHENNAI",
  "Imayam College of Arts & Science, Thuraiyur- 621 206.",
  "Sir Issac Newton Arts & Science College, Pappakoil Village,  Anthanapettai (Po), Nagapttinam Dt. - 611 001",
  "M.N. COLLEGE OF OPTOMETRY (Inst. Code - 373), CHENNAI",
  "NIGHTINGALE INSTITUTE OF NURSING EDUCATION (Inst. Code - 302), COIMBATORE",
  " GOVERNMENT MOHAN KUMARAMANGALAM MEDICAL COLLEGE, COLLEGE OF NURSING, (Inst. Code - 401), SALEM",
  "VIJAYA EDUCATIONAL ACADEMY (Inst. Code - 441)",
  "ARASU COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "Sri Meenakshi Vidiyal Arts And Science College",
  "MEENAKSHI ARTS And SCIENCE COLLEGE",
  "MERIT ARTS AND SCIENCE COLLEGE",
  "SRI MOOGAMBIGAI ARTS AND SCIENCE COLLEGE (WOMEN)",
  "KMC COLLEGE OF NURSING (Inst. Code - 553), TRICHY",
  "CHRISTIAN MEDICAL COLLEGE (M.Sc.(EPIDEMIOLOGY)   (Inst. Code - 180), VELLORE",
  "Paventhar Bharathidasan College of Arts & Science, Pudukkottai - 622 515.",
  "CSI KALYANI COLLEGE OF ALLIED HEALTH SCIENCES (Inst. Code - 593), CHENNAI",
  "VADAMALAYAN INSTITUTE OF MEDICAL AND ALLIED HEALTH SCIENCES (Inst. Code - 444), MADURAI",
  "Bishop Heber College, Tiruchirappalli - 620 017.",
  "Sengamala Thayaar Educational Trust Women's College, Mannargudi - 614 001.",
  "VASAN INSTITUTE OF OPHTHALMOLOGY & RESEARCH (Inst. Code - 424), CHENNAI",
  "VEECARE COLLEGE OF HEALTH SCIENCE (Inst. Code - 476), CHENNAI",
  "TCR HOSPITAL & CHARITABLE TRUST (Inst. Code - 558), KRISHNAGIRI",
  "PREETHI HOSPITAL (Inst. Code - 549), MADURAI",
  "MEENAKSHI MISSION HOSPITAL & RESEARCH CENTRE (Inst. Code - 542), MADURAI",
  "MELMARUVATHUR ADHIPARASAKTHI INSTITUTE OF MEDICAL SCIENCES AND RESEARCH (Inst. Code - 450), KANCHEEPURAM",
  "KING INSTITUTE OF PREVENTIVE MEDICINE & RESEARCH (Inst. Code - 405), CHENNAI",
  "Meenakshi Ramasamy Arts and Science College, Udaiyarpalayam, Ariyalur - 621 804.",
  "Thiru. Vi. Ka. Government Arts College, Thiruvarur - 610 003.",
  "Cambridge College of Arts and Science, Vettamangalam, Karur District-639 117.",
  "MADURAI MEDICAL COLLEGE & HOSPITAL (Inst. Code - 003), MADURAI",
  "AADHI BHAGAWAN COLLEGE OF PHARMACY (Inst. Code - 281), RANTHAM, THIRUVANNAMALAI",
  "Thai Moogambigai Dental College and Hospital",
  "Dr. M.G.R. Engineering and College",
  "Sri Ramachandra College of Allied Health Sciences",
  "Amrita School of Business, Coimbatore",
  "PONNAIYAH RAMAJAYAM INSTITUTE OF SCIENCE AND TECHNOLOGY, CHENNAI ECR/CITY CAMPUS",
  "PONNAIYAH RAMAJAYAM INSTITUTE OF SCIENCE AND TECHNOLOGY, TIRUCHIRAPPALLI - 620 009",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, PALKULAM",
  "Sri Pushpam Institute of Vocational Education and Training, 13 V.O.C. Nagar, First Street, Thanjavur - 613 007",
  "AGNI SCHOOL OF BUSINESS EXCELLENCE",
  "ANNAI MIRA COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "AR SCHOOL OF BUSINESS",
  "Navalar Na. Mu. Venkatasamy Nattar Thiruvarul Kalloori, Thanjavur - 613 003",
  "Government Law College, Vellore",
  "CHERAN COLLEGE OF ENGINEERING",
  "Bharathidasan University College, Orathanadu - 614 625",
  "Bethlahem Institute of Engineering",
  "SHANMUGA COLLEGE OF ARTS AND SCIENCE",
  "MADONNA ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "SRI VIDYA KMACHI ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "G S College of Physical Education",
  "Pasumpon Muthuramaliga Thevar College",
  "PGP College of Yoga and Research Centre",
  "K R College of Physical Education",
  "Puratchi Thalaivar Dr. MGR Government Arts and Science College",
  "Selvam College of Yoga and Research Centre",
  "DA VINCI SCHOOL OF DESIGN AND ARCHITECTURE",
  "G.KUPPUSWAMY NAIDU MEMORIAL HOSPITAL (Inst. Code - 548), COIMBATORE",
  "MISRIMAL NAVAJEE MUNOTH JAIN SCHOOL OF ARCHITECTURE",
  "SRI RAMAKRISHNA COLLEGE OF ENGINEERING",
  "CHRISTIAN MEDICAL COLLEGE (Inst. Code - 515), VELLORE",
  "CHRISTIAN MEDICAL COLLEGE (Inst. Code - 436), VELLORE",
  "Government Arts College, Ariyalur - 621 713.",
  "Jaya Sakthi Engineering College",
  "Sri Sai Ranganathan Engineering College",
  "Solamalai College of Engineering",
  "SRM TRP Engineering College",
  "ARIFA INSTITUTE OF TECHNOLOGY",
  "JEPPIAAR INSTITUTE OF TECHNOLOGY",
  "JSS College of Pharmacy",
  "Veerammal Engineering College, Dindigul",
  "ROHINI COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "SIGMA COLLEGE OF ARCHITECTURE",
  "V.V.College of Engineering",
  "V.P. Muthaiah Pillai Meenakshi Ammal Engineering College for Women",
  "THENI GOVERNMENT MEDICAL COLLEGE (Inst. Code - 240), THENI",
  "TIRUNELVELI MEDICAL COLLEGE (Inst. Code - 008), TIRUNELVELI",
  "St. ISABEL COLLEGE OF NURSING (Inst. Code - 537), CHENNAI ",
  "Agni College of Technology",
  "MOHAMED SATHAK COLLEGE OF ARTS AND SCIENCE",
  "KRP College of Education",
  "SACRED HEART COLLEGE OF NURSING (Inst. Code - 545), DINDIGUL",
  "SHREE VENKATESHWARA COLLEGE OF PARAMEDICAL SCIENCES  ",
  "Sree Abirami college of Physiotherapy",
  "SRI VIJAY VIDYALYACOLLEGE OF PHYSIOTHERAPY",
  "St TERESA ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "SIR ISSAC NEWTON COLLEGE OF PHYSIOHERAPY",
  "SREE ABIRAAMI ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "SHREE VENKATESHWARA ARTS AND SCIENCE COEDUCATION COLLEGE",
  "KARPAGAM FACULTY OF MEDICAL SCIENCES & RESEARCH (Inst. Code - 536), COIMBATORE",
  "CSI KALYANI  COLLEGE OF NURSING (Inst. Code - 546), CHENNAI",
  "SACRED HEART COLLEGE OF NURSING (Inst. Code - 323), THANJAVUR",
  "SRM TRICHY ARTS AND SCIENCE COLLEGE",
  "VELLORE INSTITUTE OF TECHNOLOGY, CHENNAI",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, CHENNAI",
  "THIAGI THARMAKKAN AMIRTHAM COLLEGE OF ARTS AND SCIENCE",
  "SATHYA COLLEGE OF ARTS AND SCIENCE, KILLVISHRAM",
  "Arun Krishna college of Arts &Science,Valaiyampattu Road,Chengam -6-6 701",
  "Don Bosco College",
  "AGNI SCHOOL OF ARCHITECTURE AND DESIGN EXCELLENCE(ASADE)",
  "PACHAMUTHU COLLEGE OF NURSING",
  "Velammal  College of Nursing",
  "Vivekananda  College  of  Education",
  "KAMALATCHI PANDURANGAN COLLEGE OF PHARMACY (Inst. Code - 115), TIRUVANNAMALAI",
  "Mother Teresa College of Education",
  "MUTHAYAMMAL COLLEGE OF ENGINEERING",
  "ALAGAPPA UNIVERSITY EVENING COLLEGE, THONDI",
  "Shri indraganesan institute of medical science college of Physiotherapy",
  "PEE GEE College of Arts & Science",
  "Viswha Bharathi Arts & Science College",
  "K.S.R. College of Arts & Science for Women",
  "ALAGAPPA UNIVERSITY EVENING COLLEGE, RAMANATHAPURAM",
  "PERIYAR UNIVERSITY PG EXT CENTRE GOVERNMENT ARTS COLLEGE CAMPUS",
  "KRISHNA ARTS AND SCIENCE COLLEGE, KATTINAYANAPALLI",
  "ADHIYAMAN ARTS AND SCIENCE COLLEGE FOR WOMEN, SRINIVASA NAGAR",
  "Government Arts College",
  "Vidhyaa Arts & Science College",
  "Annai Arts & Science College",
  "Government Arts College for Women",
  "Siri PSG Arts & Science College for Women",
  "Paavendar College of Arts & Science",
  "Pavai Arts & Science College for Women",
  "Sengunthar Arts & Science College",
  "AET Arts & Science College",
  "Subramaniam Arts & Science College",
  "Sivagamiammal College of Arts & Science",
  "Vysya College",
  "Trinity College for Women",
  "J.K.K Nataraja College of Arts & Science",
  "Kandaswami Kandars College",
  "Shri Sathya Sai college of Nursing",
  "PSN COLLEGE OF NURSING",
  "Jayalakshmi Institute of Technology",
  "KONGU NATUROPATHY AND YOGA MEDICAL COLLEGE",
  "MADRAS ENGINEERING COLLEGE",
  "GOVERNMENT MEDICAL COLLEGE KARUR",
  "SANTOSH COLLEGE OF PHYSIOTHERAPY",
  "KRISHNA PHARMACY COLLEGE",
  "BETHLEHEM COLLEGE OF ARTS AND SCIENCE",
  "ANNAI COLLEGE OF NURSING",
  "Jamal Mohamed College of Teacher Education",
  "LAKSHMI BANGARU ARTS AND SCIENCE COLLEGE",
  "Immanuel Arasar  College of Education",
  "BHARATH VIDHYA MANDHIR ARTS AND SCIENCE COLLEGE",
  "ANNAI SCHOLASTICA ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "ST PETERS NURSING COLLEGE AND RESEARCH INSTITUTE",
  "KRISHNA NATUROPATHY AND YOGA MEDICAL COLLEGE",
  "S M S COLLEGE OF ARTS AND SCIENCE SIVAKASI",
  "ST JOSEPH COLLEGE OF ARTS AND SCIENCE",
  "ANNAI COLLEGE OF NATUROPATHY AND YOGA SCIENCE",
  "SENGUNTHAR COLLEGE OF ALLIED HEALTH SCIENCES",
  "SNS COLLEGE OF PHYSIOTHERAPY",
  "SWAMY VIVEKANANDHA NATUROPATHY AND YOGA MEDICAL  COLLEGE",
  "NILGIRI COLLEGE OF ARTS AND SCIENCE, THE NILGIRIS",
  "SRI KAILASH WOMENS COLLEGE",
  "S.K.A.COLLEGE OF EDUCATION",
  "Sri Vidya Mandir Arts & Science College (Autonomous)",
  "Government  College of  Arts and Science, Arakkonam.",
  "United  Institute of Technology",
  "Srithiyagaraja Institute of Teacher education",
  "Imayam Institute of Agriculture and Technology",
  "BRILLIANT COLLEGE OF EDUCATION",
  "Arignar Anna Govt.Arts Collegefor Women,Walajapet-632513.",
  "ArakkonamArts&Science College,M.R.F.Nagar,Ichiputhur,Arakkonam-632 521",
  "Auxilium College (Autonomous)Gandhi Nagar,Katpadi-632 006",
  "D.K.M. College for Women,(autonomous )Sainathapuram-632 001",
  "Holy Cross College of Arts &Science for Women,Molakarampatti-632 521",
  "Imayam Arts &Science college,Green Land, kanavaipudur village,NEW Town Post,Vaniyambadi Road,hengam-606 701",
  "Jamia Darussalam Arabic College,Oomerabad",
  "Kaveripakkam   college   of  Arts   and  Science CollegeKaveripakkam-632 508",
  "Marudhar Kesari Jain College for Women (Autonomous), Vaniyambadi",
  "M.M.E.S. Women's Arts &Science College,Hakeem Nagar,Melvisharam-632 509",
  "Marappan Lakshiamma arts and Science  College,(co-Ed)Kurumber-635652,Tirupattur taluk.",
  "Tirupattur  Arts and Science College,SalaiNagar,VaniyambadiRoad,Tirupattur-635 506",
  "SRI SAIRAM SIDDHA MEDICAL COLLEGE & RESEARCH CENTRE (Inst. Code - 190), KANCHEEPURAM",
  "Arcot Sri Mahalakshmi Women's Institute of Management and Computer Applications, Arcot-Arni Road, Villapakkam-632521",
  "Adiparasakthi  college of arts&Science,(Autonomous),G.B.Nagar,Kalavai-632506",
  "SRI MOOKAMBIKA COLLEGE OF NURSING (Inst. Code - 137), KANNIYAKUMARI",
  "SREE MOOKAMBIKA INSTITUTE OF MEDICAL SCIENCES (Inst. Code - 242), KANNIYAKUMARI",
  "KARPAGA VINYAKA INSTITUTE OF DENTAL SCIENCES (Inst. Code - 272), KANCHEEPURAM",
  "GOVERNMENT HOMOEOPATHIC MEDICAL COLLEGE & HOSPITAL (Inst. Code - 016), MADURAI",
  "C.S.I. JAYARAJ ANNAPACKIAM COLLEGE OF NURSING (Inst. Code - 069), MADURAI",
  "CHETTINAD DENTAL COLLEGE AND RESEARCH INSTITUTE (Inst. Code - 267), KANCHEEPURAM",
  "THASIAH COLLEGE OF NURSING (Inst. Code - 299), KANNIYAKUMARI",
  "KONGUNADU COLLEGE OF NURSING (Inst. Code - 312), COIMBATORE",
  "KEERAI THAMILSELVAN COLLEG OF NURSING (Inst. Code - 322), PUDUKOTTAI",
  "KAVERY MEDICAL CENTRE AND HOSPITAL (Inst. Code - 445), TRICHY",
  "GOVERNMENT KANYAKUMARI MEDICAL COLLEGE (Inst. Code - 087), KANYAKUMARI",
  "GOVERNMENT AYURVEDA MEDICAL COLLEGE AND HOSPITAL (Inst. Code - 347), KANNIYAKUMARI",
  "GLOBAL COLLEGE OF NURSING (Inst. Code - 311), KANYAKUMARI",
  "CSI ST.LUKE  COLLEGE OF NURSING (Inst. Code - 504), TOOTHUKUDI",
  "CHRISTIAN COLLEGE OF PHYSIOTHERAPY (Inst. Code - 176), KANNIAKUMARI",
  "CHRISTIAN COLLEGE OF NURSING (Inst. Code - 187), NEYYOOR, KANNIYAKUMARI",
  "CHILD JESUS COLLEGE OF NURSING (Inst. Code - 234), TRICHIRAPALLI",
  "THANTHAI ROEVER COLLEGE OF PHARMACY (Inst. Code - 138), PERAMBALUR",
  "SRI KRISHNASAMY ARTS AND SCIENCE COLLEGE",
  "THANTHAI ROEVER COLLEGE OF NURSING (Inst. Code - 222), PERAMBALAUR",
  "SWAMI VIVEKANANDA COLLEGE OF NURSING (Inst. Code - 289), A.JETTIHALLI, DHARMAPURI",
  "SURABI SCHOOL OF NURSING (Inst. Code - 514), KARUR",
  "SURABI COLLEGE OF NURSING (Inst. Code - 502), COIMBATORE",
  "SRI VIJAY VIDHYALAYA COLLEGE OF NURSING (Inst. Code - 306), DHARMAPURI",
  "SRRI PASPO COLLEGE OF NURSING (Inst. Code - 296), DHARMAPURI",
  "PADMAVATHI COLLEGE OF NURSING (Inst. Code - 088), DHARMAPURI",
  "SIVARAJ NATUROPATHY AND YOGA MEDICAL COLLEGE (Inst. Code - 133), SALEM",
  "SHRI BHARANI COLLEGE OF NURSING (Inst. Code - 334), SALEM",
  "R.V.S. COLLEGE OF NURSING (Inst. Code - 080), SULAR, COIMBATORE",
  "P.P.G. COLLEGE OF NURSING (Inst. Code - 154), COIMBATORE",
  "PADMAVATHI COLLEGE OF PHARMACY (Inst. Code - 104), DHARMAPURI",
  "O.P.R. MEMORIAL COLLEGE OF PARA MEDICAL SCIENCES (Inst. Code - 338), CUDDALORE",
  "OM SAKTHI COLLEGE OF NURSING (Inst. Code - 324),  DHARMAPURI",
  "St.Marys College of Education, Erode",
  "St.Marys college of Education, Thoothukkudi",
  "Government Arts College, Coimbatore",
  "AISHWARYA COLLEGE OF ENGINEERING AND TECHNOLOGY, ERODE",
  "ATTHI NURSING COLLEGE",
  "ATTHI NATUROPATHY AND YOGA MEDICAL COLLEGE",
  "SUGUNA COLLEGE OF ARTS AND SCIENCE ",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE PERUMBAKKAM CHENNAI",
  "SHREE KRISHNA COLLEGE OF PHARMACY",
  "LATHA MATHAVAN ARTS AND SCIENCE COLLEGE",
  "RVS AGRICULTURAL COLLEGE",
  "GOVERNMENT COLLEGE OF ENGINEERING, BODINAYAKKANUR",
  "DHARMARATHNAKARA Dr.N.MAHALINGAM INSTITUTE. OF PARAMEDICAL SCIENCES AND RESEARCH, COLLEGE OF NURSING (Inst. Code - 216), ERODE",
  "SRI NAVAA COLLEGE OF EDUCATION",
  "CHERRAAN S  COLLEGE OF NURSING (Inst. Code - 061), COIMBATORE",
  "BILROTH COLLEGE OF NURSING (Inst. Code - 259), CHENNAI",
  "VIGNESH NURSING COLLEGE (Inst. Code - 297), TIRUVANNAMALAI",
  "VENKATESWARA NURSING COLLEGE (Inst. Code - 238), CHENNAI",
  "Dr KUMARASWAMI HEALTH CENTRE COLLEGE OF NURSING (Inst. Code - 463),  KANYAKUMARI",
  "OOA-MAVMM SCHOOL OF MANAGEMENT, MADURAI",
  "Meenakshi Medical College and Research Institute, Enathurm Kanchipuram",
  "P S R ARTS AND SCIENCE COLLEGE SIVAKASI",
  "Meenakshi College of Physiotherapy, Chennai",
  "Meenakshi College of Nursing, Mangadu, Chennai",
  "ST JOSEPH COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "Dharma Vidyaalaya College of  Education",
  "SRI LAKSHMINARAYAN COLLEGE OF EDUCATION",
  "GOVERNMENT MEDICAL COLLEGE THIRUVALLUR",
  "Annai Women's College, Aurobindo Nagar, TNPL Road, Punnamchathiram, Karur 639 136.",
  "Jamal Mohamed College, Tiruchirappalli - 620 020.",
  "Sri Sankara Arts and Science College, Neelathanallur Road, Asur, Kumbakonam, 612 501",
  "Shrimati Indira Gandhi College, Tiruchirappalli - 620 002.",
  "V.O.C. college of Education, (Aided)",
  "Thassim Beevi Abdul Kader College for Women, Kilakarai",
  "TAMILNADU THEOLOGICAL SEMINARY",
  "Sri Ramachandra Medical College and Research Institute",
  "A R M College of Engineering and Technology",
  "ARS College of Engineering",
  "Government Arts and Science College,Thondamuthur",
  "Sri Ramachandra Dental College & Hospital",
  "Sri Ramachandra College of Physiotherapy",
  "Islamiah Women's Arts and Science College, No: 10, Bye-Pass Road, Newtown, Vaniyambadi-635752",
  "Sri Ramachandra College of Pharmacy",
  "Sri Ramachandra College of Nursing",
  "SSM COLLEGE OF ARTS AND SCIENCE",
  "Sri Ramachandra College of Biomedical Sciences, Technology & Research",
  "SREE MOOKAMBIKA INSTITUTE OF MEDICAL SCIENCES ALLIED HEALTH SCIENCES",
  "KANYAKUMARI MEDICAL MISSION, CSI HOSPITAL, NEYYOOR",
  "TRICHY SRM MEDICAL COLLEGE HOSPITAL AND RESERCH CENTRE (Inst. Code - 246), TRICHY",
  "Indira Gandhi College of Education",
  "C.S Jain College of Education",
  "Cholan College of Education",
  "V.J.P. College of Education",
  "Vivekananda College of Education",
  "Varuvan Vadivelan College of Education",
  "Umamaheswaranar College of Education",
  "T.S.M. College of Education",
  "T.N.N.MEMORIAL COLLEGE OF TEACHER EDUCATION , KANNIYAKUMARI",
  "The Best College of Education",
  "Sri Rajarajeswari College of Education, Tiruchirappalli",
  "Sri Krishna College of Education",
  "Lakshmi College of Education, (Aided)",
  "THANJAVUR MEDICAL COLLEGE (Inst. Code - 005), THANJAVUR",
  "St. Antony's College of Arts and Sciences for Women,Thamaraipadi",
  "SURABI SCHOOL OF NURSING (Inst. Code - 377), DINDIGUL",
  "STANLEY MEDICAL COLLEGE & HOSPITAL (Inst. Code - 002), CHENNAI",
  "S.S.M. COLLEGE OF PHARMACY (Inst. Code - 345), ERODE ",
  "SRI SAIRAM HOMOEOPATHY MEDICAL COLLEGE (Inst. Code - 209), CHENNAI",
  "SRI SAIRAM AYURVEDA MEDICAL COLLEGE AND RESEARCH CENTRE (Inst. Code - 213), CHENNAI",
  "SRI RAMAKRISHNA DENTAL COLLEGE AND HOSPITAL (Inst. Code - 204), COIMBATORE",
  "SREE ABIRAMI HOSPITAL (P) LTD.,  (Inst. Code - 387), COIMBATORE",
  "SHENBAGHA COLLEGE OF NURSING (Inst. Code - 317), CHENNAI",
  "S THANGAPAZHAM COLLEGE OF NURSING",
  "SSM COLLEGE OF NURSING",
  "SRIVANCHI COLLEGE OF ARTS AND SCIENCE    ",
  "G T N INSTITUTE OF PARAMEDICAL AND ALLIED HEALTH SCIENCE",
  "Women's University College of Education,Kodaikanal",
  "RAGAS DENTAL COLLEGE & HOSPITAL (Inst. Code - 023), CHENNAI",
  "P.P.G. COLLEGE OF PHYSIOTHERAPY (Inst. Code - 146), COIMBATORE",
  "OMAYAL ACHI COLLEGE OF NURSING (Inst. Code - 045), CHENNAI",
  "NANDHA COLLEGE OF PHYSIOTHERAPY (Inst. Code - 098), ERODE",
  "NANDHA COLLEGE OF PHARMACY (Inst. Code - 051), ERODE",
  "NANDHA COLLEGE OF NURSING (Inst. Code - 261), ERODE",
  "MOHAMED SATHAK A.J. COLLEGE OF PHARMACY (Inst. Code - 153), CHENNAI",
  "MADRAS MEDICAL COLLEGE & HOSPITAL  (Inst. Code - 001),  CHENNAI",
  "GOVERNMENT KILPAUK MEDICAL COLLEGE (Inst. Code - 004), CHENNAI",
  "J V COLLEGE OF NURSING (Inst. Code - 319), CHENNAI",
  "JAYA COLLEGE OF PARAMEDICAL SCIENCES, COLLEGE OF PHYSIOTHERAPY (Inst. Code - 202), CHENNAI",
  "G.R. HOSPITAL (Inst. Code - 372), COIMBATORE",
  "GOVERNMENT YOGA AND NATUROPATHY COLLEGE, ARINGNAR ANNA GOVT. HOSPITAL OF INDIAN MEDICINE CAMPUS (Inst. Code - 159), CHENNAI",
  "GANGA COLLEGE OF NURSING (Inst. Code - 488), COIMBATORE",
  "THE ERODE COLLEGE OF PHARMACY (Inst. Code - 058), ERODE",
  "ELLEN COLLEGE OF NURSING (Inst. Code - 232), COIMBATORE",
  "DHANVANTRI CRITICAL CARE CENTER, ERODE HEART HOSPITAL INSTITUTE OF CLINICAL TOXICOLOGY (Inst. Code - 404), ERODE",
  "DHANVANTRI COLLEGE OF NURSING (Inst. Code - 215), ERODE",
  "JAYA COLLEGE OF PARAMEDICAL SCIENCES, COLLEGE OF PHARMCY (Inst. Code - 224), CHENNAI",
  "SRI RAMAKRISHNA INSTITUTE OF PARAMEDICAL SCIENCES, COLLEGE OF NURSING (Inst. Code - 034),  COIMBATORE",
  "ANNAI VEILANKANNI S PHARMACY COLLEGE (Inst. Code - 118), CHENNAI",
  "MOHAMED SATHAK A.J. COLLEGE OF NURSING (Inst. Code - 218), CHENNAI",
  "SRI SHANMUGHA COLLEGE OF ENGINEERING AND TECHNOLOGY, SALEM",
  "RATHINAM TECHNICAL CAMPUS, COIMBATORE",
  "DHANALAKSHMI SRINIVASAN NURSING COLLEGE",
  "GANESH COLLEGE OF ENGINEERING, SALEM",
  "School of Postgraduate Studies, Coimbatore",
  "Government Arts and Science College, Modakkurichi, Erode",
  "Sree Sowdambika College of Engineering",
  "DON BOSCO COLLEGE OF ARTS AND SCIENCE",
  "USWATHAN HASANA MAMANJI HAJI ABDUL LATHEEF WOMENS COLLEGE, PALLAPATTI",
  "CHRISTIAN MEDICAL COLLEGE, COLLEGE OF OCCUPATION THERAPHY (Inst. Code - 177),  VELLORE ",
  "CHRISTIAN MEDICAL COLLEGE (B.M.R.S.C & B.Sc.M.L.T) (Inst. Code - 178 & 179),   VELLORE ",
  "Bharathidasan University Constituent Arts & Science College (Co-education),  Nannilam, Thiruvarur District",
  "Meenaakshi Ramaswamy Engineering College",
  "Mother Terasa College of Engineering and Technology",
  "Shanmuganathan Engineering College",
  "St.Anne's College of Engineering and Technology",
  "Alagappa College of Technology Campus",
  "College of Engineering, Guindy Campus",
  "Dr. M. S. Swaminathan Agricultural College and Research Institute, Eachangkottai",
  "M.A.M. School Architecture ",
  "Prime College of Architecture and Planning ",
  "Caussanel College of Arts and Science, Muthuppettai",
  "Idhaya College for Women, Sarugani",
  "Ananda College, Devakottai",
  "Raja Doraisingam Government Arts College, Sivaganga",
  "Sri Sarada Niketan college for Women, Amaravathipudur",
  "Seethalakshmi Achi College for Women, Pallathur",
  "Dr. Umayal Ramanathan College for Women, Karaikudi",
  "Matha College of Arts and Science, Manamadurai",
  "Sethupathi Govt. Arts College, Ramanathapuram",
  "Government Arts College for Women, Ramanathapuram",
  "VSS Government Arts College, Poolankurichi",
  "Government Arts College, Paramakudi",
  "Government Arts College for Women, Sivaganga",
  "Ramasamy Tamil College, Karaikudi",
  "Alagappa Government Arts College, Karaikudi",
  "Sonai Meenal Arts and Science College,  Mudukulathur",
  "PMT Memorial college, Kamuthi",
  "Syed Hameetha Arts and Science College, Kilakarai",
  "Arumugam Pillai Seethaiammal College, Tiruppathur",
  "Madurai Sivakasi Nadar Pioneer Meenaksmi Women college, Poovanthi",
  "Sree Sevugan Annamalai College, Devakottai",
  "V.G. INSTITUTE OF PARAMEDICAL SCIENCES (Inst. Code - 391)",
  "St.Joseph college of Education, Kanniyakumari",
  "AALIM MUHAMMED SALEGH ACADEMY OF ARCHITECTURE",
  "THANTHAI ROEVER COLLEGE OF PHYSIOTHERAPY (Inst. Code - 108), TRICHIRAPALLI",
  "PPG College of Arts and Science",
  "SENGHUNDHAR COLLEGE OF PHARMACY",
  "KUMARAGURU INSTITUTE OF AGRICULTURE",
  "MANGALAM COLLEGE OF EDUCATION",
  "Government Arts and Science College(Co-Education),Avinashi",
  "SURAN COLLEGE OF NURSING (Inst. Code - 309), VIRUDHUNAGAR",
  "ST.XAVIER CATHOLIC COLLEGE OF NURSING (Inst. Code - 239), KANNIYAKUMARI",
  "SRI SANTHOSI COLLEGE OF NURSING (Inst. Code - 295), KANCHEEPURAM",
  "SRESAKTHIMAYEIL INSTITUTE OF NURSING AND RESEARCH (Inst. Code - 262), NAMAKKAL",
  "SREE RAMAKRISHNA MEDICAL COLLEGE OF NATUROPATHY AND YOGIC SCIENCES (Inst. Code - 161), KANYAKUMARI",
  "RASS ACADEMY COLLEGE OF NURSING (Inst. Code - 228), SIVAGANGA",
  "P S COLLEGE OF NURSING (Inst. Code - 301), KANYAKUMARI",
  "PRIYADARSHINI DENTAL COLLEGE & HOSPITAL (Inst. Code - 271), TIRUVALLUR ",
  "PADMASREE COLLEGE OF NURSING (Inst. Code - 287), KANCHEEPURAM",
  "NEHRU COLLEGE OF NURSING (Inst. Code - 326),  TRICHIRAPALLI",
  "MOUNT ZION COLLEGE OF NURSING (Inst. Code - 331),  PUDUKKOTTAI ",
  "MMM COLLEGE OF NURSING (Inst. Code - 291), ",
  "GEM HOSPITAL & RESEARCH CENTRE PVT. LTD., (Inst. Code - 421),  COIMBATORE",
  "GANGA MEDICAL CENTRE AND HOSPITAL PVT. LTD.,  (Inst. Code - 417), COIMBATORE",
  "DHANALAKSHMI SRINIVASAN MEDICAL COLLEGE AND HOSPITAL (Inst. Code - 455),  PERAMBALUR",
  "DHANALAKSHMI SRINIVASAN COLLEGE OF NURSING (Inst. Code - 227), PERAMBALUR",
  "CHRISTIAN MEDICAL COLLEGE (Inst. Code - 011), VELLORE",
  "CHERRAAN S  COLLEGE OF PHARMACY (Inst. Code - 116), COIMBATORE",
  "ADHIPARASAKTHI DENTAL COLLEGE AND HOSPITAL (Inst. Code - 197), KANCHEEPURAM",
  "ADHIPARASAKTHI COLLEGE OF PHARMACY (Inst. Code - 076), KANCHEEPURAM ",
  "RVS COLLEGE OF ARTS AND SCIENCE",
  "VET College of Education",
  "St.Johns college of Education, Tirunelveli",
  "Sri Balaji College of  Education",
  "SRI LAKSHMI COLLEGE OF EDUCATION",
  "R.K.R. College of Education",
  "NATIONAL COLLEGE OF EDUCATION SALEM",
  "MOTHER TERASA COLLGE OF AGRICULTURE",
  "J.K.K.NATTRAJA COLLEGE OF EDUCATION",
  "Imayam College of Education",
  "Adiparasakthi College Of Education",
  "PARVATHY'S ARTS AND SCIENCE COLLEGE",
  "Elizabeth College of Arts & Science, Annamangalam (Po), Vepanthattai (Tk.) Perambalur - 620 102.",
  "Holy Cross College, Tiruchirappalli - 620 002.",
  "A.A. Government Arts College, Musiri - 621 201.",
  "Deen College of Arts and Science, Nidur-Kaduvangudi, Aruvappadi Village, Mayiladuthurai, Nagapattinam (Dt.) - 609 203",
  "Vivekananda Arts and Science College for Women, Thenpathi, NSB Nagar, Sirkali Taluk, Nagapattinam - 609 111.",
  "Kongu College of Arts & Science, Deeran Chinnamalai Nagar, Karur - 639 006.",
  "Government College for Women, Kumbakonam - 612 001.",
  "Government Arts College, Kumbakonam - 612 001.",
  "ANNAI FATIMA INSTITUTE OF CATERING TECHNOLOGY",
  "SRI HAYAGREEVA ARTS & SCIENCE COLLEGE",
  "SREE BALAKRISHNA COLLEGE OF ARTS & SCIENCE",
  "THIAGARAJAR COLLEGE",
  "E.M.G. YADAVA WOMEN'S COLLEGE",
  "YADAVA COLLEGE",
  "INSTITUTE OF CO-OPERAGIVE MANAGEMENT",
  "V.PP. MUTHIAH PILLAI MEENAKSHI AMMAL COLLEGE (W)",
  "SUBRAMANYA COLLEGE OF ARTS & SCIENCE",
  "MADURAI KAMARAJ UNIVERSITY COLLEGE, SATTUR",
  "SRI KALISWARI COLLEGE",
  "G.T.N. ARTS COLLEGE",
  "AKILIKA HERBAL INSTITUTE",
  "FATIMA COLLEGE",
  "P.M.T. COLLEGE",
  "M.K. UNIVERSITY EVENING COLLEGE, PERIYAKULAM",
  "COLLEGE OF GANDHIAN THOUGHT",
  "THENI COLLEGE OF ARTS SCIENCE",
  "MANNAR TIRUMALAI NAICKER COLLEGE",
  "MADURAI KAMARAJ UNIVERSTIY COLLEGE, KOTTUR",
  "MADURA COLLEGE",
  "RAJAPALAYAM RAJU'S COLLEGE",
  "A.K.C. COLLEGE OF ARTS & SCIENCE",
  "PANNAIKADU VEERAMMAL PARAMASIVAM COLLEGE",
  "THE AMERICAN COLLEGE",
  "N.P.R. ARTS & SCIENCE COLLEGE",
  "P.S. MUTHU COLLEGE OF ARTS & SCIENCE",
  "N.M.S.S.V.N.COLLEGE",
  "S.B.K. COLLEGE",
  "SENTHAMARAI COLLEGE OF ARTS & SCIENCE",
  "SOURASHTRA COLLEGE FOR WOMEN",
  "THIAGARAJAR SCHOOL OF MANAGEMENT",
  "N.M.S. SERMATHAI VASAN COLLEGE FOR WOMEN",
  "MADURAI GANDHI NMR SUBBARAMAN COLLEGE FOR WOMEN",
  "WASH INSTITUTE",
  "NAZIA COLLEGE OF ARTS & SCIENCE",
  "SRI SAI BHARATH COLLEGE OF ARTS & SCIENCE",
  "K.P. NATIONAL COLLEGE OF ARTS & SCIENCE",
  "P.K.N. COLLEGE OF ARTS & SCIENCE",
  "SRI MEENAKSHI GOVERNMENT ARTS COLLEGE FOR WOMEN (AUTONOMOUS)",
  "ARUL ANANDAR COLLEGE",
  "MANGAYARKARASI  COLLEGE OF ARTS & SCIENCE FOR WOMEN",
  "M.S.S.WAKF BOARD COLLEGE",
  "RAMA PRABHA COLLEGE OF ARTS & SCIENCE",
  "THENI KAMMAVAR SANGAM COLLEGE OF ARTS & SCIENCE",
  "Sudharsan College of Arts Science, Perumanadu Village, Iluppur Taluk,Pudukkottai - 622 104.",
  "D.G. Government Arts College for Women, Mayiladuthurai - 609 001.",
  "Aadhavan Arts and Science College, Alathur Village, Chettiyappatty Panchayat, Manapparai (Tk), Tiruchirappalli - 621 306.",
  "SUBBALAKSHMI LAKSHMIPATHI COLLEGE OF SCIENCE",
  "Kalaimahal College of Arts and Science, Sembanarkoil, Tharangambadi Taluk, Naagappatinam - 609 309.",
  "Idhaya College of Women, Sakkottai, Kumbakonam 612 001.",
  "Valluvar College of Science and Management, Kodaiyur, Aravakurichi Taluk, Karur - 639 003",
  "Kachiyappa Munivar Tamizhiyal Kalloori, Umaiyalpuram Village, Sevanthilingapuram (P.O), Musiri (Tk), Tiruchirappalli (Dt.) - 621 211",
  "A.D.M. College for Women (Autonomous) , Nagapattinam - 611 001.",
  "Bharathidasan University Constituent College, Lalgudi - 621 601",
  "Auxilium College of Arts and Science for Women,Regunathapuram Village,Alangudi Taluk,Pudukkottai District - 622 302.",
  "Islahiya Arabic College, Anbu Nagar, Airport, Tiruchirappalli - 620 007.",
  "Srimad Andavan Arts & Science College, Thiruvanaikoil, Tiruchirappalli - 620 005.",
  "Best Arts and Science College, 46, Kaivilancherry Road, Thenpathi, Sirkali Taluk, Nagapattinam District-609 111.",
  "Sulthana Abdullah Rowther College for Women, Thiruvarur - 614 101.",
  "SARASWATHI NARAYANAN COLLEGE",
  "Vanavil Arts &Science College,Thayappa Gounder Street,Natrampaal-635 852",
  "Arcot Sri Mahaalakshmi Women's College",
  "Excel College of Architecture and Planning",
  "Government College of Engineering",
  "Government College of Engineering",
  "Kathir College of Engineering",
  "Bharathiyar Institute of Engineering for Women",
  "CMS College of Engineering and Technology",
  "Erode Sengunthar Engineering College",
  "Mahendra College of Engineering",
  "Ranganathan Architecture College",
  "Shree Venkateshwara Hi-Tech Engineering College",
  "SRG Engineering College",
  "ACCHUTHA INSTITUTE OF OPTOMETRY",
  "AMRITA VISHWA VIDYAPEETHAM NAGERCOIL CAMPUS",
  "AAA COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Rathnavel Subramaniam College of Arts and Science",
  "Dr MGR FISHERIES COLLEGE AND RESEARCH INSTITUTE, PONNERI",
  "RB GOTHI JAIN COLLEGE FOR WOMEN",
  "NAZARETH COLLEGE OF ARTS AND SCIENCE",
  "Shri Shankarlal Sundarbai Shasun Jain College for Women",
  "MADHA ARTS AND SCIENCE COLLEGE",
  "TAMIL NADU INSTITUTE OF LABOUR STUDIES",
  "HINDUSTAN COLLEGE OF ARTS AND SCIENCE",
  "RAJESWARI VEDACHALAM GOVT ARTS COLLEGE",
  "ETHIRAJ COLLEGE FOR WOMEN",
  "PATRICIAN COLLEGE OF ARTS AND SCIENCE",
  "ES SUBRAMANIAM MEMORIAL COLLEGE OF ARTS AND SCIENCE",
  "ANNA ADARSH COLLEGE FOR WOMEN",
  "ALPHA ARTS AND SCIENCE COLLEGE",
  "PACHAIYAPPAS COLLEGE CHENNAI",
  "MOP VAISHNAV COLLEGE FOR WOMEN",
  "GURU SHREE SHANTHI VIJAI JAIN COLLEGE FOR WOMEN",
  "KANCHI SHRI KRISHNA COLLEGE OF ARTS AND SCIENCE",
  "THIRUMURUGAN ARTS AND SCIENCE COLLEGE",
  "PRESIDENCY COLLEGE",
  "RAMAKRISHNA MISSION VIVEKANANDA COLLEGE",
  "APOLLO ARTS AND SCIENCE COLLEGE",
  "CHENNAI NATIONAL ARTS AND SCIENCE COLLEGE",
  "VIDHYA SAGAR WOMENS COLLEGE",
  "QUAID E MILLETH GOVT COLLEGE FOR WOMEN",
  "THIRUTHANGAL NADAR COLLEGE",
  "BHARATHI WOMENS COLLEGE",
  "INSTITUTE OF ENGINEERING TECHNOLOGY",
  "PROF DHANAPALAN COLLEGE FOR WOMEN",
  "KUMARARANI MEENA MUTHIAH COLLEGE OF ARTS AND SCIENCE",
  "ST LOUIS COLLEGE FOR THE DEAF",
  "PATTAMMAL ALAGESAN COLLEGE OF ARTS AND SCIENCE",
  "MAHALAKSHMI COLLEGE OF ARTS AND SCIENCE",
  "MEASI INSTITUTE OF INFORMATION TECHNOLOGY",
  "SRIRAM COLLEGE OF ARTS AND SCIENCE",
  "MEASI INSTITUTE OF MANAGEMENT",
  "CHRIST ARTS AND SCIENCE COLLEGE",
  "TMG COLLEGE OF ARTS AND SCIENCE",
  "Shrimathi Devkunvar Nanalal Bhatt Vaishnav College for Women",
  "SIVET COLLEGE",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, THIRUVOTTIYUR",
  "SSKV COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "SREE MUTHUKUMARASWAMY COLLEGE",
  "MADRAS SCHOOL OF SOCIAL WORK",
  "MADRAS CHRISTIAN COLLEGE",
  "SRIDEVI ARTS AND SCIENCE COLLEGE",
  "St. John's College of Physical Education",
  "Forest College and Research Institute",
  "Anbil Dharmalingam Agricultural College and Research Institute",
  "Horticultural College and Research Institute for Women",
  "JAINEE COLLEGE OF EDUCATION , DINDIGUL",
  "NAVODHAYA COLLEGE OF EDUCATION , KRISHNAGIRI",
  "J.P. COLLEGE OF EDUCATION , TIRUNELVELI",
  "AUXILIUM COLLEGE OF EDUCATION , VELLORE",
  "Samy College of Education, Dharmapuri",
  "Government  College of Arts & Science,pappirettipatty",
  "MOHAMMED SATHAK DASTHAGIR TEACHER TRAINING COLLEGE , RAMANATHAPURAM",
  "ANUGRAHA INSTITUTE OF SOCIAL SCIENCES, DINDIGUL",
  "SACRED HEART COLLEGE OF ARTS AND SCIENCE, DINDIGUL",
  "SRI KALISWARI INSTITUTE OF MANAGEMENT AND TECHNOLOGY, VIRUDHUNAGAR",
  "VIVEKANANDA DENAL COLLEGE FOR WOMEN (Inst. Code - 265), NAMAKKAL",
  "WHITE MEMORIAL COLLEGE OF NURSING (Inst. Code - 300), KANNIYAKUMARI",
  "RAJALAKSHMI COLLEGE OF ARTS AND SCIENCE",
  "AKSHAYA INSTITUTE OF MANAGEMENT STUDIES, COIMBATORE",
  "SAN INTERNATIONAL COLLEGE OF ARTS AND SCIENCE, COIMBATORE",
  "PONNAIYAH RAMAJAYAM INSTITUTE OF SCIENCE AND TECHNOLOGY, KUMBAKONAM-612 501",
  "SOKA IKEDA COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "MAHARANI NURSING COLLEGE ,  TIRUPPUR",
  "THIRAVIAM COLLEGE OF  NURSING (Inst. Code - 343), MOUNT JERUSALEM, THENI",
  "U.C.A. COLLEGE OF PARAMEDICAL SCIENCES (Inst. Code - 149), CHETPUT",
  "ALAGAPPA UNIVERSITY EVENING COLLEGE, THIRUPPUVANAM",
  "VIVEKANANDHA COLLEGE OF NURSING (Inst. Code - 097), NAMAKKAL ",
  "VELUMAILU SIDDHA MEDICAL COLLEGE (Inst. Code - 194), KANCHEEPURAM",
  "Sengunthar Engineering College",
  "Shreenivasa Engineering College",
  "SHREE SATHYAM COLLEGE OF ENGINEERING AND TECHNOLOGY, SALEM",
  "SNS College of Engineering",
  "Sri Venkateswara Institute of Information Technology and Management",
  "SSM College of Engineering",
  "SSM School of Management and Computer Applications",
  "Surya Engineering College",
  "Vidyaa Vikas College of Engineering and Technology",
  "Vivekanandha College of Engineering for Women",
  "Vivekanandha College of Technology for Women",
  "Vivekanandha Institute of Information and Management Studies",
  "VSA Educational and Charitable Trusts Group of Institutions",
  "V.S.B. Engineering College",
  "N.P.R. College of Engineering and Technology, Natham Village, Dindigul",
  "R V S Educational Trusts Group of Institutions, Dindigul",
  "RVS Schoool of Architecture, Dindigul",
  "SBM College of Engineering and Technology, Dindigul",
  "Sri Raaja Raajan College of Engineering and Technology, Karaikudi",
  "Sir Issac Newton College of Engineering and Technology",
  "Star Lion College of Engineering and Technology",
  "SMR East Coast College of Engineering and Technology",
  "Sri Subramanya College of Engineering and Technology,  Palani",
  "St. Michael College of Engineering and Technology, Kalayarkoil, Sivagangai Dist",
  "Sri Shakthi Institute of Engineering and Technology",
  "Sri Venkateswara College of Computer Applications and Management",
  "Tagore Institute of Engineering and Technology",
  "Tamilnadu College of Engineering",
  "Varuvan Vadivelan Institute of Technology",
  "Vasavi Vidya Trust Group of Institutions Faculty of MBA",
  "Velalar College of Engineering and Technology",
  "Bharath Niketan Engineering College, Theni",
  "Fatima Michael College of Engineering and Technology, Madurai",
  "KARAIKUDI INSTITUTE OF TECHNOLOGY AND KARAIKUDI INSTITUTE OF MANAGEMENT, KARAIKUDI",
  "K.L.N. College of Engineering Pottapalayam, Sivagangai Dist",
  "Mohamed Sathak Engineering College, Kilakarai",
  "Pandiyan Saraswathi Yadav Engineering College, Arasanoor, Sivagangai",
  "SACS MAVMM Engineering College, Madurai",
  "Thiagarajar College of Engineering, Madurai",
  "Velammal College of Engineering & Technology, Madurai",
  "National Engineering College",
  "Veterinary College and Research Institute, Orathanad",
  "Ultra College of Engineering and Technology, Madurai",
  "University College of Engineering, Dindigul",
  "Ganapathy Chettiar College of Engineering and Technology",
  "Sri Nandhanam College of Engineering and Technology",
  "St. Joseph's College of Engineering",
  "Misrimal Navajee Munoth Jain Engineering College",
  "Mohamed Sathak A.J. Academy of Architecture",
  "Mohamed Sathak A.J. College of Engineering",
  "Anand Institute of Higher Technology",
  "SMK Fomra Institute of Technology",
  "New Prince Shri Bhavani College of Engineering and Technology",
  "Maha Barathi Engineering College",
  "C. Abdul Hakeem College of Engineering and Technology",
  "Global Institute of Engineering and Technology",
  "University College of Engineering, Kancheepuram",
  "Jaya College of Engineering and Technology",
  "FISHERIES COLLEGE AND RESEARCH INSTITUTE, THOOTHUKUDI",
  "C M ANNAMALAI ARTS AND SCIENCE COLLEGE FOR WOMEN VELLATHUR",
  "Sishya Arts and Science College",
  "Puratchithalaivar Dr M G R Government Arts and Science College",
  "College of Poultry Production and Management, Hosur",
  "POLLACHI INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "SASI CREATIVE SCHOOL OF ARCHITECTURE",
  "SUGUNA COLLEGE OF ENGINEERING",
  "V.S.B COLLEGE OF ENGINEERING TECHNICAL CAMPUS",
  "VIVEKANANDA INSTITUTE OF MANAGEMENT STUDIES",
  "MADURAI SCHOOL OF MANAGEMENT",
  "VAIGAI COLLEGE OF ENGINEERING",
  "ANNAI VEILANKANNIS COLLEGE OF ARTS AND SCIENCE",
  "TAMILNADU GOVERNMENT MUSIC COLLEGE THIRUVAIYARU",
  "Tamilnadu govt music college Madurai",
  "Government College of Fine Arts",
  "Government Arts And Science College",
  "ANNAI KHADEEJA ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "PONMANA SEMMAL PURATCHI THALAIVAR MGR GOVERNMENT ARTS AND SCIENCE COLLEGE",
  "PADMASHRI Dr. SIVANTHI ADITANAR COLLEGE OF NURSING (Inst. Code - 468), THOOTHUKUDI",
  "PEDIATRIC EMERGENCY UNIT, INSTITUTE  OF CHILD HEALTH AND HOSPITAL FOR CHILDREN (MMC) (Inst. Code - 416), CHENNAI",
  "P.S.G. COLLEGE OF PARAMEDICAL SCIENCES (Inst. Code - 172), COIMBATORE",
  "THIRUVARUR GOVERNMENT MEDICAL COLLEGE AND HOSPITAL (Inst. Code - 400), THIRUVARUR",
  "KARAN ARTS AND SCIENCE COLLEGE",
  "P.S.G. COLLEGE OF PHARMACY (Inst. Code - 126), COIMBATORE",
  "REVATHI MEDICAL CENTER (Inst. Code - 500), TIRUPUR",
  "R.V.S. COLLEGE OF PHYSIOTHERAPY (Inst. Code - 081), COIMBATORE",
  "R V S DENTAL COLLEGE AND HOSPITAL (Inst. Code - 274), COIMBATORE",
  "SANKARALINGAM BHUVANESWARI COLLEGE OF PHARMACY (Inst. Code - 048), VIRUDHUNAGAR",
  "SARDAR RAJAS COLLEGE OF NURSING (Inst. Code - 396), TIRUNELVELI",
  "Dr Purathchithalaivar Government Arts and Science College",
  "ROYAL COLLEGE OF NURSING (Inst. Code - 388) , COIMBATORE",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE VEPPANTHATTAI",
  "RIGHT COLLEGE OF NURSING (Inst. Code - 293), VANAGARAM, CHENNAI",
  "R.V.S COLLEGE OF NURSING (Inst. Code - 298), KANNAMPALAYAM, COIMBATORE",
  "R.V.S. HOMOEOPATHIC MEDICAL COLLEGE (Inst. Code - 212), COIMBATORE",
  "S.A. RAJA PHARMACY COLLEGE  (Inst. Code - 099), VADAKANKULAM",
  "SERVITE COLLEGE OF NURSING (Inst. Code - 303), NAGAMANAGALAM, TRICHY",
  "RAJALAKSHMI COLLEGE OF NURSING (Inst. Code - 310), CHENNAI",
  "VIJAYA COLLEGE OF EDUCATION",
  "R.V.S. SIDDHA MEDICAL COLLEGE AND HOSPITAL (Inst. Code - 264), COIMBATORE",
  "SAKTHI COLLEGE OF NURSING (Inst. Code - 233), DINDIGUL",
  "SAKTHI COLLEGE OF NURSING (Inst. Code - 290), KARUR",
  "SARA COLLEGE OF NURSING (Inst. Code - 112), ERODE ",
  "SCHIEFFELIN INSTITUTE OF HEALTH - RESEARCH LEPROSY CENTRE (Inst. Code - 442), KARIGIRI",
  "SRI MUTHUKUMARAN MEDICAL COLLEGE HOSPITAL AND RESEARCH INSTITUTE (Inst. Code - 349), CHENNAI",
  "Dhivyam colllege of education",
  "GOVERNMENT LAW COLLEGE",
  "THOOTHUKUDI GOVERNMENT MEDICAL COLLEGE (Inst. Code - 160), THOOTHUKUDI",
  "VELLALAR COLLEGE OF NURSING (Inst. Code - 321), ERODE",
  "V V VANNIAPERUMAL NURSING COLEGE FOR WOMEN (Inst. Code - 394), VIRUDHUNAGAR",
  "WHITE MEMORIAL COLLEGE OF PHYSIOTHERAPY(Inst. Code - 192), KANNIYAKUMARI",
  "SIVAGANGAI GOVERNMENT MEDICAL COLLEGE (Inst. Code - 572), SIVAGANGAI",
  "Bharat Ratna Puratchi Thalaivar Dr MGR Government Arts and Science College",
  "Lord Jegannath College of Education",
  "C M Annamalai College of Education",
  "Government Arts and Science College (Women), Sathankulam- 628 704, Thoothukudi Dist.",
  "ARIYALUR ENGINEERING COLLEGE",
  "NELLIANDAVAR INSTITUTE OF TECHNOLOGY",
  "ARJUN COLLEGE OF TECHNOLOGY",
  "ASIAN COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Dhaanish Ahmed Institute of Technology ",
  "GOVERNMENT COLLEGE OF ENGINEERING DHARMAPURI",
  "JAINEE COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Arunachala Hitech Engineering College",
  "MANGAYARKARASI COLLEGE OF ENGINEERING",
  "AVS COLLEGE OF TECHNOLOGY ( FORMERLY AVS TECHNICAL CAMPUS)",
  "GOVERNMENT COLLEGE OF ENGINEERING THANJAVUR",
  "GOVERNMENT COLLEGE OF ENGINEERING SRIRANGAM",
  "RAMCO INSTITUTE OF TECHNOLOGY",
  "Spice Valley Teacher Education College",
  "KARPAGA VINAYA INSTITUTE OF MEDICAL SCIENCES & RESEARCH CENTRE (Inst. Code - 490), KANCHEEPURAM",
  "DHAVANTRI INSTITUTE OF MEDICAL EDUCATION AND RESEARCH ((Inst. Code - 486), ERODE",
  "SOUNDARAPANDIAN BONE AND JOINT HOSPITAL & RESEARCH INSTITUTE PVT LTD (Inst. Code - 571), CHENNAI",
  "MEDINDIA HOSPITALS (Inst. Code - 448), CHENNAI",
  "Avichi College of Arts and Science",
  "BHARATHI COLLEGE OF EDUCATION",
  "Dr.MOHAN'S  DIABETES EDUCATION ACADEMY (Inst. Code - 419), CHENNAI",
  "KASTHOORIBHA GANDHI PHARMACY COLLEGE",
  "NOBLE COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, THIRUVADANAI",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, MUDUKULATHUR",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, KADALADI",
  "R P Sarathy Institute of Technology",
  "G.KUPPUSWAMY NAIDU MEMORIAL HOSPITAL (Inst. Code - 368), COIMBATORE",
  "PGP College of Agricultural Sciences",
  "Anna Arivagam College of Education,Pochampalli ",
  "KRISHNA COLLEGE OF EDUCATION",
  "S.R.M. College of Education",
  " Vivekanandha Arts and Science College for Women,Sankari",
  "REVATHI COLLEGE OF NURSING, (Inst. Code - 623), Tiruppur",
  "KARTHIKEYAN COLLEGE OF NURSING (Inst. Code - 624), Nagapattinam",
  "SRI KRISHNA INSTITUTE OF NURSING, (Inst. Code - 620), Salem",
  "DEEPTHI COLLEGE OF NURSING, (Inst. Code -610), Namakkal",
  "THENI GOVERNMENT MEDICAL COLLEGE, COLLEGE OF NURSING, (Ins. Code - 615), Theni",
  "THIRAVIUM PARA MEDICAL COLLEGE (Inst. Code - 629), THENI",
  "Bapuji Memorial College of Education",
  "Kapi Womens College of Education",
  "Annai Madha College of Education",
  "KAPI College of Education",
  "St. Josephs college of Education, Thoothukkudi",
  "V.E.T. College of Education",
  "THIRUVALLUVAR TEACHERS EDUCATION COLLEGE",
  "St. Peters  College of Education",
  "St.Marys College of Education, Vellore",
  "SRI SAI BHARATH NURSING AND PARAMEDICAL INSTITUTE, (Inst. Code - 630), DINDIGUL",
  "St. Anthonys College of Education",
  "S.M.R. College of Education",
  "DKT COLLEGE OF EDUCATION",
  "Selvi Manivannan College of Education",
  "SRI SAI BHARATH COLLEGE OF EDUCATION BSCBED",
  "JAYARANI ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "SRI GAYATHRI COLLEGE OF EDUCATION",
  "DVJ INTEGRATED COLLEGE OF EDUCATION",
  "SRI MUTHALAMMAN ARTS AND SCIENCE COLLEGE  WOMEN",
  "SAN Academy of Architecture",
  "NANDHA ACADEMY OF ALLIED HEALTH SCIENCES",
  "NAGARATHINAM ANGALAMMAL ARTS AND SCIENCE COLLEGE",
  "BON SECOURS ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "Annai Fathima College of Education",
  "Srinivasan Institute of Medical Sciences",
  "Government Law College",
  "PS V COLLEGE OF PHARMACEUTICAL SCIENCE AND RESEARCH KRISHNAGIRI",
  "VPMM COLLEGE OF ARCHITECTURE FOR WOMEN",
  "Sapthagiri College of Engineering",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, KADAYANALLUR",
  "KAVITHAS COLLEGE OF ARTS AND SCIENCE (CO-EDUCATION)",
  "GANDHI COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "SAKTHIKAILASH WOMENS COLLEGE",
  "JAYAM ARTS AND SCIENCE COLLEGE (CO-ED)",
  "LOYOLA COLLEGE OF ARTS AND SCIENCE (CO-ED)",
  "P.S.A COLLEGE OF ATS AND SCIENCE (CO.ED)",
  "Smt. Savithri College of Education",
  "VELAMMAL MEDICAL COLLEGE HOSPITAL AND RESEARCH INSTITUTE (Inst. Code - 598)",
  "BHARATH INSTITUTE OF EDUCATION",
  "Nehru School of Architecture",
  "Mother Gnanamma Catholic College of Education",
  "VIVEKANANDHA MEDICAL CARE HOSPITAL (Inst. Code - 606), Elayampalayam",
  "Government Arts and Science College, Kovilpatti",
  "St Alphonsa College of Arts and Science",
  "Ruben College of Arts and Science",
  "Government Thiruvannamalai Medical College And Hospital",
  "SREE BHAVANI COLLEGE OF PHARMACY",
  "EXCEL HOMOEOPATHY MEDICAL COLLEGE",
  "Kalaimagal College of Arts and Science",
  "Cherraans Arts Science College",
  "Government college of Arts & Science,Mettur",
  "Government  College of Arts & Science,Harur",
  "GRD COLLEGE OF PHARMACY",
  "ST MARIAM COLLEGE OF ALLIED HEALTH SCIENCE",
  "ST MARIAM COLLEGE OF NURSING",
  "SRI JAYENDRA SARASWATHI INSTITUTE OF OPTOMETRY",
  "HINDUSTHAN COLLEGE OF HEALTH SCIENCES",
  "NOVA COLLEGE OF EDUCATION",
  "IMMANUEL ARASAR COLLEGE OF PHARMACY",
  "SRI VIJAY VIDYALAYA COLLEGE OF ARTS AND SCIENCE",
  "UNITED COLLEGE OF NURSING",
  "SIR C V RAMAN COLLEGE OF ARTS AND SCIENCE",
  "MARIA AYURVEDA MEDICAL COLLEGE AND HOSPITAL (Inst. Code - 651)",
  "THUVARAGA COLLEGE OF EDUCATION",
  "J.K College of Education",
  "PONNUSAMY NADAR COLLEGE OF ARTS AND SCIENCE",
  "DON BOSCO ARTS AND SCIENCE COLLEGE ",
  "JP COLLEGE OF EDUCATION",
  "NANDHANAM HEALTH SCIENCES COLLEGE",
  "JAYA SCHOOL OF ARCHITECTURE",
  "GOVERNMENT MEDICAL COLLEGE, OMANDURAR ESTATE (Inst. Code -        )",
  "Dr. JEYASHEKARAN MEDICAL TRUST SCHOOL OF ALLIED HEALTH SCIENCE (Inst. Code - 633)",
  "SHRI SAKTHIKAILASSH WOMEN'S COLLEGE SALEM",
  "Sri Adhisankarar College of Education",
  "SRI SATHGURU SANGEETHA VIDYALAYAM",
  "ANNAI VIOLET ARTS AND SCIENCE COLLEGE",
  "Holy Angels School of Business",
  "INDIAN INSTITUTE OF HANDLOOM TECHNOLOGY, SALEM",
  "NADAR SARASWATHI COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "SURYA COLLEGE OF ENGINEERING",
  "P.S.R.R College of Engineering (Formerly P.S.R.Rengasamy College of Engineering for Women)",
  "Central Institute of Petrochemicals Engineering and Technology (Formerly Central Institute of Plastics Engineering and Technology)",
  "K.S.R. Institute Of Dental Science And Research, Tiruchengode",
  "Sri Ramakrishna Mission Vidyalaya College of Education, (Autonomous)",
  "DRBCCC HINDU COLLEGE",
  "ST THOMAS COLLEGE OF ARTS AND SCIENCE",
  "Vidyasagar College of Arts and Science",
  "CARDAMOM PLANTERS ASSOCIATION  COLLEGE",
  "VIVEKANANDA COLLEGE",
  "Dr.Sivanthi Aditanar College of Education",
  "M.A.M. B. School",
  "Marthandam College of Engineering and Technology",
  "Mangalam College of Education",
  "Sri Sarada College of Education, (Autonomous)",
  "Dr. S.R.J. College of Education",
  "UNIVERSAL COLLEGE OF EDUCATION ",
  "SHRI SATHYA SAI MEDICAL COLLEGE AND RESEARCH INSTITUTE",
  "RVS Kumaran Arts and Science College",
  "Sri Ramanas College of Arts and Science For Women",
  "SNS COLLEGE OF NURSING",
  "SIR ISSAC NEWTON  NATUROPATHY AND YOGA MEDICAL COLLEGE",
  "SNS COLLEGE OF ALLIED HEALTH SCIENCES",
  "EINSTEIN COLLEGE OF ARTS AND SCIENCE",
  "Edayathangudy G.S. Pillay Arts & Science College, Nagapattinam - 611 002",
  "PGP COLLEGE OF PHYSIOTHERAPY AND RESEARCH INSTITUTE ",
  "SVST KONGUNAD ARTS AND SCIENCE COLLEGE (Co-Ed)",
  "Kongu School of Architecture",
  "GEETHA JEEVAN ARTS AND SCIENCE COLLEGE",
  "Mary Matha College of Arts and Science (Co-Education)",
  "Prathyusha Engineering College",
  "Kunthavai Naacchiyaar Government Arts College for Women (Autonomous), Thanjavur - 613 007.",
  "NATIONAL INSTITUTE FOR THE EMPOWERMENT OF PERSONS WITH VISUAL DISABILITIES",
  "CHRISTIAN MEDICAL COLLEGE, COLLEGE OF PHYSIOTHERAPY,  (Inst. Code - 169), VELLORE",
  "ISHWAR INSTITUTE OF PROSTHETICS & ORTHOTICS (A UNIT OF INTERNATIONAL SOCIETY FOR HUMAN WELFARE & REHABILITATION) (Inst. Code - 533), CHENNAI",
  "THE MADRAS MEDICAL MISSION, (Inst. Code - 415), CHENNAI",
  "V.G HOSPITAL (VGH) INDIAN INSTITUTE OF LAPOROSCOPIC SURGERY RESEARCH TRAINING CENTRE (Inst.code - 413)",
  "SARADA KRISHNA HOMOEOPATHIC MEDICAL COLLEGE (Inst. Code - 207), KANNIYAKUMARI",
  "ST.JOHN'S  COLLEGE OF  NURSING (Inst. Code - 191), VELLORE",
  "INTERNATIONAL CENTRE FOR CARDIO THERACIC AND VASCULAR DISEASES, Dr.K.M.CHERIAN HEART FOUNDATION, FRONTIER LIFE PVT.,LTD., (Inst. Code - 363),  CHENNAI",
  "Faculty of  Dentistry",
  "SCHOOL OF ARCHITECTURE, St.PETERS COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Morning Star Arts and Science College for Women - Pasumpon.",
  "St.Josephs Arts and Science College for Women ",
  "RAJA COLLEGE OF ARTS AND SCIENCE",
  "V.T.M. College of Arts and Science, Arumanai - 629 151, Kanyakumari Dist",
  "OUR LADY OF HEALTH COLLEGE OF NURSING (Inst. Code - 305), THANJAVUR",
  "STELLA MARYS COLLEGE OF ENGINEERING",
  "DR AMBEDKAR GOVT ARTS COLLEGE",
  "BISHOP'S  COLLEGE OF NURSING (Inst. Code - 065), DHARAPURAM, TIRUPPUR",
  "G.Venkataswamy Naidu College, Kovilpatti - 628 502, Thoothukudi Dist.",
  "Sri Jeyandra Saraswathy Maha Vidyalaya College of Arts & Science",
  "Maharani Arts and Science Women's College",
  "AJK College of Arts and Science",
  "J.J. College of Education",
  "DR. JEYASEKARAN COLLEGE OF NURSING, KANYAKUMARI",
  "P.D.R.T. PADMAVATHI ARTS AND SCIENCE COLLEGE (WOMEN)",
  "UNIQUE COLLEGE OF ARTS AND SCIENCE ",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE",
  "St. Charles College of Education",
  "K.S.K. College of Education",
  "Arulmurugan College of Engineering",
  "ST. JOSEPH'S INSTITUTE OF TECHNOLOGY",
  "SANKARA SCHOOL OF VEDHIC SCIENCES",
  "ARULMIGU PALANIANDAVAR  COLLEGE OF ARTS & CULTURE, PALANI",
  "E.G.S.Pillay Engineering College",
  "SRI MUTHUKUMARAN ARTS AND SCIENCE COLLEGE",
  "Bon Secours Arts  and  Science College for Women",
  "THEIVANAI INSTITUTE OF BUSINESS MANAGEMENT",
  "Sri Shanmugha College of Pharmacy ",
  "SRINIVASAN COLLEGE OF PHARMACEUTICAL SCIENCES",
  "SNS College of Pharmacy and Health Sciences",
  "MEENAKSHI COLLEGE OF NURSING ",
  "MAILAM NURSING COLLEGE",
  "Scudder College of Nursing  Ranipet",
  "TAGORE COLLEGE OF NURSING",
  "MARIA SIDDHA MEDICAL COLLEGE AND HOSPITAL",
  "Hindusthan School of Architecture",
  "ARUNAI COLLEGE OF PHARMACY",
  "VP COLLEGE OF PARAMEDICAL SCIENCES",
  "NALANDA SCHOOL OF BUSINESS",
  "A Dr Vimal College of Nursing",
  "sree abirami college of pharmacy",
  "KLN Arts and Sciences College",
  "Good Shepherd College of Engineering and Technology",
  "ULTRA ARTS AND SCIENCE COLLEGE",
  "Aksheyaa College Of Arts and Science",
  "JKK MUNIRAJAH MEDICAL RESEARCH FOUNDATION ANNAI JKK SAMPOORANI AMMAL COLLEGE OF ALLIED HEALTH SCIENCES",
  "Government Medical College Pudukkottai",
  "EXCEL SIDDHA MEDICAL COLLEGE AND RESEARCH CENTER",
  "PSY ARTS AND SCIENCE COLLEGE",
  "APOLLO COLLEGE OF PHARMACY",
  "Glanis Institute of Allied Health Sciences",
  "KMCH INSTITUTE OF HEALTH SCIENCES AND RESEARCH",
  "GRT INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
  "Christopher Arts and Science College Surangudi",
  "TAGORE COLLEGE OF PHARMACY",
  "sri shanmugha college of nursing for women ",
  "DHARAN NURSING COLLEGE  ",
  "Smt Gandhimathi College of Pharmacy",
  "DHANALAKSHMI SRINIVASAN ARTS AND SCIENCE COLLEGE",
  "S A COLLEGE OF ARTS AND SCIENCE",
  "KPR College of Arts Science and Research",
  "M.V.Muthiah Government Arts College for Women, Dindigul",
  "PURATCHI THALAIVAR DR.M.G.R ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "ARUMUGHAM PALANIGURU ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "QUEENS COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "NANDHA  SIDDHA MEDICAL COLLEGE AND HOSPITAL",
  "NANDHA AYURVEDA MEDICAL COLLEGE AND HOSPITAL",
  "SIR ISSAC NEWTON COLLEGE OF NURSING",
  "RAJALAKSHMI SCHOOL OF ARCHITECTURE",
  "Syed Ammal Arts and Science College, Ramanathapuram",
  "CARE COLLEGE OF ARTS AND SCIENCE",
  "ARUNACHALA ARTS AND SCIENCE WOMEN COLLEGE",
  "UNNAMALAI COLLEGE OF ARTS AND SCIENCE",
  "UNITED COLLEGE OF ARTS AND SCIENCE",
  "AMRITA VISHWA VIDYAPEETHAM CHENNAI CAMPUS",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "PET ARTS AND SCIENCE COEDUCATION COLLEGE ",
  "Paavendhar College of Education",
  "KAVI COLLEGE OF EDUCATION",
  "Dr. Meenakshi College of Teacher Education",
  "K.S.Rangasamy College of Arts and Science (Autonomous)",
  "ARAVINDHAR AGRICULTURAL INSTITUTE OF TECHNOLOGY",
  "RVS PADMAVATHI AMMAL COLLEGE OF PHARMACY KANNAMPALAYAM",
  "S A V SAHAYA THAI ARTS AND SCIENCE (WOMEN) COLLEGE",
  "ADITHYA COLLEGE OF ARTS AND SCIENCE",
  "SIR ISSAC NEWTON COLLEGE OF PHARMACY",
  "ANNAI COLLEGE OF PHYSIOTHERAPY",
  "JSA MEDICAL COLLEGE FOR SIDDHA AND RESEARCH CENTRE",
  "GOVT ARTS AND SCIENCE COLLEGE  SIVAKASI",
  "PANIMALAR COLLEGE OF NURSING",
  "ALAGAPPA COLLEGE OF NURSING ",
  "PANIMALAR MEDICAL COLLEGE HOSPITAL AND RESEARCH INSTITUTE",
  "SRI VIJAY VIDYALAYA COLLEGE OF PHARMACY",
  "PKB COLLEGE OF NURSING",
  "S THANGAPAZHAM MEDICAL COLLEGE OF NATUROPATHY AND YOGIC SCIENCE RESEARCH CENTRE",
  "MAYOR RADHAKRISHNAN COLLEGE OF PHARMACY",
  "EXCEL NURSING COLLEGE",
  "RATHINAAM COLLEGE OF NURSING",
  "SRM TRICHY COLLEGE OF NURSING",
  "COLLEGE OF AGRICULTURAL SCIENCE",
  "SRI VENKATESWARAA NURSING COLLEGE",
  "UNITED COLLEGE OF MEDICAL SCIENCES ",
  "PAAVAI INSTITUTE OF ALLIED HEALTH SCIENCE",
  "RVS PADMAVATHY COLLEGE OF ALLIED HEALTH SCIENCES ",
  "CARE College of Engineering (Formerly CARE Group of Institutions)",
  "CHRISTIAN FELLOWSHIP HOSPITAL, ODDANCHATRAM, DINDIGUL",
  "PPG COLLEGE OF PHARMACY",
  "SRM Valliammai Engineering College",
  "S. THANGAPAZHAM AGRICULTURAL COLLEGE",
  "SRI.K.RAMACHANDRAN NAIDU COLLEGE OF NURSING (Inst. Code - 136), TIRUNELVELI",
  "Sri Muppudathi Amman College of Education",
  "C.A.R.E School of Architecture",
  "Christian College of Engineering and Technology",
  "DR AMBEDKAR GOVERNMENT LAW COLLEGE PUDUPAKKAM",
  "MUTHUKARUPPAN MEMORIAL ARTS AND SCIENCE COLLEGE",
  "J.K.K. NATTRAJA DENTAL COLLEGE & HOSPITAL, ((Inst. Code - 596), NAMAKKAL",
  "MUTHUKARUPPAN MEMORIAL COLLEGE OF EDUCATION",
  "KAMARAJ WOMENS COLLEGE THOOTHUKUDI",
  "VINAYAGA COLLEGE OF ARTS AND SCIENCE FOR WOMEN",
  "Arulmigu Subramania Swamy Arts and Science College, Vilathikulam",
  "GP PHARMACY COLLEGE",
  "BHARATHIDASAN UNIVERSITY CONSTITUENT MODEL ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "BETHLAHEM COLLEGE OF NURSING",
  "PRANA INSTITUTE OF ALLIED MEDICAL SCIENCES",
  "ARULMIGU ARTHANAREESWARAR ARTS AND SCIENCE COLLEGE",
  "SWAMY VIVEKANANDHA PHYSIOTHERAPY COLLEGE",
  "SENGUNTHAR COLLEGE OF NURSING",
  "MOTHER TERASA COLLEGE OF PHARMACY",
  "GOVERNMENT MEDICAL COLLEGE KALLAKURICHI",
  "MARIA COLLEGE OF PHYSIOTHERAPY",
  "SHRI BARANI HOMOEOPATHY MEDICAL COLLEGE ",
  "GOVERNMENT MEDICAL COLLEGE TIRUPPUR",
  "GOVERNMENT MEDICAL COLLEGE KRISHNAGIRI",
  "ANNA VINAYAGAR COLLEGE OF ARTS AND SCIENCE",
  "GOVERNMENT MEDICAL COLLEGE DINDIGUL  ",
  "MANNAI NARAYANASAMY PARAMEDICAL COLLEGE THANJAVUR, THANJAVUR",
  "SWAMY VIVEKANANDHA MEDICAL COLLEGE HOSPITAL AND RESEARCH INSTITUTE",
  "MOTHER TERASA COLLEGE OF NURSING",
  "KANCHI SRI MAGALAKSHMI ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "REVATHI INSTITUTE OF PHYSIOTHERAPY",
  "P S G PONNAMMAAL COLLEGE OF NURSING",
  "MAHENDRA COLLEGE OF ALLIED HEALTH SCIENCE",
  "JAI SAI RAM ARTS AND SCIENCE COLLEGE",
  "Govt., Arts College for Women, Nilakottai",
  "TAMIL NADU HORTICULTURE MANAGEMENT INSTITUTE, MADHAVARAM",
  "COLLEGE OF MANAGEMENT STUDIES, SRI VENKATESWARAA UNIVERSITY",
  "JAYA AGRICULTURAL COLLEGE",
  "GOVERNMENT MEDICAL COLLEGE, NAGAPATTINAM",
  "AGRICULTURAL COLLEGE AND RESEARCH INSTITUTE, KARUR",
  "VIKRAM COLLEGE OF NURSING, MADURAI",
  "ANNAI MEENAKASHI COLLEGE OF EDUCATION",
  "FACULTY OF MEDICINE, SRI LALITHAMBIGAI MEDICAL COLLEGE AND HOSPITAL",
  "KONGUNADU INTEGRATED COLLEGE OF EDUCATION",
  "SINDHI COLLEGE",
  "ST THERESAS ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "SASURIE COLLEGE OF NURSING AND RESEARCH",
  "Poompuhar College, Melaiyur",
  "SRE RAMANA COLLEGE OF EDUCATION",
  "Aravindhar College of Education",
  "Government College of Fine Arts, Kumbakonam - 612 001.",
  "Emerald Heights College for Women",
  "Kennedy College of Education",
  "SREE BHAVANI COLLEGE OF EDUCATION",
  "St. Aloysius College of Education",
  "HAJI S.M.S.SHAIK JALALUDEEN B.ED. COLLEGE , THANJAVUR",
  "Mahathma College of Education",
  "Sree Krishna College of Education",
  "Jayam College of Education",
  "VALLALAR COLLEGE OF EDUCATION,  COLLEGE CODE 10429",
  "VPN College for Teacher Education",
  "Matha College of Teacher Education",
  "ARM COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "ARS COLLEGE OF ENGINEERING",
  "CHETTINAD SCHOOL OF OCCUPATIONAL THERAPY",
  "CHERAN S COLLEGE OF ALLIED HEALTH SCIENCES",
  "PALLAVAN PHARMACY COLLEGE KANCHEEPURAM , KANCHEEPURAM",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE FOR WOMEN, ALANGULAM",
  "TAGORE COLLEGE OF PHYSIOTHERAPY",
  "S.B.G. Sanskrit Mission B.Ed., College",
  "SIMPRA COLLEGE OF EDUCATION, SENGIPATTI",
  "VETERINARY COLLEGE AND RESEARCH INSTITUTE, THENI",
  "VETERINARY COLLEGE AND RESEARCH INSTITUTE, SALEM",
  "VETERINARY COLLEGE AND RESEARCH INSTITUTE, UDUMALPET",
  "INSTITUTE OF AGRICULTURE",
  "JSA COLLEGE OF AGRICULTURE AND TECHNOLOGY",
  "PARAPROFESSIONAL INSTITUTE OF INDUSTRIAL FISHING TECHNOLOGY",
  "PARAPROFESSIONAL INSTITUTE OF AQUACULTURE TECHNOLOGY",
  "GOVERNMENT LAW COLLEGE, KARAIKUDI, SIVAGANAGAI  DISTRICT",
  "SAI SAKTHI COLLEGE OF NURSING ",
  "STUDY WORLD  COLLEGE OF ALLIED HEALTH SCIENCE",
  "GOVERNMENT LAW COLLEGE, VILLUPURAM",
  "R L INSTITUTE OF NAUTICAL SCIENCES",
  "INDRA GANESAN COLLEGE OF ARTS AND SCIENCE",
  "THALAPATHY K VINAYAKAM WOMENS ARTS AND SCIENCE COLLEGE",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE DHARAPURAM",
  "CENTRE OF EXCELLENCE FOR VEGETABLES, REDDIYARCHATRAM, DINDIGUL",
  "HORTICULTURE RESEARCH AND TRAINING CENTRE, THALLY, KRISHNAGIRI DISTRICT",
  "SHRI INDRA GANESAN INSTITUTE OF MEDICAL SCIENCE NATUROPATHY AND YOGA MEDICAL COLLEGE MANIKANDAM TRICHY DISTRICT",
  "Raadhaa College of Education",
  "COIMBATORE MARINE COLLEGE",
  "CHENNAI COLLEGE OF ARTS AND SCIENCE",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE, THALLY",
  "Government College of Engineering, Erode",
  "SURYA SCHOOL OF ARCHITECTURE",
  "HIMT COLLEGE",
  "Angel College of Education",
  "Dr. Vellasamy Nadar College of Education",
  "SUDHA SASEENDRAN SIDDHA MEDICAL COLLEGE AND HOSPITAL, MECODE, KALIYAKKAVILAI    ",
  "K S RANGASAMY COLLEGE OF PHARMACY    ",
  "EINSTEIN COLLEGE OF NURSING    ",
  "CHERRAAN COLLEGE OF TECHNOLOGY",
  "GLOBAL COLLEGE OF ARTS AND SCIENCE",
  "BALAGAN SARASWATHI ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "KARPAGA VINAYAGA INSTITUTE FOR PHARMACEUTICAL SCIENCES",
  "CHENNAI INSTITUTE OF TECHNOLOGY AND APPLIED RESEARCH",
  "SAI INSTITUTE OF NURSING EDUCATION    ",
  "E.S. COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "KANGEYAM INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH    ",
  "DR MKL NURSING COLLEGE",
  "ST PETERS PHARMACY COLLEGE AND RESEARCH INSTITUTE",
  "RATHINAM COLLEGE OF PHARMACY",
  "BHAVANI COLLEGE OF NURSING",
  "NANDHA MEDICAL COLLEGE AND HOSPITAL",
  "SRI RENGESWARAR COLLEGE OF NURSING",
  "PACHAMUTHU COLLEGE OF PHYSIOTHERAPY",
  "ST MARYS COLLEGE OF NURSING ",
  "ST MARYS COLLEGE OF HEALTH SCIENCE",
  "VCAHS VELAMMAL MEDICAL COLLEGE HOSPITAL  RESEARCH INSTITUTE ",
  "PGP INSTITUTE OF ALLIED HEALTH SCIENCES",
  "RANGAPOOPATHI NURSING COLLEGE, VILLUPURAM",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE TC KOOT ROAD VANUR ",
  "Aarupadai Veedu Institute of Technology",
  "Vinayaka Mission's College of Physiotherapy",
  "ST ANTONY S COLLEGE OF NURSING",
  "JAI RAADHA INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH",
  "St.Joseph College of Arts  & Science  College,Autonomous),Cuddalore- 607001",
  "KAMARAJAR COLLEGE OF PHARMACY",
  "Aries arts And Science College for women,Karunkuzhi, Vadalur-607 303",
  "Arignar Anna Govt. Arts College, Villupuram-605 602",
  "Bharathi Women's Arts &Science College ,Thatghur,Kaalakurugchi-606 202",
  "Valliammai College of Arts & Science ,Villupuram Main Road,Vadakarai Thazhanoor,tirukoilur-605 752",
  "B.Padmanabhan Jayanthimala College of Arts &Science ,Kozhai Nizangan,Srimushnam-608 703",
  "BWDA Arts & Science College,Kolliyangunam,Mailam,Tindivam-604 304",
  "CSM College of Arts &Science ,Erumanoor Road,Virudachalam-6-6 001",
  "Dr M G R Government Arts and Science College for Women ",
  "DR R K SHANMUGAM COLLEGE OF ARTS & SCIENCE, VILLUPURAM",
  "Dr.S.Ramadoss Arts & Science College ,Periyavadavadi-Virudachalam-606 104",
  "E S ARTS AND SCIENCE COLLEGE Co Education",
  "GOVERNMENT ARTS AND SCIENCE COLLEGE RISHIVANDIYAM",
  "Government Arts College, Chidambaram-608 102",
  "Government  Arts &Science Colllege ,Thiruvannainallur,Tirukoilur-607 203",
  "Puratchi Thalaivi Amma Government Arts and Science College, Palladam",
  "AGURCHAND MANMULL JAIN COLLEGE",
  "PACHAIYAPPAS COLLEGE FOR MEN",
  "JAYAGOVIND HARIGOPAL AGARWAL AGARSEN COLLEGE",
  "Amerda Vikas College of Education",
  "AVB COLLEGE OF PHARMACY",
  "ALADI ARUNA COLLEGE OF LIBERAL ARTS AND SCIENCE",
  "DISCOVER COLLEGE OF ARTS AND SCIENCE",
  "BETHLAHEM INSTITUTE OF MEDICAL SCIENCES, NADUTHERI, KARUNGAL, KANYAKUMARI ",
  "BETHLAHEM COLLEGE OF PHARMACEUTICAL SCIENCES",
  "PSP MEDICAL  COLLEGE HOSPITAL  AND  RESEARCH  INSTITUTE ",
  "MAHALAKSHMI COLLEGE OF NURSING",
  "ANNAI COLLEGE OF EDUCATION",
  "NOORUL ISLAM COLLEGE OF ENGINEERING AND TECHNOLOGY ",
  "SCHOOL OF ALLIED HEALTH SCIENCES, VMRFDU, SALEM",
  "VINAYAKA MISSIONS COLLEGE OF PHYSICAL EDUCATION",
  "INSTITUTE OF FISHERIES BIOTECHNOLOGY",
  "SUN COLLEGE OF PHARMACY AND RESEARCH CENTRE",
  "GOVERNMENT  ARTS  AND SCIENCE COLLEGE SRIVILLIPUTTUR",
  "SMK COLLEGE OF ARTS AND SCIENCE COLLEGE FOR WOMEN",
  "THE KAAVERY NURSING COLLEGE MECHERI",
  "OM SHANTI ARTS AND SCIENCE COLLEGE",
  "SRM Madurai College for Engineering and Technology",
  "DR VS ISAAC ARTS SCIENCE COLLEGE",
  "MAHALAKSHMI COLLEGE OF ALLIED HEALTH SCIENCE",
  "RATHINAM SCHOOL OF BUSINESS AT TIPS GLOBAL (FORMERLY TIPS SCHOOL OF MANAGEMENT)",
  "EXCEL MEDICAL COLLEGE FOR NATUROPATHY AND YOGA",
  "AL  AMEEN ARTS AND SCIENCE COLLEGE FOR WOMEN,KUMBAKONAM    ",
  "UNITED COLLEGE OF PHARMACY",
  "SHREE VENKATESHWARA COLLEGE OF PARAMEDICAL SCIENCES ",
  "AMC COLLEGE OF ALLIED HEALTH SCIENCES ",
  "TAMIL ISAI KALLOORI",
  "IMMACULATE COLLEGE OF NURSING",
  "DHANALAKSHMI SRINIVASAN PHARMACY AND RESEARCH INSTITUTE    ",
  "Community Science College and Research Institute",
  "Muthayammal College of Arts & Science",
  "Pachamuthu College of Arts & Science for Women",
  "Sri Sarada Nicketan College of Arts & Science for Women",
  "SSM College of Arts & Science",
  "Laxminarayana Arts & Science College for Women",
  "Government Arts College(Autonomous),Salem-7",
  "Selvamm Arts & Science College",
  "Institute of Advanced Study in Education",
  "CK College of Education",
  "M A K COLLEGE OF ARTS AND SCIENCE FOR WOMEN    ",
  "L N COLLEGE OF PHARMACY",
  "Sri Renugambal college of Physical Education",
  "Christian College of Physical Education",
  "Meenachi College of Physical Education",
  "Koviloor Andavar College of Physical Education",
  "Sri Sarada College of Physical Education for Women",
  "ST PETERS COLLEGE OF ALLIED HEALTH SCIENCE AND RESEARCH INSTITUTE    ",
  "SRI SAI SINDHU COLLEGE OF NURSING ",
  "ST MARYS INSTITUTE OF NURSING",
  "SALIM ALI CENTRE FOR ORNITHOLOGY AND NATURAL HISTORY    ",
  "Mahalakshmi Tech Campus",
  "THAMIRABHARANI ENGINEERING COLLEGE, TIRUNELVELI",
  "Kasturiba Gandhi Jal (Spain) College of Education for Women",
  "Vettri Vel College of Education",
  "ST.XAVIER COLLEGE OF NURSING (Inst. Code - 392), THANJAVUR ",
  "SRI SAKTHI AMMA INSTITUTE OF ALLIED HEALTH SCIENCES, (SRI NARAYANI HOSPITAL AND RESEARCH CENTE) (Inst. Code - 423) VELLORE",
  "Vidyalaya College of Education",
  "M.K.Raman College of  Education",
  "Andavar College of Education",
  "SRI NARAYANI COLLEGE OF NURSING (Inst. Code - 236), VELLORE",
  "Hindusthan College of Education",
  "Vidhya Sagar Women's College of Education",
  "Shakthi Kailash College of Education for Women",
  "D.V.C. College  of Education",
  "Kandhaswamy College of Education",
  "Sri Rengeswarer College of Education",
  "Dhanam College of Education",
  "Sri Sarada College of Education for Women",
  "Mahatma Gandhi College of Education",
  "St.Annes College of Education for  Women",
  "Menakshi Ramasamy College of Education",
  "Arunachala College of Education",
  "JSR College of Education",
  "Holy Trinity College of Education",
  "Dr.David Raja & Dr.Chandralekha College of Education",
  "Kalaimagal College of Education",
  "Sri Muthukumaran College of Education",
  "E.S.Subramaniam Memorial College of Education",
  "Vivekananda Vidyalaya College of Education",
  "Christian college of Education",
  "Kathir College of Education",
  "Thalapathy  College of Education",
  "Kumutha College of Education",
  "Nadar Saraswathi College of Education",
  "Keerrai Thamil Selvan College of Education  for Women",
  "Vadaranyam College of Education",
  "Arumugam Nallamani College of Education",
  "Bharathi College of Education",
  "MVM Chellamuthu Alagu Rathinam College of Education",
  "KSR College of Education",
  "Bishop Appasamy College of Education",
  "Seventh Day Adventist Reform Movement (SRM) College of Education",
  "Angels College of Education",
  "Thiagarajar College of Preceptors, (Aided)",
  "Sree Arumugham Teacher Training College",
  "Vijay College of Education",
  "Shri Vidhya Mandhir College of Education",
  "James college of Education",
  "Thiagarajar College of Education",
  "Punitha Valanar College of Education",
  "Thanthai Hans Roever College of Education",
  "Muna College of Education",
  "Rajas College of Education",
  "Sri Amirtha College of Education",
  "Pope John Paul II College of Education",
  "Anna Vinayagar College of Education",
  "Jeevan College of Education",
  "Shree Ragavendra College of Education",
  "Amritalaya College of Education",
  "Idhayaam College of Education",
  "Dhivya College of Education",
  "Lakshmi Ammal College of Education",
  "St. John De Britto College of Education",
  "Siddhartha College of Teacher Education",
  "St. Basil College of Education for Women",
  "Parasakthi College of Education",
  "Arun College of Education",
  "Theni Kammavar Sangam College of Education",
  "Sri Vidya Mandir College of Education, Namakkal",
  "Rev.John Thomas college of Education for women",
  "Ruby College of Preceptors",
  "Sri Vekkaliamman College of Education",
  "Maharani College of Education",
  "Pachamuthu College of Education",
  "Lakshmi Ammal College of  Education",
  "Sri Venkatachalapathy College of Education",
  "Thirumal College of Education",
  "Arasan Ganesan College of Preceptors",
  "Holy Cross College of Education",
  "Sri Venglamani Amman College of Education",
  "Bharath College of Education",
  "Bharath College of Education",
  "Thavathiru Kundrakudi Adigalar College of  Education for Women",
  "G.V.C. College of Education",
  "Sri Raaja Raajan College of Education",
  "SCAD college of Education",
  "Annai Fathima College of Education",
  "Mother Teresa College of Education for (w)",
  "K.K.S.  Mani College of Education",
  "Sri Balaji College of Education for Women",
  "Sathyasai B.Ed. College",
  "G.E.T. B.Ed  College of Education",
  "TVS Teacher Training Academy",
  "Sri Ganesh College of Education",
  "ERK College of Education",
  "Stella Matutina College of Education,  (Autonomous)",
  "NMS SVN College of Education",
  "G.R.D. College  of Education",
  "Amirtham College of Education",
  "Blessy College of Education",
  "Thellar College of Education",
  "K.M.G. College of Education",
  "Lakshmi  Ammal College of Education for Women",
  "Kasturi College of Education",
  "Sivanthi College of Education",
  "Good Shepherd College of Education",
  "K.M.G. College of Education",
  "Star Lion College of Education",
  "Al-Ameen College of Education",
  "Sri Vasavi College of Education",
  "Sri Ramakrishna College of Education, Viluppuram",
  "Raja Desingh College of Education",
  "Mass College of Education",
  "Bharathiyar College of Education",
  "Bharathiyar College of Education",
  "A.S. College of Education",
  "Arulmigu Meenakshi Amman College of Education",
  "Virudhunagar M.S.P. Nadar College of Education",
  "PSNL College of Education",
  "Thiruvalluvar College of Education for Women",
  "St.Xaviers college of Education, (Autonomous)",
  "RMP CSI PSK Rajaratnam Memorial  College of Education",
  "Rajapalayam Deivanaiammal College of Education",
  "M.A.M College of Education",
  "Sri Kubera Vinayagar College of Education",
  "Vysya College of Education",
  "White Memorial college of Education",
  "Sri Sarada Institute for Teacher Training",
  "Government College of Education for Women",
  "Sivanthi  College of  Education",
  "R.P.A.  College  of   Education",
  "St.Thomas College of Education",
  "P.A. College of Education",
  "Dr. G.R.Damodaran College of Education",
  "Ansaldo College of Education",
  "Mahendhra College of Education",
  "Gandhi College of Education",
  "Sasurie College of Education",
  "Ruben College of Education",
  "M. Kumarasamy College of Education",
  "Indian College of Education",
  "Marudupandiyar College of Education",
  "Royal College of Education",
  "Modern College of Education",
  "K.J.N. Educational College",
  "Shiva College of Education",
  "Rainbow College of Education",
  "Excel College of Education",
  "Thiraviam College of Education",
  "Annai College of Education for Women",
  "Holy Angels College of Education for Women",
  "Subham College of Education",
  "MEASI College of Education",
  "Bethany Navajeevan College of Education",
  "Sri Ramachandira College of Education",
  "Velammal College of Education",
  "Sudharsan College of Education",
  "Koottalumoodu Arulmigu Bhadreshwari     Devasthanam College of Education",
  "Sri Sundareswari College of Education",
  "Sri Saraswathi College of Education, Tiruchirappalli",
  "Sri Venkateswara College of Education, Tiruvannamalai",
  "St. Johns College of Education, Vellore",
  "Sri Bharathi College of Education",
  "National College of Education",
  "Universal College of Education",
  "Lisieux College of Education",
  "Avinasi Gounder Mariammal College of  Education",
  "Bethlahem College of Education",
  "Ponmari College of Education",
  "Ponjesly college of Education",
  "Padmavani College of Education",
  "New Millennium College of Education",
  "SRI BALAJI COLLEGE OF NURSING (Inst. Code - 386), TIRUNELVELI",
  "SRI AUROBINDO COLLEGE OF NURSING (Inst. Code - 294), KARUR",
  "RAJAS DENTAL COLLEGE AND HOSPITAL (Inst. Code - 026), TIRUNELVELI",
  "P.G.P. COLLEGE OF PHARMACEUTICAL SCIENCE & RESEARCH INSTITUTE (Inst. Code - 280), NAMAKKAL",
  "P.G.P.COLLEGE OF NURSING & RESEARCH (Inst. Code - 230), NAMAKKAL",
  "PERIYAR COLLEGE OF PHARMACEUTICAL SCIENCES FOR GIRLS (Inst. Code - 031), TIRUCHIRAPALLI",
  "NEHRU NURSING COLLEGE (Inst. Code - 210), VALLIOOR, TIRUNELVELI",
  "K.M. COLLEGE OF PHARMACY (Inst. Code - 029), MADURAI",
  "GOVERNMENT SIDDHA MEDICAL COLLEGE (Inst. Code - 014), PALAYAMKOTTAI,TIRUNELVELI",
  "GOVERNMENT COLLEGE OF PHYSIOTHERAPY (Inst. Code - 037), TIRUCHIRAPALLI",
  "DHARMA AYURVEDA MEDICAL COLLEGE AND HOSPITAL (Inst. Code - 198), KANCHEEPURAM",
  "CSI ELIZA CALDWELL COLLEGE OF NURSING (Inst. Code - 341), TIRUNELVELI",
  "C.S.I. COLLEGE OF DENTAL SCIENCES & RESEARCH, (Inst. Code - 266),  MADURAI",
  "MADURAI MEDICAL COLLEGE, COLLEGE OF NURSING (Inst. Code - 275), MADURAI",
  "CHITHIRAI COLLEGE OF NURSING (Inst. Code - 315),  MADURAI",
  "BEST DENTAL SCIENCE COLLEGE (Inst. Code - 269), MADURAI",
  "ARVINTH COLLEGE OF NURSING (Inst. Code - 279), NAMAKKAL",
  "ARUN COLLEGE OF PARAMEDICAL SCIENCES (Inst. Code - 498), VELLORE",
  "ARUN COLLEGE OF NURSING (Inst. Code - 342), VELLORE",
  "ARULMIGU KALASALINGAM COLLEGE OF PHARMACY (Inst. Code - 049), VIRUDHUNAGAR",
  "ARCOT SRI MAHALAKSHMI WOMEN S  COLLEGE OF NURSING (Inst. Code - 366), VELLORE",
  "ARAVIND EYE HOSPITALAND PG INSTITUTE OF OPHTHAMOLOGY (Inst. Code - 043), MADURAI",
  "ANNASAMY RAJAMMAL COLLEGE OF NURSING (Inst. Code - 304), TIRUNELVELI",
  "ANNAMMAL COLLEGE OF NURSING (Inst. Code - 308), KANYAKUMARI",
  "J.K.K MUNIRAJAH MEDICAL RESEARCH FOUNDATION, ANNAI J.K.K. SAMPOORANI AMMAL COLLEGE OF NURSING (Inst. Code - 068), NAMAKKAL",
  "ALADI ARUNA COLLEGE OF NURSING (Inst. Code - 337), TIRUNELVELI ",
  "SRI VENKATESWARA DENTAL COLLEGE AND HOSPITAL (Inst. Code - 270), KANCHEEPURAM",
  "Horticultural College and Research Institute, Coimbatore",
  "Agricultural Engineering College and Research Institute, Coimbatore",
  "Agricultural Engineering College and Research Institute, Tiruchirappalli",
  "Agricultural College and Research Institute, Madurai",
  "Agricultural College and Research Institute, Coimbatore",
  "Sri Sankara Arts and Science College",
  "R.G Kedia College of Commerce",
  "MNR PG COLLEGE",
  "St. John Institute of Science & Technology",
  "Chatrapathi Shivaji Degree College",
  "Osmania Medical College, Hyderabad",
  "Matrusri Enginering College",
  "Pallavi Degree College",
  "Gajwel College of Education",
  "FATHER COLOMBO COLLEGE OF NURSING",
  "Nishitha Commerce & Science College, Nizamabad (5003)",
  "Princess Durru Shehvar College of MLT, Hyderabad",
  "AASHRITHA DEGREE COLLEGE (NARAYANKHED)",
  "GOKARAJU LAILAVATHI  ENGINEERING COLLEGE",
  "AURORAS DEGREE AND PG COLLEGE, CHIKKADPALLY",
  "GRACE COLLEGE OF PHYSIOTHERAPY",
  "Government Degree College, Adilabad",
  "SATHAVAHANA COLLEGE OF EDUCATION (B.Ed)",
  "Government Degree College, Eturu Nagaram",
  "NRUPATUNGA INSTITUTE OF TECHNOLOGY AND MANAGEMENT    ",
  "AZMEERA REKHA SHYAM DEGREE COLLEGE UTNOOR",
  "S.V.M.R DEGREE COLLEGE",
  "VISHWA VIKAS DEGREE COLLEGE NAGARKURNOOL",
  "GOWTHAMI DEGREE COLLEGE, HAYATHNAGAR",
  "GOVERNMENT COLLEGE OF NURSING, SANGAREDDY",
  "Daripally Anantharamulu College of Engineering & Technology",
  "GOVERNMENT MEDICAL COLLEGE",
  "VAAGESWARI COLLEGE OF PHARMACY, BESIDE LMD POLICE STATION, THIMMAPUR, KARIMNAGAR",
  "VILLA MARIE POST GRADUATE COLLEGE FOR WOMEN",
  "SANGHAMITRA DEGREE COLLEGE MEDCHAL KUKATPALLY",
  "Jahanavi Institute of Hotel management",
  "ADITYA DEGREE COLLEGE, MULUGU",
  "Gnanodaya Degree College, Kammarpally, Nizamabad (5043)",
  "PIER GIORGIO FRASSATI College of Nursing, Suryapet",
  "Malla Reddy Engineering College for women",
  "PRAGATHI COLLEGE OF EDUCATION",
  "GOVERNMENT DEGREE COLLEGE RAJENDRANAGAR    ",
  "SRIVANI WOMENS DEGREE COLLEGE",
  "Smt.YRM DEGREE COLLEGE, Kalwakurthy",
  "Priyadarshini Institute of Science & Technology for Women, Khammam ",
  "Government College of Nursing ",
  "AURORA DEGREE COLLEGE, MEDIPALLY(WEST)",
  "SRI RAJA RAJESHWARA DEGREE COLLEGE",
  "S R Govt. Arts & Science College, Kothagudem",
  "SR INTERNATIONAL INSTITUTE OF TECHNOLOGY",
  "SR & BGNR Government Arts & Science College (Autonomous), Khammam",
  "VENKATASAI DEGREE COLLEGE (3092)",
  "BHAVITHA DEGREE COLLEGE DEVARAKADRA",
  "SREE RAGHAVENDRA VIDYALAYAM, ARMOOR",
  "JAYAPRAKASH NARAYAN ENGINEERING COLLEGE",
  "College of Veterinary Science, Korutla",
  "GURU NANAK HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN, MAHABUBNAGAR",
  "FSB Degree College",
  "TALLA PADMAVATHI COLLEGE OF PHARMACY",
  "SYMBIOSIS CENTRE FOR MANAGEMENT STUDIES, HYDERABAD",
  "Holy Faith College of Education, Paloncha",
  "PRAMEELAMMA DEGREE COLLEGE (3101), AMANGAL",
  "Dhanvanthari Institute of Management Sciences, Sujathanagar, Kothagudem, Khammam",
  "TRINITY DEGREE COLLEGE   SULTANABAD",
  "ST. JOSEPHS DEGREE COLLEGE FOR WOMEN",
  "GOVERNAMENT MEDICAL COLLEGE",
  "A.S.M. College for Women, Fort Road, Warangal  506 002",
  "Vidya Jyothi Degree & P.G. College, Station Ghanpur 506 144",
  "Vivekananda College of Education, Adilabad",
  "M.C.Gupta College of Business Management",
  "Padmavathi Degree College for Women, Kothawada, Warangal",
  "Telangana Tribal Welfare Residential Degree College(Girls)-Mulugu",
  "sai teja degree college",
  "MAHATMA JYOTHIBA PHULE TELANGANA BC WELFARE RESIDENTIAL DEGREE COLLEGE FOR MEN MEDAK",
  "KLR College of Pharmacy, Paloncha, Khammam District",
  "Government Degree College, Rangasaipet, Warangal",
  "Sravanthi College of Education, Dharmaram",
  "Lal Bahadur P.G. College, S.V.P. Road, Warangal",
  "Mancherial Institute of Mathematical Sciences,#20-531,Indira Nagar,Mancherial",
  "Vaagdevi College of Education, Parkal",
  "College of Teacher Education (Tribal Welfare), Lalctekdi, Utnoor",
  "Siddartha Degree College, Siddartha Nagar, Narsampet",
  "New Science Degree College, Hunter Road, Hanamkonda",
  "Vikas Degree College, H.No. 1-2-235, Opp. Govt. Hospital, Jangaon  506 167",
  "Warangal Institute of Technology & Science, Oorugonda (V), Athmakur (M), Warangal",
  "Vaagdevi College of Pharmacy, Ramnagar, Hanamkonda, Warangal",
  "Gowthami Degree College, Cherla (V&M)",
  "Maharshi Degree College, H.No. 4-73/2, Main Road, Palakurthy (V&M)",
  "Ekashila Degree College, Jangaon  506 167",
  "Kristhu Jyothi Degree College, Reddygudem, Thallada, Khammam",
  "Geervani Degree College, Mudhol (V&M)",
  "Saraswathi Degree College, Yerrupalem",
  "Government Degree College, Mahabubabad",
  "Fathima College of Education, Fathima Nagar, Kazipet, Warangal",
  "Mother Theresa College of Education, Paloncha",
  "Maharshi Degree College, H.No. 2-77/8, Santhoshnager, Ameenapuram, Kesamudram 506 112",
  "Kavitha Memorial P.G. College, NST Road, Khammam",
  "ABV Government Degree College, Jangaon  506 167",
  "Balaji Institute of Pharmaceutical Sciences, Laknepally (V), Narsampet (M), Warangal",
  "Anniebesant College of Education, Kranthi Nagar, Ballepally, Khammam",
  "Mohammadiya Institute of Management, Arempula, Khammam",
  "Government Degree College for Women, Khammam",
  "Chanakya Degree College, # 20-139 & 140, College Road, Mancherial",
  "Acharya Degree College",
  "KAKATIYA INSTITUTE AND MANAGEMENT STUDIES, KOTHAPALLY (H), KARIMNAGAR",
  "SRR GOVT. DEGREE COLLEGE, KARIMNAGAR",
  "ROUSSEAU COLLEGE OF TEACHER EDUCATION, VENKATRAOPALLY, NARSINGAPUR (P), BOINPALLI (M), KARIMNAGAR",
  "NAVODAYA DEGREE COLLEGE, DHARMAPURI",
  "GOVT. DEGREE COLLEGE, GODHAVARIKHANI",
  "A.K. VISHWANTHA REDDY DEGREE COLLEGE, MULKANOOR, BHEEMADEVARAPALLY",
  "VAGDEVI DEGREE COLLEGE, KORUTLA ROAD, BESIDE AMC, VEMULAWADA",
  "Gayathri Degree & PG College, H.No.1-2-14/A/1/1&2, Christian Colony, Peddapalli",
  "SRI CHAITNYA DEGREE COLLEGE,  MAIN ROAD, GODAVARIKHANI",
  "SREENIDHI DEGREE COLLEGE, KURIKYAL",
  "AYYAPPA DEGREE COLLEGE, VIDYANAGAR, NEAR SBH, SIRCILLA",
  "GOURISHETTY VENKATAIAH MEMORIAL COLLEGE OF EDUCATION, JAGITIAL ROAD, KNR",
  "ARORA DEGREE COLLEGE, MUKARAMPURA ,  KARIMNAGAR",
  "SAI RAM DEGREE COLLEGE, MUKKU BACHI MALLAIAH HOUSING COMPLEX, MARKET ROAD, JAMMIKUNTA",
  "New Science Degree & PG College, Hunter Road, Hanamkonda,  Warangal",
  "Viswambhara College of Education, Bollikunta, Warangal",
  "university college of education",
  "Government College of Nursing, Secunderabad",
  "GOVERNMENT DEGREE COLLEGE, CHOPPADANDI",
  "JUSTICE KUMARAIAH COLLEGE OF LAW, MUKTESHWARA COMPLEX, M.M. THOTA, KARIMNAGAR",
  "VIDYALATHA DEGREE COLLEGE OF COMMERCE & BUSINESS MANAGEMENT KARIMNAGAR",
  "TRINITY COLLEGE OF PHARMACEUTICAL SCIENCES, PRAGATHINAGAR, PEDDAPALLY, KARIMNAGAR",
  "MATHRUSRI DEGREE COLLEGE, GANDHI NAGAR ROAD, HUZURABAD",
  "CHANAKYA DEGREE COLLEGE, NEAR CITY CABLE, JAMMIKUNTA",
  "SRI ARUNODAYA DEGREE COLLEGE, KORATLA",
  "GNANODAYA DEGREE COLLEGE OPP: BYPASS, RAIKAL",
  "GOVT. DEGREE COLLEGE, HUZURABAD",
  "RASHMIDHAR TEJA COLLEGE OF EDUCATION, NEAR D40 CANAL, KOUSALYANAGAR, KORATLA",
  "VASAVI DEGREE COLLEGE, KALVASRIRAMPUR",
  "VANI NIKETAN INSTITUTE OF MANAGEMTNT STUDIES, MUKARAMPURA, KARIMNAGAR-505002",
  "SWAMY VIVEKANANDA DEGREE COLLEGE, NEAR BUS STAND, DHARMARAM",
  "RKLK PG College",
  "Maharshi Degree College, H.No. 21-37/8, Cherial (V&M), Warangal District",
  "PRAGATHI DEGREE COLLEGE, GOPALRAO PET, RAMADUGU",
  "TRINITY DEGREE COLLEGE JYOTHI NAGAR, NTPC, RAMAGUNDAM",
  "CRESCENT COLLEGE OF EDUCATION , MUKARAMPURA, KARIMNAGAR",
  "SREE CHAITANYA DEGREE COLLEGE, M.M.THOTA, KARIMNAGAR",
  "Nethaji Institute of Pharmaceutical Sciences, Somidi, Kazipet, Warangal",
  "KAVITHA MEMORIAL COLLEGE OF EDUCATION ",
  "AVV Degree College, SVN Road, Warangal  506 002",
  "MANAIR COLLEGE OF EDUCATION, KARIMNAGAR",
  "Sri Ramakrishna Degree College, Kamareddy (5028)",
  "GOVT. DEGREE COLLEGE, MANTHANI",
  "SRI HARSHITHA DEGREE COLLEGE,KATARAM",
  "RBVRR COLLEGE OF EDUCATION, KARIMNAGAR",
  "GOVT. DEGREE COLLEGE, JAMMIKUNTA",
  "GAYATHRI DEGREE COLLEGE, (V&M):YELLAREDDYPET",
  "ROSHINI DEGREE COLLEGE,  RAGHAVULU NAGAR, NEAR BUS STAND MANTHANI",
  "VIVEKANANDA DEGREE & PG COLLEGE, JAGTIAL ROAD, KARIMNAGAR",
  "RAJABOINA VENKATAIAH MEMORIAL COLLEGE OF NURSING",
  "Government College of Nursing, Warangal",
  "UNIVERSITY COLLEGE OF PHARMACEUTICAL SCIENCES KAKATIYA UNIVERSITY",
  "Vishwa Vishwani School of Business Hyderabad",
  "VIVEKANANDA DEGREE COLLEGE, HUSNABAD",
  "SRR COLLEGE OF PHARMACEUTICAL SCIENCES, VALBHAPUR (V), ELKATURTHI (M), KARIMNAGAR",
  "JAGRUTHI DEGREE COLLEGE, 20-462, VIDYANAGAR, HUZURABAD",
  "VANISRI DEGREE COLLEGE KARIMNAGAR",
  "NALANDA DEGREE COLLEGE , KARIMNAGAR ROAD, JAGTIAL",
  "GOVERNMENT DEGREE COLLEGE, METPALLY",
  "NSV DEGREE COLLEGE NEAR OLD BUS STAND, JAGTIAL",
  "Adarsha Law College, Balasamudram, Hanamkonda, Warangal",
  "Sangamithra Degree College, H.No. 4-67/4, Near Police Station, Bhupalpally",
  "Sadhana Degree College, near MRO Office, Yellandu",
  "RAJABOINA VENKATAIAH MEMORIAL BSC MLT COLLEGE",
  "Islamia Arts & Science College, Opp. MGM Hospital, Warangal  506 007",
  "Government Degree College, Yellandu",
  "DR PATNAM MAHENDER REDDY COLLEGE OF PHYSIOTHERAPY    ",
  "Bishop Azaraiah Degree College, Dornakal, Warangal District",
  "Pathfinder Institute of Pharmacy Education & Research, Near Warangal Airport, Warangal",
  "Pulla Reddy Institute of Pharmacy",
  "Sree Chaitanya Institute of Technological Sciences",
  "Sree Chaitanya College of Engineering",
  "Teegala Krishna Reddy Engineering College",
  "JANARDHAN REDDY COLLEGE OF EDUCATION INDIRANAGAR COLONY, HUZURABAD",
  "SRM DEGREE &PG COLLEGE, GEETHA BHAVAN CHOWRASTA, MUKARAMPURA, KARIMNAGAR",
  "SATAVAHANA DEGREE COLLEGE, HUZURABAD",
  "JAWAHARLAR NEHRU COLLEGE OF EDUCATION MALLARAM RD, VEMULAWADA",
  "Adarsh Post Graduate College of Computer Sciences, Mahabubnagar",
  "Sumathi Reddy Institute of Technology For Women",
  "Princeton College of Engineering & Technology",
  "Sreenidi Institute of Science &Technology",
  "JIMS HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMAN",
  "Dr. VRK Women's College of Engineering & Technology",
  "MARVEL DEGREE COLLEGE",
  "SKLN RAO COLLEGE OF EDUCATION ",
  "DVK DEGREE COLLEGE   ASWARAOPETA",
  "MAHAVIR INSTITUTE OF MEDICA SCIENCES ",
  "Vaagdevi College of Engineering",
  "Swarna Bharathi Institute of Science and Technology",
  "UNITY COLLEGE OF PHARMACY, RAIGIR",
  "Vinuthna College of Management, Hasanparthy, Warangal",
  "Samskruti Institute of Business Management",
  "SUPRABHATH P G COLLEGE, RAGHAVAPUR",
  "KPs Twenty first Century Degree College",
  "NALANDA COLLEGE OF PHARMACY, CHARLAPALLY",
  "RRM DEGREE COLLEGE",
  "Aradhana School of Business Management",
  "Telangana Social Welfare Residential Degree College for Women, Mahendrahill",
  "KESHAV MEMORIAL INSTITUTE OF MANAGEMENT",
  "ALLURI SETHA RAMARAJU DEGREE COLLEGE CHINTOOR",
  "Ghulam Ahmed College of Education",
  "MOTHER THERESA COLLEGE OF BED",
  "Vashista Degree College",
  "Sri Indu College of Education",
  "Seelam Pulla Reddy Memorial Degree College, CPS Road, Madhira",
  "GOVERNMENT MEDICAL COLLEGE KARIMNAGAR     ",
  "Lords Institute of Engineering & Technology",
  "ICREATE DEGREE COLLEGE",
  "MAMATA NURSING COLLEGE",
  "GLOBAL KASTURBA COLLEGE OF NURSING",
  "KPRIT COLLEGE OF ENGINEERING",
  "VAISHNAVI WOMENS DEGREE COLEGE",
  "Rahman s College of Education, Jangaon",
  "Rajiv Institute of Medical Sciences,",
  "MAHATMA GANDHI INSTITUTE OF TECHNOLOGY",
  "GOVERNMENT COLLEGE OF NURSING",
  "Sai Institute of  College of Physiotherapy",
  "SPANDANA DEGREE COLLEGE (Co-Education)",
  "VIJETHA DEGREE COLLEGE (Gajwel)",
  "Shri V. D. Bajaj  Degree College for Women",
  "Ashoka Business School",
  "YASHODA COLLEGE OF PHYSIOTHERAPY",
  "Government Degree College, Bhadrachalam",
  "SIDDARTHA DEGREE COLLEGE, BAYYARAM",
  "VIKAS COLLEGE OF PHARMACEUTICAL SCIENCES, RAYANIGUDEM",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE (BOYS), MANUGURU, BHADRADRI KOTHAGUDEM DISTRICT",
  "Government Degree College, Shanthinagar",
  "St. Anns Degree College for Women (Mallapur)",
  "Aurora's Degree & PG College",
  "Sanjeevani College of Physiotherapy, Hyderabad",
  "Santosh College of Nursing, Karimnagar",
  "Global Kasturiba College of Nursing, Hyderabad",
  "SHREE SAADHANA DEGREE COLLEGE",
  "Khammam College of Pharmacy, Allipuram (V), Khammam",
  "AGRICULTURAL COLLEGE, WARANGAL",
  "Sree Ratna College of Physiotherapy, Hyderabad",
  "SREE DATTHA INSTITUTE OF  ENGINEERING AND SCIENCE",
  "Bhadruka Degree College for Commerce & Business Management, Hanamkonda",
  "MAA INSTITUTE OF SPEECH AND HEARING ",
  "Sri Bhavana College of Nursing, Nalgonda",
  "Sri Sai College of Nursing, Nalgonda",
  " Telangana Tribal Welfare Residential Degree College (Girls)",
  "SRI CHAITANYA DEGREE COLLEGE (HYDER NAGAR)",
  "SRINIDHI DEGREE COLLEGE, DEVERAKONDA",
  "SAMATHA DEGREE COLLEGE, MIRYALAGUDA",
  "Navabharathi College of P.G Studies",
  "Trinity College Of Education",
  "hyderabad school of business degree college",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, HYDERABAD",
  "ALEXANDER COLLEGE, MUGDUMPOOR",
  "AMS Arts & Science College for Women",
  "Gauthami Degree College (Chintal)",
  "Dr. B.R. Ambedkar Institute of Management & Technology",
  "Saketa Degree College",
  "Mahbub Degree College",
  "Vaagdevi Degree College,  13-21, Thimmapur Area, Khanapur (V&M)",
  "Azad College of Pharmacy",
  "DON BOSCO COLLEGE OF EDUCATION",
  "Government College of Nursing",
  "Takshashila Degree College",
  "Kakatiya University College of Engineering and Technology",
  "Centre for Cellular and Molecular Biology (CCM)",
  "Vedhatraya Degree College, Dilwarpur (V&M)",
  "Sri Sai Vidya Vikas Degree College",
  "NEW GENERATION DEGREE COLLEGE FOR WOMEN, KHAMMAM",
  "Vedhanidhi Degree College, Narnoor (V&M)",
  "Thapasvi Degree College, Kubeer (V&M)",
  "Sraddha Degree College, Mudhole (V&M)",
  "Pragathi  Degree College",
  "S.R. Degree College, Khanapur (V&M),",
  "Sai Samath Degree College",
  "VIF College of Engineering & Technology",
  "Matrusri Degree College,  Asifabad (V&M)",
  "Keerthana Degree College,  Bela (V&M)",
  "PRATHIMA RELIEF COLLEGE OF NURSING",
  "Malla Reddy Engineering College",
  "Ekashila Degree College, Mamada (V&M)",
  "Chatrapathi Degree College",
  "SPECTRUM INSTITUTE OF MANAGEMENT AND COMPUTER SCIENCES    ",
  "Agnus Degree College,  Jainoor (V&M)",
  "MRM College of Pharamacy",
  "Avanthi Degree College, Adegaon-k, Echoda (V&M)",
  "SUN PRIDE INSTITUTE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "SRI VIDYA DEGREE COLLEGE",
  "Sri Sai  Degree College, Nandipet (5030)",
  "Vijetha Degree & PG College, Armoor (5041)",
  "Govt. Degree College, Bodhan (5007)",
  "PJR'S Spoorthy Degree College, Kamareddy (5048)",
  "MALLA REDDY TECHNICAL CAMPUS",
  "Azmeera Rekha Syam (ARS) Degree College,Khanapur (V&M)",
  "Sri Sadguru Bandayappa Swamy B.Ed. College, Bichkunda (5287)",
  "CSI Degree College, Nizamabad (5004)",
  "TKR College of Engineering & Technology",
  "SSL Degree College, Banswada (5035)",
  "Manjeera Degree College, Kamareddy (5015)",
  "S.R.S.P. Degree College, Balkonda (5025)",
  "Govt. Degree College, Yellareddy (5008)",
  "Sri Chaitanya College of Education, Bodhan (5286)",
  "MAHATMA JYOTIBA PHULE TELANGANA BACKWARD CLASSES WELFARE RESIDENTIAL DEGREE COLLEGE FOR MEN,KANDUKUR",
  "Govt. Degree College, Morthad (5044)",
  "SURABHI INSTITUTE OF ALLIED HEALTH SCIENCES",
  "Gouthami PG College, Nizamabad (5221)",
  "Vaagdevi Degree College, Nizamabad (5038)",
  "Nalanda Degree College for Women, Nizamabad (5017)",
  "Sandeepani Degree College, Kamareddy (5026)",
  "Priyadarshini College of Education, Armoor (5285)",
  "Ushasri Degree College, Kallauru (V&M)",
  "ACE Engineering college",
  "Women's Degree College, Nizamabad (5042)",
  "Sri Aurobindo Degree College, Jangaon (V&M)",
  "St. Thomas College of Education, Bodhan (5289)",
  "Prathishtha Institute of Pharmaceutical Sciences",
  "Gyana Jyothi College of Pharmacy",
  "Sarojini Naidu Vanita Maha Vidyalaya",
  "Sri Venkateshwara Degree College, Bodhan (5051)",
  "Yashoda Laxmi College of Nursing, Medchal",
  "Kavitha PG College",
  "Sahithi Degree Collelge,Jangaon (V&M)",
  "ICAT DESIGN AND MEDIA COLLEGE",
  "PADMANAYAKA COLLEGE OF SPECIAL EDUCATION",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR BOYS KARIMNAGAR",
  "Mathrusri Degree College, Girnibavi (Mandapally) (V)",
  "Government Degree College, Wardhannapet",
  "Excellent Degree College, Cherial (V&M)",
  "GOVERNMENT MEDICAL COLLEGE, MANCHERIAL",
  "Siddhartha Institute of Engineering & Technology",
  "COGNOS INSTITUTE OF HOTEL MANAGEMENT",
  "GOVERNMENT COLLEGE OF NURSING",
  "Susruta Institute of Physical Medicine and Rehabilitation, Hyderabad",
  "MJPTBCWR DEGREE COLLEGE WOMEN VARNI",
  "Central Research Institute of Unani Medicine",
  "Karshak B.Ed College, Kamareddy (5283)",
  "OUPG COLLEGE NARSAPUR",
  "W. C. C. M, Wanaparthy",
  "JNTUH UNIVERSITY COLLEGE OF ENGINEERING MAHABUBABAD",
  "SV Degree College, Pitlam (5052)",
  "SRI SIDDHARTHA DEGREE COLLEGE, MUNUGODE",
  "Vasistha Degree & PG College, Kamareddy (5037)",
  "Indur PG College of Business Management, Bodhan (5171)",
  "Army College of Dental Sciences, Secunderabad",
  "SRI SAI BHARTHI DEGREE AND PG COLLEGE NALGONDA",
  "Vaagdevi College of Physiotheraphy, Warangal",
  "Thirumala College of Physiotherapy, Nizamabad",
  "SRI CHAITANYA DEGREE COLLEGE MIRYALGUDA",
  "MJPTBCWR DEGREE COLLEGE WOMEN MUNIPALLY",
  "Sri Venkata Sai College of Medical Lab technology, Mahabubnagar",
  "Sri Ramachandra College of Nursing, Nizamabad",
  "PDS Institute of Physiotherapy, Hyderabad",
  "Navodaya College of Physiotherapy, Mahabubnagar",
  "Sneha College of Nursing, Nalgonda",
  "Sivananda College of Nursing, Karimnagar",
  "Navodaya College of Nursing, Mahabubnagar",
  "Sigma College of Nursing, Hyderabad",
  "Shanthi College of Nursing, Hyderabad",
  "Rohini College of Nursing, Hanumakinda",
  "Footwear Design and Development Institute - Hyderabad",
  "Prathima Institute of Medical Sciences, Karimnagar",
  "SREE VENKATESHWARA COMMERCE DEGREE COLLEGE, KARMANGHAT",
  "Prathima College of Nursing, Karimnagar",
  "KRANTHI DEGREE COLLEGE",
  "Owaisi College of Nursing, Hyderabad",
  "Vivekananda Institute of Science & InformationTechnology",
  "Modern Institute of Physical Medicine & Rehabilitation, Hyderabad",
  "Mediciti College of Nursing, Medchal",
  "Mamata Dental College, Khammam",
  "Kamineni Inst. of Medical Sciences, Narketpally",
  "Kamineni Institute of Paramedical Sciences (B.Sc MLT), Hyderabad",
  "Kamineni College of Nursing, Hyderabad",
  "Jaya Inst. of Medical Lab Technology B.Sc MLT, Warangal",
  "Green Lead College of Nursing, Secunderabad",
  "DCMS College of Physiotherapy, Hyderabad",
  "Chandana College of Nursing, Suryapet",
  "Chalmeda Ananda Rao Institute of Medical Sciences, Karimnagar",
  "Care Nampally College of Nursing, Hyderabad",
  "BHAVITHA DEGREE COLLEGE",
  "VIJAYA INSTITUTE OF MANAGEMENT",
  "VIGNAN DEGREE COLLEGE",
  "VIJAYA SCHOOL OF BUSINESS MANAGEMENT",
  "Care Institute of Medical Sciences College of Physiotherapy, Hyderabad",
  "Mohammadiya Institute of Pharmacy, Barugudem, Arempula, Khammam",
  "Apollo College of Nursing, Hyderabad",
  "PRATHIMA RELIEF INSTITUTE OF MEDICAL SCIENCES",
  "St. John College of Nursing, Warangal",
  "DR NARAYANA COLLEGE OF COMMERCE ",
  "BALAJI MAHILA DEGREE AND PG COLLEGE",
  "GOVERNMENT MEDICAL COLLEGE SANGAREDDY",
  "Aurora's P.G. College-MBA",
  "SRK Memorial College of Nursing, Mancherial",
  "Pulipati College of Nursing, Konizerla",
  "GOVERNMENT MEDICAL COLLEGE",
  "Princess Duru Shehvar College of Nursing, Hyderabad",
  "Bhaskar Law College",
  "VINAYAKA LAW COLLEGE",
  "Kamineni Inst. of Paramedical Sciences, Nalgonda",
  "Pragathi College of Physiotherapy, Nizamabad",
  "Gland Institute of Pharmaceutical Sciences",
  "Mother Krishnabhai College of Nursing, Hyderabad",
  "Telangana Social Welfare Residential Degree College for Women, Warangal East",
  "Mediciti Inst. of Medical Sciences, Ghanapur",
  "SHIVANI DEGREE COLLEGE",
  "APOORVA WOMENS DEGREE COLLEGE",
  "Krishna Institute of Medical Sciences College of Physiotherapy, Secunderabad",
  "Krishna Institute of Medical Sciences (KIMS) College of B.Sc MLT, Hyderabad",
  "GOVERNMENT COLLEGE OF NURSING",
  "Kakatiya Medical College, Warangal",
  "GOVERNMENT DEGREE COLLEGE, HALIYA",
  "Rousseau Institute of Management Studies",
  "SRM Institute of Medical Sciences & Technology, Karimnagar",
  "K NARAYANA MEMORIAL COLLEGE OF EDUCATION",
  "Palamuru University PG Centre Kollapur",
  "Kamineni Inst. of Dental Sciences, Narketpally",
  "APOORVA COLLEGE OF EDUCATION (B.Ed)",
  "MANUU POLYTECHNIC, HYDERABAD",
  "Kalanjali College of Nursing, Hyderabad",
  "Jaya College of B.Sc Nursing, Hanumakonda",
  "CITY MAHILA DEGREE COLLEGE",
  "Shadan College of Medical Lab Technology, Hyderabad",
  "Balaji Inst. of Nursing, Warangal",
  "Apex College of Nursing, Hyderabad",
  "Sangamitra College of Education",
  "Jalagam Vengal Rao (JVR) Government College, Sathupally",
  "MKR GOVT DEGREE COLLEGE, DEVARAKONDA",
  "SANGA MITHRA DEGREE COLLEGE FOR WOMEN, JAMMIKUNTA",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN,MEDAK",
  "Shadan Inst. of Medical Sciences College of Nursing, Hyderabad",
  "SHALIVAHANA DEGREE COLLEGE, SURYAPET",
  "MAHATHI WOMENS DEGREE COLLEGE,SIRCILLA",
  "UNIVERSITY PG COLLEGE, MAHABUBABAD",
  "SRI VENKATESHWARA DEGREE COLLEGE, ALAIR",
  "Holy Mary College of Nursing, Hyderabad",
  "DR PATNAM MAHENDER REDDY COLLEGE OF NURSING",
  "UNIVERSITY PG COLLEGE, BHUPALAPALLY",
  "Gowtami College of Nursing, Hyderabad",
  "Eashwaribai Memorial College of Nursing, Secunderabad",
  "SRI RAGHAVENDRA DEGREE COLLEGE, NALGONDA",
  "KNM GOVT. DEGREE COLLEGE, MIRYALGUDA",
  "GOUTAMI DEGREE COLLEGE, BHONGIR",
  "Sri Indu P.G College",
  "Sri Vidya Degree College (Co-Education)",
  "Indo American College of Nursing, Hyderabad",
  "Sri Krupa Institute of Pharmaceutical Sciences",
  "Wesley Degree College for Women",
  "Swayamkrushi Self Reliance for the Mentally Challenged",
  "Nalanda Degree College",
  "Sujatha Degree College for Women",
  "Ellenki Degree College (Narsapur)",
  "Vishwa Bharathi Arts & Science Degree College",
  "Suprabhat Institute of Management Studies",
  "Govt. Degree College (Gajwel)",
  "Hindu Degree College for Women",
  "G. Pulla Reddy College of Pharmacy",
  "Amjad Ali Khan College of Business Administration",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN DEVARAKONDA",
  "MESCO Institute of Management & Computer Science",
  "Ellenki Degree College (Sangareddy)",
  "Sri Aurbindo Degree College",
  "Methodist College of Engineering & Technology",
  "Malla Reddy Engineering College and Management Sciences",
  "Neelam Sanjeeva Reddy College of Education",
  "M S Degree College for Women (Shalibanda)",
  "David Memorial Institute of Management",
  "Vennela Degree College",
  "Gayathri Degree College,Jammikunta",
  "CKM Arts & Science College, Desaipet Road, Warangal  506 006",
  "Villa Marie Degree College for Women",
  "Sri Vani Degree College, V.M. Banzar, Penubally",
  "JNTUH UNIVERSITY COLLEGE OF ENGINEERING PALAIR    ",
  "JAI DURGA BHAVANI BEd COLLEGE",
  "Shalivahana Degree College",
  "AKLR Govt. Oriental College",
  "Noble P.G College (MBA/MCA)",
  "Apollo Institute of Hospital Administration",
  "Railway Degree College",
  "Moghal College of Education",
  "Vivekananda Govt. Degree College",
  "Saanvi P.G College for  Women",
  "Aadhya Degree College for Women",
  "Sri Sai College of Physiotheraphy, Nalgonda",
  "Methodist Degree College",
  "Pandit Narendra Oriental College",
  "Spoorthy Degree & P.G. College",
  "Govt. Degree College (Ibrahimpatnam)",
  "Govt. Degree College for Women (Sangareddy)",
  "Jahnavi Degree College (Boduppal)",
  "Mother Teresa College of Pharmacy",
  "Priyanka Degree College for Women",
  "Dr. B. R. Ambedkar College",
  "NATIONAL INSTITUTE OF INDIAN MEDICAL HERITAGE",
  "Shantinikethan Degree College for Women",
  "MAHATMA JYOTIBA PHULE TELANGANA BACKWARD CLASSES WELFARE RESIDENTIAL DEGREE COLLEGE FOR MEN, YELLAREDDYPET",
  "P.G. College of Law, Basheerbagh",
  "Indian College of Nursing, Mahabubnagar",
  "Pallavi College of Education",
  "Culinary Academy of India",
  "SHAARVANI INSTITUTE OF PARA MEDICAL SCIENCES",
  "Gowthami Degree College, Laxmidevipally, Kothagudem",
  "Padala Rama Reddy Law College",
  "Margadarshi College of Education, Mahabubabad",
  "Pinnacle Institute of Hotel Management",
  "I S O Degree College",
  "M.R.M  Institute of Management (Ibrahimpatnam)",
  "National Degree College, Bollorugudem, Paloncha",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN",
  "MALLA REDDY COLLEGE OF EDUCATION (B.Ed)",
  "TELANGANA SOCIAL WELFARE RESIDENCIAL DEGREE COLLEGE WOMEN ADILABAD",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN, KARIMNAGAR",
  "Pinnacle College of Culinary Arts and Hotel Management",
  "VIJETHA DEGREE COLLEGE, SURYAPET",
  "St. Francis College for Women",
  "St. Anns College of Education",
  "Badruka College of Commerce & Arts (Day)",
  "Govt. Degree College (Siddipet)",
  "GAYATRI DEGREE COLLEGE",
  "Rachana College of Journalism",
  "Vasundara Degree College (Co-Education)",
  "VISHWA BHARATHI DEGREE COLLEGE",
  "Loyola Academy",
  "VASTHSALYA COLLEGE OF BUSINESS MANAGEMENT, BHONGIR",
  "Sri Venkateshwara College of Pharmacy",
  "KONERU LAKSHMAIAH EDUCATION FOUNDATION (DEEMED TO BE UNIVERSITY ) OFF CAMPUS, HYDERABAD",
  "St. Patricks Degree & P.G College",
  "NIZAM SCHOOL OF EDUCATION",
  "Vidya Dayani Degree & P.G College (UG)",
  "Jahanavi Degree College (Secunderabad)",
  "Akshara Degree College for Women",
  "GOVERNMENT MEDICAL COLLEGE, KHAMMAM",
  "Shadan Degree College for Men",
  "Govt. Degree College for Women (Gajwel)",
  "V.V. College (AN)",
  "Aadhya Degree College",
  "SBS Degree College",
  "M S Degree College for Women (Tolichowki)",
  "SUN PRIDE DEGREE COLLEGE",
  "Roda Mistry College of Social Work & Research Centre",
  "Trendz Degree College",
  "Megana Degree College",
  "Mamata College of Nursing, Khammam",
  "MAHESHWARA MEDICAL COLLEGE",
  "Mother Teresa College of Management & Computer Applications",
  "Aurora Degree College, Near KUC X Roads, Vidyaranyapuri, Hanamkonda",
  "Govt. Degree College (Medak)",
  "BHARAT SCHOOL OF PHARMACY (FORMERLY) NAVA BHARAT INSTITUTE OF  PHARMACEUTICAL AND MEDICAL SCIENCES",
  "Brilliant  Grammar School Educational Society's Group of Institutions- Integrated Campus",
  "Govt. Nizamia Tibbi College, Hyderabad",
  "AKM Oriental College",
  "Telangana Social Welfare Residential Degree College for Womens (Girls), Kamareddy (5077)",
  "St. Pauls College of Pharmacy",
  "Vikas College of Education",
  "Shadan Institute of Management Studies for Boys",
  "Sweekar Academy of Rehabilitation Sciences, Secunderabad",
  "Dr. M.R. Reddy Degree College, Parkal  506 164",
  "Ganapathi College of Education, Parkal",
  "GOVT. MEDICAL COLLEGE, NIZAMABAD",
  "SRK Commerce & Science College, Kamareddy (5054)",
  "Pendekanti Institute of Management",
  "Shaarvani Degree College, 5-9-171 and 172, Kishanpura, Hanamkonda  506 001",
  "Vaagdevi Institute of Pharmaceutical Sciences, Bollikunta, Warangal",
  "SAHITHI DEGREE COLLEGE",
  "T.H.P Institute of Research & Rehabilitation for the Mentally Handicapped",
  "Government Dental College, Hyderabad",
  "DRS College of Education, Thorrur",
  "AYYAPPA DEGREE COLLEGE, SIRCILLA",
  "Pioneer Institute of Hotel Management",
  "Government College of Nursing, Hyderabad",
  "Mother Teresa P.G. College (MCA)",
  "Sri Venkateshwara College of Fine Arts",
  "Vivekananda Degree College (Kukatpally)",
  "Islamia Degree & P.G College",
  "Sri Venkateshwara College of Education, Banswada (5294)",
  "TRINITY DEGREE COLLEGE",
  "ESIC Medical College",
  "DR. V.R.K. WOMEN’S COLLEGE OF PHARMACY",
  "SIDDHARTHA INSTITUTE OF PHARMACY",
  "TSRTC COLLEGE OF NURSING",
  "GOVERNMENT COLLEGE OF NURSING",
  "KV Ranga Reddy Law College",
  "Aradhana College of Education",
  "Panchsheel College of Education, Nirmal",
  "KLR Degree College, Ambedkar Centre, Paloncha",
  "Princeton P.G. College of Management",
  "Vidya Dayani College of Information Technology",
  "Vasundara Women's Degree College",
  "Government Degree College, Parkal",
  "Government Degree College, Garla",
  "Sree Kavitha College of Management and Information Technology",
  "Vaagdevi Degree College, 47&54, Boath (P&M)",
  "Manair College of Law, V.V. Palem, Khammam",
  "Vaagdevi Degree & PG College, Kishanpura, Hanamkonda",
  "Gandhi Naturopathy Medical College, Hyderabad",
  "Sri Chaitanya Degree College582",
  "Vidya Jythi Institute of Technology",
  "GOVERNMENT DEGREE COLLEGE, HUSNABAD",
  "Govt. Degree College (Tandur)",
  "Gandhi Medical College, Secunderabad",
  "Pioneer Degree College",
  "ST MARYS CENTENARY COLLEGE OF MANAGEMENT",
  "Telangana Social Welfare Residential Degree College for Womens, Armoor (5079)",
  "Telangan Social Welfare Residential College for Women, Nizamabad (5078)",
  "R V M INSTITUTE OF MEDICAL SCIENCES AND RESEARCH CENTRE",
  "SRI CHAITANYA TECHNICAL CAMPUS",
  "Durgabhai Deshmukh College of B.Sc Nursing, Hyderabad",
  "Vandana Degree College",
  "Vishwa Vishwani Institute of Systems & Management",
  "Yadaiah College of Education",
  "St Anthony's Degree college for women",
  "Bhavans New Science Degree College (AN)",
  "Siddhartha Womens Degree College",
  "Dr. B.R.K.R. Govt. Ayurvedic College, Hyderabad",
  "Vishwa Bharathi Degree College",
  "Sarojini Naidu Vanita Pharmacy Maha Vidyalaya",
  "Geethanjali Degree College",
  "Gurram Balanarasaiah Institute of Pharamcy",
  "KESHAV MEMORIAL COLLEGE OF LAW",
  "SRI MATHA SARASWATHI DEGREE COLLEGE, ATMAKUR",
  "Vaagdevi Degree College, Kishanpura, Hanamkonda",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN, SIRCILLA",
  "Chaitanya Bharathi Institute of Technology",
  "RGR Siddhanthi College of Education",
  "Pragathi  Degree College ",
  "St. Johns P.G. College",
  "YPR College of Education",
  "Anwar-Ul-Uloom College of Business Management",
  "Govt. Degree College for Women (Begumpet)",
  "Ponugoti Madhav Rao Law College",
  "Lal Bahadur Degree College",
  "The Crescents College of Business Management, Janpak, Geesugonda Mandal, Warangal",
  "ARUNDATHI COLLEGE OF PHYSIOTHERAPY",
  "SRI VIDYA DEGREE COLLEGE",
  "Sree Vani Women's Degree & P.G College",
  "OSM Degree College",
  "P.V Ramreddy P.G College",
  "TMSS College of Management",
  "Ideal Degree College for Women",
  "VIJAYA PG COLLEGE (MBA)",
  "UK College of Education",
  "St. Francis Xavier Degree College",
  "Holy Mary Tec.College of Education",
  "GOVT. DEGREE COLLEGE, AGRAHARAM",
  "CHAITANYA DEGREE COLLEGE (SHAMSHABAD)",
  "Sardar Patel College",
  "Adam College of Education",
  "VKDVS Raju Degree College, Aswaraopet",
  "Vikas Degree College, # 1-119/1, Ponkal, Jannaram (M)",
  "Princeton P.G. College of Information Technology",
  "Malla Reddy College of Pharmacy",
  "Visionary Degree College",
  "EDAVANTA DEGREE COLLEGE (Hayathnagar)",
  "GOVERNMENT COLLEGE OF NURSING, RIMS, ADILABAD",
  "Mother Teresa Institute of Science & Technology",
  "College of Teacher Education (Tribal Welfare), Bhadrachalam",
  "Lal Bahadur P.G. College(MBA), S.V.P. Road, Warangal",
  "Ananntha Law College",
  "KNR Degree College, 14-52, Khanapur (V&M)",
  "MNR College of Pharmacy",
  "Nruputunga Degree College",
  "APOLLO INSTITUTE OF MEDICAL SCIENCES AND RESEARCH",
  "Wesley Degree College (Co-Edn)",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL DEGREE PHARMACY COLLEGE",
  "Badruka Degree College (AN)",
  "Aristotle P.G.College",
  "PRR College of Commerce & Management",
  "Hyderabad School of Management",
  "SRI SATYA SAI DEGREE COLLEGE-3100",
  "MANTRA School of Business Management",
  "Siddhartha Degree College",
  "GOPALA KRISHNA COLLEGE OF PHYSICAL EDUCATION",
  "Anwarul-Uloom College of Computer Studies",
  "R.G. Kedia Degree College",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE (GIRLS), KHAMMAM",
  "Arya College of Pharmacy",
  "Gokul Degree College",
  "Nagarjuna Degree College (Mutrajpally)",
  "Karanam Padmavathi Memorial Degree & P.G College",
  "Sri Sai Vignan Bharathi Degree College for Women",
  "Pragnya Degree College",
  "Amrat Kapadia Navajeevan Degree College for Women",
  "Global Institute of Hotel Management",
  "Gowthami Degree College (Vikarabad)",
  "Indira Priyadarshini Government Degree College for Women",
  "Pragati College of Education",
  "Annie Besant Womens Degree College",
  "Bharat P.G. College for Women",
  "Haindavi Degree College",
  "St. Marys Centenary Degree College",
  "Princeton Degree & P.G College",
  "MESCO College of Pharmacy",
  "Jagruthi Degree College",
  "Siddhartha Institute of Computer Science",
  "Blooms College of Hotel Management",
  "Sri Caitanya College of Engg& Tech,and Sri Chaitanya College of Business  Management",
  "GOVERNMENT MEDICAL COLLEGE MAHABUBABAD",
  "St Joseph Degree College For Women",
  "DHRUVA COLLEGE OF FASHION TECHNOLOGY",
  "Sree Ramchandra Arts & Science College",
  "Shine India Degree College",
  "R.G.R Siddhanthi College of Business Management",
  "Pinnacle Degree College",
  "VASAVI DEGREE COLLEGE, BAYYARAM",
  "GOVERNMENTCOLLEGE OF NURSING,GADWAL",
  "GOVERNMENT MEDICAL COLLEGE WANAPARTHY",
  "Akshara Institute of Management Studies",
  "GOVT, DEGREE COLLEGE, PEDDAPALLI",
  "JEC COLLEGE OF  EDUCATION, SAROORNAGAR",
  "SRI CHAITANYA WOMENS DEGREE COLLEGE, LB NAGAR, BHUPALPALLY",
  "SRI VENKATESHWARA DEGREE COLLEGE, MAAL",
  "DHARMIKA DEGREE COLLEGE",
  "HARSHASRI DEGREE COLLEGE-VELGATOOR",
  "PAVLOV COLLEGE OF TEACHER EDUCATION",
  "SRI HAMSAVAHINI DEGREE COLLEGE",
  "SRI VYSHNAVI DEGREE COLLEGE, JAGTIAL",
  "Netaji School of  Management ",
  "ROYAL COLLEGE OF EDUCATION",
  "SAHITHI DEGREE COLLEGE FOR WOMEN",
  "Sri Sarada Degree  College for Women",
  "GAYATHRI DEGREE COLLEGE (NARSAPUR)",
  "ETHAMES DEGREE COLLEGE (PANJAGUTTA)",
  "HAINDAVI DEGREE COLLEGE (S R NAGAR)",
  "LMA DEGREE COLLEGE (NAGARJUNA HILLS)",
  "GURRAM BALANARASAIAH INSTITUTE OF PHARMACY",
  "Sanskriti Degree College",
  "VIVEKANANDA DEGREE COLLEGE, SIRISILLA",
  "RAGA COLLEGE OF EDUCATION,GOUURIGUDEM, SATHUPALLY",
  "ST JOHNS COLLEGE OF EDUCATION",
  "SPOORTHY DEGREE COLEGE",
  "MAHALAKSHMI DEGREE COLLEGE ,UMDAM TALAMADUGU ADILABAD",
  "PRATHIBA DEGREE COLLEGE, CHERIAL",
  "SRI RAJA RAJESHWARI (SRR) DEGREE COLEGE",
  "KAKATIYA DEGREE COLLEGE(597)",
  "Takshashila Degree College, Kesamudram",
  "TAPASYA DEGREE COLLEGE SECUNDEABAD",
  "Nizam College, Basheerbagh",
  "Agricultural College, Sirsilla",
  "Government Degree College,Sitaphalmandi_60183",
  "Vijay Rural Engineering College",
  "UNIVERSITY COLLEGE OF COMMERCE BUSINESS MANAGEMENT OSMANIA UNIVERSITY",
  "HAMSA HOMEOPATHY MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE",
  "Dr PATNAM MAHENDER REDDY INSTITUTE OF MEDICAL SCIENCES",
  "SRI CHAITANYA DEGREE COLLEGE DHARMAPURI",
  "SRI CHAITANYA DEGREE COLLEGE-JAGITIAL",
  "KRR GOVERNMENT ARTS & SCIENCE COLLEGE, KODAD",
  "VIVEKANANDA COLLEGE OF COMPUTER SCIENCES",
  "Roots college of Hotel Management and Culinary Arts ",
  "Surabhi Dayakar Rao College of Pharmacy",
  "Shahnaz College of Education",
  "SV (Sri Vagdevi) Degree College, Nizamabad (5031)",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN, SIRCILLA",
  "CHANDANA COLLEGE OF PHYSIOTHERAPY",
  "LIMRA DEGREE COLLEGE",
  "Padishala Veerabhadraiah Memorial Degree College For Women Warangal",
  "Rabindranath College of Education",
  "AGRICULTURAL COLLEGE TORNALA    ",
  "C V RAMAN PG COLLEGE MANCHERIAL    ",
  "TSWR DEGREE & PG COLLEGE FOR WOMEN, IBRAHIMPATNAM",
  "GYAN DEGREE COLLEGE",
  "Vignan Institute of Technology & Sciences",
  "Military College of Electronics and Mechanical Engineering",
  "GOVT DEGREE COLLEGE PEBBAIR ",
  "GOVERNMENT MEDICAL COLLEGE MAHESHWARAM ",
  "Dr. BRR Govt. Degree College, Jadcherla",
  "JNTUH College of Engineering Sultanpur",
  "SINDHU SCHOOL AND COLLEGE OF NURSING",
  "Sri Sai Degree College",
  "VAISHNAVI DEGREE COLLEGE, KORUTLA ROAD, VEMULAWADA",
  "Madhira Institute of Technology and Sciences",
  "GOVERNMENT WOMENS DEGREE COLLEGE KOSGI",
  "GOVERNMENT MEDICAL COLLEGE, QUTHBULLAPUR",
  "GLOBAL ACADEMY OF HOTEL MANAGEMENT",
  "GAYATHRI DEGREE COLLEGE,IEEJA,JOGULAMBA GADWAL.",
  "SREE CHAITANYA DEGREE COLLEGE, GOLLAPALLY",
  "AYYAPPA DEGREE COLLEGE, MPP ROAD, ELLANTHAKUNTA",
  "Sri Vidya Degree College, Sundaraiah Nagar, Bandarugudem, Manuguru",
  "Vivekananda Degree College, Shadnagar",
  "Tirumala Engineering College",
  "RJRM Degree College, Marripeda",
  "Vasundhara Degree College, Surya Complex, Industrial Area, Sirpur Khagaznagar",
  "Sri Pulaji Baba Degree College, # 1-36/1, Near IB Chowk, Utnoor",
  "Browns College of Pharmacy, Ammapalem, Thanikella, Khammam",
  "Government Degree College, Chennoor 504 201",
  "Nalanda Degree College, # 13-306/12, Near IB, Mancherial (Sri Harsha)",
  "TULASI COLLEGE OF NURSING",
  "St. Joseph s P.G. College, Rampoor, Warangal",
  "Sanga Mithra Degree College_Siddipet",
  "MALLA REDDY PHARMACY COLLEGE ( FORMERLY CM COLLEGE OF PHARMACY)",
  "KLR College of Engineering & Technology",
  "Ellenki College of Engineering and Technology",
  "Gokuldas Purushothamdas Ladda (GPL) Degree College, Nirmal Road, Bhainsa",
  "DRS Degree College, Mamillagudem, Khammam",
  "Swetha Degree College, # 7-90, 7-91/1, Near Bus Stand, Chennur",
  "Vikas Degree College, Station Road, Khammam",
  "Global Institute of Management",
  "St. Pauls Degree College",
  "Sri Sahasra Degree College For Women, Santosh Nagar",
  "OMEGA DEGREE COLLEGE, UPPAL",
  "Badruka College PG Centre",
  "Siddhartha Degree College (Co-Education)",
  "BBCIT",
  "ISLAMIA COLLEEGE OF EDUCATION (B.Ed)",
  "GOVERNMENT MEDICAL COLLEGE, SIDDIPET",
  "Government Medical College Mahabubnagar",
  "GOVT. COLLEGE OF TEACHER EDUCAITON, NAGARJUNASAGAR",
  "VIJETHA DEGREE COLLEGE FOR WOMEN",
  "Priyadarshini College of Business Management",
  "Rishi UBR Womens College",
  "Chillukur Balaji College of Pharmacy",
  "Smt.Sarojini Ramulamma College of Pharmacy, Mahabubnagar",
  "Mother Theresa College of Education Mahabubabad",
  "SARAYU DEGREE COLLEGE, GUDUR",
  "M S Degree College for Women (Masabtank), Hyd",
  "Avinash Degree College",
  "EXCEL COLLEGE OF HOTEL MANAGEMENT",
  "R.K. College of Arts, Commerce and Science,  Kamareddy (5045)",
  "Nalanda Degree College, Yellareddy (5076)",
  "NEW PRAGATHI DEGREE COLLEGE OF COMMERCE & SCIENCE",
  "Goutham Degree College,Kishanpura,Hanamkonda",
  "GAYATHRI DEGREE & PG COLLEGE, H.No.1-2-14/A/1/1&2, Christian Colony, Peddapalli",
  "St. Marys College of Education (Secunderabad)",
  "Sri Sadana Degree College",
  "SKLNR COLLEGE OF EDUCATION, SARASWATHI NAGAR, JAGTIAL",
  "Nawab Shah Alam Khan College of Engineering & Technology",
  "BHAGEERATHA COLLEGE OF EDUCATION",
  "MARUTHI COLLEGE OF NURSING",
  "INDIAN INSTITUTE OF PUBLIC HEALTH HYDERABAD",
  "Ayaan Institute of Medical Sciences",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN, WANAPARTHY.",
  "MARUTHI PARAMEDICAL ACADEMY",
  "KLR COLLEGE OF PHYSIOTHERAPY",
  "Yashoda Institute Of Physiotherapy",
  "SURABHI INSTITUTE OF MEDICAL SCIENCES",
  "Chandana B.Sc Medical Lab Technology, Nalgonda",
  "VIKAS COLLEGE OF PHARMACY, Shameerpet",
  "KIMS COLLEGE OF LAW",
  "UNIVERSITY COLLEGE OF SCIENCE OSMANIA UNIVERSITY",
  "Deepthi college of Nursing",
  "Nightingale College Of Nursing",
  "Swarnanjali College of Nursing, Khammam",
  "JSPS GOVERNMENT HOMOEOPATHIC MEDICAL COLLEGE, RAMANTHPUR",
  "GOVT DEGREE COLLEGE BALKONDA",
  "Anantalakshmi Govt. Ayurvedic College, Warangal",
  "Angel College of Nursing, Khammam",
  "Apollo College of Physiotherapy, Hyderabad",
  "Aware College of B.Sc MLT, Hyderabad",
  "Aware College of Nursing, Hyderabad",
  "Bhaskar Medical College, Yenkapally",
  "Deccan College of Medical Sciences, Hyderabad",
  "Deepthi College of Nursiing, Nalgonda",
  "Devs College of Nursing, Keesara",
  "Devs Homoeopathy Medical College & Hospital, Keesara",
  "Telangana Social welfare Residential Degree College for Women Suryapet",
  "WESLEY PG COLLEGE    ",
  "ARUNDATHI COLLEGE OF NURSING",
  "GOVT DEGREE COLLEGE, DICHPALLY, NIZAMABAD",
  "SVS INSTITUTE OF PARAMEDICAL SCIENCES ",
  "NEIL GOGTE INSTITUTE OF TECHNOLOGY",
  "SHIVAM COLLEGE OF HOTEL MANAGEMENT    ",
  "MNR Homoeopathy medical college and hospital",
  "Telangana Tribal Welfare Residential Degree College of Life Sciences for Womens, Nizamabad (5081)",
  "DHRUVA INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "Spoorthy Women's Degree College",
  "SHREE VASHISTA B.Ed. COLLEGE",
  "ALEXANDER B.ED. COLLEGE",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE (GIRLS) ASIFABAD - 640",
  "SVS DEGREE AND PG COLLEGE ",
  "Balaji Institute of Technology & Science",
  "MRK COLLEGE OF EDUCATION",
  "GOVERNMENT DEGREE COLLEGE, Falaknuma",
  "Kottam Institute of Pharmacy",
  "HYDERABAD SCHOOL OF BUSINESS DEGREE COLLEGE",
  "Siva Sivani Degree College",
  "Sri Sai College of Education, Nizamabad (5288)",
  "MNR College of Engineering & Technology",
  "CSI WESLEY INSTITUTE OF TECHNOLOGY AND SCIENCES",
  "MAK COLLEGE OF PHARMACY, CHILKOOR",
  "Sridevi Women's Engineering College",
  "MNR College of Nursing, Sangareddy",
  "P.G. College, Jogipet",
  "New Sri Medha Degree College",
  "Aurora's  P.G. College (MCA), Ramanthapur",
  "Aurora's P.G. College (MBA), Ramanthapur",
  "St. Joseph's Degree & P.G. College",
  "St. Anns College for Women (Mehdipatnam)",
  "Anwarul-Uloom College  (New Mallepally)",
  "JNTUH UNIVERSITY COLLEGE OF ENGINEERING WANAPRTHY    ",
  "BHAVANI COLLEGE OF NURSING SURYAPET    ",
  "Mahatma Gandhi College of Law",
  "AGRICULTURAL COLLEGE ADILABAD    ",
  "ARUNDATHI INSTITUTE OF MEDICAL SCIENCES",
  "SDM COLLEGE OF LAW ",
  "GOVERNMENT COLLEGE OF NURSING",
  "SREE DATTHA BRINDAVAN INSTITUTE OF TEACHERS EDUCATION ",
  "SAHARA INSTITUTE OF REHABILITATION AND DEVELOPMENT STUDIES",
  "SUN DEGREE COLLEGE",
  "MAHATMA JYOTIBA PHULE TELANGANA BACKWARD CLASSES WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN MEDCHAL",
  "MAHATMA JYOTIBA PHULE TELANGANA BACKWARD CLASSES WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN HYDERABAD",
  "Aurora's PG College MCA",
  "KUMUDINI DEVI COLLEGE OF NURSING",
  "SRI TIRUMALA COLLEGE OF NURSING ",
  "Deccan College of Education",
  "GOVERNMENT DEGREE COLLEGE ,QUTHBULLAPUR",
  "Priyadarshini Degree College, Kutir Complex, Opp. Bus Stand, Kothagudem",
  "Vasavi Degree College, # 2-264, Kallur (V), Kuntala (M)",
  "Sri Ayyappa Swamy Degree College, Makthal",
  "PG CENTRE GADWAL PALAMURU UNIVERSITY",
  "Aurora's Scientific & Technological Research Academy",
  "Telangana Social Welfare Residential Degree College for Women Vikarabad",
  "Telangana Social Welfare Residential Degree College for Women Siddipet",
  "Govt. Degree College for Women, Gadwal",
  "SUCCESS DEGREE COLLEGE",
  "Telangana Social Welfare Residential Degree College for Women LBNagar",
  "Telangana Social Welfare Residential Degree College for Women Medak",
  "Telangana Social Welfare Residential Degree College for Women Jagathgirigutta",
  "GOVERNMENT COLLEGE  OF NURSING, MANCHERIAL",
  "GOVERNMENT COLLEGE OF NURSING ",
  "DURGABAI DESHMUKH COLLEGE OF PHYSIOTHERAPY",
  "GOVERNMENT MEDICAL COLLEGE , VIKARABAD",
  "GOVERNMENT MEDICAL COLLEGE, RAMAGUNDAM",
  "GOVERNMENT COLLEGE OF NURSING",
  "CMR COLLEGE OF NURSING",
  "CMR INSTITUTE OF MEDICAL SCIENCES",
  "CMR COLLEGE OF PHYSIOTHERAPY",
  "GOVERNMENT COLLEGE OF NURSING, PALAIR",
  "FATHER COLOMBO INSTITUTE OF MEDICAL SCIENCES ",
  "Bharat Institute of Technology",
  "RBVRR Women's  College of Pharmacy",
  "Indur Ushodaya Mahila Degree College, Nizamabad (5016)",
  "St. Martin's Engineering College",
  "Telangana Tribal Welfare Residential Degree College for MEN, Kamareddy (5080)",
  "Sharadha Vidyalaya Degree & P.G College ",
  "VIKAS DEGREE COLLEGE, 70-2-51, SIDHULAWADA, SIRCILLA",
  "Vision P.G College",
  "GOVERNMENT MEDIACL COLLEGE,JAGTIAL",
  "GOVERNMENT MEDICAL COLLEGE, KUMURAM BHEEM ASIFABAD",
  "GOVERNMENT MEDICAL COLLEGE JAYASHANKAR BHUPALPALLY",
  "SRI VENKATESHWARA COLLEGE OF EDUCATION",
  "GOVERNMENT DEGREE COLLEGE CHANCHALGUDA",
  "NAGARJUNA GOVT. COLLEGE, NALGONDA",
  "SURYA DEGREE COLLEGE CHANDRUGOUNDA",
  "Govt. Arts & Science College, Kamareddy (5009)",
  "SKNR GOVERNMENT ARTS & SCIENCE COLLEGE, DHARMAPURI ROAD, JAGTIAL",
  "GOVT. DEGREE COLLEGE, KORATLA",
  "GOVERNMENT DEGREE COLLEGE, NERELLA, GAMBHIRRAOPET",
  "GOVERNMENT DEGREE COLLEGE FOR WOMEN, JAGTIAL",
  "GRP Government Degree College, Bhainsa  504 103",
  "KOMATIREDDY PRATHEEK REDDY MEMORIAL DEGREE COLLEGE",
  "Government Degree College, Nirmal  504 106",
  "Govt. Degree College (Kukatpally)",
  "Govt. Degree College (Zaheerabad)",
  "GOVT DEGREE COLLEGE, MALKAJGIRI",
  "GOVERNMENT DEGREE COLLEGE UPPAL ",
  "Gandhi Academy of Technnical Education",
  "Christu Jyothi Institute of Technology & Sciences",
  "Global Institute of Engineering & Technology",
  "Bojjam Narasimhulu Pharmacy College for Women",
  "Bomma Institute of Pharmacy",
  "Nalla Narasimha Reddy Education Society Group of Institutions",
  "Pallavi Engineering College",
  "SRM PG College(MBA)",
  "Avanthi Institute of Engineering & Technology",
  "Bomma Institute of Technology Science",
  "Malla Reddy Institute of Technology",
  "Vaagdevi Pharmacy College",
  "Rishi M.S. Institute of Engineering & Technology for Women",
  "Anurag Group of Institutions",
  "MLR Institute of Technology",
  "Brilliant Institute of Engineering & Technology",
  "CMR Engineering College",
  "Global College of Pharmacy",
  "Swami Vivekananda Institute of Technology",
  "SHADAN COLLEGE OF NURSING",
  "Nethaji Institute of Pharmaceutical Sciences",
  "Jayamukhi Institute of Pharmaceutical Sciences",
  "Samskruti College of Engineering & Technology",
  "Malla Reddy College of Engineering",
  "Hyderabad Presidency College",
  "APOORVA INSTITUTE OF MANAGEMENT & SCIENCES, BHUPATHIPOOR",
  "SRI VIVEK DEGREE COLLEGE NUTHANKAL(4091)",
  "Teegala Krishna Reddy College of Pharmacy",
  "Anu Bose Institute of Technology",
  "Ksatriya College of Engineering",
  "KBR Engineering College",
  "Nobel College of Engineering & Technology for Women",
  "Malla Reddy Institute of Technology & Sciences",
  "Avanthi Institute of Pharmaceutical Sciences",
  "Netaji Institute of Engineering & Technology",
  "Mahatma Gandhi Institute of Technology",
  "Venkateswara Institute of Pharmaceutical Sciences",
  "CMR College of Engineering & Technology",
  "Nigama Engineering College",
  "J J College of Pharamcy",
  "CMR Institute of Technology",
  "MLR Institute of Pharmacy",
  "Teja College of Pharmacy",
  "SIDDHARTHA INSTITUTE OF TECHNOLOGY AND SCIENCES",
  "Vijaya Engineering College",
  "Bhaskar Engineering College",
  "Ganapathi Engineering College",
  "St. Peter's Engineering College",
  "St. Mary's College of Pharmacy",
  "Princeton Institute of Engineering & Technology For Women",
  "Hyderabad Institute of Technology & Management",
  "Sri Venkateswara Engineering College",
  "Visvesvaraya College of Engineering Technology",
  "Jyothishmathi Institute of Technological Sciences, Thimmapur",
  "Sree Dattha Institute of Pharmacy",
  "Malla Reddy College of Engineering & Technology",
  "JNTUH College of Engineering Jagityala",
  "Sree Chaitanya Institute of Pharmaceutical Sciences",
  "Princeton College of Pharmacy",
  "Abdul Kalam Institute of Technological Sciences",
  "Government Degree College(Sciences) Nagarkurnool.",
  "CAT Degree College",
  "PRIYADARSHANI DEGREE COLLEGE, HUZURNAGAR",
  "Scient Institute of Technology",
  "SRM PG College(MCA)",
  "Swami Vivekananda Institute of Pharmaceutical Sciences",
  "Medak College of Engineering & Technology",
  "Shadan College of Pharmacy",
  "St. Mary's Group of Institutions",
  "Holy Mary Institute of Technology & Science",
  "JNTUH College of Engineering Hyderabad",
  "Siddhartha Institute of Technology & Science",
  "Marri Educational Society's Marri Laxman Reddy Institute of Technology and Management",
  "Moonray Institute of Pharmaceutical Sciences",
  "Anurag Pharmcy College",
  "Sana college of Pharmacy",
  "Kamala Institute of Technology & Science",
  "Indur Institute of Engineering & Technology",
  "DRK Institute of Science & Technology",
  "St. Mary's Engineering College",
  "Aizza College of Engineering & Technology",
  "Sri Sai Educational Society's Group of Institutions",
  "Sana Engineering College",
  "Shadan Women's College of Engineering & Technology",
  "GOVT DEGREE COLLEGE KOLLAPUR",
  "CHALLENGERS DEGREE COLLEGE",
  "Keshav Memorial Institute of Technology",
  "Vijeta Degree College, Wanaparthy",
  "St. Marry College of Education, Mahabubnagar",
  "Nalanda College of Education, Mahabubnagar",
  "Sree Sai Degree College, Kalwakurthy",
  "Govt. Degree College, Amrabad",
  "N. T.R. Govt. Degree & P.G College for (W), Mahabubnagar",
  "Govt. Degree College, Shadnagar",
  "Sri Vani Degree College, Wanaparthy",
  "Sri  Srinivasa Degree College, Kollapur",
  "Sri Bijju Ananthaiah Memorial Degree College, Shadnagar",
  "Carlo Bovini Memorial Degeree College, Kalwakurthy",
  "MALD Govt. Degree College, Gadwal",
  "Sri Chaitanya Degree & P.G College, Mahabubnagar",
  "Gayathri Degree & P.G College, Wanaparthy",
  "Spoorthi Degree College, Kothakota",
  "S.V. M. Degeree & P.G College, Gadwal",
  "Govt. Degree & P.G College for Men, Wanaparthy",
  "Vikas Degree College, (Co-Education), Atmakur",
  "Swamy Vivekananda Degree & P.G College, MBNR",
  "Sri Shiva Sai Degree College, Ieej",
  "Vidya Degree College, Marikal",
  "Scholors College of Education, Wanaparthy",
  "Govt. College of Teacher Education, Mahabubnagar",
  "Sri Bramarambika Mallikarjuna College of Education, Kalwakurthy",
  "Venkata Sai College of Teacher Education, Devarakadra",
  "Sri Vekateshwara Swamy College, Kadthal",
  "Adarsha Degree & P.G College, Mahabubnagar",
  "Vignan Degree College, Shadnagar",
  "Saraswathi Degree College, Marikal",
  "Sri Chittem Narsi Reddy Memorial Govt. Degree College, Narayapet",
  "Aakash Degree College, Nagarkurnool.",
  "MAHATMA JYOTHIBA PHULE TELANGANA BC WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN",
  "Triveni Degree College, Achampet",
  "Govt. Degree College , Kalwakurthy",
  "S.V.M College of Education, Gadwal",
  "ST. JOSEPHS DEGREE COLLEGE (SHAIKPET)",
  "Navabharathi College of Education, Pebbair",
  "S.V.Govt.Oreintal College, Palem",
  "Ushodaya College of Education, Wanaparthy",
  "Manasa College of Education, Kothakota",
  "Govt. Degree College (Arts & Commerce), Nagarkurnool",
  "Sri Venkateshwara Government Arts & Science College",
  "C.Laxma Reddy College of Education, Telkapally",
  "Viswashanti Degree College, Alam pur 'X' Road",
  "Geethanjali Degree College,  Nawabpet",
  "Govt. Degree College , Kodangal",
  "Niveditha Degree College, Kothakota",
  "Sadhana Degree College, Nagarkurnool",
  "Sri Veerabadra Degree College, Koilkonda",
  "Sri U. M. Govt. Degree College, Kondanagula",
  "Vivekavardhani Degree College, Kothagudem",
  "Krishnaveni Degree College, Vidyanagar, Adilabad (Manjeera)",
  "Lal Bahadur College of Education, Warangal",
  "Kakatiya Degree College, Post Office Road, Sathupally (SHR)",
  "Vivekavardhini Degree College, Near Bus Stand, Mancherial",
  "Sri Gaayathri College of Management Sciences, Mulug Road, Warangal",
  "Muduganti Suryamma College of Education Rajampet, Asifabad",
  "Bharathi Degree College, H.No. 4-4, Near Bus Stand, Wardhannapet, Warangal",
  "Gnana Saraswathi (GSR) Degree College, Nirmal (Adarsha Womens)",
  "College of Teacher Education, Lashkar Bazar, Hanamkonda",
  "Vidya Bharathi Degree College, Tandoor",
  "JVR Pragathi Degree College, # 3-97, Near Bus Stand, Kusumanchi",
  "St. Lawrence College of Education, Arempula, Khammam",
  "Saahithi Degree College of Science and Arts, No. 14 basthi, Yellandu",
  "Megha Institute of Engineering & Technology For Women",
  "Government Degree College, Mulug",
  "Acharya Degree College, D.No. 18-144/26, Dwarakapet Road, Opp. Fire Station, W.No. 18, Narsampet",
  "KLR College of Education, Paloncha",
  "Vikas Degree College, 1-3-85, Mahabubabad",
  "Shivani Arts & Science Degree College for Women, Maruthi Nagar, Mandamarri",
  "Vagdevi Arts & Science Degree College,  4-3-41, Opp. New Bus Stand, Bhuktapur, Adilabad",
  "Jayamukhi Institute of Management Sciences, Maqdumpur, Narsampet, Warangal",
  "Jayamukhi College of Pharmacy, Maqdumpur, Narsampet, Warangal",
  "Government Degree College, Narsampet  506 132",
  "Vidyarthi Degree College, # 1-2-13/1, Ravindranagar, Adilabad",
  "Krishnaveni Degree College, Laxmidevipally, Kothagudem",
  "Mother Theresa Degree College, # 19-4-15/1, Gollagatta Road, Bhadrachalam",
  "Naveena Degree College, Nehru Nagar, Khammam (Gowtham)",
  "Krishnaveni Arts & Science Degree College, H.No. 1-17, Ambedkar Centre, Manuguru",
  "Santhiniketan Degree College, Ayyagaripet, Sathupally",
  "Alluri Institute of Management Sciences, Hunter Road, Hanamkonda",
  "Government Degree College, Paloncha",
  "Singareni Mahila Degree College, # 16-41, Andugulapet (V), Mandamarri",
  "Sacred Heart College of Arts & Science, Thallampadu",
  "N.B.R. Degree College, Shastri Nagar, Nirmal",
  "Lal Bahadur College, Sardar Patel Road, Warangal  506 007",
  "Mother Theresa College of Education, Sathupally",
  "Silver Jubilee Degree College",
  "Nalanda Degree College, H.No. 2-2-22/A/1,Near RTC Bus stand, Mahabubabad",
  "Sri Chaitanya Degree College, Near Bus Stand, Narsampet",
  "Vishwas Degree College, H.No. 5-13/1, Rajeev Chowrastha, Palakurthy (V&M), Warangal District",
  "Gouthami Degree College, # 1-2-12/15, Shanthinagar, Adilabad",
  "Jangaon Institute of Pharmaceutical Sciences, Jangaon, Warangal",
  "Ganapathy Degree College, H.No. 9-18, Mahadevpur Road, Parkal",
  "Madeena B.Ed. College, Kothagudem",
  "Vashishta Degree College, Manjulapur, Nirmal  504 106",
  "Sri Vishweswara Sanskrit Andhra (SVSA) Kalasala, Station Road, Warangal (Oriental)",
  "Sri Kakatiya Institute of Pharmaceutical Sciences, Unikicherla",
  "Government Degree College, Cherial",
  "St. Peter s Institute of Pharmaceutical Sciences, Vidyanagar, Hanamkonda",
  "Deeksha Degree College, # 1-4-125/5, Adarsha Nagar, Siddapur Road, Nirmal",
  "Government Degree College, Marripeda",
  "Kakatiya Mahila Degree College, Kaoji Sgtreet, Nakkalagutta, Hanamkonda",
  "C.V. Raman Degree College, Hanuman Nagar, Mancherial",
  "TIRUMALA INSTITUTE OF DENTAL SCIENCES  AND RESEARCH CENTRE",
  "PADMANAYAKA COLLEGE OF SPECIAL EDUCATION",
  "Maheshwara College of Education, Maheshwaram, Narsampet",
  "HAINDAVI COLLEGE OF HOTEL MANAGEMENT",
  "S.R. Degree College, Balasamudram, Hanamkonda",
  "Gouthami Degree College for Women",
  "Susheela Memorial Degree College, Didugupadu (V), Madhira",
  "Vaagdevi Institute of Management Sciences, Bollikunta, Warangal (PG)",
  "Vivekananda Degree College, Vidhyanagar colony, Echoda (V&M)",
  "Government Degree College, Thorrur",
  "BBM vaari Gayathri Degree College, Nehru Nagar, Khammam",
  "Arunodaya Degree College",
  "Balaji Institute of Pharmacy, Laknepally (V), Narsampet (M), Warangal",
  "Geethanjali College of Pharmacy",
  "Arkay College of Engineering & Technology",
  "University college of Engineering,Kothagudam",
  "Govt. Degree College (Dubbak)",
  "Anwar Ul-Uloom College of Education",
  "Sri Ramalingeshwara Degree College",
  "Jahanavi Degree College (Narayanaguda)",
  "Azad Institute of Management",
  "Shree Shakthi College of Hotel Management",
  "Reah School of Business Management",
  "Deccan College of Engineering & Technology",
  "Pallavi College of Teacher Education",
  "CMS Degree College",
  "Sharada Degree College",
  "Roots Degree College",
  "Prathibha Degree College",
  "Geetanjali Degree College",
  "Sri Gujarathi Vidhya Mandir Degree College for Women",
  "Al-Quarmoshi Institute of Business Management",
  "St. Agnes College of Education",
  "Siddhartha Degree & P.G College (Kukatpally)",
  "Netra vidhyalayam Degree College for Blind",
  "Govt. Degree College (Hayathnagar)",
  "Muffakham Jah College of Engineering & Technology",
  "Vijaya Bharathi College of Education",
  "Jagruthi Womens Degree College",
  "SRI NARAYANA DEGREE COLLEGE",
  "SREE CHAITANYA DEGREE COLLEGE CHOPPADANDI",
  "Jahanavi Degree College for Women",
  "Little Flower Degree College",
  "Presidency College of Education for Girls",
  "Sri Padmanabha Degree College",
  "Srinivasa Degree College (Medak)",
  "St. Judes College of Education",
  "Holy Trinity College of Education",
  "Ashritha Womens Degree College",
  "Noble College of Education",
  "Jagruthi Degree College (Shankarpally)",
  "Priyadarshini Collge of Computers Science & Research",
  "SR College of Teacher Education",
  "Sai Teja Degree College",
  "TKR Institute of Management & Science",
  "St. Anns Degree College for Women (Malkajgiri)",
  "New Adarsh Degree College",
  "Bharat Degree College for Women",
  "Aurobindo College of Business Management",
  "MNR Teacher Education College",
  "Leo Academy of Hospitality & Tourism Management",
  "Shivani Womens Degree College",
  "RUKMINI College of Management & Commerce",
  "Govt. College of Physical Education",
  "Govt. Degree College (Patancheru)",
  "OGA & Exhibhition Society College of Education",
  "Rishi Degree College",
  "St. Xaviers P.G. College (Gopanpally)",
  "Vignan Degree College (Bandlaguda)",
  "Mesco Degree College",
  "St. Mary's College of Education (LingaReddyPally)",
  "K.V. Ranga Reddy Degree College for Women",
  "RadheKrishna Women's College",
  "Govt. Degree College (Narayankhed)",
  "Andhra Mahila Sabha College of Teacher Education ",
  "Govt. Degree College for Women (Hussainialam)",
  "Jagruthi Degree and P.G. College (Narayanguda)",
  "Marwadi Siksha Samithi Law College",
  "Sri Sai Degree College",
  "Narayana Degree College, KOHEDA",
  "Sri Indu Institute of Management",
  "S.D Signodia College of Arts, Commerce & P.G Centre",
  "Sri Adarsh Degree College",
  "Govt. City College",
  "Vani Degree College for Women",
  "Telangana Saraswatha Parishath Oriental College",
  "IITM Degree College",
  "Sri Ram Degree College",
  "Sindu Degree College",
  "Millennium College of Education",
  "KIMS COLLEGE OF HOTEL MANAGEMENT",
  "Ayesha College of Education, Nizamabad 5296",
  "SRI VIVEKANANDA DEGREE COLLEGE",
  "CKM Arts & Science College(PG), Desaipet, Warangal",
  "Kingston P.G. College",
  "Vanitha Degree College for Women",
  "Pragathi Mahavidyalaya Degree College",
  "SVKMS NARSEE MONJEE INSTITUTE OF MANAGEMENT STUDIES",
  "Little Flower Degree College",
  "C.S.I. Institute of P.G. Studies",
  "P.G. College, Siddipet",
  "Sri Venkateshwara Commerce Degree College",
  "Govt. Degree College (Chavella)",
  "VAGDEVI DEGREE COLLEGE",
  "Nooria Arabia College",
  "Vidyarthi Degree College (Azampura, Medak)",
  "GOVT. DEGREE COLLGE, NAKREKAL",
  "Aurora's PG College (MBA), PANJAGUTTA",
  "Musheerabad Degree College for Women",
  "Pratibha Degree College",
  "Srinivasa Degree College (Narayankhed)",
  "Shadan Institute of Management Studies for Gilrs",
  "Indian Institute of Hotel management & Culinery Arts",
  "Indira Priyadarshini Govt. Degree College for Women",
  "S.R.M. College of Education",
  "G. Pulla Reddy Degree & P.G College",
  "Haji Ghouse Peeran Memorial College",
  "Siddhartha Women's Degree College",
  "HRD Degree & P.G College",
  "SRI KAKATIYA DEGREE COLLEGE, JANGAON, TELANGANA",
  "Modern College of Education",
  "Shadan College of Education",
  "Shadan Institute of Computer Studies (Girls)",
  "Ramadevi College of Education",
  "Manjeera Degree College (Patancheru)",
  "Andhra Yuvathi Mandal School of Business for Women",
  "Vathsalya College of Pharmacy",
  "Dr. Narayana College of Hotel Management",
  "Global Education centre",
  "Poojya Sri Madhavananji College of Education",
  "Anaya Degree College",
  "Pragathi Women's Degree College",
  "AVINASH COLLEGE OF COMMERCE ",
  "University College for Women, Koti",
  "VIKAS CHRISTIAN COLLEGE OF EDUCATION, SURYAPET",
  "DON BOSCO DEGREE COLLEGE, NALGONDA",
  "RKLK DEGREE COLLEGE, SURYAPET",
  "ALIMINETI MADHAVA REDDY MEMORIAL COLLEGE OF EDUCATION, CHOUTUPPAL",
  "RAMAKRISHNA DEGREE COLLEGE, HALIA",
  "SRI CHAITANYA DEGREE COLLEGE, NALGONDA",
  "BHONGIR COLLEGE OF EDUCAITON BHONGIR",
  "DUGYALA GOPAL RAO MEMORIAL DEGREE COLLEGE, THUNGATURTHY",
  "EV REDDY MEMORIAL DEGREE COLLEGE, KODAD",
  "NEW ARABINDO DEGREE COLLEGE, NEREDCHERLA",
  "SRI RAGHAVENDRA COLLEGE OF EDUCATION, NALGONDA",
  "SOGHRA COLLEGE OF TEACHER EDUCAITON, KONDA BHEEMANAPALLY",
  "NALANDA COLLEGE OF ARTS & COMMERCE, CHOUTUPPAL",
  "MARRIGUDA DEGREE COLLEGE, MARRIGUDA",
  "SHANTHINIKETHAN PG COLLEGE, MIRYALAGUDA",
  "CHAITANYA BHARATHI DEGREE COLLEGE, HUZURNAGAR",
  "DON BOSCO PG COOLLEGE NALGONDA",
  "NALANDA DEGREE COLLEGE, NALGONDA",
  "GOVERNMENT DEGREE COLLEGE, CHANDUR",
  "SRI SAI TRIVENI DEGREE COLLEGE, SURYAPET",
  "DVM COLLEGE OF EDUCATION, NALGONDA",
  "Avanthi Degree & P.G. College (MCA), Moosaramnagh",
  "SRI SAI VIKAS DEGREE COLLEGE, KODAD",
  "NALGONDA DEGREE COLLEGE, NALGONDA",
  "JAGRUTHI DEGREE COLLEGE, BHONGIR",
  "SRI NAVABHARAT DEGREE COLLEGE, BHONGIR",
  "SIDDHARTHA DEGREE COLLEGE, SURYAPET",
  "SHANTINIKETAN DEGREE COLLEGE, MIRYALAGUDA",
  "Guru Nanak Institutions Technical Campus",
  "SRI VASAVI DEGREE COLLEGE NAGARJUNA SAGAR",
  "DVM COLLEGE OF BUSINESS MANAGEMENT, CHERLAPALLY",
  "GOVERNMENT DEGREE COLLEGE, RAMMANNAPET",
  "A.V.M COLLEGE OF EDUCATION, NKREKAL",
  "VISION DEGREE COLLEGE",
  "RKLK PG COLLEGE SURYAPET",
  "PADALA DEGREE COLLEGE, THURKAPALLY",
  "Omega Degree College",
  "Telangana Tribal Welfare Degree college(Men) Nagarkurnool at Achampet",
  "SRI LAKSHMI NARASIMHA SWAMY COLLEGE, BHONGIR",
  "SRI VINAYAKA DEGREE COLLEGE, SURYAPETA",
  "SRI VENKATESHWARA DEGREE & PG COLLEGE, KODAD",
  "STANFORD WOMENS DEGREE COLLEGE, BHONGIR",
  "SRI VENKATESHWARA DEGREE COLLEGE, SURYAPET",
  "PRAGATHI DEGREE COLLEGE, CHOUTUPPAL",
  "TAPASYA DEGREE COLLEGE LAKDIKAPOOL",
  "MAHARSHI DEGREE COLLEGE",
  "STANFORD PG COLLEGE, BHONGIR",
  "SRI PRATHIBHA DEGREE COLLEGE, SURYAPET",
  "Shadan Institute of Medical Sciences, Hyderabad",
  "Shadhan Institute of Medical Sciences Teaching Hospital and Research Center, College of Physiotheraphy,Hyderabad",
  "SRI SANTOSH DEGREE COLLEGE, MOTKUR",
  "AVM DEGREE COLLEGE, NAKREKAL",
  "JMJ College of Nursing, Hyderabad",
  "RACE WOMENS DEGREE COLLEGE",
  "PRAGATHI ARTS&SCIENCE DEGREE COLLEGE, TIRUMALGIRI",
  "VIJETHA DEGREE COLLEGE, MIRYALAGUDA",
  "SRI SARASWATHI DEGREE COLLEGE, RAJAPET",
  "SUGUNA DEGREE COLLEGE, KODAD",
  "SRI SATYASAI DEGREE OCLLEGE, DEVARAKONDA",
  "STANFORD COLLEGE OF EDUCATION, HANUMAPUR",
  "SRUJANA DEGREE COLLEGE, HALIA",
  "Pulipati Prasad college of Nursing, Khammam",
  "Sri Sai College of Dental Surgery, Vikarabad",
  "Sri Satyalaxmi College of Nursing, Hyderabad",
  "SRI MALLIKARJUNA DEGREE COLLEGE, NAKREKAL",
  "Vijay Marie College of Nursing, Hyderabad",
  "Vijaya Health Care Academic Society College of Nursing, Kushaiguda",
  "Institute of Preventive Medicine Public Health Lab & Food (H) Administration, Hyderabad",
  "OBS DEGREE COLLEGE ",
  "SRIVENKATESHWARA DEGREE COLLEGE, KONDAMALLEPALLY",
  "Jaya College of Nursing, Warangal",
  "Azam Degree College",
  "SRI NAVABHARAT DEGREE & PG COLLEGE BHONGIR",
  "KIMS College of B.Sc Nursing, Hyderabad",
  "JAGRUTHI PG COLLEGE, BHONGIR",
  "JBM DEGREE COLLEGE, NARAYANPUR",
  "CHAITANYA DEGREE COLLEGE",
  "AL-MADINA COLLEGE OF EDUCATION, NALGONDA",
  "SHANTHINIKETHAN DEGREE COLLEGE KAMPASAGAR",
  "St. Pious X P.G (M.B.A) College for Women",
  "PJRS SAHITHI DEGREE COLLEGE DEVARAKONDA",
  "shiva reddy memorial college of physical education",
  "NEELAM SANJEEVA REDDY MEMORIAL DEGREE COLLEGE",
  "AVM PG COLLEGE, NAKREKAL",
  "RKLK COLLEGE OF EDUCAITON, SURYAPET",
  "Sri Surya College of Nursing, Hyderabad",
  "MAHARSHI DEGREE COLLEGE, SURYAPET",
  "SHANTINIKETHAN COLLEGE OF EDUCAIOTION, MIRYALAGUDA",
  "NAGARJUNA COLLEGE OF EDUCAITON, MIRYALAGUDA",
  "NAGARJUNA PG COLLEGE(MCA), MIRYALAGUDA",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE(GIRLS), JANGAON",
  "Yashoda College of Nursing, Hyderabad",
  "VENNELA INSTITUTE OF BUSINESS ADMINISTRATION, ANNANTHARAM",
  "Malla Reddy Institute of Management",
  "Bhagyaradhi Degree College",
  "St. Ann's P.G. College for Women (Mallapur)",
  "Nava Chaitanya Degree and PG College",
  "Vasundara Degree & P.G College (Co-education) Vidyanagar",
  "Pragnya Womens Degree College ",
  "SRI VAAGDEVI DEGREE COLLEGE",
  "SRI YUVA CHAITANYA DEGREE COLLEGE",
  "PRESIDENCY DEGREE COLLEGE FOR COMMERCE & SCIENCE",
  "NEW MADINA DEGREE COLLEGE FOR WOMEN (CHARMINAR)",
  "Government Degree College, Armoor (5010)",
  "THE PROGRESS DEGREE COLLEGE FOR WOMEN",
  "SRI CHANDRA DEGREE COLLEGE",
  "GESTO CULINARY & HOSPITALITY ACADEMY",
  "LMR DEGREE COLLEGE, KANNAPUR KADAM(M)",
  "VIVEKAVARDHANI DEGREE COLLEGE, D.No. 1-117, Near Bus Stand, GUNDALA, Khammam",
  "SRI GEERVANI COLLEGE OF EDUCATION (B.Ed.)",
  "WESTIN COLLEGE OF HOTEL MANAGEMENT",
  "SIDDHARTHA DEGREE COLLEGE (MOINABAD)",
  "HAINDAVI DEGREE COLLEGE (CHAMAPET)",
  "Megha Women's Degree College",
  "SRI CHAITANYA DEGREE COLLEGE (MADINAGUDA)",
  "ANISH DEGREE COLLEGE",
  "SANJEEVANI COLLEGE OF EDUCATION, KONDAMALLEPALLY",
  "VAAGDEVI COLLEGE OF PHYSICAL EDUCATION",
  "ST. JOSEPH DEGREE COLLEGE, UPPARPALLI",
  "GEETHANJALI DEGREE COLLEGE HABSIGUDA",
  "SRM DEGREE COLLEGE, SHAMSHABAD",
  "AVINASH DEGREE COLLEGE, KUKATPALLY",
  "AVINASH DEGREE COLLEGE, KOTHAPET",
  "HOLY MARY DEGREE COLLEGE, BALANAGAR",
  "SRI SAI VIKAS DEGREE COLLEGE",
  "SILVER JUBILEE DEGREE COLLEGE FOR WOMEN, HABSIGUDA",
  "DR. NARAYANA DEGREE COLLEGE OF COMMERCE & SCIENCE",
  "GREAT INDIA DEGREE COLLEGE",
  "AKSHARA DEGREE COLLEGE",
  "SAANVI DEGREE COLLEGE FOR WOMEN",
  "INFANT JESUS DEGREE COLLEGE",
  "SADHANA DEGREE COLLEGE -7069",
  "TAPASYA DEGREE COLLEGE NARAYANGUDA",
  "SRI VENKATESHWARA DEGREE COLLEGE (PARGI)",
  "MEGHA DEGREE COLLEGE FOR WOMEN",
  "St Xavier Degree College",
  "Gurunanak Institute of Pharmacy",
  "Nalla Reddy College of Nursing, Hyderabad",
  "Aurora's Engineering College",
  "Prathap Narender Reddy College of Pharmacy",
  "Vaasavi Degree College, H.No. 5-51,Pulluri Ramaiah Palli,Bhupalpally506 168",
  "DR VRK LAW COLLEGE",
  "University Law college",
  "Gayathri Degree College for Women",
  "Acharya Jayashankar Degree College (Narayankhed)",
  "Omega Degree College (Habsiguda)",
  "Noble Degree College",
  "JYOTHISHMATHI COLLEGE OF EDUCATION, RAMAKRISHNA COLONY, NUSTULAPUR, KARIMNAGAR",
  "Royal Degree College",
  "ALPHORES WOMENS DEGREE & PG COLLEGE JAGTIAL ROAD, KARIMNAGAR",
  "Shadan Degree College for Women",
  "TRINITY COLLEGE OF EDUCATION, STATION ROAD, PEDDAPALLY",
  "Kranthi (Alpha) Degree College",
  "Siddhartha College of Education",
  "JYOTHI COLLEGE OF EDUCATION, THADOOR (V), SIRCILLA (M), KNR",
  "St .Anthony Degree College",
  "SRI SHIVANI INSTITUTE OF MANAGEMENT, GANAGADHARA,KARIMNAGAR",
  "Suprabhat Institute of Computer Studies",
  "VIvekananda P.G College",
  "Stanley Degree And P.G College for Women",
  "Sultan-Ul-Uloom Law College",
  "LOYOLA COLLEGE OF EDUCATION, REKURTHI, MALKAPUR (P), KARIMNAGAR",
  "VODITHALA SRINIVASA RAO DEGREE COLLEGE HUZURABAD",
  "Sai Sudhir P.G. College",
  "MAHARSHI DEGREE COLLEGE,  GODAVARIKHANI",
  "VANI NIKETAN DEGREE & PG COLLEGE , MUKARAMPURA, KARIMNAGAR",
  "SHIVANI DEGREE & PG COLLEGE , MANKAMMATHOTA, KARIMNAGAR",
  "Government Degree College, Luxettipet",
  "SURYA COLLEGE OF EDUCATION, Vill&Post: Nukapally  Mond: Malyala, JAGTIAL",
  "TRINITY COLLEGE OF EDUCATION,  PEDDAPALLY",
  "GANDHI MEMORIAL DEGREE & PG COLLEGE, MARKANDEYA COLONY, GODAVARIKHANI",
  "ALPHORES INSTITUTE OF MATHEMATICAL SCIENCES, VAVILALAPALLY, KARIMNAGAR",
  "Modern College of Education, Nagarkurnool",
  "Chaitanya Degree college, Achampet",
  "Gayathri College of Education, Wanaparthy",
  "K R K REDDY COLLEGE OF EDUCATION",
  "N.B. Science Degree College",
  "Omega P.G. College - MCA,",
  "OMEGA INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "Vignana Jyothi Institute of Arts & Sciences (Co-Ed)",
  "Adarsh College of Teacher Education, Mahabubnagar",
  "Vasavi Degree College, RR Complex, Court Road, Mahabubabad",
  "Geethanjali Degree College for Women, H.No. 5-11-139 & 140, Naimnagar, Hanumakonda",
  "Kavitha Degree College, Upendrayya Nagar, Khammam",
  "Sri Datta Brindavana Institute of Teacher Education, Narayanpet",
  "Sri Ramakrishna Vivekananda D.C, Kosgi",
  "Govt. Degree College , Kollapur",
  "Veerabhadra Degree College,Pebbair",
  "GSN College of Education, Achempet",
  "Sai Krishna P.G College, Wanaparthy",
  "Sri Krishnaveni Degree College, Kalwakurthy",
  "Adarsha College of Education, Narayanpet",
  "R.D. Women s Degree College, H.No. 5-10-50/A, Kishanpura, Hanamkonda",
  "Gowthami Degree College, Mahabubnagar",
  "Sri Vasavi Degree College, Mahabubnagar",
  "Sardar Vallabhai Patel D. C, Shadnagar",
  "Vivekananda College of Education, Chattanpalli",
  "Chanakya Degree College, # 5-11-732 (New), Priyadarshini Nagar, Nirmal",
  "Masterji Degree College, Hunter Road, Subedari, Hanamkonda",
  "Kakatiya Government College, Hanamkonda  506 001",
  "Ekashila College of Education, Hyderabad Road, Jangaon",
  "Government Degree College, Manuguru",
  "Lahoti Degree College, Kondanagal",
  "Jyothishmathi Institute of Technology & Science, Nusthulapur",
  "Kotha Kota Sri Vidya Degree College, Kothakota",
  "Avanthi's PG & Research Academy",
  "Govt. Degree College for Women, Wanaparthy",
  "MVSR Engineering College",
  "Pragathi Arts & Science Degree & P.G College, Achampet",
  "Government Degree College, Madhira",
  "Goverdhan Reddy Degree College,Telkapally",
  "Vivekavardhani Degree College for Women, Laxmidevipally, Kothagudem",
  "Vinuthna Institute of Technology & Science, Hasanparthy (V&M), Warangal",
  "Scholars Degree College, Wanaparthy",
  "Noor College of Education, Shadnagar",
  "KESHAV MEMORIAL ENGNEERING COLLEGE",
  "Amritha Akshitha College of Education, Metpally, Wanaparthy",
  "Karimala Sai Degree College,  6-60, Beet Bazar, Luxettipet",
  "Vivekananda College of Computers, Shadnagar",
  "Govt. Degree College , Atmakur",
  "Al-Madina College of Education, Mahabubnagar",
  "GOVERNMENT MEDICAL COLLEGE YADADRI",
  "Kakatiya Institute of Technology & Science, Yerragattu Hillocks, Bheemaram, Hasanparthy, Warangal",
  "MAHILA DAKSHATA SAMITHI AND BANSILAL MALANI COLLEGE OF NURSING",
  "Sri Aurobindo Institute of Education, Jangaon",
  "Nirmal Hriday Degree College, # 4-55, Opp. Railway Station, Singareni (V&M)",
  "Sri Vivekananda College of Education, Mahabubabad",
  "Pulipati Prasad College of Pharmaceutical Sciences, Khammam",
  "Dr. Muscu Madhusudan Reddy College of Physical Education ",
  "SVR College of Education, Madhira",
  "Bhavitha Degree College, # 8-1-1/3, Shamshir Nagar, Ward No. 8, Bellampally",
  "UNIVERSITY COLLEGE OF ARTS AND SOCIAL SCIENCES",
  "S.V. Degree College, Market Road, Parkal",
  "Vignana Bharathi Degree College, H.No. 5-4-109, Kankara Boad, Maha",
  "Vaagdevi College of Engineering, Bollikuknta, Warangal",
  "Nishitha Degree College, Nizamabad (5022)",
  "Girraj Government College, Nizamabad (5005)",
  "Chaitanya Institute of Pharmaceutical Sciences, Rampur (V), Dharmasagar (M), Warangal",
  "Sri Rama Krishna Degree College, Dwarakapet Road, Narsampet",
  "Priyadarshini Degree College, Nehru Nagar, Khammam",
  "Browns College of Education, Ammapalem, Thanikella, Khammam",
  "Avanthi Degree & PG college (MBA), MoosaramBagh",
  "VAINAVI COLLEGE OF HOTEL MANAGEMENT",
  "Sree Gayathri Degree College Ibrahimpatnam",
  "Government Degree College  Kaghaznagar",
  "RAMAKRISHNA DEGREE COLLEGE JHANSI ROAD KORUTLA",
  "SRI ARUNODAYA DEGREE COLLEGE KATHALAPUR",
  "Goka Raju Ranga Raju Institute of Engineering & Technology",
  "ALEXANDER DEGREE COLLEGE",
  "ANURAG DEGREE COLLEGE SULTANABAD",
  "SRI SHIVANI DEGREE COLLEGE,SIRCILLA",
  "SSJ College of Pharmacy",
  "Haindavi Degree & PG College",
  "UNIVERSITY P G CENTER GADWAL",
  "Guru Nanak Institute of Technology",
  "VAISHNAVI SCHOOL OF ARCHITECTURE AND PLANNING",
  "Karthikeya Degree College",
  "MOTHER TERESA PHARMACY COLLEGE",
  "Anurag Engineering College",
  "Sphoorthy Engineering College",
  "TRR College of Engineering",
  "ST FRANCIS INSTITUTE OF MANAGEMENT STUDIES",
  "Anurag College of Engineering",
  "MJR COLLEGE OF EDUCAITON, MIRRIGUDA",
  "Sri Sai Degree College, Kunavaram Road, Bhdrachalam",
  "Vaageswari Institute of Management Sciences",
  "CSIIT COLLEGE OF ARCHITECTURE",
  "Maitreyi Degree College for Women",
  "Tata Institute of Social Sciences",
  "Maharshi Degree College, Mulug  506 343",
  "Azaan College of Education, Rakasipet, Bodhan, Nizamabad (5292)",
  "Sai Siddhartha Degree College, Bheemgal, Nizamabad (5072)",
  "Bandari Srinivas Institute of Technology",
  "Success Degree College of Commerce and Science, HB Colony, Armoor, Nizamabad (5071)",
  "JNTUH-School of Information Technology, ",
  "KVM COLLEGE OF PHYSICAL EDUCATION, KULKACHERLA",
  "Rainbow Degree College, Jukkal, Nizamabad (5067)",
  "Siddartha Degree College, Armoor, Nizamabad (5065)",
  "JNTUH Institutte of Science and Technology",
  "Sai Siddhartha Degree College, Govindpally (V), Dharpally, Nizamabad (5061)",
  "TRINITY COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Joginpally B.R Engineering College",
  "RGR Siddhanthi College of Pharmacy",
  "SPANDANA DEGREE&PG COLLEGE, SURYAPET",
  "SIDDARTHA DEGREE&PG COLLEGE, NALGONDA",
  "Narendra Degree College, Sirikonda, Nizamabad (5058)",
  "ASHOKA SCHOOL OF PLANNING AND ARCHITECTURE",
  "Medha Degree College, Navipet (V&M), Nizamabad (5018)",
  "Govt. Degree College, Bheemgal, Nizamabad (5073)",
  "Government Degree College, Dharpally, Nizamabad (5063)",
  "Kanishka Womens Degree College, Bheemaram",
  "University College of Engineering Osmania University Hyderabad",
  "UNIVERSITY COLLEG OF TECHNOLOGY AUTONOMOUS OSMANIA UNIVERSITY",
  "University College for Women Subedari",
  "UNITY PG COLLEGE, RAIGIR",
  "JNTUH College of Engineering Manthani",
  "Trinity College of Engineering & Technology",
  "BVRIT Hyderabad College of Engineering for women.",
  "Telangana Social Welfare Residential Degree College for Women,Mahabubnagar",
  "Nethaji Degree College, Cherial (V&M)",
  "Aurora's Scientific and Technological Institute",
  "KESHAVA DEGREE COLLEGE",
  "Sri Visweswaraiah Institute of Technology & Science",
  "Malla Reddy Institute of Engineering and Technology",
  "MADHU DEGREE COLLEGE(589)",
  "Sri Chaitanya Institute of Technology and Research (SCIT)",
  "TELANGANA TRIBAL WELFARE DEGREE COLLEGE FOR WOMAN SHADNAGAR",
  "Shadan College of Engineering & Technology",
  "Ratna Degree College, Opp: Petrol Bunk, Madnoor, Nizamabad (5053)",
  "Arjun College of Technology & Science",
  "Pragna College of Education",
  "COLLEGE OF FINE ARTS",
  "Telangana Tribal Welfare Residential Degree College for Men",
  "SRI VIDYABHARATI DEGREE COLLEGE, NALGONDA",
  "SCHOOL OF PLANNING AND ARCHTECTURE",
  "University College of Engineering & Technology  for Women",
  "SRI VENKATESHWARA COLLEGE OF ARCHITECTURE",
  "Ahmed College of Education, Bhiknoor (5295)",
  "Vijaya Degree College, S.N Puram (V), Varni (5057)",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL DEGREE COLLEGE (GIRLS) MAHABUBABAD",
  "Dhanvanthri College of Pharmaceutical Scienes",
  "Spoorthy Degree College (Sangareddy)",
  "Narsimha Reddy Engineering College",
  "Bhoj Reddy Engineering College for Women",
  "St.Marys Integrated Campus Hyderabad",
  "VINAYAKA COLLEGE OF PHYSICAL EDUCATION",
  "Rama Krishna Degree & PG College, Kamareddy (5024)",
  "College of Agricultural Engineering and Technology, Sangareddy",
  "B S BUGUDI BED COLLEGE",
  "SRI RANGANAYAKA SWAMY COLLEGE OF PHARMACY",
  "Galaxy Degree college (Shalibanda)",
  "JBR ARCHITECTURE COLLEGE",
  "College of Agriculture, Rajendranagar",
  "Agricultural College, Jagtial",
  "K.G Reddy College of Engineering & Technology",
  "Agriculture College, Palem",
  "College of Food Science and Technology, Rudrur",
  "Balaji Institute of Management Sciences",
  "College of Home Science, Hyderabad",
  "Brilliant Minds And Resources College of Education",
  "Agricultural College, Aswaraopet",
  "DR V R K INSTITUTE OF TECHNOLOGY    ",
  "JAWAHARLAL NEHRU COLLEGE OF EDUCATION MALLARAM ROAD VEMULAWADA",
  "ARUNDATHI COLLEGEOFMEDICALLABTECHNOLOGY",
  "GOVERNMENT DEGREE COLLEGE    ",
  "NEW SIDDHARTHA DEGREE COLLEGE",
  "Bhavans Vivekananda College of Science, Humanities & Commerce",
  "Jagruti PG.College of Management Studies",
  "CULINARY GURU INSTITUTE OF HOTEL MANAGEMENT",
  "IACG MULTIMEDIA COLLEGE",
  "St. George Degree College for Women",
  "Sai Spurthi Institute of Technology",
  "Sri Chaitanya Degree College (Ghatkesar)",
  "MJPTBCWR LAW COLLEGE FOR WOMEN HANUMAKONDA ",
  "M C Gupta College of Business Management",
  "GOVT DEGREE COLLEGE, MADNOOR ",
  "GOVERNMENT MEDICAL COLLEGE NAGARKURNOOL",
  "GOVERNMENT DEGREE COLLEGE RAMAYAMPET",
  "CHANDANA DEGREE COLLEGE, BAZARHATHNOOR",
  "Unique Degree College for Women",
  "JNIAS SCHOOL OF PLANNING AND ARCHITECTURE",
  "Kakatiya Institute of Management Studies(MBA)",
  "VIVEKANANDA PG COLLEGE, JAGTIAL ROAD, KARIMNAGAR",
  "VIVEKANANDA DEGREE COLLEGE, KARIMNAGAR",
  "MASTERS DEGREE COLLEGE,  BHAGATH NAGAR, KARIMNAGAR",
  "Ashok Institute of Engineering & Technology",
  "Joseph Sriharsha & Mary Indraja Educational Society's St. Mary's Group of Institutions",
  "St. Paul's College of Management & Information Technology",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE(BOYS), BOATH AT ADILABAD",
  "Sri Balaji Dental College",
  "TTWRDC(GIRLS) Dammapeta At Ankampalem",
  "MJPTBCWR LAW COLLEGE FOR MEN, KANDUKUR, RR DISTRICT",
  "Gouthami Degree College, 4-76, BC Colony, Old Bazar,Mahabubabad 506 101",
  "GOVERNMENT DEGREE COLLEGE ECHODA    ",
  "Babu Jagjivan Ram Govt. Degree College VITTALWADI HYDERABAD",
  "Sita Ramaiah College of Nursing, Hyderabad",
  "AVANTHI DEGREE COLLEGE",
  "ANURAG DEGREE COLLEGE SIRCILLA",
  "Mother Theresa College of B.Sc Nursing, Hyderabad",
  "Navodaya Degree for women, Gadwal",
  "Panineeya Mahavidyala Institute of Dental Sciences and Research Center, Hyderabad",
  "Telangana social Welfare Residential Degree College for Women - Bhupalpally, Jayashankar Bhupalpally Dist.",
  "St. Anns College of Education, Venkatapuram (V), Mudigonda (M)",
  "SRI AUROBINDO COLLEGE OF EDUCATION",
  "DAVID MEMORIAL COLLEGE OF HOTEL MANAGEMENT",
  "AIMS COLLEGE OF HOTEL MANAGEMENT  AND CATERING TECHNOLOGY",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE (GIRLS), KOTHAGUDEM",
  "Sree Raghavendra Vidyalayam, Armoor (5297)",
  "MILITARYCOLLEGE OF ELECTRONICS AND MECHANICAL ENGINEERING",
  "MASTERS DEGREE COLLEGE,AMANGAL",
  "Kakatiya Institute of Technolgy & Science for Women",
  "Sultan Ul Uloom College of  Pharmacy",
  "ISL Engineering College",
  "Geetanjali College of Engineering & Technology",
  "Jayamukhi Institute of Technological Sciences",
  "Swami Ramananda Thirtha Institute of Pharmaceutical Sciences",
  "BHADRUKA DEGREE COLLEGE",
  "VIGNAN DEGREE COLLEGE (ATTAPUR)",
  "AKSHAYA DEGREE COLLEGE",
  "Kommuri Pratap Reddy Institute of Technology",
  "CVR College of Engineering",
  "HIDAYAH DEGREE COLLEGE",
  "Mahaveer Institute of Science &Technology",
  "KESHAV MEMORIAL COLLEGE OF ENGINEERING (KMCE)",
  "GREATER COLLEGE OF EDUCATION",
  "Gokaraju Rangaraju College of Pharmacy",
  "BHARATHI DEGREE COLLEGE (C CODE 4092)",
  "SVVVS College",
  "DRK College of Engineering & Technology",
  "Sri Indu College of Engineering & Technology",
  "JMJ Degree College for Women, Karunapuram, Peddapendial  506 151",
  "RVM COLLEGE OF PHYSIOTHERAPY",
  "Telangana Social Welfare Residential Degree College for Women - Nalgonda",
  "Care College of Pharmacy, Oglapur (V), Athmakur (M), Warangal",
  "CVM College of Pharmacy",
  "APOORVA DEGREE COLLEGE, KARIMNAGAR",
  "MAHBOOBIA PANJETAN DEGREE COLLEGE",
  "Gandhian College of Education",
  "Sri Indu Institute of Engineering and Technology",
  "VRK DEGREE COLLEGE JADCHERLA",
  "NSV WOMENS DEGREE COLLEGE",
  "Dr. Rajendra Prasad B.Ed. College, Asifabad",
  "Chaitanya Degree College, College Road, Mancherial",
  "Government Degree College for Women, Adilabad",
  "Sneha Degree College, Government Hospital Road, Yellandu",
  "ISLAMIA COLLEGE OF LAW    ",
  "Mallareddy College of Nursing, Suraram, Hyderabad",
  "Singareni Collieries Womens Degree College, Kothagudem",
  "Government Degree College, Mancherial  504 208",
  "Malla Reddy Dental College for Women",
  "Malla Reddy Institute of Dental Sciences",
  "Vamsee Vinay Degree College, Vemsoor Road, Sathupally",
  "Nalla Malla Reddy Engineering College",
  "CMR College of pharmacy",
  "Malla Reddy Medical College for Women",
  "KSR Degree College for Women, D.No. 19-214,Warangal Road, Narsampet",
  "VAAGDEVI WOMENs DEGREE COLLEGE, DEVARAKONDA",
  "SRI VENKATESHWARA COLLEGE OF EDUCATION, KONDAMALLEPALLY",
  "Malla Reddy Institute of Medical Sciences",
  "Malla Reddy Institute of Pharmaceutical Sciences",
  "GOVERNMENT MEDICAL COLLEGE    ",
  "TELANGANA SOCIAL WELFERE RESIDENTIAL DEGREE COLLEGE (WOMEN) ",
  "Kinnera College of Nursing, Khammam",
  "TSWR Degree College for Women, Warangal West",
  "VISHWATEJA DEGREE COLLEGE, MULUGU",
  "SRI VIVEKANANDA DEGREE COLLEGE, NELLIKUDURU",
  "SREE SREE VEERABHADRA SWAMY DEGREE COLLEGE, KURAVI",
  "Sri VIdya Degree College",
  "SREE SAI DEGREE COLLEGE, KODAKANDLA",
  "VMS DEGREE COLLEGE, RAJENDRA NAGAR",
  "SAHITHI DEGREE COLLEGE, MADDUR",
  "RUDRAMADEVI MAHILA DEGREE COLLEGE, KHANAPUR",
  "KAKATIYA DEGREE COLLEGE, GOVINDARAOPET",
  "KAKATIYA DEGREE COLLEGE,  SANGEM",
  "SRI VIKAS DEGREE COLLEGE, JULURPAD",
  "PIMTECH College of B.Sc MLT, Khammam",
  "SRI KRISHNA GOWTHAMI DEGREE COLLEGE, DAMMUGUDEM",
  "VAGHESHWARI DEGREE COLLEGE, UTHKOOR, LUXETTIPET",
  "SRI RAJA RAJESWARA DEGREE COLLEGE, BAZARHATHNOOR",
  "SRI HARSHA DEGREE COLLEGE, GOUTHAMI NAGAR, MANCHERIAL",
  "SAI CHAITANYA DEGREE COLLEGE, NERADIGONDA",
  "Vishnu Institute of Pharmaceutical Education and Research",
  "PADMAVATHI DEGREE COLLEGE, SARANGAPUR",
  "PADMAVATHI DEGREE COLLEGE, BAZARHATHNOOR",
  "JADHAV RADHA BAI DEGREE COLLEGE, GUDIHATHNOOR",
  "EKALAVYA DEGREE COLLEGE, JAM, SARANGAPUR",
  "AJMERA REKHA SYAM (ARTS) DEGREE COLLEGE, PONKAL, JANNARAM, ADILABAD",
  "SIDDHARTHA COLLEGE OF PHYSICAL EDUCATION, IBRAHIMPATNAM",
  "DECCAN SCHOOL OF PHARMACY",
  "SRI CHAKRA COLLEGE OF EDUCATION, IBRAHIMPATNAM",
  "GOVERNMENT ENGINEERING COLLEGE, KOSGI    ",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL LAW COLLEGE FOR MEN",
  "PRAGATHI WOMEN'S DEGREE COLLEGE, CHANDA NAGAR",
  "Vijaya Sai Degree College",
  "VIVEKANANDA DEGREE COLLEGE, CHEVELLA",
  "VEDA DEGREE COLLEGE, CHAMPAPET",
  "ABHYASA WOMEN'S COLLEGE",
  "ANNIE BESANT WOMEN'S COLLEGE, SAROORNAGAR",
  "Jangaon College of Education, Jangaon",
  "SADHANA DEGREE COLLEGE FOR WOMEN",
  "PRATHIBA DEGREE COLLEGE FOR WOMEN, KUKATPALLY",
  "MAHAVEER DEGREE COLLEGE OF ARTS, COMMERCE & SCIENCE, RAJENDRANAGAR",
  "MAHARSHI DEGREE COLLEGE, DOMMERAPOCHAMPALLY",
  "GEETANJALI DEGREE COLLEGE, NAWABPET",
  "NEW GOVTERNMENT DEGREE COLLEGE, SERILINGAMPALLY",
  "CAPITAL DEGREE COLLEGE, L B NAGAR",
  "NEW PAGE DEGREE COLLEGE, HAYATHNAGAR",
  "CHAITANYA DEGREE COLLEGE, CHEVELLA",
  "TRINITY COLLEGE OF HOTEL MANAGEMENT, TARNAKA",
  "PRINCESS DURRU SHEHVAR COLLEGE OF EDUCATION FOR WOMEN, YAKATPURA",
  "SREE RATNA DEGREE COLLEGE FOR WOMEN",
  "SYNERGY DEGREE COLLEGE, MAINAPALLY",
  "SSK DEGREE COLLEGE FOR WOMEN, DHOOLPET",
  "SURABHI COLLEGE OF NURSING",
  "ANNAPURNA COLLEGE OF FILM AND MEDIA    ",
  "Indian Institute of Management and commerce",
  "Indira Degree College,  1-15-31, 32, Balaji Nagar, Sirpur Kaghaznagar",
  "SYMBIOSIS INSTITUTE OF TECHNOLOGY, HYDERABAD",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL DEGREE COLLEGE (WOMEN)",
  "HASINI COLLEGE OF PHYSICAL EDUCATION",
  "K.G.R Institute of Technology & Management",
  "PRATHIMA RELIEF INSTITUTE OF HEALTH SCIENCES",
  "GOVERNMENT COLLEGE OF NURSING, KOTHAGUDEM",
  "SAHITHI WOMENS DEGREE COLLEGE METPALLY",
  "COLLEGE OF DEFENCE MANAGEMENT",
  "M.V.S. Government Arts & Science College, Mahabubnagar",
  "SRI INSTITUTE OF HOTEL MANAGEMENT AND CULINARY ARTS",
  "EXCEL COLLEGE OF HOTEL MANAGEMENT",
  "CHENNIAS AMIRTA INSTITUTE OF HOTEL MANAGEMENT",
  "PRASHANTHI COLLEGE OF NURSING, REDDY COLONY, HANUMAKONDA",
  "CMR INSTITUTE OF HEALTH SCIENCES",
  "B.V Raju Institute of Technology",
  "TAPASAYA DEGREE COLLEGE  CHAITANYAPURI",
  "Prerana Degree College, Block No. 12, Islampura, Mancherial",
  "Auroras Legal Sciences Academy",
  "SURABHI COLLEGE OF PHYSIOTHERAPY",
  "CHANDANA POST BASIC BSC NURSING COLLEGE",
  "GOVERNMENT DEGREE COLLEGE W N ASIFABAD",
  "GOVERNMENT COLLEGE OF NURSING,MAHABUBABAD",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN SURYAPET",
  "DEVNAR DEGREE COLLEGE FOR BLIND",
  "Government Degree College, Nelakondapally",
  "UNIVERSITY COLLEGE OF MANAGEMENT HYDERABAD",
  "PG CENTRE, WANAPARTHY, PALAMURU UNIVERSITY",
  "INTERNATIONAL DEGREE COLLEGE",
  "Vaagdevi Engineering College",
  "MADHIRA INSTITUTE OF TECHNOLOGY & SCIENCE, KODAD",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN, MANCHERIAL",
  "Government Degree College, Bhupalpally",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL DEGREE COLLEGE  FOR WOMEN, Budhera, Munipally Mandal, Sangareddy Dist",
  "SYMBIOSIS Law School, Hyderabad",
  "SYMBIOSIS Institute of Business Management, Hyderabad",
  "HAINDAVI PG COLLEGE",
  "SANT SAMARTH INSTITUTE OF MANAGEMENT",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL ARMED FORCES PREPARATORY DEGREE COLLEGE FOR WOMEN BHONGIR",
  "TELANGANA TRIBAL WELFARE RESIDENTIAL DEGREE COLLEGES (GIRLS) MAHABUBABAD",
  "Teegala Ram Reddy College of Pharmacy",
  "DR V R K COLLEGE OF PHARMACY",
  "Ponugoti Madhava Rao Degree College",
  "Keshav Memorial Institute of Commerce and Sciences",
  "GOVERNMENT DEGREE COLLEGE (NARSAPUR)",
  "MAMATA ACADEMY OF MEDICAL SCIENCES",
  "SADHANA DEGREE COLLEGE SULTANABAD",
  "GITAM : Gandhi Institute of Technology and Management, Off Campus - Hyderabad",
  "Kasturba Gandhi Degree & PG College for Women",
  "BSC COLLEGE OF NURSING MUSLIM MATERNITY AND ZANANA HOSPITAL",
  "GOVERNMENT MEDICAL COLLEGE",
  "Geethanjali Degree College (KUSHAIGUDA)",
  "Immanuel Business School",
  "NARAYANA DEGREE COLLEGE, PASUMAMULA",
  "Stanley College of Engineering & Technology for Women",
  "GOVERNMENT MEDICAL COLLEGE RAJANNA SIRCILLA",
  "Bharathi Degree College, H.No. 11-27-16, Kothawada, Warangal",
  "MNR Dental College and Hospital, Sangareddy",
  "GOVERNMENT MEDICAL COLLEGE, KAMAREDDY",
  "Nalanda Degree College, Mavla Road, Adilabad  504 001",
  "VAAGDEVI DEGREE COLLLEGE, MANCHERIAL",
  "SUVIDYA DEGREE COLLEGE, CHITYAL",
  "SRI SRI GAYATHRI DEGREE COLLEGE, GHANPUR",
  "SANJANA DEGREE COLLEGE, GHANPUR",
  "MATHRU SRI DEGREE COLLEGE FOR WOMEN, HASANPARTHY",
  "SRI CHAITANYA DEGREE COLLEGE, KOWTALA",
  "MAESTRO SCHOOL OF PLANNING AND  ARCHITECTURE",
  "Vivekananda Degree College, Kubeer",
  "ROSHINIDEGREECOLLEGE",
  "HAINDAVI DEGREE COLLEGE (KAPRA)",
  "SREENIDHI DEGREE COLLEGE, MADHIRA",
  "JADHAV MANIKRAO DEGREE COLLEGE, INDRAVELLY",
  "REBBANA ARTS AND SCIENCE DEGREE COLLEGE, REBBENA",
  "University Arts and Science College, Kakatiya University",
  "Joginpally B.R Pharmacy College",
  "SRI VIKAS DEGREE COLLEGE, NEKKONDA",
  "SRI VIKAS DEGREE COLLEGE, SINGARENI",
  "VEDHANIDI DEGREE COLLEGE, LOKESHWARAM",
  "GALAXY Degree College",
  "DECCAN SCHOOL OF ARCHITECTURE AND PLANNING",
  "Panineeya Mahavidyala College of Education",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN, JAGITIAL",
  "TELANGANA TRIBAL WELFARE RESIDENTIALDEGREE COLLEGE (BOYS)MARIPEDA  MAHABUBABAD DIST",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL DEGREE AND PG COLLEGE FOR WOMEN BUDVEL",
  "VASUNDARA DEGREE COLLEGE",
  "VISWA BHARATHI COLLEGE OF LAW",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL LAW COLLEGE FOR WOMEN",
  "GOVT DEGREE COILEGE ARTS AND COMMERCE NAGARKURNOOR",
  "Hellen Keller's Instiute of Research and Rehabilitation for the Disabled Children",
  "Aurobindo Institute of Computer Science (Olive P.G College for Computer Science)",
  "Siddhartha Institute of Technology & Science (formerly Siddharatha Technical Institute)",
  "Sri Chaitanya Degree College (Dubbaka)",
  "Ushodaya Mahila Degree College, Bodhan (5039)",
  "Vijaya College of Pharmacy",
  "A.V. College of Arts, Science & Commerce",
  "Pendekanti Law College",
  "TAPASYA DEGREE COLLEGE KUKATPALLY",
  "KEN Degree College",
  "Sri Indu Institute of Pharmacy",
  "Sri Shivani College of Pharmacy,Warangal",
  "Sahasra Institutue of Pharmaceutical Sciences,Warangal",
  "Sri Chaitanya Degree College, Bheemaram,Warangal",
  "SRK Degree College,Cherial",
  "Yasmeen B.Ed. College",
  "Holy Mary Institute of Technology & Science College of Pharmacy",
  "Dhanvanthri Institute of Pharmaceutical Sciences",
  "Vijay College of Pharmacy",
  "SRNK Govt. Degree College, Banswada (5034)",
  "Indur College of Education, Bodhan (5281)",
  "Katipally Ravinder Reddy College of Education, Nizamabad (5284)",
  "Narendra Degree College, Armoor (5020)",
  "Care Degree College, Nizamabad (5002)",
  "Sri Vaishnavi Women's Degree College, Kamareddy (5046)",
  "Pragathi Degree College, Nizamabad (5023)",
  "Pragathi College of Education, Banswada (5291)",
  "Sri Sai Raghavendra Degree College, Nizamabad (5029)",
  "SPR Degree College, Dichpally (5050)",
  "Gouthami Degree College, Nizamabad (5006)",
  "Vijay Degree & PG College, Armoor (5040)",
  "Vijnana Bharathi Degree College, Kamareddy (5012)",
  "Ushodaya Degree College, Bodhan (5049)",
  "Shashank Degree & PG College, Banswada (5027)",
  "Narendra Womens Degree College, Armoor (5021)",
  "RIYAN COLLEGE OF EDUCATION",
  "Nalanda Degree College, Bheemghal (5019)",
  "Adarsh Hindi Maha Vidyalaya Degree College, Nizamabad (5001)",
  "Govt. Degree College, Bichkunda (5011)",
  "Sri Vijaya Sai Degree College, Bodhan (5032)",
  "Thirumala College of Nursing, Armoor",
  "Thirumala College of Medical Lab Technology, Nizamabad",
  "SVS Medical College, Mahabubnagar",
  "AVN Institute of Engineering & Technology",
  "Meghana Inst. of Dental Sciences, Nizamabad",
  "Mamata Medical College, Khammam",
  "Kakatiya College of Physiotherapy, Warabgal",
  "JB Institute of Engineering & Technology",
  "BHARATHI INSTITUTE OF BUSINESS MANAGEMENT",
  "Talla Padmavathi College of Engineering",
  "Vignan's Institute of Management & Technology For Women",
  "Duragabai Deshmukh Hospital & Research Centre, College of Physiotheraphy, Hyderabad",
  "Care College of Nursing, Hyderabad",
  "Annamacharya Institute of Technology & Sciences",
  "Jayamukhi College of Education, Narsampet",
  "St. Ann's College of Nursing, Hanumakonda",
  "Shadan Women's College of Pharmacy",
  "Vageswari College of Engineering",
  "Vision College of Pharmaceutical Sciences",
  "Vignan Institute of Pharmaceutical Sciences",
  "MNR Medical College, Sanagareddy",
  "Medha Inst. of Nursing & Diagnostic Sceicnes, Hanmakonda",
  "Kamineni Inst. of Medical Sciences, College of Nursing, Narketpally",
  "Dr. VRK Women's Medical College, Aziznagar",
  "Chalmeda Ananda Rao Institute of Medical Sciences, College of Nursing,Bommakal",
  "GOVERNMENT DEGREE COLLEGE, ALIR",
  "SRI SNEHA DEGREE COLLEGE, BHONGIR",
  "KAKATIYA DEGREE COLLEGE, NALGONDA",
  "PRAGATHI DEGREE COLLEGE, VALIGONDA",
  "SRI RAMALINGESHWARA DEGREE COLLEGE NARKETPALLY",
  "GOVT. DEGREE COLLEGE FOR WOMEN, NALGONDA",
  "ARUNODAYA DEGREE COLLEGE, NAKREKAL",
  "MATRUSHRI DEGREE COLLEGE, CHOUTUPPAL",
  "GOKUL COLLEGE OF EDUCAITON, NALGONDA",
  "NALANDA DEGREE COLLEGE, MIRYALAGUDA",
  "Government Degree College, Bellampally 504 251",
  "CHINMAY CHANDRAMATHI COLLEGE OF EDUCAITON, DEVARAKONDA",
  "HRD COLLEGE FOR TEACHER EDUCATION, DEVARAKONDA",
  "MC MEMORIAL DEGREE COLLEGE, HALIA",
  "ENRICH CHRISTIAN COLLEGE OF EDUCAITON, MARRIGUDA",
  "SRI UJWALA DEGREE COLLEGE(CO-EDUCATION), SURYAPET",
  "ST. FRANCIS COLLEGE OF EDUCATION, SURYAPET",
  "SRI HINDU DEGREE COLLEGE, RAMANNAPET",
  "SANA COLLEGE OF TEACHER EDUCAITON, KODAD",
  "NEELAGIRI DEGREE & PG COLLEGE, NALGONDA",
  "Sri Gaayathri Degree College, Ramnagar, Hanamkonda",
  "SRI CHAITANYA DEGREE COLLEGE, MAAL",
  "GOUTAMI DEGREE COLLEGE, SURYAPET",
  "UJWALA DEGREE COLLEGE, VALIGONDA",
  "SRI SAI TRIVENI PG COLLEGE SURYAPET",
  "St. Pious X Degree and P.G College for Women",
  "KAKATIYA PG COLLEGE NALGONDA",
  "SRI NAGARJUNA DEGREE COLLEGE, MIRYALAGUDA",
  "VASAVI DEGREE COLLEGE NAKREKAL",
  "TRIVENI ARTS & SCIENCE DEGREE COLLEGE, KODAD",
  "SAIRAM DEGREE COLLEGE, MOTKUR",
  "MOTHER TERESA COLLEGE OF EDUCAITON, ANANTARAM",
  "Kavitha Memorial Degree College, NST Road, Khammam",
  "MRR MEMORIAL DEGREE COLLEGE, KODAD",
  "SIDDU COLLEGE OF EDUCAION, HUZURNAGAR",
  "Mancherial Vidyaniketan Degree College,  Mancherial(119)",
  "Sarojini Naidu Degree & P.G College for Women",
  "Smt. A. Shyamala Devi Degree College for Women",
  "Shree Uma degree & P.G College",
  "Katriya Institute of Excellence in Hotel Management",
  "Sri Sai Degree & P.G College",
  "Shree Swaminarayan Gurukul College of Education",
  "St. Johns College of Education",
  "Sai Chaitanya Degree College",
  "Basaveshwara Institute of Information Technology",
  "Govt. Degree College (Sadasivpet)",
  "VIVEK VARDHINI SCHOOL OF BUSINESS MANAGEMENT",
  "D.V.M Degree College of Commerce & Science",
  "SCHOOL OF MANAGEMENT STUDIES J N T UNIVERSITY HYDERABAD",
  "Shadan Institute of Computer Studies (Boys)",
  "Institute of Public Enterprises",
  "John Bauer College of Hotel Management",
  "Sri Sai Degree & P.G College",
  "Samatha Degree College, Thorrur  506 163",
  "Nava Bharath Degree College, Nethaji Road, Sathupally",
  "Sai Ram Degree College, Near Bus Stand, Thorrur 506 163",
  "Man Power Development College",
  "Vasavi College of Engineering",
  "Sree Venkateshwara Degree College",
  "SAP Degree College",
  "Thirumala college of Pharmacy",
  "Sun Institute of Hotel Management and Catering Technology",
  "Royal Degree College for Women",
  "St. Mary's College, (Yousufguda, Hyderabad-45)",
  "GITHANJALI DEGREE COLLEGE",
  "Vinayaka College of I.T. and Business Management",
  "Nigama College of Physical Education",
  "P.G. College, Mirzapur",
  "SARDAR PATEL DEGREE COLLEGE",
  "VIDYARTHI COLLEGE OF EDUCATION",
  "SIDDARTHA DEGREE COLLEGE",
  "GOVERNMENT COLLEGE OF NURSING TANDUR",
  "BHASKAR COLLEGE OF NURSING YENKEPALLY VILLAGE  MOINABAD MANDAL  R R DIST",
  "Rams Degree College, Bhadrachalam (Sampurna, Erragunta)",
  "Sri Arunodaya Degree College, Amba Complex, Bheemaram, Hasanparthy (M)",
  "Vathsalya Institute of Science & Technology",
  "P.G. College, Vikarabad",
  "P.G. College, Secunderabad",
  "Baddam Bal Reddy Institute of Technology and Business School",
  "Pannala ram reddy college of business managememt",
  "Anjaneya degree College",
  "S.V.G. Degree College, Laxman Chanda, Adilabad 504 106",
  "Susheela College of Education, Madhira",
  "Sri Chaitanya Degree College, Rajampet, Asifabad",
  "R.B.V.R.R. Women's College",
  "GOVERNAMENT DEGREE COLLEGE,HUZURANAGAR",
  "Hindi Mahavidyalaya",
  "C.V RAMAN DEGREE COLLEGE MAKTHAL",
  "LNR COLLEGE OF EDUCATION",
  "Sindhu Degree College",
  "PRAGATHI COLLEGE OF EDUCATION",
  "Yashoda College of Nursing, Medchal",
  "Sree Dattha Group of Institutions",
  "Pragathi Degree College (Co-Ed.)",
  "V.V. College (Day)",
  "Aurora's PG College (MCA), NAMPALLY",
  "Vivekananda College of Education, Narsampet",
  "Dr. RJC College of Higher Education, Trunk Road, Khammam",
  "GOVERNMENT DEGREE COLLEGE, MAHESHWARAM ",
  "Government Degree College, Utnoor",
  "Telangana Tribal Welfare Residential Degree College (Men), Sangareddy",
  "BIRLA INSTITUTE OF TECHNOLOGY AND SCIENCE PILANI,HYDERABAD CAMPUS",
  "AL RAHAMAN COLLEGE OF EDUCATION",
  "Brindavan Institute of Teacher Education",
  "L.N. Gupta Degree College",
  "Kingston College of Education",
  "Siddhartha Degree College for Women",
  "Sri Rajah Raghava Raju Venkata Krishnam Raju Memorial (SRRRVKRM) Degree College, # 2-108, Godavari Ferry Point Road, Venkatapuram",
  "Kamineni Academy of Medical Sciences and Research Centre",
  "Max Institute of Pharmaceutical Sciences, Velugumatla (V), VV Palem (Po), Khammam",
  "Rainbow Integrated Degree College",
  "Sri Nidhi College of Education",
  "AMS School of Informatics",
  "Ashoka Institute of Engineering AND Technology",
  "Sarvepally Radhakrishna Degree College",
  "SVS Institute of Dental Sciences, Mahabubnagar",
  "JNTUH UNIVERSITY COLLEGE  OF ENGINEERING RAJANNA SIRCILLA ",
  "HASITHA WOMENS DEGREE COLLEGE ,MIRYALGUDA",
  "SRI SARASWATHI DEGREE COLLEGE THIRUMALAGIRI",
  "SYED JAMAL MEMORIAL COLLEGE OF EDUCATION, KODAD",
  "Nizam Institute of Pharmacy",
  "Chanakya Degree College,Mallapur",
  "Haindavi Degree College (Mehdipatnam)",
  "Vageswari Institute of Pharmaceutical Sciences",
  "Bharat Institute of Engineering & Technology",
  "Sri Kavita Engineering College",
  "Jyothismathi Institute of Pharmaceutical Sciences",
  "Jaya Prakash Narayan College of Engineering",
  "Avanthi's Scientific Technological & Research Academy",
  "Vardhaman College of Engineering",
  "Bhaskar Pharmacy College",
  "Medwin College of Nursing, Hyderabad",
  "Devi College of Medical Lab Technology, Hyderabad",
  "Dr. B.R. Ambedkar Paramedical Sciences, Nalgonda",
  "Sree Chaitanya PG College (MBA)",
  "AAR MAHAVEER ENGINEERING COLLEGE",
  "Talla Padmavathi Pharmacy College",
  "Image Madhapur College of Nursing, Yapral",
  "SCIENT INSTITUTE OF PHARMACY",
  "Pioneer College of Nursing, Hyderabad",
  "Rainbow College of Nursing, Hyderabad",
  "K.V.K College of Pharmacy",
  "St. Peter s College of Education, Vidyanagar, Hanamkonda",
  "ARDENT DEGREE COLLEGE",
  "Mina Institute of Engineering & Technology for Women",
  "VNR Vignanajyothi Institute of Engineering & Technology",
  "Mother Theresa College of Engineering & Technology",
  "Samskruti College of Pharmacy",
  "Kodada Institute of Technology &Science for Women",
  "SVS Group of Institutions",
  "Kasireddy Narayan Reddy College of Engineering & Research",
  "Vivekananda Institute of Technology and Science",
  "Vignana Bharathi Institute of Technology",
  "Khader Memorial College of Engineering & Technology",
  "Anwarul -Uloom College of Pharmacy",
  "Institute of Aeronautical Engineering",
  "SREYAS INSTITUTE OF ENGINEERING & TECHNOLOGY, TATTIANNNARAM",
  "Nava Bharathi College of Education",
  "ICMR National Institute of Nutrition",
  "CMR Technical Campus",
  "ACME Degree College",
  "MAMATA INSTITUTE OF DENTAL SCIENCES",
  "DBHP SABHA COLLEGE OF EDUCATION, HYDERABAD ",
  "Vivekananda College of Education",
  "Samaikya Degree College, H.No. 5-5-88, Kankara Boad, Mahabubabad",
  "Holy Mary Institute of Technology",
  "Gauthami Degree College",
  "Sri Venkata Sai College of Nursing, Mahabubnagar",
  "G.Narayanamma Institute of Technology & Science for Women",
  "SHREE VASHISTA COLLEGE OF EDUCATION NEAR VAARTHA UNIT, ALGUNOOR, THIMMAPUR, KARIMNAGAR",
  "BRILLIANT DEGREE COLLEGE, SBH LANE, SIRCILLA",
  "VIKAS DEGREE COLLEGE, RATHNAPUR (V), KAMANPUR",
  "TRINITY COLLEGE OF EDUCATION, KASULAPALLY, PEDDAPALLY",
  "Vijetha Degree College",
  "SANGA MITRA DEGREE & PG COLLEGE, AKKANNAPET ROAD, HUSNABAD",
  "Pragathi Degree College for Women",
  "St. Alphonsa College of Education",
  "Sneha Degree College",
  "MNR Degree College",
  "Princeton College of Education",
  "Princess Shehkar Degree College for Women",
  "AURORA DESIGN ACADEMY",
  "RBVRR Institute of Technology",
  "PRAGATHI DEGREE COLLEGE, KALVACHERLA, KAMANPUR",
  "VAAGESWARI DEGREE COLLEGE MUKARAMPURA ROAD, KARIMNAGAR",
  "TELANGANA SOCIAL WELFARE RESIDENTIAL DEGREE COLLEGE FOR WOMEN, KOTHAGUDEM",
  "JAGATHI DISABLED DEGREE COLLEGE (DEAF AND DUMB)",
  "Bright Institute of Management",
  "David Memorial Degree College",
  "RAMA KRISHNA DEGREE & PG COLLEGE VANI NAGAR, JAGTIAL",
  "Zunaira Degree College, Nizamabad (5068)",
  "GOVERNMENT DEGREE COLLEGE, BADANGPET",
  "TRR INSTITUTE OF MEDICAL SCIENCES",
  "G HOTEL MANAGEMENT COLLEGE",
  "DHRUVA DEGREE COLLEGE",
  "CHAITANYA DEGREE COLLEGE",
  "TARA Govt. College (A)",
  "Pingle Government College for Women, (Autonomous), Waddepally, Hanumakonda District,",
  "Abhinav Hi-Tech College of Engineering & Technology",
  "Sri Maruthi Degree College",
  "Syo Narayan Ramcharan Patwari P.G College of Commerce",
  "Manjeera College of Education",
  "Don Bosco Degree College",
  "Nehru Memorial Govt. Degree College",
  "VIDYA DAYINI WOMENS DEGREE COLLEGE",
  "NARENDRA DEGREE COLLEGE,  CHOULAMADDI (V), METPALLY",
  "MES College of Education, Arempula, Khammam",
  "Sree Vignan Degree College",
  "T.R.R. COLLEGE OF TECHNOLOGY",
  "The Mothers Degree College for Women",
  "Holy mary Institute of Technology & Management",
  "Urdu Arts College (Eve)",
  "University College of  Science, Saifabad",
  "TRINITY DEGREE COLLEGE, PRAGATHI NAGAR, PEDDAPALLY",
  "SRIVANI DEGREE COLLEGE,  OLD JANDA, SULTANABAD",
  "ALETI RAJA REDDY DEGREE COLLEGE, VELAGTOOR.",
  "AURORA'S DESIGN INSTITUTE",
  "SRI VIDYA JYOTHI DEGREE COLLEGE SRI RAM NAGAR, JAGTIAL",
  "David Memorial College of Education for Women",
  "SLN DEGREE COLLEGE , GUNDLAPALLY (V), BEJJANKI",
  "CHANAKYA DEGREE & PG COLLEGE, NEAR CITY CABLE, JAMMIKUNTA",
  "SRI VAAGDEVI DEGREE COLLEGE, HUZURABAD",
  "VIKAS DEEGREE COLLEGE,  MANKAMMATHOTA, KARIMNAGAR",
  "GOVERNMENT DEGREE COLLEGE, MAHADEVAPUR",
  "Sai Sudhir Degree & PG College",
  "SRI MITHRA DEGREE COLLEGE MUSTHABAD",
  "Avanthi Degree College",
  "SRI CHAITANY DEGREE COLLEGE, DHARMAPURI",
  "KIMS DEGREE & PG COLLEGE, NEAR BUS STAND, OPP. KALABHARATHI LANE, KARIMNAGAR",
  "Oriental Urdu College",
  "GOVT. DEGREE COLLEGE FOR WOMEN, KARIMNAGAR",
  "JAYASREE DEGREE COLLEGE, KARIMNAGAR",
  "Mumtaz Degree College",
  "Pasha Noble Degree & P.G College (New Noble Degree College)",
  "Ali Yavar Jung National Institute for the Hearing Handicapped",
  "Mallareddy College of Teacher Education (B.Ed & M.Ed)_kompally",
  "M S Degree College for Women (Nalgonda X Roads)",
  "Nishitha Degree College (MBA&MCA), Nizamabad (5174)",
  "Bhavans New Science Degree College (Day)",
  "MNR College of Teacher Education",
  "Islamia College of Education",
  "Madina Degree College",
  "Sri Chaitanya Degree College",
  "AMS College of Law College for Women",
  "Dewan Bahadur Padma Rao Modiliar Degree College for Women",
  "VANI NIKETHAN VIDYA SAMITHI,  MUKARAMPURA, KARIMNAGAR",
  "AIMS DEGREE COLLEGE",
  "BMR Degree College (Gajwel)",
  "Nawabshahala Khan College of Education",
  "Jagruthi Degree College (Malkajgiri)",
  "St. Vincent P.G. College",
  "Prathibha Degree College (Ibrahimpatnam)",
  "Govt. Degree College (Khairatabad)",
  "CSI College of Education",
  "Deccan School of Management",
  "Govt. Degree College for Women (Siddipet)",
  "RASHMIDHAR TEJA DEGREE COLLEGE , OPP: BUS STAND, KORATLA",
  "GNANODAYA DEGREE COLLEGE, NEAR COURT METPALLY",
  "Omega College of Pharmacy",
  "National College of Education",
  "National Institute for the Empowerment of Persons with Intellectual Disabilities Divyangjan",
  "Master (Vignan) Degree College",
  "Swathi Degree College",
  "PRISM SCHOOL OF BUSINESS",
  "Peoples College of Arts, Science & Commerce",
  "BMR Degree College (Siddipet)",
  "Vivekananda Degree College (Sithaphal Mandi)",
  "Institute of Advanced Study in Education",
  "Sri Venkateswara Degree College",
  "Vijayanagar College of Commerce",
  "College of Languages",
  "Presidency School of Management & Computer Science",
  "Pasha College of Education",
  "Lateefia Arabic College",
  "RGR Siddhanthi Degree College",
  "Sai Shree Degree College, Armoor(5075)",
  "Mims Degree College, Bodhan, Nizamabad (5074)",
  "New Science Degree College",
  "Dr. B.R. Ambedkar Law College",
  "Regency College of Culinary arts and Hotel Management",
  "PJR'S Memorial Sai Teja Degree College",
  "GMR College of Education",
  "INDIAN INSTITUTE OF INFORMATION TECHNOLOGY VADODARA INTERNATIONAL CAMPUS DIU",
  "SHRINATHJI COLLEGE OF COMMERCE",
  "Lions Club of Silvassa Charitable Trust, Haveli Institute of Legal Studies and Research, Sanjibhai Nagar Haweli, Silvassa-396 230",
  "Shrinathji College of Business Administration, Daman",
  "Shrinathji College of Computer Application, Daman",
  "Shri Vinoba Bhave College of Nursing, Silvassa",
  "GOVERNMENT POLYTECHNIC, DAMAN-658",
  "GOVERNMENT POLYTECHNIC, DIU",
  "Swargeeya Sanjibhai Rupjibhai Memorial Trust's, SSR College of Arts, Commerce and Science, Sanjibhai Dilkar Marg,Dadra Nagar Haveli, Sayali Silvasa 396230",
  "GOVERNMENT ENGINEERING COLLEGE DAMAN",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY",
  "Swargeeya Sanjibhai Rupjibhai Memorial Trusts SSR Institute of Management & Research, Silvassa",
  "GOVERNMENT COLLEGE OF NURSING, DAMAN",
  "LIONS CLUB OF SILVASSA CHARITABLE TRUST'S SMT DEVKIBA MOHANSINHJI CHAUHAN COLLEGE OF COMMERCE AND SCIENCE, SILVASSA ",
  "DIU COLLEGE",
  "Dr. APJ Abdul Kalam Government College, Dadra and Nagar Haveli, Ucchha Siksha Samiti, Silvassa(Dokmardi)-  396230",
  "Vaidik Dental College and Research Centre",
  "Sanjibhai Rupajibhai Memorial Trusts S.S.R. College of Pharmacy,U.T.Dadra Nagar Haveli, Sayali Silvasa 396230",
  "Sanjibhai Rupajibhai Memorial Trusts S.S.R.College of Education, Sayali Silvasa 396230",
  "DR B B A GOVERNMENT POLYTECHNIC",
  "Government College, Daman",
  "SHRI VINOBA BHAVE INSTITUTE OF ALLIED HEALTH SCIENCES",
  "NAMO Medical Education & Research Institute",
  "Government Law College",
  "SRI AUROBINDO GERENAL DEGREE COLLEGE ENGLISH MEDIUM",
  "BHAVANS TRIPURA TEACHER TRAINING COLLEGE",
  "TTAADC Polytechnic Institute",
  "GOVERNMENT DEGREE COLLEGE, GANDACHERRA",
  "Holy Cross College",
  "Sachin Deb Barman Memorial Govt. Music College",
  "Agartala Government Medical College",
  "GOVERNMENT DEGREE COLLGE, KANCHANPUR",
  "GOVERNMENT DEGREE COLLGE, SANTIRBAZER",
  "SWAMI VIVEKANANDA MAHAVIDYALAYA, MOHANPUR",
  "TRIPURA SUNDARI NURSING COLLEGE, AGARTALA",
  "Government Degree College, Dharmanagar",
  "Government Degree College, Khumlwng",
  "Kabi Nazrul Mahavidyalaya",
  "Tripura Tribal Folk Music College",
  "Regional Institute of Pharmaceutical Science & Technology",
  "Women's College",
  "Institute of Nursing Sciences",
  "Ambedkar College",
  "BIR BIKRAM COLLEGE OF PHARMACY",
  "Iswar Chandra Vidyasagar College",
  "College of Fisheries, Lembucherrra",
  "Ramthakur College",
  "Institute of Advance Studies in Education",
  "TRIPURA STATE ACADEMY OF TRIBAL CULTURE, AGARTALA",
  "NATIONAL INSTITUTE OF ELECTRONICS AND INFORMATION TECHNOLOGY, AGARTALA",
  "GOVERNMENT DEGREE COLLGE, LONGTARAI VALLEY",
  "Netaji Subhash Mahavidyalaya",
  "Tripura Institute of Technology",
  "Adwaita Malla Barman Smriti Mahavidyalaya, Amarpur",
  "Women's Polytechnic College",
  "RAJARSHI COLLEGE OF EDUCATION AND SKILL",
  "Tripura Institute of Paramedical Science",
  "College of Teacher Education, Kumarghat, Unakoti District.",
  "College of Veterinary Science & Animal Husbandry",
  "Bhavan's Tripura College of Teacher Education",
  "College of Agriculture",
  "GOVERNMENT DEGREE COLLEGE OLD AGARTALA",
  "Government College of Art & Craft",
  "Regional College of Physical Education",
  "Bhavan's Tripura College of Science & Technology",
  "Dasarathdeb Memorial College",
  "GOVERNMENT DEGREE COLLGE, TELIAMURA",
  "Tripura College of Nursing",
  "Tripura Medical College & Dr. B.R.A.M. Teaching Hospital",
  "EKALAVYA CAMPUS",
  "Government Degree College, Kamalpur",
  "Dhalai District Polytechnic Institute",
  "Ramkrishna Mahavidyalaya",
  "Micheal Madhusudan Datta College",
  "AGARTALA GOVERNMENT DENTAL COLLEGE AND IGM HOSPITAL",
  "MILESTONES INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "TRIPURA SANTINIKETAN MEDICAL COLLEGE",
  "SWAMI DHANANJOY DAS KATHIA BABA MISSION COLLEGE",
  "NORTH TRIPURA DISTRICT POLYTECHNIC, DHARMANAGAR",
  "Maharaja Bir Bikram College",
  "Bir Bikram Memorial College",
  "GOMATI DISTRICT POLYTECHNIC",
  "TECHNO COLLEGE OF ENGINEERING, AGARTALA",
  "RABINDRA NATH THAKUR MAHAVIDYALAYA, SEPAHIJALA",
  "GOVERNMENT DEGREE COLLEGE PANISAGAR",
  "Bharat Pharmaceutical Technology",
  "NATIONAL FORENSIC SCIENCES UNIVERSITY, TRIPURA CAMPUS",
  "SEEMANT INSTITUTE OF TECHNOLOGY (Constituent College of Uttarakhand technical University)",
  "Gyanarthi Media College",
  "HIMGIRI MAHAVIDYALAYA",
  "VIDYA VIKASINI DEGREE COLLEGE OF MANAGEMENT AND TECHNOLOGY",
  "Himalayiya Ayurvedic (P.G.) Medical College and Hospital",
  "DR. A.P.J ABDUL KALAM INSTITUTE OF TECHNOLOGY, TANAKPUR",
  "Dehradun Technical And Management College",
  "Param Himalaya Homoeopathic Medical College, Hospital And Research Centre",
  "S.B.(PG) College",
  "Sri Gangadhar Maithani Govt. Degree College,Guptakashi",
  "INSTITUTE OF TECHNOLOGY, GOPESHWAR",
  "Rajkiya Mahavidyalaya, Pawki Devi (Tehri Garhwal)",
  "Salt Institute of Technology and Management, Salt",
  "Surendra Singh Jeena Government PG College Syalde, Almora",
  "Bipin Tripathi Kumaon Institute of  Technology",
  "SHEETAL VEDIC SANSTHAN, RANIPHOKHARI, DEHRADUN",
  "SHRI JAIRAM SANSKRIT MAHAVIDYALAYA, RISHIKESH",
  "HARDEV SINGH SANSKRIT COLLEGE, JASPUR",
  "AROMA COLLEGE ROORKEE",
  "SHRI RISHIKULA VIDYAPEETH BRAHMCHARYA SANSKRIT MAHAVIDYALAYA, HARIDWAR",
  "AROMA GIRLS COLLEGE ROORKEE",
  "dehradoon institute of management and technology",
  "Chaman Lal Mahavidhyalya",
  "SHRI JAIBHARATA SADHU SANSKRIT MAHAVIDYALAYA, NIRANJANI AKHARA, HARIDWAR",
  "THDC Institute of Hydropower Engineering & Technology (Constituent College of Uttarakhand technical University)",
  "SHRI GARIBDASEEYA SADHU SANSKRIT MAHAVIDYALAYA, JAGJEETPUR, HARIDWAR",
  "SHRI DARSHAN MAHAVIDYALAYA, MUNI-KI-RETI, PO- SHIVANAND NAGAR, RISHIKESH",
  "SHRI 108 KALIKAMALIWALE RAMNATHJI CHHATRAHIT KARINEE SANSKRIT PATHASHALA, RISHIKESH",
  "SHRI NARAYAN SANSKRIT MAHAVIDYALAYA, KAMERI DEVI, BAGESHWAR",
  "Byapar Mandal Kanya Degree College, Manglore",
  "Bishambhar Sahaya Management Institute",
  "Global Institute of Pharmaceutical Education & Research",
  "KAYA AYURVEDIC COLLEGE AND RESEARCH CENTER    ",
  "SHRI RAMANUJ SHRI VAISHANAV SANSKRIT MAHAVIDAYALAYA, HARIDWAR",
  "SHRI NIRMAL SANSKRIT MAHAVIDYALAYA, KANKHAL, HARIDWAR",
  "SHRI JAGADDEVA SINGH SANSKRIT MAHAVIDYALAYA, SAPTRISHI ASHRAMA, SAPTSAROWAR, HARIDWAR",
  "SHRI KEDARNATH SANATAN DHARMA UPADHI SANSKRIT MAHAVIDYALAYA, UTTARAKHAND VIDYAPEETH, RUDRAPRAYAG",
  "SHRI KEDARNATH ADARSH SANSKRIT MAHAVIDYALAYA, SHORITPUR, LAMGONDI, RUDRAPRAYAG",
  "SHRI 108 SWAMI SACHCHIDANAND VEDA BHAWAN SANSKRIT MAHAVIDYALAYA, RUDRAPRAYAG",
  "SHRI  RISHI SANSKRIT MAHAVIDYALAYA, NIRDHAN NIKETAN, KHARKHARI, HARIDWAR",
  "SAMRAT PRITHVIRAJ CHAUHAN COLLEGE, KASHIPUR ",
  "Landmark Foundation Institute of Management and Technology",
  "CHAMAN LAL LAW COLLEGE,LANDHAURA-ROORKEE",
  "GOVERNMENT NURSING COLLEGE PITHORAGARH",
  "Central Institute of Management and Technology",
  "SHRI BRAHAMCHARI RAMKRISHANA SANSKRIT MAHAVIDYALAYA, PALIWAL DHARMSHALA, HARIDWAR",
  "omvati devi degree college bhalaswagaj",
  "SHRI SANATAN DHRAM SANSKRIT MAHAVIDYALAYA, LANDHAUR, MASOORI, DEHARADUN",
  "SHRI JAIDAYAL SANSKRIT MAHAVIDYALAYA, SHRINAGAR, PAURI-GARHWAL",
  "Pits B.Ed College Naitala",
  "BALIKA SANSKRIT MAHAVIDYALAYA, SENDUL KEMAR, TEHRI-GARHWAL",
  "SHRI SANATAN DHRAMA SANSKRIT MAHAVIDYALAYA, RAILWAY BAZAR, HALDWANI",
  "Om Bio-Sciences & Pharma College",
  "Institute of Co-Operative Management",
  "G.B. Pant Engineering College",
  "RAJKIYA SANSKRIT MAHAVIDYALAYA, CHAMBA, TEHRI-GARHWAL",
  "GOVERNMENT DEGREE COLLEGE  Bhatronjkhan",
  "BINDRA INSTITUTE OF HOTEL MANAGEMENT",
  "D.B.S. P.G College, Dehradun",
  "Libra College of Law, Dehradun",
  "R.M.P Degree College, Narsan",
  "B.S.M College, Roorkee",
  "Nav Chetna College of Teachers Education, Dehradun",
  "SHAHEED SHREE KHEMCHANDRA DAURBI GOVERNMENT DEGREE COLLEGE, BETALGAT",
  "Govt. Law College, Gopeshwar",
  "Kunti Naman Institute of Pharma Technology and Sciences, Haridwar",
  "PITHORAGARH COLLEGE OF NURSING, AN UNIT OF KAUSHLIYA DEVI FOUNDATION FOR PROFESSIONAL STUDIES AND RESEARCH",
  "GARHWAL INSTITUTE OF PARAMEDICAL SCIENCES",
  "GOVERNMENT NURSING COLLEGE DOBH SRIKOT PAURI",
  "R L S MEMORIAL DEGREE COLLEGE, JASPUR",
  "Ramanand Institute of Pharmacy & Management",
  "Balwant Singh Mukhiya (BSM) College of Engineering",
  "KHATIMA INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "MAHENDER SINGH DEGREE COLLEGE BUDHAWASHAHID,BUGGAWALA,HARIDWAR,(U.k)",
  "MAYA COLLEGE OF PHARMACY",
  "Rajkamal Science And Management College NH-58 Roorkee Road Bahadrabad Haridwar",
  "Municipal Post Graduate College Mussoorie",
  "Govt. Degree College, Naikhari, Chandrabadni",
  "Dayanand Womens Training College, Dehradun",
  "Doon Institute of Management and Research, Shyampur,Dehradun",
  "ROORKEE BUSINESS SCHOOL ",
  "Dr. P D B H Government Post Graduate College,Kotdwar",
  "Himalayan Institute of Pharmacy & Research",
  "COER COLLEGE OF NURSING AND PARAMEDICAL SCIENCE",
  "College of Forestry",
  "Roorkee College of Engineering",
  "A F C I INSTITUTE OF MANAGEMENT COLLEGE ",
  "Rajkiya Mahavidyalaya Tanakpur",
  "SUNRISE ACADEMY MANAGEMENT SOCIETY",
  "Devsthali Vidyapeeth Department of Professional Studies",
  "GOVT DEGREE COLLEGE, MAJRA MAHADEV",
  "Ram Chandra Uniyal Rajkiya Snatakottar Mahavidhyalya, Uttarkashi",
  "Laxman Singh Mahar Campus  Pithoragarh",
  "Modern Institute of Technology, Dhalwala, Rishikesh",
  "Satyendra Chandra Guria Institute of Management & Technology",
  "COLLEGE OF PHARMACY",
  "Beehive College of Management & Technology",
  "Omkarananda Institute of Management & Technology",
  "B.S.M. (Women) B.Ed. College, Roorkee",
  "Poornagiri Shiksha Mahavidhalaya Law",
  "Bal Ganga Degree College, Sendul, Kemar",
  "Samrat Prithviraj Chauhan Degree College, Rohalaki Kishanpur, Haridwar",
  "Shree Dev bhoomi Institute of Education Science & Technology",
  "Shaheed Mahendra Singh Bhakuni Rajkiya Mahavidyalaya Dugnakuri (Banlekh), Janpad Bageshwar",
  "GURU NANAK COLLEGE DEHRADUN",
  "GOVERNMENT DEGREE COLLEGE, PATLOT",
  "GOVERNMENT MEDICAL COLLEGE HARIDWAR",
  "B.F.I.T. Technical Campus",
  "State Institute of Hotel Management and Catering Technology and Applied Nutrition, New Tehri",
  "Rajkiya Snatkottar Mahavidyalya, Maldevta (Raipur), Dehradun",
  "BLUE MOUNTAINS COLLEGE OF TEACHER EDUCATION",
  "Doon Institute of Engineering & Technology",
  "Smt. Tarawati Institute of Bio-Medical  & Applied Sciences",
  "Govt. Institute of Hotel Management-Dehradun",
  "Rajkiya Mahavidyalaya, Satpuli, Pauri Garhwal",
  "Dev Bhoomi Institute of Technology",
  "Kukreja Institute of Hotel Management & Catering Technology",
  "RIMS GURUKUL NARSAN, ROORKEE",
  "Nimbus Academy of Management",
  "Government P.G College Kunidhar, Manila",
  "PITHORAGARH INSTITUTE OF TECHNOLOGY AND MANAGEMENT, BUNGACHHINA, PITHORAGARG",
  "BRIGHT STAR DEGREE COLLEGE AITHAL",
  "Uttaranchal Institute of Hospitality Management and Tourism",
  "GOVERNMENT P.G. COLLEGE, NEW TEHRI",
  "RAJKIYA MAHAVIDHYALAYA RAMGARH, NAINITAL",
  "Apex Institute Of Management and Technology",
  "Institute of Management Studies",
  "ROUBRAJ INSTITUTE OF ADVANCE STUDIES",
  "SRI RAM INSTITUTE OF MEDICAL SCIENCESFERUPUR KATARPUR ROAD,FERUPUR RAMKHEDA ,HARIDWAR",
  "KINGSTON IMPERIAL INSTITUTE OF MEDICAL SCIENCE",
  "RAJKIYA MODEL MAHAVIDYALAYA MEETHIBERI, HARIDWAR",
  "GOVERNMENT DEGREE COLLEGE DEHRADUN SHAHAR, DEHRADUN",
  "SMT MANJIRA DEVI AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "Methodist Girls Degree College, Civil Line, Roorkee",
  "MAHARANA PRATAP GOVERNMENT DEGREE COLLEGE NANAKMATTA UDHAM SINGH NAGAR",
  "Roorkee Institute of Technlogy",
  "V THREE COLLEGE OF PARAMEDICAL ",
  "Shivalik College of Engg.",
  "SUMITRANANDAN PANT GOVERNMENT COLLEGE, GARUD ",
  "Surajmal Laxmi Devi Sawarthia Educational Trust",
  "Govt Degree College, Shitlakhet",
  "Government Degree College, Ganai Gangoli ",
  "Phool  Singh Bisht Rajkiya Mahavidyalaya Naughar, Lambgaon, Tehri Garhwal",
  "goverment school of nursing roshnabad haridwar",
  "GOVERNMENT DEGREE COLLEGE HALDWANI CITY",
  "Government Degree College Ghat",
  "ASHA DAI DEGREE COLLEGE",
  "Birla Institute of Applied Sciences",
  "Himalayan Institute of Education and Technology.(HIET-B.Ed.College)",
  "Roorkee College",
  "ADARSH COLLEGE OF NURSING    ",
  "Shri Swami Bhumanand College of Nursing",
  "Government Doon Medical College",
  "Govt. Nursing college, Sursingh Dhar, New Tehri",
  "Shri Babu Kaliram Rakesh Rajkiya Mahavidyalaya, Churiyala, Bhagwanpur, Haridwar",
  "Modern Institute of Technology",
  "Gyani Indra Singh Institute of Professional Studies",
  "J.B. Institute of Technology",
  "NIMBUS SCHOOL OF EDUCATION",
  "State College of Nursing ",
  "COER MEDICAL COLLEGE OF AYURVEDA AND HOSPITAL ",
  "School of Humanities and Sciences",
  "School of Management and Commerce Studies",
  "SRI SAI INSTITUTE OF NURSING",
  "AROMA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "Shri Ram Singh Dhoni Rajkiya Mahavidyalaya, Jainti ",
  "Rajkiya Mahavidyalaya Chinyalisaur, Uttarkashi",
  "HARIDWAR COLLEGE OF NURSING",
  "Mahadevi Institute of Technology",
  "VIDYA JYOTI DEGREE COLLEGE",
  "VASUDA DEGREE COLLEGE",
  "SHIVALIK INSTITUTE OF PROFESSIONAL STUDIES",
  "Dr. Shivanand Nautiyal Rajkiya Mahavidyalaya, Bedikhal (Pauri Garhwal)",
  "DBS GROUP, HBL CAMPUS",
  "Shri Guru Nanak Dev PG College Nanakmatta Sahib Distt. U.S Nagar",
  "Rajkeeya Mahavidyalaya Thatyur Tehri Garhwal",
  "GOVERNMENT POST GRADUATE COLLEGE, GAIRSAIN, CHAMOLI",
  " College of Education",
  "G D C Muwani",
  "Soban Singh Jeena University Campus Champawat",
  "GOVERMENT DEGREE COLLEGE GURURABANJ",
  "Sri Ram Institute of Management & Technology (PG College)",
  "RCPs Institute of Education ",
  "G.R.D. Institute of Management & Technology",
  "Bishambhar Sahay Institute of Technology",
  "Roorkee College of Management & Computer Applications",
  "Swami Darshananand Institute of Management & Technology",
  "Sardar Bhagwan Singh (PG) Institute of Bio-Medical Sciences & Research",
  "S S J Campus, Almora",
  "BEEHIVE NURSING COLLEGE",
  "Kukreja Institute of Teachers Education, Dehradun",
  "Sai Institute of Paramedical and Allied Science, 26/26 A, Rajpur Road, Dehradun",
  "R.C .P P.G College and Allied Sciences,Roorkee",
  "Shri Varahi Devi Sanskrit Mahavidhalaya",
  "Om Bio-Sciences & Management College",
  "HIMALAYAN SCHOOL OF SCIENCE & TECHNOLOGY",
  "Raath Mahavidyalaya, Paithani",
  "M.K.P.P.G College, Dehradun",
  "Malini Valley College of Education, Shirrajpur, Kotdwar",
  "S.S.D.P.C  Girls Degree College, Roorkee",
  "HIMALAYAN SCHOOL OF MANAGEMENT STUDIES",
  "Himalayan College of Nursing",
  "RAAJAKEEYA MAHAAVIDAALAY KALJIKHAL",
  "Vasudev College of Law",
  "RAJKIYA MAHAVIDYALAYA KAMAND, TEHRI GARHWAL",
  "Rajkiya Snatakottar Mahavidyalaya, Thalisain (Pauri-Garhwal)",
  "Sri Guru Ram Rai Institute of Medical Sciences, Dehradun",
  "Govt. Degree College, kanda",
  "PDSS degree college",
  "govt degree colllege Nandasain",
  "HARIDEV COLLEGE OF LAW KASHIPUR",
  "JAGANNATH VISHWA LAW COLLEGE",
  "Shaheed Durga Mall Government Post Graduate College, Doiwala, Dehradun",
  "BHARAT SINGH RAWAT RAJKIYA MAHAVIDYALAYA RIKHNIKHAL PAURI GARHWAL",
  "Radhey Hari Govt. Post Graduate College, kashipur",
  "Rajkiya Snatkottar Mahavidyalaya, Laksar, Haridwar",
  "Govt. P.G Degree College, Gopeshwar",
  "BHAGWAT PRASHAD SHIKSHAN EVAM SEWA SANSTHAAN HITANU UTTARKASHI",
  "IDEAL BUSINESS SCHOOL",
  "Quadra Institute of Nursing",
  "Surajmal Agarwal Private Kanya Mahavidyalaya College of Nursing (SAPKM College Of Nursing)",
  "Surajmal Agarwal Girl College of Paramedical and Health Sciences",
  "Naincy College of Nursing",
  "Pal College of Nursing and Medical Sciences",
  "DOON PG COLLEGE OF AGRICULTURE AND ALLIED SCIENCES",
  "DOON (PG) PARAMEDICAL COLLEGE OF AGRICULTURE SCIENCE AND TECHNOLOGY",
  "Govt. Degree College,Nainbagh",
  "Himwant Kavi Chandra Kunwar Bartwal Rajkiya Mahavidyalaya Nagnath Pokhari, Chamoli",
  "Govt. Degree College, Rudraprayag",
  "Omkaranand Saraswati Government Degree College, Devprayag",
  "Sri Gulab Singh Govt. Degree College, Chakrata, Dehradun",
  "JAGRAN SCHOOL OF LAW",
  "Govt.Degree College Masi",
  "Rani Dharm Kunwar Government Degree College Dallawala, Khanpur (Haridwar)",
  "KESHAV SURYAMUKHI COLLEGE OF EDUCATION",
  "TRINITY INSTITUTE OF PROFESSIONAL STUDIES",
  "Saheed Capt. D.K.Khola College of Education ",
  "LBSS COLLEGE OF EDUCATION, MAHUWA DABRA, JASPUR",
  "DEV BHOOMI INSTITUTE OF MANAGEMENT STUDIES",
  "Unity Law College",
  "RENAISSANCE COLLEGE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "RAJKIYA SNATAKOTTAR MAHAVIDYALAYA, BAZPUR",
  "Pt. Shiv Ram Rajkiya Mahavidyalaya, Tyuni, Dehradun",
  "SHRI VISHWANATHA SNATAKOTAR SANSKRIT MAHAVIDYALAYA, UJELI, UTTARAKASHI",
  "SHRI MAHADEVI GIRI SNATAKOTAR MAHAVIDYALAYA, HALDWANI",
  "SHRI BADRINATH RAJKIYA SANSKRIT MAHAVIDYALAYA, NEW TEHRI",
  "SHRI JWALAMUKHI SANSKRIT MAHAVIDYALAYA, DEVDHUNG VINAYKHAL, TEHRI-GARHWAL",
  "SHRI JAGADGURU SHRI CHANDRA SANSKRIT MAHAVIDYALAYA, BHAGVADDHAMA, HARIDWAR",
  "SHRI DRONASTHALI ARYA KANYA GURUKULA MAHAVIDYALAYA, KISHANPUR, DEHRADUN",
  "SHRI GURU RAMRAI LAKSHMAN SANSKRIT MAHAVIDYALAYA, DEHRADUN",
  "SHRI PUNJAB SINDH KSHETRA SADHU MAHAVIDYALAYA, RISHIKESH",
  "SHRI GURUMANDALASHRAMA SANSKRIT MAHAVIDYALAYA, HARIDWAR",
  "Swargiya Chandra Singh Shahi Government Post Graduate College, Kapkot",
  "GOVERNMENT PROFESSIONAL COLLEGE BANAS",
  "MANAS COLLEGE OF SCIENCE TECHNOLOGY AND MANAGEMENT",
  "Swatantrata Sangram Senani Than Singh Rawat Rajkiya Mahavidyalaya, Nainidanda, Pauri-Garhwal",
  "Govt. P G College, Berinag",
  "PITHORAGARH INSTITUTE OF BIO MEDICAL SCIENCE, AN UNIT OF KAUSHLIYA DEVI FOUNDATION FOR PROFESSIONAL STUDIES AND RESEARCH",
  "Doon Valley College of Education, Thakurpur,P.O-Premnagar, Dehradun",
  "Gurukul Degree (B.Ed) College, Haridwar",
  "Dolphin (P.G.) Institute of Biomedical and Natural Sciences, Manduwala, near Sudhowala, Dehradun",
  "SAI INSTITUTE OF MEDICAL SCIENCES",
  "Beehive College of Advance Studies, Beehive City Central Hope Town, Selaqui,Chakrata Road, Dehradun",
  "Government Model Degree College, Devidhura",
  "Pt Badri Dutt Pandey Campus  Bageshwar",
  "S.V Government P.G College Lohaghat   ",
  "GOVERNMENT DEGREE COLLEGE DEWAL CHAMOLI UTTARAKHAND ",
  "B.S.M Law College, Roorkee",
  "Doon Institute of Education, Rishikesh-Haridwar Highway,Shyampur, Rishikesh",
  "Rajkiya Mahavidyalaya Jaspur (Udhamsingh Nagar)",
  "Bishamber Sahay Law College, Roorkee",
  "Sushana Methodist Girls B.Ed College, Civil Line, Roorkee",
  "Pestle Weed College of information Technology, Technological Park,OK Hill,Dehradun",
  "Garg U.G. Degree College, Laksar",
  "GOVERNMENT NURSING COLLEGE CHAMPAWAT",
  "Institute of Technology and Management, 60 Chakrata Road,Dehradun",
  "DIVINE COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "Droan College of Education and Technology, Dineshpur Road, Rudrapur",
  "Shri Guru Ram Rai (P.G.) College, Dehradun",
  "Dr. Sushila Tiwari College of Advance Studies,Roorkee",
  "Indira Priyadarshini Govt. Girls P.G. College of Commerce, Haldwani",
  "Government Madical College, Haldwani",
  "Govt. P G College, Didihaat, Narayan Nagar",
  "Rajkiya Mahavidyalaya  Baluwakot ( Pithoragarh)",
  "Mariyam Institute of Higher Studies and Allied Courses, Haldwani",
  "Jai Arihant Academic Institute Haldwani",
  "Dr. Shusheela Tiwari Degree College, Sitarganj",
  "Dewbhomi College of Education, Chonabhata Road, Banbasa",
  "B.S.V. Govt.Girls  Degree College, Jaspur",
  "Chandrawati Tiwari Govt.Girls  Degree College, kashipur",
  "Dev Bhoomi Institute of Pharmacy & Research",
  "Surajmal Agarwal Girls College of Management",
  "Inder Singh Rawat Rajkiya Mahavidyalaya Pokhal, Tehri Garhwal",
  "Shaheed Srimati Hansa Dhanai Rajkiya Mahavidyalaya, Agrora (Dharmandal), Tehri Garhwal",
  "M.I.E.T. Kumaon",
  "maa purnagiri college of education",
  "SUSHILA INSTITUTE OF MEDICAL SCIENCES",
  "JAIVEER MEMORIAL SATYA MAHAVIDYALAYA DANGI NAILCHAMI TEHSIL GHANSALI",
  "SHRI RAM COLLEGE OF EDUCATION JALALPUR HARIDWAR",
  "College of Technology",
  "College of Home Science",
  "College of Post-Graduate Studies",
  "Baba Farid Institute of Technology, Dehradun",
  "Colloge of Basic Sciences & Humanities",
  "College of Fisheries",
  "College of Veterinary & Animal Sciences",
  "College of Agriculture",
  "College of Agribusiness Management",
  "Himalayan College, Himalayan Charitable Trust, Shiv Complex, Civil Line, Roorkee",
  "CHINMAYA ADVANCE RESERCH EDUCATION , CARE COLLEGE OF PARAMEDICAL SCIENCES ",
  "Roorkee Adventist College, Roorkee",
  "AMAZON INSTITUTE OF HOTEL TOURISM AND MANAGEMENT",
  "Nalanda College of Education,SC-1, C-28, Defence Colony, Dehradun",
  "Chanakya Law College, Rudrapur",
  "Govt. Degree College, Bhikiyasen",
  "Droan B.Ed College, Gadarpur Road Rudrapur",
  "College of Education, Roorkee-Haridwar Road,Shantarshah, Haridwar",
  "RAJKIYA MAHAVIDYALYA , MORI",
  "Dhanauri  P G College, Dhanauri",
  "JANTA GIRLS DEGREE COLLEGE    ",
  "MAA AMBEY INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES    ",
  "DIVINE COLLEGE OF NATUROPATHY AND YOGIC SCIENCES    ",
  "Poornagiri College of Education",
  "Harsh Vidya Mandir (P.G.) College, Raisi, Haridwar",
  "SWAMI VIVEKANAND COLLEGE OF MANAGEMENT AND TECHNOLOGY(VCMT)",
  "D D COLLEGE  ",
  "CH. BHARAT SINGH INSTITUTE OF TEACHER EDUCATION COURSES JHABRERA",
  "Govt. Degree College, Pokhra",
  "Beehive Ayurved Medical College and Hospital",
  "Amrit College of Education, Dhanauri",
  "SANJEEVANI YOG AVUM NATUROPATHY SANSTHAN",
  "B.R. EDUCATION SAMITI ",
  "Garhwal Mahavidayalya",
  "Chandola Homoeopathic Medical College and Hospital ",
  "GOVT DEGREE COLLEGE BRAHMKHAL",
  "Vishamber Sahai Ayurvedic Medical College and Research Center, Roorkee.",
  "Saraswati Professional Degree College",
  "Government Degree College, Uffrainkhal",
  "s.j.s.group of education",
  "DEV BHOOMI MEDICAL COLLEGE OF AYURVEDA AND HOSPITAL",
  "HARIOM SARASWATI P.G. COLLEGE ",
  "Govt Degree College Maldhanchaur (Nainital)",
  "SITA RAM DEGREE COLLEGE ROORKEE",
  "Chinmaya Advance Research Education (CARE) College of Nursing",
  "MOTHERHOOD AYURVEDA MEDICAL COLLEGE",
  "HARIDWAR AYURVEDIC MEDICAL COLLEGE AND RESEARCH CENTRE ",
  "GURU NANAK COLLEGE OF NURSING ",
  "Alchemist School of Education,Khatima",
  "aryan college of education ",
  "JBIT College of Pharmacy",
  "JAGANNATH VISHWA COLLEGE",
  "Anusuya Prasad Bahuguna Govt. P.G College, Agastyamuni",
  "SMT MANJIRA DEVI NURSING AND PARAMEDICAL COLLEGE HITANU DHANARI UTTARKASHI",
  "Veer Shaheed Kesari Chand Rajkiya Snatkottar Mahavidyalaya, Dakpathar, Vikas Nagar",
  "PRAGATI PARAMEDICAL INSTITUTE AND HOSPITAL",
  "Govt. Degree College Lamgara",
  "UTTARANCHAL MEDICAL COLLEGE OF AYURVEDA AND RESEARCH, PREMNAGAR, DEHRADUN ",
  "SHRI RAM INSTITUTE OF HOTEL MANAGEMENT",
  "PARAAJ INSTITUTE OF MEDICAL SCIENCE",
  "SHRI RAGHUNATH KIRTI CAMPUS",
  "GOVERNMENT NURSING COLLEGE, HALDWANI",
  "Chinmaya Degree College, Haridwar",
  "G.R.D Girls Degree College, Niranjanpur, Near Police Line, Patel Nagar, Dehradun",
  "D.A.V.P.G College, Dehradun",
  "Himalayan Institute of Technology, Dehradun",
  "Droan B.Ed College for Woman, Sunderpur Road, Dineshpur, Rudrapur",
  "DSB Campus",
  "GET GROUP OF INSTITUTIONS COLLEGE OF NURSING",
  "MAHAY YOGI PILOT BABA COLLEGE OF HIGHER EDUCATION AND RESEARCH TALLA GETHIYA, BHOWALI SANITORIUM",
  "HERBERTPUR CHRISTIAN  HOSPITAL, COLLEGE  OF NURSING",
  "Hermann Gmeiner Degree College, Bhimtal",
  "ALPINE INSTITUTE OF MEDICAL SCIENCE AND HOSPITAL",
  "Shri Guru Nanak  Degree College, Preet Vihar Colony, Rudrapur",
  "DOON FILM SCHOOL    ",
  "SWAMI VIVEKANAND VIDHYA MANDIR MAHAVIDHYALAYA BELESHWAR     ",
  "Shri Sanatan Dharm Govt.Girls  Degree College, Rudrapur",
  " Amrapali Institute of Applied Science, Haldwani",
  "ARYABHATTA RESEARCH INSTITUTE OF OBSERVATIONAL SCIENCES",
  "National Institute for the Empowerment of Persons with Visual Disabilities (Divyangjan), Dehradun",
  "HEC GROUP OF INSTITUTIONS",
  "ROORKEE DEGREE COLLEGE ROORKEE",
  " P.N.G.GOVERNMENT P.G.COLLEGE, RAMNGAR",
  "V3 COLLEGE OF NURSING ",
  "DURGA INSTITUTE OF PARAMEDICAL SCIENCES",
  "RUDRAPUR COLLEGE OF MANAGEMENT And TECHNOLOGY",
  "UNITY COLLEGE OF NURSING",
  "SHRIBADRISH KEERTI SANSKRIT VIDYALPEETH, DIMMAR SIMALI, CHAMOLI",
  "Govt. Degree College, Jakholi",
  "SHRI BADRINATH VEDA-VEDANGA SNATKOTAT MAHAVIDYALAYA, JOSHIMATH, CHAMOLI",
  "SHRI RAGHUNATH KEERTI ADARSH SANSKRIT MAHAVIDYALAYA, DEVPRAYAG, PAURI-GARHWAL",
  "Govt. Institute of Hotel Management-Almora",
  "uttarakhand aayurvedic college",
  "UTTARANCHAL AYURVEDIC COLLEGE, RAJPUR ROAD, DEHRADUN",
  "DOON INSTITUTE OF AYURVEDA FACULTY SCIENCE",
  "SHRI BHAGWANDAS SANSKRIT MAHAVIDYALAYA, HARIDWAR",
  "ANMOL BHARTIYA UPCHAR EVAM YOGA SANSTHAN",
  "College of Pharmacy Roorkee",
  "Burman Group of Institution",
  "RAJKIYA MAHAVIDHYALAY PATI",
  "SWARGIYA SHREE JAIDATT WAILLA SWANTANTRATA SANGRAM SENANI GOVERNMENT POST GRADUATE COLLEGE, RANIKHET",
  "Alpine Institute of Management and Technology, Dehradun",
  "Swatantrata Sangram Senani Sw. Sri Pan Singh Bisht Rajkiya Mahavidyalaya, Talla Sult, Almora",
  "Tulas Institute",
  "Mayank College of Education",
  "S.D. College of Education",
  "HIMALAYAN YOG AVAM PRAKRITIK CHIKITSA SHIKSHAN SANSTHAN",
  "SHRIDEV SUMAN SUBHARTI MEDICAL COLLEGE",
  "Roorkee College of Pharmacy",
  "GOVERMENT DEGREE COLLEGE KHADI TEHRI GARHWAL",
  "INSTITUTE OF PROFESSIONAL STUDIES",
  "School of Pharmaceutical Sciences",
  "GRACE PARAMEDICAL COLLEGE ",
  "Institute of Hospitality, Management and Sciences",
  "Seema Dental College and Hospital,Veerbhadra Road, Rishikesh",
  "Dev Bhoomi School of Architecture",
  "M B Govt. P.G. College, Haldwani",
  "SAHEED BELMATI CHAUHAN GOVERNMENT DEGREE COLLEGE, POKHRI (QUILI)",
  "DEVSTHALI VIDYAPEETH COLLEGE OF NURSING",
  "Gyan Uday College Of Higher Education",
  "GRD (PG) IMT",
  "MINERVA INSTITUTE OF MANAGEMENT And TECHNOLOGY",
  "LIBRA COLLEGE OF HIGHER STUDIES",
  "Krishna Insititute of Technology Laksar Haridwar",
  "Doon (PG) College of Agriculture Science and Technology, Camp Road, Selaqui, Dehradun",
  "AAROGYAM INSTITUTION OF PARAMEDICAL AND ALLIED SCIENCES",
  "Barfiya Lal Juwantha Govt Post Graduate College, Purola Uttarkashi",
  "EDUCITY INSTITUTE ",
  "CITY DEGREE COLLEGE OF MANAGEMENT AND TECHONOLOGY",
  "Uttaranchal College of Technology and Biomedical Science, Saharanpur Road, Dehradun",
  "Dev Bhumi Institue of Professional Education, Rudrapur",
  "Govt. P G College, Gangolihat",
  "Uttaranchal Dental Medical and Research  Institute, Dehradun",
  "Rajkiya Mahavidyalaya Banbasa (Champawat)",
  "College of Engineering Roorkee",
  "JBIT COLLEGE OF APPLIED SCIENCE",
  "DOON INSTITUTE OF MEDICAL SCIENCES FACULTY OF PARAMEDICAL SCIENCES",
  "Swargiya Shri Madan Mohan Upadhyay Swatantrata Sangram Senani Rajkeeya Snatkottar Mahavidhyalaya Dwarahat Almora",
  "Beehive College of Engg. & Technology",
  "Bhakt Darshan Govt. Post Graduate College, Jaiharikhal",
  "BISHAMBER SAHAI P.G COLLEGE, ROORKEE",
  "RAJKIYA MAHAVIDYALAYA BHUPATWALA, HARIDWAR",
  "Modern Global Nursing Institute",
  "SURAJMAL MEDICAL COLLEGE OF AYURVED AND HOSPITAL",
  "HARIOM SARASWATI COLLEGE OF NURSING    ",
  "Shri Shivnath Sanskrit Mahavidyalaya",
  "Govt. P G College, Someshwar",
  "HOPE INSTITUTE OF MEDICAL SCIENCE COLLEGE OF NURSING ",
  "SATYENDRA CHANDRA GURIA IMT COLLEGE OF MANAGEMENT AND HIGHER STUDIES",
  "DOON INSTITUTE OF MEDICAL SCIENCES ",
  "Jai Arihant College of Teacher Education",
  "shrimad dayanand arsh jyotirmath gurukul",
  "GOVERNMENT NURSING COLLEGE BASE HOSPITAL ALMORA",
  "Surajmal Agarwal Private Govt.Girls  Degree College, Kichha",
  "Pal College of Technology and Management, Haldwani",
  "Pt. Poornanand Tiwari Government Degree College, Doshapani, Chaukhuta",
  "Govt. Degree College, Margubpur, Roorkee, Haridwar",
  "H.N.B. Government P.G. College, Khatima",
  "INSTITUTE OF TECHNOLOGY BAUN UTTARKASHI",
  "SAMRAT PRITHVIRAJ CHAUHAN INSTITUTE OF NURSING AND PARAMEDICAL SCIENCE",
  "Wildlife Institute of India",
  "SAI COLLEGE OF NURSING DEHRADUN",
  "Rajkiya Mahavidyalaya Kanvaghati Kotdwar ",
  "DEVSTHALI  PG COLLEGE OF BIOMEDICAL SCIENCES AND RESEARCH",
  "ASHA ACADEMY",
  "SOBAN SINGH JEENA GOVERNMENT INSTITUTE OF MEDICAL SCIENCE AND RESEARCH",
  "ARIHANT LAW COLLEGE",
  "SAI COLLEGE OF PHARMACY",
  "RISHI YOG INSTITUTE",
  "GOVT DEGREE COLLEGE PABAU",
  "Roorkee college of Education",
  "DOON COLLEGE OF NURSING AND PARAMEDICAL SCIENCE    ",
  "DAIVI SAMPAD ADHYATMA SANSKRIT MAHAVIDYALAYA, PARMARTHA NIKETAN, PO- SWARGASHRAMA, PAURI-GARHWAL",
  "Rajkiya Mahavidyalaya Manglour, Haridwar",
  "Dharmanand Uniyal Government Degree College, Narendranagar ",
  "KUNWAR PRABHA DEGREE COLLEGE LALDHANG HARIDWAR",
  "Govt. P G College, Munsyari",
  "Om Ayurvedic Medical College Hospital AND Research Center Roorkee",
  "MAA GANGE INSTITUTE OF HOTEL MANAGEMENT AND PROFESSIONAL STUDIES",
  "Ganna Krishak Govt.Girls  Degree College, Kichha",
  "PRAGATI INSTITUTE OF PARAMEDICAL AND HOSPITAL",
  "Veer Chandra Singh Garhwali Govt Institute of Medical Science and Research ",
  "Himalayan Institute of Medical Sciences",
  "Sriram  Institute of Management and Technology, Kashipur",
  "WOMEN INSTITUTE OF TECHNOLOGY",
  "Kashipur College of Education",
  "KINGSTON IMPERIAL INSTITUTE OF TECHNOLOGY AND SCIENCES",
  "Laxmi College of Education, Bichpuri Farm, Bazpur",
  "MAHILA VIDYALYA DEGREE COLLEGE, SATI KUND KANKHAL, HARIDWAR",
  "D P S College of Education, Bichpuri Farm, Bazpur",
  "SARDAR BHAGAT SINGH GOVERNMENT POST GRADUATE COLLEGE, RUDRAPUR, UDHAM SINGH NAGAR- 263153, UTTARAKHAND",
  "LAL BAHADUR SHASTRI GOVERNMENT POST GRADUATE COLLEGE,HALDUCHAUR (NAINITAL) UTTARAKHAND",
  "BFIT INSTITUTE OF SCIENCES AND HOSPITAL ",
  "JAGANNATH VISHWA COLLEGE OF EDUCATION",
  "ROORKEE BUSINESS SCHOOL OF PHARMACY, ROORKEE",
  "QUANTUM SCHOOL OF GRADUATE STUDIES",
  "Saraswati Institute of Management & Technology",
  "Patanjali Bhartiya Ayurvigyan Evam Anusandhan Sansthan, Patanjali Yogpeeth Haridwar",
  "GURU NANAK COLLEGE OF PARAMEDICAL SCIENCES AND HOSPITAL",
  "SGBG MEMORIYAL COLLEGE OF EDUCATION",
  "SATYENDRA CHANDRA GURIA LAW COLLEGE",
  "Dr. Shivanand Nautiyal Government Post Graduate College, Karanprayag (Chamoli)",
  "COER School of Management",
  "Siddhartha Institute of Pharmacy",
  "Govt. Degree College, Barkot",
  "Rajkiya Mahavidyalaya Kichha Udham Singh Nagar",
  "Maya College of Agriculture and Technology   ",
  "Phonics Group of Institutions",
  "Inspirational College of Teachers Education, Kathgodam",
  "RAJKIYA SNATKOTTAR MAHAVIDYALAYA, JOSHIMATH",
  "Himalayan Adhyan Kendra, Pithoragarh",
  "Gopal Babu Goswami Government Degree College Chaukhutia",
  "QUADRA INSTITUTE OF AYURVEDA, ROORKEE",
  "Doon Business School",
  "B.R.D. College of Management & Sciences",
  "Govt. Degree College, Talwari",
  "K.L.D.A.V College, Roorkee",
  "HARDEV SINGH SMARAK COLLEGE JASPUR",
  "Doon College of Engg. & Technology",
  "Devsthali Vidhyapeeth College of Pharmacy",
  "Dronacharya Institute of Teacher Education, VPO- Dharamwala, Vikasnagar, Shimla bypass Road, Dehradun",
  "Nimbus Academy of Management, Jhajhara, Dehradun",
  "Doon Ghati College of Professional Education, Doiwala, Dehradun",
  "VCSG College of Horticulture",
  "Rajkiya Mahavidyalaya Amori (Champawat)",
  "S.P Memorial B.Ed. College, Bhaktiyana, Srinagar",
  "B.S.M B.Ed College, Roorkee",
  "Pandit Purnanand Tiwari Law College, Idgah Road, Jwalapur,Haridwar",
  "M.S Garg B.Ed. College Laksar, Roorkee",
  "Roorkee Degree College, Dhanauri, Roorkee",
  "Arihant College of Education, Vill- Shantarshah,P.O-Daulatpur,Via- Badharabad, Haridwar",
  "Shrishti Institute of Education, Iqbalpur Road, Asafnagar, Shantipuram, Roorkee",
  "RAGHOMAL OMPRAKASH GOYAL DEGREE COLLEGE",
  "S.B.N DEGREE COLLEGE",
  "SWAMI VIVEKANANDA COLLEGE OF EDUCATION ROORKEE",
  "Harishcandra Ramkali B.Ed. College",
  "Amrit Law College, Dhanauri",
  "NORTHERN INDIA COLLEGE OF EDUCATION",
  "Pherupur Degree Collage,Pherupur",
  "SHRI SARSWATI SANSKRIT MAHAVIDYALAYA, VASUKEDAR, RUDRAPRAYAG",
  "Institute of Management and Technology, Kashipur",
  "Faculty of Ayurveda",
  "SARDAR MAHIPAL RAJENDRA DEGREE COLLEGE",
  "PDG College of Education, Bichpuri Farm, Bazpur",
  "Maya Institute of Technology & Management",
  "N S GAHLAUT MEMORIAL LAW COLLEGE",
  "BHARTIYA MAHAVIDYALAYA",
  "SHRI KASHI VISHWANATH MAHAVIDYALAYA, UTTARKASHI",
  "BAJAJ COLLEGE OF MANAGEMENT AND TECHNOLOGY,CHINI MILL ROAD",
  "Sri Sai Shikshan Sansthan",
  "Government Post Graduate college, Sitarganj",
  "MAYA DEVI EDUCATIONAL FOUNDATION B.ED. COLLEGE",
  "GURU NANAK COLLEGE OF PHARMACEUTICAL SCIENCES",
  "GOVERNMENT COLLEGE OF NURSING, PATIYALDHAR, GOPESHWAR, CHAMOLI",
  "Govt. Degree College, Chaubattakhal",
  "SIDDHARTHA NURSING EDUCATION AND RESEARCH INSTITUTE",
  "HarishChand Ramkali Degree College",
  "DR RATAN LAL HIMALAYAN DEGREE COLLEGE ROORKEE HARIDWAR",
  "GOVERNMENT DEGREE COLLEGE GADARPUR ",
  "GOVT DEGREE COLLEGE, KHIRSU, PAURI GARHWAL   ",
  "Dronas College of Management & Technical Education",
  "Doon Paramedical College,28, Chakrata Road, Dehradun",
  "Rajkiya Mahavidyalaya, Kotabagh",
  "SWAMI VIVEKANAND INSTITUTE OF NURSING ",
  "Institute of Technology Roorkee (ITR)",
  "ARYAWART GURUKUL MAHAVIDYALAYA, BAJEDARA, UNNAO",
  "R.L.R.P. MAHAVIDYALAYA, UGU, UNNAO",
  "SUMAN SATYANARAYAN JANHIT MAHAVIDYALAYA, SABLI KHERA, SADIPUR, UNNAO",
  "Shri Gulab Hari Sanskrit Mahavidyalaya, Vrindavan",
  "Shri Ramdeshik Snatakottar Sanskrit Mahavidyalaya, Shri Vaisnavashram, Daraganj, Prayag",
  "Shri Ramkrishna Sanskrit Mahavidyalaya, Pawara",
  "Harish chandra Research Institute (HRI),Allahabad",
  "Vivekanand College of Nursing",
  "GANGA SHEEL MAHAVIDHYALAYA",
  "Vishva Bandhu Sanskrit Mahavidyalaya, Usaka Bazar",
  "SARDAR ISHWAR SINGH DEGREE COLLEGE, LAKHIMPUR",
  "Chitamber School of Humanities & Social Sciences",
  "SRI GAJENDRA SINGH SMRATI VIDHI M/V",
  "BRAJ BHUSAN SINGH MAHAVIDYALAYA, BRAJRAJ NAGAR, MURCHA",
  "CHAUDHARY CHARAN SINGH COLLEGE OF LAW HEORA",
  "SAINIK KALKA SINGH BAIJNATH NAGAR",
  "AZIZ COLLEGE OF LAW, JAHANGIRPUR",
  "SARLA DWIVEDI VIDHI M/V, AKBARPUR",
  "SANSKAR DEGREE COLLEGE, BHATKHERWA ROAD, TAURA",
  "Shri Ramdwihal Sanskrit Mahavidyalaya, Mayandipur, Mitava",
  "LALA HARIRAM GANGA DEVI MAHAVIDYALAYA, KUKUHI, KACHAUNA,",
  "R P SINGH MEMORIAL DEGREE COLLEGE, VILLAGE AND POST PADIYA NAGLA, BLOCK BHAGATPUR, MORADABAD",
  "BALA DEVI ROSHAN LAL LAW COLLEGE BISALPUR PILIBHIT",
  "ABES ENGINEERING COLLEGE, GHAZIABAD",
  "ABES INSTITUTE OF TECHNOLOGY, GHAZIABAD",
  "ABSS INSTITUTE OF TECHNOLOGY, MAWANA ROAD, MEERUT",
  "ACCURATE INSTITUTE OF ADVANCED MANAGEMENT, GREATER NOIDA",
  "ACCURATE INSTITUTE OF ARCHITERCTURE AND PANNING, GREATER NOIDA",
  "ACE COLLEGE OF ENGINEERING AND MANAGEMENT,ETMADPURA,AGRA.",
  "ACN COLLEGE OF ENGINEERING AND MANAGEMENT STUDIES, KASIMPUR ROAD, VILL.- CHERRAT, ALIGARH",
  "ADHUNIK COLLEGE OF ENGINEERING , DUHAI, GHAZIABAD",
  "ADHUNIK INSTITUTE OF PRODUCTIVITY MANAGEMENT AND RESEARCH , GHAZIABAD",
  "AJAY KUMAR GARG ENGINEERING COLLEGE, GHAZIABAD",
  "AJAY KUMAR GARG INSTITUTE OF MANAGEMENT, GHAZIABAD.",
  "ANJALI COLLEGE OF PHARMACY AND SC., ETMADPUR, AGRA",
  "APEX INSTITUTE OF TECHNOLOGY, RAMPUR",
  "AR INSTITUTE OF MANAGEMENT AND TECHNOLOGY, MEERUT.",
  "BHAGWANT INSTITUTE OF TECHNOLOGY, MUZAFFAR NAGAR",
  "BRAHMANAND GROUP OF INSTITUTIONS,BULANDSHAHAR",
  "B S A COLLEGE OF ENGINEERING AND TECHNOLOGY, MATHURA",
  "CBS COLLEGE OF MANAGEMENT,AGRA.",
  "DEWAN V.S. INSTITUTE OF HOTEL MANAGEMENT AND TECHNOLOGY, MEERUT.",
  "ESHAN COLLEGE OF ENGINEERING, AGRA-MATHURA HIGHWAY, MATHURA",
  "FACULTY OF ENGG. AND TECHNOLOGY, AGRA COLLEGE, AGRA",
  "FIT ENGINEERING COLLEGE, KASERU BUXAR, MEERUT",
  "FORTE INSTITUTE OF TECHNOLOGY, MEERUT",
  "GALGOTIA S COLLEGE OF ENGINEERING AND TECHNOLOGY, GREATER NOIDA",
  "HARDAYAL TECHNICAL CAMPUS MATHURA",
  "HARI COLLEGE OF MANAGEMENT, GAGALHERI, SAHARANPUR",
  "HARLAL INSTITUTE OF MANAGEMENT AND TECHNOLOGY, GREATER NOIDA",
  "HERITAGE INSTITUTE OF HOTEL AND TOURISM, AGRA",
  "HINDUSTAN COLLEGE OF SCIENCE & TECHNOLOGY,  MATHURA",
  "HI-TECH INSTITUTE OF ENGINEERING AND TECHNOLOGY, GHAZIABAD",
  "HLM COLLEGE, 11 KM. DELHI-MEERUT ROAD, GHAZIABAD",
  "H. R. INSTITUTE OF ENGINEERING AND TECHNOLOGY, GHAZIABAD",
  "H.R.INSTITUTE OF HOTEL MANAGEMENT, MORTA, GHAZIABAD",
  "H.R.INSTITUTE OF PHARMACY, MORTA, GHAZIABAD",
  "H.R.INSTITUTE OF TECHNOLOGY, MORTA, GHAZIABAD",
  "IIMT COLLEGE OF ENGINEERING, GREATER NOIDA",
  "J.K. INSTITUTE OF PHARMACY AND MANAGEMENT, KHURJA, BULANDSHAHR",
  "JMS GROUP OF INSTITUTIONS, NH 24 BY PASS, HAPUR",
  "J.P.INSTITUTE OF ENGINEERING AND TECHNOLOGY, MEERUT",
  "J.P. INSTITUTE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY, MEERUT",
  "NEELKANTH INSTITUTE OF TECHNOLOGY, MEERUT",
  "NIMT INSTITUTE OF HOSPITAL AND PHARMA MANAGEMENT, GREATER NOIDA",
  "NKBR COLLEGE OF PHARMACY AND RESEARCH CENTRE, MEERUT",
  "NOIDA INSTITUTE OF ENGG. AND TECHNOLOGY, GREATER NOIDA",
  "CH SUGHAR SINGH EDUCATION ACADEMY",
  "JAINATH  MAHAVIDYALYA, ALIPUR, MADRA, JAKHANIYA, GHAZIPUR",
  "SANT LAKHANDAS VIDHI MAHAVIDYALAYA, TAPESWARI NAGAR, MARDAH, GHAZIPUR",
  "BRAMHLIN SHRI PUJARI MAHARAJ MAHAVIDYALYA, TIYARA, BADLAPUR, JAUNPUR",
  "DOODHNATH SINGH SMARK MAHAVIDYALAYA MARIYAHU, JAUNPUR",
  "RAMKARAN SHIVKARAN ADARSH MAHAVIDYALAYA, SIYAVA, BHITARI, GHAZIPUR",
  "BABA GAJJAN DAS BALIKA MAHAVIDYALAYA, JAWAL, GHAZIPUR",
  "Rajdhari Singh Smarak Mahavidyalaya, MIRZAPUR, GHAZIPUR",
  "SRAJAN INSTITUTE OF MANAGEMENT & TECHNOLOGY, FATEHGANJ (WEST), BAREILLY",
  "GURUKUL COLLEGE, RAWANA SIKARPUR, BIJNOR",
  "NORTH INDIA COLLEGE OF HIGHER EDUCATION, NAJIBABAD ( BIJNOR )",
  "RAM SINGH CHAUHAN MEMORIAL DEGREE COLLEGE, REHAR, BADIGARH, ( BIJNOR )",
  "S.S.D. COLLEGE OF HIGHER EDUCATION, GARMALPUR, NAJIBABAD ( BIJNOR )",
  "SANTOSH SMARAK MAHAVIDYALAYA, DODRAJPUR, KAYAM NAGAR, NAGINA (BIJNOR)",
  "VINAYAK COLLEGE, KOTWALI, BIJNOR",
  "LALA RADHEY SHYAM COLLEGE OF LAW, KOTWALI ROAD, NAGINA ( BIJNOR )",
  "MATA KAMLA DEVI MAHILA MAHAVIDYALAYA ,BIJNOR",
  "CH. SHER SINGH CHIKARA SMARAK MAHAVIDYALAYA, KAILBAKRI ( AMROHA )",
  "MAYFAIR COLLEGE, PANDIT NAGLA BYPASS, MORADABAD",
  "RAM CHARAN MAHATAVIYA DEVI MEMO. MAHAVIDYALAYA, THAKURDWARA(MORADABAD)",
  "SRI PARASNATH INSTITUTE OF EDUCATION & TECH., PIPALSANA ( MORADABAD )",
  "SUKHDAI SMARAK B.ED. COLLEGE, RATUPURA, THAKURDWARA ( MORADABAD )",
  "ADESH COLLEGE OF EDUCATION, NARAYANPUR, BISALPUR, PILIBHIT",
  "CHAUDHARY NIHAL SINGH MAHAVIDYALAYA, AIMI ( PILIBHIT )",
  "D.P.P. DEGREE COLLEGE, VILLAGE DHANKUNA, POST SAKHOLA ( PILIBHIT )",
  "KRISHNA MAHAVIDYALAYA, LALPUR, AAJADPUR, BANDA ( SHAHJAHANPUR )",
  "NEW GREAT SCHOLARS DEGREE COLLEGE, ISLAMGANJ,ALLAHAGANJ (SHAHJAHANPUR)",
  "SATYAPAL SINGH YADAV MAHAVIDYALAYA, KALAN ( SHAHJAHANPUR )",
  "MANGALMAY INSTITUTE OF ENGINEERING AND TECHNOLOGY, GREATER NOIDA",
  "SHANTI NIKETAN INSTITUTE OF TECHNOLOGY, RAHU NANGLI, CHANDPUR (BIJNOR)",
  "GYAN STHALY VIDHI MAHAVIDHYALAYA BACHAWALI BADAGAON JHANSI",
  "Swami Vivekanand Law College Premnagar Jhansi",
  "RADHA SWAMI PUBLIC MAHAVIDYALAYA, TAGALA, DILARI (MORADABAD)",
  "RAM RAHIM DEGREE COLLEGE, DARSHANPUR, SAIDNAGAR ( RAMPUR )",
  "HABIBI INSTITUTE OF HIGHER EDUCATION, DINGERPUR, GURER, BILARI (MORADABAD)",
  "GAHLAUT COLLEGE, HALDAUR (BIJNOR)",
  "BHAGWAN AADINATH COLLEGE OF EDUCATION MAHRRA LALITPUR",
  "I T M, COLLEGE OF EDUCATION",
  "GAHARWAR MAHAVIDYALAYA ",
  "SAINIK COLLEGE OF PHARMACY",
  "PREMWATI PRAKASH NARAYAN MAHAVIDYALAYA",
  "CHANDRA PRABHA SHARMA MAHAVIDHYALAYA",
  "SRI KASHI MAHAVIDHYALAYA",
  "NAZIRI MAHAVIDHYALAYA",
  "LALTI KUMUDESHWAR EDUCATIONAL AND TRAINING MAHILA COLLEGE ,GHURAHUPUR KERAKAT JAUNPUR",
  "HEERALAL YADAV COLLEGE OF LAW",
  "B. K. R. Girls Degree College, Ghazipur",
  "Baijnath Mahavidyalay, Budhanpur, Ghazipur",
  "A.Y.T. INSTUTITE OF HIGHER EDUCATION, DEORIA",
  "JAI SHANKAR KALAWATI DEVI MAHILA MAHAVIDYALAYA, SALLAHAPUR, DEORIA",
  "BRAMESHWARI MAHILA MAHAVIDYALAYA, GORAKHPUR",
  "GAUTAM BUDDHA MAHAVIDYALAYA, GORAKHPUR",
  "KAILASHI DEVI KESHAV PRASAD MAHILA MAHAVIDYALAYA, GORAKHPUR",
  "Kalindi Singh Mahavidyala, Ghazipur",
  "ASM mahavidyalaya, mathura",
  "N.K.COLLEGE, NAGLA BALLU HUSUMARA ROAD MAINPURI ",
  "Om Jee Mahavidyalay, Ghazipur",
  "Mata Tetara Devi Schidanand Girls Degree College, Ghazipur",
  "MAA SINGHASINI DEVI MAHILA MAHAVIDYALAYA, DEORIA",
  "P.K. MAHAVIDYALAYA, KUSHINAGAR",
  "MAHARANA PRATAP MAHILA MAHAVIDYALAYA, KUSHINAGAR",
  "Niranjan Mahavidyalaya Mustafabad Bijaura, Ghazipur",
  "Shri Lachiram Mahavidyalay, Ghazipur",
  "Raghunandan Kishundev Mahavidyalay, Ghazipur",
  "Saswat Surayvansi Mahavidyalay, Ghazipur",
  "Sant Kinaram Mahavidyalay, Ghazipur",
  "Ramapati Badhya Mahila Degree College, Ghazipur",
  "RAM RADHIKA MAHAVIDYALAY, DEORIA",
  "SONIYA MAHILA MAHAVIDYALAYA, DEORIA",
  "SRI BHAGAWAN DUTT MAHILA MAHAVIDYALAYA, DEORIA",
  "RAGHAV PRASAD MASHALI DEVI MAHILA MAHAVIDYALAYA, GORAKHPUR",
  "SHYAMA MALL MAHAVIDYALAYA, GORAKHPUR",
  "VEER BAHADUR SINGH SMARAK MAHAVIDYALAYA, GORAKHPUR",
  "SRI RAJENDRA YADAV MAHAVIDYALAYA, KUSHINAGAR",
  "TRIVENI RAI KISAN MAHILA MAHAVIDYALAYA, KUSHINAGAR",
  "S.K.S. COLLEGE, MATHURA",
  "MANJOOR ALI MAHAVIDYALAYA, DEORIA",
  "Adarsh M.D. Mahila Mahavidyalay, Talwal, Ghazipur",
  "RAKESH CHATURVEDI DEGREE COLLEGE, DASKOLAVA, BASTI",
  "Rajan Chandrika Mahavidyalaya, Ghazipur",
  "Shri Ramchandra Badami Mahila Mahavidyalaya, Ghazipur",
  "RAJKIYA MAHILA MAHAVIDYALAYA MISHRIKH SITAPUR",
  "DEEP VIDHI MAHAVIDYALAYA, RAMGARH, CHANDWAK, JAUNPUR",
  "SHANTI SINGH MEMORIAL INSTITUTE & RESEARCH CENTRE, BALLIA",
  "Rajaram Smriti Mahavidyalaya Chandpur, Ghazipur",
  "SHRI RASAL SINGH COLLEGE OF EDUCATION NAGLA MADNA",
  "R S MAHAVIDYALAYA HARCHANDPUR MAINPURI",
  "DIGVIJAI SINGH DEGREE COLLEGE",
  "MAHARANA PRATAP COLLEGE OF EDUCATION MANGURA KIRAWALI AGRA",
  "JAI SHRI SANKAT MOCHAN SHIKSHAN SANSTHAN",
  "SHRI BABURAM DEGREE COLLEGE, CHULHAWALI,TUNDLA",
  "ASHOK RAJMANI COLLEGE OF LAW, SARAIYA, MANIKPUR, CHITRAKOOT, UTTAR PRADESH",
  "Panchsheel mahavidyalaya",
  "Dr. Amit Kumar Singh Kanya Mahavidyalay, Ghazipur",
  "Dharma Devi Mahavidyalaya, Belapar, Baksa, Jaunpur",
  "SUDHAKAR SINGH FOUNDATION MAHAVIDYALAYA, PILKHINI, GAURABADSHAHPUR, JAUNPUR",
  "Shri Ram Degree College, Jamunipur Nigoh Jaunpur ",
  "RAMKARAN INSTITUTE OF HIGHER EDUCATION,NAULI  KHUTHAN JAUNPUR",
  "KATYAYANI COLLEGE OF LAW",
  "SHARDA SHANTI COLLEGE OF LAW",
  "Saheed Bhagat Singh Baba Murali Mahila Degree College, Sadat",
  "MA SARYU DEVI MAHAVIDYALAYA PAHARPUR KALAN HARIPUR KARAUNDI KALAN SULTANPUR",
  "Rajarshi Tandon Girls Degree College",
  "GOVERNMENT DEGREE COLLEGE SAIYAN KHERAGARH AGRA",
  "BABA KANHAIYA MAHAVIDYALAYA, GHARI KOLAHAR, MATHURA",
  "HARI RAM PATEL LAW COLLEGE PILKHUA MAUAIMA PRAYAGRAJ",
  "Institute of Mental Health and Hospital",
  "Smt. Sudesh Devi Memorial College of Education ",
  "D.N.V. COLLEGE ",
  "Krishna College, Barsana Road Nand Gaon",
  "MATA JHANDEWALAN EDUCATION",
  "Swami Dayanand Sarswati Educational Institute, Bhawalpur Bansali Sambhal",
  "PT HEERALAL VIDHI MAHAVIDYALAYA ANTU DEHAT PRATAPGARH",
  "Maa Israji Devi Mahavidyalay, Jaunpur",
  "K S V Institute of Engg. and Technology, Sadat, Ghazipur",
  "SITA DEVI MAHAVIDYALAYA",
  "Government Medical College, Jalaun",
  "RAJAT COLLEGE OF EDUCATION AND MANAGEMENT",
  "Government Medical College, Kannauj",
  "Mata Dhanamati Devi Degree College, Kurahawa",
  "PARASHURAM SINGH MAHAVIDYALAYA, BANKI MOD, PATEHARA KALA",
  "MANGLAM MAHILA MAHAVIDYALAY, MUSAFIR KHANA, AMETHI",
  "VINOD KUMAR MAHILA MAHAVIDALYA, MAHMOODPUR SEMARI",
  "Sonalal Jha Shakuntala Devi Mahila Degree College, Jhungia Bazar, Gorakhpur",
  "SW SHREE CHANDRA SHEKHAR PANDEY MAHAVIDYALAYA",
  "RAGHUNATH PRASAD DEGREE COLLEGE, TERAHI MAFI",
  "AVM GIRLS INSTITUTE",
  "ISRAWATI DEVI MAHAVIDYALAYA",
  "BABA RAM NATH SAMRAK MAHAVIDYALAYA",
  "ADARSH COLLEGE OF EDUCATION",
  "RAMARPIT MAHAVIDYALAYA, GAZIPUR",
  "Rajeshwar Mahadev Degree College, Amrupur, Ghazipur",
  "KISAN DEGREE COLLEGE, BANGAON KATRA BAZAR",
  "NAVJEEVAN KISAN DEGREE COLLEGE, MAWANA",
  "M.D. COLLEGE OF HIGHER EDUCATION FOR GIRLS, BIJNOR",
  "Ranjeet Singh Inistute of Education and Tecnology",
  "RAJAVAT COLLEGE OF EDUCATION, PALI, LALITPUR",
  "Pt. Munnilal Sharma Mahavidhyalaya, Patti Pachigain, Rohta",
  "SHRI RANVIR SINGH MAHAVIDHYALAYA PARSOTI GARHI SURIR MANT MATHURA",
  "JIMS ENGINEERING MANAGEMENT AND TECHINICAL CAMPUS",
  "SPARSH MAHAVIDYALAYA",
  "LATE BHAGIRATHI YADAV MAHAVIDYALAYA",
  "SRI AMAR BAHADUR MAHAVIDYALAYA",
  "PIONEER MAHILA MAHAVIDALAYA",
  "MAA BHAWANI MAHILA MAHAVIDYALAYA, SOGAI",
  "VEERMATI VIDHYA MAHAVIDYALAYA,KEWALI MAYDEWALI,GHORAWAL",
  "Smt Kastoori Dwivedi Adarsh Shiksha Mavidhyalaya",
  "Sw. Ravindranand Badoniya Mahavidyalaya",
  "SAYED MOHAMMAD ISHTIYAK MAHILA MAHAVIDYALAYA NAWABGANJ GONDA",
  "DEVIDEEN SINGH MAHAVIDYALAYA LOLPUR SHIVDAYALGANJ GONDA",
  "B P MAHAVIDYALAYA NARAYANPUR MASKINWA GONDA",
  "HARI PRASAD CHANDRAWATI SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA SEEHMAI KARIRAT AMBEDKARNAGAR",
  "Seemawarti Degree College,Pandey Nagar,Jaitapur,Rupaidiha Bahraich",
  "MAA GAYATRI MAHILA MAHAVIDYALAYA HINGUTARGARH CHANDAULI",
  "SW DR SRI KUBER SINGH MAHAVIDYALAYA",
  "baba jai gurudev smriti maha vidhyalya, tighra ambedkarnagar",
  "RAJA DEVI BUX SINGH AWADH RAJ SINGH MAHAVIDYALYA EVM PARSHIKSHAN SANSTHAN",
  "Deep Narayan Surya Kumar Smrit Mahavidyalay Bandipur Ambedkar Nagar",
  "Ramlakhan Singh Mahavidyalaya  Rampur Baijapur, Jaunpur",
  "HP INSTITUTE OF HIGHER EDUCATION,DATAGANJ ROAD",
  "Indraprastha Law College ",
  "PT RAMSHABAD SMRITI MAHAVIDYALAYA, VISHUNPUR, VAJADAHA, JAHANGIRGANJ",
  "S S V MAHAVIDALAYA, HALAPUR",
  "SHIV MURAT SINGH MAHAVIDYALAYA, TRISHUNDI, AMETHI",
  "NIRMALA INSTITUTE OF WOMENS EDUCATION AND TECHNOLOGY ",
  "SMT SUBHADRA TIWARI MAHAVIDYALAYA, KIRTUPUR, PARAHATHIGO, BIKAPUR",
  "ADARSH MAHILA MAHAVIDYALAYA",
  "SAVITRI SHRI NATH MAHAVIDYALAYA, RASHULPUR, BAKARGUNJ",
  "M L S LAW COLLEGE JAKHAULI RUDAULI AYODHYA",
  "LALJI LAW COLLEGE BARA PARSHADEPUR SALON RAEBARELI",
  "SHASHI BHUSHAN SHARAN SINGH MAHAVIDYALAYA, UJJAINI KALAN",
  "Saraswati Mahila Mahavidyalaya, Katsari",
  "Sri Pal Singh Smarak Mahila Mahavidayalaya, Garavpur Lambhua",
  "AJIJUL NISHA GIRLS DEGREE COLLEGE, DARIYAPUR, POWER HOUSE, RANIGANJ",
  "Shakuntla Devi Mahila Shikshan Evam Prashikshan Shansthan, Pooni Bhim Patti Chanda",
  "NRIPATI NARAIN SINGH SMARAK MAHAVIDYALAYA ",
  "Phoolmati Institute",
  "SHATAKSHI COLLEGE OF EDUCATION, CHITWANA",
  "SHANTI YADAV DEGREE COLLEGE, MOHAMMAD NAGAR ",
  "RAJKIYA MAHAVIDYALAYA HARDATTNAGAR, GIRANT, JAMUNHA, SHRAVASTI",
  "MAHENDRA INSTITUTE OF TECHNOLOGY, MEERUT",
  "SHRI DARBARI LAL VIMLA DEVI KRISHNA KUMAR MAHAVIDYALAYA, KALUWA MAU ANRAJAULI",
  "K R S INSTITUTE OF LAW, INDIRAPIR, GONDA",
  "Bholanath Smarak Mahavidyalaya, Dhamupur",
  "SHANTI NIKETAN INSTITUTE OF TEACHER EDUCATION",
  "DUSIYANT SINGH BHALESULTAN MAHAVIDYALAYA, SADIPUR MUSAFIRKHANA",
  "SHANTI INSTITUTE OF TECHNOLOGY",
  "GYAN SHREE COLLEGE OF PROFESSIONAL EDUCATION, BEHSUMA",
  "Hamidia Girls Degree College",
  "Baba Budheshwar Nath Shikshan Prashikshan Mahavidyalaya, Rampur, Dhebiahar, Nanpara",
  "Ram Janaki Sanskrit Snatkottar Mahavidyalaya",
  "Kalawati Devi Smark Mahavidyalaya",
  "S K B M Degree College, Dildar Nagar",
  "Jay Kamakhya Jag Jeewan Dharmachandra Shukla Mahavidyalaya, Rautawan",
  "JAY ABALA JAG JEEWAN MAHAVIDYALA AVAM SHIKSHAN PRASHIKASHAN, BIHARA",
  "BHAGAWANDAS MAURYA MAHILA MAHAVIDYALAYA, SHUKLA BAZAR",
  "SRI SAI SHIVRAM GIRLS  EDUCATIONAL INSTITUTE,  SARAYBHAGMANI, GAURIGANJ, AMETHI ",
  "MAHARSHI DAYANAND DEGREE COLLEGE, PALARA",
  "MATA RAMDASI MAHILA MAHAVIDYALAYA, BAHADURA TIKRI",
  "BHAGYAWANTI DEVI DEVTA SINGH MAHILA MAHAVIDYALAYA, KARMA KODRI",
  "Shri Hanuman Sanskrit Mahavidyalaya",
  "Shri Krisnaurvedik Sanskrit Mahavidyalaya, Moosanagar Kanpur Dehat",
  "ISHWAR PRASAD MAHAVIDYALAYA  DEURA RAJA TENDU ",
  "M.G.M DEGREE COLLEGE, DHIKOLI",
  "I.I.M.T. COLLEGE OF SCIENCE & TECHNOLOGY PLOT NO. A-20, KNOWLEDGE PARK-III, GREATER NOIDA , 0120-2322655, 9412781877",
  "Amarawati Devi Mahavidyalaya, Jaipalapar, Khajani",
  "APEX COLLEGE OF EDUCATION",
  "MAA SHARADA MAHAVIDYALAYA, PAKARPUR KADIPUR",
  "Manvar Kanshiram Gautam Buddh Girls Degree College, Sauraha, Gangi Bazar",
  "Yoginath Vidhyapeeth ",
  "AMBEKESHWAR INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "SHAKUNTALA DEVI COLLEGE OF PHARMACY",
  "Bhuval Mahavidyalay,Barodeeh",
  "GAUTAM BUDDHA MAHAVIDYALAYA",
  "CH. GANGA SINGH GODAWALI MAHAVIDYALAYA",
  "Dron college of education",
  "V N Bhatkhande Sangeet Mahavidyalaya, Ghaziabad 201001",
  "VISHRAM SINGH SHANTI DEVI MAHAVIDYALAYA",
  "GURU NANAK DEGREE COLLEGE",
  "BABA LAXMANDAS MAHAVIDYALAYA",
  " Id Memorial Degree college, Ghazipur",
  "Shiv Mahavidyalay, Hariharpur, Dobhi, Jaunpur",
  "Jai Maa Sudami Devi Mahavidyalaya Khanpur Ghazipur",
  "DEENANATH VIDHI MAHAVIDYALAYA SEMARI PRATAPPUR HANDIA PRAYAGRAJ",
  "AKHTARI QURESHI GIRLS DEGREE COLLEGE",
  "Gairul Nisa Girls Degree College",
  "R.D. Memorial Degree College",
  "BABA FARID COLLEGE OF MANAGEMENT AND TECHNOLOGY",
  "ABDULLA DEGREE COLLEGE",
  "SARDAR VALLABH BHAI PATEL SHIKSHAN SANSTHAN",
  "EXON MONTESSORI GIRLS DEGREE COLLEGE",
  "PSIT COLLEGE OF HIGHER EDUCATION, BHAUTI",
  "MATA VIDYAWATI RAM AVTAR MAHAVIDYALAYA",
  "G C R G TRUST OF GROUP INSTITUTIONAL, BAKSHI KA TALAAB, LUCKNOW",
  "Shri Sanskrit Mahavidyalaya, Gorakhpur",
  "KESHRI SINGH MEMORIAL DEGREE COLLEGE, VILLAGE TIKRI",
  "Peetam Lal Memorial Degree College, Nizampur",
  "CITY GIRLS COLLEGE",
  "CITY WOMENS COLLEGE",
  "Delhi Metropolitan Education ",
  "Shri Thakur Jee Ramlakhsman Jaanki Mahila Mahavidyalay, Ghazipur",
  "Maharshi Shandila Prashikshan Sansthan Jagdishpur Gauriganj Amethi ",
  "L T R institute of technology kurali meerut",
  "RAMPAL SINGH SATYAVATI DEVI MEMORIAL MAHAVIDYALAYA, DATAGANJ",
  "Mahatma Gautam Buddh Mahavidyalaya, Pilkhuwa, Hapur",
  "Pandit Rambaran Mishra Sanskrit Snatakottar Mahavidyalaya, Bhopatpur",
  "Osho Dhyan Vigyan Mahavidyalay Miuna Khudaganj Shahjahanpur",
  "Lakhpati Devi Parmeshwar Bhagat Mahavidyalaya, Laxmipur, Ekdanga, Maharajganj",
  "Om Ji Women college of Education, Omnagar, Ghazipur",
  "YOGINATH DEGREE COLLEGE SAROORPUR KALAN, BAGHPAT, Ph. 0121-2258919",
  "S.R.S. INSTITUTE OF EDUCATION & TECHNOLOGY GEJHA, MOHIUDDINPUR, MEERUT Ph.9837514655, 9219446577, 0121-2881691",
  "CHANDRA KAMAL MAHAVIDHYALAYA",
  "SHRI PITAM SINGH MAHAVIDHYALAYA, DURA",
  "THAKUR NIROTTAM SINGH MAHAVIDALAYA",
  "J S COLLEGE OF EDUCATION, KUSMARA",
  "J.A.V. College, Baraut (Baghpat) Mob.No.9868439438 01234-262239",
  "VAJIRAO DEGREE COLLEGE",
  "RAJPAL SINGH MAHAVIDHYALAY, PILAKHTAR",
  "SMT VINOD DEVI MAHAVIDHYALAY, EKA",
  "SANT SHRI KESHAVANAD MAHAVIDHYALAY, GRAM ADHAMPUR, SHIKOHABAD",
  "Th.Rajendra Singh Mahavidhyalaya",
  "G S A COLLEGE OF EDUCATION, MAHUA KHERA",
  "BABA DEVHANS MAHILA COLLEGE, NAWADA, PARHAM",
  "SHRI BHAWANI SINGH MAHAVIDHYALAYA, TERI BAGIYA",
  "PRESIDENCY COLLEGE OF EDU. & TECHNOLOGY NS-1, SEC-1, SHATABADI NAGAR, DELHI ROAD, MEERUT`",
  "Updesh Singh Chauhan Mahavidyalaya, Bewar",
  "Pooran Gopal Shukla National College of Law",
  "ACHARYA TARACHAND SHASTRI MAHAVIDHYALYA",
  "Pooran Gopal Shukla Acedemy",
  "A.R. INSTITUTE OF MANAGEMENT & TECHNOLOGY RAJPURA, MEERUT",
  "SWANTRA SENANI SHRI RAMPHOOL SINGH SAMARAK KANYA MAHAVIDYALYA, PALWADA, MEERUT",
  "SARDAR PATEL EDUCATIONAL COLLEGE, ATA, KHERAGARH",
  "D S COLLEGE OF LAW",
  "BOHRE PATIRAM DEGREE COLLEGE",
  "THAKUR BACCHU SINGH COLLEGE OF LAW, JAROLI, SHAMSABAD ",
  "Shrimati Janki Devi Kanya Mahavidhalaya",
  "S B S COLLEGE, FALLEN CHHATA",
  "SRI MAHIPAL SINGH GIRLS COLLEGE, SIKANDARPUR, GHAGHOO",
  "BHORE NATHHI LAL MUDGAL DEGREE COLLEGE, IRADAT NAGAR",
  "Kela Devi Institute, Karondna, Devri Iradat Nagar Road",
  "SHRI GAURISHANKAR COLLEGE",
  "Kala Degree College, Karodhana, Devri Road",
  "R B Degree College, Tanda Manpur, Shergarh",
  "JAI JAI RAM MAHAVIDYALAY MURADPUR KHUTAR SHAHJAHANPUR",
  "SHRI RAJENDRA SINGH MAHAVIDHYALAYA, VISANPUR KURAWALI",
  "MAJOR RAMVIR SINGH EDUCATION INSTITUTE, BALIPUR, SIRSAGANJ",
  "KHAJAN SINGH GIRLS DEGREE COLLEGE, KAGAROL",
  "F H MEDICAL COLLEGE",
  "SEVADHAM MAHILA MAHAVIDHYALAYA, RATANGARH, VIKAS KHAND",
  "PUSHPA SINGH GULAB SINGH MAHAVIDYALAYA",
  "SRI SADGURU BHOLANAND MAHILA MAHAVIDYALAYA,  KAMALPUR",
  "MAA SARASWATI MAHILA MAHAVIDYALAYA,  BAHUTRAKHURD, RAMAIPUR",
  "DR. SHADI LAL COLLEGE OF EDUCATION, MEERUT",
  "MAA DRAUPADI DEVI KANYA VIDYALAYA, SHIKARPUR, BULANDSHAR",
  "Y S L COLLEGE OF EDUCATION SARDHANA ROAD, KANKERKHERA, MEERUT",
  "Janta Degree College Patla, Ghaziabad",
  "Agrasen.(P.G.) College Sikandrabad (Bulandshahr) Mob.No.9837429096 05732-269337",
  "KISHAN INSTITUTE OF INFORMATION TECHNOLOGY MEWLA CROSSING, NEAR AMARUJALLA, OPP. MUKET MAHAL BANQUET HALL, DELHI ROAD, MEERUT Ph. No :- 2408400, 01, 05 , 9927131555, 9927500592",
  "AMBRISH SHARMA COLL. OF EDUCATION & TECH. HAPUR ROAD, MEERUT, Ph. No. :- 9897244898",
  "MURTI DEVI MEMORIAL COLLEGE BAGHPAT-MEERUT ROAD, PILANA, BAGHPAT Ph. 011-22812399, 31079767",
  "SUNDERDEEP COLLEGE OF MANAGEMENT & TECHNOLOGY, GHAZIABAD",
  "Ramesh Chand Sharma Memorial Mahavidhalaya",
  "MASCOT COLLEGE OF EDUCATION",
  "GSRM MEMORIAL COLLEGE OF EDUCATION",
  "RAMA COLLEGE OF EDUCATION KILA ROAD MEERUT",
  "Ch. Charan Singh Government Mahavidyala, Chhaprauli (Baghpat) Mob. No.9412355707",
  "Shiv Mandir Chhuttan Lal Kaka Girls Degree College, Sikandrabad, Bulandshahr",
  "MODEL DIVINE MAHILA COLLEGE BAGHPAT-ROAD, PILANA, BAGHPAT    MOB. 9868046173, 09557085100",
  "HI-TECH  INST. OF ENGINEERING & TECHNOLOGY PLOT NO. 773, DELHI-HAPUR BYE PASS ROAD, 26th. MILE STONE, NH-24, GHAZIABAD,  Ph. 0120-2765031",
  "Pt. DEEN DAYAL UPADHYAYA  MGMT COLLEGE 17-THE MALL, MEERUT CANTT",
  "SARASWATI INSTITUTE OF MEDICAL SCIENCES, PILKHUWA, HAPUR",
  "Government Mahavidyalaya  Noida Mob. No.0120-2575115",
  "Sant Josephs Girls Degree College,  Sardhana (Meerut) Mob.No.9410815034",
  "DIGAMBER JAIN BALIKA VIDHYAPEETH VPO.-KHEKRA. DISTT. BAGHPAT",
  "JINDAL INSTITUTE OF EDUCATION NEAR-KHARKHAUDA MOD, N.H.-58, MOHIUDDINPUR, MEERUT Mob. 9837000073, 9358402039, 9319705923",
  "SARASWATI VIDHYA MANDIR LAW COLLEGE SHIKARPUR, BULANDSHAHR,",
  "Pt. SUJAN SINGH DEGREE COLLEGE, SURAJ KUND ROAD, MEERUT, Ph. 646835,  646925",
  "INSTITUTE OF MANAGEMENT & RESEARCH DUHAI, GHAZIABAD.,",
  "NIRANJAN INST. OF EDUCATION TECHNOLOGY BAHADURPUR, SARADHANA ROAD, MEERUT    Ph. 0121-2630138, 9358434771",
  "UNIQUE INSTITUTE OF MANAGEMENT AND TECHNOLOGY, MURADNAGAR, GHAZIABAD",
  "Vidyavati Mukand Lal Girls College, Ghaziabad",
  "GANDHI INSTITUTION OF PERFECT TEACHING STUDIES,  NAGLA SHAR KHAN URF JAINPUR, MEERUT (Only for Girls)",
  "Krishak (P.G.) College Mawana (Meerut) Mob.No.9897074721",
  "VEDICK KANYA DEGREE COLLEGE TATIRI, BAGHPAT",
  "SAMRAT PRITHVIRAJ CHAUHAN DEGREE COLLEGE BAGHPAT,  Ph. 9412101700, 2221111",
  "INSTITUTE FOR ADVANCE STUDIES  RORI, MODINAGAR GHAZIABAD",
  "GYANSTHALI VIDHYPEETH BHOJPUR, HAPUR ROAD, MODINAGAR, GHAZIABAD",
  "RAM - EESH INSTITUTE OF EDUCATION,         PLOT NO. 3, KNOWLEDGE PARK-1,SURAJPUR-KASNA ROAD, GREATER NOIDA ( G.B. NAGAR )",
  "Sanjay Gandhi (P.G.) College Sarurpur Khurd (Meerut) Mob. No.9412782858 287222",
  "KAKA HORAM SINGH COLLEGE OF LAW DELHI-SAHARANPUR ROAD, BAGHPAT 9412335619 9837170369",
  "DR. AMBEDKAR DEGREE COLLEGE, MEERUT",
  "MOHAN COLLEGE OF TEACHERS EDUCATION BARAL, PARTAPUR, MEERUT, Ph. 9358520777, 9897100201",
  "DIVINE LAW COLLEGE VILL+POST-MAUKHAS, GARH ROAD, MEERUT",
  "DHAN SINGH GUJAR MAHAVIDYALAYA,  LONI,  GHAZIABAD",
  "SETH TARIF SINGH JAIN COLLEGE, KHATTA PRAHAD PUR, BAGHPAT",
  "S P S College of Education, Asara, Delhi Saharanpur Road, Baraut, Baghpat",
  "G & R INSTITUTE OF MANAGEMENT AND TECHNOLOGY,  VILL-ALLIPUR GIJHORI, BARAN, BULANDSHAR",
  "SANSKAR VIDYA BHARTI COLLEGE OF EDUCATION KAMALPUR ROAD MEERUT",
  "INDRADEV GIRLS INST. OF EDUCATION  & TECHONOLOGY BAGHPAT, Mob. NO. 9411825941, 9761990342, 09350317286",
  "INSTITUTE OF APPLIED MEDICINES AND RESEARCH NINE,KM STONE ,DELHI MEERUT ROAD ,DUHAI ,GHAZIABAD",
  "MAHAMAYA CHEMALI DEVI  DEGREE COLLEGE VILL. FAULADPUR, POST. BRAUDI,  SIKANDRABAD, BULANDSHAHR",
  "SMT. SARADA DEVI JEWALA PRASAD AGARWAL  KANYA DEGREE COLLEGE, NARSENA, BULANDSHAHR",
  "J.S.M. ACADEMY SALARPUR, MAWANA ROAD, MEERUT Ph. No.:- 9897172299, 9412083866, 0121-2671777",
  "Ginni Devi Modi Girls PG College Modinagar Ghaziabad",
  "SRI GOPI CHAND MAHAVIDYALAYA  AHERA (BAGHPAT)",
  "D.N. College, Gulaowathi (Bulandshahr) Mob.No.9412229152",
  "SMT. SUKHBIRI DEVI GAYATRI DEVI VIDHI MAHAVIDYALA, NIMKA, JAWAR (G.B. NAGAR) Mob. No. 9997326692, 9412610707, 05732223177 www.ssdgdm.com",
  "Institute of Technical Education and Research Centre Duhai Ghaziabad",
  "GANDHI INST. OF PROFF.  & TECHNICAL STUDIES JAINPUR, HAPUR BYPASS, DELHI ROAD, MEERUT",
  "INSTITUTE FOR EDUCATION & TECHNICAL SCIENCES NH, FIFTY EIGHT ABUPUR ROAD ,MURADNAGAR ,GHAZIABAD",
  "MODERN INSTITUTE OF TEACHER EDUCATION PLOT NO. 307, VPO-DUHAI, DELHI-MEERUT ROAD, GHAZIABAD MOB. NO. 0120-2675504, 2675565, 0120-2679163",
  "J.V.College, Baraut (Baghpat) Mob.No.9411023134, 01234-262130",
  "SHRI SAI MAHAVIDYALAYA FATEHPUR PUTTI, BAGHPAT PH. 01234-311445, Mob.-9897151851",
  "BRAHMANAND MAHAVIDYALAYA BULANDSHAHR-KHURJA ROAD, BULANDSHAHR",
  "IMIRC COLLEGE OF LAW BHAINA GARH, HAPUR",
  "INDRAPRASTHA COLLEGE OF EDU. & TECHNOLOGY, SINGHAWALI AHEER, BAGHPAT,  Ph. 2234834, 2234716",
  "Ishan Institute of Management and Technology, Greater Noida",
  "SAMRATH INSTITUTE FOR EDUCATION & TECH. VILL & POST-NEK, BAGPAT ROAD, MEERUT, Ph. 9412579199",
  "JAGRITI DEGREE COLLEGE, SISOLI, GARH ROAD, MEERUT",
  "PRINCE INSTITUTE OF INNOVATIVE TECHNOLOGY D-16, SECTOR-9, NEW VIJAY NAGAR, GHAZIABAD, Ph. 9868251818, 9810786431",
  "SH. VINAYAK COLLEGE OF EDUCATION, MAWIKALA, BAGHPAT",
  "COLLEGE OF INFORMATION TECHNOLOGY 38 A KNOWLEDGE PARK I GREATER NOIDA",
  "MUSLIM GIRLS DEGREE COLLEGE BULANDSHAHR",
  "INSTITUTE OF MANAGEMENT EDUCATION 178, MAIN G.T. ROAD, SAHIBABAD (GHAZIABAD) Ph. No :- 627646",
  "DADHICHI COLLEGE OF HIGHER EDUCATION N-POCKET, DADHICHI ROAD, GANGA NAGAR, MEERUT  Ph. No. 3250070, 2704858, 9837772222",
  "VENKATESHWARA INST. OF COMP. SCI.  & TECH. 208 - A, SAKET, MEERUT Ph. No :- 4006862",
  "VIJAY SINGH PATHIK INSTITUTE OF LAW BHEEL AKBARPUR, DADRI, GAUTAMBUDH NAGAR",
  "BARAUT COLLEGE OF EDUCATION GURANA, AMINAGAR SARAI ROAD BARAUT (BAGHPAT) Ph. 9897151851, 09412207128,  01234-252620 (O)",
  "ASTRON COLLEGE OF EDUCATION NOOR NAGAR, HAPUR BYPASS, DELHI ROAD, MEERUT Ph. 0121-2522827, 534782, 9412202426 www.astroncollege.org,",
  "MAHAVEER COLLEGE OF LAW POHALI, SARADHANA ROAD, MEERUT",
  "INDRAPRASTH INSTITUTE OF EDUCATION & MANAGEMENT, HAPUR",
  "BALAJI COLLEGE OF MGMT & TECHNOLOGY, KILA PARICHATI GARH, MEERUT Ph.",
  "jatan swaroop College, Sikandrabad (Bulandshahr)",
  "FAIZ-E-AM DEGREE COLLEGE MEERUT",
  "ADHARSHILA COLLEGE OF EDUCTION PARTAPUR  BYPASS ROAD, MEERUT, Ph. 9897577661-62",
  "VENKATESHWARA COLLEGE OF EDUCATION PAWLA, INCHOLI, MEERUT",
  "AAMNA LAW COLLEGE DASNA , GHAZIABAD",
  "CH. BACHCHU SINGH COLLEGE OF EDUCATION",
  "Shri Barat singh degree college ",
  "Shri Devi Soram Singh Educational Institute Pandhat, Jasrana, Firozabad",
  "SRI SATYAPAL SINGH MEMO DEGREE COLLEGE SIURA KHUDAGANG",
  "Vidya Devi College of Education, Bansgaon, Gorakhpur",
  "Ch. Vedram College of Higher Education, Sirodhan, Hapur",
  "Jawahar Lal Neharu Sanskrit Mahavidyalaya",
  "BANSHI DHAR MAHAVIDYALAYA, ORAI",
  "RASHTRIYA RAKSHA UNIVERSTIY LUCKNOW CAMPUS",
  "DULARI DEVI COLLEGE OF EDUCATION, UTRARA DIST. FIROZABAD",
  "SHRI MEGH SINGH HUNDILAL COLLEGE, TIKAMAI, FIROZABAD (UP)",
  "JAI MAA SHARDE MAHAVIDHYALAY",
  "Pt. Sriniwas Dwivedi Mahavidyalaya",
  "SHARDA SHIKSHAN SANSTHAN ",
  "CH. GAJRAJ SINGH DEGREE COLLEGE, NAGLA RAJA, KARHAL DIST. MAINPURI",
  "MADHU VACHASPATI INSTITUTE OF LEGAL STUDIES",
  "NOIDA INTERNATIONAL UNIVERSITY SCHOOL OF NURSING",
  "C M S DEGREE COLLEGE CHANDAULI BIDHUNA AURAIYA",
  "JAIGURUDEV DEGREE COLLEGE",
  "SHRI RAMDAS MAHAVIDYALAYA, DULLAHAPUR",
  "RAJVEER SINGH MEMORIAL MAHAVIDHYALAYA ANORA MATHURA",
  "SHRI RAMGOPAL MAHAVIDYALAY",
  "C-DOTS INSTITUTE OF COMPUTER TECHNOLOGY SAHARANPUR",
  "Adarsh Shri ram Sanskrit Vidyalaya, Chhangapur, Leduka",
  "Brijraj Singh Sanskrit Mahavidyalaya, Bharramai",
  "Shri Narayan Sanskrit Mahavidyalaya,Rishi Ashram, Ranopli, Ayodhya, ",
  "Hindi Sanskrit Adarsh Mahavidyalaya, Bhairav ji, Mahrajganj",
  "Shri Krushnabrahmacharyashram Sanskrit Mahavidyalaya, Hathras",
  "Shri Sanatan Dharm Sanskrit Mahavidyalaya, Revatipur",
  "Atmaraam Sanskrit Mahavidyalaya, Bharaipur",
  "Shri Saraswati Sanskrit Mahavidyalaya, Guravat, Cholapur",
  "Sanatan Dharm Sanskrit Mahavidyalaya, Nagar Bazar",
  "Shri Parashuram Sanskrit Mahavidyalaya, Jalalabad",
  "Vedadarsh Sanskrit Mahavidyalaya, Sarikalan Rudranagar",
  "Shri Udaseen Sanskrit Mahavidyalaya, D 36/19 Dhundiraj Gali",
  "Tayyabpur Vidyapeeth Sanskrit Mahavidyalaya, Tayyabpur , Siddhpur",
  "Ishmarg Sanskrit Mahavidyalaya,",
  "Shri Bhagavat Mahavidyalaya, Assi",
  "Pandit Shivdayal Shukla Sanskrit Mahavidyalaya, Manoharnagar, Pure Shukla, Paraiya nanakar, Paraiyan",
  "Shri Bhavanand Sanskrit Mahavidyalaya, Punarjee, Jahanaganj",
  "Dr. Ramgopalacharya Sanskrit Mahavidyalaya, Nayavaas",
  "Shri Vyas Kshetra Sanskrit Mahavidyalaya, Kalapi",
  "Ramprasad Sanskrit Mahavidyalaya, Gopalpur, Sikrara",
  "Adarsh Hanumat Sanskrit Mahavidyalaya, Muruval",
  "Shri Pramod Sanskrit Mahavidyalaya, Sahsavan",
  "Shri Goswami Tulasi Das Sanskrit Mahavidyalaya, Jamalpur",
  "Shri Sankatmochan Sanskrit Mahavidyalaya, Suriyava",
  "Sanskrit Mahavidyalaya, Kot",
  "Munishwar Sanskrit Mahavidyalaya, Karmaini",
  "Shri Vidyadharm Pracharini Sanskrit Mahavidyalaya, Bhawani Chhapar",
  "Shri Saudamini Sanskrit Mahavidyalaya, 149 Vivekanand Marg",
  "BRAMH DEV INDRAMATI TRIPATHI MAHILA DEGREE COLLEGE",
  "Saraswati Balika Sanskrit Mahavidyalaya, Shivpur, Belwana, Baal Pakauli",
  "Shri Sanatan Bhairav Shankar Brahm Sanskrit Mahavidyalaya, Bariya Ghat",
  "Shri Hanumat Sanskrit Mahavidyalaya, Ali Shahpur, Sikarara",
  "Srimati Pakaua Devi Adarsh Sanskrit Mahavidyalaya, Manikpur",
  "COLLEGE OF MANAGEMENT STUDIES, KANPUR",
  "Shri Radha Krishna Sanskrit Mahavidyalaya, Dalmau",
  "Ramrati Rampyare Sanskrit Mahavidyalaya, Brahmapura, Chouri Choura",
  "Parashuram Seva Sansthan, Gyanchandra Sanskrit Mahavidyalaya, Rampur Mahval",
  "Shri Kunj Bihari Sanskrit Mahavidyalaya, Biharipur Vrindavan",
  "Shri Kishori Lal Venimadhav Sanskrit Mahavidyalaya, Vairahana, Prayag",
  "Shri Rajgopal Sanskrit Mahavidyalaya, Ayodhya",
  "Shri Ram Janki Sanskrit Mahavidyalaya, Gauriyapur, Akbarpur",
  "Shri Ramkumar Adarsh Sanskrit Mahavidyalaya, Kath",
  "Shri Dayanand Sanskrit Mahavidyalaya, Ganeshpur, Maniyar",
  "Shri Krishnanand Rambari Sanskrit Pathshala, Rambag, Rudauli",
  "Shri Janardan Sanskrit Mahavidyalaya, Mundera Shukla",
  "Shanti Niketan Sanskrit Mahavidyalaya, Rudauli",
  "Shri Ratanmoti Sanskrit Mahavidyalaya, Gokul",
  "Shri Sahdev Sanskrit Mahavidyalaya, Maharajganj",
  "Shri Vishieshwar Sanskrit Mahavidyalaya, Darapur, Meerganj",
  "Shri Jyotish Peeth Sanskrit Mahavidyalaya, Shankaracharya Ashram, Alopibag",
  "Adarsh Sanskrit Mahavidyalaya, Dharasigagaha",
  "Shri Saraswati Gurukul Vidyapeeth, Munari",
  "Audyogik Nav Shikshayan Sanskrit Mahavidyalaya,Dev Nagar Saraya",
  "Shri Shivshankar Sanskrit Mahavidyalaya, Nagarpanchayat, Ghosia",
  "Hanumat Sanskrit Mahavidyalaya, Hathibarani,",
  "Shri Ranglaxmi Adarsh Sanskrit Mahavidyalaya, Vrindavan",
  "Shri Jawahar Singh Sanskrit Mahavidyalaya, Kamlapur",
  "Gyanodaya Sanskrit Mahavidyalaya, Kamlasagar, Maryadpur",
  "Gurukul Sanskrit Mahavidyalaya, Shukrataal",
  "Dharmchakra Vihar Antarrashtriya Mool Baudh Shiksha Sansthan, Sarnath",
  "Shri J.M.Goenaka Sanskrit Mahavidyalaya, Assi",
  "Banshidhar Sanskrit Mahavidyalaya, Gayatri Nagar, Sarainandan",
  "Shri Sanatan Dharm Sanskrit Mahavidyalaya, Muktishwarnath, Hasoopur",
  "Shrinath Chandravati Sanskrit Pathshala, Jagdishpur",
  "SHRI R K SINGH GIRLS DEGREE COLLEGE GANGCHAULI HATHRAS ",
  "S M D INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "OPM COLLEGE OF NURSING AND PARAMEDICAL SCIENCES AZAMGARH",
  "Shri Durgaji Sanskrit Mahavidyalaya, Chandesar",
  "Srimati Murtimati Sanskrit Vidyapeeth, Ghanghata, Kohara",
  "Shri Nepali Sanskrit Mahavidyalaya, Mangalagauri",
  "SHRI DAIVIYE SAMAPAD BRAHMACHARYA SANSKRIT MAHAVIDYALAYA, MUMUKSHU ASHRAM, SHAHJHANPUR, UP",
  "FILM INSTITUTE OF e-MITS LUCKNOW",
  "Shri Raam Tahal Sanskrit Mahavidyalaya, Yadunathpur, Saifabad",
  "Shri Dakshinamurti Sanskrit Mahavidyalaya, Mishra Pokhara",
  "Shri Vaidik Dharm Sanjeevani Sanskrit pathshala, Sahjanwa",
  "Shri Aanand Bodhashram Sanskrit Mahavidyalaya, Tivaripur, Gaddha",
  "HAZI ABDUL KAUYUM MEMORIAL DEGREE COLLEGE, MAUAIMA",
  "Vidvat Parishad Sanskrit Mahavidyalaya, Karnailganj",
  "Sanatan Devi Das Sanskrit Mahavidyalaya Sudanipur",
  "RAMTEJ BHAGAUTI PRASAD MAHAVIDYALAYA, DHARSAWAN",
  "NARSINGH NARAYAN HARI PRASAD MAHAVIDYALAYA, MEENAPUR",
  "SRI TIRUPATI BALAJI MAHAVIDYALAYA, CHIMARA",
  "Shri Ramkrishna Sanskrit Mahavidyalaya, Bheempura, no. 1",
  "Kedarnath Sanskrit Mahavidyalaya, Goppur, Cholapur",
  "Shri Mathur Chaturved Sanskrit Mahavidyalaya, Dampiyar Nagar",
  "Shri Gurukul Vaidik Sanskrit Mahavidyalaya Sirathoo",
  "Shri Devikund Sanskrit Mahavidyalaya, Devbandpur",
  "Tulasi Smarak Sanskrit Mahavidyalaya, Rajapur",
  "Shri Nrisingh Sanskrit Adarsh Sanskrit Mahavidyalaya, Beraso, Deenapur",
  "Triveni Sanskrit Mahavidyalaya, Daraganj, Prayag",
  "Shri Maha  Kalika Sanskrit Mahavidyalaya, Sopara, Deoria",
  "Anant Shri Vasudev Sanskrit Mahavidyalaya, Naimisharanya",
  "Shri Sanatan Dharm Sanskrit Mahavidyalaya, Mehadaval",
  "Shri Brahm Sanskrit Mahavidyalaya, Swami Baag, Ganahi, Bijaipur",
  "Shri Bhagirathi Sureka Sanskrit Mahavidyalaya, Brahmnal",
  "Shri Maharathi Sanskrit Mahavidyalaya, Kurahans, Kotniya",
  "Shri Shyamlal Shukla Sanskrit Mahavidyalaya, Ayodhya, Koraval",
  "S M D DEGREE COLLEGE, MAHAVEERNAGAR  ",
  "SHAHID GURUDATT SINGH DEGREE COLLEGE ",
  "Janhavi Sanskrit Adarsh Mahavidyalaya, Kalakankar",
  "Shri Dayaraam Sanskrit Mahavidyalaya, Parmeshwarpur, Chandesar",
  "BORA INSTITUTE OF MANAGEMENT SCIENCES, SITAPUR ROAD",
  "TECHNO INSTITUTE OF HIGHER STUDIES",
  "Shri Brahm Vidya Mandir Sanskrit Mahavidyalaya, Vrindavan",
  "MEVALAL JAISWAL MAHAVIDYALAYA, LALGANJ, SORAV,",
  "MEWA LAL SINGH DEGREE COLLEGE, PIPIRSA, NIBI, NAINI,",
  "MOHD. SHAMI GIRLS DEGREE COLLEGE,MAUEYEMA,",
  "MOTI LAL NEHRU DEGREE COLLEGE, KAUNDHIYARA,",
  "MOTI LAL SINGH VIDHI MAHAVIDYALAYA,ALLAHABAD",
  "MA. KASHIRAM MAHAVIDYALAYA, PANASA, KARCHANA,",
  "MAULVI LIYAKAT ALI DEGREE COLLEGE, MAHAGAWAN,",
  "M.V.R. DEGREE COLLEGE, KASIYA SIRATHU,",
  "M.P. GARG DEGREE COLLEGE, CHAKDADANPUR, JHALWA,",
  "Shri Sanatan Dharm Sanskrit Mahavidyalaya,",
  "N.B.S. COLLEGE OF MANAGEMENT & TECHNOLOGY, SORAV,",
  "NIVEDITA SINGH GIRLS DEGREE COLLEGE, SHANTI NAGAR,",
  "NARAYAN MAHAVIDYALAYA, AUNTA, MEJA,",
  "OM MAHAVIDYALAYA, BHADARPUR, SIKANDARA,",
  "PHOOLCHANDRA SINGH TULSHI DEVI M/V, RAHI KALA,T.S.L.,NAINI,",
  "PIDI MAHAVIDYALAYA, PIDI,",
  "PRATAP NARAIAN SUBHADRA DEVI M/V, FIROZPUR, HETAPATTY",
  "PRAYAG CITIZEN LAW COLLEGE, SIRHAR, MEJA,",
  "PRAYAG MAHAVIDYALAYA, SHIVMANGAL NAGAR, HETAPATTI,",
  "PRAYAG MAHILA VIDYAPEETH DEGREE COLLEGE",
  "PRAYAG VIDHI MAHAVIDYALAYA, MUVAIYA, NAINI,",
  "PT. GOPI NATH MISRA MAHAVIDYALAYA, ALLAHABAD",
  "PT. HARVANSH PRASAD MAHAVIDYALAYA, DURGAPUR, TILHAPUR,",
  "PT. KHERE PD. VIPIN BIHARI MAHAVIDYALAYA, KAUNH, CHANDPUR,",
  "PT. PURUSHOTTAM DEGREE COLLEGE, DHANA, MALIHA,",
  "PT. RAMAKANT SHUKLA MAHAVIDYALAYA",
  "PT. RAM KAILASH TRIPATHI MAHILA MAHAVIDYALAYA",
  "PT. YAGYA NARAYAN DUBEY SMARAK MAHAVIDYALAYA, PHULPUR,",
  "RADHA RAMAN MISHRA MAHAVIDYALAYA, TULAPUR, SIKANDARA,",
  "RAJA KAMLAKAR DEGREE COLLEGE, SHANKERGARH,",
  "RAJ DEGREE COLLEGE, CHATAUNA, SARAI MAMREJ, HANDIA,",
  "RAJENDRA DEGREE COLLEGE, BHAGIPUR (SARAI INAYAT), JHUSI,",
  "RAJENDRA PRASAD DUBEY SMARAK BALIKA MAHAVIDYALAYA",
  "RAJKIYA MAHILA MAHAVIDYALAYA,BINDKI,",
  "RAMA NAND SINGH MAHILA MAHAVIDYALAYA, HADIA",
  "RAM BHAJAN SINGH MAHAVIDYALAYA, SEWRA CHAIL",
  "RAJ NARAIN PANDEYVIDHI MAHAVIDYALAYA",
  "RAMPAL MAURYA MAHAVIDYALAYA, KHAGA,",
  "RAMMURTI SINGH MAHAVIDYALAYA,HANDIA,ALLAHABAD",
  "RAM YASH MAHAVIDYALAYA, MALAK BALAU, NAWABGANJ,",
  "R.B.S. MAHAVIDYALAYA, MEJA KHAS,",
  "RAM SAJIWAN CHANDA DEVI BALIKA MAHAVIDHYALAYA",
  "RANI CHANDRA PRABHA DEGREE COLLEGE, KHAGA,",
  "RITURAJ MAHAVIDYALAYA, JONIHA ROAD,",
  "R.K.YADAV LAW COLLEGE, BHIKHPUR",
  "R.N. SINGH MAHAVIDYALAYA, SAHSON,",
  "R.P. DEGREE COLLEGE, DARANAGAR",
  "RAMNATH MAHAVIDYALAYA, NIWADA, MASNA,",
  "RAMRATI PATEL MAHAVIDYALAYA, SAHLOLWA, KARCHANA,",
  "SAHDEI DEVI BHUWAR PRASAD MAHAVIDYALAYA",
  "SAILDEVI MAHILA MAHAVIDYALAYA, ADARSH NAGAR, MEJA,",
  "SAINIK LAW COLLEGE,KAITHWAL,JAGATPUR",
  "SAINIK MAHAVIDYALAYA, MAI, DEVKALI, HANUMANGANJ,",
  "SAMDARIYA BALIKA MAHAVIDYALAYA, KATRA DAYARAM, SORAV,",
  "SANJAY MALVIYA DEGREE COLLEGE, GANJA SADAR,",
  "SANTOSH SINGH MAHAVIDYALAYA, SARAI BAKEWAR, BINDKI,",
  "S S SINGH MAHAVIDHYALAYA, KORAON",
  "SANT RAM LAKHAN DEGREE COLLEGE, BARAUT",
  "SANT SINGH LAW COLLEGE BHUSKA MEJA ROAD",
  "SARDAR PATEL MAHAVIDYALAYA, SONAI KARCHHANA,",
  "SARVESHWARI MAHAVIDYALAYA, DHANUA, CHAKA, NAINI,",
  "SARVODAYA MAHAVIDYALAYA, ALLAHABAD",
  "SATYAM SHIVAM SHUBHAM D/C TIKARI",
  "SATYA NARAIAN MAHAVIDYALAYA, JALALPUR",
  "SHAMBHU NATH TIWARI VIDHI MAHAVIDYALAYA,ALLAHABAD",
  "SHANTI MAHAVIDYALAYA, BAGAIKALA, BAGAIKHURD,",
  "SHARMILA JAISWAL DEGREE COLLEGE BARAUT ALLAHABAD",
  "SHIV MAHAVIDYALAYA, ALIPUR, MAUIMA,",
  "SHRAMIK KANNYA DEGREE COLLEGE, HANDIA",
  "SARLA DEVI SRIRAM MAHILA MAHAVIDYALAYA",
  "SHANTI DEVI RAJAN BABU MAHAVIDYALAYA, PASHCHIM SHARIRA,",
  "SH. CAP. V.P. SINGH SMARAK DEGREE COLLEGE, KOILAHA, JUNAIDPUR,",
  "SHIV DARSHAN LAL DEGREE COLLEGE, DARAULI",
  "SHIVKALI YADAV JAGPATTY BALIKA MAHAVIDHYALAYA",
  "MAA BEHFAIYA MAHILA MAHAVIDYALAYA ARAKHPUR BARAHI GHAZIPUR",
  "Kalloomal Sanskrit Mahavidyalaya, Chaval Mandi",
  "Shiv Prasad Pandey Sanskrit Mahavidyalaya, Cullcterganj",
  "Shri Harsheshwarnath Sanskrit Pathshala, Brahmarpatti Bhiyanv",
  "Radha Krishna Sanskrit Mahavidyalaya, Laxminiwas Bagh",
  "Srimati Lachi Devi Sanskrit Mahavidyalaya, Bhaluvani, Barhaj",
  "Adarsh Sanskrit Ayurveda Mahavidyalaya",
  "Shri Laxminarayan Sanskrit Pathshala, Premsarover, Gazipur, Barsana",
  "Nishulka Gurukul Mahavidyalaya, Ramkot, Ayodhya",
  "Jaihind Sanskrit Mahavidyalaya, Kandhikalan",
  "Panini Sanskrit Mahavidyalaya, Padrauna",
  "Srimad Balmukund Mahadeshik Sanskrit Mahavidyalaya, Swarg Dwar, Ayodhya",
  "Shri Adarsh Ramanand Sanskrit Mahavidyalaya, Shankuldhara, Khojanwa",
  "Shri Vijay Raghav Sanskrit Mahavidyalaya, Pandeya Chak, Barnai",
  "Shri Sanatan Dharm Sanskrit College",
  "Shri Sadgurudham Sanskrit Mahavidyalaya, Chandani",
  "Shri Ramanand Peeth Sanskrit Mahavidyalaya, Karnghanta",
  "Nityanand Ved Mahavidyalaya",
  "Shri Laxminarayan Sanskrit Mahavidyalaya, Mokalpur",
  "Sanskrit Vidyapeeth Snatakottar Mahavidyalaya,Bamanuwa, Tahrauli, ",
  "Adarsh Sanskrit Mahavidyalaya, Ramnagar, Urai",
  "Rashtriya Sanskrit Snatakottar Mahavidyalaya, Dobhi, Chandavak",
  "Hindi Sanskrit Mahavidyalaya, Gagargarh, Shivapaar",
  "Deva Vani Pracharak Sanskrit Mahavidyalaya, Barahari Pipara, Daulakadam",
  "TH.O.P. SINGH EDUCATIONAL COLLEGE",
  "BHADAURIA COLLEGE OF EDUCATION KOSI KHURD BHARATPUR ROAD MATHURA",
  "D C S COLLEGE OF LAW",
  "I.P. (P.G.) COLLEGE, CAMPUS-2, BULANDSHAHR",
  "Shri Vishwanath Sanskrit Mahavidyalaya, Tripura Bhairavi",
  "Adarsh Sangved Sanskrit Mahavidyalaya, Imaliya Gurudayal Ganj Baraganv",
  "SHIV GOVIND MAHAVIDYALAY, Machilisahar, Jaunpur",
  "Shri Adarsh Shiv Bahadur Sanskrit Mahavidyalaya, Ahorava Bhawani, Shivaratanganj",
  "Adarsh Shri Vasudev Sanskrit Mahavidyalaya, Gutavan",
  "Shri Brahmanand Sanskrit Mahavidyalaya, Rath",
  "Shri Mumukshu Bhavan Ved Vedang Sanskrit Mahavidyalaya, Assi",
  "SRI KALYAN SINGHDEGREE COLLEGE, KANNAUJ",
  "J.S.S GIRLS DEGREE COLLEGE KANDOLA",
  "A H M A DEGREE COLLEGE",
  "NIMT INSTITUTE OF EDUCATION",
  "L P N GIRLS DEGREE COLLEGE, TRIVENINAGAR, VIJHWAT, JAUNPUR",
  "THE OXFORD COLLEGE OF EDUCATION MASOORIE, HAPUR",
  "ANAND DEGREE COLLEGE",
  "MAA RAMDARSHANI MAHILA MAHAVIDYALAYA",
  " J S COLLEGE MUDESI MATHURA",
  "VIMLA INSTITUTE OF PHARMACY, KANPUR NAGAR",
  "NEW KHUSRO DEGREE COLLEGE",
  "DEO INDRAWATI MAHAVIDYALYA, ARKHAPUR TANDA",
  "HERITAGE BUSINESS COLLEGE",
  "SHIVANSHU SUSHIL MAHAVIDYALAYA",
  "LALTA PRASAD TIWARI SMARAK MAHAVIDYALAYA ",
  "Sudhakar Sanskrit Mahavidyalaya, Khajuri",
  "Hooblal Adarsha Sanskrit Mahavidyalaya, Bharwari",
  "Harinarayan Adarsh Sanskrit Mahavidyalaya, Jagapur Bhaupur",
  "Shri Sanyasi Sanskrit Mahavidyalaya, Dhundhiraj Gali",
  "Shri Baldev Sahai Sanskrit Mahavidyalaya,  124 Cantt",
  "Pauranik Vaidic Adhyayan Anusandhan Sansthan, Naimisharanya",
  "ALIVE INFOTECH COMPUTER EDUCATION SHIKOHABAD",
  "Shri Sanatan Dharm Adarsh Sanskrit Mahavidyalaya, Dhani",
  "Shri Shivshanti Sanskrit Mahavidyalaya, Chaubepur",
  "Shri Gopal Adarsh Sanskrit Mahavidyalaya, Rasin",
  "ASIAN  LAW COLLEGE",
  "Arya Gurukul Sanskrit Mahavidyalaya, Sisaraganj",
  "Shri Sanatan Dharm Sanskrit Mahavidyalaya, Ratanganj, Yudhisthir Patti, Ahraula",
  "PT BANSH RAJ PRASHIKSHAN MAHAVIDYALAYA ",
  "Brahmchari Sanskrit Mahavidyalaya, Tilamapur, Sarnath",
  "CH. HARMOHAN SINGH PARAMEDICAL SCIENCE & NURSING INSTITUTION",
  "DR SARVESH KUMAR SHUKLA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "AJAY SANGAAL INSTITUTE OF MEDICAL SCIENCES AND RESEARCH AND AYUSHMAAN HOSPITAL",
  "SHRI SAHAB SINGH NURSING AND PARAMEDICAL COLLEGE AGRA",
  "Shri Shivasharma Sanskrit Mahavidyalaya, Daraganj",
  "Shri Jai Dev Vaishnav Sanskrit Mahavidyalaya, Karvi",
  "MAA VAISHNO DEVI NAKCHHED TIWARI GIRLS INSTITUTE OF EDUCATION AND MANAGEMENT, KOTIYA",
  "Shri Vidya Vinodadarsh Sanskrit Mahavidyalaya, Maunighat, Navabganj",
  "Hardev Sanskrit Mahavidyalaya, Nevada",
  "Yagyashala Sanskrit Pathshala, Mathiya Shukla, Tarkulvan",
  "Shri Maharani Vandevi Sanskrit Mahavidyalaya, Kahinour",
  "Shri Teekmani Sanskrit College, Sakarkand Gali",
  "Suryansh Sanskrit Mahavidyalaya, Vashirpur",
  "Shri Sanskrit Mahavidyalaya, Patti Narendrapur",
  "Shri Saraswati Sanskrit Pathshala, Pandit Ke Rampur, Bariyarpur",
  "Shri Bhujangeshwar Nath Sanskrit Pathshala, Chak Mahadev, Bhujagi",
  "Shri Sanskrit Mahavidyalaya, Khekhara",
  "Uma Maheshwar Sanskrit Mahavidyalaya, Koldhema",
  "Shri Krishnadarshan Sanskrit Mahavidyalaya, Vrindavan",
  "Shri Vichar Sabha Sanskrit Mahavidyalaya, Purana Sabha",
  "Shri Gurukul Sanskrit Mahavidyalaya, Rudrapur, Tilhar",
  "Shri Manav Jeevan Sudhar Brahmacharya Sanskrit Mahavidyalaya,  Dalmau",
  "Shri Bhartiya Vidyapeeth, Kodara, Kaziganv",
  "Narsingh Bahadur Singh Shanti Devi Sanskrit Mahavidyalaya, Chintpur",
  "Shri Birala Sanskrit Mahavidyalaya, Lalghat",
  "Shri Veer Raghav Bhagvat Sanskrit Mahavidyalaya, Yugal Vihar Kunj, Purana Fatak, Ayodhya",
  "Shri Baldev Das Hanumat Sanskrit Mahavidyalaya, Unurukhakuti",
  "KASHI VISHWANATH MAHAVIDYALAYA, AVADHPURI, JAFARPUR, KADIPUR",
  "RISHIRAJ SINGH MAHAVIDALAYA, BAMHRAULI",
  "SAI BABA GAURI BABA SHRI ARJUN SINGH MAHAVIDYALAY, WALLIPUR , NEWADA",
  "AMIT MEMORIAL KANYA MAHAVIDHAYALA",
  "NISTHA INSTITUTE OF SCIENCE & TECHNOLOGY AZAMGARH",
  "Varanaseya Shri Goswami Tulasidas Sanskrit Mahavidyalaya, Tulasi Ghat",
  "SHRI RAM AVADH NISHAD MAHAVIDYALAYA, KHOTAHI, KUSHINAGAR",
  "Pt. Krishna Dutt Shukla Mahavidyalaya, Bisanda, Banda",
  "Durgesh Nandani Vashishat Narayan Shikshan and Prashikshan Mahavidyalaya, Soharauna Tiwari, Maharajganj",
  "SW. BAHADUR SINGH MAHAVIDYALAYA, BANKAT KARO, JAUNPUR",
  "Gopinath Mahavidylala, Devali, Salamatpur, Ghazipur",
  "Shri Harishankar Mahavidyalaya ,Jamuvari (Bahalolpur), Ghazipur",
  "Ram Rahim Mahavidyalaya, Gahmar Ghazipur",
  "Rahul Mahavidyalaya, Kalavari Shekha , Jaunpur",
  "Biju Patnayak Sonakar Balika Degree College, Devchandpur, Ghazipur",
  "MANGALMAY INSTITUTE OF MANAGEMENT AND TECHNOLOGY, GREATER NOIDA",
  "Shivangi Mahila Mahavidyalaya, Panchahatiya Jaunpur",
  "Pro Ramnath Pandey Mahila Mahavidyalaya, Mungara Badshahpur, Jaunpur",
  "Shri Rajaram Mahavidyalaya, Tariyari ,Kerakat, Jaunpur",
  "Sarju Rai Memorial Degree College, Gandhi, Nagar Ghazipur",
  "Mahamandeleshvar Shribalkrishan Yati Mahavidyalaya Vindravan Ghazipur",
  "SRI MAHAVIR PRASAD MAHILA MAHAVIDYALAYA, SURYA NAGAR, RAJAJIPURAM, LUCKNOW-226017",
  "Sarvajanik Mahavidyalaya ,Mugara Badshahpur, Jaunpur",
  "Bihari Mahila Mahavidyalaya , Machhalishahar , Jaunpur",
  "Lt. Kishun Chandar Bakhari Baba Mahavidyalaya, Tiyari, Birano Ghazipur",
  "MAA GAYATRI COLLEGE OF EDUCATION",
  "Modern College",
  "MAHARANI LAXMI BAI MEMORIAL MAHAVIDYALAYA",
  "BHARTIYA INSTITUTE OF HIGHER EDUCATION",
  "Pashupati Nath Smarak Mahavidhyala Sherpur ,Kala, Ghazipur",
  "Aachary Baldev College, Kopa ,Patarhi, Jaunpur",
  "Gadadhar Shlok Mahavidyalayay, Revtipur, Ghazipur",
  "Mukteshwar Prasad Mahavidyalaya, Jaunpur",
  "Shri Shiv Mahavidyalaya, Pharidaha ,Khanpur, Ghazipur",
  "Diyava Nath Kevala Shankar Mahavidyalaya Datav ,Jaunpur",
  "Matuk Smarak Mahavidyalaya ,Dadhaval, Ghazipur",
  "Shri Banshi Balgopal Mahavidyalaya, Sagra ,Rajupur Ghazipur",
  "Sw.Malti Singh Mahavidyalaya Ambarpur,Belva,Madiyahu,Jaunpur",
  "R S GIRLS DEGREE COLLEGE, ISMAILPUR AMBAPARA UNNAO",
  "Government Degree College, Bhojpur, Moradabad ",
  "LAKSHYA COLLEGE OF LAW BAGWARA SEOHARA BIJNOR",
  "AMANI GROUP OF INSTITUTIONS BIJNOR ROAD AMROHA",
  "LAKSHYA COLLEGE OF ADVANCE EDUCATION BAGWARA SEOHARA BIJNOR",
  "Shri Rangji Yadav Mahavidyalaya, Rampur Manjha, Matkhanna, Ghazipur",
  "Shri Babu Nandan Adarsh Mahavidyalaya, Rampur Bantra, Ghazipur",
  "Ram Kishun Singh Mahavidyalaya Siddikpur,Jaunpur",
  "DAYA AWADH MAHAVIDYALAYA, MOHAMMADPUR, AMANIGANJ",
  "RASHTRIYA MAHAVIDYALAY, SUJANGANJ, JAUNPUR",
  "Brijesh College of Education, Sardarpur, Baddhupur, Ghazipur",
  "Mukhram Mahavidyalaya, Jagadishpur, Ruhipur Ghazipur",
  "BABA BHOLE MAA PARVATI MAA SHOBHAWATI ADARSH MAHAVIDHYALYA, TENDUA KAJI",
  "Mata Behphaiya Sogara Mahavidyalaya, Kuttubpur Kasimabad, Ghazipur",
  "Tilakdhari Snatkottar Mahavidyalaya, Jaunpur",
  "THE GREAT RAMSWAROOP PRIKASH KUMARI MEMORIAL DEGREE COLLEGE AMARIA",
  "IIMT College of Law, Greater Noida",
  "M.S.B. EDUCATIONAL MAHAVIDHYALYA",
  "Shri Meghabaran Singh Mahavidyalaya, Bhadaila, Karampur, Ghazipur",
  "LAXMI NARAYAN ATARRANI EDUCATIONAL INSTITUTE ",
  "RAM TEERATH COLLEGE OF EDUCATION",
  "R G N P DEGREE COLLEGE TAJPUR BIJNOR",
  "BRAHMA DEVI SHIKSHA JAN KALYAN MAHAVIDYALAY",
  "M.S.R. COLLEGE OF EDUCATION",
  "Mind Power Education College, Roopaspur, Shikohabad, Firozabad",
  "YASHPAL SINGH MAHAVIDHYALAYA",
  "Harishchandra Mahavidyalaya, Maudhiya , Ghazipur",
  "Krishak Mahavidyalaya Ukaraon Bahriyabad Ghazipur",
  "G S M VIDYAPEETH, CHITAWALI, SATUPURA, SAMBHAL",
  "D S M ACADEMY DHANAURA ROAD AFZALPUR LOOT AMROHA",
  "RAMVIR SINGH MEMORIAL DEGREE COLLEGE, VILL AND PO CHHPRA, TEH GUNNAUR, SAMBHAL",
  "Rajendra Prasad Memorial Degree College",
  "RAM BHAROSE SINGH MEMORIAL MAHAVIDYALAYA, MALLAHPUR, BUDAUN",
  "MANDAWAR DEGREE COLLEGE, MANDAWAR, BIJNOR",
  "Vansha Devi Mahavidyalaya ,Gajadharpur Gaddopur Jaunpur",
  "Yash Raj Institute of Education",
  "SKY GIRLS DEGREE COLLEGE JHALU BIJNOR",
  "ATUL INSTITUTE",
  "Shri Bajrang Mahavidyalaya Ghanshyampur, Jaunpur",
  "SRI RAM MILAN MISHR BALIKA MAHAVIDHYALYA, MOTIGAR PUR",
  "Swami Sahajanand Snatkottar Mahavidyalaya Ghazipur",
  "Umashankar Shastri Mahavidyalaya,Haisipara, Ghazipur",
  "Shri Ram Mahavidyalaya, Aadampur, Nigoh Jaunpur",
  "Prabhu Devi Mahavidyalaya , Machhli Gaon, Badlapur Khurd, Jaunpur",
  "Resami Mahila Mahavidyalay, Ghazipur",
  "Guru Phulchand Mahavidyalaya, Daulatpur, Ghazipur",
  "Sarju Prasad Mahavidyalaya, Kajgaaw , Jaunpur",
  "Pt. Deen Dayal Upadhyay Goverment Degree College, Saidpur , Ghazipur",
  "Dwarika Prasad Mahavidyalaya,Vijadharmau,Mungra Badashahpur, Jaunpur",
  "Siyaram Lodhi Mahavidhyalaya Jasanpur Mainpuri",
  "Savitri Devi Mahavidyalaya",
  "Dr.Ram Manohar Lohiya Degree College,Adhyatmapurm, Dhotari, Ghazipur",
  "Janta Adarsh Mahavidyalaya, Maksudanpur, Mubarkpur, Gangauli, Ghazipur",
  "Samata Snatkottar Mahavidyalaya, Sadat ,Ghazipur",
  "Jangi Mahavidyalaya Asbaranpur ,Jaunpur",
  "Mahila Mahavidyalaya Hetimpur, Jamaniya, Ghazipur",
  "Uma Devi Kanya Mahavidyalaya, Jahanabad, Pilibhit",
  "ARYA DEV MAHAVIDYALAYA, TISUA, BAREILLY",
  "L.B.S. Group of Education Institute of Management, Hardua, Nababganj, Bareilly",
  "Sarvseva Mahavidyalaya, Aabadan Bairan, Ghazipur",
  "BHAGAUTI MAHAVIDYALAYA ",
  "LITTLE FLOWER SCHOOL OF MANAGEMENT AND HIGHER STUDIES, AUDHE, VARANASI",
  "SRI NABAB SINGH MAHAVIDYALAYA, HARIPUR, RATANPUR, MAINPUR",
  "SHRI RAM MURTI SMARAK COLLEGE OF ENGINEERING & TECHNOLOGY",
  "Navyug Mahavidyalaya Madhupur,Jaunpur",
  "Dr. Ram Manohar Lohia Institute of Medical Sciences",
  "Shivam College of Education",
  "SWAMI ADGADANAD MAHILA MAHAVIDYALAY",
  "St. J. B. College of Education, Mainpuri Road, Shikohabad, Firozabad",
  "LALLAN R TIWARI B.Ed COLLEGE MAHUARKALA",
  "Mariyahu, Snatkottar Mahavidyalaya, Mariyahu, Jaunpur",
  "SHREE KRISHNA SHARDA DEVI MAHILA MAHAVIDYALAYA, MAWAIYA, MIRZAPUR",
  "MOLAI SINGH HAUSHILA PRASAD SINGH RAM SAGAR SINGH MAHAVIDYALAYA, BHEDI, MIRZAPUR",
  "MAA TILESRA DEVI MAHAVIDAILIYA,  BHASRA TANDA",
  "RAJEEV PRAKASH DEGREE COLLEGE SINGRAUR UPARHAR ALLAHABAD",
  "DHANAWANTI MAHILA MAHAVIDHYALAY VISHUNPURA CHANDAULI",
  "Shree Bashisth Mahavidyalay, Baghari-Jamania, Ghazipur",
  "B.S.P College, Kannoj Ghaat, Mathura",
  "RADHA KRISHNA MAHILA MAHAVIDYALAYA",
  "MAHABODHI COLLEGE OF LAW",
  "UNITY DEGREE COLLEGE ",
  "CHANDRAWATI COLLEGE OF NURSING AND PARAMEDICAL SCIENCES, SIDDHARTHNAGAR",
  "Government Degree College Pawanikala",
  "ABHAY PRATAP SINGH DEGREE COLLEGE BHAUTAR AJHUA",
  "SARVODAYA MAHAVIDALIYA, SHAH PUR AURAWAN",
  "DIGAMBER JAIN COLLEGE OF EDUCATION",
  "VIDYA RAI WOMANS COLLEGE",
  "Satyam College of Education",
  "Gulabi Devi Mahavidyalaya, Siddiqpur ,Jaunpur",
  "Dr. Satya Prakash Singh Mahavidyalaya, Jamuniya ,Jaunpur",
  "Indrapati Mahavidyalay, Gairwah, Jaunpur",
  "Asha Mahavidyalaya, Dhirjijot, Sikhani, Ghazipur",
  "Ram Adhin Mahavidyalaya Tekardih, Jiyaramau, Jaunpur",
  "Gandhi Smarak Degree College, Samodhpur, Jaunpur",
  "Abul Kalam Azad Educational Institute, Dumariaganj, Siddharthnagar",
  "Jokhan Mahavidyalaya, Ekara, Ghazipur",
  "Sant Lakhandas (Naga Baba) Pachottar Mahavidyalaya, Tapeshvari, Nagar,Mardah ,Ghazipur",
  "swami vivekananda mahavidyalaya banda",
  "N.B.S. COLLEGE OF EDUCATION AND MANAGEMENT, BHADA, SULTANPUR (U.P.)",
  "Samarajit (S.J) Mahavidyalaya Veerbhanpur ,Jaunpur",
  "Baba Kamdev Singh Mahavidyalaya, Madhi, Jaunpur",
  "SHAKUNTALA MEMORIAL EDUCATIONAL INSTITUTE UNNAISA BAHRAICH",
  "Sahkari P.G.College Mihrawan , Jaunpur",
  "Bholanath Mishr Degree College Bholanagar, Jaunpur",
  "Nagarik Degree College Janghae ,Jaunpur",
  "Hindu P G College, Jamaniya, Ghazipur",
  "Dr. Akhtar Hasan Rizvi Shiya Degree College ,Jaunpur",
  "Raj Bahadur Mahavidyalaya , Gulalpur ,Jaunpur",
  "MODERN INTERNATIONAL COLLEGE OF LAW",
  "SR DEGREE COLLEGE SIKSHAN PRASHIKSHAN SANSTHAN GAJPUR BANSPAR GORAKHPUR",
  "Ch.surendra singh teachers trainning college bhatpuri saurikh kannauj",
  "Maa Kamakhya Mahavidyalaya, Gahmar Ghazipur",
  "Raj Gaurav Mahavidayala, Khutahan Jaunpur",
  "Trivedi Degree College, Mahraha, Bindiki, Fatehpur",
  "SRI LAXMI NARAYAN JANHIT DEGREE COLLEGE",
  "G.C. Degree College ",
  "SHIV ADARSH MAHAVIDYALAYA PENDHAT, FIROZABAD",
  "RAJKIYA MAHAVIDYALAYA TIGODWA DUMARIYAGANJ SIDDHARTHNAGAR ",
  "S.K. SCIENTIFIC MAHAVIDYALAYA SEKHIN,KARHAL, MAINPURI",
  "BRIJRAJ SINGH COLLEGE,KUBERPUR,FIROZABAD",
  "SRI BRAJ BEHARI DEGREE COLLEGE,KOSI-KALAN,MATHURA",
  "BANSHIDHAR SHARDA DEVI MAHAVIDYALAYA ALIPUR KHERA MAINPURI",
  "JAY MURTI COLLEGE NAGLA BALL,SISRAGANJ FIROZABAD",
  "MAA DURGA COLLEGE,SHASTRI PURAM,AGRA",
  "AKSHITA COLLEGE OF HIGHER EDUCATION ETMADNAGAR ALIPUR SARDHANA MEERUT",
  "BABU BAIJNATH PRASAD SHIKSHAN PRASHIKSHAN SANSTHAN, CHITAUNA, JALALPUR, KERAKAT, JAUNPUR",
  "Bashir Kha Mahila Mahavidyalaya, Usiya, Dildarnagar-Dewal Road, Jamaniya, Ghazipur",
  "BABA LAL PRATAP SINGH VIDHI MAHAVIDYALAYA, MUNGARI, KARCHHANA, ALLAHABAD",
  "BABA HARDEV SINGH  MAHAVIDYALAYA",
  "RAJKIYA MAHILA MAHAVIDYALYA, SHAHGANJ",
  "AADI SHIV NAVEEN MAHAVIDYALYA SHANTIPURAM OUNCHA MAINPURI",
  "KRISHNA PHARMACY COLLEGE",
  "B.D.M GIRLS COLLEGE,SHIKOHABAD,(FIROZABAD)",
  "A.K. DEGREE COLLEGE JYOTI, MAINPURI",
  "S.N. MAHAVIDYALAYA, BHARATPUR, FIROZABAD",
  "SRI SHIV PRASAD MEMORIAL BALIKA DEGREE COLLGE ,TUNDLA,FIROZABAD",
  "SANT RAM KRISHNAKANYA MAHAVIDHYALAY,AGRA",
  "RADHA KRISHAN KANYA MAHAVIDHYALYA SIKANDRA AGRA",
  "PREM PRAYAG MAHILA MAHAVIDYALAYA, BHONGAON,MAINPURI",
  "SHRI SURESH CHANDRA SHARMA DEGREE COLLEGE, JAGNER, AGRA",
  "AMAR NATH GIRLS DEGREE COLLEGE MATHURA",
  "SHRI JI  BABA INSTITUTE SEMRI MATHURA",
  "ST JOHN`S COLLEGE, AGRA",
  "BABU RAM CHAND CHEMELI KIRAN AGRASEN MAHAVI.KAGAROL AGRA",
  "INDIAN INSTITUTE OF MEDICAL SCIENCES RAUZAGAON FAIZABAD",
  "MADHAV SARVODAY LAW COLLEGE MOKALPUR RANI BAZAR AYODHYA",
  "KANTI DEVI COLLEGE OF EDUCATION MAHILA MAHAVIDYALAYA, DHANIYAKUNDI, BHUIDHARPUR, TAHABARPUR, AZAMGARH",
  "MANORAMA INSTITUTE OF MANAGEMENT & TECH. LADAMADA, AGRA",
  "RAJKIYA MAHILA MAHAVIDYALAYA, NAGLA KASHI, DHAULANA, HAPUR",
  "RAJKIY MAHAVIDYALAYA MADHOGARGH KONCH JALAUN",
  "AGRA PUBLIC TEACHERS TRANING COLLEGE ARTONI, AGRA",
  "Baikunthi Devi Kanya Mahavidyalaya Agra",
  "SYMBOZIA GIRLS COLLEGE MAHARANI BAGH BODLA, AGRA",
  "SRI KRISHNA COLLEGE OF EDUCATION FARIHA, FIROZABAD",
  "CAPT. RAKESH MOHAN SHYAM DEGREE COLLEGE, MATHURA",
  "C.S MEMORIAL DEGREE COLLEGE BAS BADAM ETMADPUR AGRA",
  "SHRI SHIV RAJ SINGH MAHAVIDYALAYA KISHANI,MAINPURI",
  "CHAUDHARY RAGHUNATH SINGH MAHAVIDYALAYA FATEHPUR SIKARI ROAD KIRAWALI,AGRA",
  "SRI RADHA MADHAV MAHAVIDHYALAYA, SABHAPUR CHITTARPUR RAM NAGAR, MAINPURI",
  "G.S.M COLLEGE OF EDUCATION BEWAR MAINPURI",
  "SMT BHAGWATI DEVI JAIN GIRLS COLLEGE, AGRA",
  "Raja Ram Mahavidyalaya Ramnagar, Jaunpur",
  "M.G BALIKA (PG) COLLEGE,FIROZABAD",
  "JAI MAA INSTT. OF EDUCATION KHARRA AGRA OAD MAINPURI",
  "K.R.TEACHERS TRAINING COLLEGE, MATHURA",
  "Parvati Girls Educational Institute ",
  "I.T.S. COLLEGE OF PHARMACY, MURADNAGAR, GHAZIABAD",
  "SAHARANPUR INSTITUTE OF ADVANCE STUDIES, GOKELPUR, SAHARANPUR",
  "SACHDEVA INSTITUTE OF TECHNOLOGY, MATHURA",
  "JAIPURIA INSTITUTE OF MANAGEMENT, GHAZIABAD",
  "Institute of Technical Education & Research Centre, GHAZIABAD",
  "SHANTI NIKETAN COLLEGE OF BUSINESS MANAGEMENT & COMPUTER SCIENCE,AGRA-GWALIOR ROAD,TEHRA,AGRA",
  "S.S. COLLEGE OF EDUCATION , SIKANDRA,KHAS PUR, AGRA",
  "D.E.(P.G.) COLLEGE, TUNDLA ROAD, NH-2, AGRA",
  "K.B.A. MAHAVIDYALAYA BARNAHAL MAINPURI",
  "SAUDAN SINGH INSTITUTE OF HIGER EDUCATION NAGLA RAMBAL KALENDI VIHAR, AGRA",
  "SHRI RAJENDRA SINGH YADAV MAHAVIDYALAYA, SARGAWAN, FIROZABAD",
  "MATA BASANTI SCHOOL OF BIOSCIENCE AND BIOTECHNOLOGY, AGRA",
  "SRI RAMA NAND KAILASH CHANDRA PAIGORIYA COLLEGE,AGRA",
  "SURYA EDUCATIONAL INST.. FARHA, MATHURA",
  "DEV EDUCATION COLLEGE BARHAN AGRA",
  "RAJIV ACADEMY FOR TECHNOLOGY & MANAGEMENT,  MATHURA, U.P.",
  "SURENDRA SINGH KANYA MAHAVIDHYALYA, IRADAT NAGAR, AGRA",
  "DAALCHAND MAHAVIDYALAYA, NARBOI, RAYA, MATHURA",
  "JASWANT SINGH BHADARIYA KANYA MAHA VIDHAYLYA KOSI KHURD MATHURA",
  "STATE. PT. J.L.N. HOMEO. MEDICAL COLLEGE, KANPUR",
  "NARAIN COLLEGE,SHIKOHABAD,(FIROZABAD)",
  "RAMESH CHANDRA CHANDRAKALA DEVI COLLEGE OF TECHNOLOGY, MAANT, MATHURA",
  "MAHA BODHI MAHAVIDYALAYA MAINPURI ROAD KUSUMARA (MAINPURI)",
  "ISHWARCHAND VIDYASAGAR INSTITUTE OF TECHNOLOGY, AKBARPUR, MATHURA.",
  "CHANDANVAN INSTITUTE OF EDUCATION MATHURA",
  "CH.VEER BHAN SINGH MAHAVIDYALAYA CHATRIPUR MAINPURI",
  "SMT. SURAJMUKHI DEGREE COLLEGE,MAINPURI",
  "GOPAL DASS MEMO. EDUCATIONAL INSTT. AGRA",
  "CHAUDHARY SURAJ SINGH MAHAVIDYALAYA MAINPURI KUSUMARA ROAD JAGIR MAINPURI",
  "DEV COLLEGE BARHAN ETMADPUR, AGRA",
  "DHEERENDRA PAL SINGH INSTITUTE OF HIGHER EDUCATION AGRA ROAD MAINPURI",
  "N.S.S. COLLEGE OF EDUCATION CHHOLI, MATHURA",
  "SHRI GIRIRAJ MAHARAJ COLLEGE,MATHURA",
  "SRI RAM SINGH MAHAVIDYALAYA BRIJBHUSHAN NAGAR KISHNI MAINPURI",
  "J.S COLLEGE OF EDUCATIONAL BYE PASS RD.SHIKOHABAD,FIROZABAD",
  "INSTITUTE OF TECHNOLOGY MANAGEMENT, ALIGARH",
  "UTTAM INSTITUTE OF TECHNOLOGY & MANAGEMENT,RUNKATA,AGRA",
  "RAJIV ACADEMY FOR TEACHERS EDUCATION, MATHURA",
  "R.C. SHARMA DEGREE COLLEGE, AGRA",
  "SMT. BHUDEVI MAHAVIDYALAYA SHASTRI PURAM, AGRA",
  "BABA TIKAM SINGH KANYA MAHAVIDYALAYA HIMAT KHERGARH ,FIROZABAD",
  "SHIVANAND ANAND MAHA VIDHYALAYA , ETAH ROAD, SHIKOHABAD",
  "SMT LAXMI DEVI MAHILLA EDUCATIONAL INSTITUTE SHAMSABAD,AGRA",
  "SURDAS BRAJ RANI MEMORIAL DEGREE COLLEGE,RUNKATA,AGRA",
  "GOVT.GIRLS DEGREE COLLEGE,SIRSAGANJ,FIROZABAD",
  "DNS COLLEGE OF ENGINEERING AND TECHNOLOGY, J P NAGAR",
  "RAMESHWARI DEVI KANYA MAHAVIDYALAYA PATHOLI,AGRA",
  "DISHA INSTITUTE OF SCIENCE AND TECHNOLOGY, DHAMPUR, BIJNORE",
  "DISHA BHARTI COLLEGE OF MANAGEMENT AND EDUCATION, SAHARANPUR",
  "GOVERNMENT COLLEGE RAMPUR MANIHARAN, SAHARNAPUR",
  "Shahzada Muslim Mahavidyalaya, karma-Bahuara, Dildarnagar, Ghazipur",
  "MAA KAMLA DEVI  MAHAVIDYALAYA, PIPRIMAFI, SHIVPUR",
  "GOVERNMENT DEGREE COLLEGE BAIRIYA BALLIA",
  "PT. RAM LAKHAN SHUKLA  GOVERNMENT P.G. COLLEGE ALAPUR, AMBEDKARNAGAR",
  "DR. RAM PRAKASH SMARAK MAHAVIDYALAYA,PARAS",
  "K P S LAW COLLEGE MYOHAR KAUSHAMBI UP",
  "Santraj Sanjay Mahavidyalaya, Deeha, Kunda, Pratapgarh",
  "Jyotirvid Rammurti Mahavidyalaya, Devari, Manda, Allahabad",
  "RAFAT ULLA MAHAVIDYALAYA AJHUI SULTANPUR",
  "LALA SIPATTAR LAL RAMBETI DEGREE COLLEGE HARRAMPUR, Bareilly ",
  "DAYARAM VERMA MAHAVIDYALAY PEETHAPUR KUDIYA CHITAUNA ",
  "MAA GAYATRI RAMPRASAD PANDEY SMARAK MAHAVIDYALAYA, MUGRAUL BANKATI, SURYABALI SINGH, GONDA ",
  "RAJKIYA MAHILA MAHAVIDYALAYA PARASINPUR PHULPUR PRAYAGRAJ",
  "JANTA JAGRITI GIRLS DEGREE COLLEGE EKRI SARDHANA MEERUT",
  "Fatima Degree College",
  "PANCHSIDDH LAW COLLEGE",
  "LAXMI DEVI DEGREE COLLEGE",
  "KK VIDDHI MAHAVIDYALAYA, MANDHATA, PRATAPGARH",
  "Shri Mahant Vicharanand Sanskrit Mahavidyalya",
  "ACHARYA SADASHIV SHIKSHA SANSTHAN ",
  "AJAB NARAIN HARISH CHANDRA SMARAK MAHAVIDYALAYA, SHEKHAPUR, GAURIGANJ, PRATAPGARH",
  "BAIJNATH BALIKA MAHAVIDYALAYA, KUSHI NAGAR, RAIPUR BHATNI, PRATAPGARH",
  "BAJRANG MAHAVIDYALAYA, KUNDA, PRATAPGARH",
  "DHANRAJ KUNWAR GIRLS COLLEGE, SARAI BHUPATI, KATRA GULAB SINGH, PRATAPGARH",
  "Jwala Devi Mahavidyalay Retahi, Manikpur",
  "KAMACCHA PRASAD PRATAP NARAIN MISHRA COLLEGE OF EDUCATION & TECHNOLOGY, PURE DUDHI, RAMGANJ, PRATAPGARH",
  "Akshay Mahila Mahavidyalay, Piyusha Nagar, Pahitiya Ghazipur",
  "Maharana Pratap College for Teachers Training",
  "Kuber Mahavidyalaya, Hasanpur, Jajauli No. 2 Ballia",
  "KOTHIWAL COLLEGE OF NURSING",
  "RAI KRISHNA PAL SINGH MAHAVIDYALAYA BEERAPUR PRATAPGARH",
  "V B S VIDHI MAHAVIDYALAY BAGAI KALA BAGAI KHURD PRAYAGRAJ ",
  "SHRIMATI DR NIRMALA LAW COLLEGE RANJEETPUR CHILBILA PRATAPGARH UP",
  "Maharaj Balwant Singh P.G.College, Gangapur, Varanasi",
  "Pt. Mahaveer Prasad Tripathi Mahavidyalay, Vijaypur, Mirzapur",
  "M.S. Adarsh Mahavidyalaya, Polwa, Mahuli, Duddhi, Sonebhadra",
  "Pushpa Singh Vidhi Mahavidyalaya. Barewan, Chunar, Mirzapur",
  "Varanasi Girls Degree College, Varanasi",
  "Kalikadham P.G.College, Sewapuri, Varanasi",
  "Ramanuj Pratap Mahavidyalay, Dramalganj, Mirzapur",
  "Girija Prasad Dwivedi Mahavidyalaya, Semradh, Sant Ravidas Nagar, Bhadohi",
  "RUMA MAHAVIDYALAYA, GOVRI, PRATAPGARH",
  "Dr. Kanak Tripathi Degree College, Bargadhi, Bhathat, Gorakhpur",
  "Rajeshwar Pandey Memorial Mahavidyalaya, Turkpatti Mahuan, Kushinagar",
  "Babu Tahsildar Shahi Mahavidyalaya, Singha, Kushinagar",
  "Srimati Subhraji Devi Degree College, Tiwaripur, Badhyapar, Gorakhpur",
  "Kabutari Devi Rajeshwar Tripathi Smarak Mahavidyalaya, Balendrapuri, Dumari Khas, Gorakhpur",
  "Gyatri Devi Degree College, Pathara, Badango, Gorakhpur",
  "Shivshankar Chaturvedi Degree College, Tungpar, Sant Kabir Nagar",
  "Saradar Ballabh Bhai Patel Kanya Degree College, Partawal Bazar, Maharajganj",
  "Santram Chaudhary Shrimati Rajkali Devi Educational Academy, Dasia, Basti",
  "Pt. Ambika Pratap Narayan Mahavidyalaya, Dumri, Hariharpur, Sant Kabir Nagar",
  "Om Prakash Mahavidyalaya, Bahuar Kala, Jhulanipur, Maharajganj",
  "Jaimata Rani Srimati Dhansira Degree College, Karmahiya, Basti",
  "Hiralal Ramniwas P. G. College, Khalilabad, Sant Kabir Nagar",
  "Devi Singh Smarak Mahavidyalya, Rajnauli (Sirsi), Sant Kabir Nagar",
  "Brahamdutt Dwivedi Prabha Dwivedi Degree College, Ramgarh Chhawani, Basti",
  "Ambika Ram Devi Degree College, sandpur, ramana Taukir, haraiya, basti",
  "Digvijay Nath P. G. College, Gorakhpur",
  "Lilawati Devi Mahavidyalaya, Piprajham, Kushinagar",
  "Siddheshwar Shitaldev Narayan Mahavidyalay, Bharhe Chaura, Bhatani, Deoria",
  "S.K.G.N. Degree College, Madapar, Kusumahi Bazar, Gorakhpur",
  "B.R.D. Degree College, Madapahi, Nonapar, Deoria",
  "Vishwanath Rai Kakand Mahavidyalay Khukhundu, Deoria",
  "Sudama Devi Mahila Mahavidyalaya, Piparhiyan, Pakadi Babu, Bhatparani, Deoria",
  "Pacific College of Physiotherapy, Gorakhpur",
  "B. R. D. B. D. P. G. College, Ashram, Barhaj, Deoria",
  "Pt. Thakur Prasad Tripathi Kisan Mahavidyalay Aabhuram (Turkwaliya), Gorakhpur",
  "D. A. V. P. G. College, Gorakhpur",
  "Vidyarthi Mahavidyalay, Jagdeeshpur Bardeeha, Kushinagar",
  "Saradar Patel Mahavidyalay, Haraiya Buzurg, Kushinagar",
  "Sarvodaya Kisan Mahavidyalaya, Kaudiram, Gorakhpur",
  "Late Sarada Prasad Rawat Degree College, Bhiti Rawat, Sahajanwa, Gorakhpur",
  "Pyari Devi Rajit Mahavidyalya, Tilaura, Pali, Sahajanwa, Gorakhpur",
  "Pt. Ramnayan Ramsukh Degree College, Sohnag, Belghat, Gorakhpur",
  "Nath Chandravat Mahavidyalaya, Jagdishpur, Gorakhpur",
  "Jawahar Lal Nehru P. G. College, Bansgaon, Gorakhpur",
  "Swarn Prabha P.G. College, Aanand Nagar (Pharenda), Maharajganj",
  "Shivpati Mahavidyalay, Shohratgarh, Siddharthnagar",
  "Sardar Patel Degree College Bargadwa, Kopia, Sant Kabir Nagar",
  "Purvanchal Degree College, Munderawa, Basti",
  "Pt. Surya Narayan Chaturvedi Mahavidyalaya, Nathnagar, Sant Kabir Nagar",
  "Pt. Surya Narayan Chaturvedi College of Law,Khalilabad, Sant Kabir Nagar",
  "Premlata Mahavidyalaya, Achiya Mehadawal, Sant Kabir Nagar",
  "Paramhans Pal Degree College, Gurli, Maharajganj",
  "Murati Devi Smarak Mahavidyalaya, Pakari, Uska Bazar, Siddharthnagar",
  "Late Gaukaran Singh Dinesh Mahavidyalaya, Chilihan, Siddharathnagar",
  "Lakhpati Devi Ram Kishor Mahila Mahavidyalay, Ektekwa, Basti",
  "Kallan Degree College, Thumhava Bhaiya, Khutahana, Siddharathnagar",
  "Jeevan Deep Women College of Education, Suryanagar, Ghazipur",
  "RAJKIYA MAHAVIDYALAYA, NAKUR, SAHARANPUR",
  "Model Public Education College, Chandausi",
  "Rama Jain Kanya Mahavidyalaya, Najibabad",
  "Shri K.D. Nagar Memorial degree College",
  "SKDM Institute of Education, Siraswan, Harchand",
  "Gangasheel School of Nursing",
  "Ganna Krishak Mahavidyalaya",
  "Baba RamDas Mahavidyalaya Saidpurkani, Bholapur",
  "Wilsonia Degree College",
  "Govt. Mahavidyalaya, Bilsi",
  "Gandhi Samrak Mahavidyalaya, Surjan Nagar Jai Nagar",
  "Vivekanand Mahavidyalaya, Darbara",
  "Ram Ratan Singh Memrial Degree College, Zahidpur, Shahabad",
  "Govt. Mahavidyalaya , Sambhal",
  "B R COLLEGE",
  "Shyam Sunder Memorial (PG) College, Chandausi",
  "Sirsa College of Science & Technology, Sirsa, Baheri",
  "Mahamaya Govt. Degree College, Sherkot",
  "Jhamman Lal Degree College, Hasanpur",
  "Rakshpal Bahadur Teacher's Training Institute",
  "Vardhaman College, Bijnor",
  "Disha Institute of Science & Technology, Dhampur",
  "Sahu Ram Swaroop Mahila Mahavidyalaya",
  "Harbansh Dayaprakash Shyamadevi Mahavidyalaya, Dhavarsi",
  "Ranjeet Singh Memorial (PG) College, Dhampur",
  "Radhey Lal Memrial College, Afzalgarh",
  "Pritee Rural Institute for Technology & Education, Bhuta",
  "Roshan Lal Shanti Devi Academy",
  "Gokul Das Hindu Girls College",
  "Govind Ballabh Pant Mahavidyalaya, Kachla",
  "ACME Institute of Management & Technlogy",
  "Budaun Institute of Management & Technology",
  "Gindo Devi Mahila Mahavidyalaya",
  "Dhampur Law College, Dhampur",
  "Maharaja Prithviraj Chauhan Degree College, Sarakthal, Swar",
  "Bhagirathi Devi Mahavidyalaya, Mandi Dhanora",
  "Yameen Mhammed Saifi Degree College, Mandi Dhanora",
  "Kanya Mahavidyalaya, Bhoor",
  "Rambaran Verma college of Education",
  "CHAUDHARY CHARAN SINGH COLLEGE OF PHARMACY",
  "ERAM COLLEGE KURSI ROAD GUDAMBA",
  "SAVITRI SINGH ADYA PRASAD MAHAVIDYALAYA SARAIYA AYODHYA",
  "Maharaja Agrasen Mahavidyalaya",
  "SHRIMATI DURGAWATI DEVI MAHILA MAHAVIDYALAY KODRA BANKATA BHARPURWA",
  "SHIVKUMARI MAHILA MAHAVIDYALAYA LOHTI SARAIYA RUDAULI AYODHYA",
  "VIVEK COLLEGE OF AYURVEDIC SCIENCES AND HOSPITAL BIJNOR",
  "NANDINI COLLEGE, NAWABGANJ, DISTRICT-GONDA",
  "J.M.B. Institute of Life Sciences & Higher Education",
  "Virendra Mithileshwar Mahavidyalaya, Mahadeya Lotan, Siddharthnagar",
  "Smt. Prabha Devi Mahavidyalay, Khalilabad, Sant Kabir Nagar",
  "KHALSA Mahavidyalaya",
  "R.B.S. Mahavidyalaya, Payakpur, Dingrapur, Basti",
  "Ramdhani Singh Nohara Devi Govt. Degree College, Garha Gautam, Kaptanganj, Basti",
  "Sri Harpal Shastri Smarak Mahavidyalaya, Pheena",
  "G.S. Degree College, Jamdeeh, Basti",
  "Chote Lal Damodar Prasad Shibban Lal Degree College, Beesokhor, Maharajganj",
  "Budh Vidyapeeth Mahavidyalay, Naugarh, Siddharthnagar",
  "Budh Balika Degree College, Gautam Palli, Siddharthnagar",
  "ANNAPURNA DEVI KANYA MAHAVIDYALAYA",
  "Brijlal Smarak Degree College, Rajabari, Thuthibari, Maharajganj",
  "Kundan Singh Memorial Mahavidyalaya, Afjalpur Loot, Post Kaurala, Amroha",
  "Pushp Institute of Sciences & Higher Studies",
  "Darshan Singh Memorial Degree College, Baheri",
  "MahaRaja Harishchanda PG College",
  "Khusro Memorial Degree College, C.B. Ganj",
  "Springdale Mahila Mahavidyalaya",
  "City Degree College, Nagina",
  "Ram Saran Yadav Sanskrit Mahavidyalaya",
  " SHRI RAMLAKHAN GIRI SANSKRIT MAHAVIDYALY, RAMCHANDIPUR, CHAUBEYPUR,VARANASI 221104",
  "Thakur Rammurti Rambahal Singh Mahavidyalaya, Ramgarh, Puredhani, Pratapgarh",
  "GCRG COLLEGE OF PHARMACY",
  "UDAYRAJ CHANDRABHAN SHYAMA DEVI MAHILA MAHAVIDYALAYA CHANDRANAGAR, KHANPUR, HUJURPUR KAISARGANJ, BAHRAICH",
  "DR. OM PRAKASH SCHOOL OF PHARMACY",
  "Vishavnath Saraswati Mahila Mahavidyalaya, Dudahi, Kushinagar",
  "DR RAGINI SANSKRIT SNATKOTTAR MAHAVIDHYALYA ATARSUIYA JARI PRAGRAJ",
  "Rama Bai Ambedkar Govt. Mahavidyalaya, Gajraula",
  "Purshottam Lal Sharma Degree College, Dandra, Sahaswan",
  "Hafiz Rahmat Khan Law Degree College",
  "Khandelwal College of Management Science & Technology",
  "Nehru Memorial Shiv Narayan Das Mahavidyalaya",
  "Abdul Razzaq Degree College, Joya",
  "Devta Mahavidyalaya, Morna",
  "Hari-Mangal Mahavidyalaya, Bilari",
  "Musavvir Husain Baqri Memorial Degree College, Said Nagli, Amroha",
  "Shri Balaji Acadamy, Mahmood Bastaur",
  "Farooq Aslam Degree College,Amroha",
  "Ayodhya Prasad Memorial Mahavidyalaya , Ujhani",
  "Rajneesh Pratap Singh Mahavidyalaya, Haldaur",
  "Nehtaur Degree College, Nehtaur",
  "Shri Sangved Sanskrit Mahavidyalaya, Nagharipur, Mustafabad",
  "Shri Shankar Sanskrit Mahavidyalaya, Manikavali",
  "Shri Vaishnava Bhagwan Deshrajsuri Adarsh Sanskrit Mahavidyalaya, Udaibhanpur, Kolhuva",
  "Shri Vidyadharmvardhani Pathshala Sanskrit Mahavidyalaya, Gur ki mandi",
  "Shri Yamuna Sanskrit Mahavidyalaya, Katsila, Chandauli",
  "SWAMI RAMPRAPNNACHARYA MADRASHI SWAMI RAGHAVACHARYA RAMANUJ SANSKRIT MAHAVIDHYALYA VRINDAVAN",
  "Vishwanath Vedik Karmkand Vidyalaya, Vishwanath Gali",
  "Lokmani Memorial Degree College, Kadrabad Khurd, Seohara",
  "NARAYAN GROUP OF EDUCATIONAL INSTITUTIONS VILLAGE SARAI JARERA SIKANDRA RAO HATHRAS ",
  "Prem Kishan Khanna Govt. College, Jalalabad",
  "Bareilly College",
  "Sirsi Sadat Degree College, Sirsi Dadat",
  "UTTAR PRADESH TEXTILE TECHNOLOGY INSTITUTE, KANPUR",
  "JIVIKA COLLEGE OF PHARMACY",
  "NANDLAL PRABHU DEVI PROFESSIONAL INSTITUTE",
  "Dr Ram Manohar Lohiya  Mahavidyalaya",
  "SRAD COLLEGE OF EDUCATION",
  "S S D LAW COLLEGE GARHMALPUR NAJIBABAD",
  "Sri Sai Degree College, Bhawalpur Bansli",
  "OM SAI VINDHYA COLLEGE OF PHARMACY TISUHI MARIHAN MIRZAPUR",
  "BAHADUR YADAV MAHAVIDYALAYA, BHATNI, DEORIA, UP",
  "SHYAMVEER SINGH MEMORIYAL DEGREE COLLEGE GARHIYA RANGEEN TILHAR",
  "H N A Rohilkhand Degree College  Tilhar Shahjahanpur ",
  "ARYA COLLEGE OF PHARMACY",
  "MA SHARADA DEVI MAHILA MAHAVIDYALAYA,  KAITHAULI,  BABATPUR,  VARANASI",
  "MAHARANA INSTITUTE OF PROFESSIONAL STUDIES, KANPUR",
  "DR VIRENDRA SWARUP INSTITUTE OF COMPUTER STUDIES, KANPUR",
  "DAYANAND ACADEMY OF MANAGEMENT STUDIES, KANPUR",
  "Km. Mayawati Government Girls Post Graduate Badalpur, Gautambuddha Nagar",
  "BALWANT SINGH MAHAVIDYALAYA, ASRAWALI SHIKOHABAD FIROZABAD UP.",
  "DAYANAD DINANATH COLLEGE OF MANAGEMENT, KANPUR",
  "COLLEGE OF MANAGEMENT STUDIES, KANPUR",
  "SHRI MAA DURGA JAGRANI DEVI SANSKRIT MAHAVIDYALAYA DHARMAPUR BHIRA KHERI",
  "SCHOOL OF OPTOMETRY SITAPUR EYE HOSPITAL SITAPUR",
  "SMT MAHRANA BABULAL SHIKSHAN EVAM PRASHIKSHAN SANSTHAN MAURYA NAGAR MAUDARA KARENTI KUNDA PRATAPGARH ",
  "Dwarikadas hari Mahavidyalaya Sarijahagir Patti shahganj jaunpur",
  "RAJSHREE COLLEGE OF NURSING AND PARAMEDICAL",
  "MOTI MAHILA MAHAVIDYALAYA",
  "ADESH COLLEGE OF PHARMACY",
  "Maa Gaura Mahavidyalaya Hamirpur",
  "RAMPUR COLLEGE OF LAW MILAK",
  "RASIK BIHARI MAHAVIDYALAYA BADHNAPUR KANCHAR VISHESHWARGANJ BAHRAICH",
  "DSSOP PHARMACY COLLEGE",
  "Hakikullah Chaudhary College of Pharmacy",
  "Aksh International College Raja ka Tajpur  bijnor",
  "Ram Adhar Singh Mahavidyalaya Sehmalpur Jalalpur Jaunpur",
  "Ram Nageena Smarak Mahila Mahavidyalaya Amhat Ghazipur",
  "ARYAKUL COLLEGE OF PHARMACY AND  RESEARCH SITAPUR",
  "Sardar Patel College of Pharmacy",
  "SIGNA COLLEGE OF PHARMACY",
  "Himalyan Group of Institute for Law Loyan Malakpur Baraut Baghpat",
  "Seiko College of Pharmacy",
  "Ankerite college of pharmacy",
  "RPS COLLEGE OF PHARMACY",
  "B N COLLEGE OF PHARMACY",
  "Durgawati Radheshyam Balika Mahavidyalaya Rudranagar Ghazipur",
  "Paras Nath Janardan Girls Degree College Badihari Daulatpur Ghazipur",
  "RUKMINI DEVI ASHARAFI LAL VERMA SHIKSHAN AVM PRAKSHIKSHAN SANSTHAN PAIKOLIYA HARRAIYA BASTI",
  "DEV MAHAVIDHYALAYA, NAYAYIPUR, SORAV",
  "SARLA DEVI KAMLAPRASADSHUKLA MAHAVIDYALAYA GONDA",
  "MAA VAISHNO DEVI MAHILA MAHAVIDYALAYA, BHAGAUTIPUR, BAREILLY",
  "BANSI COLLEGE OF MANAGEMENT AND TECHNOLOGY, KANPUR",
  "Sonpati Devi Mahila Degree College, Maharajganj",
  "CENTRAL INSTITUTE OF PLASTIC ENGINERRING AND TECHNOLOGY, LUCKNOW",
  "GOVERNMENT INSTITITE OF MEDICAL SCIENCES",
  "ROSHAN SINGH CHAUHAN SAMARK MAHAVIDYALAYA, ASMOLI",
  "B N COLLEGE OF ENGINEERING AND TECHNOLOGY, LUCKNOW",
  "AZAD INSTITUTE OF PHARMACY AND RESEARCH , LUCKNOW",
  "BUDDHA INSTITUTE OF TECHNOLOGY , GORAKHPUR",
  "NANDANI NAGAR MAHAVIDAYALA COLLEGE OF PHARMACY, GONDA",
  "K R S COLLEGE OF PHARMACY, GONDA",
  "SHRI SIDDHI VINAYAK COLLEGE OF PHARMACY RAIBHA AGRA",
  "ACHARYA NARENDRA DEV COLLEGE OF PHARMACY, GONDA",
  "I E C COLLEGE OF ENGINEERING AND TECHNOLOGY , G.B.NAGAR",
  "Siddharth Mahavidyalaya, Bardpur, Siddharthnagar",
  "MAHARAJA SUHEL DEV AUTONOMOUS STATE MEDICAL COLLEGE AND MAHARISHI BALARK HOSPITAL KDC ROAD BAHRAICH",
  "RAJARSHI DASHRATH AUTONOMOUS STATE MEDICAL COLLEGE AYODHYA",
  "SHRI R L T INSTITUTE OF PHARMACEUTICAL SCIENCE AND TECHNOLOGY COLLEGE, ETAWAH",
  "SAGAR INSTITUTE OF TECHNOLOGY AND MANAGEMENT, BARABANKI",
  "SAGAR INSTITUTE OF TECHNOLOGY AND MANAGEMENT DEPARTMENT OF PHARMACY, BARABANKI",
  "Rajeev Gandhi Mahavidyalay, Nautanwa, Maharajganj",
  "Pt. Kashi Prasad Dixit Shikhan Prashikhan Mahavidyalaya, Pakari Dixit, Maharajganj",
  "Maulana Azad Mahavidyalay, Baytaal, Kadirabad, Siddharthnagar",
  "Late Asharfi Lal Mahavidyalay, Itwa Jogiya, Siddharthnagar",
  "Kaushal Kishor Tej Pratap Snatak Mahavidyalaya, Bagapar, Maharajganj",
  "Mahatma Gandhi Memorial College, Sambhal",
  "Janta Vaidik Mahavidyalay, Menhdawal, Sant Kabir Nagar",
  "Janki Prasad Chaudhary Mahila Mahavidyalay, Kataudha, Basti",
  "Govt. Degree College, Dumariaganj, Siddharathnagar",
  "Gorakshpithadhishwer Mahant Awaidhnath Mahavidyalay, Chauk Bazar, Maharajganj",
  "Vasant Kanya Mahavidyalaya, Kamachha",
  "Multanimal Modi College, Modinagar (Ghaziabad)",
  "Rajkiya Engineering College Sonbhadra",
  "Shri Ram Murti Smarak College of Law",
  "Government Degree College",
  "SHIVBALI SINGH GROUP OF EDUCATIONAL AND TRAINING INSTITUTE",
  "MAA GAYTRI MANGLA DEVI PANDEY SMARAK MHAVIDYALAY, SOTHIA, MOTIGANJ,  GONDA",
  "B S BEd COLLEGE",
  "SP COLLEGE OF PHARMACEUTICAL SCIENCE AND RESEARCH",
  "BPS Educational Institution of Pharmacy",
  "JAHANGIRABAD EDUCATIONAL TRUST GROUP OF INSTITUTIONS FACULTY OF ARTS",
  "KAMLA PRASAD SINGH MAHAVIDYALAYA BARAULA GAURA SULTANPUR",
  "RAJKIYA MODEL DEGREE COLLEGE ARNIYA BULANDSHAHR",
  "Asha College of Education, Dhirjeejot Sikhadi Ghazipur",
  "NARI SHIKSHA NIKETAN GIRLS P.G. COLLEGE, KAISARBAGH",
  "PRAKASH CHANDRA MAHAVIDYALAYA, KAKOR BUJURG,",
  "BRAHMANAND P.G. COLLEGE,",
  "SANT VIRAGI BABA MAHAVIDYALAYA, SRINAGAR,",
  "BABU SUKHDEV PRASAD VERMA LAW COLLEGE, CHAKERI,",
  "JANTA MAHAVIDYALAYA, AJEETMAL,",
  "KESHAV PRASAD SMARAK MAHAVIDYALAYA, MIRZAPUR KALAN,",
  "VIDYA MANDIR DEGREE COLLEGE, KAYAMGANJ,",
  "GAUTAM BUDDHA MAHAVIDYALAYA, SIDDHARTH NAGAR,",
  "DARSHAN SINGH MAHILA MAHAVIDYALAYA, BEWAN,",
  "LALLU SINGH MAHAVIDYALAYA, IMLIPUR,",
  "K.S.B.D. MAHAVIDYALAYA, BHIKHNAPUR,",
  "JAHANGIRABAD EDUCATIONAL TRUSTS GROUP OF INSTITUTIONS FACULTY OF MANAGEMENT, BARABANKI",
  "DADAJI MAHAVIDYALAYA, ERWAKATRA,",
  "MOHINI B. MANWANI GIRLS DEGREE COLLEGE, AWAS VIKAS-3,",
  "SHAKTI COLLEGE OF PHARMACY, BALRAMPUR",
  "LALARAM MAHAVIDYALAYA, CHAMPANER,",
  "SHRI DARSHAN MAHAVIDYALAYA, DIBIYAPUR ROAD,",
  "RAMA MAHAVIDYALAYA",
  "SHIVWATI SHIVNANDAN SHUKLA MAHAVIDYALAYA, PUKHRAYAN,",
  "D.W.T. COLLEGE,",
  "MAHARANA PRATAP DENTAL COLLEGE & HOSPITAL,",
  "OM SRI VISWAKARMAJI MAHAVIDYALAYA, KAHINJARI,",
  "BAHUUDDASIYA SEWA SHIKSHA SANSTHAN GIRLS DEG. COLL., SAURIK,",
  "PT. LALTAPRASAD RAMKRISHNA MAHAVIDYALAYA, SHANTI NAGAR, BHAWANIGANJ, SARWAN,",
  "PT. SAHADEV PRASAD TRIVEDI MAHAVIDYALAYA, RAMAIPUR,",
  "DAYANAND COLLEGE OF LAW,",
  "SNEHLATA GUPTA MEMORIAL DEGREE COLLEGE, RASULABAD,",
  "SRI R.P. PORWAL MAHAVIDYALAYA, RAJPUR,",
  "GAURI SHANKER DWIVEDI MAHAVIDYALAYA, JHINJHAK,",
  "BRAHASPATI MAHILA MAHAVIDYALAYA, KIDWAI NAGAR,",
  "KUNJBIHARILAL MEMO. MAHAVIDYALAYA, DUBKI, HASANPUR,",
  "KARGIL SAHEED MAHAVIDYALAYA, JASWANT NAGAR,",
  "Baba Mathura Das Sitaram Mahavidyalaya, Chilkahar, Ballia",
  "Baba Sakharaj Smarak Mahavidyalaya Jakariya, Ballia",
  "Bajrang Mahavidyalaya, Dadar Ashram, Sikandarpur, Ballia",
  "SHAKUNTALA DEVI MAHILA MAHAVIDYALAYA, KAYAMGANJ,",
  "Banke Bahadur Singh Mahavidyalaya, Turtipar, Ballia",
  "SONE SHREE SMARAK BALIKA MAHAVIDYALAYA, TIRWA,",
  "JAGRAN COLLEGE OF ARTS, SCIENCE & COMMERCE, JUHI,",
  "SUYASH INSTITUTE OF INFORMATION TECHNOLOGY, GORAKHPUR",
  "SIR MADAN LAL INSTITUTE OF PHARMACY, ETAWAH",
  "SHRI RLT INSTIUTE OF MANAGEMENT, ETAWAH",
  "K L S INSTITUTE OF ENGG AND TECHNOLOGY, BIJNAUR",
  "V.V.K. DEGREE COLLEGE, TYOR, TAALGRAM,",
  "VIDYA PRAKASH MAHAVIDYALAYA, UDHRANPUR,",
  "HAZI TAUFIQ ALI MAHAVIDYALAYA, GUNHA, GUGRAPUR,",
  "L.Y. DEGREE COLLEGE, KAYAMGANJ,",
  "KUNDAN LAL SHUKLA MAHAVIDYALAYA, RANIA,",
  "SRI THAKUR JI MAHARAJ MAHAVIDYALAYA, SAFIPUR,",
  "NEHRU P.G. COLLEGE, CHHIBRAMAU,",
  "MULAYAM SINGH MAHAVIDYALAYA, SAKARAPUR, YASHODA NAGAR,",
  "Vimla Devi Mahila Mahavidyalaya, Katghar Khas karaudikala kadipur sultanpur",
  "Baba Kuber Nath Mukhlal Memorial Vidyapeeth Mahila Sansthan ",
  "Smt Ramkali Iqbal Bahadur Group Of colleges",
  "KAMLESH KUMARI LAXMI KANT MAHAVIDYALAYA ",
  "SHIV LAL MAHAVIDYALAYA, LUHARGAON, JHANSI",
  "Shri Prabhunath Mahila Mahavidyalaya, Basantchak Saidpur Ghazipur",
  "MIT College of Pharmacy Moradabad",
  "RAJPATI MATAPRASAD SHIKSHAK PRASHIKSHAN MAHILA MAHAVIDYALAYA GAURA KALWARI BASTI",
  "Gunjeshwar Upadhyay Kanya Mahavidyalya, Barwa turkdiha kushinagar ",
  "Shri Radhakrishna Mahila Mahavidyalaya Sundarpur Govindpur Ghazipur",
  "Muhammad Sher Ali Madina Mahavidyalaya Kothilwa Deoria",
  "GAJENDRA SINGH PUBLIC DEGREE COLLEGE, BIDHUNA, AURRAIYA",
  "RAM JANKI MAHAVIDYALAYA, ASAI, BAIRY SAWAI,",
  "SWARGIYA SMT SHANTI RAGHAVE MEMORIAL COLLEGE FOR EDUCATION AND TECHNOLOGY",
  "SRI THAKUR JI MAHARAJ MAHAVIDYALAYA, BILHAUR,",
  "SHIVSHANKAR SINGH SHIVRAM SINGH MAHAVIDYALAYA, VIRSINGHPUR,",
  "SHRIMATI KALI DEVI MAHAVIDYALAY BHAGANE BHAGWANPURI VAYA BARAHI CHAURI CHAURA GORAKHPUR",
  "FATEHBAHADUR SINGH SHIVSHANKER SINGH MAHAVIDYALAYA SASANA BAHADURPUR BELTHARA ROAD BALLIA",
  "SHIVLOK MAHILA MAHAVIDYALAYA, MEHARBAN SINGH KA PURWA,",
  "PHARMACY COLLEGE, AZAMGARH",
  "DR. RAM NARAYAN MAHILA MAHAVIDYALAYA, KAYAMGANJ,",
  "SRI RAMKUMAR BHARTIYA GYAN DEVI MAHAVIDYALAYA, FAFOOND,",
  "PT. RISHI MAHARAJ MAHAVIDYALAYA, JASWANTPUR, MURADGANJ,",
  "UNITED INSTITUTE OF TECHNOLOGY, ALLAHABAD",
  "R K PHARMACY COLLEGE, AZAMGARH",
  "TRIYUGI NARAYAN MAHAVIDYALAYA, MANGALPUR,",
  "BHARTIYA MAHAVIDYALAYA, BELA,",
  "K.M. COLLEGE OF EDUCATION, MUIYA,",
  "DAYANAND DEENA NATH MAHAVIDYALAYA, RAMAIPUR,",
  "GAYA PRASAD VIDHI MAHAVIDYALAYA, DHUKAPUR, SHIVRAJPUR, PURA,",
  "SARASWATI B.ED. MAHAVIDYALAYA, ROOMA,",
  "CH. GAJRAJ SINGH MAHAVIDYALAYA, RATHAURA, TAJPUR,",
  "PRABUDDH AYURVEDIC MEDICAL COLLEGE HOSPITAL AND REASERCH CENTRE  LUCKNOW",
  "TARA DEVI MAHAVIDHYALAYA",
  "INTEGRAL AND INNOVATIVE SUSTAINABLE EDUCATION COLLEGE",
  "R S D ACADEMY COLLEGE OF PHARMACY",
  "R S D ACADEMY INSTITUTE OF MEDICAL SCIENCES",
  "NANDAN BANDAN MAHAVIDYALAYA",
  "SCPM COLLEGE OF PHARMACY",
  "SCPM COLLEGE OF NURSING",
  "B P SINGH LAW COLLEGE",
  "RAJARSHI RANANJAY SINH COLLEGE OF PHARMACY, AMETHI",
  "BABU BANARASI DAS INSTITUTE OF TECHNOLOGY, GHAZIABAD",
  "R.V.NORTHLAND INSTITUTE, DADRI, G.B.NAGAR",
  "G L  BAJAJ GROUP OF INSTITUTIONS,MATHURA",
  "Dev Kumari Raja Ram Pharmacy Shikshan Sansthan",
  "ICHCHHARAM SINGH MAHAVIDYALAYA DOBHIYARA SHAHGANJ",
  "Sunil Kumar Mahavidyalaya",
  "RAM VICHARE TRIPATHI MAHILA MAHAVIDYALAYA ASNA BODARWAR KUSHINAGAR",
  "Maa Bandhui Devraj Mahavidyalaya, Pashuhari, Ballia",
  "Maa Fula Devi Kanya Mahavidyalaya, Titauli (Baghuri) Ballia",
  "Maa Kalawati Devi Mahila Mahavidyalaya Khandawa Nagra Ballia",
  "Maa Kasturi Devi Mahavidyalaya Nawanagar, Ballia",
  "Maa Maturani Devi Mahavidyalaya, Chandadih, Ballia",
  "Mahatma Ratan Guljar Mahavidyalaya, Sarai, Bharti, Kop, Silhata, Ballia",
  "Mathura P.G. College Rasra,Ballia",
  "Md. Shahban Memorial Mahavidyalaya, Nagra, Ballia",
  "Meera Memorial Mahila Mahavidyalaya,Ballia",
  "Panna Mahavidyalaya, Kushhan, Bhimpura No.1, Ballia",
  "Prithwi Shiv Kishan Majdoor Balika P.G. College, Rasra, Ballia",
  "Pt. Shriniwas Mahavidyalaya, Nagra Ballia",
  "Radha Mohan Kishan Mazdoor Mahavidyalaya, Niyamatpur, Kanso, Ballia",
  "Government Model Degree College",
  "SWARGIYA RAMVILASH SINGH SHIKSHAN SANSTHA MAHILA MAHAVIDYALAYA",
  "PT SHIV SHARAN COLLEGE OF EDUCATION ",
  "BABU FATEH BAHADUR SINGH VIDHI MAHAVIDHYALAY ",
  "JD SINGH MAHAVIDYALAYA DURGAGANJ AUNG ",
  "SHRI BABBOO SINGH MAHAVIDYALAYA KHANNA MAHOBA",
  "Pro Deenanath Pandey Shiksha Evam Prakshishan Mahavidyalaya Badausa",
  "PRO DEENANATH PANDEY VIDHI MAHAVIDYALAY BADAUSA BANDA",
  "RAJEEV ACADEMY FOR PHARMACY, MATHURA",
  "Dayanand Deenanath College, Institute of Pharmacy, Kanpur",
  "MAHATMA GANDHI MISSION COLLEGE OF ENGINEERING AND TECHNOLOGY, NOIDA",
  "PRO DEENANATH PANDEY MAHAVIDYALAY BERRANV BANDA",
  "SRM Govt Ayurvedic College and Hospital",
  "KISHAN INSTITUTE OF INFORMATION TECHNOLOGY, MEERUT",
  "KCC INSTITUTE OF MANAGEMENT, GR.NOIDA",
  "Kite Law College",
  "Kashinath College of Higher Education, Bakikhurd",
  "GAUTAM BUDDHA COLLEGE OF PHARMACY",
  "AXIS INSTITUTE OF PHARMACY",
  "CHRIST CHURCH  COLLEGE, KANPUR",
  "BRAHMAVART P.G. COLLEGE, MANDHANA,",
  "SHANTI DEVI MAHAVIDHAYALAYA MAIN PURI",
  "DEVANSHU SAMAJ KALYAN SEWA VIDHI MAHAVIDYALAYA, SAURIKH,",
  "INSTITUTE OF COMPUTER BASTI",
  "RAHUL SANRITYAYAN COLLEGE OF PHARMACY",
  "APEX INSTITUTE OF PHARMACY",
  "I A M R COLLEGE",
  "GOVERNMENT MEDICAL COLLEGE BADAUN",
  "Sw. Chandrika Kisan Mahavidyalaya, Sainupur, Amghat, Bhawarkol, Ghazipur",
  "TRINITY INSTITUTE OF INNOVATIONS IN PROFESSIONAL STUDIES ",
  "MATA RAMDULARI RAMASHRAY SHIKSHAK PRASHIKSHAN SANSTHAN NAURANGABAD KHAJEPUR BAHARIABAD GHAZIPUR",
  "KRISHNA INSTITUTE OF SCIENCE",
  "KALAWATI DEVI SMARAK VIDHI MAHAVIDHYALAYA UTTAMNAGAR BADNAPUR BAHRAICH",
  "DULESHWARI SUKHDEV D S MEMORIAL GIRLS DEGREE COLLEGE RATSAR BALLIA",
  "RUPRANI MAHILA MAHAVIDYALAYA",
  "R G S COLLEGE OF PHARMACY",
  "SURSATI INDRADEV MAHILA MAHAVIDYALAYA HARSARPUR CHAUBEPUR GHAZIPUR",
  "S L R MAHAVIDHYALAYA RAMAIHAR MAINPURI",
  "PT VASUDEV TIWARI VIDHI MAHAVIDHYALY ",
  "ARYAKUL COLLEGE OF PHARMACY AND RESEARCH RAEBARELI",
  "K S DEGREE COLLEGE AURANDH MAINPURI",
  "NOIDA INTERNATIONAL INSTITUTE OF MEDICAL SCIENCES",
  "ECI MAHILA MAHAVIDHYALAY TAMSA MARG MIRJAPUR AKBARPUR AMBEDKARNAGAR",
  "SHRI RAM MURTI SMARAK  COLLEGE OF NURSING ",
  "CITY LAW COLLEGE",
  "SHRI KRISHNA RTS YADAV MAHAVIDYALAYA",
  "PT KAUSHAL KISHOR AWASTHI MAHAVIDHYALAYA BHARATPUR KAKHAWATOO AURAIYA",
  "SHRI SHIV RATAN SINGH MAHAVIDHLAYA BARMUPUR AURAIYA",
  "KRITIKA NURSING COLLEGE BAREILLY",
  "SARSWATI MAHILA MAHAVIDYALAYA NASIRPUR JALALABAD GHAZIPUR",
  "SHRI GAYA PRASAD SMRITI MAHAVIDYALAYA BUDHADANA KAKOR AURIYA",
  "R K SMARAK MAHILA MAHAVIDYALAYA NARIYAON AMBEDKAR NAGAR",
  "HEERALAL YADAV MEMORIAL TRUST OF EDUCATION",
  "NOVA EDUCATIONAL TRUST, LUCKNOW",
  "CHANDRA SHEKHAR SINGH AYURVEDA SANSTHAN",
  "VIDYAWATI MAHILA MAHAVIDYALAYA MANIYAREPUR CHANDWAK JAUNPUR",
  "SHRI  RAMMURTI SMARAK BUSSINESS SCHOOL ASHAKHEDA UNNAO",
  "SHYAMA BASANT MAHAVIDYALAYA MEERA REHATI DULLAHPUR GHAZIPUR",
  "BRAJLAL PANDEY MAHAVIDYALAYA BAIRIPUR RAMNATH MANKAPUR GONDA",
  "GAYA BAKHAS RAM LALI MAHAVIDYALAYA SANDWA PALIYA HAIDERGARH BARABANKI",
  "INSTITUTE OF MANAGEMENT STUDIES, NH-24, ADHYATMIK NAGAR, NEAR GURUKUL SCHOOL, DASNA (GHAZIABAD)",
  "MAA SHARDA MAHILA MAHAVIDYALAYA MUSANDI ROAD KALUKHERA KANCHANPUR UNNAO",
  "SHRI RAM GROUP OF COLLEGES,MUZAFFARNAGAR.",
  "Gandhi Mahavidyalaya, Mirdha, Beruarbari, Ballia",
  "SRI BALBHADRA RAJRANG VIDHI MAHAVIDYALAY KHAPTIHA SAIDABAD PRAYAGRAJ",
  "GYAN SMARAK MAHILA MAHAVIDYALAYA ALMAPUR AMARTAL AMBEDKARNAGAR",
  "NITRA TECHNICAL CAMPUS, GHAZIABAD",
  "KRISHNA INSTITUTE OF MANAGEMENT, BANA, MAWANA ROAD, MEERUT",
  "KALKA INSTITUTE FOR RESEARCH AND ADVANCED STUDIES, MEERUT",
  "BHAGWANT INSTITUTE OF PHARMACY, MUZAFFARNAGAR",
  "B.B.S. INSTITUTE OF PHARMACUTICAL AND ALLIED SCIENCE, GREATER NOIDA",
  "RAJ MAHILA MAHAVIDYALAYA MIRZAPUR",
  "MILLENNIUM INSTITUTE OF TECHNOLOGY, , MUZAFFARABAD, SAHARANPUR",
  "SRS MAHILA DEGREE COLLEGE VRINDAVAN MAHGAON RAJATALAB VARANASI ",
  "ALLENHOUSE INSTITUTE OF MANAGEMENT",
  "Dr. S. N. Dev Group of Colleges, Sikka Shamli",
  "INSTITUTE OF MANGEMENT AND SCIENCE, J P NAGAR",
  "BHAGWAN SHREE KRISHNA MAHILA MAHAVIDYALAY KANTA CHANDAULI ",
  "PRABHAWATI DEVI MEMORIAL COLLEGE OF EDUCATION AND TRAINING ANIRUDHPUR PURABPATTI MIRZAPUR",
  "PT. AVADH VIHARI RAJPATI MAHAVIDHYALAYA, DHIKUHI, KHEMIPUR, KUNDA",
  "SHRI BABU SINGH DADDU JI AYURVEDIC MEDICAL COLLEGE & HOSPITAL, KRISHNA NAGAR BAGHAR KANPUR ROAD, FATEHGARH FARRUKHABAD (U.P.)",
  "INDRADEV RAI MEMORIAL MAHILA MAHAVIDYALAY SALEMGARH SEORAHI KUSHINAGAR",
  "SURAJBHAN SHIVBALAK RAM MAHAVIDHYALAYA BARGARH CHITRAKOOT",
  "ACCURATE BUSINESS SCHOOL GREATER NOIDA",
  "ANANT BALIKA MAHAVIDYALAY BARESTA KHURD PRATAPPUR PRAYAGRAJ UP",
  "RAM NAYAN VERMA COLLEGE OF LAW MANGRAWAN KADIPUR SULTANPUR",
  "SARASWATI MAHILA MAHAVIDYALAYA CHHATARI JALALPUR KERAKAT JAUNPUR",
  "PT RAJENDRA PRASAD SMARAK MAHAVIDYALAYA",
  "ISHRAWATI DEVI MAHAVIDYALAYA ORWRA BASTI",
  "INDRARAJ MAHILA MAHAVIDYALAYA",
  "R S MEMORIAL PRASHIKSHAN SHANSTHAN LALMANPUR AMBEDKAR NAGAR",
  "BABU HARBANSH BAHADUR SINGH TEACHERS TRAINING COLLEGE JAGDISHPUR KATARI VARANASI ",
  "MAA DURGA MAHAVIDHYALAYA MAHILA KAJRINOORPUR NIGOHI SHAHJAHANPUR",
  "LALIT HARI RAJKEEYA AYURVEDIC COLLEGE,",
  "DEV NURSING COLLEGE",
  "SRIMATI CHANDRAWATI CHAUDHARY MAHILA MAHAVIDYALAY PHULWARIYA SANT KABIR NAGAR",
  "MILESTONE INSTITUTE OF LAW MEERUT ROAD MORTA GHAZIABAD",
  "RAJKEEYA MAHAVIDYALA  BILOHA GASADI",
  "LALSA INSTITUTE OF EDUCATION RAIPUR GHAZIPUR",
  "RAGHAV MAHAVIDYALAYA RAIPUR MUNGRABADSHAHPUR JAUNPUR",
  "SAINATH COLLEGE OF PHARMACY",
  "MAHARSHI DAYANAND SARASWATI LAW COLLEGE BHADASNA",
  "PRIDE COLLEGE OF LAW,AMARPUR BHARIWAR,SHANKARGARH,PRAYAGRAJ,UTTAR PRADESH",
  "Venkatesh Parankush Sanskrit Mahavidyalaya, Assi",
  "Shri Radha Krishna Sanskrit Mahavidyalaya, Rajamau Bachharanwa",
  "SATGURU DEGREE COLLEGE, DHANIKHERA,",
  "P.D. MAHILA DEGREE COLLEGE, FATEHGARH,",
  "RAGHURAJA RAMGOPAL MAHILA MAHAVIDYALAYA, SUMERPUR,",
  "GANDHI MAHAVIDYALAYA, ORAI",
  "University Polytechnic, Shahjahanpur",
  "RAMPAL SINGH MAHAVIDYALAYA, CHANDAK",
  "INSTITUTE OF MANAGEMENT & SCIENCE, GAJRAULA",
  "MAYA SHAMSI DEGREE COLLEGE, BIJNOR ROAD",
  "LANDMARK INSTITUTE OF MANAGEMENT & TECHNOLOGY, DIDAULI",
  "KEVLANAND B.ED. COLLEGE, DARANAGAR GANJ",
  "BHAGWANT SINGH INST. OF PROFESSIONAL STUDIES, THAKURDWARA",
  "YASHIKA KANYA DEGREE COLLEGE, MANPUR",
  "AMBALIKA INSTITUTE OF HIGHER EDUCATION",
  "SHREE SATYA COLLEGE OF HIGHER EDUCATION, LODHIPUR RAJPUT",
  "Hariram Satyanarayan Institute of Higher Education, Islam Nagar",
  "NATIONAL CAPITAL REGION INSTITUTE OF MEDICAL SCIENCES, MEERUT",
  "RHM COLLEGE OF HIGHER EDUCATION HARSAINPUR SIRASKHEDA ",
  "BRIJ LAL VERMA MEMORIAL MAHAVIDYALAYA RAILWAY STATION SARSAUL FUFUWAR KANPUR NAGAR",
  "PANDIT DEENDAYAL UPADHAYAY RAJKIYA MAHILA MAHAVIDYALAYS",
  "DR. M.C. SAXENA COLLEGE OF EDUCAITON, DUBAGGA",
  "ADHARRSHILA INSTITUTE OF TECHNOLOGY",
  "SHRI LAL BAHADUR VERMA EDUCATIONAL INSTITUTE CHANDPUR  JAIDPUR  BARABANKI ",
  "AVADH COLLEGE OF PHARMACY NINDURA FATEHPUR BARABANKI",
  "SUMITRA INSTITUTE OF NURSING AND PARA MEDICAL SCIENCES",
  "KUNWAR KANCHAN SINGH MAHAVIDYALAYA  NARAULI SAMBHAL",
  "FATIMA GIRLS DEGREE COLLEGE",
  "UNIVERSAL DEGREE COLLEGE ",
  "NAJIBABAD DEGREE COLLEGE",
  "BAIJANTI DEVI MAHAVIDHYALAYA GRAM SONDHA BARKHEDA KALAN PILIBHIT",
  "ABDUL RAZZAQ OF LAW COLLEGE AMROHA",
  "SWARN ACADEMY FOR FUTURE EDUCATION",
  "V D M COLLEGE OF MANAGEMENT",
  "PT AMAN SINGH JK COLLEGE OF EDUCATION",
  "SHRI GANPATI MAHAVIDYALAYA SALAHPUR KADIPUR SULTANPUR",
  "AMARNATH SONA DEVI MAHAVIDYALAYA BHAWANIPUR TARAON GHAZIPUR",
  "GANGA SAGAR SINGH MAHAVIDYALAYA",
  "SHRI CHINTAMANI SMARAK LAW COLLEGE KATRA PHOOL KUNWAR AMETHI",
  "ENGINEER RSV MAHAVIDYALAYA SAFDARGANJ BARABANKI",
  "THAKUR RAGHUVEER SINGH EDUCATION COLLEGE",
  "NOVA COLLEGE OF PHARMACY  BHAISURA GOMTI NAGAR EXT LUCKNOW",
  "LPM COLLEGE  OF PHARMACY",
  "INSTITUTE OF COOPERATIVE AND CORPORATE MANAGEMENT RESEARCH AND TRAINING",
  "LATE MUNEER AHMAD BALIKA MAHAVIDYALAYA KHARGUPUR GONDA",
  "RUDRA COLLEGE OF PHARMACY",
  "K P SINGH VIDHI MAHAVIDYALAYA MAKARA LAHANGPUR JAUNPUR",
  "DR ATAR SINGH KAILASH KUMARI VIDHI MAHAVIDYALAYA TATIYAGANJ KANPUR NAGAR",
  "RANJEET SINGH MAHAVIDYALAYA, ETAWAH",
  "JAY BAJRANG LAW COLLEGE MUNGRA BADSHAHPUR JAUNPUR",
  "FACULTY OF PHARMACY JS UNIVERSITY",
  "DEWA MAHILA MAHAVIDYALAYA",
  "CHIT BAHAL ATULANJANEY MAHILA MAHAVIDYALAY PURANPUR ETAURI BUJURG  AMBEDKAR NAGAR",
  "VANDANA INSTITUTE OF PHARMACY",
  "THYUGRAJ SINGH PHARMACY COLLEGE ",
  "GANESH PRASAD SHAILESH KUMAR MAHAVIDYALAYA SATRIKH BARABANKI",
  "LALA MAHADEV PRASAD VERMA BALIKA MAHAVIDYALAYA",
  "SHRI VISHWANATH P G COLLEGE, KALAN, SULTANPUR",
  "SATYADEV DEGREE COLLEGE, GADHIIPURAM (BORSIYA) FADANPUR ",
  "Abhay Narayan Singh Memorial Degree College Kundesar, Ghazipur",
  "S S C ARYA BALIKA DEGREE COLLEGE",
  "Netaji Subhash Chandra Bose Govt Girls PG College Aliganj",
  "NARVDESHWAR LAW COLLEGE, MALHAUR ROAD, CHINHAT",
  "LUCKNOW PUBLIC COLLEGE OF PROFESSIONAL STUDIES",
  "G S R M MEMORIAL DEGREE COLLEGE, SAROJANI NAGAR, KANPUR ROAD,",
  "Srimat Paramhans Sanskrit Mahavidyalaya, Tikarmafi",
  "Maa Prema Mahila Mahavidyalay, Ghazipur",
  "GAUTAM BUDH DEGREE COLLEGE, GAURI GANJ, BIJNOR",
  "CHARAK INSTITUTE OF EDUCATION, CHOWK",
  "CHANDRA BHANU GUPT KRISHI MAHAVIDYALAYA, BAKSHI KA TALAB",
  "CAREER COLLEGE OF MANAGEMENT & EDUCATION, VIKAS NAGAR",
  "SRI AGRASEN MAHAVIDYALAYA, MAURANIPUR, JHANSI",
  "Lodi Singh Dwarika Singh Kaushik Mahavidyalay , Ghazipur",
  "SRI CHHAVI NATH SINGH MAHAVIDYALAYA, MOHHAMADABAD, FARRUKHABAD",
  "A K G COLLEGE BIKAMAU, BAKSHI KA TALAB",
  "Shri Krishna Sudama Sansthan, Bhandahakala, Kaithi",
  "Ganji Prasad Mahavidyalaya, Dihwa, Mugalsarai, Chandauli",
  "Rajkiya Mahavidyalaya, Naugarh, Chandauli",
  "RAMA CONVENT MAHAVIDYALAYA HANUMANTPUR, B.K.T.",
  "Radha Krishna Ramnaresh  Mahavidyalaya, Salempur Baghain, Ghazipur",
  "DREAMS COLLEGE OF PHARMACY",
  "VIRK SIROHI SADHBHAWANA MAHAVIDHYALAYA",
  "T M S PHARMACY COLLEGE JAUNPUR",
  "BHAILA DEGREE COLLEGE BHAILA, SAHARANPUR",
  "VEERANGNA AVANTIBAI MAHAVIDYALAYA,KAHILIYA, HARDOI RD",
  "C.N.S.GIRLS DEGREE COLLEGE",
  "SUNDAR LAL RAMA COLLEGE OF NURSING",
  "RADHA KRISHNA MAHAVIDYALAYA, SAMBHAL ",
  "R R MAHAVIDYALAYA, SEMPUR UMARDA",
  "PUJYA BHAURAO DEVRAS MAHAVIDYALAYA, MUKTAPUR,",
  "ABHAIVEER SMRATI MAHAVIDYALAYA, UDI,",
  "RADIANT COLLEGE OF LAW",
  "S K V EDUCATION",
  "PT  SANT PRASAD PATHAK  MAHILA MAHAVIDYALAYA DEVALAPAR GOLA GORAKHPUR ",
  "JK MODERN LAW COLLEGE DHAMPUR",
  "SHYAM BIHARI SINGH SHIKSHAN SANSTHAN SINGWAN PURSHOTTAM PATTI BHITI AMBEDKAR NAGAR",
  "JAYPRABHA CHANDRASHEKHAR MAHAVIDYALAYA JAYPRAKASH NAGAR BALLIA",
  "SHRI VISHAMBHAR DAYAL TRIPATHI RAJKIYA MAHAVIDAYALA GANJ MURADABAD UNNAO",
  "SWAMI RAMDEV GURUKUL MAHAVIDYALAYA ARHANPUR SHAHGANJ JAUNPUR",
  "VARNIKA DEGREE COLLEGE NOORPUR HATTI ",
  "KHAKI BABA SIDDHARTH MAHAVIDYALAYA,GHAZIPUR",
  "SMT. FOOLMATI DEVI KANYA MAHAVIDHYALAYA BICHPURI SADABAD ROAD RAYA MATHURA",
  "SHRI BHOLA SHANKAR MAHILA MAHA VIDHYALYA",
  "D.P.EDUCATIONAL INSTITUTE CHAUMUHAN,MATHURA",
  "A.M. COLLEGE OF LAW CHHATA MATHURA",
  "J.S. MEMORIAL MAHAVIDHYALAYA",
  "CH. RAGHUWAR DAYAL MAHAVIIDHAYALAYA, SHIKOHABAD DISTT FIROZABAD ",
  "SUMAN PRAKASH MAHAVIDHYALAY NAGLA KISHAN SINGH PUL KHADIT",
  "global girls college",
  "SARASWATI DEVI MAHILA MAHA VIDYALAYA, TIKULHIYA, MAHARAJGANJ",
  "RAM BHAROSE MAIKULAL MAHAVIDYALAYA TELIBAGH LUCKNOW",
  "REENA VERMA MAHAVIDYALAYA BAGHMARA LAKHIMPUR KHERI",
  "DR. OM PRAKASH INSTITUTE OF MANAGEMENT & TECH.,",
  "M.A.R. INSTITUTE  ETAH ROAD SHIKOHABAD",
  "AADINATH COLLEGE OF EDUCATION, MAHARRA, LALITPUR",
  "KESHAV RAM MAHAVIDYALAYA, KOTA, DALA, SONBHADRA",
  "Dr keshav giri college of law",
  "BABA AWATAR SINGH JI NIRANKARI MAHAVIDYALAYA, SISWAN SOHNARIYA, DEORIA",
  "HOTI LAL INSTITUTE OF EDUCATION BAS BODIYA ETMADPUR AGRA",
  "DR. RAM MANOHAR LOHIYA MAHAVIDHYALAYA, DILAHI, KHAIRAHI",
  "K L ADARSH MAHAVIDYALAYA MAUDAHA",
  "AMRITLAL MAHAVIDYALAY USKA BAZAR SIDDHARTH NAGAR",
  "BABU BASANT LAL MAHAVIDYALAYA ALLAHABAD",
  "SMT. JAYPATTI SMARAK MAHAVIDYALAYA, UPARHAR, LOHARI,",
  "RENU MAHESH SEWA SANSTHA ILASIA GRANT SITAPUR",
  "BHAGIRATHI YADAV MAHAVIDYALAYA HANDIA ALLAHABAD",
  "PT RAMRAJ MISHRA MAHAVIDYALAYA TENDUA SHUKUL BAZAR DISTT AMETHI",
  "harishchandra chaudhari mahavidyalay",
  "sri ram degree college",
  "RAJDEVI SINGH VIDHI MAHAVIDYALAYA MAULABAKIPUR HASANGANJ UNNAO",
  "KAMAL KAILASH TECHERS TRENING INSTITUTE AKMA KUMARGANJ AYODHYA",
  "Shri Doodhnath Shukla Sanskrit Mahavidyalaya, Sahijedpur, Barhata",
  "S P KANAUJIYA MAHAVIDYALAYA NANAMAU SURSA HARDOI",
  "AL KABIR DEGREE COLLEGE ",
  "SUKHRAJ SINGH BALIKA MAHAVIDHYALAYA  SAPAHA CHHAT ASPUR DEVSARA PATTI PRATAPGARH",
  "BABU DURGA PRASAD MISHRA MAHAVIDYALAYA BAHIRADEEHA CHHAPIYA GONDA",
  "RAJARAM MAHAVIDYALAY  BHARAHARI CHOPAN SONBHADRA",
  "SRI RAMENDRA SINGH SUMAN LATA MAHAVIDYALAYA",
  "PT RAM ADHIN DIXIT EDUCATIONAL TRAINING INSTITUTE",
  "VIJAY KUMAR ARUNDHATA DEVI MAHAVIDHAYALAY SOHAWAL PIPARPATI PARTAWAL MAHARAJGANJ",
  "Swami Shukdevanand Law College",
  "RAMNATH DEGREE COLLEGE KARGUWAN KHURD JHANSI",
  "PT R P BALIKA MAHAVIDYALAYA, TAHROULI, JHANSI",
  "Narain Ucch Shiksha Sansthan (Law college ), Jhalwa, Allahabad",
  "Aqla Hasan College of Teacher Training Education, Saraipeer, Bhelsar, Faizabad",
  "BHAGWANDAS  SARWESHWARI MAHAVIDYALAY DHAUKHARIYA KANDHAIPUR RAMNAGAR BARABANKI",
  "M.S MAHAVIDYALAYA BAKHTIYARPUR BASREHAR ETAWAH",
  "PUSHPA KHARWAR MAHILA MAHA VIDYALAYA KASMIRIYA TANDA AMBEDKAR NAGAR",
  "GOVERNMENT GIRLS DEGREE COLLEGE KURAWALI",
  "ADARSH MAHAVIDYALAYA , SALKHAN , SONBHADRA",
  "Metro College of Health Sciences AND Research",
  "Shri RamSwaroop Singh Mahavidyalya",
  "Government Post Graduate  College , Obra, Sonebhadra",
  "HINDU MAHILA  MAHAVIDYALAYA SHAMALI, MUZAFFARNAGAR",
  "VASUDEV RAM KRISHNA MISHRA  MAHAVIDYALAYA UMARIA BADAL URF GAINDA SORAON PRAYAGRAJ",
  "DON BOSCO DEGREE COLLEGE ",
  "Vasanta College for Women, Rajghat",
  "UNIVERSAL PUBLIC GIRLS SCHOOL, VISHUNPUR KOLAPATTI FARIHA NIZAMABAD AZAMGARH",
  "SHARDA OM JI LAW COLLEGE, KADEREPUR, BADLAPUR, JAUNPUR",
  "GOVERNMENT DEGREE COLLEGE, KASGANJ,",
  "DR.ISLAM MAZID DEGREE.COLLEGE,BHARGAIN, KASGANJ",
  "SIR M.U. DEGREE COLLEGE",
  "Warner School of Food & Dairy Technology",
  "HARDAYAL SINGH MAHAVIDYALAYA, PAHADPURA, SAMTHAR, JHANSI",
  "Vaugh School of Agricultural Engineering & Technology",
  "SRI SHARDA INSTITUTE OF PROFESSIONAL STUDIES",
  "ISABELLA THOBURN COLLEGE",
  "Government Degree College, Hansaor, Barabanki",
  "C.C.R.D. College, Muzaffarnagar Mob.No.9412637436 0131-2621744",
  "SIRATUL MUSTAKEEM DEGREE COLLEGE HANEEF NAGAR LOLEPUR SULTANPUR",
  "Sunderasan School of Veterinary Science",
  "RAMESHWARAM PHARMACY COLLEGE",
  "CH BIJENDRA SINGH MAHAVIDYALAY",
  "H K K M MAHILA MAHAVIDYALAYA, JAITPUR MAHOBA",
  "Sudha Lal Womens College",
  "School of Forensic Science",
  "School of Film and Mass Communication",
  "SHIVMURTI RAMASHANKAR SHIKSHAK PRASHIKSHAN SANSTHAN SUNDERPUR PARASRAMPUR PRATAPGARH",
  "PRATIBHA UCCHA SHIKSHA SANTHAN ",
  "R R GUPTA SHIKSHAN PRASHIKSHAN SANSTHAN",
  "PARASNATH SHIKSHAN VA PRASHIKSHAN MAHAVIDYALAYA",
  "JAGPAT SINGH SMARAK VIDHI MAHAVIDYALAYA",
  "BENI MADHAV MAHAVIDYALAYA",
  "A N TIWARI VIDHI MAHAVIDYALAY SHIV MANGAL NAGAR GULALPUR HETAPATTI PRAYAGRAJ",
  "DIPANJALI VIDHI MAHAVIDYALAYA",
  "K P LAW COLLEGE KATHULA JHALWA PRAYAGRAJ ",
  "PATI SINGH LAW COLLEGE",
  "YAMUNA SINGH SHIKSHAN PRASHIKSHAN SANSTHAN MANGARH KUNDA PRTAPGARH UP ",
  "TALUKEDAR BABU RAMESH BAHADUR SINGH MAHAVIDYALAYA",
  "DOLPHIN MANAV SHIKSHAN SANSTHAN, CHEETPUR, DILIPPUR, PRATAPGARH",
  "LAW COLLEGE OF ALLAHABAD ",
  "GOKUL SINGH SMARAK MAHAVIDYALAYA SONAWA CHILBILA PRATAPGARH",
  "SHIVA DEGREE COLLEGE, MANAPUR, PRATAPGARH",
  "SMT. PANAU DEVI MAHAVIDYALAYA, KEWTALI, PATTI, PRATAPGARH",
  "SHARWOOD MAHAVIDHYALYA",
  "LLOYD LAW COLLEGE, GREATER NOIDA",
  "BALRAM KRISHAN ACADEMY, BEHIND SAINT PETERS CHURCH, MOHANLALGANJ, LUCKNOW",
  "BABA SHOBHA MANI SANSKRIT MAHAVIDYALY CHERO BARATHI",
  "PARSHURAM SANSKRIT MAHAVIDYALAY",
  "GEETA DEGREE COLLEGE",
  "BHAGWAN BAKSH SINGH DEGREE COLLEGE ",
  "MAHARANA PRATAP COLLEGE OF MANAGEMENT AND COMMERCE ",
  "MAA VAISHNO DEVI DEGREE COLLEGE",
  "MEERUT INST. OF ENGINEERING & TECHNOLOGY BAGHPAT CROSSING, PARTAPUR BY PASS, MEERUT Ph. No :- 0121-2439019, 2439058",
  "Sant Parsottam Balika Mahavidyalaya, Baghol, Jangipur, Ghazipur",
  "School of Basic Science",
  "Joseph School of Business Studies",
  "Jacob School of Biotechnology & Bioengineering",
  "Shri Parmanand Manorama Devi Mahila Mahavidyalaya, Ibrahimpur Kalan, Gangauli, Ghazipur",
  "BABU VISHNU PRATAP SINGH SMARAK MAHAVIDYALAYA",
  "Grace Zamen School of Education",
  "Gospel & Plough School of Theology",
  "R.S.S. College,  Pilkhuwa (Pancheel Nagar) Mob.No.9818582683",
  "Christian School of Health Science",
  "INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "SAI INSTITUTE OF LAW COLLEGE",
  "K S COLLEGE OF EDUCATION",
  "ITS COLLEGE OF PROFESSIONAL STUDIES",
  "GOVT DEGREE COLLEGE SUMERPUR HAMIRPUR U P ",
  "SUKHDEV SINGH MAHAVIDYALYA",
  "Bhagwandin Sanvari Devi Mahavidyalaya, Jalalpur, Nevari, Fatehpur",
  "Bahan Mayawati Mahavidyalaya, Chaukari, Chaura , Ghazipur",
  "IMIRC COLLEGE BHAINA GARHMUKTESHWAR HAPUR",
  "SHRI KRISHNA MAHAVIDYALAYA AMILO DEEHA KARCHHANA ALLAHABAD",
  "SW. RAM PRASAD YADAV MAHAVIDYALAYA, SINDHAV,",
  "SRI JAGDAMBA PRASAD MAHILA MAHAVIDYALAYA,",
  "SRI BABU SINGH COLLEGE OF LAW, SAYARA, SIRATHU,",
  "SMT. VIMLA RANI BHARGAVA BALIKA MAHAVIDYALAYA, TEWA, MANJHANPUR,",
  "SMT. MULA DEVI RAMDAS MAHAVIDYALAYA, BADDU KA PURA, BYUR, HANDIA,",
  "PT RAMKRIPAL DIXIT LAW COLLEGE",
  "RAM SAJIWAN SINGH VIDHI MAHAVIDYALAYA, JAYANTIPUR,",
  "LAL BAHADUR SASHTRI AYURVEDIC COLLEGE, HANDIA,",
  "B.P.D. MAHAVIDYALAYA & PRASHIKSAHN SANSTHAN, SIRATHU,",
  "ASHOK TIWARI EDILPURI DEGREE COLLEGE, SARAI AQUIL,",
  "VISWANATH PRASAD MAHAVIDYALAYA BHIKHANPUR MURATGANJ, KAUSHAMBI",
  "SW. SRI B.R.M. YADAV MAHILA MAHAVIDYALAYA, DAMGARA, HANDIYA",
  "SW. DHANRAJ SINGH MAHAVIDYALAYA, MAHJANA, DHANUPUR,",
  "STATE UNANI MEDICAL COLLEGE,",
  "SHRI RAMSWAROOP MEMORIAL COLLEGE OF ENGINEERING AND MANAGEMENT, LUCKNOW",
  "Amity University Uttar Pradesh Lucknow Campus",
  "Ramjanm Saraswati Smarak Mahavidyalaya Molnapur Sarai Dhanesh Jakhaniya Ghazipur",
  "D K Girls College Rasulpur Pachrasi Devkali Ghazipur",
  "Rajnath Memorial Mahavidyalaya Bhitari Ghazipur",
  "RAMKALI MAHILA MAHAVIDYALAYA DARAULI",
  "CH Sughar Singh Pharmacy College",
  "SHRI KHANDESWARI SWAMI MAHILA SHIKSHAN SANSTHAN ",
  "A K National Girls Degree College, Mathkauriya, Sauna, Ghazipur",
  "UDAY PRATAP SINGH MAHAVIDYALAYA, GAUR, MIRZAMURAD, VARANASI",
  "RAJKIYA MAHAVIDYALAYA, MADHUBAN, MAU",
  "SRI KRISHNA SHIKHA SANSTHAN,GHATAMPUR",
  "KAMAKHYA MAHILA MAHAVIDYALAYA DERHGAWAN GHAZIPUR",
  "SHRI RAM CHARITTAR MAHILA MAHAVIDYALAY PAUNI SOHANI KERAKAT JAUNPUR",
  "SHRI BADRINATH MAHILA MAHAVIDYALAYA MEDANIPUR SIKANDARPUR GHAZIPUR",
  "MUSAFIR MAHAVIDYALAYA ATARIYA DHARAMMARPUR GHAZIPUR",
  "LATE RAMDEV CHAUDHARI ADARH MAHAVIDYALAYA ZAMANIYA GHAZIPUR",
  "RAM NATH MUNSHI MAHILA MAHAVIDYALAYA SADAT GHAZIPUR",
  "SHRI VISHWANATH UPADHYAY SANSKRIT MAHAVIDYALAY MANHARI",
  "JAI NARAYAN COLLEGE OF LAW, SEHRA, KARCHHANA, PRAYAGRAJ",
  "J.S.. ACADEMY FOR GIRLS POCKET-D, PALLAVPURAM, MEERUT",
  "MODERN DEGREE COLLEGE,  MEERUT ROAD, DUHAI, GHZIABAD",
  "RAJKEEYA MAHAVIDYALAYA PADIYAPAR, JAISWALI, DEORIA",
  "SHATABADI INSTITUTE OF EDUCATION MOHIDDINPUR, DELHI ROAD, MEERUT Ph. No. :- 9412202763,  2762236,  2440417",
  "LATE RAVINDRANAND BARONIA LAW COLLEGE",
  "BABA GOVARDHAN NATH MAHAVIDYALAYA CHARKHARI MAHOBA UTTAR PRADESH",
  "JMS LAW COLLEGE",
  "STATE L.B.S HOMEO MEDICAL COLLEGE, ALLAHABAD",
  "SHRI RAM SINGH PREMLATA KANYA DEGREE COLLEGE, RATANPUR, KASARKALA, BULANDSHAHR",
  "INNOVATIVE INSTITUTE OF LAW PLAT NO. 6, KNOWLEDGE PARK-2, GREATER NOIDA",
  "B.L. ACADEMY OF HIGHER EDUCATION LAWAN,  MEERUT",
  "SCHOOL OF BUSINESS MANAGEMENT AND TECHNOLOGY  KHURJA ROAD, BULANDSHAHR",
  "S.S EDUCATIONAL INSTITUTE GAMARI,MALAPURA AGRA",
  "MAHALAXMI DEGEE COLLEGE NANGLI ESA, MAWANA ROAD, MEERUT",
  "Suraj Gyan Mahavidyalaya",
  "RADHA GOVIND COLLEGE OF EDUCATION GREATER NOIDA (GAUTAMBUDH NARAG)",
  "SHRI LALA RAM SHARMA COLLEGE OF LAW JARARA KHAIR ALIGARH",
  "D.J.College, Baraut (Baghpat) Ph.No.01234-262130",
  "VISION INSTITUTE OF SCIENCE AND MANAGEMENT",
  "DEWAN LAW COLLEGE PARTAPUR, BYE PASS ROAD, MEERUT",
  "SARASWATI SINGH MAHILA MAHAVIDYALAYA MAIRIYA PAREVPUR SHRAVASTI",
  "DR SUNITA NURSING AND PARAMEDICAL COLLEGE",
  "S.N.MEDICAL COLLEGE, AGRA",
  "VIVEK COLLEGE OF EDUCATION SARA ROAD, GOVINDPURI, MODINAGAR, GHAZIABAD",
  "SHREE RAM LAW COLLEGE DHUMARI ETAH",
  "SATYAWATI DEVI LAW COLLEGE KHANDEHA ALIGARH",
  "LALLAN R TIWARI MAHAVIDYALAYA AWAM BED COLLEGE",
  "MAA KELA DEVI GIRLS COLLEGE, SIKRIKALAN, MODINAGAR, GHAZIABAD",
  "BANWARI DEVI ASHOK KUMAR INSTITUTE OF LAW SIRSIYA SHRAWSTI",
  "Ram Nagina Vindhy Mahavidhyalaya Majhauli Jharokalan Sonbhadra UP",
  "Rajeev Memorial Mahila Mahavidyalaya ",
  "K B A MAHILA MAHAVIDYALAYA",
  "SHAMSHUL QAMAR GIRLS DEGREE COLLEGE DIDAULI ",
  "SHRI RAMNATH YADAV SUBHAWATI DEVI MAHAVIDYALAY YADAVPUR TOTAHA SKN",
  "RAJALI DEVI MAHAVIDYALAY PARGAN MATHIYA KUSHINAGAR ",
  "MAHILA MAHAVIDHYALAYA",
  "SARSWATI DEVI WOMEN INSTITUTE OF HIGHER EDUCATION  MAUNAGARHWA DEORIA",
  "Chandrika Prasad Mahavidyalay",
  "Smt Savitri Devi Mahila Mahavidyalay  Dhanaha Jaura Bazar kushinagar ",
  "MAHARANI LAXMI BAAYE BALIKA MAHAVIDYALAY ",
  "Indoo devi Suurya Narayan Verma Shikshan Sansthan",
  "Shri Mateshwari Mahavidyalay Bardiha Parshuram Deoria",
  "SRI SAI RAM BED COLLEGE PHULPUR PRAYAGRAJ",
  "BADRIRAI MAHAVIDYALAYA DUBAULI LAKURINISFIRAI",
  "S S COLLEGE OF LAW ",
  "Pt Shri Shyam Vinda Prasad Sanskrit mahavidhyalay Mohiuddin Pur Coranw kaushambi",
  "GNIOT INSTITUTE OF MEDICAL SCIENCES AND RESEARCH",
  "ITS COLLEGE OF HEALTH AND WELLNESS SCIENCES, KNOWLEDGE PARK, GAUTAM BUDDHA NAGAR",
  "YASHRAJ INSTITUTE OF PROFESSIONAL STUDIES, TATIAGANJ, MANDHANA,",
  "COLLEGE OF NURSING, BABA EDUCATIONAL SOCIETY, CHINHAT",
  "SAHARA COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "Naurangi Devi Pannalal Shikshan Prashikshan Sansthan Pathatiyakala Pratapgarh ",
  "S S COLLEGE OF EDUCATION ",
  "SHARDA COLLEGE OF EDUCATION AND TECHNOLOGY",
  "GANPATI VIDYAPEETH EDUCATIONAL INSTITUTE",
  "FAKIRCHAND VIDYAPEETH EDUCATIONAL INSTITUTE",
  "RAM BRIKSH JEE MAHILA MAHAVIDYALAYA, GARER, DEORIA",
  "CAPTAN SINGH MEMORIAL EDUCATIONAL INSTITUTE AMBEDKARNAGAR",
  "NARENDRA PRATAP SINGH COLLEGE OF LAW CHANDPUR SAIDOPATTI SULTANPUR",
  "SHRI MOTILAL NISHAD SHANTI DEVI MAHAVIDYALAY SEMRAHANA MIHIPURWA BAHRAICH",
  "SHIV BALI SINGH GROUP OF EDUCATIONAL AND TRAINING INSTITUTE COLLEGE OF PHARMACY",
  "ABDUL SAMI MEMORIAL LAW COLLEGE KIRATPUR",
  "MARIYAM GIRLS COLLEGE OF HIGHER EDUCATION KIRATPUR",
  "GANGA SHYODAN SINGH KANYA MAHAVIDYALAYA, SAMBHAL",
  "M C S EDUCATIONAL INSTITUTE WAJIDPUR KHAIR ALIGARH ",
  "INTEGRATED SCHOOL OF EDUCATION, GHAZIABAD",
  "ADARSH MAHAVIDYALAYA HARIHAN KALAN REOTI BALLIA",
  "DR SWAMI RADHE CHAITANYA MAHAVIDYALAYA BILARA PATEHARA HALIYA MIRZAPUR",
  "SMS LAW COLLEGE KHUSHIPUR BACHHAON VARANASI",
  "SRI SARAJU SINGH SIKSHAN SANSTHAN ",
  "NAND KISHORE SINGH LAW COLLEGE ",
  "SRI HANUMAN MAHAVIDYALAYA REWARI BUJURG FATEHPUR ",
  "LATE RAJESHWARI SINGH GYANSTHALI MAHAVIDYALAY SONBARSA BELWAGHAT SISWA BAZAR MAHARAJGANJ",
  "BABA RAMDAWAR MAHILA MAHAVIDYALAYA NAISARA GHAZIPUR",
  "C J Y MAHAVIDYALAYA AMIHIT KERAKAT JAUNPUR",
  "Mahendra Singh Surendra Singh Dayashankar Memorial Mahavidyalaya, Titra Khalilpur, Konch, Jalaun - 285 205, U.P",
  "FORT INST. OF TECHNOLOGY GREEN PARK, MAWANA ROAD, MEERUT",
  "Ramkali Mahila Mahavidayalay",
  "pt ramswaroop upadhyay mahavidalya husenpurkalan girwan banda",
  "R R MAHAVIDYALAYA BAIJALPUR AMARGARH PRATRAPGARH",
  "Paras Nath Mahavidyalay Jungal Ghorath Kubersthan Kushinagar",
  "Sw Badelala Gupta Mahavidyalay",
  "GANDHI SIKSHA MAHAVIDHLAYA",
  "SHRI SAHUKAR SINGH AVAM SMT KALAWATI M V LILUIYA KANNAUJ",
  "SRI GOPAL MAHAVIDYLAYA MAHTOLI SIKANDRA KANPUR DEHAT ",
  "DR. RAM MANOHAR LOHIA INSTITUTE DELHI- MEERUT ROAD, SIKRI KALA, MODINAGAR (GZB.)",
  "CENTRAL SANSKRIT UNIVERSITY, GANGA NATH JHA CAMPUS, PRAYAGRAJ",
  "VIT COLLEGE OF EDUCATION JATOLI, KANKER KHERA, SARDHANA, MEERUT",
  "SMT DILAWARI DEVI KISAN KANYA PG COLLEGE, CHINGRAWATHI, BULANDSHSHAR,",
  "ASHOKA SCHOOL OF BUSINESS",
  "MILESTONE INSTITUTE OF PROFESSIONAL STUDIES  MORTA,GHAZIABAD",
  "VIDYA MANDIR SHIKSHAN SANSTHAN RAHMAT NAGAR MANIRAM GORAKHPUR",
  "BHARTIYA PHARMACY COLLEGE",
  "Dhirendra Mahila P.G. College, Karmajeetpur, Sundarpur, Varanasi",
  "SHRIGOPI CHAND COLLEGE OF PHARMACY, BAGHPAT",
  "SARASWATI COLLEGE OF PROFESSIONAL STUDIES 819, DASNA, 27, KM. STONE, NH-24, GHAZIABAD-HAPUR BYE PASS, GHAZIABAD",
  "Veer Abdul Hamid Smarak Mahavidyalaya, Fatehpur, Jhungia, Gorakhpur",
  "janta mahavidyalaya",
  "S G DEGREE BED PRASHIKSHAN KENDRA ",
  "SRI SHUKDEV PRASAD TRIPATHI SMARK SANSKRIT VIDYAPITH BHATHAHI KHURD ",
  "Divya Jyoti Ayurvedic Medical College and Hospital, Ajit Mahal, Niwari Road, Modinagar, Ghaziabad",
  "GURU RAGHUVAR PRASAD BAUDDH DEGREE COLLEGE",
  "Ch Harchand Singh College of Law",
  "DJ COLLEGE OF PHARMACY, GHAZIABAD",
  "SANKALP INSTITUTE OF LAW DUHAI, GHAZIABAD",
  "RAJKUMARI RAJDEV TRILOKI NATH MAHILA MAHAVIDYALAY JONHIYA BHITI RAWAT SAHJANWA GORAKHPUR",
  "SAS AYURVEDIC MEDICAL COLLEGE  AND HOSPITAL VARANASI",
  "PANDIT RAMAKANT TRIPATHI BALIKA SANSKRIT MAHAVIDYALAY",
  "PT AKHAND PRATAP NARAYAN COLLEGE OF EDUCATION MAINSIR KHALILABAD SANT KABIR NAGAR",
  "BABA RISHIDEV SINGH MAHAVIDHYALAYA ",
  "PRATHVIRAJ SINGH JANTA MAHAVIDHYALAYA KHADINI KANNAUJ",
  "swami sahajanand college of pharmacy",
  "YOUTH GIRLS DEGREE COLLEGE",
  "SANT GOPICHAND EDUCATION AND WELFARE SOCIETY",
  "G L BAJAJ INSTITUTE OF MANAGEMENT",
  "M D LAW COLLEGE BABARPUR, SIKANDRA, AGRA",
  "GREATER NOIDA COLLEGE",
  "MAA GAYATRI COLLEGE OF PHARMACY",
  "UNITED COLLEGE OF EDUCATION",
  "H R K MAHAVIDYALAYA TAND SAMOGARA MIRZAPUR",
  "KRISHNARPIT INSTITUTE OF LAW",
  "B R K RAGHAW VIDHI MAHAVIDYALAYA SEMADARI DHANGHATA",
  "GAYA PRASAD DWIVEDI MAHAVIDYALAYA SAKHWAT PREM KA PURA JAUNPUR",
  "N.A.S. College Meerut Ph. No.0121-2642153 Mob. 9358405381",
  "INSTITUTE OF LAW & ACADEMIC STUDIES, KALYANPUR GARH, HAPUR",
  "KATYAYANI COLLEGE OF EDUCATION BADRUDEEN NAGAR, VILLAGE+POST-NANU, SARDHANA ROAD, MEERUT PHONE-9557928869",
  "JANTA MAHAVIDYALAYA EVAM PRASHIKSHAN SANSTHAN AMDAHI GONDA",
  "VEER KUNWAR COLLEGE OF LAW BIJNOR",
  "SAMANYU WOMANS COLLEGE",
  "KRISHNA SUDAMA SANSATHAN  BHANDAHA KALA KATHI VARANASI",
  "PRATAP COLLEGE OF HIGHER EDUCATION SINDHAV FATEHPUR",
  "INSTITUTE OF LAW AND SOCIAL SCIENCE",
  "SUMEDHA VIDHI MAHAVIDYALAY",
  "INTEGRATED SCHOOL OF LAW ,  GHAZIABAD",
  "SYADWAD INSTITUTE OF HIGHER EDUCATION AND RESEARCH, KHASARA NO.1414, BANGER BAGPAT, MAIN DELHI-SAHARANPUR ROAD, NEAR-BIKANER RESTAURANT, BAGPAT",
  "INSTITUTE OF PROFESSIONAL EXCELLENCE AND MANAGEMENT. GHAZIABAD,",
  "Arya Kanya Pathshala Degree College, Hapur (Pancheel Nagar) Ph.No.0122-2313564",
  "N.R.E.C. College Khurja (Bulandshahr)",
  "PSIT  PRANVEER SINGH INSTITUTE OF TECHNOLOGY PHARMACY",
  "VEDANT COLLEGE OF EDUCATION, SYANA ROAD, HAPUR",
  "ISHAN INSTITUTE OF LAW",
  "D.J.B.V. COLLEGE OF EUDCATION FOR WOMEN KHEKRA, BAGHPAT",
  "Rani Shanti Devi Social Welfare and Educational College",
  "Shri Vinayak College of Law Mavikalan Baghpat",
  "MAA SHARDA VIDHYAPEETH, VILLAGE SEHRA, BULANDSHAHR",
  "Mariampur College of Nursing ",
  "DEEP INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "Shahid Mangal Pandey Government Mahila Mahavidyalaya, Meerut Mob. No.9412456314",
  "SRI RAM JANKI EDUCATIONAL COLLEGE, VILL. RAM NAGAR, POST  AMAWASUFI, DISTT  FAIZABAD (U.P.)",
  "AMAN INSTITUTE OF MANAGEMENT & EDUCATION 65, DUHAI, DELHI-MEERUT ROAD, GHAZIABAD",
  "BHARTI VIDYAPEETH RALICHAUHAN, KILA ROAD, MEERUT",
  "ANGOORI DEVI COLLEGE OF LAW EDUCATION LAKHWATI, BULANDSHAHR",
  "COSMOS COLLEGE OF EDUCATION VILLAGE-MOHIYAPUR, TAJ EXPRESS HIGHWAY, NOIDA, Ph. 2616066, 2251254",
  "MAA AMBA BALIKA DEGREE COLLEGE GOWLIKHERA, BAGHPAT",
  "NOBEL COLLEGE OF PROFFESIONAL  STUDIES GARH ROAD, MEERUT",
  "PARAMOUNT INSTITUTE OF EDUCATION & TECHNOLOGY, TATIRI (BAGHPAT) Mob. 9997778604, 9837156120",
  "INDO UNIVERSAL COLLEGE OF MGMT & TECHNOLOGY, CHACHAPUR, BABULI, BAGHPAT",
  "RAMRANI VISHWANATH SINGH BALIKA MAHAVIDYALAYA RASALKHERA HAFIZABAD ",
  "KANCHAN SINGH MAHAVIDYALAYA, BANIPARA MAHARAJ, KANPUR DEHAT",
  "JAMUNA DEVI PHOOL KUNWARI BALIKA MAHAVIDYALAYA UMESH NAGAR CHAK HANUMAN UNNAO",
  "Satyam Institute of Education Technology",
  "NOIDA INSTITUTE OF EDUCATION & TECHNOLOGY C/o NOIDA PUBLIC SECONDARY SCHOOL, A-78, SECTOR-23, NOIDA (G.B.NAGAR) Ph. No. :-  2413081, 2413082",
  "MOTHER TERESA NURSING COLLEGE",
  "CHANDER SINGH GIRLS DEGREE COLLEGE GARHI DULLA BAGHPAT",
  "KANCHAN DEVI AKHILESH MISHRA MAHAVIDYALAYA RASOOLABAD UNNAO",
  "ANJANA COLLEGE",
  "Late Keshw Prasad Mahavidyalaya, Sasna, Bahadurpur, Belthra Road, Ballia",
  "I.T.S. DENTAL COLLEGE HOSPITAL & RESEARCH CENTER, PLOT NO.47, KNOWLEDGE PARK-III GREATAR NOIDA (GAUTAM BUDH NAGAR) Ph. No.0120-2481609, 2323701, 09810908898, 09899327547",
  "Late. Balram Singh Smarak Mahavidyalaya, Dighargarh, Ballia",
  "RUDRA INSTITUTE OF TECHNOLOGY, NANPUR, HAPUR",
  "SSR LAW COLLEGE",
  "Lalit Krishna Women Institute Of Higher Education , Indarpur, Ballia",
  "IIF COLLEGE OF COMMERCE AND MANAGEMENT STUDIES",
  "Kawleshwar Rai Mahila Mahavidyalaya, Bahuara, Ballia",
  "SHREE MAHENDRA NATH MAHAVIDYALAY ,JIGINIYAN HARDOI",
  "Kanhaiya Smarak Mhavidyalaya, Ballia",
  "Kamala Devi Bajoria Mahavidyalaya, Dubhar, Ballia",
  "J J GYAN GIRLS COLLEGE",
  "KEVALA DALTHAMMAN MAHILA MAHAVIDYALAY ",
  "Janta Mahavidyalaya, Nagra, Ballia",
  "Jai Mauni Baba Deva Girdhari Mahavidyalaya, Rohna, Rasra, Ballia",
  "Jai Mata Dulhmi Tribhuwan Mahavidyalay, Chogra, Ballia",
  "Ishteyak Ahmad Memorial Mahavidyalaya, Piprauli, Baragaon, Ballia",
  "IIF BUSINESS SCHOOL",
  "Heeranand Mahavidyalaya, Narayanpur, Rasulpur, Rasra, Ballia",
  "ST XAVIERS DEGREE COLLEGE",
  "Harishankar Prasad Vidhi Mahavidyalaya, Dharmsthali, Chitbaragaon, Ballia",
  "ROOTS INSTITUTE OF PROFESSIONAL EDUCATION",
  "GULSHAN SINGH MEMORIAL COLLEGE OF LAW ",
  "GULAB DEVI MAHILA P G  COLLEGE, BALLIA",
  "SANT N R DEGREE COLLEGE RAMAGARHA BISERA MURKIYA AGRA",
  "SHRI B S MAHAVIDHYALAYA MUKHRAI GARSAN KHERAGARH AGRA",
  "Gopal ji Mahavidyalaya, Rewti, Ballia",
  "Gaurishankar Rai Kanya Mahavidyalaya, (Gaurishankarpuram) Karnai, Ballia",
  "SHANTI UCHCH SHIKSHA EVAM TAKNIKI MAHAVIDYALAY PANDEYPUR LAHANGPUR MIRZAPUR",
  "GAURI BHAIYA MAHAVIDYALAYA, SAGARPALI, BALLIA",
  "Srinath Baba Jangali Baba Mahavidyala, Jam, Ballia",
  "Sri Narheji P.G. College,Narhi, Rasra, Ballia",
  "Sri Narheji Law College, Narhi, Rasra, Ballia",
  "Sri Kishun College",
  "Sri. Jamuna Ram Mahavidyalaya, Chitbaragaon, Ballia",
  "Smt. Fulehara Smarak Mahila Mahavidyalaya, Kamtaila, Rasra, Ballia",
  "SHRI RAJ NARAYAN MAHAVIDYALAYA BHEEMPURA NO 2 BALLIA",
  "SHRI HARADEV COLLEGE BALLIA",
  "Shivraj Smarak Mahavidyalaya, Rampur, Ballia",
  "Shaktipith Mahavidyalaya, Daulatpur, Ballia",
  "Shail Singh Mahila Mahavidyalaya, Nagra,Ballia",
  "Shahid Mangal Pandey Rajkiya Mahavidyalaya, Ballia",
  "SENT XAVIER MAHAVIDYALAYA BALLIA",
  "Satish Chandra College, Ballia",
  "Sant Gramyanchal Mahavidyalaya",
  " SAHDEV  BALDEV  RAMESHWAR  SARASWATI  SHIKSHAN  SANSTHAN",
  "Sagar Mahila Mahavidyalaya, Bhimpura, Ballia",
  "Shri Ram Murti Smarak Institute of Paramedical Sciemces Bareilly",
  "Virendra College of Education",
  "Acharya Kripacharya guru prasad mahila mahavidyalya Dabethua Varanasi",
  "SB COLLEGE OF LAW",
  "TECHNO INSTITUTE OF MANAGEMENT SCIENCES",
  "ITM COLLEGE OF PHARMACY",
  "MEHERWAN MAHAVIDYALAYA JARAKHAR",
  "RAMSEVAK SHIVHARE INSTITUTE OF LAW PACHNEHI BANDA ",
  "DR SHIV UMA GUPTA DEGREE COLLEGE",
  "KASHI INSTITUTE OF MANAGEMENT AND SCIENCE, GAUR MADHUKARSHAHPUR, MIRZAMURAD, VARANASI",
  "DR SHIV PRASAD KAMLA DEVI MAHILA MAHAVIDHAYALAYA BARDARD MUNDERWA BASTI",
  "DEVVANI MAHILA MAHAVIDYALYA",
  "KALAWATI CHHUTTAN LAL KAKA DEGREE COLLEGE, VILLAGE BHONRA, POST WAIR, DISTRICT BULANDSHAHR",
  "ganeshi devi memorial mahavidhyalaya",
  "GAUTAM BUDDHA MAHAVIDALAYA PACHPERWA SANGATH SANT KABIR NAGAR",
  "Sri Rakhant Baba Mahavidyalaya, Atrauli, Karmauta, Ballia",
  "Sri Neelam Devi Mahavidyalaya, Dhaturitola, Bairria, Ballia",
  "Srinath Baba Mahavidyala, Esari, Salempur, Ballia",
  "GAURA DEVI MAHILA MAHAVIDYALAYA SIRKOHIYA HADHI BAZAR BASTI",
  "BHOORE HUSAIN PASHA MEMORIAL COLLEGE OF HIGHER EDUCATION",
  "VED INSTITUTE OF EDUCATION",
  "VANDURGA INSTITUTE OF MANAGEMENT AND TECHNOLOGY BHOORBARAL MEERUT",
  "TAKSHSHILA MAHILA MAHAVIDYALAYA MIRJABAD MUHAMMADABAD GHAZIPUR",
  "SW RAMESH CHANDRA RAM SWAROOP MAHAVIDHYALAYA DEVRASAI BHARTHANA ETAWAH",
  "SW DEVRAJ DARBARI DUKHANTI SAINIK KISAN MAHAVIDYALAYA PACHAIPATTI MAKHDUMPUR BHIMAPAR GHAZIPUR",
  "SRI KRISHNA MAHAVIDYALAYA",
  "SHYAM RAGHVENDRA DEGREE COLLEGE",
  "SHRI SAI COLLEGE OF PHARMACY",
  "PT HARISH CHANDRA MISHRA NAGRAHA VIDHI MAHAVIDYALAYA",
  "MAHAVEER COLLEGE OF EDUCATION POHALLI SARDHANA ROAD MEERUT",
  "KANAKRANI DARSHAN SINGH SHIKSHAN SANSTHAN",
  "JWALA PRASAD SINGH MAHILA MAHAVIDYALAY MAHADEV NAGAR NANEMAU SULTANPUR",
  "JSMDMAHAVIDYALAYA",
  "HARSHA INSTITUTE OF PHARMACY",
  "TAPSTHALI MAHILA MAHAVIDYALAY",
  "TAPSTHALI MAHAVIDYALAY",
  "H R INSTITUTE OF LAW",
  "GULSHAN KUMAR FILM AND TELEVISION INSTITUTE OF INDIA",
  "ESHAN COLLEGE OF MANAGEMENT",
  "FUTURE KUL DEGREE COLLEGE DHAMNA KHURD, TAHROLI, JHANSI",
  "LATE GORELAL MAHARAV MAHAVIDYALAY ORAN BANDA",
  "S M A MEMORIAL GIRLS COLLEGE",
  "SARASWATI DEVI BHAGIRATHI MAHAVIDHYALAYA",
  "SW BHAGWATI PRASAD VERMA MAHAVIDYALAYA MAGALSI SOHAWAL AYODHYA",
  "ARYAVART MAHAVIDYALAYA",
  "ITWARI DEVI MAHILA MAHAVIDYALAY, VILL HARIPUR BANWA POST LOHRAMAU, SULTANPUR",
  "YASH GLOBAL GIRLS DEGREE COLLEGE ",
  "LLOYD INSTITUTE OF MANAGEMENT AND TECHNOLOGY, GREATER NOIDA",
  "Bankey Bihari Institute Of Education",
  "R D COLLEGE",
  "SR COLLEGE OF LAW AMBABAI JHANSI",
  "SR GROUP OF INSTITUTIONS (COLLEGE OF PHARMACY), JHANSI",
  "Dr.Ram Manohar Lohiya P.G.College, Bhairav Talab, Varanasi",
  "Sri Dukharan Singh Degree College, Vijaynagar, Turkaulia Babu, Basti",
  "Kisan P. G. College, Tamkuhi Road, Sevarahi, Kushinagar",
  "Shree Krishna Mahavidyalaya, Bhantpar (Barhepurwa), Malhanpar, Gorakhpur",
  "J. B. Mahajan Mahila Degree College,  Chaurichaura, Gorakhpur",
  "S.R.M.S. Institute of Medical Sciences",
  "Dr. Ram Bahadur Singh Memorial Mahavidyalaya, Milak",
  "BUDDH SINGH MAHAVIDYALAYA",
  "NARAYAN SWAROOP INSTITUTE OF NURSING AND PARAMEDICAL SCIENCE, KAUSHAMBI",
  "VINAYAK LAW COLLEGE",
  "RAJKIYA MAHAVIDYALAYA MAJHAWA MIRZAPUR",
  "OM LAW COLLEGE",
  "VIJAY INSTITUTE OF LAW",
  "Regional College of Professional Studies & Research",
  "Rajiv Gandhi Shikha Degree College, Paisia Laxmipur, Maharajganj",
  "DR MITHILESH MANI TRIPATHI LAW COLLEGE GAURAGARH SIDDHARTHNAGAR",
  "U R S LAW COLLEGE",
  "ASHA BHAGWAN BUX SINGH LAW COLLEGE",
  "Late Bhagwant Patel Panmati Devi Degree College, Chandarpur, Bashia Buzurag, Maharajganj",
  "Babu Kamata Singh Mahavidyalaya,Lafiya.Lalganj, Azamgarh",
  "BABUJI LALLAN SINGH SHIKSHAN PRASHIKSHAN SANSTHAN NIBI BELAISA AZAMGARH",
  "Babu Mangala Rai Smarak Mahila Sansthan Amaura Azamgarh",
  "Babu Nakki Singh Smarak Mahavidyalaya,Mohabatpur,Shahgarh, Azamgarh",
  "Babu Raghunath Ji Mahila Mahavidhyalaya Gambhirpur, Azamgarh",
  "BABU RAMANAND SINGH MAHILA MAHAVIDYALAYA, KOTA, UCHAHUWAN, AZAMGARH",
  "Baburam Kailashi Devi Mahila Mahavidyalaya, Dhanauli Rampur Doharighat ,Mau",
  "Babu Ramkuver Ji Maa Prabhawti College of Education, Gram-Hasapur, Post-Mujafferpur, Azamgarh",
  "Bageshwari Mahavidyalay, Deeha, Azamgarh",
  "Baijnath Ramnaresh Mahavidyalaya,Kajipur,Barhalganj, Azamgarh",
  "BAJNU SMARAK MAHAVIDYALAYA BAGHARA UCHAHUWAN AZAMGARH",
  "BAJRANG COLLEGE OF EDUCATION MAHILA MAHAVIDYALAYA",
  "BARKHU RAM VERMA MAHILA MAHAVIDYALAYA, JOKAHARA, LATGHAT, AZAMGARH",
  "B.B.S. RAJ MAHAVIDYALAYA, GOPALPUR (MEHNAGAR), AZAMGARH",
  "Bhagwan Adarsh Mahavidyalaya,Chakparipur(Kaneala) Azamgarh",
  "Bhagwati Smarak Mahavidyalaya,Mirjapurkhas,Shahpur,Jahanaganj, Azamgarh",
  "Bhrigunath Balika Mahavidyalaya ,Paramubarakpur, Mau",
  "Bindeshwari Mahavidyalaya, Dhawariyasath, Mau",
  "Bindu Devi Mahila Mahavidyalaya ",
  "BRAMHARSHI SRI RAMKRISHNA URMILA MAHILA MAHAVIDYALAYA RAMNAGAR KHALISA MAU",
  "B.S.S Mahavidyalaya, Kopaganj, Mau",
  "Chandrabhanu Mahavidyalaya, Masuriyapur Nainijor, Azamgarh",
  "Chandradev Smarak Mahila Mahavidyalaya, Khanpur, Mau",
  "CHANDRASHEKHAR MAHAVIDYALAYA ,SAHJADPUR, NIYAMATPUR, BAGLI, MAU ",
  "Chauri Belha Mahavidyalaya,Tarwa, Azamgarh",
  "Chhote Lohiya Mahavidyalaya ,Jamunipur, Chakesar, Kashidham, Surajpur,Mau",
  "D A V. P.G College Azamgarh",
  "DBSK GIRLS DEGREE COLLEGE, AZMATGARH, AZAMATGARH",
  "D.C.S.K. P G College Mau",
  "Deep Niketan Mahavidyalaya, Bhatikla, Karha ,Mau",
  "Devi Shyamsathi Mahila Mahavidyalaya Sadhwganj,Barsara,Khalsha, Azamgarh",
  "Dhanpatti Dharma Mahavidyalaya,Khemupur, Azamgarh",
  "DINESH SINGH SMARAK MAHAVIDYALYA, PAKARI, AHIRAULA, AZAMGARH",
  "DR BHEEMRAO AMBEDKAR MAHAVIDYALAYA BANKAT LEDAURA AZAMGARH",
  "Dr.Bhim Rao Ambedkar Mahavidyalaya, Chakra Basunagar ,Dargah, Mau",
  "Dr.Bhim Rao Ambedkar Mahavidyalaya,Mauprasin,Mehanajpur, Azamgarh",
  "Dr Bhim Rao Ambedkar Mahavidyalaya Niyamupur Adari Mau",
  "Dr. Bhim Rao Ambedkar Mahavidyalayay, Indara, Mau",
  "Dr.Ram Manohar Lohiya PG College ,Belwana, Azamgarh",
  "Dr.Susheela Gramin Mahavidyalaya Ratuwapar,Lakhandeh, Azamgarh",
  "DSSA MAHAVIDYALAY DADANPUR AHIRAULI GHOSI MAU",
  "Dulari Devi Panmati Mahila Mahavidyalaya Jagadishpur Gahani Mau",
  "DURGAWATI MAHILA MAHAVIDYALAYA PAKHAIPUR KUSHMAUR MAU",
  "Er. Radheshyam Smarak Mahavidyalaya,Sarya Safe.Sanjarpur, Azamgarh",
  "Fatima Hind Mahila Mahavidyalaya, Mahul Azamgarh",
  "Feku Singh Mahavidyalaya,Chewar, Azamgarh",
  "Gajadhar Gurukul Nanhkudas Mahavidyalay, Azamgarh",
  "Gandhi Shatabdi Smarak Snatkottar Mahavidyalaya, Koelsa, Azamgarh",
  "Gandhi Smarak Triveni Mahavidyalaya, Bardah Azamgarh",
  "Ganga Gauri Mahavidyalaya,Ramnagar,Baijabari, Azamgarh",
  "Gautam Budha Panchsheel Mahavidyalaya,Adilpur, Azamgarh",
  "Gaya Prasad Smarak Rajkiya Mahila Mahavidyalaya,Ambari, Azamgarh",
  "GOLDCREST COLLEGE OF EDUCATION AND RESEARCH KHANIYARA LALGANJ AZAMGARH",
  "GOVT GIRLS DEGREE COLLEGE AHIRAULA AZAMGARH",
  "Gramin Mahila Mahavidyalaya,Ranipur Rajmo,Bindra Bazar, Azamgarh",
  "Gram Samaj Mahavidyalaya,Jaistali,Babu Ki Khajuri Azamgarh",
  "GVSS Mahila Mahavidyalaya, Bishunpura (Kuti), Ahiraula, Azamgarh",
  "H.A. Rab Girls Degree College Jahangirabad Maunathbhanjan, Mau",
  "Hariom Mahavidyalaya,Aatreetha, Azamgarh",
  "Jagpati Mahila Mahavidyalaya, Mehnagar, Azamgarh",
  "JAGRASANI DEVI MAHILA MAHAVIDYALAYA BADANPUR CHACHAIPUR MAU",
  "Jai Maa Khandwari Mahila Mahavidyalay, Kahinaur, Mau",
  "Jai Maa Vaishno Mahavidyalaya,Gahni, Azamgarh",
  "Jainath Memorial Mahavidyalaya harairampur lalganj azamgarh",
  "Jai Prakash Rai Mahavidyalaya,Fatuhi, Azamgarh",
  "Ramdev Memorial Mahavidyalaya,Ranipur Rajmo,Mohamdpur Azamgarh",
  "Ramdev Ramharsh Kisaan Mahavidyalaya, Chiraiyakota ,mau",
  "Ramdhan Damodar Mahavidyalaya, Ksara, Mau",
  "Ramdhari Smarak Mahavidyalaya, Meerpur, Godhna, Mau",
  "Ramgopal Institute of Educationa, Badagao, Mau",
  "RAM KISHOR BALIKA MAHAVIDYALAYA, MAHUL",
  "Ram Lagan Girls Degree College, Amila,  Mau",
  "Ramlagan Mahavidyalaya. Jamalpur, Mirzapur, Ghosi,Mau",
  "Ramlakhan Mahavidyalay, Jamdeeh, Mau",
  "RAM MURAT TRIBHUWAN MAHILA MAHAVIDYALAYA BARDIHA SAGADI AZAMGARH",
  "Ramnath Dhananjay Smarak Mahila Mahavidyalaya,Jagdishpur,Atarauliya, Azamgarh",
  "Ramnaval Singh Smarak Mahavidyalaya, Chiraiyakota, Mau",
  "Ramprasad Smarak SHikshan Prashikshan Seva Sansthan Lakhani Mubarakpur, Mau",
  "Ramraji Devi Mahila Mahavidyalaya,Surai Azamgarh",
  "RAMSAKAL SINGH SMARAK MAHILA MAHAVIDYALAYA, MADHUBAN GUREHTHA KHARAGPUR AZAMGARH",
  "RAM SAKAL SMARAK MAHAVIDYALAYA, GORETHANI, ATROULIYA",
  "Ramsheela Girls Degree College",
  "Ramsubhag Kisan Mahavidyalaya Jagdishpur,Saraymeer Azamgarh",
  "Ramsumer Mahavidyalay, Parasmanpur Newada, Azamgarh",
  "Ramsundar Pandey Mahavidayala, Gaziyapur, Mau",
  "RAMSWAROOP KISAN MAHILA MAHAVIDYALAYA BUDHANPUR AZAMGARH",
  "Ram Ugarh Muneshvari Mahadev Mahavidyalaya,Kajha Kothi, Mau",
  "Ran Bahadur Mahavidyalaya, Phoolpur (Dehat), Azamgarh",
  "Ranjit Pandey Smarak Mahila Mahavidyalaya",
  "Reshmi Degree College, Mau",
  "Rishi Ram Naresh Krishak Mahavidyalaya, Molanapur, Dubari, Mau",
  "R.S.S. Prashikshan Mahavidyalaya, Azamgrgh",
  "R.S.S. PRASHIKSHAN SANSTHAN, JAHANAGANJ, AZAMGARH",
  "SAFIYA GIRLS DEGREE COLLEGE, MAHALIYA, SHAHAGARH AZAMGARH",
  "Sai College of Education Mahila Mahavidyalaya Laphiya Lalganj Azamgarh",
  "Samta Mahavidyalay, Badagaou, Mau",
  "SANJAY MAHAVIDYALAYA, UDIYAWAN, AZAMGARH",
  "Santboola Chotu Yaduvanshi Mahavidyalaya, Sachui, Mau",
  "Sant Gadinath Rajkiya Mahavidyalaya,Mohammadabad, Gohana, Mau",
  "SANT HARDEV DAS MAHAVIDYALAYA HAIBATPUR MADHUBAN MAU",
  "Sant Mauni Baba SMS Girls Degree College, Azamgarh",
  "SANT SRINATH SRI LAXMAN JI MAHAVIDYALAYA BELAULI SONBARSA MAU",
  "SARASHWATI SHANTI MAHAVIDYALYA, RANIPUR RAJMO, BINDRABAZAR AZAMGARH",
  "Saraswati Mahila Mahavidyalay",
  "SARVODAYA MAHAVIDYALAYA, MARTINGANJ, AZAMGARH",
  "Sarvodaya P.G. College, Ghosi, Mau",
  "Sarvoday Mahila Degree College, Harbanshpur, Azamgarh",
  "Shanti Singh Mahavidyalaya, Bhopaura, Mau",
  "Shanti Sudama Smarak Mahavidyalaya,Amora, Azamgarh",
  "Sharda Shanti Shikshak Prasikshan Sansthan Bankata Basgit Sadar Azamgarh",
  "Shekhar Social Mahila Mahavidyalaya And Education Foundation, Sammopur, Sidhari, Azamgarh",
  "Shibli National College Azamgarh",
  "SHIVAM GIRLS COLLEGE OF EDUCATION NAURASIYA TARAWA LALGANJ AZAMGARH",
  "Shivanand Mahavidyalaya ,Indara, Mau",
  "SHIVGOVIND RAMBACHAN MAHAVIDYALAYA SIKSHA SANSTHAN, LALITPURGHOSI",
  "SHIVKUMARI SHAB MAHAVIDYALAYA KYAMPUR, MUHAMDABAD GOHANA",
  "Shivmangali Devi Mahavidyalaya, Kandheri, Mau",
  "Shivmangali Devi Teacher Training Institute, Kandheri, Mau",
  "Shivmangli Devi shikshak prashikshan Sansthan Kandheri Mau",
  "SHIVSANKER SINGH MAHAVIDYALAYA KANELLA, KARNHAT, AZAMGARH",
  "SHREE MANSA RAM BRAMHA JI MAHAVIDYALAYA BAHADURPUR MARYADPUR MAU",
  "Shree Parashar Brahma Sudhakar Pandey Damyanti Devi Institute of Girls Education, Raikwardeeh, Mau",
  "Shree Umakant Shikshan Prashikshan Sansthan Evam Mahavidyalaya Champa Nagar Chakia Azamgarh",
  "Shri Agrasen Mahila Snatkottar Mahavidyalaya Azamgarh",
  "Shri Baba Sadhaw Ram Mahavidyalaya,Koinaha,Barsara Khalsa Azamgarh",
  "Shri Badri Prasad Mahavidyalaya,Aarifpur,Sagari, Azamgarh",
  "Shri Bhawanand Balika Mahavidyalaya,Punarji,Jahanganj Azamgarh",
  "SHRI BHIKHARI BALIKA MAHAVIDYALAYA UBARPUR LALGANJ AZAMGARH",
  "Shri Durga Ji Girls Degree College Sehda Azamgarh",
  "SHRI DURGA JI MAHAVIDYALAYA KYAMPUR MOHAMMADABAD GOHANA MAU",
  "Shri Durga Ji Snatkottar Mahavidyalaya, Chandesar, Azamgarh",
  "Shri Gandhi Snatkottar Mahavidyalaya,Maltari, Azamgarh",
  "CHHATRAPAL SUKHRAJ SINGH DEGREE COLLEGE",
  "THAKUR LAL PRATAP SINGH DEGREE COLLEGE KATWARUPUR HANUMANGANJ PRAYAGRAJ",
  "C B S LAW COLLEGE",
  "SMT DASWANTI DEVI MAHAVIDYALAYA CHAMPAPUR KHEMPATTI PRAYAGRAJ",
  "CHANDRAWATI VIDHI MAHAVIDYALAY",
  "DRKAMLA SHANKAR BIND MAHILA MAHAVIDYALAY",
  "NAGRAHA VIDHI MAHAVIDYALAY",
  "R B SINGH VIDHI MAHAVIDYALAYA",
  "LAXAMI NARAYAN LAW COLLEGE",
  "NARAYAN VIDHI MAHAVIDYALAYA",
  "SHRI RAMSWAROOP DEGREE COLLAGE ",
  "LDC DEGREE COLLEGE",
  "R K  LAW COLLEGE",
  "SRMS INTERNATIONAL BUSINESS SCHOOL",
  "SUSHILA SINGH VIDHI MAHAVIDYALAYA, SARAY MOHAMMADJIA, BHUPATPUR, HANDIA,PRAYAGRAJ",
  "RADHIKA LAW COLLEGE",
  "RAMSAMUJH GURUKUL VIDHI MAHAVIDYALAY CHAMRAULI HASANGANJ UNNAO",
  "KALYAN SINGH COLLEGE OF LAW KHANPUR DIST BULANDSHAHR",
  "Siddique Ahmad P.G. college, Distauli, Deoria",
  "RAJKIYA ENGINEERING COLLEGE PRATAPGARH",
  "R B S MAHAVIDHYALAYA SHYAM NAGAR PATIYALI KASGANJ",
  "Nasima Begam Mahila Mahavidyalay Dharmkhor, Babu Ghati, Deoria",
  "Shriram Mahavidyalaya, Teliya Kalan, Deoria",
  "Dilip Kishore Mehrotra Institute of Pharmacy",
  "GAYATRI DEVI COLLEGE OF LAW, CHHAPRAULI ROAD, BARAUT DISTT BAGHPAT",
  "J AND A DEGREE COLLEGE",
  "SANDHYA DEVI RAMDEV SHARMA KANYA MAHAVIDHYALAYA, SAPHIPUR, ALIGARH",
  "BABA BANSHIDHAR MAHAVIDHYALYA, NISURKHA, BULANDSHAHR",
  "MAWANA COLLEGE OF LAW",
  "ASIAN LAW COLLEGE",
  "Babu Ram Singh Bhay Singh Memorial Mahavidyalaya, Babrala",
  "ACHARYA HARIBABU AGNIHOTRI MAHA VIDYALAYA CHIYASAR KANNAUJ",
  "HARPAL SINGH MEMORIAL MAHAVIDYALAYA",
  "PT SHIVRAM SHUKLA GANGA DEVI MAHILA DEGREE COLLEGE , NIGOHA LUCKNOW ",
  "K D MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTER MATHURA",
  "LM MAHILA DEGREE COLLEGE",
  "SHRI SANTAN PAL SINGH AYURVEDIC MEDICAL COLLEGE AND HOSPITAL, MIRZAPUR SHAHJAHANPUR",
  "Sri Gurukul Mahavidyalaya, Dadari, Badhalganj, Gorakhpur",
  "DR. ASHA SMRITI MAHAVIDYALAYA, DEVA ROAD",
  "KRITIKA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "GANGA DEVI LAW COLLEGE SARAYTAKKI BABATPUR VARANASI",
  "AZAD DEGREE COLLEGE, NARKUT, BANGLA BAZAR",
  "ABES BUSINESS SCHOOL",
  "UDAY PRATAP WOMENS COLLEGE IJARA MAJIDAHA CHANDAULI",
  "BADULI COLLEGE VILL BADULI POST KOTA DISTT SAHARANPUR  ",
  "CH DALEL SINGH LAW COLLEGE B N NANU NAHAR PUL MEERUT ",
  "IED HOTEL MANAGEMENT",
  "Raghunath Girls Post Graduate College, Meerut",
  "MAHILA VIDYALAYA DEGREE COLLEGE",
  "S. K. B. Institute of Higher Education, Ragghupur, Behara, Kerakat, Jaunpur",
  "LALCHANDRA BALIKA MAHAVIDYALAYA RAWAL SAIDPUR GHAZIPUR",
  "K.R (PG) COLLEGE ,MATHURA",
  "Gangotri Devi Mahila Mahavidyalaya, Gorakhpur",
  "SRI MANNU LAL KANYA MAHAVIDYALAYA, HANSPUR, BILHOUR,",
  "CHRISTIAN TRAINING COLELGE, GOLAGANJ",
  "Vinda Pal Ugrasen Pal Mahavidhalaya, Siktahan (Parmeshwarpur), Sant Kabir Nagar",
  "SUKH DEVI MAHAVIDHYALAY PAHADPUR MAFI KASGANJ",
  "CITY ACADEMY DEGREE COLLEGE, TIWARIGANJ",
  "DR. BHIM RAO AMBEDKAR RAJKIYA MAHAVIDYALAYA, ANAUGI,",
  "SW. MAHADEV PRASAD SMARAK MAHILA MAHAVIDYALAYA,",
  "RAM CHANDRA SHUKLA SMARAK MAHAVIDYALAYA JAMUWARI AMETHI",
  "RIDDHI SIDDHI INSTITUTE OF PHARMACY",
  "R D SINGH VIDHI MAHAVIDYALAYA KASERUA KALA SAHSON PRAYAGRAJ",
  "R A S INSTITUTE OF PHARMACY",
  "SIDDHARTH MAHAVIDYALAYA, LUDHPURA, JASWANT NAGAR,",
  "Snatkottar Mahavidyalaya Bansdih, Ballia",
  "SRI GULAB SINGH MAHAVIDYALAYA, BARMUPUR,",
  "SUBHASH DEGREE COLLEGE, KIDWAI NAGAR,",
  "Lucknow Model College of Pharmacy",
  "SRI NARAIN SINGH MAHAVIDYALAYA, BHITARGAON, GHATAMPUR,",
  "LTR COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "VIVEK COLLEGE OF TECHNICAL EDUCATION, BIJNORE",
  "Gorakshnath Sanskrit Vidyapeeth, Gorakshanath Mandir",
  "Duliya Devi Smarak Sanskrit Mahavidyalaya, Transport Nagar",
  "SATYAWATI DEVI MAHAVIDYALAYA KHANDEHA KHAIR ALIGARH",
  "A.N.A. Institute of Pharmaceutical Sciences And Research Bareilly",
  "GSRM MEMORIAL COLLEGE OF PHARMACY, LUCKNOW",
  "Reshami College of Teacher Education, Atariya, Gharmmarpur, Ghazipur",
  "GAGAN MAHAVIDHYALAYA MORHENA GABHANA ALIGARH",
  "Rajiv Gandhi Institute of Information Technology",
  "GLOBAL INSTITUTE OF EDUCATION, NARAYANPUR TANDA",
  "BUDAUN KESRI CH. BADAN SINGH MEMORIAL DEGREE COLLEGE, ISLAMNAGAR",
  "SHIVSHANKAR SINGH MAHAVIDYALAY SARAKPUR, MAWAI, UNCHAHAR, RAEBARELI",
  "PT RAM CHARITRA MISHRA MAHAVIDYALAYA",
  "A.N.A. COLLEGE OF MANAGEMENT STUDIES, DELHI ROAD",
  "SWAMI VIVEKANAND COLLEGE OF HIGHER EDUCATION",
  "PT RAM DULARE MISHRA MAHAVIDYALAYA",
  "AMRITANANDMAYI COLLEGE OF HIGHER EDUCATION",
  "SACHIDANAND BAJPAI MAHAVIDYALAYA",
  "RURAL GIRLS COMPETITIVE DEGREE COLLEGE, DAURALA, SARDHANA ROAD",
  "Om Ji Institute of Engineering and Technology, Jakhaniya, Ghazipur",
  "S.L.EDUCATION INSTITUTE PALLUPURA GHOSI MORADABAD",
  "RAJESHWARI SINGH MAHAVIDYALAYA, BHAGAHARIYA, PURE MITAI ",
  "DR. NAPAL SINGH ADAITYA MAHAVIDYALAYA, ALIGARH",
  "RAJBAKSH SINGH SMARAK MAHAVIDYALAYA, SANTBAKSH NAGAR DAUDPUR AKBARPUR",
  "JAVITRI INSTITUTE OF AYURVEDA MEDICAL SCIENCES",
  "SRI BANKA BIHARI MAHAVIDHYALAYA, KHUMANPUR, BAGHAIPUR, AURAIYA",
  "M A K  AZAD FAIJ-E-AAM MAHAVIDYALAYA, ASALATGANJ",
  "SHRI MUKUT SINGH PANCHSHEEL MAHAVIDYALAYA AWAGRAH TUNDALA ROAD,LALPUR ETAH",
  "GANGA BHAGWATI MAHAVIDHYALAYA",
  "MAA VIMLA MAHILA MAHAVIDYALAY JAISINGHPUR SULTANPUR",
  "ARYA KANYA MAHAVIDYALAY TANDA AMBEDKAR NAGAR",
  "VEERANGNA AWANTIBAI MAHAVIDYALAYA , KHANPUR",
  "S.P. MAHILA MAHAVIDYALAYA, TIRWA",
  "KUWMAR MAHESH SINGH JAGROOP SINGH SMARAK MAHAVIDYALAYA,VAKTU KHERA, AJGAIN, UNNAO",
  "Shri Tulasi Das Udairaj Sanskrit Mahavidyalaya, Chitrakhor, Bankati",
  "F.S. COLLEGE,USAYENI, FIROZABAD",
  "CHUNNI DEVI R N MEMORIAL MAHAVIDYALAYA, SAMSABAD",
  "HASTINAPUR COLLEGE OF EDUCATION",
  "Ramsamujh Mahavidyalaya Fattupur,Bhagavanpur,Jaunpur",
  "RAGHURAJA RAMGOPAL MAHAVIDYALAYA, BAHURAJMAU, RAITHANA,",
  "PRAKASHDEEP LAW COLLEGE",
  "BABU SUNDER SINGH DEGREE COLLEGE",
  "Ishwardayal Parsandidevi Post Graduate College, Bulandshahr",
  "AL PARVEJ GIRLS DEGREE COLLEGE",
  "Chandrakanti Ramawati Devi Arya Mahila P.G. College, Gorakhpur",
  "D.P. MAHAVIDYALAYA, SAHASWAN",
  "ACE INSTITUTE OF MANAGEMENT & TECHNOLOGY",
  "INDIAN INSTITUTE OF PRINTING AND PACKAGING TECHNOLOGY",
  "ANUBIS DEGREE COLLEGE, RAMPUR ROAD, MEERGANJ",
  "DR RAJENDRA PRASAD MEMORIAL EDUCATION SANSTHA ",
  "YADUKUL INSITIUTE OF EDUCATION YADUBANDHU NAGRA BARA PARSHADEPUR RAIBARELI ",
  "S B SINGH LAW COLLEGE MATHIYA AMBEDKAR NAGAR",
  "DOON COLLEGE OF EDUCATION FOR WOMEN SUNDERPUR, SAHARANPUR Ph. No- 9837039652, 9412057738",
  "DOON COLLEGE VILL GANESHPUR ",
  "SAHARA DEGREE COLLEGE, VILL JANUNAGAR, NEAR KEMRI, TEH MILAK",
  "Mahila Maha Vidyalaya",
  "ITM COLLEGE OF SCIENCE AND MANAGEMENT",
  "ITM COLLEGE OF PHARMACY AND  RESEARCH",
  "ITM COLLEGE OF LAW",
  "SHRI BABU SINGH JAY SINGH AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "CHANDRADEV LAW COLLEGE, MALHANI, DEORIA",
  "Sir JP Mahila Mahavidyalaya, Kevtali Badalpur Jaunpur",
  "SUNRISE COLLEGE OF HIGHER EDUCATION",
  "SHIVSHAKTI MAHILA MAHAVIDYALAYA, KAMALPUR AZAMAGRH",
  "Sw Subedar Singh Smriti Mahila Mahavidyalaya,Katesarkala,Chaubepur,Varanasi",
  "SARDAR PATEL INSTITUTE OF AYURVEDIC MEDICAL SCIENCES AND RESEARCH CENTRE",
  "RAMBADAN SINGH MAHILA MAHAVIDYALAYA, RAUNAPAR KADIPUR AZAMGARH",
  "SHRIMATI NAVRANGI DEVI MAHILA MAHAVIDYALAYA KHALISPUR GOPALPUR HAREEPUR SULTANPUR",
  "CH NAVAB SINGH PRADHAN MAHAVIDYALAY NAGLA CHAND JALESAR ETAH    ",
  "ARYAA SMT DULARI SINGH COLLEGE OF EDUCATION AND RESEARCH",
  "GOVERNMENT DEGREE COLLEGE SUKRAULI KUSHINAGAR",
  "GOVERNMENT DEGREE COLLEGE, GUNAI, GAHARPUR, MEJA, PRAYAGRAJ, UTTAR PRADESH",
  "IQRA EDUCATIONAL INSTITUTE, SHIKOHABAD",
  "LEELAWATI ADYA PRASAD GIRLS DEGREE COLLEGE",
  "RAJKIYA MAHAVIDYALAYA LENGRI GULAR SHRAVASTI",
  "Sukhai Singh MAHAVIDYALAYA, Bhelwal, Pipra Gautam, Basti",
  "SHRI BHARAT SINGH KAMLA DEVI MAHAVIDHYALYA RAYPUR KHAS ALIGARH",
  "THAKUR DEEP NARAYAN SINGH SMARAK LAW COLLEGE",
  "Parameshwar Singh Memorial Mahavidyalaya, Mathura Nagar, Anandnagar, Maharajganj",
  "U M R I INSTITUTE OF HIGHER EDUCATION",
  "SHRI VINAYAK COLLEGE OF EDUCATION NAGLA AWAJEE ETAH RAOD SHIKOHABAD",
  "SHRI KRISHNA YADAV SURSATI MAHILA MAHAVIDYALAYA",
  "FI COLLEGE OF NURSING ",
  "BHAGWATI INSTITUTE OF TECHNOLOGY AND SCIENCE",
  "KCC INSTITUTE OF LAW",
  "SHIVA COLLEGE OF LAW",
  "J B S INSTITUTE OF PHARMACY",
  "BABU RAM CHANDRA SINGH COLLEGE OF LAW, LOHATI SARAIYA, RUDAULI, AYODHYA",
  "MAA ANJANI SURYANSH COLLAGE OF EDUCATION",
  "THAKUR SHRI JAGVIR SINGH MAHAVIDYALAY PADHEEN AURAIYA",
  "SHRI LAKSHMAN SINGH GAHARWAR VIDHI MAHAVIDHYALAY TEDHA KANTIT PAHADI MIRZAPUR",
  "SHREE SHYAM EDUCATION COLLEGE  NARAURA  BULANDSHAHAR",
  "ACCMAN BUSINESS SCHOOL",
  "Rajdeep Mahavidyalaya, Kailhat, Mirzapur",
  "HIMALAYAN INSTITUTE OF PHARMACY AND RESERACH    ",
  "S R HOSPITAL AND MEDICAL INSTITUTE",
  "Y.D. P.G. COLLEGE, LAKHIMPUR,",
  "SRAM COLLEGE OF PHARMACY",
  "GULAB DEVI MAHAVIDYALAYA SIKANDARPUR BAJHA CHAYAL KAUSHAMBI",
  "DC COLLEGE OF EDUCATION AND TECHNOLOGY AGSAULI",
  "P R MEMORIAL VIDHI MAHAVIDYALYA NOORPUR BEHTA, MOHANLAL GANJ, LUCKNOW",
  "VIRANGANA AVANTI BAI LODHI DEG. COLL., KANATTHUKHERA,",
  "VIMLA DEVI RAVINDRA PATEL MAHAVIDYALAYA",
  "VIMLA DEVI RAVINDRA KUMAR SHIKSHA  PRASHIKSHAN MAHAVIDYALYA RUDAMAU MADHOGANJ HARDOI",
  "SRI VIMAL NATH SHIKSHA PRASHIKSHAN MAHILA MAHAVIDYALAYA, SIDHAULI, SITAPUR",
  "USMANI DEGREE COLLEGE, MAHEWAGANJ, LAKHIMPUR,",
  "TRIVENI KASHI MAHAVIDYALAY",
  "Rajkiya Mahavidyalaya, Jahangirabad, Bulandshahr",
  "SHRI SAINT GIRI EDUCATIONAL INSTITUTE     ",
  "ARSH MAHAVIDYALAY MAINAHIYA BASTI",
  "TAKSHASHILA PUBLIC MAHAVIDHYALAYA, BACHGAON",
  "SW. YASHODA KANYA MAHAVIDYALAYA, MISRIKH,",
  "R C B DEGREE COLLEGE KESHOPUR RAYA MATHURA",
  "Radhika Mahavidyalaya, Karwal, Majhgawan (Gagaha), Gorakhpur",
  "CHAMELI DEVI DURGA PRASAD GIRLS DEGREE COLLEGE, SONDA, GHAZIABAD",
  "ANJANI GIRDHARI AADARSH MAHAVIDHYALAYA",
  "SRI GAYADEEN  MAHAVIDYALAYA, BAMURAHA, RATHGAON",
  "AYODHYA PRASAD MISHRA MAHAVIDYALAYA,FATEHPUR CHAURASI, UNNAO",
  "INDIAN INSTITUTE OF HEALTH AND TECHNOLOGY",
  "FAKHARUDDIN ALI AHAMAD RAJKEEYA SNATKOTTAR MAHAVIDYALAYA, MAHMUDABAD, SITAPUR",
  "LALA RAM LADETE RAMSHRI DEVI MAHAVIDHAYALAYA SARAY AGAHAT ETAH",
  "Dr. RAJENDRA PRASAD MEMORIAL DEGREE COLLEGE",
  "RAM PRATAP RANGLAL INSTITUTE OF MANAGEMENT & TECHNOLOGY",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, VARANASI",
  "SW SHRI GIRJA DAYAL MISHRA MAHAVIDYALAYA, KISHUNAPUR BARAI JALALPUR, KHAIRABAD, SITAPUR",
  "ALIGARH UNANI MEDICAL COLLEGE AND ACN HOSPITAL, ALIGARH",
  "SW SARJU PRASAD MAHAVIDYALAYA, CHAMRAHA",
  "SW. RAGHUNANDAN SINGH MAHAVIDYALAYA, SARWA, SANDILA,",
  "SW. KOATPAL SINGH DEGREE COLLEGE, MAJHIGAWAN,",
  "SWAMI SATYAMITRANAND MAHAVIDYALAYA, MAHANANDPUR,",
  "SWAMI KALYANNAND MAHAVIDYALAYA, NYORADEV, LONAR,",
  "SWAMI BRAHMANAND MAHAVIDYALAYA, AGAMPUR, SAHABAD",
  "SUSHIL VERMA MEMORIAL GIRLS DEGREE COLLEGE",
  "SURESH KUMAR SINGH SHIV PRASAD MAHAVIDHYALAYA,BAGHAURA, GAOUSGANJ",
  "S S DEGREE COLLEGE, HARIYANVA",
  "SHRI SAI RAM VIDHI COLLEGE",
  "SRI VSIHWANATH SINGH SMARAK MAHAVIDYALAYA RAHWAN HARCHANDPUR",
  "MAHIPAL SINGH MAHAVIDYALAYA, KHUMARIPUR, BEHTA,",
  "MAHIPAL SINGH LAW COLLEGE",
  "MAHAVIR PRASAD MAHAVIDYALAYA, KAMIPUR, KACHAUNA,",
  "SHRI R K DEGREE COLLEGE KAIRANA SHAMLI",
  "SRI RAM BABA S M V EKWARI BALLIA",
  "MAHAVEER PRASAD MAYAWATI MAHAVIDYALYA DAULATYARPUR MADHOGANJ",
  "MAHARANA PRATAP RAJKEEYA MAHAVIDYALAYA,",
  "MAHARAJA HRISHCHANDRA COLLEGE OF LAW",
  "MAHARAJA HARISHCHANDRA COLLEGE OF HIGHER EDUCATION,GAURKHARE",
  "MAHABALI MEVALAL MAHAVIDYALAYA TIKAULA KASTA MITAULI LAKHIMPUR KHERI",
  "MADHURI SINGH MAHAVIDYALAYA ADAMPUR SANDI",
  "MAA VINDHYVASINI MAHAVIDYALAY PATELNAGAR SITAPUR ",
  "MAA SARASWATI MAHAVIDHYALAYA ",
  "MAA KAMLA DEVI SHREE PITAMBARA VIDYAPEETH PARA RAGHUWAR NAGAR LAHARPUR SITAPUR",
  "RKD MAHAVIDYALAYA",
  "S. N. COLLEGE OF PHARMACY, JAUNPUR",
  "CH HUKUM SINGH DEGREE COLLEGE ",
  "RAMKUMAR BRAHMDEV PRABHAWATI RAMRATI MAHAVIDYALAYA SIHAPAR SAHJANWA GORAKHPUR",
  "SHYAMBIHARI LALCHAND MAHAVIDYALAYA AZAMPUR AZAMGARH",
  "DEV RISHI INSTITUTE OF LAW",
  "Institute of Professional Studies",
  "Maharaj Singh College SAHARANPUR",
  "MAA SHAKUNTLA DEVI MAHAVIDHALAY, J.H. NAGAR, BAHGON, JAITHRA, ETAH",
  "K.C. ADARSH P.G. COLLEGE SIDHPURA",
  "KEDAR RAO MAHILA MAHAVIDYALAYA",
  "R K College of Pharmacy",
  "SHRI HARCHARAN LAL VERMA MAHAVIDHYALAYA",
  "SMT VIMLA DEVI INSTITUTE OF EDUCATION JALESAR ROAD AWAGARH",
  "SHRI RAM SAHAY SINGH KANYA MAHAVIDYALAYA, MAHARIPUR, BASTI",
  "SMT VIDYAWATI COLLEGE OF EDUCATION, GORAMACHIYA, JHANSI",
  "B N PHARMACY COLLEGE, RAMPUR, JAHANAGANJ, AZAMGARH    ",
  "BHAGWATI INSTITUTE OF MANAGEMENT AND TECHNOLOGY MEERUT",
  "CH. SHRIRAM YADAV MAHAVIDYALAYA, PATIYALI",
  "NBS LAW COLLEGE    ",
  "RAM GULAM LAW COLLEGE    ",
  "S N LAW COLLEGE    ",
  "HABIBI COLLEGE OF LAW    ",
  "HARE RAMA HARE KRISHNA LAW COLLEGE    ",
  "SHOEB ANSARI VIDHI MAHAVIDYALAY MAUAIMA PRAYAGRAJ UP    ",
  "KD COLLEGE OF NURSING AND PARAMEDICAL SCIENCES     ",
  "VIDYA SCHOOL OF BUSINESS, MEERUT",
  "SHYAMA SHYAM TEACHERS TRAINING COLLEGE, AGRA",
  "RAM SINGAR SINGH MAHILA MAHAVIDYALAY, FAIZULLAH JAHIRULLAH VISHNUPUR AZAMGARH",
  "KRISHNA SCHOOL OF NURSING, BIJNOR, UTTAR PRADESH    ",
  "DEEPENDRA SHUKLA VIDHI MAHAVIDYALAYA    ",
  "SAVITRI SINGH MAHILA MAHAVIDYALAYA, ODHARA SALEMPUR NAINIJOOR AZAMGARH",
  "MAN SINGH VIDHI MAHAVIDYALAYA    ",
  "MAA GAYATRY INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "SAI MAHAVIDYALAYA, CHATTARPUR, AHIRAULI, AZAMGARH    ",
  "MAA SHARDA COLLEGE OF NURSING    ",
  "MISSION COLLEGE OF NURSING, SIRISTI, AMAULI BHAGATUA, VARANASI",
  "ANSHUMAN SINGH MAHAVIDHYALAY    ",
  "SHRI DURGA SAPTSHATI VIDHI MAHAVIDYALAYA    ",
  "HOLY ANGLE DEGREE COLLEGE DHAKDEI SAHARNPUR",
  "S B D COLLEGE OF SCIENCE AND EDUCATION     ",
  "BBS INSTITUTE OF LAW    ",
  "RAM NAGINA PHARMACY COLLEGE, SONBHADRA    ",
  "RAJ SHREE INSTITUTE OF MANAGEMENT AND TECHNOLOGY MAHAVIDHYALAYA LABHERA NAWABGANJ    ",
  "RAM SAGAR SHAMBHU DAYAL MAHAVIDYALAYA, BAJUDEEH, KHERI",
  "RAM PRASAD KUSHAWAHA MAHAVIDYALAYA",
  "KAPTAN SINGH MEMORIAL EDUCATIONAL INSTITUTE OF LAW COLLEGE BHAGOLA SONAWA AMBEDKERNAGAR    ",
  "BAIKUNTH NATH VIDHI MAHAVIDYALAYA,  DUTTNAGAR, HUJOORPUR ROAD,  COLONAILGANJ, GONDA, UTTAR PRADESH    ",
  "FACULTY OF MANAGEMENT",
  "MAA SHARDA DEVI LAW COLLEGE FATTAPUR KALA RAMSANEHIGHAT BARABANKI     ",
  "RAMPAL SINGH SMRITI LAW COLLEGE MANEHARU RAEBARELI",
  "MAA SHARDA MAHAVIDYALAYA, GHURAT, TEJPURA,BANGRA",
  "RAMGANGA MAHAVIDYALAYA, KORWAN BITHOLI",
  "D R COLLEGE OF EDUCATION AND TECHNOLOGY ,DOTAI,GARHMUKTESHWAR, DISTRICT,HAPUR",
  "MAHARAJA AGRASEN COLLEGE OF ENGINEERING & TECHNOLOGY, J.P.NAGAR",
  "RAMESHWAR DAYAL RAM KISHORE MISHRA MAHAVIDYALAYA, SANDANA,",
  "RAM DULARI KANAUJIA MAHAVIDYALAYA,CHANDIPUR",
  "PUTTULAL JAYBASA DEVI MADHUKAR MAHAVIDYALAYA, SIKRI TAMBAOUR, SITAPUR",
  "PT NAGINA COLLEGE OF PHARMACY, JOKAHARA LATGHAT SAGARI AZAMGARH",
  "PT SHEETAL PRASAD MISHRA MAHAVIDYALAYA, SONDASI, RAEBARELI",
  "PT. RAJ NARAYAN MISHRA DEGREE COLLEGE, MISHRAPUR,",
  "LALA MAHADEV PRASAD VERMA BALIKA MAHAVIDYALAYA, GOSAIGANJ, LUCKNOW",
  "PT PARMESHWAR DEEN LAW COLLEGE, ATRAULI",
  "PT. JAGANNATH MISHRA MAHAVIDYALAYA, LALGANJ,",
  "NATHAN BANO BABU KHAN JANATA DEGREE COLLEGE",
  "NARAYAN BALIKA MAHAVIDHYALAYA, BAWAN",
  "Manmeet Nagar Law College",
  "MALTI DEVI MAHAVIDYALAYA, THAKUR NAGAR (NAIMISARANYA),",
  "SWAMI KALYAN DEV DEGREE COLLEGE HASTINAPUR (MEERUT)",
  "JAGANNATH PRASAD SMARAK COLLEGE OF LAW, GAUHANIA, JASRA,",
  "ANIRUDDH YADAV MAHAVIDLAYA, PUR, BALLIA ",
  "JANKI DEVI DEGREE COLLEGE",
  "VIJAY SINGH LAL SINGH SHIKSHAN SANSTHAN",
  "VEER BAHADUR SINGH MEMORIAL COLLEGE",
  "SATYA BHAMA COLLEGE OF EDUCATION",
  "KALAWATI AYURVEDIC MEDICAL COLLEGE AND RESEARCH CENTER",
  "Dr D P Singh Mahavidyalaya Hathora Bujurg Shahjahanpur",
  "KISHORI KAMLESH MAHAVIDYALAY GAUR MIRZAMURAD VARANASI",
  "MAA CHANDRIKA DEVI INSTITUTE OF PARAMEDICAL SCIENCES",
  "CH JAIVEER SINGH SHIKSHAN SANSTHAN MISHRAPUR KANNAUJ    ",
  "JAGESHWAR  PRASAD MANNULAL VIDHI MAHAVIDHYALAYA HANSPUR BILHAUR KANPUR NAGAR    ",
  "MATA RAMA DEVI MEMORIAL MAHAVIDYALAYA JALALABAD SHAHJAHANPUR",
  "RAM DEI SINGH MAHILA MAHAVIDYALYA BEGIKOL AMBEDKAR NAGAR    ",
  "LATE ABDUL RASHEED LATE MOHD SAEED BALIKA MAHAVIDYALAYA SULTANPUR    ",
  "STATE. K.G.K. HOMEO. MEDICAL COLLEGE, MORADABAD",
  "VISHWANATH SINGH INRAJI DEVI LAW COLLEGE    ",
  "K P SINGH COLLEGE OF PHARMACY VILLAGE RAMGARH PURDHANI PRATAPGARH",
  "KAUSHLENDRA COLLEGE OF LAW MANGARH KUNDA PRATAPGARH    ",
  "M.L.B.Medical College, Jhansi",
  "SISHODIYA MAHAVIDYALAYA, BELA PIPRAICH GORAKHPUR ",
  "LUCKNOW INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "SBS COLLEGE JABRA MANT MATHURA",
  "R V INSTITUTE OF PHARMACY",
  "B M S COLLEGE OF PHARMACY",
  "A K G Institute of Nursing",
  "BABU BHEESHAM SINGH INSTITUTE OF HIGHER EDUCATION, GOJHARI, GURUBAXGANJ, RAEBARELI",
  "RAJENDRA  COLLEGE OF NURSING",
  "HARISH CHANDRA PHARMACY COLLEGE VILLAGE SAKHAILA GAURABADSHAHPUR JAUNPUR",
  "COLLEGE OF AGRICULTURE, KOTWA, AZAMGARH    ",
  "RAJVEER SINGH SIKARWAR COLLEGE SAIDPUR BALDEO MATHURA",
  "SANKATHA PRASAD VIJAY BAHADUR SINGH ISHMRITI MAHAVIDAYALAYA, LAHUREPUR, KARAHIYA BAZAR SALON, RAEBARELI",
  "MAA BHAGWATI MAHAVIDHALAYA,HUNSEPUR",
  "RAMDHARI BALIKA MAHAVIDYALAYA, HASHANPUR URF BHARTHIPUR AIRAKALA AZAMGARH",
  "RAJNARAYAN OJHA MEMORIAL MAHAVIDYALAYA    ",
  "IDEAL LAW COLLEGE    ",
  "SUNDER DEEP COLLEGE OF LOW, DELHI HAPUR ROAD, GHAZIABAD",
  "DIVYA COLLEGE OF HEALTH SCIENCES    ",
  "LM65 SOBARAN KANYA MAHAVIDYALAYA SANSARPUR BOJHIYA KHERI",
  "ANKERITE INTERNATIONAL INSTITUTE OF MEDICAL SCIENCES LUCKNOW",
  "MAXWELL INSTITUTE OF MEDICAL SCIENCES CHANDAULI",
  "LALJI DEGREE COLLEGE, VARA PARSADEPUR,",
  "DIXIT COLLEGE OF PHARMACY AND RESEARCH",
  "Sardar Patel College of Nursing, Lucknow",
  "BABA SOORAJMAL ACADEMY    ",
  "SURAYA NATH SINGH SMARAK MAHAVIDYALAY, GHINHAPUR, GOPALPUR, AZAMGARH",
  "SHRI SIDH VINAYAK COLLEGE OF LAW JAMUNAVATA GOVERDHAN ROAD MATHURA",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION, MEERUT",
  "GHAZIABAD INSTITUTE OF MANAGEMENT AND TECHNOLOGY, DUHAI, GHAZIABAD",
  "SW MUNESHWAR SINGH SHIKSHAN SANSTHAN MAHAVIDYALAYA, SIDHAULI ROAD, MISHRIKH, SITAPUR",
  "SRI NARAIYAN PRATAP SINGH SMRATI MAHAVIDYALAYA",
  "SURAJ GIRLS MAHAVIDYALAYA, LAULEHARA, RAMPUR, GHAZIPUR    ",
  "CITY SCHOOL OF PHARMACY",
  "K P SINGH MEMORIAL INSTITUTE OF PHARMACY",
  "BABU SATTIRAM JAIKARAN SMARAK PHARMACY COLLEGE, KAJIPUR, CHIRAIYAKOT, AZAMGARH",
  "JASWANT SINGH BHADAURIYA DIGREE COLLEGE KOSI KHURD MATHURA",
  "SHRI RAM BILAS INSTITUTE OF NURSING AND MEDICAL SCIENCES",
  "RAMA MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE, HAPUR",
  "AZAMGARH MAHILA MAHAVIDYALAYA, SUDANPUR, GAURAPATTI, AZAMGARH    ",
  "NARAINA NURSING COLLEGE, KANPUR",
  "CHAMPA ANKIT VIDHI MAHAVIDYALAYA NAUPUR THANAGADDI    ",
  "BABU RAMESHWAR DAYAL MAHAVIDYALAYA FATTEPUR MITAULI LAKHIMPUR KHERI",
  "DR. SARVESH SHUKLA INSTITUTE OF PHARMACY BAHRAICH",
  "Shraddha Shankar Shikshan Prashikshan Sansthan Mahila Mahavidyalaya, Mirzapur, Ahiraulee, Shitalganj, Mariahu, Jaunpur",
  "MODERN INTERNATIONAL COLLEGE OF EDUCATION",
  "ITM COLLEGE OF MANAGEMENT",
  "NISHAT HOSPITALS & INSTITUTE OF PARAMEDICAL SCIENCES AND COLLEGE OF NURSING",
  "SRI SYAMDAS BABA COLLEGE GUHETA SATVISA CHATA MATHURA",
  "ONE BEAT COLLEGE OF MEDICAL SCIENCES",
  "RAGHURAJ SINGH SANSKRIT MAHAVIDYALAY KURAULI BHADOHI",
  "SARVODAY DEGREE COLLEGE DOKAM AMYA, TRILOKPUR, SIDDHARTH NAGAR",
  "Vindyavasini Mahavidyalaya, Bharuhana, Mirzapur",
  "I.T.S INSTITUTE OF HEALTH & ALLIED SCIENCES, MURADNAGAR, GHAZIABAD",
  "SHRI BABULAL COLLEGE OF PHARMACY",
  "NIMT INSTITUTE OF MEDICAL & PARAMEDICAL SCIENCES",
  "IEC GROUP OF INSTITUTES    ",
  "MAA BHAWANI VIDHI MAHAVIDYALAYA SOGAI CHANDAULI    ",
  "I L A S DEGREE COLLEGE DOATAI GARHMUKTESHWAR",
  "SARASWATHI COLLEGE OF NURSING ANWARPUR PILKHUWA HAPUR",
  "CH SUNDAR SINGH MAHAVIDYALAYA",
  "MALTI MEMORIAL TRUSTS CSM GROUP OF INSTITUTIONS, FACULTY OF B PHARMACY ALLAHABAD",
  "AUTONOMOUS STATE MEDICAL COLLEGE    ",
  "AUTONOMOUS STATE MEDICAL COLLEGE GONDA    ",
  " AUTONOMOUS STATE MEDICAL COLLEGE SULTANPUR    ",
  "AUTONOMOUS STATE MEDICAL COLLEGE KANPUR DEHAT    ",
  "Mahatma Gautam Budh Balika Mahavidyalaya, Pilkhuwa, Hapur",
  "Shiva Education Institute, Mo Kadim, Modinagar, Ghaziabad",
  "GREATER NOIDA INSTITUTE OF TECHNOLOGY",
  "PT. RAMESHWAR BAJPAI SMRITI MAHAVIDYALAYA SULTANPUR AIMA, MUNSHIGANJ, RAEBARELI",
  "Shri Krishna Institute of Management & Science, Chandausi",
  "SAVITRI HOSPITAL & PARAMEDICAL INSTITUTE GORAKHPUR",
  "Shri Shyam Sunder Bhagwandas Garg Mahavidyalay Aajhai Kala Chaumuhan Mathura",
  "ALIGARH COLLEGE OF NURSHING AND ASIAN HOSPITAL, ALIGARH",
  "SITARA BANNO MEMORIAL DEGREE COLLEGE, SIRSI, BILARI ROAD ( SAMBHAL )",
  "MAA VIBHA SINGH MAHAVIDYALAYA    ",
  "CHAUDHARY SUGHAR SINGH NURSING AND PARAMEDICAL COLLEGE",
  "YAWAR DEGREE COLLEGE",
  "VISHWANATH MAHAVIDYALAYA",
  "POPULAR COLLEGE OF NURSING VILL AND POST BACHCHHAO CHUNAR ROAD VARANASI",
  "DIVINE GANGA LAW DEGREE COLLEGE AAMKOL KUREBHAR SULTANPUR    ",
  "Paramhans Babua Jee Girls Educational Institute Mahila Mahavidyalaya",
  "S K M MAHILA DEGREE COLLEGE CHANDPUR, NAWABGANJ, FARRUKHABAD    ",
  "SHANTI SHIKSHA NIKETAN MAHILA MAHAVIDYALAYA SINDHORA VARANASI",
  "BASANT KANTI MAHAVIDYALAYA    ",
  "POST GRADUATE INSTITUTE OF CHILD HEALTH, NOIDA",
  "VISHRAM SINGH MAHAVIDHYALAYA, BILGRAM",
  "VISHESWAR DAYAL MAHAVIDYALAYA, KONSAR CHAURAHA, BISWAN,",
  "VIRENDRA SINGH RAMWATI MAMORIAL MAHAVIDHYALAYA,KURSATH,HARDOI",
  "SHRI GULAB SINGH COLLEGE OF NURSING AND PARAMEDICAL",
  "KAMALA NEHRU MEMORIAL HOSPITAL, PRAYAGRAJ",
  "S S Institute of Nursing Hardoi",
  "FATIMA HOSPITAL SCHOOL OF NURSING LUCKNOW",
  "ST JUDE'S HOSPITAL JHANSI",
  "COLLEGE OF HORTICULTURE AND FORESTRY    ",
  "LALA LAJPAT RAI MEMORIAL MEDICAL COLLEGE, MEERUT",
  "GANGASHEEL AYURVEDIC MEDICAL COLLEGE AND HOSPITAL    ",
  "TDL LAW COLLEGE    ",
  "CM COLLEGE OF EDUCATION",
  "BRIJ CHIKITSA SANTHAN SCHOOL OF NURSING AND PARAMEDICAL COLLEGE MATHURA",
  "AUTONOMOUS STATE MEDICAL COLLEGE, PILIBHIT    ",
  "Shraddhey Baburam Balika College Khanpur Ghazipur",
  "SRI KRISHNA COLLEGE, SITAPUR",
  "SRI JALIM PRASAD MAHAVIDYALAYA, SHAHPUR, GANGAKHERA,",
  "SRI GURU NANAK MAHAVIDYALAYA, LAKHIMPUR,",
  "FATIMA HOSPITAL MAU",
  "SRI GURUNANAK KANYA DEGREE COLLEGE, GOLA GOKARANNATH,",
  "PANDIT HARIHAR SHASRTI SANSKRIT MAHAVIDYALAY KHARAGPUR AZAMGARH    ",
  "SRI GHURAI LAL VERMA SCIENCE MAHAVIDYALAYA, NAYAGAON,",
  "SONELAL MEMORIAL MAHAVIDYALAYA, SUBHAN KHERA,",
  "SMRATI MAHAVIDHYALAYA, PREETAMPUR, MATEHIYA",
  "J P SINGH VIDHI MAHAVIDYALAYA VINAYAKPUR     ",
  "SRI SURESHCHANDRA EDUCATIONAL INSTITUTE BHITI HANDIA PRAYAGRAJ",
  "S.M.D. PATEL MAHAVIDYALAYA, PATSENI, KACHAUNA,",
  "S.L.M.S.S. DEGREE OLLEGE,PHARDAPUR",
  "SHIVAJI MAHARAJ MAHAVIDYALAYA,AKBARPUR,RAIBARELI",
  "GRAMIN BHARAT MAHILA MAHAVIDHYALAYA",
  "SARVODAY COLLEGE OF EDUCATION AND TRAINING INSTITUTE",
  "SHAHJADE SINGH MAHAVIDYALAYA, ATRAOULI, BHARAWAN,",
  "MITTHU LAL MAURYA RAJESHWARI DEVI LAW COLLEGE    ",
  "SANTOSH COLLEGE OF NURSING    ",
  "BRIJ BEHARI SAHAI MAHAVIDYALAYA",
  "DAYANAND YADAV LAW COLLEGE    ",
  "KMC College of Nursing and Paramedical Sciences, Meerut",
  "VIJAY PHARMACY COLLEGE GULALPUR JAUNPUR",
  "DR. ISLAM MAZID TEACHERS TRAINING COLLEGE, KASGANJ",
  "SMT.MITHLESH SHARMA MAHAVIDYALAYA KOTA MAHAMAYA NAGAR",
  "SUDAMA DEVI BALIKA MAHAVIDYALAYA ALIGANJ ETAH",
  "JAMEEL AHMAD MEMORIAL MAHAVIDYALYA, NARUPURA KATKA ",
  "BHOORI SINGH MAHAVIDHYALAYA, KUSHWA, JALESAR",
  "D.R.G. MAHAVIDHYALYA DHANI PUR KURANA, ALIGARH",
  "GYAN MAHAVIDYALAYA,ALIGARH",
  "SHRI SIDDHBABA MAHAVIDHYALAYA",
  "PRIDE COLLEGE OF EDUCATION AMARPUR BHADIWAAR SHANKARGARH",
  "Jhamman Lal Shanti Devi Mahavidyalaya",
  "ARL MAHAVIDYALAYA MALAV KHURD TAPPAL ALIGARH ",
  "COLLEGE OF EDUCATION BALIKA",
  "GOVT. P.G. COLLEGE JALESAR ETAH",
  "kinetic institute department of pharmacy",
  "RAJA RAM GOPAL LAW COLLEGE DEORHI SOHAWAL AYODHYA    ",
  "vandurga institute of  management  and technology ",
  "BABA  BRAMHDEV MAHAVIDHYALAY DHAMANIKHERA PATAN UNNAO    ",
  "LAL POSH PAL SINGH DEGREE COLLEGE,ANCHALPUR,ETAH",
  "HANSHRAJI DEVI MAHILA MAHAVIDYALAYA, PAWAILADPUR SARAIMEER AZAMGARH    ",
  "SHRI BALAJI MAHARAJ MAHAVIDYALAYA, DAHELIYA, ETHA",
  "R S COLLEGE OF EDUCATION ",
  "GOVERNMENT DEGREE COLLEGE KURSANDA HATHRAS",
  "SARASWATI VIDYA MANDIR SCIENCE & TECHNOLOGY MAHAVIDYALAYA, LALGANJ, PRATAPGARH",
  "H.S. LAW COLLEGE G.T. ROAD, ETAH",
  "Ramkali College of Law ",
  "VISHWAMITRA DEGREE COLLEGE",
  "VIDYA DEVI KANYA MAHAVIDYALA JANDERA,  SAMASPUR,  SAHARANPUR",
  "VIDYADEEP DEGREE COLLEGE",
  "TILAK RAM SAINI GIRLS DEGREE COLLEGE, SARSAWA, SAHARANPUR",
  "THE MRINALINI  COLLEGE, HRORA, SAHARNPUR",
  "THAKUR KRIPAL SINGH Memorial DEGREE COLLEGE, RANKHANDI, SAHARANPUR",
  "TGT COLLEGE OF EDUCATION, AMBEHTA PEER",
  "SWAMI KALYAN DEV VISHVKARMA MAHILA DEGREE COLLEGE , SAHARANPUR",
  "Somdutt Sharma Degree College",
  "SMT VIDYAWATI COLLEGE OF LAW",
  "Siddhartha Degree College Akhlor Kheri",
  "SHAKUMBARI COLLEGE",
  "SATGURU INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "SAHARANPUR INSTITUTE OF ADVANCED STUDIES GOKELPUR, SHARANPUR",
  "Radha Krishan Institute of Technology and  Management",
  "PURANMAL RAMLAL DEGREE COLLEGE, GANGOH, SAHARANPUR",
  "MUNNA LAL JAI NARAYAN KHEMKHA GIRLS COLLEGE SAHARANPUR",
  "MOULANA MADANI MEMORIAL EDUCATION COLLEGE",
  "Maharishi Dayanand College of Education for Girls",
  "MAHARANA PRATAP MEMORIAL DEGREE COLLEGE, SHIMALANA, SAHARANPUR",
  "KS Degree College",
  "KRISHNA COLLEGE OF LAW VILL.-KAMALPUR, CHHUTMALPUR, SAHRANPUR",
  "KANYA JAGRITI MAHAVIDYALAYA UMAHI KALAN, SAHARANPUR",
  "KANHA COLLEGE OF HIGHER EDUCATION, SHERPUR KHANAJADPUR, SAHARANPUR",
  "J.V.JAIN COLLEGE, SAHARANPUR",
  "JANHIT DEGREE COLLEGE GANGALI,  SAHARANPUR",
  "ISLAMIA DEGEE COLLEGE, DEOBAND, SAHARANPUR",
  "HARI COLLEGE OF MANAGEMENT",
  "HARI COLLEGE OF LAW RANDEVI, SHARANPUR",
  "GOVERNMENT MAHILA MAHAVIDYALAYA KOTA (SAHARANPUR)",
  "K.P.S GIRLS COLLEGE OF EDUCATION, ALIPUR KALAN",
  "D.A.V. College Muzaffarnagar",
  "CH. HARVANSH SINGH KANYA  DEGREE COLLEGE, KHATAULI,  MUZAFFARNAGAR",
  "CH. ATAR SINGH DEGREE COLLEGE, THANABHAWAN, MUZAFFARNAGAR",
  "CHANDSHEKHAR AZAD DEGREE COLLEGE,  CHARTHAWAL, MUZAFFARNAGAR",
  "B.M. College of Education",
  "BHAGWANT COLLEGE OF EDUCATION BUGHWANTPURAM, MUZAFFARNAGAR",
  "ALPINE COLLEGE OF EDUCATION SAHARANPUR ROAD, JALALABAD, SHAMLI, MUZAFFARNAGAR",
  "DEWASTHALI VIDHYAPEETH",
  "Government Women P.G. College, Kandhla",
  "GURUDEV COLLEGE OF EDUCATION FOR GIRLS, LINK ROAD",
  "Gurudev College of Law, Link Road, Pawti, Jhijhana, Shamli",
  "KARAMBHUMI COLLEGE",
  "OM SHRI GURU SHAKSHI RAMCHANDER INSTITUTE, BHAJU",
  "UPADHYAY NAYAN SAGAR JAIN DEGREE COLLEGE, SHAMLI",
  "VIVEKANAND INSTITUTE OF EDUCATION AND TECHNOLOGY MAHILA MAHAVIDYALAYA",
  "V.V. Post-Graduate College, Shamli",
  "SANJEEVANI NURSING COLLEGE",
  "BHAGWANT INSTITUTE OF MEDICAL SCIENCES, BHAGWANTPURAM, BIJNOR DELHI HIGHWAY, MUZAFFARNAGAR",
  "UMANATH SINGH SHIKSHAN PRASHIKSHAN MAHAVIDYALYA PILKHINI JAUNPUR",
  "MAYA INSTITUTE OF EDUCATION AND TRAINING SOKHNA, HATHRAS",
  "Mahalwar Academy of Higher Education",
  "SHRI RAMESHWAR COLLEGE OF LAW    ",
  "UBS LAW COLLEGE    ",
  "G G School of Nursing and Paramedical, Agra",
  "SHRI SHAYM SUNDER COLLEGE,DARIYAB GANJ ,KASHI RAM NAGAR",
  "VISHVESHWARYA COLLEGE OF LAW",
  "H.S. DEGREE COLLEGE,MAHAMAYANAGAR",
  "ACN INSTITUTE FOR HIGHER EDUCATION, ALIGARH",
  "ADARSH JANTA MAHAVIDYALAYA GIROR ETAH",
  "SHRI BRAHMDEEN SINGH SINGRAUR SANSKRIT MAHAVIDYALAY UNCHDEEH AKODHA MEJA PRAYAGRAJ ",
  "S D S EDUCATION INSTITUTE MARTHARA ETAH",
  "St Joseph Degree College Muzaffara",
  "SMT. LAUNGSHREE DEVI MAHAVIDHYALAYA NAGLA AAL BAGHRAYA HATHRAS",
  "GAITRY SMARAK KANYA MAHAVIDYALAYA CHANDUS ALIGARH",
  "ST ANDREWS COLLEGE OF EDUCATION",
  "KRIPAL SINGH KASIMPUR MAHAVIDHYALAYA",
  "HAZRAT NIZAMUDDIN DEGREE COLLEGE BAGHRAI POST BADHOLA KASGANJ",
  "S.S.B.Ed College",
  "LUCKNOW METRO INSTITUTE OF NURSING AND PARAMEDICS LUCKNOW",
  "GOVT.DEGREE COLLEGE GONDA,IGLAS ALIGARH",
  "CAPTAIN SHREE GANGA SINGH YADAV MAHILA MAHAVIDHYALAY GHAMURRA MAINPURI",
  "Ram Dulari Raghuveer Singh degree College Prembag Patti Jaithra",
  "SAI MEER COLLEGE OF PHARMACY, FARRUKHABAD ROAD CHHIBRAMAU, KANNAUJ",
  "SRIJAN INSTITUTE OF PARAMEDICAL SCIENCE",
  "S.D. COLLEGE OF COMMERCE MUZAFFARANAGAR",
  "MAA KUNTI MALKHAN SINGH MAHAVIDYALYA DUDHMAN, ALIGARH",
  "SHRI RADHE MAHAVIDHYALAYA ,VASUNDHARA ,ETAH",
  "CH BADAN SINGH DEGREE COLLEGE G T ROAD AASPUR ETAH",
  "CH.RAM SINGH MAHAVIDYALAYA NAHAL AUTROLI ALIGARH",
  "SRI PRAMOD MAHAVIDHYALYA, HATHRAS",
  "J S S S MAHAVIDYALAYA    ",
  "SRI BHAGWAN SHIV P.G. COLLEGE UMMEDPUR",
  "C.S.MAHAVIDYALAYA HARCHANDPUR KHURD ETAH",
  "LALA RAM SHRI DEVI DEGREE COLLEGE AUTROLI ALIGARH",
  "HEY NATH VIDHYAPEETH RAMPUR BAKTRA IGLAS ALIGARH",
  "SHRI VARSHNEY COLLEGE,ALIGARH",
  "RAM SHRI DEVI MAHAVIDHYALAYA NAGLA MAHARI POST KUMROWA DISTRICT KASGANJ",
  "JAGNNATH PRASAD MAHAVIDYALAYA KOTA MAHAMAYA NAGAR",
  "SHRI RAM SCHOOL OF NURSING",
  "RAM SHANKAR SARASWAT COLLEGE OF LAW",
  "MAHRISHI COLLEGE OF PHARMACY, KAUSHAMBHI",
  "K.A COLLEGE KASHI RAM NAGAR(KASGANJ)",
  "JAMIA URDU COLLEGE OF EDUCATION",
  "VIJENDRA PAL SINGH NETRA PAL SINGH MAHAVIDHYALAYA DEVKARANPUR JALESAR ETAH",
  "RAJKIYA MAHAVIDHYALAYA TARGAWAN JAITHRA ETAH",
  "Adarsh Gyandeep Kanya Mahavidhyalya",
  "C P S GIRLS DEGREE COLLEGE SIKANDRA RAO HATHRAS",
  "CH POORAN SINGH MAHAVIDHYALYA, SEKHGARHI",
  "DEEN DYAL COLLEGE MUZAFFARNAGAR",
  "Smt Dharamwati Devi Mahavidhyalaya, Harduagang",
  "SDS DEGREE COLLEGE",
  "SHRI KRISHAN MAHAVIDYALAYA AUGSOLI SIKANDRA RAO,MAHAMAYA NAGAR",
  "KAILASH INSTITUTE OF PHARMACY AND MEDICAL SCIENCES, GORAKHPUR",
  "ANJU PRIYANKA DEGREE COLLEGE,SASNI,MAHAMAYA NAGAR",
  "SHRI SARDAR SINGH SMARK MAHAVIDYALAYA NAGLA BATUL POST NARUPURA,ALIGARH",
  "SRI RAM SINGH VITTAN DEVI MAHAVIDYALAYA UMMEDPUR RIJOR, ETAH",
  "KRISHNA MAHAVIDHYALAYA SUJANPUR KHAIR ALIGARH",
  "CH.JEVAN SINGH MEMORIAL MAHAVIDHAYALA SAROL ALIGARH",
  "Shri Deena Nath Krashi Mahavidhyalaya, Shiv Nagar, Aliganj Road, Etah",
  "SRI RAM MURTI GUPTA GOVT.COLLEGE,CHHARRA ALIGARH",
  "SMT SURAJMUKHI MAHAVIDHYALAYA, AMBARPUR",
  "DR B.R AMBEDKAR JANAM SHTABDI DEGREE COLLEGE,DHANSARI ALIGARH",
  "ANANDI DEVI INSTITUTE OF HIGHER EDUCATION G.T. ROAD, SIKANDRA",
  "VEERANGANA AVANTI BAI MAHILA MAHAVIDHAYALAYA UDDAITPUR, ETAH",
  "GOVIND MAHAVIDHYALAYA",
  "KUMAR INSTITUTE OF MANAGEMENT & INFORMATION TECHNOLOGY",
  "GOVT.COLLEGE TAPPAL,ALIGARH",
  "MANYAVAR KANSHI RAM GOVERNMENT DEGREE COLLEGE,GABHANA, ALIGARH",
  "BIRENDRA SHANKAR MATHUR COLLEGE OF NURSING",
  "MAA KALAWATI VIDHI MAHAVIDYALAYA",
  "SHRI BAHADUR SINGH MAHAVIDHALAYA, GOLA KUA, PARSOAN,ETAH",
  "SHRI KUMARSEN SHARMA MAHAVIDHALAYA,HARDOI ALIGARH",
  "SORAN SINGH RORIA COLLEGE OF EDUCATION",
  "SRI BATUK PRASAD MAHILA MAHAVIDYALAY BARJI NAYEPUR",
  "BABA RAMDAL SURAJDEV PHARMACY COLLEGE BALLIA    ",
  "SIR M.U.TEACHERS TRAINING COLLEGE, NEAR MANDI SAMITI, G.T. ROAD, ETAH",
  "GYAN STHALY MAHAVIDYALAYA, BACHAWALI, BADAGAON, JHANSI",
  "SHRI VISHNU BHAGWAN LAW COLLEGE AGRA ROAD ETAH",
  "CH. GULAB SINGH MAHAVIDHYALAY",
  "GEETA SINGH VIDHI MAHAVIDYALAYA AURAHA UPARHAR HETAPATTI PRAYAGRAJ",
  "SRI RADHA GOVIND MAHAVIDYALAYA HEERA PUR (GOPI), ALIGARH",
  "GAUTAM BUDDH MAHAVIDYALAYA",
  "SHIVALIK INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "Mahendra Singh Shakuntala Devi Kanya Mahavidyalay, Beswan",
  "MANYAWAR KANSHIRAM PARYATAN PRABANDH SANSTHAN, GOMATI NAGAR, LUCKNOW ",
  "Shree Jawahar Lal Mahavidhalaya Chharra Aligarh",
  "SHRIMATI GUJRATI DEVI VIDHI COLLEGE GADANPUR HICHCHHANPATTI AZAMGARH",
  "SHRI VISHRAM SANSKRIT MAHAVIDYALYA BAKHARIYA,  ROUTAPAR, LALGANJ, BASTI ",
  "DR. R.P.S. MAHAVIDHYALAY, BAKALPUR CHAPRAI, ETAH",
  "OM BHAGWATI DEGREE COLLEGE, HASAYAN, HATHRAS",
  "SHRI MAHENDRA PAL SHASTRI MAHAVIDYALAYA, BHAWANKHERA ALIGARH",
  "SHRI MOHAR SINGH DEGREE COLLEGE BASUNDHRA ETAH",
  "SHREE RAM SARAN MAHAVIDYALAYA RAI ALIGANJ ETAH",
  "UMALOK COLLEGE OF EDUCATION, BHATIPURA, MEGHRAJPUR, GARH ROADM MEERUT.",
  "SHANTI DEVI MAHILA MAHAVIDYALAY, BHAGWANPUR, MADIYAPAR, AZAMGARH",
  "S.R. INSTITUTE OF PHARMACY, MAIKPUR BHUTA, FARIDPUR ROAD, BHUTA",
  "SRAJAN INSTITUTE OF PHARMACY",
  "SRAJAN INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "BANDA PARA MEDICAL COLLEGE AND NURSING SCHOOL",
  "BABU YUGRAJ SINGH PHARMACY COLLEGE",
  "HIMS COLLEGE OF PHYSIOTHERAPY    ",
  "LAXMI CHAND KATORI DEVI DEGREE COLLEGE AGRA ROAD,MAHAMAYA NAGAR",
  "YASH RAJ INSTITUTE OF PHARMACY",
  "RAM DULARI VERMA MAHILA MAHAVIDYALAYA BHAWANIDEEN PURWA UDHAULI BARABANKI",
  "A H M COLLEGE OF NURSING     ",
  "JAISHREE COLLEGE",
  "SIGNA INSTITUTE OF PROFESSIONAL STUDIES",
  "RIG INSTITUTE OF HOSPITALITY AND MANAGEMENT    ",
  "GURU PHOOLCHAND VIDHI MAHAVIDYALAY, DAULATPUR, GHAZIPUR     ",
  "DIVYA JYOTI NURSING COLLEGE, GHAZIABAD, UTTAR PRADESH",
  "B P SANSTHAN, GAURA UPARWAR, CHAUBEYPUR, VARANASI    ",
  "SANSKAR COLLEGE OF ENGINEERING AND TECHNOLOGY, HAPUR",
  "Babu Mukut Bihari Lal Jain Mahavidyalaya",
  "GAYA SINGH SUMITRA SINGH CHAUHAN MAHAVIDYALYA, SITAPUR",
  "INDIRA GANDHI COLLEGE OF PHARMACY, DUMARI, MARYADPUR, MAU",
  "I E T COLLEGE OF PHARMACY VILLAGE LAKHAUVA POST FATEHGANJ TAHSIL SADAR JAUNPUR",
  "CHANDRA SHEKHAR AZAD MAHAVIDHYALAYA ",
  "KINETIC   INSTITUTE   DEPARTMENT   OF    LAW",
  "SWAMI VIVEKANAND COLLEGE",
  "SWAMI KALYAN DEV OMANAND GIRLS DEGREE COLLEGE BEHRA SADAT MZN",
  "SWAMI KALYAN DEV DEGREE COLLEGE, BAGHRA, MUZAFFARNAGAR",
  "VEETRAG SWAMI KALYAN DEV DEGREE COLLEGE BARLA, MUZAFFARNAGAR Ph",
  "SWAMI KALYAN DEV COLLEGE  BHOPA, MUZAFFARNAGAR",
  "SMT. BHAGWATI DEVI KANYA MAHAVIDYALAYA, BHOURA KALAN",
  "SHRI RAM  COLLEGE OF LAW MUZAFFARNAGAR",
  "SHRI KRISHNA GIRLS COLLEGE OF HIGHER EDUCATION",
  "SHANTI DEVI JAIN DEGREE COLLEGE,  MUZAFFARNAGAR, Mob",
  "ROYAL COLLEGE OF EDUCATION AND HIGHER STUDIES",
  "S.D. GIRLS DEGREE COLLEGE BUDANA, MUZAFFARNAGAR",
  "SMDegree college purkazi",
  "SVM YOGA AND HEALTH SCIENCES COLLEGE",
  "SAMBHAL LAW COLLEGE, CHANDAWALI, HASANPUR ROAD, PO SINGHPURSANI, SAMBHAL",
  "DOON COLLEGE OF LAW SUNDERPUR, SAHARANPUR",
  "AAKANKSHA COLLEGE OF LAW",
  "RANI GANESH KUNWARI PG COLLEGE ",
  "RAJKIYA MAHAVIDYALAYA BHAWANIPUR KALA ITIYATHOK GONDA",
  "D A V DEGREE COLLEGE, JANSATH",
  "DTS GIRLS DEGREE COLLEGE, DUMJHEDA ROAD, KASBA CHILKANA, SAHARANPUR",
  "JAGPATI SINGH SMARAK MAHAVIDYALAYA, SEMRA RAFIGANJ",
  "SMT ASHA DEVI MAHAVIDYALAYA",
  "KMC MEDICAL COLLEGE AND  HOSPITAL, MAHARAJGANJ",
  "Shepherd School of Engineering & Technology",
  "INNOVATIVE INST. OF EDUCTION & TECHNOLOGY PLAT NO. 6, KNOWLEDGE PARK-2, GREATER NOIDA",
  "ANUJ GOYAL COLLEGE OF LAW",
  "RAMASHRAY SHUKL MAHAVIDYALAYA, PURE CHHATUPUR, RAMPUR BAWLI, PRATAPGARH",
  "SAVITRI BALIKA SHIKCHAN PRASIKCHAN SANSTHAN, RAMPUR BAWLI",
  "PUTTU SINGH VERMA SOMVATI DEVI MAHAVIDYALAYA SALEMPUR KHURD TILHAR",
  "ISHWARI PRASAD RAMKALI DEVI MAHAVIDYALAYA VIRASIN NIGOHI SHAHJAHANPUR",
  "R.C.A GIRLS (PG)  COLLEGE MATHURA",
  "VIMLA SINGH SMARAK VIDHI MAHAVIDYALAY, RAMPUR SARDHA, AYODHYA",
  "SRI MOHAR SINGH MAHAVIDYALAYA",
  "SHANTI AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "MAIRASHTRA INSTITUTE OF GLOBAL EDUCATION",
  "Rohilkhand Medical College & Hospital",
  "DEV RISHI COLLEGE OF EDUCATION",
  "SWAMI KALYANDEV RAJKEEYA AYURVEDIC COLLEGE,",
  "SRI SAI AYURVEDIC MEDICAL COLLEGE AND HOSPITAL  ALIGARH",
  "DR NORMAN BORLAUG RESEARCH INSTITUTES SANAUDHIKHAS, KASGANJ    ",
  "AVADH COLLEGE OF PHARMACY NINDURA TEHSIL FATEHPUR BARABANKI",
  "R P M COLLEGE OF LAW, KOTA ROAD, HATHRAS    ",
  "INTERNATIONAL MARITIME INSTITUTE, GR. NOIDA",
  "GSRM MEMORIAL INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES AND HOSPITAL    ",
  "JAGMEET MEMORIAL NURSING COLLEGE ",
  "KAUSHLENDRA MAHAVIDYALAYA, MANGARH, KUNDA, PRATAPGARH",
  "ST MARY S COLLEGE OF NURSING",
  "S.D.COLLEGE OF MANAGEMENT STUDIES, BHOPA ROAD, MUZAFFARNAGAR.",
  "SHRI BALAJI MAHARAJ MAHAVIDYALAYA NAGLA SHARU SASNI MAHAMAYA NAGAR",
  "SHRI HARIHAR VIDHI MAHAVIDYALAYA FARIHA AZAMGARH",
  "SW. PATIRAJI DEVI SHRI KEDAR SINGH MAHAVIDYALAYA, BHUILI, JAMALPUR, MIRZAPUR",
  "INSTITUTE OF TECHNOLOGY AND SCIENCE, MOHAN NAGAR, GHAZIABAD",
  "ALI YAVAR JUNG NATIONAL INSTITUTE OF SPEECH AND HEARING DISABILITIES",
  "SARDAR PATEL MAHADEV PRASAD   MAHAVIDHYALAYA,LALGANJ",
  "SMT. RAJRANI AGNIHOTRI DEGREE COLLEGE, SEMRAUTA,",
  "GAYATRI DEVI MAHILA MAHAVIDYALAYA LALGANJ RAEBARELI",
  "KASHI BRIGHT ANGEL DEGREE COLLEGE",
  "BHAGWAT MEMORIAL MAHAVIDYALAYA",
  "BHAGAWTI PRASAD SHANTI DEVI MAHAVIDYALAYA HAIBATPUR SITAPUR",
  "SHIVAJI VIDYAPEETH MAHAVIDYALAYA, LAHARPUR,",
  "RAJGURU SHREE KRISHNA PANDEY SANSKRIT MAHAVIDYALAY",
  "BABA SARVJEET GIRI MAHAVIDYALAYA, SARAI BHUPATI, KATRA GULAB SINGH, PRATAPGARH",
  "H.B.H.MAHAVIDYALAYA NANEHERA, VEDBUGAMPUR, SAHARANPUR",
  "KRISHNA INSTITUTE OF EDUCATION & MANAGEMENT, KHANPUR GURJUR, SAHARANPUR ROAD, GANGOH, SAHARANPUR",
  "CH.SHRIRAM SONVATI YADAV DEGREE COOLEGE SATYANAGAR MUSEPURA ETAH",
  "HEADWAY COLLEGE OF EDUCATION AND TECHNOLOGY, LAWAR",
  "BUDDHA INSTITUTE OF MANAGEMENT",
  "ALLAMA IQBAL UNANI MEDICAL COLLEGE AND ACN HOSPITAL",
  "Jyoti College of Management Science & Technology",
  "JAI MAA VAISHNO PRASHIKSHAN KENDRA",
  "MAHARSHI VISHWAMITRA AUTONOMOUS STATE MEDICAL COLLEGE",
  "GAYATRI MAHAVIDHYALAY ",
  "CH BIJENDRA SINGH MITHLESH SINGH MAHAVIDHYALAY UTKARSH NAGAR NAGLA BALDEV HATHIN",
  "SMT. SHARDA JAUHARI NAGAR PALIKA KNYA MAHAVIDYALAY, KASGANJ",
  "S.S.D GIRLS DEGREE COLLEGE ",
  "VIVEKANANADA COLLEGE OF LAW, ALIGARH",
  "VIRANGANA MAHARANI AVANTI BAI GOVT.DEGREE COLLEGE,ATRAULI ALIGARH",
  "SRI TIKA RAM KANYA MAHAVIDYALAYA,ALIGARH",
  "S. N. Institute of Education, Achalpur, Etah",
  "SMT GULABO DEVI  GIRLS DEGREE COLLEGE",
  "S.R.D.A GIRLS COLLEGE ,MAHAMAYA NAGAR (HATHRAS)",
  "SMT.RAMSHREE SHIKHSHA MAHILA MAHAVIDYALAYA ETAH",
  "Saraswati Balika Mahavidyalaya  Shanti Nagar  Etah",
  "PT.LAXMI NARAIN MEMORIAL MAHAVIDYALAYA GHARBARA TAPPAL ALIGARH",
  "SUBHASH CHANDRA SNATAK MAHAVIDYALAYA, BANKATWA, SABARPUR, GONDA",
  "PARAMHANS MAHAVIDYALAYA, KAISERGANJ, BAHRAICH",
  "B.M. MEMORIAL MAHAVIDYALAYA, KAKRAHI, KISHUNPUR, MADHARMAU, AMBEDKARNAGA",
  "RAJ KISHORE VERMA MAHAVIDYALAYA PRASHIKSHAN SANSTHAN, ANKARIPUR, GOSAIGANJ, FAIZABAD",
  "MAHARSHI YOGIRAJ DEVARHAWA BABA MAHAVIDYALAYA, TENDUI KALA NEAR BLOCK JAHANGIRGANJ, AMBEDKAR NAGAR",
  "AMRAWATI DEVI MAHAVIDYALAYA, TEKI PATTI, BIHAR, PRATAPGARH",
  "B.B.S. PUBLIC MAHAVIDYALAYA, BARNA, LALGOPALGANJ, KUNDA, PRATAPGARH",
  "DR. RAJESHWAR SEVASHRAM MAHAVIDYALAYA, DHIDHUI, PRATAPGARH",
  "MAA GOMTI SMARAK MAHAVIDYALAYA, BHAV KUNDA, PRATAPGARH",
  "BRIJRAJ SAHODRA MAHAVIDYALAYA, PURE PAHAD, SULTANPUR",
  "DHODHERAM P.G. COLLEGE, SEVRA, FAIZABAD",
  "SHIV MAHESH SHAIKSHIK SHIKSHAN SANSTHAN MAHAVIDYALAYA, SULTANPUR",
  "BABA BARIYAR SHAH MAHAVIDYALAYA, BHARKHARE, SULTANPUR",
  "KISAN P.G. COLLEGE, BAHRAICH",
  "SRI RAM JANKI MAHAVIDYALAYA, RAMNAGAR, AMAWASUFI, FAIZABAD",
  "SMT. RAGHURAJI DEVI MAHILA MAHAVIDYALAYA, HANSWAR, AMBEDKAR NAGAR",
  "SANT RAM PRASAD CHAUDHARY MAHAVIDYALAYA, KODAILA, FAIZABAD",
  "RAJKARAN SINGH MAHILA MAHAVIDYALAYA, KUMHIYA, FAIZABAD",
  "DEO INDRAWATI MAHAVIDYALAYA, KATEHRI, AMBEDKAR NAGAR",
  "RAMASHANKAR PRABHA MAHAVIDYALAYA, DANDUPUR, SUKHRIGANJ, AMBEDKAR NAGAR",
  "PHOOLA DEVI CHANDRA DHAR MISHRA MAHAVIDYALAYA, CHANDAUKA, AMBEDKAR NAGAR",
  "PT. SATYA NARAIN DWIVEDI SMARAK MAHAVIDYALAYA, DOSTPUR, SULTANPUR",
  "JAI BAJRANG SHIV GULAM MAHAVIDYALAYA, AMREM, KARAUDI KALA, KADIPUR, SULTANPUR",
  "CHAUDHARY GAYA PRASAD MAHAVIDYALAYA, SHIVPUR, BAHRAICH",
  "MITHLESH NANDINI RESHMA ARIF MAHAVIDYALAYA, NANPARA, BAHRAICH",
  "SMT. DHANPATA MAURYA MAHILA MAHAVIDYALAYA RASOOLPUR LILHA",
  "RAM SAMUJH SURSATI MAHAVIDYALAYA, RATANPUR, AKBARPUR, AMBEDKAR NAGAR",
  "PT. RAM KEDAR RAM KISHORE TRIPATHI MAHAVIDYALAYA, RAWANIA PACHCHIMI, SULTANPUR",
  "RAJAT MAHILA MAHAVIDYALAYA, SINGHPUR GOHILA, BASKHARI HANSWAR MARG, AMBEDKAR NAGAR",
  "MAHAKAVI TULSIDAS MAHAVIDYALAYA, PARASPUR, GONDA",
  "RAMBALI NATIONAL MAHAVIDYALAYA, GOSAIGANJ, FAIZABAD",
  "GANGA DEVI LAL BAHADUR MAHAVIDYALAYA, PURE RUDRA USMANPUR KOTHI, BARABANKI",
  "SANT KAVI BABA BAIJNATH GOVT P.G. COLLEGE, HARAKH, BARABANKI",
  "RAJA RAGHURAJ SINGH MAHAVIDYALAYA, MANKAPUR, GONDA",
  "MAHAVIDYALAYA DERWA, PRATAPGARH",
  "GANGA JAMUNA COLLEGE OF LAW",
  "KUSUMA DEVI DEGREE COLLEGE JATAU KASGANJ",
  "SHRI RANJEET SINGH COLLEGE OF EDUCATION VIDHI AZAMGARH",
  "SMT.GENDA DEVI MAHAVIDYALAYA ALLIPUR BARWARA POST SIRAWALI, KASGANJ",
  "Centre for Behavioral and Cognitive Science",
  "ACHARYA NARENDRA DEO KISAN P.G. COLLEGE, BABHNAN, GONDA",
  "BABU SUNDER SINGH COLLEGE OF PHARMACY",
  "HARIVANSH MAHAVIDYALAYA CHAUSA KUNDA PRATAPGARH UTTAR PRADESH",
  "SHRI GANGA  CHARAN MAYA DEVI MAHAVIDYALAYA ",
  "Mata Pyari Rajdev Mahavidyalaya, Sadat, Ghazipur",
  "RENU MAHESH PHARMACY COLLEGE",
  "MULAYAM SINGH YADAV MAHILA MAHAVIDYALAYA, JALALPUR, AMBEDKAR NAGAR",
  "Halina School of Home Science",
  "Sanskrit Pathshala, Sadat",
  "SHIVANAND ANAND MADHAV DEGREE COLLEGE, FIROZABAD",
  "ASHOK MAHAVIDYALAYA, GANJMURADABAD,",
  "SHRI SIDDHI VINAYAK MEDICAL COLLEGE AND HOSPITAL",
  "SARASWATI MAHILA MAHAVIDYALAYA, VIJAY NAGAR,",
  "JAGDAMBA SHARAN SINGH EDUCATIONAL INSTITUTE, PURE FAKEER, TARABGANJ, GONDA",
  "G S AYURVEDA MEDICAL COLLEGE AND  HOSPITAL HAPUR",
  "HIERANK BUSINESS SCHOOL, A-42, SECTOR 62, NOIDA-201307",
  "SARYU DEGREE COLLEGE, KARNAILGANJ, GONDA",
  "MAHILA MAHAVIDYALAYA, GADDOPUR, GOSAIGANJ, FAIZABAD",
  "PANNALAL PUTRAWATI DEVI MAHAVIDYALAYA, BATTUGARH YARKI, AMBEDKAR NAGAR",
  "JAI MAA BARAHI MAHAVIDYALAYA, UMRI, BEGAMGANJ, GONDA",
  "B.D.D.B. BALIKA MAHAVIDYALAYA, DAN BAHADUR NAGAR, BHADAIYA, SULTANPUR",
  "DR. BHEEMRAO AMBEDKAR MAHAVIDYALAYA, KAITHOLA, GONDA",
  "CHANDRA SHEKHAR SHYAM RAJI MAHAVIDYALAYA, DHANEPUR, GONDA",
  "PT. RAM TEERATH SMARAK MAHAVIDYALAYA, ITIATHOK, GONDA",
  "JAI SHANKAR KRIPA MAHAVIDYALAYA, MUDERWA, PRATAPPUR, AMBEDKAR NAGAR",
  "INDIRA GANDHI P.G. COLLEGE, GAURIGANJ, SULTANPUR",
  "CHAUDHARY CHARAN SINGH MAHAVIDYALAYA, BARDARI, BARABANKI",
  "SRI PARAMHANS SHIKSHAN PRASHIKSHAN SANSTHAN, MAHAVIDYALAYA, AYODHYA, FAIZABAD",
  "SWAMI KARPATRI JI MAHARAJ RAJKIYA MAHAVIDYALAYA, RANIGANJ, PURE GOSAI, PRATAPGARH",
  "B.N. SINGH SMARAK MAHAVIDYALAYA, PURWASI, PRATAPGARH",
  "BHAGWAT DUTT MAHAVIDYALAYA, AJHARA, PRATAPGARH",
  "BADRI NARAIN SINGH MAHAVIDYALAYA, SAKRAULI, MADUPUR, PRATAPGARH",
  "ABUL KALAM AZAD MAHAVIDYALAYA, RAMGARH, RANIGANJ, PRATAPGARH",
  "SRI RAJPATI SINGH SMARAK SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA, SULTANPUR",
  "GURU VASHISTH MAHAVIDYALAYA, MANKAPUR, GONDA",
  "MUNSHI RAGHUNANDAN PRASAD SARDAR PATEL P.G. COLLEGE, BARABANKI",
  "HAKIULLAH CHAUDHARY MAHAVIDYALAYA, DHARI GHAT, GONDA",
  "SHYAM BAKSH MAHAVIDYALAYA, HALIAPUR, SULTANPUR",
  "SHAKTI SMARAK VIDHI SANSTHAN, DULHINPUR, BALRAMPUR",
  "HAZI ISMAIL MAHAVIDYALAYA, SADULLAHNAGAR, BALRAMPUR",
  "BANWARI DEVI ASHOK KUMAR SMARAK MAHAVIDYALAYA, DHODHWA KALA, SIRSIA, SHRAWASTI",
  "PRAN DEVI MAHADEV MAHAVIDYALAYA, PAYARKHAS, GONDA",
  "TRILOKNATH SNATKOTTAR MAHAVIDYALAYA, TANDA, AMBEDKAR NAGAR",
  "SHIV SAVITRI MAHAVIDYALAYA, SARAI MUGHAL, FAIZABAD",
  "RAMMURTI MISHRA SMARAK MAHAVIDYALAYA, BHEEKHPUR, AMBEDKAR NAGAR",
  "KAMLA PRASAD SINGH MAHILA MAHAVIDYALAYA, MATHURA NAGAR, RAMGARH, SULTANPUR",
  "RIWARD MAHAVIDYALAYA, HANUMANGANJ, SULTANPUR",
  "SRI KANHAIYA MANIK CHAND MAHILA MAHAVIDYALAYA, BHAWANIPUR, SURAPUR, SULTANPUR",
  "VINAYAK GIRLS COLLEGE OF MANAGEMENT, KHAJURAHAT, FAIZABAD",
  "GAUTAM BUDDHA RAJKIYA MAHAVIDYALAYA, FAIZABAD",
  "KAMLA NEHRU INSTITUTE OF MANAGEMENT & TECHNOLOGY, SULTANPUR",
  "RAJMATA LALLI KUMARI MAHAVIDYALAYA, PAYAGPUR, BAHRAICH",
  "SHRI LAL BAHADUR SHASTRI DEGREE COLLEGE, GONDA",
  "GANPAT SAHAI P.G. COLLEGE, SULTANPUR",
  "TRIBHUVAN SINGH HARIHAR SINGH MAHAVIDYALAYA, PALIA GOLPUR, SULTANPUR",
  "ARJUN PRASAD MAHILA MAHAVIDYALAYA, PAYASIDHAM, SURHURPUR, AMBEDKAR NAGAR",
  "PT. GAJRAJ SHUKL MAHAVIDYALAYA, CHANDELPUR, DHAMMAUR, SULTANPUR",
  "RAMKALI BABURAM SMARAK MAHAVIDYALAYA, KUDARKOT,",
  "JANTA SHIKSHA SANSTHAN MAHAVIDYALAYA, GHATAMPUR,",
  "INDIAN INSTITUTE OF ORIENTAL SCIENCES",
  "SHRIMAD DAYANAND KANYA GURUKUL MAHAVIDYALAYA",
  "DR. RAM MANOHAR LOHIA DEGREE COLLEGE, PURWA SUJAN,",
  "GANGA DEVI RAMSAJIVAN MAHAVIDYALAYA ",
  "DR. B.R. AMBEDKAR DEGREE COLLEGE ",
  "LLOYD  School of Pharmacy",
  "J P  LODHI MAHILA MAHAVIDYALAYA, BHARAWAN",
  "BHAGAT SINGH MAHAVIDYALAYA",
  "BAISWARA DEGREE COLLEGE, LALGANJ",
  "BABU RAMESHWAR DAYAL DEGREE COLLEGE",
  "SHRI MAHANT SUKHDEVPURI DEGREE COLLEGE, BILANDPUR ASHOK, PURANPUR, PILIBHIT",
  "SHREE KASHINATH MAHAVIDYALAYA, TILESARA, GHAZIPUR",
  "UJJWAL SINGH MAHAVIDYALYA",
  "SUNDER LAL PARWATI MAHAVIDYALAYA, MALLWAN",
  "GYANYOG SHIKSHA SANSTHAN AATA JALAUN",
  "Shanti Devi Memorial Mahavidayalay",
  "Teri P.G. Collage, Ghazipur",
  "ALIGARH COLLEGE OF PHARMACY, ALIGARH",
  "LANDMARK TECHNICAL CAMPUS DEDOLI, AMROHA, J.P. NAGAR",
  "R.V. INSTITUTE OF TECHNOLOGY, BIJNOR",
  "ALIGARH COLLEGE OF ENGINEERING AND TECHNOLOGY, ALIGARH",
  "PURUSHOTTAM SRIRAM DEGREE COLLEGE NANDANA GHATAMPUR, KANPUR NAGAR",
  "YOGIRAJ SRIKRISHNA MAHAVIDYALAYA AMELA BAJHERA, AURRAIYA",
  "SRI PUTTU SINGH MAHAVIDYALAYA BELA ROAD BIDHUNA, AURRAIYA",
  "NATRAJ INSTITUTE OF EDUCATION AND TECHNOLOGY POOTHA, DAULATPUR JHANGIRABAD, BULANDSHAHR",
  "BHAGIRATHI INSTITUTE OF MANAGEMENT AND TECHNOLOGY MANDORI SEOHARA BIJNOR",
  "MAHAVEER COLLEGE OF PHARMACY",
  "OM PRAKASH CHAUBEY MAHAVIDYALAYA PAIGUPUR ANANTRAM, AURRAIYA",
  "SMT KRIPA SHUKLA PUTTILAL MAHAVIDYALAYA TISTI, KANPUR DEHAT",
  "SHANKARANAND MAHAVIDYALAYA PHUPHWARA SARSAUL, KANPUR NAGAR",
  "RASTRABIR NIHALA RATI COLLEGE OF COMMERCE AND MANAGEMENT GHOSILA VARANASI",
  "RAJ SCHOOL OF MANAGEMENT SCIENCES VARANASI",
  "LATE RAM VILAS SINGH SHIKSHAN SANSTHAN CHANDAULI",
  "SHRI YOGESHWAR NATH MAHAVIDYALAYA CHANDAULI",
  "HARISHCHANDRA MAHAVIDYALAYA SONBHADRA",
  "PRIYADARSHI ASHOK MAHAVIDYALAYA SONBHADRA",
  "RAMBETI BALIKA DEGREE COLLEGE, TALGRAM",
  "BUDDHIRAM DUBEY MAHILA MAHAVIDYALAYA BHADOHI",
  "SHIV NARAIN SMARK MAHAVIDYALAYA, GHATAMPUR",
  "CITY COLLEGE OF MANAGEMENT AND TECHNOLOGY, LUCKNOW",
  "H M F A MEMORIAL INSTITUTE OF ENGINEERING AND TECHNOLOGY, ALLAHABAD",
  "LDC INSTITUTE OF TECHNICAL STUDIES, ALLAHABAD",
  "PRAYAG INSTITUTE OF TECHNOLOGY AND MANAGEMENT , ALLAHABAD",
  "JP SCHOOL OF BUSINESS, MEERUT",
  "MEERUT INTERNATIONAL INSTITUTE OF TECHNOLOGY, MEERUT",
  "SUNRISE INSTITUTE OF ENGINEERING TECHNOLOGY AND MANAGEMENT , UNNAO",
  "ASHOKA INSTITUTE OF TECHNOLOGY AND MANAGEMENT , VARANASI",
  "JEEVANDEEP INSTITUTE OF MANAGEMENT AND TECHNOLOGY, VARANASI",
  "KASHI INSTITUTE OF PHARMACY, VARANASI",
  "KASHI INSTITUTE OF TECHNOLOGY, VARANASI",
  "SARASWATI HIGHER EDUCATION AND TECHNICAL COLLEGE OF ENGINEERING, VARANASI",
  "KAMLA NEHRU INSTITUTE OF MANAGEMENT AND TECHNOLOGY, SULTANPUR",
  "KAMLA NEHRU INSTITUTE OF PHYSICAL AND SOCIAL SCIENCES, SULTANPUR",
  "RAJARSHI RANANJAY SINH INSTITUTE OF MANAGEMENT AND TECHNOLOGY, SULTANPUR",
  "DR VIRENDRA SWARUP MEMORIAL TRUST GROUP OF INSTITUTIONS, UNNAO",
  "INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH, UNNAO",
  "KANPUR INSTITUTE OF MANAGEMENT STUDIES, UNNAO",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, RAE BARELI",
  "BRIJ KISHORE HOMEOPHATHIC MEDICAL COLLEGE, DEOKALI",
  "Shri harsh Savitri Sanskrit Mahavidyalaya, Daraganj, Prayag",
  "HALFAL MAHAVIDYALAYA",
  "SARASWATI HIGHER EDUCATION AND TECHNICAL COLLEGE OF PHARMACY, VARANASI",
  "HARGOVIND SINGH MEMORIAL DEGREE COLLEGE,ERVA KATRA",
  "SRI KOMIL SINGH S.D. MAHAVIDYALAYA,LADAITA,CHIBRAMAU",
  "DIVINE COLLEGE",
  "KUNWAR AJAY SINGH VIDHI MAHAVIDYALAYA,LALAU KHERA,DEEH",
  "CH INDAL SINGH MAHAVIDYALAYA, GURSAHAIGANJ",
  "RAM JANKI COLLEGE OF LAW, BAIRY SAWAI",
  "S J LAW COLLEGE, RAMAIPUR",
  "SRIKANT MAHAVIDYALAYA, BIDHUNA",
  "LALJI SINGH DEGREE COLLEGE KOTHARA KALAN, SULTANPUR",
  "Pandit Ambika Pratap Narayan Sanskrit Mahavidyalaya, Khalilabad",
  "Shri Panchayati Swami Brahmanand Adarsh Sanskrit Mahavidyalaya, Naya Bazar",
  "Shri Paramhansanant Sanskrit Mahavidyalaya, Ashram Barhaj Bazar",
  "Vaidikadarsh Snatakottar Sanskrit Mahavidyalaya, Sarayu Bagh Ayodhya",
  "Shri Shanti Niketan Sanskrit Snatakottar Mahavidyalaya, Agast Kunda",
  "Badrinarayan V.M. Sanskrit Snatakottar Mahavidyalaya, Kaniyar, Badaganv",
  "Brahmrshi Ram Vilas Vedanti Sanskrit Mahavidyalaya, Sankat Mochan Mandir, Leelapur",
  "Satyanarayan Sanskrit Adarsh Mahavidyalaya, Barari Baitalpur",
  "DR. SHIV SAGAR LAL MAHAVIDHYALAYA, PANHAN, PATAN, UNNAO",
  "RUDRAS COLLEGE",
  "Shri Radha Krishna Mahila Mahavidyalaya, Chandauli",
  "R.K. COLLEGE,KUTHILA LAYAKPUR",
  "Vimla Mahavidyalaya Khor,Tulasi Ashram,Chandauli",
  "Shri M S K S Kushwaha Memorial Degree College, Raipur",
  "SRI RAM SINGH EDUCAITONAL INSTITUTE BARTHER ETAH",
  "J.L.N. (P.G.) COLLEGE, ETAH",
  "Chaudhari Ramdas Mahila Mahavidyalaya,Tiyara,Chandauli",
  "NARAINI DEVI MAHAVIDYALAYA MATHURA ROAD SADABAD, MAHAMAYA NAGAR",
  "Swami Argaranand ji Mahila Mahavidyalaya Barahan,Mangalpur,Chandauli",
  "Babu Tufani Singh Mahavidyalaya, Chandauli",
  "Sharda Devi Mahavidyalaya, Kamhari, Chandauli",
  "KAUSHIK MAHAVIDYALAYA ,SURWAT, GHAZIPUR",
  "Hardevanand Mahila Mahavidyala,Tenduhan,Saidaraja,Chandauli",
  "Hardeva Mahavidyalaya,Pagahi,Dhanapur,Chandauli",
  "PUSHPA DEVI GIRLS COLLEGE, GANDHI MARKET ETAH",
  "R J LAW MAHAVIDYALAYA",
  "P.M.COLLEGE OF EDUCATION, KARSUA, ALIGARH",
  "RAMLAL HARDEVI SMRITI MAHAVIDYALAYA, PATARA",
  "DR DHRMENDRA SINGH BANSHIDHAR SACHAN MAHAVIDHYALAYA",
  "KULSHEKHAR SINGH MEMORIAL MAHAVIDYALAYA, SARYA, BHATPAR RANI, DEORIA",
  "MAA PITAMBARA KANYA MAHAVIDHYALAYA",
  "GANPATI DEGREE COLLEGE",
  "BABA SURYABALI SANT SHARAN DAS BALIKA MAHAVIDYALAY MEERAPUR DERABIBI  AYODHYA",
  "RAO BALVEER SINGH RANVEER SINGH MAHAVIDYALAYA, SAKRAVA",
  "VIJAY MAHAVIDYALAYA,HARI RAMPUR,IGLAS ALIGARH",
  "CH. NATHHU SINGH DEGREE COLLEGE ",
  "LONGSHREE HOLKAR MAHAVIDHYALAYA",
  "A K DEGREE COLLEGE, CHHIBRAMAU",
  "TH BELDAV SINGH MAHAVIDYALAYA",
  "CH SURENDRA SINGH MAHILA TEACHERS TRANNING COLLEGE",
  "VISHESH EDUCATIONAL INSTITUTE KUBERPUR ROHINA",
  "SAI MEER LAW COLLEGE, CHIBRAMAU",
  "MAA BHAGWATI MAHAVIDYALAYA, CHHIBRAMAU",
  "SRI BABU SINGH DADDU JI LAW COLLEGE",
  "SRI JAI SINGH LAW COLLEGE, FATEHGARH",
  "SRI BABU SINGH DEGREE COLLEGE, MAUDARWAJA",
  "SRI SURENDRA PAL SHARMA MAHAVIDYALAYA",
  "KRISHNA DEVI BALIKA DEGREE COLLEGE, AWASH VIKASH",
  "R.J. MAHAVIYALAYA,RAIPUR,GHARBARA,ALIGARH",
  "JAY GIRIRAJ DHARAN MAHAVIDHYALAYA NEHEL ATROLI, ALIGARH",
  "SANCHATNA COLLEGE",
  "SRI SHIVDAN SINGH SMRITI COLLEGE,IGLAS ALIGARH",
  "RAJRANI SMARK MAHILA MAHAVIDHYALAYA",
  "CH SURESH SINGH MAHAVIDHYALAYA, GADHIYA",
  "Shyam sundar pyare lal gupta mahavidhyalay yakubpur auraiya",
  "SRI BABU SINGH BALIKA DEGREE COLLEGE, NAWABGANJ",
  "KHALSA COLLEGE, CHAMRAULY",
  "BAUHRE HARI SINGH COLLEGE",
  "Baba Parvat Nath Snatkottar Mahavidyalay Parvata Vishwanathpur, Sant Kabir Nagar",
  "JAI KISHAN BALIKA MAHAVIDYALAYA, CHAMIYANIGANJ",
  "SURYAPAL SINGH ANUSUIYA MAHAVIDYALAYA",
  "AZIZ GIRLS MAHAVIDHYALAYA, JAHANGIR",
  "OCHHELAL SURYAPRASAD MAHILA MAHAVIDHYALAYA",
  "SHANTI NIKETAN MAHAVIDYALAYA, SHANTINAGAR",
  "SRI BABU SINGH DADDU JI KRASHI MAHAVIDYALAYA",
  "GIRIJA DEVI DEGREE COLLEGE, SAKWAI",
  "KRISHNA DEVI BALIKA DEGREE COLLEGE, KHADIYA",
  "SRI BABU SINGH LAW COLLEGE, NAWABGANJ",
  "Shri Bachchan Singh Mahavidhyalaya, Kadarpur, Mirahchi, Kasganj",
  "RAM KISHORE SMARAK MAHAVIDHYALAYA, JADUVANSHPUR",
  "KARM KHETRA MAHAVIDYALAYA, USRAHA",
  "SW. MAHARAJ SINGH YADAV SMRATI MAHAVIDYALAYA BUJHAUA ETAILY AURAIYA",
  "RAM SEWAK RAMMURTI DEVI MAHAVIDYALAYA",
  "DR B. R. AMBEDKAR MAHAVIDALAY, GIRWAN",
  "Mohan Memorial Prayag Mahavidyalaya Shivadashi Chak ,Basu Chak, Ghazipur",
  "GANGARAM BANSHIDHAR MAHAVIDYALAYA, KUTHOUND ",
  "AMAR DEEP DEGREE COLLEGE, JALESAR ROAD,FIROZABAD",
  "RAM SINGH MAHAVIDYALAYA,NAGLA SIKANDAR TUNDELA ETAH ROAD FIROZABAD.",
  "ACHARYAKULAM VIDYAPITH",
  "SAMARPAN LAW COLLEGE",
  "SRI K.L. SHASTRI GIRLS DEGRE COLLEGE, FATEHABAD ROAD, TAJGANJ, AGRA",
  "BABA SAHEB DR. AMBEDKAR MAHAVIDYALAYA, FIROZABAD",
  "SHRI M.S CHAUHAN MAHAVIDYALAYA ,HARIDARSHAN NAGAR,MAINPURI",
  "SRI DWARIKA PRASAD SINGH GIRLS DEGREE COLLEGE ",
  "BABA SIDH KANYA MAHAVIDYALAYA SONA ARJUNPUR SAHARANPUR",
  "CHANDRA PAL SINGH MAHAVIDYALAYA",
  "SRI MUNI YADAV SOMNA DEVI MAHILA MAHAVIDYALAY HUJURA SUHAWAN SK NAGAR",
  "CHAUDHARY COLLEGE OF EDUCATION",
  "SHRI BALAJI MAHAVIDHYALAY HARDOI ",
  "SIDDHARTH SHIKSHAN AVAM SANSTHAN KARAUNDA POST DEORA BAZAR SIDDHARTH NAGAR",
  "SHEELA DEVI MAHAVIDYALAYA BHEDIYA NICHLAUL ",
  "Ram Singh College Of Pharmacy",
  "HOMI BHABHA CANCER HOSPITAL, VARANASI",
  "M P SINGH SMARAK MAHILA MAHAVIDYALAYA PANCHPUTI JAGTAPUR MANKAPUR GONDA",
  "JAGDISH SINGH MAHAVIDYALAY DEHARI RASRA BALLIA",
  "COLLEGE OF AGRICULTURE, RLBCAU",
  "Vishwanath Sharda Devi Mahavidyalaya, Bharadwaliya Mafi Sant Kabir Nagar",
  "M D AYURVEDIC MEDICAL COLLEGE AND HOSPITAL, BABARPUR, SIKANDRA, AGRA",
  "ADARSH SHRI SHANKAR SANSKRIT MAHAVIDYALY KUTHOND JALAUN ",
  "MOTI SINGH MEMORIAL COLLEGE",
  "Govt Degree College Barakhal Mehdaval Santkabir Nagar ",
  "KAMALA RAJ SARITA MAHAVIDYALAYA SIWAN KALAN SIKANDARPUR BALLIA    ",
  "Delhi Technical Campus, Sunshine Educational and Development Society",
  "Dr. Ram Manohar Lohiya Rajkiya Mahavidyalaya ,Muftigunj ,Jaunpur",
  "RAJKALI RAMASHANKAR SHUKLA MAHAVIDYALAYA",
  "SRI VIJAY SWARUP MAHILLA COLLEGE OF EDUCATION,SIKENDRA AGRA",
  "JYOTIRADITYA INSTITUTE OF PHARMACY",
  "LALPATI MUNESARA MAHILA MAHAVIDYALAY BHEEKHARPUR SULTANPUR",
  "TAMANNA BEGUM WOMENS COLLEGE ",
  "PRADUMAN SINGH SHIKSHAN PRASHIKSHAN SANSTHAN SCHOOL OF NURSING",
  "PANDIT RAJAN LAW COLLEGE",
  "Kapildev Permeshwari Memorial Mahavidyalaya",
  "AVRL Mahila Mahavidyalaya",
  "Janaklali mahavidyalya tahsinpur pure jigna mishr sohawal ayodhya",
  "R. K. GIRLS DEGREE COLLEGE, GARHI ABDULLA KHAN, UNN, SHAMLI",
  "NATIONAL (P.G)COLLEGE ,BHOGAON (MAINPURI)",
  "KAMLA SUSHILA LAL BAHADUR MAHILA MAHAVIDYALAYA PURE PAHADSINGH PUNNPUR VISHERGANJ AMATHI",
  "BABA RAMDEV SMARAK MAHAVIDALYA , BARTAR NONAHRA, GHAZIPUR",
  "COLONEL JAGANNATH SINGH MAHILA MAHAVIDYALAYA SHIKSHAN PRASHIKSHAN SANSTHAN PITHAPUR SARAIYA BHITI DISTT AMBEDKAR NAGAR UP ",
  "SHRI HARINARAIN MAHAVIDALYA,JAGATPUR,GAHLI, BASARIKHPUR, GHAZIPUR",
  "SARJU SINGH MAHAVIDALYA, HAMJAPURKHAS, JHOTANA,GHAZIPUR",
  "HARIVANSHI DWARIKA COLLEGE & EDUCATION, DURKHUSHI, MARDAH, GHAZIPUR",
  "PT RK SHUKLA DEGREE COLLLEGE ",
  "NAND BABA S N S K INSTITUTE OF EDUCATION, BHAWARAHA, PANDEYPUR RADHEY, GHAZIPUR",
  "SMT BANSHRAJI DEVI SHIKSHAN PRASHIKSHAN MAHILA MAHAVIDYALAY ASHRAFPUR SKN",
  "GANGA PRASAD SMARAK DEGREE COLLEGE ",
  "GULSHAN MEMORIAL MAHAVIDYALAYA SARAI CHAHANIYA CHANDAULI",
  "COLLEGE OF NURSING GIMS",
  "SWAMI SHUKDEVANAND COLLEGE",
  "MAJOR SHIVDAYAL SINGH MAHILA MAHAVIDYALAYA, MOHAMMADABAD, FARRUKHABAD",
  "CONSTITUENT GOVERNMENT COLLEGE HASANPUR AMROHA",
  "CONSTITUENT GOVERNMENT COLLEGE RICHHA BAHERI BAREILLY",
  "CONSTITUENT GOVERNMENT COLLEGE,BHADPURA,NAWABGANJ,BAREILLY",
  "CONSTITUENT GOVERNMENT COLLEGE, SAHASWAN, BUDAUN",
  "CONSTITUENT GOVERNMENT COLLEGE FATEHULLAGANJ, THAKURDWARA, MORADABAD",
  "CONSTITUENT GOVERNMENT COLLEGE PURANPUR, PILIBHIT",
  "AUTONOMOUS STATE MEDICAL COLLEGE, ETAH",
  "LPS INSTITUTE OF CARDIOLOGY  AND CARDIO VASCULAR THORACIC SURGERY",
  "COLLEGE OF NURSING, AUTONOMOUS STATE MEDICAL COLLEGE,DHARNIPUR",
  "S R PARAMEDICAL INSTITUTE",
  "KANDHLA COLLEGE",
  "JAIN KANYA PATHSHALA DEGREE COLLEGE",
  "SMT.LEELA DEVI COLLEGE MAGANA BALDEV MATHURA",
  "HARBIRI DEVI BHOPAL SINGH DEGREE COLLEGE YUSUFPUR BHOPA ROAD MUZAFFARNAGAR",
  "DEEN DAYAL COLLEGE OF LAW MUZAFFARNAGAR",
  "D.A.V. DEGREE COLLEGE BUDANA, MUZAFFARNGAR",
  "LALA SUKHLAL SANATAN DHARM KANYA DEGREE COLLEGE, PURKAJI",
  "Kisan P.G. College, Raksa, Ratsar, Ballia",
  "MAA SARASWATI BALIKA MAHAVIDYALAYA, SIKANDERPUR KAIRANA, MUZAFFARNAGAR",
  "MAHARAJA AGRASEN GIRLS DEGREE COLLEGE,  CHARATWAL, MUZAFFARNAGAR",
  "GHASIRAM KALKA PRASAD SHIKSHA MAHAVIDYALAYA, KARSAN, ORAI",
  "M.S.S.K.D. DEGREE COLLEGE, MORANA, MUZAFFARNAGAR",
  "NISHTHA CHAUDHARY MAHAVIDHYALAY MURSAN HATHRAS",
  "OM SHRI GURU SHAKSHI RAMCHANDER INSTITUTE  DELHI-SAHARANPUR ROAD, JASALA,SHAMLI",
  "S.D. COLLEGE MUZAFFARNAGAR",
  "ST. R. C. COLLEGE OF EDUCATION",
  "VENKATESHWARA INSTITUTE OF MEDICAL SCIENCES",
  "ASIAN COLLEGE, SUBBAKHARI, SARSAWA, SAHARANPUR",
  "B.S.M. DEGREE COLLEGE JANDHARI, SHARANPUR",
  "CH. HARI SINGH KANYA MAHAVIDYALA  MUNDIKHERI, RAMPUR MANIHARAN, SAHARANPUR",
  "DEEPANSHU COLLEGE OF LAW CHUNNATI GADA, DELHI ROAD, SAHARANPUR",
  "SHRI MUKESH KUMAR JAUHARI NURSING AND PARAMEDICAL COLLEGE",
  "SHAHEED BHAGAT SINGH MEMORIAL COLLEGE OF LAW SAMPLA BEGAMPUR NAKUR SAHARANPUR",
  "B R COLLEGE OF HIGHER EDUCATION AND TECHNOLOGY",
  "DEOBAND COLLEGE OF HIGHER EDUCATION MOH-BARHZIAUL-HAQ, NEAR-TALHERI CHUNJI, DEOBAND (SAHRANPUR)",
  "NAWAB AZMAT ALI KHAN GIRLS COLLEGE,  MUZAFFARNAGAR",
  "SILVER BELLS INSTITUTE FOR HIGHER EDUCATION PANIPAT ROAD, SHAMALI (MZN.)",
  "ST. R.C. COLLEGE OF HIGHER EDUCATION SHAMLI ROAD, BANAT, MUZAFFARNAGAR",
  "Vijay Singh Pathik Government Mahavidyalaya, Kairana (Prabudh Nagar)",
  "ASIAN COLLEGE OF LAW, SUBBAKHARI, SARSAWA, SAHARANPUR",
  "BRIGHT FUTURE GIRLS COLLEGE",
  "Maharaja Bijli Pasi Government P.G. College Ashiana",
  "CH. G.S. GIRLS DEGREE COLLEGE",
  "DEEPANSHU COLLEGE OF PROFESSIONAL STUDIES",
  "DEEPANSHU WOMENS DEGREE COLLEGE CHUNNATI GADA, DELHI ROAD, SAHARANPUR",
  "GOCHAR MAHAVIDALAYA RAMPUR MANIHARAN (SAHARANPUR)",
  "KUSUM KUMARI GOVIND NARAYAN SHIKSHA MAHAVIDYALAYA, LAUNA",
  "ANARI DEVI JOKHAN PRASAD MAHILA MAHAVIDYALAY SEWAIPAR SHANICHARA BAZAR SKN",
  "VEER KUNWAR COLLEGE OF PHARMACY BIJNOR",
  "AGRA PUBLIC COLLEGE OF TECHNOLOGY AND MANAGEMENT, AGRA",
  "C L JAISAWAL LAW COLLEGE HANDIA PRAYAGRAJ",
  "GOVERNMENT COLLEGE DEOBAND (SAHARANPUR)",
  "GOVERNMENT MAHAVIDYALAYA NANAUTA (SAHARANPUR)",
  "M V D EDUCATIONAL AND LAW COLLEGE, LUCKNOW",
  "SHRI HEERA LAL SMARAK MAHAVIDYALAYA,  NAKTAI KHURD ALIGANJ",
  "INSTITUTE OF INFORMATICS TECH. & ENGINEERING E - 8, INDUSTRIAL ESTATE, DELHI ROAD, SAHARANPUR, Ph. No :- 0132 -762864, 723676",
  "SHRI RAM INSTITUTE OF EDUCATIONAL AND PROFESSIONAL STUDIES",
  "PATRONAGE INSTITUTIONS OF PROFESSIONAL STUDIES",
  "SRI SYHAM MAHAVIDHYALA KARAHARA MIDHAKUR AGRA",
  "RESHAMA MAHILA MAHAVIDYALAYA SIKANDARPUR BAIRAKH GHAZIPUR",
  "DEV BHOOMI GROUP OF INSTITUTIONS SAHARANPUR",
  "CAPTAN S C MAHILA MAHAVIDYALA    ",
  "SHRI AJAB SINGH MAHAVIDHYALAYA NAGLA DHARU JASRANA FIROZABAD    ",
  "B B RAI MEMORIAL VIDHI MAHAVIDALAYA",
  "SHRI SUBEDAR MAHAVIDYALAYA, HARNAGARPUR, UMRAIN, AURRAIYA ",
  "Sukdeo Singh Lavkush Degree College",
  "SYMBIOSIS INSTITUTE OF BUSINESS MANAGEMENT, NOIDA",
  "CHHEDILAL RAKAMLAL MAHAVIDYALAYA",
  "SHRI HARIPRASAD MAHAVIDYALAYA FIROZPUR MAKHDOOMI RUDAULI AYODHYA",
  "KRISHNA ACADEMY BICHPURI ROAD, BICHPURI, AGRA",
  "R.K COLLEGE OF SYSTEM AND MANGEMENT,(FIROZABAD)",
  "SRI RAJ KUMAR SINGH DEGREE COLLEGE, MAINPURI",
  "RAM REKHA RAI GANGA RAI VIDHI MAHAVIDYALAYA NEHARU NAGAR MAHARAJGANJ U P ",
  "SHRI DURGA JI LAW COLLEGE KYAMPUR MOHAMMADABAD GOHNA MAU    ",
  "GREEN AGRA MAHAVIDYALAYA PILI POKHAR MAHAMAYA NAGAR ROAD, AGRA",
  "RAMA DENTAL COLLEGE HOSPITAL & RESEARCH, KANPUR",
  "GURU NIRANJAN MAHAVIDYALAYA LUHENTA MOD IRADAT NAGAR AGRA",
  "Shri Gopi Ram Mahavidhyalya, Ghiror, Mainpuri",
  "C-IMPACT INST., AGRA MATHURA ROAD SIKENDRA, AGRA",
  "Mahendra Gayatri School of Nursing",
  "CH.MADHAV SINGH SMARAK MAHAVIDYALAYA AWAD NAGAR KISHRI MAINPURI",
  "J.S.INSTITUTE OF EDUCATION, SHIKOHABAD",
  "SHRIMATI RAMADEVI JAGDISH PRASAD MAHAVIDYALAYA SARAYNEEM JALESAR ETAH",
  "USHA COLLEGE OF PHARMACY AND MEDICAL SCIENCES",
  "SHRI MAHENDRA SINGH YADAV VIDHI MAHAVIDHYALAY,TARAON,KORAON,PRAYAGRAJ,UP    ",
  "KEWLA PRASAD SHUKL JANTA MAHAVIDYALAYA, DEVNAHARI, SAHSOAN, PRAYAGRAJ    ",
  "DR. ASHISH PARAMEDICAL COLLEGE, NURSING TRAINING CENTRE, DEORIA",
  "SARASVATI VIDHYA MANDIR VIGYAAN AIWAM PRODYOGIKI NURSING MAHAVIDYALAYA PRATAPGARH",
  "SBS Dadduji college of pharmacy bhojpur fatehgarh farrukhabad",
  "YASH RAJ LAW COLLEGE    ",
  "BANARSIDAS GARG DEGREE COLLEGE AHAMADGARG",
  "DEV MAHAVIDHYALAYA GORAI IGLAS ALIGARH",
  "SATYADEV INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "ANIRUDH TECHNICAL EDUCATION RESEARCH INSTITUTE KUSAHA CHANDAULI",
  "CPS GIRLS COLLEGE",
  "SINGRAUR VIDHI MAHAVIDYALAYA",
  "RBS VIDHI MAHAVIDYALAY",
  "P C LAW COLLEGE    ",
  "DR ANAR SINGH NURSING AND PARAMEDICAL COLLEGE",
  "TEJPAL SINGH TYAGI KUSHAL PAL TYAGI MEMORIAL  DEGREE COLLEGE, MURADNAGAR, GHAZIABAD",
  "SHRI SIDH VINAYAK MAHAVIDYALAY GOVERDHAN ROAD MATHURA",
  "DR. GHANSHYAM SINGH MAHAVIDYALAYA SOYEPUR, LALPUR AZAMGARH ROAD, VARANASI",
  "ADARSH KRISHNA COLLEGE EDU. BHOOP NAGAR,MAINPURI",
  "RAJKIYA MAHAVIDYALAYA KATRA CHUGGHUPUR SULTANPUR ",
  "RAJKIYA MAHAVIDYALAYA, KATERA    ",
  "SHREE RAMAN SINGH DEGREE COLLEGE KHIRARI RAYA MATHURA",
  "UNIVERSAL COLLEGE OF HIGHER EDUCATION KHAJURI  MEERUT     ",
  "JAS RANA DEGREE COLLEGE, JHAPARA,JASRANA,FIROZABAD",
  "DR. M.P.S.MEMORIAL COLLEGE OF BUSINESS STUDIES,AGRA DELHI HIGHWAY,SIKANDRA AGRA",
  "DIPANJALI MANAGEMENT COLLEGE    ",
  "MEERUT INSTITUTE OF HIGHER EDUCATION NAGLI ISHA  MAWANA ROAD MEERUT     ",
  "GLOBAL COLLEGE OF HIGHER EDUCATION  KHAJURI MEERUT    ",
  "DR AMBEDKAR INSTITUTE OF TECHNOLOGY FOR DIVYANGJAN, KANPUR",
  "Kedarnath Jagannath Mahavidyalay",
  "MAA SARASWATI COLLEGE OF LAW DAMODARA JAUNPUR",
  "Faridul Haque Memorial Degree College Sabrahad Shahganj jaunpur",
  "Rashtriya Snatkottar Mahavidyalaya, Jamuhai, Jaunpur",
  "Maa Bageshvari Devi Mahila Mahavidyalaya , Nasirpur Ghazipur",
  "Kuteer Degree College, Chakkey , Jaunpur",
  "RAJKIYA ENGINEERING COLLEGE GONDA",
  "RAJKIYA ENGINEERING COLLEGE MIRZAPUR",
  "RAJKIYA ENGINEERING COLLEGE , BASTI",
  "AADISHAKTI COLLEGE, TAJOPUR, MAU",
  "Aazad Hind Mahavidyalaya, Chakramji Maunath, Bhanjan, Mau",
  "Abdul Usman Mahavidyalaya, Raypur (Paliya), Mau",
  "Adarsh Devkali Baba Smarak Mahavidyalaya, Udaina, Ahraula,  Azamgarh",
  "ANAND MAHILA MAHAVIDYALAY BARSERWA BAHADURPUR, AZAMGARH",
  "ANUPAMA RAI MEMORIAL COLLEGE OF EDUCATION, HARAIRAMPUR, AZAMGARH",
  "Arjun Girls Degree College, Walidpur, Mau",
  "Aruna Memorial Sarswati Mahavidyalaya, Rewridih ,Mau",
  "ARYA BABU VINDHYACHAL SINGH COLLEGE OF EDUCATION, TAHIRPUR SAFIPUR LALGANJ AZAMGARH",
  "Avadh Narayan Singh Mahavidyalaya, Sultanipur, Mau",
  "AZAD MAHAVDAYALAYA, SARAIYA PALHNA, AZAMGARH",
  "AZAMGARH GIRLS DEGREE COLLEGE NASEERPUR BILARIYAGANJ AZAMGARH",
  "Baba Baijnath Ji Mahavidyalaya,Godhpur,Kishundaspur, Azamgarh",
  "Baba Baijnath Mahavidyalaya,Amnave,Martinganj Azamgarh",
  "BABA BHAWARNATH MAHAVIDYALYA  KHARAGPUR AAZAMGARH",
  "Baba Bhrigu Mahavidyalaya, Paliya Mau",
  "BABA JAGDEV DAS MAA AMRAWATI SHIVPOOJAN MAHAVIDYALAYA, PAKRITAAL, Mau",
  "BABA PARAMHANS TRIBHUWAN SMARAK  MAHAVIDYALAYA, HANUMAN NAGAR, KARAMPUR, MAU",
  "Baba Ramnath Utkarsh Mahavidyalaya Baalpur,Kharela, Azamgarh",
  "BABA RAMPYARE SINGH SHIKSHAN PRASHIKSHAN SANSTHAN, MOHABBATPUR SHAHAGARH AZAMGARH",
  "Baba Ramtahal Das Vishal Mahavidyalaya,Bharthipur, Azamgarh",
  "Baba Sahoru Das Smarak(B.S.D.S)Mahavidyalaya,Nandawn, Azamgarh",
  "Baba Tapeshwar Mahila Mahavidyalaya, Gurapar, Mau",
  "Baba Thanidas Balika Mahavidyalaya, Gofa, Amila, Mau",
  "BABA VEER BAHADUR RAMNATH MAHAVIDYALAYA PILAKHI VARUNA MAU",
  "BABA VISHWANATH KRISHAK MAHAVIDYALAYA, BHINTKASO,MEHNAGAR, AZAMGARH",
  "Manywar Kanshiram R.D. Ram R.B. Ram Memorial Degree College ,Kamalpur, Kolaura, Mau",
  "Maryada Prushottam Mahavidyalaya, Bhunsuri, Ratanpur,Mau",
  "MATA DHIRAJI MAHAVIDYALAYA SALEMPUR SULTANIPUR AZAMGARH",
  "MATA KASTURA MAHILA MAHAVIDYALAYA GARBARA TIKARGARH LALGANJ AZAMGARH",
  "MATA LILAWATI CHANARA DEVI MOHIT PHALWAN MAHAVIDYALAYA, KHAJURA PHULLICH BOGARIYA ",
  "Mata Pyari Devi Darshan Mahavidyalaya, Mehnagar, Azamgarh",
  "MATA RADHIKA BALIKA MAHAVIDYALAYA KAMHARIYA AZAMGARH",
  "Mathura Rai Mahila Mahavidyalaya,Maltari, Azamgarh",
  "Maulana Abul Kalam Azad Alpsankhyak Shikshan Prashikshan Sansthan Pardahan Mau",
  "Md. Shahbaan Memorial Mahavidyalaya , Rampur Belauli, Mau",
  "Mewati Devi Mahavidyalaya, Gohana, Mau",
  "M H MEMORIAL MAHILA MAHAVIDYALAYA DANDI BHOPAURA GHOSI MAU",
  "Mirza Ahsanullah Beg Niswan Balika Mahavidyalaya,AnjanShaheed, Azamgarh",
  "M.K.Rai Deep Adarash Balika Mahavidyalaya,Bhagwanpur,Thekma, Azamgarh",
  "Mohammad Masud Khan Degree College,Magrawa Azamgarh",
  "Moti Harishchandra Mahavidyalaya, Baldhih, Pandaha",
  "Mubarkpur Girls Degree College,Mubarkpur,Azamgarh",
  "MUNESHWAR DEVNANDAN YADAV MAHILA MAHAVIDYALAYA, AKBARPUR, BILARIYAGANJ AZAMGARH",
  "MUNNI DEVI MAHILA MAHAVIDYALAYA, GOPALPUR AZAMGARH",
  "Musafir Prabhavati Mahavidyalaya, Salahabad, (Bachauna), Mau",
  "Naamvar Khuddan Smarak Kisaan , Mahavidyalaya, Sirasa, Chiraiyakota, Mau",
  "Nageshwar Pandey Mahavidyalaya, Piparsath,Mau",
  "Nand Academy Mahila Mahavidyalay, Rohowa Mustafabad, Mujaffarpur, Azamgarh",
  "Navi Ahamd Mahila Degree College, Mau",
  "Neta Ji Subhash Chandra Bose Mahavidyalaya,Deogaon, Azamgarh",
  "OM PRAKASH MISHRA SMARAK MAHAVIDYALAYA, MOLANAPUR, AHMADBAKS, PHULESH, AZAMGARH",
  "Palakdhari Singh Mahila Mahavidyalaya,Itaora,Chandeshwar, Azamgarh",
  "PARAM PUJYA SHRI BABA BAIJNATH MAHAVIDYALAYA SAKATPUR SUKKHIPUR AZAMGARH",
  "PARAS BABA SAHAB AMBEDKER SAHEED FAUJDAR RAM MAHAVIDLYA PRASPURA DUMRAO MAU",
  "Paras Kanya Degree College, Brindabajar, Azamgarh",
  "PHOOLCHAND GRAMIN MAHILA MAHAVIDYALAYA, NARAHANKHAS, AZAMGARH",
  "Phula Devi Mangru Singh Memorial Mahavidyalay Chatarpur Lalganj , Azamgarh",
  "PRATIMA GIRLS DEGREE COLLEGE ANJANSHAHID AZAMGARH",
  "Prithaviraj Chauhan Mahavidyalaya, Mau",
  "Priyanka Mahavidyalaya Narphora Bilari Azamgarh",
  "Pt. Chandrika Smarak Purvanchal Mahavidyalaya, Surahpur Mohammadabad , Gohna, Mau",
  "Pt.Nagina Smarak Mahavidyalaya,Jokhara, Azamgarh",
  "Pt Tripurari Mishra Adarsh Mahavidyalaya, Rohuva Mustafabad Gadaha Azamgarh",
  "PUBLIC GIRLSDEGREE COLLEGE, KANKAHA SARAIMEER",
  "Public Mahila Sahar P. G. College, Baramadpur Mohammadabad - Gohna, Mau",
  "PURVANCHAL MAHILA DIGREE COLLEGE, BHIKKHARIPUR, MAU",
  "Purvanchal Snatkottar Mahavidyalaya,Rani Ki Saray Azamgarh",
  "Purvanchal Vidhi Mahavidyalaya Sammopur Rani Ki Sarai Azamgarh",
  "Radhakrishna Mahavidyalaya Bangawan Ghosi Mau",
  "RAJAN COLLEGE OF EDUCATION",
  "Rajan College of Womens Education, Kopaganj",
  "Rajbahadur Singh Smarak Mahavidyalaya,Hameedpur, (Shaheedwara) Azamgarh",
  "Rajdai Devi Mahavidyalaya, Sangrampur Deedarganj Azamgarh",
  "Rajdeo Panmati Mall Mahila Mahavidyalay, Makhdumpur, Lalanpur, Mau",
  "Rajdev Krishak Mahavidyalaya,Kashipur,Surai,Sathiyawa, Azamgarh",
  "Rajeev Gandhi Mahavidyalaya,Balldev,Manduri,Captanganj, Azamgarh",
  "Rajeev Gandhi Mahila P.G. College , Pardahan,Mill Road Mau",
  "Rajendra Tara Chauhan Mahavidyalay, Etaura, Ardauna, Mau",
  "RAJIYA SMARAK MAHILA MAHAVIDYALAYA, HAKIKATPUR ( MATLUPUR), MAU",
  "Rajnath Mahavidyalaya Shukl ,Patti Kathtarav, Mau",
  "Rajpati Yadav Mahavidyalaya, Naraipur, Azamgarh",
  "Ramashankar Singh Mahavidyalaya Makhana Pindohari Mau",
  "Ramawadh Singh Mahavidhyalaya Pipiridhia,Mau",
  "RamAwadh Singh Shikshan And Prashikshan Sansthan, Bhar, Piparideeh, Mau",
  "Ram Bachan Singh Rajkiya Mahila Mahavidyalaya, Bagali Pijara, Mau",
  "Ram Bachan Yadav Mahavidyalaya,Bahauddinpur,Kharaso,Folpur, Azamgarh",
  "RAMBARAN GHURBHARI YADAV MAHAVIDYALAYA, SAMAUDDINPUR KARMI, MAU",
  "RAM BHAJAN DEGREE COLLEGE, MAU",
  "RAMDEV INSTITUTE OF EDUCATION, KHILLUPUR, SANJARPUR, AZAMGARH",
  "SRI LATURI SINGH SRI RAM MAHA VIDHALYA,DHUMARI,ETAH",
  "Maharani Banaras Mahila Mahavidyalaya, Ramnagar, Varanasi",
  "ASHA PHARMACY COLLEGE KUSMURA BARAGAON VARANASI",
  "SHIV PRASHIKSHAN SANSTHAN",
  "SAI COLLEGE OF PHARMACY, SIKATIYA, MAU     ",
  "BABA RAGHAV DAS MEDICAL COLLEGE GORAKHPUR    ",
  "BHAGWANTI EDUCATION CENTRE DEGREE COLLEGE., MANDHANA, BITHOOR ROAD,",
  "ANKALIKAR VANI MASIK PATRIKA SAMITI COLLEGE PRATAPNER PARASANI PILUA MAHAVEER ROAD ETAWAH",
  "ROBIN COLLEGE OF EDUCATION AND TECHNOLOGY",
  "BANSHI COLLEGE OF EDUCATION, MOHAMMADPUR,BITHOOR, KANPUR NAGAR",
  "SUBHADRA DEVI MULA RAM KRISAK MAHAVIDYALAYA HAMZAPUR, NIGOHI",
  "JAGANNATH PRASAD BHAGWAN DEI SAHU MAHAVIDYALAY",
  "VIDYA NIKETAN DEGREE COLLEGE,",
  "MAHATMA VIDUR AUTONOMOUS STATE MEDICAL COLLEGE, BIJNOR    ",
  "BANARAS INSTITUTE OF TEACHERS EDUCATION, NIBAH, PINDRA, VARANASI",
  "Sw. Purushottam Mahavidyalaya,Halpur Govindpur, Ghazipur",
  "Shrimati Rajdei Singh Mahila Mahavidyalaya, Takha (Pashchim), Shahgunj , Jaunpur",
  "SHRI GANDHI GRAMODYOG MAHAVIDHYALAYA BHARAUSA MOTH,JHANSI    ",
  "AUTONOMOUS STATE MEDICAL COLLEGE HARDOI",
  "RAJKALI INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "DHIRENDRA SINGH JITENDRA SINGH MAHAVIDHYALAY BACHHARAN CHITRAKOOT UTTAR PRADESH",
  "GANPAT SAHAI VIDHI MAHAVIDYALAYA PAYAGIPUR SULTANPUR",
  "DAYA SAVITRI MAHILA MAHAVIDYALAYA    ",
  "DEEPCHAND SINGH MAMORIAL DEGREE COLLEGE    ",
  "EMERALD NURSING INSTITUTE BARABANKI    ",
  "P P SINGH SMARAK EDUCATION COLLEGE    ",
  "HARI SAHAY LAW COLLEGE",
  "RAMPAL SINGH MAHAVEER SINGH KRASI MAHAVIDYALAYA SITAPUR    ",
  "S R EDUCATIONAL INSTITUTE OF LAW",
  "VINDHYA GURUKUL COLLEGE OF PHARMACY",
  "SITA DEVI LAW COLLEGE RASOOLPUR, BADOSARAI, BARABANKI     ",
  "THAKUR YUGRAJ SINGH COLLEGE OF MEDICAL AND SCIENCE     ",
  "MAHARSHI DEVRAHA BABA AUTONOMOUS STATE MEDICAL COLLEGE DEORIA",
  "SITARAM INSTITUTE OF TECHNOLOGY,MAVI,MEERUT",
  "K S MAHILA MAHAVIDYALAYA JHAKRI MAURANIPUR",
  "S N SEWA SANSTHAN GIRLS DEGREE COLLEGE",
  "ALHAI SHIKSHAK PRASHIKSHAN SANSTHAN UMMEDJOT KHORASHA GONDA",
  "J P MAHILA MAHAVIDYALAY ATESUA MURDAHA BAZAR VARANASI",
  "SHRI RAM AWATAR CHAUBEY MAHAVIDYALAY DHADHANI BHANMAL RAI JAMANIYA GHAZIPUR",
  "SRI RAMDULARE SHUKLA MAHAVIDYALAYA    ",
  "PATHFINDER RESEARCH AND TRAINING FOUNDATION    ",
  "CHAUDHARY PHOOL SINGH ARYA KANYA MAHAVIDALYA DADARI ROAD PICHOKRA BAGHPAT",
  "DR KAILASH NATH SINGH VIDHI MAHAVIDYALAYA, NAUDHIYA UPARHAR, SHANKARGARH, ALLAHABAD    ",
  "RAJSHREE AYURVEDIC MEDICAL COLLEGE AND HOSPITAL    ",
  "SMT SYAMADEVI HARSH MAHAVIDYALYA BHAVANIGARH SULTANPUR    ",
  "PT BHOOPAL DAS MEMORIAL DEGREE COLLAGE MALKHANPUR BISAULI BUDAUN",
  "SHRIMAD DAYANAND KANYA GURUKUL MAHAVIDYALAYA, CHOTIPURA, AMROHA",
  "RENUKA GIRLS DEGREE COLLEGE, VINAYAKPUR, SULTANPUR",
  "K R B DEGREE COLLEGE ASAN ROAD KOTAKI SIKARARI TUNDLA FIROZABAD",
  "VIKRAMA PRASAD SINGH MAHILA MAHAVIDYALAYA, BIRAPATTI, VARANASI",
  "SHYAM COLLEGE BHARHARA NEAR TELIYANI BLOCK FATEHPUR",
  "S R EDUCATIONAL INSTITUTE",
  "JAY GURUDEV RAM SUMIRAN KRIPAL MAHAVIDYALAY KALEND HARDO SKN",
  "SMT RAJKUMARI LAW COLLEGE",
  "SGL GIRLS COLLEGE OF SCIENCE AND TECHNOLOGY SONKH GOVERDHAN ROAD PAINTHA MATHURA",
  "MAHADEV RAMSWAROOP DEGREE COLLEGE",
  "DR K L PATEL COLLEGE OF PROFESSIONAL STUDIES SORAON PRAYAGRAJ ",
  "SANJIVNIE COLLEGE OF EDUCATION AND TEACHERS TRAINING BPES ALADADPUR KIRTANPUR BAHRAICH",
  "VASUDEV JANTA MAHAVIDYALAYA",
  "KOHANDAUR LAW COLLEGE",
  "AUTONOMOUS STATE MEDICAL COLLEGE",
  "PT SOM CHANDRA DWIVEDI VIDHI MAHAVIDYALAYA BAMHRAULI SIRATHU KAUSHAMBI",
  "VAIBHAV GIRLS COLLEGE OF EDUCATION",
  "SIDDH VINAYAK MAHAVIDYALAY ",
  "WHITE FEATHERS DEGREE COLLEGE",
  "MLS COLLEGE RUDAULI AYODHYA",
  "PAHALWAN GURUUDEEN VIDHI MAHAVIDYALAYA",
  "BHARAT SINGH MEMORIAL DEGREE COLLEGE ",
  "NANHI DEVI RAGHUNATH SINGH SMRITI KANYA MAHAVIDYALAYA",
  "PRACHI LAW COLLEGE",
  "VIIT PHARMACY COLLEGE",
  "BLOOMING BUDS B ED COLLEGE KOLHUA SANT KABIR NAGAR",
  "MAHATMA JYOTIBA RAO PHOOLE DEGREE COLLEGE ADILABAD JAGDISHPURAM MOHAMDABAD GHAZIPUR",
  "SARASWATI SHIKSHAN PRASHIKSHAN MAHAVIDYALYA",
  "SAINATH INSTITUTE OF PARAMEDICAL AND NURSING SCIENCES HINDUWARI SONEBHADRA ",
  "DAYAWATI MAHAVIDYALAYA",
  "DR RAM MANOHAR LOHIA MAHAVIDYALAYA PARTAWAL BAZAR MAHRAJGANJ ",
  "LATE GAJRAJ SINGH MAHAVIDYAYA",
  "SHIVPRASANN SINGH SMARAK MAHAVIDYALAYA, BHITAULI BAZAR, MAHARAJGANJ",
  "SARSWATI DEVI BALIKA MAHAVIDYALAYA BRIDGMANGANJ, MAHARAJGANJ",
  "Sakaldiha P.G.College, Chandauli",
  "R. P. YADAV BALIKA MAHAVIDYALAYA, MAHULI BAZAR, SANT KABIR NAGAR",
  "RAMYASH LAW COLLEGE     ",
  "PT. RAJAT DEGREE COLLEGE, MAJHAUWA PARVATA VISHWANATHPUR,  SANT KABIR NAGAR",
  "PT. RAJAN MAHILA DEGREE COLLEGE, PACHPEDIYA, BASTI",
  "JAY NAND SPECIAL TEACHERS TRAINING INSTITUTE",
  "B B S INSTITUTE OF PROFESSIONAL STUDIES PHAPHAMAU PRAYAGRAJ    ",
  "DRONACHARYA AYURVEDIC EDUCATIONAL INSTITUTE AND HOSPITAL",
  "PT. CHANDRADEV PANDEY MAHAVIDYALAYA, KAULAHI, HAISAR BAZAR,  SANT KABIR NAGAR",
  "BHAGIRATHI KRISHAK MAHAVIDYALAYA, BHAGIRATHI NAGAR, MAHARAJGANJ",
  "MAMTA MAHAVIDYALAYA NAIPAI FIROZABAD",
  "SMT. GYAN KUMARI SINGH KANYA MAHAVIDYALAYA, BATHUA PURWA, GORAKHPUR",
  "SWARGEEYA KALIKA PRASAD DUBEY MAHAYIDYALAYA, AKDANGA, KHJANI ,  GORAKHPUR",
  "BAPU AYURVEDIC MEDICAL COLLEGE EVAM HOSPITAL ",
  "SHEEL SAGAR MAHAVIDYALAYA, HIRNAHI, KINDEPATTI, KUSHINAGAR",
  " NATIONAL INSTITUTE FOR THE EMPOWERMENT OF PERSONS WITH INTELLECTUAL DISABILITIES REGIONAL CENTRE NOIDA",
  "SHARADA DEVI MAHILA MAHAVIDYALAYA , KURMI PATTI, PATHRDEWA , DEORIA",
  "SWARGEEYA RAM RAHASYA MAHAVIDYALAYA, SINGHPUR, CHAURI CHAURA, GORAKHPUR",
  "SRI RATI RAM MAHAVIDYALAYA,NAND GAON, BARSANA ROAD, MATHURA",
  "SHRIMATI TAPESHWARI DEVI MAHILA MAHAVIDYALAYA, NAI BAZAR, GORAKHPUR",
  "OM SAI KRIPA MAHAVIDYALAYA, KUNDAULI, LAR, DEORIA",
  "MAA FULPATI DEVI MAHILA MAHAVIDYALAYA, RAMPUR KARKHANA, DEORIA",
  "SWAMI VIVEKANAND SMARAK MAHAVIDYALAYA, CHANDI, KESHWAPAR, GORAKHPUR",
  "SHIVDULARI DEVI DALDAPAT SHAHI MAHILA MAHAVIDYALAYA, RAMKOLA ,  KUSHINAGAR",
  "S S Prashikshan Sansthan Mahila Mahavidyalaya",
  "SADGURU RAMASHRAY DAS MAHAVIDYALAYA, PALI, BANSGAON, GORAKHPUR",
  "S. K. KANYA MAHAVIDYALAYA, TILAULI, SOHNAG, DEORIA",
  "RANA DILEEP CHANDRA SINGH KISMATI DEVI VIDYAPEETH MAHAVIDYALAYA,  GORAKHPUR",
  "RAMESH CHANDRA RAO NAVTAPPI MAHAVIDYALAYA, RAMPURGARH, DEORIA",
  "NARMADA DEVI MAHILA MAHAVIDYALAYA, KARAM YOGI KAMLA NAGAR,VIMAL VATIKA, AGRA",
  "RAM CHANDRA MANISH KUMAR MAHAVIDYALAYA , KUSHINAGAR",
  "SRI RADHE JAMUNA DEVI KANYA DEGREE COLLEGE, AGRA",
  "RAM ADHAR SINGH MAHAVIDYALAYA, RAJWAL, BHEUSA, KHAJNI, GORAKHPUR",
  "RAJKIYA MAHAVIDYALAYA, DHADHA BUZURG (HATA), KUSHINAGAR",
  "RAJESHWARI DEVI RAM SUBHAG SINGH MAHAVIDYALAYA, KURMIPATTI, PATHARDEVA,  DEORIA",
  "SETH RAMSWAROOP GOVINDI DEVI DEGREE COLLEGE,AGRA",
  "MAA FEKANA DEVI BALIKA MAHAVIDYALAYA SULTANPUR AMIHIT JAUNPUR",
  "Dhruva Narayan Mahila mahavidyalaya dhankari bhadra maharajganj ",
  "MASCOT COLLEGE OF PHARMACY",
  "DIXIT COLLEGE OF LAW",
  "S K MISHRA COLLEGE OF PHARMACY, AZAMGARH ",
  "SHYAM SINGH VIDHI MAHAVIDYALAY, MAHRAUDA, SAHSON, PRAYAGRAJ    ",
  "DAULATPUR MAHAVIDYALAYA DAULATPUR, BARABANKI",
  "Raj Kumar Goel Institute of Technology &  Management,Ghaziabad",
  "Kedar Smarak sanskrit Mahavidyalay Devghariya Ibrahimpatti Ballia Uttar Pradesh",
  "MAA ANJANI INSTITUTE OF EDUCATION ETAH ROAD, SHIKOHABAD",
  "MAHARSHI BABA GALUDAS GANGA SAGAR MAHAVIDYALAYA",
  "PRABHAKAR COLLEGE OF PHARMACY",
  "Seeta Sharan Singh Mahavidyalay",
  "SURYA BUKSH SINGH MAHAVIDYALAYA REACH RUDAULI AYODHYA    ",
  "MAHENDRA SINGH MEMORIAL EDUCATIONAL INSTITUTE",
  "VIDYA INSTITUTE OF FASHION TECHNOLOGY, BAGHPAT ROAD, MEERUT.",
  "Sree Narpati Singh Mahavidyalaya, Ujarauti Kala, Sant Kabir Nagar",
  "VIDYA COLLEGE OF ENGINEERING, MEERUT",
  "VENKATESHWARA INSTITUTE OF TECHNOLOGY, DELHI- RORRKEE BYPASS, JATOLI, MEERUT",
  "Shri Ram College of Pharmacy",
  "CHAUDHARY REWAT SINGH DEGREE COLLEGE BILARI HANDALPUR SAMBHAL",
  "VEER KUNWAR INSTITUTE OF TECHNOLOGY, NAGINA ROAD, BIJNOR",
  "UNNATI MANAGEMENT COLLEGE, DAULATPUR, FARAH, MATHURA",
  "UNITED INSTITUTE OF MANAGEMENT, GREATER NOIDA",
  "SUNDER DEEP COLLEGE OF ARCHITECTURE & PLANNING, GHAZIABAD",
  "SSLD VARSHNEY INSTITUTE OF MANAGEMENT AND ENGINEERING,ALIGARH",
  "SSLD VARSHNEY GIRLS ENGINEERING COLLEGE, ALIGARH - KANPUR G.T. ROAD, ALIGARH",
  "SHREE JEE BABA INSTITUTE OF PROFESSIONAL STUDIES, SEMARI CHATA, MATHURA",
  "SHREE BANKEY BIHARI INSTITUTE OF MANAGEMENT, MEERUT",
  "SHREE BANKEY BIHARI INSTITUTE OF ARCHITECTURE,MEERUT",
  "SHANTI NIKETAN TRUSTs GROUP OF INSTITUTIONS AND FACULTY OF MANAGEMENT, MEERUT",
  "S.D. COLLEGE OF PHARMACY AND VOCATIONAL STUDIES, MUZAFFARNAGAR",
  "S.D.COLLEGE OF ENGINEERING AND TECHNOLOGY, MUZAFFARNAGAR",
  "RUDRA GROUP OF INSTITUTIONS, MEERUT",
  "SHRIMATI URMILA DEVI MAHILA MAHAVIDYALAY SEKHUI RITHIYA BAZAR SIDDHARTHNAGAR    ",
  "RSD ACADEMY COLLEGE OF MANAGEMENT AND TECHNOLOGY, MORADABAD",
  "RISHI INSTITUTE OF ENGINEERING AND TECHNOLOGY, MEERUT",
  "VISHVESHWARYA GROUP OF INSTITUTIONS, DADRI",
  "RAKSHPAL BAHADUR MANAGEMENT INSTITUTE, GREATER NOIDA",
  "RAJ KUMAR GOEL INSTITUTE OF TECHNOLOGY, GHAZIABAD",
  "SWARNIM BHARAT KANYA MAHAVIDHYALAY, KOTA KHASGARI, ALIGARH",
  "SHRI BADRINATH COLLEGE OF PHARMACY",
  "RAJEEV ACADEMY FOR TECHNOLOGY AND MANAGEMENT, MATHURA",
  "RAJA S.P SINGH DEGREE COLLEGE GWALIOR ROAD ITORA AGRA",
  "RADHA GOVIND INSTITUTE OF PHARMACY, MORADABAD-CHANDAUSI ROAD, MORADABAD",
  "RADHA GOVIND ENGINEERING COLLEGE, MEERUT",
  "VIRENDRA SINGH CHAUHAN MAHAVIDHYALAYA HANUMANTA JAITHARA ETAH    ",
  "RAM PRAKASH SINGH BALIKA COLLEGE DHUMARI ETAH    ",
  "INSTITUTE OF ADVANCE MANAGEMENT AND TECHNOLOGY, MERRUT",
  "SHRI KS LAW COLLEGE    ",
  "SHANTI INSTITUTE OF TECHNOLOGY,MEERUT",
  "INSTITIUTE OF ADVANCED MANAGEMENT AND RESEARCH, GHAZIABAD",
  "INDRAPRASTHA INSTITUTE OF MANAGEMENT AND TECHNOLOGY, SAHARANPUR",
  "INDERPRASTHA ENGINEERING COLLEGE, GHAZIABAD",
  "SHREE LATE BECHU SINGH KANHPURIYA MAHAVIDYALAYA JANAPUR JAMON AMETHI",
  "IMS ENGINEERING COLLEGE, GHAZIABAD",
  "VISION INSTITUTE OF TECHNOLOGY, SHAHPUR MADRAK, ALIGARH",
  "VISHVESWARYA INSTITUTE OF TECHNOLOGY, DADRI,GREATER NOIDA PHASE -II,G B NAGAR",
  "VINAYAK VIDYAPEETH, PAWLIKHAS, MODIPURAM, MEERUT",
  "SHRI GOPI CHAND INSTITUTE OF TECHNOLOGY AND MANAGEMENT, BAGHPAT",
  "VRINDAVAN LAW COLLEGE, VRINDABAN, MATHURA",
  "RAJENDRA PRASAD LAW COLLEGE DHOKARI PHOOLPUR PRAYAGRAJ",
  "R S MAHAVIDYALAYA BAGI KADAURA ORAI JALAUN",
  "VIDYAWATI DEVI LAW COLLEGE",
  "SHRI RAMCHARAN SMARAK SHIKSHAN SANSTHAN SHIV NAGAR KUMARGANJ AYODHYA ",
  "RAM NAGINA SONANCHAL MAHAVIDYALAY",
  "SSS COLLEGE OF PHARMACY",
  "NEELAM COLLEGE OF ENGINEERING AND TECHNOLOGY, KIRAWALI, AGRA",
  "BHAGWAN DAS LILAVATI COLLEGE, BAMRAULI AHIR, AGRA",
  "MORADABAD EDUCATIONAL TRUST (MET) GROUP OF INSTITUTIONS, FACULTY OF PHARMACY, MORADABAD",
  "ALLAMA IQBAL UNANI MEDICAL COLLEGE,",
  "AMRAPALI AYURVEDIC MEDICAL COLLEGE AND HOSPITAL ",
  "ERA COLLEGE OF NURSING    ",
  "R J College of Pharmacy",
  "HARI COLLEGE OF PHARMACY",
  "MURAD LARI EDUCATIONAL INSTITUTE DHANPURAWA SALEMPUR DEORIA",
  "BHAGWATI COLLEGE OF PHARMACY",
  "TDL COLLEGE OF ENGINEERING AND MANAGEMENT SCIENCES",
  "ANKERITE AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "SATYADEO COLLEGE OF PHARMACY",
  "INDRA PRASTHA INSTITUTE OF MANAGEMENT AND TECHNOLOGY UMAHI KOTA SAHARANPUR",
  "RAM-EESH INSTITUTE OF ENGINEERING & TECHNOLOGY",
  "RAM-EESH INSTITUTE OF VOCATIONAL & TECHNICAL EDUCATION",
  "ERAS INSTITUTE OF ALLIED HEALTH SCIENCE AND RESEARCH    ",
  "CITY COLLEGE",
  "TULSIRAM MAHAVIDHYALAYA,BIDHUNA",
  "Raj School of Management and Sciences",
  "MISSION COLLEGE OF PHARMACY SIRISHTI BHAGATUA VARANASI",
  "JANTA COLLEGE OF PHARMACY, NOORPUR",
  "Dadi Rajmati Devi Mahila Mahavidyalay",
  "VISHVESHWARYA COLLEGE OF PHARMACY",
  "BRAHMDEV GULAB SINGH COLLEGE, KASAUJHA URF PURE RAGHAI HANDIA",
  "BALIRAJI RAMDEEN SHARAMA MAHILA MAHAVIDYALAY",
  "VINDHYAVASINI KRISHNA BIHARI MAHILA MAHAVIDYALAYA, AURAI, FATEHPUR",
  "R J Degree College, Rampur, Balbhadra Ghazipur",
  "GOVIND LAW COLLEGE BHAGWATNAGAR PARSIYA LOK VIDYAPEETH NAGAR FARENDA ",
  "ORLEAN COLLEGE OF PHARMACY",
  "R B AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "SHYAM NARAYAN URMILA GIRLS TEACHER TRAINING COLLEGE",
  "Goel Institute of Pharmaceutical Sciences",
  "Mata Shivraji Devi Veer Mahavidyalay",
  "LALITA SINGH INSTITUTE OF HIGHER EDUCATION, KUSHANBRAHMAN, BALLIA",
  "PANNO DEVI SIKSHAN SANSTHAN",
  "SANSKRITI COLLEGE OF HIGHER EDUCATION AND STUDIES",
  "SHRI BABU SINGH INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "GOEL AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "AMBRISH SHARMA COLLEGE OF EDUCATION,  TECH HAPUR ROAD MEERUT",
  "CHAUDHARY BADRI PRASAD SITARAM MAHAVIDYALAYA RASADA BILLAHARGHAT FAIZABAD",
  "MAHARANA PRATAP COLLEGE OF PHARMACEUTICAL SCIENCES ",
  "Government Pharmacy College BRD Medical College Campus Gorakhpur",
  "VIDUSHI MAHILA MAHAVIDYALAYA ",
  "THE STUDY HALL COLLEGE",
  "Rishi Ramnaresh college of pharmacy",
  "CHATARPATI SHIVAJI MAHAVIDYALAYA, BADURGARH, HAPUR",
  "RAJKUMAR GOEL GIRLS DEGREE COLLEGE, GARHMUKTESHWAR, HAPUR",
  "CH. MAHENDRA SINGH DEGREE COLLEGE, GARHMUKTESHWAR, HAPUR",
  "MAA SARASWATI NAWAL SINGH KANYA MAHAVIDHYALAYA,MADAK TAPPAL ALIGARH",
  "HAR HAR MAHADEV MAHILA SHIKSHAN SANSTHAN MATHANA CHUNAR MIRZAPUR",
  "L N PHARMACY COLLEGE",
  "H.L.M GIRLS COLLEGE  JINDAL NAGAR",
  "SHREE GEET LAW COLLEGE",
  "PASHUPATI  INSTITUTE OF STUDIES PILAKHUWA, HAPUR",
  "SANSKAR COLLEGE OF ARCHITECTURE AND PLANNING, HAPUR",
  "J B S INSTITUTE MALINPUR RAMSANEHI GHAT",
  "SARASWATI INSTITUTE OF ENGINEERING AND TECHNOLOGY, HAPUR",
  "SWAMI VIVEKANAND LAW COLLEGE, HAPUR",
  "PRABHA DEVI BHAGWATI PRASAD VIDHI MAHAVIDYALAYA",
  "SANSKAR COLLEGE OF PHARMACY AND RESEARCH, HAPUR",
  "KANCHAN BALIKA VIDYALAYA ",
  "SHREE SHREE MAHASANT BAIJU BABA SIKSHAN SANSTHAN CHANDAULI",
  "CHANDNI COLLEGE OF NURSING",
  "SHRI MAHABALI BALCHAND MAHAVIDYALAYA, SARDARPUR BADDUPUR GHAZIPUR",
  "PAHALWAN GURUDEEN COLLEGE ",
  "Kamala Devi Durga Das Mahavidyalaya, Bashia, Partawal, Maharajganj",
  "VASUDEV SINGH MAHAVIDYALAYA",
  " A G HASHMI DEGREE COLLEGE ",
  "MAA VAISHNO DEVI SIDDHNATH SHUKLA MAHILA MAHAVIDYALAYA SIKSHAN EVAM PRASHIKHAN SANSTHAN PALI ROAD SHUKUL BAZAR AMETHI",
  "K D C College of Pharmacy",
  "KAMAYANI MAHAVIDYALAYA, AJIYAURDEI, LOHIA NAGAR, ALIGANJ, SULTANPUR",
  "ARK COLLEGE OF PHARMACY",
  "KRISHNA PHARMACY COLLEGE",
  "SUYASH MAHAVIDYALAYA",
  "BON MAHARAJ INSTITUTE OF MANAGEMENT AND TECHNOLOGY, RAMAN RATI, VRINDAVAN, MATHURA",
  "A.K COLLEGE ,SHIKOHABAD,(FIROZABAD)",
  "SMT. MAHADEVI MAHAVIDYALAYA SIDDHI BABA ASHRAM BHAROUL SHIKOHABAD(FIROZABAD)",
  "M.D.COLLEGE LAWYERS COLONY, BYE PASS ROAD, AGRA",
  "INCREDIBLE INSTITUTE OF MANAGEMENT & TECHNOLOGIES, ACHHNERA, AGRA",
  "Rajkiya Mahila Snatkottar Mahavidyalaya, Ghazipur",
  "MAA ISWARI DEVI UNHAR SINGH DEGREE COLLEGE GANESH PUR BALAPUR ,MAINPURI",
  "SHRI GANGA SAHAY KANYA MAHAVIDYALAYA, MAINPURI",
  "B.L.COLLEGE OF EDUCATION PADUA ROAD, BHOUNGAN, MAINPURI",
  "KUNAL PROFFESSIONAL EDUCATIONAL ACADEMY, TEHRA, AGRA",
  "L.R DEGREE COLLEGE,JASRANA ,FIROZABAD",
  "DALVEER SINGH DEGREE COLLEGE, SHIKOHABAD",
  "S.D BHADAWAR DEGREE COLLEGE CHALLESOR,AGRA",
  "Ramdular Sanskrit Mahavidyalaya, Belakhas, Saraynmamarej",
  "R P Memorial Mahavidyalaya",
  "SRI KRISHNA DUTT ACADEMY",
  "JAI HANUMAN MAHAVIDYALAYA HARBANSHPUR JABDI SHRAVASTI",
  "Shanti Devi Mahila Mahavidyalaya",
  "HARIDWAR GAURISHANKAR MAHILA MAHAVIDYALAYA",
  "INDRASHANI KUNWAR INSTITUTE OF HIGHER EDUCATION",
  "DR B P S COLLEGE OF LAW BAKALPUR SHAMSABAD ROAD AGRA",
  "SHRIDEVI MEMORIAL MAHAVIDYALAYA KAKRARA SHIKOHABAD FIROZABAD",
  "AMARDEEP COLLEGE OF PHARMACY",
  "Aditya College of Law",
  "CHAUDHARY TRIVENI RAM PREM NATH MAHILA MAHAVIDAYALAYA ",
  "Jagadguru Swami Krishnacharya Mahavidhyalaya, Pure Inchha Mishra Benipur Baldeo, Gauriganj",
  "SHRIMATI SHYAMA DEVI DEGREE COLLEGE OF SCIENCE AND MANAGEMENT",
  "RAM KRISHNA VIDYAWATI MAHAVIDYALAYA, SAKARAN",
  "Iswar Saran Degree College",
  "AKBARPUR DEGREE COLLEGE, AKBARPUR",
  "S L D GIRLS COLLEGE",
  "INSTITUTE OF TECHNOLOGY & MANAGEMANT, CHEARI PHARENDA ROAD, MAHARAJGANJ",
  "SRI VASUDEV PRATHMIC SHIKSHA PRASHIKSHAN SANSTHAN, GUTWAN JAUNPUR",
  "SHRI SIDDHI VINAYAK INSTITUTE OF TECHNOLOGY, NAINITAL ROAD, BAREILLY",
  "SHRI SIDDHI VINAYAK INSTITUTE OF MANAGEMENT, NAINITAL ROAD, BAREILLY",
  "Shri Rajnath Pandey Sanskrit Mahavidyalaya, Tiwaripur, Pandeypur",
  "TH RAJESH SINGH MAHAVIDHAYALYA, PANCHAVALI ROAD",
  "UNITED INSTITUTE OF MANAGEMENT, ALLAHABAD ",
  "UNITED COLLEGE OF ENGINEERING AND RESEARCH, ALLAHABAD",
  "Chaudhary Mahadeo Prasad Degree College",
  "SARA SINGH DEGREE COLLEGE BILSAR ROAD ALIGANJ",
  "OM MAA VESHNO DIGREE COLLEGE, KUSHIYARI JASRANA, FIROZABAD",
  "Bhagavat Sanskrit Mahavidyalaya, Rusi Mandir Ayodhya",
  "M S INSTITUTE OF EDUCATION SHYAMPUR JLEELPUR GANJDUNDWARA ROAD KASGANJ",
  "UDAYVEER SINGH MAHAVIDYALAYA, JONAI, SAINYA, AGRA",
  "S.M.S. MAHAVIDYALAYA, NAGALA SANJA, MATHURA",
  "DIRVED GIRI MEMORIAL COLLEGE OF EDUCATION",
  "ANEETA DEVI BALIKA MAHAVIDYALAYA, ARJUNPUR, MAINPURI",
  "GHANSHYAM GIRI GIRLS COLLEGES OF EDUCATION",
  "SHRI RAGHUVEER SINGH MAHAVIDYALAYA, UTRARA, FIROZABAD",
  "SHRI DAUJI MAHARAJ DIGREE COLLEGE, SAMSHABAD ROAD, AGRA",
  "SHANTI UDAY COLLEGE OF SCIENCE AND TECHNOLOGY, AKOLA MALPURA, AGRA",
  "KMC COLLEGE OF NURSING MAHARAJGANJ",
  "AUTONOMOUS STATE MEDICAL COLLEGE",
  "MERIDIAN NURSING AND PARAMEDICAL COLLEGE",
  "MAHAMAYA RAJKIYA ALLOPTHIC MEDICAL COLLEGE, AMBEDKAR NAGAR",
  "MASTER SCHOOL OF MANAGEMENT STUDIES",
  "DR S N DEV COLLEGE OF EDUCATION SIKKA SHAMLI ",
  "LTR SHIKSHA SANSTHAN GIRLS WING",
  "DIXIT MAHAVIDHYALAYA BHATAULA JALALI ALIGARH",
  "SHIV SUMAN MAHILA MAHAVIDYALAYA SHIV NAGAR ALIGANJ ROAD ETAH",
  "SHREE SHYO PRASAD SHANTI DEVI MAHAVIDHYAL",
  "SHRI VISHNU BHAGWAN MAHAVIDYALAYA",
  "DR RISHIKANT SIDDHARTH MAHAVIDYALAYA SAHAWAR KASGANJ",
  "G.S. LAW COLLEGE, FAFOOND ROAD, AURRAIYA",
  "CH. B.S. BALIKA MAHAVIDYALAYA, JALDEVINAGAR, MAINPURI",
  "CH. PREM SINGH PREMWATI MAHAVIDYALAYA, GANESHPUR, MAINPURI",
  "CH. SUNDER LAL MAHAVIDYALAYA KUSHMARA, MAINPURI",
  "SHRI GOVIND SINGH MAHAVIDYALAYA, JHALGOPALPUR, FIROZABAD",
  "CHODHARY KIRAN ACADEMY, FATHEPUR SIKARI ROAD, KIRAWALI, AGRA",
  "SHRIMATI KALAVATI DEVI MAHAVIDYALAYA, BANGURI SAMSHABAD ROAD, AGRA",
  "SHRIMATI ILAYECHI DEVI MAHAVIDYALAYA, BAROLI GURJAR, AGRA",
  "SURESH CHANDRA SINGHAL MEMORIYAL MAHAVIDYALAYA, JAGNER ROAD, AGRA",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION, MALL ROAD, MEERUT CANTT",
  "AMBIKA PRASAD TRIPATHI MAHAVIDYALAYA,CHAYAL",
  "Sant Bula Satyanam Daas Birbal Snatkottar Mahavidyalaya Amiri , Dullahpur Ghazipur",
  "Chandrika Prasad Mishra Mahavidyalay, Gogia Pathak, Shankarpur, Basti",
  "Somnath Basdei Raghsharan Chaudhary Degree College, dhaurukhor, lalganj, basti",
  "Devi Sharan Degree College, Parsauna (Kolhui), Maharajganj",
  "Shree Tara Chand Mahavidyalay, Dhanghata, Sant Kabir Nagar",
  "Srimati Shankar Dei Mahila Degree College, Ghanghata, Sant Kabir Nagar",
  "Sant Ram Krishna Param Hans Mahavidyalay, Bashiya, Gayghat, Sant Kabir Nagar",
  "MAULANA MOHAMMED ALI JOHAR HIGHER EDUCATION INSTITUTE, KIRATPUR",
  "SARDAR BALLABH BHAI PATEL DEGREE COLLEGE, BHOLIPURA",
  "GLORIOUS COLLEGE OF MANAGEMENT AND TECHNOLOGY, FATHEGANJ EAST",
  "SRI KISHAN SINGH DEGREE COLLEGE, CHONTI PURA",
  "SMT SHEELA SMARAK SIKH MAHAVIDYALAYA, KHANDSAL KALAN",
  "SHRI DEVI SINGH INSTITUTE OF EDUCATION, GAJSTHAL",
  "Sumitra Mahavidyalaya ,Sherwa , Jaunpur",
  "SAMA PARVEEN GIRLS DEGREE COLLEGE, HARIYANA, JOYA",
  "N T DEGREE COLLEGE, HASANPUR",
  "GILL INSTITUTE OF HIGHER EDUCATION, KAILSA",
  "A.K.P. Degree College, Khurja (Bulandshahr)",
  "GIRAND SINGH MEMORIAL DEGREE COLLEGE, PILAKPUR DELARI",
  "DHARAMVEER SINGH MEMORIALDEGREE COLLEGE, PO SULTANPUR DOST",
  "BARIK MAHAVIDYALAYA, SEHALI KHADDAR, POST DILARI",
  "AXIS INSTITUTE OF TECHNOLOGY AND MANAGEMENT, KANPUR",
  "AXIS INSTITUTE OF FASHION TECHNOLOGY, KANPUR",
  "IBNE SEENA PHARMACY COLLEGE, HARDOI",
  "IIMT COLLEGE OF PHARMACY, GREATER NOIDA",
  "HIMT COLLEGE OF PHARMACY, GREATER NOIDA",
  "KIPM COLLEGE OF MANAGEMENT, GORAKHPUR",
  "KIPM COLLEGE OF ENGINEERING AND TECHNOLOGY, GORAKHPUR",
  "KAILASH INSTITUTE OF PHARMACY AND MANAGEMENT, GORAKHPUR",
  "INDIAN INSTITUTE OF CARPET TECHNOLOGY, BHADOHI",
  "BUDDHA INSTITUTE OF HOTEL MANAGEMENT",
  "UTKARSH COLLEGE OF MANAGEMENT EDUCATION, BAREILY",
  "Shyam Kanhaiya Rai Balika Mahavidyalaya,  Amaura, Pandaha, Azamgarh",
  "RAKSHPAL BAHADUR COLLEGE OF ENGINEERING AND TECHNOLOGY, BAREILLY",
  "SIDDHARTH LAW COLLEGE   ",
  "Shyama Tiwari Mahavidyalaya, Tinhari , Parsupur ,Mau",
  "Shri Vikrama Chauhan Samrak Mahavidyalaya,Rampur,Bhujahi, Azamgarh",
  "RAJSHREE INSTITUTE OF MANAGEMENT AND TECHNOLOGY, BAREILLY",
  "Shanti College of Teachers Education Khuraso Phoolpur Azamgarh",
  "SHAMBHUNATH MAHAVIDYALAYA TINHARI PARSUPUR MAU",
  "SHAILENDRA MAHILA MAHAVIDYALAYA, JAHANAGANJ, AZAMGARH",
  "SHAHEED ACHHABER MALL MAHILA MAHAVIDYALYA, SULTANPUR, BARAGAWA, MADHUBAN, MAU",
  "LOTUS INSTITUTE OF MANAGEMENT , BAREILLY",
  "RAJA HARISHCHANDRA MAHAVIDYALAY, RUKKUNPUR, RAMPURKANDHI, DEVLAS, MAU",
  "JAI SHREE MAHAVIDYALAY, DAULATPUR, THATHIA, KANNAUJ",
  "K J COLLEGE OF PHARMACY BABATPUR VARANASHI",
  "RAHMANIA DEGREE COLLEGE ROPANPUR, HISMANPUR, MAU",
  "R.A.F MAHILA MAHAVIDYALAYA, SHAMSHABAD, KARAHA, MAU",
  "Sainik Girija Shankar Mahavidyalaya, Kerakat, Jaunpur",
  "UTTAR PRADESH STATE INSTITUTE OF FORENSIC SCIENCES",
  "JAHANGIRABAD EDUCATIONAL TRUST GROUP OF INSTITUTIONS FACULTY ENGINEERING, BARABANKI",
  "SMT FULEHRA SMARAK COLLEGE OF PHARMACY , BALLIA",
  "APEX TRUST NURSING COLLEGE",
  "Hindu College",
  "BHAVDIYA INSTITUTE OF BUSINESS MANAGEMENT, FAIZABAD",
  "RAKSHPAL BAHADUR COLLEGE OF PHARMACY, BAREILLY",
  "Mahadev Mahavidyalaya, Neruvadeeh Gahana, Mau",
  "ANA COLLEGE OF MANAGEMET STUDIES, BAREILLY",
  "A N A COLLEGE OF ENGINEERING AND MANAGEMENT STUDIES, BAREILLY",
  "SHERWOOD COLLEGE OF PHARMACY, BARABANKI",
  "Maa Sharda Snatkottar Mahavidyalaya,Sambhupur Gahaji Azamgarh",
  "KHANDELWAL COLLEGE OF MANAGEMENT SCIENCE AND TECHNOLOGY, BAREILLY",
  "INDRAJEET MAHILA MAHAVIDYALAYA ARAJI DEVARA NAINIJOR (PAKARHIYWA) AZAMGARH",
  "IBN-E-SINA TIBBIYA COLLEGE,",
  "AMAR SHAHEED TH. DARIYAV SINGH MAHAVIDYALAYA, KHAGA,",
  "SHAMBHUNATH INSTITUTE OF PHARMACY, ALLAHABAD",
  "CHHATRAPATI SHAHU JI MAHARAJ COLLEGE OF ENGINEERING AND TECHNOLOGY, ALLAHABAD",
  "B B S COLLEGE OF ENGINERING AND TECHNOLOGY, ALLAHABAD",
  "H.M. Mahavidyalaya, Pivatal, Mau",
  "BUNIYAD MAHAVIDHYALAYA",
  "ABHAY MEMORIAL TRUST GROUP OF INSTITUTIONS, ALLAHABAD",
  "CSM GROUP OF INSTITUTIONS FACULTY OF MANAGEMENT, ALLAHABAD",
  "ARYAN GLOBAL LAW COLLEGE",
  "Harsha College of Education, Kothara, Azamgarh",
  "KRISHNARPIT INSTITUTE OF PHARMACY, ALLAHABAD ",
  "SHIVDAN SINGH INSTITUTE OF TECHNOLOGY AND MANAGEMENT, ALIGARH",
  "Haripal Ji Smarak Mahavidyalaya, Daraura Karha, Mau",
  "Prathviraj Chauhan Institute of Education & Technology, Dhampur",
  "Babu Harihar Singh Smarak Mahavidyalaya Itayal Bhawanipur Azamgarh",
  "SHAMBHUNATH INSTITUTE OF ENGG AND TECHNOLOGY , ALLAHABAD",
  "AADHARSHILA TEACHER TRAINING INSTITUTE FOR WOMEN, VILLAGE LEHARRA KHANPUR",
  "UNITED INSTITUTE OF PHARMACY, ALLAHABAD",
  "SHAMBHUNATH INSTITUTE OF MANAGEMENT, ALLAHABAD",
  "Babu Durga Rai Mahila Mahavidyalaya",
  "DRONACHARYA GROUP OF INSTITUTIONS, GREATER NOIDA, G.B.NAGAR",
  "I.T.S ENGINEERING COLLEGE, GREATER NOIDA",
  "HINDUSTAN INSTITUTE OF MANAGEMENT & COMPUTER STUDIES, MATHURA",
  "Baba Vishwnath Mahavidyalaya,Nibi,Mohamdlla Azamgarh",
  "AMANI GROUP OF INSTITUTIONS, AMROHA",
  "Shri Paramhans Sanskrit Pathshala, Sangat Lahouri Tola",
  "Apex College of Nursing Varanasi",
  "SRI  GIRIRAJ GIRI MAHAVIDHYALAYA RORA MAURANIPUR ",
  "RAM AVADH SINGH MAHAVIDYALAYA SONBHADRA",
  "ITM AYURVEDIC MEDICAL COLLEGE AND HOSPITAL CHEHARI MAHARAJGANJ",
  "KALKA ENGINEERING COLLEGE, PARTAPUR BYPASS ROAD, MEERUT",
  "CHARAK AYURVEDIC MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTER",
  "INSTITUTE OF TECHNOLOGY AND MANAGEMENET, MEERUT-BAGHPAT ROAD, PANCHLI, MEERUT",
  "SUDAMA DEVI MAHILA MAHAVIDYALAYA CHANDAULI",
  "INSTITUTE OF MANAGEMENT EDUCATION, GHAZIABAD",
  "NARAYAN INSTITUTE OF EDUCATION AND TECHNOLOGY GARH ROAD, SISOLI, MEERUT Ph. No 9456262543, 9456685015, 9897476539",
  "INSTITUTE OF MANAGEMENT AND RESEARCH, GHAZIABAD",
  "DR. K.N. MODI INSTITUTE OF ENGG. & TECHNOLOGY, GHAZIABAD",
  "RAJA BALWANT SINGH MANAGEMENT TECHNICAL CAMPUS, AGRA.",
  "RAJA BALWANT SINGH ENGINEERING TECHNICAL CAMPUS, AGRA",
  "MORADABAD INSTITUTE OF TECHNOLOGY, MORADABAD.",
  "PREM CHANDRA LAW COLLEGE BAHSAR TIRWA KANNAUJ",
  "MEERUT INSTITUTE OF TECHNOLOGY, BARAL, PARTAPUR, MEERUT",
  "KUNWAR SATYAVIRA COLLEGE OF ENGINEERING AND MANAGEMENT, BIJNOR.",
  "CENTRAL PUBLIC SCHOOL FOR GIRLS ",
  "SWATI HOSPITAL AND AYURVEDIC MEDICAL COLLEGE ",
  "Allahabad Degree College",
  "CH. KHACHERE L AL MAHILA MAHAVIDYALAYA, PIPRIKALA",
  "MSD COLLEGE OF LAW AND HIGHER STUDIES",
  "C L Gupta Eye Institute",
  "Vimla Ramashankar Mahavidyalaya, Yusuphpur, Shahpur, Ghazipur",
  "MAA SHAHZADI DEVI MEMORIAL NURSING COLLEGE",
  "DAYA SHANKAR TIWARI VIDHI MAHAVIDYALAYA",
  "Government Raza Post Graduate College",
  "BAIJNATH RAMNARESH LAW COLLEGE",
  "SHAHID BHAGAT SINGH LAW COLLEGE, BITHOOR,",
  "P.S.M. DEGREE COLLEGE,",
  "SWAMI VIVEKANAND LAW COLLEGE, DUNIYAPUR, HARAHUA, VARANASI",
  "GAURINATH COLLEGE OF EDUCATION",
  "DHANVANTARI AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "OM SAI RAM GROUP OF COLLEGE KURSI BARABANKI",
  "ADHYANT INSTITUTE OF PROFESSIONAL EDUCATION",
  "OM SAI COLLEGE OF EDUCATION ",
  "AMAR SAHID KANCHAN SINGH MAHAVIDYALAYA, SHIVPURI, KHAGA,",
  "M N B MEMORIYAL MAHAVIDYALAYA BALLIA",
  "DPBS COLLEGE, ANUPSHAHR",
  "LLOYD SCHOOL OF LAW",
  "SANSKAR COLLEGE OF MANAGEMENT AND PROFESSIONAL STUDIES HAPUR",
  "MAA BHAGWATI MAHAVIDHYALAYA BICHPURI MANAI ALIGARH",
  "SHARDA COLLEGE OF PHARMACY",
  "DWARIKA PRASAD HIRAWATI LAW COLLEGE, NASARATPUR, PHOOLPUR, PRAYAGRAJ, UTTAR PRADESH",
  "BABU YUGRAJ SINGH AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "Shri Ram Sharan Janata Janardan Sanskrit Mahavidyalaya, Rudauli, Rudranagar",
  "SHRI LAL SINGH SUSHILA DEVI EDUCATIONAL INSTITUTE MENDU HATHRAS",
  "BABU YUGRAJ SINGH COLLEGE OF MEDICAL AND SCIENCES",
  "MANIRAJJI PANDEY SHIKSHAN AVAM PRASHIKSAN MAHILA MAHAVIDYALAYA RAMSAPUR LAHENGA SALON RAEBARELI",
  "DR RAM MANOHAR LOHIA COLLEGE OF PHARMACY",
  "PT SATISH CHAND RAMA DEVI DEGREE COLLEGE    ",
  "MAA MOTI DEVI MAHILA PROFESSIONAL HIGHER EDUCATIONAL INSTITUTE    ",
  "BABU HARI RAM SINGH VIDHI MAHAVIDYALAYA, MANDARI, PRAYAGRAJ    ",
  "SHRI RAM DAYAL SINGH MAHAVIDYALA PARIGAON BHANWAT MAINPURI    ",
  "JMS INSTITUTE OF TECHNOLOGY, GHAZIABAD    ",
  "M D PATWA DEGREE COLLEGE    ",
  "BABU TIRTHRAJ SMARAK MAHAVIDYALAYA DEORIA BUZURG    ",
  "CS AYURVEDIC MEDICAL COLLEGE AND HOSPITAL ",
  "SMT SIYARAJI NAKCHED TIWARI OMPRAKASH TIWARI VIDHI MAHAVIDYALAYA",
  "INSTITUTE OF TEACHERS TRAINING AND EDUCATION",
  "JB MAHILA MAHAVIDYALAYA    ",
  "BUILD FOR SUCCESS DEGREE COLLEGE    ",
  "COMMANDER ARJUN SINGH BHADAURIA MAHAVIDYALAYA, KAMET, UDI, ETAWAH",
  "S N A INSTITUTE OF PHARMACY",
  "SHRI VISHNU BHAGWAN COLLEGE OF PHARMACY",
  "SAHARANPUR AYURVED MEDICAL COLLEGE",
  "S R D COLLEGE ARONJ SHIKOHABAD FIROZABAD    ",
  "BRIGHT CAREER GROUP OF COLLEGE    ",
  "SHRI FATEH SINGH DEGREE COLLEGE    ",
  "PT HUKUM SINGH EDUCATION COLLEGE KARAB RAYA MATHURA    ",
  "BHAGAUTI PRASAD SINGH MAHAVIDYALAYA SINKI KALA MEJA PRAYAGRAJ",
  "APRUP LAW COLLAGE AHIRAULI AYAR BAZAR VARANASI",
  "S K MAHAVIDHYALAY, NAGLA DURGOO, KADARGANJ KHAM, KASGANJ",
  "COLLEGE OF NURSING GOVERNMENT MEDICAL COLLEGE PRAYAGRAJ",
  "KUSUM SINGH KAMESH SINGH MAHAVIDYALAYA ITBAHRA GAUR BASTI    ",
  "MATA VINDHYAVASINI MAHAVIDYALAYA JALLAPUR SABUKPUR AMBEDKAR NAGAR    ",
  "RANA PRATAP LAW COLLEGE DHARAMDASPUR NIDURA KUREBHAR SULTANPUR ",
  "SHANTI RAMESH CHANDRA MAHAVIDYALAYA BENDO KARCHHANA PRAYAGRAJ",
  "MDALSHA COLLEGE OF PHARMACY",
  "WISDOM LAW COLLEGE",
  "HARIRAJ KRISHNA DEVI GIRLS DEGREE COLLEGE CHARWA KAUSHAMBI ",
  "VIDUSHI COLLEGE OF PHARMACY",
  "SULTANPUR INSTITUTE OF PHARMACY",
  "P.R. GOVT. MAHILA COLLEGE,",
  "CHANDRA SHEKHAR AZAD MAHAVIDYALAYA, NANSA, FAIZABAD",
  "HANUMAT LAW COLLEGE, KAUSHAMBI    ",
  "N K NATIONAL MAHILA MAHAVIDYALAYA, NADWASARAI, MAU",
  "HAUSHILA PRASAD SHUKLA MAHAVIDYALAY",
  "GAJROOP SINGH SMARAK MAHAVIDYALAYA DHARWARA, KARCHHANA, PRAYAGRAJ",
  "BABA RAMDAL RAJENDRA SINGH LAW COLLEGE PAKWAINAR RASRA BALLIA",
  "J D MAHAVIDYALAYA NASIRPUR SALEMPUR HANSRAJPUR GHAZIPUR",
  "KUNWARS COLLEGE OF NURSING    ",
  "RAM SUCHIT SINGH SARASWATI MAHAVIDYALAYA, TARUN, FAIZABAD",
  "RAJA MOHAN GIRLS P.G. COLLEGE, FAIZABAD",
  "HANUMAT SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA, SULTANPUR",
  "R.D.R.B. MAHAVIDYALAYA, NATHTHUPUR LODHNA, AMBEDKAR NAGAR",
  "SAHYOGI R.B. DEGREE COLLEGE, KHUSHHALPUR, BARABANKI",
  "GURU NANAK AVADEMY MAHILA MAHAVIDYALAYA, USRU, FAIZABAD",
  "LORD GAUTAM BUDH INSTITUTE, KARANPUR PARASPUR, GONDA",
  "BHANMATI SMARAK MAHAVIDYALAYA, NEAR NEW CIRCUIT HOUSE, AKBARPUR, AMBEDKARNAGAR",
  "MAHAVEER SANSKRIT MAHAVIDYALAYA KASARA MAU",
  "JUGUL KISHOR KHETAN BRAHMDEV TIWARI SHKSHA AND PRAKSHIAN SANSTHAN, PAKRI BEERBHADRA",
  "MAHATMA GANDHI SMARAK MAHAVIDYALAYA, JIAPUR, SAIDKHANPUR, KUREBHAR, SULTANPUR",
  "NAVDURGA MAHAVIDYALAYA, KHASROPUR, BASKHARI, AMBEDKAR NAGAR",
  "PRATHVIRAJ CHAUHAN INSTITUTE OF MEDICAL SCIENCES    ",
  "SAI HOSPITAL AND COLLEGE OF NURSING",
  "THAKUR HAR NARAYAN SINGH MAHAVIDYALAYA, PRAYAGRAJ    ",
  "B D M COLLEGE OF LAW",
  "PANDIT POORANMAL MEMORIAL EDUCATIONAL INSTITUTE BHAGVANPUR GABHANA ALIGARH    ",
  "RADHA GOVIND COLLEGE OF PHARMACY    ",
  "Singasani Devi Mahila Degree College, Nema Deoria",
  "BABU VISHRAM SINGH MAHAVIDYALAYA, ROHARI GORAKHPUR",
  "PRINCE INSTITUTE OF INNOVATIVE TECHNOLOGY, GREATER NOIDA, G.B. NAGAR",
  "SMT. SHIV DULARI SINGH MAHILA MAHAVIDYALAYA, KARAUDI AMETHI, SULTANPUR",
  "KAMLA PRASAD SINGH VIDHI MAHAVIDYALAYA, MATHURA NAGAR, RAMGARH, SULTANPUR",
  "RANI GANESH KUNWARI MAHAVIDYALAYA, JAMO, SULTANPUR",
  "KRISHNAWATI RAM NARESH DEGREE COLLEGE, TIWARI NAGAR, PURE MURLI, MAKDOOMPUR, FAIZABAD",
  "SUBHASH CHANDRA BOSE MAHAVIDYALAYA, KAHLI TERWA, GAUSGANJ, HARDOI",
  "RAJKIYA MAHILA MAHAVIDYALAYA KHARKHODA,MEERUT",
  "KRISHNAPAL SINGH MAHAVIDYALAYA, TAMBAUR,",
  "KRISHNA MAHAVIDHYALAYA, MOHAMMADI",
  "Sahas Degree College, Naugawan Sadat",
  "Adarsh Mahavidyalaya, Hardua, Nawabganj",
  "Sukhdai Smarak Mahavidyalaya, Ratupura, Thakurwara",
  "Saubhagyavati Bai Dani Mahila Mahavidyalaya, Dhampur",
  "KHAITANJI LAW COLLEGE, TIRWA, LAKHIMPUR ROAD,",
  "D.R.A. Government Degree College, Bisauli, Badaun",
  "Rukhmani Mahavidyalaya, Lodhipur Rajput",
  "Waseem Turki Muslim Muslim Degree College, Fatehpur Mafi, Palaula",
  "Babu Rampal Singh Mahavidyalaya, Thakurdwara",
  "Swami Vivekanand Mahavidyala, Puwayan",
  "Gaurisnankar Mahavidyalaya, Gularia Uprala, Aonla",
  "K G GARJAN GIRLS MAHAVIDYALAYA, NAGRA BEHJAM",
  "Dharamveer Institute of Education & Technology, Noorpur",
  "VEERANGNA RANI AVANTIBAI LODHI GOVT. MAHILA MAHAVIDYALAYA, BAREILLY",
  "S.P. College, Tigri, Chandpur",
  "GRAMIN SHIKSHAN SANSTHAN,MOHIUDDINPUR,DIHAWA,DAULATPUR,TANDA,AMBEDKARNAGAR U.P",
  "RSD Academy Girls Degree College",
  "KAMLA HARI MAHAVIDHYALAY",
  "J.P. VERMA SCIENCE MAHAVIDYALAYA, TERWA GAUSGANJ,",
  "JPS Mahavidyalay",
  "JIWAN LAL KAMLA DEVI KANNYA MAHAVIDYALAYA, LAKHIMPUR",
  "JAVENDRA NATH RAM PRAKASH MAHAVIDYALAYA, MADHOGANJ",
  "JAI HANUMAN PRABHAT SINGH MAHAVIDHALAYA",
  "mehndi hasan nisar ahmad mahila mahavidhyalaya ",
  "SWAMI VIVEKANAND DIGREE COLLEGE NARAYANPUR PRITAMPUR AMBEDKAR NAGRA",
  "JAI BALA JI LALIT KISHOR MAHAVIDYALAYA BHAWANIPUR RAEBARELI",
  "INDIRA GANDHI RAJKIYA MAHILA MAHAVIDYALAYA,",
  "HAZI ANIS KHAN GIRLS DEGREE COLLEGE KADAURA JALAUN",
  "MAHAVEER PRASAD SMARAK MAHILA DIGREE COLLEGE",
  "VIJAYI TULASI SINGH MAHAVIDYALAYA",
  "LAXMI DEVI LAW COLLEGE",
  "GURUDEV HARDEV MAHAVIDYALAYA PAILANI,BANDA",
  "I.G.R.U. ACADEMY, FURSATGANJ AIRFIELD,",
  "Kiranlata Singh Mahavidyalay Kaundar Asothar Fatehpur",
  "JUSTICE LAW COLLEGE",
  "RAMBETI MAHILA MAHAVIDYALAYA, YADUVANSHNAGAR TALGRAM, KANNAUJ",
  "Veer Bahadur Singh Memorial Mahavidyalaya, Paniyara, Maharajganj",
  "Vidya Singh Jagnnath Singh Degree College, Koni (Sri Tameshwarnath Dham), Sant Kabir Nagar",
  "Vanshraji Devi Degree College, Parsawa Jigana, Basti",
  "Uma Maheshwar Mahavidyalay, Bhogipur, Sant Kabir Nagar",
  "Surya College of Education, Meerganj, Khalilabad, Sant Kabir Nagar",
  "Sri Samay G.H.A. Mahavidyalaya, Jairampatti, Sant Kabir Nagar",
  "Govt. Mahavidyalaya, Gangeshwari, Rehra",
  "Springdale College of Management Studies",
  "Lal Bhadur Singh Smarak Degree College, Gohawar",
  "Rashida Begum Muslim Mahavidyalaya, Amroha",
  "PHOOLWATI INSTITUTE OF LAW EDUCATION & TECHNOLOGY, AGGARWAL MANDI, TATIRI (BAGHPAT)",
  "RS PHARMACY COLLEGE, KHAJAURI, RAJATALAB, VARANASI",
  "Sri Ram Surya Mani Degree College, Mahuwa Khurd, Dumariaganj, Siddharthnagar",
  "Srimati Sundar Dei Balika Mahavidyalaya, Jairampatti, Sant Kabir Nagar",
  "SHRI BALAJI MAHAVIDYALAYA, PAKADI, NONIYA, MAHARAJGANJ",
  "Shiv Harsh Kisan P.G. College, Basti",
  "SHARDA DEVI MEMORIAL DEGREE COLLEGE, MAGHAR, SANT KABIR NAGAR",
  "HARINAM SINGH BAGHEL VIGYAN EVM PROUDYOGIKI MAHAVIDYALAYA",
  "SAVITRI DEVI MAHILA MAHAVIDYALAYA , TIGRA MAUR, SANT KABIR NAGAR",
  "Sarvajeet Kaushal Public Mahavidyalaya, Pindri Buzurg, Siddharthnagar",
  "H M H DEGREE COLLEGE, LAHARPUR, SITAPUR",
  "Sant Kabir Acharya Amrit Das Mahavidyalaya, Magahar, Sant Kabir Nagar",
  "HINDU KANYA MAHAVIDYALAYA,",
  "HIND INSTITUTE OF MEDICAL SCIENCES ATARIA SITAPUR",
  "RAMSAMUJH GURUKUL MAHAVIDYALAYA,CHAMRAULI,HASANGANJ, UNNAO",
  "JAINATH MEMORIAL PHARMACY COLLEGE VILLAGE HARAIRAMPUR POST CHIRKIHIT AZAMGARH",
  "MATA DULARI DEVI PHARMACY COLLEGE PHOOLPUR AZAMGARH",
  "KCC INSTITUTE OF LEGAL AND HIGHER EDUCATION",
  "J P COLLEGE OF PHARMACY",
  "B T U MAHILA SIKSHA EVEM PRASHIKSHAN SANSTHAN DULLAHPUR GHAZIPUR",
  "HAJI NAWAB ALI DEGREE COLLEGE, JALUHAPUR, DINGURAPUR, LAHARPUR, SITAPUR",
  "HAZARI LAL MAHAVIDYALAYA, PAHADAPUR,",
  "HARI CHANDRA MAHAVIDYALAYA, HADELA, GOLA ROAD, ALIGANJ",
  "GYANDEEP KANYA MAHAVIDYALAYA,PANDEYPURWA,SINDHAULI",
  "GYAN DEEP DEGREE COLLEGE,NEWADA,TADIYAWAN",
  "GURU NANAK DEV EDUCATIONAL INSTITUTE,ETARA",
  "GURUKUL MAHAVIDYALAYA, PURASI HALOR,",
  "GURU HARIKISHAN MAHAVIDYALAYA, GOLA GOKARANNATH,",
  "GURU DRONACHARYA MAHAVIDYALAYA",
  "GULAB FULANNDAR VIDHI MAHAVIDYALAYA, SANDI,",
  "GREEN FIELD COLLEGE ILASIYA GRANT RAMKOT, SITAPUR",
  "RANA PATRU SINGH NARENDRA BAHADUR SINGH MAHAVIDHYALAYA, BASTI",
  "Ram Bharose Pandey Mahila Degree College, Khajuria, Siddharthnagar",
  "RAM AKSHAIVAR MAHAVIDYALAYA, RAMVAPUR, KURTHIA, SIDDHARTHNAGAR",
  "Shri Vidyadharm Sanjeevani Sanskrit Mahavidyalaya,",
  "S K SINGH LAW COLLEGE PAYAKPUR",
  "Shri Ramachari Sanskrit Mahavidyalaya, Ramanuj Kot, Assi",
  "PREMBABU SUMITRA DEVI MAHILA MAHAVIDYALAYA , CHANGERA MUNGERA,  SANT KABIR NAGAR",
  "GRAMODAY MAHAVIDYALAYA, DIGHIYA",
  "PRAHLAD KUMAR SUSHILA DEVI SHIVAJI MAHILA MAHAVIDYALAYA, PAKARDAND, BASTI",
  "Munna Pal Kailashi Devi Mahavidyalaya, Kodwat, Sant Kabir Nagar",
  "Mohan Dhansira Mahavidyalaya, Jangal Belhar, Sant Kabir Nagar",
  "MOHAMMED UMAR AMJADIA MAHAVIDYALAYA, PATKHAULI, SAFDEIYAN KALAN, BASTI",
  "Late Janki Devi Smarak Mahavidyalaya, Bhagata, Sant Kabir Nagar",
  "Modern Academy B.Ed. College,Sikri Kalan, Modinagar, Ghaziabad",
  "SRI RAMTEERTH CHAUDHARY MAHAVIDYALAYA, BANGHUSRA, UTRAULA, BALRAMPUR",
  "SHAKTI SMARAK SANSTHAN, DULHINPUR, BALRAMPUR",
  "SATYA NARAIN UCCHA SHIKSHA SANSTHAN, TULSIPUR",
  "RAJA VIRENDRA KANT SINGH MAHAVIDYALAYA, BHINGA, SHRAWASTI",
  "Laxmi Saroj Sanskrit Mahavidyalaya, Kurmidiha",
  "KISAN PARSHIKSHAN MAHAVIDHYALAY, BASTI",
  "KISAN ADARSH MAHAVIDALAYA, BELWA SISWA BAZAR, MAHARAJGANJ",
  "Shri Rukmini Ballabh Ved Vedant Sanskrit Mahavidyalaya, Avantika Ahar",
  "Purvanchal Institute of Dental Sciences, AL-4, Sector-7, GIDA, Gorakhpur",
  "RAJKIYA MAHAVIDYALAYA MAHADEVA,BASTI",
  "RAJKIYA MAHAVIDYALAYA, SALARPUR, GARHMUKTESHWAR, HAPUR",
  "KASHINATH MAHAVIDYALAYA, KARAUNDA, KHALSA , SIDDHARTHNAGAR",
  "MAA SHARDA RAM AADHAR SHIKHSAD PRASHIKHAD SANTHAN AARIPUR SARAY PATOI BELTHARA ROAD BALLIA",
  "Karma Devi Smriti Mahavidyalaya, Sansarpur, basti",
  "DILEEP KUMAR SMARAK COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "Kanya Degree College, Gayaghat, Basti",
  "FAISAL MAHAVIDYALAYA, TULSIPUR, BALRAMPUR",
  "CHAUDHARY LALTA PRASAD SINGH BAUDH MAHAVIDYALAYA, SRI DUTT GANJ, BALRAMPUR",
  "Chand Girls School, Teuwa Grant, Itwa",
  "Bhagwan Das Mahavidyalay, Sikandarpur, Basti",
  "Moradabad Muslim Mahavidyalaya",
  "Rani Bhagyavati Devi Mahila Mahavidyalaya, Bijnor",
  "Naval Kishore Bhartiya Municipal Girls College, Chandausi",
  "Shri Dharamjit Singh P G College, Mirzapur",
  "Jagdish Saran Hindu (PG) College, Amroha",
  "SIDDHARTH INSTITUTE",
  "E M D MAHAVIDYALAYA",
  "SHRI KAPILDEV MEMORIAL COLLEGE OF PHARMACY, MAU",
  "Rameshwar Sanskrit Mahavidyalaya, Ugapur, Aurai",
  "Bathwal Sanskrit Mahavidyalaya, Golabazar",
  "YATHARTH NURSING COLLEGE AND PARAMEDICAL INSTITUTE",
  "BALRAMPUR CITY MONTESSORI GIRLS DEGREE COLLEGE BALRAMPUR",
  "Bhagwant Ayurvedic College and Bhagwant Hospital",
  "BABA MOLAN SINGH SMARAK MAHAVIDYALAYA, SANT KABIR NAGAR",
  "Banshraj Jaishree Degree College, Motiram Adda, Gorakhpur",
  "Awadh Center Of Education for Women, Khafaja, Semriwan, Sant Kabir Nagar",
  "SANT BHAGWANA NAND JI MAHARAJ MAHAVIDYALAYA RAMPUR GHATAMPUR KANPUR NAGAR",
  "Amba K.P.S.B.P. College of Education, Hariharpur, Sant Kabir Nagar",
  "Government Degree College, Haripur Nihastha",
  "GIRLS DEGREE COLLEGE, BILGRAM,",
  "GAYATRI DEVI SEWAK MAHAVIDYALAYA, BAHERA",
  "GAYADEEN MAURYA SMRATI MAHAVIDYALAYA, DALAMAU,",
  "GEETA PHARMACY COLLEGE",
  "Mulayam Singh (Agriculture) Mahavidyalaya, kathara , Bidhanu",
  "KANHAIYA LAL MAHILA MAHAVIDYALAYA SUCHITTAGANJ SOHAWAL AYODHYA ",
  "KASHI DARSHAN D U MAHILA MAHAVIDYALAYA",
  "GAURI SHANKER MAHAVIDYALAYA",
  "GAURA DEVI DHANAI PRASAD MAHILA MAHAVIDYALAYA LAKHANSENPUR BANKAT SEWAPURI VARANASI ",
  "SONANANDAN TEACHERS TRANING INSTITUTE DHERAPUR KALICHABAD JAUNPUR",
  "INDRAPATI INSTITUTE OF TEACHERS EDUCATION MEERGOSAIPUR JAFRABAD JAUNPUR",
  "GAURI SHANKAR VIDYA DEVI MEMORIAL DEGREE COLLEGE ",
  "SD MAHAVIDHYALAYA THAKURDWARA MORADABAD",
  "GANNA KRASHAK MAHAVIDYALAYA,SAVAYAJPUR",
  "GANNA KISAN MAHAVIDYALAYA, MOHAMMDI, LAKHIMPUR,",
  "GANDHI MAHAVIDYALAYA",
  "Jain Girls Degree College khekra ",
  "Ramdev Degree College, Mahimapur Deeh, Naupedwa, Jaunpur",
  "SHRI RAJARAM DEGREE COLLEGE",
  "SHRI BABU SINGH LAW COLLEGE KHANDIYA MAUDARWAJA ",
  "Subba Mahavidyalaya",
  "Secret Heart Girls College for Education And Training",
  "PT. UMASHANKAR NARAYAN HARI MAHAVIDHYALAYA",
  "Rajkiya Mahavidyalya Kant , Shahjahanpur",
  "MDP College of Education ",
  "ST THOMAS COLLEGE OF LAW",
  "RAM KRIPAL SINGH MAHAVIDYALAYA SARAI BHIKHARI KHILAI PRATAPGARH",
  "BAGHPAT GLOBAL COLLEGE MEETLI GORIPUR",
  "APEX COLLEGE OF PHARMACY",
  "SHRI JAiVEER SINGH MAHAVIDYALAYA JASRANA ",
  "NARAYAN COLLEGE",
  "VIVEK COLLEGE OF TEACHER EDUCATION",
  "ZEE COLLEGE OF PHARMACY",
  "MJS SMARAK PRASHIKSHAN MAHAVIDYALAYA NANDIGRAM BHARATKUND FAIZABAD",
  "FEROZE GANDHI COLLEGE",
  "RIDDHI SIDDHI COLLEGE OF HIGHER EDUCATION ",
  "Feroze Gandhi Institute of Professional Studies",
  "FATAMA MAHAVIDYALAYA, GAURI KHALSA, SUBBAKHERA,",
  "D S MAHILA MAHAVIDHYALAYA RAIPUR KHERI",
  "SHRI RATAN SINGH COLLEGE OF PHARMACY",
  "DHARAM SAMAJ COLLEGE OF PHARMACY ALIGARH ",
  "INDRAPRASTHA COLLEGE OF EDUCATION",
  "Siddarth Shiksha Sansthan ",
  "CH. BHOPAL SINGH COLLEGE OF EDUCATION, DAHA, BAGHPAT",
  "DR. RAM MANOHAR LOHIA DEGREE COLLEGE, ALLIPUR,",
  "DR. HARI SHANKAR MISHRA MAHAVIDYALAYA, MALIHAMAU,",
  "INDIRA GANDHI INSTITUTE OF PARAMEDICAL SCIENCES",
  "SHRI VISHWANATH COLLEGE OF PHARMACY VILL KALAN POST KALAN DISTT SULTANPUR UP",
  "AMBROSIA ACADEMY",
  "ARUN YOG ACADEMY",
  "DURGESH NANDINI MAHAVIDYALAYA CHARERA PURA BAZAR FAIZABAD",
  "DR. HARI SHANKAR MISHRA LAW COLLEGE, MALIHAMAU,",
  "DR. B.R. AMBEDKAR TARAI KISAN MAHAVIDYALAYA, LAKHIMPUR,",
  "DR. BHIMRAO AMBEDKAR MAHAVIDYALAYA, MURAD NAGAR, LAKHIMPUR,",
  "J P PHARMACY COLLEGE KOTWA SADAK BARABANKI UTTAR PRADESH ",
  "MAHANT AVAIDYANATH RAJKIYA MAHAVIDYALAYA JUNGLE KAUDIYA GORAKHPUR",
  "DR. BHIMRAO AMBEDKAR MAHAVIDYALAYA, MADHOUGANJ,",
  "DR. BHIM RAO AMBEDKAR MAHAVIDHYALAYA RAMPUR, MATHURA",
  "B.D.M. MAHAVIDYALAYA,PAIGAON,MATHURA",
  "DR. AMBEDKAR RAJKEEYA MAHAVIDYALAYA, UNCHAHAR,",
  "RAM CHAMELI CHADHA VISHVAS GIRLS COLLEGE GHAZIABAD",
  "KALKA DENTAL COLLEGE PARTAPUR BY PASS, MEERUT",
  "ANUP SINGH MAHAVIDYALAYA SUKHPURA BALLIA",
  "SHRI SUNDAR LAL SMARAK MAHAVIDHYALAY SHIKSHAN PRASHIKSHAN SANSTHAN AURELA SAIDANPUR BARABANKI",
  "DIVYA NAND VIDYAMANDIR MAHAVIDYALAYA, SANDILA,",
  "DIVYA KRIPAL MAHAVIDYALAYA, GOSWA, MALLAWAN,",
  "DIKSHA MAHILA MAHAVIDHYALAYA",
  "DEEN DAYAL UPADHYAY GOVERNMENT POST GRADUATE COLLEGE, SITAPUR",
  "JAI SHIV PG MAHAVIDYALAYA, BUDHERANA",
  "Bagishwari Rambasi Mahila Mahavidyalay, Guruwaliya, Kushinagar",
  "DAYAL DEGREE COLLEGE, JEETAMAU, SITAPUR",
  "DASHRATH PRASAD MAHAVIDYALAYA SALON RAEBARELI",
  "SMT VIDHYA PRASHIKSHAN SANSTHAN",
  "DULARI MAHILA MAHAVIDYALAYA, DULARI NAGAR",
  "J.D.S Degree College",
  "DR RAJENDRA VEER SINGH GIRLS INSTITUTE OF EDUCATION",
  "Ranju Singh Degree College, Sonadi, Deoria",
  "KCNIT COLLEGE OF EDUCATION",
  "DR RAJENDRA PRASAD SHIKSHAN SANSTHAN",
  "GURUKUL MAHAVIDYALYA KHAHRA BANDA",
  "SPECTRUM HI PHARMACY COLLEGE",
  "DIVYA COLLEGE OF PHARMACY",
  "SHRI MALTI PRASAD SARPANCH GAUTAM BUDDHA GIRLS DIGREE COLLEGE",
  "DANDATEK DEGREE COLLEGE RANGWA LAHARPUR SITAPUR",
  "C.S.N. P.G. COLLEGE,",
  "CHHEDI LAL REDHYSHYAM MAHAVIDYALAYA,MISHRIKH",
  "CHEDALAL MAHAVIDHYALAYA, GAUSGANJ",
  "CH. BECHELAL MAHAVIDYALAYA, RASULPUR, DHAURHARA, LAKHIMPUR",
  "J.S. DEGREE COLLEGE, Nagla Hatti",
  "Shri Natthi Singh Institute of Education, Balarai",
  "Doodhnath Sarvoday Mahavidyalaya, Sakrar, Jhansi",
  "Arya Khjano Devi Mahavidyalaya",
  "SHRI PRATAP SINGH MAHAVIDHYALAYA",
  "Sardar Vallabh Bhai Patel Mahavidhayala",
  "RAM DEV MAHAVIDYALAYA, HARRINGTONGANJ",
  "BHAGWATI PRASAD MOHINI DEVI MAHAVIDYALAYA, JAINPUR KHENWAR",
  "BHAGWAT PRASAD MEMORIAL MAHILA MAHAVIDHYALAYA, ATARRA",
  "CHANDRIKA SINGH SUNDER SINGH MAHAVIDYALAYA FATTEPUR LAKHIMPUR KHERI",
  "Chandra Shekhar Azad Degree College",
  "CANE GROWERS NEHRU DEGREE COLLEGE, GOLA GOKARAN NATH KHERI",
  "Al Ibrahim Mahavidhyalaya",
  "KAUSHAMBI VIDHI MAHAVIDYALAYA, TILHAPUR MOD,",
  "Narsingh Prasad Singh Mahila Mahavidyalaya, Urwa Bazar, Gorakhpur",
  "SETH DHANPAL CHAND JAIN INSTITUTE OF NURSING AND PARAMEDICAL SCIENCE ",
  "B.S. EDUCATIONAL KANYA MAHAVIDYALAYA, PAKARIYA, KHAIRABAD,",
  "SRI VISHRAM SINGH MAHAVIDHYALAYA",
  "S. S. Girls Degree College",
  "Shree Vedram College of Higher Education",
  "SRI UPENDRA TIWARI SMRATI MAHAVIDYALAYA, SAWAYAJPUR,",
  "SRI THAKUR JI MAHARAJ MAHAVIDYALAYA, HERWAL,",
  "SRI SURAJ DATT KANTI DEVI MAHILA MAHAVIDHYALAYA, KHIRO",
  "SRI SHIV RAJ SINGH MAHAVIDYALAYA",
  "SRI SATGURU SAI MAHAVIDHYALAYA,RUDAMAU,MADHAUGANJ",
  "SRI SAI NATH MAHAVIDHYALAYA,DHIKUNI,SANDILA",
  "SRI SAI BABA KANYA MAHAVIDYALAYA, DHARNAG, SAHAMHOLI,",
  "SRI R.S. MAHAVIDYALAYA ",
  "SRI RAM SWAROOP PATEL MAHAVIDYALAYA, BILGRAM,",
  "DIVINE COLLEGE OF EDUCATION FOR GIRLS, MAUKHAS, GARH ROAD",
  "SHRIMATI MARGSHREE DEGREE COLLEGE ",
  "Sri Kaptan Singh Mahavidlaya, Sarai Prayag",
  "SMT. MARGSHREE COLLEGE OF EDUCATION",
  "SRI RAM PAL MAHAVIDYALAYA ",
  "Ramrati Verma Nanhku Verma Mahavidayalaya",
  "PRAHLAD SINGH MEMORIAL COLLEGE OF LAW",
  "DELHI INSTITUTE OF HIGHER EDUCATION ",
  "BHOO DEVI MATA MAHAVIDYALAYA, PAIGAON",
  "RAJDATT SHUKLA BABURAM HOUSILA PRASAD MAHILA SHIKSHAN SANSTHAN, SHIVNAGAR SARAULI",
  "MAHAMAHIM MAHIPAL SHASTRI DEGREE COLLEGE",
  "Regional Campus, Lucknow",
  "UMA SHANKAR KATIYAR EDUCATION CENTRE ",
  "MA KRIPALA DEVII SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA",
  "SHREE K S DEGREE COLLEGE, ASMOLI",
  "SRI RAM LAL SINGH MAHAVIDHYALAYA,SADARPUR",
  "Shri Ramkaran Mahavidyalaya Ishopur Rampur Ghazipur",
  "Sukhamay Mahila Mahavidyalayay, Behana, Jaunpur",
  "SRI RAMESHWAR TRIPATHI MAHAVIDYALAYA, BAHUPUR, RAMPUR,",
  "SRI RAM BHAROSE SINGH MAHAVIDYALAYA, BAJEHRA, PIHANI,",
  "SRI RAJ BAHADUR MAHAVIDYALAYA,LONAR, HARDOI",
  "Shri Avadh Raj Singh Smarak Mahavidhyalay",
  "HAZI ABDULLAH MAHILA MAHAVIDYALAYA",
  "RAI UMANATH BALI  MAHAVIDYALAYA",
  "SHRI RAM CHANDRA NARAYAN SHIKSHAN EVAM PRASHIKSHAN MAHAVIDYALAYA",
  "ROHIT MEMORIAL MAHAVIDYALAYA, MAHADEVNAGAR, CHAPAR, SULTANPUR",
  "VMY INSTITUTE OF PARAMEDICAL SCIENCES, GANGAUPUR, MADHUBAN MAU",
  "RAJESH PANDEY LAW COLLEGE, AKBARPUR, AMBEDKAR NAGAR",
  "ROHIT MEMORIAL INSTITUTE OF EDUCATION, SARASWATI NAGAR, DOSTPUR, SULTANPUR",
  "JAI GANESH SHIV SAGAR MAHILA MAHAVIDYALAYA, DEOKALI, FAIZABAD",
  "SANT PATHIK MAHAVIDYALAYA, SHASTRI ANANDPUR, SUBEHA, BARABANKI",
  "NARSINGH NARAYAN SHUKL MAHAVIDYALAYA RAJKALI NAGAR, SUVANSH CHAURAHA, RAHWAI, KUNDA, PRATAPGARH",
  "OM BUDDHESHWAR MAHAVIDYALAYA, PRATAPGARH",
  "Teerthanker Mahaveer College of Pharmacy",
  "Teerthanker Mahaveer of College of Education",
  "SHRI PRABHU DAYAL MAHILA MAHAVIDYALAYA, DHAKWA, BHANDIA, SITAPUR",
  "S L J DEGREE COLLEGE",
  "Indradev Ramnaval Banafar Mahavidyalaya Daharmavo Ghazipur",
  "SMT. SAVITRI DEVI MEMORIAL DEGREE COLLEGE ",
  "SRI P.L. VERMA TEACHERS TRAINING COLLEGE, DAKOULI,",
  "SRI PADUM SINGH MAHAVIDYALAYA KHAMRAMAU MALEHARA SANDILA HARDOI",
  "SRI NARAYAN SINGH MAHAVIDYALAYA, SHAHABAD",
  "MOHAMMAD YAQUB DEGREE COLEGE SHIVGARH RANIGANJ PRATAPGARH",
  "HARPRASAD RAMPYARI DEGREE COLLEGE",
  "SRI MEHARVAN SINGH MAHAVIDYALAYA, DAKAULI,",
  "SRI MAHAVIR SINGH SMARAK MAHAVIDYALAYA, HARCHANDRAPUR,",
  "SRI MAHARANA PRATAP MAHILA MAHAVIDYALAYA, DALMAU",
  "JDSR INSTITUTE OF PHARMACY HARPARA NIGOHI SHAHJAHANPUR",
  "SRI LAL JI SINGH JEEWAN JYOTI MAHAVIDHALAYA,MOHARIYA KALA,PARSANDI",
  "SRI KRISHNA MAHAVIDYALAYA, BAIJUPUR",
  "MAHRAJI DEVI MOOLCHAND MAHAVIDYALAY",
  "JP MAURYA MAHAVIDYALAYA KHAGA FATEHPUR",
  "SRI GANDHI MAHAVIDYALAYA, SIDHAULI, SITAPUR",
  "SRI D.P. VERMA MEMORIAL DEGREE COLLEGE, KHAGESIYAMAU,",
  "SRI DIMOND DEGREE COLLEGE, MAHUIPURI,",
  "JAGMEET MEMORIAL COLLEGE OF PHARMACY BAVANPUR CHANDPUR BIJNOR",
  "SHREE JI INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH VILLAGE BICHHOLA DHOOKI SIKARPUR SARAI ROAD POST SEONDARA TEHSIL  BILARI DISTRICT MORADABAD",
  "M V COLLEGE OF EDUCATION",
  "PT MANIK CHANDRA SHARMA S MAHAVIDYALAYA AAMI SARAI MANIK CHANDRA NAGAR PATTI ",
  "SRI CHANDRA BHAGWAN LAW DEGREE COLLEGE",
  "MAHADEV MAHENDRA MAHAVIDYALAY FESHUDA SAKALDIHA SAIYADRAJA CHANDAULI",
  "SAGAR COLLEGE OF PHARMACY",
  "SHRI SANTAN PAL SINGH PHARMACY COLLEGE",
  "MAYA INSTITUTE OF PHARMACY",
  "PT RAMASHANKAR MISHRA MAHAVIDYALAYA PACHRAON VARANASI",
  "NANDINI COLLEGE OF ARTS AND SCIENCE",
  "S G L M INSTITUTE OF B TC BADAUSA",
  "RAM KUMAR SMARAK SHIKSHAN PRASHIKSHAN BALIKA MAHAVIDYALYA SHUKULBAZAR",
  "SHRI DINESHWAR MISHRA JI DEGREE COLLEGE",
  "SANT BHEEKHADAS NAKCHHED TIWARI PHARMACY COLLEGE MOHLI AYODHYA ",
  "GAJRAJ SINGH YADAV KARANPAL SINGH YADAV COLLEGE OF PHARMACY DOHAK PASGAWON MOHAMMADI LAKHIMPUR KHERI",
  "SRI BANDHALAL MITANLAL MAHAVIDYALAYA",
  "MEVARAM HARIPRASAD MAHAVIDHYALAY BASAI ARELA PINAHAT AGRA",
  "DWIVEDI VIDHI MAHAVIDYALAYA",
  "SMT DEGREE COLLEGE",
  "CHANDRA SHEKHAR AZAD MAHAVIDYALAYA MIJHHOURA PARASPUR GONDA",
  "LATE RAVINDRANAND BARONIA COLLEGE OF PHARMCY ",
  "SRI BALAJI MAHARAJ MAHAVIDYALAYA, PAHUNTERA,",
  "SRI BAIJNATH SINGH MAHAVIDYALAYA, DAHINTI, SALKUPUR,",
  "SRI BAIJNATH SINGH MAHAVIDYALAYA, BARKHERA, SAKATPUR,",
  "UNIVERSAL INSTITUTE OF PHARMACY",
  "RAKSHPAL BAHADUR COLLEGE OF NURSING BAREILLY",
  "MATA HARSH SHUKLA GIRLS COLLEGE OF EDUCATION DEHLI BAZAR SULTANPUR",
  "ABHIRAJI KANYA  MAHAVIDHYALAY ",
  "SITARAM SHANTI NIKETAN MAHILA MAHAVIDYALAYA JEVAL GHAZIPUR",
  "M H MEMORIAL DEGREE COLLEGE GUAR KHERA HARORA BILARI",
  "DR MAHENDRA KUMAR CHHOTELAL BIND COLLEGE OF PHARMACY PRAYAGRAJ",
  "SHIVBARAT SINGH SHIKSHAN PRASHIKSHAN SANSTHAN ARGUPUR KALAN JAUNPUR",
  "RAINBOW COLLEGE OF HIGHER EDUCATION",
  "MAHARISHI DAYANAND EDUCATIONAL INSTITUTE",
  "SARVODAYA HOSPITAL AND COLLEGE OF NURSING",
  "SAMAHI COLLEGE OF PHARMACY",
  "PT BALGOVIND DIXIT COLLEGE OF EDUCATION AND PROFESSIONAL MANAGEMENT BITHOOR KANPUR NAGAR",
  "PT RAM PRAVESH CHAUBEY MAHAVIDYALAYA KURAULI NIYAR VARANASI",
  "C D GIRLS COLLEGE OF EDUCATION",
  "SRI BACHCHULAL RAMDULARI MAHAVIDYALAYA, BISWAN,",
  "JASWANT SINGH BHADAURIA LAW COLLEGE KOSI KHURD",
  "ATMS COLLEGE OF EDUCATION ACCHEJA, HAPUR",
  "SURYA PRATAP SINGH DEGREE COLLEGE ",
  "S.S. COLLEGE OF EDUCATION",
  "SRI AMAR SINGH SNATAK MAHAVIDYALAYA,KAURAPUR, GAURA DEEH,",
  "S. R. Degree College",
  "SONELAL SUSHILA DEVI MAHAVIDYALAYA, BHATAULI",
  "SMT. SHIV PYARI MAHAVIDHYALAYA,BAGHURA,GAUSGANJ",
  "SMT RADHA DEVI SHRI KRISHNA SHASTRI MAHAVIDYALAYA, MUSHARFABAD, BILGRAM",
  "SMT. DULARI RADHESHYAM DEGREE COLLEGE, SHAHJALALPUR,",
  "Government Degree College, Nadhabhood (Sahaswan)",
  "SITAPUR SIKSHA SANSTHAN, KANWA KHERA,",
  "SITAPUR SHIKSHA SANSTHAN,",
  "SHRI GANDHI MAHAVIDYALAYA, CHANDRABHUSHAN GANJ, GHORWARA, RAEBARELI",
  "ABDUL GAFFAR MAHAVIDYALAYA GANJMURADABAD",
  "INTERNATIONAL SCHOOL OF MEDIA AND ENTERTAINMENT STUDIES",
  "ACADEMY OF TECHNOLOGY MANAGEMENT AND SCIENCE",
  "METRO COLLEGE OF NURSING",
  "SHRI BARAKHANDI MAHAVIDYALAYA, SHIVGARH,",
  "BAGHPAT INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "SHREE UMA MAHESHWAR MAHAVIDYALAYA,FURSATGANJ",
  "SARASWATI COLLEGE OF HIGHER EDUCATION ",
  "MAHARAJA AGRASEN COLLEGE OF HIGHER EDUCATION",
  "SHRI RAM COLLEGE OF HIGHER EDUCATION",
  "SMT. KAMLA DEVI VIDYAPEETH",
  "SHREE PAL SINGH MAHAVIDYALAYA",
  "BALAJI INSTITUTE OF HIGHER EDUCATION ",
  "RAMDEVI KANYA COLLEGE",
  "PT. RAVINDRA DEV INSTITUTE OF EDUCATION",
  "K R EDUCATIONAL INSTITUTE ",
  "SHIV SHAKTI GIRLS DEGREE COLLEGE",
  "SHRI RAJKUMAR SINGH DEGREE COLLEGE OF EDUCATION",
  "SHRI PUTTU SINGH COLLEGE OF EDUCATION",
  "GLOBAL GENIUS COLLEGE KUMHER ROAD SONKH MATHURA",
  "S.R MAHAVIDHYALA ,GOVINDEPUR ",
  "Maa Vaishnavi Mahavidyalay Karanjakala Jaunpur",
  "TIRUPATI BALAJI KANYA MAHAVIDHALAYAY",
  "RAJA KANHA MAHAVIDYALAYA, JAGESAR GANJ",
  "NAND KISHORE COLLEGE OF PHARMACY",
  "RAMKISHUN MAHAVIDYALAYA KARKAPUR ALLAWALPUR GHAZIPUR",
  "MAHAVIDYALAYA BAGHOL GHAZIPUR",
  "RAJKEEYA MAHAVIDYALAYA",
  "Swami Harsewanand Mahavidyalaya",
  "PREM SINGH SWATANTRTA SENANI MAHAVIDHALAYA ",
  "RAMAUTAR SINGH COLLEGE OF EDUCATION",
  "SWA SRI RAJABHAIYA YADAV MEMORIAL DEGREE COLLEGE",
  "LATE HEERADEVI ASHARANI GIRLS DEGREE COLLEGE KABRAI",
  "R. N. INSTITUTE OF ADVANCED STUDIES GANCHA ROAD, BANDA ",
  "PT. RAM KRIPAL DIXIT DEGREE COLLEGE",
  "LATE SHRI POORAN RAM PRAKASH DIXIT DEGREE COLLEGE MAGROL",
  "MOHTARMA JAINAB HIRA MAHAVIDYALAYA , ATA KALPI JALAUN",
  "PRO. DEENANATH PANDEY MAHAVIDYALAYA",
  "SHAKUNTALA KRISHANA INSTITUTE OF TECHNOLOGY",
  "SATISH VIDHI MAHAVIDYALAYA DHIRJIJOT SIKHADI GHAZIPUR",
  "MEERUT COLLEGE OF HIGHER EDUCATION ",
  "NIHAL SHYAM COLLEGE OF MANAGEMENT SCIENCE AND TECHNOLOGY ",
  "SAMA MAHENDRA GIRLS DEGREE COLLEGE CHAKMALUK SIKHADI GHAZIPUR",
  "D. J. COLLEGE OF DENTAL SCIENCES AND RESEARCH, MODINAGAR, GHAZIABAD",
  "B K DEGREE COLLEGE",
  "DR.SHASHI KANT SINGH MAHAVIDYALAYA BARIYASANPUR, VARANASI",
  "MAHATMA DEGREE COLLEGE, MAZA",
  "MATA GOMATI DEVI DEGREE COLLEGE, BIRAULI, CHAYAL,",
  "MARYADA DEVI KANYA DEGREE COLLEGE, HANUMANGANJ,",
  "MANGLA DEVI SMARAK LAW COLLEGE, MASIKA, NAINI",
  "MAHATMA GANDHI COLLEGE,",
  "MAHATMA BUDDH MAHAVIDYALAYA, AJUHA,",
  "MAHARANA PRATAP MAHAVIDYALAYA, KARCHALPUR,",
  "MAHAMAYA RAJKIYA MAHAVIDYALAYA, DHANUPUR, HANDIA,",
  "Abdul Aziz Ansari Degree College, Majadiha, Shahganj , Jaunpur",
  "TULASHA DEVI INSTITUTE OF PHARMACY SCIENCES",
  "MAHAMAYA RAJKIYA MAHAVIDYALAYA,",
  "Maa Malti Devi Mahila Degree College, Pachdeora, Atrampur",
  "MANGLA DEVI SMARAK DEGREE COLLEGE, MASIKA, NAINI",
  "MA. KANSHIRAM MAHAVIDHYALAYA, KANAILY",
  "MAHILA SEWA SADAN DEGREE COLLEGE",
  "SHREE MAHAVEER JI LAW COLLEGE, AHMAD NAGAR, MAZLISHPUR",
  "SHREE LAXMAN PRASAD RAJ MAHAVIDYALAYA",
  "SHREE KRISHNA EDUCATIONAL INSTITUTE",
  "SHREE JAGDEV SINGH MAHAVIDHYALAYA,ATRAULI",
  "Shree Bajja Lal Poolmati Mahavidyalya, Jamadhi Pasgawan",
  "SHIV MUNNI DEVI GAYA SINGH SANJANA SINGH GAYATRI MAHAVIDDHALAYA RAKEHATI",
  "SHIV MAHAVIDYALA",
  "SHIVAM AGRAWAL MEMORIAL DEGREE COLLEGE",
  "MAHAVIR SUMITRA MAHILA MAHAVIDYALAYA, HANDIA",
  "MAHAVIR KAILASH MAHAVIDYALAYA, KOSDA KALA, MANDA,",
  "RAJESH PILOT MAHAVIDHYALAYA, SHAKALPURA, LONI, GHAZIABAD",
  "SHAHEED BHAGAT SINGH MAHAVIDHYALA HAIDERPUR HARGAON SITAPUR",
  "SETH RAM GULAM DEGREE COLLEGE, MAHMOODABAD,AWADH",
  "MAHATMA LAW COLLEGE MAZE",
  "MAA VAISHNAVI DEGREE COLLEGE, THARVAI,",
  "MAA SUMERA DEVI YADAV BALIKA MAHAVIDHYALAYA",
  "MAHARISHI COLLEGE OF LAW",
  "Tilakdhari Mahila Mahavidyalaya, Jaunpur",
  "Baba Ganesh Dutt Mahavidyalaya, Rattipur, Jaunpur",
  "RAMKRISHNA SHIKSHA SAMITI MAHAVIDYALAY",
  "MAHARISHI COLLEGE OF EDUCATION, BHARWARI",
  "MAA SHARDA MAHAVIDYALAYA, KUNWARPUR ROAD, BINDKI,",
  "Jang Bahadur Rai Mahavidyalaya, Lauvadih, Ghazipur",
  "MAA SARASWATI SITA DEGREE COLLEGE, HARAKHPUR, SORAV,",
  "MAA LAXMI MAHILA MAHAVIDHYALAYA",
  "MAA GULAB KALI BHARGAVA DEGREE COLLEGE",
  "MAA GAYATRI MAHILA DEGREE COLLEGE, NAINI,",
  "K L SINGH SMARAK MAHAVIDYALAYA",
  "K.P. UCHHA SIKSHA SANSTHAN, JHALWA",
  "KISHORI LAL M/V, PURWA, NAINI",
  "KISHORI LAL MAHAVIDYALAYA, NAINI,",
  "KIRAN SINGH MAHAVIDHYALAYA, GAJIPUR",
  "SATYAWATI PATEL MAHAVIDYALAYA, MAMRI, LAKHIMPUR",
  "SATYA SAI MAHAVIDHYALAYA,GANGAULI,UCHAHAR",
  "ITERC COLLEGE OF LAW, DUHAI, GHAZIABAD    ",
  "SARVODYA VIDYA PEETH P.G. COLLEGE, SALON,",
  "Jay Bajarang Mahila Mahavidyalaya, Mugura Badshahpur, Jaunpur",
  "SARDAR VALLABH BHAI PATEL MAHAVIDYALAYA, TAMANPUR,",
  "SARDAR SINGH SHIVRAJ SINGH MAHAVIDYALAYA, RAGHUVAR NAGAR,",
  "KESHVANAND MAHAVIDYALAYA",
  "KISAN MAHAVIDYALAYA, PATEL NAGAR, KHERHAT,",
  "KAUSHAMBI MAHAVIDYALAYA, TILHAPUR MORH,",
  "FM DEGREE COLLEGE ",
  "KARGIL SAHID LALMANI YADAV MAHAVIDYALAYA, LOHARI, KARCHANA,",
  "KAMTA SINGH GIRLS DEGREE COLLEGE, JHUNSI,",
  "SMT SHAKUNTALA DEVI MAHAVIDHYALAYA NEAR G T ROAD MAHUA KHEDA ETAH",
  "KAMLESH YADAV DEGREE COLLEGE, RAHIMAPUR, JHUSI,",
  "KAMLESH NARAIN GIRIJA DEVI MAHAVIDHYALAYA",
  "KALPANA MAHAVIDYALAYA, VIJAIPUR",
  "KALAWATI DEGREE COLLEGE, HARDI, BARA,",
  "JWALA PRASAD DEGREE COLLEGE, NARENI,",
  "B M G DEGREE COLLEGE, DHARWARA",
  "JEET NARAIN SINGH YADAV SMARAK BALIKA MAHAVIDYALAYA, ALLAHABAD",
  "JANG BAHADUR SINGH PATEL DEGREE COLLEGE, JALALPUR,",
  "JAIRAM JANKI MAHAVIDYALAYA, MAHARISHI NAGAR,",
  "JAI NARAYAN SMARAK DEGREE COLLEGE, SEHARA,",
  "PT ASHOK KUMAR MISHRA VIDHI MAHAVIDYALAYA ASHOK NAGAR KHUTEHANA BAHRAICH",
  "JAI NARAYAN SINGH C.D. MAHAVIDYALAYA, SEMRI, KARCHANA,",
  "JAGPAT SINGH SINGRAUR DEGREE COLLEGE, J.P. NAGAR,",
  "JAGDEV PRASAD SMARAK MAHAVIDYALAYA, SANSARPUR, KORANV",
  "Walther Degree College, Rampur Jaunpur",
  "PRASAD INSTITUTE OF MEDICAL SCIENCES",
  "JANAK DULARI SHIV DATT MAHAVIDYALAYA, OSA,",
  "JAGANNATH PRASAD SMARAK MAHAVIDYALAYA, GHOORPUR,",
  "JAGANNATH PRASAD SMARAK COLLEGE OF EDUCATION, BUDANWA, JASRA",
  "ISRAJI DEVI SHIKSHAN SANSTHAN,ALLAHABAD",
  "ISHWAR JAN PRASAD SHARMA MAHAVIDYALAYA, JHIRI, KARCHANA,",
  "ISHWAR DEEN BHAGWAT SINGH MAHAVIDHYALYA,KHAGA",
  "INDRAKALI MAHAVIDYALAYA, GAUSARAKHURD, MEJA,",
  "INDRADEV TRIPATHI DEGREE COLLEGE, TENWA, MANJHANPUR,",
  "H M ALI MINYA NADAVI DEGREE COLLEGE",
  "HEMWATI NANDAN BAHUGUNA RAJKIYA MAHAVIDYALAYA, NAINI,",
  "HARPRATAP SINGH YADAV MAHAVIDYALAYA, HANDIYA,",
  "HANUMANT MAHAVIDYALAYA, LAHURPUR, HANUMANGANJ,",
  "G. SINGH VIDHI MAHAVIDYALAYA, KASHERUWA KHURD,",
  "G SINGH COLLEGE, SAHSON",
  "GRAMYA SHIKSHA BALIKA M/V, BHRINGARI DOHRIA, MEJA ",
  "G P DEGREE COLLEGE SURENDRAGARH THARVIHAR KARCHANA, ALLAHABAD",
  "GHANSHYAM URVASHI VIDHI MAHAVIDYALAYA",
  "GHANSHYAM URVASHI MAHAVIDYALAYA,PHULPUR",
  "GAUTAM BUDDH MAHAVIDYALAYA, PHOOLPUR,",
  "GAUTAM BUDDHA MAHAVIDYALAYA, SAIDABAD, HANDIA,",
  "Baba Sahab Dr. Bhimrao Ambedkar Mahavidyalaya, Sidadikpur Jaunpur",
  "BABU CHANDRIKA PRASAD MAHILA MAHAVIDYALAYA, MUSTAFAPUR,",
  "Smt. Indira Gandhi Rajkiya Mahavidyalaya, Lalganj Mirzapur",
  "Gyandaini Mahila Mahavidyalaya, Parampur, Akelawan, Varanasi",
  "Smt. Jagwanti Devi Hiranand Mahavidyalaya, Berwa, Paharpur, Sant Ravidas Nagar, Bhadohi",
  "Shrimati Janki Rampal Mahavidyalaya, Bhannaur Jaunpur",
  "Baba Vishwanat Mahavidyalaya, Lakhanpur, Varanasi",
  "Ramkhelawan Singh P.G. College, Kalwari, Madihan, Mirzapur",
  "SARSWATI UCHCHA SHIKSHA EVAM TAKNIKI MAHAVIDYALAYA, GAHANI, AYAR, VARANASI",
  "SUDHAKAR MAHILA P.G. COLLEGE KHAJURI PANDEYPUR VARANASI",
  "S.S.P.P.D. Mahavidyalaya, Tisuhi, Madihan, Mirzapur",
  "K. N. Govt. P.G. College, Gyanpur, Sant Ravidas Nagar, Bhadohi",
  "Jeevandeep Mahavidyalaya, Baralalpur, Varanasi",
  "Shyam Tara Mahila Mahavidyalaya, kosra, Mirzamurad, Varanasi",
  "Ram Rekha Rai Ganga Rai Mahila Mahavidyalaya, Rajivnagar, Maharajganj",
  "T R S COLLEGE OF EDUCATION AND TECHNOLOGY",
  "GANGA DEGREE COLLEGE, RAM NAGAR, SORAV,",
  "Dr. Bhimrao Ambedkar Balika Degree College Maharajgunj, Jaunpur",
  "SHREE KUNWAR THAKUR JAYPAL SINGH DAU MAHAVIDYALAYA KHIRYAMISHR BANPUR",
  "GOLDEN COLLEGE OF EDUCATION",
  "GANDHI SHANTI NIKETAN DEGREE COLLEGE, GOUHANIA (JASARA),",
  "DWARIKA PRASHAD MAHAVIDYALA MADARI SISHWA MAUIMA ALLAHABAD",
  "DWARIKA PRASAD VIDHI MAHAVIDHYALAYA,SORAON",
  "DR. RIZVI COLLEGE OF LAW, KARARI,",
  "DR. MAHENDRA KUMAR CHHOTE LAL BIND MAHAVIDYALAYA, HANDIYA",
  "PRITHVIRAJ CHAUHAN SMARAK JANG BAHADUR SINGH KANYA MAHAVIDYALAYA CHANGASI BUDAUN",
  "LBSS DEGREE COLLEGE GOHAWAR BIJNOR",
  "KALIKA CHANDRIKA INDRASAN MAHAVIDYALAYA BHARATPUR BAHARIYABAD GHAZIPUR",
  "SHRI HARIHAR DEGREE COLLEGE",
  "GHARBHARAN MEVA VEERA DAS MAHAVIDYALAYA KUDDANPUR GHAZIPUR",
  "ITS Centre for Dental Studies and Research Delhi, Murad Nagar, Ghaziabad",
  "RUDRA COLLEGE OF LAW",
  "MAA SHARDA SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA CHIKHARI HARRINGTONGANJ AYODHYA ",
  "ARVIND MADHURI TIWARI MAHAVIDYALAYA ",
  "MUKULARANYAM MAHAVIDYALAYA",
  "MAA SHARDA PHARMACY COLLEGE CHIKHARI HARRINGTONGANJ AYODHYA ",
  "CRS College",
  "DAYAWATI COLLEGE OF LAW BHANKANDA, NEAR KUCHESAR ROAD CHOPLA, SIYANA ROAD, GHAZIABAD MOB. 09997086932, 09291565668, 09897043589",
  "AGRA EDUCATION COLLEGE",
  "Chakleshwar Singh Educational Institute",
  "LOTUS SHIKSHAN SANSTHAN KOSI KHURD MATHURA",
  "SHRI RADHA KRISHNA DEGREE COLLEGE",
  "SRI JILEDAR SINGH SMARAK MAHAVIDYALAYA SULTAN PUR KISHINI MAINPURI",
  "SHRI JI GOVERDHAN MAHARAJ COLLEGE OF PROFESONAL STUDIES ",
  "ASHA DEVI BALIKA MAHAVIDYALAYA",
  "RAJKKEEYA MAHAVIDYALAYA LOTNA PURVA UNNAO",
  "SRI RAJENDRA SINGH COLLEGE ",
  "SMT. SHOBHA DEVI SOWARN SINGH MAHAVIDYALAYA ",
  "Dr.Ram Manohar Lohiya Mahavidyalaya Jhotari, Dhamupur, Ghazipur",
  "SRI BHIYALAL RAMVEER SINGH MAHAVIDYALAYA",
  "PREM NARYAN ISHWAR DAYAL MAHAVIDYALAYA ",
  "FATMA VIDHI MAHAVIDYALAYA",
  "MAHAVEER COLLEGE OF HIGHER EDUCATION HABUSA MOD SARAI INAYAT PRAYAGRAJ",
  "SHRI VIDHYA SAGAR KANYA MAHAVIDHALAY, LALITPUR",
  "Rajdev Mahavidyalaya ,Sipah Jahurabad, Ghazipur",
  "SMT. KAMALA YADAV YADUNATH SINGH MAHAVIDYALAYA",
  "Krishak Mahavidyalay, Rajgarh, Mirzapur",
  "ROHIT SINGH EDUCATIONAL TRUST MANGARH KUNDA PRATAPGARH",
  "PREM CHANDRA COLLEGE, RAMAIPUR, ALLAHABAD",
  "PHOOLAN SRI MAHILA MAHAVIDYALAYA",
  "GURUKUL MAHAVIDYALAYA",
  "SHRI SANTKUMAR SINGH MAHILA MAHAVIDYALAYA DUGHARA GORAKHPUR",
  "DR. RAM KRISHAN RAJPUT LAW COLLEGE ",
  "DR. ANAR SINGH LAW COLLEGE ",
  "CHAUDHARY BADAM SINGH MAHAVIDYALAYA INDARPUR FARUKHABAD",
  "SMT. URMILA DEVI MAHAVIDYALAYA BHARTHANA ",
  "Jagatpur P.G.College, Varanasi",
  "CH. HUKUM SINGH DEV KUWAR MAHAVIDYALAYA ",
  "VISHAL VIDHI MAHAVIDYALAYA EKDIL ETAWAH",
  "BRIJBHUSAN SINGH COLLEGE OF LAW",
  "Mathura College of Law, Purjageer, Mirzapur",
  "SATYAWATI GAYAPRASAD MAHILA MAHAVIDYALAYA VAIVAHA",
  "PRABHAT ACADEMY",
  "Nanhku Ram Mahavidyalaya, Padri Khurda (Patka gaon) Mudiladih, Sonebhadra",
  "SHAMBHONATH COLLEGE OF EDUCATION",
  "Rajeev Gandhi Mahavidyalaya, Mandara, Jakhiniya, Ghazipur",
  "Baba Ramdal Surajdev Smarak Mahavidyalaya, Madhopur, Pakwainar,Ballia",
  "Shyam Mahavidyalaya, Senduriya, Chopan, Somebhadra",
  "SHRI HARDAYAL MAHILA MAHA VIDYALAYA ",
  "Sardar Ballabh Bhai Patel Mahavidyalaya, Bacchawan, Varanasi",
  "Anusri College, Abhiya Road, Kaira, Suriyawan, Sant Ravidas Nagar, Bhadohi",
  "FAIZ-E-AAM MODERN DEGREE COLLEGE MATHURA",
  "POORAN PRASAD GUPTA MEMORIAL COLLEGE, AGRA",
  "BENI MADHAV CHYAWAN JI MAHARAJ MAHAVIDYALAYA",
  "RAM SUMER SURYAVANSHI MAHILA COLLAGE ,GHAZIPUR",
  "LATE.C G GIRLS DEGREE COLLEGE RAMPUR GHAZIPUR",
  "BABA SAHAB DR. BHIM RAO AMBEDKAR COLLEGE OF AGRIL ENGG. & TECHNOLOGY ETAWAH ( CSAUA&T KANPUR)",
  "Sri Vindeshwari Janki Mahavidyalaya, Pidarikala, Sant Kabir Nagar",
  "Kaushilya Mahavidyalaya, Dilavarpur, Mariyahu Jaunpur",
  "YASHRAJ COLLEGE OF PROFESSIONAL STUDIES",
  "JAGPATI SHEETLA PRASAD PRASHIKSHAN VIDHI MAHAVIDYALAYA ",
  "R. N. SHIKSHA DEEP KANYA MAHAVIDHYALAYA",
  "Shri Dhaneshwar Siksha avam Prasikshan Sansthan, Kusumhi khurd, Ghazipur",
  "B. S. MUKHIYA MAHAVIDHYALAYA",
  "GCRG Memorial Trusts Group of Institutions Faculty of Engineering",
  "VEERANGNA MAHARANI LAXMIBAI GOVT. GIRLS DEGREE COLLEGE",
  "GOVT. GIRLS DEGREE COLLEGE",
  "Baba Jageswar Nath Mahavidyalay, Hetimpur, Chakiya, Chandauli",
  "GOVT. DEGREE COLLEGE, SAMTHAR",
  "GOVT. DEGREE COLLEGE, MAUDAHA                        ",
  "GOVT. DEGREE COLLEGE, CHARKHARI",
  "CH. M.P. SITAVI DEVI VIDHI MAHAVIDYALAYA,KANNAUJ",
  "GOVT. DEGREE COLLEGE, MANIKPUR                             ",
  "GOSWAMI TULSI DAS GOVT. DEGREE COLLEGE, KARWI",
  "SANATAN DHARMA BALIKA DEGREE COLLEGE, ORAI",
  "GHANARAM NIRANJAN MAHAVIDYALAYA, DIRAVATI",
  "R.P. Degree College, Dharsara, Ghorawal, Sonebhadra",
  "USHA EDUCATIONAL INSTITUTE FARAH MATHURA",
  "AABAN LAW COLLEGE JOYA",
  "CHAUDHARY OMKAR SINGH GIRLS DEGREE COLLEGE EDALGARHI BAJNA MATHURA",
  "GAYA PRASAD MAHAVIDYALAYA, SITAPUR",
  "VIVEKANANDA COLLEGE OF TECHNOLOGY AND MANAGEMENT, ALIGARH",
  "EKALAVYA MAHAVIDYALAYA, DUREDI ROAD",
  "DR RAM MANOHAR LOHIYA DEGREE COLLEGE, SULTAN NAGAR, KARVI",
  "DR RAM MANOHAR LOHIYA MAHILA MAHAVIDYALAYA, GURSARAI",
  "VIKRAMADITYA VIDHI MAHAVIDYALAYA BIRGAPUR HANUMANGANJ PRAYAGRAJ    ",
  "DR. B.R. AMBEDKAR DEGREE COLLEGE, LADAKA PURWA",
  "SHREE DEEPCHANDRA CHOUDHARY MAHAVIDYALAYA, LALITPUR",
  "PT. DEEN DAYAL UPADHYAY GOVT. DEGREE COLLEGE, MAHRAUNI",
  "D.D. SINGH BISEN MAHAVIDYALAYA, LAHARGIRD",
  "AWADH BIHARI SINGH MAHAVIDYALAY SHRIKANTPUR URF NARAYANGARH BALLIA",
  "Sri Baldeo P.G.College Baragaon, Varanasi",
  "R.S. Banaras Law College, Karmajitpur, Sundarpur, Varanasi",
  "CHHATRAPATI SHIVAJI M.S.D. MAHAVIDYALAYA, PALI",
  "CHHATRAPATI SHAHUJI MAHARAJ MAHAVIDYALAYA NARAINA KHERA, AGARHUNDA,",
  "CHATRAPATI SAHU JI MAHILA MAHAVIDYALAYA, KARVI",
  "RAMPATI DEVI KANYA MAHAVIDYALAYA, SARAIYA, PUROSHOTAMPUR JAISINGHPUR, SULTANPUR",
  "CHANDRA SHEKHAR AZAD INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "Shri Prahalad Mukhiya Mahavidhyalaya, Jatipura Road, Gaunthauli, Goverdhan Mathura",
  "GULAB RANI MAHAVIDYALAYA, BADAUSA",
  "VIKRAM SIKSHA NIKETAN MAHVIDYALAYA , MAINPURI",
  "B D M INTERNATIONAL LAW COLLEGE",
  "Rajbahadur Yadav Mahavidyalaya, Ekauna, Jaunpur",
  "STATE INSTITUTE OF FOOD PROCESSING TECHNOLOGY, LUCKNOW",
  "Sri Ram Chandra Mahavidyalay, Trikalpur, Garwar, Ballia",
  "FUTURE INSTITUTE OF PHARMACY",
  "FUTURE INSTITUTE OF ENGINEERING & TECHNOLOGY,BAREILLY",
  "Kusmara Mahila Mahavidhyalaya, Kusmara",
  "Shri Bhagwan Singh Girls College of Education and Technology, Akbarpur Mod, Shamsabad Road",
  "THE SUN SHINE COLLEGE OF EDUCATION, GHAZIPUR    ",
  "SHIV KUMARI MAHAVIDYALAYA, ASHAPUR RANIGANJ",
  "MAHAVIDYALAYA PURE BUDDHIDHAR, BABAGANJ, PRATAPGARH",
  "MAA GAYATRI GANGA PRASAD MISHRA MAHILA DEGREE COLLEGE KAPTANGANJ BASTI ",
  "Buddha Institute of Pharmacy",
  "S.S.L.D. VARSHNEY INSTITUTE OF MANAGEMENT AND TECHNOLOGY, ALIGARH",
  "DVS COLLEGE",
  "RAAFIAH COLLEGE OF EDUCATION",
  "VIMALA SHANKAR VIDHI MAHAVIDYALYA AKAVASPATTI BHITARI GHAZIPUR ",
  "Bala Ji Girls Degree College Bhabhaura Aurihar Ghazipur",
  "St GEORGE INSTITUTE OF EDUCATION FOR WOMEN",
  "J S Singh Institute of Pharmacy Sitapur ",
  "SHRI INDRAMANI MAHILA MAHAVIDYALAYA, KHOIRI, BARSHATHI, JAUNPUR",
  "SAI LAW COLLEGE",
  "GODWILL DEGREE COLLEGE",
  "PATRONAGE INSTITUTE OF MANAGEMENT STUDIES, GREATER NOIDA",
  "SRI BAIJNATH GIRLS INSTITUTE OF EDUCATION AND MANAGEMENT",
  "DAYANAD ARYA VEDIK DEGREE COLLEGE KUNDAUL,AGRA",
  "UPENDRA JEET SINGH MAHILA MAHAVIDYALAYA ",
  "BBDIT College of Pharmacy Ghaziabad",
  "Savitribaifule Rajkiya P.G. College, Chakiya, Chandauli",
  "MANTI DEVI VISHWANATH MAHILA MAHAVIDYALAYA DEVPAR MADANPUR DEORIA",
  "Adarsh Janta Mahavidyalaya, Kolna (Chunar) Mirzapur",
  "Sudha Devi Mahavidyalaya, Pancharaw, Varanasi",
  "Maa Khandwari Vidhi Mahavidyalaya, Chahniya, Chandauli",
  "Chhatradhari Mahavidyalaya, Dayalpur, Sadalpura, Chandauli",
  "S A M Mahavidhalaya",
  "Shri Maharaj Singh Smarak Mahavidhyalaya",
  "GYAN STHALI DEGREE COLLEGE, BHARTHANA",
  "HARI SINGH MEMORIAL DEGREE COLLEGE NARAYANPUR URF UDHOWALA , BIJNOR",
  "CHANDPUR DEGREE COLLEGE ",
  "CITY COLLEGE OF PHARMACY",
  "Meerut Institute of Special Education ",
  "MOTI PRASAD CHAUDHARY MAHAVIDYALAYA BRAMHPUR MAHARAJGANJ",
  "SHREE DEV VIDYAPEETH MAHILA MAHAVIDAYALA",
  "Kalpa Devi Ramdev Rai Balika Mahavidyalaya, Kauwatar",
  "IKRAM NABI KHAN GIRLS DEGREE COLLEGE, NANDAUR, MEHDAWAL, SANT KABIR NAGAR",
  "Dr. Mithilesh Mani Tripathi Adrash Degree College, Kotia Gadori, Siddharthnagar",
  "D.P.S INSTITUTE, CHRANGHIYA, TULSIPUR",
  "OMKANTA DEGREE COLLEGE, RAKSHA",
  "INDCARE COLLEGE OF LAW, KNOWLEDGE PARK III, GREATER NOIDA",
  "COLONEL JAGANNATH SINGH MAHAVIDYALAYA LORPUR TAJAN AKBARPUR AMBEDKAR NAGAR UP ",
  "Shri Haygriv Ramanuj Sanskrit mahavidyalaya, mathura",
  "INSTITUTE OF MANAGEMENT EDUCATION AND TECHNOLOGY",
  "PRAHLAD SINGH MEMORIAL DEGREE COLLEGE, FALAWDA ROAD, CHITORA, KHATAULI",
  "EKLAVYA VIDHI MAHAVIDYALAYA, MAHOBA ROAD",
  "KRISHNA P. R. COLLEGE OF EDUCATION PAUSARA",
  "AMBAY GIRLS DEGREE COLLEGE, HAPUR",
  "Shri Vidya Bhushan Sanskrit Mahavidyalaya",
  "Sri Bajrang Singh Mahavidyalaya Mau Gauriganj Amethi Sultanpur",
  "MAHATMA GANDHI MAHILA DEGREE COLLEGE",
  "Shri Raam Rajaraam Sanskrit Mahavidyalaya,Varanasi",
  "JAI SHREE COLLEGE",
  "Excellence Institute of Higher Education, Jewri",
  "DAYANAND VIDYAPEETH COLLEGE OF LAW",
  "AADISHREE GIRLS COLLEGE FOR HIGER EDUCATION, NH-119 KAUL MAWANA",
  "SW. SURESH CHANDRA MISHRA LAW COLLEGE, KUCHECHA",
  "BUNDELKHAND NAVODAYA MAHAVIDYALAYA, MUSKARA",
  "NANDINI NAGAR VIDHI MAHAVIDYALAYA, NAWABGANJ",
  "GINNI DEVI MODI INSTITUE OF EDUCATION, MODINAGAR, GHAZIABAD",
  "HIND MAHILA VIDYAPEETH",
  "Shri Sangved Mahavidyalaya, Narawar, Narora",
  "DAKSH MAHILA VIDYPEETH, CHANDOK DORAHA, JAHANGIRABAD",
  "CITY LAW COLLEGE, LAKSHBAR BAJHA",
  "J P COLLEGE FOR HIGHER EDUCATION",
  " J P COLLEGE OF LAW",
  "SDJP Mahavidalaya, Dalla Nizampur",
  "RAM MILAN MAURYA KARMA DEVI MAHILA MAHAVIDYLYA, NATTHUPUR LAUDHANA",
  "Shri Viswanath Sanskrit Mahavidyalaya, Koraon",
  "Kunvar Singh Mahavidyalaya, Ballia",
  "Arya Kanya Mahavidyalaya ",
  "Abhinav Pragya Mahavidyalaya, Kumhariya, Rath",
  "Abhinav Pragya Mahavidyalaya, Lodhipur, Nivada, Rath Road",
  "Shri Kashi Raj Rajakiya Sanskrit Mahavidyalaya, Gyanpur, Bhadohi",
  "Maa Shanti Devi Mahavidyalaya, Haldirampur(Baharpur) Belthara Road, Ballia",
  "RAIZADA DHARAMDAS INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "Loknath Mahavidyalaya, Ramgarh, Chandauli",
  "Maharaja Suheldeo Mahila Mahavidyalaya, Gaziapur, Semri, Ballia",
  "Sirataj Singh Humela Devi Sikshan and Prashichan Mahavidyalaya",
  "Shivalik Mahavidyalaya, Patana, Khargaura, Bhinga Shrawasti",
  "MODERN SCHOOL FOR EDUCATION, HAPUR",
  "Shri Raam Roop Sanskrit Mahavidyalaya",
  "OM GHUSHMESHWAR NATH MAHAVIDYALAYA, SARAI SETAN LALGANJ",
  "MANRAJI MUNNARRAM MAHAVIDYALAYA, MAJHAULI PATTI",
  "DR K N MODI INSTITUTE OF PHARMACEUTICAL EDUCATION & RESEARCH, GHAZIABAD",
  "RAMPHAL MEMORIAL KANYA MAHAVIDYALAYA ",
  "SWAMI VIVEKANANDA DIGREE COLLEGE PHATWA BALRAMPUR",
  "KRS COLLEGE OF HIGHER EDUCATION",
  "Shaheed Bhagat Singh Girls Degree College, Rardhana, Sardhana",
  "Raghuwar Dayal Prabhu Dayal Institute of Higher Education, Shekhupur Raura, Jahangirabad",
  "Shri Sarvar Adarsh Sanskrit Mahavidyalaya",
  "Piyush Prashikshan Mahavidyalaya, Gauriganj, Amethi",
  "MAA VAISHNO DEVI SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA, PURE KIRAT SIYARAMNAGAR",
  "SAI KRIPA SHIKSHAN PRASHIKSHAN SANSHTHAN, DUNDI AMANIGANJ",
  "DR MAMTA COLLAGE OF LAW, KOLHAMPUR, NAWABGANJ",
  "HAJI WARIS ALI SHAH MEMORIAL DEGREE COLLEGE",
  "SHRI RAMNIWAS GIRLS COLLEGE, KARNWAL",
  "VIDYOTMA KANYA MAHAVIDYALAYA ",
  "Kaulesar Suryamati Mahavidayala, Mohanpur Gilant",
  "DEV SHIKSHAN PRASHIKSHAN SANSTHAN, KHAJURI, HAIRINGTONGANJ",
  "K.B. P.G. College, Mirzapur",
  "SHRI RAM INSTITUTE OF PROFESSIONAL STUDIES",
  "NARAYAN MEMORIAL GIRLS COLLEGE OF EDUCATION, ASAUOPAR ",
  "SHRI HARINARAYN SINGH SHIKSHAN SANSTHAN, DERA MAUSHI BARA GAON",
  "Balaji Degree College Sorana Sarsawa saharanpur",
  "SHANTI DEVI JAIN GIRLS DEGREE COLLEGE, SHAHPUR, SAHARANPUR",
  "JANTA MAHAVIDHALYAYA AMBHETA CHAND SAHARANPUR",
  "KISAAN SEWAK DEGREE COLLEGE GARI ABDULLA KHAN SHAMLI",
  "VIDOTAMA  KANYA MAHAVIDYALAYA, GANGDHARI, KHATAULI,  MUZAFFARNAGAR",
  "MEERUT INTERNATIONAL INSTITUTE OF TEACHERS",
  "KAILASHPATI SHIKSHAN EVAM PRASHIKSHAN MAHILA MAHAVIDYALAYA, KURAWAN",
  "G.D. Binnani P.G. College, Mirzapur",
  "RAGHURAJ SHARAN SINGH MAHAVIDYALAYA, NAKHA BASANT BALPUR",
  "SHEETALGANJ PRATAP MAHAVIDYALAYA, SHEETAL GANJ GRANT, MASKANWA",
  "BABA HARDEV MAHADEV SMARAK MAHAVIDYALAYA, LODHAURA, RUDAULI",
  "Maharani Gulab Kunvri Mahila Mahavidyala, Pindra, Varanasi",
  "VIPIN BIHARI SHARAN SINGH MAHAVIDYALAYA, TARABGANJ",
  "HARI PRASAD NIRMALA WITS MAHAVIDYALAYA, GOKULPUR",
  "Sri Saraswati Sanskrit Snatakottar Mahavidyalaya, Akodha",
  "MAHILA SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA, TURKAULI, NAWABGANJ",
  "NANDINI EDUCATIONAL INSTITUTE, BALAPUR, NAWABGANJ",
  "LATE BABU INDRABAHADUR SINGH SMARAK MAHAVIDYALAY, AMANIGANJ",
  "RRS COLLEGE OF EDUCATION, AZAMPUR",
  "CHANDRAKANTA MAHAVIDHAYALAYA, PIRBIAWANI",
  "DEVBUX BALDEV SMARAK MAHAVIDYALAYA, HANUMANGANJ, SARURPUR",
  "AL BARKAT INSTITUTE OF MANAGEMENT STUDIES, ALIGARH",
  "R.S.S. MAHAVIDHYAL SAINDPUR MATHURA",
  "SHIVKALA BUDDH SHIKSHAN PRASHIKSHAN SANSTHAN, KADIPUR,  KAKOLI RAMPUR BHAGAN",
  "Raj Kishor Yadav Balika Mahavidalaya, Mudiladih, Kadipur",
  "CHAUDHARY MAHAVIDYALAYA",
  "LPS GROUP OF INSTITUTE AND MEDICAL SCIENCE AONLA BAREILLY",
  "SHRI RAM GAMBHIR KASTURI LAL ABBI GROUP OF COLLEGES ",
  "VINOBA VIDYAPEETH",
  "VISHNUDEEP MAHAVIDYALAYA GHATAMPUR AHAROURA MIRZAPUR",
  "VIKRAM SINGH KANYA MAHAVIDYALAYA",
  "D K D L DEGREE COLLEGE KAJU KAUSHAMBI",
  "NARAYAN MAHAVIDYALAYA, SURWAN MISIRPUR ",
  "MAULVI FARZAND ALI COLLEGE OF LAW",
  "SHARDA DEEN SINGH COLLEGE OF LAW",
  "ASHA RAM SINGH GIRLS DEGREE COLLEGE",
  "RAM SAJEEVAN SAVITRI DEVI DEGREE COLLEGE",
  "BABU SANKATHA PRASAD MISHRA VIDHI MAHAVIDYALAYA AUTA MEJA PRAYAGRAJ UP",
  "Government Medical College, Azamgarh",
  "JMC DEGREE COLLEGE",
  "K.R GIRLS COLLEGE MATHURA",
  "RAJKIYA MAHAVIDYALAYA, BEEKAPUR",
  "SRI HUBRAJ JAISWAL MAHILA MAHAVIDYALAYA BARIYAWAN",
  "Pt. Shantibhushan Mahavidyalaya, Gajokhar, Parsara, Varanasi",
  "Swami Atulanand Hindu Mahavidyalaya, Parmanandpur, Shivpur, Varanasi",
  "GYATRI MAHAVIDYALAYA MUDI JAHAGIRPURI KHANDHAVLI, AGRA",
  "SITA RAM SINGH MAHAVIDYALAYA",
  "Rajat Degree College of Education and Training Institute",
  "Rajat Balika Degree College",
  "BABU LAKSHMAN PRASAD EDUCATIONAL INSTITUTE",
  "Shri Ram Krishna Mahavidyalaya Kisoli Bulandshahr",
  "L S R LAW ACADEMY KNOWLEDGE AND INNOVATION CAMPUS NH, FIFTY EIGHT ABUPUR",
  "BALWANTA DEVI JAGATPAL COLLEGE OF EDUCATION, KATEHARI",
  "FLORENCE NIGHTINGALE PUBLIC GIRLS DEGREE COLLEGE",
  "VIMLA DEVI COLLEGE OF EDUCATION",
  "Udai Pratap College, Varanasi",
  "SHRI BALRAM SINGH MAHAVIDYALAYA",
  "SHRI JI BABA COLLEGE OF LAW SEMRI MATHURA",
  "INSTITUTE OF PARAMEDICAL SCIENCES SITAPUR",
  "Pt. Shivcharan Sharma  Mahavidhyalaya,Goharra,Iradat Nagar,Agra",
  "SHREE CHANDRA BHAN SINGH DEGREE COLLEGE FACULTY OF PHARMACY",
  "SMT.MARGSHREE KANYA MAHAVIDYALAYA PERETH ,FIROZABAD",
  "Meerut college for Girls Education",
  "DAU DAYAL MAHILA MAHAVIDYALAYA FIROZABAD",
  "SARAS COLLEGE OF PHARMACY",
  "KEWALPATTI RAMASREY MAHAVIDDYALAYA",
  "SWATANTRA GIRLS DEGREE COLLEGE",
  "SHEKHAR COLLEGE OF EDUCATION",
  "NARVADESHWAR DEGREE COLLEGE",
  "SHRI CHANDRA BHAN SINGH DEGREE COLLEGE, AGRA",
  "KAYAM SINGH MAHAVIDYALYA ORANDH MAINPURI",
  "B.D.M. KANYA DEGREE COLLEGE, AGRA",
  "SHASHI BHUSHAN GIRLS DEGREE COLLEGE, 61- GURU GOVIND SINGH MARG",
  "Maa Bhawani Mahavidyalaya, Sogai, Chandauli",
  "Shri Abhimanyu Yadav Mahavidyalaya, Lapri, Jaunpur",
  "Sarvoday Mahila Mahavidyalaya, Pranpatti, Leduka, Jaunpur",
  "Shambhu Narayan Mahavidyalaya, Harhari, Ghazipur",
  "Shri Chandrabali Balika Mahavidyalaya, Saidpur, Ghazipur",
  "Regional Institute of Ophthalmology  ",
  "LOKMANI SHARMA SWATANTRATA SANGRAM SENANI GOVERNMENT DEGREE COLLEGE MANT MATHURA ",
  "Ambika Prasad Degree College, Baburi, Dheena, Chandauli",
  "Vishwnath Singh Mahavidyalaya, Parasurampur, Chandauli",
  "Pt. Kamalapati Tripathi Rajkiya P.G. College, Chandauli",
  "Mahadev Mahavidyalaya, Bariyasanpur, Varanasi",
  "Sri Krishna Mahila Mahavidyalaya, Hasanpur, Chandauli",
  "Falahe Ummat Girl Degree College, Station Road,Bhadohi",
  "institute of Education Nibia, Bachawan, Varanasi",
  "Vindhya Kanya Mahavidyalaya, Urmaura, Rabertsganj, Sonebhadra",
  "Dayawanti Punj Training Institute, Sitamadhi, Sant Ravidas Nagar, Bhadohi",
  "Lokbandhu Rajnarayan Law College, Motikot, Gangapur, Varanasi",
  "Lalta Singh Rajkiya Mahila Mahavidyalaya, Adalhat, Mirzapur",
  "Swami Sahajanand Mahavidyalaya, Kachwan, Mirzapur",
  "SMT BHAGRATHI DEVI MEMORIAL DEGREE COLLEGE RAMPUR GHOGHAR MORADABAD",
  "DR. NARENDRA DWIVEDI SHIKSHA MAHAVIDYALAYA, KARSAN, ORAI",
  "KASHINATH SHIKSHA SANSTHAN, NARAYANPUR, KAKRAHI, DAULATPUR, GHAZIPUR ",
  "Kashi Nath Banarasi Mahavidyalaya, Ghazipur ",
  "Lalji Ramraj Yadav Mahavidyalaya, Belwa, Madiyahu",
  "Kedar Faujdar Mahavidyalaya, Guraini ",
  "Vindhyachal Ji (Girls) College, Alavalpur",
  "Shri Jaimangal Sanskrit Mahavidyalaya, Nari, Khunshapur",
  "Maa Mansha Devi Mahavidyalaya, Barhani, Chandauli",
  "adarsh Ramadhar Mahavidyalay, Nyekoat, Rayespur, Muniyar, Ghazipur",
  "Maharshi Moolchand Yadav Mahila Mahavidyalaya, Nadauli, Kerakat, Jaunpur",
  "MAYA DEVI SITA RAM DEGREE COLLEGE ",
  "DR AWDHESH PRAKASH SHARMA SMARK MAHAVIDDAYLAY, NASIPUR",
  "Kashi Anathalaya Associations Vanita Polytechnic",
  "Shahid Hira Singh Rajkiya Mahavidyalaya, Dhanapur, Chandauli",
  "Maa Sharda College of Education Suithakalan Shahganj Jaunpur",
  "Baba Vishwanath Mahavidyalaya, Ghazipur",
  "ZEERA DEVI MAHILA MAHAVIDYALAY, KOLHUA, LAKRA, UTRAWAL, SANT KABIR NAGAR",
  "Sri Guru Gorakhnath Degree College, Jogia, Ghughali, Maharajganj",
  "Ram Adhare Chaurasia Mahavidyalay, Bakainiha, Uska Bazar, Siddharthnagar",
  "Rajiv Gandhi Memorial Degree College, Lehra, Brijmanganj, Maharajganj",
  "GAURAV B T C MAHILA COLLEGE KATARI CHOLAPUR VARANASI",
  "Yamuna Devi Mahavidyalaya, Pura, Balua, Chandauli",
  "Ram Dev Degree College, G.T. Road, Jangiganj, Sant Ravidas Nagar, Bhadohi",
  "Jai Maa Bhagwati Sonanchal P.G. College, Pusauli, Sonebhadra",
  "Swami Govindashram Mahavidyalay, Pairapur, Mirzapur",
  "O.D.M. COLLEGE KOYAL RAYA MATHURA",
  "Budham Sharnam Mahavidyalaya, Mudval Fatiulahpur, Ghazipur",
  "Maa Sharada Mahila Mahavidyalaya Jalalabad, Ghazipur",
  "BABA KINARAM AUTONOMOUS STATE MEDICAL COLLAGE, CHANDAULI",
  "Ram Suresh Singh Mahavidyalaya, Mirzapur",
  "Babu Basant Lal Rajnarayan Mahavidyalaya, Mirzapur",
  "S.K. Mahila Mahavidyalaya, Mirzapur",
  "Shri Gajanand Sheetal Yadev Mahavidyalaya, Mirzapur",
  "Vanvashi Mahila Mahavidyalaya, Dala, Sonebhadra",
  "Babu Ram Ujagir Singh Mahavidyalaya, Mirzapur",
  "Sona Devi Mahavidyalaya, Ballia",
  "Muni August Balika Mahavidyalaya, Mirzapur",
  "Shri RamChander Yadev Shrimati Reshma Yadev Mahila Mahavidyalaya, Mirzapur",
  "Guru Karshni Mahavidyalaya, Mirzapur",
  "Vindhya Mahila Mahavidyalaya, Mirzapur",
  " Shri Dhaneshvar Snatkotar Mahavidyalay, Kusumhi Khurd Ghazipur",
  "Sugriva Sahu Ramanaresh Gupt Mahavidyalaya, Sonbhadra",
  "Sarvajeet Singh Mahavidyalaya Koilariya,Sonbhadra",
  "SHRI HRS GIRLS EDUCATIONAL INSTITUTE",
  "SARDAR BHAGAT SINGH COLLEGE OF HIGHER EDUCATION",
  "RAM DULARI ALOK KUMAR MAHILA DEGREE COLLEGE",
  "RADHEYSHYAM DEGREE COLLEGE",
  "R D S J LAW COLLEGE",
  "R D S J COLLEGE OF MANAGEMENT",
  "MODERN COLLEGE OF EDUCATION, LUCKNOW",
  "LALA MAHAVEER PRASAD OM PRAKASH VERMA KANYA DEGREE COLLEGE",
  "L.N. ACADEMY MAHAVIDYALAY",
  "SUBHASH CHANDRA BOSE INSTITUTE OF HIGHER EDUCATION",
  "JURIS LAW COLLEGE",
  "DIVYA SINGH MEMORIAL MAHILA MAHAVIDYALAYA, LUCKNOW",
  "DAYAL GROUP OF INSTITUTIONS, SULTANPUR ROAD, LUCKNOW",
  "CAREER DEGREE COLLEGE, LUCKNOW",
  "CENTRE FOR MANAGEMENT DEVELOPMENT, GHAZIABAD",
  "Lakhan Singh Khazani Devi Mahavdhyalaya,Mursan,Hathras",
  "PEETAMBER DEGREE COLLEGE DAYAL BAGH POIYA GHAT, AGRA",
  "Swatantrata Senani Sri Prabhunarayan Singh Mahavidyalaya, Cholapur, Varanasi",
  "Keshav Prasad Mishra Rajkiya Mahila Mahavidyalaya, Aurai Sant Ravidas Nagar, Bhadohi",
  "Maa Shiv Devi Mahavidyalaya, Belatad, Shahganj, Sonebhadra",
  "PT.SHREE CHAND SHARMA MEMORIAL MAHAVIDYALAYA MANPUR KALYAN KAIR ALIGARH",
  "PRAKASH DEGREE COLLEGE ETAH",
  "C.D. GIRLS DEGREE COLLEGE, LUCKNOW",
  "Sri Ghanshyam Dubey Mahavidyalaya, Suriyawa, Sant Ravidas Nagar, Bhadohi",
  "BASUDEV DEGREE COLLEGE, AMRAAI GAON, LUCKNOW",
  "Musafir Balgopal Mahavidyalaya, Sonbhadra",
  "Maa Khandwari Mahavidyalaya, Chahniya, Chandauli",
  "ACHARYA SITARAM CHATURVEDI MAHILA MAHAVIDYALAYA DOMARI RAMNAGAR VARANASI",
  "Pt. Ramjiyavan Shukla Mahavidyalaya, Sant Ravidas Nagar ",
  "Narottam Singh Padam Singh Rajkiya Mahavidyalaya, Mangaraha, Mirzapur",
  "SHRI RAM SANAHI YADAV DIGREE COLLEGE, SIKANDARAU",
  "B.P SINGH DEGREE COLLEGE KILA ROAD ALIGANJ ETAH",
  "DEV DRISHTI MAHAVIDYALAYA BARAULI RAO ALIGARH",
  "GYAN EDUCATIONAL INSTITUTE",
  "Durga Girls Degree College, Chandauli",
  "SHRI CHITRAGUPT(P.G) COLLEGE,MAINPURI",
  "K L INSTITUTE OF EDUCATION",
  "SRI TEJ SINGH GAJADHAR MAHAVIDYALAYA JAITHRA ETAH",
  "SHRI CHHITAR MAL MAHAVIDYALAYA BRATHALA SAIYAN AGRA",
  "Vimal Singh Mahavidyalaya, Itahara,Sant Ravidas Nagar,Bhadohi",
  "CHAUDHARY JAGAN SINGH COLLEGE UMARI MATHURA",
  "Shri Vijaya Bahadur Mahavidyalaya, Bhadauriya , Baburi, Chandauli",
  "K.P.INSTITUTE OF PFOFESSIONAL STUDIES ETMADPUR, AGRA",
  "RAGHURAM MAHAVIDYALAYA KAGAROL AGRA",
  "SRI GIRIRAJ MAHARAJ COLLEGE OF LAW & PROF. STUDIES, MATHURA",
  "MAA RAMDULARI COLLEGE 11 NR GARDEN OLE, MATHURA",
  "MAHARAJA COLLEGE POLI DUNGRA SONKH ROAD MATHURA",
  "CH.DEVI SINGH MAHAVIDYALAYA ANJANI MAINPURI",
  "Yamuna Girls College Of Education, Badhawal,Bhojapur, Chandauli",
  "PC BAGLA COLLEGE MAHAMAYA NAGAR (HATHRAS)",
  "DAYANAND GIRLS P.G. COLLEGE, KANPUR",
  "TILAK MAHAVIDYALAYA, AURAIYA",
  "COLLEGE OF MANAGEMENT STUDIES, KADER PATARI, HADHA,",
  "DR. VIRENDRA SWARUP INSTITUTE OF PROFESSIONAL STUDIES, KIDWAI NAGAR, KANPUR",
  "SONAMATI MAHAVIDYALAYA, NANAMAU MARG, BILHOUR,",
  "SARASWATI MAHAVIDYALAYA, NEAR TIXI TEMPLE,",
  "SMT. SHAKUNTALA DEVI MAHILA MAHAVIDYALAYA, RUR, KHIDINI,",
  "SAI COLLEGE OF MEDICAL SCI. & TECH., CHAUBEPUR,",
  "SHRI SHAKTI DEGREE COLLEGE, SHAKHAHARI, HARBASPUR,",
  "DR. GOVIND PRASAD RANI DEVI PATEL VIDHI MAHAVIDYALAYA, ARAUL,",
  "BHARTIYA MAHAVIDYALAYA,",
  "CITY PUBLIC MAHILA DEGREE COLLEGE, NEKPUR CHAURASI,",
  "SRI C.B. SINGH MEMORIAL SHIKSHAN SANSTHAN, JHINJHAK,",
  "M.D.B.L. DEGREE COLLEGE, BAUDH VIHAR, BHARTHANA,",
  "MANNULAL DWIVEDI MAHAVIDYALAYA, SAHAR, AURAIYA",
  "D.A.V. COLLEGE, KANPUR",
  "VISION COLLEGE OF MANAGEMENT, HATHIPUR, MAHARAJPUR,",
  "SRI GOPINATH SINGH LAW COLLEGE, YADUVANSH NAGAR, TALGRAM ,",
  "MAJOR SHIVDAYAL SINGH VIDHI MAHAVIDYALAYA, BEVAR ROAD, FATEHGARH, FARRUKHABAD",
  "CHAUDHARY JAMADAR SINGH MAHILA DEGREE COLLEGE, SAURIKH,",
  "CHAUDHARY MAHADEV PRASAD MAHAVIDYALAYA, PALEPUR, UNNAO",
  "SMT. AMTUNNA BANO MAHILA MAHAVIDYALAYA, GURSAHAIGANJ,",
  "JANTA MAHAVIDYALAYA, GAURIKARAN,",
  "SINGH VAHINI MAHAVIDYALAYA, ADAMPUR, AJITMAL,",
  "SRI RAVINATH SINGH DEGREE COLLEGE, JAITPUR,",
  "R.S.G.U. COLLEGE, PUKHRAYAN,",
  "PURUSHOTTAM SINGH MAHAVIDYALAYA, RAJENDRA NAGAR,",
  "CAP. VISHAL SINGH DEGREE COLLEGE, BHARTHANA,",
  "JHAULAL GAJODHAR PRASAD MAHAVIDYALAYA, RASULABAD,",
  "GAUTAM BUDDH MAHAVIDYALAYA, SAHIYAPUR,",
  "S.P.B. SANATAN DHARM DEGREE COLLEGE, HINDPAL KHERA, MAHAI,",
  "RAMWATI RAJ BAHADUR DEGREE COLLEGE, PRITHVIPUR,",
  "VIVEKANAND INSTT. OF MANAGEMENT & TECHNOLOGY, ALAMPUR,",
  "SMT. RAMA DEVI MAHILA MAHAVIDYALAYA, JHINJHAK,",
  "SHRI JAGWANT SINGH BHADOURIA DEGREE COLLEGE, AMOUR,",
  "BAUDHA BAL VIDYA MANDIR DEGREE COLLEGE, ACHHALDA,",
  "SRI SHIV MAHAVIDYALAYA, YAKUBPUR,",
  "PATEL VIDYAPEETH MAHAVIDYALAYA, BARAUR,",
  "SIR MADAN LAL INSTITUTE OF EDUCATION, ALAMPUR HAUZ,",
  "LUCKNOW CAMPUS",
  "GANGANATH JHA CAMPUS",
  "Shri Tridandi Dev Sanskrit Mahavidyalaya, Kaushlesh Sadan, Katara, Ayodhya",
  "Shri Shastratha Sanskrit Mahavidyalaya, Dashaswamedh",
  "Devi Savitri Sanskrit Mahavidyalaya, Dakinganj",
  "Shri Sanatan Dharm Sanskrit Mahavidyalay Jalalpur Jaunpur",
  "Adarsh Rani Chandravati Shyama Mahavidyalaya, kachori Gali",
  "Hanumat Sanskrit Mahavidyalaya, Hanuman Gahri, Ayodhya",
  "Raja Ram Sanskrit Mahavidyalaya, Jakhav, Gopiganj",
  "Shri Sanatan Dharm Sanskrit Mahavidyalaya, Navabganj",
  "Shri Gandhi Gurukul Sanskrit Mahavidyalaya, Bhavarnath",
  "Shri Ram Sanskrit Pathshala, Jhhauva, Ramganv",
  "Maharaja Pateshwari Prasad Singh Adarsh Sanskrit Mahavidyalaya, Balrampur",
  "Saraswati Adarsh Sanskrit Mahavidyalaya, Khairabad",
  "Shri Shiv Prasad Sanskrit Mahavidyalaya, Chitava Bazar Pajawa",
  "Indira Sanskrit Mahavidyalaya, Indara",
  "Shri Vishwanath Gurukul Sanskrit Mahavidyalaya, Karnaghanta",
  "Shri Yogiraj Sanskrit Mahavidyalaya, Gopal Mandir Ramghat Ayodhya",
  "Shri Bholanath Adarsh Sanskrit Mahavidyalaya, Ukani",
  "Ramkripalu Sanskrit Mahavidyalaya, Pure Murali, Amanva",
  "Shri Harihar Rajmati Sanskrit Mahavidyalaya, Ramgarh Bariya",
  "Shri Raam Asre Tripathi Sanskrit Mahavidyalaya, Chilhiya",
  "Shri Kabir Adarsh Sanskrit Mahavidyalaya, Kabir Chaura",
  "Shri Chaitanya Shiksha Sansthan, Shital Chaya Raman Reti, Vrindavan",
  "Pratham Shreniya Vidyadharm Vardhini Sanskrit Mahavidyalaya, Prem ka Pura",
  "Vivek College of Law",
  "Shri Mukund Sanskrit Mahavidyalaya, Kannauj",
  "Shrikrishna Sanskrit Mahavidyalaya, Laxmipur, Tarkulwan",
  "Shri Bajrang Adarsh Sanskrit Mahavidyalaya, Dardar Ashram, Chandawa, Barwa",
  "Vidyaratna Sanskrit Mahavidyalaya, Kaneri, Phoolpur",
  "Janaki Raman Sanskrit Mahavidyalaya,",
  "Shri Sharad Kumari Sanskrit Mahavidyalaya, Kaniyar, Baraganv",
  "Shishu Sanskrit Vidyalaya, Veersinghpur Saraiya, Saya",
  "Shri Rishikul Brahmcharyashram Adarsh Sanskrit Mahavidyalaya, Katghar",
  "Shri Mahaveer Sanskrit Mahavidyalaya,Veerapur, Kamlanagar",
  "Annada Devi Kanya Gurukul Sanskrit Mahavidyalaya, Shivala",
  "Mahanirvan Ved Mahavidyalaya, Daraganj, Prayag",
  "Govardhan Sanskrit Mahavidyalaya, Ramkot, Ayodhya",
  "Sanatan Dharm Sanskrit Mahavidyalaya, Rupaideeha",
  "Shri Shivaharsh Devanarayan Bhagvat Prasad Sanskrit Mahavidyalaya, Poore Hanuman Deenpur, Akodhhi",
  "VSSD COLLEGE, KANPUR",
  "RAM KRISHNA MAHAVIDYALAYA, RANU KHERA, KAMALGANJ,",
  "CHHATRAPATI SHIVAJI MAHAVIDYALAYA, SIKANDARA,",
  "CH. NATTHU SINGH YADAV MAHAVIDYALAYA, KUMHAWAR,",
  "Shri Sankirtan Brahmcharyashram Sanskrit Mahavidyalaya, Jhoonsi, Prayag",
  "Shri Panini Sanskrit Mahavidyalaya, Dayanand Nagar Kolhui",
  "Shri Mrityunjay Pandey Sanskrit Mahavidyalaya, Barahua, Saidpur",
  "Shri Gurudev Sanskrit Vidya Mandir, Paruiya Ashram",
  "Shri Sanatan Dharm Sanskrit Mahavidyalaya",
  "Shri Barahi Sanskrit Mahavidyalaya, Raniganj",
  "Shri Devaraj Sanskrit Mahavidyalaya, Nagawan Lanka",
  "Gurukul Sanskrit Mahavidyalaya, Suryakund",
  "Radhika Sanskrit Mahavidyalaya, Lakhamipur",
  "Nandlal Bajoriya Sanskrit Mahavidyalaya, Assi",
  "Shri Vaishnav Dharm Subodhani Sanskrit Pathshala, Badasthan, Ayodhya",
  "Shri Giriraj Kumari Adarsh Sanskrit Mahavidyalaya, Gabhana",
  "Shri Mayanand Giri Sanskrit Mahavidyalaya, Gaudoliya",
  "Shri Baijanath Sanskrit Mahavidyalaya, Bartan Bazar",
  "Sarvadanand Sanskrit Mahavidyalaya, Sadhashram",
  "Bhagwan Gautam Buddh Sanskrit Mahavidyalaya, Tajpur",
  "Jaldhari Devi Sanskrit Mahavidyalaya, Noonkhar",
  "Adarsh Saraswati Sanskrit Vidyalaya, Rithhiya, Pipraich",
  "Shri Gaurishankar Sanskrit Mahavidyalaya, Sujanganj",
  "Shri Ramanuj Sanskrit Mahavidyalaya, Mishra Pokhara",
  "Shri Dugdheshwar Sanskrit Mahavidyalaya,",
  "Shri Harihar Sanskrit Pathshala Bazar Gosai",
  "Smt. Shivraji Maurya Sanskrit Mahavidyalaya, Bheeti",
  "Shri Vidvat Parishad Sanskrit Mahavidyalaya, Mahadeva, Lavdhera",
  "Shri Shiv Shankar Sanskrit Mahavidyalaya, Harharpur Mahanth",
  "Shri B.N.Mehata Sanskrit Mahavidyalaya,",
  "Shri Mannoolal Sanskrit Mahavidyalaya, Atarra",
  "Shri Sanskrit College, Araiya",
  "SANSKRITI VIDYA SANSTHAN",
  "BABA INSTITUTE OF PHARMACY, BARLA, BASERA MARG, MUZAFFARNAGAR",
  "SRI RAM ADARSH MAHAVIDYALAYA PANWAWARI SIKENDRA AGRA",
  "SIYA RAM SHYAMA DEVI MAHAVIDYALAYA RAWAL MATHURA",
  "CHITRAKOOT INSTITUTE OF COMPUTER SCIENCE & TECHNOLOTY KARWI",
  "CENTRE OF COMPUTERS & COMMUNICATION ALLAHABAD",
  "BHARAT MATA INSTITUTE OF INFORMATION TECHNOLOGY VARANASI",
  "K.P.S. DEGREE COLLEGE, KAKARUA, LALITPUR",
  "JAI CHAMAN MAHAVIDYALAYA VILL SARAI ASNARA NEHTAUR ",
  "Akhil Bharatiya Veer Bahadur Singh Jansewa Sansthan Mahavidyalaya, Pipiganj, Gorakhpur",
  "TIRUPATI  INSTITUTE OF SCIENCE AND TECHNOLOGY MOHIUDDINPUR, MEERUT",
  "UMA DEVI MAHILA MAHAVIDYALAYA, KARANPUR KHUJI SHITLAGANJ",
  "Shri Dadu Balram Sanskrit Mahavidyalaya, Gwalikhera",
  "Sarvabhaum Snatakottar Sanskrit Mahavidyalaya, Govardhan",
  "Sankhata Prasad Vaidya Sanskrit Mahavidyalaya, Pakhvaya, Khamariya",
  "Maharshi Dayanand Gurukul Mahavidyalaya, Patel Marg",
  "J.S. COLLEGE ",
  "JADAUN LAW COLLEGE",
  "SHRI DAFEDAR SINGH PAHALWAN MAHAVIDYALAYA ",
  "Handia P.G.College,Handia,Allahabad",
  "BAL VIKAS MAHAVIDYALAYA, ATSU, AURAIYA",
  "Sanskrit Mahavidyalaya, Karaundiya",
  "Adarsh Seva Bharati Mahavidyalaya,Ramganv Palahi Patti",
  "Shri Nivas Bodhayan Ramanuj Sanskrit Mahavidyalaya, Uttar Totadrimath, Ayodhya",
  "Shri Gurukul Sanskrit Mahavidyalaya, Bahadurgarh Pooth",
  "Shri Ram Adarsh Sanskrit Ayurveda Vidya Mandir, Maheva",
  "Navals Degree College, Kusumahi, Gorakhpur",
  "Dr. Ambedkar Kumar Pahalavan Mahavidyalaya, Pandeypur Radhe, Ghazipur",
  "Babu Jangi Singh Degree College, Gorakhpur",
  "S. D. Memorial Snatak Mahavidyalaya, Nautan, Deoria",
  "S. S. Walayat Husain Mahavidyalay Sitapatti, Banjaria, Deoria",
  "Bapu Degree College, Peepeeganj, Gorakhpur",
  "Saroj Vidyashankar Saraswati Mandir Mahavidyalaya, Kodae Ka Pura Balvargunj Sujangunj,Jaunpur",
  "Sant Vinoba P. G. College, Deoria",
  "Chaudhary Charan Singh Degree College, Baraipar, Bankata, Deoria",
  "Shekh Shahid Mahila Degree College, Madanpur, Deoria",
  "Bacha Chand Smarak Dwaba Vikash Mahavidyalaya, Onapar, Belghat, Gorakhpur",
  "Ramashankar Krishak Mahavidyalaya, Mail, Deoria",
  "Shaheed Chandrashekhar Singh Sewa Sansthan Mahavidyalaya, Bardiha, Prashuram Lar, Deoria",
  "S. R. Degree College, Gajpur, Banspar, Gorakhpur",
  "Shree Muralidhar Bhagwat Lal Mahavidyalay, Mathauli Bazar, Kushinagar",
  "Amit Mahavidyalaya, Amit Nagar, Sapha Road, Kasia, Kushinagar",
  "A P N P.G. College, Basti",
  "Lal Bahadur Shastri Smarak Degree College, Aanad Nagar, Maharajganj",
  "GOVT. DEGREE COLLEGE, MATI AKBARPUR,",
  "D.S.N. P.G. COLLEGE,",
  "RADHA VALLABH COLLEGE OF PHARMACY, VILLAGE IMAMPUR, POST KHUTHAN, JAUNPUR",
  "RAM SINGH JAVITRI DEVI MAHAVIDHALAYA",
  "SHRI CHHATRAPATI SHAHUJI MAHARAJ MAHAVIDYALAYA, JHILAHI, GONDA",
  "RAJKIYA MAHAVIDYALAYA, GRAM HARDOI, ATRAULI, ALIGARH",
  "GREATER NOIDA INSTITUTE OF MANAGEMENT",
  "GREATER NOIDA COLLEGE OF LAW",
  "Ishan Ayurved Medical College and Research Centre",
  "SHRI KRISHNA COLLEGE OF LAW, JOHNMANI DAULA BAGHPAT",
  "P. D. Law College, Khalilabad, Sant Kabir Nagar",
  "S. J. INSTITUTE OF PHARMACY, KANPUR NAGAR",
  "HAZI MAZARUDDIN MAHAVIDYALAYA, DUNDWA, GURSAHAIGANJ,",
  "DEVMAAYA DWARIKA PRASAD BRAHMCHARI SANSKRIT MAHAVIDYALAYA",
  "MAHARANA PRATAP COLLEGE OF AYURVEDIC AND MEDICAL SCIENCES",
  "LAVKUSH VIDHI MAHAVIDYALAYA, JANKI KUND, PARIYAR,",
  "PT. R.K. SHUKLA COLLEGE OF LAW, AMILIHA, CHAUBEPUR,",
  "Manyavar Kanshiram Government Degree College, Loni, Siddiqnagar, Ghaziabad",
  "Pt. Ambika Pratap Narayan Mahila Mahavidyalya, Mahadeva, Dumari, Sant Kabir Nagar",
  "INDRAPATI INSTITUTE OF TEACHERS EDUCATION MAHILA MAHAVIDYALAYA, VILLAGE MEERGOSAIPUR, POST ZAFARABAD, JAUNPUR",
  "CH. MOHAR SINGH MAHAVIDYALAYA, MANSUPURWA, BARIYAMAU,",
  "Pt. Mahadev Shukla Krishak P.G. College, Gaur, Basti",
  "DMS SHIKSHAN PRASHIKSHAN LAW COLLEGE BASTI",
  "LIFE LINE EDUCATIONAL INSTITUTE",
  "KRISHNA SHIKSHA NIKETAN MAHAVIDYALAYA, NILKANTHPUR, NARHI, BALLIA",
  "Vishva Shanti Niketan Mahavidyalaya, Rudrapur Bhaluhi, Maharajganj",
  "B.R.D.B.D. Mahila Degree College, Ashram Barhaj, Deoria",
  "Dr. B. R. Ambedkar Krishak Mahavidyalaya, Jalalabad Dullahpur Ghazipur",
  "J. B. Mahajan Degree College,  Chaurichaura, Gorakhpur",
  "Ramsakhi Ramnivas Girl Degree College, Bharauli, Gorakhpur",
  "Hiraman Mahatam Degree College, Mahuadih, Deoria",
  "Srimati Kesha Devi Degree College, Pakari Virbhadra, Deoria",
  "A.P. Gupta & Srimati Geeta Devi Mahila Mahavidyalaya, Sangrampur, Unwal, Gorakhpur",
  "AXIS INSTITUTE OF HIGHER EDUCATION, HATHIPUR, MAHARAJPUR,",
  "RAM SAHAY RAJKEEYA MAHAVIDYALAYA, BAIRI SHIVRAJPUR,",
  "GAUTAM BUDDH BALIKA MAHAVIDYALAYA,",
  "KRIPALU MAHILA MAHAVIDYALAYA, KUNDA, HARNAMGANJ, PRATAPGARH",
  "K.R. LAXMI BALIKA MAHAVIDYALAYA, KAKARDAHI, BAGHPUR,",
  "MAHALAKSHMI COLLEGE FOR GIRLS. DELHI-MEERUT ROAD, DUHAI, GHAZIABAD",
  "RAJKIYA MAHAVIDYALAYA, HASTINAPUR, MEERUT",
  "KMC COLLEGE OF AGRICULTURE",
  "SRI KRISHNA JANKA DEVI MAHAVIDYALAYA, DILWAL,",
  "MAHAPRAN NIRALA MAHAVIDYALAYA, OSIYA BEEGHAPUR, UNNAO",
  "SRI BABU SINGH DEGREE COLLEGE, NAWABGANJ,",
  "GANGA SINGH MAHAVIDYALAYA, SULTANPUR, HUSEPUR, SAURIKH,",
  "RAMWATI DEVI NARAYAN MAHAVIDYALAYA, ASALATGANJ,",
  "CHAUDHARY CHARAN SINGH DEGREE COLLEGE, HEWARA,",
  "GOVERNMENT DEGREE COLLEGE, GANESHPURA, BABINA, JHANSI",
  "S.N. SEN B.V.P.G. COLLEGE,",
  "DAYANAND ACADEMY OF MANAGEMENT STUDIES, GOVIND NAGAR,",
  "SRI NARAIN GIRLS P.G. COLLEGE,",
  "Dr. Ram Manohar Lohia Mahavidyalaya, Mahabir Chhapara, Gorakhpur",
  "Devchandar Dalsingaar Bhartiya Vidyapeeth Mahavidyalaya, Aary Nagar, Muhammadpur Ghazipur",
  "Haridwar Bhatt Smarak mahavidyalaya, Rajpur, Gagha, Gorakhpur",
  "Indra Gandhi Girls Degree College, Rampur Taramandal, Gorakhpur",
  "National P. G. College, Barhalganj, Gorakhpur",
  "Prabhadevi Bhagwati Prasad Mahavidyalaya, Annantpur, Sahajanwa, Gorakhpur",
  "Premi Devi Samaj Kalyan Mahila P.G. College, Padarauna, Kushinagar",
  "Shree Mahaveer Mahavidyalay, Kaptanganj, Kushinagar",
  "KAUSHALYA BHARAT SINGH GANDHI RAJKIYA MAHILA MAHAVIDYALAYA, DHIDHUI PATTI, PRATAPGARH",
  "R.K. COLLEGE, GARH ROAD, KITHORE, MEERUT",
  "PROF. H.N. MISHRA COLLEGE OF EDUCATION,",
  "ACCURATE INSTITUTE OF MANAGEMENT AND TECHNOLOGY, GREATER NOIDA",
  "RAM AUTAR MAHAVIDYALAYA, BUDHAULI,",
  "Shukdeo Prasad Tripathi Mahavidyalaya, Bhathahi Khurd, Kushinagar",
  "Udit Narayan Snatakottar Mahavidyalay, Padrauna, Kushinagar",
  "Laljee Rai Degree College, Khori Bari, Rampur, Deoria",
  "Raksha Rao Rajnath Rao Degree College, Narayanpur, Deoria",
  "B. R. D. P. G. College, Deoria",
  "Abhay Mahavidyalaya Tarna, Varanasi",
  "Rama Institute of Higher Education, Kiratpur",
  "Rajkiya Mahavidyalaya, Faridpur (Bareilly)",
  "Dr. Ram Manohar Lohiya Govt. Degree College, Aonla",
  "PT. BACHHI LAL DWIVEDI MAHAVIDYALAYA, BHAGAUTIPUR, AURRAIYA",
  "R.R. DEGREE COLLEGE, SARAI PRATHAM, BIDHUNA,",
  "Shri Ram Sanskrit Snatakottar Mahavidyalaya, Teliyashukla, Teliyakala",
  "Shrinath Sanskrit Mahavidyalaya, Rasara",
  "Shri Keshari Prasad Sanskrit Mahavidyalaya, Chak Ujiyari, Khejuri",
  "Shri Kedar Nath Ram Murti Mishra Sanskrit Mahavidyalay, Sikari Kanupur, Block-Mangraura, Distt- Pratapgarh ",
  "Shri Durga Sanskrit Mahavidyalaya, Amaree, Amarhat",
  "Afzalgarh Mahavidyalaya, Afzalgarh",
  "Shri Dayalu Sanskrit Mahavidyalaya, Bansfathak",
  "Shri Chandi Mandir Ramswaroop Gupta Adarsh Sanskrit Mahavidyalaya, Rajabazar, Badlapur",
  "Shri Balaji Sanskrit Mahavidyalaya,",
  "Sawitri Dayaram Pandey Sanskrit Mahavidyalaya Bal Shiksha Niketan",
  "Sadhu Shri Devnarayan Sanskrit Mahavidyalaya, Kusa",
  "Dharmagyanopdesh Sanskrit Mahavidyalaya, Mahamana Malviya Nagar, Prayag",
  "Deepnarayan Sanskrit Mahavidyalaya, Handiyadeeh",
  "Bhuval Smarak Sanskrit Mahavidyalaya, Azamgarh",
  "Baleshwar Prasad Sanskrit Mahavidyalaya, Gauri Nanhul, Sikandarpur",
  "GOVERNMENT DEGREE COLLEGE BIJAULI JHANSI ",
  "Baldev Sanskrit Mahavidyalaya",
  "Sw Shanti Devi Shikshan Evam Prashikshan Sansthan Karanji Harihar Jakhaniya Ghazipur",
  "RAJKIYA DEGREE COLLEGE, KALPI, JALAUN",
  "R.S.M. LAW COLLEGE",
  "C P LAW COLLEGE",
  "INSTITUTE OF PROFESSIONAL STUDIES IKLA ROAD DASANA, GHAZIABAD",
  "Adarsh Shri Sang Sanskrit Brahmvidya Mahavidyalaya, Baradev",
  "RAJKIYA MAHAVIDYALAYA TUNDLA, FIROZABAD ",
  "JHALLU SINGH MAHAVIDYALAYA, JAUHARPUR, CHHAPAR, BANDA",
  "BABA VISHWANATH  AYURVEDIC MEDICAL COLLEGE AND HOSPITAL MARTIGANS, AZAMGARH",
  "VISHVASARIA INSTITUTE OF ENGENERING & TECH FROM GHAZIABAD-BULANDSHAR G.T. ROAD DADRI GAUTUM BUDH NAGAR Ph. 9810173602,  9811215131, 4662167, 73,74 ,75,",
  "Adarsh Shri Bramharshi Sanskrit Mahavidyalaya, Revatipur",
  "RAJKIYA MAHILA MAHAVIDYALAYA BHARAPURA, ALIGANJ, ETAH",
  "Ch. NARENDRA SINGH COLLEGE OF EDUCATION, JATOLI, MEERUT",
  "AACHARYA RAM CHANDRA MAHAVIDYALAYA, REUSA, SITAPUR",
  "MKR (PG) INSTITUTE OF TECHNOLOGY HASANPUR MUSSOORIE, ON DELHI BAGHPAT ROAD, KHEKRA, BAGHPAT MOB. No. 09528102313, 09634297268, 09319854166 Ph. 0121-2232309, 2232965",
  "Adarsh Shiv Sharda Sanskrit Mahavidyalaya, Imali Ganva",
  "RAINBOW NURSING COLLEGE AZAMGARH",
  "Adarsh Sanskrit Mahavidyalaya, Maunathbhanjan",
  "P.I.E.T COLLEGE OF EDUCATION    GHAAT ROAD, DELHI-ROORKEE BY PASS NH-58, PARTAPUR, MEERUT",
  "LORD SHIVA INSTITUTE FOR HIGHER STUDIES, SHIKARPUR, BULANDSHAR",
  "APS COLLEGE OF LAW",
  "RADHA KRISHNA LAW COLLEGE",
  "DR B S KUSHWAH INSTITUTE OF MEDICAL SCIENCES, LAKHANPUR, KANPUR",
  "DCS MEMORIAL MAHAVIDYALAYA",
  "Adarsh Sanskrit Mahavidyalaya, Bhauapar",
  "Adarsha Shri Hanumat Sanskrit Mahavidyalaya, Araka, Mahaveerpur, Vathuri, Rasulpur",
  "AJAY SANGAAL INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "Sunrise Mahavidyalaya",
  "JAIN BALIKA  VIDYAPEETH MAIN ROAD, KHEKRA, BAGHPAT Ph. 9412631054",
  "College of Teacher Education, Sambhal",
  "SHRI BABA VISHWANATH JI LAW COLLEGE, GAMBHIRPUR, AZAMGARH",
  "Shri Ramdev Sanskrit Mahavidyalaya, Jakariya",
  "RAMANAND BEERBAL PATEL MAHAVIDYALAY SARAI SULTAN BAHRIYA ",
  "KRISHNA INSTITUTE",
  "Indu Prakash Pharmacy College Haldharpur Mau",
  "PREM JYOTI DEEN DAYAL SHRINET MAHAVIDYALAYA HARPUR PIPIGANJ GORAKHPUR UP",
  "UMALOK COLLEGE OF PHARMACY",
  "GOVERNMENT DEGREE COLLEGE PIPRAHARI TINDWARI BANDA",
  "AALA HAZRAT KANYA DEGREE COLLEGE, BAHERI",
  "Vishwanath Brahmcharyaashram, Raamghat",
  "RAJKIYA MAHILA MAHAVIDYALAYA, BANGAR,",
  "PYARELAL SMARAK MAHAVIDYALAYA, SIMARIYA,",
  "INDRA NARAIN KRISHNA KUMAR MAHAVIDYALYA BHATNI LALGANJ PRATAPGARH ",
  "Gramodaya Mahavidyalaya & Research Institute, Bilari",
  "Haneef Memorial Muslim Degree College, Umri Kalan",
  "Govt. Mahila (PG) Mahavidyalaya",
  "Moradabad College of Law",
  "Rakshpal Bahadur Management Institute",
  "Narayan Mahavidhyalaya G A Patti, Pratapgarh",
  "BABASAHEB BHIMRAO AMBEDKAR LAW COLLEGE",
  "D.A.V. DEGREE COLLEGE, LUCKNOW",
  "MAA USHA SINGH MAHAVIDYALAYA KHARHAR SIPAH MAHERI RANIGANJ PRATAPGARH",
  "Janta Mahavidyalaya, Ratanupur , Jaunpur",
  "Lala Radhey Shyam Girls Degree College, Nagina",
  "Rajendra Prasad Degree College, Meerganj",
  "Ismail National Mahila (P.G.) College Budhana Gate Meerut",
  "KESHAV MARAWADA DEGREE COLLEGE, PILAKHUWA, GHAZIABAD",
  "Rajkiya Mahavidyalay B B Nagar, Bulandshahr",
  "Dr. K.N. MODI INST. OF PHARMACEUTICAL EDUCATION AND RESEARCH MODINAGAR (GHAZIABAD) Ph. No :-  45522,  45566",
  "VAIBHAV INSTITUTE OF MANAGEMENT AND TECHNOLOGY, JALKHERA, G.T. ROAD, BULANDSHAHR",
  "Shri Shiv Prasad Sanskrit Mahavidyalaya, Daramalganj",
  "KAMLA NEHRU INSTITUTE OF TECHNOLOGY, SULTANPUR",
  "GURU SAHAY MAHAVIDYALAYA BHAIPUR FAIZABAD",
  "Rajkeeya Mahavidyalay, Rudhauli, Basti",
  "SUSHILA DEVI KANHAIYA BUKSH SINGH MAHAVIDYALAYA, RANKI, SANGIPUR",
  "VAISHNO DEVI PRASHIKSHAN MAHAVIDYALAYA, GODAHI, KUNDA, PRATAPGARH",
  "SABIR ALI BALIKA DEGREE COLLEGE, JAKHANIYA, GHAZIPUR",
  "Amar Nath Mishra P.G. College, Dubey Chapra, Ballia",
  "Asha Singh Mahavidyalaya Shahpur, Ballia",
  "BABA KASHINATH MAHAVIDYALAYA BALLIA",
  "Rishi Bal Mahavidyalaya, Patti Maudha, Kanth",
  "Upadhi Mahavidyalaya",
  "Gandhi Faiz-e-aam  College",
  "Chaudhary Charan Singh Degree College, Padmapur, Pandavnagar, Basti",
  "Late. Bhagwan Singh Mahavidyalaya, (Garbar) Patar Kalan, Dubar Kalan, Mirzapur",
  "Kalli Devi Kanya Mahavidyalaya, Tikari, Jigna, Mirzapur",
  "K S COLLEGE OF MANAGEMENT",
  "R P T C COLLEGE OF LAW",
  "SRI KRISHNA RTS YADAV VIDHI MAHAVIDYALAYA, NARAULI, RUDAULI, AYODHYA",
  "Pt.Deendayal Upadhyay Rajkiya Mahavidyalaya, Palhipatti, Varanasi",
  "LAXMI DEVI ARYA KANYA DEGREE COLLEGE MAVANA",
  "Maa Swaroopa Devi Mahila Mahavidyalaya, Ghazipur",
  "KAMKUS COLLEGE OF LAW, SANJAY NAGAR, GHAZIABAD ,",
  "VIDYA INSTITUTE OF CREATIVE TEACHING BAGHPAT ROAD, MEERUT, Ph. No. 91-121-2439192",
  "ERAM COLLEGE OF LAW",
  "LALA MANGAT RAM MAHAVIDYALAYA, GHAZIABAD",
  "ATAL BIHARI VAJPAYEE GOVERNMENT COLLEGE BAH, AGRA",
  "SHAHEED BHAGAT SINGH COLLEGE OF EDUCATION VILL-DAULATPUR, POST-SALAWA, MEERUT Ph. No. 9837322774, 9045856235",
  "INSTITUTE OF MANAGEMENT STUDIES A-8B, SECTOR-62, INSTITUTIONAL ARYA ,NOIDA Ph. No :- 241050-51-43",
  "Bhagyawati Mahila Mahavidalaya",
  "RAM HARSH LAW COLLEGE, BARIYAPUR, SAIDABAD, HANDIA, PRAYAGRAJ, UP",
  "Shah Ji Degree college ",
  "BABA TIKAM SINGH DEGREE COLLEGE",
  "WALTECH COLLEGE OF EDUCATION, PLOT NO.154, 156A,156B, VILLAGE-ULDEPUR, MEERUT",
  "Sham-E- Ghausia Minority (S.G.M.) Unani Medical College And Hospital, Saheri, Ghazipur",
  "Savitri Mahila Mahavidyalay, Barahpur, Nandganj, Ghazipur",
  "K D Mahavidyalaya, Chandpur, Khanpur, Ghazipur",
  "Acharya Triveni Das Balika Mahavidyalaya, Nasirabad, Umeshnagar, Ghazipur",
  "Virendra Mahavidyalaya, Sarojnagar, Devchandpur, Ghazipur",
  "R B S Mahavidyalaya, Gaddopur, Jaunpur",
  "VIJAY COLLEGE OF EDUCATION Z-BLOCK, MAHENDRA ENCLAVE, SHASTRI NAGAR, GHAZIABAD,",
  "Swami Dayanand Degree College, Meerganj",
  "Ganga Singh Mahavidyalaya, Patkhauli Dakshin, Maniar, Ballia",
  "Sri Ramkaran Mahavidyalaya, Bheempura No. 1,Ballia",
  "Sri Sahdew Paudhria Ambedkar Mahila Mahavidyalaya, Manda, Rasra, Ballia",
  "R N Balika Mahavidyalaya, Badhauna, Fatehganj, Jaunpur",
  "Mata Asarfi Devi Mahila Shikshan Sansthan, Budhanpur Shadiyabad, Ghazipur",
  "GOVERNMENT DEGREE COLLEGE, JAITPUR, KULPAHAR, MAHOBA",
  "NEW ERA COLLEGE OF SCIENCE & TECHNOLOGY , PANDAV NAGAR, GHAZIABAD,",
  "CH. SHIV CHARAN SINGH DEGREE COLLEGE VILL.- NOROJPUR, TAHASIL & DISTT.-BAGHPAT MOB. NO. 9997778604",
  "K.D. College, Simbhaoli (Hapur)",
  "Amity Law School",
  "DEVKI DEVI SMRITI VIDHI MAHAVIDYALAYA, BAHORIKPUR, HATHIGAHAN, SORAON, PRAYAGRAJ",
  "PREM RAGHU AYURVEDIC MEDICAL COLLEGE AND HOSPITAL ",
  "RAJKIYA MAHAVIDYALAYA, SIRATHU, KAUSHAMBI, U P",
  "HEMANT LAW COLLEGE, DAMDAM, RANIGANJ, PRATAPGARH, UP",
  "LORD BUDDHA LAW COLLEGE, RAJAPUR MAKSOODAN, SORAON, PRAYAGRAJ",
  "NIRMAL GANGA INSTITUTE OF EDUCATION JARGAWAN, BULANDHSAHR",
  "CH JEEVAN SINGH MEMORIAL LAW COLLEGE SAROL TAPPAL ALIGARH",
  "MAHADEV INSTITUTE OF TECHNOLOGY, VILLAGE- RAMNAGAR, POST. AMINAGAR  SARAI, DISTT. BAGHPAT, Ph. 0121-2962012 9412783177,9456262543, 9897476539",
  "Bayalasi Mahavidyalaya, Jalalpur, Jaunpur",
  "PANDIT TEJRAM COLLEGE OF EDUCATION SIDDIQUE NAGAR , GHAZIABAD,",
  "GYAN BHARTI INSTITUTE OF MANAGEMENT STUDIES, JEWARI, KHIRWA ROAD, KANKER KHEDA, MEERUT",
  "RAMA DEVI KANYA MAHAVIDYALAYA E-3, SECTOR-61, NOIDA, Ph. 2586310",
  "DR MAHENDRA KUMAR CHHOTELAL BIND COLLEGE OF NURSING AND PARAMEDICAL SCIENCES UPARDAHA HANDIA PRAYAGRAJ",
  "M.I.T BUSINESS SCHOOL POHALI, SARADHANA ROAD, MEERUT",
  "CHET RAM SHARMA COLLEGE OF EDUCATION SADARPUR, SECTOR - 44, NOIDA Ph. No :-  91-4572032, 4573355, 4500460",
  "GONARD COLLEGE OF NURSING AND PARAMEDICAL SCIENCE",
  "ADARSH JANATA MAHAVIDYALAYA SHASTRI NAGAR SORAON ALLAHABAD",
  "KANOHAR LAL SNATAKOTTAR MAHILA MAHAVIDYALAYA, MEERUT",
  "R.I.E.T VIDYAPEETH, POHLI, SARDHANA ROAD, MEERUT",
  "GANDHI INSTITUTION OF PROFESSIONAL & TECHNICAL STUDIES FOR GIRLS NAGLA SHAR KHAN URF JAINPUR, MEERUT",
  "Classic College of Law, Maheshpur Thakuran",
  "INSTITUTE OF FINE ARTS,  MODINAGAR (GHAZIABAD)",
  "R P S Sansthan, Udaychandpur, Rampati Nagar, Kerakat, Jaunpur",
  "Hakim Mahtabuddin Hashmi Law College, Amroha",
  "Sri Dhannarayan Ramnarayan Dani Mahila Mahavidyalaya, Seohara",
  "Muslima Girls Degree College",
  "Government Degree College",
  "Ram Lubhai Sahani Govt. Mahila Mahavidyalaya",
  "Janta Degree College, Noorpur",
  "GOVT. ENGINEERING COLLEGE,AZAMGARH",
  "LLOYD INSTITUTE OF MANAGEMENT TECHNOLOGY",
  "SURAJ BHAN COLLEGE BISALPUR",
  "THAKURDEEN PATHAK MAHILA MAHAVIDYALAYA, SAIDEHI, AMBEDKAR NAGAR",
  "SRI GANGA MEMORIAL GIRLS DEGREE COLLEGE, PAISAR, BARABANKI",
  "EXCELLENT COLLEGE INGOHATA HAMIRPUR",
  "Bharat Singh Mahila Mahavidyalaya Purev Jalalpur Jaunpur",
  "SETH VISHAMBHAR NATH INSTITUTE OF PHARMACEUTICAL SCIENCES  ",
  "BABA SUDAMA PANDEY KALAWATI DEVI MAHILA SNATKOTTAR MAHAVIDYALAY PIPARA BUJURG",
  "Dr Sonelal Patel Mahavidyalaya Birdha  Lalitpur",
  "Ramjit Sanshthan Tadawa Khanpur Ghazipur",
  "HAKEEM RAIS UNANI MEDICAL COLLEGE AND HOSPITAL",
  "INSTITUTE OF INFORMATICS & MGMT. SCIENCES ANUYOGI PURAM,  NEAR-MEDICAL COLLEGE, GARH ROAD, MEERUT-250004 PH. NO.0121-2760396, 2767823, 2765023. 2603082 09456449694",
  "KANPUR VIDYA MANDIR MAHILA MAHAVIDYALAYA, SWAROOP NAGAR,",
  "M.B. College,  Dadri (G.B. Nagar) Ph.No.0120-2662651",
  "COLLEGE OF APPLIED EDU. & HEALTH SCIENCE GANGOTRI, ROORKEE ROAD, MEERUT Ph. No :- 663200, 769239,  772463,  647931",
  "I.M.S. LAW COLLEGE A-8B, SECTOR-62, INSTITUTIONAL ARYA ,NOIDA Ph. No :- 241050-51-43",
  "YASHODA GIRLS DEGREE COLLEGE",
  "Parwati PG College, Doharighat, Mau",
  "GURUDEV INNOVATIVE COLLEGE OF PHARMACY",
  "MADHU VACHASPATI INSTITUTE OF NURSING, KAUSHAMBI",
  "RADHEY SHYAM MAHAVIDYALAYA",
  "AFZALGARH LAW COLLEGE",
  "JANHIT INSTITUTE OF EDUCATION AND INFORMATION GREATER NOIDA",
  "SHIVA INSTITUTE OF MANAGEMENT STUDIES ,GHAZIABAD",
  "GANDHI EYE HOSPITAL ALIGARH, SCHOOL OF OPTOMETRY & ORTHOPTICS",
  "MAHARAJA AGRASAIN INSTITUTE OF TECHNOLOGY, GHAZIABAD",
  "MARATHWADA INSTITUTE OF TECHNOLOGY, BULANDSHAHAR",
  "Ramashanker Mahavidyalaya, Ballia",
  "DIGAMBARAYA EDUCATIONAL INSTITUTE",
  "HILLWOOD MEDICAL SCHOOL",
  "shri mati neetu devi bind mahavidyalay ",
  "AYODHYA PRASAD DWIVEDI LAW COLLEGE",
  "VIDYA DEVI MAHAVIDYALAYA PATNA BANDA SHAHJAHANPUR",
  "HUBRAJI DEVI GIRLS INSTITUTE PANDELA KADIPUR SULTANPUR",
  "JWALA PRASAD SINGH MAHAVIDYALAYA MAHADEVNAGAR, NANEMAU, SULTANPUR",
  "RAM DULAR SMARAK DEGREE COLLEGE",
  "Ramdas Mahavidyalaya, Sikriya, Bhimpura No-1, Ballia",
  "Ramdhari Chandrbhan Mahavidyalaya, Nagpura, Nafrepur, rasra, Ballia",
  "JANHIT COLLEGE OF LAW, GREATER NOIDA",
  "D.P.M. INSTITUTE OF EDUCATION MEERUT-BIJNORE ROAD, BEHSUMA, MEERUT",
  "LAVKUSH MAHAVIDYALAYA,JANKI KUND,PARIYAR, UNNAO",
  "SHRI KRISHAN MAHAVIDYALA , BALANI, BAGHPAT",
  "SHIVAM INSTITUTE OF HIGHER EDUCATION KHURJA, BULANDSHAR",
  "SHRI RAM YADAV BALIKA MAHAVIDYALAYA",
  "Shri Murli Manohar Town Post Graduate College, Ballia",
  "Bhagwant Singh Mahavidyalaya, Kuankhera, Khalsa",
  "Maharshi Sikshan Avam Prashikshan Sansthan Kharawadih Ghazipur",
  "SUMAN MAHAVIDYALAYA, KHALISHPUR, BADLAPUR, JAUNPUR",
  "RAMSURAT SINGH MAHAVIDYALAYA",
  "SAKSHI COLLEGE OF PHARMACY",
  "SATYA INSTITUTE OF MANAGEMENT STUDIES PANDAV NAGAR  GHAZIABAD",
  "NIGHTINGAL INSTITUTE OF NURSING, NOIDA",
  "H C COLLEGE OF EDUCATION AND TECHNOLOGY ",
  "KRISHNA INSTITUTE OF MANAGEMENT, BAGPAT ROAD, KITHOLI, MEERUT Ph. 0121-2672668, 2646575",
  "B.D.S. SCHOOL OF LAW SECTOR-8, JAGRITI VIHAR, OPP. MEDICAL COLLEGE, MEERUT.  Ph. No :- 2768840, 2768387",
  "SAVITA DEVI MAHAVIDYALA   DELHI-MEERUT ROAD, MOHIUDDINPUR MEERUT, Ph. 9412830843, 9412708099",
  "ELITE COLLEGE OF PROFESSIONAL & STUDIES NH-58, DADRI, MEERUT",
  "Krishna Gopal Mahavidyalaya, Nagina",
  "Ganna Kishan Degree College, Powayan",
  "Dhampur Degree College, Dhampur",
  "Teju Singh Memorial Degree College, Shahbajpur, Gajraula",
  "Vivek College of Education",
  "Shriji Institute of Legal And Vocational Education & Research",
  "Suraj Bhan Institute of Information Technology",
  "M.M. Degree College Khekhra (Baghpat) Mob.No.9411905011 0121-223040",
  "Doctor Krishna Gopal Dwivedi Ayurvedic Medical College and Hospital",
  "LT DR GOVIND DAS RICHHARIYA VIDHI SANSTHAN BARUASAGAR JHANSI",
  "VEENA VAADINI SANSKRIT COLLEGE",
  "Shri Ram Institute of Education,Dhampur",
  "RAM LAKHAN PATEL MAHAVIDYALAYA  PILKHAWAN SOHAWAL AYODHYA",
  "PURUSHOTTAM SINGH MAHAVIDYALAYA SINHNI ISAULI SULTANPUR",
  "mamta girls degree college, aseni road, kurauli , barabanki ",
  "Swami Jai Dev Yogiraj Mahavidyalaya",
  "KAMLA NEHRU INSTITUTE OF PHYSICAL AND SOCIAL SCIENCES MANAGEMENT INSTITUTE",
  "Bhagwan Devi Institute of Management Studies",
  "BALWANT VIDYA PEETH RURAL INSTT.BICHPURI AGRA",
  "RAJKIYA MAHAVIDYALAYA BARKI SEVAPURI RAJATALAB VARANASI ",
  "INSTITUTE OF BUSINESS MANAGEMENT & FASHION TECHNOLOGY  BULANDSHAHR",
  "RAM LAKHAN BHATT MAHAVIDYALAYA,PANKI",
  "MAA SHANTI DEVI MAHAVIDHYALAYA,BAHTA MUZAWAR",
  "RADHA KRISHNA MAHAVIDYALAYA,HASNAPUR,GAJMURADABAD",
  "SRI SUNDER LAL JI SMRITI MAHAVIDHYALAYA,PURWA",
  "GREAT GANGES INSTITUTE OF TECHNOLOGY,GADANKHERA",
  "JAI SHREE BALAJI MAHAVIDHYALAYA, JAITAPUR",
  "BIMT COLLEGE,MEERUT",
  "INDRAPRASTH INSTITUTE OF TECHNOLOGY, J P NAGAR",
  "INNOVATIVE COLLEGE OF PHARMACY, GREATER NOIDA",
  "GOVERNMENT MAHILA DEGREE COLLEGE, BUDAUN",
  "SAWITRI DEVI MAHILA MAHAVIDYALAYA POWAYAN SHAHJAHANPUR",
  "Dhyan Singh Memorial Degree College, Kanth",
  "R. B. S. LAW COLLEGE",
  "Ishrat Group Of Institutions",
  "GANGOTRI COLLEGE FOR WOMEN",
  "Muslim Degree College, Kakrala",
  "MAHARSHI SAUBHARI COLLEGE",
  "KUNWAR MUNINDRA SINGH MAHAVIDYALAY, DEENSHAH GAURA, RAEBARELI",
  "Baijnath Adarsh Mahavidyalaya, Mundera Rai, Sant Kabir Nagar",
  "VAISHNO INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "Bitoli Devi Mahavidyalaya, Khutar, Shahjahanpur",
  "D S EDUCATIONAL INSTITUTE",
  "SUBEDAR SINGH MAHAVIDYALAYA SAMAHUTA KHURD, LAMBHUA, SULTANPUR ( 879 )",
  "NATIONAL INSTITUTE OF ELECTRONICS & INFORMATION TECHNOLOGY,GORAKHPUR",
  "KRISHNAPAL SINGH SMARAK MAHAVIDYALAYA, KUNDANI,",
  "SHRI BAIJNATH SHIV KALA LAW COLLEGE MANGALPUR, BARABANKI",
  "AL HANEEF EDUCATIONAL CENTRE",
  "MODERN COLLEGE JHANSI",
  "SRI BRIJPAL SINGH BETI KUNWAR ISMARAK MAHAVIDYALAYA",
  "DHARMA DEVI BADRI PRASAD SMARAK MAHAVIDYALAYA, KURWAR, SULTANPUR",
  "LORD BUDDHA MAHAVIDYALAYA, SAKET NAGAR, RUPAIDIHA, BAHRAICH",
  "S D COLLEGE OF EDUCATION AND MEDICAL SCIENCE    ",
  "SUMITRA SHIKSHAN PRASHIKSHAN SANSTHAN MAHILA MAHAVIDYALAYA RASULHA HAIDARGANJ BAZAR AYODHYA    ",
  "MAHARANA PRATAP MAHAVIDYALAYA, RAMDASPUR, MAJHAULI, BIKAPUR, FAIZABAD",
  "SMT. MAHADEVI MAHAVIDYALAYA, DOMAPUR, SULTANPUR",
  "S D COLLEGE OF LAW    ",
  "BABA BIHARILAL EDUCATIONAL INSTITUTE, AMADARVESHPUR",
  "MAA PHOOL PATTI DEVI MAHAVIDYALAYA, BHEEKHPUR THANA JAITPUR, AMBEDKAR NAGAR",
  "RK EDUCATIONAL INSTITUTE, BADEPUR, JALALPUR, AMBEDKARNAGAR",
  "NARAYAN COLLEGE OF SCIENCE AND ARTS",
  "LAKSHMAN SINGH BELHARI MAHAVIDYALAYA, MADAYE NUMAYE, SULTANPUR",
  "LATE MOHANLAL VERMA EDUCATION INSTITUTE, BARABANKI",
  "BHAGIRATHI SINGH SMARAK MAHAVIDYALAYA, WAZEERGANJ, GONDA",
  "PT. RAM CHARITRA MISHRA MAHAVIDYALAYA, PADAILA, SULTANPUR",
  "RANA PRATAP P.G. COLLEGE, SULTANPUR",
  "RAM BARAN MAHAVIDYALAYA, VISHARPUR, RUPINPUR, JAISINGHPUR, SULTANPUR",
  "ASM LAW COLLEGE    ",
  "RAM DULARI SHARDA PRASAD INDRA BHADRA SINGH MAHAVIDYALAYA, SULTANPUR",
  "SMT. J. DEVI MAHILA MAHAVIDYALAYA, BABHNAN, GONDA",
  "ISLAMIA COLLEGE OF COMMERCE GIDA GORAKHPUR    ",
  "S N D COLLEGE DIKHTAULI SHIKOHABAD FIROZABAD",
  "BAIKUNTHNATH MAHAVIDYALAY, HUJURPUR ROAD, KARNAILGANJ, GONDA",
  "MANISHI MAHILA MAHAVIDYALAYA, GAURIGANJ, SULTANPUR",
  "MAHARAJA BALBHADRA SINGH RAIKWAR MAHAVIDYALAYA, BANKATA VIKAS KHAND, PAYAGPUR, BAHRAICH",
  "J.D.J.B. ANAND MAHAVIDYALAYA, DHANWARI, KHEMAPUR, AMBEDKAR NAGAR",
  "SRI RAGHUKUL MAHILA VIDYAPEETH, CIVIL LINES, GONDA",
  "SANT TULSIDAS P.G. COLLEGE, KADIPUR, SULTANPUR",
  "CH BADAN SINGH KANYA MAHAVIDHYALAYA SAKEET ETAH",
  "Smt Lalita Adarsh Sanskrit Mahavidyalaya, Belthara Road",
  "R S MEMORIAL MAHAVIDHYALAYA AHAMEDABAD ETAH",
  "BABU JAISHANKER GAYA PRASAD LAW COLLEGE, SUMERPUR,UNNAO",
  "BABU JAI SHANKER GAYAPRASAD MAHAVIDYALAYA, CHHACHHIRAI, SUMERPUR, UNNAO",
  "BABU RAM PAL SINGH MAHAVIDHAYALAYA,MAURANWAN, UNNAO",
  "SRI RAM CHANDRA SINGH MAHAVIDYALAYA, LOHATI SARAIYA, VIKAS KHAND, RUDAULI, FAIZABAD",
  "SHRI MAHAVIR SINGH KUSHWAH MAHAVIDYALAYA PIDHORA, ETAH",
  "VEDANTA LAW COLLEGE     ",
  "J D S MAHAVIDYALAYA DUDHAUNDA PATRAHI JAUNPUR    ",
  "GYAN STHALI COLLEGE JAGATPUR    ",
  "KUNJAN LAL JAISWAL VIDHI MAHAVIDYALAYA, NAWABGANJ, ATRAMPUR, PRAYAGRAJ    ",
  "Sunbeam Womens College Varuna",
  "VAISHNAVI MAHILA MAHAVIDYALAYA RAMPUR RAJA TAMKUHIRAJ KUSHINAGAR    ",
  "R P GIRLS DEGREE COLLEGE, MAJHAGAWAN KALA JALALPUR BAYALASI KERAKAT JAUNPUR    ",
  "LAL VIJYANAND MAHAVIDYALAYA, DHAMMAUR, SULTANPUR",
  "SHANTI DEVI JAIN B.ED COLLEGE  SHAHPUR, MUZAFFARNAGAR",
  "SHANTI DEVI JAIN  COLLEGE  SHAHPUR, MUZAFFARNAGAR,",
  "HALDAUR COLLEGE OF LAW ",
  "NAURANG SINGH MAHAVIDYALAYA, KARAMHARI, DEVAITHA, JAMANIYA, GHAZIPUR    ",
  "B D S LAW COLLEGE JAGDISHPUR KHAJURI BARABANKI    ",
  "Maa Asha Gyandeep Sansthan, Kuchhmuchh, Nayansand, Jaunpur",
  "RAJSUDHA INSTITUTE OF TECHNICAL EDUCATION",
  "SITA DEVI GIRLS MAHAVIDYALAYA, BARAUSA, SULTANPUR",
  "SIR R S LAW COLLEGE    ",
  "SYMBIOSIS Centre for Management Studies, NOIDA",
  "Yogendra Nath Saxenxa College of Pharmacy and Research Centre",
  "SHYAMSUNDER MEMORIAL LAW COLLEGE, CHANDAUSI",
  "SRI JI BABA SARASWATI VYAVSAIK PRASHIKSHAN MAHAVIDHLAY, MATHURA",
  "ASHA MAHAVIDYALAYA BABATPUR VARANASI",
  "ASHA MAHILA MAHAVIDYALAYA KUSMURA BARAGAON VARANASI",
  "BAHJOI MAHAVIDYALAYA BAHJOI",
  "PAHALWAN GURUDEEN VIDHI MAHAVIDHYALAYA, MACHHLISHAHAR, JAUNPUR",
  "KRISHAK COLLEGE OF PHARMACY    ",
  "SIMANT MAHAVIDYALAYA, RUPAIDIHA, BAHRAICH",
  "SURYA MAHILA MAHAVIDYALAYA NAGRA BADLI, THARUAPUR, BASTI, UP",
  "CH. RAM GOPAL SINGH VIDHI MAHAVIDYALAYA, MEHARBAN SINGH KA PURWA,",
  "SARDAR BHAGAT SINGH CONSTITUENT GOVERNMENT COLLEGE DHAKA POWAYAN SHAHJAHANPUR    ",
  "OM SHRI SAI KRIPA INSTITUTE OF NURSING AND PARAMEDICAL    ",
  "SHARDA MAHILA MAHAVIDYALAYA BANKI SIKRARA JAUNPUR    ",
  "ALLAHABAD INSTITUTE OF MEDICAL SCIENCES     ",
  "PRAKASH NURSING SCHOOL    ",
  "LAKSHYA TECHNICAL CAMPUS, SAHAJHANPUR",
  "RAMNAGAR P.G. COLLEGE, RAMNAGAR, BARABANKI",
  "GULAB SINGH VIDHI MAHAVIDYALAYA KICHKILA HANDIA PRAYAGRAJ    ",
  "Saraswati Kanya Mahavidyalaya, Rampur",
  "ALHAI MAHAVIDYALAYA, UMEDJOT, KHERHANSA, GONDA",
  "SHRI KRISHNA AYURVEDIC MEDICAL COLLEGE & HOSPITAL RAUNAKHURD CHOLAPUR VARANASI",
  "M.H. MAHILA MAHAVIDYALAYA, BARAI KUNDA, PRATAPGARH",
  "LALITA DEVI MAHAVIDYALAYA, RAHTEEKAR, PRATAPGARH",
  "ATAR SINGH LAW COLLEGE, VITTHALPUR URF BARAMADPUR, HANDIA, PRAYAGRAJ    ",
  "SRI RAM PRASAD VIDHI MAHAVIDYALAYA PACHKHARA JASRA PRAYAGRAJ    ",
  "SARDAR SINGH COLLEGE OF EDUCATION",
  "NANDAN MAHAVIDYALAYA, CHATURGARH, VISHIA, PRATAPGARH",
  "SARDAR PATEL MAHAVIDYALAYA SIKARO KORAON PRAYAGRAJ     ",
  "P.G. COLLEGE, PATTI, PRATAPGARH",
  "JAIRAJ KUNWAR BABA PARASPAL SINGH MAHAVIDYALAYA, LEELAPUR, PRATAPGARH",
  "CHINTAMANI SMARAK VIDHI MAHAVIDYALAYA, GODE SADAR, PRATAPGARH",
  "KEDARNATH CHAUDHARY SMARAK MAHAVIDYALAYA SONBARSA GONDA    ",
  "KAMLA PRASAD SINGH MAHAVIDYALAYA, MATHURA NAGAR, RAMGARH, SULTANPUR",
  "SHIV GANGA DEGREE COLLEGE RAMNAGAR MAUAIMA PRAYAGRAJ UP    ",
  "RAM KHELAWAN MAHAVIDYALAYA, SHESHPUR, DAMODAR, ASANDRA, BARABANKI",
  "MANPURIA COLLEGE OF ACADEMIC AND PROFESSIONAL STUDIES, MANPUR, BARABANKI",
  "S K MISHRA ANITA AYURVEDIC MEDICAL COLLEGE",
  "CENTRAL LAW COLLEGE    ",
  "SETH BADRI PRASAD SMARITI MAHAVIDHYALAYA DEPARTMENT OF PHARMACY    ",
  "RAJSHRI RANANJAY ASAMDEO MAHAVIDYALAYA, PIPARPUR, SULTANPUR",
  "RAJA AKHAND PRATAP MAHAVIDYALAYA, KHAPRADEEH, FAIZABAD",
  "JAI MAA SUDAMI DEVI BALIKA MAHAVIDYALAYA, KHANPUR, GHAZIPUR    ",
  "KALYANAM KAROTI    ",
  "KINETIC DIVYANG RESEARCHAND REHABILITATION CENTRE    ",
  "CHANDRA BALI URMILA MAHAVIDYALAYA, KUMARGANJ, FAIZABAD",
  "KASHINATH NURSING AND PARAMEDICAL COLLEGE    ",
  "DASHRATH SINGH SMARAK MAHAVIDYALAYA, NIPANIA, GAURA CHAUKI, GONDA",
  "PRAKASH KIRAN EDUCATIONAL INSTITUTION    ",
  "L.N COLLEGE LABHAUA ROAD,NAGLA POPI SHIKOHABAD",
  "CH.CHARAN SINGH CHAHARVATI COLLEGE AKOLA,AGRA",
  "KALPA MAHILA MAHAVIDYALAYA, MOHAMMADPUR, AMBEDKAR NAGAR",
  "PT. PRANNATH KAMLA PRASAD (MANOJ VINOD) MAHAVIDYALAYA, ADITYA NAGAR, AMAHIA, BARABANKI",
  "RAM KUMAR YADAV MAHAVIDYALAY  KHAIRAHA MOTIGARPUR SULTANPUR    ",
  "SARDAR PATEL MAHAVIDYALAYA, BARAGAON, JALALPUR, AMBEDKAR NAGAR",
  "MUKHIYA VIDHYA RAM MARGSHREE MAHADEVI MAHAVIDYALAYA,LAUHARI GARSHAN,(FIROZABAD)",
  "MAA DHANESWARI DEVI MAHAVIDYALAYA KUSHA RASHIDPUR BALLIA    ",
  "GNIT COLLEGE OF PHARMACY",
  "mulayam singh yadav degree college maithra aalpur bahjoi  sambhal",
  "R A S LAW COLLEGE    ",
  "BILAL AKHTAR LAW COLLEGE",
  "RISHIRAJ SINGH MAHAVIDYALAYA, MAHUARI, AMBEDKAR NAGAR",
  "SHRI BHOOP SINGH SMRITI MAHILA MAHAVIDYALAYA BHOOP NAGAR ,MAINPURI",
  "BABA BARUA DAS P.G. COLLEGE, PARUIYA ASHRAM, AMBEDKAR NAGAR",
  "MANTHAN COLLEGE OF LAW",
  "RAMNATH SINGH BASIC TEACHERS TRAINING COLLEGE THARI PHOOLPUR VARANASI",
  "SUSHRUT INSTITUTE OF PLASTIC SURGERY (P) LTD LUCKNOW",
  "RUDAULI MAHAVIDYALAYA, RUDAULI, BARABANKI",
  "Lloyd college of Arts ,Commerce & Science",
  "HARDAYAL DEGREE COLLEGE BAGRAUNI KULPAHAR MAHOBA    ",
  "DAYANAN DBACHHRAWAN P G COLLEGE, BACHRAWAN RAEBARELI",
  "SHREE RAM LAKHAN SINGH SHIKSHAN SANSTHAN NAKHARA KHANDEV JAUNPUR    ",
  "SRI RAM JANKI SHIKSHAN PRASHIKSHAN MAHILA MAHAVIDYALAYA, RAMNAGAR, AMAWASUFI, FAIZABAD",
  "SMT BHAGWATI DEVI MAHAVIDHYALAYA",
  "PT PURUSHOTTAM DWIVEDI MAHAVIDYALAY KOTWAMAFI BARGARH CHITRAKOOT UP    ",
  "CENTRAL INSTITUTE OF PHARMACY",
  "JAWAHARLAL NEHRU MEMORIAL P.G. COLLEGE, BARABANKI",
  "R D S NURSING AND PARAMEDICAL COLLEGE, KUSHAW, BHAUPUR, JAUNPUR",
  "MAA PHOOL KALI LAW COLLEGE, AURAHA UPARHAR, HEETAPATTI, JHUNSI, PRAYAGRAJ, UTTAR PRADESH    ",
  "INSTITUTE OF INTERNATIONAL EXCELLENCE, HAPUR",
  "HERITAGE INSTITUTE OF MEDICAL SCIENCES, VARANASI    ",
  "RBSD RAM BHAROSE SAVITADEEN MAHAVIDYALAYA UMRA KALA",
  "MAA TAPESHWARI DEVI SMARAK MAHAVIDYALAYA, AMBEDKAR NAGAR    ",
  "PARSHURAM VERMA SMARAK MAHILA MAHAVIDYALAYA, TARUN, FAIZABAD",
  "SANT DWARIKA PRASAD MAHAVIDYALAYA, KOTWA, MOHAMMADPUR, AKBARPUR, AMBEDKAR NAGAR",
  "D N MAHILA MAHAVIDYALAYA, MUJAR BUJURG, BHATMILA, MAU    ",
  "BABA JAIRAM DWIVEDI MAHAVIDYALAYA, NARHARPUR, SULTANPUR",
  "PRASAD INSTITUTE OF TECHNOLOGY, JAUNPUR",
  "I E T COLLEGE OF PHARMACY VILLAGE LAKHAUA POST FATEHGANJ TAHSIL SADAR JAUNPUR",
  "SURYA COLLEGE OF MANAGEMENT AND SCIENCE NEAR HCL IT CITY SULTANPUR ROAD LUCKNOW     ",
  "SW. NOORUDDIN KHAN ADVOCATE GIRLS DEGREE COLLEGE, AFLEPUR, MALHANI BAZAR, JAUNPUR",
  "R.S.M.P. MAHAVIDYALAYA, RAI ASKARANPUR, AZAD NAGAR, KUNDA, PRATAPGARH",
  "SANTUSHTI COLLEGE OF NURSING    ",
  "K.S.SAKET P.G. COLLEGE, FAIZABAD",
  "SRI SHANKAR JI MAHAVIDYALAYA, MATHIA, AMBEDKAR NAGAR",
  "PT KANHAIYA LAL MISHRA VIDHI MAHAVIDALAYA     ",
  "Dr Achal singh Yadav Institute of Nursing and Paramedical Science",
  "I.A.M.R. B.ED COLLEGE NINE, KM STONE, DELHI MEERUT ROAD, DUHAI ,GHAZIABAD",
  "IAMR LAW COLLEGE NINE,KM ,STONE DELHI MEERUT ROAD, DUHAI, GHAZIABAD",
  "KINSRAJ SMARAK SHIKSHAN SEVA SANSTHAN/MAHAVIDYALAYA, SUNDARNAGAR, TAINEE, MAHUL, AZAMGARH",
  "SHREE DRONACHARYA P G COLLEGE DANKAUR GAUTAM BUDDHA NAGAR",
  "Dewraj Mahavidyalaya, Mauraha, Chandadih, Ballia",
  "SHIV SHAKTI GIRLS DEGREE COLLEGE, BAHERVA, MAHMOODABAD, SITAPUR",
  "JAGDISH PRASAD YADAV SHIV KUMAR SINGH YADAV MAHAVIDHYALAYA, BEDNAPUR NAKHA, LAKHIMPUR KHIRI",
  "JANKI PRASAD VERMA MEMORIAL MAHAVIDYALAYA, KOTWA SARAK, BARABANKI",
  "R B S S COLLEGE SAIDPUR BALDEO MATHRUA",
  "DIVINE INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "SHIVALIK INSTITUTE OF EDUCATION Vill Redi Mustahkam, Near Chamari Kheda, Post Chhutmalpur, Saharanpur",
  "APEX COLLEGE OF NURSING AND APEX PARAMEDICAL INSTITUTE, BHIKARIPUR KHURD, VARANASI    ",
  "MEGHNATH SINGH SHISHODIA COLLEGE OF LAW DHAULANA HAPUR",
  "FS COLLEGE OF PHARMACY AND RESEARCH CENTRE    ",
  "SHYAMPATI CHANDRA SHEKHAR MISHRA SHAIKSHIK SANSTHAN",
  "PARMESHWER PRASAD MEWA LAL DERGEE COLLEGE, MALADHAR, CHHATTA KUNDA",
  "SUSHILA MAHAVIDYALAYA, PAHARPUR, KUNDA, PRATAPGARH",
  "R M S College",
  "MATA KAMAKHYA BHAWANI DEVPATI KRIPA SHANKAR SHIKSHAN AVAM PRASHIKSHAN SANSTHAN HARSHVARDHAN NAGAR GANESHPUR AYODHYA    ",
  "RAM ADHAR GRAMIN MAHAVIDYALAYA, BARAGAON, IBRAHIMPUR, KEDARNAGAR, AMBEDKAR NAGAR",
  "RAM NIVAS MAHAVIDYALAYA, CHITRAKOT, GANDHI, FARRUKHABAD",
  "BABU SUNDER SINGH MAHAVIDYALAYA, HUJOORPUR, BAHRAICH",
  "SRI KRISHNA MAHAVIDYALAYA, MANGARI, FAIZABAD",
  "MAA VAISNO SHIKSHAK PRASHIKSHAN SANSTHAN    ",
  "R S PARAMEDICAL AND NURSING COLLEGE DEVA DULLAHAPUR GHAZIPUR",
  "GSRM MEMORIAL COLLEGE OF NURSING    ",
  "SURUCHI INSTITUTE OF NURSING, LUCKNOW",
  "BIHARI LAL SMARAK KISAN MAHAVIDYALAYA, AAMA DARVESHPUR, AMBEDKAR NAGAR",
  "SAINIK COLLEGE OF NURSING     ",
  "STATE SHRI DURGA JI HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL, CHANDESHWAR, AZAMGARH",
  "OM PRAKASH MISHRA VIDHI MAHAVIDYALAY,MOLNAPUR,AHMADBAKSH PHULESH,AZAMGARH",
  "PT. DEVENDRA MISHRA VIDHI MAHAVIDYALAY RANIPUR RAJAMO, PAHILEPUR,BINDRABAZAR,AZAMGARH",
  "AGRA COLLEGE, AGRA",
  "MATA KUSAMA DEVI COLLEGE OF EDUCATION, RAJJABPUR MEHNAZPUR AZAMGARH",
  "MAHARANA PRATAP INSTITUTE OF TECHNOLOGY    ",
  "BOHARE NARAYAN SINGH ARYA DEGREE COLLEGE, MATHURA",
  "SANJAY SINGH DEGREE COLLEGE, BARGADWA HARRAIYA, PHARENDA, MAHARAJGANJ    ",
  "SUBHADRA NATH KANYA MAHAVIDHYALAYA, SEWARA, BHARAULI, BARHNI, SIDDHARTHNAGAR    ",
  "MAA DURGA SARVODAY MAHAVIDYALAYA, ARWAL, SULTANPUR",
  "CERT COLLEGE OF LAW",
  "R N COLLEGE OF PHARMACY MORADABAD    ",
  "R K COLLEGE OF PHARMACY MORADABAD UP    ",
  "HARLAL INSTITUTE OF MANAGEMENT AND TECHNOLOGY    ",
  "BHARAT INSTITUTE OF TECHNOLOGY MEERUT",
  "VIMALA SHANKAR MAHILA MAHAVIDYALAY MOKALPUR GOBARAHAN VARANASI    ",
  "MUZAFFARNAGAR NURSING INSTITUTE",
  "SHRI VIDYADHAR TIWARI MAHILA MAHAVIDYALAYA, SULTANPUR, DARIYAVGANJ, JAUNPUR",
  "MAHATMA BUDDHA LOK KALYAN AVAM GRAMYA VIKAS SANSTHAN LAKHIMPUR KHERI",
  "GC HOMEOPATHIC MEDICAL COLLEGE AND RESEARCH CENTER    ",
  "Kamla Pandey Mahavidyalaya, Bilari-Bhiti, Gaura Gosain",
  "SMT. DHANPATA MAURYA SMARAK MAHAVIDYALAYA. RASOOLPUR, LILHA, FAIZABAD",
  "P.L. MEMORIAL MAHAVIDYALAYA, FAIZABAD ROAD, BARABANKI",
  "203-RAMESHWARAM INSTITUTE OF TECHNOLOGY AND MANAGEMENT ",
  "VIVEKANAND INSTITUTE OF TECHNOLOGY AND MANAGEMENT BARAI VARANASI    ",
  "MAHILA P.G. COLLEGE, BAHRAICH",
  "SANJEEVANI COLLEGE OF LAW, KIRTANPUR, BAHRAICH",
  "MSB COLLEGE OF LAW    ",
  "ACCURATE COLLEGE OF LAW    ",
  "S R C NURSING AND PARAMEDICAL INSTITUTE",
  "MAHIPAL INSTITUTE OF LAW EDUCATION ,VIL POST, DHAMRAWLI , DISTT  BULANDSHAHR",
  "Gaurishankar (G.S) Mahavidyalaya Gairikala Khunsapur Jaunpur",
  "SUN INSTITUTE OF MANAGEMENT AND TECHNOLOGY SHAHJAHANPUR",
  "DOON COLLEGE NURSING    ",
  "SMT LATA CHARITABLE HOSPITAL AND NURSING COLLEGE    ",
  "SAHARANPUR HOSPITAL AND NURSING COLLEGE    ",
  "JAINATH MEMORIAL LAW COLLEGE    ",
  "Khalsa Degree College Nagria Milak Rampur ",
  "BHARAT INSTITUTE OF TECHNOLOGY SCHOOL OF MANAGEMENT, MEERUT",
  "URMILA DEVI DEGREE COLLEGE, RASAR, BARAUT, HANDIA, PRAYAGRAJ",
  "RAM HARAKH SINGH MAHAVIDYALAYA, PAUDHAN, RAMPUR, SULTANPUR",
  "B.N.S. GIRLS DEGREE COLLEGE OF EDUCATION, JANAURA, FAIZABAD",
  "S.R. MAHAVIDHYALYA INDAVALI BALDEO MATHURA",
  "KISAN MAHAVIDYALAYA, MAHUA PAKAR, BABHANJOT, GAURA CHAUKI, GONDA",
  "SMT. SATYAWATI DEVI INSTITUTE OF EDUCATION AND TECHNOLOGY, CHANGA NARHARPUR, AMBEDKAR NAGAR",
  "SARASWATI INSTITUTE OF EDUCATION, KANODA, NH-58, KANODA, MEERUT",
  "KUNAL COLLEGE TEHRA AGRA",
  "WINSOFT COLLEGE OF EDUCATION PANWARI MAHOBA    ",
  "Shri Ramdeshik  Gyaanpeeth, Sanskrit Mahavidyalaya, Rampur, Karipur",
  "CHAUDHARY HANUMAN PRASAD KRISHAK MAHAVIDYALAYA, RUDRAPUR BHAGAHI, AMBEDKAR NAGAR",
  "KALKA PRASAD NARAYAN DAS MAHAVIDYALAYA, KITHWA, DYORI, FAIZABAD",
  "'SHANTI DEVI RAM BADAN MAHAVIDYALAYA, NASIRPUR, AMBEDKARNAGAR",
  "NAVYUG MAHILA MAHAVIDYALAYA, RATANPURBARI, SAHIJAN, SULTANPUR",
  "CH LALTA SINGH SMARK MAHAVIDYALAYA     ",
  "RAMABAI RAJKIYA MAHILA MAHAVIDYALAYA, AKBARPUR, AMBEDKAR NAGAR",
  "S A S COLLEGE OF NURSING ATHGAWAN HARAHUA VARANASI",
  "R A S COLLEGE OF NURSING KULHANAMAU KALICHABAD JAUNPUR",
  "B S MAHAVIDHYALAYA RAIPUR KHAS ALIGARH    ",
  "YASHODA DEVI RAMPATI MAHILA MAHAVIDYALAYA SARAULI AYODHYA    ",
  "HEMWATI NANDAN BAHUGUNA P.G. COLLEGE, LALGANJ, PRATAPGARH",
  "REGENCY INSTITUTE OF NURSING KANPUR",
  "BHOLA BHAGWATI DEGREE COLLAGE, DWARIKAPUR, MAU    ",
  "RAM GIRISH RAI TEACHERS TRANING COLLEGE DUBAULI GORAKHPUR",
  "Govind Ballabh Pant Degree College, Pratapganj , Jaunpur",
  "DEV INDRAWATI COLLEGE OF LAW KATEHARI AMBEDKAR NAGAR    ",
  "PT. JAG NARAIN SHUKL GRAMODAI MAHAVIDYALAYA, RANIPUR PAHARI, TARABGANJ, GONDA",
  "ADARSH KANYA MAHAVIDYALAYA, JIAPUR BARUA JALAKI, DIHWA, DAULATPUR, KEDAR NAGAR, TANDA, AMBEDKAR NAGAR",
  "UMA NATH SINGH AUTONOMOUS STATE MEDICAL COLLEGE SOCIETY JAUNPUR",
  "KAMTA PRASAD MATHURA PRASAD JANTA MAHAVIDYALAYA, BABHNAN, GONDA",
  "RAMNEWAJ MAHAVIDYALAYA, BAWAN, KUMARGANJ, FAIZABAD",
  "SMT VIDYAWATI COLLEGE OF NURSING    ",
  "AYODHYA VIDYAPEETH COLLEGE OF NURSING AND PARAMEDICAL SCIENCES    ",
  "PIST NURSING COLLEGE, BANVEER KACHH, PRATAPGARH CITY, PRATAPGARH    ",
  "KARMYOGI RAMSOORAT TRIPATHI MAHAVIDYALAYA, KRISHNA NAGAR, SISWA, AMBEDKAR NAGAR",
  "Ram Dulari Balika Sanskrit Mahavidyalaya, Mubarakpur Tanda",
  "DDM COLLEGE OF PHARMACY",
  "Dhanpati Devi Maurya Nursing School",
  "ARNAV PARAMEDICAL INSTITUTE SATRKH HARAK ROAD BARABANKI",
  "GRAMYANCHAL MAHAVIDYALAYA, HAIDERGARH, BARABANKI",
  "R K AYURVEDIC MEDICAL COLLEGE AND HOSPITAL, KASHIPUR SURAI SATHIAON AZAMGARH    ",
  "SHREE K N SINGH VIDHI MAHAVIDYALAYA, JIYANPUR, AZAMGARH    ",
  "FOOTWEAR DESIGN AND DEVELOPMENT INSTITUTE - RAE BARELI",
  "DR APJ ABDUL KALAM COLLEGE OF NURSING AND PARAMEDICAL SCIENCES, BASTI, UTTAR PRADESH      ",
  "DR. RAM PRASANNA MANIRAM MAHAVIDYALAYA, SARAIRASI, FAIZABAD",
  "Vidya Devi memorial college of education village meerpur",
  "ABUL KALAM AZAD MAHAVIDYALAYA, JAMUNIABAG, VISHUNGA, GONDA",
  "Maa Kaushilya School Of nursing ",
  "LALJHARI DEVI MAHILA MAHAVIDYALAYA BIRIYA BALLIA    ",
  "SANT PARAMHANS GURU PRASAD BALIKA MAHAVIDYALAYA, MOHLI, FAIZABAD",
  "INDIRA GANDHI SCHOOL OF NURSING SULTANPUR-",
  "BIHARI LAL DEGREE COLLEGE AND PROFESSIONAL STUDIES, GRAM KAIRICHA, BARABANKI",
  "APRUP SHIKSHAN SANSTHAN AHIRAULI AYAR BAZAR VARANASI",
  "Z I COLLEGE OF LAW    ",
  "SARDAR VALLABH BHAI PATEL MAHAVIDYALAY CHORMA SULTANPUR    ",
  "LAKHAN LAL SHARAN SINGH MAHAVIDYALAYA, RAGHUNATHPUR (VISHNOHARPUR), GONDA",
  "ELENA MAHAVIDYALAYA, BAHARPUR LAHAUTA, SEMRI, SULTANPUR",
  "SANT BHEEKHA DAS RAMJAS MAHAVIDYALAYA, MOHLI, FAIZABAD",
  "INSTITUTE OF INFORMATION MANAGEMENT AND TECHNOLOGY, ALIGARH",
  "VINITA DEVI MAHILA MAHAVIDYALAYA, VAISHAPUR",
  "RAJKIYA MAHAVIDYALAYA, PACHPEDWA, BALRAMPUR",
  "CHANDRA BHAN DEVI SEWAK MAHAVIDYALAYA, PRATAPPUR KAMAICHA, SULTANPUR",
  "NANDINI NAGAR MAHAVIDYALAYA, NAWABGANJ, GONDA",
  "IDEAL MAHAVIDYALAYA, SAMARSANDA, KURSI, BARABANKI",
  "SARVOTTAM INSTITUTE OF TECHNOLOGY AND MANAGEMENT,G. NOIDA",
  "SADHU RAM VISHWAKARMA PRAGATI MAHAVIDYALAYA NAROTTAMPUR BAHRAICH",
  "EKLAVYA MAHAVIDYALAYA, JHUMIA, BAHRAICH",
  "Parvati Sanskrit Mahavidyalaya, Dohari Ghat",
  "CHAUDHARY BEERI SINGH COLLEGE OF ENGINEERING AND MANAGEMENT, ETMADPUR, AGRA",
  "COLLEGE OF BUSINESS STUDIES, AGRA",
  "BUNDELKHAND COLLEGE, JHANSI",
  "COLLEGE OF ENGINEERING AND RURAL TECHNOLOGY, MEERUT",
  "COLLEGE OF PHARMACY, JAKHODA, AGRA",
  "DEEWAN V.S. INSTITUTE OF ENGINEERING AND TECHNOLOGY, MEERUT",
  "DELHI INSTITUTE OF ENGINEERING AND TECHNOLOGY, PARTAPUR BYPASS, MEERUT",
  "DOON COLLEGE OF EDUCATION, SAHARANPUR",
  "UTKARSH NURSING COLLEGE",
  "DR. RAM MANOHAR LOHIA MAHAVIDYALAYA, SHANTI NAGAR, LALUMAU, KHAJOORGAON, RAEBARELI",
  "DR. BHIMRAO AMBEDKAR ENGINEERING COLLEGE OF INFORMATION TECHNOLOGY, BIJNOR.",
  "EDIFY INSTITUTE OF MANAGEMENT AND TECHNOLOGY, MATHURA",
  "NOIDA INSTITUTE OF ENGG. AND TECHNOLOGY, (MCA INSTITUTE ), GREATER NOIDA",
  "NIGC INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "OXFORD COLLEGE OF PHARMACY, HAPUR",
  "PANCHWATI INSTITUTE OF ENGINEERING AND TECHNOLOGY, DELHI- HARDWAR BYPASS, MEERUT",
  "SUNDERDEEP ENGINEERING COLLEGE, GHAZIABAD",
  "CAREER COLLEGE OF NURSING LUCKNOW",
  "SUNDERDEEP PHARMACY COLLEGE, GHAZIABAD",
  "SHIVPAL SINGH YADAV DEGREE COLLEGE",
  "SVS GROUP OF INSTITUTIONS, MEERUT",
  "TRANSLAM INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH, RAJPURA, MAWANA ROAD, MEERUT",
  "G AND R INSTITUTE OF MANAGEMENT AND TECHNOLOGY, BHULANDSHAR",
  "VINAYAK PHARMACY COLLEGE, AZAMGARH",
  "GLOBAL INSTITUTE OF INFORMATION TECHNOLOGY, GREATER NOIDA",
  "SHRI NAWAB SINGH MAHAVIDAVALYA, FIROZABAD",
  "GREATER NOIDA INSTITUTE OF TECHNOLOGY (MBA INSTITUTE), GREATER NOIDA",
  "MIT COLLEGE OF MANAGEMENT, MURADABAD,MURADABAD",
  "MODERN INSTITUTE OF TECHNOLOGY AND MANAGEMENT, GHAZIABAD",
  "MODINAGAR INSTITUTE OF TECHNOLOGY, GHAZIABAD",
  "INSTITUE OF PROFESSIONAL EXCELLENCE AND MANAGEMENT, GHAZIABAD.",
  "STALLIAN COLLEGE FOR ENGINEERING AND TECHNOLOGY,SAHARANPUR",
  "SHRI SAI COLLEGE OF EDUCATION, MEERUT",
  "TRANSLAM INSTITUTE OF TECHNOLOGY AND MANAGEMENT, MAWANA ROAD, MEERUT",
  "UNIQUE INSTITUTE OF MANAGEMENT, MODINAGAR, GHAZIABAD.",
  "GOKARAN NARVADESHWAR INSTITUTE OF TECHNOLOGY & MANAGEMENT,BARABANKI",
  "PREM PRAKASH GUPTA INSTITUTE OF ENGINEERING,BAREILLY",
  "PURVANCHAL INSTITUTE OF ARCHITECTURE & DESIGN,GORAKHPUR",
  "NARAINA VIDYA PEETH \" GROUP OF INSTITUTIONS\" FACULTY OF PHARMACY,KANPUR",
  "VISION INSTITUTE OF TECHNOLOGY,KANPUR",
  "VARANASI COLLEGE OF PHARMACY,VARANASI",
  "SHRI BHAGWAN VISHNU SWAMI SATUA BABA SANSKRIT MAHAVIDHYALA GADHWASI TOLA VARANASI",
  "J D S N SINGH LAW COLLAGE RUDAULI KANDHAIPUR SULTANPUR",
  "GULAB SINGH WOMEN COLLEGE, HIRADHARPUR, MAHPUR, GHAZIPUR",
  "VIMLA VIKRAM VIDHI MAHAVIDYALAYA PACHPERWA BALRAMPUR",
  "VIMLA VIKRAM MAHAVIDYALAYA, PACHPERWA, BALRAMPUR",
  "RAJKIYA MAHAVIDYALAYA, LATIFNAGAR, SAROJINI NAGAR, LUCKNOW",
  "LORD KRISHNA MAHAVIDYALAYA",
  "NARVADESHWAR MANAGEMENT COLLEGE, LUCKNOW",
  "JYOTI KANYA MAHAVIDHYALAYA HIMMATGANJ BILSI BUDAUN",
  "Shri Narang Sanskrit Mahavidyalaya, Ghugali, Mahrajganj",
  "RADHIKA INSTITUTE OF TEACHERS TRAINING ",
  "KRISHNA LAW COLLEGE ",
  "SMT. MODHA DEVI JAGDEVI MAHILA DEGREE COLLEGE",
  "HARE KRISHNA COLLEGE OF HUMANITIES, KANPUR",
  "Prerna Mahavidyalaya",
  "K.P.Training College",
  "STATE HOMOEOPATHIC MEDICAL COLLEGE  HOSPITAL CHHERAT ALIGARH",
  "BHAWANI PRASAD MISHR JATASHANKAR SIKSHAN SEWA SANSTHAN MAHAVIDYALAYA",
  "Govt. Model Degree College, Kapoori Govindpur, Saharanpur",
  "Government Mahila Mahavidyalaya Behat (Saharanpur) Mob. No.9412864533",
  "Shivalik Ayurvedik Medical College, Vill-Bijarva, Post-Bankat, Azamgarh",
  "MAJOR SUBEDAR SINGH MAHAVIDYALAYA KESHAUPUR TEJGANJ JASMAI MAINPURI",
  "COLONOL JAGANNATH SINGH MAHAVIDYALAYA, PEETHAPUR, SARAIYA, BHITI, AMBEDKAR NAGAR",
  "ARYA COLLEGE OF LAW",
  "HUKAM SINGH MEMORIAL GIRLS DEGREE COLLEGE NANAUTA",
  "SHRI RAM GIRLS COLLEGE,  MUZAFFARNAGAR",
  "GNIT COLLEGE OF MANAGEMENT",
  "G.S.COLLEGE OF EDUCATION, SHIKOHABAD",
  "Jagat Taran Girls Degree College",
  "SRI DHAM MAHAVIDYALAYA RATANPUR",
  "SHRI BABA ANANDESHWAR MAHA VIDHYALAYA",
  "DR V.P.S COLLEGE GARHI UDI,JALESAR ROAD,FIROZABAD",
  "TRIVENI DEVI GANGASRI MAHILA MAHAVIDYALAYA, BHARTHANA,",
  "CHANDRA SHEKHAR AZAD DEGREE COLLEGE, JAMU,",
  "S.G.R. MAHAVIDYALAYA, YADUVANSH NAGAR, TALGRAM,",
  "SHIVPAL SINGH MAHAVIDYALAYA, KAIST, JASWANT NAGAR,",
  "DR. VIRENDRA SWARUP INSTITUTE OF COMPUTER STUDIES, SAKET NAGAR,KANPUR",
  "YOGIRAJ SHRI KRISHNA MAHAVIDYALAYA,RASULABAD CROSSING G.T. ROAD BY PASS BHOGAON, MAINPURI",
  "R.B.S COLLEGE, AGRA",
  "VAIDIC MAHAVIDYALAYA, DIVYAPURI, DIBIYAPUR,",
  "TH.BIRI SINGH.DEGREE COLLEGE,TUNDLA,FIROZABAD",
  "DHANVANTRI EDUCATIONAL INSTITUTE NH-2 FARAH, MATHURA",
  "BADRI VISHAL P.G. COLLEGE,",
  "MAA R.K. DEVI MAHAVIDYALAYA, TIKAMPUR, PHAPHUND",
  "GURAH DEVI SHYAM BIHARI MAHAVIDYALAYA, DERAPUR,",
  "CH. KHAJAN SINGH MAHAVIDYALAYA, JURAKHAN KHERA,",
  "VIJAY VIDROHI KRANTIKARI SHIKSHAN SANSTHAN, NADEMAU,",
  "SAKET MAHAVIDYALAYA JHERA JHAL ,FIROZABAD",
  "SRI SAGAR SINGH SOMVATI DEGREE COLLEGE, BAHORIKPUR, JAHANGANJ, FARRUKHABAD",
  "Shiv Sakhi Memorial Degree College, Ghazipur",
  "MANUU Lucknow Campus",
  "RAMRAJ SINGH JAISRAJ SINGH MAHAVIDYALYA",
  "JBS INSTITUTE BANDI KA PURWA",
  "Institute of Fine Arts,Varanasi",
  "RAJAT DEGREE COLLEGE, SHAKTI NAGAR",
  "Nav Sadhana Kala Kendra,Varanasi-221 003",
  "Shri Rawatpura Sarkar Institute Pharmacy",
  "SHRI PRAMOD JI MAHILA MAHAVIDYALAYA, KUSHAHRA SHAHGANJ - SONEBHADRA",
  "SHRI HARISH CHANDRA TIWARI MAHAVIDYALAYA ANEPUR MAHEWA ETAWAH",
  "B J L GIRLS DEGREE COLLEGE    ",
  "Dr. Bhanu Pratap Singh Mahavishyalya Bakal Pur Road, Shamshabad road, Agra",
  "CAPTAN RAM SINGH DEGREE COLLEGE NAGLA RAM KUBIR,FIROZABAD",
  "Dr A P J ABDUL KALAM TECHNICAL UNIVERSITY FACULTY OF ARCHITECTURE, LUCKNOW",
  "BAIDYA SHIVCHARAN LAL SMARATI MAHAVIDHLYA SERGARH",
  "Army Institute of Management Technology",
  "FS COLLEGE OF NURSING",
  "SRI JAGVIR SINGH CHAUHAN SMRITI MAHAVIDYALAY,AKBARPUR LALSAHAY, ETAH",
  "GOVT. ENGINEERING COLLEGE,AMBEDKAR NAGAR",
  "Amity School of Engineering & Technology",
  "SHRI RAJARAM CHETNA DEGREE COLLEGE    ",
  "RAMBHEEK RAJRANI DEGREE COLLEGE MALOOKPUR GADIYA BARABANKI    ",
  "ADARSH SAMAJ MAHAVIDYALAYA DOLATPUR,FIROZABAD",
  "C - DAC, NOIDA",
  "G L TEACHERS EDUCATIONAL INSTITUTE",
  "Shahzad Husain Degree College",
  "COLLEGE OF AGRICULTURE LAKHIMPURKHERI    ",
  "Shri Darbari Lal Mahila Mahavidyalaya",
  "DEVESH NURSING AND PARAMEDICAL COLLEGE, UMARPUR SAYYAD SARAWA, CHAIL, KAUSHAMBI",
  "Mahatma Gandhi Shati Smarak Mahavidyalaya ,Garua Maksoodpur, Ghazipur",
  "KVS INSTITUTE OF AYURVEDIC MEDICAL SCIENCE AND RESEARCH CENTER MARDAPUR BAKSUPUR GHAZIPUR    ",
  "J K COLLEGE OF NURSING, ETAWAH",
  "BAKHSHI TEACHERS TRAINING INSTITUTE",
  "AWADHESH SINGH MAHAVIDYALAYA, ASAVI,",
  "KARMA NURSING AND PARAMEDICAL COLLEGE",
  "PUSHPANJALI SCHOOL OF NURSING AGRA",
  "ACHARYA RAMAKANT MAHILA SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA",
  "RAMAAKANT INDRAWATI DEVI MAHAVIDHYALAYA DEIDEEH DHAURAHARA",
  "SMT. PREMA DEVI MANOJ KUMAR MAHILA DEGREE COLLEGE, SARAI MAMREJ, HANDIA, ALLAHABAD",
  "Savitri Devi Mahila Mahavidyalay",
  "H.H.A.GOOD LIFE MAHAVIDYALAYA RAILWAY ROAD KAMPIL FARRUKHABAD",
  "PT RAMANAND MISHRA MAHAVIDYALAYA TIRSATH(RAMPUR BAKHAR) DOTHA KORAON",
  "SHRI RAM MANOHAR YADAV MAHAVIDYALAYA ",
  "RAM RATAN MAHAVIDYALAY RAMPUR MANSOORGANJ MAHARAJGANJ",
  "Kalawati Devi College of Education, Bijadhar Mau, Machalisahar, Jaunpur",
  "DR. TANDON NURSING COLLEGE, AGRA",
  "SHRI LOKMANI SHARMA MAHAVIDYALAYA BHAGRA NOUGIL MATHURA",
  "TND MAHAVIDYALAY PAKADIYR BISHUNPUR MAHARAJGANJ",
  "Danish Alpsankhyak Sikshan Evam Prasikshan Sansthan",
  "CHANDAN SINGH KANYA MAHAVIDHYALA , JHANSI",
  "baiswara mahavidyalaya bisenmau bighapur unnao",
  "Chaudhary Shiv Kumar Patel Mahila Mahavidyalaya",
  "kalpnath singh mahila mahavidyalya  lotan siddharth nagar",
  "HANSA DEVI MAHAVIDYALAYA ACHALPUR JAMON AMETHI",
  "S.B. SINGH MAHILA MAHAVIDYALAYA",
  "KRISHNA MAHILA MAHAVIDYALAY BADWAR PANIYARA MAHARAJGANJ",
  "Vindhya Gurukul College, Gosaipur, Sakteshgarh, Chunar, Mirzapur",
  "GONARD EDUCATIONAL INSTITUTE, BEERPUR, KATRA, GONDA",
  "MAHARAJA DEVI BAKSH SINGH SMARAK SANSTHAN, BANGHUSRA, DUMARIADEEH, GONDA",
  "R.P. DEGREE COLLEGE, KAMALGANJ,",
  "SRI RADHE KRISHNA M.D. MAHAVIDYALAYA, TIWARIPUR, SARSAUL,",
  "D. A. V. COLLEGE MEERUT HAPUR ROAD, KHARKHAUDA, MEERUT Ph. 0121-2883269, 2763289, 9412705545, 9412207835",
  "SRI MEGH SINGH COLLEGE, AGRA",
  " A.S. (P.G.) College, Mawana (Meerut)",
  "I.O.P VRINDAVAN,MATHURA",
  "SHRI BANSHI DHAR MEMORIAL MAHAVIDYALAYA TUNDLA, FIROZABAD",
  "BHAGWATI DEVI SMARITI MAHAVIDYALAYA KURANI, MAINPURI",
  "PT.MANISH SHARMA MAHAVIDHYALAYA KOTLI BAGHICHI DEVERI ROAD AGRA",
  "BASANTI DEVI DEGREE COLLEGE, DEVLI, BULANDSHAHR",
  "TRIDENT COLLEGE OF EDUCATION 593/10, PARTAPUR, NEW FLYOVER BY PASS ROAD  NH-58  MEERUT 250 005",
  "ARSHIA COLLEGE FOR HIGHER EDUCATION VILL. KAUL, MAWANA MEERUT",
  "WOMEN' S COLLEGE",
  "BABU KAMTA PRASAD JAIN MAHAVIDYALAYA DELHI ROAD, BARAUT (BAGHPAT) Ph. 0124-267602",
  "BHAGWATI COLLEGE OF MGMT & TECHNOLOGY SIVAYA, ROORKEE ROAD, MEERUT",
  "Ch. Shiv Nath Singh Sadilya (P.G.) College, Machhara (Meerut) Mob. No.9411262544",
  "SUNRISE INSTITUE OF EDUCATION & TECH K. K. ROAD, NEAR DADRI (G.B. NAGAR)",
  "SHREE SAI COLLEGE OF EDUCATION & TECH. VILLAGE & POST. JAGENTHI, SARDHANA ROAD, MEERUT, PH. 9812782086",
  "INSTITUTE FOR HIGHER EDUCATION ONE ONE SEVEN, MEERUT-DELHI ROAD, GULDHAR, GHAZIABAD,",
  "DOON COLLEGE OF EDUCATION SUNDERPUR, SAHARANPUR Ph. No- 9837039652, 9412057738",
  "RAMESH CHAND INSTITUTE OF MANAGEMENT MEERUPUR TRONIKA CITY,LONI, GHAZIABD",
  "S.V.S. SCHOOL OF MANAGEMENT, MAWANA, MEERUT Ph. No. 9837666669, 1233-273333",
  "L.T.R. INSTITUTE OF EDUCATION KURALI BAGHPAT ROAD, MEERUT Ph.  0121-2881353, 2512682",
  "WALSON INSTITUTE OF LAW,  GULAOTHI ROAD, SIKANDRABAD, BULANDSHAR",
  "NOIDA COLLEGE OF PHYSICAL EDUCATION NAVODY VIDYALAYA ROAD, DHOOM MANIKPUR, DADRI, (G.B. NARAG) Ph. No- 4571581, 45701848, 09810476598",
  "MORDEN COLLEGE OF LAW, MOHAN NAGAR, GHAZIABAD,",
  "TRANSLAM COLLEGE OF EDUCATION P.O. - RAJPURA, MAWANA ROAD, MEERUT",
  "MEWAR INSTITUTE OF MANAGEMENT,VASUNDHARA, GHAZIABAD",
  "RAKSHPAL BAHADUR MANAGMENT INSTITUTE PLOT NO. 4, KNOWLEDGE PARK-III, GREATER NOIDA",
  "SHRI MAHAVEER GIRLS DEGREE COLLEGE, POHALI, SARADHANA ROAD, MEERUT",
  "BHAGWATI COLLEGE OF EDUCATION SIVAYA, ROORKEE ROAD, MEERUT",
  "I.I.M.T. COLLEGE OF MANAGEMENT PLOT NO. A-20, KNOWLEDGE PARK-III,  GREATER NOIDA,  Ph. No. :  9412707955, 0120-2322655, 2231880",
  "HAJARI LAL MEMORAIL INSTITUTE OF EDUCATION & TECHNOLOGY KHAILA, BAGHPAT",
  "GREEN LAND COLLEGE OF EDUCATION DILIP PARK, MODINAGAR (GHZIABAD)",
  "NKBR COLLEGE OF PROFESSIONAL STUDIES MEERUT-HAPUR  ROAD, PHAPHUNDA, MEERUT, Ph. 0121-2954248,, 2575775, 9897548873,",
  "GAYTARI DEVI COLLEGE OF EDUCATION MALAKPUR ROAD, BARAUT (BAGHPAT)",
  "V-TECH  INSTITUTE OF INTEGRATED  TECHNOLOGY KHURJA G.T. ROAD, BULANDSHAHR",
  "KALKA INST. FOR RESEARCH & ADVANCED STUDIES PARTAPUR BY PASS, MEERUT",
  "INSTITUTE OF MANAGEMENT & INFORMATION TECHNOLOGY, HAPUR",
  "KISHAN INSTITUTE OF TEACHER EDUCATION MEWLA CROSSING, NEAR AMARUJALLA, OPP. MUKET MAHAL BANQUET HALL, DELHI ROAD, MEERUT Ph. No :- 2408400, 01, 05 , 9927131555, 9927500592",
  "SETH RAMANAND MANGAL SEN MAHAVIDYALAYA,  CHATTARI, BULANDSHAHR",
  "M S Institute, Chola Road, Bulandshahr",
  "R.D. COLLEGE OF EDUCATION SISHOLI, GARH ROAD, MEERUT Ph. 0121-2882252, 9358434497",
  "PANCHWATI INSTITUTE OF EDUCATION & TECHNOLOGY GHAAT ROAD, PARTAPUR,  TAHASIL & DISTT-MEERUT",
  "Maharaja Agarsen College of Higher Education, Sarai Chhabila, Bulandshahr",
  "BHAGWATI COLLEGE OF LAW SIVAYA, ROORKEE ROAD, MEERUT",
  "KRISHNA INSTITUTE OF EDUCATION 11 KM. MILESTONE, BANA, MAWANA ROAD, N.H.119 MEERUT",
  "LAKHMI CHAND PATWARI COLL OF EDUCATION DELHI BAGHPAT ROAD,  KHEKRA (BAGHPAT), Ph. 0121-2233097, 9412631054",
  "INSTITUTE OF TEACHER EDUCATION KADARBAD, MODINAGAR (GHAZIABAD)",
  "AMOGHA INSTITUTE OF PROFESSIONAL & TECHNICAL EDUCATION MORTA, GHAZIABAD",
  "H.L.M. COLLEGE  DELHI-MEERUT ROAD, GHAZIABAD",
  "B.D.S. GURUKUL OF EUDATION SECTOR-8, JAGRITI VIHAR, OPP. MEDICAL COLLEGE, MEERUT.  Ph. No :- 2768840, 2768387",
  "RELIABLE INSTITUTE OF LAW MORTA, DELHI-MEERUT ROAD, GHAZIABAD",
  "CH. DHARAMPAL SINGH DEGREE COLLEGE, ADAMPUR, BAGHPAT",
  "GLOBAL COLLEGE OF LAW NAAGLOK",
  "COLLEGE OF EDUCATION BILASPUR (GREATER NOIDA) Ph. No. : 0120-2566423, 2566424",
  "Meerut College Meerut Ph.No.0121-4012004, 4012000",
  "MAHESHWARAM  COLLEGE OF EDUCATION & LAW SYANA, BULANDSHAHR",
  "MAHILA INSTITUTE OF TECHNOLOGY, KALAND ROAD, SARDHANA ROAD, MEERUT Ph. 9997312494, 9837791586",
  "M.B. GIRLS COLLEGE DADRI (GAUTAMBUDH NAGAR)",
  "D.N.(P.G.) College, Meerut Ph. No. 0121-4007794, 2519222",
  "UNIVERSAL COLLEGE OF EDUCATION DELHI-SAHARANPUR ROAD, BAOLI, BARAUT (BAGHPAT)",
  "SHRI JWALA PRASAD SHARMA SHIKSHAN SANSTHAN INSTITUTE, KOREI, KIRAWALI",
  "Jhhauva Dharm Nagar Sanskrit Mahavidyalaya, Sikari Ganj",
  "HIERANK BUSINESS SCHOOL  A-42,Sector 62,Noida-201307",
  "CHAUDHARY CHANDAN SINGH MAHAVIDYALAYA, MAKRAND NAGAR,",
  "FUTURE INSTITUTE OF MEDICAL SCIENCES  BAREILLY",
  "JUHARI DEVI GIRLS DEGREE COLLEGE,",
  "JEEVANDEEP INSTITUTE OF NURSING And PARAMEDICAL SCIENCES",
  "SATNAMI KANYA VIDYAPETH, RUKANPUR",
  "BABU RAM CHANDRA SINGH INSTITUTE OF NURSING AND PARAMEDICAL",
  "Vivekanand College of Nursing",
  "Moti Lal Nehru Medical College",
  "D R COLLEGE OF PHARMACY VILL DOTAI GARHMUKTESHWAR HAPUR    ",
  "NIRMALA DEVI PHARMACY COLLEGE NAYANSAND GAURABADSHAHPUR JAUNPUR",
  "BHAVDIYA INSTITUTE OF PHARMACEUTICAL SCIENCE & RESEARCH, FAIZABAD",
  "BHARAT AYURVED MEDICAL COLLEGE & RESEARCH CENTER, RUDKI ROAD,",
  "SURYA COLLEGE OF EDUCATION GRAM,POST DHARAMPUR FIVE BISWA, BHATIYAN TEHSEEL, DHOLANA ,JANPAD HAPUR",
  "F H COLLEGE OF NURSING",
  "C S COLLEGE OF NURSING AND PARAMEDICAL",
  "M.A.S. DEGREE COLLEGE, SHEKHPUR ASHIK, KUNDA, PRATAPGARH",
  "S D COLLEGE OF SCIENCES    ",
  "RAM KRISHNA SINGARI DEVI MAHILA MAHAVIDHYALAY FETWA KARANPUR BASTI    ",
  "BAPPA JI MAHILA MAHAVIDYALAY CHAFARIYA BAHRAICH    ",
  "SUSHIL INSTITUTE OF MANAGEMENT & TECHNOLOGY, MAWANA, MEERUT",
  "NEW ADARSH COLLEGE OF LAW    ",
  "Srishti Balika Sikchan Sansthan, Pahadpur, Bisambhar, Ghazipur",
  "BHAWANI  DEGREE COLLEGE SHAHAJAPUR, MEERUT",
  "I.P.E.M. LAW ACADEMY, GHAZIABAD",
  "INDRADEV INST. OF EDUCATION  & TECHONOLOGY MURADNAGAR ROAD, BAGPAT Mob. NO. 9411825941, 9761990342, 09350317286",
  "Ramanath Mahavidyalaya, Ishapur, Jaunpur",
  "NEW ADARSH INST. OF EDUCATION, NEAR L.P.G. GAS PLANT, LONI, GHAZIABAD Ph. 9810329578, 2683033",
  "Gandhi Vidya Nikaten Degree College, Budhpur-Ramala (Baghpat) Mob.No.9897740051, 251040",
  "SHRI KRISHNA COLLEGE OF EDUCATION SIGHAWALI AHIR, BAGHPAT",
  "GLOBAL INSTITUTE OF INFORMATION TECHNOLOGY 32-A, KNOWLEDGE PARK-I, GREATER NOIDA Ph. No :-   0120-3227187, 09899696752",
  "KALANDI COLLEGE MALAKPUR-CHAPURALI ROAD, BARAUT, BAGHPAT",
  "RELIABLE INSTITUTE . OF MANAGEMENT.&  TECHNOLOGY MORTA,  GHAZIABAD",
  "CH.BASIR KHAN MAHAVIDYALAYA HARRA, TEHSIL-SARDHANA, MEERUT",
  "S S V College, Hapur",
  "SHAFI DEGREE COLLEGE, BISALPUR",
  "NATHU SINGH DEGREE COLLEGE,KARANPUR, THAKURDWARA",
  "RAJPAL SINGH MEMORIAL MAHAVIDYALAYA, RAMPUR GHOGHER",
  "Mewar law Institute ,vasundhara ghaziabad",
  "SHRI SAHAB SINGH MAHAVIDYALAYA,MUSTAFABAD,FIROZABAD",
  "CHANDRAPAL SINGH DEGREE COLLEGE, SHYODASPUR, THAKURDWARA",
  "Abdul Razaq Memorial Degree College",
  "MAHARANA PRATAP LAW COLLEGE RAMDASPUR MAJHAULI BIKAPUR",
  "KUNWAR RAM BHAROSE MAHAVIDYALAYA, HASANGANJ,",
  "B.T.N. MEMORIEAL EDUCATIONAL INSTITUTE SENDHUTARA AYODHYA",
  "PT BAL KRISHNA KRISHNA KUMARI MEMORIAL MAHAVIDYALAYA",
  "G D R GIRLS COLLEGE ",
  "BABU SINGH MAHAVIDYALAYA, RAMPUR, BAIJU,",
  "GANGADEVI BALIKA MAHAVIDYALAYA, BHAVANIPUR, MOHANPUR RATANPUR",
  "HIRA MAHILA MAHAVIDYALAYA BUDHIYABARI DOHARIYA BAZAR GORAKHPUR",
  "SUKHRAM MAHAVIDHYALA VIJAYPUR DABRAI FIROZABAD",
  "HEMANT DEGREE COLLEGE, SADHONAGAR DAMDAM",
  "SMT. NATHIYA DEVI DEGREE COLLEGE, SHAMSHABAD",
  "SMT KRIPA SHUKLA PUTTILAL MAHAVIDYALAYA, KEWLEPUR, SUJANPUR",
  "BHAGWANDEEN SINGH PATEL MAHAVIDYALAYA, RAGAULI",
  "BABU RAMESHWAR SINGH MAHAVIDYALAYA, KHARELA",
  "DEOBAND UNANI MEDICAL COLLEGE HOSPITAL AND RESEARCH CENTRE DEOBAND",
  "BABA DHYANI DAS MAHAVIDYALAYA, KALOLIJAR",
  "SATYA NARAIN MAHAVIDYALAYA, BHADAUSI, PRATAPGARH",
  "SHRI BRIJENDRA JANATA DEGREE COLLEGE",
  "Abhinav Pragya Mahavidyalaya, Sarila",
  "A.N.D.N.N.M. MAHAVIDYALAYA,",
  "KISHAN PYARI SHUKLA COLLEGE MUNDESI MATHURA",
  "R K G EDUCATIONAL COLLEGE, IN FRONT OF Dr. AMBEDAKAR UNIVERSITY, RAEBAREILY ROAD",
  "R N GIRLS DEGREE COLLEGE, SHANTI NAGAR, ALAMBAGH",
  "SMT. RAMA AGRAHARI MAHILA MAHAVIDYALAYA, BIKHARIPUR,",
  "SHRI SIDDHI VINAYAK DEGREE COLLEGE RAIBHA ACHHNERA, AGRA",
  "RAMPAL BITAN DEVI MAHAVIDYALAYA, BAWAN IMLI, KHAJUHA,",
  "ST. MOTHER TERSA VIDHI MAHAVIDYALAYA, LONAPUR, GOMTI NAGAR",
  "Govt. P G College",
  "RAM LAKHAN MAHAVIDHYALAYA,SORAN",
  "DR SHAKUNTALA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL NAYANSAND GAURABADSHAHPUR JAUNPUR",
  "RAM DULARI B.L. JAISWAL MAHAVIDHYALAYA,ATRAMPUR",
  "G S LAW COLLEGE KAKRABAD JEHTA MALL ROAD, LUCKNOW",
  "GOVIND SINGH SMARAK DEGREE COLLEGE, HANDIA, ALLAHABAD",
  "RAJ NARAYAN PANDEY DEGREE COLLEGE, BERUI,",
  "SARVDEV AYURVEDIC MEDICAL COLLEGE  AND MAHAMRITYUNJAY HOSPITAL,  ITAURA, CHANDRESHWAR,  AZAMGARH    ",
  "S. R. COLLEGE OF PROFESSIONAL STUDIES, AMBABAI, JHANSI",
  "HARI BANDHU NURSING AND PARAMEDICAL INSTITUTE MADHUKAR NAGAR COLONY RUPPANPUR NATUI SARNATH VARANASI",
  "S R College",
  "Trivedi Girls Degree College",
  "SWAMI SWAROOPANAND INSTITUTE OF MGMT & TECHNOLOGY GRAHI PUKHTA, MUZAFFARNAGAR",
  "CH. KALIRAM MAHAVIDYALAYA NAGLA, SAHARANPUR",
  "WEBTECH COLLEGE OF MANAGEMENT AND TECHNOLOGY",
  "MAHARANA PRATAP AYURVEDIC MEDICAL COLLEGE & HOSPITAL, KANPUR",
  "BUNDELKHAND VIDHI MAHAVIDYALAYA, ORAI ",
  "BRAHMA NAND MAHAVIDYALAYA, RATH ",
  "BIPIN BIHARI DEGREE COLLEGE                         ",
  "BALA JI MAHARAJ MAHAVIDYALAYA, KAPTIHA KALAN",
  "PT RAMKRISHNA THAPAK MAHAVIDYALAYA, KAILIYA",
  "SANT KABIRDAS DEGREE COLLEGE CHANDHOKHA CHEDA BHUTA BAREILLY     ",
  "MAA SHANTI DEVI VIDHI MAHAVIDYALAYA, GADHA, AMILIYA, KORAON, PRAYAGRAJ",
  "DURGA SHIKSHA NIKETAN MAHAVIDYALAYA, BHARWARA, GOMTI NAGAR",
  "PT. GHANARAM HARIRAM MAHAVIDYALAYA, MINAURA - KOCH ROAD, ORAI ",
  "KEVALAPATI MAHAVIDHYALAYA, SINDHOURA, MUGARSON",
  "KESAI RAM JHURA DEVI MAHAVIDYALAYA, KORAON,",
  "Smt Amrit Kunwar College",
  "SHRI RAM CHARAN SINGH DEGREE COLLEGE JAROLI SHAMSABAD AGRA",
  "Swami Vivekanand Degree College Nagra Jhansi",
  "Yug Chetna College",
  "Veer Bhoomi Govt. Degree College",
  "Shri Shankar Bhagwan Institute of Technology",
  "DR. R.P. RICHHARIYA DEGREE COLLEGE, BARUASAGAR                     ",
  "CH.HARIRAM MAHILA MAHAVIDHYALYA, DULHARAY KA PURWA, BHAGYANAGAR",
  "AMIRUDDULA ISLAMIA DEGREE COLLEGE",
  "Ramjag P.G. Mahavidyalaya, Mardanpur, Ghazipur",
  "DR JAIMANGAL SINGH PRATHMIK PRASHIKSHAN SANSTHAN",
  "Kulbhaskar Ashram Post Graduate College, Prayagraj",
  "Shabari P.G. College, Sikhani Ghazipur",
  "ASIAN COLLEGE OF EDUCATION SUBBAKHARI, SARSAWA, SAHARANPUR",
  "ALLENHOUSE BUSINESS SCHOOL, KANPUR",
  "SHARDA DEVI MAHAVIDYALAYA, KADEREPUR, BADLAPUR, JAUNPUR",
  "SANITY INSTITUTE OF MANAGEMENT AND STUDIES, RAMPUR",
  "M D S GIRLS COLLEGE OF EDUCATION, FUNA, POST FINA,CHANDPUR",
  "KALYAN SINGH INSTITUTE OF EDUCATION, ATE",
  "R.K. (P.G.) College Shamali (Prabudh Nagar) Mob.No.01398-253197, 250143",
  "LALA LAXMI NARAYAN DEGREE COLLEGE, SIRSA, PRAYAGRAJ",
  "DHARAM SINGH JAGDISH SINGH MAHAVIDYALAYA, FATHAPUR KALA, BEHAT, SAHARANPUT",
  "ODM AYURVEDIC MEDICAL COLLEGE AND HOSPITAL ",
  "Shri Haridas Mahavidyalaya Lahangpur, Jaunpur",
  "AHILYABAI HOLKAR COLLEGE OF SCIENCE AND TECHNOLOGY, ASLEMPUR ",
  "D.S.R. DEGREE COLLEGE, PIPRA NANKAR, BAHERI ",
  "D.V.M. MAHAVIDYALAYA AND TECHNICAL COLLEGE, NAGINA",
  "SWARGIYA RAMVILASH SINGH VIDHI MAHAVIDYALAYA",
  "DARYAO SINGH RATHORE MEMORIAL MAHAVIDYALAYA, GULARIA ",
  "VIMALA DEVI SANSKRIT MAHAVIDYALAY SARAI PADARI SHANKARGANJ JAUNPUR",
  "DHARAMVEER COLLEGE OF EDUCATION, BISHANPURA KOT",
  "Remote Sensing Applications Center",
  "Sadguru Shri Sitadash Mahavidyalaya",
  "Dr. G. S. Dubey Mahavidyalaya, Meethepaar, Jaunpur",
  "Baba Vanwari Lal Balgopal Mahavidyalay.Malora Ghazipur",
  "Patiram Bhagat Singh Mahavidyalay,Jhanpur, Bhitari, Ghazipur",
  "ADARSH SATYENDRA MAHAVIDYALAYA, LUCKNOW",
  "AKBARI BEGUM LAW COLLEGE, LUCKNOW",
  "ARYAKUL COLLEGE OF EDUCATION, NATKUR,GAURI, BIJNOR, LUCKNOW",
  "KCM COLLEGE OF EDUCATION LUCKNOW",
  "SWAMI VIVEKANAND INSTITUTE OF INFORMATION & TECHNOLOGY GORAKHPUR",
  "Champa Devi Mahavidyalaya, Karkhiyanva,Varanasi",
  "J.N.M.College For Advance Studies and Technology Khushahal Nagar ,Badalalpur,Varanasi",
  "Arjuna Singh Mahavidyalaya, Khajuri, Mirzamurad,Varanasi",
  "Shri jamuna Prasad Maurya Shikshan Prashikshan Sansthan,Khewali,Varanasi",
  "Rajeshwari Mahila Mahavidyalaya, Baijalpatti Harahuan ,Varanasi",
  "PREMA KATIYAR SIKSHAN SANSTHAN MAHAVIDYALAYA,",
  "DURGA MAHAVIDYALAYA, KHASPUR, VIA PAKBARA ",
  "GURU JAMESHWAR MAHAVIDYALAYA, SARKARA VISHNOI, THAKURDWARA",
  "H.M.A. RIZVI PRASHIKSHAN SANSTHAN, BIJNOR",
  "HIMALAYA INSTITUTE OF EDUCATION, RAMPUR ",
  "IMPACT COLLEGE OF SCIENCE AND TECHNOLOGY, RAMPUR",
  "JANTA COLLEGE OF EDUCATION, NAGAR PALIKA, NOORPUR",
  "JANTA MAHAVIDYALAYA, PEEPLI NAYAK, RAMPUR ",
  "SHRI KHUSHIRAM INSTITUTE OF MANAGEMENT & INFORMATION TECHNOLOGY KHAIR",
  "KB INSTITUTE OF TECHNOLOGY & MANAGEMENT FAIZABAD",
  "MADAN MOHAN SMARAK, MAHAVIDYALAYA RUNKATA, AGRA",
  "S.R DEGREE COLLEGE UKKHRRA,AGRA",
  "TH. TEJ SINGH DEGREE COLLEGE, AGRA",
  "SETH GAGAN DAS SMRITI GIRLS COLLEGE, RATANPUR,",
  "S.J. MAHAVIDYALAYA, RAMAIPUR,",
  "DR RAM MANOHAR LOHIYA RAJKEEYA MAHAVIDYALAYA, BIDHUNA, AURRAIYA",
  "CITY PUBLIC DEGREE COLLEGE, NEKPUR CHAURASI, FATEHGARH,",
  "SWAMI GIRISHANANAD COLLEGE, TIRWA,",
  "MAA SHEETALA DEVI TRIJUGI NARAYAN MAHILA MAHAVIDYALAYA,BARANDA, MAKANPUR ROAD, ARAUL",
  "CHAUDHARY JAMADAR SINGH MAHAVIDYALAYA, LALAKPUR,",
  "SRI PUTTULAL MEMORIAL MAHAVIDYALAYA, JAHANGANJ,",
  "OMAR VAISHYA LALA PURUSHOTTAM DAS COLLEGE, SHYAM NAGAR,",
  "SRI DEEN DAYAL KUSHWAHA MAHAVIDYALAYA, SAMBHALPUR,",
  "VICTOR PUBLIC DEGREE COLLEGE, BHARTHANA,",
  "MAJOR SHIVDAYAL SINGH MAHAVIDYALAYA MOHAMMADABAD",
  "RAJ BAHADUR SINGH DEGREE COLLEGE, LAKHANA,",
  "CH. JASWANT SINGH MAHAVIDYALAYA, BHARTHANA,",
  "INDIRA GANDHI RAJKEEYA DEGREE COLLEGE, BANGARMAU,",
  "SHRI KRISHNA MAHAVIDYALAYA, NAGLA HARJU,",
  "SHRI GANESH SHANKAR VIDYARTHI MAHAVIDYALAYA, NARWAL, SEMARJHAL, KANPUR NAGAR",
  "VIVEKANAND GRAMODYOG MAHAVIDYALAYA, DIBIYAPUR, AURAIYA",
  "JWALA DEVI VIDYAMANDIR P.G. COLLEGE,",
  "HARSAHAI P.G. COLLEGE,",
  "ARMAPUR P.G. COLLEGE, ARMAPUR,",
  "AMAR SHAHID RAO RAM BUX SINGH MAHAVIDYALAYA, GAURA BIHAR, UNNAO",
  "D.B.S. COLLEGE, GOVIND NAGAR,",
  "DR. GOVIND PRASAD RANI DEVI PATEL MAHAVIDYALAYA, ARAUL,",
  "JANTA COLLEGE, BAKEWAR,",
  "DR. BHIMRAO AMBEDKAR BUDDHA MAHAVIDYALAYA, NAGLA KHADAR,",
  "GAYA PRASAD VERMA MAHAVIDYALAYA, DAMAULI, CHAKAR NAGAR,",
  "GURU NANAK GIRLS DEGREE COLLEGE,",
  "SW. BABU SINGH BALIKA MAHAVIDYALAYA, RAMPUR,",
  "DR. ANURADHA TRIPATHI MEM. BALIKA MAHAVIDYALAYA, KHANPUR,",
  "KUNWAR ASIF ALI KAISAR JAHAN DEGREE COLLEGE, HYDRABAD,",
  "SRI KRISHNA JANKA DEVI MAHAVIDYALAYA, RURA,",
  "GAUTAM BUDDHA MAHAVIDYALAYA, RAMPURA, HAIDERPUR,",
  "MA. KASIRAM RAJKIYA MAHAVIDYALAYA, NINAUWA,",
  "KHALSA GIRLS DEGREE COLLEGE, HARJINDER NAGAR,",
  "RAMKRISHNA PARAMHANS MAHAVIDYALAYA, KULHA, ATOURA, ASEEWAN,",
  "GAUTAM BUDDH BALIKA MAHAVIDYALAYA, INDERGARH,",
  "SMT. RAMDULARI MEMORIAL KANYA MAHAVIDYALAYA, SARAI,",
  "PT. RAM NARAYAN KANHAIYA LAL BALIKA MAHAVIDYALAYA, NANKARI,",
  "BABURAM RUKMANI DEVI MAHAVIDYALAYA, GAUSGANJ,",
  "OM SHIV PUBLIC MAHAVIDYALAYA, HAZI NAGAR,",
  "SRI KAILASH NATH KATIYAR MAHAVIDYALAYA, SIKANDARA,",
  "SAI COLLEGE OF EDUCATION",
  "Babban Pati Chandra Bhushan Tiwari Mahavidyalaya, Nichlaul, Maharajganj",
  "INDRA DEVI Memorial Girls Degree College, Morna Bijnor",
  "Rotary Institute of Management & Techonology, Chandausi",
  "Chaudhary Mahaveer Prasad Memorial Mahavidyalay, Hathihwa, Bardpur, Siddharthnagar",
  "Azad Mahavidyalaya, Karaunda Masina, Siddharthnagar",
  "ASHOK MAHAVIDYALAYA, AMA PANDEY (BHARAT NAGAR), BASTI",
  "WOOD ROCK DEGREE COLLEGE",
  "RAM KISHOR MAHAVIDYALAYA, KUWARPUR, Jaunpur",
  "Maa Yashoda Noubat mahavidyalay, Ghazipur",
  "Rajkeeya Mahavidyalay, Indupur, Gauri Bazar, Deoria",
  "Madan Mohan Malaviya P.G. College, Bhatparrani, Deoria",
  "Khudaija Bibi Makhdoom Bakhsh Girls Degree College, Lar, Deoria",
  "Dr. Ram Manohar Lohia Degree College, Satraon, Deoria",
  "Ram Manohar Lohia Degree College, Malibari, Bariyarpur, Barhara, Deoria",
  "Pt. Deena Nath Pandey Rajkeeya Mahila P. G. College, Deoria",
  "Bahadur Yadav Memorial Degree College, Nagar Panchayat Bhatni, Deoria",
  "Rajkeeya Mahila Mahavidyalay, Salempur, Deoria",
  "Radhika Devi Kailash Prasad Degree College, Balua Chhapar, Pipra Chandrabhan, Deoria",
  "BABU KAILASH PRASAD  MAHAVIDYALAYA , SAWREJI KHARAG , BELWA BAZAR, DEORIA",
  "Madhusudan Das Degree College, Asuran, Gorakhpur",
  "Sw. Chandrashekhar Ji Poorv Pradhan Mantri Smarak Mahavidyalaya, Ghazipur",
  "Dewendra P.G. College, Belthra Road, Ballia",
  "Aatam Prakash Adarsh Mahavidyalay Arshadpur Jangipur, Ghazipur",
  "G.C.R.G INSTITUTE OF TEACHERS EDUCATION",
  "SURYA  MAHAVIDYALAYA, SIDDHARTHNAGAR",
  "SRI TILAKDHARI ANTARVANSH MAHAVIDYALAYA, SANT KABIR NAGAR",
  "RAMCHARIT CHAUDHARY MAHAVIDYALAYA, BASTI",
  "PRAWATI DEVI MOTI PRASAD MAHAVIDYALAYA, MAHARAJGANJ",
  "PATEL SHISHARAN PRASHISHARAN MAHILA DEGREE COLLEGE, BHITA RAMSEN, BASTI",
  "MISHRABHANDHU MAHAVIDYALAYA, MAHARAJGANJ",
  "MATA RANI RUMALI DEVI MAHAVIDYALAYA, MAHARAJGANJ",
  "LALITA SAVITRI DEVI MAHILA  MAHAVIDYALAYA, MAHARAJGANJ",
  "DURGESH NANDANI VASHIST NARAYAN MAHAVIDYALAYA, MAHARAJGANJ",
  "A.R.C. DEGREE COLLEGE, SANT KABIR NAGAR ",
  "CHANDRA SHEKHAR BABA KESHAV MAHAVIDYALAYA BALLIA",
  "Sant Ramnarayan Rajkishor Shankar Mahila Mahavidyalay, Ghazipur",
  "Shailesh Mahavidyalaya, Ghazipur",
  "SHRI YASH PAL SINGH MAHAVIDYALAYA BHADANWARA ,MANT,MATHURA",
  "Arjun Yadav Girls College Ikara, Ghazipur",
  "Gajadhar Singh Mahavidyalaya, Ghazipur",
  "SHRI DOODHNATH SUDAMI BALIKA MAHAVIDYALAYA, BHEEMAPAR, SADAT,GHAZIPUR ",
  "Kali Prasad Memorial Mahavidyalaya, Sihari, Basti",
  "SETH RAMDAS MEMORIAL MAHAVIDYALAYA, ERACH",
  "THAKUR DEV SINGH SMARAK MAHAVIDYALAYA, GYADI",
  "SUDARSHAN DEGREE COLLEGE, BANSI, LALITPUR",
  "BAL VIKAS MAHAVIDHYALAYA KUTUBPUR GANWARI BIJNOR",
  "GANDHI DEGREE COLLEGE, AMBABAI",
  "SAI MAHILA MAHAVIDYALAY HOLAGARH SORAON PRAYAGRAJ",
  "H N MEMORIAL MAHILA MAHAVIDYALAYA, SHIVAJI NAGAR",
  "JAI BUNDELKHAND INSTITUTE FOR SCIENCE EDUCATION MANAGEMENT TECHNOLOGY BABINA JHANSI",
  "OXFORD  COLLEGE  OF   EDUCATION  AND   TECHNOLOGY   ",
  "BRAJKISHOR VISHNU KUMAR MAHAVIDYALAYA, ABHAIDEPUR",
  "KRAPAL SINGH DADI MAHAVIDYALAYA, NADIGAON, KONCH",
  "SUMANRANI INSTITUTE OF TECHNOLOGY",
  "SRI RAMSEWAK SAXENA MEMORIAL MAHAVIDYALAYA, KUTHOUND",
  "LAXMI DEVI RAJENDRA SINGH YADAV DEGREE COLLEGE, USARGAON",
  "JAI BUNDELKHAND LAW COLLEGE, PANARI",
  "RAJA BHAIYA VERMA MAHAVIDYALAYA, TEHROLI, JHANSI",
  "SETH BADRI PRASAD SMRATI MAHAVIDYALAYA, KONCH",
  "SHRAVAN KUMAR DWIVEDI MAHESH KUMAR PANDEY MAHAVIDYALAYA, HUSEPURA, SURAI",
  "KARMYAG MAHAVIDYALAYA, ITAURA (GURU)",
  "GENDALAL YADAV MAHAVIDYALAYA, DAKOR",
  "RAJBAI SHIV BALAK SINGH MAHAVIDYALAYA, DADWA",
  "MUKUT BIHARI MAHAVIDYALAYA, URGAON",
  "BHAGWAN SINGH MAHAVIDHYALAYA, AJANARI, ORAI",
  "SRI MAHABEER INSTITUTE OF LEARNING AND EDUCATION, ORAI",
  "SHREE LALLA SINGH MAHAVIDHIYALAY, BARAHA",
  "OMM HARIHAR MAHAVIDYALAYA, KUNDAURA",
  "LATE SRI BABURAM MAHAVIDYALAYA, VIGHANA",
  "LATE SHRI POORAN RAMPRAKASH DIXIT MAHAVIDYALAY, GAHAROLI",
  "HAR PAL SINGH MEMORIAL KANYA MAHAVIDHYALAYA, VIVAR",
  "KISHNU BABU SHIVHARE MAHAVIDYALAYA, SISOLAR",
  "JAGATRAJ MAHAVIDYALAYA, RATH",
  "FOOLMATI DEVI TEACHER TRAINING COLLEGE MANT ROAD RAYA MATHURA",
  "SMT PHOOLMATI DEVI COLLEGE OF LAW MANT ROAD RAYA MATHURA",
  "Dharma Samaj College, Aligarh",
  "Lala Kishan Chand Government Mahavidyalaya Gangoh (Saharanpur)",
  "BOHARE PREM SINGH COLLEGE, GARHI INCHHA",
  "DR SHANNO RANI SARASWATI KANYA MAHAVIDYALAYA, SINGHARPUR, MATHURA ROAD, ALIGARH",
  "I T M COLLEGE KHAIR ROAD KARSUA ALIGARH",
  "Al Hidayah College of Education",
  "SSM PG COLLEGE MANIKPUR JALESAR ROAD HATHRAS",
  "Meghsingh Dropa Mahavidyalaya",
  "S.D.S. MAHAVIDYALAYA, ETAH",
  "LONG SHREE COLLEGE OF EDUCATION",
  "SHRI VISHNU BHAGWAN MAHAVIDHYALAY AGRA ROAD ETAH",
  "RAJESH KUMAR SADHANA DEVI MAHAVIDYALAYA DHUMARI ETAH",
  "DR. RAM KUMAR GAYATRI DEVI MAHAVIDHALAYA, RAJA KA RAMPUR, ETAH",
  "SHRI SHANKAR SINGH MAHAVIDYALAYA,SINDPURA, KASGANJ",
  "BOONMAX LAW COLLEGE",
  "MAHAVEER LAW COLLEGE ,GT ROAD,ABUSA MOD,SARAI INAYAT,PRAYAGRAJ,UP",
  "SRI KHUSHI RAM MAHAVIDYALAYA KAIR ALIGARH",
  "ABDUL SAHID MAHAVIDHYALAYA KASIMPUR BAHADURGARH AGRA ROAD ETAH",
  "R N SINGH MAHAVIDYALAYA",
  "CH. MUKHTYAR SINGH YADAV MAHAVIDYALAYA KAILTHA ALIGANJ ETAH",
  "ADVANCE INSTITUTE OF BIOTECH AND PARAMEDICAL SCIENCES, KANPUR",
  "SHAHID UDHAM SINGH MAHAVIDYALYA KHIZARPUR CHAK MUSTAFA PUR POST BEHAT DISTRICT SAHARANPUR",
  "DR. VIRENDRA SINGH MAHAVIDHYALAY, MIREHCHI ROAD, MAREHRA, ETAH",
  "MAMTA COLLEGE, BRIJNAGAR, SADABAD ROAD JALESAR, ETAH",
  "Shree Satya Ayurvedic Medical College And Hospital",
  "GOVT. DEGREE COLLEGE, KHAIR ALIGARH",
  "Shri Gama Dhaneshvari Balika Mahavidyalaya, Shikshan Sansthan, Shishuapar, Sadat, Ghazipur",
  "LATE. LALARAM MAHAVIDHYALAYA NAGLA ,BHOOD",
  "R.P KANYA MAHAVIDYALAYA BHUDHAICH,JALESAR ROAD,MAHAMAYA NAGAR",
  "SHRI RAM CHANDRA SINGH MAHAVIDHALAYAY, KAMALPUR SIKANDRA RAO",
  "KAUSHIK MAHAVIDYALAYA",
  "SRI LALA RAM MEMORIAL DEGREE COLLEGE, ALIGARH",
  "MAA KAMLA DEVI MAHILA MAHAVIDYALAYA",
  "R.B.S COLLEGE OF MANAGEMENT & TECH. KHAIR, ALIGARH",
  "R D SINGH COLLEGE OF EDUCATION, BASMAHUA, SAHNSO, PRAYAGRAJ",
  "SHRI SURAJ SINGH MEMORIAL COLLEGE AWAGARH ETAH",
  "SHRI P.P.S.COLLEGE NAGLA KHOKAR,VIGORE, ETAH",
  "MAYA RAJENDRA MAHAVIDYALAYA NEETI NIVAS TASINGA SADABAD",
  "MAA JAANKI DEVI MAHAVIDHYALAYA, PORA",
  "FATIMA COLLEGE OF NURSING GORAKHPUR",
  "GRAMODHAR MAHAVIDYALAYA,NAGLA PARSI,DADDO,ALIGARH",
  "SHRI RAM COLLEGE OPP. ALMASPUR TELEPHONE EXCHANGE, PARIKRAMA MARG, MUZAFFARNAGAR Ph. No. :-  0131-3091565, 0131-2402133, 2620565",
  "TARA CHAND VEDIC PUTRI DEGREE COLLEGE NAI MANDI, MUZAFFARNAGAR",
  "Dr KNS COLLEGE OF NURSING, Dr KNS MEMORIAL INSTITUTE OF MEDICAL  SCIENCES, AYODHYA ROAD BARABANKI",
  "Lachi Devi Mahila Mahavidyalaya, Chakbibulaa, Mitthanpara, Ghazipur",
  "BHARTIYA NURSING COLLEGE",
  "SHRI BABU SINGH DADDU JI NURSING AND PARAMEDICAL COLLEGE",
  "Dr R M L Institute of Pharmacy Kunwarpur Badagaon Shahjahanpur",
  "RML INSTITUTE OF MEDICAL SCIENCES",
  "KRISHNA VIDHI MAHAVIDYALAYA, SARAI LILI, KHOJAPUR, PHULPUR, PRAYAGRAJ    ",
  "Govt. Degree College Babrala-Gunnaur, Sambhal (U.P.)",
  "Varun Arjun School of Nursing",
  "M K D GIRLS DEGREE COLLEGE GOPALPUR BHITARI KERAKAT JAUNPUR    ",
  "MAA SHARDA  NURSING AND PARAMEDICAL COLLEGE VILL CHIKHARI POST HARRINGTANGANJ DIST AYODHYA",
  "GOVERNMENT DEGREE COLLEGE GAHMAR GHAZIPUR     ",
  "KAKA NAVRANG LAL CHUTTAN LAL LAW COLLEGE, BULANDSHAHR    ",
  "BABA VISHWANATH COLLEGE OF LAW LUTFABAD BACHHAULI BIKAPUR AYODHYA    ",
  "CHAUDHARY COLLEGE OF PHARMACY",
  "RAJKIYA MAHILA MAHAVIDYALAYA , MUSAFIRKHANA , AMETHI",
  "PHULPATTI BRIJBHUSHAN MAHILA MAHAVIDYALAYA, PATKHAULI, SADAR, PRATAPGARH    ",
  "MAA BHAGWATI COLLEGE OF PHARMACY",
  "M G B RAJAT COLLEGE OF PHARMACY AND MANAGEMENT",
  "PURNODAYA MAHILA MAHAVIDYALAYA BACHCHHAW VARANASI",
  "SRI SAI R R INSTITUTE OF PHARMACY, ALIGARH",
  "VIMLA NURSING COLLEGE",
  "JOKHULAL PIYARI DEVI MAHAVIDYALAYA NEWARIYA BHETEWARA KALANA MIRZAPUR",
  "VIRENDRA NATH SHUKLA INSTITUTE OF EDUCATION & TECHNOLOGY, SHUKULPUR, SANGIPUR, PRATAPGARH",
  "RAJKIYA MAHAVIDYALAYA, RAMKOLA, KUSHINAGAR",
  "Dental College Azamgarh",
  "GAURI SHANKER KANYA MAHAVIDYALAYA  BULANDSHAHR",
  "A P SINGH VIDHI MAHAVIDYALAYA    ",
  "DR H R BACHCHAN COLLEGE OF PHARMACY UNNAO",
  "S.N. Singh Institute of Engineering And Technology,  Jakhaniya, Ghazipur ",
  "NIRMALA INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "Meerut Institute of Technology (Professional Courses)",
  "MAA GANGA COLLEGE OF EDUCATION",
  "GAUTAM SHRI SHOBHA MAHAVIDYALAYA, DAULATABAD SADAR AZAMGARH",
  "SHARDA DEVI MAHAVIDYALAY GRAM KADAREPUR BADALAPUR JAUNPUR",
  "RASHTRAKAVI MAITHILI SHARAN GUPT COLLEGE OF EDUCATION",
  "FACULTY OF PHARMACY",
  "SWARGIYA VANSHA NARAYAN SINGH MAHILA MAHAVIDYALAY, GAUR, MIRZAMURAD, VARANASI",
  "SW PT SHREE BRAHMANAND DUBEY RAMNARAYAN SHASTRI MAHAVIDYALAYA, BIJNA, TAHRAULI, JHANSI",
  "SANT SHIROMANI KABIR SAHEB MAHAVIDHYALAYA, BAMHORI SUHAGI, RANIPUR, JHANSI",
  "SWAMI VIVEKANAND MAHAVIDYALAYA,DUGARA, JHANSI",
  "Malti Mahila Mahavidyalaya, Saadatpur, Jangipur, Ghazipur",
  "ATAL BIHARI VAJPEYI NAGAR NIGAM DEGREE COLLEGE, ISMAILGANJ SURENDRA NAGAR LUCKNOW",
  "SANSKRITI INSTITUTE OF ADVANCE STUDIES, GHAZIABAD",
  "BABU PT. RAMESHWAR PRASAD DWIVEDI MAHAVIDYALAYA, JARIA, RAEBARELI",
  "SAVITRI MAHILA DEGREE COLLEGE, TAKPURA, DARSHAN NAGAR, FAIZABAD",
  "SATYADEV NURSING AND PARAMEDICAL COLLEGE    ",
  "INSTITUTE OF AYUSH MEDICAL SCIENCES",
  "S D COLLEGE OF NURSING    ",
  "RADHA GOVIND INSTITUTE OF NURSING SCIENCES MEERUT",
  "JAMIA URDU COLLEGE OF LAW JAMIA URDU MEDICAL ROAD ALIGARH",
  "SULTANPUR INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "Bhulloo Mahavidyalaya, Gadaipur, Ghazipur",
  "SRS AYURVEDIC MEDICAL COLLEGE AND HOSPITAL ",
  "KAVINDRA NARAYAN LAW COLLEGE    ",
  "SRI SATYAPAL SINGH MAHAVIDYALAYA, NAVADA INDEYPUR, SPN",
  "Surya Kiran Institute of Technology, Ganora Shakeh, Bulandshahr",
  "Sheik ul Hind Maulana Mehmood Hasan Medical College Saharanpur",
  "BORA INSTITUTE OF ALLIED HEALTH SCIENCES LUCKNOW",
  "Shambhu Dayal PG College Ghaziabad",
  "DAYANAND VIDHYAPEETH EDUCATIONAL INSTITUTE",
  "Major Angad Singh Mahavidhyalaya ,Rustampur Barauli, Mainpuri",
  "LB COLEEGE OF NURSING AND PARAMEDICAL SCIENCE    ",
  "GANDHI MEDICAL COLLEGE AMBABAI JHANSI    ",
  "JAMIYA TIBBIYA COLLEGE, DEOBAND,",
  "Heeralal Law College, Benti, Lucknow",
  "SHAHEED BHAGAT SINGH COLLEGE OF EDUCATION, DANGROLL,SHAMLI",
  "Shri Roopram Institute of Law",
  "SHRI SAI COLLEGE, GADARHERI, SARSAWA NAKUR ROAD",
  "Ch Nepal Singh Mahavidhalyay Dugchada Saharanpur",
  "DOON HILLS INSTITUTE OF MANAGEMENT AND TECHNOLOGY DEOBAND SAHARANPUR",
  "CH. VIRENDRA SINGH DEGREE COLLEGE SALARPURA, GANGOH, SAHARANPUR",
  "SHEKH MISTER MIYAN MOHD UMAR DEGREE COLLEGE     ",
  "GYANDEEP LAW COLLEGE    ",
  "BABA CHANDRABHUSHAN YATI UDAYNATH JAN KALYAN BALIKA MAHAVIDYALAYA SHIKSHAN PRASHIKSHAN SANSTHAN     ",
  "GOVERNMENT AYURVEDIC COLLEGE AND HOSPITAL ATARRA    ",
  "JAI PRAKASH MEMORIAL LAW COLLEGE    ",
  "S.M.S COLLEGE NAGRIYA MOD G.T. ROAD ETAH",
  "MAA SIYA DEVI COLLEGE, SIYA VIHAR, AGRA ROAD, JALESAR, ETAH",
  "BABU UDREJ SHIKSHAN SANSTHAN, BAJHA, MAHRAJGANJ, JAUNPUR",
  "PURUSHOTTAM MAHAVIDYALAYA, RANVEENPUR, MAU",
  "MUZAFFARNAGAR INSTITUTE OF TECHNOLOGY ROORKEE ROAD, MUZAFFARNAGAR",
  "RADHIKA KRISHNA MURARI MAHAVIDYALAY, JAMEEN HARKHORI (DHANCHULA), AZAMGARH",
  "FACULTY OF PHARMACY F S UNIVERSITY    ",
  "MAA KISHUN DEVI GIRLS DEGREE COLLEGE, MUTURJIPUR, DHUWARJUN, GHAZIPUR    ",
  "FS PHARMACY COLLEGE    ",
  "URMILA MAHILA MAHAVIDYALAY    ",
  "Krishna College of Education",
  "INSTITUTE OF MANAGEMENT STUDIES K.NO. 320, VILL-MUSHTHAM SAHARANPUR",
  "MATA SHANTI SHIKSHAN SANSTHAN KHUSHANAMPUR DARIYAPUR NEWADA LALGANJ AZAMGARH    ",
  "D K D L LAW COLLEGE KAJU KAUSHAMBI    ",
  "BUDDHA LAW COLLEGE    ",
  "CHANDPUR DEGREE COLLEGE OF LAW    ",
  "Bharti Bhawan Sanskrit Mahavidyalaya, Saraiya Raje Sultanpur",
  "MIT COLLEGE OF LAW AND JUSTICE    ",
  "Institute of Pharmacy, Harish Chandra P.G. College, Varanasi",
  "OM INDU DEVI MAHAVIDYALAYA, DIHWA, NAGRA, BALLIA",
  "SUN PHARMACY COLLEGE BADHUNA FATEHGANJ JAUNPUR",
  "FACULTY OF ENGINEERING SHANTI NIKETAN TRUST'S GROUP OF INSTITUTIONS,MEERUT",
  "Amawash Chaurasia Mahavidyalaya, Kubernath, Kushinagar",
  "LLOYD SCHOOL OF MANAGEMENT STUDIES",
  "SHRI VIDYA MAURYA LAW COLLEGE ",
  "LUCKNOW COLLEGE OF MANAGEMENT AND EDUCATION",
  "KANUJI LAL MAHAVIDHYALAYA ",
  "Shri Vindhyeswari Sanskrit Mahavidyalaya, Walterganj, Bhiura",
  "Sushila Devi Hemchandra Adarsh Mahila Mahavidyalaya Hathpakad Ambedkarnagar",
  "HAYAT UNANI MEDICAL COLLEGE AND RESEARCH CENTRE",
  "B.M DEGREE COLLEGE",
  "ANTARRASHTRIYA BOUDH SHODH SANSTHAN , LUCKNOW",
  "SANT KABIR RASHTRIYA MAHAVIDYALAYA, HALLIA, MIRZAPUR",
  "SALASAR INSTITUTE OF EDUCATION DAYAL BAGH, AGRA",
  "RANWAT SINGH COLLEGE OF EDUCATION, RAHATIKAR PRATAPGARH ",
  "SW. BADAN SINGH KUSHWAHA KANYA MAHAVIDYALAYA, GHATAMPUR,",
  "SW. BADAN SINGH KUSHWAHA MAHAVIDYALAYA, KOTRA MAKRANDPUR,",
  "SHRI KASHI CHANDRA DEV YADAV PHARMACY COLLEGE, HAZIPUR BAMHAUR AZAMGARH",
  "VEDANTA SCHOOL OF NURSING AND PARAMEDICAL SCIENCE",
  "PRABUDDH MAHAVIDYALAYA,HARDOI",
  "TIKAIT H B S G MAHAVIDYALAYA, RAEBARELI",
  "DR B N K D MAHAVIDYALAYA, BAGHAULI",
  "P P S PHARMACY COLLEGE",
  "SRI JAGANNATH PRASAD MAHAVIDHYALAYA,BAGDAD,MALLAWAN",
  "SRI KRISHNA VERMA MAHAVIDYALAYA, BHAWANI KHEDA,",
  "CHAUDHARY SOHAN LAL MAHAVIDYALAYA, SAMHO,BHARTANA",
  "NEPAL SINGH MAHAVIDYALAYA, KAZI KAMALPUR,",
  "MANU DEGREE COLLEGE, LAKHIMPUR KHERI",
  "S.S. MAHAVIDYALAYA, RUDA MAU, MADHAVGANJ,",
  "SRI RADHA RANI MAHAVIDYALAYA JULAHPUR SIKANDRA ROAD MAHAMAYA NAGAR",
  "LORD KRISHNA INSTITUTE FOR EDUCATION ATAULLAHPUR, SAHARANPUR   Ph. 0132-3250492, 9412424467, 9897709177,",
  "DR RAM NARESH MAHAVIDYALAYA, CHANGAIPUR JIYANPUR AZAMGARH",
  "Shri Shivprassan Sanskrit Mahavidyalaya, Sathi Baveru",
  "SARTHAK INSTITUTE OF MEDICAL SCIENCE",
  "SRI SHIVDAYAL PAL MAHAVIDYALAYA, SEMRA CHAURAHA,",
  "GIRJA DAYAL RAJENDRA BAJPAI MAHAVIDALAYA",
  "NEPAL SINGH MAHAVIDYALAYA, TOWN AREA, HARGAON,",
  "MAA CHANDRAVATI MAHAVIDYALAY SEMRA CHUNAR MIRZAPUR",
  "BABA KADHERA SINGH DEGREE COLLEGE, AKKHA, SONKH",
  "PACHKARIYA DEVI SHIV NARAIN DEGREE COLLEGE, MAHITHA",
  "DR RAM MANOHAR LOHIA INSTITUTE OF MEDICAL SCIENCES, VIBHUTI KHAND, GOMTI NAGAR, LUCKNOW",
  "SURENDRA SINGH GHANSHYAM SINGH BALIKA MAHAVIDYALAYA,  SANTNAGAR, NAUGAWA",
  "RANA BENI MADHAV DEGREE COLLEGE, SEMAUR",
  "Harish Chandra Post Graduate College, Varanasi",
  "NK COLLEGE, KUSMARA ROAD, MAINPURI",
  "SAINIK PHARMACY COLLEGE",
  "SAKSHI COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "MAA BHAGWATI COLLEGE OF NURSING",
  "HIMS COLLEGE OF NURSING AND  PARAMEDICAL SCIENCES VARANASI",
  "SMT SANTOSH KUMARI PATHAK SMRITI MAHAVIDHYALAYA GOORA BARELA MIAUN BUDAUN",
  "Janbharti Mahavidyalaya, Diliya, Talwar, Ghazipur",
  "A N A COLLEGE OF MEDICAL SCIENCES AND HOSPITAL AGRAS ROAD BAREILLY",
  "DEEPMALA COLLEGE OF NURSING, BAREILLY",
  "COLLEGE OF NURSING, GMC, AZAMGARH",
  "INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "HEISENBERG GIRLS INSTITUTE OF ADVANCE STUDIES BHADOHI ROAD SHIVPUR MARIAHU JAUNPUR",
  "KR. DEVENDRA PAL SINGH MEMORIAL DEGREE COLLEGE NAGLA UDI,ETAH",
  "JANTA DEGREE COLLEGE PARSON",
  "Dr. Girish Chandra Rama Mahavidhiyalaya Agra Road Awagarh",
  "AL- BARKAAT INSTITUTE OF EDUCATION , ANOOP SHAHAR ROAD, ALIGARH",
  "SRI RAJVEER SINGH MEMORIAL DEGREE COLLEGE, KASHIRAM NAGAR",
  "AASHUTOSH INSTITUTE OF MANAGEMENT SCIENCE AND RESEARCH",
  "SW. DAYA SHANKAR PATEL MAHAVIDYALAYA, GAZIPUR, MAHOLI,",
  "Eras Lucknow Medical COllege and Hospital",
  "LALITA COLLEGE OF EDUCATION",
  "JAHANGIRABAD INSTITUTE OF TECHNOLOGY FACULTY OF PHARMACY",
  "SMT BUTUBAI MAHAVIDYALAYA ATARRA BANDA",
  "INDU INSTITUTE OF EDUCATION ",
  "APS DIGREE COLLEGE Sonughat Deoria",
  "Ingraham Institute Girls Degree College Ghaziabad ",
  "M P SINGH SMARAK VIDHI MAHAVIDYALAYA PANCHPUTI JAGTAPUR MANKAPUR GONDA",
  "SHREE RAM AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "RAJKIYA MAHILA MAHAVIDYALAYA, SHEIKH SARAI, SITAPUR",
  "SHRI BABU SINGH JAY SINGH NURSING AND PARAMEDICAL COLLEGE",
  "Shri Ram Mahavidyalaya Hansari",
  "Kanpur Institute of Higher Education",
  "BALRAM MAHAVIDYALAYA MANIHARI GHAZIPUR",
  "BRINDRAWAN LAL JAIN RAMSAHAY RAWAT EDUCATIONAL COLLEGE GAUNA LALITPUR",
  "PT SRIRAM PARTAP SHUKLA  MAHILA MAHAVIDHYAL KANJASH MUSAFIRKHANA AMETHI",
  " AMROHA COLLEGE OF LAW",
  "LT. ANIRUDH SHUKLA MAHAVIDYALAYA, FATEHPUR, BARABANKI",
  "Shri Ramdev Sanskrit Mahavidyalaya, Baderi",
  "Shri Nigamagam Sanskrit Mahavidyalaya, Ganj",
  "Shri Krishna Bhooshan Ved Vedang  Sanskrit Mahavidyalaya,Vagarmau",
  "Acharya Badrinath Shukla Smarak Sanskrit Mahavidyalaya, Dumariya Bujurg",
  "GMS COLLEGE OF PHARMACY ",
  "RANI NILIMA KUMARI MAHILA MAHAVIDYALAYA, DHARUPUR, PRATAPGARH",
  "Shatabdi Law College",
  "Savita Devi Girls College",
  "KUNWAR MAHAVIDYALAYA, VILL MAHAVATPUR, JATPURA, BIJNOR",
  "Dharam Institute of Technology",
  "AVIRAJ COLLEGE OF EDUCATION AND TECHNOLOGY",
  "A.P. DEGREE COLLEGE UNCHAGAON",
  "Rajesh Yadav Mahavidyalaya, Bataubeer, Thakurganj, Jaunpur",
  "VIVEK COLLEGE OF MANAGEMENT AND TECHNOLOGY, BIJNORE",
  "Krishna Institute of Education Girls, Hapur",
  "SHAHID BANDHU SINGH DEGREE COLLEGE",
  "Shri Sain Nath Shikshan Prashikshan Sansthan  Ishipur Maharani Paschim Lambhua Sultanpur ",
  "RAMPATI BALBHADRA PRASAD SHUKLA VIDYALAY MILKIPUR AYODHYA",
  "Bhagwan Aadinath college of Pharmacy",
  "TEJAS INSTITUTE OF EDUCATION AND TRAINING ",
  "LAL BAHADUR SINGH SHIKSHAN EVAM PRASHIKSHAN SANSTHAN",
  "Shri Rawatpura Sarkar College",
  "Amar Bahadur Singh Shikshan Prashikshan Sansthan",
  "HANUMAT KRIPA MAHAVIDHYALYA, RORA, MAURANIPUR, JHANSI",
  "MEERUT NURSING COLLEGE",
  "SONIA KIRAN PRASHIKSHAN KENDRA RAMPUR DUBEY",
  "ADARSH SANSKRIT MAHAVIDYALYA",
  "Dwarika Prasad Sinha Mahila Mahavidyalaya, Ballia",
  "Duja Devi Mahavidyalaya, Sahatwar, Ballia",
  "D.S.Man Malti Devi Mahavidyalaya, Ballia",
  "COLLEGE OF PHARMACY JSS ACADEMY OF TECHNICAL EDUCATION",
  "Dr. Ram Manohar Lohia Subedar Mahavidyalaya, Habsapur, Ballia",
  "LAKHMI CHAND PATWARI COLLEGE OF PHARMACY",
  "HARKALI DEVI GIRLS MAHAVIDYALAYA",
  "R G COLLEGE OF PHARMACY",
  "SUYASH INSTITUTE OF PHARMACY",
  "KRITIKA PHARMACY COLLEGE",
  "ABESIT COLLEGE OF PHARMACY, GHAZIABAD",
  "DR PREM PRAKASH YADAV MAHAVIDHYALAYA ",
  "Sri Gyan Mati Umashankar Singh Mahila Mahavidyalya",
  "MOTI KALPATI MAHAVIDYALAYA PAKADI BUJURG DEORIA",
  "SAI SAVITRI MEMORIAL MAHAVIDYALAYA",
  "S N ANCHAL INSTITUTE OF HIGHER EDUCATION ",
  "MOON DEGREE COLLEGE",
  "SHIV SHANKAR SINGH SMARAK MAHAVIDYALAYA KARIMPUR RUDAULI FAIZABAD ",
  "MAA BACHCHI SMARAK MAHAVIDYALAYA",
  "DR RAM MANOHAR LOHIA BALIKA MAHAVIDYALAYA TARAPUR KANDAI BIHAR KUNDA  PRATAPGARH",
  "CHAVIRAJI URMILA DEVI SHAIKSHIK SANSTHAN SHUKULPUR SANGIPUR",
  "BEERENDRA BAHADUR MAHILA MAHAVIDYALAYA BEEND MUZAHI BAZAR PATTI PRATAPGARH",
  "MAHAMAYA RAJKIYA ALLOPATHIC MEDICAL COLLEGE",
  "RAM CHHATRA SINGH MAHAVIDYALAYA, KERAWANIYA, SHIVPURA",
  "RAMSHRI MAHAVIDYALAYA JAJAULI MAKKHANPUR FIROZABAD",
  "S.S.MEMORIAL MAHAVIDYALAYA USAINI",
  "RANI AVANTIBAI LODHI INSTITUTE OF HIGHER EDUCATION",
  "CH. NIHAL SINGH DEGREE COLLEGE NAGLA BALLU DHEERPURA TUNDLA FIROZABAD",
  "MAA SARASWATI DEGREE COLLEGE ASBARANPUR TRILOCHAN MAHADEV JAUNPUR",
  "MAHENDRA SINGH MAHAVIDHYALAYA,TALBEHAT",
  "KBM DEGREE COLLEGE ",
  "MAHARSHI GAUTAM ACADEMY GIRLS DEGREE COLLEGE",
  "Dr. Ram Manohar Lohia Mahavidyalaya, Malibari, Shahpur, Deoria",
  "Krishna Sudama Sansthan, Sadat, Ghazipur",
  "K V S Sansthan Baksupur",
  "DEVANSHI GIRLS COLLEGE OF EDUCATION",
  "AMEER HASAN FARUQI MASOODYA MUBARKA DEGREE COLLEGE, IMAMGANJ ROAD, NANPARA",
  "RAJA BHAIYA MEMORIAL MAHILA MAHAVIDYALAYA, VANSHPURWA MAHSI",
  "NATIONAL MAHILA MAHAVIDYALA, REHRA BAZAR",
  "Maa Kalawati Mahavidyalaya",
  "A.P. SINGH DEGREE COLLEGE, MAHARAJPUR HATHIGAWAN",
  "RAJA AWADH MAHAVIDYALAY",
  "Rakesh College of a Educational Group",
  "DEEP NARAYAN SINGH DEGREE COLLEGE ",
  "Mangal Sanskrit Mahavidyalaya",
  "Shri Sarvahit Karini Sanskrit Mahavidyalaya",
  "TUNGNATH MAURYA SHAMARAK MAHAVIDYAAYA, SHRAYAHARRA, KATRA TARABGANJ",
  "KEDAR NATH EDUCATIONAL INSTITUTE",
  "Bihari Sanskrit Mahavidyalaya, Chandpur",
  "Baba Raghunandan Daas Sanskrit Mahavidyalaya",
  "Shri Parashar Brahmcharyashram Sanskrit Mahavidyalaya",
  "Shri Bhagirathi Sanskrit Mahavidyalaya",
  "SHIV OM NAKCHHED TIWARI SHIKSHAN PRASHIKSHAN SANSTHAN, SANT NAGAR",
  "SHRI HARI OM PRAKASH TIWARI BALIKA SHIKSHAN PRASHIKSHAN SANSTHAN, SANT NAGAR MOHLI",
  "DR. PUSHPENDRA SINGH SMARAK MAHAVIDYALAYA",
  "MEENA SHAH INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "Career Post Graduate Institute of Dental Sciences and Hospitals",
  "Sardar Patel Post Graduate Institute of Dental and Medical Sciences",
  "RAM BUKSH SINGH SMARAK MAHAVIDYALAYA",
  "Thakur Satya Narayan Chandra Pratap Singh Mahvidyalya ",
  "Career Institute of Medical Sciences and Hospital",
  "JAGAT NARAYAN MAHAVIDHYALAYA, ARUSA NARAYANPUR",
  "BINDESHWARI P G COLLEGE, BARDHABHIURA, DOSTPUR ROAD, AKBARPUR",
  "SHRIPATI SINGH MAHAVIDYALAYA, BHARATHNAGAR PURA BAZAR",
  "LATE SMT RASKENDRI DEVI MAHAVIDYALAYA, UMARI",
  "SRI PARAMHANS GIRLS DEGREE COLLEGE, VIDYAKUND, AYODHYA",
  "JNS KASHMIRI GIRLS DEGREE COLLEGE",
  "GRAMBANDHU MAHAVIDYALAYA, SHAHBABAD GRANT, HAINRIGTANGANJ, AYODHYA",
  "RAJKIYA MAHAVIDYALAYA JAKHORA LALITPUR",
  "APOLLO INSTITUTE OF PROFESSIONAL STUDIES, KANPUR",
  "Mishrilal Sheetal Prasad Sarvodaya Mahavidyalaya, Neochana ",
  "Baba Biharilal Girls Educational Institute, Amadarveshpur",
  "Kedar Nath Singh Memorial Trust Institute of Teachers Training, Karaundia",
  "MODERN COLLEGE OF PROFESSIONAL STUDIES,ANAND INDUSTRIAL AREA, MOHAN NAGAR,GHAZIABAD",
  "DHARMENDRA SINGH MEMORIAL COLLEGE, ATOLA",
  "Kamla Nehru Vidhi Sansthan, Faridipur",
  "Dr. Rajendra Prasad Mahavidyalaya ",
  "SHRI RAM SHYAM MAHAVIDHYALAY, TIKRI BUJURG",
  "SARFARAZ DEGREE COLLEGE",
  "SARDAR PATEL M S D MAHAVIDYALAYA MIRCHWARA LALITPUR",
  "SARASHWATI VIDYAPEETH MAHILA MAHAVIDYALAYA RAGAUL MAUDAHA",
  "SANT SWAMI BRAHMANAND MAHAVIDHYALYA JAKHAURA LALITPUR",
  "RAJKUMAR SINGH MAHAVIDHYALAYA, ARTHARA, BABERU",
  "KUNWAR HARPAL SINGH CHANDEL MAHAVIDYALAYA MAHRONI LALITPUR",
  "JAWAHAR VIJAY SINGH MAHAVIDYALAYA, NASIRPUR ",
  "SHREE JAICHANDRA SINGH MAHAVIDYALAYA EVAM ADHYAPAN PRASHIKSHAN SANSTHAN, KARVI",
  "Bundelkhand Navodaya Mahavidyalaya, Srinagar ",
  "HIMANSHU VIKRAM SINGH INSTITUTE OF TEACHING AND TRAINING",
  "KESHAV MADHAV VIDHI SHIKSHAN SANSTHAN",
  "MUNNI DEVI MAHAVIDYALYA, BELA ROAD,RASOOLABAD",
  "Bhabhuti Prasad Smarak Mahavidyalaya, Dhara Road",
  "P D PANDEY RAJPATI MAHAVIDYALAYA, ANJANA",
  "BABA SUKHDEV SMARAK MAHAVIDYALAYA, NARIYAW GALARAHA",
  "SHANTI DEVI SUBHASH CHANDRA SUSHANT DEGREE COLLEGE, SUBHASHNAGAR, CHAKUJOT",
  "Meghnath Singh Shishodia Institute of Education and Technology dhaulana hapur",
  "Ram Newaj Singh Shikshan Prashikshan Mahila Mahavidyalaya, Bawan, Kumarganj",
  "CHHANGUR SINGH MAHAVIDYALAYA, UMARI, BEGHUMGANJ, PURE SURYAVANSH",
  "SRI VEERENDRA NATH SINGH SMARAK MAHAVIDYALAYA, THAURI, AMETHI",
  "RANI LAKSHMIBAI SMARAK MAHILA MAHAVIDYALAYA, KUREBHAR",
  "Babu Gulab Singh Mahavidyalaya, Powa, Banakata",
  "Gajpal Singh Patel Degree College",
  "Sri BalaJi Shaikshik Sansthan Upadhyaypur Atheha",
  "S.K. Degree College",
  "S.K. Mahavidyalaya",
  "DELHI COLLEGE OF MANAGEMENT, MEERUT",
  "RUDAULI EDUCATIONAL INSTITUTE, SARAIPEER, BHELSAR",
  "BUNDELKHAND NOVODAYA MAHAVIDYALAYA, PACHPAHRA",
  "Chandrasekahar Pandey Mahavidyalaya, Babruiha, Kaundha, Bikapur",
  "BABA BAIJNATH DR. RAMDEV BHAGWATI SINGH, SIKSHAN PRASHIKSHAN MAHAVIDYALAY, SARY DHANETHI",
  "krishna institute o LAW, Hapur",
  "GAYA PRASAD PANDEY MAHAVIDYALAY",
  "Kisan Vidhi Mahavidyalaya Mudiyari Ghazipur",
  "Maa Daulati College of Education Brindavan Ghazipur",
  "TEERTHANKER PARSHVNATH SCHOOL OF NURSING",
  "DR RAM MANOHAR LOHIYA MAHAVIDYALAYA, KARTAL",
  "HAJJAN SADIKA BEGUM MAHAVIDYALAYA BURGAIR,KANSHI RAM NAGAR",
  "Dashrath Sansthan, Hariharpur (Kanri), Ghazipur",
  "SMT PADMA MATITARI MAHAVIDYALAYA SHIKSHA EVAM SOODH SANSTHAN GOGMAU JAMON AMETHI",
  "Aditya Dixit Girls Degree College, Odasan, Ghazipur",
  "Shri Ram Surat Mahavidyalya, Bhoda Madiyahu Jaunpur",
  "MADHAV MAHAVIDYALAYA, ATARRA",
  "B N Singh Memorial Technical Institute",
  "RAM GULAM RAI SHIKSHAN PRASHIKASHAN MAHAVIDYALAYA",
  "CITY COLLEGE",
  "M D K P COLLEGE OF LAW MAKANPUR BARABANKI UP",
  "SANKAT MOCHAN SHIKSHAN PRASHIKSHAN SANSTHAN MAHILA MAHAVIDYALAYA",
  "SHRI RAM MAHAVIDYALAYA, BANGRA",
  "PT. OMKAR NARAYAN PRAKASH NARAYAN MISHRA MAHAVIDYALAYA, SIRSA KALAR",
  "LATE RAMDUTT DWIVEDI MAHAVIDYALAYA, RAMPURA",
  "RAMWATI RAJBAHADUR LAW COLLEGE, PRATHVIPUR",
  "OMSHANTI COLLEGE OF LAW, ANJANI MAINPURI",
  "GN Womans Educational Institute, Salamatpur",
  "Lalita Mahavidyalaya, Narauli",
  "Dhaneshwar Yadav Mahila Mahavidyalaya, Mokalpur Newada, Jaunpur",
  "Aadarsh Nanhkoo Ram Mahavidyalaya, Ramgarh, Barawan, Jaunpur",
  "MP Girls Sansthan, Saidpur",
  "Maa Gomti Balika Mahavidyalaya, Jakhaniya",
  "Shri Ramlakhan Singh Sikshan Sansthan Nakahara, Khandev, Jaunpur",
  "Tetri Devi Mahavidyalaya, Sarai Gokul, Ghazipur",
  "Gurukul Patanjali Vidyapeeth, Rampur, Deoaria, Ghazipur",
  "Jiut Das Girls College, Sadat Ghazipur",
  "D A V Collage Maudha, Ghazipur",
  "D A V Sansthan Nayanpur Patrahi, Jaunpur",
  "Mata Bhagyamani Devi Mahila Degree College, Sahedi",
  "YOGESHWAR CHANDRIKA SARDAR PATEL MAHAVIDYALYA ",
  "RAJENDRA PRASAD TRIPATHI MAHAVIDYALAYA",
  "Ram Saran Degree College, Mardanpur",
  "Chaudhary Mahadev Singh Mahavidyalaya",
  "Moti Singh Mahavidhalaya",
  "R.R.S.MAHILA MAHAVDYALAY, LALPUR, JAUGAR",
  "Ramsurat Shivmurti Mahavidyalaya, Mahmudpur, Hathini , Ghazipur",
  "BABA KASHI VISVANATH MAHAVIDYALAYA, BHURKURA BABURI CHAKIYA ",
  "SUBHASH CHANDRA MAHAVIDYALAYA, CHAKARAMA ",
  "Ran Bahadur Manik Raji Mahavidyalaya, Gothav Jaunpur",
  "S. R. COLLEGE OF TEACHER EDUCATION",
  "VILLAGE BALIKA MAHAVIDYALAYA, RAJGARH, JHANSI",
  "VIMLA DEVI HARIHAR SINGH SMARAK MAHILA MAHAVIDYALAYA ",
  "Pt. Ramswaroop Dwivedi Mahavidyalaya ,Karanda, Ghazipur",
  "Baba Hajari Singh Memorial Balika Degree college, jakhaniya, Ghazipur",
  "HADIYA BABA POST GRADUATE COLLEGE, KASHAAI",
  "RAMESHWAR PRASAD VIDHI MAHAVIDYALAYA, PACHNEHI",
  "BHAGWATI PRASAD MAHAVIDYALAYA, TOLIKALAN, BABERU",
  "SHIVMOHAN SINGH RAMAUTAR MAHAVIDYALAYA MURVAL",
  "SAMRAT PRITHVIRAJ CHAUHAN COLLEGE OF LAW AND TECHNOLOGY",
  "RAM SEWAK SHIVHARE DEGREE COLLEGE, PACHNEHI",
  "GOVERNMENT COLLEGE JEWAR",
  "PARVATI MAHILA MAHAVIDYALAYA, BARUA SYODA, NARAINI",
  "HEERA SINGH YADAV MAHAVIDYALAYA, GORARI, VIKRAMPUR, GHAZIPUR",
  "SHRI MANGALAM COLLEGE OF LAW AND MANAGEMENT NOIDA",
  "MOTILAL MAHAVIDYALAYA, SAIDPUR, GHAZIPUR",
  "CH ATAR SINGH COLLEGE OF EDUCATION",
  "CHAUDHARI HARDWARILAL MAHAVIDYALAYA, KOSMA MUSALMEEN, MAINPURI",
  "MAUNI BABA DHARMANAND SARASWATI MAHARAJ MAHAVIDYALAYA, KOSMA MUSALMEEN, MAINNPURI",
  "MANDHATA SIKSHAN SANSTHAN MAHILA MAHAVIDHALAYA SIRSAGANJ",
  "ADVANCE COLLEGE OF EDUCATION",
  "BHAGIRATHI MAHILA MAHAVIDYALAY PRATAPPUR CHAMURKHA KATEHARI AMBEDKARNAGAR",
  "LATE PT BABU CHANDRA SHEKHAR RAM BHAROSE TIWARI MAHAVIDYALAYA, CHHIRIYA, SALEMPUR",
  "AMAR SINGH MEMORIAL DEGREE COLLEGE",
  "KANHJI SINGH MAHAVIDYALAYA",
  "GHUNA DEVI COLLEGE , KASOUNDER, DISTT, BALLIA",
  "R G COLLEGE OF NURSING AND PARAMEDICAL",
  "SOMDEV MAHAVIDYALAY",
  "T S MISRA MEDICAL COLLEGE AND HOSPITAL",
  "Shri Dinesh Chandra Geeta Mahavidyalaya, Baruwadih, Baikunthpur, Deoria",
  "PMT DEGREE COLLEGE MAJRUDDINPUR KHAJURAHAT BIKAPUR AYODHYA",
  "AASRA COLLEGE KARANPUR CHANDPUR BIJNOR",
  "DAYASHANKAR JAGDISH BAHADUR MAHILA MAHAVIDHYALAY, LOHANGI",
  "COLLEGE OF NURSING,LLRM, MEDICAL COLLEGE, MEERUT",
  "C.P. GAUTAM MAHILA MAHAVIDYALAYA, TENDUA KHURD, RAM NAGAR",
  "SWAR MAHILA MAHAVIDYALAYA SWAR",
  "BALDEV SHRIDHAR MAHAVIDALAYA,BHAVRAHA, PANDEYPUR, RADHE,GHAZIPUR",
  "SVD GURUKUL MAHAVIDYALAY DUMDUMA UNCHGAON",
  "THAKUR MATIVAR SINGH MAHAVIDYALAYA, PURAUTTAM, JAMALPUR",
  "M.J.K. DEGREE COLLEGE PILIBHIT",
  "OPTOMETRY RESEARCH AND TRAINING INSTITUTE",
  "MAA BHAGWATI MAHILA MAHAVIDYALAYA ",
  "R S SADGURU MAHAVIDYALAYA, JABARAPUR",
  "MAA VINDHYAVASINI INSTITUTE OF HIGHER EDUCATION MANEGEMENT and TECHONOLOGY MUSKIRA MARIHAN MIRZAPUR",
  "Smt JANKI DEVI RAJ KUMAR SINGH DEGREE COLLEGE",
  "PT. BETALAL LAXMI NARAIN MAHAVIDYALAYA",
  "PT. SHIVDATT PRASAD DWIVEDI MAHAVIDYALAYA",
  "SRI SHIVPADRAJ MAHAVIDYALAYA",
  "SRI SOBRAN SINGH MAHAVIDYALAYA",
  "SRI MAHENDRA SINGH KANYA MAHAVIDYALAYA",
  "CHANDRADEEP SINGH SMARAK MAHAVIDYALAY",
  "MAJOR S D SINGH MAHAVIDYALAYA, SAKWAI",
  "BALRAM SINGH INSTITUTE OF SCIENCE AND TECH.",
  "VIDYASHREE PARTH  MAHAVIDALAYA   CHATHIYA FAIJU FARIDPUR BAREILLY ",
  "MAJOR S.D.SINGH AGRL.AND  COMMERCE DEGREE COLLEGE",
  "CH. PANCHAM SINGH MAHAVIDYALAYA",
  "KRISHANA MAHAVIDYALAYA",
  "Chaudhary  Niyaz Muhammad Degree College ",
  "Umanath Singh Vidhi Mahavidyalay, Fareedpur, Jaunpur",
  "SAHAB SINGH DEGREE COLLEGE NANGLA KHEPPAR MUZAFFARNAGAR",
  "LTR INSTITUTE OF MANAGEMENT ",
  "BRAHMDEV SUSHILA MAHILA MAHAVIDYALAYA",
  "Almighty Girls Degree College, Brimanganj, Maharajganj",
  "Dwarika Prasad Yadav Mahavidyalaya,Mishramau,Sandi, Jaunpur",
  "MUKESH SINGH YADAV SMIRITI MAHAVIDYALAYA",
  "SHRI SHIVRAM RAMTIRTH SMARAK MAHAVIDYALAYA GADHA ASTHANA MILKIPUR AYODHYA",
  "Shri D. R. Mahila Mahavidyalaya, Maksudanpatti, Tari, Varanasi",
  "NIMT VIDHI EVAM KANOON SANSTHAN",
  "JAGANNATH SINGH KANYA MAHAVIDALAYA",
  "SRI VISHAMBHAR DAYAL MAHAVIDYALAYA, DABRAPUR",
  "R G MAHAVIDYALAYA, BAGHPUR",
  "JAMUNA PRASAD MEMORIAL COLLEGE, BHAIRPURA KHAJURIA BAREILLY",
  "SAROJNI DEVI RAMNATH AWASTHI M/V,UTMANPUR GONDARI",
  "MAA SIDDHESWARI MAHAVIDYALAYA, DWARIKA NAGAR",
  "SRI RAM BAHADUR PANDEY DEGREE COLLEGE",
  "SRI MOHAN PARA MEDICAL COLLEGE,MAHAMAYANAGAR",
  "KUSAGRA MAHILA MAHAVIDYALAYA, SIMARIYA",
  "S B DEGREE COLLEGE,G T ROAD",
  "SWAMI VIVEKANAND MAHAVIDYALAYA, UMARAN",
  "P R D MAHAVIDYALAYA, JAHANGIRABAD",
  "PT. DEEN DAYAL UPADHYAY RAJKIYA MAHILA SNATKOTTAR MAHAVIDYLAYA, E-BLOCK, RAJA JI PURAM",
  "AKBARI BEGUM COLLEGE OF EDUCATION",
  "GIRJESH COLLEGE OF EDUCATION",
  "KCC INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "KASTURI COLLEGE OF EDUCATION, VILLAGE NANU SARDHANA",
  "MOTHERHOOD INSTITUTE OF TECHNOLOGY, NANU SARDHANA",
  "BUNDELKHAND NOVODAYA MAHAVIDYALAYA, PANVARI",
  "MAA BHADRAKALI MAHAVIDYALAYA, KABRAI",
  "PARSHURAM MAHAVIDYALAYA, SIMRAWARI, JHANSI",
  "RAM LAKHAN PATEL MAHAVIDHYALYA, AIT",
  "Dinesh Adarsh Mahavidyalay, Devchandpur, Baari, Ghazipur",
  "Veer Shivaji Degree College, Sarhari, Gorakhpur",
  "GOVT. GIRLS P.G. COLLEGE",
  "GURU ROPAN SIKSHAN SANSTHAN, ORAI",
  "HARI SINGH ARYA MAHAVIDYALAYA, GADIYAGAON",
  "HIRANAND MAHAVIDYALAYA, VIVAR",
  "INDERPAL SINGH M.S.D. MAHAVIDHAYALAY, JHAKHLON",
  "JAGDISH SINGH YADAV NAND KISHOR MODI MAHAVIDYALAYA, GURSARAI",
  "JAI BUNDELKHAND MAHAVIDHYALAYA, KULPAHAD",
  "JAMUNA DEVI NARESH CHANDRA MAHAVIDHYALAYA, ORAI",
  "MAHARANI LAXMI BAI RAJKIYA PARAMEDICAL TRAINING COLLEGE JHANSI",
  "Maa Sadhana Degree College, Runkata, Agra",
  "ZILA PARISHAD AGRICULTURE COLLEGE",
  "KAILASHI DEVI SHRAVAN KUMARI MAHAVIDYALAYA ",
  "KALPI COLLEGE, KALPI",
  "KASHI PRASAD MAHAVIDHYALAYA, KUDHOUDA",
  "KEDARNATH RAMSWAROOP MAHAVIDYALAYA, KHATWARA",
  "KESHAV DEV TIWARI MAHAVIDYALAYA, GOHAN",
  "KISHORI LAL BACCHA LAL YADAV MAHAVIDYALAYA, SOMAI ",
  "KRISHANVALLABH SHRAVAN KUMAR MAHAVIDYALAYA,LAHARUA, CHHIRIYA",
  "LALA ALOPIDIN COLLEGE OF TEACHER EDUCATION, KUTAUNDA, RATH ROAD, ORAI",
  "JAI BAJARANG RAM SURAT MAHAVIDYALAYA, BHATAULI BASAULI, JAUNPUR",
  "SHYAMADEVI VISHRAM SINGH MAHAVIDHYALAYA MORCHA BAROUNA KALA AURAIYA",
  "LATE GAYA PARASAD MAHAVIDYALAYA, BHABHUA",
  "LATE KAMRUDDEEN MEMORIAL DEGREE COLLEGE, AKBARPUR SYONDHA",
  "LATE. BAHADUR SINGH MAHAVIDYALAYA, MADHAUGURH ",
  "SHYAMTA PRASAD CHAUDHARY MAHILA MAHAVIDYALAYA, KHARGAURA BASTI, KATRA, SHRAWASTI",
  "LAXMI CHARAN HUBB LAL MAHAVIDYALAYA, KARSAN",
  "LAXMI DEVI MAHAVIDYALAYA, MADARIPUR",
  "LATE. KAMTA PRASAD SHASTRI MAHAVIDYALAYA, BADAUSA",
  "SW PRAHLAD SINGH SMARAK MAHAVIDYALAYA, GAURI KALA, JASPURA",
  "SW SUNDER LAL SHIVHARE DEGREE COLLEGE, MAKRAV",
  "LATE WALI MOHD. ISLAMIA DEGREE COLLEGE, ORAI ",
  "MAA CHANDRIKA MAHILA MAHAVIDHYALAYA",
  "SMT  SHAKUNTALA DEVI KANYA MAHAVIDHYALAYA  ",
  "MADHU TANDON MAHILA MAHAVIDYALAYA, KALPI",
  "MAHAMATI PRAN NATH DEGREE COLLEGE, MAU",
  "MAHARSHI GAUTAM BUDDH MAHILA MAHAVIDYALAYA, BABERU",
  "SHRI RAM AUTAR VIDHI MAHAVIDHYALAYA BUJHAVA PAHADIPUR RASULABAD KANPUR DEHAT",
  "DR MAYA SHANKAR TRIPATHI VIDHI MAHAVIDYALAYA KARNAI CHHAWANI BASTI",
  "Indu Mahila Mahavidyalay Bhudsuri (Badhya), Ratanpura - Mau",
  "SHRI RAJENDAR SINGH COLLEGE OF PHARMACY",
  "KALAWATI DEVI MAHILA MAHAVIDYALAYA, KUSHINAGAR",
  "BRIJ BHUSHAN SINGH MAHILA MAHAVIDYALAYA, MAINPURI",
  "Raja Harpal Singh Mahavidyalaya, Singramau ,Jaunpur",
  "M. KANSHIRAM DEGREE COLLEGE, SIYA KHIRKA, BAMOUR",
  "MOTI BAI RAJARAM MAHAVIDYALAYA, GARAUTHA",
  "k k college Gokul mathura",
  "Chaudhary Ram Charitra Parameshwar Prasad Degree College, Mudadih, Basti",
  "GANGA DEVI KAPIL DEV TIWARI MAHAVIDYALAYA , BHUJAINI , SANT KABIR NAGAR",
  "MATHURA PRASAD MAHAVIDHALAYA, KONCH",
  "NEHRU MAHAVIDYALAYA LALITPUR",
  "PAHALVAN GURUDEEN MAHILA MAHAVIDYALAYA, PANARI",
  "PHUNDI SINGH LAUNA GOVT. DEGREE COLLEGE",
  "NAVEEN MAHAVIDYALAYA, SARAIYA",
  "PT GANGADHAR PANDEY SHRAVAN KUMAR MAHAVIDYALAYA, KUTHOUND",
  "PT. JAWAHAR LAL NEHRU MAHAVIDYALAYA",
  "PT. KEDARNATH RAJARAM MAHAVIDYALAYA, KAMASIN",
  "NARAINA MEDICAL COLLEGE AND RESEARCH CENTRE",
  "BALWANTI DEVI REHABILITATION INSTITUTE",
  "PT. PARASHURAM DWIVEDI MAHAVIDYALAYA, JAGAMMANPUR ",
  "AMAR SHAHEED JODHA SINGH ATAIYA THAKUR DARIAO SINGH MEDICAL COLLEGE",
  "RAJENDRA  PRASAD TARA CHAND MAHAVIDYALAYA, NICHLAUL, MAHARAJGANJ",
  "PT RAJARAM UPADYAYA MAHAVIDYALAYA, ROLLY",
  "CH. JAIVEER SINGH MAHILA SHIKSHAN SANSTHAN, KANNAUJ",
  "PT. VASHUDEV TIWARI COLLEGE OF EDUCATION",
  "MG EDUCATIONAL AND TRAINING COLLEGE SINDHORA DAGMAGPUR MIRZAPUR",
  "MOHAN COLLEGE OF LAW",
  "PT VASUDEV TIWARI KANYA MAHAVIDYALAYA,",
  "RAGHUVEER SINGH RAJKIYA MAHAVIDYALAYA, LALITPUR",
  "RAJADEVI DEGREE COLLEGE                ",
  "RAJEEV GANDHI D.A.V. DEGREE COLLEGE  ",
  "RAJJAN DEVI HEMANT KUMARI MAHAVIDYALAYA, GOHAN ",
  "RAMANATH VIMLA DEVI KHERA INSTITUTE OF EDUCATION ",
  "RAMRATI NAUBADA MEMORIAL MAHILA MAHAVIDYALAYA, KURARA",
  "RAM SHREE MAHAVIDYALAYA",
  "RAM SWARUP YADAV DEGREE COLLEGE, POONCHH                ",
  "RASHTRAKAVI MAITHALISHRAN GUPT MAHAVIDYALAYA, CHIRGAON",
  "ROSHAN SINGH BADAN SINGH GAYATRI MAHAVIDYALAYA, KABARAI",
  "SAI VIDHI MAHAVIDYALAYA",
  "SETH VIRENDER KUMAR MAHAVIDYALAYA, GUDHA NYAMATPUR",
  "SHAHEED SINGHRAN MAHAVIDYALAYA, PIROUNA",
  "SHARDA DEVI DEGREE COLLEGE, BIJOLI",
  "SHATABDI CENTRE FOR EDUCATION EXILENCE MAHAVIDYALAYA",
  "SHIV DARSHAN MAHAVIDYALAYA, TINDWARI",
  "SRI GURU HARKISHAN DEGREE COLLEGE",
  "SRI KISHOR GOSWAMI MAHAVIDHYALAYA, KULPAHAD",
  "RADHA KRISHNA MAHILA MAHAVIDYALAYA, HARSINGPUR MADARIPUR ",
  "SHRI RAMDHAM MAHAVIDYALAYA, ROUNI, MAURANIPUR, JHANSI",
  "SRI RAM KRISHNA MAHAVIDYALAYA, KURARA ",
  "K. S. COLLEGE, JAHAHNABAD",
  "SHRI SHIVPUJAN GOKUL MAHAVIDYALAYA, GHAZIPUR",
  "Shri Chandrabhan Singh Degree College Chandpur Gonapar Jaunpur",
  "SRI DEVI DAYAL RASTOGI DEGREE COLLEGE, SHAHABAD",
  "FIZA KAUSAR DEGREE COLLEGE, PIHANI,",
  "RAJESHWARI ANIL KUMAR MAHAVIDHYALAYA",
  "SRI RAM BAKSH SINGH DEGREE COLLEGE",
  "SRI RAM SWAROOP TIWARI JANTA MAHAVIDHYALAYA,KUKAHA,RAMPUR",
  "Ramlal Adarsh Mahavidyalaya",
  "Subhas Vidya Mandir Mahavidyalaya",
  "S R COLLEGE OF LAW",
  "Baba Dharmdev Balika Mahavidyalaya Maahpur Ghazipur",
  "Shivdhar Kisan Mahavidyalaya Harauli Ghazipur",
  "Shri Bhrigu Baba Mahila Mahavidyalaya Dhamupur Ghazipur",
  "Raja Ram Mahavidyalaya, Belauna Kala, Jaunpur",
  "Satiram Mahavidyalaya, Aalampatti, Ghazipur",
  "DEV VIDYASTHALI, DOBHI, KHETASARAI",
  "SARASWATI DENTAL COLLEGE & HOSPITAL",
  "Shri Narayan Daas Sanskrit Mahavidyalaya, Kaulesara, Ledayari",
  "S.N. MAHAVIDYALAYA BHOGAON, MAINPURI",
  "Bindeshwari Mahavidyalaya, Malap, Harshenpur, Ballia",
  "PRADUMAN SINGH SHIKSHAN PRASHIKSHAN SANSTHAN PHARMACY COLLEGE",
  "SHRI KRISHNA COLLEGE OF EDUCATION",
  "SRI BANKEY BIHARI JI EDUCATIONAL INSTITUTE GADI THANA  SAMSHABAD AGRA ",
  "VIDYA DEVI SHRI B.D. SOMANI ARYA MAHILA UCHCHA SHIKSHAN SANSTHAN, HABIBPURA, CHETGANJ, VARANASI",
  "MATA RAMRAJI DEVI MAHAVIDYALAYA",
  "BUNDELKHAND JANTA DEGREE COLLEGE",
  "Baba Ramcheej Mahila Mahavidyalaya ",
  "MAA URMILA DEVI MAHILA MAHAVIDYALAYA",
  "ARYAVART VIDHYAPEETH (MAHILA MAHAVIDHALYA), KISOLI, AGOUTA, BULANDSHAHR",
  "DAYANAND MAHAVIDYALYA SHERPUR NEWLA KARSANDA BARABANKI",
  "INDRA INSTITUTE OF PARAMEDICAL AND NURSING COLLEGE, KURAHUAN, AKHARI, VARANASI",
  "SETH VISHAMBHAR NATH INSTITUTE OF PHARMACY ",
  "ANAND COLLEGE OF PHARMACY, AGRA",
  "SHIV SHYAM MAHAVIDYALAYA, SHAHBAJPUR, HANUMANGANJ,",
  "MORADABAD EDUCATIONAL TRUST FACULTY OF ARCHITECTURE, MORADABAD",
  "SRM BUSINESS SCHOOL, LUCKNOW",
  "SHERWOOD COLLEGE OF MANAGEMENT, LUCKNOW",
  "SAROJ INSTITUTE OF TECHNOLOGY AND MANAGEMENT, LUCKNOW",
  "S R INSTITUTE OF MANAGEMENT AND TECHNOLOGY, LUCKNOW",
  "RAMESHWARAM INSTITUTE OF TECHNOLOGY AND MANAGEMENT, LUCKNOW",
  "R R INSTITUTE OF MODERN TECHNOLOGY, LUCKNOW",
  "MAHATMA GANDHI INSTITUTE OF PHARMACY, LUCKNOW",
  "MAHARANA INSTITUTE OF TECHNOLOGY AND SCIENCE, LUCKNOW",
  "INSTITUTE OF MANAGEMENT RESEARCH AND TECHNOLOGY, LUCKNOW",
  "INSTITUTE OF CO OPERATIVE AND CORPORATE MANAGEMENT RESEARCH AND TRAINING, LUCKNOW",
  "I I L M ACADEMY FOR HIGHER LEARNING, LUCKNOW",
  "HYGIA INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH, LUCKNOW",
  "HIMALAYAN INSTITUTE OF TECHNOLOGY AND MANAGEMENT, LUCKNOW",
  "SHRI GOVARDHAN MAHAVIDYALAY ",
  "DOODHNATH COLLEGE OF PHARMACY, SAKRAR, JHANSI",
  "SHRI RAMDAS MAHAVIDYALAY ",
  "RUSTAM DEGREE COLLEGE FIROZPUR BINDKI FATEHPUR",
  "CH.MANIRAM SHIV BALAK PATEL MAHAVIDYALYA ",
  "SHREE CHANDRABHAN SINGH MAHAVIDYALA ",
  "VISHWANATH SINGH MAHAVIDYALAYA",
  "ABHA YADAV SMARAK KANYA DEG. COLL. MEJA ROAD,",
  "ABHAY BALIKA MAHAVIDYALAYA, RANIPUR, HANDIA,",
  "ADARSH SHIKSHA MANDIR DEGREE COLLEGE, MASAULI, MANDA,",
  "BABU SUNDAR SINGH INSTITUTE OF TECHNOLOGY AND MANAGEMENT, LUCKNOW",
  "BABU BANARASI DAS NORTHERN INDIA INSTITUTE OF TECHNOLOGY, LUCKNOW",
  "LUCKNOW INSTITUTE OF PHARMCY, LUCKNOW ",
  "GCRG MEMORIAL TRUSTS GROUP OF INSTITUTIONS FACULTY OF MANAGEMENT, LUCKNOW ",
  "AXIS INSTITUTE OF PLANNING AND MANAGEMENT, KANPUR NAGAR",
  "AXIS BUISNESS SCHOOL, KANPUR NAGAR",
  "VIDYA BHAVAN COLLEGE FOR ENGINEERING TECHNOLOGY , KANPUR",
  "School of Forestry & Environment",
  "Allahabad School of Agriculture",
  "MAHAMAYA COLLEGE OF AGRICULTURAL ENGINEARING",
  "INSTITUTE OF BIODIVERSITY AND BIOTECHNOLOGY",
  "DIRECTORATE OF EXTENSION EDUCATION",
  "DIRECTORATE OF AGRICULTURAL RESEARCH",
  "ALVI GIRLS DEGREE COLLEGE, PHOOLPUR",
  "COLLEGE OF VETRINARY SCEINCE & ANIMAL HUSBANDARY",
  "COLLEGE OF HORTICULTURE AND FORESTRY",
  "COLLEGE OF HOME SCIENCE",
  "AMAR BAHADUR SINGH MAHAVIDYALAYA",
  "AMRIT GANGA DEGREE COLLEGE, HANDIA",
  "ARCHANA GIRLS DEGREE COLLEGE, ALLAHABAD",
  "BHAGWAN BUDDHA LAKSHMI MAHAVIDYALAYA HIRANDAPUR RAMPUR KARKHANA DEORIA",
  "ARPIT GIRLS DEGREE COLLEGE, BELAKHAS,MAMREZ",
  "DR. SHYAMA PRASAD MUKHERJEE GOVERNMENT DEGREE COLLEGE, BHADOHI",
  "ATAR SINGH DEGREE COLLEGE, HANDIA",
  "INDRAWAS KUMARI MEMORIAL DEGREE COLLEGE, ANAPUR,",
  "ATIBAL SINGH MAHAVIDYALAYA, SINKI KALAN,",
  "ATIBAL SINGH VIDHI MAHAVIDYALAYA, SINKI KALA,",
  "COLLEGE OF FISHRIES",
  "RAJARSHI PURUSHOTTAM DAS TANDON RAJKIYA MAHAVIDYALAYA, TALBEHAT, LALITPUR",
  "AYODHYA PRASAD DWIVEDI DEGREE COLLEGE",
  "BABA JAGDEV YADAV DEGREE COLLEGE, HANDIA",
  "BABU FATEH BAHADUR SINGH DEGREE COLLEGE, NAHWAI,",
  "COLLEGE OF AGRICULTURE",
  "Shri Vishwanath Singh Sanskrit Mahavidyalaya, Arakha",
  "BABU HARIRAM SINGH MAHAVIDYALAYA, MANDARI,",
  "BAL GOVIND PATEL SMARAK DEGREE COLLEGE, MAUAIMA,",
  "BALRAM MAHAVIDYALAYA, SIRHIR, MEJA,",
  "BASANT MAHAVIDYALA, TENDUI, SARAI ENAYAT,",
  "BASDEV SINGH MAHILA MAHAVIDYALAYA, TARWAI, MEJA,",
  "BEENA SINGH MAHILA MAHAVIDYALAYA, BARAON",
  "BENI MADHAV SINGH MAHAVIDYALAYA, BIGHAIYA,",
  "BHAGWAN DEEN YADAV MAHAVIDHYALAYA,HARAKHPUR",
  "BRAHMADEV MAHAVIDYALAYA JARAW, HANDIA",
  "BRIJ RAJ SINGH DEGREE COLLEGE, THULMA, ASEPUR,",
  "BRIJ RAJ SINGH GIRLS DEGREE COLLEGE, 306 SANJAY NAGAR, NAINI,",
  "CHANDRAKALI MAHAVIDHYALAYA,PHOOLPUR",
  "CHANDRENDRA BAHADUR SINGH VIDHI MAHAVIDYALAYA",
  "CHHATRAPATI SHIVAJI DEGREE COLLEGE, SAHSON,",
  "CHANDRA SHEKHAR AZAD MAHAVIDYALAYA, DHOKRI, PHOOLPUR,",
  "CH. TULSIRAM YADAV MAHAVIDYALAYA, GHOSARA, TULSINAGAR,",
  "ABHAY PRATAP SINGH DEGREE COLLEGE, KUNWARPUR ROAD, BINDKI,",
  "ABHINAV PRAGYA MAHAVIDYALAYA, HARDUARPUR,",
  "RAJKIYA MAHAVIDYALAY PAHI CHITRAKOOT",
  "BABU RADHYSHYAM GUPTA COLLEGE,FATEHPUR",
  "BACHCHURAM RAMSWAROOP SINGH MAHAVIDYALAYA, ADHAULI,",
  "B.M. MAHAVIDYALAYA, BHARWARI,",
  "B.N.U. MAHAVIDYALAYA",
  "B.P. KUSHWAHA MAHAVIDYALAYA, BALRAMPUR, BARETHI,",
  "B.P. MISRA MAHILA MAHAVIDHYALAYA,MAZA",
  "CH. SHIV KUMAR SINGH SMARAK MAHAVIDYALAYA, DHATA,",
  "CITIZEN GIRLS COLLEGE, BALRAM NAGAR, NAINI,",
  "DAYASHANKAR MAHILA MAHAVIDYALAYA,HANDIA",
  "ERAM COLLEGE",
  "DEENA NATH PANDEY MAHAVIDYALAYA, SIRATHU,",
  "Dr Gaurav Singh Memorial Girls Degree College Chauri Gonda",
  "DEEN DAYAL UPADHYAY RAJKEEYA MAHAVIDYALAYA, SAIDABAD,",
  "DEGREE COLLEGE, UPARDAHA, BARAUT,",
  "DESH RAJ SINGH SIKSHAN SANSTHAN",
  "DHARAMPAL SINGH CHANDAIL MAHAVIDYALAYA, ADHAULI,",
  "DILIP KUMAR SMARAK MAHAVIDYALAYA, KODA JAHANABAD,",
  "DR. A.H. RIZVI DEGREE COLLEGE, KARARI,",
  "BHASKAR COLLEGE OF EDUCATION",
  "J S COLLEGE OF EDUCATION",
  "DR. BHIMRAO AMBEDKAR MAHAVIDYALAYA, JUGNIDEEH, PHOOLPUR,",
  "DR. B.R.A. GOVT. GIRLS DEGREE COLLEGE,",
  "DR. GANESH PRASAD VIDHI MAHAVIDHYALAYA,HANDIYA",
  "DR. KAILASH NATH SINGH MAHAVIDYALAYA, NAUDHIYA, UPARHAR,",
  "S.R. DEGREE COLLEGE, RASOOLPUR, BHAIMECHA, HASWA,",
  "SMT. KRISHNA MAHAVIDYALAYA, SAYARA,",
  "GYANANDA ACADEMY OF HIGHER EDUCATION",
  "AWADH PARAMEDICAL COLLEGE AND INSTITUTE NAYANSAND JAUNPUR",
  "RAMNATH SINGH MAHAVIDYALAYA, CHAYAL KHAS,",
  "SMT. PUSHPA DEVI MAHAVIDHYALAYA,MYOHAR",
  "RAM SAJIWAN SINGH MAHAVIDYALAYA, JAYANTIPUR,",
  "SW. HARIPAL SINGH MAHAVIDYALAYA",
  "SHRI BABU SINGH DEGREE COLLEGE, SARAINYA,",
  "SHRI RAGHURAJ SINGH MEMORIAL MAHAVIDYALAYA FAKIRABAD",
  "SHYAM KUMARI MAHAVIDYALAYA, HANDIA",
  "SIDDH NARAYAN RAM HARSH DEGREE COLLEGE, VIDYA NAGAR,",
  "RAMA DEVI SHIV MANGAL PRASAD MAHAVIDYALAYA, AJUHA,",
  "SITA SIROMANI DEGREE COLLEGE, KAPSA, PHOOLPUR,",
  "SMT. DHANRAJI DEVI MAHILA D/C KORAON",
  "SMT. DURGAWATI DEVI MAHAVIDYALAYA, MANU KA PURA, MEJA,",
  "SMT GIRZA DEVI MAHILA MAHAVIDYALAYA KHAGA, FATEHPUR",
  "SMT  GOMATI DEVI CHOTE LAL BIND MAHAVIDYALAYA, HANDIA",
  "SMT. KAILASHI DEVI R.S. MAHAVIDYALAYA, RASTIPUR, HANDIA,",
  "SMT. KAMALA DEVI VIDHI MAHAVIDYALAYA,KUSARI",
  "SOM CHANDRA DWIVEDI MAHAVIDYALAYA,BAMHRAULI,SIRATHU",
  "SRI KRISHNA EDUCATION VIDHI COLLEGE, MAZA",
  "SRI KRISHNA MAHAVIDALAYA, JARI, BARA, ALLAHABAD",
  "G S COLLEGE OF LAW",
  "SRI KRISHNA MAHILA MAHAVIDYALAYA, FIROZPUR, FULPUR,",
  "SRI MATHURA PRASAD MISRA MAHAVIDHYALAYA, MEJA",
  "SRI PARMANAND SMARAK MAHAVIDYALAYA, ALLAHABAD",
  "SRI RAM PRASAD MISHRA PT. BABULAL MAHAVIDYALAYA, JASRA,",
  "SRI SATYADEV DEG.COLL. CHAKIYA SATHER, MADWA HANDIA,",
  "SRIDHAR SINGH YADAV MAHAVIDYALAYA, GOSAURA KALA,",
  "SRIDHAR SINGH YADAV VIDHI MAHAVIDYALAYA",
  "SRI HANUMANT PAL MAHAVIDYALAYA, CHUAPIRAN, KADA,",
  "Shrichand Ji Mahavidyalaya, Pilkhini, Gaurabadshahpur, Jaunpur",
  "SRINATH RAMNATH MAHAVIDYALAYA, DHANAWAL, SONBARSA, MANDA,",
  "GREATER NOIDA INSTITUTE OF TECHNOLOGY (ENGINEERING INSTITUTE)",
  "SRI RAM AUTAR SINGH MAHAVIDYALAYA, SESHPUR, UNWA,",
  "PARASNATH MAHILA MAHAVIDYALAYA KANAWAN HARINGTONGANJ BIKAPUR FAIZABAD",
  "S.S.S. SWARG. PARASHURAM UMRAO COLLEGE, AJAMPUR,",
  "SRI CHANDRAPAL SINGH MAHAVIDYALAYA, KHERWA, BARAULA,",
  "S N T COLLEGE OF EDU AND TECH MAHILA HANUMANGANJ, ALLAHABAD",
  "SUKHRAJI SRI RAM BALIKA MAHAVIDYALAYA,ALLAHABAD",
  "SURENDRA PRASAD SHUKLA MAHILA MAHAVIDYALAYA,ALLAHABAD",
  "SURYAPAL SINGH PATEL MAHAVIDYALAYA,BAMRAULI",
  "SWAMI BHAGWAN DAS MAHILA MAHAVIDYALAYA,TILHAPUR MOD",
  "SW ARJUN SINGH RANI INDIRA SINGH MAHAVIDYALAYA, JAIRAMPUR",
  "SW. BHAGWANTI DEVI DEG.COLL. BHUSKA, MEJA ROAD,",
  "SW. J.P.M.P. MAHILA MAHAVIDHYALAYA,RASULPUR,LADIGAON",
  "SW. KRIPA SHANKER TIWARI MAHAVIDYALAYA, NAHWAI, MEJA,",
  "SW. MAHAVIR SINGH MAHAVIDYLAYA, MUNGARI, KARCHCHANA,",
  "R K PRASHIKSHAN KENDRA SAIDUPUR HANUMANGANJ PRAYAGRAJ",
  "SW. NAND KISHOR MAHAVIDYALAYA, DHANUHA, CHAKA,",
  "SW.PT. RAMDULAR PANDEY MAHAVIDHYALAYA,FOOLPUR",
  "S.R. SINGH R.B. SINGH MAHAVIDYALAYA, MOTIHAN,",
  "SMT VIMALA DEVI MAHAVIDHYALAYA HUSAMGANJ PHOOLPUR, ALLAHABAD",
  "SRI INDRAPAL SINGH MAHAVIDYALAYA",
  "SRI RAGHUVEER SINGH MAHAVIDYALAYA, BANIKHAS, CHAMPAHA,",
  "SRI DEVI PRASAD MAHAVIDYALAYA, PILAKHANI, JANGHAI,",
  "SRI RAJDHAR SINGH MAHAVIDYALAYA,BIGAHANI SIRSA MEJA, ALLAHABAD",
  "VISHWANATH INSTITUTE OF PHARMACY GHAZIPUR",
  "RAJKIYA MAHILA MAHAVIDYALAYA SAIYADRAJA CHANDAULI",
  "SRI YAGYA NARAYAN PANDEY DEGREE COLLEGE, LALAPUR,",
  "TH  AMAR SINGH MAHAVIDYALAYA, HOLAGARH",
  "TH. HAR NARAYAN SINGH DEGREE COLLEGE, KARAILA BAGH,",
  "TH. JAINARAIN SINGH MAMORIAL DEGREE COLLEGE",
  "TH. YUGRAJ SINGH MAHAVIDYALAYA,",
  "TH. YUGRAJ SINGH VIDHI MAHAVIDYALAYA, G.T. ROAD,",
  "T.N. SINGH EDUCATION COLLEGE,MEJA, ALLAHABAD",
  "T.R.S MAHILA MAHAVIDYALAYA, KAUSHAMBI",
  "UDAI PRATAP SINGH MAHAVIDYALAYA",
  "UDAIRAJ SINGH VIDHI MAHAVIDYALAYA, SAIDPUR, HANUMANGANJ,",
  "VASDEV MAHAVIDYALAYA  GARAHIYA CHINTAMAN TARYASUJAN KUSHINAGAR",
  "UNITED INSTITUTE OF MANAGEMENT, LEADER ROAD,",
  "URMILA LAW COLLEGE,TULSHINAGAR,ALLAHABAD",
  "URMILA MAHILA MAHAVIDYALAYA, JUNSHI",
  "VAISNAVI DEGREE COLLEGE KHARKA DABOUR MEJA, ALLAHABAD",
  "VIDHYAVATI DEVI MAHAVIDHYALAYA, MAUAIMA",
  "VIJAY DEGREE COLLEGE, SAILAYA KHURD,MEJA,",
  "VINDHYAVASINI PRASAD VIDYAKANT PANDIT DEG. COLL. KORAON,",
  "YATHARTHA VIDHI MAHAVIDYALA, TIKARI",
  "YUWA SAMRAT RAJEEV GANDHI DEGREE COLLEGE, GAUHARPUR,",
  "SW. TILAK RAJ SINGH MAHAVIDHYALAYA,ALIPUR,JEETA",
  "SW. TIRATH RAJ SINGH MAHAVIDHYALAYA,MYOUHAR",
  "KAMLA MAHILA MAHAVIDYALAYA SANTOSHNAGAR GHAZIPUR",
  "Mata Kushum Devi Girls Degree College",
  "INTEGRAL DEGREE COLLEGE",
  "SWAMI VIVEKANAND LAW COLLEGE",
  "MAA SHANTI DEVI MAHAVIDYALAYA ",
  "PT VISHWANATH PANDEY MAHAVIDYALAYA",
  "UMALOK COLLEGE OF NURSING",
  "AMARNATH MAHAVIDYALAYA",
  "GLOBAL EDUCATION ",
  "BHAVANIDEEN SINGH MAHAVIDYALAYA CHURAHA GOHAND HAMIRPUR",
  "SHRI JALPA SINGH MAHAVIDYALAYA",
  "SRI DEEL SINGH RAMGOPAL MAHAVIDYALAYA BADANPUR BIDHUNA AURAIYA",
  "RAM BARAN SINGH MAHAILA MAHAVIDHLAYA, PRATAPPUR ",
  "SIDDHARTH MAHAVIDYALAY KAMHARIYA KHURD MITHVAL BAZAR BANSI SIDDHARTH NAGAR",
  "ASHA BHAGWAN BUX SINGH MAHAVIDYALAYA ",
  "SMT. SWARNLATA SMARAK KANYA MAHAVIDYALAYA",
  "S.S MAHAVIDYALAYA, RANJEET NAGAR",
  "GANGARATHI TEACHING AND TRAINING INSTITUTE",
  "RAJA RAM MAHAVIDYALAYA, ASHRAFPUR MAJGAWAN, JALALPUR",
  "SRI RAM ADHAR VERMA SMARAK MAHAVIDYALAYA, GAURA MAHAMADPUR PARA",
  "RAJKIYA P.G. COLLEGE, MUSAFIRKHANA",
  "H. L. TEACHERS TRAINING COLLEGE, RAMPUR, AHIRAULI",
  "MANOHAR LAL MAHAVIDYALAYA KUTUAPUR KANT SHAHJAHANPUR",
  "VAIDYA SHRI RAM BHAROS PRAYAGWATI MISHRA SHAIKSHANIK EVAM TAKNIKI MAHAVIDYALAYA",
  "NAWABH SINGH BADAN SINGH SHIKSHAN SANSTHAN ",
  "HAZI NEWAZ ALI MAHAVIDYALAYA, DAULATPUR GRANT",
  "MOTHER TERESA MAHILA MAHAVIDYALAYA, KATKAKHANPUR",
  "SHYAMA DEVI COLLEGE OF EDUCATION, BADAIL",
  "Shree Bala ji Degree College, Basgaon",
  "ASHA DEVI MAHAVIDYALAYA, PITHLA",
  "Budhni Devi Smarak Mahila Mahavidyalaya",
  "Chaudhary Veerbhan Singh Anita Devi Mahavidyalaya",
  "Dr. Parashuram Deen Bandhu Mahavidyalaya, Baskhari",
  "SANSKAR COLLEGE",
  "KRISHNA COLLEGE OF EDUCATION AND MANAGEMENT",
  "Shriram Mahila Mahavidyalya, Kasimabad, Ghazipur",
  "SAYED MOHD ISTAYAK LAW DEGREE COLLEGE",
  "ANAND ENGINEERING COLLEGE, ARTONI, AGRA",
  "K.S. COLLEGE OF LAW SHAMLI",
  "DMS SHIKCHAN PRASHKCHAN SANSTHAN ",
  "SHRI DHARMJEET SINGH VIDHI MAHAVIDYALAYA ",
  "Imamuddin Turki Memorial Institute of Higher Education",
  "SHRI AIVAR SINGH DESHWAR INSTITUTE OF EDUCATION JATORA ROAD BALDEV MATHURA",
  "Budhhuram Satyawati Devi Sansthan, Kuddupur, Jaunpur",
  "SMT. SHANTI DEVI DEGREE COLLEGE",
  "AUTONOMOUS STATE MEDICAL COLLEGE",
  "RAJSHREE LAW COLLEGE BAREILLY",
  "CH. HARCHAND SINGH MAHAVIDYALYA GOTNI, BULANDSHAHR",
  "BE-CON INSTITUTE OF TECHNOLOGY MEERUT BYPASS ROAD, OPP. RAJ KAMAL HANDLOOM FACTORY, PRATAPUR, MEERUT Ph. No :- 2611621, 2511336, 2645381",
  "Maa Gayatri Ramnaresh Mahila Mahavidyalaya Dihiya Jaunpur",
  "Sw Digvijay Singh Mahila Mahavidyalaya Hasanpur Bhaura Kerakat Jaunpur",
  "SITARAM MAURYA BALIKA MAHAVIDYALAYA MATRAMPUR, ROHANIYA, UNCHAHAR, RAEBARELI",
  "SHRIMATI GANESHI BAI SONI VIGYAN MAHAVIDYALAYA, MAURANIPUR, JHANSI",
  "KRISHNA INSTITUTE OF PHARMACY AND SCIENCES",
  "AABAN EDUCATION INSTITUTE JOYA AMROHA",
  "MAHARANA PRATAP SCHOOL OF PHARMACY",
  "ROHTASH SINGH MEMORIAL COLLEGE OF EDUCATION DAULATPUR MEERUT",
  "VIRANGNA AWANTIBAI MAHAVIDAYALYA ",
  "MAHAVEER AYURVEDIC MEDICAL COLLEGE AND HOSPITAL ",
  "D S MISHRA LAW COLLEGE TULAPUR AANTA MEJA PRAYAGRAJ",
  "DHARMRAJ SINGH COLLEGE OF EDUCATION,RAGAULI, CHITRAKOOT",
  "Rammoorat Mahila Mahavidyalaya, Ghazipur",
  "GNIOT INSTITUTE OF PROFESSIONAL STUDIES",
  "S S COLLEGE OF TEACHER EDUCATION",
  "BHARTIYA AYURVEDIC MEDICAL COLLEGE",
  "SANJEEVANI AYURVEDIC MEDICAL COLLEGE",
  "SUN INSTITUTE OF TEACHERS EDUCATION",
  "Maa Vaishno College of Education",
  "R.B.S. COLLEGE MANOHAR NAGAR ",
  "LILAWATI DEVI MAHILA MAHAVIDYALAYA, SOHANRIYA, DEORIA",
  "BHRIGURASHAN RAI MAHILA MAHAVIDYALAYA, DEORIA",
  "DR. AMBEDKAR SMARAK EWAM SHRIMATI RAJKISHORI DEVI MAHILA MAHAVIDYALAYA,  MITHAURA BAZAAR, MAHARAJGANJ",
  "CHANDRIKA PRASAD SHUKLA MAHAVIDYALAYA, GORAKHPUR",
  "BADRI NARAYAN MAHAVIDYALAYA , JUGLE GAYGHAT , KUSHINAGAR",
  "BACCHI DEVI RAMDEV CHAUBE MAHAVIDYALAYA, AJAYPURI, BHAUVAPAR, SARDARNAGAR, GORAKHPUR",
  "ANURAGI DEVI MAHAVIDYALAYA, BAHUAS, KUSHINAGAR",
  "MAA SARASWATI BALIKA MAHAVIDYALAYA , SOHANPUR , DEORIA",
  "CHANDRABALI RAI MAHAVIDYALAYA, BAGHARA MAHUAARI, DEORIA",
  "SRI BABU SINGH DEGREE COLLEGE, FATEHGARH, ",
  "INSTITUTE OF TECHNOLOGY & MANAGEMENT,LUCKNOW",
  "INSTITUTE OF ENGINEERING & TECHNOLOGY,LUCKNOW",
  "BANSAL INSTITUTE OF ENGINEERING & TECHNOLOGY,LUCKNOW",
  "KALI PRASAD MAHILA MAHAVIDYALAYA, KANAURA , KUSHINAGAR",
  "Sri Rammurti Smarak  College of Engineering  Technology & Research,BAREILLY",
  "INSTITUTE OF PHARMACY ,,SITAPUR",
  "INSTITUTE OF TECHNOLOGY & MANAGEMENT,GORAKHPUR",
  "R.D.ENGINEERING COLLEGE RESEARCH CENTRE,GHAZIABAD",
  "GREATER NOIDA INSTITUTE OF BUSINESS MAAGEMENT,GAUTAM BUDDH NAGAR",
  "S.P.MEMORIAL INSTITUTE OF TECHNOLOGY,KAUSHAMBI",
  "VIVEKANAND INSTITUTE OF TECHNOLOGY & SCIENCE, HAPUR",
  "GREATER NOIDA COLLEGE OF TECHNOLOGY,GAUTAM BUDDH NAGAR",
  "SIR MADAN LAL INSTITUTE OF MANAGEMENT,,ETAWAH",
  "JAI BAHADUR SHAHI (JBS) MAHAVIDYALAYA, BHINGARI BAZAR, BHATPAR RANI, DEORIA",
  "\"BHAGWANDAS SHAKUNTALA DEVI WOMEN EDUCATIONAL INSTITUTE, BADURHIA CHAURAHA,  CHAURI CHAURA, GORAKHPUR\"",
  "SETH VISHAMBHAR NATH INSTITUTE OF ENGG. & TECHNOLOGY,BARABANKI",
  "KALICHARAN NIGAM INSTITUTE OF TECHNOLOGY,BANDA",
  "DR. BHIMRAO AMBEDKAR ENGINEERING COLLEGE OF INFORMATION TECHNOLOGY,BANDA",
  "KRISHNARPIT INSTITUTE OF MANAGEMENT & TECHNOLOGY,ALLAHABAD",
  "INSTITUTE OF ENGG. & RURAL TECHNOLOGY,ALLAHABAD",
  "AGRA PUBLIC COLLEGE OF HIGHER EDUCATION AND RESEARCH CENTRE",
  "PRABHAT ENGINEERING COLLEGE",
  "SHRI CHHOTE LAL JAGROOP SINGH YADAV MAHAVIDYALAYA,BEHTA,MUZAWAR",
  "MAA VASHNO DEVI MAHAVIDHYALAYA,PAL NAGAR",
  "SRI P.L. YADAV MAHAVIDYALAYA,SUNVERSA",
  "SW. NARENDRA SINGH MAHAVIDYALAYA,GAJNER",
  "LORD KRISHNA MAHAVIDHYALAYA,KANCHAUSI",
  "SW. K.D.S.S. MAHILA SIKSHAN SANSTHAN LOHARI",
  "AVIKA DEGREE COLLEGE,RAGHURAJ NAGAR",
  "KANNAUJ DEGREE COLLEGE,JAPHARABAD,CHIBRAMAU",
  "VIRENDRA SINGH KATIYAR MAHAVIDHYALAYA,SHANTI NAGAR",
  "M.S. MAHAVIDHYALAYA,USRAHAR",
  "K.N.BALIKA DEGREE COLLEGE,SANFAI",
  "PT. KEDAR NATH MAHILA MAHAVIDHYALAYA,HARRAJPUR,BAKEWAR",
  "TATHAGAT BUDDH MAHILA MAHAVIDHYALAYA,CHITBHAWAN",
  "S.S. MEMORIAL MAHAVIDHYALAYA,SUTIYANI MOD,TAKHA, ETAWAH",
  "Anekant College of Higher Education",
  "DWARIKA PRASAD BALAKRAM MAHAVIDHYALAYA ACHHALDA ROAD BIDHUNA AURRAIYA",
  "D.V.S. MAHAVIDHYALAYA,DEIPUR,AIRWA KATRA",
  "G.S. MAHAVIDYALAYA,SAHAYAL",
  "VIMAL KUMAR GUPTA MAHAVIDYALAY ASRENDA UNNAO",
  "ELITE COLLEGE OF HIGHER EDUCATION UTMANPUR UNNAO",
  "SRI RADHA KRISHNA MAHAVIDHYALAYA,KATRA,PHAPHUND",
  "DR BHIMRAO AMBEDKAR MAHAVIDYALAY, ATRAULIMAFI PAHADI RAJAPUR CHITRAKOOT",
  "SHRI SUNDAR SINGH JAWAHAR SINGH PATEL DEGREE COLLEGE PATEL NAGAR KARAHI MAU CHITRAKOOT U P",
  "SOMVATI PATEL SMARAK MAHAVIDHYALAYA MAHOBKANTH MAHOBA",
  "Shri Sangveda Adarsh Sanskrit Mahavidyalaya, Tameshwarnath",
  "JSS ACADEMY OF TECHNICAL EDUCATION, NOIDA",
  "Shri Devi Prasadiya Sanskrit Mahavidyalaya,",
  "Shri BAKEYLAL MEMORIAL MAHAVIDYALAYA, CHANDPUD",
  "RAM SWAROOP SINGH GAUR MAHAVIDYALAYA,AKBARPUR",
  "SHIVGYAN DEGREE COLLEGE MANAGMENT AND TECHNOLOGY, KHANDAUA",
  "BASAMATTI DEVI SANKATHA PRASAD MAHILA MAHAVIDYALAYA, BHADERA, KHOCHAWAN, VARANASI",
  "SACRED HEART INSTITUTE OF MANAGAMENT AND TECHNOLOGY, SITAPUR",
  "SUN INSTITUTE OF MANAGEMENT AND TECHNOLOGY, SHAHJAHANPUR",
  "DEV BHOOMI GROUPS OF INSTITUTIONS FACULTY OF MANAGEMENT, SAHARANPUR",
  "DEV BHOOMI GROUPS OF INSTITUTIONS FACULTY OF COMPUTER APPLICATION, SAHARANPUR",
  "FEROZE GANDHI INSTITUTE OF ENGG AND TECHNOLOGY , RAEBARELI",
  "GHANSHYAM BINANI ACADEMY OF MANAGEMENT SCIENCES, MIRZAPUR",
  "SHRINATHJI INSTITUTE FOR TECHNICAL EDUCATION, MEERUT",
  "DEWAN V S INSTITUTE OF ENGINEERING AND TECHNOLOGY, MEERUT",
  "DR M C SAXENA COLLEGE OF ENGINEERING AND TECHNOLOGY, LUCKNOW",
  "RAJEEV GANDHI COLLEGE OF PHARMACY, MAHARAJGANJ",
  "M G INSTITUTE OF MANAGEMENT AND TECHNOLOGY, LUCKNOW",
  "LUCKNOW MODEL INSTITUTE OF TECHNOLOGY AND MANAGEMENT, LUCKNOW",
  "LUCKNOW INSTITUTE OF TECHNOLOGY, LUCKNOW",
  "LAL BAHADUR SHASTRI INSTITUTE OF MANAGEMENT AND DEVELOPMENT STUDIES, LUCKNOW",
  "ITM SCHOOL OF MANAGEMENT, LUCKNOW",
  "ITM INSTITUTE OF ARCHITECTURE AND TOWN PLANNING, LUCKNOW",
  "INTERNATIONAL INSTITUTE FOR SPECIAL EDUCATION, LUCKNOW",
  "GOEL INSTITUTE OF TECHNOLOGY AND MANAGEMENT, LUCKNOW",
  "GOEL INSTITUTE OF PHARMACY AND SCIENCES, LUCKNOW",
  "DR M C SAXENA COLLEGE OF PHARMACY, LUCKNOW",
  "MADHU VACHASPATI INSTITUTE OF ENGINEERING AND TECHNOLOGY , KAUSHAMBI",
  "PRANVEER SINGH INSTITUTE OF TECHNOLOGY, KANPUR",
  "NARAINA VIDYA PEETH MANAGEMENT INSTITUTE, KANPUR",
  "NARAINA VIDYA PEETH ENGINEERING AND MANAGEMENT INSTITUTE, KANPUR",
  "NARAINA COLLEGE OF ENGINEERING AND TECHNOLOGY, KANPUR",
  "MAHARANA PRATAP ENGINEERING COLLEGE, KANPUR",
  "MAHARANA PRATAP COLLEGE OF PHARMACY, KANPUR",
  "KRISHNA INSTITUTE OF TECHNOLOGY, KANPUR",
  "MADHU VACHASPATI SCHOOL OF MANAGEMENT, KAUSAMBI",
  "DR RIZVI COLLEGE OF ENGINEERING, KARARI",
  "CHANDRA SHEKHAR SINGH COLLEGE OF PHARMACY, KAUSHAMBI",
  "BHALCHANDRA INSTITUTE OF EDUCATION AND MANAGEMENT , LUCKNOW",
  "AZAD INSTITUTE OF ENGG AND TECHNOLOGY, LUCKNOW",
  "ARYAKUL COLLGE OF MANAGEMENT, LUCKNOW",
  "ARYAKUL COLLEGE OF PHARMACY AND RESEARCH, LUCKNOW",
  "AMBALIKA INSTITUTE OF MANAGEMENT AND TECHNOLOGY, LUCKNOW",
  "AXIS INSTITUTE OF ARCHITECTURE, KANPUR",
  "APOLLO INSTITUTE OF TECHNOLOGY, KANPUR",
  "ALLENHOUSE INSTITUTE OF TECHNOLOGY, KANPUR",
  "APEEJAY INSTITUTE OF TECHNOLOGY SCHOOL OF ARCHITECTURE AND PLANNING, GREATERÂ NOIDA",
  "SR GROUP OF INSTITUTIONS COLLEGE OF ENGINEERING MANAGEMENT AND TECHNOLOGY, JHANSI",
  "SMT VIDYAWATI COLLEGE OF PHARMACY, JHANSI",
  "BUNDELKHAND INSTITUTE OF ENGINEERING AND TECHNOLOGY, JHANSI",
  "KUNWAR HARI BANSH SINGH COLLEGE OF PHARMACY, JAUNPUR",
  "UNITED COLLEGE OF ENGG AND RESEARCH , GREATERÂ NOIDA",
  "MAA KABOOTARA DEVI SATYABHAMA MAHILA MAHAVIDYALAYA MUBARAKPUR AMBEDKARNAGAR",
  "DR B R AMBEDKAR POOJA COLLEGE OF PHARMACY , GORAKHPUR",
  "TECHNICAL EDUCATION AND RESEARCH INSTITUTE, GHAZIPUR",
  "INSTITUTE OF PROFESSIONAL EXCELLENCE AND MANAGEMENT, GHAZIABAD",
  "KANPUR INSTITUTE OF TECHNOLOGY AND PHARMACY, KANPUR",
  "JAGRAN INSTITUTE OF MANAGEMENT, KANPUR",
  "INDUS INSTITUTE OF TECHNOLOGY AND MANAGEMENT, KANPUR",
  "DR VIRENDRA SWAROOP INSTITUTE OF PROFESSIONAL STUDIES, KANPUR",
  "MEERUT INSTITUTE OF ENGINEERING AND TECHNOLOGY, MEERUT",
  "KRISHNA MANAGEMENT COLLEGE, GHAZIABAD",
  "KOTHIWAL INSTITUTE OF TECHNOLOGY AND PROFESSIONAL STUDIES, MORADABAD",
  "KISHAN INSTITUTE OF ENGINEERING AND TECHNOLOGY, MEERUT",
  "BABU BANARASIDAS INSTITUTE OF ENGINEERING TECHNOLOGY AND RESEARCH CENTRE, BULANDSHAHAR",
  "KIET GROUP OF INSTITUTIONS, GHAZIABAD",
  "RAMESHWAR PRASAD COLLEGE PACHNEHI BANDA UP",
  "SANT KRIPAL SINGH INSTITUTE OF LAW",
  "RAM BARAN SINGH MAHAVIDYALAYA CHORAHA BARAIPAR JAUNPUR",
  "SBN GIRLS DEGREE COLLEGE UTTRANCHAL NAGAR NANDGRAM GHAZIABAD",
  "SWAMI VIVEKANAND COLLEGE MAHOBA",
  "LOK BANDHU BABURAM MAHAVIDYALAY GAURI NAGAR GAURI IBRAHIM TAMKUHIRAJ KUSHINAGAR",
  "Sanskrit Pathshala, Raamkaula",
  "SRI KOMIL SINGH S D MEMORIAL MAHAVIDYALAYA KANNAUJ",
  "Abhay College of Commerce and Education Munderi, Chaubepur Khurd,  Varanasi.",
  "MICROTEK COLLEGE OF MANAGEMENT AND TECHNOLOGY",
  "Mount Kailash College Of Education",
  "Government  P.G. College, Bisalpur- Pilibhit",
  "Jubali Sanskrit College",
  "M.I.E.T.  PAWLIKHAS, MEERUT",
  "B.S.A COLLEGE,MATHURA",
  "Pt. PRITHI NATH (PG) COLLEGE,",
  "SRI RAGHURAJ SINGH SIKSHAN PRASHIKSHAN SANSTHAN DEEH DHAGGUPUR SULTANPUR",
  "Satyam Fashion Institue",
  "PATEL PANCHAYTI MAHAVIDYALAYA, RAM SANEHIGHAT, BARABANKI",
  "Q.F. MAHAVIDYALAYA, NANDAURA, FATEHPUR, BARABANKI",
  "SANJEEVANI COLLEGE SHIKSHAN AVAM PRASHIKSHAN MAHAVIDYALAYA, BAHRAICH",
  "RAM SEWAK YADAV MAHAVIDYALAYA, CHANDAULI, BARABANKI",
  "DESH DEEPAK ADARSH MAHAVIDYALAYA, TENDUAMAFI, BIKAPUR, FAIZABAD",
  "RAMRAJI MAHAVIDYALAYA, VAIDHA, SULTANPUR",
  "MAHILA MAHAVIDYALAYA, RUSTAMPUR TANDA, AMBEDKAR NAGAR",
  "MAHARANI LAL KUNWARI SNATKOTTAR MAHAVIDYALAYA, BALRAMPUR",
  "GANGA DEVI YADAV MEMORIAL MAHILA MAHAVIDYALAYA, ISMAILPUR, DEVA, BARABANKI",
  "MAHILA MAHAVIDYALAYA, BELA PARSA, AMBEDKAR NAGAR",
  "KOSHAL MAHAVIDYALAYA, BARAI PARA, MAYA, FAIZABAD",
  "CHANDRA BHAN SINGH MAHAVIDYALAYA, KUMHIYA, FAIZABAD",
  "MALKA MAHILA MAHAVIDYALAYA, ASANDRA, BARABANKI",
  "PT. ONKAR NATH MAHAVIDYALAYA, BAKHAT KA PURWA, GAURIGANJ, SULTANPUR",
  "JAI MAA DURGE DHARMAWATI MAHAVIDYALAYA, KALYAN BHADARSA, FAIZABAD",
  "RAM LAKHAN MAHAVIDYALAYA, BHITI, AMBEDKAR NAGAR",
  "MALTI SINGH MAHILA MAHAVIDYALAYA, DYORI, FAIZABAD",
  "SWAMI VIVEKANAD SHIKSHAN SANSTHAN MAHAVIDYALAYA, LAMBHUA, SULTANPUR",
  "KUNWARI CHANDRAWATI MAHAVIDYALAYA, MUMTAZNAGAR, FAIZABAD",
  "SRI VINAYAK MAHAVIDYALAYA, KHAJURAHAT, FAIZABAD",
  "AVADH LAW COLLEGE, ASAINI, BARABANKI",
  "RAJKIYA MAHAVIDYALAY SEHMO BASTI",
  "BHAVDIYA EDUCATIONAL INSTITUTE, SOHAWAL, FAIZABAD",
  "R.P.S.B.S. MAHAVIDYALAYA, SISANI, JAFARGANJ, AMBEDKAR NAGAR",
  "RANI SHANTI DEVI MAHAVIDYALAYA, HATAUDHA, RAMSANEHIGHAT, BARABANKI",
  "SARASWATI DEVI NARI GYANSTHALI MAHAVIDYALAYA, GONDA",
  "MAA VAISHNO DEVI MAHILA MAHAVIDYALAYA, DEVRAKOT, FAIZABAD",
  "SARDAR MOHAR SINGH MEMORIAL MAHILA MAHAVIDYALAYA, BANDHARA, MANKAPUR, GONDA",
  "HARISH CHANDRA MAHAVIDYALAYA, SAROULI, FAIZABAD",
  "DHANRAJI DEVI BALIKA MAHAVIDYALAYA, UTRETHU, AMBEDKAR NAGAR",
  "ACHARYA CHANAKYA MAHAVIDYALAYA, MAHMOODPUR SEMRI, SULTANPUR",
  "RAM SARDAR PANDEY SMARAK SHIVPURI MAHAVIDYALAYA, KHANDASA, FAIZABAD",
  "RAMPHER SHIVPHER MAHAVIDYALAYA, NIBHDI, FAIZABAD",
  "RAJIV GANDHI MAHAVIDYALAYA, JAGDISHPUR, SULTANPUR",
  "LATE VIRENDRA PRATAP SINGH SMARAK MAHAVIDYALAYA, KUNDA, BHAIRAVPUR, SULTANPUR",
  "RANVEER RANANJAI SNATKOTTAR MAHAVIDYALAYA, AMETHI, SULTANPUR",
  "PT. ASHOK MISHRA SMARAK MAHAVIDYALAYA, ASHOK NAGAR, BAHRAICH",
  "RAMHIT LAKSHIMAN SMARAK MAHAVIDYALAYA, BANDIPUR, AMBEDKAR NAGAR",
  "PT. DEEN DAYAL UPADHYAY GRAMODAI MAHAVIDYALAYA, BADALPUR, DIDISIA KALA, BELSAR, GONDA",
  "LATE RAM RAJ VERMA MAHAVIDYALAYA, SARANGPUR, KUREBHAR, SULTANPUR",
  "SINGARI DEVI SMARAK MAHAVIDYALAYA, RAMNAGAR, AMBEDKAR NAGAR",
  "LALLAN JI BRAHMCHARI MAHAVIDYALAYA, RAJESULTANPUR, AMBEDKAR NAGAR",
  "CHAUDHARY CHARAN SINGH MAHAVIDYALAYA, BARSANDI, SOHAWAL, FAIZABAD",
  "MAA KAMLA MAHAVIDYALAYA, DHAKHA MEDNIPUR, AKBARPUR, AMBEDKAR NAGAR",
  "ACHARYA VINOBA BHAVE MAHAVIDYALAYA, PREM NAGAR, CHHIDA, SULTANPUR",
  "BABA GAYADEEN VAIDYA BABURAM MAHAVIDYALAYA, MAINPUR, NAWABGANJ, GONDA",
  "MAINATHI KUNWAR CHANDRAWATI DEGREE COLLEGE, SARAI ANADEO, PRATAPGARH",
  "BENI PRASAD SINGH SOMVANSHI MAHAVIDYALAYA, BHAROKHAN PATTI, PRATAPGARH",
  "MAA KAILASHI SAVITRI DEVI MAHILA MAHAVIDYALAYA, JAGDISHPUR, BEEDAPUR, PRATAPGARH",
  "AVADHESH SURESH SINGH SMARAK MAHAVIDYALAYA, RAJAPUR, BINDHAN, PRATAPGARH",
  "GRAMODAI ASHRAM P.G. COLLEGE, VIRSINGHPUR SAYA, AMBEDKAR NAGAR",
  "B.N.K.B. P.G. COLLEGE, AKBARPUR, AMBEDKAR NAGAR",
  "MAA GAYATRI RAM SUKH PANDEY MAHAVIDYALAYA, MASKANWA, GONDA",
  "C.B. SINGH LAW COLLEGE, SONGAON, AMBEDKAR NAGAR",
  "RAM AVADH SMARAK MAHAVIDYALAYA, KASDAHAN, SHUKUL BAZAR, AMBEDKAR NAGAR",
  "RAMESHWAR DUTT MEMORIAL MAHAVIDYALAYA, KRISHNA NAGAR, MAHSI, BAHRAICH",
  "BADLI MAHAVIDYALAYA, AMRETHU, KADIPUR, SULTANPUR",
  "SARDAR PATEL SMARAK MAHAVIDYALAYA, LARPUR, AMBEDKAR NAGAR",
  "AVADH KISAN MAHAVIDYALAYA, NASRATPUR, FAIZABAD",
  "PRACHARYA MISHRA CHANDRIKA PRASAD SUKHRAJ KISAN MAHAVIDYALAYA, SHRAWASTI",
  "MAHAMAYA RAJKIYA MAHILA MAHAVIDYALAYA, SHRAWASTI",
  "HARIHAR PRASAD MAHAVIDYALAYA, KURWAR ROAD, SULTANPUR",
  "PT. KRIPA SHANKAR MAHAVIDYALAYA, KALPADHAM, AMBEDKARNAGAR",
  "SHIVNATH VERMA SMARAK MAHAVIDYALAYA, DEO NAGAR, KHANPUR PILAI, SULTANPUR",
  "J.B.S. MAHAVIDYALAYA, DULHADEPUR, TIKAIT NAGAR, BARABANKI",
  "SRI RAM ADARSH MAHAVIDYALAYA, MUBARAKPUR MARAILA, AMBEDKAR NAGAR",
  "VIDYAWATI BALIKA MAHAVIDYALAYA, AKHAND NAGAR, SULTANPUR",
  "RAMROOP SMARAK MAHAVIDYALAYA, FAIZABAD",
  "DASHRATH VERMA MAHAVIDYALAYA, GAURA BASANTPUR AHIRAULI, AMBEDKAR NAGAR",
  "SANJAY GANDHI P.G. COLLEGE, CHAUKIA, SULTANPUR",
  "HULASI DEVI SMRITI MAHAVIDYALAYA, DEVDHAM, GANJA, AMBEDKAR NAGAR",
  "ERAM COLLEGE, MELARIGANJ, BARABANKI",
  "SANT KABIR SANT BHAGWAN RAM SHARAN MAHAVIDYALAYA, BABAPURWA, DOODI, BARABANKI",
  "GRAMYANCHAL LAW MAHAVIDYALAYA, HAIDERGARH, BARABANKI",
  "SRI BAIJNATH SHIVKALA MAHAVIDYALAYA, MANGALPUR, TRIVEDI GANJ, BARABANKI",
  "Shri Radhakrishna Adarsh Sanskrit Mahavidyalaya, Sukhpura",
  "LATE SRI RAVINDRA SINGH MAHAVIDYALAYA, SAHIBAPUR, WAZEERGANJ, GONDA",
  "CHANDRA DENTAL COLLEGE AND HOSPITAL, SAFEDABAD, BARABANKI",
  "SAI DEGREE COLLEGE, FATEHPUR, BARABANKI",
  "BABU BASUDEV SINGH SMARAK MAHAVIDYALAYA, JAITAPUR, BAHRAICH",
  "ANGAD SINGH SMARAK MAHAVIDYALAYA, KANNOO PUR, AMBEDKAR NAGAR",
  "SHANTI SMARAK MAHAVIDYALAYA SHIKSHAN EVAM PRASHIKSHAN SANSTHA, SEMSI, FAIZABAD",
  "Jamuna Keshav Singh Memorial P.G. College,Neuwa,Samopur,Thekma, Azamgarh",
  "Janta P G College, Ranipur Mau",
  "J.P.R. Girls Degree College",
  "J S B Girls Degree College, Rudrapur, Panail, Mau",
  "KALAWATI GORAKH MAHAVIDYALAYA, MUNAUWARPUR PHOOLPUR AZAMGARH",
  "Karma Lal Bihari Degree College, Mau",
  "KARMAWATI SHIKSHAN EVAM PRASHIKSHAN SANSTHAN GONTHA DOHARIGHAT MAU",
  "KDN Mahavidyalaya, Ubarpur, Azamgarh",
  "Keshav Madhav Baijnath Mahavidyalaya, Chakavilayat, Daragah, Mau",
  "Kisan Majdur Mahavidyalaya ,Bhiti, Mau",
  "KRANTI MAHAVIDYALAYA, BAIRAMPUR AZAMGARH",
  "Krishak Mahavidyalaya, Koiriyapar ,Mau",
  "Krishna Institute of Education for Womens, Tenduli, Paligarh, Mau",
  "Krishna Mahavidyalaya, Taajpur , (Usmanpur) Pipridih , Mau",
  "Krishna Patel Mahavidyalaya, Rohuvar Vaidauli",
  "Kuba Mahavidyalaya,Dariyapur,Newada, Azamgarh",
  "Kumar Parmarth Baba Govind Mahavidyalaya Kalyanpur ,Mau",
  "Kumud Singh Mahavidyalaya,Masuriypur,Nanijor,Azamgarh",
  "KUNWAR SINGH SMARAK MAHAVIDYALAYA, DEEH AMILO AZAMGARH",
  "KUSUM DEVI MAHILA MAHAVIDYALAYA BANKATA BAZAR GOSAIN AZAMGARH",
  "Lakshmi Narayan Mahavidyalaya, Kushmaur, Pakhaipur, Mau",
  "LALCHANDRA KANHAYA JI MAHAVIDYALAYA, TISAURA MAFI BADAHGANJ, AZAMGARH",
  "Lalsar Krishak Mahavidyalaya, Takteuwa Rampur, Mau",
  "Lalti Mahila Mahavidyalay, Bangaon ,Azamgarh",
  "Late Ishdatt Smarak Mahavidyalaya,Devara Kadim,Maharajganj Azamgarh",
  "Late Kalpanath Mahavidyalaya,Barserwa,Ahirauli,Lalganj, Azamgarh",
  "LAUJARI ISARAWATI MAHAVIDYALAYA BABHANAULI MAFI UCHGAON AZAMGARH",
  "LODI KISAN MAHAVIDYALAYA, MAHADEVPUR SENPUR AZAMGARH",
  "Maa Astbhuji Mahila Mahavidyalaya, Belau",
  "Maa Babuna Balika Mahavidyalaya,Badgahan Azamgarh",
  "Maa Buddha National Mahavidyalaya,Gandhwai, Azamgarh",
  "Maa Chandrawati Devi Mahila Mahavidyalay, Mehnagar, Azamgarh",
  "Maa Chanrami Devi Mahila Mahavidyalaya, Tamrua",
  "Maa Dhanwati Mahavidyalaya,Singhpur, Azamgarh",
  "Maa Durga ji Mahavidyalaya, Durwasa, Dharmdaspur, Azamgarh",
  "Maa Gauri Mahila Mahavidyalaya, Gambhirvan Chakval, Azamgarh",
  "MAA HARIDASI SMARAK MAHILA MAHAVIDYALAYA CHITTEPUR AZAMGARH",
  "Maa Ismati Devi Mahila Mahavidyalay, Bijarwa, Bankat, Azamgarh",
  "Maa Kailashi Anari Leela Mahavidyalaya. Gondapur,  Azamgarh",
  "Maa Kamla Mahavidyalaya, Tejpur Sultanpur, Azamgarh",
  "MAA MALTI DEVI  MAHILA MAHAVIDYALAYA, KANILA",
  "Maa Mewati Tara Devi Institute of Girls Education, Dhaurhara, Mau",
  "Maa Murati Balika Mahavidyalaya,Balrampur, Azamgarh",
  "MAA PRABHAWATI BALIKA MAHAVIDYALAYA, SURAI, SATHIYANV, AZAMGARH",
  "MAA SHAKUNTALA INSTITUTE OF EDUCATION MATLUBPUR AZAMGARH",
  "MAA SHAKUNTALA MAHILA MAHAVIDYALAYA, AMARHAT",
  "MAA SHARDA JAMUNA MAHAVIDYALAY, TANDWAKHAS KHARIHANI",
  "Maa Sharda Law Collage Gahji Azamgarh",
  "MAHARANA PRATAP MAHAVIDYALAYA, FAIZABAD",
  "PT. SHIV RATAN DUBEY BALIKA MAHAVIDYALAYA, DUBEYPUR, KUREBHAR, SULTANPUR",
  "Maa Sharda Mahavidyalaya Singhpur Saraiya Maholi Azamgarh",
  "Maa Shringari Smarak Mahila Mahavidyalaya,Bharauli, Azamgarh",
  "MAA SUDAMI DEVI MAHILA MAHAVIDYALAYA, KARIYABAR SEMARI AZAMGARH",
  "MAA SUSHILA SINGH GIRLS COLLEGE OF EDUCATION JAKHAWAN BARAUNA AZAMGARH",
  "Maa Vaishno Mahila Mahavidyalaya, Kishundaspur, Azamgarh",
  "Maa Vindhyavasini Shikshan Seva Trust Mahila Mahavidyalaya Chakhasan Bandhanpur Surajpur Mau",
  "Mahadev Ramsoch Krishak Mahavidyalay, Sipah, Ibrahimabad, Mau",
  "MAHAMAYA MAHAVIDYALAY, BADGAHAN, AZAMGARH",
  "Maharshi Baba Lodidas Mahavidyalaya, Khurahat, Mau",
  "MAHARSHI DAYANAND MAHAVIDYALAYA LAKHANI MUBARAKPUR GHOSI MAU",
  "Mahatma Ashau Baba KKP Institute of Education, Tokangadha, Azamgarh",
  "Mahatma Buddha samaj Kalyan Mahila Mahavidyalay Bhiti Mau",
  "MAIMUNNISHA MUSLIM MAHILA MAHAVIDYALAYA BILAUNJHA MAU",
  "Maina Devi Mahavidyalaya,Baidauli, Azamgarh",
  "Majidun Nisa Girls Degree College, Kopaganj ,Mau",
  "M A MEMORIAL GIRLS DEGREE COLLEGE, COLBAJ BAHADUR Azamgarh",
  "Mangaru Memorial Mahila Mahavidyalay, Mau",
  "Shri Harihar Ji Mahavidyalaya, Azamgarh,Fariha,Nijamabad,Azamgarh",
  "Shri Harishankar Ji Mahavidyalaya,Rampur,Jahanaganj Azamgarh",
  "Shri Jagdish Degree College Sihuka Abeerpur Mehnajpur Azamgarh",
  "Shri Jagdish Narayan Mahendra Prasad Mahavidyalaya,Raghupur, Azamgarh",
  "Shri Jagroop Yadav Smarak Vidhi Mahavidyalaya, Mau",
  "Shri Kamalnath Singh Mahavidyalaya,Barohi,Fattehpur Azamgarh",
  "SHRI KASHI CHANDRADEV YADAV MAHAVIDYALAYA, HAZIPUR BAMHAUR AZAMGARH",
  "SHRI KAWALDHARI MAHILA MAHAVIDYALAYA BABA KATAIEGANJ ISHWARPUR AZAMGARH",
  "Shri K.N. Singh Mahila Mahavidyalaya,Nagar Chetra,Jiyanpur, Azamgarh",
  "Shri Komal Sahu Smarak Mahavidyalaya,Punapar(Badhagaw),Jiyanpur, Azamgarh",
  "Shri Krishna Ambedkar Mahavidyalaya, Madhuvan, Mau",
  "SHRI KRISHNA MAHILA MAHAVIDYALYA, SIPAH, IBRAHIMABAD, MAU",
  "Shri Krishnan P. G. College, Bansgaon Azamgarh",
  "SHREEMATI INDIRA GANDHI MAHAVIDYALYA, DUMARI, MARYADPUR, MAU",
  "SHRI MUKTINAT SMARAK MAHAVIDLYAY, PARAMUBARAKPUR",
  "SHRI NAANHU YADAV KISAN BALIKA MAHAVIDYALAY, BHAGVANPUR HARAURA AZAMGARH",
  "Shri Raghunath Prashad Shau Mahila Mahavidyalya",
  "Shri Ramashrey Jagdamba Gramin Mahavidyalaya,Jamuwa, Azamgarh",
  "Shri Ramdhani Kisan Mahavidyalaya,Badhra,Uchhuya, Azamgarh",
  "SHRI RAMDHARI CHAUHAN MAHAVIDYALAYA, BASTI, KHIRIYA, MAU",
  "Shri Ramdwar Pandey Mahavidyalaya,Laradpur,Orilpur, Azamgarh",
  "SHRI RAM JANAKI MAHILA MAHAVIDYALAYA UMARIGANESHPUR MEHNAGAR AZAMGARH",
  "SHRI SHANKAR DURGA JEE MAHAVIDYALAYA, KHARCHALPUR, JAMALPUR, SOFIPUR, AZAMGARH",
  "SHRI SHARDA GYAN MAHILA MAHAVIDYALAYA BARAIPUR MIYAPUR MAU",
  "SHRI SHARDA GYAN MAHILA MAHAVIDYALAYA LILHAVA DHARMPUR VISHUNPUR MAU",
  "Shri Sharda Mahavidyalaya,Khorampur,Beloun, Azamgarh",
  "SHRI SHARDA MATA PRASAD DEGREE COLLEGE, MAIKHARAGPUR, AZAMGARH",
  "Shri Shiva Degree College,Terahi Captainganj Azamgarh",
  "Shri Shiv Baba Mahavidyalaya ,Dadanpur, Allupur, Pidsai, Mau",
  "SHRI TARA VISHRAM GIRLS COLLEGE JAMADARA CHAKRA MAU",
  "SHYAMKARAN SMARAK  MAHAVIDYALAYA, SAIFPUR URF BAAJANPUR AZAMGARH",
  "Sitaram Ramanand  Smarak Snatkottar Mahavidyalaya,Sameda, Azamgarh",
  "S K D Girls Degree College Vidavanpur Azamgarh",
  "Smt Gujrati Devi Mahavidyalaya Gadanpur Hichchhanpatti Azamgarh",
  "Sri Baba Yugul Veer Mahila Mahavidyalaya Abilasan Jahanaganj Azamgarh",
  "Sri Gobardhan Mahila Mahavidyalaya Kathatraon Mau",
  "Sri Krishna Geeta Rastriy Mahavidyalaya, Lalganj, Azamgarh",
  "S S D BALIKA MAHAVIDYALAYA MUHAMMADPUR KODARA SAGARI AZAMGARH",
  "Sugwanti Smarak Mahavidyalaya, Kajha, Mau",
  "Sukhram Singh Mahavidyalaya, Sarva, Mau",
  "Sukhram Singh Shikshak Prashikshan Sansthan Pardaha Mau ",
  "Sukhram Singh Shikshan Prashikshan Sansthan, Sarwa, Mau",
  "Sunshine Girls Degree College,Panti Jegaha,Azamgarh",
  "Suryanath Ramugrah Mahavidyalaya Mau",
  "Sushila Rai Mahila Mahavidyalaya,Saray Mohan, Azamgarh",
  "Swami Sahjanand Janta P.G Collage,Hareya Azamgarh",
  "SWAMI SAHAJANAND SARASWATI SHIKSHAN PRASHIKSHAN SANSTHAN, JIWALI, AZAMGARH",
  "Swami Vivekanand Mahila Mahavidyalaya Khalisa Ramnager Mod Mau",
  "SWATANTRATA  SANGRAM SENANI PRAMHANS MISHRA BANSRAJI DEVI MAHILA MAHAVIDLYAY, RIAYA",
  "Swatantrta Sangram Senani Mahendra Mahavidyalaya, Haldharpur Mau",
  "Sw Shrimati Indira Gandhi Balika Mahavidyalaya, Ghosi, Mau",
  "Talimuddin Niswa Mahavidyalaya",
  "Tapeshwar Dharmeshwar Prasad Vidhi Mahavidyalaya, Gangaupur, Madhuban, Mau",
  "TRILOKI SINGH SMARAK D EL ED PRASHIKSHAN SANSTHAN RATUAPAR AZAMGARH",
  "UDAIRAJ SINGH RAMPYARI MAHAVIDYALYA, JALALPUR, KAUDIYA  AZAMGARH",
  "ULTRA MODERN GIRLS DEGREE COLLEGE, MEHNAGAR AZAMGARH",
  "VBS Mahila Mahavidyalaya, Allipur, Dagaulee, Mau",
  "Verma Shyam Dulari College of Education Araji Dewara Nainijor Azamgarh",
  "Verma Shyam Dulari Mahavidyalaya,A.D.Nainijor., Azamgarh",
  "Vikayal Vikrama Rai Mahavidyalaya, Harya Azamghar",
  "Vinayak Public School Fariha Nijamabad Azamgarh",
  "Vishwa Nath Smarak Mahavidyalaya, Kabutra, Moholi, Azamgarh",
  "Yogendra Mahavidyalaya,Kamhriya,Kharihani, Azamgarh",
  "SARASWATHI COLLEGE OF PHARMACY ANWARPUR, PILKHUWA, HAPUR",
  "SETH VISHAMBHAR NATH INSTITUTE OF HIGHER STUDIES, BARABANKI",
  "SRI BALDEV SINGH BHALE SULTANPUR MAHAVIDYALAYA, HALIAPUR, SULTANPUR",
  "INSTITUTE OF ENVIRONMENT AND MANAGEMENT, JUGGAUR, BARABANKI",
  "JHAMBABA MAHAVIDYALAYA, SOORJUPUR, AMBEDKAR NAGAR",
  "RAGHAURAM DIWAKAR DUTT GYANODAI MAHAVIDYALAYA, DIWAKAR NAGAR, GONDA",
  "SANJEEVANI MAHAVIDYALAYA, KIRTANPUR, BAHRAICH",
  "MADHAV SAROVODAY MAHAVIDYALAYA, MUKALPUR, AMAUNA, RANI BAZAR, FAIZABAD",
  "JHUNJHUNWALA MAHAVIDYALAYA, DWARIKAPURI, FAIZABAD",
  "URMILA MAHAVIDYALAYA, UNCHGAON, RAMPUR BHAGAN, FAIZABAD",
  "GAYATRI VIDYAPEETH P.G. COLLEGE, RISIA, BAHRAICH",
  "HIND INSTITUTE OF MEDICAL SCIENCES, RAILWAY CROSSING, SAFEDABAD, BARABANKI",
  "MAHATMA JAGJEEVAN SAHAB MAHAVIDYALAYA, AMANIGANJ, FAIZABAD",
  "GRAMODAY MAHAVIDYALAYA, RAMPUR SARGHA, FAIZABAD",
  "MEDAI PRASAD YADAV MAHAVIDYALAYA, RAIPUR BHATNI, PRATAPGARH",
  "KAMLA BAJRANG BALIKA MAHAVIDYALAYA, HEERAGANJ, EDHA, KUNDA, PRATAPGARH",
  "BABU SANT BUX MAHAVIDYALAYA, SANDWA DUBAN, SAHABGANJ, PRATAPGARH",
  "RAM KHELAWAN JAGANNATH P.G. COLLEGE SARAIYA CHHATIRAWA AYODHYA",
  "SARVODAY MAHAVIDYALAYA, MIHIPURWA, BAHRAICH",
  "SRI GANESH JI GRAM VIKAS SHIKSHAN SANSTHAN MAHAVIDYALAYA, BHUJGI, AMBEDKARNAGAR",
  "NAVYUG MAHAVIDYALAYA, RATANPUR BARI, SULTANPUR",
  "SHIV MAHAVIDYALAYA, AMDAHI, BANDIPUR, AMBEDKAR NAGAR",
  "MAHARANA PRATAP SMARAK SHIKSHAN PRASHIKSHAN SANSTHAN, NAGAHRA, GOSAIGANJ, AMBEDKAR NAGAR",
  "RAM UJAGIR MAHAVIDYALAYA, BASOHARI, AMBEDKAR NAGAR",
  "BABA BARUADAS SHIKSHAN SANSTHAN MAHILA MAHAVIDYALAYA, MAGANPUR, SHAHUPUR, JALALPUR, AMBEDKAR NAGAR",
  "J AND A LAW COLLEGE",
  "GRAMODAYA LAW COLLEGE, AMARPURKASHI, BILARI DISTT MORADABAD ",
  "UDAYVEER SINGH KANYA MAHAVIDYALAYA  QASAMPUR JAGRUP PAWANSA SAMBHAL",
  "KALAWATI GIRLS MAHAVIDYALAYA, SHAHPUR LAPTA, SULTANPUR",
  "SMT. KAMLA RAM UDIT MAHAVIDYALAYA, KANAKSINGHPUR, AMETHI, SULTANPUR",
  "DR. LOHIA MAHILA MAHAVIDYALAYA, KUCHERA, FAIZABAD",
  "HARSH MAHILA MAHAVIDYALAYA, DEHLI BAZAR, SULTANPUR",
  "SARDAR VALLABH BHAI PATEL MAHAVIDYALAYA SAPAHA CHITRAKOOT",
  "A.P.S. MAHAVIDYALAYA, CHAKRASENPUR, ANAND NAGAR, AMBEDKAR NAGAR",
  "Shri Diamond Jubali Anglo Raja Raghubar Dayal Adarsh Sanskrit Mahavidyalaya,",
  "THAKURDEEN PATHAK SMRITI MAHAVIDYALAYA, SAIDEHI, AMBEDKAR NAGAR",
  "M.D. COLLEGE OF TECHNOLOGY AND MANAGEMENT, AMARSANDA, BARABANKI",
  "Ginni Devi Modi Sanskrit Vidyapeeth, Modi Nagar",
  "BABA VISHWANATH SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA, LOFTABAD, BACHAULI, BIKAPUR, FAIZABAD",
  "UDAI MAHAVIDYALAYA, RUSIA MAFI, BIKAPUR, FAIZABAD",
  "SRI RAM SINGH GULERIA SMARAK MAHAVIDYALAYA, YASHWANT NAGAR, KURAWAN, FAIZABAD",
  "COLONEL ISHWARI SINGH MAHAVIDYALAYA SHEKHPUR BUZURG JALAUN",
  "KALPANA SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA, SARAI MANOHAR, HAIDERGANJ, FAIZABAD",
  "Chidanand Sanskrit Mahavidyalaya, Pathani Tola",
  "PARAG DEI MAHILA MAHAVIDYALAYA, HALIYAPUR, SULTANPUR",
  "SRI MAHADEV SHIKSHAN SANSTHAN MAHAVIDYALAYA, RAMNAGAR, TARHAR, GONDA",
  "'SHYAM MANOHAR DEGREE COLLEGE, FEROZPUR, PAKARIYARPUR, FATEHPUR, BARABANKI",
  "BABA JANGALI MAHILA MAHAVIDYALAYA SALEMPUR RANJEETPUR, GHAZIPUR",
  "SADHANA ADARSH RAMAN EDUCATION POINT, BAGHOL, JANGIPUR, GHAZIPUR",
  "RAJA PREM SINGH SHIKSHA MAHAVIDYALAYA, KOTHI RAJA HEERA SINGH, BAHRAICH",
  "MANYAWAR KANSHIRAM SNATKOTTAR MAHAVIDYALAYA, ASIDHA (KHARGUPUR), GONDA",
  "GAYA PARSAD INSTITUTE OF HUMAN EXCLLENCE",
  "SHRI BABUNANDAN ADARSH VIDHI MAHAVIDYALAYA RAMPUR BANTRA NANDGANJ GHAZIPUR",
  "ALIGARH COLLEGE OF ENGINEERING AND MANAGEMENT",
  "RAM DIHAL SINGH MAHAVIDYALAYA, GARAYE BHARKHARI, LAMBHUA, SULTANPUR",
  "DR. ASHOK KUMAR SMARAK MAHAVIDYALAYA, TAMSA MARG, AKBARPUR, AMBEDKAR NAGAR",
  "LATE.FAUJDAR SINGH CHAUHAN GIRL DEGREE COLLAGE PALI GHAZIPUR",
  "RANI SUSHMA DEVI MAHILA MAHAVIDYALAYA, AMETHI, SULTANPUR",
  "PT.MAHARAJDEEN SHUKLA SHIKSHAN SEWA SANSTHAN",
  "T.R.C. LAW COLLEGE, BASUDEV NAGAR, SATRIKH, BARABANKI",
  "Govind Ballabh Pant Social Science Institute",
  "Ewing Christian College(Autonomous College)",
  "Arya Kanya Degree College",
  "Gyan Bharti College of Education",
  "NIRANJAN SINGH MAHAVIDYALAYA, UGU, SAFIPUR",
  "SHRI RAM INSTITUTE OF EDUCATION TIMAKIYA, BAGHPAT ROAD MEERUT",
  "RAGHUVEER SHARAN MEMORIAL DEGEE COLLEGE SHAKURPUR, MODINAGAR, GHAZIABAD",
  "SUMMER FIELD COLLEGE OF HIGHER EDUCATION GOVINDPURI, MODINAGAR, GHAZIABAD",
  "PARSANDI DEVI COLLEGE OF LAW BILASHPUR, GREATER NOIDA",
  "KAILASH INSTITUTE OF NURSING AND PARA-MEDICAL SCIENCE 46-A/1, KNOWLEDGE PARK-3, GREATER NOIDA Ph.9810039905, 9818097543",
  "SHRI ASHARAM DIGEMBER JAIN GIRLS COLLEGE CHHAPRAULI, BAGHPAT",
  "GANDHI SAMARAK DEVNAGARI MAHAVIDYALAYA, PARICHATI GARH, MEERUT",
  "D.A.V. College, Bulandshahr Mob.No.9897534305 05732-234655",
  "J.P. INSTITUTE OF EDUCATION & APPLIED SCIENCE, P.O. RAJPURA, MAWANA ROAD, MEERUT  Ph. No :-  0121-2622577, 2622477, 9837285666",
  "DEWAN INSTITUTE OF MANAGEMENT STUDIES PARTAPUR BYE PASS ROAD, MEERUT Ph. No :- 0121-2440315. 375 Fax No 0121-2440337",
  "SANKALP INSTITUTE OF EDUCATION  DUHAI,  GHAZIABAD",
  "Vidyawati Devi Mahavidhyalaya, Vaishnavi Nagar, Jharahi",
  "KAKA BHUKHAN SINGH GAYA BAKSH SINGH MAHAVIDYALAYA",
  "Kanhaiyalal Saumydarsh Sanskrit Mahavidyalaya,Gwaliar Road",
  "GLOBAL INSTITUTE OF EDUCATION 32-A, KNOWLEDGE PARK-I, GREATER NOIDA Ph. No :-   0120-3227187, 09899696752",
  "Gangeswar Sanskrit  Ved Vidyalaya, Paramanand Ashram, Jhoonsi",
  "DR. RAM MANOHAR LOHIA  CHOBISA MAHAVIDYALAYA,  MOHANA, BULANDSHAHR",
  "JAI MAA SAVITRI GROUP OF INSTITUTIONS NH-24, HAPUR",
  "PARSANDI DEVI COLLEGE OF MANAGEMENT &TECHNOLOGY, BILASHPUR, GREATER NOIDA",
  "NEETU SMRATI VIDHI MAHAVIDYALAYA",
  "JANHIT INSTITUTE OF EDUCATION MATIYALA, GHAZIABAD",
  "S.S.S.S. College Rasana (Meerut) Mob. No.9412109158",
  "Digambar Degree College Dibai Bulandshahr",
  "MEERUT COLLEGE OF ADVANCE TECHNOLOGY SECTOR-2, POCKET-A, SHATABDI NAGAR, MEERUT Ph. No. 0121, 2441618, 2441617",
  "SH. SWAMI DAYAL BHATNAGAR LAW  COLLEGE SIKANDRABAD, BULANDSHAHR",
  "ACADEMY OF BUSINESS MANAGEMENT \"GYAN STHALI\", HAPUR ROAD, MODINAGAR (GHAZIABAD), Ph. 9837626264, 9639003766, 9411901161",
  "SHRI BALAJI DEGREE COLLEGE , KURALI MEERUT BAGHPAT ROAD , MEERUT Ph.",
  "CH. CHARAN SINGH COLLEGE OF EDUCATION & TECHNOLOGY SADARPUR, MEERUT PH. 0121-2765886, 0941201494 www.ccseducation.co.in, email-sukh.path@yahoo.com",
  "HARLAL SCHOOL OF LAW PLOT No. - 8, INSTITUTIONAL AREA, GREATER NOIDA Ph. No :-  09810128598",
  "M.M.H. College, Ghaziabad",
  "NEELKANTH VIDYAPEETH NH-58, PAWLI KHAS, MODIPURAM, MEERUT",
  "RAM SHIROMANI GITA SHIKSHAK PRASIKSHAN SANSTHAN",
  "JAN KALYAN INSTITUTE OF TECHNICAL EXCELLENCE",
  "JAGMOHAN COLLEGE OF LAW MASURI LINK ROAD, KHEKRA, BAGHPAT",
  "SHANTI NIKETAN COLLEGE OF LAW VILL KAYASTH GAVRI MOHIUDDINPUR ,MEERUT",
  "S.S.D. KANYA  DEGREE COLLEGE DABAI, BULANDSHAHR",
  "INDRAPRASTH COLLEGE KILLA ROAD, BHAWANAPUR, MEERUT",
  "RUDRA INSTITUTE OF TECHNOLOGY, NH-119, MAWANA KHURD, MEERUT Ph. 9897100201, 9415328178",
  "NEW ERA COLLEGE OF EDUCATION 616, BHIKANPUR, DUHAI, MEERUT ROAD, GHAZIABAD Ph. No. 0120-2675610, 2675710",
  "NGI COLLEGE OF PHARMACY",
  "DEV BHOOMI SCHOOL OF PROFESSIONAL STUDIES DABKI ROAD, VILLAGE-BERI JAMA (JUST 7 KMS FROM CLOCK TOWER) DISTT.- SAHARANPUR 0132-2792208-10-11",
  "SHRI BAKABIHARI DENTAL COLLEGE & RESEARCH CENTRE, MASURI, GHAZIABAD",
  "R.J. INSTITUTE OF HIGHER EDUCATION  CHAUNDERA",
  "PADMAWATI BAL VIDYAPEETH POCKET-B, DEFCE ENCLAVE, MEERUT",
  "INSTITUTE OF EDUCATION & MANAGEMENT, K. ROAD CHAUPLA, HAPUR",
  "INSTITUTE OF MANAGEMENT AND SCIENCES",
  "SYANA DEGREE COLLEGE GHANSOORPUR, BULANDSHAHR",
  "CH. TARA CHAND DEGREE COLLEGE, TAGA SARAI, HAPUR  ",
  "VINAYAK VIDYAPEETH,  NH-58, PAWLIKHAS, MODIPURAM, MEERUT Ph. 9897796608, 9760077770",
  "RARDHANA DEGREE COLLEGE RARDHANA MEERUT",
  "JURIS  COLLEGE  OF  LAW ",
  "L.R.College, Sahibabad, Ghaziabad",
  "ROYAL COLLEGE OF LAW ,TWENTY EIGHT KM, NH- twenty four, DASNA ,post ,Adhyatmik nagar , Ghaziabad",
  "COLLEGE OF EDUCATION ,COED,  BULANDSHAHAR ROAD  INDUSTRIAL.  AREA, GHAZIABAD",
  "R. V. HIGHER EDUCATION & TECHNICAL INSTITUTE G. T. ROAD, CHITHERA DADRI, G.B. NAGAR Ph. No. :-  09810981348",
  "GALGOTIAS INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "SH. HOTI SINGH MAHENDRA SINGH ADRESH KANYA MAHAVIDYALAYA, PAHASU, BULANDSHAHR",
  "A.P.S. COLLEGE OF EDUCATION SARDHANA, BINAULI ROAD, NEAR BHOONI CHOWK, TEH.SARDHANA, JULEDHA, MEERUT",
  "APEX INSTITUTE OF MGMT. STUDIES & RESEARCH VILLAGE-GHAT ROAD, PARTAPUR BYPASS, P.O. M.I.E.T.MEERUT, Ph. No :-   2645461",
  "GALGOTIAS COLLEGE OF PHARMACY",
  "CH. MAHKAR SINGH COLLEGE OF EDUCATION  KHARA NO. 333, PABARSA, POST-DAURALA, MEERUT",
  "R K INSTITUTE OF AYURVEDIC MEDICAL SCIENCES",
  "H.L.M. LAW COLLEGE ,DUHAI ,GHAZIABAD",
  "BHAGWATI INSTITUTE  OF TECHNOLOGY & SCIENCE MASOORI NAHAR, MASOORI, GHAZIABAD",
  "H.R. INSTITUTE OF SCIENCE & TECHNOLOGY 7TH KM STONE, DELHI-MEERUT ROAD, MORTA GHAZIABAD, PH NO. 120-2679173",
  "DELHI COLLEGE OF STUDIES,  A FOURTY FIVE,  SITE NO, IV  INDSTRIAL AREA, SAHIBABAD, GHAZIABAD",
  "MAHAVEER INSTITUTE OF TECHNOLOGY,  POHALI, SARADHANA ROAD, MEERUT",
  "I.M.E. LAW COLLEGE 178, MAIN G.T. ROAD, SAHIBABAD (GHAZIABAD) Ph. No :- 627646",
  "SIR MADANLAL INSTITUTE OF NURSING AND PARAMEDICAL",
  "S.R. COLLEGE OF EDUCATION INCHOLI, MAWANA ROAD, MEERUT",
  "HIMALIYAN GROUP OF INSTITUTE LOYAM, MALAKPUR, BARAUT, BAGHPAT",
  "INSTITUTE FOR EDUCATION & TECHNICAL SCIENCES, NH ,FIFTY EIGHT, ABUPUR ROAD MURADNAGAR,, GHAZIABAD,",
  "LATE RAM SINGH PATEL MAHAVIDHYALAYA",
  "MEERUT COLLEGE OF PROFESSIONAL EDUCATION KHIRWA JALALPUR, MEERUT MOB. 9219598018, 9456829015",
  "LAKHI DEVI RAMCHANDRA SHUKLA MAHAVIDYALAYA HARPUR BUDHAT GORAKHPUR",
  "ROYAL EDUCATIONAL INSTITUTE ,TWENTY EIGHT KM , NH-TWENTY FOUR  , DASNA POST, ADHYATMIK NAGAR,  GHAZIABAD",
  "BABA SAIJNATH PAHLWAN SHIKSHAN SANSTHAN ",
  "SHREE BHOLANATH MAHILA MAHAVIDYALAYA ",
  "INSTITUTE OF DENTAL STUDIES & TECHNOLOGIES ,GHAZIABAD",
  "SURYANSH COLLEGE OF HIGHER EDU. FOR GIRLS PAWALI ROAD, PARATPUR BY-PASS, MEERUT",
  "RAGHUWAR DAYAL PRABHU DAYAL GIRLS (P.G.) COLLEGE,  BHAIPUR DORAHA, JAHANGIRABAD, BULANDSHAHR",
  "SHRI MADHAV COLLEGE OF EDUCATION & TECHNOLOGY, KESHAV NAGAR, HAPUR",
  "I. P. S. (INSTITUTE OF PROFESSIONAL STUDIES) KASHI, PARTAPUR, DELHI ROAD, MEERUT Ph. 0121- 6521979, 9837228873",
  "M N D MAHILA MAHAVIDYALAYA, KHARGUPUR ALAPUR",
  "CH. MAHKAR SINGH GIRLS COLLEGE OF EDUCATION AND TECHNOLOGY, VILL. PABARSA, POST-DAURALA, SARDHANA, MEERUT",
  "ADHUNIK INSTITUTE OF EDUCATION & RESEARCH  DUHAI, (GHAZIABAD)",
  "SHYAMLAL SARASWATI MAHAVIDYALAYA, SHIKARPUR BULANDSHAHR",
  "VISHVASARIA COLLEGE OF EDUCATION MAGHRAJPUR, MEERUT",
  "Amar Singh College, Lakhaoti, Bulandshahr",
  "NOIDA INSTITUTE OF ENGINEERING AND TECHNOLOGY (PHARMACY INSTITUTE)",
  "STELLER INSTITUTE OF PHARMACY",
  "DISHA INSTITUTE OF PHARMACY",
  "SWARGIYA RAMAKSHAIBAR SINGH SHIKSHAN SANSTHAN SANSKRIT MAHAVIDYALAYA",
  "NIRMALA SANSKRIT MAHAVIDYALAYA, RATASI, BADLAPUR, JAUNPUR",
  "MANGALMAY INSTITUTE OF MGMT & TECHNOLOGY KNOWLEDGE PARK II GREATER NOIDA",
  "A P MAHAVIDYALAYA",
  "Sitaram Samarpan Mahavidyalaya",
  "Swami Krishnanand College",
  "Tikaram Yadav Smriti Mahavidyalaya, Moth, Jhansi",
  "Shri Swami Nagaji Girls College",
  "SRIMATI SHYAMADEVI SANSKRIT MAHAVIDYALAYA AMWA KAUSHAMBI",
  "Atarra P.G. College",
  "Uday Pratap Mahila Mahavidyalay Kuttubpur, Ghazipur ",
  "Smt Omvati College",
  "LBS LAW COLLEGE",
  "SW. GAPHOOR KHAN MAHAVIDYALAYA BABINA, KADAURA",
  "SHREE DEEPCHANDRA CHOUDHARY COLLEGE OF LAW, LALITPUR",
  "DAYANAND VEDIC COLLEGE, ORAI ",
  "H L A L DEGREE COLLEGE AND TECHONOLAGY VIMAWAL RAMNAGAR AMBEDKAR NAGAR",
  "CH. SOBRAN SINGH MAHAVIDHYALAYA",
  "ANJUM MAHILA MAHAVIDYALAYA, MAHUAWA, PARWARPAR KUSHINAGAR",
  "MOTICHAND INSTITUTE OF HIGHER EDUCATION RESEARCH AND TECHNOLOGY ",
  "R V NORTHLAND INSTITUTE OF MANAGEMENT",
  "Shikhar Institute of Pharmacy",
  "C.B Gupta B.S.S Mahavidyalya,Chandrawal",
  "Maa Ram Dulari Balika Mahavidyalaya, Ghazipur",
  "Sw Tufani Pahalwan Adarsh Mahila Mahavidyalaya Arakhpur Meerpur Ghazipur",
  "PT RAJENDRA PRASAD SMARAK COLLEGE OF PHARMACY",
  "RAJKIYA ENGINEERING COLLEGE, KANNAUJ",
  "K G INSTITUTE OF EDUCATION",
  "Arya Mahila Post Graduate College, Chetganj",
  "DAV POST GRADUATE COLLEGE MAHARSHI DAYANAND MARG, NARHARPURA, AUSANGANJ, VARANASI",
  "NEW INSTITUTE OF SOCIAL COMMUNICATIONS, RESEARCH & TRAINING (NISCORT) , GHAZIABAD",
  "Dharm Samaj Sanskrit Mahavidyalaya,",
  "Durga Sanskrit Pathshala, Chhatrapura, Saiyadraja",
  "Adarsh Audyogik Sanskrit Mahavidyalaya, Gosaiganj",
  "Shri Brahmcharya Ashram Sanskrit Mahavidyalaya, Gyanguddi, Vrindavan",
  "Adarsh Shri Sanatan Dharm Sanskrit Mahavidyalaya, Rasmandal",
  "Shri Balvant Adarsh Sanskrit Mahavidyalaya, Duganva, Sura Bazar",
  "Sarvabhaumik Shikshasram Sanskrit Mahavidyalaya, Ghurahupur, Sarnath",
  "Adarsh Munishwar Sanskrit Mahavidyalaya, Gauramafi Patti",
  "Shri Sarasvati Brahmacharyashram Sanskrit Mahavidyalaya, Parmat",
  "Pritvipal Bhagat Smarak Sanskrit Mahavidyalaya, Dhhekvara, Kopaganj",
  "Shri Sitaram Sanskrit Mahavidyalaya, Katiyari Satranva",
  "Shri Nrishingh Veda Sanskrit Mahavidyalaya, Vidhuna, Auraiya,",
  "Shri Narayan Naga Nirankari Adarsh Sanskrit Mahavidyalaya,",
  "Shiv Sanatan Dharm Sanskrit Mahavidyalaya, Belagai",
  "Maa Sukali Devi Sanskrit Mahavidyalaya, Sahjaur, Vishunpura,",
  "Shri Bhagawati Sanskrit Mahavidyalaya, Ratanpur, Kanchanpur",
  "Shri Tiwari Vaidikadarsha Sanskrit Mahavidyalaya, Rani Ghat",
  "Shri Sarvadharmini Sanskrit Pathshala, Janaki Ghat, Ayodhya",
  "Shri Bilweshwar Sanskrit Mahavidyalaya,",
  "Shri Kapileshwar Sanskrit Mahavidyalaya, Nimaicha, Devchandpur",
  "Swami Brahmtej Sanskrit Mahavidyalaya, Sheshpur, Khutahani",
  "Balram Sanskrit Mahavidyalaya,Sirheer Siloundhi Meja",
  "Shri Kameshwar SAnskrit Pathashala, Hathras",
  "Shri Nath Sanskrit Mahavidyalaya, Hata",
  "Rudra Adhyatm Sanskrit Mahavidyalaya, Bhayat, Bhopapur",
  "Devi Dutt Tiwari Shiksha Sansthan Sanskrit Mahavidyalaya, Khoribari, Laxmipur",
  "Shri Sanskrit Mahavidyalaya, Rampur",
  "Samarath Shikshan Sansthan Sanskrit Mahavidyalaya, Khayuran",
  "SAGAR COLLEGE OF EDUCATION, MUREEDPUR, AMROHA ",
  "Shri Nath Adarsh Sanskrit Mahavidyalaya, Devipur, Mubarakpur, Tanda",
  "Varanaseya Shrichand Sanskrit College, Shivala",
  "Shri Siddheshwar Nath Adarsh Sanskrit Mahavidyalaya, Kuti Kotawa, Narayanpur",
  "Shri Krishna Sanskrit Mahavidyalaya, Raniganj, Kaithola",
  "Shri Kubernath Sanskrit Vidyalaya, Kubernath",
  "Shri Roopkala Sanskrit Vidyapeeth, Divyakalakunj, Ayodhya",
  "Nayab Abbasi  Mahavidyalaya, Amroha",
  "Shri Sanyasi Sanskrit Pathashala, Rajadepur, Sagari",
  "Shri Hardevdas Nathmal Bairolia Adarsh Sanskrit Mahavidyalaya, D. 14/110 Terineem",
  "Shri Raghunath Brahmcharya Ashram Adarsh Sanskrit Mahavidyalaya, Chandausi",
  "Sampurnanand Sanskrit Mahavidyalaya, Prabhupur",
  "Shri Nimbark Sanskrit Mahavidyalaya, Vrindavan",
  "Vidyavati Sanskrit Mahavidyalaya, Balakaranpur, Soranv",
  "NANDLAL PRABHU DEVI PROFESSIONAL INSTITUTE ",
  "S. R. GROUP OF INSTITUTIONS (COLLEGE OF SCIENCE AND ENGINEERING), JHANSI",
  "SHRI RAM EDUCATION KANYA DEGREE COLLEGE",
  "Kiran Shastri Sanskrit Mahavidyalaya, Sikandarpur",
  "Shri Seth Gayadeen Sanskrit Mahavidyalaya, Gundaura, Daudpur",
  "Shri Surya Narayan Smarak Sanskrit Mahavidyalaya,Dukhiyapur, Atarampur",
  "BALL JYOTI KANYA MAHA VIDHYALAYA ",
  "Shri Panchayati Sanskrit Mahavidyalaya, Munderavan",
  "Shri Laxmandas Yajurved Sanskrit Mahavidyalaya, Khurja",
  "Shri Gurukul Mahavidyalaya, Tatarapur",
  "SHRI RAM COLLEGE OF LAW",
  "Samar Shaheed Bharti Balika Sanskrit Mahavidyalaya, Ranbeer Sarava",
  "Shri Dwaba Sanskrit Prachar Samiti Sanskrit Vidyalaya, Bariya",
  "A N A AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "Shrimati Vidya Devi Sanskrit Mahavidyalaya, Shrikanthpur",
  "Anand Sanskrit Mahavidyalaya, Bela Mavai",
  "Shri Sadhubela Sanskrit Mahavidyalaya, Sakarkand Gali",
  "Shri Sai Academy, Amhera, Adipur, Mawana Road, Meerut",
  "Vedamau Vaidik Vidyapeeth",
  "Sanskrit Vidya Prabhodhani Pathshala, Hata",
  "Tivarinath Sanskrit Mahavidyalaya, Nainitaal Road",
  "Shri Gaurishankar Smarak Sanskrit Mahavidyalaya, Sringverpur",
  "Shri Hariram Gopal Krishna Sanatan Dharma Sanskrit Mahavidyalaya, 24 Unchamandi, Prayag",
  "THAKUR ROSHAN SINGH CONSTITUENT GOVERNMENT  COLLEGE NAVADA DAROBAST KATRA SHAHJAHANPUR",
  "Adarsh Shrisad Adarsh Sanskrit Mahavidyalaya, Bajiganj, Mallava",
  "Mata Chandravati Sanskrit Mahavidyalaya,",
  "Budhiya Mai Banvaree Sanskrit Mahavidyalaya, Shivpur Kalan, Kohdaur",
  "DISHA BHARTI COLLEGE OF MANAGEMENT & EDUCATION,  OPP. D.P.S. DELHI ROAD, SAHARANPUR MOB. NO. 09897780656, 09837053011 www.dishabharticollege.com  email.- infodishabharti@gmail.com",
  "Shri Sachchidanand Adarsh Sanskrit Pathshala, Bhurkuda",
  "Shri Durgaji Sanskrit Mahavidyalaya, Mahoba",
  "Kamlakar Adarsh Sanskrit Mahavidyalaya, Louharamau",
  "Munishwar Prasad Adarsh Sanskrit Mahavidyalaya, Pachar Bazar",
  "Adarsh Sanskrit Mahavidyalaya, Bachhana, Bilhur",
  "Swami Devanand Adarsh Sanskrit Mahavidyalaya,Devashram, Mathlar",
  "Maharshi Durvasa Sanskrit Mahavidyalaya, Kakra, Dubaval",
  "Shiv Sankat Haran Adarsh Sanskrit Mahavidyalaya, Sikoha",
  "Surya Narayan Sanskrit Mahavidyalaya, Baripur, Maharajganj",
  "Kashi Gurukul Sanskrit Mahavidyalaya, Dhoopchandi",
  "Shri Sharada Sanskrit Mahavidyalaya, 103 Vidyant Marg",
  "Mohan Das Gurukul Sanskrit Mahavidyalaya, Gopalghat",
  "Srimati Bhagirathi Trast Adarsh Sanskrit Mahavidyalaya, Chunar",
  "Visanda Sanskrit Mahavidyalaya, Visanda",
  "Adarsha Hanumat Sanskrit Mahavidyalaya, Udaichandrapur, Kerakat",
  "Shri Kashi Vidya Mandir Sanskrit Digree Colege, Mishra Pokhara",
  "Shri Sachha Adhyatma Sanskrit Mahavidyalaya, Arail, Naini",
  "Raam Pratap Snatkottar Sanskrit Mahavidyalaya, Bairahana, Mukhauta Dham",
  "Brahmarshi Yogiraj Devaraha Baba Sanskrit Mahavidyalaya, Mukhaniya",
  "Shri Thakurji Adarsh Sanskrit Mahavidyalaya, Imaliya",
  "Shri Sangved Sanskrit Mahavidyalaya, Hatwa Bazar Bhatani",
  "Shri Vaikunthnath Pavhari Sanskrit Mahavidyalaya,Vaikunthnath",
  "Satyendra Bahadur Sanskrit Mahavidyalaya, Kharagsenpur, Thanagaddi",
  "Pandit Gopinath Kaviraj Sanskrit Mahavidyalaya, Kaithi",
  "Shri Syadvad Mahavidyalaya, Bhadaini",
  "Shri Rabartsganj Sanskrit Mahavidyalaya, Rabartsganj",
  "Shri Parmanand Sanskrit Mahavidyalaya, Rasulpur, Nandlal",
  "Shri adarsh Sanskrit Mahavidyalaya, Vazidpur, Pahtiya",
  "Shri Sitaram Satsang Ashram Sanskrit Mahavidyalaya, Mishrauli, Mathura Chapar",
  "Shri Shaligram Jagannath Sanatan Dharm Adarsh Sanskrit Mahavidyalaya,",
  "Shri Ghanshyam Das Arya Vaidik Mahavidyalaya, Gurukul",
  "Bharatiya Sanskrit Mahavidyalaya, Alamganj, Urdu Bazar",
  "Sarvaya Adaesh Sanskrit Mahavidyalaya, Bahadurganj, Prayag",
  "Shri Shakha Gurukul Vaanprasthashram Sanskrit Mahavidyalaya, Makhadoom Nagar, Tanda",
  "Shri Sachha Adhyatma Sanskrit Mahavidyalaya, Sakaldiha",
  "M.L.D. Adarsh Sanskrit Mahavidyalaya, Khudaganj",
  "Shri Shubhash Sanskrit Mahavidyalaya, Miranpur",
  "Shri Bhuvneshwari Maheshwaranand Sanskrit Mahavidyalaya, Jhalokhar",
  "ADARSH BHARATI MAHAVIDYALAYA KHETASARAI JAUNPUR",
  "Babu Jagan Prasad Baijanath Sanskrit Mahavidyalaya, Hariharpur, Panchkoshi Marg",
  "Gandhi Smarak Sanskrit Mahavidyalaya, Raje Sultanpur,",
  "MAHANT DIGVIJAY NATH SANSKRIT MAHAVIDYALAYA, UMAPUR",
  "Adarsh Srikanthh Sanskrit Mahavidyalaya, Kondar, Mahakheda",
  "Jagatnarayan Sanskrit Mahavidyalaya, Jagatganj, Ramdayalganj",
  "Jagdamba Sanskrit Sangved Vidyalaya, Shanichara Bazar",
  "Shri Sankat Mochan Sanskrit Mahavidyalaya, Cheebo",
  "Shri Ramanuj Darshan Sanskrit Mahavidyalaya, Tripura Bhairavi",
  "Rishikul Sanskrit Mahavidyalaya, Sisava Bazar",
  "Srimat Paleshwar Hariprappan Sanskrit Mahavidyalaya, Sahtawar",
  "Shri Om Shankar Ji Sanskrit Snatkottar Sanskrit Mahavidyalaya, Sikandarpur",
  "Parankush Sanskrit Mahavidyalaya, Purenoti, Babooganj",
  "UTKARSH ACADEMY FARRUKHABAD",
  "Shri Vamdev Sanskrit Mahavidyalaya, Kailashpuri",
  "Ved Bhawan Sanskrit Mahavidyalaya,Shringerimath, Alopibagh",
  "Ved Vyas Sanskrit Mahavidyalaya, Naimisharanya",
  "SHRIDEVI GROUP OF HIGHER STUDIES",
  "Shri Ekarasanand Sanskrit Mahavidyalaya,",
  "Raamshankar Sangved Vidyapeeth, Kodara Chandrahar, Kopaiya",
  "Ved Vedang Sanskrit Mahavidyalaya, Nawali Torava",
  "Shri Sitaram Jayram Anglo Sanskrit Mahavidyalaya, Sumerpur",
  "NEW STEPS TECHNOLOGY GORAKHPUR",
  "Shri Alpeshwar Nath Sanskrit Mahavidyalaya, Janevara, Fatehganj",
  "Sangved Sanskrit Mahavidyalaya, Hanumangarhi",
  "Shri  Hanuman Sanskrit Vidyalaya, Samadhpur",
  "Sanskrit Pathshala, Dhipokhar Pakari Dubey",
  "Shri Sanatan Dharm Adarsh Sanskrit Mahavidyalaya, Hiraj Patti, Madhuban",
  "Jay Gurudev Sanskrit Mahavidyalaya, Bazar Patti",
  "Surendra Evam Ravindra Mishra Sanskrit Mahavidyalaya, Bidara Mishra Nagar",
  "Shri Ram Sanskrit Mahavidyalaya, Lorika",
  "SANT RAMNARAYAN RAJKISHOR SHANKAR MAHAVIDYALAYA",
  "Shri Arya Mahavidyalaya, Kirthal",
  "EAST WEST EDUCATIONAL INSTITUTE, BADNOLI, HAPUR-245101",
  "Maa Shaarda Rajnarayan Rai , Smarak Mahavidyalaya, Paali ,Ghazipur",
  "Krishna Sudama Mahavidyalaya, Maradapur, Daulat, Nagar Ghazipur",
  "Mukhram Kisan Mahavidyalaya, Dahrakala, Ghazipur",
  "Malikpura Degree College Malikpura, Ghazipur",
  "Mata Prasad Adarsh Mahavidyalaya Bhabhuri (Sherwan) Jaunpur",
  "Yshoda Mahavidyalaya, Patrahi , Jaunpur",
  "Maa Duraga Girls College,Dobhi, Jaunpur",
  "Rajesh Kumar Mahavidyalaya Kohane Sultaanpur Jaunpur",
  "Sarvodaya Vidyapith Mahavidyalaya, Meergunj Jaunpur",
  "Mohammad Hasan Degree, College ,Jaunpur",
  "Saltanat Bahadur Degree College, Badlapur Jaunpur",
  "K.D.S. Mahavidyalaya, Subhashpur, Paali, Jaunpur",
  "Shri Ramashankar Bal Gopal Mahavidyalaya, Nasirpur, Maupara, Ghazipur",
  "Mahant Pavahari Shribalkrishna Yati Kanya Mahavidyalaya Hathiyaram, Ghazipur",
  "Maa Saraswati Mahavidyalaya Damodara,Jaunpur",
  "P G College, Ghazipur (Snatkottar Mahavidyalaya Ghazipur)",
  " SHRI BATUKNATH SANSKRIT MAHAVIDYALAYA",
  "SHRI BABU LAL VIDHI MAHAVIDHYALAY GOVERDHAN MATHURA",
  "DIVYA COLLEGE OF EDUCATION, FARAH, MATHURA",
  "TRC MAHAVIDYALAYA DEPARTMENT OF PHARMACY",
  "Om Vishwanath Svarnmasukh Mahavidyalaya, Khudabakspur, Dullahpur, Ghazipur",
  "RAMCHANDRA YADAV MAHAVIDHYALAYA MAILANI LAKHIMPUR KHERI",
  "NCPE COLLEGE OF LAW",
  "SHAKUMBHARI DEGREE COLLEGE",
  "Bapu Mahavidyalaya, Sadat, Ghazipur",
  "R.D.S. Mahavidyalaya, Kushaw Bhaupar , Jaunpur",
  "Thakur Jagannath Singh Mahavidyalaya Nuaaw, Barae Jaunpur",
  "Ramnagina Kisan Mahavidyalaya, Mudiyari, Jakhaniya, Ghazipur",
  "Jatashankar Gupta Degree College, Katvar , Jaunpur",
  "Shri Ram Dular Pahalavan Mahavidyalaya, Semari Shahpur, Jaunpur",
  "Ram Avadh Yadav Ganna Krishak Mahavidyalaya,Takha, Shahganj Jaunpur",
  "Shri Mahanth Ramashraya Daas Snatkottar Mahavidyalaya Bhurkura , Ghazipur",
  "Mahavidyalaya Akarao ,Shadiyabad Ghazipur",
  "Srijan Mahavidyalaya Bhatevara Machhalishahar Jaunpur",
  "Muslim Girls Degree College,Jaunpur",
  "Pachottar Mahavidyalaya, Mardah, Ghazipur",
  "Vimala Yadav Mahavidyalaya , Akavaspatti, Bhitari, Ghazipur",
  "Himtaaj Mahavidyalaya, Nevadhiya Jaunpur",
  "Hunuman Singh Mahavidyalaya Devkali Ghazipur",
  "DR ABDUL ALI TIBBIYA COLLEGE AND HOSPITAL",
  "RAJENDRA SHILPI PATEL MAHAVIDYALAYA, DHAURAHARA, LAKHIMPUR KHERI",
  "Kashinath Mahavidyalaya, Narayanpur, Kakarhi, Daulatpur, Ghazipur",
  "Birbal Mahavidyalaya, Rasulpur Machhalishahar Jaunpur",
  "Suraybali Yadav Mahavidyalaya Devkali Saraykhvaja, Jaunpur",
  "Shri Radharaman Mahavidyalaya, Adarsh Vidyapith , Ruhipur Ghazipur",
  "Prabhu Narayan Singh Mahavidyalaya ,Baghelvanshiy, Manhi Aasharm Kasimabad Ghazipur",
  "Baba Prasidhha Narayan Mahavidyalaya ,Bagathari ,Murara, Kerakat, Jaunpur",
  "Janhit Mahavidyalaya, Gomati Nagar Mahimapur Jalalpur Jaunpur",
  "Baba Jangali Mahavidyalaya, Salempur, Vajidpur, Ghazipur",
  "Harishchand Mahavidyalaya, Kavala ,Jakhaniya, Ghazipur",
  "Shastri Dipan Chaudhari Mahavidyalaya, Bhadev, Pream Ka, Pura ,Ghazipur",
  "Shri Ganesh Rai Snatkottar, Mahavidyalaya, Dobhi, Jaunpur",
  "Sukhdev Kisan Mahavidyalaya, Phulpur, Budhanpur, Ghazipur",
  "Chaudhari Charan Singh Kisan Mahavidyalaya, Nevada, Durga, Vijay Ray,Jakhaniya Ghazipur",
  "Shrinath Alakananda Mahavidyalaya, Bhuvarpur, Anauni, Ghazipur",
  "Sarveshvari Mahavidyalaya Kamruddinpur,Rampur Jaunpur",
  "Matri Gangajali Mahavidyalaya Maudhiya, Ghazipur",
  "Ramdev Mahavidyalaya, Sirauli Meerganj, Jaunpur",
  "Khardiha Mahavidyalaya, Khardiha, Ghazipur",
  "HAJI RASHIDAN BEGUM AND HAJI SAHAB JAHAN EDUCATIONCAL INSTITUTE GANESH PUR, GANGDUNDWARA",
  "Raja Shri krishna Dutt Degree College, Jaunpur",
  "Lutavan Mahavidyalaya, Sakara, Jaitpur, Ghazipur",
  "SHAKUNTALA SINGH SINGRAUR MAHAVIDYALAYA, KAMALPUR, UCHAHAR, RAEBARELI",
  "Muneshwar Mahavidyalaya ,Vishvpalpur Baraepaar Jaunpur",
  "Shahid Smarak Rajkiya Mahavidyalaya Yusupfpur, Mohmmadabad, Ghazipur",
  "LAKSHYA ACADEMY OF HIGHER STUDIES, POORANPUR",
  "Maa Gujarati Mahavidyalaya Churawanpur Baksha , Jaunpur",
  "PRAKASH INSTITUTE OF AYURVEDIC MEDICAL SCIENCES AND RESEARCH",
  "Baba Gajadhar Daas Balika Mahavidyalaya, Aatmpur Chhpara(Sadat),Ghazipur",
  "Mulchand Mahavidyalaya, Holipur, Ghazipur",
  "Shri Marvari Sanskrit Mahavidyalaya, Meerghat",
  "SRI DURGA PAL SINGH MAHAVIDHYALAYA,PINHAT AGRA",
  "ACADEMY OF MANAG. & EXCELLENCE, 2 GAILANA ROAD AGRA",
  "CHACHA VISHAL SINGH KANYA MAHAVIDHYALYA, AGRA",
  "KISHON DILEEP SINGH BHAGAL MEMORIAL DEGREE COLLEGE, NAGLA, BRIJ DHANOLI, AGRA",
  "EXCELLENT DEGREE COLLEGE FATEHPUR SIKARI ROAD,AGRA",
  "YADUNATH PAL SINGH MAHA AHEMADPUR SIRSAGANJ,FIROZABAD",
  "Kundan Singh Memorial College of Law",
  "S.K.V. COLLEGE OF LAW, NH-2, AGRA",
  "SHRI RAGHUBIR SARAN DEGREE COLLEGE LAKHANPUR, SIKANDRA, AGRA",
  "SHRI GIRRAJ MAHAVIDYALAYA INSTT.OF MANAGEMENT MUDESHI, MATHURA",
  "N.D COLLEGE OF SCIENCE & TECHNOLOGY SHYAMO MODE SHAMSABAD ROAD,AGRA",
  "MATA SURAJ MUKHI GIRLS DEGREE COLLEGE OF COMMERCE & ECONOMICS SHADARA, AGRA",
  "RIZWAN GIRLS DEGREE COLLEGE",
  "Babu Shivpattar Rai Smarak Mahavidyalaya Ramgarh Sagri Azamgarh",
  "LALI DEVI MAHILA MAHAVIDYALAYA SHAKARKOLA KHAJURI AZAMGARH",
  "R.B.S.DEGRRE COLLEGE MADAURA MAHAVAN MATHURA",
  "UNIVERSAL PUBLIC SCHOOL FARIHA NIJAMABAD AZAMGARH",
  "MATA BHAGWATI DEVI GOVT. GIRLS DEGREE COLLEGE ANWALKHERA",
  "SHRI JAMADAR SINGH YADAV MAHAVIDHALAYA,MAINPURI",
  "SWAMI AVDUTANANAD MAHAVIDYALAYA BHAGYA NAGAR KHIRIYA,MAINPURI",
  "SMT.ROSHAN KUVER KUSUM LATA DEGREE COLLEGE MORCHA ,FIROZABAD",
  "ARYAN INSTT. OF MANAG. & COMP. STUDIES,AGRA",
  "BHARTIYA KAPILMUNI DEGREE COLLEGE,KARPIYA,BEWAR MAINPURI",
  "SHRI LAL SINGH DEGREE COLLEGE, AGRA",
  "SHRI JANGJEET SINGH MAHAVIDHYALAYA, WAZIDPUR, FATEHABAD, AGRA",
  "SHANTI DEVI AHUJA GIRLS COLLEGE OF EDUCATION,FIROZABAD",
  "PALIWAL DEGREE COLLEGE,SHIKOHABAD",
  "KRISHNA COLLEGE OF SPORTS & EDUCATION, BAMRAULI KATARA, AGRA",
  "SRI RAGHUKUL MAHAVIDYALAYA VAKALPUR KHERAGARH AGRA",
  "SHRIMATI PREM LATA MAYA DEVI AGRAWAL GIRLS DEEGRI COLLEGE RAYA MATHURA",
  "R.K.COLLEGE OF LAW CHAMELI BAGH AGRA ROAD, FIROZABAD",
  "S.R.K (PG) COLLEGE ,FIROZABAD",
  "SRI R.N YADAV MAHAVIDYALAYA BARNAHAL MAINPURI",
  "SHRI BABU LAL MAHAVIDYALAY GOVERDHAN",
  "SHRI JAGDAMBA MAHAVIDYALAYA FOUNDRY NAGAR, AGRA",
  "SANT JANU BABU COLLEGE,FIROZABAD",
  "SMT R.D. COLLEGE OL",
  "MURALIDHAR MAHAVIDYALAYA RASULPUR JAJAMPATTI",
  "S.R.D COLLEGE AGRA ROAD,SHIKOHABAD (FIROZABAD)",
  "HAZARI LAL MAHAVIDAYALAY SONKH KHERA MATHURA",
  "SHRIMATI KUSUMA DIKSHIT COLLEGE NERKHI, TUNDALA, FIROZABAD",
  "GOVT. MAHAVIDHYALAYA FATEHABAD.AGRA",
  "R.K.GUPTA MEMORIAL INSTITUTE OF TECH. & MGMT. 123 MOHAMMADPUR, SIKANDARA, AGRA",
  "Sarju Devi Mahila Mahavidyalaya ",
  "MOTI LAL RAM NATH MAHAVIDYALAYA BHADURALI BAH AGRA",
  "SEOHARA DEGREE COLLEGE, SEOHARA, BIJNOR",
  "SHRI MEGH SINGH MAHAVIDYALAYA, ABIDGARH TARRAKPUR,AGRA",
  "OMVIR SINGH SIYA RAM MAHAVIDHYALAYA, NAGLA DHARAM, FIROZABAD",
  "BAUHARE JAGANNATH SINGH VASDEV SINGH SMARK MAHAVIDHYALYA DATTACHOLI KHURD ALIGARH",
  "BABU ISHWARI PRASAD RAWAL MEMORIAL COLLEGE, SHAHJADPUR (BIJNOR)",
  "Eklavya College of Education",
  "AMBAY COLLEGE OF LAW, BABUGARH CHHAWANI, BHIMYARI, HAPUR",
  "COLLEGE OF EDUCATION, Mahoba",
  "Anu Girls Degree College, B.B Nagar, Bulandshahr",
  "Shree Guru Govind Singh College Of Education",
  "S.S. DEGREE COLLEGE, SHAMSHABAD, AGRA",
  "DWARIKDHEESH MAHAVIDYALAYA KURAWALI,MAINPURI",
  "SHRI PUTTU LAL MARG SHREE MEMORIAL MAHAVIDHYALAYA , ETORA, FIROZABAD",
  "R.B DEGREE COLLEGE,KALINDI BIHAR NARAICH,AGRA",
  "S G COLLEGE OF EDUCATION SARAIYA RATNAWE AMARI AZAMGARH ",
  "SHRI BAIJNATH MEMORIAL SCHOOL OF TEACHERS TRAINING ASONA SATHIAON AZAMGARH",
  "RAMA MAHILA DEGREE COLLEGE BY PASS ROAD KARHEL, MAINPURI",
  "Shri Sai Girls Degree College, Puranpur ",
  "Vasant Kanya Mahavidyalaya",
  "DIGAMBER JAIN COLLEGE OF EDUCATION",
  "BABU RAM YADAV MAHAVIDIYALAYA ,KARHAL MAINPURI",
  "PARSHVNATH COLLEGE OF EDUCATION",
  "ACME INST. OF MANAGEMENT & TECH. NEAR SUDHIR DHARMA KANTA SIKANDRA,AGRA",
  "SRI KISHNI MAHAVIDYALAYA ,KISHNI MAINPURI",
  "ANJALI INSTITUTE OF MANAGEMENT AND SCIENCE, AGRA",
  "SRI. SIDDI VINAYAK EDUCATION MAHAVIDYALAYA RAIBA ACCHNERA, AGRA",
  "CH.NATHU SINGH YADAV MAHAVIDYALAYA MAINPURI",
  "SRI KIRORI LAL SHASTRI MAHAVIDYALAYA JAGNER, AGRA",
  "SARVODAYA MAHAVIDYALAYA CHAUMUHAN MATHURA",
  "SHRI RAM CHARAN SINGH MAHAVIDYALAYA JATORA BALDEV, MATHURA",
  "BHADAVAR VIDHYA MANDIR MAHAVIDHYALAY,AGRA",
  "GULKANDI LALA RAM MAHAVIDYALAYA PATLONI, MATHURA",
  "KRISHNA COLLEGE OF SCIENCE & TECH. BAMRAULI KATARA AGRA",
  "GRAMODYA MAHAVIDYALAYA EKHA, FIROZABAD",
  "SHRI ROSHAN LAL INSTITUTE OF SCIENCE AND TECHNOLOGY,AGRA",
  "SMT HARPYARI DEVI MAHILLA COLLEGE JANGAJIT NAGAR SHAMSABAD ROAD, AGRA",
  "MUKDAM BIHARILAL MAHAVIDYALAY MAHUAN MATHURA",
  "C.L JAIN COLLEGE,FIROZABAD",
  "BABA DEGREE COLLEGE",
  "GOVERNMENT MEDCICAL COLLEGE, BANDA",
  "P.K. DEGREE COLLEGE GRAM TEHRA HATHRAS ROAD SONAI MATHURA",
  "DPS DEGREE COLLEGE MAHTAPUR IGLAS, ALIGARH",
  "BALAJI COLLEGE, BHABHAURA, AUDIHAR, GHAZIPUR",
  "CHAMPA DEVI MAHAVIDYALAYA",
  "GAUTAM BUDDH KANYA MAHAVIDYALAY BARAIPAR BAGHAULI SANT KABIR NAGAR",
  "SAMRAT PRATHVIRAJ CHAUHAN COLLEGE , AZMABAD ARAON FIROZABAD ( U. P.)",
  "OM DEGREE COLLEGE,SHIKOHABAD",
  "R K INSTITUTE OF MEDICAL SCIENCES",
  "KAUSHIK COLLEGE MOHAMMADPUR LALA MEERUT",
  "S.D.S. DEGREE COLLEGE KOSI  KHURD MATHURA",
  "RANVEER SINGH SHYAM SINGH MAHAVIDYALAYA DEVIDEEN NAGAR,FIROZABAD",
  "Shree Guru Tegh Bahadur Sahib Govt. Degree College, Bilaspur",
  "S.D. COLLEGE OF MANAGEMENT STUDIES, BHOPA ROAD, MUZAFFARNAGAR",
  "SMT. DASHRATH DEVI MAHAVIDYALAYA, ADARSH NAGAR PURE UDNI, SHUKUL BAZAR, SULTANPUR",
  "SMT.PATURI DEVI DEGREE COLLEGE,GARHI NANDU KIRRAWALI,AGRA",
  "AGRA VANASTHALI MAHAVIDYALAYA JHARNA NALA, CHALLESOR",
  "SRI SHANKAR SHIV MAHAVIDYALAYA PRATA PUR TUNDLA,FIROZABAD",
  "S.K.B. ACADEMY, TUNDLA ROAD, AGRA",
  "K C C INSTITUTE OF LEGAL AND HIGHER EDUCATION AFFILIATED TO C C S UNIVERSITY",
  "RAJKIYA ENGINEERING COLLEGE MAINPURI",
  "Guru Teg Bahadur Paramedical Institute",
  "CH BADAN SINGH SHANTI DEVI KANYA MAHAVIDHYALYA SHAHPUR MILWALI ETAH",
  "VEENA SUDHAKAR OJHA MAHAVIDYALAY",
  "Sri Ram Gopal College of Pharmacy",
  "Kedar Sukhdev S N O P Mahavidyalaya, Harasarpur, Chaubepur Ghazipur",
  "SARDAR PATEL MAHAVIDHAYALAYA,MALLAWAN",
  "Shri Ram Ratan Shastri Mahavidyalaya",
  "SRI RAM BHAJAN SINGH MAHAVIDHYALAYA",
  "G. L.BAJAJ INSTITUTE OF TECHNOLOGY AND MANAGEMENT, GREATER NOIDA",
  "BABU BRIJBIHARI SINGH MAHAVIDALAYA",
  "GREATER NOIDA ACADEMY OF LEGAL STUDIES AND RESEARCH",
  "lakhimpur college of education ",
  "MESCO INSTITUTE OF PHARMACY",
  "RAJKUMAR GOEL INSTITUTE OF TECHNOLOGY, GHAZIABAD UP",
  "RAMHARI MAHAVIDHYALAY, KHERAGARH, AGRA ",
  "SHRI RAM CHANDRA DEGREE COLLEGE AASHIFABAD SAMASPUR MEERUT",
  "BABU BANARSI DAS DEGREE COLLEGE, BULANDSHAHR ",
  "SRI NISHAD RAJ AKHANDA NAND MAHAVIDYALAYA, KITIYAWA, SULTANPUR",
  "ADARSH MAHAVIDHYALAY BADAHAR",
  "Maa Pyari Devi Mahavidyalay, Jaunpur",
  "Babu Banarasi Das  Engineering,College, Lucknow",
  "S.M.D. COLLEGE SOKHADEV BURJA AKOS MATHURA",
  "Muni ji Mahavidyalaya, Rupaudha, Narayanpur, Mirzapur",
  "Devendra Nath Janta P.G. College, Hasanpur, Chandauli",
  "Sri Agrasen Kanya P.G.College, Bulanala, Varanasi",
  "Institute of Computer Science and Technology,NibiaBachawan,Vns.",
  "RAJIV GANDHI VIDHAPEETH MAHAVIDHYALAYA,PAKARGAO,TILOI",
  "Manniya Kanshiram College of Education, Netanagar, Anoopshahr, Bulandshahr",
  "Shivlok Srinet Mahavidyalaya, Kapsaur, Padri, Mirzapur",
  "Jatadhari Mahavidyalaya, Marufpur, Chandauli",
  "Lal Bahadur Shsastri P.G. College, Mugalsarai, Chandauli",
  "RAFFEQ HUSSAIN MEMORIAL DEGREE COLLEGE, AMROHA",
  "SIDDHI VINAYAK MAHAVIDYALAYA PIPRA BAZAR GONDA",
  "BALA JI COLLEGE OF LAW SAURANA, SARSAWA, SAHARANPUR",
  "DAV COLLEGE OF LAW",
  "Sri Krishna Mahavidyalaya, Rauna Khurd, Varanasi",
  "LALI YADAV MAHAVIDYALAYA BAIJPUR KARAMPUR AKBARPUR AMBEDKARNAGAR",
  "K.G.S. Mahavidyalaya, Jopa, Mirzapur",
  "Government Degree College Jakkhini, Varanasi",
  "S R K MAHAVIDHYALAYA ATARIYA SITAPUR ",
  "Shri Rajendra Singh Mahavidyalaya Birno Ghazipur",
  "PHARMA DEPT SR FOUNDATION JEE COLLEGE OF EDUCATION AND TRANING",
  "SUNBEAM COLLEGE FOR WOMEN, BHAGWANPUR, LANKA, VARANASI",
  "Grayanchal Mahila Vidyapith, Gangapur, Mangari, Varanasi",
  "Bhau Rao Deoras Rajkiya Mahavidyalaya, Duddhi, Sonebhadra",
  "SHRI SARASWATI DURGA MAHILA MAHAVIDYALAYA SHERKOT BIJNOR",
  "L S VIDYAPEETH ",
  "DR SHAMIM GIRLS DEGREE COLLEGE",
  "Chaudhary Govind Singh Mahavidyalaya, Khajuri, Shahganj, Sonebhadra",
  "Sarnath Bodhisatwa Mahavidyalaya, Munari, Sarnath, Varanasi",
  "New Khusro Degree College Aonla Bareilly",
  "SRI ATMARAM SUMITRA DEVI MAHAVIDYALAYA, NEVILGANJ, BIDHUNA, AURAIYA",
  "SHERWOOD COLLEGE OF PROFESSIONAL MANAGEMENT",
  "Smt. Kanti Singh Law College, Gyanpur, Sant Ravidas Nagar, Bhadohi",
  "Swami Saran Mahavidyalaya, Chandaul",
  "B V M COLLEGE OF SCIENCE AND TECHNOLOGY",
  "SRI RAM KISHUN COLLEGE GOKUL KARASANA VARANASI",
  "Basant Ram Nagina Mahavidyalaya, Dharao, Chandauli",
  "Harinandan Mahavidyalaya, Sarai Rasulpur (Hatwapar",
  "Rajkiya Mahila Mahavidyalaya, Rabertsganj, Sonebhadra",
  "Sardar Patel Mahavidyalaya, Badhaini, Babhniyaw, Varanasi",
  "Awadhoot Bhagwan Ram P.G. College, Anpara, Sonebhadra",
  "Maa Saraswati Mahila Mahavidyalaya, Chandpur Industrial Estate, Varanasi",
  "Markandey Mahavidyalaya, Tarapur, Post- Sadalpura, Chandauli",
  "Arun Kumar Keshari Mahila Mahavidyalaya, Madhupur, Sonebhadra",
  "Rajkiya Mahila Mahavidyalaya, DLW, Varanasi",
  "ACCURATE COLLEGE OF PHARMACY",
  "Pt. Deen Dayal Upadhyay Rajkiya Mahila Mahavidyalaya, Sewapuri, Varanasi",
  "Sri Ram College of Comerse & Education, Paigamberpur, Panchkroshi Chauraha, Varanasi",
  "Vikram Singh Kanya Mahavidyalaya, Nai Satti Mugalsarai, Chandauli",
  "Suryanath Mahavidyalaya, Nidilpur, Chandauli",
  "Sant Kinaram Mahila Mahavidyalaya, Rabertsganj, Sonebhadra",
  "Sanjay Memorial womens College,Kerakatpur, Varanasi",
  "Sriram Singh Mahavidyalaya, Shivgarh, Padri, Mirzapur",
  "Sant Kinaram P.G. Mahavidyalaya, Kaimurpith, Rabertsganj, Sonebhadra",
  "KHAJAN SINGH BHANTI DEVI DEGREE COLLEGE MURSANA BULANDSHAHR",
  "SWATANTRATA SANGRAM SENANI VISHRAM SINGH GOVERNMENT POST GRADUATE COLLEGE  CHUNAR, MIRZAPUR",
  "Babu Ram Singh Mahavidyalaya, Kharpathar, Murdhwa, Renukoot, Sonebhadra",
  "RGS AYURVEDIC COLLEGE AND RESEARCH CENTRE, HOSPITAL",
  "Sri Hansraj Memorial Mahavidyalya, Rampur",
  "Baba Domandeo Mahavidyalaya, Kapisa, Danganj, Varanasi",
  "MAA KAMLA SURYA NARAYAN MAHAVIDYALAY",
  "Jay Prakash Mahavidyalaya, Umraha, Varanasi",
  "J.S.P. Mahavidyalaya, Kasyan Kala, Sonebhadra",
  "M.P.Institute of Management &Computer Aplication,Bhagtua,Chiraigaon,Varanasi",
  "Sri Bodhan Ram Mahavidyalaya, Chanbe, Mirzapur",
  "School of Management Sciences, Khushipur, Bachhawan, Varanasii",
  "Kamala arya Kanya Mahavidyalaya, Mirzapur",
  "SUDHAKAR MAHILA VIDHI MAHAVIDYALYA KHAJURI PANDEYPUR VARANASI",
  "Rajarshi School of Management and Technology, UP College Campus, Varanasi",
  "Om Uchcha Shiksha Sansthan, Vitthalpur, Gopiganj, Bhadohi",
  "Ram Lalit Singh Mahavidyalaya, Kailhat, Chunar, Mirzapur",
  "Keshav Prasad Ralhi Mahavidyalay, Aurai, Sant Ravidas Nagar, Bhadohi",
  "INSTITUTE OF OPTOMETRY AYODHYA EYE HOSPITAL",
  "Gaurav Mahavidyalaya, Deorai, Sultanipur, Danganj, Varanasi",
  "Subhash Balika Mahavidyalaya, Auri, Anpara, Sonebhadra",
  "Jhinaki Devi Smarak Degree College, Pharenda, Anandnagar, Maharajganj",
  "G.P.S. Degree College,  Khalilabad, Sant Kabir Nagar",
  "ASIAN SCHOOL OF BUSINESS ",
  "GAYADEI MAHILA MAHAVIDYALAYA DURGAPUR ROAD BHAGWARIA KATRA AMETHI",
  "Dr. Ram Manohar Lohia Mahavidyalay, Itwa, Siddharathnagar",
  "Dhruwa Narayan Mahila Degree College, Hariharpur,Mithaura Bazar, Maharajganj",
  "Brijlal Thakurai Mahavidyalaya, Jangal Belhar, Sant Kabir Nagar",
  "Amrit Lal Mahavidyalay, Baikunthpur, Maharajganj",
  "SIDDHANT RAJ MAHAVIDAYALA  JAITPUR KALAN AGRA",
  "SWAMI VIVEKANAND COLLEGE OF PHARMACY",
  "Blooming Buds Degree College,Maniram Siktaur, Gorakhpur",
  "FUTURE INSTITUTE OF AYURVEDIC MEDICAL SCIENCES BAREILLY",
  "JWALA DEVI VIDHI MAHAVIDYALAYA",
  "Sarovadi Devi Satyanarayan Mahila Mahavidyalaya, Pipra Chandrabhan (Mishra Tola), Deoria",
  "D A V SANSTHAN RAUNAKHURD VARANASI",
  "PATEL DEGREE COLLEGE, ALIYAPUR, SAJETI,",
  "RIZWANA BEGAM MEMORIAL DEGREE COLLEGE",
  "Vidyawati Devi Mahila Mahavidyalaya, Damodarpur -  Atrauli, Chakmokam Ali, Deoria",
  "SRI RAVINATH SINGH LAW COLLEGE, DAHELIA",
  "Shanti Devi Memorial Mahila Degree College, Divadhar, Pipramishra, Deoria",
  "Invertis Institute of Management Studies",
  "Sir Syed College of Commerce & Management, Aurangabad, Salempur, Deoria",
  "THE SD DEGREE COLLEGE",
  "Budh Mahavidyalay Ratsiya Kothi, Deoria",
  "Swami Viveka Nand Degree College, Kotwa Mishra, Degree",
  "Janki Devi Teenmurti Mahavidyalaya, Sakhvaniya, Kushinagar",
  "Mahatma Gandhi P. G. College, Gorakhpur",
  "Veer Bahadur Singh Rajkeeya Mahavidyalaya Campierganj, Gorakhpur",
  "Reshma Devi Degree College, Amwa, Sohanariya, Deoria",
  "SANT NANHKU SINGH MAHAVIDYALAYA DEIPUR VARANASI",
  "Gramasthali Mahila Mahavidyalaya, Kakarakhor, Gorakhpur",
  "ARYAN GLOBAL COLLEGE, NEGURA, SADAR CHANDAULI, CHANDAULI",
  "Marwad Business School, Naseerabad, Gorakhpur",
  "Devaki Devi Degree College, Pagara, Hata, Kushinagar",
  "St. Andrew's College, Gorakhpur",
  "Late Ramlal Tripathi Degree College, Pipra Shukla, Deoria",
  "Maharaja Agrsen College of Commerece, Deoria",
  "Indrasan Shiksha Sansthan Degree Collge, Demusa Ghati, Deoria",
  "Sahid Captain Vijay Pratap Singh Mahavidyalaya, Awajapur, Sakaldiha, Chandauli",
  "Swami Devanand P.G. College, Mathlar, Deoria",
  "APEX INSTITUTE OF AYURVEDIC MEDICINE AND HOSPITAL",
  "Bageshwari Shikshan Sansthan Degree College, Maiel, Deoria",
  "SMT DHANPATA MAURYA VIDHI MAHAVIDYALAY RASOOLPUR LILHA AYODHYA ",
  "Budh Snatakottar Mahavidyalay, Kushinagar",
  "Vir Bahadur Singh Memorial Mahila Mahavidyalaya, Industrial Area, Lachhipur,  Gorakhpur",
  "Pt. Ram Komal Dwivedi Degree College, Katka Purwa, Gorakhpur",
  "BABU MAHIPATI SINGH MAHAVIDYALAYA TILOI AMETHI",
  "Pavitra Degree College, Siktaur (Maniram), Gorakhpur",
  "Sarswati Kanya Mahavidyalaya, Bhatahat, Gorakhpur",
  "Late Deep Narayan Yadav Degree College, Jagdishpur Bhaluyan, Gorakhpur",
  "Kewla Sundar Mahavidyalaya, Sathipar, Gorakhpur",
  "BABU PARMANAND RAI SMARAK MAHAVIDYALAYA SETHWAL RANI KI SARAI AZAMGARH",
  "Bhairav Prasad Mauraya Smarak Mahila Mahadiyalay, Vishunpura (Piparsandi), Gorakhpur",
  "Shruti Kerti Baudh Kanya Mahavidyalay Barhaj, Deoria",
  "Sarvanand shandilya Yogeshwar Mahavidyalay, Padari, Jamua Tiwari, Salempur, Deoria",
  "Babu Baijnath Singh Mahavidyalaya, Devadhi, Andils, Deoria",
  "Sarswati Devi Degree College, Khadda Bazar, Kushinagar",
  "St. Joseph College for Women, Civil Lines, Gorakhpur",
  "Ram Girish Rai Mahavidyalaya, Dubauli, Gorakhpur",
  "Ramchandra Upadhyay Degree College, Dhanauti Bhatparrani, Deoria",
  "Surya Baksh Pal Smarak Mahavidyalay, Bankati, Basti",
  "Ramnaresh Smarak Degree College, Nagawa, Dhani Bazar, Maharajganj",
  "Mahila Degree College, Basti",
  "Indrasan Singh Swatantrata Sangram Senani Rajkeeya Mahavidyalay, Panchwas, Basti",
  "Deenbandhu Mahavidyalay, Tenuwa, Basti",
  "KAILASH INSTITUTE OF MANAGEMENT GIDA GORAKHPUR",
  "Raghuveer Mahavidyalaya Thaloi, Bhikharipur Kala Jaunpur",
  "Banarasi Yadav Bhup Narayan Pandey Degree College, Madanpura, Sukarauli, Basti",
  "Shayameshwar Mahavidyalaya, Sikriganj, Gorakhpur",
  "Dev Bandhu Degree College, Nonapar, Deoria",
  "Saraswati Devi Mahavidyalay, Nandapar, Jaitpur, Gorakhpur",
  "Rajendra Babu Degree College, Bankatia Dubey, Deoria",
  "M.P. Mahila Mahavidyalaya, Ramduttpur, Gorakhpur",
  "V. S. A. V. Degree College, Gola, Gorakhpur",
  "Shanti Sashaktikaran Degree College, Sidhuvapar, Barhalganj, Gorakhpur",
  "Vir Bahadur Singh Mahavidyalaya, Harnahi (Mahurawn), Gorakhpur",
  "Sita Devi Degree College, Byepass Road, Bhatni, Deoria",
  "Ravindra Kishore Shahi, Rajkeeya Mahavidyalay, Patherdeva, Deoria",
  "Ramgulam Rai P.G. College, Bankatashiv, Sallahpur, Deoria",
  "BAREILLY INSTITUTE OF PARA MEDICAL SCIENCES",
  "Bhartiya Krishak Mahadiyalay, Piparsandi, Gorakhpur",
  "Premwati Devi Samark Mahila Mahavidyalaya, Puraini",
  "Jugal Kishore Degree College, Gowan, Sambhal",
  "Shree Ram College of Education, Gajraula",
  "Shree Bhagwan Mahaveer Snatakottar Mahavidyalay Pavanagar (Fazil Nagar), Kushinagar",
  "Srimati Ramadevi Mahavidyalaya, Indrasenwa, Ramkola, Kushinagar",
  "Pt. Hari Sahay Degree College, Jaiti, Belghat, Gorakhpur",
  "Mahavidyalay, Bhatwali Bazar (Unwal), Gorakhpur",
  "Draupadi Devi Vidhyanchal Mahavidyalaya, Ahirauli, Sinhorwa, Gorakhpur",
  "CNP DEGREE COLLEGE",
  "Bhawani Prasad Pandey Mahavidyalay, Kareem Nagar, Gorakhpur",
  "Banshi Chand Degree College, Chilwan, Gorakhpur",
  "Akhilbhagya, Mahavidyalaya, Ranapar, Gorakhpur",
  "JAGDAMBA KANYA MAHAVIDYALAYA SIDHPURA KASGANJ",
  "Pt.  Sri Krishna Upadhyay Mahila Degree College, Rudrapur, Deoria",
  "Shree Rainath Brahamdev Mahavidyalay, Salempur, Deoria",
  "Teju Singh Memorial Law College, Shahbajpur, Gajraula",
  "Model Public Law College, Chandausi",
  "BRIJ BEHARI SAHAI COLLEGE, KADIRPUR, PRAYAGRAJ ",
  "SHREE RAGHAV COLLEGE OF LAW AND LEGAL STUDIES KHEMIPUR NIDHIYAWAN AYODHYA",
  "Jainath Memorial Balika Mahavidyalaya, Harairampur, Chirkihit, Lalganj, Azamgarh",
  "K.G.K. (PG) College",
  "Ganna Utpadak Mahavidyalaya, Baheri",
  "Bankey Bhari College of Law, Ujhani",
  "Shri Govind Mahavidyalaya, Tewarkhas, Bilari",
  "SHANTI NIKETAN GROUP OF INSTITUTIONS VILL IKLA MOHIUDDINPUR MEERUT    ",
  "Lakshya Institute of Management & Information Technology",
  "MANIRAJI PANDEY SHIKSHAN AVAM PRASHIKSHAN MAHILA MAHAVIDYALAYA RAMSAPUR LAHENGA SALON RAEBARELI",
  "UPKAR FOUNDATION MANGRAULI JAGDISHPUR MUSAFIRKHANA AMETHI",
  "Swami Educational Complex, Pooranpur",
  "AMAR SHAHEED KANCHAN SINGH MAHAVIDYALAYA, SHIVPURI KHAGA, FATEHPUR",
  "Ram Chandra Singh Memorial Degree College, Mirzapur",
  "AZAD DEGREE COLLEGE, GONDLAMAU, SITAPUR",
  "SMRITI PATEL MAHAVIDYALAYA, MUBARAKPUR, HARCHANDPUR, RAEBARELI",
  "SUNDERLAL JAI NARAIN DEGREE COLLEGE, RASULPUR, SITAPUR",
  "Krishna College of Law",
  "Dayanand Arya Kanya Mahavidyalaya",
  "Krishna College of Science & Information Technology",
  "SITARAM ADARSH SANSKRIT MAHAVIDYALAY",
  "DR VIJAY AYURVEDIC MEDICAL COLLEGE, HOSPITAL AND RESEARCH CENTRE BHANDAHA KALA KAITHI VARANASI",
  "SHREE RAMLAKHAN SINGH SIKSHAN SANSTHAN Plot No Six Hundred Twenty Four Nakhara Khandev Jaunpur",
  "SHRI SADANAND SANSKRIT MAHAVIDYALAYA",
  "PRAGYA YOG SANSKRIT MAHAVIDYALAYA",
  "CHAUDHARI RAM SINGH PUSHPA DEVI LAW COLLEGE     ",
  "COLLEGE OF NURSING",
  "JAI MAA BHAGWATI SONANCHAL EDUCATIONAL LAW COLLEGE, RAUP SAHIJANKALA SONEBHADRA ",
  "BABU BANARSI DAS INSTITUTE OF TECHNOLOGY B,ED, GHAZIABAD",
  "G.S.V.M. MEDICAL COLLEGE,",
  "BABU BANARSI DAS COLLEGE OF TEACHERS, JAHANGIRABAD, BULANDSHAHR",
  "Shubhi Devi Mahila Degree College, Khalilabad, Sant Kabir Nagar",
  "SHRI BALA GIRLS INSTITUTE OF EDUCATION BALAJI NAGAR MAHGAON VARANASI",
  "UNIQUE LAW COLLEGE MURADNAGAR GHAZIABAD",
  "KRISHNA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL VILL HASHAMPUR POST JHALU NOORPUR ROAD BIJNOR",
  "MATA KISHUN DEI MAHILA MAHAVIDYALAYA    ",
  "KRISHNA SUDAMA SHIKSHA EVAM PRASHIKSHAN SANSTHAN    ",
  "KEDAR KAUSHILYA MAHILA MAHAVIDYALAYA     ",
  "R B SINGH MAHAVIDHYALAYA    ",
  "PANDIT SANKATHA PRASAD PANDEY ACADEMY BHARTHIPUR AMETHI",
  "HAJI MAQSOOD ALI GIRLS DEGREE COLLEGE",
  "SHRI RAMCHANDRA VAIDYA AYURVEDIC MEDICAL COLLEGE AND HOSPITAL    ",
  "B P N OF INSTITUTION SHOBHA NAGAR BAMHANI MAHADEWA MARG, RAMNAGAR BARABANKI",
  "RAJA PREM SINGH SHIKSHA MAHAVIDYALAYA TAJKHUDAI BAHRAICH",
  "LORD KRISHNA NURSING AND PARAMEDICAL ATRAULI ALIGARH",
  "RAM SAGAR SINGH MAHILA MAHAVIDYALAYA, MISIRPUR, JAUNPUR",
  "SHAHEED RAJA HARI PRASAD MALL STATE HOMEOPATHIC MEDICAL COLLEGE AND HOSPITAL  BARHALGANJ GORAKHPUR ",
  "R K SINGH HOSPITAL AND INSTITUTE OF MEDICAL SCIENCES ",
  "AUTONOMOUS STATE MEDICAL COLLEGE, FIROZABAD",
  "DR BHIMRAO RAMJI AMBEDKAR GOVERNMENT MEDICAL COLLEGE KANNAUJ",
  "VIMLA FAMILY AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "PHOOLPATTI COLLEGE OF WOMEN EDUCATION, HAJIPUR , SINGHUR,DARABGANJ, MUMTAZNAGAR, AYODHYA",
  "DASHRATH YADAV MAHILA MAHAVIDYALAYA  GHAZIPUR",
  "RANI LAKSHMIBAI MAHILA MAHA VIDYALAY MADHUPUR SONBHADRA",
  "GAUTAM BUDDHA COLLEGE OF PHARMACY LUCKNOW",
  "DR MITHILESH MANI TRIPATHI COLLEGE OF PHARMACY GAURAGARH SIDDHARTHNAGAR    ",
  "RAMNATH BHUDEVI GIRLS COLLEGE BAH    ",
  "URMILA GRAMIN SIKSHAN SANSTHAN KOTSARAI, SOHAWAL, AYODHYA ",
  "PT PARSADI LAL MEMORIAL MAHAVIDHYALAY",
  "POINEER INSTITUTE OF PHARMACY",
  "NAIMINATH AYURVEDIC MEDICAL COLLEGE, HOSPITAL AND RESEARCH CENTRE",
  "SHRI RAMESHWAR COLLEGE OF PHARMACY, Hapur",
  "BABA SHIV SARAN SINGH BAKE SINGH EDUCATIONAL INSTITUTE PERI POKHAR MANKAPUR GONDA",
  "VEER VIJAY PHARMACY COLLEGE",
  "PT RAJARAM UMA DEVI MAHILA MAHAVIDYALAY    ",
  "URMILA COLLEGE OF PHARMACY KOTSARAI AYODHYA",
  "ASK INSTITUTE OF EDUCATION MAHILA MAHAVIDYALAYA AMROHA",
  "PMT COLLEGE OF PAHRMACY AYODHYA",
  "Shri Badri Prasad Memorial Academy Anu. Mahavidyalay, Janjankala, Kudraha, Basti",
  "Shree Akshaybar Singh Memorial Mahavidyalay,Natwa Jangal, Maharajganj",
  "Sarswati Devi Degree College, Nichlaul, Maharajganj",
  "JANKI DEVI KANYA MAHAVIDYALAYA  ANANDPUR POST DUNKA MEERGANJ BAREILLY",
  "Sant Kabir Vidyapeeth Mahavidyalya, Magahar, Sant Kabir Nagar",
  "HAUSILA PRASAD SINGH SMARAK MAHILA MAHAVIDYALAYA SHARIFPUR GOVINDPUR SULTANPUR",
  "R.P. Yadav Mahavidyalaya, Mahulli Bazar, Sant Kabir Nagar",
  "Ratan Sen Degree College, Bansi, Siddharthnagar",
  "SHRI VIJENDRA SINGH LAWANIA DEGREE COLLEGE , GARHI DHANU, IGLAS ALIGARH",
  "Ram Prasad Singh Degree College, Siswa Bazar, Maharajganj",
  "RAMDHARI SINGH MAHAVIDYALAYA",
  "Rajkeeya Mahila Mahavidyalay, Haraiya, Basti",
  "Madhav Prasad Tripathi Rajkeeya Mahila Mahavidyalaya, Khalilabad, Sant Kabir Nagar",
  "Lord Krishna Degree College, Brijmanganj, Maharajganj",
  "Jayaram Raj Upadhyay Balika Degree College, Padaribabu, Parsurampur, Basti",
  "Jawahar Lal Nehru Smarak P. G. College, Maharajganj",
  "MANVASH VIJAY SINGH MAHAVIDYALAYA    ",
  "Jagdish Prasad Pandey Smarak Degree College, Devpur, Adda Bazar, Maharajganj",
  "SHYAMSUNDARI MAHILA MAHAVIDYALAY, DUBARI MOLANAPUR, MAU",
  "Dr. Ram Manohar Lohia Mahavidyalaya, Nautanwa, Maharajganj",
  "Dr. Bhimrao Ambedakar Govt. Degree College, Maharajganj",
  "Chandragupta Maurya Prabhabansh Mahila Degree College, Mathauli, Bankati, Basti",
  "Bansh Bahadur Pal Mahavidyalay, Unchgaon, Basti",
  "PT. OM PRAKASH SHARMA MAHAVIDYALAYA, RURA,",
  "SHEEL SANEHI DEGREE COLLEGE, SANT KABIR NAGAR",
  "ALIGARH AYURVEDIC MEDICAL COLLEGE AND ACN HOSPITAL,ALIGARH",
  "A.V.R.L. Degree College, Githani, Chandhar, Sant Kabir Nagar",
  "DR. RAM MANOHAR LOHIA MAHAVIDYALAYA, JURIA (JALIHAPUR),",
  "V.N.B.P. Degree College, Maharajganj, Gorakhpur",
  "Sardar Patel Institute of Science and Technology Mahavidyalaya, Moharipur, Gorakhpur",
  "Smt. Draupadi Devi Tripathi Mahavidyalaya, Rudrapur, Khajani, Gorakhpur",
  "Babu Purushottam Das Radha Raman Das Mahavidyalaya, Mahadev Jharkhandi, Gorakhpur",
  "Raja Devi Mahila Degree College, Sallahapur, Bhatni, Deoria",
  "Prabhawati Devi Degree College, Kharawaniya Naveen, Ropan Chhapara, Lar, Deoria",
  "A.Y.T. College of Education, Ghataila Gaji, Deoria",
  "Ma Sukali Devi Mahavidyalay, Sahjaur, Deoria",
  "Swarn Jayanti Mahavidyalaya, Pipraich, Gorakhpur",
  "Jauwad Ali Shah Imambara Girls P. G. College, Gorakhpur",
  "Dr. Ram Manohar Lohia mahavidyalaya, Karaundi, Bhaluani, Deoria",
  "Indu Devi Rampati Mahila Mahavidyalay, Sewrahi, Kushinagar",
  "SCHOOL OF MANAGEMENT SCIENCES, LUCKNOW",
  "ARNAV AYURVEDIC MEDICAL COLLEGE",
  "Digvijay Nath L. T. Parsikhchar Mahavidyalay, Gorakhpur",
  "DOODHNATH SMARAK MAHAVIDYALAYA ALDEMAU NOORPUR KADIPUR SULTANPUR",
  "Sahu Jain College, Najibabad",
  "Satyanarayan Degree College, Bharauli Baradihadal, Deoria",
  "Lagna Devi Tarakant Mahila Mahavidyalaya, Ronihwa, Deoria",
  "Kirti Institute of Nursing and Paramedical Sciences",
  "Amarjeet Singh Siksha Smarak Mahila Mahavidyalay, Sonadih, Mau",
  "Vishal Kanya Degree College, Izzatnagar",
  "NANAK JI SANSKRIT MAHAVIDYALAY",
  "Islamia College of Commerce, Gorakhpur",
  "Maharana Pratap Mahavidyalay, Jungle Dhushan, Gorakhpur",
  "Ramji Sahay Mahavidyalay, Rudrapur, Deoria",
  "ADARSH SHANKAR SANSKRIT MAHAVIDHYALAYA",
  "MAA SHITALA KUMAR SANSKRIT MAHAVIDYALAYA",
  "KRISHNAWATI SANSKRIT MAHAVIDYALAY ORWA SAKALDIHA CHANDAULI",
  "Kalpnath Rai Degree College, Laxmipur, Bhatni, Deoria",
  "RAM KUMAR SMARAK SHIKSHAN EVAM PRASHIKSHAN SEWA SANSTHAN SHUKUL BAZAR AMETHI",
  "ST. THOMAS COLLEGE OF EDUCATION",
  "Srimati Banni Devi Mahila Mahavidyalaya, Padarauna, Kushinagar",
  "LLOYD INSTITUTE OF ENGINEERING AND TECHNOLOGY, GREATER NOIDA",
  "CITY MODEL COLLEGE, BHAILAMAU, KALPI ROAD,",
  "PAHALWAN GURUDEEN COLLEGE OF SCIENCE AND TECHNOLOGY",
  "Mahanth Shyamdas Mahavidyalaya, Nebua, Raiganj, Kushinagar",
  "Kisan Mahvidyalay, Paikoli Hata, Kushinagar",
  "Saraswati Vidya Mandir Mahila Mahavidyalay, Aaryanagar, Gorakhpur",
  "D. D. U. Rajkeeya Mahavidyalay, Sahjanwa, Gorakhpur",
  "BABA RAMDAL SURAJDEV NURSING AND PARAMEDICAL COLLEGE,BALLIA,UTTAR PRADESH    ",
  "Babu Laljee Singh Mahavidyalaya, Bhagaura, Sahajanwan, Gorakhpur",
  "SHAMBHUNATH RESEARCH INSTITUTE OF MEDICAL SCIENCES AND HOSPITAL    ",
  "Swami Vivekanand Mahavidyalaya, Pakadi (Mansoorganj), Kushinagar",
  "DS PARAMEDICAL AND NURSING COLLEGE    ",
  "THE SUN SHINE SHIKSHAN AWAM PRASHIKSHAN SANSTHAN, JAKHANIAN, GHAZIPUR    ",
  "Babua Jee Snatak Degree College, Pindi, Deoria",
  "Parameshwar Degree College, Nautan Hathiagarh, Deoria",
  "Bhagwant Pandey Mahavidyalaya, Bodarwar, Kushinagar",
  "KUNWAR MAHESH DUTT HARPATRAI KANYA MAHAVIDYALAY DEOBAND SAHARANPUR",
  "SWAMI NARAYAN DASS KANYA DEGREE COLLEGE MALHIPUR SAHARANPUR",
  "ASHADEEP DEGREE COLLEGE",
  "DWARIKADHEESH  RESEARCH EDUCATION & MGMT SCHOOL,  JANTA ROAD, SAHARANPUR",
  "K.K. Jain College Khatauli (Muzaffarnagar)",
  "AAKANSHA COLLEGE MEERAPUR, MUZAFFARNAGAR",
  "SWAMI KALYAN DEV KANYA DEGREE COLLEGE, BABRI, MUZAFFARNAGAR",
  "M S HOSPITAL AND RESEARCH CENTRE    ",
  "kailash Institute of law",
  "SHARDA SHANTI MAHAVIDYALAYA, BANKATA BASGIT AZAMGARH    ",
  "KRISHNA SUDAMA VIDHI MAHAVIDYALAYA MARDAPUR DAULAT NAGAR GHAZIPUR    ",
  "GYANANDA LAW COLLEGE AMRAWATI VINDHYACHAL MIRZAPUR    ",
  "PANCHSHIL DEGREE COLLEGE, MAWAI KALAN, HALIYA, MIRZAPUR",
  "S S A GIRLS DEGREE COLLEGE ANDAWAN SIRATHU KAUSHAMBI    ",
  "MADHAV PRASAD TRIPATHI MEDICAL COLLEGE    ",
  "TH GUNRAJ SINGH MAHILA DEGREE COLLEGE, AUSANPUR, HANDIA, PRAYAGRAJ, UP    ",
  "CHANDRAKALI RAMRAJ DEGREE COLLEGE, KATRAULI GAURA, RANIGANJ, PRATAPGARH, UP    ",
  "RAJEEV MEMORIAL INSTITUTE OF EUDCATION & TECHNOLOGY, BHARDWAJ FARM HOUSE, GANGOH, SAHARANPUR",
  "BABU AMAR BAHADUR SINGH VIDHI MAGHAVIDYALAYA    ",
  "CHAUDHARI BHAGIRATHI YADAV MAHAVIDYALAYA, MAILAHA, BAHARIYA, PRAYAGRAJ, UP    ",
  "PANDIT VISHWAMBHAR NATH TRIPATHI ADARSH MAHILA MAHAVIDYALAY    ",
  "SHIKHA CHATURVEDI LAW COLLEGE    ",
  "SWAMI KALYAN DEV VEDIK COLLEGE FOR MANAGEMENT VILL-SIKANDERPUR, POST. JHINJHANA, MUZAFFARNAGAR",
  "RASEE INSTITUTE OF EDUCATIONS    ",
  "Devi Singh Mahavidhayalay, Majhara Dhanola Kala, Shamshabad, Agra",
  "MAA VAISHNAVI PHARMACY COLLEGE, KARANJAKALA, JAUNPUR    ",
  "SHANTI JAGDEESH MAHAVIDYALAYA, ARJUNPUR, RANIGANJ KAITHOLA, PRATAPGARH",
  "P T S LAW COLLEGE    ",
  "S N GIRLS SANSTHAN, SOHANI, KERAKAT, JAUNPUR    ",
  "GURU PHOOLCHANDRA GIRLS COLLEGE, DAULATPUR, GHAZIPUR    ",
  "KESHLATA COLLEGE OF NURSING BAREILLY    ",
  "MUKTA PRASAD DEGREE COLLEGE",
  "NAURANG SINGH VIDHI MAHAVIDYALAYA    ",
  "SHRI BALAJI COLLEGE OF PHARMACY AND RESEARCH CENTRE    ",
  "R K EDUCATIONAL INSTITUTE BADEPUR JALALPUR AMBEDKAR NAGAR    ",
  "INSTITUTE OF PHARMACY F S UNIVERSITY    ",
  "RADHIKA MEMORIAL DIGREE COLLEGE, DUMARIA, NAUGARH, CHANDAULI    ",
  "DR.BHIM RAO AMBEDKAR RAJKIYE MAHAVIDYALAYA AUDENYA PADRIYA MAINPURI",
  "SHRI RAM MURTI SMARAK COLLEGE OF NURSING , BAREILLY     ",
  "J N AND S B SHIKSHAN PRASHIKSHAN COLLEGE EVAM MAHILA MAHAVIDYALAYA PHAKHANPURA GHAZIPUR    ",
  "FS PHARMACY INSTITUTE    ",
  " PT LAXMIKANT MAHAVIDHYALA PACHHAUHA, KAMASHIN BANDA    ",
  "Shri Raj Rajeshwari Mahila Mahavidyalaya, Hunsepur Kaboolpur, Jaunpur",
  "Maa Kamala Devi Mahavidyalaya, Jaypalpur, Mungrabadshahpur, Jaunpur",
  "BABA PT RAMCHANDRA SHARMA MAHAVIDYALAYA BILSI BUDAUN    ",
  "RAMDENI SINGH JAGDISH SINGH MEMORIAL SAMITI    ",
  "JEEVAN JYOTI INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "MAA VINDHYAWASINI AUTONOMOUS STATE MEDICAL COLLEGE, MIRZAPUR",
  "KAUSHILYA DEVI BAIJNATH JAISWAL MAINA DEVI SHER BAHADUR SINGH MAHAVIDYALAYA GUWAWA BHILAMPUR JAUNPUR",
  "BABU K.P. SINGH MAHAVIDYALAYA KHEMAUPUR CHANDDESHWAR AZAMGARH",
  "DHARMA DEVI MAHAVIDYALAYA, PANWARA, JAUNPUR",
  "BABU LALLAN SINGH MAHAVIDYALAYA, BHUJAHI JAHANAGANJ AZAMGARH",
  "MICROTEK COLLEGE OF MANAGEMENT AND TECHNOLOGY, MURTAZABAD, KERAKAT, JAUNPUR",
  "UBS GROUP OF INSTITUTE    ",
  "Maa Sudami Mahila Mahavidyalaya, Alimapur, Bahadiya, Ghazipur",
  "SHRI RADHA RANI MAHAVIDYALAYA VIRAMPUR, GT ROAD,, ETAH",
  "OM SATYANAM KOTWADHAM RAMNARESH RAMRATI SHIKSHAN SANSTHAN INAYATNAGAR MILKIPUR AYODHYA    ",
  "VIKAT INSTITUTE SCHOOL OF NURSING",
  "Vaidya Yagya Dutt Sharma Ayurved Mahavidyalya",
  "CHANDRA SHEKHAR AZAD DEGREE COLLEGE DOSTI NAGAR UNNAO    ",
  "AMARAVATI INSTITUTE OF HIGHER EDUCATION, HARIHARPUR, VARANASI",
  "Pt Ramesh chandra Parasnath Mahavidyalaya Ramchandarpur Hardwari Jaunpur",
  "PADMAVATI MAHILA  MAHAVIDHYALAY AMRA KHAIRA CHAK KANDAWA VARANASI",
  "T.S. MISRA COLLEGE OF NURSING, AMAUSI, LUCKNOW",
  "BABA VISWANATH LAW OF COLLEGE BIKAPUR AYODHYA    ",
  "SADHU SINGH MAHAVIDYALAYA    ",
  "SHREE HEERA LAL SMARAK MAHAVIDYALAYA MEHNDIPUR",
  "PRAYAGRAJ COLLEGE OF LAW    ",
  "SHRI SHALLESWAR UCCHA SHIKSHA SANSTHAN, SARILA ,HAMIRPUR    ",
  "LATE KAMLA DEVI MAHAVIDHYALAY ETAYAL GOHAND HAMIRPUR    ",
  "SRI GAJENDRA SINGH MEERA DEVI MAHAVIDHYALAYA, SANGAM NAGAR, TADHA, PREMPUR, KANNAUJ",
  "CITY HOSPITAL AND INSTITUTE OF PARAMEDICAL SCIENCES    ",
  "DR. CHANDRAMA SINGH MAHILA MAHAVIDYALAYA PURASHIV, SAKALPUR, VARANASI",
  "B N S MAHILA MAHAVIDYALAYA, AKHARI, BYPASS, VARANASI",
  "BRAHMANAND MAHILA MAHAVIDYALYA, KHURJA BULANDSHAHR",
  "SHRI KAMLA PRASAD SINGH DEGREE COLLEGE, GANGKALA, BARAGAON, VARANASI",
  "KAMALA DEGREE COLLEGE, LAKHIMPUR KHERI",
  "BHARTIYA VIDYA BHAWAN, GIRLS, D. COLLEGE, GOMTI NAGAR",
  "CITY ACADEMY LAW COLLEGE, TIWARIGANJ",
  "SHRI MAHESH PRASAD DEGREE COLLEGE, MOHANLALGANJ",
  "SANSKRIT PATHSHALA GIRLS DEGREE COLLEGE",
  "NOVA INSTITUTE OF NURSING & PARAMEDICAL SCIENCES LUCKNOW",
  "GOEL INSTITUTE OF HIGHER STUDIES MAHAVIDYALAYA, FAIZABAD ROAD",
  "I K M LAW COLLEGE, ANAPUR, PRAYAGRAJ, UTTAR PRADESH    ",
  "MS INSTITUTE OF NURSING",
  "SHRI RAM INSTITUTE OF MANAGEMENT AND TECHNOLOGY RAILWAY ROAD DIBAI BULANDSHAHR",
  "DR. GHANSHYAM SINGH COLLEGE OF EDUCATION, GOSAIPUR, MOHAV, VARANASI",
  "R D S COLLEGE OF PHARMACY",
  "SHRI K L SHASTRI SMARAK NURSING COLLEGE LUCKNOW",
  "RASHTRIYA KATHAK SANSTHAN, GOMTI NAGAR",
  "ERA'S COLLEGE OF MANAGEMENT, HARDOI ROAD",
  "MOTHER TERESA PARAMEDICAL COLLEGE AND HOSPITAL SAHARANPUR    ",
  "KALI CHARAN DEGREE COLLEGE, HARDOI ROAD",
  "B.C.M College of Nursing",
  "SPARK COLLEGE OF PARAMEDICAL SCIENCES AND NURSING, BAHRAICH    ",
  "ARYAVART INSTITUTE OF HIGHER EDUCATION, UTARETHIA",
  "GYANODAYA DEGREE COLLEGE",
  "SWAMI VIVEKANAND MAHILA MAHAVIDYALAYA, ELDICO",
  "ANJUMAN A ASHRAF PHARMACY COLLEGE     ",
  "BABA BHEEM SAIN MAHAVIDHYALAY RAL MATHURA",
  "SHRI RADHA KESHAV MAHAVIDHYALAYA    ",
  "Vansthli Mahavidyalaya, Ahraura, Mirzapur",
  "S S MAHAVIDHYALAYA     ",
  "PANDIT HARDWARI LAL SMRITI MAHILA MAHAVIDYALAYA SITAPUR    ",
  "KASHI NATH NURSING AND PARAMEDICAL COLLEGE, RAMBHAJANPUR, BANKI KHURD",
  "SHRI KANHAIYA LAL MAHAVIDYALAYA DHANA SHAMSABAD MATHURA",
  "G C R G College of Nursing",
  "ERAM GIRLS, DEGREE COLLEGE, INDIRA NAGAR",
  "Javitri institute of medical sciences",
  "KUNWAR AJEET COLLEGE OF PHARMACY, JAUNPUR    ",
  "AUTONOMOUS STATE MEDICAL COLLEGE LALITPUR    ",
  "COLLEGE OF INNOVATIVE MANAGEMENT AND SCIENCE, GOMTI NAGAR",
  "BRIGHT CARRIER GIRLS DEGREE COLLEGE",
  "MEENU INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES HARDOI UTTAR PRADESH    ",
  "SMT RAGINI ANTERVEDI LAW COLLEGE    ",
  "GHANSHYAM PANDEY GIRLS DIGREE COLLAGE OF SCINCE AND MANAGEMENT KAMIYA BAHAUDDINPUR SULTANPUR    ",
  "AUTONOMOUS STATE MEDICAL COLLEGE, LAKHIMPUR KHERI    ",
  "UTTAR PRADESH INSTITUTE OF DESIGN AND RESEARCH",
  "RUPRANI LAW COLLEGE     ",
  "RAJKIYA MAHAVIDYALAY PARSAVAN, KHANDASA, MILKIPUR, AYODHYA     ",
  "RAJKIYA AYURVED MAHAVIDYALAYA AND CHIKITSALAYA VARANASI    ",
  "KALYAN SINGH GOVERNMENT MEDICAL COLLEGE     ",
  "SANSKAR LAW COLLEGE BHATKHERWA ROAD TAURA UNNAO    ",
  "INSTITUTE OF PARAMEDICAL SCIENCES GIMS GREATER NOIDA    ",
  "KUNWAR ASIF ALI DEGREE COLLEGE, MALIHABAD",
  "LUCKNOW DEGREE COLLEGE, HARDOI ROAD",
  "KALAWATI NURSING AND PARAMEDICAL COLLEGE",
  "JEEVAN JYOTI AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "CHARAK INSTITUTE OF PARAMEDICAL STUDIES LUCKNOW    ",
  "VEER BAHADUR SINGH MAHILA VIDYALAYA",
  "R J NURSING AND PARAMEDICAL INSTITUTE",
  "GANESH BUX HARVANSH BAHADUR MAHAVIDHYLAYA SANHUKUAAN JAGATPUR RAEBARELI",
  "KUNWAR UDAYVEER SINGH RAMSANEHI SINGH MEMO DEGREE COLLEGE SATHRA DHARAMPUR KALAN SHAHJAHANPUR",
  "KARAMAT HUSAIN MUSLIM GIRLS DEGREE COLLEGE",
  "Shri Gajadhar Singh Yashoda Devi Smarak Mahavidhyalaya Maharaj Nagar, Shankarpur, Kudarkot, Auraiya",
  "SAMARPAN COLLEGE OF PHARMACY",
  "SAMARPAN INSTITUTE OF NURSING & PARAMEDICAL SCIENCES LUCKNOW",
  "SWARGIYA RAMVILASH SINGH SHIKHSAN SANSTHA MAHILA MAHAVIDYALAY, KANHAIPUR, AHRAURA, MIRZAPUR",
  "MAA SARASWATI COLLEGE OF TEACHERS EDUCATION, KURAUNA, SAJOI, VARANASI",
  "DEV RISHI INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "BIJENDRA TEOTIA MEMORIAL MAHAVIDHAYALYA, KALCHEENA ROAD, MANKI, MODINAGAR, GHAZIABAD",
  "A B G Institute of Paramedical Sciences",
  "RAJAT DEGREE COLLEGE, PANCHVATI",
  "PANDIT DEV NARAYAN SHUKLA VIDHI MAHAVIDAYALYA    ",
  "CAREER CONVENT GIRLS DEGREE COLLEGE, VIKAS NAGAR",
  "MOHAMMAD YAHIYA MEMORIAL GIRLS DEGREE COLLEGE CO EDUCATION SEHIYA SIRATHU KAUSHAMBI    ",
  "DR RAGINI VIDHI MAHAVIDYALAYA    ",
  "BHAGWAANDEEN SINGH PATEL VIDHI MAHAVIDHYALAY RAGAULI, CHITRAKOOT",
  "MEHAR BABA MAHILA MAHAVIDYALAYA KURRA RATH HAMIRPUR    ",
  "I.P.N.S. MAHILA MAHAVIDYALAYA BAIRAHANA (AKORHA), DHAUKALGANJ, VARANASI",
  "Dr. KNS Memorial Institute of Medical Sciences",
  "Sri Satguru Mahavidyalaya, Murarmau, Raebareli",
  "RAJSHREE NURSING INSTITUTE, BAREILLY",
  "MAHESHWARI NURSING AND PARAMEDICAL INSTT. ALIGARH",
  "KRISHNA DEVI GIRLS DEGREE COLLEGE, ALAMBAGH",
  "MODERN COLLEGE OF PHARMACY, JHANSI",
  "BABA BAIJNATH JI LAW COLLEGE, GODHPUR, KISHUNDASPUR, AZAMGARH    ",
  "GOVT AYURVEDIC COLLEGE AND HOSPITAL JHANSI    ",
  "SHRI SANKAT MOCHAN UCHCH SHIKSHA EVAM TAKANIKI MAHAVIDYALAYA CHAUBEYPUR VARANASI",
  "WALSON INSTITUTE OF MANAGEMENT AND TECHNOLOGY, SIKANDRABAD, BULANDSHAHR",
  "DAYANAND YADAV DEGREE COLLEGE ARJUNGANJ LUCKNOW",
  "CITY COLLEGE OF MANAGEMENT, TIWARIGANJ",
  "SHIA P.G. COLLEGE, LUCKNOW",
  "SURJAN DEVI ANUSUIYA DEVI DEGREE COLLEGE",
  "B.S.N.V.  P.G. COLLEGE",
  "TRINITY INSTITUTE OF HIGHER EDUCATION    ",
  "SHUBH KANHA JI SANSTHAN, HARIKAR PATTI, AHAN, KERAKAT, JAUNPUR",
  "A.P. SEN MEMORIAL GIRLS DEGREE COLLEGE",
  "RAJAT WOMEN'S COLLEGE OF EDUCATION AND MANAGEMENT, CHINHAT",
  "Arya Mahila Degree College Katiya Tola S.P.N.",
  "LUCKNOW LAW COLLEGE, AHIMAMAU",
  "MODERN GIRLS COLLEGE OF PROFESSIONAL STUDIES",
  "MAHAMAYA RAJKIYA MAHAVIDYALAYA, MAHONA",
  "BASUDEV MEMORIAL GIRLS DEGREE COLLEGE",
  "DRON COLLEGE OF EDUCATION SARDHANA MEERUT     ",
  "HEERA LAL YADAV LAW COLLEGE, SAROJNI NAGAR",
  "UNITY DEGREE COLLEGE, HARDOI ROAD",
  "KHUN KHUN JI GIRLS DEGREE COLLEGE, CHOWK",
  "VANASTHALI GYANPEETH GIRLS DEGREE COLLEGE, BKT",
  "NAVYUG KANYA MAHAVIDYALAYA, RAJENDRA NAGAR",
  "BRIGHT CAREER GIRLS DEGREE COLLEGE MALIHABAD LUCKNOW     ",
  "VIDYANT HINDU DEGREE COLLEGE, G.B. MARG",
  "MUMTAZ DEGREE COLLEGE, DALIGANJ",
  "SATYANAND INSTITUTE OF HIGHER EDUCATION, SAROJNI NAGAR",
  "MAA SARASWATI VIDHI MAHAVIDYALAYA KURAUNA SAJOI VARANASI    ",
  "ST XAVIER LAW COLLEGE BABURA KHAS DHINA    ",
  "MOHAN MEMORIAL PRAYAG MAHAVIDYALAYA, MAJHAULI, JHAROKALAN, DUDDHI, SONBHADRA    ",
  "MRITUNJAY PANDEY MAHILA MAHAVIDYALAYA    ",
  "MAA KAUSHILYA DEVI RAMLALI MAHILA MAHAVIDYALAYA MOKALPUR RANI BAZAR AYODHYA    ",
  "LAL BAHADUR SHASTRI GIRLS COLLEGE OF MANAGEMENT, KURSI ROAD",
  "LUCKNOW CHRISTIAN COLLEGE, GOLAGANJ",
  "VISHAMBHAR SINGH RAMKALI MAHILA MAHAVIDYALAYA FATTEPURWA MAHARAJPUR KANPUR NAGAR    ",
  "RAKSHA DEVI MAHILA MAHAVIDHYALAYA LODHI NAGAR KHIMSHEPUR FARRUKHABAD UP    ",
  "SHRI RAMSWAROOP MEMORIAL COLLEGE OF MANAGEMENT, TIWARIGANJ, FAIZABAD ROAD, LUCKNOW",
  "NATIONAL P.G. COLLEGE",
  "DEVANSHU SAMAJ KALYAN SEWA DEG. COLL. MAHADEV NAGAR, SAURIK,",
  "DR. RAM MANOHAR LOHIA MAHAVIDYALAYA, KALYANPUR,",
  "CHHATRAPATI SHIVAJI COLLEGE OF LAW    ",
  "VANSHA DEVI MAHAVIDYALAY VILLAGE GAJADHARPUR GADDOPUR JAUNPUR    ",
  "B R MEMORIAL MAHAVIDYALAYA UDHOPUR PHOOLPUR VARANASI",
  "MANOHAR LAL VIDHI MAHAVIDYALAYA, JURAWAN KHERA,",
  "YASHODA KUNWAR YADAV MAHILA MAHAVIDYALAYA, BHOGNIPUR,",
  "DAYANAND DANKU PARAGA GYAN UDAI MAHAVIDYALAYA, MURLIPUR,",
  "ABHINAV SEVA SANSTHAN MAHAVIDYALAYA, RAJEEV NAGAR,",
  "KRISHNA INSTITUTE OF NURSING SCIENCE AND RESEARCH, KANPUR",
  "CHAUDHARY VEERENDRA SINGH MAHAVIDHYALAYA BARAULA ALIGARH    ",
  "Baba Indradev Girls Educational Institute, Maheshpur Kala, Ghazipur",
  "RAGHVENDRA HOSPITAL & NURSING TRAINING INSTITUTE JHANSI",
  "ACHARYA NARAYANA COLLEGE, MEERPUR, PRATAPPUR, BELWAI",
  "KRISHNAPAL SINGH LAW COLLEGE    ",
  "MAHARISHI GAUTAM VIDHI MAHAVIDYALAYA MAINPUR NAWABGANJ GONDA    ",
  "R B S MAHAVIDYALAY VILLAGE GADDOPUR JAUNPUR    ",
  "AWADH RAJI MAHILA MAHAVIDYALAYA DEORIA JUNGLI UTRAULA    ",
  "SATYADEO LAW COLLEGE    ",
  "LATE BABU INDRA BAHADUR SINGH LAW COLLEGE, AMANIGANJ, MILKIPUR, AYODHYA    ",
  "SHRI RADHA MADHAV MAHILA DEGREE COLLEGE SAMHON BHARTHANA ETAWAH    ",
  "MEHAR BABA MAHILA MAHAVIDYALAYA KURRA RATH HAMIRPUR    ",
  "CH. BANVARI LAL MAHAVIDYALAYA, HASERAN,",
  "DR. HARIVANSH RAI BACHCHAN MAHAVIDYALAYA, LALAUKHEDA (DEEH),",
  "D.A.V. TRAINING COLLEGE,",
  "SETH SRI NIWAS AGARWAL INSTITUTE OF MANAGEMENT, NARAMAU,",
  "Faculty Of Management and Technology, Harish Chandra P G College, Bawan Beegha Campus, Azamgarh Road, Varanasi",
  "GULAB SINGH MAHAVIDYALAYA KICHKILA HANDIA PRAYAGRAJ    ",
  "GOVERNMENT COLLEGE OF NURSING, BRD MEDICAL COLLEGE CAMPUS, GORAKHPUR, UTTAR PRADESH    ",
  "CHARU NURSING COLLEGE OF EDUCATION    ",
  "FLORENCE NIGHTINGALE COLLEGE OF NURSING",
  "R P SINGH MAHILA MAHAVIDHALAYA RAMGADH AMBEDKARNAGAR    ",
  "SHANTI COLLEGE OF LAW    ",
  "SVM COLLEGE OF LAW, SARAWAN, ALAPUR, AMBEDKAR NAGAR    ",
  "R P S M V S MAHAVIDYALAYA SISANI JAFARGANJ AMBEDKAR NAGAR    ",
  "Madhav Institute of Technology",
  "SHRI P N SHARMA DEGREE COLLEGE SAIDPUR LALITPUR",
  "AWADH PARAMEDICAL COLLEGE AND INSTITUTE  JAUNPUR",
  "RADHA GOVIND LAW COLLEGE    ",
  "DULARI DEVI GIRLS COLLGE OF EDUCATION BASTI BELAULI MAU    ",
  "MANOHAR LAL MAHAVIDYALAYA, JAJMAU,",
  "MAHILA MAHAVIDYALAYA, KIDWAI NAGAR,",
  "SHAHID BHAGAT SINGH MAHAVIDYALAYA, BITHOOR,",
  "BABU RAM CHANDRA SINGH COLLEGE OF PHARMACY",
  "SHRI CHEDIRAM SHUKLA MAHILA MHAVIDYALAY, SEMUR, HANSWAR, AMBEDKAR NAGAR    ",
  "D.N. P.G. COLLEGE, FATEHGARH,",
  "ALL INDIA CHILDREN CARE AND EDUCATIONAL DEVELOPMENT SOCIETY NURSING COLLEGE, AZAMGARH    ",
  "KAILASH SINGH MAHILA MAHAVIDYALAY BARDIHA PARSHURAM LAR DEORIA    ",
  "VIDYAWATI DEVI COLLEGE PHARMACCY",
  "NARAINA COLLEGE OF MANAGEMENT, PANKI,",
  "CAPTAIN SUKHWASI SINGH SMARAK JANTA MAHAVIDYALAYA, GHATAMPUR,",
  "SRI THAKUR JI MAHARAJ MAHAVIDYALAYA, PURWA,",
  "RAVI SCHOOL OF NURSING",
  "DR. VISHAMBHAR SINGH PRATAP SINGH MAHAVIDYALAYA, TATIAGANJ,",
  "RAJKEEYA MAHAVIDYALAYA,",
  "KAMLA MODERN NURSING INSTITUTE JHANSI",
  "MAHARAJA HARISHCHANDRA MAHAVIDYALAYA, BARHPUR,",
  "College of Fisheries Science  and Research Centre Etawah",
  "COLLEGE OF DAIRY TECHNOLOGY ETAWAH",
  "SIDDHESWAR MAHARAJ MAHAVIDYALAYA, NIGHRA ROAD, KARMPUR,",
  "YAMUNA ARUN KUMAR SHUKLA SMARAK SHIKSHAN SEWA SANSTHAN, PADRI, NAGRA, BALLIA    ",
  "SHRI DOODHNATH SARVODAYA VIDHI MAHAVIDHYALAYA SAKRAR JHANSI    ",
  "HALIM MUSLIM P.G. COLLEGE,",
  "SHRI LALA RAM  MAHAVIDYALAYA ,SHRINAGAR, KALAN, SHAHJAHANPUR",
  "K.K. P.G. COLLEGE,",
  "HAJI NESHAR AHAMAD MAHAVIDYALAY    ",
  "INTEGRATED ACADEMY OF MANAGEMENT. & TECHNOLOGY ,  GHAZIABAD",
  "SCHOOL OF MANAGEMENT SCIENCES, SULTANPUR ROAD",
  "NARAYAN ARYA KANYA PATHSHALA,",
  "H.S.A. DEGREE COLLEGE, RAJIPUR, KAMALGANJ,",
  "AVADH INSTITUTE OF MEDICAL TECHNOLOGY AND HOSPITAL",
  "VIJAY LAXMI MAHILA MAHAVIDYALAYA , JALHUPUR , VARANASI    ",
  "SHRI GURU NANAK GIRLS DEGREE COLLEGE",
  "DEI TECHNICAL COLLEGE",
  "DURGA SHIKSHA NIKETAN MAHAVIDYALAYA, B K T, LUCKNOW",
  "OXFORD MODEL INSTITUTE OF ADVANCE STUDIES, SHYAM NAGAR,",
  "SMT. MANORAMA MAHAVIDYALAYA, FAFOOND ROAD,",
  "BABURAM MOHANLAL MAHAVIDYALAYA, BIDHUNA,",
  "CONSTITUENT GOVERNMENT COLLEGE, MEERAPUR BANGAR, BIJNOR",
  "PT TRILOKINATH MISHRA VIDHIMAHAVIDYALAYA    ",
  "RAMESHWARAM INSTITUTE OF EDUCATION AND TRAINING, SITAPUR ROAD",
  "AVADH GIRLS DEGREE COLLEGE",
  "JAI NARAYAN P.G. COLLEGE",
  "SRI BAJRANGI MAHAVIDYALAYA, MAWAI MUKTA, NANDPUR,",
  "RAMADHEEN SINGH GIRLS DEGREE COLLEGE, DALIGANJ",
  "HEERALAL YADAV BALIKA DEGREE COLLEGE, SAROJNI NAGAR, KANPUR ROAD, LUCKNOW",
  "RAM PRASAD BISMIL MEMORIAL DEGREE COLLEGE,",
  "ROOP RANI SUKHNANDAN SINGH COLLEGE, NAUBASTA,",
  "BHALCHANDRA INSTITUTE OF EDUCATION & MANAGEMENT",
  "BIT Extension Center, Noida",
  "MAYA DEVI KANYA MAHAVIDYALAYA BHAISORA YUSUK NAGALIYA SAMBHAL",
  "ABHISHEK PHARMACY COLLEGE WARD N FIVE LOKMANYA TILAK NAGAR CHANDAULI",
  "DEV BHOOMI COLLEGE OF PHARMACY",
  "ASHOK SINGH PHARMACY COLLEGE MAHAROOPUR JAUNPUR",
  "ROHAN SINGH MAHAVIDYALAYA LUKTARA BANDA     ",
  "SHANTI MANGALICK COLLEGE OF NURSING AND PARAMEDICAL AGRA",
  "ABHISHEK NURSING AND PARAMEDICAL INSTITUTE WARD N FIVE LOKMANYA TILAK NAGAR CHANDAULI",
  "Kisaan Snatkottar Mahavidyalaya ,Baghawa Ghazipur",
  "J.P. INSTITUTE OF EDUCATION,  MAWANA ROAD, MEERUT ,  Ph. No :-  2551515, 2550522, 2540845",
  "PT BACHCHAN JI MAHAVIDYALAYA USARI CHAKIYA CHANDAULI    ",
  "VIVEKANAND GIRLS VIDYAPEETH IBRAHIMPATTI BALLIA    ",
  "SMT SHAKUNTALA DEVI NURSING AND PARAMEDICAL COLLEGE    ",
  "VATSALYA NURSING COLLEGE",
  "SHER BAHADUR CHANDRAWATI SINGH MAHAVIDYALAYA KAIBHA KEMAURA SULTANPUR",
  "Pandit Girdhari Lal College of Education, kuchesar, road, chaupla  fatehpur, post babugarh chhawani,  distt hapur",
  "RASHTRIYA MAHAVIDYALAYA MANDA RASRA BALLIA",
  "BHAGAUTI PRASAD MAHILA MAHAVIDYALAYA JAUNPUR    ",
  "KAMTA PRASAD MISHRA LAW COLLEGE TULAPUR SIKANDRA ALLAHABAD",
  "Shyam Sunder Shikshan Prashikshan Mahavidyalaya",
  "GANGARAM SETH DEGREE COLLEGE KALAN, SHAHJAHANPUR",
  "SHAMBHUNATH MEMORIAL NURSING COLLEGE    ",
  "S A VIDHI MAHAVIDYALAYA     ",
  "DR CHANDRABHAN SINGH KANYA MAHAVIDHALYA MOTH    ",
  "VINDHYA LAW COLLEGE GORDIHA, ROBERTSGANJ SONEBHADRA    ",
  "WTM AYURVEDIC MEDICAL COLLEGE AND HOSPITAL    ",
  "VIMALA DEVI SANSKRIT MAHAVIDYALAY MOKALPUR GOBARAHAN VARANASI    ",
  "CH. SURENDRA SINGH MAHAVIDYALAYA, MAJHIGAWAN, SAURIKH,",
  "AUTONOMOUS STATE MEDICAL COLLEGE AURAIYA UTTAR PRADESH     ",
  "AUTONOMOUS STATE MEDICAL COLLEGE KUSHINAGAR     ",
  "DR SARVESH KUMAR SHUKLA INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES BAHRAICH",
  "PRAKASH VIDYA MANDIR MAHILA MAHAVIDYALAYA, DABAULI WEST,",
  "CHAUDHARY INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "CH KEHAR SINGH INSTITUTE OF PARAMEDICAL SCINECES & HOSPITAL BAGHPAT",
  "ASIAN INSTITUTE OF SCIENCE & TECHNOLOGY, SEKHUPUR,",
  "VAMDEV SINGH MAHAVIDYALAYA,",
  "SARLA DWIVEDI MAHAVIDYALAYA, AKBARPUR, KANPUR DEHAT",
  "DR. B.R. AMBEDKAR LAW DEGREE COLLEGE, GIRWAN ",
  "KR. R.C.M COLLGE,MAINPURI",
  "A.P.S. DEGREE COLLEGE SHIVPURI BAJNA MATHURA",
  "SHAHEED BHAGAT SINGH INSTITUTE OF MANAGEMENT & TECH., RAMHUT",
  "LAKSHYA COLLEGE OF MANAGEMENT & TECHNOLOGY, BAGWARA, SEOHARA",
  "NALANDA MAHAVIDYALAYA, KASAMPUR, DHANNAMAFI URF PATTI",
  "SWAMI KALYAN DEV DEGREE COLLEGE, ALHAIDADPUR MUBARAK",
  "SHRI VIKRAM SINGH DEGREE COLLEGE, MOHAMMADPUR, RAJORI",
  "ATMARAM MAHAVIDYALAYA, ALAPUR",
  "KHAWAJA GHAREEB NAWAZ( KGN) DEGREE COLLEGE, BANKOTA",
  "BANKEY BIHARI KANYA MAHAVIDYALAYA",
  "CHAUDHARY HARNAM SINGH MAHAVIDYALAYA, BHUTA",
  "LOTUS INSTITUTE OF MANAGEMENT, LUCKNOW RD",
  "TRILOKCHANDRA DEGREE COLLEGE, CHITAULY, FATEHGANJ (W)",
  "P.G.I. MANAGEMENT, LUCKNOW RD, PO RAJAU",
  "SHRI GANESH SINGH MAHAVIDYALAY, AHRAN SUVANSH, MILKIPUR, AYODHYA",
  "CROSS BELLY INSTITUTE OF PHARMACY, AZAMGARH (1276)",
  "FUTURE INSTITUTE OF MANAGEMENT STUDIES, LUCKNOW ROAD,",
  "ST88 DEEH KABIRA BABA DEGREE COLLEGE SERVADEEH PISAWAN SITAPUR",
  "UTKARSH SCHOOL OF MANAGEMENT & TECHNOLOGY,RAMPUR ROAD",
  "MAA GAYATRI MAHILA MAHAVIDHYALAY RURA KANPUR DEHAT",
  "MAA SHAHAZADI DEVI MEMORIAL NURSING COLLEGE, BIJARVA POST BANKAT TAHSIL SAGARI AZAMGARH",
  "RANVEER NEELAM MAHAVIDYALAYA, BHARTHANA,",
  "DIXIT COLLEGE OF HIGHER EDUCATION, NASRAT NAGAR",
  "APEX COLLEGE OF MANAGEMENT & COMPUTER APPLICATIONS, KAUSHAL GANJ",
  "ASIM SIDDIQUE MEMORIAL DEGREE COLLEGE, MEERA SARAI",
  "KASHI RAM MEMORIAL COLLEGE,, MANPUR, BAHERI",
  "SRI TARA SINGH MAHILA MAHAVIDYALAYA",
  "AUTONOMOUS STATE MEDICAL COLLEGE KAUSHAMBI    ",
  "Navoday Mahavidyalaya, Ramipur, Medha",
  "GURU TEG BAHADUR DEGREE COLLEGE, CHHAVI",
  "Radhakrishna Mahila Mahavidyalaya Tilak Patti Dudahi Kushinagar",
  "Savitri Devi Mahavidyalaya, Fattupur Kalan M. Badshahpur Jaunpur",
  "PARMARTH COLLEGE OF PHARMACY HAPUR",
  "MVR LAW COLLEGE",
  "DESH DEEPAK ADARSH LAW COLLEGE TENDUA MAFI BIKAPUR AYODHYA",
  "ASCENT COLLEGE",
  "UNITY DEGREE COLLEGE, RAMPUR",
  "AMBEDKAR GENERAL NURSING TRAINING CENTRE MIRZAPUR",
  "UMAPATI MAHADEV BALIKA MAHAVIDYALAYA, AMROHA",
  "SUBHASH SMARAK DEGREE COLLEGE, RAMPUR ",
  "SANJEEVANI NURSING COLLEGE",
  "SMT. SHANTI CHAUHAN SMARAK MAHAVIDYALAYA, RAMPUR",
  "SHRI RATAN SINGH MEMORIAL MAHAVIDYALAYA, SHAHJAHANPUR",
  "SHRI RAMGOPAL SINGH MAHAVIDYALAYA, MORADABAD ",
  "TRILOKI SINGH VIDHI MAHAVIDYALAYA, RATUAPAR AZAMGARH",
  "Indira Gandhi College of Pharmacy",
  "SHAHEEN SMARAK MAHAVIDYALAYA, SAMBHAL",
  "SAI COLLEGE ( MAHILA ), PILIBHIT ",
  "RAJSHREE MEDICAL RESEARCH INSTITUTE, BAREILLY",
  "PREMA DEVI MAHAVIDHYALAYA BHAGYA NAGAR LAIGAON KISHNI MAINPURI    ",
  "SHRI PRAMOD CHARAN DWIVEDI VIDHI MAHAVIDYALAYA, DEVPALPUR, CHAUBEPUR, KANPUR",
  "COLLEGE OF EDUCATION AND TECHNOLOGY DEVPALPUR, CHAUBEPUR, KANPUR",
  "SRI RAM CHANDRA CHATTURVEDI, AERAHO,TIRWA, KANNAUJ",
  "RAJKIRAN DEGREE COLLEGE, YAKUTPUR, MORADABAD ",
  "GANGOTRI SCHOOL OF NURSING",
  "RADHA KRISHAN DEGREE COLLEGE, BUDAUN",
  "NORTH INDIA COLLEGE OF LAW, BIJNOR ",
  "NEW SAINIK COLLEGE OF LAW, MORADABAD ",
  "LOKMANI LAW SCHOOL KADRABAD KHURD, SEOHARA, BIJNOR",
  "LAL BAHADUR SHASTRI COLLEGE OF HIGHER EDUCATION, BAREILLY",
  "LALMANI MAHILA MAHAVIDYALAYA FAGUI CHANDAULI",
  "KAMLA PANDEY WOMEN EDUCATIONAL INSTITUTE, NIJAMUDDINPUR, DULLAHPUR, GHAZIPUR",
  "PRIYANKA OMENDRA COLLEGE OF LAW ANJANI MAINPURI",
  "KRISHNA COLLEGE OF EDUCATION, BIJNOR",
  "KHUSRO MEMORIAL DEGREE COLLEGE, SARKAURI, BUDAUN ",
  "KHUSRO DEGREE COLLEGE, BAKARGANJ, PILIBHIT ",
  "RAJKIYA MAHAVIDYALAYA, KANTH, MORADABAD",
  "K. P. PATEL MAHILA MAHAVIDYALAYA",
  "GMS COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "ANAND NURSING COLLEGE MEERUT",
  "B.D.H.S MAHAVIDYALAYA, ALIGARH",
  "SMT. KELA DEVI SHARMA MAHAVIDHYALAYA",
  "Harsh Mahavidhyalaya, Mehrara Road, Sahpau, Hathras",
  "VISHVAKARMA KANYA MAHAVIDYALAYA BAJANA ROAD TAPPAL ALIGARH",
  "MAHARSHI DAYANAND VIDYA SANSKRITI MAHAVIDYALAYA,AHEN,MAHAMAYA NAGAR",
  "Maa Gayatri Institute, Chandos, Aligarh",
  "KRISHNA COLLEGE OF DEGREE AND TECHNOLOGY BUDHU NAGLA HEMRAJ HATHRAS",
  "JANTA MAHAVIDHYALAYA KAILTHA ALIGANJ ETAH",
  "VIRANGANA AVANTI BAI MAHAVIDYALAYA BHOOPALPUR, ETAH",
  "K S MAHAVIDHYALAYA, RAM GARH, HATHRAS",
  "MOOLCHAND MEMORIAL KANYA MAHAVIDYALAYA",
  "Dr V P Madnawat College of Educational and Professional Courses",
  "MOTHER TERESA WOMEN COLLEGE,RAM GHAT ROAD,ALIGARH",
  "SRI CHET RAM SINGH MAHAVIDYALAYA SIRSOL MOHANPUR KASHI RAM NAGAR",
  "SHIVDAN SINGH INSTT. OF TECH. & MANAGEMENT IGLAS, ALIGARH",
  "SHRI RAGHUVEER SINGH YADAV MAHAVIDYALAYA, NAGLA DAMAR PATIYALI",
  "SHRI MALKHAN SINGH MAHAVIDHALAYA,RUDRAPUR, ETAH",
  "Shri Ramswaroop Gangaprasad College",
  "SMT.KAPOORI DEVI MAHAVIDHYALAYA,BILAWALI HASSANA,JAGMOHAN,ALIGHAR",
  "Dr. RAM MANOHAR LOHIA DEGREE COLLEGE, DHOLNA, KASGANJ",
  "J.P.G.D DEGREE COLLEGE CHANDEPA, HATHRAS",
  "GYAN VIGYAN INSTITUTE OF EDUCATION, PAKHAUDANA KHAIR",
  "SHRI SURESH KUMAR PUNDHIR DEGREE COLLEGE, BADHANU",
  "KALYANI GIRLS DEGREE COLLEGE MOREHRA, ETAH",
  "MALKHAN SINGH MAHAVIDHYALYA, HATHRAS",
  "JAY BAJRANG MAHAVIDHYALYA, CHAMKARI",
  "CH.CHARAN SINGH SHIVDAN SINGH COLLEGE,IGLAS,ALIGARH",
  "SHRI KRISHAN YOGIRAJ DEGREE COLLEGE RATIBHANPUR,MAHAMAYA NAGAR",
  "K.G.N DEGRE COLLEGE,SIKANDRA,RAO ,MAHAMAYA NAGAR",
  "SRI CHANDRA SWAMI DEGREE COLLEGE,GANAGA NAGAR.ETAH",
  "RADHA KRISHNA MAHAVIDHALAYA,PUL ALTHARA,KAKRAWLI,ETAH",
  "LAL BAHADUR SHASTRI KANYA MAHAVIDYALAYA, AGRA ROAD",
  "JAWAHAR LAL LODHI DEGREE COLLEGE, MADKARA JAGANNATHPUR, BAREILLY",
  "SRC (Smt Rajrani Chauhan) Law College",
  "RAM BAI PATEL MAHAVIDYALAY DEVKALI CHITRAKOOT     ",
  "DCS COLLEGE OF LAW, MURADNAGAR ROAD, BAGHPAT, UTTAR PRADESH",
  "Government Degree College Bahua Dehat Fatehpur",
  "EXCEL SCHOOL OF NURSING, KANPUR",
  "NARAYAN LAXMAN MAHAVIDYALAYA, BASANT NAGAR,",
  "SWARGIYA RAMVILASH SINGH SHIKSHAN SANSTHA LAW COLLEGE PACHPHERWA MUGHAL SARAI CHANDAULI",
  "D.M.R. DEGREE COLLEGE, BHAGUWALA, BIJNOR",
  "CHAUDHARY GAYASUDDIN MAHAVIDYALAYA, UJARI",
  "M D College",
  "SARASWATI SHIKSHAN SANSTHAN SARSAWA",
  "DARSHAN SINGH SMRITI MAHAVIDYALAYA,",
  "MAYANK SHEKHAR MAHAVIDYALAYA, KAURAWAN,",
  "Hashmi Mahila Mahavidyalaya, Amroha",
  "Veer Kunwar degree College",
  "Syed Degree College, Saidpur",
  "Gulab Singh Hindu Mahavidyalaya, Chandpur",
  "ramlalit singh vidhi mahavidyalay",
  "RAM NARESH SINGH MAHILA MAHAVIDYALAY",
  "RAMLALIT SINGH MAHILA MAHAVIDYALAY",
  "Jeet Bahadur Singh Mahavidyalay, Village and Post - Garavpur, Tehsil  Lambhua",
  "SAMS INSTITUTE OF HOTEL MANAGEMENT, VARANASI",
  "SHAMBHUNATH INSTITUTE OF LAW",
  "Maa Khandwari Mahila Mahavidyalaya",
  "SUMAN DEVI BRAJ KISHORE SINGH VIDHI MAHAVIDHYALAYA, CHHIBRAMAU, KANNAUJ",
  "NARSINGH BAHADUR SINGH MAHAVIDYALAYA MUKUNDPUR HOLAGARH SORAV PRAYAGRAJ",
  "Baba Ramcharitra Mahavidyalaya Mirdadpur Ghazipur",
  "MAJOR JAYKARAN SINGH CHANDEL MAHAVIDYALAYA MAHEBA JALAUN",
  "SUCHITA NANDAN MAHAVIDYALAYA",
  "MU. RAMDHANI JAGROOP SINGH DEGREE COLLEGE, BAISHKANTI,",
  "Ch. Narendra Pratap Mahavidyalalya, Rampur-Bakewar, Fatehpur",
  "PT. RAM KUMAR SHUKLA MAHAVIDYALAYA",
  "babu ram naresh singh memorial degree college",
  "MAA RAJ RANI MAHALA MAHAVIDYALAYA, BAGHLA (MADANPUR), DUBAHA, ALLAHABAD",
  "Rajkeeya Mahavidyalaya, Gosaikheda, Unnao",
  "LAL SINGH MAHILA MAHAVIDYALAYA,AKBARPUR,KANPUR DEHAT",
  "HARI INSTITUTE OF TECHNOLOGY RANDEVI, SHARANPUR",
  "SHREE MATI KALAVATI DEVI PRATHVI PAL SINGH MAHILA MAHAVIDYALAYA KAMASIN BANDA, BANDA",
  "Pahalwan Indradeo Mahila Mahavidyalaya, Ghazipur",
  "R.D.ENGINEERING COLLEGE, DUHAI, GHAZIABAD",
  "ISABELLA THOBURN COLLEGE (PROFESSIONAL STUDIES)",
  "Rainbow Mahila Sansthan, Nandganj, Ghazipur",
  "Sardar Patel Mahila Mahavidyalaya, Banda ",
  "Ramdev Balika Mahavidyalaya, Gopalpur, Amari, Suithakala, Jaunpur",
  "AMAR SINGH RAJPOOT MEMORIAL MAHAVIDYALAY",
  "SARYU INDRA MAHAVIDYALAYA, SANGRAM GARH, PRATAPGARH",
  "SHRI  SHYAM COLLEGE OF LAW",
  "RAGHURAJ PRATAP SINGH MAHAVIDYALAYA",
  " BABU BANARASI DAS INSTITUTE OF TECHNOLOGY AND MANAGEMENT, LUCKNOW",
  "Manvendra Singh Suman Mahavidyalaya Pesara Kerakat Jaunpur",
  "ALKHA MAHILA MAHAVIDYALAY",
  "BHUWAR SINGH SMARAK MAHAVIDYALAYA RAIBIGO KADIPUR SULTANPUR ",
  "PARVATI DEVI MAHAVIDYALAYA PAIGAMBERPUR ALHAIPUR MOHKAM DHAMPUR BIJNOR",
  "Shri Shiv Mangal Singh Memorial Degree College  Mirzapur Shahjahanpur",
  "LOTUS INSTITUTE OF PHARMACY",
  "R K INSTITUTE OF PHARMACY",
  "ACME INSTITUTE OF PHARMACY",
  "BRIGHT FUTURE DEGREE COLLEGE GAJROULA KALAN ",
  "Shiv Adarsh College Of Education",
  "061-PT. SRI JAGANNATH PRASAD MAHAVIDHYALAYA,DABRAI,SAMSHABAD,AGRA",
  "RAJKIYE MODEL MAHAVIDHALAY, PULWARA, LALITPUR",
  "Shiv Adarsh Degree College",
  "RANI LAXMI BAI MAHAVIDHYALAYA BUDHWAR ROAD LALITPUR",
  "saraswati mandir mahavidyalaya madawara lalitpur up ",
  "RAM CHARITRA SHUKLA MAHAVIDYALAYA PARANIPUR MEJA PRAYAGRAJ",
  "SRI SITA RAM KEWALA DEVI MAHA VIDAYAL MALAK TULAPUR SHIVGARH SULTANPUR",
  "ABHINAV COLLEGE OF TEACHING AND TRAINING KOLHAMPUR NAWABGANJ GONDA",
  "PAHALWAN GURUDEEN PRASIKSHAN MAHAVIDYALAYA",
  "S.D. COLLEGE OF LAW,  S D COLLEGE CAMPUS, BHOPA ROAD, MUZAFFARNAGAR",
  "SMT. MUKHTARI DEVI TIKATA KANYA MAHAVIDYALAYA, SISOLI,  MUZAFFARNGAR",
  "Devpreet Degree College",
  "SRI MAHENDRA SINGH COLLEGE PIPRAULI GARIYA ETAWAH",
  "THAKUR SUBA SINGH DEGREE COLLEGE, BIRALSI, MUZAFFARNAGAR",
  "TRIDEV COLLEGE OF EDUCATION (FOR WOMEN)",
  "SHRI KRISHNA RAM BAHADUR SHANTI DEVI MAHILA MAHAVIDYALAYA LAKSHAMANPUR GRANT BIKAPUR FAIZZABAD",
  "R A B D MAHAVIDYALAYA HASRI MADAWARA LALITPUR",
  "HAFIZ RAHMAT KHAN DEGREE COLLEGE SARAINI TURKUNIYA",
  "UNIQUE COLLEGE OF LAW, NEAR CHAUDHARPUR, DELHI ROAD",
  "Shiv Shanker Singh Mahavidyalay, Sadat, Gazipur",
  "HAFIZ RAHMAT KHAN DEGREE COLLEGE CHANDOI PILIBHIT",
  "RAJKEEYA MAHILA MAHAVIDYALAYA, DEVAVARAMPUR DEHAT CHHIBRAMAU, KANNAUJ",
  "ASHOK SHUKLA MAHILA MAHAVIDYALAYA KONCH",
  "LORD MAHAVEER COLLEGE OF LAW, BIJNA KASHIPUR ROAD",
  "BAL BHARTI DIGREE COLLEGE",
  "SGLM MAHILA MAHAVIDYALAYA BADAUSA , BANDA",
  "PT. GHANARAM HARIRAM MAHAVIDYALAYA MANGROTH HAMIRPUR",
  "ASHARFI LAL SHUKLA MAHAVIDYALAYA KIRWAHA (RAMPURA)",
  "RAJIV GANDHI GRAMIN COLLEGE",
  "CHOUDHARY DIGVIJAY SINGH MAHAVIDYALAYA DAKOR",
  "mahacharan smarak mahavidyalaya revan, mauranipur, jhansi",
  "MAHALAXMI COLLEGE OF LAW",
  "GYAN BHARTI COLLEGE, HALGOYA, BADGON  ROAD, SAHARANPUR",
  "S.S. MAHAVIDYALAYA ",
  "GYANSTHALI LAW COLLEGE",
  "HARKESH SINGH RANA MAHAVIDHYALYA",
  "ISLAMIA COLLEGE OF LAW DEOBAND, SAHARANPUR",
  "MAHAVIR INSTITUTE OF MANAGEMENT & TECH. DEHRADUN ROAD, VILL-RASULPUR, PO-CHHUTMALPUR DISTT SAHARANPUR",
  "TH HAR NARAYAN SINGH VIDHI MAHAVIDYALAYA, KARAILABAGH PRAYAGRAJ",
  "SHRI RAM JANKI MAHAVIDYALAYA HASANPUR KATAULI LAKHIMPUR KHERI ",
  "G S MEDICAL COLLEGE AND HOSPITAL HAPUR",
  "RAMDOOT COLLEGE OF EDUCATION SAHARANPUR-NAKUR, RANDEVI, SAHARANPUR 09456229246",
  "SWAMI KALYAN DEV SHAMBHU SINGH BHOOMALI DEVI DEGREE COLLEGE",
  "SHRI KRISHNA COLLEGE OF LAW VILL. TELIPURA POST SARSAWA, DISTT. SAHARANPUR",
  "CH. RAM SINGH COLLEGE OF EDUCATION, KHERA CHAUGAVA,JANSATH",
  "BHAGWANT INSTITUTE OF TECHNOLOGY BUGHWANTPURAM, MUZAFFARNAGAR",
  "Jain College of Education, Banat Shamli",
  "CHANDPUR PHARMACY COLLEGE CHANDPUR BIJNOR",
  "PAHUNCHI LAL MAHAVIDHYALAYA LAKHRAUA FARRUKHABAD ",
  "PREM WATI DEVI MAHAVIDHYALAYA",
  "Kanhaiya Lal Vishnu Charan Mahavidyalaya",
  "shri guru hargovind sahabh ji memorial college of education",
  "SINGH SAHAB HOMOEOPATHIC MEDICAL COLLEGE AND HOSPITAL",
  "Satya Narayan Singh Mahavidyalay",
  "VEER VIJAY EDUCATION SOCIETY",
  "MEERUT VIDYAPEETH EDUCATIONAL INSTITUTE MULHERA SARDHANA MEERUT",
  "ZAKIR HUSSAIN COLLEGE OF HIGHER EDUCATION MULHERA SARDHANA MEERUT",
  "Himalayan College of Education, Baraut, Baghpat-250611",
  "MAA SHARDA DEVI MAHAVIDYALAYA , BARABANKI",
  "Chaudhary Charan Singh Institute of Education for Women,Baghpat",
  "SHIV SAVITRI EDUCATIONAL INSTITUTE",
  "SAYEED MOHAMMAD ISHTIYAAK MAHAVIDYALAYA KALYANPUR NAWABGANJ GONDA",
  "KRISHNA INDRA VIDYA BALIKA MAHAVIDYALAYA",
  "Kothiwal Dental College & Research Centre",
  "Dr. Shiv Prasad Rajpati Mahavidyalay, Dariba, Zafrabad, Jaunpur",
  "MAUJILAL RAM KISHOR MAHAVIDYALAY GOKULPUR KODA JAHANABAD",
  "RAMANAND SINGH COLLEGE OF EDUCATION ",
  "krishnarpit institute of education ",
  "MAA ANJANI  PARI  EDUCATION INSTITUTE ETAH ROAD SHIKOHABAD",
  "SAYYADAH SIDDIQUA GIRLS DEGREE COLLEGE",
  "Sri Thakur Shiv Bahadur Yashvant Singh Mahavidaylaya Rajnager Bhadar Amethi",
  "UNURKHA TIWARI DANPATI SHIKSHAN PRASHIKSHAN MAHAVIDYAL BEWANA AMBEDKERNAGAR ",
  "Smt. Shyama Devi Harsh Mahila Mahavidyalay",
  "SANT PRASAD SURJANDEEN MAHAVIDYALAYA PURE AJEETAN UNCHGAON SHUKUL BAZAR AMETHI",
  "SWAMI VIVEKANAND COLLEGE OF HIGHER EDUCATION BITHRA PILIBHIT",
  "DEV INDRAWATI MAHILA MAHAVIDHYALAYA KATEHARI AMBEDKAR NAGAR UP",
  "SCPM AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "GRAMODAYA MAHILA MAHAVIDYALAY",
  "PRAKASH SHIKSHAN PRASHIKSHAN SANSTHAN MACHAULI SHIVTARA AMBEDKAR NAGAR",
  "SMT VIMLA SINGH MEMORIAL WOMEN COLLEGE OF EDUCATION AND MANAGEMENT",
  "ANURAG SHIKSHAN EWAM PRASHIKSHAN SANSTHAN DARRA CHUNAR MIRZAPUR UP",
  "MANU LAW COLLEGE",
  "MADHU VACHASPATI INSTITUTE OF PHARMACY",
  "I.I.M.T COLLEGE OF EDUCATION GANGA NAGAR , MAWANA ROAD, MEERUT",
  "Doodhnath Shikshan Sansthan, Molnapur, Jakhaniya, Ghazipur",
  "RAM SUNDER VERMA SMARAK MAHAVIDYALAYA BHADULI CHILVARIYA BAHRAICH",
  "DEVATA DEVI MAHILA DEGREE COLLAGE",
  "DR UDAI JASRAJ RATNA MAHILA MAHAVIDYALAYA",
  "Vishva Bharti Vidyapeeth",
  "GEETA SINGH MAHILA MAHAVIDYALAYA JAISINGH MAU TARUN FAIZABAD",
  "Doon Ayurvedic Medical College and Hospital ",
  "UNNATI PHARMACY COLLEGE ",
  "ODV COLLEGE OF EDUCATION",
  "Pt Bhrigunath Chaturvedi College of Law",
  "CH  ASHARAM TYAGI MAHAVIDYALAY  JARODA PANDA  SAHARANPUR",
  "SVD Gurukul Vidhi Mahavidyalaya Dumduma Unchgaon Jaunpur",
  "Pt. Devi Dayal Studies of Higher Education ",
  "Shakun Education of Institute",
  "SHRI NAVAL KISHOR COLLEGE KARANPUR CHAURAHA FARAH MATHURA",
  "turki college of education",
  "SRI VIKRAMA CHAUBEY SANSKRIT MAHAVIDYALAYA, DEVA, DULLHPUR, GHAZIPUR",
  "SHRI RAM MAHAVIDYALAY PATAUA BIRDHA LALITPUR",
  "Institute of Engineering and Technology",
  "ABDUL KALAM COLLEGE OF EDUCATION ALIPUR SARDHANA MEERUT UP ",
  "Ch.surendra singh B.ed Mahavidhyalaya Majhigawan Saurikh Kannauj",
  "FACULTY OF PHARMACY FUTURE INSTITUTE OF MEDICAL SCIENCES",
  "SAINIK ANJANI KIRAN MAHAVIDYALYA GOTHAIN NAGRA BALLIA",
  "SHRI SANKTHA PRASAD KAMLA DEVI SANSKRIT MAHAVIDYALAYA MALSIL MEHANDI",
  "DURGA DEVI HEERA LAL DEGREE COLLEGE DELHUPUR",
  "R K MAHAVIDYALAYA BHELARA GHATAMPUR SULTANPUR",
  "ASIAN VIDHI EVAM NYAYIK VIGYAN MAHAVIDYALAYA, KHAMPUR (URF) GANGAPUR, NAWABGANJ, BAREILLY",
  "Lalchand College Of Teacher Education Pahadpurkhurd Ghazipur",
  "Nirmal Moolchani shikshan prashikshan sansthan Mahila Mahavidyalaya Nasirpur Hansrajpur Ghazipur",
  "SRI JAI NARAYAN MAHAVIDALAY DURGIPUR BERUWARBARI BALLIA",
  "SMT RAJ KUMARI SHUKLA VIDHI MAHAVIDYALAY TIKARI ALLAHABAD",
  "Ramnageena shikshak prashikshan Mahavidyalaya Pahadpur Kalan Ghazipur",
  "P G S MAHAVIDYALAY GORAI IGLAS ALIGARH",
  "ERAM UNANI MEDICAL COLLEGE & HOSPITAL, GUDAMBA,",
  "GANPATI COLLEGE OF HIGHER EDUCATION DASHRATHPUR SAKOTI TANDA MEERUT ",
  "ASTER COLLEG OF EDUCATION J-1, SILVER OAK STATE, DELTA-IInd, GREATER NOIDA",
  "SHRI UDAL SINGH MAHAVIDHYALAYA ASFABAD FIROZABAD ",
  "Shri Vaidik Sanskrit Vidyalaya, Kachaura, Mahamayanagar",
  "DAYA AWADH GIRLS COLLEGE OF EDUCATION MOHAMMADPUR AMANIGANJ FAIZABAD",
  "Baba Vishvanath Mahavidyalaya, Teliyani Bahadiya, Ghazipur",
  "MAA LILAWATI SUDESHWARI INSTITUTE OF PHARMACY",
  "RAJ NARAYAN MISHRA MAHAVIDYALA",
  "Chandrawati Vindo Mahila Mahavidyalya Gopalpur Udharan Ballia",
  "MAJOR S.D. SINGH AYURVEDIC MEDICAL COLLEGE & HOSPITAL,",
  "Prabal Brahm Mahavidyalya, Awathahi, Ghazipur",
  "ABU HURAIRAH GIRLS COLLEGE",
  "HYGIA INSTITUTE OF PHARMACY ",
  "sj education centre ramaipur kanpur ",
  "PARVATI MAHILA MAHAVIDYALAYA KALAN SULTANPUR",
  "Aastha Institute of Professional Studies",
  "SHANTI AMAR SINGH COLLEGE OF EDUCATION",
  "SHRI RAM SINGH LODHI RAJPUT MAHAVIDHYALYA  DIBAI  DISTT BULANDSHAHAR ",
  "I.I.M.T ENGG. COLLEGE GANGA NAGAR , MAWANA ROAD, MEERUT  Ph. 0121-2621006, 2620287, 2620284",
  "TRANSLAM COLLEGE OF LAW P.O. - RAJPURA, MAWANA ROAD, MEERUT",
  "GHAUSIA COLLEGE OF PHARMACY FATEHPUR",
  "DUNNI LAL JAISWAL DEGREE COLLEGE ",
  "MODERN DEGREE COLLEGE OF LAW",
  "MAA HANS VAHINI MAHAVIDHYALAY RAMPUR BASANI CHANDAULI",
  "Kanpur Institute for Teacher Education",
  "UJJAGAR LAL DEGREE COLLEGE, TAPKAPUR, GURUSHAYAGANJ, KANNAUJ",
  "Smt. Mohan Kaur College Of Law",
  "Mata Jahendra Mahila Mahavidyalaya, Bhitari, Gazipur",
  "KAMLA NEHRU INSTITUTE OF  PHYSICAL & SOCIAL SCIENCES, SULTANPUR",
  "DIMT LAW COLLEGE",
  "Atlantis College of Education",
  "Saraswati Devi Mahavidyalaya ",
  "Haldaur DegreeCollege Haldaur ",
  "Geeta law college",
  "SHEETALA PRASAD MAHAVIDYALAYA, BIHAR KUNDA",
  "CH. S.S.D. COLLEGE",
  "JAI SHIV ACADEMY COLLEG E OFHIGHER EDUCATION, DHANPURA, MAWANA, MEERUT",
  "R.N.C. Mahavidyalaya Saidpur, Ballia",
  "Ramdhyan Mahavidyalaya, Jogapur, Budhau, Ballia",
  "Yashoda Nandan Mahila Mahavidyalaya, Gaura, Madanpura, Ekail, Ballia",
  "Vivekanand Mahavidyalaya, Semri, Ballia",
  "Veer Lorik Sughar Mahavidyalaya Vigah, Charauwa, Ballia",
  "VEER LORIK SHAHID ABDUL HAMEED BUDHINATH SARVODAY MAHAVIDYALAYA BALLIA",
  "Udit Narayan Rishabh Mahavidyalaya, Pindari, Ballia",
  "DAYASHANKAR VIDHI MAHAVIDYALAYA BASNEHTA PRATAPPUR HANDIA PRAYAGRAJ UTTAR PRADESH",
  "Tileshwari Devi Mahavidyalaya, Gaura, Patoi, Ballia",
  "Swatantrata sangram Senani Chaudhari Mahavidyalaya, Bisunpur, Baleshwar, Ballia",
  "SWATANTRA SRI ANIRUDH MAHAVIDYALYA, TARI BARA, GAWAN",
  "Swami Ramnarayanacharya Mahila Mahavidyalaya, Bilthraroad, Ballia",
  "SWAMINATH MAHAVIDHYALAYA",
  "Sudristi Baba Mahavidyalaya, Raniganj, Ballia",
  "Sri Swami Nath Singh Surendra Mahavidyalaya, Dharmpur, Kazipur, Ballia",
  "Sri Shiv Narayan Ganga Prasad Mahila Mahavidyalaya, Khanpur, Dumaria, Ballia",
  "SURESH CHANDRA MISHRA MAHAVIDYALAYA, NEAR RAMLILA MAIDAN, PRATAPGARH",
  "SARVODAY MAHAVIDYALAYA, TARAPUR, PRATAPGARH",
  "SARVODAYA BALIKA MAHAVIDYALAYA, SANGIPUR",
  "SAKET GIRLS DEGREE COLLEGE, DAHILAMAU, PRATAPGARH",
  "RAJ NARAIN SINGH MAHAVIDYALAYA, BHADOHI, PRATAPGARH",
  "KORAON VIDHI MAHAVIDYALAYA",
  "RAJENDRA PRASAD BALIKA MAHAVIDYALAY, VINAIKA ASPUR DEVSARA",
  "PT. RAJPATI MAHAVIDYALAYA, PARMI PATTI, PRATAPGARH",
  "Pt.Heeralal chhavraj Kunwar Mahavidyalay, Antu Dehat",
  "Kunti Devi Mahila Shikshan Prashikshan Sansthan, Sarai Sultani Raniganj",
  "DR RAM CHANDRA SHUKLA MEMORIAL VIDHI MAHAVIDYALAYA, FATEHPUR",
  "GOVERNMENT HOMEOPHATHIC MEDICAL COLLEGE, LUCKNOW",
  "YASHODA NANDAN HARIVANSH MAHAVIDYALAYA, TARANPUR SANDWA, CHANDRIKA, PRATAPGARH",
  "JANTA MAHAVIDYALAYA, CHANDRA NAGAR, SEHUD, DIBIYAPUR,",
  "TAUFIQ MEMORIAL DEGREE COLLEGE BAYARA SIDDHARTH NAGAR UP",
  "Ramdeo Singh Mahavidyalaya, Mahmaoodpur, Baharipur, Badalapur, Jaunpur",
  "Panchu Ram yadav Mahavidyalaya, Aara, Jaunpur",
  "SYMBIOSIS Law School, NOIDA",
  "LILAWATI DEVI MAHILA MAHAVIDYALAYA ",
  "MAA SARASWATI PARAMEDICAL INSTITUTE GHAZIPUR UP",
  "NAVEEN CHANDRA TIWARI SMARAK MAHAVIDYALAYA PARASARAY ITIYATHOK GONDA",
  "LAXMINARAYAN SHUKLA MAHAVIDYALAYA KHARA CHANDAUR SULTANPUR",
  "BIOVED RESEARCH INSTITUTE OF AGRICULTURE TECHNOLOGY AND SCIENCES ",
  "JUG LAL BALIKA MAHAVIDALAYA AKLAKHOR KATHAR JUNGLE KAPTANGANJ BASTI",
  "Vidya Kamla Mahila Shiksha Sansthan Dhuvarjun Ghazipur",
  "SWATANTRATA SANGRAM SENANI BHAGAUTI PRASAD YADAV SMARAK MAHAVIDYALAYA EVAM SHIKSHAN PRASHIKSHAN SANS",
  "NEELKANTH GIRLS COLLEGE OF EDUCATION REHTI TRILOCHAN JAUNPUR",
  "R C C COLLEGE OF PHARMACY",
  "CROSS BELLY COLLEGE OF PHARMACY KUKURIPUR SATHION AZAMGARH",
  "PT. DEV NARAYAN SHUKLA MAHAVIDYALAYA JAGATPUR AADIL HUSAINGANJ FATEHPUR",
  "Jai Bundelkhand Mahveer Mahavidyalaya Khohi Banda",
  "Dhanwanti Mahila Mahavidyalaya ",
  "RANA PRATAP SHIKSHA PRASHIKSHAN SANSTHAN MAHAVIDYALAY,A BHARAULI, DEORIA",
  "JARIBANDHAN MAHAVIDYALAYA",
  "BELA SINGH MAHAVIDYALAYA",
  "Shri Mahanth Maniraj Das Baliraj College",
  "T.R.C. MAHAVIDYALAYA",
  "H.L.Y. Degree College",
  "kanti degree college",
  "Maa Ramrathi Devi Balika Mahavidyalaya, Vikrampur, Ghazipur",
  "MUID AHAMAD KANYA MAHAVIDYALAYA DOSTPUR SULTANPUR",
  "Buddham Sharnam Mahavidyalaya Lodipur Zamaniya Ghazipur",
  "CIMT Degree College",
  "Sw. Ramashish Adarsh Mahavidyalaya, Shahpur, Mahmoodpur, Ghazipur",
  "RADHA KRISHNA COLLEGE OF PHARMACY",
  "BUDDHA DEGREE COLLEGE",
  "JEEVAK AYURVED MEDICAL COLLEGE AND HOSPITAL RESEARCH CENTER KAMLAPUR AKAUNI CHANDAULI",
  "Baldev Shridhar Vidhi Mahavidyalaya Bhavarha ,Pandeypur, Radhey, Ghazipur",
  "RADHA GOVIND COLLEGE OF EDUCATION",
  "Shri Rajroop Memorial Mahavidhyalaya, Harpur Belahi, Tamkuhiraj",
  "Dasharath Mahavidyalaya, Baheri ",
  "DR. LAL JI TRIPATHI MAHAVIDYALAYA, PATHANPUR",
  "DESHRANI RAJPOOT MAHAVIDYALAYA, JARAKHAR RATH",
  "MANIRAM VERMA EDUCATIONAL INSTITUTE, MADANA UPARHAR",
  "PARASNATH DEGREE COLLEGE",
  "BRIJ KISHOR NIRMALA DEVI MAHAVIDYALAYA",
  "Centre For Advanced Studies ",
  "Wisdom Education College",
  "BALA DEVI ROSHAN LAL COLLEGE OF HIGHER EDUCATION",
  "BADLU HASAN MEMORIAL DEGREE COLLEGE, JOYA",
  "KRISHNA NARESH MAHAVIDHLIYA",
  "DR.HARIVANSH RAI BACHCHAN MAHAVIDYALAYA  ",
  "A.P.S COLLEGE,KHIWAI",
  "LUTAWAN INSTITUTE OF PHARMACY",
  "Maa Fuliya Devi Mahila Mahavidyalaya, Jugnunagar, Mampur, Alawalpur, Ghazipur",
  "Govt. Degree college",
  "S.S.G. COLLEGE,596 M. MAUHAR",
  "R.S. Raj Mahavidyalaya, Sikrara Jaunpur",
  "SRIMATI SHANTI DEVI DEGREE COLLEGE ",
  "CH. J.S.S.S. MAHAVIDYALAYA ",
  "B.R. VIDHI MAHAVIDHYALAYA",
  "SHRI BABU RAM MAHAVIDYALAY",
  "PRACHI MAHAVIDYALAYA, NAUBASTA",
  "RAM CHARAN RAM DULARI KANYA MAHAVIDYALAYA",
  "MAHARANA PRATAP COLLEGE OF PROFESSIONAL STUDIES",
  "PYARE LAL MAHAVIDYALAYA, ARAUL",
  "SHREE RAM LAW COLLEGE, GHATAMPUR",
  "ANGAD SINGH DEELIP SINGH MAHILA MAHAVIDHYALAYA",
  "LAVKUSH INSTITUTE FOR HIGHER EDUCATION, CHAUWEPUR",
  "RAMKALI MOTILAL SMARAK MAHAVIDYALAYA",
  "K L S COLLEGE, RANIYA",
  "B.S.S. COLLEGE OF SCIENCE & ART KARMER ROAD,ORAI",
  "BABA DHAN SINGH RISALDAR MAHAVIDYALAYA, ANAND NAGAR, ANDA",
  "KRISHNA MAHAVIDYALAYA, THAKURDWARA ( MORADABAD )",
  "JEEWAN LAKSHYA DEGREE COLLEGE, HATHIPUR WAHAUDIN, BILARI (MORADABAD)",
  "MAHARAJA AGARSEN EDUCATION AND MANAGEMENT, AMROHA  ",
  "D.N.S. COLLEGE, AMROHA ",
  "ALI MOBIN SANATAK MAHAVIDYALAYA, KHETAPUR, JHAGEER, AMROHA ",
  "SARDAR BEGUM MEMORIAL DEGREE COLLEGE, SAMBHAL ROAD, HASANPUR (AMROHA)",
  "MAA VAISHNAV DEVI LAW COLLEGE, JUGGAUR,CHINHAT, FAIZABAD ROAD, LUCKNOW",
  "RAJDEO MAHAVIDYALAYA, SALEMPUR, BAGHAI, GHAZIPUR",
  "U. P. Institute of Design, Noida",
  "Svdharm Mahavidyalaya, Katya, Saray ,Gokul ,Ghazipur",
  "PRATAP BAHADUR SNATKOTTAR MAHAVIDYALAYA, PRATAPGARH CITY, PRATAPGARH",
  "Mahant Maniraj Das Upendra Girls Education Institute, Ghazipur",
  "CENTRAL MONTESSORI MAHILA DEGREE COLLEGE DHAUR MAU MATI BARABANKI",
  "Pt. Juggi Lal Arun Kumar Shiksha Sansthan, Vill.  Chaubeypur, Post Sevtari, Jaisinghpur",
  "MAA REETA MAHILA MAHAVIDYALAYA, RAMGARH, AMBEDKAR NAGAR",
  "SARYU DEVI MAHAVIDYALAYA, UDAIYADEEH, PRATAPGARH",
  "MADAN MOHAN MALVIYA P.G. COLLEGE, KALAKANKAR, PRATAPGARH",
  "Pt. Vidyadhar Mishra Saraswati Vidya Mandir Vigyan Evam Anusandhan Mahavidyalaya, Rampur Bawli",
  "RAJKIYA MAHAVIDYALAYA, MAGRAURA, PRATAPGARH",
  "RAJKIYA P.G. COLLEGE, SANGIPUR, PRATAPGARH",
  "MUNISHWAR DUTT SNATKOTTAR MAHAVIDYALAYA, PRATAPGARH",
  "SATYANARAYAN  GUPTA MADHURI  DEVI MAHAVIDYALAYA , BANKI , DEORIA",
  "MAHANTH RAMASHANKAR DAS MAHAVIDYALAYA , GORAKHPUR",
  "VIMAL MAHILA MAHAVIDYALAYA, GORAKHPUR",
  "Shyama Prasad Mukherji Govt. Degree College",
  "Sanwal Dass Sadan Lal Khanna Girls Degree College",
  "Fizza Mahila, Mahavidyalay, Pihuli, Tajpur, Dehma, Ghazipur",
  "Shri Basudev Dharmavati Shashikala Girl Degree College ",
  "PT. SUKHRAJ RAGHUNATHI INSTITUTE OF EDUCATION & TECHNOLOGY, RANJEETPUR, CHILBILA, PRATAPGARH",
  "RAJA TRILOCHAN PRASAD MAHAVIDYALAYA, KUNDA, PRATAPGARH",
  "Maa Parvati Kunwar Saikshanik Sansthan, Mahdaur, Ghazipur",
  "Pandit  Deen Dayal Upadhyay Rajkiya Mahavidyalaya, N.H.- 24 Tilhar, Shahjahanpur, Uttar Pradesh -242307",
  "S.N. DEGREE COLLEGE, CHHIWLAHA,",
  "MAHENDRA PRATAP SINGH LAW COLLEGE,ANDAWA,SARAI ENAYAT",
  "Sanjay Gandhi College of Education",
  "B S DEGREE COLLEGE ",
  "sukhram college of education",
  "RAM NARESH LAVKUSH MAHAVIDHALAYA ORILAL NAGAR BARIGHAT LALGANJ BASTI",
  "BHAGWAN SINGH INSTITUTE OF PHARMACY",
  "CHINTA DEVI BALIKA MAHAVIDYALAY",
  "DR PUSHPENDRA SINGH COLLEGE OF PHARMACY",
  "Shree Krishna College Of Pharmacy",
  "JANGALI YADAV VIDYALAY, SALEMPUR, NASEERPUR, GHAZIPUR",
  "CHANMATI EDUCATIONAL AND TEACHERS TRAINING INSTITUTE",
  "NEW SAINIK COLLEGE OF EDUCATION",
  "MCE",
  "Durga Prasad Smarak Vidhi Mahavidyalaya Unchdeeh soraon allahabad",
  "Dr. Ram Manohar Lohiya Mahila Mahavidyalaya, Jhotari, Dhamupur, Ghazipur",
  "I P S LAW COLLEGE ",
  "Satyam Law College",
  "JAMUNA RAM MEMORIAL SCHOOL",
  "Jai Prakash Mahila Mahavidyalaya, Nagra, Ballia",
  "PT. RAM NARAIN SHARMA MAHAVIDYALAYA, KARAUDHA, AMARGARH, PRATAPGARH",
  "TAHIRA INSTT OF MEDICAL SCIENCES",
  "R A S DEGREE COLLEGE",
  "Radha Krishna Balika Shikshan Sansthan, Kanauli, Holipur, Ghazipur",
  "BHAGWAT PRASAD SMARAK MAHAVIDYALAYA, GAUSPUR, UNCHAHAR, RAEBARELI",
  "B.N. DEGREE COLLEGE, SHAHABAD,",
  "B.N.A.S. MAHAVIDYALAYA, MAHARI,",
  "BHUPRAM DHARMESHWAR PRASAD MAHAVIDYALAYA",
  "BHAGWAN DEVI MAIKULAL MAHAVIDYALAYA, GAUTARA,",
  "CHAUDHARY BHUNDE MEMORIAL MAHAVIDALAYA",
  "BHAGWAN DEEN ARYA KANYA P G COLLEGE, MISHRANA, LAKHIMPUR KHERI",
  "BABU RAMESHWAR DAYAL LAW COLLEGE, SARAIYAN OEL, LAKHIMPUR",
  "BABU PT. SHIV BHUSHAN SHARMA MAHAVIDYALAYA RASHIGAO RAEBARELI",
  "SHRI PALAKDHARI BALIKA SHIKSHA EVAM PRASHIKSHAN SANSTHAN TURNA GHAZIPUR",
  "BABA CHANDRA SINGH MAHAVIDYALAYA",
  "AZEEM MEMORIAL NATIONAL DEGREE COLLEGE,BENIPUR,BISWAN",
  "AYODHYA SINGH MEMORIAL DEGREE COLLEGE",
  "ASHOK KUMAR MAHAVIDYALAYA, PARCHAL",
  "A.S. BATESWAR DAYAL MEMO. MAHAVIDYALAYA, MADHAOGANJ,",
  "ARYA KANYA MAHAVIDYALAYA,",
  "ANIL PUBLIC MAHAVIDYALAYA",
  "Acharya Narendra Dev T T College, Sitapur",
  "AMBEDKAR MAHILA DEGREE COLLEGE, AMAWAN",
  "ALI SHER MEMORIAL MAHAVIDHYALAYA, DALELNAGAR (SMODHA)",
  "Ajay Shanti Degree College",
  "AJAY PAL SINGH MAHAVIDHYALAYA,SANDI",
  "AIM",
  "ADHARSHILA LAW COLLEGE OF PROFESSIONAL COURSES",
  "ADHARSHILA COLLEGE OF PROFESSIONAL COURSES",
  "ADARSH JANTA MAHAVIDYALAYA, DEVKALI, LAKHIMPUR,",
  "ABDUL SATTAR KHAN MAHAVIDHYALAYA,KHERON",
  "K P UCCHA SHIKSHA SANSTHAN KATHULA JHALWA PRAYAGRAJ",
  "SVAANRI DEVI MAHAVIDYALAYA",
  "Kunwar Satyavira College of Engineering and Management, BIJNOR",
  "SHIVDAN PROF RAJARAM YADAV MAHAVIDYALAYA TARAHATI MACHALISHAHAR JAUNPUR",
  "DHARAMVEER DEGREE COLLEGE, BISHANPURA",
  "SANT SURAJ BABU MAHAVIDYALAYA, SITAPUR",
  "SANTOSH KUMAR MAHAVIDYALAYA, KASIMPUR, BEHDAR,",
  "SAINT BILAL CONVENT SCHOOL",
  "SACRED HEART DEGREE COLLEGE, NAIPALPUR,",
  "College of Nursing, Maharshi Vashishtha Autonomous State Medical College, Basti",
  "R.R. MAHAVIDYALAYA, PANTHEPURWA,",
  "ROYAL PRUDANCE DEGREE COLLEGE, SITAPUR ROAD, MUDIA KHEDA, LAKHIMPUR,",
  "ROYAL COLLEGE OF EDUCATION",
  "R.M.P. P.G. COLLEGE,",
  "R. K. Pandey Mahavidyalaya",
  "REGENCY TEACHERS TRAINING COLLEGE,",
  "RANA BENI MADHAV VEER VEERA PASI MAHAVIDYALYA",
  "RAMDAYAL PRASADILAL LODHI M/V DALELPUR BHARKHANI PALI HARDOI",
  "RAMBUX SINGH SMARAK MAHAVIDYALAYA",
  "RAMBETI DEV NARAIN BAJPAI MAHAVIDHYALAYA,BILGRAM",
  "RAM AUTAR KALYANI DEVI MAHVIDYALAYA BISWAN SITAPUR",
  "RAM AKBAL SHIVRANI MAHAVIDYALAYA, MAHMOODABAD",
  "RAJKEEYA MAHAVIDYALAYA KUCHLAI, SITAPUR",
  "Rajkiya Mahavidyalaya Toderpur Hardoi",
  "RAJKEEYA MAHAVIDYALAYA, PIHANI,",
  "RAJKEEYA MAHAVIDYALAYA, PALIYAN KALAN,",
  "RAJKALI DEVI MAHAVIDYALAYA, LAHENGA, SALON,",
  "RAJENDRA SINGH RAJESHWARI MAHAVIDYALAY, DHOLAI KALA",
  "RAJENDRA SINGH KAMLA DEVI, MAHAVIDHYALYA ,DEVGANPUR,MIRZAPUR, ALIYA",
  "RAJENDRA PRASAD MAHAVIDHYALAYA,KORIHAR,SATAON",
  "INDERPRASTHA DENTAL COLLEGE & HOSPITAL (GHAZIABAD)",
  "PANKAJ MAHESWARI SMRATI MAHAVIDYALAYA, CHAKTAHIRPUR,",
  "PREM PRAKASH SINGH KAMALA DEVI MAHAVIDHYALAYA, REUSA, SITAPUR",
  "PRAKASH MAHAVIDHYALAYA,BARAUNA",
  "Pracharya shree Vidhyadhar Namisharanya College",
  "PRABHAT RAJENDRA KUMAR POONAM DEVI MAHAVIDYALAYA",
  "P.B.R. KRASHI MAHAVIDYALAYA,TERWA,GAUSGANJ",
  "PATEL SRI TEEKARAM DEGREE COLLEGE, SAIBAGDAD,",
  "PANCHSHEEL MAHAVIDYALAYA, ETOURA BUJURG,",
  "OM SRI GURU KRIPA MAHAVIDYALAYA ",
  "NOORJAHAN DEGREE COLLEGE, GOPAMAU",
  "NIRMALA DEGREE COLLEGE",
  "New Standard College of higher education Maharajganj Raebareli",
  "NEW STANDARD COLLEGE OF HIGHER EDUCATION",
  "NEW ADIL MAHAVIDYALAYA,MALAIYA,SANDILA",
  "NAND KISHOR KAILASH CHANDRA MAHAVIDYALAYA TIKRA BISWAN SITAPUR UTTAR PRADESH 261201",
  "MULARAM SMARAK MAHAVIDYALAYA, BHIKHAMPUR, KUMBHI,",
  "KESHAV KAMALA MAHAVIDHYALYA MAHARIYA",
  "KEDAR NATH PATEL MAHAVIDHYALAYA",
  "KATIYARI DEGREE COLLEGE, HARPALPUR,",
  "MOULANA AZAD INST. OF HUMANI. SCI. & TECH., MAHAMOODABAD,",
  "MOHD  YUSUF MAHAVIDYALAYA, SANDILA",
  "MOHD. ALI NAZEER FATMA MAHAVIDYALAYA, GORIKHALSA,",
  "MOHAMMDI MAHAVIDHYALAYA MOHAMMDI",
  "MOHAMMADI LAW COLLEGE, MOHAMMADI, LAKHIMPUR KHERI",
  "MISHRI LAL MAHAVIDAYALAY PADARIYA TULA",
  "MASTER EDUCATIONAL DEGREE COLLEGE, SANSARPUR, GOLA, KHERI",
  "MASEE HUNNISA DEGREE COLLEGE, KHAJOHANA,",
  "MARIYAM BIBI INSTITUTE OF HIGHER EDUCATION, LAHURIYA KODRAS KHURD AMAWAN, RAEBARELI",
  "JAGANNATH PRASAD MAHAVIDHYALAY KUSAHIL BAZAR GOTANI KUNDA PRATAPGARH",
  "MANYAWAR KASHIRAM MAHAVIDYALAYA, DALMAU,",
  "K P Mahila Mahavidyalaya, Saidabad, Zamaniya, Ghazipur",
  "MANYAWAR KASHIRAM LAW COLLEGE, SAHABAD,",
  "RAM NARESH SINGH DEGREE COLLEGE",
  "SHRI RAMDAS MAHAVIDYALAYA, BARI, DHANAPUR, KERAKAT, JAUNPUR",
  "MANU LAW COLLEGE, LAKHIMPUR,",
  "MANOHAR LAL GEETA DEVI MAHAVIDYALAYA,RAHVI",
  "MANMIT NAGAR MAHAVIDYALAYA,JAGDEVPUR,PALIA KALA",
  "Jaymangal Mahavidyalay, Narayanpur, Kakarahi, Daulatpur, Saidpur, Ghazipur",
  "SRI SAI COLLEGE OF NURSING ALIGARH",
  "SHRI RAM MAHAVIDYALAYA JAILI JAIRAULI JASVANTPUR MAINPURI",
  "H.L.G DEGREE COLLEGE, MORATHAL, HARDUAGANJ, ALIGARH",
  "MAHARSHI VASISHTHA  AUTONOMOUS STATE MEDICAL COLLEGE BASTI ",
  "Jagarnath Mahavidyalay, Daulatpur, Barihari Saidpur, Ghazipur",
  "MAIKU LAL MAHAVIDYALAYA, SANPKHERA, BILGRAM,",
  "SAMRIDHI DEGREE COLLEGE KAIRDA ROAD CHHIBRAMAU KANNAUJ",
  "MAHMOODABAD LAW COLLEGE, MAHMOODABAD,",
  "Fekan yadav Mahavidyalaya, Kusumhi Khurd, Rasulpur, Ghazipur",
  "MAHMOODABAD COLLEGE OF MANAGEMENT & TECH., MAHMOODABAD,",
  "PANINI KANYA MAHAVIDYALAYA",
  "SHRI UMESHWAR PRATAP SINGH SMARAK KISAN MAHAVIDYALAY ",
  "SHRIMATI HARIPYARI DEVI EDUCATIONAL INSTITUTE RAJPUR CHUNGI AGRA ",
  "MAULANA ABUL KALAM AZAD MAHAVIDYALAYA VISHUNAGA JAMUNIYABAAG GONDA",
  "RAMLAL SINGH VIDHI MAHAVIDYALAYA",
  "KANHAIYA SINGH MAHILA MAHAVIDYALAYA BARANI HATHI BAZAR VARANASI",
  "DAYASHANKAR SINGH KUSHWAHA MAHAVIDALAYA",
  "UMEDA DEVI MAHAVIDYALAY CHAKNANDA KACHHAWA MIRZAPUR",
  "GS COLLEGE OF PHARMACY, HAPUR",
  "Gulabi Bhimal Mahila Mahavidyalaya, Manikpur, Manpur, Karanda, Ghazipur",
  "USHA SINGH VIDHI MAHAVIDYALAYA",
  "SHAKUNTALA DEGREE COLLEGE, NOORPUR RD, CHANDPUR",
  "KANCHAN DEGREE COLLEGE",
  "KAMLA NEHRU P.G. COLLEGE, TEJGAON,",
  "PARMESHWAR VIDHI MAHAVIDYALAYA",
  "PARAG MAHAVIDYALAYA, SEMRI RANAPUR",
  "RAM AUTAR BHAGIRATHI MAHAVIDYALAYA CHAUSAND BANDA",
  "GULAB MAHAVIDYALAYA, SANDI,",
  "SHRI RAMPRATAP DIXIT DEGREE COLLEGE SONRAHI TINDWARI BANDA",
  "ADARSH MAHAVIDYALAYA, MURAI BAGH, RAEBARELI",
  "Harishchandra Chaudhari Mahila Mahavidyalaya, Jangipur, Ghazipur",
  "Rajkishore Mahavidyalaya, Baruen , Jamaniya, Ghazipur",
  "K S COLLEGE OF HIGHER EDUCATION SHAMLI",
  "SW SHRI RAMPAL SINGH RAJKIYA MAHAVIDHALIYA USAWAN DATAGANJ BADAUN UP",
  "GS COLLEGE OF NURSING HAPUR",
  "MUZAFFARNAGAR MEDICAL COLLEGE OPP. BEFRAIPUR, INDUSTRIAL AREA, MEERUT ROAD, MUZAFFARNAGAR",
  "SHIV SHAKTI MAHAVIDYALAYA",
  "MAA RAMWATI MAHAVDHYALAYA      ",
  "GOVERNMENT DEGREE COLLEGE  GOVERDHAN MATHURA",
  "GOVERNMENT DEGREE COLLEGE VRINDAVAN, MATHURA",
  "SHRIMATI JALDHARA DEVI MAHAVIDYALAYA HASAYEN, HATHRAS",
  "M.R. DEGREE COLLEGE KASGANG MAIMREE SIKANDRA RAO ROAD,KASHI RAM NAGAR",
  "BABA NATTHU SINGH VIDHI MAHAVIDHYALAYA BAHURAJMAU RAITHANA UNNAO",
  "SHRI BIHARI LAL BHARTI MAHAVIDYALAYA, ALIGARH",
  "SMT. GOMTI SAMARAK VIGYAN MAHAVIDHALAYA NAWAB NAGAR PARSON,ETAH",
  "Ghurbhari Mahavidyalaya, Ruhipur, Jagdishpur, Chaukiya, Ghazipur",
  "KAVI POORANMAL DAS SHIKSHAN SANSTHAN, KUTUBPUR",
  "L M S DEGREE COLLEGE ISHRA SAKIT",
  "SAMRAT MIHIR BHOJ RAJKIYA MAHAVIDYALAYA, PABLA, BAGHPAT",
  "RAJKIYA MAHILA MAHAVIDYALAYA, SARDHANA, MEERUT",
  "RAJKIYA MAHAVIDYALAYA, GAHMAR, ZAMANIA, GHAZIPUR ",
  "RAJKIYA MAHAVIDYALAYA MODINAGAR GHAZIABAD",
  "SHRI KHUB CHANDRA MAHAVIDYALAYA",
  "SHIVMANGAL MAHAVIDYALAY, PARDAHA, JAMEEN PARDAHA, BELA SULTANPUR, MAU",
  "VIVEKANAND COLLEGE OF EDUCATION,ALIGARH",
  "KAUSAL KISHOR RAM BETI DEVI MAHAVIDHYALAY BARNA ETAH",
  "KU. SHAKUR KHAN DEGREE COLLEGE JALESAR ROAD SAKRA",
  "Manorma Institute of Education, Mukharana, Etah",
  "B C L G Educational Institute",
  "SRI GOPALJI MAHAVIDYALAYA,HIMMATPUR,ETAH",
  "Sunbeem Girls Degree College, Daulat Nagar (Sadat) Ghazipur",
  "INDU INSTITUTE OF NURSING SCIENCES",
  "DR R K S SHIKHAN SANSTHAN, KHIRIYA DHUMARI, ETAH",
  "SHRI GUMANI SINGH MAHAVIDYALAYA DABAR AUGSOLI SIKANDRA ROAD, MAHAMAYA NAGAR",
  "Shri keshav Brahm Mahila Mahavidyalay, Garh Chaubey, Terahi, Kaptanganj, Azamgarh",
  "S. N. COLLEGE OF HIGHER EDUCATION, BAZIDPUR, SIDHPURA, KASGANJ",
  "Maa Vaishno Devi Mahavidhyalaya, Vijaygarh",
  "D N LAW COLLEGE",
  "DR MAHENDRA KUMAR CHHOTE LAL BIND COLLEGE OF LAW UPARDAHA HANDIA PRAYAGRAJ",
  "INDIRAPURAM INSTITUTE OF HIGHER STUDIES INDIRAPURAM GHAZIABAD",
  "RIYA INTERNATIONAL COLLEGE ",
  "CH. HARPRASAD SINGH YADAV EDUCATION INSTITUTE, JUNERDPUR, ALIGANJ, ETAH",
  "SMT NIRMALA DEVI MULAYAM SINGH MAHAVIDHYALAY DEVKARANPUR JALESAR ETAH",
  "GANJDUNDWARA COLLEGE,GANJDUNDWARA, KASGANJ",
  "ALIGARH COLLEGE OF EDUCATION ANOOP SHAHAR ROAD, CHEEROT ALIGARH",
  "DHARAMVIR SINGH MAHAVIDYALAYA",
  "S.P.S. Degree College",
  "R.P.M. DEGREE COLLEGE, HATHRAS",
  "V.K.JAIN COLLEGE OF EDUCATION SORON RD. KASHI RAM NAGAR",
  "DEV SHREE HOSPITAL AND NURSING COLLEGE",
  "D R GROUP OF EDUCATION",
  "RAJRANI MAHAVIDYALAYA, VAHORANPUR, KANSHIRAMNAGAR",
  "DAN SAHAI MEMORIAL COLLEGE,RAMPUR, KASGANJ",
  "M.H.H. Degree College Awagarh, Kila Etah",
  "shakuntalam college for teacher education",
  "ALIGARH TEACHERS TRAINING COLLEGE, ALIGARH",
  "SWARGIYA RAMVILASH SINGH SHIKSHAN SANSTHA MAHAVIDYALAYA, TIYARI, BEN TIYARI, CHAKIA, CHANDAULI",
  "GAJRAJ SINGH MEMORIAL DEGREE COLLEGE,ISHARA,ETAH",
  "DHARM JYOTI MAHAVIDYALAYA,TAHARPUR,IGLAS,ALIGARH",
  "CH. RAM PRAKASH YADAV MAHAVIDHALAYA, TULSINAGAR, KASGANJ",
  "BOHARE MOHAN LAL MEMORIAL MAHAVIDYALAYA",
  "PURNODAY LAW COLLEGE, BACHCHHAW, VARANASI",
  "B. S. Bhoop Degree College, Lavkush Nagar",
  "MAHAVEER SHIKSHAN SANSTHAN MADHUPURA KASGANJ",
  "TARACHANDRA MAHAVIDHYALAY BAISKHEDIYA SAKIT",
  "Mehant Jagannath Das Mahavidhlya, Bijnakhedi, Bandukhedi, Sarsawa, Saharanpur",
  "RATANPAL SINGH SHYAM LATA MAHAVIDHYALAYA SHIVSAHAY NAGAR NAGLA SIMRA ALIGANJ ETAH",
  "S. R. S. EDUCATION INSTITUTE SHIKOHABAD ROAD NIDHAULI KHURD",
  "MASTER PRATAP SINGH VERMA DEGREE COLLEGE,SADABAD, HATHRAS",
  "SHRI FAIAZ HUSSAIN (P.G) COLLEGE,NIDHAULI KALAN,ETAH",
  "SMT.BHUDEVI KHUSHALI RAM MAHAVIDYALAYA,HASAYAN,MAHAMAYA NAGAR",
  "Onkar Nath Tripathi Law College, Launh Kudahu, Mugrabadshahpur, Jaunpur",
  "JANTA KANYA MAHAVIDYALAYA, AWAGARH, ETAH",
  "SARASWATI DEGREE COLLEGE,MAHAMAYA NAGAR (HATHRAS)",
  "AMRITA SINGH MEMORIAL DEGRE COLLEGE,TEJPUR,JAVA,ALIGARH",
  "SUBHASH CHANDRA MAHAVIDHYALAY HARDOI ALIGARH",
  "Veerkhand Mahavidhyalaya, Nagla Jhanda",
  "SOVARAN SINGH EDUCATION INSTITUTE BY PASS ROAD HIMMATPUR GAHRANA ETAH",
  "KARMA YOGI DEGREE COLLEGE, MALIHAMAU,",
  "Maa Ganga College of Education Purdil Nagar Hathras",
  "SHRI FATEH SINGH MAHAVIDHYALAYA",
  "ISLAMIA DEGREE COLLEGE, SAHARANPUR",
  "MAA JANAKI INSTITUTE OF MANAGMENT AND TECHNOLOGY KUTHILA ETAH",
  "JEEVAN GOPI INSTITUTE OF PHARMACY AND TECHNOLOGY",
  "KHAIR KANYA MAHAVIDYALAYA KHAIR ALIGARH",
  " CHAUDHARY JHAMMAN SINGH MAHAVIDHYALAY",
  "G S COLLEGE KURSANDA HATHRAS",
  "MAA GAYTRI ARYA KANYA MAHAVIDYALAYA,JALESAR ETAH",
  "RAJKIY MAHAVIDYALAY CANTT AGRA",
  "PRACHI TEACHERS TRAINING COLLEGE FATTEPUR DAKSHIN SEN PASCHIM PARA NAUBASTA  KANPUR",
  "SHRI MAHARAJA AGRASEN KANYA MAHAVIDHAYALAY",
  "SHRI HARPRASAD MAN SINGH THENUA DEG. COLLEGE, ROOHRI, HATHRAS",
  "RAJKIYA MAHAVIDHYALAYA, RAMSARI, GHATAMPUR, KANPUR    ",
  "RA INSTITUTE OF PHARMACY",
  "DEEN BANDHU DEENA NATH MAHAVIDYALAYA SHIV NAGAR ALIGANJ ROAD,ETAH",
  "DR UDAY PRATAP CHATURVEDI COLLEGE OF EDUCATION NAINAJHALA  VISHWANATHPUR KHALILABAD SANT KABIRNAGAR",
  "Smt Chandrawati Devi Mahila Degree College, Tameshwarnath Dham, Sant Kabir Nagar",
  "SHRI BRAJ RAJ SINGH MAHAVIDYALAYA YASODA NAGAR PURAO ETAH",
  "CHANDRA PRABHA MAHAVIDYALAYA SARAI NEEM JALESOR, ETAH",
  "YASHODA DEVI MAHAVIDHYALAYA, MURSAN, HATHRAS",
  "INST.OF INFORMATION & MANAGEMENT TECHNOLOGY RAM GHAT ROAD,ALIGARH",
  "S.K COLLEGE ETAH",
  "SRI FARUQ HUSSAIN (P.G) COLLEGE,NIDHAULI KALAN,ETAH",
  "OMPAL MUNSHI SINGH MAHAVIDHYALAYA,KAKA-BEGPUR GULARIYA",
  "I.T.M. COLLEGE OF EDUCATION",
  "PT DEEN DAYAL UPADHYAY RAJKIYE MAHILA MAHAVIDYALYA FARAH MATHURA",
  "SARDAR PATEL INSTITUTE OF TECHNOLOGY SHIKARPUR, BULANDSHAHR",
  "P.R. RAJPUT DEGREE COLLEGE SARAY AGAHAT ETAH",
  "Al- Barkaat College of Graduate Studies ",
  "K.C EDUCATIONAL INSTITUTE ,SAHPAU,JALESAR ROAD,MAHAMAYA NAGAR",
  "R B S Collage, Gangiri, Aligarh ",
  "DR.Z.H DEGREE COLLEGE,ETAH",
  "SIYARAM SINGH DIGREE COLLEGE,AVAGARH, ETHA",
  "MAA KAILASHI SAVITRI DEVI VIDHI MAHAVIDYALAYA BEERAPUR, RANIGANJ, PRATAPGARH, UP",
  "D D S MAHAVIDYALAYA BHARATPUR BAJHERA KHAIR ALIGARH",
  "INDRA NARAYAN SHUKLA VIDHI MAHAVIDYALAYA,KATRA DAYARAM,MAUAIMA,SORAON,PRAYAGRAJ,UTTAR PRADESH",
  "MAA KAILASHWATI MAHAVIDYALAYA, NAGLA KHIMAI, KADARGANJ, KASGANJ",
  "MAHARANA PRATAP GOVT. DEGREE COLLEGE SIKNADRA RAO ,MAHAMAYA NAGAR",
  "GAGAN COLLEGE OF MANGEMENT & TECH,ALIGARH",
  "ALIGARH COLLEGE OF ENGINEERING AND TECHNOLOGY, ALIGARH",
  "CH HARINANDAN SINGH INSTITUTE OF EDUCATION AGRA ROAD ETAH",
  "KANPUR INSTITUTE OF TECHNOLOGY , KANPUR",
  "SMT TARA DEVI MAHAVIDYALAYA, MIYASUR, PATIYALI",
  "CHAUDHARY SAHAB SINGH BOHRE MAHAVIDHYALAY GOMAT CHAURAHA  KHAIR ALIGARH",
  "SRI BHUMRAJ SINGH LILA DEVI P.G. COLLEGE LADAMPUR KATARA",
  "THE BHAWANIPUR EDUCATION SOCIETY COLLEGE",
  "MINERVA ACADEMY B.ED COLLEGE",
  "National Institute of Locomotor Disabilities",
  "Institute of Engineering & Management ",
  "RAIGANJ GOVERNMENT MEDICAL COLLEGE AND HOSPITAL",
  "Sree Chaitanya Mahavidyalaya",
  "Jamini Mazumder Memorial College",
  "Uttar Banga Womens' B. Ed. College",
  "MINERVA SCHOOL AND COLLEGE  OF NURSING ",
  "Govt. College of Engineering and Ceramic Technology 113",
  "Durgapur Institute of Science, Technology and Management 229",
  "Durgapur Institute of Advanced Technology and Management 155",
  "Dumkal Institute of Engg. and Technology 331",
  "Calcutta Institute of Engineering and Management 165",
  "Bengal College of Engg. and Technology 324",
  "Bengal College of Pharmaceutical Sciences and Research 242",
  "BCDA College of Pharmacy and Technology 201",
  "Sarsuna College",
  "MALDA PARAMEDICAL COLLEGE",
  "Behala College",
  "GOVT COLLEGE OF NURSING SERAMPORE WALSH SD SS HOSPITAL",
  "Rabindra Nazrul Smriti B.Ed. Educational Institute",
  "NALHATI INSTITUTE OF NURSING",
  "ELITE INSTITUTE OF NURSING SCIENCES",
  "GAZOLE COLLEGE OF EDUCATION",
  "USHA RANI COLLEGE OF EDUCATION",
  "Diamond Harbour Government Medical College and Hospital",
  "Uttaran College of Education",
  "SARAT CHANDRA CHATTOPADHYAY GOVERNMENT MEDICAL COLLEGE AND HOSPITAL,ULUBERIA,HOWRAH",
  "BENOY CHOWDHURY MEMORIAL AND HEALTH RESEARCH INSTITUTE",
  "TECHNO INDIA COLLEGE AND SCHOOL OF NURSING KANKINARA",
  "SKYLARK INSTITUTE OF NURSING",
  "RANGAMATI SHIKSHAN ASHRAM",
  "Raja Narendralal Khan Women's College",
  "TEHATTA INSTITUTE OF EDUCATION",
  "BKM COLLEGE OF  EDUCATION",
  "M HOSSAIN TEACHERS TRAINING INSTITUTE",
  "Shri Ramkrishna Institute of Medical Sciences and Sanaka Hospitals",
  "BASUMATI INSTITUTE OF NURSING",
  "Deben Mahato Teachers' Training College",
  "IIFT KOLKATA",
  "Santaldih College",
  "Ramananda Centenary College",
  "Raghunathpur College",
  "Panchokot Mahavidyalaya",
  "Nistarini College",
  "Netaji Nagar College",
  "Netaji Subhas Ashram Mahavidyalaya",
  "HALADHAR MAHATO TEACHERS TRAINING INSTITUTE",
  "Manbhum Mahavidyalaya",
  "Institute of Advance Education and Research 288",
  "KABIGURU INSTITUTE OF EDUCATION",
  "Udyog College of Education",
  "Moulana Abdul Kalam Ajad Teacherâs Training Institute, Bhedia",
  "Berhampore Science and Management College",
  "AURANGABAD B.ED. TRAINING COLLEGE",
  "KINGSTON TECAHERS TRAINING COLLEGE",
  "Bengal Institute of Business Studies",
  "GOVT  COLLEGE OF NURSING      SURI SADAR HOSPITAL     SURI",
  "GOVERNMENT GENERAL DEGREE COLLEGE LALGARH",
  "GURU NANAK INSTITUTE OF DENTAL SCIENCES & RESEARCH",
  "Future Institute of Engineering and Management 148",
  "Indas Mahavidyalaya",
  "Jamini Roy College",
  "Khatra Adibasi Mahavidyalaya",
  "National School of Management Studies  Durgapur Chapter 197",
  "Onda Thana Mahavidyalaya",
  "Pandit Raghunath Murmu Smriti Mahavidyalaya",
  "Patrasayer Mahavidyalaya",
  "Raipur Block Mahavidyalaya",
  "Ramananda College",
  "Saldiha College",
  "Sonamukhi College",
  "GITANJALI BEd COLLEGE",
  "GOKHURAPOTA B. ED. COLLEGE",
  "HADECHHA LACHHIMUDDIN BEd COLLEGE",
  "HERITAGE COLLEGE OF EDUCATION",
  "Hope Institute of Bengal (B.Ed. Section)",
  "IMPERIAL INSTITUTE OF EDUCATION & TRAINING (B.ED)",
  "INDIRA GANDHI MEMORIAL B.ED COLLEGE",
  "INDIRA GANDHI TEACHERS TRAINING INSTITUTE",
  "Institute of Education for Women",
  "NAKSHATRA INSTITUTE OF NURSING",
  "Jaiaganj Institute of Education & Training",
  "JYOTIRMOY SCHOOL OF EDUCATION",
  "EAST MALDA B ED COLLEGE",
  "KABI KRITTIBAS B.ED. COLLEGE",
  "Kamala Devi Sohanraj Singhvi Jain College of Education",
  "Kaviguru Nobel Centenary Training College",
  "Krishnagar B.Ed. College",
  "LIEUTENANT ABHISHEK RAYCHAUDHURI T.T.COLLEGE",
  "Maharaja Manindra Chandra B.Ed. College",
  "MATIARI B ED COLLEGE",
  "MOULANA ABUL KALAM AZAD COLLEGE OF EDUCATION",
  "THAKUR ANUKUL CHANDRA SATSANG MISSION SADHANPITH",
  "Murshidabad Minority B.Ed. College",
  "NETAJI BEd TRAINING COLLEGE",
  "Netaji Subash College of Education",
  "NIBEDITA TEACHERS TRAINING COLLEGE",
  "Pailan College of Education",
  "Plassey Teacher Training Institute",
  "Raidighi B.Ed. College",
  "RAMKRISHNA MANDAL INSTITUTE OF EDUCATION",
  "Renuka Debi B.Ed. College",
  "ANGEL TEACHERS TRAINING ACDEMY",
  "ROSOMOYEE VIVEKANANDA TOPOBAN PATHAGAR B.ED COLLEGE",
  "SABUJ B.ED. COLLEGE",
  "Sammilani Teachers' Training college",
  "Sishu Bikash College of Education",
  "Sree Sree Ramakrishna B.Ed. College",
  "Sunderban Ashutosh B.Ed College for Women",
  "SUNITI EDUCATIONAL TRUST",
  "Vivekananda R. K. Mission B.Ed. College",
  "Surendra Lal Das Teachers Training College",
  "KRISHNAPUR TEACHERS TAINING INSTITUTE",
  "KABI NAZRUL ISLAM TEACHERS TRAINING COLLEGE",
  "Chhatna Chandidas Mahavidyalaya",
  "Siddhartha College of Education",
  "Universal College of Education",
  "Institute of Engineering and Management 366",
  "FOOTWEAR DESIGN AND DEVELOPMENT INSTITUTE",
  "SUKLA DEVI ACADEMY FOR B ED",
  "MAHAMAYA SHIKSHA PARISHAD",
  "TATA MEDICAL CENTRE",
  "BHAGWANGOLA NURSING INSTITUTE",
  "ADARSHABANI TEACHER TRAINING COLLEGE",
  "SILIGURI TERAI B.ED COLLEGE",
  "MEDISKY NURSING INSTITUTE",
  "Manbhum Institute of Education & Social Science",
  "Prafulla Chandra College",
  "CIFE Kolkata",
  "Ramkrishna Mahato Memorial Teachers Training College",
  "Haldia Institute of Health Sciences",
  "SISTER NIVEDITA D ED TRAINING INSTITUTE",
  "GOURANGDI B Ed COLLEGE",
  "GOVT COLLEGE OF NURSING ULUBERIA S D HOSPITAL",
  "Rabin Mukherjee College",
  "KALIPADA GHOSH TARAI MAHAVIDYALAYA, DARJEELING",
  "QUEENSLAND ACADEMY OF NURSING",
  "OLIVE. ACADEMY",
  "NETAJI SUBHAS MAHAVIDYALAYA, COOCHBEHAR",
  "ZENITH INSTITUTE OF NURSING SCIENCES",
  "DURGAPUR WOMENS COLLEGE RAIGANJ",
  "Ashok Nilay Nivedita College of Education",
  "Vivekananda Mission Ashram",
  "GITANJALI COLLEGE OF EDUCATION",
  "Vidyasagar College of Optometry and Vision Science 139",
  "HILFUL FUZULCOLLEGE OF EDUCATION AND RESEARCH (HIGHER)",
  "GHATAL COLLEGE OF EDUCATION",
  "EASTERN DOOARS B.Ed. TRAINING COLLEGE",
  "UTTARAYAN COLLEGE OF EDUCATION",
  "SOFIA MEMORIAL B.ED COLLEGE",
  "KUMARGANJ COLLEGE",
  "BANARHAT KARTICK ORAON HINDI GOVERNMENT COLLEGE",
  "VIHARILAL COLLEGE OF EDUCATION",
  "Chaitanya College of Education",
  "SIBANI MANDAL MAHAVIDYALAYA",
  "Sponsored Teachers' Training college",
  "Haldia Institute of Health Sciences",
  "Institute of Post Graduate Ayurvedic Education & Research",
  "GOVERNMENT GENERAL DEGREE COLLEGE, KALIGANJ ",
  "School of Tropical Medicine",
  "Nopany Institute of healthcare Studies",
  "Burdwan Homoeopathic Medical College & Hospital",
  "GLOBAL HIRAMONI MEMORIAL NURSING INSTITUTION",
  "Eminent College of Management and Technology 348",
  "DISHARI INSTITUTE OF NURSING SCIENCE",
  "GOVTCOLLEGE OF NURSING  COLLEGE OF MEDICINE SAGORE DUTTA HOSPITAL",
  "MAYNAGURI COLLEGE, JALPAIGURI",
  "SRI SITARAM VAIDIC ADARSHA SANSKRIT MAHAVIDYALAYA",
  "EAST WEST INSTITUTE OF MEDICAL SCIENCES AND RESEASRCH",
  "Ramakrishna Sarada Mission Vivekananda Vidyabhavan",
  "BIJANBARI DEGREE COLLEGE",
  "GOVERNMENT COLLEGE OF NURSING KHARAGPUR S D HOSPITAL",
  "SANTINIKETAN GOVERNMENT COLLEGE OF NURSING",
  "Vibekananda Teacher Training College",
  "College of Nursing, ID & BG Hospital",
  "MRCC College of Physiotherapy",
  "SHISHURAM DAS COLLEGE",
  "BISHNUPADA SARKAR COLLEGE OF EDUCATION",
  "Mankar College",
  "Ramkrishna Mission Seva Pratisthan and Vivekananda Institute of Medical Sciences",
  "Agnibina School of Education",
  "DESUN NURSING SCHOOL AND DESUN COLLEGE OF NURSING",
  "Siliguri Institute of Technology 334",
  "Balipukur Teachers Training College",
  "Sreegopal Banerjee College",
  "Govt. College of Engineering and Textile Technology, Berhampur 111",
  "Maulana Abul Kalam Azad Teachers Training College",
  "NORTH BENGAL TEACHERS TRAINING COLLEGE",
  "Siliguri Institute of Technology 119",
  "PURNADISHA JOYCHANDI TEACHER TRAINING COLLEGE",
  "Katwa College",
  "Ehiapur B. Ed. College",
  "Contai College of Learning and Management Science 340",
  "SANTINIKETAN NURSING INSTITUTE",
  "DASHARATHI HAJRA MEMORIAL COLLEGE, BURDWAN",
  "MANIKCHAK COLLEGE OF EDUCATION DED",
  "AMRITY COLLEGE OF EDUCATION",
  "Sovarani Nursing College",
  "Ali Yabar Jung National Institute of Hearing Handicapped",
  "Panchmura Mahavidyalaya",
  "RAMPURHAT TEACHERS TRAINING COLLEGE",
  "ABS Academy",
  "VIVEKANANDA COLLEGE OF EDUCATION",
  "Cooch Behar Government Engineering College 349",
  "Swami Vivekananda Institute of Modern Studies 351",
  "VIDYASAGAR TEACHERS' TRAINING COLLEGE",
  "VIDYASAGAR TEACHERS TRAINING INSTITUTE",
  "SARADAMOYEE COLLEGE OF EDUCATION",
  "M R College of Pharmaceutical Sciences and Research 363",
  "Rajib Gandhi Memorial Ayurvedic Medical College & Hospital",
  "Institute of Child Health",
  "Birbhum Vivekananda Homoeopathic Medical College & Hospital",
  "Maa Sarada College of Nursing",
  "Kushmandi Government College",
  "College of Nursing, R G Kar Medical College",
  "Govt. College of Nursing, Burdwan Medical College",
  "PARAMA B.ED. COLLEGE, BURDWAN",
  "Haldia Institute of Dental Sciencess and Research",
  "North Bengal Dental College",
  "TEHATTA SADANANDA MAHAVIDYALAYA",
  "Mahatma Gandhi College",
  "IQ City Institute of Nursing Sciences",
  "Subhas Chandra Basu B.Ed. Traning College",
  "SHILBHADRA TEACHERS TRAINING INSTITUTE",
  "DEBEN MAHATA GOVERNMENT MEDICAL COLLEGE AND HOSPITAL",
  "Central Sericultural Research & Training Institute",
  "PURBANCHAL B.ED COLLEGE",
  "SIDRA BEd COLLEGE",
  "SANJOY COLLEGE OF EDUCATION",
  "Kotshila Mahavidyalaya",
  "SAMYA SAMAJ TEACHERS TRAINING COLLEGE",
  "RISHI AUROBINDO INSTITUTE OF TEACHER EDUCATION",
  "Garhbeta College",
  "RASHBEHARI COLLEGE OF EDUCATION",
  "Ranibala College of Teacher Education",
  "College of Nursing, Command Hospital",
  "KAIKALA SANSKRIT VIDYAPEETH (KAIKALA ADARSHA SANSKRIT MAHAVIDYALAYA)",
  "RAMNAGAR B.ED. COLLEGE",
  "BIRHAMBIR TEACHERS TRAINING INSTITUTE",
  "SUNCITY INSTITUTE OF NURSING",
  "Jibantala Rokeya Mahavidyalaya",
  "ABS ACADEMY OF NURSING AND HEALTH SCIENCES",
  "KALNA NURSING INSTITUTE",
  "PURNA CHANDRA COLLEGE OF EDUCATION",
  "SUSMITA COLLEGE OF EDUCATION",
  "Burdwan Medical College",
  "Kashipur Michael Madhusudan Mahavidyalaya",
  "SUDHIR  KARMAKAR  COLLEGE  OF  EDUCATION",
  "PURBA MEDINIPUR G.K. COLLEGE OF EDUCATION",
  "GOURI DEVI INSTITUTE OF MEDICAL SCIENCES AND HOSPITAL",
  "Global Group of Institutions 337",
  "SBIHM School of Management 341",
  "BELARANI INSTITUTE OF MEDICAL SCIENCE",
  "J.K.College",
  "Sister Florence College of Nursing",
  "Pratap Chandra Memorial Homoeopathic Medical College & Hospital",
  "Chitta Mahato Memorial College",
  "Purba Medinipur B.Ed. College",
  "ST MARYS COLLEGE BACHELOR OF EDUCATION AND HIGHER STUDIES",
  "Burdwan Institute of Medical and Life Sciences",
  "PRATAP CHANDRA COLLEGE OF EDUCATION",
  "Midnapore Institute of Education",
  "PAGLANANDA SANSKRIT MAHAVIDYALAYA",
  "University Institute of Technology",
  "Vidyasagar Foundation School of Education & Training",
  "W B Govt College of Nursing, SSKM Hospital Campus",
  "Calcutta Girls B.T College",
  "UTTARAYAN COLLEGE OF LAW",
  "AYAN ARNAB SIKSHAN SANSTHA",
  "KHARAGPUR VISION ACADEMY ",
  "KHARAGPUR TRIBAL B.ED TRANING COLLEGE",
  "Kamarsha Teachers Training College",
  "Kabi Sukanta Secondary Teachers' Traning Institute",
  "Institute of Genetic Medicine & Genomic Science",
  "Institute of Education",
  "Institute of Post Graduate Medical Education & Research",
  "E S I, Joka",
  "College of Nursing, Calcutta National Medical College",
  "N R S Medical College",
  "SILIGURI INSTITUTE OF NURSING",
  "INSTITUTE FOR TEACHER EDUCATION",
  "SRI RAMKRISHNA SARADA COLLEGE OF EDUCATION",
  "IDAN TEACHERS TRAINING COLLEGE",
  "EXCELLENT MODEL COLLEGE FOR TEACHER EDUCATION",
  "CHARNOCK HEALTHCARE INSTITUTE",
  "Medical College",
  "Charnock Hospital",
  "Subarnarekha Mahavidyalaya",
  "Sivanath Sastri  College",
  "Edugate Teachers Training Institute",
  "College of Nursing, Midnapore Medical College",
  "DHAMAIT SIKSHAK SHIKSHAN MAHAVIDYALAYA",
  "NILACHAL INSTITUTE OF NURSING AND HEALTH SCIENCES",
  "Deshpran College of Teacher Education",
  "Bogchari Primary Teachers Training Institute",
  "MANIKCHAK COLLEGE",
  "Susil Kar College",
  "Ramakrishna Mission Sikshanamandira",
  "BISHNUPADA PRIMARY TEACHERS TRAINING COLLEGE",
  "Sir Gurudas Mahavidyalaya",
  "Ramakrishna Mission Residential College",
  "BIT Extension Center, Kolkata",
  "Maheshtala College",
  "Sonarpur Mahavidyalaya",
  "City College",
  "Netaji Nagar College For Women",
  "Birendranath Sasmal Primary Teachers Training Institute",
  "Supreme Institute of Management and Technology 364",
  "Maulana Azad College",
  "Bengal College of Teacher Education",
  "INDIAN INSTITUTE OF EDUCATION",
  "BANKIM BEHARI TEACHERS TRAINING INSTITUTE",
  "Magrahat College",
  "Bangashree Teachers Training Institute",
  "G. D. College",
  "Shyamaprasad College",
  "St. Paul's Cathedral Mission College",
  "Asutosh College",
  "Harimohan Ghosh College",
  "Acharya Girish Chandra Bose College",
  "Chittaranjan College",
  "iLEAD Institute of Leadership Entrepreneurship and Development 289",
  "K. K. Das College",
  "Bagnan College",
  "Suri Vidyasagar College",
  "Chandidas Mahavidyalaya",
  "Burdwan Raj College",
  "MADHUSUDAN HORE MAHAVIDYALAYA, COOCHBEHAR",
  "Elias Chowdhury Academy",
  "Surendranath College",
  "Cyber Research & Training Institute",
  "Vivekananda B.Ed. And D.El.Ed. College",
  "Vijaygarh Jyotish Roy College",
  "ANINDITA COLLEGE FOR TEACHER EDUCATION",
  "Gushkara Mahavidyalaya",
  "NSHM Knowledge Campus Durgapur Group of Institutions 273",
  "Birbhum Mahavidyalaya",
  "Sailajananda Falguni Smriti Mahavidyalaya",
  "Jamalpur Mahavidyalaya",
  "Rampurhat College",
  "Hooghly Womens College",
  "Arambag Girls College",
  "Kandra Radha Kanta Kundu Mahavidyalaya",
  "Kabikankan Mukundaram Mahavidyalaya",
  "Aghore Kamini Prakash Chandra Mahavidyalaya",
  "Government Physical Education College for Women",
  "Kalna College",
  "Bankura Unnayani Institute of Engineering 105",
  "Academy of Technology 169",
  "Khalisani Mahavidyalaya",
  "Burdwan Institute of Management & Computer Science",
  "Tamralipta Institute of Management and Technology 212",
  "Bankura Zilla Saradamani Mahila Mahavidyapith",
  "SUNDARBAN MINORITY B. ED COLLEGE",
  "Bengal College of Engineering 260",
  "Saroj Mohan Institute of Technology 320",
  "AGRAGATI INSTITUTE OF HEALTH SCIENCES NURSING EDUCATION UNIT",
  "MOTHER RIJIYA INSTITUTE OF NURSING ",
  "Hooghly Mohsin College",
  "A M E X",
  "Hazi Rustam Mallick Memorial College of Education",
  "Barjora College",
  "BHIMPUR B.ED. COLLEGE",
  "Government College of Education",
  "Purbasthali College",
  "Kabi Joydeb Mahavidyalaya",
  "College of Art & Design",
  "Abhedananda Mahavidyalaya",
  "Kabi Sukanta Mahavidyalaya",
  "Eastern Institute for Integrated Learning in Management 183",
  "SHREE RAMAKRISHNA VIVEKANANDA MISSION COLLEGE OF JURIDICAL STUDIES",
  "JIAGANJ SCHOOL AND COLLEGE OF NURSING",
  "TECHNO INDIA TEACHERS TRAINING INSTITUTE, TAPSHIKHATA ALIPURDUAR ",
  "Netaji Subhash Engineering College 109",
  "Kotibarsha Institute of Technology and Management 202",
  "Sanaka Educational Trusts Group of Institutions 278",
  "Institute of Management Study 194",
  "Union Christian Training College",
  "Shahid Matangini Hazra Government General Degree College for Women",
  "Shimurali Sachinandan College of Education",
  "Jalangi B.Ed. College",
  "Jakir Hossain B.Ed. College",
  "Jagadish chandra Basu Sikshak sikshan Mahavidyalaya",
  "GOVERNMENT GENERAL DEGREE COLLEGE, RANIBANDH",
  "Nur Mohammad Smriti  Mahavidyalaya",
  "Bankura Christian College",
  "Bankura Sammilani College",
  "SEACOM B.ED. COLLEGE",
  "Rajnagar Mahavidyalaya",
  "Shyamaprasad Institute of Education & Training",
  "NAKSHALBARI COLLEGE, DARJILING",
  "Kabi Nazrul College",
  "IQ CITY UNITED WORLD SCHOOL OF BUSINESS",
  "HERAMBA CHANDRA COLLEGE",
  "ASHOK NILAY PRABHABASU PARAMEDICAL COLLEGE",
  "INDIAN MARITIME UNIVERSITY, KOLKATA",
  "IMPS College of Engineering and Technology 170",
  "Durgapur Government College",
  "DR SHAHIDULLAH INSTITUTE OF EUCATION",
  "ROYAL COLLEGE OF NURSING",
  "CARE AND CURE INSTITUTE OF NURSING AND RESEARCH",
  "DISHA NURSING INSTITUTE",
  "Ideal Institute of Engineering 279",
  "Gurunanak Institute of Technology 143",
  "HIMALAYAN NURSING COLLEGE AND HIMALAYAN NURSING SCHOOL",
  "JAGANNATH GUPTA INSTITUTE OF PHARMACY",
  "Panchla Mahavidyalaya",
  "Women's College Calcutta",
  "Gangadharpur Mahavidyamandir",
  "Swami Niswambalananda Girls' College",
  "Fakir Chand College",
  "Panchur College",
  "Sree Agrasain College",
  "Vivekananda College for Women",
  "Post Graduate Institute of Hospital Administration 211",
  "SITARAM MAHATO MEMORIAL COLLEGE",
  "GHOOM  JOREBUNGLOW DEGREE COLLEGE, DARJEELING",
  "KALIMPONG COLLEGE, DARJEELING",
  "Dr. B.R. Ambedkar Satabarshiki Mahavidyalaya",
  "Seth Anandram Jaipuria College",
  "PRIYAMVADA BIRLA INSTITUTE OF NURSING",
  "NORTH BENGAL ST  XAVIERS  COLLEGE, JALPAIGURI",
  "SARAT CHANDRA TEACHER TRAINING INSTITUTE",
  "Kalinagar Mahavidyalaya",
  "INTERNATIONAL INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH",
  "SUSRIJO INSTITUTE OF AGRICULTURAL SCIENCE TECHNOLOGY AND MANAGEMENT",
  "Institute of Science and Technology - Management",
  "Dr. Bhupendra Nath Dutta Smriti Mahavidyalaya",
  "DISHARI INSTITUTE OF PARAMEDICAL AND ALLIED HEALTH SCIENCE",
  "Mrinalini Datta Mahavidyapith",
  "JAGATBANDHU TEACHERS TRAINING INSTITUTE ",
  "PANCHKOT INSTITUTE OF NURSING ",
  "SWAMI VIVEKANANDA COLLEGE OF EDUCATION",
  "CHUYAPARA SHREE RAMAKRISHNA TEACHERS TRAINING COLLEGE AND RESEARCH (B ED)",
  "Matiaburj College",
  "TUFANGANJ COLLEGE OF EDUCATION",
  "Egra Sarada Shashi Bhusan College",
  "Paramedical College, Durgapur 161",
  "Pailan College of Management and Technology 297",
  "NAVJEEVAN COLLEGE OF NURSING",
  "North Malda Teachears' Education College",
  "PAKUAHAT TEACHERS EDUCATION COLLEGE, MALDA",
  "DSMS College of Healthcare Management - in association with CMRI",
  "PANDUA IDEAL TEACHERS TRAINING COLLEGE",
  "VIDYASAGAR PRIMARY TEACHERS TRAINING COLLEGE B ED",
  "Vidyasagar Teacher Training College",
  "YUNUSH BEd COLLEGE",
  "Bethuadahari College",
  "P. R. THAKUR GOVT. COLLEGE",
  "Dr. R Ahmed Dental College",
  "Srikrishna College",
  "Chapra Bangaljhi Mahavidyalaya",
  "Asleha Girls College",
  "INDIAN INSTITUTE OF LEGAL STUDIES, DARJILING",
  "Sree Ramkrishna Sarada Vidya Mahapith",
  "Neotia Academy Nursing Training Institute",
  "Bolpur College",
  "Pailan College of Management and Technology 156",
  "Tehatta Sri Sri Krishnaray College of Education",
  "Chandraketugarh sahidullah Smriti Mahavidyalaya",
  "Acharya Prafulla Chandra College",
  "Bhairab Ganguly College",
  "AMINPUR COLLEGE OF EDUCATION",
  "Naba Barrackpur Prafulla Chandra Mahavidyalaya",
  "Bangal Fine Arts College,P.O.-Chandpara Bazar, NORTH 24 PARGANAS",
  "College of Nursing , N R S Medical College",
  "Pailan College of Management and Technology 296",
  "College of Visual Arts,Kolkata-700 094",
  "Calcutta Homoeopathic Medical College & Hospital",
  "BISWANATH INSTITUTE OF B.Ed. COLLEGE",
  "D N De Homoeopathic Medical College & Hospital",
  "PHANSIDEWA  PRIMARY  TEACHERS TRAINING  INSTITUTE",
  "VIVEKANANDA COLLEGE OF EDUCATION",
  "Dr. B.R.Ambedkar College",
  "RASHBEHARI PHARMACEUTICAL INSTITUTE",
  "GURUKULCOLLEGE OF EDUCATION",
  "Hiralal Bhakat College",
  "SONADA DEGREE COLLEGE, DARJEELING",
  "Sofia Girls College",
  "VIVEKANANDA NURSING INSTITUTE ",
  "College of Nursing , Medical College",
  "SILIGURI MAHILA MAHAVIDYALAYA, DARJEELING",
  "PT. ISWAR CHANDRA VIDYASAGAR P.T.T AND  B.ED COLLEGE",
  "Birbhum Pharmacy School 353",
  "Duargapur Paramedical Institute",
  "College of Medicine and Sagar Dutta Hospital",
  "College and School of Nursing, R N Tagore Hospital, a Unit of Asia Heart Foundation",
  "K P C medical College",
  "College of Nursing, NIOH",
  "kharagpur Homoeopathic Medical College & Hospital",
  "Bankura Sammilani Medical College",
  "Dr B C Roy Post Graduate Institute of Peadiatric Sciences",
  "Metropolitan Homoeopathic Medical College & Hospital",
  "Haldia Institute of Technology 103",
  "Government General Degree College Salboni",
  "Vidyasagar Institute of Health",
  "Narula Institute of Technology 127",
  "All India Institute of Hygiene and Public Health",
  "National Institute of Homoeopathy",
  "Netai Charan Chakraborty Homoeopathic Medical College & Hospital",
  "SOUTH FIELD COLLEGE, DARJEELING",
  "Institute of Paramedical and Therapeutic Sciences and Technology",
  "Kalyani Government Engineering College 102",
  "College of Physiotherapy, Peerless Hospital",
  "Central Research Institute of Ayurveda",
  "College of Nursing , North Bengal Medical College",
  "Bengal Homoeopathic Medical College & Hospital",
  "Murshidabad College of Engg. and Technology 330",
  "Chittaranjan Seva Sadan Sishu Sadan & College of Obstetics and Gynaecology",
  "JHARGRAM GOVERNMENT MEDICAL COLLEGE AND HOSPITAL",
  "Mahesh Bhattacharya Homoeopathic Medical College & Hospital",
  "Midnapore Medical College",
  "Calcutta Unani Medical College",
  "Institute of Pharmacy",
  "Kingston Law College",
  "Maldah Medical College",
  "J B Roy Ayurvedic Medical College & Hospital",
  "Modern Institute of Engg. and Technology 269",
  "Meghnad Saha Institute of Technology 142",
  "MCKV Institute of Engineering 116",
  "Dumkal College",
  "UNIVERSITY B T AND  EVENING COLLEGE, COOCHBEHAR",
  "MIRIK COLLEGE, DARJEELING",
  "Command Hospital",
  "WEST BENGAL EDUCATIONAL INSTITUTE WBEI ",
  "Chittaranjan National Cancer Institute",
  "BARASAT GOVERNMENT MEDICAL COLLEGE AND HOSPITAL, BARASAT",
  "PRAFULLA CHANDRA SEN GOVERNMENT MEDICAL COLLEGE AND HOSPITAL",
  "KSHUDIRAM BOSE INSTITUTE OF HEALTH EDUCATION AND RESEARCH",
  "MISRA NURSING INSTITUTE OF ASANSOL",
  "JALPAIGURI GOVERNMENT MEDICAL COLLEGE AND HOSPITAL",
  "MOTHER MARY INSTITUTE OF NURSING",
  "Kingston College Of  Science",
  "Mahadevananda Mahavidyalaya",
  "Nahata Jogendranath Mondal Smriti Mahavidyalaya",
  "Barasat College",
  "Midnapore Homoeopathic Medical College & Hospital",
  "GEORGE COLLEGE UNDER THE GAYATRI CHETNA FOUNDATION",
  "SWAMI VIVEKANANDA INSTITUTE OF NURSING",
  "Bengal Institute of Technology and Management 329",
  "AGNIBINA COLLEGE OF PHARMACY    ",
  "M N ACADEMIC TRUST",
  "Burdwan Dental College",
  "B M Birla College of Nursing",
  "Government General Degree College, Mangalkote",
  "GOVERNMENT GENERAL DEGREE COLLEGE, GOPIBALLAVPUR-II",
  "VIDYASAGAR TEACHERS TRAINING INSTITUTE",
  "Krishna Chandra College",
  "North Bengal Medical College",
  "R G Kar Medical College",
  "Haldia Law College",
  "Institute of Biomedical Sciences",
  "Prabhat Kumar College",
  "Mahishadal Girl's College",
  "College of Nursing , Bankura Sammilani Medical College",
  "Lokenath B.Ed. College",
  "Coochbehar Government Medical College  Hospital",
  "Sarsuna Law College",
  "SHYAMANGINI KUNDU COLLEGE OF EDUCATION",
  "Government General Degree College Chapra",
  "GOVERNMENT GENERAL DEGREE COLLEGE, NAKASHIPARA",
  "ITAHAR IDEAL TEACHERS TRAINING COLLEGE",
  "TECHNO INDIA COLLEGE AND SCHOOL OF NURSING ,KANKINARA",
  "AL-AMEEN MEMORIAL MINORITY COLLEGE (B.ED)",
  "ASHALATA TEACHERS TRAINING INSTITUTE",
  "Mahananda College of Education",
  "AMU MURSHIDABAD CENTRE",
  "MATHURA NATH MEMORIAL NURSING INSTITUTION",
  "BIBHUTIBHUSHAN B.Ed. COLLEGE",
  "Bholananda National Academy 132",
  "Mugberia Gangadhar Mahavidyalaya",
  "DumDum Motijheel College",
  "ANTARA INSTITUTE OF HEALTH SCIENCES",
  "Peerless College of Nursing",
  "JOYPUR COLLEGE OF EDUCATION",
  "COOCHBEHAR ADVANCEMENT AND PROSPERITY COLLEGE OF EDUCATION",
  "SATYENDRANATH BASU D El Ed AND B Ed COLLEGE",
  "MUKTIR SHIKSHA COLLEGE OF EDUCATION",
  "SAMUKTALA SIDHU KANHU COLLEGE, JALPAIGURI",
  "SRIJONI COLLEGE OF EDUCATION",
  "MOTHER TERESA INSTITUTE OF NURSING ",
  "Techno International New Town 187",
  "KABIGURU PRIMARY TEACHERS TRAINING INSTITUTE",
  "M.R. INSTITUTE OF NURSING ",
  "Panskura Teachers Traning Institute",
  "USHA HIRANMAYE TEACHERS TRAINING INSTITUTE DELED AND BED",
  "Ramkrishna Mission Vivekananda Centenary College",
  "RANI PRIMARY TEACHERS TRAINING INSTITUTE ",
  "GOKUL INSTITUTE OF NURSING",
  "NIMAS 215",
  "GEORGE SCHOOL OF LAW",
  "Saltora Netaji Centenary College",
  "JANGIPUR COLLEGE OF EDUCATION",
  "Gazole Mahavidyalaya",
  "DURGAPUR INSTITUTE OF PARAMEDICAL SCIENCE",
  "Nandanpur Teachers Traning College",
  "NATURAL COLLEGE OF EDUCATION",
  "M.U.C. Women's College",
  "Syamaprasad Inst. of Tech. and Management 153",
  "West Bengal State Council for Science and Technology 243",
  "GANI NURSING INSTITUTE    ",
  "Mrinmoyee Institute of Education",
  "ACHARYA  BROJENDRA NATH SEAL COLLEGE",
  "RAMKRISHNA COLLEGE OF EDUCATION",
  "COOCHBEHAR COLLEGE, COOCHBEHAR",
  "Khejuri College",
  "IDEAL INSTITUTE OF NURSING",
  "ANINDITA INSTITUTE OF NURSING",
  "KANYASHREE COLLEGE",
  "J B MEMORIAL COLLEGE OF EDUCATION",
  "SOUTH SUNDARBAN INSTITUTE OF HIGHER EDUCATION",
  "AMEX LAW COLLEGE",
  "Government General Degree College at Keshiary",
  "B P PODDAR AND PARVATI DEVI ACADEMY OF NURSING",
  "KABI JAGADRAM ROY GOVERNMENT GENERAL DEGREE COLLEGE",
  "RISHI ARABINDO COLLEGE OF EDUCATION",
  "Global College of Pharmaceutical Technology 356",
  "Sevayatan School of Medical Technology",
  "Lokepara Mahavidyalaya",
  "Shibpur Dinobundhoo Institution (College)",
  "MAHATMA RURAL DEVELOPMENT SOCIETY",
  "Uttar Dinajpur P.T.T.I",
  "Gobardanga Hindu College",
  "National Institute for Mentally Handicapped",
  "GOVERNMENT COLLEGE OF NURSING ",
  "Prasanta Chandra Mahalanobish Mahavidyalaya",
  "JANGAL MAHAL TEACHERS TRAINING INSTITUTE",
  "HLG Institute ",
  "Sri Ramkrishna College of Education",
  "MAHARAJA COLLEGE OF EDUCATION",
  "East Calcutta Girls College",
  "RAJBINA B.Ed. COLLEGE",
  "Kaliyaganj College of Education",
  "GOVERNMENT CENTRE OF LEGAL EDUCATION",
  "Seva Bharati Mahavidyalaya",
  "Hooghly B. C. Roy Institute, Boinchigram",
  "HURA BT AND BD PATI PTTI/D.EL.ED COLLEGE",
  "Institute of Business Management",
  "Netajee Subhash Chandra Bose Institute of Education",
  "GOVT COLLEGE OF NURSING DIAMOND HARBOUR MEDICAL COLLEGE DIAMOND HARBOUR HEALTH DISTRICT",
  "NABADIGANTA COLLEGE OF EDUCATION",
  "Gandhari College",
  "Haji Saheb Teachers Training College",
  "TOTSOL EDUCATIONAL ACADEMY",
  "Brahmananda Keshab Chandra College",
  "PANDIT DINDAYAL UPADHYAY ACADEMY",
  "BCET INSTITUTE OF NURSING SCIENCES",
  "NATHANIYAL MURMU MEMORIAL COLLEGE, DAKSHIN DIJNAPUR",
  "SPANDAN COLLEGE OF PHARMACY",
  "Vivekananda Mahavidyalaya, Burdwan",
  "ASP COLLEGE OF EDUCATION",
  "S.B.S. GOVERNMENT COLLEGE, HILI",
  "Dr. Gourmohan Roy College",
  "Saheed Anurup Chandra Mahavidyalaya",
  "Dishari College of Education, Burdwan",
  "Sewnarayan Rameswar Fatepuria  College",
  "CLUNY COLLEGE FOR WOMEN, DARJEELING",
  "Genesis Institute of Management and Technology",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY, KOLKATA",
  "HAZI EBRAHIM MEMORIAL TEACHERS TRAINING COLLEGE",
  "Balagarh Bijoy Krishna Mahavidyalaya",
  "SIDDHINATH MAHAVIDYALAYA",
  "THE INSTITUTE FOR ACADEMIC EXCELLENCE",
  "Vivekananda Satavarshiki Mahavidyalaya",
  "BALIADANGA SARIF B.ED. COLLEGE",
  "SARIF B.ED. COLLEGE",
  "Government General Degree College, Tehatta",
  "SAHAJPATH",
  "PURBAYAN EDUCATIONAL INSTITUTION",
  "Prof. S. Nurul Hasan College",
  "Yogoda Satsanga Palpara Mahavidyalaya",
  "Bharatiya Vidya Bhavan Institute of Management Science 339",
  "Vidyasagar Primary Teachers Training Institute,Dhamait",
  "Techno International Batanagar 332",
  "Raja Rammohan Roy Mahavidyalaya",
  "BHAKTABALA BEd COLLEGE",
  "KALYANI TECHNOLOGY ACADEMY",
  "NAWJAN INSTITUTE OF NURSING",
  "BIRNAGAR KABI NABIN CHANDRA SEN TEACHERS TRAINING INSTITUTE",
  "THAKUR ANUKUL CHANDRA TAPAVAN VIDYALAYA",
  "ACHARYA SUKUMAR SEN MAHAVIDYALAYA, BURDWAN",
  "Elitte College of Engineering 346",
  "Global College of Science and Technology 345",
  "ANANDA CHANDRA COLLEGE OF COMMERCE, JALPAIGURI",
  "SISTER NIBEDITA GOVERNMENT GENERAL DEGREE COLLEGE FOR GIRLS",
  "Sambhunath Memorial College of Education B.Ed",
  "Heritage Law College",
  "SWARNAMOYEE JOGENDRANATH MAHAVIDYALAYA",
  "Government General Degree College, Kalna-I",
  "GOVERNMENT GENERAL DEGREE COLLEGE, MOHANPUR",
  "Centre for Teachers Training and Research Institute",
  "GLORIOUS INSTITUTE OF NURSING",
  "INTERNATIONAL INSTITUTE OF HOSPITAL MANAGEMENT  AND ALLIED HEALTH SCIENCES",
  "DR KADAMBINI GANGULY INSTITUTE OF NURSING",
  "PRATIMA INSTITUTE OF NURSING AND HEALTH SCIENCE",
  "RCC Institute of Information Technology (Non AICTE)",
  "BIRPARA COLLEGE, JALPAIGURI",
  "P. N. Das College",
  "SALBONI INSTITUTE OF NURSING",
  "KARIMPUR ANITA PRIMARY TEACHERS TRAINING INSTITUTE",
  "GOVERNMENT COLLEGE OF NURSING DISTRICT HOSPITAL HOWRAH",
  "FALAKATA COLLEGE, JALPAIGURI",
  "JALPAIGURI LAW COLLEGE, JALPAIGURI",
  "Malda College",
  "Balurghat Mahila Mahavidyalaya",
  "Kaliachak College",
  "Raiganj Surendranath Mahavidyalaya",
  "Harishchandrapur College",
  "Asansol Engineering College 108",
  "Meghnad Saha Institute of Technology 310",
  "Gurunanak Institute of Hotel Management 312",
  "Gurunanak Institute of Hotel Management 185",
  "Gurunanak Institute of Technology 311",
  "Govt. College of Engg. and Textile Technology, Serampur 110",
  "Dooars Academy of Technology and Management 199",
  "Pakuahat Degree College",
  "Shree Agrasen College",
  "NSHM College of Management and Technology 149",
  "South Malda College",
  "Kaliyaganj College",
  "Samsi College",
  "Gour Mahavidyalaya",
  "Dewan Abdul Gani College",
  "Gangarampur College",
  "Murshidabad College of Engineering and Technology 106",
  "Hooghly Engineering and Technology College 176",
  "NSHM Knowledge Campus, Kolkata - Group of Institutions 277",
  "Buniadpur Mahavidyalaya",
  "Dr. Meghnad Saha College",
  "PKG MEDICAL COLLEGE",
  "MATANGINI GOVT COLLEGE OF NURSING PURBA MEDINIPUR DISTRICT HOSPITAL TAMLUK",
  "CALCUTTA INSTITUTE OF EDUCATION",
  "GURUKUL INSTITUTE OF NURSING ",
  "SHYAMBAZAR  LAW COLLEGE",
  "NATIONAL COLLEGE OF EDUCATION",
  "GURUKUL TEACHERS TRAINING CENTRE",
  "ADHIR SARASWATI COLLEGE OF EDUCATION",
  "ANAND COLLEGE OF EDUCATION",
  "Saheed Nurul Islam Mahavidyalaya",
  "Malda Women's College",
  "Puras - Kanpure Haridas Nandi Mahavidyalaya",
  "Vivekananda College",
  "Bidhannagar College",
  "Techno India 309",
  "PARIMAL MITRA SMRITI MAHAVIDYALAYA, JALPAIGURI",
  "Midnapore City College",
  "Taki Government College",
  "Bejoy Narayan Mahavidyalaya",
  "Chanchal College",
  "Riagin Roushonara Teachers Training College",
  "Dinabandhu Mahavidyalaya",
  "Barasat Government College",
  "DumDum Motijheel Rabindra Mahavidyalaya",
  "Rishi Bankim Chandra College",
  "Rishi Bankim Chandra College for Women",
  "Netaji Satabarshiki Mahavidyalaya",
  "Banipur Mahila Mahavidyalaya",
  "Sarojini Naidu College For Women",
  "JATINDRA MOHAN COLLEGE OF EDUCATION ",
  "JNP COLLEGE OF EDUCATION",
  "Rockvale Management College",
  "ANANDA MARGA GURUKULA TEACHERS TRAINING COLLEGE",
  "Chandernagore College",
  "SEVEN RANGERS INSTITUTE OF NURSING",
  "DR. MATHURA MOHAN SIL D. EL. ED COLLEGE",
  "Sitananda College",
  "GOURAV INSTITUTE OF MANAGEMENT SCIENCE",
  "NETAJI SUBHAS CHANDRA BOSE TEACHERS TRAINING COLLGE, UTTAR DIJNAPUR",
  "SWAMI VIVEKANANDA UNIVERSAL COLLEGE OF EDUCATION",
  "Debra Thana Sahid Kshudiram Smriti Mahavidyalaya",
  "Derozio Memorial College",
  "AASTHA NURSING INSTITUTE",
  "MANMOHINI ACADEMIC INSTITUTION",
  "DESHBANDHU B.Ed COLLEGE",
  "HALDIA INSTITUTE OF PHARMACY",
  "MARINA INSTITUTE OF NURSING",
  "SIDDHIVINAYAK B.Ed COLLEGE",
  "Monalisa B.Ed college and higher Education",
  "Kharagpur College",
  "Maharaja Nandakumar Mahavidyalaya",
  "Rabindra Bharati Mahavidyalaya",
  "M.M.Ali And S.M. Teachers Training Institute",
  "KABIGURU NURSING INSTITUTE",
  "BHIMPUR MOHANANADA COLLEGE OF EDUCATION",
  "AKUI KAMALABALA WOMENS COLLEGE",
  "VISHWA JYOTISH VIDYAPEETH SANSKRIT MAHAVIDYALAYA",
  "SANTIPUR B ED COLLEGE",
  "VIDYASAGAR COLLEGE OF EDUCATION, DARJILING",
  "DINAJPUR B.ED COLLEGE",
  "SRI R K B T COLLEGE, DARJEELING",
  "DEWANHAT MAHAVIDYALAYA, COOCHBEHAR",
  "JAKIR HOSSAIN MEDICAL COLLEGE AND RESEARCH INSTITUTE",
  "ST.  JOSEPH'S COLLEGE, DARJEELING",
  "KAZI NAJRUL ISLAM TEACHERS TRAINING INSTITUTE ",
  "Yeaqub Ali B. Ed. College",
  "SILIGURI B ED  COLLEGE, DARJEELING",
  "Dr. B. C. Roy Academy of Professional Courses",
  "SAGARPARA TEACHERS TRAINING INSTITUTE",
  "GHOLDIGRUI SIKSSHAN MANDIR",
  "JAGANNATH GUPTA INSTITUTE OF MEDICAL SCIENCES AND HOSPITAL",
  "SEVA VARATI B ED COLLEGE",
  "Bandwan Mahavidyalaya",
  "PRAGATI COLLEGE OF EDUCATION",
  "MAHABHASKAR TEACHERS TRAINING COLLEGE",
  "N.B.S. COLLEGE OF EDUCATION",
  "KABIGURU RABINDRANATH COLLEGE OF EDUCATION, COOCHBEHAR",
  "GITA TEACHERS TRAINING COLLEGE",
  "COOCH BEHAR B ED  COLLEGE, COOCHBEHAR",
  "Post Graduate Govt.Institute for Physical Education",
  "Sabang Sajani Kanta Mahavidyalaya",
  "Alipurduar B.Ed.Training College",
  "SRI RAMAKRISHNA COLLEGE OF EDUCATION",
  "A C TRAINING COLLEGE, JALPAIGURI",
  "BALAI CHARAN SECONDARY TEACHERS TRAINING INSTITUTE",
  "Indrani Devi Institute of Education, Bhandarhati",
  "MANDAL TEACHERS TRAINING COLLEGE",
  "Bamanpukur Humayun Kabir Mahavidyalaya",
  "Khamargachi B. Ed. College",
  "Basirhat College",
  "Hiralal Mazumdar Memorial College for Women",
  "Rishi Bankim Chandra Evening College",
  "SREE RAMKRISHNA COLLEGE OF EDUCATION",
  "Barrackpore Rastraguru Surendranath College",
  "Sree Chaitanya College Habra",
  "Hingalganj Mahavidyalaya",
  "Swami Dhananjay Das Kathiababa Mahavidyalaya",
  "BAIKUNTHA COLLEGE OF EDUCATION",
  "BELARANI INSTITUTE OF NURSING",
  "Morning Star College",
  "Subhas Bose Institute of Hotel Management",
  "Panihati Mahavidyalaya",
  "ATRYEE COLLEGE OF EDUCATION",
  "DINHATA COLLEGE, COOCHBEHAR",
  "MRINALINI DEVI COLLEGE OF NURSING",
  "DMBH Institute of Medical Science",
  "SUKANTA MAHAVIDYALAYA, JALPAIGURI",
  "CHANCHAL TEACHERS TRAINING COLLEGE",
  "MUNSHI PREMCHAND MAHAVIDYALAYA, SILIGURI, DARJEELING",
  "Nabagram Amar Chand Kundu College",
  "AVIMANYU COLLEGE OF EDUCATION",
  "Balurghat B.Ed. College",
  "BANGHARH SCHOLAR TEACHERS TRAINING INSTITUTE",
  "BIROSTHALI TEACHERS TRAINING COLLEGE",
  "CHANCHAL B ED COLLEGE, MALDA",
  "DAKSHIN DINAJPUR B ED COLLEGE",
  "DSMS COLLEGE OF HEALTH CARE MANAGEMENT",
  "Tarakeswar Degree College",
  "BELUR SRAMAJIBI SWASTHYA PRAKALPA SAMITY",
  "Birsha Munda Memorial College",
  "Chatra Ramai Pandit Mahavidyalaya",
  "Sankrail Anil Biswas Smriti Mahavidyalaya",
  "Gobinda Prasad Mahavidyalaya",
  "BETA COLLEGE OF EDUCATION",
  "Vidyasagar Institute of Health",
  "SURYA SEN MAHAVIDYALAYA, DARJEELING",
  "SILIGURI COLLEGE OF COMMERCE, DARJEELING",
  "SILIGURI COLLEGE, DARJEELING",
  "Jalangi Mahavidyalaya",
  "Muzaffar Ahmed Mahavidyalaya",
  "J.R.S.E.T College of Law",
  "MEDITECH NURSING INSTITUTE     ",
  "Chakdaha College",
  "Nabadwip Vidyasagar College",
  "Berhampore Girls' College",
  "ARKADUYTI COLLEGE OF EDUCATION",
  "S.K. Acharya Institute of Law",
  "Berhampore College",
  "Nagar College",
  "A R LAW COLLEGE",
  "Lalgola College",
  "Bimal Chandra College of Law",
  "Achhruram Memorial College",
  "Dwijendralal College",
  "Sripat Singh College",
  "Alinagar Teachers Training College",
  "Ananda Marg College",
  "DAVID HARE TEACHERS TRAINING COLLEGE, MALDA",
  "DR SARVAPALLI RADHAKRISHNAN B ED COLLEGE, MALDA",
  "Gangarampur B. Ed. College",
  "GOUR MALDA COLLEGE OF EDUCATION (B Ed)",
  "Govt. Teachers' Training College",
  "HOLY CHILD B ED COLLEGE, MALDA",
  "ISLAMPUR COLLEGE OF EDUCATION",
  "JANARDAN COLLEGE OF EDUCATION  (B.Ed) ",
  "KALIACHAK SULTANA COLLEGE OF EDUCATION, MALDA",
  "KARNAJORA COLLEGE OF EDUCATION",
  "MOTHER TERESA COLLEGE OF EDUCATION",
  "Arsha College",
  "Balarampur College",
  "Techno India Institute of Technology 145",
  "The Calcutta Anglo Gujarati College 195",
  "Techno India (Hooghly Campus) 152",
  "Swami Vivekananda Institute of Science and Technology 241",
  "Swami Vivekananda Institute of Management and Computer Science 250",
  "Surendra Institute of Engineering and Management 261",
  "Siliguri Institute of Technology (HMCT) 335",
  "Seacom Management College 214",
  "Seacom Engineering College 206",
  "Regent Education and Research Foundation Group of Institutions 263",
  "Kolkata Teachers Training College",
  "Surendranath College for Women",
  "Jangipur College",
  "Hazi A.K. Khan College",
  "Jatindra Rajendra Mahavidyalaya",
  "Tagore School of Rural Development & Agriculture",
  "Haringhata Mahavidyalaya",
  "Santipur College",
  "Subhas Chandra Bose Centenary College",
  "Monarch College of Art & Technology",
  "Murshidabad Adarsha Mahavidyalaya",
  "Ranaghat College",
  "Kandi Raj College",
  "Mohammad Abdul Bari Institute of Juridical Science",
  "Krishnanath College",
  "Kalyani Mahavidyalaya",
  "Dukhulal Nibaran Chandra College",
  "Dr. B.R. Ambedkar College",
  "Prabharani Institute of Education (Physical Education)",
  "Krishnagar Womens College",
  "Sudhiranjan  Lahiri  Mahavidyalaya",
  "Sunil Dhar Memorial B.P.Ed. College",
  "Institute of Mass Communication Film & Television",
  "Karimpur Pannadevi College",
  "Camellia Institute of Technology 230",
  "Techno Engineering College Banipur 244",
  "Sarojmohan Institute of Technology 168",
  "Ramkrishna Mahato Government Engineering College Purulia 350",
  "DHUPGURI COLLEGE OF EDUCATION",
  "MANORANJAN SAHA MEMORIAL B.Ed COLLEGE",
  "Udaynarayanpur Madhabilata Mahavidyalaya",
  "Women's Christian College",
  "Bijoy Pal Memorial B. Ed. College",
  "ANANDA CHANDRA COLLEGE, JALPAIGURI",
  "Jalpaiguri Govt. Engineering College 101",
  "ABACUS Institute of Engineering and Management 240",
  "Azad Hind Fouz  Smriti Mahavidyalaya",
  "Pingla Thana Mahavidyalaya",
  "Woodlands College of Nursing,",
  "Kadambini Women's College of Education",
  "Bengal College of Pharmaceutical Technology 376",
  "Asansol Girls' College",
  "St. Xaviers College, Asansol",
  "Triveni Debi Bhalotia College",
  "Calcutta National Medical College",
  "JMN MEDICAL COLLEGE",
  "NIRMALA CHITTA TEACHERS TRAINING INSTITUTE",
  "SEBABRATA INSTITUTE OF NURSING",
  "NH RABINDRANATH TAGORE INTERNATIONAL INSTITUTE OF CARDIAC SCIENCES",
  "RASULPUR PROTIK NURSING INSTITUTION",
  "KUNTALA DAS COLLEGE OF EDUCATION",
  "GITANJALI INSTITUTE OF NURSING",
  "SAMAJKALYAN NURSING INSTITUTE",
  "SAINTHIA NURSING INSTITUTE",
  "J.D. Birla Institute",
  "RAMPURHAT NURSING INSTITUTION",
  "SEPHALI MEMORIAL NURSING INSTITUTE",
  "NSMS NURSING INSTITUTE",
  "BISHNUPUR PUBLIC SCHOOL AND COLLEGE OF NURSING",
  "Bengal Music College",
  "INSTITUTE OF NEUROSCIENCES,KOLKATA",
  "PRAGATI NURSING COLLEGE AND  PRAGATI NURSING SCHOOL",
  "DMBH Institute of Medical Seience 382",
  "NSHM INSTITUTE OF NURSING",
  "PATHAK COLLEGE OF EDUCATION",
  "GITANJALI COLLEGE OF PHYSICAL EDUCATION",
  "Dr. Sudhir Chandra Sur Institute of Technology and Sports Complex 255",
  "Pandaveswar School of Pharmacy 384",
  "HLG INSTITUTE OF NURSING",
  "PRAVAKARAN BED COLLEGE",
  "BANGIYO GURUKUL ASHRAM",
  "Dr. B. C. Roy College of Pharmacy and Allied Health Sciences 189",
  "Sagardighi Kamada Kinkar Smriti Mahavidyalaya",
  "Saha Institute of Nuclear Physics (SINP),Kolkata",
  "PRAMOTH NATH DAS ACADEMY OF NURSING",
  "Kishore Bharati Bhagini Nivedita College Co Ed",
  "PRITHWISH CHANDRA BISWAS KANYA MAHAVIDYALAYA",
  "SAMRIDDHI INSTITUTE OF NURSING ",
  "Vivekjyoti College",
  "ADAN INSTITUTE OF NURSING SCIENCE",
  "ACHARYA PRAFULLA CHANDRA ROY GOVERNMENT COLLEGE",
  "PURNADISHA NURSING TRAINING INSTITUTE",
  "BIRBHUM INSTITUTE OF NURSING ",
  "Vidyanagar College",
  "SANTINIKETAN PARAMEDICAL COLLEGE",
  "MIES R M LAW COLLEGE",
  "Kazi Nazrul Islam College Of Education",
  "DOMKAL SABKAT MANDAL PTTI DED EDUCATIONAL INSTITUTE",
  "SUKHDEB BRHMACHARI INSTITUTE OF EDUCATION",
  "Habibpur Teachers Training College D El Ed",
  "Buniadpur Teachers Training College",
  "Anand College of Education 365",
  "BHAKTA BALA SANSKRIT COLLEGE",
  "MAZIDIA ACADEMY",
  "VIVEKANANDA INSTITUTE OF EDUCATION",
  "SIMANTA MANBHUM TEACHERS TRAINING COLLEGE",
  "SUSRIJO INSTITUTE OF PARAMEDICAL TECHNOLOGY AND OPTOMETRY",
  "SWAMI VIBEKANANDA COLLEGE OF EDUCATION",
  "Institute OF Human Excellence D.El.Ed",
  "krishna prasad pal memorial teachers training college",
  "TRINITY BED COLLEGE ",
  "TEBHAGA TEACHERS TRAINING COLLEGE",
  "SWAMI VIVEKANANDA PRIMARY TEACHERS TRAINING INSTITUTE",
  "Satyapriya Roy College of Education",
  "SAROJINI ACADEMY",
  "MR COLLEGE",
  "LALGOLA TEACHERS TRAINING ACADEMY",
  "MATANGINI TEACHERS TRAINING INSTITUTE",
  "Global Institute of Education",
  "VIDYASAGAR B.ED. COLLEGE",
  "BRATINDRA LATIKA B.ED and  D.EL.ED COLLEGE",
  "KAZIGRAM COLLEGE OF EDUCATION",
  "BARASAT COLLEGE OF TEACHER EDUCATION",
  "SAHID KHUDIRAM COLLEGE OF EDUCATION",
  "MAA GOURI DEVI COLLEGE OF EDUCATION",
  "EDUCITY COLLEGE OF EDUCATION",
  "NAZRUL ISLAM COLLEGE OF EDUCATION",
  "TECHNO INDIA TEACHERS TRAINING INSTITUTE",
  "RAIGANJ TEACHERS TRAINING COLLEGE",
  "Sova Rani D.Ed College",
  "SARADA DEVI COLLEGE OF EDUCATION",
  "JAGADISH CHANDRA MANDAL INSTITUTE OF EDUCATION",
  "AZAD D.ED. TRAINING COLLEGE",
  "SWAMI VIVEKANANDA TRIBAL COLLEGE OF TEACHERS EDUCATION",
  "Saltora B. Ed. College",
  "R N TAGORE B ED COLLEGE",
  "RIZIA BIBI ACADEMY OF TEACHERS EDUCATION",
  "Swami Vivekananda College of Education For Women",
  "KULTIKRI TEACHER TRAINING INSTITUTE OF HIGHER STUDIES",
  "LJD  COLLEGE FALTA",
  "BENGAL EDUCATIONAL COLLEGE",
  "KUMRI VIVEKANANDA P.T.T.I. ",
  "TARA MAA PRIMARY TEACHERS TRAINING INSTITUTE",
  "KAZI NAZRUL ISLAM B.ED. COLLEGE",
  "Sambhunath College",
  "LJD LAW COLLEGE FALTA",
  "Raipur B. Ed. College",
  "RADHARANI EDUCATIONAL INSTITUTE",
  "Nikhil Banga Sikshan Mahavidyalaya",
  "KHARGRAM COLLEGE OF EDUCATION",
  "B L EDUCATIONAL TEACHERS TRAINING COLLEGE",
  "HINGALGANJ AMBITION COLLEGE OF EDUCATION",
  "Nandalal Ghosh B.T.College",
  "MR COLLEGE OF EDUCATION",
  "Madhyamgram B.Ed College",
  "DR.B.C.ROY COLLEGE OF EDUCATION",
  "Amdanga Adarsha Teachers Training College",
  "JOYPUR B ED COLLEGE",
  "Gopal Chandra MemorialCollege of Education",
  "Chandernagore Institute of Management & Technology",
  "Vivekananda Mahavidyalaya, Haripal",
  "Turku Hansda-Lapsa Hemram Mahavidyalaya",
  "Rabindra Mahavidyalaya",
  "Polba Mahavidyalaya",
  "Galsi Mahavidyalaya",
  "Netaji Mahavidyalaya",
  "Gandhi Centenary B.T College",
  "Frontpage College of Education",
  "CHAKRA TEACHERS TRAINING COLLEGE",
  "JOTEGHANASHYAM MOHAN KARTICK TEACHERS TRAINING COLLEGE",
  "Sir Rashbehari Ghosh Mahavidyalaya",
  "Purni Devi Chaudhuri Girls' College",
  "Government Training College Hooghly",
  "Memari College",
  "Chandrapur College",
  "The Indian College of Arts and Draftsmanship",
  "CHARNOCK COLLEGE OF PARAMEDICS (B.Sc OTT and CCT)",
  "ALTAB HOSSAIN PRIMARY TEACHERS TRAINING INSTITUTE",
  "Govt. General Degree College,Narayangarh",
  "ALIPURDUAR ASHUTOSH B.ED COLLEGE",
  "Dhruba Chand  Halder College",
  "DEBRA INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "VIVEKANANDA COLLEGE, ALIPURDUAR",
  "TARAPADA DEY EDUCATIONAL INSTITUTION",
  "Institute of Business Management and Research Under Graduate Studies",
  "The Heritage Academy 213",
  "TAGORE INSTITUTE OF ART & EDUCATION, BIRBHUM",
  "ORIENTAL INSTITUTE OF HEALTH SCIENCES",
  "BINOY SADAN B.Ed COLLEGE OF WOMEN IN SOCIAL ACTION",
  "Raiganj Educare Teachers Training College",
  "SARIF COLLEGE OF EDUCATION",
  "TAMRALIPTO GOVERNMENT MEDICAL COLLEGE AND HOSPITAL",
  "KOLKATA POLICE LAW INSTITUTE",
  "Minerva Academy B.Ed. College",
  "Ramsaday College",
  "PRAGATI EDUCATIONAL INSTITUTE",
  "BISHNUPRIYA COLLEGE OF EDUCATION",
  "ODALCHUA PTTI AND B.ED",
  "Ramakrishna Mission Brahmananda College of Education",
  "RAJA RAM MOHAN ROY COLLEGE OF EDUCATION",
  "RASULPUR SHIKSHAK SHIKSHAN MAHAVIDYALAYA",
  "RASULPUR PROTIK",
  "COALFIELD COLLEGE OF EDUCATION",
  "BANESWAR SARATHIBALA MAHAVIDYALAYA",
  "Apollo College of Nursing,",
  "LALGOLA MADAN MOHAN ROY TEACHERS TRAINING COLLEGE",
  "GOVERNMENT GENERAL DEGREE COLLEGE, SINGUR",
  "ST PAULS COLLEGE OF NURSING",
  "RABINDRA NAJRUL SMRITI TEACHERS TRAINING COLLEGE",
  "FUNDAMENTAL INSTITUTE OF TEACHERS TRAINING",
  "KUSUM DEVI SUNDERLAL DUGAR JAIN DENTAL COLLEGE AND HOSPITAL",
  "BARACKPORE COLLEGE OF EDUCATION",
  "BELARANI INSTITUTE OF PARAMEDICAL AND ALLIED SCIENCES",
  "DESUN HOSPITAL, KOLKATA",
  "RAIPUR RABINDRA VIVEK NURSING INSTITUTE",
  "International Institute of Hotel Management",
  "SANJOY MEMORIAL ACADEMY OF NURSING AND RESEARCH",
  "KRISHNA NURSING INSTITUTE",
  "SILIGURI PARAMEDICAL COLLEGE",
  "B P PODDAR AND PARVATI DEVI FOUNDATION FOR EDUCATION",
  "MURSHIDABAD NURSING INSTITUTE",
  "NALANDA NURSING INSTITUTE ",
  "WESTBANK COLLEGE OF NURSING ",
  "BADLA VIVEKANANDA B.Ed COLLEGE",
  "Institute of Education (PG) for Women, Chandernagore Hooghly",
  "GOVERNMENT COLLEGE OF NURSING  RAMPURHAT",
  "SANTINIKETAN MEDICAL COLLEGE ",
  "KALNA SURENDRANATH B ED COLLEGE",
  "Tarashankar Bandopadhyay B. Ed. Institution",
  "SATYA KINKAR DEY ACADEMY",
  "TOSHANI COLLEGE OF EDUCATION",
  "ABODH INSTITUTION",
  "ST XAVIERS COLLEGE, BURDWAN",
  "KURSEONG COLLEGE, DARJEELING",
  "GYANJYOTI COLLEGE, DARJEELING",
  "SALESIAN COLLEGE, DARJEELING",
  "ALIPURDUAR COLLEGE",
  "Basirhat Mahabodhi College of Education",
  "Bankura College of Education",
  "DARJEELING GOVERNMENT COLLEGE, DARJEELING",
  "SAHEED KSHUDIRAM COLLEGE, JALPAIGURI",
  "NANI BHATTACHARYA SMARAK MAHAVIDYALAYA, ALIPURDUAR",
  "Vivekananda Mission Mahavidyalaya",
  "Joypur Panchanan Roy College",
  "ISLAMPUR COLLEGE, UTTAR DINAJPUR",
  "Chandrakona Vidyasagar Mahavidyalaya",
  "Krishnagar Government College",
  "JIS College of Engineering 317",
  "Neotia Institute of Technology, Management and Science 144",
  "RCC Institute of Information Technology 117",
  "Bengal College of Engineering and Technology 125",
  "Bengal School of Technology 193",
  "Bengal School of Technology and Management 266",
  "Budge Budge Institute of Technology 276",
  "Calcutta Institute of Technology 177",
  "Athena B. Ed. College",
  "Dinabandhu Andrews Inst. of Tech. and Mgmt. 154",
  "AL HERA COLLEGE OF EDUCATION",
  "ADYAPEATH ANNADA B.ED. COLLEGE",
  "ADARSHA COLLEGE OF EDUCATION",
  "Gupta College of Technological Sciences 124",
  "Dumkal Institute of Engineering and Technology 131",
  "Adamas Institute of Teacher Education",
  "Global Institute of Management and Technology 259",
  "Global Institute of Science and Technology 192",
  "Heritage Institute of Technology 126",
  "Institute of Business Management and Research",
  "BEJPURA PRIMARY TEACHERS TRAINING INSTITUTE",
  "Institute of Science and Technology 182",
  "International Institute of Management Sciences 178",
  "JIS College of Engg. 318",
  "Kingston School of Management and Science 173",
  "Institute of Hotel and Restaurant Management 290",
  "GLF Business School",
  "Kulti College",
  "PIJUSH KANTI MUKHERJEE MAHAVIDYALAYA",
  "GOVERNMENT GENERAL DEGREE COLLEGE AT PEDONG",
  "LILABATI MAHAVIDYALAYA",
  "Management Institute of Durgapur 326",
  "DHUPGURI GIRLS COLLEGE",
  "CHOPRA KAMALA PAUL SMRITI MAHAVIDYALAYA",
  "Narula Institute of Technology 306",
  "NIPS School of Hotel Management 180",
  "Nopany Institute of Management Studies 150",
  "Provadebi B.Ed. College",
  "C K R Institution of Education",
  "Government General Degree College, Dantan II",
  "Omdayal Group of Institutions 275",
  "Prajnanananda Institute of Technology and Management 220",
  "Rinpoche Academy of Management and Technology 246",
  "Seacom Marine College 235",
  "Supreme Knowledge Foundation Group of Institutions 253",
  "Swami Vivekananda Institute of Modern Science 264",
  "Techno India College of Technology 314",
  "Asansol Engineering College 322",
  "Netaji Subhash Engineering College 292",
  "Future Institute of Engg. and Management 294",
  "Government General Degree College, Kharagpur II",
  "CHANDRADWEEP COLLEGE OF EDUCATION, B.Ed",
  "Army Institute of Management 136",
  "Aryabhatta Institute of Engg. and Management 327",
  "Camellia Institute of Technology and Management 257",
  "GORUBATHAN GOVERNMENT COLLEGE",
  "Heritage Business School 304",
  "Netaji Subhash Engineering College 291",
  "Techno India Kolkata 226",
  "George College of Management and Science 164",
  "Bengal Institute of Technology 121",
  "Bengal Institute of Technology and Management 163",
  "Bhartiya Vidya Bhavan Institute of Management Science 129",
  "Calcutta Institute of Pharmaceutical Technology and Allied Health Sciences 159",
  "College of Engineering and Management, Kolaghat 107",
  "Dolphin School of Hotel Management 265",
  "Dream Institute of Technology 209",
  "Gitaram Institute of Management 134",
  "Golden Regency Institute of Hospitality Management 200",
  "Domkal Girls College",
  "THAKUR PANCHANAN MAHILA MAHAVIDYALAYA, COOCHBEHAR",
  "TUFUNGANJ MAHAVIDYALAYA, COOCHBEHAR",
  "IMS Business School 333",
  "B. P. Poddar Institute of Management and Technology 115",
  "SITALKUCHI COLLEGE, COOCHBEHAR",
  "MEKHLIGANJ COLLEGE, COOCHBEHAR",
  "MATHABHANGA COLLEGE",
  "GOVT. COLLEGE OF PHYSICAL EDUCATION FOR WOMEN, COOCHBEHAR",
  "GHOKSADANGA BIRENDRA MAHAVIDYALAYA, COOCHBEHAR",
  "FoIRDM, Ramakrishna Mission Vivekananda University",
  "Inspiria Knowledge Campus 344",
  "Michael Madhusudan Memorial College",
  "Law College, Durgapur",
  "Kazi Nazrul Islam Mahavidyalaya",
  "Durgapur Institute of Legal Studies",
  "DS M S College of Tourism and Management",
  "Khandra College",
  "Durgapur Women's College",
  "Dr. B. C. Roy Engineering College, Durgapur 120",
  "B. P. Poddar Institute of Management & Technology 301",
  "ABS Academy of Science, Technology and Management 216",
  "ABS Academy of Science, Technology and Management 328",
  "Camellia School of Engineering and Technology 238",
  "Greater Kolkata College of Engineering and Management 236",
  "Birbhum Institute of Engineering and Technology 118",
  "NSHM College of Management and Technology, Kolkata 234",
  "Govt. College of Engineering and Leather Technology 112",
  "Gurunanak Institute of Pharmaceutical Science and Technology 186",
  "Gurunank Institute of Pharmaceutical Science and Technology 313",
  "Haldia Institute of Management 175",
  "Haldia Inst. of Maritime Studies and Research 179",
  "Advanced Information and Management Studies 198",
  "Gargi Memorial Institute of Technology Campus 281",
  "St. Marys Technical Campus Kolkata 286",
  "Glorious College of Education",
  "GURUKUL TEACHER TRAINING INSTITUTE",
  "Siliguri Institute of Technology (MCA) 336",
  "Institute of Genetic Engineering 210",
  "JIS College of Engineering 123",
  "Kanad Institute of Engineering and Management 252",
  "Mallabhum Institute of Technology 158",
  "South Calcutta Girls' College",
  "Gourmohan Sachin Mondol Mahavidyalaya",
  "Anandamohan College",
  "Shri Shikshayatan College",
  "St. Xavier's College",
  "Sundarban Mahavidyalaya",
  "Netaji Nagar Day College",
  "Maharaja Manindra Ch. College",
  "Bangabasi Evening College",
  "Surendranath Law College",
  "Basanti Devi College",
  "Government College of Art & Craft, Calcutta",
  "Sadhan Chandra Mahavidyalaya",
  "Jogesh Chandra Chaudhuri College",
  "Surendranath Evening College",
  "Jyotirmoy School of Law",
  "Budge Budge College",
  "Sundarban Hazi Desarat College",
  "Seth Soorajmull Jalan Girls ' College",
  "Serampore College",
  "South Calcutta Law  College",
  "State Institute of Physical Education for Women",
  "Al- Ameen Memorial Minority College",
  "Bidhan Chandra College",
  "Kultali Dr. B. R. Ambedkar College",
  "VEDANTA COLLEGE",
  "INDIAN INSTITUTION OF LEGAL STUDIES COOCH BEHAR",
  "Sagar Mahavidyalaya",
  "Pathar Pratima Mahavidyalaya",
  "Naba Ballygunge Mahavidyalaya",
  "Taradevi Harakhchand Kankaria Jain College",
  "Rani Birla Girls' College",
  "Ramakrishna Mission Vidyamandira",
  "Jogamaya Devi College",
  "Narasinha Dutt College",
  "Sukanta College",
  "Acharya Jagadish Chandra Bose College",
  "Vidyasagar College",
  "Mahitosh Nandi Mahavidyalaya",
  "New Alipore College",
  "Gokhale Memorial Girls College",
  "Khudiram Bose Central College",
  "Sammilani Mahavidyalaya",
  "Nabagram Hiralal Paul College",
  "Bankim Sardar College",
  "Raja Peary Mohan College",
  "Shirakole Mahavidyalaya",
  "Dinabandhu Andrews College",
  "Calcutta Girls' College",
  "City College of Commerce & Business Administration",
  "Lalbaba College",
  "Bangabasi Morning College",
  "Deshbandhu College for Girls'",
  "Jogesh Chandra Chaudhuri Law College",
  "Scottish Church College",
  "Kidderpore College",
  "Bhangar Mahavidyalaya",
  "Baruipur College",
  "Maharani Kasiswari College",
  "Lady Brabourne College",
  "Charu Chandra College",
  "Savitri Girls' College",
  "Dhola Mahavidyalaya",
  "Raidighi College",
  "Bikash Bharati Law College",
  "Vivekananda College",
  "Vidyasagar College for Women",
  "Rammohan College",
  "Serampore  Girls'College",
  "Loreto College",
  "Goenka College of Commerce & Business Administration",
  "Vidyasagar Mahavidyalaya",
  "Bethune College",
  "Bijoy krishna Girls' College",
  "Rabindra Siksha Sammilani Law College",
  "Maharaja Sris Chandra College",
  "Gurudas College",
  "Muralidhar Girls' College",
  "INTERNATIONAL INSTITUTE OF NURSING AND RESEARCH",
  "Prabhu Jagatbandhu College",
  "Bangabasi College",
  "Umes Chandra College",
  "Sovarani Memorial College",
  "Vidyapati Bachelor Education College",
  "UTTAR DINAJPUR PRIMARY TEACHER TRAINING INSTITUTE RAIGANJ",
  "Jhargram Raj College",
  "Tamralipta Mahavidyalaya",
  "Mahishadal Raj College",
  "Deshbandhu Mahavidyalaya",
  "Hijli College",
  "Rabindra Satabarshiki Mahavidyalaya",
  "Haldia Government College",
  "Belda College",
  "Panskura Banamali College",
  "Bidhan Chandra College",
  "Sukumar Sengupta Mahavidyalaya",
  "Midnapore Law College",
  "Santal Bidroha Sardha Satabarsiki Mahavidyalaya",
  "Moyna College",
  "Deshapran Mahavidyalaya",
  "K. D. College of Commerce and General Studies",
  "Oriental Institute of Science and Technology",
  "Bhatter College",
  "Sevayatan Sikshan Mahavidyalaya",
  "AMIK Institute of Management Science & Technology",
  "Bajkul Milani Mahavidyalaya",
  "Gourav Guin Memorial Collegew",
  "Raniganj Institute of Information Technology",
  "Silda Chandrasekhar College",
  "Raniganj Institute of Computer & Information Science",
  "Ramnagar College",
  "Midnapore College",
  "Chaipat Saheed Pradyot Bhattacharya Mahavidyalaya",
  "Vidyasagar School of Social Works",
  "Maa Sarada Institute of Nursing",
  "MURSHIDABAD MEDICAL COLLEGE AND HOSPITAL",
  "Rampurhat Government Medical College ",
  "COLLEGE OF NURSING ESI HOSPITAL ASANSOL",
  "KABIGURU RABINDRANATH COLLEGE OF EDUCATION",
  "Gitanjali College of Pharmacy 362",
  "Techno College Hooghly 188",
  "JLD Engineering and Management College",
  "Bharat Technology 208",
  "P.G. Institute of Medical Sciences 352",
  "KSHUDIRAM BOSE COLLEGE OF EDUCATION",
  "JAGANNATH GUPTA INSTITUTE OF NURSING SCIENCES",
  "FALAKATA B.ED COLLEGE",
  "INDIAN ACADEMY OF TEACHERS EDUCATION",
  "ANP TEACHERS TRAINING B.ED. COLLEGE",
  "BARA ANDULIA P T T I",
  "THE HERITAGE COLLEGE",
  "Mahatma Gandhi Academic Institute",
  "IIAS School of Management, Siliguri 338",
  "Ghoshpukur College",
  "BIRSA MUNDA COLLEGE",
  "CHHAYA GHOSH MAHILA B. ED. COLLEGE",
  "SANTIPUR PRIMARY TEACHERS TRAINING INSTITUTE",
  "Raniganj Girls' College",
  "MOTHER TERESA INSTITUTE OF EDUCATION AND RESEARCH",
  "HAJI SAYED PROGRESSIVE TEACHERS TRAINING INSTITUTE",
  "MNM Teachers Training College",
  "MIRZA NOOR MAHAMMAD COLLEGE OF EDUCATION",
  "Gurukul Management Studies 221",
  "Eminent College of Pharmaceutical Technology 354",
  "DARJEELING UNIVERSAL CAMPUS, COLLEGE OF EDUCATION",
  "Durgapur Institute of Science & Technology",
  "Banwarilal Bhalotia College",
  "SYED MUZTABA ALI COLLEGE OF EDUCATION",
  "RAMPUR ADARSHA COLLEGE OF EDUCATION",
  "DR. B. C. ROY TEACHERS TRAINING INSTITUTE",
  "Plassey College",
  "Uluberia College",
  "PAJHRAPARA MINORITY B.ED COLLEGE",
  "ABDUL SAHEB B.ED COLLEGE ",
  "APEX TEACHERS TRAINING COLLEGE",
  "MOHINIGANJ IDEAL TEACHERS TRAINING COLLEGE",
  "KAZI NAZRUL ISLAM TEACHERS TRAINING COLLEGE",
  "TARIFA MEMORIAL TEACHERS TRAINING COLLEGE",
  "Beldanga Humayan Kabir Memorial BEd College",
  "ABDUL JABBAR COLLEGE OF EDUCATION",
  "MOTHER TERESA TEACHER TRAINING COLLEGE",
  "BKJK SCHOOL OF EDUCATION",
  "RANI INDIRA DEBI GOVERNMENT GIRLS COLLEGE",
  "Dr. A. P. J. Abdul Kalam Government College, New Town Rajarhat",
  "BHAGIRATHI PRIMARY TEACHERS TRAINING INSTITUTE ",
  "Sarat Centenary College",
  "RAHAMANIA BEd COLLEGE",
  "HETAMPUR RAJBATI B.Ed COLLEGE",
  "Raiganj B. Ed. College",
  "Dr. Ambedkar B.Ed College",
  "Subhadra Pal PTTI",
  "Hemnalini Mamorial College of Engineering 343",
  "Parameswar Mahavidyalaya",
  "Kabiguru College Of Education",
  "Jogendra Rajkrishna College of Teachers Education",
  "SAGARPARA EDUCATION COLLEGE",
  "Central Modern College of Education",
  "Debendranath Mondal (D.N.Mondal) College",
  "Government Girls' General Degree College",
  "Sureswar Dutta Law College",
  "BELAYAT MUNSI PRIMARY TEACHERS TRAINING INSTITUTE",
  "ICARE INSTITUTE OF MEDICAL SCIENCES AND RESEARCH , HALDIA, West Bengal",
  "ARYA BHARAT SIKSHYA PRATISTHAN",
  "MIRZAPUR B.ED.COLLEGE",
  "GURUKUL. THE. TEACHING INSTITUTE",
  "A M TEACHERS TRAINING INSTITUTE",
  "NABIPUR NABAJAGARAN COLLEGE OF EDUCATION",
  "BARASAT SUBHAS CHANDRA COLLEGE OF EDUCATION",
  "GEORGE COLLEGE (DEPARTMENT OF EDUCATION)",
  "Ajijur Rahaman College of Education",
  "IQ City Medical College",
  "MINAKHAN DR.B.R.AMBEDKAR COLLEGE OF EDUCATION",
  "GANGAPADA MEMORIAL INSTITUTE OF D.ED ",
  "Prabharani B.Ed. College",
  "MASS EDUCATION TEACHERS TRAINING INSTITUTE",
  "KNOWLEDGE VALLEY COLLEGE OF EDUCATION",
  "Bengal Institute of pharmaceutical Sciences",
  "BANUALI AND AJIRAN TEACHERS TRAINING INSTITUTE (B.ED COLLEGE)",
  "ELITTE COLLEGE OF HEALTH SCIENCE",
  "ARYAN EDUCATION AND RESEARCH INSTITUTE",
  "Future Institute of Technology 342",
  "DOMKAL B.ED COLLEGE",
  "Techno Main Salt Lake 130",
  "Camellia Institute of Engineering and Technology 271",
  "St. Thomas College of Engineering & Technology 122",
  "EASTERN INSTITUTE FOR INTEGRATED LEARNING IN MANAGEMENT",
  "LALIT MOHAN MEMORIAL COLLEGE OF EDUCATION",
  "SUNDARBAN B.ED. COLLEGE",
  "DHALI INSTITUTE OF TEACHER EDUCATION",
  "GITANJALI TEACHERS TRAINING COLLEGE",
  "SAHA ALIMUDDIN COLLEGE OF EDUCATION",
  "GARHCHUMUK KOLIA TEACHERS' TRAINING COLLEGE",
  "Gangadharpur Sikshan Mandir",
  "El-Bethel College (for B.Ed)",
  "Education College",
  "DURGAPUR ANANDAMOY B Ed COLLEGE",
  "DR SARVEPALLI RADHAKRISHNAN TEACHERs TRAINING COLLEGE, MURSHIDABAD",
  "DR. B.R.AMBEDKAR INSTITUTE OF EDUCATION",
  "DISHA EDUCATIONAL INSTITUTE",
  "DEBNARAYAN SHIKSHA SANSTHAN(B.ED COLLEGE)",
  "Bhujanga Bhusan Ushangini B.Ed. Institution",
  "Berhampore B Ed College, Saidabad",
  "Bagnan Teachers Training College",
  "ANNAPURNA MEMORIAL COLLEGE OF EDUCATION",
  "BENGAL COLLEGE OF EDUCATION",
  "AZAD MISSION TEACHERS TRAINING COLLEGE",
  "ANTONY BEd COLLEGE",
  "AL HILAL MISSION TEACHERS TRAINING INSTITUTE",
  "ACHARYA JAGADISH CHANDRA ACADEMY B Ed COLLEGE",
  "ABDUS SATTAR MEMORIAL COLLEGE OF EDUCATION",
  "ABDUR RAHIM PANCHANAN PAL INSTITUTION",
  "MONARCH COLLEGE OF EDUCATION",
  "WEST POINT SCHOOL OF EDUCATION",
  "WALI INSTITUTE OF TEACHERS EDUCATION",
  "VIVODHANANDA SARASWATI TEACHERS TRAINING COLLEGE",
  "Amdanga Jugal Kishore Mahavidyalaya",
  "Nayagram Pandit Raghunath Murmu Government College",
  "Dr. Kanailal Bhattacharya College",
  "George College 133",
  "NSHM INSTITUTE OF PHARMACEUTICAL TECHNOLOGY, DURGAPUR",
  "Balurghat Law College",
  "FALTA JIS NURSING INSTITUTE",
  "TANMOY COLLEGE OF HIGHER EDUCATION B.Ed",
  "DOOARS INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH",
  "SwarajnagarTeachers' Training College (B. Ed.)",
  "Balurghat College",
  "PANDAVESWAR INSTITUTE OF HEALTH AND ALLIED SCIENCES",
  "Swami Vivekananda College of Education",
  "SUNDARBAN ANIL KRISHNA MAHAVIDYALAYA (B Ed)",
  "Barabazar Bikram Tudu Memorial College",
  "Bengal Institute of Science & Technology",
  "Saradama Girls College",
  "Bikramjeet Goswami Memorial College",
  "Ramakrishna Mission Blind Boys Academy",
  "MODEL B.P.ED. COLLEGE, JALPAIGURI",
  "Shyampur Siddheswari Mahavidyalaya",
  "Victoria Institution",
  "SALESIAN COLLEGE (SILIGURI CAMPAS), DARJILING",
  "College of Teacher Education, Asansol",
  "ALEX INSTITUTE OF NURSING",
  "SAROJINI INSTITUTE OF NURSING",
  "SOVA RANI COLLEGE OF EDUCATION",
  "DEEPSIKHA NURSING INSTITUTE",
  "RAVEL INSTITUTE OF NURSING",
  "BINODA LAW COLLEGE",
  "DUBRAJPUR NURSING AND MEDICAL RESEARCH INSTITUTE",
  "Government College of Education, Banipur",
  "PRASANNADEB WOMENS COLLEGE",
  "Chunaram Gobinda Memorial Government College",
  "UTTAR BANGA MAHESWARI COLLEGE    ",
  "Alipurduar Government Engineering and Management College",
  "MOTHER USHA MEMORIAL ORIENTAL CENTRAL SANSKRIT INSTITUTION AND AGAM TANTRA RESEARCH CENTRE",
  "BHARATI CHATUSPATHI SANSKRIT MAHAVIDYALAYA",
  "KRISHNANAGAR INSTITUTE OF MEDICAL SCIENCE ",
  "JIS SCHOOL OF MEDICAL SCIENCE AND RESEARCH",
  "TLM INSTITUTE OF HEALTH SCIENCES AND RESEARCH    ",
  "SANKARA NETHRALAYA ELITE SCHOOL OF OPTOMETRY    ",
  "Sagardighi Teachers Training College",
  "VIVODHANANDA SARASWATI NURSING INSTITUTE",
  "DSMS INSTITUTE OF NURSING",
  "Calcutta Institute of Science and Management 299",
  "RAMAKRISHNA VEDANTA MISSION TEACHERS ACADEMY",
  "Kaji Najrul Minority College of Education",
  "Aurangabad B.Ed. College",
  "Pandit Raghunath Murmu Teachers' Training College",
  "Pritilata Waddedar Mahavidyalaya",
  "AR MEMORIAL TEACHERS TRAINING INSTITUTE",
  "VIDYASAGAR COLLEGE OF EDUCATION FOR B.ED ADDI.COURSE",
  "Satish B. Ed. College",
  "SYAMSUNDAR COLLEGE",
  "GOVERNMENT COLLEGE OF NURSING MURSHIDABAD MEDICAL COLLEGE AND HOSPITAL ",
  "VIDYASAGAR PARAMEDICAL INSTITUTE",
  "DISHARI INSTITUTE OF PARAMEDICAL AND ALLIED HEALTH SCIENCE MALDA",
  "IQ CITY INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "SHELTER",
  "BAKSHIRHAT MAHAVIDYALAYA",
  "Narajole Raj College",
  "Pandaveswar College",
  "Milli-Al-Ameen College for Girls",
  "Vidyasagar Metropolitan College",
  "RAJGANJ COLLEGE",
  "College of Paramedical  and Allied Health sciences,WBUHS",
  "UNIVERSITY COLLEGE OF NURSING COM  AND  JNM HOSPITAL ,WBUHS,KALYANI,NADIA",
  "Simlapal College of Education,  Simlapal",
  "Variable Energy Cyclotron Centre (VECC),Kolkata",
  "College of Medicine and J N M Hospital, Kalyani",
  "Prabhanani Institute of Education (B.Ed. College)",
  "ALIPURDUAR MAHILA MAHAVIDYALAYA",
  "J.R.S.E.T. College of Education",
  "Bagchi Jamsherpur Namita-Sankar B.Ed. College",
  "BURDWAN RURAL MEDICAL TRAINING AND TREATMENT CENTER ",
  "YOGA SHRI YOGA AND NATUROPATHY GOVT MEDICAL COLLEGE AND HOSPITAL",
  "Netaji Subhas Chandra Bose Institute of Pharmacy 174",
  "Rani Dhanya Kumari College",
  "Kanchrapara College",
  "Asannagar Madan Mohan Tarkalankar College",
  "Dr. K.R. Adhikary College of Optometry & Paramedical Technology",
  "Raja Birendra Chandra College",
  "Panchthupi Haripada Gouribala College",
  "GOVERNMENT POLYTECHNIC DIGLIPUR ",
  "DR S RADHAKRISHNAN DISTRICT INSTITUTE OF EDUCATION AND TRAINING",
  "DR R S R SCHOOL OF NURSING, VEDAYAPALEM, NELLORE",
  "GOVERNMENT POLYTECHNIC SATYAVEDU",
  "NUZVID POLYTECHNIC",
  "SRI LAKSHMI SCHOOL OF NURSING, KURNOOL",
  "S S AND N SCHOOL OF NURSING",
  "AVANI SCHOOL OF NURSING, SRIKAKULAM",
  "S.S.V. School of Nursing, Innispeta, Rajahmundry",
  "ALURI SCHOOL OF NURSING, NEAR R.T.C. BUS STAND, PRAKASAM",
  "EMMI SCHOOL OF NURSING, PHIRANGIPURAM, GUNTUR",
  "ENLIGHT SCHOOL OF NURSING TRIUPATI",
  "ALWAR SCHOOL OF BUSINESS AND COMPUTERS",
  "ESC GOVT POLYTECHNIC NANDYAL",
  "FAITH SCHOOL OF NURSING, ANANTHAPUR",
  "FATIMA SCHOOL OF NURSING CUDDAPAH",
  "FLORENCE NIGHTINGALE SCHOOL OF NURSING, DEVI CHOWK, GUNTUR",
  "AMBEDKAR INSTITUTE OF MANAGEMENT STUDIES",
  "FLORENCE NIGHTINGALE SCHOOL OF NURSING EAST GODAWARI",
  "GIET Polytechnic College",
  "GIFFORD MEMORIAL HOSPITAL OF 7TH DAY ADVENTISTS KRISHNA",
  "AMG SATYAVEDAM SCHOOL OF NURSING, CHILAKALURIPET, GUNTUR",
  "AMG SATYAVEDAM SCHOOL OF NURSING, SEETHAMMADHARA, VISAKHAPATNAM",
  "GOVERNMENT GENERAL HOSPITAL, GUNTUR",
  "GOVERNMENT GENERAL HOSPITAL, KAKINADA, EAST GODAVARI",
  "GOVERNMENT GENERAL HOSPITAL KURNOOL",
  "GOVERNMENT INSTITUTE OF CHEMICAL ENGINEERING, VISAKHAPATNAM",
  "GOVERNMENT POLYTECHNIC, AMADALAVALASA",
  "GOVERNMENT POLYTECHNIC, ANAKAPALLI",
  "GOVERNMENT POLYTECHNIC, ANAPARTHI",
  "GOVERNMENT POLYTECHNIC, ATMAKUR",
  "GOVERNMENT POLYTECHNIC, DHARMAVARAM",
  "GOVERNMENT POLYTECHNIC, GANNAVARAM",
  "MADHURI SCHOOL OF NURSING, SHYAMALANAGAR, GUNTUR",
  "GOVERNMENT POLYTECHNIC, JANGAREDDYGUDEM",
  "GOVERNMENT POLYTECHNIC, KALIKIRI",
  "GOVERNMENT POLYTECHNIC, KANDUKUR",
  "MADHU SCHOOL OF NURSING PRAKASAM",
  "GOVERNMENT POLYTECHNIC, ADONI",
  "GOVERNMENT POLYTECHNIC PARVATHIPURAM",
  "GOVERNMENT POLYTECHNIC, PILLARIPATUU",
  "Prasanthi Polytechnic",
  "DILEEF SCHOOL OF NURSING NELLORE",
  "GOVERNMENT POLYTECHNIC, SIMHADRIPURAM",
  "GOVERNMENT POLYTECHNIC, TADEPALLIGUDEM",
  "GOVERNMENT POLYTECHNIC, URAVAKONDA",
  "GOVERNMENT POLYTECHNIC VEMPALLI",
  "MALYADRI SCHOOL OF NURSING, A.P.H.B. COLONY, NELLORE",
  "GOVT GENERAL HOSPITAL, VIJAYAWADA, KRISHNA",
  "GOVT.INST.CERAMIC TECHNOLOGY GUDUR",
  "MASS SCHOOL OF NURSING ANANTHAPUR-",
  "GOVT INST OF TEXTILE TECH. GUNTUR",
  "GOVT POLYTECHNIC ANANTHAPUR",
  "GOVT POLYTECHNIC FOR MINORITIES GUNTUR",
  "MBTS GOVT POLYTECHNIC GUNTUR",
  "GOVT POLYTECHNIC FOR MINORITIES KURNOOL",
  "GOVT POLYTECHNIC FOR WOMEN BHEEMUNIPATNAM",
  "GOVT POLYTECHNIC FOR WOMEN CUDDAPAH",
  "MOTHER CARE SCHOOL OF NURSING GUNTUR",
  "GOVT POLYTECHNIC FOR WOMEN NANDIGAMA",
  "MOTHER THERESA SCHOOL OF NURSING EAST GODAVARI",
  "GOVT POLYTECHNIC FOR WOMEN NELLORE",
  "Dr. YSR GOVERNMENT POLYTECHNIC, KALIDINDI",
  "MOTHER THERESA SCHOOL OF NURSING, KADAPA, CUDDAPAH",
  "DASARI SUBBA RAO GOVERNMENT POLYTECHNIC PONNUR",
  "Government Polytechnic College Narpala",
  "GOVT POLYTECHNIC FOR WOMEN PALAMANERU",
  "GOVT POLYTECHNIC FOR WOMEN SRIKAKULAM",
  "MOTHER THERESA SCHOOL OF NURSING KRISHNA",
  "GOVT POLYTECHNIC NARSIPATNAM",
  "GOVT POLYTECHNIC NELLORE",
  "MOTHER THERESA SCHOOL OF NURSING, VIZAG, VISAKHAPATNAM",
  "GOVT POLYTECHNIC PRODDATUR",
  "GEMS SCHOOL OF NURSING",
  "GOVT POLYTECHNIC SRIKAKULAM",
  "GOVT POLYTECHNIC VIJAYAWADA",
  "MOTHER VANNINI HOSPITAL WEST GODAWARI",
  "GOVT POLYTECHNIC VISAKHAPATNAM",
  "GRAVIS MEDI'S SCHOOL OF NURSING VISAKHAPATNAM",
  "G S L SCHOOL OF NURSING EAST GODAWARI",
  "M P R MEMORIAL SCHOOL OF NURSING, NADIKUDI, GUNTUR",
  "MRS A V N COLLEGE",
  "MSR SCHOOL OF NURSING, KADAPA, CUDDAPAH",
  "M S R SCHOOL OF NURSING, MAHARANI PET, VISAKHAPATNAM",
  "HARITHA SCHOOL OF NURSING, KAKINADA, EAST GODAVARI",
  "MURALI KRISHNA SCHOOL OF NURSING, VEDAYAPALEM, NELLORE",
  "NAGARJUNA SCHOOL OF NURSING KRISHNA",
  "INTEGRAL INSTITUTE OF ADVANCED MANAGEMENT (IIAM)",
  "JANAPRIYA SCHOOL OF NURSING, KAKINADA, EAST GODAVARI",
  "J D SCHOOL OF NURSING, KADAPA, CUDDAPAH",
  "JEEVAN JYOTHI HOSPITAL SCHOOL OF NURSING ANANTAPUR",
  "NARAYANA SCHOOL OF NURSING NELLORE",
  "KARUNA SCHOOL OF NURSING, TANUKU, WEST GODAVARI",
  "VKR & VNB POLYTECHNIC GUDIVADA",
  "V.P.R. Institute of Elementary Teacher Education, Rayavaram, Mydukur Raod, Proddutur, Kadapa",
  "YOUTH SCHOOL OF NURSING ANANTHAPUR",
  "VENKATA PADMA SCHOOL OF NURSING VIZIANAGARAM",
  "SRI VENKATESWARA INSTITUTE OF TRADITIONAL SCULPTURE AND ARCHITECTURE",
  "SHASHI SCHOOL OF NURSING KAKINADA",
  "AMBIKA SISHU KENDRA",
  "SRI RAMA BHADRA SCHOOL OF NURSING, BAPATLA, GUNTUR",
  "NATIONAL SCHOOL OF NURSING, ADONI, KURNOOL DISTRICT",
  "PHANI SCHOOL OF NURSING KRISHNA",
  "PARTHA SCHOOL OF NURSING, PARTHA CHARITABLE SOCIETY, CHITTOOR",
  "PADMAVATHI SCHOOL OF NURSING, MADHAVADARA, VISAKHAPATNAM",
  "PADMAVATHI SCHOOL OF NURSING, CHUMMUNIAPAT, CUDDAPAH",
  "KAKINADA INSTITUE OF TECHNOLOGICAL SCIENCES",
  "JYOTHI SCHOOL OF NURSING, TADEPALLIGUDEM, WEST GODAVARI",
  "SRI RAM SCHOOL OF NURSING, KAKINADA, EAST GODAVARI",
  "J S SCHOOL OF NURSING PRAKASAM",
  "RISE KRISHNA SAI POLYTECHNIC",
  "RIMS SCHOOL OF NURSING, ONGOLE, PRAKASAM",
  "GOVERNMENT POLYTECHNIC, ADDANKI",
  "R D T SCHOOL OF NURSING ANANTHAPUR",
  "CIPAI GOVINDA REDDY SCHOOLOF NURSING TRIUPATI",
  "CHUNDI RANGANAYAKULU POLYTECHNIC",
  "GMR POLYTECHNIC SRISAILAM",
  "CHRISTIAN SCHOOL OF NURSING KURNOOL",
  "GMR POLYTECHNIC GUMMA LAXMIPURAM",
  "CHANDRA SCHOOL OF NURSING GUNTUR",
  "CENTRE FOR MANAGEMENT AND TECHNOLOGY (CMT)",
  "SRI VENKATA PADMAVATHI SCHOOL OF NURSING CHITTOOR",
  "SAI KARUNA SCHOOL OF NURSING, PADAMATA (POST), KRISHNA",
  "SAI KRISHNA POLYTECHNIC",
  "S S S D GOVERNMENT POLYTECHNIC, CHINAMERANGI",
  "SAI KRUPA SCHOOL OF NURSING, KADAPA, CUDDAPAH",
  "SAI NIGHTINGALE SCHOOL OF NURSING, MACHERLA, GUNTUR",
  "ST ANN'S HOSPITAL SCHOOL OF NURSING KRISHNA",
  "SAI SADGURU SCHOOL OF NURSING RAJAHMUNDRY",
  "SAI SCHOOL OF NURSING, RAJAHMUNDARY, EAST GODAVARI",
  "SALVATION ARMY EVANGALINE BOOTH HOSP. GUNTUR",
  "SAMATHA SCHOOL OF NURSING KADAPA",
  "SANKETIKA POLYTECHNIC COLLEGE",
  "SANTHI SCHOOL OF NURSING, KAKINADA, EAST GODAVARI",
  "SAPTAGIRI SCHOOL OF NURSING CHITTOOR",
  "SARASWATHI SCHOOL OF NURSING, RAMARAOPET, EAST GODAVARI",
  "GMR POLYTECHNIC BHADRACHALAM",
  "SATYABHAMA SCHOOL OF NURSING KADAPA",
  "SATYA SCHOOL OF NURSING GUNTUR",
  "MRAGR GOVT POLYTECHNIC VIZIANAGARAM",
  "SEVEN HILLS HOSPITAL SCHOOL OF NURSING VISAKHAPATNAM",
  "SMT. T.K.R. POLYTECHNIC FOR WOMEN",
  "Sraddaha College of Diploma in Enggineering and Technology",
  "SRAVYA SCHOOL OF NURSING, PONNUR, GUNTUR",
  "GIRIJAS SCHOOL OF NURSING, GUDIWADA, KRISHNA",
  "SRI UMAMAHESWARA SCHOOL OF NURSING KURNOOL-",
  "BEHARA POLYTECHNIC",
  "SREE MULLAPUDI VENKATARAYA MEMORIAL POLYTECHNIC",
  "GIPDCE&T VISAKHAPATNAM",
  "GMR POLYTECHNIC PADERU",
  "GMR POLYTECHNIC MADANAPALLI",
  "BELLAMKONDA SUDHA SCHOOL OF NURSING, GIDDALUR, PRAKASAM",
  "BELLAMKONDA SUDHA SCHOOL OF NURSING, CUMBUM, PRAKASAM",
  "AAYUSHMAN INSTITUTE OF PARAMEDICAL SCIENCES",
  "SOWMYA SCHOOL OF NURSING BUCHIREDDYPALEM SPS NELLORE DISTRICT",
  "VSM INSTITUTE OF PARAMEDICAL SCIENCES",
  "MEDI INSTITUTE OF MEDICAL SCIENCES",
  "SREE JEEVANA JYOTHI ALLIED AND HEALTHCARE INSTITUTION, GIDDALUR",
  "RAMESH INSTITUTE OF MEDICAL SCIENCES, ONGOLE",
  "ADITYA PARAMEDICAL COLLEGE, YERRAGODNAPALEM",
  "SRI GOWTHAM ALLIED AND HEALTH CARE INSTITUTION, CUMBUM",
  "SRIDEVI PARAMEDICAL TRAINING INSTITUTE",
  "SRI MAHALAKSHMI INSTITUTE OF PARAMEDICAL SCIENCES, SANTAKAVITI",
  "NIVYA PARA MEDICAL COLLEGE, RAJAHMUNDRY",
  "JYOTHI INSTITUTE OF PARAMEDICAL SCIENCES, JADEPALLIGUDEM",
  "Vellore Institute of Technology-Andhra Pradesh(VIT-AP), Amaravti",
  "GOVERNMENT DIPLOMA IN EDUCATION COLLEGE AT ITDA       RAMPACHODAVARAM, EAST GODAVARI TRIBAL AREA",
  "COMPOSITE REGIONAL CENTRE NELLORE ",
  "SRI CHAITANYA PARAMEDICAL COLLEGE",
  "SWAMY  SCHOOL OF NURSING",
  "APOLLO PARAMEDICAL COLLEGE",
  "GOVT MODEL RESIDENTIAL POLYTECHNIC SEETAMPET",
  "VIJAYKRISHNA PARAMEDICAL COLLGE",
  "SRI KATYAYANI PARAMEDICAL COLLEGE",
  "VICTORIA INSTITUTE OF PARAMEDIAL SCIENCES",
  "SRINIVASA DIPLOMA IN ENGINEERING AND TECHNOLOGY",
  "OXFORD SCHOOL OF NURSING, CHIRALA, PRAKASAM DISTRICT",
  "CHARITHA SCHOOL OF NURSING, SURYARAOPET, KRISHNA",
  "SWATHI SCHOOL OF NURSING",
  "KOTA REDDY SCHOOL OF NURSING",
  "Government Polytechnic Rayadurg",
  "Kavitha School of Nursing",
  "Vikas Polytechnic College",
  "K C Reddy School of Nursing",
  "SRI KRISHNA SCHOOL OF NURSING CHITTOOR",
  "Government Polytechnic Tekkali",
  "APOLLO PARAMEDICAL COLLEGE",
  "CHANDRA  PARAMEDICAL COLLEGE ",
  "SRIDEVI PARAMEDICAL COLLEGE ",
  "SATYA DEVA INSTITUTE OF PARAMEDICAL TECHNOLOGY",
  "CENTRAL INSTITUTE OF PLASTICS ENGINEERING AND TECHNOLOGY VIJAYAWADA",
  "RAJAVARDHAN COLLEGE OF PARAMEDICAL SCIENCES",
  "SRI VENKATESWARA SCHOOL OF NURSING",
  "AMRITA SAI INSTITUTE OF SCIENCE  AND TECHNOLOGY",
  "ST MARYS PARAMEDICAL COLLEGE",
  "SRI SURYA SCHOOL OF NURSING, RAJAHMUNDRY",
  "R R PARAMEDICAL COLLEGE",
  "ANAND PARAMEDICAL COLLEGE, GANNAVARAM",
  "SRI SAI COLLEGE OF HEALTH SCIENCES, ONGOLE, PRAKASAM",
  "AKSHAY INSTITUTE OF PARAMEDICAL SCIENCE",
  "VEDA PRAKASH PARAMEDICAL COLLEGE",
  "Medarametla Anjamma Mastan Rao College of Education (D.El.Ed)",
  "GOVERNMENT POLYTECHNIC, REPALLE",
  "SARA SCHOOL OF NURSING, SIDDARDHA NAGAR, EAST GODAVARI",
  "PRABHU SCHOOL OF NURSING NELLORE",
  "MOTHER THERESA MPHA (M) TRAINING INSTITUTE",
  "AVANTHI POLYTECHNIC COLLEGE",
  "DR.B.R.A.G.M.R.POLYTECHNIC",
  "BELLAMKONDA POLYTECHNIC COLLEGE",
  "VICTORIA PARAMEDICAL SCIENCES  NANDIGAMA",
  "STATE INSTITUTE OF HOTEL MANAGMENT TIRUPATI",
  "ADITYA GLOBAL BUSINESS SCHOOL",
  "RATNA PARAMEDICAL INSTITUTE , KOYYALAGUDEM",
  "Indira School of Nursing, Sethampet, Visakhapatnam",
  "AMRUTHA SCHOOL OF NURSING, PENDURTHI, VISAKHAPATNAM",
  "SARADA SCHOOL OF NURSING, MANDAPETA, EAST GODAVARI DISTRICT",
  "JESUS MARIAN SCHOOL OF NURSING",
  "ONGOLE SCHOOL OF NURSING",
  "GOVERNMENT POLYTECHNIC, PITHAPURAM-533450,",
  "TANVI SCHOOL OF NURSING, PIDUGURALLA, GUNTUR DISTRICT",
  "K.P.K School of Nursing, LIC Colony, Anantapur",
  "SRI SURYA INSTITUTE OF TECHNOLOGY AND SCIENCES",
  "SRI JYOTHI COLLEGE OF COLLEGE OF MEDICAL TECHNOLOGY, JANGAREDDYGUDEM, ELURU DISTRICT",
  "ST. JOHNS INSTITUTE OF MEDICAL TECHNOLOGY",
  "THAMMINENI PRIVATE PARAMEDICAL INSTITUTE",
  "VIJAYAWADA COLLEGE OF MEDICAL TECHNOLOGY",
  "PARAMESWARI COLLEGE OF PARA MEDICAL TECHNOLOGICAL SCIENCES , ONGOLE ",
  "PARAMESWARI COLLEGE OF PARAMEDICAL SCIENCES , ONGOLE",
  "SARADA SCHOOL OF NURSING MEDARAMETLA",
  "SRI VENKATESWARA SCHOOL OF NURSING, KOLLIPARA, GUNTUR",
  "KONDAVEETI SCHOOL OF NURSING",
  "GRAMEENA SCHOOL OF NURSING",
  "SUBHODAYA INSTITUTE OF PARAMEDICAL SCIENCES, NELLORE",
  "PUTTAPARTHI INSTITUTE OF MEDICAL SCIENCES AND TECLNOLOGY",
  "BOLLINENI MEDSKILLS PARAMEDICAL INSTITUTION",
  "BOLLINENI MEDSKILLS PARAMEDICAL INSTITUTION",
  " KRUPA PARAMEDICAL INSTITUTE, PALAKOLLU, WEST GODAVARI DISTRICT ",
  "SIKINDER MOHASEEN (SM) SCHOOL OF NURSING",
  "YASHODA SCHOOL OF NURSING,ELWINPET, KAKINADA, EAST GODAVARI DISTRICT",
  "SIDDARTHA SCHOOL OF NURSING, GANDHI NAGAR, KAKINADA, EAST GODAVARI DISTRICT",
  "GLOBAL SCHOOL OF NURSING, VENKATESWARA NAGAR, VISAKHAPATNAM",
  "THE COLLEGE OF MEDICAL TECHNOLOGY PRAKASAM DISTRICT",
  "SRI VENKATESWARA SCHOOL OF NURSING, GUNTUR",
  "Rathnamma School of Nursing",
  "Government Polytechnic Chodavaram",
  "INDIAN CULINARY INSTITUTE",
  "AMERICAN SCHOOL OF NURSING, ANANTAPUR",
  "GOVERNMENT POLYTECHNIC PENDURTHI",
  "SAI RANGA POLYTECHNIC",
  "ST MOTHER THERESA SCHOOL OF NURSING",
  "INDIAN INSTITUTE OF TOURISM AND TRAVEL MANAGEMENT",
  "EMMANUEL SCHOOL OF NURSING SANTHI NAGAR KAKINADA",
  "CHAITANYA SCHOOL OF NURSING ONGOLE PRAKASAM DISTRICT",
  "HARSHA INSTITUTE OF PARA MEDICAL SCIENCES, CUMBUM, PRAKASAM DISTRICT",
  "KBR SCHOOL OF NURSING",
  "ADITYA INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "THAMMINENI INSTITUTE OF MEDICAL SCIENCES",
  "DR ANJIREDDY INSTITUTE OF PARAMEDICAL SCIENCES",
  "SUBHADRA INSTITUTE OF PARAMEDICAL SCIENCES, BALAGA, SRIKAKULAM",
  "SWETHA MPHA (MALE) TRAINING INSTITUTE",
  "SRI SAI COLLEGE OF MEDICAL LAB TECHNOLOGY",
  "AMARAVATHI SCHOOL OF NURSING ATCHUTAPURAM KAKINADA",
  "SRI KAMAKSHITHAI INSTITUTE OF MEDICAL LAB TECHNOLOGY B V NAGAR NELLORE",
  "KITES PARAMEDICAL INSTITUTE, SARADA COLONY",
  "VISWAVANI SCHOOL OF NURISNG KURNOOL",
  "VARALAXMI SCHOOL OF NURSING, KADAPA, CUDDAPAH",
  "LAVANYA SCHOOL OF NURSING, KAKINADA, EAST GODAVARI",
  "ENNOBLE SCHOOL OF NURSING , NARSIPATNAM",
  "VASANTHA LAKSHMI SCHOOL OF NURSING, NELLORE",
  "PALLAVAI SCHOOL OF NURSING, VEDAYAPALEM, NELLORE",
  "TVR POLYTECHNIC",
  "SRI VENKATARAMANA SCHOOL OF NURSING, TANUKU, WEST GODAVARI",
  "AROGYAVARAM MEDICAL CENTRE AROGYAVARAM",
  "SRI VENKATA RAMANA SCHOOL OF NURSING, RAMNAGAR, PRAKASAM",
  "ARIES POLYTECHNIC COLLEGE",
  "ANNAPURNA SCHOOL OF NURSING, PALAKOL MANDAL, WEST GODAVARI",
  "SRI PADMAVATHI WOMEN'S POLYTECHNIC",
  "SRI PADMAWATI SCHOOL OF NURSING ANANTAPUR",
  "SAVEERA PARAMEDICAL IINSTITUTION",
  "PRAGATHI SCHOOL OF NURSING, PATAMATALANKA, KRISHNA",
  "SRI SAPTHA JYOTHI SCHOOL OF NURSING, GUNTAKAL, ANANTHAPUR",
  "GOVERNMENT POLYTECHNIC GUNTAKAL",
  "SRI SAI SCHOOL OF NURSING PRAKASAM",
  "PREMA SCHOOL OF NURSING, MAHARANIPET, VISAKHAPATNAM",
  "SRI SAI KRISHNA SCHOOL OF NURSING NELLORE",
  "SRI SAI SCHOOL OF NURSING GUNTUR",
  "PRIYADARSHINI SCHOOL OF NURSING EAST GODAVARI",
  "SHRI VIJAYA JYOTHI COLLEGE OF NURSING",
  "KONDRAGUNTA SCHOOL OF NURSING, KALIDASVARI VEEDHI, PRAKASAM",
  "KRISHNAVENI PARA MEDICAL COLLEGE, NARASARAOPET, GUNTUR DISTRICT",
  "SRI VIJAYALAKSHMI EDUCATIONAL SOCIETY LAB TECHNICIAN TRAINING CENTRE, KURNOOL",
  "SRI VASAVI PARAMEDICAL COLLEGE, PRODDATUR ",
  "PRASANTHI PARAMEDICAL INSTITUTE, BHIMAVARAM",
  "VIKAS PHARMACY COLLEGE",
  "FLORENCE NIGHTINGALE SCHOOL OF NURSING KRISHNA",
  "SRI GAYATHRI PARAMEDICAL INSTITUTE, BHIMAVARAM",
  "VISWASAI SCHOOL OF NURSING, KOVVUR, WEST GODAVARI",
  "KARUNA SCHOOL OF NURSING, PALLAMRAJU NAGAR, EAST GODAVARI",
  "GOVT POLYTECHNIC FOR WOMEN HINDUPUR",
  "SVES X RAY TECHNICIAN TRAINING CENTRE KURNOOL,",
  "VIKAS POLYTECHNIC COLLEGE, VISSANNAPETA",
  "PADMA TEJ AND BHAVYA TEJ COLLEGE OF HEALTH SCIENCES",
  "SIDDHARDHA PARAMEDICAL INSTITUTE",
  "TRINITY INSTITUTE OF HEALTHCARE SCIENCES",
  "ZEENATH AND HAMMUBI ELEMENTARY TEACHER TRAINING INSTITUTION",
  "NATIONAL  INSTITUTE  OF  MEDICAL SCIENCES ",
  "SRI VENKATESWARA MPHW (F) TRAINING INSTITUTE",
  "SRI GAYATRI PARAMEDICAL INSTITUTE, GOLLALAKODERU, PALAKODERU",
  "SRI LAKSHMINARAYANA PARAMEDICAL TRAINING INSTITUTE, PUTTUR",
  "SVCM Institution of Elementary Teacher Education",
  "SRI VASAVI PARAMEDICAL COLLEGE",
  "SRI VENKATESWARA SCHOOL OF NURSING",
  "SRI GEETHA PARAMEDICAL COLLEGE ",
  "SRI DURGA SCHOOL OF NURSING PRAKASAM",
  "SRI SAI BALAJI PARAMEDICAL COLLEGE, ONGOLE",
  "MSME TECHNOLOGY CENTRE",
  "S.V.C.M. POLYTECHNIC BADVEL",
  "SRI SAI BALAJI PARAMEDICAL COLLEGE, DARSI",
  "ARUN KIDNEY PARAMEDICAL COLLEGE",
  "KV INSTITUTE OF MEDICAL TECHNOLOGY",
  "R K PARAMEDICAL INSTITUTIONS",
  "EMMANUEL PARAMEDICAL COLLEGE",
  "SRI GNANA PRASUNAMBIKA SCHOOL OF NURSING CHITTOOR",
  "SATYA SRI PARAMEDICAL COLLEGE",
  "ARUNODAYA SCHOOL OF NURSING",
  "SWAMY SCHOOL OF NURSING GUNTUR",
  "Kasturba School of Nursing, Narsapuram, West Godavari District",
  "SRI SAI COLLEGE OF HEALTH SCINCE, ONGOLE",
  "SRI SURYA INSTITUTE OF HEALTH SCIENCE",
  "HARIKA COLLEGE OF PARAMEDICAL SCIENCES",
  "SRI SRINIVASA INSTITUTE OF MEDICAL SCIENCES",
  "PRASANTHI SCHOOL OF NURSING PRATHIPADU",
  "VARAHI SCHOOL OF NURSING",
  "RAGHAVA M.P.H.A(M) TRAINING INSTITUTE",
  "MOTHER SCHOOL OF NURSING, BHIMAVARAM",
  "PRAVEE INSTITUTE OF PARAMEDICAL SCIENCES",
  "GENIOUS COLLEGE OF PARAMEDICAL SCIENCES, TENALI, GUNTUR DISTRICT",
  "SRI DEEPTHI SCHOOL OF NURSING",
  "AYYAVARU REDDY MEMORIAL SCHOOL OF NURSING, KADAPA, CUDDAPAH",
  "NIRMALA SCHOOL OF NURSING ANANTHAPUR",
  "A.V.N.POLYTECHNIC",
  "ASWINI SCHOOL OF NURSING, MANGALAGIRI ROAD, GUNTUR",
  "ASHAM SCHOOL OF NURSING, MARKAPUR, PRAKASAM",
  "P N C AND K R SON, NARASARAOPET, GUNTUR",
  "SRI PADMAVATHI SCHOOL OF NURSING NELLORE",
  "VIJETHA VISWA VIDYANIKETH",
  "RVS SCHOOL OF NURSING, CHITTOOR",
  "GOVERNMENT POLYTECHNIC, MYDUKUR",
  "SRI VENKATESHWARA SCHOOL OF NURSING CHITTOOR",
  "NATIONAL SCHOOL OF NURSING, KAKINADA",
  "SRI PADMAVATHI SCHOOL OF NURSING, ANANTHAPUR",
  "JEEVANJYOTHI SCHOOL OF NURSING, CHINARAVURU, TENALI, GUNTUR DISTRICT",
  "SWATANTRA SCHOOL OF NURSING EAST GODAVARI",
  "SRI G PULLA REDDY GOVERNMENT POLYTECHNIC",
  "VENKATESWARA INSTITUTE OF MEDICAL SCIENCES",
  "SMT SWARASWATHAMMA SCHOOL OF NURSING",
  "S.V.GOVERNMENT POLYTECHNIC, TIRUPATHI",
  "SOFY INSTITUTE OF PARA MEDICAL SCIENCES, MADANAPALLE",
  "AJ INSTITUTE OF PARAMEDICAL SCIENCES",
  "AZAD COLLEGE OF MEDICAL HEALTH SCIENCES",
  "GOVERNMENT POLYTECHNIC, BETHAMCHERLA",
  "RAJU PARAMEDICAL TRAINING INSTITUTE",
  "SRI KRISHNA CHAITANYA COLLEGE OF PARAMEDICAL SCIENCES",
  "RAVI CHANDRA INSTITUTE OF MEDICAL TECHNOLOGY",
  "USHA SCHOOL OF NURSING KRISHNA",
  "VANI SCHOOL OF NURSING, CO-OPERATIVE COLONY, CUDDAPAH",
  "VARDHAN SCHOOL OF NURSING KRISHNA",
  "SRI HARSHA SCHOOL OF NURSING KURNOOL",
  "VASAVI POLYTECHNIC BANAGANANPALLI",
  "VEDHA SCHOOL OF NURSING, L.S. NAGAR, CHITTOOR",
  "SRI KRISHNA CHAITANYA SCHOOL OF NURSING, PRASANTHNAGAR, CHITTOOR",
  "SEEDS INSTITUTE OF MEDICAL LAB TECHNOLOGY",
  "BVC COLLEGE OF ENGINEERING",
  "STAR INSTITUTE OF PARA MEDICAL SCIENCES",
  "G.B.R Government Polytechnic Chipurupalli",
  "SRI LAKSHMI SCHOOL OF NURSING GUNTUR",
  "SURYA MPHW (M) TRAINING INSTITUTE, KURNOOL ROAD, ONGOLE",
  "SRI SAI BHAVANI SCHOOL OF NURSING, BRODIPET, GUNTUR",
  "SRI RAMYA SAI SCHOOL OF NURSING, GUNTAKAL, ANANTAPUR DISTRICT",
  "BALAJI INSTITUTE OF PARAMEDICAL SCIENCES",
  "BHARGAVI SCHOOL OF NURSING, CHERUVUKOMMUPALEM, ONGOLE, PRAKASAM DISTRICT",
  "NIGHTINGALE SCHOOL OF NURSING SABBAVARAM",
  "LOKESH SCHOOL OF NURSING, KURNOOL",
  "SUN RISE SCHOOL OF NURSING, EAST GUDUR, GUDUR",
  "VARSHINI SCHOOL OF NURSING, NARASANNAPETA, SRIKAKULAM DISTRICT",
  "VIJAYA INSTITUTE OF MEDICAL SCIENCES SCHOOL OF NURSING, KRISHNA",
  "VIJAYA SCHOOL OF NURSING, GREAMSPET, CHITTOOR",
  "VIJAYA SCHOOL OF NURSING GUNTUR",
  "SRI SATYA SAI INSTITUTE OF HEALTH SCIENCES, DARIMADUGU, MARKAPUR",
  "VIJAYA SCHOOL OF NURSING NELLORE",
  "VIJAY INSTITUTE OF NURSING SCIENCES, SRIKAKULAM",
  "VIJAY SCHOOL OF NURSING KRISHNA",
  "VIKRANTH SCHOOL OF NURSING, KRANTHI EDUCATIONAL SOCIETY, SRIKAKULAM",
  "VIMALA SCHOOL OF NURSING ANANTAPUR",
  "AMAR SCHOOL OF NURSING, AMARAVATHI",
  "VISAKHA SCHOOL OF NURSING VISAKHAPATNAM",
  "VISHWA BHARATHI SCHOOL OF NURSING KURNOOL",
  "KAUMUDI SCHOOL OF NURSING, KOTHAVALASA, VIZAYANAGARAM DISTRICT",
  "SRI VIKAS INSTITUTE OF MEDICAL SCIENCES",
  "JAYALAKSHMI INSTITUTE OF PARAMEDICAL SCIENCES",
  "ROHI PARAMEDICAL INSTITUTE, ROYAPETA, NARASAPURAM",
  "SRINIVASA INSTITUTE OF MEDICAL TECHNOLOGY VIJAYAWADA NTR DISTRICT",
  "MEDARAMETLA ANJAMMA MASTAN RAO PARAMEDICAL COLLEGE",
  "SATYA SAI COLLEGE OF MEDICAL AND HEALTH SCIENCES",
  "PH COLLEGE OF HEALTH SCIENCES",
  "GAYATRI SCHOOL OF NURSING PALAKONDA SRIKAKULAM DISTRICT",
  "ST JOSEPHS GENERAL HOSPITAL GUNTUR",
  "SRI SEVEN HILLS SCHOOL OF NURSING VISAKHAPATNAM",
  "VIJAYAM INSTITUTE OF TECHNOLOGY",
  "SRI PADMAVATHI SCHOOL OF NURSING KADAPA",
  "GOVERENMENT POLYTECHNIC, KAMALAPURAM",
  "SSR PARAMEDICAL COLLEGE",
  "SRI PADMAVATHI, SCHOOL OF NURSING, NARAYANAVARAM, CHITTOOR",
  "R. S. SCHOOL OF NURSING",
  "ORTUS SCHOOL OF NURSING, PENDURTHY, VISAKHAPATNAM",
  "GOVERNMENT POLYTECHNIC,ALUR",
  "VEDA SCHOOL OF NURSING, SATTENAPALLI, GUNTUR DISTRICT",
  "CHIRALA SCHOOL OF NURSING, CHIRALA, PRAKASAM DISTRICT",
  "GOVERNMENT POLYTECHNIC KADIRI",
  "LAKSHMI SURYA NURSING SCHOOL, YKM COLONY,  PARVATHIPURAM, VIZIANAGARAM DISTRICT",
  "SANTHIRAM INSTIUTE OF PARAMEDICAL SCIENCES,NANDYAL",
  "GOVT.POLYTECHNIC,RAJAMPETA",
  "BEHARA TECHNICAL CAMPUS(BEHARA POLYTECHNIC)",
  "GOVERNMENT MODEL RESIDENTIAL POLYTECHNIC JAGARAMPALLI RAMPACHODAVARAM",
  "BEHARA SCHOOL OF NURSING",
  "KITES SCHOOL OF NURSING",
  "JYOTHI MULTIPURPOSE HEALTH WORKERS (FEMALE) TRAINING INSTITUTE",
  "MOTHER INSTITUTE OF MEDICAL TECHNOLOGY",
  "swamy vivekananda polytechnic",
  "Chaitanya Bharathi Institute of Technology (Polytechnic)",
  "SVES MALE NURSING COLLEGE , KURNOOL, ",
  "SUVR & SR GOVT POLYTECHNIC FOR WOMEN ETHAMUKKALA",
  "Gouthami Institute of Technology and Management for Women (2nd Shift Polytechnic College)",
  "ST ANNS COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "GOVERNMENT POLYTECHNIC, DRAKSHARAMAM",
  "SIR C.R. REDDY POLYTECHNIC ELURU",
  "MOTHER SCHOOL OF NURSING DHARMASAGARAM VILLAGE NARSIPATNAM MANDAL",
  "SRI YVS & SRI BRM POLYTECHNIC",
  "GOVT. POLYTECHNIC CHANDRAGIRI",
  "MADDALA RAMAKRISHNAMMA POLYTECHNIC",
  "PRAGATHI POLYTECHNIC COLLEGE",
  "government polytechnic, jammalamadugu",
  "MVR College of Engg and Tech, Shift-II Polytechnic, Paritala,Kanchikacherla Mandal",
  "ARYABHATTA POLYTECHNIC COLLEGE",
  "SATYA SRI SCHOOL OF NURSING, KAKINADA",
  "BOTHCHU RAMBHOTLU AND DHANA LAKSHMI SCHOOL OF NURSING",
  "Jhansi Collge of Education (D.El.Ed), Prakasam",
  "BUDDALA NARASIMHA MURTHY AGRICULTURAL POLYTECHNIC",
  "SAI LAKSHMI SCHOOL OF NURSING",
  "BEHARA SUBHAKAR POLYTECHNIC",
  "SAI SRI INSTITUTE OF ALLIED HEALTH SCIENCES",
  "SRI LAKSHMI GAYATHRI SCHOOL OF NURSING, KAKINADA",
  "MOTHER THERESA PARA MEDICAL TECHNOLOGY",
  "VENKATESA SCHOOL OF NURSING, MANDAPETA",
  "SVKP POLYTECHNIC CUMBUM",
  "PRASANTHI SCHOOL OF NURSING",
  "LOYOLA POLYTECHNIC PULLUVENDLA",
  "T.G.L. POLYTECHNIC ADONI",
  "DR. Y .C. JAMES YEN GOVERNMENT POLYTECHNIC. KUPPAM",
  "THANDRA PAPARAYA POLYTECHNIC BOBBILI",
  "BAPATLA POLYTECHNIC BAPATLA",
  "AVYA PARAMEDICAL COLLEGE, HUKUMPETA, RAJAMANENDRAVARAM",
  "THE RAJIV GANDHI RECS POLYTECHNIC,KASIMKOTA",
  "ASSRAM SCHOOL OF NURSING, MALKAPURAM, WEST GODAVARI",
  "SUSEELA SCHOOL OF NURSING, BAPATLA, GUNTUR",
  "T I M S SCHOOL OF NURSING, GANNAVARAM, KRISHNA",
  "TIRUMALA SCHOOL OF NURSING VIZIANAGARAM",
  "TIRUPATHI SCHOOL OF NURSING, CHITTOOR",
  "T.M. POLYTECHNIC CUDDAPAH",
  "SURYA SCHOOL OF NURSING, NIDADOVOLLU, WEST GODAVARI",
  "ROYAL SCHOOL OF NURSING, KAKINADA",
  "SUPRIYA SCHOOL OF NURSING, RAMARAOPET, EAST GODAVARI",
  "ARROW COLLEGE OF PARAMEDICAL SCIENCES, VIJAYAWADA",
  "SRI JYOTHI POLYTECHNIC",
  "SUJATHA SCHOOL OF NURSING EAST GODAVARI",
  "ST LUKE' S SCHOOL OF NURSING TRG. VISAKHAPATNAM",
  "GOVERNMENT POLYTECHNIC, RAYACHOTY",
  "SUDHA SCHOOL OF NURSING EAST GODAVARI",
  "SANTI PARAMEDICAL TRAINING INSTITUE, AMALAPURAM",
  "ALWARDAS POLYTECHNIC COLLEGE",
  "BOLLINENI MEDSKILLS PARAMEDICAL INSTITUTION",
  "KES POLYTECHNIC",
  "K V R INSTITUTE OF PARAMEDICIAL SCIENCES SCHOOL OF NURSING, PENAMALURU, KRISHNA",
  "ANDHRA POLYTECHNIC KAKINADA",
  "EMANUEL SCHOOL OF NURSING, MAKAVARAPALEM, VISAKHAPATNAM",
  "NAVA PRAHARSHA INSTITUTE OF MEDICAL TECHNOLOGY",
  "SATYA SAI INSTITUTE OF PARAMEDICAL TECHNOLOGY",
  "SMT. B. SEETHA POLYTECHNIC VISHNUPUR BHIMAVARAM",
  "R S INSTITUTE OF PARAMEDICAL SCIENCES ADONI",
  "CHRISTIAN MEDICAL CENTRE EAST GODAWARI",
  "VIJENDRA INSTITUTE OF MEDICAL TECHNOLOGY",
  "K H K SCHOOL OF NURSING, SANA STREET, SRIKAKULAM",
  "KAVURI SUBBA RAO SCHOOL OF NURSING GUNTUR",
  "NARAYANA SCHOOL OF NURSING SRIKAKULAM",
  "DR. PINNAMANENI SIDDHARTHA INSTT OF MEDICAL SC. KRISHNA",
  "AL-HUDA POLYTECHNIC NELLORE",
  "SANTHI SCHOOL OF LAB TECHNICIAN TRAINING ",
  "DR PAULRAJ SCHOOL OF NURSING, NANDULPET, GUNTUR",
  "GOVERNMENT POLYTECHNIC, KALYANDURG, ANANTAPUR",
  "HELP SCHOOL OF NURSING, KETHANAKONDA, NTR DISTRICT",
  "DR B V SYAMALA RATNAM SCHOOL OF NURSING ANANTAPUR",
  "DIVI SEEMA POLYTECHNIC AVANIGADDA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) WEST GODAVARI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) NELLORE",
  "DISTRICT HOSPITAL SCHOOL OF NURSING, ELURU, WEST GODAVARI",
  "D G R SCHOOL OF NURSING, HARANATHPURAM, NELLORE",
  "SIVA SAI SCHOOL OF NURSING EAST GODAVARI",
  "DEEPIKA SCHOOL OF NURSING, TIRUPATHI, CHITTOOR",
  "GOVERNMENT POLYTECHNIC KAVALI",
  "ST JOSEPH'S SCHOOL OF NURSING MAHARANIPETA VISAKHAPATNAM",
  "D D R SCHOOL OF NURSING VISAKHAPATNAM",
  "ST JOSEPH'S SCHOOL OF NURSING GUNTUR",
  "ST JOSEPH'S HOSPITAL SCHOOL OF NURSING VISAKHAPATNAM-",
  "DA GOVT POLYTECHNIC ONGOLE",
  "SIR C V RAMAN POLYTECHNIC",
  "C S I SCHOOL OF NURSING KADAPA",
  "S I M S SCHOOL OF NURSING GUNTUR",
  "NARAYANA POLYTECHNIC",
  "CHARLES PAUL SCHOOL OF MEDICAL LAB TECHNOLOGY ",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) ANGALURU KRISHNA",
  "CRESCENT SCHOOL OF NURSING KADAPA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) CHITTOOR",
  "A E L C SCHOOL OF NURSING PRAKASAM",
  "COL. D.S. RAJU POLYTECHNIC PODURU",
  "DR ANJIREDDY SCHOOL OF NURSING",
  "DR B S R SCHOOL OF NURSING, THYAGARAYANAGARA, NELLORE",
  "DR P V RAMACHANDRA REDDY'S PEOPLES POLYCLINIC NELLORE",
  "AECS APARNA SCHOOL OF NURSING TIRUPATI",
  "DR RAJASEKHAR REDDY SCHOOL OF NURSING NELLORE",
  "DR SAMUEL GEORGE INSTITUTE OF ENGINEERING & TECHNOLOGY",
  "ADITYA SCHOOL OF NURSING, KADAPA, CUDDAPAH",
  "FLORENCE NIGHTINGALE SCHOOL OF NURSING, RAJAM, SRIKAKULAM",
  "GANESH SCHOOL OF NURSING, GUDIWADA, KRISHNA",
  "ADITYA SCHOOL OF NURSING EAST GODAWARI",
  "GBR Elementary  Teacher Education, Anaparthy, East Godavari District - 533 342",
  "BOLLINENI SCHOOL OF NURSING NELLORE",
  "G B R SCHOOL OF NURSING, ANANPARTHI, EAST GODAVARI",
  "SATYA INSTITUTE OF PARAMEDICAL TECHNOLOGY",
  "G K REDDY SCHOOL OF NURSING, CHITTOOR",
  "ADDANKI PRABHUDAS AND SUJANAMMA MEMORIAL SCHOOL OF NURSING, OGMOJI CAMPUS, 31-1-35 AM TRUNK ROAD, PRAKASAM",
  "GLOBAL SCHOOL OF NURSING, VIJAYAWADA, KRISHNA",
  "ST ANN'S SCHOOL OF NURSING VISAKHAPATNAM-",
  "BLESS SCHOOL OF NURSING, PADMAVATHI COLONY, CHITTOOR",
  "GOVERNMENT POLYTECHNIC, KROSUR",
  "GOVERNMENT POLYTECHNIC, MACHILIPATNAM",
  "BHASKARA POLYTECHNIC",
  "GOVERNMENT POLYTECHNIC, MADAKASIRA, ANANTAPUR",
  "GOVT POLYTECHNIC FOR WOMEN GUNTUR",
  "SRI TEJA PARAMEDICAL TRAINING INSTITUTE, K. AGRAHARAM AMALAPURAM",
  "GOVT POLYTECHNIC FOR WOMEN KAKINADA",
  "GOVT POLYTECHNIC GUDUR",
  "KONASEEMA SCHOOL OF NURSING, AMMALAPURAM, EAST GODAVARI",
  "KRISHNAVENI SCHOOL OF NURSING, NARASARAOPET, GUNTUR",
  "LAZARUS SCHOOL OF NURSING VISAKHAPATNAM",
  "MEGHANA SCHOOL OF NURSING, SAJJAPURAM, WEST GODAVARI",
  "SRI ADISIVA SADGURU ALLI SAHEB SIVARYULE SCHOOL OF NURSING, GUNTAKAL, ANANTHAPUR",
  "M I M S SCHOOL OF NURSING VIZIANAGARAM",
  "MINERVA SCHOOL OF NURSING VISAKHAPATNAM",
  "M K SCHOOL OF NURSING VISAKHAPATNAM",
  "MOHAN TEACHER TRAINING INSTITUTE MOHAN EDUCATIONAL SOCIETY EAST GODAVARI",
  "MULAGONDLA PAKIRA REDDY MEMORIAL POLYTECHNIC",
  "SRI BHARGAVI SCHOOL OF NURSING NELLORE",
  "RAGHAVA SCHOOL OF NURSING, RAMA RAO PET, EAST GODAVARI",
  "SRI BHARGAVI SCHOOL OF NURSING PRAKASAM",
  "Sri Buchepalli Venkayamma Subbareddy College of Education (D.Ed.), Gandhi nagar,  Chimakurthy, Prakasam District - 523226.",
  "RAMAKRISHAN SCHOOL OF NURSING EAST GODAVARI",
  "SRI CHAITANYA POLYTECHNIC COLLEGE",
  "R R CHRISTIAN SCHOOL OF NURSING KURNOOL",
  "RV SCHOOL OF NURSING, MUMMIDIVARAM, EAST GODAVARI",
  "SAGARA DURGA SCHOOL OF NURSING VISAKHAPATNAM",
  "SRI VASAVI INSTITUTE OF ENGINEERING & TECHNOLOGY",
  "SAI BHARGAVI SCHOOL OF NURSING, NELLORE",
  "SAI GANAPATHI POLYTECHNIC",
  "BHARGAVI SCHOOLOF NURSING KURNOOL",
  "BHARAT SCHOOL OF NURSING EAST GODAWARI",
  "SRUTHI SCHOOL OF NURSING GUNTUR",
  "SRI Y V S & B R M SCHOOL OF NURSING EAST GODAVARI",
  "AANM & VVRSR POLYTCHNIC",
  "BHARATHI SCHOOL OF NURSING PRAKASAM",
  "KIMS SCHOOL OF NURSING, AMALAPURAM, EAST GODAVARI",
  "KING GEORGE HOSPITAL SCHOOL OF NURSING VISAKHAPATNAM",
  "ST MARYS SCHOOL OF NURSING, KOVVUR, WEST GODAVARI",
  "SYSTEM PARAMEDICAL SCIENCES, PONDURU",
  "SIDDARTHA SCHOOL OF NURSING, CHAITANYA NAGAR, VISAKHAPATNAM",
  "BETHANY SCHOOL OF NURSING, P.M. PALEM, VISAKHAPATNAM",
  "SRI VINAYAKA SCHOOL OF NURSING, TIRUCHANUR, CHITTOOR",
  "SHIRIDI SAI DIPLOMA IN ENGINEERING & TECHNOLOGY",
  "KUNTHIDEVI MAHILABHYUDAYA SCHOOL OF NURSING WEST GODAVARI",
  "DHARMA PARAMEDICAL COLLEGE",
  "NARSAPUR CHRISTIAN HOSPITAL, NARSAPUR, WEST GODAVARI",
  "LAXMI SCHOOL OF NURSING VIZIANAGARAM",
  "PVK AND DNS COLLEGE OF HEALTH SCIENCE",
  "SANKAR NARAYANA INSTITUTE OF MEDICAL SCIENCES",
  "B A RAMAIAH POLYTECHNIC, RAJAHMUNDRY",
  "R K REDDY INSTITUTE OF PARAMEDICAL SCIENCES",
  "SRI VIKAS SCHOOL OF NURSING, TIRUPATHI, CHITTOOR",
  "NATIONAL SCHOOL OF NURSING PRAKASAM",
  "Balaji College of Elementary Teacher Education, Khajanagar, Near RTC Bus Stand, Anantapur- 515001",
  "GOVERNMENT POLYTECHNIC, OBULAVARIPALLI",
  "G M R POLYTECHNIC, K R PURAM",
  "BALAJEE POLYTECHNIC",
  "GOVERNMENT POLYTECHNIC TADIPATRI",
  "SRI VENKATESWARA POLYTECHNIC",
  "NELLORE SCHOOL OF NURSING, VEDAYAPALEM, NELLORE",
  "GOVERNMENT POLYTECHNIC KHONSA",
  "GOVERNMENT POLYTECHNIC ROING",
  "KHANDO DROWA SANGMO GOVT ANM SCHOOL OF NURSING",
  "GOVERNMENT POLYTECHNIC PASIGHAT",
  "NORTH EAST REGIONAL INSTITUTE OF REHABILITATION SCIENCE AND INCLUSION",
  "GOVERNMENT ANM SCHOOL NAMSAI",
  "NAMDAPHA NURSING INSTITUTE",
  "DIET, KHUPA",
  "Government Polytechnic Dirang",
  "GOVERNMENT POLYTECHNIC COLLEGE, ZIRO",
  "DIET DIRANG",
  "RAMAKRISHNA MISSION HOSPITAL SCHOOL OF NURSING",
  "DIET PASIGHAT",
  "DIET ROING",
  "RAJIV GANDHI GOVT. POLYTECHNIC",
  "DIET, DAPORIJO",
  "MARTHA NURSING TRAINING SCHOOL",
  "DIET SEPPA",
  "GOVERNMENT POLYTECHNIC NAMSAI",
  "GOVT GNM SCHOOL DAPORIJO",
  "REGIONAL INSTITUTE OF NURSING, ITANAGAR",
  "HEALTH TRAINING AND RESEARCH CENTRE  SCHOOL OF NURSING, HIGH REGION PASIGHAT DISTRICT EAST SIANG, ARUNACHAL PRADESH",
  "DIET CHANGLANG",
  "DIET PAPUMPARE",
  "DIBRUGARH MEDICAL COLLEGE HOSPITAL DIBRUGARH",
  "DIBRUGARH POLYTECHNIC LAHOWAL, DIBRUGARH",
  "DIET BARPETA",
  "DIET SONARI",
  "DIET CACHAR",
  "DIET DARRANG",
  "GOVT NORMAL SCHOOL, HOWLY",
  "DIET DHUBRI",
  "GIRLS' POLYTECHNIC BAMUNIMAIDAM GUWAHATI-781021",
  "DIET N.C. HILLS",
  "GNM TRAINING CENTRE, CIVIL HOSPITAL, NALBARI",
  "NOWGONG POLYTECHNIC NAGAON-782001",
  "DIET NALBARI",
  "PRATIKSHA SCHOOL OF NURSING, BARBARI, GUWAHATI",
  "RESIDENTIAL GIRLS' POLYTECHNIC GOLAGHAT-785621",
  "DIET NAGAON",
  "SCHOOL OF NURSING, ST. AUGUSTINE CHRISTIAN HOSPITAL, CHIRANG",
  "SILCHAR POLYTECHNIC MEHERPUR SILCHAR-788005",
  "DIET MORIGAON",
  "DIET LAKHIMPUR",
  "DIET KOKRAJHAR",
  "JBSCHOOL OF NURSING",
  "KENDUGURI INSTITUTE OF NURSING",
  "DIET KARIMGANJ",
  "DIET KAMRUP",
  "DIET JORHAT",
  "PURBOTTAR INSTITUTE OF NURSING",
  "INDIAN INSTITUTE OF HANDLOOM TECHNOLOGY GUWAHATI",
  "SIBSAGAR POLYTECHNIC",
  "REGIONAL INSTITUTE OF NURSING AND PARAMEDICAL TECHNOLOGY",
  "NIGHTINGALE INSTITUTE OF NURSING MORIGAON",
  "UDALGURI POLYTECHNIC",
  "TINSUKIA POLYTECHNIC",
  "MORIGAON POLYTECHNIC",
  "SCHOOL OF NURSING, TITBABOR, JORHAT, JMCH CAMPUS",
  "NATIONAL INSTITUTE OF NURSING",
  "ARYA SCHOOL OF NURSING KAMRUP",
  "BONGAIGAON NORMAL SCHOOL",
  "GNM TRAINING CENTRE, CIVIL HOSPITAL, HAILAKANDI",
  "GNM TRAINING CENTRE, CIVIL HOSPITAL, DARRANG",
  "MERCY SCHOOL OF NURSING",
  "GNM TRAINING CENTRE, CIVIL HOSPITAL, DHUBRI",
  "GNM TRAINING CENTRE, CIVIL HOSPITAL, KARBI ANGLONG",
  "GNM TRAINING CENTRE, LGB CIVIL HOSPITAL, TINSUKIA",
  "MMCH School of Nursing an annex of GMCH, Guwahati",
  "GOVERMENT GNM TRAINING SCHOOL, KUSHAL KONWAR CIVIL HOSPITAL, GOLAGHAT",
  "HEALTH CARE NURSING INSTITUTE OF SCIENCE AND PARAMEDICAL TECHNOLOGY",
  "GNM SCHOOL OF NURSING KARIMGANJ",
  "NIRU BORA INSTITUTE OF HEALTH AND SCIENCE EDUCATION",
  "GNM SCHOOL OF NURSING CIVIL HOSPITAL, HALFLONG DIMA HASAO",
  "GNM/ANM TRAINING CENTRE, KANAKLATA CIVIL HOSPITAL TEZPUR",
  "SCHOOL OF NURSING OIL INDIA HOSPITAL DULIAJAN",
  "VKNRL SCHOOL OF NURSING",
  "BASIC TRAINING CENTRE, HAILAKANDI",
  "DHAKUAKHANA NORMAL SCHOOL",
  "P BARUAH SCHOOL OF NURSING",
  "SCHOOL OF NURSING , BAPTIST CHRISTIAN HOSPITAL, TEZPUR",
  "LOWER ASSAM SCHOOL OF NURSING  BONGAIGAON",
  "SCHOOL OF NURSING, SATRIBARI CHRISTIAN HOSPITAL",
  "HOLY SPIRIT SCHOOL OF NURSING",
  "ASSAM ANM FHW NURSE TRAINING INSTITUTE",
  "SCAMEWO SCHOOL OF NURSING",
  "TP PARAMEDICAL AND SCHOOL OF NURSING",
  "NALBARI NURSING AND PARAMEDICAL INSTITUTE",
  "BASIC TRAINING CENTRE, NALBARI",
  "SUN VALLEY GNM SCHOOL OF NURSING",
  "BASIC TRAINING CENTRE, AZAD, LAKHIMPUR",
  "SIVASAGAR INSTITUTE OF NURSING AND HEALTHCARE MANAGEMENT",
  "N E SCHOOL OF NURSING, KALGACHIA",
  "GOVERNMENT GNM SCHOOL OF NURSING GUWAHATI MEDICAL COLLEGE HOSPITAL BANGAGARH",
  "ANM TRAINING SCHOOL",
  "DR. BHUPEN HAZARIKA REGIONAL GOVERNMENT FILM AND TELEVISION INSTITUTE",
  "SIVA SUNDARI NARI SIKSHASRAM SCHOOL OF NURSING",
  "KARIMGANJ POLYTECHNIC",
  "ASSAM ENGINEERING INSTITUTE CHANDMARI GUWAHATI-781003",
  "ASSAM NURSING INSTITUTE",
  "FHW TRAINING CENTRE IRCS SILCHAR",
  "Assam Institute of Management",
  "JIBIKA NURSING INSTITUTE AND PARAMEDICAL TECHNOLOGY",
  "Sarbananda Deka School of Nursing",
  "Institute of Hotel Management Catering Technology And Applied Nutrition Guwahati",
  "Sonitpur Polytechnic",
  "GOALPARA POLYTECHNIC",
  "Dhemaji Polytechnic",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING & TECHNOLOGY:CENTRE FOR SKILLING AND TECHNICAL SUPPORT-GUWAHATI",
  "DIPHU POLYTECHNIC",
  "DIET SONITPUR",
  "ASSAM TEXTILE INSTITUTE",
  "IQRA ACADEMY OF NURSING",
  "BONGAIGAON POLYTECHNIC, BONGAIGAON",
  "CATHOLIC HOSPITAL SONITPUR",
  "COLLEGE OF PHYSIOTHERAPY & MEDICAL SCIENCES KAMRUP",
  "NORTH EAST PARAMEDICAL AND NURSING INSTITUTE KAMRUP",
  "BASIC TRAINING CENTRE, KOKRAJHAR",
  "SCHOOL OF NURSING, BAPTIST CHRISTIAN HOSPITAL, TEZPUR",
  "SAM COLLEGE OF NURSING",
  "NEF INSTITUTE OF NURSING",
  "DOWN TOWN SCHOOL OF NURSING",
  "RANI NURSING INSTITUTE",
  "Basic Training Centre Joysagar",
  "BASIC TRAINING CENTRE RAHA",
  "BTC Sonari",
  "NEMCARE SCHOOL OF NURSING, BHANGAGARH, GUWAHATI",
  "BASIC TRAINING CENTRE RANGIA",
  "Basic Training Centre Dergaon",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, BONGAIGAON",
  "Basic Training Center Dalgaon",
  "BASIC TRAINING CENTRE DIPHU",
  "Basic Training Centre Dudhnoi",
  "LAKHIMPUR POLYTECHNIC",
  "BARPETA POLYTECHNIC",
  "BAKSA POLYTECHNIC",
  "NALBARI POLYTECHNIC",
  "CHIRANG POLYTECHNIC",
  "Basic Training Centre, Howly",
  "DIET DIBRUGARH",
  "NORMAL SCHOOL NAGAON",
  "NORMAL SCHOOL JORHAT",
  "NORMAL SCHOOL CACHAR",
  "INTERNATINOAL HOSPITAL SCHOOL OF NURSING KAMRUP",
  "HAILAKANDI POLYTECHNIC",
  "H.R.H. THE PRINCE OF WALES INSTITUTE OF ENGINEERING AND TECHNOLOGY JORHAT-785001",
  "HAJI ABDUL MAJID MEMORIAL NURSING SCHOOL NAGAON",
  "S D SAHEWALLA MEMORIAL SCHOOL OF NURSING DIBRUGARH",
  "BASIC TRAINING CENTRE, GOLAKGANJ",
  "RED CROSS NURSING TRAINING CENTRE",
  "GNM/ANM SCHOOL OF NURSING, BARPETA",
  "District Institute of Education and Training Tinsukia",
  "DR S KRISHNAMURTHI CENTRE FOR RESEARCH AND EDUCATION IN CANCER",
  "DIET GOLAGHAT",
  "DIET DUDHNOI",
  "KUKISCHOOL OF NURSING",
  "SOLACE INSTITUTE OF NURSING",
  "JORHAT CHRISTIAN MEDICAL CENTRE SCHOOL OF NURSING",
  "SCHOOL OF NURSING, BURROWS MEMORIAL CHRISTIAN HOSPITAL",
  "ST LUKE'S HOSPITAL TINSUKIA",
  "Basic Training Centre Chabua",
  "ASSAM INSTITUTE OF NURSING",
  "DISPUR HOSPITALS SCHOOL OF NURSING",
  "DIET DHEMAJI",
  "ASCENT SCHOOL OF NURSING",
  "J B Institute of Pharmacy",
  "SAINT GEROSA INSTITUTE OF NURSING DIBRUGARH",
  "KINGGATE INSTITUTE OF ALLIED HEALTH SCIENCE",
  "NORMAL SCHOOL SONITPUR",
  "GNM TRAINING CENTRE, B.P. CIVIL HOSPITAL, NAGAON",
  "BASIC TRAINING CENTRE RAVANAPARA, MAJULI",
  "SIBSAGAR COLLEGE OF TEACHERS EDUCATION",
  "GNM TRAINING CENTRE, CIVIL HOSPITAL, KOKRAJHAR",
  "GNM TRAINING CENTRE,  CIVIL HOSPITAL MORIGAON",
  "SCAMEWO SCHOOL OF NURSING, SIVASAGAR",
  "GNM TRAINING CENTRE,  NORTH LAKHIMPUR CIVIL HOSPITAL, LAKHIMPUR",
  "GNM TRAINING CENTRE, CIVIL HOSPITAL,  DHEMAJI",
  "ASIAN MISSION INSTITUTE OF NURSING",
  "SANSKAR MADHAB, SCHOOL OF NURSING, PANIKHAITI",
  "GNM TRAINING CENTRE, CIVIL HOSPITAL, GOALPARA",
  "GNM TRAINING CENTRE, CIVIL HOSPITAL SIVASAGAR",
  "GOHAIN INSTITUTE OF NURSING",
  "SCHOOL OF NURSING, MAKUNDA CHRISTIAN LEPROSY AND GENERAL HOSPITAL",
  "KAMRUP POLYTECHNIC",
  "SILCHAR MEDICAL COLLEGE AND HOSP CACHAR",
  "BASIC TRAINING CENTRE, CHENGA",
  "ICMR RMRC,NE, DIBRUGARH",
  "GOLAGHAT POLYTECHNIC",
  "INSTITUTE OF YOGA AND NUTRITION SCIENCES",
  "GNM TRAINING SCHOOL, NALBARI MATERNITY HOSPITAL, NALBARI",
  "HAPJAN INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES, TINSUKIA",
  "PRAGATI HOSPITAL & RESEARCH CENTRE SIVASAGA",
  "District Institute of Education and Training (DIET), Narar, Madhubani",
  "GOVERNMENT POLYTECHNIC KISHANGANJ",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING COLLEGE DIET MOTIHARI PURBI CHAMPARAN",
  "GOVT. POLYTECHNIC, ARARIA",
  "DEV NARAYAN TEACHER TRAINING INSTITUTE ",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING & TECHNOLOGY (CIPET)",
  "NETAJI SUBHAS INSTITUTE OF POLYTECHNIC",
  "GENERAL NURSING MIDWIFERY (GNM) TRAINING INSTITUTE SHEIKHPURA",
  "MILLIA SIR SYED PRIMARY TEACHERS TRAINING COLLEGE    ",
  "SHER SAH MEDICAL RESEARCH AND TRAINING ANM SCHOOL, TAKIYA, SASARAM",
  "ANM SCHOOL BIRAUL",
  "ANM SCHOOL, MADHUBANI",
  "ANM TRAINING SCHOOL SDH TARAPUR MUNGER",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SHAHPUR BEGUSARAI",
  "RIMU INSTITUTE OF TECHNOLOGY",
  "ANM TRAINING SCHOOL SIMARI BAKTIYARPUR SAHARSA",
  "ANM SCHOOL TEKARI",
  "ANM SCHOOL, ISLAMPUR, NALANDA",
  "Girija Devi Polytechnic College",
  "MGM Nursing Training School",
  "District Institute of Education and Training-cum-Primary Teachers Education College, Sasaram",
  "SMT MANORAMA DEVI NURSING AND ALLIED SCIENCE INSTITUTE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING PURABSARAI MUNGER",
  "PRIMARY TEACHER EDUCATION COLLEGE BIHIYA BHOJPUR",
  "BLOCK INSTITUTE OF EDUCATION AND TRAINING DARIYAPUR PURBI CHAMPARAN",
  "PRIMARY TEACHERS EDUCATION COLLEGE SUKHASAN MADHEPURA",
  "PRIMARY TEACHER EDUCATION COLLEGE SHAHPUR PATORI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING DIET RAMBAGH MUZAFFARPUR",
  "BLOCK INSTITUTE OF EDUCATION AND TRAINING",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING DUMRAON BUXAR",
  "MITR ANM TRANING SCHOOL",
  "MOTHER TERESA SCHOOL OF NURSING ANM SCHOOL, RANCHI ROAD, BIHARSARIF, NALANDA",
  "PTEC KISHANGANJ",
  "PTEC CHANDWARA, MUZAFFARPUR",
  "PTEC BNR COLLEGE, PATNA",
  "MAA KAMAKHYA POLYTECHNIC",
  "NEW GOVERNMENT POLYTECHNIC PATNA-13",
  "VAIDYANATH COLLEGE OF EDUCATION",
  "SHYAM SCHOOL OF NURSING",
  "R.G. COLLEGE OF EDUCATION",
  "ANM SCHOOL SUKHPUR, SUPAUL",
  "NARAYAN NURSING COLLEGE, SASARAM",
  "ANM TRAINING SCHOOL TRIVENIGANJ SUPAUL",
  "EXALT COLLEGE OF POLYTECHNIC",
  "PRIMARY TEACHER EDUCATION COLLEGE SHERGHATI GAYA",
  "L T GNM NURSING INSTITUTE ",
  "GURO BINDA COLLEGE OF EDUCATION",
  "NALANDA ANM NURSING, GARDHPUR, NALANDA",
  "ANM TRAINING INSTITUTE,MANIHARI,KATIHAR",
  "LAKHISARAI INSTITUTE OF NURSING",
  "JAGDAMBA ANM NURSING SCHOOL",
  "ANM TRAINING SCHOOL,SUBDIVISIONAL HOSPITAL,SONPUR,SARAN",
  "GOVT PHARMACY COLLEGE BANKA",
  "ANM SCHOOL BELSAND SITAMARHI",
  "SRI RAJ NURSING TRAINING INSTITUTE",
  "ANM TRAINING SCHOOL, SUB DIVISIONAL HOSPITAL, BENIPUR",
  "G N M TRAINING SCHOOL BARKA KATRA BHABHUA",
  "GNM INSTITUTE MAHULI JAMUI",
  "GOVERNMENT PHARMACY COLLEGE SIWAN",
  "SARVODAYA INSTITUTE OF NURSING AND PARAMEDICAL",
  "PRASAD NURSING INSTITUTE",
  "ANM SCHOOL MARHAURA",
  "NEXUS INSTITUTE OF TECHNOLOGY",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION BODHGAYA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING NOORSARAI, NALANDA",
  "GOVERNMENT POLYTECHNIC BARH",
  "Composite Regional Centre, Patna",
  "RAJ COLLEGE OF PHARMACY",
  "SATYAM INTERNATIONAL INSTITUTE OF TECHNOLOGY",
  "GIRIJA DEVI D EL ED COLLEGE",
  "SWAMI VIVEKANAND NURSING SCHOOL, JAMUI",
  "GOVERNMENT POLYTECHNIC JEHANABAD",
  "GOVERNMENT POLYTECHNIC KHAGARIA",
  "GOVERNMENT POLYTECHNIC PATNA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING",
  "Mata Sushila Institute of Education",
  "GOVERNMENT POLYTECHNIC OF TEXTILE TECHNOLOGY",
  "SURENDRA SAVITRI MEMORIAL INSTITUTE OF PARAMEDICAL AND ALLIED SCIENCES",
  "GNM INSTITUTE SUKHPUR SUPAUL",
  "ANM SCHOOL, CHAPPRA",
  "RAJEEV COLLEGE OF PROFESSIONAL EDUCATION",
  "GOVERNMENT POLYTECHNIC, WEST CHAMPARAN",
  "RADIANT INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "JAMUI INSTITUTE OF TECHNOLOGY",
  "SNS VIDYAPEETH, MOTIHARI",
  "SUBHASH INSTITUTE OF TECHNOLOGY JAMUI",
  "GOVERNMENT POLYTECHNIC MADHEPURA",
  "THE GUIDANCE NURSING INSTITUTE AND ALLIED SCIENCES",
  "AYURVEDIC MAGNETOTHERAPY RESEARCH INSTITUTE,AMRI",
  "ANM SCHOOL, BARH",
  "MANORMA DEVI SIKIRIA ANM SCHOOL, MOTIHARI",
  "PTEC BANGRA, SARAN",
  "BLOCK INSTITUTE OF EDUCATION AND TRAINING  BIET MADHOPATTI DARBHANGA",
  "KRISHNA INSTITUTE OF HIGHER EDUCATION",
  "SHREE BALAJI NURSING TRAINING SCHOOL",
  "GNM SCHOOL RAGHOPUR BALAT MADHUBANI",
  "K K INSTITUTE OF NURSING",
  "BABA RAJARAM COLLEGE OF EDUCATION",
  "LEADER INSTITUTE OF HIGHER EDUCATION",
  "MGM COLLEGE OF NURSING AND PARAMEDICAL",
  "ANM SCHOOL NARKATIYAGANJ",
  "Government Polytechnic Aurangabad",
  "ANM TRAINING SCHOOL SUB DIVISIONAL HOSPITAL DALSINGHSARAI SAMASTIPUR",
  "LICHAVI INSTITUTE OF PROFESSIONAL STUDIES",
  "DARBHANGA NURSING SCHOOL",
  "BRAJ KISHOR NARAYAN SINGH GOVERNMENT POLYTECHNIC, GOPALGANJ",
  "PANDIT DEEN DAYAL NURSING SCHOOL, SIWAN",
  "L.T. NURSING INSTITUTE, FARHADA",
  "SRT MEMORAIL ANM TRAINING SCHOOL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KAIMUR, MOHANIA",
  "ANM TRAINING SCHOOL,FORBESGANJ",
  "GOVERNMENT POLYTECHNIC SIWAN",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING KUMAR BAGH, WEST CHAMPARAN",
  "YOGENDRA INSTITUTE OF NURSING",
  "GOVERNMENT POLYTECHNIC LAKHISARAI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING PATNA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING PUSA, SAMASTIPUR",
  "PTEC PATARHI, MUZAFFARPUR",
  "ANM SCHOOL, BALLIA, BEGUSARAI",
  "GNM SCHOOL LEPROSY HOSPITAL, MUNGER",
  "PTEC POHRARA, MUZAFFARPUR",
  "GOVERNMENT POLYTECHNIC BHOJPUR",
  "ANM SCHOOL HAWELI KHARAGPUR",
  "PTEC RAMPUR, JALALPUR",
  "UTKARSH REHABILITATION AND RESEARCH INSTITUTE",
  "TRIPOLIA SCHOOL OF NURSING, PATNA",
  "BASUDEO INSTITUTE OF NURSING SCIENCE",
  "TRIVENI COLLLEGE OF EDUCATION NURSING",
  "PTEC SURHATHA, VAISHALI",
  "J M INSTITUTE OF SPEECH AND HEARING",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION, HAZIPUR",
  "A N M TRAING SCHOOL  SIKARHANA DHAKA EAST CHAMPARAN",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING (DIET) DUMRA, SITAMARHI",
  "RAM PRATAP INSTITUTE OF NURSING SCIENCES, RUKANPURA",
  "R B MEMORIAL SCHOOL OF NURSING, DARBHANGA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING GAYA",
  "SHYAMLAL CHANDRA SHEKHAR NURSING SCHOOL, KHAGARIA",
  "PTEC BARH PATNA",
  "DT INSTITUTE OF NURSING AND PARAMEDICAL",
  "UNIVERSAL HOSPITAL AND RESEARCH CENTER",
  "ROYAL COLLEGE OF MEDICAL SCIENCE",
  "ANM SCHOOL BIKRAMGANJ, ROHTAS",
  "ARYABHATT POLYTECHNIC",
  "ANM TRAINING SCHOOL KHAGARIA",
  "R S INSTITUTE OF NURSING SCIENCE AND PARAMEDICAL",
  "K R ANM INSTITUTE OF NURSING",
  "PINAK ANM NURSHING AND PARAMEDICAL COLLEGE",
  "ANM SCHOOL RAJAULI NAWADA",
  "GYANJYOTI SCHOOL OF NURSING",
  "MOTHER TERESA NURSING SCHOOL, KATIHAR",
  "ARYABHATTA INSTITUTE OF NURSING AND PARAMEDICAL",
  "G N M TRAINING INSTITUTE",
  "DOON INSTITUTE OF NURSING ANM TRAINING SCHOOL",
  "MAA TARACHANDI INSTITUTE CIVIL LINES SASARAM ROHTAS",
  "MEDICAL TRAINING SANSTHAN JASO ROAD BUXAR",
  "BALAJI NURSING SCHOOL ANM TRAINING CENTER",
  "ANM TRAINNING CENTER",
  "SATYENDRAM NURSING INSTITUTE OF ANM",
  "SANDIP FOUNDATION,SHRI RAM POLYTECHNIC, MADHUBANI",
  "PRASHANT NURSING TRAINING SCHOOL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING NAWADA",
  "PARAS ANM TRAINING SCHOOL",
  "GOVERNMENT POLYTECHNIC NAWADA",
  "ANM SCHOOL DAUDNAGAR AURANGABAD",
  "GOVERNMENT POLYTECHNIC,RAGHOPUR(SUPAUL)",
  "GOVERNMENT POLYTECHNIC, BUXAR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BANKA",
  "GEMS SCHOOL OF NURSING",
  "MOTHER TERESA NURSING SCHOOL, AARAH",
  "ANM SCHOOL GOGARI KHAGARIA",
  "HEMWANTI DEVI NURSING SANSTHAN",
  "WOMEN PRIMARY TEACHER EDUCATION COLLEGE, BISHNUPUR, BEGUSARAI",
  "PRIMARY TEACHER EDUCATION COLLEGE SASARAM ROHTAS",
  "PRIMARY TEACHERS EDUCATION COLLEGE MASAURHI PATNA",
  "PRIMARY TEACHER EDUCATION COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION  AND TRAINING TARAR DAUDNAGAR AURANGABAD",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING MADHEPURA",
  "GNM TRAINING INSTITUTE JEHANABAD",
  "SAVITRI NURSING TRAINING SCHOOL",
  "ANM SCHOOL, NIRMALI, SUPAUL",
  "School of Nursing, J L N M C H BHAGALPUR",
  "PRIMARY TEACHER EDUCATION COLLEGE NAGARPARA BHAGALPUR",
  "HI TECH POLYTECHNIC COLLEGE",
  "KHWAJA GARIB NAWAZ ANM SCHOOL, DHARBHANGA",
  "MILLIA POLYTECHNIC",
  "PRIMARY TEACHER EDUCATION COLLEGE PHULWARIA BHAGALPUR",
  "SHREE BALAJI INSTITUTE OF NURSING AND PARAMEDICAL",
  "GOVT. POLYTECHNIC TEKARI, GAYA",
  "SHIVAM HIGHER EDUCATION FOUNDATION GNM COLLEGE",
  "SHIVAM HIGHER EDUCATION FOUNDATION ANM TRAINING SCHOOL",
  "J.P. Institute of Technology",
  "KAMESHWAR NARAYAN SINGH GOVERNMENT POLYTECHNIC, SAMASTIPUR",
  "GOVERNMENT POLYTECHNIC KAIMUR",
  "GOVERNMENT POLYTECHNIC BANKA",
  "RAM PRATAP INSTITUTE OF HIGHER EDUCATION",
  "Dhanarua School of Nursing",
  "Himalaya Institute of Higher Education",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING SIWAN",
  "GAUTAM INSTITUTE OF NURSING AND PARAMEDICS, NALANDA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, SONEPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING THAWAE, GOPALGANJ",
  "DR ZAKKIR HUSSAIN TEACHER TRAINING COLLEGE DARBHANGA",
  "GOVERNMENT POLYTECHNIC MOTIHARI",
  "DUNCAN HOSPITAL, EAST CHAMPARAN",
  "GANGA MEMORIAL COLLEGE OF POLYTECHNIC",
  "GEMS POLYTECHNIC COLLEGE",
  "GOVERNMENT POLYTECHNIC BARAUNI",
  "GOVERNMENT POLYTECHNIC BHAGALPUR",
  "GOVERNMENT POLYTECHNIC CHAPRA",
  "GOVERNMENT POLYTECHNIC DARBHANGA",
  "GOVERNMENT POLYTECHNIC GAYA",
  "GOVERNMENT POLYTECHNIC GOPALGANJ",
  "GOVERNMENT POLYTECHNIC MUZAFFARPUR",
  "AMBEDKAR ANM TRAINING SCHOOL, DANAPUR, PATNA",
  "ANM SCHOOL, BEGUSARAI",
  "ANM SCHOOL, BETIAH",
  "GOVERNMENT POLYTECHNIC , SHEOHAR",
  "ANM SCHOOL, BHAGALPUR",
  "ANM SCHOOL, BIHARSARIFF",
  "ANM SCHOOL, KISHANGANJ",
  "government polytechnic vaishali",
  "ANM SCHOOL, MOTIHARI",
  "ANM SCHOOL, MUNGHYR",
  "ANM SCHOOL, MUZAFFARPUR",
  "ANM SCHOOL, PURNEA",
  "GOVT. POLYTECHNIC PURNEA",
  "ANM SCHOOL, SAMASTIPUR",
  "GOVT. POLYTECHNIC SAHARSA",
  "ANM SCHOOL, SITAMARHI",
  "ANUGHRA NARAYAN MAGADH MEDICAL COLLEGE HOSPITAL, GAYA",
  "GOVT. WOMEN POLYTEHNIC MUZAFFARPUR",
  "AZMET COLLEGE OF ENGINEERING & TECHNOLOGY,KISHANGANJ",
  "BADDIUZAMAKHAN INSTITUTE OF POLYTECHNIC",
  "INSTITUTE OF BUSINESS MANAGEMENT, BUDHMARG PATNA",
  "BHARAT INSTITUTE OF AERONAUTICS PATNA",
  "BUDDHA INSTITUTE OF TECHNOLOGY GAYA",
  "BUDDHA POLYTECHNIC INSTITUTE, GAYA",
  "INTERNATIONAL SCHOOL OF MANAGEMENT PATNA",
  "BUDHA ANM SCHOOL, BELDHA BIGHA, NALANDA",
  "BUDHA INSTITUTE OF HEALTH EDUCATION ANM SCHOOL, GAYA",
  "Development Management Institute",
  "DHANO DEVI ANM NURSING SCHOOL, JEHANABAD",
  "MAA BHAGWATI ANM SCHOOL, MADHUBANI",
  "M P S POLYTECHNIC COLLEGE ,MUSHARI, MUZAFFARPUR",
  "SAVITRI NURSING PARAMEDICAL TRAINIING SANSTHAN",
  "ANM SCHOOL MAHNAR,VAISHALI",
  "GNM SCHOOL SDH HATHUA GOPALGANJ",
  "ANM TRANING SCHOOL, SDH, JAYNAGAR",
  "ANM SCHOOL CHAKIA",
  "ANM SCHOOL, MAHUA, RAJAPAKKAR",
  "ANM SCHOOL BENIPATTTI",
  "GOVERNMENT POLYTECHNIC JAMUI",
  "DIET LAKHISARAI",
  "GNM INSTITUTE SDH MAHARAJGANJ SIWAN",
  "ACADEMY OF PHARMACY MEDICAL AND MANAGEMENT STUDIES",
  "SNB COLLEGE OF PHARMACY AND MANAGEMENT",
  "LHV SCHOOL, PATNACITY",
  "ANM SCHOOL, KATIHAAR",
  "ST STEPHENE’S COLLEGE OF NURSING",
  "PRIMARY TEACHER EDUCATION COLLEGE HAWELI KHARAGPUR MUNGER",
  "GOVT.POLYTECHNIC, ASTHAWAN",
  "MAHARSHI DAYANAND INSTITUTE OF NURSHING",
  "JAMUI POLYTECHNIC, JAMUI",
  "Government Polytechnic Sheikhpura",
  "DISTRICT INSTITUTE FOR EDUCATION AND TRAINING, BHAGALPUR",
  "MAA MUDESHWARI PARA MEDICAL AND NURSING SANSTHAN, BHABHUA",
  "GOVERNMENT POLYTECHNIC SITAMARHI",
  "DISTRICT INSTITUTE FOR EDUCATION AND TRAINING, SHEOHAR",
  "GOVERNMENT POLYTECHNIC , DEHRI-ON-SONE",
  "DISTRICT INSTITUTE FOR EDUCATION AND TRAINING, SHREE NAGAR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, DARBHANGA",
  "GOVERNMENT POLYTECHNIC MUNGER",
  "ANM NURSES TRAINING CENTER, LCT GHAT, MAINPURA, PATNA",
  "BEST NURSING INSTITUTE",
  "AKASH NURSING INSTITUTE",
  "MATA GUJRI MEMORIAL G N M NURSING SCHOOL, KISHANGANJ",
  "R R P SCHOOL OF NURSING",
  "MAA KANTI SCHOOL OF NURSING",
  "GNM TRAINING INSTITUTE SASARAM",
  "BHAVYA SHREE INSTITUTE OF NURSING ANM TRAINING SCHOOL",
  "KRISHNA INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "ANM TRAINING SCHOOL NEEMCHAK BATHANI SDH GAYA",
  "DHANO DEVI HIGHER EDUCATION GNM SCHOOL GHOSI ROAD BAIRAGI BAGH JEHANABAD",
  "S K GLOBAL SCHOOL OF HEALTH SCIENCE",
  "YAMUNA INSTITUTE OF NURSING",
  "NAZMA INSTITUTE OF NURSING EDUCATION PIPRA KHAS MIRGANJ",
  "RAMAKANTI ANM NURSING TRAINING SCHOOL",
  "CHANDRAGUPT INSTITUTE OF MANAGEMENT PATNA",
  "ANM SCHOOL LAKHISARAI",
  "C R K POLYTECHNIC",
  "Rup Bala Memorial A.N.M.Traning Center",
  "R P SINGH MEMORIAL NURSING COLLEGE, SIPARA, PATNA",
  "DARBHANGA MEDICAL COLLEGE & HOSPITAL, DARBHANGA",
  "PATLIPUTRA INSTITUTE OF NURSING TRAINING",
  "GOVT. WOMEN'S POLYTECHNIC PATNA",
  "GOVERNMENT PHARMACY COLLEGE, ROHTAS",
  "SUBHWANTI INSTITUTE OF HEALTH EDUCATION",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING(DIET) SHEIKHPURA",
  "VIVEKANAND PARAMEDICAL NURSING COLLEGE",
  "RAJ NURSING INSTITUTE (G.N.M.SCHOOL), ODAR, BHABUA, KAIMUR",
  "CHANAKYA INSTITUTE OF POLYTECHNIC AND TECHNOLOGY",
  "MODERN INSTITUTE OF NURSING",
  "Prabhu Kailash Polytechnic college",
  "ANM SCHOOL ROSERA",
  "GNM TRAINING INSTITUTE, BETTIAH",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING AND TECHNOLOGY BHAGALPUR",
  "NAZIRUL HASAN INSTITUTE OF HIGHER EDUCATION SONIHAR KHAGARIA",
  "GNM SCHOOL, BANKA",
  "OM SAI SHIV NURSING COLLEGE, BEGUSARAI",
  "ANM SCHOOL, SHEOHAR",
  "MAMTA INSTITUTE OF EDUCATION",
  "ANM SCHOOL, GAYA",
  "ANM SCHOOL, BHOJPUR",
  "ANM SCHOOL, HAJIPUR",
  "MIRGANJ NURSING SCHOOL AND TRAINING INSTITUTE",
  "MADHUBANI INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "ANM SCHOOL, HATHWA",
  "KHAWAJA GARIB NAWAJ PARA MEDICAL COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, KHAGARIA",
  "KALMI INSTITUTE OF NURSING",
  "HIRAWATI A N M NURSING SCHOOL",
  "ANM SCHOOL,UDAKISHANGANJ",
  "DARBHANGA NURSING SCHOOL SHIVDHARA DARBHANGA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BHOJPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING DIGGI, VAISHALI",
  "MILLIA POLYTECHNIC PURNEA",
  "NAINA NURSING INSTITUTE, MUZAFFARPUR",
  "PTEC MAHENDRU, PATNA",
  "PTEC MOKAMA, PATNA",
  "DR NESAR HAIDER INSTITUTE OF NURSING SCIENCES",
  "G M PARAMEDICAL COLLEGE",
  "SANJEEVANI AAROGYA SANSTHAN ANM TRAINING SCHOOL FATUHA PATNA",
  "ANM SCHOOL MAIRWA SIWAN",
  "SHRI BHAGWAT PRASAD SINGH MEMORIAL ANM TRAINING SCHOOL",
  "ANM SCHOOL JALLEY",
  "MAGADH ANM TRAINING SCHOOL",
  "RAJGIR ANM NURSING SCHOOL",
  "MAMTA NURSING INSTITUTE",
  "GNM NURSING INSTITUTE JLNMCH BHAGALPUR",
  "Parmarth Institute of Nursing Education",
  "GOVERNMENT POLYTECHNIC KATIHAR",
  "ANM SCHOOL LAXMIPUR JAMUI",
  "ANUSHKA ANM TRAINING SCHOOL",
  "BENIPUR NURSING TRAINING SANSTHAN",
  "ANM TRAINING SCHOOL BHABUA KAIMUR",
  "NAVRANG PRABHUNATH INSTITUTEOF NURSING AND HOSPITAL",
  "DPS SCHOOL OF NURSING",
  "MAGADH INSTITUTE OF TECHNOLOGY",
  "ANM SCHOOL, PIRO, BHOJPUR",
  "RAJ ANM TRAINING SCHOOL MUZAFFARPUR",
  "GNM TRAINING SCHOOL OLD SDH KHAGARIA",
  "NATIONAL INSTITUTE OF NURSING AND PARAMEDICAL SCIENCE",
  "ANM TRAINING SCHOOL SUB DIVISIONAL HOSPITAL JANJARPUR MADHUBANI",
  "ANM SCHOOL BAGAHA",
  "BUDDHA INSTITUTE OF HEALTH EDUCATION",
  "ANM SCHOOL TRAINING SCHOOL VIRPUR SUPAUL",
  "BIHAR INSTITUTE OF NURSING AND PARA MEDICAL, JAITIPUR, NEORA, PATNA",
  "BHAGAPUR INSTITUTE OF NURSING",
  "ANM SCHOOL ARWAL SADAR ARWAL",
  "PRAMEELA ADHAR NURSING COLLEGE SATANPUR SAMASTIPUR",
  "MAALIK INSTITUTE OF TECHNOLOGY",
  "primary teacher education college siwan mairwa",
  "MAHILA PRIMARY TEACHERS TRAINING COLLEGE MUSAPUR KATIHAR",
  "GOVERNMENT POLYTECHNIC ARWAL",
  "DIET TIKAPATTI KATIHAR",
  "GNM INSTITUTE ARWAL",
  "NAWADA COLLEGE OF NURSING",
  "S K M NURSING SCHOOL",
  "SITYOG INSTITUTE OF POLYTECHNIC, AURANGABAD",
  "APOLLO NURSING TRAINING SCHOOL",
  "CHAMPARAN NURSING COLLEGE",
  "RAJ KUMARI NURSING TRAINING SCHOOL",
  "MAITREE ANM NURSING TRAINING INSTITUTE",
  "ADITYA TATHAGAT INSTITUTE OF PHARMACY",
  "CHAMPARAN COLLEGE",
  "VIVEKANAND INSTITUTE OF TECHNOLOGY",
  "GOVERNMENT POLYTECHANIC MADHUBANI",
  "PRIMARY TEACHER EDUCATION COLLEGE",
  "VIDYA EDUCATION GROUP",
  "ANJU INSTITUTE OF NURSING SCIENCE",
  "ST TERESA'S PRIMARY EDUCATION COLLEGE BETTIAH",
  "EKALAVYA INSTITUTE OF HIGHER EDUCATION",
  "CHAMPARAN GROUP OF INSTITUTIONS, SALIM NAGAR, MARJADWA-PARSA, MAINATAND",
  "DIVINE INSTITUTE OF TECHNOLOGY",
  "HIMALAYA INSTITUTE OF TECHNOLOGY",
  "STATE COUNCIL OF EDUCATIONAL RESEARCH AND TRAINING (SCERT)",
  "GOVERNMENT POLYTECHNIC FOR WOMEN, CHANDIGARH",
  "DR. AMBEDKAR INSTITUTE OF HOTEL MANAGEMENT CATERING AND NUTRITION",
  "D.A.V. MODEL SCHOOL CHANDIGARH",
  "REGIONAL INSTITUTE OF COOPERATIVE MANAGEMENT",
  "PML SD BUSINESS SCHOOL",
  "Chandigarh College of Engineering and Technology (Diploma Wing)",
  "INDO SWISS TRAINING CENTRE",
  "RAJARAM MOHAN RAI INSTITUTE OF VOCATIONAL STUDIES CHANDIGARH",
  "CHANDIGARH INSTITUTE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "SRI GURU GOBIND SINGH COLLEGE OF PHARMACY",
  "GOVT. G.N.M. TRAINING CENTER, DHAMTARI",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION, NAVA RAIPUR",
  "GOVERNMENT GNMTC JASHPUR",
  "C G SCHOOL OF NURSING RAIPUR",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING AND TECHNOLOGY KORBA",
  "DIET AMBIKAPUR, SURGUJA",
  "DIET BASTER, BASTAR",
  "Govt. Genral Nursing Training Centre Distric Hospital Bilaspur, Chhattisgarh",
  "JAGRANI DEVI COLLEGE OF EDUCATION DARRABHATHA, DIST JANJGIR CHAMPA CG",
  "APAAR INSTITUTE OF NURSING",
  "VISHWA BHARATHI EDUCATIONAL DEVELOPMENT SOCIETYs VISHWA BHARATHI INSTITUTE KONTA, DANTEWADA",
  "RAVI SHANKAR COLLEGE OF EDUCATION",
  "DIET KHAIRAGARH, RAJNANDGAON",
  "DIET DHARAMJAIGARH, RAIGARH",
  "BTI DONGARGAON, RAJNANDGAON",
  "MAA MANGALA GNM TRAINING CENTRE,RAIPUR",
  "GOVT. GNM TRAINING CENTER KORBA",
  "THE EVANGELICAL MISSION HOSPITAL RAIPUR",
  "BHARTI SCHOOL OF EDUCATION RAHOD",
  "DIET KANKER, KANKER",
  "DIET KABIRDHAM, KAWARDHA",
  "DIET JANJGIR, JANJGIR-CHAMPA",
  "DIET KORBA, KORBA",
  "GOVT GNM TRAINING CENTER NARAYANPUR",
  "GLOBAL EDUCATION INSTITUTE - DHANELI",
  "DIET DANTEWADA, DANTEWADA",
  "DIET BEMETARA, DURG",
  "GOVT. SCHOOL OF NURSING, KONDAGAON",
  "RAMKRISHNA INSTITUTE OF MEDICAL SCIENCE",
  "GOVT GNM TRANING CENTRE MAHASAMUND",
  "Shri Siddhi Balaji School of Nursing",
  "Asharfi Devi Institute of Nursing Balrampur",
  "Shri Rawatpura Sarkar Institute Village Pacheda Post Kurru Near Muktangan Champaran Road Atal Nagar",
  "School Of Nursing Holy Cross Hospital Kunkuri",
  "KALINDI ACADEMY OF NURSING SCIENCE",
  "Kalindi Institute of Nursing Sciences",
  "LAKSHYA INSTITUTE OF NURSING",
  "PRISM SCHOOL OF BUSINESS AND ENTREPRENEURSHIP",
  "RITEE BUSINESS SCHOOL (RIBS) RAIPUR",
  "SANTA CRUX SISTERS ASSOCIATION PATTHALGAONs HOLY CROSS BTI, JASHPUR",
  "Christian Hospital School of Nursing",
  "JMJ MORNING STAR SCHOOL OF NURSING",
  "A. K. School of NUrsing Manendragarh",
  "MAHEE NURSING INSTITUTE",
  "Shri Rawatpura Sarkar Institute of Modern Education - Dhaneli",
  "Govt. gnm Training Centre Dantewada (C.G.)",
  "Govt. School Of Nursing, Maharani Hospital Jagdalpur",
  "SHRI RAWATPURA SARKAR INSTITUTE, DHANELI",
  "DIET JASHPUR, JASHPUR",
  "GOVERNMENT M.P.W. TRAINING CENTER, KORBA",
  "Shri Balaji Institute of Nursing",
  "SHIVALIK INSTITUTE OF MANAGEMENT EDUCATION AND RESEARCH",
  "INDIAN INSTITUTE OF HANDLOOM TECHNOLOGY, Janjgir - Champa",
  "GOVT.G.N.M.T.C.DURG",
  "Govt G N M School of Nursing Kanker",
  "GOVERNMENT BASIC TRAINING INSTITUTE BILASPUR",
  "G N M TRAINING CENTRE RAIPUR",
  "Gayatri Institute of Nursing, Jagdalpur",
  "DIET RAIPUR, RAIPUR",
  "DIET PENDRA, BILASPUR",
  "DIET NAGRI, DHAMTARI",
  "DIET MAHASAMUND, MAHASAMUND",
  "DIET KORIYA, KORIYA",
  "COMPOSITE REGIONAL CENTRE FOR SKILL DEVELOPMENT REHABILITATION AND EMPOWERMENT OF PERSONS WITH DISABILITIES RAJNANDGAON",
  "MAHARISHI SHIKSHA SANSTHAN MAHARISHI ROAD MANGLA BILASPUR",
  "KANTI DARSHAN MAHAVIDYALAYA",
  "FELLOWSHIP SCHOOL OF NURSING",
  "JRD COLLEGE OF EDUCATION",
  "MAYARAM SCHOOL OF NURSING",
  "INTERNATIONAL INSTITUTE OF HEALTH MANAGEMENT RESEARCH",
  "ICAR NATIONAL INSTITUTE OF AGRICULTURAL ECONOMICS AND POLICY RESEARCH",
  "MAHARAJA AGARSAIN COLEGE OF NURSING",
  "SRI SHARADA INSTITUTE OF INDIAN MANAGEMENT RESEARCH",
  "ICS INFOTECH",
  "Brahm Shakti School of Nursing",
  "FOSTIIMA Business School",
  "THE NATIONAL INSTITUTE OF HEALTH AND FAMILY WELFARE",
  "RUKMINI DEVI COLLEGE OF EDUCATION",
  "CHANDRA BHUSHAN SINGH MEMORIAL MAHILA BAL EVAM SHRAVAN VIKLANG SHIKSHA EVAM PUNARVAS SANSTHAN",
  "The Blind Relief Association",
  "Entreneurship  Management Processes International New Delhi",
  "BRMT College of Education",
  "sant parmanand hospital school of nursing",
  "Manvi Institute of Education and Technology",
  "Drishhti",
  "SIMPATHY INSTITUTE OF HOMOEOPATHIC PHARMACY AND HOSPITAL",
  "CSIR NATIONAL INSTITUTE OF SCIENCE COMMUNICATION AND POLICY RESEARCH ",
  "INSTITUTE OF MARKETING AND MANAGEMENT, QUTAB INSTITUTIONAL AREA",
  "NATIONAL  INSTITUTE OF TUBERCULOSIS AND RESPIRATORY DISEASES, NEW DELHI",
  "APEEJAY INSTITUTE OF MASS COMMUNICATION",
  "Aaryan College of Education",
  "AISHE STANDALONE INSTITUTE",
  "VIDYA TRAINING INSTITUTE",
  "GREAT MISSION TEACHERS TRAINING INSTITUTE, DWARKA",
  "IMPACT PARAMEDICAL AND HEALTH INSTITUTE, COLLEGE OF NURSING",
  "MATA RISALO DEVI INSTITUTE OF NURSING",
  "SRI SUKHMANI INSTITUTE OF MANAGEMENT",
  "CSIR-NATIONAL PHYSICAL LABORATORY",
  "SATYAM INTERNATIONAL POLYTECHNIC",
  "BHARATIYA VIDYA BHAVAN'S USHA AND LAKSHMI MITTAL INSTITUTE OF MANAGEMENT",
  "NEW DELHI INSTITUTE OF INFORMATION AND TECHNOLOGY",
  "FORE SCHOOL OF MANAGEMENT",
  "MAHARAJA AGRASEN BUSINESS SCHOOL",
  "LAL BAHADUR SHASTRI INSTITUTE OF MANAGEMENT",
  "YMCA TEACHERS TRAINING INSTITUTE FOR SPECIAL EDUCATION",
  "TAMANA SCHOOL OF HOPE",
  "INSTITUTE OF VOCATIONAL STUDIES, SHEIKH SARAI",
  "CBSM DELHI",
  "INTERNATIONAL POLYTECHNIC FOR WOMEN 171 A KHIRKI ROAD MALVIYA NAGAR",
  "APEEJAY INSTITUTE OF DESIGN",
  "Shakuntla School of Nursing",
  "INDIAN SIGN LANGUAGE RESEARCH AND TRAINING CENTRE",
  "AMAR JYOTI REHABILITATION AND RESEARCH CENTRE",
  "MR  BHARATI COLLEGE OF EDUCATION, WEST DELHI",
  "M.D.INDRAPRASTHA INSTITUTE OF HIGHER EDUCATION, RAJEEV NAGAR",
  "TECNIA INSTITUTE OF TEACHER EDUCATION, ROHINI",
  "JAGAN INSTITUTE OF MANAGEMENT STUDIES TECHNICAL CAMPUS",
  "PEARL ACADEMY",
  "M.A. EDUCATION INSTITUTE, ROHINI",
  "APOLLO SCHOOL OF NURSING",
  "S.B. College of Science And Technology",
  "SRI SUKHMANT INSTITUTE OF MANAGEMENT",
  "LOVELY TEACHERS TRAINING INSTITUTE, PRIYADARSHNI VIHAR",
  "LADY READING HEALTH SCHOOL, BARA HINDU RAO, NEW DELHI",
  "NEW DELHI INSTITUTE OF INFORMATION TECHNOLOGY AND MANAGEMENT",
  "MOTHERS CARE COLLEGE OF SPECIAL EDUCATION",
  "DIET ANSARI ROAD DARGA GANJ NEW DELHI",
  "SALOKAYA COLLEGE OF NURSING",
  "INSTITUTE OF COMPANY SECRETARIES OF INDIA",
  "Association For Advancement and Rehabilitation of Handicapped",
  "GURU TEGH BAHADUR POLYTECHNIC (G.H.P.S. PREMISES) POORVI MARG VASANT VIHAR",
  "CHHOTU RAM RURAL INSTITUTE OF TECHNOLOGY KANJHAWALA (GHEVRA)",
  "Gitarattan Institute of Advanced Studies and  Training, Rohini",
  "GINNI DEVI ACTION SCHOOL OF NURSING, PASCHIM VIHAR",
  "FORTUNE INSTITUTE OF INTERNATIONAL BUSINESS",
  "BABA HARI DASS INSTITUTE OF NURSING EDUCATION SOUTH WEST",
  "V.D. INSTITUTE OF TECHNOLOGY",
  "International Management Institute",
  "SMT JANAKI RANI TALWAR SCHOOL OF NURSING NEW DELHI",
  "BABA HARIDASS COLLEGE OF PHARMACY & TECHNOLOGY",
  "ASIA-PACIFIC INSTITUTE OF MANAGEMENT",
  "APEEJAY SCHOOL OF MANAGEMENT",
  "L.C.COLLEGE OF EDUCATION",
  "Amity Institute of  Education, Saket",
  "TECNIA INSTITUTE OF ADVANCED STUDIES CDL",
  "SAINATH COLLEGE OF EDUCATION",
  "DIET GHUMMANHERA DELHI",
  "INDIAN INSTITUTE OF PACKAGING",
  "RISHAB INSTITUTE, POCKET-IV, MAIN ROAD, MAYUR VIHAR",
  "SIR GANGA RAM HOSPITAL NEW DELHI",
  "SRI RAM INSTITUTE OF TEACHER EDUCATION, DWARKA",
  "SARADA UKIL SCHOOL OF ART",
  "SAVIOUR COLLEGE OF NURSING",
  "INSTITUTE OF PARAMEDICAL SCIENCES AND RESEARCH",
  "NEW DELHI INSTITUTE OF MANAGEMENT",
  "DIET DILSHAD GARDEN, NORTH EAST",
  "J.R.N. INSTITUTE OF AVIATION TECHNOLOGY NEW DELHI",
  "DIET KESHAV PURAM DELHI",
  "INTEGRATED INSTITUTE OF TECHNOLOGY SECTOR-9 DWARKA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, PITAMPURA",
  "ADITYA INSTITUTE OF TECHNOLOGY, DELHI",
  "DPMI SCHOOL OF NURSING    ",
  "RAMA KRISHNA TEACHER TRAINING INSTITUTE, VIKAS PURI",
  "PUSA POLYTECHNIC",
  "M R BHARTI SCHOOL OF NURSING",
  "TIRATH RAM SHAH HOSPITAL NEW DELHI",
  "AKANKSHA INSTITUTE OF NURSING, NAJAFGARH",
  "PRADEEP MEMORIAL COMPREHENSIVE COLLEGE OF EDUCATION, NANGLOI",
  "DIET SKV SCHOOL COMPLEX R K PURAM SEC - VII NEW DELHI",
  "DIET BABA PHOOLA SINGH MARG OLD RAJENDRA NAGAR NEW DELHI",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING AND NUTRITION PUSA",
  "SAI INSTITUTE FOR GIRLS GEETA COLONY",
  "Rajmata vijayraje scindia nursing school",
  "DIET KAKARDOEM DELHI",
  "MANOVIKAS COMPREHENSIVE REHABILITATION AND RESEARCH CENTRE    ",
  "DIET MOTIBAGH, NEW DELHI",
  "ASHOK INSTITUTE OF HOSPITALITY AND TOURISM MANAGEMENT",
  "RURAL HEALTH TRAINING CENTRE, NAJAFGARH, NEW DELHI",
  "HOLY FAMILY HOSPITAL SOUTH DELHI",
  "SUSHILA SCHOOL OF NURSING",
  "DELHI INSTITUTE OF HOTEL MANAGEMENT",
  "JAIN BHARTI INSTITUTE OF ELEMENTARY EDUCATION",
  "Delhi College of Vocational Studies and Research, Baprola",
  "INSTITUTE OF PUBLIC HEALTH AND HYGIENE",
  "DELHI SCHOOL OF BUSINESS",
  "OJAS COLLEGE OF EDUCATION",
  "JAGANNATH INTERNATIONAL MANAGEMENT SCHOOL",
  "SAI NURSING INSTITUTE",
  "GOVERNMENT POLYTECHNIC PANJI",
  "GOVERNMENT POLYTECHNIC CURCHOREM",
  "VRUNDAVAN INSTITUTE OF PARA MEDICAL TECHNOLOGY",
  "SHREE VETAL INSTITUTE OF EDUCATION AND TRAINING",
  "AGNEL POLYTECHNIC, VERNA GOA",
  "HQ 2 SIGNAL TRAINING CENTRE",
  "INSTITUTE OF SHIPBUILDING TECHNOLOGY, GOA",
  "GOVERNMENT POLYTECHNIC BICHOLIM",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING GOA BARODZ",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION",
  "ST JOSEPH VAZ INSTITUTE OF EDUCATION",
  "GOA INSTITUTE OF MANAGEMENT",
  "AGNEL INSTITUTE OF FOOD CRAFTS AND CULINARY SCIENCES VERNA",
  "GUARDIAN ANGEL INSTITUTE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY CURCHOREM",
  "INSTITUTE OF MARITIME STUDIES",
  "INDIAN INSTITUTE OF TOURISM AND TRAVEL MANAGEMENT",
  "SAI PARA MEDICAL INSTITUTE",
  "ANM SCHOOL, COMMUNITY HEALTH CENTRE, CHHOTILA",
  "KHEDUT KH M K MANDAL PTC COLLEGE SANJELI",
  "SAURASHTRA COLLEGE OF NURSING",
  "MAHILA PTC COLLEGE KUTCH",
  "KALAPURNAM INSTITUTE",
  "SHREE VIRPUR MAHILA UTKARSH MANDAL KHEDA",
  "ANM SCHOOL, SHETH N. L. GENERAL HOSPITAL, PATAN",
  "SABAR SCHOOL OF NURSING",
  "Manav Nursing School, Visnagar",
  "General Nursing School",
  "ADANI INSTITUTE OF DIGITAL TECHNOLOGY MANAGEMENT, GANDHINAGAR",
  "PACIFIC INSTITUTE OF NURSING",
  "MANGLAM PTC COLLEGE UNTARDA",
  "SHREE B D BARAD INSTITUTE OF NURSING",
  "PRIME INSTITUTE OF NURSING",
  "MARY BROWN MEMORIAL TRAINING COLLEGE KHEDA",
  "General Nursing School Santrampur (Ta Santrampur Dist Mahisagar)",
  "MOTHER TERRASA NURSING INSTITUTE",
  "SHREE SVT INSTITUTE OF NURSING",
  "ANM SCHOOL, COTTAGE HOSPITAL, BHILODA",
  "SHRI ANAND DIPLOMA IN GENERAL NURSING & MIDWIFERY SCHOOL RAJKOT",
  "B.A.MEHTA KALA MAHAVIDYALAYA, AMALSAD",
  "KASTURBA STREE ADHYAPAN MANDHIR, KOBA, GANDHINAGAR",
  "ANM SCHOOL, DIVISIONAL TRAINING CENTRE, ALIABADA",
  "ANM SCHOOL, DIVISIONAL TRAINING CENTRE, PADRA",
  "VIDHYADEEP SCHOOL OF NURSING (ANM)",
  "SPORTS SCHOOL OF NURSING",
  "BHIMRATNA NURSING COLLEGE",
  "MORVA INSTITUTE OF NURSING",
  "ANM SCHOOL, DIVISIONAL TRAINING CENTRE, SACHIN, SURAT",
  "BAPA SITARAM PTC COLLEGE, RAJULA",
  "BHAGWAN MAHAVIR SCHOOL OF NURSING SURAT",
  "B M BARAD PTC COLLEGE SUTRAPADA",
  "B. M. Patel School of Nursing, Hajipur",
  "SHREE SWAMINARAYAN COLLEGE OF NURSING",
  "Cambay General Hospital Nsg. School, Khambhat",
  "CHUNIBHAI JADAVIJIBHAI MANDAVIA PTC COLLEGE RAJKOT",
  "SHREE NILKANTH NURSING SCHOOL",
  "CIVIL SURGEON HOSPITAL JUNAGADH",
  "ANM NURSING SCHOOL, K K MEHTA GOVERNMENT HOSPITAL, SAVARKUNDLA",
  "ANM SCHOOL, CHC & REFERAL HOSPITAL, CHHOTA- UDEPUR",
  "C.K.PATEL COLLEGE OF PRIMARY TEACHER EDUCATION SABARKANTHA",
  "MATRU SHREE NATHIBEN HAMIRBHAI GAGIYA GNM NURSING COLLEGE AND MATRU SHREE SAVDHIBEN MERAMANBHAI NANDANIYA INSTITUTE ANM",
  "B N PATEL INSTITUTE OF NURSING",
  "DHORAJI SANCHALIT PTC COLLEGE RAJKOT",
  "MATRUSHRI KHEMIBA PTC COLLEGE SURAT",
  "MAHAKALI ACADEMY FOR NURSING AND ALLIED SCIENCES",
  "ANM SCHOOL, R. R. GENERAL HOSPITAL,, LIMBDI",
  "MATRUSHRI VRAJKUVARBEN BACHUBHAI MANVAR PTC COLLEGE DUMIYANI",
  "ANM SCHOOL, GENERAL HOSPITAL, RAJPIPLA",
  "MATRUSHRI VRAJKUVARBEN B MANVAR SCHOOL OF NURSING RAJKOT",
  "D.I. Patel School of Nursing, Sujanpur",
  "PANKTI COLLEGE OF NURSING",
  "VISHWABHARATI COLLEGE OF NURSING",
  "SHRI C.K.MEHTA COLLEGE OF PRIMARY EDUCATION BANASKANTHA",
  "MATRUVANDAN PTC COLLEGE JUNAGADH",
  "JIVUBA NURSING COLLEGE",
  "ALICE COLLEGE OF NURSING",
  "ANM SCHOOL, G. D. GENERAL HOSPITAL, VISNAGAR",
  "MATUSHRI KHEMIBA PTC COLLEGE UDHNA",
  "SHAKTI INSTITUTE OF NURSING",
  "DISHAN COLLEGE OF NURSING",
  "ANM SCHOOL, CIVIL HOSPITAL, DAHOD",
  "SHRI DAYAMAN INSTITUTE OF NURSING, JAMNAGAR",
  "M.B.SHAH PRIMARY TEACHER TRAINING COLLEGE KHEDA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING ASHANAGAR DANG",
  "IFSMA FIRE AND SAFETY COLLEGE,VADODARA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING DAHOD",
  "ANM SCHOOL, CIVIL HOSPITAL, RADHANPUR",
  "LIMBDI INSTITUTE OF NURSING EDUCATION",
  "N. L. Amodra School of Nursing,,  At: Charadva",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING IDAR IDAR SABARKANTHA",
  "MEDILINK INSTITUTE OF NURSING , AHMEDABAD",
  "SHRI D M MEHTA & SMT S D MEHTA MAHILA PTC COLLEGE DHROL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING JUNAGARH",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING MEHSANA",
  "K V KAMDAR COLLEGE OF NURSING",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING RAJKOT",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING SANTRAMPUR PANCHMAHAL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING VALSAD",
  "LOTUS NURSING COLLEGE",
  "GENERAL NURSING SCHOOL, STATE HOSPITAL, DHARAMPUR",
  "SHREE VANKAL NURSING COLLEGE AND RESEARCH CENTRE",
  "SAHAJANAND INSTITUTE OF NURSING",
  "GHAR SALA BUNIYADI ADHYAPAN MANDIR BHAVNAGAR",
  "METAS ADV. SCHOOL OF NURSING, ADV. HOSPITAL, SURAT",
  "UPASANA INSTITUTE OF NURSING",
  "SHRI G.G.MEHTASTREE ADHYAPAN MANDIR BANSKANTHA",
  "GOVERNMENT BASIC TRAINING COLLEGE FOR MEN BHARIA",
  "MICA",
  "YAMUNA NURSING INSTITUTE OF SCIENCE",
  "KRISHNA COLLEGE",
  "SAMI INSTITUTE OF NURSING",
  "GOVT TRAINING COLLEGE FOR MAN SABARKANTHA",
  "HANUMANT SCHOOL OF NURSING BHAVNAGAR",
  "NILKANTH INSTITUTE OF NURSING",
  "SARDAR PATEL NURSING INSTITUTE",
  "AAYUSH MEDICAL INSTITUTE",
  "H.K.PRIMARY TRAINING COLLEGE AHMEDABAD",
  "NOBLE STAR NURSING COLLEGE MAKHIYALA",
  "M K LATIWALA ADHYAPAN MANDIR MODASA",
  "EKTA COLLEGE OF NURSING, SONGADH",
  "HUMAN TORCH SCHOOL OF NURSING JAMNAGAR",
  "INDIAN DIAMOND INSTITUTE, SURAT",
  "SHREE SATYA SAI SCHOOL OF NURSING",
  "SHRI LOHANA STHAPIT MAHILA ADHYAPAN MANDIR RAJKOT",
  "SARDAR PATEL INSTITUTE OF NURSING",
  "SHAGUN INSTITUTE OF NURSING",
  "MOTIBHAI AMIN PRATHMIK SHIKSHAK ADHYAPAN MANDIR ANAND",
  "UDAYBHANSINHJI REGIONAL INSTITUTE OF CO-OPERATIVE MANAGEMENT",
  "Shree Shreyas Nursing Institute, Jodiya",
  "SHREE ATMIYA NURSING INSTITUTE",
  "DECENT NURSING SCHOOL",
  "Vanita Vishram ANM School, Surat",
  "Vidhya Nikunj Nusing School, Rajkot",
  "Vraj Institute of Nursing, Mota- Chiloda",
  "ANM SCHOOL, REGIONAL TRAINING CENTRE, RAJKOT",
  "JUNAGADH KELAVANI MANDAL PTC COLLEGE JUNAGADH",
  "ANM SCHOOL, G. K. GENERAL HOSPITAL,, BHUJ",
  "Vinayaka College of Nursing",
  "KASTURBA ADHYAPAN MANDIR BORAKHADI",
  "V.S.RAVAL BUNIYADI ADHYAPAN MANDIR SABARKANTHA",
  "WESTERN INDIA INSTITUTE OF THE AERONAUTICS AHMEDABAD",
  "STREE ADHYAPAN MANDIR , RAJPIPLA",
  "SHREE ARJUN P. T. C. COLLEGE, SUPASI",
  "ASHOKBHATT INSTITUTE OF NURSING",
  "SOMNATH ANM SCHOOL, KODINAR",
  "SHAGUN INSTITUTE OF NURSING",
  "JAY SOMNATH INSTITUTE OF NURSING EDUCATION RAJKOT",
  "CARE INSTITUTE OF NURSING",
  "Akshar Nursing School  and College",
  "ANM SCHOOL, S. S. HOSPITAL, PETLAD",
  "ANM SCHOOL, M. G. G. HOSPITAL, NAVSARI",
  "TAKSHASHILA COLLEGE OF NURSING",
  "Smt. Raniben Madhabhai Bhadarka Institute of Nursing",
  "ANM SCHOOL, SHREE J. S. CHAUHAN HOSPITAL, D. BARIA",
  "SHREE KESARIYAJI DASHAMA COLLEGE OF NURSING",
  "COMPOSITE REGIONAL CENTRE FOR PERSONS WITH DISABILTIES",
  "TRISHIKA NURSING INSTITUTE RAJPIPLA",
  "D A PATEL INSTITUTE OF NURSING",
  "KRISHNA COLLEGE OF NURSING GNM HEDUVA RAJGAR MEHSANA",
  "ANM SCHOOL, REGIONAL TRAINING CENTRE, BAVLA",
  "SHREEJIBAPA NURSING COLLEGE MEGHRAJ",
  "K M JANI SCHOOL OF NURSING, AMRELI",
  "SHREEMATI RUKSHMANIBA KANAJIBHAI PATEL SCHOOL OF NURSING",
  "MEGHAL SCHOOL OF NURSING MALIYA HATEENA",
  "EKTA INSTITUTE OF NURSING",
  "PANCHSHIL NURSING COLLEGE",
  "Shree Swaminarayan SON, Surat",
  "VIDHYADEEP NURSING SCHOOL",
  "KRISHNA NURSING INSTITUTE",
  "FUTURE LINK NURSING COLLEGE",
  "SHANJIVANI INSTITUTE OF NURSING LUNAWADA",
  "Shital Institute of Nursing, Lunawada",
  "MAHANTAM SCHOOL OF NURSING",
  "ANM SCHOOL, GOVERNMENT HOSPITAL, MORBI",
  "JAYDEEP SHARDA MEMORIAL SCHOOL OF NURSING, SURAT",
  "SMT I K RAVAT NURSING COLLEGE SANJELI DAHOD",
  "ADITYA INSTITUTE OF NURSING KESHOD",
  "V S INSTITUTE OF NURSING",
  "PRAYOSHA NURSING SCHOOL",
  "ANM SCHOOL SAGAR EDUCATION AND CHARITABLE TRUST",
  "VEDANT NURSING SCHOOL",
  "SHIVAM SCHOOL OF NURSING",
  "VARDAN SCHOOL OF NURSING",
  "ADARSH NURSING SCHOOL DHANERA",
  "LATE SH P N BORICHA PTC COLLEGE MERADA",
  "SHRI GANESH COLLEGE OF NURSING",
  "INDO GERMAN TOOL ROOM AHMEDABAD",
  "NALANDA NURSING INSTITUTE",
  "S B SHARMA COLLEGE OF NURSING AND RESEARCH",
  "ANM SCHOOL, GENERAL HOSPITAL, MANDVI",
  "SHREE SODHA SCHOOL OF NURSING, RAJKOT",
  "NRUPUR INSTITUTE OF NURSING SCIENCE AND RESEARCH, VADODARA",
  "SHREE VIVEKANAND NURSING COLLEGE",
  "SANCHALIT NURSING SCHOOL AMRELI",
  "OM NANDISH SCHOOL OF NURSING",
  "SHAKTI KRUPA ART TEACHERS TRENING COLLEGE HIMTNAGAR",
  "ACHIEVER NURSING COLLEGE",
  "AYUSHMAN NURSING COLLEGE",
  "LOKBHARATI ADHYAPAN MANDIR BHAVNAGAR",
  "SCHOOL OF NURSING, GENERAL HOSPITAL, AMRELI",
  "JATAN SCHOOL OF NURSING",
  "METHODIST HOSPITAL KHEDA",
  "Akshar trust",
  "Smt. P. J. Institute of Nursing",
  "ANM / FHW TRAINING SCHOOL NANAPONDHA",
  "SHREE RAM SCHOOL OF NURSING",
  "SCHOOL OF NURSING, CIVIL HOSPITAL, AHMEDABAD",
  "Institute of Rural Management Anand (IRMA)",
  "RADHA KISHAN SCHOOL OF NURSING",
  "GUJARAT INSTITUTE OF NURSING, DEESA",
  "SMT C S BHABHOR NURSING SCHOOL SINGVAD",
  "ISCON INSTITUTE OF NURSING AND RESEARCH CENTRE",
  "ANKUR SPECIAL SCHOOL FOR MENTALLY RETARDED CHILDREN",
  "CHANDRABEN PIYUSHBHAI KOTHARI JEWELEX INSTITUTE OF NURSING",
  "INDU NURSING SCHOOL VADODARA",
  "VIRENDRA P SHAH NURSING ACADEMY RAJKAVADO PATAN",
  "GKT-Training College for the Teachers of the Mentally Retarded",
  "Vrundavan Polytechnic in Animal Husbandary",
  "A TO Z COLLEGE OF NURSING SCIENCE AND RESEARCH",
  "MAHILA ADHYAPAN MANDIR ZALOD",
  "ANM SCHOOL, COMMUNITY HEALTH CENTRE, BAGSARA",
  "SARASWATI SCHOOL OF NURSING RADHANPUR",
  "SHRI MAA SHARDA ADHYAPAN MANDIR PTC COLLEGE SURENDRANAGAR",
  "MUNISEVA ASHRAM SCHOOL OF NURSING VADODARA",
  "MTS. D.B. PATEL B.ED. COLLEGE FOR GIRLS RAJKOT",
  "BANKER NURSING INSTITUTE VADODARA",
  "ANJUMAN EDU PURUSH PTC COLLEGE BALASINOR",
  "SHREE LAXMIPATI MAHAVIR NURSING SCHOOL",
  "SHREE K M BORISAGAR SCHOOL OF NURSING, KHAMBHA",
  "SHREEJI PTC COLLEGE SABARKANTHA",
  "MAHILA ADHYAPAN MANDIR BABAPUR",
  "SCHOOL OF NURSING, GENERAL HOSPITAL, NADIAD",
  "ANJUMAN EDU MAHILA PTC COLLEGE BALASINOR",
  "Mahatma Gandhi SON, Junagadh",
  "L.R. RAV PRIMARY TEACHER TRAINING COLLEGE SABARKANTHA",
  "AMINABEN M GANGAT MEMORIAL SCHOOL OF NURSING SURAT",
  "AMAR BHARATI MAHILA ADHYAPAN MANDIR GANDHINAGAR",
  "Akshar School of Nursing, Bhiloda",
  "ADHYAPAN MANDIR VALLABH VIDHYALAYA BOCHASAN KHEDA",
  "SMT Sharmishtaben niranjanbhai parikh Nursing College",
  "SHREE DIVINE INSTITUTE OF NURSING",
  "Dadhichi Diploma Polytechnic College",
  "RIDDHI POLYTECHNIC IN ANIMAL HUSBANDRY",
  "THE NEW PROGRESSIVE COLLEGE OF FINE ARTS MEHSANA",
  "SCHOOL OF NURSING(GNM), CIVIL HOSPITA, DAHOD",
  "PATANJALI NURSING SCHOOL HALVAD",
  "UMIYA MAHILA NURSING COLLEGE SHREE KADVA PATEL KELVANI MANDAL DHROL",
  "SMT M M PATEL GNM NURSING COLLEGE",
  "stree adhyapan mandir Anera",
  "SCHOOL OF NURSING, M G G HOSPITAL, NAVASARI",
  "SCHOOL OF NURSING, SHETH V. S. HOSPITAL, ELISBRIDGE, AHEMDABAD",
  "SHRI K.D.BARAD SMARAK TRUST JUNAGADH",
  "SHRI MAA SHARDA SCHOOL OF NURSING JORAVARNAGAR",
  "SCHOOL OF NURSING, SIR PARTAP GENERAL HOSPITAL, HIMATNAGAR",
  "SETH SHRI LAKSHMI BHAI NAPUR PRIMARY TEACHER TRAINING COLLEGE KUTCH",
  "Set Institute of Nurisng, Junagadh",
  "SHRI SANKET PATEL MEMORIAL NURSING COLLEGE",
  "GOVERNMENT  NURSING SCHOOL, MEHSANA",
  "SHANTI BUSINESS SCHOOL",
  "ADARSH ART TEACHERS TRAINING COLLEGE",
  "SHARDA INSTITUTE OF NURSING, PETHAPUR",
  "SMT MAJA BEN CHANDULAL PATEL STREE ADHYAPAN MANDIR BRODA",
  "Maa Kaamal Medical Center",
  "SHETH CHIMANLAL NAGINDAS TALIMI VIDYALAY AHMEDABAD",
  "SMT. RAJULBEN VINAYCHANDRA SHAH COLLGE OF FINE ARTS",
  "SHETH SHRI GIRDHARLAL WOMEN'S PTC COLLEGE,DAHOD",
  "SMT. MANEKBA STREE ADHYAPAN MANDIR GANDHINAGAR",
  "Aravalli School of Nursing, Juna Takhatpur",
  "SHREE C.U.SHAH STREE ADAPAN MANDIR AHMEDABAD",
  "SHREE DHARMABHKTI SCHOOL OF NURSING, BOTAD",
  "SMT. SADGUNABEN C.U.SHAH ADHYAPAN MANDIR SURENDRANAGAR",
  "Shree H. N. Sukla Nursing School, Rajkot",
  "Navsarjan Polytechnic in Animal Husbandry",
  "AHMEDABAD AVIATION AND AERONAUTICS LTD.",
  "MEDICAL SCIENCE AND NURSING COLLEGE DHROL",
  "DALIBA NURSING SCHOOL ANDROKHA (GNM)",
  "SHREE NOOTAN KELAVANI MANDAL VALSAD",
  "KESHAVAM POLYTECHNIC IN ANIMAL HUSBANDARY",
  "SMT. SHARDABEN KANTILAL PATEL PTC COLLEGE SABARKANTHA",
  "SHRI NAVYUG P.T.C. COLLEGE - KESHOD",
  "SHREE NARAYAN NURSING COLLEGE, CHHOTAUDEPUR",
  "A.K.PATEL SCHOOL OF NURSING , VALAD, GANDHINAGAR.",
  "KRISHNA NURSING SCHOOL",
  "FORWARD SCHOOL TRUST MANAGED PTC COLLEGE AMRELI",
  "EXCEL SCHOOL OF NURSING BHAVNAGAR",
  "Shankersinh Vaghela Bapu ANM School of Nursing",
  "ENTREPRENEURSHIP DEVELOPMENT INSTITUTE OF INDIA",
  "EKTA SCHOOL OF NURSING, KHEDBRHMA",
  "ANM SCHOOL, SANSKAR TIRTH- AJOL, AJOL",
  "DR SUBHAS ADHYAPAN MANDIR JUNAGADH",
  "SADHANA INSTITUTE OF NURSING, VASADVA",
  "MOTHER TERRASA SCHOOL OF NURSING",
  "SAI ANM SCHOOL OF NURSING BALAIYA CROSSING",
  "SCHOOL OF NURSING(GNM), M G S HOSPITAL, SURENDRANAGAR",
  "JAY AMBE ANM NURSING SCHOOL MOTIREL EAST",
  "ANM/ GNM GENERAL NURSING SCHOOL, GENERAL HOSPITAL, AHWA- DANG",
  "SCHOOL OF NURSING(GNM), G. K. GENERAL HOSPITAL, BHUJ- KUTCH",
  "SCHOOL OF NURSING(GNM),GENERAL HOSPITAL, RAJPIPLA, NARMADA",
  "SCHOOL OF NURSING(GNM), CIVIL HOSPITAL,  PALANPUR, BANASKANTHA",
  "National Institute of Pharmaceutical Education and Research (NIPER) - Ahmedabad",
  "M.Y. PATEL SCHOOL OF NURSING, ATKOT",
  "AARYADEEP INSITUTE OF NURSING MESAN",
  "SHREE SWAMI VIVEKANAND D EL ED COLLEGE",
  "VIJAY INSTITUTE OF NURSING",
  "SANKALP SCHOOL OF NURSING",
  "SMT. S.K.BORWAL WALA MAHILA ADHYAPANA MANDIR VALSAD",
  "HARI KRISHNA COLLEGE OF NURSING",
  "SHARDABA NURSING COLLEGE, VANKANER",
  "UDAN NURSING INSTITUTE",
  "SMT S S PATEL PTC COLLEGE DAHOD",
  "ST. KABIR INSTITUTE OF PROFESSIONAL STUDIES",
  "STREE ADHYAPAN MANDIR AHMEDABAD",
  "SURAJBA STREE ADHYAPAN MANDIR ANAND",
  "SHREE BAJRANGDAS BAPA SHAIKSHANIK SANKUL,",
  "SWAMI VIVEKANAND PTC COLLEGE KHEDA",
  "BLIND WELFARE COUNCIL",
  "TAKSHASHILA PTC COLLEGE SURENDRANAGAR",
  "THAKORBHAI NATHUBHAI PTC COLLEGE BHARTHANA (VESU)",
  "PRERNA SCHOOL OF NURSING",
  "THE FAIZ BRIGHT NURSING SCHOOL, VAKANER",
  "TAPI NURSING SCHOOL",
  "SHREE SWAMINARAYAN INSTITUTE OF NURSING",
  "NILAM INSTITUTE OF NURSING",
  "TIRUPATI SCHOOL OF NURSING, VADODARA",
  "VIVEKANAND NURSING COLLEGE",
  "AHMEDABAD INSTITUTE OF HOSPITALITY MANAGEMENT",
  "GENERAL NURSING SCHOOL SABARIDHAM SCHOOL CAMPUS VYARA",
  "GROW MORE SCHOOL OF NURSING (G.N.M.)",
  "SARTHAK NURSING COLLEGE",
  "BANAS NURSING SCHOOL  PALANPUR",
  "R M PATEL PTC COLLEGE JEPUR",
  "AARYA NURSING COLLEGE",
  "MAHANTAM NURSING COLLEGE",
  "ALL INDIA INSTITUTE OF LOCAL SELF GOVERNMENT AHMEDABAD",
  "EKLAVYA NURSING COLLEGE",
  "SADBHAV SCHOOL OF NURSING (G.N.M)",
  "SHRI K.H.DESAI PURUSH ADHYAPAN MANDIR VALSAD",
  "Shree V.K.Bhimani Nursing Institute",
  "Dr. Dayabhai Kanjibhai Ukani School of Nursing",
  "SRI ARBUDA INSTITUTE OF NURSING",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING AND NUTRITION AHMEDABAD",
  "SMT N K NURSING COLLEGE SANJELI",
  "I S DESAI SCHOOL OF NURSING",
  "SWARNIM INSTITUTE OF NURSING",
  "S H INSTITUTE OF NURSING AND RESEARCH CENTER, FULKI CROSS ROAD, NEAR VAGAHDA VILLAGE, DASADA",
  "MAA GAYATRI COLLEGE OF NURSING",
  "AMCT NURSING INSTITUTE",
  "JAY DWARKADHISH INSTITUTE OF NURSING,KAILASHBHAWAN, LAMBADIYA ROAD,KHERAJ,KHEDBRAMHA",
  "VANDANA NURSING AND PARA MEDICAL COLLEGE",
  "VEDANT INSTITUTE OF NURSING",
  "SHREE NARMADA INSTITUTE OF NURSING AND RESERCH CENTER",
  "K J SCHOOL OF NURSING MAKHIYALA JUNAGADH",
  "VANSDA INSTITUTE OF NURSING EDUCATION",
  "SILVER OAK INSTITUTE OF BUSINESS MANAGEMENT",
  "BIRSA MUNDA COLLEGE OF NURSING",
  "ADARSH GNM COLLEGE OF NURSING BHABHAR",
  "SHREE BALAJI NURSING COLLEGE BHILODA",
  "SHREE GYANMANDIR PTC COLLEGE PALANPUR",
  "G G MORIWALA INSTITUTE OF NURSING",
  "SHREE SAHJANAND COLLEGE OF NURSING",
  "VISHVAMANGLAM INSTITUTE OF NURSING AND RESEARCH CENTER",
  "NAVJIVAN INSTITUTE OF NURSING",
  "EKTA COLLEGE OF NURSING",
  "ASH SCHOOL OF NURSING VIJAPUR",
  "TATHYA NURSING COLLEGE",
  "RAGHAV SCHOOL OF NURSING",
  "N D NAKUM INSTITUTE OF NURSING",
  "ADWAIT NURSING COLLEGE JASARA",
  "RADHE INSTITUTE OF NURSING, VADANA BHABHAR",
  "UMA INSTITUTE OF NURSING",
  "Shree Shankar School of Nsg., Munund",
  "CLIMAX INSTITUTE OF NURSING, PANTHAWADA",
  "Shree Saraswati CON, Gir-Gadhda",
  "Shree Sai School of Nursing, Visnagar",
  "Sheth C. N. College of Fine Arts",
  "D M GORIYA INSTITUTE OF NURSING",
  "SMT M.M.PATEL PTC COLLEGE, VIJAYNAGAR",
  "ADIVASI INSTITUTE OF NURSING",
  "SHRI GANESH NURSING SCHOOL RALGON",
  "POLYTECHNIC IN ANIMAL HUSBANDRY KHADASALI",
  "Mehsana District Bank School Of Nursing",
  "GCS SCHOOL OF NURSING",
  "Training College For the Teachers of the Deaf and Blind",
  "PRIMARY TEACHER TRAINING COLLEGE BHAVNAGAR",
  "SHRI NANALAL BHANUSHANKAR VYAS PTC COLLEGE AMRELI",
  "P R TRAINING COLLEGE AHMEDABAD",
  "PRANAM PRIMARY TEACHERS TRAINING COLLEGE SARKHEJ",
  "SHRI RAJIBEN GANDALAL GENERAL NURSING SCHOOL MEHSANA",
  "P R TRAINING COLLEGE (HINDI) AHMEDABAD",
  "SMT V M CHANDERA SCHOOL OF NURSING",
  "P R TRAINING COLLEGE (URDU) AHMEDABAD",
  "SHRI NYALKARAN NURSING COLLEGE",
  "SHRI SHIKSHAN SADHNA STRI ADHYAPAN MANDIR PTC COLLEGE AHMEDABAD",
  "P.& T. Nursing School, Bhandu",
  "KALP INSTITUTE OF NURSING - JUNAGADH",
  "PUSHPRAJ SCHOOL OF NURSING, AHMEDABAD",
  "SHRI SHIVSHKTI DHAM PTC COLLEGE & CHARITABLE TRUST NAVSARI",
  "Ratanba School of Nursing, Virpur",
  "SHRI U J BARAD PTC COLLEGE SUTRAPADA",
  "RIDDHI SCHOOL OF NURSING, HIMATNAGAR",
  "Royal Internation School of Nsg., Vadodara",
  "P M PATEL COLLEGE OF EDUCATION ANAND",
  "SIGMA INSTITUTE OF NURSING VADODARA",
  "SHRI M L DOSHI MAHILA ADHYAPAN MANDIR SURENDRANAGAR",
  "Saraswat ANM School, Valsad",
  "SARASWATI PTC COLLEGE GHADI",
  "SINGHI INSTITUTE OF NURSING AHMEDABAD",
  "SARDAR VALLABHBHAI PRABHAS ADHYAPAN MANDIR PRABHAS PATAN JUNAGADH",
  "SARDAR VALLABHBHAI STREE ADHYAPAN MANDIR KHED",
  "SARKARI MAHILA ADHYAPAN MANDIR VADODARA",
  "SKLP Insitute of Nursing, Bhuj",
  "SARSWATI STRI ADHYAPAN MANDIR AHMEDABAD",
  "SATKEVAL PRI TEACHERS TRAINING COLLEGE SARSA",
  "S.M. MODI BASIC TRAINING COLLEGE MEHSANA",
  "SCHOOL OF NURSING, ATMAVALLABH HOSPITAL, IDAR",
  "SCHOOL OF NURSING, CHC & REFERAL HOSPITAL , VYARA",
  "OUR LADY OF PILLAR NURSING SCHOOL, SANAND",
  "NIRMALA GAJWANI SCHOOL OF NURSING KUTCH",
  "SHRI M.A.MEHTA MUNICIPAL MAHILA ADHYAPAN MANDIR JAMNAGAR",
  "NDC INSTITUTE OF AIRCRAFT MAINTENACE ENGINEERING VADODARA",
  "SCHOOL OF NURSING, GENERAL HOSPITAL, BHARUCH",
  "National Institute of Occupational Health",
  "SMT AMARDEEP PTC COLLEGE PILVAI",
  "SCHOOL OF NURSING, GENERAL HOSPITAL GODHRA",
  "SHRI MAHILA ADHYAPAN MANDIR SAVARKUNDLA",
  "SCHOOL OF NURSING, GENERAL HOSPITAL, MANDVI",
  "NAI TALIM ADHYAPAN MANDIR SURAT",
  "ST TERESA INCLUSIVE SCHOOL",
  "POLYTECHNIC EDUCATION & TRAINING INSTITUTE 9TH MILESTONE KAITHAL ROAD",
  "GOVERNMENT POLYTECHNIC LISANA (REWARI)",
  "ARAVALI COLLEGE OF PHARMACY VILLAGE AND POST GOKALGARH",
  "Rao Mohar Singh College of Pharmacy",
  "Modish Institute of Polytechnic",
  "SANSKARAM COLLEGE OF PHARMACY",
  "BKN GOVT. POLYTECHNIC NARNAUL",
  "BPS MAHILA POLYTECHNIC",
  "NEKI RAM NURSING COLLEGE",
  "MKM COLLEGE OF POLYTECHNIC FOR GIRLS",
  "BRIGHT SCHOOL OF NURSING",
  "NEW KANSHI DED TRAINING SCHOOL BEHBALPUR HISAR",
  "SAT PRIYA COLLEGE OF PHARMACY",
  "BALAJI COLLEGE OF PHARMACY",
  "ANM TRAINING CENTRE NARNAUL",
  "PARAMOUNT SCHOOL OF NURSING JHAJJAR",
  "GOVERNMENT POLYTECHNIC FOR WOMEN SIRSA",
  "AIT KANINA GAHARA ROAD KANINA, MAHENDERGARH",
  "CR INSTITUTE OF EDUCATION",
  "NIC COLLEGE OF EDUCATION",
  "GENERAL HOSPITAL BHIWANI",
  "AMAN INSTITUTE OF EDUCATION",
  "SHIVA DIVYANG KALYAN AND PUNARWAS KENDRA",
  "PARADISE COLLEGE OF EDUCATION JAURASI",
  "PIONEER DED COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KAITHAL",
  "EVEREST SCHOOL OF NURSING YAMUNANAGAR",
  "MANAV LAKSHYA SCHOOL OF NURSING BHUNA FATEHABAD",
  "ADARSH COLLEGE OF EDUCATION",
  "CH RAJMAL  MEMIROAL COLLEGE OF EDUCTION",
  "JAI MATA SCHOOL OF NURSING AND MEDICAL SCIENCES",
  "LR COLLEGE OF PHARMACY VPO HATHIN PALWAL",
  "Shri Chamatkari Santji College of Nursing Girawar",
  "SHAKTI COLLEGE OF EDUCATION",
  "MUKHI POLYTECHNIC GOHANA WARD NO. 12 VISHNU NAGAR",
  "AASTHA INSTITUTE FOR DIVYANGJAN",
  "JAI BAJRANG BALI MPHW M TRAINING CENTRE UNCHI BHANDORE",
  "ARYA DED TRAINING SCHOOL    ",
  "G C COLLEGE OF EDUCATION TAURU",
  "Baba Saheb Ambedkar Polytechnic, VPO, MP Majra",
  "SAVITRI DEVI COLLEGE OF EDUCATION KANINA",
  "MODERN INSTITUTE OF EDUCATION",
  "OM INSTITUTE OF POLYTECHNIC, HISAR",
  "RAO JAGAN SINGH MEMORIAL COLLEGE OF PHARMACY",
  "SARASWATI MODERN COLLEGE OF PHARMACY MOHNA FARIDABAD",
  "SVM COLLEGE OF PHARMACY",
  "DEV INSTITUTE OF MEDICAL SCIENCES SAMAIN ROHTAK",
  "ROYAL COLLEGE OF PHARMACY",
  "RAGHUNATH COLLEGE OF PHARMACY",
  "Tirupati College of Polytechnic and Pharmacy",
  "SUNRISE COLLEGE OF EDUCATION SALOONI",
  "RAMA SCHOOL OF NURSING KAITHAL",
  "SARASWATI VIDYA MANDIR VPO CHANG, BHIWANI",
  "SOMANY COLLEGE OF PHARMACY",
  "G R COLLEGE OF EDUCATION DEROLI AHIR",
  "JR Kissan College of Pharmacy and Health Science",
  "GOVERNMENT POLYTECHNIC BHIWANI",
  "GOVERNMENT POLYTECHNIC  MALAB, NUH",
  "PDMIET KARSINDHU (SAFIDON)",
  "AADHAR COLLEGE OF SPECIAL EDUCATION",
  "J M REHABILITATION AND RESEARCH CENTRE",
  "VISHAV BHARTI MPHW MALE TRAINING SCHOOL VPO BARWALA HISAR",
  "SHRI BABA YOGI NETANATH HOSPITAL AND NURSING COLLEGE",
  "MDCOLLEGEOFEDUCATIONHAFIZPUR",
  "GOVERNMENT POLYTECHNIC AMBALA",
  "J R INSTITUTE OF EDUCATION",
  "ANM TRAINING SCHOOL OF NURSING ,GURUGRAM",
  "ASHTVINAYAK COLLEGE OF PHARMACY",
  "JHANKAR COLLEGE OF PHARMACY",
  "LAWRENCE COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC MANESAR",
  "LN INSTITUTE OF TECHNOLOGY",
  "GOVERNMENT POLYTECHNIC MANDI ADAMPUR",
  "CHETNA SCHOOL OF NURSING PILLUKHERA JIND",
  "ANM SCHOOL OF NURSING, GENERAL HOSPITAL, SIRSA",
  "BRIGHT REHABILITAION CENTRE",
  "BABA KHYALI NATH COLLEGE OF EDUCATION",
  "GURU SAIN BHAGAT HEALTH INSTITUTE JEEWAN JYOTI HOSPITAL BASANT VIHAR KARNAL",
  "STATE HEALTH AND FAMILY WELFARE TRAINING CENTRE PGIMS CAMPUS ROHTAK",
  "GURUSAIN BHAGAT HEALTH INSTITUTE VPO RINDAL KARNAL",
  "SARWAN COLLEGE OF EDUCATION",
  "UPKAR MPHW MALE TRAINING SCHOOL SISAR KHAS TEHSIL  MEHAM  DISTT ROHTAK",
  "SH RAM GOPAL MPHW (M) TRAINING SCHOOL",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING &  TECHNOLOGY",
  "SHRI KRISHAN COLLEGE OF EDUCATION BHUNGARKA, NARNAUL",
  "SKS COLLEGE OF EDUCATION",
  "HOLISTIC INSTITUTE OF HEALTH SCIENCES",
  "BALA JI INSTITUTE OF HEALTH AND MEDICAL EDUCATION",
  "RDR JANSEWA SCHOOL OF NURSING",
  "BHANTI DEVI SCHOOL OF NURSING SANDLANA HISAR",
  "THOMAS EDISON INCLUSIVE SCHOOL, COLLEGE OF SPECIAL EDUCATION    ",
  "LORD KRISHNA COLLEGE OF EDUCATION",
  "PT. L. R. SCHOOL OF PHARMACY",
  "VIJAY INSTITUTE OF NURSING",
  "SAT KABIR COLLEGE OF PHARMACY",
  "MCM SCHOOL OF NURSING KILAZAFARGARH JIND",
  "HOLISTIC EDUCATION SOCIETY",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BHIWANI",
  "ST ANDREWS COLLEGE OF PHARMACY",
  "R.P. INSTITUTE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC INDRI",
  "GOVERNMENT POLYTECHNIC EDUCATION SOCIETY, MORNI",
  "GOVT ANM TRAINING SCHOOL FARIDABAD",
  "GVN POLYTECHNIC COLLEGE",
  "GOVERNMENT POLYTECHNIC SONEPAT",
  "ADARSH DED COLLEGE",
  "CCC School of Nursing",
  "SVM SCHOOL OF NURSING VPO CHANG",
  "SHIVALIK DED COLLEGE OF EDUCATION",
  "GOVERNMENT INSTITUTE FOR TRAINING OF TRAINERS (GITOT)",
  "Institute of Hotel Management Catering Technology and Applied Nutrition, Jyotisar, Kurukshetra",
  "P M COLLEGE OF PHARMACY",
  "ANM SCHOOL OF NURSING MANDIKHERA MEWAT",
  "SHRI SANATAN DHARAM INSTITUTE OF PHARMACY & MEDICAL TECHNOLOGY",
  "SARV HND COLLEGE OF PHARMACY",
  "BHARAT COLLEGE OF EDUCATION KANDROLI",
  "NAVEEN COLLEGE OF PHARMACY",
  "SHIV SHANKAR COLLEGE OF EDUCATION KAITHAL",
  "CITY COLLEGE",
  "MD COLLEGE OF EDUCATION",
  "MODERN DED COLLEGE KHARKARA",
  "RCM COLLEGE OF EDUCATION KOSLI",
  "ARYABHATT COLLEGE OF NURSING",
  "NAV NIRMAN REHABILITATION AND RESEARCH CENTER, BARWALA  HISAR",
  "THE LALIT SURI HOSPITALITY SCHOOL",
  "NALANDA ELEMENTRY TEACHERS EDUCATION",
  "HERITAGE SCHOOL OF NURSING, TOHANA",
  "GOVT. POLYTECHNIC SHERGARH KAITHAL",
  "NARYANA COLLEGE OF EDUCATION BHATTU MANDI",
  "BANBHORI COLLEGE OF NURSING",
  "BABA SWAMI DAYAL SCHOOL OF NURSING",
  "AMAR JYOTI FOUNDATION",
  "GREEN VALLEY SPECIAL SCHOOL, JAMALPUR",
  "GENERAL HOSPITAL SCHOOL OF NURSING DIST ROHTAK HARYANA",
  "NATIONAL MPHW MALE TRAINING SCHOOL, BEHBALPUR, HISAR",
  "NCP COLLEGE OF POLYTECHNIC",
  "GNM SCHOOL OF NURSING",
  "D C JAIN SCHOOL OF NURSING",
  "DR RAGHBIR SINGH COLLEGE OF EDUCATION JUNDLA",
  "BALAJI COLLEGE OF PHARMACY",
  "SANJEEVNI COLLEGE OF PHARMACEUTICAL SCIENCES",
  "NAV GYAN INSTITUTE OF EDUCATION KOTHAL KALAN",
  "INDERPRASTHA COLLEGE OF EDUCATION",
  "PHOGAT NURSING SCHOOL",
  "GOVERNMENT POLYTECHNIC JHAJJAR",
  "AMBALA INSTITUTE OF HOTEL MANAGEMENT",
  "GNM SCHOOL OF NURSING, GENERAL HOSPITAL, HISAR",
  "S D COLLEGE OF PHARMACY, VILLAGE JANAULA, PATAUDI ROAD, FARUKHNAGAR, DISTRICT GURGAON",
  "NATIONAL COUNCIL FOR CEMENT AND BUILDING MATERIALS",
  "SHIVAM COLLEGE OF EDUCATION",
  "Great Lakes Institute of Management, Gurgaon",
  "BMP COLLEGE OF PHARMACY",
  "ARYA COLLEGE OF PHARMACY",
  "SARVODYA COLLEGE OF PHARMACY",
  "SWAMI VIVEKANAND TEACHER TRAINING INSTITUTION",
  "LALA AMI CHAND COLLEGE OF PHARMACY",
  "RAO KHEMCHAND PHARMACY COLLEGE",
  "Rama and Krishana College of Pharmacy Maksuspur Narnaul",
  "Ch.Ranbir Singh Government Polytechnic Hathnikund",
  "Geetanjali Institute of Teacher Training",
  "Govt. Polytechnic, Chhapar, Charkhi Dadri",
  "HARNAM SINGH COLLEGE OF PHARMACY VILL KHERI BATTER DISTT AND TEH CH DADRI",
  "DVM COLLEGE OF PHARMACY",
  "SANT GANGA NATH SCHOOL OF NURSING, KITLANA, BHIWANI",
  "AERP-ITM POLYTECHNIC",
  "SWAMI VIVEKANAND PARAMHANS COLLEGE OF NURSING",
  "VIGYA COLLEGE OF PHARMACY",
  "Modern International College of Pharmacy",
  "Translational Health Science and Technology Institute",
  "GAURAV COLLEGE OF PHARMACY",
  "S S SCHOOL OF NURSING ST FLOUR AGNIHOTRI EYE HOSPITAL BARWALA ROAD HISAR",
  "DR SHANTI YADAV SCHOOL OF NURSING REWARI",
  "TORCH BEARERS INSTITUTE OF PHARMACY",
  "S D COLLEGE OF NURSING",
  "MAHAGYANI RISHI ASHTAVAKRA KENDRA GOVT POLYTECHNIC PANCHKULA",
  "HARYANA WELFARE SOCIETY FOR PERSONS WITH SPEECH AND HEARING IMPAIRMENT",
  "JBDM COLLEGE OF SPECIAL EDCUATION",
  "RAO ADAL SINGH COLLEGE OF PHARMACY",
  "HARSH MEMORIAL COLLEGE OF PHARMACY",
  "South Point School Of Polytechnic Sonipat",
  "BKN COLLEGE OF PHARMACY",
  "RAMCHANDER MEMORIAL COLLEGE OF PHARMACY",
  "NATIONAL NURSING INSTITUTE",
  "GAJRAJ NURSING INSTITUTE",
  "GENERAL HOSPITAL GOVT ANM TRAINING SCHOOL AMBALA CITY",
  "SARASWATI MPHW M TRAINING SCHOOL VILLAGE ASALWAS DUBIA BHIWANI",
  "SAVITRI JINDAL INSTITUTE OF NURSING UNDER OM SAVITRI JINDAL CHARITABLE SOCIETY MODEL TOWN HISAR",
  "ARUN JAITLEY NATIONAL INSTITUTE OF FINANCIAL MANAGEMENT, FARIDABAD",
  "BHARAT INSTITUTE OF NURSING",
  "NICMAR INSTITUTE OF CONSTRUCTION MANAGEMENT AND RESEARCH    ",
  "APNA COLLEGE",
  "AADHAR HEALTH INSTITUTE",
  "GOVT MPHW M TRAINING SCHOOL GENERAL HOSPITAL SONIPAT",
  "S D INSTITUTE OF EDUCATION",
  "ADARSH SCHOOL OF NURSING",
  "M.D.N. SCHOOL OF NURSING, KALAYAT, KAITHAL",
  "Government Polytechnic Panchkula",
  "MATA SAHIBKAUR COLLEGE OF PHARMACY",
  "MA SARBATI COLLEGE OF EDUCATION",
  "Soil School of Business Design",
  "PHILADELPHIA HOSPITAL AMBALA",
  "Govt. Polytechnic Dhangar",
  "LORD SHIVA SCHOOL OF NURSING SIRSA",
  "GOVERNMENT POLYTECHNIC CUM MULTI SKILL TRAINING CENTRE DHAMLAWAS REWARI",
  "XLRI XAVIER SCHOOL OF MANAGEMENT DELHI NCR",
  "R S MEMORIAL COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC FOR WOMEN FARIDABAD",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY and APPLIED NUTRITION ROHTAK",
  "GURU DAKSH GOVERNMENT POLYTECHNIC HISAR",
  "GOVT POLYTECHNIC UMRI KURUKSHETRA",
  "PAVITRA INSTITUTE OF PHARMACY",
  "RAS COLLEGE OF PHARMACY",
  "RANI LAXMI BAI COLLEGE OF  EDUCATION",
  "ADARSH SCHOOL OF NURSING",
  "MAA OMWATI INSTITUTE OF PHARMACY     ",
  "SD INSTITUTE OF PHARMACY, VILLAGE FARIDPUR, NEAR TOLL PLAZA",
  "MSME TECHNOLOGY CENTRE  ROHTAK",
  "SKS COLLEGE OF PHARMACY",
  "NATIONAL SCHOOL OF NURSING FATEHABAD",
  "PATAUDI COLLEGE OF PHARMACY",
  "JRM NURSING COLLEGE",
  "R K COLLEGE OF PHARMACY",
  "MISRI DEVI REHABILITATION CENTER",
  "MANAGEMENT DEVELOPMENT INSTITUTE",
  "CHHOTU RAM POLYTECHNIC",
  "ADARSH COLLEGE OF EDUCATION DEHRA",
  "RED CROSS HINDU INSTITUTE FOR EDUCATION AND REHABILITATION OF MENTALLY CHALLENGED CHILDREN",
  "GOVT POLYTECHNIC RAJPUR SADHAURA",
  "HARYANA COLLEGE OF EDUCATION FOR WOMEN    ",
  "ST PAULS COLLEGEOF EDUCATION    ",
  "Haryana Institute of Civil Aviation",
  "SHEELA DEVI INSTITUTE OF MANAGEMENT AND TECHNOLOGY (SDIMT)",
  "Raja jait Singh Govt. Polytechnic",
  "JK BUSINESS SCHOOL",
  "INDIANA BITS INSTITUTE OF EDUCATION",
  "BALAJI SCHOOL OF NURSING, BHIWANI",
  "AERP INSTITUTE OF PHARMACY",
  "Govt. Polytechnic Nanakpur",
  "SARDAR AJIT SINGH COLLEGE OF EDUCATION",
  "SHRI SHIV MANDIR SANATAN DHARAM SR SEC SCHOOL AND DED CENTRE, UCHANA KALAN JIND",
  "Govt. Polytechnic, Jamalpur Shekhon",
  "UNITED INSTITUTE OF PHARMACY",
  "NIHAL SINGH COLLEGE OF PHARMACY",
  "Cambridge College of Pharmacy",
  "BHARAT GENERAL NURSING & MIDWIFERY INSTITUTE KURUKSHETRA",
  "Naveen Institute of Nursing",
  "GYAN GANGA COLLEGE OF PHARMACY",
  "LAL BAHADUR SHASTRI COLLEGE OF PHARMACY ",
  "EDUCATION CONCERN SOCIETY FOR DEVELOPMENT OF PERSON WITH SPECIAL NEEDS",
  "DR BR AMBEDKAR INSTITUTE OF PHARMACY",
  "SANT ISHAR SINGH COLLEGE OF NURSING, PEHOWA",
  "SARITA JAIN COLLEGE OF PHARMACY",
  "MANGE RAM COLLEGE OF PHARMACY",
  "KESHAV COLLEGE OF PHARMACY, VPO MATANI, SIWANI",
  "SWAMI VIVEKANAND COLLEGE OF EDUCATION VPO ALAHAR TEHSIL RADAUR",
  "MODISH INSTITUTE OF PHARMACY",
  "RAO NET RAM COLLEGE OF PHARMACY, SALIMPUR",
  "MAHARSHI KASHYAP GOVT POLYTECHNIC JATTAL",
  "MKM INSTITUTE OF PGDM",
  "DBM COLLEGE OF PHARMACY VPO MADINA GOHANA",
  "VIDYA DEVI COLLAGE OF EDUCATION",
  "CHANDERMUKHI SCHOOL OF NURSING",
  "GURU TEG BAHADUR EDUCATION AND HEALTH CENTER NARWANA",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION, YAMUNANAGAR",
  "INSTITUTE OF HOTEL MANAGEMENT, FARIDABAD",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION, PANIPAT",
  "Lal Bahadur Shastri School of Nursing",
  "GANPATI POLYTECHNIC FOR ENGINEERING BILASPUR JAGADHRI",
  "GANDHI SCHOOL OF NURSING KARNAL",
  "YASHVIR MEMORIAL TECHNICAL INSTITUTE BHAMBHEWA",
  "YAMUNA POLYTECHNIC FOR ENGINEEING VILL. GADHOLI TEHSIL JAGADHARI",
  "GANDHI COLLEGE OF PHARMACY, KARNAL",
  "VINAYAK COLLEGE OF POLYTECHNIC VILL. KACHWA",
  "VAISH TECHNICAL INSTITUTE",
  "TAGORE INSTITUTE OF RESEARCH & TECHNOLOGY JAMALPUR",
  "DR. BHIM RAO AMBEDKAR INSTITUTE OF TECHNOLOGY VILL FATEHPUR",
  "SWAMI DEVI DYAL COLLEGE OF TECHNICAL EDUCATION GOLPURA, BARWALA",
  "SWAMI DEVI DAYAL INSTITUTE OF PHARMACY VILL. GOLPURA TEHSIL BARWALA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KURUSHETRA",
  "STAR AVIATION ACADEMY GURGAON",
  "S O S NURSING SCHOOL FARIDABAD",
  "IBMR BUSINESS SCHOOL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, JIND",
  "SHRI KRISHNA POLYTECHNIC. RATTAN DERA ROAD",
  "SHRI HARYANA SHEKAWATI BRAHMACHARYA BHIWANI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING HISAR",
  "SHREE RAM MULAKH COLLEGE OF TECHNICAL EDUCATION, AMBALA",
  "SHREE RAM INSTITUE OF TECHNICAL EDUCATION NH-73 MOULI (BARWALA)",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING AMBALA",
  "SHARBATI SCHOOL OF NURSING MAHINDERGARH",
  "SHAHEED UDHAM SINGH SCHOOL OF NURSING FATEHABAD",
  "SETH JAI PARKASH POLYTECHNIC DAMLA",
  "DEV POLYTECHNIC COLLEGE VLL. KHATKAR",
  "RAJIV GANDHI GOVERNMENT POLYTECHNIC ,NARWANA",
  "DEV POLYTECHNIC COLLEGE VILL. DHEEN TEHSIL BARARA",
  "SHAHEED CAPT. D.K. KHOLA POLYTECHNIC",
  "SHAHEED BABA DEEP SINGH SCHOOL OF NURSING FATEHABAD",
  "DEHAT VIKAS COLLEGE OF PHARMACY, TIGAON",
  "SETH HARBAKSH LOHIA JAIRAM MAHILA POLYTECHNIC LOHAR MAJRA",
  "SD SHANTI NIKETAN INSTITUTE OF ENGINEERING & TECHNOLOGY TOSHAM ROAD LADWA",
  "DEEN BANDHU SIR CHOTU RAM GOVERNMENT POLYTECHNIC SAMPLA",
  "DAYANAND PUBLIC SCHOOL SONIPAT",
  "CH. MATU RAM ARYA GOVT. POLYTECHNIC EDUCATION SOCIETY",
  "B R COLLEGE OF PHARMACY, BAGPUR",
  "SARVODAYA NURSING INSTITUTE FARIDABAD",
  "AKASH INSTITUTE OF TECHNOLOGY",
  "RANI JHANSI LAXMI BAI GOVT. POLYTECHNIC LOHARU",
  "RAJENDRA SCHOOL OF NURSING SIRSA",
  "MD COLLEGE OF POLYTECHNIC SONALI ROAD",
  "MATA SHANTI DEVI INSTITUTE OF NURSING SIRSA",
  "L.R. INSTITUTE OF TECHNOLOGY & MANAGEMENT VILL. DEEGHOT TEHSIL HODAL",
  "GOVERNMENT POLYTECHNIC MANDKOLA",
  "KRISHNA POLYTECHNIC VPO JHAL TEHSIL KOSLI",
  "KALPANA CHAWLA GOVT. POLYTECHNIC FOR WOMEN",
  "JKP POLYTECHNIC RATTANGARH",
  "JIND POLYTECHNIC COLLEGE 1ST MILE STONE PANIPAT ROAD",
  "GYAN GANGA POLYTECHNIC SALPANI KHURD NEAR HEENGA KHER. JHASNA ROAD",
  "GURU GOBIND SINGH GOVT.POLYTECHNIC EDUCATION SOCIETY",
  "GURU BRAHMANAND JI GOVT. POLYTECHNIC NILOKHERI",
  "GOVT ELEMENTRY TEACHER TRAINING INSTITUTE PANCHUKULA",
  "GOVT ELEMENTARY TEACHER TRAINING FEROZEPUR NAMARE GURGAON",
  "GOVERNMENT POLYTECHNIC UTTAWAR",
  "GOVERNMENT POLYTECHNIC SIRSA",
  "GOVERNMENT POLYTECHNIC MEHAM",
  "CH. DEVI LAL GOVERNMENT POLYTECHNIC NATHUSRI CHOPTA",
  "RADHA SWAMI NURSING COLLEGE",
  "TAGORE COLLEGE OF PHARMACY JAMALPUR",
  "KRISHNA COLLEGE OF PHARMACY",
  "APEX INSTITUTE OF PHARMACY",
  "HKSD SCHOOL AND COLLEGE OF NURSING HISAR",
  "KHUSHI SCHOOL OF NURSING",
  "CH BHAGMAL SCHOOL OF NURSING HISAR",
  "SWASTIK COLLEGE OF EDUCATION",
  "DPG POLYTECHNIC GURUGRAM",
  "vidyawati college of education mohindergarh (D.ed.) affiliated to bhiwani board, ncte",
  "SSD COLLEGE OF EDUCATION KHATOTI KHURD",
  "SMC COLLEGE OF EDUCATION KHATOTI KHURD",
  "UPDESH ELEMENTARY TEACHERS EDUCATIONAL INSTITUTE",
  "SHRI RAM INSTITUTE OF EDUCATION and TECHNOLOGY",
  "SHIVALIK COLLEGE OF EDUCATION",
  "K.N. COLLEGE OF EDUCATION CHARKHI DADRI",
  "sehrawat college of pharmacy hathin distt palwal",
  "SH. SOM PRAKASH VATS MEMORIAL COLLEGE OF EDUCATION",
  "SWAKAR SCHOOL OF NURSING",
  "ABHILASHI JBT TRAINING INSTITUTE MANDI",
  "BABU JAGJIVAN RAM CHARITABLE EDUCATIONAL TRUST",
  "DAWARKA DASS MEMORIAL SAI INSTITUTE OF EDUCATION TRAINING HAMIRPUR",
  "VINAYAKA INSTITUTE OF PHARMACY",
  "DEVASYA (WOMEN) POLYTECHNIC VILL- BAZURI PO TEHSIL & DISTT. HAMIRPUR",
  "CIPET  CSTS  BADDI",
  "DEV BHUMI POLYTECHNIC VILL- CHANDPUR NEAR LALEHARI TEHSIL HROLI DISTT. UNA",
  "DISTRICT HOSPITAL MANDI",
  "JAI BHARTI COLLEGE OF EDUCATION LOHARIAN, HAMIRPUR",
  "HIMALYAN INSTITUTE OF NURSING COLLEGE THAKUR KARAM SINGH CHARITABLE TRUST TEHSIL PRAGPUR DISTT KANGRA HP    ",
  "SIRDA(WOMEN) POLYTECHNIC VILL. TROAT, P.O KANAID, SUNDERNAGAR, MANDI",
  "SHANTI NIKETAN COLLEGE OF PHARMACY RATTI, SUNDERNAGAR, MANDI",
  "JEEVAN REKHA SCHOOL OF NURSING MANDI",
  "HIMACHAL INSTITUTE OF ENGINEERING AND TECHNOLOGY SHAHPUR, KANGRA",
  "GOVT. POLYTECHNIC TALWAR, (JAISINGHPUR), KANGRA",
  "GOVERNMENT POLYTECHNIC JANDAUR",
  "Skills Development Society",
  "GOVT POLYTECHNIC FOR WOMEN REHAN",
  "ADVANCE TECHNOLOGIES EDUCATION SOCIETY",
  "GOVT. POLYTECHNIC SUNDERNAGAR, MANDI",
  "GOVT. B.R. AMBEDKAR POLYTECHNIC AMBOTA, UNA",
  "GREEN HIILLS PHARMACY COLLEGE",
  "INSTITUTE OF HOTEL MANAGEMENT, HAMIRPUR",
  "GNM TRAINING SCHOOL KHANERI, SHIMLA",
  "AWASTHI INSTITUTE OF NURSING NALAGARH, SOLAN",
  "ATAL BIHARI VAJPAYEE GOVERNMENT INSTITUTE OF ENGINEERING & TECHNOLOGY SHIMLA  (DIPLOMA PROGRAMME)",
  "Skills Development School,Rohru",
  "Skills Development School",
  "AASTHA SPECIAL SCHOOL NAHAN, SIRMOUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING CHAMBA",
  "GOVT. MILLENNIUM POLYTECHNIC CHAMBA",
  "KARISHMA EDUCATIONAL CENTRE DEPARTMENT OF ELEMENTARY TEACHER EDUCATION MANDI",
  "DR RAJINDER PRASAD MEDICAL COLLEGE HOSPITAL KANGRA",
  "KAMAKSHI G N M INSTITUTE KANGRA",
  "PRIYADARSHANI COLLEGE OF PHARMACY RAIT",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BILASPUR",
  "JAKH INSTITUTE OF NURSING SHIMLA",
  "AWASTHI VETRINARY PHARMACIST TRAINING INSTITUTE",
  "GOVERNMENT POLYTECHNIC, KULLU",
  "GOVERNMENT POLYTECHNIC, KINNAUR",
  "ASAMS Education Group",
  "GNM TRAINING SCHOOL KULLU",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING HAMIRPUR",
  "HIM NAVODAYA SIKSHAN SANSTHAN CHAMBA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KOTLA KHURD UNA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KINNAUR",
  "HIMCAPES SCHOOL OF NURSING UNA",
  "SHIVALIK POLYTECHNIC VPO. BADHERA TEHSIL HAROLI DISTT. UNA",
  "HIMALYAN POLYTECHNIC SADHURA ROAD KALA AMB DISTT. SIRMOUR",
  "GOVERNMENT POLYTECHNIC, BILASPUR",
  "SCHOOL OF NURSING SIRMOUR",
  "SRI SAI CHARITABLE HOSPITAL & INSTT OF MEDICAL SCIENCES MANDI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SOLAN",
  "SCHOOL OF NURSING KULLU",
  "SWAMI SHRI RAJESHWARANAND BHARTI NURSING TRG INSTT CHAMBA",
  "GOVT. POLYTECHNIC HAMIRPUR",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING AND NUTRITION, KUFRI, SHIMLA-171012",
  "HIMALAYAN SCHOOL OF NURSING SIRMOUR",
  "CEDTI INSTITUTE OF MANAGEMENT  AND TECHNOLOGY",
  "SAI SANJEEVINI INSTITUTE OF MEDICAL SCIENCES SOLAN",
  "ASAMS Education Group, Kangra",
  "GOVT. POLYTECHNIC KANGRA",
  "GOVERNMENT POLYTECHNIC, LAHAUL & SPITI",
  "GOVT. POLYTECHNIC FOR WOMEN KANDAGHAT DISTT. SOLAN",
  "HIMACHAL INSTITUTE OF NURSING, SIRMAUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING DHARAMSHALA KANGRA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SHAMLAGHAT SHIMLA",
  "NANDA HOSPITAL UNA",
  "MAA JANAKI SCHOOL OF NURSING HAMIRPUR",
  "L.R.POLYTECHNIC OCHGHAT, SOLAN",
  "LORD MAHAVIRA PARAMEDICAL INSTITUTE SOLAN",
  "COMPOSITE REGIONAL CENTRE FOR PERSONS WITH DISABILITIES SUNDERNAGAR",
  "STATE INSTITUTE OF HOTEL MANAGEMENT, DHARAMSHALA",
  "GREEN HILLS POLYTECHNIC COLLEGE KUMARHATI SOLAN (GHEC KUMARHATI)",
  "KUSUM GUPTA & ASSOCIATES SOLAN",
  "Government GNM Training School, Bilaspur",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SIRMOUR",
  "GOVERNMENT POLYTECHNIC PAONTA SAHIB, SIRMOUR",
  "K.C.POLYTECHNIC PANDOGA UPARELA TEHSIL & DISTT. UNA",
  "GRACE SCHOOL OF NURSING KANGRA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING MANDI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KULLU",
  "DREAMZ POLYTECHNIC KHILRA P.O. MERAMASIT TEHSIL SUNDERNAGAR DISTT. MANDI",
  "Institute for Digital Education  and Allieds Studies",
  "GOVT. POLYTECHNIC ROHROO SHIMLA",
  "GOVT. POLYTECHNIC BANIKHETH CHAMBA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KEYLONG LOHOUL- SPITI",
  "SMART CAREER INSTITUTE OF INFORMATION TECHNOLOGY",
  "B R College of Paramedical Sciences",
  "MASTERMIND INSTITUTE OF EDUCATION PVT. LTD.",
  "Shri mata vaishno devi paramedical institute",
  "FLORIDA INSTITUTE OF IT PVT. LTD.",
  "B R Kohli Institute of Paramedical Studies, Ramban",
  "MULTISOFT INSTITUTE OF IT PVT. LTD.",
  "NATIONAL EDUCATION AND RESEARCH TRUST",
  "sky light computers private limited",
  "wintech educational trust hardshoora kunzer",
  "NATIONAL IT KUPWARA",
  "KASHMIR INSTITUTE OF MEDICAL SCIENCE AND TECHNOLOGY",
  "PHOENIX PARAMEDICAL COLLEGE PULWAMA KASHMIR",
  "LORDS INSTITUTE OF MEDICAL SCIENCES AND TECHNOLOGY",
  "ROYAL INSTITUTE OF PARA MEDICAL SCIENCES",
  "B N INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES SUNJWAN JAMMU",
  "FLORENCE PARA MEDICAL INSTITUTE ANANTNAG",
  "S Sidharatha Paramedical Training Institue",
  "I-TECH EDUCATIONAL TRUST",
  "JOHN BISHOP MEMORIAL HOSPITAL SCHOOL OF NURSING",
  "SAM COLLEGE OF NURSING AND PARAMEDICAL SCIENCES BEERWAH",
  "SUPREME INSTITUTE OF INFORMATION TECHNOLOGY",
  "GNM ANMT SCHOOL KATHUA",
  "GOVT ANM SCHOOL REASI",
  "GNM SCHOOL UDHAMPUR",
  "S B G M PARAMEDICAL INSTITUTE  SHOPIAN KASHMIR",
  "GOVT AMT SCHOOL BAKSHI NAGAR JAMMU",
  "GOVT GNM SCHOOL AKHNOOR",
  "GOVT ANM SCHOOL KISHTWAR",
  "NEW AGE PARAMEDICAL SCINCES PHINTER BILLAWAR",
  "MUBARAKH PARAMEDICAL TRAINING INSTITUTE HYDERPORA",
  "STJOSEPH SCHOOL OF NURSING",
  "INTECH COMPUTER EDUCATION  SYSTEMS BANDIPORA",
  "AL NOOR PARA MEDICAL INSTITUTE",
  "AWAMI WELFARE TRUST",
  "SHRI NANAK MEDICAL INSTITUTE OF HEALTH SCIENCES",
  "MAALA  AZIZ PARAMEDICAL INSTITUTE KALOOSA BANDIPORA",
  "B.M.S Institute of Paramedical Sciences Jammu",
  "Stephens Institute of Paramedical",
  "Disha Institute of Paramedical and Nursing Sciences Batote",
  "GOVERNMENT ANMT SCHOOL DODA",
  "BANDIPORA COLLEGE OF INFORMATION TECHNOLOGY",
  "AL SABOOR PARAMEDICAL INSTITUTE KULGAM",
  "SOUTH KASHMIR PARAMEDICAL COLLEGE",
  "RAJIV GANDHI INSTITUTE OF PHARMACY",
  "MMC Institute of Para-Medical Sciences",
  "SOPORE INFOTECH",
  "SAIN CHARITABLE INSTITUTE OF PARAMEDICAL SCIENCES",
  "INDIAN INSTITUTE OF PARAMEDICAL SCIENCES NAGRI KATHUA",
  "Gurukul Institute of Paramedical Studies Bhaderwah",
  "SUSHANT COLLEGE OF PHARMACY KATHUA",
  "MAHA LAXMI COLLEGE OF PHARMACY",
  "AKASH INSTITUTE OF PARA MEDICAL SCIENCES GARNAI UDHAMPUR",
  "GOVT ANMT SCHOOL   POONCH",
  "I.E.C.S PURKHOO",
  "Gupta Institue Of Paramedical And Allied Health Sciences",
  "G P C SHOPIAN",
  "TRAVANI PARAMEDICAL INSTITUTE KATRA",
  "GOVT POLYTECHNIC SAMBA",
  "Govt. Polytechnic, Ramban",
  "Govt. Polytechnic, Kishtwar",
  "GOVT. POLYTECHNIC FOR WOMEN SRINAGAR",
  "GOVT. POLYTECHNIC FOR WOMEN JAMMU",
  "Govt. Polytechnic College Reasi",
  "GOVT. POLYTECHNIC COLLEGE DODA",
  "GOVT POLYTECHNIC COLLEGE BUDGAM",
  "Govt. Polytechnic College Bandipora",
  "Government Polytechnic Kathua",
  "GOVERNMENT POLYTECHNIC JAMMU",
  "Government Polytechnic College,Pulwama",
  "GOVERNMENT POLYTECHNIC COLLEGE, POONCH",
  "Government Polytechnic College Kupwara",
  "BEE ENN NURSING INSTITUTE JAMMU",
  "AV INSTITUTE OF NURSING AND MEDICAL SCIENCES",
  "ACHARYA SHRI CHANDER INSTITUTE OF NURSING, JAMMU",
  "KUPWARA INSTITUTE OF PARAMEDICAL SCIENCES",
  "NATIONAL IT HANDWARA",
  "RIGHT TRACK INSTITUTE OF TECHNOLOGY",
  "GOVERNMENT POLYTECHNIC COLLEGE UDHAMPUR",
  "FASTRACK INSTITUTE OF IT AND COMPUTER SCIENCE AND ENGINEERING",
  "I-TECT EDUCATIONAL TRUST",
  "SMART PEN INSTITUTE",
  "I G E S INSTITUTE OF NURSING AND HEALTH SCIENCES JAMMU",
  "Indian Institute of Technical Trainings, School of Nursing",
  "J K INSTITUTE OF NURSING & PARA MEDICAL SCIENCES JAMMU",
  "KASHMIR GOVERNMENT POLYTECHNIC",
  "KITE POLYTECHNIC",
  "MASTERPRO INSTITUTE",
  "ROYAL POLYTECHNIC",
  "ICI COMPUTER EDUCATION",
  "Technology Incubation Centre",
  "GOVT ANMT SCHOOL RAJOURI",
  "RDGD MEMORIAL TRUST INSTITUTE OF PARAMEDICAL SCIENCES SAMBA",
  "NOORANI PARAMEDICAL TRAINING INSTITUTE PULWAMA",
  "GOVT AMT SCHOOL SRINAGAR",
  "HAKIM SONAULLAH INSTITUTE OF PARAMEDICAL SCIENCES SOPORE KASHMIR",
  "GOVT AMT SCHOOL ANANTNAG",
  "KASHMIR COLLEGE OF PHARMACY AND ALLIED SCIENCES",
  "GOVT AMT SCHOOL KUPWARA",
  "BR KOHLI PARAMEDICAL STUDIES MAITRA RAMBAN",
  "Green Valley Paramedical Institute Kashmir",
  "ACHARYA SRI CHANDER TECHNICAL INSTITUTE POLYTECHNIC",
  "M/S NEW COMMUNICATION CENTER",
  "S.M.S INSTITUTE OF MEDICAL SCIENCES",
  "Government Polytechnic College Ganderbal",
  "POONCH COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "JAMMU COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "Government Polytechnic College Baramulla",
  "Government Polytechnic College, Anantnag",
  "Institute of Hotel Management, Rajbagh, Srinagar",
  "Galaxy Paramedical College",
  "THINK AND WIN TECHNOLOGIES",
  "Classic Institute of Health sciences",
  "FLORENCE NIGHTINGALE SCHOOL OF NURSING",
  "SANJEEVNI INSTITUTE OF PARAMEDICAL SCIENCES",
  "INFONET COMPUTERS",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING VIJAYPUR, SAMBA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, SRINAGAR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, SHOPIAN",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, REASI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, PULWAMA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, POONCH",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KUPWARA",
  "K M TECHNICAL TRAINING AND MANAGEMENT INSTITUTE",
  "HELPAGE INSTITUTE OF TECHNOLOGY",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KULGAM",
  "BABA BUDHAN ALI SHAH PARAMEDICAL INSTITUTE CHATHA JAMMU",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KISHTWAR",
  "NARSING DEV INSTITUTE OF MEDICAL SCIENCES, UDHAMPUR",
  "NITS POLYTECHNIC",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, JAMMU",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, GANDERBAL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, DODA",
  "MATA VAISHNO DEVI INSTITUTE OF PARAMEDICAL AND HEALTH SCIENCE KATHUA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BUDGAM",
  "DATA RANPAT DEV INSTITUTE OF PARAMEDICAL AND HEALTH SCIENCE KATHUA",
  "KAWA COLLEGE OF PARA MEDICAL SCIENCES",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BASOHLI, KATHUA",
  "HARMOKH INSTITUTE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BARAMULLA",
  "GOVT SCHOOLOF NURSING BARAMULLA    ",
  "IMDAD WELFARE TRUST",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BANIHAL, RAMBAN",
  "CYBERTECH EDUCATIONAL TRUST",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BANDIPORA",
  "RB PARAMEDICAL INSTITUTE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, ANANTNAG",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING (KUD)  UDHAMPUR",
  "B R SCHOOL OF NURSING JAMMU",
  "TARAN PARAMEDICAL INSTITUTE",
  "Alma Computer",
  "INFOPARK COMPUTER EDUCATION",
  "KASHSOFT COMPUTERS",
  "Paramedical Institute of Kidney and Urological Disease Research Center",
  "Swami Vivekananda Institute of Nursing and Paramedical Sciences",
  "ALFALAH PARAMEDICAL INSTITUTE",
  "MULTISOFT INSTITUTE OF IT",
  "GNM SCHOOL PULWAMA",
  "SKYLARK INSTITUTE OF PARAMEDICAL SCIENCES PULWAMA",
  "SUPER ADVANCED COMPUTER INSTITUTE",
  "Guru Institute of Nursing and Paramedical Sciences",
  "NATIONAL INSTITUTE OF FASHION TECHNOLOGY",
  "SLV COLLEGE OF NURSING ",
  "GURU INSTITUTE OF PARAMEDICAL SCIENCES",
  "S.S.M POLYTECHNIC",
  "MADR E MEHARBAN INSTITUTE OF HEALTH SCIENCES",
  "HARMOKH SKILL TRAINING CENTER NOWPORA BANDIPORA",
  "QADRIA INSTITUTE OF PARAMEDICAL SCIENCES  ISM",
  "IQRA PARAMEDICAL INSTITUTE",
  "NEW MODERN INSTITUTE OF PARAMEDICAL AND NURSING SCIENCES KISHTWAR",
  "RAMZANA COMPUTERS",
  "TAHIRA KHANAMS INSTITUTE OF PARAMEDICAL  SCIENCES,LAWAYPORA,KASHMIR",
  "TARIQ PARAMEDICAL TRAINING INSTITUTE RAJOURI",
  "set paramedical institute pazalpora bhejbhera",
  "CATALOG COMPUTERS",
  "HUSSAIN PARA MEDICAL INSTITUTE AND NURSING SCIENCES GHAT DODA",
  "FLORENCE NIGHTINGALE INSTITUTE OF NURSING AND PARAMEDICAL SCIENCE UDHAMPUR",
  "FOOD CRAFT INSTITUTE",
  "HYATT INSTITUTE OF PHARMASUTICAL EDUCATION AND RESEARCH    ",
  "MK COLLEGE OF  PARAMEDICAL INSTITUTE VESSU QAZIGUND",
  "Al Gousia Computer Education",
  "GOVT ANMT SCHOOL BARAMULLA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, RAJOURI",
  "Green Land Paramedical Institute",
  "CYBERTECH EDUCATIONAL INSTITUTE",
  "MARAZ PARAMEDICAL TRAINING INSTITUTE PAZAL PORA BIJBEHARA",
  "GOVERNMENT POLYTECHNIC COLLEGE KULGAM",
  "KUNWAR SINGH COLLEGE OF PHARMACY",
  "ROYAL PROFESSIONAL COLLEGE",
  "COMPOSITE REGIONAL CENTRE RANCHI",
  "JHARKHAND COLLEGE OF PHARMACY",
  "SATISH KUMAR SINHA MEMORIAL COLLEGE OF PHARMACY",
  "ANM TRAINING SCHOOL, PANIIT, LATEHAR",
  "URSULINE PRIMARY TEACHERS EDUCATION COLLEGE, CHANDRAPURA, PAKUR",
  "HILL VIEW NURSING SCHOOL",
  "SHIVAM SCHOOL OF NURSING",
  "FLORENCE SCHOOL OF NURSING RANCHI",
  "VIKAS INSTITUTE OF PHARMACY",
  "BUDDHA COLLEGE OF NURSING    ",
  "ST XAVIERS INTERNATIONAL SCHOOL OF NURSING    ",
  "MERCY SCHOOL OF NURSING",
  "Istitute of Medical and Technological Science",
  "Maa Kalawati institute of Health education And Research Centre",
  "KUNWAR SINGH PHARMACY COLLEGE OF EDUCATION",
  "SHREE SAI NURSING TRAINING SCHOOL",
  "PRIMARY TEACHERS TRAINING COLLEGE CHAKULIA",
  "R S INSTITUTE OF HEALTH EDUCATION",
  "RIDHI SIDHI COLLEGE OF HEALTH EDUCATION",
  "JHARKHAND SCHOOL OF PHARMACY",
  "MOHULPAHARI NURSING SCHOOL DUMKA",
  "Nirmala Nursing School",
  "PRERNA TRUST",
  "FOOD CRAFT INSTITUTE - DEOGARH  ",
  "SNS INSTITUTE OF HEALTH EDUCATION",
  "SAHYOG COLLEGE OF MEDICAL SCIENCES",
  "KISMATI COLLEGE OF PHARMACY",
  "KALAWATI SCHOOL OF NURSING KAMRE",
  "DAYANAND ANGLO VADIC TEACHERS TRAINING COLLEGE GIRIDIH",
  "VANANCHAL SCHOOL OF NURSING",
  "PRIMARY TEACHER TRAINING COLLEGE, SIMDEGA",
  "ASARFI INSTITUTE OF PARAMEDICAL",
  "SPG WOMENS PRIMARY TEACHERS EDUCATION COLLEGE",
  "KRISHNA MURARI INSTITUTE OF MEDICAL AND HEALTH SCIENCE",
  "SOHARI CHANDRAVANSI NURSING SCHOOL",
  "GM COLLEGE OF NURSING AND PHARMACY",
  "TRIVENI COLLEGE OF PHARMACY",
  "SAROZANI NURSING COLLEGE ",
  "ASHISH NURSING PRASIKSHAN SANSTHAN CHHARDA",
  "JASLOK NURSING COLLAGE",
  "RANCHI COLLEGE OF TECHNOLOGY AND RESEARCH CENTRE",
  "OXFORD INSTITUTE OF PHARMACY",
  "KISMATI COLLEGE OF NURSING",
  "SHREE JAGANNATH INSTITUTE OF PARAMEDICAL SCIENCE",
  "DEO INSTITUTE OF NURSING SCIENCES",
  "NIRMALA DEVI NURSING SCHOOL",
  "SNK COLLEGE OF PHARMACY",
  "R P COLLEGE OF PHARMACY",
  "SNP COLLEGE OF PHARMACY",
  "DRONA COLLEGE OF PHARMACY",
  "K K SCHOOL OF NURSING",
  "NICHITPUR INSTITUTE OF HEALTH EDUCATION AND RESEARCH CENTRE",
  "JEEVAN JYOTI SCHOOL OF NURSING EAST SINGHBHUM",
  "USHA COLLEGE OF NURSING",
  "PITAMBARA COLLEGE PHARMACY",
  "DEOGHAR COLLEGE OF HEALTH EDUCATION",
  "R K COLLEGE OF NURSING",
  "JEEVAN",
  "ANITA DEVI COLLEGE OF NURSING",
  "BHARATHI COLLEGE OF PHARMACY",
  "VIDYAPATI COLLEGE OF HEALTH AND PROFESSIONAL EDUCATION",
  "H G E A COLLEGE OF PHARMACY",
  "JHARKHAND GOVERNMENT MINI TOOL ROOM AND TRAINING CENTRE, RANCHI",
  "DUMKA COLLEGE OF HEALTH AND PROFESSIONAL EDUCATION",
  "DHANVANTRI COLLEGE OF PHARMACY",
  "CITY PARAMEDICAL NURSING COLLEGE",
  "ST URSULA ANM NURSING SCHOOL KONBIR NOATOLI",
  "RAVI MAHATO SMARAK NURSING COLLEGE, MAHUDA",
  "HAZARIBAGH SCHOOL OF NURSING",
  "DHARTI AABA NURSING COLLEGE",
  "GIRIJA INSTITUTE OF PARAMEDICAL",
  "PANDA COLLEGE OF PHARMACY",
  "SALUJA GOLD COLLEGE OF PARAMEDICS",
  "DIVINE NURSING COLLEGE",
  "Maa Para Medical Institute",
  "JAMSHEDPUR PHARMACY COLEGE",
  "T A A B COLLEGE OF PHARMACY",
  "Z A ROYAL COLLEGE OF PHARMACY",
  "KALAWATI COLLEGE OF PHARMACY KAMRE",
  "KUNWAR SINGH NURSING COLLEGE OF EDUCATION",
  "ELITE PUBLIC NURSING SCHOOL",
  "Institute of Paramedical Education-A unit of Basant Dynamics",
  "AVIRAM GRAMIN VIKASH SWYAM SEVI SANSTHAN COLLEGE OF PHARMACY",
  "PEMIYA RISHIKESH COLLEGE OF PHARMACY",
  "GULAB SCHOOL OF NURSING",
  "DR B R AMBEDKAR COLLEGE OF PHARMACY",
  "ARAM INSTITUTE",
  "KISMAT COLLEGE OF PHARMACY",
  "GURUPAD PRIMARY TEACHERS TRAINING COLLEGE RANKA",
  "JASNAND NURSING COLLEGE    ",
  "Institute of Science and Management",
  "BHARAT MATA SCHOOL OF NURSING",
  "FLORENCE COLLEGE OF PHARMACY",
  "RBM COLLEGE",
  "G D  BAGARIA SCHOOL OF NURSING",
  "IDEAL ACADEMY OF NURSING EDUCATION",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION, RANCHI",
  "DEEPSHIKHA INSTITUTE FOR CHILD DEVELOPMENT AND MENTAL HEALTH A UNIT OF PURSHREE",
  "LIFE CARE NURSING SCHOOL",
  "GANDHI COLLEGE OF ALLIED SCIENCE",
  "INDEN COLLEGE OF PHARMACY",
  "SARDAR PATEL GROUP OF EDUCATION",
  "MANRAKHAN MAHTO NURSING COLLEGE",
  "BRIGHT COLLEGE OF NURSING",
  "HERITAGE PHARMACY COLLEGE",
  "NEOMEDICS COLLEGE OF NURSING",
  "BANSHIDHAR COLLEGE OF PHARMACY",
  "JEEVAN DEEP PARAMEDICAL COLLEGE",
  "MAHADEVI BIRLA INSTITUTE OF NURSING & CLINICAL TECHNOLOGY RANCHI",
  "RK PHARMACY COLLEGE",
  "J P COLLEGE OF NURSING",
  "MANRAKHAN MAHTO PHARMACY COLLEGE",
  "RAJIV COLLEGE OF HEALTH EDUCATION",
  "CONSTANT LIEVENS SCHOOL OF NURSING, MANDAR, RANCHI",
  "BOKARO INSTITUTE OF HEALTH EDUCATION",
  "DHANBAD PARAMEDICAL COLLEGE",
  "SHINE ABDUR RAZA ANSARI INSITIUTE OF HEALTH EDUCATION AND RESEARCH CENTER",
  "ANM TRAINING SCHOOL PANIIT JAMTARA",
  "JHARKHAND PHARMACY COLLEGE PUNDAG RANCHI",
  "PANDA COLLEGE OF NURSING",
  "TUPUDANA INSTITUTE OF MEDICAL SCIENCES",
  "DHANBAD COLLEGE OF MEDICAL SCIENCES",
  "BABU LAL BADAMIYA DEVI INSTITUTE OF HEALTH",
  "PT UDIT NARAYAN COLLEGE OF HIGHER EDUCATION AND STUDIES",
  "HERITAGE GNM NURSING COLLEGE",
  "TRINITY EDUCATIONAL INSTITUTE",
  "VANANCHAL INSTITTUE OF HEALTH EDUCATION AND RESEARCH",
  "JHARKHAND COLLEGE OF NURSING AND PROFESSIONAL EDUCATION",
  "URSULINE SCHOOL OF NURSING DUMKA",
  "GOVERNMENT TOOL ROOM AND TRAINING CENTRE DUMKA",
  "RAMGOVIND SCHOOL OF NURSING",
  "PRAMODE MEMORIAL INSTITUTE OF NURSING",
  "EASTERN COLLEGE OF NURSING AND HEALTH STUDIES",
  "SAI COLLEGE OF NURSING",
  "ST MARYS NURSING SCHOOL",
  "Bimla Devi Sewa Sadan ANM Nursing School",
  "AVYAN COLLEGE OF PHARMACY",
  "KALAWATI SCHOOLOF NURSING AND PARA MEDICAL TECHNOLOGY HEHAL",
  "AKSHAT COLLEGE OF HEALTH EDUCATION",
  "RIDHIMA COLLEGE OF PHARMACY",
  "AAROHAN COLLEGE OF PHARMACY",
  "Ramchandra Chandravansi Polytechnic Institute",
  "H S CHANDRA PARAMEDICAL HEALTH INSTITUTE    ",
  "R S MEMORIAL NURSING AND PHARMACY COLLEGE",
  "BAZRA COLLEGE OF PHARMACY",
  "ARSH NARAYANI PHARMACY COLLEGE    ",
  "AEROSPACE RESEARCH AND DEVELOPMENT CENTRE",
  "AL NOOR INSTITUTE OF MEDICAL TECHNOLOGY",
  "GANDHI PARAMEDICAL TECHNOLOGY",
  "COLLEGE OF NURSING, TATA MAIN HOSPITAL",
  "H S CHANDRA NURSING AND PARAMEDICAL HEALTH INSTITUTE    ",
  "ASARFI INSTITUTE OF PHARMACY",
  "Primary Teachers Education College",
  "SNS COLLEGE OF HEALTH EDUCATION",
  "DR BINOD INSTITUTE OF MEDICAL SCIENCE, HARIHARGANJ",
  "PRIMARY TEACHER TRAINING COLLEGE, CHAINPUR",
  "MEERA INSTITUTE OF TECHNOLOGY AND PHARMACY",
  "WOMEN PRIMARY TEACHER TRAINING COLLEGE",
  "BIMLA HARIHAR INSTITUTE OF NURSING CHAKLA ORMANJHI ",
  "MOTHER TERESA PHARMACY COLLEGE    ",
  "R B COLLEGE OF PHARMACY",
  "TRIBAL AMRIT BAIDNATH PHARMACY COLLEGE ",
  "OM SAI ANM NURSING TRAINING SCHOOL",
  "SCHOOL OF NURSING , BOKARO GENERAL HOSPITAL",
  "BIMLA HARIHAR INSTITUTE OF PHARMACY",
  "DR APJ ABDUL KALAM COLLEGE OF PHARMACY",
  "INSTITUTE OF MEDICAL SCIENCES AND HEALTH",
  "MOTHER TERESA COLLEGE OF NURSING",
  "SHINE-ABDULR RAZZAQUE ANSARI INSTITUTE OF RANCHI",
  "ANKUR INSTITUTE OF PHARMACY",
  "A R COLLEGE OF PHARMACY",
  "SWARNREKHA COLLEGE OF NURSING",
  "MEENASHRI INSTITUTE OF NURSING",
  "BETHESDA PRIMARY TEACHERS EDUCATION COLLEGE,RANCHI",
  "URSULINE PRIMARY TEACHERS EDUCATION COLLEGE LOHARDAGA",
  "SATYA SAI NURSING RESEARCH INSTITUTE, NAUGARHA ",
  "ST JOHNS SCHOOL OF NURSING",
  "AROGYAM HOSPITAL AND RESEARCH PRIVATE LIMITED",
  "BIRSA SCHOOL OF PHARMACY",
  "SHATRUGHAN PRASAD SINGH INSTITUTE OF NURSING AND PARAMEDICAL",
  "KAILASH INSTITUTE OF NURSING AND PARAMEDICALS",
  "BANSHIDHAR SCHOOL OF PARAMEDICAL SCIENCE",
  "MADHUSTHALI INSTITUTE OF PARAMEDICAL SCIENCES",
  "VAISMA INSTITUTE OF HEALTH EDUCATION PROFESSIONAL STUDIES AND RESEARCH CENTRE,RANCHI",
  "BIRSA NURSING SANSTHAN",
  "AAROGYAM COLLEGE OF MEDICAL SCIENCE",
  "MEERA COLLEGE OF NURSING",
  "JHARKHAND NURSING SCHOOL",
  "A.N.M. TRAINING CENTRE, ST. URSULA HOSPITAL, LOHARDAGA",
  "BOKARO HOSPITAL AND RESEARCH INSTITUTE",
  "BOKARO INSTITUTE OF MEDICAL AND HEALTH SCIENCES",
  "YASHODA PRIMARY TEACHER EDUCATION COLLEGE",
  "ALCHEMIST AVIATION PVT LTD",
  "PRABHAWATI SCHOOL OF NURSING",
  "SHAKUNTALA NURSING COLLEGE",
  "NARAYAN GAYATRI COLLEGE OF HEALTH EDUCATION",
  "MAA RANKINI NURSING COLLEGE    ",
  "VINITA COLLEGE OF NURSING",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING",
  "ARNAV INSTITUTE OF PHARMACY",
  "KASHIBAI GANPAT COLLEGE OF PHARMACY",
  "KASHYAP INSTITUTE OF VISION SCIENCE",
  "BHARTI SCHOOL OF NURSING",
  "SJAS COLLEGE OF PHARMACY    ",
  "GAYATRI INSTITUTE OF NURSING SCIENCES, NEW COLONY, TOONGRI, CHAIBASA",
  "PATEL COLLEGE OF PHARMACY",
  "J P COLLEGE OF PARAMEDICAL",
  "SUN RISE COLLEGE OF PHARMACY",
  "BIRSA RESEASRCH INSTITUTE FOR MEDICAL AND BIOMEDICAL STUDIES",
  "DEEPAK PARAMEDICAL COLLEGE AND HOSPITAL",
  "RAM KESHWAR COLLEGE OF PHARMACY",
  "VIDYAKRISHNA COLLEGE OF HEALTH EDUCATION",
  "MOTHER TERESA ANM TRAINING SCHOOL BANO",
  "VIKAS INSTITUTE OF NURSING",
  "MOTHERS INTERNATIONAL INSTITUTE OF NURSING",
  "IDEAL SCHOOL OF NURSING",
  "AROGYAM COLLEGE OF PHARMACY",
  "ASIAN INSTITUTE OF ALLIED HEALTH SCIENCES DHANBAD",
  "R S PARAMEDICAL AND NURSING COLLEGE",
  "SHIVAM SCHOOL OF PHARMACY",
  "IDEAL ACADEMY OF PARAMEDICAL  SCIENCE",
  "RAMBHA COLLEGE OF PHARMACY    ",
  "VINAYAK COLLEGE OF PHARMACY",
  "Dhanbad School of Nursing",
  "SWARNREKHA COLLEGE OF PHARMACY",
  "SWAWLAMBI NURSING SCHOOL",
  "USHA ANM SCHOOL",
  "DR BHIM RAO AMBEDKAR PARAMEDICAL COLLEGE",
  "SN PHARMACY INSTITUTE",
  "SHIVAM SCHOOL OF PARAMEDICAL",
  "RANCHI COLLEGE OF NURSING AND PROFESSIONAL EDUCATION",
  "MANIKARAN COLLEGE OF PHARMACY HAZARIBAGH",
  "DHANBAD COLLEGE OF PHARMCY AND RESEARCH INSTITUTE",
  "KRISHNA INSTITUTE OF PHARMACY",
  "SARDAR PATEL COLLEGE OF HEALTH EDUCATION",
  "DIET JASIDIH DEOGHAR",
  "BRIGHT COLLEGE OF MEDICAL SCIENCE",
  "PRIMARY TEACHER EDUCATION COLLEGE GHORMARA DEOGHAR",
  "SARDAR PATEL COLLEGE OF PHARMACY",
  "R S M PHARMACY COLLEGE BERO RANCHI    ",
  "INDO DANISH TOOL ROOM JAMSHEDPUR",
  "RAMSHOBHA COLLEGE OF EDUCATION",
  "DIET RATU RANCHI",
  "VATSALYA INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES    ",
  "S R COLLEGE OF NURSING",
  "DUMKA COLLEGE OF NURSING",
  "EHSAN COLLEGE OF PHARMACY",
  "JAJNERY INSTITUTE OF PARAMEDICAL SCIENCES",
  "St. Annes ANM training School",
  "GODAWARI COLLEGE OF PHARMACY",
  "COLLEGE OF PHARMACEUTICAL SCIENCES",
  "J P COLLEGE PHARMACY",
  "VANANCHAL NURSING TRAINING SCHOOL",
  "JAINENDRA PHARMACY COLLEGE",
  "SP SINGH COLLEGE OF PHARMACY",
  "SHAKUNTALA PARAMEDICAL COLLEGE, PAKUR",
  "VANANCHAL COLLEGE OF PHARMACY",
  "BIRSA INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "Central Institute of Petrochemicals Engineering & Technology (CIPET), Ranchi",
  "JHARKHAND PARAMEDICAL SCIENCE",
  "TATA NAGAR INSTITUTE OF PARAMEDICAL TECHNOLOGY ADITYAPUR",
  "TEJASH INSTITUTE OF HEALTH EDUCATION",
  "KICAM NURSING TRAINING SCHOOL",
  "PRIMARY TEACHER EDUCATION COLLEGE, BUNDU, RANCHI",
  "AROGYAM PHARMACY COLLEGE",
  "OMKAR INSTITUTE OF PARAMEDICAL SCIENCE",
  "ALAKHDEO COLLEGE OF NURSING",
  "AMBEDKAR INSTITUTE OF HIGHER EDUCATION",
  "PUSKAR SCHOOL OF NURSING TRAINING",
  "CITY PHARMACY COLLEGE",
  "Rupsona nursing college",
  "JAINENDRA PARAMEDICAL COLLEGE",
  "INSTITUTE OF MEDICAL SCIENCES",
  "SURYA ANM SCHOOL",
  "BUDDHA HEALTH CARE AND HIGHER EDUCATION",
  "NALANDA NURSING SCHOOL",
  "AGASTYA SCHOOL OF NURSING",
  "HIND COLLEGE OF PHARMACY",
  "SWARNREKHA INSTITUTE OF PARAMEDICAL SCIENCES",
  "SURYA PARAMEDICAL INSTITUTE",
  "BHARATHI COLLEGE OF NURSING",
  "ARSH NARAYANI PARAMEDICAL COLLEGE AND HOSPITAL, RANCHI",
  "VIDYA COLLEGE OF NURSING, ANGARA, RANCHI",
  "INDRASANI COLLEGE OF PHARMACY",
  "JASLOK PHARAMACY COLLEGE",
  "SEVENTH DAY ADVENTIST HOSPITAL RANCHI",
  "JAINENDRA NURSING COLLEGE",
  "SALUJA GOLD COLLEGE OF PHARMACY",
  "LOK NAYAK JAI PRAKASH PARAMEDICAL INSTITUTE",
  "RAJA RAM MEMORIAL PARA MEDICAL COLLEGE",
  "Karyanand Tiwary School Of Nursing",
  "HAMIDA PARAMEDICAL INSTITUTE AND RESEARCH",
  "GYAN JYOTI PARAMEDICAL AND NURSING SCHOOL",
  "SANGHAMITRA COLLEGE OF NURSING",
  "VIKAS INSTITUTE OF PARAMEDICAL SCIENCE",
  "BLM SCHOOL OF PHARMACY",
  "GANDHI INSTITUTE OF NURSING",
  "COLLEGE OF MEDICINE  AND PARAMEDICAL SCIENCES",
  "SARDAR PATEL INSTITUTE OF PARAMEDICAL",
  "PAHARHI NURSING SCHOOL",
  "R P ANM SCHOOL AND R P GNM SCHOOL",
  "KASHIBAI GANPAT NURSING COLLEGE",
  "SHRINIVAS INSTITUTE OF PARAMEDICAL SCIENCES",
  "SCHOOL OF NURSING ST. JOSEPH'S HOSPITAL, GUMLA",
  "XAVIER INSTITUTE OF SOCIAL SERVICE",
  "GHANSHYAM MEHTA COLLEGE OF MEDICAL AND SCIENCE",
  "MAKELIFE PARAMEDICAL COLLEGE",
  "XLRI - Xavier School of Management",
  "TATA TAINING COLLEGE",
  "GYAN JYOTI COLLEGE OF PHARMACY",
  "SARDAR PATEL PARAMEDICAL AND RESEARCH CENTRE",
  "BIRSA SCHOOL OF NURSING",
  "NIGHTINGAL SCHOOL OF NURSING",
  "SURYA NURSING COLLEGE",
  "KEJRIWAL INSTITUTE OF MANAGEMENT AND DEVELOPMENT STUDIES",
  "AMAR JYOTI SCHOOL OF NURSINGH CHANHO",
  "JAGANNATH COLLEGE OF PHARMACY",
  "SAKET INSTITUTE OF PARAMEDICAL SCIENCES",
  "GRIZZLY COLLEGE OF PHARMACY",
  "AV SCHOOL OF NURSING",
  "IYNS COLLEGE OF NURSING",
  "SAVITRI COLLEGE OF PHARMACY",
  "ANM SCHOOL PANIIT, CHAIBASA",
  "S N PRASAD NURSING PARAMEDICAL INSTITUTE ",
  "JANKI NURSING COLLEGE",
  "AVYAN SCHOOL OF NURSING",
  "INDIAN COLLEGE OF PHARMACY",
  "KULPRAKASH MEMORIAL NURSING SCHOOL",
  "SANJAY SCHOOL OF NURSING",
  "Kristraja School of Nursing",
  "GIRIJA INSTITUTE OF PHARMACY",
  "BNTC SCHOOL OF NURSING AND PARAMEDICAL SCIENCE",
  "DIVINE MISSION COLLEGE OF PHARMACY",
  "INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "ANM SCHOOL PANIIT, PREJHA FOUNDATION, ITKI",
  "NIRMALA DEVI COLLEGE OF PHARMACY",
  "NUTAN COLLEGE OF PROFESSIONAL EDUCATION    ",
  "NANDINI INSTITUTE OF NURSING    ",
  "ANM SCHOOL PANIIT, PREJHA FOUNDATION, SADAR HOSPITAL CAMPUS, GUMLA",
  "DAMODAR VALLEY MEDICAL AND NURSING COLLEGE    ",
  "VICTORY COLLEGE OF NURSING    ",
  "ANM SCHOOL PANIIT RAJNAGAR",
  "JD COLLEGE OF NURSING     ",
  "SILICON INSTITUTE OF HEALTH EDUCATION",
  "AR INSTITUTE OF EDUCATION",
  "MANAS GANGOTRI NURSING COLLEGE",
  "ASHOKA INSTITUTE OF HOTEL MANAGEMENT",
  "AASHI NURSING SCHOOL",
  "LM NURSING COLLEGE ",
  "MANRAKHAN MAHTO PARAMEDICAL COLLEGE",
  "ANM SCHOOL PANIIT PREJHA FOUNDATION MASMANO CHANHO",
  "DEO INSTITUTE OF PHARMACY SCIENCES    ",
  "GULAB PHARMACY COLLEGE",
  "NURSING KAUSHAL COLLEGE SAHEBGANJ",
  "EHSAN COLLEGE OF PHARMACY",
  "TILA INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "A G COLLEGE OF PHARMACY",
  "DIET GAMAHARIA SARAIKELA- KHARSAWAN",
  "AROGYAM HOSPITAL AND NURSING SCHOOL",
  "BRIGHT SCHOOL OF PHARMACY",
  "BIRSA COLLEGE OF NURSING",
  "Government Polytechnic Tarihal, Hubballi",
  "GANGOTRI PARA MEDICAL COLLEGE",
  "KARNATAKA PARENTS ASSOCIATION OF CITIZENS WITH INTELLECTUAL AND DEVELOPMENTAL DISABILITIES, KPACIDD",
  "KAVERI COLLEGE OF PARAMEDICAL SCIENCES",
  "NATIONAL PARA MEDICAL COLLEGE HOSPET",
  "SUSHRUTHA INSTITUTE OF PHARMACY",
  "SMT L V (GOVT.) POLYTECHNIC HASSAN",
  "S.V.M PARAMEDICAL INSTITUTE TALIKOTI",
  "ENLIGHT INSTITUTE OF PARAMEDICAL SCIENCES",
  "SRI SHANTHIDHAMA SCHOOL OF NURSING",
  "GOVERNMENT POLYTECHNIC, HOOVINAHADAGALI",
  "GOVERNMENT POLYTECHNIC GUNNAL",
  "OXFORD INSTITUTE OF PARAMEDICAL SCIENCE , YADGIR",
  "GOVERNAMENTPOLYTECHNIC  HAROHALLI",
  "THE RK SCHOOL OF NURSING, MANDYA",
  "SPASTICS SOCIETY OF KARNATAKA",
  "SRI SIDDALINGESHWAR EDUCATION TRUST YSS SCHOOL OF NURSING BANGALORE",
  "GOVT POLYETECNIC HALIYAL",
  "SHRI SAMARTH COLLEGE OF PHARMACY GAJENDRAGAD",
  "KUKKESHRI COLLEGE OF PHARMACY YELBURGA",
  "HITA SCHOOL OF NURSING",
  "GOVERNMENT POLYTECHNIC SADALGA",
  "SRI GOKULA EDUCATION  INSTITUTE KOLAR",
  "SHRI GURU INSTITUTE OF PARAMEDICAL SCIENCE BELAGAVI",
  "GNANADHARE EDUCATION AND RESEARCH INSTITUTE OF PARAMEDICAL SCIENCES",
  "SANJEEVINI INSTITUTE OF PARAMEDICAL SCIENCES",
  "SRI SAI COLLEGE OF PHARMACY",
  "AKASH INSTITUTE OF MEDICAL SCIENCES AND RESEARCH CENTRE",
  "SVETS SHAKUNTALA PATIL PARA MEDICAL COLLEGE HUMNABAD BIDAR",
  "Government Teachers Training Center for Hearing Handicapped",
  "M.M.education Societys Para Medical College, Vijayapura",
  "BALIGONDU GURU COLLEGE OF PHARMACY K B EXTENSION FORT ROAD CHITRADRUGA",
  "ASHWINI SCHOOL OF NURSING SHAHAPUR",
  "HAVISH PARAMEDICAL COLLEGE GURMITKAL YADGIR",
  "FOOD CRAFT INSTITUTE (KARNATAKA) SOCIETY",
  "VINAY COLLEGE OF PHARMACY",
  "Y S S SCHOOL OF NURSING HAGARIBOMMANAHALLI",
  "ASHOK M HURLIKOPPI MEMORIAL PARAMEDICAL INSTITUTE DHARWAD",
  "SHREE ACHYUTHA INSTITUTE OF PARAMEDICAL SCIENCES CHITRADURGA",
  "BRIGHT COLLEGE OF PARA MEDICAL SCIENCES",
  "SHRINIDHI INSTITUTE OF NURSING",
  "GM COLLEGE OF PHARMACY",
  "S A COLLEGE OF PHARMACY",
  "H M S COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC KADUR",
  "BUDDA BASAVA AMBEDKAR SCHOOL OF NURSING, KALABURAGI",
  "ASBK SCHOOL OF NURSING BANGALORE",
  "XAVIER INSTITUTE OF MANAGEMENT AND ENTREPRENEURSHIP",
  "NAGESH INSTITUTE OF PARAMEDICAL",
  "GURU SCHOOL OF NURSING",
  "priyanka gandhi school of nursing bangalore",
  "SRI SHAHU MAHARAJ COLLEGE OF PHARMACY",
  "Government Polytechnic for Women  Holenarsipura",
  "Managuli Institute of Pharmaceutical Sciences Shahapur",
  "VEERABHADRESHWAR COLLEGE OF PHARMACY D PHARMACY",
  "SARASWATI SCHOOL OF NURSING BIDAR",
  "PRUTHVI PARA MEDICAL COLLEGE, DAVANAGERE",
  "B V V SANGHAS SHARADAMBE INSTITUTE OF NURSING SCIENCES, BAGALKOT",
  "CHYAVANA COLLEGE OF PARAMEDICAL SCIENCES",
  "OVR School Of Nursing Kalaburagi",
  "PRAYAVI SCHOOL OF NURSING BIDAR",
  "JANHAVI SCHOOL OF NURSING CHITRADURGA",
  "Jai Karnataka School of Nursing, Gulbarga",
  "Sanskaar School of Nursing",
  "PRASANNA SCHOOL OF NURSING D. KANNADA",
  "PRASANNA POLYTECHNICUJIRE BELTHANGADY D K DIST.",
  "ISBR BUSINESS SCHOOL",
  "PRAGATHI T.T.I BANGALORE RURAL",
  "PRAGATHI INSTITUTE OF NURSING BANGALORE",
  "POOJA INSTITUTE OF NURSING BELLARY",
  "MURTHY INSTITUTE OF PARAMEDICAL SCIENCES CHITHRADURGA",
  "SARVODAYA SCHOOL OF NURSING MANVI",
  "MANSHAR COLLEGE OF PARAMEDICAL SCIENCES",
  "I R POLYTECHNIC BANGALORE",
  "P M S SCHOOL OF NURSING BANGALORE URBAN",
  "PATEL SCHOOL OF NURSING BANGALORE",
  "P G SCHOOL OF NURSING HASSAN",
  "SHREYAS INSTITUTE OF PARA MEDICAL SCIENCES HAVERI",
  "P E S POLYTECHNICBANASHANKARI 1ST CROSSHANUMANTHNAGAR BANGALORE",
  "PES Polytechnic (563), Guddadarakere, Shivamogga",
  "JAYAKAR SCHOOL OF NURSING",
  "SHREE SHARADA COLLEGE OF PHARMACY",
  "PEARL VALLEY EDUCATION SOCIETY BANGALORE",
  "PAVAN SCHOOL OF NURSING KOLAR",
  "SHREE PRATAPGOUDA PATIL GOVERNMENT POLYTECHNIC MASKI",
  "SHRI MANIKPRABHU PARA MEDICAL COLLEGE",
  "PAVAN POLYTECHNIC KOLAR",
  "PAVANA SCHOOL OF NURSING BANGALORE URBAN",
  "PATANJALI SCHOOL OF NURSING CHITRADURGA",
  "INSTITUTE OF TEXTILE TECHNOLOGY BANGALORE",
  "P A POLYTECHNIC NADUPADAV MANGALORE",
  "PANCHASHEELA POLYTECHNIC BANGALORE",
  "GOVERNMENT POLYTECHNIC BYADGI",
  "INSTITUTE OF PRINTING TECHNOLOGY BANGALORE",
  "PADMASHREE SCHOOL OF NURSING BANGALORE",
  "INSTITUTE OF NURSING S V P MAHILA VIDYA PEETH VIDYANAGAR, HUBLI",
  "TALUK HOSPITAL SIRA, TUMKUR",
  "INSTITUTE OF NURSING SCIENCES HUBLI",
  "INSTITUTE OF LEATHER TECHNOLOGY",
  "INFANT JESUS D.ED COLLEGE, RAICHUR",
  "INDUS BUSINESS ACADEMY",
  "INDIRA PRIYADARSHINI SCHOOL OF NURSING BIDAR",
  "SPARSH PARAMEDICAL COLLEGE BIDAR",
  "INDIRA NURSING SCHOOL DAKSHINA KANNADA",
  "INDIRA GANDHI SCHOOL OF NURSING CHITRADURGA",
  "OXFORD SCHOOL OF NURSING J P NAGAR BANGALORE",
  "INDIAN SCHOOL OF NURSING BIDAR",
  "OXFORD SCHOOL OF NURSING GULBARGA",
  "OXFORD SCHOOL OF NURSING B B ROAD BANGALORE",
  "INDIAN SCHOOL OF NURSING- B BANGALORE",
  "OXFORD POLYTECHNIC, HUBLI",
  "OXFORD (EVENING) POLYTECHNIC BANGALORE",
  "OUR LADY OF LOURDES SCHOOL OF NURSING DHARWAD",
  "RAMAN SCHOOL OF NURSING KAMAKSHIPALYA",
  "SHREE YOGI ACHYUTHA INSTITUTE OF PARAMEDICAL SCIENCES CHITHRADURGA",
  "IKON NURSING SCHOOL BANGALORE RURAL",
  "THARA INSTITUTE OF PARAMEDICAL SCIENCE,MANDYA",
  "OM SHANKAR D.ED. COLLEGE, GULBARGA",
  "OM D.ED COLLEGE, DHARWAD",
  "HYDERABAD KARNATAKA EDUCATION SOCIETY'S POLYTECHNIC GULBARGA",
  "OCEAN SCHOOL OF NURSING, BANGALORE",
  "NUTAN VIDYALAYA SOCIETYPOLYTECHNIC GULBARGA",
  "H.V.TEACHER TRAINING INSTITUTE BELGAUM",
  "N S V K TRUST BANGALORE",
  "N R A M POLYTECHNIC NITTE",
  "HUBLI INSTITUTE OF NURSING SCIENCES HUBLI",
  "NORTH KARNATAKA SCHOOL OF NURSING, BIDAR",
  "NORTH KARNATAKA DED COLLEGE, BASAVAKALYAN",
  "NOOR SCHOOL OF NURSING BIDAR",
  "GOVERNMENT POLYTECHNIC PERIYAPATANA",
  "HKDET PARA MEDICAL INSTITUTE BIDAR",
  "HOLY MOTHER INSTITUTE OF NURSING BANGALORE",
  "MANONIDHI INSTITUTE OF PARA MEDICAL SCIENCES MYSURU",
  "PVS COLLEGE OF PHARMACY, CHITRADURGA",
  "DASTHI COLLEGE OF PARAMEDICAL SCIENCES",
  "NOORIE LATHEEF D.ED COLLEGE, GONAMAKANAHALLI",
  "N M TRUST POLYTECHNIC NIDASOSHI",
  "HOLY CROSS SCHOOL OF NURSING CHAMRAJNAGAR",
  "NIGHTINGALE SCHOOL OF DIPLOMA IN GENERAL NURSING & BIDAR",
  "NIGHTANGLE SCHOOL OF NURSING CHIKMAGALUR",
  "HOLDSWORTH MEMORIAL COLLEGE OF NURSING, MYSORE",
  "SHREE INSTITUTE OF PARAMEDICAL SCIENCES",
  "NIDA SCHOOL OF NURSING BIDAR",
  "NEW SARVODAYA SCHOOL OF NURSING BANGALORE",
  "NEW NAVODAYA INSTITUTE OF NURSING MANDYA",
  "NEW CITY HOSPITAL SCHOOL OF NURSING UDUPI",
  "H N S SCHOOL OF NURSING GULBARGA",
  "NETHAJI SCHOOL OF NURSING DAKSHINA KANNADA",
  "GOVT TOOL ROOM AND TRAINING CENTRE, HUMNABAD",
  "N E SOCIETY POLYTECHNIC CHITTAPUR",
  "Thakur college of pharmacy",
  "H M S RURAL POLYTECHNIC MANCHANAKUPPE TUMKUR",
  "S. J. (GOVT.) POLYTECHNIC BANGALORE",
  "NDRK POLYTECHNIC KIADB, THIMMANAHALLI INDUSTRIAL AREA, KANDALI",
  "N C PATEL SCHOOL OF NURSING BANGALORE",
  "RAMAN SCHOOL OF NURSING, DASANAPURA",
  "NAVANEETHAM SCHOOL OF NURSING BANGALORE",
  "SHIFAA HOSPITAL",
  "SWAMY VIVEKANANDA INSTITUTE OF PARAMEDICAL SCIENCES",
  "POL COLLEGE OF PHARMACY, VIJAYAPURA",
  "H M S POLYTECHNIC TUMKUR",
  "N R K INSTITUTE OF PARAMEDICAL SCIENCES HASSAN",
  "SVM PARAMEDICAL INSTITUTE KUSHTAGI",
  "NAVALGUND TALUKA SHIKSHAN SAMITIS D.ED COLLEGE, NAVALGUND",
  "NAVACHETHANA DED COLLEGE, BANGARPETE",
  "AL-AMEEN MEDICAL COLLEGE AND HOSPITAL",
  "ANNAPURNA PARAMEDICAL INSTITUTE MUDDEBIHAL",
  "NAVABHARATA EDN. & PLANTATION FARMERS SOCIETY DHARWAD",
  "H K E S WOMENS POLYTECHNIC GULBARGA",
  "NATIONAL SCHOOL OF NURSING BANGALORE",
  "NANJAPPA TRUST HOSPITAL SHIMOGA",
  "H K E SOCIETY'S SCHOOL OF NURSING GULBARGA",
  "SRI S NIJALINGAPPA MEDICAL EDUCATIONAL CENTER",
  "NANJAMMA TEACHER TRAINING INSTI KOLAR",
  "SRI ADICHUNCHANAGIRI INSTITUTE OF PARAMEDICAL SCIENCES",
  "NANDINI SCHOOL OF NURSING RAICHUR",
  "H K E SOCIETY POLYTECHNIC RAICHUR",
  "PATIL SCHOOL OF NURSING KALABURAGI",
  "RAMAKRISHNA PARA MEDICAL SCIENCE",
  "SHIVAGANGA INSTITUTE OF PARAMEDICAL SCIENCES SHAHAPUR",
  "Shree Sharada School of Nursing, BIDAR",
  "SIMHADRI INSTITUTE OF PARAMEDICAL SCIENCES CHITRADURGA",
  "ST BENEDICTS INSTITUTE OF NURSING",
  "DAYANANADA SAGAR COLLEGE OF PARAMEDICAL SCIENCES",
  "swamy vivekananda institute of pharmacy lingasugur",
  "KARNATAKA HANDLOOM TECHNOLOGY INSTITUTE",
  "MADAKARI INSTITUTE OF PARAMEDICAL SCIENCES HIREKERUR",
  "NANDI INSTITUTE OF PARA MEDICAL SCIENCES",
  "BAGALKOT INSTITUTE OF PARAMEDICAL SCIENCES",
  "ST AGNES TEACHER TRAINING INSTITUTE FOR THE SPECIAL EDUCATION",
  "SMT KAMALATHAI HERANJALS PARAMEDICAL COLLEGE",
  "ARUNODAYA PARA MEDICAL COLLEGE",
  "BASAVASHREE INSTITUTE OF NURSING SCIENCES KOPPAL",
  "sharada college of pharmacy koppal",
  "SHREE BASAVA INSTITUTE OF NURSING SCIENCE SINDHANUR",
  "SHRI JAGDGURU GURUSIDDESWAR CO OPEARTIVE HOSPITAL SOCIETYS COLLEGE OF PHARMACY GHATAPRABHA",
  "JAWAHAR POLYTECHNIC YADGIR",
  "SRI C B YELIGAR POLYTECHNIC",
  "RIYAN INSTITUTE OF PARAMEDICAL SCIENCES",
  "prabhank school of nursing",
  "NANJAPPA INSTITUTE OF PARA MEDICAL SCIENCE",
  "VIDYA INSTITUTE OF PARA MEDICAL SCIENCES",
  "shashank school of nursing",
  "SHRI SADGURU RAYALINGESHWAR PARA MEDICAL COLLEGE MUDHOL BAGALKOT",
  "SOUTHERN SCHOOL OF NURSING",
  "SUNRISE COLLEGE OF PHARMACY, BIDAR",
  "SUPREME INSTITUTE OF NURSING",
  "KREDA COLLEGE OF PHARMACY",
  "ALLAMPRABHU PARAMEDICAL COLLEGE",
  "GOVERNMENT TOOL ROOM AND TRAINING CENTRE CHITRADURGQA",
  "JOSHI INSTITUTE OF PARAMEDICAL SCIENCES",
  "SHREE BASAVESHWAR PARA MEDICAL COLLEGE GADAG",
  "ARADHYA INSTITUTE OF PARAMEDICAL SCIENCES",
  "GOVT SCHOOL OF NURSING GADAG",
  "SANJAY INSTITUTE OF PARAMEDICAL SCIENCES",
  "KKECS SCHOOL OF NURSING",
  "VIKRAM PARAMEDICAL INSTITUTE HUNSUR, MYSURU",
  "VIDHYA SHEKHAR SCHOOL OF NURSING",
  "OXFORD TEACHER TRAINING INSTITUTE BANGALORE",
  "PRAGATI INSTITUTE OF PARA MEDICAL SCIENCE BASAVAKALYAN BIDAR",
  "K V HANCHINAL PARA MEDICAL COLLEGE",
  "BASAVA RAJENDRA NURSING SCHOOL, MARIYALA",
  "SRI MANJUNATHA INSTITUTE OF PARA MEDICAL SCIENCES",
  "S V T PARA MEDICAL COLLEGE GADAG",
  "VIDYARATHNA SCHOOL OF NURSING UDUPI",
  "GOVERNMENT POLYTECHNIC HOLALKERE",
  "SRI SIDDHAROODH COLLEGE OF PHARMACY",
  "ST XAVIERS COLLEGE",
  "SUMANGALI SCHOOL OF NURSING",
  "SHREE RAGHUNANDANA SCHOOL OF GNM NURSING CHITRADURGA",
  "MODERN INSTITUTE OF NURSING SCHOOL",
  "ANUGRAHA SCHOOL OF NURSING",
  "CHANNABASAVESHWAR PARA MEDICAL COLLEGE, DODDAHUNASEMATH, SAVANUR, HAVERI",
  "RAM PARA MEDICAL COLLEGE HARUGERI ATHANI GOKAK ROAD RAIBAG BELAGAVI",
  "AARYA SCHOOL OF NURSING",
  "SAINT ANTONYS SCHOOL OF NURSING",
  "GOVERNMENT SCHOOL OF NURSING, DISTRICT HOSPITAL, CHAMARAJANAGAR",
  "LANKA PRAGATHI SCHOOL OF NURSING",
  "Basavakalayan Polytechnic",
  "MVJ MEDICAL COLLEGE AND RESEARCH HOSPITAL HASKOT BANGALORE",
  "SHREE LAKSHMI VENKATESHWARA T.T.I BELLARY",
  "SHREE SHIVAYOGISHWAR GRAMEEN TTI INCHAL, BELGAUM",
  "S S SAINATH SCHOOL OF NURSING CHITTA BIDAR",
  "SHREE VIDYADHIRAJ POLYTECHNIC KUMTA",
  "SHRI BAHUBALI SCHOOL OF NURSING HASSAN",
  "SHRI BASAVESHWAR RURAL EDUCATION & DEVELOPMENT TRU DHARWAD",
  "AL KAREEM SCHOOL OF NURSING GULBARGA",
  "SHRI DATA SAI NURSING SCHOOL KOLAR",
  "SHRIDEVI SCHOOL OF NURSING TUMKUR",
  "GNYANODAYA COLLAGE OF PARA MEDICAL SCIENCES",
  "SMT V.V.SANGH D.ED. COLLEGE AFZALPUR, GULBARGA",
  "GOVERNMENT POLYTECHNIC TIPTUR",
  "S.NINGAMMA S.HUGAR D.ED COLLEGE, ANNIGERI",
  "S N MOODBIDRI POLYTECHNIC MOODBIDRI",
  "H K SCHOOL OF NURSING",
  "MYRA School of Business",
  "S N S POLYTECHNIC SUNKADAKATTE",
  "SONIA GANDHI SCHOOL OF NURSING GULBARGA",
  "POORNAA PRAGNA INSTITUTE OF PARAMEDICAL SCIENCES",
  "SOUTH KARNATAKA SCHOOL OF NURSING SUBRAMANYAPURA",
  "SOWRABHA INSTITUTE OF NURSING SCIENCES TUMKUR",
  "SHREE JAGADGURU GAVISIDDHESHWARA PARA MEDICAL COLLEGE",
  "SRI SADGURU KABEERANANDA SWAMY SCHOOL OF NURSING CHITRADURGA",
  "SRI SADGURU SIDDHAROODH SWAMI INSTITUTE OF DIPLOMA IN EDUCATION, BIDAR",
  "Jain Polytechnic, Davangere",
  "SRI SAI SCHOOL OF NURSING BANGALORE",
  "SRI SANGAMESHWARA V.KALMATH D.ED COLLEGE, MANVI",
  "DHARANI INSTITUTE OF PARA MEDICAL SCIENCES, DHARWAD",
  "SRI. SANJEEV POLYTECHNIC LINGASAGUR",
  "SRI SHANTHINI SCHOOL OF NURSING BANGALORE",
  "VEERANNA MUSTI INSTITUTE OF NURSING SCIENCES GANGAVATHI",
  "SRI SHARANABASAVESWARA TEACHER TRAINING INSTITUTE BELLARY",
  "SUSHRUTHA PARA MEDICAL COLLEGE DAVANGERE",
  "S V V S POLYTECHNIC BELLARY",
  "SWABHIMAN SCHOOL OF NURSING, BANGALORE",
  "MALNAD SCHOOL OF NURSING",
  "SWAMI VIVEKANANDA YOUTH MOVEMENT MYSORE",
  "SWETHA SCHOOL OF NURSING BANGALORE",
  "VIDYARTHI SCHOOL OF NURSING",
  "SYED BAREY INSTITUTE OF EDUN GULBARGA",
  "TADIKELA SUBBAIAH SCHOOL OF NURSING SHIMOGA",
  "SREE VEERABHADRESHWARA SCHOOL OF NURSING",
  "TAGORE MEMORILA POLYTECHNICRAICHUR",
  "SHUSHRUTHI INSTITUTE OF NURSING",
  "VYDEHI INSTITUTE OF NURSING SCIENCES & RES. CENTRE BANGALORE",
  "YADGIR POLYTECHNIC YADGIR",
  "SIRIGERI D VENKOBA SETTY MEMORIAL COLLEGE OF NURSING GANGAVATHI",
  "BANGALORE CITY COLLEGE OF PARAMEDICAL",
  "Y.K.D POLYTECHNIC, GULBARGA",
  "RR COLLEGE OF PHARMACY",
  "Government School of Nursing, K C General Hospital, Malleshwaram , Bangalore",
  "ST PHILOMENAS SCHOOL OF NURSING",
  "KHANNUR SCHOOL OF NURSING, RANEBENNUR",
  "ADITYA SCHOOL OF NURSING",
  "REHOBOTH INSTITUTE OF NURSING",
  "K L E POLYTECHNIC HAVERI",
  "SHARADA SCHOOL OF NURSING",
  "SECAB INSTITUTE OF PARA MEDICAL SCIENCES",
  "LITTLE FLOWER COLLEGE OF PHARMACY",
  "SRI SAI INSTITUTE OF PARAMEDICAL SCIENCES",
  "SHARADA COLLEGE OF PHARMACY",
  "BARANI INSTITUTE OF PARA MEDICAL SCIENCES",
  "SHREE GANGA PARA MEDICAL COLLEGE CHANNAGIRI",
  "GOVT. POLYTECHNIC ATHANI",
  "SIDDHARTH COLLEGE OF PHARMACY ATHANI",
  "SREE MATHRUSHREE INSTITUTE OF PARA MEDICAL SCIENCES CHITRADURGA",
  "ABHYUDAYA PARA MEDICAL COLLEGE MUDDEBHIHAL VIJAYAPURA",
  "SHRI SUSHRUTA PARA MEDICAL COLLEGE GAJENDRAGAD",
  "SIDDHARTH COLLEGE OF PHARMACY MUDHOL",
  "FAITH INSTITUTE OF NURSING SCIENCES BANGALORE",
  "MARY MATHA SCHOOL OF NURSING BANGALORE",
  "MARGADARSHAN PARAMEDICAL COLLEGE",
  "BHAVAN S PRIYAMVADA BIRLA INSTITUTE OF MANAGEMENT",
  "SAMATA LOK SHIKSHANA SAMITI GULBARGA GANGOTRI COLLEGE OF PHARMACY ALAND",
  "HARSHA INSTITUTE OF PARAMEDICAL SCIENCES",
  "RAMAN INSTITUTE OF PARAMEDICAL SCIENCES",
  "NSS INSTITUTE OF PARAMEDICAL SCIENCES",
  "SHREEYA COLLEGE OF PARAMEDICAL SCIENCES, DHARWAD",
  "UNITY INSTITUTE OF PARAMEDICAL SCIENCES",
  "SARATHI SCHOOL OF NURSING",
  "V P GALA INSTITUTE OF PARAMEDICAL SCIENCE GADAG",
  "SANJEEVINI PARAMEDICAL COLLEGE VIJAYAPURA",
  "SRI MAITHRI INSTITUTE OF PARA MEDICAL SCIENCES HUBLI",
  "SATYAM SCHOOL OF NURSING BANGALORE URBAN",
  "GAYATHRI INSTITUTE OF PARAMEDICAL SCIENCES",
  "SATYAM SCHOOL OF NURSING BELLARY",
  "DR SUBHASH PATIL INSTITUTE OF PARAMEDICAL SCIENCES BAGALKOT",
  "ANJUMANE ISLAM DHARWAD",
  "DISTRICT HOSPITAL CHIKKABALLAPURA",
  "ANJUMAN E-ISLAM POLYTECHNIC GADAG",
  "GOVERNMENT POLYTECHNIC ARKERA",
  "ANJUMAN KANNADA TTI, BADAMI",
  "ANJUMAN POLYTECHNIC AYODHYANAGAR HUBLI",
  "ANJUMAN TEACHER TRAINING INSTITUTE HUBLI DHARWAD",
  "ANJUMAN URDU TEACHERS TRAINING INSTITUTE BIJAPUR",
  "ANNAPURNA SCHOOL OF NURSING GULBARGA",
  "ANURADHA SCHOOL OF NURSING BANGALORE URBAN",
  "BT PATIL& SONS POLYTECHNIC PYAN DARGA ROAD",
  "B V V SANGHAs  S R VASTRAD RURAL POLYTECHNIC, GULEDGUDD",
  "B V V S POLYTECHNIC BAGALKOT",
  "BBC INSTITUTE OF PARAMEDICAL SCIENCE KOPPAL",
  "B V V S SAJJALASHREE INSTITUTE OF NURSING SCIENCES BAGALKOT",
  "CAMBRIDGE SCHOOL OF NURSING BIDAR",
  "SUNRISE PARA MEDICAL COLLEGE SINDHANUR",
  "CAPITANIO TTI MANGALORE, DAKSHINA KANNADA",
  "CARAMEL D.ED COLLEGE, BIDAR",
  "NIGHTINGALE SCHOOL OF NURSING BANGALORE",
  "CAUVERY POLYTECHNIC GONIKOPPAL",
  "DR M V SHETTY SCHOOL OF NURSING DAKSHINA KANNADA",
  "DR. RADHAKRISHNA D.ED. COLLEGE CHITTAPUR, GULBARGA",
  "D R R (GOVT.) POLYTECHNIC DAVANAGERE",
  "DR. S. RADHAKRISHNAN COLLEGE OF PHYSICAL EDUCATION, HUMNABAD",
  "DR SRI SRI SRI SHIVAKUMARA MAHASWAMY POLYTECHNIC",
  "DR S R K SCHOOL OF NURSING BIDAR",
  "SARVODYA PAR MEDICAL COLLEGE MANVI",
  "KANAKA PARA MEDICAL COLLEGE",
  "RUMAN SCHOOL OF NURSING BANGALORE",
  "M M SCHOOL OF NURSING",
  "RURAL TTI (GRAMANTARA VIDYA SAMSTHE) BANGALORE",
  "DR,S,RADHAKRISHNAN D,ED TEACHER TRINING INSTITUTE ,CHITTAPUR",
  "R V TEACHERS TRAINING INSTITUTION BANGALORE",
  "SHUSHRUSHA SCHOOL OF NURSING",
  "VIJAYA PARA MEDICAL COLLEGE",
  "SOFIA SCHOOL OF NURSING",
  "GOVT. TOOL ROOM AND TRAINING CENTRE, KADUR",
  "SRI VINAYAKA INSTITUTE OF PARAMEDICAL SCIENCES",
  "SIDDARTHA TEACHER TRAINING INSTITUTE TUMKUR",
  "JEEVARATHNA SCHOOL OF NURSING",
  "SRI SAI INSTITUTE OF PARAMEDICAL SCIENCES",
  "Aishwarya School of Nursing",
  "AIM PARA MEDICAL COLLEGE SURAPUR KEMBHAVI YADGIR",
  "RAMAN SCHOOL OF NURSING",
  "Government School of Nursing,Bidar",
  "CSI REDFERN MEMORIAL INSTITUTE OF PARA MEDICAL SCIENCES",
  "SRI BASAVESHWARA INSTITUTE OF PARAMEDICAL",
  "SIR M VISVESVARAYYA POLYTECHNIC HOSPET",
  "SRI RAJAMATANGEE INSTITUTE OF PARA MEDICAL SCIENCES",
  "K S N R INSTITUTE OF NURSING BALLARI",
  "SWARNALATHA SCHOOL OF NURSING BANGALORE",
  "K V SCHOOL OF NURSING BANGALORE",
  "ACHUTHA SCHOOL OF NURSING",
  "UNITY SCHOOL OF NURSING",
  "BANGALORE CITY INTERNATIONAL SCHOOL OF NURSING",
  "SPOORTHI INSTITUTE OF NURSING",
  "Swamy Vivekananda School of Nursing",
  "Udupi School of Nursing",
  "Nightingale School Of Nursing",
  "SRI RAM SCHOOL OF NUIRSING",
  "MNG ACADEMYS SCHOOL OF NURSING",
  "KRIPA SCHOOL OF NURSING",
  "VASAVI INSTITUE OF PARA MEDICAL SCIENCES CHITRADURGA",
  "ASNSSS SANJAY PATIL COLLEGE OF PHARMACY SANKESHWAR",
  "JYOTI SCHOOL OF NURSING",
  "GAVISIDDESHWAR INSTITUTE OF PARA MEDICAL SCIENCE YELBURGA",
  "MEGHA PARAMEDICAL COLLEGE HALLIKHED",
  "SHREE DHANVANTRI COLLEGE OF PHARMACY",
  "SIRUGUPPA EDUCATION SOCIETYS T.T.I BELLARY",
  "ST IGNATIUS INSTITUTE OF PARAMEDICAL SCIENCES",
  "SHASHANK PARA MEDICAL COLLEGE",
  "IREACT COLLEGE OF PHARMACY",
  "S R PARAMEDICAL COLLEGE MOLAKALMURU CHITRADURGA",
  "SHREE RAMA KRISHNA INSTITUTE OF PARAMEDICAL SCIENCES CHITRADURGA",
  "LAKSHMI NARAYANA PARA MEDICAL INSTITUTE BADAMI BAGALKOT",
  "RADHA KRISHNA PARA MEDICAL INSTITUTE VIJAYAPURA",
  "SRI RAMA PARA MEDICAL COLLEGE CHITRADURGA",
  "SIDDAGANGA PARA MEDICAL COLLEGE MUDDEBIHAL",
  "SURAKSHA SCHOOL OF NURSING",
  "JNANASAGARA INSTITUTE OF PARAMEDICAL SCIENCES SAGAR",
  "SONIYA EDUCATION TRUSTS RURAL COLLEGE OF PHARMACY KAGWAD",
  "SABAH SCHOOL OF NURSING",
  "GNANA PEETHA INSTITUTE OF PARA MEDICAL SCIENCE YADGIR",
  "GLOBAL INSTITUTE OF BUSINESS STUDIES",
  "GOVERNMENT POLYTECHNIC BHAVIKERE TARIKERE",
  "KLES Institute of Nursing Sciences,Gokak.",
  "DIVINE CARE INSTITUTIONS OF PARAMEDICAL SCIENCE ",
  "Sri Gururaja College of Pharmacy",
  "Smt Sharada Paramedical College Yadgir",
  "Samruddi Para Medical College",
  "Dipali Institute Of Paramedical Sciences Dipali hospital",
  "St. Josephs School of Nursing",
  "INDIAN COLLEGE OF PHARMACY",
  "S J M POLYTECHNIC BIRUR",
  "VINAYAKA COLLEGE OF PHARMACY",
  "WISDOM DED COLLEGE, KGF",
  "SHRIDEVI POLYTECHNIC",
  "EXCELLENT SCHOOL OF NURSING SHAHAPUR DIST YADAGIR",
  "K.R.E. SOCIETYS",
  "A.O.S.R INSTITUTE OF PHARMACEUTICAL SCIENCES KALABURAGI",
  "HOLY FAMILY SCHOOL OF NURSING BANGALORE",
  "TIPU SULTAN COLLEGE OF PHARMACY",
  "BHEEMCHANDRA PARAMEDICAL INSTITUTE",
  "B S F INSTITUTE OF TECHNOLOGYSTC CAMPAS PO AFS YELAHANKA BANGALORE",
  "ANANT SADVIDYA SCHOOL OF NURSING HASSAN",
  "R L JALAPPA POLYTECHNIC",
  "Al Ameen paramedical college",
  "MAHBOOB SUBHANI SCHOOL OF NURSING KALABURAGI",
  "ABHAYA INSTITUTE OF ALLIED HEALTH SCIENCES",
  "RR SCHOOL OF NURSING",
  "SANTHOME SCHOOL OF NURSING",
  "VIDYA KENDRA SCHOOL OF NURSING ",
  "NEW MANGALORE PARAMEDICAL COLLEGE",
  "SHRIMATHI SHANTHABAI EDUCATIONAL SOCIETY PARA MEDICAL SCIENCES",
  "KEMPEGOWDA INSTITUTE OF MEDICAL SCIENCES HOSPITAL AND RESEARCH CENTER",
  "SJ BGS POLYTECHNIC",
  "S J B SCHOOL OF NURSING BANGALORE",
  "PRAKRUTHI COLLEGE OF PHARMACY",
  "GOVERNMENT TOOL ROOM AND TRAINING CENTRE",
  "NOORIE SCHOOL OF NURSING KOLAR",
  "GOVT TOOL ROOM AND TRAINING CENTRE KOPPAL",
  "GOVERNMENT TOOL ROOM  AND TRAINING CENTRE YADGIR",
  "Vaishno School of Nurisng, 117/1, Sante Circle, Chintamani Road, Hoskote-562114",
  "ST.TERESA SCHOOL OF NURSING COLLEGE YADGIRI",
  "JANATHA SCHOOL OF NURSING HASSAN",
  "GOVT POLYTECHNIC CHANNAGIRI",
  "GOVERNMENT POLYTECHNIC HONNALI",
  "AARYBHAT PARAMEDICAL COLLEGE SHIGIKERI BAGALKOTE",
  "SHRI SHARANARA SHIKSHANA SAMITI INSTITUTE OF PARAMEDICAL SCIENCES RON",
  "SREE VARU  PARA MEDICAL COLLEGE CHITRADURGA",
  "T E S POLYTECHNIC DODDA BANASWADI BANGALORE",
  "TAVARAGERAS TEACHER EDUCATION INSTITUTION KOPPAL",
  "TAPOVANA INSTITUTE OF NURSING DAVANAGERE",
  "S.V.E. SOCIETYS TEACHER TRAINING INSTITUTE BIDAR",
  "GOVERNMENT POLYTECHNIC GAURIBIDANUR",
  "SJES POLYTECHNIC BANGALORE",
  "SVE SOCIETYS DED INSTITUTION, BHALKI",
  "HMS SCHOOL OF NURSING",
  "GOVERNMENT POLYTECHNIC KAUP",
  "GOLDEN SCHOOL OF NURSING",
  "GOVERNMENT POLYTECHNIC KOPPA",
  "RAMAIAH INSTITUTE OF MANAGEMENT STUDIES",
  "ARYABHATA PARAMEDICAL COLLEGE BANGALORE",
  "SUVARNA INSTITUTE OF NURSING KOLAR",
  "KARNATAKA GERMAN TECHNICAL  TRAINING INSTITUTE",
  "SAMARTH PARA MEDICAL COLLEGE RAICHUR",
  "BIDAR COLLEGE OF PHARMACY BIDAR",
  "K K COLLEGE OF PHARMACY BIDAR",
  "THE MARATHA MANDAL PHARMACY COLLEGE NIPANI RURAL BELGAUM",
  "SGES SMT LALITA N MAGADUM COLLEGE OF PHARMACY ANKALI",
  "SUSHRUTI D.ED COLLEGE, BANGALORE",
  "KRES KARNATAKA SCHOOL OF PHARMACY CHITGUPPA",
  "RAMAN COLLEGE OF PHARMACY",
  "SURYA NURSING SCHOOL BANGALORE",
  "SURABHI INSTITUTE OF NURSING BIDAR",
  "SULEMAN SCHOOL OF NURSNG BIDAR",
  "SUKRUTHA TEACHERS TRAINING INSTITUTE CHAMARAJANAGAR",
  "SUGUNA SCHOOL OF NURSING KOLAR",
  "S V PARA MEDICAL SCIENCES KOLAR",
  "SAI INSTITUTE OF ALLIED SCIENCES AND PARAMEDICAL COLLEGE",
  "VAJRAKAYA PARA MEDICAL COLLEGE",
  "SUBASH SCHOOL OF NURSING BANGALORE",
  "VANISHRI MAHILA MANDAL VIDYASHALI COLLEGE OF PHARMACY",
  "SRI BASAVESHWARA COLLEGE OF PHARMACY",
  "ST THERESA SCHOOL OF NURSING BANGALORE",
  "S T S K K S POLYTECHNIC GADAG",
  "SAINT PAULS D PHARMACY COLLEGE GANGAVATHI",
  "ST PHILOMINA SCHOOL OF NURSING KOLAR",
  "ST MOTHER TERESA'S SCHOOL OF NURSING TUMKUR",
  "GOVT TOOL ROOM TRAINING CENTRE DHARWAD",
  "ST MARY SCHOOL OF NURSING CHITRADURGA",
  "ST MARY SCHOOL OF NURSING BANGALORE",
  "ST MARTHA'S HOSPITAL SCHOOL OF NURSING BANGALORE",
  "SHRI H D DEVAGOWDA INSTT. OR PARA MEDICAL SCIENCES HASSAN",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING AND TECHNOLOGY",
  "S T J POLYTECHNIC HARAPANAHALLI",
  "SHUTTARIA INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "AYESHA COLLEGE OF PHARMACY",
  "ST. JOSEPH'S CONVENT TTI FOR WOMEN MANDYA",
  "SHIV CHATRAPATI SMARK SAMITIS JIJAMATA COLLEGE OF PHARMACY",
  "ST. JOSEPH'S CONVENT TEACHER TRAINING INSTITUTE BELGAUM",
  "ST JOSEPH SCHOOL OF NURSING UTTARAHALLI, BANGALORE",
  "ST JOHNS' S SCHOOL OF NURSING BANGALORE",
  "ST. JOHNS POLYTECHNIC HUBLI",
  "CHANDRAVALLI SCHOOL OF NURSING",
  "FORT SCHOOL OF NURSING",
  "SRI RANGANATHA SCHOOL OF NURSING HOSADURGA",
  "SRI CHANNEGOWDA SCHOOL OF NURSING",
  "SAI SCHOOL OF NURSING",
  "SHARADA SABURI SCHOOL OF NURSING",
  "RAJIV SCHOOL OF NURSING CHITRADURGA",
  "NEELGANGA INSTITUTE OF NURSING SCIENCE",
  "KOUSTHUBHA SCHOOL OF NURSING",
  "S T J Institute Of Technology Diploma II Shift",
  "CH GLOBAL INSTITUTE OF NURSING BASAVAKALYAN BIDAR",
  "CHRISTIAN SCHOOL OF NURSING",
  "BENAKA SCHOOL OF NURSING",
  "VINAYAKA SCHOOL OF NURSING",
  "ST IGNATIUS SCHOOL OF NURSING KANNADA",
  "ST GEORGE SCHOOL OF NURSING BANGALORE URBAN",
  "ST ANNS TEACHER TRAINING INSTITUTE DAKSHINA KANNADA",
  "SRI SIDDALINGESHWARA TEACHER TRAINING INSTITUTE SHAHPUR, GULBARGA",
  "SRI SIDDAGANGA TEACHER TRAINING INSTITUTE TUMKUR",
  "SRI N JAYANNA SCHOOL OF NURSING CHITRADURGA",
  "SRI RAMUSUNASHREE SCHOOL OF NURSING BANGALORE",
  "SRI NIRVANASWAMY SCHOOL OF NURSING BANGALORE RURAL",
  "SRI MYLARALINGESHWARA SWAMY SCHOOL OF NURSING CHITRADURGA",
  "SRI M.V. INSTITUTE OF NURSING, MANDYA",
  "SRI RAMANASHREE SCHOOL OF NURSING, GULBARGA",
  "SRI MRUTHYUNJAYA SCHOOL OF NURSING DAVANGERE",
  "SRI MARUTHI TEACHEER TRAINING INSTITUTE KOLAR",
  "SRI RAMANA MAHARSHI SCHOOL OF NURSING TUMKUR",
  "SRI LEPAKSHA SWAMY SCHOOL OF NURSING, CHITRADURGA",
  "SRI LAKSHMI VENKATESWARA SCHOOL OF NURSING CHITRADURGA",
  "SRI RAMAKRISHNA SCHOOL OF NURSING CHICKMAGALUR",
  "SRI KRISHNA SCHOOL OF NURSING BANGALORE",
  "SRI KRISHNA POLYTECHNIC BANGALORE",
  "SRI SHARADA PARAMADICAL INSTITUTE, BALLARI",
  "SRI. T S CHANDRASHEKARAIAH INSTITUTE OF PARAMEDICAL SCIENCES MYSORE",
  "SHREE BALAJI INSTITUTE PARAMEDICAL SCIENCE",
  "PVS INSTITUTE OF PARAMEDICAL SCIENCES",
  "DR AMBEDKAR PARA MEDICAL EDUCATION SOCIETY SHIVAMOGGA",
  "SREE NEELAKANTAIAH MEMORIAL PRE UNIVERSITY COLLEGE CHITRADURGA",
  "VISHNU PARA MEDICAL INSTITUTE CHITRADURGA",
  "H V PARA MEDICAL INSTITUTE CHITRADURGA",
  "SRI RAGHAVENDRA INSTITUTE OF PARA MEDICAL SCIENCE SHIMOGA",
  "SUSHRUTA INSTITUTE OF PARA MEDICAL SCIENCE",
  "DISTRICT HOSPITAL VIJAYAPURA",
  "GULBARGA INSTITUTE OF PARAMEDICAL SCIENCES  KALABURAGI",
  "SRI KOTTURSWAMY VIVIDODHESH KOPPAL",
  "ESIC PARAMEDICAL COLLEGE GULBARGA",
  "SRI RAMACHANDRA TTI CHAMARAJANAGAR",
  "INAMDAR INSTITUTE OF PARAMEDICAL SCIENCE KALABURAGI",
  "SRI KAMADHENU SCHOOL OF NURSING CHICKMAGALUR",
  "MATHOSHREE INSTITUTION OF PARAMEDICAL SCIENCE",
  "PATIL PARAMEDICAL INSTITUTE  GANESH NAGAR VIJAYAPUR",
  "SRI JAGAJYOTHI BASAVESHWAR DED COLLEGE, BIJAPUR",
  "ANNAPURNA PARA MEDICAL INSTITUTE",
  "HPR INSTITUTE OF PARAMEDICAL SCIENCES",
  "SRI HARNARAIN SOMANI TEACHERS TRAINING INSTITUTIONS, MYSORE",
  "SURABI INSTITUTE OF PARA MEDICAL SCIENCES CHALAGERA",
  "ST MARY S  PARAMEDICAL COLLEGE",
  "OM SHANTIDHAMA SCHOOL OF NURSING",
  "RAHINI PARA MEDICAL COLLEGE",
  "SRI RAMACHANDRA D P ED COLLEGE SANTHEMARAHALLI, CHAMRAJNAGAR",
  "MOTHER THERESA INSTITUTE OF PARA MEDICAL SCIENCES HUMNABAD",
  "SRI VEERABHADRESHWARA MEDICAL AND CHARITABLETRUST BAGALKOT",
  "SRI MARUTI PARA MEDICAL COLLEGE",
  "SAHAKAARI VIDHYAKENDRA POLYTECHNICJAYANAGAR 9TH BLOCKBANGALORE",
  "SAIDAPUR VIDYA VARDHAKA SANGHAs D.ED COLLEGE YADGIRI, GULBARGA",
  "SAI SHANKAR INSTITUTE OF EDUCATION PONNAMPET VIRAJPET TQ, KODAGU",
  "SAJJALASRI D.ED COLLEGE, LINGASAGUR",
  "SAMBHRAM INSTITUTE OF NURSING KOLAR",
  "SRI GURU SHANESHWARA D ED COLLEGE, MELKOTE",
  "SRI GURURAJ TEACHER TRAINING INSTITUTE KOLAR",
  "SRI ESHWARAMMAJI SCHOOL OF NURSING ( S E S O N) KOLAR",
  "SRI RAGHAVENDRA INSTITUTE OF NURSING TUMKUR",
  "SRI. D. DEVRAJ URS TEACHER TRAINING INSTITUTE BIDAR",
  "Sri Channakeshava Government Polytechnic, Guddada Channapur, Bankapur",
  "SRI CHANNABASAVESWARA D.ED. COLLEGE, DHARWAD",
  "SRI RAGAVENDRA INSTITUTE OF D ED, CHIT",
  "SRI CHANNABASAVESHWARA PRIMARY TEACHER TRAINING IN HAVERI",
  "SRI B.V.N. TEACHERS TRAINING INSTITUTE KOLAR",
  "SRI BASAVESHWARA TEACHER TRAINING INSTITUTE TUMKUR",
  "S.J.E.S TEACHER TRAINING INSTITUTE BANGALORE",
  "SRI BASAVARAJ SCHOOL OF NURSING CHITRADURGA",
  "SREE VENKATESHWARA SCHOOL OF NURSING BANGALORE",
  "SREE SIDDARAMESHWARA POLYTECHNIC TIPTUR",
  "SREE NATARAJA SCHOOL OF NURSING MYSORE",
  "SREENAGAR SCHOOL OF NURSING BANGALORE",
  "SREE BASAVESHWARA SCHOOL OF NURSING TUMKUR",
  "SREE BAHUBALI POLYTECHNIC SHRAVANABELAGOLA",
  "SWAMY VIVEKANANDA PARAMEDICAL SCIENCES",
  "SAHYADRI PARAMEDICAL COLLEGE",
  "JYOTI INSTITUTE OF PARA MEDICAL SCIENCE BIDAR",
  "SRI LAKSHMI INSTITUTE OF PARA MEDICAL SCIENCE",
  "SURPUR PARAMEDICAL INSTITUTE SHORAPUR",
  "S R C INSTITUTE OF BUSINESS MANAGEMENT BANGALORE",
  "DR SURGIMATH PARAMEDICAL COLLEGE YADGIR",
  "VIDYAVAHINI PARA MEDICAL COLLEGE",
  "SPURTHY INSTITUTE OF NURSING BANGALORE",
  "WENLOCK DISTRICT HOSPITAL DAKSHINA KANNADA",
  "SMT VEERAMMA SCHOOL OF NURSING TUMKUR",
  "S. J.EVENING POLYTECHNIC BANGALORE",
  "SMT VASANTHA SCHOOL OF NURSING GULBARGA",
  "P P INSTITUTE OF PARA MEDICAL SCIENCES SHAHAPURA YADGIRI",
  "SANTHOME SCHOOL OF NURSING BANGALORE URBAN",
  "BOWRING AND LADY CURZON HOSPITAL",
  "SMT SUSHILADEVI NAGUR MEMORIAL NURSING SCHOOL BIJAPUR",
  "SANTOSH TEACHER TRAINING INSTITUTE KOLAR",
  "SHRI CHANNABASAVESHWAR PARAMEDICAL COLLEGE",
  "NATIONAL PARAMEDICAL INSTITUTE",
  "KEERTHI EDUCATION SOCIETY",
  "VENKATESHWAR PARAMEDICAL COLLEGE RAYBAG",
  "RAJARAJESWARI MEDICAL COLLEGE AND HOSPITAL",
  "KRUTHIN COLLEGE OF PARAMEDICAL SCIENCES",
  "PBR INSTITUTE OF PARAMEDICAL SCIENCES CHAMARAJANAGAR",
  "SMT SUMATI NAIK INSTITUTE OF NURSING SCIENCES UTTARA KANNADA",
  "JAGADGURU GURUSIDDESHWAR CO-OPERATIVE HOSPITAL SOCIETY",
  "SRI SANGMESHWAR INSTITUTE OF PARAMEDICAL SCIENCES BASAVAKALYAN",
  "S S COLLEGE OF PHARMACY",
  "SMT SHAKUNTALA SCHOOL OF NURSING HUBLI",
  "SRI PADMARAJ D.P.ED COLLEGE, SINDAGI",
  "SUNRISE COLLEGE OF PHARMACY",
  "SMT NARAYANI D R KARIGOWDA SCHOOL OF NURSING HASSAN",
  "LOTUS COLLEGE OF PHARMACY",
  "SRI ADWIKA SCHOOL OF NURSING LINGASUGUR",
  "SARVODAYA COLLEGE OF PHARMACY",
  "HOPKINS SCHOOL OF NURSING",
  "GOVT TOOL ROOM AND TRAINING CENTRE KOLAR",
  "J R D BATE PARA MEDICAL INSTITUTE CHIKODI BELAGUM",
  "Helen Keller Government Teachers Training Center for Visually Handicapped Children",
  "MOODLAKATTE INSTITUTE OF PARA MEDICAL SCIENCES",
  "HULIGAPPA PARAMEDICAL COLLEGE YADGIR",
  "GOVERNMENT POLYTECHNIC KOLLEGAL",
  "LOKMANYA EDUCATION SOCIETYS VITHALRAO YESHWANTRAO CHAVAN POLYTECHNIC",
  "SAPTHAGIRI SCHOOL OF NURSING BANGALORE URBAN",
  "RAJIVGANDHI PARAMEDICAL INSTITUTE YADGIR",
  "SMT M C VASANTA SCHOOL OF NURSING BIDAR",
  "DEODHAR INSTITUTE OF PARAMEDICAL SCIENCES HAVERI",
  "GOVT. TOOL ROOM AND TRAINING CENTRE, KANAKAPURA",
  "RELIANCE EDUCATION SOCIETY PARAMEDICAL COLLEGE TALIKOTI",
  "DR SURGIMATH PARA MEDICAL COLLEGE SHAHAPURA YADGIRI",
  "DR SURGIMATH PARA MEDICAL COLLEGE SHORAPURA YADGIR",
  "LIMA SCHOOL OF NURSING",
  "SAI KRISH PARAMEDICAL INSTITUTE",
  "SRHEE S B SAUNSHI COLLEGE OF PHARMACY, GADAG, KARNATAKA",
  "GOVT TOOL ROOM AND TRAINING  CENTRE NELAGOLA",
  "SHRI SIDDHIVINAYAK INSTITUTE OF PHARMACY HARUGERI",
  "M M JOSHI EYE INSTITUTE",
  "SRI SAI PARAMEDICAL INSTITUTE SHAHAPUR",
  "EXCELLENT INSTITUTE OF PARAMEDICAL SCIENCE SHAHAPUR",
  "YATHINDRA INSTITUTE OF PARA MEDICAL SCIENCE",
  "PRAGATHI COLLEGE OF PARA MEDICAL SCIENCES",
  "ADITYA PARA MEDICAL COLLEGE HUMNABAD, BIDAR",
  "ANNAPURNA PARAMEDICAL INSTITUTE TALIKOTI",
  "DR B. R. AMBEDKAR INSTITUTE OF PARA MEDICAL SCIENCES CHITRADURGA",
  "NUTAN  PARA MEDICAL INSTITUTE CHITRADURGA",
  "LAKEVIEW INSTITUTE OF PARAMEDICAL SCIENCES BELAGAVI",
  "DR M V SHETTY COLLEGE OF MEDICAL LABORATORY TECHNOLOGY, MANGALORE",
  "MARGADARSHAN INSTITUTE OF PARAMEDICAL SCIENCES COLLEGE HUNGUNDA",
  "INSTITUTE OF PARAMEDICAL SCIENCES GANGAVTI",
  "LUMBINI INSTITUTE OF PARAMEDICAL SCIENCE COLLEGE",
  "B M HORAKERI INSTITUTE OF PARAMEDICAL SCIENCES",
  "NANDA GOKULA SCHOOL OF NURSING KOLAR",
  "RENUKA INSTITUTE OF PARAMEDICAL SCIENCE DHARWAD",
  "HITECH PARAMEDICAL COLLEGE",
  "VARADARAJA INSITIUTE OF PARAMEDICAL SCIENCES",
  "LORVEN SCHOOL OF NURSING BANGALORE URBAN",
  "INDUS INSTITUTE OF PARAMEDIC SCIENCES BOLWAR PUTTUR",
  "LOMBARD MEMORIAL HOSPITAL (C S I HOSP.) DAKSHINA KANNADA",
  "LIFE LINE SCHOOL OF NURSING BANGALORE URBAN",
  "LAXMI MEMORIAL INSTT OF NURSING DAKSHINA KANNADA",
  "LAKSHMI DEVI SCHOOL OF NURSING BANGALORE RURAL",
  "SVM PARAMEDICAL COLLEGE MUDDEBIHAL",
  "SRI LAKSHMI KAMAL NARAYAN SCHOOL OF NURSING YELAHANKA ",
  "PRIYANKA GANDHI SCHOOL OF NURSING",
  "MATS INSTITUTE OF MANAGEMENT & ENTREPRENURSHIP",
  "AKSHATHA INSTITUTE OF NURSING SCIENCES BELLARY",
  "LAKE SIDE MEDICAL CENTRE & HOSP SCH OF NSG. BANGALORE URBAN",
  "K V T POLYTECHNICC.V.V. CAMPAS CHICKABALLAPUR",
  "KV POLYTECHNIC COLLEGE, RANNEBENNUR",
  "K V G POLYTECHNIC SULLIA",
  "K V G INSTITUTE OF NURSING DAKSHINA KANNADA",
  "KV CP.ED COLLEGE KV CAMPUS CHIKKABALLAPUR",
  "KUMUDA UMASHANKAR TEACHER TRAINING INSTITUTE UDUPI",
  "KUMUDA SCHOOL OF NURSING DAVANGERE",
  "RAJEEV GANDHI PARAMEDICAL COLLEGE DAVANGERE",
  "K T G SCHOOL OF NURSING BANGALORE",
  "KSS TTI, BELGAUM",
  "PATIL PARAMEDICAL INSTITUTE TALIKOT",
  "KRUPANIDHI EDUCATION TRUST SCHOOL OF NURSING BANGALORE URBAN",
  "K R SCHOOL OF NURSING BANGALORE URBAN",
  "JSS POLYTECHNIC MYSURU",
  "SHREE SWAMI VIVEKANANDA SCHOOL OF NURSING",
  "KRISHNA SAGARA TTI KRISHNA SAGAR, BANGALORE",
  "K.R. HOSPITAL, MYSORE",
  "VISION PARA MEDICAL COLLEGE SINDAGI",
  "KREDA SCHOOL OF NURSING BANGALORE URBAN",
  "KPE SOCIETYS TEACHER TRAINING INSTITUTE DHARWAD",
  "K.P.E.S. D.ED COLLEGE, RAICHUR",
  "K PANDYARAJAH BALLAL NURSING INSTITUTE ULLAL",
  "KOSHYS SCHOOL OF NURSING BANGALORE",
  "K N N SCHOOL OF NURSING BANGALORE URBAN",
  "MANASA INSTITUTE OF NURSING SCIENCES",
  "NEELGANGA INSTITUTE OF PARAMEDICAL SCIENCES",
  "NEW LIFE SCHOOL OF NURSING",
  "SHRI MALLIKARJUNA POLYTECHBNIC N H-13 CHITRADURGA",
  "K M N SCHOOL OF NURSING",
  "KALPATARU SCHOOL OF NURSING",
  "KAMAKSHI SCHOOL OF NURSING MYSORE",
  "KLS SHRI VASANTRAO POTDAR POLYTECHNIC",
  "K L S SCHOOL OF NURSING BELLARY",
  "K.L.E. SOCIETYS TEACHER TRAINING INSTITUTE KOPPAL",
  "K.L.E. SOCIETYS TEACHER TRAINING INSTITUTE BELGAUM",
  "K.L.E. SOCIETYS TEACHER TRAINING INSTITUTE ATHANI TALUK BELGAUM",
  "KLE SOCIETYS S.S. BASAVANAL TTI BELGAUM",
  "K L E SOCIETY'S INSTITUTE OF NURSING SCIENCES UTTAR KANNADA",
  "SHRADDA SCHOOL OF NURSING",
  "SRI RAGHAVENDRA INSTITUTE OF PARAMEDICAL SCIENCES CHITRADURGA",
  "K L E SOCIETY'S INSTITUTE OF NURSING SCIENCES HUBLI",
  "K L E SOCIETY'S HOSPITAL COLLEGE OF NURSING BELGAUM",
  "K L E SOCIETY POLYTECHNIC MAHALINGAPURA",
  "K L E SOCIETY POLYTECHNIC HUBLI",
  "SHRI BASAVA PARAMEDICAL COLLEGE ILKAL",
  "HOLLY CROSS INSTITUTE OF PARA MEDICAL SCIENCES",
  "SREE SEVALAL INSTITUTE OF PARA MEDICAL SCIENCE",
  "RENUKA INSTITUTE OF OPTOMETRY",
  "K R HEGDE COLLEGE OF PARAMEDICAL SCIENCES",
  "SUSHRUTHA SCHOOL OF NURSING",
  "MINHAS SCHOOL OF NURSING",
  "K L E SOCIETY POLYTECHNIC CHIKODI",
  "K L E SOCIETY POLYTECHNIC BAILHONGAL BELGAUM DISTRICT.",
  "KLES Institute of Nursing Sciences, Ankola, Uttar Kannada",
  "KAVERI SCHOOL OF NURSING BANGALORE",
  "KARNATAK RURAL EDUCATION SOCIETY BELGAUM",
  "KARNATAKA SCHOOL OF NURSING GULBARGA",
  "KARNATAKA SCHOOL OF NURSING BANGALORE URBAN",
  "KARNATAKA HEALTH INSTITUTE SCH OF NSG. BELGAUM",
  "KARNATAKA (GOVT) POLYTECHNIC MANGALORE",
  "KARNATAKA DED COLLEGE BASAVAKALYAN, BIDAR",
  "KARAVALI POLYTECHNIC MANGALORE",
  "KARANATKA GRAMEEN TEACHER TRAINING INSTITUTE BELGAUM",
  "RAVI SCHOOL OF NURSING",
  "SRI GANGADHARESHWARA SCHOOL OF NURSING",
  "VIKRAM SCHOOL OF NURSING MYSORE",
  "KANAKADAS SHIXAN SAMITIS TEACHER TRG. INSTITUTE DHARWAD",
  "KANAKADAS SHIXAN SAMITHIS T.T.I DHARWAD",
  "KANAKADAS SHIKSHANA SAMITI KANAKA NILAYA GADAG",
  "KAMMAVARY POLYTECHNIC BANGALORE",
  "KAMATH INSTITUTE OF TECHNOLOGY POLYTECHNIC KUNDAP",
  "Institute of Hotel Management Catering Technology and Applied Nutrition",
  "JNANABHARATHI COLLEGE OF PARAMEDICAL SCIENCES",
  "KAMALA NEHRU EDUCATION TRUST BELGAUM",
  "KALPATHARU SCHOOL OF NURSING BELTHANGADY",
  "KALABHYRAVESWARA POLYTECHNIC HESARAGHATTA BANGALORE",
  "HEARTLAND COLLEGE OF PHARMACY BANGALORE",
  "DIANA COLLEGE OF PHARMACY BANGALORE",
  "ST THERESA COLLEGE OF PHARMACY BANGALORE",
  "J V MANDAL POLYTECHNIC TERDAL BAGALKOT",
  "JUPITER SCHOOL OF NURSING BANGALORE RURAL",
  "J.S.S. TEACHER TRAINING INSTITUTE FOR WOMEN MYSORE",
  "J.S.S. TEACHER TRAINING INSTITUTE FOR MEN MYSORE",
  "J S S SCHOOL OF NURSING MYSORE",
  "GOVT NURSING SCHOOL DAKSHINA KANNADA",
  "J S S SCHOOL OF NURSING CHAMARAJNAGARA",
  "J S S SCHOOL OF NURSING CHAMARAJANAGAR",
  "J S S POLYTECHNIC NANJANGUD",
  "BGS ACADEMY FOR PARAMEDICAL INSTITUTE",
  "J S S POLYTECHNIC FOR WOMEN MYSORE",
  "J S S POLYTECHNIC FOR PHYSICALLY HANDICAPPED MYSORE",
  "GOVT NURSING SCHOOL BELLARY",
  "K L E T  SCHOOL OF NURSING",
  "GOVERNMENT WOMENS POLYTECHNIC SHIRALAKOPPA SHIKA",
  "GOVERNMENT WOMENS POLYTECHNIC KARKALA UDUPI DISTRICT",
  "GOVERNMENT WOMENS POLYTECHNIC HUBLI",
  "GOVERNMENT WOMEN`S POLYTECHNIC BANGALORE",
  "GOVERNMENT VISL S J POLYTECHNIC BHADRAVATHI",
  "AL-AMEEN PARAMEDICAL INSTITUTE KALAKERI",
  "HPR SCHOOL OF NURSING",
  "SHABARI MATHA SCHOOL OF NURSING BIDAR",
  "ADARSHA INSTITUTE OF PARAMEDICAL SCIENCES",
  "SHRI SANGAMESHWAR COLLEGE OF PHARMACY SINDAGI",
  "S.R.K. SCHOOL OF NURSING, BANGALORE",
  "M A J SCHOOL OF NURSING BANGALORE",
  "GOVERNMENT URDU TEACHER TRAINING INSTITUTE (DIET), BIJAPUR",
  "GOVERNMENT TEACHER TRAINING INSTITUTE FOR WOMEN GULBARGA",
  "GOVERNMENT TEACHER TRAINING INSTITUTE FOR WOMEN DHARWAD",
  "GOVERNMENT TEACHER TRAINING INSTITUTE FOR MEN GULBARGA",
  "GOVERNMENT RESIDENTIAL WOMEN`S POLYTECHNIC SHIMOGA",
  "EAST WEST SCHOOL OF NURSING BANGALORE URBAN",
  "EAST WEST POLYTECHNIC BANGALORE",
  "D V S POLYTECHNIC SHIMOGA`",
  "DR L PADMAVATHI INSTITUTE OF NURSING SCIENCES GULBARGA",
  "DR. JOHN'S SCHOOL OF NURSING BANGALORE URBAN",
  "DR. G. S. MELKOTE RURAL POLYTECHNIC KUKNUR",
  "DR B R AMBEDKAR SCHOOL OF NSG BHADRAVATHI",
  "DR. AJAY SCHOOL OF NURSING, GULBARGA",
  "DIVINE GRACE SCHOOL OF NURSING BANGALORE RURAL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, UDUPI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, RAMANAGAR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING MANGALORE, DAKSHINA KANNADA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, MANDYA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, GULBARGA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, CHITRADURGA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, CHIKKA BALLAPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BELGAUM",
  "MALLIGI INSTITUTE OF PARAMEDICAL SCIENCES HOSAPETE",
  "SHREEYA INSTITUTE OF NURSING SCIENCES",
  "SUSHRUTHA INSTITUTE OF NURSING BANGALORE",
  "SHRI. HIGULAMBIKA EDUCATION SOCIETY’S DED COLLEGE, KALABURAGI",
  "GOVERNMENT POLYTECHNIC SURAPUR YADGIR DIST.",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BANGALORE RURAL",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SHIMOGA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING RAICHUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING MYSORE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KOLAR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING HASSAN",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING DHARWAD",
  "BADOL DEVI COLLEGE OF PHARMACY",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING DAVANAGERE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING COORG",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING CHIKMAGALORE",
  "S.M. SHANBHAG HEGDEKAR INSTITUTE UTTARA KANNADA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BIDAR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BELLARY",
  "S L V SCHOOL OF NURSING BANGALORE",
  "GNANA DHARE EDUCATION AND RESEARCH INSTITUTE OF PARAMEDICAL SCIENCES",
  "ANJANI BALDEV COLLEGE OF PHARMACY A B COLLEGE OF PHARMACY",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BAGALKOT",
  "DISTRICT HOSPITAL SCHOOL OF NURSING, BIJAPUR",
  "B R KOPP PARA MEDICAL INSTITUTE GOKAK",
  "DIANA SCHOOL OF NURSING BANGALORE",
  "SLN TEACHERS TRAINING INSTITUTE BANGALORE",
  "DHANWANTARI SCHOOL OF NURSING CHIKBANAVAR",
  "DHANVANTARI SCHOOL OF NURSING UDUPI",
  "SJVP POLYTECHNIC, HARIHAR",
  "DEVRAJ URS. COLLEGE OF NURSING KOLAR",
  "DECCAN D.ED COLLEGE, GULBARGA",
  "DBHP SABHA'S GANGADHAR POLYTECHNIC",
  "S.J.R. TEACHERS TRAINING INSTITUTE DHARWAD",
  "D .BHANUMAIAH POLYTECHNIC MYSORE",
  "DAYANANDA SAGAR INSTITUTE OF TECHNOLOGY BANGALORE",
  "DAYANANDA SAGAR BUSINESS SCHOOL",
  "DALPHIN DED COLLEGE SHIDLAGATTA, CHIKKA BALLAPUR",
  "S J M SCHOOL OF NURSING, CHITRADURGA",
  "DAFFODILS TEACHERS TRAINING INSTITUTE GULBARGA",
  "D A C G (GOVT.) POLYTECHNIC CHICKAMAGAUR",
  "Sri Sadguru  Sachidanand Sainath Charitable and education Trust",
  "C.V.CHARANTIMATH RURAL POLYTECHNIC",
  "C.S. TUBACHI EDUCATION SOCIETY BELGAUM",
  "C S I RED FERN MEMORIAL HOSPITAL HASSAN",
  "S J M POLYTECHNIC NELAMANGALA",
  "C P C (GOVT.) POLYTECHNIC MYSORE",
  "COMMAND HOSPITAL BANGALORE",
  "COLACO SCHOOL OF NURSING DAKSHINA KANNADA",
  "C N MUGALKHOD INSTITUTE OF NURSING BELGAUM",
  "S J M POLYTECHNIC CHITRADURGA",
  "CITY INSTITUTE OF NURSING DAKSHINA KANNADA",
  "S J M POLYTECHNIC CHALLAKERE",
  "CITY CENTURY SCHOOL OF NURSING BANGALORE",
  "CITIZEN D ED COLLEGE, SIDLAGHATTA",
  "CHURCH OF SOUTH INDIA HOSPITAL BANGALORE",
  "CHURCH OF SOUTH INDIA GOODWILL POLYTECHNIC BANGALORE",
  "CHIKODI TALUKA EDUCATION SOCIETYS TEACHER TRAINING BELGAUM",
  "HPR SCHOOL OF NURSING SCIENCE",
  "CHATRAPATI SHIVAJI TEACHER TRAINING INSTITUTION BELGAUM",
  "CHAITANYA SCHOOL OF NURSING BANGALORE",
  "CBAE BAIREVESHWARA COLLEGE OF PHYSICAL EDUCATION NAVANAGAR, HUBLI-DHARWAD",
  "CAUVERY SCHOOL OF NURSING MYSORE",
  "B T L SCHOOL OF NURSING BANGALORE URBAN",
  "BRITE SCHOOL OF NURSING BANGALORE",
  "ARATAL RUDRAGOUDA DED COLLEGE MUNDARGI ROAD, GADAG",
  "A P S POLYTECHNICSOMANAHALLIKANAKAPURA ROAD BANGALORE",
  "APOLLO NURSING SCHOOL BANGALORE",
  "ABBS School of Management",
  "SOPHIA SCHOOL OF NURSING",
  "SMT. NAGARATHNAMMA SCHOOL OF NURSING",
  "ANJALI SCHOOL OF NURSING BIDAR",
  "ANAND D.ED. COLLEGE MARAGUTTI CROSS, GULABARGA",
  "ANANDA MARGAPOLYTECHNIC MALLUR",
  "TARA INSTITUTE OF PARAMEDICAL SCIENCES",
  "AMBIKA SCHOOL OF NURSING BANGALORE RURAL",
  "ALVA'S INSTITUTE OF NURSING SCIENCES DAKSHINA KANNADA",
  "International School of Management Excellence",
  "AL- QAMAR INSTITUTE OF NURSING GULBARGA",
  "AL-NAZAR D.ED. COLLEGE HOUSING BOARD COLONY, GULBARGA",
  "FAIZAN PARAMEDICAL SCIENCES",
  "ALLAMA PRABHU INSTITUTE OF NURSING SCIENCE BANGALORE",
  "AL KHATEEB POLYTECHNIC BANGALORE",
  "AL- BADAR SCHOOL OF NURSING GULBARGA",
  "AL-AMEEN FATIMA SCHOOL OF NURSING BIJAPUR",
  "AL AMEEN DED COLLEGE, KOLAR",
  "INDIRA SCHOOL OF NURSING",
  "AKSHAYA SCHOOL OF NURSING TUMKUR",
  "AKSHAYA POLYTECHNIC, LINGAPURA, OBALAPURA POST",
  "S. S. SAINATH COLLEGE, BIDAR",
  "AKKAMAHADEVI SCHOOL OF NURSING BIDAR",
  "AKKAMAHADEVI SCHOOL OF NURSING BANGALORE",
  "swamy vivekananda college of pharmacy",
  "AFZA TEACHER TRAINING INSTITUTE KOLAR",
  "A E T SCHOOL OF NURSING MANDYA",
  "DISTRICT INSTITUTION OF EDUCATION AND TRAINING, CHAMARAJANAGAR",
  "AE&CS RAMPRIYA TEACHER TRAINING INSTITUTE KOLAR",
  "A E C S MAARUTI SCHOOL OF NURSING BANGALORE URBAN",
  "ADICHUNCHANGIRI INSTITUTE OF NURSING MANDYA",
  "ADICHUNCHANAGIRI POLYTECHNIC CHICKAMAGALUR",
  "ADARSHA POLYTECHNIC",
  "NEW ERA SCHOOL OF NURSING NATIONAL SON",
  "ACHARYA SCHOOL OF MANAGEMENT",
  "ACHARYA D.ED. COLLEGE, BANGALORE",
  "ABU KARNATAKA SCHOOL OF NURSING GULBARGA",
  "ABAYA SCHOOL OF NURSING, BANGALORE",
  "SHRI VENKATESHWAR PARAMEDICAL COLLEGE",
  "DR B R AMBEDKAR INSTITUTE OF D PHARMACY HUMNABAD",
  "P B COLLEGE OF PHARMACY YADGIRI",
  "JNANA GANGOTRI INSTITUTE OF PARA MEDICAL SCIENCES SHIVAMOGGA",
  "PINNACLE INSTITUTE OF PHARMACY",
  "MAYUR COLLEGE OF PHARMACY",
  "PEARL ACADEMY",
  "AL IQRA COLLEGE OF PHARMACY",
  "BANGALORE MANAGEMENT INSTITUTE",
  "AROGYA PARA MEDICAL COLLEGE MUDALGI",
  "GOVT TOOL ROOM AND TRAINING CENTRE KALABURAGI",
  "MANGALA COLLEGE OF PARA MEDICAL SCIENCES",
  "DR AMBEDKAR INSTITUTE OF PARAMEDICAL SCIENCES",
  "VIDYANIKETHANA EDUCATION INSTITUTE OF PARA MEDICAL SCIENCES",
  "MAGNUS SCHOOL OF NURSING",
  "GOVERNMENT POLYTECHNIC BELURU",
  "VIJAYA INSTITUTE OF NURSING SCIENCES, BELAGAVI",
  "ARUNODAYA COLLEGE OF PHARMACY",
  "YASHODA SCHOOL OF NURSING VIJAYAPUR",
  "RANGANATHA INSTITUTE OF PARA MEDICAL SCIENCE HOLALKERE",
  "ACHARYA INSTITUTE OF PARAMEDICAL SCIENCES",
  "R K PARA MEDICAL COLLEGE",
  "SAMBHRAM INSTITUTE OF PARAMEDICAL SCIENCES",
  "GANGOTRI COLLEGE OF PARAMEDICAL SCIENCES ALAND KALABURGI",
  "ROYAL CONCORDE SCHOOL OF NURSING",
  "SIDDAGANGA SCHOOL OF NURSING",
  "SHIV INSTITUTE OF NURSING SCIENCES",
  "SCT SCHOOL OF NURSING",
  "GKM SCHOOL OF NURSING",
  "SANA SCHOOL OF NURSING DHARWARD",
  "SDVS SANGHS ANNAPOORNA INSTITUTE OF PARAMEDICAL SCIENCES SANKESHWAR ",
  "DIANA PARAMEDICAL COLLEGE",
  "HPR COLLEGE OF PARAMEDICAL SCIENCES PUTTUR",
  "LUMBINI PARAMEDICAL INSTITUTE KALABURAGI ",
  "ZHIYA SCHOOL OF NURSING",
  "MOUNTAIN VALLEY SCHOOL OF NURSING",
  "G R V SCHOOL OF NURSING",
  "INDO ASIAN ACADEMY SCHOOL OF NURSING",
  "DIANA INSTITUTE OF NURSING",
  "CENTURY SCHOOL OF NURSING",
  "NANDINI SCHOOL OF NURSING",
  "AMEENA SCHOOL OF NURSING, CHITRADURGA",
  "NITTE EDUCATION TRUST SCHOOL OF MANAGEMENT",
  "ALLAMAPRABHU INSTITUTE OF PARAMEDICAL SCIENCE LINGASUGUR",
  "ROYAL PHARMACY COLLEGE KALABURAGI",
  "HYDERABAD KARNATAKA EDUCATION SOCIETY INSTITUTE OF PHARMACY SHAHABAD",
  "MANIKYA JYOTI PARAMEDICAL COLLEGE SURPUR",
  "DARSHANAPUR PARAMEDICAL COLLEGE SHAHAPUR DIST YADGIR",
  "BLS INSTITUTE OF PARAMEDICAL SCIENCE",
  "HKGN PARA MEDICAL COLLEGE SHAHAPUR DIST YADGIR",
  "HALMADGI PARA MEDICAL COLLEGE BASAVAKALAYANA",
  "DR CHANDRASHEKHAR RAJESHWAR INSTITUTE OF PARA MEDICAL SCIENCES HUMNABAD",
  "VAIDYA INSTITUTE OF PARAMEDICAL SCIENCES",
  "NEW PRAGATHI INSTITUTE OF NURSING",
  "ASHWINI SCHOOL OF NURSING",
  "VIJAYAJYOTI SCHOOL OF NURSING",
  "SANKALPA SCHOOL OF NURSING",
  "BANGI COLLEGE OF PHARMACY VIJAYAPUR",
  "SADVIDYA INSTITUTE OF PARA MEDICAL SCIENCES",
  "SRI GURUKOTTURESHWARA PARA MEDICAL INSTITUTE",
  "MATHOSHREE KAMALABAI KARJAGI PARAMEDICAL COLLEGE BASAVANA BAGEWADI",
  "ECR SCHOOL OF NURSING",
  "SRI RENUKA PARAMEDICAL COLLEGE HAGARIBOMMANAHALLI BELLARY",
  "SHANTHA COLLEGE OF PARA MEDICAL SCIENCES",
  "JAWAHAR SCHOOL OF NURSING",
  "VEERANNA MUSTI INSTITUTE OF PARAMEDICAL SCIENCES GANGAVATHI",
  "GOVERNMENT POLYTECHNIC KAMADOLLI",
  "MARUTHI INSTITUTE OF PARAMEDICAL SCIENCES",
  "FAHAD INSTITUTE OF PARA MEDICAL COLLGE VIJAYAPUR",
  "DR KTB SCHOOL OF NURSING",
  "MOTHER NOORUNNISSA SCHOOL OF NURSING",
  "CNK SCHOOL OF NURSING",
  "KEERTHI SCHOOL OF NURSING BENGALURU",
  "M V M SCHOOL OF NURSING",
  "MOUNT SHEPHERD SCHOOL OF NURSING",
  "GREENCITY SCHOOL OF NURSING",
  "ST ALPHONSA SCHOOL OF NURSING",
  "BLOSSOM SCHOOL OF NURSING",
  "NOORIE SCHOOL OF NURSING",
  "PARSHWANATH DODDANAVAR SCHOOL OF NURSING",
  "KASHVI SCHOOL OF NURSING",
  "VASU SCHOOL OF NURSING",
  "PARAMANADA SCHOOL OF NURSING",
  "S V P SCHOOL OF NURSING",
  "PRINCESS CITY SCHOOL OF NURSING",
  "NIDA COLLEGE OF PHARMACY",
  "NEELGANGA INSTITUTE OF PHARMACY SCIENCE YERBAGH BASAVKALYAN",
  "ANAUEL SCHOOL OF NURSING",
  "SHEKHAR INSTITUTE OF NURSING RK HEGDE NAGAR BANGALORE",
  "SAK SCHOOL OF NURSING CHANNAPATNA",
  "ANURADHA COLLEGE OF PHARMACY",
  "K T G COLLEGE OF PHARMACY",
  "NIVEDITA SCHOOL OF NURSING",
  "SRI DURGAMBA SCHOOL OF NURSING",
  "VIDYANIDHI INSTITUTE OF PARAMEDICAL SCIENCES TUMAKURU",
  "AMBIKA INSTITUTE OF EDUCATIONAL SOCIETY",
  "KALYAN KARNATAKA INSTITUTE OF PARA MEDICAL SCIENCES BASAVAKALYAN",
  "PAN ASIA SCHOOL OF NURSING",
  "GOLDEN SCHOOL OF NURSING",
  "ENLIGHT SCHOOL OF NURSING",
  "SHARATH EYE HOSPITAL",
  "SMT SUMAN HEDE PARAMEDICAL COLLEGE BIDAR",
  "DR SANJAY DANGE INSTITUTE OF PARAMEDICAL SCIENCE HAVERI",
  "CRESCENT COLLEGE OFPHARMACY KALABURAGI",
  "SHREE BASAVA INSTITUTE OF PARAMEDICAL SCIENCE SINDHANUR",
  "FORTUNE COLLEGE OF PARAMEDICAL SCIENCES BRAHMAVARA UDUPI DISTRICT",
  "CHAKRAVARTHY SCHOOL OF NURSING CHANNAPATNA",
  "BASAVESHWARA SCHOOL OF NURSING",
  "M S SCHOOL OF NURSING",
  "SHREE MERU SCHOOL OF NURSING",
  "T JOHN SCHOOL OF NURSING",
  "DHEERAJ SCHOOL OF NURSING GADAG",
  "DR SACHIN PATTANSHETTI COLLEGE OF PHARMACY",
  "KARNATAKA EDUCATION SOCIETY COLLEGE OF PHARMACY GUNNALLI ROAD BIDAR",
  "LOTUS SCHOOL OF NURSING TALIKOTI",
  "NAGANAGOWDA DIDIGI SCHOOL OF NURSING",
  "CHANDRAMUKHI SCHOOL OF NURSING KOPPAL",
  "DHANWANTARI INSTITUTE OF PARA MEDICAL SCIENCES",
  "C N MUGALKHOD INSTITUTE OF PARA MEDICAL SCIENCES",
  "INSTITUTE OF HEALTH MANAGEMENT RESEARCH BANGALORE",
  "JASMINE PARA MEDICAL COLLEGE BIDAR",
  "SRI BYRAVESHWARA PARAMEDICAL COLLEGE KOLAR",
  "KRUPANIDHI SCHOOL OF MANAGEMENT",
  "PRIYADARSHINI SCHOOL OF NURSING",
  "VIVEKANAND EDUCATION SOCIETYS COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC BASAVAN BAGEWADI",
  "GOVERNMENT TOOL ROOM AND TRAINING CENTRE UDUPI",
  "SCT KRISHNAVENI INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH",
  "SIRASAGI PARA MEDICAL COLLEGE OF SCIENCES ALMEL SINDAGI BIJAPUR",
  "INDIAN COLLEGE OF PHARMACY",
  "NIVEDITA PARA MEDICAL INSTITUTE AMADIHAL",
  "V C AKKI SCHOOL OF PHARMACY",
  "VAISHNAVI PARA MEDICAL COLLEGE KODEKAL",
  "DISTRICT HOSPITAL HAVERI",
  "JAGAJYOTHI BASAWESHWARA PARA MEDICAL COLLEGE KALABURGI",
  "CHAITANYA INSTITUTE OF PARA MEDICAL SCIENCES KALABURGI",
  "MILIND SOCIAL WELFARE EDUCATION SOCIETY BIDAR",
  "SHREE DEVI PARAMEDICAL COLLEGE SINDAGI BIJAPUR",
  "MOURYA INSTITUTE OF PARA MEDICAL SCIENCES",
  "R K INSTITUTE OF PARAMEDICAL SCIENCES BALLARI",
  "CHINNAMBIKA INSTITUTE OF PARA MEDICAL SCIENCES NARAGUNDA GADAG DIST",
  "SWAMI VIVEKANANDA PARA MEDICAL COLLEGE LINGASUGUR RAICHUR",
  "BASAVESHWAR COLLEGE OF PHARMACY GADAG",
  "SHREE DURGA PARA MEDICAL COLLEGE HIREKERUR HAVERI",
  "SRI BANASHANKARI PARA MEDICAL INSTITUTE BADAMI BAGALKOT",
  "KREDA INSTITUTE OF PARAMEDICAL SCIENCES",
  "KANAKA INSTITUTE OF PARA MEDICAL SCIENCE HOSADURGA",
  "ADVIN INSTITUTE OF PARAMEDICAL SCIENCES TIPTUR",
  "PUJAR INSTITUTE OF PARAMEDICAL SCIENCE MUNDARAGI GADAG",
  "INDIRA GADHI INSTITUTE OF PARA MEDICAL SCIENCE",
  "NOBLE COLLEGE OF PARA MEDICAL SCIENCES",
  "K C GENERAL HOSPITAL BENGALURU",
  "NOBLE INSTITUTE OF PARA MEDICAL SCIENCES BHALKI BIDAR",
  "SRI LAKSHMI INSTITUTE OF PARAMEDICAL SCIENCE RANIBENNUR HAVERI",
  "KALYANA KARNATAKA INSTITUTE OF PARA MEDICAL SCIENCES RAICHUR",
  "GLOBAL INSTITUTE OF PARAMEDICAL SCIENCES",
  "MEGHANA PARA MEDICAL INSTITUTE CHITRADURGA",
  "SHREE S B SAUNSHI COLLEGE OF PHARMACY GADAG",
  "VIDYABHARATH SCHOOL OF NURSING ",
  "SHRI MARUTHI SCHOOL OF NURSING ",
  "SPATIKA SCHOOL OF NURSING",
  "DIVINE SCHOOL OF NURSING",
  "Manjunatha School of Nursing Sciences",
  "SPANDANA INSTITUTE OF PARAMEDICAL SCIENCES CHIKKODI",
  "SHANTI DHAMA SCHOOL OF NURSING BANGALORE URBAN",
  "NSB WORLD BUSINESS SCHOOL",
  "SAVITA SCHOOL OF NURSING",
  "GOVERNMENT TOOL ROOM AND TRAINING CENTRE GOKAK",
  "VIDYA BHARATH COLLEGE OF PHARMACY",
  "PURAD INSTITUTE OF NURSING, GADAG",
  "SPOORTHI SCHOOL OF NURSING HUMNABAD",
  "PATEL COLLEGE OF PHARMACY RAMANAGARA",
  "DIVINE GRACE COLLEGE OF PHARMACY RAMANAGARA",
  "HAL MANAGEMENT ACADEMY",
  "KSHEMANKARI SCHOOL OF NURSING HOSPET",
  "KSHEMANKARI SCHOOL OF NURSING",
  "GOVERNMENT TOOL ROOM AND TRAINING CENTRE, HASSAN",
  "AMARSHANTH PARAMEDIAL COLLEGE",
  "SRI SHANTESHWAR PARA MEDICAL COLLEGE INDI VIJAYAPUR",
  "GOVT TOOL ROOM AND TRAINING CENTRE-Raichur",
  "GOVERNMENT TOOL ROOM AND TRAINING CENTRE - DANDELI",
  "ALLIANCE COLLEGE OF PHARMACY KALABURAGI",
  "SHRI SAI RURAL NURSING SCHOOL AKOL",
  "SHRI BASAVESHWAR COLLEGE OF PHARMACY VIJAYAPUR",
  "AADHAR INSTITUTE OF PHARMACY",
  "Bangi School of Nursing Vijayapura",
  "PAVANI SCHOOL OF NURSING",
  "UNIVERSAL COLLEGE PHARMACY RAMANAGARA",
  "BHAGATH SCHOOL OF NURSING",
  "FLORENCE SCHOOL OF NURSING",
  "KHASIMBEE SAHEBA COLLEGE OF PHARMACY",
  "OM SCHOOL OF NURSING",
  "Amrutha School of Nursing",
  "LALITHA NURSING SCHOOL",
  "NATIONAL SCHOOL OF NURSING",
  "PADMAVATHI SCHOOL OF NURSING",
  "SRI KANAKA SCHOOL OF NURSING",
  "MANJUSHREE SCHOOL OF NURSING",
  "PRUDENCE SCHOOL OF NURSING",
  "RATNADEEP SCHOOL OF NURSING  SCIENCES",
  "SUPRAJA SCHOOL OF NURSING",
  "INTECH MGM SCHOOL OF NURSING",
  "N M M SCHOOL OF NURSING",
  "N V L SCHOOL OF NURSING",
  "KIRAN SCHOOL OF NURSING",
  "R K P SCHOOL OF NURSING",
  "HARSHIKA SCHOOL OF NURSING",
  "CHIGATERI DISTRICT HOSPITAL DAVANGERE",
  "P G INSTITUTE OF PARAMEDICAL SCIENCES",
  "SPOORTHI INSTITUTE OF PARAMEDICAL SCIENCES GANGAVATHI",
  "OM PARA MEDICAL COLLEGE",
  "SURPUR PARA MEDICAL INSTITUTE",
  "MATOSHREE BORAMMA HONNAPPA PARAMEDICAL INSTITUTE",
  "AMET INSTITUTE OF PARA MEDICAL SCIENCES",
  "ASKI PARAMEDICAL COLLEGE",
  "JNANABHARATHI INSTITUTE OF PARAMEDICAL SCIENCES",
  "GNM INSTITUTE OF PARAMEDICAL SCIENCES",
  "MAHIMA INSTITUTE OF PARAMEDICAL SCIENCES",
  "ANUGRAHA INSTITUTE OF PARA MEDICAL SCIENCES",
  "SUNSHINE INSTITUTE OF PARAMEDICAL SCIENCES",
  "DKG Para Medical College Kalaburagi",
  "SUNRISE INSTITUTE OF PARAMEDICAL SCIENCES",
  "RESHMI PARAMEDICAL INSTITUTE",
  "Somanahalli Educational society",
  "V S PARAMEDICAL INSTITUTE",
  "JYOTI INSTITUTE OF PARAMEDICAL SCIENCES",
  "SRI SIDDESHWARA PARA MEDICAL COLLEGE",
  "SHRI SHARANABASAVESHWAR PARAMEDICAL COLLEGE",
  "SKE INSTITUTE OF PARAMEDICAL SCIENCES",
  "SLES PARAMEDICAL COLLEGE",
  "SURABI INSTITUTE OF PARA MEDICAL SCIENCES",
  "BGS PARA MEDICAL INSTITUTE OF SCIENCES",
  "SRI ESHWARAMMAJI PARA MEDICAL COLLEGE",
  "KPSM PARA MEDICAL COLLEGE",
  "JUPITER INSTITUTE OF PARAMEDICAL SCIENCES",
  "R K INSTITUTE OF PARAMEDICAL SCIENCES",
  "AROGYADHAMA INSTITUTE OF PARA MEDICAL SCIENCES",
  "SRUJANA INSTITUTE OF PARAMEDICAL SCIENCES",
  "BAPUJI INSTITUTE OF PARAMEDICAL SCIENCE",
  "AZAD PARAMEDICAL INSTITUTE MUDDEBIHAL",
  "SRI H. D. DEVEGOWDA PARA MEDICAL COLLEGE BIDAR",
  "MADEENA INSTITUTE OF PARA MEDICAL SCIENCES DHARWAD",
  "Shree Udaykumar School of Nursing Chittapur",
  "SIDHARTHA INSTITUTE OF PARAMEDICAL SCIENCES BIDAR",
  "MADANI COLLEGE OF PHARMACY",
  "MALANOOR PARAMEDICAL INSTITUTE MALANOOR",
  "PRIYANKA GANDHI INSTITUTE OF NURSING GULBARGA",
  "St Josephs Institute of Management",
  "DRUSTI INSTITUTE OF PARAMEDICAL SCIENCES DHARWAD",
  "BSR INSTITUTE OF OPERATION THEATRE TECHNOLOGY TUMKUR",
  "CHALUKYA EDUCATION SOCIETYs COLLEGE OF PHARMACY BIDAR KARNATAKA",
  "spvvss polytechnic sindagi",
  "GOVERNMENT POLYTECHNIC MOSALEHOSAHALLI    HASSAN TALUK",
  "SRI VEERA RANI KITTUR CHENNAMMA PARA MEDICAL INSTITUTE  HUVINAHADAGALI",
  "SHRI LAXMANRAO JARKIHOLI POLYTECHNIC GOKAK",
  "SWAMI VIVEKANAND PARAMEDICAL COLLEGE MUDDEBIHAL ",
  "DECCAN COLLEGE OF PHARMACY",
  "Dr Gurachar Nargund College Of Pharmacy muradi",
  "SANA INSTITUTE OF PARA MEDICAL SCIENCES DHARWAD",
  "GOVERNMENT POLYTECHNIC SIRA",
  "BLDEAS COLLEGE OF PHARMACY BASAVAN BAGEWADI",
  "KANNADA BALAGA SOCIETYS RURAL PARA MEDICAL COLLEGE",
  "PARVEEN COLLEGE OF PHARMACY",
  "SANA INSTITUTE OF PARA MEDICAL SCIENCES HUBLI",
  "PRAGATHI EDUCATIONAL TRUSTS PRAGATHI COLLEGE OF PHARMACY",
  "NOBLE COLLEGE OF PHARMACY",
  "BASAVASHREE PARAMEDICAL COLLEGE",
  "EPHRAIM SCHOOL OF NURSING",
  "IDEAL PARA MEDICAL INSTITUTE KALAKERI",
  "SRI MAHANTESH PATIL SCHOOL OF NURSING MALLABAD",
  "K S School of Nursing",
  "NEW INDIAN SCHOOL OF NURSING",
  "GNANADEEKSHA INSTITUTE OF PARAMEDICAL, HASSAN",
  "NEELGANGA SCHOOL OF NURSING",
  "Dr S V Totagantimath School of Nursing Gadag",
  "PRASHANTH INSTITUTE OF PARA MEDICAL SCIENCES KAUP",
  "NOMAN SCHOOL OF NURSING",
  "SHRI SAI JYOTI PARAMEDICAL COLLEGE ATHANI",
  "R R K S COLLEGE OF PARA MEDICAL SCIENCESS BIDAR",
  "KUMAR SWAMIJI PARA MEDICAL COLLEGE BHALKI",
  "SRI HARI PARA MEDICAL COLLEGE YADGIRI",
  "VARDHAMANA INSTITUTE OF PARA MEDICAL SCIENCE",
  "DISTRICT HOSPITAL KOPPALA",
  "SRIPAD HEGDE KADAVA INSTITUTE OF PARA MEDICAL SCIENCE",
  "SRI MARUTI PARA MEDICAL COLLEGE YADGIRI",
  "INDIRA EDUCATION TRUST",
  "SPOORTI INSTITUTE OF PARAMEDICAL SCIENCES RANEBENNUR",
  "MADEGOWDA PARA MEDICAL COLLEGE",
  "MANASA INSTITUTE OF  PARAMEDICAL SCIENCES   DAVANGERE",
  "S D JAYRAM INSTITUTE OF PARAMEDICAL SCIENCES",
  "SIDDARAMAPPA DANIGONDA MEMORIAL TRUST TERDAL",
  "SHAMA INSTITUTE OF MEDICAL SCIENCES",
  "GMETS DR GOUDARS PARA MEDICAL COLLEGE BIJAYPUR",
  "COLACO ACADEMY OF PARA MEDICAL SCIENCES",
  "SHRI RAVI INSTITUTE OF PARAMEDICAL",
  "SRI MAHALAXMI PARAMEDICAL COLLEGE, AFZALPUR",
  "BABUSINGH THAKUR  PARAMEDICAL INSTITUTE DHARWAD",
  "SRI VIMALESHWARA PARA MEDICAL COLLEGE DAVANGERE",
  "SRI HOLE HUCHCHESHWARA PARA MEDICAL INSTITUTE , GULEDGUDDA , BAGALKOT",
  "SRI MRITHUNJAYA GRAMEENABHIRUDDI SAMASTHE  SHIGGAON  HAVERI",
  "NADGIR INSTITUTE OF PARAMEDICAL SCIENCES",
  "VIDYARTHI PARA MEDICAL COLLEGE KUSHALANAGAR",
  "NALANDA PARAMEDICAL COLLEGE",
  "SHRI SAI PARAMEDICAL COLLEGE ANKALI",
  "K N NAGEGOWDA PARA MEDICAL COLLEGE",
  "Vikram Institute of Paramedical Sciences",
  "HPR COLLEGE OF PARAMEDICAL SORABA",
  "NEW CITY COLLEGE OF PARAMEDICAL SCIENCES UDUPI",
  "Sanskaar Institute of Paramedical Sciences",
  "AMRUTHA HOSPITAL AND TRAINING CENTER AMRUTHAHALLI",
  "HEHS INSTITUTE OF PARAMEDICAL SCIENCE DEVANAHALLI",
  "HEHS INSTITUTE OF PARAMEDICAL SCIENCE DODDABALLAPUR",
  "SRI DEVARAJ URS PARAMEDICAL COLLEGE DAVANGERE",
  "SRI MRUTHYUNJAYA INSTITUTE OF PARA MEDICAL SCIENCES DAVANGERE",
  "ABU PARAMEDICAL COLLEGE",
  "CAMBRIDGE COLLEGE OF PHARMACY",
  "MAHATAMA GANDHI INSTITUTE OF PARA MEDICAL SCIENCE",
  "SRI H D DEVEGOWDA INSTITUTE OF PARA MEDICAL SCIENCES, HASSAN",
  "Gurudev Institute of paramedical Sciences",
  "VIDYARTHI PARA MEDICAL COLLEGE",
  "SRI RANGANATHA COLLEGE OF PARA MEDICAL SCEINCES",
  "ADARSH PARAMEDICAL INSTITUTE CHIKODI",
  "SRI VINAYAKA PARAMEDICAL COLLEGE",
  "W. C. Rontgen Institute of paramedical Science",
  "RAJEEV INSTITUTE OF PARAMEDICAL SCIENCES",
  "ABHAY PARA MEDICAL COLLEGE",
  "CSI LOMBARD MEMORIAL HOSPITAL UDUPI",
  "SRI VEERARANI KITTURA CHENNAMMA SCHOOL OF NURSING",
  "DR ABDUL KALAM INSTITUTE OF PARAMEDICAL SCIENCES",
  "MANONIDHI INSTITUTE OF PARAMEDICAL SCIENCES",
  "GANGA INSTITUTE OF PARA MEDICAL SCIENCES   CHANNAGIRI",
  "SRI SIDDI VINAYAKA INSTITUTE OF PARA MEDICAL SCIENCE RAIBAGH BELAGAVI",
  "DIKSUCHI COLLEGE OF PARA MEDICAL SCIENCE DAVANGERE",
  "SS INSTITUTE OF PARAMEDICAL SCIENCES",
  "ST JOSEPHS ACADEMY OF NURSING",
  "SURAKSHA PARA MEDICAL INSTITUTE MUDALAGI",
  "Sahiyadri Institute of Paramedical Sciences",
  "Bharatesh Institute of Paramedical Sciences",
  "GOVT.TOOL ROOM AND TRAINING CENTRE-BANGALORE",
  "SKEY BIRD INSTITUTE OF PARAMEDICAL SCIENCES RAICHUR",
  "LABUBAI BANITABAI BHANDARI PARA MEDICAL COLLEGE RAICHUR",
  "ADWIKA INSTITUTE OF PARAMEDICAL SCIENCES BANGALORE",
  "SRI VENKATESHWARA C K INSTITUTE OF PHARMACY",
  "SRI DURGA INSTITUTE OF PARAMEDICAL SCIENCE",
  "Y.S.S SCHOOL OF NURSING, KUDLAGI",
  "ALKHOD SCHOOL OF NURSING",
  "SRI VEERBHADRESHWAR EDUCATIONAL TRUSTS BASAVESHWARA INSTITUTE OF PHARMACEUTICAL SCIENCES, KALLUR ROAD HUMNABAD BIDAR",
  "GOVERNMENT POLYTECHNIC MALAVALLI",
  "SAINT PAULS PARAMEDICAL COLLEGE",
  "AR INSTITUTE OF PARAMEDICAL COLLEGE",
  "KHATIB INSTITUTE OF PARAMEDICAL SCIENCE",
  "GOVT TOOL ROOM And TRAINING CENTRE- GUNDLUPET",
  "SRI CHANNEGOWDA INSTITUTE OF PARAMEDICAL SCIENCES",
  "SRI VENKATESWARA SCHOOL OF NURSING, DASANAPURA",
  "C V RAMAN GENERAL HOSPITAL",
  "KIRLOSKAR INSTITUTE OF MANAGEMENT",
  "Agriculture and Food Management Institute",
  "RASHTRIYA RACHNATMAK KARYA SAMITHIS SCHOOL OF NURSING BIDAR",
  "SANJEEVINI SCHOOL OF PHARMACY",
  "BELLARY INSTITUTE OF NURSING, BELLARY",
  "NANDI  INSTITUTE OF NURSING SCIENCES,BAGALKOT",
  "Mother Mary School of Nursing",
  "JAYANAGAR GENERAL HOSPITAL",
  "GOVERNMENT TOOLROOM AND TRAINING CENTRE, MAGADI",
  "GOVERNMENT DENTAL COLLEGE AND RESEARCH INSTITUTE, BANGALORE",
  "SPOORTHI PARA MEDICAL COLLEGE, GADAG",
  "SANJEEVINI INSTITUTE OF PARAMEDICAL SCIENCE JAMKHANDI",
  "HUILGOL NARAYANRAO PARA MEDICAL COLLEGE, K C RANI ROAD, GADAG",
  "SNR DISTRICT HOSPITAL",
  "District Hospital Bagalkote",
  "ACE SCHOOL OF NURSING",
  "DISTRICT HOSPITAL , TUMAKURU",
  "SAHYADRI POLYTECHNIC THIRTHAHALLI",
  "YESs  SRI SIDDHALINGESHWAR COLLEGE OF PHARMACY, NAUBAD, BIDAR-585402",
  "EAST WEST INSTITUTE OF POLYTECHNIC, YELAHANKA NEW TOWN, BANGALORE",
  "GOVERNMENT TOOL ROOM AND TRAINING CENTRE, SHIGGAON",
  "SANIYA PARA MEDICAL COLLEGE, VIJAYAPURA",
  "SRI VINAYAKA INSTITUTE OF PARAMEDICAL SCIENCES",
  "ST. TERESA'S WOMEN'S TEACHERS' TRAINING INSTITUTE, CHAMARAJPET, BANGALORE",
  "GOVERNMENT TOOL ROOM AND TRAINING CENTRE DEVANAHALLI",
  "HAMEEDA COLLEGE OF PHARMACY",
  "ANANYA SCHOOL OF NURSING",
  "SHREE DURGA PARA MEDICAL COLLEGE HIREKERUR HAVERI",
  "DR CHANDRAKANT B PATIL PARAMEDICAL COLLEGE SHAMANEWADI TQ CHIKODI",
  "NOTRE DAME JUNIOR COLLEGE OF EDUCATION",
  "INAMDAR COLLEGE OF PHARMACY",
  "SARANG INSTITUTE OF POLYTECHNIC",
  "DISTRICT HOSPITAL PARA MEDICAL SCIENCES DHARWAD",
  "Noor Teacher Training Institute",
  "SHARABHESWARA INSTITUTE OF NURSING BELLARY",
  "Sri Dharmasthala Manjunatheshwara Polytechnic, Ujire",
  "Swada School Of Nursing",
  "SHARANABASAVESHWAR DED COLLEGE, BASAVAKALYAN",
  "SHARANA HARALAYYA DED COLLEGE CHALLAKERE, CHITRADURGA",
  "Rifa-Hul Muslimeen Educational Trust Farooqia College of Para Medical Sciences Mysore",
  "GAVISIDDESHWAR INSTITUTE OF NURSING SCIENCE YALBURGA DIST KOPPAL",
  "SAI KRISH POLYTECHNIC",
  "SRI VAGDEVI SCHOOL OF NURSING",
  "Lakshmi School of Nursing",
  "INTERNATIONAL SCHOOL OF BUSINESS AND MEDIA",
  "ROOHI SCHOOL OF NURSING BIDAR",
  "SRI SAI SAMARTHA PARAMEDICAL INSTITUTE ",
  "M B H PARA MEDICAL COLLEGE SURPUR YADGIRI",
  "GOVERNMENT POLYTECHNIC ARASIKERE",
  "KARNATAKA GERMAN TECHNICAL TRAINING INSTITUTE BENGALURU",
  "GOVERNMENT POLYTECHNIC KOLHAR",
  "SHREE SHARADHA INSTITUTE OF PARAMEDICAL SCIENCES",
  "GURURAJ V METI SMARAK SCHOOL OF NURSING, SHANTHINAGAR, DEVADURGA, RAYACHURU ",
  "J P SCHOOL OF NURSING BANGALORE RURAL",
  "JOSHI SCHOOL OF NURSING BANGALORE",
  "J N POLYTECHNIC THANAKUSHNOORTQ.AURAD(B) BIDAR DIST",
  "JNANESH INSTITUTE OF NURSING BANGALORE",
  "JNANA JYOTHI SCHOOL OF NURSING BANGALORE",
  "SMT GOWRAMMA CHARANTIMATH INSTITUTE OF NURSING SCIENCES",
  "GANDHIJI PARA MEDICAL COLLEGE GADAG",
  "SACRED HEART TEACHERS TRAINING INSTITUTE BANGALORE",
  "SABEERA D ED COLLEGE (URDU MEDIUM) CHANNAGIRI, DAVANAGERE",
  "REV NOORUNISSA SCHOOL OF NURSING KOLAR",
  "R E S POLYTECHNIC BANGALORE",
  "REBEKAH ANN NAYLOR SCHOOL OF NURSING BANGALORE",
  "RAVINDRANATH TAGORE SCHOOL OF NURSING BANGALORE",
  "J.M.J D.ED COLLGE UTTARA KANNADA",
  "RATHNA SCHOOL OF NURSING HASSAN",
  "RAMAN POLYTECHNIC (KAMAKSHIPALYA) BANGALORE",
  "D. S. Dinakar Polytechnic",
  "RAMAKRISHNA SCHOOL OF NURSING, BANGALORE",
  "J.G.TEACHERS TRAINING INSTITUTE, HUBLI",
  "RAMAKRISHNA POLYTECHNIC SRINIVASAPUR",
  "RAJMAHAL VILAS SCHOOL OF NURSING, BANGALORE",
  "LITTLE FLOWER INSTITUTE OF PARA MEDICAL SCIENCES",
  "RAJIV GANDHI SCHOOL OF NURSING HUBLI",
  "RAJIV GANDHI SCHOOL OF NURSING BIDAR",
  "JAWAHAR TEACHER TRAINING INSTITUTE YADGIR, GULBARGA",
  "RAJIV GANDHI SCHOOL OF NURSING BELLARY",
  "RAJIV GANDHI SCHOOL OF NURSING BANGALORE",
  "JAGDISH SHETH SCHOOL OF MANAGEMENT",
  "RAJIV GANDHI POLYTECHNIC BANGALORE",
  "RAJIV GANDHI INSTITUTE OF TECHNOLOGY VIDHYANAGAR",
  "JAWAHAR TEACHER TRAINING INSTITUTE GULBARGA",
  "RAJEEV SCHOOL OF NURSING HASSAN",
  "SMT SHAKUNTALA INSTITUTE OF PARAMEDICAL SCIENCES HUBBLI",
  "NIVEDITA PARAMDEDICAL INSTITUTE YADGIRI",
  "RAJEEV POLYTECHNIC HASSAN",
  "JASMINE SCHOOLOF NURSING BIDAR",
  "RAGHAVENDRA SCHOOL OF NURSING DAVANGERE",
  "QUEEN VICTORIA SCHOOL OF NURSING, GULBARGA",
  "QUALITY HEALTHCARE SCHOOL OF NURSING BANGALORE URBAN",
  "JASMINE DED COLLEGE, BIDAR",
  "P V S SCHOOL OF NURSING CHITRADURGA",
  "P. V. P. POLYTECHNIC JNANABHARATHI BANGALORE",
  "PRIYADARSHINI SCHOOL OF NURSING BANGALORE",
  "PRIN L N WELINGKAR INSTITUTE OF MANAGEMENT DEVELOPMENT AND RESEARCH",
  "PRINCE SCHOOL OF NURSING BANGALORE",
  "PRIMARY TEACHER TRAINING CENTRE UTTARA KANNADA",
  "PRESIDENCY SCHOOL OF NURSING BANGALORE",
  "PREMIER INSTITUTE OF NURSING CHIKKABALLAPUR",
  "NALANDA FOUNDATION POLYTECHNIC HUBLI",
  "HKDET POLYTECHNIC HUDAGI VILLAGE HUMNABAD",
  "NAGESH SCHOOL OF NURSING HASSAN",
  "NADGIR POLYTECHNIC BANGALORE",
  "MYTHRI SCHOOL OF NURSING SHIMOGA",
  "HIREMATH SAMSTHAN VIDYAPEETH TRUST BIDAR",
  "MY INSTITUTE TEACHERS TRAINING INSTITUTE BANGALORE",
  "HINDUSTAN ELECT. ACADEMY POLYTECHNIC BANGALORE",
  "M.V.P RURAL POLYTECHNIC HAUNSABHAVI",
  "M V J SCHOOL OF NURSING BANGALORE URBAN",
  "M V J POLYTECHNIC BANGALORE-67",
  "HINA SCHOOL OF NURSING BANGALORE",
  "GOVERNMENT POLYTECHNIC HOLEALUR",
  "M S RAMAIAH POLYTECHNIC BANGALORE",
  "M S RAMAIAH INSTITUTE OF MANAGEMENT",
  "HILLSIDE SCHOOL OF NURSING BANGALORE",
  "M S M S RURAL POLYTECHNICMARALITQ. GANGAVATHI",
  "MRUTYUNJAYA VIDYAPEETHA D.ED COLLEGE HAMSABHAVI, HAVERI",
  "HARSHA SCHOOL OF NURSING BANGALORE",
  "MOUNT FARAN POLYTECHNIC ANAND NAGAR ROAD OLD HUBLI",
  "MOTICHAND LENGADE BHARATESH POLYTECHNICBASAVESH NAGAR BASAVA KUDACHI COLONYBELGAUM",
  "HARALAIAH POLYTECHNIC BHALKI BIDAR DISTRICT",
  "MOTHER THERESA'S SCHOOL OF NURSING CHITRADURGA",
  "MOTHER THERESA SCHOOL OF NURSING, BIDAR",
  "MOTHER THERESA SCHOOL OF NURSING BANGALORE RURAL",
  "HALAMMA SCHOOL OF NURSING JOSHI GALLI ILKAL BAGALKOT",
  "MOTHER THERESA POLYTECHNIC KOLARA",
  "MOTHER THERESA NURSING SCHOOL GADAG",
  "G.V.GOWDA MEMORIAL VIDYARTHINILAYA VOKKALIGARA SAN CHAMARAJANAGAR",
  "MOTHER NOOR UNNEESA DED COLLEGE, KGF",
  "MODERN INSTITUTE OF NURSING BANGALORE",
  "MODERN EDUCATION SOCIETY POLYTECHNIC SIRSI",
  "GURUNANAK DED COLLEGE, BIDAR",
  "M N TECH INST KAMMAGONDANAHALLY BANGALORE",
  "MK ANANTARAJ DED COLLEGE KODANGALLU, DK",
  "M J ADARSHA NURSING SCHOOL BANGALORE URBAN",
  "GULGANNAVAR POLYTECHNIC, KOPPAL",
  "MITRA SCHOOL OF NURSING UDUPI",
  "MITHRA SCHOOL OF NURSING BANGALORE",
  "MIRANDA SCHOOL OF NURSING BANGALORE URBAN",
  "G T T C POLYTECHNIC BANGALORE",
  "MILLAT TEACHERS TRAINING INSTITUTION DHARWAD",
  "M H SCHOOL OF NURSING BANGALORE RURAL",
  "GOVT TOOL ROOM And TRAINING CENTREUDYAMBAGH",
  "M E S SCHOOL OF NURSING BANGALORE",
  "M E S POLYTECHNIC MADHUGIRI",
  "GOVT.TOOL ROOM And TRAINING CENTRE- Shimoga",
  "M E S INSTITUTE OF NURSING UTTAR KANNADA",
  "M E I POLYTECHNIC BANGALORE",
  "GOVT.TOOL ROOM AND TRAINING CENTRE-Mysore",
  "M E I EVENING POLYTECHNIC BANGALORE",
  "MATRU SCHOOL OF NURSING BANGALORE URBAN",
  "MARATHI TEACHER TRAINING INSTITUTE BELGAUM",
  "GOVT.TOOL ROOM AND TRAINING CENTRE-Mandya",
  "MARATHA MANDAL POLYTECHNIC BELGAUM",
  "MANONIDHI INSTITUTE OF NURSING CHAMARAJANAGAR",
  "GOVT. TOOL ROOM AND TRAINING CENTRE- KUDALASANGAMA",
  "MANJUNATHA SCHOOL OF NURSING BANGALORE",
  "SRI VISHWABHARATHI SCHOOL OF NURSING",
  "MANIPAL SCHOOL OF NURSING MANIPAL",
  "MANGALA SCHOOL OF NURSING HASSAN",
  "MANGALA SCHOOL OF NURSING DAKSHINA KANNADA",
  "GOVT. TOOL ROOM AND TRAINING CENTRE-HARIHAR",
  "MANASA SCHOOL OF NURSING KOLAR",
  "MALLIK SANDAL POLYTECHNIC BIJAPUR",
  "MALLIGE MEDICAL CENTRE BANGALORE",
  "Govt. Tool Room And Training Centre-Dakshina Kannada",
  "GOVT SCHOOL OF NURSING,  D.H. HAVERI",
  "GOVT SCHOOL OF NURSING, DHC CHITRADURGA",
  "GOVT SCHOOL OF NURSING D.H., BIJAPUR",
  "GOVT. POLYTECHNIC JALAKI",
  "GOVT. POLYTECHNIC FOR WOMEN HASSAN",
  "GOVT. POLYTECHNIC CHANNASANDRA",
  "MAHMOOD SHARIFF POLYTECHNIC REHMAN KHAN ROAD YESHWANTHPURBANGALORE-22",
  "MAHIMA INSTITUTE OF NURSING BELLARY",
  "MAHILA VIDYAPEETHA TTI FOR WOMEN DHARWAD",
  "MAHESHWARI SCHOOL OF NURSING GADAG",
  "MAHAYOGINI MATA MANIKESHWARI D.ED. COLLEGE SEDAM, GULABARGA",
  "MAHATMA GANDHI SCHOOL OF NURSING BANGALORE",
  "MAHATMA GANDHI PROFESSIONAL SCHOOL OF NURSING BANGALORE",
  "MAHALAKSHMI SCHOOL OF NURSING BANGALORE RURAL",
  "MADHU SCHOOL  OF NURSING, BENGALURU",
  "MAA VISHWA PALANI TRUST BIDAR",
  "R K INSTITUTE OF NURSING",
  "LOWRY MEMORIAL TEACHER TRAINING INSTITUTE BANGALORE",
  "GOVERNMENT POLYTECHNIC TUMKUR",
  "GOVERNMENT POLYTECHNIC SORABA",
  "GOVERNMENT TTI, SINDHANUR",
  "GOVERNMENT POLYTECHNIC SIDDAPURA",
  "GOVERNMENT POLYTECHNIC RAMANAGARA",
  "GOVERNMENT POLYTECHNIC RAICHUR",
  "GOVERNMENT POLYTECHNIC RABAKAVI BANAHATTI BAGALKOT",
  "GOVERNMENT POLYTECHNIC OURAD",
  "GOVERNMENT POLYTECHNIC NARAGUNDA DEVADURGARAICHUR",
  "GOVERNMENT POLYTECHNIC NAGAMANGALA MANDYA DISTRICT",
  "GOVERNMENT TEACHER TRAINING INSTITUTE TUMKUR",
  "GOVERNMENT POLYTECHNIC MULABAGILU KOLAR DIST.",
  "GOVERNMENT POLYTECHNIC MUDHOLABAGALKOT",
  "GOVERNMENT POLYTECHNIC KARATAGI GANGAVATHI KOPPALA",
  "GOVERNMENT POLYTECHNIC KAMPLI",
  "GOVERNMENT POLYTECHNICKALAGI GULBURGA DIST.",
  "GOVERNMENT POLYTECHNIC JOIDA",
  "GOVERNMENT TEACHER TRAINING INSTITUTE KOPPAL",
  "GOVERNMENT POLYTECHNIC IMMIDIHALLI",
  "GOVERNMENT POLYTECHNIC HUBBALI DHARAWAD DIST.",
  "GOVERNMENT POLYTECHNIC HOSADURGACHITRADURGA DIST",
  "GOVERNMENT POLYTECHNIC HOLENARASIPURA",
  "GOVERNMENT POLYTECHNIC, HIRIYUR",
  "GOVERNMENT POLYTECHNIC HARAPANAHALLI DAVANAGERE DIST.",
  "GOVERNMENT POLYTECHNIC HANAGAL HAVERI DIST.",
  "GOVERNMENT POLYTECHNIC GUTTURU HARIHARA DAVANAGERE DIST.",
  "GOVERNMENT POLYTECHNIC GULBARGA",
  "GOVERNMENT POLYTECHNIC GAJENDRAGAD",
  "GOVERNMENT POLYTECHNIC FOR WOMEN RAMANAGARA",
  "GOVERNMENT POLYTECHNIC FOR WOMEN MANGALORE",
  "GOVERNMENT POLYTECHNIC FOR WOMEN GULBARGA",
  "GOVERNMENT POLYTECHNIC CHITRADURGA",
  "GOVERNMENT POLYTECHNIC CHINTAMANI",
  "GOVERNMENT POLYTECHNIC CHANNAPATNA",
  "GOVERNMENT POLYTECHNIC CHAMARAJANAGAR",
  "GOVERNMENT POLYTECHNIC BILAGI BAGALKOT DISTRICT",
  "GOVERNMENT POLYTECHNIC BIJAPUR",
  "GOVERNMENT POLYTECHNIC BIDAR",
  "GOVERNMENT POLYTECHNIC BHANTVALA DAKSHINA KANNADA",
  "GOVERNMENT POLYTECHNIC BETAGERI GADAG DIST.",
  "GOVERNMENT POLYTECHNIC BELLARY",
  "GOVERNMENT POLYTECHNIC BELGAUM",
  "GOVERNMENT POLYTECHNIC BALAGANAHALLI KOLAR DIST.",
  "GOVERNMENT POLYTECHNIC BAILURU UDUPI DIST.",
  "GOVERNMENT POLYTECHNIC BAGEPALLI",
  "GOVERNMENT POLYTECHNIC BAGALKOT",
  "GOVERNMENT POLYTECHNIC ARAKERE SRIRANGAPATTANA",
  "GOVERNMENT POLDYTECHNIC APHAJALPURA GULBURGA DIST.",
  "GOVERNMENT NURSING SCHOOL TUMKUR",
  "GOVERNMENT MAHARANI TEACHERS TRAINING INSTITUTE MYSORE",
  "GOVERNMENT FILM & TV TECHNICAL INSTITUTE BANGALORE",
  "GOVERNMENT TEACHER TRAINING INSTITUTE HOSADURGA CHITRADURGA CHITRADURG",
  "GOVERNMENT DDPOLYTECHNIC TURUVEKERE RT--TUMKUR DISTRICT",
  "GOVERNMENT CP.ED COLLEGE AGALAGURKI, CHIKKABALLAPUR",
  "GOUTHAM SCHOOL OF NURWING CHAMRAJNAGAR",
  "GOUTHAMI SCHOOL OF NURSING BANGALORE",
  "GOUTHAM INSTT OF NSG BANGALORE",
  "GOUTHAM COLLEGE OF PARAMEDICAL SCIENCES",
  "GOPALA GOWDA SHANTHAVERI MEMORIAL HOSPITAL TRUST MYSORE",
  "GOMATESH POLYTECHNIC BELGAUM",
  "GOLDFINCH SCHOOL OF NURSING BANGALORE",
  "GNANA VIKAS POLYTECHNIC CHITRADURGA",
  "GLOBAL SCHOOL OF NURSING BANGALORE",
  "GIRIDHAR RAMANARAYAN INSTITUTE OF COMMERCIAL PRACTICE BANGALORE",
  "GHOUSIA POLYTECHNIC FOR WOMEN BANGALORE",
  "GAYATHRI SCHOOL OF NURSING BANGALORE",
  "NARAYANA HRUDAYALA SCHOOL OF NURSING BANGALORE RURAL",
  "DECCAN TEACHER TRAINING INSTITUTE ",
  "JAI HIND DED COLLEGE BULAND PERWAZ COLONY GULBARGA ",
  "GANGOTHRI SCHOOLOF NURSING BANGALORE URBAN",
  "S G INSTITUTE OF PARA MEDICAL SCIENCES CHITRADURGA",
  "GANGOTHRI SCHOOL OF NURSING BANGALORE URBAN",
  "FLORIDA SCHOOL OF NURSING BANGALORE URBAN",
  "FLORENCE NIGHTINGALE SCHOOL OF NURSING GULBARGA",
  "FLORENCE NIGHTINGALE SCHOOL OF NURSING BIDAR",
  "FEDERAL PRIMARY TEACHER TRAINING CENTRE RAICHUR",
  "FATHIMA TEACHER TRAINING INSTITUTE FOR WOMEN BANGALORE",
  "FATHER MULLER SCHOOL OF NURSING, DAKSHINA KANNADA",
  "FAROOQIA TEACHER TRNG. INSTITUTE FOR WOMEN MYSORE",
  "FAROOQIA POLYTECHNIC FOR WOMEN MYSORE",
  "FARAN SCHOOL OF NURSING BANGALORE",
  "ELLEN THOBURN COWEN MEMORIAL HOSPITAL OF KOLAR",
  "EBEN- EZER SCHOOL OF NURSING BANGALORE URBAN",
  "BOWRING & LADY CURZON HOSP. NURSING SCHOOL BANGALORE",
  "B L S SCHOOL OF NURSING MANDYA",
  "B L D E ASSOCIATION SCHOOL OF NURSING BIJAPUR",
  "B L D E ASSOCIATION POLYTECHNI BIJAPUR",
  "BILWA INSTITUTE OF NURSING BELLARY",
  "BILAHARA ACADEMY OF NURSING SCIENCES BANGALORE RURAL",
  "BHARAT POLYTECHNIC BANGARPET",
  "BHARATHI SCHOOL OF NURSING TUMKUR",
  "BHARATH EDUCATION SOCIETY, BANGALORE",
  "B G S POLYTECHNIC CHIKBALLAPUR-562101",
  "BEYNON SMITH TEACHER TRAINING INSTITUTE BELGAUM",
  "B E TRUST POLYTECHNIC K M DODDI (MANDYA DISTRICT",
  "BEST SCHOOL OF NURSING BELLARY",
  "BTL POLYTECHNIC",
  "B E S INSTITUTE OF TECHNOLOGY BANGALORE",
  "SHEKHAR INSTITUTE OF NURSING BANGALORE",
  "BEARYS FOUNDATION FOR TEACHERS TRAINING UDUPI",
  "BCN POLYTECHNIC LAKSHMESHWARA GADAG",
  "BASEL MISSION TEACHER TRAINING INSTITUTE DHARWAD",
  "BASAVESHWAR VIDYA VARDHAK SANGHAS T.T.I BAGALKOT",
  "BASAVESHWAR TEACHER TRAINING INSTITUTE BAGALKOT",
  "BASAVESHWAR D.ED COLLEGE, DEVADURGA",
  "BASAVESHWARA DED COLLEGE, BASAVAKALYAN",
  "BAPUJI TEACHERS TRAINING INSTITUTE KOPPAL",
  "BAPUJI SCHOOL OF NURSING SHIMOGA",
  "BAPUJI POLYTECHNIC SHABANUR DAVANAGERE",
  "BAPUJI COLLEGE OF NURSING CHITRADURGA",
  "BANGALORE NURSING SCHOOL BANGALORE",
  "BANGALORE INSTITUTE OF NURSING BANGALORE",
  "BANGALORE CITY SCHOOL OF NURSING I I T CAMPUS HULLIMOVA BANGALORE",
  "BANGALORE CITY SCHOOL OF NURSING CHELIKERE MAIN ROAD BANGALORE",
  "JAIN POLYTECHNIC BELAGAUM",
  "BALAJI POLYTECHNIC, GULBARGA",
  "Bajaj School of Nursing",
  "BAGALKOT BASAVESHWAR VIDYA VARDHAK SANGHAS T.T.I BELGAUM",
  "AZAD WOMEN TEACHERS TRAINING INSTITUTE SHIMOGA",
  "AYESHA SCHOOL OF NURISNG GULBARGA",
  "A V SCHOOL OF NURSING BANGALORE",
  "A V K SCHOOL OF NURSING BANGALORE",
  "ATHENA SCHOOL OF NURSING DAKSHINA KANNADA",
  "ASIA PACIFIC SHOOL OF NURSING BANGALORE",
  "ASHWINI SCHOOL OF NURSING BIJAPUR",
  "ASHWINI SCHOOL OF NURSING BANGALORE",
  "ASHRITH SCHOOL OF NURSING, KOTA",
  "ASHRAYA INSTITUTE OF NURSING SCIENCE CHIKMAGALUR",
  "ASHOKA POLYTECHNIC, KAMMAGONDANA HALLI, JALAHALLI WEST",
  "A SHAMA RAO NURSING SCHOOL DAKSHINA KANNADA",
  "A S G M RURAL POLYTECHNIC YARUR HUBLI",
  "ARYA BHARATHI POLYTECHNIC TUMKUR",
  "ARUNDHATI D.ED COLLEGE RANGAMPET, GULBARGA",
  "ARUNA SCHOOL OF NURSING TUMKUR",
  "ARISTOTLE T.T.I KOLAR",
  "ARISTOTLE SCHOOL OF NURSING KOLAR",
  "ARISTOTLE RURAL D.ED COLLEGE, MARIKUPPAM, KGF",
  "JOSCO SCHOOL OF NURSING",
  "REGIONAL COLLEGE OF MANAGEMENT AND ENTREPRENEURSHIP",
  "JANAPRIYA INSTITUTE OF PARAMEDICAL SCIENCES HASSAN",
  "SRI MANJUNATHA INSTITUTE OF PARA MEDICAL SCIENCES",
  "R MUDDURANGEGOWDA COLLEGE OF PHARMACY",
  "SHRI KALIDAS EDUCATIONAL SOCIETY BIJAPUR",
  "SHETTY POLYTECHNIC GULBURGA DIST.",
  "SHILPA SCHOOL OF NURSING BAGALKOT",
  "SHIV CHATRAPATI SMARAK SAMITIS SCHOOL OF NURSING KARWAR, UTTAR KANNADA",
  "SHRI J G CO-OPERATIVE HOSPITAL & RESEARCH BELGAUM",
  "SHREE BHAVANI SCHOOL OF NURSING BANGALORE",
  "SHRI HALESHWAR VIDYA PEETHAS SHRI GADAG",
  "ANGEL SCHOOL OF NURSING",
  "MAHALAXMI PARA MEDICAL INSTITUTE",
  "NEELAMBIKA SCHOOL OF NURSING",
  "SHRI GOMATESH EDUCATION SOCIETY'S INSTITTUTE OF NURSING BELGAUM",
  "SRI THIRUMALA SCHOOL OF NURSING",
  "SMT MAHANTAMMA PATIL PARA MEDICAL SCIENCE COLLEGE AFZALPUR",
  "V C AKKI CLLEGE OF PARAMEDICAL SCIENCE ILKAL",
  "K S INSTITUTE OF PARAMEDICAL AND ALLIED HEALTH SCIENCES KOPPAL",
  "BHARATHI VIDYA VARDHAK SCHOOL OF NURSING",
  "GOVERNMENT POLYTECHNIC BASAVAPATNA",
  "SHRI SAI SAMARTH INSTITUTE OF PARA MEDICAL SCIENCES DANDELI",
  "SAI DATTA SCHOOL OF NURSING",
  "SRINMATH POLYTECHNIC MYSORE",
  "SRI SIDDHAROODH INSTITUTE OF PARAMEDICAL SCIENCE BASAVAKALYAN",
  "SAGAR GANGOTRI SCHOOL OF NURSING SHIMOGA",
  "SULTAN COLLEGE OF D PHARMACY",
  "SUSHRUTHA SCHOOL OF NURSING SHAHPUR",
  "SUNRISE SCHOOL OF NURSING",
  "POORNAA PRAGNA SCHOOL OF NURSING",
  "NEW SHUSHRUTI SCHOOL OF NURSING",
  "MODERN SCHOOL OF NURSING",
  "MAX MULLAR INSTITUTE OF PARA MEDICAL SCIENCE, KGF",
  "MARGADARSHAN SCHOOL OF NURSING TONDIHAL ILKAL",
  "SIDDAGANGA INSTITUTE OF PARAMEDICAL SCIENCES",
  "ANJUMAN PARA MEDICAL INSTITUTE HUBLI DHARWAD",
  "R L  ABHISHEK RAO COLLEGE OF PARAMEDICAL SCIENCES",
  "KARNATAKA HEALTH INSTITUTE OF PARAMEDICAL SCIENCES GHATAPRABHA",
  "YENEPOYA INSTITUTE OF NURSING SCIENCES DAKSHINA KANNADA",
  "B S N COLLEGE OF PHARMACY",
  "Asian Institute of Pharmaceutical Sciences, Kalaburagi",
  "DR. APJ ABDUL KALAM COLLEGE OF PHARMACY",
  "DR. T M A PAI POLYTECHNIC MANIPAL",
  "DR VIJAYA KUMARI SCHOOL OF NURSING BANGALORE URBAN",
  "GOVERNMENT POLYTECHNIC KARWAR",
  "GOVERNMENT POLYTECHNIC KOPPAL",
  "GOVERNMENT POLYTECHNIC K R PET",
  "GOVERNMENT POLYTECHNIC KUDALGI",
  "GOVERNMENT POLYTECHNIC KUSHALNAGAR",
  "GOVERNMENT POLYTECHNIC KUSHTAGI",
  "GOVERNMENT POLYTECHNIC LINGASUGURU RAICHUR DISTRICT",
  "GOVERNMENT POLYTECHNIC MIRLE K R NAGARA TQ. MYSORE DISTRICT",
  "GOVERNMENT POLYTECHNIC MUDAGODA",
  "I M P A C T POLYTECHNIC BANGALORE",
  "IMRAN POLYTECHNIC, GULBARGA",
  "INDHIRA SHIVARAO POLYTECHNIC UDUPI",
  "INDIAN ACADEMY SCHOOL OF NURSING BANGALORE",
  "INDIAN INSTITUTE OF NURSING RAJARAJESHWARINAGAR BANGALORE",
  "Indian Institute of Plantation Management, Bangalore",
  "INDIAN SCHOOLOF NURSING BANGALORE",
  "K C T POLYTECHNIC GULBARGA",
  "KEMPEGOWDA INSTITUTE OF NURSING SCIENCES BANGALORE URBAN",
  "KEMPEGOWDA MEMORIAL POLYTECHNIC OORDIGERE ROAD BE",
  "NIRMALA RAMANA NURSING SCHOOL KODAGU",
  "K E T SCHOOL OF NURSING BIDAR",
  "KHAJA BANDA NAWAZ SCHOOL OF NURSING GULBARGA",
  "NIRMALA SCHOOL OF NURSING BANGALORE RURAL",
  "KHK INSTITUTE OF ENGINEERINGDHARWAD",
  "K I M S HOSPITAL SCHOOL OF NURSING, HUBLI",
  "NIRMALA SCHOOL OF NURSING SHIMOGA",
  "K J T E S POLYTECHNIC MULBAGAL",
  "MARIAM SCHOOL OF GENERAL NURSING & MIDWIFERY BANGALORE URBAN",
  "NISARGA SCHOOL OF NURSING HASSAN",
  "MARIA SCHOOL OF NURSING BANGALORE",
  "MARTINLUTHER SCHOOL OF NURSING HUBLI",
  "NITTE USHA INSTT. OF NURSING SCIENCES DAKSHINA KANNADA",
  "ANUPAMA SCHOOL OF NURISNG BANGALORE",
  "MASKI ABDULLA MEMORIAL D.ED COLLEGE, HATTI",
  "NITTUR EDUCATION SOCIETY POLYTECHNIC NITTUR",
  "MASOOD SCHOOL OF NURSING DAKSHINA KANNADA",
  "MATHRUSHREE BHEEMBAI AMBEDKAR INST OF NURSING BANGALORE",
  "NIVEDITA SCHOOL OF NURSING GULBARGA",
  "R.G.E. SOCIETYS DIPLOMA IN EDUCATION GADAG",
  "R J S POLYTECHNIC BANGALORE",
  "R K M SCHOOL OF NURSING BIJAPUR",
  "R M POLYTECHNIC GULBURGA DIST.",
  "R N SHETTY POLYTECHNIC BELGAUM",
  "B V V SANGHAS SHARADAMBE INSTITUTE OF NURSING SCIENCES",
  "R N SHETTY POLYTECHNIC MURUDESHWAR",
  "ROOHI SCHOOL OF NURSING BANGALORE",
  "ROSA MISTICA TEACHER TRAINING INSTITUTE DAKSHINA KANNADA",
  "ROYALE CONCORDE TEACHER TRAINING INSTITUTE BANASHANKARI BANGALORE",
  "ROYAL SCHOOL OF NURSING BANGALORE",
  "RR EDUCATIONAL CULTURAL & CHARITABLE TRUST, SOORAMPALLI",
  "R.R.POLYTECHNIC BANGALORE",
  "SHREEDEVI ISHWAR PARA MEDICAL COLLEGE DEVAR HIPPARAGI VIJAYAPURA",
  "V E I PARA MEDICAL COLLEGE SINDAGI VIJAYAPURA",
  "R R SCHOOL OF NURSING BANGALORE",
  "RR TAMIL DED COLLEGE, KGF",
  "R.T.E.SOCIETY'S RURAL POLYTECHNIC HULKOTI",
  "SLT Polytechnic college Gurumitkal",
  "R T NAGAR SCHOOL OF NURSING BANGALORE",
  "GOVT. TOOL ROOM AND TRAINING CENTRE CHIKODI",
  "SHRI BABA INSTITUTE OF NURSING SCIENCES HUBLI",
  "GOVT TOOL ROOM AND TRAINING CENTER GOWRIBIDANURU",
  "SHETTY PARAMEDICAL INSTITUTE",
  "UNIVERSAL SCHOOL OF NURSING BANGALORE URBAN",
  "UNITY NURSING INSTITUTE SCHOOL OF NURSING DAKSHINA KANNADA",
  "UNITY HEALTH COMPLEX SCHOOL OF NURSING CHITRADURGA",
  "UMA MAHESWARA SCHOOL OF NURSING RAICHUR",
  "TUNGABHADRA SCHOOL OF NURSING BELLARY",
  "TUKKAR SCHOOL OF NURISNG BELGAUM",
  "T M A E S SCHOOL OF NURSING BELLARY",
  "TMAE SOCIETYS TEACHER TRAINING INSTITUTE DAVANAGERE",
  "JASMINE COLLEGE OF PHARMACY, BIDAR",
  "T M A E SOCIETYPOLYTECHNIC HOSPET",
  "T M A E SOCIETY POLYTECHNIC BHADRAVATHI",
  "TMAE DPED COLLEGE, HAVERI",
  "T JOHN SCHOOL OF NURSING GULBARGA",
  "TIPPU SHAHEED INSTITUTE OF TECHNOLOGY HUBLI",
  "THRUPTI INSTITUTE OF NURSING BANGALORE URBAN",
  "THE RURAL EDUCATION SOCIETY BANGALORE RURAL",
  "THE OXFORD POLYTECHNIC 1ST PHASEJ.P.NAGAR BANGALORE",
  "THE BIJAPUR DIST. MINORITY NATIONAL EDN SOCIETY BIJAPUR",
  "PARADISE COLLEGE OF PHARMACY KALABURAGI",
  "ST ANN' S SCHOOL OF NURSING DAKSHINA KANNADA",
  "ST. ANNES D.ED. COLLEGE, ALNAVAR",
  "SS TTI LACHYAN, BIJAPUR",
  "BALLARI RURAL POLYTECHNIC",
  "S S INSTITUTE OF NURSING SCIENCES DAVANGERE",
  "SRI TIRUMALA SCHOOL OF NURSING BENGALURU",
  "SHREE MERU SCHOOL OF NURSING BENGALURU",
  "SURAVI SCHOOL OF NURSING BENGALURU",
  "SHRUSHTI SCHOOL OF NURSING",
  "SRI KAMADHENU SCHOOL OF NURSING BENGALURU",
  "ASTER SCHOOL OF NURSING",
  "BANGALORE COLLEGE OF PHARMACY",
  "WEST HILL POLYTECHNIC ARALABARAGURU, C R PATNA",
  "RAIBAG POLYDSTECHNIC RAIBAG",
  "V S MS SECOND SHIFT POLYTECHNIC",
  "DIVINE GRACE SCHOOL OF NURSING",
  "AUREL SCHOOL OF NURSING",
  "SMT SHAKUNTALA PATIL INSTITUTE OF NURSING SCIENCES GADAG",
  "POORVIKA SCHOOL OF NURSING",
  "CNK A SCHOOL OF NURSING",
  "SIDDALINGA SCHOOL OF NURSING",
  "COMPOSITE REGIONAL CENTRE FOR SKILL DEVELOPMENT REHABILITATION AND EMPOWERMENT OF PERSONS WITH DISABILITIES DAVANAGERE",
  "VIVEKANANDA POLYTECHNIC PUTTUR (DK)",
  "ANUPAMA COLLEGE OF PHARMACY",
  "SRI RAMKRISHNA COLLEGE OF PHARMACY",
  "RAJIV GANDHI EDUCATION SOCIETIES PHARMACY COLLEGE NAREGAL ABBIGERE ROAD ROAD RONA GADAG KARNATAKA",
  "VISWESWARAIAH POLYTECHNIC",
  "S S G POLYTECHNIC JEVARGI",
  "VISWA SAI SCHOOL OF NURSING BANGALORE",
  "VISWA BHARATHI SCHOOL OF NURSING BANGALORE",
  "VISHWA DARSHANA SCHOOL OF NURSING KARWAR (UTTARA KANNADA)",
  "SS COLLEGE OF PHYSICAL EDUCATION, BIJAPUR",
  "VISHNU SCHOOL OF NURSING KOLAR",
  "VIJAYANAGAR SCHOOL OF NURSING BANGALORE",
  "VIJAYALAKSHMI SCHOOL OF NURSING KOLAR",
  "SRI VISHWARADHYA D.ED COLLEGE YADGIRI, GULBARGA",
  "VIJAYALAKSHMI POLYTECHNIC PALAR NAGARA K G F",
  "CAMBRIDGE SCHOOL OF NURSING",
  "BAPUJI INSTITUTE OF PARAMEDICAL SCIENCES",
  "SURYA SCHOOL OF NURSING",
  "DANESHWARI INSTITUTE OF PARA MEDICAL SCIENCES BAGALKOTE",
  "SREE SIDDAGANGA HOSPITAL PARAMEDICAL COLLEGE",
  "VIGNAN INSTITUTE OF NURSING BANGALORE",
  "SRI VISHNU SCHOOL OF NURSING BANGALORE RURAL",
  "VIGHSHNESHWAR D.ED COLLEGE, HUBLI",
  "VIDYASHALI INSTITUTE OF PARAMEDICAL SCIENCES AURAD BIDAR",
  "VIGHNESHWARA INSTITUTE OF NURSING SCIENCES DHARWAD",
  "VIDYA VIKAS TRUST'S BIDAR",
  "CHANNABASAVA COLLEGE OF PARAMEDICAL SCIENCE BASAVAKALYAN",
  "SRI VINAYAKA SCHOOL OF NURSING, KGF",
  "SRI SANGAMESHWAR COLLEGE OF PARAMEDICAL SCIENCE KAMALNAGAR BIDAR",
  "SIRASAGI PARA MEDICAL COLLEGE OF SCIENCE ALMEL",
  "JEEVAN AROGYA PARA MEDICAL COLLEGE JAMKHANDI",
  "RMSS INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "VIDYA VIKAS EDUCATION TRUST POLYTECHNIC MYSORE",
  "VIDYAVARDHAKA POLYTECHNIC MYSORE",
  "ACHARYA POLYTECHNIC",
  "JC COLLEGE OF PHARMACY SIRA",
  "S D F COLLEGE OF PHARMACY BIDAR",
  "SRI SANGAMESHWAR COLLEGE OF PHARMACY KAMALNAGAR",
  "CHANNABASAVA COLLEGE OF PHARMACY BASAVAKALYAN",
  "SRI VINAYAKA POLYTECHNICKORAMANDAL",
  "J B EDUCATION SOCIETY R SMT SHARNAMMAHALMADGI COLLEGE OF PHARMACY BASAVAKALYAN",
  "VIDYA SCHOOL OF NURSING UDUPI",
  "MANJUNATHA  COLLEGE OF PHARMACY",
  "VIDYASAGAR SCHOOL OF NURSING BANGALORE",
  "SRI VIDYANIKETHAN POLYTECHNIC HASSAN",
  "VIDYASAGAR ALPASANKHYATAR SHAIKSHANIK SAMSTHES ANN BELGAUM",
  "VIDYAMANI SCHOOL OF NURSING BIDAR",
  "SUJAY INSTITUTE OF PARAMEDICAL SCIENCES CHITRADURGA",
  "VIDYA KIRANA SCHOOL OF NURSING, BANGALORE",
  "RAMANUJACHARYA PARA MEDICAL COLLEGE",
  "BETHANY PARA MEDICAL COLLEGE",
  "V E T B V L POLYTECHNIC BANGALORE",
  "INDUS VALLEY COLLEGE OF PARA MEDICAL SCIENCES BANGALORE",
  "SRI SHIVAYOGEESHWARA PARA MEDICAL COLLEGE",
  "ASHWINI INSTITUTE OF PARAMEDICAL SCIENCES BIJAPURA",
  "B G S INSTITUTE OF NURSING SCIENCES KUSHTAGI",
  "SRI VENKATESWARA D.ED COLLEGE, KGF",
  "SAFIA URDU D.ED COLLEGE, RAICHUR",
  "VASAVI GNANAPEETA POLYTECHNIC BANGALORE",
  "VARMA TEACHERS TRAINING INSTITUTE CHAMARAJANAGAR",
  "SRI VENKATESHWARA SCHOOL OF NURSING TUMKUR",
  "VARDARAJA SCHOOL OF NURSING TUMKUR",
  "VARALAKSHMI SCHOOL OF NURSING T DASARAHALLI BANGALORE URBAN",
  "SRI VENKATESHWARA POLYTECHNIC BANGALORE",
  "VANITHA TEACHER TRAINING INSTITUTE DHARWAD",
  "VANIE NURSING SCHOOL BANGALORE URBAN",
  "SRI VENKATA RAJU INSTITUTE OF TECH BANGALORE",
  "VAIDYA SCHOOL OF NURSING HASSAN",
  "VAGDEVI NURSING SCHOOL BANGALORE URBAN",
  "KRISHNA INSTITUTE OF NURSING",
  "SRI VEERASHIVA SAMAJ T.T.I RAICHUR",
  "USAMA CHARITABLE TRUST SHIMOGA",
  "SRI SS DED COLLEGE LONI BK, BIJAPUR",
  "SRI SIDDHARTHA SCHOOL OF NURSING SIDDHARTHA NAGAR B H ROAD TUMKUR",
  "SRI SIDDHARTHA SCHOOL OF NURSING AGALKOTE CAMPUS B H ROAD TUMKUR",
  "SRI SIDDHARTHA POLYTECHNIC, BANGARPET",
  "SRI SIDDHARTHA DED COLLEGE HUCHCHA GONDANAHALLI, TUMKUR",
  "SIDDARTHA TEACHERS TRAINING INSTITUTE CHAMARAJANAGAR",
  "GOLDEN GATE COLLEGE OF PHARMACY",
  "Govt tool room and training centre gttc",
  "SIDDAGANGA POLYTECHNIC TUMKUR",
  "HASSAN COLLEGE OF PHARMACY",
  "SHUSHRUTI SCHOOL OF NURSING BANGALORE",
  "SHRI VIJAYA MAHANTESH VIDYAVARDHAK SANGHA BAGALKOT",
  "ROYAL INSTITUTE OF PARAMEDICAL SCIENCES",
  "LUMBINI INSTITUTE OF PARAMEDICAL SCIENCES COLLEGE",
  "BHAGWAN MAHAVEER INSTITUTE OF PARAMEDICAL SCIENCE",
  "DISTRICT HOSPITAL CHITRADURGA",
  "LATE SRI VEERBHADRAPPA DEVARKAL EDUCATION TRUST YADGIR",
  "Govt Tool Room and Training Center Hosapete",
  "SHRI VEERABHADRESHWARA RURAL TEACHERS TRAININ (D.ED) INSTITUTE BELLARY",
  "SHRI UTAGANOOR BASAVALINGA TATA EDN. TRUST RAICHUR",
  "SRI VEERABHADRESHWAR PARAMEDICAL COLLEGE BASAVAKALYAN",
  "Sushrutha School of Nursing",
  "MARGADARSHAN COLLEGE OF PHRAMACY",
  "Amruta Institute of Engineering and Management Sciences",
  "SHRI ULAVI CHANNABASAVESHWAR POLYTECHNIC",
  "ADARSH PARA MEDICAL INSTITUTE TIKOTA",
  "Niveditha College Of Pharmacy",
  "RAJEE SCHOOL OF NURSING",
  "SANA SCHOOL OF EDUCATION SHANTINIKETAN DHARWAD",
  "SANDUR POLYTECHNIC, YESHWANTNAGAR",
  "SANJAY GANDHI POLYTECHNIC BELLARY",
  "SANJAY MEMORIAL POLYTECHNICIKKERI ROADSAGAR-577401SHIMOGA DIST",
  "SANJEEVINI COOPERATIVE INSTITUTE OF NURSING, HASSAN",
  "SANJEEVINI INSTITUTE OF NURSING SCIENCES DAVANGERE",
  "SANJIVINI NURSING INSTITUTE DAKSHINA KANNADA",
  "SANJO SCHOOL OF NURSING MANDYA",
  "SARVA SEVA BODHAKA SHIKSHANODAYA TTI CHITRADURG",
  "SHRI SUBHAS NAGUR MEMORIAL POLYTECHNIC BIJAPUR",
  "SHRI SHIVAJI MARTHI TEACHER TRAINING INSTITUTION BIJAPUR",
  "SARVODAYA SCHOOL OF NURSING BANGALORE",
  "sharada college of pharmacy yadgir",
  "SHRI PADMARAJ VIDHYA VARDHAKA SAMSTHA BIJAPUR",
  "DR SHASHIDHAR MAALAKARADDY PARAMEDICAL COLLEGE KHANAPUR",
  "SHRI MURUGHARAJENDRA D.ED. COLLEGE KUSNOOR ROAD, GULBARGA",
  "SRI JAWAHAR PARA MEDICAL INSTITUTE YADGIR",
  "Sri S B Deshmukh Pharmacy College",
  "SHRI MAHAYOGINI MATA MANIKESHWARI D ED COLLEGE, MANIKAGIRI GUL",
  "ADARSH PARAMEDICAL COLLEGE BYADGI",
  "SHRI LAXMI VENKATESWARA SCHOOL OF NURSING CHITRADURGA",
  "SNEHA SCHOOL OF NURSING",
  "PADMABHUSHAN DR M C MODI CHARITABLE EYE HOSPITAL",
  "SRI BASAVARAJ PARA MEDICAL COLLEGE  HIRIYUR",
  "ORIENTAL COLLEGE OF PHARMACY",
  "VIJAYA EDUCATION SOCIETY AND RESEARCH CENTER",
  "SHRI K.R.HUKKERI VIDYA VARDHAK SANGH BELGAUM",
  "SRI MYLARALINGESHWARA INSTITUTE OF PARAMEDICAL SCINNECES",
  "SRI MARUTHI INSTITUTE OF PARAMEDICAL SCIENCES",
  "SHRI KALMESHWAR TEACHERS TRAINING INSTITUTE BELGAUM",
  "SHRI KALIDAS EDUCATION SOCIETY BAGALKOT",
  "SAUDAGAR D.ED COLLEGE, GULBARGA",
  "S B SCHOOL OF NURSING BANGALORE URBAN",
  "SCHOOL OF MINES K G F",
  "SCHOOL OF NURSING BELGAUM",
  "SCHOOL OF NURSING CHIGATERI",
  "SCHOOL OF NURSING GULBARGA",
  "S C T POLYTECHNIC BANGALORE",
  "S D JAYARAM SCHOOL OF NURSING MANDYA",
  "SDM INSTITUTE FOR MANAGEMENT DEVELOPMENT",
  "S.D.M.INSTITUTE OF EDUCATION DAKSHINA KANNADA",
  "S D M INSTITUTE OF NURSING SCIENCES DHARWAD",
  "S E A SCHOOL OF NURSING BANGALORE",
  "SEEMA DED COLLEGE, KGF",
  "SES POLYTECHNIC SIRUGUPPA",
  "S E T POLYTECHNIC MELKOTE",
  "SGES DR. N MAGDAM POLYTECHNIC ANKALI",
  "S.G.M POLYTECHNIC, DEVANUR",
  "S G V INSTITUTE OF NURSING BELGAUM",
  "SHANTHINIKETHAN POLYTECHNIC B M ROAD VIVEKANANDA",
  "SANJEEVINI COLLEGE OF PARAMEDICAL SCIENCES",
  "INTERNATIONAL  INSTITUTE OF BUSINESS STUDY",
  "GOVT SCHOOL OF NURSING KOZHIKODE",
  "SCHOOL OF NURSING CHAZHIKATTU HOSPITALS (P) LTD. DUKKI",
  "GOVT SCHOOL OF NURSING FOR SC/ ST KOLLAM",
  "KASTOORBA GANDHI TEACHER TRAINING INSTITUTE KOLLAM",
  "GOVT SCHOOL OF NURSING ERNAKULAM",
  "GOVT. POLYTECHNIC COLLEGE VANDIPERIYAR KUMILY",
  "KMCT POLYTECHNIC COLLEGE KUTTIPPURAM",
  "CRESCENT TEACHER TRAINING INSTITUTE THIRUVANANTHAPURAM",
  "GOVT. POLYTECHNIC COLLEGE PURAPPUZHA",
  "MAR BASELIOUS MEDICAL MISSION HOSPITAL ERNAKULAM",
  "GOVT. POLYTECHNIC COLLEGE PERUMBAVOOR",
  "GOVT. POLYTECHNIC COLLEGE PERINTHALMANNA",
  "GOVT. POLYTECHNIC COLLEGE NEDUMKANDAM",
  "CHAITHANYA EYE HOSPITAL AND RESEARCH INSTITUTE",
  "KERALA STATE ELECTRONICS DEVELOPMENT CORPORATION LTD",
  "GOVT. POLYTECHNIC COLLEGE KUNNAMKULAM",
  "GOVT. POLYTECHNIC COLLEGE KOTHAMANGALAM",
  "PRS PARAMEDICAL INSTITUTE",
  "LBS CENTRE FOR SCIENCE AND TECHNOLOGY",
  "VICTORY HEALTH INSPECTOR TRAINING SCHOOL OLATHANNY THIRUVANANTHAPURAM",
  "GOVT SCHOOL OF NURSING WAYANAD",
  "GOVT SCHOOL OF NURSING THRISSUR",
  "GOVT SCHOOL OF NURSING PATHANAMTHITTA",
  "GOVT SCHOOL OF NURSING PALAKKAD",
  "GOVT SCHOOL OF NURSING KOTTAYAM",
  "GOVT. POLYTECHNIC COLLEGE KORATTY",
  "GOVT. POLYTECHNIC COLLEGE KALAMSSERY",
  "MALABAR POLYTECHNIC CAMPUS",
  "GOVT. POLYTECHNIC COLLEGE CHELAKKARA",
  "GOVT GENERAL HOSPITAL THIRUVANANTHAPURAM",
  "LISIEUX CONVENT TEACHER TRAINING INSTITUTE THRISSUR",
  "RAJIV GANDHI ACADEMY FOR AVIATION TECHNOLOGY",
  "GOVRNMENT POLYTECHNIC COLLEGE PUNALUR",
  "GOVERNMENT TTI EDAPPALLY, ERNAKULAM",
  "MAHARAJAH'S TECHNOLOGICAL INSTITUTE",
  "GOVERNMENT TTI CHERUVATHOOR, ERNAKULAM",
  "GOVERNMENT TTI, CHALAKUDY",
  "MADIN POLYTECHNIC COLLEGE",
  "GOVERNMENT TEACHER TRAINING INSTITUTE WAYNAD",
  "GOVERNMENT TEACHER TRAINING INSTITUTE MUVATTUPUZHA ERNAKULAM",
  "SCHOOL OF NURSING CALICUT",
  "LSN TEACHER TRAINING INSTITUTE PALAKKAD",
  "GOVERNMENT TEACHER TRAINING INSTITUTE MATHAMANGALAM, KANNUR",
  "QUAIDE-A-MILLATH TEACHERS TRAINING INSTITUTE THIRUVANANTHAPURAM",
  "GOVERNMENT TEACHER TRAINING INSTITUTE MANACAUD THIRUVANANTHAPURAM",
  "LOURDES SCHOOL OF NURSING HOLY CROSS HOSPITAL KOTTIYAM, KOLLAM",
  "GOVERNMENT TEACHER TRAINING INSTITUTE MALAPPURAM",
  "M GM SILVER JUBILEE POLYTECHNIC COLLEGE",
  "GOVERNMENT TEACHER TRAINING INSTITUTE KOZHIKODE",
  "GOVERNMENT TEACHER TRAINING INSTITUTE KOTTAYAM KOTTAYAM",
  "LOURDES HOSPITAL ERNAKULAM",
  "SCHOOL OF NURSING ALUVA ERNAKULAM",
  "COOPERATIVE TRAINING COLLEGE TIRUR",
  "GOVERNMENT TEACHER TRAINING INSTITUTE KANNUR",
  "GOVERNMENT SPECIAL TEACHERS TRAINING CENTER GOVT BLIND SCHOOL COMPOUND VIDHYANAGAR KASARAGOD",
  "PUSHPAGIRI COLLEGE OF ALLIED HEALTH SCIENCES, THIRUVALLA",
  "GOVERNMENT TEACHER TRAINING INSTITUTE FOR WOMENKANNUR",
  "GOVERNMENT TEACHER TRAINING INSTITUTE FOR MEN KOZHIKODE",
  "K M C T SCHOOL OF NURSING KOZHIKODE",
  "CO OPERATIVE TRAINING COLLEGE,KANHANGAD",
  "GOVERNMENT TEACHER TRAINING INSTITUTE ETTUMANOOR KOTTAYAM",
  "GOVERNMENT TEACHER TRAINING INSTITUTE CHITTOR PALAKKAD",
  "majlispolytechnic college",
  "GOVERNMENT TEACHER TRAINING INSTITUTE AMBIKAPURAM PALAKKAD",
  "COOPERATIVE TRAINING COLLEGE, KOZHIKODE",
  "GOVERNMENT TEACHER TRAINING INSTITUTE ALAPUZHA",
  "LISIE HOSPITAL ERNAKULAM",
  "TRIVENI INSTITUTE OF PHARMACY",
  "GOVERNMENT SCHOOL OF NURSING MALAPPURAM",
  "K I M S SCHOOL OF NURSING TRIVANDRUM",
  "FAROOK EDUCATIONAL SOCIETY MALAPURAM",
  "FOOD CRAFT INSTITUTE KOTTAYAM",
  "FOOD CRAFT INSTITUTE, PERINTHALMANNA",
  "LISA SCHOOL OF NURSING KOZHIKODE",
  "FOOD CRAFT INSTITUTE ,CHERTHALA",
  "GOVERNMENT SCHOOL OF NURSING KANNUR",
  "FOOD CRAFT INSTITUTE, THODUPUZHA",
  "GOVERNMENT SCHOOL OF NURSING, DISTRICT HOSPITAL KOLLAM",
  "SCHOOL OF NURSING ARUNAPURAM KOTTAYAM",
  "GOVERNMENT POLYTECHNIC COLLEGE VENNIKULAM",
  "JAMIA NADAWIYYA TTI MALAPURAM",
  "JAWAHAR BHARATHI EDUCATIONAL MALAPURAM",
  "FAROOK INSTITUTE OF TEACHER EDUCATION KOZHIKODE",
  "SCHOOL OF NURSING KUNNAMKULAMTHRISSUR",
  "SCHOOL OF NURSING KURIAKOSE CHAVARA MEMORIAL HOSPITAL L S P O NOORANADU ALAPPUZHA",
  "SCHOOL OF NURSING LOURDE HOSPITAL TALIPARAMBA KANNUR",
  "SCHOOL OF NURSING MARADU ERNAKULAM",
  "COOPERATIVE TRAINING CENTRE ARANMULA",
  "SCHOOL OF NURSING MUNDAKAYAM EAST IDUKKI",
  "SCHOOL OF NURSING NEDUMKANDARM IDUKKI",
  "SCHOOL OF NURSING NORTH PARAVUR ERNAKULAM",
  "FOOD CRAFT INSTITUTE, KOLLAM",
  "SCHOOL OF NURSING OLLUR THRISSUR",
  "THE BADAGARA CO -OPERATIVE INSTITUTE OF NURSING KOZHIKODE",
  "CHILD DEVELOPMENT CENTRE, MEDICAL COLLEGE, THIRUVANANTHAPURAM",
  "THIAGARAJAR POLYTECHNIC COLLEGE ALAGAPPANAGAR",
  "FOOD CRAFT INSTITUTE, THIRUVANANTHAPURAM",
  "FOOD CRAFT INSTITUTE, KANNUR",
  "THUNCHAN SMARAKA TEACHER TRAINING INSTITUTE THIRUVANANTHAPURAM",
  "TIRUMALA DEVASWOM TEACHER TRAINING INSTITUTE ERNAKULAM",
  "TIRUVALLA MEDICAL MISSION SCHOOL OF NURSING PATHANAMTHITTA",
  "TTI CHETTIKULANGARA MAVELIKKARA, ALAPPUZHA",
  "TTI THAZEKARA, ALAPUZHA",
  "GOVERNMENT POLYTECHNIC COLLEGE VECHOOCHIRA",
  "Holy Grace Polytechnic College",
  "FOOD CRAFT INSTITUTE  THRISSUR",
  "KOZHIKODE DISTRICT CO OPERATIVE HOSPITAL",
  "BENZIGER SCHOOL OF NURSING",
  "GOVERNMENT POLYTECHNIC COLLEGE THRIKKARIPUR",
  "FOOD CRAFT INSTITUTE, UDMA",
  "AL-AZHAR COLLEGE OF ENGINEERING AND POLYTECHNIC",
  "CHEMPAKASSERY TEACHER TRAINING INSTITUTE KOLLAM",
  "C.F. TEACHER TRAINING INSTITUTE KOLLAM",
  "CENTRAL POLYTECHNIC COLLEGE VATTIYOORKKAVU",
  "FOOD CRAFT INSTITUTE KALAMASSERY",
  "MANZOOR HOSPITAL KASARGOD",
  "T A T M COOPERATIVE TRAINING COLLEGE, PALA",
  "FOOD CRAFT INSTITUTE PALAKKAD",
  "SEETHI SAHIB MEMORIAL ORPHANAGE  TEACHER TRAINING INSTITUTE THIRURANGADI, MALAPURAM",
  "MANNAM PATTA EDUCATION PALAKKAD",
  "MANKADA ORPHANAGE TEACHER TRAINING INSTITUTE MALAPURAM",
  "MALIK DEENAR CHARITABLE HOSPITAL KASARGOD",
  "SEETHI SAHIB CHARITABLE TRUST KOZHIKODE",
  "MALABAR TEACHER TRAINING INSTITUTE KANNUR",
  "K VELAYUDHAN MEMORIAL HOSPITAL ALAPPUZHA",
  "SCHOOL OF NURSING UPHILL MALAPPURAM",
  "FOOD CRAFT INSTITIUTE, KOZHIKODE",
  "Younus College of Polytechnic",
  "SCHOOL OF NURSING TALIPARAMBA CO- OPERATIVE HOSPITAL TALIPARAMBA KANNUR",
  "CRAFT SCHOOL OF NURSING",
  "KULAMUDIYIL NEELAKANDAN NAIR MEMORIAL TTI KOLLAM",
  "VIJAYA COLLEGE OF PARAMEDICAL SCIENCES",
  "COOPERATIVE TRAINING CENTER, NORTH PARAVUR, ERANAKULAM",
  "SCHOOL OF NURSING ST. SEBASTIANs VISITATION HOSPITAL ARTHUNKAL, CHERTHALA",
  "K T C T SCHOOL OF NURSING THIRUVANANTHAPURAM",
  "KRISTU JAYANTI SCHOOL OF NURSING KOLLAM",
  "KRISHNA TEACHER TRAINING THRISSUR",
  "SCHOOL OF NURSING SREEKANDAPURAM HOSPITAL KANDIYOOR ALAPPUZHA",
  "K P M SCHOOL OF NURSING MALAPURAM",
  "H.M. TRAINING SCHOOL ERNAKULAM",
  "SCHOOL OF NURSING SHORNUR ROAD THRISSUR",
  "HIO TTI OLAVATTUR",
  "MALABAR POLYTECHNIC COLLEGE KOTTAKKAL",
  "KMCT SCHOOL OF MANAGEMENT",
  "SCHOOL OF NURSING SANTHI HOSPITAL OMASSERY, CALICUT",
  "SNM Polytechnic College",
  "SCHOOL OF NURSING PARIYARAM KANNUR",
  "CARMEL POLYTECHNIC COLLEGE",
  "GOVERNMENT POLYTECHNIC COLLEGE CHERTHALA",
  "CAREWELL SCHOOL OF NURSING KASARGOD",
  "B.N.V. TEACHER TRAINING INSTITUTE THIRUVANANTHAPURAM",
  "SCMS COLLEGE OF POLYTECHNICS",
  "SCHOOL OF NURSING KASARAGOD",
  "B N V SCHOOL OF NURSING, THIRUVALLAM, THIRUVANANTHAPURAM",
  "NSS COOPERATIVE TRAINING COLLEGE",
  "B K J M SCHOOL OF NURSING KANNUR",
  "MOHD. ABDUL RAHMAN MEMORIAL TEACHET TRG INSTITUTE KOZHIKODE",
  "LEYAMMA MEMORIAL S/N KOTTAYAM",
  "MORNING STAR SCHOOL OF NURSING IDUKKI",
  "SCHOOL OF NURSING ALLAPUZHA",
  "SCHOOL OF NURSING ALATHUR PALAKKAD",
  "SAN JOS PARISH HOSPITAL THRISSUR",
  "MGM POLYTECHNIC COLLEGE",
  "SAN JOE HOSPITAL ERNAKULAM",
  "HIGHRANGE CO OPERATIVE HOSPITAL SCHOOL OF NURSING THANKAMANY IDUKKI",
  "B.I. TEACHER TRAINING INSTITUTE KOTTAYAM",
  "SADANAM INSTITUTE OF COMMERCE AND MANAGEMENT STUDIES",
  "NATIONAL TTI KUTTIKONAM, KOLLOM",
  "BISHOP VAYALIL MEDICAL CENTRE IDUKKI",
  "BHAGAVATHI VILASAM TEACHER TRAINING INSTITUTE ERNAKULAM",
  "CO OPERATIVE TRAINING CENTER, KARANI, WAYANAD",
  "MARIA THERESA HOSPITAL TRICHUR",
  "LAL MEMORIAL HOSPITAL THRISSUR",
  "BBM TTI MUNDAKKAYAM, KOTTAYAM",
  "BADHIRIYA TEACHER TRAINING INSTITUTE KOLLAM",
  "BABY MEMORIAL HOSPITAL KOZHIKODE",
  "ASAN MEMORIAL TEACHER TRAINING INSTITUTE THIRUVANANTHAPURAM",
  "JPHN Training Centre for SC/ST",
  "COOPERATIVE TRAINING CENTRE PALAKKAD",
  "LOURDES COLLEGE OF PARAMEDICAL SCIENCES, KOCHI, ERNAKULAM",
  "AZHICODE SEETHI SAHIB MEMORIAL TEACHER TRG INSTITUTE THRISSUR",
  "JOHN ENOCH COLLEGE OF PHARMACY",
  "KERALA FEDERATION OF THE BLIND TRAINING CENTRE FOR THE TEACHERS OF VISUALLY HANDICAPPED",
  "SACRED HEART TEACHER TRAINING INSTITUTE PATHANAMTHITTA",
  "AWH TTI CHERUVANNUR FEROKE, KOZHIKODE",
  "AWH POLYTECHNIC COLLEGE, KUTTIKKATOOR",
  "SACRED HEART HOSPITAL THRISSUR",
  "KOYILI HOSPITAL KANNUR",
  "ASSUMPTION SCHOOL OF NURSING WAYANAD",
  "STATE PUBLIC HEALTH AND CLINICAL LABORATORY THIRUVANANTHAPURAM",
  "INSTITUTE OF HUMAN RESOURCES DEVELOPMENT",
  "A J COLLEGE OF PARAMEDICAL SCIENCES, KAZHAKUTTAM",
  "R SANKAR MEMORIAL SCHOOL OF NURSING SANKAR SHASTHYABDAPOORTHI MEMORIAL HOSPITAL, KOLLAM",
  "MUTHOOT BUSINESS SCHOOL",
  "CRESCENT CHARITABLE SOCIETY MUSLIM EDUCATION TRUST, CHANDANATHOPE",
  "Badagara Educational Co-operative Society Ltd., Vadakara",
  "ASSUMPTION HOSPITAL PALAKKAD",
  "ASSISSI HOSPITAL KOTTAYAM",
  "KADUVAYIL THANGAL CHARITABLE TRUST, THIRUVANANTHAPURAM",
  "MILADE SHERIEF MEMORIAL TEACHERS TRAINING INSTITUT KOLLAM",
  "LITTLE FLOWER SCHOOL OF NURSING ERNAKULAM",
  "KMCT NATIONAL HOSPITAL INSTITUTE OF HEALTH SCIENCES",
  "ANSAR SCHOOL OF NURSING THRISSUR",
  "PUSHPAGEETH SCHOOL FOR TEACHER EDUCATION (T T I) THIRUVANANTHAPURAM",
  "MARTHOMA NURSERY TTI PATHANAMTHITTA",
  "MAR IVANIOS SCHOOL OF NURSING ,PERUMPUZHA,KUNDARA,KOLLAM",
  "ANM SCHOOL, SIVAGIRI SREENARAYANA MEDICAL MISSION HOSPITAL, VARKALA",
  "ANM SCHOOL, L M S BOYS BRIGADE HOSPITAL, KUNDARA",
  "JUBILEE MISSION COLLEGE OF ALLIED HEALTH SCIENCES",
  "ROSE DALE TEACHER TRAINING INSTITUTE THIRUVANANTHAPURAM",
  "MAR THEODOSIUS MEMORIAL MEDICAL MISSION KOLLAM",
  "KERALA MEDIA ACADEMY ",
  "ANM SCHOOL, I H M BHARANANGANAM, KOTTAYAM",
  "KODUVALLY MUSLIM ORPHANAGE TEACHER TRAINING INSTIT KOZHIKODE",
  "ICA-The Institute of Certified  Accountants",
  "SCHOOL OF NURSING KANJOOR ERNAKULAM",
  "VIDYA PRE PRIMARY TEACHERS TRAINING INSTITUTE, OLLUR",
  "MEITRA HOSPITAL, KOZHIKODE",
  "AES COLLEGE OF PHARMACY",
  "CALICUT ORPHANAGE TTI KOZHIKODE",
  "MAR OSTHATHEOS TEACHER TRAINING INSTITUTE THRISSUR",
  "THANBEEHUL ISLAM TEACHERS TRAINING CENTRE KASARAGOD",
  "R.M. TEACHER TRAINING INSTITUTE ERNAKULAM",
  "GOVERNMENT POLYTECHNIC COLLEGE NEDUMANGAD",
  "SRIVIDYADHIRAJA MODEL TEACHER TRAINING INSTITUTE KOLLAM",
  "KMCT INSTITUTE OF ALLIED HEALTH SCIENCES",
  "KMCT TEACHER TRAINING INSTITUTE KOZHIKODE",
  "SRI RAMAKRISHNA SARADA SCHOOL OF NURSING",
  "SREE GOKULAM SCHOOL OF NURSING",
  "KUSUMAGIRI MENTAL HEALTH CENTRE",
  "RESIDENTIAL WOMEN'S POLYTECHNIC COLLEGE PAYYANNUR",
  "SEETHI SAHIB MEMORIAL TEACHER TRAINING INSTITUTE KOLLAM",
  "COOPERATIVE TRAINING CENTRE NEDUMKANDAM",
  "R.B.M T T I KOLLAM",
  "SCHOOL OF NURSING ,AKG MEMORIAL CO-OPERATIVE HOSPITAL",
  "DAYA INSTITUTE OF PARAMEDICAL SCIENCES",
  "SCHOOL OF NURSING, DR. GOVINDANS HOSPITAL, CONVENT ROAD, THIRUVANANTHAPURAM",
  "RAMA VILASOM TEACHER TRAINING INSTITUTE KOLLAM",
  "KOTTUKAL DAMODARAN PILLAI MEMORIAL PARAMEDICAL INSTITUTE",
  "INDIRA GANDHI INSTITUTE OF PARAMEDICAL SCIENCES",
  "ST. JOSEPH'S HOSPITAL TRUST MANJUMMEL, ERNAKULAM",
  "THE DALE VIEW COLLEGE OF PARAMEDICAL SCIENCES",
  "SCHOOL OF NURSING KANNIAMPURAM OTTAPALAM PALAKKAD",
  "INSTITUTE OF MANAGEMENT IN GOVERNMENT",
  "CO  OPERATIVE TRAINING COLLEGE  THALASSERY",
  "KMCT POLYTECHNIC COLLEGE",
  "RAMAN MEMORIAL TEACHER TRAINING INSTITUTE MALAPURAM",
  "INSTITUTE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY KOVALAM",
  "SCHOOL OF NURSING DHANLAKSHMI HOSPITAL KANNUR",
  "SCHOOL OF NURSING IDUKKI",
  "RAJAGIRI BUSINESS SCHOOL",
  "INSTITUTE OF PRINTING TECHNOLOGY AND GOVERNMENT POLYTECHNIC COLLEGE",
  "NATIONAL SCHOOL OF NURISNG THIRUVANANTHAPURAM",
  "ANM SCHOOL, ASSISI HOSPITAL, CHANNAPETTAH",
  "ST JOSEPH'S HOSPITAL THRISSUR",
  "NATIONAL HOSPITAL SCHOOL OF NURSING KOZHIKODE",
  "BHARATH MATHA COLLEGE OF MEDICAL TECHNOLOGY,KURAVILANGADU,KOTTAYAM",
  "PIMS SCHOOL OF NURSING",
  "ST.JOHN SYRIAN TEACHER TRAINING INSTITUTE ERNAKULAM",
  "ST JAMES HOSPITAL THRISSUR",
  "AMS MANNADIAR MEMORIAL TEACHER TRG INSTITUTE PALAKKAD",
  "SHREE NARAYANA MEDICAL MISSION GENERAL ALAPPUZHA",
  "AMALA CANCER HOSPITAL AND RESEARCH CENTRE THRISSUR",
  "AL-AZHAR TEACHER TRAINING INSTITUTE IDUKKI",
  "ST. GEORGE TEACHER TRAINING INSTITUTE WAYNAD",
  "COOPERATIVE TRAINING CENTER, NAGAMPADOM,KOTTAYAM",
  "K Karunakaran Memorial Model Polytechnic College, Kallettumkara",
  "NIMS INSTITUTE OF PARAMEDICAL SCIENCE, ARALUMMOODU, NEYYATTINKARA",
  "NALANDA TTI NANNIYODE, THIRUVANANTHAPURAM",
  "NAIR SAMAJAM TTI MANNAR, ALAPPUZHA",
  "M.V. TEACHER TRAINING INSTITUTE THIRUVANANTHAPURAM",
  "MUNNAR CATERING COLLEGE",
  "KERALA GOVT. POLYTECHNIC COLLEGE KOZHIKODE",
  "KELTRON TOOLROOM RESEARCH & TRAINING CENTRE (KELTRAC)",
  "JUBILEE MISSION HOSPITAL THRISSUR",
  "JPE TTI, KOORKENCHERY",
  "JOSCO SCHOOL OF NURSING ALAPPUZHA",
  "JOHN MEMORIAL TEACHER TRAINING INSTITUTE KOLLAM",
  "JDT ISLAM POLYTECHNIC COLLEGE",
  "GUARDS TEACHER TRAINING INSTITUTE PALAKKAD",
  "GOVERNMENT POLYTECHNIC COLLEGE KASARGOD",
  "ST.TERESAS TEACHER TRAINING INSTITUTE KOTTAYAM",
  "GOVERNMENT POLYTECHNIC COLLEGE KANNUR",
  "MS TTI RANNI, PATHANAMTHITTA",
  "MOTHER CHANTAL SCHOOL OF NURSING ALAPUZHA",
  "ST.TERESAS ANGLO INDIAN TEACHER TRNG INSTITUTE KANNUR",
  "MODERN HOSPITAL KODUNGALLUR LTD THRISSUR",
  "ST RITA'S SCHOOL OF NURSING KOTTAYAM",
  "MODEL RESIDENTIAL POLYTECHNIC COLLEGE, KUZHALMANNAM, PALAKKAD",
  "MODEL POLYTECHNIC COLLEGE, VADAKARA",
  "MODEL POLYTECHNIC COLLEGE, POONJAR",
  "ARIES POLYTECHNIC COLLEGE",
  "MODEL POLYTECHNIC COLLEGE, PAINAVU",
  "NIRMALA HOSPITAL KOZHIKODE",
  "MODEL POLYTECHNIC COLLEGE, KARUNAGAPPALLY",
  "MEDICAL TRUST HOSPITAL ERNAKULAM",
  "M-DIT POLYTECHNIC COLLEGE",
  "M C T TEACHER TRAINING INSTITUTE MALAPURAM",
  "HOLY FAMILY SCHOOL OF NURSING IDUKKI",
  "BEERAN HAJI MEMORIAL TEACHER TRAINING INSTITUTE MALAPURAM",
  "MARY QUEEN'S HOSPITAL KOTTAYAM",
  "GOVERNMENT POLYTECHNIC COLLEGE KADUTHURUTHY",
  "MARY KATHERINE SCHOOL OF NURSING KOTTAYAM",
  "SCMS COCHIN SCHOOL OF BUSINESS",
  "MAHATHMAGANDHI COLLEGE OF HEALTH SCIENCES",
  "DUXFORD INTERNATIONAL BUSINESS SCHOOL    ",
  "HOLY GHOST MISSION HOSPITAL KOTTAYAM",
  "MARY IMMACULATE SCHOOL OF NURSING TRICHUR",
  "SWAMI VIVEKANANDA INSTITUTE OF PARAMEDICAL SCIENCE AND TECHNOLOGY",
  "ATLAS IDEAL INTERNATIONAL COLLEGE",
  "COOPERATIVE TRAINING COLLEGE, THRISSUR",
  "WELCARE INSTITUTE OF PARAMEDICAL SCIENCES",
  "KERALA STATE CENTRE FOR ADVANCED PRINTING AND TRAINING",
  "GOVERNMENT SPECIAL TEACHERS TRAINING CENTRE, PARAPPANANGADI",
  "DEVI VILASOM TEACHER TRAINING INSTITUTE KOLLAM",
  "CENTRAL INSTITUTE ON MENTAL RETARDATION",
  "CO OPERATIVE TRAINING COLLEGE, KOTTARAKKARA, KOLLAM",
  "STATE INSTITUTE OF HOSPITALITY MANAGEMENT",
  "PSM INSTITUTE OF PARAMEDICAL SCIENCES AND RESESRCH CENTRE,MARADU",
  "DEVA MATHA HOSPITAL ERNAKULAM",
  "DEENABANDHU SCHOOL OF NURSING PALAKKAD",
  "SABARIGIRI INSTITUTE OF ALLIED MEDICAL SCIENCES",
  "JDT ISLAM SCHOOL OF NURSING, VELLIMADUKUNNU, KOZHIKODE",
  "A M COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC COLLEGE NADUVIL",
  "DARUL ULOUM TEACHERS TRAINING INSTITUTE MALAPURAM",
  "IDEAL EDUCATIONAL INSTITUTE OF TEACHER TRAINING PALAKKAD",
  "DARUL HUDA T T I KOZHIKODE",
  "PADMANABHODAYAM TTI MEZHUVELI, PATHANAMTHITTA",
  "GOVERNMENT POLYTECHNIC COLLEGE EZHUKONE",
  "C.S.I. TEACHER TRAINING INSTITUTE CHEMBOOR THIRUVANANTHAPURAM",
  "I H M HOSPITAL KOTTAYAM",
  "C S I SCHOOL OF NURSING THIRUVANANTHAPURAM",
  "IRINJALAKUDA CO-OPERATIVE SCHOOL OF NURSING THRISSUR",
  "C S I SCHOOL OF NURSING KOLLAM",
  "CREDENCE SCHOOL OF NURSING, ULLOOR, THIRUVANANTHAPURAM",
  "KERALA STATE RURAL WOMENS ELECTRONICS INDUSTRIAL CO OPERATIVE FEDERATION LIMITED",
  "GOVT POLYTECHNIC COLLEGE MANJERI",
  "INDIRA GANDHI MEMORIAL TRUST",
  "ST.PETER'S TEACHER TRAINING INSTITUTE ERNAKULAM",
  "ABDUL SALAM TEACHER TRAINING INSTITUTE KOLLAM",
  "GOVERNMENT POLYTECHNIC COLLEGE NATTAKAM",
  "ST. MARY'S POLYTECHNIC COLLEGE",
  "GOVERNMENT POLYTECHNIC COLLEGE ATTINGAL",
  "ST.GEORGE'S TEACHER TRAINING INSTITUTE KOLLAM",
  "ST. GEORGES TEACHER TRAINING INSTITUTE ERNAKULAM",
  "GOVERNMENT POLYTECHNIC COLLEGE ADOOR",
  "INDIAN INSTITUTE OF HANDLOOM TECHNOLOGY KANNUR",
  "ST.ALBERT'S TEACHER TRAINING INSTITUTE ERNAKULAM",
  "GOVERNMENT ANM TRAINING CENTRE, THALAYOLAPARAMBU",
  "ST THOMAS MISSION HOSPITAL ALAPPUZHA",
  "SREE RAMA GOVERNMENT POLYTECHNIC COLLEGE THRIPRAYAR",
  "MODEL POLYTECHNIC COLLEGE",
  "GOVERNMENT ANM TRAINING CENTRE PERINGOTTUKURISSI, PLALAKKAD",
  "SREEN NARAYANA POLYTECHNIC COLLEGE KOTTIYAM",
  "BHARATH HINDI PRACHRA KENDRAM",
  "Indira Gandhi Polytechnic College",
  "COOPERATIVE TRAINING CENTRE, THRISSUR",
  "FAZFARI TEACHERS TRAINING INSTITUTE MALAPURAM",
  "SREE NARAYANA TEACHER TRAINING INSTITUTE THRISSUR",
  "SREE NARAYANA TEACHER TRAINING INSTITUTE PALAKKAD",
  "SREE NARAYANA TEACHER TRAINING INSTITUTE KOLLAM",
  "HEALTH AND FAMILY WELFARE TRAINING CENTRE",
  "SREE MAHADEVA TEACHER EDUCATION INSTITUTE KOTTAYAM",
  "SREE DHARMA PARIPALANA YOGAM SCHOOL OF TTC COCHIN",
  "S N V TTI KAKKAZHOM, ALAPPUZHA",
  "S.N. TEACHER TRAINING INSTITUTE THRISSUR",
  "S.N.S. SAMAJAM TEACHER TRAINING INSTITUTE THRISSUR",
  "FATIMA MATA MISSION HOSPITAL WAYANAD",
  "S.N.M TEACHER TRAINING INSTITUTE ERNAKULAM",
  "AL AZHAR COLLEGE OF PARAMEDICAL SCIENCES, PERUMPILLICHIRA P O, THODUPUZHA, IDUKKI",
  "SIVAGIRI SREE NARAYANA MEDICAL MISSION MALAYALAM",
  "SIDHEEQUIYA ISLAMIC CENTRE MALAPURAM",
  "S.H. PRE-PRIMARY TEACHER TRAINING INSTITUTE KOTTAYAM",
  "MODEL POLYTECHNIC COLLEGE, KALLIYASSERRY",
  "SEVAMANDIR TEACHER TRAINING INSTITUTE MALAPURAM",
  "SANKAR INSTITUTE OF PARAMEDICAL SCIENCES",
  "ST MARTIN DE-PORRES HOSPITAL KANNUR",
  "N I M S SCHOOL OF NURSING MALAPPURAM",
  "M K HAJI SCHOOL OF NURSING MALAPURAM",
  "M E S SCHOOL OF NURSING MALAPPURAM",
  "LEADERS COLLEGE",
  "ST JOSEPH TTI KARUKUTTY, ERNAKULAM",
  "TRAVANCORE SCHOOL OF ALLIED HEALTH SCIENCES",
  "MANJAPPARA EDUCATIONAL AND CHARITABLE TRUST KOLLAM",
  "C.H.MEMORIAL TEACHER TRAINING INSTITUTE KOLLAM",
  "PRAYAGA INSTITUTE OF MANAGEMENT STUDIES",
  "ABDUL WAHAB MEMORIAL RAJAH SCHOOL OF NURSING THRISSUR",
  "ST. JOSEPH TEACHER TRAINING INSTITUTE MUTHOLY KOTTAYAM",
  "MEPPAYUR SALAFI TEACHER TRAINING INSTITUTE KOZHIKODE",
  "SEETHI SAHIB MEMORIAL POLYTECHNIC COLLEGE",
  "ST.VINCENT COLONY TEACHER TRAINING INSTITUTE KOZHIKODE",
  "SHA SHIB AVIATION ACADEMY",
  "FATHIMA  COLLEGE OF PHARMACY",
  "MAR BASELIOS TEACHER TRAINING INSTITUTE WAYNAD",
  "MAR AUGUSTINE JUBILEE MISSION HOSPITAL ERNAKULAM",
  "FATHIMA MEMORIAL TEACHER TRAINING INSTITUTE KOLLAM",
  "INSTITUTE OF COOPERATIVE MANAGEMENT",
  "ABRAHAM MALPAN MEMORIAL TEACHER TRG INSTITUTE PATHANAMTHITTA",
  "NGPM TEACHER TRAINING INSTITUTE KOLLAM",
  "PATTOM THANUPILLAI MEMORIAL TEACHERS TRAINING INST THIRUVANANTHAPURAM",
  "P V S SCHOOL OF NURSING KOZHIKODE",
  "ST.JOSEPH TEACHER TRAINING INSTITUTE ERNAKULAM",
  "CO OPERATIVE TRAINING CENTRE,THIRUVANANTHAPURAM",
  "ST.JOSEPHS TEACHER TRAINING INSTITUTE THRISSUR",
  "GOVERNMENT POLYTECHNIC COLLEGEMANANTHAVADY",
  "GOVERNMENT POLYTECHNIC COLLEGE THIRURANGADI",
  "ST JOSEPH HOSPITAL, ERNAKULAM",
  "TRAINING INSTITUTE OF MULTI REHABILITATION TECHNOLOGY ",
  "PRINCE MARTHANDA VARMA TEACHER TRG INSTITUTE PATHANAMTHITTA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING THRISSUR",
  "J.T.I. TEACHER TRAINING INSTITUTE MALAPURAM",
  "NIRMALA MEDICAL CENTRE ERNAKULUM",
  "A J SCHOOLOF NURSING TRIVANDRUM",
  "Indira Gandhi Polytechnic College, Nellikuzhi",
  "PRANAVAM SCHOOL OF NURSING KOLLAM",
  "A K G MEMORIAL CO- OPERATIVE HOSPITAL KANNUR",
  "NATIONAL INSTITUTE FOR RUBBER TRAINING",
  "ST.TRESA S TEACHER TRAINING INSTITUTE KOLLAM",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING WAYNAD",
  "MELMURI MUSLIM EDUCATIONAL INSTITUTE MALAPURAM",
  "The Institute for Cost and Management Studies",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING THODUPUZHA IDUKKI",
  "P.G.M TEACHER TRAINING INSTITUTE PATHANAMTHITTA",
  "SREE GOKULAM SNGM COLLEGE OF PHARMACY",
  "RSMH TEACHER TRAINING INSTITUTE",
  "DR. NAIRS HOSPITAL KOLLAM",
  "PTM INSTITUTE OF PARAMEDICAL SCIENCE",
  "G G SCHOOL OF NURSING",
  "ST JOSEPHS TTI PAVARATTY, TRICHUR",
  "Bharadwaj Institute Educational Charitable Trust",
  "PERINGATHUR TEACHERS TRAINING INSTITUTE KANNUR",
  "SCHOOL OF NURSING, ST JOSEPH HOSPITAL KOLLAM",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING THIRUVANANTHAPURAM",
  "PARABRAHMA SPECIALITY HOSPITAL & RESEARCH CENTRE KOLLAM",
  "BAKER MEMORIAL PRE-PRIMARY TEACHERS TRAINING INSTITUTE (BMPPTTI)",
  "VISWADARSHINI TEACHER TRAINING INSTITUTE THIRUVANANTHAPURAM",
  "COOPERATIVE TRAINING CENTER KOTTARAKKARA",
  "COMTRUST ACADEMY FOR RESEARCH AND TRAINING",
  "OUR LADYS TEACHER TRAINING INSTITUTE ERNAKULAM",
  "Mariyumma Memorial Institute of Teacher Education",
  "C.N.I TEACHER TRAINING INSTITUTE KOTTAYAM",
  "SREEANJANEYA SCHOOL OF NURSING",
  "SREE NARAYANA TEACHER TRAINING INSTITUTE KASARAGOD",
  "GOVERNMENT POLYTECHNIC COLLEGE PALAKKD",
  "INDIRA GANDHI TEACHERS TRAINING INSTITUTE ERNAKULAM",
  "Orphanage Polytechnic College",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING PATHANAMTHITTA PATHANAMTHITTA",
  "KIMS INSTITUTE OF PARAMEDICAL SCIENCES, THIRUVANANTHAPURAM",
  "MAYYIL TEACHER TRAINING INSTITUTE KANNUR",
  "NSS TTI KAVIYOOR THIRIVALLA, PATHANAMTHITTA",
  "SAMARITAN INSTITUTE OF PARAMEDICAL SCIENCES",
  "E M S MEMORIAL COOPERATIVE HOSPITAL MALAPPURAM",
  "JAI BHARATH INSTITUTE OF MEDICAL SCIENCES",
  "PUBLIC HEALTH TRAINING CENTRE",
  "TEACHER TRAINING INSTITUTE THE MALNADU EDUCATIONAL KANNUR",
  "SEVANA  SCHOOL OF NURSING",
  "ST THOMAS TTI THIRUVALLA, PATHANAMTHITTA",
  "C.K.RAGHAVAN MEMORIAL TEACHER TRAINING INSTITUTE WAYNAD",
  "GOVERNMENT TEACHER TRAINING INSTITUTE  KANNIVAYAL, KASARGODE",
  "NSS TTI CHERUKOLE PO VAZHAKUNNAM, PATHANAMTHITTA",
  "MGM SILVER JUBILEE COLLEGE OF POLYTECHNIC AND PHARMACEUTICAL SCIENCES",
  "A J COLLEGE OF PHARMACY",
  "ST.JOSEPH'S TEACHER TRAINING INSTITUTE WAYNAD",
  "NSS TEACHER TRAINING INSTITUTE THADIYOOR P.O. THIRUVALLA PATHANAMTHITTA PATHANAMTHITTA",
  "COOPERATIVE TRAINING COLLEGE, PALAKKAD, OPPOSITE PMG HIGH SCHOOL, PALAKKAD MUNCIPALITY",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING PALAKKAD",
  "CENTRE FOR HERITAGE STUDIES",
  "NSS TEACHER TRAINING INSTITUTE OTHERA P.O. THIRUVALLA PATHANAMTHITTA PATHANAMTHITTA",
  "GOVERNMENT POLYTECHNIC COLLEGE PALA",
  "GOVERNMENT POLYTECHNIC COLLEGE NEYYATTINKARA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING MALAPPURAM",
  "FOOD CRAFT INSTITUTE, TIRUR",
  "APRM TEACHER TRAINING INSTITUTE KOLLAM",
  "XAVIER INSTITUTE OF MANAGEMENT AND ENTREPRENEURSHIP",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KOZHIKODE",
  "WOMENS POLYTECHNIC COLLEGE KOZHIKODE",
  "KET COLLEGE OF PARAMEDICAL SCIENCE",
  "WOMEN'S POLYTECHNIC COLLEGE KOTTAKKAL",
  "CHRISTU RAJ SCHOOL OF NURSING KANNUR",
  "WOMEN'S POLYTECHNIC COLLEGE KAYAMKULAM",
  "COOPERATIVE TRAINING CENTRE   MUNNAD",
  "WOMEN'S POLYTECHNIC COLLEGE KAIMANAM",
  "SARASWATHY INSTITUTE OF ALLIED HEALTH SCIENCES",
  "K R NARAYANAN NATIONAL INSTITUTE OF VISUAL SCIENCE AND ARTS",
  "TTKM TEACHER TRAINING INSTITUTE MALAPURAM",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KOTTAYAM",
  "WOMEN'S POLYTECHNIC COLLEGE",
  "ST JOHNS COLLEGE OF PARAMEDICAL SCIENCES,KATTAPPANA ,IDUKKI",
  "WOMEN POLYTECHNIC COLLEGE, ERNAKULAM",
  "VKPMNSS TTI EDAMATTAM, KOTTAYAM",
  "VINAYAKA HOSPITAL SCHOOL OF NURSING WAYANAD",
  "CO OPERATIVE TRAINING CENTRE KANNUR",
  "VIJAYMATHA SCHOOL OF NURSING THRISSUR",
  "COCHIN PORT TRUST HOSPITAL ERNAKULAM",
  "VALUMMEL TEACHER TRAINING INSTITUTE WAYNAD",
  "UPASANA SCHOOL OF NURSING, KOLLAM",
  "UNITY TTI MATTANNUR NAGAVAVU, KANNUR",
  "TEACHER TRAINING INSTITUTE PALAKKAD",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KOLLAM",
  "TEACHER TRAINING INSTITUTE MAVELIKARA ALAPPUZHA",
  "SWAMY NITHYANANDA POLYTECHNIC COLLEGE KANHANGAD",
  "S U T SCHOOL OF NURSING THIRUVANANTHAPURAM",
  "N S S MEDICAL MISSION HOSPITAL PATHANAMTHITTA",
  "EVANS TTI PARASSALA, THIRUVANANTHAPURAM",
  "JOSCO MULTI SPECIALITY HOSPITAL",
  "EZHUTHACHAN NATIONAL ACADEMI TTI THIRUVANANTHAPURAM",
  " KARUNYA HEALTH INSPECTOR TRAINING INSTITUTE",
  "SREE NARAYANA PRE-PRIMARY TTI ALAPUZHA",
  "GOVERMENT SPECIAL TEACHERS TRAINING CENTRE KASARAGOD",
  "ST JOSEPHS COLLEGE OF PHARMACY MUTTOM",
  "GOVERNMENT POLYTECHNIC COLLEGE MUTTOM",
  "AKM POLYTECHNIC COLLEGE",
  "N.S.S. POLYTECHNIC COLLEGE PANDALAM",
  "COOPERATIVE TRAINING COLLEGE CHERTHALA",
  "SHREE VIDYADHIRAJA PHARMACY COLLEGE",
  "COOPERATIVE TRAINING CENTER, KOZHIKODE",
  "GOVERNMENT POLYTECHNIC COLLEGE MEPPADI",
  "AWH INSTITUTE FOR PARAMEDICAL COURSES ",
  "EZHUTHACHAN SMARAKA PPTTI ERNAKULAM",
  "ST THOMAS TTI PALA, KOTTAYAM",
  "CO OPERATIVE TRAINING CENTRE, CHERTHALA",
  "ST THOMAS COLLEGE OF TEACHER EDUCATION TTI, PALA KOTTAYAM",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KASARAGOD",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KANNUR",
  "ST JAMES INSTITUTE OF ALLIED HEALTH SCIENCES",
  "PMA SAFI HUMAN RESOURCES INSTITUTE",
  "GOVERNMENT POLYTECHNIC COLLEGE MEENANGADI",
  "CO OPERATIVE  TRAINING COLLEGE , KURAVANKONAM , THIRUVANANTHAPURAM",
  "GOVERNMENT POLYTECHNIC COLLEGE MATTANNUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING ERNAKULAM",
  "CHRIST KING CONVENT TEACHER TRAINING INSTITUTE THRISSUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING ALAPPUZHA",
  "ARADHANA EYE INSTITUTE",
  "D.H.M TEACHER TRAINING INSTITUTE KOZHIKODE",
  "NATIONAL POWER TRAINING INSTITUTE, ALAPPUZHA",
  "ANANTHAPURI INSTITUTE OF PARAMEDICAL SCIENCES",
  "INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "GOVERNMENT POLYTECHNIC KARGIL",
  "SANJEEVNI INSTITUTE OF NURSING AND PARA MEDICAL SCIENCES KARGIL",
  "AMT SCHOOL SNM HOSPITAL LEH    ",
  "KASHSOFT COMPUTERS KARGIL",
  "Govt polytechnic leh",
  "DIGITAL COMPUTER CENTRE KARGIL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KARGIL",
  "GOVERNMENT GNM SCHOOL KARGIL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, LEH",
  "VENUS PUBLIC EDUCATION SOCIETY, BAHODAPUR, GWALIOR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING VIDISHA",
  "NATIONAL INSTITUTE OF MENTAL HEALTH REHABILITATION",
  "SYNERGY INSTITUTE OF MANAGEMENT",
  "INTERNATIONAL SCHOOL OF BUSINESS ADMINISTRATION",
  "RADHA KRISHNA COLLEGE",
  "AMBITION COLLEGE OF EDUCATION",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING JABALPUR",
  "LSA COLLEGE DHAR",
  "ABVM Group Of College",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING GWALIOR",
  "SKS INSTITUTE OF BUSINESS STUDIES",
  "MEERA DEVI PARAMEDICAL INSTITUTE",
  "VITAL PARAMEDICAL COLLEGE",
  "BHARTI VIDYA MANDIR COLLEGE OF NURSING",
  "SAPPHIRE INSTITUTE OF NURSING AND SCIENCE",
  "MAA PADMAWATI INSTITUTE OF NURSING",
  "LAXMAN SETH COLLEGE OF NURSING",
  "VEENA VADINI COLLEGE OF MANAGEMENT",
  "GOVT.POLYTECHNIC COLLEGE KHURAI",
  "GOVT.POLYTECHNIC COLLEGE KHIRSADOH",
  "GOVT.POLYTECHNIC COLLEGE KHARGONE",
  "GOVT.POLYTECHNIC COLLEGE KATNI",
  "NEW ERA INSTITUTE FOR DIPLOMA IN EDUCATION",
  "INDORE INTERNATIONAL COLLEGE",
  "GYANKUNJ INTERNATIONAL",
  "SCHOLARS PUBLIC SCHOOL",
  "A S School of Nursing, Mandu Road,  Dhar",
  "BARWANI INSTITUTE OF NURSING",
  "GOVT.POLYTECHNIC COLLEGE HARDA",
  "GOVT.POLYTECHNIC COLLEGE DINDORI",
  "GOVT.POLYTECHNIC COLLEGE DEWAS",
  "GOVT.POLYTECHNIC COLLEGE DATIA",
  "GOVT.POLYTECHNIC COLLEGE DABRA",
  "GOVT.POLYTECHNIC COLLEGE CHHINDWARA",
  "GOVT.POLYTECHNIC COLLEGE BETUL",
  "GOVT.POLYTECHNIC COLLEGE BALAGHAT",
  "GOVT.POLYTECHNIC COLLEGE BADWANI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SHAJAPUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SEONI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SEHORE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SAGER SAGAR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING RAISEN",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BHIND",
  "PARAKH COLLEGE BHOPAL",
  "GIRNAR BUSINESS SCHOOL",
  "SARDAR PATEL SCHOOL OF EDUCATION",
  "ANSH COLLEGE OF MANAGEMENT",
  "MANGAL MAHAVIDYALAYA,AMILHEDA,PORSA,MORENA",
  "AAYUSHMAN SCHOOL OF NURSING JHABUA",
  "J B INSTITUTE OF NURSING & RESEARCH GWALIOR",
  "PRIYADARSHINI MAHAVIDYALAYA INDORE",
  "K. K. VYAVSIK ADHAYAYAN MAHAVIDHYALAYA",
  "ANANT INSTITUTE OF NURSING",
  "GOVT. DISTRICT INSTITUTE OF EDUCATION AND TRAINING KHARGONE",
  "IIPS, PANIHAR, GHATIGAON, GWALIOR",
  "SHREE BALAJI INSTITUTE OF PROFESSIONAL STUDIES",
  "MA NARMADA COLLEGE OF NURSING DHAR",
  "BHOPAL COLLEGE OF NURSING",
  "MARUTI INSTITUTE OF NURSING SEONI",
  "INDORE WOMEN'S POLYTECHNIC COLLEGE",
  "ASPIRE PGDM INSTITUTE",
  "ANGIRA COLLEGE OF EDUCATION NIWARI",
  "SHARDA DEVI CHATURVEDI EDUCATION INSTITUTE, BHIND",
  "S R COLLEGE",
  "GURUKUL ACADEMY",
  "ASPIRE INSTITUTE",
  "INTERNATIONAL SCHOOL OF BUSINESS ADMINISTRATION SANWER",
  "VIR TATYA TOPE PARAMEDICAL COLLEGE",
  "SHRI BAGULAMUKHI INSTITUTE OF MANAGEMENT",
  "narmada institute of nursing medical science",
  "GURUDEV COLLEGE",
  "MAA GIRJA DEVI TRAINING COLLEGE",
  "PRESTIGE INSTITUTE OF BUSINESS MANAGEMENT",
  "MAA GIRJA DEVI TRAINING COLLEGE BHIND",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KATNI    ",
  "MAA GIRJA DEVI TRAINING COLLEGE JAMNA",
  "SAMARTHYA NURSING INSTITUTE",
  "CHANDRASHEKHAR COLLEGE OF NURSING",
  "ICMR NATIONAL INSTITUTE FOR RESEARCH IN ENVIRONMENTAL HEALTH",
  "ICMR-NATIONAL INSTITUTE OF RESEARCH IN TRIBAL HEALTH",
  "Gyanodaya Institute of Nursing",
  "Gyanodaya Institute of Professional Studies",
  "GYANODAYA THE COLLEGE OF EXCELLENCE",
  "HAMIDIA HOSPITAL BHOPAL",
  "SAPPHIRE INSTITUTE OF MANAGEMENT",
  "S N KRISHNA NURSING COLLEGE",
  "INDORE MANAGEMENT INSTITUTE AND RESEARCH CENTRE",
  "INDRAPRASHTH INSTITUTE OF TECHNOLOGY AND MANAGEMENT GWALIOR",
  "INDRAPRASTH NURSING COLLEGE GWALIOR",
  "Government Polytechnic College, Rajgarh",
  "INSTITUTE OF NURSING SCIENCE STUDIES AND RESEARCH GWALIOR",
  "SHRI GAJANAN SHIKSHA SAMITI COLLEGE KIWLARI SOHAGPUR",
  "PATEL INSTITUTE OF MANAGEMENT STUDIES BHOPAL",
  "JABALPUR INSTITUTE OF HEALTH SCIENCES JABALPUR",
  "JAI INSTITUTE OF NURSING & RESEARCH GWALIOR",
  "JAIPURIA INSTITUTE OF MANAGEMENT INDORE",
  "JAYPEE POLYTECHNIC AND TRAINING CENTRE REWA",
  "J.B. INSTITUTE OF TEACHER EDUCATION GWALIOR",
  "JIJA MATA GOVT POLYTECHNIC COLLEGE BURHANPUR",
  "SYNERGY INSTITUTE OF MANAGEMENT MAHESHWAR",
  "NAVRATAN COLLEGE OF MANAGEMENT",
  "Karnimata Institute of Nursing",
  "SHRI ARJUN SINGH SHIKSHA MAHAVIDHYALAY CHOKWAN PURA THARA AMBAH",
  "S R COLLEGE OF SCIENCE AND TECHNOLOGY CHAKARPUR DISTRICT NIWARI MP",
  "SAPPHIRE INSTITUTE OF BUSINESS MANAGEMENT INDORE",
  "K S NURSING COLLEGE GWALIOR",
  "PARMHANS NURSING INSTITUTE OF EDUCATIONAL NARSINGHPUR",
  "NAVAMBEY COLLEGE OF EDUCATION",
  "LAL BAHADUR SHASTRI VYAVSAYIK ADHYAPAN MAHAVIDYALY HARDA",
  "LAL BAHADUR SHASTRI VYAVSAYIK ADHYAYAN MAHAVIDYALAYA, HARDA",
  "D S MEMORIAL COLLEGE OF EDUCATION",
  "PARAMHANS MAHAVIDHYALAYA NARSINGHPUR",
  "CHOUDHARY RUSTAM SINGH NURSING COLLEGE BHIND",
  "AADINATH ACADEMY",
  "N R INSTITUTE D ED COLLEGE MANDVI",
  "MALWA COLLEGE OF EDUCATION BINAGANJ CHACHODA, GUNA",
  "MAYA DEVI INSTITUTE OF ADVANCED EDUCATION",
  "MALWA SCHOOL OF NURSING",
  "MARUTI INSTITUTE OF NURSING ,BETUL",
  "GNS NURSING COLLEGE, GWALIOR",
  "MARUTI INSTITUTE OF NURSING ,HOSHANGABAD",
  "BALAJI SCHOOL OF NURSING",
  "SUNRISE COLLEGE OF EDUCATION",
  "MARUTI INSTITUTE OF NURSING, SEONI",
  "PRESTIGE INSTITUTE OF GLOBAL MANAGEMENT",
  "S R COLLEGE OF EDUCATION HAMA CHHATARPUR",
  "Maulaa Azad D.Ed. College, Burahanpur",
  "M.J.P. POLYTECHNIC COLLEGE KHANDWA",
  "M P S COLLEGE OF NURSING & RESEARCH GWALIOR",
  "M.P.S. SHIKSHA MAHAVIDYALAYA GWALIOR",
  "MOTHER TERESA SCHOOL OF NURSING, HOSHANGABAD, BLOCK KESLA",
  "GOVT.POLYTECHNIC COLLEGE BHIND",
  "S K COLLEGE OF EDUCATION HARPALPUR DISTT CHHATARPUR",
  "NAVAL KISHORE SHIVHARE NURSING SCHOOL BHIND",
  "govt. polytechnic college sironj",
  "NISHAD COLLEGE OF NURSING & ALLIED SCIENCES SATNA",
  "S.S.N. M.I.M.T. COLLEGE, NARSINGHPUR",
  "IITS COLLEGE SCHOOL OF NURSING GUNA",
  "N S MEMORIAL SCHOOL OF NURSING DATIA",
  "OJASWINI INSTITUTE OF NURSING SCIENCES & RESEARCH DAMOH",
  "OJASWINI NURSING SCHOOL SAGAR",
  "ARYANSH SCHOOL OF NURSING",
  "OMKAR COLLEGE OF PROFESSIONAL STUDIES, GUNA",
  "VANDE MAATRAM SCHOOL OF NURSING GWALIOR",
  "VARDHMAN SHIKSHA MAHAVIDYALAYA KATNI",
  "VEENA VADINI SHIKSHAK PRASHIKSHAN GWALIOR",
  "ARSHI SCHOOL OF NURSING",
  "Vijayaraje College Of Education Gwalior",
  "XAVIER INSTITUTION OF DEVELOPMENT ACTION AND STUDIES -XIDAS",
  "YOGMANI INSTITUTE OF NURSING JABALPUR",
  "YUVA VYAVASAIK SHIKSHAN SANSTHAN GUNA",
  "SAI NATH COLLEGE OF MANAGEMENT",
  "The Madhya Pradesh Flying Club Ltd",
  "MAN COLLEGE OF SPECIAL EDUCATION AND PSYCHOLOGICAL STUDIES GUNA",
  "BRIGHT COLLEGE OF EDUCATION",
  "YUVA VYAVSAIK SHIKSHA MAHAVIDYALAYA ASHOKNAGAR",
  "ZAKIR HUSSAIN TEACHER TRAINING INSTITUTE KHANDWA",
  "RAMADHAR SINGH SHIKSHA MAHAVIDHYALAYA NAYAGAON BHIND",
  "GOVT DISTRICT INSTITUTE OF EDUCATION AND TRAINING ALIRAJPUR",
  "GYANODAYA THE COLLEGE OF EXCELLENCE (POLYTECHNIC)",
  "C P S DED COLLEGE  BADAGAON AMBAH MORENA",
  "LITTLE STEP COLLEGE OF EDUCATION",
  "OXFORD COLLEGE OF MANAGEMENT",
  "IMI Business School",
  "DIET NEEMUCH",
  "SHRI DHEER SINGH D.ED COLLEGE GORMI BHIND (M.P.)",
  "SARDAR PATEL SCHOOL OF NURSING",
  "Sharada Arunoday Kalyankari Shiksha Samiti",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SIDHI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING TIKAMGARH",
  "Vikramaditya College",
  "VIKRAMADITYA INSTITUTE OF MEDICAL SCIENCES",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING UJJAIN",
  "DR.B.R.AMBEDKAR POLYTECHNIC COLLEGE GWALIOR",
  "INDIRA GANDHI COLLEGE OF NURSING",
  "GOVT.POLYTECHNIC COLLEGE ALIRAJPUR",
  "GOVT.POLYTECHNIC COLLEGE ANUPPUR",
  "Gurukul College of Education",
  "AADARSH PARAMEDICAL SANSTHAN",
  "Charak Institute of Nursing College Gwalior",
  "RADHARAMAN SPECIAL EDUCATION",
  "MALWA INSTITUTE OF MANAGEMENT",
  "BHAVINI COLLEGE",
  "EVERGREEN EDUCATION SOCIETY COLLEGE KIWLARI SOHAGPUR",
  "SHYAMA DEVI COLLEGE OF EDUCATION, MAIN ROAD MEHGAWN, RAISEN",
  "Government Polytechnic College, Jatara",
  "SRI KANVERTARA INSTITUTE FOR TEACHERS TRAINING KHARGAON",
  "Anant Institute of Business Studies",
  "SAANVI INSTITUTE OF NURSING AND RESEARCH GWALIOR",
  "LAXMAN SETH POLYTECHNIC COLLEGE DINARA SHIVPURI",
  "BAFNA COLLEGE",
  "PHOENIX COLLEGE",
  "GOVT. POLYTECHNIC COLLEGE MORENA",
  "ARIHANT INSTITUTE OF PROFESSIONAL STUDIES",
  "SAI SCHOOL OF NURSING",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING REWA",
  "TEERTHANKAR MAHAVEER SHIKSHA MAHAVIDYALAYA",
  "ADARSH COLLEGE OF MANAGEMENT BHOPAL",
  "MARUTINANDAN PARAMEDICAL INSTITUTE OF SCIENCE",
  "LAXMAN SETH PARAMEDICAL COLLEGE  DINARA SHIVPURI",
  "GYANSAGAR ACADEMY COLLEGE",
  "DIET DEWAS",
  "GENIUS COLLEGE OF EDUCATION BADFARA AMBAH MORENA MP",
  "GOVT.POLYTECHNIC COLLEGE SHIVPURI",
  "INTERNATIONAL SCHOOL OF BUSINESS ADMINISTRATION",
  "ISBA COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BETUL",
  "POLYTECHNIC COLLEGE DAMOH",
  "SHRI RAM RAJA SARKAR INSTITUTE OF EDUCATION",
  "Government Polytechnic College Sheopur",
  "MAA KRISHNA NURSING SCHOOL",
  "DIET BARWANI",
  "SAI ACADEMY",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING AND TECHNOLOGY",
  "SWATANTRA SAINANI INSTITUTE OF BUSINESS MANAGEMENT",
  "Scholars Academy",
  "INSTITUTE OF ALLIED SCIENCE AND COMPUTER APPLICATIONS GWALIOR",
  "Yash College of Professional Studies, Badnawar",
  "INDIAN INSTITUTE OF TOURISM AND TRAVEL MANAGEMENT",
  "GULAB BAI YADAV D.ED. SHIKSHAN SANSTHAN KHARGAON",
  "SAMRIDDHI COLLEGE OF NURSING DHAR",
  "SHRIKRISHNA SHIKSHA MAHAVIDHALAYA, CHAKARPUR DISTICT NIWARI MADHYA PRADESH",
  "MAULANA AZAD D.El.Ed. COLLEGE, GULARKHEDI,GULABGANJ VIDISHA",
  "R K School of Nursing Gwalior",
  "swargiya shrilal saxena smrti mahavidyalaya",
  "ROYAL INSTITUTE OF MANAGEMENT AND ADVANCED STUDIES",
  "GOVT.POLYTECHNIC COLLEGE REWA",
  "S V COLLEGE OF EDUCATION",
  "Sapient Institute of Management Studies",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING RAIGARH",
  "DELHI COLLEGE",
  "SDVM COLLEGE OF NURSING AND RESEARCH INSTITUTE",
  "VIR TATYA TOPE GNM SCHOOL",
  "GRANTHAMM COLLEGE OF MANAGEMENT",
  "DC BUSINESS SCHOOL",
  "SHRI SWAMIJI MAHARAJ COLLEGE OF NURSING DATIA",
  "DEVKINANDAN COLLEGE OF MANAGEMENT",
  "STATE INSTITUTE OF HOTEL MANAGEMENT INDORE",
  "VIDYA DEVI COLLEGE OF MANAGEMENT",
  "NRI SCHOOL OF MANAGEMENT STUDIES",
  "Aayushman college of nursing, Ranapur",
  "INDORE MAHAVIDYALAYA INDORE",
  "SHRI KHERAPATI SARKAR COLLEGE OF MANAGEMENT",
  "SHRI VASUDEV BASIC TEACHER TRAINING INSTITUTE MORENA",
  "GOVT.POLYTECHNIC COLLEGE SIDHI",
  "DR GYAN PRAKASH EDUCATIONAL RESERCH CENTRE CHHATTARPUR",
  "KARTIKAY INSTITUTE OF REHABILITATION AND TRAINING CENTRE    ",
  "MEERA MAHAVIDHYALAYA UJJAIN",
  "VISHVABHARTI INSTITUTE OF EDUCATION, UJJAIN",
  "BHARAT INSTITUTE OF NURSING, DINDORI",
  "VIKRANT INSTITUTE OF BUSINESS MANAGEMENT",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING RATLAM",
  "GYAN VIHAR COLLEGE OF NURSING",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SATNA",
  "PITAMBARA COLLEGE OF MANAGEMENT",
  "EMPIRE COLLEGE",
  "VIKAS EDUCATION AND ENVIRONMENT ACADEMY",
  "BHARAT INSTITUTE OF NURSING BALAGHAT",
  "FOOD CRAFT INSTITUTE KHAJURAHO",
  "SONALI SCHOOL OF NURSING",
  "KAMAD GIRI SHIKSHA AVAM SAMAJIK SANSTHAN'S D.EL.ED COLLEGE, GWALIOR",
  "SOPHIA NURSING SCHOOL GWALIOR",
  "DAU SARDAR SINGH NURSING INSTITUTE",
  "MULTAPI MAHAVIDHYLAYA PARMANDAL MULTAI",
  "GOVT.POLYTECHNIC COLLEGE TIKAMGARH",
  "GOVT.POLYTECHNIC COLLEGE WAIDHAN",
  "GOVT. WOMENS POLYTECHNIC COLLEGE BHOPAL",
  "S.V.POLYTECHNIC COLLEGE BHOPAL",
  "TAM BRAN SCHOOL OF NURSING GWALIOR",
  "GOVT. WOMENS POLYTECHNIC COLLEGE GWALIOR",
  "AMBIKA COLLEGE OF MANAGEMENT",
  "LAL BAHADUR SHASTRI INSTITUTE OF MANAGEMENT INDORE",
  "MY INSTITUTE OF MANAGEMENT",
  "EXCEL BUSINESS SCHOOL INDORE",
  "RAMSHANTI COLLEGE OF HIGHER EDUCATION PANDHURNA",
  "STATE INSTITUTE OF HOTEL MANAGEMENT, JABALPUR",
  "PATEL INSTITUTE OF MANAGEMENT STUDIES",
  "T D INSTITUTE OF PROFESSIONAL STUDIES REWA",
  "SHRI RAWATPURA SARKAR INSTITUTE OF PROFESSIONAL STUDIES",
  "VIDHYAPEETH INSTITUTE OF NURSING",
  "P S SCHOOL OF NURSING, GWALIOR",
  "D.S. SCHOOL OF NURSING, GWALIOR",
  "KALAWATI SMRITI MAHAVIDYALAYA, SEHORE",
  "RAMNATH SINGH INSTITUTE OF TECHNOLOGY AND SCIENCE",
  "SAI SAMRTH SCHOOL OF NURSING",
  "SUNRISE SCHOOL OF NURSING, SHIVPURI",
  "FLORANCE COLLEGE OF NURSING",
  "SARDAR PATEL SCHOOL OF NURSING",
  "GOVT.POLYTECHNIC COLLEGE RAGHOGARH",
  "SHANTI COLLEGE OF NURSING, CHHATARPUR",
  "SHRI DHANWANTARI SCHOOL OF NURSING, BETUL",
  "VEENA VADINI COLLEGE OF NURSING GWALIOR",
  "T M S SCHOOL OF NURSING SHEOPUR",
  "SIYA RAM COLLEGE OF NURSING GWALIOR",
  "SAI NATH COLLEGE GWALIOR",
  "G.T.POLYTECHNIC COLLEGE JAORA",
  "MAHESHWARI COLLEGE OF NURSING",
  "PANCHSHEEL INSTITUTE OF NURSING SHAHDOL",
  "LORD BUDDHA SCHOOL OF NURSING, REWA",
  "THE SINGROULI INSTITUTE OF NURSING WAIDHAN, DIST SINGROULI",
  "MADHAV PARAMEDICAL COLLEGE PANNA",
  "OMKAR SCHOOL OF NURSING, ARON, DISTT-GUNA",
  "M K PERAMEDICAL INSTITUTE OF SCIENCE",
  "PANDIT DEENDAYAL MAHAVIDYALAYA BHIND",
  "ATHARV INSTITUTE OF NURSING SCIENCE JOBAT",
  "PARIJAT VIDYANIKETAN SAMITI INDORE",
  "SHAKUNTALA DEVI D ED COLLEGE",
  "PATIRAM SHIVHARE MAHAVIDYALAYA BHIND",
  "Government Polytechnic College Agar",
  "UJJAIN POLYTECHNIC COLLEGE UJJAIN",
  "PATIRAM SHIVHARE NURSING SCHOOL BHIND",
  "VIVEKANAND EDUCATION SOCIETY",
  "RBS SCHOOL OF NURSING",
  "RAJA BHOJ COLLEGE OF NURSING JAMTHI BETUL",
  "RAJEEV GANDHI COLLEGE OF PHARMACY (POLY)",
  "JPB COLLEGE",
  "R D MEMORIAL SCHOOL OF NURSING BHOPAL",
  "REGIONAL NURSING SCHOOL JABALPUR",
  "REWA POLYTECHNIC (PHARMACY) REWA",
  "R L SCHOOL OF NURSING MORENA",
  "RAMKRISHNA SCHOOL OF NURSING GWALIOR",
  "INSIGHT INSTITUTE OF EDUCATION",
  "PATIDAR NURSING INSTITUTE",
  "R.N.S. INSTT. OF PHARMACY GWALIOR",
  "FOOD CRAFT INSTITUTE REWA",
  "RAVI SHANKAR GLOBAL EDUCATION COLLEGE",
  "SADGURU SCHOOL OF NSG SATNA",
  "ISABEL MC CONNEL SCHOOL OF NURSING, ALIRAJPUR",
  "AAYAM SCHOOL OF NURSING NARSINGHPUR",
  "AUXILIARY NURSE AND MIDWIFE HEALTH WORKERS SCHOOL",
  "Bhagwan Singh Socila Welfare Foundation Society",
  "SHRI SHANTI COLLEGE OF EDUCATION DATIA",
  "Vaishnav Mata Mahavidyalay  Nursing Panna (M.P.)",
  "SAGAR COLLEGE OF NURSING",
  "CHRISTIAN HOSPITAL CHATTARPUR CHATTARPUR",
  "GOVT. POLYTECHNIC COLLEGE ITARSI",
  "SHRI BANKE BIHARI NURSING COLLEGE",
  "MP WELFARE ASSOCIATION OF THE BLIND",
  "RADIANT INSTITUTE OF MANAGEMENT",
  "SNEH INSTITUTE FOR LEARNING AND EMPOWERMENT",
  "JAI MAA PITAMBRA COLLEGE OF MANAGEMENT",
  "MAA VAISHNO DEVI NURSING INSTITUTE",
  "KANHA JI SHIKSHA MAHAVIDHYALAY MAHAPUR BHIND",
  "SPN MAHAVIDYALAYA NARSINGHPUR",
  "KALANIKETAN POLYTECHNIC COLLEGE JABALPUR",
  "CHOWDHARI SHIV KUMAR SHARMA TEACHER INSTITUTION PRITHVIPURA BHIND",
  "MGM SCHOOL OF NURSING KATNI",
  "ARYAN COLLEGE OF EDUCATION, MORAR",
  "Sanjeevani College of Nursing",
  "GOVT.POLYTECHNIC COLLEGE MANDSAUR",
  "PRAGYA SAGAR ACADEMY ",
  "GOVT.POLYTECHNIC COLLEGE PACHORE",
  "TRINITY NURSING SCHOOL",
  "SARDAR PATEL MAHAVIDHYALAY",
  "GOVT.POLYTECHNIC COLLEGE RAISEN",
  "SAMRAT ASHOK TECHNOLOGICAL INSTITUTE POLYTECHNIC COLLEGE",
  "GOVT.POLYTECHNIC COLLEGE SAGAR",
  "NEW ERA COLLEGE OF MANAGEMENT",
  "GOVT.POLYTECHNIC COLLEGE SANAWAD",
  "govt. polytechnic college, nasrullaganj",
  "SANGHVI INSTITUTE OF MANAGEMENT AND SCIENCES(PGDM)",
  "Nagaji Institute of Teachers Education, Sitholi, Gwaliar",
  "MMD D.ed College",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING DATIA",
  "PRAGYA BAL UTTHAN SAMITI KATANGI, JABALPUR",
  "BAPU COLLEGE OF EDUCATION",
  "D V S SCHOOL OF NURSING  AND RESEARCH GWALIOR",
  "OMKAR SCHOOL OF NURSING GUNA",
  "SARDAR PATEL SCHOOL OF EDUCATION",
  "S S College of Computer and Professional Studies Plot No. 11/3 Village Sonakhar Dist Chhindwara",
  "VIKRANT INSTITUTE OF BUSINESS MANAGEMENT",
  "Adarsh jeevan mahavidhyalaya",
  "MOOK BADHIR SANGATHAN",
  "SARDAR PATEL COLLEGE OF NURSING RATLAM",
  "AADARSH COLLEGE OF PROFESSIONAL STUDIES",
  "POLYTECHNIC COLLEGE NOWGONG",
  "Bhagwan Singh Social Welfare Foundation Society",
  "Sarwa Dharma Institute of Nursing",
  "BALDEV KRISHNA COLLEGE OF TEACHERS TRAINING JAFRABAD IMLIYA JOURA",
  "MANDLA INSITTUTE OF NURSING",
  "SCHOOL OF RURAL MANAGEMENT, BHADWASA",
  "GOVT.POLYTECHNIC COLLEGE SEONI",
  "RENAISSANCE UNIVERSITY IIIBM",
  "SCHOOL OF NURSING CHRISTIAN HOSPITAL",
  "RENAISSANCE UNIVERSITY IISCS",
  "NARAYANAN COLLEGE",
  "GOVT.POLYTECHNIC COLLEGE SHAHDOL",
  "SHARVA DHARMA SHIKSHAK PRASIKSHAN KENDRA GWALIOR",
  "Shri Balaji College of Education, Plot -256, Senthra Aheer, porsa",
  "SHIVAM SHIKSHA MAHAVIDYALAYA MORENA",
  "SHIVNATH SINGH SCHOOL OF NURSING GWALIOR",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION GWALIOR",
  "SHRINATH COLLEGE OF NURSING, ALIRAJPUR",
  "SHRI RAWATPURA SARKAR SCHOOL OF NURSING DATIA",
  "Shri Saibaba Shikshan Prashikshan Sansthan, Burhanpur",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BAGRUL HARDA",
  "VIDYAVATI COLLEGE  OF NURSING BTI ROAD VIKRAMPURA BHIND",
  "GOVT.POLYTECHNIC COLLEGE SHAJAPUR",
  "ARYABHATT COLLEGE OF TECHNOLOGY  AND SCIENCE UDAIPURA",
  "AADHAR COLLEGE OF NURSING SAILANA",
  "ARHAM INSTITUTE OF NURSING",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING PANNA",
  "GALAV RISHI INSTITUTE OF EDUCATION",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING NARSINGHPUR",
  "ASHA NIKETAN SCHOOL OF NURSING, BHOPAL",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING MANDSAUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING MANDLA",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION BHOPAL",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KHANDWA",
  "ARNEJA COLEGE OF EDUCATION GWALIOR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING HOSANGABAD",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING GUNA",
  "GOVT DISTRICT INSTITUTE OF EDUCATION AND TRAINING  VIKAT GANJ  BANDHAVGARH  UMARIA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING DHAR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING DAMOH",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING CHINDWADA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING CHHATARPUR",
  "VAMA SCHOOL OF NURSING",
  "SHRI SAI INSTITUTE OF TECHNOLOGY RATLAM",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BHOPAL",
  "GOVT. WOMENS POLYTECHNIC COLLEGE JABALPUR",
  "DHAR POLYTECHNIC COLLEGE DHAR",
  "MAHI SCHOOL OF NURSING SARWAN PALACE SARWAN",
  "DEVI RUKMANI SHIKSHA TRAINING INSTITUTE KHARGAON",
  "CHRISTIAN MEDICAL TRAINING CENTRE SCHOOL & COLLEGE OF NURSING DAMOH",
  "SAHARA COLLEGE OF EDUCATION",
  "CHRISTIAN BASIC TRAINING INSTITUTE KHANDWA",
  "SMT KASTURI DEVI EDUCATION COLLEGE",
  "christ college of nursing biaora",
  "ANANT INSTITUTE OF NURSING",
  "SHREE BALAJI SHIKSHAN MAHAVIDYALAYA",
  "CENTRAL INSTITUTE OF NURSING SCIENCE JABALPUR",
  "Center for Higher Studies Elementary Teacher Education D.Ed. College",
  "MA SIDDHESWARI EDUCATION COLLEGE KALAMAD  BAIRAD PLOT  TEHSIL POHARI SHIVPURI M P",
  "BOSTON SCHOOL FOR NURSING, GWALIOR",
  "A.B.V.M. College of Education",
  "SHREE BALAJI COLLEGE OF PHARMACY",
  "S R MEMORIAL NURSING AND RESEARCH INSTITUTE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SAHDOLE",
  "B H R C SCHOOL OF NURSING INDORE",
  "Bharat College of Education",
  "BHAGWATI INSTITUTE OF PROFESSIONAL STUDIES GWALIOR",
  "Bal Niketan Sangh D.Ed. College",
  "BAL ADHYAPAN MANDIR INDORE",
  "AWADH MADHAV SCHOOL OF NURSING GWALIOR",
  "A.V.IT. EDUCATION",
  "asha institute of nursing",
  "ARYAN SCHOOL OF NURSING GWALIOR",
  "ANUSHREE SCHOOL OF NURSING JABALPUR",
  "ACHARYA NARENDRA DEV COLLEGE RITHOUNIYA KAILARAS",
  "DISTRICT INSTITUTION OF EDUCATION AND TRAINING DINDORI",
  "H M COLLEGE OF NURSING",
  "SANMATI SHIKSHA MAHAVIDYALAYA VILLAGE BAJHAI BHIND",
  "PEACE COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING DEWAS",
  "IMPERIAL INSTITUTION OF MANAGEMENT GWALIOR",
  "V E E ACADEMY GWALIOR",
  "RANI RUPMATI COLLEGE OF MANAGEMENT",
  "SNEH INSTITUTE OF NURSING  HOSPITAL",
  "TRAINING COLLEGE OF NURSING GENERAL HOSPITAL MALEGAON",
  "Vamanrao Ithape Nursing School, Sangamner",
  "Lokseva Nursing School,Beed.",
  "5014-Anjuman Imdadut Tulba's Institute Of Pharmacy, Malegaon(Nashik)",
  "RADHAI INSTITUTE OF NURSING SCHOOL, GANGAKHED, PARBHANI",
  "MARATHWADA NURSING SCHOOL, NANDED",
  "6312-Abhinav Education society College of Engineering and Technology (Diploma), Wadwadi, Tal. Khandala",
  "School of Nursing S.R.T.R. Medical College and Hospital, Ambajogai",
  "SHREE SEVA MEDICAL FOUNDATIONS SHAKUNTALA INSTITUTE OF NURSING EDUCATION, SHIRWAL",
  "JAWALGE NURSING SCHOOL LATUR",
  "6720-Shri Balasaheb Mane Shikshan Prasarak Mandal,Ashokrao Mane Polytechnic, Ambap, Tal-Hatkanangle, Dist. Kolhapur",
  "2280-Vetaleshwar Shikshan Sanstha's Rajiv Gandhi Instiute of Polytechnic, Hasegaon Tal. Ausa Dist Latur",
  "5288-Adivasi Deomogara Edu. Society's K. D. Gavit D.Pharmacy College, Pathrai, Tal.Dist.-Nandurbar",
  "6478-BHARTI VIDYAPEETHS INSTITUTE OF PHARMACY (UN AIDED WING) PUNE",
  "6415-All India Shri Shivaji Memorial Society's Polytechnic, Pune",
  "1148-P. R. Pote Patil Institute of Engineering & Research, At Kathora, Amravati",
  "2526-V.J.SHINDE POLYTENIC COLLEGE OSMANABAD",
  "6435-Zeal Education Society, Zeal Polytechnic, Narhe Tal. Haveli, Pune",
  "2277-Yogwashistha Shikshan Prasarak Mandal?s Polytechnic,Babhalgaon Dist Latur",
  "2567-Yashodeep Institute of Pharmacy, Pimpalgaon Pandhari, Aurangabad.",
  "SIDDHGIRI NURSING INSTITUTE",
  "ACHARYA VINOBA BHAVE NURSING COLLEGE KATOL",
  "ADARASH SHIKSHAN PRASARAK MAMDAL JALKOT SANCHLIT JANSEVA NURSING COLLEGE MUKHED TQ MUKHED DIST NANDED",
  "SAKSHAM NURSING SCHOOL GNM UDGIR",
  "BILL GATES NURSING SCHOOL OSMANABAD",
  "2546-College of Pharmacy(D.Pharm), Khandala",
  "2576-VSS Institute of Pharmacy, Badnapur",
  "5252-The People Education Society's, Diploma College Of Enggineering & Technology,Jamkhed",
  "New Nursing School, Beed",
  "3296-Saraswati Education Society's Yadavrao Tasgaonkar Institute Of Pharmacy(Diploma), Bhivpuri, Karjat",
  "3281-Saraswati Education Society,Saraswati Institute of Technology, Kharghar, Navi Mumbai",
  "Late Tulsabai Sopanrao Patil Institute of Nursing",
  "6324-Rajgad Dnyanpeeth's Technical Campus,Dhangwadi, Bhor",
  "2292-Anand Charitable Trusts, Diploma in Engineering & Technology, Murshadapur, Ashti, Dist. Beed",
  "SWAMI VIVEKANAND SANSTHA, NURSING SCHOOL, MALEGAON",
  "6890-Teerthankar Education Society's Dr. Shivajirao Kadam College of B.Pharmacy, Kasbe Digraj Sangli",
  "2600-KESHAVRAO PATIL INSTITUTE OF PHARMACY,OSMANABAD",
  "ARJUN SCHOOL OF NURSING, JALNA",
  "1168-Balaji Polytechnic,Sawarala,Tal-Wani,Yavatmal",
  "Parvatibai Nursing School wardha",
  "2172-Hi-Tech Polytechnic, Aurangabad",
  "1144-Bhaiyasaheb Javade Education Society, Amravati Polytechnic College, Bhankhed, Amravati",
  "2558-Dnyansadhana Institute of Pharmacy, Dharmapuri",
  "Sahakaramaharshi vishnuanna patil nursing school",
  "6416-Dr. D. Y. Patil Pratishthan's, Padmashree Dr. D.Y.Patil Polytechnic, Nigdi",
  "6270-Shri Balasaheb Mane Shikshan Prasarak Mandal,Ashokrao Mane Polytechnic, Ambap, Tal-Hatkanangle, Dist. Kolhapur",
  "ASHWINI NURSING TRAINING SCHOOL",
  "5432-R.M.S. Institute of Pharmacy, Sayane Khurd",
  "6260-Rajgad Dnyanpeeth's College of Pharmacy, Bhor",
  "2287-People Education Society's P.E.S. Polytechnic, Nagsenvan, Aurangabad",
  "3144-Mahavir Education Trust's Shah & Anchor Kutchhi Polytechnic, Mumbai",
  "1012-GOVERNMENT POLYTECHNIC YAVATMAL",
  "2614 Aurangabad Pharmacy College, Mitmita",
  "INDIRA GANDHI SCHOOL OF NURSING LOHA",
  "SHRI KASHI SHIKSHAN PRASARAK MANDALS SAI NURSING SCHOOL SHEVGAON",
  "5480 MATOSHRI RADHA COLLEGE OF D PHARMACY",
  "2610-SHIVPRASAD COLLEGE OF PHARMACY",
  "5452-RUPESH BADHAN INSTITUTE OF PHARMACY PIMPALNER",
  "3505-ABHINAV INSTITUTE OF PHARMACY, Chinchpada, Kalyan",
  "4653 ANJANYA POLYTECHNIC COLLEGE, Tumsar",
  "GANPAT BHARTI VAIDYAKIYA V SHIKSHAN PRASRAK MANDAL",
  "Maharashtra Arogya Mandals Institute of Nursing Education,Pune",
  "3259-L & T INSTITUTE OF TECHNOLOGY MUMBAI",
  "6939-Delight Institute of Pharmacy, Koregaon Bhima",
  "LATE PARASRAM SHIKSHAN SANSTHA , KAWARABANDH TAL SALEKASA DIST BHANDARA , SANCHLIT G K NURSING SCHOOL KAWARABANDH TAL SALEKASA  DIST GONDIA",
  "WOMEN'S EDUCATION SOCIETY'S WOMEN'S TECHNICAL EDUCATION & RESEARCH INSTITUTE NAGPUR.",
  "3500-VIJAYRAO NAIK COLLEGE OF PHARMACY",
  "6916-PHARATE PATIL COLLEGE OF PHARMACY DIPLOMA MANDVAGN PHARATA",
  "2618-SHRI SAMBHAJI COLLEGE OF PHARMACY",
  "6954-SHRI GANPATI INSTITUTE OF D PHARMACY TEMBHURNI",
  "CENTRAL INSTITUTE OF PLASTICS ENGINEERING AND TECHNOLOGY",
  "4251-Sant Tukdoji Maharaj Shikshan Sanstha's Shri Sai Taj Polytechnic, Drugdhamna, Nagpur",
  "6921-Elixir Institute of Pharmacy, Pune",
  "6149-Choudhary Attar Singh Yadav Memorial Trust,Siddhant College of Engineering, Maval",
  "FULABAI MUNDE MAHILA MANDALS KOMALBAI MUNDE NURSING SCHOOL",
  "Vishavbharti Mahila Sevabhavi Mandals Ankita Dound Institute of Nursing Gitta Road Ambajogai",
  "KADAM SCHOOL OF GNM NURSING",
  "LATE PANJABRAO PATIL JAWALGAONKAR COLLEGE OF NURSING NANDED",
  "4652-MOUDA COLLEGE OF PHARMACY",
  "SAWALI SCHOOL OF NURSING",
  "FLORENCE NIGHTINGALE GNM NURSING COLLEGE, JALNA",
  "ATLANTA SCHOOL OF NURSING",
  "DISHA NURSING COLLEGE, NAGPUR",
  "Sant Eknath Institute of Nursing Shevgaon",
  "SUNITA NURSING SCHOOL",
  "SMT.LAXMIBAI CHANDEKAR NURSING SCHOOL, GOREGAON",
  "TANISHQ NURSING SCHOOL",
  "RAJIV GANDHI DED COLLEGE DHAD",
  "S. P. JAIN INSTITUTE OF MANAGEMENT AND RESEARCH",
  "5008-GOVERNMENT POLYTECHNIC, JALGAON",
  "NATIONAL INSTITUTE OF SECURITIES MARKETS",
  "MOTHER TERESA NURSING SCHOOL SELU DIST PARBHANI",
  "LATE ANANTRAO RAJURKAR COLLEGE OF NURSING NANDED",
  "RAMESH PATIL INSTITUTE OF PHARMACY",
  "LATE CHANDRABHAGABAI KESHAVE COLLEGE OF NURSING AT POST MAHUR TA MAHUR DIST NANDED",
  "ITM BUSINESS SCHOOL DOMBIVILI",
  "MATA GIRIJA NURSING SCHOOL HALADWADHAVANA TAL, JALKOT,DIST , LATUR",
  "5223-MGTS MANDAL'S SHARADCHANDRIKA SURESH PATIL INSTITUTE OF TECHNOLOGY(POLYTECHNIC), CHOPDA",
  "SMT JAYSHREE SHARADCHANDRA KOTHARI BUSINESS SCHOOL",
  "2520-D B GROUP OF INSTITUTIONS, SCHOOL OF TECHNOLOGY, POLYTECHNIC, MAHALANGRA, CHAKUR",
  "2280-RAJIV GANDHI INSTITUTE OF POLYTECHNIC, AUSA",
  "3374-MET`S INSTITUTE OF MEDICAL SCIENCES",
  "3364-INSTITUTE OF INDUSTRIAL SAFETY PROFESSIONALS OF INDIA BORIVALI (E) MUMBAI",
  "4019-NAGAR YUVAK SHIKSHAN SANSTHA ADV. V.R.MANOHAR INSTITUTE OF DIPLOMA IN PHARMACY NAGPUR",
  "2612-SMT LATATAI BABURAO PATIL INSTITUTE OF PHARMACY KHANDGAON  NANDED",
  "5341-K S S M M`S DHANVANTARI COLLEGE OF ENGINEERING NASHIK",
  "6934-PUNE DISTRICT EDUCATION ASSOSIATION COLLEGE OF PHARMACY, HADAPSAR, PUNE",
  "6942-SHARDABAI PAWAR INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH DIPLOMA",
  "6953-VARVAND GRAM SHIKSHAN SANSTHAS EKNATH SITARAM DIVEKAR COLLEGE OF PHARMACY",
  "3383-SHRI MOHAMED YUSUF SEAMEN WELFARE FOUNDATION",
  "6724-CHHATRAPATI SHAHU EDUCATION SOCIETYCHHATRAPATI SHAHU POLYTECHNIC AT POST ATIT DIST SATARA",
  "DURGADEVI SARAF GLOBAL BUSINESS SCHOOL",
  "SHIVRAJ COLLEGE OF PHARMACY",
  "SUSHGANGA COLLEGE OF PHARMACY,WANI DIST YAVATMAL",
  "A C PATIL INSTITUTE OF PHARMACY, KHARGHAR",
  "PALAK NURSING INSTITUTE",
  "NANDIGRAM NURSING COLLEGE NANDED DIST NANDED",
  "GODAVARI NURSING SCHOOL OF ANM AURANGABAD",
  "LATE BHASKARARAV SHINGNE KRIDA VA SHIKSHAN PRASARK SANSTHA LATE VIJAY MAKHAMALE INSTITUTE OF RGNM SCHOOL MAKALPUR PANGRA TQ SINDKHED RAJA DIST BULDHANA",
  "WALUJ NURSING SCHOOL AURANGABAD",
  "VAIJAPUR NURSING SCHOOL AURANGABAD",
  "2027-Adarsh Shikshan Prasarak Mandal's Diploma In Pharmacy Institute, Osmanabad",
  "Christ Institute of Management",
  "HEMLATABAI NAIK COLLEGE OF NURSING TELWADI",
  "ANAND SCHOOL OF NURSING,VAIJAPUR",
  "SAKSH COLLEGE OF NURSING, MIRAJ",
  "SAMBODHI SCHOOL OF NURSING GNM CHHATRAPATI SAMBHAJINAGAR",
  "SANJIVAN COLLEGE OF NURSING, MORANE GONDUR BYPASS ROAD, GONDUR, DHULE",
  "SAPTASHRUNGI NURSING SCHOOL VANI",
  "SARA INSTITUTE OF NURSING TEMBHURNI",
  "SHIVCHHATRAPATI COLLEGE OF NURSING",
  "SHREEYASH NURSING COLLEGE",
  "SHRIRAM INSTITUTE OF NURSING, KAULKHED",
  "AHEMAN COLLEGE OF NURSING CHIKHALDARA DIST AMRAVATI",
  "DEVGIRI NURSING SCHOOL",
  "JIJAU COLLEGE OF NURSING AND RESEARCH CENTER MARKHEL",
  "6355-SBMSPM ASHOKRAO MANE COLLEGE OF PHARMACY",
  "INSTITUTE OF DIPLOMA PHARMACY, SAVE",
  "KRUSHNATULSI INSTITUTE OF NURSING",
  "NEW WOMENS COLLEGE OF PHARMACY, KOLHAPUR",
  "MAHATMA BASWESHWAR NURSING SCHOOL",
  "SONEKAR COLLEGE OF HEALTH SCIENCES, NAGPUR",
  "ATAL BIHARI VAJPAYEE COLLEGE OF PHARMACY",
  "ANGEL COLLEGE OF PHARMACY PUNE",
  "BELESHWAR INSTITUTE OF PHARMACY PARBHANI",
  "SHRI RAMKRISHNA PARAMHANS POLYTECHNIC INSTITUTE",
  "VIDYA AMRUT DNYAN PRATISHTHANS VITHAI PANDIT DEORE INSTITUTE OF PHARMACY SHIRSONDI TAL MALEGAON DIST NASHIK",
  "AARYA SCHOOL OF NURSING, WASHIM",
  "D P KHARDE NAVJEEVAN COLLEGE OF PHARMACY",
  "DEEP COLLEGE OF PHARMACY,BOISAR",
  "ADVIKA COLLEGE OF PHARMACY AND RESEARCH CENTER, ANSING",
  "MANWATKAR COLLEGE OF PHARMACY D PHARM AT GHODPETH TAH BHADRAWATI DIST CHANDRAPUR",
  "SANT GAJANAN MAHARAJ COLLEGE OF PHARMACY SINDEWAHI",
  "BHIMASHANKAR NURSING SCHOOL SHIRADHON",
  "HORIZON SCHOOL OF NURSING, VISHNUPURI, NANDED",
  "KAI GOPINATHRAOJI RATHOD SCHOOL OF NURSING GNM",
  "SWA HARSHWARDHAN HUMANE COLLEGE OF PHARMACY BELATI ROAD KONDHA KOSRA TAH PAUNI DIST BHANDARA",
  "MODERN NURSING SCHOOL GNM, BILOLI",
  "NAVNEET COLLEGE OF NURSING , CHINORA , WARORA",
  "NAVNIRMAN INSTITUTE OF NURSING EDUCATIOIN, LOVALE, SANGMESHWAR",
  "PARVATI COLLEGE OF NURSING",
  "RENUKA COLLEGE OF NURSING",
  "SAVITRIBAI PHULE INSTITUTE OF NURSING COLLEGE KILLARI TQ AUSA DIST LATUR",
  "MATOSHREE JIJAU NURSING SCHOOL HARSUL CHATRAPATI SAMBHAJINAGAR",
  "MHAISHALKAR SHINDE INSTITUTE OF NURSING SCIENCES, SANGLI",
  "4655 Dr.Arun Motghare Diploma in Pharmacy, Kosara, Konda",
  "SINDHUDURG EDUCATION SOCIETYS  COLLEGE OF PHARMACY D PHARM",
  "6827- Mahadevrao wandre Institute of Technology, Turkewadi.",
  "AAI TULJABHAVANI  SEVABHAVI SANSTHA RAJMUDRA GNM NURSING SCHOOL NANDED",
  "AAI TULJABHAVANI  SEVABHAVI SANSTHA RAJMUDRA ANM NURSING SCHOOL NANDED",
  "5402- Shree Kapildhara Polytechnic Igatpuri",
  "DNYANAI NURSING SCHOOL",
  "DNYANAI INSTITUTE OF NURSING SCHOOL",
  "CHAITANYA NURSING SCHOOL GNM AT BADNAPUR DIST JALNA",
  "SWAMI VIVEKANAND INSTITUTE OF NURSING",
  "SHANTAI NURSING VIDYALAY PALGHAR",
  "MAULI CHARITABLE TRAUST KOHINOOR RGNM NURSING SCHOOL UJANI EKAMBI ROAD TQ AUSA DIST LATUR",
  "SAMARTH NURSING SCHOOL MUDKHED DIST NANDED",
  "RASHTRAMATA JIJAU NURSING COLLEGE",
  "SHRAMSAFALYA BAHUUDDESHIYA SEVABHAVI SANSTHAS JALNA SANCHLIT AMD INSTITUTE OF NURSING",
  "PANDIT DINDAYAL UPADHYAY NURSING SCHOOL",
  "MAULI CHARITABLE TRUSTS KOHINOOR ANM NURSING SCHOOL, LATUR",
  "MAULI CHARITABLE TRUSTS KOHINOOR INSTITUTE OF NURSING, LATUR",
  "LATE BHAU DAJI PATIL DESHMUKH GRAMIN VIKAS PRATISHTHAN RANM NURSING SCHOOL KOTUL",
  "5468 - Matoshri Education Society's Matoshri Institute of Pharmacy, Dhanore",
  "SAISHYAM FOUNDATIONS, SAI NURSING INSTITUTE, DUGAD PHATA, BHIWANDI, THANE",
  "SAMBHAJI GNM NURSING SCHOOL CHAPOLI TAL CHAKUR DIST LATUR",
  "SHRI SANT GAHININATH MAHARAJ NURSING INSTITUTE",
  "SMT MATHURABI HARPALE NURSING SCHOOL",
  "SRINATH INSTITUTE OF NURSING",
  "TULJAI NURSING COLLEGE",
  "VIVEKANAND NURSING COLLEGE, HIWARA ASHRAM TQ MEHKAR DIST BULDHANA",
  "ANKUSH SHIKSHAN SANSTHA'S G.H. RAISONI INSTITUTE OF LIFE SCIENCES NAGPUR",
  "BHAUSAHEB R.K. PATIL DTED COLLEGE, PIMPRI GAWALI",
  "NANDINI SHIKSHAN SANSTHA PARBHANI SANCHALIT DECCAN NURSING COLLEGE PARBHANI",
  "MATA GIRIJA GNM NURSING SCHOOLJALGAON ROAD CH SAMBHAJINAGAR",
  "LOTUS NURSING COLLEGE PUNE",
  "MUKTAI COLLEGE OF NURSING EDUCATION BHANDISHEGAON PANDHARPUR",
  "DR R N LAHOTI NURSING COLLEGE SULTANPUR",
  "HIRANYA NURSING COLLEGE",
  "SAHARA COLLEGE OF NURSING PARBHANI",
  "HURERA COLLEGE OF NURSING NANDURA BULDHANA",
  "DR KETKI PATIL SCHOOL OF NURSING, JALGAON",
  "B.M.W.SEVASADAN ADHYAPIKA VIDYALAY, PUNE",
  "ANANDI SHIKSHAN PARSARAK MANDAL KALAMBE TARF KALE KOPARDE TAL KARVEER DIST KOLHAPUR SANCHALIT ANANDI GNM COLLEGE TARF  KALE TAL KARVEER DIST KOLHAPUR",
  "MATOSHRI EDUCATION SOCIETY'S SATYAJEET D.ED COLLEGE, MEHKAR, BULDANA",
  "ATTHARVA HEALTH AND EDUCATION FOUNDATION, PUNE SANCHLIT M D MEDICAL INSTITUTE ,TALEGAON DABHADE PUNE",
  "SHIVSHAKTI NURSING INSTITUTE",
  "LATE PARWATIBAI BUDARE NURSING SCHOOL",
  "CARE INSTITUTE OF NURSING EDUCATION",
  "DR M I MOMIN INSTITUTE OF NURSING EDUCATION",
  "SHREE SAMARTH NURSING COLLEGE RIDHORA TQ BALAPUR DIST AKOLA",
  "TALHA COLLEGE OF NURSING GNM WARDHA",
  "GANGAMAI JUNIOR COLLEGE OF EDUCATION NAGAON DHULE",
  "MATOSHRI EDUCATION SOCIETYS M A D SCHOOL OF RGNM NURSING, BABHULGAON, YEOLA",
  "ARYA COLLEGE OF PHARMACY TEMBHURNI TALUKA MADHA DIST SOLAPUR",
  "6266-SHETKARI SHIKSHAN MANDALS PADMABHOOSHAN VASANTRAODADA PATIL INSTITUTE OF TECHNOLOGY, BUDHGAON (DIP)",
  "JITO EDUCATIONAL AND MEDICAL TRUST, SANCHLIT, SMT VIMALADEVI KHYALILAL VAGHARECHA COLLEGE OF NURSING EDUCATION , SAKET ROAD, MAJIWADA, THANE",
  "SEVASADAN SCHOOL OF NURSING GADHINGLAJ",
  "SANTOSHI MATA SCHOOL OF NURSING ,NANDURBAR",
  "NAVYUVAK SHIKSHAN PRASARAK MANDAL RAWANKOLAS BHOSLE COLLEGE OF EDUCATION MUKHED NANDED",
  "SHAHADA TALUKA CO. OP. EDUCATION SHAHADA NANDURBAR",
  "SHRI RAMDAS ATHWALE COLLEGE OF EDUCATION, SOLAPUR",
  "SHRI SIDDHI COLLEGE OF NURSING",
  "6824-TRINITY POLYTECHNIC PUNE, MAHARASHTRA",
  "RAJIV GANDHI COLLEGE OF NURSING DESAIGANJ WADSA DIST GADCHIROLI",
  "VIDYABHARTI COLLEGE OF NURSING SHIVANGAON TQ TIOSA DIST AMRAVATI",
  "5249-Trimurti Shikshan Prasarak Mandal, Trimurti Institute Of Technology, Paladhi Bk, Jalgaon",
  "MIMA Institute of Management",
  "KASTURBA GANDHI NURSING SCHOOL, MANIK NAGAR NANDED",
  "4015-ACHARYA SHRIMANNARAYAN POLYTECHNIC, PIMPRI-WARDHA",
  "5261-TULAJABHAVANI SEVA PRATISTHAN, SONIYA GANDHI POLYTECHNIC, SHRIGONDA",
  "MOTHER TERESA NURSING SCHOOL, HINGOLI",
  "CENTRAL INSTITUTE OF EDUCATION GNM",
  "SIDDHAYOGI INSTITUTE OF NURSING COLLEGE AKLUJ, MALSHIRAS, DIST SOLAPUR",
  "SHANTINIKETAN COLLEGE OF NURSING, JALNA",
  "KAI MATHURABAI INGLE SCHOOL OF NURSING GNM",
  "BHAGWANBABA SCHOOL OF NURSING KOTHALAJ TQ DIST HINGOLI",
  "JIIUS MOTHER HAWWA NURSING INSTITUTE AKKALKUWA NANDURBAR",
  "SWARAJYA NURSING COLLEGE, GADHINGLAJ,  KOLHAPUR",
  "KRUSHI PRATISHTHAN JARODA SUBHADRA NURSING SCHOOL JARODA TQ KALAMNURI DIST HINGOLI",
  "SANT GAJANAN MAHARAJ NURSING SCHOOL SHEGAON",
  "2525-KRUSHNAJI PURUSHOTTOM CHOUSALKAR YOGESHWARI POLYTECHNIC AMBAJOGAI DIST BEED",
  "3501-SIDDHIS INSTITUTE OF PHARMACY",
  "JIJAU NURSING SCHOOL MANIK NAGAR NANDED",
  "RAJE CHHATRAPATI PARAMEDICAL AND NURSING COLLEGE",
  "SWAMI VIVEKANAND NURSING GNM COLLEGE",
  "SAMARTH NURSING SCHOOL BEED",
  "SAU MANGALA SUBHASH PATIL SCHOOL OF NURSING DIDOLA BK, MOTALA, BULDHANA",
  "OM COLLEGE OF NURSING",
  "WANI COLLEGE OF PHARMACY",
  "K M INSTITUTE OF D PHARMACY KAIJ",
  "S P COLLEGE OF PHARMACY PATODA",
  "SATPUDA INSTITUTE OF PHARMACY SHEGAON DIST BULDHANA",
  "TATYASAHEB A B CHAUDHARI INSTITUTE OF PHARMACY",
  "ADV TUSHAR GAWALI COLLEGE OF PHARMACY RESEARCH AND TECHNOLOGY ANWA",
  "DESHMUKH COLLEGE OF PHARMACY, KASAR SIRSI",
  "ARMAN INSTITUTE OF PHARMACY, SHIRURANANTPAL TQ SHIRURANANTPAL DIST LATUR",
  "SSK COLLEGE OF PHARMACY, WADZIRE , NASHIK",
  "GLOBAL COLLEGE OF PHARMACY, NASHIK",
  "DHARASHIV INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH SHELKA DHANORA KALAMB",
  "BORDIKAR COLLEGE OF PHARMACY, MATHALA, JINTUR",
  "BORDIKAR COLLEGE OF PHARMACY, SELU",
  "SUMATIDEVI TOMPE INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH, CHANDUR BAZAR, AMRAVATI",
  "SHRI SAIBABA COLLEGE OF NURSING NAGPUR",
  "ASHOKA INSTITUTE OF PHARMACY",
  "SWAMI VIVEKANAND ANM NURSING COLLEGE",
  "MAHATMA GANDHI COLLEGE OF NURSING WARDHA",
  "VEDANTAA INSTITUTE OF NURSING MEDICAL SCIENCE, DAHANU",
  "Karmayogi Institute of Technology, Shelve, Tal.Pandharpur",
  "Indrayani Shikshan Prasarak Mandal Shri Pushpasen Sawant College of Pharmacy, Kudal",
  "MUKTAI NURSING COLLEGE",
  "SHARAD COLLEGE OF PHARMACY, YADRAV",
  "VAISHALITAI JONDHALE COLLEGE OF PHARMACY D PHARM",
  "MAULI INSTITUTE OF PHARMACY AND RESEARCH CENTER WASHIM",
  "NARENDRA SURYAWANSHI COLLEGE OF PHARMACY, WARDHA",
  "J K COLLEGE OF PHARMACY, HINGOLI",
  "Dr. Panjabrao Deshmukh Adhyapak Vidyalay, Pusad",
  "SHRI SIDDHESHWAR NURSING INSTITUTE DHULE",
  "MANASHRI SHAIKSHANIK AND KRUSHI SANSTHA, NANDURBAR SANCHALIT AASTHA NURSING SCHOOL SHAHADA ROAD NEAR RAJPUT LAWNS, NANDURBAR",
  "NATIONAL ACADEMY OF DEFENCE PRODUCTION",
  "SHRI SWAMI SAMARTH NURSING COLLEGE",
  "DR D Y PATIL PRATISHTHANS D Y PATIL PGDM INSTITUTE AKURDI PUNE",
  "VIDYASAGAR EDUCATION SOCIETY GURUKUL POLYTECHNIC NAGRA GONDIA",
  "SAI INSTITUTE OF NURSING SCIENCES",
  "SAI NURSING SCHOOL LATUR",
  "SHRI BALASAHEB MANE SHIKSHAN PRASARAK MANDAL, AMBAP TAL HATKANAGALE DIST KOLHAPUR, SANCHALIT MATOSHRI VATSALA MANE INSTITUTE OF NURSING, PETH VADGAON, TAL HATKANAGALE, DIST KOLHAPUR",
  "SIDDHI COLLEGE OF NURSING,MURGUD ,TAL KAGAL, DIST KOLHAPUR",
  "MATRUBHOOMI PRATISHTHAN SHIKSHAN PRASRAK MANDAL UDGIR ADHIRAJ COLLEGE OF NURSING DEHU ROAD ALANDI DIST PUNE",
  "MATRUBHOOMI PRATISHTHAN SHIKSHAN PRASRAK MANDAL UDGIR MATRUBHOOMI INSTITUTE OF NURSING NANDED ROAD NANDED",
  "LATE SANJAY TOMPE & LATE SAMEER DESHMUKH COLLEGE OF EDUCATION (D.EI.ED.) CHANDURBAZAR",
  "SHRI VENKATESHA SHIKSHAN PRASARAK MANDALS SHRI VENKATESHA NURSING SCHOOL ADITYANAGAR, EKNATHNAGAR BEED",
  "SHRI SANT BHAGWANBABA SEVABHAVI SANSTHA SANCHLIT SHRI VENKATESHA NURSING SCHOOL, AMBAJOGAI",
  "GAJANAN MAHARAJ BAHUUDDESHIYA SEVABHAVI SANSTHA, SANCHALIT WALUNJ NURSING SCHOOL OASIS CHOWK WALUNJ CHHTRPTI SAMBHJINAGAR",
  "Dr. rajendra Gode College of Pharmacy, Amravati",
  "SAISIDDHI COLLEGE OF PHARMACY    ",
  "L.S.J. WELNESS NURSING SCHOOL (G.N.M.), GOTHEGHAR, SHAHAPUR, THANE",
  "SHRI CHHATRAPATI SHIVAJI MAHARAJ COLLEGE OF NURSING, RAHURI ",
  "P V BELHEKAR COLLEGE OF NURSING",
  "J V  COLLEGE OF NURSING ,DAMPUR MOUDA TQ JIWATI DIST CHANDRAPUR    ",
  "SHARDA NURSING SCHOOL JAWALA BAZAR, AUNDHA, HINGOLI",
  "DR J J MAGDUM COLLEGE OF NURSING",
  "DADA MAHARAJ INSTITUTE OF MEDICAL SCIENCES SATARA",
  "SAI SANJIVANI NURSING COLLEGE ",
  "SAHYADRI  INSTITUTE  OF NURSING  EDUCATION  KHARAWATE  DAHIWALI",
  "SAVITRIBAI PHULE NURSING SCHOOL MANWAT",
  "SHRI GANESH SHIKSHAN PRASARAK MANDAL BALGHAT POLYTECHNIC COLLEGE RUDHA LATUR",
  "RAJNANADA SCHOOL OF NURSING, AUSA ROAD, DIST LATUR",
  "SEVASADAN COLLEGE OF NURSING, MIRAJ ",
  "GENERAL HOSPITAL JALNA",
  "SHRIMATI MAYA COLLEGE OF NURSING",
  "GURUKUL INSTITUTE OF TECHNOLOGY",
  "SNEHADEVI RAJE DHARMARAOBABA ATRAM BAHUUDDESHIYA SANSTHA, AHERI SANCHALIT SNEHADHARMA COLLEGE OF NURSING, RAJWADA AHERI",
  "Jamiya Islamiya Ishatul Olu's Jamiya Polytechnic, Akkalkuwa",
  "KSPMS JIJAMATA NURSING SCHOOL LATUR",
  "MOTHER TERESA RANM NURSING INSTITUTE UDGIR",
  "LOKSEVA BAHUUDDESHIYA SEVABHAVI SANSTHA SONI NURSING SCHOOL SAMBHAJI NAGAR KHADGAON ROAD LATUR DIST LATUR",
  "VARAD COLLEGE OF PHARMACY, PIMPALNER",
  "MAA RENUKA SCHOOL OF NURSING BHATKULI AMRAVATI",
  "VAIBHAV SEVABHAVI SANSTHA  TAMBWESHWAR NURSING SCHOOL DHARUR",
  "BAPURAO SHELKE NURSING SCHOOL AHMEDPUR",
  "RENUKA SCHOOL OF NURSING AMBAJOGAI",
  "SWAPNIL INSTITUTE OF NURSING",
  "SMT RAJKAMAL TIDKE INSTITUTE OF NURSING MOUDA DISTRICT NAGPUR",
  "SWAMI NARAYAN NURSING INSTITUTE",
  "MULA PRAVARA NURSING SCHOOL",
  "ATHARVA SCHOOL OF BUSINESS",
  "DR B B KHALADKAR GNM NURSING SCHOOL",
  "JAI HIND COLLEGE OF NURSING JUNNER PUNE",
  "MUKUNDRAV PHATAK NURSING COLLEGE DEVGAD",
  "PUNE BUSINESS SCHOOL",
  "MEDILINE INSTITUTE OF NURSING",
  "SHRIRAM INSTITUTE OF NURSING PANIV",
  "REDBIRD FLIGHT TRAINING ACADEMY PVT LTD",
  "TATYASAHEB A B CHAUDHARI COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "SHANTAI INSTITUTE OF TECHNOLOGY",
  "RAJASHRI SHAHU COLLEGE OF NURSING DIST WASHIM",
  "MAHATMA PHULE NURSING SCHOOL ANM BABHULGAON",
  "ACQUARIOUS PUBLIC EDUCATION SOCIETY NAGPUR ACQUARIOUS SCHOOL OF NURSING KUDWA",
  "3267-Sai Shiva Education Trust's, Muchhala Polytechnic,Thane",
  "4239-The Shriram Gramvikas Shikshan Sanstha, Baburaoji Tidke Polytechnic, Mouda, Nagpur",
  "LATE RAGHUNATHRAO MUNDE NURSING SCHOOL , AMBAJOGAI",
  "LATE. RAMBAHU (ANNA) KHADE SEVABHAVI SANSTHA MAJALGAON BEED",
  "LATE RAMRAOJI DUDHE COLLEGE OF EDUCATION AND COLLEGE OF DIPLOMA IN EDUCATION DARWHA YAVATMAL",
  "Late Ramrao Patil D.T.ED",
  "LATE SHANKARLAL AGARWAL COLLEGE OF TEACHING STUDIES MANOHAR CHOWK GONDIA",
  "LATE. SHIVRAMJI HIWASE D.ED COLLEGE, WARUD",
  "LATE SHRI BALIBHADRA SINGH SHIKSHAN SANSTHA KHARODI MUMBAI",
  "MAHATMA FULE SAMATA SHIKSHAN SANSTHA SMT. RADHABAI PAWAR D. ED. COLLEGE KATOL NAGPUR",
  "MAHATMA GANDHI JR. COLLEGE OFEDUCATION ARANYESHWAR PUNE",
  "MAHATMA GANDHI MEMORIAL HOSPITAL MUMBAI",
  "MAHATMA GANDHI MISSION JUNIOR COLLEGE OF EDUCATION CIDCO AURANGABAD",
  "MAHATMA GANDHI SHIKSHAN PRASARAK MANDAL ADHYAPAK VIHAYALA SHAHADA NANDURBAR",
  "Mahatma Junior College of Education",
  "MAHATMA PHULE GRAMIN VIKAS JALKOT LATUR",
  "MINORITY EDUCATIONAL SOCIETY YAVATMAL YAVATMAL",
  "MITRA SADHANA SHIKSHAN PRASARAK MANDAL RAJARSHI SAHU D. ED. COLLEGE PATHRI AURANGABAD",
  "MIT SCHOOL OF TELECOM MANAGEMENT",
  "M.K HAJI ADHAYAPAK VIDAYALAYA DEOPUR DHULE",
  "NURSING SCHOOL GENERAL HOSPITAL, CHANDRAPUR",
  "MODEL ACTION FOR THE RURAL AND CHILD HELP(MARCH) NAWAPUR NANDURBAR",
  "NINAIDEVI SHIKSHAN PRASARAK MANDAL SHIVKJIRAO DESHMUKH SHIRALA SANGLI",
  "N.L.DALMIA INSTITUTE OF MANAGEMENT STUDIES & RESEARCH",
  "N M WADIA HOSPITAL PUNE",
  "NOOR EDUCATION SOCIETY JUNIOR COLLEGE OF EDUCATION AKALKCT SOLAPUR",
  "AADIVASI SHIKSHAN VIKAS PRASARAK MANDAL SHIVPRASAD D. ED . COLLEGE NARSI ROAD MUKHED NANDE",
  "NOOTAN SCHOOL OF NURSING, NANDGAON",
  "AAKAR SCHOOL OF NURSING HINGNA, NAGPUR",
  "NUTAN MAHARASHTRA VIDYA POLYTECHNICPUNE",
  "NUTAN MARATHA VIDYALAYA JALGAON JALGAON",
  "ABASAHEB KAKADE SHIKSHAN SHASTRA MAHAVIDYALYA NAV MAHARASHTRA SHIKSHAN MANDAL SHEVGAON AHMEDNAGAR",
  "OM SHANTI JR. COLLEGE OF EDUCATION AHMEDABAD JALNA AHMEDABAD",
  "PRIYADARSHANI ADYAPAK VIDAYALA (D. ED. ) STATION ROAD BHANDARA",
  "ABHAY SHIKSHAN KENDRA's KrantiJyoti Savitribai Phule College of Education (D.T.Ed) DR. BABASAHEB AMBEDKAR SMARAK VIKHROLI (EAST) MUMBAI",
  "PRIYADARSHANI EDUCATION TRUST ISLAMPURA BEED",
  "PRIYADARSHINI SEVA SANSTHA TALUKA KALAMNURI HINGOLI",
  "ABHINAV EDUCATION SOCIETY ADHYAPAK VIDYALAYA, Ambegaon Budruk, Katraj, Pune 411046",
  "PRIYADARSHNI VIKAS MANDAL TALUKA KALLAM OSMANABAD",
  "PRIYADRASHNI GRAMIN MAHILA MANDAL LONI AHMEDNAGAR",
  "PROVIDENCE JR. COLLEGE OF EDUCATION CIVIL LINES NAGPUR",
  "PRUTHVIRAJ DESHMUKH INSTITUTE OF NURSING YAVATMAL",
  "\"ABHINAV EDUCATION SOCIETY'S D.T.ED COLLEGE AKOLE",
  "R. R. EDUCATIONAL TURST MULUND (EAST) MUMBAI",
  "RURAL FOUNDATION NANDURBAR SANCHALIT D. ED. COLLEGE AKKALKUWA NANDURBAR",
  "ANJUMAN- E- ISLAM URDU JUNIOR COLLEGE OF EDUCATION MHASALA RAIGAD",
  "SACCHIDANAND KALA KRIDA & SHIKSHAN MANDAL SOCIETY PARNER AHMEDNAGAR",
  "SADGURU GRAM VIKAS PRATISHTHAN KARJAT AHMEDNAGAR",
  "ANJUMAN-I-ISLAM M. H. JR. COLLEGE OF EDUCATION FOR WOMEN MAHIM MUMBAI",
  "SADGURUR SAINATH BAHURDESHIYA SANSTHA JIJAMATA D. ED BHADRAWATI CHANDRAPUR",
  "ANJUMAN ISBAT-E-TALIM BEEDS MILIYA URDU D. ED. COLLEGE BEED",
  "SADGURU VIDHYA PRASARAK MANDAL SADGURU VIDHYA PRASARAK D. ED. COLLEGE SHAHADA NANDURBAR",
  "4241-Sanmarg Shikshan Sanstha, Shri Sharadchandra Pawar Polytechnic, Bhilewada",
  "5298-Sane Guruji Vidya Prasarak's Institute of Pharmacy, Shahada, Dist. Nandurbar",
  "5394-SAHJIVAN SHIKSHAN PRASARAK MANDALS VASANTRAO MORE POLYTECHNIC, TEHU, JALGAON",
  "ANJUMAN JUNIOR COLLEGE OF EDUCATION KHAMGAON BULDANA",
  "5354-SAKESHWAR GRAMIN VIKAS SEVA SANSTHA SAU.SUNDARBAI MANIK ADSUL POLYTECHNIC CHAS AHMEDNGAR",
  "ANNASAHEB H. GHADGE PATIL RURAL DED COLLEGE SHEVGAON AHMEDNAGAR",
  "SHRI SAYAJINATH MAHARAJ COLLEGE OF PHARMACY PUNE",
  "1281-Kamalprakash Pharmacy College & Research Centre, Kherda",
  "2568-Shreeyash Institute of Pharmacy, Aurangabad",
  "5442-MET'S INSTITUTE OF D. PHARMACY, ADGAON, NASHIK",
  "Indira Gandhi Nursing School Parner",
  "4640-Abdul Majeed Central Education Society, Institute of Pharmacy, Lonara",
  "Siddhakala School of Nursing, Pimparne Road, Sangamner Khurd,",
  "LATE RAMRAOJI ZANAK COLLEGE OF PHARMACY AND RESEARCH CENTER, KENWAD",
  "Mahalaxmi Nusing school, Tumsar, Bhandara",
  "MARATHWADA INSTITUTE OF PHARMACY, LONI BK, TAL ARDHAUR, DIST NANDED",
  "KOHINOOR INSTITUTE OF PHARMACY, VASANGAON, LATUR",
  "VIVEKANAND EDUCATION SOCIETYS BUSINESS SCHOOL",
  "SVIMS BUSINESS SCHOOL",
  "SARVODAYA COLLEGE OF PHARMACY",
  "PUNE INSTITUTE OF MANAGEMENT STUDIES",
  "BHARTIYA NURSING COLLEGE",
  "A G INSTITUTE OF NURSING",
  "LATE ARVIND GAIKWAD SCHOOL OF NURSING",
  "SANJIVANI PRATHISTHAN ENGLISH DED COLLEGE AT POST KURUND POST RALEGAN THERPAL TALUKA PARNER AHMEDNAGAR",
  "6722-SHRI SOMESHWAR SHIKSHAN PRASARAK MANDALS, SHARADCHANDRA PAWAR ISTITUTE OF TECHNOLOGY ,SOMESHWARNAGAR TAL-BARAMATI, DIST-PUNE",
  "PUNE INSTITUTE OF BUSINESS MANAGEMENT FOR PGDM",
  "Lexicon Management Institute of Leadership and Excellence",
  "IAEER PIBMS INSTITUTE OF PGDM",
  "MAHARSHI KARVE STREE SHIKSHAN SAMSTHA'S SMT BAKUL TAMBAT INSTITUTE OF NURSING EDUCATION PUNE",
  "TUKAI GNM NURSING SCHOOL",
  "INDIRA GANDHI NURSING SCHOOL, OSMANABAD",
  "BAL VIKAS MAHILA MANDALS SCHOOL OF NURSING",
  "MAGAS JANSEVA SAMITI BHIVRAI NURSING SCHOOL",
  "BHARATRATNA MOTHER TERSA NURSING SCHOOL SELU DIST PARBHANI",
  "HEALTH CARE NURSING SCHOOL  AAMGAO",
  "S M NURSING SCHOOL",
  "POOJA NURSING SCHOOL NAGPUR",
  "SHRI SAI SAMARTH INSTITUTE OF PHARMACY",
  "TILAK MAHARASHTRA  VIDYAPEETH INSTITUTE OF NURSING EDUCATION AND RESEARCH PUNE",
  "NURSING TRAINING CENTER GENERAL HOSPITAL GADCHIROLI",
  "ARNEJA INSTITUTE OF NURSING SCIENCES NAGPUR",
  "JAY INSTITUTE OF NURSING  INDAPUR",
  "RAJMATA JIJAU NURSING SCHOOL   WAKHARI   PANDHARPUR",
  "DNYANAI INSTITUT OF NURSING RANM KAREGAON  PARBHANI",
  "APURVA NURSING INSTITUTE  VIDYA VIHAR SANKUL RAVALGAO ROAD SELU DISTPARBHANI",
  "G M INSTITUTE OF NURSING JAMNER",
  "YASHWANT INSTITUTE OF NURSING SCHOOL",
  "MATOSHRI NURSING SCHOOL",
  "Shalinitai Meghe college of nursing salod hirapur wardha",
  "Kalpana Chawala Nursing School Parbhani",
  "SAI NURSING INSTITUTE BABHALESHWAR",
  "Late S D Maske school of nursing hingoli",
  "The Yash Foundations College of Nursing and Medical Research Institute Ratnagiri",
  "2616 SHRI AMOLAK JAIN VIDYA PRASARAK MANDAL`S PHARMACY COLLEGE KADA ASHTI BEED",
  "2595 UTTAMRAO DESHMUKH INSTITUTE OF PHARMACY BALSOND TAL DIST HINGOLI",
  "1293-SHRADDHA INSTITITE OF PHARMACY",
  "6957-ASHOKRAO MANE INSTITUTE OF PHARMACY AMBAP",
  "4199-SMT KISHORITAI BHOYAR COLLEGE OF PHARMACY D PHARM",
  "5411-AL JAMIA MOHAMMEDIYAH EDUCATION SOCIETY MAULANA MUKHTAR AHMAD NADVI TECHNICAL CAMPUS",
  "6365-SHARADCHANDRA PAWAR INSTITUTE OF PHARMACY",
  "Shakuntala Nursing School Mudkhed Tq Mudkhed District Nanded",
  "GRAMIN SHIKSHN PRASARAK MANDAL PADMAVATI NURSING SCHOOL",
  "P P COLLEGE OF NURSING LATUR",
  "ISBM SCHOOL OF COMMUNICATION AND MEDIA MANAGEMENT",
  "LATE SHRI S B PURUSHOTTAM COLLEGE OF PHARMACY, PATUR",
  "2579-D.K. Patil Institute of Pharmacy, Loha, Nanded",
  "JAI BHAGWAN COLLEGE OF EDUCATION KALWA (W) THANE",
  "JANAKI INSTITUE OF NURSING  EDUCATION",
  "NTVS ADHYAPAK VIDYALAYA NANDURBAR",
  "SCHOOL OF NURSING BEED",
  "ASMs Institute of Business Management and Research(PGDM), Pune",
  "SHIKSHAN SHASTRA VIDYALAYA CHOPDA JALGAON",
  "SHRI DEOPUR VIDHAYAK SAMITI WALWADI",
  "5460-Dr. Kolpe Institute of Pharmacy, Kolpewadi",
  "5463-K.K. WAGH INSTITUTE OF PHARMACY, CHANDORI, TAL.NIPHAD, DIST. NASHIK",
  "2597-MDA SCHOOL OF PHARMACY",
  "5465-RATNADEEP COLLEGE OF PHARMACY(D.PHARM)JAMKHED(RATNAPUR)TAL.JAMKHED DIST.AHMEDNAGAR(MS)",
  "HARINAIK D. ED. COLLEGE MANTHA JALNA",
  "Dr.KULLOLLI INSTITUTE OF NURSING SCIENCES VISHRAMBAG, SANGLI",
  "ADITYA BAHU-UDDESHIYA SANSTHAS ADITYA DIPLOMA IN EDUCATION (D. ED. ) COLLEGE KASBE BEED BOBDE TARAF BEED",
  "ADITYA JUNIOR COLLEGE OF EDUCATION SELU PRABHANI",
  "ADIVASI SEVA SAHAYAK AND SHIKSHAN PRASARAK SANSTH NAVAPUR DHULE",
  "ADV. H. N. PATIL D. ED. COLLEGE DISTRICA JALGOAN",
  "AGHAV JR. COLLEGE OF EDUCATION DHULIA STATION ROAD DHULE",
  "AHMEDNAGAR EDUCATION SOCIETY JR. COLLEGE OF EDUCATION AHMEDNAGAR SATBHAI MALA AHMEDNAGAR",
  "A. K. I. JUNIOR COLLEG OF EDUCATION KURLA MUMBAI",
  "Akshay Institute Of Nursing,Nanded",
  "AL-AMEEN JR. COLLEGE OF EDUCATION JALKOT ROAD UDGIR LATUR",
  "ALHAJ ATHAR MIRZA URDU D. ED. COLLEGE KALAMNURI HINGOLI",
  "AL-INAM-MADARSA & SOCIAL WELFARE EDUCATION SOCIETY JAISTAMBH CHOWK AMRAVATI",
  "ALLANA URDU D.T.ED COLLEGE KUNJKHEDA",
  "ALL INDIA KHILAFAT COMMITTEE JUNIOR COLLEGE OF EDUCATION",
  "A.M.MARATHI JUNIOR COLLEGE OF EDUCATION(D.EL.ED.)",
  "AMRAVATI GENERAL HOSPITAL AMRAVATI",
  "ANAND GRAM KRISHI VIKAS MANDALS TQ. BHOOM OSMANABAD",
  "ANANDI SHIKSHAN PRASARAK MANDAL MOUJE SANGAON TAL KAGAL KOLHAPUR",
  "ANAND RISHIJI INSTITUTE OF NURSING AHMEDNAGAR",
  "ANANT SHIKSHAN SANSTHAKUNDALIKRAO NAGARE ADHYPAK VIDALAYA D. ED TQ. RISOD WASHIM",
  "ANGLO JUNIOR COLLEGE OF EDUCATION KALI MUJID ROAD NANDURBAR",
  "3463-Urja Education Society's Aditya Polytechnic, Ratnagiri",
  "2206-ADARSH SHIKSHAN SANSTA`S COLLLEGE OF PHARMACY BEED",
  "4271-Jai Mahakali Shikshan Sanstha's Agnihotri Institute of Diploma in Pharmacy, Wardha",
  "5362-Shiva Trust's Ajitdada Pawar College of polytechnic,Vadala Mahadeo, Tal Shrirampur, Ahmednagar",
  "5420-Akole Taluka Education Society's Faculty of Polytechnic, Akole",
  "5363-Amruta Vaishnavi Education & Welfare Trust's Shatabdi Institute of Technology, Agastkhind, Tal Sinner",
  "5232-Amrutvahini Sheti & Shikshan Sanstha's Amrutvahini Polytechnic, Amrutnagar",
  "6024-BHARTI VIDYAPEETHS INSTITUTE OF PHARMACY (AIDED WING) PUNE",
  "2220-Anandgram Krushi Vikas Mandals Late Maharudra Bappa Mote College of Pharmacy, Girwali Tal. Bhoom",
  "4223-Anjuman Hami-E-Islam's Anjuman Polytechnic, Nagpur",
  "3278-Anjuman-I-Islam's Abdul Razzak Kalsekar Polytechnic,Panvel, Navi Mumbai",
  "4226-Ankush Shikshan Sanstha's G.H. Raisoni Polytechnic, Nagpur",
  "ARYAN EDUCATION SOCIETY VANITA VINAYALAY JR. COLLEGE OF EDUCATION SHANKARSHET MUMBAI",
  "ASHAPURI SHIKSHAN PRASARAK MANDAL KOTKAR D. ED. COLLEGE TAL. CHALISGAON JALGAON",
  "ASMITA SHAIKSHANIK SANSKRUTIK & SAMAJIK SANSTHA TALAND DHULE",
  "ATAPADI EDUCATION SOCIETY TOWN-ATPADI SANGLI",
  "A. T. T. JR. COLLEGE OF EDUCATION MALEGAN NASHIK",
  "CHANDRAVATI EDUCATIONAL FOUNDATION",
  "BABASAHEB DHABEKAR URDU ADHYAPAK VIDYALAYA AKOLA AKOLA",
  "BABURAO MUNDE(PATIL) COLLEGE DEVGAON BEED",
  "ADARSH SHIKSHAN PRASARAK SANSTHA JR. COLLEGE OF EDUCATION AT & PO. KHED OSMANABAD",
  "CHATARPATI PRAMILE RAJE GENERAL HOSPITAL KOLHAPUR",
  "CHETANA ADHYAPAK VIDYALAYA WARDHA NEAR BORGAON NAKA WARDHA",
  "ADARSH SHIKSHAN PRASARK MANKALS K. T. PATIL D. ED. BHOSALE HIGH-SCHOOL CAMPUS OSMANABAD",
  "CHETANA'S INSTITUTE OF MANAGEMENT AND RESEARCH",
  "CHINDHUJI LAXMANRAO PURKE SHIKSHAN PRASARAK MANDAL RALEGAON YAVATMAL",
  "CHINTAMANI D. ED. COLLEGE POMBHURNA CHANDRAPUR",
  "ADHAYAPAK VIDYALAYA (D.ED) ASHOKRAO MANE VIDYANAGAR PETHVADGAON, KOLHAPUR",
  "Chirayu Smt. Kaushalyadevi Bajaj Adhyapak Vidhyalaya MOUZA MANKAPUR NAGPUR",
  "CHOPDA EDUCATION SOCIETY COLLEGE OF EDUCATION OLD SHIRPUR ROAD CHOPDA",
  "CITIZEN EDUCATIONAL & WELFARE COUNCIL ALLAMA EQBAL D. ED. COLLEGE DAULATABAD AURANGABD",
  "ADHYAPAK VIDAYLAY, NASHIK",
  "CITIZENS EDUCATION SOCIETY RASTHARIYA JR. COLLEGE OF EDUCATIOIN KRIDA CHOWK NAGPUR",
  "CITIZEN WELFARE SOCIETYS SARDAR COLLEGE OF EDUCATION BUDHWAR WARD NASHIK",
  "CIVIL HOSPITAL SCHOOL OF NURSING JALGAON",
  "ADHYAPAK VIDHYALAYA CHARE SOLAPUR",
  "C. P. COLLEGE OF D. ED. DREGAON ROAD JALNA",
  "DALIT MITRA V. T. NAGPURE D. ED. COLLEGE GONDPIPRI CHANDRAPUR",
  "ADHYAPAK VIDYALAYA EKHATPUR SOLAPUR",
  "Damayantitai Deshmukh D.Ed. College Mouda Road Ramtek Nagpur",
  "Chembur Sarvankash D.Ed Vidyalaya",
  "D. ED. COLLEGE SAGAON SAGAON SANGLI",
  "ADHYAPAK VIDYALAYA GIRVI TAL-PHALTAN SATARA",
  "D. ED. URDU ADYAPAK VIDYALAYA GOUDAWN NAGPUR",
  "DEEP PARAMEDICAL ORGNAISATION PANDURANG VADE KASARVADAVLI THANE",
  "DEOMOGRA SCHOOL OF NURSING NANDURBAR",
  "ADHYAPAK VIDYALAYA JARUD AMRAVATI",
  "DES Institute of Management Development and Research",
  "DHANRAJGIRIJI HOSPITAL TRUST SOLAPUR",
  "ADHYAPAK VIDYALAYA KHADAK PURA, BEED",
  "Dhareshwar Vidya Va krida Pratisthans Dhareshwar Institute of Nursing",
  "2291-MGMS POLYTECHNIC AURANGABAD",
  "ADHYAPAK VIDYALAYA RAJAPUR (AMBEWADI) RATNAGIRI",
  "DHYANOPASAK SHIKSHAN MANDALS PRIMARY TEACHERS TRAINING D. ED. COURSE NEAR Z. P PARBHANI",
  "Dileep Ekambekar D.T.ED College Udgir",
  "ADHYAPAK VIDYALAYA SHAHADA NANDURBAR",
  "6020-Cusrow Wadia Institute of Technology( Aided ), Pune",
  "6515-Chaudhary Attarsingh Yadav Memmorial Education Trust's Siddhant College Of Pharmacy, Sudumbare, Maval",
  "ADHYAPAN PADVIKA PRASHISTHAN JUNIOR COLLEGE OF EDUCATION SHIVAJI NAGAR YAVATMAL",
  "6026-DAKSHIN SOLAPUR TALUKA SHIKSHAN MANDAL'S COLLEGE OF PHARMACY (POLY) SOLAPUR",
  "6457-Dattakala Shikshan Sanstha's, Dattakala Polytechnic, Daund Dist. Pune",
  "ADHYAPIKA VIDYALAYA BARSHI, SOLAPUR",
  "4229-Bajaj Chandrapur Polytechnic, Chandrapur",
  "3466-Devi Mahalaxmi Polytechnic, Titwala, Kalyan",
  "ADHYPAK JUNIOR COLLEGE OF EDUCATION TASGAON SANGLI",
  "4258-Dharampeth Education Soceity's Dharampeth Polytechnic, Nagpur",
  "6428-BMSPM's Ashokrao Mane Polytechnic, Vathar Tarf Vadgaon",
  "ADI JANTA VIDHYA PRASARAK MANDAL TAL. SHIRPUR SHIRPUR",
  "3260-Khalapur Taluka Shikshan Prasarak Mandal's, B.L. Patil Polytechnic, Khopoli, Dist.Raigad",
  "2215-Shri Vishweshwar Shikshan Prasarak Mandal's Swa.Dagdojirao Deshmukh D.Pharmacy College, Ausa,(Almala) Dist. Latur",
  "3007-Government Polytechnic, Mumbai",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING AMAJOGAI BEED",
  "ADILOK DTED COLLEGE GOREGAON, GONDIA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BULDHANA BULDHANA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, CHANDRAPUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KOLHAPUR KOLHAPUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING DHULE DHULE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING GADCHIROLI GADCHIROLI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING GODHANI ROAD YAVATMAL",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING JALGAON JALGAON",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING JAWAHAR THANE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING LONI KALBHOR, PUNE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING MURUD LATUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, NANDURBAR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, NASHIK",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING OLD D. ED. COLLEGE, AKOLA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING PARBHANI PARBAHANI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING PARDESHPURA AHMEDNAGAR",
  "GEETA SHIKSHAN PRASARAK MANDAL JAITALA ROAD NAGPUR",
  "GENBA SOPANRAO MOZE JUNIOR COLLEGE OF EDUCATION YERWADA PUNE",
  "GOVT. URDU JR. COLLEGE OF EDUCATION BALAPUR AKOLA",
  "DR. BABASAHEB AMBEDKAR KHADI GRAMOUDYOG SANGH MANGALWEDHA, SMT. GEETA BANKAR ADHYAPAK VIDYALAYA, SANGOLA",
  "GOVT. URDU JR. COLLEGE OF EDUCATION FOR WOMEN BHAVANI PETH PUNE",
  "GRAMIN YUVAK VIKAS SHIKSHAN MANDAL CHILLI BULDHANA",
  "DR. BABASAHEB AMBEDKAR SMARAK SAMITI PEER BAZAR AURANGABD",
  "GRAM SUDHAR YOJANA NARKHED NAGPUR",
  "GRAMVIKAS SHIKSHAN PRASARAK MANDAL CHINCHOLI SOLAPUR",
  "DR. B. R. AMBEDKAR JR. COLLEGE OF EDUCATION (D. ED. ) BORADI BORADI DHULE",
  "GULABRAO PATIL MEMORIAL TRUST D ED COLLEGE, MIRAJ",
  "GULABRAO PATIL MEMORIAL TRUST'S SCHOOL OF NURSING SANGLI",
  "DR. D. S. PALIWAL JR. COLLEGE OF EDUCATION HIRAPUR AURANGABAD",
  "GURUDEV D.ED  COLLEGE,  JUNA DHAMANGAON",
  "GURUJAN JUNIOR COLLEGE OF EDUCATION PATAN SATARA",
  "3285-DNYAN PRASARAK SHIKSHAN SANSTHA'S, BALASAHEB MHATRE POLYTECHNIC,AMBARNATH",
  "GURUKRIPA COLLEGE OF EDUCATION & RESEARCH KALYAN (W) THANE",
  "GURUKUL D.T.ED.COLLEGE, BEED",
  "DR J J MAGDUM SCHOOL OF NURSING KOLHAPUR",
  "Guru Nanak College of Elementary Teacher Education BHANDUP MUMBAI",
  "GURUNANAK INSTITUTE OF MANAGEMENT STUDIES",
  "GURURAJ SCHOOL OF NURSING PUNE",
  "DR. KALPANA CHAWLA ANTRAL VIR D. ED. COLLEGE KONDHA KOSARA BHANDARA",
  "GYANODAYA SHIKSHAN PRACHRAKSAMITIS GYANODAYA ADYAP J. K. GRAM THANE THANE",
  "HADGAON TALUKA SHIKSHAN PRASARAK MANDAL HADGAON NANDED",
  "6411-Dr. J. J. Magdum Trust, Dr. J.J.Magdum Polytechnic, Jaysingpur, Kolhapur",
  "HAJI JAN MOHAMMED MOTIWALA IQRA JR. COLLEGE OF EDUCATION KHULTABA AURANGABAD",
  "4009-Government Polytechnic, Bramhapuri",
  "5007-Government Polytechnic, Dhule",
  "6483-Dr. J. J. Magdum Charitable Trust's Dr. J.J. Magdum Pharmacy College",
  "4010-Government Polytechnic, Gadchiroli",
  "6410-Dr. D. Y. Patil Pratishthan's, Yashwantrao Bhaurao Patil Polytechnic, Pune",
  "1139-Shree Shivaji Education Society's Dr. Panjabrao Deshmukh Girls Polytechnic, Amravati",
  "6800-DKTE SOCIETYS YASHWANTRAO CHAVAN POLYTECHNIC, ICHALKARANJI",
  "MAHILA ADHYAPAK VIDYALAYA BEED BEED",
  "6715-Dnyan Kala Krida & Krushi Pratishan,Babasaheb Phadtare Polytechnic, Kalamb Walchandnagar, Tal-Indapur, Dist. Pune",
  "4641-Dr.Babasaheb Ambedkar Institute of D-Pharmacy, Sewagram, Wardha",
  "4011-Government Polytechnic Gondia",
  "2012-Government Polytechnic, Hingoli",
  "6441-Dr.D.Y.Patil Educational Academy's D. Y. Patil Polytechnic, Ambi., Talegaon",
  "2014-Government Polytechnic, Jalna",
  "6016-Government Polytechnic, Karad",
  "6225-Dattajirao Kadam Technical Education Society's Textile & Engineering Institute, Ichalkaranji.",
  "1009-Government Polytechnic, Khamgaon",
  "6010-Government Polytechnic, Kolhapur",
  "3010-Government Polytechnic, Malvan",
  "INDIRA SCHOOL OF BUSINESS STUDIES PGDM",
  "1006-Government Polytechnic, Murtijapur",
  "2017-Government Polytechnic, Nanded",
  "5009-Government Polytechnic, Nandurbar",
  "2018-Government Polytechnic, Osmanabad",
  "3008-Government Polytechnic, Pen",
  "6013-Government Polytechnic, Pune",
  "DR. ZAKIR HUSSAIN URDU JR. COLLEGE OF EDUCATION MOMINPURA",
  "3009-Government Polytechnic, Ratnagiri",
  "4008-Government Polytechnic, Sakoli",
  "6786-Dr. D. Y. Patil School of Engineering & Technology, Charholi(Bk), Via Lohgaon, Pune",
  "6017-Government Polytechnic, Solapur",
  "3013-GOVERNMENT POLYTECHNIC, VIKRAMGAD",
  "1010-GOVERNMENT POLYTECHNIC WASHIM",
  "Durgadevi Saraf Institute of Management Studies",
  "6014-GOVERNMENT RESIDENT WOMEN'S POLYTECHNIC TASGAON SANGLI",
  "DUSANE EDUCATION SOCIETY VIDYALAY & HARIBHAU DHULE",
  "2171-Gramodyogik Shikshan Mandal's Marathwada Institute Of Technology, Rotegaon, Vaijapur, Dist. Aurangabad.",
  "4601-GURUVANDAN MAHILA KALYANKARI BAHUUDDESHIYA MANDAL'S GURU SAI POLYTECHNIC COLLEGE MAUZA DATALA CHANDRAPUR",
  "DWARKAMAI SARVANGIN VIKAS SANSTHA D. S. PATIL ADHYAPAK VIDYALAY DHULE DHULE",
  "5240-Guru Gobind Singh Foundation's Guru Gobind Singh Polytechnic, Nashik",
  "6497-GULABRAO PATIL MEMORIAL TRUST, GULABRAO PATIL COLLEGE OF PHARMACY, MIRAJ",
  "GURUDATTA VIKAS SHIKSHAN SANSTHA CHAKUR LATUR",
  "2186-GUNAI SHIKSHAN PRASARAK MANDAL RAJIV GANDHI POLYTECHNIC UDGIR DIST LATUR",
  "LATE KAMALABAI AJMERA ADHYAPAK VIDYALYA STATION ROAD NANDURBAR",
  "LATE LILAWATI SATISH AWHAD EDUCATION SOCIETY D. ED. COLLEGE . MUKHED NANDED",
  "KAI. SOU. INGETROUT NAIK COLLEGE OF EDUCATION KANAKVALI SINGHUDDURG",
  "LATE NIRDHANRAO PATIL WAGHAYE ADHYAPAK VIDYALAYA TUMSAR BHANDARA",
  "Late Raghunathraoji Kendre Institute Of Nursing(GNM) ,Parali-Vaijanath",
  "5379-JAMIA ISALAMIA ISHA-ATUL ULOOM`S JAMIA COLLEGE OF PHARMACY AKKALKUWA",
  "LATE SHRI GOVINDRAO WANJARI COLLEGE OF EDUCATION SAKKARDARA CHOWK NAGPUR",
  "LAXMINARAYAN COLLEGE OF PHARMACY",
  "LATE SHRI LAXMANJI MOTGHARE CHARITABLE TRUST (WADSA) GADCHIROLI",
  "LATE SHRI RAM MEGHE ADHYAPAK VIDYALAYA BORGAON WARDHA",
  "6487-JAYAWANT SHIKSHAN PRASARAK MANDAL'S JAYAWANT INSTITUTE OF PHARMACY PUNE",
  "LATE SMT. THAKUBAI H. GHADGE PATIL RURAL DED NEWASA AHMEDNAGAR",
  "LATE TANHABAI KEDAR DED COLLEGE KASAR BEED",
  "6425-JAYWANT SHIKSHAN PRASARAK MANDALJAYWANTRAO SAWANT POLYTECHNIC HADAPSAR PUNE",
  "LATE UDHAVRAO TULSHIRAM JADHAVAR FOUNDATION INSTITUTE OF NURSING PUNE",
  "LATE USHATAI NURSING SCHOOL, KOLHAPUR",
  "LATE VASANTRAO KALE D. ED. COLLEGE BARSHI ROAD LATUR",
  "5269-Jijamata Education Society's College of Pharmacy, Nandurbar",
  "Laxmi Prabha Nursing College",
  "Maharashtra Cosmopolitan Education Societys Junior College of Education.",
  "5283-Jijamata Vidyapeeth's Shree. P.E.(Tatya) Patil Institute of Pharmacy, Jalgaon",
  "LET HEERAMAN SONU JAT EDUCATION SOCIAL MANDAL KULTHE DHULE",
  "LOKJAGRATI SHIKSHAN PRASARAK MANDAL RAPKA LATUR",
  "5260-JUMMA MASJID CHARITABLE TRUST'S POLYTECHNIC WADALA ROAD WADALA NASHIK",
  "LOKMANYA TILAK MUNICIPAL GENERAL HOSPITAL MUMBAI",
  "LOKSEVA BAHUDESHIYA SEVA MANDAL C. N. WASNIK ADHYAPAK LAKHANDUR RA LAKHANDUR BHANDARA",
  "LOKSEVA BAHUVUDDESHIYA SEVABAHAVI SANSTHA LATUR LATUR",
  "6446-KAI. AMDAR BRAMHADEVDADA MANE SHIKSHAN VA SAMAJIK PRATISHTHANBRAMHADEVDADA MANE POLYTECHNIC BELATI NOTH SOLAPUR",
  "LONESHWAR GRAMIN VIKAS MANDAL JUNIOR COLLEGE OF EDUCATION LONI HAVELI AHMEDNAGAR",
  "MAA GANGA NURSING SCHOOL, WASHIM",
  "MAA GAYATRI SCHOOL OF NURSING AMRAVATI",
  "2288-Kai Haribhai Varpudkar Gramin Mahila Sevabhavi Sanstha's LATE. HARIBAI WARPUDKAR POLYTECHNIC, PARBHANI",
  "5246-KAI. VANJIBABA GRAMIN VIKAS MANDAL SHANTIDEVI CHAVHAN INSTITUTE OF ENGINEERING & TECHNOLOGY CHALISGAON",
  "KAI. WANCHALABAI GHUMARE SHIKSHAN PRASARAK MANDAL GEORAI BEED",
  "NATIONAL INSURANCE ACADEMY, PUNE",
  "KAI. YASHODABAI DAGADU SARAF CHARITABLE TRUST SAKEGAON JALGAON",
  "KALYAN INSTITUTE OF NURSING EDUCATION",
  "Kalyani Nursing School",
  "KAMAL INSTITUTE OF NURSING EDUCATION JATH, SANGLI",
  "KAMDHENU BAHU UDDESIYA SEVABHAVI SANSTHA D. ED. COLLEGE AURANGABAD AURANGABAD",
  "KAMLA NEHRU JUNIOR COLLEGE OF EDUCATION KARAD SATARA",
  "KAMLA NEHRU URDU D. ED. COLLEGE MALKAPUR BULDANA",
  "MADARSA DARUL YATAMA URDU D.T.ED. COLLEGE PIPLA. DH. TQ. AMBAJOGAI",
  "KARMAVEER SHIKSHAN PRASARK MANDAL MAHATMA PHULE MARG BEED",
  "MADHUKARRAO MAHAKALKAR NURSING SCHOOL (RANM), NAGPUR",
  "MADHURIBAI DESHMUKH INSTITUTE OF NURSING EDUCATION NAGPUR",
  "MAEER MIT'S SRI SAVITRIBAI PHULE POLYTECHNIC",
  "MAHALUNGE GRAM VIKAS SAMITI TRUST MAHALUNGE PUNE",
  "MAHARAJA MADHAVRAO SHINDE JAMGAON AHMEDNAGAR",
  "Maharani Shantadevi Gaikwad Grihashtra Shikshan Sansthas Adhyapika Vidyalaya",
  "4234-LATE M.D. YERGUDE MEMORIAL SHIKSHAN PRASARAK MANDAL'S SHRI SAI POLYTECHNIC CHANDRAPUR",
  "4253-LATE SHRI LAXMAJI MOTGHARE CHRITABLE TRUST'S DR. ARUN MOTGHARE POLYTECHNIC KOSARA-KONDA BHANDARA",
  "KARMAVIR TATHYASAHEB HARI RAVAJI PATIL BHADGAON JALGAON",
  "4247-LAXMANRAO MANKAR COLLEGE OF POLYTECHNIC AMGAON GONDIA",
  "3286-LEELA EDUCATION SOCIETY G. V. ACHARYA POLYTECHNIC SHELU KARJAT.",
  "KARMAVIR VITHAL RAMAJI SHINDE SHIKSHAN SANSTHA GADHINGLAJ KOLHAPUR",
  "4164-LOKMANYA TILAK JANKALYAN SHIKSHAN SANSTHA'S J.L.CHATURVEDI COLLEGE OF PHARMACY(DIPLOMA) NAGPUR",
  "6448-LOKNETE MA.HANUMANTRAO PATIL CHARITABLE TRUST ADARSH INSTITUTE OF TECHNOLOGY (POLY) KHAMBALE",
  "KARMAYOGI SHRI.H.R.KAWCHALE ADHYAPAK VIDYALAY, SOLAPUR",
  "6513-LOKSEVA PRATISTHAN`S LOKSEVA COLLEGE OF PHARMACY PHULGAON HAVELI PUNE",
  "6403-Latthe Education Society's Polytechnic, Sangli",
  "MAHARASHTRA ADHYAPAK VIDYALAYA AHMEDNAGAR AHMEDNAGAR",
  "KASAMADE PARISAR VIKAS MANDALS DEOLA DEOLA",
  "Maharashtra Adyapak Vidyalaya, Nilanga",
  "MAHARASHTRA HOMEOPATHIC FOUNDATION SCHOOL OF NURSING, SANGAMNER PATHAR",
  "KHANDESH UNION EDUCATION SOCIETY JALGAON JALGAON",
  "MODERN EDUCATION SOCIETYCOLLEGE OF EDUCATION KHANAPUR KHANAPUR",
  "MOHAMMED KHALID JUNIOR COLLEGE OF EDUCATION TARAPUR THANE",
  "MORESHWAR SHIKSHAN PRASARAK MANDAL NEW COLLEGE OF D. ED. BHOKARDAN JALNA",
  "Muktai D.T.ED. College,Vambori,Tal.Rahuri,Dist.Ahemednagar",
  "MULA EDUCATION SOCIETY NEWASA",
  "MULA EDUCATION SOCIETY NEWASA AHMEDNAGAR",
  "NEW AZEEM URDU D. ED. COLLEGE URDU EDUCATION SOCIETYS QUAISER COLONY AURANGABAD",
  "5227-NAGAON EDUCATION SOCIETY'S GANGAMAI POLYTECHNIC NAGAON",
  "MULSHI INSTITUTE OF BUSINESS MANAGEMENT-POST GRADUATEDM",
  "5293-NAGAON EDUCATION SOC INSTITUTE OF PHARMACY NAGAON DHULE",
  "4224-Shri Datta Meghe Polytechnic, Nagpur",
  "MULSHI INSTITUTE OF RETAIL MANAGEMENT",
  "6473-NANASAHEB MAHADIK POLYTECHNIC INSTITUTE",
  "2026-Shri Sharda Bhavan Education Society's Nanded Pharmacy College (Polytechnic), Nanded",
  "MUMBRA TEACHER TRAINING JR. COLLEGE OF EDUCATION MUMBRA",
  "5243-NASHIK GRAMIN SHIKSHAN PRASARAK MANDALS BRAHMA VALLEY POLYTECHNIC NASHIK",
  "5375-NATH NANGEBABA MALTI PURPOSE MANDAL'S POLYTECHNIC PAROLA DIST-JALGAON",
  "5274-NASHIK DISTRICT MARATHA VIDYA PRASARAK SAMAJ'S INSTITUTE OF PHARMACEUTICAL SCIENCES ADGAON NASHIK",
  "MUNCIPAL URDU TEACHERS JR. COLLEGE OF EDUCATION MAHIM MUMBAI",
  "2208-NAVGAN SHIKSHAN SANSTHA`S P V P COLLEGE OF PHARMACY PATODA BEED",
  "MURE MEMORIAL HOSPITAL SCHOOL OF NURSING NAGPUR",
  "5296-NAVMAHARAHSTRA SHIKSHAN MANDAL`S ABASAHEB KAKADE PHARMACY COLLEGE BODHEGAON AHMEDNAGAR",
  "3294-NATIONAL CENTRE FOR RURAL DEVELOPMENT'S INSTITUTE OF PHARMACY NERUL NAVI MUMBAI",
  "2028-MARATHWADA SHIKSHAN PRASARAK MANDAL'S SHRI SHIVAJI INSTITUTE OF PHARMACY PARBHANI",
  "3142-NAVJEEVAN EDUCATION SOCIETY'S POLYTECHNIC MUMBAI",
  "4612-NAVNEET BAHUUDDESHYA SANSTHA KINKAR INSTITUTE OF TECHNOLOGYSELOODIST.WARDHA",
  "5256-MATOSHRI EDUCATION SOCEITY MATOSHRI ASARABAI POLYTECHNIC NASHIK",
  "1159-NAVSANJIVAN SHIKSHAN MANDAL`S COLLEGE OF PHARMACY DHARWA",
  "5254-OM SAI SHIKSHAN PRASARAK SANSTHA'S AAMDAR KASHINATHJI MENGAL POLYTECHNIC IGATPURI NASHIK",
  "5263-MATOSHRI EDUCATION SOCEITY MATOSHRI INSTITUTE OF TECHNOLOGY DHANORE NASHIK",
  "5247-NDMVPS SAMAJ'S RAJARSHEE SHAHU MAHARAJ POLYTECHNIC NASHIK",
  "3292-NAVYUG VIDYAPEETH TRUST'S INSTITUTE OF PHARMACYMAHAD RAIGAD",
  "3422-NEW JAI BHARAT SHIKSHAN PRASARAK MANDAL?S SHANTINIKETAN POLYTECHNIC NEW PANVEL.",
  "4242-MATA MAHAKALI BAHUUDDESHIYA SHIKSHAN PRASARAK MANDAL'S MATA MAHAKALI POLYTECHNIC COLLEGE WARORA",
  "6725-NEW SATARA SHIKSHAN SANKUL NEW SATARA COLLEGE OF ENGINEERING & MANAGEMENT PANDHARPUR",
  "Rajiv Gandhi D.Ed.College Chandrapur",
  "2194-MATOSHRI PRATISHTHAN VISHWABHARATI POLYTECHNIC INSTITUTE VISHNUPURI",
  "6729-NINAIDEVI SHIKSHAN PRASARAK MANDALSHRI. SHIVAJIRAO DESHMUKH INSTITUTE OF TECHNOLOGY SHIRALA SANGLI",
  "3307-NAGRIK SHIKSHAN SANSTHA.S COLLEGE OF PHARMACY",
  "2022-MAULANA AZAD EDUCATION SOCIETY'S KAMLA NEHRU POLYTECHNIC(PHARMACY) AURANGABAD",
  "4248-Shri Sai Shikshan Sanstha's Nit Polytechnic, Nagpur",
  "2198-NUTAN VIDYA SAMITI SITARAMJI MUNDADA MARATHWADA POLYTECHNIC PARBHANI",
  "1015-Government Polytechnic , Achalpur",
  "6810-The Great Maulana Abul Kalam Azad Minority Educational Trust's Maulana Azad Polytechnic, Solapur",
  "6632-Navsahyadri Education Society's Group of Institutions(Polytechnic)",
  "ORIENTAL SCHOOL OF BUSINESS",
  "6488-MAYANI BHAG SHIKSHAN PRASARK MANDAL'S COLLEGE OF PHARMACY (D.PHARM.) MAYANI TAL-KHATAV DIST-SATARA.",
  "OZAR VIKAS SANSTHAS VISHWASATTYA D. ED. COLLEGE NIPHAD NASIK",
  "PALLAVI ADHYAPAK VIDYALAYA TRIMURTI CHOWK NAGPUR",
  "6463-MOKASHI KRISHI VIKAS PRASISTHAN'S DADASAHEB MOKASHI POLYTECHNIC SADASHIVGAD SATARA",
  "PAL RAJENDRA EDUCATION TRUSTS PAL RAJENDRA D. ED. COLLEGE KANDIVLI (EAST) MUMBAI",
  "PANCHGANGA SHIKSHAN PRASARAK MANDAL SHRI S. K. PATIL D. ED. COLLEGE KARVEER KOLHAPUR",
  "3293-MUMBAI EDUCATION TRUST'S INSTITUTE OF PHARMACY MUMBAI",
  "PANCH RATNA JUNIOR COLLEGE OF EDUCATION TAL URAN RAIGAD",
  "PANDURANG DESAI JR. COLLEGE OF EDUCATION KUSUR KUSUR SATARA",
  "PARIVARTAN ADHYAPAK VIDYALAYA TERKHEDA OSMANABAD",
  "5419-MAULI INSTITUTE OF TECHNOLOGY, AMALNER",
  "PARIVARTAN GRAMIN VIKAS MAHILA VA SHIKSHAN MANDAL SHRI RAMKRISHANA PARAMHANS COLLEGE OF BED SARASWATI COMPLEX PARBHANI",
  "PARKAR MEDICAL FOUNDATIONs SCHOOL OF NURSING, RATNAGIRI",
  "PARVATIBAI JR. COLLEGE OF EDUCATION KARVENAGAR PUNE",
  "5244-MET'S INSTITUTE OF TECHNOLOGY POLYTECHNIC BHUJBAL KNOWLEDGE CITY ADGAON NASHIK.",
  "PARVATIBAI MHASKE INSTITUTE OF NURSING AHMEDNAGAR",
  "PASCHIM MAHARASHTRA EDUCATION TRUST MITHANAGAR PUNE",
  "6496-Meruling Shikshan Sanstha's Diploma In Pharmacy, Medha,Satara",
  "NAVSAHAYADRI CHARITABLE TRUST D. ED. COLLEGE KHED PUNE",
  "RAJARAM SHIKSHAN SANSTHA VILASRAO SHINDE ADHYAPAK TALUKA WALWA SANGLI",
  "RAJA SHREE SHIVARAYA PRATISHTHAN ADHYAPAK VIDYALAYA KOTHRUD PUNE",
  "RAJE SAMBHAJI D T ED COLLEGE KINGAON",
  "SAKET COLLEGE OF EDUCATION KALYAN (E) THANE",
  "RAJIV BAHUDDESHIYA SHIKSHAN SASNTHA R. K. D. ED. COLLEGE KALAMB YAVATMAL",
  "RAJMATA JIJAN MAHILA ADHYAPAK VIDYALAYA BARSHI SOLAPUR",
  "SAKLESHWAR GRAMIN VIKAS SEVA SANSTHAN ADHYAP BALAKASHRAM BEHIND GURUKUL BUILDING LAL AHAMEDNAGAR AHAMEDNAGAR",
  "RAMAMATA AMBEDKAR ADHYAPIKA VIDYALAYA NILANGA LATUR",
  "RAMBAI NAVRANGE JR. COLLEGE OF EDUCATION GAVDEVI NANAR CHOWK MUMBAI",
  "RAMCHANDRA SANSKRITIK KRIDA MANDALS C. P. COLLEGE OF D. ED. DEVALGAONRAJA DEVALGAONRAJA BULDHANA",
  "RAMCHANDRA SANSKRITIK KRIDA MANDALS M. G. ROAD JALNA",
  "RAMDEOBABA DED COLLEGE SOUNDAD",
  "RAMESHWAR ADHYAPAK VIDYALAYA S. RAJA SINDKHED RAJA BULDANA",
  "RAMTEK SHIKSHAN VIKAS SANSTHA SAGAR D ED COLLEGE RAMTEK NAGPUR",
  "RASHTRAHIT EDUCATION SOCIETY CHIKHLI BULDHANA",
  "RASHTRIYA APANG ADHYAPAK VIDYALAYA SHAHAPUR THANE",
  "RASHTRIYA EAKATMATA SHIKSHAN PRASARAK MANDAL PURNA PURNA",
  "6721-Purogami Shikshan Mandal,Gauri Shiv Polytechnic, Khatav Dist - Satara",
  "SAKSHI SHIKSHAN KRIDA PRMAIN ROASARAK & BAHUUDESHIYA SANSTHA MURTIZAPUR AKOLA",
  "RATHE JR. COLLEGE OF EDUCATION ASTHA ASTHA SANGLI",
  "RAVI BAHUUDESHIYA SAIKSHANIK SANSTHA SIRASPETH NAGPUR",
  "RAVINDRA JR. COLLEGE OF EDUCATION HANUMAN NAGAR NAGPUR",
  "SALVE NURSING INSTITUTE FOR SCHOOL OF NURSING GADCHIROLI",
  "RAYAT SHIKSHAN SANSTHA JIJAMATA JUNIOR COLLEGE OF EDUCATION SATARA SATARA",
  "R. B. M. COLLEGE OF EDUCATION (SHRI DHANESHWARI CIDCO AURANGABAD",
  "R. B. T. JUNIOR COLLEGE OF EDUCATION TALUKA - KALYAN THANE",
  "SAMARTHA INSTITUTE OF EDUCATION ACHALPUR CITY AMRAVATI",
  "R. C. MARUTI ADHYAPAK VIDYALAYA ANDHERI (EAST) MUMBAI",
  "R. C. PATEL JR. COLLEGE OF EDUCATION SHIRPUR SHIRPUR DHULE",
  "R. C. TEACHERS COLLEGE OF EDUCATION MANDVI MUMBAI",
  "SAMARTH DNYANPEETH SOMESHWARNAGAR (WAGHALWADI) BARAMATI PUNE",
  "RENUKA EDUCATION SOCIETY RENUKA D. ED. COLLEGE SAONER NAGPUR",
  "RENUKA EDUCATION SOCIETY TILAK NAGAR LATUR",
  "SAMBHAJI RAO SHINDE VIDYAMANDIR MARARIPETH SOLAPUR",
  "RENUKAMATA KRISHI VIKAS PRATHISTHAN DR. VISHVANATH RAO KARAD D. ED. COLLEGE KAIJ BEED",
  "REYNOLDS MEMORIAL HOSPITAL AKOLA",
  "5291-R.C.Patel Edu. Trust's H.R. Patel Institute of Pharmacy, Shirpur, Dhule",
  "6406-Karmaveer Bhaurao Patil Polytechnic,Satara",
  "SAMPADA PRATISHTHAN ADARSH D. ED COLLEGE PARNER AHMEDNAGAR",
  "4262-Ravi Bahu-Uddeshiya Shikshan Sanstha's Ravi Institute Of Diploma In Pharmacy, Mahadula, Devi Road, Koradi",
  "2216-Sahayog Sevabhavi Sanstha's College of Pharmacy, Vishnupuri, Nanded.",
  "SAMRAT ASHOK ADHYAPAK VIDYALAYA CHALISGAON JALGAON",
  "3272-Ramrao Adik Education Society's Dr. D.Y.Patil Polytechnic, Nerul",
  "SANDIPANI CHARITABLE TRUST SANGLI VARAD VINAYAK D. ED. COLLEGE MIRAJ SANGLI",
  "2539-Rajesh Bhaiyya Tope College of Pharmacy, Aurangabad",
  "1147-Rambhauji Lingade Polytechnic College, Buldhana",
  "6511-Rajmata Jijau Shikshan Prasarak Mandal Institute Of Pharmacy,Haveli, Pune",
  "SANJIVANI RURAL EDUCATION SOCIETYS KOPARGAON AHMEDNAGAR",
  "6471-Ramkrishna Technical Education Soceity, Shivaji Polytechnic College, Sangola",
  "SCHOOL OF NURSING RATNAGIRI",
  "SANMARG SHIKSHAN SANSTHA TRIMURTY SQURE NAGPUR",
  "3420-Rajendra Mane Polytechnic, Devrukh, Tal. Sangmeshwar, Dist. Ratnagiri",
  "6524-Rameshwari Mauli Prathishtan of Bhalchnadra Institute of Pharmacy, Pune",
  "SANTAI EUCATION SOCIETY SAKRI DHULIYA",
  "6464-RAJARSHI SHAHU SHIKSHAN SANSTHA'S VITTHAL PATIL POLYTECHNIC MIRAJ",
  "SAHAYOG SEVABHAVI SANTHA COLLEGE OF EDUCATION VISHNUPURI NANDED",
  "SANT DNYANESHWAR D.ED COLLEGE BHANASHIVARE NEWASA",
  "SAHJEEVAN SHIKSHAN PRASARAK MANDAL PAROLA JALGAON",
  "SAHYADHRI SEVA SANSTHA SCHOOL OF NURSING NASIK",
  "SAINATH JR. COLLEGE OF EDUCATION GADCHIROLI GADCHIROLI",
  "SANT DNYANESHWAR SHIKSHAN SANSTHA ISLAMPUR WALWA SANGLI",
  "SAINT GADGEBABA SHIKSHAN PRASARAK MANDAL KRUSHI MAHARSHI GANGAKHED PARBHANI",
  "SANT GAJANAN MAHARAJ SHIKSHAN SANSTHA V. K. PATIL JUNIOR COLLEGE OF EDUCATION GODHINGLAJ KOLHAPUR",
  "SANT TUKADOJI SEVA PITH D. ED. COLLEGE ARNI YAWATMAL",
  "SANT TUKARAM EDUCATION MANDALS VADGAON MAVAL PUNE",
  "SANT TUKARAM INSTITUTE OF NURSING LATUR",
  "SHOEB COLLEGE OF EDUCATION (D. ED. ) KAUSA THANE",
  "5280-SANJIVANI RURAL EDUCATION SOCIETY'S SANJIVANI INSTITUTE OF PHARMACY AND RESEARCH KOPARGAON",
  "SHRAMJEEVI JUNIOR COLLEGE OF EDUCATION OMERGA OSMANABAD",
  "YASHOGATHA SHIKSHAN PRASARAK MANDAL RAMTEKPURA AKOLA",
  "6520-Sant Gajanan Maharaj Rural Hospital And Research Centre's Sant Gajanan Maharaj Rural Pharmacy College, Mahagaon, Kolhapur",
  "Shree Anant Smriti Charitable Trust kasals Institute of Nursing kasal",
  "SHREE DATTKRUPA SHAIKSHNIK AND KRISHI GRAM VIKAS PRATISTHAN SHRIGONDA AHMEDNAGAR",
  "SHREE GURUDEO JUNIOR COLLEGE OF EDUCATION GURUKUNJ ASHRAM AMRAVATI",
  "6545-Samarth Education Trust's Arvind Gavali College Of Engineering Panwalewadi, Varye,Satara",
  "SHREE NEMINATH JAIN BRAHMACHARYASHRAM JAIN GURUKUL CHANDWAD NASHIK",
  "SHREE SAMARTH ACADEMY SHREE SAMARTH JR. COLLEGE OF EDUCATION TAL PARNER AHMEDNAGAR",
  "SHREE SANTKRUPA SHIKSHAN SANSTHA SHREE SANTKRUPA KARAD SATARA",
  "SARVODAY SHIKSHAN SANSTHA JATH SANGLI",
  "SHREE SARASWATI NURSING SCHOOL (RANM)",
  "SHREE SWAMI SAMARTH NURSING COLLEGE (RGNM) KOLPEWADI AHMEDNAGAR",
  "SAU JEBELINA NURSING SCHOOL GARGOTI",
  "SHRI ABAJI NANA PATIL ELEMENTARY TEACHER EDUCATION D.ED JAMNER, JALGAON",
  "SHRI AMBABAI TALIM SANSTHAS SHETH R.V. GOSALIYA JR. COLLEGE OF EDUCATION, MIRAJ SANGLI",
  "SHRI AMBIKA MANDAL KAVATHE SANGLI",
  "SAU MINATAI THAKRE INSTITUTE OF NURSING EDUCATION THANE",
  "6388-Shri Appasaheb Birnale College of Pharmacy, Sangli",
  "6437-Shree Vitthal Edu. and Research Institute, College of Engineering (Polytechnic), Gopalpur, Pandharpur",
  "SAU. VATSALABAI AMRUTRAO PATIL ADHYAPAK VIDYALAYA JALGAON JAGALGAON",
  "SAVITRI BAI PHULE COLLEGE OF EDUCATION AKOT AKOLA",
  "2168-Shree Sai Samajik Vikas Sanstha, Nath Polytechnic, Paithan, Dist. Aurangabad",
  "SHRI KAHANYALAL MAHARAJ TRUST SAMODE AKRI DHULE",
  "5289-Shree Gurudatta shikshan sanstha's Pharmacy College, Kalwan, Dist. Nashik",
  "5356-Shree Samarth Academys, Shree Samarth Polytechnic, Mhasane Village Mhasane , Tal.Parner, Ahmednagar",
  "SAVITRIBAI PHULE SOCIETYS SMT. KASHIBAI NAVALE COLLEGE OF EDUCATION TALUKA SANGOLA SOLAPUR",
  "5238-Mahavir Polytechnic, Nashik",
  "SAW DADASAHEB UNDALKAR VIDHYALAYA KARAD SATARA",
  "SAYYAD SADAT EDUCATION SOCIETY SHIROL KOLHAPUR",
  "SCHOOL OF NURSING JALNA",
  "SCHOOL OF NURSING SADASHIV PETH PUNE",
  "SCHOOL OF NURSING SATARA",
  "SCHOOL OF NURSING WADGAON PUNE",
  "school of nursing, zashi rani chouk, General Hospital Wardha",
  "School of Public Health Nursing",
  "SCSES SMT. INDUMATI RAMCHANDRA DESHMUKH SCHOOL OF NURSING, SATARA",
  "2219-Shree Bhairavnath Nisarga Mandal's D. Pharmacy College, Aalani",
  "6432-Shivneri Foundation, Shivneri Polytechnic, Khanapur, Junnar, Pune",
  "SETH CHELLARAM ADHYAPAK VIDYALAYA ANKHAR THANE",
  "2174-Shree Bharavnath Nisarga Mandal, Diploma in Engineering and Technology, Gevrai Tanda, Aurangabad",
  "6126-Shree Santkrupa Shikshan Sanstha's College of Pharmacy(Diploma),Ghogaon,Satara",
  "Seva Nursing School,Shrirampur",
  "6714-Shree Datta Shetakari Sahakari Sakhar Karkhana Ltd. Charitable Trust, Shree Datta Polytechnic College, Dattanagar Tal-Shirol, Dist Kolhapur",
  "6799-Shivganga Charitable Trust, Sangli Vishveshwarya Technical Campus, Faculty of Diploma Engineering, Patgaon, Miraj",
  "SEVA SADAN JR. COLLEGE LOF EDUCATION NAGPUR SITA BUILDING NAGPUR",
  "6432-Shivneri Foundation, Shivneri Polytechnic, Khanapur, Junnar, Pune",
  "6470-Shriram Education Soceity's Shivaji Polytechnic, Atpadi, Sangli",
  "6405-Shivnagar Vidya Prasarak Mandal's Institute of Tech. & Engg., Malegaon(Bk.)",
  "SEVA SHIKSHAN PRASARAK MANDAL DR. N. J. PAULBUDHE D. ED. COLLEGE SAVEDI AHMEDNAGAR",
  "3280-Shivajirao S. Jondhle Polytechnic, Asangaon, Shahapur.Thane",
  "SEWA SADAN COLLEGE OF EDUCATION ULHASNAGAR THANE",
  "5300-SHRADDHA RURAL MEDICAL SOCIAL WELFARE & EDUCATION`S SAHAKAR MAHARSHI KISANRAO VARAL PATIL COLLEGE OF PHARMACY NIGHOJ TAL PARNER AHMEDNAGAR",
  "6466-SHREE SANTKRUPA SHIKSHAN SANSTHA SHREE SANTKRUPA INSTITUTE OF ENGINEERING & TECHNOLOGY KARAD",
  "SHAAN EDUCATION SOCIETY GUARDIAN COLLEGE OF EDUCATION KONDHWA PUNE",
  "1007-SHREE SHIVAJI EDUCATION SOCIETY`S DR PUNJABRAO DESHMUKH POLYTECHNIC (UN-AIDED) AMRAVATI",
  "6644-Shri. Ambabai Talim Sanstha's Sanjay Bhokare Group of Institutes, Miraj",
  "SHRI PANDURANG KRIPA BAHUUDDESHIYA SHIKSHAN PRASARAK SANSTHA SHRIGONDA AHMEDNAGAR",
  "SHRI ANGARSIDDHA SHIKSHAN PRASARAK MANDAL VAIBHAVWADI SINDHUDURG",
  "SHRI SHIVAJI JUNIOR COLLEGE OF EDUCATION NEHRU NAGAR SOLAPUR",
  "4249-Shri Nirmaladevi Education Soceity's Sonatai Pandav Polytehnic, Paradsinga",
  "SHRI SWAMI VIVEKANAND SCHOOL OF NURSING BEED",
  "SHRI TULJABHAVANI BAHUUDDESHIY SAMAJ SEVI SANSTHA JUNIOR COLLEGE OF EDUCATION MADHA SOLAPUR",
  "3274-Vidyalankar Polytechnic,Mumbai",
  "SHRI TUYLIJABHAVANI JUNIOR COLLEGE OF EDUCATION TULIJAPUR OSMANABAD",
  "SHRI UDAJIRAO JR. COLLEGE OF EDUCATION GARGOTI KOLHAPUR",
  "SHRI VASANT ADHYAPAK VIDAYALAYA NAGPUR NAGPUR",
  "Shri Vasant Barahate Jr.College of Education,Bramangaon",
  "6452-Shri Umajirao Sanamadikar Medical Foundation's Siddharath Polytechnic, Jath",
  "6474-Shri Vatavruksha Swami Maharaj Devasthan's, Kai.Kalyanrao (Balasaheb) Ingale Polytechnic College, Akkalkot",
  "6458-Shri. Siddheshwar Deosthan Trust's Siddheshwar Women's Polytechnic, Solapur",
  "5228-Shri Shivaji Viddhya Prasarak Sanstha's Bapusaheb Shivajirao Deore Polytechnic, Dhule",
  "ST. TERESAS JUNIOR COLLEGE OF EDUCATION SANTA CRUZ (W) MUMBAI",
  "ST.XAVIER'S D.ED COLLEGE, KOLHAPUR",
  "6412-Shri Shivaji Shikshan Prasarak Mandal's Institute of Polytechnic, Barshi, Solapur",
  "SUDAM SHIKSHAN P MANDAL D. ED. COLLEGE KALAMB YAVATMAL",
  "2517-Shri. Shivaji Polytechnic Institute, Wasmat road, Parbhani.",
  "SIES School of Business Studies",
  "5387-Sureshchandra Dhariwal Polytechnic, Palaskhede(bk), Tal. Jamner.",
  "6767-Suman Ramesh Tulsiani Technical Campus: Faculty of Engineering, Kamshet,Pune.",
  "6025-Shri Swami Vivekanand Shikshan Santha's Institute Of Pharmacy,Miraj",
  "4277-Sudam Shikshan Prasarak Mandal's Shree Babasaheb Gharfalkar College Of Pharmacy, Nachangaon, Pulgaon",
  "3023-St. Xavier's Technical Institute, Mumbai",
  "2298-Shri Sai Institute of Technology(Polytechnic),Aurangabad",
  "6409-Solapur Education Society's Polytechnic, Solapur",
  "3024-Sophia Shree B.K. Somani Memorial Polytechnic), Mumbai",
  "4230-Shri Sadashivrao Patil Shikshan Sanstha's Kamptee Polytechnic, Kamptee",
  "6475-Smt. Premalatai Chavan Polytechnic, Karad",
  "3458-Smt. Geeta D. Tatkare Polytechnic At Gove, Kolad",
  "5270-Shri.Tilok Jain Dnyan Prasarak Mandal's Anand Colleges of Pharmacy, Pathardi, Ahmednagar",
  "3263-Smarth Samaj's S. H. Jondhale Polytechnic, Dombivli",
  "3449-S.K.Education Trust, Dr. Manoj A Shete College of Engineering & Technology, Kasara.",
  "4281-Shri Sachhidanand Shikshan Santha's Taywade Institute Of Diploma In Pharmacy, Koradi, Kamptee,Dist.Nagpur",
  "6414-Sinhgad Tech Education Society's Sou. Venutai Chavan Polytechnic, Pune",
  "2197-Shriram Pratishthan, Apurva Polytechnic, Rawalgaon, Parbhani.",
  "6491-Shri Y.S.P.Mandal's Vasantidevi Patil Institute of Pharmacy , Kodoli, Dist.Kolhapur",
  "6444-Shriram Institute Of Engineering & Technology, (Poly), Paniv",
  "4609-Shri Vyankatesh Shikshan Sanstha's,Shri Vyankatesh Polytechnic, Yelakeli, Ta- Seloo,Wardha",
  "2289-Baliram Patil Mission's S.N.Rai Institute of Engg. & Technology Shrikshtra , Mahur Dist Nanded.",
  "6522-Shriram Education Society's Sau. Venutai Chauhan Pharmacy College, Phaltan",
  "6401-Shikshan Prasarak Mandal's College of Pharmacy, Akluj",
  "S. V. C. S. D. ED. COLLEGE AKKALKOT ROAD SOLAPUR",
  "SHRI VIVEKANAND INSTITUTE OF NURSING AHMEDNAGAR",
  "SWALAMBI JR. COLLEGE OF EDUCATION DHANTOLI WARDHA",
  "SWAYAM SIDDHI MITRA SANGH COLLEGE OF EDUCATION VASANTWADI MUMBAI",
  "SH. SHIVAJI D. ED. COLLEGE WASHIM WASHIM",
  "TALAT SHIKSHAN MANDAL NANDRABAD AURANGABAD",
  "TALEGAON GENERAL HOSP & CONVALESCENT HOME' S PUNE",
  "TAPI VALLEY EDUCATION SOCIETYS ADHYAPAK VIDYALAYA, FAIZPUR, JALGAON",
  "SIDDIVINAYAK SHIKSHAN PRASARAK MANDALS R. K. D. ED. BHANDUP(W) MUMBAI",
  "TARARANI VIDYAPEETH JUNIOR COLLEGE OF EDUCATION 1ST LANE RAJARAMPURI KOLHAPUR",
  "TERNA JR. COLLEGE OF EDUCATION TULJAPUR ROAD OSMANABAD",
  "SINDHUDURG EDUCATION SOCIETY BHANDUP (WEST) MUMBAI",
  "THAKUR INSTITUTE OF AVIATION TECHNOLOGY MUMBAI",
  "THE MAHARASHTRA EDUCATION & SPORTS ACADEMY CHANDGAD CHANDGAD KOLHAPUR",
  "S. K. SOMAIYA JR. COLLEGE OF EDUCATION VIDYANAR MUMBAI",
  "THE MARY B. HARDING JR. COLLEGE OF EDUCATION ZILLA NYAYALAYA SOLAPUR",
  "THE NEW EDUCATION SOCIETY SHRI G. S. PAMNANI D. ED. COLLEGE (ENG-M. ED ULHASNAGAR THANE",
  "S. M. JOSHI ADHYAPAK VIDHYALAYA NASIK-ROAD NASIK NASIK",
  "THE TAJ EDUCATION FOUNDATION MANDRUP SOLAPUR",
  "WAINGANGA BAHUUDESHIYA VIKAS SANSTHA SAKOLI BHANDARA",
  "YASHAWANTRAO CHAVAN ADHYAPAK VIDYALAY MANGRULPIR",
  "YASH BAHUUDESHIYA SHIKSHAN SANSTHA ARJUNI MORGAON GONDIYA",
  "YASHODABAI KHARE JR. COLLEGE OF EDUCATION NAGPUR SHANKAR NAGAR NAGPUR",
  "YASHWANT JUNIOR COLLEGE OF EDUCATION RAMNAGAR WARDHA",
  "Yashwant Nursing Institute ,Kodoli",
  "YASHWANT NURSING SCHOOL, ASHTI",
  "YASHWANTRAO CHAVAN SHIKSHAN PRASARAK MANDAL ERANDOL JALGAON",
  "YERALA SCHOOL OF NURSING MUMBAI",
  "YESHWANTRAO CHAVAN COLLEGE OF EDUCATION HINGOLI HINGOLI",
  "6439-Y.D.Mane Institute of Technology, Kagal, Kolhapur",
  "5273-Late Shree Yashwantrao Chavan MMRDF Yashwantrao Chavan College of Pharmacy, Ahmednagar",
  "6504-Yashoda Shikshan Prasarak mandal's Sojar College of Pharmacy, Khandvi, Barshi, Solapur",
  "4642-Wainganga Polytechnic, Sakoli",
  "2223-Vivekvardhini Sevabhavi Sanstha's Diploma Pharmacy College, Pingali",
  "4227-Vivekanand Polytechnic,SitaSaongi,Tal-Tumsar,Dist-Bhandara",
  "3145-Vivekanand Education Society's Polytechnic, Mumbai",
  "3421-VIVA College of Diploma Engg &Tech., At. Bolinj, Virar (W) Dist. Thane",
  "6429-Vidya Vikas Pratishthan Polytechnic, Solapur",
  "2290-Vilasrao Deshmukh Foundations School of Polytechnic,Latur",
  "6485-Vishal Junnar Seva Mandal's Institute of Pharmacy,Ale, Pune",
  "1264-Vidarbha Institute of Pharmacy, Washim",
  "2178-Vinayakrao Patil Shikshan Prasarak Mandal, Institute Of Engineering & Technology Kannad",
  "1142-Vidarbha Youth Welfare Society's Polytechnic, Badnera, Amravati",
  "4021-Vidharbha Youth Welfare Society's Institute of Diploma in Pharmacy Borgaon Meghe,Wardha",
  "6445-Vidya Pratishthan's Polytechnic College, Vidyanagari, Indapur",
  "SHRI DATTAKRUPA SCHOOL OF NURSING MURBAD",
  "6493-Vishal Junner Seva Mandal's Institute of Pharmacy for Women, Ale,Pune",
  "4268-Wainganga Bahu-uddeshiya Vikas Sanstha,s Bajiraoji Karanjekar College of Pharmacy, Sakoli",
  "3262-VIDYAVARDHINI'S BHAUSAHEB VARTAK POLYTECHNIC VASAITHANE",
  "6472-Vidyavardhini Educational Academy's Vidyavardhini Institute Of Technology,Bhudargad",
  "4608-Shri Lalbahaddur Shastri Shikshan Prasarak Mandal, VJ Polytechnic, Mouza Khamona, Tah- Rajura, Chandrapur",
  "YUVAK VIKAS HIMAYAT BAG AURANGABAD",
  "YUVAK VIKAS SHIKSHAN PRASARAK MANDAL JINHUR PARBHANI",
  "YUVAK VIKAS SHIKSHAN PRASARK MANDALS GANGAKHED PARBHANI",
  "ZEAL EDUCATION SOCIETYS HINGNE KHURD PUNE",
  "SAMRUDDHI INSTITUTE OF NURSING KALYAN",
  "S B K COLLEGE OF NURSING",
  "VIJAY NURSING SCHOOL GNM LATUR",
  "KIRLOSKAR INSTITUTE OF MANAGEMENT, PUNE",
  "PAVITRA NURSING SCHOOL",
  "CIVIL HOSPIAL CIVIL SURGEON AURANGABAD",
  "DHANWANTRI MEDICAL EDUCATION AND RESEARCH CENTRES, VEDIKA SCHOOL OF NURSING",
  "DR BHANUDAS DERE COLLEGE OF NURSING",
  "DR SUBHASHRAO DHAKNE COLLEGE OF NURSING GNM ROHANWADI JALNA",
  "INDIRA GANDHI NURSING SCHOOL GNM LATUR",
  "KAI GODABAI RAMA DHONGE NURSING COLLEGE RAJUR  AKOLE  AHMEDNAGAR",
  "KAI MADHAVRAO PATIL SEVABHAVI SHIKSHAN PRASARAK MANDAL SANT TUKARAM NURSING GNM  COLLEGE AHMEDPUR",
  "ARADHYA NURSING COLLEGE",
  "DR BHARAT PATIL FOUNDATION PATIL HOSPITAL SANCHALIT DR B C ROY INSTITUTE OF MEDICAL SCIENCES TEMBHURNI TALUKA MADHA DISTRICT SOLAPUR",
  "GLOBAL NURSING SCHOOL ANM GNM",
  "HARISHCHANDRA MEDICAL FOUNDATION TRIBAL DEVLOPMENT AND COLLEGE OF NURSING AND RESEARCH CENTER AKOLE, AHMEDNAGAR",
  "JANAI GNM NURSING SCHOOL ISLAPUR ROAD KINWAT",
  "KARMAYOGI NURSING COLLEGE",
  "MATRU SEWA SANGH NURSING SCHOOL  SITA BULDI MATERNITY HOME",
  "MELGHAT INSTITUTE OF NURSING CHIKHALDARA",
  "NEHA SCHOOL OF NURSING GNM PARBHANI",
  "PARIVARTAN GRAMIN VIKAS MAHILA AND SHIKSHAN MANDAL PARBHANI SANCHLIT SHRI RAMKRUSHNA PARAMHANS INSTITUTE OF NURSING HASNAPUR PARBHANI",
  "SAI CARE SCHOOL OF NURSING",
  "SAMARTH INTISTUTE OF NURSING",
  "SANIKA COLLEGE OF NURSING, MITMITA CHHATRAPATI SAMBHAJINAGAR",
  "SUSHILADEVI NURSING COLLEGE",
  "LAXMIBAI GORTHEKAR GNM NURSING SCHOOL, UMRI",
  "MELGHAT INSTITUTE OF NURSING",
  "MOTHER HAWWA SCHOOL OF NURSING",
  "RENUKAI GNM NURSING SCHOOL, KINWAT",
  "SAMBHAJINAGAR COLLEGE OF NURSING CHHATRAPATI SAMBHAJINAGAR",
  "GOVERNMENT COLLEGE OF NURSING GENERAL HOSPITAL, DHARASHIV",
  "NIRVANA INSTITUTE OF NURSING EDUCATION, SANGAVI, SHIRPUR, DHULE",
  "MEDICARE COLLEGE OF NURSING",
  "AUREOLE SCHOOL OF BUSINESS  MANAGEMENT, PUNE",
  "NEW INSTITUTE OF TECHNOLOGY, KOLHAPUR",
  "SAMARTH COLLEGE OF NURSING SANGAMNER AHMEDNAGAR",
  "ASHA NURSING SCHOOL  AMRAVATI",
  "JIJAMATA MAHILA SEVABHAVI SANSTHA, SUNRISE SCHOOL OF NURSING, PURNA, PARBHANI",
  "DISHA SAMAJIK BAHUUDDESHIYA MAHILA MANDAL LATUR SANCHALIT RENAISSANCE SCHOOL OF NURSING",
  "TRUE COLLEGE OF NURSING MANSAR",
  "TRUE COLLEGE OF NURSING NAGPUR",
  "N. C. ABA PATIL INSTITUTE OF PHARMACY, WALWADI, DHULE",
  "SHRI SIDDHESHWAR SHIKSHAN MANDALS COLLEGE OF ARCHITECTURE SOLAPUR",
  "SCHOOL OF NURSING GENERAL HOSPITAL PARBHANI ",
  "SHAHID SITARAM COLLEGE OF ARCHITECTURE",
  "SMT K  L TIWARI COLLEGE OF ARCHITECTURE",
  "NANASAHEB THOMBARE SHIKSHAN SANTHAS SUHAS INSTITUTE OF TEHCNOLOGY DAUND",
  "SCHOOL OF NURSING ,WASHIM",
  "N D KASAR INSTITUTE OF ENGINEERING AND TECHNOLOGY ",
  "SHAHID SITARAM COLLEGE OF PHARMACY, TITAVE, RADHANAGARI",
  "AROHI COLLEGE OF PHARMACY",
  "CHETANA INSTITUTE OF PHARMACY, WARDHA",
  "DNYANDEEP COLLEGE OF PHARMACY , NAGPUR",
  "EKDANT COLLEGE OF PHARMACY",
  "GURUKUL INSTITUTE OF PHARMACY BHOKARDAN",
  "ZAGDU SINGH CHARITABLE TRUSTS THAKUR POLYTECHNIC ",
  "AADARSH INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH CENTER ",
  "SAI EDUCATION SOCIETY",
  "MOTHER TERESA MEMORIAL COLLEGE OF NURSING",
  "SHRI BHAIYASAHEB PATIL INSTITUTE OF TECHNOLOGY BHADGAON    ",
  "KALAVATI INSTITUTE OF PHARMACY",
  "INDIRA INSTITUTE COLLEGE OF PHARMACY SAKAT TAL JAMKHED DIST AHMEDNAGAR",
  "RAMRATAN SCHOOL OF PHARMACY",
  "NORTH MAHARASHTRA KNOWLEDGE CITY INSTITUTE OF PHARMACY, JALGAON     ",
  "RAMKRISHNA NURSING SCHOOL SILLOD",
  "RUKHMABAI THOMBARE COLLEGE OF PHARMACY, WARDHA, DIST WARDHA",
  "INDIAN INSTITUTE OF MATERIALS MANAGEMENT",
  "SHRI M S KOWASE COLLEGE OF PHARMACY",
  "MATA MAHAKALI COLLEGE OF PHARMACY WARORA DIST CHANDRAPUR",
  "CSIR NATIONAL CHEMICAL LABORATORY ",
  "PIMPRI NURSING SCHOOL",
  "MEERABAI KAMBLE NURSING COLLEGE BRAMHAPURI",
  "YEOLA NURSING SCHOOL, YEOLA",
  "DINDORI NURSING SCHOOL, DINDORI",
  "PETHROAD NURSING SCHOOL, PETH",
  "NIFAD NURSING SCHOOL, NIFAD",
  "IQRA URDU JR COLLEGE OF EDUCATION JALGAON",
  "IGATPURI NURSING SCHOOL IGATPURI",
  "PRAJAKTA NURSING SCHOOL,PARLI.V, BEED,MAHARASHTRA",
  "SWAPNA PURTI SHIKSHAN MANDAL PACHORE BK C O SAMARTH ADHYAPAK (D. ED. ) VIDYALA SATPUR NASIK",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING DIET C O GUJARATI HIGH SCHOOL WAKHARBAG SANGLI",
  "TULJABHAVANI NURSING SCHOOL, SURGANA",
  "DAGA MEMORIAL GOVT. HOSPITAL NAGPUR",
  "SANJEEVA NURSING SCHOOL, KOLHAPUR",
  "6888-Tatyasaheb Kore Institute of Engineering & Technology(Polytechnic), Warananagar",
  "6717-Barshi Shikshan Prasarak Mandal, Shriman Bhausaheb Zadbuke Institute of Polytechnic, Puri, Tal-Barshi, Solapur",
  "2541-Sarswati Institute of Pharmacy, Kurtadi, Hingoli",
  "5439-Dr Naikwadi College of D Pharmacy, Jamgaon Sinnar",
  "5434-Gokhale Education Society's Sir Dr.M.S.Gosavi Polytechnic Institute, Nashik Road",
  "5440-Shaineshwar Shikshan Prasarak Mandal's College of D. Pharmacy, Laling, Dhule",
  "4644-Dadasaheb Balpande College of Diploma in Pharmacy, (DBCDIP) Nagpur",
  "3486-Shree Saraswati Institute of Pharmacy, At Post Tondavali, Kankavali",
  "1275-Manav School of Polytechnic, Vyala, Tal.Balapur, Akola",
  "5424-Pratibhatai Pawer College of Pharmacy, Shrirampur",
  "6891-Eklavya College of Pharmacy, Tasgaon , Sangli",
  "5421-Pravara Rural Education Society's College of PHarmacy (D.Pharm), Chincholi",
  "VIDYASAGAR NURSING SCHOOL, SANGLI",
  "SARASWATI INSTITUTE OF NURSING SCIENCES AND RESEARCH AMRAVATI",
  "LATE BHIKAJI DARADE SCHOOL OF RGNM NURSING,DHANORE",
  "Govindrao Paul Nursing School (GNM) Hadgaon",
  "RASHTRIYA NURSING SCHOL",
  "Training School of Nursing General Hospital Sindhudurg",
  "Shri Saibaba Nursing School (ANM) Kolpewadi",
  "UMA INSTITUTE OF NURSING EDUCATION, JATH , TAL JATH DIST SANGLI",
  "SUJATA SCHOOL OF NURSING AMRAVATI",
  "SAHYADRI NURSING COLLEGE BARSHI TQ BARSHI DIST SOLAPUR",
  "5435-OBVS PROF RAVINDRA NIKAM COLLEGE OF PHARMACY(D.PHARMACY) GONDUR DHULE",
  "SHRI BANESHWAR ADHYAPAK VIDYALAYA",
  "LAXMIBAI ADHYAPAK VIDYALAYA SAKOLI",
  "Savitribai Phule GNM Nursing College, Washim",
  "TRAINING COLLEGE OF NURSING, SHRI BHAUSAHEB HIRE GOVERNMENT MEDICAL COLLEGE AND SARVOPCHAR RUGNALAYA, DHULE    ",
  "6909-Y.D. Mane Institute of Pharmacy, Kagal, Kolhapur",
  "5417-Karmaveer Shankarao Kale Education Society's Gautam Polytechnic Institute,Kpoargaon",
  "2578-Godavari Institute of Pharmacy, Kolpa",
  "5425-Pravara Rural Education Society's Institute of Pharmacy, Loni Kd",
  "5413-Netaji Subhashchandra Bose Edu Trust,Netaji Polytechnic.,Dhule",
  "6417-Poona District Education Association's, Institute of Technology,Hadpsar,Pune",
  "6889-Annasaheb Dange College of D. Pharmacy, Ashta, Sangli",
  "5427-R.G.Sapkal Institute of Pharmacy, Anjaneri",
  "2550-Prerana Institute of Pharmacy(D.Pharmacy), Parbhani",
  "ABHINAV INSTITUTE OF NURSING EDUCATION MIRAJ-SANGLI",
  "JIJAMATA INSTITUTE OF NURSING, NAIK NAGAR, TAPDIYA ESTATE NEAR SAHYADRI HOSPITAL HINGOLI",
  "Saket Institute of Nursing",
  "MUKTAI NURSING SCHOOL, RATHOD CORNER DHANEGAON NANDED",
  "Saraswati Nursing School, Gunjkheda",
  "RAHUL GANDHI URDU D.ED COLLEGE, NANDED.",
  "NIRMITI NURSING COLLEGE",
  "WFPM Hospital School of Nursing Wai",
  "SAI NURSING COLLEGE OMERGA",
  "SHREE VINAYAKRAO BAPU DESHMUKH SCHOOL OF NURSING YAVATMAL",
  "ANAND MEDICAL FOUNDATIONS NURSING INSTITUTE",
  "SUSHILA NURSING SCHOOL DAUND",
  "ASHWINI INSTITUTE OF NURSING EDUCATION SOLAPUR",
  "Yash Institute Of Nursing, Yavatmal",
  "Vidyashakit Shikshan Prasarak Mandal Ananditai Bengal Nursing School Sengaon Risod Road, Tq sengaon",
  "N.K.T.T.SHOOL OF NURSING , BHIWANDI",
  "Vedant RGNM Nursing School",
  "SHRI GORAKSHA SCHOOL OF NURSING KHAMGAON (ANM and GNM)",
  "ASHIRWAD NURSING COLLEGE OF ANM SAKOLI",
  "DNYANDEEP NURSING SCHOOL",
  "MAHARAJA SAYAJIRAO GAIKWAD NURSING SCHOOL AURANGABAD",
  "MAI NURSING SCHOOL",
  "MELGHAT NURSING SCHOOL,PARATWADA",
  "KHANDESH NURSING INSTITUTE",
  "NAVYUVA NURSING SCHOOL",
  "SHRI BHAGWAN NURSING SCHOOL LATUR",
  "SHENDGE INSTITUTE OF NURSING SCIENCE, OMERGA, DHARASHIV",
  "SAMARTH SCHOOL OF NURSING DEOULGAON RAJA BULDHANA",
  "NEW RAJMATA JIJAU RGNM NURSING SCHOOL",
  "6900-Jyotisling Shikshan Prasarak Mandal's Yashwant redekar College of Pharmacy(Diploma), Nesari, Gadhinglaj",
  "6499-Shri. Jain Vidya Prasarak Mandal, Rasiklal M.Dhariwal College Of Pharmacy, Pune",
  "DR. DALVI MEMORIAL HOSPITAL AND NURSING TRAINING SCHOOL NAGPUR",
  "Angel Nursing School Nandurbar",
  "SSS  MOTHER TERESA NURSING SCHOOL (ANM), VISHNUPURI NANDED",
  "Rajmata Jijau Shikshan Prasarak Mandals School of Nursing",
  "MANASI COLLEGE OF NURSING WASHIM",
  "BINIT NURSING INSTITUTE,SOLAPUR",
  "Mathsyodari Nursing School,Ambad TQ-Ambad Dist-Jalna(Maharashtra)",
  "Manik nursing School,Aurangabad",
  "BHARTIYA GRAMIN VIKAS SANSTHAS SANSKRUTI NURSING SCHOOL,BEED",
  "JEEVAN REKHA SCHOOL OF NURSING, BRAHMANGAON.TQ- UMARKHED",
  "PRABHAVATI NURSING SCHOOL,AURANGABAD",
  "LOKNETE RAJARAMBAPU PATIL TRAINING COLLEGE OF NURSING ISLAMPUR SANGLI",
  "ANURADHA NURSING SCHOOL CHIKHLI",
  "HARSH SCHOOL OF NURSING SUTALA (Bu) KHAMGAON",
  "HALO NURSING SCHOOL,ANDUR",
  "Ganshanti Nursing School",
  "JAI AMBE SCHOOL OF NURSING AMBAD TQ-AMBAD,DIST-JALNA(MAHARASHTRA)",
  "Sai Nursing School Malegaon",
  "MAHESHWARI INSTITUTE OF PHARMACY",
  "SHRIMATI GANGUBAI SAMBHAJI SHINDE INSTITUTE OF NURSING KARMALA ,SOLAPUR",
  "6649-TSSM's Bhivarabai Sawant College of Engineering and Research, Narhe, Pune",
  "ABHINAV SCHOOL OF NURSING",
  "VASANTRAO NAIK SCHOOL OF NURSING, JALNA.",
  "Deonil school of nursing",
  "RENUKA PHARACY COLLEGE MANGRUL KALLM",
  "MANGAON GENERAL NURSING COLLEGE",
  "SADHANA D.Ed. COLLEGE, GADHINGLAJ",
  "MOTHER TERESA NURSING INSTITUTE, NAGPUR",
  "3492-SBNM College of Pharmacy(D.Pharmacy), Mahad",
  "UDAY GER SCHOOL OF NURSING",
  "L.D.H.T NURSING SCHOOL SAWAD TQ.DIST.HINGOLI",
  "Right Value Institute Of Nursing, Nagpur",
  "Rashtra Sant Pachlegaonkar Maharaj Shikshan and Sevabhavi Samajik Vikas Sanstha Om Nursing School Beed",
  "INDIRA  BAHUUDDESHIYA SHIKSHAN SANSTHS SCHOOL OF NURSING BELAD MALKAPUR DIST BULDANA-",
  "GANGA INSTITUTE OF MEDICAL SCIENCES",
  "GANDHI NURSING SCHOOL,KADA",
  "RAJMATA JIJAU NURSING SCHOOL NANDED",
  "AAISAHEB JAYABAI GNM NURSING SCHOOL PATHRAI",
  "MAHARSHI WALMIKI INSTITUTE OF NURSING, AKOLA.",
  "Mrs. Kumudben Madanbhai Sura Nursing School",
  "Kai. Balwantrao Hanumantrao Patil Shikshan Prasarak Mandal, Karvir ,Kolhapur",
  "Mother Teresa School Of Nursing Buldana",
  "TIRUMALLA A.N.M.NURSING SCHOOL",
  "Sou. Rukhmini Manohar Machale Nursing School",
  "Vishwasattya  School of Nursing Tambat Lane ozar",
  "School of Nursing, Bhagini Mandal, Dhangar",
  "S.S.P.M. Nursing College, Aashti",
  "SHIVRASHTRA COLLEGE OF NURSING",
  "SARDAR NURSING INSTITUTE, AMRAVATI",
  "Gangabai Patil Nursing School, Pachpimpali",
  "Sanjeevan Nursing School, Yavatmal",
  "RADHIKA NURSING SCHOOL, AKOLA",
  "Sai Nursing School Tumsar",
  "SANT GAJANAN MAHARAJ SCHOOL OF NURSING",
  "Institute of Nursing Education, Akanksha Social Welfare and Human Resource development Association, Akola",
  "LATE SAU. INDIRABAI BHOYAR SCHOOL OF NURSING",
  "Swargiya Indira Gandhi Nursing School",
  "Dhanashree Institute of Nursing",
  "Rashtramata Jijau Nursing School",
  "Aai Institute Of Nursing,Gangakhed, Parbhani",
  "Dayee Institute Of Nursing, Latur",
  "Torja Nursing School, Parbhani",
  "Prabhakar Patil institute of Nursing Education, Pen",
  "Kasturba Nursing School, Mandgaon",
  "SATAO NURSING TRAINING SCHOOL, WARDHA",
  "SHARDA NURSING SCHOOL, PARTUR",
  "MAULI INSTITUTE OF NURSING (GNM)",
  "TANMAYI NURSING INSTITUTE SATANA",
  "FLORENCE SCHOOL OF NURSING, MAHAGAON",
  "Rani Mansaheb Manubadevi Rawal Nursing School",
  "TIRUMALA ANM SCHOOL OF NURSING, HADGAON",
  "Yeshwant Institute Of Nursing Aurangabad",
  "Sahakarmaharshi Tatyasaheb Kore Nursing School",
  "SHRI SAI SCHOOL OF NURSING ARMORI, GADCHIROL",
  "Yeshwant Institute Of Nursing Parbhani",
  "Chetna Nursing Institute",
  "Swa. Rupeshkumar ingole school of nursing yavatmal",
  "College of Nursing, Gokhale Education Society, Vidyanagar, Nashik",
  "PAITHAN NURSING SCHOOL, (R.A.N.M.)",
  "SAISHA NURSING SCHOOL ERANDESHWAR",
  "MAULI INSTITUTE OF NURSING (ANM)",
  "INDIRA GANDHI A.N.M. NURSING SCHOOL, PARBHANI",
  "Devang A.N.M. Nursing School",
  "Shri Dhaneshwari RGNM Nursing School, Aurangabad",
  "ARMAN NURSING SCHOOL,SHIRUR ANANTPAL DIST.LATUR",
  "GURUMAULI INSTITUTE OF NURSING SCIENCE, AMRAVATI",
  "Matoshri Nursing School R.A.N.M. (M.H.W.), Parbhani",
  "Matoshri Organisation of Nursing Education, Yavatmal",
  "BHARTIYA NURSING SCHOOL, AURANGABAD",
  "RAMLING VIGHNE NURSING SCHOOL, BEED",
  "KARUNA SCHOOL OF  NURSING,  MANMAD",
  "D.S.Nursing School",
  "Vasantdada Kale Medical Foudation Bhandishegaon, Jankalyan Institute of Nursing Education",
  "KAMAL NURSING INSTITUTE, KAIJ",
  "MOTHER TERESA MEMORIAL NURSING ACADEMY BALLARPUR",
  "ASHIRWAD NURSING SCHOOL, RAHURI",
  "V.B.N. Nursing school",
  "JAI HIND NURSING SCHOOL , HINGOLI",
  "Chetan Dattaji Gaikwad Nursing School",
  "JANATA NURSING SCHOOL",
  "SANT DNYANESHWAR MEDICAL EDUCATION RESEARCH CENTER PUNE",
  "BHAKTI VEDANT SCHOOL OF NURSING",
  "SHARADRAO NURSING COLLEGE, NAIGAON (KH),DIST-NANDED",
  "SAIRAM SCHOOL OF NURSING",
  "RADHABAI BAHEKAR NURSING SCHOOL,GONDIA",
  "SAROJINI NAIDU SCHOOL OF NURSING CHAKUR",
  "Shree Gurugovind Singh Memorial School of Nursing",
  "KRANTIAGRANI G. D. (BAPU) LAD SCHOOL OF NURSING, SANGLI",
  "Smt. Shardaben Champaklal Nanavati Institute of Polytechnics School of Nursing",
  "SHRI RISHIKESH SHIKSHAN PRASARAK MANDALS SHRI D D VISPUTE COLLEGE OF NURSING  NEW PANVEL",
  "VISION NURSING SCHOOL, BULDANA.",
  "SHRAVANI INSTITUTE OF NURSING, BASMAT",
  "TANISHQ SCHOOL OF NURSING, NAGPUR",
  "SARDARBI INSTITUTE OF NURSING EDUCATION",
  "EKVIRA SCHOOL OF NURSING, DARYAPUR",
  "Blessing Institute of Nursing, Parbhani",
  "Shri Sai Nursing School, Jalna",
  "4639-Renaissance Polytechnic,Chandrapur",
  "S.G.NURSING SCHOOL, SAMBHAJI NAGAR KHADGAON ROAD LATUR",
  "SMT. PADMINI INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES, EKTA NAGAR DIGHANCHI",
  "Sarvodaya Bhumiputra Bahu uddeshiya Vikas Mandal, Kasabai School of Nursing, Sewagram",
  "Dadasaheb Dr. Suresh G. Patil College of Nursing, Chopda",
  "SMT. GUNMALA JAIN CHARITABLE TRUST INSTITUTE OF NURSING EDUCATION",
  "SHAHNAWAZ NURSING SCHOOL, AURANGABAD",
  "School Of Nursing M.G.M Hospital Parel 12",
  "Shree Venkatesha Nursing School RANM",
  "RAJMATA AHILYADEVI INSTITUTION OF NURSING PARBHANI",
  "SHIVPRASAD NURSING INSTITUTE MUKHED",
  "Late Mrs Aboli Kuldeep Pednekar Nursing Institute",
  "2294-Shri Sai Janavikas Pratishtan's Sow.Shardadevi Pandit Polytechnic institute,Alani, Osmanabad",
  "DR.G.A.GAIKWAD NURSING COLLEGE",
  "6373-Shri Chatrapati Sambhaji Shikshan Sanstha's Sitabai Thite College of Pharmarcy(Diploma), Shirur, (Ghodnadi). Pune",
  "6510-Shriram Shikshan Sanstha's College of Pharmacy, Paniv, Malshiras, Dist. Solapur",
  "6505-Shri Vithal Education & Research Institute's, College of Pharmacy(Poly.), Pandharpur",
  "2281-Ramchandra Sanskrutik Krida Mandal's Shri R D Bhakta Polytechnic, Daregaon Tal. & Dist Jalna",
  "6892-Anusaya Institute of Pharmacy, Swami-Chincholi , Tal .Daund, Pune.",
  "3006-Government Institute of Printing Technology, Mumbai",
  "2019-Government Polytechnic, Jintur",
  "5010-Government Polytechnic, Nashik",
  "5373-Sarswati Vidya Prasarak Mandal, Aabasaheb Shivajirao Sitaram Patil Institute of Polytechnic, Chichpura, Tal- Dharangaon,Jalgaon",
  "5396-College of Engineering and Technology ,North Maharashtra Knowledge City, Jalgaon",
  "Smt.Pramilatai Bhalerao School Of Nursing",
  "INDIRA BAHUUDDESHIYA SHIKSHAN SANSTHS SCHOOL OF NURSING SAGWAN BULDANA",
  "RAMRAJE SCHOOL OF NURSING DAPOLI",
  "Samarth Nursing School, Wadwani",
  "MAHAJAN NURSING SCHOOL, YAVATMAL",
  "SHRUTI NURSING SCHOOL,WADALA MAHADEV,SHRIRAMPUR",
  "Kai Baburao Ghule School Nursing, Ambajogai",
  "RAJGURU SCHOOL OF NURSING, UDGIR",
  "RASTRAMATA JIJAU NURSING SCHOOL, NILANGA",
  "SAMARTH NURSING SCHOOL, PARBHANI",
  "RENUKA NURSING SCHOOL",
  "4023-Adv.V.R.Manohar Institute of Diploma in Medical Laboratory Technology, Nagpur",
  "4283-Swa. Madhukarrao Deshmukh Education Society, Shree Sadguru Datta Institute of Pharmacy, Bhajapur",
  "Abhinav Nursing School",
  "4610-Ballarpur Seva Samiti, Jainuddin Zaweri Polytechnic, Dewai Govindpur, Tukum, Chandrapur",
  "2016-GOVERNMENT RESIDENTIAL WOMENS POLYTECHNIC LATUR",
  "Vithai Hospital and Research Centre",
  "SEVADHAM TRUST A.S.M.T SCHOOL OF NURSING",
  "School of Nursing, Late Kedari Redekar Shikshan Sanstha",
  "Swami Vivekaanand Sikshan Sanstha,Sakshi Nursing School",
  "Anusaya Shikshan Prasarak Mandals Shri Swami Narayan Nursing Institute",
  "Rajiv Gandhi RGNM Nursing school, Udgir",
  "Raje Sambhaji Maharaj Shikshan Sansthas, M. J. Pawade Nursing School, Morshi",
  "2513-SHARDA POLYTECHNIC COLLEGE, AURAD-SHAHAJANI,LATUR",
  "Tejaswini Nursing School",
  "G.B. PATIL SCHOOL OF NURSING, UDGIR",
  "MANMAD NURSING SCHOOL, MANMAD, NASHIK",
  "3288-Bhartiya Education/Social Charitable Trust, Sheth Shri Otarmal Sheshmal Parmar College Of Diploma, Raigad",
  "2580-Shri.Ramkrishna Paramhans college of Pharmacy, (D.Pharm), Hasnapur, Parbhani",
  "6728-Shri Narsinha Shikshan Prasarak Mandal,Ramrao Nikam Polytechnic College, Indoli Tal-Karad, Dist-Satara",
  "5237-Shri Krishna Education & Cultural Mandal, Shri Gulabrao Deokar Polytechnic, Jalgaon",
  "6494-Dr J J Magdum Trust's Anil Alias Pintu Magdum Memorial Pharmacy College, Dharangutti,Tal-Shirol, Dist, Kolhapur",
  "6434-Dinkarrao K. Shinde Smarak Trust, Dr. A.D. Shinde Institute Of Technology, Gadhinglaj",
  "2218-Education Society Naigaon Diploma in Pharmacy, Nanded.",
  "6468-Swami Vivekananda Shikshan Sanstha, Dr. Bapuji Salunkhe Institute Of Engineering & Technology,Kolhapur",
  "4604-Gramin Vikas Multipurpose Education Society,Prabhat Diploma College of Engineering, Mouza Rui, Ta- Bramhapuri, Chandrapur",
  "6723-Chh.Shivaji Shikshan Mandal,Chh.Shivaji Polytechnic Institute,Vaduj, Tal-Khatav, Dist. Satara",
  "2213-Jalana Education Society's Institute Of Pharmacy,Jalna",
  "DHARTI SCHOOL OF NURSING",
  "1165-Dwarka Bahuuddeshiya Gramin Vikas Foundation's Rajashri Shahu College Of Pharmacy, Buldhana",
  "LATE MAHALINGE SWAMI NURSING SCHOOL, LATUR",
  "Nandatai lohave school of Nursing, Wardha",
  "4232-Navodaya Shikshan Sanstha's Shankarrao Dhawad Polytechnic, Nagpur",
  "Satabai Landge Nursing School",
  "5361-Raghvendra Shikshan Prasarak Mandal's Late Junasing Mangtu College of Engg. (Diploma), Valthan, Tal Chalisgaon,Jalgaon",
  "2526-BHIWSAN PATIL SHINDE SHIKSHAN GRAMIN VIKAS & BAHU SANSTHASHINDE POLYTECHNIC ANJANI BK TQ: MEHKAR DIST: BULDHANA",
  "Mahatma Jyotiba Phule Bahu.Shikshan Sansthas Nursing School, Sasilani Nagar, Chikhali",
  "6712-JAI BHAVANI EDUCATION SOCIETYRAJIV GANDHI POLYTECHNIC COLLEGEZIPRAPWADI TAL. PHALTAN DIST. SATARA",
  "4250-MARATHA SHIKSHAN SANSTHA'S P.R.PATIL INSTITTUTE OF POLYTECHNIC TALEGAON ASTHI WARDHA",
  "SHAHU MAHARAJ NURSING, SCHOOL (RANM)",
  "MARATHA MANDIR S. R. DESAI JUNIOR COLLEGE OF EDUCATION SHIVAJI NAGR RATNAGIRI",
  "6492-SAMARTH EDUCATIONAL TRUST`S SAWKAR PHARMACY COLLEGE JAITAPUR SATARA 415004",
  "5258-dip Foundation's Sandip Polytechnic, Nashik",
  "PAINGANGA INSTITUTE OF NURSING YELGAON",
  "Snehal GNM Institute of Nursing Pune",
  "6887-Mahalaxmi Institute of Pharmacy, Raigaon, Dist.Satara",
  "5481 MRS. SARASWATI WANI COLLEGE OF D. PHARMACY",
  "DR. D. Y. PATIL B-SCHOOL",
  "ANM GNM NURSING SCHOOL GENERAL HOSPITAL HINGOLI",
  "ST FRANCIS INSTITUTE OF HOTEL MANAGEMENT, MUMBAI",
  "DNYANVARDHINI CHARITABLE TRUST NURSING INSTITUTE",
  "Central India college of Pharmacy, Nagpur",
  "SHRI KOLTE PATIL NURSING COLLEGE WADI",
  "VSS SCHOOL OF NURSING BADNAPUR DIST JALNA",
  "GURU MISHRI COLLEGE OF PHARMACY SHELGAON TQ BADNAPUR DIST JALNA",
  "Sanjay Ghodawat Institute, Atigre, Kolhapur",
  "ISMS TBS",
  "SVSS LATUR COLLEGE OF NURSING LATUR",
  "SHRI COLLEGE OF NURSING",
  "INSTITUTE OF NURSING EDUCATION, GURU NANAK HOSPITAL",
  "MAHARSHI KARVE STREE SHIKSHAN SAMSTHAS COLLEGE OF NURSING RATNAGIRI",
  "SG SCHOOL OF NURSING AHMEDPUR",
  "TANVI SCHOOL OF NURSING CHAKUR",
  "SARIKA SCHOOL OF NURSING GNM",
  "PATHRIKAR NURSING SCHOOL",
  "RISING EDUCATION AND WELFARE SOCIETY RISING NURSING SCHOOL HINGOLI",
  "MAA JIJAU GNM NURSING INSTITUTE",
  "SPARSH INSTITUTE OF NURSING COLLEGE LATUR",
  "PUNE FOUNDATION FOR EDUCATION AND HEALTH CARE, PUNE SANCHALIT GLOBAL INSTITUTE OF NURSING EDUCATION, SADASHIV PETH, PUNE",
  "DR KHACHANE NURSING COLLEGE GNM, YAWAL, JALGAON",
  "NURSING TRAINING SCHOOL, GENERAL HOSPITAL, BHANDARA",
  "SARASWATI GNM NURSING INSTITUTE PANBHOSI",
  "ANGEL SCHOOL OF NURSING DHADGAON",
  "NIKAM COLLEGE OF NURSING AT POST GONDUR TAL DIST DHULE",
  "RAJVI NURSING SCHOOL",
  "SANGHARSH GRAMIN VIKAS BAHUUDDESHIYA SEVABHAVI SANSTHA UDGIR SANCHALIT FLORANCE INSTITUTE OF NURSING NANDED",
  "SIDDHANATH INSTITUTE OF NURSING, PANDHARPUR,SOLAPUR",
  "SUMANTAI SCHOOL OF NURSING MANTRIPARK WASHIM DIST WASHIM",
  "BIRSA MUNDA INSTITUTE OF NURSING GNM LONKHEDA TAL SHAHADA DIST NANDURBAR",
  "VAISHNODEVIMATA NURSING COLLEGE BEED TQ  DIST BEED",
  "DR V S JADHAV COLLEGE OF NURSING",
  "LATE VILASRAO DESHMUKH INSTITUTE OF NURSING NAVAPUR",
  "MATOSHRI GODABAI DHONGE COLLEGE OF NURSING, KHAMBALE, GHOTI, IGATPURI, NASHIK",
  "PRAVARA RURAL EDUCATION SOCIETYS SINDHUTAI VIKHE PATIL COLLEGE OF NURSING",
  "SHRIRAM COLLEGE OF NURSING MORSHI TA MORSHI DIST AMRAVATI",
  "CHHATRAPATI SHAHU MAHARAJ SHAIKSHANIK SANSTHA PARBHANI SANCHLIT KAMALABAI WADKUTE NURSING COLLEGE,GNM TADKALAS TAL PURNA DIST PARBHANI",
  "CHHATRAPATI SHAHU MAHARAJ SHAIKSHANIK SANSTHA PARBHANI SANCHALIT,DEVKRUPA NURSING COLLEGE HINGOLI",
  "SMT KALPANATAI PATIL NURSING COLLEGE",
  "JIVANSEVA NURSING INSTITUE",
  "VITTHALA NURSING SCHOOL, LONI, PATHRI, PARBHANI",
  "VITTHALA NURSING SCHOOL, BRAMHANGAON PARBHANI",
  "GODAVARI SCHOOL OF NURSING GNM",
  "ADARSH ANM GNM  NURSING SCHOOL BASMAT",
  "BORDIKAR COLLEGE OF NURSING MATHLA , PARBHANI ROAD JINTUR",
  "VISHWANAND COLLEGE OF NURSING, CHANDRAPUR",
  "VIVEKANAND NURSING SCHOOL",
  "SURYA INSTITUTE OF NURSING SCIENCE, PALGHAR",
  "VISHWAPRADNYA NURSING COLLEGE, PARBHANI",
  "DR PANJABRAO KATHE FOUNDATION SANCHLIT DR KATHE NURSING COLLEGE",
  "PRAYAG KARAD COLLEGE OF NURSING, NANDGAON LATUR",
  "SWAMI VIVEKANAND NURSING INSTITUTE",
  "DISHA PRATISHTHAN UDGIR DISHA NURSING SCHOOL RING ROAD LATUR TQ DIST LATUR",
  "DR V N MIRZAPURE NURSING COLLEGE GNM",
  "USHADEVI PHADTARE NURSING SCHOOL GNM",
  "SHALOM SCHOOL OF NURSING GNM BULDHANA",
  "TARABAI COLLEGE OF NURSING AHMEDNAGAR",
  "VENKATESH CHOUDHARY COLLEGE OF NURSING EKURKA ROAD, UDGIR, LATUR",
  "BABA COLLEGE OF NURSING DARYAPUR",
  "GLOBAL COLLEGE OF NURSING, LATUR",
  "JANAI SCHOOL OF NURSING GNM",
  "SEF S SURYADATTA COLLEGE OF NURSING,PARAMEDICAL SCIENCES AND TECHNOLOGY,BAVDHAN PUNE MULSHI",
  "SHANTISHANKAR NURSING COLLEGE AHMEDPUR",
  "SSPMS COLLEGE OF NURSING",
  "MAHARASHTRA INSTITUTE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "DR DNYANESHWAR MULAY COLLEGE OF NURSING TASGAON",
  "DR DNYANESHWAR MULE NURSING COLLEGE, ABDUL LAT",
  "MAA JIJAU NURSING SCHOOL",
  "SAHARA A N M NURSING SCHOOL PARBHANI",
  "SHREE SWAMI VIVEKANAND NURSING COLLEGE, MADHA, SOLAPUR",
  "VASANTI MANE COLLEGE OF NURSING,WAGHERI,KARAD,SATARA",
  "SANSKAR NURSING SCHOOL MUL",
  "SONIYA NURSING SCHOOL CHANDRAPUR",
  "SAKEENA INSTITUTE OF NURSING EDUCATION MIRAJ",
  "SHRI MANJUNATH SCHOOL OF NURSING, VADUJ, SATARA",
  "AAI PANCHFULA INSTITUTE OF NURSING",
  "SND SCHOOL OF NURSING VIRCHAK TAL DIST NANDURBAR",
  "MATOSHRI SCHOOL OF NURSING ,VIRCHAK TAL DIST NANDURBAR",
  "AYUSH NURSING COLLEGE DHARUR",
  "C S NURSING COLLEGE DEORI DISTT GONDIA",
  "DNYANDEVRAO BAPU DANDGE NURSING COLLEGE, DHAD, BULDHANA",
  "IMPERIAL SCHOOL OF BANKING AND MANAGEMENT STUDIES",
  "SUVIDHA NURSING SCHOOL GADCHIROLI",
  "RAYBA BAHUUDDESHIYA VIKAS SANSTHA TALUKA JILHA DHULE SANCHALIT DR N K R SHIROLE COLLEGE OF NURSING ERANDOL",
  "PRINCESS INSTITUTE OF NURSING COLLEGE",
  "KISAN VIDYA PRASARAK SANSTHA SANCHALIT LATE LILATAI VISHWASRAO RANDHE COLLEGE OF NURSING BORADI",
  "SHREE P E TATYA PATIL NURSING SCHOOL, JALGAON",
  "NALANDA FOUNDATION BEED SANCHALIT MATA RAMAI COLLEGE OF NURSING",
  "ATALBIHARI VAJPAYEE COLLEGE OF NURSING",
  "BHAGWAN BABA NURSING SCHOOL, CHINCHOLI SANGLE, TAL LONAR DIST BULDHANA",
  "JIVDANI SCHOOL OF NURSING",
  "KAI VIMALBAI KHANDELWAL NURSING COLLEGE",
  "LAXMI MUNDE NURSING SCHOOL, TAKLI, KAIJ",
  "MOTHER TERESA COLLEGE OF NURSING",
  "PADMAI NURSING COLLEGE",
  "MOTHER TERESA NURSING SCHOOL MUKHED",
  "DISHA BAHUDDESHIYA SEVABHAVI SANSTHA ,JALNA SANCHLIT PEOPLES INSTITUTE OF NURSING , SHENDRA PARISAR",
  "DNYAN GANGA COLLEGE OF NURSING",
  "DR PRAFULLA PATIL NURSING SCHOOL FOR GNM PARBHANI",
  "FLORENCE EDUCATION AND WELFARE SOCIETY JALNA SANCHALIT FLORENCE GNM NURSING INSTITUTE, PARTUR",
  "GLOBAL INSTITUTE OF NURSING, AT POST BORI TQ DIST LATUR",
  "JIJAU NURSING SCHOOL VISHNUPURI NANDED",
  "JIJAU SCHOOL OF NURSING SASHT PIIMPALGAON, TQ AMBAD, DIST JALNA",
  "KESHARBAI NURSING COLLEGE KAIJ TQ KAIJ DIST BEED",
  "MANDAKINI NURSING INSTITUTE , LATUR",
  "NATIONAL GNM NURSING COLLEGE SILLOD DIST CHHATRAPATI SAMBHJINAGAR",
  "PADMAI NURSING SCHOOL",
  "PROF N S KATEKAR INSTITUTE OF NURSING",
  "RAIRESHWARI  NURSING  COLLEGE , LATUR",
  "RAJARSHI SHAHU MAHARAJ COLLEGE OF NURSING, KOHMARA, SADAK ARJUNI",
  "RANJANA NURSING COLLEGE AMBEJOGAI",
  "RATNAGIRI COLLEGE OF NURSING",
  "SADGURU SCHOOL OF NURSING GNM",
  "School of Nursing, Cama And Albless Hospital, Mumbai",
  "SHRI DATTA SHIKSHAN PRASARAK MANDAL,PANUTRE, SANCHLIT VITTHAL PATIL COLLEGE OF NURSING,KALE",
  "SHRI SAI INSTITUTE OF GNM NURSING, BORI",
  "SIDDHIVINAYAK NURSING COLLEGE",
  "S T H NURSING COLLEGE, PUSAD",
  "SWAMI VIVEKANAND PRATISTHAN, KHADGAON TAL GANGAKHED , DIST PARBHANI, SANCHLIT RADHAI NURSING SCHOOL RAMNAGAR AKOLI, TAL GANGAKHED DIST PARBHANI",
  "SWARA INSTITUTE OF NURSING",
  "TULSI COLLEGE OF NURSING, BEED",
  "PUNYASHLOK AHILYADEVI HOLKAR COLLEGE OF NURSING AND RESEARCH CENTRE, MUKRAMABAD",
  "SHRIRATNA INSTITUTE OF NURSING COLLEGE, MIRAJ, SANGLI",
  "LATE RAOSAHEB DHONDIRAM MANE NURSING SCHOOL",
  "MAA SHRI NARENDRAJI MODI PARICHARIKA PRASHIKSHAN SANSTHA, KAIJ TA KAIJ DIST BEED",
  "MUKTAI NURSING COLLEGE, GIRIM",
  "PHOENIX INSTITUTE OF MEDICAL SCIENCES",
  "SHALINITAI MEGHE COLLEGE OF NURSING, HINGANA ROAD, WANADONGARI, NAGPUR",
  "SHREE SANT SAIBABA NURSING COLLGE  BHRAMI MURTIZAPUR",
  "SHRI L D AHER NURSING SCHOOL",
  "SHUBH NURSING SCHOOL",
  "Anand Charitable Sanstha's' College of Pharmaceutical Science & Research,Ashti",
  "DR ARUN MOTGHARE NURSING SCHOOL",
  "DR ARUN MOTGHARE NURSING SCHOOL ANM",
  "DISTRICT HOSPITAL SAWARGAON AMBAJOGAI  BEED",
  "KESARI NURSING COLLEGE",
  "SAI NURSING COLLEGE NAVAPUR",
  "ADITYA COLLEGE OF NURSING",
  "ADITYA INSTITUTE OF NURSING AND PARAMEDICAL",
  "DR DNYANESHWAR MULE GNM NURSING COLLEGE, KOLHAPUR",
  "SOMAYYA DIPLOMA IN PHARMACY CHANDRAPUR",
  "AMBIKA INSTITUTE OF NURSING EDUCATION PALGHAR",
  "SCHOOL OF NURSING GENERAL HOSPITAL AUNDH PUNE",
  "DR BABASAHEB AMBEDKAR COLLEGE BRAMHAPURI D PHARMA",
  "SMT BHAGIRATHI PATIL COLLEGE OF NURSING",
  "MUKTAI COLLEGE OF NURSING",
  "AROMIRA SCHOOL OF NURSING,DHARANGAO",
  "AROMIRA SCHOOL OF NURSING, KUDWA GONDIA",
  "JIJAU SCHOOL OF NURSING GNM KHANDGAON BENDRI TQ NAIGAON DIST NANDED",
  "NUTAN NURSING INSTITUTE",
  "SHRI GAJANAN MAHARAJ SCHOOL OF NURSING",
  "DHAMMADARSHANA FOUNDATION MUMBAI SANCHALIT PRIYADARSHI NURSING AND PARAMEDICAL EDUCATION INSTITUTE",
  "NANASO NARHAR NAGRAJ PATIL NURSING COLLEGE",
  "PIOS COLLEGE OF NURSING, UDGAON",
  "SHRI SANT LAHANUJI MAHARAJ COLLEGE OF NURSING, CHANDUR RAILWAY",
  "VARDHAMAN COLLEGE OF NURSING KARANJA LAD",
  "Lokmanya Medical Foundation School of Nursing Education, Chinchwad Pune",
  "SHRI SIDDHIVINAYAK INSTITUTE OF PHARMACY",
  "VIDYA INSTITUTE OF PHARMACY DHANORE YEOLA",
  "ASHIRWAD COLLEGE OF PHARMACY ",
  "ADARSH COLLEGE OF PHARMACY",
  "G N INSTITUTE OF PHARMACY",
  "MAULI NURSING COLLEGE (G.N.M.), OMERGA, DHARASHIV",
  "MATUSHRI SCHOOL OF NURSING MANASGAON",
  "GEETAI NURSING COLLEGE",
  "Dr Savita School of Nursing,Seloo",
  "SVS COLLEGE OF PHATMACEUTICAL EDUCATION AND RESEARCH,TEMBHURNI",
  "SHRI DATTA GNM NURSING TIRORA",
  "LATE UDDHAVRAO TULSHIRAM JADHAVAR FOUNDATION INSTITUTE OF NURSING TERKHEDA WASHI",
  "BHAGWANT SEVA SANSTHA BHAGWANT NURSING SCHOOL PALGHAR",
  "RAMACHANDRAN INTERNATIONAL INSTITUTE OF MANAGEMENT",
  "RAJIV GANDHI NURSING SCHOOL KHANAPUR PHATA PINGLI ROAD PARBHANI",
  "SHARAD COLLEGE OF NURSING YADRAV ICHALKARANJI",
  "NAGPUR FLYING CLUB",
  "EMERALD SCHOOL OF NURSING",
  "INDIRA GANDHI NURSING SCHOOL PARBHANI",
  "RENUKA SCHOOL OF NURSING KALLAM",
  "INDIRA GANDHI NURSING SCHOOL HINGOLI",
  "GLOBAL INSTITUTE OF BUSINESS MANAGEMENT  AND DECISION SCIENCES PUNE",
  "ASIAN COLLEGE OF PHARMACY DHAYARI PUNE",
  "MEDPRO COLEGE OF GNM NURSING",
  "ADITYA SCHOOL OF BUSINESS MANAGEMENT",
  "SUSAIN ANM NURSING SCHOOL OSMANABAD",
  "SOU GULABI BAHUUDDESHIYA SAMAJIK SHIKSHAN VA AROGYA SANSTHA ELENA SCHOOL OF NURSING MOUZA BRAMHAPURI",
  "DSPM SCHOOL OF NURSING BABHALGAON",
  "ASHIRWAD NURSING COLLEGE OF GNM SAKOLI",
  "S M M B S SARASWATI NURSING SCHOOL",
  "SANJEEVANI NURSING COLLEGE SAKOLI",
  "SAHYADRI INSTITUTE OF NURSING EDUCATION",
  "2619-SHRAMJIVI SHIKSHAN PRASARAK MANDALS SHRAMJIVI COLLEGE OF PHARMACY OMERGA",
  "2606-AMBADASRAO WARPUDKAR INSTITUTE OF PHARMACY",
  "6931-SAMARTH COLLEGE OF   PHARMCY",
  "6757-YASHODA TECHNICAL CAMPUS SATARA FACULTY OF POLYTECHNIC",
  "Potdar Foundation Sumantai Institute Of Pharmacy",
  "UNIQUE RANM NURSING SCHOOL PARLI V",
  "6936-KRISHNA FOUNDATIONS JAYWANT INSTITUTE OF PHARAMCY WATHAR",
  "TRIDENT INSTITUTE OF NURSING CHANDUR RLY",
  "2584-Srinath College of Pharmacy, Aurangabad",
  "2598-Shivai Charitable Trust's College of Pharmacy, Koregaonwadi, Umerga",
  "1286 - INSTITUTE OF PHARMACY AND RESEARCH,BADNERA, AMRAVATI",
  "64902-GOURI SHANKAR EDUCATION SOCIETY'S COLLEGE OF PHARMACY (D. PHARM.), LIMB, SATARA",
  "GOVT. JUNIOR COLLEGE OF EDUCATION DHARMABAD NANDED",
  "HINDUSTANI EDUCATION SOCIETY AUSA LATUR",
  "HOLY FAMILY INSTITUTE OF NURSING EDUCATION THANE",
  "HOLY SPIRIT SCHOOL OF NURSING MUMBAI",
  "HON. VILASRAO DESHMUKH D. ED. COLLEGE SANGRAMPUR BULDHANA",
  "HUMAN WELFARE SOCIETY'S IDEAL JUNIOR COLLEGE OF EDUCATION, SAVANGI, AURANGABAD",
  "IDEAL COLLEGE OF EDUCATION AMBERNATH THANE",
  "INDIRA D. ED. COLLEGE KARAD SATARA",
  "JANTA SIKSHAN PRASARAK MANDAL SARASWATI ADHYAPAN VIDYALAYA (D. ED) VAITAWADI VAITAWADI",
  "J. A. T. URDU JR. COLLEGE OF EDUCATION ISLAMPURA NASIK",
  "2534-Swami Vikekanand Institute of Polytechnic, Latur",
  "JAU DURGA BHAVANI KRIDA MANDAL SHRI SURESH SASA JAIN JALGAON JALGAON",
  "JAWAHARLAL NEHRU INSTITUTE OF EDUCATION VASARNI NANDED",
  "JAYAMALHAR SEVABHAVI SANSTHA PATODA",
  "JAYASHREE MAHILA MANDAL YELGAON BULDANA",
  "KASARI KHORA SHIKSHAN SANSTHA PANHALA PANHALA",
  "KASTURBAI COLLEGE OF EDUCATION ASHOK CHOWK SOLAPUR",
  "KASTURBA JUNIOR COLLEGE OF EDUCATION RAJNEMI PARISAR SANGLI",
  "KBHSSTS ADHYAPAK VIDYALAYA MALEGAON CAMP NASHIK",
  "K E M HOSPITAL MUMBAI",
  "KHAJA BANDE NAWAZ EDUCATIONAL AND WALFARE SOCIETY ABDUR AZEEM JR. COLLEGE OF EDUCATION AURANGABAD AURANGABAD",
  "KHANDESH COLLEGE EDUCATION SOCIETYS JALGAON JALGAON",
  "Aromira School of Nursing",
  "3258-Agnel Polytechnic (Fr. Agnel Charities) , Vashi, Navi Mumbai",
  "BHIWASAN PATIL SHINDE SHIKSHAN GRAMIN VIKAS BAHUUD BULDHANA BULDHANA",
  "5395-Ashok Institute of Engineering & Technology(Polytechnic), Shrirampur.",
  "6829-Womens College of Pharmacy,Peth Vadgaon, Tq - Hatkanangale",
  "2203-Bhagwan Shikshan Prasarak Mandal's Dr. Y.S. Khedkar College Of Pharmacy, CIDCO, Aurangabad",
  "3256-Bharati Vidyapeeth's Institute of Technology, Navi Mumbai",
  "6408-Bharti Vidyaapeeth's Jawaharlal Nehru Institute of Technology, Pune",
  "B.H.S.S.TRUST'S POLYTECHNIC",
  "5265-DHULE CHARITABLE SOCIETY'S INSTITUTE OF PHARMACY DHULE",
  "2176-Chatrapati Shahu Maharaj Shikshan Sanstha, C.S.M.S. Sansthas College Of Polytechnic, Kanchanwadi, Aurangabad",
  "6469-Shahajirao Patil Vikas Pratishthan, S. B. Patil Polytechnic, Indapur",
  "3020-Sasmira's Institute of Manmade Textiles, Mumbai",
  "6237-Deccan Education Society's Technical Institute ,Pune",
  "6443-Shanti Education Society, A.G. Patil Polytechnic Institute, Solapur",
  "6407-Satara Education Society's Satara Polytechnic, Satara",
  "1140-Dhamangaon Education Society's L.A.M.I.T. Dhamangaon Rly, Amravati",
  "6479-SATARA EDUCATION SOCIETY'S LATE SUMAN DHEKANE DEPARTMENT OF PHARMACY SATARA",
  "6509-S. D. PATIL INSTITUTE OF PHARMACY URUN-ISLAMPUR",
  "4254-Krushna Sahayogi Tantra Shikshan Sanstha, Chatrapati Shivaji Institute Of Technology, Deori, Gondia",
  "3277-SHREE SHANKAR NARAYAN EDUCATION TRUSTPRAVIN PATIL COLLEGE OF DIPLOMA ENGG. & TECHNOLOGY THANE",
  "6421-DR. D.Y. PATIL PRATHISTHAN'S DR. D.Y. PATIL POLYTECHNIC KOLHAPUR",
  "6503-Shree Ambabai Talim Sanstha's Diploma In Pharmacy ,Wanlesswadi, Miraj, Sangli",
  "6495-Dr. D. Y. Patil Pratishthan's Dr. D. Y. Patil Institute Of Pharmacy, Akurdi, Pune",
  "3040-Dr. Babasaheb Ambedkar Tech.University,Institute of Petrochemical Engineering,Lonere,Raigad",
  "6736-Shivnagar Vidya Prasarak Manda'ls Institute Of Pharmacy Malegaon",
  "1155-Shikshan Prsarak Mandal's Institute of Pharmacy, Wani",
  "DR. RAM RODGE DED COLLEGE SAILU",
  "5225-Shree Sant Muktabai Sansthan's Shri Sant Muktabai Institute of Technology, Jalgaon",
  "1007-Shree Shivaji Education Society's Dr. Panjabrao Deshmukh Polytechnic, Amravati",
  "Dr.V.N.Bedekar Institute of Management Studies",
  "DR. ZAKIR HUSSAIN JR. COLLEGE OF EDUCATION PARBHANI PARBHANI",
  "GOVT. JR. COLLEGE OF EDUCATION PAITHAN AURNGABAD",
  "2143-Shri Dhaneshwari Manav Vikas Mandal's Diploma In Pharmacy Institute, At Post Gevrai Tanda, Paithan Road, Aurangabad.",
  "4602-Shri Gurudeo Educational Memorial & Cultural Society, Om Polytechnic College, Mauza Parsodi, Tal-Umrer,Nagpur",
  "2285-Shri Govindaprabhu Gramin & Shahari Vikas Sevabhavi Sanstha's MDA Institute of Polytechnic Kolpa, Latur",
  "2222-Shri Durgamata Bhu. Krida & Shikshan Sanstha's Uttamrao Deshmukh Institute Of Pharmacy(Dharmapuri), Parbhani",
  "SHRI NIKETAN COLLEGE OF EDUCATION NAGBHIR CHANDRAPUR",
  "GOVT. JR. COLLEGE OF EDUCATION WALGAON ROAD AMRAVATI",
  "5230-Shri Neminath Jain Bramhacharyasharam's Shri H. H. J. B. Polytechnic,Chandwad",
  "SHRI VENKATESHA SHIKSHAN PRASARAK MANDAL JUNIOR COLLEGE OF EDUCATION AURANGABAD AURANGABAD",
  "GOVT. JR. COLLEGE OF EDUCATION (WOMEN) OSMANPURA AURANGABAD",
  "SHRI VENKATESHWARA SHIKSHAN SANSTHA SANCHALIT NANASAHEB MAHADIK D. ED. COLLEGE WALWA SANGLI",
  "SHRI VITHAL SHIKSHAN PRASARAK MANDAL MADHA SOLAPUR",
  "GOVT. JUNIOR COLLEE OF EDUCATION WARDHA WARDHA",
  "SHRI VITTALAI CHARITABLE TRUST RADHANAGRI KOLHAPUR",
  "GOVT. JUNIOR COLLEGE OF EDUCATION BHANDARA BHANDARA",
  "SWAMI RAMANAND SHIKSHAN PRASARAK MANDAL D. ED. COLLEGE GHANSWANGI JALNA",
  "SWAMI VIVEKANAND SHIKSHAN PARSARAK MANDALS NEAR MOTI TALAV JALNA ROA BULDHANA",
  "SWAMI VIVEKANAND SHIKSHAN PRASARAK MANDALS SWAMI VIVEKANAND COLLEGE OF EDUCATION UDGIR LATUR",
  "SWAMI VIVEKANAND SHIKSHAN SANSTHA JUNIOR COLLEGE OF EDUCATION NALDURG OSMANABAD",
  "SWAMI VIVEKANAND SHIKSHAN SANSTHA TULJAPUR OSMANABAD",
  "SWARGLYA HARIBHAU MAHURE BAHUUDDESHIYA SHIKSHAN SANSTHA DEOLI WARDHA",
  "VIDYASHAKTI SHIKSHAN PRASARAK MANDAL SENGAON HINGOLI",
  "VIDYAVARDHINI SHIKSHAN &KRIDA PRASARAK MANDAL BULDANA BULDANA",
  "VIDYA VIKAS MANDAL DIPLOMA IN TEACHER EDUCATION SAKRI TAL SAKRI DHULE",
  "VIDYA VIKAS TRAINING COLLEGE SAWANTWADI SINGHUDDURG",
  "Vignaharta Adhyapak Vidyalaya Umari",
  "VIKAS SANSTHAN YA PRASHIKSHAN SANSTHA GDHANI NAGPUR",
  "LATE NIRDHANRAO PATIL WAGHAYE ARJUNI SADAK GONDIA",
  "SHRI JAYRAMSETH CHAUDHARI INSTITUTE OF NURSING EDUCATION AND PARA MEDICAL SCIENCES MURBAD",
  "GONDIA NURSING COLLEGE",
  "Navjeevan School Of Nursing Ahmedpur Dist. Latur",
  "2549-Warpudkar Institute of Pharmacy(D.Pharmacy), Pedgaon",
  "2189-Vishweshwarayya Abhiyantriki Padvika Mahavidyalay, Almala, Tq. Ausa, Dist. Latur",
  "2565-Usha Dwarkadas Pathrikar Institute of Pharmacy, Dongargaon Kawad",
  "1151-Late Ahilyabai Kakade Bahuuddeshiya Shikshan Prasarak Mandal, Sai Polytechnic,Kinhi(J),Yavatmal",
  "SHRI SAI BAHUUDDESHIY SEVABHAVI SANTHA SANCHALIT SAI INSTITUTE OF GNM NURSING SCHOOL NANDED",
  "4338-Wainganga Bahu uddeshiya Vikas Sanstha's Wainganga Technical Institute, Nagzira Road, Sakoli,",
  "KAUSHALYA INSTITUTE OF NURSING BULDHANA",
  "CHITAMANI SCHOOL OF NURSING KALAMB",
  "LATE DATTRAO HAIBATRAO THORAT NURSING SCHOOL",
  "Sanjeevani Multipurpose Foundation Dr Deepak Patil Nursing Institute Borpadale",
  "LATE ANNASAHEB KAKADE NURSING SCHOOL SAILU",
  "Priyadarsini Shikshanik Bahuuddeshaya gram Vikas mahila Sheva Bhavi Girijai School Of Nursing Shirur",
  "Om Shanti Nursing RANM College Bhokardan",
  "Dagadojirao Patil Nursing College Jalkot Tq Jalkot Dist Latur",
  "SAI NURSING SCHOOL",
  "Karm R S Wagh Education and Health Sanstha School of Nursing",
  "6482-Shri. Balasaheb Mane Shikshan Prasarak Mandal Ambap's, Ashokrao Mane Institute of Diploma in Pharmacy, Vadgaon",
  "6490-Gouri Shankar Education Society's College Of Pharmacy (D. Pharm.), Limb, Satara",
  "6489-Gourishankar Education Society's College Of Pharmacy (D.Pharm.), Degaon, Satara",
  "NEW NURSING SCHOOL",
  "Royal Education Society Sharda Institute of Nursing",
  "Datta Meghe College of Nursing",
  "3039-Prin. K.M. Kundnani College of Pharmacy Polytechnic, Ulhasnagar",
  "Ekvira Devi Nursing School",
  "Bel Air College of nursing",
  "YASHWANT SCHOOL OF NURSING GNM HINGOLI",
  "2175- Sharadchandraji Pawar Polytechnic, Bhalgaon, Aurangabad",
  "6480-POONA DISTRICT EDUCATION ASSOCIATION SETH GOVIND RAGHUNATH SABLE COLLEGE OF PHARMACY(POLY)SASWAD PUNE.",
  "2615 KOHINOOR INSTITUTE OF D PHARMACY KHULDABAD AURANGABAD",
  "SMT SHALINITAI MEGHE COLLEGE OF NURSING AND HOSPITAL BHILEWADA BHANDARA",
  "3508 B K PATIL INSTITUTE OF PHARMACY, TALOJA",
  "Chatrpati Shahu Shikshan Sanstha Subhadra Institute of Nursing School",
  "5408 VIDYA NIKETAN COLLEGE OF ENGINEERING",
  "4210 HI-TECH COLLEGE OF PHARMACY",
  "5472 SUMANTAI INSTITUTE OF PHARMACY",
  "6958-GENESIS INSTITUTE OF PHARMACY",
  "2590-DHARTI JANSEVA PRATISHTHANS COLLEGE OF PHARMACY PATHRI D PHARM",
  "6032-DEPARTMENT OF PHARMACY PUNE",
  "SHRI K R PANDAV COLLEGE OF NURSING AND HOSPITAL NEW NANDANVAN NAGPUR",
  "VIDARBHA INSTITUTE OF TECHNOLOGY",
  "ST JOHN COLLEGE OF ENGINEERING AND MANAGEMENT",
  "St John Institute of Pharmacy and Research",
  "SHRI SAI INSTITUTE OF NURSING SCHOOL RANM BORI",
  "HUDCO NURSING SCHOOL",
  "SHRI SWAMI SAMARTH NURSING SCHOOL",
  "2548JANKALYAN VIKAS MANDAL S SWARGIYA LILAWATI SATISH AWHAD D.PHARMACY COLLEGE, (MINORITY) KHANDGAON",
  "YASHODHARA NURSING INSTITUTE, SOLAPUR",
  "G S NURSING SCHOOL",
  "5433-R.C. Patel Polytechnic, Shirpur",
  "5458-Shri. Prakashchand Jain College of Pharmacy & Research, Palaskheda",
  "6915-DNYANVILAS COLLEGE OF PHARMACY, DUDULGAON TAl HAVELI DIST PUNE",
  "4240-M.S. & M.G.V.B.S., Central India Institute Of Polytechnic, Nagpur",
  "2217- Swargiya Lilawati Satish Awhad D.Pharmacy College Hokarna Campus, TQ Mukhed Dist Nanded.",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION",
  "AVG INSTITUTE OF NURSING EDUCATION",
  "MEERA NURSING SCHOOL",
  "2593-S.R. Institute of Diploma in Pharmacy, Udgir",
  "6918-JIJAMATA COLLEGE OF PHARMACY, SARATI",
  "GENERAL HOSPITAL AHMEDNAGAR",
  "BACKWARD CLASS YOUTH RELIEF COMMITTEEUMRER POLYTECHNIC NAGPUR",
  "BADSHAHI ANJUMAN ISHAATE - TALEEM SHIKSHAN SANSTHA AT. POST. TQ. PAITHAN RAZIA AURANGABAD",
  "BAHUJAN SAMAJ SHIKSHAN PRASARAK MANDALS COLLEGE OF EDUCATION (D.T.ED. COLLEGE) SONGIR",
  "BAHU UDDESHIYA GAJBHIYE SHIKSHAN SANSTHA PRAKASH D. ED. COLLEGE GOREGAON GONDIA",
  "BAHUUDDESHIYA SAMAJIK GRAMIN & SHAIKSHANIK SANSTHA KALWAN NASHIK",
  "BAJIPUR VANITA VIDYALAYA PARNAKA VASAI THANE",
  "4222 BACKWARD CLASS YOUTH RELIEF COMMITTEES NAGPUR POLYTECHNIC NAGPUR.",
  "BAL BAHGWAN SHIKSHAN PRASARAK MANDAL KANDIKIVALI (W) MUMBAI",
  "BALBHAGWAN SHIKSHAN PRASARAK MANDAL MOHANRAO PATIL D. ED. COLLEGE AHMADPUR LATUR",
  "BANABAI GAGADANI TRUST ADHYAPAK VIDYALAYA MHASAWAD JALGAON",
  "BAR RAJBHAU KHOBRAGADE BRAHMAPURI CHANDARAPUR",
  "B D PETIT PARSEE GENERAL HOSPITAL MUMBAI",
  "BGPS, MUMBAI D.ED.COLLEGE WADALA (E) MUMBAI 400037",
  "BHAGWAN BABA ADHYAPAK VIDHYALAYA D. ED. COLLEGE SANT LATUR LATUR",
  "BHAGWAN SHIKSHAN PRASARAK MANDL CIDCO AURANAGABAD",
  "BHAGWANT RAO D. ED. COLLEGEGADCHIROLI CHAMORSHI ROAD GADCHIROLI",
  "BHAIRAVNATH SHIKSHAN SANSTHA SAVITRIBAI PHULE ADHYAPIKA VIDYALAYA KHANDALA SATARA",
  "BHARATRATNA RAJIV D. ED. COLLEGE OF EDUCATION LONAR BULDANA",
  "BHARAT SHIKSHAN PRASARAK MANDAL JAIKRANTI SR. COLLEGE OF EDUCATION LONAR LATUR",
  "BHARAT SHIKSHAN PRASARAK MANDAL MAULI ADHYAPAK VIDYALAYA WADALA SOLAPUR",
  "BHAU SAHEB GANGANE ADHLYAPAK VIDYALAYA B. G. D. ED. COLLEGE SHANWARA AKOT AKOT AKOLA",
  "ACADEMY OF CARVER AVIATION PUNE",
  "BHAUSAHEB MANE SHAIKSHANIK KRUSHI PARYAVARAN SWA. PANJABRAO MANE D. ED. COLLEGE BRAHM UMARKHED YAVATMAL",
  "BHAUSAHEB PATIL JUNIOR COLLEGE OF EDUCATION KEJ BEED",
  "ADARSHA BAHUDEEESHIYA SHIKSHAN PRASARAK MANDAL SULRANPUR BULDHANA",
  "ADARSH ADHYAPAN VIDYALAYA NEAR C. B. S. GOLE COLONY NASIK",
  "ADARSH EDUCATION SOCIETY AMALNER JALGAON",
  "ADARSH SHIKSHAN PRASARAK MANDAL AT. PO. WALWADI DHULE",
  "ADARSH SHIKSHAN PRASARAK MANDAL NEW PANVEL RAIGAD",
  "BHAWABHUTI SHIKSHAN SANSTHA SHRI LAXMANRAO MANKAR COLLEGE OF EDUCATION GONDIA GONDIA",
  "BHIMA EDUCATION TRUSTS COLLEGE OF EDUCATION DAUND PUNE",
  "6514-Abhinav Education Society's College Of Pharmacy, Narhe, Tal. Haveli, Dist. Pune",
  "GOVT. JR. COLLEGE OF EDUCATION HANUMAN BASTI AKOLA",
  "4272-\tBhausaheb Mulak Charitable Trust 'S Bhausaheb Mulak College Of D. Pharmacy, Umred, Nagpur",
  "6427-BHIVRABAI SAWANT POLYTECHNIC WAGHOLI PUNE",
  "4247-ABHINAV BAHUUDDESHIYA'S SIDDHIVINAYAK COLLEGE OF PHARMACY, WARORA, DIST. CHANDRAPUR",
  "4270-Backward Class Youth Relief Committee's Institute of D. Pharmacy, Nagpur",
  "4252-Late Madhukarrao Deshmukh Education Soceity's Avdhoot Diploma College Of Engineering, Mouza, Bhojapur",
  "GRAM VIKAS SHIKSHAN SANSTHA NANDED NANDED",
  "BHOSLA ADHYAPAK VIDYALAYA NEW NANDANVAN NAGPUR",
  "BIRSA MUNDA ADIWASI BAHU-UDDESHIYA SHIKSHAN SANSTHA KELAPUR-DONGARGAON YVATMAL",
  "6015-Government Polytechnic, Miraj",
  "BIRSA MUNDA BAHUUDDESHIYA SHIKSHAN SANSTHAS LATE RAMAJI UIKE D. ED. (BOYS) COLLEGE KELAPUR DONGARGAON YAVATMAL",
  "1153-Adarsha Bahuuddeshiya Shikshan Prasarak Mandal, Dr. R . N. Lahoti Polytechnic, Sultanpur",
  "BOMBAY TEACHERS TRAINING COLLEGE COLABA MUMBAI MUMBAI",
  "BRAHMA VALLEY EDUATIONAL CAMPUS TRIMBAKESHWAR NASHIK",
  "BRAMHANAND BAHUUDDESHIYA YUWAK KALYAN SANSTHA WATHODA NAGPUR",
  "5415-ADARSH POLYTECHNIC, DHULE",
  "BRAVE SAFETY AND FIRE ACADEMY",
  "Br. Nath Pai School of Nursing Kudal",
  "3297-ADARSH SHIKSHAN MANDAL`S IDEAL COLLEGE OF PHARMACY KALYAN",
  "BUNTS SANGHA'S UMA KRISHNA SHETTY INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH",
  "B Y L NAIR CHARITABLE HOSPITAL MUMBAI",
  "6433-Vidyavardhini Charitable Trust's Abhaysinhraje Bhonsle Institute of Technology, Shahunagar- Shendra, Satara",
  "CENTRE FOR ADVANCED EDUCATION INSTITUTE OF MANAGEMENT TECHNOLOGY",
  "CHAITAINYA BHAHUUDDESHYA SHIKSHAN PRASARAK MANDAL TAL. SHIROL KOLHAPUR",
  "CHANDRAKIRAN SHIKSHAN SANSTHA LATE BHIYASAHEB URKANDE WARDHA WARDHA",
  "CHARWAK ADHYAPAK VIDYALAYA AHMEDPUR LATUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING PHALTAN SATARA",
  "GENERAL HOSPITAL SANGLI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SINDHUDURG SINDHUDURG",
  "GENERAL HOSPITAL SATARA",
  "GENERAL HOSPITAL (SHRI CHHATRAPATI SHIVAJI MAHARAJ) SOLAPUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING TAMBRI OSMANABAD",
  "GHULAM NABI AZAD URDU D. ED. COLLEGE PUSAD YAVATMAL",
  "GIRIRAJ NURSING SCHOOL PUNE",
  "GLOBAL HEALTHCARE INSTITUTE COLLEGE OF NURSING NASHIK",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING TARDA NAKA NANDE",
  "GODAVARI FOUNDATION NASHIK D. ED. COLLEGE WADALA NASHIK",
  "GODAVARI SCHOOL OF NURSING JALGOAN",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING VAIJAPUR",
  "GOKULDAS TEJPAL HOSPITAL MUMBAI",
  "GONDPIPRI COLLEGE OF EDUCATION GONDPIPRI CHANDRAPUR",
  "GOVERNMENT GIRLS D. ED. COLLEGE NASIK SATARA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING VELAPUR, SOLAPUR",
  "GOVERNMENTJUNIOR COLLEGE OF EDUCATION MANGAON RAIGAD",
  "Government Junior College of Education (Old), Babupeth, Chandrapur",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, AMRAVATI",
  "GOVERNMENTJUNIOR COLLEGE OF EDUCATION OLDJALNA",
  "3028-Father Agnel Technical College (Polytechnic), Bandra(W), Mumbai",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, LAKHALA, WASHIM",
  "2010-Government Polytechnic, Aurangabad",
  "4022-Government Institute of Hotel Management & Catering Technology, Nagpur",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING PANVEL (DIET) PANVEL RAIGAD",
  "4013-Government Polytechnic, Arvi",
  "1008-Government Polytechnic, Amravati",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING RATNAGIRI",
  "2013-Government Polytechnic, Ambad",
  "District Institute of Education & Training, Shivaji Nagar, Hingoli Dist. Hingoli",
  "5006-Government Polytechnic, Ahmednagar",
  "6259-Gourishankar Education & Charitable Trust, Gourishankar Polytechnic,Limb, Satara",
  "6011-Government Polytechnic, Awasari (Khurd)",
  "D. K. PATIL EDUCATION TRUST PALGHAR THANE",
  "2011-Government Polytechnic, Beed",
  "4012-Government Polytechnic, Sadar, Nagpur",
  "2192-Education Society, Kalawatibai College Of Engineering & Technology (Polytechnic), Naigaon, Nanded",
  "D. L. PATIL ADHYAPAK VIDYALAYA WADA THANE",
  "1014-Geetadevi Khandelwal Institute of Pharmacy, Akola",
  "Dnayan sanvardharn adhyapak vidhyalay hinganghat",
  "6835-Gandhi Natha Rangji College of Diploma Pharmacy, Solapur",
  "1280\tGawande College of Pharmacy Sakhar Kheda",
  "DHANVANTRI SHIKSHAN VA SAMAJIK PRATISHTHAN VIKAS D. ED. WARJE NARE PUNE",
  "6430-Genba Sopanrao Moze Institute of Technology, Balewadi, Tal.Haveli",
  "5294-Godavari Shikshan Mandal's Asian Institute of Pharmacy, Nashik.",
  "D. N. M. D. ED. COLLEGE VIDYAVARDHINI EDUCATION STN BHIVPURI ROAD RAIGAD",
  "5250-G.H.R. Education Foundation, G.H. Raisoni Polytechnic, Saokhede Bk, Jalgaon",
  "4264-Gondiya Education Society's Manoharbhai Patel Institute of Pharmacy, Gondia",
  "DNYANGANGA SHIKSHAN PRASARAK MANDAL SHRIPATRAO TAL PANHALA KOLHAPUR",
  "4245-Gopal Education Soceity's Shri Mukundrao Pannase Polytechnic, Mauza Mondha",
  "DNYANSAGAR ADHYAPAK VIDYALAYA DEVLALI SOLAPUR",
  "6454-D. Y. Patil Educational Socity's D.Y. Patil College Of Engineering & Polytechnic, Kolhapur",
  "6404-Ekalavya Shikshan Sanstha's Polytechnic,pune",
  "6756-Fabtech Technical Campus College of Engineering and Research, Sangola",
  "DNYAN VARDHANI COLLEGE OF EDUCATION BALSOND HINGOLI",
  "Government RANM Nursing School, Babhalgaon Latur",
  "DNYAN VIKAS MANDAL PRIYDARSHANI ADHYAPAK VIDYALAYA SAKRT SAKRI DHULE",
  "GOVERNMENT URDU JR. COLLEGE OF EDUCATION FOR MEN PUNE PUNE",
  "GOVT. JUNIOR COLLEGE OF EDUCATION HADGAON NANDED",
  "GOVT. JUNIOR COLLEGE OF EDUCATION KANNAD AURANGABAD",
  "DNYANWARDHINI SHIKSHAN PRASARAK MANDAL LATE ANNASAHEB PARBHANI PARBAHANI",
  "GOVT. JUNIOR COLLEGE OF EDUCATION NAIK NOOR BEED",
  "GOVT. JUNIOR COLLEGE OF EDUCATION SASWANE RAIGAD",
  "DR. BABASAHEB ADHYAPAK VIDYALAYA JUNIOR COLLEGE OF EDUCATION PEZARI ALIBAGH RAIGAD",
  "GOVT. JUNIOR COLLEGE OF EDUCATION UDGIR LATUR",
  "GOVT. JUNIOR COLLEGE OF EDUCATION VIDYANAGAR PARBHANI",
  "DR. BABASAHEB AMBEDKAR ADHYAPAK VIDYALAYA KANDAHR NANDED",
  "Govt. Nurisng Trainng Center, S.G.G.M.Hospital, Nanded",
  "GOVT. PRE-PRIMARY TRAINING COLLEGE NAGPUR NAGPUR NAGPUR",
  "5404-Gurukul Education Society's Institute of Engineering & Technology, Nandgaon",
  "HAJRAT AYSHA SIDDIQUA URDU DTED GIRLS COLLEGE DARWHA",
  "DWARKA MULTIPURPOSE VILLAGE DEVELOPMENT FOUNDATION SHAHU MAHARAJ D. ED. (GIRLS) COLLEGE PANCHAYAT BULDHANA",
  "HANUMAN GRAMVIKAS PRATISHTAN HINGANA-KUMBHARI BHAUSAHEB BIDKAR D.ED COLLEGE, SHIVANI AKOLA",
  "HARIOM BAHUUDDESHIYA SEVABHAVI SANSTHA TIRUMALLA LATUR LATUR",
  "DYANDEEP ADHYAPAK VIDYALAYA MANTHA JALNA",
  "Dyan Vikas D Ed College, Koprkhairane",
  "INDIRA BAHUDDESHIYA SHIKSHAN SANSTHA CHIKHLI ROAD BULDHANA",
  "INDIRA BAHUUDDESHIYA SHIKSHAN SANSTHA MALKAPUR BULDHANA",
  "D Y PATIL INSTITUTE OF NURSING EDUCATION KOLHAPUR",
  "INDIRA BAHUUDESHIYA SHIKSHAN SANSTHA ADHYAPAK VIDYALAYA MALKAPUR BULDANA",
  "INDIRA GANDHI ADHYAPAK MAHAVIDYALAYA UPNAGAR NASIK",
  "EDUCATION SOCIETY NAIGAON NANDED",
  "INDIRA GANDHI (URDU) D. ED. COLLEGE NANDED",
  "INDIRA INSTITUTE OF AIRCRAFT ENGINEERING PUNE",
  "EKLAYA ADIVASI BHATAKYA VIMUKTA JATI-JAMATI VA SANGAMNER AHMEDNAGAR",
  "INDO GERMAN TOOL ROOM",
  "INDRABHAGYA KRISHI VA GRAMIN VIKASH SANSTHA DIGHANCHI SANGLI",
  "INDUTAI MEMORIAL D. ED. COLLEGE TUMSAR BHANDARA",
  "ETHEL GORDON JUNIOR COLLEGE OF EDUCATION PUNE PUNE",
  "Institute for Design of Electrical Measuring Instruments",
  "INSTITUTE FOR FUTURE EDUCATION ENTREPRENEURSHIP AND LEADERSHIP",
  "EVANGELINE BOOTH HOSPITAL AHMEDNAGAR",
  "INSTITUTE OF AIRCRAFT MAINTENANCE ENGINEERING AURANGABAD",
  "INSTITUTE OF NURSING EDUCATION PARBHANI",
  "FLORENCE NIGHTINGALE INST OF NURSING MUMBAI",
  "INSTITUTE OF NURSING EDUCATION SANGLI",
  "INTERNATIONAL INSTITUTE OF MANAGEMENT STUDIES",
  "FRIENDS EDUCATION SOCIETY SHAKUNT HARISH D. ED. COLLEGE KENDREWADI BEED",
  "INTERNATIONAL SCHOOL OF BUSINESS AND MEDIA",
  "IQRA JUNIOR COLLEGE OF EDUCATION",
  "GANDHI GRAM D. ED. COLLEGE BARBADI ROAD WARDHA",
  "ISHWAR DESHMUKH ADHYAPAK VIDYALAY DIGRAS",
  "JAGDAMBA EDUCATION SOCIETYS JAGDAMBA SCHOOL OF RGNM NURSING, BABHOLGAON, YEOLA",
  "GANGAMAI INSTITUTE OF EDUCATION WAGHADI",
  "JAGDAMBA EDUCATION SOCIETYS S N D SCHOOL OF RANM NURSING, BABHULGAON, YEOLA",
  "JAGDAMBA EDUCATION SOCIETYS YEOLA NASIK",
  "4235-JAI MAHAKALI SANSTHA;S AGNIHOTRI SCHOOL OF TECHNOLOGY RAMNAGAR WARDHA",
  "JAGDAMBA SHIKSHAN PRASARAK MANDALS COLLEGE OF EDUCATION GEORAI BEED",
  "JAGDAMHA SHIKSHAN PRASARAK MANDAL CHHATRAPATI SANKUI BEED",
  "JAGRUTI ADHYAPAK VIDYALAYA TASGAON SANGLI",
  "JAIBHAVANI SHIKSHAN PRASARAK MANDAL GEORAI BEED",
  "JAI GANESH EDUCATIONAL FOUNDATION JAI GANESH ADHYAPAK PUNE PUNE",
  "JAI JAWAN JAI KISAN SHIKSHAN PRASARAK MANDAL KANDHAR NANDED",
  "JAI SHRI KRISHNA SHIKSHAN PRASARAK MANDAL AURANGABAD AURANGABAD",
  "2187-HINDUSTANI EDUCATION SOCIETY N.B.S. INSTITUTE OF POLYTECHNIC AUSA LATUR",
  "5251-Hon. Shri. Babanrao Pachpute Vichardhara Trust's Parikrama Polytechnic,Kashti",
  "2213-Jalana Education Society's Institute Of Pharmacy,Jalna",
  "4255-Jai Mahakali Shikshan Sanstha's Agnihotri Polytechnic, Sindhi (Meghe), Wardha",
  "3469-MAHARASHTRA POLYTECHNIC SHENALE,MANDANGAD",
  "6431-Sai Charitable Trust, Indira Institute Of Diploma Engineering(Poly), Sasure, Tal. Barshi",
  "5221-Shri Chhatrapati Shivaji Shikshan Sanstha's Indira Gandhi Poly. Belwandi (su) ,Tal-Shrigonda Dist- Ahmednagar",
  "2193-Sahayog Sevabhai Sanstha, Indira Institute Of Technology(Polytechnic), Nanded.",
  "5241-Jagdamba Edu Soc., Santosh N. Darade Polytechnic, Yeola, Nashik",
  "2023-Jai Bhavani Shikshan Prasarak Mandal's Institute Of Pharmacy, Gadhi Georai",
  "3279-INSTITUTE OF PRINTING TECHNOLOY AND RESEARCH PANVEL",
  "4246-JAIDEO EDUCATION SOCIETY J.D. POLYTECHNIC KHANDALA NAGPUR",
  "JAMHOOR JUNIOR COLLEGE OF EDUCATION (URDU), UDGIR",
  "6418-Jaihind Comprehensive Educational Institute's Jaihind Polytechnic, Kuran,Tal. Junnar",
  "JAMIA JUNIOR COLLEGE OF EDUCATION D.T.ED. AKKALKUWA DIST. NANDURBAR",
  "JANATA SHIKSHAN PRACHARAK SAMITIS DOKALI THANE",
  "JANKAYAN SANSTHA SHRI MAHADEORAO SHIVAKAR ADHYAPAK GONDIA GONDIA",
  "JANTA JUNIOR COLLEGE OF EDUCATION CHANDRAPUR CHANDRAPUR CHANDRAPUR",
  "JAYDAYA SHIKSHAN PRASARAK MANDAL` SAKRI DHULE",
  "JAY DURGA BAHUUDDESHIYA SHIKSHAN PRASARAK MANDAL DARWHA YAVATMAL",
  "JAY JAGDAMBA BAHU-UDDESHIYA SANSTHA SARJAPUR SOLAPUR",
  "JAYWANT SHIKSHAN PRASARAK MANDAL IMPERIAL ADHYAPAK HADAPSAR PUNE",
  "J. D. PATIL SANGLUDKAR SMRTI KENDRA DARYAPUR D. ED COLLEGE DARYAPUR AMRAVATI",
  "JEEVAN JYOT NURSING COLLEGE, OSMANABAD",
  "JIJAMATA BAH-UDDESHIYA SHIKSHAN PRASARAK MANDAL JALKOT LATUR",
  "JIJAMATA SHIKSHAN PRASARAK MANDAL D. ED COLLEGE KANNNAD AURANGABAD",
  "KHEMAJI NAIK COLLEGE OF EDUCATION KORPANA CHANDRAPUR",
  "KING EDWARD MEMORIAL HSOPITAL PUNE",
  "JIJAU SHIKSHAN MAHAVIDYALAYA SANDEEP TALKIES YAVATMAL",
  "KISAN DNYANODAY MANDAL CHALISGAON JALGAON",
  "KISAN SHIKSHAN PRASARAK MANDALS BORGAON LATUR",
  "JIJAV BAHUUDDESHIYA SANSTHA AMALNER AMALNER",
  "KISAN VIDYA PRASARAK SANSTHA SHIRPUR KISAN ADHYAPAK VIDYALAYA SHIRPUR DHULE",
  "K J SOMAIYA HOSP. AND RES. CTR. MUMBAI",
  "K.J.SOMAIYA INTITUTE OF MANAGEMENT STUDIES & RESEARCH",
  "JITENDRA PAWAR (DADA) D. ED COLLEGE PUSESAWALI SATARA",
  "K. L. E. SOCEITYS D. ED. COLLEGE ICHAKARANANJI SOLAPUR",
  "K. M. ASGHAR HUSAIN COLLEGE OF EDUCATION AKOLA",
  "K. M. S. JUNIOR COLLEGE OF EDUCATION PAREL MUMBAI",
  "JOHN WILSON EDUCATION SOCIETYS D. ED. COLLEGE JALNA JALNA",
  "KOHINOOR MANAGEMENT SCHOOL",
  "JR. COLLEGE OF EDUCATION DANDEGAON GONDIA BHANDARA",
  "KOPARGAON TALUKA VIDYARTHI SAHAYYAK SAMITI'S SHRI. CHAKRADHAR SWAMI D.T.ED. COLLEGE, KOPARGAON",
  "KOPARGAON TALUKA VIDYATHI SAHAYAK SAMITI KOPARGAON",
  "JR. COLLEGE OF EDUCATION GONDIA BHANDARA",
  "KOTHARI ADHYAPAK VIDYALAYA NANDURA NANDURA BULDANA",
  "KRANTI NURSING SCHOOL AHMEDNAGAR",
  "JULEKHA D. ED. COLLEGE HINDUSTANI EDUCATION SOCIETY DIAT LATUR LATUR",
  "KRANTISMRUTI JR. COLLEGE OF EDUCATION, SATARA",
  "JUNIOR COLLEGE OF EDUCATION (D. ED) PINGLI PARBHANI",
  "KRISHNA HOSP. & MEDICAL RESEARCH CENTRE SATARA",
  "KRUSHNA SAHAYOGI TANTRA SHIKSHAN SANSTHA TUMSA BHANDARA",
  "JUNIOR COLLEGE OF EDUCATION KHIRODA JALGAON",
  "KRUSHNS SAHAYOGI TANTRA SHIKSHAN SANSTHAS CHATARAPATI JR COLLEGE OF EDUCATION DEORI GONDIA",
  "KUNBI SHIKSHAN PRASARAK SANTHA JUNIOR COLLEGE OF EDUCATION KHED RATNAGIRI",
  "JUNIOR COLLEGE OF EDUCATION MITHBAY",
  "Kurundwad Institute Of Nursing Education,Kurundwad",
  "2284-Kiran Bahuuddeshiya Shikshan Sanstha's R R Polytechnic, Hasegaon (K), Tal. Kalamb, Dist Osmanabad",
  "JUNIOR COLLEGE OF EDUCATION PANDHRPUR SOLAPUR",
  "5285-KAKASAHEB MHASKE MEMORIAL MEDICAL FOUNDATION`S KAKASAHEB MHASKE COLLEGE OF PHARMACY NAGAPUR AHMEDNAGAR",
  "3275-Kala Vidyamandir Institute of Technology, Malad(W), Mumbai",
  "5371-Karmaveer R.S.Wagh Education & Health Institute, Kadwa Polytechnic, Rajaram Nagar, Tal-Dindori, Nashik",
  "JUNIOR COLLEGE OF EDUCATION PETALA KOLHAPUR",
  "6544-Karmveer Bhaurao Patil Shikshan Sansthan's Sahyadri Polytechnic,Pune",
  "6456-KASEGAON EDUCATION SOCEITY'S POLYTECHNIC LOHAGAON",
  "INSTITUTE OF CIVIL AND RURAL ENGINEERING",
  "5276-KHANDESH EDUCATION SOCIETY`S COLLEGE OF PHARMACY AMALNER JALGAON",
  "1277-KIRTI POLYTECHNIC, UTTAM NAGAR, AMRAVATI",
  "5275-KISAN DNANODAYA MANDAL'S INSTITUTE OF PHARMACY CHALISGAON JALGAON",
  "JUNIOR COLLEGEOF EDUCATION PUNE PUNE",
  "5267-KISAN VIDYA PRASARAK SANSTHA`S MAHARANI AHILYABAI HOLKAR COLLEGE OF PHARMACY BORADI",
  "JUNIOR COLLEGE OF EDUCATION RAHIMATPUR SATARA",
  "3021-K. J. SOMAIYA POLYTECHNIC MUMBAI",
  "5226-K.K WAGH EDUCATION SOCIETY'S K. K. WAGH POLYTECHNIC NASHIK",
  "6023-Kolhapur District Chemist Asso. Inst. Of Pharmacy, Kolhapur",
  "KAGAL EDUCATION SOCIETIE D. R. MANE MAHAVIDYALAYA CAMPUS KAGAL KOLHAPUR",
  "6516-KRISHNA CHARITABLE TRUST`S KRISHNA COLLEGE OF PHARMACY MALKAPUR KARAD",
  "4280-KRUSHNA SAHYOGI TANTRA SHIKSHAN SANSTHA`S CHATRAPATI SHIVAJI COLLEGE OF PHARMACY DEVARI TAL DEVARI GONDIYA",
  "5367-K.V.N.NAIK S. P. SANSTHA?S POLYTECHNIC NASHIK",
  "KAI. AAMDAR GOVINDRAO PATIL BAHHUDESHIYA UDGIR LATUR",
  "6814-K.P. Patil Institute ( Polytechnic ), Bhudargad, Dist.Kolhapur",
  "LAHANUJI MAHARAJ BAHUUDDESHIYA SHIKSHAN PRASARAK MANDAL DARYAPUR AMRAVATI",
  "KAI ANJANBAI RAMCHANDRA SRUYAWANSHI D. ED COLLEGE MUNGASE NASIK",
  "LAKJIVAN BAHUDESHIYA SEVABHAVI SANSTHA LOKRAJA D. ED AHMEDPUR LATUR",
  "LATE ABASAHEB KHEDKAR SHIKSHAN SANSTHA LATE SHOBHATAI AKOT AKOLA",
  "KAI BHAUSAHEB HIRAY SMARNIKA SAMITI TRUST NEW ENGLISH D. ED COLLEGE ATSOYGON MALEGAON NASIK",
  "LATE. BANSARAJ SINGH THAKUR EDUCATION SOCIETY NIRALA D. ED. NAGPUR NAGPUR",
  "LATE CHANGDEVRAO BANGAR NURSING SCHOOL, BHOOM",
  "KAI. RAI MAHESH SAOKAR PORREDDIWAR ADHYAPAK MAHAVIDYALAYA DHANORA GADCHIROLI",
  "LATE DAGADABAI CHAMPALALJI BIYANI, SHAIKSHANIK VIKAS MANDAL SANCHALIT, BIYANI D.ED. COLLEGE, JALGAON",
  "MAHARASHTRA JR. COLLEGE OF EDUCATION AJNI NAGPUR",
  "MAHARASHTRA JR. COLLEGE OF EDUCATION CHANDUR BAZAR AMRAVATI",
  "KHANDOBA SHIKSHAN PRASARAK MANDAL BHOKARDAN BHOKARDAN JALNA",
  "MAHARASHTRA MAGASVARGIYA SHAIKSHNIK AND SAMAJIK VIKAS MANDAL LAKHANDUR BHANDARA",
  "MAHARASHTRA MAGASVARGIYA SHAIKSHNIK AND SAMAJIK VIKAS MANDAL MORGAON GONDIA",
  "MAHARASHTRA NURSING SCHOOL, CHAKUR, LATUR",
  "MAHARASHTRA SHIKSHAN MANDAL SANGMESHWAR E. ED COLLEGE SHIVNAGAR LATUR",
  "KHATOON MINORITY WOMEN SOCIAL AND EDUCATION SOCIETY MALEGAON MALEGAON",
  "MAHARSHI KARVE STREE-SHIKSHAN SANSTHA NARGUNDKAR EDUCATIONAL COMPLEX NAGPUR NAGPUR",
  "MAHARSHI SHINDE ADHYAPAK VIDYALAYA SHIVAJI NAGAR NASIK",
  "UTTAMRAO DAHAKE SHIKSHAN MAHAVIDYALAYA KANHERI SARAP TAL BARSHI TAKALI DIST AKOLA",
  "MAHASHRI SHAIKSHANIK AND KRISHI SANSTHA NANDURBAR NANDURBAR",
  "6519-Loknete Maa. Hanumantrao Patil Charitable Trust's Adarsh Institute Of Pharmacy, Vita",
  "KADARIYA MUSLIM EDUCATION MULTIPURPOSE CHARITABLE TRUST KADARIYA D. ED. COLLEGE CHIKHLI ROAD BULDANA",
  "MAHATMA JYOTIBA PHULE BAHUUDDESHIYA SHIKSHAN CHIKHILI BULDANA",
  "MAHATMA PHULE JR. COLLEGE OF EDUCATION SATARA SATARA",
  "MAHATMA PHULE VIDYANIKETAN SANSTHA HADPASAR PUNE",
  "MAHILA ASHRAM JR. COLLEGE OF EDUCATION MAHILA ASHRAM WARDHA",
  "MAHILA BAHUDDESHIYA SHIKSHAN SANSTHAS D. ED. COLLEGE OF EDUCATION WARDHA WARDHA",
  "MAHILA JR. COLLEGE OF EDUCATION CHANDRAPUR CHANDRAPUR",
  "MAHILA JUNIOR COLLEGE LOF EDUCATION BHANDARA DISTBHANDARA DISTBHANDARA",
  "MAITREYA SHIKSHAN PRASARAK MANDAL NANDANVANA COLONY AURANGABAD",
  "MAJALGAON VIKAS PRATISHTHAN MANJALGAON MAHILA D. ED COLLEGE MAJALGAON MAJALGAON",
  "MANAV SADHAN VIKAS SANSTHAs SCHOOL OF NURSING, SINDHUDURG",
  "MANGANGA SHIKSHAN SANSTHA ATPADI ATPADI",
  "MANJRA CHARITABLE TRUST WORLI MUMBAI",
  "MARATHA VIDHYA PRASARAK SAMAJ'S ADHYAPAK VIDYALAYA SINNAR, NASHIK",
  "MARATHI JUNIOR COLLEGE OF EDUCATION MALEGAON NASIK",
  "6523-MAHARASHTRA COSMOPOLITAN EDUCATION SOCIETY INSTITUTE OF PHARMACY(DIPLOMA) AZAM CAMPAUS PUNE",
  "6019-MAHARASHTRA INSTITUTE OF PRINTING TECHNOLOGY(AIDED) PUNE",
  "4598-MAHARASHTRA SHIKSHAN PRASARAK MANDALSSOMMAYA DIPLOMA IN ENGINEERING WADGAON DIST CHANDRAPUR",
  "2024-MAHARASHTRA SHIKSHAN SAMITI'S MAHARASHTRA POLYTECHNIC (D. PHARMACY) INSTITUTE NILANGALATUR",
  "MATOSHRI EDUCATION SOCIETYS MATOSHRI SCHOOL OF ANM NURSING, BABHULGAON, YEOLA",
  "5357-Maharashtra Shikshan Vikas Mandal's Loknete Gopalraoji Gulwe, Polytehnic,Vilholi,Nashik",
  "MATOSHRI EDUCATION SOCIETYS MATOSHRI SCHOOL OF ANM NURSING, EKLAHARE",
  "6027-MAHARASHTRA STATE INSTITUTE OF HOTEL MANAGEMENT & CATERING TECHNOLOGYPUNE",
  "2181-Mahatma Basaveshwar Education Society's T.B.Girwalkar Polytechnic, Ambejogai, Dist.Beed",
  "2214-MAHATMA BASVESHWAR EDUCATION SOC COLLEGE OF PHARMACY BARSHI ROAD LATUR",
  "MATRUBHOOMI NURSING SCHOOL, UDGIR",
  "1163-MAHILA UTKARSHA PRATISHSTAN`S PHARMACY COLLEGE RISOD WASHIM",
  "4276-MAHILA VIKAS SANSTHA'S DR. R.G. BHOYAR INSTITUTE OF PHARMACY WARDHA",
  "MATSYODARI SHIKSHAN SANSTHAS COLLEGE OF EDUCATION JALNA",
  "3291-MANDAR EDUCATION SOCIETY'S COLLEGE OF PHARMACY(DIPLOMA) PEDHAMBE",
  "3255-MANDAR EDUCATION SOCIETY'S RAJARAM SHINDE INSTITUTE OF ENGINEERING AND TECHNOLOGY PEDHAMBE",
  "3270-MARATHA MANDIR'S BABASAHEB GAWADE INSTITUTE OF TECHNOLOGY MUMBAI",
  "MATUSHRI SHIKSHAN SEVA MANDAL MATUSHRI ADHYAPAK VIDYALAYA (D. ED. ) SHEGAON SHEGAON",
  "4275-MAHATMA PHULE SAMATA SHIKSHAN SANSTHA`S K D PAWAR COLLEGE OF PHARMACY SAONER NAGPUR",
  "Maulana Mohd. ALi Johar D. El. Ed College",
  "3283-Mahatma Education Society's, Pillai HOC Polytechnic, Rasayani",
  "MARATHWADA ASSOCIATION FOR SOCIAL SERVICESS KHULTABAD AURANGABAD",
  "MAULE KALA KRIDA SHAIKSHANIK SANSKRUTIK & KRUSHI VIKAS PRATISHTAN KHANDALA SATARA",
  "MARATHWARD SHIKSHAK PRASARAK MANDAL LAL BAHADUR SHASTRI D. ED COLLEGE PARTUR JALNA",
  "MARY BHORE SCHOOL OF NURSING SANGLI",
  "MAULI PRATHISTHAN LATE MARUTI BADHE ADHYAPAK VIDYALAYA HAVELI AURANGABAD",
  "MASUMIYA URDU D. ED. COLLEG FOR WOMEN MUKUND NAGAR AHMEDNAGAR",
  "MEDICAL MISSION SECULAR INSTITUTE, NITYASEVA HOSPITAL NURSING SCHOOL SHEGAON, AHMADNAGAR",
  "MATHURAI SHIKSHAN SANSTHA JALGAON CHALISGAON",
  "MATOSHRI EDUCATION SOCIETYS M A D SCHOOL OF RANM NURSING, DHANORE, YEOLA",
  "MEHMUDA SHIKSHAN & MAHILA GRAMIN GODHNI NAGPUR",
  "MELGHAT ADIWASI VIDYALAYA CHIKHALDARA AMRAVATI",
  "MGM INSTITUTE OF NURSING EDUCATION",
  "MHAVIDARBHA BHIKKU SANGH BHADRAWATIS TAKSHASHILA JUNIOR COLLEGE OF EDUCATION BHADRAWAT CHANDRAPUR",
  "MODEL COLLEGE OF EDUCATION JUBILEE PARK AURANGABAD",
  "PES JUNIOR COLLEGE OF EDUCATION NAVI MUMBAI THANE",
  "PHULE SAMAJ SUDHARAK SAMITI MUKHED NANDED",
  "5013-Mahatma Gandhi Taluka Shikshan Mandal's Sharadchandrika S. Patil Inst of Technology, Chopda",
  "PIMPALNER EDUCATION SOCIETY SAKRI DHULE",
  "PRABHADEVI  SCHOOL  OF  NURSING, CHANDRAPUR",
  "2022-MAULANA AZAD EDUCATION SOCIETY'S KAMLA NEHRU POLYTECHNIC (PHARMACY)(PRIVATE) AURANGABAD",
  "PRABHAKAR MAMULKAR D. ED. COLLEGE RAJURA CHANDRAPUR",
  "PRABHAKAR PATIL EDUCATION SOCIETY ALIBAG RAIGAD",
  "PRADNYA BAHUUDDESHIYA MAHILA SANSTHA SHEGAON BULDANA",
  "6007-Walchand College of Engineering, Sangli",
  "PRADNYA PRATISHTHAN WAMAN NAGAR NANDED",
  "PRAGAT MAHILA MANDAL TULJA BHAVANI D. ED. COLLEGE DEGLOOR NANDED",
  "PRAJASATTAK COLLEGE OF EDUCATION BHANDARA ROAD NAGPUR",
  "PRATAP JUNIOR COLLEGE OF EDUCATION NIGARE KOLHAPUR",
  "NAGNATH EDUCATION SOCIETY D. ED. COLLEGE HATKANANGLE KOLHAPUR",
  "PRATIBHA SCHOOL OF NURSING",
  "PRAVARA MEDICAL TRUST AHMEDNAGAR",
  "NAGRIK JR. COLLEGE OF EDUCATION MAHAL NAGPUR",
  "PRAVARA RURAL COLLEGE OF EDUCATION RAHATA AHMEDNAGAR",
  "PRAYTNA NURSING COLLEGE",
  "NAMDEOJAGTAPADHYAPAK VIDYALAYA KARMALA SOLAPUR",
  "PRERANA EDUCATION SOCIETY NARKHED NAGPUR",
  "SARASWATI ADHYAPAK VIDYALAYA KINWAT NANDED",
  "PUJYA SANE GURUJI EDUCATION SOCIETY MALEGAON NASIK",
  "NAS COLLEGE OF EDUCATION (DEEP EDUCATION SOCIETY) PALGHAR THANE",
  "PUNE INSTITUTE OF AVIATION TECHNOLOGY PUNE",
  "PUNE ZILLA SHIKSHAN MANDAL PAUD ROAD PUNE",
  "NASIK DISTRICT MARATHA VIDYA PRASARAK DINDORI NASIK",
  "PUNJABAI PATEL COLLEGE OF EDUCATION GONDIA GONDIA",
  "PYARABAI SOMANI ADHYAPIKA VIDYALAYA DEOPUR DHULE",
  "2025-Panchakshri Shivacharya Trust's Channa Basweshwar Institute Of D. Pharmacy, Latur",
  "NASIK MEDICO TRAINING PVT LTD NASIK",
  "1158-PARAMHANSA RAMKRISHNA MAUNIBABA SHIKSHAN SANTHA`S ANURADHA COLLEGE OF PHARMACY CHIKHALI",
  "1250-PARAMHANS RAMKRISHNA MOUNI BABA SHIKSHAN SANSTHA'S ANURADHA POLYTECHNIC ANURADHA NAGARCHIKHALI BULDHANA.",
  "NATIONAL HEALTH LAW RESEARCH INSTITUTES, CHINGUAAI INSTITUTE OF NURSING EDUCATION,KAVATHE MAHANKAL,",
  "St Paul Nursing College, Bamni",
  "NATIONAL INSTITUTE OF BANK MANAGEMENT, PUNE",
  "NATIONAL URDU ADHYAPAK VIDYALAYA (URDU) AGRA ROAD KALYAN",
  "NATIONAL URDU D. ED. COLLEGE SILLOD AURANGABAD",
  "NATIONAL URDU GIRLS D. ED. COLLEGE NEAR POWER HOUSE JALNA",
  "NATIONAL WOMENS WELFARE SOCIETY DARWHA YAVATMAL",
  "NAVAL BHAU PRATISHTHANS AMALNER JALGAON",
  "Navbharat Junior College of Education, Wardha",
  "NAVINBHAI SHAH PRATHISTAN SANGAMNER AHMEDNAGAR",
  "4233-Lokmanya Tilak Jankalyan Shikshan Sanstha's Priyadarshini Polytechnic, Nagpur",
  "6413-Pimpri Chinchwad Education Trust's Pimpri Chinchwad Polytechnic,Pune",
  "NAVIN OSMANABAD ZILLA BALVIKAS SAMITEE BANK COLONY OSMANABAD",
  "5231-Poojya Sane Guruji Vidhya Prasarak Mandal's G. M. Choudhari Polytechnic, Shahada",
  "NAVINRMAN PRATISHTHAN LATE KAKA SAHEAB RAMRAO VISHNU PATIL SAKRI DHULE",
  "6125-POONA DISTRICT EDUCATION ASSOCIATION SHANKARRAO URSAL COLLEGE OF PHARMACY(DIPLOMA) KHARADI TAL: HAVELI",
  "NAVJEEVAN EDUCATION SOCIETY BHANDUP MUMBAI",
  "5220-PRAVARA RURAL EDUCATION SOCIETY'S PADMASHRI DR. VITTALRAO VIKHE PATIL POLYTECHNIC AHMEDNAGAR",
  "2545-P.T.S.P.MANDALS PHARMACY COLLEGE, MANWATH",
  "NAVJEEVAN EDU. SOCIETYS COLLEGE OF EDU. & RESEARCH KARJAT RAIGAD",
  "5012-Pravara Rural Education Society's Pravara Rural College Of Pharmacy, Pravaranagar",
  "Navjeevan nursing school chamorshi dist. gadchiroli",
  "4597-Jai Mahakali Shikshan Sanstha, Pulgaon Polytechnic,Pulgaon, Tah-Deoli,Wardha",
  "6625-Universal College of Engineering & Research, Sasewadi (POLYTECHNIC SECOND SHIFT)",
  "NAVNEET BAHUDDESHIYA SANSTHAS KINKAR COLLEGE OF EDUCATION SELOO WARDHA",
  "3284-PRABHAKAR PATIL EDUCATION SOCIETY'S, POLYTECHNIC,RAIGAD",
  "QUEENS COLLEGE OF EDUCATION PARBHANI PARBHANI",
  "NAV PRATIBHA D. ED. COLLEGE NAGPUR AURVDIK COLLEGE AYODHYA NAGAR NAGPUR",
  "RADHASWAMI VIVIDH KARYKARI EDUCATION SANSTHA HASANBAG ROAD NAGPUR",
  "RADHSWAMI VIVIDH KARYKARI EDUCATION SANSTHA RAMANA MAROTI ROAD NAGPUR",
  "RAHAGANDALE D. ED. JUNIOR COLLEGE OF EDUCATION SENDUR WADA BHANDARA",
  "RAJABHAU REDIJ ADHYAPAK VIDYALAYA CHIPLUN RATNAGIRI",
  "RAJANI SMRUTI NURSING SCHOOL, DHULE",
  "RAJARAM BHOSALE SOCIAL AND EDUCATIONAL SOCIETY MALSIRAS SOLAPUR",
  "SARASWATI BAHUDDESHIYA SAMAJ SHIKSHAN SANSTHA KALMESHWAR NAGPUR",
  "SARASWATI EDUCATION SOCIETY'S SHREE TIRUPATI TANTRA NIKETAN AKOLA",
  "SARASWATI MAHILA BAHUDDESHIYA SHIKSHAN SANSTHA HINGNA NAGPUR",
  "SARASWATI MATA SHIKSHAN PARASARAK SANSTHA SOYGAON NASIK",
  "SARAVODAY SHIKSHAN SANSTHAS WASHI OSMANABAD",
  "SARDAR VALLABHBAI PATEL ADHYAPAK VIDYALAYA DHARANGAON JALGAON",
  "3264-Sahyadri Shikshan Sanstha's Sahyadri Poly.Sawarde(Ratnagiri)",
  "6442-Sant Gajanan Maharaj Rural Polytechnic, Gadhingaj, Kolhapur",
  "SHAHAPUR TALUKA EDUCATION SOCIETY THANE SHAHAPUR",
  "SHAH BABU EDUCATION SOCIETY SHAH BABU D. ED. COLLEGE PATUR AKOLA",
  "6828-Sant Tukaram Polytechnic, Indori, Talegaon",
  "SHAHEED DUNICHAND TEJANDAS KALANI MEMORIAL TRUSTS COLLEGE OF EDUCATION ULHASNAGAR-1 THANE",
  "SHAHU SHIKSHAN SANSTHA BORIVALI (W) MUMBAI",
  "4243-Sanmarg Shikshan Sanstha'sm Smt. Radhikatai Pandav Polytechnic, Besa, Nagpur",
  "SHAHU SHIKSHAN SANSTHA (PANDHARPUR) KUSUMAGRAJ WOMENS COLLEGE EDU. PANCHAVA NASIK",
  "5360-Savitabai Phule Shikshan Prasarak Mandal's Rajendra Jotiram Phule Polytechnic, Mirajgaon Tal Karjat. Ahmednagar",
  "4231-Sanmarg Shikshan Sanstha's Late Vasantdada Polytechnic, Nagpur.",
  "6476-Sau. Devibai Narayandas Chhabada Rural Education Soceity,Late N.B. Chhabada Institute Of Engg & Tech.(Poly), Satara",
  "SHAHU SHIKSHAN SANSTHA (PANDHARPUR) RAJMATA ADHYAPAK VIDYALAYA VIJAYANAGAR SANGLI",
  "4279-SANMARG SHIKSHAN SANSTHA'S K.R.PANDAV INSTITUTE OF PHARMACY NAGPUR.",
  "SHAHU SHIKSHAN SANSTHA TALUKA KALYAN THANE",
  "SHANKARRAO NIMBALKAR JR. COLLEGE OF EDUCATION BARSHI SOLAPUR",
  "SHANTIDOOT BAHUDDESHIYA PRATISHTHAN SHANTIDOOT ADHYAPAK VIDYALAYA MADAHA",
  "4267-Sarodaya Mahila Mandal's Priyadarshani Yashodhara College Of Pharmacy,Chandrapur",
  "SHANTINIKETAN D. ED. COLLEGE CIVIL-LINES NAGPUR",
  "SHANTIWAN BAHUUDDESHIYA SHIKSHAN MANDAL SHEWALI DHULE",
  "5255-Sanjivani Pratishthan's Institute Of Technology,Kurund",
  "SHARADABAI PAWAR INSTITUTE OF NURSING PUNE",
  "SHARAD GRAMIN VIKAS BAHU UDDESHIYA SHIKSHAN SANSTH BARBADA WARDHA",
  "6455-Sandipani Charitable Trust, M.D. Jadhav Institute Of Technology.,Bhose",
  "SHEELA MULTIPURPOSE SOCIETY WADI NAGPUR",
  "SHETHKAR SHIKSHAN PRASARAK MANDALS COLLEGE OF EDUCATION ASTHI BEED",
  "SHEWANTADEVI ADHYAPAK VIDYALAYA (D. ED) PAUNI BHANDARA",
  "5258-Sandip Foundation's Sandip Polytechnic, Nashik",
  "SHIKSHAKNETE SHIVAJIRAO PATIL ADHYAPAK VIDYALAYA GANGAPUR AURANGABAD",
  "SHIKSHAN MAHARSHI DR. D. Y. PATIL EDUCATION SOCIETY CHINCHWAD PUNE",
  "SHIKSHAN MAHARSHI LATE SHRIHARI CIVIL LINES CHANDRAPUR",
  "5224-Sanjay Education Society's Polytechnic, Wadibhokar, Dhule",
  "SHIKSHAN MAHAVIDYALAYA KATOL NAGPUR",
  "SHIKSHAN MANDIR SANSTHA JUNIOR COLLEGE OF EDUCATION G. P. O. JALGAON",
  "VIDYA PRASARAK MANDAL DARWHA YAVATMAL",
  "5284-Sau Mathurabai Bhausaheb Thorat Sevabhavi Trust 'S Sau. Mathurabai Bhausaheb Thorat Institute Of D. Pharmacy",
  "2296-SEVADAS SHIKSHAN PRASARAK MANDAL'S VASANTRAO NAIK INSTIUTE OF TECHNOLOGY VASARNI NANDED",
  "3268-SAMARTH. SAMAJ'S. SHIVAJIRAO S. JONDHALE POLYTECHNIC AMBARNATH MUMBAI",
  "6481-SHAHU CHATRAPATI SHIKSHAN SANSTHA'S RAJARSHI SHAHU CHHATRAPATI INSTITUTE OF PHARMACY KOLHAPUR",
  "6420-Shikshan Prasarak Mandal's Polytechnic,Solapur",
  "6451-SAMARTH RURAL EDUCATION INSTITUTE SAMARTH POLYTECHNIC BANGARWADI BELHE",
  "6436-Sharad Institute of Technology Polytechnic, Yadrav( Ichalkaranji)",
  "5368-Seva Shikshan Prasarak Mandal, Dr. N. J. Paulbudhe Institute of Technology, Narayandoho Tal Nagar, Ahmednagar",
  "SHIKSHAN PRASARAK SANSTHA AT GHULEWADI SANGAMNER AHMEDNAGAR",
  "5295-SANJAY EDU.SOC.'S S.E.S. INSTITUTE OF PHARMACY BALAPUR(PHAGANE) DHULE.",
  "SHIKSHAN SHASTRA VIDYALAYA YAVATMAL YAVATMAL",
  "SHINDE MAHILA ADHYAPAK MAHAVIDYALAYA PANCHAYATI KATOL NAGPUR",
  "4238-SANMARG SHIKSHAN SANSTHA SHRI KRUSHNARAO PANDAV POLYTECHNIC BAHADURA NAGPUR",
  "SHISHU VIHAR MANDAL TARABAI MODAK ADHYAPAK VIDHYALAYA JUNIOR COLLEGE OF EDUCATION HINDU COLONY MUMBAI",
  "SHISHU VIKAS TEACHERS TRAINING EDUCATION AURANGABAD AURANGABAD",
  "3290-SAHYADRI SHIKSHAN SANSTHA`S COLLEGE OF PHARMACY SAWARDE",
  "SHIVAJI SHIKSHAN PRASARAK MANDAL ADHYAPAK VIDHYALAYA, JALGAON",
  "SHIVAJI SHIKSHAN PRASARAK MANDAL MOUZA GADCHIROLI",
  "5403-Samarth Institute of Pharmacy, Kavathe",
  "SHIVCHATRAPATI SEVABHAVI SANSTHA COLLEGE OF EDUCATION AHMEDPUR LATUR",
  "SHIVPRATAP GRAM VIKAS MANDAL BHAGWAN BABA D. ED. COLLEGE JUNNAR PARBHANI",
  "SHIVRATNA SHIKSHAN SANSTHA MALSIRAS SOLAPUR",
  "1156-SANJAY RATHOD SHIKSHAN SANSTHA'S MANOHAR NAIK INSTITUTE OF PHARMACY YAWATMAL",
  "Shiv Vaibhav Junior College of  Education, Bachelor Road, Post Manas Mandir , Wardha-442005",
  "SHRI BALAJI SHIKSHAN PRASARAK MANDAL SHEPWADA BEED",
  "SHRI BALBHAGWAN SHIKSHAN PRASARAK MANDAL JULE SOLAPUR SOLAPUR",
  "SHRI BHAIRAVNATH NISARG MANDALS KALAMB OSMANABAD",
  "SHRI CHATRAPATI SHAHU JUNIOR COLLEGE OF EDUCATION RUKADU KOLHAPUR",
  "SHRI CHATRAPATI SHIVAJI MAHARAJ SHIKSHAN SANSTHA LOHA NANDED",
  "SHRI CHINTAMANI MAHILA EDUCATION SOCIETY YUVAKALYAN D. ED. COLLEGE AMLNER JALGAON",
  "SHRI DADA GANESH SANSKRITIK KRIDA & VIDYAPRASARAK MITRA MANDAL DHADGAON NANDURBAR",
  "SHRI DADASAHEB GAWAI CHARITABLE TRUST KAMAL PUSPA AMRAVATI",
  "SHRI DATTA GURU COLLEGE OF EDUCATION (D.Ed) khadki",
  "SHRI DATTA SHIKSHAN PRASARK MANDAL PANHALA KOLHAPUR",
  "SHRI DHANESHWARI MANAV VIKAS MANDAL COLLEGE OF WOMEN TULSI ARCADE AURANGABAD",
  "SHRI DHANESHWARI MANAV VIKAS MANDALS SAKRI DHULE",
  "SHRI DUTTA NAVAYUVAK SHIKSHAN PRASARAK MANDAL VAIJAPUR AURANGABAD",
  "SHRI GAJANAN MAHARAJ SHIKSHAN SANSTHA MONDA NAGPUR",
  "SHRI GANESH SHIKSHAN PRASARAK MANDAL PU. AHILAYADEVI D. ED. COLLEGE AHMEDPUR LATUR",
  "SHRI GOVARDHANSINHAJI COLLEGE OF EDUCATION (D. ED. ) CHAUPALA NANDURBAR",
  "S.S.M. JR. COLLEGE OF EDUCATION KALYAN THANE",
  "SHRI GURUDEV SHIKSHAN PRASARAK MANDAL HAMULAL ADHYAPAK VINCHUR SOLAPUR",
  "SHRIRAM ASEGAONKAR JUNIOR COLLEGE OF EDUCATION PUSAD YAVATMAL",
  "SHRI HARILAL BHAGWATI MUNICIPAL GEN HOSPITAL MUMBAI",
  "SHRI H. V. P. MANDAL JUNIOR COLLEGE OF EDUCATION AMRAVATI AMRAVATI",
  "SHRI JAIN VIDYA PRASARAK MANDAL CHINCHWAD GAON PUNE",
  "SHRI KANIFNATH SHIKSHAN SANSTHAS ADHYAPAK VIDYALAYA D. ED. COLLEGE PATHARDI AHMEDNAGAR",
  "SHRI KASAMJI SAVABHAVI SANSTHA K. M. D. ED. COLLEGE AMBAJOGAI BEED",
  "SHRIRAM EDUCATION SOCIETY DHAMANGAON AMRAVATI",
  "SHRI KASHI VISHWESHWAR SHIKSHAN PRASARAK MANDAL AKALKOT SOLAPUR",
  "SHRI. KISANRAO KHOBRAGADE D. T. ED. COLLEGE VAIRAGAD",
  "SHRI RAM EDUCATION SOCIETYS MALSHIRAS SOLAPUR",
  "SHRI KISANRAO KHOBRAGADE EDUCATION SOCIETY ARMORI GADCHIROLI",
  "SHRI KRISHNA ADYAPAK VIDYALAYA SAONER SAONER NAGPUR",
  "SHRIKRUSHNA DED COLLEGE KOKANA",
  "SHRI SADGURU BALUMAMA SHIKSHAN MANDAL D. ED. COLLEGE BHUDARGAD KOLHAPUR",
  "SHRI MADHAO BAHU-UDDESHIYA SHIKSHAN SANSTHA SHRI MADHORAO BHOYAR ADHAYAPAK VIDYALAYA DAWANIWADA GONDIA",
  "SHRI MAHARANAPRATAP ADHYAPAK VIDYALAYA BUTI BORI NAGPUR",
  "SHRI SAI BABA BHAKTA MANDAL MHASAWAD SHAHADA NANDURBAR",
  "SHRI MAHESH BAHUUDDESHIYA SANSTHA SHRI MAHESH D ED BULDANA BULDHANA",
  "SHRI MANOHARRAO NAIK SHIKSHAN PRASARAK MANDAL PUSAD YAVATMAL",
  "SHRI SAI SCHOOL OF NURSING UMRED",
  "SHRIMANT RAJE DAULATSINGHJI RAWAL SHINDKHEDA DHULE",
  "SHRI SAI SHIKSHAN SANSTHA SHRI RANJITSINHA MOHITE PATIL D. ED. COLLEGE WASHIM WASHIM",
  "5301-Shri.Krishna Educational & Cultural Mandal,Shri.Gulabrao Deokar Institute of Pharmacy & Research Centre, Jalgaon",
  "5358-Shri Dattakrupa Shaikshanik & Krushi Gramvikas Pratisthn's Saikrupa Polytechnic, Ghargaon, Tal Shrigonda, Ahmednagar",
  "3025-Shri Bhagubhai Mafatlal Polytechnic, Mumbai",
  "SHRI SANTAJI EDUCATION & SOCIAL WELFARE SOCIETY KUMBHARI AKOLA",
  "6816-Shri Chimasaheb jagdale Institute of Technology, Narsobawadi, Tal.Shirol, Kolhapur",
  "SHRI SANTAJI SHIKSHAN VIKAS SANSTHA SHRI SANTAJI SQUARE NAGPUR",
  "1157-Shri Chhatrapati Shahumaharaj Shikshan Santha's Institute Of Pharmacy, Maregaon",
  "4261-Shri Bhawabhuti Shikshan Sanstha's Shri Laxmanrao Mankar Institute Of Pharmacy, Amgoan",
  "YASHWANT JUNIOR COLLEGE OF EDUCATION BULDHANA",
  "1167-Shri Gurudatta Shikshan Prasarak Sanstha's Late Shri Ramraoji Gawande Institute Of Pharmacy, Akola",
  "6501-Shri Dhanlaxmi Foundation, Karad's Late Adv. Dadasaheb Chavan Memorial Institute of Pharmacy, Malwadi-Masur",
  "SHRI SEVADAS SHIKSHAN PRASARAK MANDAL MAHATMA GANDHI D. ED. COLLEGE CIDCO NANDED",
  "1247-Shri Dadasaheb Gavai Charitable Trust's Vikramshila Polytechnic,Darapur, Tal. Daryapur, Dist. Amravati",
  "5259-SHRI DATTAKRUPA SHAIKSHANIK & KRISHI GRAM VIKAS PRATISTHAN SHRI SIDDHIVINAYAK POLYTECHNIC KARJAT AHMEDNAGAR",
  "SHRI SHAHU SHIKSHAN PRASARAL MANDALS D. ED. COLLEGE RANKALA KOLHAPUR",
  "SHRI SHAMGIR SHIKSHAN SANSTHA SHRI SHAMGIR ADHYAPAK NILANGA LATUR",
  "SHRI SHAMRAO PATIL ADHYAPAK VIDYALAYA HATKANANGALE KOHLAPUR",
  "SHRI SHARDA BHAWAN EDUCATION SOCIETY NANDED NANDED",
  "SHRI SHIVAJI EDUCATION AND KRISHI PRATISHTHAN SHAHADA DHULE",
  "SHRI SHIVAJI JR. OOF COLLEGE OF EDUCATION AMRAVATI AMRAVATI AMRAVATI",
  "SHRI SHIVAJI JR. VOLLEGE OF EDUCATION PUSAD YAVATMAL",
  "SHRI SHIVAJI JUNIOR COLLEGE OF EDUCATION CHIKHALI BULDHANA",
  "SHRI SHIVAJI JUNIOR COLLEGE OF EDUCATION ISLAMPUR SANGLI",
  "THOMAS BAPTISTA HIGH SCHOOL PUBLIC TRUST VASIA THANE",
  "S M M P P GANPATRAO ADKE INSTITUTE OF NURSING NASHIK",
  "TIGER WELFARE ASSOCIATION BAHIRWADI BEED",
  "TIRPUDE NURSING TRANING SCHOOL",
  "SMT.D.Y.SAWANT NURSING(R.A.N.M) SCHOOL",
  "TIRUPATI PRATISHTHAN LATE SANTRAMJI RABBEWAR D. ED. COLLEGE VASMAT HINGOLI",
  "TRAINING SCHOOL OF NURSING AKOLA",
  "SMT.GOKULABAI BADHE ADHYAPAK VIDHYALAYA,RAMGAON",
  "TRAINING SCHOOL OF NURSING (A.N.M.) GENERAL HOSPITAL YAVATMAL",
  "TRAINING SCHOOL OF NURSING DHULE",
  "SMT SUMITRABAI THAKARE TRAINING SCHOOL OF NURSING YAVATMAL",
  "TRIMURTI PAWAN PRATISHTHAN SHEVGAON AHMEDNAGAR",
  "TRIMURTI PAWAN PRATISHTHAN SHRIRAMPUR SHRIRAMPUR",
  "VIVEKANAND ADHYAPAK VIDYALAYA BHABALGAON LATUR",
  "SOLAPUR SOCIAL ASSOCIATIONS COLLEGE OF EDUCATION SIDDESHWAR PETH SOLAPUR",
  "TRIMURTI PAWAN PRATISHTHAN SMT MEENATAI BALA SAHEB THACKEREY RURALS BOYS D. ED. COLLEGE NEWASA AHMEDNAGAR",
  "TRIMURTI PAWAN PRATISHTHAN SMT MEENATAI BALA SAHEB THACKEREY RURALS GIRLS D. ED COLLEGE NEWASA AHMEDNAGR",
  "TULARAM DHOKE D.T. ED. COLLEGE KHAPERKHEDA",
  "SOMESHWAR EDUCATION SOCIETY SHINDAKHEDA DHULE",
  "Tulshiramji Shebe School Of Nursing Pusad",
  "UDAY MAHILA SEVA SANSTHA UMRER NAGPUR",
  "SONAJI SHIKSHAN PRASARAK MANDAL MAJALGAON BEED",
  "UJWAL RURAL DEVELOPMENT SOCIETY SHINDKHEDA DHULE",
  "UKANDRAO MORE DED COLLEGE TIRORA",
  "UMA ADHYAPAK VIDYALAYA PANDHARPUR, SOLAPUR",
  "S. P. D. ED. COLLEGE MARATHA SHIKSHAN SANSTHA GAJANAN AMRAVATI AMRAVATI",
  "UMER BIN KHATTAB WELFARE TRUST KANNAD AURANGABAD",
  "UNION JUNIOR COLLEGE OF EDUCATION, AHMEDNAGAR",
  "Universal Business School, Raigarh",
  "S. S. V. S. SANSTHA ADHYAPAK VIDYALAYA BEED VIDYANAR EAST BEED BEED",
  "UNIVERSAL SOCIETY FOR QUALITY EDUCATION AND RESEARCHS IRENE ADHYAPAK VIDHYALAYA JATWADA AURANGABAD",
  "URDU D. ED. COLLEGE MALANINAGAR NEAR ROCKEL TANK YAVATMAL",
  "S. T. ADHYAPIKA VIDYAMANDIR MALVAN SINDHUDURG",
  "URDU JR. COLLEGE OF EDUCATION YAVAL JALGAON",
  "URDU JUNIOR COLLEGE OF EDUCATION (GIRLS) KHAMGAON BULDHANA",
  "UTTANRAO RATHOD D. ED. COLLEGE MAHUR NANDED",
  "ST ALOYSIUS JR. COLLEGE OF EDUCATION PAPDY VASAI",
  "VAHIBHAV SHIKSHAN PRASARAK MANDAL SMT. SHUSHILABAI KADAM D. ED COLLEGE VAIJAPUR AURANGABAD",
  "VAIKUNTH MEHTA NATIONAL INSTITUTE OF COOPERATIVE MANAGEMENT",
  "ST GEORGE HOSPITAL MUMBAI",
  "VAISHNAVDEVI ADHYAPAK VIDAYALAYA SAONER NAGPUR",
  "VANDNIYA RASHTRASANT TUKDOJI SHIKSHAN SANSTHA CHIMUR CHIMUR",
  "ST. JOHN DE BRITTO ADHYAPAK VIDYALAYA MANICKPUR THANE",
  "VANITA SHAIKSHANIK SOCIAL AND CULTURE TRUST SHAHADA SHAHADA",
  "VANVAIBHAV SHIKSHAN MANDAL D. ED. COLLEGE ALLAPALLI GADCHIROLI",
  "5266-Tapi Valley Education Society's Institute of Pharmacy,Faizpur",
  "ST. JOHNS LADY JEEJEE BHOY TRUST GOREGAON (W) MUMBAI",
  "ST LUKE'S HOSPITAL AHMEDNAGAR",
  "ST. MONICA JR. COLLEGE OF EDUCATION AHMADNAGAR",
  "5229-Technical & Medical Education Society's J. T. Mahajan Polytechnic, Faizpur",
  "6467-Swami Vivekananda Pratisthan, Swami Vivekananda Institute Of Technology,Khed, Solapur",
  "5245-Sangamner Medical Foundation & Research Institutes,Wamanrao Ethape Polytechnic, Velhale, Sangamner",
  "5430-SWAMI INSTITUTE OF PHARMACY, ABHONA",
  "VEVEKANAND ADHYAPAK VIDYALAYA NANDANVAN NAGPUR",
  "VICHARDHARA PRATISHTHAN RAJIV GANDHI ADHYAPAK VIDYALAYA BHOOM OSMANABAD",
  "VIDARBHA GRAM VIKAS SHIKSHAN MANDAL SUJAL D. ED. COLLEGE GANJWARD CHANDRAPUR",
  "VIDHYA PRATISHTHAN VIDHYANAGARI BARAMATI PUNE",
  "VIDHYA VARDHANI SHIKSHAN SANSTHA SANCHALIT SARASWATI ADHYAPAK VIDYALAYA PAWDEWADI NANDED",
  "VIDYADHAR EDUCATIONAL TRUST TALUKA AMBERNATH BADLAPUR",
  "VIKASWADI ADHYAPAK VIDYALAYA VIKASWADI THANA",
  "VISHVATMAK JANGLI MAHARAJ ASHRAM TRUST OM GURUDEV D. ED. COLLEGE KOPARGAON AHMEDNAGAR",
  "VISHWABHARATI MAHILA SEVABHAVI MANDAL AMEJOGAI BEED",
  "VITTHALRAO DESHMUKH ADHYAPAK VIDYALAYA SANGLI SANGLI",
  "VIVEKANAND ADHYAPAK VIDYALAYA WARORA CHANDRAPUR",
  "VIVEKANAND PRATISHTHAN SAVKHEDA JALGAON",
  "VIVEK VARDHINI COLLEGE OF EDUCATION SHIVAJI NAG NANDED",
  "V S GENERAL HOSPITAL THANE",
  "4603-Young Engineer's Education Society, Maharashtra Institute of Polytecnic, Betala, Bramhapuri,Chandrapur",
  "4278-Young Engineers Education Society's Maharashtra Institute Of Pharmacy, Betada, Bramhapuri, Chandrapur",
  "5428-Ahinsa Institute of Pharmacy, Dondaicha",
  "2552-Savitribai College of Pharmacy, Bamani",
  "SHRI SATYASAI ADIVASI GRAMIN VIKAS VA BAHU-UDDESIYASHIKSHAN SANSTHA BHAGAWANRAO ADHYAPAK V C O N. P. WAGHAYE B. ED. COLLEGE ARMORI ARMORI GADCHIROLI GADCHIROLI",
  "DR. D. Y. PATIL PRATISHTHAN C O D. Y. PATIL COLLEGE PIMPR PUNE",
  "RAHUL D. ED. COLLEGE (ENGLISH MEDIUM) C O MOTHER MARYS HIGH SCHOOL AND JUNIOR COLLEGE BHAVANDAR(E) THANE",
  "MAA ANUSAYA SCHOOL OF NURSING , AKOLA",
  "AZAD HIND NURSING SCHOOL,AKOLA",
  "APEX NURSING SCHOOL KOLHAPUR",
  "KALPATARU SHAIKSHANIK SEVA MANDAL ADHYAPAK VIDYALAYA",
  "Rajeev Gandhi Memorial GNM Nursing College Sinnar",
  "SWAMI VIVEKANAND MEDICAL MISSION, KHAPRI, AAROGYA SEVA KENDRA, SCHOOL OF NURSING",
  "New Vision Nursing School, Latur",
  "Govindrao Paul Nursing School (ANM) Hadgaon",
  "Late Narayandas Bhawandas Chhabada Training College of Nursing",
  "Rosalind S. Teton School of Nursing, Bhaktivedanta Hospital",
  "Dr. Vithalrao Vikhe Patil Foundations Institute of Nursing Education, Ahmednagar",
  "SCHOOL OF NURSING DISTRICT HOSPITAL FOR WOMEN S AMRAVATI",
  "SHRI PUKHRAJ NAGRAJ RANKA SCHOOL OF NURSING PUNE",
  "JIJAMATA NURSING SCHOOL,LATUR",
  "INDIRA GANDHI NURSING SCHOOL LATUR",
  "Yash Institute of Nursing and Paramedical Sciences Indapur Dist-Pune",
  "Rajeev Gandhi Memorila ANM Nursing College Sinnar",
  "Late Sou Roshanbi Shamanji Nursing School",
  "Navjeevan School of Nursing, Shahapur",
  "Nazarene Nursing Training College, Reynolds Memorial Hospital, Washim",
  "3428-Bharati Vidyapeeth Institute of Pharmacy, Belapur Navi Mumbai",
  "2547-M.S.S.P.M. LATE BHAGIRATHI YASHWANTRAO PATHRIKAR COLLEGE OF D-PHARMACY,PATHRI",
  "2544-Gurukrupa Institute of Pharamcy, Majalgaon",
  "Rajmata Nursing School, Satara",
  "5437-Trimurti Institute of Pharmacy, Paldhi (BK), Jalgaon",
  "DAYANAND SCHOOL OF NURSING, VADOLI, TALASARI",
  "JIJAMATA SCHOOL OF NURSING MAJALGAON DIST BEED",
  "ANUSAYA NURSING COLLEGE, RANSHET.",
  "2557-Anand Charitable Sanstha's Gangai Pharmacy College, Kada",
  "6908-Ashokrao Mane Institute of Pharmaceutical Science and Research, Save",
  "2581-RADHEYA CHARITABLE TRUSTS DINESH BEMBADE COLLEGE OF PHARMACY, MAHALANGRA, TQ CHAKUR",
  "5454-Shantiniketan College of Pharmacy, Ahmednagar",
  "GOGANATH BABA NURSING SCHOOL AURANGABAD",
  "ACHARYA VINOBA BHAVE NURSING SCHOOL KATOL",
  "K T PATIL SCHOOL OF NURSING, OSMANABAD",
  "Shree Gajanan Maharaj Training school of Nursing Jawhar",
  "Indira Gandhi Nursing School Bhiwapur Dist.Nagpur",
  "SSSPMS College of Nursing Barshi, Dist-Solapur",
  "SAIBABA SEVABHAVI SANSTHA DR RAMESH DHOKANE PATIL SCHOOL OF NURSING NEWASAFATA MUKNDPR",
  "SAVITRIBAI PHULE RANM NURSING COLLEGE",
  "SCHOOL OF NURSING SHRI MARKANDEY SOLAPUR SAHAKARI RUGNALAYA AND RESEARCH CENTRE NIYAMIT .",
  "JIJAMATA INSTITUTE OF NURSING BHADRAWATI",
  "Saraswati Nursing School, dhamangaon",
  "SHRI BHAIRAVANATH SHIKSHAN SANSTHA, SHRI BHAIRAVNATH NURSING SCHOOL",
  "SATYAM SHIVAM SUNDARAM SHIKSHAN SANSTHAS UTTAMRAO UMAK MEMO. NURSING TRAINING SCHOOL KAPUSTALNI",
  "Dhanwantri Medical Education and Res Centres,Dr.T.M.Dhonde School Of Nursing,",
  "MATA GIRIJA NURSING SCHOOL HARSOOL AURANGABAD",
  "YASHWANT NURSING TRAINING SCHOOL",
  "Renuka Nursing ANM School Kallam",
  "SPANDAN NURSING COLLEGE KONDHA KOSRA",
  "Shree Sai Nursing (RGNM) College Jamkhed Taluka Jamkhed District Ahmednagar(MS)",
  "JIJAMATA NURSING SCHOOL SHEVGAON AHMEDNAGAR",
  "MOTHER TERESA COLLEGE OF NURSING WASHIM",
  "PRAVARA MEDICAL TRUST, COLLEGE OF NURSING, LONI (Bk)",
  "School of Nursing Rachana Trust, Nashik",
  "DR. K. B. MAPARI INSTITUTE OF NURSING ANM, LONAR",
  "Vidarbha school of nursing camp amravati",
  "6904-Anandi Pharmacy College, Kalambe Tarf Kale",
  "2278-Renukamata KrishiVikas Pratisthan's Swami Vivekanand Polytechnic, Jola, Post Devgaon Tq Kaij, Dist Beed",
  "5431-Shri. Sai Institute of Technology, Amalner",
  "6911-Zadbuke Institute of Pharmacy, Puri",
  "2566-Matoshri Institute of Pharmacy, Vaijapur",
  "6423-Shri Jain Vidya Prasarak Mandal's Rasiklal M. Dhariwal Institute of Technology, Chinchwadgaon, Pune",
  "1279-Dr.R. N. Lahoti Institute of Pharmacy, Sultanpur",
  "Sant Gajanan Maharaj Nursing School Sindewahi Tah Sindewahi Dist Chandrapur",
  "6903-Indrayani Vidya Mandir's Indrayani Institute of Pharmacy, Talegaon Dabhade",
  "2293-Mauli Shikhan Prasarak Mandal's Lal Bahadur Shastri Polytechnic, Udgir Dist Latur",
  "5455-Shram Sadhana Bombay Trust's Institute of Pharmacy, Bambhori, Jalgaon",
  "6910-Samarth Institute of Pharmacy, Belhe , Junnar",
  "4650-P.R.Patil Institute of Pharmacy, Talegaon(SP),Wardha",
  "1285-M.E.S. COLLEGE OF PHARMACY,  MEHKAR",
  "SHABBIR AHMED ANSARI NURSING SCHOOL MIRAJ DIST-SANGLI",
  "Asharam School of Nursing Kamptee",
  "Shri Swami Samarth Nursing School Ner Dist-Yavatmal",
  "AVATAR MEHER BABA SCHOOL OF NURSING, NAGPUR",
  "DR.SHIVAJIRAO GHOGARE NURSING SCHOOL",
  "Mahalaxmi Nursing Institute, Kolhapur",
  "3448-Gokhale Education Society, Katgara Polytechnic Institute, Bordi.",
  "2209-Shree Balaji Shikshan Prasarak's Institute of Pharmacy, Ambejogai, Dist. Beed.",
  "2528-Rajiv Gandhi Polytechnic, Markhel, Tal.Degloor, Dist.Nanded.",
  "Smt Vasundharabai Ghuikhedkar Nursing School Amravati",
  "MAHATMA GANDHI NURSING INSTUTUE, KAWTHA",
  "BHIVRAJ KALANTRI NURSING INSTITUTE CIDCO NANDED",
  "OMKAR NURSING SCHOOL, BHILOLI, NANDED",
  "SAI CARE NURSING SCHOOL NASHIK",
  "ANNABHAU SATHE FOUNDATION ADARASH NURSING SCHOOL",
  "3011-Government Polytechnic, Thane",
  "6906-DELIGHT COLLEGE OF PHARMACY, KOREGAON BHIMA",
  "TIRUPATI NURSING SCHOOL, PARBHANI",
  "Mungsaji Maharaj Nursing School Darwha Dist Yavatmal",
  "Padole Nursing School Yavatmal",
  "VARSHARAJ NURSING SCHOOL",
  "Savitribai Phule College of Nursing",
  "SHRI SIDDHI NURSING SCHOOL MURGUD TAL-KAGAL DIST-KOLHAPUR",
  "SWAMI RAMANAND TIRTH NURSING INSTITUTE,KANDHAR",
  "PHULE SAMAJ SUDHARAK SAMITI INDIRA GANDHI NURSING INSTITUTE",
  "Dhanvantari School Of Nursing Malewadi, Akluj",
  "Bhakti Institute of Nursing, Pandharpur",
  "MOTHER TERESA NURSING SCHOOL,HINGOLI",
  "DR.Dahiphale Medical Foundation Trust, School of Nursing, Aurangabad",
  "VAIDYANATH INSTITUTE OF NURSING RGNM",
  "MONICA NURSING SCHOOL",
  "NANDA AAI BAHU UDDESHIY MAHILA MANDALS, NURSING TRAINING CENTER",
  "Savitribai Phule Nursing School, Kannad",
  "JIJAMATA SCHOOL OF NURSING",
  "DWARIKA SANGAMNERKAR MEDICAL FOUNDATION SCHOOL OF NURSING NAVI PETH PUNE",
  "Mauli Nursing School, Beed",
  "JIJAMATA NURSING SCHOOL,Bhenda tq,shevgaon,Ahmednagar",
  "DIPTI AAHER  NURSING SCHOOL",
  "Adarsh Nursing School, Vita",
  "K.D.GAVIT NURSING SCHOOL, NANDURBAR",
  "MAHATMA FULE NURSING SCHOOL",
  "SHRI DATTATRAYA PRABHU BAHU,SHIKSHAN SANSTHA,SHREE DATTA NURSING SCHOOL",
  "Hon .R .R Patil institute of nursing education ,sangli",
  "SHRI SURESHDADA DESHMUKH INSTITUTE OF NURSING",
  "DAGDOJIRAO PATIL RGNM NURSING SCHOOL HADGAON",
  "Ideal Nursing School , Kankavli",
  "SMT.Kamalaben Patel Institute of Nursing,Kumbhari",
  "Shiva Trust, Aurangabad Training School of Nursing",
  "5464-Vidya Niketan Institute of Pharmacy & Research Center, Bota",
  "M. J. Pawade Nursing School, Amravati",
  "1288-Vardhaman College of Pharmacy, Karanja (LAD), Washim",
  "5278-The Shirpur Education Society's R.C.Patel Institute Of Pharmacy, Shirpur",
  "5253-Kisan Dnyanoday Mandal Gudhe's Dr. Uttamrao Mahajan Institute Of Engineering & Technology,Chalisgaon, Jalgaon",
  "2596-INSTITUTE OF PHARMACY, BADNAPUR, DIST-JALNA",
  "Lotus Nursing Institute",
  "S.Chandra Girls Nursing College",
  "DR. D. Y. Patil Institute of Nursing Education",
  "Aastha School of Nursing,Osmanabad",
  "Sharda Nursing School, Khana Tumsar Bhandara",
  "RAM RATAN NURSING INSTITUTE BHOKAR",
  "KALASKAR NURSING INSTITUTE",
  "Shri Gajanan Mauli Sevabhavi Sansthas, Jijamata Nursing School, Sayane (BK)",
  "PRAGATI NURSING  SCHOOL,  PATODA",
  "MOTHER TERESA NURSING INSTITUTE, KANDHAR",
  "Devyani School of Nursing",
  "KASTURABAI NURSING SCHOOL UDGIR",
  "NITYASEVA NURSING SCHOOL ALKUTI TAL PARNER DIST AHMEDNAGAR",
  "shalom nursing school",
  "Rajlaxmi Nursing School, Madadgaon",
  "KALWAN NURSING SCHOOL, KALWAN, NASHIK",
  "Shiva Trust, Aurangabad Nursing School, Bhalgaon, Aurangabad",
  "SAVITHRIBAI PULE NURSING SCHOOL, JALKOT TQ JALKOT",
  "F.J.F.M Hospital and Community Health Unit, Newasa",
  "Kedarnath Nursing School, Islampur",
  "DHANWANTARI INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES, KOKRUD",
  "Bhartiya Mahila Vikass Nursing School, Wardha",
  "SALAHUDDIN AYYUBI MEMORIAL JUNIOR COLLEGE OF EDUCATION URDU SHANTINAGAR, BHIWANDI.",
  "Diamond Nursing Institute",
  "New Maharashta Institute of Nursing",
  "SAKSHI DESHMUKH INSTITUTE OF NURSING,YAVATMAL",
  "1015-Government Polytechnic , Achalpur",
  "BAHUJAN SAMAJ PRABODHAN SHIKSHAN SANSTHA SCHOOL OF NURSING,KOTUL,TAL AKOLE, DIST. AHMEDNAGAR",
  "Kopargaon Nursing School",
  "Shrirampur Nursing School",
  "NATIONAL SCHOOL OF NURSING, AKOLA",
  "SAU. R. G. MALI NURSING SCHOOL",
  "INDIRA GANDHI NURSING SCHOOL, BASMAT TQ.BASMAT DIST. HINGOLI",
  "Creative Nursing School",
  "Aadhar Nursing School",
  "Siddhagiri Nursing Institute, Kaneri",
  "Navjeevan Institute Of Nursing Sciences Ahmedpur Dist. Latur",
  "Sant Rambhau A.N.M School,Ahmedpur, Dist-Latur",
  "Indira Gandhi School Of Nursing, Golchha Marg Sadar, Nagpur",
  "Suvarna School of Nursing, Saoner",
  "Junior College of Education, Dindori. tal Dindori Nashik",
  "2540-Ratneshwari Institute of Polytechnic, Nanded",
  "1287-Raje Laxmansingh Bhosale College of Pharmacy, Hingna Barlinga",
  "2202-Sayli Charitable Trust's College Of Pharmacy, Mitmita, Aurangabad.",
  "WESTERN MAHARASHTRA NURSING SCHOOL, TILWANI",
  "Gondia City Institute of Nursing  and Paramedical Sciences",
  "NAVIN NURSING SCHOOL OSMANABAD",
  "DR. VANADANATAI DHONE NURSING SCHOOL",
  "5297-Sangamner Medical foundation & Research Institute, Wamanrao Ithape Pharmacy College, Sangamner, Dist. Ahmednagar",
  "6357-TATYASAHEB KORE COLLEGE OF PHARMACY (DIPLOMA) WARANANAGAR",
  "Dr.Prafulla Patil Nursing School Parbhani",
  "1150-Swavalambi Shikshan Sanstha's Sushganga Polytechnic, Wani",
  "5248-Sulochana Behelekar Samajik & Bahu Uddeshiya Shikshan Sanstha,Dnyaneshwar Polytechnic, Ahmednagar",
  "1115-J.S.P Mandal's Sudhakarrao Naik Institute of Pharmacy, Pusad Dist. Yavatmal",
  "PUSHPAI NURSING SCHOOL,  KINGAON",
  "6506-JAYAWANT SHIKSHAN PRASARK MANDAL'S JAYWANTRAO SAWANT INSTITUTE OF PHARMACY HADAPSAR PUNE",
  "Late Pramodji Mahajan Rgnm Nursing School, Ambajogai",
  "ONENESS SCHOOL OF NURSING, (YELGAON) BULDANA",
  "New Mother Teresa A.N.M. School of Nursing, Udgir",
  "Madhav ANM School, Parbhani",
  "5370-KEDARESHWAR GRAMIN VIKAS PRATISHTHAN KAI. SAU. SUNITATAI EKNATHRAO DHAKANE POLYTEHNIC COLLEGERAKSHI TAL-SHEVGAONAHMEDNGAR",
  "MAHARASHTRA SCHOOL OF NURSING MIDC LATUR",
  "2224-MARATHWADA INSTITUTE OF TECHNOLOGY AURANGABAD",
  "2182-MARATHWADA SHIKSHAN PRASARAK MANDAL YESHWANTRAO CHAVAN INSTITUTE OF POLYTECHNIC BEED",
  "2173-Shree Yash Pratishthan, Shree Yash Polytechnic, Satara Tanda, Aurangabad.",
  "1164-Shree, Swami Samarth Institute of Pharmacy, at parsodi, Dhamangaon Rly, Dist.Amravati",
  "5277-MULA EDUCATION SOCEITYMULA RURAL INSTITUTE OF PHARMACYSONAI TAL. NEWASA DIST. AHMEDNAGAR",
  "5369-NASHIK INSTITUTE OF TECHNOLOGY LATE ANNASAHEB PATIL POLYTECHNIC DINDORI ROAD CANNOL ROAD MERI NASHIK",
  "4020-Shikshan Prasarak Mandal's Smt. Kusumtai Wankhede Institute of Pharmacy, Katol",
  "5268-Shree Neminath Jain Brahmacharyashram Jain Gurukul's Shri.Deepchand Fakirchand Lodha Pharmacy Institute, Chandwad",
  "5154-NIKAM INSTITUTE OF TECHNOLOGY (POLYATECHNIC) GONDUR DHULE",
  "5268-Shree Neminath Jain Brahmacharyashram Jain Gurukul's Shri.Deepchand Fakirchand Lodha Pharmacy Institute, Chandwad",
  "5467-Shastry Institute of Pharmacy, Erandol",
  "6766-Phaltan Education Society's College of Engineering Thakurki Tal- Phaltan Dist-Satara",
  "1160-Shri.Durgamata Bahuudeshiya Krida and Shaikshanik Sanstha,Ishwar Deshmukh Institute Of Pharmacy, Digras",
  "5376-Raj Laxmi Foundation, Sahkar Maharshi Rajaram Bapu Patil Polytechnic Institute, Madagaon ,Ahmednagar",
  "1245-SAKSHI SHIKSHAN KRIDA PRASARAK & BAHU SANSTHA'S DR. RAJESH RAMDASJI KAMBE POLYTECHNIC, TURKHED, TAL: MURTIZAPUR DIST: AKOLA",
  "5222-SANJIVANI RURAL EDUCATION SOCIETY'S K.B.P. POLYTECHNIC KOPARGAON DIST AHMEDNAGAR",
  "6713-SHETAKARI SHIKSHAN PRASARAK MANDALSHRI. JAYAWANTRAO BHOSALE POLYTECHNIC KILLE MACHINDRAGAD TAL-WALWA SANGLI",
  "KAMALTAI BUDHE NURSING SCHOOL",
  "S.R.V. NURSING COLLEGE, DAWAKI",
  "SHRI DATTA SCHOOL OF NURSING SAGAON",
  "Aparna Institute Of Nursing Education",
  "Y.D. Mane Institute of Nursing,Kagal.",
  "Swami Vivekanand Shikshan Prasarak Mandals, Swami Vivekanand School of Nursing, Udgir",
  "Smt. K. N. Patel School of Nursing",
  "AURANGABAD NURSING SCHOOL, AURANGABAD",
  "BELESHWAR INSTITUTE OF NURSING, PARBHANI",
  "5366-Potdar Foundation Taloda,Potdar Polytechnic, Patne, Malegaon, Nashik",
  "1246-Indira Bahuuddeshiya Shikshan Sanstha's Dr. Rajendra Gode Polytechnic,Ghatkhed, Amravati",
  "6449-MARATHWADA MITRA MANDAL'S POLYTECHNIC PUNE",
  "AKI INSTITUTE OF NURSING",
  "NARMADA NURSING INSTITUTE",
  "FLORENCE NIGHTINGALE TRAINING COLLEGE OF NURSING SAWANGI MEGHE WARDHA",
  "Vamanrao Ithape RGNM School, Sangamaner",
  "FLORENCE NIGHTINGALE NURSING SCHOOL AMRAVATI",
  "Florence School of Nursing, Latur",
  "1011-GOVERNMENT POLYTECHNIC YAVATMAL (PREVIOUSLY GOVT. RESIDENTIAL WOMENS POLYTECHNIC, YAVATMAL)",
  "D.P.Nursing College and Research Institute Selu, Wardha",
  "KANISHKA SCHOOL OF NURSING , SATARA.",
  "College of Nursing, Wanless Hospital, Miraj Medical Centre, Miraj",
  "Institute of Nursing Education, Ratnapur",
  "School of Nursing, K.T.S.GENERAL HOSPITAL, GONDIA",
  "SHRI SANT LAHANUJI MAHARAJ SCHOOL OF NURSING, LOTWADA",
  "SAVITRIBAI PHULE SCHOOL OF NURSING AKOLA",
  "SMT HANSABEN NURSING SCHOOL, NAGPUR",
  "SHEETAL NURSING SCHOOL  AURANGABAD",
  "S.Chandra Nursing School, Amgaon",
  "4266-Mehmuda Shikshan & Mahila Gr. Vikas Bahu. Sanstha's Central India Institute Of Pharmacy, Nagpur",
  "3298-Bhartiya Education Soc.'s Institute of Pharmacy, Velshet, Tal. Roha, Dist. Raigad",
  "KOPARGAON TALUKA VIDYARTHI SAHAYAK SAMITIS COLLEGE OF NURSING",
  "SAROJINI NURSING SCHOOL",
  "DESAI SCHOOL OF NURSING",
  "Vishwas Sawant Nursing School, Beed",
  "Kiran Nursing School",
  "PRIYANKA GANDHI NURSING SCHOOL",
  "SAKOLKAR NURSING SCHOOL",
  "Laxmanrao Umak Memorial Nursing School, Badnera",
  "SARASWATI GAIKWAD NURSING SCHOOL KOTOLI",
  "ANGEL OF MERCY INSTITUTE OF NURSING SCIENCES, AKOLA",
  "JALNA NURSING SCHOOL",
  "Kamlabai Umak Nursing School Amravati.",
  "2183-Aditya Bahuddeshiya Sanstha, Aditya Polytechnic, Beed",
  "4019-Nagar Yuvak Shikshan Sanstha Adv. V.R.Manohar Institute Of Diploma In Pharmacy, Nagpur",
  "ISME SCHOOL OF MANAGEMENT AND ENTREPRENEURSHIP",
  "2594-Tatyaraoji More College of Pharmacy, Umerga",
  "ISDI SCHOOL OF DESIGN AND INNOVATION",
  "VASANTPRABHA SCHOOL OF NURSING , BULDHANA",
  "3489-Yashwantrao Bhonsale College of D. Pharmacy,  Sawantwadi.",
  "Anandi Shikshan Prasarak Mandal, Anandi Nursing School",
  "6922- Siddhant School of Pharmacy ( Women ), Pune",
  "2118-Shree Bhairavnath Nisarg Mandal.'S Diploma In Pharmacy Institute, Hatta, Tal.Basmat",
  "5257- K. K. WAGH POLYTECHNIC, CHANDORI",
  "5485 MULA EDUCATION SOCIETYS SHARDA COLLEGE OF PHARMACY VADGAONGUPTA AHMEDNAGAR",
  "5483 PRAVARA MEDICAL TRUST COLLEGE OF PHARMACY",
  "5478 RASHTRIYA SHIKSHAN MANDAL N N SATTHA COLLEGE OF PHARMACY",
  "5484 SHRI SWAMI SAMARTH INSTITUTE OF PHARMACY, MALWADI BOTA",
  "2611 KADAM COLLEGE OF PHARMACY",
  "4657-DR R G BHOYAR INSTITUTE OF PHARMACY SELOO DIST WARDHA",
  "6935-LOKMANGAL COLLEGE OF PHARMACY WADALA",
  "6937-FABTECH COLLEGE OF PHARMACY",
  "2604-NBS INSTITUTE OF PHARMACY AUSA",
  "5470-BANKAR PATIL COLLEGE OF PHARMACY",
  "5443-DIVINE COLLEGE OF PHARMACY",
  "5476-JMCT INSTITUTE OF PHARMACY",
  "5475-RAVINDRA VIDYA PRASARAK MANDAL",
  "RAJARSHI SHAHU COLLEGE OF PHARMACY",
  "6468-DR BAPUJI SALUNKHE INSTITUTE OF PHARMACY",
  "2218 Education Society Naigaon Diploma in Pharmacy, Nanded.",
  "KISAN SHIKSHAN SANSTHAs, HUTATMA INSTITUTE OF NURSING WALWA, SANGLI",
  "OM PLYTECHNIC UMRER",
  "Mungasaji Maharaj Nursing School Yavatmal",
  "INSTITUTE OF HOTEL MANAGEMENT",
  "Rajeev Institute of Business Management",
  "ASMs Institute of International Business  and Research",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING & TECHNOLOGY (CIPET)",
  "PRIN L N WELINGKAR INSTITUTE OF MANAGEMENT DEVELOPMENT AND RESEARCH PGDM",
  "5482 DR ITHAPE INSTITUTE OF D PHARMACY, SANGAMNER",
  "3235 GAHLOT INSTITUTE OF PHARMACY  KOPARKHAIRANE NAVI MUMBAI",
  "5438 N D KASAR COLLEGE OF PHARMACY",
  "1297 VIDYANIKETAN COLLEGE OF PHARMACY",
  "2607 SHENFADU FAKIRBA INSTITUTE OF PHARMACY",
  "2263 GAJANANA TECHNICAL INSTITUTE KADA TAL AASHTI BEED",
  "2282 MITTHULALJI  SARDA  POLYTECHNIC",
  "4402 SARVODAYA MAHILA MANDAL BAJAJ TECHNICAL INSTITUTE CHANDRAPUR",
  "5345 KAI LAXMIBAI MAHILA VIKAS MANDAL DHULE INSTITUTE OF TECHNOLOGY DHULE",
  "5336 VIDYA SAGAR POST GRADUATE INSTITUTE DHULE",
  "2605 JGVVSSS SUYASH COLLEGE OF PHARMACY WARUD",
  "SASMIRAS BUSINESS SCHOOL",
  "INDUS BUSINESS SCHOOL PUNE",
  "THAKUR GLOBAL BUSINESS SCHOOL",
  "5461- ARIHANT COLLEGE OF PHARMACY",
  "2267-CHANNABASESHWAR P G D M L T COLLEGE LATUR",
  "MIT SCHOOL OF DISTANCE EDUCATION",
  "DR D Y PATIL SEAMEDU SCHOOL OF MEDIA MANAGEMENT",
  "TERNA GLOBAL BUSINESS SHOOL",
  "GANGAPUR NURSING SCHOOL",
  "SHRADDHA NURSING SCHOOL",
  "DPOS NETT COLLEGE OF PHARMACY",
  "RAJLAXMI NURSING SCHOOL",
  "IDEAL NURSING SCHOOL",
  "MET Institute of Post Graduate Diploma in Management",
  "SAVITRIBAI PHULE EDUCATION AND WELFARE SOCIETY TQ DIST PARBHANI SANCHLIT SAHARA GNM NURSING SCHOOL PARBHANI",
  "SUKHPRADA BAHUUDESHIY SANSTHA NASHIK SANCHALIT SHREYA NURSING SCHOOL KALWAN",
  "SAVITRIBAI PHULE NURSING SCHOOL WAKHARI PANDHARPUR",
  "MODERN INSTITUTE OF NURSING ARAN MODNIMB",
  "OM SHANTI GNM COLLEGE JOMALA BHOKARDAN",
  "SAMBHAJIRAO KENDRE NURSING SCHOOL NAIK NAGAR TQ UDGIR DIST LATUR",
  "SWAMI RAMDAS NURSING COLLEGE",
  "RAJMATA JIJAU SCHOOL OF NURSING PUNE",
  "SURYADATTA INSTITUTE OF MANAGEMENT AND MASS COMMUNICATION PGDM",
  "SAVITRIBAI PHULE NURSING SCHOOL LASUR STATION",
  "DR RAJENDRA GODE G N M NURSING SCHOOL OLD AJISPUR ROAD SAGWAN DIST BULDANA",
  "PRADNYA SHRAMAN SARASWATACHARYA DEVNANDIJI JAIN BAHUUDDESHIYA SAMAJ SEVA SANSTHA MOTHER KANCHAN NURSING INSTITUTE",
  "SRV NURSING SCHOOL AND RESEARCH INSTITUTE NAGBHID",
  "SAVITRIBAI FULE ANM AND GNM NURSING SCHOOL GADCHIROLI",
  "PRAJAPATI COLLEGE OF NURSING KUDUS",
  "ST FRANCIS INSTITUTE OF MANAGEMENT AND RESEARCH PGDM",
  "ARYAVEER INSTITUTE OF NURSING SARALGAON TAL MURBAD DIST THANE",
  "SARA SCHOOL OF NURSING NAVI MUMBAI",
  "DR MAR THEOPHILUS INSTITUTE OF MANAGEMENT STUDIES",
  "SHRI DR KOLPE NURSING COLLEGE",
  "JEEVAK SCHOOL OF NURSING MHASRUL NASHIK",
  "B R HARNE SCHOOL OF NURSING KARAV VANGANI TAL AMBERNATH THANE",
  "NAVJEEVAN NURSING SCHOOL DIST CHANDRAPUR",
  "SHIFA INSTITUTE OF NURSING COLLEGE AUSA",
  "IDEAL INSTITUTE OF NURSING COLLEGE LOHARA",
  "GANGAMAI SCHOOL OF NURSING, SOLAPUR",
  "PRAKASHCHAND JAIN INSTITUTE OF NURSING",
  "DR K D SHENDGE GNM NURSING SCHOOL OMERGA TQ OMERGA DIST OSMANABAD",
  "LATE PANDURANG PATIL NURSING SCHOOL",
  "SANMATI NURSING SCHOOL, WASHIM",
  "JIO INSTITUTE",
  "KANHOPATRA NURSING SCHOOL MANGALWEDHA TAL MANGALWEDHA DIST SOLAPUR",
  "MKES INSTITUTE OF MANAGEMENT STUDIES AND RESEARCH",
  "DEVGIRI PARAMEDICAL KAUSHALYA VIKAS SANSTHA",
  "SANJEEVANI D M L T NURSING COLLEGE,CHIPLUN,RATNAGIRI",
  "ALL INDIA INSTITUTE OF LOCAL SELF GOVERNMENT",
  "1161-MATOSHRI EDUCATION SOCIETY'S SATYAJEET COLLEGE OF PHARMACY MEHAKAR DIST.BULDHANA",
  "SUVIDHA INSTITUTE OF NURSING SCHOOL AT ATPADI TQ ATPADI DIST SANGALI",
  "RADHE RADHE VOCATIONAL TRAINING INSTITUTE",
  "INSTITUTE FOR TECHNOLOGY AND MANAGEMENT,NAVI MUMBAI",
  "SAHYADRI NURSING COLLEGE OSMANABAD",
  "2201-Umer Bin Khattab Welfare Trust's Vastanvi College of Pharmacy, Kunjkheda Ta. Kannad Dist. Aurangabad",
  "5264-ADIVASI SEVA SAMITI'S INSTITUTE OF INDUSTRIAL & PHARMACEUTICAL TECHNOLOGY, PANCHAVATI NASHIK",
  "SURYA NURSING COLLEGE (ANM), MANCHI HILL",
  "SURYA NURSING COLLEGE, (G.N.M), MANCHI HILL",
  "LT GOVINDRAO DESHPANDE COLLEGE OF NURSING WASHIM",
  "FATEMA COLLEGE OF NURSING GNM TIOSA",
  "MAULI NURSING SCHOOL TARODA NANDED",
  "RADHAI GNM NURSING SCHOOL KAREGAON TQ LOHA DIST NANDED",
  "KASTURBA GANDHI NURSING SCHOOL BALANTWADI KANDHAR",
  "5290-SHELLINO EDUCATION SOCIETYS NANASAHEB R.G. PATIL INSTITUTE OF PHARMACY, MAMURABAD, JALGAON",
  "SHILP BHARAT COLLEGE OF NURSING  THANE",
  "SUNANDA SCHOOL OF NURSING,BHNADARA",
  "SWAMI VIVEKANAND SCHOOL OF NURSING, AURANGABAD",
  "SHRI DATTAKRUPA SHIKSHANIK AND KRUSHI GRAMVIKAS PRATISHTHAN PANDURANG KRUPA NURSING SCHOOL MANDAVGAN FARATA",
  "SHRI DATTAKRUPA SHAIKSHANIK AND KRUSHI GRAMVIKAS PRATISHTHAN SAIKRUPA NURSING SCHOOL GHARGAON",
  "LATE VALMIKRAO SAVANT INSTITUTE OF D PHARMACY",
  "VARDHMAN EDUCATION AND WELFARE SOCIETY AHINSA INSTITUTE OF NURSING",
  "FUEL BUSINESS SCHOOL",
  "ASHOKA NURSING COLLEGE CHANDRAPUR",
  "GAYATRI NURSING COLLEGE ASANGAON THANE",
  "SHREE DATTA NURSING SCHOOL AMGAON",
  "VEDANTAA INSTITUTE OF PARAMEDICAL SCIENCES, DAHANU",
  "SARASWATI NURSING COLLEGE DHULE",
  "SAI CARE NURSING SCHOOL, SHAHAPUR",
  "GENERAL HOSPITAL, ALIBAG, RAIGAD",
  "SHIVPARVATI MEDICAL PRATISTHAN, AURANGABAD SANCHLIT LOKMANYA NURSING INSTITUTE, CHALISGAON ROAD, OPP CANOSA SCHOOL, DHULE",
  "SHRI BALASAHEB MANE SHIKSHAN PRASARAK MANDAL AMBAP ASHOKRAO MANE INSTITUTE OF PHARMACY, VATHAR TARF VADGAON",
  "DR RAJENDRA GODE GNM NURSING SCHOOL AMRAVATI",
  "CHHATRAPATI SAMBHAJI MAHARAJ GNM NURSING SCHOOL, RAMRAHIM NAGAR, KANDHAR",
  "MA AJITDADA PAWAR NURSING INSTITUTE",
  "SAI SIDDHI SCHOOL OF NURSING",
  "PADMABHUSHAN KRANTIVEER DR NAGNATH ANNA NAYAKAWADI COLLEGE OF PHARMACY",
  "S.K.B. College of Pharmacy, Gada, Kamptee",
  "SHRI TULJABHAVANI BAHUUDDESHIY SAMAJ SEVA SANSTHA,  JUNIOR COLLEGE OF EDUCATION (DE.D), KURDUWADI, MADHA SOLAPUR",
  "Hon. Shree Babanrao Pachpute Vichardhara Trust's Parikrama Diploma in Pharmaceutical Sciences, Shrigonda Dist - Ahmednagar",
  "A.I.'S MOHAMMED HAJI SABOO SIDDIK POLYTECHNIC, Mumbai",
  "IES's Management College and Research Centre",
  "6288:-Bharati Vidyapeeth, College of Engineering, Near chitranagari, Kolhapur",
  "SANTKRUPA NURSING COLLEGE",
  "ANISH COLLEGE OF NURSING, KURUNDWAD",
  "NOBLE INSTITUTE OF MEDICAL SCIENCES, HADAPSAR, PUNE",
  "SAKET INSTITUTE OF PHARMACY ,SHAHAPUR",
  "EAGLEWOOD POLYTECHNIC INSTITUTE",
  "VITTHAI D PHARMACY COLLEGE BEED",
  "MATRUBHOOMI INSTITUTE OF NURSING AMBEGAON BK KATRAJ TQ HAVELI DIST PUNE",
  "APARNA NURSING SCHOOL JUNNER PUNE",
  "SHINE NURSING SCHOOL FURSANGI",
  "MATA MAHAKALI COLLEGE OF NURSING AT PARSODA TAH WARORA DIST CHANDRAPUR",
  "VATSALYA COLLEGE OF NURSING, NERPINGLAI, AMRAVATI",
  "SAI INSTITUTE OF NURSING SHENDRI BADYACHIWADI MIDC GADHINGLAJ",
  "BAHUJAN SAMAJ SARVANGIN VIKAS PRATISTHAN UJWALA SCHOOL OF NURSING",
  "INDIRA NURSING SCHOOL",
  "INDIRA GANDHI NURSING SCHOOL",
  "VARSHARAJ NURSING SCHOOL ,WANI ,YAVATMAL",
  "DEVRUKH INSTITUTE OF NURSING, DEVRUKH ,TAL SANGAMESHWAR",
  "SUREKHA INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES ASHTA",
  "UNITECH B SCHOOL",
  "MATRUKRUPA NURSING COLLEGE",
  "YASHODANURSINGSCHOOLUDGIR",
  "SHREE SAI COLLEGE OF NURSING",
  "GENESIS INSTITUTE OF NURSING RADHANAGARI",
  "UNNATI BAHUUDESHIYA GRAMIN VIKAS SANSTHA SAI NURSING SCHOOL RANM WADGAON KO TQ",
  "WOMEN INDIA TRUST SCHOOL OF NURSING",
  "SANJIVANI BUSINESS SCHOOL KOPARGAON",
  "GENERAL HOSPITAL NANDURBAR",
  "SHRI SAI INSTITUTE OF NURSING AND MEDICAL  SCIENCE, NAGPUR",
  "SUHARI INSTITUTE OF NURSING EDUCATION, PIMPALNER, SAKRI, DHULE    ",
  "DR PALLAVI S SURYAWANSHI COLLEGE OF NURSING SAKAT TAL JAMKHED DIST AHMEDNAGAR ",
  "BABANDADA PATIL COLLEGE OF NURSING",
  "SANJAYRAO VASANTRAO KADAM COLLEGE OF NURSING AND RESEARCH CENTRE",
  "SHRI  SURYAMOHAN  BAHUUDDESHIYA SHIKSHAN SANSTHA SANCHALIT MAHALAXMI NURSING COLLEGE GNM  ABHYANKAR NAGAR TUMSAR",
  "JAY AMBE SCHOOL OF NURSING AMBAD ROAD JALNA",
  "KOYANA INSTITUTE OF NURSING, ISLAMPUR, WALWA, SANGLI",
  "DR R N COOPER HOSPITAL MUMBAI",
  "ANNAPURNA INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH",
  "NARAYANA INSTITUTE OF PHARMACY",
  "RAMDAS VIDYA NIKETAN COLLEGE OF PHARMACY",
  "SHRI SHRI AMRUTANAND MAHAYOGESHWAR D PHARMACY COLLEGE, PANGRI, TALUKA MANTHA, DISTRICT JALNA",
  "ADVANCED CENTRE FOR TREATMENT, RESEARCH AND EDUCATION IN CANCER",
  "MAHATMA JYOTIBA PHULE BAHUUDDESHIYA SHIKSHAN SANCHLIT'S SCHOOL OF NURSING, CHIKHLI, BULDANA",
  "MAHATMA PHULE GRAMIN VIKAS SEVABHAVI SANSTHA SONAWAL SANCHALIT SAVITRI BAI PHULE NURSING SCHOOL JALKOT ",
  "AAI VATSALA SCHOOL OF NURSING, SEWAGRAM WARDHA    ",
  "AAI VATSALA SCHOOL OF NURSING RALEGAON, YAVATMAL    ",
  "VALIA SCHOOL OF MANAGEMENT    ",
  "ALDEL INSTITUTE OF MANAGEMENT",
  "TEJAL SHAIKSHANIK SANSTHA NASHIK SANCHALIT  SMT VIMALABEN RAMESHCHANDRA JOSHI NURSING COLLEGE , GORAKSHNATH ROA SATPUR NASHIK",
  "OM SHIVRASHTRA MEDICAL AND EDUCATIONAL SOCIETY",
  "TRAINING SCHOOL OF NURSING SUB DIST HOSPITAL PUSAD  DIST YAVATMAL",
  "VIVEKANAND COLLEGE OF PHARMACY",
  "RAJASHRI COLLEGE OF PHARMACY, MEHKAR",
  "PADMAVATI COLLEGE OF D PHARMACY ",
  "SHRI PADMALAYA INSTITUTE OF PHARMACY",
  "KSHIRSAGAR COLLEGE OF PHARMACY ARNI",
  "SHANTIWAN INSTITUTE OF PHARMACY SHEWALI",
  "TARINI COLLEGE OF PHARMACY, NAGPUR",
  "POTDAR POLYTECHNIC, BAMBRUD",
  "SPANDAN NURSING EDUCATION (GNM) COLLEGE BELA BHANDARA",
  "3282-Saraswati Education Society, Yadavrao Tasgaonkar Polytechnic, Chandha, Nasarapur, Bhivpuri Road Railway",
  "SHRI NAGESHWAR COLLEGE OF PHARMACY",
  "OYSTER COLLEGE OF PHARMACY CHHATRAPATI SAMBHAJINAGR",
  "SHRIMATI SONABAI KELE COLLEGE OF PHARMACY, KELEWADI",
  "NETAJI SUBHASHCHANDRA BOSE EDUCATIONS TRUST NETAJI COLLEGE OF PHARMACY  AJANG  DHULE",
  "IMPERIAL COLLEGE OF PHARMACY TIRORA",
  "KAI. DYANDEO PATIL TRUST COLLEGE OF PHARMACY CHIKHURDA",
  "SURYODAY COLLEGE OF NURSING",
  "INDUTAI GAIKWAD PATIL NURSING COLLEGE ",
  "DR. UTTAMRAO MAHAJAN INSTITUTE OF NURSING, CHALISGAON",
  "MAI INSTITUTE OF HOTEL MANAGEMENT, SINDHUDURG",
  "PARVATIBAI GENBA MOZE COLLEGE OF PHARMACY BALEWADI ,PUNE",
  "SWAMI POLYTECHNIC",
  " SHRI DATTA SHIKSHAN PRASARAK MANDAL PANUTRES ALKA PATIL COLLEGE  OF PHARMACY KALE",
  "SWAMI VIVEKANAND INSTITUTE OF PHARMACY, CHHATRAPATI SAMBHAJI NAGAR",
  "SHREE SARASWATI INSTITUTE OF TECHNOLOGY",
  "LIFELINE SCHOOL OF NURSING",
  "SUSHILA NURSING COLLEGE",
  "HINDAVI COLLEGE OF PHARMACY",
  "ARYAVRAT PYARAMEDICAL VYAVSAIK SHIKSHAN SYAMEOJAGAR SHIKSHAN MANDAL,WASHIM",
  "Puranmal Lahoti Government Institute of Engineering  and Technology, Latur",
  "JANAPRABHA COLLEGE OF NURSING",
  "SAU KALPANABAI UTTAMRAO MAHAJAN INSTITUTE OF NURSING  SHIRPUR DIST DHULE ",
  "GNM TRAINING SCHOOL CHURACHANDPUR",
  "TUNNU School of Nursing",
  "ICTC THOUBAL",
  "THE SCHOOL OF NURSING IMPHAL",
  "OINAM IBOHAL POLYTECHNIC",
  "SCHOOL OF NURSING KCH",
  "N I T COMPUTER INSTITUTE  , CENTRE CODE NO. 220031",
  "L CHAOBI NURSING INSTITUTE",
  "Techno Allied Health Institute",
  "COMPOSITE REGIONAL CENTRE, IMPHAL",
  "Saina institute of medical sciences",
  "ROYAL SCHOOL OF NURSING    ",
  "DIET KAKCHING",
  "DIET D.M.COLLEGE CAMPUS IMPHAL",
  "TECHNO CARE INSTITUTE",
  "Shija Academy Of Nursing",
  "SAINA INSTITUTE OF MEDICAL SCIENCES (SIMS)",
  "DIET CHURACHANDPUR",
  "BETHESDA SCHOOL OF NURSING CHURACHANDPUR",
  "CENTRAL INSTITUTE OF PLASTIC ENGG. & TECHNOLOGY IMPHAL",
  "IRENGBAM THAMCHA DEVI NURSING AND HEALTH CARE RES INST IMPHAL WEST",
  "RAHMANIA VOCATIONAL TRAINING CENTRE",
  "FEMALE HEALTH WORKERS TRAINING SCHOOL LAMPHEL",
  "Nightingale Nursing Institute",
  "DIET HNATHAM VILLAGE CHANDEL",
  "DIET MOIRANG BISHNUPUR",
  "DIET UKHRUL HUNDUNG",
  "SHIJA ACADEMY",
  "DIET SENAPATI",
  "DIET TAMEI TAMENGLONG",
  "Hindi Teachers Training Institute,Imphal",
  "DIET IMPHAL EAST",
  "Dr Anjuli Nayak nursing institute",
  "GNM TRAINING SCHOOL THOUBAL",
  "Jawaharlal Nehru School of Nursing, Porompat",
  "SCHOOL OF ANM/FHW IMPHAL MEDICAL DIRECTORATE",
  "ADVANCED COMPUTER LEARNING CENTRE",
  "MANIPUR NURSING INSTITUTE, TENTHA",
  "LEIRIK INSTITUTE OF NURSING",
  "SHILLONG POLYTECHNIC",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING THADLASKEIN, JAINTIA HILLS",
  "CHERRA TEACHERS TRAINING CENTRE EAST KHASI HILLS",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, NONGPOH",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BAGHMARA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING RESUBELPARA, EAST GARO HILLS",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING SAITSOHPEN, EAST KHASI HILLS",
  "VATSALYA INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "INSTITUTE OF HOTEL MANAGEMENT",
  "GNM SCHOOL OF NURSING PAHAMSYIEM, NONGPOH",
  "COMPOSITE REGIONAL CENTRE FOR SKILL DEVELOPMENT, REHABILITATION AND EMPOWERMENT OF PERSONS WITH DISABILITIES DIVYANGJAN, CRC SHILLONG    ",
  "ST JOSEPHS ACADEMY OF NURSING UMTREW RIBHOI DISTRICT MEGHALAYA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING WEST GARO HILLS, TURA",
  "RAPSBUN SCHOOL OF NURSING EAST KHASI HILLS",
  "DR. NORMAN TUNNEL HOSPITAL, SCHOOL OF NURSING JOWAI.",
  "SCHOOL OF NURSING EAST KHASI HILLS",
  "CIVIL HOSPITAL EAST KHASI HILLS EAST KHASI HILLS",
  "MONTFORT CENTRE FOR EDUCATION",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING WEST KHASI HILLS",
  "North Eastern Institute of Ayurveda and Homoeopathy",
  "WOODLAND INSTITUTE OF NURSING EAST KHASI HILLS",
  "TURA POLYTECHNIC",
  "DR. H. GORDON ROBERTS HOSPITAL EAST KHASI HILLS",
  "JOWAI POLYTECHNIC",
  "Bethany School of Nursing",
  "RINO SIMONETTI MEMORIAL SCHOOL OF NURSING WEST GARO HILLS",
  "FAITH NURSING SCHOOL, RAMTHAR LUNGLEI",
  "MIZORAM INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "SCHOOL OF AGRICULTURAL SCIENCE",
  "APOLLO SCHOOL OF NURSING AIZAWL",
  "LM COMPUTER INSTITUTE",
  "EBENEZER INSTITUTE OF TECHNOLOGY, KANAN, AIZAWL",
  "HI TECH INSTITUTE OF COMPUTER",
  "ZORAM ARVY COMMEC INSTITUTE",
  "INTEGRATED ANIMAL HUSBANDRY AND VETERINARY TRAINING INSTITUTE",
  "D AND D IT ACADEMY",
  "CITY COMPUTER CENTRE",
  "SUNSET COMPUTER",
  "ANM SCHOOL MAMIT",
  "IDEA COMPUTER INSTITUTE",
  "ROYAL COMPUTER INSTITUTE",
  "EYE CARE INSTITUTE OF OPHTHALMIC SCIENCES",
  "AUXILIARY NURSING AND MIDWIFERY SCHOOL AIZAWL",
  "MP COMPUTER INSTITUTE",
  "INSTITUTE FOR NEW EDUCATION AND TECHNOLOGY, INET",
  "EASTERN STAR COMPUTER CENTER",
  "KMC ACADEMY OF COMPUTER",
  "DIVINE COMPUTER CENTRE",
  "INSTITUTE OF LABORATORY SCIENCES",
  "LIANSAILOVA INSTITUTE OF TECHNOLOGY",
  "Laithangpuii College of Pharmacy",
  "FAITH INSTITUTE OF PARAMEDICAL TECHNOLOGY",
  "Z AND M INSTITUTE OF LABORATORY TECHNOLOGY AND RESEARCH",
  "MFM SCHOOL OF NURSING",
  "ACADEMY OF PARAMEDICAL TECHNOLOGY",
  "NAZARETH INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "MARCEILES COMPUTER INSTITUTE",
  "DOVE COMPUTER INSTITUTE",
  "ANM SCHOOL LAWNGTLAI",
  "MIZORAM HINDI TRAINING COLLEGE",
  "ZOCOMP INSTITUTE",
  "NURSING SCHOOL LUNGLEI",
  "WOMEN POLYTECHNIC AIZAWL",
  "EVLOGIES COMPUTER LEARNING DIVISION",
  "MATRIX COMPUTER CENTRE, BAZAR VENG, LAWNGTLAI",
  "ZORAM COMPUTER TRAINING CENTRE",
  "MERGE COMPUTER CENTRE",
  "MODERN INFORMATION TECHNOLOGY",
  "EYE CARE INSTITUTE OF OPHTHALMIC SCIENCES    ",
  "CHRISTIAN SERKAWN HOSP. SCHOOL OF NURSING LUNGLEI",
  "HEALTH WORKERS TRAINING SCHOOL",
  "BLESSINO PHARMACY INSTITUTE",
  "DISTRICT INSTITUTE FOR EDUCATION & TRAINING, CHAMPHAI",
  "DISTRICT INSTITUTE FOR EDUCATION & TRAINING, KOLASIB",
  "REGIONAL INSTITUTE OF COMPUTER EDUCATION",
  "VOCATIONAL SCHOOL OF EDUCATION",
  "VTR COMPUTER CENTRE DURTLANG NORTH",
  "BLESSINO NURSING SCHOOL",
  "MIZORAM COMPUTER CENTRE",
  "DISTRICT INSTITUTE FOR EDUCATION & TRAINING, LAWNGTLAI",
  "GNM SCHOOL CHAMPHAI",
  "DISTRICT INSTITUTE FOR EDUCATION & TRAINING, MAMIT",
  "DISTRICT INSTITUTE FOR EDUCATION & TRAINING, SAIHA",
  "DOLREICH INSTITUTE OF TECHNOLOGY",
  "BEER SEBA GROUP OF INSTITUTION",
  "JOJO COMPUTER INSTITUTE",
  "GOVERNMENT POLYTECHNIC, LUNGLEI",
  "CHAWNGTHU COMPUTER INSTITUTE",
  "MARTIN COMPUTER INSTITUTE",
  "DANNYS COMPUTER INSTITUTE",
  "GOSHEN COMPUTER LEARNING CENTRE",
  "MIZORAM PROFESSIONAL COMPUTER INSTITUTE",
  "CHAWNGHLUT COMPUTER INSTITUTE",
  "DISTRICT INSTITUTE FOR EDUCATION & TRAINING, SERCHHIP",
  "KHAWLHRING COMPUTER INSTITUTE OF TECHNOLOGY",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, AIZAWL",
  "DIVINE COMPUTER CENTER",
  "VTR COMPUTER CENTRE, KHATLA, AIZAWL",
  "SCHOOL OF NURSING THINGDAWL",
  "JOHANS COMPUTER INSTITUTE",
  "INFOSTEP COMPUTER ACADEMY",
  "GILLIAN COMPUTERZ",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, LUNGLEI",
  "GOVERNMENT POLYTECHNIC SEDEM",
  "GOVERNMENT POLYTECHNIC DOYANG WOKHA",
  "DIET MOKOKCHUNG YIMYU COMPOUND MOKOKCHUNG",
  "ST. PAUL INSTITUTE OF EDUCATION KOHIMA",
  "INSTITUTE OF COMMUNICATION & INFORMATION TECHNOLOGY MOKOKCHUNG",
  "NAGALAND TOOL ROOM AND TRAINING CENTRE",
  "GOVERNMENT POLYTECHNIC, KOHIMA",
  "DIET CHIECHAMA KOHIMA",
  "KHELHOSHE POLYTECHNIC ATOIZU",
  "SCHOOL OF NURSING, DIMAPUR",
  "DIET WOKHA",
  "GOVERNMENT POLYTECHNIC PEREN",
  "DIET ZUNHEBOTO",
  "Government Polytechnic Tsunazho, Chetheba, Phek",
  "GOVERNMENT POLYTECHNIC ABOI MON",
  "DIET MON",
  "HEALTH NURSING SCHOOL",
  "DIET,PFUTSERO",
  "DIET TUENSANG",
  "STATE INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION",
  "GOVERNMENT POLYTECHNIC SEITHEKEMA C CHUMOUKEDIMA",
  "DIET DIMAPUR",
  "GRACE NURSING AND HEALTH SCIENCES INSTITUTE",
  "DIVINE COLLEGE OF HEALTH SCIENCE BHUBANESWAR",
  "SAHAY MEDICAL ACADEMY",
  "TEJAS COLLEGE OF NURSING AND PARAMEDICAL SCIENCE",
  "ASHUTOSH INSTITUTE OF PARAMEDICAL SCIENCE",
  "Dhaneswar School of Nursing",
  "Sundargarh GNM Training College,Sudargarh, Odisha",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, PURI",
  "IIPM SCHOOL OF ENGINEERING AND TECHNOLOGY , KANSBAHAL",
  "SUM NURSING SCHOOL KHURDA",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, RAGADI, BANKI",
  "SAMBALPUR NURSING SCHOOL",
  "SHRADDHA GNM TRAINING CENTRE",
  "NIRMANA SCHOOL OF NURSING",
  "SATYANARAYAN GNM TRAINING COLLEGE",
  "KORAPUT SCHOOL OF NURSING GNM",
  "S.S.B. REGIONAL INSTT. SC. & TECH. (POLY) CHIRADA",
  "ST THOMAS SCHOOL OF NURSING BALASORE",
  "SUBHADRA DEVI SCHOOL OF NURSING",
  "RCM GLOBAL B SCHOOL",
  "SHIKSHYA O SAMBHABANA",
  "DHARMANANDA SCHOOL OF MEDICAL SCIENCE AND TECHNOLOGY",
  "SHREE ANM TRAINING CENTRE",
  "SASMITA INSTITUTE OF MEDICAL SCIENCE  AND TECHNOLOGY",
  "GYANADEVI SCHOOL OF NURSING",
  "Gopabandhu Institute of Medical Science And Research",
  "ANM Training Centre, Sundergarh",
  "ASHAA KIRANN INSTITUTE OF MEDICAL SCIENCE",
  "RAMAMNI COLLEGE OF NURSING",
  "PRASANNA PURSOTTAM DEV SCHOOL OF NURSING",
  "SANJU INSTITUTE OF MEDICAL SCIENCE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING PHULBANI, TIKABALI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING PARLAKHEMUNDI, GAJAPATI",
  "ANM Training Centre, Subarnapur",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, PANCHAPADA, JHARSUGUDA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, NAWARANGPUR",
  "ANM Training Centre, Sambalpur",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING NARSHINGHPUR, CUTTACK",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING MAYURBHANJA, BARIPADA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KHURDA",
  "ANM Training Centre, Keonjhar",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING KHALLIKOTE, GANJAM",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KEONJHAR",
  "ANM Training Centre, Kendrapara",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING JEYPORE, KORAPUT",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, JAGATSINGHPUR",
  "AYAN SCHOOL OF NURSING",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING DOLIPUR, JAJPUR",
  "MANJARI DEVI SCHOOL OF NURSING KHURDAH",
  "Balasore School Of Nursing",
  "D K SCHOOL OF NURSING",
  "ANM Training Centre, Dhenkanal",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, DHENKANAL",
  "MAYURBHANJ SCHOOL OF ENGINEERING BARIPADA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, DEOGARH",
  "SHANTI SCHOOL OF NURSING",
  "PREMIER COLLEGE OF PHARMACY",
  "HARSHAVARDHAN INSTITUTE OF MEDICAL SCIENCE    ",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, PHULBANI",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, SAKHIGOPAL, PURI",
  "ANM Training Centre Deogarh",
  "KHANDABAHAL COLLEGE OF NURSING",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING CHHENDIPADA, ANGUL",
  "RADHAKANT SCHOOL OF NURSING",
  "BIJAYANTI COLLEGE OF NURSING",
  "NEWTON COLLEGE OF HEALTH AND SCIENCE",
  "SEVA COLLEGE OF NURSING",
  "BIJAYANTI COLLEGE OF NURSING,ANGUL",
  "ANM Training Centre, Daspalla",
  "Sambalpur ANM Training Centre,Sambalpur",
  "KALAHANDI SCHOOL OF NURSING",
  "MAYURBHANJ SCHOOL OF NURSING",
  "Sankar Rukmani School of Nursing",
  "MASTER  ACADEMY OF PATHOLOGICAL SCIENCE    ",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BOUDH",
  "GOVT. SCHOOL OF NURSING,DHH,SUNDARGARH",
  "BHABASAGAR SCHOOL OF NURSING",
  "AAHWAAN INSTITUTE OF HEALTH SCIENCE",
  "SUDHANANDANA RESIDENTIAL POLYTECHNIC NECHHIPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BHAWANIPATNA, KALAHANDI",
  "LAXMIPRIYA INSTITUTE OF MEDICAL SCIENCE",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, TITLAGARH, BALANGIR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BARAGARH",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION (WOMEN) BHUBANESWAR, KHURDA",
  "MITS SCHOOL OF ENGINEERING, BHUBANESWAR",
  "ANM Training Centre, Boudh",
  "NABARANGPUR COLLEGE OF PHARMACY    ",
  "SWAMI VIVEKANANDA INSTITUTE OF MEDICAL SCIENCE",
  "SADGURU COLLEGE OF NURSING",
  "SHANTI MEMORIAL SCHOOL OF NURSING",
  "GOURI INSTITUTE OF MEDICAL SCIENCE, ROURKELA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BALANGIR",
  "MMCHT ANM Training Centre",
  "ANM TRAINING CENTRE,GAJAPATI",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, POLSARA, GANJAM",
  "Sarala GNM Training College",
  "PATHANI SAMANTA COLLEGE OF MEDICAL SCIENCE",
  "SUNDARGARH PHARMA COLLEGE",
  "ORISSA ASSOCIATION FOR THE BLIND",
  "Indian Institute of Tourism  and Travel Management",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING AGARPARA, BHADRAK",
  "SAI RUDRA COLLEGE OF NURSING",
  "SHANTI DMLT TRAINING INSTITUTE",
  "SABITRI COLLEGE OF MEDICAL SCIENCE",
  "LAXMIDHAR COLLEGE OF MEDICAL SCIENCE",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, DHARMAGARH",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, KISHORENAGAR, ANGUL",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, PIPILI, PURI",
  "ODISHA INSTITUTE OF EDUCATIONAL DEVELOPMENTAL STUDIES",
  "ROURKELA INSTITUTE OF TECHNOLOGY KALINGA ROURKELA",
  "KALINGA INSTITUTE OF PARAMEDICAL SCIENCE",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION (URDU), CUTTACK",
  "C.V. RAMAN POLYTECHNIC BHUBANESWAR",
  "ANM  Training Centre, Bhubaneswar",
  "OM SAI COLLEGE OF PHARMACY AND HEALTH SCIENCE",
  "HERBAL CROSS INSTITUTE OF PHARMACY",
  "Royal Institute of Allied Medical Sciences",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, CHIKITI",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, LANGALESWAR, BALASORE",
  "RASIK GIRI MEMORIAL INSTITUTE FOR MEDICAL AND LABORATORY TECHNICIAN",
  "QNETIC TECHNO MEDICAL FOUNDATION",
  "SADGURU COLLEGE OF ALLIED MEDICAL SCIENCES    ",
  "SHRIDHAR SAHU COLLEGE OF PHARMACY",
  "Mothers Nursing School",
  "MEDSKILL INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "Mother Teresa Health Worker (Female) Training Centre",
  "SWAMI VIVEKANANDA INSTITUTE OF HEALTH SCIENCE",
  "Somanath School of Nursing",
  "Sarala Institute of  Nursing",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, BOLANGIR",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, PAHIMAHURA, BHADRAK",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, BHANJANAGAR, GANJAM",
  "SRI MEDICAL SCIENCE AND PHARMACY COLLEGE",
  "SUN SHINE INSTITUTE OF MEDICAL SCIENCE AND TECHNOLOGY",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, BAGUDI, BALASORE",
  "AMIT INSTITUTE OF MEDICAL SCIENCE AND HOSPITAL",
  "RAJIB LOCHAN HOTA COLLEGE OF PHARMACY, BARPALI",
  "Mother Teresa School of Nursing",
  "SOPHITORIUM MANAGEMENT COLLEGE",
  "ROTARY PARAMEDICAL INSTITUTE",
  "SARASWATI INSTITUTE OF MEDICAL SCIENCE",
  "Creative Junior Nursing School",
  "GENERAL NURSING AND MIDWIFERY TRAINING SCHOOL",
  "TRIVENI INSTITUTE OF PHARMACEUTICAL AND HEALTH SCIENCE",
  "BARUNEI SCHOOL OF NURSING",
  "SHANTI INSTITUTE OF MEDICAL SCIENCE AND TECHNOLOGY DMLT",
  "ALEX INSTITUTE OF MEDICAL SCIENCE",
  "ENFOLD SCHOOL OF NURSING",
  "Mukti ANM Training Centre",
  "CITY INSTITUTE OF TECHNICAL EDUCATION KUANR MUNDA ROURKELA",
  "Institute of Management And Information Science",
  "BABA JATESWAR NURSING TRAINING SCHOOL",
  "TRIVIKRAM INSTITUTE OF HEALTH SCIENCE AND RESEARCH",
  "NIGAMANANDA INSTITUTE OF MEDICAL SCIENCES",
  "UTKAL COLLEGE OF NURSING AND MEDICAL SCIENCE",
  "NATIONAL INSTITUTE OF MEDICAL & MANAGEMENT STUDIES KHURDA",
  "MARUTI  PHARMACY  COLLEGE",
  "AKASH INSTITUTE OF PHARMACEUTICAL EDUCATION AND TECHNOLOGY KENDRAPARA",
  "BHUBANESWAR INSTITUTE OF MEDICAL SCIENCE KENDRAPARA",
  "KUSUM INSTITUTE OF HEALTH SCIENCE",
  "MAHENDRA BISWAL INSTITUTE OF LABORATORY TECHNOLOGY",
  "ASHAA KIRANN ENGINEERING SCHOOL",
  "BATAKRUSHNA COLLEGE OF PHARMACY NUAPADA",
  "KALINGA INSTITUTE OF MEDICAL TECHNOLOGY CHATRAPUR GANJAM",
  "ANJANADEVI COLLEGE OF NURSING, JAMUJHARI,CHHATABAR,JANLA, KHORDHA,ODISHA",
  "GOVERNMENT SECONDARY TRAINING SCHOOL, BHALULATA, SUNDARGARH",
  "MAHARAJA INSTITUTE OF ADVANCED COMPUTING AND RESEARCH",
  "GOVT DAV SECONDARY TRAINING SCHOOL, KALINGA",
  "JHARSUGUDA ANM TRAINING SCHOOL BEHERMAL",
  "ANM TRAINING CENTRE, PURI",
  "Anm Training Centre, Rayagada",
  "STATE INSTITUTE OF HOTEL MANAGEMENT, BALANGIR",
  "SIVANANDA COLLEGE OF PHARMACY",
  "MAYURBHANJ MEDICAL ACADEMY",
  "DIVYA INSTITUTE OF MEDICAL SCIENCE",
  "Kuntala Devi Institute of Medical and Technology",
  "DRIEMS SCHOOL OF PARAMEDICAL",
  "PURI COLLEGE OF PHARMACY",
  "VIGYAN INSTITUTE OF MEDICAL TECHNOLOGY AND ALLIED SCIENCE",
  "BIJU PATTNAIK PHARMACY COLLEGE JAJPUR",
  "MAHIMA COLLEGE OF PHARMACY",
  "ANGUL COLLEGE OF PHARMACY",
  "MAHENDRA INSTITUTE OF MANAGEMENT AND TECHNICAL STUDIES",
  "Synergy Polytechnic, Bhubaneswar",
  "AGRADOOT COLLEGE OF NURSING",
  "SHANTI SCHOOL OF NURSING",
  "PARAMEDICAL WING INSTITUTE OF PHARMACY AND TECHNOLOGY SALIPUR",
  "SASWATI SCHOOL OF NURSING",
  "KASHINATH INSTITUTE OF TECHNOLOGICAL EDUCATION",
  "Nabapravat School of Nursing",
  "KALAM INSTITUTE OF TECHNOLOGY BERHAMPUR",
  "NALANDA INSTITUTE OF TECHNOLOGY CHANDAKA BHUBANESWAR",
  "Satyam Regional Institute of Nursing",
  "ANANTA SARADA NURSING SCHOOL",
  "MOTHERS INSTITUTE OF NURSING ACADEMY JALESWAR BALASORE",
  "DHANESWAR INSTITUTE OF MEDICAL TECHNOLOGY",
  "RAMADEVI INSTITUTE OF MEDICAL SCIENCE AND RESEARCH",
  "Namitadevi School of Nursing",
  "ANM Training Centre, Bhawanipatna",
  "GITANJALI SCHOOL OF NURSING",
  "NEW SHINE INSTITUTE OF MEDICAL SCIENCES AND TECHNOLOGY",
  "NARAYANI INSTT. OF ENGG. & TECH. BANARPAL",
  "Satyanarayan ANM Training School",
  "NARAYANI SCHOOL OF NURSING JAGATSINGHPUR",
  "Premier School Of Nursing (Anm And Gnm)",
  "NAYAGARH INSTITUTE OF ENGINEERING & TECHNOLOGY (POLYTECHNIC)",
  "CHRISTIAN HOSPITAL GANJAM",
  "AADITRI INSTITUTE OF MEDICAL SCIENCE",
  "MAHESWARI GNM TRAINING SCHOOL",
  "NEELACHAL INSTITUTE OF NURSING SCHOOL",
  "SATYA SAI SCHOOL OF ENGGINEERING DIPLOMA, BALASORE",
  "VISION INSTITUTE OF MEDICAL SCIENCE AND RESEARCH",
  "NILACHAL POLYTECHNIC BHUBANESHWAR",
  "Choudwar School of Nursing",
  "CATHOLIC MISSION HOSPITAL SUNDERGARH",
  "SAI STITI INSTITUTE  OF MEDICAL SCIENCE",
  "ANJALI COLLEGE OF NURSING STUDIES",
  "ANM Training Centre, Berhampur",
  "Blue Wheel Institute Of Nursing Sciences",
  "BLOCK INSTITUTE OF EDUCATION AND TRAINING, UMERKOTE",
  "School of Nursing (ANM) , Plot No  N-5/157, Nayapalli, Dist - Khurda , Bhubaneswar, Odisha 751015",
  "ANM Training Centre, Baripada",
  "BLOCK INSTITUTE OF EDUCATION AND TRAINING, KUNDUKELA SUNDERGARH",
  "SHREEYA COLLEGE OF NURSING",
  "NARAYAN MEMORIAL INSTITUTE OF MEDICAL SCIENCE",
  "SOPHITORIUM ENGINEERING SCHOOL",
  "NILASAILA INSTITUTE OF SCIENCE AND TECHNOLOGY, SERGARH, BALASORE",
  "SHAIKH INSTITUTE OF MEDICAL TECHNOLOGY",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, KUSHALDA, MAYURBHANJ",
  "COMPASSION SCHOOL OF NURSING",
  "ARADHANA FOUNDATION OF NURSING",
  "MICROVIEW INSTITUTE OF MEDICAL LABORATORY TECHNOLOGY",
  "NORTH ODISHA SCHOOL OF ENGINEERING, MAYURBHANJ",
  "NURSES TRAINING INSTITUTE SUNDERGARH",
  "SCHOOL OF NURSING & HEALTH SCIENCES GANJAM",
  "INSPIRE INSTITUTE OF MEDICAL LABORATORY TECHNOLOGY",
  "MAA TARA COLLEGE OF NURSING",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, NIMAPARA, PURI",
  "ODISHA INSTITUTE OF ENGINEERING & TECHNOLOGY DHENKANAL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, MALKANAGIRI, CHITRAKONDA",
  "SARADA DEVI INSTITUTE OF MEDICAL SCIENCE",
  "ODISHA POLYTECHNIC",
  "School of Nursing, N P M Institute of Medical Science and Research , In Front of Dist. H Q Hospital, Dist-Keonjhar, Odisha-758001",
  "ASA INSTITUTE OF SKILL DEVELOPMENT",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BHAGABATPUR, KENDRAPARA",
  "KANAK DEVI INSTITUTE OF MEDICAL SCIENCE",
  "ODISHA SCHOOL OF MINING ENGINEERING",
  "JAYADEVA INSTITUTE OF NURSING SCIENCES",
  "BHUBANESWAR INSTITUTE OF MEDICAL SCIENCE",
  "PALLY CHANDAN SCHOOL OF NURSING",
  "GOURI SCHOOL OF NURSING",
  "Orissa Health Education School Of Nursing",
  "GITANJALI SCHOOL OF NURSING KHORDHA",
  "SCHOOL OF NURSING RAYAGADA",
  "Orissa Nursing Training Institute",
  "OXFORD SCHOOL OF POLYTECHNIC DIPLOMA, BALIANTA",
  "PABITRA MOHAN INSTITUTE OF TECHNOLOGY TALCHER",
  "SEVA SCHOOL OF NURSING ANGUL",
  "ANM Training Centre, Balasore",
  "SARASWAT SCHOOL OF NURSING",
  "PRIYADARSHINI COLLEGE OF NURSING AND ALLIED HEALTH SCIENCES",
  "SAIRUDRA COLLEGE OF NURSING",
  "MUKTI SCHOOL OF NURSING, CUTTACK",
  "Shaikh School of  Nursing,  Odisha",
  "VAKTI SCHOOL OF NURSING,BOUDH",
  "RN GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, CUTTACK",
  "JHADESWAR SCHOOL OF NURSING",
  "JAY JAGANNATH SCHOOL OF NURSING, KHARIAR ROAD, NUAPADA",
  "CHALLENGERS ACADEMY OF S.H.E      ",
  "PADAMPUR NURSING COLLEGE",
  "ASA COLLEGE OF NURSING",
  "SASHIPRAVA SCHOOL OF NURSING",
  "KEONJHAR NURSING COLLEGE KEONJHAR",
  "BLOCK INSTITUTE OF EDUCATION AND TRAINING, GORUMAHISANI MAYURBHANJ",
  "PADMASHREE KRUTARTHA ACHARYA INSTITUTE OF ENGINEERING & TECHNOLOGY, BERGARH",
  "PALLICHANDAN SCHOOL OF NURSING PURI",
  "ANM Training Centre, Jeypore",
  "PATHANI SAMANTA INSTITUTE OF ENGG. & TECHNOLOGY",
  "SUNDARGARH GNM TRAINING CENTRE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, NUAPADA",
  "MANIKESWARI PHARAMACY SCHOOL    ",
  "Shaktirupa School of Nursing , Odisha",
  "ARUN GNM TRAINING SCHOOL",
  "Pioneer ANM Training School",
  "BHARAT SCHOOL OF NURSING",
  "Shree Mahavir School of Nursing, Odisha",
  "SIDDHARTHA INSTITUTE OF ENGG. & TECH. (POLY) EKTAGUDA",
  "S I E M S School of Nursing",
  "SITE - A School of Nursing",
  "Smt.Susila Devi Institute of Nursing Education, Rayagada",
  "GOVT ELEMENTARY TEACHER EDUCATION INSTITUTION, BALIGUDA",
  "DRIEMS Polytechnic",
  "Sradha School of Nursing , Odisha",
  "Sree Vidya Niketan College of Medical Science and Research",
  "SKDAV GOVERNMENT POLYTECHNIC",
  "BAPUJI ACADEMY OF MEDICAL SCIENCE",
  "SRI JAGANNATH GNM TRAINING SCHOOL PURI",
  "MANIKESWARI INSTITUTE OF PARAMEDICAL SCIENCE",
  "SUNAAYANA COLLEGE OF MEDICAL SCIENCE",
  "GAYATRI COLLEGE OF PHYSIOTHERAPY",
  "GAYATRI INSTITUTE OF PARAMEDICAL SCIENCES",
  "SCHOOL OF DMLT NPM INSTITUTE OF MEDICAL SCIENCE AND RESEARCH",
  "SATYANARAYAN DMLT TRAINING SCHOOL",
  "SANTOSHI INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
  "AIGIRI COLLEGE OF MEDICAL SCIENCE, KHORDHA",
  "SUBASH BOSE COLLEGE OF PHARMACY",
  "MAYURBHANJ DMLT TRAINING INSTITUTE",
  "CARE INSTITUTE OF MEDICAL SCIENCE AND TECHNOLOGY",
  "HEREDITY INSTITUTE OF MEDICAL SCIENCES",
  "ANGUL INSTITUTE OF MEDICAL SCIENCE",
  "MAA MANGALA COLLEGE OF PHARMACEUTICAL SCIENCES",
  "CREATIVE JENUS NURSING SCHOOL",
  "SAKUNTALA SUDARSAN INSTITUTE OF TECHNOLOGY POLYTECHNIC",
  "EASTERN INSTITUTE OF MEDICAL SCIENCE",
  "REGIONAL INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "Gitanjali School of Nursing",
  "KANDHAMAL COLLEGE OF PHARMACY",
  "ROYAL VISION INSTITUTE OF MEDICAL SCIENCE",
  "MANISHA GNM COLLEGE",
  "GOVERNMENT POLYTECHNIC, Boudh",
  "BAJIROUT INSTITUTE OF ENGGINEERING & TECHNOLOGY (POLY), GOBINDPUR, DHENKANAL",
  "INSTITUTE OF MANAGEMENT BHUBANESWAR",
  "HRUDANANDA DANI NURSING COLLEGE",
  "ODM BUSINESS SCHOOL",
  "GANESH INSTITUTE OF ENGG. & TECH. ANDHARUA BHUVANESWAR",
  "SWARNALATA SCHOOL AND NURSING COLLEGE",
  "ISPAT SCHOOL OF NURSING",
  "GANDHI SCHOOL OF ENGINEERING PURUSOTTAMPUR BEHRAMPUR",
  "DIBYA SCHOOL OF NURSING",
  "BETNOTI SCHOOL OF NURSING",
  "ARADHYA SCHOOL OF NURSING",
  "SYNERGY SCHOOL OF ENGINEERING",
  "GANAPATI INSTITUTE OF ENGINEERING & TECHNOLOGY POLYTECHNIC JAGATPUR",
  "SHREE JAGANNATH COLLEGE OF NURSING",
  "Gajapati School of Nursing",
  "Florence Nightingale ANM (Female Health Worker) Training School",
  "BERHAMPUR COLLEGE OF NURSING",
  "MAHESWARI PHARMACEUTICAL COLLEGE SUNDARGARH",
  "CAPITAL SCHOOL OF ENGINEERING",
  "Essen School of Nursing",
  "VIKAS COLLEGE OF NURSING",
  "ARUN ANM TRAINING SCHOOL",
  "KENDRAPARA SCHOOL OF NURSING",
  "MANORAMA SCHOOL OF NURSING",
  "JN INSTITUTE OF MEDICAL SCIENCE",
  "D R I E M S School Of Nursing",
  "BADRI PRASAD INSTT. OF TECHNOLOGY DEBAIPALI SAMBALPUR",
  "GHUMUSAR GNM SCHOOL OF NURSING",
  "TARINI SCHOOL AND COLLEGE OF NURSING, KEONJHAR",
  "PADMALAYA SCHOOL OF NURSING,ICHHABATIGUDA",
  "IDREAM INSTITUTE OF MEDICAL AND HEALTH SCIENCE",
  "Dr Ambedkar Institute of Medical Science",
  "BALAJI INSTITTUE OF TECH. & SCIENCE KNOWLEDGE CENTRE GUNUPUR",
  "SIMILIPAL INSTITUTE OF MEDICAL SCIENCE",
  "Srimaa School Of Nursing,Puri, Odisha",
  "BIRAJA INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "MINATIDEVI SCHOOL OF NURSING",
  "SARADADEVI SCHOOL AND COLLEGE OF NURSING",
  "Dox Orland School of Nursing",
  "RAJDHANI NURSING SCHOOL",
  "OM SAI INSTITUTE OF PARAMEDICAL SCIENCES",
  "KAMALAKANTA NURSING AND HEALTH SCIENCE COLLEGE",
  "Aum Sai School of Nursing",
  "Divine School of Nursing",
  "JASODA NURSING SCHOOL",
  "LORD JAGANNATH INSTITUTE OF PARAMEDICAL SCIENCES, BBSR",
  "UMAMANI INSTITUTE OF PHARMACY",
  "SOHAM SCHOOL OF NURSING, SISUPALGARH, BHUBANESWAR ",
  "AUMSAI INSTITUTE OF TECHNICAL EDUCATION BERHAMPUR",
  "CARE INSTITUTE OF MEDICAL SCIENCE",
  "DIVINE INSTITUTE OF ENGG. TECH. PODA ASTIA BARIPADA",
  "INSPIRE INSTITUTE OF PARAMEDICAL SCIENCES",
  "RITAYANI COLLEGE OF NURSING,GNM",
  "GENERAL NURSING AND MIDWIFERY TRAINING SCHOOL ANGUL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, SONEPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING SANKARA, SUNDARGARH",
  "KUMUDINI INSTITUTE OF MEDICAL TECHNOLOGY",
  "INSTITUTE OF PHARMACEUTICAL SCIENCE AND TECHNOLOGY PADMAPUR",
  "BALAJI COLLEGE OF NURSING",
  "SURENDRA HOSPITAL DMLT AND DMRT TRAINING SCHOOL",
  "CRYOGENEX INSTITUTE OF MEDICAL SCIENCE AND RESEARCH",
  "MAHESWARI ANM TRAINING SCHOOL BARGARH",
  "SRI POLYTECHNIC KOMOND ODAGOAN",
  "NARAYAN MEMORIAL INSTITUTE OF MEDICAL SCIENCE NMIMS",
  "BADRIPRASAD SCHOOL OF NURSING",
  "PRIYANKA DEVI COLLEGE OF PHARMACY",
  "KUMUDIN SCHOOL OF NURSING",
  "ASIAN SCHOOL OF TECHNOLOGY BANTALA MUKTAPUR",
  "Sri Ram School of Nursing , At / Po - Sohela , Dist-Bargarh",
  "MAA BAUTI NURSING CENTRE, GNM",
  "SHIKSHA COLLEGE OF NURSING",
  "Sri Sri Baroda School of Nursing , Odisha",
  "SMILE INSTITUTE OF MEDICAL SCIENCE",
  "JET ANM TRANING CENTRE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, SAMBALPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING REMUNA, BALASORE",
  "NETAJI SCHOOL OF NURSING",
  "ARYAN INSTT. OF ENGG. & TECH. (POLY) SUNDERGRAM",
  "SUSHREE INSTITUTE OF TECHNICAL EDUCATION BALANGIR",
  "KRUSHNA BHARATI INSTITUTE OF MEDICAL SCIENCE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING  RAYAGADA, BISSAM CUTTACK",
  "PRATIVA DEVI SCHOOL OF NURSING",
  "SUSHREE INSTITUTE OF TECHNICAL EDUCATION",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING RAJSUNAKHALA, NAYAGARH",
  "MAA SAMLAI  INSTITUTE OF DMLT TRAINING",
  "SUSIL KUMAR INSTITUTE OF MEDICAL SCIENCE",
  "ANM TRAINING CENTRE, MALKANGIRI",
  "MANIKESWARI COLLEGE OF NURSING",
  "EKAMRA SCHOOL OF NURSING",
  "SCB MEDICAL COLLEGE PHARMACY WING CUTTACK",
  "PRATIVA INSTITUTE OF MEDICAL SCIENCE",
  "NOBEL COLLEGE OF MEDICAL SCIENCE",
  "SUNDARGARH INSTITUTE OF MANAGEMENT",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, PATNAGARH, BALANGIR",
  "Government Polytechnic, Jagatsingpur",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, KUANRMUNDA",
  "ANM Training Centre, Bolangir",
  "KOUTILYA NURSING SCHOOL",
  "CRYOGENEX INSTITUTE OF MEDICAL SCIENCE AND RESEARCH ,KENDUJHAR",
  "BALASORE SCHOOL OF ENGINEERING BALASORE",
  "SARADADEVI SCHOOL OF NURSING",
  "GHADAI INSTITUTE OF MEDICAL SCIENCE,MALKANGIRI",
  "ANM TRAINING CENTRE, PHULBANI",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, REMULI, KEONJHAR",
  "PAN GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, BANKOI, KHURDA",
  "MAA BHANDARGHARANI ANM TRAINING CENTRE",
  "INNOVATION-THE BUSINESS SCHOOL, MUKTAPUR, KHURDA",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, TUDIGADIA, BALASORE",
  "KIIT POLYTECHNIC BHUBNESWAR",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, FAKIRPUR",
  "SHANTI SCHOOL OF NURSING AND RESEARCH CENTRE",
  "JAY GANESH SCHOOL OF NURSING",
  "INTERSCIENCE INSTITUTE OF MANAGEMENT AND TECHNOLOGYBHUBANESWAR",
  "PRESIDENCY COLLEGE BERHAMPUR",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, TANGI",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, BARIPADA, MAYURBHANJ",
  "CHIDANANDA INSTITUTE OF MEDICAL SCIENCE",
  "BRAMHANANDA INSTITUTE OF MEDICAL SCIENCE",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, KENDRAPARA",
  "SRI JAGANNATH SCHOOL OF NURSING",
  "BRIGHT INSTITUTE OF MEDICAL TECHNOLOGY",
  "SASMITA SCHOOL OF NURSING",
  "TRISHA NURSING CENTRE",
  "GURUKRUPA COLLEGE OF NURSING",
  "GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION, ATHAGARH, CUTTACK",
  "MINAKHI SCHOOL OF NURSHING",
  "NIBEDITA INSTITUTE OF NURSING EDUCATION AND TRAINING CENTRE",
  "NATIONAL INSTITUTE OF MEDICAL SCIENCE",
  "MAA MAJHIGHARIANI INSTITUTE OF NURSING",
  "SAI SCHOOL OF ENGINEERING",
  "ISHIKA NURSING AND PARAMEDICAL STUDIES",
  "VIJAYANJALI SCHOOL OF ENGINEERING",
  "NM COLLEGE OF NURSING",
  "BIRAJA SCHOOL OF NURSING JAJPUR",
  "UTKAL K O N INSTITUTE OF MEDICAL SCIENCE",
  "BALASORE INSTITUTE OF MEDICAL SCIENCE",
  "GOVERNMENT POLYTECHNIC, AGNIPUR",
  "ESTUARINE BIOLOGY REGIONAL CENTRE ZOOLOGICAL SURVEY OF INDIA",
  "TRISHA TRAINING COLLEGE",
  "DIBYA COLLEGE OF PHARMACY",
  "PRAGATI INSTITUTE OF PARAMEDICAL SCIENCE",
  "MAA TARINI COLLEGE OF PARAMEDICAL SCIENCE, KEONJHAR",
  "JAJPUR PHARMACY COLLEGE",
  "GOVT.POLYTECHNIC,BHADRAK",
  "SAI ACADEMY OF NURSING SCIENCES",
  "BISHNUPRIYA GNM NURSING SCHOOL",
  "LATASHRI COLLEGE OF NURSING",
  "MARSHAGHAI NURSING COLLEGE",
  "BRIGHT SCHOOL OF NURSING",
  "JASODA DEVI INSTITUTE OF MEDICAL TECHNOLOGY, SONEPUR",
  "GOVERNMENT POLYTECHNIC DARLIPALI",
  "BIJUPATTNAIK PHARMACEUTICAL COLLEGE",
  "SARADA DEVI INSTITUTE OF MEDICAL SCIENCES",
  "GOVERNMENT POLYTECHNIC, DEOGARH",
  "ROYAL COLLEGE OF HOSPITALITY MANAGEMENT",
  "KASTURABA COLLEGE OF NURSING",
  "ASA COLLEGE OF MEDICAL SCIENCE",
  "MAA SAMALAI PHARMACY COLLEGE",
  "SANKAR RUKMINI COLLEGE OF PHARMACY",
  "SWARNALATA INSTITUTE OF ALLIED MEDICAL SCIENCE",
  "MAA BHANDARA GHARANI COLLEGE OF PHARMACY",
  "International Management Institute",
  "AUROSRI INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
  "SABITRI DEVI SCHOOL OF NURSING",
  "PANCHALINGESWAR INSTITUTE OF MEDICAL SCIENCE",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION",
  "AMRAVATI POLYTECHNIC",
  "JAGANNATH INSTITUTE OF TECHNOLOGY",
  "ASPIRE INSTITUTE OF NURSING",
  "Golap Devi School Of Nursing",
  "COMPOSITE REGIONAL CENTRE FOR SKILL DEVELOPMENT, REHABILITATION AND EMPOWERMENT OF PERSONS WITH DISABILITIES, BALANGIR",
  "AFFINITY BUSINESS SCHOOL,BARATOTA",
  "UNOPOS SCHOOL OF PHARMACY",
  "SUSIL KUMAR INSTITUTE OF MEDICAL SCIENCE",
  "LINGARAJ SCHOOL OF HEALTH SCIENCE",
  "RENUBALA MOTHERS INSTITUTE OF MEDICAL TECHNOLOGY",
  "SRI JAGANNATH COLLEGE OF PHARMACY, BALANGIR",
  "EINSTEIN SCHOOL OF ENGINEERING",
  "NIRMALYA SCHOOL OF PHARMACY",
  "KUNTALADEVI SCHOOL OF NURSING",
  "BHUBANESWAR INSTITUTE OF MEDICAL SCIENCE",
  "MAA SONTOSHI COLLEGE OF NURSING",
  "JAYADEVA BUSINESS SCHOOL",
  "VIKASH COLLEGE OF PARAMEDICAL SCIENCE",
  "DHABALESWAR INSTITUE OF POLYTECHNIC ATHAGARH",
  "SARALA INSTITUTE OF MANAGMENT STUDIES",
  "HRUDANANDA DANI PHARMACY COLLEGE",
  "GURUKUL COLLEGE OF NURSING AND PARAMEDICAL SCIENCE",
  "ISPAT GENERAL HOSPITAL ROURKELA",
  "CRYOGENEX INSTITUTE OF MEDICAL SCIENCE AND RESEARCH , BHADRAK",
  "STAUNCH SCHOOL AND COLLEGE OF NURSING",
  "CTG COLLEGE OF NURSING AND MEDICAL SCIENCE",
  "GHANA INSTITUTE OF MEDICAL SCIENCES",
  "MAA MANGALA COLLEGE OF NURSING, ANKURA, KARANJIA",
  "SRI AUROBINDO INSTITUTE OF MEDICAL TECHNOLOGY AND RESEARCH",
  "MANIKESWARI ANM TRAINING CENTRE",
  "EBM ANM HEALTH WORKER F TRAINING CENTRE",
  "BOLANGIR ANM TRAINING CENTRE",
  "MAA GAYATRI SCHOOL OF NURSING, NAHANGA, KUPARI, BALASORE",
  "Raman School of Nursing",
  "RAMADEVI SCHOOL OF NURSING KENDRAPARA",
  "VV GIRI GOVT. ELEMENTARY TEACHER EDUCATION INSTITUTION (FOR WOMEN), BERHAMPUR, GANJAM",
  "Rajdhani School of Nursing",
  "Bhubaneswar School of Nursing",
  "Acharya Harihara Anm Training School",
  "Agradoot School of Nursing",
  "Aisect Junior Nursing School",
  "GOVERNMENT POLYTECHNIC, Angul",
  "GOVERNMENT POLYTECHNIC, BADAJHINKI",
  "BARAPADA SCHOOL OF ENGINEERING & TECHNOLOGY, BARAPADA",
  "GOVERNMENT POLYTECHNIC, BARGRAH",
  "GOVERNMENT POLYTECHNIC, BATAGUDA",
  "BARUNEI INSTT. OF ENGG. & TECH. (POLY) KADALIBADI",
  "GOVERNMENT POLYTECHNIC, BERHAMPUR",
  "GOVERNMENT POLYTECHNIC, BIDYADHARPUR",
  "B B Chhatoi School of Nursing",
  "GOVERNMENT POLYTECHNIC CHANDRASEKHARPUR, BHUBANESWAR",
  "BERHAMPUR SCHOOL OF ENGINEERING & TECHNOLOGY",
  "GOVERNMENT POLYTECHNIC, CHATRA CHAKADA",
  "BHADRAK ENGG. SCHOOL & TECH. ASURALI",
  "GOVERNMENT POLYTECHNIC, DHENKANAL",
  "GOVERNMENT POLYTECHNIC, JAJPUR, RAGADI",
  "GOVERNMENT POLYTECHNIC, Kalahandi",
  "Bhagabati ANM Training School",
  "GOVERNMENT POLYTECHNIC, Koraput",
  "GOVERNMENT POLYTECHNIC, LARKIPALI",
  "Bhagabati School of Nursing (G.N.M)",
  "GOVERNMENT POLYTECHNIC, MALKANGIRI",
  "GOVERNMENT POLYTECHNIC,MAYURBHANJ",
  "BHARAT INSTITUTE OF ENGG. & TECH. SIVRAM VIHAR BERHAMPUR",
  "BHAVA INSTITUTE OF MEDICAL SCIENCE & RESEARCH KHORDHA",
  "BHAVAN'S CENTRE FOR COMMUNICATION AND MANAGEMENT, KHARVELANAGAR",
  "BHUBANANANDA ODISHA SCHOOL OF ENGINEERING",
  "BHUBANESWAR POLYTECHNIC JANALA BHUBANESWAR",
  "Bidyut School of Nursing",
  "BIJU PATNAIK INSTITUTE OF TECHNOLOGY PHULBANI",
  "BIJU PATTANAIK FILM & TELEVISION INSTITUTE OF ODISHA",
  "BIJUPATTANAIK G N M TRAINING SCHOOL MAYURBHANJ",
  "HI-TECH INSTITUTE OF ENGG. & MANAGEMENT RANITAL",
  "HI-TECH INSTITUTE OF INFORMATION & TECHNOLOGY UMERI JEYPORE",
  "HITECH SCHOOL OF NURSING KHORDHA",
  "HOLY INSTITUTE OF TECHNOLOGY GOVINDAPUR",
  "IDEAL SCHOOL OF ENGINEERING JHINKHARADA KHURDA",
  "RAMARANI INSTITUTE OF TECHNOLOGY BALASORE",
  "IIMT School of Nursing",
  "R.K. INSTITUTE OF ENGINEERING & TECHNOLOGY",
  "INDUS SCHOOL OF ENGINEERING BARAKUDA",
  "KALINGA NAGAR POLYTECHNIC TARAPUR",
  "INSTITUTE OF ENGINEERING & MANAGEMENT JEYPORE",
  "Rourkela Institute of Nursing",
  "INSTITUTE OF TEXTILE TECHNOLOGY",
  "Sabarmati School of  Nursing",
  "Janakalyan School Of Nursing",
  "Janaki Devi  Junior And Senier Nursing School",
  "Jasoda Devi School Of Nursing",
  "JEYPORE SCHOOL OF ENGINEERING & TECHNOLOGY RONDAPALI JEYPORE",
  "JHADESWAR INSTITUTE OF ENGG. & TECH. CHHANPUR BALASORE",
  "JHARSUGUDA ENGINEERING SCHOOL",
  "JHARSUGUDA GNM TRAINING COLLEGE JHARSUGUDA",
  "Sabitridevi School of Nursing",
  "KALAHANDI SCHOOL OF ENGINEERING & TECHNOLOGY BHAWANIPATHA",
  "KALINGA INSTITUTE OF INDUSTRIAL TECHNOLOGY KHORDHA",
  "Kalinga Nursing School",
  "KOSHAL ANM & GNM TRAINING SCHOOL",
  "KALINGA NURSING SCHOOL KHORDHA",
  "KALING INSTT. OF ENGG. & TECH. FC PROJECT JAJPUR",
  "KANDHAMAL G N M TRAINING COLLEGE GAON",
  "Sahayoga Institute of GNM Training College",
  "Kasturaba Gandhi Anm/Hw (F) Training School",
  "KEONJHAR SCHOOL OF ENGINEERING KEONJHAR",
  "Khurda School of Nursing",
  "SAI INSTITUTE OF TECHNOLOGICAL SCIENCE",
  "Koraput GNM Training College",
  "KRUPAJAL ENGIENERING SCHOOL BHUBANESWAR",
  "Kuntala Devi School of Nursing",
  "Sailabala School Of Nursing",
  "KUNTALA DEVI SCHOOL OF NURSING NAYAGARH",
  "Maa Annapurna School of Nursing",
  "Salandi School Of Nursing",
  "Maa Bauti ANM Training School",
  "Maa Tara Tarini School of Nursing",
  "SAMANTA CHANDRASEKHAR INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "MAHALAXMI INSTITUTE OF TECHNOLOGY & ENGINEERING",
  "MAHAMAYA INSTITUTE OF MEDICAL & TECH. SCIENCE NUAPADA",
  "SANJAY MEMORIAL INSTITUTE OF TECHNOLOGY(DIPLOMA)",
  "Maharani Premkumari Nursing Training School",
  "MAHAVIR ENGINEERING COLLEGE",
  "Sanjog School of Nursing",
  "MAHIMA SCHOOL OF NURSING JAGATSINGHPUR",
  "Mamata Devi School of Nursing",
  "RAJA KISHORE CHANDRA ACADEMY OF TECHNOLOGY(POLYTECHNIC)",
  "SUSILA DEVI BATAKRISHNA NURSING SCHOOL NUAPADA",
  "PURUSOTTAM SCHOOL OF ENGG. & TECHNOLOGY MANDIAKUDUR ROURKELA",
  "PRATIVA DEVI SCHOOL OF NURSING KHURDA",
  "SWAMI VIVEKANANDA SCHOOL OF ENGINEERING & TECHNOLOGY BHUVANESWAR",
  "BALANGIR COLLEGE OF NURSING",
  "PNS SCHOOL OF ENGG. & TECH. MARSHAGHAI",
  "Swarnalata School Of Nursing Studies, Bahadulapatna",
  "GOVERNMENT POLYTECHNIC, SAHINKI",
  "TARINI SCHOOL OF NURSING",
  "GOVERNMENT POLYTECHNIC, RENGALI",
  "GOVERNMENT POLYTECHNIC, NUAPADA",
  "TULASI G N M TRAINING CENTRE KENDRAPARA",
  "GOVERNMENT POLYTECHNIC, NAYAGARH",
  "SIKHAR INSTITUTE OF MEDICAL SCIENCE, ANLABERENI",
  "BLOCK INSTITUTE OF EDUCATION AND TRAINING,  GUNUPUR",
  "B.I.T. POLYTECHNIC BALASORE",
  "UMA CHARAN PATNAIK ENGINEERING SCHOOL, BERHAMPUR",
  "DIBYA JYOTI SCHOOL OF NURSING, CHARICHHAK",
  "FRANKLIN INSTITUTE OF MEDICAL SCIENCE, PURI",
  "UTKAL AEROSPACE AND ENGINEERING BHUBANESWAR",
  "VIVEKANANDA INSTITUTE OF HEALTH SCIENCE",
  "GURUKRUPA COLLEGE OF MEDICAL SCIENCE",
  "UTKAL GOURAB MADHUSUDAN INSTITUTE OF TECHNOLOGY, RAYAGADA",
  "Biswanath Institute of Medical Technology",
  "ARYAN SCHOOL OF NURSING",
  "BARGAON NURSING COLLEGE",
  "UTKAL INSTITUTE OF ENGINEERING & TECHNOLOGY, KHURDA",
  "KALAHANDI INSTITUTE OF MEDICAL SCIENCE",
  "UTKALMANI GOPABANDHU INSTITUTE OF ENGINEERING, ROURKELA",
  "FUTURE BRIGHT SENIOR NURSING SCHOOL",
  "SHREE INSTITUTE OF MEDICAL SCIENCE AND TECHNOLOGY",
  "GOPINATH GNM TRAINING COLLEGE NUAPADA",
  "VENUS GROUP OF EDUCATIONAL & RESEARCH INSTITUTE",
  "BILLIANT  GNM NURSING SCHOOL",
  "SUNDARGARH COLLEGE OF MEDICAL SCIENCE",
  "VIIT School of Nursing, At/Po-Dhanmandal, Chandikhol, Dist-Jajpur-754024, Odisha",
  "DISHA INSTITUTE OF NURSING",
  "Vikash GNM Training School,  At/ Po  Januganj, Dist  - Balasore , Odisha",
  "INTERNATIONAL POLYTECHNIC",
  "SRI JAGANNATH INSTITUTE OF MEDICAL SCIENCE  AND TECHNOLOGY",
  "VIKASH POLYTECHNIC, BARGARH",
  "MAHAMAYA PHARMACY COLLEGE, LAUDMAL, PAIKMAL",
  "NABARANGPUR ANM TRAINING CENTRE",
  "Vinayaka School of Nursing, 222/1 Sastrinagar, Unit-IV, Khurda, Bhubaneswar, Odisha-751001",
  "Vision ANM (Female Health Worker) Training Centre , At/Po-Koraput, Dist-Koraput",
  "MAA SARALA DMLT SCHOOL",
  "NPM INSTITUTE OF MEDICAL SCIENCE AND RESEARCH KEONJHAR NEAR LORD JAGANNATH PLUS TWO SCIENCE RESIDENTIAL COLLEGE COLLEGE ROAD BANIAPAT KEONJHAR",
  "AVA NURSING SCHOOL",
  "RAMAMANI INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "ZENITH INSTITUTE OF SCIENCE & TECHNOLOGY",
  "Zenesys Junior Nursing School, At-Pragyan Vihar",
  "Xavier School of Nursing , At/Po Mukunda Prasad (Mukunda Bhawan)",
  "Vivekananda Charitable Trust ANM Training Centre, At/Po -Junagard, Pragati Nagar ,",
  "PURNA CHANDRA INSTITUTE OF ENGINEERING & TECHNOLOGY, CHHENDIPADA",
  "Puri School of Nursing",
  "Puri Saraswati School of Nursing",
  "PRINKYA DEVI SCHOOL OF NURSING PURI",
  "GURUKULA ENGG. SCHOOL CHATABAR BHUBANESWAR",
  "GURUKRUPA TECHNICAL SCHOOL NARSINGHPUR",
  "GOVT.POLYTECHNIC,PURI",
  "BLACK DIAMOND SCHOOL OF ENGINEERING. BRAJRAJ NAGAR",
  "SHREE BALADEVJEW SCHOOL OF NURSING",
  "SUNDARGARH DMLT INSTITUTE SUNDARGARH",
  "KABI NARSINGH MATHA BLIND DEAF AND MR SCHOOL",
  "BHAGABATI SCHOOL OF NURSING",
  "ARATI SCHOOL OF NURSING",
  "ORISSA SCHOOL OF ENGINEERING (POLY) BERHAMPUR",
  "SAI SNEHA COLLEGE OF NURSHING AND HEALTH SCIENCE",
  "KANAKADEVI INSTITUTE OF MEDICAL SCIENCE AND RESEARCH",
  "AKHANDALMANI INSTITUTE OF MEDICAL SCIENCE (AIMS)",
  "SADGURU COLLEGE AND SCHOOL OF NURSING",
  "SAI SHAKTI INSTITUTE OF MEDICAL SCIENCE,CUTTACK",
  "SHARDAR BALLAHAVA BHAI PATEL GNM SCHOOL OF NURSING",
  "SRIRAM COLLEGE OF NURSING",
  "BHAGABAN KAR INSTITUTE OF MEDICAL SCIENCE",
  "ISHAAN INSTITUTE OF MEDICAL SCIENCE",
  "JHARSUGUDA NURSING COLLEGE",
  "MUKTI SCHOOL OF NURSING, MALKANGIRI",
  "SRI GURU INSTITUTE OF ENGINEERING AND MANAGEMENT STUDIES",
  "NETAJI SCHOOL OF NURSING KENDRAPARA",
  "KAMALADEVI INSTITUTE OF MEDICAL SCIENCES",
  "SABITRI SCHOOL OF NURSING",
  "ARYABHATT INSTITUTE OF MEDICAL SCIENCE",
  "GAYATRI PARAMEDICAL TRAINING INSTITUTE",
  "MAHIMA INSTITUTE OF MEDICAL SCIENCE",
  "NABARANGPUR COLLEGE OF MEDICAL SCIENCE",
  "KOUSTUV RESEARCH INSTITUTE OF MEDICAL SCIENCE",
  "FLEDGE INSTITUTE OF MEDICAL SCIENCE",
  "LINGARAJA INSTITUTE OF MEDICAL SCIENCE",
  "IMB SCHOOL OF NURSING",
  "AFFINITY SCHOOL OF NURSING",
  "SARASWATA PHARMACY COLLEGE",
  "SUSHREE MEDICAL SCIENCE AND RESEARCH INSTITUTE BALANGIR",
  "SUBHAM SCHOOL OF NURSING,ODISHA",
  "SHREE RAM SCHOOL OF NURSING",
  "SATYANARAYAN GNM TRAINING COLLEGE",
  "DHENKANAL ACADEMY OF MEDICAL SCIENCE",
  "GET INSTITUTE OF MEDICAL TECHNOLOGY",
  "BHUBANESWAR INSTITUTE OF MANAGEMENT STUDIES",
  "MAA TARA TARINI COLLEGE OF PHARMACY",
  "PALLYCHANDAN DMLT TRAINING CENTRE",
  "SIDDHESWAR COLLEGE OF PHARMACEUTICAL SCIENCES",
  "SUNDERGARH ENGINEERING SCHOOL KIREI",
  "BHUBANESWAR INSTITUTE OF MEDICAL SCIENCE DHARMAGARH",
  "INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "MAHAVIR SCHOOL OF MEDICAL SCIENCE",
  "KRUPAJAL BUSINESS SCHOOL",
  "KEONJHAR INSTITUTE OF MEDICAL SCIENCE AND RESEARCH KEONJHAR",
  "PURI SARASWATI INSTITUTE OF MEDICAL SCIENCE",
  "SANTI SCHOOL OF NURSING",
  "PARAMEDIC INSTITUTE OF MEDICAL SCIENCE AND TECHNOLOGY",
  "MAHESWARI INSTITUTE OF MEDICAL SCIENCE JUNAGARH",
  "MAHESWARI INSTITUTE OF MEDICAL SCIENCE BHAWANIPATN",
  "DRISHTI SCHOOL OF NURSING",
  "Dibyajyoti School of Nursing",
  "DIGAMBARIDEVI INSTITUTE OF MEDICAL SCIENCE",
  "AUM SAI COLLEGE OF PARAMEDICAL",
  "SATYAM INSTITUTE OF MEDICAL SCIENCE AND  TECHNOLOGY",
  "PALLICHANDAN SCHOOL OF NURSING   ANM",
  "KALAHANDI COLLEGE OF NURSING AND ALLIED SCIENCES",
  "SHANTI ANM TRAINING SCHOOL OF NURSING BALICHANDRAPUR",
  "PARBATI DEVI SCHOOL OF NURSING",
  "RAJGANGPUR COLLEGE OF MEDICAL SCIENCE ",
  "SRICHANDAN COLLEGE OF NURSING    ",
  "APRIZE INSTITUTE OF MEDICAL SCIENCE    ",
  "DHARMAPADA COLLEGE OF NURSING    ",
  "RMTI HEALTHCARE ACADEMY",
  "SAI SARALA PHARMACY COLLEGE JALESWAR",
  "SAI KRISHNA NURSING TRAINING SCHOOL JALESWAR",
  "HEALTH CARE POLYCLINIC AND RESEARCH",
  "EVERMATE INSTITUTE OF MEDICAL SCIENCE",
  "KALINGA INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "ADARSHA INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "MMCHT GNM TRAINING CENTRE",
  "SAMALESWARI INSTITUTE OF MEDICAL SCIENCE",
  "ASHAA KIRANN BUSINESS SCHOOL",
  "MAHESWARI INSTITUTE OF HEALTH SCIENCE, TITLAGARH",
  "SORO SCHOOL OF ENGINEERING (DIPLOMA)",
  "ROSALIA NURSING ACADEMY",
  "NOBEL INSTITUTE OF MEDICAL SCIENCE",
  "SAI SHRADHA COLLEGE OF NURSING",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING & TECHNOLOGY",
  "SWARNALATA SCHOOL OF NURSING",
  "TRIVIKRAM INSTITUTE OF HEALTH SCIENCE AND RESEARCH",
  "BOUDH GNM TRAINING COLLEGE",
  "SAI NURSING COLLEGE",
  "DR B R AMBEDKAR POLYTECHNIC COLLEGE, YANAM",
  "ANNAI ABIRAMI COMMUNITY COLLEGE OF HEALTH SCIENCES",
  "HAYAGRIVA POLYTECHNIC COLLEGE",
  "IMMACULATE INSTITUTE OF HEALTH SCIENCES",
  "INDIRA GANDHI POLYTECHNIC COLLEGE MAHE",
  "KARAIKAL POLYTECHNIC COLLEGE VARICHIKUDY KARAIKAL",
  "MOTILAL NEHRU GOVERNMENT POLYTECHNIC COLLEGE LAWPET",
  "PUDDUCHHERY INSTITUTE OF HOTEL MANAGEMENT & CATERING TECHNOLOGY UPPALAM",
  "SRI MANAKULA VINAYAGAR POLYTECHNIC COLLEGE",
  "ST.MARY S TEACHER TRAINING INSTITUTE KARAIKAL",
  "WOMENS POLYTECHNIC COLLEGE KARAIKALMEDU, KARAIKAL",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING PUDUCHERRY",
  "United Christian School of Nursing",
  "GURU NANAK NURSING INSTITUTE BHATINDA",
  "GURU NANAK DEV SCHOOL OF NURSING BARNALA",
  "GURU NANAK DEV SCHOOL OF NURSING BARETA DISTT. MANSA PINCODE 151501",
  "UNITED SCHOOL OF NURSING",
  "GURU NANAK DEV POLYTECHNIC LUDHIANA.",
  "UNIVERSAL COLLEGE OF NURSING",
  "GURU NANAK DEV INSTITUE OF NURSING EDU AND RES SANGRUR",
  "GURUKUL SCHOOL OF NURSING",
  "GURU GOBIND SINGH NURSING TRAINING CENTRE AMRITSAR",
  "GURU GOBIND SINGH INSTITUTE OF NURSING PATIALA",
  "Guru Gobind Singh Institute of Nursing Kamal pura, Ludhiana",
  "Guru Arjan Dev College of Nursing dhariwal",
  "GURU ANGAD DEV SCHOOL OF NURSING LUDHIANA",
  "GRD INTERNATIONAL INSTITUTE OF NURSING",
  "GOVT SCHOOL OF NURSING,CIVIL HOSPITAL,GURDASPUR",
  "Govt. Nursing Training School, Civil Hospital Sangrur",
  "GOVERNMENT POLYTECHNIC, BATHINDA",
  "GOVERNMENT POLYTECHNIC, BATALA",
  "GOVERNMENT INSTITUTE OF TEXTILE CHEMISTRY AND KNITTING TECHNOLOGY, LUDHIANA",
  "GOVERNMENT INSTITUTE OF GARMENT TECHNOLOGY, AMRITSAR",
  "GNM TRAINING SCHOOL CIVIL HOSPITAL BATHINDA",
  "Global Institute of Nursing",
  "FRANCES NEWTON HOSPITAL FEROZEPUR",
  "EASTEND SCHOOL OF NURSING LUDHIANA",
  "DURGA SCHOOL OF NURSING LUDHIANA",
  "Dr Shyam Lal Thapar School of Nursing, Moga",
  "DR. MOHAN KAUR MEMORIAL NURSING INSTITUTE LUDHIANA",
  "DR. IT POLYTECHNIC COLLEGE, PATIALA",
  "CHEEMA INSTITUTE OF DIPLOMA IN ELEMENTARY",
  "DR DAYAL SINGH MEMORIAL SCHOOL OF NURSING ROPAR",
  "DOABA POLYTECHNIC COLLEGE, MOHALI",
  "DOABA POLYTECHNIC COLEGE RAHON, NAWANSHEHAR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING FARIDKOT",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING SANGRUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING PATIALA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING NAWANSHHR NAWANSHAHAR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING MUKTSAR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KAPURTHALA",
  "SPEAKING HAND WELFARE FOUNDATION",
  "DISTRICT EDUCATION AND TRAINING INSTITUTE, AJJOWAL, HOSHIARPUR",
  "DESH BHAGAT SCHOOL OF NURSING FATEHGARH",
  "DESH BHAGAT INSTITUTE OF EDUCATION MANDI GOBINDGARH",
  "DEEP INSTITUTE OF NURSING & MEDICAL SCIENCES BHATINDA",
  "COLONEL SCHOOL OF NURSING SANGRUR",
  "CHARANJIT SINGH MEMORIAL INSTITUE OF NURSING EDUCATION ROPAR",
  "C G N KHALSA COLLEGE OF PHARMACY, LUDHIANA",
  "CENTRAL TOOL ROOM, LUDHIANA",
  "SAI COLLEGE OF NURSING",
  "CENTRAL INSTITUTE OF PLASTICS ENGINEERING & TECHNOLOGY (CIPET), AMRITSAR",
  "SADBHAVANA COLLEGE OF MANAGEMENT TECHNOLOGY, ALLADIWAL, RAIKOT, LUDHIANA",
  "CENTRAL INSTITUTE OF HAND TOOLS, JALANDHAR",
  "BHAGWATI PROFESSIONAL EDUCATION SOCIETY MANSA",
  "BENGAL HEALTH INSTITUTE OF SCIENCES LUDHIANA",
  "BATALA INSTITUTE OF MEDICAL SCIENCE GURDASPUR",
  "BANKEY BIHARI POLYTECHNIC COLLEGE, FAZILKA",
  "K. S. Gill Institute Of Education, MAKHA",
  "KARAMJEET COLLEGE OF EDUCATION",
  "MALWA INSTITUTE OF NURSING, MALAKPUR KHIALA, MANSA",
  "Sant Sukhchain Singh Institute Of Education, Dharampura",
  "ASRA COLLEGE OF ENGINEERING AND TECHNOLOGY (POLYTECHNIC WING)",
  "SSUKHJINDER SINGH COLLEGE OF PHARMACY AYURVEDA GURDASPUR",
  "AYAAN INSTITUTE OF NURSING, SANGRUR",
  "SMT URMILA DEVI COLLEGE OF D PHARMACY",
  "Dr Balbir Singh Institute of Nursing Bhagta Bhai Ka",
  "Shri Guru Teg Bahadur Nursing Institute, Balloh",
  "VIDYA SAGAR GIRLS COLLEGE OF EDUCATION",
  "MATA GUJRI COLLEGE OF EDUCATION",
  "MALWA INSTITUTE OF PHARMACY, MEHAL KALAN",
  "International Divine School of Nursing Ratwara Sahib",
  "VIDYA SAGAR INSTITUTE OF EDUCATION",
  "SANGHA COLLEGE OF EDUCATION",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING ROPAR",
  "G.H.G.College of Teacher Training, Gondwal, Raikot(141109).",
  "B U COLLEGE OF EDUCATION",
  "GOVERNMENT POLYTECHNIC COLLEGE, DINANAGAR",
  "BIBI BHANI COLLEGE OF EDUCATION , LONGOWAL",
  "Saraswati Professional and Higher Education College of Education",
  "SHAHEED SUKHDEV SINGH COLLEGE OF PHARMACY",
  "SARASWATI GIRLS COLLEGE OF EDUCATION",
  "GLOBAL COLLEGE OF D PHARMACY",
  "S. SUKHJINDER SINGH POLYTECHNIC & PHARMACY COLLEGE, GURDASPUR",
  "BABA SHEIKH FARID MEDICAL INSTITUTE FOR NURSING",
  "MAHANT GURBANTA DASS MEMORIAL COLLEGE OF PHARMACY, BATHINDA",
  "SATYAM COLLEGE OF  POLYTECHNIC, JALANDHAR",
  "THE ROYAL COLLEGE OF PHARMACY",
  "GTB College of Pharmacy and  Technology, Balloh",
  "VIDYA SAGAR PARAMEDICAL INSTITUTE",
  "GURU AMAR DASS SCHOOL OF NURSING AMRITSAR",
  "AMAN BHALLA INSTITUTE OF ENGINEERING & TECHNOLOGY, PATHANKOT",
  "BANKEY BIHARI COLLEGE OF EDUCATION",
  "STANFORD BUSINESS SCHOOL",
  "INDIAN MEDICAL INSTITUTE OF NURSING JALANDHAR",
  "THE ROYAL COLLEGE OF NURSING BOROWAL MANSA",
  "PUNJAB COLLEGE OF EDUCATION",
  "RATTAN PROFESSIONAL EUDCATION COLLEGE MOHALI",
  "S.Sukhjinder Singh Elementry Teacher Training Institute",
  "SHRI GURU TEG BAHUDUR COLLEGE OF EDUCATION, PLOT NO 34 VILLAGE HARIGARH",
  "MATA GUJRI NURSING COLLEGE BABANPUR , DHURI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING JALANDHAR",
  "S. AMARJIT SINGH SAHI GOVT. POLYTECHNIC COLLEGE TALWARA",
  "JEEWAN JOT NURSING INSTITUTE LUDHIANA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING JAGRAON",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING GURDASPUR",
  "INSTITUTE OF HOTEL MANAGEMENT",
  "SACHKHAND SCHOOL OF NURSING FEROZEPUR",
  "ANGAD NURSING COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING FEROZEPUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING FATEHGARH SAHIB FATEHGARH SAHI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING BATHINDA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING AMRITSAR",
  "MAHARAJA AGGARSAIN INSTITUTE OF TECHNOLOGY, ABOHAR",
  "PATHANKOT POLYTEHNIC COLLEGE, PATHANKOT",
  "GOVERNMENT POLYTECHNIC, G.T.B.GARH",
  "GURU HARGOBIND COLLEGE OF PHARMACY, RAIKOT",
  "GURU NANAK INSTITUTE OF TECHNOLOGY (POLYTECHNIC), HOSHIARPUR",
  "SANT DARBARA SINGH SCHOOL OF NURSING LOPON",
  "Shaheed Udham Singh Elementary Teacher Training Institute",
  "GOVERNMENT POLYTECHNIC COLLEGE, RUPNAGAR",
  "KGM AYURVEDIC UPVAID COLLEGE AND HOSPITAL, NAWANSHAHR",
  "GURUKUL SCHOOL OF NURSING",
  "SACRED HEART HOSPITAL JALANDHAR",
  "BRILLIANT COLLEGE OF EDUCATION",
  "Sainik Elementary Teacher Training College Chural Kalan",
  "Fateh College of Education for Women",
  "LJM  COLLEGE OF EDUCATION .JALALDIWAL .RAIKOT .LUDHIANA",
  "GOVERNMENT POLYTECHNIC, BHIKHIWIND",
  "GOVERNMENT POLYTECHNIC COLLEGE, BEHRAM",
  "GOVERNMENT POLYTECHNIC COLLEGE, FATUHIKHERA",
  "GOVERNMENT POLYTECHNIC COLLEGE, KOTAKPURA",
  "KINGS COLLEGE OF EDUCATION",
  "M.P.H.W. (F) Training School, Nangal",
  "ST KABIR SCHOOL OF NURSING",
  "GOVERNMENT POLYTECHNIC, FEROZEPUR",
  "GOVERNMENT POLYTECHNIC, KHUNIMAJRA",
  "Govt. Institute of Nursing and Paramedical Sciences, Civil Hospital Ropar",
  "GOVT. J.B.T. SCHOOL BUDHLABAD MANSA",
  "BANSAL SCHOOL OF NURSING, JAINPUR",
  "Bawa Nihal Singh College of Education",
  "MALWA COLLEGE OF PHARMACY MALAKPUR KHIALA MANSA",
  "KHALSA RURAL NURSING TRAINING INSTITUTE & HOSPITAL MANSA",
  "PUNJAB INSTITUTE OF TEXTILE TECHNOLOGY, AMRITSAR",
  "SATGURU EDUCATIONAL WELFARE SOCIETY LUDHIANA",
  "SRI GURU RAMDASS PHARMACY COLLEGE",
  "RIMT COLLEGE OF EDUCATION MANDI GOBINDGARH",
  "MAHARISHI PARSHURAM COLLEGE OF PHARMACY FAZILKA",
  "LUDHIANA INSTITUTE OF NURSING",
  "Punjab Institute of Nursing, Nangla",
  "SANT SOLDIER POLYTECHNIC & PHARMACY COLLEGE, JALANDHAR",
  "Saint Kabir College of Education",
  "SARDAR BAHADAR CAPTAIN MEHTAB SINGH TECHNOLOGY INSTITUTE, ATTALGARH",
  "TAWI POLYTECHNIC SHAPUR KANDI, GURDASPUR",
  "VIDYA JYOTI COLLEGE OF PHARMACY, KOTERA LEHAL, JAKHAL ROAD, LEHRAGA, SANGRUR",
  "V.M.S POLYTECHNIC & PHARMACY, GURDASPUR",
  "BABA HAZARA SINGH POLYTECHNIC , GURDASPUR",
  "BHAI GURDAS POLYTECHNIC, SANGRUR",
  "C T POLYTECHNIC, JALANDHAR",
  "DESH BHAGAT POLYTECHNIC INSTITUTE BARDHWAL, DHURI",
  "DIPS POLYTECHNIC COLLEGE,HOSHIARPUR",
  "GOVERNMENT POLYTECHNIC, AMRITSAR",
  "SATYAM POLYTECHNIC & PHARMACY COLLEGE, AMRITSAR",
  "SHAHEED NAND SINGH GOVERNMENT POLYTECHNIC COLLEGE, BARETA",
  "S. R. S. GOVT. POLYTECHNIC COLLEGE , LUDHIANA",
  "ST. SOLDIER INSTITUTE OF PHARMACY & POLYTECHNIC",
  "GOVERNMENT POLYTECHNIC PATIALA",
  "LUDHIANA POLYTEHNIC COLLEGE, KUBE, SAMRALA, LUDHIANA",
  "MAI BHAGO GOVERNMENT POLYTECHNIC COLLEGE FOR GIRLS, AMRITSAR",
  "MALWA POLYTECHNIC SADIQ ROAD FARIDKOT.",
  "NANCY POLYTECHNIC COLLELGE, PATIALA",
  "PANNU POLYTECHNIC COLLEGE, GURDASPUR",
  "R & D CENTRE FOR BICYCLE AND SEWING MACHINE, LUDHIANA",
  "S D COLLEGE OF PHARMACY, BARNALA",
  "Punjab Multipurpose Institute of Nursing",
  "NEW UNIVERSAL COLLEGE OF EDUCATION, BALLOPUR",
  "PUNJAB NATIONAL NURSING SCHOOL PATIALA",
  "VIDYA SAGAR INSTITUTE OF POLYTECHNIC AND PHARMACY COLLEGE, MANSA",
  "VIDYASAGAR INSTITUTE OF NURSING,AHLUPUR",
  "VIDYA RATTAN POLYTECHNIC, SANGRUR",
  "VICTOR INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES MOHALI",
  "UNIVERSAL POLYTECHNIC COLLEGE BALLOPUR, MOHALI",
  "REHBAR INSTITUTE OF MEDICAL SCIENCES BHAWANIGARH",
  "REGIONAL POLYTECHNIC COLLEGE, BATHINDA",
  "JAI AMBEY SCHOOL OF NURSING",
  "Rayat Institute of Diploma Pharmacy, Railmajara.",
  "GURU NANAK NURSING TRAINING INSTITUTE AND HOSPITAL JALANDHAR",
  "SAINT KABIR POLYTECHNIC, FAZILKA",
  "HIMALAYA MODERN SCHOOL OF NURSING GURDASPUR",
  "SAINT SAHARA INSTITUTE OF NURSING EDUCATION MUKTSAR",
  "K C POLYTECHNIC COLLEGE, NAWANSHEHAR",
  "KHALSA COLLEGE OF PHARMACY, AMRITSAR, PUNJAB",
  "KRISHNA COLLEGE OF NURSING",
  "krishna college of pharmacy",
  "SAI POLYTECHNIC, PATHANKOT",
  "GOVERNMENT POLYTECHNIC COLLEGE  JALANDHAR",
  "GOVERNMENT INSTITUTE OF LEATHER & FOOTWEAR TECHNOLOGY, JALANDHAR",
  "LALA LAJPAT RAI MEMORIAL POLYTECHNIC, AJITWAL MOGA",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION",
  "K D SCHOOL OF NURSING HOSHIARPUR",
  "MAJHA INTERNATIONAL SCHOOL OF NURSING",
  "VIDYA JYOTI COLLEGE OF NURSING, KOTRA LEHAL, LEHRAGAGA",
  "RAMGARHIA INSTITUTE OF HEALTH SCIENCES & RESEARCH KAPURTHALA",
  "Asra College of Education ETT",
  "life Guard Institute of Education (Bhindran) Sangrur",
  "MODERN COLLEGE OF PHARMACY KHURD",
  "SAINT SAHARA SCHOOL OF NURSING, KOT SHAMIR, BATHINDA",
  "THAPAR POLYTECHNIC, PATIALA",
  "MPHW FEMALE TRAINING SCHOOL CIVIL HOSPITAL MOGA",
  "DR RAVINDER INSTITUTE OF NURSING BAJAKHANA",
  "NEW MALWA INSTITUTE OF NURSING KOTKAPURA",
  "BEANT COLLEGE OF ENGINEERING & TECHNOLOGY(POLYTECHNIC WING), GURDASPUR",
  "Synergy International Institute of Nursing",
  "SFC INSTITUTE OF PHARMACY",
  "AMAN BHALLA COLLEGE OF PHARMACY",
  "SWAMI VIVEKANAND POLYTEHNIC COLLEGE, RAMNAGAR, BANUR, RAJPURA, PATIALA",
  "SHAHEED BHAGAT SINGH COLLEGE OF NURSING MEHAL KALAN",
  "Akal Sahaye College Of Education",
  "BANKEY BIHARI COLLEGE OF PHARMACY",
  "SWAMI PREMANAND PARAMEDICAL & GNM SCHOOL OF NURSING HOSHIARPUR",
  "Sant Kabir College Of Education",
  "SWAMI DAYANAND COLLEGE OF PHARMCY, LEHRA BEGA",
  "BABA SUCHA SINGH INSTITUTE OF NURSING, SAMAON",
  "Amar Shaheed Baba Ajit Singh Jujhar Singh Memorial Diploma College of Pharmacy,Bela",
  "dasmesh institute of education nangal kalan mansa",
  "SHREE BALAJI INSTITUTE OF MEDICAL SCIENCES AND HOSPITAL",
  "ST SOLDIER NURSING TRAINING INSTITUTE JALANDHAR",
  "Bharat College of Pharmacy",
  "SSD Institute Of Nursing",
  "SRI SUKHMANI POLYTECHNIC  CAMPUS, MOHALI",
  "SRI GURU NANAK DEV NURSING INSTITUTE GURDASPUR",
  "S.P.COLLEGE OF NURSING MIDDA",
  "Singha Nursing College",
  "SIDHU SCHOOL OF NURSING LUDHIANA",
  "SHRI GURU HARGOBIND SAHIB GOVERNMENT POLYTECHNIC COLLEGE, RANWAN",
  "SHIVALIK EXCELLENCE SCHOOL OF NURSING TARAN",
  "VIDYA SAGAR COLLEGE OF  NURSING BHIKHI",
  "PUNAB COLLEGE OF PHARMACY, FEROZEPUR",
  "Shaheed Madan La Dhingra Memorial Government School of Nursing, Amritsar",
  "PT. J R GOVERNMENT POLYTECHNIC COLLEGE, HOSHIARPUR",
  "SUKHJINDER AYURVEDIC PHARMACY UPVAID COLLEGE",
  "Pannu School of nursing",
  "ONKAR COLELGE OF PHARMACY, SAJUMA, BHAWANIGARH, SANGRUR",
  "SHAHEED BHAGAT SINGH POLYTECHNIC AND PHARMACY COLLEGE, AMRITSAR",
  "NURSING TRAINING INSTITUTE & HOSPITAL JALANDHAR",
  "NEW PUNJAB POLYTECHNIC COLLEGE, BATHINDA",
  "New Punjab College of Elementary Education, Nangla",
  "SHAHEED BHAGAT SINGH COLLEGE OF ENGINEERING & TECHNOLOGY (POLYTECHNIC WING), FEROZEPUR",
  "NATIONAL COLLEGE OF GENERAL NURSING & MIDWIFERY BARNALA",
  "S G L NURSING SCHOOL JALANDHAR",
  "Baba Sheikh Farid Pharmacy College, Kotkapura",
  "MUKTISAR INSTITUTE OF HIGHER EDUCATION MUKTSAR",
  "MPHW (F) TRAINING SCHOOL CIVIL HOSPITAL",
  "M L MEMORIAL POLYTECHNIC COLLEGE, MOGA",
  "MEHR CHAND POLYTECHNIC, JALANDHAR",
  "School Of Nursing Mata Kaushalya Government Hospital",
  "Meera School of Nursing",
  "Mata Sundri Institute Of Nursing,Dhade",
  "SCHOOL OF NURSING CIVIL HOSPITAL JALANDHAR",
  "MATA SAHIB KAUR NURSING INSTITUTE MUKTSAR",
  "MATA ISHAR KAUR NURSING INSITUTE TAMKOT",
  "SARDAR PATEL EDUCATIONAL SOCIETY FEROZEPUR",
  "RAMGARHIA POLYTECHNIC, PHAGWARA",
  "SARASWATI POLYTECHNIC, BATHINDA",
  "MAHA SHIV SHAKTI SCHOOL OF NURSING AMRITSAR",
  "MAHANT GURBANTA DASS MEMORIAL SCHOOL OF NURSING BHATINDA",
  "MAA SARASWATI SCHOOL OF NURSING",
  "SANT INDER DASS NURSING INSTITUTE PATIALA",
  "LUDHIANA GROUP OF COLLEGE POLYTECHNIC, LUDHIANA",
  "SANT BABA ATAR SINGH GOVERNMENT POLYTECHNIC COLLEGE, BADBAR",
  "LORD KRISHNA COLLEGE OF PHARMACY KHOKHAR LEHRAGAGA, SANGRUR",
  "SALUTARY NURSING INSTITUTE",
  "LONGOWAL POLYTECHNICAL & PHARMACY COLLEGE, DERABASSI",
  "LIFE GUARD NURSING INSTITUTE SANGRUR",
  "Little Angel college of Education VPO Panni Wala, Malot, Shri Muktsar Saahib",
  "BANKEY BIHARI INSTITUTE OF NURSING",
  "BAB ISHAR SINGH COLLEGE OF PHARMACY, GAGRA, MOGA",
  "BABA KUNDAN SCHOOL OF NURSING",
  "BABA KUNDAN COLLEGE OF PHARMACY, LUDHIANA",
  "Baba Kuma Singh Ji Engg. College, Poly Wing",
  "VIDYASAGAR COLLEGE OF ELEMENTARY EDUCATION",
  "BHARAT COLLEGE OF EDUCATION",
  "BABA ISHAR SINGH POLYTECHNIC, KOT-ISE-KHAN",
  "BABA BANDA SINGH BAHADUR POLYTECHNIC COLLEGE, FATEHGARH SAHEB",
  "BABA BANDA BAHADUR SCHOOL OF NURSING FARIDKOT",
  "AMRITSAR SCHOOL OF NURSING AMRITSAR",
  "AKLIA POLYTECHNIC COLLEGE, BATHINDA",
  "ADESH POLYTECHNIC, MUKATSAR",
  "ABOHAR POLYTECHNIC COLLEGE ABOHAR",
  "CHITKARA SCHOOL OF HOSPITALITY",
  "ABHISHEK POLYTECHNIC COLLEGE, DAULATPURA, ABOKHAR",
  "MATA JARNAIL KAUR MEMORIAL INSTITUTE OF NURSING AND PARAMEDICAL SCINCES",
  "CIVIL HOSPITAL MULTIPURPOSE HEALTH WORKER FEMALE TRAINING SCHOOL SANGRUR DISTT SANGRUR PUNJAB",
  "TRAINING CENTRE FOR TEACHERS OF THE VISUALLY HANDICAPPED",
  "MPHW F TRAINING SCHOOL ,CIVIL HOSPITAL, GURDASPUR",
  "EK JOT NURSING INSTITUTE  SWADDI KHURD JAGRAON",
  "DOABA INSTITUTE OF NURSING",
  "MATA GUJRI SCHOOL OF NURSING SANGRUR",
  "DASHMESH NURSING INSTITUTE MUKTSAR",
  "SFC INSTITUTE OF AYURVEDA",
  "SANT BABA PREM SINGH MEMORIAL GOVERNMENT POLYTECHNIC COLLEGE, BEGOWAL",
  "MAHANT GURBANTA DASS MEMORIAL AYURVEDIC INSTITUTE",
  "GURU NANAK DEV INSTITUTE OF NURSING,QADIAN",
  "BHAGAT PURAN SINGH INSTITUTE FOR SPECIAL NEEDS, MANAWALA",
  "SHRI GURU TEG BAHADUR COLLEGE OF EDUCATION ",
  "B M College of Education, Balluana",
  "ALL INDIA PINGALWARA CHARITABLE SOCIETY, MANAWALA AMRITSAR     ",
  "VIDYA SAGAR NURSING COLLEGE     ",
  "ABIGAIL CHRISTIAN NURSING INSTITUTE",
  "PUNJAB MEDICAL INSTITUTE OF NURSING & HOSPITAL JALANDHAR",
  "HOLY NURSING SCHOOL MUKUTSAR",
  "Dilbag Memorial School of Nursing, Village Sohian Kalan",
  "NATIONAL AGRI FOOD BIOTECHNOLOGY INSTITUTE ,NABI",
  "BABA HANS RAJ MEMORIAL COLLEGE OF EDUCATION, BAJAKHANA",
  "JAGJIT SINGH SACHDEVA ASHA KIRAN SPECIAL SCHOOL",
  "KALLAWANTI SCHOOL OF NURSING, GONIANA KHURD, DISTT BATHINDA",
  "Vinayaka College of Pharmacy",
  "R R COLLEGE OF PARAMEDICAL SCIENCES",
  "SAINT MEERA BSTC COLLEGE NATHDWARA",
  "SHAKSHI COLLEGE OF PARAMEDICAL SCIENCES",
  "STATE INSTITUTE OF HOTEL MANAGEMENT, JHALAWAR",
  "MAA SHARDE NURSING SCHOOL GANGARTALAI",
  "RATNI DEVI BALIKA BSTC VIDHYALAYA DWARIKAPURI HINDAUN",
  "ADARSH GYANODAY SPECIAL EDUCATION TEACHER TRAINING COLLEGE LADNUN NAGAUR",
  "L B S STC COLLEGE",
  "MAHARAJA AGRASEN COLLEGE NAGAR BHARATPUR",
  "KAVYA SHIKSHA EVAM VIKAS SEVA SANSTHAN KARAULI",
  "SANTOKBA DURLABHJI SCHOOL OF NURSING, JAIPUR",
  "SBS POLYTECHNIC COLLEGE, SIKER",
  "GURUKUL PARAMEDICAL COLLEGE",
  "LAXMI POLITECHNIC COLLEGE, JAIPUR",
  "RADHE KRISHAN COLLEGE OF PHARMACY",
  "SCHOOL OF NURSING HARISH HOSPITAL ALWAR",
  "KESHAV NURSING SCHOOL JAIPUR",
  "RAJASTHAN COLLEGE OF HOTEL MANAGEMENT AND SECURITY  KUCHAMAN CITY",
  "G L SAINI MEMORIAL INSTITUTE OF NURSING",
  "DIKSHA NURSING SCHOOL",
  "Pragyan Research Institute of Diploma Engineering, Barmer",
  "SHREE KRISHNA JAN SEVA SANSTHAN",
  "PANCHOLI VISHESH T T COLLEGE",
  "GURUKUL SPASTIC SOCIETY JAIPUR",
  "SANSKAAR SPECIAL EDUCATION COLLEGE, PEEPLU",
  "DISHA SPECIAL TEACHER TRAINING INSTITUTE DAUSA",
  "BHAGWATI TEACHER TRAINING INSTITUTE",
  "PRINCE POLYTECHNIC COLLEGE, SIKAR",
  "UNIVERSAL POLYTECHNIC COLLEGE, DAUSA",
  "VIJAY PARAMEDICAL COLLEGE BANDIKUI",
  "MANTRAM WOMAN POLYTECHNIC COLLEGE, DUNGARPUR",
  "NIMT INSTITUTE OF MANAGEMENT",
  "MARUDHARA POLYTECHNIC COLLEGE LAKSHMANGARH, SIKAR",
  "DEV PARAMEDICAL COLLEGE",
  "VNV PARAMEDICAL INSTITUTE SITHAL",
  "RAJ NURSING AND PARAMEDICAL INSTITUTE",
  "RAJ RAJESHWARI PARAMEDICAL DIPLOMA COLLEGE",
  "DHANVANTARI INSTITUTE OF PARAMEDICAL SCIENCE JAIPUR",
  "APEX SCHOOL OF NURSING APEX UNIVERSITY ACHROL JAIPUR",
  "GANADHIPATI PURUSHOTTAM SHEKHAWATI INSTITUTE OF PARAMEDICAL SCIENCES",
  "MURLI SINGH YADAV MEMORIAL DIVYANG STC COLLEGE",
  "SUPARSHVA PARA MEDICAL INSTITUTE",
  "Indian Institute of Paramedical Science",
  "PT. JAWAHAR LAL HEHRU SMRITI SHIKSHA PRASAR SAMITI. NEHRU SHIKSHA MAHAVIDHYALAYA KARAULI",
  "TAXILA BUSINESS SCHOOL, MANSAROVAR",
  "INSTITUTE OF DIGITAL EDUCATION AND EMPLOYMENT DEVELOPMENT",
  "SHRI RAM GOPAL VISHESH VIDYALAYA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BAGARI NAGAR, PALI",
  "SATYAM INSTITUTE OF TECHNOLOGY",
  "REGIONAL POLYTECHNIC COLLEGE, ISI-7 SITAPURA INSTITUTIONAL AREA, SITAPURA, JAIPUR",
  "Ravindra paramedical institute Jhunjhunu",
  "APEX CAREER INSTITUTE",
  "OVALE INSTITUTE OF PARAMEDICAL SCIENCES",
  "SARVODAYA TEACHER TRAINING INSTITUTE",
  "MLD PARAMEDICAL INTITUTE KEKRI AJMER",
  "PARAMEDICAL INSTITUTE OF HARISH HOSPITAL",
  "RAJASTHAN INSTITUTE OF NURSING, CHIRAWA, JHUNJHUNU",
  "BRIGHT MOON PRATHMIK TRACHER TRAINING SANSTHAN",
  "B.R. POLYTECHNIC COLLEGE, SIKAR",
  "ADARSH PARAMEDICAL INSTITUTE CHURU",
  "LAXMI BAI MAHILA SANSKRIT TEACHERS TRAINING INSTITUTE JAMWARAMGARH",
  "GOVERNMENT WOMEN POLYTECHNIC COLLEGE, ALWAR",
  "SARVODAYA INSTITUTE OF PARA MEDICAL NURSING INSTITUTE KOTA",
  "CARRIOR SHIKSHAK PRASHIKSHAN SCHOOL, JHUNJHUNU",
  "GURUKRIPA INSTITUTE FOR MEDICAL EDUCATION",
  "AOES TEACHER TRAINING CENTRE",
  "PRAYAS SEVA SANSTHA",
  "MOTHER INDIA POLYTECHNIC COLLEGE, MEGA HIGHWAY KHANPUR, JHALAWAR",
  "ALOK PUBLIC SCHOOL SHIKSHA SAMITI TEACHER TRAINING CENTER DSEIDD COLLEGE TONK,RAJASTHAN",
  "SHRI DEV SPECIAL TEACHER TRAINING CENTER DEOGARH",
  "MILAN SPECIAL COLLEGE",
  "MODERN INSTITUTE OF PARAMEDICAL BANSWARA ROAD SANGWARA",
  "ASHA DEVI POLYTECHNIC COLLEGE, CHURU",
  "BARMER COLLEGE OF SPECIAL EDUCATION",
  "A S SCHOOL OF NURSING SRIGANGANAGAR",
  "LOKMANYA TILAK SPECIAL DED COLLEGE IDD",
  "RITURAJ COLLEGE OF PARAMEDICAL SCIENCES",
  "BABA KHETANATH MAHILA SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA",
  "CHIRAYU HOSPITAL PARAMEDICAL COLLEGE",
  "LITTLE FEET INSTITUTE OF SPECIAL EDUCATION",
  "BALAJI POLYTECHNIC COLLEGE BHAMATSAR, BIKANER",
  "MAHATMA JYOTIRAO PHULE REHABILITATION CENTER",
  "AGRASEN INSTITUTE OF PARAMEDICAL",
  "BANSAL SCHOOL OF NURSING HANUMANGARH",
  "BANSUR POLYTCHNIC COLLEGE BANSUR",
  "IMPULSE TT COLLEGE DAUSA",
  "BASIC ELEMENTORY TRAINING STC COLLEGE, BIKANER",
  "BHAGWATI SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA NASIS COLONY GANGAPUR CITY SAWAI MADHOPUR",
  "DIVYA JYOTI GYAN EVAM SAMAGIK VIKAS SAMITI",
  "SAVI INSTITUTE OF NURSING BARMER",
  "BHARAT TEACHER TRAINING SCHOOL KISHANGANJ BARAN",
  "SETH MOTI LAL TEACHES TRAINING COLLEGE, JHUNJHUNU",
  "SETH SUSHIL KUMAR BIHANI S.D. SHIKSHA MAHAVIDYALAYA SRI GANGANAGAR",
  "SEVA SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA JAIPUR",
  "BHAWANI INSTITUTE OF TECHNICAL EDUCATION, NAGAUR",
  "TAGORE PARAMEDICAL COLLEGE CHIRAWA",
  "SAKET PARAMEDICAL COLLEGE",
  "PR MEMORIAL INSTITUTE",
  "BHIWADI COLLEGE OF POLYTECHNIC, BHIWADI",
  "PT.JAWAHAR LAL NEHRU SMRITI AMRITI SHIKSHA PRASAR SAMITI",
  "Maharaja Mahila College of Education BSTC Bhagwari Kalan Behror  Alwar",
  "TAK SHIKSHA NIKETAN BSTC T.T college, Ajmer",
  "HCT SCHOOL OF NURSING",
  "JAIN PARAMEDICAL TRAINING INSTITUTE",
  "OPERA CITY INSTITUTE OF PARAMEDICAL EDUCATION",
  "RITURAJ COLLEGE OF PARAMEDICAL SCIENCES,PARABATSAR,NAGAUR",
  "Sanjeevani Institute of Nursing",
  "S G POLYTECHNIC COLLEGE, JALORE",
  "BIRLA TECHNICAL TRAINING INSTITUTE, PILANI",
  "JR INSTITUTE OF NURSING SAGWARA",
  "Government Polytechnic College, Udaipur",
  "BABY HAPPY MODERN STC MAHAVIDIYALAYA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, AJMER",
  "BIYANI SCHOOL OF NURSING JAIPUR",
  "MARWAR SCHOOL OF NURSING JODHPUR",
  "ROHET TEACHER TRAINING COLLEGE",
  "SHRI LAL BAHADUR SHASTRI STC COLLEGE JODHPUR",
  "MANSI COLLEGE OF TECHONOLOGY, SIKAR",
  "SHRI LAL BAHADUR SHASTRI NURSING INSTITUTE JODHPUR",
  "SHRI MATI CHANDRAWAL GUPTA MAHILA SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA SIROHI",
  "SHRI MATSYA ELEMENTRY TEACHER TRAINING INSTITUTE",
  "RAJ NURSING INSTITUTE KHINWASAR",
  "POKARAN POLYTECHNIC COLLEGE, POKARAN",
  "VARDHMAN SHIKSHAK PRASHIKSHAN BSTC VIDHYALAYA SIKAR",
  "MARUDHARA PARAMEDICAL INSTITUTE",
  "SHRI RAGHUNATH ELEMENTRY TEACHER EDUCATION INSTITUTE SIKAR",
  "SHREE BALAJI SCHOOL OF NURSING JODHPUR",
  "P.N.B. POLYTECHNIC COLLEGE, JAIPUR",
  "MAA GAYATRI SCHOOL OF NURSING UMARDA, UDAIPUR",
  "VEENA  MEMORIAL POLYTECHNIC  COLLEGE, KARAULI",
  "SHRI R.N.MEMORIAL MAHILA STC",
  "MATSYA INSTITUTE OF PARAMEDICAL SCIENCE, DAUSA",
  "SHRI SHYAM SHIKSHAK PRASHIKSHAN VIDYALAYA HANUMANGARH",
  "DHOLAPLASH POLYTECHNIC COLLEGE, ALWAR",
  "INDIAN INSTITUTE OF HANDLOOM TECHNOLOGY",
  "SHRI TIRUPATI BALAJI POLYTECNIC COLLEGE, KOTA",
  "SWAMI VIVEKANAND POLYTECHNIC COLLEGE, JHALAWAR",
  "BRIGHT CAREER POLYTECHNIC COLLEGE NOKHA, BIKANER",
  "MAHILA VIDHYA MANDIR SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA, BAGWAS, PRATAPGARH",
  "BHARTIYA TEACHERS TRAINING COLLEGE KISHANGARH BAS",
  "GEETANJALI COLLEGE OF PARAMEDICAL SCIENCE",
  "Shree Balaji Nursing Institute, Sujangarh",
  "ARAWALI SHIKSHA EVAM ANUSANDHAN SANSTHAN",
  "RUHI CHOUDHARY INSTITUTE OF NURSING",
  "GOVERNMENT POLYTECHNIC COLLEGE, JHALAWAD",
  "THAREJA PARAMEDICAL INSTITUTE",
  "GOVERNMENT WOMAN POLYTECHNIC COLLEGE, KOTA",
  "NAVJEEVAN INSTITUTE OF PARAMEDICAL SCIENCES",
  "GOVERNMENT WOMAN POLYTECHNIC COLLEGE, JAIPUR",
  "MAYURAKSHI SCHOOL OF NURSING JODHPUR",
  "SARASWATI SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA SIKAR",
  "GOVERNMENT WOMAN POLYTECHNIC COLLEGE, BIKANER",
  "KANDOI PARAMEDICAL INSTITUTE",
  "SANSKAR TEACHERS TRAINING SCHOOL, JODHPUR",
  "SANSKAR INTERNATIONAL MAHILA SHIKSHA MAHAVIDYALAYA HANUMANGARH",
  "GOVERNMENT WOMAN POLYTECHNIC COLLEGE, BHARATPUR",
  "Krishna Paramedical College",
  "GOVERNMENT WOMAN POLYTECHNIC COLLEGE, AJMER",
  "GOVERNMENT SANSKRIT TT, MAHAPURA",
  "INDARAPRASTHA  INSTITUTE OF POLYTECHNIC, IIP",
  "NISHA PARAMEDICAL INSTITUTE OF SCIENCE AND TECHNOLOGY JODHPUR",
  "GOVERNMENT RESIDENTIAL WOMAN POLYTECHNIC COLLEGE, JODHPUR",
  "MODERN SCHOOL OF NURSING",
  "SH. AGRASEN TEACHER TEACHER TRAINING SCHOOL",
  "GOVERNMENT RAMCHANDRA KHAITAN POLYTECHNIC COLLEGE, JAIPUR",
  "RAMSNEHI SCHOOL OF NURSING BHILWARA",
  "RAJASTHAN COLLEGE FOR TEACHER TRAINING GHARSISAR, BIKANER",
  "H B BANSALI T T SCHOOL",
  "GRAMIN SEWA SANSTHAN TEACHER TRAINING INSTITUTE BARI ROAD DHOLPUR",
  "SARKAR NURSING COLLEGE ",
  "NIRMAL COLLEGE OF PARAMEDICAL SCIENCE",
  "SUDHA NURSING SCHOOL KOTA",
  "AAINA SPECIAL TEACHER TRANING INSTITUTE",
  "SHRI HARI NURSING COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BHEELWARA",
  "SHREE DEV NARAYAN SHIKSHA SAMITI CHAKSU",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BHARATPUR",
  "US INSTITUTE OF PARAMEDICAL SCIENCE",
  "SHEKHAWATI PARAMEDICAL INSTITUTE, KHINWASAR, GUDHA GORJI, JHUNJHUNU",
  "rajasthan polytechnic college, bissau",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, HANUMANGARH",
  "GOVERNMENT POLYTECHNIC COLLEGE, TONK",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BARMER",
  "SANJEEVAN INSTITUTE OF PARAMEDICAL SCIENCE & NURSING JAIPUR",
  "RAJAT INSTITUTE OF MEDICAL SCIENCES",
  "SAINT JOSEPH COLLEGE FOR TECHNICAL EDUCATION, TONK",
  "SANJEEVNI INSTITUTE OF PARAMEDICAL SCIENCES",
  "MATA GUJRI COLLEGE OF SPECIAL EDUCATION",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, GONER JAIPUR",
  "RANTHAMBHORE SEVIKA PARAMEDICAL INSTITUTE",
  "GULPADIYA T T COLLEGE RASIDPUR MAHWA",
  "GOVERNMENT POLYTECHNIC COLLEGE, SIKAR",
  "SAI MENTAL RETARTED RSIDENTIAL SCHOOL JHALAWAR",
  "REGIONAL INSTITUTE OF POLYTECHNIC STUDIES DHAMOTAR, PRATAPGARH",
  "GOVERNMENT POLYTECHNIC COLLEGE, SAWAI MADHOPUR",
  "BHARTIYA VIDHYA MANDIR TEACHER TRAINING COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, CHITTORGARH",
  "SANT BABA FATEH SINGH CHANAN SINGH INST OF PARAMEDICAL SCIENCES",
  "VISHWA BHARTI STC COLLEGE NARNAUL ROAD SINGHANA JHUNJHUNU RAJ",
  "AYUSH PARAMEDICAL INSTITUTE",
  "MANAS PARAMEDICAL COLLEGE",
  "KALYAN JAN SEVA SHIKSHA EVAM GRAMIN VIKAS SAMITI",
  "RAJDHANI PARAMEDICAL COLLEGE",
  "SANJEEVAN PARAMEDICAL & NURSING TRAINING CENTRE DAUSA",
  "SURENDERA NURSING TRAINING INSTITUTE",
  "SHEKAWATI TEACHER TRAINING SCHOOL",
  "SHEKHAWATI NURSING SCHOOL JHUNJHUNU",
  "R. N. T. GIRLS SCHOOL OF BSTC KAPASAN",
  "SAMARPAN SPECIAL INSTITUTE TONK",
  "VEER TEJA MAHILA NURSING SCHOOL TEJASTHALI MARWAR MUNDWA NAGAUR",
  "GOVERNMENT MINORITY LINGUAL TEACHER TRAINING INSTITUTION TOPDARA AJMER",
  "D P TIWARI SCHOOL OF NURSING",
  "MEERA MAHILA COLLEGE D.El.Ed. VILLAGE SEMALPURA TEH. AND  DISTT. CHITTORGARH",
  "MANAV DHARAM SPECIAL EDUCATION TEACHERS TRAINING CENTER",
  "TAPAS Shekshik Punarwas Avem Anusandhan Sansthan",
  "SHEKHAWATI POLYTECHNIC COLLEGE, SIKAR",
  "R. N. T. INSTITUTE OF BSTC KAPASAN",
  "SHRI MAHALAXMI MAHILA BASIC SCHOOL TRAINING COLLEGE",
  "SHREE HEM SINGH SPECIAL TEACHERS TRAINNING COLLEGE",
  "Shree Ji Nursing Institute",
  "REGIONAL INSTITUTE OF POLYTECHNIC STUDIES VATIKA SANGANER, JAIPUR",
  "NAVJEEVAN CO EDUCATION ELEMENTARY TT COLLEGE, SRIGANGANAGAR",
  "SHRI BHAYYA SHIKSHA SAMITI SPECIAL EDUCATION TEACHER TRAINING CENTER TONK",
  "MAHARANA PRATAP INSTITUTE OF PARAMEDICAL SCIENCE AND TECHNOLOGY",
  "SH.GOKUL BHAI BHATTGOVERNMENT POLYTECHNIC COLLEGE, SIROHI",
  "MARUDHARA BAL SHIKSHAN SANSTHAN",
  "SOCIETY FOR EDUCATION CONSCIENTISATION AWARENESS  AND TRAINING  KARAULI",
  "MOTHER TERESA ELEMENTRY TEACHER TRAINING INSTITUTION BHARATPUR",
  "SOCIETY FOR WELFARE OF MENTALLY HANDICAPPED SHREE NIRMAL VIVEK SCHOOL",
  "GOVERNMENT POLYTECHNIC COLLEGE MANDORE JODHPUR",
  "SHRI BALAJI GROUP OF SPECIAL EDUCATION (RUN BY SHRI BALAJI SHAIKSHANIK SANSTHAN)",
  "KOSHALYAM INSTITUTE FOR TRAINING AND RESEARCH",
  "SH. MISHRI LAL DUBEY GIRLS STC SCHOOL",
  "DHANWANTRI PARAMEDICAL TRAINING INSTITUTE",
  "SHREE BHAWANI SHANKER SHIKSHAK PRASHIKSHAN VIDYALAYA NARAYANPUR,ALWAR",
  "SHREE KRISHNA EDUCATIONAL INSTITUTE BHARATPUR",
  "SHREE MOOL CHAND MEENA SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA LALSOT",
  "NIMBARK SANSKRIT STC",
  "SHREE SABAL BALIKA SHIKSHAK PRASHIKSHAN VIDYALAYA",
  "SHRI BAJRANG POLYTECHNILC COLLEGE, BHARATPUR",
  "SHRI RAM COLLEGE OF PARAMEDICAL SCIENCES",
  "SAHYOG SEWA SANSTHAN",
  "CHETNA SPECIAL EDUCATION TEACHER TRAINING COLLEGE,NINWA ROAD,UNIYARA",
  "GET WELL HOSPITAL AND RESEARCH CENTER",
  "ADARSH GYANODAY VIKAS SAMITI",
  "DASHRATH MANOVIKAS SANSTHAN SIKAR",
  "MANAV DHARAM VIKLANG SEVA SANSTHAN SAWAR",
  "PRAYAS SEWA SANSTHAN",
  "NAYA SAWERA",
  "LAUGH N LEARN A ACADEMY OF SPECIAL EDUCATION",
  "MANSI JAN SEWA KALYAN SANSTHAN",
  "SHRI BAJRANG SHIKSHAK PRASHIKSHAN SCHOOL",
  "GLOBAL HOSPITAL SCHOOL OF NURSING TALHATI ABU ROAD",
  "shri balaji polytechnic college",
  "INSTITUTE FOR RURAL DEVELOPMENT AND TECHNICAL RESEARCH",
  "ST STEPHENS TEACHER TRAINING CENTER DIDWANA NAGAUR",
  "MSME TECHNOLOGY CENTRE BHIWADI",
  "SHRI DEV SPECIAL TEACHER TRAINING CENTER GULABPURA BHILWARA",
  "SHRI BALDEV RAM MIRDHA INSTITUTE OF NURSING NAGOUR",
  "NATIONAL EDUCATION INSTITUTE OF NURSING MAGLANA ROAD MAKRANA",
  "GENERAL NURSING AND MIDWIFERY TRAINING CENTRE BARMER",
  "SHRI BHAWANI NIKETAN POLYTECHNIC",
  "Bharat Vikas Parishad Hospital And Research Center",
  "SORABH COLLEGE OF ENGINEERING & TECHNOLOGY, KARAULI",
  "PRABHA SHANKAR PANDYA COLLEGE, PARTAPUR",
  "CHAUDHARY MANIRAM SCHOOL OF BSTC, HANUMANGARH",
  "K R MEMORIAL SCHOOL OF NURSING CHOMU ",
  "GOVERNMENT POLYTECHNIC COLLEGE, RAJASMAND",
  "SWAMI VIVEKANAND PUNARWAS SANSTHAN, BASSI, JAIPUR",
  "PRATAP BSTC COLLEGE",
  "CREATIVE HANDS SOCIETY FOR EDUCATION AND HEALTH",
  "Surender Kaur Memorial Teacher Training College",
  "THE FIRST ONE INSTITUTE OF SPECIAL EDUCATION",
  "JUBIN SPASTICS HOME AND CHARITABLE TRUST",
  "SATYABHAMA INSTITUTE OF SPECIAL EDUCATION AND RESEARCH",
  "MANAV DHARAM MENTALLY RETARDED TEACHER TRAINING CENTRE",
  "T R MEMORIAL SPECIAL TEACHER TRAINING COLLEGE DEORA, VILLAGE DEORA, POST DEORA, TEH CHITALWANA,  DIST JALORE RAJASTHAN",
  "TAGORE INSTITUTE OF SPECIAL EDUCATION",
  "LIFE STYLE WELFARE SANSTHA",
  "YASH REHABILITATION CENTRE FOR HANDICAPPED CHILDREN",
  "SWEEKAR SPECIAL SCHOOL SAMITI,",
  "LATE SHRI RAM KUMAR COLLEGE OF SPECIAL EDUCATION",
  "ASHA KA JHARNA",
  "NAVJIVAN SPECIAL TEACHER TRAINING CENTRE LALSOT DAUSA",
  "SARKAR NURSING SCHOOL",
  "VEER TEJA SPECIAL TEACHER TRAINING COLLAGE NIMBALKOT",
  "SHRI DEVI WOMEN POLYTECHNIC, HANUMANGARH",
  "SHRI JAIN SWETAMBER TERAPANTHI MAHILA SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA, RANAWAS, DIST PALI, RAJASTHAN",
  "GOVT MODEL NURSING INSTITUTE AND CENTER FOR EXCELLENC FOR MIDWIFERY KEKRI AJMER",
  "ANANTA SCHOOL OF NURSING",
  "SIDDHARTH INSTITUTE OF NURSING JAIPUR",
  "MURLI SINGH YADAV MEMORIAL NURSING INSTITUTE UDAIRAMSAR",
  "ADITYA SHIKSHAN AND PRASHIKSHAN SANSTHAN CAMBRIDGE SCHOOL OF NURSING",
  "RAJASTHAN SCHOOL OF NURSING",
  "SAVITRI DEVI NURSING INSTITUTE UDAIRAMSAR",
  "KRISHNA COLLEGE OF LIFE SCIENCES",
  "NAVJEEVAN SPECIAL SCHOOL TEACHERS TRAINING INSTITUTE RUN BY GOGAMERI JAN JAGARTI VIKAS SEVA SAMITI",
  "GEETA DEVI PARAMEDICAL AND RESEARCH INSTITUTE",
  "RAJ NURSING PARAMEDICAL INSTITUTE, REVDAR, SIROHI",
  "SHRI DIGAMBER JAIN ADARSH MAHILA SANSKRIT PRASHIKSHAN VIDYALAYA",
  "SHRI GOKUL VERMA GOVERNMENT POLYTECHNIC COLLEGE, BHARATPUR",
  "SHRI GURUNANAK KHALSA SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA",
  "RAMANAND T T COLLEGE",
  "SHRI JAIN ADARSH KANYA SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA BIKANER",
  "SHRI JAWAHAR WOMAN POLYTECHNIC COLLEGE, DAUSA",
  "LOKESH STC COLLEGE",
  "INDIRA EDUCATION INSTITUTE OF NURSING UDAIPUR",
  "RNT COLLEGE OF BSTC",
  "SATYA SAI SCHOOL OF NURSING SIKAR",
  "SHRI KRISHNA POLYTECHNIC COLLEGE",
  "SIDDHARTH INSTITUTE OF TECHNOLOGY, JAIPUR",
  "SHRINATH INSTITUTE OF PARAMEDICALK SCIENCES",
  "Maa karni BSTC",
  "Siddhi Vinayak Polytechnic, Alwar",
  "SIDHI VINAYAK NURSING SCHOOL",
  "CH. GIRDHARI RAM DHAKA POLYTECHNIC COLLEGE, HANUMANGARH",
  "SMS COLLEGE OF PARAMEDICAL SCIENCES",
  "SANKALP PARAMEDICAL INSTITUTE DHOLPUR",
  "NEW INDIAN POLYTECHNIC COLLEGE DUNDLOD NAWLAGARH, JHUNJHUNU",
  "SWASTIK PARAMEDICAL COLLEGE",
  "APEX CAREER INSTITUTE",
  "SGN NURSING AND PARAMEDICAL COLLEGE PAOTA",
  "GOVERNMENT POLYTECHNIC COLLEGE, PALI",
  "FOREX WELFARE SOCIETY SHIV B.ED. COLLAGE SPECIAL EDUCATION IDD COLLEGE, SAROLI MOD, DOONI, TONK",
  "RIGVED INSTITUTE OF PARAMEDICAL SCIENCES",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BARAN",
  "DEENDAYAL POLYTECHNIC COLLEGE, SIKAR",
  "MADHAV NURSING SCHOOL KOTA",
  "SORABH TT COLLEGE SAWAI MADHOPUR (515)",
  "SHRI BAJRANG PARAMEDICAL COLLEGE",
  "SVN Sansthan",
  "AGRASEN PARA MEDICAL INSTITUTE SAWAI  MADHOPUR",
  "YAGAM SPECIAL TEACHER TRAINING CENTER",
  "NAGFANI INSTITUTE OF NURSING",
  "ASSENT SPECIAL TEACHER TRAINING CENTER",
  "DADHIMATHI MAHILA TEACHER'S TRAINING INSTITUTION FOR WOMEN STC",
  "SHEKHAWATI INSTITUTE OF PARA MEDICAL SCIENCE",
  "RAMI DEVI NURSING AND PARAMEDICAL INSTITUTE TONK",
  "S R PARAMEDICAL COLLEGE    ",
  "DR. MAMTA PARAMEDICAL INSTITUTE",
  "ARAVALI INSTITUTE OF PARAMEDICAL SCIENCES",
  "Government Polytechnic College Kelwara",
  "DEEPAK DEPLOMA ELEMENTRY T T COLLEGE PAOTA",
  "Mahavir Educational And Welfare Trust",
  "CHOUDHARY MALURAM BHAMBU GOVERNMENT POLYTECHNIC COLLEGE, SRIGANGANAGAR",
  "LKC SRI JAGDAMBA ANDH VIDHALYA SAMITI",
  "INDIAN INSTITUTE OF LEARNING DISABILITIES  AND REHABILITATION",
  "nirmal shikshak prashikshan sansthan munderi",
  "brindavan institute of paramedical sciences",
  "RAMAN POLYTECHNIC COLLEGE, BIKANER",
  "DR. B. LAL INSTITUTE OF PARAMEDICAL SCIENCES",
  "MOTHER INDIA TEACHER TRAINING SCHOOL",
  "M B HEALTH & HYGIENE NURSING EDUCATION INSTITUTE DUNGARPUR",
  "ARIHANT PARAMEDICAL INSTITUTE",
  "OM SHIV SANSTHAN TEACHER TRAINING COLLEGE",
  "MARUDHAR SPECIAL TEACHERS TRAINING COLLEGE, JODHPUR",
  "SHRI BAPUJI SPECIAL TEACHER TRAINING CENTRE",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION",
  "SHRI MAHADEV SPECIAL TEACHER TRAINING CENTER",
  "R G SPECIAL TEACHER TRAINING CENTRE",
  "CAMBRIDGE INSTITUTE OF PHARMACY",
  "HARI DAYAALU PARAMEDICAL COLLEGE, BARMER ",
  "VINAYAK NATIONAL COLLEGE OF PARAMEDICAL",
  "SHIV DHARA PARAMEDICAL COLLEGE",
  "CAMBRIDGE PARAMEDICAL INSTITUTE BARMER",
  "KAMAKSHA EDUCATION COLLEGE OF SAGWARA SAGWARA DUNGARPUR",
  "JINDAL PARAMEDICAL INSTITUTE",
  "KANCHAN SPECIAL COLLEGE RAMGARH PACHWARA, DAUSA",
  "ISHOM INSTITUTE OF PARAMEDICAL SCIENCE",
  "BHARTI SPECIAL COLLEGE DAUSA",
  "RAM INSTITUTE OF PARAMEDICAL SCIENCES",
  "RONAK SPECIAL TEACHER TRAINING INSTITUTE",
  "GOVERNMENT POLYTECHNIC COLLEGE, JHUNJHUNU",
  "KRISHNA PARAMEDICAL COLLEGE KAROTH ROAD RAJGARH ALWAR",
  "RAWAT PARA MEDICAL COLLEGE",
  "M D SANSTHAN",
  "GOVERNMENT POLYTECHNIC COLLEGE LADPURA KOTA",
  "KATARA PARAMEDICAL COLLEGE",
  "Rajasthan  Vidyapeeth Kul Hari Bhau Upadhayaya Mahila Shikshak Mahavidyalaya , Hatundi Ajmer",
  "MISRI DEVI MEMORIAL POLYTECHNIC COLLEGE, KARAULI",
  "STAR COLLEGE OF PARAMEDICAL SCIENCES",
  "DHAKER PARAMEDICAL COLLEGE",
  "BALAJI PARAMEDICAL INSTITUTE, TODI SIKAR ROAD, JAIPUR",
  "CHANDGIRAM POLYTECHNIC COLLEGE, CHURU",
  "CHAUDHARY BSTC SCHOOL RAJGARH, CHURU",
  "CHAUDHARY MRM MEMORIAL INSTITUTE SURATGARH, SRIGANGANAGAR",
  "STATE INSTITUTE OF HOTEL MANAGEMENT UDAIPUR",
  "PRASHANTI COLLEGE OF EDUCATION FOR WOMEN ( BSTC )",
  "GOVERNMENT POLYTECHNIC COLLEGE, JODHPUR",
  "AADHAR SPECIAL B ED COLLEGE",
  "SURYODAYA VIDHYA MANDIR SHIKSHA SAMITI BUNDI",
  "MOTHERLAND TEACHER TRAINING SCHOOL TONK",
  "KABRA INSTITUTE OF MEDICAL SCIENCES",
  "SHREE DADU DAYAL PARAMEDICAL INSTITUTE JODHPUR",
  "NORANG RAM DAYANAD DHUKIA PARAMEDICAL SANSTHAN JHUNJHUNU",
  "SUFIYA INSTITUTE OF PARAMEDICAL SCIENCE",
  "SIDDHARTH INSTITUTE OF PARAMEDICAL SCIENCES",
  "SHREE SHYAM PARAMEDICAL COLLEGE",
  "SHRI MATSAYA PARAMEDICAL COLLEGE",
  "ANNPURNA BSTC SCHOOL",
  "RAJASTHAN PARAMEDICAL COLLEGE",
  "MAHARANA PRATAP VISHESH MAHAVIDHALIYA UNIYARA",
  "THE LITTLE STAR SPECIAL TEACHER TRAINING CENTER",
  "STATE INSTITUTE OF HOTEL MANAGEMENT SAWAI MADHOPUR",
  "JYOTI COLLEGE OF PARAMEDICAL SCIENCES",
  "TANWAR SHIKSHA SANSTHAN",
  "R R COLLEGE OF PARAMEDICAL SCIENCES",
  "MAHALA INSTITUTE OF PARAMEDICAL SCIENCES",
  "SYMBIOSIS COLLEGE OF PARAMEDICAL SCIENCES JAIPUR",
  "SHRI BHANDARI SPECIAL TEACHER TRAINING CENTRE",
  "M.B.MAHILA TEACHER TRAINING SCHOOL DUNGARPUR",
  "PROF S KARAN INSTITUTE OF PARAMEDICAL SCIENCES",
  "SADI LAL KATARIA MEMORIAL MAHILA SHIKSHAK PRASHIKSHAN COLLEGE PILANI, JHUNJHUNU",
  "REGIONAL COLLEGE OF POLYTECHNIC VATIKA, JAIPUR",
  "CHAUDHARY MS MEMORIAL SHIKSHAK PRASHIKSHAN COLLEGE TARANAGAR, CHURU",
  "HEALTH AND HYGIENE NURSING EDUCATION INSTITUTE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BIKANER",
  "GOVERNMENT POLYTECHNIC COLLEGE, KARAULI",
  "SALASAR BALAJI INSTITUTE OF PARAMEDICAL SCIENCE",
  "MAHAVEER SPECIAL TEACHER TRANING EDUCATION INSTITUTE",
  "GOVERNMENT POLYTECHNIC COLLEGE, KOTA",
  "SHREE KRISHANA SCHOOL OF NURSING",
  "VENKTESHWAR INSTITUTE OF PARAMEDICAL SCIENCES",
  "SUPERKING COLLEGE OF PARAMEDICAL SCIENCE",
  "SWAMI DAYANAND INSTITUTE OF NURSING KHAJUWALA",
  "R K INSTITUTE OF PARAMEDICAL SCIENCES",
  "SARASWATI  BAHU DIVYANG SHIKSHAN SANSTHAN, BEENJHBAYALA",
  "SHRI VINAYAK COLLEGE OF PARAMEDICAL SCIENCE",
  "SONI NURSING SCHOOL JAIPUR",
  "SMT DHAPUBAI BSTC COLLEGE",
  "OM INSTITUTE OF PARAMRDICAL SCIENCE",
  "JODHPUR BADHIR KALYAN SAMITI",
  "Vidya Bharti STC College",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, ALWAR",
  "GOVERNMENT POLYTECHNIC COLLEGE, PRATAPGARH",
  "Florence Nightingale School Of Nursrng",
  "AROGYA INSTITUTE OF PARAMEDICAL SCIENCES",
  "BHAGWAN MAHAVEER COLLEGE OF PARAMEDICAL SCIENCES",
  "CHAUDHARY PARMARAM GODARA SHIKSHAK PRASHIKSHAN COLLEGE BHADRA, HANUMANGARH",
  "SANT BABA FATEH SINGH CHANAN SINGH NURSING INSTITUTE",
  "MAHATMA GANDHI GENERAL NURSING SCHOOL SIKAR",
  "TRIVENI  PARAMEDICAL INSTITUTE KEKRI",
  "RAJASTHAN EDUCATION INSTITUTE OF NURSING DAUSA",
  "GOVERNMENT POLYTECHNIC COLLEGE, NAGAUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BUNDI",
  "GOVERNMENT POLYTECHNIC COLLEGE, NIMRANA ALWAR",
  "SHRI MUNSHI RAM MITTAL PARAMEDICAL INSTITUTE SIKAR",
  "K R PARAMEDICAL COLLEGE CHOMU JAIPUR RAJASTHAN",
  "YOGESH SHEKSHIK PUNARWAS AWAM SHODH SANSTHAN SIROHI",
  "VINAYAK PARAMEDICAL COLLEGE",
  "DSM PARAMEDICAL INSTITUTE",
  "KIRAN DEVI SPECIAL TEACHER TRAINING CENTER",
  "G N M Training Center, Chittorgarh",
  "BALAJI PARAMEDICAL INSTITUTE",
  "R K T T COLLEGE BORAWAR",
  "JAN SWASTHYA KALYAN PARAMEDICAL COLLEGE",
  "SCHOOL OF AERONAUTICS , NEEMRANA ALWAR",
  "SHEKHAWATI MEDICAL TRAINING INSTITUTE",
  "NAVJEEVAN TRAINING INSTITUTE SIKAR",
  "MAHATMA GANDHI PARAMEDICAL COLLEGE",
  "PRINCE ACADEMY OF TECHNICAL EDUCATION, SIKER",
  "SUNRISE INSTITUTE OF NURSING EDUCATION UDAIPUR",
  "AMBASSY SCHOOL OF NURSING JAIPUR",
  "MUVE PARAMEDICAL RESEARCH INSTITUTE BHARATPUR",
  "SHEKHAWATI COLLEGE OF EDUCATION",
  "R.C.MEMORIAL T.T.COLLEGE",
  "TIMES STC SCHOOL HANUMANGARH",
  "SHRI KRISHNA PRIMARY MAHILA TEACHERS TRAINING SANSTHAN JAIPUR",
  "PRAGATI STC INSTITUTE",
  "MATA SANTOSH DEVI PARAMEDICAL COLLEGE",
  "SHRI DIGAMBER PARAMEDICAL INSTITUTE",
  "MBM D ED SPECIAL COLLEGE",
  "S. S. PARAMEDICAL COLLEGE",
  "RAJASTHANI INSTITUTE OF PARAMEDICAL SCIENCES",
  "COMPOSITE REGIONAL CENTRE FOR SKILL DEVELOPMENT REHABILITATION AND EMPOWERMENT OF PERSONS WITH DISABILITIES DIVYANGJAN, JAIPUR",
  "R. S. PARAMEDICAL INSTITUTE",
  "Shekhawati Institute of Para Medical Science",
  "VANSH HIGHER EDUCATION INSTITUTE",
  "MARUTI NANDAN ELEMENTARY (BSTC) TT COLLEGE",
  "MADHAV VIDHYAPEETH",
  "DR RADHAKRISHNAN TEACHERS TRAINING SCHOOL, KUCHAMAN CITY",
  "MANSIK VIKLANG SHIKSHAN PRASHIKSHAN KENDRA",
  "SHREE RUGHA RAM BHADU PARAMEDICAL COLLEGE",
  "NEHRU ADARSH JAN SWASTHYA GRAMIN VIKAS SANTHA",
  "SHRI SAINATH MANOVIKAS SANSTHAN SIKAR",
  "NAV CHETNA MANSIK VIKLANG AND MOOK BADHIR VIDHALAYA SAMITI",
  "CHILDRENS ACADEMY DED COLLEGE",
  "C.R.L. POLYTECHNIC COLLEGE DUNDLOD",
  "SWASTHYA KALYAN COLLEGE OF PARAMEDICAL TECHNOLOGY",
  "IDLE TEACHERS TRAINING SCHOOL HISAR ROAD RAJGARH DISTRICT CHURU RAJASTHAN",
  "MSY BSTC",
  "MAHATMA JYOTI RAO PHOOLE MAHILA SANSKRIT SHIKSHAK PRASHIKSHAN VIDYALAYA JAIPUR",
  "BDML COLLEGE OF EDUCAITON",
  "JAI BABA AMARNATH T T SCHOOL",
  "AYUSHMAAN INSTITUTE OF SPECIAL TEACHER TRAINING",
  "GANGA VISION TEACHER TRAINING INSTITUTE",
  "KOTA BLOOD BANK SOCIETY",
  "MAITRI INSTITUTE OF MEDICAL SCIENCES",
  "GARIMA SPECIAL SCHOOL SAMITI",
  "SRI JAGDAMBA EDUCATION AND RESEARCH INSTITUTE",
  "THAKUR MADAN SINGH T.T. COLLEGE",
  "RADHAKRISHNAN T.T. COLLEGE FOR WOMEN",
  "OM KOTHARI INSTITUTE OF TEACHER TRAINING",
  "Mewar Girls College of TeachersTraining",
  "Veena Memorial College of Education",
  "JAMVAY TT COLLEGE BSTC",
  "MAHARANA PRATAP MAHILA SANSKRIT STC SCHOOL,BASERI",
  "BHARTIYA PRASHIKSHAN SANSTHAN",
  "A.J.MANJU COLLEGE OF PARAMEDICAL SCIENCE KHANPUR",
  "Dana Shivam Paramedical College",
  "saraswati mahila teacher training college",
  "Riya Hospital And Para Medical college",
  "SONA VIKLANG PUNARWAS AVOM SODH SANSTHAN",
  "Children Shikshak Prashikshan Sansthan",
  "LAXMIDHAR POLYTECHNIC COLLEGE",
  "REGIONAL GIRLS COLLEGE",
  "SORABH T T COLLEGE KHEDLI DAUSA",
  "JAI SHRI BALAJI INSTITUTE OF SPECIAL EDUCATION DAUSA",
  "BHANWAR KANWAR SUGAN SINGH SHIKSHA MAHAVIDHLAYA  INDERPURA UDAIPURWATI",
  "Susheela Institute of Paramedical Sciences",
  "Krishna Hospital and Institute of Para Medical Science",
  "RAJASTHAN MAHILA KALYAN MANDAL",
  "PANDIT DEENDAYAL UPADHYAY SHIKSHAN SANSTHAN",
  "CH CHARAN SINGH NATIONAL INSTITUTE OF AGRICULTURAL MARKETING",
  "KHANDELA T.T. COLLEGE",
  "Shekhawati STC College",
  "PRAYAS CENTRE FOR SPECIAL EDUCATION AND VOCATIONAL TRAINING",
  "SHRADHALAYA JANJATI TEACHER TTI",
  "SHEKHAWATI INSTITUTE OF AYURVEDA AYURVED NURSING PRASHIKSHAN KENDRA JAIPUR ROAD SIKAR",
  "SAMBAL SAMITI JAIPUR",
  "SHIVAM  SPECIAL TEACHER TRAINING CENTER SUJANGARH HEARING IMPAIRMENT",
  "TR MEMORIAL SPECIAL TEACHER TRAINING COLLEGE DEORA, VILLAGE DEORA, POST DEORA, TEH CHITALWANA,  DIST JALORE RAJASTHAN",
  "RUHI CHOUDHARY PARA MEDICAL INSTITUTE SADULPUR",
  "GOPESHWAR SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA,KANWARPURA,DOONGERJA,DIGOD,KOTA 325201",
  "MAJISA SPECIAL TEACHER TRAINING CENTER SUJANGARH HEARING IMPAIRMENT",
  "KAMLA SHIKSHAN SANSTHAN",
  "Shri S L Saini Memorial College of Paramedical Sciences",
  "SARASWATI VIDYA ASHRAM SAMITI",
  "G.D. COLLEGE (D.EL.Ed) , JAMWARAMGARH , JAIPUR",
  "FOOD CRAFT INSTITUTE SUMERPUR",
  "MATESHWARI NURSING EDUCATION INSTITUTE UDAIPUR",
  "SHRI RUDRA SPECIAL TEACHER TRAINING CENTER BIDASAR",
  "POORNIMA INSTITUTE OF HOTEL MANAGEMENT JAIPUR",
  "SHYAM SAROVAR COLLEGE OF EDUCATION NADBAI",
  "SHRI BABA RAMDEV SPECIAL TEACHER TRAINING CENTER BIDASAR HEARING IMPAIRMENT",
  "MAHATMA JYOTIBA FULE INSTITUTE OF NURSING JAIPUR",
  "IRSHAD MEMORIAL INSTITUTE OF PARAMEDICAL AND NURSING EDUCATION JAIPUR",
  "ISHOM SPECIAL TEACHER TRAINING CENTER LADNUN",
  "G D COLLEGE JAMWARAMGARH",
  "RUNGTA PARAMEDICAL COLLEGE",
  "SHRI MARUDHAR KESRI BALIKA SANSKRIT SHIKSHAK PRASHIKSHAN VIDYALAYA",
  "Dev Kanya Shikshak Prashikshan Mahavidyalaya, Jahazpur",
  "GAURAV NURSING SCHOOL JAIPUR",
  "Saraswati Para medical College",
  "MOTI LAL DAVE T T COLLEGE METWALA",
  "Nimt College of Paramedical Sciences",
  "LATE KUMARI LAXMI BADHALA MAHILA PRIMARY TEACHER TRAINING SCHOOL",
  "PRAKHAR INSTITUTE OF PARA MEDICAL SCIENCES",
  "SHANTI NIKETAN PARA MEDICAL COLLEGE",
  "RAJRISHI COLLEGE OF PARAMEDICAL",
  "FOOD CRAFT INSTITUTE AJMER",
  "ABUROAD POLYTECHNIC COLLEGE, SIROHI",
  "ADITIYA POLYTECHNIC COLLEGE, AJMER",
  "AGRAWAL BALIKA PRARAMBHIK SHIKSHAK PRASHIKSHAN GANGAPUR CITY",
  "ALKA MEMORIAL COLLEGE OF SCIENCE, JAIPUR",
  "ARAVALI TEACHERS TRAINING COLLEGE NEEM KA THANA, JUNJHUNU",
  "ARJUN RAM SHEKSHAN PRASHIKSHAN VIDYALAYA SIKAR",
  "ARYAN MUKUL POLYTECHNIC COLLEGE, DEOLI",
  "ARYAN POLYTECHNIC COLLEGE, AJMER",
  "ARYA SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA SIKAR",
  "ARCHANA COLLEGE OF PARAMEDICAL SCIENCES",
  "OM SHIKSHAN SANSTHAN",
  "GAURAV INSTITUTE OF PARAMEDICAL SCIENCE KHEDA, HINDAUN CITY, DISTT KARAULI",
  "SANKALP SPECIAL INSTITUTE NEWAI",
  "SANGAM SPECIAL INSTITUTE PEEPLU",
  "JAISWAL PARAMEDICAL INSTITUTE",
  "SWERA REHABILITATION TRAINING INSTITUTE RUN BY SOCIETY FOR SINGLE WOMEN EMPOWERMENT",
  "JAI DURGA SCHOOL OF NURSING JAIPUR",
  "TAGORE ELEMENTARY TEACHER EDUCATION SCHOOL",
  "AGRANI INSTITUTE OF PARAMEDICAL SCIENCES",
  "SUNRISE INSTITUTE OF PARAMEDICAL SCIENCES",
  "Regional Teachers Training College",
  "SHRI HARI PARAMEDICAL COLLEGE ",
  "MAULANA AZAD MUSLIM TEACHER'S TRAINING SCHOOL JODHPUR",
  "BOMBAY INSTITUTE OF HEALTH SCIENCE AND RESEARCH",
  "SANGARIA COLLEGE OF PARAMEDICAL SCIENCE",
  "RELIABLE PARAMEDICAL COLLEGE",
  "MKD COLLEGE OF EDUCATION MANDAWAR",
  "Vidya Teacher Training college",
  "SRI GOVIND SHIKSHAK PRASHIKSHAN COLLEGE BISAU, JHUNJHUNU",
  "APEX POLYTECHNIC INSTITUTE, JAIPUR",
  "UDAIPUR INSTITUTE OF NURSING UDAIPUR",
  "JODHPUR INSTITUTE OF HOTEL MANAGEMENT",
  "RAJDHANI INSTITUTE OF PARAMEDICAL SCIENCES",
  "Global institute of Nursing , Udaipur",
  "AMBIKA INSTITUTE FOR PARAMEDICAL STUDIES",
  "U.S. OSTWAL INSTITUTE OF TECHNOLOGY AND SCIENCE",
  "TIRUPATI SCHOOL OF NURSING",
  "GLOBAL NURSING SCHOOL",
  "OM SHIKSHAN WA PRASHIKSHAN SANSTHAN",
  "SHREE JAGDISH SEVA SANSTHAN",
  "PRERNA EDUCATION AND WELFARE SOCIETY",
  "CHAITANYA SEVA SANSTHAN",
  "STATE INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION GOVT POLYTECHNIC CAMPUS NEW PALI ROAD JODHPUR",
  "LITTLE ANGEL COLLEGE OF SPECIAL EDUCATION",
  "RAJ PARAMEDICAL COLLEGE",
  "SHRI MAHARSHI DADHICH( S M D) SCHOOL OF NURSING KOTA",
  "KAMAKSHI SCHOOL OF NURSING BALOTRA",
  "RAVINDRA NURSING SCHOOL JHUNJHUNU",
  "SHIKSHA SANCHALAN AND CHIKITSA PRASAR SAMITI",
  "BHARTI TEACHER TRAINING SCHOOL",
  "BHARTIYA BALIKA SHIKSHAK PARSHIKSHAN SANSTHAN",
  "UJJWAL VIKRAM BSTC COLLAGE",
  "GOVERNMENT POLYTECHNIC COLLEGE BANDIKUI",
  "GOVERNMENT WOMEN POLYTECHNIC COLLEGE, TAPUKARA",
  "RAJIV GANDHI MEMORIAL SCHOOL OF NURSING JODHPUR",
  "RAJASTHAN TEACHERS TRAINING SCHOOL JHUNJHUNU",
  "RAJASTHAN SHIKSHAK PRASHIKSHAN VIDKHYALAY",
  "RAJASTHAN SANSKRIT SHIKSHAK PRASHIKSAN",
  "RAJASTHAN POLYTECHNIC COLLEGE, JHUNJHUNU",
  "RAJASTHAN POLYTECHNIC COLLEGE, BIKANER",
  "RAJASTHAN NURSING SCHOOL JHUNJHUNU",
  "RAJASTHAN GIRLS STC SCHOOL MALSISAR, JHUNJHUNU",
  "JAI NARAYAN VYAS SCHOOL OF PHARMACY & DIPLOMA ENGINEERING, BARMER",
  "INSTT OF MED TECH & NSG EDUC JAIPUR",
  "INSTITUTE OF RURAL MANAGEMENT",
  "INDIRA GANDHI BALIKA NIKETAN SANSKRIT SHIKSHAK PRASHIKSHAN SCHOOL, JHUNJHUNU",
  "INDIRA GANDHI BALIKA NIKETAN JHUNJHUNU",
  "INDIAN PUBLIC PRIMARY TT COLLEGE, JHUNJHUNU",
  "IMPERIAL POLYTECHNIC COLLEGE, SHOYCHAND CHURU",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, GARHI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, DUNGARPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, DHOLPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, DAUSA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, CHURU",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING CHUNAWADH, SRIGANGANAGAR",
  "ST JKL STC COLLEGE",
  "JAGAN INSTITUTE OF MANAGEMENT STUDIES",
  "SORABH COLLEGE OF PARAMEDICAL SCIENCE",
  "GOVERNMENT POLYTECHNIC COLLEGE PILANI CAMP GOVERNMENT POLYTECHNIC COLLEGE JHUNJHUNU",
  "GOVERNMENT POLYTECHNIC COLLEGE NAWA",
  "MANASVI AYUSH NURSING COLLEGE",
  "YOGIRAJ INSTITUTE OF TECHNOLOGY, KOTA",
  "YADUVANSHI POLYTECHNIC, JHUNJHUNU",
  "YADUVANSHI INSTITUTE OF EDUCATION JHUNJHUNU",
  "VYAS NURSING INSTITUTE JODHPUR",
  "VRIDDHI POLYTECHNIC COLLEGE, JAIPUR",
  "V.K. TYAGI TEACHER TRAINING COLLAGE DHOLPUR",
  "VINAYAK NURSING SCHOOL JAIPUR",
  "VIKAS POLYTECHNIC COLLEGE DEEG, BHARATPUR",
  "VIDYA BHAWAN KALA SANSTHAN BSTC",
  "VIDYA BHAWAN GOVERNMENT POLYTECHNIC COLLEGE, UDAIPUR",
  "VASHISTH POLYTECHNIC COLLEGE, SRIGANGANAGAR",
  "SWAMI VIVEKANAND COLLEGE FOR PROFESSIONAL STUDIES SINTHAL, BIKANER",
  "SWAMI VEVEKANAND ELEMENTARY TEACHERS EDUCATION PROGRAMME HANUMANGARH",
  "SWAMI KESWANAND SHIKSHAN SANSTHAN TEACHERS TRAINING INSTITUTE",
  "SWAMI KESHWANAND INSTITUTE OF TECHNICAL EDUCATION, SIKAR",
  "SUNDER SHIKSHAK PRASHIKSHAN VIDYALAYA JAIPUR",
  "SUMERPUR POLYTECH COLLEGE, PALI",
  "SUGAN INSTITUTE OF TECHNOLOGY AND ENGINEERING FALAUDI, JODHPUR",
  "SS POLYTECHNIC COLLEGE, JHAMAR KOTDA ROAD, UMARDA, UDAIPUR",
  "SRI ADARSH MAHILA ELE. TEACHERS EDUCATION SCHOOL",
  "SMT RAMKUMARI ELEMENTARY SHIKSHAK PRASHIKSHAN COLLEGE, JHUNJHUNU",
  "S.M.S. TEACHER TRAINING SCHOOL AJMER",
  "SLBS POLYTECHNIC COLLEGE, JODHPUR",
  "MANAV MANGAL GIRLS COLLEGE OF EDUCATION SANGRIA, HANUMANGARH",
  "NIROGDHAM SCHOOL OF NURSING JHALAWAR",
  "MAI KHADIJA SCHOOL OF NURSING JODHPUR",
  "NEW INDIAN TEACHERS TRAINING SCHOOL JHUNJHUNU",
  "MAHESH INSTITUTE OF PROFESSIONAL STUDIES, BARMER",
  "MAHATMA JYOTIBA FULE INSTITUTE OF ENGINEERING & TECHONOLOGY, CHURU",
  "MAHATMA GANDHI SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA BHARATPUR",
  "MAHARANI PRATAP STC SCHOOL",
  "MAHARANA PRATAP STC SCHOOL",
  "MAHARANA PRATAP INSTITUTE OF POLYTECHNIC, BHIWADI ALWAR",
  "MAHANT SHRI RAGHUNAND DAS SHIKSHAN SANSTHA DUNGARPUR",
  "MAA BHARTI TEACHER'S TRAINING SCHOOL",
  "LUCKY INSTITUTE OF PROFESSIONAL STUDIES",
  "L.B.S POLYTECHNIC COLLEGE PACHER BARI, JHUNJHUNU",
  "GOVERNMENT POLYTECHNIC COLLEGE, JAISALMER",
  "LBS POLYTECHNIC COLLEGE, JODHPUR",
  "GOVERNMENT POLYTECHNIC COLLEGE, HANUMANGARH",
  "LAXMIDEVI INSTITUTE OF ENGINEERING & TECHNOLOGY, ALWAR",
  "LAL BHADUR SHASTRI STC SCHOOL",
  "GOVERNMENT POLYTECHNIC COLLEGE, DUNGARPUR",
  "KRISHNA INSTITUTE OF TECHNOLOGY & ENGINEERING, CHIMANPURA PALI",
  "GOVERNMENT POLYTECHNIC COLLEGE, DHOLPUR",
  "GOVERNMENT POLYTECHNIC COLLEGE, DAUSA",
  "GOVERNMENT POLYTECHNIC COLLEGE, CHURU",
  "KOTA POLYTECHNIC COLLEGE, RIICO INDUSTRIAL AREA, JHALAWAR ROAD",
  "KAUTILYA MAHILA SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA KOTA",
  "KARUNA SHIKSHAK PRASHIKSHAN COLLEGE, HANUMANGARH",
  "GOVERNMENT POLYTECHNIC COLLEGE, CHITTORGARH",
  "GOVERNMENT POLYTECHNIC COLLEGE, BUNDI",
  "GOVERNMENT POLYTECHNIC COLLEGE, BIKANER",
  "KARUNA SCHOOL OF NURSING HANUMANGARH",
  "GOVERNMENT POLYTECHNIC COLLEGE, BHILWARA",
  "KALIDAS SANSKRIT TEACHER TRAINING INSTITUTE",
  "GOVERNMENT POLYTECHNIC COLLEGE, BARMER",
  "JRS INSTITUTE OF TECHNICAL EDUCATION, SIKAR",
  "GOVERNMENT POLYTECHNIC COLLEGE, BARAN",
  "GOVERNMENT POLYTECHNIC COLLEGE, BANASWADA",
  "GOVERNMENT POLYTECHNIC COLLEGE, BAGIDORA",
  "GOVERNMENT POLYTECHNIC COLLEGE, ALWAR",
  "J L MEMORIAL TT COLLEGE, JODHPUR",
  "JITS POLYTECHNIC, NH 12, MEDI CITY, PO BOX NO 20, DEOLI, TONK",
  "GOVERNMENT POLYTECHNIC COLLEGE, AJMER",
  "GANPATI COLLRGR OF SCIENCE TECHONOLOGY & MANAGEMENT, JAIPUR",
  "FULERA POLYTECHNIC COLLEGE, JAIPUR",
  "JEEVLI SHIKSHAK PRASHIKSHAN INSTITUTE, JHUNJHUNU",
  "JB TEACHERS TRAINING INSTITUTE, SRIGANGANAGAR",
  "EKALAYAYA SCHOOL OF TEACHER TRAINING",
  "JAIPUR INSTITUTE OF POLYTECHNIC & TECHNOLOGY, JAIPUR",
  "DR. RADHAKRISHNAN POLYTECHNIC COLLEGE, SEZ JAIPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, UDAIPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, TONK",
  "JAIPURIA INSTITUTE OF MANAGEMENT",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, SIKAR",
  "IMPERIAL INSTITUTE OF POLYTECHNIC & TECHNOLOGY, JAIPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, SAWAIMADHOPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, NATHDAWARA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KUCHAMAN CITY, NAGAUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KOTA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KAROLI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, JODHPUR",
  "IASE UNIVERSITY SARDARSAHAR, CHURU",
  "HARI SEWA SANSKRIT SHIKSHAK PRASHIKSHAN VIDYALAYA BHILWARA",
  "GURUKUL POLYTECHNIC COLLEGE, CHUMU JAIPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, JHUNJHUNU",
  "GURMEET SINGH GHANSHYAM DASS SHIKSHAK PRASHIKSHAN KANYA VIDYALYA, SRIGANGANAGAR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, JHALAWARAPATAN",
  "GOVINDAM TEACHER'S TRAINING SCHOOL",
  "GOVINDAM POLYTECHNIC COLLEGE, SIKAR",
  "GOVERNMENT WOMAN POLYTECHNIC COLLEGE, UDAIPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, JAISALMER",
  "GOVERNMENT WOMAN POLYTECHNIC COLLEGE, SANGANER JAIPUR",
  "PARADISE POLYTECHNIC COLLEGE, SIKER",
  "VINAYAK COLLEGE OF EDUCATION SUNDARPURA",
  "KESHAV PARAMEDICAL COLLEGE BHILWARA",
  "MARUTI ANUKAMPA INSTITUTE OF NURSING SUJANGARH CHURU    ",
  "MLD COLLEGE OF NURSING EDUCATION KEKRI    ",
  "PODDAR BUSINESS SCHOOL",
  "SIDDHANT INSTITUTE OF NURSING ",
  "SUDHA INSTITUTE OF PARAMEDICAL SCIENCES",
  "SIDDARTH PARAMEDICAL COLLEGE UDAIPUR",
  "GOVERNMENT POLYTECHNIC COLLEGE, JALORE",
  "UMD MAHARANI COLLEGE FOR PARAMEDICAL,VINAYAK PATH,NINDOLA , CHOMU , JAIPUR",
  "PINK PEARL PARAMEDICAL COLLEGE,REENGUS    ",
  "SRIJAN MANAV SHIKSHA AVAM KALYAN SANSTHAN",
  "STATE INSTITUTE OF HOTEL MANAGEMENT, DHOLPUR",
  "MR PARAMEDICAL COLLEGE",
  "NEW INDIAN INSTITUTE OF PARAMEDICAL SCIENCE    ",
  "SHRI KRISHAN INSTITUTE OF EDUCATION BSTC",
  "SHRI DEVNARAYAN SPECIAL TEACHER TRAINING CENTER, HURDA, BHILWARA",
  "SHRI DEV SPECIAL TEACHER TRAINING CENTER, SHAHPURA, BHILWARA",
  "SHRI DEV SPECIAL TEACHER TRAINING CENTER ASIND",
  "R N T T COLLEGE SYAOU, GOVINDGARH, JAIPUR RAJASTHAN",
  "NAMAN HOSPITAL AND INSTITUTE OF PARAMEDICAL SCIENCE",
  "JAI BABA AMARNATH PARAMEDICAL COLLEGE",
  "SHRI RAM SPECIAL TEACHER TRAINING COLLEGE",
  "IMPERIAL COLLEGE OF PARAMEDICAL SCIENCES",
  "BRAJ PARAMEDICAL RESEARCH INSTITUTE",
  "DHAKAR PARAMEDICAL COLLEGE    ",
  "BHANDARI INSTITUTE OF MEDICAL SCIENCES",
  "JUBIN NURSING SCHOOL",
  "VASUNDHARA MAHILA SHIKSHAK PRASHIKSHAN VIDYALAYA",
  "VIRAJ SPECIAL EDUCATION TEACHER TRAINING COLLEGE KUCHAMAN CITY",
  "APEX SCHOOL OF PARAMEDICAL SCIENCES,APEX UNIVERSITY",
  "LAUGH N LEARN COLLEGE OF PARAMEDICAL SCIENCE",
  "CAMBRIDGE NURSING AND PARAMEDICAL INSTITUTE",
  "SARASWATI PARAMEDICAL INSTITUTE, DAUSA",
  "AYUSHMAN COLLEGE OF PARAMEDICAL SCIENCE",
  "DH COLLEGE OF PARAMEDICAL, LUNIYAWAS, TEHSIL SANGANER, JAIPUR",
  "RAJASHAN NURSING AND PARAMEDICAL INSTITUTE, SITHAL",
  "L N MEMORIAL PARAMEDICAL INSTITUTE, BHALERI ROAD CHURU",
  "GLOBAL COLLEGE OF PHARMACY",
  "ROYAL SHIKSHAK PRASHIKSHAN CENTRE",
  "MKD COLLEGE OF EDUCATION",
  "RAGHUKUL SCHOOL OF NURSING",
  "SHRI GOVIND COLLEGE OF PARAMEDICAL    ",
  "THE NIGHTINGALES INSTITUTE OF PARAMEDICAL SCIENCE JAIPUIR    ",
  "GOVINDAM  COLLEGE OF PARAMEDICAL SCIENCE    ",
  "SKD PARAMEDICAL COLLEGE",
  "STECH COLLEGE OF PARAMEDICAL",
  "PR COLLEGE OF PARAMEDICAL AND RESEARCH INSTITUTE    ",
  "DPM INSTITUTE OF PARAMEDICAL SCIENCE HALENA ROAD SARSENA WEIR BHARATPUR ",
  "PARMANAND TRILOKCHAND REHABILITATION CENTER SUJANGARH",
  "SAMARPAN TEACHER TRAINING INSTITUTE",
  "LOVELY MAMTA SPECIAL COLLEGE OF EDUCATION",
  "GAURAV COLLEGE OF PARAMEDICAL SCIENCES",
  "SANSKAR BHARTI INSTITUTE OF PARAMEDICAL SCIENCE, HANTRA NADBAI , BHARATPUR",
  "S.S.M.PARA MEDICAL COLLEGE TARANAGAR",
  "MADHUR SPECIAL PRASHIKSHAN SANSTHAN CHURU",
  "PACIFIC COLLEGE OF PARAMEDICAL SCIENCE",
  "SOCIAL DEVELOPMENT AND EDUCATION SOCIETY",
  "ASHA DEVI INSTITUTE OF NURSING CHURU",
  "PARAMEDICAL DEAPRTMENT SHEKHAWATI AYURVED MEDICAL COLLEGE PILANI",
  "SUNROSE SHIKSHAK PRASHIKSHAN MAHAVIDYALYA SAGWARA",
  "PANNADHAY PARAMEDICAL COLLEGE TONK",
  "VIVEKANAND SCHOOL OF BSTC GHATOL",
  "MODERN PARAMEDICAL COLLEGE",
  "APEX INSTITUTE OF PARAMEDICAL SCIENCE AND RESEARCH, KOTA",
  "MT COLLEGE OF PARAMEDICAL SCIENCES, JAIPUR",
  "CAMBRIDGE NURSING INSTITUTE, SIMANI, JHUNJHUNU",
  "RAVINDRA INSTITUTE OF NURSING",
  "BASANT COLLEGE OF PARAMEDICAL SCIENCES",
  "VIDHYASTHALI SHIKSHAN PRASHIKSHAN SANSTHAN",
  "VIVEK VARDHANI SHIKSHA AVN MANO VIKAS SEVA SAMITI",
  "NATIONAL EDUCATION AND WELFARE SOCIETY TEACHER TRAINING",
  "BANDHAN SANSTHAN",
  "TAJ MEMORIAL TEACHER TRAINING SCHOOL",
  "ANMOL SPECIAL TEACHER TRAINING CENTER",
  "ADITYA INSTITUTE OF REHABILITATION SCIENCE, BANDIKUI",
  "LAUGH N LEARN A ACADEMY OF SPECIAL EDUCATION",
  "AYUSHMAAN COLLEGE OF SPECIAL EDUCATION, DAUSA",
  "SANT SUKH DEV SHAH INSTITUTE OF PARAMEDICAL SCIENCE",
  "SARVODAYA COLLEGE BAGIDORA",
  "S.N. COLLEGE OF EDUCATION",
  "SATGURU TEACHER TRAINING COLLEGE",
  "NAVJYOTI VIKLANG KALYAN EVAM PUNARVAS SANSTHAAN",
  "SAUR CHETNA EVAM URJA VIGYAN SHODH SANSTHAN",
  "VIVEK SHIKSHAK PRASHIKSHAN VIDHYLAYA",
  "SHRI BL COLLEGE OF PARAMEDICAL SCIENCES CHOMU JAIPUR",
  "SHRI SAI BABA COLLEGE OF PARAMEDICAL SCIENCES",
  "TAK SHIKSHA NIKETAN GIRLS BSTC AJMER",
  "MATRIX PARAMEDICAL COLLEGE",
  "SHRI BALAJI INSTITUTE OF PARAMEDICAL",
  "MAHATMA GANDHI SCHOOL OF TEACHER TRAINING, BADLIYA, GHATOL, BANSWARA",
  "THE PEOPLE PARAMEDICAL COLLEGE",
  "SAURABH SCHOOL OF NURSING",
  "SHREE BHADARIYA RAY SHIKSHAN SANSTHAN",
  "SARVODAYA GIRLS COLLEGE NAYA PADARIYA KALINJARA",
  "ALANKAR MAHILA TEACHERS TRAINING SCHOOL JAIPUR",
  "SHRI KALYAN SPECIAL TEACHER CENTER",
  "SATYAM SPECIAL TEACHER TRAINING CENTER",
  "CKRD MEMORIAL SCHOOL OF NURSING ",
  "AMRITA DEVI SCHOOL OF NURSING,BALOTRA",
  "SHRI BANKE BIHARI PARAMEDICAL COLLEGE , NEAR KHEM KARAN CHAURAHA,MATHURA ROAD , BHARATPUR",
  "AMRITAM LIVE STOCK ASSISTANT DIPLOMA TRAINING INSTITUTE BATAWADI TEHSIL ANTA BARAN",
  "CKRD MEMORIAL PARAMEDICAL INSTITUTE",
  "GOVERNMENT WOMEN POLYTECHNIC COLLEGE TAPUKARA",
  "SHREE VINAYAK INSTITUTE OF MEDICAL TECHNOLOGY AND NURSING EDUCATION ",
  "REHAN PUBLIC SHIKSHAN SANSTHA,DANTA",
  "GOVERNMENT POLYTECHNIC COLLEGE BEAWAR",
  "balaji institutue of education",
  "PANNADHAY HEARING IMPAIRED TEACHERS TRAINING CENTER TONK",
  "GOVERNMENT POLYTECHNIC COLLEGE NIWAI",
  "Shri Aanasagar STC College",
  "SHREE KARANI SHEKHSNIK SAMAJIK AND DIVYANG KALYAN SAMITI",
  "SHREENATH BSTC SCHOOL , BARI SADRI",
  "AMBIKA TEACHER TRAINING COLLEGE STC COLLEGE MALSISAR JHUNJHUNU",
  "SHEKHAWATI SHIKSHAN SANSTHAN",
  "NAVJEEVAN SHIKSHAN SANSTHAN",
  "SWEET VOICE WELFARE AND SHIKSHA SOCIETY",
  "RAJESH PILOT SMRITI GRAM UDYOG SHIKSHA SAMITI",
  "SHREE JAGDISH SEVA SANSTHAN TEACHER TRAINING CENTER TONK",
  "Mantram STC",
  "GOVT POLYTECHNIC COLLEGE UCCHAIN",
  "UNIVERSE STC COLLEGE",
  "TILAK INSTITUTE OF PARAMEDICAL SCIENCES",
  "B LAL INSTITUTE OF PARAMEDICAL AND HEALTH SCIENCE",
  "Pt. BADRI PRASAD SHIKSHAK PRASHIKSHAN MAHAVIDHYALAYA KOLANA,BANDIKUI",
  "P.L.DUBEY MEMORIAL S.T.C. COLLEGE",
  "MAI KHADIJA INSTITUTE OF PARAMEDICAL SCIENCES, JODHPUR",
  "DR DAYAL INSTITUTE OF PARAMEDICAL TECHNOLOGY",
  "HANUMANGARH PARAMEDICAL COLLEGE",
  "Aryan polytechnic college Kota",
  "GNM TRAINING SCHOOL, GANGTOK",
  "CARMEL TEACHER TRAINING INSTITUTE EAST SIKKIM",
  "CENTRE FOR COMPUTERS & COMMUNICATION TECHNOLOGY (CCCT) CHISOPANI SOUTH SIKKIM (POLYTECHNIC)",
  "DIET GANGTOK",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION",
  "District Institute Of Education And Training",
  "ADVANCED TECHNICAL TRAINING CENTRE BARDANG, EAST SIKKIM",
  "DIET,west",
  "JOHN TEACHER TRAINING INSTITUTE KULITALAI",
  "MARUTHI POLYTECHNIC COLLEGE MANIVIZHUNDAN SOUTH",
  "JOSEPH CHELLAMUTHU TEACHER TRAINING INSTITUTE KEERAMBUR",
  "EBENEZER TEACHER TRAINING INSTITUTE, THOOTHUKUDI",
  "JPKM, SCHOOL OF NURSING, VELLORE",
  "J R POLYTECHNIC COLLEGE, TIRUCHIRAPPALLI",
  "EIT POLYTECHNIC COLLEGE SALANGAPALAYAM",
  "KALAI BHARATHI TEACHER TRAINING INSTITUTION SHOLINGHUR",
  "KALAIMAHAL TEACHER TRAINING INSTITUTE, NAGAPATINAM",
  "ELUMALAI POLYTECHNIC COLLEGE KOLIYANUR",
  "KALAIVANAR N S K POLYTECHNIC COLLEGE CHENBAGARAMANPUTHOOR",
  "KALAPANDIAN POLYTECHNIC COLLEGE SILLAMARATHUPATTI, THENI",
  "KALIMAHAL TEACHER TRAINING INSTITUTE FOR WOMAN SEMBANARKOIL THARANGAMBADI",
  "KAMARAJ POLYTECHNIC COLLEGE NEENDAKARAI-A",
  "ELUMALAIYAN POLYTECHNIC COLLEGE KOLLUMANGUDI",
  "KAMATCHI POLYTECHNIC COLLEGE POTHAVUR, TRICHY",
  "KANCHI SHRI KAMATCHI AMMAN TEACHERS TRAINING INSTITUTE MANGAI KOOT ROAD",
  "KANIKAI MATHA TEACHER TRAINING INSTITUTE NARASINGAPURAM POST KONDARASAMPALAYAM DHARAPURAM",
  "KARIGIRI SCHOOL OF NURSING VELLORE",
  "K A R POLYTECHNIC COLLEGE -",
  "KARTHIKEYAN TEACHER TRAINING INSTITUTE ANTHANAPETTAI",
  "M.M POLYTECHNIC COLLEGE",
  "KARTHIKEYA POLYTECHNIC COLLEGE KANNUDAYANPATTI",
  "KARUNYAA TEACHER TRAINING INSTITUTE KUMPINIPET",
  "KA SO KA POLYTECHNIC COLLEGE",
  "EXCEL SCHOOL OF NURSING TIRUNELVELI",
  "KASTURBA GANDHI SCHOOL OF NURSING VILLAPURAM",
  "KEERAI THAMIL SELVAN TEACHER TRAINING INSTITUTE SATHIYAMANGALAM",
  "EZHIL TEACHER TRAINING INSTITUTE SALEM",
  "K E T POLYTECHNIC COLLEGE, KRISHNAGIRI",
  "K.K.S.MANI POLYTECHNIC COLLEGE VALLAM",
  "K L NAGASAMY MEMORIAL POLYTECHNIC COLLEGE VIRAGANOOR POST",
  "FLORENCE NIGHTINGALE SCHOOL OF NURSING TIRUVANNAMALAI",
  "K.M.G. POLYTECHNIC COLLEGE ANGALA KURICHI",
  "KOLANDHAVEL TEACHER TRAINING INSTITUTE THIPPAMPATTI POLLACHI",
  "F X POLYTECHNIC COLLEGE THARUVAI",
  "KONAGAR NADU NURSING AND INSTITUTE OF MEDICAL TECHNOLOGY, THANJAVUR",
  "KONGHU VELALAR POLYTECNIC COLLEGE PATTAKARNPALAYAM",
  "GANAPATHY TEACHER TRAINING INSTITUTE, MELAKAVANUR, RAMNAD",
  "KONGU HI-TEK POLYTECHNIC COLLEGE, KARUR",
  "KONGUNADU POLYTECHNIC COLLEGE D.GUDALORE, DINDIGUL",
  "KONGUNADU POLYTECHNIC COLLEGE THOLURPATTI",
  "GANDHI POLYTECHNIC COLLEGE VINNAPPALLI",
  "KONGU POLYTECHNIC COLLEGE PERUNDURAI",
  "KOTTAI MARIYAMMAN POLYTECHNIC COLLEGE MINNAMPALLI",
  "KRISHNA HOSPITAL SCHOOL OF NURSING CUDDALORE",
  "GANDHI TEACHER TRAINING INSTITUTE, ERODEWrite institute Name here...",
  "KRISHNA TEACHER TRAINING INSTITUTE KATTINAYANAPALLI",
  "K R SCHOOL OF NURSING COIMBATORE",
  "PANNAI PARAMEDICAL COLLEGE",
  "GANGAA POLYTECHNIC COLLEGE KANAKAGIRI",
  "GOVT POLYTECHNIC COLLEGE FOR WOMEN -MADAKKULAM",
  "MASS TEACHER TRAINING SCHOOL DARASURAM KUMBAKONAM",
  "MATHA TEACHER TRAINING INSTITUTE THAMARAIPULAM VEDARANIYAM",
  "MATHERI TEACHER TRAINING INSTITUTE BAZAAR STREET KAVERIPAKKAM",
  "MEENAAKSHI RAMASAMY POLYTECHNIC COLLEGE THATHANUR",
  "MEENAKSHIAMMAL POLYTECHNIC COLLEGE MALLIYANKARANAI",
  "M I E T Polytechnic College",
  "MEENAKSHI AMMAL TEACHER TRAINING INSTITUTE PERUNKOZHI MALLIANKARANAI UTHIRAMERUR",
  "MEENAKSHI KRISHNAN POLYTECHNIC COLLEGE PAMMAL",
  "MEENAKSHI POLYTECHNIC COLLEGE SFNO.44, DHARMAPURI",
  "MEENAKSHI RAMASAMY TEACHER TRAINING INSTITUTE THATHANUR UDYARPALYAM",
  "MEENATCHI GOVINDARAJAN POLYTECHNIC COLLEGE",
  "MERCY TEACHER TRAINING INSTITUTE CHIDAMBARAM",
  "MERIT TEACHER TRAINING INSTITUE GOMATHI NAGA AMBASAMUDRAM",
  "M E T TEACHER TRAINING INSTITUTE CHENBAGARAMANPUTHUR",
  "M.I.T. POLYTECHNIC COLLEGE NAVAPATTY",
  "M K RAMAN TEACHER TRAINING INSTITUTE CHIDAMBARAM",
  "M M INSTITUTE OF MEDICAL SCIENCES, SCHOOL OF NURSING, TIRUPPUR",
  "MNSK POLYTECHNIC COLLEGE ALANGUDI",
  "MODERATOR GNANADASAN POLYTECHNIC COLLEGE VADASERY",
  "MODERN POLYTECHIC COLLEGE, MAHAIMAIPURAM, UDAYARPALAYAM",
  "MODERN TEACHER TRAINING INSTITUTE JAYANKONDAM",
  "MOHAMED SATHAK POLYTECHNIC COLLEGE MAYAKULAM",
  "MORNING STAR POLYTECHNIC COLLEGE ALOOR",
  "MOTHER TERESA POLYTECHNIC COLLEGE ILLUPPUR",
  "MRK POLYTECHNIC COLLEGE, CUDDALORE",
  "M S Polytechnic College",
  "MUNA INSTITUTE OF EDUCATION PARANGIPETTI",
  "MURUGAPPA POLYTECHNIC COLLEGE THIRUMULLAIVOIL",
  "MURUGESAN INSTITUTE OF TECHNOLOGY KARUMAPURAM",
  "MUSIRI INSTITUTE OF TECHNOLOGY M PUDUPATTI",
  "MUTHAYAMMAL POLYTECHNIC COLLEGE KAKKAVERI",
  "MUTHAYAMMAL POLYTECHNIC INSTITUTION, NAMAKKAL",
  "PARK AMC POLYTECHNIC COLLEGE",
  "MUTHIAH POLYTECHNIC COLLEGE ANNAMALAINAGAR",
  "NACHIAPPA SWAMIGAL POLYTECHNIC COLLEGE KOVILOOR",
  "NACHIMUTHU POLYTECHNIC COLLEGE POLLACHI",
  "NADAR MAHAJANA SANGAM VIMALA CHELLADURAI POLYTECHNIC COLLEGE, MALLAMPALAYAM, DHARAPURAM",
  "NAGAMMAI TEACHER TRAINING INSTITUTE PERIYAR NAGAR",
  "NAGA SIVA POLYTECHNIC COLLEGE VIRATHANOOR",
  "NAIRS TEACHER TRAINING INSTITUTE AMMANS NAGAR",
  "N A MANJAMMAL POLYTECHNIC COLLEGE RAJAPALAYAM",
  "NANDHA POLYTECHNIC COLLEGE VEPPAMPALAYAM",
  "NANJAPPA INSTITUTE OF TECHNOLOGY KARUMATHAMPATTI",
  "NANJIAH LINGAMMAL POLYTECH COLLEGE CHIKKADASAM PALAYAM",
  "NARASIMMA PALLAVAN POLYTECHNIC COLLEGE THIMMA SAMUDRAM",
  "NAYAGI INSTITUTE OF NURSING VELLORE",
  "NEHRU COLLEGE OF AERONAUTICS & APPLIED SCIENCES COIMBATORE",
  "NETHAJI SUBASH CHANDRA BOSE POLYUTECHNIC COLLEGE KEELAKAVATHUKUDY",
  "NOVA TEACHER TRAINING INSTITUTE . SELVAPURAM, , COIMBATORE",
  "NPA CENTENARY POLYTECHNIC COLLEGE",
  "SACRED HEART TEACHER TRAINING INSTITUTE PUDUPALAYAM",
  "OM SHANTHI TEACHER TRAINING INSTITUTE GOVINDUMETT PERAMBUDUR",
  "O.P.R. MEMORIAL INSTITUTE OF TEACHER TRAINING VADALUR",
  "ORIENTAL TEACHER TRAINING INSTITUTE UTHANGUDI NEAR MATTUTHAVANI BUS STAND",
  "OUR LADY SCHOOL OF NURSING DINDIGUL",
  "OXFORD TEACHER TRAINING INSTITUTE, TRICHY",
  "PAAVAI POLYTECHNIC COLLEGE PACHAL",
  "PAAVENDHAR POLYTECHNIC COLLEGE MINIVIZHUNDHAN SOUTH",
  "P A C RAMASAMY RAJA POLYTECHNIC COLLEGE VENGANALLUR PANCHAYAT",
  "PADALESUWARAR POLYTECHNIC COLLEGE MANJAKUPPAM",
  "PALANIAMMAL TEACHER TRAINING INSTITUTE POLLACHI",
  "PALLAVAN POLYTECHNIC COLLEGE KOLIVAKKAM",
  "PANDIYAN POLYTECHNIC COLLEGE ADHIYUR VILLAGE",
  "P A POLYTECHNIC COLLEGE POLLACHI",
  "PARAMVEER POLYTECHNIC COLLEGE PAPPARAPATTY",
  "PARIMALA PANDURANGAN POLYTECHNIC COLLEGE, CHITHATHUR, WALAJAPET",
  "PASTOR LENSSEN POLYTECHNIC COLLEGE KUTHENKULY",
  "PATTAMMAL SCHOOL OF NURSING, KUMBAKONAM",
  "PAVENDAR BHARATHIDASAN POLYTECHNIC COLLEGE MATHUR",
  "PEE GEE POLYTECHNIC COLLEGE NO",
  "PERIYAR CENTENARY POLYTECHNIC COLLEGE VALLAM",
  "PERIYAR TEACHER TRAINING INSTITUTE PERIYAR MALIGAI PUTHUR",
  "PET POLYTECHNIC COLLEGE ACHAMPADU",
  "PGP POLYTECHNIC COLLEGE",
  "PIONEER SCHOOL OF NURSING RAMANATHAPURAM",
  "SDS POLYTECHNIC COLLEGE",
  "SREE KUMARAGURU POLYTECHNIC COLLEGE HARUR",
  "SREE NARAYANAGURU POLYTECHNIC COLLEGE MADUKKARAI",
  "SANDARAVADHANAM TEACHER TRAINING INSTITUTEKATTUMANNARKOIL",
  "SREE SREENIVAASAR TEACHER TRAINING INSTITUTE PANAGUDI",
  "SREE VAIKUNDAR POLYTECHNIC COLLEGE PILLAYARPURAM, KANYAKUMARI",
  "SANKARA POLYTECHNIC COLLEGE SARAVANAMPATTY",
  "S R G POLYTECHNIC COLLEGE ATHANUR",
  "SRI ADHISANKARAR POLYTECHNIC COLLEGE IRUNGALUR",
  "SRI ADHISANKARAR TEACHER TRAINING INSTITUTE MANNACHANALLUR",
  "SANKAR POLYTECHNIC COLLEGE SANKARNAGAR",
  "SRI ANNAI ABHIRAMI POLYTECHNIC COLLEGE, PUDUKKOTTAI",
  "SRI ANNAI POLYTECHNIC COLLEGE, VELLORE",
  "S A POLYTECHNIC COLLEGE THIRUVERKADU",
  "SRI AYYAPPA POLYTECHNIC COLLEGE AIVADHUGUDI",
  "SRI BALAJI POLYTECHNIC COLLEGE CHENGALPET",
  "SARAH TEACHER TRAINING INSTITUTE FOR GIRLS PONN STREET NANJAI UTHUKKULI",
  "SRI BALAJI TEACHERS TRAINING INSTITUTE SWAMY EDUCATIONAL TRUST CHROMEPET",
  "SRI BALAJI TEACHER TRAINING INSTITUTE FOR WOMEN CHERANMAHADEVI",
  "SRI BALAKRISHNA POLYTECHNIC COLLEGE DHARAPURAM",
  "SARAH TUCKER TEACHER TRAINING INSTITUTE PALAYAMKOTTAI",
  "SRI BALAMURUGAN POLYTECHNIC COLLEGE THALAYUTHU",
  "SRI BHARATHI POLYTECHNIC COLLEGE FOR WOMEN KAIKKURICHI",
  "SRI BHARATHI TEACHER TRAINING INSTITUTE, ILLUPPUR, PUDUKOTTAI",
  "S.A. RAJAS POLYTECHNIC COLLEGE ADANKARKULAM",
  "SRI BHARATHI TEACHER TRAINING INSTITUTE (W), PUDUKOTTAI",
  "SRI BHARATHI VELU POLYTECHNIC COLLEGE MELVENKATAPURAM",
  "SRI DEVI TEACHER TRAINING INSTITUTE KRISHNAPURAM PONNERI",
  "SRI DURGA DEVI POLYTECHNIC COLLEGE KHIZL MUDALAM BEDU",
  "SASTHAA TEACHER TRAINING INSTITUTE THIRUMAYAM",
  "SRI DURGA SCHOOL OF NURSING PUDUKKOTTAI",
  "SRI ISSAC NEWTON TEACHER TRAINING INSTITUTE KADAMBADY",
  "SASTHA POLYTECHNIC COLLEGE KEELANILAIKKOTTAI",
  "SRI JEYA SCHOOL OF NURSING VELLORE",
  "SRI KARPAGA POLYTECHNIC COLLEGE KANCHIPURAM",
  "SATHIYASAI TEACHER TRAINING INSTITUTE PATTABIRAM",
  "SRI K.RAMACHANDRA NAIDU TEACHER TRAINING INSTITUTE SANKARANKOVIL",
  "Sri Krishna Polytechnic College, Kovaipudur",
  "SBM POLYTECHNIC COLLEGE",
  "SRI KRISHNA POLYTECHNIC COLLEGE SEVUGAMPATTI",
  "SRI KRISHNA POLYTECHNIC COLLEGE VADAMAMBAKKAM",
  "SCAD POLYTECHNIC COLLEGE CHERANMAHADEVI",
  "SRI KRISHNA TEACHER TRAINING INSTITUTE ARAKKONAM",
  "SRI KUMARAN SCHOOL OF NURSING, CHENNAI",
  "SCAD TEACHER EDUCATION INSTITUTE CHERANMAHADEVI",
  "SRI LAKSHMI TEACHER TRAINING INSTITUTE VELAYUTHA NAGAR JAYANKONDAM",
  "SRI MAHALAKSHMI POLYTECHNIC COLLEGE POONDIYANKUPPAM, CUDDALORE",
  "SRI MAHALAKSHMI TEACHERS TRAINING INSTITUTE FOR WOMEN PALLADAM TIRUPUR",
  "SCHOOL OF NURSING, COIMBATORE MEDICAL COLLEGE & HOSPITAL, COIMBATORE",
  "SRI MOOGAMBIGAI POLYTECHNIC COLLEGE, HOSUR MAIN ROAD, MADHAMPATTI",
  "SRI MOOKAMBIGAI SCHOOL OF NURSING, TIRUCHIRRAPPALLI",
  "SCHOOL OF NURSING, CSI RAINY MULTISPECIALITY HOSPITAL, CHENNAI",
  "SRI MUTHALAMMAN POLYTECHNIC COLLEGE THELICHATHANALLUR",
  "SRI NALLALAGHU POLYTECHNIC COLLEGE THANDAL KALANI",
  "SRINIVASA POLYTECHNIC COLLEGE KALAMAVUR",
  "SCHOOL OF NURSING, DURGABAI DESHMUKH GENERAL HOSPITAL & RESEARCH CENTRE, CHENNAI",
  "SRI PADMAM POLYTECHNIC COLLEGE PACHAL",
  "MADRAS SCHOOL OF ECONOMICS",
  "S R I POLYTECHNIC COLLEGE BIRUDUR",
  "SCHOOL OF NURSING, EX-MINISTER K. RAJARAM NAIDU PARA MEDICAL INSTITUTITONS, MADURAI",
  "SRI RAGAVENDRA POLYTECHNIC COLLEGE KOMARAPALAYAM",
  "ST. MICHAEL TEACHER TRAINING INSTITUTE KALAIYARKOIL",
  "SRI RAGHAVENDRA INSTITUTE OF TEACHER EDUCATION K. SINGARAKOTTAI",
  "SCHOOL OF NURSING, GOVERNMENT ANNAL GANDHI MEMORIAL HOSPITAL, TIRUCHIRAPPALLI",
  "SRI RAGHAVENDRA SCHOOL OF NURSING, NAGAPATTINAM",
  "SRI RAJIV GANDHI POLYTECHNIC COLLEGE MYLADI",
  "SRI RAMACHANDIRA TEACHER TRAINING INSTITUTE VEDARANIAM",
  "SRI RAMACHANDRA POLYTECHNIC COLLEGE, DHARMAPURI",
  "SCHOOL OF NURSING, GOVERNMENT HEADQUARTERS HOSPITAL, CUDDALORE",
  "SRI RAMAKRISHNA MISSION VIDYALAYA GANDHI T.T.I. PERIANAICKENPALAYAM",
  "SRI RAMAKRISHNA MISSION VIDYALAYA POLY. COLLEGE GUDALUR",
  "SRI RAMAKRISHNA POLYTECHNIC COLLEGE -IDIGARAI PANCHAYAT",
  "SCHOOL OF NURSING, GOVERNMENT HEADQUARTERS HOSPITAL, DINDIGUL",
  "SRI RAMAKRISHNA POLYTECHNIC COLLEGE KOOTHAMBAKKAM",
  "ST JUDES POLYTECHNIC COLLEGE, ANNAI NAGAR, VILAVANCODE",
  "ST MARK S TEACHER TRAINING INSTITUTE MADUKKARAI",
  "ST MARYS HOSPITAL & INSTITUTE OF BIO-MEDICAL TECHNOLOGY, TIRUVANNAMALAI",
  "ST MARYS SCHOOL OF NURSING COIMBATORE",
  "ST MARYS TEACHER TRAINING INSTITUTE CHENGALPATTU",
  "ST. MARYS TEACHER TRAINING INSTITUTE FOR WOMEN VICKRAMASINGAPURAM",
  "ST.MICHAEL POLYTECHNIC COLLEGE KALAYARKOIL",
  "ST.MICHAELS TEACHER TRAINING INSTITUTE PALANI",
  "ST. THERESA (G)TEACHER TRAINING INSTITUTE, THARANGAMBADI, NAGAPATINAM",
  "ST THERESA OF CHILD JESUS SCHOOL OF NURSING CHENNAI-",
  "ST. THERESAS TEACHER TRAINING INSTITUTE VIRAHANUR",
  "TEACHER TRAINING INSTITUTE CHIDAMBARAM",
  "ST XAVIERS POLYTECHNIC COLLEGE MULLIKKUNDU, DEVAKOTTAI",
  "ST XAVIERS POLYTECHNIC COLLEGE SEYDUNGANALLUR",
  "ST. XAVIERS TEACHER TRAINING INSTITUTE ALANGUDI",
  "TELC TEACHER TRAINING INSTITUTE FOR MEN THARAGAMBADI",
  "SUBRAMANIAN POLYTECHNIC COLLEGE -",
  "SUDARSAN POLYTECHNIC COLLEGE -SATHIYAMANGALAM",
  "SHREE MARUTHI POLYTECHNIC COLLEGE MANIVIZHUNDAN SOUTH",
  "SUDHARSHANA POLYTECHNIC COLLEGE KALIPATTI",
  "TELC TEACHER TRAINING INSTITUTE FOR WOMEN USILAMPATTI",
  "SUGUNA POLYTECHNIC COLLEGE -KALAPATTI",
  "SUN INSTITUTE OF TECHNOLOGY ERACHAKULAM",
  "TERESA TEACHER TRAINING INSTITUTE ILLUPUR",
  "ANM TRAINING SCHOOL AT MULTIPURPOSE HEALTH WORKERS (FEMALE) TRAINING SCHOOL TRIPLICANE CHENNAI",
  "SUN POLYTECHNIC COLLEGE ERACHAKULAM",
  "SURABI SCHOOL OF NURSING DINDIGUL",
  "THAAI POLYTECHNIC COLLEGE T.VADIPATTI, MADURAI",
  "SURYA POLYTECHNIC COLLEGE KEEZHAKONDAI",
  "JESU POLYTECHNIC COLLEGE, KALLALANGUDI",
  "S.VEERASAMY CHETTIAR INSTITUTE OF TEACHER EDUCATION PULIANGUDI",
  "THAI MOOGAMBIGAI POLYTECHNIC COLLEGE MOGAPPAIR",
  "SVS POLYTECHNIC COLLEGE RAMADEVAM",
  "SWAMI VIVEKANANDA POLYTECHNIC COLLEGE",
  "SWAMI VIVEKANANDA TEACHER TRAINING INSTITUTE ARUMBAVUR VEPANTHATTAI",
  "SWAMY ABEDHANANDHA POLYTECHNIC COLLEGE THELLAR",
  "THANAPANDIYAN POLYTECHNIC COLLEGE UCHAPATTI",
  "TAMILNADU CHRISTIAN REVIVIAL MISSION ORGANISATION, SCHOOL OF NURSING, PERAMBALUR",
  "THANGAM MUTHU POLYTECHNIC COLLEGE ENDAPULI KAMATCHIPURAM",
  "THANTHAI ROEVER INST. OF POLYTECHNIC COLLEGE ELAMBALUR",
  "THE CHRISTIAN INST FOR TECH EDN POLY COLLEGE ODDANCHATRAM",
  "THE INDIAN POLYTECHNIC COLLEGE SADAIYANERI AZHAGANERI",
  "THE KARUR POLYTECHNIC COLLEGE ANDAN KOIL EAST",
  "THE KAVERY POLYTECHNIC COLLEGE M KALIPATTI",
  "THE KEVIN POLYTECHNIC COLLEGE VILLAGE",
  "THE KONGHU POLYTECHNIC COLLEGE MUKKUTHIPALAYAM",
  "THENI KAMMAVAR SANGAM POLYTECHNIC COLLEGE KODUVILARPATTI",
  "THE SALEM POLYTECHNIC COLLEGE GAJALNAICKENPATTY",
  "THEVANESAM ERUDHAYA AMMAL POLYTECHNIC COLLEGE, VEMBAR",
  "VIVEKANANDA POLYTECHNIC COLLEGE SEPLANATHAM, CUDDALORE",
  "V.J.P TEACHER TRAINIING INSTITUTION SIRUGANUR",
  "THIAGARAJAR POLYTECHNIC COLLEGE JAGIR AMMAPALAYAM - MEYYANOOR",
  "VOICE OF GOD POLYTECHNIC COLLEGE, DEVARAYAPURAM",
  "V P MUTHEIAH PILAI MEENAKSHIAMMAL TEACHER TRAINING KRISHNANKOIL",
  "THIRUMAGAL POLYTECHNIC COLLEGE, VANCHUVANCHERY, SRIPERUMBUDUR",
  "V RAMAKRISHNA POLYTECHNIC COLLEGE THIRUVOTTIYUR",
  "VSK TEACHER TRAINING INSTITUTE THIRUMAYAM",
  "THIRUMALAI POLYTECHNIC COLLEGE KANCHIPURAM",
  "V.V. TEACHER TRAINING INSTITUTE MILLERPURAM",
  "WILLIAMÂ SCHOOL OF NURSING, NAGERCOIL, KANYAKUMARI",
  "THIRUMALAI SRINIVASA PARA MEDICAL INSTITUTE, TIRUCHIRAPPALLI",
  "V.K.P. POLYTECHNIC COLLEGE, TENKASI",
  "THIRUMATHI ELIZABETH POLYTECHNIC COLLEGE ANNAMANGALAM",
  "THIRU RAMAKRISHNA NALLAMMAI POLYTECHNIC COLLEGE NANJIYAMPALAYAM",
  "THIRU SEVEN HILLS POLYTECHNIC COLLEGE -MADURAVOYAL",
  "THIRUTHANI POLYTECHNIC COLLEGE LAKSHMAPURAM",
  "THIRUVALLUVAR POLYTECHNIC COLLEGE SOOLAPPURAM",
  "VELLALAR TEACHER TRAINING INSTITUTE THINDAL",
  "VELLORE POLYTECHNIC COLLEGE OYYATHUR, VELLORE",
  "VELUDAYAR SCHOOL OF EDUCATION TEACHER TRAINING INSTITUTE MEIPPORUL NAGAR",
  "VENKATESVARA TECHER TRAINING INSTITUTE THIRUMAIRAYASAMUTHIRAM",
  "VENKATESWARA POLYTECHNIC COLLEGE KAIKKURICHI",
  "VENKATESWARA SCHOOL OF NURSING, THANJAVUR",
  "VENKATRAMANA POLYTECHNIC COLLEGE, KARUR",
  "VESTLEY INSTITUTE OF DIPLOMA IN TEACHER EDUCATION ARANTHANGI",
  "VESTLEY TEACHER TRAINING INSTITUTE FOR WOMEN ARANTHANGI",
  "VETHATHIRI MAHARISHI INSTITUTE OF TECHNOLOGY KODIVALASAI ATHIMANJERI PET",
  "PRIME TEACHER TRAINING INSTITUTE KLLVELUR",
  "VETRI VINAYAHA POLYTECHNIC COLLEGE THOTTIAM",
  "THIRUMALAI MADHANUR POLYTECHNIC COLLEGE PALUR",
  "VALLIAMMAI POLYTECHNIC COLLEGE KATTANKULATHUR",
  "VIGNESHWARA POLYTECHNIC COLLEGE CHIDAMBARAM, CUDDALORE",
  "MCC BOYD TANDON SCHOOL OF BUSINESS    ",
  "VINAYAGAS INSTITUTE OF TEACHER EDUCATION ARIYALUR",
  "VINAYAGA TEACHER TRAINING INSTITUTE CUDDALORE",
  "VINAYAKA MISSIONS AVIATION ACADEMY",
  "VIRUDHUNAGAR S.VELLAICHAMY NADAR POLYTECHNIC COLLEGE",
  "QUEEN MARYS ANM TRAINING SCHOOL",
  "Government Polytechnic College, Chrompet, Chennai",
  "ANTARCTICA COLLEGE OF PHARMACY",
  "E.S Polytechnic College",
  "ORANGE TREE SCHOOL OF NURSING ANM",
  "THIAGARAJAR SCHOOL OF BUSINESS",
  "ASHWINI ADIVASI SCHOOL OF NURSING",
  "KRISHNASAMY MEMORIAL POLYTECHNIC COLLEGE",
  "AISHWARYA POLYTECHNIC COLLEGE PARUVACHI",
  "MUGIL COLLEGE OF PARAMEDICAL SCIENCE",
  "ALAGAPPA POLYTECHNIC COLLEGE -KARAIKUDI",
  "SAT SCHOOL OF NURSING",
  "AL-AMAN TEACHER TRAINING INSTITUTE RAJENDRAPURAM",
  "AL AMEEN POLYTECHNIC COLLEGE ERODE",
  "MURUGA POLYTECHNIC COLLEGE MELUR",
  "BALA VIHAR TRAINING SCHOOL     ",
  "AVINASI GOUNDER MARIAMMALTEACHER TRAINING INSTITUTE KOLLAMPALAYAM",
  "SIVAKUMAR SCHOOL OF NURSING VELLORE",
  "SIVANTHI TEACHER TRAINING INSTITUTE, UDANKUDI, THOOTHUKUDI",
  "N.M. POLYTECHNIC COLLEGE PUDUKKOTTAI",
  "SIVANTHI TEACHER TRAINING INSTITUTION KUNDRATHUR",
  "SIVA PARAMEDICAL SCHOOL OF NURSING, COIMBATORE",
  "A M K TECHNOLOGY POLYTECHNIC COLLEGE CHEMBARAMBAKKAM",
  "SKA TEACHER TRAINING INSTITUTE MEENACHISUNDARNAD ST AUNDIPATTY",
  "NADAR MAHAJANA SANGAM COLLEGE OF PHARMACY",
  "KUMARAN POLYTECHNIC COLLEGE ARIYUR, PUDUKKOTTAI",
  "MARUDHAM TEACHER TRAINING INSTITUTE VELACHERY",
  "E R K INSTITUTE OF PARAMEDICAL SCIENCE SCHOOL OF NURSING ANM",
  "VETHAMONICKAM MEMORIAL C.S.I. POLYTECHNIC COLLEGE",
  "GOVERNMENT POLYTECHNIC COLLEGE, RAGHUNATHAPURAM, PAPANASAM T.K",
  "SRI ANNAMALAI COLLEGE OF NURSING",
  "St.Marys Teacher Training Institute, Anmadurai",
  "SIR ISSAC NEWTON POLYTECHNIC COLLEGE -PAPPAKOIL",
  "VIDHYALAKSHMI POLYTECHNIC  COLLEGE",
  "S K SCHOOL OF NURSING FOR WOMEN NAGAPATTINAM",
  "S M ARUMUGAM POLYTECHNIC COLLEGE DHARMAPURI",
  "GOVT SCHOOL OF AYUSH PARAMEDICAL COURSES",
  "S M S POLYTECHNIC COLLEGE, VIRUDHUNAGAR",
  "AMMAIAPPAR POLYTECHNIC COLLEGE, MEENATCHIYAPURAM",
  "S.M.S. TEACHER TRAINING INSTITUTE SIVAKASI",
  "SOORIYA SCHOOL OF NURSING CHENNAI",
  "ANBARASU INST OF MEDICAL AND RESEARCH, CHENNAI",
  "ANDAVAR TEACHER TRAINING INSTITUTE FIRST BEACH LINE ROAD",
  "ANGEL POLYTECHNIC COLLEGE, RAJAPALAYAM",
  "ANNA ADARSH TEACHER TRAINING INSTITUTE PONNERI",
  "ANNAI ARPUTHAM INSTITUTE OF DIPLOMA IN NURSING NAMAKKAL",
  "ANNAI COLLEGE OF POLYTECHNIC KOVILACHERI. KOVILACHERI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, PERAMBALUR",
  "JAYAM SCHOOL OF NURSING THANJAVUR",
  "ANNAI J K K SAMPOORANIAMMAL POLYTECHNIC COLLEGE GOBICHETTIPALAYAM",
  "ANNAI J.K.K. TEACHER TRAINING INSTITUTE, KOMARAPALAYAM, NAMAKKAL",
  "ANNAI MADHA POLYTECHNIC COLLEGE TITTAGUDI",
  "ANNAI TEACHER TRAINING INSTITUTE KOVILACHERRY KUMBAKONAM",
  "ANNAI TERESA SCHOOL OF NURSING & PARAMEDICAL SCIENCES ARIYALUR",
  "ANNAI THERESSA, SCHOOL OF NURSING, SALEM",
  "SHRI SAI BABA POLYTECHNIC COLLEGE",
  "ANNAI VEILANKANNI TEACHER TRAINING INSTITUTE PUDUR",
  "ANNAI VELANKANNI POLYTECHNIC COLLEGE ANGUCHETTYPALAYAM",
  "GOODSAMARITAN TTI",
  "ANNAI VELU TEACHER TRAINING INSTITUTE",
  "ANNAMALAI POLYTECHNIC COLLEGE CHETTINAD",
  "ANNDAVAR POLYTECHNIC COLLEGE ALUKKULI",
  "DON BOSCO POLYTECHNIC COLLEGE- BASIN BRIDGE",
  "S.S.K. POLYTECHNIC COLLEGE",
  "E.G.S.PILLAY POLYTECHNIC COLLEGE",
  "APOLLO POLYTECHNIC COLLEGE -PANRUTI VILLAGE",
  "ARASU POLYTECHNIC COLLEGE",
  "PSV POLYTECHNIC COLLEGE",
  "AKY POLYTECHNIC COLLEGE",
  "PERUNTHALAIVAR K KAMARAJAR POLYTECHNIC COLLEGE",
  "CHERAN POLYTECHNIC COLLEGE, KADACHANALLUR",
  "VINAYAKA SCHOOL OF NURSING SALEM",
  "VIGNESH POLYTECHNIC COLLEGE KIZHKACHIRAPET",
  "ARASAN GANESAN POLYTECHNIC COLLEGE AMATHUR",
  "ARAVINDAR POLYTECHNIC COLLEGE AMBATHURAI",
  "KURINJE POLYTECHNIC COLLEGE",
  "VIDYA VIKAS PLUS TEACHER TRAINING INSTITUTE UDUMBIAM",
  "ARCOT SRI MAHALAKSHMI WOMENS INSTITUTE OF TTI ARCOT",
  "SRI VATSA SCHOOL OF NURSING",
  "VIDYA VIHAR TEACHER TRAINING INSTITUTE AMBUR",
  "ARINGAR ANNA TEACHER TRAINING INSTITUTE, THOOTHUKUDI",
  "VIDHYA VIKAS TEACHER TRAINING INSTITUTE TIRUCHENGODE",
  "ANM TRAINING SCHOOL, REGIONAL TRAINING INSTITUTE OF PUBLIC HEALTH CAMPUS, THIRUVARANKULAM",
  "N H SCHOOL OF NURSING NAGAPATTINAM",
  "SIGA POLYTECHNIC COLLEGE EGMORE",
  "V G SCHOOL OF NURSING COIMBATORE",
  "ARINGAR ANNA TEACHER TRAINING INSTITUTE VEDARANIAM",
  "SUTHANTHIRA POLYTECHNIC COLLEGE, NATARAJAPURAM, KALAYARKOIL",
  "SRI RENUGAMBAL POLYTECHNIC COLLEGE ETTIVADI",
  "SRI RENGESWARAR TEACHER TRAINING INSTITUTE POTTI RETTI PATTI",
  "SRI RENGESWARAR POLYTECHNIC COLLEGE POTTIREDDIPATTI",
  "SRI RENGA POLYTECHNIC COLLEGE MANNACHANALLUR",
  "SRI RANGANATHAR INSTITUTE OF POLYTECHNIC COLLEGE ATHIPALAYAM",
  "SRI RANGABOOPATHY TEACHER TRAINING INSTITUTE, VILLUPURAM",
  "SIVAKASI INSTITUTE OF PRINTING TECHNOLOGY",
  "SITARAJARAM POLYTECHNIC COLLEGE",
  "SAHAYA MATHA TEACHER TRAINING INSTITUTE KALAIYARKOIL",
  "SADASIVAM KATHIRKAMAVALLI POLYTECHNIC COLLEGE NO.27, THIRUVARUR",
  "OOLIYASTHANAM TEACHER TRAINING INSTITUTE",
  "N.V. POLYTECHNIC COLLEGE SOMAVARAPATTI",
  "N P R POLYTECHNIC COLLEGE PUNNAPATTI",
  "MAHARAJA POLYTECHNIC COLLEGE ARALIPATTI VILAKKU, SIVAGANGAI",
  "LOYOLA INSTITUTE OF BUSINESS ADMINISTRATION",
  "I R T SCHOOL OF NURSING ERODE",
  "EXCEL POLYTECHNIC COLLEGE PALLAKKAPALAYAM",
  "EVEREST POLYTECHNIC COLEGE EVEREST NAGAR, TIRUNELVELI",
  "E S SUBARAMANIAM TEACHER TRAINING INSTITUTE, PODATTURPET, THIRUVALLUR",
  "ER PERUMAL MANIMEKALAI POLYTECHNIC COLLEGE SHOOLAGIRI",
  "ERODE KONGU COLLEGE OF POLYTECHNIC CHENNIMALAI",
  "CLAUDINE SCHOOL OF NURSING DINDIGUL",
  "C I T SANDWICH POLYTECHNIC COLLEGE SINGANALLUR",
  "AL ISLAMIYA POLYTECHNIC COLLEGE",
  "AL-HIDHAYA WOMENS TREACHER TRAINING INSTITUTE TENKASI",
  "SRI VENKATACHALAPATHY POLYTECHNIC COLLEGE VADAKUCHIPALAYAM",
  "RAJALAKSHMI SCHOOL OF BUSINESS",
  "BLOCK INSTITUTE OF TEACHER EDUCATION",
  "VIDHYA SAGAR WOMENS TEACHER TRAINING INSTITUTE CHENGALPATTU",
  "ACT TEACHER TRAINING INSTITUTE",
  "RUKMANI TEACHER TRAINING INSTITUTE",
  "GRG POLYTECHNIC COLLEGE KUPPEPALAYAM",
  "GOVERNMENT POLYTECHNIC COLLEGE, KOODUVELI",
  "CHOLAN INSTITUTE OF TECHNOLOGY SEMBARAMBAKKAM",
  "CHOZHAN TEACHER TRAINING INSTITUTE KANCHEEPURAM",
  "CHRISTARAJA TEACHER TRAINING INSTITUTE",
  "CHRISTIAN TEACHER TRAINING INSTITUTE PERAMBALUR",
  "CHRIST THE KING INSTI. OF TECHNOLOGY OTHAKKALMANDAPAM",
  "CHURCH PARK ANGLO INDIAN TEACHER TRAINING SCHOOL ANNA SALAI CHENNAI",
  "C.M.ANNALMALAI POLYTECHNIC COLLEGE R K PET",
  "INSTITUTE OF TEXTILE TECHNOLOGY CHENNAI",
  "CMS POLYTECHNIC COLLEGE CMS NAGAR, NAMAKKAL",
  "CONCORDIA TEACHER TRAINING INSTITUTE AMBUR VELLORE",
  "C P C L POLYTECHNIC COLLEGE MANALI",
  "CRESCENT YOUSUF ZULAIKHA SCHOOL OF NURSING, MADURAI",
  "CRESENT TEACHER TRAINING INSTITUTE, SEETHAKATHI NAGAR, MADURAI",
  "CSI HOSPITAL SCHOOL OF NURSING, ERODE",
  "INSTITUTE OF CERAMIC TECHNOLOGY VRIDHACHALAM",
  "DR.SIVANTHI ADHITHANAR TEACHER TRAINING INSTITUTE, TIRUCHENDUR., THOOTHUKUDI",
  "INSTITUTE OF CHEMICAL TECHNOLOGY RAJA ANNAMALAI PURAM",
  "INSTITUTE OF LEATHER TECHNOLOGY -",
  "DR THANGAMMA SCHOOL OF NURSING VELLORE",
  "IRUTHAYA ANDAVAR TEACHER TRAINING INSTITUTE, KARRUPPUR, TANJAVUR",
  "JAI RUPA TEACHER TRAINING INSTITUTE TIRUPPUR",
  "JAYAM POLYTECHNIC COLLEGE NALLANUR",
  "DR.VELLASWAMY NADAR TEACHER TRAINING SCHOOL THANJAVUR",
  "JAYANTHI PADMANABA TEACHER TRAINING INSTITUTE SRISUSHNAM",
  "JAYANTHI TEACHER TRAINING INSTITUTE TIRUPUR",
  "DUSI POLYTECHNIC COLLEGE DUSI VILLAGE - POST",
  "JAYA POLYTECHNIC COLLEGE -NADUKUTHAGAI",
  "JAYARAJ ANNAPACKIAM CSI POLYTECHNIC COLLEGE NAZARETH",
  "JAYARAM POLYTECHNIC COLLEGE KARATTAMPATTY-PAGALAVADI",
  "JEEVAN POLYTECHNIC COLLEGE, MANAPPARAI",
  "JEEVAN TEACHER TRAINING INSTITUTE MANAPPARI",
  "JEEVAS POLYTECHNIC COLLEGE, COIMBATORE",
  "JENNEYS ACADEMYOF TOURISM AND HOTEL MANAGEMENT K- KALLIKUDI",
  "JEYA POLYTECHNIC COLLEGE",
  "JEYARAM TEACHER TRAINING INSTITUTE, TRICHY",
  "J.J. POLYTECHNIC COLLEGE AMMAPETTAI",
  "D.V.D. TEACHER TRAINING INSTITUTE KANYAKUMARI",
  "J J TEACHER TRAINING INSTITUTE J J NAGAR SIVAPURAM NAMASAMUDRAM",
  "J K TEACHER TRAINING INSTITUTE KUNNAKURUMBI ARANTHANGI",
  "JOHN BOSCO POLYTECHNIC COLLEGE TIRUVALLUR",
  "EASWAR POLYTECHNIC COLLEGE",
  "VAANI POLYTECHNIC COLLEGE, VELLORE",
  "SCHOOL OF NURSING, GOVERNMENT HEADQUARTERS HOSPITAL, THE NILGIRIS",
  "SCHOOL OF NURSING, GOVERNMENT HEADQUARTERS HOSPITAL, RAMANATHAPURAM",
  "SCHOOL OF NURSING, GOVERNMENT HEADQUARTERS HOSPITAL, NAGAPATTINAM",
  "SRI RAM NALLAMANI YADAVA TEACHER TRAINING INSTITUTE KANJARAMPETTAI",
  "SCHOOL OF NURSING, GOVERNMENT HEADQUARTERS HOSPITAL, KANCHEEPURAM",
  "SRI RAMANA INSTITUTE OF POLYTECHNIC COLLEGE MOOLAIKARAIPATTI",
  "R.D.B. TEACHER TRAINING INSTITUTE PAPANASAM",
  "SRI RAMAKRISHNA POLYTECHNIC COLLEGE -SIRUVACHIUR",
  "SREE KRISHNA POLYTECHNIC COLLEGE VADASERY",
  "BPR SCHOOL OF NURSING, VELLORE",
  "SANDARAVADHANAM SCHOOL OF NURSING CUDDALORE",
  "BABA TEACHER TRAINING INSTITUTE KAYATHAR",
  "A.K.T. MEMORIAL POLYTECHNIC COLLEGE KALLKURICHI",
  "KMR COLLEGE OF PHARMACY",
  "BARATHIARS CENTENARYMEMORIAL WOMENS POLYTECH COLLEGE -ETTAYAPURAM",
  "BAKTHAVATCHALAM POLY. COLLEGE KARAIPETTAI",
  "RVREHA POLYTECHNIC COLLEGE",
  "AYYAPPA POLYTECHNIC COLLEGE AIVADHUGUDI",
  "AYYA NADAR JANAKI AMMAL POLYTECHNIC COLLEGE CHINNAKKAMANPATTI",
  "AVVAIL SCHOOL OF NURSING, KANCHEEPURAM",
  "AVM School of Nursing, Thoothukudi",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING ADUTHURAI THANJAVUR",
  "HINDUSTHAN POLYTECHNIC COLLEGE OTHAKKALMANDAPAM, COIMBATORE",
  "DHIVYA POLYTECHNIC COLLEGE CHETPET",
  "DHANALAKSHMI SRINIVASAN TEACHER TRAINING INSTITUTE, PERAMBALUR",
  "DHANALAKSHMI SRINIVASAN POLYTECHNIC COLLEGE PERAMBALUR",
  "SRI RAMACHANDRA POLYTECHNIC COLLEGE, DHARMANEETHI",
  "ANDAVAR PARA MEDICAL INSTITUTION",
  "DEVARAJAN TEACHER TRAINING INSTITUTE NAGAPATTINAM",
  "DEVANGAR POLYTECHNIC COLLEGE, THENI",
  "MANGAYARKARASI TEACHER TRAINING INSTITUTE",
  "ARIES POLYTECHNIC COLLEGE KURUNJIPADI",
  "DEVAMATHA SCHOOL OF NURSING NILGIRI",
  "C.S.S.R TEACHER TRAINING INSTITUTE, MURUGA BHAVANAM, DINDIGUL",
  "C.S.I. TEACHER TRAINING INSTITUTE FOR WOMEN SALEM",
  "CSI TEACHER TRAINING INSTITUTE, ERODE",
  "C S I POLYTECHNIC COLLEGE SALEM",
  "CSI MISSION GENERAL HOSPITAL, TIRUCHIRAPPALLI",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION, TARAMANI, CHENNAI",
  "TVM ACADEMY OF HEALTH SCIENCE",
  "S. VEERASAMY CHETTIAR POLYTECHNIC COLLEGE TN PUDUKKUDI VILLAGE",
  "DISTRICT INSTITUTE OF EDUCATION AND  TRAINING COIMBATORE",
  "SRS POLYTECHNIC COLLEGE",
  "VIVEKANANDA TEACHER TRAINING INSTITUTE",
  "INSTITUTE OF TOOL ENGINEERING ADIYANUTHU",
  "PARK GLOBAL SCHOOL OF BUSINESS EXCELLENCE CHENNAI",
  "RAMAKRISHNA MISSION POLYTECHNIC COLLEGE CHENNAI",
  "TVM ACADEMY OF HEALTH SCIENCE ANM",
  "VASANTHA MURUGU POLYTECHNIC COLLEGE",
  "RAJAS TEACHER TRAINING INSTITUTE VIDAKANGULAM",
  "HINDUSTAN INSTITUTE OF ENGINEERING TECHNOLOGY ALANDUR",
  "RAJA SADHA BAKKIYAM TEACHER TRAINING SCHOOL UDAYARPALAYAM",
  "RAJAPALAYAM DEIVANAI AMMAL TEACHER TRAINING INSTITUTE SALEM ROAD",
  "RAJAMMAL SCHOOL OF NURSING, VELLORE",
  "HAJI S.M.S. SHAIK JALALUDEEN TEACHER TRAINING INSTITUTE THANJAVUR",
  "RAJAMMAL RANGASAMY ELEMENTARY TTI TIRUCHENGODE",
  "GURU RAAGAVINDRA POLYTECHNIC COLLEGE VEPPOOR VILLAGE",
  "RAJALAKSHMI POLYTECHNIC COLLEGE -SOMASIPADI",
  "GUDIYATTAM POLYTECHNIC COLLEGE KAKATHOPPU VILLAGE",
  "RAJAJI INSTITUTE OF TECHNOLOGY VEERAPANDI",
  "RAJAGOPAL POLYTECHNIC COLLEGE KONDASAMUDRAM",
  "ST MARY'S SCHOOL OF NURSING TIRUNELVELI",
  "RAJA DESINGH POLYTECHNIC COLLEGE KALAIYUR",
  "GREAT LAKES INSTITUTE OF MANAGEMENT",
  "RAGAS SCHOOL OF NURSING, CHENNAI",
  "P V POLYTECHNIC COLLEGE PELAKUPPAM",
  "G.R.DAMODARAN TECHER TRAINING INSTITUTE COIMBATORE",
  "PUNITHA ANNAL TEACHER TRAINING INSTITUTE FOR WOMEN KEERANUR",
  "P T LEE CHENGALVARAYA NAICKER POLYTECHNIC COLLEGE PURASAIWALKAM",
  "PSV POLYTECHNIC COLLEGE MIRATUNILAI, PUDUKKOTTAI",
  "P S R POLYTECHNIC COLLEGE APPAYANAYAKEN PATTI",
  "G.P. POLYTECHNIC COLLEGE PALNANGUPPAM",
  "P.S.N. POLYTECHNIC COLLEGE -MELATHEDIYOOR",
  "P.S.N INSTITUTE OF TECHNOLOGY MARUNGOOR",
  "P.S.G.PONNAMMAL POLYTECHNIC COLLEGE",
  "P.S.G PONAMMAL TEACHER TRAINING INSTITUTE KANGAYAM",
  "P S G POLYTECHNIC COLLEGE PEELAMEDU",
  "Central Institute of Petrochemicals Engineering & Technology (CIPET), Madurai",
  "PONNAIYAH RAMAJAYAM POLYTECHNIC COLLEGE VALLAM",
  "PONNAIYAH RAMAJAYAM POLYTECHNIC COLLEGE KEELAPALAYUR VILLAGE",
  "P.K.D. TTI POLLACHI",
  "MASS POLYTECHNIC COLLEGE KALLAPULIYUR",
  "MARY IMMACULATE TEACHER TRAINING INSTITUTE VELLORE TIRUPATTUR",
  "GOVT POLYTECHNIC COLLEGE FOR WOMEN -COIMBATORE",
  "MARUTAM NELLI POLYTECHNIC COLLEGE DALAVAHALLI",
  "SEETHALAKSHMI SCHOOL OF NURSING, ERODE",
  "MARTHR DEVASAGAYAM TTI UNNAMALAIKADAI",
  "GOVERNMENT TECHNICAL TRAINING CENTRE GUINDY, CHENNAI",
  "MANORA POLYTECHNIC COLLEGE KOTTAKUDI, PATTUKKOTTAI",
  "GOVERNMENT TEACHER TRAINING INSTITUTE SAMUGARAENGAPURAM TIRUNELVELI",
  "PARK GLOBAL SCHOOL OF BUSINESS EXCELLENCE COIMBATORE",
  "MANICKAM TEACHER TRAINING INSTITUTE CHARLES NAGAR SHESAIYA ROAD",
  "MANGALAM TEACHER TRAINING INSTITUTE VICTORY AVENUE THIRUMULLAIVOYAL",
  "GOVERNMENT TEACHER TRAINING INSTITUTE GANGAVALLI SALEM",
  "MANGALAM TEACHER TRAINING INSTITUTE MANGALAM NAGAR ANTHIYUR",
  "MANGALAM TEACHER TRAINING INSTITUTE BHUVANAGIRI CHIDAMBARAM",
  "M A M POLYTECHNIC COLLEGE -",
  "SRI ANNAMALAI POLYTECHNIC COLLEGE PADUR",
  "MAHENDRA TEACHER TRAINING INSTITUTE VALAPADI",
  "MAHENDRA POLYTECHNIC COLLEGE VADUGAPALAYAM",
  "GOVERNMENT TEACHER TRAINING INSTITUTE FOR WOMEN THANJAVUR",
  "MAHENDHIRA TEACHER TRAINING INSTITUTE TIRUCHENGODE",
  "GOVERNMENT TEACHER TRAINING INSTITUTE FOR WOMEN ROYAPETTAH CHENNAI",
  "KUMAR JOTHI COLLEGE OF NURSING",
  "MAHATMA GANDHI TEACHER TRAINING INSTITUTE NORTH STREET SOLAISERI REDDIAPATTI SANKARANKOIL",
  "MAHATH AMMA POLYTECHNIC COLLEGE ARIYUR",
  "MAHARISHI VIDYAMANDIR TEACHER TRAINING INSTITUTE KK NAGAR",
  "GOVERNMENT TEACHER TRAINING INSTITUTE FOR WOMEN RANIPET VELLORE",
  "MAHARANI TEACHER TRAINING INSTITUTE MANJIYAMPALAYAM DHARAPURAM",
  "MAHARANI POLYTECHNIC COLLEGE NANJIYAMPALAYAM",
  "LITTLE FLOWER POLYTECHNIC COLLEGE MOULIVAKKAM",
  "APOLLO SCHOOL OF NURSING, CHENNAI",
  "GOVERNMENT TEACHER TRAINING INSTITUTE FOR WOMEN COIMBATORE",
  "LATHA MADHAVAN POLYTECHNIC COLLEGE KIDARIPATTI",
  "GOVERNMENT TEACHER TRAINING INSTITUTE FOR WOMEN CHINNADHARAPURA KARUR",
  "LALGUDI CO OPERATIVE POLYTECHNIC COLLEGE LALGUDI",
  "Government Polytechnic College, Bargur",
  "Government Polytechnic College, Tirunelveli",
  "GOVERNMENT TEACHER TRAINING INSTITUTE FOR BOYS JOHILPATTI VIRUDHUNAGAR",
  "LAKSHMINARAYANA SCHOOL OF NURSING, DHARMAPURI",
  "GOVERNMENT POLYTEHCNIC COLLEGE NO.27 THIRUKOILUR, VILLUPURAM",
  "SHRI SITHESWARAR POLYTECHNIC COLLEGE",
  "LAKSHMI NARAYANA POLYTECHNIC COLLEGE PAGALAHALLI",
  "LAKSHMI AMMAL TEACHER TRAINING INSTITUTE TINDIVANAM ROAD",
  "TEXCITY COLLEGE OF PHARMACY",
  "PARIMALA PANDURANGAN COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC COLLEGE, USILAMPATTI",
  "LAKSHMI AMMAL TEACHER TRAINING INSTITUTE, , KANCHIPURAM",
  "LAKSHMIAMMAL POLYTECHNIC COLLEGE NALATTINPUTHUR",
  "GOVERNMENT POLYTECHNIC COLLEGE UDHAGAMANDALAM",
  "KUNDAVAII SCHOOL OF NURSING THANJAVUR",
  "KUMUTHA TEACHER TRAINING INSTITUTE K.A. JANAGARTHINAM NAMBIYUR",
  "GOVERNMENT POLYTECHNIC COLLEGE TRICHY THUVAKUDIMALAI",
  "KUMARAN POLYTECHNIC COLLEGE THENMATHUR",
  "KUMARAN POLYTECHNIC COLLEGE, KNAKKAR STREET, PONNERI",
  "GOVERNMENT POLYTECHNIC COLLEGE THOOTHUKUDI",
  "KUMARAN COLLEGE OF MEDICAL SCIENCES & RESEARCH INSTITUTE, VELLORE",
  "GOVERNMENT POLYTECHNIC COLLEGE, THIRUVANNAMALAI",
  "GOVERNMENT POLYTECHNIC COLLEGE PWD CAMPUS, THIRUVARUR",
  "GOVERNMENT POLYTECHNIC COLLEGE PURASAWALKAM OTTERI",
  "GOVERNMENT POLYTECHNIC COLLEGE OORVANI",
  "GOVERNMENT POLYTECHNIC COLLEGE NAGERCOIL",
  "GOVERNMENT POLYTECHNIC COLLEGE MELUR, MADURAI",
  "GOVERNMENT POLYTECHNIC COLLEGE KOTTUR, THENI",
  "GOVERNMENT POLYTECHNIC COLLEGE KEELAKANAVAI, PERAMBALUR",
  "GOVERNMENT POLYTECHNIC COLLEGE KATTINAYANAPPALLI",
  "GOVERNMENT POLYTECHNIC COLLEGE KANIYALAMPATTI, KARUR",
  "U.S.P. POLYTECHNIC COLLEGE KODIKURICHI",
  "GOVERNMENT POLYTECHNIC COLLEGE COIMBATORE",
  "Government polytechnic college , Cheyyar",
  "SRI RAMACHANDRA COLLEGE OF PHARMACY VEDARANIAM",
  "SUBBASAKTHI INSTITUTE OF PARAMEDICAL SCIENCE",
  "GOVERNMENT POLYTECHNIC COLLEGE, MOHANUR",
  "GOVERNMENT POLYTECHNIC COLLEGE BOOMANDAHALLI VILLAGE, DHARMAPURI",
  "SOLAMALAI TEACHER TRAINING INSTITUTE FOR WOMEN",
  "BLOCK INSTITUTE OF TEACHER EDUCATION ,PAVUNJUR",
  "GOOD SHEPHERD TEACHERS TRAINING INSTITUTE",
  "GOVERNMENT POLYTECHNIC COLLEGE",
  "C S JAIN COLLEGE OF PHARMACY",
  "GOMATHI AMBAL POLYTECHNIC COLLEGE MALAIYADIKURICHI",
  "GOLDEN POLYTECHNIC COLLEGE PALLAKKADU VILLAGE, SALEM",
  "GNANODAYA TEACHER TRAINING INSTITUTE ST.THOMAS MOUNT CHENNAI",
  "K S R POLYTECHNIC COLLEGE THOKKAVADI",
  "GMS MAVMM POLYTECHNIC COLLEGE NAICKEN PATTI",
  "K S RENGASAMY INSTITUTE OF TECHNOLOGY THOKKAVADI",
  "K.S.M. POLYTECHNIC COLLEGE PAPAMADAI, SIVAGANGAI",
  "INSTITUTE OF PRINTING TECHNOLOGY KALIKUNDRAM",
  "MASS POLYTECHNIC COLLEGE V PARANGANI",
  "GIRIVAASAN POLYTECHNIC COLLEGE PAPPURAPATTY, DHARMAPURI",
  "RDB SCHOOL OF NURSING AND PARAMEDICAL SCIENCE ,PAPANASAM",
  "K.S.MANIAM INSTITUTE OF TEACHER TRAINING CENTRE MOHANUR ROAD",
  "THE KALAKSHETRA FOUNDATION, CHENNAI",
  "K.S.K TEACHER TRAINING INSTITUTE KUMBAKONAM",
  "GOVERNMENT POLYTECHNIC COLLEGE VANAVASI",
  "INFANT JESUS TEACHER TRAINING INSTITUTE, MULAGUMOODU, KANYAKUMARI",
  "SHRI BHARATHI COLLEGE OF NURSING ANM TRAINING SCHOOL",
  "DR RADHAKRISHNA TEACHER TRAINING INSTITUTE VELLORE",
  "INDRA GANESAN TEACHER TRAINING INSTITUE TIRUCHIRAPALLI",
  "GOVT POLYTECHNIC COLLEGE, VALANGAIMAN 612804",
  "SVA COLLEGE OF POLYTECHNIC",
  "SERVITE ANM (F) TRAINING SCHOOL",
  "SYED AMMAL SCHOOL OF NURSING (WOMEN)",
  "GOVERNMENT POLYTECHNIC COLLEGE,KADATHUR",
  "NANDHA TEACHER TRAINING INSTITUTE PITCHANDAM PALYAM",
  "DR. RADHAKRISHNAN TEACHER TRAINING INSTITUTE VILLUPURAM",
  "INDIRA TEACHERS TRAINING INSTITUTE THIRUVALLUR",
  "IMMANUVEL ARASAR TEACHER TRAINING INSTITUTE, , KANYAKUMARI",
  "SAGAYAMATHA ANM (F) TRAINING SCHOOL",
  "DR. M.G.R POLYTECHNIC COLLEGE IRUMBEDU",
  "ANM TRAINING SCHOOL, MANICKAMPALAYAM",
  "IMAYAN TEACHER TRAINING INSTITUTE, TRICHY",
  "IMAYAM POLYTECHNIC COLLEGE KANNANUR",
  "HOLLY CROSS TEACHER TRAINING INSTITUTE, SAMUGARENGAPURAM, THIRUNELVELI",
  "DR MARIA ASCHHOFF SCHOOL OF NURSING TIRUVANNAMALAI",
  "DR. KALAM POLYTECHNIC COLLEGE PERIYANAYAKI PURAM, THANJAVUR",
  "DR DHARMAMBAL GOVERNMENT POLYTECHNIC COLLEGE FOR WOMEN THARAMANI",
  "DR AMANULLAH EDUCATIONAL TRUST, SCHOOL OF NURSING, ERODE",
  "DR ALVA PARAMEDICAL EDUCATIONAL INSTITUTE COIMBATORE",
  "D P C POLYTECHNIC COLLEGE -PAGALPATTI",
  "DON BOSCO POLYTECHNIC COLLEGE THIRUKAZHUKUNDRAM",
  "DKT TEACHER TRAINING INSTITUTE , TIRUPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING VILLUPURAM",
  "THIRUVALLUVAR POLYTECHNIC COLLEGE VELLAMADAI",
  "THIRUVIUM TEACHER TRAINING INSTITUTE PERIYAKULAM ROAD",
  "THOZHILATHIBAR TEACHER TRAINING INSTITUTE EDAMALAI PATTI PUDUR",
  "TIRUMALA POLYTECHNIC COLLEGE, TIRUVANNAMALAI",
  "T.J.S POLYTECHNIC COLLEGE, THIRUVALLUR",
  "TMT RAJAMANIAMMAL EDUCATIONAL TRUST, TRICHY",
  "T P E V R GOVT. POLYTECHNIC COLLEGE SIVARAMAPURAM",
  "T S SRINIVASAN POLYTECHNIC COLLEGE AND CENTRE FOR ADVANCED VANAGARAM",
  "UDAYA INSTITUTE OF TECHNOLOGY NEENDAKARAI - B",
  "COLLEGE OF ALLIED MEDICAL SCIENCES",
  "UDAYA POLYTECHNIC COLLEGE NEENDAKARAI B",
  "UDHAYAM POLYTECHNIC COLLEGE THANGACHIMADAM",
  "UMA MAHESWARANAR TEACHER TRAINING INSTITUTE KARANTHAI",
  "UNION CHRISTIAN POLYTECHNIC COLLEGE EDAICODE",
  "UNION TEACHER TRAINING INSTITUTE NORTH ARCOT",
  "VADARANYAM TEACHER TRAINING INSTITUTE TIRUVALLUR",
  "VALIVALAM DESIKAR INSTITUTE OF TEACHER TRAINING SOUTH PALPANNAICHERRY",
  "VALIVALAM DESIKAR POLYTECHNIC COLLEGE NAGAPATTINAM",
  "VALLALAR TEACHER TRAINING INSTITUTE GUDIYATTAM",
  "VANDAYAR POLYTECHNIC COLLEGE PULAVARNATHAM",
  "VARADHARAJAN POLYTECHNIC COLLEGE, MUTHAL VARISAIPATTI, KUNNAM",
  "VASU TEACHER TRAINING INSTITUTE TIRUNAGAR",
  "VEERALAKSHMI TEACHER TRAINING INSTITUTE FOR WOMEN ALANGUDY",
  "VIVEKANADA POLYTECHNIC COLLEGE, SIVAGANGAI",
  "VIVEKANANDA POLYTECHNIC COLLEGE, KANYAKUMARI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING TIRUCHIRAPALLI",
  "BLOCK INSTITUTE OF TEACHER EDUCATION",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING THIRUVARUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING THENI",
  "ST. JOSEPHS TEACHER TRAINING INSTITUTE SATANKULAM PANDARAPURAM",
  "NELLIANDAVAR INSTITUTE OF POLYTECHNIC",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING SALEM",
  "TAMILNADU POLYTECHNIC COLLEGE -",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING NAGAPATTINAM",
  "ST.JOSEPHS TEACHER TRAINING INSTITUTE FOR WOMEN SURAMANGALAM PAGALPATTY",
  "ST JOSEPHS SCHOOL OF NURSING, KRISHNAGIRI",
  "VETRI POLYTECHNIC COLLEGE",
  "GOVERNMENT POLYTECHNIC COLLEGE UTHANGARAI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING KANCHEEPURAM",
  "ARIFA POLYTECHNIC COLLEGE KEEZHAIYUR",
  "SESHASAYEE INSTITUTE OF TECHNOLOGY ARIYAMANGALAM",
  "ST.JOSEPHs  POLYTECHNIC COLLEGE PAPPU NAGAR, DINDIGUL",
  "ST JOSEPHS POLYTECHNIC COLLEGE KRISHNAGIRI",
  "GOVERNMENT POLYTECHNIC COLLEGE, SEVVAPET",
  "STATE INSTITUTE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "HI-TECH POLYTECHNIC COLLEGE SAMUGARANGAPURAM, TIRUNELVELI",
  "ST.JOSEPH POLYTECHNIC COLLEGE TIRUMAYAM",
  "SENTHUR POLYTECHNIC COLLEGE, NAMBIYUR",
  "KUMARAN ASHARAM MEDICAL TRUST TTI THANJAVUR",
  "ST.JOSEPH POLYTECHNIC COLLEGE PICHANOOR",
  "ST.JOHNS TEACHER TRAINING INSTITUTE NAZARETH",
  "ST.JOHNS TEACHER TRAINING INSTITUTE FOR WOMEN VEERAVANALLUR",
  "SENTHIL TEACHER TRAINING INSTITUTE VRIDDHACHALAM",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING VIRUDHUNAGAR",
  "Firebird Institute of Research in Management",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING VANARAMUTTI TUTICORIN",
  "P S B POLYTECHNIC COLLEGE THIRUPORUR",
  "D N V SCHOOL OF NURSING DHARMAPURI",
  "ST. CHRISTOPHERS TEACHER TRAINING INSTITUTE VEPERY, CHENNAI",
  "ST BENEDICTs SCHOOL OF NURSING FOR WOMEN, TIRUVANNAMALAI",
  "Government Polytechnic College, Gandharvakottai",
  "GOVERNMENT POLYTECHNIC COLLEGE, AUNDIPATTI",
  "SEMBODAI RV TEACHER TRAINING INSTITUTE VEDARANIAM",
  "GOVERNMENT POLYTECHNIC COLLEGE, CHEKKANURANI",
  "KAMARAJAR POLYTECHNIC COLLEGE",
  "GOVERNMENT POLYTECHNIC COLLEGE, SRIRANGAM",
  "STATE INSTITUTE OF COMMERCE EDUCATION CHENNAI",
  "ST ANTONY'S SCHOOL OF NURSING KANYAKUMARI",
  "ST.ANN'S TEACHER TRAINING INSTITUTE ADAIKALAPURAM",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, DHARMAPURI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING VADALUR CUDDALORE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING TRIPLICANE CHENNAI",
  "ST. ANGELAS TEACHER TRAINING INSTITUTE PONAMALAIPATTI",
  "SSR POLYTECHNIC COLLEGE",
  "SSM INSTITUTE OF TEXTILE TECHNOLOGY AND POLYTECHNIC COLLEGE KOMARAPALAYAM - AMANI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING T.KALLUPATTI MADURAI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING TIRUR THIRUVALLUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING RANIPET VELLORE",
  "CHEYYAR POLYTECHNIC COLLEGE KULAMANDHAI",
  "935-JCT POLYTECHNIC COLLEGE",
  "MARIA POLYTECHNIC COLLEGE",
  "GOVERNMENT POLYTECHNIC COLLEGE, KEELAPALUVUR",
  "SRI VIRUTHAMBIGAI TEACHER TRAINING INSTITUTE VRIDDHACHALA",
  "STELLA MARYS TEACHER TRAINING INSTITUTE, SIVAGIRI, THIRUNELVELI",
  "145 GOVERNMENT POLYTECHNIC COLLEGE, PALACODE",
  "SEMBODAI R V POLYTECHNIC COLLEGE SEMBODAI",
  "SRI VIRUTHAMBIGAI SCHOOL OF NURSING CUDDALORE",
  "SRI VINAYAGA POLYTECHNIC COLLEGE PUDHUMOTTUR",
  "SELVAM TEACHER TRAINING INSTITUTE PAPPINAYAKKAN",
  "SRI VIJAY VIDYALAYA TEACHER TRAINING INSTITUTE GANDHI NAGAR",
  "GOVERNMENT POLYTECHNIC COLLEGE, JOLARPET",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING PERUNDURAI ERODE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING NAMAKKAL NAMAKKAL",
  "KMV POLYTECHNIC COLLEGE",
  "SEIKALATHUR KAMATCHIAMMAN POLYTECHNIC COLLEGE SEIKALATHUR",
  "SRI VIGNESH POLYTECHNIC COLLEGE KOOTHUR",
  "SEETHAIAMMAL POLYTECHNIC COLLEGE -",
  "SRI.VIDYA TEACHER TRAINING INSTITUTE P.KUMARALINGAPURAM",
  "SRI VENKATESWARA POLYTECHNIC COLLEGE PARASUR",
  "SCHOOL OF NURSING, TUTICORIN MEDICAL COLLEGE HL,TUTICORIN",
  "SRI VENKATESWARA POLYTECHNIC COLLEGE, KAZHUDUR",
  "SRI VENKATESWARA POLYTECHNIC COLLEGE ADUKKAMPARAI",
  "SRI VENKATESVARA POLYTECHNIC COLLEGE THIRUMALAIRAYASAMUTHIRAM",
  "NADAR MAHASANASANGAM TEACHER TRAINING INSTITUTE, NAGAMALAI, MADURAI",
  "SCHOOL OF NURSING, TIRUNELVELI MEDICAL COLLEGE HL, TIRUNELVELI",
  "SRI VENKATESHWARAA POLYTECHNIC COLLEGE PAPPINAICKANAHALLI",
  "SCHOOL OF NURSING, THANJAVUR MEDICAL COLLEGE HOSPITAL THANJAVUR",
  "SRI VATSA POLYTECHNIC COLLEGE E., VIRUDHUNAGAR",
  "SRI THIYAGARAJA INSTITUTE OF TEACHER EDUCATION THIRUVARUR",
  "SCHOOL OF NURSING, RAJAPALAYAM NURSES TRAINING INSTITUTE, KANYAKUMARI",
  "SRI THIAGARAJAR POLYTECHNIC COLLEGE VALAPPADY",
  "SRI S RAMASAMY NAIDU MEMORIAL POLYTECHNIC COLLEGE E MUTHULINGAPURAM",
  "SRI SOWDAMBIKA POLYTECHNIC COLLEGE ARUPPUKOTTAI",
  "SCHOOL OF NURSING, MOUNT TABOR MEDICAL MISSION HL, PUDUKOTTAI",
  "SRI SITHESWARRAR TEACHER TRAINING INSTITUTE ARCOT",
  "SRI SARADHA TEACHER TRAINING INSTITUTE FOR WOMAN SIRUVACHUR",
  "SRI SANTHOSHI POLYTECHNIC COLLEGE PAIYAMBADI",
  "DON BOSCO POLYTECHNIC COLLEGE KAZHIAPPANALLUR",
  "PASUMPON NETHAJI POLYTECHNIC COLLEGE MELANEELITHANALLUR",
  "M S P V N LAKSHMITHAIAMMAL POLYTECHNIC COLLEGE KEELAPAVOOR",
  "CHENDURAN POLYTECHNIC COLLEGE PILIVALAM",
  "SCHOOL OF NURSING, MAYOR RADHAKRISHNAN INSTITUTE OF PARAMEDICAL SCIENCES, CUDDALORE",
  "SRI SAKTHI POLYTECHNIC COLLEGE CHE-NACHIPATTU",
  "SRI SAIRAM POLYTECHNIC COLLEGE POONTHANDALAM",
  "SCHOOL OF NURSING, KASTURBA HOSPITAL, CHENNAI",
  "S THANGAPAZHAM POLYTECHNIC COLLEGE CHINTHAMANIPERIPUTHUR, TIRUNELVELI",
  "SRI RAM TEACHER TRAINING INSTITUTE VELIPPALAYAM",
  "SRI RAM POLYTECHNIC COLLEGE PERUMALPATTU",
  "SCHOOL OF NURSING, KANYAKUMARI MEDICAL COLLEGE & HOSPITAL, KANYAKUMARI",
  "SCHOOL OF NURSING, GOVERNMENT VELLORE MEDICAL COLLEGE HOSPITAL, VELLORE",
  "SCHOOL OF NURSING, GOVERNMENT THENI MEDICAL COLLEGE HOSPITAL, THENI",
  "SCHOOL OF NURSING, GOVERNMENT STANLEY MEDICAL COLLEGE HOSPITAL, CHENNAI",
  "SCHOOL OF NURSING, GOVERNMENT KILPAUK MEDICAL COLLEGE HOSPITAL, CHENNAI",
  "SCHOOL OF NURSING, GOVERNMENT HEADQUARTERS HOSPITAL, VIRUDHUNAGAR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING MUNANJIPATTI TIRUNELVELI",
  "ST. MARIAM POLYTECHNIC COLLEGE MARANTHAI",
  "SCHOOL OF NURSING, GOVERNMENT HEADQUARTERS HOSPITAL, TIRUPPUR",
  "SREE ARUMUGHAM POLYTECHNIC COLLEGE THOLUDUR",
  "S.PREETHI TEACHER TRAINING INSTITUTE, PADAMATHUR, SIVAGANGAI",
  "SANCTA FATIMA TEACHER TRAINING INSTITUTE NALLAMANNYACKANPATTI",
  "SHRI RAMANAs ABC POLYTECHNIC COLLEGE PALAM RAJAKKAPATTI, DINDIGUL",
  "GOVERNMENT POLYTECHNIC COLLEGE, SANKARAPURAM",
  "SRINIVASA SUBBARAYA POLYTECHNIC COLLEGE ANNAIKARAN CHATARAM",
  "V.J.P. POLYTECHNIC COLLEGE MANNACHANALLUR",
  "ANM TRAINING SCHOOL, GOVERNMENT PRIMARY HEALTH CENTRE CAMPUS, POOVANTHI, THIRUPUVANAM, SIVAGANGAI ",
  "ANM TRAINING SCHOOL, COMMUNICABLE DISEASES HOSPITAL",
  "SAMUVEL POLYTECHNIC COLLEGE MUDIVAITHANEDAL",
  "SHRI KRISHNAA POLYTECHNIC COLLEGE -",
  "RAASI POLYTECHNIC COLLEGE",
  "GOVERNMENT POLYTECHNIC COLLEGE, KELAMANGALAM",
  "KAPI POLYTECHNIC COLLEGE GANDHIGRAM MAMA, DINDIGUL",
  "MERIT POLYTECHNIC COLLEGE, KADAYAM",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING MAYANUR KARUR",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING MANJUR RAMANATHAPURAM",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING MACHUVADI PUDUKOTTAI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KRISHNAGIRI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KOTAGIRI NILGIRIS",
  "GOvernment Polytechnic college, R K nagar",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KILPENNATHUR THIRUVANNAMALAI",
  "SHRI BHARATHI TEACHER TRAINING INSTITUTE ROYAKOTTAH",
  "SHREE VENKATESHWARA HI TECH POLYTECHNIC COLLEGE GOBI",
  "SALEM KONGU POLYTECHNIC COLLEGE VEERAPANDI",
  "SHREENIVASA POLYTECHNIC COLLEGE B PALLIPATTI",
  "SHIVA TEACHER TRAINING INSTITUTE MUSIRI",
  "SAKTHI POLYTECHNIC COLLEGE VEMPATHIVELLALAPALAYAM",
  "SHINY TEACHER TRAINING INSTITUTE CHIDAMBARAM",
  "SHEVAROYS INST OF CATERING AND HOTEL MANAGEMENT YERCAUD",
  "SAKTHI INSTITUTE OF FASHION TECHNOLOGY PERIYAPALAYAM",
  "SHENBAGAM SCHOOL OF NURSING MADURAI",
  "SHANMUGHA POLYTECHNIC COLLEGE TIRUMALAISAMUDRAM",
  "SHAKTHI INSTITUTE OF TEACHER TRAINING & RESEARCH PALAKKANUTHU",
  "SAIRAM TEACHER TRAINING INSTITUTE SIRKALI",
  "SEVEN HILLS TEACHER TRAINING INSTITUTE, KARUMBUR, CUDDALORE",
  "SEVAMANDIR TEACHER TRAINING INSTITUTE FOR WOMEN PARANGIPETTAI",
  "Sah School of Nursing, Thoothukudi",
  "PRIYADARSHINI POLYTECHNIC COLLEGE CHETTIYAPPANUR",
  "SREE KRRISHNA COLLEGE OF PHARMACY",
  "R.V.S. TEACHER TRAINING INSTITUTE R.V.S NAGAR",
  "R V S POLYTECHNIC COLLEGE KANNAMPALAYAM",
  "RUKMINI SHANMUGAM POLYTECHNIC COLLEGE VARICHIYUR",
  "RUKMANI TEACHER TRAINING SCHOOL KADAYANALLUR",
  "RUDHRAVENI MUTHUSWAMY POLYTECHNIC COLLEGE PALAPPAMPATTI",
  "RSK SCHOOL OF NURSING, TRICHY",
  "ROYAL TEACHER TRAINNING INSTITUTE KATTINAYANAPALLI",
  "ROYAL POLYTECHNIC COLLEGE KULATHUR",
  "ROSELINE TEACHER TRAINING INSTITUTE VICTORIA NAGAR SHIVAGANGA",
  "ROSAMMAL TEACHER TRAINING INSTITUTION FOR WOMEN POOPALRAYER PURAM",
  "REGIONAL LABOUR INSTITUTE ADYAR",
  "RECT POLYTECHNIC COLLEGE SOUTH VIJAYANARAYANAM, TIRUNELVELI",
  "RATNAVEL SUBRAMANIAM POLYTECHNIC COLLEGE KULATHUR",
  "RATHNA POLYTECHNIC COLLEGE, POLUR",
  "RANIPPETTAI INSTITUTE OF TECHNOLOGY WALAJA",
  "VICKRAM POLYTECHNIC COLLEGE ENATHI",
  "CHELLAMMAL TEACHER TRAINING INSTITUTE, THENI",
  "CHANDY POLYTECHNIC COLLEGE MULLAKKADU",
  "RANGANATHAN POLYTECHNIC COLLEGE JAHIRMAICKENPALAYAM, COIMBATORE",
  "RANE POLYTECHNIC TECHNICAL CAMPUS, TIRUCHIRAPPALLI",
  "SRI ANDAL NACHIYAR POLYTECHNIC COLLEGE",
  "CENTWIN TEACHER TRAINING INSTITUTE, ERODE",
  "RAMYA SATHIANATHAN POLYTECHNIC COLLEGE, SENGIPPATTY",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KEELAPALUVUR PERAMBALUR",
  "RAMU - SEETHA POLYTECHNIC COLLEGE",
  "A V C C POLYTECHNIC COLLEGE MANNAMPANDAL",
  "ARUMUGAM TEACHER TRAINING INSTITUTE GANDHI RO ALANGUNDY",
  "ARUMUGAM NALLAMANI TEACHER TRAINING INSTITUTE SRI RAM NALLAMANI PUBLIC CHRT 70 TPK ROAD",
  "BLOCK INSTITUTE OF TEACHER EDUCATION, CUDDALORE",
  "ARULMURUGAN POLYTECHNIC COLLEGE THENNILAI WEST",
  "ARULMIGU THIRUPURASUNDARI AMMAN POLYTECHNIC COLLEGE EGAI",
  "ARULMIGU SENTHILANDAVAR POLYTECHNIC COLLEGE TENKASI",
  "ARULMIGU PALANIANDAVAR POLYTECHNIC COLLEGE PALANI-",
  "ARULMIGU KALASALINGAM TEACHER TRAINING INSTITUTE",
  "ARULMIGU KALASALINGAM POLYTECHNIC COLLEGE NATHAMPATI",
  "A R J POLYTECHNIC COLLEGE EDAYARNATHAM",
  "A.G. TRUST TEACHER TRAINING INSTITUTE TIRUPUR",
  "A. D. J. DHARMAMBAL POLYTECHNIC COLLEGE NAGAPATTINAM",
  "ADI PARASAKTHI POLYTECHNIC COLLEGE ERUMIYAMPATTI VILLAGE",
  "ADHIYAMAAN POLYTECHNIC COLLEGE DR M G R NAGAR HOSUR",
  "ADHIPARASAKTHI POLYTECHNIC COLLEGE MELMARUVATHUR",
  "ADAIKALAMATHA INSTITUTE OF TEACHER EDUCATION VALLAM",
  "ACHARYA POLYTECHNIC COLLEGE -VELLARIVELLI",
  "AAROORAN POLYTECHNIC COLLEGE SURRAKUDI",
  "AALIM MUHAMMED SALEGH POLYTECHNIC COLLEGE AVADI",
  "21ST CENTURY INTERNATIONAL SCHOOL TRUST KANJIRANGAL",
  "CENTRAL POLYTECHNIC COLLEGE KALIKUNDRAM",
  "C C M RAMAKRISHNA POLYTECHNIC COLLEGE KURUVADI",
  "CAPE POLYTECHNIC COLLEGE BOOTHAPANDY",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KANYAKUMARI",
  "BWDA POLYTECHNIC COLLEGE PONMANAI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING KALAYARKOIL SIVAGANGAI",
  "BHAVANI POLYTECHNIC COLLEGE VARADHANALLUR",
  "BHARAT TEACHER TRAINING INSTITUTE KOSAPET",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING DINDIGUL",
  "BHARATH POLYTECHNIC COLLEGE THIRVANCHERRY",
  "BHARATH POLYTECHNIC COLLEGE KOOTHAMPOONDI",
  "BHARATH NIKETAN POLYTECHNIC COLLEGE SRI GOWRI NAGAR, THENI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING COIMBATORE",
  "BHARATHI VIDYALAYA TEACHER TRAINING INSTITUTE PUDUKKOTTAI",
  "BHARATHI TEACHER TRAINING INSTITUTE BHARTH EDUN TRUST",
  "BLOCK INSTITUTE OF TEACHER EDUCATION BRAMMADESAM",
  "BHARATH INSTITUTE OF CATERING TECHNOLOGY AND HOTEL MANAGEMEN THANJAVUR",
  "BHARATH INSTITUE OF TEACHER TRAINING SIVAJI NAGAR NEAR MEMBALAM",
  "BETHESDA TEACHER TRAINING INSTITUTE BETHALPURAM",
  "BLOCK INSTITUTE OF TEACHER EDUCATION",
  "BETHEL SCHOOL OF NURSING, KANYAKUMARI",
  "BEST TEACHER TRAINING INSTITUTE SIRKALI",
  "BEATTIE MEMORIAL TEACHER TRAINING INSTITUTE FOR WOMEN RANIPET",
  "SINGARENI COLLORIES COMPANY LTD HOSPITAL KHAMMAM",
  "ROHINI SCHOOL OF NURSING WARANGAL",
  "SAHITHI ELEMENTARY TEACHER EDUCATION, UJJALAWADA(V), NAGARKURNOOL(M), MAHABUBNAGAR -509209",
  "ASHRAY AKRUTI    ",
  "SAMSKRUTI COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "St. Marys D.Ed College , Medak",
  "SANJAY GANDHI GOVERNMENT POLYTECHNIC",
  "SANTHI SCHOOL OF NURSING HYDERABAD",
  "Ayesha College of Education",
  "Tirumala Engineering College",
  "NOBLE POLYTECHNIC COLLEGE",
  "Manasa College of Elementary Teacher Education, Kothakota, Wanaparthy, Revenue Division, Mahaboobnagar -509381",
  "GOVT POLYTECHNIC ,NAGARJUNA SAGAR",
  "GOVERNMENT POLYTECHNIC,CHERIAL",
  "GEERVANI SCHOOL OF NURSING, SRIPURAM COLONY, HYDERABAD",
  "Govt. Polytechnic, Narayankhed",
  "PREETHI SCHOOL OF NURSING, NANALNAGAR, HYDERABAD",
  "GOVERNMENT MODEL RESIDENTIAL POLYTECHNIC, MANUGURU",
  "CMR INSTITUTE OF ELEMENTARY TEACHER EDUCATION, GUNDLA, POCHAMPALLY DUNDIGAL, GUNDLA POCHAMPALLI, RANGA REDDY",
  "VIVEKANANDA COLLEGE OF POLYTECHNIC",
  "PRINCIES ESIN'S WOMEN'S HOSPITAL SCHOOL OF NURSING HYDERABAD",
  "AURORAS BUSINESS SCHOOL",
  "ABDULKALAM INSTITUTE OF TECHNOLOGICAL SCIENCES",
  "GOVERNMENT POLYTECHNIC KESAMUDRAM",
  "Trinity College of Elementary Teacher Education,Karimnagar",
  "GOVERNMENT POLYTECHNIC SHADNAGAR",
  "Dhruva College of Management",
  "WOXSEN SCHOOL OF BUSINESS",
  "ADARSHA INSTITUTE OF ELEMENTARY TEACHER EDUCATION, NARAYANPET",
  "NOBLE COLLEGE OF PHARMACY",
  "AKSHARA POLYTECHNIC COLLEGE",
  "VIVEKANANDA INSTITUTE OF TECHNOLOGY AND SCIENCE",
  "PULIPATI PRASAD SCHOOL OF NURSING, ZAHEERPURA, KHAMMAM",
  "AURORAS SCHOOL OF BUSINESS STUDIES",
  "Telangana State Aviation Academy",
  "Aurora s polytechnic college,Yadadri Bhuvanagiri",
  "AURORA S MANAGEMENT ACADEMY",
  "SRI REMA SCHOOL OF NURSING",
  "Q.Q. GOVT. POLYTECHNIC OLD CITY HYDERABAD",
  "INSTITUTE OF INSURANCE AND RISK MANAGEMENT(IIRM)",
  "DEEPTHI SCHOOL OF NURSING, ASHOK NAGAR, MANCHERIAL",
  "ALA SAROJINAMMA SCHOOL OF NURSING NIZAMABAD",
  "GOVERNMENT POLYTECHNIC PATANCHERU",
  "APARNA SCHOOL OF NURSING, CHAITANYAPURI STREET, NALGONDA",
  "APEX SCHOOL OF NURSING, CHAITANYAPURI, HYDERABAD",
  "APOLLO HOSPITAL HYDERABAD",
  "APOORVA COLLEGE OF EDUCATION, BHOOPATHIPOOR",
  "APPLE SCHOOL OF NURSING WARANGAL",
  "VYNR D ED COLLEGE, CHILKOOR (V), Kanakamamidi Post Moinabad (M), Ranga Reddy District",
  "ARCHANA SCHOOL OF NURSING HYDERABAD",
  "ARUNA BAI D Ed COLLEGE, HUGGELLI",
  "AVM INSTITUTE OF ELEMENTARY TEACHER EDUCATION, NAKREKAL",
  "BALAJI SCHOOL OF NURSING, NALGONDA",
  "BANDARI SRINIVAS INSTITUTE OF TECHNOLOGY",
  "BAPUJI SCHOOL OF NURSING NALGONDA",
  "BEULAH SCHOOL OF NURSING, RAMACHANDRAPURAM, MEDAK",
  "BHAGATH COLLEGE OF DIPLOMA IN ENGINEERING AND TECHNOLOGY",
  "BHAGATH COLLEGE OF ELEMENTARY EDUCATION, AKUPAMULA, KODAD NALGONDA",
  "BHAGAWAN MAHAVIR SCHOOL OF NURSING, A.C. GUARDS, HYDERABAD",
  "BHAGYANAGAR SCHOOL OF NURSING HYDERABAD",
  "BHARATHI SCHOOL OF NURSING, SAROORNAGAR MANDAL, HYDERABAD",
  "Bhongir College of Elementary Teacher Education, Hanumapur, Bhongir, Nalgonda",
  "BOMMA INSTITUTE OF TECHNOLOGY & SCIENCE",
  "BRAINSTORM SCHOOL OF NURSING, OPP. BHEL, BHEL TOWN SHIP, MEDAK",
  "BRILLIANT MINDS AND RESOURCES D ED COLLEGE, PRASHANTH NAGAR, SIDDIPET, MEDAK",
  "Browns College of Elementary Teacher Education, Ammapalem, Tanikella, Khammam-507305.",
  "B.V.KRISHNA POLYTECHNIC",
  "CARE SCHOOL OF NURSING HYDERABAD",
  "RAHMANS ELEMENTRY TEACHER EDUCATION INSTITUTION WARANGAL",
  "CHANDANA D ED COLLEGE, PILLALAMARRI, SURYAPET, NALGONDA",
  "CHANDANA SCHOOL OF NURSING, SURYAPET, NALGONDA",
  "ANUBOSE INSTITUTE OF TECHNOLOGY (2nd SHIFT DIPLOMA)",
  "David Memorial Teacher Training Institute, Yacharam, Rangareddy-501509",
  "DAWN COLLEGE OF ELEMENTARY EDUCATION, VEMPAD, NIDMANOOR",
  "DEEPTHI SCHOOL OF NURSING, NEAR COLLECTORATE, NALGONDA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) KARIMNAGAR",
  "RASHMIDHAR TEJA ELEMENTARY TEACHER EDUCATION KARIMNAGAR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) MAHABUBNAGAR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) MEDAK",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) NALGONDA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) NIZAMABAD",
  "ABDUL KALAM D ED COLLEGE, Plot No. 429/9, NS Road, LINGAPOOR (V), Kamareddy, Nizamabad District",
  "St Agnes College of Education, Gundlapochampalli, Rangaredy District",
  "RASHMI DHAR TEJA SCHOOL OF NURSING, VAVILALAPALLI, KARIMNAGAR",
  "APARNA SCHOOL OF NURSING, SURYAPET, SURYAPET DISTRICT, TELANGANA",
  "PALLAVI INSTITUTE OF DIPLOMA IN EDUCATION, NANCHERLA GATE, PARGI ROAD, RANGAREDDY DISTRICT-509337",
  "INSTITUTE OF MANAGEMENT TECHNOLOGY HYDERABAD",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) SECUNDERABAD",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) TEKULAPALLU",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) WARANGAL",
  "ICAR NATIONAL ACADEMY OF AGRICULTURAL RESEARCH MANAGEMENT",
  "DODDA RACHAMMA MEMORIAL (DRM) COLLEGE OF ELEMENTARY TEACHER EDUCATION, CHARLAPALLY, NALGONDA -508001",
  "DOMESTIC SCIENCE TRAINING COLLEGE, EAST MARREDPALLY, SECUNDERABAD",
  "RATNAPURI INSTITUTE OF TECHNOLOGY - COLLEGE OF POLYTECHNIC",
  "DR BR AMBEDKAR GOVT POLYTECHNIC FOR WOMEN KARIMNAGAR",
  "Dr. Zakir Hussain Institute of Elementary Education,DNo.15-1- 59/1A, OppL Govt. Polytechnic, SVP Road, Warangal - 506007",
  "REMEDY SCHOOL OF NURSING HYDERABAD",
  "SHREE VIJAYA SCHOOL OF NURSING RANGA REDDY",
  "REOUSSEAU COLLEGE OF ELEMENTARY EDUCATION, VENKATRAOPALLY, SIRCILLA, KARIMNAGAR",
  "RESHMA SCHOOL OF NURSING, GODAVARIKHANI, KARIMNAGAR",
  "R G REDDY TEACHER TRAINING INSTITUTE, TELKAPALLY",
  "Trinity College of Elementary Teacher Education, Karimnagar",
  "R.K.L.K. D.ED. COLLEGE, BEHIND GANDHI PARK, SURYAPET, NALGONDA DISTRICT",
  "INDO AMERICAN SCHOOL OF NURSING, JUBLLIE HILLS, HYDERABAD",
  "GOVERNMENT POLYTECHNIC NIRMAL, ADILABAD",
  "SANTOSH SCHOOL OF NURSING KARIMNAGAR",
  "INDUR INSTITUTE OF ELEMENTARY TEACHER EDN. ACHANPALLY(V) NIZAMABAD",
  "INDUR INSTITUTE OF ENGINEERING & TECHNOLOGY",
  "SWARNA BHARATHI INSTITUTE OF SCIENCE AND TECHNOLOGY (2ND SHIFT POLYTECHNIC)",
  "ASIFIA COLLEGE OF EDUCATION",
  "S V S POLYTECHNIC,Warangal",
  "jayaprakash narayan college of engineering 2nd shift polytechnic",
  "ARJUN COLLEGE OF TECHNOLOGY AND SCIENCES (POLYTECHNIC)",
  "VIDYA BHARATHI INSTITUTE OF TECHNOLOGY",
  "SVS GROUP OF INSTITUTIONS( II SHIFT POLYTECHNIC)",
  "MOTHER THERESA COLLEGE OF ENGINEERING AND TECHNOLOGY(II SHIFT)",
  "TKR COLLEGE OF ENGINEERING AND TECHNOLOGY (II SHIFT POLYTECHNIC)",
  "ANURAG COLLEGE OF ENGINEERING (II SHIFT POLYTECHNIC)",
  "S.E.S.-S.N.MURTHY POLYTECHNIC",
  "Srinidhi Teacher Training Institute, Adilabad",
  "Sri Vivekananda College of Elementary Education,  Mahabubabad, Warangal",
  "Sri Venkateshwara D.Ed College, Ranga Reddy",
  "Sri Venkateshwara College of Education, Nizamabad",
  "Sri Raghavendra College of Education, Nalgonda",
  "Siddhu College of Education D.Ed, Nalgonda",
  "Shree Swaminarayana Gurukul College of Education,Rangareddy",
  "VISHVABHARATHY COLLEGE OF ELEMENTARY EDUCATION, PEBBAIR, WANAPARTHY, MAHABUBNAGAR",
  "INSTITUTE OF PUBLIC ENTERPRISE, SHAMIRPET (V&M), HYDERABAD",
  "Govt. Polytechnic for Women, Siddipet",
  "SRM D ED COLLEGE, GURRAMGUDA",
  "Dr. M.R. Reddy College of Elementary Teacher Education, Parkal, Warangal District",
  "SAHAJA SCHOOL OF EDUCATION, No. 164, 1st Street, Rangampalli (V), Peddapalli (M),Karimnagar District",
  "EARE DIPLOMA IN EDUCATION COLLEGE, THUNGAPADU, VENKATADRIPALEM, MIRYALAGUDA, NALGONDA",
  "Jangaon Elementary Teacher Education, No.1-2-333, Siddipet Road, Jangoan, Warangal-506167",
  "SRI VENKATESWARA SCHOOL OF NURSING, MALKAJIGIRI, HYDERABAD",
  "SREE RAJA RAJESHWARA SWAMY GOVERNMENT POLYTECHNIC SIRCILLA",
  "SRI VENKATA SAI SCHOOL OF NURSING MAHBOOBNAGAR",
  "SRI SANGAMESHWARA GOVERNAMENT POLYTECHNIC ZAHEERABAD",
  "THATHA SCHOOL OF NURSING HYDERABAD",
  "NIGHTINGALE SCHOOL OF NURSING, MEHIDIPATNAM, HYDERABAD",
  "JYOTHISHMATHI INSTITUTE OF TECHNOLOGICAL SCIENCES, KARIMNAGAR",
  "NIGAMA COLLEGE OF EDUCATION, SAMBAIAHPALLY",
  "NATIONAL INSTITUTE OF AGRICULTURAL EXTENSION MANAGEMENT, HYDERABAD",
  "SHRUTHI SCHOOL OF NURSING, VANASTHALIPURAM, HYDERABAD",
  "NALANDA TEACHER TRAINING INSTITUTE MAHABUBNAGAR",
  "NAGARJUNA COLLEGE OF TEACHER EDUCATION, RAGHAVENDRA VIDYA SAMITHI, 5-1-108/4/B, BANDAMEEDIPALLY, VALLABHNAGAR, MAHABUBNAGAR",
  "JAWAHARLAL NEHRU ELEMENTARY TEACHER EDUCATION INSTITUTE,                                                                         MARKET ROAD, VEMULAWADA, KARIMNAGAR-505302",
  "HOLYFAITH MINORITY INSTITUTE OF ELE. TEACHER EDN. KISTARAM KHAMMAM",
  "HOLY FAITH  MINORITY COLLEGE OF EDUCATION (D.Ed.)",
  "Navabharathi College of Elementary Teacher Education, Mahbubnagar",
  "JAYA SCHOOL OF NURSING, HANAMKONDA, WARANGAL",
  "HITS INSTITUTE OF EDUNCATIONAL TRAINING HOLY MARY INSTITUTE OF TECHNOLOGY RANGA REDDY",
  "HEENA SCHOOL OF NURSING, MIRYALGUDA, NALGONDA",
  "JAYA SCHOOL OF NURSING HYDERABAD",
  "HEALING TOUCH SCHOOL OF NURSING HYDERABAD",
  "SIDDARTHA D ED COLLEGE, K.No. 197&198, Urella Road, Devuni Erravally (V&P),Chevella (M), Rangareddy District",
  "J EASHWARI BAI MEMORIAL SCHOOL OF NURSING HYDERABAD",
  "J J SCHOOL OF NURSING HYDERABAD",
  "KONERU LAKSHMAIAH  EDUCATION FOUNDATION  DEEMED TO BE UNIVERSITY OFF  CAMPUS BOWRAMPET  HYDERABAD",
  "Vivekananda College of Education,Warangal",
  "Vivekananda College of Education,  Nizamabad",
  "J.N.GOVT. POLYTECHNIC RAMANTHAPUR HYDERABAD",
  "JYOTHI SCHOOL OF NURSING, HYDERABAD",
  "JYOTHI SCHOOL OF NURSING, MIRYALAGUDA, NALGONDA",
  "SG GOVT POLYTECHNIC ADILABAD",
  "KAKATIYA SCHOOL OF NURSING, LAKSHMI DEVI PALLI, KHAMMAM",
  "KAMINENI INSTITUTE OF MEDICAL SCIENCES NALGONDA",
  "SITA RAMAIAH SCHOOL OF NURSING, QUTBULLAPUR, HYDERABAD",
  "SIVANI SCHOOL OF NURSING. KARIMNAGAR",
  "SLV COLLEGE OF ELEMENTARY EDUCATION, CHERUVUGATTU, YELLAREDDYGUDEM, NARKETPALLY, NALGONDA",
  "LAKSHMI PARAMEDICAL INSTITUTE MPHW (F) TRAINING INSTITUTE ADILABAD   ",
  "SMT DURGABAI DESHMUKH GOVT. WOMEN'S TECH. TRAINING INST. HYDERABAD",
  "SNEHA SCHOOL OF NURSING, CHAITANYAPURI, HYDERABAD",
  "V.C. INSTITUTE OF TEACHER EDUCATION NALGONDA",
  "SRAVANTHI INSTITUTE OF ELEMENTARY TEAHCER EDN. WARANGAL",
  "KAMINENI SCHOOL OF NURSING HYDERABAD",
  "SREE DATTHA INSTITUTE OF ENGINEERING AND SCIENCE",
  "SREEKAVITHA ENGINEERING COLLEGE 2nd Shift(Polytechnic)",
  "Tirumala Institute of Elementary Education,Ranga Reddy",
  "KARUNA SCHOOL OF NURSING RANGA REDDY",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) RANGA REDDY",
  "Susheela College of Education, Khammam",
  "SRI AUROBINDO COLLEGE OF ELEMENTARY EDUCATION, CHERVUGATTU, YELLAREDDY GUDEM, NARKATPALLY, NALGONDA",
  "ST JOSEPH'S SCHOOL OF NURSING NALGONDA",
  "Kingston Institute of Ele.Teacher Education, Siddipet, Medak",
  "SRI BALAJI PULIPATI PRASAD SCHOOL OF NURSING, KOTHAGUDEM, KHAMMAM",
  "CM INSTITUTE OF ELEMENTARY TEACHER EDUCATION, QUTUBULLAPUR, JEEDIMETLA, GANDIMAISAMMA, Rangareddy",
  "SRI BHAVANA SCHOOL OF NURSING NALGONDA",
  "SRI JASWANTH SCHOOL OF NURSING HYDERABAD",
  "KINNERA SCHOOL OF NURSING, GUTTALA BAZAR, KHAMMAM",
  "SRI KETHAKI SANGAMESHWARA D ED COLLEGE, JHARASANGAM, ZAHIRABAD, MEDAK",
  "INSTITUTE OF MANAGEMENT TECHNOLOGY, HYDERABAD",
  "SRI LAKKINENI RAMAYYA PRATHIBA COLLEGE OF EDUCATION, KALLOOR",
  "K NARAYANA MEMORIAL COLLEGE OF EDUCATION, NARSINGI, MEDAK",
  "CENTRAL TRAINING ESTABLISHMENT AIR INDIA LTD",
  "SRINIVASA SCHOOL OF NURSING, VANASTHALIPURAM, HYDERABAD",
  "SRI PHULAJI BABA COLLEGE OF EDUCATION, UTNOOR",
  "SUJATHA SCHOOL OF NURSING RANGAREDDY DISTRICT",
  "KRISHNA INSTITUTE OF MEDICAL SCIENCES HYDERABAD",
  "St. Peters D.Ed. College,Warangal",
  "Vaishnavi College of Education,Nalgonda",
  "Sri Sadguru Bandayappa Swamy D.Ed. College, C/o.Basalingappa Mutt, Bichkunda village and mandal, Nizamabad-503306",
  "SRI SAI EDUCATIONAL SOCIETYs GROUP OF INSTITUTIONS(Second Shift Polytechnic)",
  "LAKSHMI NAGI REDDY COLLEGE OF DIPLOMA IN ELEMENTARY EDUCATION, WADDEPALLY",
  "SRI SAI SCHOOL OF NURSING, SANTHI NAGAR, NALGONDA",
  "S R M INSTITUTE OF MEDICAL SCIENCES & TECHNOLOGY KARIMNAGAR",
  "STANFORD INSTITUTE OF ELEMENTARY TEACHER EDN. NALGONDA",
  "LAXMI SAI SCHOOL OF NURSING, MANCHERIAL, ADILABAD",
  "ST ANN' S SCHOOL OF NURSING WARANGAL",
  "YASHODA LAKSHMI SCHOOL OF NURSING MEDCHAL",
  "ST JOHNS SCHOOL OF NURSING, WADDEPALLI, WARANGAL",
  "LAXMI SRINIVASA SCHOOL OF NURSING, ECIL, HYDERABAD",
  "Anwaru-ul-uloom College of Elementary Teacher Education, New Malakpet, Hyderabad",
  "ANUBOSE TEACHER TRAINING COLLEGE, PALONCHA",
  "B B R SCHOOL OF NURSING, BALANAGAR, HYDERABAD",
  "GOVERNMENT POLYTECHNIC, JOGIPET",
  "BALAJI INSTITUTE OF TECHNOLOGY AND SCI.",
  "Madeena D.Ed., college, No.5-16-109, M.G. Road, Kothagudem, Khammam-507101",
  "OMEGA BUSINESS SCHOOL",
  "PRAGNA COLLEGE OF EDUCATION.(D.Ed)",
  "Ellennki Engineering College",
  "SHADAN SCHOOL OF NURSING HYDERABAD",
  "APPLE SCHOOL OF NURSING, MATWADA, WARANGAL",
  "MADHIRA BRAHMA REDDY COLLEGE OF EDUCATION, PALEANNARAM, CHILKUR, KODAD, NALGONDA",
  "SHREE VASHISTA COLLEGE OF DIPLOMA IN ELEMENTARY EDUCATION, BADDIPALLY, KAMANPOOR",
  "Annie Bescent College of Elementary Teacher Education, Ponnekal, Khammam (R)",
  "MALLA REDDY INSTITUTE OF ELE. TCHR. EDUCATION SURVEY HYDERABAD",
  "MAMATA SCHOOL OF NURSING KHAMMAM",
  "KDR GOVT POLYTECHNIC WANAPARTHY",
  "K.N. POLYTECHNIC FOR WOMEN",
  "UK COLLEGE OF ELEMENTARY TEACHER EDUCATION",
  "GOVT. POLYTECHNIC FOR WOMEN (MINORITIES) VIKARABAD RR DIST.",
  "ANDHRA MAHILA SABHA NURSING TRG INSTITUTE HYDERABAD",
  "Sri Venkateswara Engineering College (II Shift Diploma courses)",
  "St. Mary S Group of Institutions Hyderabad",
  "ISLAMIA COLLEGE OF ELEMENTARY TEACHER EDUCATION, NO.17-3-1/5, SRT COLONY, YAKUTPURA, HYD. -23 (MUSLIM)",
  "AVANTHI s SCIENTIFIC TECHNOLOGICAL AND RESEARCH ACADEMY",
  "TEEGALA KRISHNA REDDY ENGINEERING COLLEGE (DIPLOMA) II SHIFT",
  "HOLYMARY INSTITUTE OF TECHNOLOGY (II SHIFT POLYTECHNIC COLLEGE)",
  "VISVESVARAYA COLLEGE OF ENGINEERING AND TECHNOLOGY(II SHIFT DIPLOMA)",
  "KBR ENGINEERING COLLEGE (II SHIFT POLYTECHNIC)",
  "WARANGAL INSTITUTE OF TECHNOLOGY  AND SCIENCE (2nd Shift Polytechnic)",
  "SWAPNA SCHOOL OF NURSING RANGA REDDY",
  "MASS SCHOOL OF NURSING, BHONGIR, NALGONDA",
  "SVS D ED COLLEGE, BHAGYANAGAR COLONY, IBRAHIMPATNAM, RANGA REDDY",
  "S V SCHOOL OF NURSING, HYDERABAD",
  "SVR COLLEGE OF ELEMENTARY TEACHER EDUCATION",
  "ALEXANDER COLLEGE OF EDUCATION, MUQDUMPUR",
  "ISLAMIA COLLEGE OF ELEMENTARY TEACHER EDUCATION, MUSTABABAD, SIDDIPET, MEDAK-502109",
  "S V MODEL D ED COLLEGE, DOMMARAPOCHAMPALLY",
  "STTHOMAS INSTITUTION OF ELEMENTARY TEACHERS EDUCATION, ACHANPALLY",
  "MARUTHI PARAMEDICAL ACADEMY KHAMMAM",
  "ST THERESA'S SCHOOL OF NURSING HYDERABAD",
  "SAI CHANDRA DMLT TRAINING INSTITUTE    ",
  "SAI THEJA PARA MEDICAL INSTITUTE    ",
  "WINGS AVIATION PRIVATE LIMITED",
  "St. Lawrence College of Elementary Teacher Education, Arempula, Khammam (Rural) -507003",
  "St. Judes Teachers Training college for Women Vikarabad, Rangareddy-501101",
  "MARIYAMMA SCHOOL OF NURSING HYDERABAD",
  "MARGADARSHI ELEMENTARY TEACHER EDUCATION WARANGAL",
  "MANGAMMA MEMORIAL SCHOOL OF NURSING HYDERABAD",
  "Venkateshwara School of Nursing",
  "IMAGE SCHOOL OF NURSING MEDAK",
  "II Shift Polytechnic, VNR Vignana Jyothi Institute of Engineering And Technology",
  "HOLY TRINITY INSTITUTE OF EDUCATIONAL TRAINING BOGARAM(V) RANGA REDDY",
  "HOLY MOTHER COLLEGE OF EDUCATION, BALAPUR, KESHAVGIRI, SAROOR NAGAR, HYDERABAD",
  "GOWTHAMI SCHOOL OF NURSING, SAROORNAGAR, HYDERABAD",
  "GOVT POLYTECHNIC WARANGAL",
  "Govt. Polytechnic, Vaddepally",
  "Govt. Polytechnic, Station Ghanpur",
  "GOVT.POLYTECHNIC SECUENDERABAD",
  "GOVT POLYTECHNIC NIZAMABAD",
  "Govt. Polytechnic, Navipet",
  "Govt. Polytechnic, Nandipet",
  "GOVT POLYTECHNIC NALGONDA",
  "Govt. Polytechnic, Medchal",
  "GOVT. POLYTECHNIC MASAB TANK HYDERABAD",
  "GOVT POLYTECHNIC MAHABOOBNAGAR",
  "Govt. Polytechnic, Madhira",
  "Al-Madina College of Education (D.Ed)  Salemnager, Mahabubnagar District",
  "GOVT POLYTECHNIC KOTHAGUDEM",
  "Govt. Polytechnic, Kotagiri",
  "Govt. Polytechnic, Kosgi",
  "Govt. Polytechnic, Gomaram (Narsapur)",
  "Govt. Polytechnic, Gadwal",
  "GOVT POLYTECHNIC FOR WOMEN WARANGAL",
  "GOVT POLYTECHNIC FOR WOMEN SURYAPET NALGONDA",
  "Govt. Polytechnic for Women, Pebbair",
  "GOVT POLYTECHNIC FOR WOMEN NIZAMABAD",
  "VAAGESWARI COLLEGE OF ENGINEERING (II Shift Polytechnic)",
  "GOVT POLYTECHNIC FOR WOMEN MEDAK",
  "Govt. Polytechnic for Women, Jogipet",
  "Govt. Polytechnic, Chegunta",
  "GOVT POLYTECHNIC BELLAMPALLY",
  "Govt. Model Residential Polytechnic, Utnoor",
  "GOVT.INSTI.OF ELECTRONICS EAST MARREDPALLYSECUNDERABAD",
  "GOVT GIRLS VOCATIONAL INSTITUTE WARANGAL",
  "GOVERNMENT POLYTECHNIC, YADAGIRIGUTTA",
  "Government Polytechnic,Tirumalagiri",
  "GOVERNMENT POLYTECHNIC, SIDDIPET",
  "GOVERNMENT POLYTECHNIC, SHIVAREDDYPETA, VIKARABAD",
  "GOVERNMENT POLYTECHNIC, SANGAREDDY",
  "Government Polytechnic, Parkal",
  "GOVERNMENT POLYTECHNIC, KATARAM",
  "GOVERNMENT DIPLOMA IN EDUCATION COLLEGE AT ITDA BADHRACHALAM, KHAMMAM TRIBAL AREA",
  "GOKUL TEACHER TRAINING INSTITUTE, GOKUL NAGAR, MUNUGODE, BY PASS ROAD, NALGODA",
  "AHMED INSTITUTION OF ELEMENTARY TEACHER EDUCATION, SHANKARANAGAR, BODHAN, NIZAMABAD",
  "GNANESWARI SCHOOL OF NURSING, BAPUNAGAR, HYDERABAD",
  "G.M.R. D.Ed. College, Plot.No.2/2, Digwal village, Zaheerabad, Medak-502220",
  "GLOBAL SCHOOL OF NURSING, CHAITANYAPURI, HYDERABAD",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING AND TECHNOLOGY",
  "ADITYA SCHOOL OF NURSING HYDERABAD",
  "Ghulam Ahmed (D.Ed) Mount Pleasant Road, D.No.8-2-249, Road No.3, Banjara Hills, Hyderabad.(Muslim)",
  "Gayathri Institute of Technology and Science",
  "GANDHI ACADEMY OF TECHNICAL EDUCATION(Second Shift Polytechnic)",
  "GANDHI ACADEMY OF TECHNICAL EDUCATION POLYTECHNIC, RAMAPURAM (V), KODA (M), NALGONDA (DIST)-508206",
  "ADARSHA COLLEGE OF ELEMENTARY TEACHER EDUCATION,  VENKATESHWARA COLONY, JADCHERLA, MAHABUBNAGAR -509101",
  "BHAVANI SCHOOL OF NURSING, SURYAPET, SURYAPET DISTRICT",
  "Fatima College of Elementary Teacher Education, Fatimanagar, NIT post, Kazipet,  Warangal-506004 (Christian minority upto 2009-10)",
  "Enrich Christian College of Elementary Teacher Education, Marrigudem, Nalgonda-508245",
  "ENGINEERING STAFF COLLEGE OF INDIA",
  "MINA INSTITUTE OF ENGINEERING AND TECHNOLOGY FOR WOMEN (2nd shift Diploma),MIRYALAGUDA",
  "ELLENKI COLLEGE OF TEACHER TRAINING EDUCATION, CHINNAGUNDAVALLI, SIDDIPET, MEDAK",
  "Ekashila College of Elementary Teacher Education, Ekashila Campus, 6-2-12, Hyderabad road, Jangoan, Warangal -506167",
  "ANNAMACHARYA INSTITUE OF TECHNOLOGY & SCIENCES",
  "ABYUDAYA  SCHOOL OF NURSING",
  "AHMED COLLEGE OF ELEMENTARY EDUCATION, RAMESHWARAPALLY, BHIKNOOR, NIZAMABAD",
  "VISHWABHARATHI COLLEGE OF DIPLOMA IN EDUCATION, GANDEED",
  "VISHWA VISHWANI INSTITUTE OF SYSTEMS AND MANGEMENT",
  "Food and Agri Business School PGDM (ABM) , Sagar Group of Institutions",
  "Viswambhara Teacher Training Institute, Bollikunta,  Warangal District-506005",
  "GLOBAL SCHOOL OF NURSING, SERILINGAMPALLY",
  "A D R MEMORIAL SCHOOL OF NURSING, SHARADANAGAR, HYDERABAD",
  "A.P.GOVERNMENT INSTITUTE OF LEATHER TECHNOLOGY",
  "TRINITY COLLEGE OF ENGINEERING  AND TECHNOLOGY (II-SHIFT POLYTECHNIC) PEDDAPALLI",
  "ELLENKI COLLEGE OF ENGINEERING AND TECHNOLOGY IInd Shift",
  "ADMINISTRATIVE STAFF COLLEGE OF INDIA",
  "FERNANDEZ SCHOOL OF NURSING RANGA REDDY",
  "SRM INSTITUTE OF MEDICAL SCIENCES & TECHNOLOGY SCHOOL OF NURSING, RAMNAGAR, KARIMNAGAR",
  "PRINCETON COLLEGE OF ENGINEERING AND TECHNOLOGY (2ND SHIFT DIPLOMA)",
  "SIVA SIVANI INSTITUTE OF MANAGEMENT",
  "GOVERNMENT POLYTECHNIC FOR WOMEN, SECUNDERABAD",
  "Aurora s Research and Technological Institute, Warangal Rural",
  "ST.MARYS INTEGRATED CAMPUS HYDERABAD (2ND SHIFT POLYTECHNIC)",
  "GOURISETTY VENKANTAIAH MEMORIAL COLLEGE OF ELEMENTARY TEACHER EDUCATION, NO.3-7-619, JAGTIAL ROAD, KARIMNAGAR DISTRICT-505001",
  "VINUTHNA INSTITUTE OF TECHNOLOGY AND SCIENCE ( II SHIFT POLYTECHNIC )",
  "SAI SPURTHI INSTITUTE OF TECHNOLOGY(2nd SHIFT POLYTECHNIC COLLEGE)",
  "NIGAMA ENGINEERING COLLEGE",
  "SREE VISVESVARAYA INSTITUE OF TECHNOLOGY AND SCIENCE (II Shift Polytechnic)",
  "Nalanda College of Pharmacy - D Pharmacy",
  "RRS COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "Anurag Engineering College (2nd Shift Polytechnic)",
  "ST MARY S COLLEGE OF ENGINEERING  AND TECHNOLOGY (II SHIFT POLYTECHNIC COLLEGE)",
  "SIDDHARTHA INSTITUTE OF TECHNOLOGY AND SCIENCE (II Shift Diploma College)",
  "SREE VISVESVARAYA POLYTECHNIC MAHABUBNAGAR",
  "Pratishta Institute of Pharmaceutical Sciences (D Pharmacy)",
  "VAAGDEVI ENGINEERING COLLEGE (II-SHIFT POLYTECHNIC)",
  "CHRISTU JYOTHI INSTITUTE OF TECHNOLOGY AND SCIENCE (II SHIFT POLYTECHNIC)",
  "II shift - SAGAR GROUP OF INSTITUTIONS,SAGAR POLYTECHNIC(567)",
  "MEGACITY SCHOOL OF NURSING, RANGAREDDY DISTRICT HYDERABAD",
  "TRINITY COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "VIJAY RURAL ENGINEERING COLLEGE - II SHIFT POLYTECHNIC",
  "NATIONAL INSTITUTE OF RURAL DEVELOPMENT AND PANCHAYATI RAJ",
  "VENKATA SAI SCHOOL OF NURSING MEDAK",
  "Megha Institute of Engineering and  Technology For Women",
  "Vikas D.Ed., College, Ranga Reddy",
  "Surya D.Ed., College,Karimnagar",
  "Sanjeevani College of Education, Nalgonda",
  "Sai Elementary Teacher Training, Karimnagar",
  "SSV D.Ed College,Ranga Reddy",
  "S.V. College of Education, Nizamabad",
  "Raga College of Education,  Khammam",
  "SRKM D.Ed. College, Adilabad",
  "Srinivasa College of Elementary Education, Mahabubnagar",
  "Shivani Institute of Teacher Education, Warangal.",
  "BALAJI INSTITUTE OF EDUCATION AND TRAINING,  WARANGAL D",
  "Y S R ELEMENTARY TEACHER TRAINING INSTITUTE, PETBASHIRBAG, QUTHBULLAPUR, RANGA REDDY",
  "SINGARENI COLLIERIES POLYTECHNIC",
  "VENKATESHWARA COLLEGE OF EDUCATION CHARLAPALLY NALGONDA",
  "Pragathi College of Education,  Mahabubnagar",
  "Sharvani College of Elementary Teacher Education,  Wanaparthy , Mahabubnagar",
  "Palamoor Reddy Seva Samithi D.Ed. College, Mahabubnagar",
  "GOVERNMENT POLYTECHNIC HUSNABAD",
  "Noble D.Ed College, Medak",
  "Shantinikethan College of Education, Nalgonda",
  "Nethaji College of Elementary Education ,Ranga Reddy",
  "Nagarjuna College of Education (D.Ed),Nalgonda",
  "M.E.S. College of Education, Khammam",
  "Krishna Institute of Teacher Education,  Mahabubnagar",
  "Jayamukhi Teacher Training Institute,  Warangal",
  "HRD College of Teacher Education,  Nalgonda",
  "Gnanodaya College of Elementary Education, Karimnagar",
  "Gayathri College of Elementary Teacher Education, Mahaboobnagar",
  "Gate College of Education, Nalgonda",
  "G.P. Ladda D.Ed. College,  Adilabad",
  "Dwaraka College of Elementary Teacher Education,  Mahabubnagar",
  "VENNALA SCHOOL OF NURSING, GANDHINAGAR, NALGONDA",
  "Deccan College of D.Ed, Medak",
  "Bugudi Tulasidas D.Ed College, Sy.No. 83, Plot No.1, Tandur Village, Post and Taluk, Ranga Reddy - 501141",
  "Shalini College of Education ,Karimnagar",
  "Sarvepally Radhakrishna Educational Society, Mahbubnagar",
  "VIGNANA JYOTHI INSTITUTE OF MANAGEMENT",
  "SCHOOL OF INNOVATION AND MANAGEMENT",
  "VIJAYA ENGINEERING COLLEGE",
  "VIJAYA HEALTH CARE INSITUTE OF PARAMEDICAL SCIENCES SCHOOL OF NURSING, RAMACHANDRAREDDY NAGAR, MEDAK",
  "VIJAYA SCHOOL OF NURSING HYDERABAD",
  "DEVI SCHOOL OF NURSING, RAMACHANDRAPURAM, MEDAK",
  "VIJAY MARIE HYDERABAD",
  "VIJAYA SCHOOL OF NURSING, YENUGONDA, MAHABOOBNAGAR",
  "VIJAY COLLEGE OF D ED FOR WOMEN, MUBARAKNAGAR",
  "SIDDARTHA PARAMEDICAL COLLEGE",
  "SIRI PARA MEDICAL MPHA (M) TRAINING INSTITUTE",
  "HOLY FATIMA SCHOOL OF NURSING, MURADNAGAR, HYDERABAD",
  "BADRUKA SCHOOL OF MANAGEMENT ",
  "VATHSALYA COLLEGE OF EDUCATION (D ED) BANJARA HILLS, BHONGIR, Nalgonda Dist",
  "KRK REDDY D ED COLLEGE, ANKIREDDYPALLY",
  "Govt. Polytechnic, Korutla",
  "CHRISTINA SCHOOL OF NURSING RANGA REDDY",
  "SHRI SHAKTI INSTITUTE OF HOTEL MANAGEMENT, HYDERABAD",
  "VINUTHNA COLLEGE OF EDUCATION, HASANPARTY",
  "SANA POLYTECHNIC",
  "ELLENKI INSTITUTE OF ENGINEERING AND TECHNOLOGY IInd SHIFT",
  "JYOTHISHMATHI INSTITUTE OF TECHNOLOGY & SCIENCE",
  "Balaji Institute of Elementary  Teacher Education, Formerly MAHESHWARA INSTITUTE OF ELEMENTRY TEACHER EDUCATION, MAHESHWARAM, NARSAMPET (m),  WARANGAL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING (DIET) ADILABAD",
  "GMR POLYTECHNIC GAJWEL MEDAK",
  "GURUNANAK SCHOOL OF NURSING HYDERABAD",
  "KUMUDINIDEVI SCHOOL OF NURSING",
  "GOVERNMENT POLYTECHNIC COLLEGE MAHESHWARAM",
  "ASHOKA SCHOOL OF BUSINESS",
  "DR YSR NATIONAL INSTITUTE OF TOURISM AND HOSPITALITY MANAGEMENT",
  "ST JOSEPHS PGDM COLLEGE",
  "KASTURI SCHOOL OF NURSING HYDERABAD",
  "ITM BUSINESS SCHOOL WARANGAL",
  "PRATHIMA SCHOOL OF NURSING KARIMNAGAR",
  "YASHODA SCHOOL OF NURSING RANGA REDDY",
  "PRAGATHI SCHOOL OF NURSING RANGA REDDY",
  "YASMEEN INSTITUTE OF ELEMENTRY TEACHER EDUCATION WARANGAL",
  "PRAGATHI D ED COLLEGE, DURKI",
  "V.M.R. POLYTECHNIC WARANGAL",
  "VIVEKANANDA INSTITUTE OF ELEMENTARY TEACHER EDU. ADILABAD",
  "Vivekananda College of Elementary Education, Chattanpally, Shadnagar, Mahabubnagar-509216.",
  "PRAGATHI D ED COLLEGE, ANNOJIGUDA",
  "PRAKASH COLLEGE OF ELEMENTARY EDUCATION, GOLLAPALLI, CHEVELLA",
  "PRABHA SCHOOL OF NURSING, MANCHERIAL, ADILABAD",
  "POULOMI SCHOOL OF NURSING HYDERABAD",
  "PANCH SHEEL INSTITUTE OF EDUCATION ADILABAD",
  "PALLAVI D ED COLLEGE, BALAJI NAGAR, PARGI",
  "OXFORD SCHOOL OF NURSING HYDERABAD",
  "NOBLE SCHOOL OF NURSING RANGA REDDY",
  "NIVEDITHA COLLEGE OF ELEMENTARY TEACHER EDUCATION, KOTHAKOTA",
  "NIRMALA SCHOOL OF NURSING, SURYAPET, NALGONDA",
  "Yashoda School of Nursing, Medchal",
  "NIKHIL SCHOOL OF NURSING, GAUTAM NAGAR, HYDERABAD",
  "MYTHRI SCHOOL OF NURSING HYDERABAD-",
  "MYTHRI SCHOOL OF NURSING, BHEMARAM, WARANGAL",
  "Mother Theressa College of Elementary Teacher Education, New Paloncha, Khammam-507115",
  "MOTHER THERESA SCHOOL OF NURSING, KUSHAIGUDA, HYDERABAD",
  "MOTHER TERESA COLLEGE OF ELEMENTARY EDUCATION, SATHUPALLY",
  "VENKATA SAI DIPLOMA IN ELEMENTARY EDUCATION INSTITUTION, DEVARAKADRA, MAHABUBNAGAR",
  "MOTHER TERESA COLLEGE OF EDUCATION, MAHABUBABAD",
  "VANI NIKETAN D ED COLLEGE, KARIMNAGAR",
  "MOTHER KRISHNA BAI SCHOOL OF NURSING HYDERABAD",
  "VANDANA SCHOOL OF NURSING, KODAD, NALGONDA",
  "ICAR NATIONAL ACADEMY OF AGRICULTURAL RESEARCH MANAGEMENT",
  "VAAGDEVI SCHOOL OF NURSING, KISHNANPURA, WARANGAL",
  "M N R SCHOOL OF NURSING, SANGAREDDY, MEDAK",
  "Vaagdevi College of D.Ed., Programme, Parkal, Warangal District -506164",
  "U K COLLEGE OF ELEMENTARY TEACHER EDUCATION, GODHUMAKUNTA, KEESARA, RANGA REDDY",
  "TUMARA COLLEGE OF ELEMENTARY EDUCATION, GOLLAGUDA, KESHARAJUPALLY",
  "MNR Elementary Teacher Education, MNR Nagar, Narsapur road, Sangareddy, Medak-502294",
  "TRINITY PARA MEDICAL COLLEGE SCHOOL OF NURSING, ST. JOHNS EDUCATIONAL SOCIETY, KHAMMAM",
  "TIRUMALA SCHOOL OF NURSING VINAYAK NAGAR NIZAMABAD",
  "MNR Elementary Teacher Education Institute, Bachupally, Kukatpally, Rangareddy-500072.",
  "THIRUMALA SCHOOL OF NURSING, ARMOOR, NIZAMABAD",
  "THE LITTLE FLOWER SCHOOL OF NURSING HYDERABAD",
  "MIDWIN SCHOOL OF NURSING, RAMACHANDRAPURAM, MEDAK",
  "TEJESWI SCHOOL OF NURSING HYDERABAD",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNLOGY AND APPLIED NUTRITION",
  "TEJA COLLEGE OF ELEMENTARY EDUCATION, KODAD, NALGONDA",
  "MEDICITY SCHOOL OF NURSING RANGAREDDI",
  "TALLA PADMAVATHI INSTITUTE OF ELEMENTARY TCHR. EDN WARANGAL",
  "IIITM EDUCATION INDIA",
  "INSTITUTE OF HOTEL MANAGEMENT AND CATERING TECHNOLOGY",
  "DIET SOUTH TRIPURA",
  "NATIONAL SCHOOL OF DRAMA (THEATRE-IN-EDUCATION WING)",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING AND TECHNOLOGY (CIPET)  AGARTALA",
  "SR GROUP OF INSTITUTIONS     ",
  "ANM TRAINING INSTITUTE , PALACE COMPOUND",
  "HFT INSTITUTE OF NURSING SCIENCES AGARTALA",
  "STATE INSTITUTE OF HOTEL MANAGEMENT, AGARTALA",
  "RAJ RAJESHWARI INSTITUTE OF NURSING SCIENCE",
  "MPW (F) TRAINING INSTITUTE",
  "Sarvodaya Institute of Nursing",
  "COMPOSITE REGIONAL CENTER FOR SKILL DEVELOPMENT, REHABILITATION AND EMPOWERMENT OF PERSONS WITH DISABILITIES, CRC SRE TRIPURA    ",
  "ANM (R) TRAINING INSTITUTE, SANTIR BAZAR",
  "AGARTALA GOVERNMENT NURSING COLLEGE",
  "NORTH EAST INSTITUTE OF NURSING SCIENCE",
  "DIET DHALAI",
  "ILS Nursing College, Agartala",
  "DIET WEST TRIPURA",
  "DR B R A MEMORIAL NURSING SCHOOL WEST TRIPURA",
  "GNM TRAINING INSTITUTE, UDAIPUR",
  "DIET NORTH TRIPURA",
  "GOVERNMENT POLYTECHNIC, GAIRSAIN",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, DIDIHAAT (PITHORAGARH)",
  "KUMAUN AYURVEDIC MEDICAL COLLEGE AND HOSPITAL",
  "GOVERNMENT POLYTECHNIC, DWARAHAT",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, CHARIGAON (PAURI)",
  "GOVERNMENT POLYTECHNIC, DIDIHAT",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BHIMTAL",
  "GOVERNMENT POLYTECHNIC, DEHRADUN",
  "GOVERNMENT POLYTECHNIC, DANYA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BARKOT (UTTARKASHI)",
  "GOVERNMENT POLYTECHNIC, KULSARI",
  "Government Polytechnic, Chopta",
  "SITA RAM HOMEOPATHIC PARAMEDICAL PHARMACY COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, ALMORA",
  "GOVERNMENT POLYTECHNIC CHINYALISAUR",
  "Government Polytechnic Chaunaliya, Almora",
  "DEV BHOOMI INSTITUTE OF POLYTECHNIC",
  "GOVERNMENT POLYTECHNIC CHAMPAWAT",
  "Dev Bhoomi Institute of Pharmacy and Research, Dehradun",
  "GOVERNMENT POLYTECHNIC BHEEMTAL",
  "GOVERNMENT POLYTECHNIC, BHALSABHAGAJ",
  "COMBINED ( P G) INSTITUTE OF MEDICAL SCEINES DEHRADUN",
  "GOVERNMENT POLYTECHNIC, BERINAG",
  "COLLEGE OF ADVANCE TECHNOLOGY, ROORKEE",
  "GOVERNMENT POLYTECHNIC, BAZPUR",
  "VASUDEV COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC, LOHAGHAT",
  "GOVERNMENT POLYTECHNIC, MALLASALAM ALMORA",
  "CHAMAN LAL COLLEGE OF PHARMACY",
  "KRISHNA AYURVEDIC AND UNANI COLLEGE",
  "GOVERNMENT POLYTECHNIC, MUNAKOT",
  "BHARAT COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC, NARENDRA NAGAR",
  "MAHADEV COLLEGE OF PHARMACY",
  "SHRI RAM AYURVEDIC PARA MEDICAL",
  "Droan College of Pharmacy",
  "Swastik School of Nursing, Khatima",
  "MSME TECHNOLOGY CENTRE, SITARGANJ",
  "OM NURSING COLLEGE",
  "Aarogyam Nursing College",
  "AYUSHMAN COLLEGE OF MEDICAL SCIENCE",
  "KESHAV SURYAMUKHI COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC RANIPOKHARI",
  "Samrat prithviraj chauhan College of Pharmacy",
  "GOVERNMENT POLYTECHNIC, GOPESHWAR",
  "VIDYASHREE AYURVEDIC PARAMEDICAL COLLEGE    ",
  "ANM TRAINING CENTRE,  RANIPOKHRI, DEHRADUN",
  "CARE COLLEGE OF PHARMACY",
  "SWAMI VISHNU CHAITANYA COLLEGE OF PHARMACY ROORKEE",
  "STATE SCHOOL OF NURSING, CHANDER NAGER",
  "MOTHERHOOD INSTITUTE OF MANAGEMENT AND TECHNOLOGY, ROORKEE",
  "K.L. POLYTECHNIC, ROORKEE",
  "IMS INSTITUTE OF TECHNOLOGY, ROORKEE",
  "IDEAL BUSINESS SCHOOL",
  "GYANI INDER SINGH INSTITUTE OF PROFESSIONAL STUDIES, DEHRADUN",
  "GOVERNMENT RURAL POLYTECHNIC, THALNADI",
  "S.S.S.S.S.P.U GOVERNMENT POLYTECHNIC, SULT",
  "GOVERNMENT RURAL POLYTECHNIC, TAKULA",
  "GOVERNMENT POLYTECHNIC, VIKASHNAGAR DEHRADUN",
  "GOVERNMENT POLYTECHNIC, UTTARKASHI",
  "GOVERNMENT POLYTECHNIC, TANKAPUR",
  "Shivalik Institute of Ayurved and Resarch",
  "GOVERNMENT POLYTECHNIC, SRINAGAR",
  "GOVERNMENT POLYTECHNIC, SHAYMPUR",
  "JASWANT SINGH RAWAT GOVERNMENT POLYTECHNIC BIRONKHAL",
  "GOVERNMENT POLYTECHNIC,SHAKTIFARM",
  "GOVERNMENT POLYTECHNIC, SATPULI",
  "GOVERNMENT POLYTECHNIC, SAHIYA DEHRADUN",
  "GOVERNMENT POLYTECHNIC, RUDRAPRAYAG",
  "GOVERNMENT POLYTECHNIC, RAMNAGAR",
  "GOVERNMENT POLYTECHNIC, QUANSI",
  "GOVERNMENT POLYTECHNIC POKHARI",
  "Government Polytechnic, Pipli",
  "GOVERNMENT POLYTECHNIC, PAURI",
  "GOVERNMENT POLYTECHNIC, PANTNAGAR",
  "GOVERNMENT POLYTECHNIC, PABAU",
  "GOVERNMENT POLYTECHNIC, NEW TEHRI",
  "GOVERNMENT POLYTECHNIC, KHATIMA",
  "GOVERNMENT GIRLS POLYTECHNIC, JAKHOLI",
  "GOVERNMENT POLYTECHNIC, KASHIPUR",
  "GOVERNMENT GIRLS POLYTECHNIC, DEHRADUN",
  "GOVERNMENT POLYTECHNIC, KAPKOT",
  "GOVERNMENT GIRLS POLYTECHNIC, ALMORA",
  "GET GROUP OF INSTITUTION FACULTY OF TECHNOLOGY, UDHAM SINGH NAGAR",
  "GOVERNMENT POLYTECHNIC, KANDIKHAL",
  "GOVERNMENT POLYTECHNIC, KANDA",
  "Dronas Polytechnic College",
  "GOVERNMENT POLYTECHNIC, KANALICHHEENA PITHORAGARH",
  "DROAN COLLEGE OF NURSING UDHAM SINGH NAGAR",
  "GOVERNMENT POLYTECHNIC, KALADHUNGI NAINITAL",
  "DRC, RATURA (RUDRAPRAYAG)",
  "Government Polytechnic, Joshimath",
  "DRC, LOHAGHAT (CHAMPAWAT)",
  "Doon Ayurvedic Paramedical College",
  "GOVERNMENT POLYTECHNIC, JAKHNIDHAR",
  "GOVERNMENT POLYTECHNIC, HINDOLAKHAL",
  "MAA GIIRIJA INSTITUTE OF PHARMACEUTICAL SCIENCE HIMMATPUR BLOCK RAMNAGAR NAINITAL",
  "GOVERNMENT POLYTECHNIC, GARUR",
  "DOON BUSINESS SCHOOL GLOBAL",
  "GOVERNMENT POLYTECHNIC, HARIDWAR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, TEHRI",
  "GOVERNMENT POLYTECHNIC, KOTDWAR",
  "GOVERNMENT POLYTECHNIC, GAUCHAR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, RUDRAPUR",
  "GOVERNMENT POLYTECHNIC, GANAI GANGOLI",
  "GOVERNMENT POLYTECHNIC, GAJJA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, ROORKEE (HARIDWAR)",
  "DIVINE COLLEGE OF PHARMACY",
  "MAHARISHI DAYANAND HOMOEOPATHIC PARAMEDICAL PHARMACY INSTITUTE",
  "SRISTHI PHARMACY COLLEGE",
  "B D PANDEY HOSPITAL SCHOOL OF NURSING NAINITAL",
  "MOTHERHOOD COLLEGE OF PHARMACY",
  "S J S GROUP OF EDUCATION AYURVEDIC COLLEGE KHERA LAXMIPUR JASPUR",
  "Haridwar College of Pharmacy",
  "SITA RAM AYURVEDIC PARAMEDICAL COLLEGE",
  "ALPINE INSTITUTE OF AERONAUTICS DEHRADUN",
  "GOVERNMENT POLYTECHNIC, KOTABAGH",
  "CHARAK RAMMURTI AYURVEDIC UNANI COLLEGE",
  "STATE INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION RAMNAGAR",
  "BALWANT SINGH MUKHIYA(BSM) COLLEGE OF POLYTECHNIC, ROORKEE",
  "BHAGIRATHI INSTITUTE OF PHARMACY",
  "BHAGIRATHI INSTITUTE OF TECHNOLOGY AND MANAGEMENT COLLEGE (POLYTECHNIC), LOHAGHAT",
  "GOVERNMENT POLYTECHNIC BAANS",
  "Government Polytechnic, Bachelikhal",
  "BHARATAM INSTITUTE OF TECHNOLOGY",
  "GOVERNMENT POLYTECHNIC BADECHEENA",
  "GOVERNMENT POLYTECHNIC BANSBAGARH",
  "BISHAMBER SAHAI DIPLOMA ENGINEERING COLLEGE, ROORKEE",
  "ELECTRONICS SERVICE AND TRAINING CENTRE",
  "GOVERNMENT POLYTECHNIC BARAM",
  "BLUE MOUNTAINS COLLEGE OF HOTEL MANAGEMENT & CATERING TECHNOLOGY",
  "GOVERNMENT POLYTECHNIC, BARKOT",
  "B.S. NEGI MAHILA PRAVIDHIK PRASHIKSHAN SANSTHAN, DEHRADUN",
  "ALPINE COLLEGE OF MANAGEMENT & TECHNOLOGY, DEHRADUN",
  "OM INSTITUTE OF TECHNOLOGY, ROORKEE",
  "HAJI MANGTA HASAN UNANI AND AYURVEDIC PARA MADICAL COLLEGE AND HOSPITAL",
  "ROORKEE COLLEGE OF PHARMACY, ROORKEE",
  "ROORKEE COLLEGE OF POLYTECHNIC, ROORKEE",
  "GOVERNMENT POLYTECHNIC, PRATAPNAGAR",
  "shri krishna institute of bhartiya ayurvedic aushdhe",
  "RUDRAPUR INSTITUTE OF TECHNOLOGY, BHAGWANPUR, DANPUR RUDRAPUR",
  "SDIMT GURUKUL MAHAVIDYALAYA, HARIDWAR",
  "SRI SAI INSTITUTE OF TECHNOLOGY, JASPUR",
  "KUKREJA INSTITUTE OF HOTEL MANAGEMENT    ",
  "RIMS COLLEGE OF PHARMACY",
  "SHAKUMBHARI INSTITUTE OF HIGHER EDUCATION, ROORKEE",
  "SIX SIGMA INSTITUTE OF TECHNOLOGY & SCIENCE, RUDRAPUR",
  "HERITAGE AVIATION PVT LTD    ",
  "Shri Uttarakhand Ayurvedic Bhaisjya Kalpak (Pharmacist) Prashikshan Vidhyalay",
  "VIDYA JYOTI COLLEGE OF PHARMACY",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, GAUCHAR (CHAMOLI)",
  "SMT. MANJIRA DEVI SHIKSHAN AND PRASHIKSHAN INSTITUTE, HITANU UTTARKASHI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, DEHRADUN",
  "SUNRISE INSTITUTE OF PHRMACY, DEHRADUN",
  "Panchtatva Ayurvedic Research Institute and Hospital",
  "GM AYURVEDIC MEDICAL COLLEGE",
  "UTTARAKHAND PARAMEDICAL AYURVEDIC COLLEGE CHHARBA SAHASPUR VIKASNAGAR DEHRADUN",
  "UTTARAKHAND INSTITUTE OF TECHNICAL AND PROFESSIONAL EDUCATION, RAMNAGAR",
  "pragati college of pharmacy",
  "CIPET CENTRE FOR SKILLING AND TECHNICAL SUPPORT (CSTS), DEHRADUN",
  "UTTARATECH POLYTECHNIC, ROORKEE",
  "MAHARISHI DAYANAND MEDICAL SCIENCE AND RESEARCH INSTITUTE",
  "RCP College of Pharmacy",
  "ANANT MEDICAL COLLEGE AND HOSPITAL GORDHANPUR KHANPUR HARIDWAR",
  "ZAID HOMEOPATHIC PARAMEDICAL COLLEGE",
  "GOVERNMENT POLYTECHNIC, AAMWALA DEHRADUN",
  "SAINI NURSING SCHOOL",
  "Govt Polytechnic, Jainti",
  "ROORKEE AYURVEDIC MEDICAL COLLEGE",
  "AYUSH INDIA INSTITUTE OF MEDICAL SCIENCE    ",
  "ANANT HOMOEOPATHIC PARAMEDICAL COLLEGE",
  "BRD College of Pharmacy",
  "SHREE COLLEGE OF NURSING",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION, DEHRADUN",
  "Sanjeevani Hospital And Medical Research Institute",
  "DRC, BAGESHWAR",
  "SHRI AYUSH HOSPITAL AND RESEARCH INSTITUTE",
  "Maa Saraswati Paramedical College and Hospital",
  "SWAMI VISHNU CHAITANYA SCHOOL OF NURSING, ROORKEE",
  "INSTITUTE OF MANAGEMENT EDUCATION AND CONSULTANCY",
  "SHAHEED CAPTAIN D K KHOLA COLLEGE OF PHARMACY, DINESHPUR",
  "ARIHANT COLLEGE OF PHARMACY",
  "SURAJMAL AGARWAL COLLEGE OF POLYTECHNIC",
  "Bharti School of Nursing",
  "SHRI SIDDHI VINAYAK COLLEGE OF PHARMACY",
  "CITY COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC, NAINITAL (Nainital)",
  "kalpana ayurvedic unani paramedical college and hospital",
  "J.S.S. College and Hospital",
  "KRISHNA BALRAM NURSING PARAMEDICAL COLLEGE AND HOSPITAL",
  "GOVERNMENT GIRLS POLYTECHNIC, CHARKHARI",
  "ITM COLLEGE OF POLYTECHNIC CHEHARI MAHARAJGANJ U P",
  "MR EDUCATION",
  "SHRI SAI VIDYAPEETH",
  "CHANDNI CHARITABLE HOSPITAL SOCIETY SCHOOL OF NURSING LAKHANPUR VIKAS NAGAR KANPUR",
  "B R S D School of Nursing Uttam Nagar, Bhujahi, Azamgarh",
  "A M COLLEGE OF HIGHER EDUCATION, BASDEOPUR",
  "Rai K B Singh Nursing and Paramedical College, Civil Line Kutchehary Road Husenabad, Jaunpur",
  "KRISHNA SCHOOL OF NURSING HUSENABAD, KRISHNA COLONY NEAR JAYCEES CHAURAHA JAUNPUR",
  "MAHALAXMI INSTITUTE OF MANAGEMENT & TECHNOLOGY MEERUT",
  "MAA CCHAVIRAJI DEVI COLLEGE OF EDUCATION, CHANDULI",
  "lalita college of education",
  "KRS INSTITUTE OF PARAMEDICAL SCIENCES AND NURSING GONDA",
  "LLOYD BUSINESS SCHOOL",
  "K K HOSPITAL LUCKNOW",
  "LIFE LINE SCHOOL OF NURSING KAMDHENU NAGAR AURANGABAD MATHURA",
  "PRASAD POLYTECHNIC PANCH HATIA JAUNPUR",
  "KM. MAYAWATI GOVERNMENT GIRLS POLYTECHNIC BADALPUR",
  "Dr KNS School of Nursing Lucknow",
  "Krishna Nursing and Paramedical Institute",
  "K. S. INSTITUTE OF MANAGEMENT & TECHNOLOGY",
  "KUNAL COLLEGE OF PHARMACY",
  "KUNAL PROFESSIONAL EDUCATION ACADEMY",
  "LADY RAJRANI INSTITUTE OF EDUCATION",
  "Lal Bahadur Shastri Institute of Management and Technology",
  "Lal Bahadur Shastri Polytechnic,Manda Allahabad",
  "LITTLE FLOWER POLYTECHNIC",
  "LORD KRISHNA INSTITUTE OF EDUCATION, MATHURA",
  "LUCKNOW POLYTECHNIC LUCKNOW",
  "LUCKNOW SCHOOL OF NURSING",
  "MAA ASARFI NURSING SCHOOL",
  "MAA BHAGWATI EDUCATIONAL INSTITUTE",
  "MAA KAUSHILYA SCHOOL OF NURSING, AZAMGARH",
  "SETH GANGA SAGAR JATIA POLYTECHNIC KHURJA",
  "RAMESH CHAND INSTITUTE OF MANAGEMENT(RCIM)",
  "SRI ANAR DEVI KHANDELWAL GIRLS POLYTECHNIC, MATHURA",
  "SAGAR COLLEGE OF EDUCATION",
  "UMALOK SCHOOL OF NURSING MEERUT",
  "RAM ADHAR NURSING COLLEGE, AMBEDKARNAGAR",
  "RAMA SCHOOL OF NURSING KANPUR",
  "RAMNIHORA INSTITUTE OF NURSING AND PARAMEDICAL ALLAHABAD",
  "RamSingh College Of Engg. And Technology",
  "R K POLYTECHNIC",
  "R K SCHOOL OF NURSING",
  "R P YADAV SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA BARIDIHA MAHULI SANT KABIR NAGAR UP",
  "R.S.S.College",
  "RUCHI INSTITUTE OF CREATIVE ARTS",
  "RUDRA GROUP OF INSTITUTIONS",
  "RUMA INSTITUTE OF MEDICAL SCIENCES",
  "SAI HOSPITAL AND SCHOOL OF NURSING",
  "VARANASI COLLEGE OF NURSING VILL-SARAI TAKKI, POST-RAMAI, NEAR BABATPUR AIRPORT VARANASI",
  "SAMS INSTITUTE OF TECHNOLOGY, VARANASI",
  "SURYA POLYTECHNIC FOR ENGINEERING & TECHNOLOGY HAPUR",
  "Upkar School of Nursing Vill Shahpur Jatt Hapur",
  "SMT VIDYAWATI SCHOOL OF NURSING JHANSI",
  "S.P.M. NURSING COLLEGE, KANPUR",
  "SRIDUTT  SINGH INSTITUTE FOR TEACHER TRAINING",
  "SRI KRISHNA SCHOOL OF NURSING",
  "MAA SHAHAZADI DEVI MEMORIAL SCHOOL OF NURSING, BIJARVA POST BANKAT AZAMGARH",
  "Jhunjhunwala Institute of Medical Sciences",
  "Ananda school of nursing",
  "A P S COLLEGE OF EDUCATION AND TECHNOLOGY VILL KHIWAI ROHTA ROAD POST AND TEHSIL SARDHANA MEERUT",
  "SHIVA POLYTECHNIC INSTITUTE AND MGT. COLLEGE",
  "ASHADEEP NURSING COLLEGE AND PARAMEDICAL",
  "SARASWATHI INSTITUTE OF PARAMEDICALS ANWARPUR PILKHUWA HAPUR",
  "SBM TEACHER TRANING AND REHABILITATION CENTRE",
  "JAI SHREE COLLEGE OF PHARMACY",
  "SS COLLEGE OF PHARMACY, ALIGARH",
  "YADUVANSH PRASAD MISHRA INSTITUTE OF PHARMACY, MAHARAJGANJ",
  "R P POLYTECHNIC COLLEGE DEORIA",
  "BAHADUR YADAV COLLEGE OF PHARMACY NAGAR PANCHAYAT BHATNI DEORIA",
  "JAMUNA PRASAD MEMORIAL COLLEGE OF PHARMACY, Bareilly",
  "CHANDAN MEMORIAL VIKLANG VIKAS SAMITEE, DEEP SPECIAL TEACHERS TRAINING CENTRE",
  "MAA YASHODA MEMORIAL SHIKSHAK PRASHIKSHAN SANSTHAN",
  "PARVARISH SCHOOL",
  "PYSSUM RESEARCH AND TRAINING CENTRE",
  "SRI SHARDA INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "SRI KOMAL SAHU SMARAK PHARMACY COLLEGE, POONAPAR SAGARI AZAMGARH",
  "DEWAN V.S. INSTITUTE OF MANAGEMENT",
  "SKGN COLLEGE OF PHARMACY, GORAKHPUR",
  "SEEMAWARTI COLLEGE OF PHARMACY, BAHRAICH",
  "SISHODIYA PHARMACY COLLEGE,GORAKHPUR",
  "PACIFIC COLLEGE OF PHARMACY GORAKHPUR",
  "CHANDRA COLLEGE OF PHARMACY",
  "LAXMI HEALTH CARE PARAMEDICAL COLLEGE AND HOSPITAL KUTTUPUR KHANPUR",
  "SHRI RAWATPURA SARKAR INSTITUTE OF PARAMEDICAL SCIENCES",
  "HEALTH WORKER FEMALE TRAINING CENTRE, MAHOBA",
  "HEALTH WORKER FEMALE TRAINING CENTRE, NEHTAUR, BIJNOR",
  "HEALTH WORKER FEMALE TRAINING CENTRE, BALLIA",
  "S K MISHRA COLLEGE OF PHARMACY VILL BALPUR POST SARAIPALTU TEH LALGANJ DIST AZAMGARH",
  "HEALTH WORKER FEMALE TRAINING CENTRE, MEERUT",
  "HEALTH WORKER FEMALE TRAINING CENTRE, BASTI",
  "HEALTH WORKER FEMALE TRAINING CENTRE, ETAWAH",
  "HEALTH WORKER FEMALE TRAINING CENTRE, SULTANPUR",
  "HEALTH WORKER FEMALE TRAINING CENTRE, HAPUR",
  "HEALTH WORKER FEMALE TRAINING CENTRE, BAREILLY",
  "HEALTH WORKER FEMALE TRAINING CENTRE, RAE BARELI",
  "S S D NURSING COLLEGE",
  "GOPINATH NURSING AND PARAMEDICAL COLLEGE",
  "RAM TEERATH COLLEGE NURSING",
  "B H S COLLEGE OF NURSING GOVINDPUR AZAMGARH",
  "DEVBHOOMI COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "SHANTI NIKETAN COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "NIRMALA DEVI NURSING AND PARAMEDICAL INSTITUTE JAUNPUR",
  "PRATEEK SINGH INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "PIST NURSING COLLEGE",
  "RADHA GOVIND INSTITUTE OF MEDICAL SCIENCES CHANDAUSI SAMBHAL",
  "URS NURSING INSTITUTE",
  "R B COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "INDRAPRASTHA NURSING COLLEGE",
  "R N NURSING COLLEGE",
  "LUCKNOW SCHOOL OF NURSING",
  "COL JP TRIPATHI NURSING COLLEGE",
  "RANJINI MADAN SCHOOL OF NURSING AND PARAMEDICALS",
  "YOGENDAR COLLEGE OF PHARMACY KAMHARIYA KHARIHANI AZAMGARH",
  "TULSI PHARMACY COLLEGE MAHRAHA BINDKI FATEHPUR",
  "CH RAM PRAKASH YADAV COLLEGE OF PHARMACY BADARIYA SORON",
  "VIRAJ COLLEGE OF PHARMACY",
  "KANCHAN PHARMACY COLLEGE",
  "RAM AKBAAL SHIVRANI PHARMACY COLLEGE",
  "PANCHSIDHA PHARMACY COLLEGE",
  "RAI KRISHAN PAL SINGH INSTITUTE OF PHARMACY",
  "SHARDA DEVI PHARMACY COLLEGE JHANSI",
  "BALAJI COLLEGE OF PHARMACY",
  "S A F E COLLEGE OF PHARMACY",
  "KRISHNA COLLEGE OF PHARMACY BIJNOR",
  "MANDAWAR COLLEGE OF PHARMACY",
  "ADARSH SHIKSHAN PRASHIKSHAN COLLEGE",
  "BAISWARA EDUCATION TRUST",
  "SANCHETNA INSTITUTE",
  "BHAVDIYA HEMARAJ VERMA TEACHERS TRAINING INSTITUTE",
  "JAGRANI COLLEGE OF PHARMACY",
  "SUN INSTITUTE OF PHARMACY",
  "SHIVAM COLLEGE OF EDUCATION AZAMGARH",
  "JP MEMORIAL PARAMEDICAL COLLEGE KAHANDIYA GANNE NARI BARI PRAYAGRAJ",
  "R K POLYTECHNIC COLLEGE",
  "AMBEDKAR INSTITUTE PHARMACY MIRZAPUR",
  "J S INSTITUTE OF PHARMACY",
  "D P S PHARMACY COLLEGE",
  "UMAPATI MAHADEV COLLEGE OF PHARMACY",
  "TARA DEVI INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "CHIRAG COLLEGE OF PHARMACY VILLAGE KAREEM NAGAR POST DULHUPUR",
  "SATYADEV INSTITUTE OF MANAGEMENT AND TECHNOLOGY (PHARMACY), BULANDSHAHR",
  "RADHA KRISHNA INSTITUTE OF AYURVEDIC PHARMACY AND MEDICAL SCIENCE,KANPUR NAGAR",
  "SMT RAMA AGRAHARI SHIKSHA AND BTC PRASHIKSHAN SANSTHAN",
  "BAHAN MAYAWATI COLLEGE OF PHARMACY",
  "MADHAV NETRA KENDRA",
  "BABA BHAWARNATH COLLEGE OF PHARMACY, AZAMGARH",
  "HAHNEMANN HOMEOPATHIC PHARMACY COLLEGE AIDHE LAMAHI VARANASI",
  "SANT SITARAM PHARMACY COLLEGE BASANTPUR SINDHORA VARANASI",
  "MAA KAILASHI BABURAM PANDEY COLLEGE OF PHARMACY AZAMGARH",
  "SHASHI COLLEGE OF PHARMACY",
  "SUSHMA INSTITUTE OF MEDICAL AND HIGHER STUDIES",
  "MOTILAL PHARMACY COLLEGE",
  "VAIDHYA COLLEGE OF PHARMACY, GHAZIPUR",
  "SANT BULA SATYANAM DAS BIRBAL PHARMACY COLLEGE",
  "BABA PARAS NATH COLLEGE OF PHARMACY AND PARAMEDICAL SCIENCE BARABANKI",
  "SS INSTITUTE OF PHARMACY",
  "MAA SHARDA COLLEGE OF PHARMACY JALALABAD GHAZIPUR",
  "MK RAI DEEP ADARSH PHARMACY COLLEGE AZAMGARH",
  "SANT BULA CHHOTU YADUVANSHIY COLLEGE OF PHARMACY",
  "SHASHI INSTITUTE OF PHARMACEUTICAL SCIENCE AND RESEARCH JAUNPUR",
  "SUSHILA DEVI OMPRAKASH PHARMACY COLLEGE  MIRZAPUR KHURD MIRZAPUR",
  "SUBHASH SINGH COLLEGE OF PHARMACY, AZAMGARH",
  "GOVERNMENT POLYTECHNIC SALON",
  "MAHARISHI PATANJALI POLYTECHNIC OF INFORMATION TECHNOLOGY, KARINAILGANJ, GONDA",
  "AMARNATH COLLEGE OF PHARMACY",
  "BALDEV SHRIDHAR NURSING INSTITUTE",
  "ADITYA VIKRAM SINGH PHARMACY COLLEGE",
  "GYANDEEP COLLEGE OF PHARMACY, HARDOI",
  "MAHALAXMI PHARMACY COLLEGE VILL NANGLI ESA MAWANA ROAD MEERUT",
  "SURUCHI UCHCH SHIKSHA SANSTHAN",
  "APMIT TEACHERS EDUCATION INSTITUTE",
  "AKSHAR JYOTI ACADEMY",
  "MAA KAMLA HOMOEOPATHIC PHARMACY COLLEGE",
  "UMA SHANKAR SHASTRI PHARMACY COLLEGE , GHAZIPUR",
  "KANHAIYA COLLEGE OF PHARMACY, JAUNPUR",
  "RAHMANIYA D PHARMA COLLEGE, MAU",
  "ALIGARH SCHOOL OF NURSING, ANOOP SHAHAR ROAD NEAR FM TOWER, ALIGARH",
  "SHREE MAHAVIR COLLEGE CHITTRAI TUNDLA",
  "SAMA MAHENDRA COLLEGE OF EDUCATION, DHIRJIJOT, SIKHADI, JAKHANIYA, GHAZIPUR",
  "ERAM VIDYALAYA, MEERPUR SUDYAMAU BARABANKI",
  "MAHATMA BUDDHA LOK KALYAN EVAM GRAMYA VIKAS SANSTHAN GAURI ROAD LUCKNOW",
  "KUNWARI CHNANDRAWATI COLLEGE OF EDUCATION GHATAMPUR MUMTAZ NAGAR AYODHYA",
  "SBS INSTITUTE BANDA",
  "ERAM VIDYALAYA, RASOOLPUR HOUSE JAHANGIRABAD",
  "KRS SHIKSHAN PRASHIKSHAN SANSTHAN  BALLIPUR NAWABGANJ GONDA",
  "CHANDRABALI SINGH URMILA SHIKSHAN PRASHIKSHAN SANSTHAN KUMARGANJ",
  "SHRI VISHNU COLLEGE OF PHARMACY",
  "SHOBHA COLLEGE OF PHARMACY RAMPUR POKHARAPAR DEORIA",
  "SMT VIMLA DEVI COLLEGE OF PHARMACY BHADAR SONKH MATHURA",
  "ITM COLLEGE OF HOMOEOPATHIC PHARMACY CHEHARI MAHARAJGANJ",
  "RAMJANAM SARASWATI SMARAK PHARMACY COLLEGE,  GHAZIPUR",
  "DAYARAM VERMA COLLEGE OF PHARMACY, AMBEDKAR NAGAR",
  "SMT GYAN KUMARI SINGH COLLEGE OF PHARMACY, GORAKHPUR",
  "VATSALYA INSTITUTE OF PHARMACY",
  "BHAGIRATHI COLLEGE PHARMACY, AMBEDKARNAGAR",
  "NEELKANTH COLLEGE OF EDUCATION JAUNPUR",
  "MAHATMA BUDDHA MAHAVIDYALYA, KHAJUHA, KAUSHAMBI",
  "SHRI JAI NARAYAN COLLEGE OF PHARMACY DURGIPUR BERUARBARI BALLIA",
  "MAA SHARDA INSTITUTE OF TECHNOLOGY SHAMBHUPUR GAHAJI AZAMGARH",
  "DR. RIZVI COLLEGE OF PHARMACY",
  "PHARMACY COLLEGE BEHAT SAHARANPUR",
  "SUNDERPUR PHARMACY COLLEGE",
  "LOTUS INSTITUTE OF EDUCATION AND RESEARCH",
  "RANJEET COLLEGE OF AYURVED PHARMACY GOSAIGANJ AYODHYA",
  "BHAGIRATHI KAMLA SHIKSHAN PRASHIKSHAN SANSTHAN",
  "BPS COLLEGE OF PHARMACY",
  "CHAUDHARY INSTITUTE OF PHARMACY",
  "D A V COLLEGE OF PHARMACY JAUNPUR",
  "KAMAKHYA SCHOOL OF PHARMACY",
  "KVS COLLEGE OF PHARMACY",
  "MAA BHAGWATI COLLEGE OF PHARMACY CHHIBRAMAU KANNAUJ",
  "SHANTI NIKETAN COLLEGE OF PHARMACY",
  "SHRI NAWAB SINGH COLLEGE OF PHARMACY",
  "SWAMI RAMANAND COLLEGE OF PHARMACY",
  "GANPAT SAHAI COLLEGE OF PHARMACY",
  "AMAN COLLEGE OF PHARMACY, Muzaffarnagar",
  "SHRI LOKMANI SHARMA COLLEGE OF PHARMACY , MATHURA",
  "DEE TEE COLLEGE",
  "ACCURATE INSTITUTE OF POLYTECHNIC",
  "DAKSH VIDYAPEETH",
  "S B COLLEGE OF PHARMACY, AZAMGARH",
  "GSM COLLEGE OF PHARMACY",
  "JSM COLLEGE OF PHARMACY",
  "LMS COLLEGE OF PHARMACY",
  "CHAUDHARY INSTITUTE OF TECHNOLOGY, BALLIA",
  "J D COLLEGE OF PHARMACY",
  "LUCKNOW MODEL COLLEGE OF NURSING",
  "BABURAM RUKMANI DEVI HIGHER SECONDARY SCHOOL",
  "S D J P  HOMEOPATHIC PHARMACY COLLEGE",
  "DR BANDANA COLLEGE OF PHARMACY",
  "AYODHYA PRASAD SINGH SIKSHAN PRASIKSHAN SANSTHAN",
  "KHUSHI INSTITUTE OF EDUCATION SAUNRA FATEHPUR",
  "BHAVDIYA MEDICAL COLLEGE AND INSTITUTE OF NURSING AYODHYA",
  "B S R COLLEGE OF PHARMACY",
  "BULANDSHAHR COLLEGE BULANDSHAHR SCHOOL OF PHARMACY",
  "MUNSHI RAM DHANI JAGROOP SINGH MAHAVIDYALAYA PHARMACY,KAUSHAMBI",
  "YOGIRAJ COLLEGE OF PHARMACY AND RESEARCH CENTER",
  "R.D.Singh Memorial Institute",
  "SKD COLLEGE OF PHARMACY",
  "S S MEMORIAL COLLEGE OF PHARMACY",
  "ARIHANT INSTITUTE OF PHARMACY",
  "DR RAJESH POLYTECHNIC INSTITUTE AKAVASPATTI BHITARI GHAZIPUR",
  "SHRI JAMUNA PRASAD MAURYA COLLEGE OF PHARMACY",
  "MAA BHAGWATI MAHAVIDHYALYA DEPARTMENT OF PHARMACY, ALIGARH",
  "BALADEVI ROSHANLAL COLLEGE OF PHARMACY ,PILIBHIT",
  "A P S COLLEGE OF PHARMACY , HARDOI",
  "CH GAJRAJ SINGH PHARMACY COLLEGE",
  "MANRAJI DEVI COLLEGE OF PHARMACY",
  "MODERN MAHAVIDYALAYA",
  "SHIVA COLLEGE OF PHARMACY",
  "GURU SAHAY COLLEGE OF PHARMACY",
  "R S N PHARMACY COLLEGE, SAMMOPUR, THEKMA, AZAMGARH",
  "PT MAHAVIR PRASAD COLLEGE OF PHARMACY",
  "CHIRAG COLLEGE OF PHARMACY KAREEM NAGAR DULHUPUR AMBEDKAR NAGAR",
  "PVT COLLEGE OF PHARMACY KATHTARAWN MAU",
  "SHIVMURTI YADAV COLLEGE OF AYURVEDIC PHARMACY",
  "BABA VISHWANATH PHARMACY COLLEGE, AZAMAGRH",
  "SHAMBHU NATH COLLEGE OF PHARMACY, MAU",
  "K D S  COLLEGE OF NURSING AND PARAMEDICAL",
  "SHANTI INSTITUTE OF TECHNOLOGY AND PHARMACY",
  "SHRI HEERA LAL SMARAK COLLEGE OF PHARMACY, RAMPUR",
  "Vaidya Chhotelal Chikitsa Vigyan Sansthan, Manduadeeh, Varansi",
  "N B S COLLEGE OF PHARMACY, SULTANPUR",
  "SHRI SADABRIKSH SARASWATI PHARMACY COLLEGE , DEORIA",
  "RAM NAVAL SINGH COLLEGE OF PHARMACY, MAU",
  "JPC INSTITUTE OF PHARMACY , BASTI",
  "ACHARYA RAMESH CHANDRA COLLEGE OF PHARMACY, BAHRAICH",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING SONBHADRA",
  "AKHIL INSTITUTE OF NURSING AND PARAMEDICAL COLLEGE",
  "BANSAL INSTITUTE OF MEDICAL SCIENCE MEERUT",
  "EVEREST COLLEGE OF  PHARMACY",
  "HARI PRASAD CHANDRAWATI COLLEGE OF PHARMACY AMBEDKARNAGAR",
  "KDS COLLEGE OF PHARMACY,UTTAM NAGAR,BEDNAPUR,BAHRAICH",
  "KHALSA COLLEGE OF PHARMACY",
  "THA BACCHOO SINGH EDUCATIONAL INSTITUTE JAROLI SHAMSHABAD AGRA",
  "PANCHSHIL TEACHERS TRAINING INSTITUTE",
  "VIDYA DEVI WOMEN INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "BLOOMING BUDS DEEGREE MAHILA BTC COLLEGE KHALILABAD SANT KABIR NAGAR",
  "DR. S N INSTITUTE OF EDUCATION",
  "R R SHIKSHA SANSTHAN SAJHAULI CHUNAR MIRZAPUR",
  "BAIJNATH RAMNARESH SIKSHAN PRASIKSHAN MAHAVIDYALAY",
  "DIVYA SHIKSHA MANDIR",
  "DSM VIDYAPEETH",
  "ALIGARH COLLEGE OF PHARMACY",
  "D A V COLLEGE OF PHARMACY, RAUNAKHURD, VARANASI",
  "MAA PRABHAVATI COLLEGE OF PHARMACY AZAMGARH",
  "MAA SHARDEY COLLEGE OF PHARMACY ALIGARH",
  "NAV DURGA ALLOPATHIC PHARMACY COLLEGE KHASROPUR BASKHARI AMBEDKAR NAGAR",
  "NK COLLEGE OF PHARMACY PRAYAGRAJ",
  "P S A COLLEGE OF PHARMACY AZAMGARH",
  "SHAMBHUNATH COLLEGE OF PHARMACY TINAHARI MAU",
  "S J B COLLEGE OF PHARMACY AZAMGARH",
  "SMT URMILA DEVI COLLEG OF PHARMACY,  AURAIYA",
  "RAM AWADH SINGH COLLEGE OF PHARMACY, MAU",
  "LASANTE COLLEGE OF AYURVEDIC",
  "MAHADEV MAHENDRA PHARMACY COLLEGE, CHANDAULI",
  "VATS CHANDRAKALA NAGINA COLLEGE OF EDUCATION UP",
  "VINDHYANCHAL JI COLLEGE KARKAPUR, GHAZIPUR",
  "Lord Shiva College",
  "MIRZA AHSANULLAH BEG SHIKSHAN PRASHIKSHAN SANSTHAN ANJANSHAHEED AZAMGARH",
  "JAVITRI COLLEGE OF PHARMACY , LUCKNOW",
  "JAVITRI INSTITUTE OF MEDICAL SCINCE AND PHARMACY DIVISION",
  "SOVRAN SINGH MAHAVIDYALAYA STREET NUMBER SURAYANDA VILL SURAYANDA POST PHOOLPURTEHSIL AJEETMAL DIST AURAIYA UTTAR PRADESH",
  "SMT VIMLA SINGH MEMORIAL COLLEGE OF EDUCATION AND MANAGEMENT",
  "BABA PAUHARI SHIKSHAN PRASHIKSHAN KENDRA PACHKHORA AZAMGARH",
  "RDJS TECHNICAL COLLEGE OF HIGHER EDUCATION",
  "OM PRAKASH MISHRA SHIKSHAN PRASHIKSHAN SANSTHAN MOLNAPUR AHMADBAKSH PHULESH AZAMGARH",
  "SARDAR BALLABH BHAI PATEL INSTITUTE OF PHARMACY",
  "SHRI TRIDANDI SWAMI KANYA VIDYALAY",
  "SONI VIKAS SHIKSHAN PRASHIKSHAN SANSTHAN KAILHAT MIRZAPUR",
  "SARDAR PATEL SHIKSHAN SANSTHAN TEJALHERA",
  "AAKANKSHA INSTITUTE OF TEACHER EDUCATION",
  "SHREE PRAKASH COLLEGE OF PHARMACY,  AZAMGARH,",
  "PT SATYA NARAYAN DWIVEDI COLLEGE OF PHARMACY, SULTANPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BULANDSHAHAR",
  "GOVERNMENT POLYTECHNIC, KAIMGANJ FARRUKHABAD",
  "ARYAKUL INSTITUTE OF PHARMACY RAEBARELI",
  "EMERALD AYURVEDIC ACADEMY",
  "GHANSHYAM COLLEGE OF PHARMACY",
  "KAMTA PRASAD AYURVEDIK PHARMACY COLLEGE JAGESARGANJ DULLAPUR AKBARPUR AMBEDKAR NAGAR",
  "RAMESH COLLEGE OF PHARMACY, GHAZIPUR",
  "RAMASHRAY SINGH INSTITUTE OF AYURVEDIC PHARMACY AND NURSING BASTI, KHIRIYAN, MAU",
  "SAI AYURVEDIC PHARMASIST AND UPACHARIKA PRAKISHAN COLLEGE",
  "SAI COLLEGE OF HOMEOPATHIC PHARMACY",
  "SARDAR PATEL SMARAK COLLEGE OF PHARMACY",
  "SHRI GIRRAJ MAHARAJ COLLEGE OF PHARMACY",
  "SMRITI  PATEL COLLEGE OF PHARMACY",
  "SWAMI VIVEKANAND INSTITUTE SHAHZADPUR AKBARPUR AMBEDKAR NAGAR",
  "SW DEVRAJ DARBARI DUKHANTI SAINIK KISAN PAIRAMEDICAL INSTITUTE, PACHAIPATTI MAKHDOOMPUR, GHAZIPUR",
  "UNURKHA TIWARI DANPATI COLLEGE OF HOMIOPATHIC PHARMACY BEWANA AMBEDKAR NAGAR",
  "VISHNU BHAGWAN COLLEGE OF PHARMACY",
  "KAYAM SINGH PHARMACY COLLEGE AURANDH",
  "BALAJI NURSING AND PARAMEDICAL PHARMACY COLLEGE GHAZIPUR",
  "KAMTA PRASAD HOMEOPATHIC PHARMACY COLLEGE JAGESARGANJ DULLAPUR AMBEDKAR NAGAR",
  "OM JEE WOMEN COLLEGE OF EDUCATION, OMNAGAR, JAKHANIYA, GHAZIPUR",
  "SW KISHUN CHANDRA BAKHARI BABA MAHAVIDYALAY",
  "BHARTIYA VIDYAPEETH AYURVEDIC NURSING AND PHARMACY COLLEGE",
  "DAYANAND YADAV COLLEGE OF PHARMACY",
  "DHARMDEO COLLEGE OF PHARMACY",
  "DR SHYAMA PRASAD MUKHARJEE COLLEGE OF PHARMACY, MAU",
  "RAJDHARI SINGH COLLEGE OF PHARMACY, GHAZIPUR",
  "HARIPAL JI COLLEGE OF PHARMACY, MAU",
  "SAI COLLEGE OF PHARMACY, BARABANKI",
  "SEIKO COLLEGE OF PHARMACY AND NURSING",
  "SHAMBHUNATH NARAYAN COLLEGE OF PHARMACY HARHARI GHAZIPUR",
  "SUNITA NURSING AND PARAMEDICAL COLLEGE GRAM BELAPAR (HAYATGANJ) BAKSHA JAUNPUR",
  "SPRINGER TRAINING CENTRE, USRA BAZAR",
  "TNG INSTITUTE OF PARAMEDICAL SCIENCES",
  "RAMNATH MUNSHI COLLEGE OF NURSING AND PHARMACY SADAT GHAZIPUR",
  "DR S K MISHRA ANITA PHARMACY COLLEGE, AZAMGARH",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING GHAZIPUR",
  "DR R S AYURVEDIC PHARMACIST AND NURSING COLLEGE VIKRAMPUR KHALISPUR VARANASI",
  "AFZALGARH PHARMACY COLLEGE, DHAMPUR ROAD AFZALGARH BIJNOR",
  "BABUAJEE COLLEGE OF PHARMACY JAMSARAPINDI DEORIA",
  "BABU KAMTA SINGH COLLEGE OF PHARMACY, LAFIYA LALGANJ AZAMGARH",
  "B D R COLLEGE OF HOMEOPATHIC PHARMACY, BELAU THEKMA AZAMAGRH",
  "DHAMPUR COLLEGE OF PHARMACY",
  "GAURA COLLEGE OF PHARMACY",
  "HUKAM SINGH AYURVEDIC MEDICAL COLLEGE AND HOSPITAL NANAUTA SAHARANPUR",
  "J N SHAHI COLLEGE OF PHARMACY",
  "K N SINGH COLLEGE OF PHARMACY, JIYANPUR, SAGARI, AZAMGARH",
  "VINOD KUMAR INSTITUTE OF HOMEOPATHIC PHARMACY MAHMOODPUR SEMRI SULTANPUR",
  "SHABARI BALIKA MAHAVIDYALAYA",
  "SHRI KRISHNA NURSING AND PHARMACY COLLEGE",
  "MAA CHANDRIKA DEVI INSTITUTE AND RESEARCH CENTRE, BKT, LUCKNOW",
  "PROF N M INSTITUTE OF PARAMEDICAL SCIENCES CHINHAT LUCKNOW",
  "SONELAL MEMORIAL INSTITUTE OF PARAMEDICAL SUBHAN KHERA HARDOI",
  "SRM AYUSH INSTITUTE OF MEDICAL SCIENCES LUCKNOW",
  "ST MARYS INSTITUTE OF PARAMEDICAL SCIENCES LUCKNOW",
  "SUBHAWATI COLLEGE OF PHARMACY , GHAZIPUR",
  "MORADABAD AYURVEDIC CHIKITSA SANSTHAN",
  "SANJAY MISHRA COLLEGE OF PHARMACY MALIHAMAU HARDOI",
  "SRIJAN COLLEGE OF PHARMACY",
  "SRIMATI GUJRATI DEVI HOMEOPATHIC PHARMACY COLLEGE, GADANPUR HICHCHHANPATTI AZAMGARH",
  "Ashirwad Nursing and Paramedical College, Village Chhitauna, Dubeypur, Jalalpur, Jaunpur",
  "OM JI MAHAVIDYALAYA, GAURA KHAS, JAKHANIYA, GHAZIPUR",
  "PREM INSTITUTE OF PHARMACY, ALIGARH",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING RAI BAREILLY",
  "RADHA GOVIND POLYTECHNIC COLLEGE, SAMBHAL",
  "GOEL INSTITUTE OF TECHNOLOGY AND MANAGEMENT DIPLOMA DIV",
  "GOVERNMENT GIRLS POLYTECHNIC, SADAR, MIRZAPUR",
  "DR VIJAY COLLEGE OF PHARMACY KAITHI VARANASI",
  "J K CANCER INSTITUTE KANPUR",
  "SHRI KOMIL SINGH SHANTI DEVI MAHAVIDYALAYA",
  "BR PHARMACY COLLEGE",
  "DNV PARAMEDICAL AND PHARMACY COLLEGE",
  "MAA SHRINGARI DEVI COLLEGE OF PHARMACY, AZAMGARH",
  "MAHARISHI CHARAK AYURVEDIC PHARMCIST AND NURSING TRAINING CENTER",
  "MRS PARAMEDICAL INSTITUTE VPO BALIPUR TEHSIL SIRSAGANJ DIST FIROZABAD",
  "NAVYUG UPCHARIKA PARSHIKSAHAN COLLEGE VILL POST KOTA SAHARANPUR",
  "P.M.V. POLYTECHNIC MATHURA",
  "SHAKUNTALA HOMOEOPATHIC PHARMACY COLLEGE, SURWAT",
  "ULTRA MODERN COLLEGE OF PHARMACY, AZAMGARH",
  "SAMARPAN PHARMACY COLLEGE, AZAMGARH",
  "R K SINGH INSTITUTE OF AYURVED NURSING PHARMACY AND RESEARCH RAGAULI CHITRAKOOT",
  "SHRI BABU SINGH COLLEGE OF PHARMACY",
  "MRIDUL TUSHAR COLLEGE OF PHARMACY, AGRA",
  "SHRI KOMIL SINGH COLLEGE OF PHARMACY , KANNAUJ",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING MATHURA",
  "KUNWAR HARIBANSH SINGH INSTITUTE OF NURSING & PARAMEDICALS, JAGARNATH PATTI JAUNPUR",
  "PREMCHAND COLLEGE OF PHARMACY, SALIKPUR SAURI, GHAZIPUR",
  "RJGS COLLEGE OF PHARMACY",
  "DAYA SARASWATI NURSING PARAMEDICAL COLLEGE JAUNPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING RAMPUR",
  "KAMAYANI SHIKSHAK PRASHIKSHAN KENDRA",
  "Janaki Prasad Chaudhary B.T.C. College",
  "K.L. POLYTECHNIC BHARAURA MALHANI JAUNPUR",
  "DR RPS INSTITUTE OF EDUCATION",
  "PREM EDUCATIONAL INSTITUTE",
  "Late Nageshwari Devi Educational Training Institute",
  "JAYANT DEV DHAR DUBEY COLLEGE OF EDUCATION, TILAURA (MAINAPAR) PALI SAHJANWA GORAKHPUR",
  "NOBLE ACADEMY",
  "MAA BALIRAJI SEWA SANSTHA",
  "RAM MURAT SMARAK SHIKSHAN SEVA SAMEETI VILL BASIRHAN POST GAMBHIRPUR AZAMGARH",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, SANT KABIR NAGAR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING SHAHJAHANPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, VARANASI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING UNNAO",
  "PT RAM CHARITRA RAMADHAR BALIRAM INSTITUTE OF EDUCATION",
  "GAYATRI COLLEGE OF ENGG ANDTECHNOLOGY",
  "SHARADA DEVI MEMORIAL AYURVEDIC COLLEGE OF EDUCATION, USRAULI, SHAHGANJ, JAUNPUR",
  "RISHI RAM NARESH TECHNICAL INSTITUTE",
  "SHIV BHAGWAN SHIV SHIKSHA SANKAY COLLEGE",
  "ARYAN COLLEGE OF PROFESSIONAL EDUCATION",
  "VISHWAMITRA COLLEGE OF EDUCATION",
  "BABA BIHARI LAL INSTITUTE OF MEDICAL SCIENCES AMBEDKAR NAGAR",
  "GOVERNMENT POLYTECHNIC, SANDILA, HARDOI (PPP MODE)",
  "MAA MURATI COLLEGE OF PHARMACY, AZAMGARH",
  "SADGURU SHRI SEETADAS COLLEGE OF PHARMACY, GHAZIPUR",
  "SHRI BABU SINGH DADDU JI COLLEGE OF PHARMACY FARRUKHABAD",
  "SHRI RADHE KRISHNA AYURVEDIC PARAMEDICAL NURSING COLLEGE DHUAI ETAH",
  "C D SINGH COLLEGE OF PHARMACY RAGHOPUR RASRA BALLIA",
  "CHARAK PARA MEDICAL COLLEGE",
  "FATIMA AYURVEDIC COLLEGE OF PHARMACY AND NURSING",
  "HARI PRASAD CHANDRAWATI COLLEGE OF PHARMACY AMBEDKARNAGAR",
  "MAA GAYATRI INSTITUTE OF PHARMACY COLLEGE",
  "R G COLLEGE OF AYURVEDIC AND NURSING",
  "GOVT.POLYTECHNIC CHHABILHAKHOR SADAR BASTI",
  "Arjun Singh Mahavidhyalaya",
  "Mata Pyari Devi Shiksha Evam Prashikshan Sansthan",
  "Haripal Ji Smarak Mahavidyalaya",
  "ABHAY COLLEGE OF EDUCATION CHAUBEYPUR KHURD VARANASI",
  "BABA NAGESHWAR JI SANSTHAN",
  "CHAUDHARY MADAN PRASAD SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA GAUHANIA KHALEELPUR SIDDHARTHNAGAR",
  "HARE KRISHNA COLLEGE",
  "LAL BAHADUR SHASTRI SMARAK P G COLLEGE",
  "MAA JANAKRAJI RAM SARIKHAN SHIKSHAK PRASHIKSHAN VIDYALAYA JAMUWA AZAMGARH",
  "MP INSTITUTE OF MANAGEMENT AND COMPUTER APPLICATION , BHAGATUA , AMAULI ,VARANASI",
  "PRO DEENANATH PANDEY SHIKSHA EVAM PRASHIKSHAN SANSTHAN BADAUSA BANDA",
  "RAM GULAM RAI SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA",
  "R K B N ACADEMY SHIKSHAN AVAM PRASHIKSHAN  SANSTHAN",
  "SONA NANDAN TEACHERS TRAINING INSTITUTE PLOT NO THREE HUNDRED TWENTY NINE DHERAPUR KALICHABAD JAUNPUR",
  "SRIPATI SINGH KAUSHILYA DEVI SIKSHAN PRASIKSHAN SANSTHAN MAU",
  "VEER BAHADUR SINGH B T C COLLEGE",
  "VISHWANATH SINGH TEACHERS TARINING INSTITUTEGULARIHA PURWA UNNAO",
  "GAJRAJ SINGH POLYTECHNIC AHARPUR JAMUNIYA JAUNPUR",
  "DR MP SINGH COLLEGE OF PHARMACY HIMMATGANJ RAFINAGAR BILSI BUDAUN",
  "SIR MU COLLEGE OF PHARMACY",
  "SARASWATI CHERITABLE TRUST P NO THREE HUNDRED FIVE EIGHT VI GUDBADI PO GAIRWAH TEH SHAHGANJ JAUNPUR",
  "Balaji College",
  "ACHARYA NARAYANA COLLEGE MEERPUR PRATAPPUR BELWAI SULTANPUR",
  "BABA GAJJAN DAS VIDYALAYA",
  "DHARMADEI KISHOR MAHAVIDYALAYA BADDHUPUR SADAR GHAZIPUR",
  "DR SHAMBHOONATH SHIKSHAN PRASHIKSHAN SANSTHAN, MEERPUR PYAREPUR, BAHARIYABAD, GHAZIPUR",
  "KRISHNA INSTITUTE OF EDUCATION, TENDULI PALIGARH, MAU",
  "LATE BHAGWANT PATEL PANMATI DEVI PG COLLEGE , CHANDERPUR , BASAHIYA BUJURG , MAHARAJGANJ",
  "MATRI GANGAJALI DEGREE COLLEGE",
  "NEEL KANTH COLLEGE OF EDUCATION REHATI TRILOCHAN MAHADEV JAUNPUR",
  "RADHESHYAM COLLEGE OF EDUCATION HAZIPUR SINGHPUR MUMTAJ NAGAR AYODHYA",
  "SAI COLLEGE OF EDUCATION",
  "SHRI GAJADHAR SINGH COLLEGE OF EDUCATION",
  "FATIMA PHARMACY COLLEGE, BALRAMPUR",
  "SHRI PALAKDHARI SHIKSHA EVAM PRASHIKSHAN SANSTHAN",
  "SHRI PL MEMORIAL DEGREE COLLEGE",
  "MAA BHAGAWATI SHIKSHAN PRASHIKSHAN SANSTHAN",
  "RADHIKA COLLEGE PLOT NO ONE THOUSAND NINE HUNDRED FIFTEY NINE HUNDRED FIFTEY ONE KUDDUPUR JAUNPUR",
  "SARVODAYA VIGYAN PRAUDYOGIKI MAHAVIDYALAYA SANGIPUR",
  "SARYU INDRA EDUCATIONAL TRAINING  INSTITUTE SANGRAMGARH KUNDA PRATAPGARH",
  "AAAKANKSHA COLLEGE OF  PHARMACY",
  "MAA BHAWANI BTC COLLEGE SOGAI CHANDAULI",
  "MAHARISHI PARASHURAM INSTITUTE OF HIGHER EDUCATION",
  "MATESHWARI SAKLA BAIJNATH SINGH EDUCATION TRAINING INSTITUTE",
  "RAM BHAJAN SINGH SHIKSHAN PRASHIKSHAN SANSTHAN",
  "RPS JANTA INTER COLLEGE RATUPURA THAKURDWARA MORADABAD",
  "SAI NATH COLLEGE OF TEACHER EDUCATION UJHANI BUDAUN",
  "SHAHEED BHAGAT SINGH MEMORIAL COLLEGE BEGAMPUR   SARSAWASAHARANPUR",
  "S S D EDUCATIONAL INSTITUTE",
  "SUNDER DEEP COLLEGE OF EDUCATION AND INFORMATION",
  "MATA DHANESHWARI SUSHILA DEVI SHIKSHAK SHIKASHAN PRASHIKSHAN SANSTHAN",
  "DR. GHANSHYAM SINGH B T C COLLEGE, GOSAIPUR, MOHAV, CHOLAPUR, CHAMRAHA BAZAR, VARANASI",
  "ANUBIS INSTITUTE OF MEDICAL SCIENCES",
  "G S  BTC TRAINING  COLLEGE",
  "GULJARI RAM DEHAL SHIKSHAN AND PRAKSHISHAN SANSTHAN SARAYBHOGI MACHALISHAHAR JAUNPUR",
  "RAM CHARITAR SMARAK SHIKSHAN PRASHIKSHAN, SANSTHAN, RAMPUR, JAHANAGANJ, AZAMGARH,",
  "ACHARY BALDEV SANSTHAN, PLOT NO. ONE THOUSAND SIXTY FOUR, KOPA, PATA RAHI, JAUNPUR",
  "PYARE LAL PRASHIKSHAN MAHAVIDYALAYA MEDUA ARAUL",
  "RMM COLLEGE OF PHARMACY BABURA MAHULIYA AMBEDKARNAGAR",
  "SUMIRTA AYURVEDIC PHARMACY COLLEGE HAIDERGANJ BAZAR KHAPRADEEH AYODHYA",
  "RORIA GROUP OF PHARMACY, ALIGARH",
  "FEKU SMARAK SHIKSHAN SANSTHAN, CHEWAR PASCHHIM, LALGANJ, AZAMGARH",
  "LBS COLLEGE OF PHARMACY , BARABANKI",
  "JBS INSTITUTE, DULHADEPUR TIKAIT NAGAR BARABANKI",
  "YADUPATI NURSING COLLEGE AND HOSPITAL, KARMAHARI, DEVETHA, JAMANIA, GHAZIPUR",
  "SRI RAJARAM SHIKSHAN AVAM PRASHIKSHAN SANSTHAN",
  "VIJAY PRATAP INSTITUTE OF TECHNOLOGY ZAFRABAD JAUNPUR",
  "Kanti Devi College of Education",
  "Smt. Shyama Devi Degree College of Science and Management",
  "SMT SIYARAJI NAKCHHED TIWARI OMPRAKASH TIWARI VIDYALAY",
  "DADA BHARAT SINGH SHIKSHAN PRASHIKSHAN SANSTHAN KAILAHAT PACHEWARA CHUNAR MIRZAPUR",
  "HAZI ISMAIL SHIKSHAK PARSHIKSHAN SANSTHAN ITAI RAMPUR, BALRAMPUR",
  "MAA BABUNA BALIKA MAHAVIDYALAYA",
  "MAA DURGA SANSTHAN PANIHAR LEVARUVA KERAKAT JAUNPUR",
  "MAHAMAYA MAHILA MAHAVIDYALAYA",
  "MANYAVAR KANSIRAM SHIKSHAN EVAM PRASHIKSHAN SANSTHAN KASDAHAN SHUKLA BAZAR AMBEDKAR NAGAR",
  "SAI BABA SHIVRAJ SINGH CHAUHAN MAHAVIDYALAYA",
  "SHRI BANSI YADAV BAL GOPAL MAHAVIDYALAYA, SAIDPUR, GHAZIPUR",
  "SHRI CHHANNGUR SMARAK SHIKSHA PRASHIKSHAN SANSTHAN",
  "SMT SUMITRA DEVI TEACHERS TRAINING COLLEGE, BADGAHAN, AZAMGARH",
  "KRISHNA SCHOOL OF NURSING AND PARAMEDICAL SCIENCES, HUSENABAD KRISHNA COLONY NEAR JAYCEES CHAURAHA, JAUNPUR",
  "A R I M T PHARMACY COLLEGE, MEERUT",
  "DR RAM MANOHAR LOHIA MAHAVIDYALAYA, JHOTARI, GHAZIPUR",
  "KRISHNA INSTITUTE OF EDUCATION",
  "T D COLLEGE OF PHARMACY KASDHAN SHUKLBAZAR AMBEDKARNAGAR",
  "YASHODA MAHAVIDYALAYA PLOT NO EIGHTY SEVEN VILLAGE AND POST PATARAHI THE KERAKAT DIST JAUNPUR",
  "RAI RATAN BAHADUR SHIKSHAN PRASHIKSHAN SANSTHAN GADDOPUR JAUNPUR",
  "Pt. Sri Krishna Upadhyay Mahila Mahavidhyalaya",
  "J D COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING JALAUN",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING MAHARAJGANJ",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING MAU",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BALLIA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BANDA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BASTI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING FIROZABAD",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING MEERUT",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING MORADABAD",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING MUZAFFARNAGAR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING KANPUR DEHAT",
  "Shri Lachhiram Mahavidyalaya",
  "O P M COLLEGE OF PHARMACY",
  "BABA VISHWANATH COLLEGE OF PHARMACY ,DEORIA",
  "MAA SHIVMURTI COLLEGE OF PHARMACY, AZAMGARH",
  "M R D PHARMACY COLLEGE, Azamgarh",
  "R K AYURVEDIC NURSING EVAM PHARMACY INSTITUTE, KASHIPUR SURAI SATHIAON AZAMGARH",
  "M S D ADARSH HOMOEOPATHY COLLEGE, BAALPUR KHARAILA SARIPALTU AZAMGARH",
  "PT. THAKUR PRASAD TRIPATHI KISHAN DEGREE COLLEGE",
  "BABA BAIJNATH TRIPATHI COLAGE OF BTC KENOUNA BASTI",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING AGRA",
  "MOHAN MEMORIAL PRAYAG MAHAVIDYALAYA, KOTWALI RAMPUR MAJHA, GHAZIPUR",
  "M S R VIDYAPEETH",
  "RAM NAGINA SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA, PAHARPUR KALAN, SAIDPUR, GHAZIPUR",
  "SRI SAI RAM EDUCATIONAL COLLEGE",
  "GOVERNMENT POLYTECHNIC BAKSHI KA TALAB, LUCKNOW (PPP MODE)",
  "DS COLLEGE OF AYURVEDIC PHARMACY AND NURSING",
  "SHIV SHYAM PHARMACY COLLEGE",
  "R B COLLEGE OF TEACHER EDUCATION",
  "APRUP SHIKSHAN SANSTHAN",
  "DSSA MAHAVIDHYALAY DADANPUR AHIEAULI GHOSI MAU",
  "MAA VINDHYAVASINI SHIKSHAN PRASHIKSHAN SANSTHAN, KHORRAMPUR BELAU NIZAMABAD AZAMGARH",
  "SRI PARSHWA NATH MAHAVIDYALAYA, TIKARIYA, SITAPUR",
  "SHRI GANPATI INSTITUTE OF PHARMACY, AMBEDKAR NAGAR",
  "DR AMBEDKAR SHIKSHAN PRASHIKSHAN SANSTHAN KARAIN KADIPUR SULTANPUR",
  "HARSH GIRLS TEACHER TRAINING COLLEGE DEHLI BAZAR SULTANPUR",
  "RAMASHANKAR MAHAVIDYALAYA",
  "SUKHDEV KISHAN MAHILA MAHAVIDYALAYA, PHOOLPUR NAWABAD, JAKHANIYA, GHAZIPUR",
  "B R GAUTAM POLYTECHNIC INSTITUTE RAJAPUR RAMPUR JAUNPUR",
  "Purvanchal Sewa Sansthan",
  "SUMITRA DEVI GIRLS DEGREE COLLEGE ALI NAGAR KENJARA FIROZABAD",
  "VIDYA SAGAR ACADEMY MANT ROAD RAYA MATHURA",
  "GOVERNMENT POLYTECHNIC BANSHDEEH, BALLIA (PPP MODE)",
  "SHRIMATI SHANTI DEVI BTC PRASHIKSHAN SANSTHAN MAHRIPUR BASTI",
  "MAHAMAYA COLLEGE OF PHARMACY, AZAMGARH",
  "RAMYASH COLLEGE OF PHARMACY",
  "ADARSH COLLEGE OF PHARMACY, GHAZIPUR",
  "SAINIK NURSING AND PARAMEDICAL SCHOOL",
  "SHRI BABUSINGH JAI SINGH AYURVEDIC PARA MEDICAL AND NURSING COLLEGE BHAUPUR BEWAR ROAD FATEHGARH FARRUKHABAD",
  "KESHRAJI COLLEGE  OF PHARMACY AYODHYA",
  "SHEETLA PRASAD INSITITUTE OF MEDICAL SCIENCES",
  "RAM DEV INSTITUTE OF EDUCATION",
  "SHRIMATI GUJRATI DEVI SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA, GADANPUR HICHCHHANPATTI, PACHKHORA, SAGARI, AZAMGARH",
  "SHRI RAM ADHAR COLLEGE BAIRIYA AMEDA SAIDPUR GHAZIPUR",
  "BABA BALBHADRA SAHAI INSTITUTE OF EDUCATION AND TRAINING",
  "SAI NATH COLLEGE VIJAY KAMATHELA KUNDAL FATEHBAD ROAD AGRA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BIJNOR",
  "B D S COLLEGE OF PHARMACY ETAH",
  "R B S MAHAVIDHYALYA DEPARTMENT OF PHARMACY PATIYALI KASGANJ",
  "RBS NURSING AND PHARMACY COLLEGE",
  "R K INSTITUTE OF PHARMACY KORAON PRAYAGRAJ",
  "SATYAPRABHA COLLEGE OF PHARMACY",
  "SHIV NATH VERMA SMARAK MAHAVIDYALA",
  "SHREE PRAHALAD SMARAK AYURVEDIC PHARMACY AND NURSING COLLEGE SILTHARI CHURK ROBERTASGANJ SONBHADRA UP",
  "SHRI JILENDAR SINGH SMARAK COLLEGE OF PHARMACY MAINPURI",
  "SHRI KRISHNA COLLEGE OF PHARMACY SIPAH IBRAHIMABAD MAU",
  "SHRI RAMDAS COLLEGE OF PHARMACY",
  "PANDIT MARKANDEY CHATURVEDI SHIKSHAN SANSTHAN HARHARI GHAZIPUR",
  "P D R D SHIKSHA EVAM PRASHIKSHAN SANSTHAN, DHAMUPUR, GHAZIPUR",
  "PURUSHOTTAM INDRASAN SHIKSHAN PRASHIKSHAN BTC SANSTHAN DURKHUSHI MARDAH GHAZIPUR",
  "RIET VIDYAPEETH",
  "SHIVA COLLEGE OF EDUCATION",
  "SITA RAM RAMANAND SMARAK MAHAVIDYALAYA, SAMENDA AZAMGARH",
  "SLS PHARMACY AND NURSING COLLEGE",
  "Sir J.P. BTC College of Education Kewtali Maharajganj Jaunpur",
  "SUKHDEV HOMEOPATHIC PHARMACY COLLEGE, PHOOLPUR, NAVABAD, BUDHANPUR, GHAZIPUR",
  "VIDYA BHAVAN COLLEGE OF PHARMACY",
  "BRMH DUTT DWIVEDI PRABHA DWIVEDI MAHAVIDHYALAYA",
  "PT HARI SAHAY SHIKSHAN PRASHIKSHAN SANSTHAN JAITI BELGHAT GORAKHPUR",
  "GOVERNMENT MEDICAL COLLEGE, AMBEDKAR NAGAR",
  "MISSION COLLEGE OF PHYSIOTHERAPY CHRISTIAN HOSPITAL SEVA SANSTHAN CAMPUS HARBANSHPUR AZAMGARH",
  "S A S EDUCATIONAL INSTITUTE, AGRA",
  "Sri Bhawananad Sanskrit Mahavidyalaya",
  "PRAKASH MAHAVIDHYALAYA ETAH",
  "REHMAN COLLEGE OF PHARMACY, AZAMGARH",
  "SHAKUNTALA MEMORIAL EDUCATIONAL INSTITUTE OF PHARMACY",
  "VERMA SHYAMDULARI COLLEGE OF PHARMACY, AZAMGARH",
  "GAYA PRASHAD DIWEDI TEACHERS TRAINING INSTITUTE PREM KA PURA JAUNPUR",
  "RADHAKRISHNA PHARMACY COLLEGE, UNNAO",
  "MATA ASHARFI DEVI SHIKSHAN SANSTHAN BUDHANPUR SHADIYABAD GHAZIPUR",
  "SHRIMATI URMILA DEVI SHIKSHA PRASAR SANSTHAN BALLAPUR AURAIYA",
  "Kamla Pandey Shikshan Prashikshan Sansthan",
  "Beermati Vidya Mahavidyalaya",
  "R S COLLEGE OF PHARMACY,PRABHA NAGAR MAINPURI ROAD SHIKOHABAD",
  "SATYAM SHIVAM COLLEGE OF PHARMACY",
  "SHYAM KUMARI GROUP OF PHARMACY COLLEGE",
  "LATE SURYANATH SINGH AYURVEDIC PHARMACY COLLEGE DADANPUR AHIRAULI GHOSI MAU",
  "SMT FULEHRA SMARAK HOMOEOPATHIC DIPLOMA COLLEGE OF PHARMACY",
  "S P COLLEGE OF PHARMACY NAGLA DHEER FIROZABAD",
  "S R D COLLEGE OF PHARMACY",
  "SRIMATI FULEHRA SMARAK COLLEGE OF AYURVEDIC NURSING AND PHARMACY",
  "SWAMI VIVEKANAND COLLEGE OF PHARMACY KATHA DAL NARAINPUR SHUKLAGANJ UNNAO",
  "BEERMATI BTC COLLEGE",
  "C V DEGREE COLLEGE",
  "HAJI ISMAIL DEGREE COLLEGE SADULLAH NAGAR BALRAMPUR",
  "S K S COLLEGE OF PHARMACY",
  "BABA RAMDAL SURAJDEV INSTITUTE OF NURSING AND PHARMACY",
  "BANDA PARAMEDICAL COLLEGE NAWAB BANDA CHARITY HOSPITAL",
  "CHRISTIAN HOSPITAL SEVA SANSTHAN HARBANSHPUR AZAMGARH",
  "COLLEGE OF PARAMEDICAL CHRISTIAN HOSPITAL SEVA SANSTHAN CAMPUS HARBANSHPUR AZAMGARH",
  "PATEL SMH HOSPITAL AND AYURVEDIC PARAMEDICAL COLLEGE",
  "ST AGNES COLLEGE SAHAPUR FARAH MATHURA",
  "GAYA PRASAD DWIVEDI TEACHER TRANING INSTITUTE, SEKHAWAT PREM KA PURA, JAUNPUR",
  "U S COLLEGE OF PHARMACY, FIROZABAD",
  "Bhrigu Nath Singh Teacher Training School",
  "Mata Dheeraji Mahavidyalay",
  "Maa Mewati Tara Devi Institute of Girls Education",
  "Mata Dhiraji Devi Shikshan Prashikshan Sansthan",
  "Shri Dashrath Shiksha Pracharini Sammittee",
  "Savargia Savitri Singh Siksha Prasar avam Jan Kalyan Samiti",
  "Ramraji Devi Mahila Mahavidhyalay",
  "K D M Institute of Education",
  "Pt. Ram Charitra Mishra Mahavidyalaya Shiksha Sansthan",
  "Swargiya Faujdar Singh Chauhan Shikshan Avam Prashikshan Sanstha",
  "BRK PHARMACY COLLEGE BHADIR MUHAMMADABAD MAU",
  "DR APJ ABDUL KALAM HOMEOPATHIC PHARMACY COLLEGE, VILL GHOGHREKI SAHARANPUR",
  "DR RAJKUMARI RAM SARDAR YADAV INSTITUTE OF MEDICAL SCIENCE",
  "JAMUNA RAM COLLEGE OF PHARMACY CIHTBARA GAON BALLIA",
  "KANTI AYURVEDIC COLLEGE OF PHARMACY AND NURSING COLLEGE",
  "SHREE KRISHNA COLLEGE",
  "SCM COLLEGE OF PHARMACY",
  "MAA VAISHNO DEVI NAKCHHED TIWARI PHARMACY INSTITUTE, AYODHYA",
  "S G S Ayurvedic and Pharmacy College",
  "MAA SHAKUNTLA DEVI MAHAVIDHYALAYA AND HOSPITAL, ETAH",
  "NANDBABA TRUST COLLEGE OF PHARMACY MATHURA",
  "VNVP COLLEGE OF PHARMACY GORAKHPUR",
  "VIVEKANAND COLLEGE OF PHARMACY",
  "DEVI SHYAMRATHI MAHILA MAHAVIDYALAYA PRASHIKSHAN SANSTHAN, PLOT NUMBER SIX HUNDRED EIGHTY EIGHT, BARSARA KHALSA, NIZAMABAD, AZAMGARH",
  "MAA VAISHNO DEVI MAHAVIDHALAYA ROOPPUR BHARATPUR MAINPURI",
  "MATA KUSUMA DEVI COLLEGE OF EDUCATION, RAJJABPUR SIHUNKA ABIRPUR AZAMGARH",
  "SARDAR VALLABH BHAI PATEL DEGREE COLLEGE",
  "SHRI MUKDAM BIHARI LAL COLLEGE",
  "ISHWARDEEN BHAGWAT SINGH COLLEGE OF PHARMACY",
  "AXIS INSTITUTE OF DIPLOMA ENGINEERING",
  "GAUTAM BUDDHA PARAMEDICAL AND PHARMACY COLLEGE ,KANNAUJ",
  "GOVERNMENT POLYTECHNIC KADIPUR SULTANPUR RUN BY AICCEDS",
  "RAMASHANKAR COLLEGE OF PHARMACY BALLIA",
  "R G S COLLEGE OF PHARMACY",
  "SARDAR BALLABHBHAI PATEL COLLEGE CHITRAKOOT",
  "S B S L D COLLEGE OF PHARMACY",
  "SHANTI SINGH MEMORIAL ALLOPATHIC PAHARMACY COLLEGE NAWA NAGAR BALLIA",
  "SHRI RAMJANAKI COLLEGE OF PHARMACY, AZAMGARH",
  "SHRI RAM PRATAP COLLEGE OF PHARMACY, AZAMGARH",
  "SHRI SHEETALA PRASAD COLLEGE OF PHARMACY, AZAMGARH",
  "S K R PHARMACY COLLEGE JAUNPUR",
  "S S COLLEGE OF PHARMACY JAUNPUR",
  "TRILOKI SINGH MEMORIAL INSTITUTE OF MEDICAL SCIENCE, AZAMGARH",
  "VASUDEV SINGH COLLEGE OF PHARMACY, AZAMGARH",
  "ABHIRAM INSTITUTE OF APPLIED HEALTH SCIENCES  HOSPITAL",
  "SRI SANKAT MOCHAN PHARMACY SANSTHAN VARANASI",
  "MAA JANAKRAJI RAMSARIKHAN PHARMACY COLLEGE, AZAMGARH",
  "KAMLA RAJ GNM COLLAGE GAUWAPAR BELTHRA ROD BALLIA",
  "LAL CHANDRA COLLEGE OF PHARMACY, SULTANPUR",
  "NIJI SANSTHAN S S PRAKSHISHAN SANSTHAN",
  "SMT GULABI DEVI TEACHERS TRAINING COLLEGE RENDWALIA GUARA CHOWKI GONDA",
  "SULTAN AFZAL MAHAVIDHYALAYA",
  "H S V COLLEGE AVERNI MATHURA",
  "ARYAKUL COLLEGE OF PHARMACY",
  "MADHAV SARVODAYA COLLEGE OF PHARMACY AND PARAMEDICAL SCIENCES AYODHYA",
  "MODERN INTERNATIONAL COLLEGE OF PHARMACY",
  "NBS COLLEGE OF PHARMACY",
  "SHRI RAM JI PHARMACY COLLEGE",
  "MAA BINDU COLLEGE OF PHARMACY, MAU",
  "GREATER VALLEY COLLEGE OF MEDICAL SCIENCE",
  "ARYAKUL COLLEGE OF EDUCATION VILLAGE NATKUR CRPF BASE CAMP LUCKNOW",
  "KALPANA B T C COLLEGE MARIYAHU JAUNPUR",
  "MUNI JI SHIKSHAN SANSTHAN RUPAUDHA NARAYANPUR MIRZAPUR",
  "RD SHIKSHAN AND PRASHIKSHAN SANSTHAN",
  "R P M COLLEGE OF EDUCATION, DAUJI ROAD, HATHRAS",
  "SANKATHA PRASAD PHARMACY COLLEGE VARANASI",
  "RAMWATI DEVI COLLEGE OF EDUCATION",
  "BABA GAJJAN DAS COLLEGE OF PHARMACY",
  "BABURAM RUKMANI DEVI PHARMACY COLLEGE KANPUR DEHAT",
  "KUL GOVINDI DEVI HOMEOPATHIC PHARMACY COLLEGE DADANPUR AHIRAULI GHOSI MAU",
  "VIDYAVATI NIGAM MEMORIAL INSTITUTE OF PHARMACY, BANDA",
  "VIDYAWATI NIGAM MEMORIAL COLLEGE OF PHARMACY, BANDA",
  "RAJ KISHOR HOMEOPATHIC PHARMACY COLLEGE, GHAZIPUR",
  "RUKMANI COLLEGE OF PHARMACY",
  "S K INSTITUTE OF TECHNOLOGY",
  "SUGAWANTI SHAMBHU NATH SMARAK HOMOEOPATHIC PHARMACY COLLEGE",
  "SUNDARA DEVI COLLEGE OF HOMOEOPATHIC PHARMACY",
  "VIMALA SHANKAR COLLEGE OF PHARMACY GHAZIPUR",
  "Smt Vimla Devi Ayurvedic Nursing and Pharmacy College",
  "MAXWELL INSTITUTE OF MEDICAL SCIENCES, CHANDAULI",
  "PT RAM PRASAD BISMIL PARAMEDICAL INSTITUTE AUTONOMOUS STATE MEDICAL COLLEGE SOCIETY SHAHJAHNAPUR",
  "TAPESHWAR DHARMESHWAR PRASAD COLLEGE OF EDUCATION GANGAUPUR MADHUBAN MAU",
  "WALTECH COLLEGE OF BTC TRAINING VILL ULDEYPUR POST RAJPURA DISTT MEERUT",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING SITAPUR",
  "AMAR SINGH COLLEGE OF PHARMACY",
  "K K L K COLLEGE OF PHARMACY, KANPUR NAGAR",
  "E SHAN AYURVEDIC NURSING AND PHARMACY COLLEGE",
  "G C COLLEGE OF PHARMACY",
  "S R D COLLEGE OLE MATHURA",
  "ISHTIYAQUE AHMAD MEMORIAL MAHAVIDYALAYA",
  "L B S COLLEGE OF PHARMACY",
  "LUCKNOW COLLEGE OF PHARMACY",
  "PT KUNDAN LAL SHUKLA COLLEGE OF PHARMACY",
  "RAMDAS SINGH COLLEGE OF PHARMACY, PRAYAGRAJ",
  "RAMJIT PHARMACY COLLEGE, GHAZIPUR",
  "SHRI DHANESHWAR COLLEGE OF PHARMACY, GHAZIPUR",
  "PT SHRI RAM DUBEY SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA, SULTANPUR, DASAWAN, MADIYAPAR, BUDHANPUR, AZAMGARH",
  "SHRI SAI NATH SHIKSHAN EVAM PRASHIKSHAN SANSTHAN",
  "SHREE RAMLAKHAN SINGH SIKSHAN SANSTHAN PLOT NO SIX HUNDRED TWENTY FOUR NAKAHARA KHANDEV JAUNPUR",
  "AMBIKA RAM DEVI PARAMEDICAL COLLEGE",
  "SHRI JAGANNATH COLLEGE OF PHARMACY, GONDA",
  "HIRAMAN MAHATAM PHARMACY COLLEGE , DEORIA",
  "ERAM MEDICAL COLLEGE, BARABANKI",
  "SHRI SHARDA AYURVEDIC PHARMACY AND NURSING SANSTHAN",
  "VISION COLLEGE OF PHARMACY AND BIOMEDICAL SCIENCE",
  "G M NURSING PARAMEDICAL COLLEGE AND HOSPITAL",
  "GURU SHRI GORAKSHNATH SCHOOL OF NURSING GORAKHANATH MANDIR PARISAR",
  "KAYAM SINGH NURSING AND PARAMEDICAL COLLEGE MAINPURI",
  "KESHLATA HOSPITAL BAREILLY",
  "L B COLLEGE OF NURSING PARAMEDICAL SCIENCE",
  "LILADHAR G N M COLLEGE PALCHANDRAHAN BALLIA",
  "SHRI BAJRANG COLLEGE OF NURSING AND HOSPITAL",
  "VARDAN COLLEGE OF NURSING",
  "BABA VISHWANATH PHARMACY COLLEGE, GHAZIPUR",
  "DR SHRI RAM MEMORIAL PROFESSIONAL INSTITUTE ASMANPATTI RAMDAYALGANJ JAUNPUR",
  "DR SHRI RAM MEMORIAL PROFESSIONAL INSTITUTE PALI JAUNPUR",
  "HALDAUR COLLEGE OF PHARMACY",
  "HARI NARAYAN SINGH PHARMACY COLLEGE",
  "JIUTDAS COLLEGE OF PHARMACY",
  "MATA KISMATI MAHILA MAHAVIDYALYA SAKARA JAITPURA GHAZIPUR",
  "KUNWAR HARIBANSH SINGH COLLEGE OF AYURVEDIC PHARMACY",
  "PURVANCHAL NURSING EVAM PHARMACY COLLEGE, NADWA SARAY, MAU",
  "RAMLAGAN NURSING AND PHARMACY COLLEGE AMILA MAU",
  "SHREE THAKUR JI PHARMACY COLLEGE",
  "SHRI BHAGWAN PHARMACY COLLEGE",
  "SHRI RAKHANT BABA PHARMACIST AND NURSING PRASHIKSHAN KENDRA ATRAULI KARMAUTTA BALLIA",
  "THAKUR TEJ BAHADUR SINGH INSTITUTE OF TECHNOLOGY",
  "URMILA DEVI  PHARMACY COLLEGE",
  "KAMLA PHARMACY COLLEGE JAUNPUR",
  "INDIAN COLLEGE OF NURSING AND PARAMEDICAL EDUCATION JAUNPUR",
  "MAHAVEER SINGH CHAHAR NURSING AND PHARMACY COLLEGE HATHODA MAHAVAN MATHURA",
  "SHIV NATH VERMA SMARAK MAHAVIDYALAYA",
  "SRI GANGARAM BANKELAL DEGREE COLLEGE",
  "S.G.S. COLLEGE B.T.C. JAJAMPATTI RASULPUR",
  "KISAN DEGREE COLLEGE, BAHRAICH",
  "BABU K D SINGH PHARMACY COLLEGE, GHAZIPUR",
  "BAISWARA PHARMACY COLLEGE",
  "BHAGWAT PRASAD PARAMEDICAL TRAINING CENTRE",
  "DECENT INDIAN COLLEGE OF PHARMACY, SAHARANPUR",
  "DIXIT AYUSH PHARMACY COLLEGE CHANDPA MITAI HATHRAS",
  "D K D L COLLEGE OF PHARMACY KAUSHAMBI",
  "ANJANA INSTITUTE OF TECHNICAL EDUCATION",
  "PAPPU SINGH SHIKSHAN PRASHIKSHAN SANSTHAN",
  "C N S PARAMEDICAL AND NURSING COLLEGE LAKHAIYAMAU GURSAHAIGANJ KANNAUJ",
  "LALJI PHARMACY COLLEGE",
  "R K COLLEGE OF PHARMACY ETAH",
  "SHRI DAL CHAND SINGH TEACHER TRAINING COLLEGE MAT ROAD RAYA MATHURA",
  "WORLD GREEN PHARMACY COLLEGE",
  "ANURAG INSTITUTE OF PARAMEDICAL SCIENCES",
  "CHARAK INSTITUTE OF ALLIED HEALTH SCIENCES",
  "CHARAK INSTITUTE OF DIALYSIS TECHNICIAN",
  "HARIPAL SHASTRI PHARMACY COLLEGE",
  "JANVI COLLEGE OF PHARMACY",
  "KESHAV HOMEOPATHIC PHARMACY COLLEGE GANGAUPUR MAU",
  "K K INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES LUCKNOW",
  "S D SINGH PARAMEDICAL COLLEGE VILLAGE RAKHWALI POST FARIHA FIROZABAD",
  "CHANDRADEV COLLEGE OF PHARMACY MAU",
  "MURLIDHAR MAHAVIDHYALAYA (B.T.C) RASOOLPUR JAJANPATTI MAGORRA MATHURA",
  "D.C.S. TEACHERS TRAINING COLLEGE MAT ROAD RAYA MATHURA",
  "UDAY PRATAP PHARMACY COLLEGE CHANDAULI",
  "DR B R AMBEDKAR POLYTECHNIC COLLEGE MARDAPUR SADAT JAKHANIYA GHAZIPUR",
  "JAGANATH COLLEGE OF PHARMACY KOTA HATHRAS",
  "JAGAT INSTITUTE OF TRAUMA AND ORTHOPAEDIC AND COLLEGE OF PARAMEDICAL SCIENCES FAIZABAD",
  "FAUJDAR COLLEGE OF HOMEOPATHIC PHARMACY, NEWADA, SANI, DHAMUPUR, GHAZIPUR",
  "KASHINATH INSTITUTE OF POLYTECHNIC",
  "KNITM COLLEGE OF PHARMCY",
  "MEENU COLLEGE OF PHARMACY",
  "PRAKASH COLLEGE OF PHARMACY, AZAMGARH",
  "SATYANAND UCHCHA SHIKSHA SANSTHAN",
  "PT AMBIKA PRASAD KAMALADEVI COLLEGE OF PHARMACY AYODHYA",
  "RAM SAGAR RAJ PATI PHARMACY COLLEGE AYODHYA",
  "SAROJ COLLEGE OF ENGINEERING AND POLYTECHNIC",
  "SAROJ COLLEGE OF PHARMACY",
  "S R COLLEGE OF PHARMACY",
  "VIMALA SHANKAR PHARMACY COLLEGE",
  "Y D SINGH PHARMACY COLLEGE",
  "VANSHA DEVI NURSING AND PARAMEDICAL COLLEGE KARAUDAHA AMARGARH PRATAPGARH",
  "KAKA SHYAMLAL HOMEOPATHIC PHARMECY COLLAGE PALCHANDRAHAN TARIBARAGAON BALLIA",
  "DR S K AYURVEDIC PARAMEDICAL COLLEGE PADIA MAJHAWAMEER BASTI",
  "GLOCAL COLLEGE OF PARAMEDICAL SCIENCE AND RESEARCH CENTRE",
  "LILADHAR DIPLOMA IN HOMOPATHIC PHARMACY COLLEGE PALCHANDRAHANBALLIA",
  "MAA GAYATRI INSTITUTE OF PHARMACY AND PARAMEDICAL SCIENCES, PRAYAGRAJ",
  "NATIONAL INSTITUTE OF PARAMEDICAL SCIENCES, LUCKNOW",
  "OM SAI AYURVEDIC COLLEGE SAIDPURA",
  "R K SCHOOL OF NURSING AYURVEDIC",
  "SARVODAYA COLLEGE OF PHARMACY",
  "A V M D INSTITUTE",
  "B D COLLEGE",
  "MA ISRAJEE DEVI BTC MAHAVIDYALAY GULJARGANJ JAUNPUR",
  "SHRI RADHA RANI MAHAVIDHYALAYA, VILL RATIBHANPUR, P.O PIPALGAWAN, SIKANDRARAO",
  "DNM COLLEGE OF PHARMACY",
  "KALAWATI COLLEGE OF PHARMACY AND NURSING",
  "KAUSHAL KISHOR TEJ PRATAP COLLEGE OF PHARMACY AND NURSING BAGAPAR",
  "S D PAL COLLEGE OF PHARMACY",
  "MAA AADI SHAKTI MATAJI UMA MAHAVIDYALAYA, BHUWALPUR BIBIPUR AZAMGARH",
  "VANSHA DEVI SHIKSHAK PRASHIKSHAN KENDRA GAJADHARPUR GADDOPUR BADLAPUR JAUNPUR",
  "APRAJITA COLLEGE OF NURSING AND PARAMEDICAL SCIENCES LUCKNOW",
  "DAYANAND INSTITUTE OF PARA MEDICAL SCIENCE",
  "MAHARAJA HARISH CHANDRA COLLEGE OF NURSING AND HEALTH SCIENCE, HARDOI",
  "MAA VINAVADINI COLLEGE OF PHARMACY, GHAZIPUR",
  "THAKUR EDAL SINGH SMRATI KANYA MAHAVIDHLAYA TEHRA AGRA",
  "SHREE KRISHNA HOMOEOPATHIC PHARMACY COLLEGE SIHIPUR JAUNPUR",
  "SHYAM KARAN SMARAK COLLEGE OF PHARMACY, SAIFPUR URF BAJANPUR LALGANJ AZAMGARH",
  "AYUSH COLLLEGE OF NURSING AND PHARMACY",
  "NEW MUZAFFARNAGAR AYURVED NURSING AND HOSPITAL",
  "SURESH MISHRA AYURVEDIC NURSING AND PHARMACY COLLEGE",
  "DEEP COLLEGE OF EDUCTION , VILL AMAURA , POST PANDHAN , LALGANJ , AZAMGARH , UP",
  "MAA KAILASHI SAVITRI DEVI BASIC TRAINING COLLEGE JAGDISHPUR BEERAPUR RANIGANJ PRATAPGARH",
  "POINEER,BTCCOLLEGE,VILLKHASRAUL,BLOCKBHARAWAN,TEHSILSANDILA,HARDOI",
  "VADRI NARAYAN SINGH MAHAVIDYALAYA",
  "BABA SADHAV RAM PARAMEDICAL COLLEGE AND HOSPITAL, KOINHA, BARSARA KHALSA,  AZAMGARH",
  "JAN KALYAN EYE HOSPITAL",
  "KALYANAM KAROTI VYAVSAIK PRASIKSHAN EVAM PUNARWAS SANSTHAN, MATHURA",
  "LOKMANI COLLEGE OF PHARMACY ISHARPUR KADRABAD KHURD SEOHARA BIJNOR",
  "SARASWATI INSTITUTE OF HIGHER STUDIES",
  "CHANDRADEO SMARAK SIKSHAK SIKSHAN PRASIKSHAN VIDYALAYA KANPUR MAU",
  "DR M M PURVANCHAL PRASHIKSHAN COLLEGE",
  "HD COLLEGE OF PHARMACY, CHANDAULI",
  "SARDAR PATEL INSTITUTE OF PARAMEDICAL SCIENCES, LUCKNOW",
  "ADYA PRASAD KASHI PRASAD COLLEGE OF EDUCATION BALWARGANJ SUJANGANJ JAUNPUR",
  "EMERALD NINE ACADEMY",
  "SHIKSHA SAGAR SHIKSHAK PRASHIKSHAN SANSTHAN",
  "SHIV MAHESH PUBLIC SCHOOL MUNSIGANJ HAL KORWA AMETHI",
  "SHRI BUDHHU YADAV SHIKSHAN PRASIKHAN SANSTHAN GANGAPUR BADAGAW GHAZIPUR",
  "SHRI J P SHIKSHAN PRASHIKSHAN SANSTHAN ABOOPUR SULTANIPUR DISTT MAU",
  "SHRI RAM COLLEGE OF EDUCATION MUZAFFARNAGAR",
  "SKD ACADEMY",
  "S R COLLEGE OF HIGHER EDUCATION",
  "SUSHMA EDUCATIONAL INSTITUTE",
  "VIVEKANAND GIRLS COLLEGE SEMARI BALLIA UP",
  "COLONEL JAGANNATH SINGH MAHAVIDYALAYA PITHAPUR SARIYA, AKBARPUR, AMBEDKAR NAGAR UP",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, BUDAUN",
  "NAVODAYA PUBLIC SCHOOL",
  "KRISHNA PAL SINGH INSTITUTE OF MEDICAL SCIENCE",
  "MAA KUNTI DEVI COLLEGE OF PHARMACY",
  "MAA SWAROOPA DEVI COLLEGE OF PHARMACY, GHAZIPUR",
  "MA PREMA COLLEGE OF PHARMACY, GHAZIPUR",
  "RAM NAGINA COLLEGE OF PHARMACY, GHAZIPUR",
  "R M PHARMACY COLLEGE, SONBHADRA",
  "SHIV SHANKAR SINGH MAHAVIDYALAY PHARMACY",
  "SMT GUJRATI DEVI PHARMACY COLLEGE, AZAMGARH",
  "S S MEMORIAL INSTITUTE OF MEDICAL SCIENCE",
  "A H B COLLEGE OF EDUCATION",
  "BABA PARVAT NATH BTC TRAINING COLLEGE",
  "DBS INSTITUTE OF TRAINING EDUCATION AND MANAGMENT",
  "KUWAR SANJEEV SINGH COLLEGE OF EDUCATION GUJELA DOHRU GHATAMPUR KANPUR NAGAR",
  "PT AMBIKA PRATAP NARAYAN BTC TRAINING COLLEGE DUMARI  HARIHARPUR SANT KABIR NAGAR",
  "RAJENDRA PRASAD SINGH BTC PRASHIKSHAN SANSTHAN KODARI GHAZIPUR",
  "RAKSHA DEVI UCHATAR MADHYAMIK MAHAVIDYALAYA LODHI NAGAR KHIMSEPUR FARRUKHABAD",
  "RAM DULARI RAM GIRI COLLEGE OF EDUCATION",
  "SRI SUKHAI SINGH COLLEGE FOR EDUCATION AND TRAINING YUSUFPUR KHADAWA MANIHARI GHAZIPUR",
  "DHARMA DEVI MAHAVIDYALAYA VILLAGE BELAPAR BUXA JAUNPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BAGHPAT",
  "RAMBRIKSHA JI PARAMEDICAL COLLEGE GARER, BHALUNI, DEORIA",
  "RT INSTITUTE OF EDUCATION AND TRAINING DEVLI SALAMATPUR GHAZIPUR",
  "PARUL COLLEGE OF PHARMACY, AGRA",
  "MAHRSHI BABA GALU DAS GANGA SAGAR DIPLOMA IN HOMOEOPATHIC PHARMACY COLLEGE, SHAHMUHAMMADPUR, RASRA, BALLIA",
  "MANYAWAR KASHIRAM MAHAVIDYALAY",
  "P R MEMORIAL INSTITUTE OF HOMEOPATHIC PHARMACY",
  "SIR VK AYURVADIC PHARMACY COLLEGE",
  "SHARDA DEVI KANYA MAHAVIDYALAYA KADEREPUR BADLAPUR JAUNPUR",
  "EXCEL SCHOOL OF NURSING AND PARAMEDICAL SCIENECES, UNNAO",
  "GOPINATH PHARMACY COLLEGE DEVLI SALAMATPUR GHAZIPUR UP",
  "NEELKANTH PARA MEDICAL INSTITUTE",
  "PANDIT RADHA KRISHNA PARAMEDICAL COLLEGE, BHATNI, DEORIA",
  "SHAMME GHAUSIA MINORITY (SGM) AYURVEDIC MEDICAL COLLEGE SAHERI GHAZIPUR",
  "VARANASI INSTITUTE OF OPTOMETRY, VARANASI",
  "MAHARSHI BABA GALUDAS G N M COLLEGE SHAHAMUHAMMADPUR POST CHANDRAWAR RASRA BALLIA",
  "V M Y AYURVED PHARMACIST AVAM NURSHING COLLEGE,  MAU",
  "KRISHNA SUDAMA MAHAVIDYALAYA MARDAPUR GHAZIPUR",
  "SHARDA DEVI SIKSHAK PRASIKSHAN KENDRA PLOT N SIX THREE SIX BY ZEOR POINT SIX NINE SIX KADERPUR JNP",
  "SRI JAGDISH B T C COLLEGE SIHUKA ABIRPUR MEHNAJPUR LALGANJ AZAMGARH",
  "ADARSH COLLEGE OF PHARMACY, SIDDHARTHNAGAR",
  "PATANJALI AYURVED SCHOOL OF NURSING ASHRAFPUR BANKAT AZAMGARH",
  "SHRI BALDEV COLLEGE OF NURSING AND MEDICAL RESEARCH CENTER",
  "VIIT NURSING COLLEGE AND HOSPITAL",
  "AYUSHI COLLEGE OF PHARMACY",
  "BABU SINGH MAHAVIDHYALAY, ASALATNAGAR, CHHIBRAMAU",
  "DR VIJAY PHARMACY COLLEGE AZAMGARH",
  "INDRAPRASTHA INSTITUTE OF PHARMACY",
  "SHIVLOK SHRINET SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA",
  "SHREE JAGJEET SHARMA SUMANLATA OM CITY CONVENT BALIKA DEGREE COLLEGE KHURJA",
  "SHRI B D R GARG EDUCATIONAL INSTITUTE AJHAI KALAN MATHURA",
  "SMT SHYAMA DEVI HARSH MAHAVIDYALAY BHAVANIGARH RAICHA, SULTANPUR",
  "SURYA SHIKSHAN PRASHIKSHAN SANSTHAN NAGRA BADLI, THARUAPUR, BASTI, U P",
  "T M BTC COLLEGE KARMAHIYA RUDHAULI BASTI",
  "GURUKUL COLLEGE OF PHARMACY, GHAZIPUR",
  "RAM TEJ BHAGAUTI PRASAD COLLEGE OF PHARMACY, BAHRAICH",
  "AUXILLIUM COLLEGE OF PHARMACY",
  "BHAGWAN ADARSH COLLEGE OF PHARMACY, AZAMGARH",
  "INDRAPRASTHA COLLEGE OF PHARMACY",
  "SWARGIYA FAUJDAR SINGH CHAUHAN SHIKSHAN AVAN PRASHIKSHAN SANSTHAN PHARMACY COLLEGE",
  "JIVIKA PARAMEDICAL AND NURSING COLLEGE",
  "NIRDOSH DEVI PARAMEDICAL COLLEGE, MORADABAD",
  "SANTOSH SINGH COLLEGE OF PHARMACY,FATEHPUR",
  "MATA RADHIKA DEVI BTC PRASHIKSHAN SANSTHAN, KAMHARIYA, MEHNAGAR, AZAMGARH",
  "RAJKUMAR SHIKSHAN PRASHIKSHAN SANSTHAN",
  "ARCHANA PHARMACY COLLEGE",
  "SHRI RAMDAS COLLEGE OF PHARMACY, JAUNPUR",
  "SHRI RAM MURTI VERMA PHARAMACY COLLEGE CHANDPUR SADOPATTI PARGANA BARAUSA TEHSIL SADAR SULTANPUR",
  "SHUBH KANHA JI PHARMACY COLLEGE, JAUNPUR",
  "SUSHEELA DEVI INSTITUTE OF MEDICAL SCIENCE",
  "VARSHNEY COLLEGE OF PHARMACY",
  "VIMALA PHARMACY COLLEGE",
  "SHRI MAHESH MOHINI MEMORIAL COLLEGE OF PHARMACY, PILIBHIT",
  "SHANTI SINGH COLLEGE OF PHARMACY, MIRZAPUR",
  "BABA RAMDAL SURAJDEV PHARMACY COLLEGE",
  "H  R INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "H S COLLEGE OF PHARMACY",
  "PANCHSHEEL COLLEGE OF PHARMACY",
  "RANBIR SINGH COLLEGE OF PHARMACY",
  "AIM COLLEGE",
  "GOVINDI PHARMACY COLLEGE, VILLAGE DADANPUR, AHIRAULI, GHOSI, MAU",
  "SWATANTRATA SANGRAM SENANI BHAGAUTI PRASAD YADAV INSTITUTE OF MEDICAL SCIENCE, AMETHI",
  "ADARSH MAHAVIDYALAYA COLLEGE OF PHARMACY, BALLIA",
  "EKLAVYA COLLEGE OF PHARMACY, AURAIYA",
  "ABHAY PARAMEDICAL COLLEGE",
  "SHRIMATI INDRAVATI INSTITUTE",
  "SHRI RAM KARAN COLLEGE OF PHARMACY BALLIA",
  "SHRI SATYAPAL SINGH MEMORIAL PHARMACYCOLLEGE",
  "SRI LAL BAHADUR SHASTRI PHARMACY COLLEGE",
  "SRI THAKUR JI MAHARAJ PHARMACY COLLEGE , BILHAUR, KANPUR NAGAR",
  "V I I T POLYTECHNIC COLLEGE SUNGERA BULANDSHAHR",
  "SDRDS  PHARMACY COLLEGE, ALIGARH",
  "FACULTY OF NURSING AND PARAMEDICAL STUDIES",
  "R B D N COLLEGE OF PHARMACY",
  "MAA PANNA DHAY INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES, GULALPUR, SHAHGANJ, JAUNPUR",
  "B R S COLLEGE OF PHARMACY",
  "SHRI THAKUR JI MAHARAJ PHARMACY COLLEGE HERWAL HARDOI",
  "SHRI THAKUR JI MAHARAJ PHARMACY COLLEGE PURWA UNNAO",
  "SWAMI KALYAN DEV COLLEGE OF PHARMACY, BEHRA SADAT, MUZAFFARNAGAR",
  "RAJ PARAMEDICAL COLLEGE, PRAYAGRAJ",
  "BOHRA NATTHA SINGH EDUCATION INSTITUTE, BHILAWATI AGRA",
  "RASHTRIYA VIKAS SEWA SANSATHAN TILAMAPUR ASHAPUR VARANASI",
  "A H M COLLEGE OF PARAMEDICAL SCIENCES",
  "BHAGWAN MAHAVEER SWAMI COLLEGE OF ELEMENTARY TEACHERS TRAINING",
  "BRAHMESHWARI MAHILA MAHAVIDYALAYA, GORAKHPUR",
  "COLLEGE OF TEACHER EDUCATION (CTE) VARANASI UTTAR PRADESH",
  "RAJARAM INSTITUTE OF EDUCATION AND TRAINING",
  "RAJ KUMARI SHIKSHAN EVAM PRASHIKSHAN SANSTHAN",
  "SANJIVANIE COLLEGE OF EDUCATION AND TEACHERS TRAINING",
  "S S INSTITUTE OF PHARMACY, GHAZIPUR",
  "C P S COLLEGE ITORA FIROZABAD",
  "SARVODAYA MAHILA MAHAVIDYALAY",
  "SATYA NARAYAN SINGH UCHCH SHIKKSHA AND TAKNIKI COLLEGE",
  "SHREE NAGESHWAR SINGH SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA",
  "SHRI KRISHNA SHIKSHAN PRASHIKSHAN SANSTHAN HASANPUR CHANDAULI",
  "SIR J P B T C COLLEGE LOHINDA KEWTALI BADLAPUR JAUNPUR",
  "S N UCHCH SHIKSHA SANSTHAN",
  "VIJAY PRASHIKSHAN KENDRA SALAYA KAL MEJA PRAYAGRAJ",
  "VINDHYAWASINI MAHILA MAHAVIDYALAYA BHARUHANA MIRZAPUR",
  "AABAN COLLEGE OF PHARMACY JOYA AMROHA",
  "BACHCHULAL JAISWAL MAHAVIDYALAY COLLEGE OF PHARMECY",
  "JAGDISH SINGH COLLEGE OF PHARMACY",
  "KEDAR PHAUJDAR COLLEGE OF PHARMACY GURAINI GHAZIPUR",
  "MAA MATURNI DEVI MAHAVIDYALAY D PHARM",
  "CH RUKMANGAL SINGH MAHAVIDYALAYA ROOP PUR BHARATPUR MAINPURI",
  "H W FEMALE TRAINING CENTRE, SITAPUR",
  "MBL ACADEMY MAHUAN FARAH MATHURA",
  "SUKKHAN LAL EDUCATION INSTITUTE PALLUPURA GHOSI MORADABAD",
  "BALAJI COLLEGE OF EDUCATION PIPALGAWAN SIKANDARRAO HATHRAS",
  "DRP EDUCATIONAL INSTITUTE",
  "SHIV KUMAR CHATURVEDI MAHAVIDHYALAY",
  "SHRI HAZARILAL MAHAVIDYALAYA, BALOIYA, KANCHANPUR, MAMOODABAD, SITAPUR",
  "SHRI KASHI YADAV SODH EVAM PRASHIKSHAN SANSTHAN, BAMHAUR SADAR AZAMGARH",
  "TEJU SINGH MEMORIAL COLLEGE OF EDUCATION",
  "DHARMA DEVI BADRI PRASAD SMARAK PHARMACY COLLEGE, KURWAR SULTANPUR",
  "DR V P MADNAWAT COLEGE OF PHARMACY",
  "FORTE COLLEGE OF PHARMACY",
  "SHRI RAM SINGH PHARMACY COLLEGE",
  "SARTHAK COLLEGE OF PHARMACY, PRATPAGARH",
  "SHRI THAKUR JI MAHARAJ PHARMACY COLLEGE, BILHAUR, KANPUR",
  "DHARAMVEER COLLEGE OF NURSING BISHANPURA",
  "WTM COLLEGE OF PHARMACY",
  "DR ASHOK KUMAR SMARAK INSTITUTE OF PHARMACY,AMBEDKARNAGAR",
  "T.B. BTC COLLEGE BHANWARIPUR CHHANBEY",
  "B M VIDYAPEETH",
  "DEEPAK BHADAURIYA TEACHERS TRAINING COLLEGE",
  "DELHI COLLEGE OF HIGHER EDUCATION SALARPUR MAWANA MEERUT",
  "DR RAM NARESH EDUCATIONAL INSTITUTE, CHANGAIPUR JIYANPUR AZAMAGRH",
  "PURVANCHAL SHIKSHAN PRASHIKSHAN SANSTHAN HURMUJPUR JAKHANIAN GHAZIPUR",
  "RADHA KRISHANA COLLEGE OF EDUCATION AJNOKH BARSANA MATHURA",
  "SARASWATI DEVI PRASHIKSHAN SANSTHAN MAKOYA KISHNI MAINPURI",
  "SARASWATI SHIKSHAN SANSTHAN",
  "SHRI DAYANAND DEV SWAMI SHA MAHAVIDYALAYA DALOOPUR MAINPURI",
  "SHRI GARG GROUP OF EDUCATIONAL INSTITUTE",
  "SHRI KRISHNA TECHNOLOGY DEVELOPMENT COLLEGE SALAIYA KALA MEJA PRAYAGRAJ",
  "VISHAL INSTITUTE OF REHABILITATION SCIENCE, GURU NANAK NAGAR, NAINI, PRAYAGRAJ",
  "BRIJRAJ SINGH MAHAVIDYALAY",
  "AASHRIWAD JAMUNA JAMWANTI INSTITUTE OF PROFESSIONAL EDUCATION, MAU",
  "KRISHNA SUDAMA COLLEGE OF PHARMACY, VARANASI",
  "AZAD NURSING COLLEGE VILL SARAIYA PALHANA POST PAWANI KALA MEHNAGAR AZAMGARH",
  "MATA SURAJMUKHI NURSING INSTITUTE AND RESEARCH CENTER AGRA",
  "CH ANGAD SINGH COLLEGE OF EDUCATION KUBERPUR DHARMANGADPUR MAINPURI",
  "CH PREM SINGH PREMWATI PHARMACY COLLEGE, MAINPURI",
  "SHRI TEJ SINGH GAJADHAR COLLEGE , DEPARTMENT OF PHARMACY, ETAH",
  "UMRAI SCHOOL OF AYURVEDIC PHARMACY UMRAI SCHOOL OF AYURVEDIC NURSING",
  "D R G COLLEGE OF PHARMACY",
  "DR RK PATEL COLLEGE OF PHARMACY GOPALPUR PRATAPGARH",
  "RM COLLEGE OF PHARMACY, BASTI",
  "SHRI DAFEDAR SINGH COLLEGE OF PHARMACY",
  "WORLD GREEN NURSING COLLEGE",
  "J D S B S V S SHIKSH SADAN SULTANPUR KISHNI MAINPURI",
  "SHRI JILEDAR SINGH SMARAK BALIKA MAHAVIDYALAYA SULTANPUR KISHNI MAINPURI",
  "S L RAJENDRA INSTITUTE OF HIGHER EDUCATION",
  "SMT SARASWATI DEVI VIDHYA MANDIR SULTANPUR KISHNI MAINPURI",
  "D C S COLLEGE OF EDUCATION, ROAD MURADNAGAR, VILLAGE NAYA GAON, BAGHPAT",
  "INSTITUTE OF PROFESSIONAL STUDIES DAWAR KHURJA",
  "MAA ANJANI RAMSIYA COLLEGE OF EDUCATION",
  "GURUKUL PATANJALI VIDYAPEETH",
  "MOOLCHAND  MEMORIAL MAHAVIDYALAYA",
  "G P MAHAVIDYALAYA DIHWA MUGHALSARAI CHANDDAULI UP",
  "BABA BAIJNATH JI COLLEGE OF PHARMACY, AZAMGARH",
  "SAKSHI INSTITUTE OF PHARMACY AND NURSING COLLEGE",
  "SHIVALIK AYURVEDIC PHARMACY COLLEGE AZAMGARH",
  "MOID AHMAD PRASHIKCHAN SANSTHAN",
  "LOK KALYAN VIKAS SHIKSHAN EVAM PRASHIKSHAN SANSTHAN KARKHIYAON PHOOLPUR VARANASI",
  "MATA DEVMUNI HOMOEOPATHIC COLLEGE OF PHARMACY",
  "JAGANNATH INSTITUTE OF PHARMACY",
  "AMARAVATI INSTITUTE OF PHARMACY,VARANASI",
  "BABA SHIVNATH SINGH SHIKSHAN EVAM PRASHIKSHAN SANSTHAN, ANEI TARAICHA, BADAURA SADAR AZAMGARH",
  "MAHARSHI BABA GALU DAS GANGA SAGAR DIPLOMA IN HOMOEOPATHIC PHARMACY COLLEGE SHAHAMUHAMMADPUR BALLIA",
  "PT RK SHUKLA COLLEGE OF PHARMACY",
  "UNIVERSAL COLLEGE OF PHARMACY",
  "V D M COLLEGE OF EDUCATION AND PHARMACY",
  "NARAYAN PARAMEEDICAL SCIENCES AMBEDKARR  NAGAR",
  "SHRI SARASWATI DURGA PARAMEDICAL COLLEGE SHERKOT BIJNOR",
  "DAU GAUTAM COLLEGE OF PHARMACY, AGRA",
  "SHYAMA SHYAM INSTITUTE OF MEDICAL SCIENCE AND RESEARCH, AGRA",
  "BHAGWAN ADARSH PHARMACY COLLEGE AZAMGARH",
  "LAXMI MEMORIAL COLLEGE OF PHARMACY",
  "PT CHANDRADEV PANDEY COLLEGE OF PHARMACY HAISAR BAZAR SANT KABIR NAGAR",
  "WISDOM PHARMACY COLLEGE",
  "MAA SHARDA COLLEGE OF PHARMACY SULTANPUR",
  "RAM NARESH NANHKU COLLEGE OF PHARMACY, AZAMGARH",
  "SWAMI VIVEKANAND COLLEGE OF PHARAMCY",
  "LATE KESHAV PRASAD MAHAVIDYALAYA PHARMACY COLLEGE SASNA BHADURPUR BELTHARA ROAD BALLIA",
  "B R P V COLLEGE OF NURSING AND PHARMACY",
  "S S COLLEGE OF PHARMACY ANGULI JAUNPUR",
  "CHAUDHARY SHIV KUMAR SINGH PHARMACY COLLEGE",
  "CHANDRAPRABHA SHIVSAGAR COLLEGE OF PHARMACY",
  "SMT MAHADEVI COLLEGE OF PHARMACY",
  "SHIVA COLLEGE OF PHARMACY",
  "PERMESHWARI DEVI TRIVENI PRASAD SHUKLA MAHAVIDYALAYA",
  "SHREE MULAYAM SINGH YADAV MAHILA PG COLLEGE",
  "BABBAN SINGH MEMORIAL NURSING AND PHARMACY COLLEGE",
  "KRISHNA COLLEGE OF PHARMACY",
  "BABU AMBIKA PRASAD SHIKSHAN PRASHIKSHAN SANSTHAN",
  "KRISHNA DEVI INSTITUTE OF HEALTH AND ALLIED SCIENCES",
  "ICHCHHA RAM SINGH COLLEGE OF PHARMACY",
  "CHAUDHARY CHARAN SINGH COLLEGE OF PHARMACY VILL BARDARI POST MARKAMAU DIST BARABANKI",
  "DR RAM MANOHAR LOHIYA SHIKSHAN SANSHTHAN, MUSKURA KOERIYAPAR, MAU",
  "KEDAR NATH INSTITUTE OF PARAMEDICAL SCIENCES SORAON ALLAHABAD",
  "SINGH SAHAB HOMOEOPATHIC MEDICAL PHARMACY COLLEGE    ",
  "K S COLLEGE OF PHARMACY     ",
  "CHANDRASHEKHAR BABA KESHAV GROUP OF PHARMACY COLLEGE    ",
  "BRIJBHUSHAN SINGH PHARMACY COLLEGE     ",
  "CH KARAM SINGH INSTITUTE OF TECHNOLOGY MANAGEMENT MALAKPUR ROAD BARAUT",
  "VAIBHAV INSTITUTE OF EDUCATION",
  "KASHINATH COLLEGE OF EDUCATION, PLOT NO ONE NINE, ATAULI, BAKIKHURD, GHAZIPUR",
  "KMV COLLEGE",
  "DR GOVIND PRASAD RANI DEVI PATEL UCHCHA SHIKSHA SANSTHAN ARAUL KANPUR NAGAR",
  "SANT SINGH INSTITUTE ",
  "H W FEMALE TRAINING CENTRE RAMPUR",
  "SWAMI PARAM INSTITUTE OF NURSING AND PARAMEDICAL",
  "JBB PHARMACY COLLEGE",
  "SHARI KRISHNA RTS COLLEGE OF PHARMACY ",
  "RAMADHAR COLLEGE OF PHARMACY",
  "GANGA DEGREE COLLEGE OF PHARMACY",
  "R. K.Institute of Nursing and Paramedical",
  "SHRI KASHI CHANDRA DEV YADAV PRAVIDHIK SHIKSHAN SANSTHAN",
  "DEEPMALA COLLEGE OF PHARMACY",
  "TOSS COLLEGE OF PHARMACY",
  "ARYA AYURVEDIC PHARMACY COLLEGE, DULLAHPUR, GHAZIPUR",
  "CHANDRADEV SMARAK COLLEGE OF PHARMACY ",
  "KAMALA RAJ DIPLOMA IN HOMEOPATHIC PHARMACY COLLEGE GAUWAPAR BELTHARA ROAD BALLIA",
  "RAM SAJIVAN SAVITRI DEVI INSTITUTE OF MEDICAL SCIENCE BARIYARPUR ,BAGHAURA",
  "HW FEMALE TRANING CENTRE",
  "RANI SHANTI DEVI INSTITUTE OF HOMEOPATHIC PHARMACY",
  "KPS COLLEGE OF PHARMACY",
  "AMIT MEMORIAL MAHAVIDHYALAYA",
  "DAYARAM VERMA SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA PEETHAPUR KUDIYA CHITAUNA AMBEDKAR NAGAR ",
  "N S COLLEGE, SAHPAU",
  "SIDDH GOPAL COLLEGE OF TEACHERS TRAINING SHIVRAJPUR KANPUR NAGAR",
  "JAGANNATH PRASAD SMARAK COLLEGE OF ELEMENTARY TEACHER EDUCATION",
  "JAGPATI SHEETLA PRASAD TRAINING COLLEGE",
  "H.W. (FEMALE) TRAINING CENTRE, ALLAHABAD",
  "IIMT COLLEGE OF EDUCATION",
  "PANDIT SAMPAT TIWARI INSTITUTE OF PHARMACY, DOGHARA, POST TIRMASAHUN, TAMKUHIRAJ, KUSHINAGAR",
  "GOVERNMENT POLYTECHNIC RAMPUR",
  "GOVERNMENT POLYTECHNIC SAHARANPUR",
  "GOVERNMENT POLYTECHNIC SHAJAHANPUR",
  "GOVERNMENT POLYTECHNIC SONEBHADRA",
  "PARAMEDICAL SCHOOL GIMS",
  "MLRSM INSTITUTE OF HOTEL MANAGEMENT",
  "FHRAI INSTITUTE OF HOSPITALITY MANAGEMENT",
  "VISHVESHWARYA INSTITUTE OF POLYTECHNIC",
  "GOVERNMENT POLYTECHNIC CHANGIPUR,NOORPUR, BIJNOR",
  "GOVERNMENT POLYTECHNIC BINDKI,  FATEHPUR",
  "MAHAKARUNIK TATHAGAT GAUTAM BUDDH GOVERNMENT POLYTECHNIC",
  "GAYATRI NURSING AND PHARMACY COLLEGE",
  "SHYAMPATI BALIRAM MAURYA INSTITUTE OF PHARMACY AND NURSING MAALAV KARHAN MAU",
  "CH HUKUM SINGH NURSING AND PARAMEDICAL COLLEGE JANDHERA SAMASPUR SAHARANPUR",
  "LAXMI DEVI AYURVEDIC PHARMACY COLLEGE",
  "SIR SAIYAD INSTITUTE OF PARA MEDICAL AYURVED AND UNANI SCIENCES",
  "RUDRA INSTITUTE OF MEDICAL SCIENCE",
  "SVS POLYTECHNIC",
  "SIR M U PHARMACY COLLEGE",
  "SAI HOSPITAL AND INSTITUTE OF PHARMACY",
  "MMIT SIDDHARATHNAGAR",
  "SAVITRI NURSING AND PARAMEDICAL COLLEGE",
  "ANANTRAJ INSTITUTE OF PHARMACY",
  "GOMTI HOSPITAL AND NURSING INSTITUTE",
  "BABU RANJEET SINGH EDUCATIONAL INSTITUTE",
  "COLLEGE OF PHARMACY RAJ KUMAR GOEL INSTITUTE OF TECHNOLOGY",
  "GOVERNMENT POLYTECHNIC ATRAULIA AZAMGARH RUN BY AICCEDS",
  "ONE BEAT PARAMEDICAL INSTITUTE",
  "D S INSTITUTE OF PARAMEDICAL SCIENCE AND HOSPITAL GHAZIABAD",
  "MEERUT PARAMEDICAL  COLLEGE",
  "ROOPA NURSING HOME",
  "S R K AYURVED COLLEGE KATRA DAYARAM MAUAIMA PRAYAGRAJ",
  "M G INSTITUTE OF MEDICAL SCIENCES",
  "INDIAN INSTITUTE OF BIO TECHNOLOGY AND PARAMEDICAL SCIENCES VARANASI",
  "RAMARPIT INSTITUTE OF PHARMACY AND NURSING GAZIPUR BARABANKI",
  "RAMARPIT INSTITUTE OF HOMEOPATHIC PHARMACY GAZIPUR NEAR KOTWA SADAK BARABANKI",
  "DR.GAUR HARI SINGHANIA INSTITUTE OF MANGEMENT AND RESEARCH",
  "DEVO MAHESH COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "MMIT Kanpur Dehat",
  "NATIONAL INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH, RAEBARELI",
  "Shanti Polytechnic",
  "GOVERNMENT POLYTECHNIC TUNDLA, FIROZABAD",
  "AMBITION INSTITUTE OF TECHNOLGOY",
  "APS COLLEGE OF EDUCATION AND TECHNOLOGY",
  "ara shandilya school of nursing",
  "ARYIKA GYANWATI GOVERNMENT GIRLS POLYTECHNIC",
  "ASHIRVAD NURSING & PARAMEDICAL INSTITUTE VARANASI",
  "ASIAN BUSINESS SCHOOL",
  "ASIAN COLLEGE OF NURSING, BAREILLY",
  "AUROUS INSTITUTE OF MANAGEMENT",
  "AZAD POLYTECHNIC BHARTIPUR PALHANA",
  "BABA BINDESHWARI SINGH INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "BABA VISHWANATH INSTITUTE OF TECHNOLOGY",
  "BABU SANT BAKHSH SHIVMURTI SINGH ENGG. & MEDCO INSTITUTE PRATAPGARH",
  "BAKSHI POLYTECHNIC MUJAR MACHHLI SHAHAR",
  "BALRAM SINGH INSTITUTE OF NURSING AND PARAMEDICAL SCIENCE ETAWAH",
  "BANARAS INSTITUTEOF POLYTECHNIC & ENGINEERING",
  "BEACON INSTITUTE OF TECHNOLOGY",
  "BHAAVYA TECHNICAL INSTITUTE",
  "BHALCHANDRA INSTITUTE OF PARAMEDICAL SCIENCE & NURSING LUCKNOW",
  "BIRLA INSTITUTE OF MANAGEMENT TECHNOLOGY",
  "B.S.M.COLLEGE OF TECHNOLOGY AND MANAGEMENT",
  "Chandra Hospital and Research Centre",
  "CHARAK INSTITUTE OF PARAMEDICAL& HEALTH SCIENCES LUCKNOW",
  "Christ Institute of Management",
  "C M S N NURSING & PARAMEDICAL COLLEGE GORAKHPUR",
  "GOVERNMENT GIRLS POLYTECHNIC MORADABAD",
  "GOVERNMENT GIRLS POLYTECHNIC VARANASI",
  "GOVERNMENT LEATHER INSTITUTE, AGRA",
  "GOVERNMENT LEATHER INSTITUTE KANPUR",
  "GOVERNMENT POLYTECHNIC AADAMPUR, TARABGANJ,GONDA",
  "GOVERNMENT POLYTECHNIC AURAI (SANT RAVIDAS NAGAR BHADOHI)",
  "GOVERNMENT POLYTECHNIC BADAUN",
  "GOVERNMENT POLYTECHNIC BAHRIACH",
  "GOVERNMENT POLYTECHNIC BANDA",
  "GOVERNMENT POLYTECHNIC BARABANKI",
  "GOVERNMENT POLYTECHNIC BAREILLY",
  "GOVERNMENT POLYTECHNIC BARGARH(CHITRAKOOT)",
  "GOVERNMENT POLYTECHNIC BIJNORE",
  "GOVERNMENT POLYTECHNIC CHHACHHA BHOGAON",
  "Government polytechnic Deeh",
  "GOVERNMENT POLYTECHNIC DEORIA",
  "GOVERNMENT POLYTECHNIC ETAWAH",
  "GOVERNMENT POLYTECHNIC FAIZABAD",
  "GOVERNMENT POLYTECHNIC FARRUKHABAD",
  "HARBILAS BAL & MAHILA CHIKITSALAY LUCKNOW",
  "HARDAYAL COLLEGE OF ENGINEERING And MANAGEMENT GROUP OF INSTITUTIONS FACULTY OF EDUCATION",
  "Harshit School of Nursing",
  "HASTINAPUR INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "HAYAT INSTITUTE OF NURSING, LUCKNOW",
  "HEWETT POLYTECHNIC",
  "Hillary Clinton Nursing School",
  "HLM BUSINESS SCHOOL",
  "IEM INSTITUTE OF BUSINESS MANAGEMENT",
  "IILM GRADUATE SCHOOL OF MANAGEMENT",
  "I I M T COLLEGE OF MEDICAL SCIENCE MEERUT",
  "IIMT COLLEGE OF POLYTECHNIC, GREATER NOIDA",
  "S.D. POLYTECHNIC",
  "SEVADI INSTITUTE OF MANAGEMENT & TECHNOLOGY",
  "SRI RAMAKRISHNA MISSION SEVASHRAMA SCHOOL OF NURSING MATHURA",
  "S.G. INSTITUTE OF NURSING",
  "SHAIL INSTITUTE OF NURSING LUCKNOW",
  "SHAMM E HUSAINI INSTITUTE OF NURSING COLLEGE AND HOSPITAL",
  "SRI SAI INSTT. OF PHARMACY INDIRA NAGAR",
  "Shankar Nursing and Paramedical Institute",
  "SRI SATISH CHANDRA PANDEY MEMORIAL HOSPITAL, GONDA",
  "SHANTI INSTITUTE OF NURSING AND PARAMEDICAL COLLEGE",
  "S S G PARAMEDICAL COLLEGE",
  "SHANTI INSTT. OF TECHNOLOGY GRAM-KURALI",
  "S S MEMORIAL EDUCATIONAL ACADEMY SAIFAI,ETAWAH",
  "SHASHWAT-THE-INSTITUTE OF PARAMEDICAL AND NURSING LUCKNOW",
  "S S SCHOOL OF NURSING PILIBHIT",
  "SHEKAR SCHOOL OF NURSING LUCKNOW",
  "SHIVALIK INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "ST CATHERINE HOSPITAL KANPUR",
  "SHIVAM INSTITUTE OF SCIENCE & TECHNOLGY",
  "ST MARY'S SCHOOL OF NURSING & PARAMEDICAL INSTITUTE LUCKNOW",
  "SHIV SURGICAL NURSING SCHOOL, VARANASI",
  "SHREE BALAJI POLYTECHNIC COLLEGE",
  "ST MARY'S SCHOOL OF NURSING VARANASI",
  "SHREE JAGANNATH JI EDUCATIONAL INSTITUTE",
  "SUKHDEHI SMARAK INSTITUTE OF NURSING & PARAMEDICAL MURADABAD",
  "Shree Satya College of Medical Sciences",
  "SHRI BABA SADHAV RAM PARAMEDICAL COLLEGE & NURSING COLLEGE AZAMGARH",
  "SURESH DEEP POLYTECHNIC",
  "SHRI BHANWAR SINGH MUKHIAJI COLLEGE",
  "S V M Technical Institute, Lalganj",
  "SHRI DEVI SAURAM SINGH EDUCATION INSTITUTE VILL AND POST PAINDHAT, JASRANA, FIROZABAD",
  "SHRI GIRRAJ MAHARAJ POLYTECHNIC COLLEGE",
  "SWAMI KALYAN DEV POLYTECHNIC INSTITUITE",
  "SHRI SAHDEV PAUDHARIYA AMBEDKAR SEWA SANSTHAN",
  "SWAMI SAHAJANAND POLYTECHNIC",
  "SHRI SIDDHI VINAYAK POLYTECHNIC, NAINITAL ROAD, BAREILLY",
  "SHRI SIDDHI VINAYAK SCHOOL OF NURSING, NAINITAL ROAD, BAREILLY",
  "SYADWAD INSTITUTE OF HIGHER EDUCATION & RESEARCH BAGHPAT",
  "SHRI TRIDANDIDEO HANUMAT TECHNICAL COLLEGE",
  "TAMANNA INSTITUTE OF ALLIED HEALTH SCIENCES ALLAHABAD",
  "SIR MADANLAL COLLEGE OF EDUCATION",
  "TATHAGAT GAUTAM BUDH GOVERNMENT POLYTECHNIC SHRAVASTI",
  "SIR MADAN LAL INSTT. OF PHARMACY ALAMPUR",
  "SMT.  ASHARFI DEVEI MAHILA MAHAVIDYALAYA BUBAKPUR, SARDHANA ROAD MEERUT",
  "TECHNO INSTITUTE OF MANAGEMENT SCIENCES, LUCKNOW",
  "Tirupati College of Engineering",
  "Smt. Champa Devi shikshan Prashikshan College, Tilaura Pali Sahjanwa Gorakhpur U.P",
  "SMT. FULEHRA SMARAK COLLEGE OF POLYTECHNIC KAMTAILLA RASRA BALLLIA",
  "TOWN POLYTECHNIC",
  "Smt Shiva Maurya Teachers Training College",
  "SMT SUNDARA DEVI SHIKSHAN PRASHIKSHAN SANSTHAN HALIYAPUR SULTANPUR",
  "UMRAO TECHNOLOGICAL INSTITUTE",
  "URMILA COLLEGE OF TECHNOLOGY AND MANAGEMENT",
  "UTKARSH COLLEGE OF MANAGEMENT EDUCATION",
  "VATSALYA INSTITUTE OF NURSING & PARAMEDICLA SCIENCES ALLAHABAD",
  "Venkateshwara College of Engineering",
  "Venkateshwara College of Pharmacy",
  "VENKETASHWARA COLLEGE OF HIGHER EDUCATION, VILL-DASHRATHPUR, MEERUT",
  "V L M COLLEGE OF NURSING AND ALLIED HEALTH SCIENCES ALLAHABAD",
  "YABUVANSH PRASAD MISHRA INSTITUTE OF PROFESSIONAL STUDIES",
  "MAHAMAYA POLYTECHNIC OF INFORMATION TECHNOLOGY LENGADI GOOLAR SRAVASTI",
  "vedanta school of nursing",
  "KP Nursing  and Paramedical Training College",
  "Government Polytechnic Mawana Khurd Meerut",
  "SHREE RAM NURSING COLLEGE",
  "Mahamaya Polytechnic for Information Technology Aligarh",
  "GOVERNMENT POLYTECHNIC CHANDAUSI",
  "Chakleshwar Singh Educational Institute",
  "MGA INSTITUTE OF POLYTECHNIC",
  "M.M.I.T. SEHUD AURAIYA",
  "SAI MEER COLLEGE OF POLYTECHNIC",
  "MAHAMAYA POLYTECHNIC OF INFORMATION TECHNOLOGY, SANT KABIR NAGAR",
  "GOVERNMENT POLYTECHNIC BHAURAHI CHUNAR MIRZAPUR",
  "Mahamaya I.T. Polytechnic Kushinagar",
  "P.C.P.S COLLEGE OF TECHNOLOGY AND MANAGEMENT,USPHAR,MATHURA",
  "government polytechnic chopan sonebhadra",
  "R R institute Of Modern Polytechnic",
  "GOVERNMENT POLYTECHNIC KOTWAN, MATHURA",
  "NARAYAN COLLEGE OF SCIENCE AND ARTS",
  "GOVERNMENT POLYTECHNIC, PURANPUR",
  "JAHAGIRABAD EDUCATIONAL INSTITUTE OF TECHNOLOGY FOR POLYTECHNIC",
  "AMBALIKA INSTITUTE OF PROFESSIONAL STUDIES.MOHANLAL GANJ LUCKNOW",
  "DR. M. C. Saxena Polytechnic Lucknow",
  "F H COLLEGE OF PARA MEDICAL",
  "GOVERNMENT POLYTECHNIC JAMUNIA DEEH HARAKH BARABANKI",
  "CHATRAPATI SAHUJI MAHARAJ GOVT. POLYTECHNIC AMBEDKAR NAGAR",
  "MAHAMAYA POLYTECHIC OF INFORMATION TECHNOLOGY HATHRAS",
  "GL BAJAJ INSTITUTE OF MANAGEMENT AND RESEARCH PGDM INSTITUTE",
  "Upkar Institute of Nursing and Paramedical Sciences",
  "Dr Mahaveer Singh Nursing Collage",
  "arshi nursing and paramedical college",
  "MINORITY COMPUTER INSTITUTE UNDER MINORITY DEVELOPMENT SOCIETY",
  "STNT NURSING INSTITUTE",
  "LAL SINGH EDUCATIONAL INSTITUTE",
  "vit college of pharmacy",
  "GANDHI INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "S.P COLLEGE OF PHARMACY",
  "SHREE RAM COLLEGE OF PHARMACY",
  "Government Polytechnic Jatwada Jansath Muzaffarnagar",
  "SAI INSTITUTE PARAMEDICAL STUDIES, ALIGARH",
  "Ahsan Pharmacy College",
  "MAHENDRA GAYATRI COLLEGE OF PHARMACY",
  "ITM COLLEGE OF PHARMACY",
  "PRATIMA NURSING COLLEGE",
  "ITM Polytechnic",
  "Popular Nursing School Mirzapur",
  "MODERN COLLEGE OF ENGINEERING ,KONCHHABHANWAR JHANSI",
  "V.K. JAIN INSTITUTE OF EDUCATION",
  "BABA GAJADHAR DAS NURSING COLLEGE",
  "K N D M COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "KMC NURSING AND PARAMEDICAL INSTITUTE",
  "Glocal College Of Nursing and Research Centre",
  "AASTHA NURSING COLLEGE",
  "CHAUDHARY CHARAN SINGH COLLEGE OF ENGINEERING",
  "NEELAM COLLEGE OF PHARMACY",
  "FOOD CRAFT INSTITUTE ALIGARH",
  "SARASWATI INFORMATION TECHNOLOGY INSTITUTE SHAHPUR BALLIA",
  "INSTITUTE OF HOTEL MANAGEMENT & CATERING TECHNOLOGY",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION LUCKNOW",
  "Kanpur Institute Of Technical Education",
  "GOVT POLYTECHNIC BAIJPUR BHITI AMBEDKAR NAGAR",
  "A S K INSTITUTE OF EDUCATION",
  "Ishan Institute of Pharmacy",
  "GREATER NOIDA POLYTECHNIC COLLEGE",
  "MADHU VACHASPATI INSTITUTE OF TEACHERS EDUCATION",
  "SAGAR COLLEGE OF PHARMACY",
  "SRI SAI RAM INSTITUTE",
  "NEELKANTH COLLEGE OF PHARMACY",
  "MAHARSHI PATANJALI YOG EVM PRAKRITIK CHIKITSA PARISHAD",
  "GOVERNMENT POLYTECHNIC  SANTKABIR NAGAR",
  "BABA VISHWANATH COLLEGE OF PHARMACY",
  "DR OM PRAKASH COLLEGE OF PHARMACY",
  "SARVODAYA COLLEGE OF PHARMACY",
  "DIVYA COLLEGE OF PHARMACY MAHARAJGANJ",
  "RAJA BALWANT SINGH POLYTECHNIC, BICHPURI",
  "DN COLLEGE",
  "KALKA PHARMACY INSTITUTE FOR ADVANCED STUDIES",
  "IMS COLLEGE OF POLYTECHNIC",
  "SHAKUNTALA DEVI PHARMACY COLLEGE",
  "SHRI BABURAM PHARMACY COLLEGE",
  "DR ANGNA PHARMACY COLLEGE",
  "TEJAS INSTITUTE OF PHARMACY",
  "Sir M U Pharmacy College Ganjdundwara Road Sahawar Kasganj",
  "MAJOR S D SINGH COLLEGE OF PHARMACY",
  "RAVI COLLEGE OF PHARMACY",
  "Vijay Laxmi college of Pharmacy",
  "PT DEEN DAYAL UPADHYAY COLLEGE OF PHARMACY",
  "ACHARYA CHANKYA MAHAVIDAYALYA FACULTY OF PHARMACY",
  "DR VIMAL KUMAR DWIVEDI INSTITUTE OF PHARMACY",
  "Madan Mohan Lal Mehrotra Institute of Pharmacy",
  "PANDIT DEV NARAYAN SHUKLA COLLEGE OF PHARMACY",
  "BABA SAHEB AMBEDKAR POLYTECHNIC",
  "B K POLYTECHNIC",
  "VIKAT INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "Ved Institute of Pharmacy",
  "INSTITUTE OF PHARMACY LUCKNOW",
  "RAMASHRAY SINGH INSTITUTE OF PHARMACY",
  "PANCHWATI COLLEGE OF PHARMACY",
  "KESHAV PHARMACY COLLEGE",
  "JYOTIRADITYA INSTITUTE OF TECHNOLOGY MANAGEMENT AND RESEARCH",
  "PANDIT JAMUNA PRASAD COLLEGE OF PHARMACY",
  "Girija devi college of pharmacy mohammadabad farrukhabad",
  "Chaudhary Pancham Singh Pharmacy College",
  "Dr anar Singh college of pharmacy",
  "DHARAMVEER SINGH RAJPUT MEMORIAL COLLEGE OF PHARMACY USMANPUR MORADABAD",
  "LLYOD COLLEGE OF ENGINEERING",
  "K L S D COLLEGE OF PHARMACY",
  "gopinath pharmacy college",
  "MLS COLLEGE",
  "IEM College of Pharmacy",
  "Jeevan Jyoti Institute of Pharmacy",
  "GOVERNMENT POLYTECHNIC ALIYA SITAPUR",
  "RAMDOOT COLLEGE OF PHARMACY",
  "DR DASHRATH CHAUDHARY COLLEGE OF PHARMACY",
  "government girls polytechnic tilhar",
  "SHRI GULAB SINGH COLLEGE OF PHARMACY",
  "FACULTY OF PHARMACY NARAINA VIDYAPEETH GANGAGANJ PANKI KANPUR",
  "INDO UNIVERSAL COLLEGE OF PHARMACY BAOLI BAGHPAT",
  "MAA SAVITRI COLLEGE OF PHARMACY",
  "AVADH INSTITUTE OF PHARMACY",
  "P S INSTITUTE OF PHARMACY",
  "JAGANNATH COLLEGE OF PHARMACY",
  "GAYATRI EDUCATIONAL INSTITUTE",
  "SHRI BABU SINGH JAY SINGH HOMEOPATHIC PHARMACY COLLEGE",
  "CH Sughar Singh College of Pharmacy",
  "Government Polytechnic Sahaswan Budaun",
  "AMAR SHAHID KANCHAN SINGH MAHAVIDYALAYA FACULTY OF PHARMACY",
  "DR BPS COLLEGE OF EDUCATION",
  "SANT RAVIDAS GOVERNMENT POLYTECHNIC, CHAKIYA CHANDAULI",
  "SHANTI COLLEGE",
  "shri Sant giri educational institute rali chauhan",
  "Government Polytechnic, Kutana, Baraut",
  "Government Polytechnic, Shamsabad,  Agra",
  "GOVERNMENT GIRLS POLYTECHNIC, SHAMLI",
  "PATEL PANCHAYATI COLLEGE OF PHARMACY BARABANKI",
  "MAA BHAGWATI SARVODAYA SANSTHAN",
  "B R COLLEGE OF PHARMACY",
  "SHARADANAND ANCHAL TECHNICAL INSTITUTE, BALLIA",
  "VIMLA FAMILY PHARMACY COLLEGE",
  "CHANDRA KAMAL PHARMACY MAHAVIDALAYA",
  "VIKAS INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "KANNAUJ COLLEGE OF PHARMACY",
  "SHRI VIRENDRA SINGH KATIYAR INSTITUTE OF PHARMACY",
  "SHARDA NARAYAN INSTITUTE OF NURSING  AND PARAMEDICAL SCIENCES MAU",
  "KRISHNA INSTITUTE OF EDUCATION AND TECHNOLOGY  KHATAULI ROAD BEHSUMA MEERUT",
  "Shri Satya Sai Institute of Pharmaceutical Science and Research",
  "DEV INDRAWATI COLLEGE OF PHARMACY ARKHAPUR",
  "RajaRam Verma Shikshan Sansthan Jiyapur Baruwa Jalanki Tanda Ambedkar Nagar",
  "Krishak Collage Of Pharmacy",
  "VINAYAKA INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "KS MEMORIAL COLLEGE FOR RESEARCH AND REHABILITATION, LUCKNOW",
  "KS MEMORIAL COLLEGE FOR RESEARCH AND REHABILITATION, RAE BARELI",
  "QADAR AHMAD KHAN COLLEGE OF PHARMACY",
  "BABA RAMDAL SURAJDEV PHARMACY COLLEGE PATNA RASRA BALLIA",
  "SHRI NATH BABA COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC MOHAMMAD PUR GITI CAMPUS BAHRAICH",
  "LUTAWAN INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "GOVERNMENT POLYTECHNIC KISHNI MAINPURI",
  "MAA BHAGWATA KUNWAR INSTITUTE OF POLYTECHNIC MAU",
  "DR BR AMBEDKAR NURSING AND PHARMACY COLLEGE BIJNOUR LUCKNOW",
  "GOVERNMENT POLYTECHNIC KATAI JOYA AMROHA",
  "BHAGWATI INSTITUTE OF PROFESSIONAL STUDIES",
  "MAHARSHI DAYANAND REHABILITATION INSTITUTE",
  "VINDA PAL UGRASEN PAL INSTITUTE FOR SPECIAL EDUCATION",
  "MAHAMAYA POLYTECHNIC FOR INFORMATION TECHNOLOGY KASGANJ",
  "SHAKUMBHARI AYURVEDIC PRASHIKSHAN SANSTHAN ROORKEE ROAD DEOBAND",
  "BHARTIYA AYURVEDIC PARAMEDICAL COLLEGE",
  "TDL COLLEGE OF TECHNOLOGY AND MANAGEMENT",
  "PIONEER FLYING ACADEMY PVT LTD",
  "SHAIL SUBHASH INSTITUTE OF PARAMEDICAL SCIENCES",
  "INDIAN INSTITUTE OF TOURISM AND TRAVEL MANAGEMENT",
  "RAJIV GANDHI POLYTECHNIC MUSAFIRKHANA AMETHI UP",
  "DEV PARAMEDICAL INSTITUTE OF MEDICAL SCIENCES",
  "WHITE FEATHERS GROUP OF EDUCATIONAL INSTITUTES KOTWADHAM ROAD TIKAITNAGAR BARABANKI",
  "GOVERNMENT POLYTECHNIC PURAINA SADAR MAHARAJGANJ",
  "APS COLLEGE OF PHARMACY",
  "BHOLERAM COLLEGE OF PHARMACY",
  "SHRI CHANDRA SHEKHAR PANDEY COLLEGE OF PHARMACY",
  "ANAND COLLEGE",
  "MAA KAUSHILYA SCHOOL OF NURSING AND PARAMEDICAL SCIENCES",
  "WISDOM COLLEGE OF PHARMACY",
  "R D D PHARMA",
  "BALA JI COLLEGE OF NURSING AND PARAMEDICAL SCIENCE",
  "M D NURSING AND PARAMEDICAL COLLEGE",
  "NEW ELECTRA KING OF NURSING AND PARAMEDICAL SCIENCE",
  "SARDAR VALLABH BHAI PATEL COLLEGE OF PHARMACY",
  "VAGESHWARI SHIKSHAN SANSTHAN PHARMACY COLLEGE MAIL DEORIA",
  "SHRI RAM INSTITUTE OF PHARMACY",
  "DEPARTMENT OF PHARMACY RAMA SHIKSHA SANSTHAN",
  "BHONWAL SCHOOL OF ENGINEERING",
  "CROSS BELLY REHABILITATION SANSTHAN KUKURIPUR SATHIAON AZAMGARH",
  "JAINATH MEMORIAL REHABILITATION SANSTHAN HARAIRAMPUR CHIRKIHIT LALGANJ AZAMGARH",
  "RAJKALI DEVI PHARMACY COLLEGE VILLAGE AND POST LAHENGA BLOCK CHHATOH TEHSIL SALON RAEBARELI",
  "ANAND POLYTECHNIC COLLEGE",
  "SHANTI NIKETAN SPECIAL SCHOOL",
  "SANSKAAR SPECIAL SCHOOL",
  "RUDRA POLYTECHNIC",
  "SHANTI SUDAMA COLLEGE OF PHARMACY AZAMGARH",
  "JAINATH MEMORIAL AYURVEDIC PHARMACY EVAM NURSING COLLEGE HARAIRAMPUR CHIRKIHIT AZAMGARH",
  "S B S COLLEGE OF PHARMACY BHUJGI AMBEDKAR NAGAR UTTAR PRADESH",
  "B M COLLEGE OF PHARMACY",
  "SURYA NATH SINGH SMARAK MAHAVIDYALAYA",
  "BRAJRAJ SINGH COLLEGE OF EDUCATION",
  "VIJAY SUDHA COLLEGE OF PHARMACY",
  "RUMA INSTITUTE OF PHARMACY",
  "S S P PHARMACY  RASRA BALLIA UP",
  "NEELKANTH COLLEGE OF PHARMACY EDUCATION",
  "RAMESHWARAM COLLEGE OF EDUCATION AND TRAINING",
  "SHIVAM COLLEGE OF EDUCATION",
  "DEVI PRASAD SINGH SHAIKSHIK SANSTHAN BHARATGANJ GANIPUR RAMGANJ AMETHI",
  "ACE EDUCATION INSTITUTE",
  "S S COLLEGE OF HIGHER EDUCATION",
  "GULSHAN SINGH MEMORIAL COLLEGE OF EDUCATION VILL HIMMATPUR POST BAKAINA DISTT BIJNOR",
  "SARRTHI INSTITUTE OF DEVELOPMENTAL STUDIES BHUHERA SAFEDABAD BARABANKI",
  "ARYA RAMRATI DEVI SURUJU SINGH SHIKSHAN EVAM PRASHIKSHAN SANSTHAN",
  "NEELAM COLLEGE OF EDUCATION",
  "GCRG COLLEGE OF TEACHERS EDUCATION",
  "BABU RANI JATA SHANKAR MAHILA BTC COLLEGE KOLHUA",
  "PANDIT SURENDRA NATH AWASTHI SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA HAIDERGARH BARABANKI UP",
  "SHRI HIMALAYAN INSTITUTE TECHNOLOGY AND MANAGMENT",
  "M S D COLLEGE OF PHARMACY VILL  POST ASBARANPUR TRILOCHAN MAHADEV TEH KERAKAT JAUNPUR",
  "KANAV INSTITUTE OF EDUCATION",
  "AMBEKESHWAR INSTITUTE OF TECHNOLOGY AND MANAGMENT VILL KATHWARA POST BAKSHI KA TALAB LUCKNOW",
  "VISHWANATH MEMORIAL COLLEGE OF PHARMACY",
  "D S INSTITUTE OF PARAMEDICAL SCIENCE AND HOSPITAL HAPUR",
  "DHANWANTARI INSTITUTE OF MEDICAL SCIENCES",
  "KANPUR PARA MEDICAL COLLEGE",
  "CITY PARA MEDICAL COLLEGE",
  "RAGHUVIR INSTITUTE OF NURSING & PARAMEDICAL SCIENCES",
  "GOVERNMENT POLYTECHNIC KULPAHAD MAHOBA PPP",
  "SHRI MUSAFIR PARMARTH COLLEGE OF PHARMACY KALYANPUR MAU",
  "DEV BHUMI INSTITUTE OF PARAMEDICAL SCIENCE",
  "SHAMBHUNATH RESEARCH INSTITUTE OF MEDICAL SCIENCES AND HOSPITAL, JHALWA, PRAYAGRAJ",
  "B R COLLEGE OF NURSING RAJEPUR MALLAWAN BILGRAM HARDOI",
  "KRISHNA PARAMEDICAL COLLEGE AND HOSPITAL",
  "MAA BHAGWATI COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "INDIAN INSTITUTE OF PARAMEDICAL SCIENCE",
  "AHSAN PARAMEDICAL COLLEGE",
  "CHAUDHARY CHARAN SINGH MEDICAL INSTITUTE",
  "SAI INSTITUTE OF PARAMEDICAL SCIENCES",
  "INDU INSTITUTE OF MEDICAL SCINECE",
  "INSTITUTE OF ALLIED HEALTH SCIENCE, SARAWAT HOSPITAL, GHAZIABAD",
  "R N PANDEY HOSPITAL AND PARAMEDICAL INSTITUTE GONDA",
  "DR ATUL MEMORIAL INSTITUTE OF PARAMEDICAL SCIENCES GHATAMPUR KANPUR NAGAR",
  "SHANTI NURSING HOME AND MATERNITY CENTER, GHATAMPUR KANPUR NAGAR",
  "UTKARSH PARAMEDICAL COLLEGE",
  "RAMA INSTITUTE OF PARAMEDICAL SCIENCES",
  "CHRISTIAN INSTITUTE OF PARAMEDICAL SCIENCES KASGANJ",
  "HIGHWAY INSTITUTE OF EMERGENCY AND TRAUMA CARE TECHNICIAN",
  "MAHRSHI  CHARAK PARA MEDICAL COLLEGE",
  "PHOTON PARAMEDICAL COLLEGE",
  "D M R COLLEGE OF PARAMEDICAL SCIENCES",
  "NEW STATE NURSING AND PARAMEDICAL COLLEGE",
  "KAUSHALYA DEVI SCHOOL OF OPTOMETRY",
  "JEEVAN JYOTI PARAMEDICAL INSTITUTE",
  "DR MAHADEVI INSTITUTE OF MEDICAL SCIENCE AND TECHNOLOGY",
  "SUSHRUT PARAMEDICAL INSTITUTE DEHRADOON ROAD HARORA, SAHARANPUR",
  "SARASWATI INSTITUTE OF PHARMACY SARAI SHEKH MAHMOOD TARUN BIKAPUR AYODHYA",
  "R R PARAMEDICAL COLLEGE AND HOSPITAL",
  "SHIKHAR INSTITUTE OF NURSING",
  "BHANMATI SMARAK COLLEGE OF PHARMACY",
  "NATIONAL ASSCOCIATION FOR THE BLIND, ASHARFI BHAWAN CHAURAHA AYODHYA",
  "RAJKUMARI SHIKSHAN PRASHIKSHAN KENDRA",
  "OMPAL MUNSHI SINGH COLLEGE OF PHARMACY",
  "SHRI RAM LAKHAN LAL COLLEGE OF SPECIAL EDUCATION",
  "JP COLLEGE OF PHARMACY",
  "ACME INSTITUTE OF MEDICAL SCIENCES",
  "NEELKANTH COLLEGE OF EDUCATION",
  "GLOBAL INSTITUTE BAREILLY",
  "B D INTERMEDIATE COLLEGE GOVINDPUR JAUNPUR",
  "SHRI RAJROOP MEMORIAL FOUNDATION EVAM EDUCATIONAL TRUST",
  "ROYAL COLLEGE OF PHARMACY",
  "RANWAT SINGH COLLEGE OF PHARMACY",
  "SHIVAJI INSTITUTE OF TECHNOLOGY AND MANAGEMENT VILL AND POST BENDO TEHSIL KARCHHANA DISTRICT PRAYAGRAJ UP",
  "HANSWAHINI INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "KRISHNA COLLEGE OF PHARMACY FATEHPUR KALSIYA ROAD KAMALPUR CHHUTMALPUR SAHARANPUR",
  "SHRI VISHWANATH COLLEGE OF POLYTECHNIC KALAN SULTANPUR",
  "INSTITUTE OF PARAMEDICAL SCIENCE AND RESEARCH",
  "ARYA INSTITUTE OF PARAMEDICAL SCIENCES, BAREILLY",
  "ANANTRAJ INSTITUTE OF PARAMEDICAL SCIENCES",
  "RAVI SCHOOL OF PARAMEDICAL",
  "B R D COLLEGE",
  "SHRI SIDDHI VINAYAK INSTITUTE OF PARAMEDICAL STUDIES",
  "GAHLAUT PHARMACY COLLEGE, HALDAUR",
  "BHARAT MATA SAMAJOTTHAN SAMITI",
  "ITM INSTITUTE OF HIGHER EDUCATION",
  "K S V COLLEGE OF PHAMACY",
  "SHREE SATYA SCHOOL OF NURSING",
  "KRISNA SUDAMA COLLEGE OF PHARMACY  VILL BAKSUPUR POST HURMUJPUR GHAZIPUR",
  "D M R COLLEGE OF NURSING",
  "SHREE HEERANAND PHARMACY COLLEGE",
  "PT SHRAVAN KUMAR DWIVEDI SUNEETA DWIVEDI MEDICAL COLLEGE OF PHARMACY JAGAMMANPUR JALAUN",
  "K M COLLEGE OF PHARMACY",
  "SHREE SAI COLLEGE OF PHARMACY",
  "DR AK MEMORIAL COLLEGE OF NURSING AND HOSPITAL",
  "SHRI RAM MURTI SMARAK COLLEGE OF NURSING AND  PARAMEDICAL SCIENCES UNNAO",
  "SHRI NATH BABA NURSING AND PARAMEDICAL COLLEGE",
  "RBS MAHAVIDYALAYA",
  "JANTA POLYTECHNIC OF PHARMACY",
  "RAJ COLLEGE OF PHARMACY",
  "CHAUDHARY RAMVEER SINGH YADAV PHARMACY COLLEGE HARSAINA KASGANJ",
  "SNSK INSTITUTE OF TECHNOLOGY",
  "ARYAN NURSING AND PARAMEDICAL COLLEGE, GHAZIABAD",
  "S K COLLEGE OF PHARMACY VILL SANDA KHAS NIGOHI SHAHJAHANPUR",
  "SRI VIMAL NATH PHARMACY INSTITUTE",
  "SHRI MANMOHAN SHARMA VAIDJI INSTITUTE OF PHARMACY",
  "CHOUDHARY CHARAN SINGH PHARMACY COLLEGE",
  "MAHATMA BUDDHA COLLEGE OF PHARMACY",
  "P L N M COLLEGE OF PHARMACY",
  "KRISHNA COLLEGE OF PHARMACY",
  "SHRI KHUSHIRAM COLLEGE OF PHARMACY",
  "PARWATI COLLEGE OF PHARMACY",
  "SHRI KUMAR SEN SHARMA PHARMACY COLLEGE",
  "RISHIRAJ COLLEGE OF PHARMACY, AMBEDKARNAGAR",
  "SARDAR PATEL BANSH GOPAL COLLEGE OF PHARMACY",
  "S S BAPU PHARMACY COLLEGE AKHOP BELTHARA ROAD BALLIA",
  "COLUMBUS INSTITUTE OF MEDICAL SCIENCE",
  "NEW KHUSRO PHARMACY INSTITUTE OF SCIENCES BAREILLY",
  "JAIN PHARMACY COLLEGE OF EDUCATION",
  "HEERALAL YADAV COLLEGE OF PHARMACY",
  "KUNWARS COLLEGE OF PHARMACY",
  "NARVADESHWAR NARENDRA PHARMACY COLLEGE, LUCKNOW",
  "PARMESHWAR SINGH MEMORIAL COLLEGE OF PHARMACY",
  "ATUL PHARMACY COLLEGE, MAINPURI",
  "RAMRATTI DEVI COLLEGE OF PHARMACY",
  "MAS COLLEGE OF PHARMACY",
  "A P SINGH PHARMACY COLLEGE",
  "VIRENDRA COLLEGE OF PHARMACY",
  "GANGA SAGAR SINGH PHARMACY COLLEGE",
  "M Y INSTITUTE OF PHARMACY SHIVGARH RANIGANJ PRATAPGARH",
  "NIRMLA RAM AJOR YADAV PHARMACY COLLEGE",
  "MAA GOMTI PHARMACY COLLEGE",
  "RSMP COLLEGE OF PHARMACY",
  "G S GIRI COLLEGE OF PHARMACY",
  "PRAYAG INSTITUTE OF PHARMACY",
  "SAVITRI DEVI COLLEGE OF PHARMACY",
  "BADRIDHAR DWIVEDI COLLEGE OF PHARMACY",
  "R B S COLLEGE OF PHARMACY",
  "OMKAR NATH SINGH COLLEGE OF PHARMACY",
  "S D HARSH COLLEGE OF PHARMACY SULTANPUR",
  "KAMAYANI PHARMACY COLLEGE, SULTANPUR",
  "GAJRAJ PHARMACY COLLEGE, SULTANPUR",
  "MATHURA PRASAD SINGH INSTITUTE OF MEDICAL SCIENCES, RAMGARH, LAMBHUA, SULTANPUR",
  "ALITE COLLEGE OF PHARMACY",
  "SB INSTITUTE OF PHARMACY",
  "MANGALMAY PHARMACY COLLEGE",
  "COMPOSITE REGIONAL REHABILITATION CENTRE FOR PERSON WITH DISABILITY",
  "HAPPINESS TEACEHRS TRAINING INSTITUTE",
  "BHARAT EDUCATIONAL INSTITUTE",
  "SRI MARUTI COLLEGE OF RESEARCH AND REHABILITATION,",
  "CBSM RAEBARELI SPEECH AND HEARINGH INSTITUTE",
  "EMERALD NURSING INSTITUTE",
  "H S BAGHEL COLLEGE OF NURSING",
  "HARSH NURSING COLLEGE DEHLI BAZAR SULTANPUR",
  "SPECTRUM COLLEGE OF SPECIAL EDUCATION",
  "GREATER NOIDA INSTITUTE OF MANAGEMENT, GREATER NOIDA",
  "DR S N DEV COLLEGE OF PHARMACY",
  "SPARSH GLOBAL BUSINESS SCHOOL",
  "A.D.R.S. INSTITUTE OF TECHNOLOGY & MANAGEMENT",
  "PREM KUMARI COLLEGE OF MEDICAL SCIENCES",
  "DHANVANTRI PARAMEDICAL INSTITUTE",
  "HIND AYURVEDIC PHARMASIST PRSIKSHAN KENDER NAGAL SAHARANPUR",
  "HEALTH WORKER FEMALE TRAINING CENTRE MORADABAD",
  "JEEVAN JYOTI INSTITUTE OF MEDICAL SCIENCES",
  "J K INSTITUTE OF PARAMEDICAL SCIENCES, ALLAHABAD",
  "NAVJEEVAN HOSPITAL AND INSTITUTE OF PARAMEDICAL SCIENCES",
  "UMA COLLEGE OF PHARMACY",
  "VIVEKANAND HOSPITAL AND RESEARCH CENTRE",
  "AASTHA PARAMEDICAL COLLEGE",
  "DR JLRS EYE HOSPITAL",
  "SHAKTI INSTITUTE OF NURSING AND PARAMEDICAL RAEBARELI",
  "GURU VASHISTH PARAMEDICAL COLLEGE",
  "SHRI R P PORWAL INSTITUTE",
  "ECI INSTITUTE OF HOMEOPATHIC PHARMACY TAMSA MARG AKBARPUR AMBEDKAR NAGAR UP",
  "C IMPACT INSTITUTE OF PHARMACY",
  "BABU ANGAD SINGH COLLEGE OF PHARMACY",
  "BM MEMORIAL DEGREE COLLEGE PHARMACY",
  "DEV INDRAWATI INSTITUTE OF POLYTECHNIC",
  "DEV INDRAWATI MAHAVIDYALAYA",
  "DEV INDRAWATI COLLEGE OF PHARMACY",
  "RN COLLEGE OF PHARACY, AMBEDKAR NAGAR",
  "R S MEMORIAL COLLEGE OF PHARMACY",
  "BABU MAHIPAT SINGH COLLEGE OF PHARMACY",
  "J D INSTITUTE OF ENGINEERING AND TECHNOLOGY SADIPUR",
  "JAI SHIV COLLEGE OF PHARMACY AND RESEARCH CENTREE",
  "GIRISH BABU COLLEGE OF PHARMACY",
  "VEERKHAND PHARMACY COLLEGE NAGLA JHANDA  ALIGARH",
  "DEPARTMENT OF PHARMACY SHRI PARAMHANS SHIKSHAN PRASHIKSHAN MAHAVIDYALAYA",
  "DR LOHIA COLLEGE OF PHARMACY, KUCHERA, AYODHYA",
  "SVS SCHOOL OF PHARMACY",
  "KRISHNA INSTITUTE OF PHARMACY MEERUT",
  "R K MISSION COLLEGE OF ALLOPATHIC PHARMACY AYODHYA",
  "KAMAKHYA COLLEGE OF PHARMACY",
  "RANJEET COLLEGE OF PHARMACY AYODHYA",
  "SAI BABA COLLEGE OF PHARMACY",
  "DURGESH NANDINI COLLEGE OF PHARMACY",
  "SWAMI SWAROOPANAND COLLEGE OF PHARMACY",
  "AMBA KPS COLLEGE OF PHARMACY",
  "NARPATI SINGH MAHAVIDYALAYA PHARMACY SANT KABIR NAGAR",
  "RP VIDYAPEETH PHARMACY COLLEGE",
  "PRATEEK SINGH SIDDHARTH POLYTECHNIC COLLEGE",
  "SHREE JEE BABA COLLEGE OF PHARMACY",
  "SMT MAMTA VIDHYALAYA",
  "SHRI BAJRANG INSTITUTE OF PHARMACY",
  "AKG INSTITUTE OF PHARMACY",
  "GAYA PRASAD INSTITUTE OF HUMAN EXCELLENCE FOR PHARMACY",
  "DR B R AMBEDKAR COLLEGE OF PHARMACY",
  "KARAMAT COLLEGE OF PHARMACY",
  "AMMA BABUJI PHARAMACY COLLEGE",
  "NAND COLLEGE OF PHARMACY",
  "MAHATMA GANDHI INSTITUTE OF MEDICAL SCIENCES",
  "RAM NAGINA PHARMACY COLLEGE",
  "ARCHANA COLLEGE OF PHARMACY PRAYAGRAJ",
  "SGB COLLEGE OF PHARMACY",
  "BUDDHA COLLEGE OF PHARMACY",
  "SHREE LAKSHMAN COLLEGE OF EDUCATION, DEORIA",
  "HP INSTITUTE OF PHARMACY",
  "NIHAL SHYAM COLLEGE OF PHARMACY",
  "CHAMPA DEVI COLLEGE OF PHARMACY",
  "SARASWATI DEVI MAHAVIDYALAYA MAHARAJGANJ",
  "LUCKNOW PUBLIC COLLEGE OF PHARMACY",
  "ELITE COLLEGE OF PHARMACY",
  "R A K COLLEGE OF PHARMACY HARDOI",
  "PROFESSOR DEENANATH PANDEY MEDICAL COLLEGE OF PHARMACY",
  "RAM NEWAJ SINGH COLLEGE OF PHARMACY, KUMARGANJ AYODHYA",
  "SHAHID CAPTAIN VIJAI PRATAP SINGH MAHAVIDYALAYA AWAJAUR CHANDAULI",
  "PRITEE COLLEGE OF PHARMACY",
  "SMT AMLEE DEVI COLLEGE OF EDUCATION KOSMA MAINPURI",
  "SMT MURTI DEVI S R S MAHAVIDHYALAY KOSMA MUSALMIN MAINPURI",
  "DNM INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "GANGA PRASAD COLLEGE OF PHARMACY",
  "SMT FULEHRA VISHISHT B T C PRASHIKSHAN KENDRA",
  "SHRI DEVI PRASAD SHARMA MEMORIAL VIDHYALAYA IGLAS",
  "SHRI BABU LAL INSTITUTE OF PHARMACY,MATHURA",
  "CAMBRIDGE PHARMACY COLLEGE BAHARAICH",
  "HILZAR BORDEN EDUCATION CENTRE",
  "KINETIC INSTITUTE OF PHARMACY",
  "BHARAT AYURVED PHARMACY AND NURSING COLLEGE ",
  "JAMIA PARAMEDICAL COLLEGE",
  "VINAYAK MEDICAL COLLEGE",
  "ANJANA INSTITUTE OF TECHNICAL EDUCATION, MADUPUR SAKRAULI, SADAR, PRATAPGARH",
  "SHIFA COLLEGE OF MEDICAL SCIENCES",
  "LATE SURESH CHANDRA MISHRA COLLEGE OF PHARMACY",
  "KRISHNA JAN KALYAN SHIKSHAN SANSTHAN",
  "S H M INSTITUTE OF NURSING AND PARAMEDICAL SCIENCE",
  "BABU PT RAMESHWAR PRASAD DWIVEDI COLLEGE OF PHARMACY",
  "LUCKNOW INSTITUTE OF PHARMACY ",
  "SRDP PHARMACY COLLEGE",
  "SHRIMANT R L SUMAN UCHCHATAR PRAVIDHIK SHAIKSHANIK SANSTHAN, MADANPUR, FIROZABAD",
  "S S INSTITUTE OF MANAGEMENT AND PHARMACY",
  "RAJ CHANDRA HOSPITAL AND RESEARCH CENTRE LUCKNOW",
  "FATIMA HOSPITAL, GORAKHPUR",
  "SANKALP, BARAHPUR, NANDGANJ, GHAZIPUR",
  "MOTHER TERESA INSTITUTE OF PARAMEDICAL SCIENCES",
  "RANA INSTITUTE OF MEDICAL SCIENCES ",
  "SHRI H R S EDUCATIONAL INSTITUTE",
  "DR R N GUPTA INSTITUTE AND RESEARCH CENTER, BADAUN",
  "MEDISON INSTITUTE OF PARAMEDICAL SCIENCES ",
  "ABHAY PRATAP SINGH PHARMACY COLLEGE",
  "DR SHASHI PRABHA SIDDHARTH PHARMACY COLLEGE , KASGANJ",
  "VIRENDRA PRAKASH SIDDHARTH PHARMACY COLLEGE , KASGANJ",
  "JANNAYAK LATE BABU MANAGER SINGH GOVERNMENT POLYTECHNIC BAIRIYA BALLIA",
  "DR JP INSTITUTE OF PHARMACY",
  "R. B. S. PARA MEDICAL COLLEGE RAKSHA JHANSI",
  "JAGANNATH AYURVEDIC COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC MAHASI BAHRAICH",
  "CH. HARMOHAN SINGH PARAMEDICAL SCIENCE & NURSING INSTITUTION",
  "BHARTIYA CHAUHAN SAMITI ",
  "SHARDA SCHOOL OF NURSING & PARAMEDICAL PILIBHIT",
  "SIR SYED SCHOOL OF PARAMEDICAL SCIENCES BALRAMPUR",
  "INSTITUTE OF PHARMACY AND PARAMEDICAL SCIENCE",
  "OM SHRI SAI KRIPA COLLEGE OF PHARMACY",
  "SAINIK GIRIJASHANKAR BTC MAHAVIDYALAYA, PLOT NO SEVEN SEVEN ONE, SARAUNI, KERAKAT, JAUNPUR",
  "HARINANDAN MAHAVIDYALAYA RASOOLPUR SARAI HATWAPAR CHANDAULI",
  "SHRI RAM SMARK MAHAVIDHYALAY VILLAGE PARSON POST PARSON ETAH",
  "BUDDHA PARAMEDICAL COLLEGE",
  "B R COLLEGE OF PHARMACY HARDOI",
  "SAI HOSPITAL BAREILLY",
  "NIET BUSINESS SCHOOL, GREATER NOIDA",
  "MALVIYA SMRITI ACADEMY",
  "GOVT. GIRLS POLYTECHNIC JHANSI",
  "RAMKALI PHARMACY COLLEGE ",
  "LILAWATI ADAYA PRASAD MAHAVIDYALAYA COLLEGE OF PHARAMACY",
  "MAA MUNNAR DEVI PHARMACY COLLEGE BILI MARKUNDI DALA OBRA SONBHADRA",
  "SOMVATI PATEL SMARAK MAHAVIDYALAYA, PANWARI, DHAWAR, MAHOBA",
  "K R B COLLEGE OF PHARMACY",
  "DR VIJAY INSTITUTE OF EDUCATION AND TECHNOLOGY BHANDAHA KALA, KAITHI VARANASI",
  "RAM UJAGIR COLLEGE OF AYURVEDIC PHARMACY AND NURSING BASOHARI",
  "SR COLLEGE OF PHARMACEUTICAL SCIENCES",
  "KAMLA DEVI PHARMACY COLLEGE",
  "GYAN BHARTI COLLEGE OF PHARMACY",
  "SANJEEVANI INSTITUTE OF PHARMACY",
  "SEWA NAND PANDEY MEMORIAL SHIKSHAN EVAM PRASHIKSHAN SANSTHAN, PANDEYPUR, BALLIA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING SIDDHARTHNAGAR",
  "SWAMI SAHAJANAND JANTA MAHAVIDYALAYA AZAMGARH",
  "SRI RAM JANKI TEACHERS TRAINING COLLEGE,  AYODHYA",
  "SONANANDAN MAHAVIDYALAY PLOT NO THREE HUNDRED FOURTY TWO DERAPUR KALICHABAD",
  "CHAUDHARY JAGAN SINGH COLLEGE UMARI MATHURA",
  "MAHARSHI  BABA GALU DAS GANGA SAGAR SHIKSHAN PRASHIKSHAN SEWA SHANSTAN  BALLUA UP ",
  "AGRA DEAF EDUCATION FOUNDATION, AGRA",
  "SAMARPAN BADHIR VIDYALAYA",
  "MAHARISHI SHIKSHAN EVAM PRASHIKSHAN SANSTHAN OFF PHARMACY",
  "DAYA SARASWATI COLLEGE OF PHARMACY JAUNPUR",
  "GOVERNMENT MAHILA POLYTECHNIC BASTI",
  "GOVERNMENT POLYTECHNIC GHUGHALPUR BALARAMPUR",
  "RAMDEV INSTITUTE OF PHARMACY AZAMGARH",
  "B N SIROHI COLLEGE BHADAR SON, SONKH ROAD",
  "SHRI VIDHYA SAGAR ACADEMY OF HIGHER EDUCATION SAGAR ROAD NATIONAL HIGHWAY LALITPUR",
  "KCE",
  "MANSOORI ACADEMY",
  "KAMAYANI NURSING COLLEGE, VILLAGE AJIAURDEI, POST ALIGANJ, DISTRICT SULTANPUR",
  "A R C INSTITUTE OF PHARMACY SANT KABIR NAGAR",
  "BACHCHU SINGH NURSING AND PARAMEDICAL COLLEGE, PRAYAGRAJ",
  "PT RAKESH MISHRA COLLEGE OF PHARMACY AND MEDICAL SCIENCE",
  "PREMA COLLEGE OF PHARMACY",
  "SHREE TARA CHANDRA COLLEGE OF PHARMACY AND MEDICAL SCIENCE",
  "SHRI PRABHAT PHARMACY COLLEGE, SULTANPUR",
  "BANARAS INSTITUTE OF PHARMACY EDUCATION",
  "ASHA COLLEGE OF PHARMACY AND RESEARCH BABATPUR VARANASI",
  "VINDHYA POLYTECHNIC COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "S. M. Nursing College",
  "SHRI RAM POLYTECHNIC",
  "CBS COLLEGE OF PHARMACY",
  "PT KHERE PRASAD VIPIN BIHARI COLLEGE OF PHARMACY",
  "ORDIAL COLLEGE OF PHARMACY",
  "SHRI RAM MURTI SAMARAK SCHOOL OF NURSING BAREILLY",
  "Shri Ram Group of Colleges",
  "Shri Krishna Educational Institute, Ahmadyagar, Sitapur",
  "BHAGWAN DEVI INSTITUTE OF PHARMACY,RAMPUR",
  "G P S B T C TRAINING COLLEGE KHALILABAD SANT KABIR NAGAR",
  "SHANTI NIKETAN GROUP OF INSTITUTIONS",
  "RAMKAILASH TECHERS TRENING INSTITUTE AKMA KUMARGANJ AYODHYA",
  "RAMA NURSING COLLEGE, HAPUR",
  "ACADEMY OF TECHNOLOGY MANAGEMENT AND SCIENCE",
  "GURU VASHISTH INSTITUTE OF NURSING",
  "INSTITUTE OF PRODUCTIVITY AND MANAGEMENT, LUCKNOW",
  "VINDA PAL UGRASEN PAL MAHAVIDALAYA",
  "RAMWATI RAJBAHADUR EDUCATION COLLEGE PRATHVIPUR ETAWAH",
  "SHRI RAMDEVI RAMDAYAL TRIPATHI GIRLS POLYTECHNIC",
  "HEALTH WORKER FEMALE TRAINING CENTRE, FATEHGARH, FARRUKHABAD",
  "SVM COLLEGE OF PHARMACY",
  "HEALTH WORKER FEMALE TRAINING CENTRE, MAINPURI",
  "HEALTH WORKER FEMALE TRAINING CENTRE, AYODHYA",
  "KBS NURSING COLLEGE",
  "HEALTH WORKER FEMALE TRAINING CENTRE, GORAKHPUR",
  "HEALTH WORKER FEMALE TRAINING CENTRE, AGRA",
  "ASHOK INSTITUTE OF PHARMACY",
  "HEALTH WORKER FEMALE TRAINING CENTRE, CHOLAPUR, VARANASI",
  "HEALTH WORKER FEMALE TRAINING CENTRE, BARAGAON, VARANASI",
  "SHAHEED VIRENDRA SINGH SIROHI INSTIUE OF TECHNOLOGY",
  "DEVENDRA SINGH MUNNI DEVI SCHOOL OF NURSING",
  "SWAMI VIVEKANAND COLLEGE OF NURSING",
  "HEALTH WORKER FEMALE TRAINING CENTRE, MIRZAPUR",
  "HEALTH WORKER FEMALE TRAINING CENTRE, LUCKNOW",
  "RENU MAHESH INSTITUTE OF NURSING SCIENCES, SITAPUR",
  "HEALTH WORKER FEMALE TRAINING CENTRE, SAHARANPUR",
  "HEALTH WORKER FEMALE TRAINING CENTRE, MUZAFFARNAGAR",
  "MAA LAWANGI BUDHIYA COLLEGE OF PHARMACY BASU NAGAR DARGAH MAU",
  "DR. RAJENDRA PRASAD POLYTECHNIC",
  "SHANTI SINGH COLLEGE OF PHARMACY BHOPAURA MAU",
  "RAVINDRA SINGH SMARAK PARAMEDICAL SCIENCE AND NSG INST. GONDA",
  "GAUTAMBUDH PARAMEDICAL COLLEGE AND HOSPITAL,KANPATIYAPUR,MAKARANDNAGAR, KANNAUJ",
  "EMERALD  NINE ACADEMY HOMEOPATHIC PHARMACY COLLEGE",
  "RAMA COLLEGE OF PHARMACY",
  "BABU RAM UJAGIR SINGH COLLEGE OF PHARMACY",
  "HEALTH WORKER FEMALE TRAINING CENTRE, BANDA",
  "HEALTH WORKER FEMALE TRAINING CENTRE, MATHURA",
  "PHARMACY COLLEGE SIDDHRATHNAGAR",
  "SIDDHARTHNAGAR PHARMACY COLLEGE",
  "DOON PHARMACY RESEARCH INSTITUTE",
  "DOON PARAMEDICAL COLLEGE AND HOSPITAL",
  "SAINT UMAR AYURVEDIC PHARMACY AND NURSING COLLEGE, NAGRA, JHANSI",
  "RAZA COLLEGE OF NURSING AND PARAMEDICAL SCIENCES BAHERI BAREILLY",
  "S S INSTITUTE OF PHARMACY AND NURSING",
  "SAHARANPUR PHARMACY COLLEGE",
  "PHARMACY COLLEGE",
  "PHARMACY COLLEGE SUNDERPUR",
  "COLLEGE OF PHARMACY SAHARANPUR",
  "BABA BAIJNATH COLLEGE OF PHARMACY AZAMGARH",
  "F S INSTITUTE OF PHARMACY",
  "KRISHNA INSTITUTE OF PROFESSIONAL EDUCATION BIJNOR",
  "DR NITNEMS INSTITUTE OF MENTAL HEALTH AND COGNITIVE SCIENCES",
  "AMBEKESHWAR INSTITUTE OF PHARMACY",
  "DR. BHEEM RAO AMBEDKAR TARAI KISAN MAHAVIDYALAYA",
  "SADBHAWANA PHARMACY COLLEGE, DINGURPUR MUKHLISHPUR AZAMGARH",
  "JP PHARMACY COLLEGE",
  "BABA RAMNATH UTKARSH PHARMACY COLLEGE, BALPUR, AZAMGARH",
  "RAJEEV SHARMA COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "PANKAJ AYURVEDIC PERAMEDICAL COLLEGE DEOBAND",
  "PT TRIPURARI MISHRA ADARSH PHARMACY COLLEGE, TAJPUR GARHA, AZAMGARH",
  "CHANDPUR PHARMACY COLLEGE",
  "SAMARPAN HOMEOPATHIC PHARMACY COLLEGE",
  "PRABHA DEVI PARAMEDICAL COLLEGE",
  "MUNNA SINGH PHARMACY COLLEGE VILLAGE BHAINSORA POST YUSUFPUR NAGALIYA SAMBHAL",
  "S J S GROOP EDUCATION SURJAN NAGAR THAKURDWARA MORADABAD",
  "RAINBOW PHARMACY COLLEGE AZAMGARH",
  "VINOD KUMAR AYURVEDIC PHARMACY COLLEGE",
  "SAI HOMOEOPATHIC PARAMEDICAL COLLEGE",
  "BHARAT EDUCATIONAL INSTITUTE PHARMACY",
  "POPULAR NURSING SCHOOL AND PARAMEDICAL INSTITUTE, MIRZAPUR",
  "JAINATH MEMORIAL COLLEGE OF HOMEOPATHY PHARMACY, HARAIRAMPUR, LALGANJ, AZAMGARH",
  "SUGREEV SINGH MEMORIAL INSTITUTE OF PARAMEDICAL SCIENCES AND HOSPITAL",
  "RP COLLEGE OF PHARMACY JALALPUR KAUDIA AZAMGARH",
  "SMT SHYAMA DEVI INSTITUTE OF HOMOEOPATHIC PHARMACY",
  "ARYAKUL INSTITUTE OF PHARMACY",
  "ARJUN COLLEGE OF PHARMACY, CHANGAIPUR, JIYANPUR  AZAMGARH",
  "SANMUKH COLLEGE OF PHARMACY",
  "NEELDEEP ACADEMY, TEHSIL-SADAR",
  "CH GAJRAJ SINGH PRASHIKSHAN SANSTHAN",
  "SHRI GOPICHAND INSTITUTE OF MANAGEMENT & TECHNOLOGY",
  "CHANDAULI POLYTECHNIC",
  "CROSS BELLY INSTITUTE OF HOMEOPATHIC PHARMACY KUKURIPUR SATHION AZAMGARH",
  "ACHARYA NARENDRA DEV COLLEGE OF PHARMACY, BABHNAN GONDA",
  "AERONAUTICAL TRAINING INSTITUTE UP",
  "A K G Institute of Nursing and Paramedical Sciences",
  "ALLAHABAD COLLEGE OF ENGINEERING AND MANAGEMENT",
  "MAA MATURNI DEVI MAHAVIDYALAY NURSING TRAINING CENTER",
  "I I M T SCHOOL OF NURSING AGRA",
  "MAA RAMRATI MEMORIAL NURSING COLLEGE",
  "MAA SHARDA COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "IMS POLYTECHNIC",
  "MAHALWAR INSTITUTE OF TECHNOLOGY",
  "MAHAMAYA POLYTECHNIC OF INFORMATION TECHNOLOGY CHANDAULI",
  "INDIAN INSTITUTE OF FINANCE, GREATER NOIDA",
  "MAHAMAYA POLYTECHNIC OF INFORMATION TECHNOLOGY GORAKHPUR",
  "MAHARAJA AGRASEN POLYTECHNIC COLLEGE, DAYANATPUR JEWAR, G B NAGAR",
  "MARIAMPUR HOSPITAL KANPUR",
  "INDIAN INSTITUTE OF HANDLOOM TECHNOLOGY, VARANASI",
  "MARY V GORDEN SCHOOL OF NURSING. BAREILLY",
  "Indian institute of nursing",
  "MASCOT INSTITUTE OF MANAGEMENT",
  "MASTER SCHOOL OF MANAGEMENT",
  "MATA GAYATRI DEVI NURSING SCHOOL BIJNOR",
  "MEJOR S.D. SINGH SCHOOL OF NURSING, FARRUKHABAD",
  "INDRA NURSING COLLEGE",
  "METRO COLLEGE OF NURSING GAUTAM BUDH NGR",
  "MOTHER TERESA NURSING SCHOOL & HOSPITAL SAHARANPUR",
  "INFINITY INSTITUTE OF MANAGEMENT & TECHNOLOGY",
  "MURLIDHAR GAJANAND POLYTECHNIC HATHRAS",
  "INSITITUTE OF MANAGEMENT TECHNOLOGY GHAZIABAD",
  "NAZARETH HOSPITAL SCHOOL OF NURSING ALLAHABAD",
  "NEELAVAYNI KRISHNA SCHOOL OF NURSING RAMPUR",
  "NEEL KANTH INSTITUTE OF ENGG. & TECHNOLGOY",
  "INSTITUTE OF ENGG. & RURAL TECHNOLOGY",
  "NEW ERA COLLEGE OF SCIENCE and TECHNOLOGY",
  "N.R.I.P.T.",
  "INSTITUTE OF ENVIRONMENT & MANAGEMENT GUGGAUR",
  "NSS COLLEGE OF BTC",
  "PACIFIC COLLEGE OF NURSING",
  "PANCHWATI INSTITUTE OF POLYTECHNIC",
  "INSTITUTE OF MANAGEMENT STUDIES",
  "PANNA DHAI MAA SUBHARATI NURSING COLLEGE MEERUT",
  "P K POLYTECHNIC",
  "P.L. COLLEGE OF EDUCATION JASWANTNAGAR ETAWAH",
  "ISHWARCHAND VIDYA SAGAR INST. OF TECHNOLOGY 561",
  "P.P.S.COLLEGE OF NURSING",
  "PRAKASH INSTITUTE OF PHYSIO. REH. & ALLIED HEALTH SCIENCES, NOIDA",
  "PREM RAGHU HOSPITAL & PARAMEDICAL INSTITUTE HATHRAS",
  "JANTA POLYTECHNIC JHANGIRABAD",
  "PRINCE INSTITUTE OF INNOVATIVE TECHNOLOGY GR. NOIDA",
  "PRIYANKA COLLEGE OF MEDICAL SCIENCE AND RESEARCH CENTER, DHAMPUR",
  "JEEVANDEEP SCHOOL OF NURSING VARNASI",
  "PT. RAM ADHAR J. TIWARI COLLEGE OF POLYTECHNIC",
  "RAJ SCHOOL OF NURSING GORAKHPUR",
  "JHANVI SCHOOL OF NURSING, LUCKNOW",
  "JHUNJHUNWALA P G COLLEGE FACULTY OF ENGINEERING AND TECHNOLOGY DWARIKAPURI FAIZABAD",
  "J N MEDICAL COLLEGE HOSPITAL ALIGARH",
  "JAIPURIA INSTITUTE OF MANAGEMENT, NOIDA",
  "JYOTI COLLEGE OF MANAGEMENT SCIENCE & TECHNOLOGY BAREILLY",
  "JYOTI HOSPITAL, ALLAHABAD",
  "KALKA INSTITUTE FOR RESEARCH AND ADVANCED STUDIES",
  "KAMAL INSTITUTE OF TECHNOLOGY",
  "KAMLA NEHRU INSTITUTE OF MANAGEMENT & TECHNOLOGY SULTANPUR-",
  "KANCHAN POLYTECHNIC",
  "KESHAV POLYTECHNIC",
  "KESHLATA SCHOOL OF NURSING BAREILLY",
  "KET POLYTECHNIC INSTITUTE",
  "SAINT MOTHER THERESA GNM SCHOOL OF NURSING ALLAHABAD",
  "SAI SCHOOL OF NURSING SULTANPUR",
  "SAKET INSTITUTE OF RESEARCH & PARAMEDICAL SCIENCE ALLAHABAD",
  "SANJAY GANDHI POLYTECHNIC JAGDISHPUR",
  "SANJAY GANDHI SCHOOL OF NURSING PILIBHIT",
  "SANJIVINI INSTT. OF TECH. & MANAGEMENT",
  "SANTOSH HOSPITALS GHAZIABAD",
  "SARDAR PATEL SCHOOL OF NURSING LUCKNOW",
  "SATYADEV INSTITUTE OF TECHNOLOGY",
  "SAVITRI BAI PHULE GOVERNMETN POLYTECHNIC",
  "SAVITRI BAI PHULE GOVT. GIRLS POLYTECHNIC",
  "SAVITRI RAMBARAN SHUKLA SHIKKCHAN PRASHIKKCHAN  AMETHI",
  "School of Engineering and Technology",
  "SCHOOL OF NURSING DEVA ROAD LUCKNOW",
  "School of Nursing Gangotri Devi Mahila Mahavidayalaya",
  "SCHOOL OF NURSING MEMORIAL HOSPITAL",
  "SCHOOL OF PHARMACY & RESEARCH",
  "NATIONAL SUGAR INSTITUTE, KANPUR",
  "VAIDYA BHOOP SINGH INSTITUTE OF PHARMACY",
  "M S PHARMACY COLLEGE MEERAPUR DERABIBI AYODHYA",
  "SHRI GIRRAJ MAHARAJ INSTITUTE OF PHARMACY, MATHURA",
  "MNM RAKESH PHARMACY COLEGE",
  "MAHACHARAN PHARMACY COLLEGE REVAN MAURANIPUR JHANSI",
  "KOPAL INSTITUTE OF PHARMACY, BAREILLY, UP",
  "DWARIKA PRASAD PHARMACY COLLEGE, PRAYAGRAJ",
  "PT RAM NARAYAN SHARMA MAHAVIDYALAY PRATAPGARH",
  "JAY NAND PARAMEDICAL COLLEGE",
  "MSME TECHNOLOGY CENTRE KANPUR",
  "JAI MAA VAISHNO DEVI PHARMACY COLLEGE",
  "S M B L ACADEMY",
  "RCS MEMMORIAL COLLEGE OF PHARMACY, AGRA",
  "SHRI MOTI SMRITI INSTITUTE OF TECNOLOGY",
  "R R MAHAVIDYALAY PRATAPGARH",
  "DEV COLLEGE OF MEDICAL SCIENCE, AYODHYA",
  "CHAUDHARY NIYAZ MOHAMMAD DEGREE COLLEGE, BUDAUN",
  "BABU SUSHIL SINGH INSTITUTE OF POLYTECHNIC, NIBI BELAISA SADAR AZAMGARH",
  "J M P C LALGANJ AZAMGARH",
  "SAI COLLEGE OF PHARMACY AND NURSING",
  "A P S COLLEGE OF PHARMACY RUKMANGAD PUR POST KHEMAPUR DIST AMBEDKAR NAGAR",
  "J B S INSTITUTE OF PHARMACY BANDI KA PURWA BARABANKI",
  "S D INSTITUTE OF PHARMACY, MUZAFFARNAGAR",
  "MAHARAJA AGRASEN COLLEGE OF PHARMACY",
  "J B S INSTITUTE OF PHARMACY JALPAPUR MEENNAGAR BARABANKI",
  "CROSS BELLY AYURVEDIC SCHOOL KUKURIPUR SATHIAON AZAMGARH",
  "BRMHDUTT DWIVEDI PRABHA DWIVEDI AURVEDIC PHARMACY UNANI COLLAGE CHHAWANI BASTI",
  "PRIME EDUCATIONAL INSTITUTE",
  "LAXMI MEMORIAL INSTITUTE OF EDUCATION, UCHAURI, SHEKHANPUR, KASIMABAD, GHAZIPUR",
  "SIYA RAM GANGA PRASAD PHARMACY COLLEGE",
  "UNIVERSAL COLLEGE OF PHARMACY UDAIPUR KHURD KARANWAS ROAD ANOOPSHAHR DIST BULANDSHAHR",
  "RADHA KRISHNA COLLEGE OF PHARMACY KANAULI, HOLIPUR, SAIDPUR, GHAZIPUR",
  "P S COLLEGE OF PHARMACY, FIROZABAD",
  "SPARK COLLEGE OF PHARMACY",
  "K D S COLLEGE OF PHARMACY",
  "INDRA PHARMACY COLLEGE",
  "DDM COLLEGE OF NURSING AND PARAMEDICAL SCIENCE",
  "SHAHEED BHAGAT SINGH COLLEGE OF PHARMACY",
  "SHAFI DEGREE COLLEGE, PILIBHIT",
  "SCHOOL OF PHARMACY SHIVAM TECHNICAL CAMPUS",
  "SCHOOL OF PHARMACY COLLEGE",
  "R B S COLLEGE OF PHARMACY",
  "AKSHITA COLLEGE OF PHARMACY VILL ETMADNAGAR ALIPUR TEHSIL-SARDHANA MEERUT",
  "SANTUSHTI COLLEGE OF MEDICAL AND HIGHER STUDIES",
  "SANTOSH COLLEGE OF PHARMACY",
  "R P COLLEGE OF PHARMACY BANIKODAR BARABANKI",
  "R K COLLEGE OF PHARMACY GHATAMPUR BHELARA SULTANPUR",
  "GOVERNMENT POLYTECHNIC KURU PINDRA VARANASI",
  "LORD BUDDHA COLLEGE OF PHARMACY",
  "MANVENDRA SINGH SUMAN MAHAVIDYALAYA PHARMACY COLLEGE JAUNPUR",
  "MAA SARASWATI COLLEGE OF PHARMACY JAUNPUR",
  "SHRI R P COLLEGE OF PHARMACY",
  "R K COLLEGE OF PHARMACY, AZAMGARH",
  "MAA SARASWATI DEVI COLLEGE OF PHARMACY,JAUNPUR",
  "UNNATI MANAGEMENT COLLEGE AND TECHNOLOGY, FARAH, MATHURA",
  "GOVERNMENT POLYTECHNIC KIRTHAL CHAPRAULI BAGPHAT",
  "GOVERNMENT POLYTECHNIC, KENAURA, SULTANPUR",
  "GOVERNMENT POLYTECHNIC, ALAPUR , BUDAUN",
  "government polytechnic premdhar patti raniganj pratapgarh",
  "R J PHARMACY COLLEGE, GHAZIPUR",
  "P G GROUP OF COLLEGE PHARMACY JAUNPUR",
  "Rajat Degree College, Matiyari",
  "Mahamaya Poly. of Information Technology Maharajganj",
  "R A S INSTITUTE OF PHARMACY PIPARIDEEH MAU",
  "K.V. PHARMACY COLLEGE, NH-2, KUBERPUR, AGRA",
  "MAHAVEER INSTITUTE OF TECHNOLOGY ABUSA SARAI INAYAT ALLAHABAD",
  "Asit College of Education Gangapura, Etawah",
  "RAM LAKHAN MAHAVIDYALAYA",
  "C.B.S.COLLEGE OF POLYTECHNIC",
  "SUSHILA PHARMACY COLLEGE",
  "Asian Institute Of Rural Technology",
  "SHIV SHAKTI PARAMEDICAL COLLEGE ALIGARH",
  "I V S POLYTECHNIC CODE 568",
  "RAM GOPAL SHUKLA COLLEGE OF PHARMACY",
  "RAJNARAYAN PHARMACY COLLEGE",
  "PURVANCHAL COLLEGE OF PHARMACY, AZAMGARH",
  "P R S COLLEGE OF PHARMACY BILSAD ROAD ALIGANJ ETAH",
  "TAJ MAHAVIDHYALAYA KASIMPUR BAHADURGARH ETAH",
  "PREMWATI PRAKASH NARAYAN COLLEGE OF PHARMACY KANPUR DEHAT",
  "P M D MAHAVIDYALAYA",
  "NANDRANI COLLEGE OF PHARMACY",
  "BRMHDUTT DWIVEDI PRABHA DWIVEDI COLLAGE OF HOMYOPATHIC PHARMACY",
  "NAND KISHORE PHARMACY COLLEGE",
  "KRISHNA INSTITUTE OF HIGHER EDUCATION",
  "MAHARSHI MOOLCHAND YADAV PHARMACY COLLEGE, JAUNPUR",
  "STUDY WELL INSTITUTE OF PHARMACY",
  "ISHRAWATI DEVI INSTITUTE OF PHARMACY COLLEGE, BASTI",
  "MAA SHARDA INSTITUTE OF PHARMACY, PRAYAGRAJ",
  "NARPAT SINGH COLLEGE OF PHARMACY",
  "DR VK VERMA INSTITUTE OF MEDICAL SCIENCE",
  "DR A P J ABDUL KALAM COLLEGE OF PHARMACY",
  "MAA PRABHAWATI HOMEOPATHIC PHARMACY COLLEGE,  SURAI SATHIAON AZAMGARH",
  "MAA KAUSHALYA COLLEGE OF PHARMACY, AZAMGARH",
  "K S COLLEGE OF PHARMACY, MAURANIPUR, JHANSI",
  "KESHAV MADHAV INSTITUTE OF PHARMACY",
  "DAYANAND CHAUDHARY COLLEGE OF MEDICAL SCIENCE",
  "KALAWATI COLLEGE OF PHARMACY",
  "PPS PHARMACY COLLEGE ETAH",
  "KAILASH NATH COLLEGE OF PHARMACY AZAMGARH",
  "JANTA COLLEGE OF PHARMACY JAUNPUR",
  "JAMUNADEVI NARESHCHANDRA MAHAVIDHYALAYA COLLEGE OF PHARMACY",
  "JAI BAJRANG PHARMACY INSTITUTE JAUNPUR",
  "H M COLLEGE OF PHARMACY",
  "HARDAM SINGH VEDIC PHARMACY COLLEGE",
  "GAHARWAR COLLEGE OF PHARMACY",
  "DR RAM MANOHAR LOHIYA PHARMACY AND NURSING COLLEGE",
  "BILLAH COLLEGE OF PHARMACY",
  "NARVADESHWAR PHARMACY COLLEGE",
  "GOVERNMENT POLYTECHNIC DIBAI BULANDSHAHR",
  "SHREE RAM COLLEGE OF PHARMACY",
  "GANGA SHEEL PARA MEDICAL COLLEGE, BAREILY",
  "MAHARANA PRATAP COLLEGE OF PHARMACY AND PARAMEDICAL SCIENCES",
  "DMR PHARMACY COLLEGE",
  "BMBL JAIN COLLEGE OF PHARMACY",
  "V V COLLEGE OF AYURVEDA",
  "DMR COLLEGE",
  "SGGS COLLEGE OF PHARMACY AND RESEARCH CENTRE",
  "DURGA COLLEGE OF PHARMACY",
  "CHAUDHARY COLLEGE OF PHARMACY",
  "Dr KNS College of Paramedical Sciences Dr KNS Memorial Institute of Medical Sciences Barabanki",
  "SAMARPAN AYURVEDIC PHARMACY COLLEGE",
  "S G COLLEGE OF PHARMACY",
  "SRI KOMAL SAHU SMARAK PHRMACY COLLEGE POONAPAR JIYANPUR AZAMGARH",
  "SHIV SHAKTI PARAMEDICAL AND NURSING COLLEGE ALIGARH",
  "CHANDRASHEKHAR JI PURVA PRADHANMANTRI SMARAK PHARMACY COLLEGE, GHAZIPUR",
  "RADHA KRISHNA COLLEGE OF HOMOEOPATHY",
  "CAMBRIDGE SCHOOL OF PHARMACY, MAHOBA",
  "B S PHARMACY COLLEGE, GHAZIPUR",
  "B R D PHARMACY MEDICAL INSTITUTE NAISARA SAIDPUR GHAZIPUR",
  "BABU HARI RAM SINGH MAHAVIDYALAYA OF PHARMACY",
  "BABA PATALNATH COLLEGE OF PHARMACY, AZAMGARH",
  "F I INSTITUTE OF PARAMEDICALS",
  "SUMITRA INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "AKHAND COLLEGE OF PHARMACY FARDAPUR PO BHADAICHA HARDOI",
  "MAHATMA GAUTAM BUDDHA SHAKTI VIDYA PEETH COLLEGE OF EDUCATION",
  "ABHAY PRATAP SINGH PHARMACY COLLEGE KADA KAUSHAMBI",
  "Teerthanker Shantinath College of Education",
  "CHIRANJEEV NURSING INSTITUTE",
  "S D S T T COLLEGE MARTHARA ETAH",
  "Teerthanker Neminath girls College of Education",
  "Smt. Mala Devi Memorial College",
  "S.B.L. Memorial College",
  "MAA KALAWATI SHIKSHAN SEVA SANSTHAN,KAREHA,KARCHANA,ALLAHABAD",
  "DR SHEELA SHARMA INSTITUTE OF NURSING AND PARAMEDICAL ",
  "SD AYURVEDIC PHARMACY COLLEGE",
  "NANDA INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "I D MEMORIAL COLLEGE OF PHARMACY",
  "KUSUM INSTITUTE OF EDUCATION BAHORA KASGANJ",
  "KDH COLLEGE OF PHARMACY",
  "RAM TEERATH COLLEGE OF PHARMACY",
  "AMEER HASAN COLLEGE OF PHARMACY, IMAMGANJ ROAD, NANPARA",
  "RIT COLLEGE OF PHARMACY RASOOLABAD NANPUR HAPUR",
  "ARYAKUL INSTITUTE OF PHARMACY SITAPUR",
  "SHRI GOVIND DEGREE COLLEGE TEWAR KHAS BILARI MORADABAD",
  "NARAYAN COLLEGE OF PHARMACY",
  "RAJA RAGHURAJ SINGH COLLEGE OF PHARMACY GONDA",
  "BABU RAMESHWAR DAYAL COLLEGE OF MEDICAL SCIENCE",
  "ZACISTHA EDUCATIONAL INSTITUTE",
  "DAYA INSTITUTE OF EDUCATION AND TECHNOLOGY",
  "R B S COLLEGE OF EDUCATION KURANI SAMADHGANJ JAUNPUR",
  "Sugreev Singh Memorial Institute of Nursing AND  Hospital",
  "PACHAINYA COLLEGE OF PHARMACY, MATHURA",
  "SHRI BHAWANI PRASAD DUBEY SHIKSHA AVAM PRASHIKSHAN SANSTHAN BANGAON KATRA BAZAR GONDA",
  "RAJ SINGH COLLEGE OF EDUCATION VILLAGE POST TIKROUL TESIL RAMPUR MANIHARAN SAHARANPUR",
  "PT SATYA NARAYAN DWIVEDI SHIKSHAN EVAM PRASHIKSHAN MAHAVIDYALAYA",
  "PRABHA DEVI BHAGWATI PRASAD MAHAVIDYALAY BTC COLLEGE",
  "NIRMALA TEACHERS TRAINING COLLEGE GANPA SIRATHU KAUSHAMBI",
  "NANDRANI SHIKSHAN SANSTHAN",
  "MORADABAD COLLEGE OF EDUCATION",
  "MAA YAMUNA GIRLS COLLEGE OF EDUCATION, BHOJAPUR",
  "MAA GAYTRI BASIC TEACHER TRANNING INSTITUTE AMROLI RATANPUR ALIGANJ ETAH",
  "NALANDA COLLEGE OF HOMEO PHARMACY BAHORIKPUR AKKBARPUR AMBEDKAR NAGAR",
  "HIRA SINGH YADAV COLLEGE OF PHARMACY",
  "Rajat College of Education and Management",
  "KUNWAR KALI EDUCATIONAL COLLEGE VILL ALAMPUR DHAPI BIJNOR",
  "KAMALA PANDEY WOMEN EDUCATIONAL INSTITUTE NIZAMUDDINPUR DULLAHAPUR GHAZIPUR",
  "KAILASHI DEVI KESHAW PRASAD BTC COLLEGE",
  "H M SHIKSHAN AVAM PRASHIKSHAN SANSTHAN, PEEWATAL, MAU",
  "VIKAT INSTITUTE",
  "R K SINGH HOSPITAL AND INSTITUTE OF MEDICAL SCIENCES RAGAULI KARWI CHITRAKOOT UP",
  "VINAYAKA INSTITUTE",
  "LONG SHRI EDUCATIONAL INSTITUTE LAXMINAGAR MATHURA",
  "BINDESHWARI DUBEY COLLEGE OF EDUCATION AND TRANINING YUSUFPUR GHAZIPUR",
  "BABU MUSAFIR SINGH B T C PRASHIKSHAN SANSTHAN",
  "VIVEKANANDA COLLEGE OF POLYTECHNIC",
  "NARAINA POLYTECHNIC INSTITUTE",
  "B R COLLEGE OF PHARMACY",
  "R K INSTITUTE OF NURSING AND PARAMEDICAL SCIENCE BANKERS CALONY FAIZABAD ROAD SHAHGANJ JAUNPUR",
  "Government Polytechnic , Mujahana Hata, Kushinagar",
  "RAJ OPTOMETRY TRAINING CENTRE DEORIA",
  "KRISHNA AYURVEDIC COLLEGE AND HOSPITAL VILLAGE  KAMALPUR POST CHHUTMALPUR DISTRICT SAHARANPUR",
  "INSTITUTE OF MEDICAL SCIENCES, AMROHA",
  "UMRAI SCHOOL OF HOMEOPATHIC PHARMACY",
  "BHAGIRATHI KAMALA HOMEOPATHIC PHARMACY COLLEGE PRATAPPUR CHAMURKHA KATEHARI AMBEDKARNAGAR",
  "Rajat Degree College of Education and Training Institute",
  "EKTA PARAMEDICAL COLLEGE",
  "MOHAMMAD HASAN POST GRADUATE COLLEGE SUKHKHIPUR SHAHGANJ ROAD JAUNPUR",
  "TETARI DEVI SHIKSHA EVOM PRASHIKSHAN SANSTHAN,  SARAY GOKUL, GHAZIPUR",
  "BHAGIRATHI AYURVED PHARMACY COLLEGE PRATAPPUR CHAMURKHA KATEHARI AMBEDKARNAGAR",
  "SAMVRIDDHI COLLEGE OF PHARMACY, BARABANKI",
  "SUMANLATA SANTANPAL SINGH INSTITUTE OF MEDICAL SCIENSES, SHAHJAHANPUR",
  "ATIBAL SINGH TEACHER TRANING COLLEGE SINKI KLAAN MEJA ALLAHABAD",
  "SWARAJ COLLEGE OF EDUCATION",
  "Thakur Tej Singh College Of Education",
  "SHRI RAM LAKHAN PATEL COLLEGE OF PHARMACY , AYODHYA",
  "DHARAMVEER INTITUTE OF NURSING NOORPUR BIJNOR",
  "VIIT POLYTECHNIC COLLEGE, BULANDSHAHAR",
  "S S INSTITUTE OF PHARMACY AND PARAMEDICAL",
  "S N S K INSTITUTE OF HOMOEOPATHIC PHARMACY  ,GHAZIPUR",
  "Laxmi Nursing Training Institute",
  "RAM AVADH HOMOEOPATHY PHARMACY COLLEGE",
  "Rajat Girls College of Education and Management",
  "Government Polytechnic,Chariyaon Bujurg,Deoria",
  "MAHAMAYA POLYTECHNIC OF INFORMATION & TECHNOLOGY,AMORHA,J.P. NAGAR",
  "ARCADIAN INSTITUTE OF HIGHER EDUCATION",
  "AJIT KUMAR AYURVEDIC PHARMACY COLLEGE",
  "R.D. COLLEGE B.T.C. OL FARAH MATHURA",
  "DS SCHOOL OF NURSING NH TWENTY FOUR OPP SHRI BANKEY BIHARI DENTAL COLLEGE PRASON JINDAL NAGAR MASURI HAPUR GHAZIABAD",
  "HERITAGE SCHOOL OF NURSING, BHADWAR VARANASI",
  "RAMA SHANKAR PRABHA INSTITUTE OF HOMOEOPATHIC PHARMACY",
  "ANAND MAHILA MAHAVIDYALAYA, PLOT NO 1026, BARSERVA, BAHADURPUR, LALGANJ, AZAMGARH",
  "SUSHILA YADAV SHIKSHA SANSTHAN, PLOT NO THIRTY FOUR, THIRTY SEVEN, FATTEPUR CHARI BHITARI GHAZIPUR",
  "MAHARAJA PRITHVIRAJ CHAUHAN COLLEGE OF PHARMACY SARAKTHAL TANDA RAMPUR",
  "MAA SARASWATI SCIENCE  AND TECHNOLOGY",
  "GOVERNMENT POLYTECHNIC, BABERU BANDA",
  "P D NURSING AND PARAMEDICAL COLLEGE",
  "GOVERNMENT POLYTECHNIC SAHJANWA GORAKHPUR  ",
  "BHAGWAN ADARSH HOMEOPATHIC PHARMACY COLLEGE, NAREHATHA CHAKRAPANPUR AZAMGARH",
  "KAMALA PATI PHARMACY AND NURSING COLLEGE OF EDUCATION, RAJEPUR KAJGAON JAUNPUR",
  "DADA BHARAT SINGH SHIKSHAN PRASHIKSHAN SANSTHAN KAILAHAT CHUNAR MIRZAPUR",
  "FACULTY OF PHARMACY DWARIKADHEESH MAHAVIDHYALAYA , MAINPURI",
  "B N SINGH MEMORIAL HOSPITAL AND NURSING TRAINING INSTITUTE, PRATAPGARH",
  "SHRI MAHAVEER SINGH PHARMACY COLLEGE , RAEBARELI",
  "DR SP GUPTA COLLEGE OF PROFESSIONAL STUDIES, PRAYAGRAJ",
  "M D PHARMACY COLLEGE BHARALAI SHIVPUR VARANASI",
  "SADBHAWANA VIDYAPEETH SHIKSHA SAMITI",
  "Indu prakash polytechnic college",
  "SSG HEALTH WORKER FEMALE TRAINING CENTRE, AGRA",
  "VARUN ARJUN COLLEGE OF PHARMACY",
  "LRS WORLD COLLEGE",
  "MAJOR S D SINGH NURSING AND PARAMEDICAL COLLEGE MOHAMMDABAD FARRUKHABAD",
  "A N G IDEAL AYURVEDIC PHARMACY AND NURSING COLLEGE SARAITAKKI BABATPUR VARANASI",
  "SANTUSHTI INSTITUTE OF NURSING & PARAMEDICAL SCIENCES NEWADA SUNDERPUR VARANASI",
  "SURYA PAL INSTITUTE OF PHARMACY",
  "MAA BUDDHA NATIONAL MAHAVIDYALAY SAMITI, MUNIYA MAKADUMPUR, JAGDISHPUR NIZAMABAD, AZAMGARH",
  "UNITECH INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "VIMLA VIKRAM DEGREE MAHAVIDYALAYA COLLEGE",
  "SHAMBHUNATH COLLEGE OF EDUCATION",
  "LALITA TEACHER TRAINING INSTITUTE PLOT NO ONE SEVEN ZERO RAGHUVEER NAGAR BHIKHARIPUR MACHHALISHAHAR JAUNPUR",
  "AGRA PUBLIC PHARMACY COLLEGE OF DIPLOMA",
  "SURYA COLLEGE OF TECHNICAL STUDIES",
  "R B COLLEGE OF PHARMACY",
  "GS SCHOOL OF NURSING HAPUR",
  "Government Polytechnic Puwayan Shahjahanpur",
  "GOVERNMENT POLYTECHNIC NIKARIKA RAJGARH MIRZAPUR",
  "JAGAT NARAYAN TIWARI INSTITUTE OF NURSING, BANSDEV PATTI, MANYAHU, JAUNPUR",
  "GOVERNMENT POLYTECHNIC , ROORKEE, BAHERI, BAREILLY",
  "VAISHNAVI COLLEGE OF PHARMACY BAHADURPUR MAINPURI",
  "SHRI DIGAMBAR SINGH ANGOORI DEVI INSTITUTE OF PHARMACY SAHAR CHHATA MATHURA",
  "GOVERNMENT GOVIND BALLABH PANT POLYTECHNIC",
  "VIVEKANANDA POLYCLINIC AWAM AYURVIGYAN SANSTHAN VIVEKANANDA PURAM LUCKNOW",
  "JAI MATA DULHAMI TRIBHUWAN MAHAVIDYALAYA",
  "D J COLLEGE OF PARAMEDICAL SCIENCES, NIWARI ROAD, MODINAGAR, GHAZIABAD",
  "SWAMI VIVEKANAND INSTITUTE OF MEDICAL SCIENCE",
  "AWADH PARAMEDICAL INSTITUTE",
  "AWADH CT SCAN EMERGENCY AND TRAUMA CARE INSTITUTE",
  "SMT CHAMPA DEVI SHIKSHA PRAKSHISHAN COLLEGE",
  "SHRI SHAKTIMAYI HOMEOPATHAITH PHARMECY COLLEGE KHARAGPUR AZAMGARH",
  "SHRI RAJESH KUMAR THATHERA PHARMACY COLLEGE, AZAMGARH",
  "DEVKI MADHAV INSTITUTE OF PARAMEDICAL SCIENCES",
  "S V M PHARMACY COLLEGE SARAI SULTANI RANIGANJ PRATAPGARH",
  "RAJ NARAYAN SINGH SAMMOPUR POLYTECHNIC",
  "SHRI DURGAJI COLLEGE OF PHARMACY, AZAMGARH",
  "SACHIDANAND SCHOOL OF  NURSING",
  "RAMLALIT SINGH PARAMEDICAL INSTITUTE OF MEDICAL SCIENCES MIRZAPUR",
  "SKG College Of Pharmecy",
  "TILKA DEVI INSTITUTE OF PARA MEDICAL SCIENCES, PRATAPGARH",
  "SHOBHAWATI COLLEGE OF PHARMACY DERAMUSI AYODHYA",
  "SHAHBAAN MEMORIAL AYURVEDIC PHARMACY ANDGNM COLLEGE SARAI CHAWAT NAGRA BALLIA",
  "government polytechnic hindalpur",
  "Ahsan Paramedical And Nursing College",
  "R R Polytechnic  Hindwari  Sonebhadra",
  "KAMKUS COLLEGE OF SPECIAL EDUCATION AND RESEARCH",
  "Anantraj Institute of Nursing and Paramedical Sciences",
  "sai college of pharmacy",
  "Shree Bhagwat Institute of Technology",
  "GOVERNMENT GIRLS POLYTECHNIC, ARNIA, BULANDSHAHR",
  "I Business Institute",
  "GOVERNMENT POLYTECHNIC SARSAI RATH",
  "NTPC School of Business",
  "Prabha Institute Of Nursing and Paramedical Training",
  "SAROJANI KAMLA DEVI AYURVEDIC PARAMEDICAL NURSING AND PHARMACY COLLEGE AGRA ROAD ETAH",
  "RGNP COLLEGE OF PHARMACY RAJA KA TAJPUR NOORPUR BIJNOR",
  "MAJOR S D S COLLEGE OF PHARMACY",
  "SIKARWAR COLLEGE SAIDPUR MATHURA",
  "Dr KNS College of Nursing Ambedkar Nagar",
  "NISHAT HOSPITALS AND INSTITUTE OF PARAMEDICAL SCIENCES",
  "NIRMALA DEVI POLYTECHNIC COLLEGE NAYANSAND JAUNPUR",
  "KARMYOGI COLLEGE OF HOMOEOPATHIC PHARMACY AMBEDKAR NAGAR ",
  "IMS College of Engineering",
  "Govt. Polytechnic Sinduria",
  "SAMRIDHI COLLEGE OF PHARMACY",
  "H.W. (FEMALE) TRAINING CENTRE, AZAMGARH",
  "U P INSTITUTE FOR THE HEARING HANDICAPPED PRAYAGRAJ",
  "SANSKRITI PHARMACY COLLEGE",
  "GOVERNMENT GIRLS POLYTECHNIC, RISIA NANPARA, BAHRAICH",
  "DR ANITA YADAV COLLEGE OF PHARMACY",
  "SUKHDEV SINGH MAHAVIDYALAYA AND PHARMACY",
  "SHIV SHAKTI HOMEOPATHIC PHARMACY COLLEGE , CHOTA MIRZAPUR, MIRZAPUR",
  "RANI CHANDRA PRABHA PHARMACY COLLEGE KHAGA FATEHPUR",
  "RAM SINGH PHARMACY COLLEGE, MAINPURI",
  "SETH BADRI PRASAD SMARITI MAHAVIDHYALAYA",
  "SHIVMURTI COLLEGE OF PHARMACY",
  "RAJ KISHORI DEVI SHIKSHAN PRASHIKSHAN SEWA SANSTHAN",
  "LT SH JAGAT NARAYAN TRAINING COLLEGE FOR MENTALLY HANDICAPPED ",
  "DR K N MODI ENGINEERING COLLEEGE",
  "I.E.M.",
  "HANDIA POLYTECHIC",
  "SMT VIMLA DEVI COLLEGE OF PHARMACY",
  "RAMDEV COLLEGE OF PHARMACY AYODHYA",
  "GURU SHRI GORAKSHNATH CHIKITSALAYA GORAKHPUR",
  "RAMBACHAN YADAV MAHVIDHYALAY PHARMECY",
  "PRIYANKA COLLEGE OF PHARMACY ANJANI MAINPURI",
  "PREMA DEVI PHARMACY OLLAGE, MAINPURI",
  "OM SAI AYURVEDIC COLLEGE  SAHARANPUR",
  "MAWANA COLLEGE OF PHARMACY",
  "MAHARSHI YOGIRAJ DEVRAHA BABA MAHAVIDYALAY AMBEDKARNAGAR",
  "KAULESHWAR SURYAMATI INSTITUTE OF HOMOEOPATHIC PHARMACY M G AMBEDKAR NAGAR",
  "J P HOMOEO PHARMACY COLLEGE",
  "J K INSTITUTE OF PHARMACY AGWALRAILWAY CROSSING KHURJA DISTT BULANDSHAHR",
  "GURUKUL SCHOOL OF NURSING",
  "AAPRUP COLLEGE OF PHARMACY KUSAHA PARGANA NARWAN CHANDAULI",
  "G B S COLLEGE OF PHARMACY JAISINGHMAU TARUN AYODHYA",
  "PREMA TEACHERS TRAINING COLLEGE ACHIYA MEHDAWAL SKNAGAR",
  "G S R M MEMORIAL SCHOOL OF NURSING LUCKNOW",
  "GOVT PLOYTECHNIC SIKANDRA KANPUR DEHAT",
  "GOVERNMENT POLYTECHNIC, MANKEDA, AGRA",
  "GOVERNMENT POLYTECHNIC MANIKPUR CHITRAKUT",
  "GOVERNMENT POLYTECHNIC MAINPURI",
  "GOVERNMENT POLYTECHNIC LUCKNOW",
  "KRISHNA SUDAMA SANSTHAN (BTC)",
  "R. A. S. SCHOOL OF NURSING, KULHANAMAU, LUCKNOW ROAD, JAUNPUR",
  "Mahalwar Institute Of Pharmacy",
  "GOVERNMENT POLYTECHNIC LALITPUR",
  "GOVERNMENT POLYTECHNIC GHAZIPUR",
  "GOVERNMENT POLYTECHNIC GHAZIABAD",
  "GOVERNMENT POLYTECHNIC GHATAMPUR",
  "GOVERNMENT POLYTECHNIC FIROZABAD",
  "DR BASUDEO YADAV HOMOEPATHIC PHARMACY COLLEGE NARANGPUR PATTI PRATAPGARH",
  "BABU BASANT LAL COLLEGE OF PHARMACY,PRAYAGRAJ",
  "GOVERNMENT POLYTECHNIC FATHEPUR",
  "GOVERNMENT POLYTECHNIC MAHOBA",
  "ARCHIT UTKARSH COLLEGE OF PHARMACY ROOPPUR BHARATPUR MAINPURI",
  "GURUKUL PRASHIKSHAN MAHAVIDYALAYA PURASI",
  "TRINITY COLLEGE OF PARAMEDICAL SCIENCES",
  "KARMYOGI COLLEGE OF EDUCATION",
  "A P COLLEGE OF PHARMACY",
  "SHAKUNTALAM INSTITUTE OF PHARMACY",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, KANPUR NAGAR",
  "MSB COLLEGE OF PHARMACY",
  "GD COLLEGE OF PHARMACY ",
  "ANJANA COLLEGE OF PHARMACY",
  "AJAY PAL COLLEGE OF PHARMACY",
  "AAMOLYA COLLEGE OF PHARMACY AZAMGARH",
  "KRISHAK MAHAVIDYALAY UKRAW BAHARIYABAD GHAZIPUR",
  "SHRI MANNULAL SANSKRIT MAHAVIDYALAYA ATARRA",
  "RANGJI YADAV COLLEGE OF TEACHER EDUCATION",
  "HARINANDAN JILA SIKSHA AND PRASHIKSHAN SANSTHAN SARAI RASOOLPUR HATWAPAR CHANDAULI",
  "D C S INTERNATIONAL INTER COLLEGE",
  "S D S COLLEGE OF PHARMACY MARTHARA ETAH",
  "PARSHURAM VERMA MEMORIAL COLLEGE OF PHARMACY",
  "MIT INSTITUTE OF TECHNOLOGY",
  "DR KASHINATH COLLEGE OF PHARMACY, GHAZIPUR",
  "BABU BAIJNATH SINGH PHARMACY AND NURSING COLLEG, DEORIA",
  "ZENESIS INTERNATIONAL SCHOOL NANDAPAR GORAKHPUR",
  "AYISHA PARAMEDICAL COLLEGE",
  "MAHAVEER SINGH CHAHAR COLLEGE OF PHARMACY ",
  "DR. R. N. RAI COLLEGE OF PHARMACY",
  "DIVYA PARAMEDICAL COLLEGE AND HOSPITAL",
  "H S INSTITUTE OF HIGHER  EDUCATION",
  "VINDHYACHAL DRAUPADI DEVI SEWA SAMITI",
  "SUSHILA YADAV SHIKSHA SANSTHAN FATEHPUR CHARI BHITARI GHAZIPUR",
  "JAWAHAR LAL NEHRU POLYTECHNIC MEHMOODABAD",
  "UMALOK CHARITABLE TRUST",
  "INGRAHAM POLYTECHNIC,HAPUR ROAD",
  "BABA JAGESHWARNATH MAHAVIDHYALAYA CHANDAULI",
  "MAA BUDDHA NATIONAL INSTITUTE OF ENGG. & TECHNOLOGY",
  "R K INSTITUTE OF PARAMEDICAL SCIENCES",
  "INDRA DEO DHAR DUBEY COLLEGE OF EDUCATION, TILAURA PALI SAHJANWA, GORAKHPUR",
  "PREMA INSTITUTE FOR SPECIAL EDUCATION, ACHHIYA MENHDAWAL, SANT KABIR NAGAR, UP",
  "RACHIT HOSPITAL",
  "IIMT COLLEGE OF PARAMEDICAL EDUCATION",
  "NAVADA GRAM UDYOG VIKAS SAMITI ALI MOBEEN MEMORIAL INSTITUTE FOR HANDICAPPED MOHALLA BAGLA AMROHA ",
  "SIGNA COLLEGE OF NURSING",
  "K S V COLLEGE OF NURSING AND MEDICAL",
  "RSVS EDUCATIONAL TRAINING INSTITUTE CHITARI SAGRA LALGANJ PRATAPGARH",
  "RAJKISHOR SINGH MAHAVIDYALAY PHARMACY, GHAZIPUR",
  "DIPANJALI PHARMACY COLLEGE, PRAYAGRAJ",
  "RAM KUMAR SHUKLA SHIKSHAN AVAM PRASHIKSHAN SANSTHAN",
  "CHHATRAPATI SHAHUJI MAHARAJ  GOVERNMENT POLYTECHNIC UTRAULA  BALRAMPUR",
  "SIGNA COLLEGE OF PHARMACY",
  "mitit",
  "ANAND INSTITIUTE OF PARAMEDICAL SCIENCES",
  "BRIJBHUSHAN SINGH PHARMACY COLLEGE KISHNI ROAD",
  "BRAJBHUSHAN SINGH COLLEGE OF PHARMACY, MAINPURI",
  "B D M INTERNATIONAL PHARMACY SCHOOL",
  "BADULI PHARMACY COLLEGE",
  "PASHUPATINATH SMARAK MAHAVIDYALAY BTC, SHERPUR KALAN, GHAZIPUR",
  "BAJRANG COLLEGE OF EDUCATION PHARMACY COLLEGE, AZAMGARH",
  "KANCHAN DEGREE COLLEGE",
  "INSTITUTE OF PROFESSIONAL STUDIES GHAZIABAD",
  "PREM RAGHU INSTITUTE OF PHARMACY",
  "DAYAWATI COLLEGE OF EDUCATION",
  "FEROZE GANDHI POLYTECHNIC, RAE BARELI",
  "GOVERNMENT GIRLS POLYTECHNIC MEZA",
  "GAJRAULA COLLEGE OF PHARMACY AND RESEARCH CENTRE",
  "Maharshi Moolchand Yadav Nursing And Paramedical College Nadauli Kerakat Jaunpur",
  "GOVERNMENT GIRLS POLYTECHNIC LUCKNOW",
  "GOVERNMENT GIRLS POLYTECHNIC GORAKHPUR",
  "GOVERNMENT GIRLS POLYTECHNIC BAREILLY",
  "LASANTE AYURVEDIC COLLEGE",
  "LAVANYA AYURVEDIC COLLEGE OF NURSING DEWA ROAD LUCKNOW",
  "ARJUN YADAV GIRLS COLLEGE OF PHARMACY, GHAZIPUR",
  "B S COLLEGE OF PHARMACY",
  "BBS COLLEGE OF PHARMACY AND POLYTECHNIC PRAYAGRAJ",
  "APS COLLEGE OF PHARMACY CHAKARASENPUR AMBEDKAR NAGAR",
  "J P PHARMACY COLLEGE",
  "SARVODHYA ADARSH PHARMACY COLLEGE",
  "NAVNEET COLLEGE",
  "J S DIPLOMA PHARMACY COLLEGE",
  "RAMNARAIN  RAMDULARI COLLEGE OF PHARMACY, GHAZIPUR",
  "GOVERNMENT GIRLS POLYTECHNIC BALIA",
  "SUKHAMAY TRAINING INSTITUTE PLOT NO ONE SEVEN EIGHT FIVE GRAM PO BEHARA JAUNPUR",
  "SONIA MAHILA MAHAVIDYALAYA TILA TALI BELWA BAZAR DEORIA",
  "SAYED AAYSHA ZAHEER MEMORIAL INSTITUTE",
  "GOVERNMENT GIRLS POLYTECHNIC AMETHI",
  "MAHARSHI MOOLCHAND YADAV MAHILA BTC COLLEGE, NADAULI, KERAKAT, JAUNPUR",
  "LALA RADHEY SHYAM COLLEGE OF EDUCATION",
  "JASWANT SINGH BHADAURIA TEACHERS TRAINING COLLEGE",
  "SHEKHAR COLLEGE OF PHARMACY AND NURSING, LUCKNOW",
  "VARDAN AYURVEDIC PARAMEDICAL INSTITUTE  CHAUDAH MEEL DALMAU RAEBARELI",
  "S S INSTITUTE OF PARAMEDICALS HARDOI",
  "R K HOMEOPATHIC PHARMACY, KASHIPUR SURAI SATHIAON AZAMGARH",
  "BABA BALAK DAS GIRLS DEGREE COLLEGE OF SCIENCE AND MANAGEMENT GOPALPUR BARAGAON MOTIGARPUR SULTANPUR",
  "A S B D COLLEGE OF PHARMACY",
  "S D D COLLEGE OF PHARMACY",
  "J N T INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES HARIBANDHANPUR NAIGANJ",
  "SAVITA DEVI INSTITUTE OF PHARMACY",
  "VIKAS INSTITUTE OF HOMOEOPATHIC PHARMACY COLLEGE AKBARPUR AMBEDKAR NAGAR",
  "SRI SWAMI JI COLLEGE OF PHARMACY AND HOSPITAL",
  "SAGAR PHARMACY COLLEGE OF  HOMEOPATHIC",
  "RBS COLLEGE MADAURA",
  "HIMALAYAN INSTITUTE OF AYURVEDA",
  "GOVERNMENT GIRLS POLYTECHNIC ALLAHABAD",
  "JIVIKA INSTITUTE OF PHARMACY",
  "GOVERMENT POLYTECHNIC KURSI  FATEHPUR BARABANKI",
  "GLOBE EDUCATIONAL INSTITUTE AND MANAGEMENT",
  "C C L COLLEGE OF PHARMACY ADDA KARAB",
  "AZMAL KHAN TIBBIYA COLLEGE MUZAFFARNAGER",
  " URMILA DEVI COLLEGE KRIPAL SINGH NAGAR BARASAMASPUR JALESAR ETAH",
  "R D Pandey College of Teacher Education",
  "GCRG COLLEGE OF POLYTECHNIC",
  "GANDHI POLYTECHNIC MUZAFFARNAGAR",
  "SRI DURGA JI NURSING SCHOOL, SEHADA MAHARAJPUR, KANDHARAPUR AZAMGARH",
  "KINETIC INSTITUTE AND HOSPITAL, DEPARTMENT OF PARAMEDICAL SCIENCE",
  "RDJS COLLEGE",
  "IDEAL ARIKET COLLEGE OF PHARMACY AND PARAMEDICAL SCIENCES, BARABANKI",
  "WISDOM TEACHER TRAINING SCHOOL",
  "VIDYA INSTITUTE OF TRAINING AND EDUCATION",
  "URS SHIKSHAN PRASHIKSHAN SANSTHAN",
  "SMT MALTI DEVI MAHILA SHIKSHA MAHAVIDYALAYA",
  "SHRI AIVAR SINGH DESHWAR COLLEGE OF EDUCATION",
  "SDS MAHAVIDYALAYA KOSI KHURD MATHURA",
  "LUDURA DEVI SHIKSHAN PRASHIKSHAN SANSTHAN BAIRIPUR SIRKONI JAUNPUR",
  "ISH PRAKSHIKSHAN SANSTHAN AZAMGARH",
  "HAFIZ ABDUL MANNAN ANSARI SHIKSHA EVAM PRASHIKSHAN SANSTHAN",
  "AJMAL KHAN TIBBIYA COLLEGE",
  "BHANMATI SMARAK COLLEGE OF EDUCATION",
  "VAIDYA YAGYA DUTT SHARMA AYURVED MAHAVIDYALAYA DR MAHESH DUTT SHARMA PARAMEDICAL COLLEGE",
  "SCHOOL OF NURSING INSTITUTE OF PARAMEDICAL",
  "H D NURSING AND PARAMEDICAL INSTITUTE SAREHUA KALA CHANDAULI",
  "DAYARAM VERMA COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "SRI RADHAKRISHNA MAHAVIDYALAYA",
  "S P S COLLEGE OF PROFESSIONAL STUDIES",
  "SANTOSH COLLEGE OF EDUCATION",
  "R N SHIKSHAK PRASHIKSHAN KENDRA PLOT N TWO NINE ONE BADAUNA FATEHGANJ JAUNPUR",
  "RAM BAHADUR SINGH SIKSHAN SANSTHAN PURAIN KHAGA FATEHPUR",
  "RAJPATI SMARAK SHIKSHAN PRASHIKSHAN MAHAVIDYALAY ANJANA SADAR FAIZABAD",
  "ORDIAL INSTITUTE OF MANAGEMENT",
  "MAHENDRA JANKI SHIKSHAN EVAM PRASHIKSHAN SANSTHAN",
  "KAMAKHYA MANAV SAMITI",
  "J B MAHAJAN MAHILA PG",
  "HARISHCHANDRA SHIKSHAN PRASHIKSHAN MAHAVIDYALAY, SARAULI, AYODHYA",
  "CHANDRAWATI DEVI COLLEGE OF EDUCATION AMWA HIRAMAN DUBEY MEHAHARHANGPUR DEORIA",
  "S G S COLLEGE OF PHARMACY",
  "JSB COLLEGE OF PHARMACY",
  "SHEKHAR PARAMEDICAL AND NURSING COLLEGE",
  "LAKSHYA MEDICAL COLLEGE BAGWARA SEOHARA",
  "SWAMI KALYAN DEV PHARMACY COLLEGE",
  "SHRI KRISHNA COLLEGE OF PHARMACY, JALALPUR, ZAMANIA, GHAZIPUR",
  "MUSAFIR BAL GOPAL PHARMACY COLLEGE SONBHADRA",
  "MAHARANA PRATAP PHARMACY COLLEGE",
  "JASWANT SINGH BHADAURIA COLLEGE OF PHARMACY",
  "H I T M COLLEGE OF PHARMACY",
  "ARYAN COLLEGE OF PHARMACY",
  "SWAMI SHARAN BTC PRASHIKSHAN VIDYALAYA",
  "SWAMI OMANAND SARASVATI SPECIAL EDUCATION AND TRAINING INSTITUTE",
  "SUDAMA DEVI BTC PRASHIKSHAN VIDYALAYA",
  "MAA VINDHYAVASINI BTC COLLEGE TISUHI, MARIHAN, MIRZAPUR",
  "BD JAISWAL INSTITUTE, AMBEDKARNAGAR",
  "BAIJNATH RAMNARESH NURSING AND PARAMEDICAL COLLEGE KAZIPUR CHIRAIYAKOT AZAMGARH",
  "AZAD LUCKNOW POLYTECHNIC",
  "V S COLLEGE OF PHARMACY",
  "Venkateshwara Institute of Pharmacy",
  "VGI College of Pharmacy",
  "KAMLA INSTITUTE OF PARAMEDICAL SCIENCES",
  "SETH JAIPRAKASH MUKANDLAL  POLYTECHNIC",
  "SAGAR COLLEGE OF AYURVEDA",
  "RAHMAN COLLEGE OF PHARMACY",
  "OM COLLEGE OF PHARMACY, PRAYAGRAJ",
  "SHRI LALARAM SHARMA COLLEGE OF PHARMACY JARARA KHAIR ALIGARH",
  "K V Collage of Education",
  "DHANIRAM YADAV AYURVEDIK DIPLOMA PHARMESIST COLLEGE BEERBHANPUR JAUNPUR",
  "DR KNS SCHOOL OF NURSING LUCKNOW",
  "SHRI KRISHNA COLLEGE OF NURSING EDUCATION, JOHNMANI DAULA BAGHPAT",
  "SHRI VINAYAK PARAMEDICAL COLLEGE, FIROZABAD",
  "R H M COLLEGE OF HIGHER EDUCATION",
  "PARAS SINGH COLLEGE OF PHARMACY",
  "INDRA PRATAP BTC COLLEGE KASYA KALAN SONBHADRA",
  "A R T S COLLEGE OF PHARMACY,AZAMGARH",
  "ACN INSTITUTE OF TEACHING EDUCATION",
  "SHRI AVADHRAJ SINGH COLLEGE OF PHARMACY VISUNPUR BAIRIYA GONDA",
  "RAKSHPAL BAHADUR PHARMACY INSTITUTE",
  "MOHD SHAHBAAN MEMORIAL COLLEGE OF PHARMACY",
  "SHRI VASHISHTH COLLEGE OF PHARMACY, GHAZIPUR",
  "NIIT COLLEGE OF PHARMACY",
  "MAHAMAYA POLYTECHNIC OF INFORMATION TECHNOLOGY",
  "DR R P S NEHRA INSTITUTE OF EDUCATION",
  "R P MISHRA COLLEGE OF PHARMACY",
  "SURYANATH BTC PRASHIKSHAN VIDYALAYA",
  "S N MAHAVIDYALAYA",
  "SHRI KHADESHWARI SWAMI SHIKSHAN SANSTHAN",
  "RAM AWADH SINGH SIKSHAN EVAN PRASHIKSHAN SANSTHAN PIPARIDIH MAU",
  "RAM AWADH SINGH MAHAVIDHYALAY PIPARIDIH MAU",
  "MAA SANTOSHI INTER COLLEGE RATIBHANPUR SIKANDRA RAO HATHRAS",
  "KP BTC TRAINING COLLEGE",
  "HINDUSTAN INSTITUTE OF TECHNOLOGY AND MANAGEMENT TEHRA",
  "G M MAHAVIDYALAYA",
  "D A V COLLEGE ANIL NAGAR PATARAHI JAUNPUR",
  "BASANT SHIKSHA SAMITI",
  "BABU SHIVPUJAN SINGH URF CHHOTKU SINGH SIKSHAN EVAM PRASIKSHAN SANSTHAN PN ONE SEVEN EIGHT SIX MADHI JAUNPUR",
  "ACHARYA BALDEV SANSTHAN KOPA PATRAHI JAUNPUR",
  "A B R L B T C TRAINING COLLEGE GHITHINI SANT KABIR NAGAR",
  "FOURESS  HOMOEOPATHIC PHARMACY COLLEGE",
  "SHRI NATH  ALAKNANDA MAHAVIDYLAYA",
  "SHRI BHAGWAN NURSING AND PARAMEDICAL COLLEGE",
  "SANT RAMNARAYAN NURSING AND PARAMEDICAL COLLEGE AND HOSPITAL, BARUIN,  ZAMANIA, GHAZIPUR",
  "RAJKISHOR SINGH NURSING AND PARAMEDICAL COLLEGE AND HOSPITAL, BARUIN, ZAMANIA, GHAZIPUR",
  "R K PANDEY PHARMACY COLLEGE",
  "PREM SINGH COLLEGE OF PHARMACY",
  "MD COLLEGE OF HIGHER STUDIES",
  "DEEPAK INSTITUTE OF PHARMACY HARDOI",
  "Udaseencharya Jagatguru Shreechand Ji Mahavidyalaya PLAT N TWENTY PIKHINI GAURABADSHAHPUR JAUNPUR",
  "SWAMI VIVEKANAND MEMORIAL ACADEMY BALIPUR FIROZABAD",
  "SHYAMKARAN SMARAK MAHAVIDYALAYA, SAIFPUR BIJNOUR AZAMGARH",
  "Niji Sansthan S K G N DEGREE COLLEGE",
  "SHRI GURUDEV SHIKSHA SAMITI SHIKSHAN PRASHIKSHAN SANSTHAN CHITKON JAUNPUR",
  "SHRI RAJARAM MEMORIAL COLLEGE OF NURSING AND PARAMEDICIAL",
  "KARUNASHRAY SCHOOL OF NURSING AND PARAMEDICAL INSTITUTE",
  "FIROZABAD SCHOOL OF NURSING FIROZABAD",
  "FATIMA INSTITUTE OF MEDICAL SCIENCES GORAKHPUR",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING AND TECHNOLOGY",
  "SHRI  BABA SADHAV RAM SHIKSHA VIKASH SANSTHAN PLOT NUMBER FOUR, BARSARA KHALSA, NIZAMABAD, AZAMGARH",
  "SHREE RAM SINGH MAHAVIDYALAYA TERHA PANDRI MIRZAPUR",
  "RAMPHER SINGH TEACHING AND TRAINING INSTITUTE",
  "RAJDEVI RAM PRASAD SINGH MAHAVIDYALAYA",
  "MAINA DEVI SHIKSHAN PRASHIKSHAN SANSTHAN AZAMGARH",
  "HIRA SINGH COLLEGE OF EDUCATION AWAJAPUR CHANDAULI",
  "GRAMARSHI PANDIT RAM KUMAR PANDEY SMARAK SHIKSHAK PRASHIKSHAN  SANSTHAN, VILLEGE  SAYA, PO  SAYA, TAHSIL BHEETI, CITY  AMBEDKAR NAGAR, UP,",
  "DIRGAJ PRASAD SINGH SHIKSHAN PRASHIKSHAN SANSTHAN",
  "CH OMPRAKASH COLLEGE OF EDUCATION",
  "GOVERNMENT POLYTECHNIC THAKURDWARA",
  "I T M COLLEGE OF PHARMACY ALIGARH",
  "Karmalal Bihari Digree College",
  "BHAGWAN SINGH BTC PRASHIKSHAN SANSTHAN GARBAR DUBAR KALAN LALGANJ MIRZAPUR",
  "A K SINGH COLLEGE NAGLA BARI ETAH",
  "Smt Satyawati Devi College Of Pharmacy",
  "ADARSH KRISHAN COLLEGE OF EDUCATION BICHHWAN ROAD MAINPURI",
  "MAHAMAYA INSTITUTE OF INFORMATION TECHNOLOGY SHAMLI",
  "SHRI JAY SINGH CHOTE SAHAB COLLEGE OF PHARMACY",
  "LILADHAR G N M COLLEGE PAL CHANDRAHAN",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING PRATAPGARH",
  "SHRI JAY SINGH PHARMACY COLLEGE",
  "M D COLLEGE OF PHARMACY, CHANDAULI",
  "DR KANCHAN SINGH INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "Government Polytechnic Bighapur Unnao",
  "V D M COLLEGE OF MANAGEMENT AND PHARMCY",
  "CENTRAL WOMENS COLLEGE OF EDUCATION",
  "MAA DHANAWATI COLLEGE OF PHARMACY, DHIRAJIPUR, AZAMGARH",
  "S R N COLLEGE OF PHARMACY, JETHWAR, AKUPUR, BHIMPUR, RASRA, BALLIA",
  "R S S PHARMACY COLLEGE, JAHANAGANJ, AZAMGARH",
  "R B S S COLLEGE",
  "PASHUPATI NATH SMARAK INSTITUTE OF PHARMACY, GHAZIPUR",
  "MAA MOTIRANI DEVI PHARMACY COLLEGE VILLEGE PADASARA NADAULI TAJPUR SIKANDARPUR GARVI DISTRICT BALLIA UP",
  "HAZARILAL COLLEGE OF PHARMACY",
  "SHRI RAJ RAJESHWARI SHIKSHAN  PRASHIKSHAN SANSTHAN  SUNGULPUR BIBIPUR JAUNPUR",
  "SHRI HARIHAR JI PUBLIC SCHOOL, FARIHA NIZAMABAD AZAMGARH",
  "INDRAWATI MEMORIAL GIRLS COLLEGE SAUNA GHAZIPUR",
  "ACMT COLLEGE",
  "MA KASTURBA SCHOOL OF NURSING AYURVED",
  "MAJOR SD SINGH AYURVEDIC NURSING AND PHARMACY COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING ALLAHABAD",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING MIRZAPUR",
  "SHANKAR INSTITUTE OF EDUCATION",
  "RANJEET SINGH MEMORIAL INSTITUTE OF TECHNOLOGY",
  "RAM BARAN SINGH SIKSHAN SANSTHAN",
  "RAJBIR SINGH SIKARWAR BTC COLLEGE",
  "SHRI AMAR BAHADUR SINGH INSTITUTE OF PHARMACY",
  "MOOLCHAND MAHAVIDYALAYA, HOLIPUR, GHAZIPUR",
  "LATE RAM PIYARI PANDEY ELEMENTRY TEACHER TRAINING INSTITUTE",
  "HARISCHANDRA CHAUDHARI MAHAVIDYALAY",
  "D N V COLLEGE SADABAD ROAD JATORA MATHURA",
  "BUDDHU RAM SATYAVATI DEVI SHIKSHAK PRASHIKSHANSANSTHAN KUDDUPUR JAUNPUR",
  "BM COLLEGE OF EDUCATION AMBEDKAR NAGAR",
  "ADARSH SHIKSHAN PRASHIKSHAN COLLEGE ROBERTSGANJ SONBHADRA",
  "PANDIT BANSRAJ SATYA GOVIND COLLEGE PHARMACY",
  "OM MAA AADI SHAKTI COLLEGE OF PHARMACY DEWA DULLAHAPUR GHAZIPUR",
  "MATRI GANGAJALI PHARMACY COLLEGE",
  "J K INSTITUTE OF MEDICAL SCIENCE",
  "MAA SHANTI DEVI COLLEGE OF PHARAMACY",
  "LALJI CHIKITSA VIGYAN SANSTHAN EVAM AYURVED PHARMACY COLLEGE",
  "MAA ISRAJI DEVI MAHAVIDHYALAY VILLAGE RAIYA JAUNPUR",
  "shakeel college of nursing",
  "DR SHIV SAGAR LAL COLLEGE OF PHARMACY,  UNNAO",
  "KAMLA DUBEY COLLEGE OF TEACHERS EDUCATION PLOT NUMBER ONE SEVEN FIVE SARSARA MARIYAHU JAUNPUR",
  "HARISH CHAND COLLEGE OF PHARMACY, KAWLA JAKHANIYA",
  "KARMYOGI PARAMEDICAL INSTITUTE, RAIBARELI",
  "SMT SHAILA DEVI B T C TRAINING COLLEGE SANT KABIR NAGAR",
  "SMT SATYAWATI DEVI INSTITUTE OF TEACHING AND TRAINING",
  "S J J S S L O C C BALIKA DEGREE COLLEGE KHURJA BULANDSHAHR",
  "SHRI RAM CHANDRA SINGH SHIKSHAN PRASHIKSHAN SANSTHAN LOHTI SARIYA RUDAULI AYODHYA",
  "Bhalchandra Insitiute of Paramedical Science",
  "SHANTI COLLEGE OF PHARMACY",
  "SHAILESH COLLEGE OF PHARMACY, GHAZIPUR",
  "MIIT COLLEGE OF PHARMACY",
  "MCS COLLEGE OF SCIENCE AND TECHNOLOGY REWAN",
  "MBL COLLEGE OF PHARMACY",
  "KINGS EDEN COLLEGE OF PHARMACY SADARPUR MOHAMMADABAD GOHNA MAU",
  "KAMESHWAR UPADHYAY MEMORIAL COLLEGE OF PHARMACY",
  "Hakim Haider Ali Paramedical College Ghazipur",
  "SHIV SHAKTI COLLEGE OF PHARMACY ALIGARH ANOOPSHAHAR ROAD TEJPUR JAWAN ALIGARH",
  "CHANDRADEV MEMORIAL POLYTECHNIC COLLEGE",
  "ATAL PHARMACY COLLEGE",
  "RAMA HOSPITAL AND RESEARCH CENTRE",
  "Maa Gayatri Institute of Pharmacy, Chandos, Aligarh",
  "A B SINGH COLLEGE OF PHARMACY",
  "Rajat Technical College of Education",
  "TABISH PHARMACY SCHOOL",
  "SUMITRA COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC BACHHRAWAN",
  "R R SHIKSHA SANSTHAN",
  "AYUSH AYURVED PARA MEDICAL COLLEGE",
  "S J S PARAMEDICAL COLLEGE SURJANNAGAR THAKURDWARA MORADABAD",
  "BALRAM SINGH INSTITUTE OF SCIENCE AND TECHNOLGY",
  "C D D NURSING AND PHARMACY COLLEGE, PHOOLPUR, NAWABAD, BUDHANPUR, GHAZIPUR",
  "SUKHDEV NURSING AND PARAMEDICAL COLLEGE AND HOSPITAL, PHOOLPUR, NAWABAD, BUDHANPUR, GHAZIPUR",
  "JAI MAA VAISHNO AYURVEDIC PARAMEDICAL INSTITUTE BHWALPUR KILA PRATAPGARH",
  "V M Y College of Pharmacy",
  "GYAN PARA MEDICAL AND NURSING COLLEGE KATRA ROAD PRATAPGARH",
  "YASAR MIRZA COLLEGE OF EDUCATON AND NURSING AMROHA",
  "SRI RAM NARESH CHAUDHARY PRASHIKSHN SANSTHAN RAMWAPUR SARKARI SANT KABIR NAGAR UP",
  "Let Pooran Ramprakash Dixit College Of Pharmacy",
  "SOCIETY FOR INSTITUTE OF PSYCHOLOGICAL RESEARCH AND HEALTH",
  "Maa Durga Girls BTC College",
  "Aisha Nursing College",
  "CHANDRA KAMAL PHARMACY MAHAVIDYALAYA",
  "RML COLLEGE OF EDUCATION",
  "SRI MOHAN DHANSIRA MAHAVIDAYALY JUNGAL BELAHAR SANT KABIR NAGAR UP",
  "SHRI KOMAL SAHU SMARAK SHIKSHAN EVAM PRASHIKSHAN SANSTHAN, POONAPAR JIYANPUR,  JAMIN HARKHORI  DHANCHULA, SAGARI AZAMGARH",
  "SHRI K N SINGH MAHILA MAHAVIDYALAYA, BAHARAMPUR, JIYANPUR, AZAMGARH",
  "R P BTC COLLEGE DHARSADA GHORAWAL SONBHADRA",
  "RAMKARAN SHIKSHAN PRASHIKSHAN SANSTHAN",
  "RAJA TRILOCHAN PRASAD PRATHMIK PRASHIKSHAN KENDRA",
  "ADHARSHILA COLLEGE OF PHARMACY",
  "Radhika Institute Of Teachers Training",
  "JAN BHARTI COLLEGE OF PHARMACY, GHAZIPUR",
  "M D COLLEGE BASUCHAK GHAZIPUR",
  "S.M.T. DEGREE COLLEGE",
  "RAJSHREE INSTITUTE OF PARAMEDICAL SCIENCES",
  "CHHATRAPATI SHIVAJI COLLEGE OF PHARMACY, KANPUR DEHAT",
  "CHANDRIKA SINGH SMARAK EDUCATION COLLEGE",
  "BABA JAGDEV DAS COLLEGE OF PHARMACY, MAU",
  "SRI NATH BABA JANGALI BABA MAHAVIDYALAYA SHIKSHAN SANSTHAN JAM BALLIA",
  "SHAGUN COLLEGE OF HIGHER EDUCATION BHAUWAPAR",
  "INDRA MOHAN CHAUHAN MEMORIAL POLYTECHNIC",
  "RAMDEV SHIKSHAN PRASHIKSHAN KENDRA RANIPUR RAJMO MOHAMMADPUR AZAMGARH",
  "MANOHAR LAL INSTITUTE OF EDUCATION  TRAINING KATRI PIPER KHERA UNNAO",
  "SRI SAI INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH",
  "INSTITUTE OF MANAGEMENT TECHNOLOGY CENTRE FOR DISTANCE LEARNING GHAZIABAD",
  "GNIOT INSTITUTE OF MANAGEMENT STUDIES",
  "S D R COLLEGE OF PHARMACY CHANDAULI",
  "R N SINGH SAMMOPUR PHARMACY COLLEGE, TAMMARPUR THEKMA AZAMAGRH",
  "FARIDA IQBAL SCHOOL OF NURSING LUCKNOW",
  "NANDINI NAGAR MAHAVIDYALAYA COLLEGE OF PHARMACY",
  "M S COLLEGE OF PHARMACY",
  "MOTHER TERESA COLLEGE OF PHARMACY AND NURSING",
  "MAA KALINDI SINGH COLLEGE OF PHARMACY, GHAZIPUR",
  "J B SINGH COLLEGE OF PHARMACY, MAINPURI",
  "DR S S COLLEGE OF PHARMACY JAUNPUR",
  "ITS SCHOOL OF MANAGEMENT",
  "DEV COLLEGE PHARMACY HASANPUR NYAYIPUR SORAWN PRAYAGRAJ",
  "CHANDRAKALI COLLEGE OF AYURVEDIC NURSING AND PHARMACY, MUBARAKPUR, PHULPUR, PRAYAGRAJ,UP",
  "SCHOOL FOR AIRCRAFT MAINTENANCE ENGINEERING",
  "B R D COLLEGE OF PHARMACY, DEORIA",
  "ACHARYA AYURVEDIC PHARMACY AND GNM COLLEGE",
  "KENDRIYA HINDI SANSTHAN MANDAL",
  "SAINIK SCHOOL OF NURSING",
  "S R DEGREE COLLEGE",
  "Dabble College of Teachers Education",
  "SUSHMA AYURVEDIC SCHOOL MEHNAJPUR, NAVODAY NAGAR, JIYANPUR, AZAMGARH",
  "SHRI SHAKTIMAYI AYURVEDIC PHARMACY COLLEGE KHARAGPUR AZAMGARH",
  "RAM KISHOR EDUCATIONAL COLLEGE AZAMGARH",
  "PRIDE COLLEGE OF PHARMACY",
  "NAVODAYA COLLEGE OF PHARMACY AZAMGARH",
  "S B S COLLEGE OF PHARMACY, HAIDARPUR, HARGAON, SITAPUR",
  "KAULESHWAR SURYAMATI AYURVEDIC PHARMACY COLLEGE MOHANPUR GIRANT AMBEDKAR NAGAR",
  "GOVERNMENT POLYTECHNIC CHAMRAUA",
  "ASM POLYTECHNIC",
  "INDIRA GANDHI COLLEGE OF PHARMACY AND NURSING COLLEGE",
  "HEERA SINGH YADAV COLLEGE OF PHARMACY, GORARI, VIKRAMPUR, SAIDPUR, GHAZIPUR",
  "FAUZDAR COLLEGE OF PHARMACY, GHAZIPUR",
  "DDS COLLEGE OF PHARMACY",
  "GL INSTITUTE OF PHARMACY, AGRA",
  "SANT RAMNARAYAN RAJKISHOR SHANKAR TEACHER TRAINING SCHOOL",
  "SHRI DURGA JI AYURVEDIC INSTITUTE, SEHADA, MAHARAJPUR, AZAMAGRH",
  "VIMALA SHANKAR MAHILA MAHAVIDYALAY AKAVASPATTI BHITARI GHAZIPUR",
  "LATE RAMVILASH SINGH SHIKSHAN SANSTHAN, SIAKNDERPUR, TEHSIL -CHAKIA",
  "LATE RAMVILASH SINGH EDUCATIONAL TRUST",
  "ERA'S LUCKNOW MED COLLEGE. & HOSPITAL LUCKNOW",
  "EMERALD-9 INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "SHUBHASHEESH SHIKSHA EVAM VIKAS SEWA SANSTHAN",
  "CERT COLLEGE OF EDUCATION",
  "DR. PRATAP SINGH MALIK COLLEGE OF NURSING & HOSPITAL, RAMPUR",
  "AAKANKSHA INSTITUTE OF TEACHER EDUCATION",
  "SMT Indira Gandhi Mahavidyalaya",
  "SHRI R P PORWAL INSTITUTE OF EDUCATION SHAHJAHANPUR KANPUR DEHAT",
  "DR. VIJAY COLLEGE OF NURSING AND MEDICAL BHANDHAKALA KAITHI VARANASI",
  "Raj Kishor Singh Teacher Training School",
  "L.R.S. College",
  "SHRI MARUBAI DEVI COLLEGE OF PHARMACY, AGRA",
  "DAYA AWADH COLLEGE OF PHARMACY , AYODHYA",
  "VIMLA INSTITUTE OF AYURVEDIC NURSING AND PHARMACY DEVKALI AYODHYA",
  "DURGA NURSING AND PARAMEDICAL RESEARCH INSTITUTE JAUNPUR",
  "HANUMAT INSTITUTE OF NURSING AND PHARMACY JAPTI WAZEERGANJ FAIZABAD AYODHYA",
  "S R HOMOEOPATHIC PHARMACY BELA PARSA AMBEDKAR NAGAR",
  "S S BAPU INSTITUTE OF POLYTECHNIC",
  "BANARAS INSTITUTE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC MOHAMMADI KHERI",
  "SARDAR VALLABH BHAI PATEL COLLEGE OF POLYTECHNIC",
  "DR O P CHAUDHARY SCHOOL OF NURSING LUCKNOW",
  "NANOTECH INSTITUTE OF PHARMACY",
  "SHUBHAM AYURVEDIC PHARMACY COLLEGE RAJJUPUR DARWAN KHEMAPUR AMBEDKAR NAGAR UP",
  "DS COLLEGE OF PHARMACY , AMBEDKARNAGAR",
  "DR R N RAI COLLEGE OF NURSING AND PHARMACY",
  "BABU RAMANAND SINGH COLLEGE OF PHARMACY, AZAMGARH",
  "BHAGWAN ADARSH AYURVEDIC  PHARMACY EVAM NARSING COLLEGE, NAREHTHA CHAKRAPANIPUR AZAMAGRH",
  "KESHLATA HOSPITAL BAREILLY",
  "URMIL ICHCHHA COLLEGE OF PHARMACY, AYODHYA",
  "SP COLLEGE OF EDUCATION",
  "SMT SAVITA CHATURVEDI MAHILA COLLEGE OF EDUCATION BHITHA VISHWANATHPUR SANT KABIR NAGAR",
  "SHRI VISHNU BHAGWAM MAHAVIDYALAYA",
  "JEEVAK HOSPITAL AND RESEARCH CENTER JEEVAK PARAMEDICAL SANSTHAN KAMLAPUR EKAUNI CHANDAULI",
  "GOVERNMENT PHYSICAL TRAINING COLLEGE RAMPUR",
  "ANAND COLLEGE OF EDUCATION, ANAND NAGAR, BASUCHAK, GHAZIPUR",
  "JEEVAK HOSPITAL AND NURSING COLLEGE KAMLAPUR EKAUNI CHANDAULI",
  "MAA VAISHNAVI SHIKSHA SAMITI SANSKRIT MAHAVIDYALAYA, KARANJAKALA, JAUNPUR",
  "DREAMS COLLEGE OF POLYTECHNIC",
  "VIDHYARTHI INSTITUTE OF HOMOEO PHARMACY",
  "MEERUT COLLEGE OF PHARMACY",
  "SHIV NARAYAN COLLEGE OF PHARMACY ",
  "Gayatri Smarak Institute of Education",
  "SRI SAHDEV PAUDHARIYA AMBEDKAR SEWA SANSTHAN MANDA, RASRA , BALLIA UP",
  "SHRI RAM NATH SHIKSHA PRASHIKSHAN SANSTHAN",
  "SHRI DHAR SINGH COLLEGE OF EDUCATION",
  "F I PHARMACY COLLEGE CAMPUS KHAND DEV BANTHRA KANPUR ROAD LUCKNOW",
  "Maa Sharda Mahila Mahavidyalay",
  "Nirmal Moolchani Educational Shiksha Avom Prashikshan Sansthan",
  "Umashankar Shashtri Mahavidyalaya",
  "S R Degree College",
  "ANKERITE PARAMEDICAL INSTITUTE LUCKNOW",
  "PARMESHWAR PRASAD MEWALAL PHARMACY COLLEGE",
  "MUSAPHIR BAL GOPAL PRASHIKSHAN SANSTHAN RAMGARH SONBHADRA",
  "M.R. COLLEGE BALAJI MANDIR ROAD, SHIKOHABAD, FIROZABAD",
  "MIET COLLEGE OF EDUCATION, VILL-P.O. DABATHUWA, TEHSIL SARDHANA, MEERUT",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING JHANSI",
  "MUNNILAL COLLEGE OF EDUCATION",
  "SANT SRI ASHARAMJI COLLEGE OF EDUCATION",
  "CHAUDHARY MALTI DEVI COLLEGE OF EDUCATION MANIKPUR SADABAD HATHRAS",
  "HAVARD INSTITUTE OF MANAGEMENT & TECHNOLOGY GAUTAM BUDH NAGAR",
  "ANURAGI DEVI PHARMACY COLLEGE ",
  "KABUTARI DEVI RAJESHWAR TRIPATHI SMARAK SHIKSHAN EWAM PRASHIKSHAN MAHAVIDALAYA",
  "GOPAL JI MAHAVIDYALYA",
  "HARIHAR SINGH MEMORIAL ACADEMY, VILL-TISAURA, PO-CHOLAPUR, VARANASI.",
  "SUDHAKAR SINGH SHIKSHAK PRASHIKSHAN SANSTHAN PILKHINI JAUNPUR",
  "A K G Educational Institute",
  "MSR Vidyapeeth",
  "MURALIDHAR RAM NARAIN EDUCATION",
  "SHREE JAMUNA RAM DEGREE COLLEGE",
  "PANDIT SIYARAM SHARMA COLLEGE OF EDUCATION, BIROULI, BULANDSHAHR",
  "K.P.S COLLEGE DISHTAUIL, FIROZABAD",
  "MOTHERHOOD COLLEGE OF EDUCATION VILL-BADRUNDDIN NAGAR, P.O.-NANU, TEHSIL SARDHANA, MEERUT",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING AZAMGARH",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, GAUTAM BUDH NAGAR",
  "LODI KISHAN B T C PRASHIKSHAN KENDRA, MAHADEVPUR SENPUR, AZAMGARH",
  "K N INSTITUTE OF HIGHER EDUCATION BHIMPURA NO ONE BALLIA",
  "HARISHCHANDRA MAHILA SHIKSHAN SANSTHAN",
  "DIET KAUSHAMBI",
  "C S S D COLLEGE OF EDUCATION , NOROJPUR GURJAR",
  "CITY ACADEMY",
  "DR RAJENDRA PRASAD COLLEGE OF PHARMACY , LUCKNOW",
  "ADRS COLLEGE OF PHARMACY,  ALIGARH",
  "JAY TECHNICAL INSTITUTE ALLAUDDINPUR KORAUTA VARANASI",
  "SHRI SANKAT MOCHAN MAHAVIDYALAYA BAHARAMPUR CHAUBEYPUR VARANASI",
  "SHIVALIK AYURVEDIC PARAMEDICAL COLLEGE",
  "MOHAMMAD ALI NAJIR FATIMA PHARMACY COLLEGE ,  HARDOI",
  "JAI CHAMAN COLLEGE OF PHARMACY",
  "BHOO DEVI MATA COLLEGE OF PHARMACY",
  "UJJAWAL AYURVEDIC PARAMEDICAL COLLEGE",
  "BABA RAMDAL SURAJDEV POLYTECHNIC COLLEGE",
  "B D M COLLEGEOF PHARMACY",
  "J P INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "LORD KRISHNA INSTITUTE OF PHARMACY ATRAULI ALIGARH",
  "MAA KUSUM COLLEGE OF PHARMACY",
  "SWATI AYURVEDIC UPCHARIKA PRASHIKSHAN KENDRA BUDHANA SHAHPUR ROAD TAWLI MUZAFFARNAGAR",
  "JP VERMA COLLEGE OF PHARMACY",
  "RAMPAL SINGH SMARAK COLLEGE OF PHARMACY",
  "AHM COLLEGE OF PHARMACY",
  "J D COLLEGE OF PHARMACY JD COP NOORPUR",
  "R P S COLLEGE OF PHARMACY VILLAGE UDAYCHANDPUR KERAKAT JAUNPUR",
  "VIMALA SHIKSHAN SANSTHAN",
  "INSTITUTE OF REHABILITATION",
  "VIMALA INSTITUTE OF TEACHERS TRAINING",
  "RAJSHREE TEACHERS TRAINING INSTITUTE BAREILLY",
  "BAIJNATH RAMNARESH COLLEGE OF TEHNOLOGY",
  "ST JOSEPHS PARAMEDICAL INSTITUTE",
  "SWAMI ATAMANAND II COLLEGE OF EDUCATION RASULPUR JUGDEV BARAULI MAURBOJH GHOSI MAU",
  "MUNIM SINGH BHARTIYA EDUCATION CENTER ATARRA ROAD BABERU BANDA",
  "SINGARI DEVI COLLEGE OF EDUCATION",
  "DR. DASHRATH CHOWDHARY NATIONAL POLYTECHNIC BANSI SIDDHARTH NAGAR",
  "SAHARA NURSING COLLEGE VILL JANUNAGAR POST KEMRI TEHSIL MILAK DISTT RAMPUR",
  "ABHISHRI COLLEGE OF TEACHING AND TRAINING",
  "RAJBALA DIVYANG TEACHER TRAINING COLLEGE",
  "NC POLYTECHNIC",
  "RIDDHI SIDDHI COLLEGE OF PHARMACY",
  "REENA INSTITUTE OF PHARMACY, AZAMGARH",
  "RAJESHWARI ANIL KUMAR MAHAVIDYALAYA PHARMACY",
  "VIDYAWATI DEVI DEGREE COLLEGE KATRA DAYARAM ALLAHABAD",
  "AKSHAY JEEVAN AYURVEDIC CHIKITSALAY MAHAVIDYALAY EVAM SHODH SANSTHAN",
  "SHERWOOD INSTITUTE OF PARAMEDICAL SCIENCES",
  "PRABHA INSTITUTE OF MEDICAL SCIENCES BIDHIYANI KHALILABAD",
  "SRI VIKRAMA SINGH LALTA SINGH MEMORIAL TEACHERS TRAINING ACADEMY AMANAWAY MARTINGANJ AZAMGARH",
  "SHRI KRISHAN SANSTHAN RAJANPUR MUDIYAR GHAZIPUR",
  "SHIKSHAN SANSTHA SWAMI RAMKRISHAN PARAMHANS PURV MADHMIK VIDYALAYA SAMITI MALIHAMAU HARDOI",
  "SAMA MAHENDRA COLLEGE OF EDUCATION, PLOT NUMBER ONE FIVE EIGHT, DHIRJIJOT, SIKHRI, GHAZIPUR",
  "RAM SURAT SINGH SHIKSHAN EVAM PRASHIKSHAN SANASTHAN MAHARUPUR JAUNPUR",
  "RAM MURATI MISHRA SMARAK TEACHING AND TRENING COLLEGE BABURA MAHULIYA AMBEDKARNAGAR",
  "RAJA HARPAL SINGH MAHAVIDYALAYA SHIKSHAK PRASHIKSHAN KENDRA SINGHAWAL SINGRAMAU JAUNPUR",
  "RADHIKA DEVI LALBIHARI TIWARI SIKSHAN PRASHIKSHAN SANSTHAN",
  "PRIYANKA COLLEGE OF PROFESSIONAL EDUCATION",
  "DOYEN INSTITUTE OF HOMEOPATHIC PHARMACY",
  "PAL INSTITUTE OF MEDICAL SCIENCES KOTWALI ROAD NEHTAUR BIJNOR",
  "MANOHAR LAL DEGREE COLLEGE FOR TEACHER EDUCATION, SAROSI UNNAO",
  "GHANSHYAM URVASHI PRASIKSHAN KENDRA BAUDAI PHOOLPUR PRAYAGRAJ",
  "DEV COLLEGE OF EDUCATION VILL JULHEDA BARNAWA ROAD SARDHANA MEERUT",
  "BAHADUR YADAV MEMORIAL P G COLLEGE RAMPUR KHURHURIYA BHATNI DEORIA UP",
  "RADHIKA SINGHSHIKSHAK PRASHIKSHAN SANSTHAN",
  "B B S PUBLIC DEGREE COLLEGE AND EDUCATION TRAINING INSTITUTION",
  "RAMLALI SMARAK VIKAS SANSTHAN",
  "BABA RAM ROOP SINGH SHIKSHAN EVAM PRASHIKSHAN SANSTHAN, CHAKRAPANPUR NAREHTHA, KANAILA, AZAMGARH",
  "SHRI SAI COLLEGE OF NURSING AND PHARMACY MAI KHARAGPUR LALGANJ AZAMGARH",
  "CHANDRA PRAKASH DEGREE COLLEGE",
  "DR SHAMBHOONATH AYURVEDIC PARAMEDICA COLLEGE AND RESEARCH CENTER, MEERPUR, PYAREPUR, BAHARIYABAD, GHAZIPUR",
  "PRATHVIRAJ CHAUHAN COLLEGE OF PHARMACY",
  "PREM EDUCATIONAL INSTITUTE",
  "AMRAPALI NURSING INSTITUTE LUCKNOW",
  "FACULTY OF PHARMACY CHANDRABHAN SINGH DEGREE COLLEGE",
  "SMT ISHRAWATI DEVI MAHILA MAHAVIDYALAYA",
  "BAJRANG COLLEGE OF EDUCATION",
  "DAYANAND DINANATH COLLEGE OF PHARMACY",
  "KINGS EDEN COLLEGE OF NURSING",
  "A N TIWARI PHARMACY COLLEGE, PRAYAGRAJ, UTTAR PRADESH",
  "M L ACADEMY COLLEGE OF SPECIAL EDUCATION",
  "SUSHMA MAHILA MAHAVIDYALAYA",
  "S M A MEMORIAL COLLEGE, JUNGAL SUBHAN ALI UNAULA DOYAM, GORAKHPUR",
  "SHANTI DEVI EDUCATIONAL INSTITUTE",
  "SHRIPATI INTERNATIONAL PUBLIC SCHOOL PLOT NO TWO HUNDRED FIFTEEN GRAM GANAPUR POST AJOSI JAUNPUR",
  "SHANTI SUDAMA MAHAVIDYALAYA SANSTHAN",
  "G B COLLEGE OF PHARMACY",
  "SHANTI JANSEVA SHIKSHAK EVAM PRASHIKSHAN SANTHAN AMAURA PANDAHA AZAMGARH",
  "AZAD COLLEGE OF PHARMACY",
  "BHAGWANT COLLEGE OF PHARMACY",
  "EXCELLENCE CENTRE OF PHARMACY",
  "SWATI HOSPITAL AND PARAMEDICAL COLLEGE BUDHANA SHAHPUR ROAD TAWLI MUZAFFARNAGAR",
  "VIDYA COLLEGE OF NURSING",
  "SHAILESH VIDYALAYA, HARTARA, BAHARIYABAD, GHAZIPUR",
  "GRAMODYOG SEWA SANSTHAN MUSAFIRKHANA AMETHI",
  "BANARAS COLLEGE OF PHARMACY ATESUA MURDAHA VARANASI",
  "BABU MANGALA RAI SAMARAK SANSTHAN",
  "VISHWANATH SETH COLLEGE OF PHARMACY AND PARAMEDICAL KARMANVEER SUSUWAHI VARANASI",
  "RAMBHAJAN SINGH SHIKSHAN PRASHIKSHAN SANSTHAN",
  "SRI RAM ADARSH INSTITUTE OF HIGHER EDUCATION ENGEERING AND MANGEMENT BEWANA",
  "SHRIMATI DURGA DEVI COLLEGE JATORA MATHURA",
  "VISHWANATH COLLEGE OF PHARMACY",
  "S S INSTITUTE OF PHARMACY JAUNPUR",
  "SHYAMPATI CHANDRASHEKHAR MISHRA COLLEGE OF PHARMACY",
  "SAGAR INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "R B S PHARMACY COLLEGE JAUNPUR",
  "JBS AYURVED SANSTHAN, MALINPUR, RAM SNEHI GHAT, BARABANKI",
  "AMARNATH SONA DEVI INSTITUTE OF PHARMACY, GHAZIPUR",
  "SHRI BAJRANG SINGH COLLEGE OF PHARMACY AMETHI",
  "S B S COLLEGE OF PHARMACY KANNUPUR JALALPUR AMBEDKAR NAGAR",
  "R D SINGH MEMORIAL INSTITUTE OF MEDICAL SCIENCE AYODHYA",
  "MAHARAJA AGRASEN COLLEGE OF PHARMACY",
  "GOVERNMENT POLYTECHNIC GHOSI MAU RUN BY AICCEDS",
  "DOODHNATH GROUP OF INSTITUTIONS",
  "CHARAK INSTITUTE OF PHARMACY LUCKNOW",
  "BAIJNATH RAM NARESH COLLEGE OF PHARMACY, AZAMGARH",
  "BAIJNATH RAMNARESH COLLEGE OF HOMEOPATHIC PHARMACY, VILLAGE TELHUWA CHAKWALI, CHIRAIYAKOT, SADAR, AZAMGARH",
  "LAXMI HEALTH CARE NURSING COLLEGE, JAUNPUR",
  "KAMLA NURSING AND PARAMEDICAL COLLEGE ONE HUNDRED ELEVEN C JACYZ ROAD JAUNPUR",
  "ISHITA COLLEGE OF PARAMEDICAL SCIENCES, SAROJ HOSPITAL BALAJINAGAR COLONY, AKHARI CHUNAR ROAD VARANASI",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, AJITMAL AURAIYA",
  "SAI COLLEGE OF PHARMACY, AZAMGARH",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BAHRAICH",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, AMBEDKAR NAGAR",
  "GANPATI COLLEGE OF PROFESSIONAL EDUCATION",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, ALIGARH",
  "LALITA COLLEGE OF PHARMACY",
  "AKHILESH YADAV PHARMACY COLLEGE",
  "VIDYA NIKETAN PHARMACY",
  "RAJKIRAN COLLEGE OF PHARMACY",
  "RAMSWAROOP COLLEGE OF EDUCATION JATORA MATHURA",
  "UNIVERSITY POLYTECHNIC DIPLOMA",
  "ADHYAYAN COLLEGE OF PHARMACY",
  "Government Polytechnic Shahbad Rampur",
  "SRI SAI INSTITUTE OF TEACHER EDUCATION LAXMAN GARHI KHAIR",
  "GOLDCREST JUNIOR COLLEGE OF EDUCATION AND RESEARCH MANAUVA KHANIYARA LALGANJ AZAMGARH",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, HATHRAS",
  "SWARGIYA RAMDHARI RAI SHIKSHAN SANSTHAN",
  "SUSHILA RAI SHIKSHAN PRASHIKSHAN KENDRA, SARAIMOHAN, LALGANJ, AZAMGARH",
  "SRI RUDRA SHIV S N S K INSTITUTE OF EDUCATION",
  "SRI LACHCHHIRAM SHIKSHA EVAM PRASHIKSHAN SANSTHAN, SALIKPUR, GHAZIPUR",
  "SHRI SHARDA SAI SHIKSHAN PRASHIKSHAN SANSTHAN, KHORRAMPUR BELAU NIZAMABAD AZAMGARH",
  "SHRI DHANDHU SINGH RAMDHUN SINGH KANYA MAHAVIDYALAYA SIRSA BIJAULI",
  "SHIV PRASHIKSHAN SANSTHAN D EL ED",
  "JAMIA COLLEGE OF PHARMACY",
  "SHASHWAT SURYAVANSHI COLLEGE OF EDUCATION AND TRAINING, ATIGAWAN, JAKHANIAN, GHAZIPUR",
  "RAMCHARAN VERMA NANHKU VERMA SHIKSHAN EVAM PRASHIKSHAN SANSTHAN SULTANPUR",
  "BABA SAHEB DR. BHIMRAO AMBEDKAR GOVERNMENT POLYTECHNIC  HAIDARPUR AURAIYA",
  "APEX INSTITUTE OF TECHNOLOGY",
  "OM MAA AADI SHAKTI KV PUBLIC SCHOOL DEWA DULLAHAPUR GHAZIPUR",
  "OM MAA AADI SHAKTI KV INSTITUTE OF EDUCATION INAMIPUR DULLAHAPUR GHAZIPUR",
  "KRISHNARPIT INSTITUTE OF TECHNOLOGY AND MANAGEMENT EDUCATIONAL SOCIETY",
  "AMAR SINGH SMARAK SHIKSHAN PRASHIKSHAN SANSTHAN DUNDI AMANIGANJ AYODHYA",
  "MOTI LAL RASTOGI SCHOOL OF MANAGEMENT",
  "SULTAN FAREED MAHAVIDHYALAY ALIPUR",
  "DR. B.R. AMBEDKAR POLYTECHNIC",
  "M G PARA MEDICAL AYURVEDIC COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING LAKHIMPUR",
  "MEERUT INSTITUTE OF PARA MEDICAL SCIENCE & HOSPITAL",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING, JYOTIBA PHULE NAGAR",
  "D.N.POLYTECHNIC MEERUT",
  "GOVERNMENT POLYTECHNIC UNNAO",
  "SIDDHI VINAYAK COLLEGE OF PHARMACY, GONDA",
  "DEV INSTITUTE OF TECHNICAL EDUCATION BERHAN",
  "GLOBAL LAW INSTITUTE, PURNAPUR",
  "DEV BHOOMI INSTITUTE OF POLYTECHNIC",
  "GOVERNMENT POLYTECHNIC PHOOLPUR PAWAI AZAMGARH RUN BY AICCEDS",
  "AKANKSHA INSTITUTE OF PARAMEDICALS",
  "DEPARTMENT OF PHARMACY L N COLLEGE",
  "GOVERNMENT POLYTECHNIC DEBAI BULANDSHAHR",
  "CHAUDHARY ATAR SINGH INSTITUTE OF MEDICAL SCIENCES, KALAN SHAHJAHANPUR",
  "DR. AMBEDKAR INSTITUTE OF TECHNOLOGY FOR DIVYANGJAN U.P. KANPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING FARUKHABAD",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING LALITPUR",
  "SHRI MAHAVIR COLLEGE OF EDUCATION RAJPUR KOTEA, FIROZABAD",
  "GOVERNMENT POLYTECHNIC BHILIHILI, AZAMGARH",
  "RANI CHHAVINATH KUNWARI PRASHIKSHAN MAHAVIDYALAY JAMON AMETHI",
  "Chaudhary Chauhari Maurya Smarak Shiksha Prasiskshan Sansthan",
  "SHRI HARDAM SINGH VEDIC COLLEGE",
  "B S B PARAMEDICAL COLLEGE AND HOSPITAL",
  "PREMA DEVI INSTITUTE OF PARA MEDICAL SCIENCE DEVLI SAHABGANJ PRATAPGARJ UP",
  "BRAHMA DEVI SHARMA COLLEGE OF EDUCATION",
  "SARSHWATI INSTITUTE",
  "CH MUKHTYAR SINGH YADAV MAHAVIDYALAYA",
  "SAI CARE COLLEGE OF PHARMACY",
  "RAHUL SANKRITYAYAN COLLEGE OF PHARMACY JAIGAHA SHEKHUPUR AZAMGARH",
  "SAMA MAHENDRA COLLEGE OF PHARMACY DHIRJIJOTE SIKHRIE JAKHANIYA GHAZIPUR",
  "SHRI BABU SINGH MAHAVIDYALAYA",
  "KALESHAR SINGH DEGREE COLLEGE",
  "SHASHWAT SURYAVANSHI MAHAVIDYALAYA ATIGANWA JAKHANIAN, GHAZIPUR",
  "RAM MURAT SMARAK SHIKSHAN SEVA SAMEETI, BASIRHA, AZAMGARH",
  "SANT KINARAM MAHAVIDYALAYA, KANERI, SAIDPUR, GHAZIPUR",
  "GULAB SINGH SHIKSHA EVAM PRASHIKSHAN KENDRA PHAPHUND ROAD AURAIYA",
  "RAM SHIROMANI GEETA PARAMEDICAL PRASHIKSHAN SANSTHAN",
  "SAGAR PHARMACY COLLEGE, BARABANKI",
  "SVMA PARAMEDICAL COLLEGE VILL AND POST BALIPUR TEHSIL SIRSAGANJ FIROZABAD",
  "SOMAI PRASAD MEMORIAL INSTITUTE OF PARAMEDICAL SCIENCES",
  "MRS EDUCATION INSTITUTE OF PARAMEDICAL SCIENCE AVAS VIKAS COLONY SEC II SHIKOHABAD FIROZABAD",
  "BABA BAIJNATH TRIPATHI COLLEGE OF HOMEOPATHIC PHARMACY KENAUNA BASTI",
  "BABA BAIJNATH TRIPATHI COLLEGE OF AYURVEDIC UNANI COLLEGE OF PHARMACY KENUNA BASTI",
  "AVANI COLLEGE OF AYURVEDIC NURSING AND PHARMACY",
  "GOVT. POLYTECHNIC BASTI",
  "AK COLLEGE OF PHARMACY, BAGHPAT",
  "ATHARV NURSING AND PARAMEDICAL COLLEGE, KHARIHANI, AZAMGARH",
  "PREMIER INSTITUTE OF PARA MEDICAL SCIENCES",
  "OJHA NURSING AND PARAMEDICAL INSTITUTE, TAGORE TOWN, PRAYAGRAJ",
  "SATYAM SHIVAM PHARMACY COLLEGE",
  "RAJ COLLEGE OF PHARMACY AND NURSING",
  "PHOOL CHANDRA SINGH TULSI DEVI MAHAVIDHYALAYA OF PHARMACY PRAYAGRAJ",
  "NANDINI COLLEGE TURKAULI NAWABGANJ GONDA",
  "MAHARAJA DEVI BUX SINGH SMARAK SANSTHAN VILLAGE BANGHUSARA POST DUMARIYADEEH DISTRICT GONDA UTTAR PRADESH",
  "KRISHNA INSTITUTE OF NURSING AND PHARMACY COLLEGE VILLAGE AND POST MISHRAULIYA BASTI",
  "APEX COLLEGE OF PHARMACY",
  "ACHARYA SADASHIV PARAMEDICAL INSTITUTE PRATAPGARH",
  "ARYAVART INSTITUTE OF TECHNOLOGY AND MANAGEMENT",
  "SHYAMPATI CHANDRA SHEKHAR MISHRA PARAMEDICAL INSTITUTE",
  "SMT OMWATI DEVI COLLEGE OF PHARMACY",
  "VIDYAWATI INSTITUTE OF PHARMACY, PRAYAGRAJ",
  "GHANSHYAM URVASHI COLLEGE OF PHARMACY",
  "DNY COLLEGE OF PHARMACY",
  "BAUHRE HARI SINGH COLLEGE OF PHARMACY",
  "BHOORE SINGH COLLEGE OF EDUCATION PHAPHUND ROAD AURAIYA",
  "JEEVAN DEEP WOMEN DEGREE COLLEGE, SURYANAGAR, JAKHANIAN, GHAZIPUR",
  "J D COLLEGE OF PHARMACY, LUCKNOW",
  "HITECH INSTITUTE",
  "LALITPUR EDUCATION INSTITUTE INDRANAGAR ORAI JALAUN",
  "M.S.D.POLYTECHNIC COLLEGE",
  "RAMJI SINGH MEMORIAL COLLEGE  PROFESSIONAL STUDIES, BIJNOR",
  "SUSHIL COLLEGE OF PHARMACY , MEERUT",
  "SHRI SIDDHI VINAYAK COLLEGE OF PHARMACY, SHAHJAHANPUR",
  "SWAMI VIVEKANAND INSTITUTE OF EDUCATION, SHAHJAHANPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING BAREILLY",
  "VAGESHWARI SHIKSHAN SANSTHAN MAHAVIDYLAYA MAIL DEORIA",
  "MUNNI DEVI SHIKSHAK PRAKSHISHAN SANSTHAN ASBARANPUR JAUNPUR",
  "Govt. Polytechnic Etah",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING GORAKHPUR",
  "POPULAR NURSING SCHOOL AND PARAMEDICAL INSTITUTE VILL AND POST BACHCHHAO CHUNAR RAOD VARANASI",
  "S S M P COLLEGE OF PHARMACY, AZAMGARH",
  "RADHA VALLABH INSTITUTE OF TECHNOLOGY, EMAMPUR, KHUTHAN, JAUNPUR",
  "SUNRISE NURSING AND PHARMACY COLLEGE UNNAO",
  "Kamla Nursing College, Sakhaila, Gaurabadshahpur, Janunpur",
  "SHREE SIDDHI VINAYAK COLLEGE OF PHARMACY",
  "R K S COLLEGE OF PHARMACY JAUNPUR",
  "RAS COLLEGE OF PHARMACY",
  "RAMASHANKAR SINGH COLLEGE OF PHARMACY",
  "J M S GROUP OF INSTITUTIONS",
  "GOVERNMENT POLYTECHNIC GOPAMAU HARDOI",
  "DWIVEDI INSTITUTE OF MEDICAL SCIENCES",
  "REKHA EYE CARE CENTER SITAPUR",
  "GOVERNMENT POLYTECHNIC BILSI BUDAUN",
  "GOVERNMENT POLYTECHNIC BARA",
  "BAIJNATH MAHAVIDYALAYA PHARMACY, GHAZIPUR",
  "J P R COLLEGE OF PHARMACY,  AZAMGARH",
  "SHYAMRAJ NURSING AND PHARMACY COLLEGE, SONBHADRA",
  "D S COLLEGE OF PHARMACY,  MAU",
  "SHRI SUKHAI SINGH COLLEGE OF PHARMACY GHAZIPUR",
  "CHANDRABHAN SINGH COLLEGE OF PHARMACY, KANPUR DEHAT",
  "SHIVA EDUCATIONAL AND PHARMACY INSTITUTE",
  "SAUMYA COLLEGE OF PHARMACY",
  "ROHINI COLLEGE O PHARMACY",
  "R K D COLLEGE OF PHARMACY",
  "PUSHPA SINGH INSTITUTE OF PHARMACY, GHAZIPUR",
  "AYUSH INSTITUTE OF PHARMACY ,BASTI",
  "MUKHRAM MAHAVIDYALAYA PHARMACY, GHAZIPUR",
  "M G INSTITUTE OF PHARMACY",
  "MANYAWAR KANSHIRAM COLLEGE OF PHARMACY, PRAYAGRAJ",
  "LALARAM SHRIDEVI PHARMACY COLLEGE",
  "K P INSTITUTE OF PHARMACY PRAYAGRAJ",
  "K P INSTITUTE OF MEDICAL SCIENCE PRATAPGARH",
  "K K VERMA PHARMACY COLLEGE SULTANPUR",
  "THE PANACEA PARAMEDICAL SCIENCES AND NURSING INSTITUTE",
  "JSPM D PHARMA KASYA SONBHADRA UP",
  "JP INSTITUTE OF ENGINEERING AND TECHNOLOGY",
  "I R SINGH MEMORIAL INSTITUTE OF SCIENCE AYODHYA",
  "BHM COLLEGE OF HIGHER EDUCATION",
  "BASUDEV COLLEGE OF PHARMACY",
  "BABA JEET NARAYAN CHAND PHARAMCY COLLEGE",
  "G S INSTITUTE OF PHARMACY, AURAIYA",
  "A V INSTITUTE OF PHARMACY",
  "A S YADAV COLLEGE OF PHARMACY, GHAZIPUR",
  "AIMS PHARMACY COLLEGE, AMROHA",
  "A C S COLLEGE OF PHARMACY KILAUNI BALDEO MATHURA",
  "RAMPRASAD KUSHWAHA MAHAVIDYALAYA SANDI HARDOI",
  "KAMAKSHA PRASAD PRATAP NARAYAN MISHRA COLLEGE OF EDUCATION AND TECHNOLOGY , PRATAPGARH",
  "K K T COLLEGE OF PHARMACY ,MAHARAJGANJ",
  "YASHODA COLLEGE OF PHARMACY JAUNPUR",
  "VATS CHANDRAKALA NAGINA COLLEGE OF PHARMACY, AZAMGARH",
  "SUSHILA RAI INSTITUTE OF HOMEOPATHIC PHARMACY COLLEGE, SARAY MOHAN, AZAMGARH",
  "SUSHILA DEVI COLLEGE OF PHARMACY",
  "SHRI KS COLLEGE OF PHARMACY",
  "SHANTI POLYTECHNIC AND PHARMACY",
  "SARVODYA POLYTECHNIC COLLEGE",
  "RAM KAILASH COLLEGE OF PHARMACY AND PARAMEDICAL SCIENCE , AYODHYA",
  "R L S COLLEGE OF PHARMACY AND RESEARCH CENTRE",
  "RIET VIDYAPEETH COLLEGE OF PHARMACY",
  "R RADHIKA COLLEGE OF PHARMACY,  SONBHADRA",
  "RADHA RAMAN MISHRA COLLEGE OF PHARMACY",
  "NAURANG SINGH COLLEGE OF PHARMACY",
  "LALPATI COLLEGE OF PHARMACY",
  "KUNJ BIHARI COLLEGE OF PHARMACY, KANPUR DEHAT",
  "SHRI RAM COLLEGE OF PHARMACY, KANPUR",
  "KHAKI BABA SIDDHARTH MAHAVIDYALAYA PHARMACY, GHAZIPUR",
  "RAMVRIKSH COLLEGE OF PHARMACY, MAU",
  "GOVERNMENT POLYTECHNIC KURARA HAMIRPUR",
  "GEETA SHUKLA COLLEGE OF PROFESSIONAL STUDIES",
  "DR RAM CHARITTAR NISHAD COLLEGE OF PHARMACY JAUNPUR",
  "DR DINESH KUMAR YADAV COLLEGE OF PHARMACY JAUNPUR",
  "DASHARATH COLLEGE OF PHARMACY, GHAZIPUR",
  "ASHOK KUMAR COLLEGE OF PHARMACY",
  "SHRI MALIKHAN SINGH MAHAVIDHYALAYA AND HOSPITAL RUDRAPUR ETAH",
  "UNITED INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "RAM NATH MUNSHI SHIKSHAK PRASHIKSHAN SANSTHAN SADAT GHAZIPUR",
  "INDIAN EDUCATIONAL TRUST SCHOOL OF NURSING, LAKHAUA, SIKRARA, JAUNPUR",
  "MOHAN INSTITUTE OF PHARMACY BAREILLY",
  "CHAUDHARY CHARAN SINGH INSTITUTE",
  "DR A K PANDEY COLLEGE OF PHARMACY",
  "RDJS PHARMACY COLLEGE",
  "KARMYOGI PANDIT RAM KISHOR TRIPATHI ADHYAPAK SHIKHSAD SANSHTHAN  VAIDAHA ROAD RAHUL NAGAR BASAUNHA MOTIGANJ SULTANPUR",
  "RUDAULI COLLEGE OF PHARMACY",
  "SHANKAR PHARMACY COLLEGE, GORAKHPUR",
  "INSTITUTE OF PROFESSIONAL SCHOOLING AND RESEARCH",
  "HIMALAYAN POLYTECHNIC INSTITUTE",
  "S S COLLEGE OF PHARMACY AMBEDKARNAGAR",
  "SHAHEED CAPTAIN VIJAY PRATAP SINGH PHARMACY COLLEGE, CHANDAULI",
  "R R S COLLEGE OF NURSING AND PHARMACY GHAZIPUR",
  "R K INSTITUTE OF MEDICAL SCIENCES, AZAMGARH",
  "VIMALA COLLEGE OF PHARMACY, CHANDAULI",
  "CHAUDHARY CHARAN SINGH INSTITUTE OF SPECIAL EDUCATION",
  "COLLEGE OF HIGHER STUDIES",
  "NISHADRAJ OMPRAKASH PHARMACY AND PARAMEDICAL COLLEGE, KUSHINAGAR",
  "NIRMALA DEVI MAURYA PHARMACY TRAINING COLLEGE, PRAYAGRAJ",
  "CHANDRA SHEKHAR PANDEY HOSPITAL AND NURSING COLLEGE",
  "KAMAKHYA PHARMACY INSTITUTE , GHAZIPUR",
  "RAJA RAGURAJ SINGH NURSING COLLEGE",
  "DR AWADHESH PRAKASH SHARMA COLLEGE OF PHARMACY NASIPUR MANSARA BARABANKI",
  "CITY PHARMACY COLLEGE, GHAZIPUR",
  "CIMT COLLEGE OF PHARMACY",
  "AYODHYA VIDYAPEETH COLLEGE OF PHARMACY",
  "SAURABH SHOBHIT SHIKSHAN PRASHIKSHAN KENDRA",
  "JEEVAN JYOTI INSTITUTE FOR THE DISABLED",
  "SARASWATI HIGHER EDUCATION AND TECHNICAL COLLEGE OF PARAMEDICAL",
  "LET SITA SINGH SMARK SHIKASHAN PRASHIKSHAN SANSTHAN KAILHAT CHUNAR MIRZAPUR",
  "GANGA INSTITUTE OF EDUCATION",
  "KARMA DEVI SHIKSHAN PRASHIKSHAN SANSTHAN LALGANJ PRATAPGARH",
  "RAMLALIT SINGH SHIKSHAN AVAM PRASHIKSHAN SANSTHAN",
  "B R D COLLEGE OF PHARMACY AZAMGARH",
  "KANNAUJ COLLEGE OF MEDICAL SCIENCE",
  "YAMUNA COLLEGE OF PHARMACY, CHANDAULI",
  "RDS COLLEGE OF PHARMACY, MIRZAPUR",
  "OXFORD MODEL INSTITUTE OF ADVANCE STUDIES MAHARAJPUR KANPUR NAGAR",
  "BUDDHA INSTITUTE OF MANAGEMENT AND TECHNOLOGY HAPUR",
  "DR AVADHESH PRAKASH SHARMA COLLEGE OF NURSING NASIPUR MANSARA BARABANKI",
  "GOVERNMENT POLYTECHNIC, BHANPUR, LAKHIMPUR KHERI (PPP MODE)",
  "SUYAS HOSPITAL OF NURSING AND PARAMEDICAL COLLEGE",
  "SHRI SIDDHI VINAYAK INSTITUTE OF PHARMACY",
  "RLT INSTITUTE OF PHARMACEUTICAL SCIENCE AND TECHNOLOGY",
  "BHABHA INSTITUTE OF PHARMACY",
  "COMPOSITE REGIONAL CENTRE FOR SKILL DEVELOPMENT REHABILITATION AND EMPOWERMENT OF PERSONS WITH DISABILITIES GORAKHPUR",
  "BABA VISHWANATH TECHNICAL INSTITUTE",
  "ANANDGANGA  PHARMACY EVAM NURSING COLLEGE HARIKIRTAN MOHALLA PURANA BHATANI DEORIA",
  "BABU RAGHUNATH JI MAHILA MAHAVIDYALAYA GAMBHEERPUR AZAMGARH",
  "THAKUR BACCHU SINGH EDUCATIONAL INSTITUTE JAROLI SHAMSABAD AGRA",
  "CAPTAIN TARA KUSHWAHA NURSING COLLEGE AND RESEARCH CENTRE",
  "RAM NEWAJ SINGH TEACHERS TRAINING COLLEGE AKMA KUMARGANJ AYODHYA",
  "ICON COLLEGE OF NURSING AND PARAMEDICAL ,GANESHPUR LAHARPUR SITAPUR",
  "AWADH PARAMEDICAL COLLEGE VISHESHARPUR SHEETALA CHAUKIA AZAMGARH ROAD JAUNPUR",
  "AMIR HASAN COLLEGE OF PHARMACY, JAMUNHA, BABAGANJ, NANPARA, BAHRAICH",
  "VARDAAN INSTITUTE OF PHARMACY, PARIYAR, UNNAO",
  "S I M NURSING COLLEGE",
  "S N SINGH COLLEGE OF EDUCATION AND TRAINING, ATIGAWAN, JAKHANIAN, GHAZIPUR",
  "SHASHWAT SURYAVANSHI INSTITUTE OF PHARMACY, ATIGAWAN, JAKHANIAN, GHAZIPUR",
  "A T D SHIKSHAN SANSTHAN VISHUNPURA DEVCHANDPUR GHAZIPUR",
  "SHANTI SHIKSHAN PRASHIKSHAN SANSTHAN MOLNAPUR AHMADBAKSH PHULESH AZAMGARH",
  "RAJBAHADUR SINGH SMARAK MAHAVIDYALAYA HAMIDPUR SHAHIDWARA AZAMGARH",
  "SHRI TIRUPATI MAHAVIDYALAYA BALDEV MANDURI PACHKHORA AZAMGARH",
  "AIMS NURSING COLLEGE GAJRAULA  AMROHA  UP",
  "CHANDRALOK INSTITUTE OF MEDICAL SCIENCES",
  "PAHALWAN GURUDEEN COLLEGE OF NURSING AND PARAMEDICAL SCIENCE",
  "BHAVDIYA MEDICAL COLLEGE AND INSTITUTE OF NURSING",
  "RAMREKHA RAI INSTITUTE OF PHARMACY",
  "BABA KINARAM SHIKSHAN EVAM PRASHIKSHAN SANSTHAN KANERI SADAT GHAZIPUR",
  "S K R COLLEGE OF EDUCATION PAHAI KANERI SAIDPUR GHAZIPUR",
  "THAKUR DEEP NARAYAN SINGH SMARAK SHIKSHAN EVAM PRASHIKSHAN SANSTHAN KUNDABHAIROPUR",
  "SHRI SURYA PRATAP SINGH SMARAK SHIKSHAN EVAM PRASHIKSHAN SANSTHAN KUNDABHAIROPUR",
  "NAVNEET COLLEGE OF EDUCATION",
  "RAGHUNANDAN KISHUNDEV COLLEGE OF NURSING AND PHARMACY DEVCHANDPUR GHAZIPUR",
  "EDIFY INSTITUTE OF BTC",
  "NAVNEET INTERNATIONAL SCHOOL OF SCIENCE",
  "OM JEE COLLEGE OF EDUCATION AND TRAINING OMNAGAR JAKHANIAN GHAZIPUR",
  "Accurate Institute of Polytechnic",
  "DIVYA COLLEGE OF SPECIAL EDUCATION",
  "BINDESHWARI MAHAVIDYALAYA",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING JAUNPUR",
  "OM JEE INSTITUTE OF PHARMACY GAURA JAKHANIAN GHAZIPUR",
  "MATA TETARA DEVI SACHCHIDANAND COLLEGE OF NURSING AND PHARMACY ALIPUR MANDARA GHAZIPUR",
  "SHASHWAT SURYAVANSHI COLLEGE OF NURSING AND PHARMACY ATIGAWAN JAKHANIAN GHAZIPUR",
  "CENTRAL INSTITUTE OF PETROCHEMICALS ENGINEERING AND TECHNOLOGY, VARANASI",
  "S N SINGH INSTITUTE OF NURSING AND PHARMACY ATIGAWAN KHETABPUR GHAZIPUR",
  "SAVITA DEVI INSTITUTE OF TECHNOLOGY",
  "NIMT GREATER NOIDA",
  "RAJSHREE COLLEGE OF PHARMACY",
  "MAA SHARDA AYURVEDIC PHARMACY AND NURSING COLLEGE GOMADIH LALGANJ AZAMGARH",
  "C S COLLEGE OF PHARMACY",
  "ANUPAMA RAI MEMORIAL COLLEGE OF PHARMACY AZAMGARH",
  "AYUSH HOMOEOPATHIC PHARMACY COLLEGE",
  "COLLEGE OF NURSING AND PHARMACY",
  "RADIANT COLLEGE OF PHARMACY",
  "OM JEE COLLEGE OF NURSING AND PHARMACY OMNAGAR JAKHANIAN GHAZIPUR",
  "ACCURATE INSTITUTE OF MANAGEMENT AND TECHNOLOGY",
  "SINGH LIFE CARE NURSING AND PARAMEDICAL SCHOOL",
  "MMIT Anaugi Kannauj",
  "SACHDEVA POLYTECHNIC",
  "DR KESHAV SINGH AZAD PHARMACY COLLEGE",
  "SITA DEVI COLLEGE OF PHARMACY AND MANAGEMENT",
  "B K INSTITUTE OF PHARMACY",
  "ASIAN INSTITUTE OF SCIENCE AND TECH BAGHPUR KANPUR DEHAT",
  "ACHARY BALDEV POLYTECNIC COLLEGE KOPA PATRAHI JAUNPUR",
  "UDAYRAJ SINGH RAMPYARI INSTITUTE OF SCIENCE AND TECHNOLOGY",
  "MAHARISHI DAYANAND REHABILITATION INSTITUTE RAL MATHURA",
  "JEEVAN DEEP NURSING AND PHARMACY COLLEGE SURYANAGAR JAKHANIAN GHAZIPUR",
  "ACN College of Polytechnic",
  "DEWAN VS INSTITUTE OF HOTEL MANAGEMENT",
  "SVM Pharmacy College",
  "DR TANDON PHARMACY COLLEGE",
  "DR BPS COLLEGE OF PHARMACY",
  "LAXMAN MEMORIAL COLLEGE OF PHARMACY",
  "LALSA INSTITUTE OF ENGINEERING AND RURAL TECHNOLOGY RAIPUR JAKHANIYA GHAZIPUR",
  "XAVIER INSTITUTE OF MANAGEMENT AND DESIGN",
  "DEV TECHNICAL CAMPUS",
  "Kunwar Ajeet College of Pharmacy",
  "NIMT HOSPITAL",
  "BUDDHA POLYTECHNIC COLLEGE",
  "Azad College Of Education",
  "MAA GAYATRI HOMEOPATHIC PHARMACY COLLEGE",
  "UDAY PHARMACY COLLEGE",
  "AVADH HOSPITAL GROUP OF INSTITUTION, GONDA",
  "SITA DEVI INSTITUTE OF HOMOEOPATHIC PHARMACY",
  "LAXMI DEVI HOMOEOPATHIC PHARMACY COLLEGE",
  "RAJKALI DEVI HOMOPATHIC PHARMACY COLLEGE LAHENGA CHHATOH SALON RAEBARELI",
  "SRC HOMEOPATHIC PHARMACY COLLGE",
  "ASIAN PARAMEDICAL INSTITUTE SHEKHUPUR BAGHPUR KANPUR DEHAT",
  "J P HOMOEOPATHIC PHARMACY COLLEGE BASTI",
  "ARYAKUL COLLEGE OF HOMOEOPATHIC PHARMACY VILL JAJAUR PO MANWA DISTT SITAPUR",
  "ARYAKUL COLLEGE OF HOMOEOPATHIC PHARMACY RAEBARELI",
  "RAMASHRAY SINGH INSTITUTE OF HOMEOPATHIC PHARMACY",
  "KANPUR PARAMEDICAL TRAINING CENTRE",
  "SHYAMPATI BALIRAM MAURYA INSTITUTE OF PHARMACY MAALAV KARAHAN MAU",
  "MUZAFFARNAGAR AYURVED PARAMEDICAL COLLEGE AND HOSPITAL BAGHRA MUZAFFARNAGAR",
  "YASHRAJ INSTITUTE OF PROFESSIONAL STUDIES KANPUR",
  "Vivek College of Health and Medical Sciences",
  "VIVEKANAND POLYCLINIC,  LUCKNOW",
  "VISION INSTITUTE OF MANAGEMENT",
  "MANYAVAR KASHI RAM GOVERNMENT POLYTECHNIC KANNAUJ (RUNNING AT GOVT. POLYTECHNIC FARRUKHABAD)",
  "Mahendra Gayatri Paramedical College",
  "Mahaveer Nursing and Paramedical College",
  "MAHATMA JYOTIBA PHULE GOVERNMENT POLYTECHNIC KAUSHAMBI",
  "MAHARANA PRATAP POLYTECHNIC",
  "JAN KALYAN INSTITUTE OF TECHNICAL EDUCATION BEHTA",
  "JANHIT SCHOOL OF MANAGEMENT",
  "JANHIT INSTITUTE OF TECHONOLY",
  "JAIPURIA SCHOOL OF BUSINESS, GAZIABAD",
  "JAIPURIA ISNTITUTE OF MANAGEMENT LUCKNOW",
  "GOVERNMENT POLYTECHNIC KANPUR",
  "Government Polytechnic Jigirsand Sikandarpur Ballia",
  "GOVERNMENT POLYTECHNIC JHANSI",
  "GOVERNMENT POLYTECHNIC JAUNPUR",
  "GOVERNMENT POLYTECHNIC JALAUN",
  "GOVERNMENT POLYTECHNIC HARDOI",
  "GOVERNMENT POLYTECHNIC GORAKHPUR",
  "GOVERNMENT POLYTECHNIC GONDA",
  "D.J. POLYTECHNIC BARAUT",
  "C-MAT BUSINESS SCHOOL",
  "CHRISTIAN HOSPITAL AZAMGARH",
  "CHRISTIAN COLLEGE OF NURSING FACULTY OF HEALTH, MED SCIE, INDIGENOUS & ALTERNATIVE SYS OF MED, ALLAHABAD",
  "CHAUDHRY MUKHTAR SINGH GOVT. GIRLS POLYTECNIC",
  "GOVERNMENT POLYTECHNIC LAKHIMPUR (KHIRI)",
  "Raj Polytechnic Siswa Babatpur Varanasi",
  "R B GAUTAM POLYTECHNIC",
  "RAM REKHA RAI INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES MAHURAW KHORIBARI BHATANI DIST DEORIA",
  "HAJI RASHIDAN BEGUM AND HAJI SAHAB JAHAN EDUCATIONAL INSTITUTE AND HOSPITAL",
  "NGI CP",
  "HLM NURSING COLLEGE",
  "PARAMEDICAL COLLEGE BAGHRA MUZAFFARNAGAR",
  "SD HOMOEOPATHIC PHARMACY COLLEGE",
  "ABHINAVA INSTITUTE OF PROFESSIONAL STUDIES KANPUR",
  "RAJAN MEMORIAL PHARMACY COLLEGE",
  "MAA KHANDWARI PHARMACY AND NURSING COLLEGE CHAHANIYA",
  "SUNANDA INSTITUTE OF PARAMEDICAL SCIENCES AND HOSPITAL",
  "R N POLYTECHNIC COLLEGE",
  "BHARAT TIBBIYA COLLEGE",
  "APEX INSTITUTE OF PARAMEDICAL SCIENCES",
  "GOVERNMENT POLYTECHNIC TALBEHAT",
  "GOVERNMENT POLYTECHNIC SUTAWALI,JP NAGAR",
  "GOVERNMENT POLYTECHNIC SUMERPUR HAMIRPUR",
  "GOVERNMENT POLYTECHNIC SORON",
  "GOVERNMENT POLYTECHNIC ORAI",
  "GOVERNMENT POLYTECHNIC NARAINI",
  "GOVERNMENT POLYTECHNIC, MORADABAD",
  "GOVERNMENT POLYTECHNIC MIRZAPUR",
  "GOVERNMENT POLYTECHNIC PRATAPGARH",
  "GOVERNMENT POLYTECHNIC MAU",
  "GOVERNMENT POLYTECHNIC PILIBHIT",
  "ASHOKA COLLEGE OF EDUCATION",
  "AHMED NAFEES TEACHER TRANING COLLEGE BHARGAIN",
  "RAJAT GIRLS DEGREE COLLEGE",
  "BABU JAY SHANKAR GAYA PRASAD COLLEGE OF PHARMACY ",
  "BIHARI KRISHAN VINDHYACHAL SANSTHAN PAHADPUR KHURD MEERPUR JAKHANIA GHAZIPUR",
  "RAM PRASHAD SHIKSHAK PRASHIKSHAN SANSTHAN",
  "MAA VAISHNO MAA SHARDA POLYTECHNIC BASEERAHAN",
  "DKJ COLLEGE OF PHARMACY, AMETHI",
  "TYS PHARMACY COLLEGE ",
  "GRS COLLEGE OF PHARMACY KALAN SHAHJAHANPUR",
  "KASHI NATH INSTITUTE OF TECHNOLOGY",
  "SS MODERN AYUSH PARAMEDICAL COLLEGE GORAKHPUR",
  "MAHATMA RATAN GULJAR PHARMACY COLLEGE ",
  "SVS COLLEGE OF PHARMACY",
  "ARYAN HOSPITAL",
  "RAM ADHAR ANUCHIKITSIYE PRASHIKAN KENDRA BADAGAON NEAR KEDARNAGAR TANDA AMBEDKAR NAGAR",
  "MAA ANJANI PHARMACY COLLEGE",
  "JAMUNA RAM INSTITUTE OF PHARMACY",
  "VINDHYAVASINI ACADEMY",
  "SHIV NARAYAN COLLEGE OF EDUCATION, KHIRWA JALALPUR, MEERUT",
  "PREMPRAYAG COLLEGE OF PHARMACY",
  "MITTHU LAL MAURYA PHARMACY COLLEGE PRAYAGRAJ",
  "SHRI MUKESH JAUHARI PARAMEDICAL COLLEGE    ",
  "GOVERNMENT NURSERY TRAINING COLLEGE FOR WOMENS    ",
  "BABU RAM PAL SINGH COLLEGE OF PHARMACY ",
  "BABU PT SHIV BHUSHAN SHARMA COLLEGE OF PHARMACY",
  "COLLEGE OF NURSING AND PARAMEDICAL SCIENCES",
  "PT SHYAM NARAYAN MEMORIAL PUBLIC SCHOOL MAU,MAU",
  "P C S PURVANCHAL MAHAVIDHYALAY, POLT NO VILLAGE SURHURPUR ,POST OFFICE SURHURPUR TEHSIL MOHAMMADABAD GOHANA UTTAR PRADESH",
  "KAILASH INSTITUTE OF HOMEOPATHIC PHARMACY    ",
  "PCPS COLLEGE OF PHARMACY    ",
  "SALMANI HOMEOPATHIC PHARMACY COLLEGE SHAIDPUR RASHIDPUR ALAPUR AMBEDKAR    ",
  "TILKA DEVI INSTITUTE OF PHARMACY AND NURSING SONAWAN",
  "SWATANTRATA SENANI CHHANGUR TRIPATHI INSTITUTE OF HOMOEOPATHIC PHARMACY",
  "SHILENDRA SINGH COLLEGE OF PHARMACY RAJGARH FIROZABAD",
  "R K J INSTITUTE TOWNSHIP MATHURA",
  "PRATEEK SINGH SIDDHARTH POLYTECHNIC COLLEGE SIDDHARTHNAGAR",
  "KRISHNA PHARMACY COLLEGE",
  "J S ACADEMY",
  "H M NURSING EVAM PHARMACY COLLEGE, PEEWATAL, MAU",
  "ADARSH COLLEGE OF PHARMACY, AZAMGARH",
  "MAA KAMLA DEVI COLLEGE OF PHARMACY, AZAMGARH",
  "VIVEKAANAND SINGH COLLEGE OF PHARMACY, AZAMGARH  UP",
  "BABU BHISHAM SINGH INSTITUTE OF PHARMACY GOJHARI RAEBARELI",
  "ACHARYA HOMEOPATHIC COLLEGE",
  "TATHAGATA BUDDHA COLLEGE OF PHARMACY",
  "FLORENCE NIGHTANGLE SCHOOL OF GENERAL NURSING SHAHAJAHANPUR",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING ETAWAH",
  "SMRITISHESH PANDIT SINGH EDUCATIONAL INSTITUTE",
  "MAA VINDHYAVASINI MAHAVIDYALAYA, DEVIYAPUR, THANA SADARPUR",
  "DIKSHA COLLEGE OF PHARMACY",
  "LALJI CHIKITSA VIGYAN SANSTHAN AND HOMOEOPATHIC PHARMACY COLLEGE",
  "MAA KHANDWARI COLLEGE OF PHARMACY",
  "RAVI KANWAL NURSING HOME",
  "DEEP SANGYA COLLEGE OF HOMOEOPATHIC PHARMACY",
  "BALAJI AYURVEDIC PARAMEDICAL COLLEGE",
  "AUTONOMOUS STATE MEDICAL COLLEGE",
  "SHAKUNTALA DEVI AYURVEDIC PARAMEDICAL AND NURSING COLLEGE",
  "SHRI TRIDANDI DEV HANUMAT COLLEGE OF PHARMACY",
  "RGS INSTITUTE OF MEDICAL SCIENCES",
  "D R P COLLEGE OF PHARMACY RADHANAGAR FOUNDRY NAGAR AGRA",
  "RAM JANKI COLLEGE OF PROFESSIONAL STUDIES",
  "NAND ACADEMY, PLOT NUMBER FIVE ZERO SEVEN, ROHAWA, GAMBHIRPUR, LALGANJ, AZAMGARH",
  "G N HOMEOPATHIC PHARMACY COLLEGE",
  "SHIVMURAT PHARMACY COLLEGE",
  "PMD INSTITUTE OF PARAMEDICAL SCIENCES",
  "MANGAL MAYA INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES, BANDA",
  "LAXMI INSTITUTE OF PARAMEDICAL SCIENCES SARAI KAZI HARHUA VARANASI",
  "RAAFIAH COLLGE OF PHARMACY",
  "MAA VAISHNO COLLEGE OF PHARMACY",
  "SHATABDI COLLEGE OF PHARMACY",
  "BAPU RAM DAUR SINGH YADAV HOMOEOPATHIC PHARMACY COLLEGE",
  "KAPTAN SINGH MEMORIAL COLLEGE OF PHARMACY",
  "URMIL ICHHA MAHAVIDYALAYA",
  "SUKH DEYI PHARMACY COLLEGE, AZAMGARH",
  "UNURAKHA TIWARI DANPATI PHARMACY COLLEGE",
  "NCR COLLEGE OF HIGHER EDUCATION SALARPUR MAWANA MEERUT",
  "LALSAR COLLEGE OF PHARMACY, MAU",
  "SMT PATIRAJ DEVI SHAIKSHANIK SANSTHAN, RAMPUR KANWA, SEWARAI, GHAZIPUR",
  "NIYATI HAIER EDUCATION INSTITUTE HANUMAN GARI MAINPURI",
  "SARASWATI HIGHER EDUCATION AND TECHNICAL COLLEGE VILLAGE GAHANI POST AYAR DISTT VARANASI UP",
  "R D R H K MAHAVIDHYALAY CHIRAIYOKOT",
  "SHEELA DEVI COLLEGE OF EDUCATION",
  "S D C S TEACHERS TRAINING COLLEGE MAANAI BICHPURI ALIGAH",
  "SMT VIDHYA RANI PRASHICHAR SANSTHAN AGRA",
  "RAGHU RAM MAHAVIDYALAYA  KISHORA KA BAGH BEERAI SAIYA AGRA",
  "ACHARYA SADASHIV COLLEGE OF PHARMACY KHARHAR PRATAPGARH",
  "MANJANA COLLEGE OF PHARMACY",
  "VASUDHA COLLEGE OF PHARMACY JAUNPUR",
  "DR AJAY PAL SINGH COLLEGE OF PHARMACY",
  "MAA SHAKTI NURSING AND PHARMACY AYURVEDIC COLLEGE UNNAO",
  "SCHOOL OF OPTOMETRY MEMORIAL HOSPITAL FARRUKHABAD",
  "KISHORI LAL MAHAVIDYALAY, VILL-PATEWERA, PURWA",
  "KISAN MAHAVIDHYALAYA TRAINING CENTER",
  "KUNWAR VIDYAWATI SINGH SHIKSHAK PRASHIKSHAN MAHAVIDYALAYA NASEERPUR RAJAPUR PRATAPGARH",
  "KARAMYOGI PRABHU DEVI LALITA DEVI SHIKSHA SANSTHAN",
  "SHRI RADHA MADHAV TECHNICAL INSTITUTE",
  "ARYAVART VIDHYAPEETH VILLAGE AND POST KISOLI BULANDSHAHR",
  "VIDYA DEVI INSTITUTE OF TEACHER TRAINING NAGLA KHUSHAL BULANDSHAHR",
  "SHIVAM INSTITUTE OF HIGHER EDUCATION",
  "SHIV SAVITRI COLLEGE OF EDUCATION",
  "MAA TILESARA DEVI MAHAVIDHALAYA BHASDHA TANDA AMBEDKARNAGAR",
  "MAHARANA PRATAP COLLEGE OF PHARMACY RAMDASPUR MAJHOLI POST DHRETHADASHRATHPUR TEHSIL BIKAPUR",
  "CHANDRABHAN SINGH DEGREE COLLEGE FACULTY OF PHARMACY CHANDPUR,GONAPAR,JAUNPUR",
  "BABU RAMESHWAR DAYAL INSTITUTE OF MEDICAL SCIENCE",
  "SATYA EYE HOSPITAL & RESEARCH INSTITUTE",
  "DAMODAR COLLEGE OF PHARMACY",
  "BHAGIRATHI COLLEGE OF PHARMACY",
  "AKSH COLLEGE OF PHARMACY",
  "DR. OM PRAKASH SCHOOL OF EDUCATION",
  "SHRI GANESHI LAL GUPTA MEMORIAL DEGREE COLLEGE",
  "AWADH NARAYAN PHARMACY COLLEGE NAYANSAND JAUNPUR",
  "SMT TRIMULA MANJU SHUKLA INSTITUTE OF TEACHERS EDUCATION SHEKHUPUR GAURA RANIGANJ PRATAPGRAH",
  "SHRI CHHAVI NATH SINGH COLLEGE OF PHARMACY",
  "SARVAJANIK PHARMACY COLLEGE",
  "RANI GANESH KUNWARI COLLEGE OF PHARMACY JAMO",
  "SETH PREM CHANDRA OM SHREE GUPTA EDUCATION AGSAULI SIKANDRA RAO HATHRAS",
  "HANUMANT PAL COLLEGE OF PHARMACY",
  "VNS COLLEGE OF PHARMACY THAURI AMETHI",
  "SWAMINATH MAHAVIDYALAY D PHARM",
  "RUMA BTC COLLEGE",
  "GRAMODDHAR SIKSHAN PRASHIKSHAN MAHAVIDYALAYA",
  "KANISHKA EDUCATIONAL INSTITUTE AND MANAGEMENT",
  "ST MICHAELS SCHOOL",
  "RAMAPATI VAIDHYA SHIKSHA AVM PRASHIKSHAN SANSTHAN",
  "SHRI BHOOPAL SINGH SBS COLLEGE OF PHARMACY",
  "SHREE MANSA RAM BRAMHA JI COLLEGE OF PHARMACY BAHADURPUR MARYADPUR MAU",
  "RAM SUBHAG SMARAK PRASHIKSHAN MAHAVIDYALAY GAHOOKHOR",
  "SMT RAMSAKHI COLLEGE LOHABAJ GARSAN, SHIKOHABAD, FIROZABAD",
  "RADHA KRISHNA COLLEGE OF EDUCATION",
  "B P COLLEGE OF PHARMACY GAURA UPARWAR CHAUBEYPUR VARANASI",
  "SHRI BALRAM SINGH MAHAVIDYALAYA MALAK MOINUDDIN UPARHAR CHAYAL KAUSHAMBI",
  "SHRI RAM CHANDRA DEGREE COLLEGE",
  "F S INSTITUTE",
  "JIUT DAS VIDYALAYA,  CHAINPUR,  SADAT, GHAZIPUR",
  "HARISH CHANDRA VIDYALAYA, SADAT,  JAKHANIYA, GHAZIPUR",
  "RAMA DEVI SHIV MANGAL PRASHAD COLLEGE OF PHARMACY",
  "SURYA COLLEGE OF PHARMACY MEERGANJ KHALILABAD SANT KABIR NAGAR",
  "SHIVGYAN PHARMACY COLLEGE",
  "ADARSH POLYTECHNIC, GHAZIPUR",
  "SAMRAT PRATHVIRAJ CHAUHAN MAHAVIDHYALAYA GHITAULI MAINPURI",
  "MAA GULAB KALI BHARGAVA COLLEGE OF PHARMACY KAUSAMBI",
  "BABU VASUDEO COLLEGE OF PHARMACY",
  "ABHAY PRATAP SINGH INTERNATIONAL SCHOOL SHAHZADPUR BAHADURPUR KHAGA FATEHPUR",
  "PANDIT ASHOK KUMAR MISHRA INSTITUTE OF MEDICAL SCIENCE",
  "A R INSTITUTE OF PHARMACY",
  "HSD SHIKHSAK PRASHIKSHAN MAHAVIDHYALAY BHANSOD BALAY PAHAD HALIYA MIRZAPUR",
  "RPS COLLEGE OF PHARMACY KAMALUDDINPUR SAUSARWAN MAU",
  "SHIVA INSTITUTE OF HIGHER EDUCATION, GHAZIPUR",
  "HARISH  CHAND  MAHAVIDYALAYA,  MAUDHIYA,  JAKHANIYA,  GHAIZPUR",
  "SURYA INSTITUTE OF PHARMACY, GHINAHAPUR AZAMGARH",
  "I S INSTITUTE OF PHARMACY",
  "VIDYA COLLEGE OF PHARMACY, FARIDPUR, BAREILLY",
  "ACADEMIC DIVISION OF NCHMCT",
  "VIJAY COLLEGE OF EDUCATION DAULAT NAGAR JAKHANIYA  GHAZIPUR",
  "T S MISRA COLLEGE OF PARAMEDICAL SCIENCES",
  "SHRADDHA SHANKAR SHIKSHAN PRASIKSHAN SANSTHAN PLOT NO EIGHT HUNDRED TEN MIRZAPUR AHIRAULI JAUNPUR",
  "KRIPALU INSTITUTE OF BIOMEDICAL SCIENCES AND RESEARCH RAEBARELI",
  "MAHRISHI MOOL CHAND YADAV SHIKSHA EVAM PRASHIKSHAN SANSTHAN NADAULI KERAKAT",
  "SHRI DEVI DEEN SINGH NURSING COLLEGE",
  "NIRMAL INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES RAEBARELI",
  "GLOBAL EYE INSTITUTE OF OPTOMETRY AND ORTHOPTICS RESEARCH CENTER BAI KA BAGH PRAYAGRAJ",
  "SHRI THAKUR JI MAHARAJ PHARMACY COLLEGE SAFIPUR UNNAO",
  "SHIVALIK  MAHAVAVIDYALAYA COLLEGE OF PHARMACY , SHRAVASTI",
  "RAM LAKHAN SINGH PHARMACY COLLEGE JAUNPUR",
  "RAM BARAN SINGH COLLEGE OF PHARMACY",
  "PT MAHAVIR PRASAD SARASWAT PHARMACY AND NURSING COLLEGE",
  "BABU VISHANU PRATAP SINGH COLLEGE OF NURSING AND PHARMACY",
  "S R HOSPITAL AND PARAMEDICAL COLLEGE, SANT KABIR NAGAR",
  "PRAKHAR COLLEGE OF PHARMACY, HARDOI",
  "RAM NARESH NANHAKU INSTITUTE OF SODH EVAM PRASHIKSHAN TRUST, GELWARA JAFARPUR AZAMGARH",
  "RAMJEET SANSTHAN BTC, PLOT NO THIRTY FIVE, SEVENTEEN, TADAWA, KHANPUR, SAIDPUR, GHAZIPUR",
  "MAA DHANAWATI MAHAVIDYALAYA SHIKSHAK PRASHIKSHAN SANSTHAN, SINGHPUR AZAMGARH",
  "KAPILANAND INSTITUTE OF PROFESSIONAL STUDIES TIKRI AMETHI",
  "SHRI BALDEO COLLEGE OF NURSING AND MEDICAL RESEARCH",
  "DISTRICT INSTITUTE OF EDUCATION & TRAINING GONDA",
  "SANJAY GANDHI COLLEGE OF PHARMACY, SULTANPUR",
  "SHRI BABU NANDAN PHARMACY INSTITUTE",
  "RAJENDRA COLLEGE OF PHARMACY BAIRAMPUR BINDKI FATEHPUR",
  "LAXMI SHOBHA EDUCATIONAL INSTITUTE VIDYAKUND AYODHYA",
  "HARISH INSTITUTE OF NURSING AND PARAMEDICAL SCIENCES",
  "FACULTY OF NURSING AND PARAMEDICAL, MAHAYOGI GORAKHNATH UNIVERSITY GORAKHPUR",
  "R L INSTITUTE OF PHARMACY, VARANASI",
  "SSD COLLEGE OF PHARMACY, BULANDSHAHR",
  "KAILASH NATH YADAV COLLEGE OF PHARMACY JAUNPUR",
  "DR AMBEDKAR PHARMACY COLLEGE, JAUNPUR",
  "JNM COLLEGE OF PHARMACY, LALPUR, MEERAPUR, BASAHI, VARANASI",
  "BHUSHAN COLLEGE OF PHARMACY, SITAPUR",
  "SARVODAYA MAHAVIDYALAY RAJMATIPUR SANGIPUR",
  "OM BUDHESHWARNATH R S V S COLLEGE OF PHARMACY",
  "MATA DHIRAJI COLLEGE OF PHARMACY, AZAMGARH",
  "SHRI BAJRANG SHIKSHAN PRASHIKSHAN COLLEGE",
  "MATA RAJRANI MAHILA MAHAVIDLAYA PURE FAKEER BELSAR GONDA",
  "MAHATMA JAGJEEVAN SAHAB SHIKSHAN PRASHIKSHAN SANSTHAN, TANDWA POST AMANIGANJ AYODHYA",
  "MAA SHARDA MAHAVIDYALAY SHAHGANJ JAUNPUR",
  "MAA DURGA JI MAHAVIDYALAYA SODSAR FAIZULLAHPUR MAU",
  "LALLAN R TIWARI TEACHER TRAINING INSTITUTE SAKALDIHA CHANDAULI",
  "KRISHAK SHIKSHAN EVAM PRASHIKSHAN MAHAVIDYALAYA, KOERIYAPAR MAU",
  "JATADHARI SHIKSHAN PRASIKSHAN MAHAVIDYALAYA",
  "JATADHARI MAHILA MAHAVIDYALAYA",
  "JAGARNATH JI SHIKSHAN AVAM PRASHIKSHAN SANSTHAN, NIMAUPUR, MAU",
  "INDU PRAKASH SHIKSHAN PRASHIKSHAN SANSTAHN MAU",
  "IDEAL DEGREE COLLEGE",
  "GYANODAYA SAMEKIT SANSHAN, JAGDISHPUR PHULPUR AZAMGARH",
  "GULAB SINGH BELA SINGH COLLEGE OF EDUCATION ANDAVA PRAYAGRAJ",
  "G S YADAV COLLEGE OF EDUCATION",
  "GAURAV B T C COLLEGE DHARSAUNA KATARI VARANASI",
  "GANPATI COLLEGE OF EDUCATION, AGRA",
  "PT UMAKANT COLLEGE OF PHARMACY AZAMAGRH",
  "DIVINE COLLEGE OF TEACHER TRAINING",
  "FUTURE INSTITUTE OF TECHNOLOGY, KALAKHURI, KHURJA, BULANDSHAHR",
  "ANUPAMA RAI MEMORIAL AYURVEDIC PHARMACIST YEVM AYURVEDIC NURSING COLLEGE HARAIRAMPUR AZAMGARH",
  "KIRAN SOCIETY",
  "NEETA DEVI MAHILA MAHAVIDYALAY",
  "MAA SHARDA COLLEGE OF PHARMACY AZAMGARH",
  " S R D EDUCATIONAL OF COLLEGE ",
  "DHANVANTRI COLLEGE OF PHARMACY, MATHURA",
  "DURGA PHARMACY COLLEGE, BARABANKI",
  "R.L.T. INSTITUTE OF PHARMACEUTICAL SCIENCE & TECHNOLOGY EKDIL",
  "RAJESH KUMAR SADHANA DEVI MAHAVIDYALAY, DHUMARI, TEHSIL ALIGANJ DIST ETAH",
  "PMT INSTITUTE OF MEDICAL SCIENCES, AYODHYA",
  "JYOTI INSTITUTE OF PHARMACY,DABHAV,DANDI,REWA ROAD,NAINI,PRAYAGRAJ",
  "G D MEMORIAL OF PHARMACY MADIHAN MIRZAPUR",
  "SHRI SAHDEV PAUDHARIYA POLYTECHNIC COLLEGE",
  "GAUTAM BUDDH COLLEGE OF PHARMACY AONLA BAREILLY",
  "RAMARPIT COLLEGE OF PHARMACY, BARABANKI",
  "MAA GANGA DEVI DIVYANG SEVA SANSTHAN",
  "VIDUSHI INSTITUTE OF PARAMEDICAL SCIENCES AND NURSING",
  "SWAMI KALYAN DEV COLLEGE OF PHARMACY",
  "R K S INSTITUTE OF PHARMACY",
  "RESHAMI SONANCHAL COLLEGE OF PHARMACY",
  "INTEGRATED ACADEMY OF MANAGEMENT AND TECHNOLOGY ADHYATMIK NAGAR INSTITUTIONAL AREA GHAZIABAD",
  "SHRI BALAJI MAHARAJ MAHAVIDYALYA, MADHOGANJ HARDOI",
  "S R COLLEGE OF PHARMACY, SONBHADRA ",
  "DUDHNATH PHARMACY COLLEGE  GHAZIPUR",
  "NIRMAL MUNCHANI PHARMACY COLLEGE NASIRPUR , HANSRAJPUR GHAZIPUR",
  "SIMS COLLEGE OF PHARMACY",
  "THE SUN SHINE COLLEGE OF PHARMACY, GHAZIPUR",
  "ALL INDIA CHILDREN CARE & EDUCATION DEVELOPMENT SOCIETY AZAMGARH",
  "BHOLE SHANKAR COLLEGE",
  "DR APJ ABDUL KALAM COLLEGE OF EDUCATION",
  "ADARSH POLYTECHNIC COLLEGE",
  "MAHARANI LAXMI BAI COLLEGE OF PHARMACY FATTEHPUR BHAU POST SINGHPUR SANI DISTRICT  SAMBHAL",
  "K L S POLYTECHNIC COLLEGE BIJNOR",
  "GAGAN COLLEGE OF PHARMACY GABHANA ALIGARH",
  "JMC INSTITUTE OF MEDICAL SCIENCES",
  "MAHALAXMI PARAMEDICAL COLLEGE AND HOSPITAL",
  "BHAGWAN MAHAVEER COLLEGE OF EDUCATIONM VILL-POHALLI, P.O.-NANU, TEHSIL-SARDHANA, MEERUT.",
  "GRAMODAYA COLLEGE OF MEDICAL SCIENCES",
  "SMT VIMLA SINGH MEMORIAL COLLEGE OF MEDICAL SCIENCE",
  "TAPASTHALI COLLEGE OF MEDICAL SCIENCE",
  "PRABHADEVI MAHILA MAHAVIDHALAY  MANIRAM GORAKHPUR ",
  "SHRI RAM JANKI COLLGE OF PHARMACY",
  "THAKUR SATYA NARAYAN INSTITUTE OF PHARMACY",
  "N D COLLEGE OF PHARMACY",
  "RP AND UR SINGH INSTITUTE OF PHARMACY",
  "R K COLLEGE OF PHARMACY",
  "CKSM COLLEGE OF PHARMACY UNNAO",
  "MAHARISHI COLLEGE OF PHARMACY",
  "JMS PHARMACY COLLEGE",
  "BABA JEET NARAYAN CHAND PHARMACY COLLEGE",
  "ROOTS COLLEGE OF PHARMACY",
  "KRISHNA INSTITUTE OF POLYTECHNIC",
  "ENGINEERING AND MANAGEMENT INSTITUTE OF INDIA",
  "APEX PARAMEDICAL INSTITUTE VARANASI",
  "SHRI RAM COLLEGE OF PHARMACY, GHAZIPUR",
  "KALAWATI COLLEGE OF PHARMACY GORHA KASGANJ U P",
  "GANGA SEWA SADAN NURSING AND PARAMEDICAL COLLEGE, VARANASI",
  "CHOUDHARY SURESH SINGH PHARMACY COLLEGE",
  "UMRAW PHARMACY COLLEGE",
  "ROHILKHAND COLLEGE OF PARAMEDICAL SCIENCES, BAREILLY",
  "SANTOSH COLLEGE OF PHARMACY",
  "DR AVANI COLLEGE OF PHARMACY",
  "BABU KAILASH PRASAD COLLEGE OF PHARMACY SAWREJI KHARAG BELWA BAZAR DEORIA",
  "MATA SARASWATI PHARMACY SANSTHAN, AZAMGARH",
  "KAMLA DEVI INSTITUTE OF PHARMACY TILAI BELWA DEORIA",
  "RUHELKHAND SCHOOL OF NURSING, BAREILLY",
  "MM COLLEGE OF PHARMACY AMBEDKAR NAGAR",
  "SHRI TRIMBAKESHWAR PHARMACY COLLEGE AZAMGARH",
  "SUGWANTI SHAMBHUNATH SMARAK PHARMACY COLLEGE KAJHA MAU",
  "S N S K INSTITUTE OF PHARMACY",
  "SHRI MAHAKALESHWAR PHARMACY COLLEGE BASIRHA AZAMGARH",
  "UNITED COLLEGE OF PHARMACY",
  "RAGHUWAR DAYAL PRABHU DAYAL INSTITUTE",
  "JAI NARAYAN HOMOEOPATHIC PHARMACY COLLEGE, SEHRA, KARCHHANA, ALLAHABAD",
  "RB INSTITUTE OF MEDICAL SCIENCES",
  "RAMDEV RAMHARSH COLLEGE OF PHARMACY JAMIN ATAULLAH CHIRAIYAKOT MAU",
  "DEEN BANDHU COLLEGE OF PHARMACY",
  "KS INSTITUTE OF MEDICAL SCIENCES",
  "GURU NANAK PHARMACY COLLEGE, BIJNOR",
  "SHRI DINESH CHANDRA GEETA COLLEGE OF PHARMACY BARUWADIH BAIKUNTHPUR DEORIA",
  "SHANKAR HOSPITAL GORAKHPUR",
  "MAA URMILA DEVI COLLEGE OF PHARMACY RAMPUR MUKUND DEORIA",
  "SHIVAJI COLLEGE OF PHARMACY",
  "T. C. EYE PARAMEDICAL INSTITUTE OF OPTOMETRY, LUCKNOW",
  "SAKUNTALA MEMORIAL AYURVEDIK PHARMACIST AVOM NURSING COLLEGE",
  "VIDYAWATI PHARMACY COLLEGE JAUNPUR",
  "SWATANTRATA SENANI CHHANGUR TRIPATHI INSTITUTE OF PHARMACY",
  "RAJENDRA BABU COLLEGE OF PHARMACY BANKATIYA DUBEY PACHRUKHIYA DEORIA",
  "R B COLLEGE OF PHARMACY ETAWAH",
  "KIRAN SINGH PHARMACY COLLEGE",
  "UJJWAL PHARMACY COLLEGE",
  "BAL GOPAL COLLEGE OF PHARMACY OJHIPUR GHAZIPUR",
  "PLATINUM INSTITUTE OF PHARMACY",
  "SW SUNDER LAL SHIVHARE COLLEGE OF PHARMACY",
  "AMBIKA RAM DEVI COLLEGE OF PHARMACY, BASTI",
  "BADRI RAI MAHAVIDYALAYA DUBAULI LAKURI NISFI RAI GORAKHPUR",
  "K. R. B. COLLEGE IN PHARMACY",
  "ANKALIKAR VANI MASIK PATRIKA SAMITI B T C COLLEGE PARASANI ETAWAH",
  "SUBHASH CHANDRA BOSE COLLEGE OF PHARMACY",
  "ARVIND PHARMACY COLLEGE HARDOI",
  "MAA SHARDA COLLEGE OF PHARMACY",
  "BABA VISHWANATH COLLEGE OF PHARMACY, JAUNPUR",
  "RAMMURTI INSTITUTE OF PHARMACY, JAUNPUR",
  "A B PHARMACY COLLEGE KANNAUJ",
  "SHRI RAGHURAJ SINGH MEMORIAL COLLEGE OF PHARMACY",
  "CHAUDHARY BECHELAL COLLEGE OF PHARMACY",
  "RAMA AGRAHARI SCHOOL OF NURSING FATEHPUR",
  "SUN INSTITUTE OF MEDICAL SCIENCES JAUNPUR",
  "RAM KRISHNA VAIBHAV COLLEGE OF PHARMACY, AZAMGARH",
  "MAA DURGA JI COLLEGE OF PHARMACY, AZAMGARH",
  "GANPATI COLLEGE OF PHARMACY, AZAMGARH",
  "VINEETA DEVI SMARAK COLLEGE OF PHARMACY",
  "MAA SARASWATI SHIKSHAN PRASHIKSHAN SANSTHAN AMADARVESHPUR AMBEDKARNAGAR",
  "DSM COLLEGE OF PHARMACY",
  "JEEVAN JYOTI PARAMEDICAL INSTITUTE",
  "SHRI RAM SANSKRIT MAHAVIDYALAY PHARMACY COLLEGE, JAUNPUR",
  "SHRI RAM COLLEGE OF NURSING AND PHARMACY SIKHADI GHAZIPUR",
  "SRLT INSTITUTE OF PHARMACY AND MANAGEMENT",
  "S P COLLEGE OF PHARMACY",
  "SWARGIYA RAMVILASH SINGH SHIKSHAN SANSTHA PHARMACY COLLEGE",
  "A B COLLEGE OF PHARMACY",
  "GOVT POLYTECHNIC SHARDHANA MEERUT",
  "SRI SHARDA COLLEGE OF PHARMACY",
  "MAA VINDHYAVASINI YASHOMATI VIDYAWATI BALIKA SHIKSHAN PRASHIKSHAN SANSTHAN SANT NAGAR MOHLI AYODHYA",
  "S N S K INSTITUTE OF NURSING AND PARAMEDICAL",
  "DEV COLLEGE OF PHARMACY",
  "AIMS PHARMACY COLLEGE , GAJRAULA AMROHA",
  "MS BHARTIYA COLLEGE OF PHARMACY",
  "SUGAMYA DED COLLEGE RUN SUGAMYA SOCIETY FOR THE WELFARE OF DIVYANGJAN AYODHYA UP",
  "AWAM SPECIAL TEACHERS TRAINING COLLEGE",
  "UTKARSH INSTITUTE OF PHARMACY",
  "PT RAJAT RAJAN MAHILA BTC COLLEGE",
  "MERIDIAN NURSING AND PARAMEDICAL COLLEGE VARANASI",
  "L P S GROUP OF INSTITUTE AND MANAGEMENT COLLEGE AONLA BAREILLY",
  "KAMLA PRASHIKSHAN SANSTHAN",
  "SAMARTH FOUNDATION",
  "HARRAIYA COLLEGE OF PHARMACY",
  "PURVANCHAL SHIKSHA SAMITI",
  "JEEVANDHARA REHABILITATION RESEARCH INSTITUTE",
  "SARLA DEVI SRIRAM VIDYALYA PHARRMACY FATEHPUR",
  "USHA CHARITABLE TRUST",
  "DR SMT MAHADEVI EDUCATIONAL WELFARE EVAM SHODH SANSTHAN",
  "CBSM PRATAPGARH",
  "BS COLLEGE OF PHARMACY",
  "THE ADVANCE SOCIETY FOR BRIGHT WAY INSTITUTE",
  "PT JAMUNA PRASAD INSTITUTE OF PHARMACY",
  "ABHAYDEEP DIVYANG SHIKSHAN PRASHIKSHAN SANSTHAN",
  "SHRI RAM JANKI SHIKSHAN PRASHIKSHAN MAHAVIDYALAY",
  "CM INSTITUTE OF PARAMEDICAL SCIENCES",
  "GRAMODAYA SHIKSHAN PRASHIKSHAN MAHAVIDYALAY",
  "LADDAN TEACHER TRAINING COLLEGE DHURRWAN JALALPUR HANDIYA PRAYAGRAJ",
  "BABU TIRTHRAJ EDUCATIONAL INSTITUTE KAURAHI AMBEDKAR NAGAR",
  "MAA ASHA GYANDEEP COLLEGE OF PHARMACY, JAUNPUR",
  "MAA GOMTI KALYAN SEWA SAMITI",
  "DEV WELFARE AND EDUCATION FOUNDATION HAZIPUR SINGHPUR MUMTAJ NAGAR AYODHYA",
  "CHAITANYA BHARAT PHARMACY COLLEGE",
  "PURVANCHAL B T C TRAINING COLLEGE MUNDERWA BASTI",
  "DIVINE COLLEGE OF TEACHERS TRAINING BARDHA BHIURA SONGAONAKBARPUR AMBEDKAR NAGAR",
  "ARYA RAMRATI DEVI PHARMACY COLLEGE AZAMGARH",
  "SRI RAM SAHAY SINGH KANYA MAHAVIDALYA",
  "SHRI BABU LAL VERMA AYURVEDIC PHARMASIST AND UPCHARIKA PARAMEDICAL COLLEGE MOHIUDDINPUR BALYA JAGDISHPUR TANDA AMBEDKAR NAGAR",
  "ST MOTHER TERESA COLLEGE OF PHARMACY",
  "BRIJRAJ SMARAK PHARMACY COLLEGE",
  "BABU DARSHAN SINGH SHIVRAM SINGH PHARMACY COLLEGE",
  "D S PHARMACY COLLEGE",
  "A S YADAV COLLEGE OF TEACHER EDUCATION, GORARI, VIKRAMPUR, SAIDPUR, GHAZIPUR",
  "SCHOOL OF NURSING CHRISTIAN HOSPITAL",
  "PT AK SHARMA COLLEGE OF PHARMACY",
  "ISLAMPUR GOVERNMENT POLYTECHNIC",
  "GLORIOUS INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "CHARNOK SCHOOL OF NURSING TEGHORIA, KOLKATA",
  "CHAPRA PRIMARY TEACHERS TRAINING INSTITUTE NADIA",
  "DAINHAT JOY MATARA PRIMARY TEACHERS TRAINING INSTITUTE BURDWAN",
  "ARISTOTLE COLLEGE OF EDUCATION",
  "INTERNATIONAL MANAGEMENT INSTITUTE KOLKATA SOUTH 24 PARGANAS",
  "CHARAKTALA D. ED. COLLEGE",
  "NAVJEEVAN SCHOOL OF NURSING DARJEELING",
  "INTERNATIONAL INSTITUTE OF HOTEL MAGEMENT NORTH 24 PARGANAS",
  "MASS EDUCATION PRIMARY TEACHERS TRAINING INSTITUTE SOUTH 24 PARGNAS",
  "AMS COLLEGE OF PHARMACY",
  "Memari Govt. Polytechnic",
  "VIDYASAGAR BASIC COLLEGE",
  "BUNDWAN POLYTECHNIC PURULIA",
  "INSTITUTE OF SCIENCE & TECHNOLOGY PASCHIM MEDINIPUR",
  "BCDA COLLEGE OF PHARMACY and TECHNOLOGY CAMPUS 2",
  "AURANGABAD PRIMARY TEACHERS TRAINING INSTITUTE AURANGABAD",
  "GENEX NURSING INSTITUTE",
  "ABS ACADEMY OF POLYTECHNIC",
  "VIVEKANANDA COLLEGE OF PHARMACY",
  "BANKURA PRIMARY TEACHERS TRAINING INSTITUTE",
  "BCARE INSTITUTE OF MANAGEMENT & TECHNOLOGY (POLYTECHNIC) MURSHIDABAD",
  "BASANTIKA INSTITUTE OF ENGINEERING & TECHNOLOGY BIRBHUM",
  "SEACOM PHARMACEUTICAL COLLEGE",
  "NATHULAL DAS PRIMARY TEACHERS TRAINING INSTITUTE MURSHIDABAD",
  "ANNAPURNA NURSING INSTITUTE",
  "BARUIPUR GOVERNMENT POLYTECHNIC",
  "AL HERA COLLEGE OF PHARMACY",
  "TECHNO POLYTECHNIC DURGAPUR",
  "INSTITUTE OF PHARMACY BANKURA",
  "PAILAN TECHNICAL CAMPUS",
  "SARADA INSTITUTE OF TEACHER EDUCATION",
  "UPASAM NURSING ACADEMY",
  "SUKANTA TEACHER TRAINING INSTITUTION",
  "Abdur Rahaman PTTI",
  "ASANSOL INSTITUTE OF ENGINEERING AND  MANAGEMENT - POLYTECHNIC",
  "NURSING TRAINING SCHOOL ASANSOL",
  "DURGAPUR POLYTECHNIC COLLEGE",
  "DR B C ROY POLYTECHNIC",
  "Desun Nursing School",
  "Contai D.Ed. College",
  "CHUYAPARA SWAMI VIVEKANANDA PRIMARY TEACHERS TRAINING COLLEGE",
  "GANGADHARPUR SIKSHAN MANDIR HOWRAH",
  "M R BANGUR HOSPITAL KOLKATTA",
  "School of Nursing, Jangipur Sub Divisional Hospital",
  "RAMAKRISHNA SARADA MISSION MATRI BHAVAN",
  "JN KONAR COLLEGE OF PHARMACY",
  "NIBEDITA PHARMACY COLLEGE",
  "SCHOOL OF NURSING IPGME&R SSKM HOSPITAL KOLKATA",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, HOOGHLY",
  "BHAGAWAN PRASAD NURSING INSTITUTE",
  "SSKM COLLEGE OF PHARMACY",
  "INSTITUTE OF PARAMEDICAL SCIENCES AND RESEARCH",
  "TOT SOL EDUCATIONAL ACADEMY, PHARMACY",
  "SHREE RAMAKRISHNA GOVT SPONSORED PRIMARY TEACHERS TRAINING INSTITUTE",
  "MANBHUM INSTITUTE OF NURSING AND MEDICAL SCIENCES",
  "BARDHAMAN INSTITUTE OF NURSING",
  "AGNIBINA SCHOOL OF PHARMACY",
  "RIZIA BIBI SCHOOL OF EDUCATION",
  "SIKSHA CHARCHA GOVERNMENT SPONSORED PRIMARY TEACHERS TRAINING INSTITUTE",
  "DEBNATH NURSING TRAINING INSTITUTE",
  "SKM INSTITUTE OF PHARMACEUTICAL SCIENCES AND RESEARCH",
  "NORTH BENGAL HANDICAPPED REHABILITATION SOCIETY",
  "SALKIA GOVERNMENT SPONSORED PRIMARY TEACHERS TRAINING INSTITUTE",
  "CHITTARANJAN TEACHERS TRAINING INSTITUTE",
  "NORTH POINT NURSING INSTITUTE",
  "SAMAJKALYAN PARAMEDICAL COLLEGE",
  "SANTINIKETAN POLYTECHNIC",
  "PANDUA COLLEGE OF PHARMACEUTICAL TECHNOLOGY",
  "NTS R G KAR MEDICAL COLLEGE AND HOSPITAL KOLKATTA",
  "STATE INSTITUTE OF HOTEL MANAGEMENT DURGAPUR",
  "RAJIB GANDHI MEMORIAL PRIMARY TEACHERS TRAINING INSTITUTE",
  "NEWTOWN INSTITUTE OF NURSING SCIENCE",
  "MRITYUNJOY ASHUTOSH COLLEGE OF EDUCATION",
  "MANISHA NURSING INSTITUTE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING",
  "BISHNUPUR PUBLIC INSTITUTE OF MEDICAL SCIENCE",
  "CHAKDAHA VIDYASAGAR PRIMARY TEACHERS TRAINING COLLEGE",
  "DMBH SCHOOL OF NURSING",
  "SEBA INSTITUTE OF NURSING",
  "SHARANYA SCHOOL OF NURSING",
  "AEROSPACE RESEARCH AND DEVELOPMENT CENTRE",
  "NIVEDITA PHARMACY COLLEGE    ",
  "MAA MANASHA COLLEGE OF PHARMACY    ",
  "EKTA COLLEGE OF PHARMACY    ",
  "RAIGANJ NIGHTINGALE INSTITUTE OF NURSING SCIENCES",
  "SISTER NIVEDITA NURSING ACADEMY",
  "PROMOTEES TRAINING SCHOOL",
  "DR H C MUKHERJEE MEMORIAL HEALTH SCHOOL",
  "MINERVA SCHOOL OF NURSING",
  "S B SCHOOL OF NURSING",
  "DUMKAL POLYTECHNIC MURSHIDABAD",
  "SILIGURI BODHI BHARATI VOCATIONAL INSTITUTE",
  "BENGAL COUNCIL FOR ALLIED AND HEALTHCARE PROFESSIONS",
  "NATIONAL COUNCIL OF MEDICAL AND PARAMEDICAL SCIENCES",
  "DR BETHUNE INSTITUTE OF NURSING",
  "GITANGSHU INSTITUTE OF NURSING SCIENCES",
  "TARAI AND DOOARS SPECIAL EDUCATION TRAINING COLLEGE",
  "RANGAMATI INSTITUTE OF NURSING",
  "KABIGURU COLLEGE OF EDUCATION",
  "RADHANAGAR GOVERNMENT  PRIMARY TEACHERS TRAINING INSTITUTE",
  "ULUBERIA GOVERNMENT POLYTECHNIC",
  "SADHANA MEMORIAL SCHOOL OF NURSING KOLKATTA",
  "DPMI SILIGURI",
  "SILIGURI INSTITUTE OF TECHNOLOGY DIPLOMA COLLEGE",
  "GURU NANAK INSTITUTE OF HOTEL MANAGEMENT, KOLKATA",
  "ARYABHATTA INSTITUTE OF ENGINEERING AND MANAGEMENT DURGAPUR",
  "ITAHAR GOVERNMENT POLYTECHNIC",
  "FLEMMING COLLEGE OF PHARMACY",
  "shyampahari Govt PTTI",
  "Nursing Training School ID  AND BG Hospital",
  "HEALING TOUCH INSTITUTE OF NURSING",
  "KALIACHAK GOVT POLYTECHNIC",
  "KARIMPUR PRIMARY TEACHERS TRAINING INSTITUTE",
  "Seacom Pharmacy College",
  "ISLAMIA HOSPITAL,INSTITUTE OF PARAMEDICAL STUDIES",
  "UTTAR BANGA PRIMARY TEACHERS TRAINING INSTITUTE MALDA",
  "ACHARYA RAMENDRA SUNDAR PRIMARY TEACHERS TRAINING INSTITUTE BIRBHUM",
  "LALITA BARIK MEMORIAL INSTITUTE PHARMACY COLLEGE    ",
  "MODEL PRIMARY TEACHERS TRAINING INSTITUTE MURSHIDABAD",
  "KSHUDIRAM BOSE COLLEGE OF PHARMACY",
  "GHOLDIGRUI SIKSHAN MANDIR  D EL ED SECTION",
  "ABL INSTITUTE OF PHARMACY",
  "BRIGHT INSTITUTE OF NURSING",
  "SSIT COLLEGE OF MANAGEMENT AND ALLIED HEALTH SCIENCES",
  "COSMOS INSTITUTE OF PHARMACEUTICAL SCIENCE    ",
  "DR ABUL HOSSAIN BISWAS INSTITUTE OF PHARMACY",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING CHHANDAR BANKURA",
  "ADAMANT COLLEGE OF PHARMACY    ",
  "Prabhat Jyotirmoyee College of Education",
  "BASUNDHARA PHARMACY COLLEGE    ",
  "TERAI NURSING INSTITUTE",
  "District Institute of Education and Training, Howrah",
  "SANJIBAN SCHOOL OF NURSING",
  "MAHABHASKAR NURSING INSTITUTE",
  "UTTAR DINAJPUR H M PHARMACY COLLEGE",
  "SANTINIKETAN COLLEGE OF ARCHITECTURE",
  "PRATIMA INSTITUTE OF PHARMACY",
  "ESI HOSPITAL SEALDAH",
  "KADAMBINI DEVI OSG NURSING INSTITUTE",
  "BARASAT INSTITUTE OF NURSING SCIENCES",
  "TEESTA NURSING INSITITUTE",
  "MONALISA INSTITUTE OF MEDICAL SCIENCE",
  "ISWAR CHANDRA VIDYASAGAR POLYTECHNIC, JHARGRAM",
  "CHITTARANJAN SAMRITI PRIMARY TEACHER TRAINING INSTITUTE RAIGANJ",
  "ANM R TRAINING SCHOOL VIDYASAGAR S G HOSPITAL BEHALA KOLKATA",
  "ICH FACULTY OF NURSING",
  "PURULIA GOVT SPOND PRIMARY TEACHERS TRAINING INSTITUTE",
  "NATIONAL INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH KOLKATA",
  "Krishnagar Govt. Primary Teachers Training Institute",
  "R P COLLEGE OF PHARMACY",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, UTTAR DINAJPUR",
  "Midnapore government Primary Teacher Training Institute for Women",
  "LORETO ST. MARYS RC PTTI",
  "PANAGARH PRIMARY TEACHERS TRAINING INSTITUTE",
  "Saraswati School of Education",
  "Calcutta Women Primary Teachers Training Institute",
  "AZAD D.ED TRAINING COLLEGE",
  "BANKURA SAMMILANI MEDICAL COLEGE HOSPITAL BANKURA",
  "NARASINGHAPUR PRIMARY TEACHER TRAINING INSTITUTE MURSHIDABAD",
  "BISHNUPUR PUBLIC B.Ed. COLLEGE",
  "Adyapeath Monikuntala Primary Teachers Training Institute",
  "KRISHNA COLLEGE OF PHARMACY",
  "JALADHAR DEY PRIMARY TEACHERS TRAINING INSTITUTE",
  "NALHATI GOVERNMENT POLYTECHNIC",
  "JHARGRAM BANI BHAVAN E.T.E (D.EL.Ed) INSTITUTION FOR GIRLS",
  "Bara Andulia Govt. Primary Teachers Training Institute",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING (DIET), MALDA",
  "MUKTIR SHIKSHA COLLEGE OF EDUCATION AND PHARMACY",
  "Soiyod Memorial PTTI D.El.Ed",
  "KAMAKHYA INSTITUTE OF EDUCATION",
  "GOURI DEVI TEACHERS TRAINING COLLEGE",
  "LAUDOHA GOVERMENT PRIMARY TEACHERS TRAINING INSTITUTE",
  "Gayeshpur Government Polytechnic",
  "P.N.DAS ACADEMY",
  "DEROZIO PHARMA INSTITUTE",
  "DALI KUNDU PRIMARY TEACHERS TRAINING INSTITUTE",
  "Sarenga Govt. Sponsord P.T.T.I",
  "PARAMEDICAL INSTITUTE OF KOLKATA OF SIGMA INTECH PRIVATE LIMITED",
  "GNM TRAINING SCHOOL, 24 PARGANAS NORTH",
  "BISHNUPUR MALLABHUM B.Ed. COLLEGE",
  "JHELUM INSTITUTE OF NURSING",
  "TAHANURA BENGAL TEACHERS TRAINING COLLEGE D.EL.ED",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, BURDWAN",
  "Alipurduar Nursing Training School",
  "ASHSHEEFA INSTITUTE OF NURSING",
  "RANIBAZAR TEACHERS TRAINING INSTITUTE",
  "DOMOHANA PHARMACY COLLEGE",
  "NIBEDITA POLYTECHNIC",
  "NIBEDITA PHARMACY INSTITUTE",
  "KATWA GOVERNMENT PRIMARY TEACHERS TRAINING INSTITUTE",
  "DHYANESWAR SUBODH COLLEGE",
  "GAIGHATA GOVERNMENT POLYTECHNIC",
  "Renuka Debi College of Education",
  "SARBODAY PUBLIC ACADEMY",
  "MOHITOSH PRIMARY TEACHERS TRAINING INSTITUTE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING",
  "GNM Nursing Training School, Jhargram Government Medical College and Hospital",
  "Its Css and  Ss",
  "ALINAGAR TEACHER S TRAINING COLLEGE",
  "AMBIKA DEVI PRIMARY TEACHERS TRAINING INSTITUTE",
  "SUPREME KNOWLEDGE FOUNDATION GROUP OF INSTITUTIONS",
  "SAYAN MEMORIAL PRIMARY TEACHERS TRAINING INSTITUTE",
  "SONARGAON VIVEKANANDA INSTITUTE FOR PRIMARY TEACHERS TRAINING",
  "TECHNO INDIA POLYTECHNIC",
  "RABINDRA BHAWAN TEACHER TRAINING INSTITUTE",
  "Westbank School of Nursing",
  "Rajganj Government Polytechnic",
  "BERHAMPORE POLYTECHNIC COLLEGE",
  "MIRMADAN MOHANLAL GOVERNMENT POLYTECHNIC",
  "Adyapeath Annada Polytechnic College",
  "GHATAL GOVT.POLYTECHNIC",
  "MEDINIPUR SADAR GOVT. POLYTECHNIC",
  "Nazirpur Teachers Training College",
  "Ratulia Secondary Teachers Training Institute",
  "Moyna Ramkrishnayan Association A Teachers Training Institution",
  "NOBLE TRAINING INSTITUTE",
  "JAKIR HOSSAIN INSTITUTE OF PHARMACY",
  "RANAGHAT GOVERNMENT POLYTECHNIC",
  "UTTARAN INSTITUTE OF MEDICAL SCIENCES",
  "LCG INSTITUTE OF POLYTECHNIC",
  "UPASANA COLLEGE OF PHARMACY",
  "Moyna Vivekananda Mission Teachers Training College",
  "BAGHMUNDI GOVERNMENT POLYTECHNIC",
  "WOODLANDS HOSP. & MEDICAL RESEARCH KOLKATTA",
  "TECHNIQUE POLYTECHNIC INSTITUTE HOOGHLY",
  "WOMEN`S POLYTECHNIC KOLKATA",
  "TARASANKAR BANDHYAPADHYAY PRIMARY TEACHERS TRAINING INSTITUTE BIRBHUM",
  "BASANTIKA COLLEGE OF EDUCATION",
  "TARAKESWAR VIVEKANANDA PALLY SEVA KENDRA HOOGHLY",
  "SANTINIKETAN PHARMACY COLLEGE",
  "BURDWAN MODEL COLLEGE OF PHARMACY",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, KOLKATA",
  "MOYNA PHARMACEUTICAL INSTITUTE",
  "SYLVAN POLYTECHNIC COLLEGE BARDHAMAN",
  "NILANJANA MEMORIAL NURSING ACADEMY",
  "CALCUTTA INSTITUTE OF NURSING SCIENCE",
  "SRIJA COLLEGE OF PHARMACY",
  "WEST BENGAL SURVEY INSTITUTE HOOGHLY",
  "SURI SADAR HOSPITAL BIRBHUM",
  "DEBI COLLEGE OF PHARMACY",
  "KABIGURU COLLEGE OF PHARMACY",
  "ABDUL KASHEM INSTITUTE OF NURSING",
  "SUB-DIVISIONAL HOSPITAL DARJEELING",
  "VIVEKANANDA PRIMARY TEACHER TRAINING INSTITUTE PURBA MEDINIPUR",
  "INDIAN INSTITUTE OF LIVER & DIGESTIVE SCIENCES",
  "SRI AUROBINDO SEVA KENDRA SCHOOL OF NURSING SOUTH 24 PARGANAS",
  "BENGAL COLLEGE OF ENGINEERING AND TECHNOLOGY",
  "MIDNAPORE SCAN CENTRE PRIVATE LIMITED",
  "VIDYASAGAR PRIMARY TEACHER TRAINING INSTITUTE HALDIA",
  "SREE RAMKRISHNA SILPA VIDYAPITH (GOVT POLYTECHNIC) BIRBHUM",
  "J S COLLEGE OF PHARMACY",
  "SILIGURI GOVERNMENT POLYTECHNIC DARJEELING",
  "DR MEGHNAD SAHA INSTITUTE OF TECHNOLOGY HALDIA PURBA MEDINIPUR",
  "VIDYASAGAR PRIMARY TEACHER TRAINING INSTITUTE DURGAPUR",
  "SIDHU KANHU BIRSA POLYTECHNIC PASCHIM MEDINIPUR",
  "MOMTAZ BEGUM PHARMACY COLLEGE",
  "MURSHIDABAD INSTITUTE OF TECHNOLOGY MURSHIDABAD",
  "SHREE RAMKRISHNA INSTITUTE OF SCIENCE & TECHNOLOGY SOUTH 24 PARGANAS",
  "VIDYASAGAR PRIMARY TEACHER TRAINING INSTITUTE DAKSHIN DINAJPUR",
  "SANTINIKETAN D.ED COLLEGE",
  "BUDGE BUDGE INSTITUTE OF NURSING",
  "TAGORE MISSION INSTITUTE OF PHARMACY",
  "L K NURSING INSTITUTE",
  "SHEIKHPARA ABDUR RAHAMAN MEMORIAL POLYTECHNIC MURSHIDABAD",
  "MURARAI GOVERNMENT POLYTECHNIC",
  "RABINDRANATH TAGORE NURSING INSTITUTE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, MURSHIDABAD",
  "DR. ASHUTOSH DAS MEMORIAL PRIMARY TEACHERS TRAINING HOOGHLY",
  "DEBNATH PARAMEDICAL INSTITUTE",
  "MOHAMMAD OSMAN GONI TEACHERS TRAINING INSTITUTE",
  "NORBE MEDICARE PRIVATE LIMITED ",
  "SAHID MATANGINI COLLEGE OF PHARMACY",
  "HOOGHLY COLLEGE OF PHARMACEUTICAL SCIENCES",
  "MISSION OF MERCY SCHOOL OF NURSING KOLKATTA",
  "SCM INSTITUTE OF ENGINEERING AND TECHNOLOGY NORTH 24 PARGANAS",
  "MINERVA POLYTECHNIC MURSHIDABAD",
  "HILLSIDE SCHOOL OF NURSING",
  "ASHOK NILAY INSTITUTE OF NURSING",
  "iWORLD INSTITUTE OF PHARMACY",
  "CENTRAL HOSPITAL, SOUTH EASTERN RAILWAY",
  "ANANDALOKE MEDICAL CENTER PVT LTD SILIGURI",
  "APC COLLEGE OF PHARMACY",
  "CALCUTTA HEART CLINIC AND HOSPITAL",
  "SUPTENDU PHARMACY INSTITUTE",
  "NS COLLEGE OF PHARMACY",
  "KOLKATA INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "MANGO VALLEY PHARMACY COLLEGE",
  "AAMNA COLLEGE OF PHARMACEUTICAL SCIENCE AND RESEARCH CENTRE",
  "ADHAYAN INSTITUTE OF PHARMACY",
  "TARAKESWAR INSTITUTE OF NURSING",
  "NURUL ISLAM COLLEGE OF PHARMACY",
  "BHAGAWAN PRASAD PHARMACY COLLEGE",
  "PANDIT ISWAR CHANDRA VIDYASAGAR COLLEGE OF PHARMACY",
  "NETAJI COLLEGE OF PHARMACY",
  "MAZIDIA ACADEMY OF PHARMACY",
  "IMPERIAL INSTITUTE OF PHARMACY",
  "VANUMOTI D.EL.ED COLLEGE",
  "BENGAL NURSING INSTITUTE",
  "TOSHANI COLLEGE OF PHARMACY",
  "APJ ABDUL KALAM PHARMACEUTICAL TECHNOLOGY",
  "PRABHAT JYOTIRMOYEE PHARMACY COLLEGE",
  "School for Skills in Allied Health Sciences, Suri",
  "AR INSTITUTE OF PARAMEDICAL SCIENCES",
  "KASTURI MEDICAL CENTRE PRIVATE LIMITED",
  "PANDUA PHARMACY COLLEGE",
  "MASAGRAM INSTITUTE OF NURSING",
  "BABUL AND SAHANARA NURSING TRAINING INSTITUTE",
  "SATYAJIT RAY FILM AND TELEVISION INSTITUTE, KOLKATA",
  "JANAKALYAN NURSING INSTITUTE",
  "APJ ABDUL KALAM MEDICAL INSTITUTE",
  "DEBRA INSTITUTE OF NURSING SCIENCE",
  "JIS INSTITUTE OF PHARMACY",
  "SAHAJPATH COLLEGE OF PHARMACY",
  "ANM R TRAINING SCHOOL AND GNM TRAINING SCHOOL,RAGHUNATHPUR SD SS HOSPITAL",
  "M H KHAN COLLEGE OF PHARMACY",
  "CHARAKTALA COLLEGE OF PHARMACY",
  "JRSET COLLEGE OF PHARMACY",
  "DISTRICT HOSPITAL (MIDNAPORE MEDICAL MEDINIPORE",
  "MOTHER TERESA INSTITUTE OF PHARMACY",
  "DARJEELING COLLEGE OF PHARMACY",
  "SAROJ NALINI PRIMARY TEACHERS TRAINING INSTITUTE KOLKATA",
  "ALAKENDU BODH NIKETAN RESIDENTIAL",
  "BANKURA INSTITUTE OF NURSING SCIENCE",
  "DISHA INSTITUTE OF PHARMACY",
  "SAROJ MOHAN INSTITUTE OF TECHNOLOGY HOOGHLY",
  "MEKHLIGANJ NETAJI PRIMARY TEACHER TRAINING INSTITUTE, COOCH BEHAR",
  "SANTINIKETAN INSTITUTE OF POLYTECHNIC BIRBHUM",
  "MD. BAZAR GOVT. SPONSORED PRIMARY TEACHERS TRAINING INSTITUTE KOLKATA",
  "MAYURAKSHI COLLEGE OF PHARMACY",
  "GLOBAL INSTITUTE OF SCIENCE & TECHNOLOGY PURBA MEDINIPUR",
  "DISCOVERY INSTITUTE OF POLYTECHNIC",
  "MBC INSTITUTE OF ENGINEERING & TECHNOLOGY BARDHAMAN",
  "HELAL COLLEGE OF PHARMACY",
  "CREDENCE PHARMACY COLLEGE",
  "MATHURAPUR DED COLLEGE, MURSHIDABAD",
  "GIMAGERIA WELFARE PRIMARY TEACHER’S TRAINING INSTITUTE PURBA MEDENIPUR",
  "DIAMOND HARBOUR GOVERNMENT POLYTECHNIC",
  "MNM INSTITUTE OF NURSING",
  "MALDA POLYTECHNIC MALDA",
  "MAJHIHIRA ASHRAM PRIMARY TEACHERS’ TRAINING INSTITUTE PURULIA",
  "DHATRIGRAM D. ED. COLLEGE",
  "ANP PHARMACIST COLLEGE OF PHARMACY",
  "MAA MANASHA Primary Teacher Training Insitution, D.Ed",
  "DISHARI INSTITUTE OF PHARMACY",
  "SATSANG MISSION COLLEGE OF PHARMACY",
  "LUTHFAA POLYTECHNIC INSTITUTE",
  "SRI RAMKRISHNA COLLEGE OF EDUCATION",
  "DHARMADA GOVT. PRIMARY TEACHERS TRAINING INSTITUTE NADIA",
  "PMIT COLLEGE OF PHARMACY",
  "LORETO HOUSE TEACHER TRAINING DEPARTMENT KOLKATA",
  "KPS INSTITUTE OF POLYTECHNIC",
  "Kolaghat Government Polytechnic",
  "DESUN SCHOOL OF NURSING, KOLKATA",
  "KINGSTON POLYTECHNIC COLLEGE KOLKATA",
  "KHRISTIYA SEVA NIKETAN BANKURA",
  "KHARAGPUR TRIBAL PRIMARY TEACHERS’ TRAINING INSTITUTE PASCHIM MEDINIPUR",
  "GHANI KHAN CHOUDHURY INSTITUTE OF ENGINEERING & TECHNOLOGY, KOTWALI, MALDA",
  "GANGARAMPUR GOVERNMENT POLYTECHNIC",
  "KALIMPONG COLLEGE OF PHARMACY",
  "DEROZIO PRIMARY TEACHERS TRAINING INSTITUTE NADIA",
  "HARASANKAR BHATTACHAARYA INSTITUTE OF TECHNOLOGY & MINING BARDHAMAN",
  "ALIPURDUAR ASHUTOSH COLLEGE OF PHARMACY AND ALLIED HEALTH CARE RESEARCH",
  "NORTH BENGAL INSTITUTE OF PHARMACEUTICAL SCIENCE",
  "K G ENGINEERING INSTITUTE BANKURA",
  "KALNA POLYTECHNIC BARDHAMAN",
  "HEMCHANDRA MEMORIAL PHARMACY COLLEGE",
  "DEBEN MAHATO PRIMARY TEACHER TRAINING INSTITUTE PURULIA",
  "KAKDWIP PRIMARY TEACHERS TRAINING INSTITUTE SOUTH 24 PARGNAS",
  "KADOMANI D.Ed. COLLEGE",
  "RISHI AUROBINDO INSTITUTE",
  "DARJEELING POLYTECHNIC DARJEELING",
  "NORTH BENGAL ELITE PHARMACY COLLEGE",
  "MUKTADHARA INSTITUTE OF MEDICAL SCIENCE",
  "FATIKA NAZRUL SUKANTA EDUCATIONAL TRAINING CENTRE",
  "ENGINEERING INSTITUTE FOR JUNIOR EXECUTIVES HOWRAH",
  "EMPLOYEE DEVELOPMENT CENTRE OF NTPC FARAKKA MURSHIDABAD",
  "ELITTE INSTITUTE OF ENGINEERING AND MANAGEMENT (POLYTECHNIC) NORTH 24 PARGANAS",
  "JYOTIRMOY SCHOOL OF BUSINESS KOLKATA",
  "MONTESWAR COLLEGE OF PHARMACY",
  "ASHOK NILAY PRABHABASU COLLEGE OF PHARMACY",
  "ELITE POLYTECHNIC INSTITUTE KOLKATA",
  "DURGAPUR SCHOOL OF NURSING BURDWAN",
  "PANCHAKOT PRIMARY TEACHERS TRAINING INSTITUTE NADIA",
  "COOCH BEHAR POLYTECHNIC COOCH BEHAR",
  "RENAISSANCE COLLEGE OF PHARMACY",
  "J. S. PRIMARY TEACHER TRAINING INSTITUTE, MURSHIDABAD",
  "JOYRAMBATI RAMAKRISHNASARADA PRIMARY TEACHERS TRAINING INSTITUTE BANKURA",
  "CONTAI POLYTECHNIC PURBA MEDINIPUR",
  "NEOTIA ACADEMY NURSING TRAINING INSTITUTE",
  "JOTE KANURANGARH MAHATMA PRIMARY TEACHERS TRAINING INSTITUTE PASCHIM MEDINIPUR",
  "J. N. KONAR PRIMARY TEACHERS TRAINING INSTITUTE BURDWAN",
  "KHAMARGACHI PRIMARY TEACHERS TRAINING INSTITUTE HOOGHLY",
  "KABIGURU INSTITUTE  ",
  "COLLEGE FOR TEACHER EDUCATION",
  "JNAN CHANDRA GHOSH POLYTECHNIC KOLKATA",
  "SWADHIN PHARMACY COLLEGE",
  "JLD COLLEGE OF ENGINEERING AND MANAGEMENT SOUTH 24 PARGANAS",
  "CHETANA PRIMARY TEACHERS TRAINING INSTITUTE PURULIA",
  "ARYA BHARAT COLLEGE OF PHARMACY",
  "ABHIGYAN INSTITUTE OF PHARMACY",
  "KRISHNAPUR PRIMARY TEACHERS TRAINING INSTITUTE BIRBHUM",
  "DURGAPUR INSTITUTE OF POLYTECHNIC",
  "Netajee Subhash Chandra Bose Institute Of Education",
  "AMDANGA COLLEGE OF PHARMACY",
  "BARASAT BIDHAN CHANDRA ROY INSTITUTE OF PHARMACY",
  "JIS SCHOOL OF POLYTECHNIC NADIA",
  "JANGIPUR GOVERNMENT POLYTECHNIC",
  "CHATTA PRIMARY TEACHERS TRAINING INSTITUTE SOUTH 24 PARGNAS",
  "JALPAIGURI POLYTECHNIC INSTITUTE JALPAIGURI",
  "MINAKHAN PHARMACEUTICAL COLLEGE AND RESEARCH CENTRE",
  "JAKIR HOSSAIN INSTITUTE OF POLYTECHNIC",
  "BANIPUR NURSING INSTITUTE",
  "HERITAGE COLLEGE OF PHARMACY",
  "NETAJI COLLEGE OF PHARMACY",
  "SPANDAN SCHOOL AND COLLEGE OF NURSING",
  "DR B C ROY NURSING INSTITUTE",
  "AZIMGANJ COLLEGE OF PHARMACY",
  "AUTISM SOCIETY WEST BENGAL    ",
  "KPS SCHOOL OF PHARMACY    ",
  "DESUN NURSING SCHOOL AND COLLEGE SILIGURI A UNIT OF DESUN HEALTH CITY FOUNDATION    ",
  "SWAMI VIVEKANANDA COLLEGE OF PHARMACY",
  "USHA RANI INSTITUTE OF PHARMACY    ",
  "VISWA KOBI COLLEGE OF PHARMACEUTICAL SCIENCE",
  "DINAJPUR INSTITUTE  OF PHARMACY    ",
  "GURUKUL INSTITUTE OF MEDICAL SCIENCE    ",
  "LOYAL INSTITUTE OF PHARMACY    ",
  "DISHA PARAMEDICAL INSTITUTE",
  "COSMOS INSTITUTE OF NURSING",
  "MURSHIDABAD INSTITUTE OF PHARMACY",
  "ESI HOSPITAL MANICKTALA",
  "SHRI GOPI NATH RANA INSTITUTE OF PHARMACY    ",
  "PRASANTA KAMAR NURSING INSTITUTE FOR MALE",
  "GLOBE ALLIED HEALTHCARE SKILL COUNCIL",
  "SEVA VARATI PRIMARY TEACHERS TRAINING INSTITUTION",
  "ROOPKALA KENDRO",
  "Alokekendra Samabay Primary Teachers Training Institute",
  "PALSANDA COLLEGE OF PHARMACY",
  "Hilli Govt. Polytechnic",
  "PURBANCHAL PRIMARY TEACHERS TRAINING INSTITUTE",
  "Swami Vivekananda Tribal College of Teachers Education D. El. Ed.",
  "RAMAKRISHNA MISSION ASHRAMA GOVERNMENT SPONSORED  PRIMARY   TEACHERS TRAINING INSTITUTE",
  "Agnibina College of Education",
  "ITACHUNA GOVT SPONSORED P.T.T.I.",
  "SILIGURI PRIMARY TEACHERS  TRAINING COLLEGE",
  "Ramlal Smriti D.EL.ED College",
  "RAJA RAMMOHAN ROY GOVT. PRIMARY TEACHERS TRAINING INSTITUTE",
  "Ainel Primary Teachers Training Institute",
  "CHANDIPUR MULTISPECIALITY HOSPITAL",
  "MALLABHUM COLLEGE OF PHARMACY",
  "BIRAMPUR ANADI CHARAN MEMORIAL TEACHERS TRAINING D.Ed COLLEGE",
  "PANDAVESWAR COLLEGE OF EDUCATION",
  "N.S. TEACHERS TRAINING COLLEGE",
  "SANKA GOVT. P.T.T.I",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, ABDARPUR, BIRBHUM",
  "Sri Ramkrishna College of Education",
  "BENGAL EDUCATION OF PHARMACY",
  "Mass Education Teachers Training Institute",
  "SANTINIKETAN D. ED. COLLEGE",
  "BANDHU SUNDAR PHARMACY ACADEMY",
  "AUROBINDO PRIMARY TEACHERS TRAINING INSTITUTE",
  "Asha Bhavan Centre",
  "GITARAM INSTITUTE OF NURSING",
  "Ehiapur Teachers Training Institute",
  "THE NEW HORIZONS INSTITUTE OF TECHNOLOGY BARDHAMAN",
  "SUNDARBAN PRIMARY TEACHERS TRAINING INSTITUTE",
  "RAGHUNATH AYURVED MAHAVIDYALAYA AND HOSPITAL",
  "SAKTIGARH GOVT. SPON. P.T.T.I UNIT - II",
  "DOMOHANA KAZI NAZRUL ISLAM D.ED TRAINING COLLEGE",
  "The Assembly of God Church Teachers Training Junior College",
  "NR School of Education",
  "Kulpi Govt. Primary Teachers Training Institute",
  "Simulgachi Primary Teachers Traning Institute",
  "SAMPRITI COLLEGE OF EDUCATION",
  "J. C. BOSE TECHNICAL INSTITUTE",
  "GITANJALI PRIMARY TEACHERS TRAINING INSTITUTE",
  "DAULATABAD PRIMARY TEACHERS TRAINING COLLEGE",
  "Minerva Institute of Education",
  "BISHNUPUR PUBLIC INSTITUTE OF EDUCATION",
  "NADIA PRIMARY TEACHERS TRAINING INSTITUTE",
  "Matiari D.Ed. College",
  "RAGHUNATHPUR GOVT. POLYTECHNIC",
  "G.N.M. Training School (For Male), Baghajatin State General Hospital",
  "Bharat Sevashram Sangha School of Nursing",
  "Pajhrapara Satellite Teachers Training Institute",
  "NURSING TRAINING SCHOOL, BURDWAN MEDICAL COLLEGE  AND HOSPITAL, BURDWAN",
  "Rajib Gandhi Nursing Training School",
  "SCHOOL  OF  INDIAN  HOTEL  MANAGEMENT",
  "RAIPUR GOVERNMENT POLYTECHNIC",
  "Ashutosh D.El.Ed. College",
  "ARAMBAGH GOVERNMENT POLYTECHNIC",
  "WOMENS POLYTECHNIC CHANDERNAGORE HOOGHLY",
  "MANIPAL HOSPITAL BROADWAY",
  "THE CALCUTTA TECHNICAL SCHOOL KOLKATA",
  "AASTHA INSTITUTE OF PHARMACY",
  "A P J ABDUL KALAM INSTITUTE",
  "BISHNUPUR PUBLIC COLLEGE OF PHARMACY",
  "VIDYASAGAR BANI BHAWAN PRIMARY TEACHERS TRAINING INSTITUTE ACHARYA PRAFULLA CHANDRA ROAD KOLKATA",
  "SANTINIKETAN COLLEGE OF EDUCATION",
  "R.K. MISSION SARADA MANDIR GOVT. SPONSORED PRIMARY TEACHERS TRAINING INSTITUTE (UNIT-II)",
  "SANAKA EDUCATIONAL TRUST`S GROUP OF INSTITUTIONS BARDHAMAN",
  "SAMBHUNATH PANDIT HOSPITAL KOLKATTA",
  "SAKTINAGAR DISTRCT HOSPITAL, NADIA",
  "NURSING TRAINING SCHOOL BARASAT",
  "SAGARIKA D.Ed. COLLEGE",
  "SADAR HOSPITAL DARJEELING",
  "PURBA MEDINIPUR PRIMARY TEACHERS TRAINING INSTITUTE",
  "SABRAKONE GOVT. PRIMARY TEACHERS TRAINING INSTITUTE BANKURA",
  "RUBY GENERAL HOSPITAL LTD KOLKATTA",
  "USHANGINI COLLEGE OF EDUCATION FOR WOMEN",
  "R.K. MISSION BOYS HOME PRIMARY TEACHERS TRAINING INSTITUTE",
  "RENUKA PRIMARY TEACHERS TRAINING INSTITUTE PASCHIM MEDINIPUR",
  "URDU MEDIUM GOVT. PRIMARY TEACHERS TRAINING INSTITUTE HOOGHLY",
  "REGIONAL INSTITUTE OF PRINTING TECHNOLOGY KOLKATA",
  "REGENT INSTITUTE OF SCIENCE AND TECHNOLOGY NORTH 24 PARGANAS",
  "UNITED MISSIONARY PRIMARY TEACHERS TRAINING INSTITUTE KOLKATA",
  "REAPARA PRIMARY TEACHERS TRAINING INSTITUTE PURBA MEDINIPUR",
  "RATUA SATYENDRA NATH BOSE GOVERNMENT POLYTECHNIC",
  "RAMKRISHNA MISSION SEVA PRATISTHAN KOLKATTA",
  "RAJENDRANATH COLLEGE OF POLYTECHNIC BARDHAMAN",
  "NIL RATAN SIRCAR MEDICAL COLLEGE HOSPITAL KOLKATA",
  "RAMAKRISHNA MISSION SHILPAPITHA",
  "PARBATIPUR NURSING INSTITUTE",
  "BIBHUTI BHUSHAN PHARMACY COLLEGE",
  "RAMAKRISHNA MISSION SHILPAMANDIRA HOWRAH",
  "RAMAKRISHNA MISSION SHILPAMANDIRA",
  "TUFANGANJ GOVERNMENT, POLYTECHNIC",
  "RAJMATI PARICHAND BOTHRA MEMORIAL JIAGANJ COLLEGE OF ENGINEERING & TECHNOLOGY MURSHIDABAD",
  "TRAINING INSTITUTE PURBA MEDINIPUR",
  "RAJA RANJIT KISHORE GOVERNMENT POLYTECHNIC",
  "RABINDRA NATH THAKUR PRIMARY TEACHERS TRAINING INSTITUTE PURBA MEDINIPUR",
  "R3S COLLEGE OF EDUCATION",
  "PURULIA POLYTECHNIC PURULIA",
  "PRAJANANDA GOVT. PRIMARY TEACHERS TRAINING INSTITUTE NADIA",
  "PASCHIM BANGA RAJYA PRATIBANDHI SAMMILANI KOLKATTA",
  "MINERVA ACADEMY PRIMARY TEACHERS TRAINING INSTITUTE NADIA",
  "NETAJI SUBHAS PRIMARY TEACHERS TRAINING INSTITUTE PURBA MEDINIPUR",
  "PARADISE INSTITUTE OF TECHNOLOGY",
  "PANSKURA PRIMARY TEACHERS TRAINING INSTITUTE PURBA MEDINIPUR",
  "PANCHANANI NANDI MEMORIAL PRIMARY TEACHERS TRAINING INSTITUTE SOUTH 24 PARGNAS",
  "ISLAMIA HOSPITAL SCHOOL OF NURSING",
  "PAILAN COLLEGE OF MANAGEMENT AND TECHNOLOGY (PGDM DIVISION)",
  "PAILAN AVIATION INSTITUTE KOLKATA",
  "NURSING TRG. SCHOOL. M J N HOSPITAL COOCH BEHAR",
  "NURSING TRAINING SCHOOL MURSHIDABAD",
  "NURSING TRAINING SCHOOL MALDA",
  "NURSING TRAINING SCHOOL LADY DUFFERIN HOSPITAL KOLKATTA",
  "NURSING TRAINING SCHOOL JALPAIGURI",
  "GOVT. PRIMARY TEACHERS TRAINING INSTITUTE COOCH BEHAR",
  "NURSING TRAINING SCHOOL HOWRAH",
  "GOPSAI AVINANDAN SANGHA PRIMARY TEACHER TRAINING INSTITUTE PASCHIM MEDINIPUR",
  "NURSING TRAINING SCHOOL HOOGHLY",
  "NURSING TRAINING SCHOOL E S I HOSPITAL KOLKATTA",
  "VIVEKANANDA COLLEGE OF EDUCATION AND PHARMACY",
  "PARBATIPUR COLLEGE OF PHARMACY AND MEDICAL SCIENCE",
  "NURSING TRAINING SCHOOL DAKSHIN DINAJPUR",
  "GOBINDAPUR ACADEMIC PRIMARY TEACHERS TRAINING INSTITUTE",
  "NURSES TRAINING CENTRE KOLKATTA",
  "MATHURAPUR COLLEGE OF PHARMACY",
  "NTS, Purba Medinipur District Hospital, Tamluk",
  "GODAGARI VIDYASAGAR EDUCATIONAL INSTITUTE AND SOCIAL WELFARE PRIMARY TEACHER TRAINING INSTITUTE MURSHIDABAD",
  "N S POLYTECHNIC COLLEGE, WEST BENGAL",
  "NSHM SCHOOL OF HOTEL MANAGEMENT BARDHAMAN",
  "NORTH CALCUTTA POLYTECHNIC KOLKATA",
  "KALNA PRIMARY TEACHERS TRAINING INSTITUTE BURDWAN",
  "NORTH BENGAL MEDICAL COLLEGE HOSPITAL DARJEELING",
  "NIPS SCHOOL OF HOTEL MANAGEMENT NORTH 24 PARGANAS",
  "GOBINDAPUR SEPHALI MEMORIAL POLYTECHNIC BARDHAMAN",
  "NIMAS NORTH 24 PARGANAS",
  "NILUFAR RUMANA D. ED. COLLEGE",
  "Jalpaiguri Institute of Technology",
  "GOBINDAPUR POLYTECHNIC COLLEGE MURSHIDABAD",
  "NIBEDITA INSTITUTE OF TECHNOLOGY MURSHIDABAD",
  "G N M TRAINING SCHOOL NADIA",
  "NETAJI SUBHAS CHANDRA BOSE PRIMARY TEACHERS TRAINING INSTITUTE MURSHIDABAD",
  "MINERVA ACADEMY PRIMARY TEACHERS TRAINING INSTITUTE MURSHIDABAD",
  "G N M TRAINING CENTRE PURULIA",
  "KANDI PRIMARY TEACHERS TRAINING INSTITUTE MURSHIDABAD",
  "INSTITUTE OF EDUCATIONAL RESEARCH & STUDIES PRIMARY TEACHERS TRAINING INSTITUTE KOLKATA",
  "BURNPUR HOSPITAL (IISCO) BARDHAMAN",
  "GLOBSYN BUSINESS SCHOOL SOUTH 24 PARGANAS",
  "CENTRAL TOOL ROOM & TRAINING CENTRE NORTH 24 PARGANAS",
  "INSTITUTE OF SCIENCE AND TECHNOLOGY PASCHIM MEDINIPUR",
  "INSTITUTE OF PHARMACY KALYANI NADIA",
  "CENTRAL INSTITUTE OF PLASTICS ENGINEERING & TECHNOLOGY PURBA MEDINIPUR",
  "INSTITUTE OF PHARMACY JALPAIGURI JALPAIGURI",
  "INSTITUTE OF HOTEL AND RESTAURANT MANAGEMENT KOLKATA",
  "CENTRAL FOOTWEAR TRAINING CENTRE SOUTH 24 PARGANAS",
  "INSTITUTE OF COST AND WORKS ACOUNTANTS OF INDIA",
  "INSTITUTE OF ADVANCED MANAGEMENT NORTH 24 PARGANAS",
  "CENTRAL CALCUTTA POLYTECHNIC KOLKATA",
  "INSERVICE TRAINING SCHOOL NADIA",
  "INDIAN INSTITUTE OF SOCIAL WEFLFARE & BUSINESS MANAGEMENT",
  "CAMELLIA INSTITUTE OF POLYTECHNIC BARDHAMAN",
  "INDIAN INSTITUTE OF PACKAGING, KOLKATA",
  "CAMELLIA INSTITUTE OF AVIATION KOLKATA",
  "INDIAN INSTITUTE OF HANDLOOM TECHNOLOGY",
  "INDIAN INSTITUTE OF AERONAUTICAL SCIENCE KOLKATA",
  "CAMELLIA COLLEGE OF POLYTECHNIC HOOGHLY",
  "HSB POLYTECHNIC, WEST BENGAL",
  "HOOGHLY INSTITUTE OF TECHNOLOGY HOOGHLY",
  "HOOGHLY B.C. ROY INSTITUTE HOOGHLY",
  "HEMCHANDRA MEMORIAL PRIMARY TEACHERS TRAINING INSTITUTE",
  "HALDIA INSTITUTE OF NURSING SCIENCE (ICARE), MIDNAPUR(E)",
  "GURU NANAK INSTITUTE OF PHARMACEUTICAL SCIENCE AND TECHNOLOGY (DIPLOMA PHARMACY) KOLKATA",
  "NIBEDITA POLYTECHNIC MURSHIDABAD",
  "DR. AMBEDKAR PRIMARY TEACHERS TRAINING INSTITUTE NADIA",
  "CALCUTTA NATIONAL MEDICAL COLLEGE HOSPITAL KOLKATTA",
  "CALCUTTA BUSINESS SCHOOL",
  "BHAGABATI DEVI PRIMARY TEACHERS TRAINING INSTITUTE PASCHIM MEDINIPUR",
  "CHANDANNAGAR COMPU-TECH ACADEMY PRIMARY TEACHERS TRAINING INSTITUTE HOOGHLY",
  "Mallabhum Institute of Polytechnic",
  "BISHNUPUR PUBLIC PRIMARY TEACHERS TRAINING INSTITUTE BANKURA",
  "GOVT. PRIMARY TEACHERS TRAINING INSTITUTE MURSHIDABAD",
  "CALCUTTA NURSING TRAINING INSTITUTE KOLKATTA",
  "CALCUTTA MEDICAL & HOSP. RESEARCH INST. KOLKATTA",
  "RAMA DEVI PHARMACY AND MEDICAL INSTITUTE",
  "BHAWANIPUR INSTITUTE OF PHARMACY",
  "NATURAL COLLEGE OF PHARMACY",
  "RAMGANJ GOVERNMENT PRIMARY TEACHERS TRAINING INSTITUTE",
  "FALAKATA POLYTECHNIC",
  "CALCUTTA INSTITUTE OF TECHNOLOGY HOWRAH",
  "DISHA INSTITUTE OF POLYTECHNIC",
  "CALCUTTA INSTITUTE OF PHARMACEUTICAL TECHNOLOGY & ALLIED HEALTH SCIENCES HOWRAH",
  "CALCUTTA BUSINESS SCHOOL SOUTH 24 PARGANAS",
  "BANDHAN SCHOOL OF BUSINESS",
  "BUDGE BUDGE INSTITUTE OF TECHNOLOGY SOUTH 24 PARGANAS",
  "BRAHMO PRIMARY TEACHERS TRAINING INSTITUTE KOLKATA",
  "BANKURA GOVERNMENT POLYTECHNIC",
  "BANIPUR GOVT. PRIMARY TEACHERS TRAINING INSTITUTE 24 PARGANAS",
  "BAM VIVEKANANDA P.T.T.COLLEGE",
  "BISHNUPUR PUBLIC INSTITUTE OF ENGINEERING (POLYTECHNIC) BANKURA",
  "BALUCHAR PRIMARY TEACHERS TRAINING INSTITUTE MURSHIDABAD",
  "ATHENA PRIMARY TEACHERS TRAINING INSTITUTE BANKURA",
  "ASANSOL POLYTECHNIC BARDHAMAN",
  "ABDUR RAHIM COLLEGE OF PHARMACY",
  "AMS COLLEGE OF POLYTECHNIC, WEST BENGAL",
  "KAVIGURU COLLEGE OF PHARMACY",
  "A M R I SCHOOL OF NURSING KOLKATTA",
  "BIRLA INSTITUTE OF TECHNOLOGY KOLKATA",
  "INTERNATIONAL MANAGEMENT AND ANALYTICS SCHOOL KOLKATA",
  "AIRCRAFT MAINTENANCE & ENGINEERING INSTITUTE KOLKATA",
  "AGRAGATI PRIMARY TEACHER’S TRAINING INSTITUTE HOWRAH",
  "BIPRADAS PALCHOWDHURY INSTITUTE OF TECHNOLOGY NADIA",
  "ACHARYYA PRAFULLA CHANDRA RAY POLYTECHNIC KOLKATA",
  "ACHARYA JAGADISH CHANDRA BOSE POLYTECHNIC NORTH 24 PARGANAS",
  "BIBHUTI BHUSAN GOVT. PRIMARY TEACHERS TRAINING INSTITUTE NORTH 24 PARGNAS",
  "MOTHER TERESA PHARMACY COLLEGE",
  "BHATJANGLA SHIPRA D.ED. COLLEGE, NADIA",
  "KANYAPUR POLYTECHNIC BARDHAMAN",
  "BENGAL INSTITUTE OF TECHNOLOGY BARDHAMAN",
  "BENGAL INSTITUTE OF POLYTECHNIC BIRBHUM",
  "BENGAL COLLEGE OF ENGINEERING & TECHNOLOGY BARDHAMAN",
  "BELOKOBA GOVT. PRIMARY TEACHERS TRAINING INSTITUTE JALPAIGURI",
  "Vivekananda Loksiksha Niketan",
  "MAYNAGURI GOVERNMENT POLYTECHNIC",
  "PUNARBASAN- A Centre for Special Education",
  "Bidyeswari Teachers Training College",
  "NAZRUL CENTENARY POLYTECHNIC BARDHAMAN",
  "Dr. Ambedkar Primary Teachers Training Institute",
  "SISTER NIVEDITA PRIMARY TEACHERS TRAINING INSTITUTE",
  "BIRBHUM EDUCATIONAL COLLEGE",
  "GOALTORE EDUCATIONAL TRAINING INSTITUTE",
  "KABIGURU RABINDRANATH COLLEGE OF EDUCATION",
  "RAMPUR ADARSHA COLLEGE OF EDUCATION",
  "NSCB INSTITUTE OF PHARMACY",
  "DR BIDHAN CHANDRA ROY COLLEGE OF PHARMACY",
  "NAJIMUDDIN INSTITUTE OF PHARMACY",
  "ANP Teachers Training B.Ed. College",
  "MURSHIDABAD PHARMACY COLLEGE",
  "Management Development Institute Murshidabad",
  "Nursing Training School, North Bengal Medical College and Hospital",
  "NURSING TRAINING SCHOOL",
  "GNM Training School College of Medicine and Sagore Dutta Hospital",
  "RJTJA DIPLOMA PHARMACY COLLEGE",
  "Upasana College of Education",
  "VISHWANATH AYURVED MAHAVIDYALAYA AND HOSPITAL",
  "BABASAHEB AMBEDKAR GOVERNMENT POLYTECHNIC",
  "JALPAIGURI DOOARS PRIMARY TEACHERS TRAINING INSTITUTE JALPAIGURI",
  "SOUTH CALCUTTA POLYTECHNIC",
  "BARASAT COLLEGE OF PHARMACEUTICAL SCIENCE AND RESEARCH CENTRE",
  "SURAKSHA DIAGNOSTIC PVT LTD",
  "JOY WELFARE NURSING INSTITUTE",
  "LAKSHMI NURSING INSTITUTE",
  "AINEL COLLEGE OF PHARMACY",
  "ILLAMBAZAR NURSING INSTITUTE",
  "DURGAPUR INSTITUTE OF NURSING SCIENCES",
  "MUKTADHARA NURSING INSTITUTION",
  "RAIGANJ POLYTECHNIC",
  "VIVEKANANDA TEACHERS TRAINING INSTITUTE",
  "Kadomani D.Ed. College",
  "KHARGRAM INSTITUTE OF PHARMACY",
  "BERHAMPORE COLLEGE OF PHARMACY",
  "SOCIETY FOR THE SCHOOL OF MEDICAL TECHNOLOGY",
  "NEW MISSION TRAINING COLLEGE",
  "GLOBSYN BUSINESS SCHOOL",
  "REGIONAL LABOUR INSTITUTE, KOLKATA",
  "BEACON PRIMARY TEACHER TRAINING INSTITUTE",
  "College of Nursing, Institute of Psychiatry-COE",
  "NOVENA COLLEGE AND SCHOOL OF NURSING",
  "SAROJ GUPTA CANCER CENTRE AND RESEARCH INSTITUTE",
  "ILLAMBAZAR INSTITUTE OF PHARMACY",
  "NIBEDITA HEALTH CARE, BERHAMPORE",
  "RANGAMATI COLLEGE OF PHARMACY",
  "GOVERNMENT SPONSORED P.T.T.I",
  "SWAPNA DEVI COLLEGE OF EDUCATION",
  "SEBA INSTITUTE OF PHARMACY",
  "KOLKATA INSTITUTE OF NURSING",
  "GOURI DEVI NURSING ACADEMY",
  "SPECIALIST CLINIC AND DIAGNOSTIC A UNIT OF BANERJEE HEALTH CARE SERVICES PVT LTD",
  "KALPANA COLLEGE OF PHARMACY",
  "NSMS INSTITUTE OF PHARMACY",
  "DASHRATH KALPANA D PHARM COLLEGE",
  "RAMAKRISHNA MISSION SARADA MANDIR GOVT SPOND PTTI, UNIT ONE, DIAMOND HARBOUR",
  "HELAL NURSING INSTITUTE",
  "SRIJONI NURSING INSTITUTE",
  "DURGAPUR SAMMILANI NURSING INSTITUTE",
  "SUBHAM NURSING INSTITUTE",
  "INDIRA SCHOOL OF NURSING",
  "AMRI HOSPITALS LIMITED MUKUNDAPUR KOLKATA",
  "RAMAKRISHNA MISSION ASHRAMA CHARITABLE DISPENSARY AND DIAGNOSTIC CENTRE, SARGACHI",
  "ANGEL DAY SCHOOL OF NURSING",
  "PEERLESS HOSPITAL & B K ROY RESEARCH CENTRE KOLKATTA",
  "SCHOOL OF NURSING, CENTRAL HOSPITAL KALNA",
  "AIR TECHNICAL TRAINING INSTITUTE KOLKATA",
  "RAMA DEVI NURSING INSTITUTE",
  "DREAM NURSING INSTITUTE",
  "KALIMPONG GOVT PRIMARY TEACHERS TRAINING INSTITUTE",
  "BURDWAN INSTITUTE OF PHARMACY",
  "NIBEDITA INSTITUTE OF PARAMEDICAL STUDIES",
  "NIBEDITA PARAMEDICAL COLLEGE",
  "VIDYASAGAR PHARMACEUTICAL COLLEGE OF EDUCATION",
  "SCHOOL OF NURSING, MCH, KOLKATA",
  "SULEKHA PHARMACY COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING, Purulia",
  "NAGENDRA D ED COLLEGE FOR GIRLS",
  "DASNAGAR GOVERNMENT POLYTECHNIC",
  "BANKURA PARAMEDICAL COLLEGE",
  "NIDAN NURSING INSTITUTE",
  "SAKTIGARH GOVT SPON PTTI UNIT I",
  "VIDYANAGAR GOVERNMENT PRIMARY TEACHERS TRAINING INSTITUTE",
  "NURSING TRAINING SCHOOL ASHOKNAGAR STATE GENERAL HOSPITAL",
  "OM NARAYAN PHARMACY COLLEGE",
  "ANM TRANING SCHOOL ,DHGMCH",
  "KAZI NAZRUL ISLAM PHARMACEUTICAL SCIENCES",
  "ALIPURDUAR DAMANPUR GOVERNMENT POLYTECHNIC",
  "SUSPARSHA INSTITUTE OF NURSING",
  "VIDYASAGAR INSTITUTE OF SAFETY AND FIRE TECHNOLOGY",
  "ZENITH SUPER SPECIALIST HOSPITAL A UNIT OF JYOTISHMAN MULTI DISCIPLINARY HOSPITAL PVT LTD",
  "OMKARNATH INSTITUTE OF PHARMACEUTICAL TECHNOLOGY AND MEDICAL SCIENCE",
  "DAKSHIN DINAJPUR NURSING INSTITUTE",
  "RED PLUS SOCIETY",
  "KALYANI INSTITUTE OF MEDICAL SCIENCES",
  "DISTRICT INSTITUTE FOR EDUCATION & TRAINING PURBA MEDINIPUR",
  "CHINSURAH NURSING INSTITUTE",
  "DEULI GOVERNMENT PRIMARY TEACHERS TRAINING INSTITUTE",
  "SUPTENDU MEMORIAL DED COLLEGE",
  "DISTRICT INSTITUTE OF EDUCATION AND TRAINING",
  "KADER MOLLA COLLEGE OF PHARMACY",
  "DEBRA PRAMILA PTTI",
  "NIVEDITA INSTITUTE OF NURSING",
  "MIRZA NOOR MAHAMMAD COLLEGE OF EDUCATION",
  "ANM R TRAINING SCHOOL DOMKAL SUBDIVISIONAL AND SUPERSPECIALITY HOSPITAL MURSHIDABAD",
  "DHUPGURI PRIMARY TEACHERS TRAINING INSTITUTE",
  "ST JOSEPHS NURSING SCHOOL",
  "CLARA BARTON SCHOOL OF NURSING",
  "SIKSHA  SANGHA  GOVERNMENT SPONSORED PRIMARY TEACHERS TRAINING INSTITUTE",
  "INTERNATIONAL SCHOOL OF BUSINESS AND MEDIA KOLKATA",
  "JAGARAN COLLEGE OF EDUCATION",
  "KAMTI EDUCATION FOUNDATION",
  "DR SUDHIR CHANDRA SUR INSTITUTE OF PHARMACEUTICAL SCIENCE AND TECHNOLOGY",
  "Voice of World",
  "SARASWATI SCHOOL OF NURSING MALDA",
  "MAHESHTALA MUNICIPAL INSTITUTE OF NURSING SCIENCES",
  "SWAMI VIVEKANANDA SCHOOL OF DIPLOMA",
  "SRAMAJIBI ACADEMY OF NURSING",
  "ST PAULS SCHOOL OF NURSING",
  "CHITYARANJAN COLLEGE OF EDUCATION",
  "CHANDRAKANT INSTITUTE OF NURSING AND HEALTH SCIENCES",
  "ANMR TRAINING SCHOOL",
  "MIRIK GOVERNMENT POLYTECHNIC",
  "INSTITUTE OF FIRE AND SAFETY ENGINEERING",
  "ARYAN INSTITUTE OF PHARMACY",
  "VIDYASAGAR EDUCATIONAL INSTITUTE",
  "BIRBHUM D EL ED COLLEGE",
  "NURSING TRAINING SCHOOL ALIPURDUAR",
  "KALIMPONG GOVERNMENT POLYTECHNIC",
  "HURAT BT AND BD PATI PTTI COLLEGE",
  "GNM TRAINING SCHOOL    LALGARH   JHARGRAM",
  "SAK PRIMARY TEACHERS TRAINING INSTITUTE",
  "KALPANA INSTITUTE OF NURSING",
  "THE CALCUTTA MEDICAL RESEARCH INSTITUTE",
  "GENEX COLLEGE OF PHARMACEUTICAL SCIENCE AND TECHNOLOGY CHINSURAH",
  "WEBEL ANIMATION ACADEMY",
  "GNM TRAINING SCHOOL GHATAL S D HOSPITAL",
  "SANTINIKETAN INSTITUTE OF ALLIED HEALTH SCIENCE",
  "KHARAGPUR PHARMACEUTICAL INSTITUTE",
  "TARIFA MEMORIAL INSTITUTE OF PHARMACY",
  "FORTUNE INSTITUTE OF NURSING AND HEALTH SCIENCES",
  "AMBIKA RADHACHAMPAK NURSING INSTITUTE",
  "CANNING GOVERNMENT POLYTECHNIC",
  "BARASAT AMS INSTITUTE OF NURSING",
  "RAMAKRISHNA NURSING INSTITUTE",
  "SWADHIN NURSING INSTITUTE",
  "SANTINIKETAN SEBANIKETAN NURSING INSTITUTE",
  "BAGDEVI GROUP OF INSTITUTION",
  "JIAGANJ INSTITUTE OF PHARMACY",
  "GOBINDAPUR SEPHALI MEMORIAL PRIMARY TEACHERS TRAINING INSTITUTE",
  "R N TAGORE PHARMACEUTICAL INSTITUTE",
  "SIR RAJENDRA NATH MUKHERJEE GOVERNMENT POLYTECHNIC",
  "MATHABHANGA GOVERNMENT POLYTECHNIC",
  "District Institute of Education and Training Jhargram",
  "PRAXIS BUSINESS SCHOOL",
  "LAKSHMI PHARMACY INSTITUTE",
  "Anjali memorial college of education and training",
  "INDIRA GANDHI TEACHERS TRAINING COLLEGE",
  "RABINDRA NATH  THAKUR TEACHERS TRAINING INSTITUTE",
  "BEHALA GOVERNMENT POLYTECHNIC",
  "GANDHARI INSTITUTE OF PHARMACEUTICAL SCIENCES",
  "INSTITUTE OF HOTEL MANAGEMENT CATERING TECHNOLOGY AND APPLIED NUTRITION",
  "MAHATMA PRIMARY TEACHERS TRAINING INSTITUTE",
  "HETAMPUR RAJBATI PRIMARY TEACHERS TRAINING INSTITUTE BIRBHUM",
  "R. N. TAGORE PTTI, MURSHIDABAD",
  "D.L ROY WOMEN PRIMARY TEACHERS TRAINING INSTITUTE",
  "Nursing Training school,Uluberia S.D. Hospital,Howrah",
  "FARIDPUR INSTITUTE OF PHARMACY",
  "GLOBAL INSTITUTE OF PHARMACY",
  "ILLAMBAZAR TEACHERS TRAINING INSTITUTE",
  "RENUKA DEBI SHIKSHAK SHIKSHAN MAHAVIDYALAYA",
  "KABI SUKANTA PTTI",
  "HAJI MD. SERAFAT MANDAL GOVERNMENT POLYTECHNIC",
  "BASUDEB NURSING ACADEMY",
  "GOKUL SHEFALI NURSING AND PARAMEDICAL COLLEGE",
  "MAHATMA GANDHI ACADEMIC INSTITUTE AND PHARMACY",
  "BELDANGA COLLEGE OF PHARMACY AND ANR",
  "R N TAGORE PTTI   BANKURA",
  "NIVEDITA NURSING INSTITUTE",
  "DOLPHIN COLLEGE OF PHARMACY AND MEDICAL SCIENCES",
  "SADIYA INSTITUTE OF NURSING",
  "DAYAL KRISHNA D ED COLLEGE",
  "EMINENT COLLEGE OF PHARMACEUTICAL TECHNOLOGY",
  "ANANDALOKE INSTITUTE OF NURSING EDUCATION, SILIGURI",
  "IKBAL INSTITUTE OF PHARMACY",
  "MCRS NURSING INSTITUTE (MALE)",
  "SALBANI INSTITUTE OF TECHNOLOGY",
  "HEALTHWORLD HOSPITALS (A UNIT OF PARASHMANI MEDICAL CENTRE PRIVATE LIMITED)",
  "RYMF ROYAL COLLEGE OF PHARMACY",
  "ARAMBAGH PHARMACEUTICAL SCIENCE",
  "JANAKALYAN NURSING INSTITUTE",
  "National Medical Commission (NMC) (formerly MCI)",
  "Dental Council of India (DCI)",
  "Pharmacy Council of India (PCI)",
  "Indian Nursing Council (INC)",
  "National Commission for Indian System of Medicine (NCISM)",
  "National Commission for Homoeopathy (NCH)",
  "Institute of Chartered Accountants of India (ICAI)",
  "Institute of Company Secretaries of India (ICSI)",
  "Institute of Cost Accountants of India (ICMAI)",
  "Bar Council of India (BCI)",
  "Council of Architecture (COA)",
  "Engineering Council of India (ECI)",
  "Rehabilitation Council of India (RCI)",
  "Veterinary Council of India (VCI)"
]